(function () {
// The Panoramax viewer bundles its own Font Awesome and ships its styles in its shadow DOM:
// the <style> auto-injected in <head> is useless and blocked by our CSP (no nonce).
// Must run before the viewer is imported, as Font Awesome reads this global at load time.
window.FontAwesomeConfig = {
    autoAddCss: false
};


var $8522ffc4d68108bd$exports = {};
/*!
 * 
 *   @panoramax/web-viewer v4.4.0
 *   https://gitlab.com/panoramax/clients/web-viewer
 *
 *   Copyright (c) Panoramax team
 *
 *   This source code is licensed under the MIT license found in the
 *   LICENSE file in the root directory of this source tree.
 *
 */ !function(le1, vt) {
    $8522ffc4d68108bd$exports = vt();
}($8522ffc4d68108bd$exports, ()=>(()=>{
        var le1 = {
            9039: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Basic
                });
                var ls = bt(4542), ho = bt(5254), Dl = bt(4964), Fl = bt(7208), sc = bt(5995), uc = bt(7343), mc = bt(2614), gc = bt.n(mc), Ac = bt(8330);
                bt(1865), bt(3638);
                class Basic extends ls.WF {
                    constructor(){
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        super(), this.users = [
                            "geovisio"
                        ], this["map-style"] = this.getAttribute("map-style") || (0, Fl.MapTiles)(), this.lang = this.getAttribute("lang") || null, this.endpoint = this.getAttribute("endpoint") || null, this.picture = this.getAttribute("picture") || null, this.sequence = this.getAttribute("sequence") || null, console.info(`\ud83d\udcf7 Panoramax ${this.getClassName()} - Version ${Ac.rE} (b7ee2f6)\n\n\ud83c\udd98 Issues can be reported at ${Ac.Jk.O}`), le1 || (this._isInternetFast = null, (0, uc.isInternetFast)().then((le1)=>this._isInternetFast = le1));
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._t = (0, Dl.getTranslations)(this.lang), this.loader = (0, sc.createWebComp)("pnx-loader", {
                            _parent: this,
                            "no-label": (0, uc.isInIframe)()
                        }), this._loadsAPI && this.endpoint && this._loadsAPI === this.endpoint || this.api && this.api._endpoint === this.endpoint || !this.endpoint || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI()), Object.entries({
                            map: "map-options",
                            psv: "psv-options",
                            fetchOptions: "fetch-options",
                            mapstyle: "map-style"
                        }).forEach((le1)=>{
                            let [vt, bt] = le1;
                            this.getAttribute(vt) && console.error(`Component attribute "${vt}" has been renamed into "${bt}". Old attribute "${vt}" is ignored.`);
                        }), (0, uc.isInIframe)() && this.classList.add("pnx-iframed");
                    }
                    _setupAPI() {
                        if (this.loader = this.loader || (0, sc.createWebComp)("pnx-loader", {
                            _parent: this
                        }), !this.endpoint) return void console.warn("No endpoint is defined");
                        this._loadsAPI = this.endpoint;
                        let le1 = this.endpoint;
                        try {
                            this["map-style"] = JSON.parse(this["map-style"]);
                        } catch (bt) {}
                        try {
                            this.api = new ho.A(this.endpoint, {
                                users: this.users,
                                fetch: this["fetch-options"],
                                style: this["map-style"]
                            }), this.api.onceReady().then(()=>{
                                if (le1 != this._loadsAPI || !this.api) return;
                                let vt = this.api.getUnavailableFeatures(), bt = this.api.getAvailableFeatures();
                                bt = 0 === vt.length ? "\u2705 All features available" : "\u2705 Available features: " + bt.join(", "), vt = 0 === vt.length ? "" : "\ud83d\udeab Unavailable features: " + vt.join(", "), console.info(`\ud83c\udf10 Connected to API "${this.api._metadata.name}" (${this.api._endpoint})\n\u2139\ufe0f API runs STAC ${this.api._metadata.stac_version} ${this.api._metadata.geovisio_version ? "& GeoVisio " + this.api._metadata.geovisio_version : ""}\n   ${bt}\n   ${vt}\n`.trim());
                            }).catch((le1)=>this.loader.dismiss(le1, this._t.pnx.error_api)).finally(()=>delete this._loadsAPI);
                        } catch (bt) {
                            var vt;
                            delete this._loadsAPI, null !== (vt = this.loader) && void 0 !== vt && vt.dismiss ? this.loader.dismiss(bt, this._t.pnx.error_api) : console.error(bt);
                        }
                    }
                    onceReady() {
                        throw new Error("You must override this method on sub-class");
                    }
                    onceAPIReady() {
                        return this.api ? this.api.onceReady() : new Promise((le1)=>setTimeout(le1, 100)).then(this.onceAPIReady.bind(this));
                    }
                    createRenderRoot() {
                        return this;
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        if (super.attributeChangedCallback(le1, vt, bt), "endpoint" === le1 && (this._loadsAPI && bt && this._loadsAPI === bt || this.api && this.api._endpoint === bt || !bt || ((this._loadsAPI || this.api) && (delete this.api, delete this._loadsAPI), this._setupAPI())), [
                            "picture",
                            "sequence"
                        ].includes(le1)) {
                            let ls, ho, Dl, Fl;
                            "picture" === le1 ? (ls = this.sequence, Dl = this.sequence, ho = bt, Fl = vt) : (ls = bt, Dl = vt, ho = this.picture, Fl = this.picture), this.dispatchEvent(new CustomEvent("select", {
                                bubbles: !0,
                                composed: !0,
                                detail: {
                                    seqId: ls,
                                    picId: ho,
                                    prevSeqId: Dl,
                                    prevPicId: Fl
                                }
                            }));
                        }
                    }
                    getClassName() {
                        return "Basic";
                    }
                    select() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        arguments.length > 2 && void 0 !== arguments[2] && arguments[2] && (this.picture = null, this.sequence = null), this.picture = vt, this.sequence = le1;
                    }
                    isWidthSmall() {
                        return (null === this || void 0 === this ? void 0 : this.offsetWidth) < 576;
                    }
                    isHeightSmall() {
                        return (null === this || void 0 === this ? void 0 : this.offsetHeight) < 400;
                    }
                    render() {
                        return ls.qy`<p>Should not be used directly, use Viewer/CoverageMap/Editor instead</p>`;
                    }
                    getSubComponentsNames() {
                        return [
                            "loader",
                            "api"
                        ];
                    }
                    addEventListener(le1, vt, bt) {
                        let ls = le1.split(":").shift();
                        if (ls && this.getSubComponentsNames().includes(ls)) {
                            var ho;
                            const Dl = le1.substring(ls.length + 1);
                            null !== (ho = this[ls]) && void 0 !== ho && ho.addEventListener ? this[ls].addEventListener(Dl, vt, bt) : setTimeout(()=>this.addEventListener(le1, vt, bt), 50);
                        } else super.addEventListener(le1, vt, bt);
                    }
                    static GetJSONConverter() {
                        return {
                            fromAttribute: (le1)=>null === le1 || "" === le1 ? null : "object" === typeof le1 || Array.isArray(le1) ? le1 : gc().parse(le1),
                            toAttribute: (le1)=>null === le1 || "" === le1 ? "" : "string" === typeof le1 ? le1 : gc().stringify(le1)
                        };
                    }
                }
                Basic.properties = {
                    picture: {
                        type: String,
                        reflect: !0
                    },
                    sequence: {
                        type: String,
                        reflect: !0
                    },
                    "fetch-options": {
                        converter: Basic.GetJSONConverter()
                    },
                    users: {
                        type: Array,
                        reflect: !0
                    },
                    "map-style": {
                        type: String
                    },
                    lang: {
                        type: String
                    },
                    endpoint: {
                        type: String
                    }
                };
            },
            153: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>CoverageMap
                });
                var ls = bt(9039), ho = bt(5642), Dl = bt(8340), Fl = bt(927), sc = (bt(7776), bt(2118));
                class CoverageMap extends ls.A {
                    constructor(){
                        super(), this._mapContainer = document.createElement("div"), this.onceAPIReady().then(()=>{
                            this.loader.setAttribute("value", 30), this._initParams = new sc.Ay(sc.Ay.GetComponentProperties(CoverageMap, this)), this._initMap();
                        });
                    }
                    disconnectedCallback() {
                        var le1;
                        super.disconnectedCallback(), null === (le1 = this.map) || void 0 === le1 || le1.destroy();
                    }
                    getClassName() {
                        return "CoverageMap";
                    }
                    onceReady() {
                        return this.map && this.map.waitForEnoughMapLoaded ? this.map.waitForEnoughMapLoaded() : new Promise((le1)=>setTimeout(le1, 100)).then(this.onceReady.bind(this));
                    }
                    render() {
                        return [
                            this.loader,
                            this._mapContainer
                        ];
                    }
                    getSubComponentsNames() {
                        const le1 = super.getSubComponentsNames();
                        return le1.push("map"), le1;
                    }
                    _initMap() {
                        this.map = new ho.A(this, this._mapContainer, Object.assign({}, this._initParams.getMapInit(), {
                            hash: !0
                        })), this.map.addControl(new Fl.NavigationControl({
                            showCompass: !1
                        })), this.loader.setAttribute("value", 70), this.addEventListener("select", this._onSelect.bind(this)), this.map.on("picture-click", (le1)=>this.select(le1.seqId, le1.picId)), this.map.on("sequence-click", (le1)=>this.select(le1.seqId)), this.map.waitForEnoughMapLoaded().then(async ()=>{
                            await (0, sc.mK)(this.map, this._initParams.getMapPostInit()), this.map.reloadLayersStyles(), this.loader.dismiss();
                        });
                    }
                    _onSelect(le1) {
                        if (le1.detail.picId || le1.detail.seqId) {
                            const vt = le1.detail.picId ? "pictures" : "sequences", bt = this.map.queryRenderedFeatures({
                                layers: [
                                    ...this.map._userLayers
                                ].map((le1)=>(0, Dl.getUserLayerId)(le1, vt)),
                                filter: [
                                    "==",
                                    [
                                        "get",
                                        "id"
                                    ],
                                    le1.detail.picId || le1.detail.seqId
                                ]
                            });
                            bt.length >= 0 && null != bt[0] && this.map._attachPreviewToPictures({
                                features: bt
                            }, vt);
                        }
                    }
                }
                CoverageMap.properties = {
                    "map-options": {
                        converter: ls.A.GetJSONConverter()
                    },
                    ...ls.A.properties
                }, customElements.define("pnx-coverage-map", CoverageMap);
            },
            1752: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Editor
                });
                bt(7365);
                var ls = bt(9039), ho = bt(5642), Dl = bt(9048), Fl = bt(508), sc = bt(8340), uc = bt(1545), mc = bt(5995);
                const gc = "sequence-headings";
                class Editor extends ls.A {
                    constructor(){
                        super(), this.raster = null, this.background = "streets", this.users = [], this._psvContainer = document.createElement("div"), this._psvContainer.setAttribute("slot", "bg"), this._mapContainer = document.createElement("div"), this._mapContainer.setAttribute("slot", "bg"), this.grid = (0, mc.createWebComp)("pnx-cornered-grid"), this.grid.appendChild(this._psvContainer), this.grid.appendChild(this._mapContainer), this.onceAPIReady().then(()=>{
                            this.loader.setAttribute("value", 30), this.sequence || this.loader.dismiss({}, "No sequence is selected"), this.addEventListener("select", this._onSelect.bind(this)), this._initPSV(), this._initMap();
                        });
                    }
                    disconnectedCallback() {
                        var le1, vt;
                        super.disconnectedCallback(), null === (le1 = this.map) || void 0 === le1 || le1.destroy(), null === (vt = this.psv) || void 0 === vt || vt.destroy();
                    }
                    getClassName() {
                        return "Editor";
                    }
                    onceReady() {
                        var le1, vt;
                        return this.map && this.psv && null !== (le1 = (vt = this.map).loaded) && void 0 !== le1 && le1.call(vt) ? Promise.resolve() : new Promise((le1)=>setTimeout(le1, 100)).then(this.onceReady.bind(this));
                    }
                    connectedCallback() {
                        Array.isArray(this.users) && this.users.length > 0 && (console.warn("Parameters users can't be changed in Editor, only selected sequence can be visible"), this.users = []), super.connectedCallback(), this._moveChildToGrid(), window.addEventListener("DOMContentLoaded", ()=>{
                            this._moveChildToGrid();
                        }, {
                            once: !0
                        });
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        "users" === le1 && Array.isArray(bt) && bt.length > 0 ? console.warn("Parameters users can't be changed in Editor, only selected sequence can be visible") : super.attributeChangedCallback(le1, vt, bt);
                    }
                    render() {
                        return [
                            this.loader,
                            this.grid
                        ];
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "map",
                            "psv",
                            "grid"
                        ]);
                    }
                    _initPSV() {
                        try {
                            this.psv = new Dl.Ay(this, this._psvContainer), this.psv._myVTour.datasource.nodeResolver = this._getNode.bind(this), this.grid.appendChild((0, mc.createWebComp)("pnx-widget-player", {
                                slot: "top",
                                _parent: this,
                                class: "pnx-only-psv pnx-print-hidden",
                                size: "xl",
                                more: "never"
                            }));
                        } catch (le1) {
                            let vt = uc.IJ.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
                            this.loader.dismiss(le1, vt);
                        }
                    }
                    _initMap() {
                        try {
                            this.map = new ho.A(this, this._mapContainer, {
                                raster: this.raster,
                                background: this.background,
                                supplementaryStyle: this._createMapStyle(),
                                zoom: 15,
                                picMarkerDraggable: !0
                            }), (0, sc.linkMapAndPhoto)(this), this.loader.setAttribute("value", 50), this._loadSequence(), this.map.once("load", ()=>{
                                this.map.hasTwoBackgrounds() && this._addMapBackgroundWidget(), this._bindPicturesEvents();
                            });
                            const le1 = this.map._picMarker.setRotation.bind(this.map._picMarker);
                            this.map._picMarker.setRotation = (vt)=>(vt = void 0 === this._lastRelHeading ? vt : vt + this._lastRelHeading - this.psv.getPictureRelativeHeading(), le1(vt));
                        } catch (le1) {
                            this.loader.dismiss(le1, this._t.pnx.error_psv);
                        }
                    }
                    _createMapStyle() {
                        return {
                            sources: {
                                geovisio_editor_sequences: {
                                    type: "geojson",
                                    data: {
                                        type: "FeatureCollection",
                                        features: []
                                    }
                                }
                            },
                            layers: [
                                {
                                    id: "geovisio_editor_sequences",
                                    type: "line",
                                    source: "geovisio_editor_sequences",
                                    layout: {
                                        ...sc.VECTOR_STYLES_NOCROWD.SEQUENCES.layout
                                    },
                                    paint: {
                                        ...sc.VECTOR_STYLES_NOCROWD.SEQUENCES.paint
                                    }
                                },
                                {
                                    id: "geovisio_editor_pictures",
                                    type: "circle",
                                    source: "geovisio_editor_sequences",
                                    layout: {
                                        ...sc.VECTOR_STYLES_NOCROWD.PICTURES.layout
                                    },
                                    paint: {
                                        ...sc.VECTOR_STYLES_NOCROWD.PICTURES.paint
                                    }
                                }
                            ]
                        };
                    }
                    _bindPicturesEvents() {
                        this.map.on("mousemove", "geovisio_editor_pictures", ()=>{
                            this.map.getCanvas().style.cursor = "pointer";
                        }), this.map.on("mouseleave", "geovisio_editor_pictures", ()=>{
                            this.map.getCanvas().style.cursor = "";
                        }), this.map.on("click", "geovisio_editor_pictures", this.map._onPictureClick.bind(this.map));
                    }
                    _loadSequence() {
                        return this.loader.setAttribute("value", 60), this.api.getSequenceItems(this.sequence).then((le1)=>{
                            if (this.loader.setAttribute("value", 80), this.map.once("sourcedata", ()=>{
                                this.map.setPaintProperty("geovisio_editor_sequences", "line-color", this.map._getLayerColorStyle("sequences")), this.map.setPaintProperty("geovisio_editor_pictures", "circle-color", this.map._getLayerColorStyle("pictures")), this.map.setLayoutProperty("geovisio_editor_sequences", "visibility", "visible"), this.map.setLayoutProperty("geovisio_editor_pictures", "visibility", "visible"), this.map.once("styledata", ()=>this.loader.dismiss());
                            }), this._sequenceData = le1.features, this.map.getSource("geovisio_editor_sequences").setData({
                                type: "FeatureCollection",
                                features: [
                                    {
                                        id: this.sequence,
                                        type: "Feature",
                                        properties: {
                                            id: this.sequence
                                        },
                                        geometry: {
                                            type: "LineString",
                                            coordinates: le1.features.map((le1)=>le1.geometry.coordinates)
                                        }
                                    },
                                    ...le1.features.map((le1)=>(le1.properties.id = le1.id, le1.properties.sequences = [
                                            this.sequence
                                        ], le1))
                                ]
                            }), this.picture) {
                                const vt = le1.features.find((le1)=>le1.id === this.picture);
                                vt ? (this.select(this.sequence, this.picture, !0), this.map.jumpTo({
                                    center: vt.geometry.coordinates,
                                    zoom: 18
                                })) : console.log("Picture with ID", vt, "was not found");
                            } else {
                                const vt = [
                                    ...le1.features[0].geometry.coordinates,
                                    ...le1.features[0].geometry.coordinates
                                ];
                                for(let bt = 1; bt < le1.features.length; bt++){
                                    const ls = le1.features[bt].geometry.coordinates;
                                    ls[0] < vt[0] && (vt[0] = ls[0]), ls[1] < vt[1] && (vt[1] = ls[1]), ls[0] > vt[2] && (vt[2] = ls[0]), ls[1] > vt[3] && (vt[3] = ls[1]);
                                }
                                this.map.fitBounds(vt, {
                                    animate: !1
                                });
                            }
                        }).catch((le1)=>this.loader.dismiss(le1, this._t.pnx.error_api));
                    }
                    _getNode(le1) {
                        const vt = this._sequenceData.find((vt)=>vt.properties.id === le1), bt = vt ? (0, Fl.apiFeatureToPSVNode)(vt, this._t, this._isInternetFast, void 0, (le1)=>this.api.cleanResourceURL(le1)) : null;
                        return bt && delete bt.links, bt;
                    }
                    _addMapBackgroundWidget() {
                        const le1 = (0, mc.createWebComp)("pnx-map-background", {
                            _parent: this,
                            size: "sm",
                            slot: "bottom-left"
                        });
                        this.grid.appendChild(le1);
                    }
                    _moveChildToGrid() {
                        Array.from(this.querySelectorAll("[slot]")).forEach((le1)=>{
                            var vt;
                            null !== (vt = le1.tagName) && void 0 !== vt && vt.toLowerCase().startsWith("pnx-") && (le1._parent = this, le1._t = this._t), this.grid.appendChild(le1);
                        });
                    }
                    previewSequenceHeadingChange(le1) {
                        const vt = void 0 !== this.map.getLayer(gc);
                        if (this.map._picMarkerPreview.remove(), void 0 === le1) return delete this._lastRelHeading, vt && this.map.setLayoutProperty(gc, "visibility", "none"), void (this.picture && this.map._picMarker.setRotation(this.psv.getXY().x));
                        this._lastRelHeading = le1, vt || this.map.addLayer({
                            id: gc,
                            type: "symbol",
                            source: "geovisio_editor_sequences",
                            layout: {
                                "icon-image": "pnx-marker",
                                "icon-overlap": "always",
                                "icon-size": .8
                            }
                        });
                        const bt = -this.psv.getPictureRelativeHeading();
                        this.map.setLayoutProperty(gc, "visibility", "visible"), this.map.setLayoutProperty(gc, "icon-rotate", [
                            "+",
                            [
                                "get",
                                "view:azimuth"
                            ],
                            bt,
                            le1
                        ]);
                        const ls = [
                            [
                                "==",
                                [
                                    "geometry-type"
                                ],
                                "Point"
                            ]
                        ];
                        this.picture && ls.push([
                            "!=",
                            [
                                "get",
                                "id"
                            ],
                            this.picture
                        ]), this.map.setFilter(gc, [
                            "all",
                            ...ls
                        ]), this.picture && this.map._picMarker.setRotation(this.psv.getXY().x);
                    }
                    _onSelect() {
                        void 0 !== this._lastRelHeading && this.previewSequenceHeadingChange(this._lastRelHeading);
                    }
                }
                Editor.properties = {
                    raster: {
                        converter: ls.A.GetJSONConverter()
                    },
                    background: {
                        type: String
                    },
                    ...ls.A.properties
                }, customElements.define("pnx-editor", Editor);
            },
            3407: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    $p: ()=>Ac,
                    Ay: ()=>PhotoViewer,
                    RD: ()=>kc
                });
                bt(970);
                var ls = bt(1545), ho = bt(4451), Dl = bt(9039), Fl = bt(9048), sc = bt(5995), uc = bt(7343), mc = bt(2118), gc = bt(4207);
                const Ac = 20, Ec = Math.PI / 6, kc = [
                    "pnx-mini",
                    "pnx-widget-player",
                    "pnx-widget-zoom"
                ];
                class PhotoViewer extends Dl.A {
                    constructor(){
                        super(), this["psv-options"] = {}, this["url-parameters"] = this.getAttribute("url-parameters") || "true", this["keyboard-shortcuts"] = this.getAttribute("keyboard-shortcuts") || "true", this["skip-tags-menu-opening"] = "true" !== (this.getAttribute("skip-tags-menu-opening") || "false"), this["share-base-url"] = this.getAttribute("share-base-url") || null, this.widgets = this.getAttribute("widgets") || "true", this.grid = (0, sc.createWebComp)("pnx-cornered-grid"), this.psvContainer = document.createElement("div"), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.popup = (0, sc.createWebComp)("pnx-popup", {
                            _parent: this,
                            onclose: this._onPopupClose.bind(this)
                        }), this.tabindex = 0, this._sequencesMetadata = {};
                    }
                    _createInitParamsHandler() {
                        var le1, vt;
                        this._initParams = new mc.Ay(mc.Ay.GetComponentProperties(PhotoViewer, this), Object.assign({}, null === (le1 = this.urlHandler) || void 0 === le1 ? void 0 : le1.currentURLParams(), null === (vt = this.urlHandler) || void 0 === vt ? void 0 : vt.currentURLParams(!0)), {
                            disableAnnotations: localStorage.getItem(uc.DISABLE_ANNOTATIONS_PARAM)
                        });
                    }
                    _initWidgets() {
                        "false" !== this._initParams.getParentPostInit().widgets && ((0, uc.isInIframe)() || (this.grid.appendChild((0, sc.createWebComp)("pnx-widget-player", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-annotations-switch", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        }))), (0, uc.isInIframe)() ? (this.legend = (0, sc.createWebComp)("pnx-widget-legend", {
                            slot: "bottom-right",
                            light: !0,
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this.grid.appendChild(this.legend)) : this.isWidthSmall() ? (this.legend = (0, sc.createWebComp)("pnx-picture-legend", {
                            _parent: this
                        }), this.bottomDrawer = (0, sc.createWebComp)("pnx-bottom-drawer", {
                            slot: "bottom",
                            _parent: this,
                            class: this._initParams.getParentPostInit().willLoadPicture ? void 0 : "pnx-hidden"
                        }), this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer), this.addEventListener("select", (le1)=>{
                            (0, uc.isNullId)(le1.detail.picId) ? this.bottomDrawer.classList.add("pnx-hidden") : this.bottomDrawer.classList.remove("pnx-hidden");
                        })) : (this.legend = (0, sc.createWebComp)("pnx-widget-legend", {
                            slot: this.isWidthSmall() ? void 0 : "top-left",
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this.grid.appendChild((0, sc.createWebComp)("pnx-widget-zoom", {
                            slot: "bottom-right",
                            class: "pnx-print-hidden",
                            _parent: this
                        })), this.grid.appendChild(this.legend)));
                    }
                    connectedCallback() {
                        super.connectedCallback(), this.presetsManager = new gc.A(this.lang), "false" !== this["url-parameters"] && (this.urlHandler = new ho.A(this), this.onceReady().then(()=>{
                            this.urlHandler.listenToChanges(), this.urlHandler._onParentChange();
                        })), this.onceAPIReady().then(this._postAPIInit.bind(this)), this._moveChildToGrid(), window.addEventListener("DOMContentLoaded", ()=>{
                            this._moveChildToGrid();
                        }, {
                            once: !0
                        });
                    }
                    disconnectedCallback() {
                        var le1, vt;
                        super.disconnectedCallback(), null === (le1 = this.urlHandler) || void 0 === le1 || le1.destroy(), null === (vt = this.psv) || void 0 === vt || vt.destroy(), document.body.removeEventListener("click", this._toggleKeyboardBasedOnFocus), window.removeEventListener("keypress", this._toggleKeyboardBasedOnFocus);
                    }
                    getClassName() {
                        return "PhotoViewer";
                    }
                    onceReady() {
                        return this.oncePSVReady().then(()=>this._initParams.getParentPostInit().willLoadPicture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
                    }
                    render() {
                        return [
                            this.loader,
                            this.grid,
                            this.popup
                        ];
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "psv",
                            "grid",
                            "popup",
                            "urlHandler"
                        ]);
                    }
                    oncePSVReady() {
                        let le1;
                        return new Promise((vt)=>{
                            le1 = setInterval(()=>{
                                this.psv && "object" === typeof this.psv && (this.psv.container ? (clearInterval(le1), vt()) : this.psv.addEventListener && this.psv.addEventListener("ready", ()=>{
                                    clearInterval(le1), vt();
                                }, {
                                    once: !0
                                }));
                            }, 250);
                        });
                    }
                    onceFirstPicLoaded() {
                        return this.oncePSVReady().then(()=>this.psv.getPictureMetadata() ? Promise.resolve() : new Promise((le1)=>{
                                this.psv.addEventListener("picture-loaded", le1, {
                                    once: !0
                                });
                            }));
                    }
                    async _postAPIInit() {
                        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
                        const le1 = this._initParams.getParentPostInit();
                        this._initPSV(), this._initWidgets(), (0, mc.ai)(this, le1), le1.keyboardShortcuts && this._handleKeyboardManagement(), le1.willLoadPicture ? this.psv.getPictureMetadata() ? this.loader.dismiss() : this.psv.addEventListener("picture-loaded", ()=>this.loader.dismiss(), {
                            once: !0
                        }) : this.loader.dismiss();
                    }
                    _initPSV() {
                        try {
                            this.psv = new Fl.Ay(this, this.psvContainer, {
                                shouldGoFast: this._psvShouldGoFast.bind(this),
                                keyboard: "always",
                                keyboardActions: {
                                    ...ls.zY.keyboardActions,
                                    8: "ROTATE_UP",
                                    2: "ROTATE_DOWN",
                                    4: "ROTATE_LEFT",
                                    6: "ROTATE_RIGHT",
                                    PageUp: ()=>this.psv.goToNextPicture(),
                                    9: ()=>this.psv.goToNextPicture(),
                                    PageDown: ()=>this.psv.goToPrevPicture(),
                                    3: ()=>this.psv.goToPrevPicture(),
                                    5: ()=>this.moveCenter(),
                                    "*": ()=>this.moveCenter(),
                                    Home: ()=>{
                                        var le1;
                                        return null === (le1 = this._toggleFocus) || void 0 === le1 ? void 0 : le1.call(this);
                                    },
                                    7: ()=>{
                                        var le1;
                                        return null === (le1 = this._toggleFocus) || void 0 === le1 ? void 0 : le1.call(this);
                                    },
                                    End: ()=>this.mini.toggleAttribute("collapsed"),
                                    1: ()=>this.mini.toggleAttribute("collapsed"),
                                    " ": ()=>this.psv.toggleSequencePlaying(),
                                    0: ()=>this.psv.toggleSequencePlaying()
                                },
                                ...this._initParams.getPSVInit()
                            }), this.oncePSVReady().then(()=>{
                                this.loader.setAttribute("value", 50), (0, mc.Vy)(this.psv, this._initParams.getPSVPostInit());
                            }), this.psv.addEventListener("sequence-playing", ()=>this.classList.add("pnx-playing")), this.psv.addEventListener("sequence-stopped", ()=>this.classList.remove("pnx-playing")), this.psv.addEventListener("dblclick", ()=>clearTimeout(this._gridFocus)), this.psv.addEventListener("click", (le1)=>{
                                clearTimeout(this._gridFocus), "CANVAS" === le1.data.target.tagName && (!this.isMapWide || this.isMapWide && !this.isMapWide()) && (this._gridFocus = setTimeout(()=>{
                                    this.grid.toggleAway() ? this.classList.add("pnx-grid-toggled") : this.classList.remove("pnx-grid-toggled");
                                }, 250));
                            }), this.psvContainer.addEventListener("mousemove", ()=>{
                                this.grid._hidden && (clearTimeout(this._gridFocus), this.grid.toggleAway(!0), this.classList.remove("pnx-grid-toggled"));
                            });
                        } catch (le1) {
                            let vt = ls.IJ.isWebGLSupported ? this._t.pnx.error_psv : this._t.pnx.error_webgl;
                            this.loader.dismiss(le1, vt);
                        }
                    }
                    _enableKeyboard() {
                        this.psv.startKeyboardControl();
                    }
                    _disableKeyboard() {
                        this.psv.stopKeyboardControl();
                    }
                    _toggleKeyboardBasedOnFocus(le1) {
                        const vt = (null === le1 || void 0 === le1 ? void 0 : le1.target) || document.activeElement;
                        if (this.contains(vt)) {
                            for (let le1 of this.grid.childNodes)if ("bg" !== le1.getAttribute("slot") && !kc.includes(le1.tagName.toLowerCase()) && le1.contains(vt)) return void this._disableKeyboard();
                            if (null !== this.popup.getAttribute("visible")) return void this._disableKeyboard();
                            this._enableKeyboard();
                        } else this._disableKeyboard();
                    }
                    _handleKeyboardManagement() {
                        window.addEventListener("click", (le1)=>this._toggleKeyboardBasedOnFocus(le1)), window.addEventListener("keypress", this._toggleKeyboardBasedOnFocus.bind(this)), this.popup.addEventListener("open", this._disableKeyboard.bind(this)), this.popup.addEventListener("close", this._enableKeyboard.bind(this)), this.psv.addEventListener("click", this._enableKeyboard.bind(this));
                        for (let le1 of this.grid.childNodes)"bg" === le1.getAttribute("slot") || kc.includes(le1.tagName.toLowerCase()) || (le1.addEventListener("focusin", this._disableKeyboard.bind(this)), le1.addEventListener("focusout", ()=>{
                            null === this.popup.getAttribute("visible") && this._enableKeyboard();
                        }));
                    }
                    _psvShouldGoFast() {
                        return this.psv._sequencePlaying && this.psv.getTransitionDuration() < 1e3;
                    }
                    _moveChildToGrid() {
                        Array.from(this.querySelectorAll("[slot]")).forEach((le1)=>{
                            var vt;
                            null !== (vt = le1.tagName) && void 0 !== vt && vt.toLowerCase().startsWith("pnx-") && (le1._parent = this, le1._t = this._t), "editors" === le1.getAttribute("slot") ? this.onceReady().then(()=>{
                                var vt;
                                return null === (vt = this.legend) || void 0 === vt ? void 0 : vt.appendChild(le1);
                            }) : this.grid.appendChild(le1);
                        });
                    }
                    setPopup(le1) {
                        let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                        le1 ? this.popup.setAttribute("visible", "") : this.popup.removeAttribute("visible"), this.popup.innerHTML = "", "string" === typeof vt ? this.popup.innerHTML = vt : Array.isArray(vt) && vt.forEach((le1)=>this.popup.appendChild(le1));
                    }
                    _onPopupClose() {
                        this.dispatchEvent(new CustomEvent("focus-changed", {
                            detail: {
                                focus: this.map && this.isMapWide() ? "map" : "pic"
                            }
                        }));
                    }
                    _showQualityScoreDoc() {
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-quality-score-doc", {
                                _t: this._t
                            })
                        ]);
                    }
                    _showReportForm() {
                        if (!this.psv.getPictureMetadata()) throw new Error("No picture currently selected");
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-report-form", {
                                _parent: this
                            })
                        ]);
                    }
                    _showShareOptions() {
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-share-menu", {
                                _parent: this,
                                "base-url": this["share-base-url"]
                            })
                        ]);
                    }
                    _showSemanticsDoc() {
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-semantics-doc", {
                                _t: this._t
                            })
                        ]);
                    }
                    _showSemanticsDownload() {
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-semantics-download", {
                                _t: this._t
                            })
                        ]);
                    }
                    moveCenter() {
                        this.psv.getPictureMetadata() && this._psvAnimate({
                            speed: Fl.LM,
                            yaw: 0,
                            pitch: 0,
                            zoom: Fl.cS
                        });
                    }
                    moveLeft() {
                        this._moveToDirection("left");
                    }
                    moveRight() {
                        this._moveToDirection("right");
                    }
                    moveUp() {
                        this._moveToDirection("up");
                    }
                    moveDown() {
                        this._moveToDirection("down");
                    }
                    _moveToDirection(le1) {
                        let vt = this.psv.getPosition();
                        switch(le1){
                            case "up":
                                vt.pitch += Ec;
                                break;
                            case "left":
                                vt.yaw -= Ec;
                                break;
                            case "down":
                                vt.pitch -= Ec;
                                break;
                            case "right":
                                vt.yaw += Ec;
                        }
                        this._psvAnimate({
                            speed: Fl.LM,
                            ...vt
                        });
                    }
                    _psvAnimate(le1) {
                        this._lastPsvAnim && this._lastPsvAnim.cancel(), this._lastPsvAnim = this.psv.animate(le1);
                    }
                    addEventListener(le1, vt, bt) {
                        super.addEventListener(le1, vt, bt);
                    }
                }
                PhotoViewer.properties = {
                    "psv-options": {
                        converter: Dl.A.GetJSONConverter()
                    },
                    widgets: {
                        type: String
                    },
                    "url-parameters": {
                        type: String
                    },
                    "keyboard-shortcuts": {
                        type: String
                    },
                    tabindex: {
                        type: Number
                    },
                    "skip-tags-menu-opening": {
                        type: String
                    },
                    "share-base-url": {
                        type: String
                    },
                    ...Dl.A.properties
                }, customElements.define("pnx-photo-viewer", PhotoViewer);
            },
            8743: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Viewer
                });
                bt(9616);
                var ls = bt(8340), ho = bt(3407), Dl = bt(2771), Fl = bt(7343), sc = bt(5995), uc = bt(9683), mc = bt(2e3), gc = bt(9438), Ac = bt(2118);
                const Ec = 100;
                class Viewer extends ho.Ay {
                    constructor(){
                        super(), this["map-options"] = !0, this.geocoder = this.getAttribute("geocoder") || "nominatim", this.mini = (0, sc.createWebComp)("pnx-mini", {
                            slot: "bottom-left",
                            _parent: this,
                            onexpand: this._onMiniExpand.bind(this),
                            collapsed: !!(0, Fl.isNullId)(this.picture) || void 0
                        }), this.mini.addEventListener("expand", this._toggleFocus.bind(this)), this.grid.appendChild(this.mini), this.mapContainer = document.createElement("div"), this.tabindex = 0;
                    }
                    _createInitParamsHandler() {
                        var le1, vt;
                        this._initParams = new Ac.Ay(Ac.Ay.GetComponentProperties(Viewer, this), Object.assign({}, null === (le1 = this.urlHandler) || void 0 === le1 ? void 0 : le1.currentURLParams(), null === (vt = this.urlHandler) || void 0 === vt ? void 0 : vt.currentURLParams(!0)), {
                            map: (0, ls.getMapParamsFromLocalStorage)(),
                            disableAnnotations: localStorage.getItem(Fl.DISABLE_ANNOTATIONS_PARAM)
                        });
                    }
                    _initWidgets() {
                        var le1, vt;
                        "false" !== this._initParams.getParentPostInit().widgets && (this.grid.appendChild((0, sc.createWebComp)("pnx-widget-zoom", {
                            slot: this.isWidthSmall() ? "top-left" : "bottom-right",
                            class: this.isWidthSmall() ? "pnx-only-map pnx-print-hidden" : "pnx-print-hidden",
                            _parent: this
                        })), (0, Fl.isInIframe)() ? (this.legend = (0, sc.createWebComp)("pnx-widget-legend", {
                            slot: "bottom-right",
                            light: !0,
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this.grid.appendChild(this.legend)) : this.isWidthSmall() ? (this.legend = (0, sc.createWebComp)("pnx-picture-legend", {
                            _parent: this
                        }), this.bottomDrawer = (0, sc.createWebComp)("pnx-bottom-drawer", {
                            slot: "bottom",
                            _parent: this,
                            class: this._initParams.getParentPostInit().willLoadPicture ? void 0 : "pnx-hidden"
                        }), this.bottomDrawer.appendChild(this.legend), this.grid.appendChild(this.bottomDrawer), this.addEventListener("select", (le1)=>{
                            (0, Fl.isNullId)(le1.detail.picId) ? this.bottomDrawer.classList.add("pnx-hidden") : this.bottomDrawer.classList.remove("pnx-hidden");
                        })) : (this.legend = (0, sc.createWebComp)("pnx-widget-legend", {
                            slot: this.isWidthSmall() ? "top" : "top-left",
                            _parent: this,
                            focus: this._initParams.getParentPostInit().focus,
                            picture: this._initParams.getParentPostInit().picture
                        }), this._miniPicLegend = (0, sc.createWebComp)("pnx-mini-picture-legend", {
                            _parent: this
                        }), this.grid.appendChild(this.legend)), (0, Fl.isInIframe)() || (this.grid.appendChild((0, sc.createWebComp)("pnx-widget-player", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-annotations-switch", {
                            slot: "top",
                            _parent: this,
                            class: "pnx-only-psv pnx-print-hidden",
                            size: this.isHeightSmall() ? "md" : "xl"
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-widget-geosearch", {
                            slot: this.isWidthSmall() ? "top-right" : "top-left",
                            _parent: this,
                            class: "pnx-only-map pnx-print-hidden",
                            geocoder: this._initParams.getParentPostInit().geocoder
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-widget-mapfilters", {
                            slot: this.isWidthSmall() ? "top-right" : "top-left",
                            _parent: this,
                            "user-search": null !== this.api._endpoints.user_search && null !== this.api._endpoints.user_tiles,
                            "quality-score": (null === (le1 = this.map) || void 0 === le1 || null === (vt = le1._hasQualityScore) || void 0 === vt ? void 0 : vt.call(le1)) || !1,
                            class: "pnx-only-map pnx-print-hidden"
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-widget-semantics-filters", {
                            slot: this.isWidthSmall() ? "top-right" : "top-left",
                            _parent: this,
                            class: "pnx-only-map pnx-print-hidden"
                        })), this.grid.appendChild((0, sc.createWebComp)("pnx-widget-maplayers", {
                            slot: "top-right",
                            _parent: this,
                            class: "pnx-only-map pnx-print-hidden"
                        }))));
                    }
                    disconnectedCallback() {
                        var le1;
                        super.disconnectedCallback(), null === (le1 = this.map) || void 0 === le1 || le1.destroy();
                    }
                    getClassName() {
                        return "Viewer";
                    }
                    getSubComponentsNames() {
                        return super.getSubComponentsNames().concat([
                            "mini",
                            "map"
                        ]);
                    }
                    onceReady() {
                        return Promise.all([
                            this.oncePSVReady(),
                            this.onceMapReady()
                        ]).then(()=>this._initParams.getParentPostInit().willLoadPicture && !this.psv.getPictureMetadata() ? this.onceFirstPicLoaded() : Promise.resolve());
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        var ls, ho;
                        if (super.attributeChangedCallback(le1, vt, bt), "picture" === le1) {
                            if (null === (ls = this.legend) || void 0 === ls || null === (ho = ls.setAttribute) || void 0 === ho || ho.call(ls, "picture", bt), (0, Fl.isNullId)(vt) && !(0, Fl.isNullId)(bt) && this.mini.removeAttribute("collapsed"), (0, Fl.isNullId)(bt)) this.map && this.isMapWide() ? this.mini.classList.add("pnx-hidden") : this.map && !this.isMapWide() && this._setFocus("map");
                            else if ((0, Fl.isNullId)(vt) && this.sequence == this._initParams.getParentPostInit().sequence && !this._initParams.getParentPostInit().picture) {
                                var Dl, sc;
                                this.mini.classList.remove("pnx-hidden"), this.mini.removeAttribute("collapsed"), "closed" === (null === (Dl = this.bottomDrawer) || void 0 === Dl || null === (sc = Dl.getAttribute) || void 0 === sc ? void 0 : sc.call(Dl, "openness")) && this.bottomDrawer.setAttribute("openness", "half-opened");
                            } else {
                                var uc, mc;
                                if (this.mini.classList.remove("pnx-hidden"), (0, Fl.isNullId)(vt)) this._setFocus("pic"), "closed" === (null === (uc = this.bottomDrawer) || void 0 === uc || null === (mc = uc.getAttribute) || void 0 === mc ? void 0 : mc.call(uc, "openness")) && this.bottomDrawer.setAttribute("openness", "half-opened");
                            }
                        }
                        "focus" === le1 && this._setFocus(bt);
                    }
                    onceMapReady() {
                        if (!this["map-options"]) return Promise.resolve();
                        let le1;
                        return new Promise((vt)=>{
                            le1 = setInterval(()=>{
                                var bt, ls, ho;
                                "object" === typeof this.map && (null !== (bt = this.map) && void 0 !== bt && null !== (ls = bt.loaded) && void 0 !== ls && ls.call(bt) ? (clearInterval(le1), vt()) : null !== (ho = this.map) && void 0 !== ho && ho.once && this.map.once("render", ()=>{
                                    clearInterval(le1), vt();
                                }));
                            }, 250);
                        });
                    }
                    async _initMap() {
                        await new Promise((le1)=>{
                            this.map = new Dl.A(this, this.mapContainer, this._initParams.getMapInit()), (0, ls.saveMapParamsToLocalStorage)(this.map), this.map.once("users-changed", ()=>{
                                this.loader.setAttribute("value", 75), le1();
                            });
                        }), await (0, Ac.mK)(this.map, this._initParams.getMapPostInit()), (0, ls.initMapKeyboardHandler)(this), (0, ls.linkMapAndPhoto)(this);
                    }
                    async _postAPIInit() {
                        this.loader.setAttribute("value", 30), this._createInitParamsHandler();
                        const le1 = this._initParams.getParentPostInit();
                        this._initPSV(), await this._initMap(), this._initWidgets(), this._moveChildToGrid(), (0, Ac.iz)(this, le1), le1.keyboardShortcuts && this._handleKeyboardManagement(), le1.willLoadPicture ? this.psv.addEventListener("picture-loaded", (vt)=>{
                            (0, Ac.iz)(this, le1), this.loader.dismiss();
                        }, {
                            once: !0
                        }) : this.loader.dismiss();
                    }
                    _enableKeyboard() {
                        this.map && this.isMapWide() ? this._enableKeyboardMap() : this._enableKeyboardPSV();
                    }
                    _enableKeyboardMap() {
                        this.psv.stopKeyboardControl(), this.map.keyboard.enable();
                    }
                    _enableKeyboardPSV() {
                        this.psv.startKeyboardControl(), this.map.keyboard.disable();
                    }
                    _disableKeyboard() {
                        this.psv.stopKeyboardControl(), this.map.keyboard.disable();
                    }
                    _handleKeyboardManagement() {
                        window.addEventListener("click", (le1)=>this._toggleKeyboardBasedOnFocus(le1)), window.addEventListener("keypress", this._toggleKeyboardBasedOnFocus.bind(this)), this.addEventListener("focus-changed", (le1)=>{
                            this.popup.getAttribute("visible") ? this._disableKeyboard() : "map" === le1.detail.focus ? this._enableKeyboardMap() : this._enableKeyboardPSV();
                        }), this.popup.addEventListener("open", this._disableKeyboard.bind(this)), this.popup.addEventListener("close", this._enableKeyboard.bind(this)), this.psv.addEventListener("click", this._enableKeyboardPSV.bind(this));
                        for (let le1 of this.grid.childNodes)"bg" === le1.getAttribute("slot") || ho.RD.includes(le1.tagName.toLowerCase()) || (le1.addEventListener("focusin", this._disableKeyboard.bind(this)), le1.addEventListener("focusout", ()=>{
                            null === this.popup.getAttribute("visible") && this._enableKeyboard();
                        }));
                    }
                    moveCenter() {
                        const le1 = this.psv.getPictureMetadata();
                        le1 && (this.map && this.isMapWide() ? this.map.flyTo({
                            center: le1.gps,
                            zoom: 20
                        }) : super.moveCenter());
                    }
                    _moveToDirection(le1) {
                        if (this.map && this.isMapWide()) {
                            let vt;
                            switch(le1){
                                case "up":
                                    vt = [
                                        0,
                                        -100
                                    ];
                                    break;
                                case "left":
                                    vt = [
                                        -100,
                                        0
                                    ];
                                    break;
                                case "down":
                                    vt = [
                                        0,
                                        Ec
                                    ];
                                    break;
                                case "right":
                                    vt = [
                                        Ec,
                                        0
                                    ];
                            }
                            this.map.panBy(vt);
                        } else super._moveToDirection(le1);
                    }
                    isMapWide() {
                        return this.mapContainer.parentNode == this.grid;
                    }
                    _setFocus(le1) {
                        var vt, bt, ls, ho;
                        let Dl = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], gc = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        if ("map" === le1 && !this.map) throw new Error("Map is not enabled");
                        if (![
                            "map",
                            "pic"
                        ].includes(le1)) throw new Error("Invalid focus value (should be pic or map)");
                        if (this.focus = le1, (gc || ("map" !== le1 || !this.map || !this.isMapWide()) && ("pic" !== le1 || this.map && this.isMapWide())) && ("map" === le1 ? (this.psvContainer.parentNode == this.grid && (this.grid.removeChild(this.psvContainer), this.psvContainer.removeAttribute("slot")), this.mapContainer.parentNode == this.mini && this.mini.removeChild(this.mapContainer), this.mapContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.mapContainer), this.mini.appendChild(this.psvContainer), this.mini.icon = (0, sc.fa)(uc.pt), this._miniPicLegend && this.mini.appendChild(this._miniPicLegend), (0, Fl.isNullId)(this.picture) ? this.mini.classList.add("pnx-hidden") : this.mini.classList.remove("pnx-hidden"), this.map.getCanvas().focus()) : (this.mapContainer.parentNode == this.grid && (this.grid.removeChild(this.mapContainer), this.mapContainer.removeAttribute("slot")), this.psvContainer.parentNode == this.mini && (this.mini.removeChild(this.psvContainer), this._miniPicLegend && this.mini.removeChild(this._miniPicLegend)), this.psvContainer.setAttribute("slot", "bg"), this.grid.appendChild(this.psvContainer), this.mini.classList.remove("pnx-hidden"), this.mini.appendChild(this.mapContainer), this.mini.icon = (0, sc.fa)(mc.e5), this.psvContainer.focus()), null === this || void 0 === this || null === (vt = this.map) || void 0 === vt || null === (bt = vt.resize) || void 0 === bt || bt.call(vt), this.psv.autoSize(), this.psv.forceRefresh(), null === (ls = this.legend) || void 0 === ls || null === (ho = ls.setAttribute) || void 0 === ho || ho.call(ls, "focus", this.focus), !Dl)) {
                            const vt = new CustomEvent("focus-changed", {
                                detail: {
                                    focus: le1
                                }
                            });
                            this.dispatchEvent(vt);
                        }
                    }
                    _toggleFocus() {
                        this._setFocus(this.isMapWide() ? "pic" : "map");
                    }
                    _onMiniExpand() {
                        this.map.resize(), this.psv.autoSize();
                    }
                    _onMapFiltersChange() {
                        var le1;
                        const vt = (0, gc.qi)("#pnx-map-filters-menu"), bt = (0, gc.qi)("#pnx-map-theme"), ho = (0, ls.mapFiltersFormValues)(vt, bt, null === (le1 = this.map) || void 0 === le1 ? void 0 : le1._hasQualityScore());
                        this.map.setFilters(ho);
                    }
                    _showLocationPrecisionDoc() {
                        this.setPopup(!0, [
                            (0, sc.createWebComp)("pnx-location-precision-doc", {
                                _t: this._t
                            })
                        ]);
                    }
                }
                Viewer.properties = {
                    "map-options": {
                        converter: ho.Ay.GetJSONConverter()
                    },
                    focus: {
                        type: String,
                        reflect: !0
                    },
                    geocoder: {
                        type: String
                    },
                    tabindex: {
                        type: Number
                    },
                    ...ho.Ay.properties
                }, customElements.define("pnx-viewer", Viewer);
            },
            3921: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    Basic: ()=>ls.A,
                    CoverageMap: ()=>ho.A,
                    Editor: ()=>Dl.A,
                    PhotoViewer: ()=>sc.Ay,
                    Viewer: ()=>Fl.A
                });
                var ls = bt(9039), ho = bt(153), Dl = bt(1752), Fl = bt(8743), sc = bt(3407);
            },
            9341: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    core: ()=>ls,
                    layout: ()=>ho,
                    menus: ()=>Dl,
                    ui: ()=>Fl
                });
                var ls = bt(3921), ho = bt(456), Dl = bt(8794), Fl = bt(7091);
            },
            6784: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>BottomDrawer
                });
                var ls = bt(4542), ho = bt(1198), Dl = bt(5995);
                const Fl = {
                    opened: 0,
                    "half-opened": .7,
                    closed: 1
                };
                class BottomDrawer extends ls.WF {
                    constructor(){
                        super(), this._isDragging = !1, this.openness = "half-opened";
                    }
                    firstUpdated() {
                        super.firstUpdated(), this._boundTouchMove = this._onTouchMove.bind(this), this._boundTouchEnd = this._onTouchEnd.bind(this), this._drawerHeight = window.innerHeight - 30;
                        const le1 = this._getDrawer();
                        le1 && (le1.style.height = `${this._drawerHeight}px`, le1.style.maxHeight = `${this._drawerHeight}px`, (0, Dl.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            var le1, vt;
                            null === (le1 = this._parent.map) || void 0 === le1 || le1.addEventListener("click", ()=>this.openness = "closed"), null === (vt = this._parent.psv) || void 0 === vt || vt.addEventListener("click", ()=>this.openness = "closed");
                        }));
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        if (super.attributeChangedCallback(le1, vt, bt), "openness" === le1) {
                            if ("opened" !== bt) {
                                const le1 = this.shadowRoot.querySelector(".content");
                                le1 && (le1.scrollTop = 0);
                            }
                            const le1 = this._getDrawer();
                            le1 && (le1.style.transform = null);
                        }
                    }
                    disconnectedCallback() {
                        super.disconnectedCallback(), this._cleanupTouchListeners();
                    }
                    _getDrawer() {
                        var le1;
                        return null === (le1 = this.shadowRoot) || void 0 === le1 ? void 0 : le1.querySelector(".drawer");
                    }
                    _onHandleClick() {
                        "opened" === this.openness ? this.openness = "closed" : "half-opened" === this.openness ? this.openness = "opened" : "closed" === this.openness && (this.openness = "half-opened");
                    }
                    _onTouchStart(le1) {
                        this._isDragging = !0, this._startFingerY = le1.touches[0].clientY, this._deltaFingerY = 0, this._drawerY = this._drawerHeight * Fl[this.openness], window.addEventListener("touchmove", this._boundTouchMove, {
                            passive: !0
                        }), window.addEventListener("touchend", this._boundTouchEnd), window.addEventListener("touchcancel", this._boundTouchEnd);
                    }
                    _onTouchMove(le1) {
                        if (!this._isDragging) return;
                        const vt = this.shadowRoot.querySelector(".content");
                        vt.scrollHeight > vt.offsetHeight && vt.scrollTop > 0 ? this._updateDrawerTransform(0) : (this._deltaFingerY = le1.touches[0].clientY - this._startFingerY, this._updateDrawerTransform(this._drawerY + this._deltaFingerY));
                    }
                    _onTouchEnd(le1) {
                        (this._isDragging && !(Math.abs(this._deltaFingerY) < 30) || le1.target.closest(".handle")) && (le1.preventDefault(), this._isDragging = !1, 0 === this._deltaFingerY && "closed" === this.openness ? this.openness = "half-opened" : this._updateDrawerTransform(this._drawerY + this._deltaFingerY, !0), this._cleanupTouchListeners(), this._startFingerY = null, this._deltaFingerY = null);
                    }
                    _cleanupTouchListeners() {
                        window.removeEventListener("touchmove", this._boundTouchMove), window.removeEventListener("touchend", this._boundTouchEnd), window.removeEventListener("touchcancel", this._boundTouchCancel);
                    }
                    _updateDrawerTransform(le1) {
                        let vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        const bt = this._getDrawer();
                        bt && (le1 = Math.max(0, Math.min(le1, this._drawerHeight - 30)), vt && (this._deltaFingerY < 0 ? "closed" === this.openness ? Math.abs(this._deltaFingerY) > this._drawerHeight * (1 - Fl["half-opened"]) ? this.openness = "opened" : this.openness = "half-opened" : this.openness = "opened" : this.openness = "closed", this._drawerY = null, le1 = Math.max(0, Math.min(Fl[this.openness] * this._drawerHeight, this._drawerHeight - 30))), bt.style.transform = `translateY(${le1}px)`);
                    }
                    render() {
                        const le1 = {
                            drawer: !0,
                            [this.openness]: !0,
                            dragging: this._isDragging
                        };
                        return ls.qy`
			<div
				class=${(0, ho.H)(le1)}
				@touchstart="${this._onTouchStart}"
				@touchmove="${this._onTouchMove}"
				@touchend="${this._onTouchEnd}"
			>
				<div class="handle" @click=${this._onHandleClick}>
					<div class="handle-bar"></div>
				</div>
				<div class="content">
					<slot></slot>
				</div>
			</div>
		`;
                    }
                }
                BottomDrawer.styles = ls.AH`
		:host {
			position: fixed;
			bottom: 0;
			left: 0;
			width: 100%;
			z-index: 130;
			pointer-events: none;
			touch-action: none;
		}

		.drawer {
			background: var(--widget-bg);
			border-top-left-radius: 16px;
			border-top-right-radius: 16px;
			box-shadow: 0 -2px 10px rgba(0, 0, 0, 0.2);
			display: flex;
			flex-direction: column;
			transition: transform 0.3s ease;
			will-change: transform;
			touch-action: auto;
			pointer-events: auto;
		}

		.drawer.dragging { transition: none; }
		.drawer.closed { transform: translateY(calc(100% - 30px)); }
		.drawer.half-opened { transform: translateY(70%); }
		.drawer.half-opened .content { overflow-y: hidden; }
		.drawer.opened { transform: translateY(0%); }

		.handle {
			height: 30px;
			display: flex;
			align-items: center;
			justify-content: center;
			cursor: pointer;
		}

		.handle-bar {
			width: 40px;
			height: 5px;
			background: var(--grey-pale);
			border-radius: 3px;
		}

		.content {
			overflow: auto;
			flex: 1;
		}
	`, BottomDrawer.properties = {
                    _fingerY: {
                        state: !0
                    },
                    _deltaFingerY: {
                        state: !0
                    },
                    _drawerY: {
                        state: !0
                    },
                    _isDragging: {
                        state: !0
                    },
                    _drawerHeight: {
                        state: !0
                    },
                    openness: {
                        type: String,
                        reflect: !0
                    }
                }, customElements.define("pnx-bottom-drawer", BottomDrawer);
            },
            7422: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>CorneredGrid
                });
                var ls = bt(4542), ho = bt(1198);
                class CorneredGrid extends ls.WF {
                    constructor(){
                        super(), this._hidden = !1;
                    }
                    toggleAway(le1) {
                        return this._hidden = null === le1 || void 0 === le1 ? !this._hidden : !le1, this._hidden;
                    }
                    render() {
                        return this.renderRoot.host.className = this._hidden ? "toggled" : "", ls.qy`
			<div class="bg">
				<slot name="bg"></slot>
			</div>
			<div class=${(0, ho.H)({
                            row: !0,
                            top: !0,
                            toggled: this._hidden
                        })}>
				<div class="corner left" part="corner-top-left">
					<slot name="top-left"></slot>
				</div>
				<div class="corner middle" part="corner-top">
					<slot name="top"></slot>
				</div>
				<div class="corner right" part="corner-top-right">
					<slot name="top-right"></slot>
				</div>
			</div>
			<div class=${(0, ho.H)({
                            row: !0,
                            bottom: !0,
                            toggled: this._hidden
                        })}>
				<div class="corner left" part="corner-bottom-left">
					<slot name="bottom-left"></slot>
				</div>
				<div class="corner middle" part="corner-bottom">
					<slot name="bottom"></slot>
				</div>
				<div class="corner right" part="corner-bottom-right">
					<slot name="bottom-right"></slot>
				</div>
			</div>
		`;
                    }
                }
                CorneredGrid.styles = ls.AH`
		:host {
			position: relative;
			width: 100%;
			height: 100%;
			display: flex;
			flex-direction: column;
			gap: 5px;
			flex-wrap: no-wrap;
		}

		.bg {
			position: absolute;
			inset: 0;
			z-index: 0;
		}

		.row {
			display: flex;
			flex-direction: row;
			flex: 1 1 50%;
			pointer-events: none;
			transition: margin 0.5s ease-in-out;
		}

		.row.bottom { align-items: flex-end; }

		.row.top.toggled { margin: -100% 0 200% 0; }
		.row.bottom.toggled { margin: 200% 0 -100% 0; }
		@media screen and (min-width: 576px) {
			.row.top.toggled { margin: -50% 0 100% 0; }
			.row.bottom.toggled { margin: 100% 0 -50% 0; }
		}

		.corner {
			position: relative;
			flex: 1 1 33%;
			display: flex;
			gap: 10px;
			height: min-content;
		}

		.corner slot {
			pointer-events: auto;
			position: relative;
			z-index: 120;
		}

		.row.bottom .corner:not(.middle) { flex-direction: column; }
		.row.bottom .corner.left { flex-direction: column-reverse; justify-content: flex-start; align-items: flex-start; }
		.row.bottom .corner.middle { justify-content: center; align-items: flex-end; }
		.row.bottom .corner.right { justify-content: flex-end; align-items: flex-end; }

		.row.top .corner { flex-direction: row; }
		.row.top .corner.left { justify-content: flex-start; align-items: flex-start; }
		.row.top .corner.middle { justify-content: center; }
		.row.top .corner.right { justify-content: flex-end; align-items: flex-start; }
	`, CorneredGrid.properties = {
                    _hidden: {
                        state: !0
                    }
                }, customElements.define("pnx-cornered-grid", CorneredGrid);
            },
            1445: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Mini
                });
                var ls = bt(4542), ho = bt(1462), Dl = bt(5721);
                class Mini extends ls.WF {
                    constructor(){
                        super(), this.collapsed = !1, this.icon = null;
                    }
                    render() {
                        var le1, vt;
                        const bt = (null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.isWidthSmall()) || (null === (vt = this._parent) || void 0 === vt ? void 0 : vt.isHeightSmall()), onExpand = ()=>this.dispatchEvent(new Event("expand", {
                                bubbles: !0,
                                composed: !0
                            }));
                        if (this.collapsed || bt) {
                            const le1 = bt ? onExpand : ()=>this.collapsed = !1;
                            return ls.qy`<pnx-button
				kind="flat"
				size="xxl"
				style="bottom: 0"
				@click=${le1}
			>${this.icon}</pnx-button>`;
                        }
                        var Fl, sc, uc;
                        return ls.qy`
				<slot></slot>

				<pnx-button
					kind="superflat"
					title=${null === (Fl = this._parent) || void 0 === Fl ? void 0 : Fl._t.pnx.expand_info}
					style="top: 0; right: 0"
					@click=${onExpand}
				>
					<img src=${ho} alt="" />
					${null === (sc = this._parent) || void 0 === sc ? void 0 : sc._t.pnx.expand}
				</pnx-button>

				<pnx-button
					kind="flat"
					title=${null === (uc = this._parent) || void 0 === uc ? void 0 : uc._t.pnx.minimize}
					style="bottom: 0; left: 0"
					@click=${()=>this.collapsed = !0}
				>
					<img src=${Dl} alt="" />
				</pnx-button>
			`;
                    }
                }
                Mini.styles = ls.AH`
		:host {
			display: block;
			position: absolute;
			inset: 0;
			pointer-events: none;
		}

		slot {
			z-index: 120;
			pointer-events: auto;
		}

		pnx-button {
			z-index: 121;
			position: absolute;
			pointer-events: auto;
		}

		pnx-button img {
			height: 20px;
		}

		pnx-button:not([size="xxl"])::part(btn) {
			border-top-left-radius: 0;
			border-bottom-right-radius: 0;
		}
	`, Mini.properties = {
                    icon: {
                        type: String
                    },
                    collapsed: {
                        type: Boolean,
                        reflect: !0
                    }
                }, customElements.define("pnx-mini", Mini);
            },
            5534: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Tabs
                });
                var ls = bt(4542);
                class Tabs extends ls.WF {
                    constructor(){
                        super(), this.activeTabIndex = 0, this.hideNav = !1;
                    }
                    _getTabs() {
                        var le1;
                        return (null === (le1 = this.shadowRoot.querySelector("slot[name='title']")) || void 0 === le1 ? void 0 : le1.assignedNodes()) || [];
                    }
                    _getContents() {
                        var le1;
                        return (null === (le1 = this.shadowRoot.querySelector("slot[name='content']")) || void 0 === le1 ? void 0 : le1.assignedNodes()) || [];
                    }
                    _changeTab(le1, vt) {
                        const bt = this._getTabs(), ls = this._getContents();
                        void 0 === le1 && void 0 === vt || (le1 && (vt = bt.findIndex((vt)=>vt === le1 || vt === le1.parentNode)), !isNaN(vt) && vt >= 0 && vt < bt.length && bt.forEach((le1, bt)=>{
                            bt == vt ? (this.activeTabIndex = bt, ls[bt].classList.add("active"), le1.classList.add("active")) : (ls[bt].classList.remove("active"), le1.classList.remove("active"));
                        }));
                    }
                    _handleTabClick(le1) {
                        this._changeTab(le1.target);
                    }
                    updated(le1) {
                        le1.has("activeTabIndex") && this._changeTab(void 0, this.activeTabIndex);
                    }
                    render() {
                        return ls.qy`
			${this.hideNav ? ls.s6 : ls.qy`<nav @click="${this._handleTabClick}">
				<slot name="title" @slotchange=${()=>this.activeTabIndex = 0}></slot>
			</nav>`}
			<div class="contents">
				<slot name="content"></slot>
			</div>
		`;
                    }
                }
                Tabs.styles = ls.AH`
		/* Tabs */
		nav {
			display: flex;
			gap: 5px;
			align-items: stretch;
			overflow-x: auto;
			touch-action: pan-x;
			position: sticky;
			top: 0;
			background: white;
			z-index: 125;
		}
		nav ::slotted(*) {
			color: var(--grey-dark);
			border-bottom: 2px solid rgba(0,0,0,0);
			cursor: pointer;
			transition: all 0.1s;
			flex: 1;
		}
		nav ::slotted(*:hover:not(.active)) { background-color: var(--blue-pale); }
		nav ::slotted(*.active) {
			color: var(--blue-dark);
			border-bottom: 2px solid var(--blue-dark);
		}

		/* Content */
		.contents ::slotted(div) { display: none !important; }
		.contents ::slotted(.active) { display: block !important; }
	`, Tabs.properties = {
                    activeTabIndex: {
                        type: Number,
                        reflect: !0
                    },
                    hideNav: {
                        type: Boolean
                    }
                }, customElements.define("pnx-tabs", Tabs);
            },
            456: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    BottomDrawer: ()=>ls.A,
                    CorneredGrid: ()=>ho.A,
                    Mini: ()=>Dl.A,
                    Tabs: ()=>Fl.A
                });
                var ls = bt(6784), ho = bt(7422), Dl = bt(1445), Fl = bt(5534);
            },
            5537: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>LocationPrecisionDoc
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(6655), sc = bt(7704), uc = bt(7343);
                class LocationPrecisionDoc extends ls.WF {
                    render() {
                        var le1, vt, bt, ho, mc, gc;
                        return ls.qy`
			<h4>${(0, Dl.fa)(Fl.Pc)} ${null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.filter_gps_precision}</h4>
			<p>${null === (vt = this._t) || void 0 === vt ? void 0 : vt.pnx.filter_gps_precision_help_1}</p>
			<p>${null === (bt = this._t) || void 0 === bt ? void 0 : bt.pnx.filter_gps_precision_help_2}</p>
			<pnx-grade-filter grade=""></pnx-grade-filter>
			<p>${null === (ho = this._t) || void 0 === ho ? void 0 : ho.pnx.filter_gps_precision_help_3.replace("{p5}", uc.QUALITYSCORE_GPS_VALUES[1]).replace("{p1}", uc.QUALITYSCORE_GPS_VALUES[7]).replace(/\.01/g, "")}</p>
			<p>${null === (mc = this._t) || void 0 === mc ? void 0 : mc.pnx.filter_gps_precision_help_4}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/#gps-position-accuracy"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${(0, Dl.fa)(sc.A)} ${null === (gc = this._t) || void 0 === gc ? void 0 : gc.pnx.popup_details_link}</pnx-link-button>
		`;
                    }
                }
                LocationPrecisionDoc.styles = [
                    ho.YC,
                    ho.Op,
                    ho.lk
                ], customElements.define("pnx-location-precision-doc", LocationPrecisionDoc);
            },
            5036: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapBackground
                });
                var ls = bt(4542), ho = bt(7534), Dl = bt(6810), Fl = bt(5995);
                class MapBackground extends ls.WF {
                    constructor(){
                        super(), this.size = "md";
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, Fl.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            null === (le1 = this._parent.map) || void 0 === le1 || le1.on("background-changed", (le1)=>{
                                this.bg = le1.background;
                            }), this.bg = null === (vt = this._parent.map) || void 0 === vt ? void 0 : vt.getBackground();
                        });
                    }
                    _onBgSelect(le1) {
                        var vt, bt;
                        this.bg = le1.target.value, null === (vt = this._parent) || void 0 === vt || null === (bt = vt.map) || void 0 === bt || bt.setBackground(this.bg);
                    }
                    render() {
                        var le1, vt;
                        return ls.qy`
			<input
				type="radio"
				id="bg-streets"
				name="bg"
				value="streets"
				@change=${this._onBgSelect}
				.checked=${"streets" == this.bg}
			/>
			<label for="bg-streets">
				<img src=${Dl} class=${this.size} alt="" />
				${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.map_background_streets}
			</label>
			<input
				type="radio"
				id="bg-aerial"
				name="bg"
				value="aerial"
				@change=${this._onBgSelect}
				.checked=${"aerial" == this.bg}
			/>
			<label for="bg-aerial">
				<img src=${ho} class=${this.size} alt="" />
				${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.map_background_aerial}
			</label>
		`;
                    }
                }
                MapBackground.styles = [
                    ls.AH`
		:host {
			justify-content: space-evenly;
			box-sizing: border-box;
			display: flex;
			gap: 10px;
		}
		input { display: none; }
		label { cursor: pointer; }

		img {
			width: 40px;
			border-radius: 5px;
			vertical-align: middle;
			margin-right: 5px;
			border: 2px solid var(--widget-bg);
		}

		img.sm {
			width: 32px;
		}

		input:checked + label img {
			outline: 3px solid var(--widget-border-btn);
		}
	`
                ], MapBackground.properties = {
                    bg: {
                        state: !0
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-map-background", MapBackground);
            },
            3581: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapFilters
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(7343), Fl = bt(8591), sc = bt(5279), uc = bt(9186), mc = bt(6069), gc = bt(3233), Ac = bt(6668), Ec = bt(7879), kc = bt(6655);
                class MapFilters extends ls.WF {
                    constructor(){
                        super(), this._formDelay = null, this.showZoomIn = !0;
                    }
                    connectedCallback() {
                        super.connectedCallback();
                        for (let le1 of this.shadowRoot.querySelectorAll("input"))le1.addEventListener("change", this._onFormChange.bind(this)), le1.addEventListener("keypress", this._onFormChange.bind(this)), le1.addEventListener("paste", this._onFormChange.bind(this)), le1.addEventListener("input", this._onFormChange.bind(this));
                        (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = (vt = this._parent).onceMapReady) || void 0 === le1 ? void 0 : le1.call(vt).then(async ()=>{
                                this._parent.map.on("zoomend", this._onMapZoom.bind(this)), this._parent.map.on("filters-changed", this._onParentFilterChange.bind(this)), this._onMapZoom(), this._onParentFilterChange(this._parent.map._mapFilters);
                                const le1 = this._parent.map.getVisibleUsers();
                                if ((null === le1 || void 0 === le1 ? void 0 : le1.length) > 0 && "geovisio" != le1[0]) {
                                    this.user = le1[0];
                                    const vt = await this._parent.api.getUserName(le1[0]);
                                    vt && (this.user = vt);
                                }
                            });
                        });
                    }
                    _onMapZoom() {
                        this.showZoomIn = this._parent.map.getZoom() < 7;
                    }
                    _onParentFilterChange(le1) {
                        var vt;
                        if (this.minDate = (null === le1 || void 0 === le1 ? void 0 : le1.minDate) || null, this.maxDate = (null === le1 || void 0 === le1 ? void 0 : le1.maxDate) || null, this.minDate && this.maxDate && this.minDate > this.maxDate) {
                            const le1 = this.minDate;
                            this.minDate = this.maxDate, this.maxDate = le1, this._onFormChange();
                        }
                        this.score = Array.isArray(null === le1 || void 0 === le1 ? void 0 : le1.qualityscore) ? le1.qualityscore.join(",") : "", this.gps = null !== le1 && void 0 !== le1 && le1.gps && Array.isArray(le1.gps) ? le1.gps.join(",") : (null === le1 || void 0 === le1 || null === (vt = le1.gps) || void 0 === vt ? void 0 : vt.length) > 0 ? le1.gps : "", this.type = "", null !== le1 && void 0 !== le1 && le1.pic_type && "" != le1.pic_type && (this.type = "flat" == le1.pic_type ? "flat" : "equirectangular");
                    }
                    _onSubmit(le1) {
                        return le1.preventDefault(), this._onFormChange(), !1;
                    }
                    _onFormChange() {
                        this._formDelay && clearTimeout(this._formDelay), this._formDelay = setTimeout(()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._onMapFiltersChange();
                        }, 250);
                    }
                    _userSearch(le1) {
                        return null === this || void 0 === this ? void 0 : this._parent.api.searchUsers(le1).then((le1)=>(le1 || []).map((le1)=>({
                                    title: le1.label,
                                    data: le1
                                })));
                    }
                    _onUserSearchResult(le1) {
                        var vt, bt, ls;
                        return le1.detail ? le1.target.classList.add("pnx-filter-active") : le1.target.classList.remove("pnx-filter-active"), null === (vt = this._parent) || void 0 === vt || null === (bt = vt.map) || void 0 === bt ? void 0 : bt.setVisibleUsers(null !== (ls = le1.detail) && void 0 !== ls && ls.data ? [
                            le1.detail.data.id
                        ] : [
                            "geovisio"
                        ]);
                    }
                    _onReset() {
                        var le1, vt, bt;
                        null === (le1 = this.shadowRoot.querySelector("#pnx-filter-qualityscore")) || void 0 === le1 || le1.setAttribute("grade", ""), null === (vt = this.shadowRoot.querySelector("#pnx-filter-search-user")) || void 0 === vt || vt.reset(), null === (bt = this.shadowRoot.querySelector("#pnx-filter-gps")) || void 0 === bt || bt.setAttribute("grade", ""), this.minDate = null, this.maxDate = null, this.type = "", this.score = null, this.user = null, this._onFormChange();
                    }
                    _onDateShortcut(le1) {
                        const vt = this.shadowRoot.getElementById("pnx-filter-date-from"), bt = this.shadowRoot.getElementById("pnx-filter-date-end");
                        vt && (vt.value !== le1 ? vt.value = le1 : vt.value = ""), bt && (bt.value = "");
                    }
                    _onMeUserSearch() {
                        var le1, vt;
                        const bt = (0, Dl.getUserAccount)();
                        if (!bt) return;
                        const ls = this.shadowRoot.getElementById("pnx-filter-search-user");
                        null !== (le1 = this._parent) && void 0 !== le1 && null !== (vt = le1.map) && void 0 !== vt && vt.getVisibleUsers().includes(bt.id) ? null === ls || void 0 === ls || ls._onResultClick() : null === ls || void 0 === ls || ls._onResultClick({
                            title: bt.name,
                            data: {
                                id: bt.id
                            }
                        });
                    }
                    render() {
                        var le1, vt, bt, Fl, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd, Yd, Qd, Xd, Kd, Jd, $d, sp;
                        const em = (0, Dl.getUserAccount)(), tm = {
                            1: null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.filter_gps_precision_morethan.replace("{n}", Dl.QUALITYSCORE_GPS_VALUES[7]).replace(/\.01/g, ""),
                            2: null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.filter_gps_precision_between.replace("{n1}", Dl.QUALITYSCORE_GPS_VALUES[5]).replace("{n2}", Dl.QUALITYSCORE_GPS_VALUES[7]).replace(/\.01/g, ""),
                            3: null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.filter_gps_precision_between.replace("{n1}", Dl.QUALITYSCORE_GPS_VALUES[3]).replace("{n2}", Dl.QUALITYSCORE_GPS_VALUES[5]).replace(/\.01/g, ""),
                            4: null === (Fl = this._parent) || void 0 === Fl ? void 0 : Fl._t.pnx.filter_gps_precision_between.replace("{n1}", Dl.QUALITYSCORE_GPS_VALUES[1]).replace("{n2}", Dl.QUALITYSCORE_GPS_VALUES[3]).replace(/\.01/g, ""),
                            5: null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.filter_gps_precision_lessthan.replace("{n}", Dl.QUALITYSCORE_GPS_VALUES[1]).replace(/\.01/g, "")
                        };
                        return ls.qy`<form
			@reset=${this._onReset}
			@change=${this._onFormChange}
			@submit=${this._onSubmit}
		>
			${this["no-date"] ? "" : ls.qy`<div class="pnx-filter-block">
				<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.filter_zoom_in}</div>
				<h4>${(0, ho.fa)(uc.ok)} ${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.filter_date}</h4>
				<div class="pnx-input-shortcuts">
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 1)).toISOString().split("T")[0])}
					>${null === (Ld = this._parent) || void 0 === Ld ? void 0 : Ld._t.pnx.filter_date_1month}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setMonth((new Date).getMonth() - 6)).toISOString().split("T")[0])}
					>${null === (Nd = this._parent) || void 0 === Nd ? void 0 : Nd._t.pnx.filter_date_6months}</button>
					<button
						@click=${()=>this._onDateShortcut(new Date((new Date).setFullYear((new Date).getFullYear() - 1)).toISOString().split("T")[0])}
					>${null === (Rd = this._parent) || void 0 === Rd ? void 0 : Rd._t.pnx.filter_date_1year}</button>
				</div>
				<div class="pnx-input-group">
					<input
						type="date"
						id="pnx-filter-date-from"
						.value=${this.minDate}
						class=${this.minDate && "" != this.minDate ? "pnx-filter-active" : ""}
					/>
					${(0, ho.fa)(mc.dm)}
					<input
						type="date"
						id="pnx-filter-date-end"
						.value=${this.maxDate}
						class=${this.maxDate && "" != this.maxDate ? "pnx-filter-active" : ""}
					/>
				</div>
			</div>`}

			${this["no-picture-type"] ? "" : ls.qy`<div class="pnx-filter-block">
				<h4>${(0, ho.fa)(sc.jb)} ${null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.filter_picture}</h4>
				<div class="pnx-input-group pnx-checkbox-btns" style="justify-content: center;">
					<input
						type="radio"
						id="pnx-filter-type-all"
						name="pnx-filter-type"
						value=""
						.checked=${!this.type || "" === this.type}
					/>
					<label for="pnx-filter-type-all">${null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.picture_all}</label>
					<input
						type="radio"
						id="pnx-filter-type-flat"
						name="pnx-filter-type"
						value="flat"
						.checked=${"flat" === this.type}
					/>
					<label for="pnx-filter-type-flat">${null === (Ud = this._parent) || void 0 === Ud ? void 0 : Ud._t.pnx.picture_flat}</label>
					<input
						type="radio"
						id="pnx-filter-type-360"
						name="pnx-filter-type"
						value="equirectangular"
						.checked=${"equirectangular" === this.type}
					/>
					<label for="pnx-filter-type-360">${null === (Gd = this._parent) || void 0 === Gd ? void 0 : Gd._t.pnx.picture_360}</label>
				</div>
			</div>`}

			${this["quality-score"] ? ls.qy`
				<div class="pnx-filter-block">
					<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">${null === (qd = this._parent) || void 0 === qd ? void 0 : qd._t.pnx.filter_zoom_in}</div>
					<h4>
						${(0, ho.fa)(gc.B9)} ${null === (Hd = this._parent) || void 0 === Hd ? void 0 : Hd._t.pnx.filter_qualityscore}
						<pnx-button
							title="${null === (Wd = this._parent) || void 0 === Wd ? void 0 : Wd._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showQualityScoreDoc();
                        }}
						>
							${(0, ho.fa)(Ac.iW)}
						</pnx-button>
					</h4>
					<div class="pnx-input-group">
						<pnx-quality-score
							id="pnx-filter-qualityscore"
							._t=${null === (Zd = this._parent) || void 0 === Zd ? void 0 : Zd._t}
							input="pnx-filter-qualityscore"
							grade=${this.score}
							@change=${this._onFormChange}
						>
						</pnx-quality-score>
					</div>
				</div>
			` : ls.s6}

			${this["no-gps"] ? "" : ls.qy`
				<div class="pnx-filter-block">
					<div class="pnx-filter-zoomin ${this.showZoomIn ? "" : "hidden"}">${null === (Yd = this._parent) || void 0 === Yd ? void 0 : Yd._t.pnx.filter_zoom_in}</div>
					<h4>
						${(0, ho.fa)(kc.Pc)} ${null === (Qd = this._parent) || void 0 === Qd ? void 0 : Qd._t.pnx.filter_gps_precision}
						${this._parent._showLocationPrecisionDoc ? ls.qy`
							<pnx-button
								title="${null === (Xd = this._parent) || void 0 === Xd ? void 0 : Xd._t.pnx.filter_gps_precision_help}"
								kind="superinline"
								@click=${()=>this._parent._showLocationPrecisionDoc()}
							>
								${(0, ho.fa)(Ac.iW)}
							</pnx-button>
						` : ls.s6}
					</h4>
					<div class="pnx-input-group">
						<pnx-grade-filter
							id="pnx-filter-gps"
							._t=${null === (Kd = this._parent) || void 0 === Kd ? void 0 : Kd._t}
							input="pnx-filter-gps"
							grade=${this.gps}
							@change=${this._onFormChange}
							.labels=${tm}
						>
						</pnx-grade-filter>
					</div>
				</div>
			`}

			${this["user-search"] ? ls.qy`
				<div class="pnx-filter-block">
					<h4>${(0, ho.fa)(Ec.X4)} ${null === (Jd = this._parent) || void 0 === Jd ? void 0 : Jd._t.pnx.filter_user}</h4>
					${em ? ls.qy`
						<div class="pnx-input-shortcuts">
							<button @click=${this._onMeUserSearch}>
								${null === ($d = this._parent) || void 0 === $d ? void 0 : $d._t.pnx.filter_user_mypics}
							</button>
						</div>
					` : ls.s6}
					<pnx-search-bar
						id="pnx-filter-search-user"
						placeholder=${null === (sp = this._parent) || void 0 === sp ? void 0 : sp._t.pnx.search_user}
						class=${this.user ? "pnx-filter-active" : ""}
						value=${this.user}
						@result=${this._onUserSearchResult}
						.searcher=${this._userSearch.bind(this)}
						._parent=${this._parent}
						no-menu-closure
					>
					</pnx-search-bar>
				</div>
			` : ls.s6}
		</form>`;
                    }
                }
                MapFilters.styles = [
                    Fl.Op,
                    Fl.YC,
                    ls.AH`
		.pnx-input-group {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 5px;
		}

		/* Filter block */
		.pnx-filter-block {
			position: relative;
			padding: 10px 15px;
			border-bottom: 2px solid var(--widget-border-div);
		}
		.pnx-filter-block:first-child {
			padding-top: 15px;
		}
		.pnx-filter-block:last-child {
			border-bottom: none;
			padding-bottom: 15px;
		}
		.pnx-filter-block h4 {
			margin-bottom: 5px;
		}
		.pnx-filter-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.8);
			text-align: center;
			font-weight: 800;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 25px;
		}
		.pnx-filter-zoomin.hidden {
			display: none;
		}

		/* Input styles */
		.pnx-filter-active,
		pnx-search-bar.pnx-filter-active::part(container),
		pnx-search-bar.pnx-filter-active::part(input) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}
		input[type=date] {
			min-width: 0;
			flex-grow: 2;
			padding: 2px 0;
			text-align: center;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			border: 1px solid var(--widget-border-div);
			border-radius: 20px;
			font-family: var(--font-family);
		}

		/* Input shortcuts */
		.pnx-input-shortcuts {
			margin-top: 0px;
			margin-bottom: 5px;
		}
		.pnx-input-shortcuts button {
			border: none;
			font-size: 0.75em;
			padding: 2px 6px;
			vertical-align: middle;
			background-color: var(--grey-pale);
			color: var(--black);
			border-radius: 10px;
			cursor: pointer;
			font-family: var(--font-family);
		}
		.pnx-input-shortcuts button:hover {
			background-color: #d9dcd9;
		}

		/* Checkbox looking like buttons */
		.pnx-input-group.pnx-checkbox-btns {
			gap: 0;
			align-items: stretch;
		}
		.pnx-checkbox-btns label {
			display: inline-block;
			padding: 2px 7px;
			background: none;
			border: 1px solid var(--widget-border-btn);
			color: var(--widget-font-direct);
			cursor: pointer;
			font-size: 16px;
			text-decoration: none;
			border-left-width: 0px;
		}
		.pnx-checkbox-btns label:hover {
			background-color: var(--widget-bg-hover);
		}
		.pnx-checkbox-btns label:first-of-type {
			border-top-left-radius: 8px;
			border-bottom-left-radius: 8px;
			border-left-width: 1px;
		}
		.pnx-checkbox-btns label:last-of-type {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		.pnx-checkbox-btns input[type="radio"] { display: none; }
		.pnx-checkbox-btns input[type="radio"]:checked + label {
			background-color: var(--widget-bg-active);
			color: var(--widget-font-active);
		}
		.pnx-checkbox-btns input[type="radio"]:checked + label:first-of-type {
			border-right-color: white;
		}

		/* Force user search width */
		#pnx-filter-search-user::part(container) { width: 100%; }
	`
                ], MapFilters.properties = {
                    "quality-score": {
                        type: Boolean
                    },
                    "user-search": {
                        type: Boolean
                    },
                    "no-date": {
                        type: Boolean
                    },
                    "no-picture-type": {
                        type: Boolean
                    },
                    "no-gps": {
                        type: Boolean
                    },
                    showZoomIn: {
                        state: !0
                    },
                    minDate: {
                        state: !0
                    },
                    maxDate: {
                        state: !0
                    },
                    type: {
                        state: !0
                    },
                    score: {
                        state: !0
                    },
                    user: {
                        state: !0
                    },
                    gps: {
                        state: !0
                    }
                }, customElements.define("pnx-map-filters-menu", MapFilters);
            },
            5334: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapLayers
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(8591), Fl = bt(7343), sc = bt(7172), uc = bt(8629), mc = bt(6668), gc = bt(8340), Ac = bt(5195);
                class MapLayers extends ls.WF {
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.onceMapReady) || void 0 === vt ? void 0 : vt.call(le1).then(()=>{
                                var le1, vt;
                                this.theme = this._parent.map._mapFilters.theme, this._parent.map.on("filters-changed", (le1)=>this.theme = le1.theme), null === (le1 = this._parent.map.indoorEqual) || void 0 === le1 || le1.on("levelschange", ()=>this.requestUpdate()), null === (vt = this._parent.map.indoorEqual) || void 0 === vt || vt.on("levelchange", ()=>this.requestUpdate());
                            });
                        });
                    }
                    _onThemeSelect(le1) {
                        var vt;
                        this.theme = le1.target.value, null === (vt = this._parent) || void 0 === vt || vt._onMapFiltersChange();
                    }
                    render() {
                        var le1, vt, bt, Dl, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd, Yd;
                        const Qd = [];
                        var Xd;
                        null !== (le1 = this._parent) && void 0 !== le1 && null !== (vt = le1.map) && void 0 !== vt && null !== (bt = vt.hasTwoBackgrounds) && void 0 !== bt && bt.call(vt) && Qd.push(ls.qy`
				<h4>${(0, ho.fa)(sc.YS)} ${null === (Xd = this._parent) || void 0 === Xd ? void 0 : Xd._t.pnx.map_background}</h4>
				<pnx-map-background ._parent=${this._parent}></pnx-map-background>
			`);
                        if (null !== (Dl = this._parent) && void 0 !== Dl && null !== (Ec = Dl.map) && void 0 !== Ec && Ec.indoorEqual) {
                            var Kd;
                            const le1 = this._parent.map.indoorEqual;
                            Qd.push(ls.qy`
				<pnx-switch
					.checked=${le1.level !== Ac.DISABLED_LEVEL}
					.disabled=${0 === le1.levels.length}
					@change=${(vt)=>le1.setLevel(vt.target.checked ? "0" : Ac.DISABLED_LEVEL)}
					style="display: block; margin: 15px 0;"
					name="pnx-level-switch"
				>
					${null === (Kd = this._parent) || void 0 === Kd ? void 0 : Kd._t.pnx.indoor_switch}
				</pnx-switch>
			`);
                        }
                        return Qd.push(ls.qy`
			<h4>${(0, ho.fa)(uc.fy)} ${null === (kc = this._parent) || void 0 === kc ? void 0 : kc._t.pnx.map_theme}</h4>
			<select id="pnx-map-theme" style="width: 100%;" @change=${this._onThemeSelect}>
				<option value=${gc.MAP_THEMES.DEFAULT} .selected=${this.theme == gc.MAP_THEMES.DEFAULT}>${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.map_theme_default}</option>
				<option value=${gc.MAP_THEMES.AGE} .selected=${this.theme == gc.MAP_THEMES.AGE}>${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.map_theme_age}</option>
				<option value=${gc.MAP_THEMES.TYPE} .selected=${this.theme == gc.MAP_THEMES.TYPE}>${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.map_theme_type}</option>
				${(null === (Ld = this._parent) || void 0 === Ld || null === (Nd = Ld.map) || void 0 === Nd || null === (Rd = Nd._hasQualityScore) || void 0 === Rd ? void 0 : Rd.call(Nd)) && ls.qy`
					<option value=${gc.MAP_THEMES.SCORE} .selected=${this.theme == gc.MAP_THEMES.SCORE}>${null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.map_theme_score}</option>
					<option value=${gc.MAP_THEMES.GPS} .selected=${this.theme == gc.MAP_THEMES.GPS}>${null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.map_theme_gps}</option>
				`}
			</select>
		`), Qd.push(ls.qy`<div class="legend">
			${this.theme == gc.MAP_THEMES.AGE ? ls.qy`
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.COLORS.PALETTE_4}"></span>
						${null === (Ud = this._parent) || void 0 === Ud ? void 0 : Ud._t.pnx.map_theme_age_4}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.COLORS.PALETTE_3}"></span>
						${null === (Gd = this._parent) || void 0 === Gd ? void 0 : Gd._t.pnx.map_theme_age_3}
					</div>
				</div>
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.COLORS.PALETTE_2}"></span>
						${null === (qd = this._parent) || void 0 === qd ? void 0 : qd._t.pnx.map_theme_age_2}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.COLORS.PALETTE_1}"></span>
						${null === (Hd = this._parent) || void 0 === Hd ? void 0 : Hd._t.pnx.map_theme_age_1}
					</div>
				</div>` : ls.s6}
			
			${this.theme == gc.MAP_THEMES.TYPE ? ls.qy`
			 	<div class="legend-entry">
			 		<span class="legend-color" style="background-color: ${Fl.COLORS.QUALI_1}"></span>
			 		${null === (Wd = this._parent) || void 0 === Wd ? void 0 : Wd._t.pnx.picture_360}
			 	</div>
			 	<div class="legend-entry">
			 		<span class="legend-color" style="background-color: ${Fl.COLORS.QUALI_2}"></span>
			 		${null === (Zd = this._parent) || void 0 === Zd ? void 0 : Zd._t.pnx.picture_flat}
			 	</div>` : ls.s6}
			
			${this.theme == gc.MAP_THEMES.SCORE ? ls.qy`<div>
				<pnx-quality-score></pnx-quality-score>
				<pnx-button
					title="${null === (Yd = this._parent) || void 0 === Yd ? void 0 : Yd._t.pnx.metadata_quality_help}"
					kind="superinline"
					@click=${()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showQualityScoreDoc();
                        }}
				>
					${(0, ho.fa)(mc.iW)}
				</pnx-button></div>` : ls.s6}
			
			${this.theme == gc.MAP_THEMES.GPS ? ls.qy`
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.GPS_VALUES[0].color}"></span>
						${Fl.GPS_VALUES[0].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.GPS_VALUES[2].color}"></span>
						${Fl.GPS_VALUES[2].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.GPS_VALUES[4].color}"></span>
						${Fl.GPS_VALUES[4].label}
					</div>
				</div>
				<div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.GPS_VALUES[1].color}"></span>
						${Fl.GPS_VALUES[1].label}
					</div>
					<div class="legend-entry">
						<span class="legend-color" style="background-color: ${Fl.GPS_VALUES[3].color}"></span>
						${Fl.GPS_VALUES[3].label}
					</div>
			</div>` : ls.s6}
		</div>`), Qd;
                    }
                }
                MapLayers.styles = [
                    Dl.Op,
                    Dl.YC,
                    Dl.Lt,
                    ls.AH`
		.legend {
			display: flex;
			flex-wrap: wrap;
			margin-top: 5px;
			justify-content: space-evenly;
		}

		.legend-entry {
			margin: 10px 8px 5px 0px;
			line-height: 12px;
			display: flex;
			align-items: center;
			font-size: 1.0em;
		}

		.legend-color {
			display: inline-block;
			width: 15px;
			height: 15px;
			border-radius: 3px;
			margin-right: 5px;
		}

		.legend-score {
			justify-content: center;
			gap: 0;
		}
	`
                ], MapLayers.properties = {
                    theme: {
                        state: !0
                    }
                }, customElements.define("pnx-map-layers-menu", MapLayers);
            },
            4749: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapLegend
                });
                var ls = bt(4542), ho = bt(5995);
                class MapLegend extends ls.WF {
                    constructor(){
                        super(), this.light = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>this.requestUpdate());
                    }
                    render() {
                        var le1, vt, bt, ho;
                        const Dl = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.map) || void 0 === vt || null === (bt = vt._attribution) || void 0 === bt ? void 0 : bt._innerContainer, Fl = null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t.map.map_data.split("{m}");
                        return this.light ? Dl && Dl.innerHTML.length > 0 ? Dl : ls.s6 : ls.qy`
				${Dl && Dl.innerHTML.length > 0 ? ls.qy`${Fl.shift()}${Dl}${Fl.shift()}` : ls.s6}
			`;
                    }
                }
                MapLegend.styles = ls.AH`
		:host {
			font-size: 0.7em;
		}
		small {
			font-size: 1em;
		}
		.maplibregl-ctrl-attrib-inner {
			display: inline-block;
		}
	`, MapLegend.properties = {
                    light: {
                        type: Boolean
                    }
                }, customElements.define("pnx-map-legend", MapLegend);
            },
            1636: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MiniPictureLegend
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(8591);
                class MiniPictureLegend extends ls.WF {
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            });
                        });
                    }
                    _onPicChange(le1) {
                        this._caption = null === le1 || void 0 === le1 ? void 0 : le1.caption;
                    }
                    render() {
                        var le1, vt;
                        return null !== (le1 = this._caption) && void 0 !== le1 && le1.date ? ls.qy`<div class="pnx-panel">${this._caption.date.toLocaleDateString((null === (vt = this._parent) || void 0 === vt ? void 0 : vt.lang) || window.navigator.language, {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                        })}</div>` : ls.s6;
                    }
                }
                MiniPictureLegend.styles = [
                    Dl.nd,
                    ls.AH`
		.pnx-panel {
			bottom: 0;
			right: 0;
			width: unset;
			min-width: unset;
			border-radius: 10px;
			border-top-right-radius: 0;
			border-bottom-left-radius: 0;
			border-right: none;
			border-bottom: none;
			padding: 2px 5px;
			font-size: 0.7em;
		}
	`
                ], MiniPictureLegend.properties = {
                    _caption: {
                        state: !0
                    }
                }, customElements.define("pnx-mini-picture-legend", MiniPictureLegend);
            },
            3589: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PictureLegend
                });
                var ls = bt(4542), ho = bt(686), Dl = bt(1198), Fl = bt(5995), sc = bt(8466), uc = bt(4336), mc = bt(2593), gc = bt(7879), Ac = bt(3324), Ec = bt(4927), kc = bt(6311), du = bt(1260), _u = bt(8591), Md = bt(3606), Ld = bt(7208);
                class PictureLegend extends ls.WF {
                    constructor(){
                        super(), this._expanded = !0, this.collapsable = !1, this.light = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._expanded = !this.collapsable, this._prevSearches = {}, (0, Fl.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            this._onPicChange(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            }), this._parent.psv.addEventListener("sequence-stopped", ()=>{
                                this._onPicChange(this._parent.psv.getPictureMetadata());
                            }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                                this._expanded = !0;
                            }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || this._parent.psv.addEventListener("annotations-toggled", (le1)=>{
                                le1.detail.visible && (this._expanded = !0);
                            }), this._parent.psv.getSelectedAnnotations().length > 0 && (this._expanded = !0);
                        });
                    }
                    _onPicChange(le1) {
                        if (clearTimeout(this._addrTimer1), this._caption = null === le1 || void 0 === le1 ? void 0 : le1.caption, le1) {
                            var vt;
                            this._visibility = (null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["geovisio:visibility"]) || null, "anyone" === this._visibility && (this._visibility = null);
                            const bt = `${le1.gps[0].toFixed(4)}/${le1.gps[1].toFixed(4)}`;
                            this._prevSearches[bt] ? this._addr = this._prevSearches[bt] : this._parent.psv._sequencePlaying || (this._addr = "", this._addrTimer1 = setTimeout(()=>{
                                (0, Md.reverseGeocodingNominatim)(le1.gps[1], le1.gps[0]).then((le1)=>{
                                    clearTimeout(this._addrTimer2), this._addr = le1, this._prevSearches[bt] = le1;
                                });
                            }, 500));
                        } else this._visibility = null, this._addr = "";
                    }
                    _onBackClick() {
                        var le1, vt;
                        this._parent.isWidthSmall() && "map" === this._parent.focus ? this._parent.select() : null === (le1 = (vt = this._parent)._setFocus) || void 0 === le1 || le1.call(vt, "map");
                    }
                    blockOnEditing(le1) {
                        this._blockOnEditor = le1;
                    }
                    render() {
                        var le1, vt, bt, _u, Md, Nd, Rd, Od, jd;
                        if (!this._caption) return ls.s6;
                        const Ud = (null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.lang) || window.navigator.language, Gd = (0, Dl.H)({
                            "pnx-hidden": this._expanded
                        }), qd = (0, Dl.H)({
                            "pnx-hidden": !this._expanded
                        });
                        var Hd, Wd, Zd, Yd, Qd, Xd;
                        return this.light ? ho.qy`<div class="pnx-picture-legend-light">
				${(null === (Hd = this._caption.producer) || void 0 === Hd ? void 0 : Hd.length) > 0 ? ho.qy`
					<a
						href=${(0, Ld.PanoramaxMetaCatalogURL)() + "/?pic=" + this._parent.psv.getPictureMetadata().id}
						target="_blank"
						title=${null === (Wd = this._parent) || void 0 === Wd ? void 0 : Wd._t.pnx.share_page}
					>${this._caption.producer[this._caption.producer.length - 1]}</a>
				</div>` : ls.s6}

				${(null === (Zd = this._caption.producer) || void 0 === Zd ? void 0 : Zd.length) > 0 && this._caption.date ? "-" : ""}

				${this._caption.date ? new Intl.DateTimeFormat(Ud, {
                            timeZone: this._caption.tz,
                            dateStyle: "short"
                        }).format(this._caption.date) : ls.s6}

				${((null === (Yd = this._caption.producer) || void 0 === Yd ? void 0 : Yd.length) > 0 || this._caption.date) && null !== (Qd = this._caption) && void 0 !== Qd && Qd.license ? "|" : ""}

				${null !== (Xd = this._caption) && void 0 !== Xd && Xd.license ? ho.qy`${(0, ho.Bk)(this._caption.license)}` : ls.s6}
			` : ho.qy`
			<div class=${(0, Dl.H)({
                            headline: !0,
                            "pnx-hidden": this._blockOnEditor
                        })}>
				${this._parent._setFocus ? ho.qy`
					<pnx-button
						kind="superinline"
						@click=${this._onBackClick}
					>
						${(0, Fl.fa)(sc.Ce)}
					</pnx-button>
				` : ls.s6}

				<div id="pic-legend-addr" title=${this._addr || ""}>
					${(null === (vt = this._addr) || void 0 === vt ? void 0 : vt.length) > 0 ? this._addr : ho.qy`<span class="pnx-placeholder-loading">&nbsp;</span>`}
				</div>

				<div class="headline-buttons">
					${this._visibility ? ho.qy`
						<div
							class="visibility-badge"
							title=${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx["visibility_title_" + this._visibility]}
						>
							${(0, Fl.fa)(Ac.aA, {
                            transform: {
                                size: 16
                            }
                        })}
							${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx["visibility_" + this._visibility]}
						</div>
					` : ls.s6}

					<pnx-button
						size="sm"
						class=${Gd}
						title=${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.share}
						@click=${()=>this._parent._showShareOptions()}
					>
						${(0, Fl.fa)(du.faShareNodes)}
					</pnx-button>

					<pnx-picture-legend-actions
						@click=${(le1)=>le1.stopPropagation()}
						._parent=${this._parent}
						?full=${this._expanded}
					></pnx-picture-legend-actions>
				</div>
			</div>

			<div id="pic-legend-info" class=${Gd}>
				${(null === (Nd = this._caption.producer) || void 0 === Nd ? void 0 : Nd.length) > 0 ? ho.qy`<div class="info-block">
					${(0, Fl.fa)(gc.X4)}
					${this._caption.producer[this._caption.producer.length - 1]}
				</div>` : ls.s6}

				${this._caption.date ? ho.qy`<div class="info-block">
					${(0, Fl.fa)(Ec.BE)}
					${this._caption.date.toLocaleDateString((null === (Rd = this._parent) || void 0 === Rd ? void 0 : Rd.lang) || window.navigator.language, {
                            year: "numeric",
                            month: "long",
                            day: "numeric"
                        })}				</div>` : ls.s6}
			</div>

			<div id="pic-legend-cta" class=${(0, Dl.H)({
                            "pnx-hidden": !this._expanded || this._blockOnEditor
                        })}>
				<pnx-button size="sm" @click=${()=>this._parent._showShareOptions()}>
					${(0, Fl.fa)(du.faShareNodes)} ${null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.share}
				</pnx-button>

				${this._parent.api._endpoints.report ? ho.qy`
						<pnx-button kind="fullwarn" size="sm" @click=${()=>this._parent._showReportForm()}>
							${(0, Fl.fa)(kc.JA)} ${null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.report}
						</pnx-button>
				` : ls.s6}

				<slot name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</div>

			<pnx-picture-metadata
				class=${qd}
				.block-editor=${this._blockOnEditor}
				._parent=${this._parent}
			></pnx-picture-metadata>

			${this.collapsable && !this._blockOnEditor ? ho.qy`<pnx-button
				kind="inline"
				size="sm"
				id="pic-legend-expand"
				@click=${()=>this._expanded = !this._expanded}
			>${this._expanded ? (0, Fl.fa)(uc.w2) : (0, Fl.fa)(mc.Jt)}</pnx-button>` : ls.s6}
		`;
                    }
                }
                PictureLegend.styles = [
                    _u.qf,
                    _u.nd,
                    _u.R,
                    ls.AH`
		:host {
			display: flex;
			flex-direction: column;
			margin: 0;
			font-family: var(--font-family);
			flex-wrap: nowrap;
		}

		@media screen and (min-width: 576px) {
			:host {
				max-height: 70vh;
			}
		}

		/* Top bar */
		.headline {
			display: flex;
			gap: 10px;
			align-items: center;
			margin: 10px 10px 5px 10px;
			justify-content: space-between;
			flex: 1;
		}

		.headline-buttons {
			display: flex;
			gap: 5px;
			align-items: center;
		}

		/* Address line */
		#pic-legend-addr {
			line-height: 1.2em;
			font-size: 1em;
			margin-bottom: 2px;
			flex-grow: 5;
			font-weight: 800;
			text-overflow: ellipsis;
			overflow: hidden;
  			white-space: nowrap;
		}

		#pic-legend-addr span {
			display: inline-block;
			height: 100%;
			width: 100%;
		}

		/* Visibility badge */
		.visibility-badge {
			cursor: help;
			background: var(--blue);
			color: var(--white);
			border-radius: 10px;
			height: 20px;
			display: inline-flex;
			font-size: 0.8em;
			padding: 0 5px;
  			gap: 3px;
			font-size: 0.7em;
  			align-items: center;
		}

		.visibility-badge svg {
			height: 1em;
		}

		/* Minimal info block */
		#pic-legend-info {
			margin: 10px;
			display: flex;
			gap: 10px;
			justify-content: space-around;
		}
		.info-block {
			display: flex;
			flex-shrink: 1;
			gap: 5px;
			font-weight: 600;
			font-size: 0.85em;
			align-items: center;
		}
		.info-block svg { height: 18px; }

		/* Expand button */
		#pic-legend-expand {
			display: block;
			margin-top: 5px;
			max-width: 100%;
			flex: 1;
		}
		#pic-legend-expand::part(btn) {
			border-radius: 10px;
			border-top-right-radius: 0;
			border-top-left-radius: 0;
		}

		/* Details block */
		pnx-picture-metadata {
			margin: 5px 10px;
			display: block;
			box-sizing: border-box;
			flex: 1;
			overflow-y: auto;
		}

		/* Details actions */
		#pic-legend-cta {
			display: flex;
			margin: 5px 10px;
			border-bottom-left-radius: 10px;
			border-bottom-right-radius: 10px;
			gap: 5px;
			flex-wrap: wrap;
			flex: 1;
		}

		/* More options menu */
		#pnx-legend-opts { min-width: unset; }

		/* Editors */
		#pic-legend-editors { margin: 0 10px; }

		/* Light version */
		.pnx-picture-legend-light {
			width: max-content;
			font-size: 10px;
		}
	`
                ], PictureLegend.properties = {
                    light: {
                        type: Boolean
                    },
                    _caption: {
                        state: !0
                    },
                    _addr: {
                        state: !0
                    },
                    _expanded: {
                        state: !0
                    },
                    _blockOnEditor: {
                        state: !0
                    },
                    _visibility: {
                        state: !0
                    },
                    collapsable: {
                        type: Boolean
                    }
                }, customElements.define("pnx-picture-legend", PictureLegend);
            },
            6993: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PictureMetadata
                });
                var ls = bt(4542), ho = bt(686), Dl = bt(5995), Fl = bt(3520), sc = bt(3233), uc = bt(2480), mc = bt(5279), gc = bt(4954), Ac = bt(2077), Ec = bt(5124), kc = bt(6668), du = bt(6249), _u = bt(8591), Md = bt(508), Ld = bt(7208), Nd = bt(7343);
                const missing = ()=>(0, Dl.fa)(Ec.Ev, {
                        styles: {
                            height: "16px"
                        }
                    });
                class PictureMetadata extends ls.WF {
                    connectedCallback() {
                        var le1;
                        super.connectedCallback();
                        const gototags = ()=>{
                            const le1 = this.shadowRoot.querySelector("pnx-tabs");
                            le1 && le1.setAttribute("activeTabIndex", 4);
                        };
                        null === (le1 = window.navigation) || void 0 === le1 || le1.addEventListener("navigate", ()=>{
                            this.requestUpdate();
                        }), (0, Dl.onceParentAvailable)(this).then(()=>{
                            var le1, vt, bt, ls;
                            this._meta = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.getPictureMetadata(), null === (bt = this._parent) || void 0 === bt || null === (ls = bt.oncePSVReady) || void 0 === ls || ls.call(bt).then(()=>{
                                this._parent.psv.addEventListener("picture-loaded", ()=>{
                                    this._meta = this._parent.psv.getPictureMetadata();
                                }), this._parent._initParams.getParentPostInit().skipTagsMenuOpening || (this._parent.psv.addEventListener("annotation-focused", gototags), this._parent.psv.addEventListener("annotations-toggled", (le1)=>{
                                    le1.detail.visible && gototags();
                                }), this._parent.psv.getSelectedAnnotations().length > 0 && gototags());
                            });
                        });
                    }
                    _onQualityScoreClick() {
                        const le1 = this.shadowRoot.querySelector("pnx-tabs");
                        le1 && le1.setAttribute("activeTabIndex", 3);
                    }
                    _onCaptureDateClick() {
                        const le1 = this.shadowRoot.querySelector("pnx-tabs");
                        le1 && le1.setAttribute("activeTabIndex", 1);
                    }
                    _toTab(le1, vt) {
                        return ho.qy`
			<h4 slot="title">${le1}</h4>
			<div slot="content" class="data-blocks">
				${vt.filter((le1)=>le1).map((le1)=>ho.qy`<div class="data-block" style=${le1.style}>
					<h5>${le1.title}</h5>
					<div style=${le1.content_style} @click=${le1.click}>${le1.content}</div>
				</div>`)}
			</div>
		`;
                    }
                    render() {
                        var le1, vt, bt, Ec, _u, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd, Yd, Qd, Xd, Kd, Jd, $d, sp, em, tm, im, nm, rm, am, sm, om, lm, cm, um, hm, dm, pm, mm, fm, gm, Am, _m, ym, vm, xm, bm, wm, Em, Mm, Sm, Tm, km, Cm, Im, Dm;
                        if (!this._meta) return ls.s6;
                        const Lm = (null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.lang) || window.navigator.language, Pm = null === (vt = this._meta) || void 0 === vt || null === (bt = vt.properties) || void 0 === bt ? void 0 : bt["pers:interior_orientation"], zm = [
                            Pm.camera_manufacturer,
                            Pm.camera_model
                        ].filter((le1)=>le1).join(" "), Nm = null !== Pm && void 0 !== Pm && Pm.focal_length ? `${null === Pm || void 0 === Pm ? void 0 : Pm.focal_length} mm` : missing();
                        let Rm = null === Pm || void 0 === Pm ? void 0 : Pm.sensor_array_dimensions;
                        Rm && (Rm = `${Rm[0]} x ${Rm[1]} px (${Math.floor(Rm[0] * Rm[1] / 1e6)} Mpx)`);
                        let Fm = null === (Ec = this._parent) || void 0 === Ec ? void 0 : Ec._t.pnx.picture_flat, Om = null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.picture_flat_long, Bm = null === Pm || void 0 === Pm ? void 0 : Pm.field_of_view;
                        var jm, Um;
                        null !== Bm && void 0 !== Bm && (360 === Bm ? (Fm = null === (jm = this._parent) || void 0 === jm ? void 0 : jm._t.pnx.picture_360, Om = null === (Um = this._parent) || void 0 === Um ? void 0 : Um._t.pnx.picture_360_long) : Fm += ` (${Bm}\xb0)`);
                        const Vm = [
                            {
                                title: null === (Rd = this._parent) || void 0 === Rd ? void 0 : Rd._t.pnx.metadata_camera_make,
                                content: (null === Pm || void 0 === Pm ? void 0 : Pm.camera_manufacturer) || missing()
                            },
                            {
                                title: null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.metadata_camera_model,
                                content: (null === Pm || void 0 === Pm ? void 0 : Pm.camera_model) || missing()
                            },
                            {
                                title: null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.metadata_camera_type,
                                content: Fm
                            },
                            {
                                title: null === (Ud = this._parent) || void 0 === Ud ? void 0 : Ud._t.pnx.metadata_camera_resolution,
                                content: Rm || missing()
                            },
                            {
                                title: null === (Gd = this._parent) || void 0 === Gd ? void 0 : Gd._t.pnx.metadata_camera_focal_length,
                                content: Nm
                            },
                            (null === (qd = this._meta) || void 0 === qd || null === (Hd = qd.caption) || void 0 === Hd ? void 0 : Hd.date) && {
                                title: null === (Wd = this._parent) || void 0 === Wd ? void 0 : Wd._t.pnx.metadata_general_date,
                                content: ho.qy`
					<strong>${new Intl.DateTimeFormat(Lm, {
                                    timeZone: this._meta.caption.tz,
                                    dateStyle: "short"
                                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(Lm, {
                                    timeZone: this._meta.caption.tz,
                                    hour: "numeric",
                                    minute: "numeric",
                                    second: "numeric",
                                    fractionalSecondDigits: 3,
                                    timeZoneName: "longOffset"
                                }).format(this._meta.caption.date)}
				`
                            }
                        ], Gm = void 0 !== (null === (Zd = this._meta) || void 0 === Zd || null === (Yd = Zd.properties) || void 0 === Yd ? void 0 : Yd["view:azimuth"]) && `${this._meta.properties["view:azimuth"]}\xb0`, qm = [
                            {
                                title: null === (Qd = this._parent) || void 0 === Qd ? void 0 : Qd._t.pnx.metadata_location_coordinates,
                                content: ho.qy`
					${this._meta.gps[0].toFixed(5)}, ${this._meta.gps[1].toFixed(5)}
					<pnx-copy-coordinates
						._parent=${this._parent}
						.gps=${this._meta.gps}
						style="margin-left: 10px"
					></pnx-copy-coordinates>
				`,
                                style: "width: 100%"
                            },
                            {
                                title: null === (Xd = this._parent) || void 0 === Xd ? void 0 : Xd._t.pnx.metadata_location_orientation,
                                content: Gm || missing()
                            },
                            {
                                title: null === (Kd = this._parent) || void 0 === Kd ? void 0 : Kd._t.pnx.metadata_location_precision,
                                content: (0, Md.getGPSPrecision)(this._meta) || missing()
                            }
                        ], Hm = (null === (Jd = this._parent) || void 0 === Jd || null === ($d = Jd.map) || void 0 === $d || null === (sp = $d._hasQualityScore) || void 0 === sp ? void 0 : sp.call($d)) || (null === (em = this._meta) || void 0 === em || null === (tm = em.properties) || void 0 === tm ? void 0 : tm["quality:horizontal_accuracy"]) || (null === (im = this._meta) || void 0 === im || null === (nm = im.properties) || void 0 === nm ? void 0 : nm["panoramax:horizontal_pixel_density"]);
                        let Wm, Zm;
                        if (Hm) {
                            var Ym, Qm, Xm, Km, Jm, $m, eg, tg, ig, ng, rg;
                            const le1 = (0, Nd.getGrade)(Nd.QUALITYSCORE_GPS_VALUES, null === (Ym = this._meta) || void 0 === Ym || null === (Qm = Ym.properties) || void 0 === Qm ? void 0 : Qm["quality:horizontal_accuracy"]), vt = (0, Nd.getGrade)(360 === (null === (Xm = this._meta) || void 0 === Xm ? void 0 : Xm.horizontalFov) ? Nd.QUALITYSCORE_RES_360_VALUES : Nd.QUALITYSCORE_RES_FLAT_VALUES, null === (Km = this._meta) || void 0 === Km || null === (Jm = Km.properties) || void 0 === Jm ? void 0 : Jm["panoramax:horizontal_pixel_density"]);
                            Zm = Math.round((vt || 1) * Nd.QUALITYSCORE_POND_RES + (le1 || 1) * Nd.QUALITYSCORE_POND_GPS), Wm = [
                                {
                                    title: ho.qy`
						${null === ($m = this._parent) || void 0 === $m ? void 0 : $m._t.pnx.metadata_quality_score}
						<pnx-button
							title="${null === (eg = this._parent) || void 0 === eg ? void 0 : eg._t.pnx.metadata_quality_help}"
							kind="superinline"
							@click=${()=>{
                                        var le1;
                                        return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showQualityScoreDoc();
                                    }}
						>
							${(0, Dl.fa)(kc.iW)}
						</pnx-button>
					`,
                                    content: ho.qy`<pnx-quality-score grade=${Zm} style="font-size: 16px"></pnx-quality-score>`,
                                    style: "width: 100%"
                                },
                                {
                                    title: null === (tg = this._parent) || void 0 === tg ? void 0 : tg._t.pnx.metadata_quality_gps_score,
                                    content: (0, Dl.createWebComp)("pnx-grade", {
                                        stars: le1,
                                        _t: null === (ig = this._parent) || void 0 === ig ? void 0 : ig._t
                                    })
                                },
                                {
                                    title: null === (ng = this._parent) || void 0 === ng ? void 0 : ng._t.pnx.metadata_quality_resolution_score,
                                    content: (0, Dl.createWebComp)("pnx-grade", {
                                        stars: vt,
                                        _t: null === (rg = this._parent) || void 0 === rg ? void 0 : rg._t
                                    })
                                }
                            ];
                        }
                        const ag = Object.entries(this._meta.properties.exif).sort().filter((le1)=>{
                            let [, vt] = le1;
                            return vt;
                        }).map((le1)=>{
                            let [vt, bt] = le1;
                            return JSON.stringify(bt).includes("\\u") && (bt = JSON.stringify(bt).replace(/\\u[0-9A-Fa-f]{4}/g, (le1)=>" 0x" + parseInt(le1.slice(2), 16).toString(16).toUpperCase().padStart(4, "0")).slice(1, -1).trim()), {
                                title: vt,
                                content: bt.length > 30 ? ho.qy`<textarea readonly .value=${bt}></textarea>` : bt,
                                style: bt.length > 30 ? "width: 100%" : void 0
                            };
                        });
                        ag.unshift({
                            content: ho.qy`
				<pnx-link-button
					size="sm"
					target="_blank"
					href="https://exiv2.org/metadata.html"
					title=${null === (rm = this._parent) || void 0 === rm ? void 0 : rm._t.pnx.metadata_exif_doc_title}
				>${(0, Dl.fa)(kc.iW)} ${null === (am = this._parent) || void 0 === am ? void 0 : am._t.pnx.metadata_exif_doc}</pnx-link-button>
			`,
                            style: "width: 100%"
                        });
                        const sg = [
                            (null === (sm = this._meta) || void 0 === sm || null === (om = sm.caption) || void 0 === om || null === (lm = om.producer) || void 0 === lm ? void 0 : lm.length) > 0 && {
                                title: null === (cm = this._parent) || void 0 === cm ? void 0 : cm._t.pnx.metadata_general_author,
                                content: ho.qy`
					<strong>${this._meta.caption.producer[this._meta.caption.producer.length - 1]}</strong>
					${this._meta.caption.producer.length > 1 ? ho.qy`<br />${this._meta.caption.producer.slice(0, -1).join(", ")}` : ls.s6}
				`
                            },
                            (null === (um = this._meta) || void 0 === um || null === (hm = um.caption) || void 0 === hm ? void 0 : hm.date) && {
                                title: null === (dm = this._parent) || void 0 === dm ? void 0 : dm._t.pnx.metadata_general_date,
                                click: this._onCaptureDateClick,
                                content_style: "cursor: pointer",
                                content: ho.qy`
					<strong>${new Intl.DateTimeFormat(Lm, {
                                    timeZone: this._meta.caption.tz,
                                    dateStyle: "long"
                                }).format(this._meta.caption.date)}</strong>
					<br />${new Intl.DateTimeFormat(Lm, {
                                    timeZone: this._meta.caption.tz,
                                    hour: "numeric",
                                    minute: "numeric",
                                    second: "numeric"
                                }).format(this._meta.caption.date)}
				`
                            },
                            Pm && {
                                title: null === (pm = this._parent) || void 0 === pm ? void 0 : pm._t.pnx.metadata_camera,
                                content: ho.qy`
					<strong>${zm.length > 0 ? zm : missing()}</strong>
					<br />${Om}
				`
                            },
                            (null === (mm = this._meta) || void 0 === mm || null === (fm = mm.caption) || void 0 === fm ? void 0 : fm.license) && {
                                title: null === (gm = this._parent) || void 0 === gm ? void 0 : gm._t.pnx.metadata_general_license,
                                content: ho.qy`${(0, ho.Bk)(this._meta.caption.license)}`
                            },
                            Hm && {
                                title: null === (Am = this._parent) || void 0 === Am ? void 0 : Am._t.pnx.metadata_quality,
                                click: this._onQualityScoreClick,
                                content: ho.qy`<pnx-quality-score
					grade=${Zm}
					style="font-size: 14px; cursor: pointer"
				/>`
                            },
                            {
                                title: null === (_m = this._parent) || void 0 === _m ? void 0 : _m._t.pnx.metadata_general_copy_id,
                                content_style: "display: flex; gap: 5px;",
                                content: ho.qy`
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${null === (ym = this._parent) || void 0 === ym ? void 0 : ym._t}
						text=${this._meta.id}
						title=${this._meta.id}
						style="flex: 1"
					>
						${(0, Dl.fa)(mc.jb)} ${null === (vm = this._parent) || void 0 === vm ? void 0 : vm._t.pnx.metadata_general_picid}
					</pnx-copy-button>
					<pnx-copy-button
						kind="outline"
						size="sm"
						._t=${null === (xm = this._parent) || void 0 === xm ? void 0 : xm._t}
						text=${this._meta.sequence.id}
						title=${this._meta.sequence.id}
						style="flex: 1"
					>
						${(0, Dl.fa)(gc.yv)} ${null === (bm = this._parent) || void 0 === bm ? void 0 : bm._t.pnx.metadata_general_seqid}
					</pnx-copy-button>
				`
                            },
                            (null === (wm = this._meta) || void 0 === wm ? void 0 : wm.origInstance) && {
                                title: null === (Em = this._parent) || void 0 === Em ? void 0 : Em._t.pnx.metadata_general_instance,
                                content: ho.qy`<strong>
					<a href=${this._meta.origInstance.href + window.location.search} target="_blank" style="text-decoration: none">
						<img
							src=${(0, Ld.PanoramaxMetaCatalogURL)() + "/api/instances/" + this._meta.origInstance.instance_name + "/logo"}
							style="height: 30px; max-width: 150px; vertical-align: middle"
							alt=""
						/>
						<span style="text-decoration: underline">
							${this._meta.origInstance.instance_name || this._meta.origInstance.href.replace(/^http.?:\/\//, "")}
						</span>
					</a>
				</strong>`
                            }
                        ];
                        return ho.qy`<pnx-tabs .hideNav=${this["block-editor"]}>
			${this._toTab(ho.qy`${(0, Dl.fa)(mc.jb)} ${null === (Mm = this._parent) || void 0 === Mm ? void 0 : Mm._t.pnx.metadata_summary}`, sg)}

			${this._toTab(ho.qy`${(0, Dl.fa)(uc.rw)} ${null === (Sm = this._parent) || void 0 === Sm ? void 0 : Sm._t.pnx.metadata_camera}`, Vm)}

			${this._toTab(ho.qy`${(0, Dl.fa)(Fl.faLocationDot)} ${null === (Tm = this._parent) || void 0 === Tm ? void 0 : Tm._t.pnx.metadata_location}`, qm)}

			${Hm ? this._toTab(ho.qy`${(0, Dl.fa)(sc.B9)} ${null === (km = this._parent) || void 0 === km ? void 0 : km._t.pnx.metadata_quality}`, Wm) : ls.s6}

			<h4 slot="title">${(0, Dl.fa)(du.DX)} ${null === (Cm = this._parent) || void 0 === Cm ? void 0 : Cm._t.pnx.semantics_title}</h4>
			<div slot="content" class="data-blocks">
				<pnx-semantics-metadata ._parent=${this._parent}></pnx-semantics-metadata>
			</div>

			${null !== (Im = this._meta.properties) && void 0 !== Im && Im.exif ? this._toTab(ho.qy`${(0, Dl.fa)(Ac.DD)} ${null === (Dm = this._parent) || void 0 === Dm ? void 0 : Dm._t.pnx.metadata_exif}`, ag) : ls.s6}
		</pnx-tabs>`;
                    }
                }
                PictureMetadata.styles = [
                    _u.Op,
                    _u.YC,
                    _u.PC,
                    _u.R,
                    _u.Tk,
                    ls.AH`
		div[slot="content"] {
			padding: 5px 10px;
			background-color: #ededed;
		}

		.data-block {
			min-width: 50%;
		}

		pnx-semantics-table {
			overflow-x: auto;
  			display: block;
		}
	`
                ], PictureMetadata.properties = {
                    _meta: {
                        state: !0
                    },
                    "block-editor": {
                        type: Boolean
                    }
                }, customElements.define("pnx-picture-metadata", PictureMetadata);
            },
            499: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PlayerOptions
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(7744), Fl = bt(325), sc = bt(9243), uc = bt(9048), mc = bt(5995);
                class PlayerOptions extends ls.WF {
                    connectedCallback() {
                        super.connectedCallback(), (0, mc.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.addEventListener("transition-duration-changed", (le1)=>{
                                this.renderRoot.querySelector("#pnx-player-speed").value = uc.Vf - le1.detail.value;
                            });
                        });
                    }
                    _onSpeedChange(le1) {
                        var vt, bt;
                        const ls = uc.Vf - le1.target.value;
                        null === (vt = this._parent) || void 0 === vt || null === (bt = vt.psv) || void 0 === bt || bt.setTransitionDuration(ls);
                    }
                    _onContrastClick() {
                        const le1 = this.renderRoot.querySelector("#pnx-player-contrast");
                        var vt, bt, ls, ho;
                        "true" == le1.getAttribute("active") ? (le1.removeAttribute("active"), null === (vt = this._parent) || void 0 === vt || null === (bt = vt.psv) || void 0 === bt || bt.setHigherContrast(!1)) : (le1.setAttribute("active", "true"), null === (ls = this._parent) || void 0 === ls || null === (ho = ls.psv) || void 0 === ho || ho.setHigherContrast(!0));
                    }
                    render() {
                        var le1, vt, bt, ho;
                        return ls.qy`
			<div class="pnx-input-range" title="${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.sequence_speed}">
				${(0, mc.fa)(sc.rO)}
				<input
					id="pnx-player-speed"
					type="range" name="speed"
					min="0" max="${uc.Vf - 100}"
					value="${uc.Vf - (null === (vt = this._parent) || void 0 === vt ? void 0 : vt.psv.getTransitionDuration())}"
					title="${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.sequence_speed}"
					style="width: 100%;"
					@change=${this._onSpeedChange}
				/>
				${(0, mc.fa)(Dl.KM)}
			</div>
			<pnx-button
				id="pnx-player-contrast"
				title="${null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t.pnx.contrast}"
				kind="outline"
				@click=${this._onContrastClick}
			>
				${(0, mc.fa)(Fl.rC)}
			</pnx-button>
		`;
                    }
                }
                PlayerOptions.styles = [
                    ho.Op,
                    ls.AH`
		:host {
			display: flex;
			flex-direction: row;
			align-items: center;
			justify-content: center;
			gap: 15px;
			padding: 5px 15px;
		}

		.pnx-input-range {
			display: flex;
			justify-content: space-between;
			gap: 10px;
			align-items: center;
			width: 100%;
		}
	`
                ], customElements.define("pnx-player-options", PlayerOptions);
            },
            5187: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>QualityScoreDoc
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(3233), sc = bt(7704);
                class QualityScoreDoc extends ls.WF {
                    render() {
                        var le1, vt, bt, ho, uc, mc, gc, Ac, Ec;
                        return ls.qy`
			<h4>${(0, Dl.fa)(Fl.B9)} ${null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.filter_qualityscore}</h4>
			<p>${null === (vt = this._t) || void 0 === vt ? void 0 : vt.pnx.qualityscore_doc_1}</p>
			<p>${null === (bt = this._t) || void 0 === bt ? void 0 : bt.pnx.qualityscore_doc_2}</p>
			<pnx-quality-score grade=""></pnx-quality-score>
			<p>${null === (ho = this._t) || void 0 === ho ? void 0 : ho.pnx.qualityscore_doc_3}</p>
			<p>${null === (uc = this._t) || void 0 === uc ? void 0 : uc.pnx.qualityscore_doc_4}</p>
			<ul>
				<li>${null === (mc = this._t) || void 0 === mc ? void 0 : mc.pnx.qualityscore_doc_41}</li>
				<li>${null === (gc = this._t) || void 0 === gc ? void 0 : gc.pnx.qualityscore_doc_42}</li>
			</ul>
			<p>${null === (Ac = this._t) || void 0 === Ac ? void 0 : Ac.pnx.qualityscore_doc_5}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/pictures-metadata/quality_score/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${(0, Dl.fa)(sc.A)} ${null === (Ec = this._t) || void 0 === Ec ? void 0 : Ec.pnx.popup_details_link}</pnx-link-button>
		`;
                    }
                }
                QualityScoreDoc.styles = [
                    ho.YC,
                    ho.Op,
                    ho.lk
                ], customElements.define("pnx-quality-score-doc", QualityScoreDoc);
            },
            9588: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ReportForm
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(4881), sc = bt(6311), uc = bt(7516), mc = bt(2975), gc = bt(1708), Ac = bt(7343);
                const Ec = [
                    "",
                    "blur_missing",
                    "blur_excess",
                    "inappropriate",
                    "privacy",
                    "picture_low_quality",
                    "mislocated",
                    "copyright",
                    "other"
                ];
                class ReportForm extends ls.WF {
                    _onSubmit(le1) {
                        var vt, bt, ls, ho;
                        le1.preventDefault();
                        const Dl = null === (vt = this._parent) || void 0 === vt || null === (bt = vt.psv) || void 0 === bt ? void 0 : bt.getPictureMetadata(), Fl = Object.fromEntries(new FormData(le1.target)), sc = {
                            issue: Fl.issue,
                            picture_id: Fl["whole-sequence"] ? null : null === Dl || void 0 === Dl ? void 0 : Dl.id,
                            reporter_comments: Fl.comments,
                            reporter_email: Fl.email,
                            sequence_id: null === Dl || void 0 === Dl || null === (ls = Dl.sequence) || void 0 === ls ? void 0 : ls.id
                        };
                        this.mode = "wait", null === (ho = this._parent) || void 0 === ho || ho.api.sendReport(sc).then(()=>{
                            this.mode = "success";
                        }).catch((le1)=>{
                            console.error(le1), this.mode = "failure", this.failure = le1;
                        });
                    }
                    render() {
                        var le1, vt, bt, ho, kc, du, _u, Md, Ld, Nd;
                        const Rd = (0, Ac.getUserAccount)();
                        var Od, jd, Ud, Gd;
                        return this.mode ? ls.qy`
				<h4>${(0, Dl.fa)(sc.JA)} ${null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.report}</h4>
				<p>
					${"wait" === this.mode ? null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.report_wait : ls.s6}
					${"success" === this.mode ? null === (Ud = this._parent) || void 0 === Ud ? void 0 : Ud._t.pnx.report_success : ls.s6}
					${"failure" === this.mode ? null === (Gd = this._parent) || void 0 === Gd ? void 0 : Gd._t.pnx.report_failure.replace("{e}", this.failure) : ls.s6}
				</p>
			` : ls.qy`
			<h4>${(0, Dl.fa)(sc.JA)} ${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.report}</h4>

			${Rd && null !== (vt = this._parent) && void 0 !== vt && vt._t ? ls.qy`
				<p>${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.report_auth.replace("{a}", Rd.name)}</p>
			` : ls.s6}

			<form @submit=${this._onSubmit.bind(this)}>
				<div class="group">
					<label for="issue">${(0, Dl.fa)(uc.faCircleInfo)} ${null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t.pnx.report_nature_label}</label>
					<select name="issue" id="issue" required class="pnx-100w">
						${Ec.map((le1)=>{
                            var vt;
                            return ls.qy`
							<option
								value=${le1}
								${"" === le1 ? ls.qy`disabled selected hidden` : ls.s6}
							>
								${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.report_nature[le1]}
							</option>
						`;
                        })}
					</select>
				</div>

				<div class="group group-inline">
					<input name="whole-sequence" id="whole-sequence" type="checkbox" />
					<label for="whole-sequence">${null === (kc = this._parent) || void 0 === kc ? void 0 : kc._t.pnx.report_whole_sequence}</label>
				</div>

				<div class="group">
					<label for="comments">${(0, Dl.fa)(mc.Be)} ${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.report_details}</label>
					<textarea name="comments" id="comments" placeholder=${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.report_details_placeholder}></textarea>
				</div>

				${Rd ? ls.s6 : ls.qy`
					<div class="group">
						<label for="email">${(0, Dl.fa)(Fl.Hz)} ${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.report_email}</label>
						<input type="email" name="email" id="email" placeholder=${null === (Ld = this._parent) || void 0 === Ld ? void 0 : Ld._t.pnx.report_email_placeholder} class="pnx-100w" />
					</div>
				`}

				<pnx-button type="submit" style="width: 100%">
					${(0, Dl.fa)(gc.is)} ${null === (Nd = this._parent) || void 0 === Nd ? void 0 : Nd._t.pnx.report_submit}
				</pnx-button>
			</form>
		`;
                    }
                }
                ReportForm.styles = [
                    ho.YC,
                    ho.Op,
                    ho.Lt,
                    ho.PC,
                    ho.hF,
                    ls.AH`
		.group {
			margin-bottom: 10px;
		}

		.group:not(.group-inline) label {
			margin-bottom: 5px;
			display: inline-block;
		}
	`
                ], ReportForm.properties = {
                    mode: {
                        state: !0
                    },
                    failure: {
                        state: !0
                    }
                }, customElements.define("pnx-report-form", ReportForm);
            },
            5457: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsDoc
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(6249), sc = bt(7704);
                class SemanticsDoc extends ls.WF {
                    render() {
                        var le1, vt, bt, ho, uc, mc;
                        return ls.qy`
			<h4>${(0, Dl.fa)(Fl.DX)} ${null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.semantics_title}</h4>
			<p>${null === (vt = this._t) || void 0 === vt ? void 0 : vt.pnx.semantics_doc_info1}</p>
			<ul style="padding-left: 1.5em;">
				<li>${null === (bt = this._t) || void 0 === bt ? void 0 : bt.pnx.semantics_doc_info1u1}</li>
				<li>${null === (ho = this._t) || void 0 === ho ? void 0 : ho.pnx.semantics_doc_info2}</li>
			</ul>
			<p>${null === (uc = this._t) || void 0 === uc ? void 0 : uc.pnx.semantics_doc_info3}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/tags/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${(0, Dl.fa)(sc.A)} ${null === (mc = this._t) || void 0 === mc ? void 0 : mc.pnx.popup_details_link}</pnx-link-button>
		`;
                    }
                }
                SemanticsDoc.styles = [
                    ho.YC,
                    ho.Op,
                    ho.lk
                ], customElements.define("pnx-semantics-doc", SemanticsDoc);
            },
            7959: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsDownload
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(6516);
                class SemanticsDownload extends ls.WF {
                    render() {
                        var le1, vt, bt;
                        return ls.qy`
			<h4>${(0, Dl.fa)(Fl.cb)} ${null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.semantics_download_title}</h4>
			<p>${null === (vt = this._t) || void 0 === vt ? void 0 : vt.pnx.semantics_download_info}</p>
			<pnx-link-button
				href="https://docs.panoramax.fr/federated-catalog/data_export/"
				target="_blank"
				kind="outline"
				style="width: 100%"
			>${null === (bt = this._t) || void 0 === bt ? void 0 : bt.pnx.semantics_download_cta}</pnx-link-button>
		`;
                    }
                }
                SemanticsDownload.styles = [
                    ho.YC,
                    ho.Op
                ], customElements.define("pnx-semantics-download", SemanticsDownload);
            },
            3728: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsFilters
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(6668), Fl = bt(6516), sc = bt(4005);
                class SemanticsFilters extends ls.WF {
                    constructor(){
                        super(), this.showZoomIn = !0, this._layers = [], (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = (vt = this._parent).onceMapReady) || void 0 === le1 ? void 0 : le1.call(vt).then(async ()=>{
                                this._parent.map.on("zoomend", this._onMapZoom.bind(this)), this._parent.map.on("render", this._onLayersChange.bind(this)), this._onMapZoom(), this._onLayersChange();
                            });
                        });
                    }
                    _layersToSet(le1) {
                        return le1.map((le1)=>{
                            var vt;
                            return le1.id + "/" + (null === (vt = le1.layout) || void 0 === vt ? void 0 : vt.visibility);
                        }).sort().join("|");
                    }
                    _onLayersChange() {
                        clearTimeout(this._debouncedChange), this._debouncedChange = setTimeout(()=>{
                            var le1, vt;
                            const bt = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.map) || void 0 === vt ? void 0 : vt.getSemanticOverlays();
                            this._layersToSet(bt) != this._layersToSet(this._layers) && (this._layers = bt, this.dispatchEvent(new CustomEvent("change", {
                                bubbles: !0,
                                composed: !0,
                                detail: {
                                    layers: bt
                                }
                            })));
                        }, 10);
                    }
                    _onMapZoom() {
                        this._showZoomIn = this._parent.map.getZoom() < sc.lU;
                    }
                    render() {
                        var le1, vt, bt;
                        if (this._layers && 0 !== this._layers.length) return ls.qy`
			<div class="pnx-tags-zoomin ${this._showZoomIn ? "" : "hidden"}">
				${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.semantics_zoom_in}
			</div>

			<div class="pnx-tags-cta">
				<pnx-button
					kind="full"
					size="sm"
					@click=${()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showSemanticsDownload();
                        }}
				>${(0, ho.fa)(Fl.cb)} ${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_download}</pnx-button>

				<pnx-button
					id="pnx-semfilt-doc"
					kind="superinline"
					size="md"
					title=${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.semantics_doc}
					@click=${()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showSemanticsDoc();
                        }}
				>${(0, ho.fa)(Dl.iW)}</pnx-button>
			</div>

			${this._layers.filter((le1)=>le1.metadata).map((le1)=>{
                            var vt, bt;
                            return ls.qy`
				<pnx-switch
					name=${"pnx-semfilt-" + le1.id}
					.checked=${"none" !== (null === (vt = le1.layout) || void 0 === vt ? void 0 : vt.visibility)}
					@change=${(vt)=>this._parent.map.setLayoutProperty(le1.id, "visibility", vt.target.checked ? "visible" : "none")}
				>${(null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.semantics_overlays[le1.id]) || le1.metadata.name || le1.id}</pnx-switch>
			`;
                        })}
		`;
                    }
                }
                SemanticsFilters.styles = ls.AH`
		.pnx-tags-zoomin {
			z-index: 131;
			background-color: rgba(255,255,255,0.8);
			text-align: center;
			font-weight: 800;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			display: flex;
			justify-content: center;
			align-items: center;
			border-radius: 25px;
		}
		.pnx-tags-zoomin.hidden {
			display: none;
		}
		.pnx-tags-cta {
			display: flex;
			align-items: center;
  			justify-content: end;
		}
		pnx-switch {
			display: block;
			margin: 5px 0;
		}
	`, SemanticsFilters.properties = {
                    _showZoomIn: {
                        state: !0
                    },
                    _layers: {
                        state: !0
                    }
                }, customElements.define("pnx-map-semantics-filters-menu", SemanticsFilters);
            },
            9671: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsList
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(2283), sc = bt(1187), uc = bt(7321), mc = bt(4692), gc = bt(8466), Ac = bt(4954), Ec = bt(7428), kc = bt(4189), du = bt(174);
                bt(8983);
                class SemanticsList extends ls.WF {
                    constructor(){
                        super(), this._meta = {}, this._seqMeta = {}, this._selectedEntry = null, this._annotPresets = {}, this._picPresets = [], this._seqPresets = [], this._entries = null, this.editable = !1, (0, Dl.moreIcons)();
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._onPicChange(), (0, Dl.onceParentAvailable)(this).then(()=>{
                            var le1, vt, bt, ls;
                            null === (le1 = this._parent.psv) || void 0 === le1 || le1.addEventListener("picture-loaded", this._onPicChange.bind(this)), null === (vt = this._parent.psv) || void 0 === vt || vt.addEventListener("annotation-focused", (le1)=>this.showAnnotation(le1.detail.annotationId)), null === (bt = this._parent.psv) || void 0 === bt || bt.addEventListener("annotations-unfocused", ()=>this._onListItemClick(null)), null === (ls = this._parent.psv) || void 0 === ls || ls.addEventListener("semantics-unfocused", ()=>this._onListItemClick(null));
                            const ho = this._parent.psv.getSelectedAnnotations();
                            ho.length > 0 && this.showAnnotation(ho[0]);
                        });
                    }
                    showAnnotation(le1) {
                        this._entries ? this._onListItemClick(this._entries.find((vt)=>"annotation" === vt.type && vt.annotation.id == le1)) : setTimeout(()=>this.showAnnotation(le1), 200);
                    }
                    showTagsGroup(le1) {
                        this._entries ? this._onListItemClick(this._entries.find((vt)=>{
                            if ("annotation" === (null === vt || void 0 === vt ? void 0 : vt.type)) return !1;
                            for(let bt = 0; bt < le1.length; bt++)if (!vt.tagGroup.semantics.find((vt)=>le1[bt].key === vt.key && le1[bt].value === vt.value)) return !1;
                            return !0;
                        })) : setTimeout(()=>this.showTagsGroup(le1), 200);
                    }
                    _onPicChange() {
                        var le1, vt, bt, ls, ho;
                        (this._meta = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.getPictureMetadata(), this._getSeqMeta(), delete this._prevPsvView, this._selectedEntry = null, this._entries = null, this.dispatchEvent(new CustomEvent("select", {
                            detail: {
                                item: null
                            }
                        })), this._meta && null !== (bt = this._parent) && void 0 !== bt && bt.presetsManager) && (this._annotPresets = {}, this._picPresets = [], this._parent.presetsManager.getPresets(this._meta.properties).then((le1)=>{
                            this._picPresets = le1, this._computeEntries();
                        }), (null === (ls = this._meta.properties) || void 0 === ls || null === (ho = ls.annotations) || void 0 === ho ? void 0 : ho.length) > 0 && Promise.all(this._meta.properties.annotations.map((le1)=>this._parent.presetsManager.getPreset(le1).then((vt)=>{
                                this._annotPresets[le1.id] = vt;
                            }))).then(()=>this._computeEntries()));
                    }
                    async _getSeqMeta() {
                        var le1, vt, bt, ls;
                        const ho = null === (le1 = this._meta) || void 0 === le1 || null === (vt = le1.sequence) || void 0 === vt ? void 0 : vt.id;
                        if (ho && !this._parent._sequencesMetadata[ho] && (this._parent._sequencesMetadata[ho] = await this._parent.api.getSequenceMetadata(ho)), this._seqMeta = this._parent._sequencesMetadata[ho], this._seqPresets = [], (null === (bt = this._seqMeta) || void 0 === bt || null === (ls = bt.semantics) || void 0 === ls ? void 0 : ls.length) > 0) {
                            const le1 = await this._parent.presetsManager.getPresets(this._seqMeta);
                            this._seqPresets = le1, this._computeEntries();
                        }
                    }
                    _getGroupedTags(le1, vt, bt, ls) {
                        const ho = [], groupToList = (le1, vt)=>{
                            const bt = [
                                {
                                    key: vt,
                                    value: le1.value
                                }
                            ];
                            return le1.qualifiers && le1.qualifiers.forEach((le1)=>bt.push({
                                    key: le1.key,
                                    value: le1.value
                                })), bt;
                        }, Dl = (0, Fl.groupByPrefix)(le1), sc = [];
                        var uc;
                        (Dl.forEach((le1)=>{
                            const bt = {};
                            le1.tags.forEach((Dl)=>{
                                const Fl = "" != le1.prefix ? `${le1.prefix}|${Dl.key}` : Dl.key;
                                if (bt[`${Fl}=${Dl.value}`]) return void groupToList(Dl, Fl).forEach((le1)=>bt[`${Fl}=${Dl.value}`].push(le1));
                                const uc = ls.find((le1)=>[
                                        "*",
                                        Dl.value
                                    ].includes(le1.tags[Fl]));
                                if (uc) {
                                    var mc;
                                    const le1 = groupToList(Dl, Fl);
                                    let ls = 0;
                                    Object.entries(uc.tags).forEach((vt)=>{
                                        let [ho, Dl] = vt, sc = Dl;
                                        var uc;
                                        "*" === Dl && (sc = null === (uc = this._meta.properties.semantics.find((le1)=>le1.key === Fl)) || void 0 === uc ? void 0 : uc.value);
                                        bt[ho + "=" + sc] = le1, ls++;
                                    }), ho.push({
                                        title: uc.name,
                                        icon: uc.iconify || "fa6-solid:cube",
                                        associatedTags: ((null === (mc = Dl.qualifiers) || void 0 === mc ? void 0 : mc.length) || 0) + ls,
                                        tagGroup: {
                                            semantics: le1
                                        },
                                        type: vt
                                    });
                                } else sc.push({
                                    key: Fl,
                                    value: Dl.value
                                });
                            });
                        }), sc.length > 0) && ho.push({
                            title: null === (uc = this._parent) || void 0 === uc ? void 0 : uc._t.pnx.semantics_features_default_title.replace("{nb}", bt++),
                            icon: "fa6-solid:tag",
                            associatedTags: sc.length,
                            tagGroup: {
                                semantics: sc
                            },
                            type: vt
                        });
                        return [
                            ho,
                            bt
                        ];
                    }
                    _computeEntries() {
                        var le1, vt, bt, ls, ho;
                        let Dl = 1, Fl = [], sc = [];
                        (null === (le1 = this._seqMeta) || void 0 === le1 || null === (vt = le1.semantics) || void 0 === vt ? void 0 : vt.length) > 0 && ([Fl, Dl] = this._getGroupedTags(this._seqMeta.semantics, "seqtags", Dl, this._seqPresets)), [sc, Dl] = this._getGroupedTags(null === (bt = this._meta.properties) || void 0 === bt ? void 0 : bt.semantics, "pictags", Dl, this._picPresets), Fl = Fl.concat(sc), Fl = Fl.concat((null === (ls = this._meta.properties) || void 0 === ls || null === (ho = ls.annotations) || void 0 === ho ? void 0 : ho.map((le1)=>{
                            var vt, bt, ls;
                            return {
                                title: (null === (vt = this._annotPresets[le1.id]) || void 0 === vt ? void 0 : vt.name) || (null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.semantics_features_default_title.replace("{nb}", Dl++)),
                                icon: (null === (ls = this._annotPresets[le1.id]) || void 0 === ls ? void 0 : ls.iconify) || "fa6-solid:cube",
                                associatedTags: le1.semantics.filter((le1)=>"delete" !== le1.action).length,
                                type: "annotation",
                                annotation: le1
                            };
                        })) || []), this._entries = Fl;
                    }
                    _onListItemHover(le1) {
                        "annotation" === (null === le1 || void 0 === le1 ? void 0 : le1.type) ? (this._prevPsvView || (this._prevPsvView = [
                            this._parent.psv.getZoomLevel(),
                            this._parent.psv.getPosition()
                        ]), this._parent.psv.focusOnAnnotation(le1.annotation.id, void 0, !0)) : (this._parent.psv.unfocusAnnotation(), this._prevPsvView && (this._parent.psv.zoom(this._prevPsvView[0]), this._parent.psv.rotate(this._prevPsvView[1]), delete this._prevPsvView));
                    }
                    _onListItemClick(le1) {
                        this._selectedEntry = le1, this._onListItemHover(le1), this.dispatchEvent(new CustomEvent("select", {
                            detail: {
                                item: le1
                            }
                        }));
                    }
                    _onItemEditClick(le1) {
                        le1.stopPropagation(), this.dispatchEvent(new CustomEvent("edit-click", {
                            detail: {
                                item: this._selectedEntry
                            }
                        }));
                    }
                    _onItemDeleteClick(le1) {
                        le1.stopPropagation(), this.dispatchEvent(new CustomEvent("delete-click", {
                            detail: {
                                item: this._selectedEntry
                            }
                        }));
                    }
                    render() {
                        if (!this._meta) return ls.s6;
                        var le1, vt, bt, ho, _u, Md, Ld, Nd, Rd;
                        if (this._selectedEntry) return ls.qy`<div class="annotation">
				<pnx-list-item
					title=${this._selectedEntry.title}
					@click=${()=>this._onListItemClick(null)}
				>
					${(0, Dl.fa)(gc.Ce, {
                            transform: {
                                size: 24
                            },
                            attributes: {
                                slot: "icon"
                            }
                        })}
					<iconify-icon
						slot="icon"
						icon=${this._selectedEntry.icon}
						style="font-size: 1.5em"
					></iconify-icon>

					<pnx-copy-button
						kind="superinline"
						text=${(0, Fl.semanticsToString)(null === (le1 = (null === (vt = this._selectedEntry) || void 0 === vt ? void 0 : vt.annotation) || (null === (bt = this._selectedEntry) || void 0 === bt ? void 0 : bt.tagGroup)) || void 0 === le1 ? void 0 : le1.semantics)}
						slot="action"
						._t=${null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t}
						title=${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.semantics_copy}
					>
						${(0, Dl.fa)(kc.jP, {
                            transform: {
                                size: 18
                            }
                        })}
						${(0, Dl.fa)(du.e6, {
                            attributes: {
                                slot: "oncopy"
                            },
                            transform: {
                                size: 18
                            }
                        })}
					</pnx-copy-button>
					
					${this.editable && "seqtags" !== this._selectedEntry.type ? ls.qy`
						<pnx-button
							kind="superinline"
							title=${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.semantics_edit}
							slot="action"
							@click=${this._onItemEditClick}
						>
							${(0, Dl.fa)(uc.hp, {
                            transform: {
                                size: 18
                            }
                        })}
						</pnx-button>
						<pnx-button
							kind="superinline"
							title=${null === (Ld = this._parent) || void 0 === Ld ? void 0 : Ld._t.pnx.semantics_delete_annotation}
							slot="action"
							@click=${this._onItemDeleteClick}
						>
							${(0, Dl.fa)(mc.yL, {
                            transform: {
                                size: 18
                            }
                        })}
						</pnx-button>` : ls.s6}
				</pnx-list-item>
				<pnx-semantics-table
					._t=${null === (Nd = this._parent) || void 0 === Nd ? void 0 : Nd._t}
					.source=${"annotation" === (null === (Rd = this._selectedEntry) || void 0 === Rd ? void 0 : Rd.type) ? this._selectedEntry.annotation : this._selectedEntry.tagGroup}
				/>
			</div>`;
                        {
                            var Od, jd, Ud;
                            const le1 = {
                                seqtags: null === (Od = this._parent) || void 0 === Od ? void 0 : Od._t.pnx.semantics_sequence_tags,
                                pictags: null === (jd = this._parent) || void 0 === jd ? void 0 : jd._t.pnx.semantics_picture_tags,
                                annotation: null === (Ud = this._parent) || void 0 === Ud ? void 0 : Ud._t.pnx.semantics_annotation_tags
                            };
                            return ls.qy`<div class="list">
				${(this._entries || []).map((vt)=>ls.qy`
					<pnx-list-item
						title=${vt.title}
						tooltip=${le1[vt.type]}
						@click=${()=>this._onListItemClick(vt)}
						@mouseover=${()=>this._onListItemHover(vt)}
						@mouseout=${()=>this._onListItemHover(null)}
					>
						<iconify-icon
							slot="icon"
							icon=${vt.icon}
							style="font-size: 1.5em"
						></iconify-icon>
						${vt.associatedTags > 1 ? ls.qy`
							<span slot="icon" class="pnx-badge-count">${vt.associatedTags}</span>
						` : ls.s6}
						${"annotation" === (null === vt || void 0 === vt ? void 0 : vt.type) ? (0, Dl.fa)(Ec.Cw, {
                                    transform: {
                                        size: 20
                                    },
                                    styles: {
                                        "margin-right": "20px"
                                    },
                                    attributes: {
                                        slot: "action"
                                    }
                                }) : ls.s6}
						${"seqtags" === (null === vt || void 0 === vt ? void 0 : vt.type) ? (0, Dl.fa)(Ac.yv, {
                                    transform: {
                                        size: 20
                                    },
                                    styles: {
                                        "margin-right": "20px"
                                    },
                                    attributes: {
                                        slot: "action"
                                    }
                                }) : ls.s6}
						${(0, Dl.fa)(sc.Xk, {
                                    transform: {
                                        size: 20
                                    },
                                    attributes: {
                                        slot: "action"
                                    }
                                })}
					</pnx-list-item>
				`)}
			</div>`;
                        }
                    }
                }
                SemanticsList.styles = [
                    ho.Op,
                    ho.wS,
                    ho.Fj,
                    ls.AH`
		.annotation { background: var(--white); }
		pnx-list-item {
			display: block;
			margin: 5px 0;
		}
	`
                ], SemanticsList.properties = {
                    editable: {
                        type: Boolean
                    },
                    _meta: {
                        state: !0
                    },
                    _seqMeta: {
                        state: !0
                    },
                    _entries: {
                        state: !0
                    },
                    _selectedEntry: {
                        state: !0
                    },
                    _annotPresets: {
                        state: !0
                    },
                    _picPresets: {
                        state: !0
                    },
                    _seqPresets: {
                        state: !0
                    }
                }, customElements.define("pnx-semantics-list", SemanticsList);
            },
            7694: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsMetadata
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(2255), Fl = bt(3624), sc = bt(1319), uc = bt(700), mc = bt(6668), gc = bt(8591), Ac = bt(7343);
                class SemanticsMetadata extends ls.WF {
                    constructor(){
                        super(), this._meta = {}, this._prevPSVPicNav = null, this._authUrl = null, this._showLinks = !0, this._addTag = !1, this._editTag = null, this._addTagGeom = null, this._editTagSem = null;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt, bt, ls;
                            this._meta = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.getPictureMetadata(), null === (bt = this._parent) || void 0 === bt || null === (ls = bt.oncePSVReady) || void 0 === ls || ls.call(bt).then(()=>{
                                this._parent.psv.addEventListener("picture-loaded", ()=>{
                                    this._meta = this._parent.psv.getPictureMetadata();
                                }), this._parent.psv.addEventListener("annotation-focused", ()=>{
                                    const le1 = this.shadowRoot.querySelector("pnx-tabs");
                                    le1 && le1.setAttribute("activeTabIndex", 4);
                                });
                            }), this._parent.api.getAuthURL().then((le1)=>this._authUrl = le1);
                        });
                    }
                    _blockPicChange(le1) {
                        var vt, bt, ls, ho;
                        null === (vt = this._parent) || void 0 === vt || null === (bt = vt.legend) || void 0 === bt || null === (ls = bt.renderRoot.querySelector("pnx-picture-legend")) || void 0 === ls || ls.blockOnEditing(le1), null !== (ho = this._parent) && void 0 !== ho && ho.mini && (this._parent.mini.style.display = le1 ? "none" : null);
                        const Dl = this._parent.renderRoot.querySelector("pnx-annotations-switch");
                        Dl && (Dl.style.display = le1 ? "none" : null), le1 ? (this._prevPSVPicNav = this._parent.psv.getPicturesNavigation(), this._parent.psv.setPicturesNavigation("pic"), this._parent._disableKeyboard(), window.addEventListener("beforeunload", this._onBrowserQuit)) : (this._parent.psv.setPicturesNavigation(this._prevPSVPicNav), this._parent._enableKeyboard(), window.removeEventListener("beforeunload", this._onBrowserQuit));
                    }
                    _onBrowserQuit(le1) {
                        le1.preventDefault(), le1.returnValue = !0;
                    }
                    _checkCanEdit() {
                        if (!this._meta.origInstance && null !== (0, Ac.getUserAccount)()) return !0;
                        var le1, vt;
                        if (this._meta.origInstance && confirm(((null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.semantics_login_needed) || "").replace("{n}", this._meta.origInstance.instance_name || this._meta.origInstance.href))) window.location.href = this._meta.origInstance.href + window.location.search.replace(/&?nav=pic/, "");
                        else {
                            if (this._meta.origInstance || !confirm(((null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_login_needed) || "").replace("{n}", this._parent.api._metadata.name))) return !1;
                            window.location.href = this._authUrl.replace("<CBURL>", encodeURIComponent(window.location.href));
                        }
                    }
                    _startAddTag() {
                        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !0, this._editTag = !1, this._addTagGeom = null, this._editTagSem = null, this._addTagGeomListener = (le1)=>this._addTagGeom = le1.detail.shape, this._parent.psv.addEventListener("annotation-drawn", this._addTagGeomListener), this._parent.psv.startDrawAnnotation());
                    }
                    _onTagSemChange(le1) {
                        this._editTagSem = le1.detail;
                    }
                    _onSaveTag() {
                        var le1;
                        const vt = this.renderRoot.querySelector("#pnx-sem-editor");
                        var bt;
                        if (vt && vt.checkValidity() && this._editTagSem && this._editTagSem.delta && 0 !== this._editTagSem.delta.length) {
                            if ("annotation" === (null === (le1 = this._editTag) || void 0 === le1 ? void 0 : le1.type)) null === (bt = this._parent) || void 0 === bt || bt.api.editPictureAnnotation(this._editTag.annotation.id, this._editTagSem.delta).then((le1)=>{
                                const vt = this._meta.properties.annotations.findIndex((vt)=>vt.id === le1.id);
                                this._meta.properties.annotations[vt] = le1, this._onCancelEditTag(le1);
                            }).catch((le1)=>{
                                var vt;
                                console.error("Can't send annotation", le1), this._onCancelEditTag(this._editTag.annotation), alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_send_fail);
                            });
                            else if (this._addTag && this._addTagGeom) {
                                var ls;
                                this._parent.psv.fixDrawAnnotation(), null === (ls = this._parent) || void 0 === ls || ls.api.createPictureAnnotation(this._meta, this._addTagGeom, this._editTagSem.delta).then((le1)=>{
                                    this._meta.properties.annotations.push(le1), this._onCancelEditTag(le1, !0);
                                }).catch((le1)=>{
                                    var vt;
                                    console.error("Can't send annotation", le1), alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_send_fail), this._onCancelEditTag();
                                });
                            } else if (this._addTag || this._editTag && "annotation" !== this._editTag.type) {
                                var ho;
                                null === (ho = this._parent) || void 0 === ho || ho.api.sendPictureSemantics(this._meta, this._editTagSem.delta).then((le1)=>{
                                    this._meta.properties.semantics = le1.properties.semantics, this._onCancelEditTag(this._editTagSem.delta);
                                }).catch((le1)=>{
                                    var vt;
                                    alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_send_fail), console.error("Can't send semantics", le1), this._onCancelEditTag();
                                });
                            }
                        } else vt.reportValidity();
                    }
                    _onEraseDrawnAnnotation() {
                        this._parent.psv.stopDrawAnnotation(), this._addTagGeom = null, this._parent.psv.startDrawAnnotation();
                    }
                    _onEditTag(le1) {
                        var vt, bt;
                        this._checkCanEdit() && (this._blockPicChange(!0), this._addTag = !1, this._addTagGeom = null, this._editTagSem = "annotation" === (null === (vt = le1.detail.item) || void 0 === vt ? void 0 : vt.type) ? {
                            semantics: le1.detail.item.annotation.semantics
                        } : le1.detail.item.tagGroup, this._editTag = le1.detail.item, "annotation" === (null === (bt = le1.detail.item) || void 0 === bt ? void 0 : bt.type) && this._parent.psv.focusOnAnnotation(le1.detail.item.annotation.id, !0));
                    }
                    _onCancelEditTag() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        this.renderRoot.querySelector("#pnx-sem-editor").reset(), this._addTag = !1, this._addTagGeom = null, this._editTag = null, vt || this._parent.psv.stopDrawAnnotation(), this._blockPicChange(!1), this.getUpdateComplete().then(()=>{
                            const vt = this.renderRoot.querySelector("#pnx-sem-list");
                            le1 && vt && (le1.id ? vt.showAnnotation(le1.id) : vt.showTagsGroup(le1));
                        });
                    }
                    _onDeleteTag(le1) {
                        var vt;
                        if (this._checkCanEdit() && confirm(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_delete_annotation_confirm)) {
                            const vt = le1.detail.item;
                            if ("annotation" === (null === vt || void 0 === vt ? void 0 : vt.type)) {
                                var bt;
                                null === (bt = this._parent) || void 0 === bt || bt.api.deletePictureAnnotation(vt.annotation.id).then(()=>{
                                    var le1;
                                    const bt = Object.assign({}, this._meta);
                                    bt.properties.annotations = this._meta.properties.annotations.filter((le1)=>le1.id != vt.annotation.id), this._meta = bt, this._parent.psv.toggleAllAnnotations(!0), null === (le1 = this.renderRoot.querySelector("pnx-semantics-list")) || void 0 === le1 || le1._onPicChange();
                                }).catch((le1)=>{
                                    var vt;
                                    console.error("Can't send annotation", le1), alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_send_fail);
                                });
                            } else {
                                var ls;
                                const le1 = vt.tagGroup.semantics.map((le1)=>Object.assign({
                                        action: "delete"
                                    }, le1));
                                null === (ls = this._parent) || void 0 === ls || ls.api.sendPictureSemantics(this._meta, le1).then((le1)=>{
                                    var vt;
                                    this._meta.properties.semantics = le1.properties.semantics, null === (vt = this.renderRoot.querySelector("pnx-semantics-list")) || void 0 === vt || vt._onPicChange();
                                }).catch((le1)=>{
                                    var vt;
                                    alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_send_fail), console.error("Can't send semantics", le1);
                                });
                            }
                        }
                    }
                    render() {
                        var le1, vt, bt, gc, Ec, kc, du, _u, Md, Ld;
                        if (null === (le1 = this._meta) || void 0 === le1 || !le1.properties) return;
                        const Nd = !this._meta.origInstance && (this._authUrl || null !== (0, Ac.getUserAccount)());
                        return ls.qy`
			${this._addTag || this._editTag ? ls.qy`
				<div class="data-block">
					<h5>
						${this._addTag ? null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.semantics_add_annotation : null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.semantics_edit}

						<pnx-button-group>
							<pnx-button
								kind="fullsuccess"
								style="margin-right: 3px"
								title=${null === (gc = this._parent) || void 0 === gc ? void 0 : gc._t.pnx.semantics_save}
								@click=${this._onSaveTag}
							>
								${(0, ho.fa)(Dl.jk)}
							</pnx-button>
							<pnx-button
								kind="fullwarn"
								title=${null === (Ec = this._parent) || void 0 === Ec ? void 0 : Ec._t.pnx.semantics_undo}
								@click=${()=>{
                            var le1;
                            return this._onCancelEditTag((null === (le1 = this._editTag) || void 0 === le1 ? void 0 : le1.annotation) || this._editTag);
                        }}
							>
								${(0, ho.fa)(Fl.GR)}
							</pnx-button>
						</pnx-button-group>
					</h5>
					<div>
						${this._addTag ? null === (kc = this._parent) || void 0 === kc ? void 0 : kc._t.pnx.semantics_draw_annotation : ls.s6}
						${this._addTag && this._addTagGeom ? ls.qy`<pnx-button
								kind="full"
								style="margin-top: 5px; width: 100%"
								@click=${this._onEraseDrawnAnnotation}
							>
							${(0, ho.fa)(uc.IP)} ${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.semantics_erase_annotation}
						</pnx-button>` : ls.s6}

						<pnx-semantics-editor
							id="pnx-sem-editor"
							style="display: block; margin-top: 5px"
							.semantics=${(null === (_u = this._editTagSem) || void 0 === _u ? void 0 : _u.semantics) || []}
							._t=${this._parent._t}
							@change=${this._onTagSemChange}
						></pnx-semantics-editor>
					</div>
				</div>
			` : ls.qy`
				${this._showLinks ? ls.qy`
					<div class="top-btns">
						<pnx-button
							kind="full"
							size="md"
							style="flex: 2 1"
							@click=${this._startAddTag}
						>
							${(0, ho.fa)(sc.jk)} ${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.semantics_add_annotation}
						</pnx-button>
						<pnx-button
							kind="full"
							size="md"
							style="flex: 1 1"
							@click=${()=>{
                            var le1;
                            return null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._showSemanticsDoc();
                        }}
						>${(0, ho.fa)(mc.iW)} ${null === (Ld = this._parent) || void 0 === Ld ? void 0 : Ld._t.pnx.semantics_doc}</pnx-button>
					</div>
				` : ls.s6}
				
				<pnx-semantics-list
					id="pnx-sem-list"
					.editable=${Nd}
					@select=${(le1)=>this._showLinks = null == le1.detail.item}
					@edit-click=${this._onEditTag}
					@delete-click=${this._onDeleteTag}
					._parent=${this._parent}
				/>
			`}
		`;
                    }
                }
                SemanticsMetadata.styles = [
                    gc.R,
                    gc.Tk,
                    ls.AH`
		.top-btns, pnx-semantics-list {
			font-size: 0.8em;
		}
		.top-btns {
			display: flex;
			margin: 5px 0;
			gap: 5px;
		}
		.top-btns > * {
			overflow: hidden;
		}
		.top-btns > *::part(btn) {
			height: unset;
		}
		.data-block {
			width: 100%;
		}
		.data-block h5 {
			justify-content: space-between;
		}
	`
                ], SemanticsMetadata.properties = {
                    _meta: {
                        state: !0
                    },
                    _prevPSVPicNav: {
                        state: !0
                    },
                    _authUrl: {
                        state: !0
                    },
                    _showLinks: {
                        state: !0
                    },
                    _addTag: {
                        state: !0
                    },
                    _editTag: {
                        state: !0
                    },
                    _addTagGeom: {
                        state: !0
                    },
                    _editTagSem: {
                        state: !0
                    }
                }, customElements.define("pnx-semantics-metadata", SemanticsMetadata);
            },
            3765: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ShareMenu
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(8591), Fl = bt(2e3), sc = bt(7516), uc = bt(6002), mc = bt(7964);
                class ShareMenu extends ls.WF {
                    constructor(){
                        super(), this._onUrlChange();
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            this._onUrlChange(), this._parent.urlHandler.addEventListener("url-changed", this._onUrlChange.bind(this));
                        });
                    }
                    _onUrlChange() {
                        var le1, vt;
                        const bt = (this["base-url"] || window.location.href).replace(/\/$/, "");
                        this._url = (null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.urlHandler) || void 0 === vt ? void 0 : vt.nextShortLink(bt)) || bt;
                    }
                    render() {
                        var le1, vt, bt, Dl, gc, Ac;
                        const Ec = `<iframe src="${this._url}" style="border: none; width: 500px; height: 300px"></iframe>`;
                        return ls.qy`
			<h4>${(0, ho.fa)(uc.QO)} ${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.share}</h4>
			<pnx-tabs>
				<h4 slot="title">${(0, ho.fa)(mc.CQ)} ${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.share_page}</h4>
				<div slot="content">
					<div class="links">
						<input type="text" readonly value=${this._url} style="flex: 2" />
						<pnx-copy-button ._t=${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t} text=${this._url}></pnx-copy-button>
					</div>
				</div>
					
				<h4 slot="title">${(0, ho.fa)(Fl.e5)} ${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.share_embed}</h4>
				<div slot="content">
					<div class="embed">
						<pnx-link-button
							href="https://docs.panoramax.fr/web-viewer/03_URL_settings/"
							target="_blank"
							kind="superinline"
							size="sm"
						>
							${(0, ho.fa)(sc.faCircleInfo)} ${null === (gc = this._parent) || void 0 === gc ? void 0 : gc._t.pnx.share_embed_docs}
						</pnx-link-button>
						<textarea readonly .value=${Ec}></textarea>
						<pnx-copy-button
							._t=${null === (Ac = this._parent) || void 0 === Ac ? void 0 : Ac._t}
							text=${Ec}
							style="width: 100%"
						></pnx-copy-button>
					</div>
				</div>
			</pnx-tabs>`;
                    }
                }
                ShareMenu.styles = [
                    Dl.Op,
                    Dl.hF,
                    Dl.PC,
                    Dl.YC,
                    ls.AH`
		div[slot="content"] {
			margin-top: 10px;
		}
		.links {
			display: flex;
			gap: 5px;
		}
		.embed {
			display: flex;
			gap: 5px;
			align-items: center;
			flex-direction: column;
		}
	`
                ], ShareMenu.properties = {
                    _url: {
                        state: !0
                    },
                    "base-url": {
                        type: String
                    }
                }, customElements.define("pnx-share-menu", ShareMenu);
            },
            8794: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    LocationPrecisionDoc: ()=>ls.A,
                    MapBackground: ()=>ho.A,
                    MapFilters: ()=>Dl.A,
                    MapLayers: ()=>Fl.A,
                    MapLegend: ()=>sc.A,
                    MiniPictureLegend: ()=>uc.A,
                    PictureLegend: ()=>mc.A,
                    PictureMetadata: ()=>gc.A,
                    PlayerOptions: ()=>Ac.A,
                    QualityScoreDoc: ()=>Ec.A,
                    ReportForm: ()=>kc.A,
                    SemanticsDoc: ()=>du.A,
                    SemanticsDownload: ()=>_u.A,
                    SemanticsFilters: ()=>Md.A,
                    SemanticsList: ()=>Ld.A,
                    SemanticsMetadata: ()=>Nd.A,
                    Share: ()=>Rd.A
                });
                var ls = bt(5537), ho = bt(5036), Dl = bt(3581), Fl = bt(5334), sc = bt(4749), uc = bt(1636), mc = bt(3589), gc = bt(6993), Ac = bt(499), Ec = bt(5187), kc = bt(9588), du = bt(5457), _u = bt(7959), Md = bt(3728), Ld = bt(9671), Nd = bt(7694), Rd = bt(3765);
            },
            8591: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    BQ: ()=>Md,
                    Fj: ()=>du,
                    HM: ()=>gc,
                    Lt: ()=>uc,
                    Op: ()=>Fl,
                    PC: ()=>sc,
                    R: ()=>Dl,
                    Tk: ()=>Rd,
                    YC: ()=>Ec,
                    hF: ()=>mc,
                    kq: ()=>Ac,
                    lk: ()=>Od,
                    nd: ()=>ho,
                    qf: ()=>_u,
                    s0: ()=>kc,
                    tp: ()=>Ld,
                    wS: ()=>Nd
                });
                var ls = bt(4542);
                const ho = ls.AH`
	.pnx-panel {
		position: absolute;
		transition: opacity 0.2s 0.1s;
		border-radius: 25px;
		border: 1px solid var(--widget-border-div);
		background-color: var(--widget-bg);
		color: var(--widget-font);
		min-width: 250px;
		box-sizing: border-box;
		font-family: var(--font-family);
	}

	.pnx-panel.pnx-hidden {
		opacity: 0;
		display: block !important;
		pointer-events: none;
	}

	.pnx-panel.pnx-padded {
		padding: 15px;
	}
`, Dl = ls.AH`
	.pnx-hidden { display: none !important; }
`, Fl = ls.AH`
	.svg-inline--fa {
		display: var(--fa-display, inline-block);
		height: 1em;
		overflow: visible;
		vertical-align: -0.125em;
	}
	svg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {
		overflow: visible;
		box-sizing: content-box;
	}
	@keyframes fa-spin {
		from {transform:rotate(0deg);}
		to {transform:rotate(360deg);}
	}
	.fa-spin {
		animation: fa-spin 2s infinite linear;
	}
`, sc = ls.AH`
	textarea {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 10px;
		padding: 5px;
		width: 100%;
		box-sizing: border-box;
		font-family: var(--font-family);
		resize: vertical;
	}
`, uc = ls.AH`
	select {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	select[disabled] {
		background-color: var(--widget-bg-inactive);
	}

	select.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, mc = ls.AH`
	input {
		background-color: var(--widget-bg);
		color: var(--widget-font);
		border: 1px solid var(--widget-border-div);
		border-radius: 20px;
		font-size: 16px;
		padding: 2px 10px;
		font-family: var(--font-family);
	}

	input.pnx-100w {
		width: 100%;
		box-sizing: border-box;
	}
`, gc = ls.AH`
	:host {
		display: inline-flex;
	}
	
	/* Common properties */
	.pnx-btn {
		white-space: nowrap;
		font-size: 1em;
		font-family: var(--font-family);
		flex-grow: 1;
		flex-shrink: 1;
		text-align: center;
		padding: 5px;
		font-weight: 600;
		flex-basis: 30%;
		line-height: 18px;
		justify-content: center;
		border-radius: 8px;
		cursor: pointer;
		text-decoration: none;
		display: inline-flex;
		align-items: center;
		gap: 5px;
		position: relative;
		width: 100%;
		height: 100%;
		min-width: 26px;
	}

	.pnx-btn:disabled { color: var(--widget-bg-inactive); }

	.pnx-btn.pnx-btn-active,
	.pnx-btn.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-full.pnx-btn-active:hover,
	.pnx-btn.pnx-btn-outline.pnx-btn-active:hover {
		background-color: var(--widget-bg-active);
		border-color: var(--widget-bg-active);
		color: var(--widget-font-active);
	}

	.pnx-btn .svg-inline--fa,
	.pnx-btn ::slotted(.svg-inline--fa),
	.pnx-btn slot .svg-inline--fa {
		height: 16px;
		pointer-events: none;
	}

	/* Sizing */
	.pnx-btn-sm {
		border-radius: 6px;
		line-height: 12px;
		font-size: 12px;
		min-width: unset;
	}

	.pnx-btn.pnx-btn-sm .svg-inline--fa,
	.pnx-btn.pnx-btn-sm ::slotted(.svg-inline--fa) {
		height: 12px;
	}

	.pnx-btn-l {
		border-radius: 12px;
		height: 24px;
		line-height: 24px;
		font-size: 20px;
		min-width: 24px;
	}

	.pnx-btn-xl {
		border-radius: 20px;
		height: 40px;
		line-height: 40px;
		font-size: 16px;
		font-weight: 500;
		min-width: 40px;
		padding: 0 10px;
		gap: 8px;
	}

	.pnx-btn.pnx-btn-xl .svg-inline--fa,
	.pnx-btn.pnx-btn-xl ::slotted(.svg-inline--fa) {
		height: 16px;
	}

	.pnx-btn-xxl {
		border-radius: 28px;
		height: 56px;
		line-height: 56px;
		font-size: 24px;
		min-width: 56px;
	}

	.pnx-btn.pnx-btn-xxl .svg-inline--fa,
	.pnx-btn.pnx-btn-xxl ::slotted(.svg-inline--fa) {
		height: 24px;
	}

	/* Fully-filled style */
	.pnx-btn-full {
		background-color: var(--widget-bg-primary);
		color: var(--widget-font-direct);
		border: none;
	}

	.pnx-btn-full:not(:disabled):hover {
		background-color: var(--widget-bg-primary-hover);
	}

	/* Fully-filled warning style */
	.pnx-btn-fullwarn {
		background-color: var(--widget-bg-warn);
		color: var(--widget-font-warn);
		border: none;
	}

	.pnx-btn-fullwarn:not(:disabled):hover {
		background-color: var(--widget-bg-warn);
	}

	/* Fully-filled success style */
	.pnx-btn-fullsuccess {
		background-color: var(--widget-bg-success);
		color: var(--widget-font-success);
		border: none;
	}

	.pnx-btn-fullsuccess:not(:disabled):hover {
		background-color: var(--widget-bg-success);
	}

	/* Outline style */
	.pnx-btn-outline {
		border: 1px solid var(--widget-border-btn);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-outline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Flat style */
	.pnx-btn-flat,
	.pnx-btn-flat.pnx-btn-active,
	.pnx-btn-flat.pnx-btn-active:hover,
	.pnx-btn-flat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font);
		background-color: var(--widget-bg);
	}

	.pnx-btn-flat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superflat style */
	.pnx-btn-superflat,
	.pnx-btn-superflat.pnx-btn-active,
	.pnx-btn-superflat.pnx-btn-active:hover,
	.pnx-btn-superflat:not(:disabled):hover {
		border: 1px solid var(--widget-border-div);
		color: var(--widget-font-direct);
		background-color: var(--widget-bg);
	}

	.pnx-btn-superflat:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Inline style */
	.pnx-btn-inline,
	.pnx-btn-inline.pnx-btn-active,
	.pnx-btn-inline.pnx-btn-active:hover,
	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		border: none;
		color: var(--widget-font);
		background: none;
	}

	.pnx-btn-inline:not(:disabled):hover,
	.pnx-btn-superinline:not(:disabled):hover {
		background-color: var(--widget-bg-hover);
	}

	/* Superinline style */
	.pnx-btn-superinline,
	.pnx-btn-superinline.pnx-btn-active,
	.pnx-btn-superinline.pnx-btn-active:hover,
	.pnx-btn-superinline:not(:disabled):hover {
		color: var(--widget-font-direct);
	}
`, Ac = ls.AH`
	pnx-button-group > pnx-button {
		display: inline-flex;
	}

	pnx-button-group > pnx-button::part(btn) {
		height: unset;
	}

	/* Togglable in group */
	pnx-button-group > pnx-togglable-group > pnx-button {
		width: 100%;
		height: 100%;
	}

	/* Row */
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="row"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-left: none;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :first-child::part(btn),
	pnx-button-group[dir="row"] > :first-child > ::part(btn) {
		border-top-right-radius: 0;
		border-bottom-right-radius: 0;
		border-right: none;
	}

	pnx-button-group[dir="row"] > :last-child::part(btn),
	pnx-button-group[dir="row"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-bottom-left-radius: 0;
		border-left: none;
	}

	/* Column */
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child)::part(btn),
	pnx-button-group[dir="column"] > :not(:first-child):not(:last-child) > ::part(btn) {
		border-radius: 0;
		border-top: none;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :first-child::part(btn),
	pnx-button-group[dir="column"] > :first-child > ::part(btn) {
		border-bottom-right-radius: 0;
		border-bottom-left-radius: 0;
		border-bottom: none;
	}

	pnx-button-group[dir="column"] > :last-child::part(btn),
	pnx-button-group[dir="column"] > :last-child > ::part(btn) {
		border-top-left-radius: 0;
		border-top-right-radius: 0;
		border-top: none;
	}
`, Ec = ls.AH`
	h1, h2, h3, h4, h5, h6 {
		font-family: var(--font-family);
	}
	
	h3 {
		font-size: 1.1em;
		line-height: 1.1em;
		font-weight: 500;
		margin: 10px 0 10px 0;
	}

	h4 {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		display: flex;
		align-items: center;
		justify-content: flex-start;
		gap: 5px;
	}

	h4:first-of-type { margin-top: 0; }

	h4 > svg.svg-inline--fa {
		height: 18px;
	}

	h4[slot="title"] {
		margin: 0;
		justify-content: center;
		font-size: 0.8em;
		line-height: 2em;
		padding: 0.5em 0;
	}
	h4[slot="title"] svg.svg-inline--fa {
		height: 14px;
	}
`, kc = ls.AH`
	.pnx-active-icon {
		box-sizing: border-box;
		background-color: var(--orange);
		border: 3px solid #fff;
		border-radius: 8px;
		height: 15px;
		left: 20px;
		position: absolute;
		top: 5px;
		width: 15px;
	}
`, du = ls.AH`
	.pnx-badge-count {
		box-sizing: border-box;
		background-color: var(--grey-pale);
		border-radius: 8px;
		right: -6px;
		position: absolute;
		top: -6px;
		width: 12px;
		height: 12px;
		font-size: 10px;
		text-align: center;
		line-height: 12px;
		font-weight: 800;
	}
`, _u = ls.AH`
	@keyframes animatedBackground {
		from {
			background-position: 0 0;
		}
		to {
			background-position: 1000px 0;
		}
	}

	.pnx-placeholder-loading {
		width: 100px;
		height: 100px;
		background-image: linear-gradient(
			90deg,
			#e4e4e4 0%,
			#f1f1f1 40%,
			#ededed 60%,
			#e4e4e4 100%
		);
		background-position: 0px 0px;
		background-repeat: repeat;
		animation: animatedBackground 5s linear infinite;
	}
`, Md = (ls.AH`
	details summary {
		font-size: 1.0em;
		line-height: 1.0em;
		font-weight: 500;
		margin: 15px 0;
		cursor: pointer;
	}

	details summary svg {
		height: 18px;
		vertical-align: sub;
		margin-right: 2px;
	}
`, ls.AH`
	@media print {
		.pnx-print-hidden { display: none !important; }
	}
`), Ld = ls.AH`
	table {
		border-collapse: collapse;
		font-size: 0.9rem;
		width: 100%;
		max-width: 100%;
		font-family: var(--font-family);
		background: var(--white);
	}

	th, td {
		padding: 10px;
		text-align: left;
		border-bottom: 1px solid #ddd;
	}

	th { font-weight: 600; }
`, Nd = ls.AH`
	iconify-icon {
		display: inline-block;
		width: 1em;
		height: 1em;
	}
`, Rd = ls.AH`
	.data-block {
		display: inline-block;
		margin: 8px 0;
		box-sizing: border-box;
		vertical-align: top;
	}
	.data-block h5 {
		font-size: 0.8em;
		font-weight: 400;
		color: var(--blue-dark);
		margin: 0 0 5px 0;
		display: flex;
		align-items: center;
		gap: 5px;
	}
	.data-block h5 pnx-button { vertical-align: middle; }
	.data-block h5 svg.svg-inline--fa { height: 14px; }
	.data-block div {
		font-size: 0.8em;
	}
`, Od = ls.AH`
	h4 {
		font-size: 1.3em;
		font-weight: 600;
		border-bottom: 3px solid var(--grey-pale);
		padding-bottom: 10px;
  		padding-top: 5px;
	}
`;
            },
            6254: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>AnnotationsSwitch
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(6249), Fl = bt(6311), sc = bt(508), uc = bt(1198), mc = bt(8591), gc = bt(7343);
                class AnnotationsSwitch extends ls.WF {
                    constructor(){
                        super(), this._annotationsToggled = !1, this._warnNoAnnot = !1, this._warnNoAnnotTooltip = !1, this.size = "xl";
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>{
                            this._parent.onceReady().then(()=>{
                                this._parent.psv.addEventListener("annotations-toggled", (le1)=>{
                                    this._annotationsToggled = le1.detail.visible, this._persistAnnotationsLocalStorage(this._annotationsToggled);
                                }), this._warnNoAnnot = !(0, sc.hasAnnotations)(this._parent.psv.getPictureMetadata()), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                    this._warnNoAnnot = !(0, sc.hasAnnotations)(this._parent.psv.getPictureMetadata());
                                });
                            }), this._parent.onceFirstPicLoaded().then(()=>{
                                this._annotationsToggled = this._parent.psv.areAnnotationsVisible() || !1, this._persistAnnotationsLocalStorage(this._annotationsToggled);
                            });
                        });
                    }
                    _persistAnnotationsLocalStorage(le1) {
                        localStorage.setItem(gc.DISABLE_ANNOTATIONS_PARAM, le1 ? "false" : "true");
                    }
                    _onClick() {
                        !this._annotationsToggled && this._warnNoAnnot && (this._warnNoAnnotTooltip = !0, setTimeout(()=>this._warnNoAnnotTooltip = !1, 2e3)), this._persistAnnotationsLocalStorage(!this._annotationsToggled), this._parent.psv.toggleAllAnnotations(!this._annotationsToggled);
                    }
                    render() {
                        var le1, vt, bt;
                        const sc = {
                            "pnx-panel": !0,
                            "pnx-hidden": !this._warnNoAnnotTooltip
                        };
                        return ls.qy`
			<pnx-button
				kind="superflat"
				size=${this.size}
				style="vertical-align: middle"
				class="pnx-print-hidden"
				title=${this._annotationsToggled ? null === (le1 = this._parent._t) || void 0 === le1 ? void 0 : le1.pnx.semantics_hide_annotations : null === (vt = this._parent._t) || void 0 === vt ? void 0 : vt.pnx.semantics_show_annotations}
				active=${this._annotationsToggled ? "" : ls.s6}
				@click=${this._onClick}
			>
				${(0, ho.fa)(Dl.DX, {
                            styles: {
                                height: "20px"
                            }
                        })}
				${this._warnNoAnnot ? (0, ho.fa)(Fl.JA, {
                            classes: "pnx-annotations-switch-empty"
                        }) : ls.s6}
			</pnx-button>
			<div
				class=${(0, uc.H)(sc)}
				@click=${()=>this._warnNoAnnotTooltip = !1}
			>
				${null === (bt = this._parent._t) || void 0 === bt ? void 0 : bt.pnx.semantics_zero_annotations}
			</div>
		`;
                    }
                }
                AnnotationsSwitch.styles = [
                    mc.nd,
                    ls.AH`
		.pnx-panel {
			padding: 5px;
			margin-top: 5px;
			width: max-content;
  			min-width: unset;
		}

		/* Custom button look */
		pnx-button::part(btn) {
			border-radius: 8px;
			height: 26px;
			width: 26px;
		}

		pnx-button[size="xl"]::part(btn) {
			border-radius: 8px;
			height: 38px;
			width: 38px;
		}

		pnx-button[active]::part(btn),
		pnx-button[active]:hover::part(btn) {
			background-color: var(--widget-bg-active) !important;
			border-color: var(--widget-bg-active) !important;
			color: var(--widget-font-active) !important;
		}

		/* No-annotations badge */
		.pnx-annotations-switch-empty {
			position: absolute;
			top: 1px;
			right: 1px;
			color: var(--orange);
			height: 8px;
		}

		pnx-button[size="xl"] .pnx-annotations-switch-empty {
			top: 2px;
			right: 2px;
			height: 12px;
		}

		pnx-button[active] .pnx-annotations-switch-empty {
			color: var(--yellow);
		}
	`
                ], AnnotationsSwitch.properties = {
                    size: {
                        type: String
                    },
                    _annotationsToggled: {
                        state: !0
                    },
                    _warnNoAnnot: {
                        state: !0
                    },
                    _warnNoAnnotTooltip: {
                        state: !0
                    }
                }, customElements.define("pnx-annotations-switch", AnnotationsSwitch);
            },
            4450: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Button
                });
                var ls = bt(4542), ho = bt(8591);
                class Button extends ls.WF {
                    constructor(){
                        super(), this.active = !1, this.disabled = !1, this.kind = "full", this.size = "md";
                    }
                    connectedCallback() {
                        super.connectedCallback(), "submit" === this.type && this.addEventListener("click", ()=>{
                            var le1;
                            return null === (le1 = this.closest("FORM")) || void 0 === le1 ? void 0 : le1.requestSubmit();
                        });
                    }
                    render() {
                        const le1 = document.createElement("button");
                        le1.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((le1)=>void 0 !== this[le1] && !1 !== this[le1] && ![
                                "active",
                                "kind",
                                "size"
                            ].includes(le1)).forEach((vt)=>le1.setAttribute(vt, this[vt])), le1.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`), this.active && le1.classList.add("pnx-btn-active");
                        const vt = document.createElement("slot");
                        return le1.appendChild(vt), le1;
                    }
                }
                Button.styles = ho.HM, Button.properties = {
                    active: {
                        type: Boolean
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    disabled: {
                        type: Boolean
                    },
                    type: {
                        type: String
                    },
                    title: {
                        type: String
                    }
                }, customElements.define("pnx-button", Button);
            },
            7679: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ButtonGroup
                });
                var ls = bt(4542);
                bt(1870);
                class ButtonGroup extends ls.WF {
                    constructor(){
                        super(), this.dir = "row", this.size = "md";
                    }
                    render() {
                        return ls.qy`<div class="${this.dir} ${this.size}">
			<slot></slot>
		</div>`;
                    }
                }
                ButtonGroup.styles = ls.AH`
		div {
			display: flex;
			flex-wrap: nowrap;
			align-items: stretch;
			align-content: stretch;
			justify-content: center;
		}

		div.row { flex-direction: row; }
		div.column { flex-direction: column; }

		div.xl { line-height: 38px; font-size: 20px; }
		div.row.xl { height: 38px; }
		div.column.xl { width: 38px; }

		div.row ::slotted(*) { height: 100%; min-width: 24px; }
		div.column ::slotted(*) { width: 100%; min-height: 24px; }

		div.row.xl ::slotted(*) { min-width: 38px; }
		div.column.xl ::slotted(*) { min-height: 38px; }
	`, ButtonGroup.properties = {
                    dir: {
                        type: String
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-button-group", ButtonGroup);
            },
            1903: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>CopyButton
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(174), Fl = bt(4189), sc = bt(8591), uc = bt(1198);
                class CopyButton extends ls.WF {
                    constructor(){
                        super(), this.data = "", this.input = "", this.unstyled = !1, this.kind = "full", this.size = "md", this._active = !1, this.addEventListener("click", this._onClick);
                    }
                    _onClick(le1) {
                        var vt;
                        let bt;
                        if (le1.stopPropagation(), "" !== this.input) {
                            const le1 = document.getElementById(this.input);
                            bt = le1.innerText || le1.value;
                        } else "" !== this.text && (bt = this.text);
                        null !== (vt = navigator) && void 0 !== vt && vt.clipboard ? (navigator.clipboard.writeText(bt), this._active = !0, setTimeout(()=>this._active = !1, 2e3)) : alert("Clipboard is not available");
                    }
                    render() {
                        var le1, vt;
                        const bt = {
                            "pnx-btn": !this.unstyled,
                            "pnx-btn-full": !this.unstyled,
                            "pnx-btn-active": !this.unstyled && this._active,
                            "pnx-btn-unstyled": this.unstyled,
                            [`pnx-btn-${this.kind}`]: !this.unstyled,
                            [`pnx-btn-${this.size}`]: !this.unstyled
                        };
                        return ls.qy`<button title=${this.title} class=${(0, uc.H)(bt)} part="btn">
			${this._active ? ls.qy`<slot name="oncopy">${(null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.copied) || ""} ${(0, ho.fa)(Dl.e6)}</slot>` : ls.qy`<slot>${(0, ho.fa)(Fl.jP)} ${(null === (vt = this._t) || void 0 === vt ? void 0 : vt.pnx.copy) || ""}</slot>`}
		</button>`;
                    }
                }
                CopyButton.styles = [
                    sc.Op,
                    sc.HM,
                    ls.AH`
		.pnx-btn-unstyled {
			border: none;
			background: none;
			font-family: var(--font-family);
			font-size: 1em;
			color: var(--widget-font);
			cursor: pointer;
			padding: 0;
			margin: 0;
		}
	`
                ], CopyButton.properties = {
                    text: {
                        type: String
                    },
                    input: {
                        type: String
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    unstyled: {
                        type: Boolean
                    },
                    title: {
                        type: String
                    },
                    _active: {
                        state: !0,
                        type: Boolean
                    }
                }, customElements.define("pnx-copy-button", CopyButton);
            },
            5051: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Grade
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(4780), Fl = bt(7325), sc = bt(8591);
                class Grade extends ls.WF {
                    constructor(){
                        super(), this.stars = 0;
                    }
                    render() {
                        var le1;
                        const vt = this.stars || 0, bt = [];
                        for(let ls = 1; ls <= vt; ls++)bt.push((0, ho.fa)(Dl.yy));
                        for(let ls = vt + 1; ls <= 5; ls++)bt.push((0, ho.fa)(Fl.yy));
                        return ls.qy`<span>
			${bt}
		</span> (${this.stars ? this.stars + "/5" : (null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.metadata_quality_missing) || "?"})`;
                    }
                }
                Grade.styles = [
                    sc.Op,
                    ls.AH`
		span { color: var(--orange); }
	`
                ], Grade.properties = {
                    stars: {
                        type: Number
                    }
                }, customElements.define("pnx-grade", Grade);
            },
            9041: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>GradeFilter
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(4780);
                class GradeFilter extends ls.WF {
                    constructor(){
                        super(), this.grade = 0, this.input = "", this.labels = {};
                    }
                    _onInput() {
                        const le1 = [];
                        for (let vt of this.renderRoot.querySelectorAll("input"))vt.checked && le1.push(vt.value);
                        this.grade = le1.join(","), this.dispatchEvent(new CustomEvent("change", {
                            bubbles: !0,
                            composed: !0
                        }));
                    }
                    render() {
                        const le1 = `${this.grade}`.split(",").map((le1)=>parseInt(le1)).filter((le1)=>!isNaN(le1));
                        return [
                            5,
                            4,
                            3,
                            2,
                            1
                        ].map((vt)=>{
                            var bt;
                            return ls.qy`
			<input
				id="${this.input}-${vt}"
				type="checkbox"
				name=${this.input}
				value=${vt}
				@change="${this._onInput}"
				.checked=${le1.includes(vt)}
			/>
			<label
				for="${this.input}-${vt}"
				title=${null !== (bt = this.labels) && void 0 !== bt && bt[vt] ? this.labels[vt] : null}
			>
				${vt} ${(0, ho.fa)(Dl.yy)}
			</label>
		`;
                        });
                    }
                }
                GradeFilter.styles = ls.AH`
		:host {
			gap: 0;
			align-items: stretch;
			display: flex;
		}
		label {
			display: inline-flex;
			padding: 2px 7px;
			background: none;
			border: 1px solid var(--widget-border-btn);
			color: var(--widget-font-direct);
			cursor: pointer;
			font-size: 16px;
			text-decoration: none;
			border-left-width: 0px;
		}
		label:hover {
			background-color: var(--widget-bg-hover);
		}
		label:first-of-type {
			border-top-left-radius: 8px;
			border-bottom-left-radius: 8px;
			border-left-width: 1px;
		}
		label:last-of-type {
			border-top-right-radius: 8px;
			border-bottom-right-radius: 8px;
		}
		label svg {
			display: block;
			width: 0.8em;
		}
		input[type="checkbox"] { display: none; }
		input[type="checkbox"]:checked + label {
			background-color: var(--widget-bg-active);
			color: var(--widget-font-active);
		}
		input[type="checkbox"]:checked + label:first-of-type {
			border-right-color: white;
		}
	`, GradeFilter.properties = {
                    grade: {
                        type: String
                    },
                    input: {
                        type: String
                    },
                    labels: {
                        type: Object
                    }
                }, customElements.define("pnx-grade-filter", GradeFilter);
            },
            438: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>LinkButton
                });
                var ls = bt(4542), ho = bt(8591);
                class LinkButton extends ls.WF {
                    constructor(){
                        super(), this.kind = "full", this.size = "md";
                    }
                    render() {
                        const le1 = document.createElement("a");
                        le1.setAttribute("part", "btn"), this.constructor.observedAttributes.filter((le1)=>void 0 !== this[le1]).forEach((vt)=>le1.setAttribute(vt, this[vt])), le1.classList.add("pnx-btn", `pnx-btn-${this.kind}`, `pnx-btn-${this.size}`);
                        const vt = document.createElement("slot");
                        return le1.appendChild(vt), le1;
                    }
                }
                LinkButton.styles = ho.HM, LinkButton.properties = {
                    href: {
                        type: String
                    },
                    target: {
                        type: String
                    },
                    title: {
                        type: String
                    },
                    download: {
                        type: String
                    },
                    class: {
                        type: String
                    },
                    kind: {
                        type: String
                    },
                    size: {
                        type: String
                    }
                }, customElements.define("pnx-link-button", LinkButton);
            },
            5271: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ListGroup
                });
                var ls = bt(4542), ho = bt(8591);
                class ListGroup extends ls.WF {
                    render() {
                        return ls.qy`<slot></slot>`;
                    }
                }
                ListGroup.styles = [
                    ho.nd,
                    ls.AH`
		:host ::slotted(*) {
			text-decoration: none;
			border: none;
			border-bottom: 1px solid var(--widget-border-div);
			background: none;
			display: block;
			width: 100%;
			color: var(--widget-font);
			font-family: var(--font-family);
			cursor: pointer;
			font-size: 1em;
			font-weight: 400;
			line-height: 18px;
			padding: 5px 10px;
  			min-width: 150px;
			width: 100%;
			text-align: left;
			box-sizing: border-box;
		}

		:host ::slotted(*:hover) {
			background-color: var(--widget-bg-hover);
		}

		:host ::slotted(*:first-child) {
			border-top-left-radius: 5px;
			border-top-right-radius: 5px;
		}

		:host ::slotted(*:last-child) {
			border: none;
			border-bottom-left-radius: 5px;
			border-bottom-right-radius: 5px;
		}
	`
                ], customElements.define("pnx-list-group", ListGroup);
            },
            5525: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ListItem
                });
                var ls = bt(4542);
                class ListItem extends ls.WF {
                    render() {
                        return ls.qy`
			<div class="list-item" title=${this.tooltip}>
				<div class="icon">
					<slot name="icon"></slot>
				</div>
				<div class="content">
					<div class="title">${this.title}</div>
					<div class="subtitle">${this.subtitle}</div>
				</div>
				<div class="action">
					<slot name="action"></slot>
				</div>
			</div>
		`;
                    }
                }
                ListItem.styles = ls.AH`
		.list-item {
			display: flex;
			align-items: center;
			padding: 8px 16px;
			cursor: pointer;
			border-bottom: 1px solid #ddd;
			font-family: var(--font-family);
			background: var(--white);
			min-height: 40px;
			box-sizing: border-box;
		}
		.list-item:hover { background: var(--widget-bg-hover); }
		.icon {
			margin-right: 16px;
			display: flex;
			align-items: center;
			gap: 10px;
			position: relative;
		}
		.action {
			margin-left: 16px;
			display: flex;
  			gap: 5px;
		}
		.content {
			flex: 1;
		}
		.title {
			font-weight: 600;
		}
		.subtitle {
			font-size: 0.9em;
			color: var(--grey-dark);
		}
	`, ListItem.properties = {
                    title: {
                        type: String
                    },
                    subtitle: {
                        type: String
                    },
                    tooltip: {
                        type: String
                    }
                }, customElements.define("pnx-list-item", ListItem);
            },
            3109: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Loader
                });
                var ls = bt(4542), ho = bt(2305), Dl = bt(5975), Fl = bt(7343);
                class Loader extends ls.WF {
                    constructor(){
                        super(), this.visible = !0, this["no-label"] = !1, this._mode = "loading", this._isLabelFun = !1, this.value = -1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._nextLabel();
                    }
                    isVisible() {
                        return this.visible;
                    }
                    dismiss() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null;
                        if (clearTimeout(this._loaderLabelChanger), le1) {
                            var ho;
                            !0 !== le1 && console.error(le1);
                            let sc = [
                                null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t.pnx.error,
                                ls.qy`<br />`
                            ];
                            var Dl, Fl;
                            if (vt && sc.push(vt, ls.qy`<br />`), bt) sc.push(ls.qy`<pnx-button kind="full">${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.error_click}</pnx-button>`), this.addEventListener("click", bt);
                            else sc.push(ls.qy`<small>${null === (Fl = this._parent) || void 0 === Fl ? void 0 : Fl._t.pnx.error_retry}</small>`);
                            this._mode = "error", this._label = sc;
                            const uc = vt || "Panoramax JS had a blocking exception", mc = new CustomEvent("broken", {
                                detail: {
                                    error: uc
                                }
                            });
                            throw this._parent.dispatchEvent(mc), new Error(uc);
                        }
                        {
                            this.value = 100, this._mode = "done", this.visible = !1, this.style.transition = "all 0.5s", setTimeout(()=>this.parentNode.removeChild(this), 2e3);
                            const le1 = new CustomEvent("ready");
                            this._parent.dispatchEvent(le1), bt && bt();
                        }
                    }
                    _nextLabel() {
                        var le1, vt, bt, ls;
                        this._isLabelFun ? this._label = null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.loading_labels_fun[(0, Fl.inRangeRandom)(0, (null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.loading_labels_fun.length) - 1)] : (this._label = null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.loading_labels_serious[(0, Fl.inRangeRandom)(0, (null === (ls = this._parent) || void 0 === ls ? void 0 : ls._t.pnx.loading_labels_serious.length) - 1)], this._isLabelFun = !0);
                        this._loaderLabelChanger = setTimeout(this._nextLabel.bind(this), (0, Fl.inRangeRandom)(500, 1500));
                    }
                    render() {
                        var le1;
                        return "error" == this._mode ? ls.qy`
				<img class="logo-dead" src=${ho} alt="" title=${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.map.loading} />
				${this._label}
			` : ls.qy`
			<pnx-progress-bar .value=${this.value}></pnx-progress-bar>
			${this["no-label"] ? ls.s6 : ls.qy`<div class="label">${this._label}</div>`}
		`;
                    }
                }
                Loader.styles = ls.AH`
		:host {
			position: absolute;
			inset: 0;
			display: flex;
			flex-direction: column;
			justify-content: center;
			gap: 10px;
			align-items: center;
			background-image: url('${(0, ls.iz)(Dl)}');
			background-repeat: no-repeat;
			background-size: cover;
			background-position: center; 
			z-index: 200;
			font-family: var(--font-family);
			font-weight: 550;
			color: var(--black);
			font-size: 1.4em;
			text-align: center;
			visibility: hidden;
			opacity: 0;
		}
		:host(*[visible]) {
			visibility: visible;
			opacity: 1;
		}

		div.label {
			background-color: rgba(255,255,255,0.5);
			box-shadow: white 0 0 10px;
			padding: 3px 10px;
			border-radius: 50px;
		}
		/* Logo */
		img.logo-dead { width: 100px; }
	`, Loader.properties = {
                    _mode: {
                        state: !0
                    },
                    _label: {
                        state: !0
                    },
                    _isLabelFun: {
                        state: !0
                    },
                    visible: {
                        type: Boolean,
                        reflect: !0
                    },
                    "no-label": {
                        type: Boolean
                    },
                    value: {
                        type: Number
                    }
                }, customElements.define("pnx-loader", Loader);
            },
            5642: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Map1
                });
                bt(3041);
                var ls = bt(8340), ho = bt(7343), Dl = bt(6883), Fl = bt(270), sc = bt(4005), uc = bt(1435), mc = bt(5195), gc = (bt(6795), bt(927)), Ac = bt.n(gc), Ec = bt(2968), kc = bt.n(Ec), du = bt(748);
                Ac().workerClass = kc(), Ac().addProtocol("pmtiles", (new du.Zs).tile), Ac().addProtocol("panora", (new uc.A).tile()), Ac().addProtocol("panoras", (new uc.A).tile());
                class Map1 extends Ac().Map {
                    constructor(le1, vt){
                        let bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        var ho;
                        (super({
                            container: vt,
                            style: (0, ls.combineStyles)(le1, bt),
                            center: [
                                0,
                                0
                            ],
                            zoom: 0,
                            maxZoom: 24,
                            attributionControl: !1,
                            dragRotate: !1,
                            pitchWithRotate: !1,
                            touchZoomRotate: !0,
                            touchPitch: !1,
                            doubleClickZoom: !1,
                            canvasContextAttributes: {
                                preserveDrawingBuffer: !le1.isWidthSmall()
                            },
                            transformRequest: le1.api._getMapRequestTransform(),
                            locale: le1._t.maplibre,
                            hash: !1,
                            ...bt
                        }), Ac().addProtocol("sem", new sc.Ay(le1.api).tile()), this._loadMarkerImages(), this._parent = le1, this._options = bt, this.getContainer().classList.add("pnx-map"), void 0 === bt.touchZoomRotate) && (null === this || void 0 === this || null === (ho = this.touchZoomRotate) || void 0 === ho || ho.disableRotation());
                        this._options.raster && (this._options.background = this._options.background || "streets"), (0, mc.initIndoorEqualOnMap)(this), this._attribution = new (Ac()).AttributionControl({
                            compact: !1,
                            ...bt.attributionControl
                        }), this.addControl(this._attribution), this._initMapPosition(), this._picMarker = this._getPictureMarker(), this._picMarkerPreview = this._getPictureMarker(!1), this._picThumbUrl = {}, this._seqPictures = {}, this._userLayers = new Set, this._parent.addEventListener("select", this.reloadLayersStyles.bind(this)), setTimeout(()=>{
                            var le1;
                            !this.loaded() && null !== (le1 = this._parent) && void 0 !== le1 && le1.loader.isVisible() && this._parent.loader.dismiss({}, this._parent._t.map.slow_loading, async ()=>{
                                await this._postLoad(), this._parent.loader.dismiss();
                            });
                        }, 15e3), this.waitForEnoughMapLoaded().then(async ()=>await this._postLoad());
                    }
                    async _postLoad() {
                        this.resize(), await this.setVisibleUsers(this._parent.users), this.reloadLayersStyles(), this.fire("ready");
                    }
                    destroy() {
                        this.remove(), delete this._parent, delete this._options, delete this._attribution, delete this._picMarker, delete this._picMarkerPreview, delete this._picThumbUrl, delete this._seqPictures, delete this._userLayers;
                    }
                    waitForEnoughMapLoaded() {
                        return new Promise((le1)=>{
                            let vt = 0, bt = 0, ls = 0, ho = 0;
                            const onSourceDataLoading = (le1)=>{
                                "source" === le1.dataType && le1.tile && (le1.sourceId.startsWith("geovisio") ? bt++ : vt++);
                            }, onSourceData = (le1)=>{
                                "source" === le1.dataType && le1.tile && (le1.sourceId.startsWith("geovisio") ? (ho++, le1.isSourceLoaded && (ho = bt)) : (ls++, le1.isSourceLoaded && (ls = vt))), checkEnoughLoaded();
                            }, checkEnoughLoaded = ()=>{
                                ls / vt >= .75 && (0 === bt || ho / bt >= .75) && (this.off("sourcedata", onSourceData), this.off("sourcedataloading", onSourceDataLoading), le1());
                            };
                            this.on("sourcedataloading", onSourceDataLoading), this.on("sourcedata", onSourceData);
                        });
                    }
                    _initMapPosition() {
                        !(0, ls.isNullCoordinates)(this._options.center) || this._options.zoom && 0 !== this._options.zoom || this._options.hash || this._parent.onceAPIReady().then(()=>{
                            var le1, vt;
                            let bt = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.api) || void 0 === vt ? void 0 : vt.getDataBbox();
                            if (bt) try {
                                bt = new (Ac()).LngLatBounds(bt), this.loaded() ? this.fitBounds(bt, {
                                    animate: !1
                                }) : this.waitForEnoughMapLoaded().then(()=>this.fitBounds(bt, {
                                        animate: !1
                                    }));
                            } catch (ls) {
                                console.warn("Received invalid bbox: " + bt);
                            }
                        });
                    }
                    _loadMarkerImages() {
                        [
                            {
                                id: "pnx-marker",
                                img: Dl
                            }
                        ].forEach((le1)=>{
                            const vt = new Image(64, 64);
                            vt.onload = ()=>this.addImage(le1.id, vt), vt.src = le1.img;
                        });
                    }
                    _hasQualityScore() {
                        var le1, vt, bt, ls;
                        const ho = (null === (le1 = this.getStyle()) || void 0 === le1 || null === (vt = le1.metadata) || void 0 === vt ? void 0 : vt["panoramax:fields"]) || {};
                        return (null === ho || void 0 === ho || null === (bt = ho.pictures) || void 0 === bt ? void 0 : bt.includes("gps_accuracy")) && (null === ho || void 0 === ho || null === (ls = ho.pictures) || void 0 === ls ? void 0 : ls.includes("h_pixel_density"));
                    }
                    _hasGridStats() {
                        var le1, vt, bt, ls, ho, Dl;
                        const Fl = (null === (le1 = this.getStyle()) || void 0 === le1 || null === (vt = le1.metadata) || void 0 === vt ? void 0 : vt["panoramax:fields"]) || {};
                        return (null === Fl || void 0 === Fl || null === (bt = Fl.grid) || void 0 === bt ? void 0 : bt.includes("nb_360_pictures")) && (null === Fl || void 0 === Fl || null === (ls = Fl.grid) || void 0 === ls ? void 0 : ls.includes("nb_flat_pictures")) && (null === Fl || void 0 === Fl || null === (ho = Fl.grid) || void 0 === ho ? void 0 : ho.includes("coef_360_pictures")) && (null === Fl || void 0 === Fl || null === (Dl = Fl.grid) || void 0 === Dl ? void 0 : Dl.includes("coef_flat_pictures"));
                    }
                    _hasLoggedGridStats() {
                        var le1, vt, bt, ls, ho;
                        const Dl = (null === (le1 = this.getStyle()) || void 0 === le1 || null === (vt = le1.metadata) || void 0 === vt ? void 0 : vt["panoramax:fields"]) || {};
                        return (null === Dl || void 0 === Dl || null === (bt = Dl.grid) || void 0 === bt ? void 0 : bt.includes("logged_coef_360_pictures")) && (null === Dl || void 0 === Dl || null === (ls = Dl.grid) || void 0 === ls ? void 0 : ls.includes("logged_coef_flat_pictures")) && (null === Dl || void 0 === Dl || null === (ho = Dl.grid) || void 0 === ho ? void 0 : ho.includes("logged_coef"));
                    }
                    reloadVectorTiles() {
                        [
                            ...this._userLayers
                        ].forEach((le1)=>{
                            const vt = this.getSource((0, ls.getUserSourceId)(le1));
                            vt.setTiles(vt.tiles);
                        });
                    }
                    hasTwoBackgrounds() {
                        return void 0 !== this.getLayer(ls.RASTER_LAYER_ID);
                    }
                    getBackground() {
                        if (!this.getLayer(ls.RASTER_LAYER_ID)) return "streets";
                        return "visible" == this.getLayoutProperty(ls.RASTER_LAYER_ID, "visibility") ? "aerial" : "streets";
                    }
                    setBackground(le1) {
                        if (!this.getLayer(ls.RASTER_LAYER_ID) && "aerial" === le1) throw new Error("No aerial imagery available");
                        this.getLayer(ls.RASTER_LAYER_ID) && (this.setLayoutProperty(ls.RASTER_LAYER_ID, "visibility", "aerial" === le1 ? "visible" : "none"), this.fire("background-changed", {
                            background: le1 || "streets"
                        }));
                    }
                    getVisibleUsers() {
                        return [
                            ...this._userLayers
                        ].filter((le1)=>this.getLayer((0, ls.getUserLayerId)(le1, "pictures")) && "visible" === this.getLayoutProperty((0, ls.getUserLayerId)(le1, "pictures"), "visibility"));
                    }
                    onceLayerReady(le1) {
                        return this.getLayer(le1) ? Promise.resolve() : new Promise((le1)=>{
                            setTimeout(le1, 250);
                        }).then(()=>this.onceLayerReady(le1));
                    }
                    async setVisibleUsers() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                        "string" === typeof le1 ? le1 = [
                            le1
                        ] : null === le1 && (le1 = []), await Promise.all(le1.filter((le1)=>"" != le1 && !this._userLayers.has(le1)).map((le1)=>(this._createPicturesTilesLayer(le1), this.onceLayerReady((0, ls.getUserLayerId)(le1, "pictures")))));
                        const vt = [
                            "pictures",
                            "sequences",
                            "sequences_plus",
                            "grid"
                        ];
                        [
                            ...this._userLayers
                        ].forEach((bt)=>{
                            vt.forEach((vt)=>{
                                const ho = (0, ls.getUserLayerId)(bt, vt);
                                this.getLayer(ho) && this.setLayoutProperty(ho, "visibility", le1.includes(bt) ? "visible" : "none");
                            });
                        }), this.reloadLayersStyles(), this.fire("users-changed", {
                            usersIds: le1
                        });
                    }
                    filterUserLayersContent(le1, vt) {
                        [
                            ...this._userLayers
                        ].forEach((bt)=>{
                            this.getLayer((0, ls.getUserLayerId)(bt, le1)) ? (this.setFilter((0, ls.getUserLayerId)(bt, le1), vt), "sequences" === le1 && this.getLayer((0, ls.getUserLayerId)(bt, "sequences_plus")) && this.setFilter((0, ls.getUserLayerId)(bt, "sequences_plus"), vt)) : console.warn("Layer", (0, ls.getUserLayerId)(bt, le1), "not ready");
                        });
                    }
                    displayPictureMarker(le1, vt, bt) {
                        let ho = arguments.length > 3 && void 0 !== arguments[3] && arguments[3], Dl = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : null;
                        this._picMarkerPreview.remove(), void 0 !== le1 && void 0 !== vt ? (this._picMarker.setLngLat([
                            le1,
                            vt
                        ]).setRotation(bt).addTo(this), this._picMarker.picId = Dl) : this._picMarker.remove(), this.reloadLayersStyles(), ho || void 0 === le1 || void 0 === vt || this.jumpTo({
                            center: [
                                le1,
                                vt
                            ],
                            zoom: this.getZoom() < ls.TILES_PICTURES_ZOOM + 2 ? ls.TILES_PICTURES_ZOOM + 2 : this.getZoom()
                        });
                    }
                    reloadLayersStyles() {
                        const updateStyle = (le1, vt)=>{
                            [
                                ...this._userLayers
                            ].forEach((bt)=>{
                                const ho = (0, ls.getUserLayerId)(bt, le1);
                                if (this.getLayer(ho)) {
                                    for(let le1 in vt.layout)this.setLayoutProperty(ho, le1, vt.layout[le1]);
                                    for(let le1 in vt.paint)this.setPaintProperty(ho, le1, vt.paint[le1]);
                                } else console.warn("Layer", ho, "not ready");
                            });
                        };
                        [
                            "pictures",
                            "sequences"
                        ].forEach((le1)=>{
                            updateStyle(le1, this._getLayerStyleProperties(le1));
                        });
                    }
                    getFirstPictureLayerID() {
                        return this.getLayersOrder().find((le1)=>le1.startsWith("geovisio_") || le1.endsWith("_sequences"));
                    }
                    addLayer(le1, vt) {
                        !vt && (!(arguments.length > 2 && void 0 !== arguments[2]) || arguments[2]) && (le1.id.startsWith("geovisio_") || le1.id === ls.RASTER_LAYER_ID || le1.source.startsWith("sem-") || (vt = this.getFirstPictureLayerID())), super.addLayer(le1, vt);
                    }
                    addSource(le1, vt) {
                        this.indoorEqual && le1 === this.indoorEqual.source.sourceId && (vt.attribution = '<a href="https://indoorequal.org/" target="_blank">\xa9 indoor=</a>'), super.addSource(le1, vt);
                    }
                    async _createPicturesTilesLayer(le1) {
                        this._userLayers.add(le1);
                        const vt = this.getStyle().layers.find(ls.isLabelLayer);
                        if ("geovisio" !== le1 && !this.getSource(`geovisio_${le1}`)) {
                            const bt = await this._parent.api.getUserMapStyle(le1);
                            Object.entries(bt.sources).forEach((le1)=>{
                                let [vt, bt] = le1;
                                return this.addSource(vt, bt);
                            }), bt.layers = bt.layers || [];
                            bt.layers.concat((0, ls.getMissingLayerStyles)(bt.sources, bt.layers)).filter((le1)=>Object.keys(le1).length > 0).forEach((le1)=>this.addLayer(le1, null === vt || void 0 === vt ? void 0 : vt.id));
                        }
                        this._picPreviewTimer = null, this._picPopup = new (Ac()).Popup({
                            closeButton: !1,
                            closeOnClick: !this._parent.isWidthSmall(),
                            offset: 15
                        });
                        const dropPreview = (le1)=>{
                            clearTimeout(this._picDropPreviewTimer), le1 ? this._picDropPreviewTimer = setTimeout(dropPreview, 250) : (clearTimeout(this._picPreviewTimer), delete this._picPopup._picId, delete this._picPopup._loading, this._picPopup.remove(), this._picMarkerPreview.remove());
                        }, bt = (0, ls.getUserLayerId)(le1, "pictures");
                        this.on("mousemove", bt, (le1)=>{
                            this.getCanvas().style.cursor = "pointer";
                            const vt = Object.assign({}, le1);
                            this._attachPreviewToPictures(vt, bt);
                        }), this.on("mouseleave", bt, ()=>{
                            this.getCanvas().style.cursor = "";
                        }), this.on("click", bt, this._onPictureClick.bind(this));
                        const ho = (0, ls.getUserLayerId)(le1, "sequences_plus");
                        this.on("mousemove", ho, (le1)=>{
                            if (this._onSequenceHover(le1), this.getCanvas().style.cursor = "pointer", le1.features[0].properties.id) {
                                const vt = Object.assign({}, le1);
                                this._attachPreviewToPictures(vt, ho);
                            }
                        }), this.on("mouseleave", ho, ()=>{
                            this.getCanvas().style.cursor = "", dropPreview(!0);
                        }), this.on("click", ho, (le1)=>{
                            le1.preventDefault(), this._onSequenceClick(le1);
                        }), "geovisio" === le1 && this.getLayer("geovisio_grid") && (this.on("mousemove", "geovisio_grid", (le1)=>{
                            if (this.getZoom() <= ls.TILES_PICTURES_ZOOM + 1) {
                                this.getCanvas().style.cursor = "pointer";
                                const vt = Object.assign({}, le1);
                                this._attachPreviewToPictures(vt, "geovisio_grid");
                            }
                        }), this.on("mouseleave", "geovisio_grid", ()=>{
                            dropPreview(), this.getCanvas().style.cursor = "";
                        }), this.on("click", "geovisio_grid", (le1)=>{
                            le1.preventDefault(), this.flyTo({
                                center: le1.lngLat,
                                zoom: ls.TILES_PICTURES_ZOOM - 6
                            });
                        })), this.on("dblclick", ()=>clearTimeout(this._gridFocus)), this.on("click", (le1)=>{
                            var vt, bt;
                            (clearTimeout(this._gridFocus), !1 === le1.defaultPrevented) && (dropPreview(), null !== (vt = (bt = this._parent).isMapWide) && void 0 !== vt && vt.call(bt) && (this._gridFocus = setTimeout(()=>{
                                var le1, vt;
                                return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.grid) || void 0 === vt ? void 0 : vt.toggleAway();
                            }, 250)));
                        });
                        const untoggleGridWidgets = ()=>{
                            var le1, vt, bt, ls;
                            null !== (le1 = (vt = this._parent).isMapWide) && void 0 !== le1 && le1.call(vt) && null !== (bt = this._parent) && void 0 !== bt && null !== (ls = bt.grid) && void 0 !== ls && ls._hidden && (clearTimeout(this._gridFocus), this._parent.grid.toggleAway(!0));
                        };
                        this.on("mousemove", untoggleGridWidgets), this.on("touchmove", untoggleGridWidgets);
                    }
                    _getLayerStyleProperties(le1) {
                        const vt = {
                            pictures: "circle",
                            sequences: "line"
                        }, bt = {
                            paint: Object.assign({
                                [`${vt[le1]}-color`]: this._getLayerColorStyle(le1)
                            }, ls.VECTOR_STYLES[le1.toUpperCase()].paint),
                            layout: Object.assign({
                                [`${vt[le1]}-sort-key`]: this._getLayerSortStyle(le1)
                            }, ls.VECTOR_STYLES[le1.toUpperCase()].layout)
                        };
                        return "pictures" === le1 && (bt.paint["circle-stroke-color"] = this._getLayerColorStyle(le1)), bt;
                    }
                    _getLayerColorStyle(le1) {
                        const vt = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            ho.COLORS.HIDDEN,
                            [
                                "==",
                                [
                                    "get",
                                    "geovisio:status"
                                ],
                                "hidden"
                            ],
                            ho.COLORS.HIDDEN
                        ], bt = this._parent.sequence;
                        return "sequences" == le1 && bt ? vt.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            bt
                        ], ho.COLORS.SELECTED) : le1.startsWith("pictures") && bt && vt.push([
                            "in",
                            bt,
                            [
                                "get",
                                "sequences"
                            ]
                        ], ho.COLORS.SELECTED), vt.push(ho.COLORS.BASE), vt;
                    }
                    _getLayerSortStyle(le1) {
                        const vt = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            90
                        ], bt = this._parent.sequence;
                        return "sequences" == le1 && bt ? vt.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            bt
                        ], 100) : le1.startsWith("pictures") && bt && vt.push([
                            "in",
                            bt,
                            [
                                "get",
                                "sequences"
                            ]
                        ], 100), vt.push(10), vt;
                    }
                    _attachPreviewToPictures(le1, vt) {
                        var bt, ho;
                        let Dl = le1.features.pop();
                        if (!Dl || Dl.properties.id == this._picPopup._picId) return;
                        clearTimeout(this._picPreviewTimer), clearTimeout(this._picDropPreviewTimer), this._picPopup._loading = Dl.properties.id, this._picPopup._picId = Dl.properties.id, delete this._picPopup._seqId;
                        let Fl = null;
                        if (vt.includes("_pictures")) Fl = Dl;
                        else if (vt.includes("_sequences")) {
                            const vt = this.getLayersOrder().find((le1)=>le1.endsWith("_pictures"));
                            if (vt) {
                                const bt = this.queryRenderedFeatures(this.getBounds(), {
                                    layers: [
                                        vt
                                    ]
                                });
                                let ls = null;
                                for(let vt = 0; vt < bt.length; vt++){
                                    let ho = le1.lngLat.distanceTo(new (Ac()).LngLat(...bt[vt].geometry.coordinates));
                                    (!ls || ho < ls) && (Fl = bt[vt], ls = ho);
                                }
                            }
                        }
                        var sc, uc, mc, gc;
                        Fl ? (this._picPopup._seqId = Fl.properties.first_sequence, null === (sc = (uc = this._picMarkerPreview).setLngLat) || void 0 === sc || sc.call(uc, Fl.geometry.coordinates).setRotation(Fl.properties.heading || 0).addTo(this)) : null === (mc = this._picMarkerPreview) || void 0 === mc || null === (gc = mc.remove) || void 0 === gc || gc.call(mc);
                        let Ec = Fl ? Fl.geometry.coordinates : le1.lngLat;
                        this._picPopup.setLngLat(Ec).addTo(this), Fl || this._picThumbUrl[Dl.properties.id] || this._picPopup.setDOMContent((0, ls.getThumbGif)(this._parent._t));
                        const displayThumb = (le1)=>{
                            if (this._picPopup._loading === Dl.properties.id) {
                                if (le1) {
                                    let vt = document.createElement("img");
                                    vt.classList.add("pnx-map-thumb"), vt.alt = this._parent._t.map.thumbnail;
                                    let bt = new Image;
                                    if (bt.src = le1, bt.addEventListener("load", ()=>{
                                        this._picPopup._loading === Dl.properties.id && (Dl.properties.hidden ? vt.children[0].src = bt.src : vt.src = bt.src, this._picPopup.setDOMContent(vt), delete this._picPopup._loading);
                                    }), Dl.properties.hidden) {
                                        const le1 = document.createElement("div");
                                        le1.classList.add("pnx-map-thumb-legend"), le1.appendChild(document.createTextNode(this._parent._t.map.not_public));
                                        const bt = document.createElement("div");
                                        bt.appendChild(vt), bt.appendChild(le1), vt = bt;
                                    }
                                } else this._picPopup.remove();
                            }
                        };
                        var kc, du;
                        this._picPopup._loading === Dl.properties.id && (this._picThumbUrl[(null === (bt = Fl) || void 0 === bt || null === (ho = bt.properties) || void 0 === ho ? void 0 : ho.id) || Dl.properties.id] ? displayThumb(this._picThumbUrl[(null === (kc = Fl) || void 0 === kc || null === (du = kc.properties) || void 0 === du ? void 0 : du.id) || Dl.properties.id]) : (clearTimeout(this._picPreviewTimer), this._picPreviewTimer = setTimeout(()=>{
                            this._picPopup._loading === Dl.properties.id && (Fl ? this._getPictureThumbURL(Fl.properties.id, Fl.properties.collection).then(displayThumb) : vt.endsWith("_grid") ? this._getThumbURL(Ec).then(displayThumb) : vt.includes("_sequences") && this._getSequenceThumbURL(Dl.properties.id, Ec).then(displayThumb));
                        }, 50)));
                    }
                    _getThumbURL(le1) {
                        return this._parent.api.getPicturesAroundCoordinates(le1.lat, le1.lng, .1, 1).then((le1)=>{
                            var vt;
                            const bt = null === le1 || void 0 === le1 || null === (vt = le1.features) || void 0 === vt ? void 0 : vt.pop();
                            return bt ? this._parent.api.findThumbnailInPictureFeature(bt) : null;
                        });
                    }
                    _getSequenceThumbURL(le1, vt) {
                        return vt ? this._parent.api.getPicturesAroundCoordinates(vt.lat, vt.lng, 1, 1, le1).then((vt)=>{
                            var bt;
                            return (null === vt || void 0 === vt || null === (bt = vt.features) || void 0 === bt ? void 0 : bt.length) > 0 ? this._parent.api.findThumbnailInPictureFeature(vt.features[0]) : this._parent.api.getPictureThumbnailURLForSequence(le1);
                        }) : this._parent.api.getPictureThumbnailURLForSequence(le1);
                    }
                    _getPictureThumbURL(le1, vt) {
                        let bt = null;
                        return le1 && (void 0 !== this._picThumbUrl[le1] ? bt = "string" === typeof this._picThumbUrl[le1] ? Promise.resolve(this._picThumbUrl[le1]) : this._picThumbUrl[le1] : (this._picThumbUrl[le1] = this._parent.api.getPictureThumbnailURL(le1, vt).then((vt)=>vt ? (this._picThumbUrl[le1] = vt, vt) : (this._picThumbUrl[le1] = null, null)).catch(()=>{
                            this._picThumbUrl[le1] = null;
                        }), bt = this._picThumbUrl[le1])), bt;
                    }
                    _getPictureMarker() {
                        let le1 = !(arguments.length > 0 && void 0 !== arguments[0]) || arguments[0];
                        const vt = document.createElement("img");
                        return vt.src = le1 ? Fl : Dl, vt.alt = "", new (Ac()).Marker({
                            element: vt,
                            picId: null
                        }).setDraggable(le1 && this._options.picMarkerDraggable);
                    }
                    _onSequenceHover(le1) {
                        var vt;
                        le1.preventDefault(), le1.features.length > 0 && null !== (vt = le1.features[0].properties) && void 0 !== vt && vt.id && this.fire("sequence-hover", {
                            seqId: le1.features[0].properties.id
                        });
                    }
                    _onSequenceClick(le1) {
                        var vt;
                        if (le1.preventDefault(), le1.originalEvent.stopImmediatePropagation(), "pic" !== (null === (vt = this._parent.psv) || void 0 === vt ? void 0 : vt.getPicturesNavigation()) && le1.features.length > 0) {
                            var bt;
                            let vt = le1.features[0];
                            le1.features.length > 1 && this._picPopup._seqId && (vt = le1.features.find((le1)=>le1.properties.id === this._picPopup._seqId) || vt), null !== (bt = vt.properties) && void 0 !== bt && bt.id && this.fire("sequence-click", {
                                seqId: vt.properties.id,
                                coordinates: le1.lngLat
                            });
                        }
                    }
                    _onPictureClick(le1) {
                        var vt, bt, ls;
                        if (le1.preventDefault(), le1.originalEvent.stopImmediatePropagation(), "pic" === (null === (vt = this._parent.psv) || void 0 === vt ? void 0 : vt.getPicturesNavigation())) return;
                        const ho = this.queryRenderedFeatures(le1.point);
                        if (ho.length > 1 && ho.find((le1)=>{
                            var vt;
                            return null === le1 || void 0 === le1 || null === (vt = le1.source) || void 0 === vt ? void 0 : vt.startsWith("sem-");
                        })) return;
                        const Dl = (null === le1 || void 0 === le1 || null === (bt = le1.features) || void 0 === bt ? void 0 : bt.length) > 0 ? le1.features[0] : null;
                        if (null !== Dl && void 0 !== Dl && null !== (ls = Dl.properties) && void 0 !== ls && ls.id) {
                            let vt = null;
                            try {
                                Dl.properties.sequences && (Array.isArray(Dl.properties.sequences) || (Dl.properties.sequences = JSON.parse(Dl.properties.sequences)), vt = Dl.properties.sequences.pop());
                            } catch (le1) {
                                console.log("Sequence ID is not available in vector tiles for picture " + Dl.properties.id);
                            }
                            this.fire("picture-click", {
                                picId: Dl.properties.id,
                                seqId: vt,
                                feature: Dl
                            });
                        }
                    }
                    addEventListener(le1, vt) {
                        let bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        null !== bt && void 0 !== bt && bt.once ? this.once(le1, vt) : this.on(le1, vt);
                    }
                }
            },
            2771: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapMore,
                    T: ()=>uc
                });
                var ls = bt(5642), ho = bt(7343), Dl = bt(8340), Fl = bt(2283), sc = bt(4005);
                const uc = [
                    "minDate",
                    "maxDate",
                    "pic_type",
                    "camera",
                    "theme",
                    "qualityscore",
                    "gps"
                ];
                class MapMore extends ls.A {
                    constructor(le1, vt){
                        super(le1, vt, arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {}), this._mapFilters = {}, this._options.theme && (this._mapFilters = {
                            theme: this._options.theme
                        }), this._featuresRestrict = {
                            pictures: {},
                            sequences: {}
                        };
                    }
                    async _postLoad() {
                        this._parent.api._endpoints.queryables && Fl.SEMANTICS_OVERLAYS.forEach((le1)=>this.addSemanticOverlay(...le1)), await super._postLoad();
                    }
                    reloadLayersStyles() {
                        if (super.reloadLayersStyles(), this._hasGridStats()) {
                            let le1 = "coef";
                            this._mapFilters.pic_type && (le1 = "flat" == this._mapFilters.pic_type ? "coef_flat_pictures" : "coef_360_pictures", this._hasLoggedGridStats() && (0, ho.getUserAccount)() && (le1 = "logged_" + le1)), this.getStyle().layers.filter((le1)=>le1.id.endsWith("_grid")).forEach((vt)=>{
                                const bt = (0, Dl.switchCoefValue)(vt, le1);
                                for(let le1 in bt.layout)this.setLayoutProperty(vt.id, le1, bt.layout[le1]);
                                for(let le1 in bt.paint)this.setPaintProperty(vt.id, le1, bt.paint[le1]);
                            });
                        }
                    }
                    _getDatesForLayerColors() {
                        const le1 = 864e5, vt = Date.now();
                        return [
                            vt - 30 * le1,
                            vt - 365 * le1,
                            vt - 730 * le1
                        ].map((le1)=>new Date(le1).toISOString().split("T")[0]);
                    }
                    _getLayerColorStyle(le1) {
                        var vt, bt, ls, Fl, sc, uc, mc, gc;
                        const Ac = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            ho.COLORS.HIDDEN
                        ], Ec = (null === (vt = this._parent.psv) || void 0 === vt || null === (bt = vt._myVTour) || void 0 === bt || null === (ls = bt.state) || void 0 === ls ? void 0 : ls.loadingNode) || (null === (Fl = this._parent.psv) || void 0 === Fl || null === (sc = Fl._myVTour) || void 0 === sc || null === (uc = sc.state) || void 0 === uc || null === (mc = uc.currentNode) || void 0 === mc ? void 0 : mc.id), kc = Ec ? null === (gc = this._parent.psv) || void 0 === gc ? void 0 : gc._picturesSequences[Ec] : null;
                        if ("sequences" == le1 && kc ? Ac.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            kc
                        ], ho.COLORS.SELECTED) : "pictures" == le1 && kc && Ac.push([
                            "in",
                            kc,
                            [
                                "get",
                                "sequences"
                            ]
                        ], ho.COLORS.SELECTED), this._mapFilters.theme == Dl.MAP_THEMES.AGE) {
                            const vt = "sequences" == le1 ? "date" : "ts", bt = this._getDatesForLayerColors();
                            Ac.push([
                                "!",
                                [
                                    "has",
                                    vt
                                ]
                            ], ho.COLORS.BASE, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[0]
                            ], ho.COLORS.PALETTE_4, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[1]
                            ], ho.COLORS.PALETTE_3, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[2]
                            ], ho.COLORS.PALETTE_2, ho.COLORS.PALETTE_1);
                        } else this._mapFilters.theme == Dl.MAP_THEMES.TYPE ? Ac.push([
                            "!",
                            [
                                "has",
                                "type"
                            ]
                        ], ho.COLORS.BASE, [
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            "equirectangular"
                        ], ho.COLORS.QUALI_1, ho.COLORS.QUALI_2) : this._mapFilters.theme == Dl.MAP_THEMES.SCORE ? Ac.push([
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            5
                        ], ho.QUALITYSCORE_VALUES[0].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            4
                        ], ho.QUALITYSCORE_VALUES[1].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            3
                        ], ho.QUALITYSCORE_VALUES[2].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            2
                        ], ho.QUALITYSCORE_VALUES[3].color, ho.QUALITYSCORE_VALUES[4].color) : this._mapFilters.theme == Dl.MAP_THEMES.GPS ? Ac.push([
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            5
                        ], ho.GPS_VALUES[0].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            4
                        ], ho.GPS_VALUES[1].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            3
                        ], ho.GPS_VALUES[2].color, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            2
                        ], ho.GPS_VALUES[3].color, ho.GPS_VALUES[4].color) : Ac.push(ho.COLORS.BASE);
                        return Ac;
                    }
                    _getLayerSortStyle(le1) {
                        var vt, bt, ls, ho, Fl, sc, uc, mc;
                        const gc = [
                            "case",
                            [
                                "==",
                                [
                                    "get",
                                    "hidden"
                                ],
                                !0
                            ],
                            90
                        ], Ac = (null === (vt = this._parent.psv) || void 0 === vt || null === (bt = vt._myVTour) || void 0 === bt || null === (ls = bt.state) || void 0 === ls ? void 0 : ls.loadingNode) || (null === (ho = this._parent.psv) || void 0 === ho || null === (Fl = ho._myVTour) || void 0 === Fl || null === (sc = Fl.state) || void 0 === sc || null === (uc = sc.currentNode) || void 0 === uc ? void 0 : uc.id), Ec = Ac ? null === (mc = this._parent.psv) || void 0 === mc ? void 0 : mc._picturesSequences[Ac] : null;
                        if ("sequences" == le1 && Ec ? gc.push([
                            "==",
                            [
                                "get",
                                "id"
                            ],
                            Ec
                        ], 100) : "pictures" == le1 && Ec && gc.push([
                            "in",
                            Ec,
                            [
                                "get",
                                "sequences"
                            ]
                        ], 100), this._mapFilters.theme == Dl.MAP_THEMES.AGE) {
                            const vt = "sequences" == le1 ? "date" : "ts", bt = this._getDatesForLayerColors();
                            gc.push([
                                "!",
                                [
                                    "has",
                                    vt
                                ]
                            ], 0, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[0]
                            ], 50, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[1]
                            ], 49, [
                                ">=",
                                [
                                    "get",
                                    vt
                                ],
                                bt[2]
                            ], 48);
                        } else this._mapFilters.theme == Dl.MAP_THEMES.TYPE ? gc.push([
                            "!",
                            [
                                "has",
                                "type"
                            ]
                        ], 0, [
                            "==",
                            [
                                "get",
                                "type"
                            ],
                            "equirectangular"
                        ], 50) : this._mapFilters.theme == Dl.MAP_THEMES.SCORE ? gc.push([
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            5
                        ], 80, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            4
                        ], 65, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            3
                        ], 50, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            2
                        ], 35, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE,
                            1
                        ], 20) : this._mapFilters.theme == Dl.MAP_THEMES.GPS && gc.push([
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            5
                        ], 80, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            4
                        ], 65, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            3
                        ], 50, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            2
                        ], 35, [
                            "==",
                            Dl.MAP_EXPR_QUALITYSCORE_GPS,
                            1
                        ], 20);
                        return gc.push(10), gc;
                    }
                    setFilters(le1) {
                        let vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], { mapFilters: bt, mapSeqFilters: ls, mapPicFilters: ho, reloadMapStyle: Fl } = (0, Dl.mapFiltersToLayersFilters)(le1, this._hasGridStats(), this._featuresRestrict);
                        this._mapFilters = bt, Fl && this.reloadLayersStyles();
                        const sc = this.getVisibleUsers().includes("geovisio");
                        ls && sc && (ls = [
                            "step",
                            [
                                "zoom"
                            ],
                            !0,
                            7,
                            ls
                        ]), this.filterUserLayersContent("sequences", ls), this.filterUserLayersContent("pictures", ho), !vt && (null !== ls || null !== ho || null !== this._mapFilters.theme && this._mapFilters.theme !== Dl.MAP_THEMES.DEFAULT) && sc && this.getZoom() < 7 && !this._hasGridStats() && this.easeTo({
                            zoom: 7
                        }), this.fire("filters-changed", Object.assign({}, this._mapFilters));
                    }
                    restrictVisibleFeatures(le1, vt, bt) {
                        this._featuresRestrict[vt] = {
                            rule: le1,
                            features: bt
                        };
                        let { mapSeqFilters: ls, mapPicFilters: ho, reloadMapStyle: Fl } = (0, Dl.mapFiltersToLayersFilters)(this._mapFilters, this._hasGridStats(), this._featuresRestrict);
                        Fl && this.reloadLayersStyles(), this.filterUserLayersContent("sequences", ls), this.filterUserLayersContent("pictures", ho);
                    }
                    async setVisibleUsers() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [];
                        await super.setVisibleUsers(le1);
                        let { mapSeqFilters: vt, mapPicFilters: bt, reloadMapStyle: ls } = (0, Dl.mapFiltersToLayersFilters)(this._mapFilters, this._hasGridStats(), this._featuresRestrict);
                        ls && this.reloadLayersStyles();
                        const ho = le1.includes("geovisio");
                        vt && ho && (vt = [
                            "step",
                            [
                                "zoom"
                            ],
                            !0,
                            7,
                            vt
                        ]), this.filterUserLayersContent("sequences", vt), this.filterUserLayersContent("pictures", bt);
                    }
                    addSemanticOverlay(le1, vt, bt) {
                        let ls = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : {};
                        if (!this._parent.api._endpoints.queryables) throw new Error("Semantics overlay are not available on API");
                        Object.entries(ls || {}).forEach((le1)=>{
                            let [vt, bt] = le1;
                            return this.addSprite(vt, bt);
                        });
                        const ho = "sem-" + le1;
                        this.addSource(ho, {
                            type: "vector",
                            tiles: [
                                `sem:///${vt}/{z}/{x}/{y}`
                            ],
                            minzoom: sc.lU,
                            maxzoom: sc.nu
                        }), this.addLayer({
                            id: le1,
                            source: ho,
                            "source-layer": "layer",
                            ...bt
                        }), this.on("click", le1, (le1)=>{
                            var vt;
                            if (le1.preventDefault(), (null === le1 || void 0 === le1 || null === (vt = le1.features) || void 0 === vt ? void 0 : vt.length) > 0) {
                                const vt = le1.features[0];
                                this._parent.select(vt.properties.seqid, vt.properties.picid), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                    var le1, vt;
                                    const bt = this._parent.psv.getPictureMetadata();
                                    1 === (null === (le1 = bt.properties) || void 0 === le1 || null === (vt = le1.annotations) || void 0 === vt ? void 0 : vt.length) && this._parent.psv.focusOnAnnotation(bt.properties.annotations[0].id);
                                }, {
                                    once: !0
                                });
                            }
                        });
                    }
                    getSemanticOverlays() {
                        return this.getStyle().layers.filter((le1)=>{
                            var vt;
                            return null === (vt = le1.source) || void 0 === vt ? void 0 : vt.startsWith("sem-");
                        });
                    }
                    toggleAllSemanticOverlays(le1) {
                        this.getSemanticOverlays().forEach((vt)=>vt.metadata && this.setLayoutProperty(vt.id, "visibility", le1 ? "visible" : "none"));
                    }
                }
            },
            9048: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Ay: ()=>Photo,
                    LM: ()=>du,
                    Vf: ()=>_u,
                    cS: ()=>kc
                });
                bt(5003);
                var ls = bt(5975), ho = bt(2305), Dl = bt(7343), Fl = bt(508), sc = (bt(3961), bt(1080), bt(2710), bt(1575), bt(1545)), uc = bt(3348), mc = bt(4991), gc = bt(3727);
                const Ac = {
                    baseUrl: ls,
                    width: 1280,
                    cols: 2,
                    rows: 1,
                    tileUrl: ()=>null
                }, Ec = {
                    id: Dl.BASE_PANORAMA_ID,
                    caption: "",
                    panorama: Ac,
                    links: [],
                    gps: [
                        0,
                        0
                    ],
                    sequence: {},
                    sphereCorrection: {},
                    horizontalFov: 360,
                    properties: {}
                }, kc = 30, du = 250, _u = 3e3, Md = "draw-annotation-1", Ld = "draw-annotation-2", Nd = "draw-annotation-r", Rd = "rgb(224, 64, 251)", Od = "rgb(224, 64, 251, 0.5)", jd = "rgb(123, 31, 162)", Ud = "rgba(123, 31, 162, 0.5)";
                sc.jM.useNewAnglesOrder = !0;
                class Photo extends sc.jM {
                    constructor(le1, vt){
                        var bt;
                        let ls = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        super({
                            container: vt,
                            adapter: [
                                gc.A,
                                {
                                    showErrorTile: !1,
                                    baseBlur: !1,
                                    resolution: le1.isWidthSmall() ? 32 : 64,
                                    shouldGoFast: (null === ls || void 0 === ls ? void 0 : ls.shouldGoFast) || (()=>!1),
                                    useXmpData: !1
                                }
                            ],
                            withCredentials: le1.api._getPSVWithCredentials(),
                            requestHeaders: null === le1 || void 0 === le1 || null === (bt = le1["fetch-options"]) || void 0 === bt ? void 0 : bt.headers,
                            panorama: Ac,
                            lang: le1._t.psv,
                            minFov: 5,
                            loadingTxt: "&nbsp;",
                            navbar: null,
                            rendererParameters: {
                                preserveDrawingBuffer: !le1.isWidthSmall()
                            },
                            plugins: [
                                [
                                    uc.$,
                                    {
                                        dataMode: "server",
                                        positionMode: "gps",
                                        renderMode: "3d",
                                        preload: !0,
                                        getNode: ()=>{},
                                        transitionOptions: ()=>{},
                                        arrowsPosition: {
                                            linkOverlapAngle: Math.PI / 6
                                        }
                                    }
                                ],
                                [
                                    mc.b,
                                    {}
                                ]
                            ],
                            ...ls
                        }), this._parent = le1, this._options = ls, vt.classList.add("pnx-psv"), this._shouldGoFast = (null === ls || void 0 === ls ? void 0 : ls.shouldGoFast) || (()=>!1), this._transitionDuration = (null === ls || void 0 === ls ? void 0 : ls.transitionDuration) || du, this._myVTour = this.getPlugin(uc.$), this._myVTour.datasource.nodeResolver = this._getNodeFromAPI.bind(this), this._myVTour.config.transitionOptions = this._psvNodeTransition.bind(this), this._clearArrows = this._myVTour.arrowsRenderer.clear.bind(this._myVTour.arrowsRenderer), this._myVTour.arrowsRenderer.clear = ()=>{}, this._myMarkers = this.getPlugin(mc.b), this._annotationsVisible = !0 === this._options.displayAnnotations, this._drawingAnnotation = null, this._sequencePlaying = !1, this._picturesNavigation = this._options.picturesNavigation || "any", this._picturesSequences = {}, this._myVTour.addEventListener("enter-arrow", this._onEnterArrow.bind(this)), this._myVTour.addEventListener("leave-arrow", this._onLeaveArrow.bind(this)), this._myVTour.addEventListener("node-changed", this._onNodeChanged.bind(this)), this._myMarkers.addEventListener("select-marker", this._onSelectMarker.bind(this)), this.addEventListener("position-updated", this._onPositionUpdated.bind(this)), this.addEventListener("zoom-updated", this._onZoomUpdated.bind(this)), this.addEventListener("dblclick", this._onDoubleClick.bind(this)), this._parent.addEventListener("select", this._onSelect.bind(this)), this.loader.size = 150, this.loader.color = "rgba(61, 61, 61, 0.5)", this.loader.textColor = "rgba(255, 255, 255, 0.7)", this.loader.border = 5, this.loader.thickness = 10, this.loader.canvas.setAttribute("viewBox", "0 0 150 150"), this.loader.__updateContent(), this._options.position && !this._parent.picture && this.goToPosition(...this._options.position);
                    }
                    async _getNodeFromAPI(le1) {
                        var vt, bt;
                        if ((0, Dl.isNullId)(le1)) return Ec;
                        const ls = await fetch(this._parent.api.getPictureMetadataUrl(le1, this._picturesSequences[le1]), this._parent.api._getFetchOptions());
                        let ho = await ls.json();
                        if (ho.features && (ho = ho.features.pop()), !ho || 0 === Object.keys(ho).length || !ls.ok) throw this._parent.loader && this._parent.loader.dismiss(!0, this._parent._t.pnx.error_pic), new Error("Picture with ID " + le1 + " was not found");
                        this._picturesSequences[le1] = ho.collection;
                        const sc = (0, Fl.apiFeatureToPSVNode)(ho, this._parent._t, this._parent._isInternetFast, this._picturesNavFilter.bind(this), this._parent.api.cleanResourceURL.bind(this._parent.api));
                        var uc, mc;
                        null !== sc && void 0 !== sc && null !== (vt = sc.sequence) && void 0 !== vt && vt.prevPic && (this._picturesSequences[null === sc || void 0 === sc || null === (uc = sc.sequence) || void 0 === uc ? void 0 : uc.prevPic] = ho.collection);
                        null !== sc && void 0 !== sc && null !== (bt = sc.sequence) && void 0 !== bt && bt.nextPic && (this._picturesSequences[null === sc || void 0 === sc || null === (mc = sc.sequence) || void 0 === mc ? void 0 : mc.nextPic] = ho.collection);
                        return sc;
                    }
                    _psvNodeTransition(le1, vt, bt) {
                        var ls, ho, Fl;
                        let sc = {};
                        const uc = this._shouldGoFast() ? 0 : Math.min(du, this._transitionDuration), mc = uc > 100, gc = null != (bt || (null === vt || void 0 === vt ? void 0 : vt.links.find((vt)=>vt.nodeId == le1.id))), Ac = vt && le1.sequence.id === vt.sequence.id, Ec = ((null === vt || void 0 === vt || null === (ls = vt.properties) || void 0 === ls ? void 0 : ls["view:azimuth"]) || 0) * (Math.PI / 180), _u = ((null === le1 || void 0 === le1 || null === (ho = le1.properties) || void 0 === ho ? void 0 : ho["view:azimuth"]) || 0) * (Math.PI / 180), Md = (0, Dl.getRelativeHeading)(le1) * (Math.PI / 180);
                        this.setOption("maxFov", Math.min(3 * le1.horizontalFov / 4, 90));
                        const Ld = {
                            showLoader: !1,
                            effect: "none",
                            speed: 0,
                            rotation: !1,
                            rotateTo: {
                                pitch: 0,
                                yaw: -Md
                            },
                            zoomTo: kc
                        };
                        if (360 == le1.horizontalFov) sc = vt ? (0, Dl.getDistance)(vt.gps, le1.gps) >= .001 ? Ld : {
                            speed: uc,
                            effect: gc && mc ? "fade" : "none",
                            rotation: gc && Ac && mc,
                            rotateTo: this.getPosition()
                        } : Ld;
                        else if (Ac) {
                            const le1 = this.getPosition().yaw, bt = vt.horizontalFov * (Math.PI / 180) / 2, ls = le1 <= bt || le1 >= 2 * Math.PI - bt, ho = Math.abs(Ec - _u) <= Math.PI / 4;
                            sc = {
                                speed: uc,
                                effect: gc && ho && mc ? "fade" : "none",
                                rotation: gc && ho && mc,
                                rotateTo: ls ? this.getPosition() : {
                                    pitch: 0,
                                    yaw: 0
                                },
                                zoomTo: ls ? this.getZoomLevel() : kc
                            };
                        } else sc = Object.assign(Ld, {
                            rotateTo: {
                                pitch: 0,
                                yaw: 0
                            }
                        });
                        "fade" === sc.effect && sc.speed >= 150 ? setTimeout(this._clearArrows, sc.speed - 100) : this._clearArrows();
                        const Nd = new CustomEvent("picture-loading", {
                            detail: {
                                ...Object.assign({}, this.getXYZ(), sc.rotateTo ? {
                                    x: 180 * (_u + sc.rotateTo.yaw) / Math.PI
                                } : null, sc.zoomTo ? {
                                    z: sc.zoomTo
                                } : null),
                                picId: le1.id,
                                lon: le1.gps[0],
                                lat: le1.gps[1],
                                first: (null === (Fl = this._parent._initParams) || void 0 === Fl ? void 0 : Fl.getParentPostInit().picture) == le1.id
                            }
                        });
                        return this.dispatchEvent(Nd), sc;
                    }
                    _onEnterArrow(le1) {
                        const vt = le1.link, bt = le1.node;
                        let ls;
                        bt && (ls = 360 === bt.horizontalFov ? (this.getPictureOriginalHeading() + 180 * this.getPosition().yaw / Math.PI) % 360 : this.getPictureOriginalHeading());
                        const ho = new CustomEvent("picture-preview-started", {
                            detail: {
                                picId: vt.nodeId,
                                coordinates: vt.gps,
                                direction: ls
                            }
                        });
                        this.dispatchEvent(ho);
                    }
                    _onLeaveArrow(le1) {
                        const vt = le1.link, bt = new CustomEvent("picture-preview-stopped", {
                            detail: {
                                picId: vt.nodeId
                            }
                        });
                        this.dispatchEvent(bt);
                    }
                    _onPositionUpdated(le1) {
                        let { position: vt } = le1;
                        const bt = (0, Dl.positionToXYZ)(vt, this.getZoomLevel());
                        bt.x += this.getPictureOriginalHeading(), bt.x = bt.x % 360;
                        const ls = new CustomEvent("view-rotated", {
                            detail: bt
                        });
                        this.dispatchEvent(ls), this._onTilesStartLoading();
                    }
                    _onZoomUpdated(le1) {
                        let { zoomLevel: vt } = le1;
                        const bt = new CustomEvent("view-rotated", {
                            detail: {
                                ...this.getXY(),
                                z: vt
                            }
                        });
                        this.dispatchEvent(bt), this._onTilesStartLoading();
                    }
                    _onDoubleClick() {
                        this.unfocusAnnotation(!1, !0);
                    }
                    _onNodeChanged(le1) {
                        for (let ho of document.getElementsByClassName("pnx-psv-tour-arrows"))ho.classList.remove("pnx-clicked");
                        if (le1.node.id) {
                            var vt, bt, ls;
                            const ho = (null === (vt = this._parent._initParams) || void 0 === vt ? void 0 : vt.getParentPostInit().picture) == le1.node.id;
                            this._parent.select(null === (bt = le1.node) || void 0 === bt || null === (ls = bt.sequence) || void 0 === ls ? void 0 : ls.id, le1.node.id);
                            const Dl = this.getPictureMetadata();
                            if (!Dl) return void this.dispatchEvent(new CustomEvent("picture-loaded", {
                                detail: {}
                            }));
                            this._prevSequence = Dl.sequence.id;
                            const Fl = new CustomEvent("picture-loaded", {
                                detail: {
                                    ...this.getXYZ(),
                                    picId: le1.node.id,
                                    lon: Dl.gps[0],
                                    lat: Dl.gps[1],
                                    first: ho
                                }
                            });
                            this.dispatchEvent(Fl), Dl.panorama.hdUrl ? (this.setOption("downloadUrl", Dl.panorama.hdUrl), this.setOption("downloadName", le1.node.id + ".jpg")) : this.setOption("downloadUrl", null), this._annotationsVisible && this.toggleAllAnnotations(!0);
                        }
                        this._onTilesStartLoading();
                    }
                    _onSelectMarker(le1) {
                        var vt;
                        if (le1.marker && null !== (vt = le1.marker.id) && void 0 !== vt && vt.startsWith("annotation-")) {
                            if (this.getSelectedAnnotations().find((le1)=>{
                                var vt, bt, ls;
                                return null === (vt = this._myMarkers.markers["annotation-" + le1]) || void 0 === vt || null === (bt = vt.config) || void 0 === bt || null === (ls = bt.data) || void 0 === ls ? void 0 : ls.blockFocus;
                            })) return;
                            this.focusOnAnnotation(le1.marker.data.id);
                        }
                    }
                    _onTilesStartLoading() {
                        this._tilesQueueTimer && (clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer), this._tilesQueueTimer = setInterval(()=>{
                            if (0 === Object.keys(this.adapter.queue.tasks).length) {
                                if (this._myVTour.state.currentNode) {
                                    const le1 = new CustomEvent("picture-tiles-loaded", {
                                        detail: {
                                            picId: this._myVTour.state.currentNode.id
                                        }
                                    });
                                    this.dispatchEvent(le1);
                                }
                                clearInterval(this._tilesQueueTimer), delete this._tilesQueueTimer;
                            }
                        }, 100);
                    }
                    getPictureMetadata() {
                        var le1, vt, bt;
                        return (0, Dl.isNullId)(null === (le1 = this._myVTour) || void 0 === le1 || null === (vt = le1.state) || void 0 === vt || null === (bt = vt.currentNode) || void 0 === bt ? void 0 : bt.id) ? null : this._myVTour.state.currentNode ? Object.assign({}, this._myVTour.state.currentNode) : null;
                    }
                    getPictureId() {
                        var le1, vt, bt, ls, ho;
                        const Fl = (null === (le1 = this._myVTour) || void 0 === le1 || null === (vt = le1.state) || void 0 === vt ? void 0 : vt.loadingNode) || (null === (bt = this._myVTour) || void 0 === bt || null === (ls = bt.state) || void 0 === ls || null === (ho = ls.currentNode) || void 0 === ho ? void 0 : ho.id);
                        return (0, Dl.isNullId)(Fl) ? null : Fl;
                    }
                    _onSelect(le1) {
                        le1.detail.seqId && (this._picturesSequences[le1.detail.picId] = le1.detail.seqId), le1.detail.seqId && !le1.detail.picId ? (this.loader.show(), this._parent.api.getSequenceItems(le1.detail.seqId, null, null, 1).then((vt)=>{
                            var bt;
                            if ((null === vt || void 0 === vt || null === (bt = vt.features) || void 0 === bt ? void 0 : bt.length) > 0) {
                                const bt = vt.features[0].id;
                                this._picturesSequences[bt] = le1.detail.seqId, this._parent.select(le1.detail.seqId, bt);
                            }
                        }).catch((le1)=>this.showErrorOverlay(le1, this._parent._t.pnx.error_pic, !0))) : le1.detail.picId ? this.getPictureId() !== le1.detail.picId && (this.loader.show(), this._myVTour.setCurrentNode(le1.detail.picId).catch((le1)=>{
                            this.showErrorOverlay(le1, this._parent._t.pnx.error_pic, !0);
                        })) : (this._myVTour.setCurrentNode(null), this._myVTour.state.currentNode.id = null, this._myVTour.state.loadingNode = null);
                    }
                    goToNextPicture() {
                        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
                        if ("pic" == this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
                        const le1 = this.getPictureMetadata().sequence.nextPic;
                        if (!le1) throw new Error("No next picture available");
                        this._parent.select(this.getPictureMetadata().sequence.id, le1);
                    }
                    goToPrevPicture() {
                        if (!this.getPictureMetadata()) throw new Error("No picture currently selected");
                        if ("pic" == this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
                        const le1 = this.getPictureMetadata().sequence.prevPic;
                        if (!le1) throw new Error("No previous picture available");
                        this._parent.select(this.getPictureMetadata().sequence.id, le1);
                    }
                    async goToPosition(le1, vt) {
                        if ("pic" == this._picturesNavigation) throw new Error("Pictures navigation is locked to current picture");
                        return this._parent.api.getPicturesAroundCoordinates(le1, vt).then((le1)=>{
                            if (le1.features.length > 0) {
                                const vt = le1.features.pop();
                                return this._parent.select(null === vt || void 0 === vt ? void 0 : vt.collection, vt.id), vt.id;
                            }
                            return Promise.reject(new Error("No picture found nearby given coordinates"));
                        });
                    }
                    getXY() {
                        const le1 = (0, Dl.positionToXYZ)(this.getPosition());
                        return le1.x = (le1.x + this.getPictureOriginalHeading()) % 360, le1;
                    }
                    getXYZ() {
                        const le1 = this.getXY();
                        return le1.z = this.getZoomLevel(), le1;
                    }
                    getPictureOriginalHeading() {
                        var le1, vt;
                        return (null === (le1 = this.getPictureMetadata()) || void 0 === le1 || null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["view:azimuth"]) || 0;
                    }
                    getPictureRelativeHeading() {
                        return (0, Dl.getRelativeHeading)(this.getPictureMetadata());
                    }
                    clearPictureMetadataCache() {
                        var le1, vt, bt, ls;
                        const ho = null === (le1 = this.getPictureMetadata()) || void 0 === le1 ? void 0 : le1.id, Dl = null === (vt = this.getPictureMetadata()) || void 0 === vt || null === (bt = vt.sequence) || void 0 === bt ? void 0 : bt.id;
                        null === (ls = this._myVTour.state.currentTooltip) || void 0 === ls || ls.hide(), this._myVTour.state.currentTooltip = null, this._myVTour.state.currentNode = null, this._myVTour.state.preload = {}, this._myVTour.datasource.nodes = {}, ho && this._parent.select(Dl, ho);
                    }
                    setXYZ(le1, vt, bt) {
                        const ls = (0, Dl.xyzToPosition)(le1 - this.getPictureOriginalHeading(), vt, bt);
                        this.rotate({
                            yaw: ls.yaw,
                            pitch: ls.pitch
                        }), this.zoom(ls.zoom);
                    }
                    setHigherContrast(le1) {
                        this.renderer.renderer.toneMapping = le1 ? 3 : 0, this.renderer.renderer.toneMappingExposure = le1 ? 2 : 1, this.needsUpdate();
                    }
                    getTransitionDuration() {
                        return this._transitionDuration;
                    }
                    setTransitionDuration(le1) {
                        if ((le1 = parseFloat(le1)) < 100 || le1 > _u) throw new Error("Invalid transition duration (should be between 100 and " + _u + ")");
                        this._transitionDuration = le1;
                        const vt = new CustomEvent("transition-duration-changed", {
                            detail: {
                                value: le1
                            }
                        });
                        this.dispatchEvent(vt);
                    }
                    setPanorama(le1, vt) {
                        if (le1.baseUrl.startsWith("data:")) return Promise.resolve();
                        const onFailure = (le1)=>{
                            var vt;
                            return this.showErrorOverlay(le1, null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.error_pic, !0);
                        };
                        try {
                            return super.setPanorama(le1, vt).catch(onFailure);
                        } catch (bt) {
                            onFailure(bt);
                        }
                    }
                    showErrorOverlay(le1, vt, bt) {
                        var ls, Dl, Fl, sc;
                        null !== (ls = this._parent) && void 0 !== ls && ls.loader.isVisible() || !this.overlay.isVisible() ? null === (Dl = this._parent) || void 0 === Dl || Dl.loader.dismiss(le1, vt, bt ? ()=>{
                            var le1;
                            null === (le1 = this._parent) || void 0 === le1 || le1.loader.dismiss(), this.overlay.hide();
                        } : void 0) : (console.error(le1), this.overlay.show({
                            image: `<img style="width: 200px" src="${ho}" alt="" />`,
                            title: null === (Fl = this._parent) || void 0 === Fl ? void 0 : Fl._t.pnx.error,
                            text: vt + "<br />" + (null === (sc = this._parent) || void 0 === sc ? void 0 : sc._t.pnx.error_click),
                            dissmisable: bt
                        }));
                    }
                    playSequence() {
                        this._sequencePlaying = !0, this.container.classList.add("pnx-psv-playing");
                        const le1 = new Event("sequence-playing", {
                            bubbles: !0,
                            composed: !0
                        });
                        this.dispatchEvent(le1);
                        const nextPicturePlay = ()=>{
                            if (this._sequencePlaying) {
                                this.addEventListener("picture-loaded", ()=>{
                                    this._playTimer = setTimeout(()=>{
                                        nextPicturePlay();
                                    }, this.getTransitionDuration());
                                }, {
                                    once: !0
                                });
                                try {
                                    this.goToNextPicture();
                                } catch (le1) {
                                    this.stopSequence();
                                }
                            }
                        };
                        this.addEventListener("click", ()=>this.stopSequence()), nextPicturePlay();
                    }
                    stopSequence() {
                        this._sequencePlaying = !1, this.container.classList.remove("pnx-psv-playing"), this._playTimer && (clearTimeout(this._playTimer), delete this._playTimer), this.forceRefresh();
                        const le1 = new Event("sequence-stopped", {
                            bubbles: !0,
                            composed: !0
                        });
                        this.dispatchEvent(le1);
                    }
                    isSequencePlaying() {
                        return this._sequencePlaying;
                    }
                    toggleSequencePlaying() {
                        this.isSequencePlaying() ? this.stopSequence() : this.playSequence();
                    }
                    getPicturesNavigation() {
                        return this._picturesNavigation;
                    }
                    setPicturesNavigation(le1) {
                        "none" === le1 && (le1 = "pic"), this._picturesNavigation = le1;
                        const vt = this.container.querySelector(".psv-virtual-tour-arrows");
                        vt && (vt.style.display = "pic" == le1 ? "none" : null);
                        const bt = new CustomEvent("pictures-navigation-changed", {
                            detail: {
                                value: le1
                            }
                        });
                        this.dispatchEvent(bt);
                    }
                    _picturesNavFilter(le1) {
                        switch(this._picturesNavigation){
                            case "seq":
                                return [
                                    "next",
                                    "prev"
                                ].includes(le1.rel);
                            case "pic":
                            case "none":
                                return !1;
                            default:
                                return !0;
                        }
                    }
                    areAnnotationsVisible() {
                        return this._annotationsVisible;
                    }
                    getSelectedAnnotations() {
                        return Object.keys(this._myMarkers.markers).filter((le1)=>{
                            var vt, bt, ls;
                            return le1.startsWith("annotation-") && (null === (vt = this._myMarkers.markers[le1]) || void 0 === vt || null === (bt = vt.config) || void 0 === bt || null === (ls = bt.data) || void 0 === ls ? void 0 : ls.selected);
                        }).map((le1)=>le1.replace("annotation-", ""));
                    }
                    toggleAllAnnotations(le1) {
                        const vt = this.getPictureMetadata(), bt = this._annotationsVisible == le1;
                        if (!vt) throw this._myMarkers.clearMarkers(), new Error("No picture currently selected");
                        if (le1) {
                            var ls;
                            let le1 = vt.properties.annotations || [];
                            0 === (null === (ls = le1) || void 0 === ls ? void 0 : ls.length) && console.warn("No annotation available on picture", vt.id), le1 = le1.map((le1)=>{
                                if (!vt.properties["pers:interior_orientation"].sensor_array_dimensions) return console.warn("Picture lacks pers:interior_orientation.sensor_array_dimensions property, can't compute marker"), null;
                                const bt = le1.shape.coordinates.map((le1)=>le1.map((le1)=>{
                                        var bt;
                                        const ls = null === (bt = vt.panorama) || void 0 === bt ? void 0 : bt.cropData, ho = {
                                            textureX: le1[0] + ((null === ls || void 0 === ls ? void 0 : ls.croppedX) || 0),
                                            textureY: le1[1] + ((null === ls || void 0 === ls ? void 0 : ls.croppedY) || 0)
                                        };
                                        return this.dataHelper.textureCoordsToSphericalCoords(ho);
                                    }));
                                return {
                                    id: `annotation-${le1.id}`,
                                    polygon: bt,
                                    data: {
                                        id: le1.id
                                    },
                                    className: "pnx-psv-annotation",
                                    svgStyle: {
                                        stroke: "var(--orange)",
                                        strokeWidth: "3px",
                                        fill: "var(--orange-transparent)",
                                        cursor: "pointer"
                                    },
                                    tooltip: this._parent._t.pnx.semantics_annotation_tooltip
                                };
                            }), this._myMarkers.setMarkers(le1);
                        } else this._myMarkers.clearMarkers();
                        this._annotationsVisible = le1, bt || this.dispatchEvent(new CustomEvent("annotations-toggled", {
                            detail: {
                                visible: le1
                            }
                        }));
                    }
                    focusOnAnnotation(le1) {
                        let vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], bt = arguments.length > 2 && void 0 !== arguments[2] && arguments[2];
                        const ls = this.getSelectedAnnotations();
                        if (le1 && 1 === ls.length && ls[0] === le1) return;
                        this.areAnnotationsVisible() || this.toggleAllAnnotations(!0), this.unfocusAnnotation(!0);
                        const ho = `annotation-${le1}`;
                        if (this._myMarkers.markers[ho]) {
                            if (this._myMarkers.updateMarker({
                                id: ho,
                                svgStyle: {
                                    stroke: "var(--red)",
                                    strokeWidth: "3px",
                                    fill: "var(--red-transparent)"
                                },
                                data: {
                                    selected: !0,
                                    blockFocus: vt
                                }
                            }), this._myMarkers.gotoMarker(ho, 0), this.zoom(65), !bt) {
                                const vt = new CustomEvent("annotation-focused", {
                                    detail: {
                                        annotationId: le1
                                    }
                                });
                                this.dispatchEvent(vt);
                            }
                        } else setTimeout(()=>this.focusOnAnnotation(le1, vt, bt), 100);
                    }
                    unfocusAnnotation() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0], vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        const bt = this.getSelectedAnnotations();
                        if (bt.length > 0) {
                            let ls = 0;
                            bt.forEach((le1)=>{
                                var bt, ho, Dl;
                                const Fl = "annotation-" + le1;
                                vt && null !== (bt = this._myMarkers.markers[Fl]) && void 0 !== bt && null !== (ho = bt.config) && void 0 !== ho && null !== (Dl = ho.data) && void 0 !== Dl && Dl.blockFocus ? ls++ : this._myMarkers.updateMarker({
                                    id: Fl,
                                    svgStyle: {
                                        stroke: "var(--orange)",
                                        strokeWidth: "3px",
                                        fill: "var(--orange-transparent)"
                                    },
                                    data: {
                                        selected: !1,
                                        blockFocus: !1
                                    }
                                });
                            }), !le1 && ls < bt.length && this.dispatchEvent(new Event("annotations-unfocused"));
                        }
                    }
                    startDrawAnnotation() {
                        this.toggleAllAnnotations(!1), this._drawingAnnotation = [], this._drawingMoves = 0, this._myMarkers.addMarker({
                            id: Nd,
                            polygon: [
                                {
                                    yaw: 0,
                                    pitch: 0
                                },
                                {
                                    yaw: 0,
                                    pitch: 0
                                },
                                {
                                    yaw: 0,
                                    pitch: 0
                                }
                            ],
                            svgStyle: {
                                fill: Ud,
                                stroke: jd,
                                strokeWidth: "2px"
                            },
                            visible: !1
                        }), this._myMarkers.addMarker({
                            id: Md,
                            circle: 5,
                            position: {
                                yaw: 0,
                                pitch: 0
                            },
                            style: {
                                cursor: "pointer"
                            },
                            svgStyle: {
                                fill: Od,
                                stroke: Rd,
                                strokeWidth: "3px"
                            }
                        }), this._myMarkers.addMarker({
                            id: Ld,
                            circle: 5,
                            position: {
                                yaw: 0,
                                pitch: 0
                            },
                            style: {
                                cursor: "pointer"
                            },
                            svgStyle: {
                                fill: Od,
                                stroke: Rd,
                                strokeWidth: "3px"
                            },
                            visible: !1
                        });
                        const firstMove = (le1)=>{
                            const vt = this.getPositionFromEvent(le1);
                            vt && this._myMarkers.markers[Md] && (this._myMarkers.updateMarker({
                                id: Md,
                                position: vt,
                                style: {
                                    cursor: "grab"
                                }
                            }), 2 == this._drawingAnnotation.length && this._myMarkers.markers[Nd] && this._myMarkers.updateMarker({
                                id: Nd,
                                polygon: [
                                    vt,
                                    {
                                        yaw: vt.yaw,
                                        pitch: this._drawingAnnotation[1].pitch
                                    },
                                    this._drawingAnnotation[1],
                                    {
                                        yaw: this._drawingAnnotation[1].yaw,
                                        pitch: vt.pitch
                                    }
                                ]
                            }));
                        }, secMove = (le1)=>{
                            const vt = this.getPositionFromEvent(le1);
                            vt && this._myMarkers.markers[Ld] && (this._myMarkers.updateMarker({
                                id: Ld,
                                position: vt,
                                style: {
                                    cursor: "grab"
                                }
                            }), this._drawingAnnotation.length >= 1 && this._myMarkers.markers[Nd] && this._myMarkers.updateMarker({
                                id: Nd,
                                polygon: [
                                    this._drawingAnnotation[0],
                                    {
                                        yaw: this._drawingAnnotation[0].yaw,
                                        pitch: vt.pitch
                                    },
                                    vt,
                                    {
                                        yaw: vt.yaw,
                                        pitch: this._drawingAnnotation[0].pitch
                                    }
                                ]
                            }));
                        };
                        this._drawListeners = [
                            firstMove,
                            secMove
                        ], this.parent.addEventListener("mousemove", firstMove), this._drawingMoves = 1, this._drawListenerClick = (le1)=>{
                            let vt = !1;
                            if (2 !== this._drawingMoves && le1.marker.id === Md ? 0 == this._drawingAnnotation.length ? (this._drawingAnnotation.push({
                                yaw: le1.marker.config.position.yaw,
                                pitch: le1.marker.config.position.pitch
                            }), this.parent.removeEventListener("mousemove", firstMove), this._myMarkers.updateMarker({
                                id: Md,
                                style: {
                                    cursor: "pointer"
                                }
                            }), this._myMarkers.updateMarker({
                                id: Ld,
                                visible: !0,
                                position: {
                                    yaw: le1.marker.config.position.yaw,
                                    pitch: le1.marker.config.position.pitch
                                }
                            }), this._myMarkers.updateMarker({
                                id: Nd,
                                visible: !0
                            }), this.parent.addEventListener("mousemove", secMove), this._drawingMoves = 2) : 0 === this._drawingMoves ? (this.parent.addEventListener("mousemove", firstMove), this._drawingMoves = 1) : (this._drawingAnnotation[0] = {
                                yaw: le1.marker.config.position.yaw,
                                pitch: le1.marker.config.position.pitch
                            }, this.parent.removeEventListener("mousemove", firstMove), this._myMarkers.updateMarker({
                                id: Md,
                                style: {
                                    cursor: "pointer"
                                }
                            }), this._drawingMoves = 0, vt = !0) : 1 !== this._drawingMoves && le1.marker.id === Ld && (1 == this._drawingAnnotation.length ? (this._drawingAnnotation.push({
                                yaw: le1.marker.config.position.yaw,
                                pitch: le1.marker.config.position.pitch
                            }), this.parent.removeEventListener("mousemove", secMove), this._myMarkers.updateMarker({
                                id: Ld,
                                style: {
                                    cursor: "pointer"
                                }
                            }), this._drawingMoves = 0, vt = !0) : 2 === this._drawingMoves ? (this._drawingAnnotation[1] = {
                                yaw: le1.marker.config.position.yaw,
                                pitch: le1.marker.config.position.pitch
                            }, this.parent.removeEventListener("mousemove", secMove), this._myMarkers.updateMarker({
                                id: Ld,
                                style: {
                                    cursor: "pointer"
                                }
                            }), this._drawingMoves = 0, vt = !0) : (this.parent.addEventListener("mousemove", secMove), this._drawingMoves = 2)), vt) {
                                var bt, ls;
                                const le1 = this.dataHelper.sphericalCoordsToTextureCoords(this._drawingAnnotation[0]), vt = this.dataHelper.sphericalCoordsToTextureCoords(this._drawingAnnotation[1]);
                                let ho = [
                                    le1.textureX,
                                    le1.textureY,
                                    vt.textureX,
                                    vt.textureY
                                ];
                                const Dl = null === (bt = this.getPictureMetadata()) || void 0 === bt || null === (ls = bt.panorama) || void 0 === ls ? void 0 : ls.cropData;
                                if (Dl && (ho[0] -= Dl.croppedX, ho[1] -= Dl.croppedY, ho[2] -= Dl.croppedX, ho[3] -= Dl.croppedY, (ho[0] < 0 || ho[0] > Dl.croppedWidth || ho[1] < 0 || ho[1] > Dl.croppedHeight || ho[2] < 0 || ho[2] > Dl.croppedWidth || ho[3] < 0 || ho[3] > Dl.croppedHeight) && (ho = null)), ho[0] >= ho[2] && ho[1] >= ho[3]) {
                                    let le1 = ho[0], vt = ho[2], bt = ho[1];
                                    ho = [
                                        vt,
                                        ho[3],
                                        le1,
                                        bt
                                    ];
                                }
                                const Fl = new CustomEvent("annotation-drawn", {
                                    detail: {
                                        shape: ho
                                    }
                                });
                                this.dispatchEvent(Fl);
                            }
                        }, this._myMarkers.addEventListener("select-marker", this._drawListenerClick);
                    }
                    fixDrawAnnotation() {
                        [
                            Md,
                            Ld
                        ].forEach((le1)=>{
                            try {
                                this._myMarkers.removeMarker(le1);
                            } catch (vt) {}
                        }), (this._drawListeners || []).forEach((le1)=>this.parent.removeEventListener("mousemove", le1)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), this._myMarkers.updateMarker({
                            id: Nd,
                            svgStyle: {
                                stroke: "var(--red)",
                                strokeWidth: "3px",
                                fill: "var(--red-transparent)",
                                cursor: "pointer"
                            }
                        }), this._drawingMoves = 0;
                    }
                    stopDrawAnnotation() {
                        [
                            Md,
                            Ld,
                            Nd
                        ].forEach((le1)=>{
                            try {
                                this._myMarkers.removeMarker(le1);
                            } catch (vt) {}
                        }), (this._drawListeners || []).forEach((le1)=>this.parent.removeEventListener("mousemove", le1)), this._myMarkers.removeEventListener("select-marker", this._drawListenerClick), delete this._drawingMoves, this._drawingAnnotation = null;
                    }
                    getPositionFromEvent(le1) {
                        const vt = this.container.getBoundingClientRect(), bt = le1.clientX - vt.left, ls = le1.clientY - vt.top, ho = this.renderer.getIntersections({
                            x: bt,
                            y: ls
                        }).find((le1)=>le1.object.userData[sc.aH.VIEWER_DATA]);
                        if (ho) return this.dataHelper.vector3ToSphericalCoords(ho.point);
                    }
                    forceRefresh() {
                        var le1;
                        const vt = this._myVTour.getCurrentNode();
                        if (vt && vt.panorama.baseUrl !== (null === vt || void 0 === vt || null === (le1 = vt.panorama) || void 0 === le1 ? void 0 : le1.origBaseUrl)) {
                            const le1 = this.getZoomLevel(), bt = this.getPosition();
                            this._myVTour.state.currentNode = null, this._myVTour.setCurrentNode(vt.id, {
                                zoomTo: le1,
                                rotateTo: bt,
                                fadeIn: !1,
                                speed: 0,
                                rotation: !1
                            });
                        }
                        vt && vt.panorama.rows > 1 && this.adapter.__refresh();
                    }
                }
            },
            4374: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Popup
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(8591), Fl = bt(6627);
                class Popup extends ls.WF {
                    constructor(){
                        super(), this.visible = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this.addEventListener("click", (le1)=>{
                            le1.target === this && this.close();
                        }), document.addEventListener("keyup", (le1)=>{
                            "Escape" === le1.key && this.visible && this.close();
                        });
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        super.attributeChangedCallback(le1, vt, bt), "visible" == le1 && ("" !== bt && !0 !== bt || this.dispatchEvent(new Event("open")));
                    }
                    close() {
                        this.visible = !1, this.dispatchEvent(new Event("close"));
                    }
                    render() {
                        return ls.qy`
			<div class="pnx-panel pnx-padded">
				<pnx-button
					class="btn-close"
					kind="inline"
					size="l"
					@click=${this.close.bind(this)}
				>
					${(0, ho.fa)(Fl.faXmark)}
				</pnx-button>

				<slot></slot>
			</div>
		`;
                    }
                }
                Popup.styles = [
                    Dl.nd,
                    Dl.Op,
                    ls.AH`
		/* Backdrop */
		:host {
			display: flex;
			align-items: center;
			justify-content: center;
			position: absolute;
			top: 0;
			right: 0;
			left: 0;
			bottom: 0;
			opacity: 0;
			visibility: hidden;
			pointer-events: none;
			transition: all 0.2s;
			background: rgba(0, 0, 0, 0.85);
		}
		:host(*[visible]) {
			opacity: 1;
			visibility: visible;
			pointer-events: unset;
			z-index: 200;
		}

		/* Content backgroud */
		.pnx-panel {
			box-sizing: border-box;
			position: relative;
			width: 90%;
			max-height: 90%;
			max-width: 400px;
			overflow-y: auto;
		}

		.btn-close {
			position: absolute;
			top: 15px;
			right: 15px;
		}
	`
                ], Popup.properties = {
                    visible: {
                        type: Boolean,
                        reflect: !0
                    }
                }, customElements.define("pnx-popup", Popup);
            },
            4364: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>ProgressBar
                });
                var ls = bt(4542);
                class ProgressBar extends ls.WF {
                    render() {
                        var le1;
                        return ls.qy`
			<progress
				value=${this.value >= 0 ? this.value : ls.s6}
				class=${this.value >= 0 ? ls.s6 : "indeterminate"}
				max="100"
				title=${null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.map.loading}
			></progress>
		`;
                    }
                }
                ProgressBar.styles = ls.AH`
		progress {
			max-width: 80vh;
			width: 300px;
			height: 16px;
			appearance: none;
			-webkit-appearance: none;
			border: 1px solid var(--grey-semi-dark);
			background-color: var(--grey);
			border-radius: 8px;
			overflow: hidden;
			padding: 3px;
			box-sizing: border-box;
			display: block;
		}

		progress::-webkit-progress-bar {
			background-color: var(--grey);
		}

		/* Don't merge with -moz below, for some f*ing reason a list selector doesn't work with Chrome */
		progress::-webkit-progress-value {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress::-moz-progress-bar {
			background-color: var(--blue);
			border-radius: 5px;
			box-sizing: border-box;
		}

		progress[value=""]::-moz-progress-bar,
		progress:not([value])::-moz-progress-bar {
			animation: indeterminateAnimation 1.5s infinite linear;
		}

		progress.indeterminate {
			position: relative;
			background-color: var(--grey);
			overflow: hidden;
		}

		progress.indeterminate::after {
			content: "";
			position: absolute;
			left: 3px;
			top: 3px;
			bottom: 3px;
			width: 20%;
			background-color: var(--blue);
			border-radius: 5px;
			animation: indeterminateAnimation 1.5s infinite linear;
			pointer-events: none;
		}

		@keyframes indeterminateAnimation {
			0%   { margin-left: 0%; width: 2%; }
			15%  { margin-left: 0%; width: 20%; }
			50%  { margin-left: 40%; width: 20%; }
			85%  { margin-left: 80%; width: 20%; }
			100% { margin-left: 98%; width: 2%; }
		}
	`, ProgressBar.properties = {
                    value: {
                        type: Number
                    }
                }, customElements.define("pnx-progress-bar", ProgressBar);
            },
            2675: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>QualityScore
                });
                var ls = bt(4542), ho = bt(7343);
                class QualityScore extends ls.WF {
                    constructor(){
                        super(), this.grade = 0, this.input = !1;
                    }
                    _onInput() {
                        const le1 = [];
                        for (let vt of this.renderRoot.querySelectorAll("input"))vt.checked && le1.push(vt.value);
                        this.grade = le1.join(","), this.dispatchEvent(new CustomEvent("change", {
                            bubbles: !0,
                            composed: !0
                        }));
                    }
                    render() {
                        const le1 = `${this.grade}`.split(",").map((le1)=>parseInt(le1)).filter((le1)=>!isNaN(le1));
                        return this.input ? ho.QUALITYSCORE_VALUES.map((vt, bt)=>{
                            var ho;
                            return ls.qy`
				<input
					id="${this.input}-${vt.label}"
					type="checkbox"
					name="qualityscore"
					value="${5 - bt}"
					@change="${this._onInput}"
					.checked=${le1.includes(5 - bt)}
				/>
				<label
					for="${this.input}-${vt.label}"
					title="${null === (ho = this._t) || void 0 === ho ? void 0 : ho.pnx.filter_qualityscore_help}"
					style="background-color: ${vt.color}"
				>
					${vt.label}
				</label>
			`;
                        }) : ho.QUALITYSCORE_VALUES.map((vt, bt)=>ls.qy`
				<span class="${le1.includes(5 - bt) ? "selected" : ""}" style="background-color: ${vt.color}">
					${vt.label}
				</span>
			`);
                    }
                }
                QualityScore.styles = ls.AH`
		:host {
			gap: 0px;
			justify-content: center;
			height: 2em;
			font-size: 18px;
			display: inline-flex;
			align-items: center;
			color: white;
		}
	
		/* Single letter */
		span, label {
			width: 1.2em;
			height: 1.5em;
			line-height: 1.5em;
			display: inline-block;
			border: 0.05em solid white;
			text-align: center;
			background-color: gray;
			color: rgba(255,255,255,0.9);
			font-family: var(--font-family);
			font-weight: 800;
			vertical-align: middle;
		}

		/* Rounded corners for first/last */
		span:first-of-type, label:first-of-type {
			border-top-left-radius: 0.4em;
			border-bottom-left-radius: 0.4em;
		}

		span:last-of-type, label:last-of-type {
			border-top-right-radius: 0.4em;
			border-bottom-right-radius: 0.4em;
		}

		/* Selected letter */
		.selected, input[type="checkbox"]:checked + label {
			font-size: 1.3em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		/* Clickable letter for input */
		label { cursor: pointer; }

		label:hover {
			font-size: 1.2em;
			height: 1.6em;
			line-height: 1.6em;
			border-radius: 0.3em !important;
		}

		input[type="checkbox"] { display: none; }
	`, QualityScore.properties = {
                    grade: {
                        type: String
                    },
                    input: {
                        type: String
                    }
                }, customElements.define("pnx-quality-score", QualityScore);
            },
            3409: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SearchBar
                });
                var ls = bt(4542), ho = bt(1198), Dl = bt(4901), Fl = bt(5995), sc = bt(8591), uc = bt(4011), mc = bt(7761), gc = bt(3444), Ac = bt(6627);
                class SearchBar extends ls.WF {
                    constructor(){
                        super(), this.reduceable = !1, this.reduced = !1, this.placeholder = ls.s6, this.size = "md", this._icon = "search", this._results = null, this["no-menu-closure"] = !1, this._throttler = null, delete this._lastSearch;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this["no-menu-closure"] || (0, Fl.listenForMenuClosure)(this, this.reset.bind(this));
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        super.attributeChangedCallback(le1, vt, bt), "value" == le1 && "search" == this._icon && (this._icon = "empty");
                    }
                    _onIconClick() {
                        [
                            "empty",
                            "warn"
                        ].includes(this._icon) && this.reset(), this.reduceable && "search" == this._icon && (this.reduced = !this.reduced);
                    }
                    _onInputChange(le1) {
                        this.value = le1.target.value, this._throttledSearch();
                    }
                    _onResultClick(le1) {
                        this.dispatchEvent(new CustomEvent("result", {
                            bubbles: !0,
                            composed: !0,
                            detail: le1
                        })), this._results = null, this._throttler && (clearTimeout(this._throttler), this._throttler = null), !this.reduceable && le1 ? (this.value = null === le1 || void 0 === le1 ? void 0 : le1.title, this._icon = "empty") : (this.value = "", this._icon = "search", this.reduceable && (this.reduced = !0));
                    }
                    _throttledSearch() {
                        this._throttler && (clearTimeout(this._throttler), delete this._throttler), this._throttler = setTimeout(this._search.bind(this), 500);
                    }
                    _search() {
                        this.value && 0 != this.value.length ? this.searcher ? (this._icon = "loading", this._results = null, this.searcher(this.value).then((le1)=>{
                            if ("loading" === this._icon) {
                                if (this._icon = "empty", le1 && 0 != le1.length) {
                                    if (!0 === le1) this._results = null;
                                    else {
                                        var vt;
                                        if (this._results = le1, !this["no-menu-closure"]) null === (vt = this._parent) || void 0 === vt || vt.dispatchEvent(new CustomEvent("menu-opened", {
                                            detail: {
                                                menu: this
                                            }
                                        }));
                                    }
                                } else this._results = [];
                            }
                        }).catch((le1)=>{
                            console.error(le1), this._icon = "warn";
                        })) : console.warn("No search handler defined") : this.reset();
                    }
                    reset() {
                        this._onResultClick(null);
                    }
                    render() {
                        var le1, vt;
                        const bt = {
                            sb: !0,
                            "sb-xxl": "xxl" === this.size,
                            "sb-reduceable": this.reduceable,
                            "sb-reduced": this.reduced
                        };
                        return ls.qy`<div
			id=${this.id}
			class=${(0, ho.H)(bt)}
			part="container"
		>
			<slot name="pre" class=${(0, ho.H)({
                            "sb-reduced": this.reduced
                        })}></slot>

			<input
				id="${this.id}-input"
				type="text"
				placeholder=${this.placeholder}
				autocomplete="off"
				@change=${this._onInputChange.bind(this)}
				@keypress=${this._onInputChange.bind(this)}
				@paste=${this._onInputChange.bind(this)}
				@input=${this._onInputChange.bind(this)}
				.value=${this.value || ""}
				part="input"
			/>

			<span
				class="sb-icon"
				@click=${this._onIconClick.bind(this)}
			>
				${"search" == this._icon ? (0, Fl.fa)(mc.$U) : ls.s6}
				${"loading" == this._icon ? (0, Fl.fa)(gc.s4, {
                            classes: [
                                "fa-spin"
                            ]
                        }) : ls.s6}
				${"empty" == this._icon ? (0, Fl.fa)(Ac.faXmark) : ls.s6}
				${"warn" == this._icon ? (0, Fl.fa)(uc.lE) : ls.s6}
			</span>

			${!this.reduced && this._results ? ls.qy`
				<div class="sb-results">
					${0 === this._results.length ? ls.qy`
						<div class="sb-empty">${null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1._t) || void 0 === vt ? void 0 : vt.pnx.search_empty}</div>
					` : ls.s6}

					${(0, Dl.T)(this._results, (le1)=>ls.qy`
						<div class="sb-result" @click=${()=>this._onResultClick(le1)}>
							${le1.title}
							${le1.subtitle && "" != le1.subtitle ? ls.qy`<br /><small>${le1.subtitle}</small>` : ls.s6}
						</div>
					`)}
				</div>
			` : ls.s6}
		</div>`;
                    }
                }
                SearchBar.styles = [
                    sc.Op,
                    ls.AH`
		/* Container */
		.sb {
			display: flex;
			align-items: center;
			justify-content: space-between;
			gap: 5px;
			border: 1px solid var(--widget-border-div);
			border-radius: 5px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			height: 30px;
			border-radius: 20px;
			position: relative;
			padding: 0 0 0 10px;
			width: fit-content;
			max-width: 100%;
			box-sizing: border-box;
			font-family: var(--font-family);
		}
		.sb.sb-xxl {
			height: 40px;
			line-height: 40px;
		}
		.sb.sb-reduceable {
			width: 360px;
		}
		.sb.sb-reduceable.sb-reduced {
			width: fit-content;
			padding: 0;
			gap: 0;
		}

		/* Text field */
		.sb input {
			background: none;
			border: none !important;
			outline: none;
			height: 20px;
			width: 100%;
			font-family: var(--font-family);
		}
		.sb.sb-xxl input {
			font-size: 1.1em;
		}
		.sb.sb-reduceable.sb-reduced input {
			display: none;
		}

		/* Status icon */
		.sb-icon {
			cursor: pointer;
			height: 30px;
			line-height: 30px;
			width: 30px;
			min-width: 30px;
			text-align: center;
		}
		.sb.sb-xxl .sb-icon {
			height: 40px;
			line-height: 40px;
			width: 40px;
			min-width: 40px;
		}
		.sb-icon svg {
			pointer-events: none;
			width: 14px;
			height: 14px;
		}

		/* Search results */
		.sb-results {
			position: absolute;
			top: 35px;
			list-style: none;
			margin: 0;
			padding: 0;
			max-width: calc(100% - 20px);
			border: 1px solid var(--widget-border-div);
			border-radius: 10px;
			background-color: var(--widget-bg);
			color: var(--widget-font);
			z-index: 130;
			font-size: 1.05em;
  			line-height: normal;
			font-family: var(--font-family);
		}
		.sb.sb-xxl .sb-results {
			top: 45px;
		}
		.sb-result,
		.sb-empty {
			display: block;
			padding: 5px 15px;
			white-space: nowrap;
			overflow: hidden;
			text-overflow: ellipsis;
			cursor: pointer;
			border-radius: 0;
		}
		.sb-result:hover {
			background-color: var(--widget-bg-hover);
		}
		.sb-result:first-child {
			border-top-right-radius: 10px;
			border-top-left-radius: 10px;
			padding-top: 15px;
		}
		.sb-result:last-child {
			border-bottom-right-radius: 10px;
			border-bottom-left-radius: 10px;
			padding-bottom: 15px;
		}
	`
                ], SearchBar.properties = {
                    id: {
                        type: String
                    },
                    placeholder: {
                        type: String
                    },
                    reduceable: {
                        type: Boolean,
                        reflect: !0
                    },
                    reduced: {
                        type: Boolean,
                        reflect: !0
                    },
                    value: {
                        type: String
                    },
                    size: {
                        type: String
                    },
                    _icon: {
                        state: !0
                    },
                    _results: {
                        state: !0
                    },
                    searcher: {
                        type: Function
                    },
                    "no-menu-closure": {
                        type: Boolean
                    }
                }, customElements.define("pnx-search-bar", SearchBar);
            },
            8780: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsEditor
                });
                var ls = bt(4542), ho = bt(9039), Dl = bt(2283), Fl = bt(8591), sc = bt(2614), uc = bt.n(sc);
                class SemanticsEditor extends ls.WF {
                    constructor(){
                        super(), this.semantics = null, this._valid = !0, this._firstSemantics = null, this.rows = 3;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._firstSemantics = null === this.semantics ? [] : uc().parse(uc().stringify(this.semantics));
                    }
                    getDiff() {
                        return (0, Dl.computeDiffTags)(this._firstSemantics || [], this.semantics);
                    }
                    checkValidity() {
                        return this._valid;
                    }
                    reportValidity() {
                        var le1;
                        null === (le1 = this.renderRoot.querySelector("textarea")) || void 0 === le1 || le1.reportValidity();
                    }
                    reset() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null;
                        this.semantics = null, this._valid = !0;
                        const vt = this.renderRoot.querySelector("textarea");
                        null === vt || void 0 === vt || vt.setCustomValidity(""), null === vt || void 0 === vt || vt.reportValidity(), this._firstSemantics = le1, this.semantics = le1;
                    }
                    _onInput(le1) {
                        const vt = le1.target;
                        try {
                            this.semantics = (0, Dl.parseSemanticsString)(vt.value) || [], this._valid = !0;
                        } catch (bt) {
                            "Invalid tags" !== bt.message && console.error(bt), this._valid = !1;
                        }
                    }
                    _onBlur(le1) {
                        const vt = le1.target.checkValidity();
                        if (this._valid) le1.target.setCustomValidity(""), this.dispatchEvent(new CustomEvent("change", {
                            detail: {
                                semantics: this.semantics || [],
                                delta: (0, Dl.computeDiffTags)(this._firstSemantics || [], this.semantics)
                            }
                        }));
                        else if (vt) {
                            var bt;
                            le1.target.setCustomValidity((null === (bt = this._t) || void 0 === bt ? void 0 : bt.pnx.semantics_editor_error) || "Invalid syntax"), le1.target.reportValidity();
                        }
                    }
                    render() {
                        var le1;
                        return ls.qy`
			<textarea
				part="text"
				autocomplete="off"
				autocorrect="off"
				autocapitalize="off"
				spellcheck="false"
				placeholder=${(null === (le1 = this._t) || void 0 === le1 ? void 0 : le1.pnx.semantics_editor_example) || "key1=value1\nprefix|key2=value2"}
				@input=${this._onInput}
  				@blur=${this._onBlur}
				rows=${this.rows}
				.value=${(0, Dl.semanticsToString)(this.semantics)}
			></textarea>
		`;
                    }
                }
                SemanticsEditor.styles = [
                    Fl.PC,
                    ls.AH`
		textarea:invalid {
			border: 2px solid var(--red);
			background-color:var(--beige);
		}
	`
                ], SemanticsEditor.properties = {
                    semantics: {
                        converter: ho.A.GetJSONConverter(),
                        reflect: !0
                    },
                    rows: {
                        type: Number
                    },
                    _valid: {
                        state: !0
                    },
                    _t: {
                        converter: ho.A.GetJSONConverter()
                    },
                    _firstSemantics: {
                        state: !0
                    }
                }, customElements.define("pnx-semantics-editor", SemanticsEditor);
            },
            2373: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsTable
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(2283);
                class SemanticsTable extends ls.WF {
                    render() {
                        if (!this.source) return ls.s6;
                        const le1 = (0, Dl.groupByPrefix)(this.source.semantics);
                        return ls.qy`<table>
			<thead>
				<tr><th>${this._t.pnx.semantics_key}</th><th>${this._t.pnx.semantics_value}</th></tr>
			</thead>
			<tbody>
				${le1.map((le1)=>le1.tags.map((vt)=>ls.qy`
					<tr>
						<td>
							${"" != le1.prefix ? le1.logo ? ls.qy`<img src=${le1.logo} class="prefix-logo" alt=${le1.prefix} title=${le1.title} />` : ls.qy`<small>(${le1.prefix})</small>` : ls.s6}
							${le1.key_transform ? le1.key_transform(vt, this._t) : vt.key}
						</td>
						<td>
							${le1.value_transform ? le1.value_transform(vt, this._t) : vt.value}
							${vt.qualifiers ? ls.qy`<div class="qualifiers">
								<b>${this._t.pnx.semantics_qualifiers}</b>
								<ul>
									${vt.qualifiers.map((le1)=>ls.qy`<li>${le1.subkey} = ${le1.value}</li>`)}
								</ul>
							</div>` : ls.s6}
						</td>
					</tr>
				`))}
			</tbody>
		</table>`;
                    }
                }
                SemanticsTable.styles = [
                    ho.tp,
                    ls.AH`
		:host { display: block; }
		th:first-child, td:first-child { width: 40%; }
		td { vertical-align: top; }

		td small { color: var(--grey-semi-dark); }
		td a small { color: unset; }
		.qualifiers { margin-top: 5px; }
		.qualifiers > b { margin: 8px 0; }
		.qualifiers ul {
			list-style: none;
			margin: 0px 0px 0px 15px;
			padding: 0;
		}

		img.prefix-logo {
			max-width: 15px;
			max-height: 15px;
			aspect-ratio: 1;
			vertical-align: middle;
		}
	`
                ], SemanticsTable.properties = {
                    source: {
                        type: Object
                    }
                }, customElements.define("pnx-semantics-table", SemanticsTable);
            },
            1578: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Switch
                });
                var ls = bt(4542);
                class Switch extends ls.WF {
                    constructor(){
                        super(), this.checked = !1, this.disabled = !1, this.name = "pnx-switch-1";
                    }
                    _onChange(le1) {
                        this.checked = le1.target.checked, this.dispatchEvent(new Event("change"));
                    }
                    render() {
                        return ls.qy`
			<label class="toggle" for=${this.name}>
				<input
					class="toggle-checkbox"
					type="checkbox"
					id=${this.name}
					name=${this.name}
					.checked=${this.checked}
					.disabled=${this.disabled}
					@change=${this._onChange}
				/>
				<div class="toggle-switch"></div>
				<span class="toggle-label">
					<slot></slot>
				</span>
			</label>
		`;
                    }
                }
                Switch.styles = ls.AH`
		.toggle {
			cursor: pointer;
			display: inline-block;
		}

		.toggle-switch {
			display: inline-block;
			background: #ccc;
			border-radius: 11px;
			width: 42px;
			height: 22px;
			position: relative;
			vertical-align: middle;
			transition: background 0.25s;
		}
		.toggle-switch:before, .toggle-switch:after {
			content: "";
		}
		.toggle-switch:before {
			display: block;
			background: linear-gradient(to bottom, #fff 0%, #eee 100%);
			border-radius: 50%;
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
			width: 16px;
			height: 16px;
			position: absolute;
			top: 3px;
			left: 3px;
			transition: left 0.25s;
		}
		.toggle:hover .toggle-switch:before {
			background: linear-gradient(to bottom, #fff 0%, #fff 100%);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.5);
		}
		.toggle-checkbox:checked + .toggle-switch {
			background: var(--widget-bg-active);
		}
		.toggle-checkbox:disabled + .toggle-switch:before,
		.toggle-checkbox:disabled:hover + .toggle-switch:before {
			background: var(--grey-pale);
			box-shadow: none;
		}
		.toggle-checkbox:disabled + .toggle-switch {
			background: var(--grey);
			box-shadow: 0 0 0 1px rgba(0, 0, 0, 0.25);
		}
		.toggle-checkbox:checked + .toggle-switch:before {
			left: 23px;
		}

		.toggle-checkbox {
			position: absolute;
			visibility: hidden;
		}

		.toggle-label {
			margin-left: 5px;
			position: relative;
			top: 2px;
		}
	`, Switch.properties = {
                    checked: {
                        type: Boolean,
                        reflect: !0
                    },
                    disabled: {
                        type: Boolean,
                        reflect: !0
                    },
                    name: {
                        type: String
                    }
                }, customElements.define("pnx-switch", Switch);
            },
            5202: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>TogglableGroup
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(1198);
                class TogglableGroup extends ls.WF {
                    constructor(){
                        super(), this._opened = !1;
                    }
                    open() {
                        var le1;
                        this._opened = !0, null === (le1 = this._parent) || void 0 === le1 || le1.dispatchEvent(new CustomEvent("menu-opened", {
                            detail: {
                                menu: this
                            }
                        })), this.adjustMenuPosition(this._btn), this._chevron && (this._chevron.style.rotate = "180deg");
                    }
                    close() {
                        this._opened = !1, this._chevron && (this._chevron.style.rotate = "");
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, Dl.listenForMenuClosure)(this, this.close.bind(this));
                    }
                    handleButtonSlotChange(le1) {
                        this._btn = le1.target.assignedNodes().pop(), this._btn && (this._chevron = this._btn.querySelector("svg.fa-chevron-down"), this._chevron && (this._chevron.style.transition = "rotate 0.2s", this._chevron.style.rotate = this._opened ? "180deg" : ""), this._btn.addEventListener("click", ()=>{
                            this._opened ? this.close() : this.open();
                        }));
                    }
                    adjustMenuPosition(le1) {
                        const vt = this.shadowRoot.querySelector("div[part='menu']");
                        vt.style.top = null, vt.style.bottom = null, vt.style.right = null, vt.style.left = null, vt.style.overflowY = null, vt.style.marginTop = null;
                        const bt = le1.getBoundingClientRect();
                        let ls = vt.getBoundingClientRect();
                        const ho = ls.right <= window.innerWidth - 10, Dl = ls.bottom <= window.innerHeight - 10;
                        ho && Dl ? vt.style.top = `${bt.bottom + 5}px` : ho || Dl ? Dl ? ho || (vt.style.marginTop = "5px", vt.style.right = window.innerWidth - bt.right + "px") : (vt.style.bottom = "10px", vt.style.top = `${bt.bottom + 5}px`, vt.style.overflowY = "auto") : (vt.style.right = window.innerWidth - bt.left + 5 + "px", vt.style.bottom = window.innerHeight - bt.bottom + "px", ls = vt.getBoundingClientRect(), ls.top - 10 < 0 && (vt.style.bottom = "10px", vt.style.top = `${bt.top}px`, vt.style.overflowY = "auto"));
                    }
                    render() {
                        const le1 = {
                            "pnx-panel": !0,
                            "pnx-panel-fixed": !0,
                            "pnx-hidden": !this._opened,
                            "pnx-padded": "false" !== this.padded
                        };
                        return ls.qy`<div class="container" @click=${(le1)=>le1.stopPropagation()}>
			<slot name="button" @slotchange=${this.handleButtonSlotChange}></slot>
			<div class=${(0, Fl.H)(le1)} part="menu">
				<slot></slot>
			</div>
		</div>`;
                    }
                }
                TogglableGroup.styles = [
                    ho.nd,
                    ls.AH`
		div.container {
			position: relative;
			height: 100%;
		}

		.pnx-panel { z-index: 130; }
		.pnx-panel-fixed { position: fixed; }
	`
                ], TogglableGroup.properties = {
                    _opened: {
                        state: !0
                    },
                    padded: {
                        type: String
                    }
                }, customElements.define("pnx-togglable-group", TogglableGroup);
            },
            7091: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    AnnotationsSwitch: ()=>uc.A,
                    Button: ()=>ho.A,
                    ButtonGroup: ()=>ls.A,
                    CopyButton: ()=>Dl.A,
                    Grade: ()=>Fl.A,
                    GradeFilter: ()=>sc.A,
                    LinkButton: ()=>mc.A,
                    ListGroup: ()=>gc.A,
                    ListItem: ()=>Ac.A,
                    Loader: ()=>Ec.A,
                    Map: ()=>kc.A,
                    MapMore: ()=>du.A,
                    Photo: ()=>_u.Ay,
                    Popup: ()=>Md.A,
                    ProgressBar: ()=>Ld.A,
                    QualityScore: ()=>Nd.A,
                    SearchBar: ()=>Rd.A,
                    SemanticsEditor: ()=>Od.A,
                    SemanticsTable: ()=>jd.A,
                    Switch: ()=>Ud.A,
                    TogglableGroup: ()=>Gd.A,
                    widgets: ()=>qd
                });
                var ls = bt(7679), ho = bt(4450), Dl = bt(1903), Fl = bt(5051), sc = bt(9041), uc = bt(6254), mc = bt(438), gc = bt(5271), Ac = bt(5525), Ec = bt(3109), kc = bt(5642), du = bt(2771), _u = bt(9048), Md = bt(4374), Ld = bt(4364), Nd = bt(2675), Rd = bt(3409), Od = bt(8780), jd = bt(2373), Ud = bt(1578), Gd = bt(5202), qd = bt(222);
            },
            5114: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>CopyCoordinates
                });
                var ls = bt(4542), ho = bt(7343), Dl = bt(5995), Fl = bt(2593), sc = bt(8591);
                class CopyCoordinates extends ls.WF {
                    render() {
                        var le1, vt;
                        const bt = (0, ho.degToDms)(this.gps[0]), sc = bt.d < 0 ? `${Math.abs(bt.d)}\xb0${bt.m}'${bt.s}"W` : `${bt.d}\xb0${bt.m}'${bt.s}"E`, uc = (0, ho.degToDms)(this.gps[1]), mc = uc.d < 0 ? `${Math.abs(uc.d)}\xb0${uc.m}'${uc.s}"S` : `${uc.d}\xb0${uc.m}'${uc.s}"N`, gc = {
                            ddeclatlon: `${this.gps[1].toFixed(5)}, ${this.gps[0].toFixed(5)}`,
                            ddeclonlat: `${this.gps[0].toFixed(5)}, ${this.gps[1].toFixed(5)}`,
                            ddmslonlat: `${sc}, ${mc}`,
                            ddmslatlon: `${mc}, ${sc}`
                        };
                        return ls.qy`<pnx-button-group style="display: inline-block; vertical-align: baseline" dir="row">
			<pnx-copy-button
				size="sm"
				text=${gc.ddeclonlat}
				title=${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.metadata_location_copy.replace("{v}", gc.ddeclonlat)}
			></pnx-copy-button>

			<pnx-togglable-group padded="false" ._parent=${this._parent}>
				<pnx-button
					size="sm"
					slot="button"
					title=${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.metadata_location_copy_more}
				>${(0, Dl.fa)(Fl.Jt)}</pnx-button>
				<pnx-list-group>
					${Object.values(gc).map((le1)=>{
                            var vt;
                            return ls.qy`
						<pnx-copy-button unstyled text=${le1} ._t=${this._parent._t}>
							${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.metadata_location_copy.replace("{v}", le1)}
						</pnx-copy-button>
					`;
                        })}
				</pnx-list-group>
			</pnx-togglable-group>
		</pnx-button-group>`;
                    }
                }
                CopyCoordinates.styles = [
                    sc.kq,
                    ls.AH`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
                ], CopyCoordinates.properties = {
                    gps: {
                        type: Array
                    }
                }, customElements.define("pnx-copy-coordinates", CopyCoordinates);
            },
            2603: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>GeoSearch
                });
                var ls = bt(927), ho = bt.n(ls), Dl = bt(4542), Fl = bt(3606), sc = bt(5995);
                bt(3630);
                const uc = {
                    ban: Fl.forwardGeocodingBAN,
                    standard: Fl.forwardGeocodingStandard,
                    nominatim: Fl.forwardGeocodingNominatim
                };
                class GeoSearch extends Dl.WF {
                    constructor(){
                        super(), this.geocoder = "nominatim", this._geolocateCtrl = new (ho()).GeolocateControl({
                            positionOptions: {
                                enableHighAccuracy: !0,
                                timeout: 6e4,
                                maximumAge: 3e5
                            },
                            showAccuracyCircle: !0,
                            showUserLocation: !0,
                            trackUserLocation: !0
                        });
                    }
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._geocoderEngine = uc[this.geocoder] || ((le1)=>uc.standard(le1, this.geocoder)), (0, sc.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.onceMapReady) || void 0 === vt ? void 0 : vt.call(le1).then(()=>{
                                this._geolocate || (this._geolocate = this._geolocateCtrl.onAdd(this._parent.map), this._geolocate.setAttribute("slot", "pre"));
                            });
                        });
                    }
                    _onInput(le1) {
                        const vt = le1.match(/([-+]?\d{1,2}\.\d+),\s*([-+]?\d{1,3}\.\d+)/), bt = le1.match(/^[0-9a-fA-F]{8}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{4}\b-[0-9a-fA-F]{12}$/);
                        if (vt) {
                            const le1 = parseFloat(vt[1]), bt = parseFloat(vt[2]);
                            return this._parent.map.jumpTo({
                                center: [
                                    bt,
                                    le1
                                ],
                                zoom: 16
                            }), Promise.resolve(!0);
                        }
                        return bt ? (this._parent.select(null, le1), Promise.resolve(!0)) : this._geocoderEngine({
                            query: le1,
                            limit: 5,
                            proximity: this._parent.map.getCenter().lat + "," + this._parent.map.getCenter().lng
                        }).then((le1)=>le1 = le1.features.map((le1)=>({
                                    title: le1.place_name.split(",")[0],
                                    subtitle: le1.place_name.split(",").slice(1).join(", "),
                                    data: le1
                                })));
                    }
                    _onSelect(le1) {
                        const vt = le1.detail;
                        var bt, ls;
                        vt && (vt.data.bounds ? null === (bt = this._parent) || void 0 === bt || bt.map.fitBounds(vt.data.bounds, {
                            animate: !1
                        }) : null === (ls = this._parent) || void 0 === ls || ls.map.jumpTo({
                            center: vt.data.center,
                            zoom: vt.data.zoom || 13
                        }));
                    }
                    render() {
                        var le1, vt;
                        const bt = (null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.isWidthSmall()) || !1;
                        return Dl.qy`
			<pnx-search-bar
				id="pnx-widget-search-bar"
				placeholder=${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.search_address}
				._parent=${this._parent}
				.searcher=${this._onInput.bind(this)}
				.reduceable=${bt}
				.reduced=${bt}
				size="xxl"
				class="pnx-print-hidden"
				@result=${this._onSelect.bind(this)}
			>
				${this._geolocate}
			</pnx-search-bar>
		`;
                    }
                }
                GeoSearch.properties = {
                    geocoder: {
                        type: String
                    },
                    _geolocate: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-geosearch", GeoSearch);
            },
            4385: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Legend
                });
                var ls = bt(4542), ho = bt(8591), Dl = bt(5995), Fl = bt(6668), sc = bt(5940), uc = bt(1198), mc = bt(7208);
                class Legend extends ls.WF {
                    constructor(){
                        super(), this.light = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, Dl.onceParentAvailable)(this).then(()=>this.requestUpdate());
                    }
                    render() {
                        var le1, vt, bt, ho;
                        const gc = {
                            "pnx-panel": !0,
                            "pnx-padded": "map" == this.focus,
                            "pnx-legend-light": this.light
                        };
                        return ls.qy`<div class=${(0, uc.H)(gc)} part="panel">
			<div
				class="presentation"
				style=${!this.light && "map" != this.focus && this.picture ? "display: none" : ""}
			>
				<img class="logo" src=${sc} alt="" />

				${this.light ? ls.qy`
					&copy; <a
						href=${(0, mc.PanoramaxWebsiteURL)()}
						title=${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.map.more_panoramax}
						target="_blank"
					>${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.panoramax}</a> |
				` : ls.qy`
					<div>
						${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.whats_panoramax}
						<pnx-link-button
							title=${null === (ho = this._parent) || void 0 === ho ? void 0 : ho._t.map.more_panoramax}
							kind="superinline"
							href=${(0, mc.PanoramaxWebsiteURL)()}
							target="_blank"
							size="sm"
						>
							${(0, Dl.fa)(Fl.iW)}
						</pnx-link-button>
					</div>
				`}
			</div>
			<pnx-picture-legend
				._parent=${this._parent}
				style=${"map" == this.focus ? "display: none" : ""}
				collapsable
				light=${this.light || ls.s6}
			>
				<slot slot="editors" name="editors">
					<pnx-widget-osmeditors ._parent=${this._parent} />
				</slot>
			</pnx-picture-legend>
			<pnx-map-legend
				._parent=${this._parent}
				style=${"map" != this.focus ? "display: none" : ""}
				light=${this.light || ls.s6}
			></pnx-map-legend>
		</div>`;
                    }
                }
                Legend.styles = [
                    ho.nd,
                    ls.AH`
		:host {
			pointer-events: none;
		}
		.pnx-panel[part="panel"] {
			border-radius: 10px;
			position: relative;
			max-width: 450px;
			z-index: 121; /* To appear above mini component */
			min-width: unset;
			pointer-events: auto;
		}
		.pnx-panel[part="panel"].pnx-padded {
			padding: 10px;
			width: 250px;
		}
		.presentation {
			font-size: 0.85em;
			line-height: 1em;
			display: flex;
			gap: 5px;
			align-items: center;
		}
		.logo {
			width: 45px;
		}
		pnx-map-legend {
			display: block;
			margin-top: 5px;
		}

		/* Lighter/smaller version */
		.pnx-panel[part="panel"].pnx-legend-light {
			display: flex;
			gap: 3px;
			padding: 3px 8px 3px 3px;
			width: unset;
			min-width: unset;
			align-items: center;
			font-size: 10px;
			margin-right: -10px;
			margin-bottom: -10px;
			border-radius: 0;
			border-top-left-radius: 5px;
			border-right: none;
  			border-bottom: none;
		}
		.pnx-legend-light a,
		.pnx-legend-light .presentation {
			font-size: 10px;
		}
		.pnx-legend-light .logo {
			width: 15px;
		}

		.pnx-legend-light pnx-map-legend {
			width: max-content;
			margin-top: unset;
			font-size: 10px;
		}
	`
                ], Legend.properties = {
                    focus: {
                        type: String
                    },
                    picture: {
                        type: String
                    },
                    light: {
                        type: Boolean
                    }
                }, customElements.define("pnx-widget-legend", Legend);
            },
            6996: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>LevelSelect
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(5195), Fl = bt(4420), sc = bt(7261), uc = bt(3624);
                bt(1870), bt(1811);
                class LevelSelect extends ls.WF {
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        var le1, vt;
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(null === (le1 = (vt = this._parent).onceMapReady) || void 0 === le1 ? void 0 : le1.call(vt)).then(()=>{
                            this._parent.map.indoorEqual.on("levelchange", ()=>this.requestUpdate()), this._parent.map.indoorEqual.on("levelschange", ()=>this.requestUpdate());
                        });
                    }
                    updated(le1) {
                        super.updated(le1), this._expanded && (null !== le1 && void 0 !== le1 && le1.has("_expanded") ? this._scrollToCurrentLevel(!1, "instant") : this._scrollToCurrentLevel(!0, "smooth"));
                    }
                    _scrollToCurrentLevel(le1, vt) {
                        const bt = this.renderRoot.querySelector(".pnx-level-active");
                        setTimeout(()=>null === bt || void 0 === bt ? void 0 : bt.scrollIntoView({
                                behavior: vt,
                                block: "center",
                                container: "nearest"
                            }), le1 ? 0 : 50);
                    }
                    render() {
                        var le1, vt, bt, mc, gc, Ac, Ec, kc;
                        const du = this._parent.map.indoorEqual;
                        if (du.level === Dl.DISABLED_LEVEL || 0 === du.levels.length) return ls.s6;
                        const _u = du.levels.findIndex((le1)=>le1 == du.level), Md = _u > 0 ? _u - 1 : null, Ld = null !== Md ? du.levels[Md] : null, Nd = _u < du.levels.length - 1 ? _u + 1 : null, Rd = null !== Nd ? du.levels[Nd] : null;
                        return ls.qy`
			<pnx-button-group
				dir="column"
				size="xl"
				class="pnx-print-hidden"
			>
				<pnx-button
					kind="superflat"
					@click=${()=>du.setLevel(Ld)}
					.disabled=${null === Ld}
					class="pnx-level-minimal"
					title=${null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1._t) || void 0 === vt ? void 0 : vt.pnx.indoor_selector_levelup}
				>${(0, ho.fa)(Fl.S$)}</pnx-button>

				${this._expanded ? ls.qy`
					<pnx-button-group
						dir="column"
						size="xl"
						class="pnx-print-hidden pnx-level-scroller"
					>
						${du.levels.map((le1)=>ls.qy`
							<pnx-button
								kind="superflat"
								@click=${()=>du.setLevel(le1)}
								class=${le1.length > 2 ? "pnx-level-long" : null}
							>
								${du.level == le1 ? ls.qy`<span class="pnx-level-active">${le1}</span>` : le1}
							</pnx-button>
						`)}
					</pnx-button-group>
				` : ls.qy`
					<pnx-button
						kind="superflat"
						class="pnx-level-minimal"
						title=${null === (bt = this._parent) || void 0 === bt || null === (mc = bt._t) || void 0 === mc ? void 0 : mc.pnx.indoor_selector_expand}
						@click=${du.levels.length > 1 ? ()=>this._expanded = !0 : null}
					>${du.level}</pnx-button>
				`}

				<pnx-button
					kind="superflat"
					@click=${()=>du.setLevel(Rd)}
					.disabled=${null === Rd}
					class="pnx-level-minimal"
					title=${null === (gc = this._parent) || void 0 === gc || null === (Ac = gc._t) || void 0 === Ac ? void 0 : Ac.pnx.indoor_selector_leveldown}
				>${(0, ho.fa)(sc.xB)}</pnx-button>

				${this._expanded ? ls.qy`
					<pnx-button
						kind="flat"
						class="pnx-level-shrink"
						@click=${()=>this._expanded = !1}
						title=${null === (Ec = this._parent) || void 0 === Ec || null === (kc = Ec._t) || void 0 === kc ? void 0 : kc.pnx.indoor_selector_shrink}
					>${(0, ho.fa)(uc.GR)}</pnx-button>
				` : ls.s6}
			</pnx-button-group>
		`;
                    }
                }
                LevelSelect.properties = {
                    _expanded: {
                        state: !0
                    }
                }, customElements.define("pnx-level-select", LevelSelect);
            },
            4529: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapFiltersButton
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(1904), Fl = bt(2593), sc = bt(6627), uc = bt(8591), mc = bt(2771);
                class MapFiltersButton extends ls.WF {
                    constructor(){
                        super(), this["user-search"] = !1, this["quality-score"] = !1, this._active = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.onceMapReady) || void 0 === vt ? void 0 : vt.call(le1).then(()=>{
                                this._active = Object.keys(this._parent.map._mapFilters).filter((le1)=>le1 && "theme" !== le1).length > 0 || this._parent.map.getVisibleUsers().filter((le1)=>"geovisio" !== le1).length > 0, this._parent.map.on("filters-changed", (le1)=>{
                                    this._active = Object.keys(le1).filter((le1)=>le1 && mc.T.includes(le1) && "theme" != le1).length > 0 || this._parent.map.getVisibleUsers().filter((le1)=>"geovisio" !== le1).length > 0;
                                }), this._parent.map.on("users-changed", (le1)=>{
                                    this._active = Object.keys(this._parent.map._mapFilters).filter((le1)=>le1 && "theme" !== le1).length > 0 || le1.usersIds.filter((le1)=>"geovisio" !== le1).length > 0;
                                });
                            });
                        });
                    }
                    render() {
                        var le1, vt;
                        const bt = null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.isWidthSmall(), uc = (0, ho.fa)(sc.faXmark, {
                            styles: {
                                "pointer-events": "auto"
                            }
                        });
                        return uc.addEventListener("click", (le1)=>{
                            le1.stopPropagation(), this.shadowRoot.querySelector("pnx-map-filters-menu")._onReset(), this.shadowRoot.querySelector("#pnx-widget-filter")._opened = !1;
                        }), ls.qy`
			<pnx-togglable-group
				id="pnx-widget-filter"
				padded="false"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${(0, ho.fa)(Dl._$)}
					${this._active ? ls.qy`<span class="pnx-active-icon"></span>` : ls.s6}
					${bt ? ls.s6 : null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.filters}
					${bt ? ls.s6 : this._active ? uc : (0, ho.fa)(Fl.Jt)}
				</pnx-button>
				<pnx-map-filters-menu
					id="pnx-map-filters-menu"
					._parent=${this._parent}
					user-search=${this["user-search"]}
					quality-score=${this["quality-score"]}
				></pnx-map-filters-menu>
			</pnx-togglable-group>
		`;
                    }
                }
                MapFiltersButton.styles = [
                    uc.s0
                ], MapFiltersButton.properties = {
                    "user-search": {
                        type: Boolean
                    },
                    "quality-score": {
                        type: Boolean
                    },
                    _active: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-mapfilters", MapFiltersButton);
            },
            1614: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>MapLayersButton
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(4220), Fl = bt(2593), sc = bt(6627), uc = bt(8591);
                class MapLayersButton extends ls.WF {
                    constructor(){
                        super(), this._active = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback();
                        const le1 = [
                            void 0,
                            null,
                            "",
                            "default"
                        ];
                        (0, ho.onceParentAvailable)(this).then(()=>{
                            var vt, bt;
                            return null === (vt = this._parent) || void 0 === vt || null === (bt = vt.onceMapReady) || void 0 === bt ? void 0 : bt.call(vt).then(()=>{
                                this._active = !le1.includes(this._parent.map._mapFilters.theme), this._parent.map.on("filters-changed", (vt)=>{
                                    this._active = !le1.includes(vt.theme);
                                });
                            });
                        });
                    }
                    render() {
                        var le1, vt;
                        const bt = null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1.isWidthSmall(), uc = (0, ho.fa)(sc.faXmark, {
                            styles: {
                                "pointer-events": "auto"
                            }
                        });
                        return uc.addEventListener("click", (le1)=>{
                            le1.stopPropagation();
                            const vt = this.shadowRoot.querySelector("pnx-map-layers-menu");
                            vt.shadowRoot.querySelector("#pnx-map-theme").value = "default", vt._onThemeSelect({
                                target: {
                                    value: "default"
                                }
                            }), this.shadowRoot.querySelector("#pnx-widget-map-layers")._opened = !1;
                        }), ls.qy`
			<pnx-togglable-group
				id="pnx-widget-map-layers"
				class="pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${(0, ho.fa)(Dl.qI)}
					${this._active ? ls.qy`<span class="pnx-active-icon"></span>` : ls.s6}
					${bt ? ls.s6 : null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.layers}
					${bt ? ls.s6 : this._active ? uc : (0, ho.fa)(Fl.Jt)}
				</pnx-button>
				<pnx-map-layers-menu
					id="pnx-map-layers-menu"
					._parent=${this._parent}
				></pnx-map-layers-menu>
			</pnx-togglable-group>
		`;
                    }
                }
                MapLayersButton.styles = [
                    uc.s0
                ], MapLayersButton.properties = {
                    _active: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-maplayers", MapLayersButton);
            },
            5789: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>OSMEditors
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(7343), Fl = bt(7208), sc = bt(3520), uc = bt(6787), mc = bt(7704);
                const gc = "http://127.0.0.1:8111";
                class OSMEditors extends ls.WF {
                    constructor(){
                        super(), this._josm = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            this._parent.onceFirstPicLoaded().then(this._onPictureLoad.bind(this)), this._parent.psv.addEventListener("picture-loaded", this._onPictureLoad.bind(this));
                        });
                    }
                    _onPictureLoad() {
                        var le1, vt;
                        this._pic = null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.getPictureMetadata();
                    }
                    _toggleJOSMLive() {
                        var le1, vt, bt, ls, ho, Fl;
                        (this._josm = !this._josm, this._josm) ? fetch(gc + "/version").then(()=>{
                            var le1, vt, bt, ls, ho, Fl, sc, uc, mc;
                            const Ac = (0, Dl.josmBboxParameters)(null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt || null === (bt = vt.getPictureMetadata) || void 0 === bt ? void 0 : bt.call(vt));
                            if (Ac) fetch(`${gc}/load_and_zoom?${Ac}`).catch((le1)=>{
                                console.warn(le1), this._toggleJOSMLive();
                            });
                            this._josmListener = ()=>{
                                var le1, vt, bt;
                                const ls = (0, Dl.josmBboxParameters)(null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt || null === (bt = vt.getPictureMetadata) || void 0 === bt ? void 0 : bt.call(vt));
                                if (ls) fetch(`${gc}/zoom?${ls}`).catch((le1)=>{
                                    console.warn(le1), this._toggleJOSMLive();
                                });
                            }, null === (ls = this._parent) || void 0 === ls || null === (ho = ls.psv) || void 0 === ho || null === (Fl = ho.addEventListener) || void 0 === Fl || Fl.call(ho, "picture-loaded", this._josmListener), null === (sc = this._parent) || void 0 === sc || null === (uc = sc.psv) || void 0 === uc || null === (mc = uc.addEventListener) || void 0 === mc || mc.call(uc, "picture-loading", this._josmListener);
                        }).catch((le1)=>{
                            var vt;
                            console.warn(le1), alert(null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.error_josm), this._toggleJOSMLive();
                        }) : this._josmListener && (null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt || null === (bt = vt.removeEventListener) || void 0 === bt || bt.call(vt, "picture-loading", this._josmListener), null === (ls = this._parent) || void 0 === ls || null === (ho = ls.psv) || void 0 === ho || null === (Fl = ho.removeEventListener) || void 0 === Fl || Fl.call(ho, "picture-loaded", this._josmListener), delete this._josmListener);
                    }
                    render() {
                        var le1, vt;
                        if (!this._pic) return ls.s6;
                        if (null !== (le1 = this._parent) && void 0 !== le1 && le1.isWidthSmall()) return ls.qy`
				<pnx-link-button
					size="sm"
					href="geo:${this._pic.gps[1]},${this._pic.gps[0]};u=3"
				>
					${(0, ho.fa)(mc.A)} ${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.geo_uri}
				</pnx-link-button>
			`;
                        {
                            var bt, Dl, gc, Ac;
                            const le1 = {
                                map: `19/${this._pic.gps[1]}/${this._pic.gps[0]}`,
                                source: "Panoramax",
                                photo_overlay: "panoramax",
                                photo: `panoramax/${this._pic.id}`
                            }, vt = le1 && `${(0, Fl.IdEditorURL)()}#${new URLSearchParams(le1).toString()}`;
                            return ls.qy`
				<pnx-link-button
					size="sm"
					href=${vt}
					target="_blank"
					title="${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.contribute_id}"
				>
					${(0, ho.fa)(sc.faLocationDot)} ${null === (Dl = this._parent) || void 0 === Dl ? void 0 : Dl._t.pnx.id}
				</pnx-link-button>

				<pnx-button
					id="pnx-edit-josm"
					size="sm"
					active=${this._josm ? "" : ls.s6}
					@click=${this._toggleJOSMLive}
					title="${null === (gc = this._parent) || void 0 === gc ? void 0 : gc._t.pnx.josm_live}"
				>
					${(0, ho.fa)(uc.hU)} ${null === (Ac = this._parent) || void 0 === Ac ? void 0 : Ac._t.pnx.josm}
				</pnx-button>
			`;
                        }
                    }
                }
                OSMEditors.properties = {
                    _pic: {
                        state: !0
                    },
                    _josm: {
                        state: !0
                    }
                }, OSMEditors.styles = ls.AH`
		:host { display: inline-flex; gap: 5px; }
		:host > * { flex: 1; }
		pnx-link-button::part(btn) { height: auto; }
	`, customElements.define("pnx-widget-osmeditors", OSMEditors);
            },
            8806: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PictureLegendActions
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(3613), Fl = bt(8591);
                class PictureLegendActions extends ls.WF {
                    constructor(){
                        super(), this.full = !1;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>this._parent.onceReady()).then(()=>{
                            this._meta = this._parent.psv.getPictureMetadata(), this._parent.psv.addEventListener("picture-loaded", ()=>{
                                this._meta = this._parent.psv.getPictureMetadata();
                            });
                        });
                    }
                    _onPrint() {
                        this._closeGroup(), window.print();
                    }
                    _closeGroup() {
                        this.renderRoot.querySelector("#pic-legend-headline-menu").close();
                    }
                    render() {
                        var le1, vt, bt, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md;
                        return ls.qy`<pnx-togglable-group padded="false" id="pic-legend-headline-menu" ._parent=${this._parent}>
			<pnx-button slot="button" kind="inline">${(0, ho.fa)(Dl.v)}</pnx-button>
			<pnx-list-group class="pnx-print-hidden" @click=${this._closeMenu}>
				${this._meta ? ls.qy`<pnx-copy-button ._t=${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t} text=${this._meta.id} unstyled>
					${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.metadata_general_copy_picid}
				</pnx-copy-button>` : ls.s6}

				<a
					download
					target="_blank"
					href=${null === (bt = this._meta) || void 0 === bt || null === (Fl = bt.panorama) || void 0 === Fl ? void 0 : Fl.hdUrl}
					@click=${this._closeGroup}
				>${null === (sc = this._parent) || void 0 === sc ? void 0 : sc._t.pnx.share_image}</a>

				${this._parent.isWidthSmall() ? ls.s6 : ls.qy`<button @click=${this._onPrint}>
					${null === (uc = this._parent) || void 0 === uc ? void 0 : uc._t.pnx.share_print}
				</button>`}

				${(null === (mc = this._parent) || void 0 === mc || null === (gc = mc.api) || void 0 === gc ? void 0 : gc.getRSSURL()) && ls.qy`
					<a
						target="_blank"
						href=${null === (Ac = this._parent) || void 0 === Ac ? void 0 : Ac.api.getRSSURL(null === (Ec = this._parent) || void 0 === Ec || null === (kc = Ec.map) || void 0 === kc || null === (du = kc.getBounds) || void 0 === du ? void 0 : du.call(kc))}
						title=${null === (_u = this._parent) || void 0 === _u ? void 0 : _u._t.pnx.share_rss_title}
						@click=${this._closeGroup}
					>
						${null === (Md = this._parent) || void 0 === Md ? void 0 : Md._t.pnx.share_rss}
					</a>
				`}
			</pnx-list-group>
		</pnx-togglable-group>`;
                    }
                }
                PictureLegendActions.styles = [
                    Fl.BQ,
                    ls.AH`
		pnx-togglable-group::part(menu) {
			border-radius: 5px;
			min-width: unset;
		}
	`
                ], PictureLegendActions.properties = {
                    full: {
                        type: Boolean
                    },
                    _meta: {
                        state: !0
                    }
                }, customElements.define("pnx-picture-legend-actions", PictureLegendActions);
            },
            8305: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Player
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(1705), Fl = bt(6386), sc = bt(7472), uc = bt(5431), mc = bt(6533);
                bt(1230);
                class Player extends ls.WF {
                    constructor(){
                        super(), this.playing = !1, this.size = "xl", this.more = "depends", this._activePrev = !0, this._activePlay = !0, this._activeNext = !0;
                    }
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, ho.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.oncePSVReady) || void 0 === vt ? void 0 : vt.call(le1).then(()=>{
                                this._parent.psv.addEventListener("sequence-playing", ()=>this.playing = !0), this._parent.psv.addEventListener("sequence-stopped", ()=>this.playing = !1), this._parent.psv.addEventListener("picture-loaded", this._changeActiveStates.bind(this)), this._parent.psv.addEventListener("pictures-navigation-changed", this._changeActiveStates.bind(this)), this._changeActiveStates();
                            });
                        });
                    }
                    _changeActiveStates() {
                        var le1, vt, bt, ls, ho, Dl;
                        "pic" === (null === (le1 = (vt = this._parent.psv).getPicturesNavigation) || void 0 === le1 ? void 0 : le1.call(vt)) ? (this._activeNext = !1, this._activePlay = !1, this._activePrev = !1) : (this._activePrev = null != (null === (bt = this._parent.psv.getPictureMetadata()) || void 0 === bt || null === (ls = bt.sequence) || void 0 === ls ? void 0 : ls.prevPic), null != (null === (ho = this._parent.psv.getPictureMetadata()) || void 0 === ho || null === (Dl = ho.sequence) || void 0 === Dl ? void 0 : Dl.nextPic) ? (this._activeNext = !0, this._activePlay = !0) : (this._activeNext = !1, this._activePlay = !1));
                        this.requestUpdate();
                    }
                    _onPlayClick() {
                        var le1, vt, bt, ls, ho, Dl;
                        null !== (le1 = this._parent) && void 0 !== le1 && null !== (vt = le1.psv) && void 0 !== vt && vt.isSequencePlaying() ? (this.playing = !1, null === (bt = this._parent) || void 0 === bt || null === (ls = bt.psv) || void 0 === ls || ls.stopSequence()) : (this.playing = !0, null === (ho = this._parent) || void 0 === ho || null === (Dl = ho.psv) || void 0 === Dl || Dl.playSequence());
                    }
                    render() {
                        var le1, vt, bt, gc, Ac, Ec, kc, du;
                        return null !== (le1 = this._parent) && void 0 !== le1 && null !== (vt = le1.psv) && void 0 !== vt && vt.addEventListener ? ls.qy`
			<pnx-button-group
				id="pnx-widget-player"
				dir="row"
				size=${this.size}
				class="pnx-print-hidden"
				style=${this._activePrev || this._activePlay || this._activeNext ? "" : "display: none"}
			>
				<pnx-button
					kind="superflat"
					id="pnx-player-prev"
					title=${null === (bt = this._parent) || void 0 === bt ? void 0 : bt._t.pnx.sequence_prev}
					@click=${()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.goToPrevPicture();
                        }}
					.disabled=${!this._activePrev}
				>${(0, ho.fa)(Dl.TH)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-play"
					title=${this.playing ? null === (gc = this._parent) || void 0 === gc ? void 0 : gc._t.pnx.sequence_pause : null === (Ac = this._parent) || void 0 === Ac ? void 0 : Ac._t.pnx.sequence_play}
					.disabled=${!this._activePlay}
					@click=${this._onPlayClick.bind(this)}
				>${this.playing ? (0, ho.fa)(sc.G1) : (0, ho.fa)(Fl.ij)}</pnx-button>

				<pnx-button
					kind="superflat"
					id="pnx-player-next"
					title=${null === (Ec = this._parent) || void 0 === Ec ? void 0 : Ec._t.pnx.sequence_next}
					.disabled=${!this._activeNext}
					@click=${()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.goToNextPicture();
                        }}
				>${(0, ho.fa)(uc.vF)}</pnx-button>

				${"never" === this.more || "always" !== this.more && null !== (kc = this._parent) && void 0 !== kc && kc.isWidthSmall() ? ls.s6 : ls.qy`
					<pnx-togglable-group padded="false" ._parent=${this._parent}>
						<pnx-button
							kind="flat"
							id="pnx-player-more"
							title=${null === (du = this._parent) || void 0 === du ? void 0 : du._t.pnx.sequence_more}
							class=${"depends" === this.more ? "pnx-xs-hidden" : ""}
							slot="button"
						>${(0, ho.fa)(mc.faEllipsisVertical)}</pnx-button>

						<pnx-player-options ._parent=${this._parent}></pnx-player-options>
					</pnx-togglable-group>
				`}
			</pnx-button-group>
		` : ls.s6;
                    }
                }
                Player.properties = {
                    playing: {
                        type: Boolean,
                        reflect: !0
                    },
                    size: {
                        type: String
                    },
                    more: {
                        type: String
                    },
                    _activePrev: {
                        state: !0
                    },
                    _activePlay: {
                        state: !0
                    },
                    _activeNext: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-player", Player);
            },
            6524: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>SemanticsFiltersButton
                });
                var ls = bt(4542), ho = bt(5995), Dl = bt(2593), Fl = bt(6627), sc = bt(6249), uc = bt(8591);
                class SemanticsFiltersButton extends ls.WF {
                    constructor(){
                        super(), this._active = !1;
                    }
                    _onLayersChange(le1) {
                        var vt, bt;
                        this._active = (null === (vt = le1.detail) || void 0 === vt || null === (bt = vt.layers) || void 0 === bt ? void 0 : bt.filter((le1)=>{
                            var vt;
                            return le1.metadata && "none" != (null === (vt = le1.layout) || void 0 === vt ? void 0 : vt.visibility);
                        }).length) > 0;
                    }
                    render() {
                        var le1, vt, bt, uc;
                        const mc = null === (le1 = this._parent.map) || void 0 === le1 || null === (vt = le1.getSemanticOverlays) || void 0 === vt ? void 0 : vt.call(le1);
                        if (!mc || 0 === mc.length) return;
                        const gc = null === (bt = this._parent) || void 0 === bt ? void 0 : bt.isWidthSmall(), Ac = (0, ho.fa)(Fl.faXmark, {
                            styles: {
                                "pointer-events": "auto"
                            }
                        });
                        return Ac.addEventListener("click", (le1)=>{
                            var vt, bt;
                            le1.stopPropagation(), null === (vt = this._parent) || void 0 === vt || null === (bt = vt.map) || void 0 === bt || bt.toggleAllSemanticOverlays(!1);
                        }), ls.qy`
			<pnx-togglable-group
				id="pnx-widget-semantics-filter"
				class="pnx-only-map pnx-print-hidden"
				._parent=${this._parent}
			>
				<pnx-button kind="flat" size="xl" slot="button">
					${(0, ho.fa)(sc.DX)}
					${this._active ? ls.qy`<span class="pnx-active-icon"></span>` : ls.s6}
					${gc ? ls.s6 : null === (uc = this._parent) || void 0 === uc ? void 0 : uc._t.pnx.semantics_title}
					${gc ? ls.s6 : this._active ? Ac : (0, ho.fa)(Dl.Jt)}
				</pnx-button>
				<pnx-map-semantics-filters-menu
					id="pnx-map-semantics-filters-menu"
					._parent=${this._parent}
					@change=${this._onLayersChange}
				></pnx-map-semantics-filters-menu>
			</pnx-togglable-group>
		`;
                    }
                }
                SemanticsFiltersButton.styles = [
                    uc.s0
                ], SemanticsFiltersButton.properties = {
                    _active: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-semantics-filters", SemanticsFiltersButton);
            },
            3023: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Zoom
                });
                var ls = bt(4542), ho = bt(9048), Dl = bt(3407), Fl = bt(5995), sc = bt(1372), uc = bt(7290);
                bt(1870);
                class Zoom extends ls.WF {
                    createRenderRoot() {
                        return this;
                    }
                    connectedCallback() {
                        super.connectedCallback(), (0, Fl.onceParentAvailable)(this).then(()=>{
                            var le1, vt;
                            return null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.oncePSVReady) || void 0 === vt ? void 0 : vt.call(le1).then(()=>{
                                var le1, vt;
                                this._lastWantedZoom = (null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt ? void 0 : vt.getZoomLevel()) || ho.cS;
                            });
                        });
                    }
                    _onClick(le1, vt) {
                        if (this._parent.map && this._parent.isMapWide()) vt ? this._parent.map.zoomIn({}, {
                            originalEvent: le1
                        }) : this._parent.map.zoomOut({}, {
                            originalEvent: le1
                        });
                        else {
                            this._parent.lastPsvAnim && this._parent.lastPsvAnim.cancel();
                            const le1 = vt ? Math.min(100, this._lastWantedZoom + Dl.$p) : Math.max(0, this._lastWantedZoom - Dl.$p);
                            this._parent.lastPsvAnim = this._parent.psv.animate({
                                speed: ho.LM,
                                zoom: le1
                            }), this._lastWantedZoom = le1;
                        }
                    }
                    render() {
                        var le1, vt;
                        return ls.qy`
			<pnx-button-group
				id="pnx-widget-zoom"
				dir="column"
				size="xl"
				class="pnx-mobile-hidden pnx-print-hidden"
			>
				<pnx-button
					id="pnx-zoom-in"
					kind="superflat"
					title=${null === (le1 = this._parent) || void 0 === le1 ? void 0 : le1._t.pnx.zoomIn}
					@click=${(le1)=>this._onClick(le1, !0)}
				>${(0, Fl.fa)(sc.QL)}</pnx-button>

				<pnx-button
					id="pnx-zoom-out"
					kind="superflat"
					title=${null === (vt = this._parent) || void 0 === vt ? void 0 : vt._t.pnx.zoomOut}
					@click=${(le1)=>this._onClick(le1, !1)}
				>${(0, Fl.fa)(uc.EZ)}</pnx-button>
			</pnx-button-group>
		`;
                    }
                }
                Zoom.properties = {
                    _lastWantedZoom: {
                        state: !0
                    }
                }, customElements.define("pnx-widget-zoom", Zoom);
            },
            222: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    CopyCoordinates: ()=>ls.A,
                    GeoSearch: ()=>ho.A,
                    Legend: ()=>Dl.A,
                    LevelSelect: ()=>Fl.A,
                    MapFiltersButton: ()=>sc.A,
                    MapLayersButton: ()=>uc.A,
                    OSMEditors: ()=>mc.A,
                    PictureLegendActions: ()=>gc.A,
                    Player: ()=>Ac.A,
                    SemanticsFiltersButton: ()=>Ec.A,
                    Zoom: ()=>kc.A
                });
                var ls = bt(5114), ho = bt(2603), Dl = bt(4385), Fl = bt(6996), sc = bt(4529), uc = bt(1614), mc = bt(5789), gc = bt(8806), Ac = bt(8305), Ec = bt(6524), kc = bt(3023);
            },
            5254: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>API
                });
                var ls = bt(7343);
                class API extends EventTarget {
                    constructor(le1){
                        let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                        if (super(), null === le1 || void 0 === le1 || "string" !== typeof le1) {
                            const le1 = new Error("endpoint parameter is empty or not a valid string");
                            throw this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: le1
                                }
                            })), le1;
                        }
                        if (le1.startsWith("/") && (le1 = window.location.href.split("/").slice(0, 3).join("/") + le1), !API.isValidHttpUrl(le1)) {
                            const vt = new Error(`endpoint parameter is not a valid URL: ${le1}`);
                            throw this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: vt
                                }
                            })), vt;
                        }
                        this._endpoint = le1, this._isReady = 0, this._dataBbox = null, this._fetchOpts = (null === vt || void 0 === vt ? void 0 : vt.fetch) || {}, this._metadata = {}, this._configuration = null, vt.skipReadLanding || (this._readLanding = fetch(le1, this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>this._parseLanding(le1, vt)).catch((le1)=>(this._isReady = -1, console.error(le1), this.dispatchEvent(new CustomEvent("broken", {
                                detail: {
                                    error: le1
                                }
                            })), Promise.reject("Viewer failed to communicate with API"))).then(()=>this._loadMapStyles(vt.style, vt.users)).then(()=>(this._isReady = 1, this.dispatchEvent(new Event("ready")), "API is ready")));
                    }
                    onceReady() {
                        return -1 == this._isReady ? Promise.reject("Viewer failed to communicate with API") : 1 == this._isReady ? Promise.resolve("API is ready") : this._readLanding;
                    }
                    isReady() {
                        return 1 == this._isReady;
                    }
                    getAvailableFeatures() {
                        return Object.entries(this._endpoints).filter((le1)=>null !== le1[1]).map((le1)=>le1[0]);
                    }
                    getUnavailableFeatures() {
                        return Object.entries(this._endpoints).filter((le1)=>null === le1[1]).map((le1)=>le1[0]);
                    }
                    _parseLanding(le1, vt) {
                        var bt, ls;
                        if (this._endpoints = {
                            collections: null,
                            search: null,
                            style: null,
                            user_style: null,
                            tiles: (null === vt || void 0 === vt ? void 0 : vt.tiles) || null,
                            user_tiles: null,
                            user_search: null,
                            collection_preview: null,
                            item_preview: null,
                            rss: null,
                            report: null,
                            queryables: null
                        }, !le1 || !le1.links || !Array.isArray(le1.links)) throw new Error("API Landing page doesn't contain 'links' list");
                        if (!le1.stac_version.startsWith("1.")) throw new Error(`API is not in a supported STAC version (Panoramax viewer supports only 1.x, API is ${le1.stac_version})`);
                        this._metadata.name = le1.title || "Unnamed", this._metadata.stac_version = le1.stac_version, this._metadata.geovisio_version = le1.geovisio_version;
                        const ho = [], Dl = [];
                        if ([
                            {
                                rel: "search",
                                type: "application/geo+json",
                                endpointId: "search",
                                mandatory: !0,
                                missingIssue: "No direct access to pictures metadata."
                            },
                            {
                                rel: "data",
                                type: "application/json",
                                endpointId: "collections",
                                mandatory: !0,
                                missingIssue: "No way for viewer to access sequences."
                            },
                            {
                                rel: "data",
                                type: "application/rss+xml",
                                endpointId: "rss"
                            },
                            {
                                rel: "xyz",
                                type: "application/vnd.mapbox-vector-tile",
                                endpointId: "tiles"
                            },
                            {
                                rel: "xyz-style",
                                type: "application/json",
                                endpointId: "style"
                            },
                            {
                                rel: "user-xyz-style",
                                type: "application/json",
                                endpointId: "user_style"
                            },
                            {
                                rel: "user-xyz",
                                type: "application/vnd.mapbox-vector-tile",
                                endpointId: "user_tiles"
                            },
                            {
                                rel: "user-search",
                                type: "application/json",
                                endpointId: "user_search",
                                missingIssue: "Filter map data by user name will not be available."
                            },
                            {
                                rel: "collection-preview",
                                type: "image/jpeg",
                                endpointId: "collection_preview",
                                missingIssue: "Display of thumbnail could be slower."
                            },
                            {
                                rel: "item-preview",
                                type: "image/jpeg",
                                endpointId: "item_preview",
                                missingIssue: "Display of thumbnail could be slower."
                            },
                            {
                                rel: "report",
                                type: "application/json",
                                endpointId: "report"
                            },
                            {
                                rel: "http://www.opengis.net/def/rel/ogc/1.0/queryables",
                                type: "application/schema+json",
                                endpointId: "queryables",
                                missingIssue: "Tags map overlay will not be available."
                            }
                        ].forEach((vt)=>{
                            const bt = le1.links.find((le1)=>le1.rel == vt.rel && le1.type == vt.type);
                            if (bt) {
                                if (!API.isValidHttpUrl(bt.href)) throw new Error(`API endpoint '${bt.rel}' (${bt.type}) is not a valid URL: ${bt.href}`);
                                this._endpoints[vt.endpointId] || (this._endpoints[vt.endpointId] = bt.href);
                            } else if (!this._endpoints[vt.endpointId]) {
                                let le1 = `API doesn't offer a '${vt.rel}' (${vt.type}) endpoint in its links`;
                                vt.missingIssue && (le1 += `\n${vt.missingIssue}`), vt.mandatory ? ho.push(le1) : vt.missingIssue && Dl.push(le1);
                            }
                        }), this._endpoints.style || this._endpoints.tiles || Dl.push("API doesn't offer 'xyz' or 'xyz-style' endpoints in its links.\nMap widget will not be available."), this._endpoints.user_style || this._endpoints.user_tiles || Dl.push("API doesn't offer 'user-xyz' or 'user-xyz-style' endpoints in its links.\nFilter map data by user ID will not be available."), Dl.forEach((le1)=>console.warn(le1)), ho.length > 0) throw new Error(ho.join("\n"));
                        const Fl = null === le1 || void 0 === le1 || null === (bt = le1.extent) || void 0 === bt || null === (ls = bt.spatial) || void 0 === ls ? void 0 : ls.bbox;
                        this._dataBbox = Fl && Array.isArray(Fl) && Fl.length > 0 && Array.isArray(Fl[0]) && 4 === Fl[0].length ? [
                            [
                                Fl[0][0],
                                Fl[0][1]
                            ],
                            [
                                Fl[0][2],
                                Fl[0][3]
                            ]
                        ] : null;
                    }
                    _loadMapStyles(le1, vt) {
                        const bt = new Set(vt || []);
                        this.mapStyle = {
                            version: 8,
                            sources: {},
                            layers: [],
                            metadata: {}
                        };
                        const ls = [
                            this.getMapStyle()
                        ];
                        if ("string" === typeof le1) {
                            const vt = le1.startsWith(this._endpoint) ? this._getFetchOptions() : void 0;
                            ls.push(fetch(le1, vt).then((le1)=>le1.json()));
                        } else "object" === typeof le1 && ls.push(Promise.resolve(le1));
                        return [
                            ...bt
                        ].filter((le1)=>"geovisio" !== le1).forEach((le1)=>{
                            ls.push(this.getUserMapStyle(le1, !0));
                        }), Promise.all(ls).then((le1)=>{
                            const vt = [
                                "bearing",
                                "center",
                                "glyphs",
                                "light",
                                "name",
                                "pitch",
                                "sky",
                                "sprite",
                                "terrain",
                                "transition",
                                "zoom"
                            ];
                            le1.forEach((le1)=>{
                                vt.forEach((vt)=>{
                                    le1[vt] && (this.mapStyle[vt] = le1[vt] || this.mapStyle[vt]);
                                }), Object.assign(this.mapStyle.sources, (null === le1 || void 0 === le1 ? void 0 : le1.sources) || {}), Object.assign(this.mapStyle.metadata, (null === le1 || void 0 === le1 ? void 0 : le1.metadata) || {}), this.mapStyle.layers = this.mapStyle.layers.concat((null === le1 || void 0 === le1 ? void 0 : le1.layers) || []);
                            });
                        }).catch((le1)=>console.error(le1));
                    }
                    _getFetchOptions() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] && arguments[0];
                        return Object.assign({
                            signal: le1 ? void 0 : AbortSignal.timeout(15e3)
                        }, this._fetchOpts);
                    }
                    _getMapRequestTransform() {
                        const le1 = this._getFetchOptions();
                        if (delete le1.signal, Object.keys(le1).length > 0) return (vt)=>{
                            if (vt.startsWith(this._endpoint)) return {
                                url: vt,
                                ...le1
                            };
                        };
                    }
                    _getPSVWithCredentials() {
                        return "include" === this._getFetchOptions().credentials ? (le1)=>le1.startsWith(this._endpoint) : void 0;
                    }
                    cleanResourceURL(le1) {
                        if (!le1) return;
                        const vt = new URL(this._endpoint);
                        return le1.startsWith("/") ? vt.protocol + "//" + vt.host + le1 : le1.startsWith("./") ? this._endpoint + le1.substring(1) : le1;
                    }
                    async getSequenceItems(le1) {
                        let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null, bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, ls = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        try {
                            return API.isIdValid(le1), fetch(vt || `${this._endpoints.collections}/${le1}/items${ls ? "?limit=" + ls : ""}`, this._getFetchOptions(!0)).then((le1)=>le1.json()).then((vt)=>{
                                let ho = vt;
                                bt && (ho.features = bt.features.concat(ho.features));
                                const Dl = vt.links.find((le1)=>"next" === le1.rel);
                                return !ls && Dl ? this.getSequenceItems(le1, Dl.href, ho) : ho;
                            });
                        } catch (ho) {
                            return Promise.reject(ho);
                        }
                    }
                    getPicturesAroundCoordinatesUrl(le1, vt) {
                        let bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : 5e-4, ls = arguments.length > 3 ? arguments[3] : void 0, ho = arguments.length > 4 ? arguments[4] : void 0;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (isNaN(parseFloat(le1)) || isNaN(parseFloat(vt))) throw new Error("lat and lon parameters should be valid numbers");
                        const Dl = [
                            vt - bt,
                            le1 - bt,
                            vt + bt,
                            le1 + bt
                        ].map((le1)=>le1.toFixed(7)).join(","), Fl = ls ? `&limit=${ls}` : "", sc = ho ? `&collections=${ho}` : "";
                        return `${this._endpoints.search}?bbox=${Dl}${Fl}${sc}`;
                    }
                    getPicturesAroundCoordinates(le1, vt, bt, ls, ho) {
                        return fetch(this.getPicturesAroundCoordinatesUrl(le1, vt, bt, ls, ho), this._getFetchOptions()).then((le1)=>le1.json());
                    }
                    getPictureMetadataUrl(le1, vt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (API.isIdValid(le1)) return vt ? `${this._endpoints.collections}/${vt}/items/${le1}` : `${this._endpoints.search}?ids=${le1}`;
                    }
                    getMapStyle() {
                        if (this.isReady()) return this.mapStyle;
                        let le1;
                        le1 = this._endpoints.style ? this._endpoints.style : this._endpoints.tiles ? {
                            version: 8,
                            sources: {
                                geovisio: {
                                    type: "vector",
                                    tiles: [
                                        this._endpoints.tiles
                                    ],
                                    minzoom: 0,
                                    maxzoom: 15
                                }
                            }
                        } : fetch(`${this._endpoint}/map/14/0/0.mvt`, this._getFetchOptions()).then(()=>(this._endpoints.tiles = `${this._endpoint}/map/{z}/{x}/{y}.mvt`, console.log("Using fallback endpoint for vector tiles"), this.getMapStyle())).catch((le1)=>(console.error(le1), Promise.reject(new Error("API doesn't offer a vector tiles endpoint"))));
                        const afterJson = (le1)=>(Object.values((null === le1 || void 0 === le1 ? void 0 : le1.sources) || {}).forEach((le1)=>le1.tiles = le1.tiles.map((le1)=>le1.replace(/^http/, "panora"))), le1);
                        return "string" === typeof le1 ? fetch(le1, this._getFetchOptions()).then((le1)=>le1.json()).then(afterJson) : Promise.resolve(le1).then(afterJson);
                    }
                    getUserMapStyle(le1) {
                        let vt;
                        return arguments.length > 1 && void 0 !== arguments[1] && arguments[1] || this.isReady() ? le1 ? (this._endpoints.user_style ? vt = this._endpoints.user_style.replace(/\{userId\}/g, le1) : this._endpoints.user_tiles && (vt = {
                            version: 8,
                            sources: {
                                [`geovisio_${le1}`]: {
                                    type: "vector",
                                    tiles: [
                                        this._endpoints.user_tiles.replace(/\{userId\}/g, le1)
                                    ],
                                    minzoom: 0,
                                    maxzoom: 15
                                }
                            }
                        }), vt ? "string" === typeof vt ? fetch(vt, this._getFetchOptions()).then((le1)=>le1.json()) : Promise.resolve(vt) : Promise.reject(new Error("API doesn't offer map style for specific user"))) : Promise.reject(new Error("Parameter userId is empty")) : Promise.reject(new Error("API is not ready to use"));
                    }
                    findThumbnailInPictureFeature(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!le1 || !le1.assets) return null;
                        let vt = null;
                        for (let bt of Object.values(le1.assets)){
                            if (bt.roles.includes("thumbnail") && "image/jpeg" == bt.type && API.isValidHttpUrl(bt.href)) return this.cleanResourceURL(bt.href);
                            bt.roles.includes("visual") && "image/jpeg" == bt.type && API.isValidHttpUrl(bt.href) && (vt = this.cleanResourceURL(bt.href));
                        }
                        return vt;
                    }
                    getPictureThumbnailURLForSequence(le1, vt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (this._endpoints.collection_preview) return Promise.resolve(this._endpoints.collection_preview.replace("{id}", le1));
                        if (vt && Array.isArray(vt.links) && vt.links.length > 0) {
                            let le1 = vt.links.find((le1)=>"preview" === le1.rel && "image/jpeg" === le1.type);
                            if (le1 && API.isValidHttpUrl(le1.href)) return Promise.resolve(le1.href);
                        }
                        const bt = `${this._endpoints.search}?limit=1&collections=${le1}`;
                        return fetch(bt, this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>Array.isArray(le1.features) && 0 != le1.features.length ? this.findThumbnailInPictureFeature(le1.features.pop()) : null);
                    }
                    getPictureThumbnailURL(le1, vt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return le1 ? this._endpoints.item_preview ? Promise.resolve(this._endpoints.item_preview.replace("{id}", le1)) : le1 && vt ? fetch(`${this._endpoints.collections}/${vt}/items/${le1}`, this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>le1 ? this.findThumbnailInPictureFeature(le1) : null) : fetch(`${this._endpoints.search}?ids=${le1}`, this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>le1 && Array.isArray(le1.features) && 0 != le1.features.length ? this.findThumbnailInPictureFeature(le1.features.pop()) : null) : Promise.resolve(null);
                    }
                    getRSSURL(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (this._endpoints.rss) {
                            let vt = this._endpoints.rss;
                            return le1 && (vt += vt.includes("?") ? "&" : "?", vt += "bbox=" + [
                                le1.getWest(),
                                le1.getSouth(),
                                le1.getEast(),
                                le1.getNorth()
                            ].join(",")), vt;
                        }
                        return null;
                    }
                    getSequenceMetadataUrl(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return `${this._endpoints.collections}/${le1}`;
                    }
                    getSequenceMetadata(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return fetch(this.getSequenceMetadataUrl(le1), this._getFetchOptions()).then((le1)=>le1.json());
                    }
                    getDataBbox() {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        return this._dataBbox;
                    }
                    searchUsers(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.user_search) throw new Error("User search is not available");
                        return fetch(`${this._endpoints.user_search}?q=${le1}`, this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>(null === le1 || void 0 === le1 ? void 0 : le1.features) || null);
                    }
                    getUserName(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.user_search) throw new Error("User search is not available");
                        return fetch(this._endpoints.user_search.replace(/\/search$/, `/${le1}`), this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>(null === le1 || void 0 === le1 ? void 0 : le1.label) || (null === le1 || void 0 === le1 ? void 0 : le1.name) || null);
                    }
                    sendReport(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (!this._endpoints.report) throw new Error("Report sending is not available");
                        const vt = {
                            ...this._getFetchOptions(),
                            method: "POST",
                            body: JSON.stringify(le1),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        return fetch(this._endpoints.report, vt).then(async (le1)=>{
                            if (le1.status >= 400) {
                                let bt = await le1.text();
                                try {
                                    bt = JSON.parse(bt).message;
                                } catch (vt) {}
                                return Promise.reject(bt);
                            }
                            return le1.json();
                        });
                    }
                    sendPictureSemantics(le1, vt) {
                        var bt;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (null === le1 || void 0 === le1 || null === (bt = le1.sequence) || void 0 === bt || !bt.id || null === le1 || void 0 === le1 || !le1.id) throw new Error("Missing IDs from picture");
                        let ls = this.getPictureMetadataUrl(le1.id, le1.sequence.id);
                        null !== le1 && void 0 !== le1 && le1.origInstance && (ls = `${le1.origInstance.href}/api/collections/${le1.sequence.id}/items/${le1.id}`);
                        const ho = {
                            ...this._getFetchOptions(),
                            method: "PATCH",
                            body: JSON.stringify({
                                semantics: vt
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        return fetch(ls, ho).then(async (le1)=>{
                            if (le1.status >= 400) {
                                let bt = await le1.text();
                                try {
                                    bt = JSON.parse(bt).message;
                                } catch (vt) {}
                                return Promise.reject(bt);
                            }
                            return le1.json();
                        });
                    }
                    createPictureAnnotation(le1, vt, bt) {
                        var ls;
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        if (null === le1 || void 0 === le1 || null === (ls = le1.sequence) || void 0 === ls || !ls.id || null === le1 || void 0 === le1 || !le1.id) throw new Error("Missing IDs from picture");
                        let ho = this.getPictureMetadataUrl(le1.id, le1.sequence.id) + "/annotations";
                        null !== le1 && void 0 !== le1 && le1.origInstance && (ho = `${le1.origInstance.href}/api/collections/${le1.sequence.id}/items/${le1.id}/annotations`);
                        const Dl = {
                            ...this._getFetchOptions(),
                            method: "POST",
                            body: JSON.stringify({
                                semantics: bt,
                                shape: vt
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        return fetch(ho, Dl).then(async (le1)=>{
                            if (le1.status >= 400) {
                                let bt = await le1.text();
                                try {
                                    bt = JSON.parse(bt).message;
                                } catch (vt) {}
                                return Promise.reject(bt);
                            }
                            return le1.json();
                        });
                    }
                    editPictureAnnotation(le1, vt) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        let bt = `${this._endpoint}/annotations/${le1}`;
                        const ls = {
                            ...this._getFetchOptions(),
                            method: "PATCH",
                            body: JSON.stringify({
                                semantics: vt
                            }),
                            headers: {
                                "Content-Type": "application/json"
                            }
                        };
                        return fetch(bt, ls).then(async (le1)=>{
                            if (le1.status >= 400) {
                                let bt = await le1.text();
                                try {
                                    bt = JSON.parse(bt).message;
                                } catch (vt) {}
                                return Promise.reject(bt);
                            }
                            return le1.json();
                        });
                    }
                    deletePictureAnnotation(le1) {
                        if (!this.isReady()) throw new Error("API is not ready to use");
                        let vt = `${this._endpoint}/annotations/${le1}`;
                        const bt = {
                            ...this._getFetchOptions(),
                            method: "DELETE"
                        };
                        return fetch(vt, bt).then(async (le1)=>{
                            if (le1.status >= 400) {
                                let bt = await le1.text();
                                try {
                                    bt = JSON.parse(bt).message;
                                } catch (vt) {}
                                return Promise.reject(bt);
                            }
                            return !0;
                        });
                    }
                    getAuthURL() {
                        var le1, vt;
                        return this._configuration ? Promise.resolve(!(null === (le1 = this._configuration) || void 0 === le1 || null === (vt = le1.auth) || void 0 === vt || !vt.enabled) && `${this._endpoint}/auth/login?next_url=<CBURL>`) : null === this._configuration ? fetch(this._endpoint + "/configuration", this._getFetchOptions()).then((le1)=>le1.json()).then((le1)=>(this._configuration = le1, this.getAuthURL())).catch(()=>(this._configuration = !1, !1)) : Promise.resolve(!1);
                    }
                    static isValidHttpUrl(le1) {
                        let vt;
                        try {
                            vt = new URL(le1);
                        } catch (bt) {
                            return !1;
                        }
                        return "http:" === vt.protocol || "https:" === vt.protocol;
                    }
                    static isIdValid(le1) {
                        if ((0, ls.isNullId)(le1)) throw new Error("id should be a valid picture unique identifier");
                        return !0;
                    }
                }
            },
            2118: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Ay: ()=>InitParameters,
                    Qm: ()=>ls,
                    Vy: ()=>alterPSVState,
                    ai: ()=>alterPhotoViewerState,
                    iz: ()=>alterViewerState,
                    mK: ()=>alterMapState
                });
                const ls = {
                    minDate: "date_from",
                    maxDate: "date_to",
                    pic_type: "pic_type",
                    camera: "camera",
                    theme: "theme",
                    qualityscore: "pic_score",
                    gps: "gps"
                }, ho = Object.fromEntries(Object.entries(ls).map((le1)=>[
                        le1[1],
                        le1[0]
                    ])), Dl = [
                    "none",
                    "null",
                    "false",
                    !1
                ], Fl = [
                    "antialias",
                    "bearing",
                    "bearingSnap",
                    "bounds",
                    "boxZoom",
                    "clickTolerance",
                    "collectResourceTiming",
                    "cooperativeGestures",
                    "crossSourceCollisions",
                    "doubleClickZoom",
                    "dragPan",
                    "dragRotate",
                    "fadeDuration",
                    "failIfMajorPerformanceCaveat",
                    "fitBoundsOptions",
                    "hash",
                    "interactive",
                    "localIdeographFontFamily",
                    "locale",
                    "logoPosition",
                    "maplibreLogo",
                    "maxBounds",
                    "maxCanvasSize",
                    "maxPitch",
                    "maxTileCacheSize",
                    "maxTileCacheZoomLevels",
                    "maxZoom",
                    "minPitch",
                    "minZoom",
                    "pitch",
                    "pitchWithRotate",
                    "pixelRatio",
                    "preserveDrawingBuffer",
                    "refreshExpiredTiles",
                    "renderWorldCopies",
                    "scrollZoom",
                    "touchPitch",
                    "touchZoomRotate",
                    "trackResize",
                    "transformCameraUpdate",
                    "transformRequest",
                    "validateStyle"
                ];
                class InitParameters {
                    constructor(){
                        var le1, vt, bt, ls, ho, sc, uc, mc;
                        let gc = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, Ac = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {}, Ec = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                        "false" === gc["url-parameters"] && (Ac = {});
                        let kc = {};
                        "object" === typeof (null === gc || void 0 === gc ? void 0 : gc["psv-options"]) && (kc = gc["psv-options"]);
                        let du = {};
                        "object" === typeof (null === gc || void 0 === gc ? void 0 : gc["map-options"]) && (du = gc["map-options"]);
                        let _u = {};
                        "object" === typeof (null === Ec || void 0 === Ec ? void 0 : Ec.map) && (_u = Ec.map);
                        let Md = Ac.map && "none" !== Ac.map ? getMapPositionFromString(Ac.map) : null, Ld = !Dl.includes(Ac.map) && !Dl.includes(gc["map-options"]), Nd = Ac.focus || gc.focus, Rd = Ac.pic || gc.picture, Od = Ac.seq || gc.sequence, jd = Ac.users || gc.users, Ud = Ac.speed || (null === (le1 = kc) || void 0 === le1 ? void 0 : le1.transitionDuration), Gd = Ac.nav || (null === (vt = kc) || void 0 === vt ? void 0 : vt.picturesNavigation), qd = Ac.theme || (null === (bt = _u) || void 0 === bt ? void 0 : bt.theme) || du.theme, Hd = Ac.background || (null === (ls = _u) || void 0 === ls ? void 0 : ls.background) || du.background, Wd = (null === Md || void 0 === Md ? void 0 : Md.center) || !Rd && ((null === (ho = _u) || void 0 === ho ? void 0 : ho.center) || du.center) || [
                            0,
                            0
                        ], Zd = (null === Md || void 0 === Md ? void 0 : Md.zoom) || (null === (sc = _u) || void 0 === sc ? void 0 : sc.zoom) || du.zoom, Yd = (null === Md || void 0 === Md ? void 0 : Md.pitch) || du.pitch, Qd = (null === Md || void 0 === Md ? void 0 : Md.bearing) || du.bearing, Xd = Ac.level || (null === (uc = du.indoor) || void 0 === uc ? void 0 : uc.level), Kd = gc.geocoder, Jd = gc.widgets, $d = gc["fetch-options"], sp = gc.style, em = gc.lang, tm = gc.endpoint, im = du.raster, nm = du.indoor, rm = du.attributionControl, am = (sm = du, Object.fromEntries(Object.entries(sm).filter((le1)=>{
                            let [vt] = le1;
                            return Fl.includes(vt);
                        })));
                        var sm;
                        let om = gc["keyboard-shortcuts"], lm = gc["skip-tags-menu-opening"], cm = "false" === (null === Ec || void 0 === Ec ? void 0 : Ec.disableAnnotations) || (null === (mc = kc) || void 0 === mc ? void 0 : mc.displayAnnotations) || !1, um = Ac.xyz, hm = Ac.date_from, dm = Ac.date_to, pm = Ac.pic_type, mm = Ac.camera, fm = Ac.pic_score, gm = Ac.gps, Am = Ac.overlay, _m = Ac.xywh, ym = Ac.annot;
                        !Ld || Rd || Od ? [
                            "map",
                            "pic"
                        ].includes(Nd) ? "map" !== Nd || Ld || (console.warn("Parameter focus can't be 'map' as map is disabled"), Nd = "pic") : (console.warn("Invalid value for parameter focus:", Nd), Nd = !Ld || Rd || Od ? "pic" : "map") : Nd = "map", "aerial" != Hd || im || (console.warn("Parameter background can't be 'aerial' as no aerial imagery is available"), Hd = "streets"), Xd && !nm && console.error("Can't set indoor level if indoor= plugin is not available"), !cm && ym && (cm = !0), ym && !Rd && console.error("Parameter annot can only be used in combination with 'picture'"), this._parentInit = {
                            map: Ld,
                            users: jd,
                            fetchOptions: $d,
                            style: sp,
                            lang: em,
                            endpoint: tm
                        }, this._parentPostInit = {
                            focus: Nd,
                            picture: Rd,
                            sequence: Od,
                            geocoder: Kd,
                            widgets: Jd,
                            forceFocus: !0,
                            keyboardShortcuts: !0,
                            willLoadPicture: void 0 !== (Rd || Od),
                            skipTagsMenuOpening: "true" === lm
                        }, this._psvInit = Object.assign(Object.fromEntries(Object.entries(kc).filter((le1)=>{
                            let [vt] = le1;
                            return ![
                                "transitionDuration",
                                "picturesNavigation",
                                "displayAnnotations"
                            ].includes(vt);
                        })), {
                            displayAnnotations: cm
                        }), this._psvAny = {
                            transitionDuration: Ud,
                            picturesNavigation: Gd
                        }, this._psvPostInit = {
                            xyz: um,
                            xywh: _m,
                            annotation: ym
                        }, this._mapInit = {
                            raster: im,
                            indoor: nm,
                            attributionControl: rm,
                            ...am
                        }, this._mapAny = {
                            theme: qd,
                            background: Hd,
                            center: Wd,
                            zoom: Zd,
                            pitch: Yd,
                            bearing: Qd,
                            users: jd
                        }, this._mapPostInit = {
                            date_from: hm,
                            date_to: dm,
                            pic_type: pm,
                            camera: mm,
                            pic_score: fm,
                            gps: gm,
                            overlay: Am,
                            level: Xd
                        }, "false" === om && (this._psvInit.keyboard = !1, this._psvInit.keyboardActions = {}, this._mapInit.keyboard = !1, this._parentPostInit.keyboardShortcuts = !1);
                    }
                    _sanitize(le1) {
                        return Object.fromEntries(Object.entries(le1).filter((le1)=>{
                            let [, vt] = le1;
                            return void 0 !== vt;
                        }));
                    }
                    getParentInit() {
                        return this._sanitize(this._parentInit);
                    }
                    getParentPostInit() {
                        return this._sanitize(this._parentPostInit);
                    }
                    getPSVInit() {
                        return this._sanitize(Object.assign({}, this._psvInit, this._psvAny));
                    }
                    getPSVPostInit() {
                        return this._sanitize(Object.assign({}, this._psvPostInit, this._psvAny));
                    }
                    getMapInit() {
                        return this._sanitize(Object.assign({}, this._mapInit, this._mapAny));
                    }
                    getMapPostInit() {
                        return this._sanitize(Object.assign({}, this._mapPostInit, this._mapAny));
                    }
                    static GetComponentProperties(le1, vt) {
                        const bt = {};
                        for(let ls in le1.properties)le1.properties[ls].state || null == vt[ls] || (bt[ls] = vt[ls]);
                        return bt;
                    }
                }
                function getMapPositionFromString(le1, vt) {
                    const bt = (le1 || "").split("/");
                    if (bt.length >= 3 && !bt.some((le1)=>isNaN(le1))) {
                        const le1 = {
                            center: [
                                +bt[2],
                                +bt[1]
                            ],
                            zoom: +bt[0],
                            pitch: +(bt[4] || 0)
                        };
                        return vt && (le1.bearing = vt.dragRotate.isEnabled() && vt.touchZoomRotate.isEnabled() ? +(bt[3] || 0) : vt.getBearing()), le1;
                    }
                    return null;
                }
                function alterPSVState(le1, vt) {
                    vt.xyz && le1.addEventListener("picture-loaded", ()=>{
                        const bt = function(le1) {
                            const vt = (le1 || "").split("/");
                            return 3 !== vt.length || vt.some((le1)=>isNaN(le1)) ? null : {
                                x: +vt[0],
                                y: +vt[1],
                                z: +vt[2]
                            };
                        }(vt.xyz);
                        le1.setXYZ(bt.x, bt.y, bt.z);
                    }, {
                        once: !0
                    }), vt.xywh && le1.addEventListener("picture-loaded", ()=>{
                        const bt = function(le1, vt) {
                            let bt = (le1 || "").split(",");
                            if (4 !== bt.length || bt.some((le1)=>isNaN(le1))) return null;
                            {
                                var ls, ho, Dl, Fl;
                                let [le1, mc, gc, Ac] = bt.map((le1)=>parseFloat(le1)), Ec = vt.panorama.basePanoData;
                                if ("function" === typeof Ec) {
                                    var sc, uc;
                                    const le1 = null === vt || void 0 === vt || null === (sc = vt.properties) || void 0 === sc || null === (uc = sc["pers:interior_orientation"]) || void 0 === uc ? void 0 : uc.sensor_array_dimensions;
                                    Ec = le1 && 2 == le1.length ? Ec({
                                        width: le1[0],
                                        height: le1[1]
                                    }) : null;
                                }
                                if (null === (ls = Ec) || void 0 === ls || !ls.fullWidth || null === (ho = Ec) || void 0 === ho || !ho.fullHeight) return null;
                                const kc = (null === (Dl = Ec) || void 0 === Dl ? void 0 : Dl.croppedX) || 0, du = (null === (Fl = Ec) || void 0 === Fl ? void 0 : Fl.croppedY) || 0, _u = kc + le1 + gc / 2 - Ec.fullWidth / 2, Md = -(du + mc + Ac / 2 - Ec.fullHeight / 2), Ld = _u / Ec.fullWidth, Nd = Md / Ec.fullHeight, Rd = (gc / Ec.fullWidth + Ac / Ec.fullHeight) / 2;
                                return {
                                    yaw: 2 * Ld * Math.PI,
                                    pitch: Nd * Math.PI,
                                    z: 100 * (1 - Rd)
                                };
                            }
                        }(vt.xywh, le1.getPictureMetadata());
                        le1.rotate(bt), le1.zoom(bt.z);
                    }, {
                        once: !0
                    }), vt.annotation && (le1.getPictureMetadata() ? le1.focusOnAnnotation(vt.annotation) : le1.addEventListener("picture-loaded", ()=>{
                        le1.focusOnAnnotation(vt.annotation);
                    }, {
                        once: !0
                    }));
                    let bt = vt.transitionDuration || vt.speed;
                    void 0 !== bt && le1.setTransitionDuration(bt);
                    let ls = vt.picturesNavigation || vt.nav;
                    [
                        "none",
                        "pic",
                        "any",
                        "seq"
                    ].includes(ls) && le1.setPicturesNavigation(ls);
                }
                async function alterMapState(le1, vt) {
                    var bt;
                    const ls = getMapPositionFromString(vt.map, le1);
                    ls && le1.jumpTo(ls);
                    let Dl = Array.isArray(vt.users) ? vt.users : (vt.users || "").split(",");
                    (0 === Dl.length || 1 === Dl.length && "" === Dl[0].trim()) && (Dl = [
                        "geovisio"
                    ]), await le1.setVisibleUsers(Dl), null === (bt = le1.setFilters) || void 0 === bt || bt.call(le1, function(le1) {
                        const vt = {};
                        for(let bt in ho)le1[bt] && (vt[ho[bt]] = le1[bt]);
                        if (vt.qualityscore) {
                            let le1 = vt.qualityscore.split("");
                            const bt = {
                                A: 5,
                                B: 4,
                                C: 3,
                                D: 2,
                                E: 1
                            };
                            vt.qualityscore = le1.map((le1)=>bt[le1]);
                        }
                        return vt;
                    }(vt)), [
                        "aerial",
                        "streets"
                    ].includes(vt.background) && le1.setBackground(vt.background), vt.overlay && vt.overlay.split(",").forEach((vt)=>{
                        const waitForLayer = ()=>{
                            le1.getLayer(vt) ? le1.setLayoutProperty(vt, "visibility", "visible") : setTimeout(waitForLayer, 200);
                        };
                        waitForLayer();
                    });
                }
                function alterPhotoViewerState(le1, vt) {
                    let bt = vt.picture || vt.pic, ls = vt.sequence || vt.seq || null;
                    if (bt) {
                        const vt = bt.split(";");
                        vt.length > 1 && console.warn("Multiple picture IDs passed in URL, only first one kept"), le1.select(1 === vt.length ? ls : null, vt[0], !0);
                    } else ls ? le1.select(ls, null, !0) : le1.select();
                }
                function alterViewerState(le1, vt) {
                    alterPhotoViewerState(le1, vt), "map" === vt.focus && null !== le1 && void 0 !== le1 && le1.map ? (le1.setPopup(!1), le1._setFocus("map", null, vt.forceFocus)) : "pic" === vt.focus && null !== le1 && void 0 !== le1 && le1.mini ? (le1.setPopup(!1), le1._setFocus("pic", null, vt.forceFocus)) : vt.focus && "meta" === vt.focus && null !== le1 && void 0 !== le1 && le1.mini && le1._setFocus("pic", null, vt.forceFocus);
                }
            },
            1435: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PanoraMapProtocol
                });
                var ls = bt(99), ho = bt(8293), Dl = bt(8552);
                class PanoraMapProtocol {
                    tile() {
                        return (le1, vt)=>{
                            vt = vt || new AbortController;
                            const bt = le1.url.replace(/^panora/, "http");
                            return fetch(bt, {
                                signal: vt.signal
                            }).then((le1)=>le1.arrayBuffer()).then((le1)=>new ho.cW(new ls.A(le1))).then((le1)=>(!le1.layers.pictures || le1.layers.pictures.length >= 5e3 || Object.values(le1.layers).forEach((le1)=>{
                                    const vt = le1.feature.bind(le1);
                                    le1.feature = (le1)=>{
                                        const bt = vt(le1);
                                        return bt.properties.uncrowded = !0, bt;
                                    };
                                }), le1)).then((le1)=>(0, Dl.bL)(le1).buffer).then((le1)=>({
                                    data: le1
                                }));
                        };
                    }
                }
            },
            3727: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PhotoAdapter
                });
                var ls = bt(3890);
                class PhotoAdapter extends ls.D {
                    constructor(le1, vt){
                        super(le1, vt), this._shouldGoFast = vt.shouldGoFast || (()=>!0);
                    }
                    loadTexture(le1, vt) {
                        return le1.origBaseUrl ? le1.baseUrl = le1.origBaseUrl : le1.origBaseUrl = le1.baseUrl, this._shouldGoFast() && le1.thumbUrl && !le1.hdLoaded && 1 == le1.rows && (le1.baseUrl = le1.thumbUrl), super.loadTexture(le1, vt).then((vt)=>(le1.baseUrl === le1.origBaseUrl && (le1.hdLoaded = !0), vt)).catch((le1)=>{
                            console.error("Can't load texture", le1);
                        });
                    }
                    __loadTiles(le1) {
                        this._shouldGoFast() || super.__loadTiles(le1);
                    }
                }
            },
            4207: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>PresetManager
                });
                var ls = bt(7208);
                const ho = {
                    fas: "fa7-solid"
                }, Dl = {};
                class PresetManager {
                    constructor(){
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : null, vt = arguments.length > 1 && void 0 !== arguments[1] && arguments[1];
                        this._ready = !1, this._presets = null, this._translations = {}, vt || this._load(le1);
                    }
                    async _load(le1) {
                        var vt, bt;
                        le1 = (null === (vt = le1) || void 0 === vt ? void 0 : vt.substring(0, 2)) || (null === (bt = window.navigator.languages[0]) || void 0 === bt ? void 0 : bt.substring(0, 2));
                        try {
                            var Fl, sc;
                            const [vt, bt, gc] = await Promise.all([
                                fetch(`${(0, ls.PanoramaxPresetsURL)()}/translations/en.min.json`),
                                le1 ? fetch(`${(0, ls.PanoramaxPresetsURL)()}/translations/${le1}.min.json`) : Promise.resolve({
                                    ok: !0
                                }),
                                fetch(`${(0, ls.PanoramaxPresetsURL)()}/presets.min.json`)
                            ]);
                            if (!vt || !bt || !gc || !vt.ok || !bt.ok || !gc.ok) throw this._ready = -1, new Error("Presets service is not available");
                            var uc, mc;
                            if (this._presets = await gc.json(), this._translations.en = null === (Fl = await vt.json()) || void 0 === Fl || null === (sc = Fl.en) || void 0 === sc ? void 0 : sc.presets, le1) this._translations[le1] = null === (uc = await bt.json()) || void 0 === uc || null === (mc = uc[le1]) || void 0 === mc ? void 0 : mc.presets;
                            Object.entries(this._presets).forEach((vt)=>{
                                var bt, ls, Fl, sc, uc, mc;
                                let [gc, Ac] = vt;
                                if (null !== (bt = this._translations[le1]) && void 0 !== bt && null !== (ls = bt.presets) && void 0 !== ls && null !== (Fl = ls[gc]) && void 0 !== Fl && Fl.name ? Ac.name = this._translations[le1].presets[gc].name : null !== (sc = this._translations.en) && void 0 !== sc && null !== (uc = sc.presets) && void 0 !== uc && null !== (mc = uc[gc]) && void 0 !== mc && mc.name && (Ac.name = this._translations.en.presets[gc].name), Ac.icon) {
                                    const le1 = Ac.icon.split("-")[0], vt = ho[le1];
                                    Ac.iconify = vt ? Ac.icon.replace(le1 + "-", vt + ":") : Ac.icon.split("-")[0] + ":" + Ac.icon.split("-").slice(1).join("-"), Dl[Ac.iconify] && (Ac.iconify = Dl[Ac.iconify]);
                                }
                            }), this._ready = !0;
                        } catch (gc) {
                            console.error("Presets service throws an error:", gc), this._ready = -1;
                        }
                    }
                    async onceReady() {
                        return this._ready ? -1 === this._ready ? Promise.reject() : Promise.resolve() : (await new Promise((le1)=>setTimeout(le1, 250)), this.onceReady());
                    }
                    async getPreset(le1) {
                        return this.getPresets(le1).then((le1)=>le1.shift());
                    }
                    async getPresets(le1) {
                        return this.onceReady().then(()=>{
                            const vt = Object.values(this._presets).filter((vt)=>{
                                if (0 === Object.keys(vt.tags).length) return !1;
                                for(let bt in vt.tags){
                                    const ls = vt.tags[bt];
                                    if (!le1.semantics.find((le1)=>"delete" !== le1.action && le1.key === bt && ("*" === ls || ls === le1.value))) return !1;
                                }
                                return !0;
                            });
                            return vt.sort((le1, vt)=>{
                                const bt = Object.keys(le1.tags).length, ls = Object.keys(vt.tags).length;
                                if (bt > ls) return -1;
                                if (bt === ls) {
                                    const bt = Object.values(le1.tags).filter((le1)=>"*" === le1).length, ls = Object.values(vt.tags).filter((le1)=>"*" === le1).length;
                                    return bt < ls ? -1 : bt > ls ? 1 : 0;
                                }
                                return 1;
                            }), vt;
                        });
                    }
                }
            },
            4005: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Ay: ()=>SemanticsMapProtocol,
                    lU: ()=>Dl,
                    nu: ()=>Fl
                });
                var ls = bt(2964), ho = bt(8552);
                const Dl = 15, Fl = 19, sc = {
                    15: 100,
                    16: 300,
                    17: 500,
                    18: 800,
                    19: 1e3
                };
                class SemanticsMapProtocol {
                    constructor(le1){
                        this.tiles = new Map, this.api = le1;
                    }
                    _tileToBbox(le1, vt, bt) {
                        const ls = Math.pow(2, bt), ho = le1 / ls * 360 - 180, Dl = (le1 + 1) / ls * 360 - 180, Fl = 180 * Math.atan(Math.sinh(Math.PI * (1 - 2 * vt / ls))) / Math.PI;
                        return [
                            ho,
                            180 * Math.atan(Math.sinh(Math.PI * (1 - 2 * (vt + 1) / ls))) / Math.PI,
                            Dl,
                            Fl
                        ];
                    }
                    _semanticsToBasicProps(le1) {
                        var vt, bt, ls, ho;
                        const Dl = {}, setOrAppend = (le1)=>{
                            Dl[le1.key] ? Dl[le1.key].add(le1.value) : Dl[le1.key] = new Set([
                                le1.value
                            ]);
                        };
                        return ((null === (vt = le1.properties) || void 0 === vt || null === (bt = vt.collection) || void 0 === bt ? void 0 : bt.semantics) || []).forEach(setOrAppend), ((null === (ls = le1.properties) || void 0 === ls ? void 0 : ls.semantics) || []).forEach(setOrAppend), ((null === (ho = le1.properties) || void 0 === ho ? void 0 : ho.annotations) || []).forEach((le1)=>le1.semantics.forEach(setOrAppend)), Object.keys(Dl).forEach((le1)=>Dl[le1] = [
                                ...Dl[le1]
                            ].join(";")), Dl.picid = le1.id, Dl.seqid = le1.collection, Dl;
                    }
                    tile() {
                        return async (le1, vt)=>{
                            vt = vt || new AbortController;
                            const bt = le1.url.match(/^sem:\/\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/);
                            if (!bt) throw new Error("Invalid URL");
                            if (this.tiles.has(le1.url)) return {
                                data: this.tiles.get(le1.url).buffer.slice(0)
                            };
                            const [uc, mc, gc, Ac, Ec] = bt, kc = this._tileToBbox(parseInt(Ac), parseInt(Ec), parseInt(gc)), du = `${this.api._endpoint}/search?bbox=${kc.join(",")}&limit=${sc[parseInt(gc)]}&sortby=id&filter=${encodeURIComponent(mc)}`;
                            return fetch(du, {
                                signal: vt.signal
                            }).then((le1)=>le1.json()).then((vt)=>{
                                if (vt.features) {
                                    if (vt.type = "FeatureCollection", 0 === vt.features.length) {
                                        const vt = new Uint8Array;
                                        return this.tiles.set(le1.url, vt), {
                                            data: vt.buffer.slice(0)
                                        };
                                    }
                                    vt.features = vt.features.map((le1)=>({
                                            type: le1.type,
                                            geometry: le1.geometry,
                                            id: le1.id,
                                            properties: this._semanticsToBasicProps(le1)
                                        }));
                                }
                                const bt = (0, ls.A)(vt, {
                                    minZoom: Dl,
                                    maxZoom: Fl
                                }).getTile(gc, Ac, Ec);
                                if (!bt) throw new Error("Can't create tile");
                                const sc = (0, ho.O7)({
                                    layer: bt
                                }, {
                                    version: 2
                                });
                                return this.tiles.set(le1.url, sc), {
                                    data: sc.buffer.slice(0)
                                };
                            });
                        };
                    }
                }
            },
            4451: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>URLHandler
                });
                var ls = bt(2118);
                const ho = [
                    "speed",
                    "nav",
                    "focus",
                    "pic",
                    "xyz",
                    "map",
                    "background",
                    "users",
                    "s",
                    "xywh",
                    "annot",
                    "seq",
                    "overlay",
                    "level"
                ].concat(Object.values(ls.Qm)), Dl = [
                    "focus-changed",
                    "pictures-navigation-changed"
                ], Fl = [
                    "position-updated",
                    "zoom-updated",
                    "view-rotated",
                    "picture-loaded",
                    "transition-duration-changed",
                    "annotation-focused",
                    "annotations-unfocused"
                ], sc = [
                    "moveend",
                    "zoomend",
                    "boxzoomend",
                    "background-changed",
                    "users-changed",
                    "filters-changed",
                    "styledata"
                ];
                class URLHandler extends EventTarget {
                    constructor(le1){
                        super(), this._parent = le1, this._delay = null;
                    }
                    listenToChanges() {
                        var le1;
                        (window.addEventListener("popstate", this._onURLChange.bind(this), !1), Dl.forEach((le1)=>this._parent.addEventListener(le1, this._onParentChange.bind(this))), Fl.forEach((le1)=>this._parent.psv.addEventListener(le1, this._onParentChange.bind(this))), this._parent.map) && (sc.forEach((le1)=>this._parent.map.on(le1, this._onParentChange.bind(this))), null === (le1 = this._parent.map.indoorEqual) || void 0 === le1 || le1.on("levelchange", this._onParentChange.bind(this)));
                    }
                    destroy() {
                        window.removeEventListener("popstate", this._onURLChange);
                    }
                    nextURLParams() {
                        var le1;
                        let vt = {};
                        "number" == typeof this._parent.psv.getTransitionDuration() && (vt.speed = this._parent.psv.getTransitionDuration()), [
                            null,
                            "any"
                        ].includes(this._parent.psv.getPicturesNavigation()) || (vt.nav = this._parent.psv.getPicturesNavigation()), this._parent.psv.getPictureId() && (vt.pic = this._parent.psv.getPictureId());
                        const bt = this._parent.psv.getPictureMetadata();
                        var ho;
                        bt && (vt.xyz = this.currentPSVString(), null !== (ho = bt.sequence) && void 0 !== ho && ho.id && (vt.seq = bt.sequence.id));
                        const Dl = this._parent.psv.getSelectedAnnotations();
                        if ((null === Dl || void 0 === Dl ? void 0 : Dl.length) > 0 && (vt.annot = Dl[0]), null !== (le1 = this._parent.map) && void 0 !== le1 && le1.loaded) {
                            var Fl, sc, uc, mc, gc, Ac;
                            vt.map = this.currentMapString(), vt.focus = "pic", this._parent.isMapWide() && (vt.focus = "map"), null !== (Fl = this._parent.map) && void 0 !== Fl && null !== (sc = Fl.hasTwoBackgrounds) && void 0 !== sc && sc.call(Fl) && null !== (uc = this._parent.map) && void 0 !== uc && null !== (mc = uc.getBackground) && void 0 !== mc && mc.call(uc) && (vt.background = this._parent.map.getBackground());
                            const le1 = this._parent.map.getVisibleUsers();
                            if ((le1.length > 1 || !le1.includes("geovisio")) && (vt.users = le1.join(",")), this._parent.map._mapFilters) {
                                for(let le1 in ls.Qm)this._parent.map._mapFilters[le1] && (vt[ls.Qm[le1]] = this._parent.map._mapFilters[le1]);
                                if (Array.isArray(vt.pic_score)) {
                                    if (5 === vt.pic_score.length) delete vt.pic_score;
                                    else {
                                        const le1 = [
                                            null,
                                            "E",
                                            "D",
                                            "C",
                                            "B",
                                            "A"
                                        ];
                                        vt.pic_score = vt.pic_score.map((vt)=>le1[vt]).join("");
                                    }
                                }
                                Array.isArray(vt.gps) && 5 === vt.gps.length && delete vt.gps;
                            }
                            if (null !== (gc = this._parent.map) && void 0 !== gc && gc.getSemanticOverlays) {
                                const le1 = this._parent.map.getSemanticOverlays().filter((le1)=>{
                                    var vt;
                                    return "none" !== (null === (vt = le1.layout) || void 0 === vt ? void 0 : vt.visibility);
                                }).map((le1)=>le1.id);
                                le1.length > 0 && (vt.overlay = le1.join(","));
                            }
                            null !== (Ac = this._parent.map) && void 0 !== Ac && Ac.indoorEqual && (vt.level = this._parent.map.indoorEqual.level);
                        }
                        return vt;
                    }
                    nextURLString() {
                        let le1 = "";
                        return Object.entries(this.nextURLParams()).sort((le1, vt)=>le1[0].localeCompare(vt[0])).forEach((vt)=>{
                            let [bt, ls] = vt, ho = !1;
                            const Dl = le1.split("&").map((le1)=>{
                                const vt = le1.split("=")[0];
                                return vt === bt ? (ho = !0, `${vt}=${ls}`) : le1;
                            }).filter((le1)=>le1);
                            ho || Dl.push(`${bt}=${ls}`), le1 = `${Dl.join("&")}`;
                        }), `?${le1}`.replace(/^\?+/, "?");
                    }
                    currentURLParams() {
                        const le1 = (arguments.length > 0 && void 0 !== arguments[0] && arguments[0] ? window.location.hash : window.location.search).replace(/^[?#]/, "").replace(/&amp;/g, "&");
                        let vt = {};
                        if (le1.split("&").map((le1)=>le1.split("=")).filter((le1)=>void 0 !== le1[0] && le1[0].length > 0 && ho.includes(le1[0])).forEach((le1)=>{
                            vt[le1[0]] = le1[1];
                        }), vt.s) {
                            const le1 = Object.fromEntries(decodeURIComponent(vt.s).split(";").map((le1)=>[
                                    le1[0],
                                    le1.substring(1)
                                ]));
                            vt = {}, "m" === le1.f ? vt.focus = "map" : "p" === le1.f ? vt.focus = "pic" : "t" === le1.f && (vt.focus = "meta"), "" !== le1.s && (vt.speed = 100 * parseFloat(le1.s)), "a" === le1.n ? vt.nav = "any" : "s" === le1.n && (vt.nav = "seq"), [
                                "n",
                                "p"
                            ].includes(le1.n) && (vt.nav = "pic"), "" !== le1.p && (vt.pic = le1.p), "" !== le1.a && (vt.annot = le1.a), "" !== le1.c && (vt.xyz = le1.c), "" !== le1.m && (vt.map = le1.m), "" !== le1.d && (vt.date_from = le1.d), "" !== le1.e && (vt.date_to = le1.e), "f" === le1.t ? vt.pic_type = "flat" : "e" === le1.t && (vt.pic_type = "equirectangular"), "" !== le1.k && (vt.camera = le1.k), "d" === le1.v ? vt.theme = "default" : "a" === le1.v ? vt.theme = "age" : "t" === le1.v ? vt.theme = "type" : "s" === le1.v ? vt.theme = "score" : "g" === le1.v && (vt.theme = "gps"), "s" === le1.b ? vt.background = "streets" : "a" === le1.b && (vt.background = "aerial"), "" !== le1.u && (vt.users = le1.u), "" !== le1.q && (vt.pic_score = le1.q), "" !== le1.g && (vt.gps = le1.g), "" !== le1.o && (vt.overlay = le1.o), "" !== le1.l && (vt.level = le1.l);
                        }
                        return vt;
                    }
                    currentMapString() {
                        var le1;
                        if (null === (le1 = this._parent.map) || void 0 === le1 || !le1.loaded) return "";
                        const vt = this._parent.map.getCenter(), bt = Math.round(100 * this._parent.map.getZoom()) / 100, ls = Math.ceil((bt * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), ho = Math.pow(10, ls), Dl = Math.round(vt.lng * ho) / ho, Fl = Math.round(vt.lat * ho) / ho, sc = this._parent.map.getBearing(), uc = this._parent.map.getPitch();
                        let mc = `${bt}/${Fl}/${Dl}`;
                        return (sc || uc) && (mc += "/" + Math.round(10 * sc) / 10), uc && (mc += `/${Math.round(uc)}`), mc;
                    }
                    currentPSVString() {
                        const le1 = this._parent.psv.getXYZ();
                        return `${le1.x.toFixed(2)}/${le1.y.toFixed(2)}/${Math.round(le1.z || 0)}`;
                    }
                    _onURLChange() {
                        let le1 = this.currentURLParams();
                        "Viewer" === this._parent.getClassName() ? (0, ls.iz)(this._parent, le1) : (0, ls.ai)(this._parent, le1), (0, ls.Vy)(this._parent.psv, le1), this._parent.map && (0, ls.mK)(this._parent.map, le1);
                    }
                    nextShortLink(le1) {
                        const vt = new URL(le1), bt = this.nextURLParams(), ls = {
                            f: (bt.focus || "").substring(0, 1),
                            s: isNaN(parseInt(bt.speed)) ? void 0 : Math.floor(parseInt(bt.speed) / 100),
                            n: (bt.nav || "").substring(0, 1),
                            p: bt.pic,
                            c: bt.xyz,
                            m: bt.map,
                            d: bt.date_from,
                            e: bt.date_to,
                            t: (bt.pic_type || "").substring(0, 1),
                            k: bt.camera,
                            v: (bt.theme || "").substring(0, 1),
                            b: (bt.background || "").substring(0, 1),
                            u: bt.users,
                            q: bt.pic_score,
                            a: bt.annot,
                            g: bt.gps,
                            o: bt.overlay,
                            l: bt.level
                        }, ho = Object.entries(ls).filter((le1)=>{
                            let [, vt] = le1;
                            return void 0 != vt && "" != vt;
                        }).map((le1)=>{
                            let [vt, bt] = le1;
                            return `${vt}${bt}`;
                        }).join(";");
                        return vt.search = `s=${ho}`, vt;
                    }
                    getUnmanagedParameters(le1) {
                        return new URLSearchParams(Array.from(le1.searchParams).filter((le1)=>{
                            let [vt] = le1;
                            return !ho.includes(vt);
                        })).toString();
                    }
                    _onParentChange() {
                        this._delay && (clearTimeout(this._delay), this._delay = null), this._delay = setTimeout(()=>{
                            var le1, vt, bt;
                            const ls = new URL(window.location.href), ho = new URL(window.location.href), Dl = this.getUnmanagedParameters(ls);
                            if (ho.search = this._parent ? this.nextURLString() + (Dl.length > 0 ? "&" + Dl : "") : "", Object.keys(this.currentURLParams(!0)).length > 0 && (ho.hash = ""), ls.search == ho.search) return;
                            const Fl = this.currentURLParams().pic || "", sc = (null === (le1 = this._parent) || void 0 === le1 || null === (vt = le1.psv) || void 0 === vt || null === (bt = vt.getPictureId) || void 0 === bt ? void 0 : bt.call(vt)) || "";
                            try {
                                if (Fl != sc ? window.history.pushState(window.history.state, null, ho.href) : window.history.replaceState(window.history.state, null, ho.href), this._parent) {
                                    const le1 = new CustomEvent("url-changed", {
                                        detail: {
                                            url: ho.href
                                        }
                                    });
                                    this.dispatchEvent(le1);
                                }
                            } catch (uc) {}
                        }, 500);
                    }
                }
            },
            3606: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    forwardGeocodingBAN: ()=>forwardGeocodingBAN,
                    forwardGeocodingNominatim: ()=>forwardGeocodingNominatim,
                    forwardGeocodingStandard: ()=>forwardGeocodingStandard,
                    reverseGeocodingNominatim: ()=>reverseGeocodingNominatim
                });
                var ls = bt(7208);
                const ho = {
                    house: 20,
                    housenumber: 20,
                    street: 18,
                    locality: 15,
                    district: 13,
                    municipality: 12,
                    city: 12,
                    county: 8,
                    region: 7,
                    state: 7,
                    country: 5
                };
                function geocoderParamsToURLString(le1) {
                    let vt = {};
                    return Object.entries(le1).filter((le1)=>void 0 !== le1[1] && null !== le1[1]).forEach((le1)=>vt[le1[0]] = le1[1]), new URLSearchParams(vt).toString();
                }
                function forwardGeocodingNominatim(le1) {
                    const vt = {
                        q: le1.query,
                        countrycodes: le1.countries,
                        limit: le1.limit,
                        viewbox: le1.bbox
                    };
                    return fetch(`${(0, ls.NominatimBaseUrl)()}/search?${geocoderParamsToURLString(vt)}&format=geocodejson&addressdetails=1`).then((le1)=>le1.json()).then((le1)=>{
                        const vt = {
                            features: []
                        }, bt = [];
                        return (le1.features || []).forEach((le1)=>{
                            var ls, Dl, Fl;
                            const sc = geocodeJsonToPlaceName(null === (ls = le1.properties) || void 0 === ls ? void 0 : ls.geocoding) || (null === (Dl = le1.properties) || void 0 === Dl || null === (Fl = Dl.geocoding) || void 0 === Fl ? void 0 : Fl.label);
                            var uc, mc;
                            bt.includes(sc) || (vt.features.push({
                                place_type: [
                                    "place"
                                ],
                                place_name: sc,
                                center: le1.geometry.coordinates,
                                zoom: ho[null === (uc = le1.properties) || void 0 === uc || null === (mc = uc.geocoding) || void 0 === mc ? void 0 : mc.type]
                            }), bt.push(sc));
                        }), vt;
                    });
                }
                function reverseGeocodingNominatim(le1, vt) {
                    return fetch(`${(0, ls.NominatimBaseUrl)()}/reverse?lat=${le1}&lon=${vt}&zoom=18&format=geocodejson`).then((le1)=>le1.json()).then((le1)=>{
                        var vt, bt, ls;
                        return geocodeJsonToPlaceName(null === le1 || void 0 === le1 || null === (vt = le1.features) || void 0 === vt || null === (bt = vt.shift()) || void 0 === bt || null === (ls = bt.properties) || void 0 === ls ? void 0 : ls.geocoding);
                    });
                }
                function forwardGeocodingBAN(le1) {
                    return forwardGeocodingStandard(le1, (0, ls.AdresseDataGouvBaseURL)());
                }
                function geocodeJsonToPlaceName(le1) {
                    if (!le1 || "object" != typeof le1) return "";
                    let vt = le1.name, bt = [], ls = [];
                    switch(le1.type){
                        case "hamlet":
                        case "croft":
                        case "isolated_dwelling":
                        case "neighbourhood":
                        case "allotments":
                        case "quarter":
                        case "farm":
                        case "farmyard":
                        case "industrial":
                        case "commercial":
                        case "retail":
                        case "city_block":
                        case "residential":
                        case "locality":
                        case "district":
                            ls.push(le1.city), ls.push(le1.county), ls.push(le1.state), ls.push(le1.country);
                            break;
                        case "city":
                        case "region":
                            ls.push(le1.county), ls.push(le1.state), ls.push(le1.country);
                            break;
                        case "country":
                            break;
                        case "house":
                        case "housenumber":
                            bt.push(le1.housenumber), bt.push(le1.street), bt.push(le1.locality), bt.push(le1.district), ls.push(le1.city), ls.push(le1.county), ls.push(le1.state), ls.push(le1.country);
                            break;
                        default:
                            bt.push(le1.street), bt.push(le1.locality), bt.push(le1.district), ls.push(le1.city), ls.push(le1.county), ls.push(le1.state), ls.push(le1.country);
                    }
                    return bt = bt.filter((le1)=>le1), bt = bt.filter((le1, ls)=>le1 != vt && (0 === ls || bt[ls - 1] !== le1)), bt = bt.length > 0 ? le1.housenumber ? bt.slice(0, 2).join(" ") : bt.shift() : null, bt === vt && (bt = null), ls = ls.filter((le1)=>le1), ls = ls.filter((le1, ho)=>le1 != vt && (!bt || !bt.includes(le1)) && (0 === ho || ls[ho - 1] !== le1)), [
                        vt,
                        bt,
                        ls.shift()
                    ].filter((le1)=>le1).join(", ");
                }
                function forwardGeocodingStandard(le1, vt) {
                    const bt = {
                        q: le1.query,
                        limit: le1.limit
                    };
                    if ("string" === typeof le1.proximity) {
                        const [vt, ls] = le1.proximity.split(",").map((le1)=>parseFloat(le1.trim()));
                        bt.lat = vt, bt.lon = ls;
                    }
                    return fetch(`${vt}/?${geocoderParamsToURLString(bt)}`).then((le1)=>le1.json()).then((le1)=>{
                        const vt = {
                            features: []
                        }, bt = [];
                        return (le1.features || []).forEach((le1)=>{
                            const ls = geocodeJsonToPlaceName(le1.properties);
                            bt.includes(ls) || "other" == le1.properties.type || (vt.features.push({
                                place_type: [
                                    "place"
                                ],
                                place_name: ls,
                                center: le1.geometry.coordinates,
                                zoom: ho[le1.properties.type]
                            }), bt.push(ls));
                        }), vt;
                    });
                }
            },
            4964: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    autoDetectLocale: ()=>autoDetectLocale,
                    getBestLabel: ()=>getBestLabel,
                    getTranslations: ()=>getTranslations
                });
                var ls = bt(3087), ho = bt(4149), Dl = bt(369), Fl = bt(389), sc = bt(9946), uc = bt(8302), mc = bt(5222), gc = bt(6909), Ac = bt(4895), Ec = bt(3979), kc = bt(6920), du = bt(9026), _u = bt(8010), Md = bt(6611), Ld = bt(991), Nd = bt(7304), Rd = bt(8230), Od = bt(6984);
                const jd = "en", Ud = {
                    be: ls,
                    da: ho,
                    de: Dl,
                    eo: sc,
                    en: Fl,
                    es: uc,
                    fr: mc,
                    hu: gc,
                    it: Ac,
                    ja: Ec,
                    nl: kc,
                    pl: du,
                    pt: _u,
                    "pt-br": Md,
                    sv: Ld,
                    tr: Nd,
                    uk: Rd,
                    "zh-hant": Od,
                    zh: Od
                };
                function autoDetectLocale(le1, vt) {
                    le1 = le1.map((le1)=>le1.toLowerCase());
                    for (const bt of window.navigator.languages){
                        let vt = bt.toLowerCase();
                        switch(vt){
                            case "zh-tw":
                            case "zh-hk":
                            case "zh-mo":
                                vt = "zh-hant";
                                break;
                            case "zh-cn":
                            case "zh-sg":
                                vt = "zh-hans";
                                break;
                            default:
                                vt.length > 2 && !le1.includes(vt) && (vt = bt.substring(0, 2));
                        }
                        const ls = le1.find((le1)=>le1 === vt);
                        if (ls) return ls;
                    }
                    return vt;
                }
                function getTranslations() {
                    let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    const vt = JSON.parse(JSON.stringify(Fl));
                    let bt;
                    if (le1 || (le1 = autoDetectLocale(Object.keys(Ud), jd)), Ud[le1] && "en" !== le1 && (bt = Ud[le1]), le1.length > 2) {
                        const vt = le1.substring(0, 2);
                        Ud[vt] && (bt = Ud[vt]);
                    }
                    return bt && Object.entries(bt).forEach((le1)=>{
                        let [bt, ls] = le1;
                        Object.entries(ls).forEach((le1)=>{
                            let [ls, ho] = le1;
                            Array.isArray(ho) && (ho = ho.filter((le1)=>null != le1)), vt[bt][ls] = ho;
                        });
                    }), vt.PREF_LANG = le1, vt;
                }
                function getBestLabel(le1, vt) {
                    return vt = vt ? vt.toLowerCase() : null, le1 = Object.fromEntries(Object.entries(le1).map((le1)=>{
                        let [vt, bt] = le1;
                        return [
                            vt.toLowerCase(),
                            bt
                        ];
                    })), vt || (vt = autoDetectLocale(Object.keys(le1), jd)), le1[vt] ? le1[vt] : vt.length > 2 && le1[vt.substring(0, 2)] ? le1[vt.substring(0, 2)] : le1[jd] || "";
                }
            },
            2030: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    API: ()=>Ec.A,
                    PhotoAdapter: ()=>kc.A,
                    PresetsManager: ()=>du.A,
                    URLHandler: ()=>_u.A,
                    geocoder: ()=>ls,
                    i18n: ()=>ho,
                    indoor: ()=>Dl,
                    map: ()=>Fl,
                    picture: ()=>sc,
                    semantics: ()=>uc,
                    services: ()=>mc,
                    utils: ()=>gc,
                    widgets: ()=>Ac
                });
                var ls = bt(3606), ho = bt(4964), Dl = bt(5195), Fl = bt(8340), sc = bt(508), uc = bt(2283), mc = bt(7208), gc = bt(7343), Ac = bt(5995), Ec = bt(5254), kc = bt(3727), du = bt(4207), _u = bt(4451);
            },
            5195: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    DISABLED_LEVEL: ()=>Dl,
                    initIndoorEqualOnMap: ()=>initIndoorEqualOnMap
                });
                var ls = bt(7208), ho = bt(5995);
                const Dl = "-1000", Fl = "levels";
                function initIndoorEqualOnMap(le1) {
                    if (le1._options.indoor) {
                        let bt = !1;
                        try {
                            IndoorEqual, bt = !0;
                        } catch (vt) {
                            console.error("The indoor= plugin is not enabled. Please add the maplibre-gl-indoorequal before calling 'indoor' option of Panoramax Viewer.");
                        }
                        if (bt) {
                            le1.indoorEqual = new IndoorEqual(le1, le1._options.indoor), le1.addControl(le1.indoorEqual), le1.indoorEqual.loadSprite((0, ls.IndoorEqualSpritesURL)()), le1.indoorEqual._refreshAfterLevelsUpdate = function() {
                                this.levels.includes(this.level) || this.level == Dl || this.setLevel("0");
                            };
                            const vt = "sem-" + Fl;
                            let bt;
                            le1.indoorEqual._updateLevels = function() {
                                if (this.map.isSourceLoaded(this.source.sourceId) && this.map.isSourceLoaded(vt)) {
                                    let le1 = new Set;
                                    this.map.querySourceFeatures(this.source.sourceId, {
                                        sourceLayer: "area"
                                    }).forEach((vt)=>{
                                        "level" !== vt.properties.class && void 0 !== vt.properties.level && le1.add(vt.properties.level.toString());
                                    }), this.map.querySourceFeatures(vt, {
                                        sourceLayer: "layer"
                                    }).forEach((vt)=>{
                                        void 0 !== vt.properties["osm|level"] && le1.add(vt.properties["osm|level"].toString());
                                    }), le1.size > 0 && le1.add("0"), 0 !== le1.symmetricDifference(new Set(this.levels)).size && (this.levels = [
                                        ...le1
                                    ].sort((le1, vt)=>parseFloat(le1) - parseFloat(vt)).reverse(), this._emitLevelsChange(), this._refreshAfterLevelsUpdate());
                                }
                            }, le1._indoorFeaturesIDs = {
                                pictures: {},
                                sequences: {}
                            }, le1.on("sourcedata", Fl, (bt)=>{
                                bt.sourceId === vt && (bt.features.forEach((vt)=>{
                                    le1._indoorFeaturesIDs.pictures[vt.properties["osm|level"]] || (le1._indoorFeaturesIDs.pictures[vt.properties["osm|level"]] = new Set), le1._indoorFeaturesIDs.sequences[vt.properties["osm|level"]] || (le1._indoorFeaturesIDs.sequences[vt.properties["osm|level"]] = new Set), le1._indoorFeaturesIDs.pictures[vt.properties["osm|level"]].add(vt.properties.picid), le1._indoorFeaturesIDs.sequences[vt.properties["osm|level"]].add(vt.properties.seqid);
                                }), updateIndoorLevelFilteringThrottled());
                            }), le1.once("load", ()=>{
                                var vt, bt, ls, ho, Dl;
                                (null === (vt = le1.addSemanticOverlay) || void 0 === vt || vt.call(le1, Fl, '"semantics.osm|level" IS NOT NULL', {
                                    type: "circle",
                                    layout: {
                                        visibility: "visible"
                                    },
                                    paint: {
                                        "circle-opacity": 0
                                    }
                                }), [
                                    null,
                                    void 0,
                                    ""
                                ].includes(null === (bt = le1._parent._initParams) || void 0 === bt || null === (ls = bt.getMapPostInit()) || void 0 === ls ? void 0 : ls.level)) || le1.indoorEqual.setLevel(null === (ho = le1._parent._initParams) || void 0 === ho || null === (Dl = ho.getMapPostInit()) || void 0 === Dl ? void 0 : Dl.level);
                            }), le1._parent.grid.appendChild((0, ho.createWebComp)("pnx-level-select", {
                                slot: "bottom-right",
                                _parent: le1._parent,
                                class: "pnx-only-map pnx-print-hidden"
                            }));
                            const updateIndoorLevelFiltering = ()=>{
                                if (le1.indoorEqual.level === Dl) le1.restrictVisibleFeatures("hide", "pictures", []), le1.restrictVisibleFeatures("hide", "sequences", []);
                                else if ("0" === le1.indoorEqual.level) {
                                    const vt = new Set;
                                    Object.entries(le1._indoorFeaturesIDs.pictures).forEach((le1)=>{
                                        let [bt, ls] = le1;
                                        "0" != bt && ls.forEach((le1)=>vt.add(le1));
                                    }), le1.restrictVisibleFeatures("hide", "pictures", [
                                        ...vt
                                    ]);
                                    let bt = new Set;
                                    Object.entries(le1._indoorFeaturesIDs.sequences).forEach((le1)=>{
                                        let [vt, ls] = le1;
                                        "0" != vt && (bt = bt.union(ls));
                                    }), le1._indoorFeaturesIDs.sequences[0] && (bt = bt.difference(le1._indoorFeaturesIDs.sequences[0])), le1.restrictVisibleFeatures("hide", "sequences", [
                                        ...bt
                                    ]);
                                } else le1.restrictVisibleFeatures("keep", "pictures", le1._indoorFeaturesIDs.pictures[le1.indoorEqual.level] ? [
                                    ...le1._indoorFeaturesIDs.pictures[le1.indoorEqual.level]
                                ] : []), le1.restrictVisibleFeatures("keep", "sequences", le1._indoorFeaturesIDs.sequences[le1.indoorEqual.level] ? [
                                    ...le1._indoorFeaturesIDs.sequences[le1.indoorEqual.level]
                                ] : []);
                            }, updateIndoorLevelFilteringThrottled = ()=>{
                                bt && (clearTimeout(bt), bt = void 0), bt = setTimeout(updateIndoorLevelFiltering, 250);
                            };
                            le1.indoorEqual.on("levelchange", updateIndoorLevelFilteringThrottled);
                        }
                    }
                }
            },
            8340: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    MAP_EXPR_QUALITYSCORE: ()=>Md,
                    MAP_EXPR_QUALITYSCORE_GPS: ()=>_u,
                    MAP_THEMES: ()=>kc,
                    RASTER_LAYER_ID: ()=>Fl,
                    TILES_PICTURES_SYMBOL_ZOOM: ()=>uc,
                    TILES_PICTURES_ZOOM: ()=>sc,
                    VECTOR_STYLES: ()=>Ac,
                    VECTOR_STYLES_NOCROWD: ()=>Ec,
                    combineStyles: ()=>combineStyles,
                    getMapParamsFromLocalStorage: ()=>getMapParamsFromLocalStorage,
                    getMissingLayerStyles: ()=>getMissingLayerStyles,
                    getThumbGif: ()=>getThumbGif,
                    getUserLayerId: ()=>getUserLayerId,
                    getUserSourceId: ()=>getUserSourceId,
                    initMapKeyboardHandler: ()=>initMapKeyboardHandler,
                    isLabelLayer: ()=>isLabelLayer,
                    isNullCoordinates: ()=>isNullCoordinates,
                    linkMapAndPhoto: ()=>linkMapAndPhoto,
                    mapFiltersFormValues: ()=>mapFiltersFormValues,
                    mapFiltersToLayersFilters: ()=>mapFiltersToLayersFilters,
                    saveMapParamsToLocalStorage: ()=>saveMapParamsToLocalStorage,
                    switchCoefValue: ()=>switchCoefValue
                });
                var ls = bt(6883), ho = bt(7343), Dl = bt(4964);
                const Fl = "pnx-aerial", sc = 15, uc = 19, mc = [
                    "!",
                    [
                        "has",
                        "uncrowded"
                    ]
                ], gc = [
                    "==",
                    [
                        "get",
                        "type"
                    ],
                    "equirectangular"
                ];
                function getVectorStyles(le1) {
                    return {
                        PICTURES: {
                            paint: {
                                "circle-radius": [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "zoom"
                                    ],
                                    sc,
                                    0,
                                    sc + .5,
                                    le1 ? 1 : [
                                        "case",
                                        mc,
                                        0,
                                        1
                                    ],
                                    sc + 1.5,
                                    le1 ? 2 : [
                                        "case",
                                        mc,
                                        0,
                                        2
                                    ],
                                    sc + 2,
                                    le1 ? 4 : [
                                        "case",
                                        mc,
                                        1,
                                        4
                                    ],
                                    sc + 3,
                                    le1 ? 5 : [
                                        "case",
                                        mc,
                                        3,
                                        5
                                    ],
                                    sc + 5,
                                    le1 ? 7 : [
                                        "case",
                                        mc,
                                        5,
                                        7
                                    ],
                                    sc + 7,
                                    le1 ? 7 : [
                                        "case",
                                        mc,
                                        7,
                                        7
                                    ]
                                ],
                                "circle-opacity": [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "zoom"
                                    ],
                                    sc,
                                    0,
                                    sc + .5,
                                    le1 ? 1 : [
                                        "case",
                                        mc,
                                        0,
                                        1
                                    ],
                                    sc + 1.5,
                                    le1 ? 1 : [
                                        "case",
                                        mc,
                                        0,
                                        1
                                    ],
                                    sc + 2,
                                    1
                                ],
                                "circle-stroke-opacity": [
                                    "case",
                                    [
                                        "all",
                                        mc,
                                        gc
                                    ],
                                    .2,
                                    gc,
                                    .4,
                                    0
                                ],
                                "circle-stroke-width": [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "zoom"
                                    ],
                                    sc + 2.5,
                                    0,
                                    sc + 3.5,
                                    le1 ? [
                                        "case",
                                        gc,
                                        10,
                                        2
                                    ] : [
                                        "case",
                                        [
                                            "all",
                                            mc,
                                            gc
                                        ],
                                        0,
                                        gc,
                                        10,
                                        mc,
                                        0,
                                        2
                                    ],
                                    sc + 4.5,
                                    le1 ? [
                                        "case",
                                        gc,
                                        10,
                                        2
                                    ] : [
                                        "case",
                                        [
                                            "all",
                                            mc,
                                            gc
                                        ],
                                        10,
                                        gc,
                                        10,
                                        mc,
                                        0,
                                        2
                                    ]
                                ]
                            },
                            layout: {}
                        },
                        SEQUENCES: {
                            paint: {
                                "line-width": [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "zoom"
                                    ],
                                    0,
                                    .5,
                                    10,
                                    1.5,
                                    sc - .5,
                                    1.5,
                                    sc + .5,
                                    le1 ? 2 : [
                                        "case",
                                        mc,
                                        .5,
                                        2
                                    ],
                                    22,
                                    le1 ? 4 : [
                                        "case",
                                        mc,
                                        1,
                                        4
                                    ]
                                ]
                            },
                            layout: {
                                "line-cap": "square"
                            }
                        },
                        SEQUENCES_PLUS: {
                            paint: {
                                "line-width": [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "zoom"
                                    ],
                                    0,
                                    15,
                                    sc + 1,
                                    30
                                ],
                                "line-opacity": 0,
                                "line-color": "#ff0000"
                            },
                            layout: {
                                "line-cap": "square"
                            }
                        }
                    };
                }
                const Ac = getVectorStyles(!1), Ec = getVectorStyles(!0), kc = {
                    DEFAULT: "default",
                    AGE: "age",
                    TYPE: "type",
                    SCORE: "score",
                    GPS: "gps"
                }, du = [
                    "case",
                    [
                        "==",
                        [
                            "get",
                            "type"
                        ],
                        "equirectangular"
                    ],
                    [
                        "case",
                        [
                            "has",
                            "h_pixel_density"
                        ],
                        [
                            "step",
                            [
                                "get",
                                "h_pixel_density"
                            ],
                            ...ho.QUALITYSCORE_RES_360_VALUES
                        ],
                        1
                    ],
                    [
                        "case",
                        [
                            "has",
                            "h_pixel_density"
                        ],
                        [
                            "step",
                            [
                                "get",
                                "h_pixel_density"
                            ],
                            ...ho.QUALITYSCORE_RES_FLAT_VALUES
                        ],
                        1
                    ]
                ], _u = [
                    "case",
                    [
                        "has",
                        "gps_accuracy"
                    ],
                    [
                        "step",
                        [
                            "get",
                            "gps_accuracy"
                        ],
                        ...ho.QUALITYSCORE_GPS_VALUES
                    ],
                    1
                ], Md = [
                    "round",
                    [
                        "+",
                        [
                            "*",
                            du,
                            ho.QUALITYSCORE_POND_RES
                        ],
                        [
                            "*",
                            _u,
                            ho.QUALITYSCORE_POND_GPS
                        ]
                    ]
                ];
                function getThumbGif(le1) {
                    const vt = document.createElement("img");
                    return vt.src = ls, vt.alt = le1.loading, vt.title = le1.loading, vt.classList.add("pnx-map-thumb", "pnx-map-thumb-loader"), vt;
                }
                function isNullCoordinates(le1) {
                    return null === le1 || void 0 === le1 || Array.isArray(le1) && (2 === le1.length && 0 === le1[0] && 0 === le1[1] || le1.length < 2);
                }
                function isLabelLayer(le1) {
                    var vt;
                    return "symbol" === le1.type && void 0 !== (null === le1 || void 0 === le1 || null === (vt = le1.layout) || void 0 === vt ? void 0 : vt["text-field"]) && (void 0 === le1.minzoom || le1.minzoom < 15);
                }
                function combineStyles(le1, vt) {
                    var bt, ls, ho;
                    const sc = le1.api.getMapStyle();
                    if (sc.layers = sc.layers || [], sc.layers = sc.layers.concat(getMissingLayerStyles(sc.sources, sc.layers)), sc.metadata || (sc.metadata = {}), vt.supplementaryStyle && (Object.assign(sc.sources, vt.supplementaryStyle.sources || {}), Object.assign(sc.metadata, vt.supplementaryStyle.metadata || {}), sc.layers = sc.layers.concat(vt.supplementaryStyle.layers || [])), sc.layers = sc.layers.filter((le1)=>le1.id), vt.raster && (sc.sources["pnx-aerial"] = vt.raster, sc.layers.push({
                        id: Fl,
                        type: "raster",
                        source: "pnx-aerial",
                        layout: {
                            visibility: "aerial" === vt.background ? "visible" : "none"
                        }
                    })), null !== le1 && void 0 !== le1 && null !== (bt = le1.users) && void 0 !== bt && bt.includes("geovisio") || sc.layers.forEach((le1)=>{
                        "geovisio" === le1.source && (le1.layout || (le1.layout = {}), le1.layout.visibility = "none");
                    }), sc.layers.sort((le1, vt)=>isLabelLayer(le1) && !isLabelLayer(vt) ? 1 : !isLabelLayer(le1) && isLabelLayer(vt) ? -1 : le1.id.startsWith("geovisio") && !vt.id.startsWith("geovisio") ? 1 : !le1.id.startsWith("geovisio") && vt.id.startsWith("geovisio") ? -1 : le1.id.endsWith("_pictures") && !vt.id.endsWith("_pictures") ? 1 : !le1.id.endsWith("_pictures") && vt.id.endsWith("_pictures") ? -1 : 0), null !== (ls = sc.metadata) && void 0 !== ls && ls["panoramax:locales"] || (sc.metadata["panoramax:locales"] = [
                        "fr",
                        "en",
                        "de",
                        "es",
                        "ru",
                        "pt",
                        "zh",
                        "hi",
                        "latin"
                    ]), sc.metadata["panoramax:locales"]) {
                        let vt = le1.lang || (0, Dl.autoDetectLocale)(sc.metadata["panoramax:locales"], "latin");
                        vt.includes("-") && (vt = vt.split("-")[0]), vt.includes("_") && (vt = vt.split("_")[0]), sc.layers.forEach((le1)=>{
                            isLabelLayer(le1) && le1.layout["text-field"].includes("name:latin") && (le1.layout["text-field"] = [
                                "coalesce",
                                [
                                    "get",
                                    `name:${vt}`
                                ],
                                [
                                    "get",
                                    "name:latin"
                                ],
                                [
                                    "get",
                                    "name"
                                ]
                            ]);
                        });
                    }
                    const uc = sc.layers.find((le1)=>"place_label_city" == le1.id);
                    let mc = sc.layers.find((le1)=>"place_label_capital" == le1.id);
                    return uc && !mc && (uc.paint = {
                        "text-color": "hsl(0, 0%, 0%)",
                        "text-halo-blur": 0,
                        "text-halo-color": "hsla(0, 0%, 100%, 1)",
                        "text-halo-width": 3
                    }, uc.layout["text-letter-spacing"] = .1, mc = JSON.parse(JSON.stringify(uc)), mc.id = "place_label_capital", mc.filter.push([
                        "<=",
                        "capital",
                        2
                    ]), uc.filter.push([
                        ">",
                        "capital",
                        2
                    ]), sc.layers.push(mc)), null !== sc && void 0 !== sc && null !== (ho = sc.sources) && void 0 !== ho && ho.plan_ign && (sc.sources.plan_ign.maxzoom = 18), sc;
                }
                function getMissingLayerStyles() {
                    let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {}, vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const bt = [];
                    return Object.keys(le1).filter((le1)=>void 0 === vt.find((vt)=>(null === vt || void 0 === vt ? void 0 : vt.source) === le1)).forEach((le1)=>{
                        le1.startsWith("geovisio") && (bt.push({
                            id: `${le1}_sequences`,
                            type: "line",
                            source: le1,
                            "source-layer": "sequences",
                            layout: {
                                ...Ac.SEQUENCES.layout
                            },
                            paint: {
                                ...Ac.SEQUENCES.paint,
                                "line-color": ho.COLORS.BASE
                            }
                        }), bt.push({
                            id: `${le1}_sequences_plus`,
                            type: "line",
                            source: le1,
                            "source-layer": "sequences",
                            layout: {
                                ...Ac.SEQUENCES_PLUS.layout
                            },
                            paint: {
                                ...Ac.SEQUENCES_PLUS.paint
                            }
                        }), bt.push({
                            id: `${le1}_pictures`,
                            type: "circle",
                            source: le1,
                            "source-layer": "pictures",
                            layout: {
                                ...Ac.PICTURES.layout
                            },
                            paint: {
                                ...Ac.PICTURES.paint,
                                "circle-color": ho.COLORS.BASE
                            }
                        }));
                    }), vt.filter((le1)=>{
                        var bt;
                        return (null === le1 || void 0 === le1 || null === (bt = le1.id) || void 0 === bt ? void 0 : bt.endsWith("_sequences")) && void 0 === vt.find((vt)=>(null === vt || void 0 === vt ? void 0 : vt.id) === le1.id + "_plus");
                    }).forEach((le1)=>{
                        bt.push({
                            id: `${le1.id}_plus`,
                            type: "line",
                            source: le1.source,
                            "source-layer": le1["source-layer"],
                            layout: {
                                ...Ac.SEQUENCES_PLUS.layout
                            },
                            paint: {
                                ...Ac.SEQUENCES_PLUS.paint
                            }
                        });
                    }), vt.filter((le1)=>{
                        var bt;
                        return (null === le1 || void 0 === le1 || null === (bt = le1.id) || void 0 === bt ? void 0 : bt.endsWith("_pictures")) && void 0 === vt.find((vt)=>(null === vt || void 0 === vt ? void 0 : vt.id) === le1.id + "_symbols");
                    }).forEach((le1)=>{
                        le1.paint = Object.assign(le1.paint || {}, Ac.PICTURES.paint), le1.layout = Object.assign(le1.layout || {}, Ac.PICTURES.layout);
                    }), bt;
                }
                function mapFiltersFormValues(le1, vt, bt) {
                    const ls = null === le1 || void 0 === le1 ? void 0 : le1.shadowRoot.getElementById("pnx-filter-date-from"), ho = null === le1 || void 0 === le1 ? void 0 : le1.shadowRoot.getElementById("pnx-filter-date-end"), Dl = null === le1 || void 0 === le1 ? void 0 : le1.shadowRoot.querySelectorAll("input[name='pnx-filter-type']");
                    let Fl = "";
                    for(let mc = 0; mc < Dl.length; mc++){
                        const le1 = Dl[mc];
                        if (le1.checked) {
                            Fl = le1.value;
                            break;
                        }
                    }
                    let sc = [], uc = [];
                    if (bt) {
                        const vt = null === le1 || void 0 === le1 ? void 0 : le1.shadowRoot.getElementById("pnx-filter-qualityscore");
                        sc = ((null === vt || void 0 === vt ? void 0 : vt.grade) || "").split(",").map((le1)=>parseInt(le1)).filter((le1)=>!isNaN(le1));
                        const bt = null === le1 || void 0 === le1 ? void 0 : le1.shadowRoot.getElementById("pnx-filter-gps");
                        uc = ((null === bt || void 0 === bt ? void 0 : bt.grade) || "").split(",").map((le1)=>parseInt(le1)).filter((le1)=>!isNaN(le1));
                    }
                    return {
                        minDate: null === ls || void 0 === ls ? void 0 : ls.value,
                        maxDate: null === ho || void 0 === ho ? void 0 : ho.value,
                        pic_type: Fl,
                        theme: null === vt || void 0 === vt ? void 0 : vt.value,
                        qualityscore: sc,
                        gps: uc
                    };
                }
                function mapFiltersToLayersFilters(le1) {
                    var vt, bt;
                    let ls = arguments.length > 1 && void 0 !== arguments[1] && arguments[1], ho = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : null, Dl = {}, Fl = [], uc = [], mc = !1;
                    if (le1.minDate && "" !== le1.minDate && (Dl.minDate = le1.minDate, Fl.push([
                        ">=",
                        [
                            "get",
                            "date"
                        ],
                        le1.minDate
                    ]), uc.push([
                        ">=",
                        [
                            "get",
                            "ts"
                        ],
                        le1.minDate
                    ])), le1.maxDate && "" !== le1.maxDate) {
                        Dl.maxDate = le1.maxDate, Fl.push([
                            "<=",
                            [
                                "get",
                                "date"
                            ],
                            le1.maxDate
                        ]);
                        let vt = new Date(le1.maxDate);
                        vt.setDate(vt.getDate() + 1), vt = vt.toISOString().split("T")[0], uc.push([
                            "<=",
                            [
                                "get",
                                "ts"
                            ],
                            vt
                        ]);
                    }
                    if (le1.pic_type && "" !== le1.pic_type && (Dl.pic_type = "flat" === le1.pic_type ? "flat" : "equirectangular", Fl.push([
                        "==",
                        [
                            "get",
                            "type"
                        ],
                        Dl.pic_type
                    ]), uc.push([
                        "==",
                        [
                            "get",
                            "type"
                        ],
                        Dl.pic_type
                    ])), ls && (mc = !0), le1.camera && "" !== le1.camera) {
                        Dl.camera = le1.camera;
                        const vt = le1.camera.toLowerCase().trim() + "                    ", bt = le1.camera.toLowerCase().trim() + "zzzzzzzzzzzzzzzzzzzz", ls = [
                            "collator",
                            {
                                "case-sensitive": !1,
                                "diacritic-sensitive": !1
                            }
                        ];
                        Fl.push([
                            ">=",
                            [
                                "get",
                                "model"
                            ],
                            vt,
                            ls
                        ]), Fl.push([
                            "<=",
                            [
                                "get",
                                "model"
                            ],
                            bt,
                            ls
                        ]), uc.push([
                            ">=",
                            [
                                "get",
                                "model"
                            ],
                            vt,
                            ls
                        ]), uc.push([
                            "<=",
                            [
                                "get",
                                "model"
                            ],
                            bt,
                            ls
                        ]);
                    }
                    return le1.qualityscore && le1.qualityscore.length > 0 && (Dl.qualityscore = le1.qualityscore, Fl.push([
                        "in",
                        Md,
                        [
                            "literal",
                            Dl.qualityscore
                        ]
                    ]), uc.push([
                        "in",
                        Md,
                        [
                            "literal",
                            Dl.qualityscore
                        ]
                    ])), le1.gps && le1.gps.length > 0 && (Dl.gps = le1.gps, Fl.push([
                        "in",
                        _u,
                        [
                            "literal",
                            Dl.gps
                        ]
                    ]), uc.push([
                        "in",
                        _u,
                        [
                            "literal",
                            Dl.gps
                        ]
                    ])), le1.theme && Object.values(kc).includes(le1.theme) && (Dl.theme = le1.theme, mc = !0), null !== ho && void 0 !== ho && ho.pictures && (null === (vt = ho.pictures.features) || void 0 === vt ? void 0 : vt.length) >= 0 && ("keep" === ho.pictures.rule ? uc.push([
                        "in",
                        [
                            "get",
                            "id"
                        ],
                        [
                            "literal",
                            ho.pictures.features
                        ]
                    ]) : ho.pictures.features.length > 0 && uc.push([
                        "!",
                        [
                            "in",
                            [
                                "get",
                                "id"
                            ],
                            [
                                "literal",
                                ho.pictures.features
                            ]
                        ]
                    ])), null !== ho && void 0 !== ho && ho.sequences && (null === (bt = ho.sequences.features) || void 0 === bt ? void 0 : bt.length) >= 0 && ("keep" === ho.sequences.rule ? Fl.push([
                        "in",
                        [
                            "get",
                            "id"
                        ],
                        [
                            "literal",
                            ho.sequences.features
                        ]
                    ]) : ho.sequences.features.length > 0 && Fl.push([
                        "!",
                        [
                            "in",
                            [
                                "get",
                                "id"
                            ],
                            [
                                "literal",
                                ho.sequences.features
                            ]
                        ]
                    ])), 0 == Fl.length ? Fl = null : Fl.unshift("all"), 0 == uc.length ? uc = null : (uc.unshift("all"), uc = [
                        "step",
                        [
                            "zoom"
                        ],
                        !0,
                        sc,
                        uc
                    ]), {
                        mapFilters: Dl,
                        mapSeqFilters: Fl,
                        mapPicFilters: uc,
                        reloadMapStyle: mc
                    };
                }
                function getUserLayerId(le1, vt) {
                    return `${getUserSourceId(le1)}_${vt}`;
                }
                function getUserSourceId(le1) {
                    return "geovisio" === le1 ? "geovisio" : "geovisio_" + le1;
                }
                function switchCoefValue(le1, vt) {
                    if (Array.isArray(le1)) return le1.map((le1)=>switchCoefValue(le1, vt));
                    if ("object" === typeof le1 && null !== le1) {
                        const bt = {};
                        for(const ls in le1)bt[ls] = switchCoefValue(le1[ls], vt);
                        return bt;
                    }
                    return "string" === typeof le1 && (le1.startsWith("coef") || le1.startsWith("logged_coef")) ? vt : le1;
                }
                function linkMapAndPhoto(le1) {
                    const onPicLoad = (vt)=>{
                        var bt, ls, Dl, Fl, sc, uc;
                        (0, ho.isNullId)(vt.detail.picId) ? (le1.map.displayPictureMarker(), null !== le1 && void 0 !== le1 && null !== (bt = le1.isMapWide) && void 0 !== bt && bt.call(le1) && (null === le1 || void 0 === le1 || null === (ls = le1.mini) || void 0 === ls || ls.setAttribute("collapsed", ""))) : (le1.map.displayPictureMarker(vt.detail.lon, vt.detail.lat, le1.psv.getXY().x, vt.detail.first && !isNullCoordinates(null === (Dl = le1._initParams) || void 0 === Dl || null === (Fl = Dl.getMapPostInit()) || void 0 === Fl ? void 0 : Fl.center), vt.detail.picId), null !== le1 && void 0 !== le1 && null !== (sc = le1.isMapWide) && void 0 !== sc && sc.call(le1) && (null === le1 || void 0 === le1 || null === (uc = le1.mini) || void 0 === uc || uc.removeAttribute("collapsed")));
                    };
                    le1.psv.addEventListener("picture-loading", onPicLoad), le1.psv.addEventListener("picture-loaded", onPicLoad), le1.psv.addEventListener("view-rotated", ()=>{
                        let vt = le1.psv.getPosition().yaw * (180 / Math.PI);
                        vt += le1.psv.getPictureOriginalHeading(), le1.map._picMarker.setRotation(vt);
                    }), le1.psv.addEventListener("picture-preview-started", (vt)=>{
                        le1.map._picMarkerPreview.setLngLat(vt.detail.coordinates).setRotation(vt.detail.direction || 0).addTo(le1.map);
                    }), le1.psv.addEventListener("picture-preview-stopped", ()=>{
                        le1.map._picMarkerPreview.remove();
                    }), le1.psv.addEventListener("picture-loaded", (vt)=>{
                        le1.isWidthSmall() && le1._picPopup && vt.detail.picId == le1._picPopup._picId && le1._picPopup.remove();
                    }), le1.map.on("picture-click", (vt)=>{
                        le1.select(vt.seqId, vt.picId), !le1.psv._myVTour.state.currentNode && null !== le1 && void 0 !== le1 && le1._setFocus && le1._setFocus("pic");
                    }), le1.map.on("sequence-click", (vt)=>{
                        le1.api.getPicturesAroundCoordinates(vt.coordinates.lat, vt.coordinates.lng, .01, 1, vt.seqId).then((vt)=>{
                            var bt, ls;
                            (null === vt || void 0 === vt || null === (bt = vt.features) || void 0 === bt ? void 0 : bt.length) > 0 && (le1.select(null === (ls = vt.features[0]) || void 0 === ls ? void 0 : ls.collection, vt.features[0].id), !le1.psv.getPictureMetadata() && null !== le1 && void 0 !== le1 && le1._setFocus && le1._setFocus("pic"));
                        });
                    }), le1._setFocus && (le1.psv.addEventListener("dblclick", ()=>{
                        le1.isMapWide() && le1._setFocus("pic");
                    }), le1.map.on("dblclick", ()=>{
                        le1.isMapWide() ? "any" === le1.psv.getPicturesNavigation() && le1.select() : le1._setFocus("map");
                    }));
                }
                function initMapKeyboardHandler(le1) {
                    le1.map.keyboard.keydown = (function(vt) {
                        if (vt.altKey || vt.ctrlKey || vt.metaKey) return;
                        switch(vt.key){
                            case "*":
                            case "5":
                                return void le1.moveCenter();
                            case "PageUp":
                            case "9":
                                return void le1.psv.goToNextPicture();
                            case "PageDown":
                            case "3":
                                return void le1.psv.goToPrevPicture();
                            case "Home":
                            case "7":
                                return vt.stopPropagation(), void le1._toggleFocus();
                            case "End":
                            case "1":
                                return void le1.mini.toggleAttribute("collapsed");
                            case " ":
                            case "0":
                                return void le1.psv.toggleSequencePlaying();
                        }
                        let bt = 0, ls = 0, ho = 0, Dl = 0, Fl = 0;
                        switch(vt.keyCode){
                            case 61:
                            case 107:
                            case 171:
                            case 187:
                                bt = 1;
                                break;
                            case 189:
                            case 109:
                            case 173:
                                bt = -1;
                                break;
                            case 37:
                            case 100:
                                vt.shiftKey ? ls = -1 : (vt.preventDefault(), Dl = -1);
                                break;
                            case 39:
                            case 102:
                                vt.shiftKey ? ls = 1 : (vt.preventDefault(), Dl = 1);
                                break;
                            case 38:
                            case 104:
                                vt.shiftKey ? ho = 1 : (vt.preventDefault(), Fl = -1);
                                break;
                            case 40:
                            case 98:
                                vt.shiftKey ? ho = -1 : (vt.preventDefault(), Fl = 1);
                                break;
                            default:
                                return;
                        }
                        return this._rotationDisabled && (ls = 0, ho = 0), {
                            cameraAnimation: (le1)=>{
                                const sc = this._tr;
                                le1.easeTo({
                                    duration: 300,
                                    easeId: "keyboardHandler",
                                    easing: (le1)=>le1 * (2 - le1),
                                    zoom: bt ? Math.round(sc.zoom) + bt * (vt.shiftKey ? 2 : 1) : sc.zoom,
                                    bearing: sc.bearing + ls * this._bearingStep,
                                    pitch: sc.pitch + ho * this._pitchStep,
                                    offset: [
                                        -Dl * this._panStep,
                                        -Fl * this._panStep
                                    ],
                                    center: sc.center
                                }, {
                                    originalEvent: vt
                                });
                            }
                        };
                    }).bind(le1.map.keyboard);
                }
                const Ld = "pnx-map-parameters";
                function getMapParamsFromLocalStorage() {
                    const le1 = localStorage.getItem(Ld);
                    if (!le1) return {};
                    try {
                        return JSON.parse(le1);
                    } catch (vt) {
                        return console.warn("Can't read map parameters stored in localStorage", vt), {};
                    }
                }
                function saveMapParamsToLocalStorage(le1) {
                    const save = ()=>localStorage.setItem(Ld, JSON.stringify({
                            center: Object.fromEntries(Object.entries(le1.getCenter()).map((le1)=>{
                                let [vt, bt] = le1;
                                return [
                                    vt,
                                    bt.toFixed(7)
                                ];
                            })),
                            zoom: le1.getZoom().toFixed(1),
                            background: le1.getBackground(),
                            theme: le1._mapFilters.theme
                        }));
                    le1.on("background-changed", save), le1.on("filters-changed", save), le1.on("moveend", save), le1.on("zoomend", save), le1.on("dragend", save), le1.on("boxzoomend", save);
                }
            },
            508: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    apiFeatureToPSVNode: ()=>apiFeatureToPSVNode,
                    filterRelatedPicsLinks: ()=>filterRelatedPicsLinks,
                    getCroppedPanoData: ()=>getCroppedPanoData,
                    getExifFloat: ()=>getExifFloat,
                    getGPSPrecision: ()=>getGPSPrecision,
                    getHashTags: ()=>getHashTags,
                    getNodeCaption: ()=>getNodeCaption,
                    getSphereCorrection: ()=>getSphereCorrection,
                    hasAnnotations: ()=>hasAnnotations,
                    sortPicturesInDirection: ()=>sortPicturesInDirection
                });
                var ls = bt(8407), ho = bt(6830), Dl = bt(7343);
                const Fl = (0, Dl.svgToPSVLink)(ls, "white"), sc = (0, Dl.svgToPSVLink)(ho, Dl.COLORS.NEXT);
                function getExifFloat(le1) {
                    if (!([
                        null,
                        void 0,
                        ""
                    ].includes(le1) || "string" === typeof le1 && "" === le1.trim())) {
                        if ("number" === typeof le1) return le1;
                        if ("string" !== typeof le1) ;
                        else {
                            if (/^-?\d+(\.\d+)?\/-?\d+(\.\d+)?$/.test(le1)) {
                                const vt = le1.split("/").map((le1)=>parseFloat(le1));
                                return vt[0] / vt[1];
                            }
                            try {
                                return parseFloat(le1);
                            } catch (vt) {}
                        }
                    }
                }
                function getGPSPrecision(le1) {
                    var vt, bt, ls, ho, Dl;
                    let Fl = null;
                    const sc = (null === le1 || void 0 === le1 || null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["quality:horizontal_accuracy"]) || getExifFloat(null === le1 || void 0 === le1 || null === (bt = le1.properties) || void 0 === bt || null === (ls = bt.exif) || void 0 === ls ? void 0 : ls["Exif.GPSInfo.GPSHPositioningError"]), uc = getExifFloat(null === le1 || void 0 === le1 || null === (ho = le1.properties) || void 0 === ho || null === (Dl = ho.exif) || void 0 === Dl ? void 0 : Dl["Exif.GPSInfo.GPSDOP"]);
                    return void 0 !== sc ? Fl = `${sc} m` : void 0 !== uc && (Fl = uc < 1 ? "ideal" : uc < 2 ? "excellent" : uc < 5 ? "good" : uc < 10 ? "moderate" : uc < 20 ? "fair" : "poor"), Fl;
                }
                function getSphereCorrection(le1) {
                    var vt, bt, ls, ho;
                    let Dl = null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["view:azimuth"];
                    if (void 0 === Dl) {
                        var Fl, sc;
                        const vt = getExifFloat(null === (Fl = le1.properties) || void 0 === Fl || null === (sc = Fl.exif) || void 0 === sc ? void 0 : sc["Exif.GPSInfo.GPSImgDirection"]);
                        void 0 !== vt && (Dl = vt);
                    }
                    Dl = Dl || 0;
                    let uc = null === (bt = le1.properties) || void 0 === bt ? void 0 : bt["pers:yaw"], mc = [
                        "Xmp.GPano.PoseHeadingDegrees",
                        "Xmp.Camera.Yaw",
                        "Exif.MpfInfo.MPFYawAngle"
                    ];
                    if (void 0 === uc) for (let Nd of mc){
                        var gc, Ac;
                        const vt = getExifFloat(null === (gc = le1.properties) || void 0 === gc || null === (Ac = gc.exif) || void 0 === Ac ? void 0 : Ac[Nd]);
                        if (void 0 !== vt) {
                            uc = vt;
                            break;
                        }
                    }
                    uc = uc || 0, Math.round(Dl) === Math.round(uc) && uc > 0 && console.warn("Picture with UUID", le1.id, "has same GPS Image direction and Yaw, could cause rendering issues");
                    let Ec = null === (ls = le1.properties) || void 0 === ls ? void 0 : ls["pers:pitch"];
                    if (mc = [
                        "Xmp.GPano.PosePitchDegrees",
                        "Xmp.Camera.Pitch",
                        "Exif.MpfInfo.MPFPitchAngle"
                    ], void 0 === Ec) for (let Nd of mc){
                        var kc, du;
                        const vt = getExifFloat(null === (kc = le1.properties) || void 0 === kc || null === (du = kc.exif) || void 0 === du ? void 0 : du[Nd]);
                        if (void 0 !== vt) {
                            Ec = vt;
                            break;
                        }
                    }
                    Ec = Ec || 0;
                    let _u = null === (ho = le1.properties) || void 0 === ho ? void 0 : ho["pers:roll"];
                    if (mc = [
                        "Xmp.GPano.PoseRollDegrees",
                        "Xmp.Camera.Roll",
                        "Exif.MpfInfo.MPFRollAngle"
                    ], void 0 === _u) for (let Nd of mc){
                        var Md, Ld;
                        const vt = getExifFloat(null === (Md = le1.properties) || void 0 === Md || null === (Ld = Md.exif) || void 0 === Ld ? void 0 : Ld[Nd]);
                        if (void 0 !== vt) {
                            _u = vt;
                            break;
                        }
                    }
                    return _u = _u || 0, 0 !== Ec && 0 !== _u ? {
                        pan: uc * Math.PI / 180,
                        tilt: -Ec * Math.PI / 180,
                        roll: _u * Math.PI / 180
                    } : {};
                }
                function getCroppedPanoData(le1, vt) {
                    var bt, ls, ho;
                    let Dl;
                    var Fl, sc;
                    if (null !== (bt = le1.properties) && void 0 !== bt && bt["pers:interior_orientation"] && null !== (Fl = le1.properties["pers:interior_orientation"]) && void 0 !== Fl && Fl.visible_area && null !== (sc = le1.properties["pers:interior_orientation"]) && void 0 !== sc && sc.sensor_array_dimensions) {
                        const vt = le1.properties["pers:interior_orientation"].visible_area, bt = le1.properties["pers:interior_orientation"].sensor_array_dimensions;
                        try {
                            Dl = {
                                fullWidth: parseInt(bt[0]),
                                fullHeight: parseInt(bt[1]),
                                croppedX: parseInt(vt[0]),
                                croppedY: parseInt(vt[1]),
                                croppedWidth: parseInt(bt[0]) - parseInt(vt[2]) - parseInt(vt[0]),
                                croppedHeight: parseInt(bt[1]) - parseInt(vt[3]) - parseInt(vt[1])
                            };
                        } catch (_u) {
                            console.warn("Invalid pers:interior_orientation values for cropped panorama " + le1.id);
                        }
                    }
                    if (!Dl && null !== (ls = le1.properties) && void 0 !== ls && ls.exif) try {
                        var uc, mc, gc, Ac, Ec, kc;
                        Dl = {
                            fullWidth: parseInt(null === (uc = le1.properties.exif) || void 0 === uc ? void 0 : uc["Xmp.GPano.FullPanoWidthPixels"]),
                            fullHeight: parseInt(null === (mc = le1.properties.exif) || void 0 === mc ? void 0 : mc["Xmp.GPano.FullPanoHeightPixels"]),
                            croppedX: parseInt(null === (gc = le1.properties.exif) || void 0 === gc ? void 0 : gc["Xmp.GPano.CroppedAreaLeftPixels"]),
                            croppedY: parseInt(null === (Ac = le1.properties.exif) || void 0 === Ac ? void 0 : Ac["Xmp.GPano.CroppedAreaTopPixels"]),
                            croppedWidth: parseInt(null === (Ec = le1.properties.exif) || void 0 === Ec ? void 0 : Ec["Xmp.GPano.CroppedAreaImageWidthPixels"]),
                            croppedHeight: parseInt(null === (kc = le1.properties.exif) || void 0 === kc ? void 0 : kc["Xmp.GPano.CroppedAreaImageHeightPixels"])
                        }, Dl.croppedWidth > Dl.fullWidth && (Dl.fullWidth = Dl.croppedWidth), Dl.croppedHeight > Dl.fullHeight && (Dl.fullHeight = Dl.croppedHeight);
                    } catch (_u) {
                        console.warn("Invalid XMP.GPano values for cropped panorama " + le1.id);
                    }
                    if (Dl && (Dl = Object.fromEntries(Object.entries(Dl || {}).filter((le1)=>!isNaN(le1[1]))), (!Dl.fullWidth && !Dl.croppedWidth && Dl.fullHeight && !Dl.croppedHeight || Dl.fullWidth && !Dl.croppedWidth && !Dl.fullHeight && !Dl.croppedHeight || Dl.fullWidth && !Dl.croppedWidth && Dl.fullHeight && !Dl.croppedHeight || Dl.fullWidth == Dl.croppedWidth && Dl.fullHeight == Dl.croppedHeight) && (Dl = {})), null !== (ho = Dl) && void 0 !== ho && ho.fullWidth && null !== vt && void 0 !== vt && vt.width) {
                        var du;
                        let le1 = vt.width / ((null === (du = Dl) || void 0 === du ? void 0 : du.croppedWidth) || Dl.fullWidth);
                        Dl = {
                            fullWidth: void 0 !== Dl.fullWidth ? Math.floor(Dl.fullWidth * le1) : void 0,
                            fullHeight: void 0 !== Dl.fullHeight ? Math.floor(Dl.fullHeight * le1) : void 0,
                            croppedWidth: void 0 !== Dl.croppedWidth ? Math.floor(Dl.croppedWidth * le1) : void 0,
                            croppedHeight: void 0 !== Dl.croppedHeight ? Math.floor(Dl.croppedHeight * le1) : void 0,
                            croppedX: void 0 !== Dl.croppedX ? Math.floor(Dl.croppedX * le1) : void 0,
                            croppedY: void 0 !== Dl.croppedY ? Math.floor(Dl.croppedY * le1) : void 0
                        };
                    }
                    return Dl || {};
                }
                function sortPicturesInDirection(le1) {
                    return (vt, bt)=>"related" != vt.rel && "related" != bt.rel ? 0 : "related" != vt.rel ? -1 : "related" != bt.rel ? 1 : vt.date == bt.date ? (0, Dl.getDistance)(le1, vt.geometry.coordinates) - (0, Dl.getDistance)(le1, bt.geometry.coordinates) : bt.date.localeCompare(vt.date);
                }
                function getNodeCaption(le1, vt) {
                    var bt, ls, ho;
                    const Dl = {};
                    if (null !== le1 && void 0 !== le1 && null !== (bt = le1.properties) && void 0 !== bt && bt.datetimetz) {
                        Dl.date = new Date(le1.properties.datetimetz);
                        const vt = le1.properties.datetimetz.match(/([+-]\d{2}):(\d{2})$|Z$/);
                        vt && ("Z" === vt[0] ? Dl.tz = "UTC" : Dl.tz = vt[0]);
                    } else null !== le1 && void 0 !== le1 && null !== (ls = le1.properties) && void 0 !== ls && ls.datetime && (Dl.date = new Date(le1.properties.datetime));
                    if (null !== le1 && void 0 !== le1 && le1.providers) {
                        var Fl;
                        const vt = null === le1 || void 0 === le1 || null === (Fl = le1.providers) || void 0 === Fl ? void 0 : Fl.filter((le1)=>{
                            var vt;
                            return null === le1 || void 0 === le1 || null === (vt = le1.roles) || void 0 === vt ? void 0 : vt.includes("producer");
                        });
                        if ((null === vt || void 0 === vt ? void 0 : vt.length) >= 0) {
                            const le1 = {};
                            vt.map((le1)=>le1.name).forEach((vt)=>{
                                const bt = vt.toLowerCase().replace(/\s/g, "");
                                le1[bt] ? le1[bt].push(vt) : le1[bt] = [
                                    vt
                                ];
                            }), Dl.producer = [], Object.values(le1).forEach((le1)=>{
                                const vt = le1[0], bt = le1.find((le1)=>le1.toLowerCase() != le1);
                                Dl.producer.push(bt || vt);
                            });
                        }
                    }
                    if (null !== le1 && void 0 !== le1 && null !== (ho = le1.properties) && void 0 !== ho && ho.license && (Dl.license = le1.properties.license, null !== le1 && void 0 !== le1 && le1.links)) {
                        const bt = le1.links.find((le1)=>"license" === (null === le1 || void 0 === le1 ? void 0 : le1.rel));
                        bt && (Dl.license = `<a href="${bt.href}" title="${vt.pnx.metadata_general_license_link}" target="_blank">${Dl.license}</a>`);
                    }
                    return Dl;
                }
                function apiFeatureToPSVNode(le1, vt) {
                    var bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld;
                    let Nd = arguments.length > 2 && void 0 !== arguments[2] && arguments[2], Rd = arguments.length > 3 && void 0 !== arguments[3] ? arguments[3] : null, Od = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : (le1)=>le1;
                    const jd = null != (null === (bt = le1.properties) || void 0 === bt || null === (ls = bt["pers:interior_orientation"]) || void 0 === ls ? void 0 : ls.field_of_view);
                    let Ud = jd ? parseInt(le1.properties["pers:interior_orientation"].field_of_view) : 70;
                    const Gd = 360 === Ud, qd = Od((Object.values(le1.assets).find((le1)=>{
                        var vt;
                        return null === le1 || void 0 === le1 || null === (vt = le1.roles) || void 0 === vt ? void 0 : vt.includes("data");
                    }) || {}).href), Hd = null === le1 || void 0 === le1 || null === (ho = le1.properties) || void 0 === ho || null === (Dl = ho["tiles:tile_matrix_sets"]) || void 0 === Dl ? void 0 : Dl.geovisio, Wd = null === (Fl = le1.links) || void 0 === Fl || null === (sc = Fl.find) || void 0 === sc ? void 0 : sc.call(Fl, (le1)=>"prev" === (null === le1 || void 0 === le1 ? void 0 : le1.rel) && "application/geo+json" === (null === le1 || void 0 === le1 ? void 0 : le1.type)), Zd = null === (uc = le1.links) || void 0 === uc || null === (mc = uc.find) || void 0 === mc ? void 0 : mc.call(uc, (le1)=>"next" === (null === le1 || void 0 === le1 ? void 0 : le1.rel) && "application/geo+json" === (null === le1 || void 0 === le1 ? void 0 : le1.type)), Yd = Object.values(le1.assets).find((le1)=>{
                        var vt;
                        return (null === (vt = le1.roles) || void 0 === vt ? void 0 : vt.includes("visual")) && "image/webp" === le1.type;
                    }), Qd = Object.values(le1.assets).find((le1)=>{
                        var vt;
                        return (null === (vt = le1.roles) || void 0 === vt ? void 0 : vt.includes("visual")) && "image/jpeg" === le1.type;
                    }), Xd = Od((Yd || Qd).href), Kd = Od(null === (gc = Object.values(le1.assets).find((le1)=>{
                        var vt;
                        return (null === (vt = le1.roles) || void 0 === vt ? void 0 : vt.includes("thumbnail")) && "image/jpeg" === le1.type;
                    })) || void 0 === gc ? void 0 : gc.href), Jd = (null === le1 || void 0 === le1 || null === (Ac = le1.asset_templates) || void 0 === Ac ? void 0 : Ac.tiles_webp) || (null === le1 || void 0 === le1 || null === (Ec = le1.asset_templates) || void 0 === Ec ? void 0 : Ec.tiles), $d = getCroppedPanoData(le1), sp = null === (kc = le1.links) || void 0 === kc || null === (du = kc.find) || void 0 === du ? void 0 : du.call(kc, (le1)=>"via" === (null === le1 || void 0 === le1 ? void 0 : le1.rel) && "application/json" === (null === le1 || void 0 === le1 ? void 0 : le1.type)), em = null === (_u = le1.properties) || void 0 === _u || null === (Md = _u["pers:interior_orientation"]) || void 0 === Md ? void 0 : Md.sensor_array_dimensions;
                    let tm;
                    if (Object.keys($d).length > 0) tm = {
                        baseUrl: Nd ? qd : Xd,
                        origBaseUrl: Nd ? qd : Xd,
                        hdUrl: qd,
                        thumbUrl: Kd,
                        basePanoData: Nd ? $d : (vt)=>getCroppedPanoData(le1, vt),
                        cropData: $d,
                        width: $d.fullWidth,
                        cols: 2,
                        rows: 1,
                        tileUrl: ()=>null
                    };
                    else if (Gd && Hd) tm = {
                        baseUrl: Xd,
                        origBaseUrl: Xd,
                        basePanoData: (le1)=>({
                                fullWidth: le1.width,
                                fullHeight: le1.height
                            }),
                        hdUrl: qd,
                        thumbUrl: Kd,
                        cols: Hd && Hd.tileMatrix[0].matrixWidth,
                        rows: Hd && Hd.tileMatrix[0].matrixHeight,
                        width: Hd && Hd.tileMatrix[0].matrixWidth * Hd.tileMatrix[0].tileWidth,
                        tileUrl: Hd && ((le1, vt)=>Od(Jd.href.replace(/\{TileCol\}/g, le1).replace(/\{TileRow\}/g, vt)))
                    };
                    else {
                        const getFlatCrop = (le1)=>{
                            le1.width < le1.height && !jd && (Ud = 35);
                            const vt = Ud * le1.height / le1.width, bt = 360 * le1.width / Ud, ls = 180 * le1.height / vt;
                            return {
                                fullWidth: Math.floor(bt),
                                fullHeight: Math.floor(ls),
                                croppedWidth: le1.width,
                                croppedHeight: le1.height,
                                croppedX: Math.floor((bt - le1.width) / 2),
                                croppedY: Math.floor((ls - le1.height) / 2)
                            };
                        };
                        let le1 = em ? getFlatCrop({
                            width: em[0],
                            height: em[1]
                        }) : null;
                        tm = {
                            baseUrl: Nd ? qd : Xd,
                            origBaseUrl: Nd ? qd : Xd,
                            hdUrl: qd,
                            thumbUrl: Kd,
                            basePanoData: getFlatCrop,
                            cropData: le1,
                            width: (null === le1 || void 0 === le1 ? void 0 : le1.fullWidth) || 2,
                            cols: 2,
                            rows: 1,
                            tileUrl: ()=>null
                        };
                    }
                    null !== (Ld = le1.properties) && void 0 !== Ld && Ld.semantics && (le1.properties.semantics = le1.properties.semantics.filter((le1)=>Object.keys(le1).length > 0));
                    return {
                        id: le1.id,
                        caption: getNodeCaption(le1, vt),
                        panorama: tm,
                        links: filterRelatedPicsLinks(le1, Rd),
                        gps: le1.geometry.coordinates,
                        sequence: {
                            id: le1.collection,
                            nextPic: Zd ? Zd.id : void 0,
                            prevPic: Wd ? Wd.id : void 0
                        },
                        sphereCorrection: getSphereCorrection(le1),
                        horizontalFov: Ud,
                        origInstance: sp,
                        properties: le1.properties
                    };
                }
                function filterRelatedPicsLinks(le1) {
                    var vt;
                    let bt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    const ls = le1.links.filter((le1)=>[
                            "next",
                            "prev",
                            "related"
                        ].includes(null === le1 || void 0 === le1 ? void 0 : le1.rel) && "application/geo+json" === (null === le1 || void 0 === le1 ? void 0 : le1.type)).filter((le1)=>!bt || bt(le1)).map((le1)=>(le1.datetime && (le1.date = le1.datetime.split("T")[0]), le1)), ho = le1.geometry.coordinates, uc = [], mc = {
                        N: [],
                        ENE: [],
                        ESE: [],
                        S: [],
                        WSW: [],
                        WNW: []
                    };
                    for (let Fl of ls)mc[(0, Dl.getSimplifiedAngle)(ho, Fl.geometry.coordinates)].push(Fl);
                    for(let Dl in mc){
                        const le1 = mc[Dl];
                        0 != le1.length && (le1.sort(sortPicturesInDirection(ho)), uc.push(le1.shift()));
                    }
                    let arrowStyle = (le1)=>"related" === le1.rel ? {
                            element: (0, Dl.getArrow)(sc),
                            size: {
                                width: 128 / 3,
                                height: 128
                            }
                        } : {
                            element: (0, Dl.getArrow)(Fl),
                            size: {
                                width: 75,
                                height: 75
                            }
                        };
                    const gc = -((null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["view:azimuth"]) || 0) * (Math.PI / 180);
                    return uc.map((le1)=>({
                            nodeId: le1.id,
                            gps: le1.geometry.coordinates,
                            arrowStyle: arrowStyle(le1),
                            linkOffset: {
                                yaw: gc
                            }
                        }));
                }
                function getHashTags(le1) {
                    var vt;
                    if (null === le1 || void 0 === le1 || null === (vt = le1.properties) || void 0 === vt || !vt.semantics) return [];
                    const bt = le1.properties.semantics.filter((le1)=>"hashtags" === le1.key), ls = [];
                    return bt.forEach((le1)=>le1.value.split(";").forEach((le1)=>ls.push(le1.trim()))), ls;
                }
                function hasAnnotations(le1) {
                    var vt, bt;
                    return (null === le1 || void 0 === le1 || null === (vt = le1.properties) || void 0 === vt || null === (bt = vt.annotations) || void 0 === bt ? void 0 : bt.length) > 0;
                }
            },
            2283: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    SEMANTICS_OVERLAYS: ()=>uc,
                    computeDiffTags: ()=>computeDiffTags,
                    decodeBasicTag: ()=>decodeBasicTag,
                    decodeKey: ()=>decodeKey,
                    groupByPrefix: ()=>groupByPrefix,
                    parseSemanticsString: ()=>parseSemanticsString,
                    semanticsToString: ()=>semanticsToString
                });
                var ls = bt(4542), ho = bt(1760), Dl = bt(9472), Fl = bt(7208), sc = bt(4964);
                const uc = [
                    [
                        "features",
                        '"semantics" IS NOT NULL',
                        {
                            metadata: {
                                name: "All features"
                            },
                            type: "circle",
                            layout: {
                                visibility: "none"
                            },
                            paint: {
                                "circle-radius": 4,
                                "circle-color": "#00897B"
                            }
                        }
                    ],
                    [
                        "tfsigns",
                        '"semantics.osm|traffic_sign" IS NOT NULL',
                        {
                            metadata: {
                                name: "Traffic signs"
                            },
                            type: "symbol",
                            layout: {
                                visibility: "none",
                                "icon-overlap": "never",
                                "icon-image": [
                                    "case",
                                    [
                                        "in",
                                        ";",
                                        [
                                            "get",
                                            "osm|traffic_sign"
                                        ]
                                    ],
                                    "pnx-tfsigns-fr:0_many",
                                    [
                                        "==",
                                        [
                                            "slice",
                                            [
                                                "get",
                                                "osm|traffic_sign"
                                            ],
                                            0,
                                            2
                                        ],
                                        "FR"
                                    ],
                                    [
                                        "concat",
                                        "pnx-tfsigns-fr:",
                                        [
                                            "slice",
                                            [
                                                "get",
                                                "osm|traffic_sign"
                                            ],
                                            3
                                        ]
                                    ],
                                    [
                                        "==",
                                        [
                                            "get",
                                            "osm|traffic_sign"
                                        ],
                                        "yes"
                                    ],
                                    "pnx-tfsigns-fr:0_unknown",
                                    [
                                        "has",
                                        "osm|traffic_sign"
                                    ],
                                    "pnx-tfsigns-fr:0_unknown",
                                    ""
                                ]
                            }
                        },
                        {
                            "pnx-tfsigns-fr": `${(0, Fl.PanoramaxPresetsURL)()}/sprites/trafficsigns_fr`
                        }
                    ]
                ];
                function valToValLink(le1, vt, bt) {
                    return ls.qy`<a href=${vt} target="_blank" title=${bt}>${le1}</a>`;
                }
                const mc = [
                    "highway",
                    "building",
                    "amenity",
                    "landuse",
                    "natural",
                    "waterway",
                    "leisure",
                    "shop",
                    "railway",
                    "tourism",
                    "barrier",
                    "boundary",
                    "place",
                    "power"
                ], gc = {};
                function getWDLabel(le1, vt) {
                    if (gc[le1]) return Promise.resolve(gc[le1]);
                    {
                        const bt = le1.startsWith("P") ? `properties/${le1}` : `items/${le1}/labels`;
                        return fetch(`${(0, Fl.WikidataAPIURL)()}/entities/${bt}`).then((le1)=>le1.json()).then((bt)=>(gc[le1] = (0, sc.getBestLabel)(bt.labels || bt, vt.PREF_LANG), gc[le1]));
                    }
                }
                const Ac = {
                    "": {
                        title: "Panoramax",
                        value_transform: (le1, vt)=>"osm" === le1.key ? valToValLink(le1.value, `${(0, Fl.OSMURL)()}/${le1.value}`, vt.pnx.semantics_value_show_osm) : le1.value
                    },
                    osm: {
                        title: "OpenStreetMap",
                        logo: ho,
                        key_transform: (le1, vt)=>valToValLink(le1.key, `${(0, Fl.OSMWikiURL)()}/Key:${le1.key}`, vt.pnx.semantics_key_doc),
                        value_transform: (le1, vt)=>mc.includes(le1.key) ? valToValLink(le1.value, `${(0, Fl.OSMWikiURL)()}/Tag:${le1.key}=${le1.value}`, vt.pnx.semantics_value_doc) : le1.value
                    },
                    wd: {
                        title: "Wikidata",
                        logo: Dl,
                        key_transform: (le1, vt)=>{
                            const bt = `${(0, Fl.WikidataURL)()}/Property:${le1.key}`;
                            if (vt.pnx.semantics_wikidata_properties[le1.key]) return valToValLink(ls.qy`${vt.pnx.semantics_wikidata_properties[le1.key]} <small>(${le1.key})</small>`, bt, vt.pnx.semantics_key_doc);
                            {
                                const ls = document.createElement("span");
                                return ls.innerText = le1.key, getWDLabel(le1.key, vt).then((vt)=>{
                                    ls.innerHTML = `${vt} <small>(${le1.key})</small>`;
                                }), valToValLink(ls, bt, vt.pnx.semantics_key_doc);
                            }
                        },
                        value_transform: (le1, vt)=>{
                            const bt = document.createElement("span");
                            return bt.innerText = le1.value, getWDLabel(le1.value, vt).then((vt)=>{
                                bt.innerHTML = `${vt} <small>(${le1.value})</small>`;
                            }), valToValLink(bt, `${(0, Fl.WikidataURL)()}/${le1.value}`, vt.pnx.semantics_value_doc);
                        }
                    },
                    exif: {
                        title: "EXIF"
                    }
                };
                function decodeBasicTag(le1) {
                    const vt = (le1 || "").lastIndexOf("=");
                    if (vt < 0) return null;
                    const bt = decodeKey(le1.substring(0, vt));
                    return bt.subkey.indexOf("=") >= 0 ? null : {
                        key: bt,
                        value: le1.substring(vt + 1)
                    };
                }
                function decodeKey() {
                    let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : "";
                    const vt = le1.match(/^(?:([a-z_]+)\|)?([^[]+)(?:\[(.*)\])?$/);
                    if (!vt) return {
                        prefix: "",
                        subkey: le1,
                        qualifies: null
                    };
                    const [, bt, ls, ho] = vt;
                    return {
                        key: le1,
                        prefix: bt || "",
                        subkey: ls,
                        qualifies: decodeBasicTag(ho)
                    };
                }
                function parseSemanticsString(le1) {
                    const vt = le1.split("\n").map((le1)=>{
                        const vt = decodeBasicTag(le1);
                        return vt && vt.key.key.length <= 256 && vt.value.length <= 2048 ? {
                            key: vt.key.key,
                            value: vt.value
                        } : null;
                    });
                    if (vt.findIndex((le1)=>!le1) >= 0) {
                        if (0 === le1.trim().length && 1 === vt.length) return [];
                        throw new Error("Invalid tags");
                    }
                    return vt;
                }
                function semanticsToString(le1) {
                    return (le1 || []).map((le1)=>`${le1.key}=${le1.value}`).join("\n");
                }
                function computeDiffTags() {
                    let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : [], vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : [];
                    const bt = [];
                    return (vt || []).filter((vt)=>void 0 === le1.find((le1)=>le1.key == vt.key && le1.value == vt.value)).forEach((le1)=>bt.push({
                            key: le1.key,
                            value: le1.value,
                            action: "add"
                        })), (le1 || []).filter((le1)=>void 0 === vt.find((vt)=>le1.key == vt.key && le1.value == vt.value)).forEach((le1)=>bt.push({
                            key: le1.key,
                            value: le1.value,
                            action: "delete"
                        })), bt;
                }
                function groupByPrefix(le1) {
                    const vt = {}, bt = [];
                    return le1.forEach((le1)=>{
                        if ("delete" === le1.action) return;
                        const ls = decodeKey(le1.key);
                        ls.qualifies ? bt.push(Object.assign({}, le1, ls)) : (vt[ls.prefix] || (vt[ls.prefix] = []), vt[ls.prefix].push(ls.prefix.length > 0 ? {
                            key: ls.subkey,
                            value: le1.value
                        } : le1));
                    }), bt.forEach((le1)=>{
                        var bt;
                        let { key: ls, prefix: ho, subkey: Dl, qualifies: Fl, value: sc } = le1;
                        const uc = null === (bt = vt[Fl.key.prefix]) || void 0 === bt ? void 0 : bt.find((le1)=>le1.key === Fl.key.subkey && (!Fl.value || Fl.value === le1.value));
                        uc && (uc.qualifiers || (uc.qualifiers = []), uc.qualifiers.push({
                            key: ls,
                            prefix: ho,
                            subkey: Dl,
                            value: sc
                        }));
                    }), Object.entries(vt).map((le1)=>{
                        let [vt, bt] = le1;
                        return Ac[vt] ? Object.assign({
                            prefix: vt,
                            tags: bt
                        }, Ac[vt]) : {
                            prefix: vt,
                            title: vt,
                            tags: bt
                        };
                    });
                }
            },
            7208: (le1, vt, bt)=>{
                "use strict";
                function MapTiles() {
                    return "https://panoramax.openstreetmap.fr/pmtiles/basic.json";
                }
                function PanoramaxWebsiteURL() {
                    return "https://panoramax.fr";
                }
                function PanoramaxPresetsURL() {
                    return "https://presets.panoramax.fr";
                }
                function PanoramaxMetaCatalogURL() {
                    return "https://explore.panoramax.fr";
                }
                function TemakiIconURL(le1) {
                    return `https://raw.githubusercontent.com/rapideditor/temaki/refs/heads/main/icons/${le1}.svg`;
                }
                function WikidataURL() {
                    return "https://www.wikidata.org/wiki";
                }
                function WikidataAPIURL() {
                    return "https://www.wikidata.org/w/rest.php/wikibase/v1";
                }
                function IdEditorURL() {
                    return "https://www.openstreetmap.org/edit?editor=id";
                }
                function OSMWikiURL() {
                    return "https://wiki.openstreetmap.org/wiki";
                }
                function OSMURL() {
                    return "https://openstreetmap.org";
                }
                function IndoorEqualSpritesURL() {
                    return "https://files.pavie.info/depot/remote/indoorequal/indoorequal";
                }
                function InternetFastThreshold() {
                    return 10;
                }
                function InternetFastTestFile() {
                    return "https://panoramax.openstreetmap.fr/images/05/ca/2c/98/0111-4baf-b6f3-587bb8847d2e.jpg";
                }
                function AdresseDataGouvBaseURL() {
                    return "https://data.geopf.fr/geocodage/search";
                }
                function NominatimBaseUrl() {
                    return "https://nominatim.openstreetmap.org";
                }
                bt.r(vt), bt.d(vt, {
                    AdresseDataGouvBaseURL: ()=>AdresseDataGouvBaseURL,
                    IdEditorURL: ()=>IdEditorURL,
                    IndoorEqualSpritesURL: ()=>IndoorEqualSpritesURL,
                    InternetFastTestFile: ()=>InternetFastTestFile,
                    InternetFastThreshold: ()=>InternetFastThreshold,
                    MapTiles: ()=>MapTiles,
                    NominatimBaseUrl: ()=>NominatimBaseUrl,
                    OSMURL: ()=>OSMURL,
                    OSMWikiURL: ()=>OSMWikiURL,
                    PanoramaxMetaCatalogURL: ()=>PanoramaxMetaCatalogURL,
                    PanoramaxPresetsURL: ()=>PanoramaxPresetsURL,
                    PanoramaxWebsiteURL: ()=>PanoramaxWebsiteURL,
                    TemakiIconURL: ()=>TemakiIconURL,
                    WikidataAPIURL: ()=>WikidataAPIURL,
                    WikidataURL: ()=>WikidataURL
                });
            },
            7343: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    BASE_PANORAMA_ID: ()=>Dl,
                    COLORS: ()=>Fl,
                    COLORS_HEX: ()=>sc,
                    DISABLE_ANNOTATIONS_PARAM: ()=>ho,
                    GPS_VALUES: ()=>du,
                    QUALITYSCORE_GPS_VALUES: ()=>Ac,
                    QUALITYSCORE_POND_GPS: ()=>kc,
                    QUALITYSCORE_POND_RES: ()=>Ec,
                    QUALITYSCORE_RES_360_VALUES: ()=>gc,
                    QUALITYSCORE_RES_FLAT_VALUES: ()=>mc,
                    QUALITYSCORE_VALUES: ()=>uc,
                    degToDms: ()=>degToDms,
                    getArrow: ()=>getArrow,
                    getAzimuth: ()=>getAzimuth,
                    getCookie: ()=>getCookie,
                    getDistance: ()=>getDistance,
                    getGrade: ()=>getGrade,
                    getRelativeHeading: ()=>getRelativeHeading,
                    getSimplifiedAngle: ()=>getSimplifiedAngle,
                    getUserAccount: ()=>getUserAccount,
                    inRangeRandom: ()=>inRangeRandom,
                    isInIframe: ()=>isInIframe,
                    isInternetFast: ()=>isInternetFast,
                    isNullId: ()=>isNullId,
                    josmBboxParameters: ()=>josmBboxParameters,
                    positionToXYZ: ()=>positionToXYZ,
                    svgToPSVLink: ()=>svgToPSVLink,
                    xyzToPosition: ()=>xyzToPosition
                });
                var ls = bt(7208);
                const ho = "pnx-disable-annotations", Dl = "geovisio-fake-id-0", Fl = {
                    BASE: "#FF6F00",
                    SELECTED: "#1E88E5",
                    HIDDEN: "#34495E",
                    NEXT: "#ffab40",
                    QUALI_1: "#00695C",
                    QUALI_2: "#fd8d3c",
                    PALETTE_1: "#fecc5c",
                    PALETTE_2: "#fd8d3c",
                    PALETTE_3: "#f03b20",
                    PALETTE_4: "#bd0026"
                }, sc = Object.fromEntries(Object.entries(Fl).map((le1)=>(le1[1] = parseInt(le1[1].slice(1), 16), le1))), uc = [
                    {
                        color: "#007f4e",
                        label: "A"
                    },
                    {
                        color: "#72b043",
                        label: "B"
                    },
                    {
                        color: "#b5be2f",
                        label: "C"
                    },
                    {
                        color: "#f8cc1b",
                        label: "D"
                    },
                    {
                        color: "#f6a020",
                        label: "E"
                    }
                ], mc = [
                    1,
                    10,
                    2,
                    15,
                    3,
                    30,
                    4
                ], gc = [
                    3,
                    15,
                    4,
                    30,
                    5
                ], Ac = [
                    5,
                    .5,
                    4,
                    2.01,
                    3,
                    5.01,
                    2,
                    10.01,
                    1
                ], Ec = .8, kc = .2, du = [
                    {
                        color: "#4A148C",
                        label: `<= ${Ac[1]} m`
                    },
                    {
                        color: "#7B1FA2",
                        label: `${Math.round(Ac[1])} - ${Math.round(Ac[3])} m`
                    },
                    {
                        color: "#9C27B0",
                        label: `${Math.round(Ac[3])} - ${Math.round(Ac[5])} m`
                    },
                    {
                        color: "#BA68C8",
                        label: `${Math.round(Ac[5])} - ${Math.round(Ac[7])} m`
                    },
                    {
                        color: "#EA80FC",
                        label: `> ${Math.round(Ac[7])} m`
                    }
                ];
                function isNullId(le1) {
                    return [
                        null,
                        void 0,
                        "",
                        Dl
                    ].includes(le1);
                }
                function getGrade(le1, vt) {
                    if (null === vt || void 0 === vt || "" === vt) return null;
                    for(let bt = 0; bt < le1.length; bt += 2){
                        const ls = le1[bt];
                        if (vt < le1[bt + 1]) return ls;
                    }
                    return le1[le1.length - 1];
                }
                function getDistance(le1, vt) {
                    const bt = le1[0] - vt[0], ls = le1[1] - vt[1];
                    return Math.sqrt(bt * bt + ls * ls);
                }
                function svgToPSVLink(le1, vt) {
                    try {
                        const bt = atob(le1.replace(/^data:image\/svg\+xml;base64,/, "")), ls = (new DOMParser).parseFromString(bt, "image/svg+xml").childNodes[0], ho = document.createElement("button");
                        return ho.appendChild(ls), ho.classList.add("pnx-psv-tour-arrows", "pnx-print-hidden"), ho.style.color = vt, ho;
                    } catch (bt) {
                        const vt = document.createElement("img");
                        return vt.src = le1, vt.alt = "", vt;
                    }
                }
                function getArrow(le1) {
                    const vt = le1.cloneNode(!0);
                    return vt.addEventListener("pointerup", ()=>vt.classList.add("pnx-clicked")), vt;
                }
                function getAzimuth(le1, vt) {
                    return (Math.atan2(vt[0] - le1[0], vt[1] - le1[1]) * (180 / Math.PI) + 360) % 360;
                }
                function getRelativeHeading(le1) {
                    var vt, bt;
                    if (!le1) throw new Error("No picture selected");
                    let ls, ho;
                    const Dl = le1.properties["view:azimuth"];
                    if (null !== le1 && void 0 !== le1 && null !== (vt = le1.sequence) && void 0 !== vt && vt.prevPic) {
                        var Fl;
                        const vt = null === le1 || void 0 === le1 || null === (Fl = le1.links) || void 0 === Fl ? void 0 : Fl.find((vt)=>vt.nodeId === le1.sequence.prevPic);
                        vt && (ls = (Dl - getAzimuth(vt.gps, le1.gps) + 180) % 360 - 180);
                    }
                    if (null !== le1 && void 0 !== le1 && null !== (bt = le1.sequence) && void 0 !== bt && bt.nextPic) {
                        var sc;
                        const vt = null === le1 || void 0 === le1 || null === (sc = le1.links) || void 0 === sc ? void 0 : sc.find((vt)=>vt.nodeId === le1.sequence.nextPic);
                        vt && (ho = (Dl - getAzimuth(le1.gps, vt.gps) + 180) % 360 - 180);
                    }
                    return void 0 !== ls ? ls : void 0 !== ho ? ho : 0;
                }
                function getSimplifiedAngle(le1, vt) {
                    const bt = Math.atan2(vt[0] - le1[0], vt[1] - le1[1]) * (180 / Math.PI);
                    return Math.abs(bt) < 30 ? "N" : bt >= 30 && bt < 90 ? "ENE" : bt >= 90 && bt < 150 ? "ESE" : Math.abs(bt) >= 150 ? "S" : bt <= -30 && bt > -90 ? "WNW" : bt <= -90 && bt > -150 ? "WSW" : void 0;
                }
                function positionToXYZ(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : void 0;
                    const bt = {
                        x: le1.yaw * (180 / Math.PI),
                        y: le1.pitch * (180 / Math.PI)
                    };
                    return void 0 !== vt && (bt.z = vt), bt;
                }
                function xyzToPosition(le1, vt, bt) {
                    return {
                        yaw: le1 / (180 / Math.PI),
                        pitch: vt / (180 / Math.PI),
                        zoom: bt
                    };
                }
                function degToDms(le1) {
                    const vt = le1 < 0 ? Math.ceil(le1) : Math.floor(le1), bt = 60 * Math.abs(le1 - vt), ls = Math.floor(bt);
                    return {
                        d: vt,
                        m: ls,
                        s: parseFloat((60 * (bt - ls)).toFixed(3))
                    };
                }
                function josmBboxParameters(le1) {
                    if (le1) {
                        var vt;
                        const bt = le1.gps, ls = null === le1 || void 0 === le1 || null === (vt = le1.properties) || void 0 === vt ? void 0 : vt["view:azimuth"], ho = 2e-4, Dl = {
                            left: bt[0] - (null === ls || ls >= 180 ? ho : 0),
                            right: bt[0] + (null === ls || ls <= 180 ? ho : 0),
                            top: bt[1] + (null === ls || ls <= 90 || ls >= 270 ? ho : 0),
                            bottom: bt[1] - (null === ls || ls >= 90 && ls <= 270 ? ho : 0),
                            changeset_source: "Panoramax"
                        };
                        return Object.entries(Dl).map((le1)=>le1.join("=")).join("&");
                    }
                    return null;
                }
                function isInIframe() {
                    try {
                        return window.self !== window.top;
                    } catch (le1) {
                        return !0;
                    }
                }
                const _u = "pnx-internet-fast";
                function isInternetFast() {
                    try {
                        const le1 = navigator.connection.downlink;
                        return Promise.resolve(le1 >= (0, ls.InternetFastThreshold)());
                    } catch (le1) {
                        try {
                            const le1 = sessionStorage.getItem(_u);
                            if ([
                                "true",
                                "false"
                            ].includes(le1)) return Promise.resolve("true" === le1);
                            const vt = (new Date).getTime();
                            return fetch(`${(0, ls.InternetFastTestFile)()}?nocache=${vt}`).then(async (le1)=>[
                                    le1,
                                    await le1.blob()
                                ]).then((le1)=>{
                                let [bt, ho] = le1;
                                const Dl = 8 * parseInt(bt.headers.get("Content-Length") || ho.size) / 1024 / 1024 / (((new Date).getTime() - vt) / 1e3) >= (0, ls.InternetFastThreshold)();
                                return sessionStorage.setItem(_u, Dl ? "true" : "false"), Dl;
                            }).catch((le1)=>(console.warn("Failed to run speedtest", le1), !1));
                        } catch (le1) {
                            return Promise.resolve(!1);
                        }
                    }
                }
                function getCookie(le1) {
                    var vt, bt, ls;
                    const ho = null === (vt = document.cookie) || void 0 === vt || null === (bt = vt.split(";")) || void 0 === bt || null === (ls = bt.find((vt)=>vt.trimStart().startsWith(`${le1}=`))) || void 0 === ls ? void 0 : ls.split("=");
                    if (ho) return ho.shift(), ho.join("=");
                }
                function getUserAccount() {
                    const le1 = getCookie("session"), vt = getCookie("user_id"), bt = getCookie("user_name");
                    return le1 && vt && bt ? {
                        id: vt,
                        name: bt
                    } : null;
                }
                function inRangeRandom(le1, vt) {
                    const bt = new Uint32Array(1);
                    crypto.getRandomValues(bt);
                    let ls = bt[0] / 4294967296;
                    return le1 = Math.ceil(le1), vt = Math.floor(vt), Math.floor(ls * (vt - le1 + 1)) + le1;
                }
            },
            5995: (le1, vt, bt)=>{
                "use strict";
                bt.r(vt), bt.d(vt, {
                    createWebComp: ()=>createWebComp,
                    fa: ()=>fa,
                    listenForMenuClosure: ()=>listenForMenuClosure,
                    moreIcons: ()=>moreIcons,
                    onceParentAvailable: ()=>onceParentAvailable
                });
                var ls = bt(3710), ho = bt(8983), Dl = bt(7208);
                function fa(le1, vt) {
                    return (0, ls.Kk)(le1, vt).node[0];
                }
                function moreIcons() {
                    (0, ho.c8)(async (le1)=>{
                        const vt = await fetch((0, Dl.TemakiIconURL)(le1));
                        return vt.ok ? {
                            body: await vt.text()
                        } : null;
                    }, "temaki");
                }
                function createWebComp(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const bt = document.createElement(le1);
                    return Object.entries(vt).forEach((le1)=>{
                        let [vt, ls] = le1;
                        vt.startsWith("_") ? bt[vt] = ls : vt.startsWith("fn") ? bt[vt.substring(2)] = ls : vt.startsWith("on") ? bt.addEventListener(vt.substring(2), ls) : ls && bt.setAttribute(vt, ls);
                    }), bt;
                }
                function listenForMenuClosure(le1, vt) {
                    var bt, ls, ho, Dl, Fl, sc, uc;
                    null === (bt = le1._parent) || void 0 === bt || bt.addEventListener("menu-opened", (bt)=>{
                        bt.detail.menu != le1 && vt();
                    }), null === (ls = le1._parent) || void 0 === ls || null === (ho = ls.onceMapReady) || void 0 === ho || ho.call(ls).then(()=>{
                        var bt, ls;
                        null === (bt = le1._parent.map) || void 0 === bt || null === (ls = bt.on) || void 0 === ls || ls.call(bt, "click", ()=>vt());
                    }), null === (Dl = le1._parent) || void 0 === Dl || null === (Fl = Dl.oncePSVReady) || void 0 === Fl || Fl.call(Dl).then(()=>{
                        le1._parent.psv.addEventListener("click", ()=>vt());
                    }), null === (sc = le1._parent) || void 0 === sc || null === (uc = sc.onceReady) || void 0 === uc || uc.call(sc).then(()=>{
                        var bt;
                        null === (bt = le1._parent.legend) || void 0 === bt || bt.addEventListener("click", ()=>vt());
                    });
                }
                function lookForParent(le1) {
                    return le1._parent ? le1._parent : le1 === document.body ? null : le1.parentNode ? lookForParent(le1.parentNode) : le1.host ? lookForParent(le1.host) : void 0;
                }
                function onceParentAvailable(le1) {
                    return le1._parent ? Promise.resolve(le1._parent) : new Promise((vt)=>{
                        const bt = setInterval(()=>{
                            const ls = lookForParent(le1);
                            ls && (le1._parent = ls, clearInterval(bt), vt(le1._parent));
                        }, 100);
                    });
                }
            },
            7325: (le1, vt)=>{
                "use strict";
                var bt = "star", ls = [
                    11088,
                    61446
                ], ho = "f005", Dl = "M287.9 0c9.2 0 17.6 5.2 21.6 13.5l68.6 141.3 153.2 22.6c9 1.3 16.5 7.6 19.3 16.3s.5 18.1-5.9 24.5L433.6 328.4l26.2 155.6c1.5 9-2.2 18.1-9.7 23.5s-17.3 6-25.3 1.7l-137-73.2L151 509.1c-8.1 4.3-17.9 3.7-25.3-1.7s-11.2-14.5-9.7-23.5l26.2-155.6L31.1 218.2c-6.5-6.4-8.7-15.9-5.9-24.5s10.3-14.9 19.3-16.3l153.2-22.6L266.3 13.5C270.4 5.2 278.7 0 287.9 0zm0 79L235.4 187.2c-3.5 7.1-10.2 12.1-18.1 13.3L99 217.9 184.9 303c5.5 5.5 8.1 13.3 6.8 21L171.4 443.7l105.2-56.2c7.1-3.8 15.6-3.8 22.6 0l105.2 56.2L384.2 324.1c-1.3-7.7 1.2-15.5 6.8-21l85.9-85.1L358.6 200.5c-7.8-1.2-14.6-6.1-18.1-13.3L287.9 79z";
                vt.mw = {
                    prefix: "far",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.yy = vt.mw;
            },
            8466: (le1, vt)=>{
                "use strict";
                var bt = "arrow-left", ls = [
                    8592
                ], ho = "f060", Dl = "M9.4 233.4c-12.5 12.5-12.5 32.8 0 45.3l160 160c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L109.2 288 416 288c17.7 0 32-14.3 32-32s-14.3-32-32-32l-306.7 0L214.6 118.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0l-160 160z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.Ce = vt.mw;
            },
            6069: (le1, vt)=>{
                "use strict";
                var bt = "arrow-right", ls = [
                    8594
                ], ho = "f061", Dl = "M438.6 278.6c12.5-12.5 12.5-32.8 0-45.3l-160-160c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L338.8 224 32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l306.7 0L233.4 393.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0l160-160z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.dm = vt.mw;
            },
            4881: (le1, vt)=>{
                "use strict";
                var bt = [
                    61946
                ], ls = "M256 64C150 64 64 150 64 256s86 192 192 192c17.7 0 32 14.3 32 32s-14.3 32-32 32C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256l0 32c0 53-43 96-96 96c-29.3 0-55.6-13.2-73.2-33.9C320 371.1 289.5 384 256 384c-70.7 0-128-57.3-128-128s57.3-128 128-128c27.9 0 53.7 8.9 74.7 24.1c5.7-5 13.1-8.1 21.3-8.1c17.7 0 32 14.3 32 32l0 80 0 32c0 17.7 14.3 32 32 32s32-14.3 32-32l0-32c0-106-86-192-192-192zm64 192a64 64 0 1 0 -128 0 64 64 0 1 0 128 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: "at",
                    icon: [
                        512,
                        512,
                        bt,
                        "40",
                        ls
                    ]
                }, vt.Hz = vt.mw;
            },
            1705: (le1, vt)=>{
                "use strict";
                var bt = "backward", ls = [
                    9194
                ], ho = "f04a", Dl = "M459.5 440.6c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-320c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4L288 214.3l0 41.7 0 41.7L459.5 440.6zM256 352l0-96 0-128 0-32c0-12.4-7.2-23.7-18.4-29s-24.5-3.6-34.1 4.4l-192 160C4.2 237.5 0 246.5 0 256s4.2 18.5 11.5 24.6l192 160c9.5 7.9 22.8 9.7 34.1 4.4s18.4-16.6 18.4-29l0-64z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.TH = vt.mw;
            },
            9186: (le1, vt)=>{
                "use strict";
                var bt = "calendar", ls = [
                    128197,
                    128198
                ], ho = "f133", Dl = "M96 32l0 32L48 64C21.5 64 0 85.5 0 112l0 48 448 0 0-48c0-26.5-21.5-48-48-48l-48 0 0-32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 32L160 64l0-32c0-17.7-14.3-32-32-32S96 14.3 96 32zM448 192L0 192 0 464c0 26.5 21.5 48 48 48l352 0c26.5 0 48-21.5 48-48l0-272z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.ok = vt.mw;
            },
            4927: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(1577);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.BE = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            1577: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "calendar-days", ls = [
                    "calendar-alt"
                ], ho = "f073", Dl = "M128 0c17.7 0 32 14.3 32 32l0 32 128 0 0-32c0-17.7 14.3-32 32-32s32 14.3 32 32l0 32 48 0c26.5 0 48 21.5 48 48l0 48L0 160l0-48C0 85.5 21.5 64 48 64l48 0 0-32c0-17.7 14.3-32 32-32zM0 192l448 0 0 272c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 192zm64 80l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm128 0l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zM64 400l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16zm144-16c-8.8 0-16 7.2-16 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0zm112 16l0 32c0 8.8 7.2 16 16 16l32 0c8.8 0 16-7.2 16-16l0-32c0-8.8-7.2-16-16-16l-32 0c-8.8 0-16 7.2-16 16z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faCalendarDays = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 448, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            2480: (le1, vt)=>{
                "use strict";
                var bt = "camera", ls = [
                    62258,
                    "camera-alt"
                ], ho = "f030", Dl = "M149.1 64.8L138.7 96 64 96C28.7 96 0 124.7 0 160L0 416c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64l-74.7 0L362.9 64.8C356.4 45.2 338.1 32 317.4 32L194.6 32c-20.7 0-39 13.2-45.5 32.8zM256 192a96 96 0 1 1 0 192 96 96 0 1 1 0-192z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.rw = vt.mw;
            },
            7261: (le1, vt)=>{
                "use strict";
                var bt = "caret-down", ls = [], ho = "f0d7", Dl = "M137.4 374.6c12.5 12.5 32.8 12.5 45.3 0l128-128c9.2-9.2 11.9-22.9 6.9-34.9s-16.6-19.8-29.6-19.8L32 192c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9l128 128z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        320,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.xB = vt.mw;
            },
            4420: (le1, vt)=>{
                "use strict";
                var bt = "caret-up", ls = [], ho = "f0d8", Dl = "M182.6 137.4c-12.5-12.5-32.8-12.5-45.3 0l-128 128c-9.2 9.2-11.9 22.9-6.9 34.9s16.6 19.8 29.6 19.8l256 0c12.9 0 24.6-7.8 29.6-19.8s2.2-25.7-6.9-34.9l-128-128z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        320,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.S$ = vt.mw;
            },
            174: (le1, vt)=>{
                "use strict";
                var bt = "check", ls = [
                    10003,
                    10004
                ], ho = "f00c", Dl = "M438.6 105.4c12.5 12.5 12.5 32.8 0 45.3l-256 256c-12.5 12.5-32.8 12.5-45.3 0l-128-128c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0L160 338.7 393.4 105.4c12.5-12.5 32.8-12.5 45.3 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.e6 = vt.mw;
            },
            2593: (le1, vt)=>{
                "use strict";
                var bt = "chevron-down", ls = [], ho = "f078", Dl = "M233.4 406.6c12.5 12.5 32.8 12.5 45.3 0l192-192c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L256 338.7 86.6 169.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l192 192z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.Jt = vt.mw;
            },
            1187: (le1, vt)=>{
                "use strict";
                var bt = "chevron-right", ls = [
                    9002
                ], ho = "f054", Dl = "M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        320,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.Xk = vt.mw;
            },
            4336: (le1, vt)=>{
                "use strict";
                var bt = "chevron-up", ls = [], ho = "f077", Dl = "M233.4 105.4c12.5-12.5 32.8-12.5 45.3 0l192 192c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L256 173.3 86.6 342.6c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3l192-192z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.w2 = vt.mw;
            },
            4011: (le1, vt)=>{
                "use strict";
                var bt = "circle-exclamation", ls = [
                    "exclamation-circle"
                ], ho = "f06a", Dl = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm0-384c13.3 0 24 10.7 24 24l0 112c0 13.3-10.7 24-24 24s-24-10.7-24-24l0-112c0-13.3 10.7-24 24-24zM224 352a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.lE = vt.mw;
            },
            7516: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "circle-info", ls = [
                    "info-circle"
                ], ho = "f05a", Dl = "M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zM216 336l24 0 0-64-24 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l48 0c13.3 0 24 10.7 24 24l0 88 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-80 0c-13.3 0-24-10.7-24-24s10.7-24 24-24zm40-208a32 32 0 1 1 0 64 32 32 0 1 1 0-64z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faCircleInfo = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 512, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            3444: (le1, vt)=>{
                "use strict";
                var bt = "circle-notch", ls = [], ho = "f1ce", Dl = "M222.7 32.1c5 16.9-4.6 34.8-21.5 39.8C121.8 95.6 64 169.1 64 256c0 106 86 192 192 192s192-86 192-192c0-86.9-57.8-160.4-137.1-184.1c-16.9-5-26.6-22.9-21.5-39.8s22.9-26.6 39.8-21.5C434.9 42.1 512 140 512 256c0 141.4-114.6 256-256 256S0 397.4 0 256C0 140 77.1 42.1 182.9 10.6c16.9-5 34.8 4.6 39.8 21.5z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.s4 = vt.mw;
            },
            2975: (le1, vt)=>{
                "use strict";
                var bt = "comment-dots", ls = [
                    128172,
                    62075,
                    "commenting"
                ], ho = "f4ad", Dl = "M256 448c141.4 0 256-93.1 256-208S397.4 32 256 32S0 125.1 0 240c0 45.1 17.7 86.8 47.7 120.9c-1.9 24.5-11.4 46.3-21.4 62.9c-5.5 9.2-11.1 16.6-15.2 21.6c-2.1 2.5-3.7 4.4-4.9 5.7c-.6 .6-1 1.1-1.3 1.4l-.3 .3c0 0 0 0 0 0c0 0 0 0 0 0s0 0 0 0s0 0 0 0c-4.6 4.6-5.9 11.4-3.4 17.4c2.5 6 8.3 9.9 14.8 9.9c28.7 0 57.6-8.9 81.6-19.3c22.9-10 42.4-21.9 54.3-30.6c31.8 11.5 67 17.9 104.1 17.9zM128 208a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm128 0a32 32 0 1 1 0 64 32 32 0 1 1 0-64zm96 32a32 32 0 1 1 64 0 32 32 0 1 1 -64 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.Be = vt.mw;
            },
            4189: (le1, vt)=>{
                "use strict";
                var bt = "copy", ls = [], ho = "f0c5", Dl = "M208 0L332.1 0c12.7 0 24.9 5.1 33.9 14.1l67.9 67.9c9 9 14.1 21.2 14.1 33.9L448 336c0 26.5-21.5 48-48 48l-192 0c-26.5 0-48-21.5-48-48l0-288c0-26.5 21.5-48 48-48zM48 128l80 0 0 64-64 0 0 256 192 0 0-32 64 0 0 48c0 26.5-21.5 48-48 48L48 512c-26.5 0-48-21.5-48-48L0 176c0-26.5 21.5-48 48-48z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.jP = vt.mw;
            },
            6516: (le1, vt)=>{
                "use strict";
                var bt = "download", ls = [], ho = "f019", Dl = "M288 32c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 242.7-73.4-73.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3l128 128c12.5 12.5 32.8 12.5 45.3 0l128-128c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L288 274.7 288 32zM64 352c-35.3 0-64 28.7-64 64l0 32c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-32c0-35.3-28.7-64-64-64l-101.5 0-45.3 45.3c-25 25-65.5 25-90.5 0L165.5 352 64 352zm368 56a24 24 0 1 1 0 48 24 24 0 1 1 0-48z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.cb = vt.mw;
            },
            7172: (le1, vt)=>{
                "use strict";
                var bt = "earth-europe", ls = [
                    "globe-europe"
                ], ho = "f7a2", Dl = "M266.3 48.3L232.5 73.6c-5.4 4-8.5 10.4-8.5 17.1l0 9.1c0 6.8 5.5 12.3 12.3 12.3c2.4 0 4.8-.7 6.8-2.1l41.8-27.9c2-1.3 4.4-2.1 6.8-2.1l1 0c6.2 0 11.3 5.1 11.3 11.3c0 3-1.2 5.9-3.3 8l-19.9 19.9c-5.8 5.8-12.9 10.2-20.7 12.8l-26.5 8.8c-5.8 1.9-9.6 7.3-9.6 13.4c0 3.7-1.5 7.3-4.1 10l-17.9 17.9c-6.4 6.4-9.9 15-9.9 24l0 4.3c0 16.4 13.6 29.7 29.9 29.7c11 0 21.2-6.2 26.1-16l4-8.1c2.4-4.8 7.4-7.9 12.8-7.9c4.5 0 8.7 2.1 11.4 5.7l16.3 21.7c2.1 2.9 5.5 4.5 9.1 4.5c8.4 0 13.9-8.9 10.1-16.4l-1.1-2.3c-3.5-7 0-15.5 7.5-18l21.2-7.1c7.6-2.5 12.7-9.6 12.7-17.6c0-10.3 8.3-18.6 18.6-18.6l29.4 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-20.7 0c-7.2 0-14.2 2.9-19.3 8l-4.7 4.7c-2.1 2.1-3.3 5-3.3 8c0 6.2 5.1 11.3 11.3 11.3l11.3 0c6 0 11.8 2.4 16 6.6l6.5 6.5c1.8 1.8 2.8 4.3 2.8 6.8s-1 5-2.8 6.8l-7.5 7.5C386 262 384 266.9 384 272s2 10 5.7 13.7L408 304c10.2 10.2 24.1 16 38.6 16l7.3 0c6.5-20.2 10-41.7 10-64c0-111.4-87.6-202.4-197.7-207.7zm172 307.9c-3.7-2.6-8.2-4.1-13-4.1c-6 0-11.8-2.4-16-6.6L396 332c-7.7-7.7-18-12-28.9-12c-9.7 0-19.2-3.5-26.6-9.8L314 287.4c-11.6-9.9-26.4-15.4-41.7-15.4l-20.9 0c-12.6 0-25 3.7-35.5 10.7L188.5 301c-17.8 11.9-28.5 31.9-28.5 53.3l0 3.2c0 17 6.7 33.3 18.7 45.3l16 16c8.5 8.5 20 13.3 32 13.3l21.3 0c13.3 0 24 10.7 24 24c0 2.5 .4 5 1.1 7.3c71.3-5.8 132.5-47.6 165.2-107.2zM0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM187.3 100.7c-6.2-6.2-16.4-6.2-22.6 0l-32 32c-6.2 6.2-6.2 16.4 0 22.6s16.4 6.2 22.6 0l32-32c6.2-6.2 6.2-16.4 0-22.6z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.YS = vt.mw;
            },
            3613: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(6533);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.v = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            6533: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "ellipsis-vertical", ls = [
                    "ellipsis-v"
                ], ho = "f142", Dl = "M64 360a56 56 0 1 0 0 112 56 56 0 1 0 0-112zm0-160a56 56 0 1 0 0 112 56 56 0 1 0 0-112zM120 96A56 56 0 1 0 8 96a56 56 0 1 0 112 0z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        128,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faEllipsisVertical = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 128, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            700: (le1, vt)=>{
                "use strict";
                var bt = "eraser", ls = [], ho = "f12d", Dl = "M290.7 57.4L57.4 290.7c-25 25-25 65.5 0 90.5l80 80c12 12 28.3 18.7 45.3 18.7L288 480l9.4 0L512 480c17.7 0 32-14.3 32-32s-14.3-32-32-32l-124.1 0L518.6 285.3c25-25 25-65.5 0-90.5L381.3 57.4c-25-25-65.5-25-90.5 0zM297.4 416l-9.4 0-105.4 0-80-80L227.3 211.3 364.7 348.7 297.4 416z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.IP = vt.mw;
            },
            7704: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(7144);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.A = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            2255: (le1, vt)=>{
                "use strict";
                var bt = "floppy-disk", ls = [
                    128190,
                    128426,
                    "save"
                ], ho = "f0c7", Dl = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-242.7c0-17-6.7-33.3-18.7-45.3L352 50.7C340 38.7 323.7 32 306.7 32L64 32zm0 96c0-17.7 14.3-32 32-32l192 0c17.7 0 32 14.3 32 32l0 64c0 17.7-14.3 32-32 32L96 224c-17.7 0-32-14.3-32-32l0-64zM224 288a64 64 0 1 1 0 128 64 64 0 1 1 0-128z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.jk = vt.mw;
            },
            5431: (le1, vt)=>{
                "use strict";
                var bt = "forward", ls = [
                    9193
                ], ho = "f04e", Dl = "M52.5 440.6c-9.5 7.9-22.8 9.7-34.1 4.4S0 428.4 0 416L0 96C0 83.6 7.2 72.3 18.4 67s24.5-3.6 34.1 4.4L224 214.3l0 41.7 0 41.7L52.5 440.6zM256 352l0-96 0-128 0-32c0-12.4 7.2-23.7 18.4-29s24.5-3.6 34.1 4.4l192 160c7.3 6.1 11.5 15.1 11.5 24.6s-4.2 18.5-11.5 24.6l-192 160c-9.5 7.9-22.8 9.7-34.1 4.4s-18.4-16.6-18.4-29l0-64z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.vF = vt.mw;
            },
            5279: (le1, vt)=>{
                "use strict";
                var bt = "image", ls = [], ho = "f03e", Dl = "M0 96C0 60.7 28.7 32 64 32l384 0c35.3 0 64 28.7 64 64l0 320c0 35.3-28.7 64-64 64L64 480c-35.3 0-64-28.7-64-64L0 96zM323.8 202.5c-4.5-6.6-11.9-10.5-19.8-10.5s-15.4 3.9-19.8 10.5l-87 127.6L170.7 297c-4.6-5.7-11.5-9-18.7-9s-14.2 3.3-18.7 9l-64 80c-5.8 7.2-6.9 17.1-2.9 25.4s12.4 13.6 21.6 13.6l96 0 32 0 208 0c8.9 0 17.1-4.9 21.2-12.8s3.6-17.4-1.4-24.7l-120-176zM112 192a48 48 0 1 0 0-96 48 48 0 1 0 0 96z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.jb = vt.mw;
            },
            4954: (le1, vt)=>{
                "use strict";
                var bt = "images", ls = [], ho = "f302", Dl = "M160 32c-35.3 0-64 28.7-64 64l0 224c0 35.3 28.7 64 64 64l352 0c35.3 0 64-28.7 64-64l0-224c0-35.3-28.7-64-64-64L160 32zM396 138.7l96 144c4.9 7.4 5.4 16.8 1.2 24.6S480.9 320 472 320l-144 0-48 0-80 0c-9.2 0-17.6-5.3-21.6-13.6s-2.9-18.2 2.9-25.4l64-80c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l17.3 21.6 56-84C360.5 132 368 128 376 128s15.5 4 20 10.7zM192 128a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM48 120c0-13.3-10.7-24-24-24S0 106.7 0 120L0 344c0 75.1 60.9 136 136 136l320 0c13.3 0 24-10.7 24-24s-10.7-24-24-24l-320 0c-48.6 0-88-39.4-88-88l0-224z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.yv = vt.mw;
            },
            6668: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(7516);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.iW = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            4220: (le1, vt)=>{
                "use strict";
                var bt = "layer-group", ls = [], ho = "f5fd", Dl = "M264.5 5.2c14.9-6.9 32.1-6.9 47 0l218.6 101c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 149.8C37.4 145.8 32 137.3 32 128s5.4-17.9 13.9-21.8L264.5 5.2zM476.9 209.6l53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 277.8C37.4 273.8 32 265.3 32 256s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0l152-70.2zm-152 198.2l152-70.2 53.2 24.6c8.5 3.9 13.9 12.4 13.9 21.8s-5.4 17.9-13.9 21.8l-218.6 101c-14.9 6.9-32.1 6.9-47 0L45.9 405.8C37.4 401.8 32 393.3 32 384s5.4-17.9 13.9-21.8l53.2-24.6 152 70.2c23.4 10.8 50.4 10.8 73.8 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.qI = vt.mw;
            },
            325: (le1, vt)=>{
                "use strict";
                var bt = "lightbulb", ls = [
                    128161
                ], ho = "f0eb", Dl = "M272 384c9.6-31.9 29.5-59.1 49.2-86.2c0 0 0 0 0 0c5.2-7.1 10.4-14.2 15.4-21.4c19.8-28.5 31.4-63 31.4-100.3C368 78.8 289.2 0 192 0S16 78.8 16 176c0 37.3 11.6 71.9 31.4 100.3c5 7.2 10.2 14.3 15.4 21.4c0 0 0 0 0 0c19.8 27.1 39.7 54.4 49.2 86.2l160 0zM192 512c44.2 0 80-35.8 80-80l0-16-160 0 0 16c0 44.2 35.8 80 80 80zM112 176c0 8.8-7.2 16-16 16s-16-7.2-16-16c0-61.9 50.1-112 112-112c8.8 0 16 7.2 16 16s-7.2 16-16 16c-44.2 0-80 35.8-80 80z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        384,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.rC = vt.mw;
            },
            7964: (le1, vt)=>{
                "use strict";
                var bt = "link", ls = [
                    128279,
                    "chain"
                ], ho = "f0c1", Dl = "M579.8 267.7c56.5-56.5 56.5-148 0-204.5c-50-50-128.8-56.5-186.3-15.4l-1.6 1.1c-14.4 10.3-17.7 30.3-7.4 44.6s30.3 17.7 44.6 7.4l1.6-1.1c32.1-22.9 76-19.3 103.8 8.6c31.5 31.5 31.5 82.5 0 114L422.3 334.8c-31.5 31.5-82.5 31.5-114 0c-27.9-27.9-31.5-71.8-8.6-103.8l1.1-1.6c10.3-14.4 6.9-34.4-7.4-44.6s-34.4-6.9-44.6 7.4l-1.1 1.6C206.5 251.2 213 330 263 380c56.5 56.5 148 56.5 204.5 0L579.8 267.7zM60.2 244.3c-56.5 56.5-56.5 148 0 204.5c50 50 128.8 56.5 186.3 15.4l1.6-1.1c14.4-10.3 17.7-30.3 7.4-44.6s-30.3-17.7-44.6-7.4l-1.6 1.1c-32.1 22.9-76 19.3-103.8-8.6C74 372 74 321 105.5 289.5L217.7 177.2c31.5-31.5 82.5-31.5 114 0c27.9 27.9 31.5 71.8 8.6 103.9l-1.1 1.6c-10.3 14.4-6.9 34.4 7.4 44.6s34.4 6.9 44.6-7.4l1.1-1.6C433.5 260.8 427 182 377 132c-56.5-56.5-148-56.5-204.5 0L60.2 244.3z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        640,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.CQ = vt.mw;
            },
            3520: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "location-dot", ls = [
                    "map-marker-alt"
                ], ho = "f3c5", Dl = "M215.7 499.2C267 435 384 279.4 384 192C384 86 298 0 192 0S0 86 0 192c0 87.4 117 243 168.3 307.2c12.3 15.3 35.1 15.3 47.4 0zM192 128a64 64 0 1 1 0 128 64 64 0 1 1 0-128z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        384,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faLocationDot = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 384, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            7761: (le1, vt)=>{
                "use strict";
                var bt = "magnifying-glass", ls = [
                    128269,
                    "search"
                ], ho = "f002", Dl = "M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.$U = vt.mw;
            },
            2e3: (le1, vt)=>{
                "use strict";
                var bt = [
                    128506,
                    62072
                ], ls = "f279", ho = "M384 476.1L192 421.2l0-385.3L384 90.8l0 385.3zm32-1.2l0-386.5L543.1 37.5c15.8-6.3 32.9 5.3 32.9 22.3l0 334.8c0 9.8-6 18.6-15.1 22.3L416 474.8zM15.1 95.1L160 37.2l0 386.5L32.9 474.5C17.1 480.8 0 469.2 0 452.2L0 117.4c0-9.8 6-18.6 15.1-22.3z";
                vt.mw = {
                    prefix: "fas",
                    iconName: "map",
                    icon: [
                        576,
                        512,
                        bt,
                        ls,
                        ho
                    ]
                }, vt.e5 = vt.mw;
            },
            6655: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(3520);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.Pc = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            3233: (le1, vt)=>{
                "use strict";
                var bt = "medal", ls = [
                    127941
                ], ho = "f5a2", Dl = "M4.1 38.2C1.4 34.2 0 29.4 0 24.6C0 11 11 0 24.6 0L133.9 0c11.2 0 21.7 5.9 27.4 15.5l68.5 114.1c-48.2 6.1-91.3 28.6-123.4 61.9L4.1 38.2zm503.7 0L405.6 191.5c-32.1-33.3-75.2-55.8-123.4-61.9L350.7 15.5C356.5 5.9 366.9 0 378.1 0L487.4 0C501 0 512 11 512 24.6c0 4.8-1.4 9.6-4.1 13.6zM80 336a176 176 0 1 1 352 0A176 176 0 1 1 80 336zm184.4-94.9c-3.4-7-13.3-7-16.8 0l-22.4 45.4c-1.4 2.8-4 4.7-7 5.1L168 298.9c-7.7 1.1-10.7 10.5-5.2 16l36.3 35.4c2.2 2.2 3.2 5.2 2.7 8.3l-8.6 49.9c-1.3 7.6 6.7 13.5 13.6 9.9l44.8-23.6c2.7-1.4 6-1.4 8.7 0l44.8 23.6c6.9 3.6 14.9-2.2 13.6-9.9l-8.6-49.9c-.5-3 .5-6.1 2.7-8.3l36.3-35.4c5.6-5.4 2.5-14.8-5.2-16l-50.1-7.3c-3-.4-5.7-2.4-7-5.1l-22.4-45.4z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.B9 = vt.mw;
            },
            7290: (le1, vt)=>{
                "use strict";
                var bt = "minus", ls = [
                    8211,
                    8722,
                    10134,
                    "subtract"
                ], ho = "f068", Dl = "M432 256c0 17.7-14.3 32-32 32L48 288c-17.7 0-32-14.3-32-32s14.3-32 32-32l352 0c17.7 0 32 14.3 32 32z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.EZ = vt.mw;
            },
            8629: (le1, vt)=>{
                "use strict";
                var bt = "palette", ls = [
                    127912
                ], ho = "f53f", Dl = "M512 256c0 .9 0 1.8 0 2.7c-.4 36.5-33.6 61.3-70.1 61.3L344 320c-26.5 0-48 21.5-48 48c0 3.4 .4 6.7 1 9.9c2.1 10.2 6.5 20 10.8 29.9c6.1 13.8 12.1 27.5 12.1 42c0 31.8-21.6 60.7-53.4 62c-3.5 .1-7 .2-10.6 .2C114.6 512 0 397.4 0 256S114.6 0 256 0S512 114.6 512 256zM128 288a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm0-96a32 32 0 1 0 0-64 32 32 0 1 0 0 64zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zm96 96a32 32 0 1 0 0-64 32 32 0 1 0 0 64z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.fy = vt.mw;
            },
            9683: (le1, vt)=>{
                "use strict";
                var bt = "panorama", ls = [], ho = "e209", Dl = "M45.6 32C20.4 32 0 52.4 0 77.6L0 434.4C0 459.6 20.4 480 45.6 480c5.1 0 10-.8 14.7-2.4C74.6 472.8 177.6 440 320 440s245.4 32.8 259.6 37.6c4.7 1.6 9.7 2.4 14.7 2.4c25.2 0 45.6-20.4 45.6-45.6l0-356.7C640 52.4 619.6 32 594.4 32c-5 0-10 .8-14.7 2.4C565.4 39.2 462.4 72 320 72S74.6 39.2 60.4 34.4C55.6 32.8 50.7 32 45.6 32zM96 160a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm272 0c7.9 0 15.4 3.9 19.8 10.5L512.3 353c5.4 8 5.6 18.4 .4 26.5s-14.7 12.3-24.2 10.7C442.7 382.4 385.2 376 320 376c-65.6 0-123.4 6.5-169.3 14.4c-9.8 1.7-19.7-2.9-24.7-11.5s-4.3-19.4 1.9-27.2L197.3 265c4.6-5.7 11.4-9 18.7-9s14.2 3.3 18.7 9l26.4 33.1 87-127.6c4.5-6.6 11.9-10.5 19.8-10.5z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        640,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.pt = vt.mw;
            },
            1708: (le1, vt)=>{
                "use strict";
                var bt = "paper-plane", ls = [
                    61913
                ], ho = "f1d8", Dl = "M498.1 5.6c10.1 7 15.4 19.1 13.5 31.2l-64 416c-1.5 9.7-7.4 18.2-16 23s-18.9 5.4-28 1.6L284 427.7l-68.5 74.1c-8.9 9.7-22.9 12.9-35.2 8.1S160 493.2 160 480l0-83.6c0-4 1.5-7.8 4.2-10.8L331.8 202.8c5.8-6.3 5.6-16-.4-22s-15.7-6.4-22-.7L106 360.8 17.7 316.6C7.1 311.3 .3 300.7 0 288.9s5.9-22.8 16.1-28.7l448-256c10.7-6.1 23.9-5.5 34 1.4z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.is = vt.mw;
            },
            7472: (le1, vt)=>{
                "use strict";
                var bt = "pause", ls = [
                    9208
                ], ho = "f04c", Dl = "M48 64C21.5 64 0 85.5 0 112L0 400c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48L48 64zm192 0c-26.5 0-48 21.5-48 48l0 288c0 26.5 21.5 48 48 48l32 0c26.5 0 48-21.5 48-48l0-288c0-26.5-21.5-48-48-48l-32 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        320,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.G1 = vt.mw;
            },
            7321: (le1, vt)=>{
                "use strict";
                var bt = [
                    128394
                ], ls = "f304", ho = "M362.7 19.3L314.3 67.7 444.3 197.7l48.4-48.4c25-25 25-65.5 0-90.5L453.3 19.3c-25-25-65.5-25-90.5 0zm-71 71L58.6 323.5c-10.4 10.4-18 23.3-22.2 37.4L1 481.2C-1.5 489.7 .8 498.8 7 505s15.3 8.5 23.7 6.1l120.3-35.4c14.1-4.2 27-11.8 37.4-22.2L421.7 220.3 291.7 90.3z";
                vt.mw = {
                    prefix: "fas",
                    iconName: "pen",
                    icon: [
                        512,
                        512,
                        bt,
                        ls,
                        ho
                    ]
                }, vt.hp = vt.mw;
            },
            9243: (le1, vt)=>{
                "use strict";
                var bt = "person-biking", ls = [
                    128692,
                    "biking"
                ], ho = "f84a", Dl = "M400 96a48 48 0 1 0 0-96 48 48 0 1 0 0 96zm27.2 64l-61.8-48.8c-17.3-13.6-41.7-13.8-59.1-.3l-83.1 64.2c-30.7 23.8-28.5 70.8 4.3 91.6L288 305.1 288 416c0 17.7 14.3 32 32 32s32-14.3 32-32l0-128c0-10.7-5.3-20.7-14.2-26.6L295 232.9l60.3-48.5L396 217c5.7 4.5 12.7 7 20 7l64 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-52.8 0zM56 384a72 72 0 1 1 144 0A72 72 0 1 1 56 384zm200 0A128 128 0 1 0 0 384a128 128 0 1 0 256 0zm184 0a72 72 0 1 1 144 0 72 72 0 1 1 -144 0zm200 0a128 128 0 1 0 -256 0 128 128 0 1 0 256 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        640,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.rO = vt.mw;
            },
            6386: (le1, vt)=>{
                "use strict";
                var bt = "play", ls = [
                    9654
                ], ho = "f04b", Dl = "M73 39c-14.8-9.1-33.4-9.4-48.5-.9S0 62.6 0 80L0 432c0 17.4 9.4 33.4 24.5 41.9s33.7 8.1 48.5-.9L361 297c14.3-8.7 23-24.2 23-41s-8.7-32.2-23-41L73 39z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        384,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.ij = vt.mw;
            },
            1372: (le1, vt)=>{
                "use strict";
                var bt = "plus", ls = [
                    10133,
                    61543,
                    "add"
                ], ho = "M256 80c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 144L48 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l144 0 0 144c0 17.7 14.3 32 32 32s32-14.3 32-32l0-144 144 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-144 0 0-144z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        "2b",
                        ho
                    ]
                }, vt.QL = vt.mw;
            },
            1319: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(2587);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.jk = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            5124: (le1, vt)=>{
                "use strict";
                var bt = "question", ls = [
                    10067,
                    10068,
                    61736
                ], ho = "M80 160c0-35.3 28.7-64 64-64l32 0c35.3 0 64 28.7 64 64l0 3.6c0 21.8-11.1 42.1-29.4 53.8l-42.2 27.1c-25.2 16.2-40.4 44.1-40.4 74l0 1.4c0 17.7 14.3 32 32 32s32-14.3 32-32l0-1.4c0-8.2 4.2-15.8 11-20.2l42.2-27.1c36.6-23.6 58.8-64.1 58.8-107.7l0-3.6c0-70.7-57.3-128-128-128l-32 0C73.3 32 16 89.3 16 160c0 17.7 14.3 32 32 32s32-14.3 32-32zm80 320a40 40 0 1 0 0-80 40 40 0 1 0 0 80z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        320,
                        512,
                        ls,
                        "3f",
                        ho
                    ]
                }, vt.Ev = vt.mw;
            },
            7744: (le1, vt)=>{
                "use strict";
                var bt = "rocket", ls = [], ho = "f135", Dl = "M156.6 384.9L125.7 354c-8.5-8.5-11.5-20.8-7.7-32.2c3-8.9 7-20.5 11.8-33.8L24 288c-8.6 0-16.6-4.6-20.9-12.1s-4.2-16.7 .2-24.1l52.5-88.5c13-21.9 36.5-35.3 61.9-35.3l82.3 0c2.4-4 4.8-7.7 7.2-11.3C289.1-4.1 411.1-8.1 483.9 5.3c11.6 2.1 20.6 11.2 22.8 22.8c13.4 72.9 9.3 194.8-111.4 276.7c-3.5 2.4-7.3 4.8-11.3 7.2l0 82.3c0 25.4-13.4 49-35.3 61.9l-88.5 52.5c-7.4 4.4-16.6 4.5-24.1 .2s-12.1-12.2-12.1-20.9l0-107.2c-14.1 4.9-26.4 8.9-35.7 11.9c-11.2 3.6-23.4 .5-31.8-7.8zM384 168a40 40 0 1 0 0-80 40 40 0 1 0 0 80z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.KM = vt.mw;
            },
            6787: (le1, vt)=>{
                "use strict";
                var bt = "satellite-dish", ls = [
                    128225
                ], ho = "f7c0", Dl = "M192 32c0-17.7 14.3-32 32-32C383.1 0 512 128.9 512 288c0 17.7-14.3 32-32 32s-32-14.3-32-32C448 164.3 347.7 64 224 64c-17.7 0-32-14.3-32-32zM60.6 220.6L164.7 324.7l28.4-28.4c-.7-2.6-1.1-5.4-1.1-8.3c0-17.7 14.3-32 32-32s32 14.3 32 32s-14.3 32-32 32c-2.9 0-5.6-.4-8.3-1.1l-28.4 28.4L291.4 451.4c14.5 14.5 11.8 38.8-7.3 46.3C260.5 506.9 234.9 512 208 512C93.1 512 0 418.9 0 304c0-26.9 5.1-52.5 14.4-76.1c7.5-19 31.8-21.8 46.3-7.3zM224 96c106 0 192 86 192 192c0 17.7-14.3 32-32 32s-32-14.3-32-32c0-70.7-57.3-128-128-128c-17.7 0-32-14.3-32-32s14.3-32 32-32z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.hU = vt.mw;
            },
            2077: (le1, vt)=>{
                "use strict";
                var bt = "scroll", ls = [
                    128220
                ], ho = "f70e", Dl = "M0 80l0 48c0 17.7 14.3 32 32 32l16 0 48 0 0-80c0-26.5-21.5-48-48-48S0 53.5 0 80zM112 32c10 13.4 16 30 16 48l0 304c0 35.3 28.7 64 64 64s64-28.7 64-64l0-5.3c0-32.4 26.3-58.7 58.7-58.7L480 320l0-192c0-53-43-96-96-96L112 32zM464 480c61.9 0 112-50.1 112-112c0-8.8-7.2-16-16-16l-245.3 0c-14.7 0-26.7 11.9-26.7 26.7l0 5.3c0 53-43 96-96 96l176 0 96 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.DD = vt.mw;
            },
            6002: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(1260);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.QO = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            1260: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "share-nodes", ls = [
                    "share-alt"
                ], ho = "f1e0", Dl = "M352 224c53 0 96-43 96-96s-43-96-96-96s-96 43-96 96c0 4 .2 8 .7 11.9l-94.1 47C145.4 170.2 121.9 160 96 160c-53 0-96 43-96 96s43 96 96 96c25.9 0 49.4-10.2 66.6-26.9l94.1 47c-.5 3.9-.7 7.8-.7 11.9c0 53 43 96 96 96s96-43 96-96s-43-96-96-96c-25.9 0-49.4 10.2-66.6 26.9l-94.1-47c.5-3.9 .7-7.8 .7-11.9s-.2-8-.7-11.9l94.1-47C302.6 213.8 326.1 224 352 224z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faShareNodes = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 448, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            1904: (le1, vt)=>{
                "use strict";
                var bt = "sliders", ls = [
                    "sliders-h"
                ], ho = "f1de", Dl = "M0 416c0 17.7 14.3 32 32 32l54.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 448c17.7 0 32-14.3 32-32s-14.3-32-32-32l-246.7 0c-12.3-28.3-40.5-48-73.3-48s-61 19.7-73.3 48L32 384c-17.7 0-32 14.3-32 32zm128 0a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zM320 256a32 32 0 1 1 64 0 32 32 0 1 1 -64 0zm32-80c-32.8 0-61 19.7-73.3 48L32 224c-17.7 0-32 14.3-32 32s14.3 32 32 32l246.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48l54.7 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-54.7 0c-12.3-28.3-40.5-48-73.3-48zM192 128a32 32 0 1 1 0-64 32 32 0 1 1 0 64zm73.3-64C253 35.7 224.8 16 192 16s-61 19.7-73.3 48L32 64C14.3 64 0 78.3 0 96s14.3 32 32 32l86.7 0c12.3 28.3 40.5 48 73.3 48s61-19.7 73.3-48L480 128c17.7 0 32-14.3 32-32s-14.3-32-32-32L265.3 64z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt._$ = vt.mw;
            },
            2587: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "square-plus", ls = [
                    61846,
                    "plus-square"
                ], ho = "f0fe", Dl = "M64 32C28.7 32 0 60.7 0 96L0 416c0 35.3 28.7 64 64 64l320 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zM200 344l0-64-64 0c-13.3 0-24-10.7-24-24s10.7-24 24-24l64 0 0-64c0-13.3 10.7-24 24-24s24 10.7 24 24l0 64 64 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-64 0 0 64c0 13.3-10.7 24-24 24s-24-10.7-24-24z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faSquarePlus = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 448, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            4780: (le1, vt)=>{
                "use strict";
                var bt = "star", ls = [
                    11088,
                    61446
                ], ho = "f005", Dl = "M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        576,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.yy = vt.mw;
            },
            6249: (le1, vt)=>{
                "use strict";
                var bt = "tags", ls = [], ho = "f02c", Dl = "M345 39.1L472.8 168.4c52.4 53 52.4 138.2 0 191.2L360.8 472.9c-9.3 9.4-24.5 9.5-33.9 .2s-9.5-24.5-.2-33.9L438.6 325.9c33.9-34.3 33.9-89.4 0-123.7L310.9 72.9c-9.3-9.4-9.2-24.6 .2-33.9s24.6-9.2 33.9 .2zM0 229.5L0 80C0 53.5 21.5 32 48 32l149.5 0c17 0 33.3 6.7 45.3 18.7l168 168c25 25 25 65.5 0 90.5L277.3 442.7c-25 25-65.5 25-90.5 0l-168-168C6.7 262.7 0 246.5 0 229.5zM144 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.DX = vt.mw;
            },
            3624: (le1, vt, bt)=>{
                "use strict";
                var ls = bt(6627);
                vt.mw = {
                    prefix: ls.prefix,
                    iconName: ls.iconName,
                    icon: [
                        ls.width,
                        ls.height,
                        ls.aliases,
                        ls.unicode,
                        ls.svgPathData
                    ]
                }, vt.GR = vt.mw, ls.prefix, ls.iconName, ls.width, ls.height, ls.aliases, ls.unicode, ls.svgPathData, ls.aliases;
            },
            4692: (le1, vt)=>{
                "use strict";
                var bt = "trash", ls = [], ho = "f1f8", Dl = "M135.2 17.7L128 32 32 32C14.3 32 0 46.3 0 64S14.3 96 32 96l384 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-96 0-7.2-14.3C307.4 6.8 296.3 0 284.2 0L163.8 0c-12.1 0-23.2 6.8-28.6 17.7zM416 128L32 128 53.2 467c1.6 25.3 22.6 45 47.9 45l245.8 0c25.3 0 46.3-19.7 47.9-45L416 128z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.yL = vt.mw;
            },
            6311: (le1, vt)=>{
                "use strict";
                var bt = "triangle-exclamation", ls = [
                    9888,
                    "exclamation-triangle",
                    "warning"
                ], ho = "f071", Dl = "M256 32c14.2 0 27.3 7.5 34.5 19.8l216 368c7.3 12.4 7.3 27.7 .2 40.1S486.3 480 472 480L40 480c-14.3 0-27.6-7.7-34.7-20.1s-7-27.8 .2-40.1l216-368C228.7 39.5 241.8 32 256 32zm0 128c-13.3 0-24 10.7-24 24l0 112c0 13.3 10.7 24 24 24s24-10.7 24-24l0-112c0-13.3-10.7-24-24-24zm32 224a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.JA = vt.mw;
            },
            7144: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "up-right-from-square", ls = [
                    "external-link-alt"
                ], ho = "f35d", Dl = "M352 0c-12.9 0-24.6 7.8-29.6 19.8s-2.2 25.7 6.9 34.9L370.7 96 201.4 265.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L416 141.3l41.4 41.4c9.2 9.2 22.9 11.9 34.9 6.9s19.8-16.6 19.8-29.6l0-128c0-17.7-14.3-32-32-32L352 0zM80 32C35.8 32 0 67.8 0 112L0 432c0 44.2 35.8 80 80 80l320 0c44.2 0 80-35.8 80-80l0-112c0-17.7-14.3-32-32-32s-32 14.3-32 32l0 112c0 8.8-7.2 16-16 16L80 448c-8.8 0-16-7.2-16-16l0-320c0-8.8 7.2-16 16-16l112 0c17.7 0 32-14.3 32-32s-14.3-32-32-32L80 32z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        512,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faUpRightFromSquare = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 512, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            7879: (le1, vt)=>{
                "use strict";
                var bt = "user", ls = [
                    128100,
                    62144
                ], ho = "f007", Dl = "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l388.6 0c16.4 0 29.7-13.3 29.7-29.7C448 383.8 368.2 304 269.7 304l-91.4 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.X4 = vt.mw;
            },
            3324: (le1, vt)=>{
                "use strict";
                var bt = "user-lock", ls = [], ho = "f502", Dl = "M224 256A128 128 0 1 0 224 0a128 128 0 1 0 0 256zm-45.7 48C79.8 304 0 383.8 0 482.3C0 498.7 13.3 512 29.7 512l362.8 0c-5.4-9.4-8.6-20.3-8.6-32l0-128c0-2.1 .1-4.2 .3-6.3c-31-26-71-41.7-114.6-41.7l-91.4 0zM528 240c17.7 0 32 14.3 32 32l0 48-64 0 0-48c0-17.7 14.3-32 32-32zm-80 32l0 48c-17.7 0-32 14.3-32 32l0 128c0 17.7 14.3 32 32 32l160 0c17.7 0 32-14.3 32-32l0-128c0-17.7-14.3-32-32-32l0-48c0-44.2-35.8-80-80-80s-80 35.8-80 80z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        640,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.aA = vt.mw;
            },
            7428: (le1, vt)=>{
                "use strict";
                var bt = "vector-square", ls = [], ho = "f5cb", Dl = "M368 80l32 0 0 32-32 0 0-32zM352 32c-17.7 0-32 14.3-32 32L128 64c0-17.7-14.3-32-32-32L32 32C14.3 32 0 46.3 0 64l0 64c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l0 64c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l64 0c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l0-192c17.7 0 32-14.3 32-32l0-64c0-17.7-14.3-32-32-32l-64 0zM96 160c17.7 0 32-14.3 32-32l192 0c0 17.7 14.3 32 32 32l0 192c-17.7 0-32 14.3-32 32l-192 0c0-17.7-14.3-32-32-32l0-192zM48 400l32 0 0 32-32 0 0-32zm320 32l0-32 32 0 0 32-32 0zM48 112l0-32 32 0 0 32-32 0z";
                vt.mw = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        448,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.Cw = vt.mw;
            },
            6627: (le1, vt)=>{
                "use strict";
                Object.defineProperty(vt, "__esModule", {
                    value: !0
                });
                var bt = "xmark", ls = [
                    128473,
                    10005,
                    10006,
                    10060,
                    215,
                    "close",
                    "multiply",
                    "remove",
                    "times"
                ], ho = "f00d", Dl = "M342.6 150.6c12.5-12.5 12.5-32.8 0-45.3s-32.8-12.5-45.3 0L192 210.7 86.6 105.4c-12.5-12.5-32.8-12.5-45.3 0s-12.5 32.8 0 45.3L146.7 256 41.4 361.4c-12.5 12.5-12.5 32.8 0 45.3s32.8 12.5 45.3 0L192 301.3 297.4 406.6c12.5 12.5 32.8 12.5 45.3 0s12.5-32.8 0-45.3L237.3 256 342.6 150.6z";
                vt.definition = {
                    prefix: "fas",
                    iconName: bt,
                    icon: [
                        384,
                        512,
                        ls,
                        ho,
                        Dl
                    ]
                }, vt.faXmark = vt.definition, vt.prefix = "fas", vt.iconName = bt, vt.width = 384, vt.height = 512, vt.ligatures = ls, vt.unicode = ho, vt.svgPathData = Dl, vt.aliases = ls;
            },
            1545: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    AZ: ()=>tm,
                    GR: ()=>yg,
                    IJ: ()=>gg,
                    Np: ()=>wg,
                    Qw: ()=>mg,
                    S: ()=>registerButton,
                    TL: ()=>Bg,
                    Wp: ()=>Ud,
                    aH: ()=>Fl,
                    e6: ()=>Gd,
                    jM: ()=>gA,
                    rx: ()=>im,
                    uj: ()=>xg,
                    zY: ()=>jg
                });
                var ls = bt(9435), ho = bt(9408), Dl = Object.defineProperty, __export = (le1, vt)=>{
                    for(var bt in vt)Dl(le1, bt, {
                        get: vt[bt],
                        enumerable: !0
                    });
                }, Fl = {};
                __export(Fl, {
                    ACTIONS: ()=>Ld,
                    ANIMATION_MIN_DURATION: ()=>uc,
                    CAPTURE_EVENTS_CLASS: ()=>Md,
                    CTRLZOOM_TIMEOUT: ()=>kc,
                    DBLCLICK_DELAY: ()=>gc,
                    EASINGS: ()=>jd,
                    ICONS: ()=>Od,
                    IDS: ()=>Nd,
                    KEY_CODES: ()=>Rd,
                    LONGTOUCH_DELAY: ()=>Ac,
                    MOVE_THRESHOLD: ()=>mc,
                    SPHERE_RADIUS: ()=>du,
                    TWOFINGERSOVERLAY_DELAY: ()=>Ec,
                    VIEWER_DATA: ()=>_u
                });
                var sc, uc = 500, mc = 4, gc = 300, Ac = 500, Ec = 100, kc = 2e3, du = 10, _u = "photoSphereViewer", Md = "psv--capture-event", Ld = ((le1)=>(le1.ROTATE_UP = "ROTATE_UP", le1.ROTATE_DOWN = "ROTATE_DOWN", le1.ROTATE_RIGHT = "ROTATE_RIGHT", le1.ROTATE_LEFT = "ROTATE_LEFT", le1.ZOOM_IN = "ZOOM_IN", le1.ZOOM_OUT = "ZOOM_OUT", le1))(Ld || {}), Nd = {
                    MENU: "menu",
                    TWO_FINGERS: "twoFingers",
                    CTRL_ZOOM: "ctrlZoom",
                    ERROR: "error",
                    DESCRIPTION: "description"
                }, Rd = {
                    Enter: "Enter",
                    Control: "Control",
                    Escape: "Escape",
                    Space: " ",
                    PageUp: "PageUp",
                    PageDown: "PageDown",
                    ArrowLeft: "ArrowLeft",
                    ArrowUp: "ArrowUp",
                    ArrowRight: "ArrowRight",
                    ArrowDown: "ArrowDown",
                    Delete: "Delete",
                    Plus: "+",
                    Minus: "-"
                }, Od = {
                    arrow: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="40 40 432 432"><g transform="rotate(0, 256, 256)"><path fill="currentColor" d="M425.23 210.55H227.39a5 5 0 01-3.53-8.53l56.56-56.57a45.5 45.5 0 000-64.28 45.15 45.15 0 00-32.13-13.3 45.15 45.15 0 00-32.14 13.3L41.32 256l174.83 174.83a45.15 45.15 0 0032.14 13.3 45.15 45.15 0 0032.13-13.3 45.5 45.5 0 000-64.28l-56.57-56.57a5 5 0 013.54-8.53h197.84c25.06 0 45.45-20.39 45.45-45.45s-20.4-45.45-45.45-45.45z"/></g>\x3c!-- Created by Flatart from the Noun Project --\x3e</svg>\n',
                    close: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><g fill="currentColor" transform=" translate(50, 50) rotate(45)"><rect x="-5" y="-65" width="10" height="130"/><rect x="-65" y="-5" width="130" height="10"/></g></svg>',
                    download: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M83.3 35.6h-17V3H32.2v32.6H16.6l33.6 32.7 33-32.7z"/><path fill="currentColor" d="M83.3 64.2v16.3H16.6V64.2H-.1v32.6H100V64.2H83.3z"/>\x3c!--Created by Michael Zenaty from the Noun Project--\x3e</svg>\n',
                    fullscreenIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M100 40H87.1V18.8h-21V6H100zM100 93.2H66V80.3h21.1v-21H100zM34 93.2H0v-34h12.9v21.1h21zM12.9 40H0V6h34v12.9H12.8z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
                    fullscreenOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M66 7h13v21h21v13H66zM66 60.3h34v12.9H79v21H66zM0 60.3h34v34H21V73.1H0zM21 7h13v34H0V28h21z"/>\x3c!--Created by Garrett Knoll from the Noun Project--\x3e</svg>\n',
                    info: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 64 64"><path fill="currentColor" d="M28.3 26.1c-1 2.6-1.9 4.8-2.6 7-2.5 7.4-5 14.7-7.2 22-1.3 4.4.5 7.2 4.3 7.8 1.3.2 2.8.2 4.2-.1 8.2-2 11.9-8.6 15.7-15.2l-2.2 2a18.8 18.8 0 0 1-7.4 5.2 2 2 0 0 1-1.6-.2c-.2-.1 0-1 0-1.4l.8-1.8L41.9 28c.5-1.4.9-3 .7-4.4-.2-2.6-3-4.4-6.3-4.4-8.8.2-15 4.5-19.5 11.8-.2.3-.2.6-.3 1.3 3.7-2.8 6.8-6.1 11.8-6.2z"/><circle fill="currentColor" cx="39.3" cy="9.2" r="8.2"/>\x3c!--Created by Arafat Uddin from the Noun Project--\x3e</svg>\n',
                    menu: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 10 80 80"><g fill="currentColor"><circle r="10" cx="20" cy="20"/><circle r="10" cx="50" cy="20"/><circle r="10" cx="80" cy="20"/><circle r="10" cx="20" cy="50"/><circle r="10" cx="50" cy="50"/><circle r="10" cx="80" cy="50"/><circle r="10" cx="20" cy="80"/><circle r="10" cx="50" cy="80"/><circle r="10" cx="80" cy="80"/></g>\x3c!-- Created by Richard Kun\xe1k from the Noun Project--\x3e</svg>\n',
                    zoomIn: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M8.728 4.009H6.744v2.737H4.006V8.73h2.738v2.736h1.984V8.73h2.737V6.746H8.728z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n',
                    zoomOut: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 20 20"><path fill="currentColor" d="M14.043 12.22a7.738 7.738 0 1 0-1.823 1.822l4.985 4.985c.503.504 1.32.504 1.822 0a1.285 1.285 0 0 0 0-1.822l-4.984-4.985zm-6.305 1.043a5.527 5.527 0 1 1 0-11.053 5.527 5.527 0 0 1 0 11.053z"/><path fill="currentColor" d="M4.006 6.746h7.459V8.73H4.006z"/>\x3c!--Created by Ryan Canning from the Noun Project--\x3e</svg>\n'
                }, jd = {
                    linear: (le1)=>le1,
                    inQuad: (le1)=>le1 * le1,
                    outQuad: (le1)=>le1 * (2 - le1),
                    inOutQuad: (le1)=>le1 < .5 ? 2 * le1 * le1 : (4 - 2 * le1) * le1 - 1,
                    inCubic: (le1)=>le1 * le1 * le1,
                    outCubic: (le1)=>--le1 * le1 * le1 + 1,
                    inOutCubic: (le1)=>le1 < .5 ? 4 * le1 * le1 * le1 : (le1 - 1) * (2 * le1 - 2) * (2 * le1 - 2) + 1,
                    inQuart: (le1)=>le1 * le1 * le1 * le1,
                    outQuart: (le1)=>1 - --le1 * le1 * le1 * le1,
                    inOutQuart: (le1)=>le1 < .5 ? 8 * le1 * le1 * le1 * le1 : 1 - 8 * --le1 * le1 * le1 * le1,
                    inQuint: (le1)=>le1 * le1 * le1 * le1 * le1,
                    outQuint: (le1)=>1 + --le1 * le1 * le1 * le1 * le1,
                    inOutQuint: (le1)=>le1 < .5 ? 16 * le1 * le1 * le1 * le1 * le1 : 1 + 16 * --le1 * le1 * le1 * le1 * le1,
                    inSine: (le1)=>1 - Math.cos(le1 * (Math.PI / 2)),
                    outSine: (le1)=>Math.sin(le1 * (Math.PI / 2)),
                    inOutSine: (le1)=>.5 - .5 * Math.cos(Math.PI * le1),
                    inExpo: (le1)=>Math.pow(2, 10 * (le1 - 1)),
                    outExpo: (le1)=>1 - Math.pow(2, -10 * le1),
                    inOutExpo: (le1)=>(le1 = 2 * le1 - 1) < 0 ? .5 * Math.pow(2, 10 * le1) : 1 - .5 * Math.pow(2, -10 * le1),
                    inCirc: (le1)=>1 - Math.sqrt(1 - le1 * le1),
                    outCirc: (le1)=>Math.sqrt(1 - (le1 - 1) * (le1 - 1)),
                    inOutCirc: (le1)=>(le1 *= 2) < 1 ? .5 - .5 * Math.sqrt(1 - le1 * le1) : .5 + .5 * Math.sqrt(1 - (le1 -= 2) * le1)
                }, Ud = {};
                function wrap(le1, vt) {
                    let bt = le1 % vt;
                    return bt < 0 && (bt += vt), bt;
                }
                function sum(le1) {
                    return le1.reduce((le1, vt)=>le1 + vt, 0);
                }
                function distance(le1, vt) {
                    return Math.sqrt(Math.pow(le1.x - vt.x, 2) + Math.pow(le1.y - vt.y, 2));
                }
                function angle(le1, vt) {
                    return Math.atan2(vt.y - le1.y, vt.x - le1.x);
                }
                function getShortestArc(le1, vt) {
                    return [
                        0,
                        2 * Math.PI,
                        2 * -Math.PI
                    ].reduce((bt, ls)=>{
                        const ho = vt - le1 + ls;
                        return Math.abs(ho) < Math.abs(bt) ? ho : bt;
                    }, 1 / 0);
                }
                function getAngle(le1, vt) {
                    return Math.acos(Math.cos(le1.pitch) * Math.cos(vt.pitch) * Math.cos(le1.yaw - vt.yaw) + Math.sin(le1.pitch) * Math.sin(vt.pitch));
                }
                function greatArcDistance(le1, vt) {
                    let [bt, ls] = le1, [ho, Dl] = vt;
                    bt - ho > Math.PI ? bt -= 2 * Math.PI : bt - ho < -Math.PI && (bt += 2 * Math.PI);
                    const Fl = (ho - bt) * Math.cos((ls + Dl) / 2), sc = Dl - ls;
                    return Math.sqrt(Fl * Fl + sc * sc);
                }
                function getElement(le1) {
                    return "string" === typeof le1 ? le1.match(/^[a-z]/i) ? document.getElementById(le1) : document.querySelector(le1) : le1;
                }
                function toggleClass(le1, vt, bt) {
                    void 0 === bt ? le1.classList.toggle(vt) : bt ? le1.classList.add(vt) : bt || le1.classList.remove(vt);
                }
                function addClasses(le1, vt) {
                    le1.classList.add(...vt.split(" ").filter((le1)=>!!le1));
                }
                function removeClasses(le1, vt) {
                    le1.classList.remove(...vt.split(" ").filter((le1)=>!!le1));
                }
                function hasParent(le1, vt) {
                    let bt = le1;
                    do {
                        if (bt === vt) return !0;
                        bt = bt.parentElement;
                    }while (bt);
                    return !1;
                }
                function getClosest(le1, vt) {
                    if (!le1?.matches) return null;
                    let bt = le1;
                    do {
                        if (bt.matches(vt)) return bt;
                        bt = bt.parentElement;
                    }while (bt);
                    return null;
                }
                function getEventTarget(le1) {
                    return le1?.composedPath()[0] || null;
                }
                function getMatchingTarget(le1, vt) {
                    return le1 ? le1.composedPath().find((le1)=>(le1 instanceof HTMLElement || le1 instanceof SVGElement) && le1.matches(vt)) : null;
                }
                function getPosition(le1) {
                    let vt = 0, bt = 0, ls = le1;
                    for(; ls;)vt += ls.offsetLeft - ls.scrollLeft + ls.clientLeft, bt += ls.offsetTop - ls.scrollTop + ls.clientTop, ls = ls.offsetParent;
                    return vt -= window.scrollX, bt -= window.scrollY, {
                        x: vt,
                        y: bt
                    };
                }
                function getStyleProperty(le1, vt) {
                    return window.getComputedStyle(le1).getPropertyValue(vt);
                }
                function getTouchData(le1) {
                    if (le1.touches.length < 2) return null;
                    const vt = {
                        x: le1.touches[0].clientX,
                        y: le1.touches[0].clientY
                    }, bt = {
                        x: le1.touches[1].clientX,
                        y: le1.touches[1].clientY
                    };
                    return {
                        distance: distance(vt, bt),
                        angle: angle(vt, bt),
                        center: {
                            x: (vt.x + bt.x) / 2,
                            y: (vt.y + bt.y) / 2
                        }
                    };
                }
                function isFullscreenEnabled(le1, vt) {
                    return void 0 === vt && (vt = !1), vt ? le1 === sc : document.fullscreenElement === le1;
                }
                function requestFullscreen(le1, vt) {
                    void 0 === vt && (vt = !1), vt ? (sc = le1, le1.classList.add("psv-fullscreen-emulation"), document.dispatchEvent(new Event("fullscreenchange"))) : le1.requestFullscreen();
                }
                function exitFullscreen(le1) {
                    void 0 === le1 && (le1 = !1), le1 ? (sc.classList.remove("psv-fullscreen-emulation"), sc = null, document.dispatchEvent(new Event("fullscreenchange"))) : document.exitFullscreen();
                }
                function keyPressMatch(le1, vt) {
                    let bt, ls = !1, ho = !1, Dl = !1, Fl = !1;
                    return "+" === vt ? bt = vt : vt.split("+").forEach((le1)=>{
                        switch(le1){
                            case "Shift":
                                ls = !0;
                                break;
                            case "Ctrl":
                                ho = !0;
                                break;
                            case "Alt":
                                Dl = !0;
                                break;
                            case "Meta":
                                Fl = !0;
                                break;
                            case "Space":
                                bt = " ";
                                break;
                            case "Plus":
                                bt = "+";
                                break;
                            case "Minus":
                                bt = "-";
                                break;
                            default:
                                bt = le1;
                        }
                    }), ls === le1.shiftKey && ho === le1.ctrlKey && Dl === le1.altKey && Fl === le1.metaKey && bt === le1.key;
                }
                function dasherize(le1) {
                    return le1.replace(/[A-Z](?:(?=[^A-Z])|[A-Z]*(?=[A-Z][^A-Z]|$))/g, (le1, vt)=>(vt > 0 ? "-" : "") + le1.toLowerCase());
                }
                function throttle(le1, vt) {
                    let bt = !1;
                    return function() {
                        for(var ls = arguments.length, ho = new Array(ls), Dl = 0; Dl < ls; Dl++)ho[Dl] = arguments[Dl];
                        bt || (bt = !0, setTimeout(()=>{
                            le1.apply(this, ho), bt = !1;
                        }, vt));
                    };
                }
                function isPlainObject(le1) {
                    if ("object" !== typeof le1 || null === le1 || "[object Object]" !== Object.prototype.toString.call(le1)) return !1;
                    if (null === Object.getPrototypeOf(le1)) return !0;
                    let vt = le1;
                    for(; null !== Object.getPrototypeOf(vt);)vt = Object.getPrototypeOf(vt);
                    return Object.getPrototypeOf(le1) === vt;
                }
                function deepmerge(le1, vt) {
                    const bt = vt;
                    return function merge(le1, vt) {
                        return Array.isArray(vt) ? (le1 && Array.isArray(le1) ? le1.length = 0 : le1 = [], vt.forEach((vt, bt)=>{
                            le1[bt] = merge(null, vt);
                        })) : "object" === typeof vt ? (le1 && !Array.isArray(le1) || (le1 = {}), Object.keys(vt).forEach((ls)=>{
                            "__proto__" !== ls && ("object" === typeof vt[ls] && vt[ls] && isPlainObject(vt[ls]) ? vt[ls] !== bt && (le1[ls] ? merge(le1[ls], vt[ls]) : le1[ls] = merge(null, vt[ls])) : le1[ls] = vt[ls]);
                        })) : le1 = vt, le1;
                    }(le1, vt);
                }
                function clone(le1) {
                    return deepmerge(null, le1);
                }
                function isEmpty(le1) {
                    return !le1 || 0 === Object.keys(le1).length && le1.constructor === Object;
                }
                function isNil(le1) {
                    return null === le1 || void 0 === le1;
                }
                function firstNonNull() {
                    for(var le1 = arguments.length, vt = new Array(le1), bt = 0; bt < le1; bt++)vt[bt] = arguments[bt];
                    for (const ls of vt)if (!isNil(ls)) return ls;
                    return null;
                }
                function deepEqual(le1, vt) {
                    if (le1 === vt) return !0;
                    if (isObject(le1) && isObject(vt)) {
                        if (Object.keys(le1).length !== Object.keys(vt).length) return !1;
                        for (const bt of Object.keys(le1))if (!deepEqual(le1[bt], vt[bt])) return !1;
                        return !0;
                    }
                    return !1;
                }
                function isObject(le1) {
                    return "object" === typeof le1 && null !== le1;
                }
                __export(Ud, {
                    Animation: ()=>Xd,
                    Dynamic: ()=>Kd,
                    MultiDynamic: ()=>Jd,
                    PressHandler: ()=>$d,
                    Slider: ()=>em,
                    SliderDirection: ()=>sp,
                    addClasses: ()=>addClasses,
                    angle: ()=>angle,
                    applyEulerInverse: ()=>applyEulerInverse,
                    checkClosedShadowDom: ()=>checkClosedShadowDom,
                    checkStylesheet: ()=>checkStylesheet,
                    checkVersion: ()=>checkVersion,
                    cleanCssPosition: ()=>cleanCssPosition,
                    clone: ()=>clone,
                    createTexture: ()=>createTexture,
                    cssPositionIsOrdered: ()=>cssPositionIsOrdered,
                    dasherize: ()=>dasherize,
                    deepEqual: ()=>deepEqual,
                    deepmerge: ()=>deepmerge,
                    distance: ()=>distance,
                    exitFullscreen: ()=>exitFullscreen,
                    firstNonNull: ()=>firstNonNull,
                    getAbortError: ()=>getAbortError,
                    getAngle: ()=>getAngle,
                    getClosest: ()=>getClosest,
                    getConfigParser: ()=>getConfigParser,
                    getElement: ()=>getElement,
                    getEventTarget: ()=>getEventTarget,
                    getMatchingTarget: ()=>getMatchingTarget,
                    getPosition: ()=>getPosition,
                    getShortestArc: ()=>getShortestArc,
                    getStyleProperty: ()=>getStyleProperty,
                    getTouchData: ()=>getTouchData,
                    getXMPValue: ()=>getXMPValue,
                    greatArcDistance: ()=>greatArcDistance,
                    hasParent: ()=>hasParent,
                    invertResolvableBoolean: ()=>invertResolvableBoolean,
                    isAbortError: ()=>isAbortError,
                    isEmpty: ()=>isEmpty,
                    isExtendedPosition: ()=>isExtendedPosition,
                    isFullscreenEnabled: ()=>isFullscreenEnabled,
                    isNil: ()=>isNil,
                    isPlainObject: ()=>isPlainObject,
                    keyPressMatch: ()=>keyPressMatch,
                    logWarn: ()=>logWarn,
                    mergePanoData: ()=>mergePanoData,
                    parseAngle: ()=>parseAngle,
                    parsePoint: ()=>parsePoint,
                    parseSpeed: ()=>parseSpeed,
                    removeClasses: ()=>removeClasses,
                    requestFullscreen: ()=>requestFullscreen,
                    resolveBoolean: ()=>resolveBoolean,
                    speedToDuration: ()=>speedToDuration,
                    sum: ()=>sum,
                    throttle: ()=>throttle,
                    toggleClass: ()=>toggleClass,
                    wrap: ()=>wrap
                });
                var Gd = class _PSVError extends Error {
                    constructor(le1, vt){
                        super(vt && vt instanceof Error ? `${le1}: ${vt.message}` : le1), this.name = "PSVError", Error.captureStackTrace?.(this, _PSVError);
                    }
                };
                function resolveBoolean(le1, vt) {
                    isPlainObject(le1) ? (vt(le1.initial, !0), le1.promise.then((le1)=>vt(le1, !1))) : vt(le1, !0);
                }
                function invertResolvableBoolean(le1) {
                    return {
                        initial: !le1.initial,
                        promise: le1.promise.then((le1)=>!le1)
                    };
                }
                function getAbortError() {
                    const le1 = new Error("Loading was aborted.");
                    return le1.name = "AbortError", le1;
                }
                function isAbortError(le1) {
                    return "AbortError" === le1?.name;
                }
                function logWarn(le1) {
                    console.warn(`PhotoSphereViewer: ${le1}`);
                }
                function isExtendedPosition(le1) {
                    return !(!le1 || Array.isArray(le1)) && [
                        [
                            "textureX",
                            "textureY"
                        ],
                        [
                            "yaw",
                            "pitch"
                        ]
                    ].some((vt)=>{
                        let [bt, ls] = vt;
                        return void 0 !== le1[bt] && void 0 !== le1[ls];
                    });
                }
                function getXMPValue(le1, vt, bt) {
                    void 0 === bt && (bt = !0);
                    let ls = le1.match("<GPano:" + vt + ">(.*)</GPano:" + vt + ">");
                    if (null !== ls) {
                        const le1 = bt ? parseInt(ls[1], 10) : parseFloat(ls[1]);
                        return isNaN(le1) ? null : le1;
                    }
                    if (ls = le1.match("GPano:" + vt + '="(.*?)"'), null !== ls) {
                        const le1 = bt ? parseInt(ls[1], 10) : parseFloat(ls[1]);
                        return isNaN(le1) ? null : le1;
                    }
                    return null;
                }
                var qd = {
                    top: "0%",
                    bottom: "100%",
                    left: "0%",
                    right: "100%",
                    center: "50%"
                }, Hd = [
                    "left",
                    "center",
                    "right"
                ], Wd = [
                    "top",
                    "center",
                    "bottom"
                ], Zd = [
                    ...Hd,
                    ...Wd
                ], Yd = "center";
                function parsePoint(le1) {
                    if (!le1) return {
                        x: .5,
                        y: .5
                    };
                    if ("object" === typeof le1) return le1;
                    let vt = le1.toLocaleLowerCase().split(" ").slice(0, 2);
                    1 === vt.length && (vt = qd[vt[0]] ? [
                        vt[0],
                        Yd
                    ] : [
                        vt[0],
                        vt[0]
                    ]);
                    const bt = "left" !== vt[1] && "right" !== vt[1] && "top" !== vt[0] && "bottom" !== vt[0];
                    vt = vt.map((le1)=>qd[le1] || le1), bt || vt.reverse();
                    const ls = vt.join(" ").match(/^([0-9.]+)% ([0-9.]+)%$/);
                    return ls ? {
                        x: parseFloat(ls[1]) / 100,
                        y: parseFloat(ls[2]) / 100
                    } : {
                        x: .5,
                        y: .5
                    };
                }
                function cleanCssPosition(le1, vt) {
                    let { allowCenter: bt, cssOrder: ls } = void 0 === vt ? {
                        allowCenter: !0,
                        cssOrder: !0
                    } : vt;
                    return le1 ? ("string" === typeof le1 && (le1 = le1.split(" ")), 1 === le1.length && (le1[0] === Yd ? le1 = [
                        Yd,
                        Yd
                    ] : -1 !== Hd.indexOf(le1[0]) ? le1 = [
                        Yd,
                        le1[0]
                    ] : -1 !== Wd.indexOf(le1[0]) && (le1 = [
                        le1[0],
                        Yd
                    ])), 2 !== le1.length || -1 === Zd.indexOf(le1[0]) || -1 === Zd.indexOf(le1[1]) ? (logWarn(`Unparsable position ${le1}`), null) : bt || le1[0] !== Yd || le1[1] !== Yd ? (ls && !cssPositionIsOrdered(le1) && (le1 = [
                        le1[1],
                        le1[0]
                    ]), le1[1] === Yd && -1 !== Hd.indexOf(le1[0]) && (le1 = [
                        Yd,
                        le1[0]
                    ]), le1[0] === Yd && -1 !== Wd.indexOf(le1[1]) && (le1 = [
                        le1[1],
                        Yd
                    ]), le1) : (logWarn("Invalid position center center"), null)) : null;
                }
                function cssPositionIsOrdered(le1) {
                    return -1 !== Wd.indexOf(le1[0]) && -1 !== Hd.indexOf(le1[1]);
                }
                function parseSpeed(le1) {
                    let vt;
                    if ("string" === typeof le1) {
                        const bt = le1.toString().trim();
                        let ho = parseFloat(bt.replace(/^(-?[0-9]+(?:\.[0-9]*)?).*$/, "$1"));
                        const Dl = bt.replace(/^-?[0-9]+(?:\.[0-9]*)?(.*)$/, "$1").trim();
                        switch(Dl.match(/(pm|per minute)$/) && (ho /= 60), Dl){
                            case "dpm":
                            case "degrees per minute":
                            case "dps":
                            case "degrees per second":
                                vt = ls.cj9.degToRad(ho);
                                break;
                            case "rdpm":
                            case "radians per minute":
                            case "rdps":
                            case "radians per second":
                                vt = ho;
                                break;
                            case "rpm":
                            case "revolutions per minute":
                            case "rps":
                            case "revolutions per second":
                                vt = ho * Math.PI * 2;
                                break;
                            default:
                                throw new Gd(`Unknown speed unit "${Dl}"`);
                        }
                    } else vt = le1;
                    return vt;
                }
                function speedToDuration(le1, vt) {
                    if ("number" !== typeof le1) {
                        const bt = parseSpeed(le1);
                        return vt / Math.abs(bt) * 1e3;
                    }
                    return Math.abs(le1);
                }
                function parseAngle(le1, vt, bt) {
                    let ho;
                    if (void 0 === vt && (vt = !1), void 0 === bt && (bt = vt), "string" === typeof le1) {
                        const vt = le1.toLowerCase().trim().match(/^(-?[0-9]+(?:\.[0-9]*)?)(.*)$/);
                        if (!vt) throw new Gd(`Unknown angle "${le1}"`);
                        const bt = parseFloat(vt[1]), Dl = vt[2];
                        if (Dl) switch(Dl){
                            case "deg":
                            case "degs":
                                ho = ls.cj9.degToRad(bt);
                                break;
                            case "rad":
                            case "rads":
                                ho = bt;
                                break;
                            default:
                                throw new Gd(`Unknown angle unit "${Dl}"`);
                        }
                        else ho = bt;
                    } else {
                        if ("number" !== typeof le1 || isNaN(le1)) throw new Gd(`Unknown angle "${le1}"`);
                        ho = le1;
                    }
                    return ho = wrap(vt ? ho + Math.PI : ho, 2 * Math.PI), vt ? ls.cj9.clamp(ho - Math.PI, -Math.PI / (bt ? 2 : 1), Math.PI / (bt ? 2 : 1)) : ho;
                }
                function createTexture(le1, vt) {
                    void 0 === vt && (vt = !1);
                    const bt = new ls.gPd(le1);
                    return bt.needsUpdate = !0, bt.minFilter = vt ? ls.$_I : ls.k6q, bt.generateMipmaps = vt, bt.anisotropy = vt ? 2 : 1, bt;
                }
                var Qd = new ls.PTz;
                function applyEulerInverse(le1, vt) {
                    Qd.setFromEuler(vt).invert(), le1.applyQuaternion(Qd);
                }
                function getConfigParser(le1, vt) {
                    const parser = function(bt) {
                        const ls = clone({
                            ...le1,
                            ...bt
                        }), ho = {};
                        for (let [Dl, Fl] of Object.entries(ls)){
                            if (vt && Dl in vt) Fl = vt[Dl](Fl, {
                                rawConfig: ls,
                                defValue: le1[Dl]
                            });
                            else if (!(Dl in le1)) {
                                logWarn(`Unknown option ${Dl}`);
                                continue;
                            }
                            ho[Dl] = Fl;
                        }
                        return ho;
                    };
                    return parser.defaults = le1, parser.parsers = vt || {}, parser;
                }
                function checkStylesheet(le1, vt) {
                    "true" !== getStyleProperty(le1, `--psv-${vt}-loaded`) && console.error(`PhotoSphereViewer: stylesheet "@photo-sphere-viewer/${vt}/index.css" is not loaded`);
                }
                function checkVersion(le1, vt, bt) {
                    vt && vt !== bt && console.error(`PhotoSphereViewer: @photo-sphere-viewer/${le1} is in version ${vt} but @photo-sphere-viewer/core is in version ${bt}`);
                }
                function checkClosedShadowDom(le1) {
                    do {
                        if (le1 instanceof ShadowRoot && "closed" === le1.mode) return void console.error("PhotoSphereViewer: closed shadow DOM detected, the viewer might not work as expected");
                        le1 = le1.parentNode;
                    }while (le1);
                }
                function mergePanoData(le1, vt, bt, ls) {
                    const ho = {
                        isEquirectangular: !0,
                        fullWidth: firstNonNull(bt?.fullWidth, ls?.fullWidth),
                        fullHeight: firstNonNull(bt?.fullHeight, ls?.fullHeight),
                        croppedWidth: firstNonNull(bt?.croppedWidth, ls?.croppedWidth, le1),
                        croppedHeight: firstNonNull(bt?.croppedHeight, ls?.croppedHeight, vt),
                        croppedX: firstNonNull(bt?.croppedX, ls?.croppedX),
                        croppedY: firstNonNull(bt?.croppedY, ls?.croppedY),
                        poseHeading: firstNonNull(bt?.poseHeading, ls?.poseHeading, 0),
                        posePitch: firstNonNull(bt?.posePitch, ls?.posePitch, 0),
                        poseRoll: firstNonNull(bt?.poseRoll, ls?.poseRoll, 0),
                        initialHeading: ls?.initialHeading,
                        initialPitch: ls?.initialPitch,
                        initialFov: ls?.initialFov
                    };
                    if (ho.croppedWidth !== le1) {
                        const vt = le1 / ho.croppedWidth;
                        [
                            "fullWidth",
                            "fullHeight",
                            "croppedWidth",
                            "croppedHeight",
                            "croppedX",
                            "croppedY"
                        ].forEach((le1)=>{
                            ho[le1] && (ho[le1] = Math.round(ho[le1] * vt));
                        });
                    }
                    return ho.fullWidth || ho.fullHeight || (ho.fullWidth = Math.max(ho.croppedWidth, 2 * ho.croppedHeight), ho.fullHeight = Math.round(ho.fullWidth / 2)), ho.fullWidth || (ho.fullWidth = 2 * ho.fullHeight), ho.fullHeight || (ho.fullHeight = Math.round(ho.fullWidth / 2)), null === ho.croppedX && (ho.croppedX = Math.round((ho.fullWidth - le1) / 2)), null === ho.croppedY && (ho.croppedY = Math.round((ho.fullHeight - vt) / 2)), Math.abs(ho.fullWidth - 2 * ho.fullHeight) > 1 && (logWarn("Invalid panoData, fullWidth should be twice fullHeight"), ho.fullHeight = Math.round(ho.fullWidth / 2)), ho.croppedX + ho.croppedWidth > ho.fullWidth && (logWarn("Invalid panoData, croppedX + croppedWidth > fullWidth"), ho.croppedX = ho.fullWidth - ho.croppedWidth), ho.croppedY + ho.croppedHeight > ho.fullHeight && (logWarn("Invalid panoData, croppedY + croppedHeight > fullHeight"), ho.croppedY = ho.fullHeight - ho.croppedHeight), ho.croppedX < 0 && (logWarn("Invalid panoData, croppedX < 0"), ho.croppedX = 0), ho.croppedY < 0 && (logWarn("Invalid panoData, croppedY < 0"), ho.croppedY = 0), ho;
                }
                var Xd = class {
                    constructor(le1){
                        this.easing = jd.linear, this.callbacks = [], this.resolved = !1, this.cancelled = !1, this.options = le1, le1 ? (le1.easing && (this.easing = "function" === typeof le1.easing ? le1.easing : jd[le1.easing] || jd.linear), this.delayTimeout = setTimeout(()=>{
                            this.delayTimeout = void 0, this.animationFrame = window.requestAnimationFrame((le1)=>this.__run(le1));
                        }, le1.delay || 0)) : this.resolved = !0;
                    }
                    __run(le1) {
                        if (this.cancelled) return;
                        this.start || (this.start = le1);
                        const vt = (le1 - this.start) / this.options.duration, bt = {};
                        if (vt < 1) {
                            for (const [le1, ls] of Object.entries(this.options.properties))if (ls) {
                                const ho = ls.start + (ls.end - ls.start) * this.easing(vt);
                                bt[le1] = ho;
                            }
                            this.options.onTick(bt, vt), this.animationFrame = window.requestAnimationFrame((le1)=>this.__run(le1));
                        } else {
                            for (const [le1, vt] of Object.entries(this.options.properties))vt && (bt[le1] = vt.end);
                            this.options.onTick(bt, 1), this.__resolve(!0), this.animationFrame = void 0;
                        }
                    }
                    __resolve(le1) {
                        le1 ? this.resolved = !0 : this.cancelled = !0, this.callbacks.forEach((vt)=>vt(le1)), this.callbacks.length = 0;
                    }
                    then(le1) {
                        return this.resolved || this.cancelled ? Promise.resolve(this.resolved).then(le1) : new Promise((le1)=>{
                            this.callbacks.push(le1);
                        }).then(le1);
                    }
                    cancel() {
                        this.cancelled || this.resolved || (this.__resolve(!1), this.delayTimeout && (window.clearTimeout(this.delayTimeout), this.delayTimeout = void 0), this.animationFrame && (window.cancelAnimationFrame(this.animationFrame), this.animationFrame = void 0));
                    }
                }, Kd = class {
                    constructor(le1, vt){
                        if (this.fn = le1, this.mode = 0, this.speed = 0, this.speedMult = 0, this.currentSpeed = 0, this.target = 0, this.__current = 0, this.min = vt.min, this.max = vt.max, this.wrap = vt.wrap, this.current = vt.defaultValue, this.wrap && 0 !== this.min) throw new Gd("invalid config");
                        this.fn && this.fn(this.current);
                    }
                    get current() {
                        return this.__current;
                    }
                    set current(le1) {
                        this.__current = le1;
                    }
                    setSpeed(le1) {
                        this.speed = le1;
                    }
                    goto(le1, vt) {
                        void 0 === vt && (vt = 1), this.mode = 2, this.target = this.wrap ? wrap(le1, this.max) : ls.cj9.clamp(le1, this.min, this.max), this.speedMult = vt;
                    }
                    step(le1, vt) {
                        void 0 === vt && (vt = 1), 0 === vt ? this.setValue(this.current + le1) : (2 !== this.mode && (this.target = this.current), this.goto(this.target + le1, vt));
                    }
                    roll(le1, vt) {
                        void 0 === le1 && (le1 = !1), void 0 === vt && (vt = 1), this.mode = 1, this.target = le1 ? -1 / 0 : 1 / 0, this.speedMult = vt;
                    }
                    stop() {
                        this.mode = 0;
                    }
                    setValue(le1) {
                        return this.target = this.wrap ? wrap(le1, this.max) : ls.cj9.clamp(le1, this.min, this.max), this.mode = 0, this.currentSpeed = 0, this.target !== this.current && (this.current = this.target, this.fn && this.fn(this.current), !0);
                    }
                    update(le1) {
                        if (2 === this.mode) {
                            this.wrap && Math.abs(this.target - this.current) > this.max / 2 && (this.current = this.current < this.target ? this.current + this.max : this.current - this.max);
                            const le1 = this.currentSpeed * this.currentSpeed / (this.speed * this.speedMult * 4);
                            Math.abs(this.target - this.current) <= le1 && (this.mode = 0);
                        }
                        let vt = 0 === this.mode ? 0 : this.speed * this.speedMult;
                        this.target < this.current && (vt = -vt), this.currentSpeed < vt ? this.currentSpeed = Math.min(vt, this.currentSpeed + le1 / 1e3 * this.speed * this.speedMult * 2) : this.currentSpeed > vt && (this.currentSpeed = Math.max(vt, this.currentSpeed - le1 / 1e3 * this.speed * this.speedMult * 2));
                        let bt = null;
                        return this.current > this.target && this.currentSpeed ? bt = Math.max(this.target, this.current + this.currentSpeed * le1 / 1e3) : this.current < this.target && this.currentSpeed && (bt = Math.min(this.target, this.current + this.currentSpeed * le1 / 1e3)), null !== bt && (bt = this.wrap ? wrap(bt, this.max) : ls.cj9.clamp(bt, this.min, this.max), bt !== this.current) && (this.current = bt, this.fn && this.fn(this.current), !0);
                    }
                }, Jd = class {
                    constructor(le1, vt){
                        this.fn = le1, this.dynamics = vt, this.fn && this.fn(this.current);
                    }
                    get current() {
                        return Object.entries(this.dynamics).reduce((le1, vt)=>{
                            let [bt, ls] = vt;
                            return le1[bt] = ls.current, le1;
                        }, {});
                    }
                    setSpeed(le1) {
                        for (const vt of Object.values(this.dynamics))vt.setSpeed(le1);
                    }
                    goto(le1, vt) {
                        void 0 === vt && (vt = 1);
                        for (const [bt, ls] of Object.entries(le1))this.dynamics[bt].goto(ls, vt);
                    }
                    step(le1, vt) {
                        if (void 0 === vt && (vt = 1), 0 === vt) this.setValue(Object.keys(le1).reduce((vt, bt)=>(vt[bt] = le1[bt] + this.dynamics[bt].current, vt), {}));
                        else for (const [bt, ls] of Object.entries(le1))this.dynamics[bt].step(ls, vt);
                    }
                    roll(le1, vt) {
                        void 0 === vt && (vt = 1);
                        for (const [bt, ls] of Object.entries(le1))this.dynamics[bt].roll(ls, vt);
                    }
                    stop() {
                        for (const le1 of Object.values(this.dynamics))le1.stop();
                    }
                    setValue(le1) {
                        let vt = !1;
                        for (const [bt, ls] of Object.entries(le1))vt = this.dynamics[bt].setValue(ls) || vt;
                        return vt && this.fn && this.fn(this.current), vt;
                    }
                    update(le1) {
                        let vt = !1;
                        for (const bt of Object.values(this.dynamics))vt = bt.update(le1) || vt;
                        return vt && this.fn && this.fn(this.current), vt;
                    }
                }, $d = class {
                    constructor(le1){
                        void 0 === le1 && (le1 = 200), this.delay = le1, this.time = 0, this.delay = le1;
                    }
                    get pending() {
                        return 0 !== this.time;
                    }
                    down(le1) {
                        this.timeout && (clearTimeout(this.timeout), this.timeout = void 0), this.time = (new Date).getTime(), this.data = le1;
                    }
                    up(le1) {
                        if (!this.time) return;
                        Date.now() - this.time < this.delay ? this.timeout = setTimeout(()=>{
                            le1(this.data), this.timeout = void 0, this.time = 0, this.data = void 0;
                        }, this.delay) : (le1(this.data), this.time = 0, this.data = void 0);
                    }
                }, sp = ((le1)=>(le1.VERTICAL = "VERTICAL", le1.HORIZONTAL = "HORIZONTAL", le1))(sp || {}), em = class {
                    constructor(le1, vt, bt){
                        this.container = le1, this.direction = vt, this.listener = bt, this.mousedown = !1, this.mouseover = !1, this.container.addEventListener("click", this), this.container.addEventListener("mousedown", this), this.container.addEventListener("mouseenter", this), this.container.addEventListener("mouseleave", this), this.container.addEventListener("touchstart", this), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("touchmove", this, !0), window.addEventListener("mouseup", this), window.addEventListener("touchend", this);
                    }
                    get isVertical() {
                        return "VERTICAL" === this.direction;
                    }
                    get isHorizontal() {
                        return "HORIZONTAL" === this.direction;
                    }
                    destroy() {
                        window.removeEventListener("mouseup", this), window.removeEventListener("touchend", this);
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case "click":
                                le1.stopPropagation();
                                break;
                            case "mousedown":
                                this.__onMouseDown(le1);
                                break;
                            case "mouseenter":
                                this.__onMouseEnter(le1);
                                break;
                            case "mouseleave":
                                this.__onMouseLeave(le1);
                                break;
                            case "touchstart":
                                this.__onTouchStart(le1);
                                break;
                            case "mousemove":
                                this.__onMouseMove(le1);
                                break;
                            case "touchmove":
                                this.__onTouchMove(le1);
                                break;
                            case "mouseup":
                                this.__onMouseUp(le1);
                                break;
                            case "touchend":
                                this.__onTouchEnd(le1);
                        }
                    }
                    __onMouseDown(le1) {
                        this.mousedown = !0, this.__update(le1.clientX, le1.clientY, !0);
                    }
                    __onMouseEnter(le1) {
                        this.mouseover = !0, this.__update(le1.clientX, le1.clientY, !0);
                    }
                    __onTouchStart(le1) {
                        this.mouseover = !0, this.mousedown = !0;
                        const vt = le1.changedTouches[0];
                        this.__update(vt.clientX, vt.clientY, !0);
                    }
                    __onMouseMove(le1) {
                        (this.mousedown || this.mouseover) && (le1.stopPropagation(), this.__update(le1.clientX, le1.clientY, !0));
                    }
                    __onTouchMove(le1) {
                        if (this.mousedown || this.mouseover) {
                            le1.stopPropagation();
                            const vt = le1.changedTouches[0];
                            this.__update(vt.clientX, vt.clientY, !0);
                        }
                    }
                    __onMouseUp(le1) {
                        this.mousedown && (this.mousedown = !1, this.__update(le1.clientX, le1.clientY, !1));
                    }
                    __onMouseLeave(le1) {
                        this.mouseover && (this.mouseover = !1, this.__update(le1.clientX, le1.clientY, !0));
                    }
                    __onTouchEnd(le1) {
                        if (this.mousedown) {
                            this.mouseover = !1, this.mousedown = !1;
                            const vt = le1.changedTouches[0];
                            this.__update(vt.clientX, vt.clientY, !1);
                        }
                    }
                    __update(le1, vt, bt) {
                        const ho = this.container.getBoundingClientRect();
                        let Dl;
                        Dl = this.isVertical ? ls.cj9.clamp((ho.bottom - vt) / ho.height, 0, 1) : ls.cj9.clamp((le1 - ho.left) / ho.width, 0, 1), this.listener({
                            value: Dl,
                            click: !bt,
                            mousedown: this.mousedown,
                            mouseover: this.mouseover,
                            cursor: {
                                clientX: le1,
                                clientY: vt
                            }
                        });
                    }
                }, tm = {};
                __export(tm, {
                    BeforeAnimateEvent: ()=>sm,
                    BeforeRenderEvent: ()=>lm,
                    BeforeRotateEvent: ()=>um,
                    ClickEvent: ()=>dm,
                    ConfigChangedEvent: ()=>mm,
                    DoubleClickEvent: ()=>gm,
                    FullscreenEvent: ()=>_m,
                    HideNotificationEvent: ()=>vm,
                    HideOverlayEvent: ()=>bm,
                    HidePanelEvent: ()=>Em,
                    HideTooltipEvent: ()=>Sm,
                    KeypressEvent: ()=>km,
                    LoadProgressEvent: ()=>Im,
                    ObjectEnterEvent: ()=>cg,
                    ObjectEvent: ()=>og,
                    ObjectHoverEvent: ()=>pg,
                    ObjectLeaveEvent: ()=>hg,
                    PanoramaErrorEvent: ()=>Rm,
                    PanoramaLoadEvent: ()=>Lm,
                    PanoramaLoadedEvent: ()=>zm,
                    PositionUpdatedEvent: ()=>jm,
                    ReadyEvent: ()=>qm,
                    RenderEvent: ()=>Wm,
                    RollUpdatedEvent: ()=>Vm,
                    ShowNotificationEvent: ()=>Ym,
                    ShowOverlayEvent: ()=>Xm,
                    ShowPanelEvent: ()=>Jm,
                    ShowTooltipEvent: ()=>eg,
                    SizeUpdatedEvent: ()=>ig,
                    StopAllEvent: ()=>rg,
                    TransitionDoneEvent: ()=>Om,
                    ViewerEvent: ()=>rm,
                    ZoomUpdatedEvent: ()=>sg
                });
                var im = class extends Event {
                    constructor(le1, vt){
                        void 0 === vt && (vt = !1), super(le1, {
                            cancelable: vt
                        });
                    }
                }, nm = class extends EventTarget {
                    dispatchEvent(le1) {
                        return super.dispatchEvent(le1);
                    }
                    addEventListener(le1, vt, bt) {
                        super.addEventListener(le1, vt, bt);
                    }
                    removeEventListener(le1, vt, bt) {
                        super.removeEventListener(le1, vt, bt);
                    }
                }, rm = class extends im {
                }, am = class _BeforeAnimateEvent extends rm {
                    constructor(le1, vt){
                        super(_BeforeAnimateEvent.type, !0), this.position = le1, this.zoomLevel = vt;
                    }
                };
                am.type = "before-animate";
                var sm = am, om = class _BeforeRenderEvent extends rm {
                    constructor(le1, vt){
                        super(_BeforeRenderEvent.type), this.timestamp = le1, this.elapsed = vt;
                    }
                };
                om.type = "before-render";
                var lm = om, cm = class _BeforeRotateEvent extends rm {
                    constructor(le1){
                        super(_BeforeRotateEvent.type, !0), this.position = le1;
                    }
                };
                cm.type = "before-rotate";
                var um = cm, hm = class _ClickEvent extends rm {
                    constructor(le1){
                        super(_ClickEvent.type), this.data = le1;
                    }
                };
                hm.type = "click";
                var dm = hm, pm = class _ConfigChangedEvent extends rm {
                    constructor(le1){
                        super(_ConfigChangedEvent.type), this.options = le1;
                    }
                    containsOptions() {
                        for(var le1 = arguments.length, vt = new Array(le1), bt = 0; bt < le1; bt++)vt[bt] = arguments[bt];
                        return vt.some((le1)=>this.options.includes(le1));
                    }
                };
                pm.type = "config-changed";
                var mm = pm, fm = class _DoubleClickEvent extends rm {
                    constructor(le1){
                        super(_DoubleClickEvent.type), this.data = le1;
                    }
                };
                fm.type = "dblclick";
                var gm = fm, Am = class _FullscreenEvent extends rm {
                    constructor(le1){
                        super(_FullscreenEvent.type), this.fullscreenEnabled = le1;
                    }
                };
                Am.type = "fullscreen";
                var _m = Am, ym = class _HideNotificationEvent extends rm {
                    constructor(le1){
                        super(_HideNotificationEvent.type), this.notificationId = le1;
                    }
                };
                ym.type = "hide-notification";
                var vm = ym, xm = class _HideOverlayEvent extends rm {
                    constructor(le1){
                        super(_HideOverlayEvent.type), this.overlayId = le1;
                    }
                };
                xm.type = "hide-overlay";
                var bm = xm, wm = class _HidePanelEvent extends rm {
                    constructor(le1){
                        super(_HidePanelEvent.type), this.panelId = le1;
                    }
                };
                wm.type = "hide-panel";
                var Em = wm, Mm = class _HideTooltipEvent extends rm {
                    constructor(le1){
                        super(_HideTooltipEvent.type), this.tooltipData = le1;
                    }
                };
                Mm.type = "hide-tooltip";
                var Sm = Mm, Tm = class _KeypressEvent extends rm {
                    constructor(le1, vt){
                        super(_KeypressEvent.type, !0), this.key = le1, this.originalEvent = vt;
                    }
                    matches(le1) {
                        return keyPressMatch(this.originalEvent, le1);
                    }
                };
                Tm.type = "key-press";
                var km = Tm, Cm = class _LoadProgressEvent extends rm {
                    constructor(le1){
                        super(_LoadProgressEvent.type), this.progress = le1;
                    }
                };
                Cm.type = "load-progress";
                var Im = Cm, Dm = class _PanoramaLoadEvent extends rm {
                    constructor(le1){
                        super(_PanoramaLoadEvent.type), this.panorama = le1;
                    }
                };
                Dm.type = "panorama-load";
                var Lm = Dm, Pm = class _PanoramaLoadedEvent extends rm {
                    constructor(le1){
                        super(_PanoramaLoadedEvent.type), this.data = le1;
                    }
                };
                Pm.type = "panorama-loaded";
                var zm = Pm, Nm = class _PanoramaErrorEvent extends rm {
                    constructor(le1, vt){
                        super(_PanoramaErrorEvent.type), this.panorama = le1, this.error = vt;
                    }
                };
                Nm.type = "panorama-error";
                var Rm = Nm, Fm = class _TransitionDoneEvent extends rm {
                    constructor(le1){
                        super(_TransitionDoneEvent.type), this.completed = le1;
                    }
                };
                Fm.type = "transition-done";
                var Om = Fm, Bm = class _PositionUpdatedEvent extends rm {
                    constructor(le1){
                        super(_PositionUpdatedEvent.type), this.position = le1;
                    }
                };
                Bm.type = "position-updated";
                var jm = Bm, Um = class _RollUpdatedEvent extends rm {
                    constructor(le1){
                        super(_RollUpdatedEvent.type), this.roll = le1;
                    }
                };
                Um.type = "roll-updated";
                var Vm = Um, Gm = class _ReadyEvent extends rm {
                    constructor(){
                        super(_ReadyEvent.type);
                    }
                };
                Gm.type = "ready";
                var qm = Gm, Hm = class _RenderEvent extends rm {
                    constructor(){
                        super(_RenderEvent.type);
                    }
                };
                Hm.type = "render";
                var Wm = Hm, Zm = class _ShowNotificationEvent extends rm {
                    constructor(le1){
                        super(_ShowNotificationEvent.type), this.notificationId = le1;
                    }
                };
                Zm.type = "show-notification";
                var Ym = Zm, Qm = class _ShowOverlayEvent extends rm {
                    constructor(le1){
                        super(_ShowOverlayEvent.type), this.overlayId = le1;
                    }
                };
                Qm.type = "show-overlay";
                var Xm = Qm, Km = class _ShowPanelEvent extends rm {
                    constructor(le1){
                        super(_ShowPanelEvent.type), this.panelId = le1;
                    }
                };
                Km.type = "show-panel";
                var Jm = Km, $m = class _ShowTooltipEvent extends rm {
                    constructor(le1, vt){
                        super(_ShowTooltipEvent.type), this.tooltip = le1, this.tooltipData = vt;
                    }
                };
                $m.type = "show-tooltip";
                var eg = $m, tg = class _SizeUpdatedEvent extends rm {
                    constructor(le1){
                        super(_SizeUpdatedEvent.type), this.size = le1;
                    }
                };
                tg.type = "size-updated";
                var ig = tg, ng = class _StopAllEvent extends rm {
                    constructor(){
                        super(_StopAllEvent.type);
                    }
                };
                ng.type = "stop-all";
                var rg = ng, ag = class _ZoomUpdatedEvent extends rm {
                    constructor(le1){
                        super(_ZoomUpdatedEvent.type), this.zoomLevel = le1;
                    }
                };
                ag.type = "zoom-updated";
                var sg = ag, og = class extends rm {
                    constructor(le1, vt, bt, ls, ho){
                        super(le1), this.originalEvent = vt, this.object = bt, this.viewerPoint = ls, this.userDataKey = ho;
                    }
                }, lg = class _ObjectEnterEvent extends og {
                    constructor(le1, vt, bt, ls){
                        super(_ObjectEnterEvent.type, le1, vt, bt, ls);
                    }
                };
                lg.type = "enter-object";
                var cg = lg, ug = class _ObjectLeaveEvent extends og {
                    constructor(le1, vt, bt, ls){
                        super(_ObjectLeaveEvent.type, le1, vt, bt, ls);
                    }
                };
                ug.type = "leave-object";
                var hg = ug, dg = class _ObjectHoverEvent extends og {
                    constructor(le1, vt, bt, ls){
                        super(_ObjectHoverEvent.type, le1, vt, bt, ls);
                    }
                };
                dg.type = "hover-object";
                var pg = dg, mg = class {
                    constructor(le1){
                        this.viewer = le1;
                    }
                    init() {}
                    destroy() {}
                    supportsTransition(le1) {
                        return !1;
                    }
                    supportsPreload(le1) {
                        return !1;
                    }
                    textureCoordsToSphericalCoords(le1, vt) {
                        throw new Gd("Current adapter does not support texture coordinates.");
                    }
                    sphericalCoordsToTextureCoords(le1, vt) {
                        throw new Gd("Current adapter does not support texture coordinates.");
                    }
                };
                function adapterInterop(le1) {
                    if (le1) {
                        for (const [, vt] of [
                            [
                                "_",
                                le1
                            ],
                            ...Object.entries(le1)
                        ])if (vt.prototype instanceof mg) return checkVersion(vt.id, vt.VERSION, "5.14.1"), vt;
                    }
                    return null;
                }
                mg.supportsDownload = !1;
                var fg = `${_u}_touchSupport`, gg = {
                    loaded: !1,
                    pixelRatio: 1,
                    isWebGLSupported: !1,
                    maxTextureWidth: 0,
                    isTouchEnabled: null,
                    __maxCanvasWidth: null,
                    isIphone: !1,
                    get maxCanvasWidth () {
                        return null === this.__maxCanvasWidth && (this.__maxCanvasWidth = function(le1) {
                            let vt = le1, bt = !1;
                            const ls = document.createElement("canvas"), ho = ls.getContext("2d");
                            ls.width = 1, ls.height = 1;
                            for(; vt > 1024 && !bt;){
                                const le1 = document.createElement("canvas"), ls = le1.getContext("2d");
                                le1.width = vt, le1.height = vt / 2;
                                try {
                                    ls.fillStyle = "white", ls.fillRect(vt - 1, vt / 2 - 1, 1, 1), ho.drawImage(le1, vt - 1, vt / 2 - 1, 1, 1, 0, 0, 1, 1), ho.getImageData(0, 0, 1, 1).data[0] > 0 && (bt = !0);
                                } catch  {}
                                le1.width = 0, le1.height = 0, bt || (vt /= 2);
                            }
                            if (bt) return vt;
                            throw new Gd("Unable to detect system capabilities");
                        }(this.maxTextureWidth)), this.__maxCanvasWidth;
                    },
                    load () {
                        if (!this.loaded) {
                            const le1 = function() {
                                try {
                                    return document.createElement("canvas").getContext("webgl2");
                                } catch  {
                                    return null;
                                }
                            }();
                            this.pixelRatio = window.devicePixelRatio || 1, this.isWebGLSupported = !!le1, this.maxTextureWidth = le1 ? le1.getParameter(le1.MAX_TEXTURE_SIZE) : 0, this.isTouchEnabled = function() {
                                let le1 = "ontouchstart" in window || navigator.maxTouchPoints > 0;
                                fg in localStorage && (le1 = "true" === localStorage[fg]);
                                const vt = new Promise((vt)=>{
                                    const clear = ()=>{
                                        window.removeEventListener("mousedown", listenerMouse), window.removeEventListener("touchstart", listenerTouch), clearTimeout(bt);
                                    }, listenerMouse = ()=>{
                                        clear(), localStorage[fg] = !1, vt(!1);
                                    }, listenerTouch = ()=>{
                                        clear(), localStorage[fg] = !0, vt(!0);
                                    }, listenerTimeout = ()=>{
                                        clear(), localStorage[fg] = le1, vt(le1);
                                    };
                                    window.addEventListener("mousedown", listenerMouse, !1), window.addEventListener("touchstart", listenerTouch, !1);
                                    const bt = setTimeout(listenerTimeout, 1e4);
                                });
                                return {
                                    initial: le1,
                                    promise: vt
                                };
                            }(), this.isIphone = /iPhone/i.test(navigator.userAgent), this.loaded = !0;
                        }
                        if (!gg.isWebGLSupported) throw new Gd("WebGL 2 is not supported.");
                        if (0 === gg.maxTextureWidth) throw new Gd("Unable to detect system capabilities");
                    }
                };
                var Ag = getConfigParser({
                    resolution: 64,
                    useXmpData: !0,
                    blur: !1
                }, {
                    resolution: (le1)=>{
                        if (!le1 || !ls.cj9.isPowerOfTwo(le1)) throw new Gd("EquirectangularAdapter resolution must be power of two.");
                        return le1;
                    }
                }), _g = class _EquirectangularAdapter extends mg {
                    static withConfig(le1) {
                        return [
                            _EquirectangularAdapter,
                            le1
                        ];
                    }
                    constructor(le1, vt){
                        super(le1), this.config = Ag(vt), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2;
                    }
                    supportsTransition() {
                        return !0;
                    }
                    supportsPreload() {
                        return !0;
                    }
                    textureCoordsToSphericalCoords(le1, vt) {
                        if (isNil(le1.textureX) || isNil(le1.textureY)) throw new Gd("Texture position is missing 'textureX' or 'textureY'");
                        const bt = (le1.textureX + vt.croppedX) / vt.fullWidth * Math.PI * 2, ls = (le1.textureY + vt.croppedY) / vt.fullHeight * Math.PI;
                        return {
                            yaw: bt >= Math.PI ? bt - Math.PI : bt + Math.PI,
                            pitch: Math.PI / 2 - ls
                        };
                    }
                    sphericalCoordsToTextureCoords(le1, vt) {
                        const bt = le1.yaw / Math.PI / 2 * vt.fullWidth, ls = le1.pitch / Math.PI * vt.fullHeight;
                        let ho = Math.round(le1.yaw < Math.PI ? bt + vt.fullWidth / 2 : bt - vt.fullWidth / 2) - vt.croppedX, Dl = Math.round(vt.fullHeight / 2 - ls) - vt.croppedY;
                        return (ho < 0 || ho > vt.croppedWidth || Dl < 0 || Dl > vt.croppedHeight) && (ho = Dl = void 0), {
                            textureX: ho,
                            textureY: Dl
                        };
                    }
                    async loadTexture(le1, vt, bt, ls) {
                        if (void 0 === vt && (vt = !0), void 0 === ls && (ls = this.config.useXmpData), "string" !== typeof le1 && ("object" !== typeof le1 || !le1.path)) return Promise.reject(new Gd("Invalid panorama url, are you using the right adapter?"));
                        let ho;
                        ho = "string" === typeof le1 ? {
                            path: le1,
                            data: bt
                        } : {
                            data: bt,
                            ...le1
                        };
                        const Dl = await this.viewer.textureLoader.loadFile(ho.path, vt ? (le1)=>this.viewer.textureLoader.dispatchProgress(le1) : null, ho.path), Fl = ls ? await this.loadXMP(Dl) : null, sc = await this.viewer.textureLoader.blobToImage(Dl);
                        "function" === typeof ho.data && (ho.data = ho.data(sc, Fl));
                        const uc = mergePanoData(sc.width, sc.height, ho.data, Fl);
                        return {
                            panorama: le1,
                            texture: this.createEquirectangularTexture(sc),
                            panoData: uc,
                            cacheKey: ho.path
                        };
                    }
                    async loadXMP(le1) {
                        const vt = await this.loadBlobAsString(le1), bt = vt.indexOf("<x:xmpmeta");
                        if (-1 === bt) return null;
                        const ls = vt.indexOf("</x:xmpmeta>", bt);
                        if (-1 === ls) return null;
                        const ho = vt.substring(bt, ls);
                        return ho.includes("GPano:") ? {
                            fullWidth: getXMPValue(ho, "FullPanoWidthPixels"),
                            fullHeight: getXMPValue(ho, "FullPanoHeightPixels"),
                            croppedWidth: getXMPValue(ho, "CroppedAreaImageWidthPixels"),
                            croppedHeight: getXMPValue(ho, "CroppedAreaImageHeightPixels"),
                            croppedX: getXMPValue(ho, "CroppedAreaLeftPixels"),
                            croppedY: getXMPValue(ho, "CroppedAreaTopPixels"),
                            poseHeading: getXMPValue(ho, "PoseHeadingDegrees", !1),
                            posePitch: getXMPValue(ho, "PosePitchDegrees", !1),
                            poseRoll: getXMPValue(ho, "PoseRollDegrees", !1),
                            initialHeading: getXMPValue(ho, "InitialViewHeadingDegrees", !1),
                            initialPitch: getXMPValue(ho, "InitialViewPitchDegrees", !1),
                            initialFov: getXMPValue(ho, "InitialHorizontalFOVDegrees", !1)
                        } : null;
                    }
                    loadBlobAsString(le1) {
                        return new Promise((vt, bt)=>{
                            const ls = new FileReader;
                            ls.onload = ()=>vt(ls.result), ls.onerror = bt, ls.readAsText(le1);
                        });
                    }
                    createEquirectangularTexture(le1) {
                        if (this.config.blur || le1.width > gg.maxTextureWidth) {
                            const vt = Math.min(1, gg.maxCanvasWidth / le1.width), bt = new OffscreenCanvas(Math.floor(le1.width * vt), Math.floor(le1.height * vt)), ls = bt.getContext("2d");
                            return this.config.blur && (ls.filter = `blur(${bt.width / 2048}px)`), ls.drawImage(le1, 0, 0, bt.width, bt.height), createTexture(bt);
                        }
                        return createTexture(le1);
                    }
                    createMesh(le1) {
                        const vt = le1.croppedX / le1.fullWidth * 2 * Math.PI, bt = le1.croppedWidth / le1.fullWidth * 2 * Math.PI, ho = le1.croppedY / le1.fullHeight * Math.PI, Dl = le1.croppedHeight / le1.fullHeight * Math.PI, Fl = new ls.Gu$(du, Math.round(this.SPHERE_SEGMENTS / (2 * Math.PI) * bt), Math.round(this.SPHERE_HORIZONTAL_SEGMENTS / Math.PI * Dl), -Math.PI / 2 + vt, bt, ho, Dl).scale(-1, 1, 1), sc = new ls.V9B({
                            depthTest: !1,
                            depthWrite: !1
                        });
                        return new ls.eaF(Fl, sc);
                    }
                    setTexture(le1, vt) {
                        le1.material.map = vt.texture;
                    }
                    setTextureOpacity(le1, vt) {
                        le1.material.opacity = vt, le1.material.transparent = vt < 1;
                    }
                    disposeTexture(le1) {
                        let { texture: vt } = le1;
                        vt.dispose();
                    }
                    disposeMesh(le1) {
                        le1.geometry.dispose(), le1.material.dispose();
                    }
                };
                _g.id = "equirectangular", _g.VERSION = "5.14.1", _g.supportsDownload = !0;
                var yg = _g, vg = class _DualFisheyeAdapter extends yg {
                    static withConfig(le1) {
                        return [
                            _DualFisheyeAdapter,
                            le1
                        ];
                    }
                    constructor(le1, vt){
                        super(le1, {
                            resolution: vt?.resolution ?? 64,
                            useXmpData: !1
                        });
                    }
                    async loadTexture(le1, vt) {
                        const bt = await super.loadTexture(le1, vt, null, !1);
                        return bt.panoData = null, bt;
                    }
                    createMesh() {
                        const le1 = new ls.Gu$(du, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS).scale(-1, 1, 1).toNonIndexed(), vt = le1.getAttribute("uv"), bt = le1.getAttribute("normal");
                        for(let ls = 0; ls < vt.count; ls++)for(let le1 = 0; le1 < 3; le1++){
                            const ho = 3 * ls + le1, Dl = bt.getX(ho), Fl = bt.getY(ho), sc = bt.getZ(ho), uc = .947;
                            if (ls < vt.count / 6) {
                                const le1 = 0 === Dl && 0 === sc ? 1 : Math.acos(Fl) / Math.sqrt(Dl * Dl + sc * sc) * (2 / Math.PI);
                                vt.setXY(ho, Dl * (uc / 4) * le1 + 1 / 4, sc * (uc / 2) * le1 + .5);
                            } else {
                                const le1 = 0 === Dl && 0 === sc ? 1 : Math.acos(-Fl) / Math.sqrt(Dl * Dl + sc * sc) * (2 / Math.PI);
                                vt.setXY(ho, uc / 4 * -Dl * le1 + 3 / 4, sc * (uc / 2) * le1 + .5);
                            }
                        }
                        le1.rotateX(-Math.PI / 2), le1.rotateY(Math.PI);
                        const ho = new ls.V9B({
                            depthTest: !1,
                            depthWrite: !1
                        });
                        return new ls.eaF(le1, ho);
                    }
                };
                vg.id = "dual-fisheye", vg.VERSION = "5.14.1";
                var xg = class _AbstractComponent {
                    constructor(le1, vt){
                        this.parent = le1, this.children = [], this.state = {
                            visible: !0
                        }, this.viewer = le1 instanceof _AbstractComponent ? le1.viewer : le1, this.container = document.createElement(vt.tagName ?? "div"), this.container.className = vt.className || "", this.parent.children.push(this), this.parent.container.appendChild(this.container);
                    }
                    destroy() {
                        this.parent.container.removeChild(this.container);
                        const le1 = this.parent.children.indexOf(this);
                        -1 !== le1 && this.parent.children.splice(le1, 1), this.children.slice().forEach((le1)=>le1.destroy()), this.children.length = 0;
                    }
                    toggle(le1) {
                        void 0 === le1 && (le1 = !this.isVisible()), le1 ? this.show() : this.hide();
                    }
                    hide(le1) {
                        this.container.style.display = "none", this.state.visible = !1;
                    }
                    show(le1) {
                        this.container.style.display = "", this.state.visible = !0;
                    }
                    isVisible() {
                        return this.state.visible;
                    }
                }, bg = getConfigParser({
                    id: null,
                    tagName: null,
                    className: null,
                    title: null,
                    hoverScale: !1,
                    collapsable: !1,
                    tabbable: !0,
                    icon: null,
                    iconActive: null
                }), wg = class extends xg {
                    constructor(le1, vt){
                        super(le1, {
                            tagName: vt.tagName,
                            className: `psv-button ${vt.hoverScale ? "psv-button--hover-scale" : ""} ${vt.className || ""}`
                        }), this.state = {
                            visible: !0,
                            enabled: !0,
                            supported: !0,
                            collapsed: !1,
                            active: !1,
                            width: 0
                        }, this.config = bg(vt), vt.id || (this.config.id = this.constructor.id), vt.icon && this.__setIcon(vt.icon), this.state.width = this.container.offsetWidth, this.config.title ? this.container.title = this.viewer.config.lang[this.config.title] ?? this.config.title : this.id && this.id in this.viewer.config.lang && (this.container.title = this.viewer.config.lang[this.id]), vt.tabbable && (this.container.tabIndex = 0), this.container.addEventListener("click", (le1)=>{
                            this.state.enabled && this.onClick(), le1.stopPropagation();
                        }), this.container.addEventListener("keydown", (le1)=>{
                            le1.key === Rd.Enter && this.state.enabled && (this.onClick(), le1.stopPropagation());
                        });
                    }
                    get id() {
                        return this.config.id;
                    }
                    get title() {
                        return this.container.title;
                    }
                    get content() {
                        return this.container.innerHTML;
                    }
                    get width() {
                        return this.state.width;
                    }
                    get collapsable() {
                        return this.config.collapsable;
                    }
                    show(le1) {
                        void 0 === le1 && (le1 = !0), this.isVisible() || (this.state.visible = !0, this.state.collapsed || (this.container.style.display = ""), le1 && this.viewer.navbar.autoSize());
                    }
                    hide(le1) {
                        void 0 === le1 && (le1 = !0), this.isVisible() && (this.state.visible = !1, this.container.style.display = "none", le1 && this.viewer.navbar.autoSize());
                    }
                    checkSupported() {
                        resolveBoolean(this.isSupported(), (le1, vt)=>{
                            this.state && (this.state.supported = le1, vt ? le1 || this.hide() : this.toggle(le1));
                        });
                    }
                    autoSize() {}
                    isSupported() {
                        return !0;
                    }
                    toggleActive(le1) {
                        void 0 === le1 && (le1 = !this.state.active), le1 !== this.state.active && (this.state.active = le1, toggleClass(this.container, "psv-button--active", this.state.active), this.config.iconActive && this.__setIcon(this.state.active ? this.config.iconActive : this.config.icon));
                    }
                    disable() {
                        this.container.classList.add("psv-button--disabled"), this.state.enabled = !1;
                    }
                    enable() {
                        this.container.classList.remove("psv-button--disabled"), this.state.enabled = !0;
                    }
                    collapse() {
                        this.state.collapsed = !0, this.container.style.display = "none";
                    }
                    uncollapse() {
                        this.state.collapsed = !1, this.state.visible && (this.container.style.display = "");
                    }
                    __setIcon(le1) {
                        this.container.innerHTML = le1, addClasses(this.container.querySelector("svg"), "psv-button-svg");
                    }
                }, Eg = class extends wg {
                    constructor(le1, vt){
                        super(le1, {
                            id: vt.id ?? `psvButton-${Math.random().toString(36).substring(2)}`,
                            className: `psv-custom-button ${vt.className || ""}`,
                            hoverScale: !1,
                            collapsable: !1 !== vt.collapsable,
                            tabbable: !1 !== vt.tabbable,
                            title: vt.title
                        }), this.customOnClick = vt.onClick, vt.content && ("string" === typeof vt.content ? this.container.innerHTML = vt.content : (this.container.classList.add("psv-custom-button--no-padding"), vt.content.style.height = "100%", vt.content.attachViewer?.(this.viewer), this.container.appendChild(vt.content))), this.state.width = this.container.offsetWidth, vt.disabled && this.disable(), !1 === vt.visible && this.hide();
                    }
                    onClick() {
                        this.customOnClick?.(this.viewer);
                    }
                }, Mg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-description-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: Od.info
                        }), this.mode = 0, this.viewer.addEventListener(vm.type, this), this.viewer.addEventListener(Ym.type, this), this.viewer.addEventListener(Em.type, this), this.viewer.addEventListener(Jm.type, this), this.viewer.addEventListener(mm.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(vm.type, this), this.viewer.removeEventListener(Ym.type, this), this.viewer.removeEventListener(Em.type, this), this.viewer.removeEventListener(Jm.type, this), this.viewer.removeEventListener(mm.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        if (le1 instanceof mm) return void (le1.containsOptions("description") && this.autoSize(!0));
                        if (!this.mode) return;
                        let vt = !1;
                        le1 instanceof vm ? vt = 1 === this.mode : le1 instanceof Ym ? vt = 1 === this.mode && le1.notificationId !== Nd.DESCRIPTION : le1 instanceof Em ? vt = 2 === this.mode : le1 instanceof Jm && (vt = 2 === this.mode && le1.panelId !== Nd.DESCRIPTION), vt && (this.toggleActive(!1), this.mode = 0);
                    }
                    onClick() {
                        this.mode ? this.__close() : this.__open();
                    }
                    hide(le1) {
                        super.hide(le1), this.mode && this.__close();
                    }
                    autoSize(le1) {
                        if (void 0 === le1 && (le1 = !1), le1) {
                            const le1 = this.viewer.navbar.getButton("caption", !1), vt = le1 && !le1.isVisible(), bt = !!this.viewer.config.description;
                            vt || bt ? this.show(!1) : this.hide(!1);
                        }
                    }
                    __close() {
                        switch(this.mode){
                            case 1:
                                this.viewer.notification.hide(Nd.DESCRIPTION);
                                break;
                            case 2:
                                this.viewer.panel.hide(Nd.DESCRIPTION);
                        }
                    }
                    __open() {
                        this.toggleActive(!0), this.viewer.config.description ? (this.mode = 2, this.viewer.panel.show({
                            id: Nd.DESCRIPTION,
                            content: `${this.viewer.config.caption ? `<p>${this.viewer.config.caption}</p>` : ""}${this.viewer.config.description}`
                        })) : (this.mode = 1, this.viewer.notification.show({
                            id: Nd.DESCRIPTION,
                            content: this.viewer.config.caption
                        }));
                    }
                };
                Mg.id = "description";
                var Sg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            tagName: "a",
                            className: "psv-download-button",
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0,
                            icon: Od.download
                        }), this.viewer.addEventListener(mm.type, this), this.viewer.addEventListener(zm.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(mm.type, this), this.viewer.removeEventListener(zm.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        le1 instanceof mm ? (le1.containsOptions("downloadUrl") && this.checkSupported(), le1.containsOptions("downloadUrl", "downloadName") && this.__update()) : le1 instanceof zm && this.__update();
                    }
                    onClick() {}
                    checkSupported() {
                        this.viewer.adapter.constructor.supportsDownload || this.viewer.config.downloadUrl ? this.show() : this.hide();
                    }
                    __update() {
                        const le1 = this.container;
                        le1.href = this.viewer.config.downloadUrl || this.viewer.config.panorama, le1.target = "_blank", le1.href.startsWith("data:") && !this.viewer.config.downloadName ? le1.download = "panorama." + le1.href.substring(0, le1.href.indexOf(";")).split("/").pop() : le1.download = this.viewer.config.downloadName || le1.href.split("/").pop();
                    }
                };
                Sg.id = "download";
                var Tg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-fullscreen-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: Od.fullscreenIn,
                            iconActive: Od.fullscreenOut
                        }), this.viewer.addEventListener(_m.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(_m.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        le1 instanceof _m && this.toggleActive(le1.fullscreenEnabled);
                    }
                    onClick() {
                        this.viewer.toggleFullscreen();
                    }
                };
                Tg.id = "fullscreen";
                var kg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-menu-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: Od.menu
                        }), this.viewer.addEventListener(Jm.type, this), this.viewer.addEventListener(Em.type, this), super.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(Jm.type, this), this.viewer.removeEventListener(Em.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        le1 instanceof Jm ? this.toggleActive(le1.panelId === Nd.MENU) : le1 instanceof Em && this.toggleActive(!1);
                    }
                    onClick() {
                        this.state.active ? this.__hideMenu() : this.__showMenu();
                    }
                    hide(le1) {
                        super.hide(le1), this.__hideMenu();
                    }
                    show(le1) {
                        super.show(le1), this.state.active && this.__showMenu();
                    }
                    __showMenu() {
                        var le1, vt;
                        this.viewer.panel.show({
                            id: Nd.MENU,
                            content: (le1 = this.viewer.navbar.collapsed, vt = this.viewer.config.lang.menu, `\n<div class="psv-panel-menu psv-panel-menu--stripped">\n  <h1 class="psv-panel-menu-title">${Od.menu} ${vt}</h1>\n  <ul class="psv-panel-menu-list">\n    ${le1.map((le1)=>`\n    <li data-psv-button="${le1.id}" class="psv-panel-menu-item" tabindex="0">\n      <span class="psv-panel-menu-item-icon">${le1.content}</span>\n      <span class="psv-panel-menu-item-label">${le1.title}</span>\n    </li>\n    `).join("")}\n  </ul>\n</div>\n`),
                            noMargin: !0,
                            clickHandler: (le1)=>{
                                const vt = le1 ? getClosest(le1, ".psv-panel-menu-item") : void 0, bt = vt ? vt.dataset.psvButton : void 0;
                                bt && (this.viewer.navbar.getButton(bt).onClick(), this.__hideMenu());
                            }
                        });
                    }
                    __hideMenu() {
                        this.viewer.panel.hide(Nd.MENU);
                    }
                };
                function getIcon(le1) {
                    let vt = 0;
                    switch(le1){
                        case 0:
                            vt = 90;
                            break;
                        case 1:
                            vt = -90;
                            break;
                        case 3:
                            vt = 180;
                            break;
                        default:
                            vt = 0;
                    }
                    return Od.arrow.replace("rotate(0", `rotate(${vt}`);
                }
                kg.id = "menu";
                var Cg = class extends wg {
                    constructor(le1, vt){
                        super(le1, {
                            className: "psv-move-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: getIcon(vt)
                        }), this.direction = vt, this.handler = new $d, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
                    }
                    destroy() {
                        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case "mousedown":
                                this.__onMouseDown();
                                break;
                            case "mouseup":
                            case "touchend":
                                this.__onMouseUp();
                                break;
                            case "keydown":
                                le1.key === Rd.Enter && this.__onMouseDown();
                                break;
                            case "keyup":
                                le1.key === Rd.Enter && this.__onMouseUp();
                        }
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(gg.isTouchEnabled);
                    }
                    __onMouseDown() {
                        if (!this.state.enabled) return;
                        const le1 = {};
                        switch(this.direction){
                            case 0:
                                le1.pitch = !1;
                                break;
                            case 1:
                                le1.pitch = !0;
                                break;
                            case 3:
                                le1.yaw = !1;
                                break;
                            default:
                                le1.yaw = !0;
                        }
                        this.viewer.stopAll(), this.viewer.dynamics.position.roll(le1), this.handler.down();
                    }
                    __onMouseUp() {
                        this.state.enabled && this.handler.up(()=>{
                            this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer();
                        });
                    }
                };
                Cg.groupId = "move";
                var Ig = class extends Cg {
                    constructor(le1){
                        super(le1, 1);
                    }
                };
                Ig.id = "moveDown";
                var Dg = class extends Cg {
                    constructor(le1){
                        super(le1, 2);
                    }
                };
                Dg.id = "moveLeft";
                var Lg = class extends Cg {
                    constructor(le1){
                        super(le1, 3);
                    }
                };
                Lg.id = "moveRight";
                var Pg = class extends Cg {
                    constructor(le1){
                        super(le1, 0);
                    }
                };
                Pg.id = "moveUp";
                var zg = class extends wg {
                    constructor(le1, vt, bt){
                        super(le1, {
                            className: "psv-zoom-button",
                            hoverScale: !0,
                            collapsable: !1,
                            tabbable: !0,
                            icon: vt
                        }), this.direction = bt, this.handler = new $d, this.container.addEventListener("mousedown", this), this.container.addEventListener("keydown", this), this.container.addEventListener("keyup", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this);
                    }
                    destroy() {
                        this.__onMouseUp(), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case "mousedown":
                                this.__onMouseDown();
                                break;
                            case "mouseup":
                            case "touchend":
                                this.__onMouseUp();
                                break;
                            case "keydown":
                                le1.key === Rd.Enter && this.__onMouseDown();
                                break;
                            case "keyup":
                                le1.key === Rd.Enter && this.__onMouseUp();
                        }
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(gg.isTouchEnabled);
                    }
                    __onMouseDown() {
                        this.state.enabled && (this.viewer.dynamics.zoom.roll(1 === this.direction), this.handler.down());
                    }
                    __onMouseUp() {
                        this.state.enabled && this.handler.up(()=>this.viewer.dynamics.zoom.stop());
                    }
                };
                zg.groupId = "zoom";
                var Ng = class extends zg {
                    constructor(le1){
                        super(le1, Od.zoomIn, 0);
                    }
                };
                Ng.id = "zoomIn";
                var Rg = class extends zg {
                    constructor(le1){
                        super(le1, Od.zoomOut, 1);
                    }
                };
                Rg.id = "zoomOut";
                var Fg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-zoom-range",
                            hoverScale: !1,
                            collapsable: !1,
                            tabbable: !1
                        }), this.zoomRange = document.createElement("div"), this.zoomRange.className = "psv-zoom-range-line", this.container.appendChild(this.zoomRange), this.zoomValue = document.createElement("div"), this.zoomValue.className = "psv-zoom-range-handle", this.zoomRange.appendChild(this.zoomValue), this.slider = new em(this.container, "HORIZONTAL", (le1)=>this.__onSliderUpdate(le1)), this.mediaMinWidth = parseInt(getStyleProperty(this.container, "max-width"), 10), this.viewer.addEventListener(sg.type, this), this.viewer.state.ready ? this.__moveZoomValue(this.viewer.getZoomLevel()) : this.viewer.addEventListener(qm.type, this);
                    }
                    destroy() {
                        this.slider.destroy(), this.viewer.removeEventListener(sg.type, this), this.viewer.removeEventListener(qm.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        le1 instanceof sg ? this.__moveZoomValue(le1.zoomLevel) : le1 instanceof qm && this.__moveZoomValue(this.viewer.getZoomLevel());
                    }
                    onClick() {}
                    isSupported() {
                        return invertResolvableBoolean(gg.isTouchEnabled);
                    }
                    autoSize() {
                        this.state.supported && (this.viewer.state.size.width <= this.mediaMinWidth && this.state.visible ? this.hide(!1) : this.viewer.state.size.width > this.mediaMinWidth && !this.state.visible && this.show(!1));
                    }
                    __moveZoomValue(le1) {
                        this.zoomValue.style.left = le1 / 100 * this.zoomRange.offsetWidth - this.zoomValue.offsetWidth / 2 + "px";
                    }
                    __onSliderUpdate(le1) {
                        le1.mousedown && this.viewer.zoom(100 * le1.value);
                    }
                };
                Fg.id = "zoomRange", Fg.groupId = "zoom";
                var Og = class extends nm {
                    constructor(le1){
                        super(), this.viewer = le1;
                    }
                    init() {}
                    destroy() {}
                }, Bg = class extends Og {
                    constructor(le1, vt){
                        super(le1), this.config = this.constructor.configParser(vt);
                    }
                    setOption(le1, vt) {
                        this.setOptions({
                            [le1]: vt
                        });
                    }
                    setOptions(le1) {
                        const vt = {
                            ...this.config,
                            ...le1
                        }, bt = this.constructor, ls = bt.configParser, ho = bt.readonlyOptions, Dl = bt.id;
                        for (let [Fl, sc] of Object.entries(le1))Fl in ls.defaults ? ho.includes(Fl) ? logWarn(`${Dl}: Option "${Fl}" cannot be updated`) : (Fl in ls.parsers && (sc = ls.parsers[Fl](sc, {
                            rawConfig: vt,
                            defValue: ls.defaults[Fl]
                        })), this.config[Fl] = sc) : logWarn(`${Dl}: Unknown option "${Fl}"`);
                    }
                };
                function pluginInterop(le1) {
                    if (le1) {
                        for (const [, vt] of [
                            [
                                "_",
                                le1
                            ],
                            ...Object.entries(le1)
                        ])if (vt.prototype instanceof Og) return checkVersion(vt.id, vt.VERSION, "5.14.1"), vt;
                    }
                    return null;
                }
                Bg.readonlyOptions = [];
                var jg = {
                    panorama: null,
                    container: null,
                    adapter: [
                        yg,
                        null
                    ],
                    plugins: [],
                    caption: null,
                    description: null,
                    downloadUrl: null,
                    downloadName: null,
                    loadingImg: null,
                    loadingTxt: "",
                    size: null,
                    fisheye: 0,
                    minFov: 30,
                    maxFov: 90,
                    defaultZoomLvl: 50,
                    defaultYaw: 0,
                    defaultPitch: 0,
                    sphereCorrection: null,
                    moveSpeed: 1,
                    zoomSpeed: 1,
                    moveInertia: .8,
                    mousewheel: !0,
                    mousemove: !0,
                    mousewheelCtrlKey: !1,
                    touchmoveTwoFingers: !1,
                    panoData: null,
                    requestHeaders: null,
                    canvasBackground: "#000",
                    defaultTransition: {
                        speed: 1500,
                        rotation: !0,
                        effect: "fade"
                    },
                    rendererParameters: {
                        alpha: !0,
                        antialias: !0
                    },
                    withCredentials: ()=>!1,
                    navbar: [
                        "zoom",
                        "move",
                        "download",
                        "description",
                        "caption",
                        "fullscreen"
                    ],
                    lang: {
                        zoom: "Zoom",
                        zoomOut: "Zoom out",
                        zoomIn: "Zoom in",
                        moveUp: "Move up",
                        moveDown: "Move down",
                        moveLeft: "Move left",
                        moveRight: "Move right",
                        description: "Description",
                        download: "Download",
                        fullscreen: "Fullscreen",
                        loading: "Loading...",
                        menu: "Menu",
                        close: "Close",
                        twoFingers: "Use two fingers to navigate",
                        ctrlZoom: "Use ctrl + scroll to zoom the image",
                        loadError: "The panorama cannot be loaded",
                        webglError: "Your browser does not seem to support WebGL"
                    },
                    keyboard: "fullscreen",
                    keyboardActions: {
                        [Rd.ArrowUp]: "ROTATE_UP",
                        [Rd.ArrowDown]: "ROTATE_DOWN",
                        [Rd.ArrowRight]: "ROTATE_RIGHT",
                        [Rd.ArrowLeft]: "ROTATE_LEFT",
                        [Rd.PageUp]: "ZOOM_IN",
                        [Rd.PageDown]: "ZOOM_OUT",
                        [Rd.Plus]: "ZOOM_IN",
                        [Rd.Minus]: "ZOOM_OUT"
                    }
                }, Ug = {
                    panorama: "Use setPanorama method to change the panorama",
                    panoData: "Use setPanorama method to change the panorama",
                    container: "Cannot change viewer container",
                    adapter: "Cannot change adapter",
                    plugins: "Cannot change plugins"
                }, Vg = {
                    container: (le1)=>{
                        if (!le1) throw new Gd("No value given for container.");
                        return le1;
                    },
                    adapter: (le1, vt)=>{
                        let { defValue: bt } = vt;
                        if (!(le1 = le1 ? Array.isArray(le1) ? [
                            adapterInterop(le1[0]),
                            le1[1]
                        ] : [
                            adapterInterop(le1),
                            null
                        ] : bt)[0]) throw new Gd("An undefined value was given for adapter.");
                        if (!le1[0].id) throw new Gd("Adapter has no id.");
                        return le1;
                    },
                    defaultYaw: (le1)=>parseAngle(le1),
                    defaultPitch: (le1)=>parseAngle(le1, !0),
                    defaultZoomLvl: (le1)=>ls.cj9.clamp(le1, 0, 100),
                    minFov: (le1, vt)=>{
                        let { rawConfig: bt } = vt;
                        return bt.maxFov < le1 && (logWarn("maxFov cannot be lower than minFov"), le1 = bt.maxFov), ls.cj9.clamp(le1, 1, 179);
                    },
                    maxFov: (le1, vt)=>{
                        let { rawConfig: bt } = vt;
                        return le1 < bt.minFov && (le1 = bt.minFov), ls.cj9.clamp(le1, 1, 179);
                    },
                    moveInertia: (le1, vt)=>{
                        let { defValue: bt } = vt;
                        return !0 === le1 ? bt : !1 === le1 ? 0 : le1;
                    },
                    lang: (le1)=>({
                            ...jg.lang,
                            ...le1
                        }),
                    fisheye: (le1)=>!0 === le1 ? 1 : !1 === le1 ? 0 : le1,
                    requestHeaders: (le1)=>le1 && "object" === typeof le1 ? ()=>le1 : "function" === typeof le1 ? le1 : null,
                    withCredentials: (le1)=>"boolean" === typeof le1 ? ()=>le1 : "function" === typeof le1 ? le1 : ()=>!1,
                    defaultTransition: (le1, vt)=>{
                        let { defValue: bt } = vt;
                        return null === le1 || 0 === le1.speed ? null : {
                            ...bt,
                            ...le1
                        };
                    },
                    rendererParameters: (le1, vt)=>{
                        let { defValue: bt } = vt;
                        return {
                            ...le1,
                            ...bt
                        };
                    },
                    plugins: (le1)=>le1.map((le1, vt)=>{
                            if (!(le1 = Array.isArray(le1) ? [
                                pluginInterop(le1[0]),
                                le1[1]
                            ] : [
                                pluginInterop(le1),
                                null
                            ])[0]) throw new Gd(`An undefined value was given for plugin ${vt}.`);
                            if (!le1[0].id) throw new Gd(`Plugin ${vt} has no id.`);
                            return le1;
                        }),
                    navbar: (le1)=>!1 === le1 ? null : !0 === le1 ? clone(jg.navbar) : "string" === typeof le1 ? le1.split(/[ ,]/) : le1
                }, Gg = getConfigParser(jg, Vg), qg = class extends wg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-caption",
                            hoverScale: !1,
                            collapsable: !1,
                            tabbable: !0
                        }), this.contentWidth = 0, this.state.width = 0, this.contentElt = document.createElement("div"), this.contentElt.className = "psv-caption-content", this.container.appendChild(this.contentElt), this.setCaption(this.viewer.config.caption);
                    }
                    hide() {
                        this.contentElt.style.display = "none", this.state.visible = !1;
                    }
                    show() {
                        this.contentElt.style.display = "", this.state.visible = !0;
                    }
                    onClick() {}
                    setCaption(le1) {
                        this.show(), this.contentElt.innerHTML = le1 ?? "", this.contentElt.innerHTML ? this.contentWidth = this.contentElt.offsetWidth : this.contentWidth = 0, this.autoSize();
                    }
                    autoSize() {
                        this.toggle(this.container.offsetWidth >= this.contentWidth), this.__refreshButton();
                    }
                    __refreshButton() {
                        this.viewer.navbar.getButton(Mg.id, !1)?.autoSize(!0);
                    }
                };
                qg.id = "caption";
                var Hg = {}, Wg = {};
                function registerButton(le1, vt) {
                    if (!le1.id) throw new Gd("Button id is required");
                    if (Hg[le1.id] = le1, le1.groupId && (Wg[le1.groupId] = Wg[le1.groupId] || []).push(le1), vt) {
                        const bt = jg.navbar;
                        switch(vt){
                            case "start":
                                bt.unshift(le1.id);
                                break;
                            case "end":
                                bt.push(le1.id);
                                break;
                            default:
                                {
                                    const [ls, ho] = vt.split(":"), Dl = bt.indexOf(ls);
                                    if (!ls || !ho || -1 === Dl) throw new Gd(`Invalid defaultPosition ${vt}`);
                                    bt.splice(Dl + ("right" === ho ? 1 : 0), 0, le1.id);
                                }
                        }
                    }
                }
                [
                    Rg,
                    Fg,
                    Ng,
                    Mg,
                    qg,
                    Sg,
                    Tg,
                    Dg,
                    Lg,
                    Pg,
                    Ig
                ].forEach((le1)=>registerButton(le1));
                var Zg = class extends xg {
                    constructor(le1){
                        super(le1, {
                            className: `psv-navbar ${Md}`
                        }), this.collapsed = [], this.state.visible = !1;
                    }
                    show() {
                        this.viewer.container.classList.add("psv--has-navbar"), this.container.classList.add("psv-navbar--open"), this.state.visible = !0;
                    }
                    hide() {
                        this.viewer.container.classList.remove("psv--has-navbar"), this.container.classList.remove("psv-navbar--open"), this.state.visible = !1;
                    }
                    setButtons(le1) {
                        this.children.slice().forEach((le1)=>le1.destroy()), this.children.length = 0, -1 !== le1.indexOf(qg.id) && -1 === le1.indexOf(Mg.id) && le1.splice(le1.indexOf(qg.id), 0, Mg.id), le1.forEach((le1)=>{
                            "object" === typeof le1 ? new Eg(this, le1) : Hg[le1] ? new Hg[le1](this) : Wg[le1] ? Wg[le1].forEach((le1)=>{
                                new le1(this);
                            }) : logWarn(`Unknown button ${le1}`);
                        }), new kg(this), this.children.forEach((le1)=>{
                            le1 instanceof wg && le1.checkSupported();
                        }), this.autoSize();
                    }
                    setCaption(le1) {
                        this.children.some((vt)=>vt instanceof qg && (vt.setCaption(le1), !0));
                    }
                    getButton(le1, vt) {
                        void 0 === vt && (vt = !0);
                        const bt = this.children.find((vt)=>vt instanceof wg && vt.id === le1);
                        return !bt && vt && logWarn(`button "${le1}" not found in the navbar`), bt;
                    }
                    focusButton(le1) {
                        this.isVisible() && (this.getButton(le1, !1)?.container || this.container.firstElementChild)?.focus();
                    }
                    autoSize() {
                        this.children.forEach((le1)=>{
                            le1 instanceof wg && le1.autoSize();
                        });
                        const le1 = this.container.offsetWidth;
                        let vt = 0;
                        const bt = [];
                        this.children.forEach((le1)=>{
                            le1.isVisible() && le1 instanceof wg && (vt += le1.width, le1.collapsable && bt.push(le1));
                        }), 0 !== vt && (le1 < vt && bt.length > 0 ? (bt.forEach((le1)=>le1.collapse()), this.collapsed = bt, this.getButton(kg.id).show(!1)) : le1 >= vt && this.collapsed.length > 0 && (this.collapsed.forEach((le1)=>le1.uncollapse()), this.collapsed = [], this.getButton(kg.id).hide(!1)), this.getButton(qg.id, !1)?.autoSize());
                    }
                };
                ls.l2R.enabled = !1;
                var Yg = {
                    enabled: !0,
                    maxItems: 10,
                    ttl: 600,
                    items: {},
                    purgeInterval: null,
                    init () {
                        ls.l2R.enabled && (logWarn("ThreeJS cache should be disabled"), ls.l2R.enabled = !1), !this.purgeInterval && this.enabled && (this.purgeInterval = setInterval(()=>this.purge(), 6e4));
                    },
                    add (le1, vt, bt) {
                        this.enabled && vt && (this.items[vt] = this.items[vt] ?? {
                            files: {},
                            lastAccess: null
                        }, this.items[vt].files[le1] = bt, this.items[vt].lastAccess = Date.now());
                    },
                    get (le1, vt) {
                        if (this.enabled && vt && this.items[vt]) return this.items[vt].lastAccess = Date.now(), this.items[vt].files[le1];
                    },
                    remove (le1, vt) {
                        this.enabled && vt && this.items[vt] && (delete this.items[vt].files[le1], 0 === Object.keys(this.items[vt].files).length && delete this.items[vt]);
                    },
                    purge () {
                        Object.entries(this.items).sort((le1, vt)=>{
                            let [, bt] = le1, [, ls] = vt;
                            return ls.lastAccess - bt.lastAccess;
                        }).forEach((le1, vt)=>{
                            let [bt, { lastAccess: ls }] = le1;
                            vt > 0 && (Date.now() - ls >= 1e3 * this.ttl || vt >= this.maxItems) && delete this.items[bt];
                        });
                    }
                }, Qg = class extends xg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-loader-container"
                        }), this.loader = document.createElement("div"), this.loader.className = "psv-loader", this.container.appendChild(this.loader), this.size = this.loader.offsetWidth, this.canvas = document.createElementNS("http://www.w3.org/2000/svg", "svg"), this.canvas.setAttribute("class", "psv-loader-canvas"), this.canvas.setAttribute("viewBox", `0 0 ${this.size} ${this.size}`), this.loader.appendChild(this.canvas), this.textColor = getStyleProperty(this.loader, "color"), this.color = getStyleProperty(this.canvas, "color"), this.border = parseInt(getStyleProperty(this.loader, "--psv-loader-border"), 10), this.thickness = parseInt(getStyleProperty(this.loader, "--psv-loader-tickness"), 10);
                        const vt = this.size / 2;
                        this.canvas.innerHTML = `\n            <circle cx="${vt}" cy="${vt}" r="${vt}" fill="${this.color}"/>\n            <path d="" fill="none" stroke="${this.textColor}" stroke-width="${this.thickness}" stroke-linecap="round"/>\n        `, this.viewer.addEventListener(mm.type, this), this.__updateContent(), this.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(mm.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        le1 instanceof mm && le1.containsOptions("loadingImg", "loadingTxt", "lang") && this.__updateContent();
                    }
                    setProgress(le1) {
                        this.container.classList.remove("psv-loader--undefined");
                        const vt = ls.cj9.clamp(le1, 0, 99.999) / 100 * Math.PI * 2, bt = this.size / 2, ho = bt, Dl = this.thickness / 2 + this.border, Fl = (this.size - this.thickness) / 2 - this.border, sc = Math.sin(vt) * Fl + bt, uc = -Math.cos(vt) * Fl + bt, mc = le1 > 50 ? "1" : "0";
                        this.canvas.querySelector("path").setAttributeNS(null, "d", `M ${ho} ${Dl} A ${Fl} ${Fl} 0 ${mc} 1 ${sc} ${uc}`);
                    }
                    showUndefined() {
                        this.show(), this.setProgress(25), this.container.classList.add("psv-loader--undefined");
                    }
                    __updateContent() {
                        const le1 = this.loader.querySelector(".psv-loader-image, .psv-loader-text");
                        let vt;
                        if (le1 && this.loader.removeChild(le1), this.viewer.config.loadingImg ? (vt = document.createElement("img"), vt.className = "psv-loader-image", vt.src = this.viewer.config.loadingImg) : null !== this.viewer.config.loadingTxt && (vt = document.createElement("div"), vt.className = "psv-loader-text", vt.innerHTML = this.viewer.config.loadingTxt || this.viewer.config.lang.loading), vt) {
                            const le1 = Math.round(Math.sqrt(2 * Math.pow(this.size / 2 - this.thickness / 2 - this.border, 2)));
                            vt.style.maxWidth = le1 + "px", vt.style.maxHeight = le1 + "px", this.loader.appendChild(vt);
                        }
                    }
                }, Xg = class extends xg {
                    constructor(le1){
                        super(le1, {
                            className: "psv-notification"
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            timeout: null
                        }, this.content = document.createElement("div"), this.content.className = "psv-notification-content", this.container.appendChild(this.content), this.content.addEventListener("click", ()=>this.hide());
                    }
                    isVisible(le1) {
                        return this.state.visible && (!le1 || !this.state.contentId || this.state.contentId === le1);
                    }
                    toggle() {
                        throw new Gd("Notification cannot be toggled");
                    }
                    show(le1) {
                        this.state.timeout && (clearTimeout(this.state.timeout), this.state.timeout = null), "string" === typeof le1 && (le1 = {
                            content: le1
                        }), this.state.contentId = le1.id || null, this.content.innerHTML = le1.content, this.container.classList.add("psv-notification--visible"), this.state.visible = !0, this.viewer.dispatchEvent(new Ym(this.state.contentId)), le1.timeout && (this.state.timeout = setTimeout(()=>this.hide(this.state.contentId), le1.timeout));
                    }
                    hide(le1) {
                        if (this.isVisible(le1)) {
                            const le1 = this.state.contentId;
                            this.container.classList.remove("psv-notification--visible"), this.state.visible = !1, this.state.contentId = null, this.viewer.dispatchEvent(new vm(le1));
                        }
                    }
                }, Kg = class extends xg {
                    constructor(le1){
                        super(le1, {
                            className: `psv-overlay ${Md}`
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            dismissible: !0
                        }, this.image = document.createElement("div"), this.image.className = "psv-overlay-image", this.container.appendChild(this.image), this.title = document.createElement("div"), this.title.className = "psv-overlay-title", this.container.appendChild(this.title), this.text = document.createElement("div"), this.text.className = "psv-overlay-text", this.container.appendChild(this.text), this.container.addEventListener("click", this), this.viewer.addEventListener(km.type, this), super.hide();
                    }
                    destroy() {
                        this.viewer.removeEventListener(km.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        "click" === le1.type ? this.isVisible() && this.state.dismissible && (this.hide(), le1.stopPropagation()) : le1 instanceof km && this.isVisible() && this.state.dismissible && le1.matches(Rd.Escape) && (this.hide(), le1.preventDefault());
                    }
                    isVisible(le1) {
                        return this.state.visible && (!le1 || !this.state.contentId || this.state.contentId === le1);
                    }
                    toggle() {
                        throw new Gd("Overlay cannot be toggled");
                    }
                    show(le1) {
                        "string" === typeof le1 && (le1 = {
                            title: le1
                        }), this.state.contentId = le1.id || null, this.state.dismissible = !1 !== le1.dismissible, this.image.innerHTML = le1.image || "", this.title.innerHTML = le1.title || "", this.text.innerHTML = le1.text || "", super.show(), this.viewer.dispatchEvent(new Xm(this.state.contentId));
                    }
                    hide(le1) {
                        if (this.isVisible(le1)) {
                            const le1 = this.state.contentId;
                            super.hide(), this.state.contentId = null, this.viewer.dispatchEvent(new bm(le1));
                        }
                    }
                }, Jg = "psv-panel-content--no-interaction", $g = class extends xg {
                    constructor(le1){
                        super(le1, {
                            className: `psv-panel ${Md}`
                        }), this.state = {
                            visible: !1,
                            contentId: null,
                            mouseX: 0,
                            mouseY: 0,
                            mousedown: !1,
                            clickHandler: null,
                            keyHandler: null,
                            width: {}
                        };
                        const vt = document.createElement("div");
                        vt.className = "psv-panel-resizer", this.container.appendChild(vt);
                        const bt = document.createElement("div");
                        bt.className = "psv-panel-close-button", bt.innerHTML = Od.close, bt.title = le1.config.lang.close, this.container.appendChild(bt), this.content = document.createElement("div"), this.content.className = "psv-panel-content", this.container.appendChild(this.content), bt.addEventListener("click", ()=>this.hide()), vt.addEventListener("mousedown", this), vt.addEventListener("touchstart", this), this.viewer.container.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchend", this), this.viewer.container.addEventListener("mousemove", this), this.viewer.container.addEventListener("touchmove", this), this.viewer.addEventListener(km.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(km.type, this), this.viewer.container.removeEventListener("mousemove", this), this.viewer.container.removeEventListener("touchmove", this), this.viewer.container.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchend", this), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case "mousedown":
                                this.__onMouseDown(le1);
                                break;
                            case "touchstart":
                                this.__onTouchStart(le1);
                                break;
                            case "mousemove":
                                this.__onMouseMove(le1);
                                break;
                            case "touchmove":
                                this.__onTouchMove(le1);
                                break;
                            case "mouseup":
                                this.__onMouseUp(le1);
                                break;
                            case "touchend":
                                this.__onTouchEnd(le1);
                                break;
                            case km.type:
                                this.__onKeyPress(le1);
                        }
                    }
                    isVisible(le1) {
                        return this.state.visible && (!le1 || !this.state.contentId || this.state.contentId === le1);
                    }
                    toggle() {
                        throw new Gd("Panel cannot be toggled");
                    }
                    show(le1) {
                        "string" === typeof le1 && (le1 = {
                            content: le1
                        });
                        const vt = this.isVisible(le1.id);
                        this.state.contentId = le1.id || null, this.state.visible = !0, this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), le1.id && this.state.width[le1.id] ? this.container.style.width = this.state.width[le1.id] : le1.width ? this.container.style.width = le1.width : this.container.style.width = null, this.content.innerHTML = le1.content, this.content.scrollTop = 0, this.container.classList.add("psv-panel--open"), toggleClass(this.content, "psv-panel-content--no-margin", !0 === le1.noMargin), le1.clickHandler && (this.state.clickHandler = (vt)=>{
                            le1.clickHandler(getEventTarget(vt));
                        }, this.state.keyHandler = (vt)=>{
                            vt.key === Rd.Enter && le1.clickHandler(getEventTarget(vt));
                        }, this.content.addEventListener("click", this.state.clickHandler), this.content.addEventListener("keydown", this.state.keyHandler), vt || setTimeout(()=>{
                            this.content.querySelector("a,button,[tabindex]")?.focus();
                        }, 300)), this.viewer.dispatchEvent(new Jm(this.state.contentId));
                    }
                    hide(le1) {
                        if (this.isVisible(le1)) {
                            const le1 = this.state.contentId;
                            this.state.visible = !1, this.state.contentId = null, this.content.innerHTML = null, this.container.classList.remove("psv-panel--open"), this.state.clickHandler && (this.content.removeEventListener("click", this.state.clickHandler), this.content.removeEventListener("keydown", this.state.keyHandler), this.state.clickHandler = null, this.state.keyHandler = null), this.viewer.dispatchEvent(new Em(le1));
                        }
                    }
                    __onMouseDown(le1) {
                        le1.stopPropagation(), this.__startResize(le1.clientX, le1.clientY);
                    }
                    __onTouchStart(le1) {
                        if (le1.stopPropagation(), 1 === le1.touches.length) {
                            const vt = le1.touches[0];
                            this.__startResize(vt.clientX, vt.clientY);
                        }
                    }
                    __onMouseUp(le1) {
                        this.state.mousedown && (le1.stopPropagation(), this.state.mousedown = !1, this.content.classList.remove(Jg));
                    }
                    __onTouchEnd(le1) {
                        this.state.mousedown && (le1.stopPropagation(), 0 === le1.touches.length && (this.state.mousedown = !1, this.content.classList.remove(Jg)));
                    }
                    __onMouseMove(le1) {
                        this.state.mousedown && (le1.stopPropagation(), this.__resize(le1.clientX, le1.clientY));
                    }
                    __onTouchMove(le1) {
                        if (this.state.mousedown) {
                            const vt = le1.touches[0];
                            this.__resize(vt.clientX, vt.clientY);
                        }
                    }
                    __onKeyPress(le1) {
                        this.isVisible() && le1.matches(Rd.Escape) && (this.hide(), le1.preventDefault());
                    }
                    __startResize(le1, vt) {
                        this.state.mouseX = le1, this.state.mouseY = vt, this.state.mousedown = !0, this.content.classList.add(Jg);
                    }
                    __resize(le1, vt) {
                        const bt = le1, ls = vt, ho = Math.max(200, this.container.offsetWidth - (bt - this.state.mouseX)) + "px";
                        this.state.contentId && (this.state.width[this.state.contentId] = ho), this.container.style.width = ho, this.state.mouseX = bt, this.state.mouseY = ls;
                    }
                }, eA = class extends xg {
                    constructor(le1, vt){
                        super(le1, {
                            className: "psv-tooltip"
                        }), this.state = {
                            visible: !0,
                            arrow: 0,
                            border: 0,
                            state: 0,
                            width: 0,
                            height: 0,
                            pos: "",
                            config: null,
                            data: null,
                            hideTimeout: null
                        }, this.content = document.createElement("div"), this.content.className = "psv-tooltip-content", this.container.appendChild(this.content), this.arrow = document.createElement("div"), this.arrow.className = "psv-tooltip-arrow", this.container.appendChild(this.arrow), this.container.addEventListener("transitionend", this), this.container.addEventListener("touchdown", (le1)=>le1.stopPropagation()), this.container.addEventListener("mousedown", (le1)=>le1.stopPropagation()), this.container.style.top = "-1000px", this.container.style.left = "-1000px", this.show(vt);
                    }
                    handleEvent(le1) {
                        "transitionend" === le1.type && this.__onTransitionEnd(le1);
                    }
                    destroy() {
                        clearTimeout(this.state.hideTimeout), delete this.state.data, super.destroy();
                    }
                    toggle() {
                        throw new Gd("Tooltip cannot be toggled");
                    }
                    show(le1) {
                        if (0 !== this.state.state) throw new Gd("Initialized tooltip cannot be re-initialized");
                        le1.className && addClasses(this.container, le1.className), le1.style && Object.assign(this.container.style, le1.style), this.state.state = 3, this.update(le1.content, le1), this.state.data = le1.data, this.state.state = 1, this.viewer.dispatchEvent(new eg(this, this.state.data)), this.__waitImages();
                    }
                    update(le1, vt) {
                        this.content.innerHTML = le1;
                        const bt = this.container.getBoundingClientRect();
                        this.state.width = bt.right - bt.left, this.state.height = bt.bottom - bt.top, this.state.arrow = parseInt(getStyleProperty(this.arrow, "border-top-width"), 10), this.state.border = parseInt(getStyleProperty(this.container, "border-top-left-radius"), 10), this.move(vt ?? this.state.config), this.__waitImages();
                    }
                    move(le1) {
                        if (1 !== this.state.state && 3 !== this.state.state) throw new Gd("Uninitialized tooltip cannot be moved");
                        le1.box = le1.box ?? this.state.config?.box ?? {
                            width: 0,
                            height: 0
                        }, this.state.config = le1;
                        const vt = this.container, bt = this.arrow, ls = {
                            posClass: cleanCssPosition(le1.position, {
                                allowCenter: !1,
                                cssOrder: !1
                            }) || [
                                "top",
                                "center"
                            ],
                            width: this.state.width,
                            height: this.state.height,
                            top: 0,
                            left: 0,
                            arrowTop: 0,
                            arrowLeft: 0
                        };
                        this.__computeTooltipPosition(ls, le1);
                        let ho = null, Dl = null;
                        if (ls.top < 0 ? ho = "bottom" : ls.top + ls.height > this.viewer.state.size.height && (ho = "top"), ls.left < 0 ? Dl = "right" : ls.left + ls.width > this.viewer.state.size.width && (Dl = "left"), Dl || ho) {
                            const vt = cssPositionIsOrdered(ls.posClass);
                            ho && (ls.posClass[vt ? 0 : 1] = ho), Dl && (ls.posClass[vt ? 1 : 0] = Dl), this.__computeTooltipPosition(ls, le1);
                        }
                        vt.style.top = ls.top + "px", vt.style.left = ls.left + "px", bt.style.top = ls.arrowTop + "px", bt.style.left = ls.arrowLeft + "px";
                        const Fl = ls.posClass.join("-");
                        Fl !== this.state.pos && (vt.classList.remove(`psv-tooltip--${this.state.pos}`), this.state.pos = Fl, vt.classList.add(`psv-tooltip--${this.state.pos}`));
                    }
                    hide() {
                        this.container.classList.remove("psv-tooltip--visible"), this.state.state = 2, this.viewer.dispatchEvent(new Sm(this.state.data));
                        const le1 = parseFloat(getStyleProperty(this.container, "transition-duration"));
                        this.state.hideTimeout = setTimeout(()=>{
                            this.destroy();
                        }, 2 * le1);
                    }
                    __onTransitionEnd(le1) {
                        if ("transform" === le1.propertyName) switch(this.state.state){
                            case 1:
                                this.container.classList.add("psv-tooltip--visible"), this.state.state = 3;
                                break;
                            case 2:
                                this.state.state = 0, this.destroy();
                        }
                    }
                    __computeTooltipPosition(le1, vt) {
                        const bt = this.state.arrow, ls = vt.top, ho = le1.height, Dl = vt.left, Fl = le1.width, sc = bt + this.state.border, uc = vt.box.width / 2 + 2 * bt, mc = vt.box.height / 2 + 2 * bt;
                        switch(le1.posClass.join("-")){
                            case "top-left":
                                le1.top = ls - mc - ho, le1.left = Dl + sc - Fl, le1.arrowTop = ho, le1.arrowLeft = Fl - sc - bt;
                                break;
                            case "top-center":
                                le1.top = ls - mc - ho, le1.left = Dl - Fl / 2, le1.arrowTop = ho, le1.arrowLeft = Fl / 2 - bt;
                                break;
                            case "top-right":
                                le1.top = ls - mc - ho, le1.left = Dl - sc, le1.arrowTop = ho, le1.arrowLeft = bt;
                                break;
                            case "bottom-left":
                                le1.top = ls + mc, le1.left = Dl + sc - Fl, le1.arrowTop = 2 * -bt, le1.arrowLeft = Fl - sc - bt;
                                break;
                            case "bottom-center":
                                le1.top = ls + mc, le1.left = Dl - Fl / 2, le1.arrowTop = 2 * -bt, le1.arrowLeft = Fl / 2 - bt;
                                break;
                            case "bottom-right":
                                le1.top = ls + mc, le1.left = Dl - sc, le1.arrowTop = 2 * -bt, le1.arrowLeft = bt;
                                break;
                            case "left-top":
                                le1.top = ls + sc - ho, le1.left = Dl - uc - Fl, le1.arrowTop = ho - sc - bt, le1.arrowLeft = Fl;
                                break;
                            case "center-left":
                                le1.top = ls - ho / 2, le1.left = Dl - uc - Fl, le1.arrowTop = ho / 2 - bt, le1.arrowLeft = Fl;
                                break;
                            case "left-bottom":
                                le1.top = ls - sc, le1.left = Dl - uc - Fl, le1.arrowTop = bt, le1.arrowLeft = Fl;
                                break;
                            case "right-top":
                                le1.top = ls + sc - ho, le1.left = Dl + uc, le1.arrowTop = ho - sc - bt, le1.arrowLeft = 2 * -bt;
                                break;
                            case "center-right":
                                le1.top = ls - ho / 2, le1.left = Dl + uc, le1.arrowTop = ho / 2 - bt, le1.arrowLeft = 2 * -bt;
                                break;
                            case "right-bottom":
                                le1.top = ls - sc, le1.left = Dl + uc, le1.arrowTop = bt, le1.arrowLeft = 2 * -bt;
                        }
                    }
                    __waitImages() {
                        const le1 = this.content.querySelectorAll("img");
                        if (le1.length > 0) {
                            const vt = [];
                            le1.forEach((le1)=>{
                                le1.complete || vt.push(new Promise((vt)=>{
                                    le1.onload = vt, le1.onerror = vt;
                                }));
                            }), vt.length && Promise.all(vt).then(()=>{
                                if (1 === this.state.state || 3 === this.state.state) {
                                    const le1 = this.container.getBoundingClientRect();
                                    this.state.width = le1.right - le1.left, this.state.height = le1.bottom - le1.top, this.move(this.state.config);
                                }
                            });
                        }
                    }
                }, tA = class {
                    constructor(le1){
                        this.viewer = le1, this.config = le1.config, this.state = le1.state;
                    }
                    destroy() {}
                }, iA = new ls.Pq0, nA = new ls.O9p(0, 0, 0, "ZXY"), rA = class extends tA {
                    constructor(le1){
                        super(le1);
                    }
                    fovToZoomLevel(le1) {
                        const vt = Math.round((le1 - this.config.minFov) / (this.config.maxFov - this.config.minFov) * 100);
                        return ls.cj9.clamp(vt - 2 * (vt - 50), 0, 100);
                    }
                    zoomLevelToFov(le1) {
                        return this.config.maxFov + le1 / 100 * (this.config.minFov - this.config.maxFov);
                    }
                    vFovToHFov(le1) {
                        return ls.cj9.radToDeg(2 * Math.atan(Math.tan(ls.cj9.degToRad(le1) / 2) * this.state.aspect));
                    }
                    hFovToVFov(le1) {
                        return ls.cj9.radToDeg(2 * Math.atan(Math.tan(ls.cj9.degToRad(le1) / 2) / this.state.aspect));
                    }
                    getAnimationProperties(le1, vt, bt) {
                        const ls = !isNil(vt), ho = !isNil(bt), Dl = {};
                        let Fl = null;
                        if (ls) {
                            const bt = this.viewer.getPosition(), ls = getShortestArc(bt.yaw, vt.yaw);
                            Dl.yaw = {
                                start: bt.yaw,
                                end: bt.yaw + ls
                            }, Dl.pitch = {
                                start: bt.pitch,
                                end: vt.pitch
                            }, Fl = speedToDuration(le1, getAngle(bt, vt));
                        }
                        if (ho) {
                            const vt = this.viewer.getZoomLevel(), ls = Math.abs(bt - vt);
                            Dl.zoom = {
                                start: vt,
                                end: bt
                            }, null === Fl && (Fl = speedToDuration(le1, Math.PI / 4 * ls / 100));
                        }
                        return Fl = null === Fl ? "number" === typeof le1 ? le1 : uc : Math.max(uc, Fl), {
                            duration: Fl,
                            properties: Dl
                        };
                    }
                    getTransitionOptions(le1) {
                        let vt;
                        const bt = this.config.defaultTransition ?? jg.defaultTransition;
                        return vt = !1 === le1.transition || null === le1.transition ? null : !0 === le1.transition ? {
                            ...bt
                        } : "object" === typeof le1.transition ? {
                            ...bt,
                            ...le1.transition
                        } : this.config.defaultTransition, vt;
                    }
                    textureCoordsToSphericalCoords(le1) {
                        if (!this.state.textureData?.panoData) throw new Gd("Current adapter does not support texture coordinates or no texture has been loaded");
                        const vt = this.viewer.adapter.textureCoordsToSphericalCoords(le1, this.state.textureData.panoData);
                        return nA.equals(this.viewer.renderer.panoramaPose) && nA.equals(this.viewer.renderer.sphereCorrection) ? vt : (this.sphericalCoordsToVector3(vt, iA), iA.applyEuler(this.viewer.renderer.panoramaPose), iA.applyEuler(this.viewer.renderer.sphereCorrection), this.vector3ToSphericalCoords(iA));
                    }
                    sphericalCoordsToTextureCoords(le1) {
                        if (!this.state.textureData?.panoData) throw new Gd("Current adapter does not support texture coordinates or no texture has been loaded");
                        return nA.equals(this.viewer.renderer.panoramaPose) && nA.equals(this.viewer.renderer.sphereCorrection) || (this.sphericalCoordsToVector3(le1, iA), applyEulerInverse(iA, this.viewer.renderer.sphereCorrection), applyEulerInverse(iA, this.viewer.renderer.panoramaPose), le1 = this.vector3ToSphericalCoords(iA)), this.viewer.adapter.sphericalCoordsToTextureCoords(le1, this.state.textureData.panoData);
                    }
                    sphericalCoordsToVector3(le1, vt, bt) {
                        return void 0 === bt && (bt = du), vt || (vt = new ls.Pq0), vt.x = bt * -Math.cos(le1.pitch) * Math.sin(le1.yaw), vt.y = bt * Math.sin(le1.pitch), vt.z = bt * Math.cos(le1.pitch) * Math.cos(le1.yaw), vt;
                    }
                    vector3ToSphericalCoords(le1) {
                        const vt = Math.acos(le1.y / Math.sqrt(le1.x * le1.x + le1.y * le1.y + le1.z * le1.z)), bt = Math.atan2(le1.x, le1.z);
                        return {
                            yaw: bt < 0 ? -bt : 2 * Math.PI - bt,
                            pitch: Math.PI / 2 - vt
                        };
                    }
                    viewerCoordsToVector3(le1) {
                        const vt = this.viewer.renderer.getIntersections(le1).filter((le1)=>le1.object.userData[_u]);
                        return vt.length ? vt[0].point : null;
                    }
                    viewerCoordsToSphericalCoords(le1) {
                        const vt = this.viewerCoordsToVector3(le1);
                        return vt ? this.vector3ToSphericalCoords(vt) : null;
                    }
                    vector3ToViewerCoords(le1) {
                        const vt = le1.clone();
                        return vt.project(this.viewer.renderer.camera), {
                            x: Math.round((vt.x + 1) / 2 * this.state.size.width),
                            y: Math.round((1 - vt.y) / 2 * this.state.size.height)
                        };
                    }
                    sphericalCoordsToViewerCoords(le1) {
                        return this.sphericalCoordsToVector3(le1, iA), this.vector3ToViewerCoords(iA);
                    }
                    isPointVisible(le1) {
                        let vt, bt;
                        if (le1 instanceof ls.Pq0) vt = le1, bt = this.vector3ToViewerCoords(le1);
                        else {
                            if (!isExtendedPosition(le1)) return !1;
                            vt = this.sphericalCoordsToVector3(le1, iA), bt = this.vector3ToViewerCoords(vt);
                        }
                        return vt.dot(this.viewer.state.direction) > 0 && bt.x >= 0 && bt.x <= this.viewer.state.size.width && bt.y >= 0 && bt.y <= this.viewer.state.size.height;
                    }
                    cleanPosition(le1) {
                        if ("yaw" in le1 || "pitch" in le1) {
                            if (!("yaw" in le1) || !("pitch" in le1)) throw new Gd("Position is missing 'yaw' or 'pitch'");
                            return {
                                yaw: parseAngle(le1.yaw),
                                pitch: parseAngle(le1.pitch, !0)
                            };
                        }
                        return this.textureCoordsToSphericalCoords(le1);
                    }
                    cleanSphereCorrection(le1) {
                        return {
                            pan: parseAngle(le1?.pan || 0),
                            tilt: parseAngle(le1?.tilt || 0, !0),
                            roll: parseAngle(le1?.roll || 0, !0, !1)
                        };
                    }
                    cleanPanoramaPose(le1) {
                        return {
                            pan: ls.cj9.degToRad(le1?.poseHeading || 0),
                            tilt: ls.cj9.degToRad(le1?.posePitch || 0),
                            roll: ls.cj9.degToRad(le1?.poseRoll || 0)
                        };
                    }
                    cleanPanoramaOptions(le1, vt) {
                        return vt?.isEquirectangular ? (isNil(le1.zoom) && !isNil(vt.initialFov) && (le1 = {
                            ...le1,
                            zoom: this.fovToZoomLevel(this.hFovToVFov(vt.initialFov))
                        }), !isNil(le1.position) || isNil(vt.initialHeading) || isNil(vt.initialPitch) || (le1 = {
                            ...le1,
                            position: {
                                yaw: parseAngle(vt.initialHeading),
                                pitch: parseAngle(vt.initialPitch, !0)
                            }
                        }), le1) : le1;
                    }
                }, aA = class _Step {
                    constructor(){
                        this.$ = _Step.IDLE;
                    }
                    is() {
                        for(var le1 = arguments.length, vt = new Array(le1), bt = 0; bt < le1; bt++)vt[bt] = arguments[bt];
                        return vt.some((le1)=>this.$ & le1);
                    }
                    set(le1) {
                        this.$ = le1;
                    }
                    add(le1) {
                        this.$ |= le1;
                    }
                    remove(le1) {
                        this.$ &= ~le1;
                    }
                };
                aA.IDLE = 0, aA.CLICK = 1, aA.MOVING = 2;
                var sA = aA, oA = class extends tA {
                    constructor(le1){
                        super(le1), this.data = {
                            startMouseX: 0,
                            startMouseY: 0,
                            mouseX: 0,
                            mouseY: 0,
                            pinchDist: 0,
                            moveDelta: {
                                yaw: 0,
                                pitch: 0,
                                zoom: 0
                            },
                            accumulatorFactor: 0,
                            ctrlKeyDown: !1,
                            dblclickData: null,
                            dblclickTimeout: null,
                            longtouchTimeout: null,
                            twofingersTimeout: null,
                            ctrlZoomTimeout: null
                        }, this.step = new sA, this.keyHandler = new $d, this.resizeObserver = new ResizeObserver(throttle(()=>this.viewer.autoSize(), 50)), this.moveThreshold = mc * gg.pixelRatio;
                    }
                    init() {
                        window.addEventListener("keydown", this, {
                            passive: !1
                        }), window.addEventListener("keyup", this), this.viewer.container.addEventListener("mousedown", this), window.addEventListener("mousemove", this, {
                            passive: !1
                        }), window.addEventListener("mouseup", this), this.viewer.container.addEventListener("touchstart", this, {
                            passive: !1
                        }), window.addEventListener("touchmove", this, {
                            passive: !1
                        }), window.addEventListener("touchend", this, {
                            passive: !1
                        }), this.viewer.container.addEventListener("wheel", this, {
                            passive: !1
                        }), document.addEventListener("fullscreenchange", this), this.resizeObserver.observe(this.viewer.container), this.viewer.addEventListener(lm.type, this), this.viewer.addEventListener(rg.type, this);
                    }
                    destroy() {
                        window.removeEventListener("keydown", this), window.removeEventListener("keyup", this), this.viewer.container.removeEventListener("mousedown", this), window.removeEventListener("mousemove", this), window.removeEventListener("mouseup", this), this.viewer.container.removeEventListener("touchstart", this), window.removeEventListener("touchmove", this), window.removeEventListener("touchend", this), this.viewer.container.removeEventListener("wheel", this), document.removeEventListener("fullscreenchange", this), this.resizeObserver.disconnect(), this.viewer.removeEventListener(lm.type, this), this.viewer.removeEventListener(rg.type, this), clearTimeout(this.data.dblclickTimeout), clearTimeout(this.data.longtouchTimeout), clearTimeout(this.data.twofingersTimeout), clearTimeout(this.data.ctrlZoomTimeout), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case "keydown":
                                this.__onKeyDown(le1);
                                break;
                            case "keyup":
                                this.__onKeyUp();
                                break;
                            case "mousemove":
                                this.__onMouseMove(le1);
                                break;
                            case "mouseup":
                                this.__onMouseUp(le1);
                                break;
                            case "touchmove":
                                this.__onTouchMove(le1);
                                break;
                            case "touchend":
                                this.__onTouchEnd(le1);
                                break;
                            case "fullscreenchange":
                                this.__onFullscreenChange();
                                break;
                            case lm.type:
                                this.__applyMoveDelta();
                                break;
                            case rg.type:
                                this.__clearMoveDelta();
                        }
                        if (!getMatchingTarget(le1, "." + Md)) switch(le1.type){
                            case "mousedown":
                                this.__onMouseDown(le1);
                                break;
                            case "touchstart":
                                this.__onTouchStart(le1);
                                break;
                            case "wheel":
                                this.__onMouseWheel(le1);
                        }
                    }
                    __onKeyDown(le1) {
                        if (this.config.mousewheelCtrlKey && (this.data.ctrlKeyDown = le1.key === Rd.Control, this.data.ctrlKeyDown && (clearTimeout(this.data.ctrlZoomTimeout), this.viewer.overlay.hide(Nd.CTRL_ZOOM))), this.viewer.dispatchEvent(new km(le1.key, le1)) && this.state.keyboardEnabled && this.config.keyboardActions && !this.keyHandler.pending) {
                            for (const [vt, bt] of Object.entries(this.config.keyboardActions))if (keyPressMatch(le1, vt)) {
                                if ("function" === typeof bt) bt(this.viewer, le1);
                                else {
                                    switch("ZOOM_IN" !== bt && "ZOOM_OUT" !== bt && this.viewer.stopAll(), bt){
                                        case "ROTATE_UP":
                                            this.viewer.dynamics.position.roll({
                                                pitch: !1
                                            });
                                            break;
                                        case "ROTATE_DOWN":
                                            this.viewer.dynamics.position.roll({
                                                pitch: !0
                                            });
                                            break;
                                        case "ROTATE_RIGHT":
                                            this.viewer.dynamics.position.roll({
                                                yaw: !1
                                            });
                                            break;
                                        case "ROTATE_LEFT":
                                            this.viewer.dynamics.position.roll({
                                                yaw: !0
                                            });
                                            break;
                                        case "ZOOM_IN":
                                            this.viewer.dynamics.zoom.roll(!1);
                                            break;
                                        case "ZOOM_OUT":
                                            this.viewer.dynamics.zoom.roll(!0);
                                    }
                                    this.keyHandler.down(bt);
                                }
                                return void le1.preventDefault();
                            }
                        }
                    }
                    __onKeyUp() {
                        this.data.ctrlKeyDown = !1, this.state.keyboardEnabled && this.keyHandler.up((le1)=>{
                            "ZOOM_IN" === le1 || "ZOOM_OUT" === le1 ? this.viewer.dynamics.zoom.stop() : (this.viewer.dynamics.position.stop(), this.viewer.resetIdleTimer());
                        });
                    }
                    __onMouseDown(le1) {
                        this.step.add(sA.CLICK), this.data.startMouseX = le1.clientX, this.data.startMouseY = le1.clientY, this.config.mousemove && le1.preventDefault();
                    }
                    __onMouseUp(le1) {
                        this.step.is(sA.CLICK, sA.MOVING) && this.__stopMove(le1.clientX, le1.clientY, le1, 2 === le1.button);
                    }
                    __onMouseMove(le1) {
                        this.config.mousemove && this.step.is(sA.CLICK, sA.MOVING) && (le1.preventDefault(), this.__doMove(le1.clientX, le1.clientY)), this.__handleObjectsEvents(le1);
                    }
                    __onTouchStart(le1) {
                        1 === le1.touches.length ? (this.step.add(sA.CLICK), this.data.startMouseX = le1.touches[0].clientX, this.data.startMouseY = le1.touches[0].clientY, this.data.longtouchTimeout || (this.data.longtouchTimeout = setTimeout(()=>{
                            const vt = le1.touches[0];
                            this.__stopMove(vt.clientX, vt.clientY, le1, !0), this.data.longtouchTimeout = null;
                        }, Ac))) : 2 === le1.touches.length && (this.step.set(sA.IDLE), this.__cancelLongTouch(), this.config.mousemove && (this.__cancelTwoFingersOverlay(), this.__startMoveZoom(le1), le1.preventDefault()));
                    }
                    __onTouchEnd(le1) {
                        if (this.__cancelLongTouch(), this.step.is(sA.CLICK, sA.MOVING)) {
                            if (le1.preventDefault(), this.__cancelTwoFingersOverlay(), 1 === le1.touches.length) this.__stopMove(this.data.mouseX, this.data.mouseY);
                            else if (0 === le1.touches.length) {
                                const vt = le1.changedTouches[0];
                                this.__stopMove(vt.clientX, vt.clientY, le1);
                            }
                        }
                    }
                    __onTouchMove(le1) {
                        if (this.__cancelLongTouch(), this.config.mousemove) {
                            if (1 === le1.touches.length) {
                                if (this.config.touchmoveTwoFingers) this.step.is(sA.CLICK) && !this.data.twofingersTimeout && (this.data.twofingersTimeout = setTimeout(()=>{
                                    this.viewer.overlay.show({
                                        id: Nd.TWO_FINGERS,
                                        image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100"><path fill="currentColor" d="M33.38 33.2a1.96 1.96 0 0 0 1.5-3.23 10.61 10.61 0 0 1 7.18-17.51c.7-.06 1.31-.49 1.61-1.12a13.02 13.02 0 0 1 11.74-7.43c7.14 0 12.96 5.8 12.96 12.9 0 3.07-1.1 6.05-3.1 8.38-.7.82-.61 2.05.21 2.76.83.7 2.07.6 2.78-.22a16.77 16.77 0 0 0 4.04-10.91C72.3 7.54 64.72 0 55.4 0a16.98 16.98 0 0 0-14.79 8.7 14.6 14.6 0 0 0-12.23 14.36c0 3.46 1.25 6.82 3.5 9.45.4.45.94.69 1.5.69m45.74 43.55a22.13 22.13 0 0 1-5.23 12.4c-4 4.55-9.53 6.86-16.42 6.86-12.6 0-20.1-10.8-20.17-10.91a1.82 1.82 0 0 0-.08-.1c-5.3-6.83-14.55-23.82-17.27-28.87-.05-.1 0-.21.02-.23a6.3 6.3 0 0 1 8.24 1.85l9.38 12.59a1.97 1.97 0 0 0 3.54-1.17V25.34a4 4 0 0 1 1.19-2.87 3.32 3.32 0 0 1 2.4-.95c1.88.05 3.4 1.82 3.4 3.94v24.32a1.96 1.96 0 0 0 3.93 0v-33.1a3.5 3.5 0 0 1 7 0v35.39a1.96 1.96 0 0 0 3.93 0v-.44c.05-2.05 1.6-3.7 3.49-3.7 1.93 0 3.5 1.7 3.5 3.82v5.63c0 .24.04.48.13.71l.1.26a1.97 1.97 0 0 0 3.76-.37c.33-1.78 1.77-3.07 3.43-3.07 1.9 0 3.45 1.67 3.5 3.74l-1.77 18.1zM77.39 51c-1.25 0-2.45.32-3.5.9v-.15c0-4.27-3.33-7.74-7.42-7.74-1.26 0-2.45.33-3.5.9V16.69a7.42 7.42 0 0 0-14.85 0v1.86a7 7 0 0 0-3.28-.94 7.21 7.21 0 0 0-5.26 2.07 7.92 7.92 0 0 0-2.38 5.67v37.9l-5.83-7.82a10.2 10.2 0 0 0-13.35-2.92 4.1 4.1 0 0 0-1.53 5.48C20 64.52 28.74 80.45 34.07 87.34c.72 1.04 9.02 12.59 23.4 12.59 7.96 0 14.66-2.84 19.38-8.2a26.06 26.06 0 0 0 6.18-14.6l1.78-18.2v-.2c0-4.26-3.32-7.73-7.42-7.73z"/>\x3c!--Created by AomAm from the Noun Project--\x3e</svg>\n',
                                        title: this.config.lang.twoFingers
                                    });
                                }, Ec));
                                else if (this.step.is(sA.CLICK, sA.MOVING)) {
                                    le1.preventDefault();
                                    const vt = le1.touches[0];
                                    this.__doMove(vt.clientX, vt.clientY);
                                }
                            } else this.__doMoveZoom(le1), this.__cancelTwoFingersOverlay();
                        }
                    }
                    __cancelLongTouch() {
                        this.data.longtouchTimeout && (clearTimeout(this.data.longtouchTimeout), this.data.longtouchTimeout = null);
                    }
                    __cancelTwoFingersOverlay() {
                        this.config.touchmoveTwoFingers && (this.data.twofingersTimeout && (clearTimeout(this.data.twofingersTimeout), this.data.twofingersTimeout = null), this.viewer.overlay.hide(Nd.TWO_FINGERS));
                    }
                    __onMouseWheel(le1) {
                        if (!this.config.mousewheel || !le1.deltaY) return;
                        if (this.config.mousewheelCtrlKey && !this.data.ctrlKeyDown) return this.viewer.overlay.show({
                            id: Nd.CTRL_ZOOM,
                            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 17 79 79"><path fill="currentColor" d="M38.1 29.27c-.24 0-.44.2-.44.45v10.7a.45.45 0 00.9 0v-10.7c0-.25-.2-.45-.45-.45zm10.2 26.66a11.54 11.54 0 01-8.48-6.14.45.45 0 10-.8.41 12.45 12.45 0 009.22 6.62.45.45 0 00.07-.9zm24.55-13.08a23.04 23.04 0 00-22.56-23v7.07l-.01.05a2.83 2.83 0 012.39 2.78v14.03l.09-.02h8.84v-9.22a.45.45 0 11.9 0v9.22h10.35v-.9zm0 27.33V44.66H62.5c-.02 2.01-.52 4-1.47 5.76a.45.45 0 01-.61.18.45.45 0 01-.19-.61 11.54 11.54 0 001.36-5.33h-8.83l-.1-.01a2.83 2.83 0 01-2.83 2.84h-.04-.04a2.83 2.83 0 01-2.83-2.83v-14.9a2.82 2.82 0 012.47-2.8v-7.11a23.04 23.04 0 00-22.57 23v.91h14.72V29.88a8.2 8.2 0 015.02-7.57c.22-.1.5.01.59.24.1.23-.01.5-.24.6a7.3 7.3 0 00-4.47 6.73v13.88h3.9a.45.45 0 110 .9h-3.9v.15a7.32 7.32 0 0011.23 6.17.45.45 0 01.49.76 8.22 8.22 0 01-12.62-6.93v-.15H26.82v25.52a23.04 23.04 0 0023.01 23.01 23.04 23.04 0 0023.02-23.01zm1.8-27.33v27.33A24.85 24.85 0 0149.84 95a24.85 24.85 0 01-24.82-24.82V42.85a24.85 24.85 0 0124.82-24.82 24.85 24.85 0 0124.83 24.82zM57.98 29.88v9.36a.45.45 0 11-.9 0v-9.36a7.28 7.28 0 00-3.4-6.17.45.45 0 01.49-.76 8.18 8.18 0 013.8 6.93z"/>\x3c!-- Created by Icon Island from the Noun Project --\x3e</svg>\n',
                            title: this.config.lang.ctrlZoom
                        }), clearTimeout(this.data.ctrlZoomTimeout), void (this.data.ctrlZoomTimeout = setTimeout(()=>this.viewer.overlay.hide(Nd.CTRL_ZOOM), kc));
                        le1.preventDefault(), le1.stopPropagation();
                        const vt = le1.deltaY / Math.abs(le1.deltaY) * 5 * this.config.zoomSpeed;
                        0 !== vt && this.viewer.dynamics.zoom.step(-vt, 5);
                    }
                    __onFullscreenChange() {
                        const le1 = this.viewer.isFullscreenEnabled();
                        "fullscreen" === this.config.keyboard && (le1 ? this.viewer.startKeyboardControl() : this.viewer.stopKeyboardControl()), this.viewer.dispatchEvent(new _m(le1));
                    }
                    __resetMove() {
                        this.step.set(sA.IDLE), this.data.mouseX = 0, this.data.mouseY = 0, this.data.startMouseX = 0, this.data.startMouseY = 0;
                    }
                    __startMoveZoom(le1) {
                        this.viewer.stopAll(), this.__resetMove();
                        const vt = getTouchData(le1);
                        this.step.set(sA.MOVING), this.data.accumulatorFactor = this.config.moveInertia, { distance: this.data.pinchDist, center: { x: this.data.mouseX, y: this.data.mouseY } } = vt;
                    }
                    __stopMove(le1, vt, bt, ls) {
                        void 0 === ls && (ls = !1), this.step.is(sA.CLICK) && !this.__moveThresholdReached(le1, vt) && this.__doClick(le1, vt, bt, ls), this.config.moveInertia && (this.data.accumulatorFactor = Math.pow(this.config.moveInertia, .5)), this.__resetMove(), this.viewer.resetIdleTimer();
                    }
                    __doClick(le1, vt, bt, ls) {
                        void 0 === ls && (ls = !1);
                        const ho = this.viewer.container.getBoundingClientRect(), Dl = le1 - ho.left, Fl = vt - ho.top, sc = this.viewer.renderer.getIntersections({
                            x: Dl,
                            y: Fl
                        }), uc = sc.find((le1)=>le1.object.userData[_u]);
                        if (uc) {
                            const ho = this.viewer.dataHelper.vector3ToSphericalCoords(uc.point), mc = {
                                rightclick: ls,
                                originalEvent: bt,
                                target: getEventTarget(bt),
                                clientX: le1,
                                clientY: vt,
                                viewerX: Dl,
                                viewerY: Fl,
                                yaw: ho.yaw,
                                pitch: ho.pitch,
                                objects: sc.map((le1)=>le1.object).filter((le1)=>!le1.userData[_u])
                            };
                            try {
                                const le1 = this.viewer.dataHelper.sphericalCoordsToTextureCoords(mc);
                                Object.assign(mc, le1);
                            } catch  {}
                            this.data.dblclickTimeout ? (Math.abs(this.data.dblclickData.clientX - mc.clientX) < this.moveThreshold && Math.abs(this.data.dblclickData.clientY - mc.clientY) < this.moveThreshold && this.viewer.dispatchEvent(new gm(this.data.dblclickData)), clearTimeout(this.data.dblclickTimeout), this.data.dblclickTimeout = null, this.data.dblclickData = null) : (this.viewer.dispatchEvent(new dm(mc)), this.data.dblclickData = clone(mc), this.data.dblclickTimeout = setTimeout(()=>{
                                this.data.dblclickTimeout = null, this.data.dblclickData = null;
                            }, gc));
                        }
                    }
                    __handleObjectsEvents(le1) {
                        if (!isEmpty(this.state.objectsObservers) && le1.composedPath().includes(this.viewer.container)) {
                            const vt = getPosition(this.viewer.container), bt = {
                                x: le1.clientX - vt.x,
                                y: le1.clientY - vt.y
                            }, ls = this.viewer.renderer.getIntersections(bt), emit = (vt, ls, ho)=>{
                                this.viewer.dispatchEvent(new ho(le1, vt, bt, ls));
                            };
                            for (const [le1, ho] of Object.entries(this.state.objectsObservers)){
                                const vt = ls.find((vt)=>vt.object.userData[le1]);
                                vt ? (ho && vt.object !== ho && (emit(ho, le1, hg), this.state.objectsObservers[le1] = null), ho ? emit(vt.object, le1, pg) : (this.state.objectsObservers[le1] = vt.object, emit(vt.object, le1, cg))) : ho && (emit(ho, le1, hg), this.state.objectsObservers[le1] = null);
                            }
                        }
                    }
                    __doMove(le1, vt) {
                        if (this.step.is(sA.CLICK) && this.__moveThresholdReached(le1, vt)) this.viewer.stopAll(), this.__resetMove(), this.step.set(sA.MOVING), this.data.mouseX = le1, this.data.mouseY = vt, this.data.accumulatorFactor = this.config.moveInertia;
                        else if (this.step.is(sA.MOVING)) {
                            const bt = (le1 - this.data.mouseX) * Math.cos(this.state.roll) - (vt - this.data.mouseY) * Math.sin(this.state.roll), ho = (vt - this.data.mouseY) * Math.cos(this.state.roll) + (le1 - this.data.mouseX) * Math.sin(this.state.roll), Dl = {
                                yaw: this.config.moveSpeed * (bt / this.state.size.width) * ls.cj9.degToRad(this.state.hFov),
                                pitch: this.config.moveSpeed * (ho / this.state.size.height) * ls.cj9.degToRad(this.state.vFov)
                            };
                            this.data.moveDelta.yaw += Dl.yaw, this.data.moveDelta.pitch += Dl.pitch, this.data.mouseX = le1, this.data.mouseY = vt;
                        }
                    }
                    __moveThresholdReached(le1, vt) {
                        return Math.abs(le1 - this.data.startMouseX) >= this.moveThreshold || Math.abs(vt - this.data.startMouseY) >= this.moveThreshold;
                    }
                    __doMoveZoom(le1) {
                        if (this.step.is(sA.MOVING)) {
                            le1.preventDefault();
                            const vt = getTouchData(le1);
                            this.__doMove(vt.center.x, vt.center.y), this.data.moveDelta.zoom += this.config.zoomSpeed * ((vt.distance - this.data.pinchDist) / gg.pixelRatio), this.data.pinchDist = vt.distance;
                        }
                    }
                    __applyMoveDelta() {
                        const le1 = .001;
                        if (Math.abs(this.data.moveDelta.yaw) > 0 || Math.abs(this.data.moveDelta.pitch) > 0) {
                            const vt = this.viewer.getPosition();
                            this.viewer.rotate({
                                yaw: vt.yaw - this.data.moveDelta.yaw * (1 - this.config.moveInertia),
                                pitch: vt.pitch + this.data.moveDelta.pitch * (1 - this.config.moveInertia)
                            }), this.data.moveDelta.yaw *= this.data.accumulatorFactor, this.data.moveDelta.pitch *= this.data.accumulatorFactor, Math.abs(this.data.moveDelta.yaw) <= le1 && (this.data.moveDelta.yaw = 0), Math.abs(this.data.moveDelta.pitch) <= le1 && (this.data.moveDelta.pitch = 0);
                        }
                        if (Math.abs(this.data.moveDelta.zoom) > 0) {
                            const vt = this.viewer.getZoomLevel();
                            this.viewer.zoom(vt + this.data.moveDelta.zoom * (1 - this.config.moveInertia)), this.data.moveDelta.zoom *= this.config.moveInertia, Math.abs(this.data.moveDelta.zoom) <= le1 && (this.data.moveDelta.zoom = 0);
                        }
                    }
                    __clearMoveDelta() {
                        this.data.moveDelta.yaw = 0, this.data.moveDelta.pitch = 0, this.data.moveDelta.zoom = 0;
                    }
                };
                ls.ppV.enabled = !1;
                var lA = new ls.I9Y, cA = new ls.kn4, uA = new ls.NRn, hA = class extends tA {
                    constructor(le1){
                        super(le1), this.frustumNeedsUpdate = !0, this.renderer = new ho.JeP(this.config.rendererParameters), this.renderer.setPixelRatio(gg.pixelRatio), this.renderer.outputColorSpace = ls.Zr2, this.renderer.toneMapping = ls.kyO, this.renderer.domElement.className = "psv-canvas", this.renderer.domElement.style.background = this.config.canvasBackground, this.scene = new ls.Z58, this.camera = new ls.ubm(50, 16 / 9, .1, 2 * du), this.camera.matrixAutoUpdate = !1;
                        const vt = new ls.eaF(new ls.Gu$(du).scale(-1, 1, 1), new ls.V9B({
                            opacity: 0,
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1
                        }));
                        vt.userData = {
                            [_u]: !0
                        }, this.scene.add(vt), this.raycaster = new ls.tBo, this.frustum = new ls.PPD, this.container = document.createElement("div"), this.container.className = "psv-canvas-container", this.container.appendChild(this.renderer.domElement), this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (le1)=>le1.preventDefault()), this.viewer.addEventListener(ig.type, this), this.viewer.addEventListener(sg.type, this), this.viewer.addEventListener(jm.type, this), this.viewer.addEventListener(Vm.type, this), this.viewer.addEventListener(mm.type, this), this.hide();
                    }
                    get panoramaPose() {
                        return this.mesh.rotation;
                    }
                    get sphereCorrection() {
                        return this.meshContainer.rotation;
                    }
                    init() {
                        this.show(), this.renderer.setAnimationLoop((le1)=>this.__renderLoop(le1));
                    }
                    destroy() {
                        this.renderer.setAnimationLoop(null), this.cleanScene(this.scene), this.renderer.dispose(), this.viewer.container.removeChild(this.container), this.viewer.removeEventListener(ig.type, this), this.viewer.removeEventListener(sg.type, this), this.viewer.removeEventListener(jm.type, this), this.viewer.removeEventListener(Vm.type, this), this.viewer.removeEventListener(mm.type, this), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case ig.type:
                                this.__onSizeUpdated();
                                break;
                            case sg.type:
                                this.__onZoomUpdated();
                                break;
                            case jm.type:
                            case Vm.type:
                                this.__onPositionUpdated();
                                break;
                            case mm.type:
                                le1.containsOptions("fisheye") && this.__onPositionUpdated(), le1.containsOptions("canvasBackground") && (this.renderer.domElement.style.background = this.config.canvasBackground);
                        }
                    }
                    hide() {
                        this.container.style.opacity = "0";
                    }
                    show() {
                        this.container.style.opacity = "1";
                    }
                    setCustomRenderer(le1) {
                        this.customRenderer = le1 ? le1(this.renderer) : null, this.viewer.needsUpdate();
                    }
                    __onSizeUpdated() {
                        this.renderer.setSize(this.state.size.width, this.state.size.height), this.camera.aspect = this.state.aspect, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __onZoomUpdated() {
                        this.camera.fov = this.state.vFov, this.camera.updateProjectionMatrix(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __onPositionUpdated() {
                        this.camera.position.set(0, 0, 0), this.camera.lookAt(this.state.direction), this.config.fisheye && this.camera.position.copy(this.state.direction).multiplyScalar(this.config.fisheye / 2).negate(), this.camera.rotateZ(-this.state.roll), this.camera.updateMatrix(), this.camera.updateMatrixWorld(), this.viewer.needsUpdate(), this.frustumNeedsUpdate = !0;
                    }
                    __renderLoop(le1) {
                        const vt = this.timestamp ? le1 - this.timestamp : 0;
                        this.timestamp = le1, this.viewer.dispatchEvent(new lm(le1, vt)), this.viewer.dynamics.update(vt), (this.state.needsUpdate || this.state.continuousUpdateCount > 0) && (this.state.needsUpdate = !1, (this.customRenderer || this.renderer).render(this.scene, this.camera), this.viewer.dispatchEvent(new Wm));
                    }
                    setTexture(le1) {
                        this.meshContainer || (this.meshContainer = new ls.YJl, this.scene.add(this.meshContainer)), this.state.textureData && this.viewer.adapter.disposeTexture(this.state.textureData), this.mesh && (this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh)), this.mesh = this.viewer.adapter.createMesh(le1.panoData), this.viewer.adapter.setTexture(this.mesh, le1, !1), this.meshContainer.add(this.mesh), this.state.textureData = le1, this.viewer.needsUpdate();
                    }
                    setPanoramaPose(le1, vt) {
                        void 0 === vt && (vt = this.mesh);
                        const bt = this.viewer.dataHelper.cleanPanoramaPose(le1);
                        vt.rotation.set(-bt.tilt, bt.pan, bt.roll, "YXZ");
                    }
                    setSphereCorrection(le1, vt) {
                        void 0 === vt && (vt = this.meshContainer);
                        const bt = this.viewer.dataHelper.cleanSphereCorrection(le1);
                        vt.rotation.set(bt.tilt, bt.pan, bt.roll, "YXZ");
                    }
                    transition(le1, vt, bt) {
                        const ho = "fade" === bt.effect || bt.rotation, Dl = !isNil(vt.position), Fl = !isNil(vt.zoom), sc = new sm(Dl ? this.viewer.dataHelper.cleanPosition(vt.position) : void 0, vt.zoom);
                        this.viewer.dispatchEvent(sc);
                        const uc = new ls.YJl, mc = this.viewer.adapter.createMesh(le1.panoData);
                        if (this.viewer.adapter.setTexture(mc, le1, !0), this.viewer.adapter.setTextureOpacity(mc, 0), this.setPanoramaPose(le1.panoData, mc), this.setSphereCorrection(vt.sphereCorrection, uc), Dl && !bt.rotation) {
                            const le1 = this.viewer.getPosition(), vt = new ls.Pq0(0, 1, 0);
                            uc.rotateOnWorldAxis(vt, sc.position.yaw - le1.yaw);
                            const bt = new ls.Pq0(0, 1, 0).cross(this.camera.getWorldDirection(new ls.Pq0)).normalize();
                            uc.rotateOnWorldAxis(bt, sc.position.pitch - le1.pitch);
                        }
                        uc.add(mc), this.scene.add(uc), this.renderer.setRenderTarget(new ls.nWS), this.renderer.render(this.scene, this.camera), this.renderer.setRenderTarget(null);
                        const { duration: gc, properties: Ac } = this.viewer.dataHelper.getAnimationProperties(bt.speed, bt.rotation ? sc.position : null, ho ? sc.zoomLevel : null), Ec = new Xd({
                            properties: {
                                ...Ac,
                                opacity: {
                                    start: 0,
                                    end: 1
                                }
                            },
                            duration: gc,
                            easing: "inOutCubic",
                            onTick: (le1)=>{
                                switch(bt.effect){
                                    case "fade":
                                        this.viewer.adapter.setTextureOpacity(mc, le1.opacity);
                                        break;
                                    case "black":
                                    case "white":
                                        le1.opacity < .5 ? this.renderer.toneMappingExposure = "black" === bt.effect ? ls.cj9.mapLinear(le1.opacity, 0, .5, 1, 0) : ls.cj9.mapLinear(le1.opacity, 0, .5, 1, 5) : (this.renderer.toneMappingExposure = "black" === bt.effect ? ls.cj9.mapLinear(le1.opacity, .5, 1, 0, 1) : ls.cj9.mapLinear(le1.opacity, .5, 1, 5, 1), this.mesh.visible = !1, this.viewer.adapter.setTextureOpacity(mc, 1), Fl && !ho && this.viewer.dynamics.zoom.setValue(sc.zoomLevel));
                                }
                                Dl && bt.rotation && this.viewer.dynamics.position.setValue({
                                    yaw: le1.yaw,
                                    pitch: le1.pitch
                                }), Fl && ho && this.viewer.dynamics.zoom.setValue(le1.zoom), this.viewer.needsUpdate();
                            }
                        });
                        return Ec.then((ls)=>{
                            uc.remove(mc), this.scene.remove(uc), ls ? (this.viewer.adapter.disposeTexture(this.state.textureData), this.meshContainer.remove(this.mesh), this.viewer.adapter.disposeMesh(this.mesh), this.mesh = mc, this.meshContainer.add(mc), this.state.textureData = le1, this.setPanoramaPose(le1.panoData), this.setSphereCorrection(vt.sphereCorrection), Dl && !bt.rotation && this.viewer.rotate(vt.position)) : (this.viewer.adapter.disposeTexture(le1), this.viewer.adapter.disposeMesh(mc));
                        }), Ec;
                    }
                    getIntersections(le1) {
                        lA.x = 2 * le1.x / this.state.size.width - 1, lA.y = -2 * le1.y / this.state.size.height + 1, this.raycaster.setFromCamera(lA, this.camera);
                        const vt = this.raycaster.intersectObjects(this.scene.children, !0).filter((le1)=>le1.object.visible).filter((le1)=>le1.object.isMesh && !!le1.object.userData);
                        return this.customRenderer?.getIntersections && vt.push(...this.customRenderer.getIntersections(this.raycaster, lA)), vt;
                    }
                    isObjectVisible(le1) {
                        if (!le1) return !1;
                        if (this.frustumNeedsUpdate && (cA.multiplyMatrices(this.camera.projectionMatrix, this.camera.matrixWorldInverse), this.frustum.setFromProjectionMatrix(cA), this.frustumNeedsUpdate = !1), le1.isVector3) return this.frustum.containsPoint(le1);
                        if (le1.isMesh && le1.geometry) {
                            const vt = le1;
                            return vt.geometry.boundingBox || vt.geometry.computeBoundingBox(), uA.copy(vt.geometry.boundingBox).applyMatrix4(vt.matrixWorld), this.frustum.intersectsBox(uA);
                        }
                        return !!le1.isObject3D && this.frustum.intersectsObject(le1);
                    }
                    addObject(le1) {
                        this.scene.add(le1);
                    }
                    removeObject(le1) {
                        this.scene.remove(le1);
                    }
                    cleanScene(le1) {
                        const disposeMaterial = (le1)=>{
                            le1.map?.dispose(), le1.uniforms && Object.values(le1.uniforms).forEach((le1)=>{
                                le1.value?.dispose?.();
                            }), le1.dispose();
                        };
                        le1.traverse((vt)=>{
                            vt.geometry?.dispose(), vt.material && (Array.isArray(vt.material) ? vt.material.forEach((le1)=>{
                                disposeMaterial(le1);
                            }) : disposeMaterial(vt.material)), vt instanceof ls.Z58 || vt.dispose?.(), vt !== le1 && this.cleanScene(vt);
                        });
                    }
                }, dA = class extends ls.$NF {
                    constructor(){
                        super(...arguments), this._abortController = new AbortController;
                    }
                    abort() {
                        return this._abortController.abort(), this._abortController = new AbortController, this;
                    }
                    load(le1, vt, bt, ls) {
                        const ho = this._abortController.signal, Dl = super.load(le1, (le1)=>{
                            removeEventListeners(), vt(le1);
                        }, bt, (le1)=>{
                            if (removeEventListeners(), ho.aborted) {
                                const le1 = new Error;
                                le1.name = "AbortError", le1.message = "The operation was aborted.", ls(le1);
                            } else ls(le1);
                        });
                        function onAbortSignal() {
                            Dl.src = "";
                        }
                        function removeEventListeners() {
                            ho.removeEventListener("abort", onAbortSignal, !1);
                        }
                        return ho.addEventListener("abort", onAbortSignal, !1), Dl;
                    }
                }, pA = class extends tA {
                    constructor(le1){
                        super(le1), this.fileLoader = new ls.Y9S, this.fileLoader.setResponseType("blob"), this.imageLoader = new dA;
                    }
                    destroy() {
                        this.abortLoading(), super.destroy();
                    }
                    abortLoading() {
                        this.fileLoader.abort?.(), this.imageLoader.abort();
                    }
                    loadFile(le1, vt, bt) {
                        const ls = Yg.get(le1, bt);
                        if (ls) {
                            if (ls instanceof Blob) return vt?.(100), Promise.resolve(ls);
                            Yg.remove(le1, bt);
                        }
                        this.config.requestHeaders && this.fileLoader.setRequestHeader(this.config.requestHeaders(le1)), this.fileLoader.setWithCredentials(this.config.withCredentials(le1));
                        let ho = 0;
                        return vt?.(ho), this.fileLoader.loadAsync(le1, (le1)=>{
                            if (le1.lengthComputable) {
                                const bt = le1.loaded / le1.total * 100;
                                bt > ho && (ho = bt, vt?.(ho));
                            }
                        }).then((ls)=>(ho = 100, vt?.(ho), Yg.add(le1, bt, ls), ls));
                    }
                    loadImage(le1, vt, bt) {
                        const ls = Yg.get(le1, bt);
                        return ls ? (vt?.(100), ls instanceof Blob ? this.blobToImage(ls) : Promise.resolve(ls)) : vt || this.config.requestHeaders ? this.loadFile(le1, vt, bt).then((le1)=>this.blobToImage(le1)) : (this.imageLoader.setWithCredentials(this.config.withCredentials(le1)), this.imageLoader.loadAsync(le1).then((vt)=>(Yg.add(le1, bt, vt), vt)));
                    }
                    blobToImage(le1) {
                        return new Promise((vt, bt)=>{
                            const ls = document.createElement("img");
                            ls.onload = ()=>{
                                URL.revokeObjectURL(ls.src), vt(ls);
                            }, ls.onerror = bt, ls.src = URL.createObjectURL(le1);
                        });
                    }
                    preloadPanorama(le1) {
                        return this.viewer.adapter.supportsPreload(le1) ? this.viewer.adapter.loadTexture(le1, !1) : Promise.reject(new Gd("Current adapter does not support preload"));
                    }
                    dispatchProgress(le1) {
                        this.viewer.loader.setProgress(le1), this.viewer.dispatchEvent(new Im(Math.round(le1)));
                    }
                }, mA = class extends tA {
                    constructor(le1){
                        super(le1), this.zoom = new Kd((le1)=>{
                            this.viewer.state.vFov = this.viewer.dataHelper.zoomLevelToFov(le1), this.viewer.state.hFov = this.viewer.dataHelper.vFovToHFov(this.viewer.state.vFov), this.viewer.dispatchEvent(new sg(le1));
                        }, {
                            defaultValue: this.viewer.config.defaultZoomLvl,
                            min: 0,
                            max: 100,
                            wrap: !1
                        }), this.position = new Jd((le1)=>{
                            this.viewer.dataHelper.sphericalCoordsToVector3(le1, this.viewer.state.direction), this.viewer.dispatchEvent(new jm(le1));
                        }, {
                            yaw: new Kd(null, {
                                defaultValue: this.config.defaultYaw,
                                min: 0,
                                max: 2 * Math.PI,
                                wrap: !0
                            }),
                            pitch: new Kd(null, {
                                defaultValue: this.config.defaultPitch,
                                min: -Math.PI / 2,
                                max: Math.PI / 2,
                                wrap: !1
                            })
                        }), this.roll = new Kd((le1)=>{
                            this.viewer.state.roll = le1, this.viewer.dispatchEvent(new Vm(le1));
                        }, {
                            defaultValue: 0,
                            min: -Math.PI,
                            max: Math.PI,
                            wrap: !1
                        }), this.updateSpeeds();
                    }
                    updateSpeeds() {
                        this.zoom.setSpeed(50 * this.config.zoomSpeed), this.position.setSpeed(ls.cj9.degToRad(50 * this.config.moveSpeed)), this.roll.setSpeed(ls.cj9.degToRad(50 * this.config.moveSpeed));
                    }
                    update(le1) {
                        this.zoom.update(le1), this.position.update(le1), this.roll.update(le1);
                    }
                }, fA = class {
                    constructor(){
                        this.ready = !1, this.needsUpdate = !1, this.continuousUpdateCount = 0, this.keyboardEnabled = !1, this.direction = new ls.Pq0(0, 0, du), this.roll = 0, this.vFov = 60, this.hFov = 60, this.aspect = 1, this.animation = null, this.transitionAnimation = null, this.loadingPromise = null, this.idleTime = -1, this.objectsObservers = {}, this.size = {
                            width: 0,
                            height: 0
                        };
                    }
                }, gA = class extends nm {
                    constructor(le1){
                        if (super(), this.plugins = {}, this.children = [], this.parent = getElement(le1.container), !this.parent) throw new Gd('"container" element not found.');
                        this.parent[_u] = this, this.container = document.createElement("div"), this.container.classList.add("psv-container"), this.parent.appendChild(this.container), checkClosedShadowDom(this.parent), checkStylesheet(this.container, "core"), this.state = new fA, this.config = Gg(le1), this.__setSize(this.config.size), this.overlay = new Kg(this);
                        try {
                            gg.load();
                        } catch (vt) {
                            return console.error(vt), void this.showError(this.config.lang.webglError);
                        }
                        Yg.init(), this.adapter = new this.config.adapter[0](this, this.config.adapter[1]), this.renderer = new hA(this), this.textureLoader = new pA(this), this.eventsHandler = new oA(this), this.dataHelper = new rA(this), this.dynamics = new mA(this), this.adapter.init?.(), this.loader = new Qg(this), this.navbar = new Zg(this), this.panel = new $g(this), this.notification = new Xg(this), this.autoSize(), this.setCursor(null), resolveBoolean(gg.isTouchEnabled, (le1)=>{
                            toggleClass(this.container, "psv--is-touch", le1);
                        }), this.config.plugins.forEach((le1)=>{
                            let [vt, bt] = le1;
                            this.plugins[vt.id] = new vt(this, bt);
                        });
                        for (const bt of Object.values(this.plugins))bt.init?.();
                        this.config.navbar && this.navbar.setButtons(this.config.navbar), this.state.loadingPromise || (this.config.panorama ? this.setPanorama(this.config.panorama, {
                            sphereCorrection: this.config.sphereCorrection,
                            panoData: this.config.panoData
                        }) : this.loader.show());
                    }
                    destroy() {
                        this.stopAll(), this.stopKeyboardControl(), this.exitFullscreen();
                        for (const [le1, vt] of Object.entries(this.plugins))vt.destroy(), delete this.plugins[le1];
                        this.children.slice().forEach((le1)=>le1.destroy()), this.children.length = 0, this.eventsHandler?.destroy(), this.renderer?.destroy(), this.textureLoader?.destroy(), this.dataHelper?.destroy(), this.adapter?.destroy(), this.dynamics?.destroy(), this.parent.removeChild(this.container), delete this.parent[_u];
                    }
                    init() {
                        this.eventsHandler.init(), this.renderer.init(), this.config.navbar && this.navbar.show(), "always" === this.config.keyboard && this.startKeyboardControl(), this.resetIdleTimer(), this.state.ready = !0, this.dispatchEvent(new qm);
                    }
                    resetIdleTimer() {
                        this.state.idleTime = performance.now();
                    }
                    disableIdleTimer() {
                        this.state.idleTime = -1;
                    }
                    getPlugin(le1) {
                        if ("string" === typeof le1) return this.plugins[le1];
                        {
                            const vt = pluginInterop(le1);
                            return vt ? this.plugins[vt.id] : null;
                        }
                    }
                    getPosition() {
                        return this.dataHelper.cleanPosition(this.dynamics.position.current);
                    }
                    getZoomLevel() {
                        return this.dynamics.zoom.current;
                    }
                    getSize() {
                        return {
                            ...this.state.size
                        };
                    }
                    isFullscreenEnabled() {
                        return isFullscreenEnabled(this.parent, gg.isIphone);
                    }
                    needsUpdate() {
                        this.state.needsUpdate = !0;
                    }
                    needsContinuousUpdate(le1) {
                        le1 ? this.state.continuousUpdateCount++ : this.state.continuousUpdateCount > 0 && this.state.continuousUpdateCount--;
                    }
                    autoSize() {
                        this.container.clientWidth === this.state.size.width && this.container.clientHeight === this.state.size.height || (this.state.size.width = Math.round(this.container.clientWidth), this.state.size.height = Math.round(this.container.clientHeight), this.state.aspect = this.state.size.width / this.state.size.height, this.state.hFov = this.dataHelper.vFovToHFov(this.state.vFov), this.dispatchEvent(new ig(this.getSize())), this.navbar.autoSize());
                    }
                    setPanorama(le1, vt) {
                        void 0 === vt && (vt = {}), this.textureLoader.abortLoading(), this.state.transitionAnimation?.cancel();
                        const bt = this.dataHelper.getTransitionOptions(vt);
                        void 0 === vt.showLoader && (vt.showLoader = !0), void 0 === vt.caption && (vt.caption = this.config.caption), void 0 === vt.description && (vt.description = this.config.description), vt.panoData || "function" !== typeof this.config.panoData || (vt.panoData = this.config.panoData), this.hideError(), this.resetIdleTimer(), this.config.panorama = le1, this.config.caption = vt.caption, this.config.description = vt.description, this.config.sphereCorrection = vt.sphereCorrection, "function" === typeof this.config.panoData && "function" !== typeof vt.panoData || (this.config.panoData = vt.panoData);
                        const done = (vt)=>{
                            if (isAbortError(vt)) return !1;
                            if (this.loader.hide(), this.state.loadingPromise = null, vt) throw this.navbar.setCaption(null), this.showError(this.config.lang.loadError), console.error(vt), this.dispatchEvent(new Rm(le1, vt)), vt;
                            return this.navbar.setCaption(this.config.caption), !0;
                        };
                        this.navbar.setCaption(`<em>${this.config.lang.loading}</em>`), !vt.showLoader && this.state.ready || this.loader.show(), this.dispatchEvent(new Lm(le1));
                        const ls = this.adapter.loadTexture(this.config.panorama, !0, vt.panoData).then((le1)=>{
                            if (le1.panorama !== this.config.panorama) throw this.adapter.disposeTexture(le1), getAbortError();
                            const bt = this.dataHelper.cleanPanoramaOptions(vt, le1.panoData);
                            return isNil(bt.zoom) && isNil(bt.position) || this.stopAll(), {
                                textureData: le1,
                                cleanOptions: bt
                            };
                        });
                        return bt && this.state.ready && this.adapter.supportsTransition(this.config.panorama) ? this.state.loadingPromise = ls.then((le1)=>{
                            let { textureData: vt, cleanOptions: ls } = le1;
                            return this.loader.hide(), this.dispatchEvent(new zm(vt)), this.state.transitionAnimation = this.renderer.transition(vt, ls, bt), this.state.transitionAnimation;
                        }).then((le1)=>{
                            if (this.state.transitionAnimation = null, this.dispatchEvent(new Om(le1)), !le1) throw getAbortError();
                        }).then(()=>done(), (le1)=>done(le1)) : this.state.loadingPromise = ls.then((le1)=>{
                            let { textureData: bt, cleanOptions: ls } = le1;
                            this.renderer.show(), this.renderer.setTexture(bt), this.renderer.setPanoramaPose(bt.panoData), this.renderer.setSphereCorrection(vt.sphereCorrection), this.state.ready || this.init(), this.dispatchEvent(new zm(bt)), isNil(ls.zoom) || this.zoom(ls.zoom), isNil(ls.position) || this.rotate(ls.position);
                        }).then(()=>done(), (le1)=>done(le1)), this.state.loadingPromise;
                    }
                    setOptions(le1) {
                        const vt = {
                            ...this.config,
                            ...le1
                        };
                        for (let [bt, ls] of Object.entries(le1))if (bt in jg) {
                            if (bt in Ug) logWarn(Ug[bt]);
                            else switch(bt in Vg && (ls = Vg[bt](ls, {
                                rawConfig: vt,
                                defValue: jg[bt]
                            })), this.config[bt] = ls, bt){
                                case "mousemove":
                                    this.state.cursorOverride || this.setCursor(null);
                                    break;
                                case "caption":
                                    this.navbar.setCaption(this.config.caption);
                                    break;
                                case "size":
                                    this.resize(this.config.size);
                                    break;
                                case "sphereCorrection":
                                    this.renderer.setSphereCorrection(this.config.sphereCorrection);
                                    break;
                                case "navbar":
                                case "lang":
                                    this.navbar.setButtons(this.config.navbar);
                                    break;
                                case "moveSpeed":
                                case "zoomSpeed":
                                    this.dynamics.updateSpeeds();
                                    break;
                                case "minFov":
                                case "maxFov":
                                    this.dynamics.zoom.setValue(this.dataHelper.fovToZoomLevel(this.state.vFov)), this.dispatchEvent(new sg(this.getZoomLevel()));
                                    break;
                                case "keyboard":
                                    "always" === this.config.keyboard ? this.startKeyboardControl() : this.stopKeyboardControl();
                            }
                        } else logWarn(`Unknown option ${bt}`);
                        this.needsUpdate(), this.dispatchEvent(new mm(Object.keys(le1)));
                    }
                    setOption(le1, vt) {
                        this.setOptions({
                            [le1]: vt
                        });
                    }
                    showError(le1) {
                        this.overlay.show({
                            id: Nd.ERROR,
                            image: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="15 15 70 70"><path fill="currentColor" d="M50,16.2c-18.6,0-33.8,15.1-33.8,33.8S31.4,83.7,50,83.7S83.8,68.6,83.8,50S68.6,16.2,50,16.2z M50,80.2c-16.7,0-30.2-13.6-30.2-30.2S33.3,19.7,50,19.7S80.3,33.3,80.3,50S66.7,80.2,50,80.2z"/><rect fill="currentColor" x="48" y="31.7" width="4" height="28"/><rect fill="currentColor" x="48" y="63.2" width="4" height="5"/>\x3c!--Created by Shastry from the Noun Project--\x3e</svg>\n',
                            title: le1,
                            dismissible: !1
                        });
                    }
                    hideError() {
                        this.overlay.hide(Nd.ERROR);
                    }
                    rotate(le1) {
                        const vt = new um(this.dataHelper.cleanPosition(le1));
                        this.dispatchEvent(vt), vt.defaultPrevented || this.dynamics.position.setValue(vt.position);
                    }
                    zoom(le1) {
                        this.dynamics.zoom.setValue(le1);
                    }
                    zoomIn(le1) {
                        void 0 === le1 && (le1 = 1), this.dynamics.zoom.step(le1);
                    }
                    zoomOut(le1) {
                        void 0 === le1 && (le1 = 1), this.dynamics.zoom.step(-le1);
                    }
                    animate(le1) {
                        const vt = isExtendedPosition(le1), bt = !isNil(le1.zoom), ls = new sm(vt ? this.dataHelper.cleanPosition(le1) : void 0, le1.zoom);
                        if (this.dispatchEvent(ls), ls.defaultPrevented) return;
                        this.stopAll();
                        const { duration: ho, properties: Dl } = this.dataHelper.getAnimationProperties(le1.speed, ls.position, ls.zoomLevel);
                        return ho ? (this.state.animation = new Xd({
                            properties: Dl,
                            duration: ho,
                            easing: le1.easing || "inOutSine",
                            onTick: (le1)=>{
                                vt && this.dynamics.position.setValue({
                                    yaw: le1.yaw,
                                    pitch: le1.pitch
                                }), bt && this.dynamics.zoom.setValue(le1.zoom);
                            }
                        }), this.state.animation.then(()=>{
                            this.state.animation = null, this.resetIdleTimer();
                        }), this.state.animation) : (vt && this.rotate(ls.position), bt && this.zoom(ls.zoomLevel), new Xd(null));
                    }
                    stopAnimation() {
                        return this.state.animation ? (this.state.animation.cancel(), this.state.animation) : Promise.resolve();
                    }
                    resize(le1) {
                        this.__setSize(le1), this.autoSize();
                    }
                    __setSize(le1) {
                        [
                            "width",
                            "height"
                        ].forEach((vt)=>{
                            le1?.[vt] && (/^[0-9.]+$/.test(le1[vt]) && (le1[vt] += "px"), this.parent.style[vt] = le1[vt]);
                        });
                    }
                    enterFullscreen() {
                        this.isFullscreenEnabled() || requestFullscreen(this.parent, gg.isIphone);
                    }
                    exitFullscreen() {
                        this.isFullscreenEnabled() && exitFullscreen(gg.isIphone);
                    }
                    toggleFullscreen() {
                        this.isFullscreenEnabled() ? this.exitFullscreen() : this.enterFullscreen();
                    }
                    startKeyboardControl() {
                        this.state.keyboardEnabled = !0;
                    }
                    stopKeyboardControl() {
                        this.state.keyboardEnabled = !1;
                    }
                    createTooltip(le1) {
                        return new eA(this, le1);
                    }
                    setCursor(le1) {
                        this.state.cursorOverride = le1, this.container.style.cursor = le1 || (this.config.mousemove ? "move" : "default");
                    }
                    observeObjects(le1) {
                        this.state.objectsObservers[le1] || (this.state.objectsObservers[le1] = null);
                    }
                    unobserveObjects(le1) {
                        delete this.state.objectsObservers[le1];
                    }
                    stopAll() {
                        return this.dispatchEvent(new rg), this.disableIdleTimer(), this.stopAnimation();
                    }
                };
            },
            3890: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    D: ()=>Ac
                });
                var ls = bt(1545), ho = bt(9435), Dl = class {
                    constructor(le1, vt, bt){
                        this.id = le1, this.priority = vt, this.fn = bt, this.status = 1;
                    }
                    start() {
                        return this.status = 2, this.fn(this).then(()=>{
                            this.status = 4;
                        }, ()=>{
                            this.status = 5;
                        });
                    }
                    cancel() {
                        this.status = 3;
                    }
                    isCancelled() {
                        return 3 === this.status;
                    }
                }, Fl = class {
                    constructor(le1){
                        void 0 === le1 && (le1 = 8), this.concurency = le1, this.runningTasks = {}, this.tasks = {};
                    }
                    enqueue(le1) {
                        this.tasks[le1.id] = le1;
                    }
                    clear() {
                        Object.values(this.tasks).forEach((le1)=>le1.cancel()), this.tasks = {}, this.runningTasks = {};
                    }
                    setPriority(le1, vt) {
                        const bt = this.tasks[le1];
                        bt && (bt.priority = vt, 0 === bt.status && (bt.status = 1));
                    }
                    disableAllTasks() {
                        Object.values(this.tasks).forEach((le1)=>{
                            le1.status = 0;
                        });
                    }
                    start() {
                        if (Object.keys(this.runningTasks).length >= this.concurency) return;
                        const le1 = Object.values(this.tasks).filter((le1)=>1 === le1.status).sort((le1, vt)=>vt.priority - le1.priority).pop();
                        le1 && (this.runningTasks[le1.id] = !0, le1.start().then(()=>{
                            le1.isCancelled() || (delete this.tasks[le1.id], delete this.runningTasks[le1.id], this.start());
                        }), this.start());
                    }
                };
                var sc = [
                    "dodgerblue",
                    "limegreen",
                    "indianred"
                ];
                function isMultiTiles(le1) {
                    return !!le1.levels;
                }
                function computeTileConfig(le1, vt, bt) {
                    return {
                        ...le1,
                        level: vt,
                        colSize: le1.width / le1.cols,
                        rowSize: le1.width / 2 / le1.rows,
                        facesByCol: bt.SPHERE_SEGMENTS / le1.cols,
                        facesByRow: bt.SPHERE_HORIZONTAL_SEGMENTS / le1.rows
                    };
                }
                function getTileConfig(le1, vt, bt, ls, ho) {
                    let Dl, Fl;
                    return isMultiTiles(le1) ? (ls ? (Fl = le1.levels.findIndex((le1)=>{
                        const ho = le1.width / 360 * vt, Dl = le1.width / 2 / 180 * bt;
                        return ho >= ls.width && Dl >= ls.height;
                    }), -1 === Fl && (Fl = le1.levels.length - 1)) : Fl = 0, Dl = le1.levels[Fl]) : (Fl = 0, Dl = {
                        ...le1
                    }), computeTileConfig(Dl, Fl, ho);
                }
                function getTileConfigByIndex(le1, vt, bt) {
                    return isMultiTiles(le1) && le1.levels[vt] ? computeTileConfig(le1.levels[vt], vt, bt) : null;
                }
                function checkTile(le1, vt) {
                    if (!le1.width || !le1.cols || !le1.rows) throw new ls.e6("Invalid panorama configuration, are you using the right adapter?");
                    if (le1.cols > vt.SPHERE_SEGMENTS) throw new ls.e6(`Panorama cols must not be greater than ${vt.SPHERE_SEGMENTS}.`);
                    if (le1.rows > vt.SPHERE_HORIZONTAL_SEGMENTS) throw new ls.e6(`Panorama rows must not be greater than ${vt.SPHERE_HORIZONTAL_SEGMENTS}.`);
                    if (!ho.cj9.isPowerOfTwo(le1.cols) || !ho.cj9.isPowerOfTwo(le1.rows)) throw new ls.e6("Panorama cols and rows must be powers of 2.");
                }
                function getCacheKey(le1, vt) {
                    for(let bt = 0; bt < vt.cols; bt++){
                        const ls = le1.tileUrl(bt, vt.rows / 2, vt.level);
                        if (ls) return ls;
                    }
                    return le1.tileUrl.toString();
                }
                function tileId(le1) {
                    return `${le1.col}x${le1.row}/${le1.config.level}`;
                }
                function meshes(le1) {
                    return le1.children;
                }
                var uc = ls.Wp.getConfigParser({
                    resolution: 64,
                    showErrorTile: !0,
                    baseBlur: !0,
                    antialias: !0,
                    debug: !1,
                    useXmpData: !1
                }), mc = new ho.Pq0, gc = class _EquirectangularTilesAdapter extends ls.Qw {
                    constructor(le1, vt){
                        super(le1), this.state = {
                            tileConfig: null,
                            tiles: {},
                            faces: {},
                            geom: null,
                            materials: [],
                            errorMaterial: null,
                            inTransition: !1
                        }, this.queue = new Fl, this.config = uc(vt), this.adapter = new ls.GR(this.viewer, {
                            resolution: this.config.resolution,
                            blur: this.config.baseBlur
                        }), this.SPHERE_SEGMENTS = this.config.resolution, this.SPHERE_HORIZONTAL_SEGMENTS = this.SPHERE_SEGMENTS / 2, this.NB_VERTICES = 2 * this.SPHERE_SEGMENTS * 3 + (this.SPHERE_HORIZONTAL_SEGMENTS - 2) * this.SPHERE_SEGMENTS * 6, this.NB_GROUPS = this.SPHERE_SEGMENTS * this.SPHERE_HORIZONTAL_SEGMENTS, this.viewer.config.requestHeaders && ls.Wp.logWarn('EquirectangularTilesAdapter fallbacks to file loader because "requestHeaders" where provided. Consider removing "requestHeaders" if you experience performances issues.');
                    }
                    static withConfig(le1) {
                        return [
                            _EquirectangularTilesAdapter,
                            le1
                        ];
                    }
                    init() {
                        super.init(), this.viewer.addEventListener(ls.AZ.TransitionDoneEvent.type, this), this.viewer.addEventListener(ls.AZ.PositionUpdatedEvent.type, this), this.viewer.addEventListener(ls.AZ.ZoomUpdatedEvent.type, this);
                    }
                    destroy() {
                        this.viewer.removeEventListener(ls.AZ.TransitionDoneEvent.type, this), this.viewer.removeEventListener(ls.AZ.PositionUpdatedEvent.type, this), this.viewer.removeEventListener(ls.AZ.ZoomUpdatedEvent.type, this), this.__cleanup(), this.state.errorMaterial?.map?.dispose(), this.state.errorMaterial?.dispose(), this.adapter.destroy(), delete this.adapter, delete this.state.geom, delete this.state.errorMaterial, super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case ls.AZ.PositionUpdatedEvent.type:
                            case ls.AZ.ZoomUpdatedEvent.type:
                                this.__refresh();
                                break;
                            case ls.AZ.TransitionDoneEvent.type:
                                this.state.inTransition = !1, le1.completed && this.__switchMesh(this.viewer.renderer.mesh);
                        }
                    }
                    supportsTransition(le1) {
                        return !!le1.baseUrl;
                    }
                    supportsPreload(le1) {
                        return !!le1.baseUrl;
                    }
                    textureCoordsToSphericalCoords(le1, vt) {
                        return this.adapter.textureCoordsToSphericalCoords(le1, vt);
                    }
                    sphericalCoordsToTextureCoords(le1, vt) {
                        return this.adapter.sphericalCoordsToTextureCoords(le1, vt);
                    }
                    async loadTexture(le1, vt) {
                        void 0 === vt && (vt = !0), function(le1, vt) {
                            if ("object" !== typeof le1 || !le1.tileUrl) throw new ls.e6("Invalid panorama configuration, are you using the right adapter?");
                            isMultiTiles(le1) ? (le1.levels.forEach((le1)=>{
                                checkTile(le1, vt), "zoomRange" in le1 && ls.Wp.logWarn('EquirectangularTilesAdapter: "zoomRange" property is deprecated and must be removed');
                            }), le1.levels.sort((le1, vt)=>le1.width - vt.width)) : checkTile(le1, vt);
                        }(le1, this);
                        const bt = getTileConfig(le1, 0, 0, null, this), ho = {
                            isEquirectangular: !0,
                            fullWidth: bt.width,
                            fullHeight: bt.width / 2,
                            croppedWidth: bt.width,
                            croppedHeight: bt.width / 2,
                            croppedX: 0,
                            croppedY: 0,
                            poseHeading: 0,
                            posePitch: 0,
                            poseRoll: 0
                        };
                        if (le1.baseUrl) {
                            const bt = await this.adapter.loadTexture(le1.baseUrl, vt, le1.basePanoData, !0);
                            return {
                                panorama: le1,
                                panoData: {
                                    ...ho,
                                    baseData: bt.panoData
                                },
                                cacheKey: bt.cacheKey,
                                texture: bt.texture
                            };
                        }
                        return {
                            panorama: le1,
                            panoData: {
                                ...ho,
                                baseData: null
                            },
                            cacheKey: getCacheKey(le1, bt),
                            texture: null
                        };
                    }
                    createMesh(le1) {
                        const vt = this.adapter.createMesh(le1.baseData ?? le1), bt = new ho.Gu$(ls.aH.SPHERE_RADIUS, this.SPHERE_SEGMENTS, this.SPHERE_HORIZONTAL_SEGMENTS, -Math.PI / 2).scale(-1, 1, 1).toNonIndexed();
                        bt.clearGroups();
                        let Dl = 0, Fl = 0;
                        for(; Dl < 3 * this.SPHERE_SEGMENTS; Dl += 3)bt.addGroup(Dl, 3, Fl++);
                        for(; Dl < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS; Dl += 6)bt.addGroup(Dl, 6, Fl++);
                        for(; Dl < this.NB_VERTICES; Dl += 3)bt.addGroup(Dl, 3, Fl++);
                        const sc = [], uc = new ho.V9B({
                            opacity: 0,
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1
                        });
                        for(let ls = 0; ls < this.NB_GROUPS; ls++)sc.push(uc);
                        const mc = new ho.eaF(bt, sc);
                        mc.renderOrder = 1;
                        const gc = new ho.YJl;
                        return gc.add(vt), gc.add(mc), gc;
                    }
                    setTexture(le1, vt, bt) {
                        const [ls] = meshes(le1);
                        vt.texture ? this.adapter.setTexture(ls, {
                            panorama: vt.panorama.baseUrl,
                            texture: vt.texture,
                            panoData: vt.panoData.baseData
                        }) : ls.visible = !1, bt ? this.state.inTransition = !0 : this.__switchMesh(le1);
                    }
                    setTextureOpacity(le1, vt) {
                        const [bt] = meshes(le1);
                        this.adapter.setTextureOpacity(bt, vt);
                    }
                    disposeTexture(le1) {
                        let { texture: vt } = le1;
                        vt?.dispose();
                    }
                    disposeMesh(le1) {
                        const [vt, bt] = meshes(le1);
                        vt.geometry.dispose(), vt.material.dispose(), bt.geometry.dispose(), bt.material.forEach((le1)=>{
                            le1.map?.dispose(), le1.dispose();
                        });
                    }
                    __refresh() {
                        if (!this.state.geom || this.state.inTransition) return;
                        const le1 = this.viewer.config.panorama, vt = getTileConfig(le1, this.viewer.state.hFov, this.viewer.state.vFov, this.viewer.state.size, this), bt = this.state.geom.getAttribute("position"), ls = {};
                        for(let ho = 0; ho < this.NB_VERTICES; ho += 1)if (mc.fromBufferAttribute(bt, ho), mc.applyEuler(this.viewer.renderer.sphereCorrection), this.viewer.renderer.isObjectVisible(mc)) {
                            let bt;
                            bt = ho < 3 * this.SPHERE_SEGMENTS ? Math.floor(ho / 3) : ho < this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS ? Math.floor((ho / 3 - this.SPHERE_SEGMENTS) / 2) + this.SPHERE_SEGMENTS : Math.floor((ho - this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS) / 3) + this.SPHERE_HORIZONTAL_SEGMENTS * (this.SPHERE_SEGMENTS - 1);
                            const Dl = Math.floor(bt / this.SPHERE_SEGMENTS), Fl = bt - Dl * this.SPHERE_SEGMENTS;
                            let sc = vt;
                            for(; sc;){
                                const vt = Math.floor(Dl / sc.facesByRow), bt = Math.floor(Fl / sc.facesByCol);
                                let ho = mc.angleTo(this.viewer.state.direction);
                                0 !== vt && vt !== sc.rows - 1 || (ho *= 2);
                                const uc = {
                                    row: vt,
                                    col: bt,
                                    angle: ho,
                                    config: sc,
                                    url: null
                                }, gc = tileId(uc);
                                if (ls[gc]) {
                                    ls[gc].angle = Math.min(ls[gc].angle, ho);
                                    break;
                                }
                                if (uc.url = le1.tileUrl(bt, vt, sc.level), uc.url) {
                                    ls[gc] = uc;
                                    break;
                                }
                                sc = getTileConfigByIndex(le1, sc.level - 1, this);
                            }
                        }
                        this.state.tileConfig = vt, this.__loadTiles(Object.values(ls));
                    }
                    __loadTiles(le1) {
                        this.queue.disableAllTasks(), le1.forEach((le1)=>{
                            const vt = tileId(le1);
                            this.state.tiles[vt] ? this.queue.setPriority(vt, le1.angle) : (this.state.tiles[vt] = !0, this.queue.enqueue(new Dl(vt, le1.angle, (vt)=>this.__loadTile(le1, vt))));
                        }), this.queue.start();
                    }
                    __loadTile(le1, vt) {
                        return this.viewer.textureLoader.loadImage(le1.url, null, this.viewer.state.textureData.cacheKey).then((bt)=>{
                            if (!vt.isCancelled()) {
                                this.config.debug && (bt = function(le1, vt, bt) {
                                    const ls = document.createElement("canvas");
                                    ls.width = le1.width, ls.height = le1.height;
                                    const ho = ls.getContext("2d");
                                    ho.fillStyle = sc[vt % sc.length], ho.fillRect(0, 0, ls.width, ls.height), ho.globalCompositeOperation = "multiply", ho.drawImage(le1, 0, 0);
                                    const Dl = le1.width / 7;
                                    return ho.globalCompositeOperation = "source-over", ho.fillStyle = "white", ho.font = `${Dl}px monospace`, ho.textAlign = "center", bt.split("\n").forEach((vt, bt)=>{
                                        ho.fillText(vt, le1.width / 2, le1.height / 2 + Dl * (.3 + bt));
                                    }), ls;
                                }(bt, le1.config.level, tileId(le1)));
                                const vt = this.config.antialias && le1.config.level > 0, Dl = new ho.V9B({
                                    map: ls.Wp.createTexture(bt, vt)
                                });
                                this.__swapMaterial(le1, Dl, !1), this.viewer.needsUpdate();
                            }
                        }).catch((bt)=>{
                            ls.Wp.isAbortError(bt) || vt.isCancelled() || !this.config.showErrorTile || (this.state.errorMaterial || (this.state.errorMaterial = function() {
                                const le1 = new OffscreenCanvas(512, 512), vt = le1.getContext("2d");
                                return vt.fillStyle = "#333", vt.fillRect(0, 0, le1.width, le1.height), vt.font = le1.width / 5 + "px serif", vt.fillStyle = "#a22", vt.textAlign = "center", vt.textBaseline = "middle", vt.fillText("\u26a0", le1.width / 2, le1.height / 2), new ho.V9B({
                                    map: ls.Wp.createTexture(le1)
                                });
                            }()), this.__swapMaterial(le1, this.state.errorMaterial, !0), this.viewer.needsUpdate());
                        });
                    }
                    __swapMaterial(le1, vt, bt) {
                        const ls = this.state.geom.getAttribute("uv");
                        for(let ho = 0; ho < le1.config.facesByCol; ho++)for(let Dl = 0; Dl < le1.config.facesByRow; Dl++){
                            const Fl = le1.col * le1.config.facesByCol + ho, sc = le1.row * le1.config.facesByRow + Dl, uc = 0 === sc, mc = sc === this.SPHERE_HORIZONTAL_SEGMENTS - 1;
                            let gc;
                            if (gc = uc ? 3 * Fl : mc ? this.NB_VERTICES - 3 * this.SPHERE_SEGMENTS + 3 * Fl : 3 * this.SPHERE_SEGMENTS + (sc - 1) * this.SPHERE_SEGMENTS * 6 + 6 * Fl, bt && this.state.faces[gc] > -1) continue;
                            if (this.state.faces[gc] > le1.config.level) continue;
                            this.state.faces[gc] = bt ? -1 : le1.config.level;
                            const Ac = this.state.geom.groups.find((le1)=>le1.start === gc).materialIndex;
                            this.state.materials[Ac] = vt;
                            const Ec = 1 - Dl / le1.config.facesByRow, kc = 1 - (Dl + 1) / le1.config.facesByRow, du = ho / le1.config.facesByCol, _u = (ho + 1) / le1.config.facesByCol;
                            uc ? (ls.setXY(gc, (du + _u) / 2, Ec), ls.setXY(gc + 1, du, kc), ls.setXY(gc + 2, _u, kc)) : mc ? (ls.setXY(gc, _u, Ec), ls.setXY(gc + 1, du, Ec), ls.setXY(gc + 2, (du + _u) / 2, kc)) : (ls.setXY(gc, _u, Ec), ls.setXY(gc + 1, du, Ec), ls.setXY(gc + 2, _u, kc), ls.setXY(gc + 3, du, Ec), ls.setXY(gc + 4, du, kc), ls.setXY(gc + 5, _u, kc));
                        }
                        ls.needsUpdate = !0;
                    }
                    __switchMesh(le1) {
                        const [, vt] = meshes(le1);
                        if (this.__cleanup(), this.state.materials = vt.material, this.state.geom = vt.geometry, this.config.debug) {
                            const le1 = function(le1) {
                                const vt = new ho.XJ7(le1), bt = new ho.DXC(vt);
                                return bt.material.depthTest = !1, bt.material.depthWrite = !1, bt.material.opacity = .25, bt.material.transparent = !0, bt;
                            }(this.state.geom);
                            this.viewer.renderer.addObject(le1), this.viewer.renderer.setSphereCorrection(this.viewer.config.sphereCorrection, le1);
                        }
                        setTimeout(()=>this.__refresh());
                    }
                    __cleanup() {
                        this.queue.clear(), this.state.tiles = {}, this.state.faces = {}, this.state.materials = [], this.state.inTransition = !1;
                    }
                };
                gc.id = "equirectangular-tiles", gc.VERSION = "5.14.1", gc.supportsDownload = !1;
                var Ac = gc;
            },
            4991: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    b: ()=>Cm
                });
                var ls = bt(1545), ho = bt(9435), Dl = Object.defineProperty;
                ((le1, vt)=>{
                    for(var bt in vt)Dl(le1, bt, {
                        get: vt[bt],
                        enumerable: !0
                    });
                })({}, {
                    EnterMarkerEvent: ()=>du,
                    GotoMarkerDoneEvent: ()=>gc,
                    HideMarkersEvent: ()=>Ud,
                    LeaveMarkerEvent: ()=>Ec,
                    MarkerVisibilityEvent: ()=>uc,
                    MarkersPluginEvent: ()=>Fl,
                    RenderMarkersListEvent: ()=>Yd,
                    SelectMarkerEvent: ()=>Md,
                    SelectMarkerListEvent: ()=>Nd,
                    SetMarkersEvent: ()=>qd,
                    ShowMarkersEvent: ()=>Wd,
                    UnselectMarkerEvent: ()=>Od
                });
                var Fl = class extends ls.rx {
                }, sc = class _MarkerVisibilityEvent extends Fl {
                    constructor(le1, vt){
                        super(_MarkerVisibilityEvent.type), this.marker = le1, this.visible = vt;
                    }
                };
                sc.type = "marker-visibility";
                var uc = sc, mc = class _GotoMarkerDoneEvent extends Fl {
                    constructor(le1){
                        super(_GotoMarkerDoneEvent.type), this.marker = le1;
                    }
                };
                mc.type = "goto-marker-done";
                var gc = mc, Ac = class _LeaveMarkerEvent extends Fl {
                    constructor(le1){
                        super(_LeaveMarkerEvent.type), this.marker = le1;
                    }
                };
                Ac.type = "leave-marker";
                var Ec = Ac, kc = class _EnterMarkerEvent extends Fl {
                    constructor(le1){
                        super(_EnterMarkerEvent.type), this.marker = le1;
                    }
                };
                kc.type = "enter-marker";
                var du = kc, _u = class _SelectMarkerEvent extends Fl {
                    constructor(le1, vt, bt){
                        super(_SelectMarkerEvent.type), this.marker = le1, this.doubleClick = vt, this.rightClick = bt;
                    }
                };
                _u.type = "select-marker";
                var Md = _u, Ld = class _SelectMarkerListEvent extends Fl {
                    constructor(le1){
                        super(_SelectMarkerListEvent.type), this.marker = le1;
                    }
                };
                Ld.type = "select-marker-list";
                var Nd = Ld, Rd = class _UnselectMarkerEvent extends Fl {
                    constructor(le1){
                        super(_UnselectMarkerEvent.type), this.marker = le1;
                    }
                };
                Rd.type = "unselect-marker";
                var Od = Rd, jd = class _HideMarkersEvent extends Fl {
                    constructor(){
                        super(_HideMarkersEvent.type);
                    }
                };
                jd.type = "hide-markers";
                var Ud = jd, Gd = class _SetMarkersEvent extends Fl {
                    constructor(le1){
                        super(_SetMarkersEvent.type), this.markers = le1;
                    }
                };
                Gd.type = "set-markers";
                var qd = Gd, Hd = class _ShowMarkersEvent extends Fl {
                    constructor(){
                        super(_ShowMarkersEvent.type);
                    }
                };
                Hd.type = "show-markers";
                var Wd = Hd, Zd = class _RenderMarkersListEvent extends Fl {
                    constructor(le1){
                        super(_RenderMarkersListEvent.type), this.markers = le1;
                    }
                };
                Zd.type = "render-markers-list";
                var Yd = Zd, Qd = class extends ls.Np {
                    constructor(le1){
                        super(le1, {
                            className: "psv-markers-button",
                            icon: '<svg xmlns="http://www.w3.org/2000/svg" viewBox="10 9 81 81"><path fill="currentColor" d="M50.5 90S22.9 51.9 22.9 36.6 35.2 9 50.5 9s27.6 12.4 27.6 27.6S50.5 90 50.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n',
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0
                        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.plugin.addEventListener(Wd.type, this), this.plugin.addEventListener(Ud.type, this), this.toggleActive(!0));
                    }
                    destroy() {
                        this.plugin && (this.plugin.removeEventListener(Wd.type, this), this.plugin.removeEventListener(Ud.type, this)), super.destroy();
                    }
                    isSupported() {
                        return !!this.plugin;
                    }
                    handleEvent(le1) {
                        le1 instanceof Wd ? this.toggleActive(!0) : le1 instanceof Ud && this.toggleActive(!1);
                    }
                    onClick() {
                        this.plugin.toggleAllMarkers();
                    }
                };
                Qd.id = "markers";
                var Xd = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="9 9 81 81"><path fill="currentColor" d="M37.5 90S9.9 51.9 9.9 36.6 22.2 9 37.5 9s27.6 12.4 27.6 27.6S37.5 90 37.5 90zm0-66.3c-6.1 0-11 4.9-11 11s4.9 11 11 11 11-4.9 11-11-4.9-11-11-11zM86.7 55H70c-1.8 0-3.3-1.5-3.3-3.3s1.5-3.3 3.3-3.3h16.7c1.8 0 3.3 1.5 3.3 3.3S88.5 55 86.7 55zm0-25h-15a3.3 3.3 0 0 1-3.3-3.3c0-1.8 1.5-3.3 3.3-3.3h15c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3zM56.5 73h30c1.8 0 3.3 1.5 3.3 3.3 0 1.8-1.5 3.3-3.3 3.3h-30a3.3 3.3 0 0 1-3.3-3.3 3.2 3.2 0 0 1 3.3-3.3z"/>\x3c!--Created by Rohith M S from the Noun Project--\x3e</svg>\n', Kd = "http://www.w3.org/2000/svg", Jd = "psvMarker", $d = ls.Wp.dasherize(Jd), sp = "marker", em = "markersList", tm = {
                    amount: 2,
                    duration: 100,
                    easing: "linear"
                }, MARKERS_LIST_TEMPLATE = (le1, vt)=>`\n<div class="psv-panel-menu psv-panel-menu--stripped">\n    <h1 class="psv-panel-menu-title">${Xd} ${vt}</h1>\n    <ul class="psv-panel-menu-list">\n    ${le1.map((le1)=>`\n        <li data-${$d}="${le1.id}" class="psv-panel-menu-item" tabindex="0">\n          ${"image" === le1.type ? `<span class="psv-panel-menu-item-icon"><img src="${le1.definition}"/></span>` : ""}\n          <span class="psv-panel-menu-item-label">${le1.getListContent()}</span>\n        </li>\n    `).join("")}\n    </ul>\n</div>\n`, im = class extends ls.Np {
                    constructor(le1){
                        super(le1, {
                            className: " psv-markers-list-button",
                            icon: Xd,
                            hoverScale: !0,
                            collapsable: !0,
                            tabbable: !0
                        }), this.plugin = this.viewer.getPlugin("markers"), this.plugin && (this.viewer.addEventListener(ls.AZ.ShowPanelEvent.type, this), this.viewer.addEventListener(ls.AZ.HidePanelEvent.type, this));
                    }
                    destroy() {
                        this.viewer.removeEventListener(ls.AZ.ShowPanelEvent.type, this), this.viewer.removeEventListener(ls.AZ.HidePanelEvent.type, this), super.destroy();
                    }
                    isSupported() {
                        return !!this.plugin;
                    }
                    handleEvent(le1) {
                        le1 instanceof ls.AZ.ShowPanelEvent ? this.toggleActive(le1.panelId === em) : le1 instanceof ls.AZ.HidePanelEvent && this.toggleActive(!1);
                    }
                    onClick() {
                        this.plugin.toggleMarkersList();
                    }
                };
                im.id = "markersList";
                var nm = new ho.Pq0, rm = new ho.PTz, am = new ho.Pq0, sm = class extends ho.B69 {
                    constructor(le1){
                        void 0 === le1 && (le1 = document.createElement("div")), super(), this.isCSS3DObject = !0, this.element = le1, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
                            this.traverse(function(le1) {
                                le1.element instanceof le1.element.ownerDocument.defaultView.Element && null !== le1.element.parentNode && le1.element.remove();
                            });
                        });
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.element = le1.element.cloneNode(!0), this;
                    }
                }, om = new ho.kn4, lm = new ho.kn4, cm = class {
                    constructor(le1){
                        void 0 === le1 && (le1 = {});
                        const vt = this;
                        let bt, ls, ho, Dl;
                        const Fl = {
                            camera: {
                                style: ""
                            },
                            objects: new WeakMap
                        }, sc = void 0 !== le1.element ? le1.element : document.createElement("div");
                        sc.style.overflow = "hidden", this.domElement = sc;
                        const uc = document.createElement("div");
                        uc.style.transformOrigin = "0 0", uc.style.pointerEvents = "none", sc.appendChild(uc);
                        const mc = document.createElement("div");
                        function epsilon(le1) {
                            return Math.abs(le1) < 1e-10 ? 0 : le1;
                        }
                        function getCameraCSSMatrix(le1) {
                            const vt = le1.elements;
                            return "matrix3d(" + epsilon(vt[0]) + "," + epsilon(-vt[1]) + "," + epsilon(vt[2]) + "," + epsilon(vt[3]) + "," + epsilon(vt[4]) + "," + epsilon(-vt[5]) + "," + epsilon(vt[6]) + "," + epsilon(vt[7]) + "," + epsilon(vt[8]) + "," + epsilon(-vt[9]) + "," + epsilon(vt[10]) + "," + epsilon(vt[11]) + "," + epsilon(vt[12]) + "," + epsilon(-vt[13]) + "," + epsilon(vt[14]) + "," + epsilon(vt[15]) + ")";
                        }
                        function getObjectCSSMatrix(le1) {
                            const vt = le1.elements;
                            return "translate(-50%,-50%)" + ("matrix3d(" + epsilon(vt[0]) + "," + epsilon(vt[1]) + "," + epsilon(vt[2]) + "," + epsilon(vt[3]) + "," + epsilon(-vt[4]) + "," + epsilon(-vt[5]) + "," + epsilon(-vt[6]) + "," + epsilon(-vt[7]) + "," + epsilon(vt[8]) + "," + epsilon(vt[9]) + "," + epsilon(vt[10]) + "," + epsilon(vt[11]) + "," + epsilon(vt[12]) + "," + epsilon(vt[13]) + "," + epsilon(vt[14]) + "," + epsilon(vt[15]) + ")");
                        }
                        function hideObject(le1) {
                            le1.isCSS3DObject && (le1.element.style.display = "none");
                            for(let vt = 0, bt = le1.children.length; vt < bt; vt++)hideObject(le1.children[vt]);
                        }
                        function renderObject(le1, bt, ls, ho) {
                            if (!1 !== le1.visible) {
                                if (le1.isCSS3DObject) {
                                    const ho = !0 === le1.layers.test(ls.layers), Dl = le1.element;
                                    if (Dl.style.display = !0 === ho ? "" : "none", !0 === ho) {
                                        let ho;
                                        le1.onBeforeRender(vt, bt, ls), le1.isCSS3DSprite ? (om.copy(ls.matrixWorldInverse), om.transpose(), 0 !== le1.rotation2D && om.multiply(lm.makeRotationZ(le1.rotation2D)), le1.matrixWorld.decompose(nm, rm, am), om.setPosition(nm), om.scale(am), om.elements[3] = 0, om.elements[7] = 0, om.elements[11] = 0, om.elements[15] = 1, ho = getObjectCSSMatrix(om)) : ho = getObjectCSSMatrix(le1.matrixWorld);
                                        const sc = Fl.objects.get(le1);
                                        if (void 0 === sc || sc.style !== ho) {
                                            Dl.style.transform = ho;
                                            const vt = {
                                                style: ho
                                            };
                                            Fl.objects.set(le1, vt);
                                        }
                                        Dl.parentNode !== mc && mc.appendChild(Dl), le1.onAfterRender(vt, bt, ls);
                                    }
                                }
                                for(let vt = 0, Dl = le1.children.length; vt < Dl; vt++)renderObject(le1.children[vt], bt, ls, ho);
                            } else hideObject(le1);
                        }
                        mc.style.transformStyle = "preserve-3d", uc.appendChild(mc), this.getSize = function() {
                            return {
                                width: bt,
                                height: ls
                            };
                        }, this.render = function(le1, vt) {
                            const sc = vt.projectionMatrix.elements[5] * Dl;
                            let gc, Ac;
                            vt.view && vt.view.enabled ? (uc.style.transform = `translate( ${-vt.view.offsetX * (bt / vt.view.width)}px, ${-vt.view.offsetY * (ls / vt.view.height)}px )`, uc.style.transform += `scale( ${vt.view.fullWidth / vt.view.width}, ${vt.view.fullHeight / vt.view.height} )`) : uc.style.transform = "", !0 === le1.matrixWorldAutoUpdate && le1.updateMatrixWorld(), null === vt.parent && !0 === vt.matrixWorldAutoUpdate && vt.updateMatrixWorld(), vt.isOrthographicCamera && (gc = -(vt.right + vt.left) / 2, Ac = (vt.top + vt.bottom) / 2);
                            const Ec = vt.view && vt.view.enabled ? vt.view.height / vt.view.fullHeight : 1, kc = vt.isOrthographicCamera ? `scale( ${Ec} )scale(` + sc + ")translate(" + epsilon(gc) + "px," + epsilon(Ac) + "px)" + getCameraCSSMatrix(vt.matrixWorldInverse) : `scale( ${Ec} )translateZ(` + sc + "px)" + getCameraCSSMatrix(vt.matrixWorldInverse), du = (vt.isPerspectiveCamera ? "perspective(" + sc + "px) " : "") + kc + "translate(" + ho + "px," + Dl + "px)";
                            Fl.camera.style !== du && (mc.style.transform = du, Fl.camera.style = du), renderObject(le1, le1, vt, kc);
                        }, this.setSize = function(le1, vt) {
                            bt = le1, ls = vt, ho = bt / 2, Dl = ls / 2, sc.style.width = le1 + "px", sc.style.height = vt + "px", uc.style.width = le1 + "px", uc.style.height = vt + "px", mc.style.width = le1 + "px", mc.style.height = vt + "px";
                        };
                    }
                }, um = class {
                    constructor(le1){
                        this.viewer = le1, this.element = document.createElement("div"), this.element.className = "psv-markers-css3d-container", this.renderer = new cm({
                            element: this.element
                        }), this.scene = new ho.Z58, this.intersectionObserver = new IntersectionObserver((le1)=>{
                            le1.forEach((le1)=>{
                                const vt = le1.target[Jd];
                                vt.config.visible && (vt.viewportIntersection = le1.isIntersecting);
                            });
                        }, {
                            root: this.element
                        }), le1.addEventListener(ls.AZ.ReadyEvent.type, this, {
                            once: !0
                        }), le1.addEventListener(ls.AZ.SizeUpdatedEvent.type, this), le1.addEventListener(ls.AZ.RenderEvent.type, this);
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case ls.AZ.ReadyEvent.type:
                            case ls.AZ.SizeUpdatedEvent.type:
                                this.updateSize();
                                break;
                            case ls.AZ.RenderEvent.type:
                                this.render();
                        }
                    }
                    destroy() {
                        this.viewer.removeEventListener(ls.AZ.ReadyEvent.type, this), this.viewer.removeEventListener(ls.AZ.SizeUpdatedEvent.type, this), this.viewer.removeEventListener(ls.AZ.RenderEvent.type, this), this.intersectionObserver.disconnect();
                    }
                    updateSize() {
                        const le1 = this.viewer.getSize();
                        this.renderer.setSize(le1.width, le1.height);
                    }
                    render() {
                        this.renderer.render(this.scene, this.viewer.renderer.camera);
                    }
                    addObject(le1) {
                        this.scene.add(le1.threeElement), this.intersectionObserver.observe(le1.domElement);
                    }
                    removeObject(le1) {
                        this.scene.remove(le1.threeElement), this.intersectionObserver.unobserve(le1.domElement);
                    }
                }, hm = ((le1)=>(le1.image = "image", le1.html = "html", le1.element = "element", le1.imageLayer = "imageLayer", le1.videoLayer = "videoLayer", le1.elementLayer = "elementLayer", le1.polygon = "polygon", le1.polygonPixels = "polygonPixels", le1.polyline = "polyline", le1.polylinePixels = "polylinePixels", le1.square = "square", le1.rect = "rect", le1.circle = "circle", le1.ellipse = "ellipse", le1.path = "path", le1))(hm || {});
                function getMarkerType(le1, vt) {
                    void 0 === vt && (vt = !1);
                    const bt = [];
                    if (Object.keys(hm).forEach((vt)=>{
                        le1[vt] && bt.push(vt);
                    }), 0 === bt.length && !vt) throw new ls.e6(`missing marker content, either ${Object.keys(hm).join(", ")}`);
                    if (bt.length > 1) throw new ls.e6(`multiple marker content, either ${Object.keys(hm).join(", ")}`);
                    return bt[0];
                }
                var dm = class {
                    constructor(le1, vt, bt){
                        if (this.viewer = le1, this.plugin = vt, this.state = {
                            anchor: null,
                            visible: !1,
                            staticTooltip: !1,
                            position: null,
                            position2D: null,
                            positions3D: null,
                            size: null
                        }, !bt.id) throw new ls.e6("missing marker id");
                        this.type = getMarkerType(bt), this.createElement(), this.update(bt);
                    }
                    get id() {
                        return this.config.id;
                    }
                    get data() {
                        return this.config.data;
                    }
                    get domElement() {
                        return null;
                    }
                    get threeElement() {
                        return null;
                    }
                    get video() {
                        return null;
                    }
                    destroy() {
                        delete this.viewer, delete this.plugin, delete this.element, this.hideTooltip();
                    }
                    is3d() {
                        return !1;
                    }
                    isNormal() {
                        return !1;
                    }
                    isPoly() {
                        return !1;
                    }
                    isSvg() {
                        return !1;
                    }
                    isCss3d() {
                        return !1;
                    }
                    update(le1) {
                        const vt = getMarkerType(le1, !0);
                        if (void 0 !== vt && vt !== this.type) throw new ls.e6(`cannot change marker ${le1.id} type`);
                        if (this.config = ls.Wp.deepmerge(this.config, le1), "string" === typeof this.config.tooltip && (this.config.tooltip = {
                            content: this.config.tooltip
                        }), this.config.tooltip && !this.config.tooltip.trigger && (this.config.tooltip.trigger = "hover"), ls.Wp.isNil(this.config.visible) && (this.config.visible = !0), ls.Wp.isNil(this.config.zIndex) && (this.config.zIndex = 1), ls.Wp.isNil(this.config.opacity) && (this.config.opacity = 1), this.config.rotation) {
                            const le1 = this.config.rotation;
                            this.config.rotation = "object" === typeof le1 ? {
                                yaw: le1.yaw ? ls.Wp.parseAngle(le1.yaw, !0, !1) : 0,
                                pitch: le1.pitch ? ls.Wp.parseAngle(le1.pitch, !0, !1) : 0,
                                roll: le1.roll ? ls.Wp.parseAngle(le1.roll, !0, !1) : 0
                            } : {
                                yaw: 0,
                                pitch: 0,
                                roll: ls.Wp.parseAngle(le1, !0, !1)
                            };
                        } else this.config.rotation = {
                            yaw: 0,
                            pitch: 0,
                            roll: 0
                        };
                        this.state.anchor = ls.Wp.parsePoint(this.config.anchor);
                    }
                    getListContent() {
                        return this.config.listContent ? this.config.listContent : this.config.tooltip?.content ? this.config.tooltip.content : this.config.html ? this.config.html : this.id;
                    }
                    showTooltip(le1, vt, bt) {
                        if (void 0 === bt && (bt = !1), this.state.visible && this.config.tooltip?.content && this.state.position2D) {
                            const ho = {
                                ...this.config.tooltip,
                                style: {
                                    pointerEvents: this.state.staticTooltip ? "auto" : "none"
                                },
                                data: this,
                                top: 0,
                                left: 0
                            };
                            if (this.isPoly() || this.is3d() || this.isCss3d()) {
                                if (le1 || vt) {
                                    const bt = ls.Wp.getPosition(this.viewer.container);
                                    ho.top = vt - bt.y + 10, ho.left = le1 - bt.x, ho.box = {
                                        width: 20,
                                        height: 20
                                    };
                                } else ho.top = this.state.position2D.y, ho.left = this.state.position2D.x;
                            } else {
                                const le1 = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                                let vt = this.state.size.width, bt = this.state.size.height;
                                this.config.hoverScale && !this.state.staticTooltip && (vt *= this.config.hoverScale.amount, bt *= this.config.hoverScale.amount), ho.top = le1.y - bt * this.state.anchor.y + bt / 2, ho.left = le1.x - vt * this.state.anchor.x + vt / 2, ho.box = {
                                    width: vt,
                                    height: bt
                                };
                            }
                            this.tooltip ? bt ? this.tooltip.update(this.config.tooltip.content, ho) : this.tooltip.move(ho) : this.tooltip = this.viewer.createTooltip(ho);
                        }
                    }
                    hideTooltip() {
                        this.tooltip && (this.tooltip.hide(), this.tooltip = null);
                    }
                }, pm = class extends dm {
                    get domElement() {
                        return this.element;
                    }
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    afterCreateElement() {
                        this.element[Jd] = this;
                    }
                    destroy() {
                        delete this.element[Jd], super.destroy();
                    }
                    update(le1) {
                        super.update(le1);
                        const vt = this.domElement;
                        vt.id = `psv-marker-${this.config.id}`, vt.setAttribute("class", "psv-marker"), this.state.visible && vt.classList.add("psv-marker--visible"), this.config.tooltip && vt.classList.add("psv-marker--has-tooltip"), this.config.content && vt.classList.add("psv-marker--has-content"), this.config.className && ls.Wp.addClasses(vt, this.config.className), vt.style.opacity = `${this.config.opacity}`, vt.style.zIndex = `${30 + this.config.zIndex}`, this.config.style && Object.assign(vt.style, this.config.style);
                    }
                }, mm = class extends pm {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    afterCreateElement() {
                        super.afterCreateElement(), this.domElement.addEventListener("transitionend", ()=>{
                            this.domElement.style.transition = "";
                        });
                    }
                    render(le1) {
                        let { viewerPosition: vt, zoomLevel: bt, hoveringMarker: ls } = le1;
                        this.__updateSize();
                        const ho = this.viewer.dataHelper.vector3ToViewerCoords(this.state.positions3D[0]);
                        ho.x -= this.state.size.width * this.state.anchor.x, ho.y -= this.state.size.height * this.state.anchor.y;
                        return this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && ho.x + this.state.size.width >= 0 && ho.x - this.state.size.width <= this.viewer.state.size.width && ho.y + this.state.size.height >= 0 && ho.y - this.state.size.height <= this.viewer.state.size.height ? (this.domElement.style.translate = `${ho.x}px ${ho.y}px 0px`, this.applyScale({
                            zoomLevel: bt,
                            viewerPosition: vt,
                            mouseover: this === ls
                        }), ho) : null;
                    }
                    update(le1) {
                        if (super.update(le1), !ls.Wp.isExtendedPosition(this.config.position)) throw new ls.e6(`missing marker ${this.id} position`);
                        try {
                            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                        } catch (bt) {
                            throw new ls.e6(`invalid marker ${this.id} position`, bt);
                        }
                        this.state.positions3D = [
                            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
                        ];
                        const vt = this.domElement;
                        vt.classList.add("psv-marker--normal"), this.config.scale && Array.isArray(this.config.scale) && (this.config.scale = {
                            zoom: this.config.scale
                        }), "boolean" === typeof this.config.hoverScale ? this.config.hoverScale = this.config.hoverScale ? this.plugin.config.defaultHoverScale || tm : null : "number" === typeof this.config.hoverScale ? this.config.hoverScale = {
                            amount: this.config.hoverScale
                        } : this.config.hoverScale || (this.config.hoverScale = this.plugin.config.defaultHoverScale), this.config.hoverScale && (this.config.hoverScale = {
                            ...this.plugin.config.defaultHoverScale,
                            ...this.config.hoverScale
                        }), vt.style.rotate = 0 !== this.config.rotation.roll ? ho.cj9.radToDeg(this.config.rotation.roll) + "deg" : null, vt.style.transformOrigin = `${100 * this.state.anchor.x}% ${100 * this.state.anchor.y}%`;
                    }
                    __updateSize() {
                        if (!this.needsUpdateSize) return;
                        const le1 = this.domElement, vt = !this.state.visible || !this.state.size;
                        if (vt && le1.classList.add("psv-marker--transparent"), this.isSvg()) {
                            const vt = le1.firstElementChild.getBoundingClientRect();
                            this.state.size = {
                                width: vt.width,
                                height: vt.height
                            };
                        } else this.state.size = {
                            width: le1.offsetWidth,
                            height: le1.offsetHeight
                        };
                        vt && le1.classList.remove("psv-marker--transparent"), this.isSvg() && (le1.style.width = this.state.size.width + "px", le1.style.height = this.state.size.height + "px"), "element" !== this.type && (this.needsUpdateSize = !1);
                    }
                    applyScale(le1) {
                        let { zoomLevel: vt, viewerPosition: bt, mouseover: Dl } = le1;
                        null !== Dl && this.config.hoverScale && (this.domElement.style.transition = `scale ${this.config.hoverScale.duration}ms ${this.config.hoverScale.easing}`);
                        let Fl = 1;
                        if ("function" === typeof this.config.scale) Fl = this.config.scale(vt, bt);
                        else if (this.config.scale) {
                            if (Array.isArray(this.config.scale.zoom)) {
                                const [le1, bt] = this.config.scale.zoom;
                                Fl *= le1 + (bt - le1) * ls.aH.EASINGS.inQuad(vt / 100);
                            }
                            if (Array.isArray(this.config.scale.yaw)) {
                                const [le1, vt] = this.config.scale.yaw, Dl = ho.cj9.degToRad(this.viewer.state.hFov) / 2, sc = Math.abs(ls.Wp.getShortestArc(this.state.position.yaw, bt.yaw));
                                Fl *= vt + (le1 - vt) * ls.aH.EASINGS.outQuad(Math.max(0, (Dl - sc) / Dl));
                            }
                        }
                        Dl && this.config.hoverScale && (Fl *= this.config.hoverScale.amount), this.domElement.style.scale = `${Fl}`;
                    }
                }, fm = class extends ho.BKk {
                    get map() {
                        return this.uniforms.map.value;
                    }
                    set map(le1) {
                        this.uniforms.map.value = le1;
                    }
                    set alpha(le1) {
                        this.uniforms.alpha.value = le1;
                    }
                    get offset() {
                        return this.uniforms.offset.value;
                    }
                    get repeat() {
                        return this.uniforms.repeat.value;
                    }
                    set chromaKey(le1) {
                        this.uniforms.keying.value = !0 === le1?.enabled, le1?.enabled && ("object" === typeof le1.color && "r" in le1.color ? this.uniforms.color.value.set(le1.color.r / 255, le1.color.g / 255, le1.color.b / 255) : this.uniforms.color.value.set(le1.color ?? 65280), this.uniforms.similarity.value = le1.similarity ?? .2, this.uniforms.smoothness.value = le1.smoothness ?? .2);
                    }
                    constructor(le1){
                        super({
                            transparent: !0,
                            depthTest: !1,
                            depthWrite: !1,
                            uniforms: {
                                map: {
                                    value: le1?.map
                                },
                                repeat: {
                                    value: new ho.I9Y(1, 1)
                                },
                                offset: {
                                    value: new ho.I9Y(0, 0)
                                },
                                alpha: {
                                    value: le1?.alpha ?? 1
                                },
                                keying: {
                                    value: !1
                                },
                                color: {
                                    value: new ho.Q1f(65280)
                                },
                                similarity: {
                                    value: .2
                                },
                                smoothness: {
                                    value: .2
                                },
                                spill: {
                                    value: .1
                                }
                            },
                            vertexShader: "varying vec2 vUv;\nuniform vec2 repeat;\nuniform vec2 offset;\n\nvoid main() {\n    vUv = uv * repeat + offset;\n    gl_Position = projectionMatrix *  modelViewMatrix * vec4( position, 1.0 );\n}\n",
                            fragmentShader: "// https://www.8thwall.com/playground/chromakey-threejs\n\nuniform sampler2D map;\nuniform float alpha;\nuniform bool keying;\nuniform vec3 color;\nuniform float similarity;\nuniform float smoothness;\nuniform float spill;\n\nvarying vec2 vUv;\n\nvec2 RGBtoUV(vec3 rgb) {\n    return vec2(\n        rgb.r * -0.169 + rgb.g * -0.331 + rgb.b *  0.5    + 0.5,\n        rgb.r *  0.5   + rgb.g * -0.419 + rgb.b * -0.081  + 0.5\n    );\n}\n\nvoid main(void) {\n    gl_FragColor = texture2D(map, vUv);\n\n    if (keying) {\n        float chromaDist = distance(RGBtoUV(gl_FragColor.rgb), RGBtoUV(color));\n\n        float baseMask = chromaDist - similarity;\n        float fullMask = pow(clamp(baseMask / smoothness, 0., 1.), 1.5);\n        gl_FragColor.a *= fullMask * alpha;\n\n        float spillVal = pow(clamp(baseMask / spill, 0., 1.), 1.5);\n        float desat = clamp(gl_FragColor.r * 0.2126 + gl_FragColor.g * 0.7152 + gl_FragColor.b * 0.0722, 0., 1.);\n        gl_FragColor.rgb = mix(vec3(desat, desat, desat), gl_FragColor.rgb, spillVal);\n    } else {\n        gl_FragColor.a *= alpha;\n    }\n}\n"
                        }), this.chromaKey = le1?.chromaKey;
                    }
                };
                function greatArcIntermediaryPoint(le1, vt, bt) {
                    const [ho, Dl] = le1, [Fl, sc] = vt, uc = ls.Wp.greatArcDistance(le1, vt), mc = Math.sin((1 - bt) * uc) / Math.sin(uc), gc = Math.sin(bt * uc) / Math.sin(uc), Ac = mc * Math.cos(Dl) * Math.cos(ho) + gc * Math.cos(sc) * Math.cos(Fl), Ec = mc * Math.cos(Dl) * Math.sin(ho) + gc * Math.cos(sc) * Math.sin(Fl), kc = mc * Math.sin(Dl) + gc * Math.sin(sc);
                    return [
                        Math.atan2(Ec, Ac),
                        Math.atan2(kc, Math.sqrt(Ac * Ac + Ec * Ec))
                    ];
                }
                function getPolygonCenter(le1) {
                    return le1.reduce((le1, vt)=>le1.add(vt), new ho.Pq0).normalize();
                }
                function getPolylineCenter(le1) {
                    const vt = function(le1) {
                        const vt = [
                            le1[0]
                        ];
                        let bt = 0;
                        for(let ls = 1; ls < le1.length; ls++){
                            const ho = le1[ls - 1][0] - le1[ls][0];
                            ho > Math.PI ? bt += 1 : ho < -Math.PI && (bt -= 1), vt.push([
                                le1[ls][0] + 2 * bt * Math.PI,
                                le1[ls][1]
                            ]);
                        }
                        return vt;
                    }(le1);
                    let bt = 0;
                    const ho = [];
                    for(let Fl = 0; Fl < vt.length - 1; Fl++){
                        const le1 = ls.Wp.greatArcDistance(vt[Fl], vt[Fl + 1]) * ls.aH.SPHERE_RADIUS;
                        ho.push(le1), bt += le1;
                    }
                    let Dl = 0;
                    for(let ls = 0; ls < vt.length - 1; ls++){
                        if (Dl + ho[ls] > bt / 2) {
                            const le1 = (bt / 2 - Dl) / ho[ls];
                            return greatArcIntermediaryPoint(vt[ls], vt[ls + 1], le1);
                        }
                        Dl += ho[ls];
                    }
                    return vt[Math.round(vt.length / 2)];
                }
                var gm = new ho.Pq0, Am = new ho.Pq0, _m = new ho.Pq0, ym = new ho.Pq0, vm = new ho.Pq0, xm = new ho.Pq0;
                function getGreatCircleIntersection(le1, vt, bt) {
                    gm.copy(bt).normalize(), Am.crossVectors(le1, vt).normalize(), _m.crossVectors(Am, le1).normalize(), ym.copy(le1).multiplyScalar(-gm.dot(_m)), vm.copy(_m).multiplyScalar(gm.dot(le1));
                    const Dl = (new ho.Pq0).addVectors(ym, vm).normalize();
                    return xm.crossVectors(Dl, gm), Dl.applyAxisAngle(xm, .01).multiplyScalar(ls.aH.SPHERE_RADIUS);
                }
                var bm = class extends dm {
                    get threeElement() {
                        return this.element;
                    }
                    get threeMesh() {
                        return this.threeElement.children[0];
                    }
                    get video() {
                        return "videoLayer" === this.type ? this.threeMesh.material.map.image : null;
                    }
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    is3d() {
                        return !0;
                    }
                    createElement() {
                        const le1 = new fm({
                            alpha: 0
                        }), vt = new ho.bdM(1, 1), bt = new ho.eaF(vt, le1);
                        bt.userData = {
                            [Jd]: this
                        }, Object.defineProperty(bt, "visible", {
                            enumerable: !0,
                            get: function() {
                                return this.userData[Jd].config.visible;
                            },
                            set: function(le1) {
                                this.userData[Jd].config.visible = le1;
                            }
                        }), this.element = (new ho.YJl).add(bt), "videoLayer" === this.type && this.viewer.needsContinuousUpdate(!0);
                    }
                    destroy() {
                        delete this.threeMesh.userData[Jd], "videoLayer" === this.type && (this.video.pause(), this.viewer.needsContinuousUpdate(!1)), super.destroy();
                    }
                    render() {
                        return this.viewer.renderer.isObjectVisible(this.threeMesh) ? this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position) : null;
                    }
                    update(le1) {
                        super.update(le1);
                        const vt = this.threeMesh, bt = vt.parent, Dl = vt.material;
                        if (ls.Wp.isExtendedPosition(this.config.position)) {
                            try {
                                this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                            } catch (Fl) {
                                throw new ls.e6(`invalid marker ${this.id} position`, Fl);
                            }
                            if (!this.config.size) throw new ls.e6(`missing marker ${this.id} size`);
                            this.state.size = this.config.size, vt.scale.set(this.config.size.width / 100, this.config.size.height / 100, 1), vt.position.set(vt.scale.x * (.5 - this.state.anchor.x), vt.scale.y * (this.state.anchor.y - .5), 0), vt.rotation.set(0, 0, 0), this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position, bt.position), bt.lookAt(0, bt.position.y, 0), vt.rotateY(-this.config.rotation.yaw), vt.rotateX(-this.config.rotation.pitch), vt.rotateZ(-this.config.rotation.roll);
                            const le1 = vt.geometry.getAttribute("position");
                            this.state.positions3D = [
                                0,
                                1,
                                3,
                                2
                            ].map((bt)=>{
                                const ls = new ho.Pq0;
                                return ls.fromBufferAttribute(le1, bt), vt.localToWorld(ls);
                            });
                        } else {
                            if (4 !== this.config.position?.length) throw new ls.e6(`missing marker ${this.id} position`);
                            let le1;
                            try {
                                le1 = this.config.position.map((le1)=>this.viewer.dataHelper.cleanPosition(le1));
                            } catch (Fl) {
                                throw new ls.e6(`invalid marker ${this.id} position`, Fl);
                            }
                            const bt = le1.map((le1)=>this.viewer.dataHelper.sphericalCoordsToVector3(le1)), ho = getPolygonCenter(bt);
                            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(ho), this.state.positions3D = bt;
                            const sc = vt.geometry.getAttribute("position");
                            [
                                bt[0],
                                bt[1],
                                bt[3],
                                bt[2]
                            ].forEach((le1, vt)=>{
                                sc.setX(vt, le1.x), sc.setY(vt, le1.y), sc.setZ(vt, le1.z);
                            }), sc.needsUpdate = !0, this.__setTextureWrap(Dl);
                        }
                        switch(this.type){
                            case "videoLayer":
                                if (this.definition !== this.config.videoLayer) {
                                    Dl.map?.dispose();
                                    const le1 = function(le1) {
                                        let { src: vt, withCredentials: bt, muted: ls, autoplay: ho } = le1;
                                        const Dl = document.createElement("video");
                                        return Dl.crossOrigin = bt ? "use-credentials" : "anonymous", Dl.loop = !0, Dl.playsInline = !0, Dl.autoplay = ho, Dl.muted = ls, Dl.preload = "metadata", vt instanceof MediaStream ? Dl.srcObject = vt : Dl.src = vt, Dl;
                                    }({
                                        src: this.config.videoLayer,
                                        withCredentials: this.viewer.config.withCredentials(this.config.videoLayer),
                                        muted: !0,
                                        autoplay: this.config.autoplay ?? !0
                                    }), bt = new ho.Nv2(le1);
                                    Dl.map = bt, Dl.alpha = 0, le1.addEventListener("loadedmetadata", ()=>{
                                        this.viewer && (Dl.alpha = this.config.opacity, ls.Wp.isExtendedPosition(this.config.position) || (vt.material.userData[Jd] = {
                                            width: le1.videoWidth,
                                            height: le1.videoHeight
                                        }, this.__setTextureWrap(Dl)));
                                    }, {
                                        once: !0
                                    }), le1.autoplay && le1.play(), this.definition = this.config.videoLayer;
                                } else Dl.alpha = this.config.opacity;
                                break;
                            case "imageLayer":
                                if (this.definition !== this.config.imageLayer) {
                                    Dl.map?.dispose();
                                    const le1 = new ho.gPd;
                                    Dl.map = le1, Dl.alpha = 0, this.viewer.textureLoader.loadImage(this.config.imageLayer).then((bt)=>{
                                        this.viewer && (ls.Wp.isExtendedPosition(this.config.position) || (vt.material.userData[Jd] = {
                                            width: bt.width,
                                            height: bt.height
                                        }, this.__setTextureWrap(Dl)), le1.image = bt, le1.anisotropy = 4, le1.needsUpdate = !0, Dl.alpha = this.config.opacity, this.viewer.needsUpdate());
                                    }), this.definition = this.config.imageLayer;
                                } else Dl.alpha = this.config.opacity;
                        }
                        Dl.chromaKey = this.config.chromaKey, vt.renderOrder = 1e3 + this.config.zIndex, vt.geometry.boundingBox = null;
                    }
                    __setTextureWrap(le1) {
                        const vt = le1.userData[Jd];
                        if (!vt || !vt.height || !vt.width) return le1.repeat.set(1, 1), void le1.offset.set(0, 0);
                        const bt = this.config.position.map((le1)=>this.viewer.dataHelper.cleanPosition(le1)), ho = (ls.Wp.greatArcDistance([
                            bt[0].yaw,
                            bt[0].pitch
                        ], [
                            bt[1].yaw,
                            bt[1].pitch
                        ]) + ls.Wp.greatArcDistance([
                            bt[3].yaw,
                            bt[3].pitch
                        ], [
                            bt[2].yaw,
                            bt[2].pitch
                        ])) / (ls.Wp.greatArcDistance([
                            bt[1].yaw,
                            bt[1].pitch
                        ], [
                            bt[2].yaw,
                            bt[2].pitch
                        ]) + ls.Wp.greatArcDistance([
                            bt[0].yaw,
                            bt[0].pitch
                        ], [
                            bt[3].yaw,
                            bt[3].pitch
                        ])), Dl = vt.width / vt.height;
                        let Fl = 0, sc = 0;
                        ho < Dl ? Fl = Dl - ho : sc = 1 / Dl - 1 / ho, le1.repeat.set(1 - Fl, 1 - sc), le1.offset.set(Fl / 2, sc / 2);
                    }
                }, wm = class extends pm {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt), this.viewportIntersection = !1;
                    }
                    get threeElement() {
                        return this.object;
                    }
                    isCss3d() {
                        return !0;
                    }
                    createElement() {
                        this.element = document.createElement("div"), this.object = new sm(this.element), this.object.userData = {
                            [Jd]: this
                        }, Object.defineProperty(this.object, "visible", {
                            enumerable: !0,
                            get: function() {
                                return this.userData[Jd].config.visible;
                            },
                            set: function(le1) {
                                this.userData[Jd].config.visible = le1;
                            }
                        }), this.afterCreateElement();
                    }
                    destroy() {
                        delete this.object.userData[Jd], delete this.object, super.destroy();
                    }
                    render(le1) {
                        let { viewerPosition: vt, zoomLevel: bt } = le1;
                        const ls = this.domElement;
                        this.state.size = {
                            width: ls.offsetWidth,
                            height: ls.offsetHeight
                        };
                        if (this.state.positions3D[0].dot(this.viewer.state.direction) > 0 && this.viewportIntersection) {
                            const le1 = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position);
                            return this.config.elementLayer.updateMarker?.({
                                marker: this,
                                position: le1,
                                viewerPosition: vt,
                                zoomLevel: bt,
                                viewerSize: this.viewer.state.size
                            }), le1;
                        }
                        return null;
                    }
                    update(le1) {
                        if (super.update(le1), !ls.Wp.isExtendedPosition(this.config.position)) throw new ls.e6(`missing marker ${this.id} position`);
                        try {
                            this.state.position = this.viewer.dataHelper.cleanPosition(this.config.position);
                        } catch (ho) {
                            throw new ls.e6(`invalid marker ${this.id} position`, ho);
                        }
                        this.state.positions3D = [
                            this.viewer.dataHelper.sphericalCoordsToVector3(this.state.position)
                        ];
                        const vt = this.threeElement, bt = this.domElement;
                        bt.classList.add("psv-marker--css3d"), bt.childNodes.forEach((le1)=>le1.remove()), bt.appendChild(this.config.elementLayer), this.config.elementLayer.style.display = "block", vt.position.copy(this.state.positions3D[0]).multiplyScalar(100), vt.lookAt(0, 100 * this.state.positions3D[0].y, 0), vt.rotateY(-this.config.rotation.yaw), vt.rotateX(-this.config.rotation.pitch), vt.rotateZ(-this.config.rotation.roll);
                    }
                }, Em = class extends mm {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    isNormal() {
                        return !0;
                    }
                    createElement() {
                        this.element = document.createElement("div"), this.afterCreateElement();
                    }
                    render(le1) {
                        const vt = super.render(le1);
                        return vt && "element" === this.type && this.config.element.updateMarker?.({
                            marker: this,
                            position: vt,
                            viewerPosition: le1.viewerPosition,
                            zoomLevel: le1.zoomLevel,
                            viewerSize: this.viewer.state.size
                        }), vt;
                    }
                    update(le1) {
                        super.update(le1);
                        const vt = this.domElement;
                        if (this.config.image && !this.config.size) throw new ls.e6(`missing marker ${this.id} size`);
                        switch(this.config.size ? (this.needsUpdateSize = !1, this.state.size = this.config.size, vt.style.width = this.config.size.width + "px", vt.style.height = this.config.size.height + "px") : this.needsUpdateSize = !0, this.type){
                            case "image":
                                this.definition = this.config.image, vt.style.backgroundImage = `url("${this.config.image}")`;
                                break;
                            case "html":
                                this.definition = this.config.html, vt.innerHTML = this.config.html;
                                break;
                            case "element":
                                this.definition !== this.config.element && (this.definition = this.config.element, vt.childNodes.forEach((le1)=>le1.remove()), vt.appendChild(this.config.element), this.config.element.style.display = "block");
                        }
                    }
                }, Mm = class extends pm {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    createElement() {
                        this.element = document.createElementNS(Kd, "path"), this.element[Jd] = this;
                    }
                    isPoly() {
                        return !0;
                    }
                    get isPixels() {
                        return "polygonPixels" === this.type || "polylinePixels" === this.type;
                    }
                    get isPolygon() {
                        return "polygon" === this.type || "polygonPixels" === this.type;
                    }
                    get isPolyline() {
                        return "polyline" === this.type || "polylinePixels" === this.type;
                    }
                    get coords() {
                        return this.definition;
                    }
                    render() {
                        const le1 = this.__getAllPolyPositions();
                        if (le1[0].length > (this.isPolygon ? 2 : 1)) {
                            const vt = this.viewer.dataHelper.sphericalCoordsToViewerCoords(this.state.position), bt = le1.filter((le1)=>le1.length > 0).map((le1)=>{
                                let bt = "M";
                                return bt += le1.map((le1)=>`${le1.x - vt.x},${le1.y - vt.y}`).join("L"), this.isPolygon && (bt += "Z"), bt;
                            }).join(" ");
                            return this.domElement.setAttributeNS(null, "d", bt), this.domElement.setAttributeNS(null, "transform", `translate(${vt.x} ${vt.y})`), vt;
                        }
                        return null;
                    }
                    update(le1) {
                        super.update(le1);
                        const vt = this.domElement;
                        vt.classList.add("psv-marker--poly"), this.config.svgStyle ? (Object.entries(this.config.svgStyle).forEach((le1)=>{
                            let [bt, ho] = le1;
                            vt.setAttributeNS(null, ls.Wp.dasherize(bt), ho);
                        }), this.isPolyline && !this.config.svgStyle.fill && vt.setAttributeNS(null, "fill", "none")) : this.isPolygon ? vt.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)") : this.isPolyline && (vt.setAttributeNS(null, "fill", "none"), vt.setAttributeNS(null, "stroke", "rgb(0,0,0)"));
                        try {
                            let le1 = this.config[this.type];
                            if (!Array.isArray(le1[0]) && "object" !== typeof le1[0]) for(let vt = 0; vt < le1.length; vt++)le1.splice(vt, 2, [
                                le1[vt],
                                le1[vt + 1]
                            ]);
                            if (Array.isArray(le1[0][0]) || "object" === typeof le1[0][0] || (le1 = [
                                le1
                            ]), this.isPolyline && le1.length > 1) throw new ls.e6("polylines cannot have holes");
                            this.isPixels ? this.definition = le1.map((le1)=>le1.map((le1)=>{
                                    let vt;
                                    return vt = ls.Wp.isExtendedPosition(le1) ? this.viewer.dataHelper.cleanPosition(le1) : this.viewer.dataHelper.textureCoordsToSphericalCoords({
                                        textureX: le1[0],
                                        textureY: le1[1]
                                    }), [
                                        vt.yaw,
                                        vt.pitch
                                    ];
                                })) : this.definition = le1.map((le1)=>le1.map((le1)=>{
                                    let vt;
                                    return vt = ls.Wp.isExtendedPosition(le1) ? this.viewer.dataHelper.cleanPosition(le1) : this.viewer.dataHelper.cleanPosition({
                                        yaw: le1[0],
                                        pitch: le1[1]
                                    }), [
                                        vt.yaw,
                                        vt.pitch
                                    ];
                                }));
                        } catch (bt) {
                            throw new ls.e6(`invalid marker ${this.id} position`, bt);
                        }
                        if (this.positions3D = this.coords.map((le1)=>le1.map((le1)=>this.viewer.dataHelper.sphericalCoordsToVector3({
                                    yaw: le1[0],
                                    pitch: le1[1]
                                }))), this.isPolygon) {
                            const le1 = getPolygonCenter(this.positions3D[0]);
                            this.state.position = this.viewer.dataHelper.vector3ToSphericalCoords(le1);
                        } else {
                            const le1 = getPolylineCenter(this.coords[0]);
                            this.state.position = {
                                yaw: le1[0],
                                pitch: le1[1]
                            };
                        }
                        this.state.positions3D = this.positions3D[0];
                    }
                    __getAllPolyPositions() {
                        return this.positions3D.map((le1)=>this.__getPolyPositions(le1));
                    }
                    __getPolyPositions(le1) {
                        const vt = le1.length, bt = le1.map((le1)=>({
                                vector: le1,
                                visible: le1.dot(this.viewer.state.direction) > 0
                            })), ls = [];
                        return bt.forEach((le1, ho)=>{
                            if (!le1.visible) [
                                0 === ho ? bt[vt - 1] : bt[ho - 1],
                                ho === vt - 1 ? bt[0] : bt[ho + 1]
                            ].forEach((vt)=>{
                                vt.visible && ls.push({
                                    visible: vt.vector,
                                    invisible: le1.vector,
                                    index: ho
                                });
                            });
                        }), ls.reverse().forEach((le1)=>{
                            bt.splice(le1.index, 0, {
                                vector: getGreatCircleIntersection(le1.visible, le1.invisible, this.viewer.state.direction),
                                visible: !0
                            });
                        }), bt.filter((le1)=>le1.visible).map((le1)=>this.viewer.dataHelper.vector3ToViewerCoords(le1.vector));
                    }
                }, Sm = class extends mm {
                    get svgElement() {
                        return this.domElement.firstElementChild;
                    }
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                    isSvg() {
                        return !0;
                    }
                    createElement() {
                        const le1 = "square" === this.type ? "rect" : this.type, vt = document.createElementNS(Kd, le1);
                        this.element = document.createElementNS(Kd, "svg"), this.element.appendChild(vt), this.afterCreateElement();
                    }
                    update(le1) {
                        super.update(le1);
                        const vt = this.svgElement;
                        switch(this.needsUpdateSize = !0, this.type){
                            case "square":
                                this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.square,
                                    height: this.config.square
                                };
                                break;
                            case "rect":
                                Array.isArray(this.config.rect) ? this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.rect[0],
                                    height: this.config.rect[1]
                                } : this.definition = {
                                    x: 0,
                                    y: 0,
                                    width: this.config.rect.width,
                                    height: this.config.rect.height
                                };
                                break;
                            case "circle":
                                this.definition = {
                                    cx: this.config.circle,
                                    cy: this.config.circle,
                                    r: this.config.circle
                                };
                                break;
                            case "ellipse":
                                Array.isArray(this.config.ellipse) ? this.definition = {
                                    cx: this.config.ellipse[0],
                                    cy: this.config.ellipse[1],
                                    rx: this.config.ellipse[0],
                                    ry: this.config.ellipse[1]
                                } : this.definition = {
                                    cx: this.config.ellipse.rx,
                                    cy: this.config.ellipse.ry,
                                    rx: this.config.ellipse.rx,
                                    ry: this.config.ellipse.ry
                                };
                                break;
                            case "path":
                                this.definition = {
                                    d: this.config.path
                                };
                        }
                        Object.entries(this.definition).forEach((le1)=>{
                            let [bt, ls] = le1;
                            vt.setAttributeNS(null, bt, ls);
                        }), this.config.svgStyle ? Object.entries(this.config.svgStyle).forEach((le1)=>{
                            let [bt, ho] = le1;
                            vt.setAttributeNS(null, ls.Wp.dasherize(bt), ho);
                        }) : vt.setAttributeNS(null, "fill", "rgba(0,0,0,0.5)");
                    }
                }, Tm = ls.Wp.getConfigParser({
                    clickEventOnMarker: !1,
                    gotoMarkerSpeed: "8rpm",
                    markers: null,
                    defaultHoverScale: null
                }, {
                    defaultHoverScale: (le1)=>le1 ? (!0 === le1 && (le1 = tm), "number" === typeof le1 && (le1 = {
                            amount: le1
                        }), {
                            ...tm,
                            ...le1
                        }) : null
                });
                var km = class _MarkersPlugin extends ls.TL {
                    constructor(le1, vt){
                        super(le1, vt), this.markers = {}, this.state = {
                            allVisible: !0,
                            showAllTooltips: !1,
                            currentMarker: null,
                            hoveringMarker: null,
                            needsReRender: !1,
                            lastClientX: null,
                            lastClientY: null
                        }, this.container = document.createElement("div"), this.container.className = "psv-markers", this.viewer.container.appendChild(this.container), this.container.addEventListener("contextmenu", (le1)=>le1.preventDefault()), this.svgContainer = document.createElementNS(Kd, "svg"), this.svgContainer.setAttribute("class", "psv-markers-svg-container"), this.container.appendChild(this.svgContainer), this.css3DContainer = new um(le1), this.container.appendChild(this.css3DContainer.element), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0);
                    }
                    static withConfig(le1) {
                        return [
                            _MarkersPlugin,
                            le1
                        ];
                    }
                    init() {
                        super.init(), ls.Wp.checkStylesheet(this.viewer.container, "markers-plugin"), this.viewer.addEventListener(ls.AZ.ClickEvent.type, this), this.viewer.addEventListener(ls.AZ.DoubleClickEvent.type, this), this.viewer.addEventListener(ls.AZ.RenderEvent.type, this), this.viewer.addEventListener(ls.AZ.ConfigChangedEvent.type, this), this.viewer.addEventListener(ls.AZ.ObjectEnterEvent.type, this), this.viewer.addEventListener(ls.AZ.ObjectHoverEvent.type, this), this.viewer.addEventListener(ls.AZ.ObjectLeaveEvent.type, this), this.viewer.addEventListener(ls.AZ.ReadyEvent.type, this, {
                            once: !0
                        });
                    }
                    destroy() {
                        this.clearMarkers(!1), this.viewer.unobserveObjects(Jd), this.viewer.removeEventListener(ls.AZ.ClickEvent.type, this), this.viewer.removeEventListener(ls.AZ.DoubleClickEvent.type, this), this.viewer.removeEventListener(ls.AZ.RenderEvent.type, this), this.viewer.removeEventListener(ls.AZ.ObjectEnterEvent.type, this), this.viewer.removeEventListener(ls.AZ.ObjectHoverEvent.type, this), this.viewer.removeEventListener(ls.AZ.ObjectLeaveEvent.type, this), this.viewer.removeEventListener(ls.AZ.ReadyEvent.type, this), this.css3DContainer.destroy(), this.viewer.container.removeChild(this.container), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case ls.AZ.ReadyEvent.type:
                                this.config.markers && (this.setMarkers(this.config.markers), delete this.config.markers);
                                break;
                            case ls.AZ.RenderEvent.type:
                                this.renderMarkers();
                                break;
                            case ls.AZ.ClickEvent.type:
                                this.__onClick(le1, !1);
                                break;
                            case ls.AZ.DoubleClickEvent.type:
                                this.__onClick(le1, !0);
                                break;
                            case ls.AZ.ObjectEnterEvent.type:
                            case ls.AZ.ObjectLeaveEvent.type:
                            case ls.AZ.ObjectHoverEvent.type:
                                if (le1.userDataKey === Jd) {
                                    const vt = le1.originalEvent, bt = le1.object.userData[Jd];
                                    switch(le1.type){
                                        case ls.AZ.ObjectEnterEvent.type:
                                            bt.config.style?.cursor ? this.viewer.setCursor(bt.config.style.cursor) : (bt.config.tooltip || bt.config.content) && this.viewer.setCursor("pointer"), this.__onEnterMarker(vt, bt);
                                            break;
                                        case ls.AZ.ObjectLeaveEvent.type:
                                            this.viewer.setCursor(null), this.__onLeaveMarker(bt);
                                            break;
                                        case ls.AZ.ObjectHoverEvent.type:
                                            this.__onHoverMarker(vt, bt);
                                    }
                                }
                                break;
                            case "mouseenter":
                                {
                                    const vt = this.__getTargetMarker(ls.Wp.getEventTarget(le1));
                                    this.__onEnterMarker(le1, vt);
                                    break;
                                }
                            case "mouseleave":
                                {
                                    const vt = this.__getTargetMarker(ls.Wp.getEventTarget(le1));
                                    this.__onLeaveMarker(vt);
                                    break;
                                }
                            case "mousemove":
                                {
                                    const vt = this.__getTargetMarker(ls.Wp.getEventTarget(le1), !0);
                                    this.__onHoverMarker(le1, vt);
                                    break;
                                }
                        }
                    }
                    toggleAllMarkers() {
                        this.state.allVisible ? this.hideAllMarkers() : this.showAllMarkers();
                    }
                    showAllMarkers() {
                        this.state.allVisible = !0, Object.values(this.markers).forEach((le1)=>{
                            le1.config.visible = !0;
                        }), this.renderMarkers(), this.dispatchEvent(new Wd);
                    }
                    hideAllMarkers() {
                        this.state.allVisible = !1, Object.values(this.markers).forEach((le1)=>{
                            le1.config.visible = !1;
                        }), this.renderMarkers(), this.dispatchEvent(new Ud);
                    }
                    toggleAllTooltips() {
                        this.state.showAllTooltips ? this.hideAllTooltips() : this.showAllTooltips();
                    }
                    showAllTooltips() {
                        this.state.showAllTooltips = !0, Object.values(this.markers).forEach((le1)=>{
                            le1.state.staticTooltip = !0, le1.showTooltip();
                        });
                    }
                    hideAllTooltips() {
                        this.state.showAllTooltips = !1, Object.values(this.markers).forEach((le1)=>{
                            le1.state.staticTooltip = !1, le1.hideTooltip();
                        });
                    }
                    getNbMarkers() {
                        return Object.keys(this.markers).length;
                    }
                    getMarkers() {
                        return Object.values(this.markers);
                    }
                    addMarker(le1, vt) {
                        if (void 0 === vt && (vt = !0), this.markers[le1.id]) throw new ls.e6(`marker "${le1.id}" already exists`);
                        const bt = new (function(le1) {
                            switch(getMarkerType(le1, !1)){
                                case "image":
                                case "html":
                                case "element":
                                    return Em;
                                case "imageLayer":
                                case "videoLayer":
                                    return bm;
                                case "elementLayer":
                                    return wm;
                                case "polygon":
                                case "polyline":
                                case "polygonPixels":
                                case "polylinePixels":
                                    return Mm;
                                case "square":
                                case "rect":
                                case "circle":
                                case "ellipse":
                                case "path":
                                    return Sm;
                                default:
                                    throw new ls.e6("invalid marker type");
                            }
                        }(le1))(this.viewer, this, le1);
                        bt.isPoly() ? this.svgContainer.appendChild(bt.domElement) : bt.isCss3d() ? this.css3DContainer.addObject(bt) : bt.is3d() ? this.viewer.renderer.addObject(bt.threeElement) : this.container.appendChild(bt.domElement), this.markers[bt.id] = bt, this.state.showAllTooltips && (bt.state.staticTooltip = !0), vt && this.__afterChangeMarkers();
                    }
                    getMarker(le1) {
                        const vt = "object" === typeof le1 ? le1.id : le1;
                        if (!this.markers[vt]) throw new ls.e6(`cannot find marker "${vt}"`);
                        return this.markers[vt];
                    }
                    getCurrentMarker() {
                        return this.state.currentMarker;
                    }
                    updateMarker(le1, vt) {
                        void 0 === vt && (vt = !0);
                        const bt = this.getMarker(le1.id);
                        bt.update(le1), vt && (this.__afterChangeMarkers(), (bt === this.state.hoveringMarker && "hover" === bt.config.tooltip?.trigger || bt.state.staticTooltip) && bt.showTooltip(this.state.lastClientX, this.state.lastClientY, !0));
                    }
                    removeMarker(le1, vt) {
                        void 0 === vt && (vt = !0);
                        const bt = this.getMarker(le1);
                        bt.isPoly() ? this.svgContainer.removeChild(bt.domElement) : bt.isCss3d() ? this.css3DContainer.removeObject(bt) : bt.is3d() ? this.viewer.renderer.removeObject(bt.threeElement) : this.container.removeChild(bt.domElement), this.state.hoveringMarker === bt && (this.state.hoveringMarker = null), this.state.currentMarker === bt && (this.state.currentMarker = null), bt.destroy(), delete this.markers[bt.id], vt && this.__afterChangeMarkers();
                    }
                    removeMarkers(le1, vt) {
                        void 0 === vt && (vt = !0), le1.forEach((le1)=>this.removeMarker(le1, !1)), vt && this.__afterChangeMarkers();
                    }
                    setMarkers(le1, vt) {
                        void 0 === vt && (vt = !0), this.clearMarkers(!1), le1?.forEach((le1)=>{
                            this.addMarker(le1, !1);
                        }), vt && this.__afterChangeMarkers();
                    }
                    clearMarkers(le1) {
                        void 0 === le1 && (le1 = !0), Object.keys(this.markers).forEach((le1)=>{
                            this.removeMarker(le1, !1);
                        }), le1 && this.__afterChangeMarkers();
                    }
                    gotoMarker(le1, vt) {
                        void 0 === vt && (vt = this.config.gotoMarkerSpeed);
                        const bt = this.getMarker(le1);
                        return vt ? this.viewer.animate({
                            ...bt.state.position,
                            zoom: bt.config.zoomLvl,
                            speed: vt
                        }).then(()=>{
                            this.dispatchEvent(new gc(bt));
                        }) : (this.viewer.rotate(bt.state.position), ls.Wp.isNil(bt.config.zoomLvl) || this.viewer.zoom(bt.config.zoomLvl), this.dispatchEvent(new gc(bt)), Promise.resolve());
                    }
                    hideMarker(le1) {
                        this.toggleMarker(le1, !1);
                    }
                    showMarker(le1) {
                        this.toggleMarker(le1, !0);
                    }
                    showMarkerTooltip(le1) {
                        const vt = this.getMarker(le1);
                        vt.state.staticTooltip = !0, vt.showTooltip();
                    }
                    hideMarkerTooltip(le1) {
                        const vt = this.getMarker(le1);
                        vt.state.staticTooltip = !1, vt.hideTooltip();
                    }
                    toggleMarker(le1, vt) {
                        const bt = this.getMarker(le1);
                        bt.config.visible = ls.Wp.isNil(vt) ? !bt.config.visible : vt, this.renderMarkers();
                    }
                    showMarkerPanel(le1) {
                        const vt = this.getMarker(le1);
                        vt.config.content ? this.viewer.panel.show({
                            id: sp,
                            content: vt.config.content
                        }) : this.hideMarkerPanel();
                    }
                    hideMarkerPanel() {
                        this.viewer.panel.hide(sp);
                    }
                    toggleMarkersList() {
                        this.viewer.panel.isVisible(em) ? this.hideMarkersList() : this.showMarkersList();
                    }
                    showMarkersList() {
                        let le1 = [];
                        Object.values(this.markers).forEach((vt)=>{
                            vt.config.visible && !vt.config.hideList && le1.push(vt);
                        });
                        const vt = new Yd(le1);
                        this.dispatchEvent(vt), le1 = vt.markers, this.viewer.panel.show({
                            id: em,
                            content: MARKERS_LIST_TEMPLATE(le1, this.viewer.config.lang[Qd.id]),
                            noMargin: !0,
                            clickHandler: (le1)=>{
                                const vt = ls.Wp.getClosest(le1, ".psv-panel-menu-item"), bt = vt ? vt.dataset[Jd] : void 0;
                                if (bt) {
                                    const le1 = this.getMarker(bt);
                                    this.dispatchEvent(new Nd(le1)), this.gotoMarker(le1.id), this.hideMarkersList();
                                }
                            }
                        });
                    }
                    hideMarkersList() {
                        this.viewer.panel.hide(em);
                    }
                    renderMarkers() {
                        if (this.state.needsReRender) return void (this.state.needsReRender = !1);
                        const le1 = this.viewer.getZoomLevel(), vt = this.viewer.getPosition(), bt = this.state.hoveringMarker;
                        Object.values(this.markers).forEach((ho)=>{
                            let Dl = ho.config.visible, Fl = !1, sc = null;
                            Dl && (sc = ho.render({
                                viewerPosition: vt,
                                zoomLevel: le1,
                                hoveringMarker: bt
                            }), Dl = !!sc), Fl = ho.state.visible !== Dl, ho.state.visible = Dl, ho.state.position2D = sc, ho.domElement && ls.Wp.toggleClass(ho.domElement, "psv-marker--visible", Dl), Dl ? ho.state.staticTooltip ? ho.showTooltip() : ho !== this.state.hoveringMarker && ho.hideTooltip() : ho.hideTooltip(), Fl && (this.dispatchEvent(new uc(ho, Dl)), (ho.is3d() || ho.isCss3d()) && (this.state.needsReRender = !0));
                        }), this.state.needsReRender && this.viewer.needsUpdate();
                    }
                    __getTargetMarker(le1, vt) {
                        if (void 0 === vt && (vt = !1), le1 instanceof Node) {
                            const bt = vt ? ls.Wp.getClosest(le1, ".psv-marker") : le1;
                            return bt ? bt[Jd] : void 0;
                        }
                        return Array.isArray(le1) ? le1.map((le1)=>le1.userData[Jd]).filter((le1)=>!!le1).sort((le1, vt)=>vt.config.zIndex - le1.config.zIndex)[0] : null;
                    }
                    __onEnterMarker(le1, vt) {
                        vt && (this.state.hoveringMarker = vt, this.state.lastClientX = le1.clientX, this.state.lastClientY = le1.clientY, this.dispatchEvent(new du(vt)), vt instanceof mm && vt.applyScale({
                            zoomLevel: this.viewer.getZoomLevel(),
                            viewerPosition: this.viewer.getPosition(),
                            mouseover: !0
                        }), vt.state.staticTooltip || "hover" !== vt.config.tooltip?.trigger || vt.showTooltip(le1.clientX, le1.clientY));
                    }
                    __onLeaveMarker(le1) {
                        le1 && (this.dispatchEvent(new Ec(le1)), le1 instanceof mm && le1.applyScale({
                            zoomLevel: this.viewer.getZoomLevel(),
                            viewerPosition: this.viewer.getPosition(),
                            mouseover: !1
                        }), this.state.hoveringMarker = null, le1.state.staticTooltip || "hover" !== le1.config.tooltip?.trigger ? le1.state.staticTooltip && le1.showTooltip() : le1.hideTooltip());
                    }
                    __onHoverMarker(le1, vt) {
                        vt && (this.state.lastClientX = le1.clientX, this.state.lastClientY = le1.clientY, (vt.isPoly() || vt.is3d() || vt.isCss3d()) && "hover" === vt.config.tooltip?.trigger && vt.showTooltip(le1.clientX, le1.clientY));
                    }
                    __onClick(le1, vt) {
                        const bt = this.__getTargetMarker(le1.data.objects), ls = this.__getTargetMarker(le1.data.target, !0) || bt;
                        this.state.currentMarker && this.state.currentMarker !== ls && (this.dispatchEvent(new Od(this.state.currentMarker)), this.viewer.panel.hide(sp), this.state.showAllTooltips || "click" !== this.state.currentMarker.config.tooltip?.trigger || this.hideMarkerTooltip(this.state.currentMarker.id), this.state.currentMarker = null), ls && (this.state.currentMarker = ls, this.dispatchEvent(new Md(ls, vt, le1.data.rightclick)), this.config.clickEventOnMarker ? le1.data.marker = ls : le1.stopImmediatePropagation(), this.markers[ls.id] && !le1.data.rightclick && ("click" === ls.config.tooltip?.trigger ? ls.tooltip ? this.hideMarkerTooltip(ls.id) : this.showMarkerTooltip(ls.id) : this.showMarkerPanel(ls.id)));
                    }
                    __afterChangeMarkers() {
                        this.__refreshUi(), this.__checkObjectsObserver(), this.viewer.needsUpdate(), this.dispatchEvent(new qd(this.getMarkers()));
                    }
                    __refreshUi() {
                        const le1 = Object.values(this.markers).filter((le1)=>!le1.config.hideList).length;
                        0 === le1 ? (this.viewer.panel.hide(sp), this.viewer.panel.hide(em)) : this.viewer.panel.isVisible(em) ? this.showMarkersList() : this.viewer.panel.isVisible(sp) && (this.state.currentMarker ? this.showMarkerPanel(this.state.currentMarker.id) : this.viewer.panel.hide()), this.viewer.navbar.getButton(Qd.id, !1)?.toggle(le1 > 0), this.viewer.navbar.getButton(im.id, !1)?.toggle(le1 > 0);
                    }
                    __checkObjectsObserver() {
                        Object.values(this.markers).some((le1)=>le1.is3d()) ? this.viewer.observeObjects(Jd) : this.viewer.unobserveObjects(Jd);
                    }
                };
                km.id = "markers", km.VERSION = "5.14.1", km.configParser = Tm, km.readonlyOptions = [
                    "markers"
                ];
                var Cm = km;
                ls.zY.lang[Qd.id] = "Markers", ls.zY.lang[im.id] = "Markers list", (0, ls.S)(Qd, "caption:left"), (0, ls.S)(im, "caption:left");
            },
            3348: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    $: ()=>im
                });
                var ls = bt(1545), ho = bt(9435), Dl = Object.defineProperty;
                ((le1, vt)=>{
                    for(var bt in vt)Dl(le1, bt, {
                        get: vt[bt],
                        enumerable: !0
                    });
                })({}, {
                    EnterArrowEvent: ()=>mc,
                    LeaveArrowEvent: ()=>Ac,
                    NodeChangedEvent: ()=>sc
                });
                var Fl = class _NodeChangedEvent extends ls.rx {
                    constructor(le1, vt){
                        super(_NodeChangedEvent.type), this.node = le1, this.data = vt;
                    }
                };
                Fl.type = "node-changed";
                var sc = Fl, uc = class _EnterArrowEvent extends ls.rx {
                    constructor(le1, vt){
                        super(_EnterArrowEvent.type), this.link = le1, this.node = vt;
                    }
                };
                uc.type = "enter-arrow";
                var mc = uc, gc = class _LeaveArrowEvent extends ls.rx {
                    constructor(le1, vt){
                        super(_LeaveArrowEvent.type), this.link = le1, this.node = vt;
                    }
                };
                gc.type = "leave-arrow";
                var Ac = gc, Ec = class extends ho.B69 {
                    constructor(le1){
                        void 0 === le1 && (le1 = document.createElement("div")), super(), this.isCSS2DObject = !0, this.element = le1, this.element.style.position = "absolute", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.center = new ho.I9Y(.5, .5), this.addEventListener("removed", function() {
                            this.traverse(function(le1) {
                                le1.element instanceof le1.element.ownerDocument.defaultView.Element && null !== le1.element.parentNode && le1.element.remove();
                            });
                        });
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.element = le1.element.cloneNode(!0), this.center = le1.center, this;
                    }
                }, kc = new ho.Pq0, du = new ho.kn4, _u = new ho.kn4, Md = new ho.Pq0, Ld = new ho.Pq0, Nd = class {
                    constructor(le1){
                        void 0 === le1 && (le1 = {});
                        const vt = this;
                        let bt, ls, ho, Dl;
                        const Fl = {
                            objects: new WeakMap
                        }, sc = void 0 !== le1.element ? le1.element : document.createElement("div");
                        function hideObject(le1) {
                            le1.isCSS2DObject && (le1.element.style.display = "none");
                            for(let vt = 0, bt = le1.children.length; vt < bt; vt++)hideObject(le1.children[vt]);
                        }
                        function renderObject(le1, bt, ls) {
                            if (!1 !== le1.visible) {
                                if (le1.isCSS2DObject) {
                                    kc.setFromMatrixPosition(le1.matrixWorld), kc.applyMatrix4(_u);
                                    const uc = kc.z >= -1 && kc.z <= 1 && !0 === le1.layers.test(ls.layers), mc = le1.element;
                                    mc.style.display = !0 === uc ? "" : "none", !0 === uc && (le1.onBeforeRender(vt, bt, ls), mc.style.transform = "translate(" + -100 * le1.center.x + "%," + -100 * le1.center.y + "%)translate(" + (kc.x * ho + ho) + "px," + (-kc.y * Dl + Dl) + "px)", mc.parentNode !== sc && sc.appendChild(mc), le1.onAfterRender(vt, bt, ls));
                                    const gc = {
                                        distanceToCameraSquared: getDistanceToSquared(ls, le1)
                                    };
                                    Fl.objects.set(le1, gc);
                                }
                                for(let vt = 0, ho = le1.children.length; vt < ho; vt++)renderObject(le1.children[vt], bt, ls);
                            } else hideObject(le1);
                        }
                        function getDistanceToSquared(le1, vt) {
                            return Md.setFromMatrixPosition(le1.matrixWorld), Ld.setFromMatrixPosition(vt.matrixWorld), Md.distanceToSquared(Ld);
                        }
                        sc.style.overflow = "hidden", this.domElement = sc, this.getSize = function() {
                            return {
                                width: bt,
                                height: ls
                            };
                        }, this.render = function(le1, vt) {
                            !0 === le1.matrixWorldAutoUpdate && le1.updateMatrixWorld(), null === vt.parent && !0 === vt.matrixWorldAutoUpdate && vt.updateMatrixWorld(), du.copy(vt.matrixWorldInverse), _u.multiplyMatrices(vt.projectionMatrix, du), renderObject(le1, le1, vt), function(le1) {
                                const vt = (function(le1) {
                                    const vt = [];
                                    return le1.traverseVisible(function(le1) {
                                        le1.isCSS2DObject && vt.push(le1);
                                    }), vt;
                                })(le1).sort(function(le1, vt) {
                                    if (le1.renderOrder !== vt.renderOrder) return vt.renderOrder - le1.renderOrder;
                                    return Fl.objects.get(le1).distanceToCameraSquared - Fl.objects.get(vt).distanceToCameraSquared;
                                }), bt = vt.length;
                                for(let ls = 0, ho = vt.length; ls < ho; ls++)vt[ls].element.style.zIndex = bt - ls;
                            }(le1);
                        }, this.setSize = function(le1, vt) {
                            bt = le1, ls = vt, ho = bt / 2, Dl = ls / 2, sc.style.width = le1 + "px", sc.style.height = vt + "px";
                        };
                    }
                }, Rd = new ho.Pq0, Od = new ho.PTz, jd = new ho.Pq0, Ud = class extends ho.B69 {
                    constructor(le1){
                        void 0 === le1 && (le1 = document.createElement("div")), super(), this.isCSS3DObject = !0, this.element = le1, this.element.style.position = "absolute", this.element.style.pointerEvents = "auto", this.element.style.userSelect = "none", this.element.setAttribute("draggable", !1), this.addEventListener("removed", function() {
                            this.traverse(function(le1) {
                                le1.element instanceof le1.element.ownerDocument.defaultView.Element && null !== le1.element.parentNode && le1.element.remove();
                            });
                        });
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.element = le1.element.cloneNode(!0), this;
                    }
                }, Gd = new ho.kn4, qd = new ho.kn4, Hd = class {
                    constructor(le1){
                        void 0 === le1 && (le1 = {});
                        const vt = this;
                        let bt, ls, ho, Dl;
                        const Fl = {
                            camera: {
                                style: ""
                            },
                            objects: new WeakMap
                        }, sc = void 0 !== le1.element ? le1.element : document.createElement("div");
                        sc.style.overflow = "hidden", this.domElement = sc;
                        const uc = document.createElement("div");
                        uc.style.transformOrigin = "0 0", uc.style.pointerEvents = "none", sc.appendChild(uc);
                        const mc = document.createElement("div");
                        function epsilon(le1) {
                            return Math.abs(le1) < 1e-10 ? 0 : le1;
                        }
                        function getCameraCSSMatrix(le1) {
                            const vt = le1.elements;
                            return "matrix3d(" + epsilon(vt[0]) + "," + epsilon(-vt[1]) + "," + epsilon(vt[2]) + "," + epsilon(vt[3]) + "," + epsilon(vt[4]) + "," + epsilon(-vt[5]) + "," + epsilon(vt[6]) + "," + epsilon(vt[7]) + "," + epsilon(vt[8]) + "," + epsilon(-vt[9]) + "," + epsilon(vt[10]) + "," + epsilon(vt[11]) + "," + epsilon(vt[12]) + "," + epsilon(-vt[13]) + "," + epsilon(vt[14]) + "," + epsilon(vt[15]) + ")";
                        }
                        function getObjectCSSMatrix(le1) {
                            const vt = le1.elements;
                            return "translate(-50%,-50%)" + ("matrix3d(" + epsilon(vt[0]) + "," + epsilon(vt[1]) + "," + epsilon(vt[2]) + "," + epsilon(vt[3]) + "," + epsilon(-vt[4]) + "," + epsilon(-vt[5]) + "," + epsilon(-vt[6]) + "," + epsilon(-vt[7]) + "," + epsilon(vt[8]) + "," + epsilon(vt[9]) + "," + epsilon(vt[10]) + "," + epsilon(vt[11]) + "," + epsilon(vt[12]) + "," + epsilon(vt[13]) + "," + epsilon(vt[14]) + "," + epsilon(vt[15]) + ")");
                        }
                        function hideObject(le1) {
                            le1.isCSS3DObject && (le1.element.style.display = "none");
                            for(let vt = 0, bt = le1.children.length; vt < bt; vt++)hideObject(le1.children[vt]);
                        }
                        function renderObject(le1, bt, ls, ho) {
                            if (!1 !== le1.visible) {
                                if (le1.isCSS3DObject) {
                                    const ho = !0 === le1.layers.test(ls.layers), Dl = le1.element;
                                    if (Dl.style.display = !0 === ho ? "" : "none", !0 === ho) {
                                        let ho;
                                        le1.onBeforeRender(vt, bt, ls), le1.isCSS3DSprite ? (Gd.copy(ls.matrixWorldInverse), Gd.transpose(), 0 !== le1.rotation2D && Gd.multiply(qd.makeRotationZ(le1.rotation2D)), le1.matrixWorld.decompose(Rd, Od, jd), Gd.setPosition(Rd), Gd.scale(jd), Gd.elements[3] = 0, Gd.elements[7] = 0, Gd.elements[11] = 0, Gd.elements[15] = 1, ho = getObjectCSSMatrix(Gd)) : ho = getObjectCSSMatrix(le1.matrixWorld);
                                        const sc = Fl.objects.get(le1);
                                        if (void 0 === sc || sc.style !== ho) {
                                            Dl.style.transform = ho;
                                            const vt = {
                                                style: ho
                                            };
                                            Fl.objects.set(le1, vt);
                                        }
                                        Dl.parentNode !== mc && mc.appendChild(Dl), le1.onAfterRender(vt, bt, ls);
                                    }
                                }
                                for(let vt = 0, Dl = le1.children.length; vt < Dl; vt++)renderObject(le1.children[vt], bt, ls, ho);
                            } else hideObject(le1);
                        }
                        mc.style.transformStyle = "preserve-3d", uc.appendChild(mc), this.getSize = function() {
                            return {
                                width: bt,
                                height: ls
                            };
                        }, this.render = function(le1, vt) {
                            const sc = vt.projectionMatrix.elements[5] * Dl;
                            let gc, Ac;
                            vt.view && vt.view.enabled ? (uc.style.transform = `translate( ${-vt.view.offsetX * (bt / vt.view.width)}px, ${-vt.view.offsetY * (ls / vt.view.height)}px )`, uc.style.transform += `scale( ${vt.view.fullWidth / vt.view.width}, ${vt.view.fullHeight / vt.view.height} )`) : uc.style.transform = "", !0 === le1.matrixWorldAutoUpdate && le1.updateMatrixWorld(), null === vt.parent && !0 === vt.matrixWorldAutoUpdate && vt.updateMatrixWorld(), vt.isOrthographicCamera && (gc = -(vt.right + vt.left) / 2, Ac = (vt.top + vt.bottom) / 2);
                            const Ec = vt.view && vt.view.enabled ? vt.view.height / vt.view.fullHeight : 1, kc = vt.isOrthographicCamera ? `scale( ${Ec} )scale(` + sc + ")translate(" + epsilon(gc) + "px," + epsilon(Ac) + "px)" + getCameraCSSMatrix(vt.matrixWorldInverse) : `scale( ${Ec} )translateZ(` + sc + "px)" + getCameraCSSMatrix(vt.matrixWorldInverse), du = (vt.isPerspectiveCamera ? "perspective(" + sc + "px) " : "") + kc + "translate(" + ho + "px," + Dl + "px)";
                            Fl.camera.style !== du && (mc.style.transform = du, Fl.camera.style = du), renderObject(le1, le1, vt, kc);
                        }, this.setSize = function(le1, vt) {
                            bt = le1, ls = vt, ho = bt / 2, Dl = ls / 2, sc.style.width = le1 + "px", sc.style.height = vt + "px", uc.style.width = le1 + "px", uc.style.height = vt + "px", mc.style.width = le1 + "px", mc.style.height = vt + "px";
                        };
                    }
                }, Wd = "tourLink", Zd = "__tour-link__", Yd = {
                    className: "psv-virtual-tour-tooltip",
                    content: '<div class="psv-virtual-tour-loader"><div></div><div></div><div></div></div>'
                }, Qd = {
                    element: ()=>{
                        const le1 = document.createElement("button");
                        return le1.className = "psv-virtual-tour-arrow", le1.innerHTML = '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 100 100">\n    <path fill-rule="even-odd" fill="currentColor" d="\n        M50,50 m45,0\n        a45,45 0 1,0 -90,0\n        a45,45 0 1,0  90,0\n\n        M50,50 m38,0\n        a38,38 0 0,1 -76,0\n        a38,38 0 0,1  76,0\n\n        M50,50 m30,0\n        a30,30 0 1,0 -60,0\n        a30,30 0 1,0  60,0\n        \n        M50,40 m2.5,-2.5\n        l17.5,17.5\n        a 2.5,2.5 0 0 1 -5,5\n        l-15,-15\n        l-15,15\n        a 2.5,2.5 0 0 1 -5,-5\n        l17.5,-17.5\n        a 3.5,3.5 0 0 1 5,0\n    "/>\n</svg>', le1;
                    },
                    size: {
                        width: 80,
                        height: 80
                    }
                }, Xd = "arrow", Kd = class extends ls.uj {
                    constructor(le1, vt){
                        super(le1, {
                            className: "psv-virtual-tour-arrows"
                        }), this.plugin = vt, this.renderer = this.is3D ? new Hd({
                            element: this.container
                        }) : new Nd({
                            element: this.container
                        }), this.camera = this.is3D ? new ho.ubm(30, 1) : null, this.scene = new ho.Z58, this.viewer.addEventListener(ls.AZ.ReadyEvent.type, this, {
                            once: !0
                        }), this.viewer.addEventListener(ls.AZ.PositionUpdatedEvent.type, this), this.viewer.addEventListener(ls.AZ.SizeUpdatedEvent.type, this), this.viewer.addEventListener(ls.AZ.RenderEvent.type, this), this.viewer.addEventListener(ls.AZ.ClickEvent.type, this), this.container.addEventListener("mouseenter", this, !0), this.container.addEventListener("mouseleave", this, !0), this.container.addEventListener("mousemove", this, !0), this.container.addEventListener("contextmenu", (le1)=>le1.preventDefault());
                    }
                    get is3D() {
                        return this.plugin.is3D;
                    }
                    get arrowsPosition() {
                        return this.plugin.config.arrowsPosition;
                    }
                    get arrowStyle() {
                        return this.plugin.config.arrowStyle;
                    }
                    init() {
                        this.is3D && (this.gallery = this.viewer.getPlugin("gallery"), this.gallery?.addEventListener("show-gallery", this), this.gallery?.addEventListener("hide-gallery", this));
                    }
                    destroy() {
                        this.viewer.removeEventListener(ls.AZ.ReadyEvent.type, this), this.viewer.removeEventListener(ls.AZ.PositionUpdatedEvent.type, this), this.viewer.removeEventListener(ls.AZ.SizeUpdatedEvent.type, this), this.viewer.removeEventListener(ls.AZ.RenderEvent.type, this), this.viewer.removeEventListener(ls.AZ.ClickEvent.type, this), this.gallery?.removeEventListener("show-gallery", this), this.gallery?.removeEventListener("hide-gallery", this), super.destroy();
                    }
                    handleEvent(le1) {
                        switch(le1.type){
                            case ls.AZ.ReadyEvent.type:
                            case ls.AZ.SizeUpdatedEvent.type:
                            case ls.AZ.PositionUpdatedEvent.type:
                                this.__updateCamera();
                                break;
                            case ls.AZ.RenderEvent.type:
                                this.render();
                                break;
                            case ls.AZ.ClickEvent.type:
                                {
                                    if (le1.data.rightclick) break;
                                    const vt = this.__getTargetLink(le1.data.target, !0);
                                    vt && this.plugin.setCurrentNode(vt.nodeId, null, vt);
                                    break;
                                }
                            case "mouseenter":
                                {
                                    const vt = this.__getTargetLink(ls.Wp.getEventTarget(le1));
                                    vt && this.plugin.__onEnterArrow(vt, le1);
                                    break;
                                }
                            case "mouseleave":
                                {
                                    const vt = this.__getTargetLink(ls.Wp.getEventTarget(le1));
                                    vt && this.plugin.__onLeaveArrow(vt);
                                    break;
                                }
                            case "mousemove":
                                this.__getTargetLink(ls.Wp.getEventTarget(le1), !0) && this.plugin.__onHoverArrow(le1);
                                break;
                            case "hide-gallery":
                                this.__onToggleGallery(!1);
                                break;
                            case "show-gallery":
                                le1.fullscreen || this.__onToggleGallery(!0);
                        }
                    }
                    __updateCamera() {
                        const le1 = this.viewer.getSize();
                        if (this.renderer.setSize(le1.width, le1.height), this.is3D) {
                            const vt = this.viewer.getPosition();
                            vt.pitch = ho.cj9.clamp(vt.pitch, -this.arrowsPosition.maxPitch, -this.arrowsPosition.minPitch), this.viewer.dataHelper.sphericalCoordsToVector3(vt, this.camera.position, 2 * le1.height).negate(), this.camera.lookAt(0, 0, 0), this.camera.translateY(le1.height / 3), this.camera.updateProjectionMatrix();
                        }
                    }
                    render() {
                        if (this.is3D) {
                            const le1 = this.viewer.getPosition(), vt = [];
                            let bt = Number.MAX_SAFE_INTEGER;
                            this.scene.children.forEach((ho)=>{
                                const Dl = ho.userData[Xd];
                                if (Dl.conflict) {
                                    const Fl = Math.abs(ls.Wp.getShortestArc(le1.yaw, Dl.yaw));
                                    bt = Math.min(bt, Fl), vt.push([
                                        ho,
                                        Fl
                                    ]);
                                }
                            }), vt.forEach((le1)=>{
                                let [vt, ls] = le1;
                                const ho = ls !== bt;
                                vt.element.style.opacity = ho ? "0.5" : null, vt.element.style.zIndex = ho ? "-1" : null;
                            }), this.renderer.render(this.scene, this.camera);
                        } else this.renderer.render(this.scene, this.viewer.renderer.camera);
                    }
                    clear() {
                        this.scene.clear();
                    }
                    __buildArrowElement(le1, vt) {
                        if (vt?.image) {
                            const le1 = document.createElement("img");
                            return le1.src = vt.image, le1;
                        }
                        if (vt?.element) return "function" === typeof vt.element ? vt.element(le1) : vt.element;
                    }
                    addLinkArrow(le1, vt, bt) {
                        void 0 === bt && (bt = 1);
                        let ho = this.__buildArrowElement(le1, le1.arrowStyle);
                        ho || (ho = this.__buildArrowElement(le1, this.arrowStyle)), ho[Wd] = le1;
                        const Dl = {
                            ...this.arrowStyle,
                            ...le1.arrowStyle
                        };
                        if (ho.classList.add("psv-virtual-tour-link"), Dl.className && ls.Wp.addClasses(ho, Dl.className), Dl.style && Object.assign(ho.style, Dl.style), this.is3D) {
                            ho.style.width = 1.5 * Dl.size.width + "px", ho.style.height = 1.5 * Dl.size.height + "px";
                            let le1 = !1;
                            this.scene.children.forEach((bt)=>{
                                const ho = bt.userData[Xd];
                                Math.abs(ls.Wp.getShortestArc(ho.yaw, vt.yaw)) < this.arrowsPosition.linkOverlapAngle && (ho.conflict = !0, le1 = !0);
                            });
                            const Fl = new Ud(ho);
                            Fl.userData[Xd] = {
                                yaw: vt.yaw,
                                conflict: le1
                            }, Fl.rotation.set(-Math.PI / 2, 0, Math.PI - vt.yaw), this.viewer.dataHelper.sphericalCoordsToVector3({
                                yaw: vt.yaw,
                                pitch: 0
                            }, Fl.position, 100 * bt), this.scene.add(Fl);
                        } else {
                            ho.style.width = Dl.size.width + "px", ho.style.height = Dl.size.height + "px", ho.style.pointerEvents = "auto";
                            const le1 = new Ec(ho);
                            this.viewer.dataHelper.sphericalCoordsToVector3(vt, le1.position), this.scene.add(le1);
                        }
                    }
                    __getTargetLink(le1, vt) {
                        void 0 === vt && (vt = !1);
                        const bt = vt ? ls.Wp.getClosest(le1, ".psv-virtual-tour-link") : le1;
                        return bt ? bt[Wd] : void 0;
                    }
                    __onToggleGallery(le1) {
                        this.container.style.marginBottom = le1 ? this.viewer.container.querySelector(".psv-gallery").offsetHeight + "px" : "";
                    }
                }, Jd = class {
                    constructor(le1, vt){
                        this.plugin = le1, this.viewer = vt, this.nodes = {};
                    }
                    destroy() {}
                    checkNode(le1) {
                        if (!le1.id) throw new ls.e6("No id given for node");
                        if (!le1.panorama) throw new ls.e6(`No panorama provided for node ${le1.id}`);
                        if (this.plugin.isGps && !(le1.gps?.length >= 2)) throw new ls.e6(`No GPS position provided for node ${le1.id}`);
                        if (!this.plugin.isGps && le1.markers?.some((le1)=>le1.gps && !le1.position)) throw new ls.e6("Cannot use GPS positioning for markers in manual mode");
                        le1.links || (ls.Wp.logWarn(`Node ${le1.id} has no links`), le1.links = []);
                    }
                    checkLink(le1, vt) {
                        if (!vt.nodeId) throw new ls.e6(`Link of node ${le1.id} has no target id`);
                        if (vt.nodeId === le1.id) throw new ls.e6(`Node ${le1.id} links to itself`);
                        if (!this.plugin.isGps && !ls.Wp.isExtendedPosition(vt.position)) throw new ls.e6(`No position provided for link ${vt.nodeId} of node ${le1.id}`);
                        if (this.plugin.isGps && !vt.gps) throw new ls.e6(`No GPS position provided for link ${vt.nodeId} of node ${le1.id}`);
                    }
                }, $d = class extends Jd {
                    async loadNode(le1) {
                        if (this.nodes[le1]) return this.nodes[le1];
                        throw new ls.e6(`Node ${le1} not found`);
                    }
                    setNodes(le1) {
                        if (!le1?.length) throw new ls.e6("No nodes provided");
                        const vt = {}, bt = {};
                        le1.forEach((le1)=>{
                            if (this.checkNode(le1), vt[le1.id]) throw new ls.e6(`Duplicate node ${le1.id}`);
                            vt[le1.id] = le1;
                        }), le1.forEach((le1)=>{
                            this.__checkLinks(le1, vt), le1.links.forEach((le1)=>{
                                bt[le1.nodeId] = !0;
                            });
                        }), le1.forEach((le1)=>{
                            bt[le1.id] || ls.Wp.logWarn(`Node ${le1.id} is never linked to`);
                        }), this.nodes = vt;
                    }
                    updateNode(le1) {
                        if (!le1.id) throw new ls.e6("No id given for node");
                        const vt = this.nodes[le1.id];
                        if (!vt) throw new ls.e6(`Node ${le1.id} does not exist`);
                        return Object.assign(vt, le1), this.checkNode(vt), this.__checkLinks(vt, this.nodes), vt;
                    }
                    __checkLinks(le1, vt) {
                        le1.links.forEach((bt)=>{
                            if (!vt[bt.nodeId]) throw new ls.e6(`Target node ${bt.nodeId} of node ${le1.id} does not exists`);
                            bt.gps = bt.gps || vt[bt.nodeId].gps, this.checkLink(le1, bt);
                        });
                    }
                }, sp = class extends Jd {
                    constructor(le1, vt){
                        if (super(le1, vt), !le1.config.getNode) throw new ls.e6("Missing getNode() option.");
                        this.nodeResolver = le1.config.getNode;
                    }
                    async loadNode(le1) {
                        if (this.nodes[le1]) return this.nodes[le1];
                        {
                            const vt = await this.nodeResolver(le1);
                            return this.checkNode(vt), vt.links.forEach((le1)=>{
                                this.checkLink(vt, le1);
                            }), this.nodes[le1] = vt, vt;
                        }
                    }
                    clearCache() {
                        this.nodes = {};
                    }
                };
                function gpsToSpherical(le1, vt) {
                    const bt = gpsDegToRad(le1), ho = gpsDegToRad(vt), Dl = le1[2] ?? 0, Fl = vt[2] ?? 0;
                    let sc = 0;
                    Dl !== Fl && (sc = Math.atan((Fl - Dl) / function(le1, vt) {
                        return 6371e3 * ls.Wp.greatArcDistance(le1, vt);
                    }(bt, ho)));
                    const uc = function(le1, vt) {
                        const [bt, ls] = le1, [ho, Dl] = vt, Fl = Math.sin(ho - bt) * Math.cos(Dl), sc = Math.cos(ls) * Math.sin(Dl) - Math.sin(ls) * Math.cos(Dl) * Math.cos(ho - bt);
                        return Math.atan2(Fl, sc);
                    }(bt, ho);
                    return {
                        yaw: uc,
                        pitch: sc
                    };
                }
                function gpsDegToRad(le1) {
                    return [
                        ho.cj9.degToRad(le1[0]),
                        ho.cj9.degToRad(le1[1])
                    ];
                }
                var em = ls.Wp.getConfigParser({
                    dataMode: "client",
                    positionMode: "manual",
                    renderMode: "3d",
                    nodes: null,
                    getNode: null,
                    startNodeId: null,
                    preload: !1,
                    transitionOptions: {
                        showLoader: !0,
                        speed: "20rpm",
                        effect: "fade",
                        rotation: !0
                    },
                    linksOnCompass: !0,
                    showLinkTooltip: !0,
                    getLinkTooltip: null,
                    arrowStyle: Qd,
                    arrowsPosition: {
                        minPitch: .3,
                        maxPitch: Math.PI / 2,
                        linkOverlapAngle: Math.PI / 4,
                        linkPitchOffset: -0.1
                    },
                    map: null
                }, {
                    dataMode (le1) {
                        if ("client" !== le1 && "server" !== le1) throw new ls.e6("VirtualTourPlugin: invalid dataMode");
                        return le1;
                    },
                    positionMode (le1) {
                        if ("gps" !== le1 && "manual" !== le1) throw new ls.e6("VirtualTourPlugin: invalid positionMode");
                        return le1;
                    },
                    renderMode (le1) {
                        if ("3d" !== le1 && "2d" !== le1) throw new ls.e6("VirtualTourPlugin: invalid renderMode");
                        return le1;
                    },
                    arrowsPosition (le1, vt) {
                        let { defValue: bt } = vt;
                        return {
                            ...bt,
                            ...le1
                        };
                    },
                    arrowStyle (le1, vt) {
                        let { defValue: bt } = vt;
                        return {
                            ...bt,
                            ...le1
                        };
                    },
                    map (le1, vt) {
                        let { rawConfig: bt } = vt;
                        if (le1) {
                            if ("server" === bt.dataMode) return ls.Wp.logWarn("VirtualTourPlugin: The map cannot be used in server side mode"), null;
                            if (!le1.imageUrl) return ls.Wp.logWarn('VirtualTourPlugin: configuring the map requires at least "imageUrl"'), null;
                            "recenter" in le1 || (le1.recenter = !0);
                        }
                        return le1;
                    }
                }), tm = class _VirtualTourPlugin extends ls.TL {
                    constructor(le1, vt){
                        super(le1, vt), this.state = {
                            currentNode: null,
                            currentTooltip: null,
                            loadingNode: null,
                            preload: {}
                        }, this.arrowsRenderer = new Kd(this.viewer, this);
                    }
                    get is3D() {
                        return "3d" === this.config.renderMode;
                    }
                    get isServerSide() {
                        return "server" === this.config.dataMode;
                    }
                    get isGps() {
                        return "gps" === this.config.positionMode;
                    }
                    static withConfig(le1) {
                        return [
                            _VirtualTourPlugin,
                            le1
                        ];
                    }
                    init() {
                        super.init(), this.arrowsRenderer.init(), ls.Wp.checkStylesheet(this.viewer.container, "virtual-tour-plugin"), this.markers = this.viewer.getPlugin("markers"), this.compass = this.viewer.getPlugin("compass"), this.markers?.config.markers && (ls.Wp.logWarn("No default markers can be configured on the MarkersPlugin when using the VirtualTourPlugin. Consider defining `markers` on each tour node."), delete this.markers.config.markers), this.isGps && (this.plan = this.viewer.getPlugin("plan")), this.isServerSide || (this.gallery = this.viewer.getPlugin("gallery"), this.map = this.viewer.getPlugin("map"), this.config.map && !this.map && ls.Wp.logWarn("The map is configured on the VirtualTourPlugin but the MapPlugin is not loaded.")), this.datasource = this.isServerSide ? new sp(this, this.viewer) : new $d(this, this.viewer), this.map && (this.map.addEventListener("select-hotspot", this), this.map.setImage(this.config.map.imageUrl)), this.plan?.addEventListener("select-hotspot", this), this.isServerSide ? this.config.startNodeId && this.setCurrentNode(this.config.startNodeId) : this.config.nodes && (this.setNodes(this.config.nodes, this.config.startNodeId), delete this.config.nodes);
                    }
                    destroy() {
                        this.map?.removeEventListener("select-hotspot", this), this.plan?.removeEventListener("select-hotspot", this), this.datasource.destroy(), this.arrowsRenderer.destroy(), delete this.datasource, delete this.markers, delete this.compass, delete this.gallery, delete this.arrowsRenderer, super.destroy();
                    }
                    handleEvent(le1) {
                        if (le1 instanceof ls.AZ.ClickEvent) {
                            const vt = le1.data.objects.find((le1)=>le1.userData[Wd])?.userData[Wd];
                            vt && this.setCurrentNode(vt.nodeId, null, vt);
                        } else if ("select-hotspot" === le1.type) {
                            const vt = le1.hotspotId;
                            vt.startsWith(Zd) && this.setCurrentNode(vt.substring(13));
                        }
                    }
                    getCurrentNode() {
                        return this.state.currentNode;
                    }
                    setNodes(le1, vt) {
                        if (this.isServerSide) throw new ls.e6("Cannot set nodes in server side mode");
                        this.__hideTooltip(), this.state.currentNode = null, this.datasource.setNodes(le1), vt ? this.datasource.nodes[vt] || (vt = le1[0].id, ls.Wp.logWarn(`startNodeId not found is provided nodes, resetted to ${vt}`)) : vt = le1[0].id, this.setCurrentNode(vt), this.__setGalleryItems(), this.__setMapHotspots(), this.__setPlanHotspots();
                    }
                    setCurrentNode(le1, vt, bt) {
                        if (le1 === this.state.currentNode?.id && !vt?.forceUpdate) return Promise.resolve(!0);
                        vt?.forceUpdate && this.isServerSide && this.datasource.clearCache(), this.viewer.hideError(), this.state.loadingNode = le1;
                        const ho = this.state.currentNode, Dl = ho && bt ? this.__getLinkPosition(ho, bt) : null;
                        return Promise.resolve(this.state.preload[le1]).then(()=>{
                            if (this.state.loadingNode !== le1) throw ls.Wp.getAbortError();
                            return this.datasource.loadNode(le1);
                        }).then((Fl)=>{
                            if (this.state.loadingNode !== le1) throw ls.Wp.getAbortError();
                            const sc = {
                                ...em.defaults.transitionOptions,
                                rotateTo: Dl,
                                zoomTo: Dl ? this.viewer.getZoomLevel() : null,
                                ..."function" === typeof this.config.transitionOptions ? this.config.transitionOptions(Fl, ho, bt) : this.config.transitionOptions,
                                ...vt
                            };
                            return sc.effect || (sc.effect = "none"), this.viewer.panel.hide("description"), this.__hideTooltip(), this.arrowsRenderer.clear(), this.gallery?.config.hideOnClick && this.gallery.hide(), this.map?.config.minimizeOnHotspotClick && this.map.minimize(), this.plan?.config.minimizeOnHotspotClick && this.plan.minimize(), sc.rotation && "none" === sc.effect ? this.viewer.animate({
                                ...sc.rotateTo,
                                zoom: sc.zoomTo,
                                speed: sc.speed
                            }).then(()=>[
                                    Fl,
                                    sc
                                ]) : Promise.resolve([
                                Fl,
                                sc
                            ]);
                        }).then((vt)=>{
                            let [bt, ho] = vt;
                            if (this.state.loadingNode !== le1) throw ls.Wp.getAbortError();
                            return this.markers?.clearMarkers(), this.config.linksOnCompass && this.compass?.clearHotspots(), this.viewer.setPanorama(bt.panorama, {
                                caption: bt.caption,
                                description: bt.description,
                                panoData: bt.panoData,
                                sphereCorrection: bt.sphereCorrection,
                                showLoader: ho.showLoader,
                                position: ho.rotateTo,
                                zoom: ho.zoomTo,
                                transition: "none" !== ho.effect && {
                                    effect: ho.effect,
                                    rotation: ho.rotation,
                                    speed: ho.speed
                                }
                            }).then((le1)=>{
                                if (!le1) throw ls.Wp.getAbortError();
                                return bt;
                            });
                        }).then((vt)=>{
                            if (this.state.loadingNode !== le1) throw ls.Wp.getAbortError();
                            return this.state.currentNode = vt, this.map && this.map.setCenter(this.__getNodeMapPosition(vt) ?? this.map.config.center, this.config.map.recenter), this.plan?.setCoordinates(vt.gps), this.__addNodeMarkers(vt), this.__renderLinks(vt), this.__preload(vt), this.state.loadingNode = null, this.dispatchEvent(new sc(vt, {
                                fromNode: ho,
                                fromLink: bt,
                                fromLinkPosition: Dl
                            })), this.viewer.resetIdleTimer(), !0;
                        }).catch((le1)=>{
                            if (ls.Wp.isAbortError(le1)) return !1;
                            throw this.viewer.showError(this.viewer.config.lang.loadError), this.viewer.loader.hide(), this.viewer.navbar.setCaption(""), this.state.loadingNode = null, le1;
                        });
                    }
                    async gotoLink(le1, vt) {
                        void 0 === vt && (vt = "8rpm");
                        const bt = this.getLinkPosition(le1);
                        vt ? await this.viewer.animate({
                            ...bt,
                            speed: vt
                        }) : this.viewer.rotate(bt);
                    }
                    getLinkPosition(le1) {
                        const vt = this.state.currentNode?.links.find((vt)=>vt.nodeId === le1);
                        if (!vt) throw new ls.e6(`Cannot find link "${le1}"`);
                        return this.__getLinkPosition(this.state.currentNode, vt);
                    }
                    updateNode(le1) {
                        if (this.isServerSide) throw new ls.e6("Cannot update node in server side mode");
                        const vt = this.datasource.updateNode(le1);
                        if ((le1.name || le1.thumbnail || le1.panorama) && this.__setGalleryItems(), (le1.name || le1.gps || le1.map) && this.__setMapHotspots(), (le1.name || le1.gps || le1.plan) && this.__setPlanHotspots(), this.state.currentNode?.id === vt.id) {
                            if (this.__hideTooltip(), le1.panorama || le1.panoData || le1.sphereCorrection) return void this.setCurrentNode(vt.id, {
                                forceUpdate: !0
                            });
                            le1.caption && this.viewer.setOption("caption", vt.caption), le1.description && this.viewer.setOption("description", vt.description), (le1.links || le1.gps) && this.__renderLinks(vt), le1.gps && this.plan?.setCoordinates(vt.gps), (le1.map || le1.gps) && this.map?.setCenter(this.__getNodeMapPosition(vt)), (le1.markers || le1.gps) && this.__addNodeMarkers(vt);
                        }
                    }
                    __setGalleryItems() {
                        this.gallery && this.gallery.setItems(Object.values(this.datasource.nodes).filter((le1)=>!1 !== le1.showInGallery).map((le1)=>({
                                id: le1.id,
                                panorama: le1.panorama,
                                name: le1.name,
                                thumbnail: le1.thumbnail
                            })), (le1)=>{
                            this.setCurrentNode(le1);
                        });
                    }
                    __setMapHotspots() {
                        this.map && this.map.setHotspots(Object.values(this.datasource.nodes).filter((le1)=>!1 !== le1.map).map((le1)=>({
                                tooltip: le1.name,
                                ...le1.map || {},
                                ...this.__getNodeMapPosition(le1),
                                id: Zd + le1.id
                            })));
                    }
                    __setPlanHotspots() {
                        this.plan && this.plan.setHotspots(Object.values(this.datasource.nodes).filter((le1)=>!1 !== le1.plan).map((le1)=>({
                                tooltip: le1.name,
                                ...le1.plan || {},
                                coordinates: le1.gps,
                                id: Zd + le1.id
                            })));
                    }
                    __renderLinks(le1) {
                        this.arrowsRenderer.clear();
                        const vt = [];
                        le1.links.forEach((bt)=>{
                            const ls = this.__getLinkPosition(le1, bt);
                            ls.yaw += bt.linkOffset?.yaw ?? 0, ls.pitch += bt.linkOffset?.pitch ?? 0, this.isGps && !this.is3D && (ls.pitch += this.config.arrowsPosition.linkPitchOffset), vt.push(ls), this.arrowsRenderer.addLinkArrow(bt, ls, bt.linkOffset?.depth);
                        }), this.arrowsRenderer.render(), this.config.linksOnCompass && this.compass?.setHotspots(vt);
                    }
                    __getLinkPosition(le1, vt) {
                        return this.isGps ? gpsToSpherical(le1.gps, vt.gps) : this.viewer.dataHelper.cleanPosition(vt.position);
                    }
                    async __getTooltipContent(le1) {
                        const vt = await this.datasource.loadNode(le1.nodeId), bt = [];
                        (vt.name || vt.thumbnail || vt.caption) && (vt.name && bt.push(`<h3>${vt.name}</h3>`), vt.thumbnail && bt.push(`<img src="${vt.thumbnail}">`), vt.caption && bt.push(`<p>${vt.caption}</p>`));
                        let ls = bt.join("");
                        return this.config.getLinkTooltip && (ls = this.config.getLinkTooltip(ls, le1, vt)), ls;
                    }
                    __onEnterArrow(le1, vt) {
                        const bt = ls.Wp.getPosition(this.viewer.container), ho = {
                            x: vt.clientX - bt.x,
                            y: vt.clientY - bt.y
                        };
                        this.config.showLinkTooltip && (this.state.currentTooltip = this.viewer.createTooltip({
                            ...Yd,
                            left: ho.x,
                            top: ho.y,
                            box: {
                                width: 20,
                                height: 20
                            }
                        }), this.__getTooltipContent(le1).then((le1)=>{
                            le1 ? this.state.currentTooltip.update(le1) : this.__hideTooltip();
                        })), this.map?.setActiveHotspot(Zd + le1.nodeId), this.plan?.setActiveHotspot(Zd + le1.nodeId), this.dispatchEvent(new mc(le1, this.state.currentNode));
                    }
                    __onHoverArrow(le1) {
                        const vt = ls.Wp.getPosition(this.viewer.container), bt = {
                            x: le1.clientX - vt.x,
                            y: le1.clientY - vt.y
                        };
                        this.state.currentTooltip?.move({
                            left: bt.x,
                            top: bt.y
                        });
                    }
                    __onLeaveArrow(le1) {
                        this.__hideTooltip(), this.map?.setActiveHotspot(null), this.plan?.setActiveHotspot(null), this.dispatchEvent(new Ac(le1, this.state.currentNode));
                    }
                    __hideTooltip() {
                        this.state.currentTooltip?.hide(), this.state.currentTooltip = null;
                    }
                    __preload(le1) {
                        this.config.preload && (this.state.preload[le1.id] = !0, this.state.currentNode.links.filter((le1)=>!this.state.preload[le1.nodeId]).filter((le1)=>"function" !== typeof this.config.preload || this.config.preload(this.state.currentNode, le1)).forEach((le1)=>{
                            this.state.preload[le1.nodeId] = this.datasource.loadNode(le1.nodeId).then((le1)=>this.viewer.textureLoader.preloadPanorama(le1.panorama)).then(()=>{
                                this.state.preload[le1.nodeId] = !0;
                            }).catch(()=>{
                                delete this.state.preload[le1.nodeId];
                            });
                        }));
                    }
                    __addNodeMarkers(le1) {
                        le1.markers && (this.markers ? this.markers.setMarkers(le1.markers.map((vt)=>(vt.gps && this.isGps && (vt.position = gpsToSpherical(le1.gps, vt.gps), vt.data?.map && Object.assign(vt.data.map, this.__getGpsMapPosition(vt.gps)), vt.data?.plan && (vt.data.plan.coordinates = vt.gps)), vt))) : ls.Wp.logWarn(`Node ${le1.id} markers ignored because the plugin is not loaded.`));
                    }
                    __getNodeMapPosition(le1) {
                        const vt = this.__getGpsMapPosition(le1.gps);
                        return vt || (le1.map ? {
                            x: le1.map.x,
                            y: le1.map.y
                        } : null);
                    }
                    __getGpsMapPosition(le1) {
                        const vt = this.config.map;
                        return this.isGps && vt && vt.extent && vt.size ? {
                            x: ho.cj9.mapLinear(le1[0], vt.extent[0], vt.extent[2], 0, vt.size.width),
                            y: ho.cj9.mapLinear(le1[1], vt.extent[1], vt.extent[3], 0, vt.size.height)
                        } : null;
                    }
                };
                tm.id = "virtual-tour", tm.VERSION = "5.14.1", tm.configParser = em, tm.readonlyOptions = Object.keys(em.defaults);
                var im = tm;
            },
            3336: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Rq: ()=>decompressSync
                });
                var ls = Uint8Array, ho = Uint16Array, Dl = Int32Array, Fl = new ls([
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    1,
                    1,
                    2,
                    2,
                    2,
                    2,
                    3,
                    3,
                    3,
                    3,
                    4,
                    4,
                    4,
                    4,
                    5,
                    5,
                    5,
                    5,
                    0,
                    0,
                    0,
                    0
                ]), sc = new ls([
                    0,
                    0,
                    0,
                    0,
                    1,
                    1,
                    2,
                    2,
                    3,
                    3,
                    4,
                    4,
                    5,
                    5,
                    6,
                    6,
                    7,
                    7,
                    8,
                    8,
                    9,
                    9,
                    10,
                    10,
                    11,
                    11,
                    12,
                    12,
                    13,
                    13,
                    0,
                    0
                ]), uc = new ls([
                    16,
                    17,
                    18,
                    0,
                    8,
                    7,
                    9,
                    6,
                    10,
                    5,
                    11,
                    4,
                    12,
                    3,
                    13,
                    2,
                    14,
                    1,
                    15
                ]), freb = function(le1, vt) {
                    for(var bt = new ho(31), ls = 0; ls < 31; ++ls)bt[ls] = vt += 1 << le1[ls - 1];
                    var Fl = new Dl(bt[30]);
                    for(ls = 1; ls < 30; ++ls)for(var sc = bt[ls]; sc < bt[ls + 1]; ++sc)Fl[sc] = sc - bt[ls] << 5 | ls;
                    return {
                        b: bt,
                        r: Fl
                    };
                }, mc = freb(Fl, 2), gc = mc.b, Ac = mc.r;
                gc[28] = 258, Ac[258] = 28;
                for(var Ec = freb(sc, 0), kc = Ec.b, du = (Ec.r, new ho(32768)), _u = 0; _u < 32768; ++_u){
                    var Md = (43690 & _u) >> 1 | (21845 & _u) << 1;
                    Md = (61680 & (Md = (52428 & Md) >> 2 | (13107 & Md) << 2)) >> 4 | (3855 & Md) << 4, du[_u] = ((65280 & Md) >> 8 | (255 & Md) << 8) >> 1;
                }
                var hMap = function(le1, vt, bt) {
                    for(var ls = le1.length, Dl = 0, Fl = new ho(vt); Dl < ls; ++Dl)le1[Dl] && ++Fl[le1[Dl] - 1];
                    var sc, uc = new ho(vt);
                    for(Dl = 1; Dl < vt; ++Dl)uc[Dl] = uc[Dl - 1] + Fl[Dl - 1] << 1;
                    if (bt) {
                        sc = new ho(1 << vt);
                        var mc = 15 - vt;
                        for(Dl = 0; Dl < ls; ++Dl)if (le1[Dl]) for(var gc = Dl << 4 | le1[Dl], Ac = vt - le1[Dl], Ec = uc[le1[Dl] - 1]++ << Ac, kc = Ec | (1 << Ac) - 1; Ec <= kc; ++Ec)sc[du[Ec] >> mc] = gc;
                    } else for(sc = new ho(ls), Dl = 0; Dl < ls; ++Dl)le1[Dl] && (sc[Dl] = du[uc[le1[Dl] - 1]++] >> 15 - le1[Dl]);
                    return sc;
                }, Ld = new ls(288);
                for(_u = 0; _u < 144; ++_u)Ld[_u] = 8;
                for(_u = 144; _u < 256; ++_u)Ld[_u] = 9;
                for(_u = 256; _u < 280; ++_u)Ld[_u] = 7;
                for(_u = 280; _u < 288; ++_u)Ld[_u] = 8;
                var Nd = new ls(32);
                for(_u = 0; _u < 32; ++_u)Nd[_u] = 5;
                var Rd = hMap(Ld, 9, 1), Od = hMap(Nd, 5, 1), max = function(le1) {
                    for(var vt = le1[0], bt = 1; bt < le1.length; ++bt)le1[bt] > vt && (vt = le1[bt]);
                    return vt;
                }, bits = function(le1, vt, bt) {
                    var ls = vt / 8 | 0;
                    return (le1[ls] | le1[ls + 1] << 8) >> (7 & vt) & bt;
                }, bits16 = function(le1, vt) {
                    var bt = vt / 8 | 0;
                    return (le1[bt] | le1[bt + 1] << 8 | le1[bt + 2] << 16) >> (7 & vt);
                }, shft = function(le1) {
                    return (le1 + 7) / 8 | 0;
                }, slc = function(le1, vt, bt) {
                    return (null == vt || vt < 0) && (vt = 0), (null == bt || bt > le1.length) && (bt = le1.length), new ls(le1.subarray(vt, bt));
                }, jd = [
                    "unexpected EOF",
                    "invalid block type",
                    "invalid length/literal",
                    "invalid distance",
                    "stream finished",
                    "no stream handler",
                    ,
                    "no callback",
                    "invalid UTF-8 data",
                    "extra field too long",
                    "date not in range 1980-2099",
                    "filename too long",
                    "stream finishing",
                    "invalid zip data"
                ], err = function(le1, vt, bt) {
                    var ls = new Error(vt || jd[le1]);
                    if (ls.code = le1, Error.captureStackTrace && Error.captureStackTrace(ls, err), !bt) throw ls;
                    return ls;
                }, inflt = function(le1, vt, bt, ho) {
                    var Dl = le1.length, mc = ho ? ho.length : 0;
                    if (!Dl || vt.f && !vt.l) return bt || new ls(0);
                    var Ac = !bt, Ec = Ac || 2 != vt.i, du = vt.i;
                    Ac && (bt = new ls(3 * Dl));
                    var cbuf = function(le1) {
                        var vt = bt.length;
                        if (le1 > vt) {
                            var ho = new ls(Math.max(2 * vt, le1));
                            ho.set(bt), bt = ho;
                        }
                    }, _u = vt.f || 0, Md = vt.p || 0, Ld = vt.b || 0, Nd = vt.l, jd = vt.d, Ud = vt.m, Gd = vt.n, qd = 8 * Dl;
                    do {
                        if (!Nd) {
                            _u = bits(le1, Md, 1);
                            var Hd = bits(le1, Md + 1, 3);
                            if (Md += 3, !Hd) {
                                var Wd = le1[(im = shft(Md) + 4) - 4] | le1[im - 3] << 8, Zd = im + Wd;
                                if (Zd > Dl) {
                                    du && err(0);
                                    break;
                                }
                                Ec && cbuf(Ld + Wd), bt.set(le1.subarray(im, Zd), Ld), vt.b = Ld += Wd, vt.p = Md = 8 * Zd, vt.f = _u;
                                continue;
                            }
                            if (1 == Hd) Nd = Rd, jd = Od, Ud = 9, Gd = 5;
                            else if (2 == Hd) {
                                var Yd = bits(le1, Md, 31) + 257, Qd = bits(le1, Md + 10, 15) + 4, Xd = Yd + bits(le1, Md + 5, 31) + 1;
                                Md += 14;
                                for(var Kd = new ls(Xd), Jd = new ls(19), $d = 0; $d < Qd; ++$d)Jd[uc[$d]] = bits(le1, Md + 3 * $d, 7);
                                Md += 3 * Qd;
                                var sp = max(Jd), em = (1 << sp) - 1, tm = hMap(Jd, sp, 1);
                                for($d = 0; $d < Xd;){
                                    var im, nm = tm[bits(le1, Md, em)];
                                    if (Md += 15 & nm, (im = nm >> 4) < 16) Kd[$d++] = im;
                                    else {
                                        var rm = 0, am = 0;
                                        for(16 == im ? (am = 3 + bits(le1, Md, 3), Md += 2, rm = Kd[$d - 1]) : 17 == im ? (am = 3 + bits(le1, Md, 7), Md += 3) : 18 == im && (am = 11 + bits(le1, Md, 127), Md += 7); am--;)Kd[$d++] = rm;
                                    }
                                }
                                var sm = Kd.subarray(0, Yd), om = Kd.subarray(Yd);
                                Ud = max(sm), Gd = max(om), Nd = hMap(sm, Ud, 1), jd = hMap(om, Gd, 1);
                            } else err(1);
                            if (Md > qd) {
                                du && err(0);
                                break;
                            }
                        }
                        Ec && cbuf(Ld + 131072);
                        for(var lm = (1 << Ud) - 1, cm = (1 << Gd) - 1, um = Md;; um = Md){
                            var hm = (rm = Nd[bits16(le1, Md) & lm]) >> 4;
                            if ((Md += 15 & rm) > qd) {
                                du && err(0);
                                break;
                            }
                            if (rm || err(2), hm < 256) bt[Ld++] = hm;
                            else {
                                if (256 == hm) {
                                    um = Md, Nd = null;
                                    break;
                                }
                                var dm = hm - 254;
                                if (hm > 264) {
                                    var pm = Fl[$d = hm - 257];
                                    dm = bits(le1, Md, (1 << pm) - 1) + gc[$d], Md += pm;
                                }
                                var mm = jd[bits16(le1, Md) & cm], fm = mm >> 4;
                                mm || err(3), Md += 15 & mm;
                                om = kc[fm];
                                if (fm > 3) {
                                    pm = sc[fm];
                                    om += bits16(le1, Md) & (1 << pm) - 1, Md += pm;
                                }
                                if (Md > qd) {
                                    du && err(0);
                                    break;
                                }
                                Ec && cbuf(Ld + 131072);
                                var gm = Ld + dm;
                                if (Ld < om) {
                                    var Am = mc - om, _m = Math.min(om, gm);
                                    for(Am + Ld < 0 && err(3); Ld < _m; ++Ld)bt[Ld] = ho[Am + Ld];
                                }
                                for(; Ld < gm; ++Ld)bt[Ld] = bt[Ld - om];
                            }
                        }
                        vt.l = Nd, vt.p = um, vt.b = Ld, vt.f = _u, Nd && (_u = 1, vt.m = Ud, vt.d = jd, vt.n = Gd);
                    }while (!_u);
                    return Ld != bt.length && Ac ? slc(bt, 0, Ld) : bt.subarray(0, Ld);
                }, Ud = new ls(0), gzs = function(le1) {
                    31 == le1[0] && 139 == le1[1] && 8 == le1[2] || err(6, "invalid gzip data");
                    var vt = le1[3], bt = 10;
                    4 & vt && (bt += 2 + (le1[10] | le1[11] << 8));
                    for(var ls = (vt >> 3 & 1) + (vt >> 4 & 1); ls > 0; ls -= !le1[bt++]);
                    return bt + (2 & vt);
                }, gzl = function(le1) {
                    var vt = le1.length;
                    return (le1[vt - 4] | le1[vt - 3] << 8 | le1[vt - 2] << 16 | le1[vt - 1] << 24) >>> 0;
                }, zls = function(le1, vt) {
                    return (8 != (15 & le1[0]) || le1[0] >> 4 > 7 || (le1[0] << 8 | le1[1]) % 31) && err(6, "invalid zlib data"), (le1[1] >> 5 & 1) == +!vt && err(6, "invalid zlib data: " + (32 & le1[1] ? "need" : "unexpected") + " dictionary"), 2 + (le1[1] >> 3 & 4);
                };
                function inflateSync(le1, vt) {
                    return inflt(le1, {
                        i: 2
                    }, vt && vt.out, vt && vt.dictionary);
                }
                function gunzipSync(le1, vt) {
                    var bt = gzs(le1);
                    return bt + 8 > le1.length && err(6, "invalid gzip data"), inflt(le1.subarray(bt, -8), {
                        i: 2
                    }, vt && vt.out || new ls(gzl(le1)), vt && vt.dictionary);
                }
                function unzlibSync(le1, vt) {
                    return inflt(le1.subarray(zls(le1, vt && vt.dictionary), -4), {
                        i: 2
                    }, vt && vt.out, vt && vt.dictionary);
                }
                function decompressSync(le1, vt) {
                    return 31 == le1[0] && 139 == le1[1] && 8 == le1[2] ? gunzipSync(le1, vt) : 8 != (15 & le1[0]) || le1[0] >> 4 > 7 || (le1[0] << 8 | le1[1]) % 31 ? inflateSync(le1, vt) : unzlibSync(le1, vt);
                }
                var Gd = "undefined" != typeof TextDecoder && new TextDecoder;
                try {
                    Gd.decode(Ud, {
                        stream: !0
                    });
                } catch (qd) {}
                "function" == typeof queueMicrotask ? queueMicrotask : "function" == typeof setTimeout && setTimeout;
            },
            2614: function(le1) {
                le1.exports = function() {
                    "use strict";
                    function createCommonjsModule(le1, vt) {
                        return le1(vt = {
                            exports: {}
                        }, vt.exports), vt.exports;
                    }
                    var le1 = createCommonjsModule(function(le1) {
                        var vt = le1.exports = "undefined" != typeof window && window.Math == Math ? window : "undefined" != typeof self && self.Math == Math ? self : Function("return this")();
                        "number" == typeof __g && (__g = vt);
                    }), vt = createCommonjsModule(function(le1) {
                        var vt = le1.exports = {
                            version: "2.6.5"
                        };
                        "number" == typeof __e && (__e = vt);
                    }), bt = (vt.version, function(le1) {
                        return "object" === typeof le1 ? null !== le1 : "function" === typeof le1;
                    }), _anObject = function(le1) {
                        if (!bt(le1)) throw TypeError(le1 + " is not an object!");
                        return le1;
                    }, _fails = function(le1) {
                        try {
                            return !!le1();
                        } catch (vt) {
                            return !0;
                        }
                    }, ls = !_fails(function() {
                        return 7 != Object.defineProperty({}, "a", {
                            get: function() {
                                return 7;
                            }
                        }).a;
                    }), ho = le1.document, Dl = bt(ho) && bt(ho.createElement), _domCreate = function(le1) {
                        return Dl ? ho.createElement(le1) : {};
                    }, Fl = !ls && !_fails(function() {
                        return 7 != Object.defineProperty(_domCreate("div"), "a", {
                            get: function() {
                                return 7;
                            }
                        }).a;
                    }), _toPrimitive = function(le1, vt) {
                        if (!bt(le1)) return le1;
                        var ls, ho;
                        if (vt && "function" == typeof (ls = le1.toString) && !bt(ho = ls.call(le1))) return ho;
                        if ("function" == typeof (ls = le1.valueOf) && !bt(ho = ls.call(le1))) return ho;
                        if (!vt && "function" == typeof (ls = le1.toString) && !bt(ho = ls.call(le1))) return ho;
                        throw TypeError("Can't convert object to primitive value");
                    }, sc = Object.defineProperty, uc = {
                        f: ls ? Object.defineProperty : function(le1, vt, bt) {
                            if (_anObject(le1), vt = _toPrimitive(vt, !0), _anObject(bt), Fl) try {
                                return sc(le1, vt, bt);
                            } catch (ls) {}
                            if ("get" in bt || "set" in bt) throw TypeError("Accessors not supported!");
                            return "value" in bt && (le1[vt] = bt.value), le1;
                        }
                    }, _propertyDesc = function(le1, vt) {
                        return {
                            enumerable: !(1 & le1),
                            configurable: !(2 & le1),
                            writable: !(4 & le1),
                            value: vt
                        };
                    }, mc = ls ? function(le1, vt, bt) {
                        return uc.f(le1, vt, _propertyDesc(1, bt));
                    } : function(le1, vt, bt) {
                        return le1[vt] = bt, le1;
                    }, gc = {}.hasOwnProperty, _has = function(le1, vt) {
                        return gc.call(le1, vt);
                    }, Ac = 0, Ec = Math.random(), _uid = function(le1) {
                        return "Symbol(".concat(void 0 === le1 ? "" : le1, ")_", (++Ac + Ec).toString(36));
                    }, kc = !1, du = createCommonjsModule(function(bt) {
                        var ls = "__core-js_shared__", ho = le1[ls] || (le1[ls] = {});
                        (bt.exports = function(le1, vt) {
                            return ho[le1] || (ho[le1] = void 0 !== vt ? vt : {});
                        })("versions", []).push({
                            version: vt.version,
                            mode: kc ? "pure" : "global",
                            copyright: "\xa9 2019 Denis Pushkarev (zloirock.ru)"
                        });
                    }), _u = du("native-function-to-string", Function.toString), Md = createCommonjsModule(function(bt) {
                        var ls = _uid("src"), ho = "toString", Dl = ("" + _u).split(ho);
                        vt.inspectSource = function(le1) {
                            return _u.call(le1);
                        }, (bt.exports = function(vt, bt, ho, Fl) {
                            var sc = "function" == typeof ho;
                            sc && (_has(ho, "name") || mc(ho, "name", bt)), vt[bt] !== ho && (sc && (_has(ho, ls) || mc(ho, ls, vt[bt] ? "" + vt[bt] : Dl.join(String(bt)))), vt === le1 ? vt[bt] = ho : Fl ? vt[bt] ? vt[bt] = ho : mc(vt, bt, ho) : (delete vt[bt], mc(vt, bt, ho)));
                        })(Function.prototype, ho, function() {
                            return "function" == typeof this && this[ls] || _u.call(this);
                        });
                    }), _aFunction = function(le1) {
                        if ("function" != typeof le1) throw TypeError(le1 + " is not a function!");
                        return le1;
                    }, _ctx = function(le1, vt, bt) {
                        if (_aFunction(le1), void 0 === vt) return le1;
                        switch(bt){
                            case 1:
                                return function(bt) {
                                    return le1.call(vt, bt);
                                };
                            case 2:
                                return function(bt, ls) {
                                    return le1.call(vt, bt, ls);
                                };
                            case 3:
                                return function(bt, ls, ho) {
                                    return le1.call(vt, bt, ls, ho);
                                };
                        }
                        return function() {
                            return le1.apply(vt, arguments);
                        };
                    }, Ld = "prototype", $export = function(bt, ls, ho) {
                        var Dl, Fl, sc, uc, gc = bt & $export.F, Ac = bt & $export.G, Ec = bt & $export.S, kc = bt & $export.P, du = bt & $export.B, _u = Ac ? le1 : Ec ? le1[ls] || (le1[ls] = {}) : (le1[ls] || {})[Ld], Nd = Ac ? vt : vt[ls] || (vt[ls] = {}), Rd = Nd[Ld] || (Nd[Ld] = {});
                        for(Dl in Ac && (ho = ls), ho)sc = ((Fl = !gc && _u && void 0 !== _u[Dl]) ? _u : ho)[Dl], uc = du && Fl ? _ctx(sc, le1) : kc && "function" == typeof sc ? _ctx(Function.call, sc) : sc, _u && Md(_u, Dl, sc, bt & $export.U), Nd[Dl] != sc && mc(Nd, Dl, uc), kc && Rd[Dl] != sc && (Rd[Dl] = sc);
                    };
                    le1.core = vt, $export.F = 1, $export.G = 2, $export.S = 4, $export.P = 8, $export.B = 16, $export.W = 32, $export.U = 64, $export.R = 128;
                    var Nd, Rd = $export, Od = Math.ceil, jd = Math.floor, _toInteger = function(le1) {
                        return isNaN(le1 = +le1) ? 0 : (le1 > 0 ? jd : Od)(le1);
                    }, _defined = function(le1) {
                        if (void 0 == le1) throw TypeError("Can't call method on  " + le1);
                        return le1;
                    }, Ud = (Nd = !1, function(le1, vt) {
                        var bt, ls, ho = String(_defined(le1)), Dl = _toInteger(vt), Fl = ho.length;
                        return Dl < 0 || Dl >= Fl ? Nd ? "" : void 0 : (bt = ho.charCodeAt(Dl)) < 55296 || bt > 56319 || Dl + 1 === Fl || (ls = ho.charCodeAt(Dl + 1)) < 56320 || ls > 57343 ? Nd ? ho.charAt(Dl) : bt : Nd ? ho.slice(Dl, Dl + 2) : ls - 56320 + (bt - 55296 << 10) + 65536;
                    });
                    Rd(Rd.P, "String", {
                        codePointAt: function(le1) {
                            return Ud(this, le1);
                        }
                    }), vt.String.codePointAt;
                    var Gd = Math.max, qd = Math.min, _toAbsoluteIndex = function(le1, vt) {
                        return (le1 = _toInteger(le1)) < 0 ? Gd(le1 + vt, 0) : qd(le1, vt);
                    }, Hd = String.fromCharCode, Wd = String.fromCodePoint;
                    Rd(Rd.S + Rd.F * (!!Wd && 1 != Wd.length), "String", {
                        fromCodePoint: function(le1) {
                            for(var vt, bt = arguments, ls = [], ho = arguments.length, Dl = 0; ho > Dl;){
                                if (vt = +bt[Dl++], _toAbsoluteIndex(vt, 1114111) !== vt) throw RangeError(vt + " is not a valid code point");
                                ls.push(vt < 65536 ? Hd(vt) : Hd(55296 + ((vt -= 65536) >> 10), vt % 1024 + 56320));
                            }
                            return ls.join("");
                        }
                    }), vt.String.fromCodePoint;
                    var Zd, Yd, Qd, Xd, Kd, Jd, $d, sp, em, tm, im, nm, rm, am, sm = {
                        Space_Separator: /[\u1680\u2000-\u200A\u202F\u205F\u3000]/,
                        ID_Start: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u05D0-\u05EA\u05F0-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1711\u1720-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1877\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4B\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C88\u1CE9-\u1CEC\u1CEE-\u1CF1\u1CF5\u1CF6\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005-\u3007\u3021-\u3029\u3031-\u3035\u3038-\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6EF\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC03-\uDC37\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDF00-\uDF19]|\uD806[\uDCA0-\uDCDF\uDCFF\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE83\uDE86-\uDE89\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50\uDF93-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]/,
                        ID_Continue: /[\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0300-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u0483-\u0487\u048A-\u052F\u0531-\u0556\u0559\u0561-\u0587\u0591-\u05BD\u05BF\u05C1\u05C2\u05C4\u05C5\u05C7\u05D0-\u05EA\u05F0-\u05F2\u0610-\u061A\u0620-\u0669\u066E-\u06D3\u06D5-\u06DC\u06DF-\u06E8\u06EA-\u06FC\u06FF\u0710-\u074A\u074D-\u07B1\u07C0-\u07F5\u07FA\u0800-\u082D\u0840-\u085B\u0860-\u086A\u08A0-\u08B4\u08B6-\u08BD\u08D4-\u08E1\u08E3-\u0963\u0966-\u096F\u0971-\u0983\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BC-\u09C4\u09C7\u09C8\u09CB-\u09CE\u09D7\u09DC\u09DD\u09DF-\u09E3\u09E6-\u09F1\u09FC\u0A01-\u0A03\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A3C\u0A3E-\u0A42\u0A47\u0A48\u0A4B-\u0A4D\u0A51\u0A59-\u0A5C\u0A5E\u0A66-\u0A75\u0A81-\u0A83\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABC-\u0AC5\u0AC7-\u0AC9\u0ACB-\u0ACD\u0AD0\u0AE0-\u0AE3\u0AE6-\u0AEF\u0AF9-\u0AFF\u0B01-\u0B03\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3C-\u0B44\u0B47\u0B48\u0B4B-\u0B4D\u0B56\u0B57\u0B5C\u0B5D\u0B5F-\u0B63\u0B66-\u0B6F\u0B71\u0B82\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BBE-\u0BC2\u0BC6-\u0BC8\u0BCA-\u0BCD\u0BD0\u0BD7\u0BE6-\u0BEF\u0C00-\u0C03\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D-\u0C44\u0C46-\u0C48\u0C4A-\u0C4D\u0C55\u0C56\u0C58-\u0C5A\u0C60-\u0C63\u0C66-\u0C6F\u0C80-\u0C83\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBC-\u0CC4\u0CC6-\u0CC8\u0CCA-\u0CCD\u0CD5\u0CD6\u0CDE\u0CE0-\u0CE3\u0CE6-\u0CEF\u0CF1\u0CF2\u0D00-\u0D03\u0D05-\u0D0C\u0D0E-\u0D10\u0D12-\u0D44\u0D46-\u0D48\u0D4A-\u0D4E\u0D54-\u0D57\u0D5F-\u0D63\u0D66-\u0D6F\u0D7A-\u0D7F\u0D82\u0D83\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0DCA\u0DCF-\u0DD4\u0DD6\u0DD8-\u0DDF\u0DE6-\u0DEF\u0DF2\u0DF3\u0E01-\u0E3A\u0E40-\u0E4E\u0E50-\u0E59\u0E81\u0E82\u0E84\u0E87\u0E88\u0E8A\u0E8D\u0E94-\u0E97\u0E99-\u0E9F\u0EA1-\u0EA3\u0EA5\u0EA7\u0EAA\u0EAB\u0EAD-\u0EB9\u0EBB-\u0EBD\u0EC0-\u0EC4\u0EC6\u0EC8-\u0ECD\u0ED0-\u0ED9\u0EDC-\u0EDF\u0F00\u0F18\u0F19\u0F20-\u0F29\u0F35\u0F37\u0F39\u0F3E-\u0F47\u0F49-\u0F6C\u0F71-\u0F84\u0F86-\u0F97\u0F99-\u0FBC\u0FC6\u1000-\u1049\u1050-\u109D\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u135D-\u135F\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16EE-\u16F8\u1700-\u170C\u170E-\u1714\u1720-\u1734\u1740-\u1753\u1760-\u176C\u176E-\u1770\u1772\u1773\u1780-\u17D3\u17D7\u17DC\u17DD\u17E0-\u17E9\u180B-\u180D\u1810-\u1819\u1820-\u1877\u1880-\u18AA\u18B0-\u18F5\u1900-\u191E\u1920-\u192B\u1930-\u193B\u1946-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u19D0-\u19D9\u1A00-\u1A1B\u1A20-\u1A5E\u1A60-\u1A7C\u1A7F-\u1A89\u1A90-\u1A99\u1AA7\u1AB0-\u1ABD\u1B00-\u1B4B\u1B50-\u1B59\u1B6B-\u1B73\u1B80-\u1BF3\u1C00-\u1C37\u1C40-\u1C49\u1C4D-\u1C7D\u1C80-\u1C88\u1CD0-\u1CD2\u1CD4-\u1CF9\u1D00-\u1DF9\u1DFB-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u203F\u2040\u2054\u2071\u207F\u2090-\u209C\u20D0-\u20DC\u20E1\u20E5-\u20F0\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2160-\u2188\u2C00-\u2C2E\u2C30-\u2C5E\u2C60-\u2CE4\u2CEB-\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D7F-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2DE0-\u2DFF\u2E2F\u3005-\u3007\u3021-\u302F\u3031-\u3035\u3038-\u303C\u3041-\u3096\u3099\u309A\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312E\u3131-\u318E\u31A0-\u31BA\u31F0-\u31FF\u3400-\u4DB5\u4E00-\u9FEA\uA000-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA62B\uA640-\uA66F\uA674-\uA67D\uA67F-\uA6F1\uA717-\uA71F\uA722-\uA788\uA78B-\uA7AE\uA7B0-\uA7B7\uA7F7-\uA827\uA840-\uA873\uA880-\uA8C5\uA8D0-\uA8D9\uA8E0-\uA8F7\uA8FB\uA8FD\uA900-\uA92D\uA930-\uA953\uA960-\uA97C\uA980-\uA9C0\uA9CF-\uA9D9\uA9E0-\uA9FE\uAA00-\uAA36\uAA40-\uAA4D\uAA50-\uAA59\uAA60-\uAA76\uAA7A-\uAAC2\uAADB-\uAADD\uAAE0-\uAAEF\uAAF2-\uAAF6\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB65\uAB70-\uABEA\uABEC\uABED\uABF0-\uABF9\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE00-\uFE0F\uFE20-\uFE2F\uFE33\uFE34\uFE4D-\uFE4F\uFE70-\uFE74\uFE76-\uFEFC\uFF10-\uFF19\uFF21-\uFF3A\uFF3F\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDD40-\uDD74\uDDFD\uDE80-\uDE9C\uDEA0-\uDED0\uDEE0\uDF00-\uDF1F\uDF2D-\uDF4A\uDF50-\uDF7A\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF\uDFD1-\uDFD5]|\uD801[\uDC00-\uDC9D\uDCA0-\uDCA9\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD80-\uDDB7\uDDBE\uDDBF\uDE00-\uDE03\uDE05\uDE06\uDE0C-\uDE13\uDE15-\uDE17\uDE19-\uDE33\uDE38-\uDE3A\uDE3F\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE6\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2]|\uD804[\uDC00-\uDC46\uDC66-\uDC6F\uDC7F-\uDCBA\uDCD0-\uDCE8\uDCF0-\uDCF9\uDD00-\uDD34\uDD36-\uDD3F\uDD50-\uDD73\uDD76\uDD80-\uDDC4\uDDCA-\uDDCC\uDDD0-\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE37\uDE3E\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEEA\uDEF0-\uDEF9\uDF00-\uDF03\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3C-\uDF44\uDF47\uDF48\uDF4B-\uDF4D\uDF50\uDF57\uDF5D-\uDF63\uDF66-\uDF6C\uDF70-\uDF74]|\uD805[\uDC00-\uDC4A\uDC50-\uDC59\uDC80-\uDCC5\uDCC7\uDCD0-\uDCD9\uDD80-\uDDB5\uDDB8-\uDDC0\uDDD8-\uDDDD\uDE00-\uDE40\uDE44\uDE50-\uDE59\uDE80-\uDEB7\uDEC0-\uDEC9\uDF00-\uDF19\uDF1D-\uDF2B\uDF30-\uDF39]|\uD806[\uDCA0-\uDCE9\uDCFF\uDE00-\uDE3E\uDE47\uDE50-\uDE83\uDE86-\uDE99\uDEC0-\uDEF8]|\uD807[\uDC00-\uDC08\uDC0A-\uDC36\uDC38-\uDC40\uDC50-\uDC59\uDC72-\uDC8F\uDC92-\uDCA7\uDCA9-\uDCB6\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD36\uDD3A\uDD3C\uDD3D\uDD3F-\uDD47\uDD50-\uDD59]|\uD808[\uDC00-\uDF99]|\uD809[\uDC00-\uDC6E\uDC80-\uDD43]|[\uD80C\uD81C-\uD820\uD840-\uD868\uD86A-\uD86C\uD86F-\uD872\uD874-\uD879][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2E]|\uD811[\uDC00-\uDE46]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE60-\uDE69\uDED0-\uDEED\uDEF0-\uDEF4\uDF00-\uDF36\uDF40-\uDF43\uDF50-\uDF59\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDF00-\uDF44\uDF50-\uDF7E\uDF8F-\uDF9F\uDFE0\uDFE1]|\uD821[\uDC00-\uDFEC]|\uD822[\uDC00-\uDEF2]|\uD82C[\uDC00-\uDD1E\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99\uDC9D\uDC9E]|\uD834[\uDD65-\uDD69\uDD6D-\uDD72\uDD7B-\uDD82\uDD85-\uDD8B\uDDAA-\uDDAD\uDE42-\uDE44]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB\uDFCE-\uDFFF]|\uD836[\uDE00-\uDE36\uDE3B-\uDE6C\uDE75\uDE84\uDE9B-\uDE9F\uDEA1-\uDEAF]|\uD838[\uDC00-\uDC06\uDC08-\uDC18\uDC1B-\uDC21\uDC23\uDC24\uDC26-\uDC2A]|\uD83A[\uDC00-\uDCC4\uDCD0-\uDCD6\uDD00-\uDD4A\uDD50-\uDD59]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDED6\uDF00-\uDFFF]|\uD86D[\uDC00-\uDF34\uDF40-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEA1\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0]|\uD87E[\uDC00-\uDE1D]|\uDB40[\uDD00-\uDDEF]/
                    }, om = {
                        isSpaceSeparator: function(le1) {
                            return "string" === typeof le1 && sm.Space_Separator.test(le1);
                        },
                        isIdStartChar: function(le1) {
                            return "string" === typeof le1 && (le1 >= "a" && le1 <= "z" || le1 >= "A" && le1 <= "Z" || "$" === le1 || "_" === le1 || sm.ID_Start.test(le1));
                        },
                        isIdContinueChar: function(le1) {
                            return "string" === typeof le1 && (le1 >= "a" && le1 <= "z" || le1 >= "A" && le1 <= "Z" || le1 >= "0" && le1 <= "9" || "$" === le1 || "_" === le1 || "\u200c" === le1 || "\u200d" === le1 || sm.ID_Continue.test(le1));
                        },
                        isDigit: function(le1) {
                            return "string" === typeof le1 && /[0-9]/.test(le1);
                        },
                        isHexDigit: function(le1) {
                            return "string" === typeof le1 && /[0-9A-Fa-f]/.test(le1);
                        }
                    }, parse = function(le1, vt) {
                        Zd = String(le1), Yd = "start", Qd = [], Xd = 0, Kd = 1, Jd = 0, $d = void 0, sp = void 0, em = void 0;
                        do $d = lex(), cm[Yd]();
                        while ("eof" !== $d.type);
                        return "function" === typeof vt ? internalize({
                            "": em
                        }, "", vt) : em;
                    };
                    function internalize(le1, vt, bt) {
                        var ls = le1[vt];
                        if (null != ls && "object" === typeof ls) {
                            if (Array.isArray(ls)) for(var ho = 0; ho < ls.length; ho++){
                                var Dl = String(ho), Fl = internalize(ls, Dl, bt);
                                void 0 === Fl ? delete ls[Dl] : Object.defineProperty(ls, Dl, {
                                    value: Fl,
                                    writable: !0,
                                    enumerable: !0,
                                    configurable: !0
                                });
                            }
                            else for(var sc in ls){
                                var uc = internalize(ls, sc, bt);
                                void 0 === uc ? delete ls[sc] : Object.defineProperty(ls, sc, {
                                    value: uc,
                                    writable: !0,
                                    enumerable: !0,
                                    configurable: !0
                                });
                            }
                        }
                        return bt.call(le1, vt, ls);
                    }
                    function lex() {
                        for(tm = "default", im = "", nm = !1, rm = 1;;){
                            am = peek();
                            var le1 = lm[tm]();
                            if (le1) return le1;
                        }
                    }
                    function peek() {
                        if (Zd[Xd]) return String.fromCodePoint(Zd.codePointAt(Xd));
                    }
                    function read() {
                        var le1 = peek();
                        return "\n" === le1 ? (Kd++, Jd = 0) : le1 ? Jd += le1.length : Jd++, le1 && (Xd += le1.length), le1;
                    }
                    var lm = {
                        default: function() {
                            switch(am){
                                case "\t":
                                case "\v":
                                case "\f":
                                case " ":
                                case "\xa0":
                                case "\ufeff":
                                case "\n":
                                case "\r":
                                case "\u2028":
                                case "\u2029":
                                    return void read();
                                case "/":
                                    return read(), void (tm = "comment");
                                case void 0:
                                    return read(), newToken("eof");
                            }
                            if (!om.isSpaceSeparator(am)) return lm[Yd]();
                            read();
                        },
                        comment: function() {
                            switch(am){
                                case "*":
                                    return read(), void (tm = "multiLineComment");
                                case "/":
                                    return read(), void (tm = "singleLineComment");
                            }
                            throw invalidChar(read());
                        },
                        multiLineComment: function() {
                            switch(am){
                                case "*":
                                    return read(), void (tm = "multiLineCommentAsterisk");
                                case void 0:
                                    throw invalidChar(read());
                            }
                            read();
                        },
                        multiLineCommentAsterisk: function() {
                            switch(am){
                                case "*":
                                    return void read();
                                case "/":
                                    return read(), void (tm = "default");
                                case void 0:
                                    throw invalidChar(read());
                            }
                            read(), tm = "multiLineComment";
                        },
                        singleLineComment: function() {
                            switch(am){
                                case "\n":
                                case "\r":
                                case "\u2028":
                                case "\u2029":
                                    return read(), void (tm = "default");
                                case void 0:
                                    return read(), newToken("eof");
                            }
                            read();
                        },
                        value: function() {
                            switch(am){
                                case "{":
                                case "[":
                                    return newToken("punctuator", read());
                                case "n":
                                    return read(), literal("ull"), newToken("null", null);
                                case "t":
                                    return read(), literal("rue"), newToken("boolean", !0);
                                case "f":
                                    return read(), literal("alse"), newToken("boolean", !1);
                                case "-":
                                case "+":
                                    return "-" === read() && (rm = -1), void (tm = "sign");
                                case ".":
                                    return im = read(), void (tm = "decimalPointLeading");
                                case "0":
                                    return im = read(), void (tm = "zero");
                                case "1":
                                case "2":
                                case "3":
                                case "4":
                                case "5":
                                case "6":
                                case "7":
                                case "8":
                                case "9":
                                    return im = read(), void (tm = "decimalInteger");
                                case "I":
                                    return read(), literal("nfinity"), newToken("numeric", 1 / 0);
                                case "N":
                                    return read(), literal("aN"), newToken("numeric", NaN);
                                case '"':
                                case "'":
                                    return nm = '"' === read(), im = "", void (tm = "string");
                            }
                            throw invalidChar(read());
                        },
                        identifierNameStartEscape: function() {
                            if ("u" !== am) throw invalidChar(read());
                            read();
                            var le1 = unicodeEscape();
                            switch(le1){
                                case "$":
                                case "_":
                                    break;
                                default:
                                    if (!om.isIdStartChar(le1)) throw invalidIdentifier();
                            }
                            im += le1, tm = "identifierName";
                        },
                        identifierName: function() {
                            switch(am){
                                case "$":
                                case "_":
                                case "\u200c":
                                case "\u200d":
                                    return void (im += read());
                                case "\\":
                                    return read(), void (tm = "identifierNameEscape");
                            }
                            if (!om.isIdContinueChar(am)) return newToken("identifier", im);
                            im += read();
                        },
                        identifierNameEscape: function() {
                            if ("u" !== am) throw invalidChar(read());
                            read();
                            var le1 = unicodeEscape();
                            switch(le1){
                                case "$":
                                case "_":
                                case "\u200c":
                                case "\u200d":
                                    break;
                                default:
                                    if (!om.isIdContinueChar(le1)) throw invalidIdentifier();
                            }
                            im += le1, tm = "identifierName";
                        },
                        sign: function() {
                            switch(am){
                                case ".":
                                    return im = read(), void (tm = "decimalPointLeading");
                                case "0":
                                    return im = read(), void (tm = "zero");
                                case "1":
                                case "2":
                                case "3":
                                case "4":
                                case "5":
                                case "6":
                                case "7":
                                case "8":
                                case "9":
                                    return im = read(), void (tm = "decimalInteger");
                                case "I":
                                    return read(), literal("nfinity"), newToken("numeric", rm * (1 / 0));
                                case "N":
                                    return read(), literal("aN"), newToken("numeric", NaN);
                            }
                            throw invalidChar(read());
                        },
                        zero: function() {
                            switch(am){
                                case ".":
                                    return im += read(), void (tm = "decimalPoint");
                                case "e":
                                case "E":
                                    return im += read(), void (tm = "decimalExponent");
                                case "x":
                                case "X":
                                    return im += read(), void (tm = "hexadecimal");
                            }
                            return newToken("numeric", 0 * rm);
                        },
                        decimalInteger: function() {
                            switch(am){
                                case ".":
                                    return im += read(), void (tm = "decimalPoint");
                                case "e":
                                case "E":
                                    return im += read(), void (tm = "decimalExponent");
                            }
                            if (!om.isDigit(am)) return newToken("numeric", rm * Number(im));
                            im += read();
                        },
                        decimalPointLeading: function() {
                            if (om.isDigit(am)) return im += read(), void (tm = "decimalFraction");
                            throw invalidChar(read());
                        },
                        decimalPoint: function() {
                            switch(am){
                                case "e":
                                case "E":
                                    return im += read(), void (tm = "decimalExponent");
                            }
                            return om.isDigit(am) ? (im += read(), void (tm = "decimalFraction")) : newToken("numeric", rm * Number(im));
                        },
                        decimalFraction: function() {
                            switch(am){
                                case "e":
                                case "E":
                                    return im += read(), void (tm = "decimalExponent");
                            }
                            if (!om.isDigit(am)) return newToken("numeric", rm * Number(im));
                            im += read();
                        },
                        decimalExponent: function() {
                            switch(am){
                                case "+":
                                case "-":
                                    return im += read(), void (tm = "decimalExponentSign");
                            }
                            if (om.isDigit(am)) return im += read(), void (tm = "decimalExponentInteger");
                            throw invalidChar(read());
                        },
                        decimalExponentSign: function() {
                            if (om.isDigit(am)) return im += read(), void (tm = "decimalExponentInteger");
                            throw invalidChar(read());
                        },
                        decimalExponentInteger: function() {
                            if (!om.isDigit(am)) return newToken("numeric", rm * Number(im));
                            im += read();
                        },
                        hexadecimal: function() {
                            if (om.isHexDigit(am)) return im += read(), void (tm = "hexadecimalInteger");
                            throw invalidChar(read());
                        },
                        hexadecimalInteger: function() {
                            if (!om.isHexDigit(am)) return newToken("numeric", rm * Number(im));
                            im += read();
                        },
                        string: function() {
                            switch(am){
                                case "\\":
                                    return read(), void (im += escape());
                                case '"':
                                    return nm ? (read(), newToken("string", im)) : void (im += read());
                                case "'":
                                    return nm ? void (im += read()) : (read(), newToken("string", im));
                                case "\n":
                                case "\r":
                                    throw invalidChar(read());
                                case "\u2028":
                                case "\u2029":
                                    separatorChar(am);
                                    break;
                                case void 0:
                                    throw invalidChar(read());
                            }
                            im += read();
                        },
                        start: function() {
                            switch(am){
                                case "{":
                                case "[":
                                    return newToken("punctuator", read());
                            }
                            tm = "value";
                        },
                        beforePropertyName: function() {
                            switch(am){
                                case "$":
                                case "_":
                                    return im = read(), void (tm = "identifierName");
                                case "\\":
                                    return read(), void (tm = "identifierNameStartEscape");
                                case "}":
                                    return newToken("punctuator", read());
                                case '"':
                                case "'":
                                    return nm = '"' === read(), void (tm = "string");
                            }
                            if (om.isIdStartChar(am)) return im += read(), void (tm = "identifierName");
                            throw invalidChar(read());
                        },
                        afterPropertyName: function() {
                            if (":" === am) return newToken("punctuator", read());
                            throw invalidChar(read());
                        },
                        beforePropertyValue: function() {
                            tm = "value";
                        },
                        afterPropertyValue: function() {
                            switch(am){
                                case ",":
                                case "}":
                                    return newToken("punctuator", read());
                            }
                            throw invalidChar(read());
                        },
                        beforeArrayValue: function() {
                            if ("]" === am) return newToken("punctuator", read());
                            tm = "value";
                        },
                        afterArrayValue: function() {
                            switch(am){
                                case ",":
                                case "]":
                                    return newToken("punctuator", read());
                            }
                            throw invalidChar(read());
                        },
                        end: function() {
                            throw invalidChar(read());
                        }
                    };
                    function newToken(le1, vt) {
                        return {
                            type: le1,
                            value: vt,
                            line: Kd,
                            column: Jd
                        };
                    }
                    function literal(le1) {
                        for(var vt = 0, bt = le1; vt < bt.length; vt += 1){
                            var ls = bt[vt];
                            if (peek() !== ls) throw invalidChar(read());
                            read();
                        }
                    }
                    function escape() {
                        switch(peek()){
                            case "b":
                                return read(), "\b";
                            case "f":
                                return read(), "\f";
                            case "n":
                                return read(), "\n";
                            case "r":
                                return read(), "\r";
                            case "t":
                                return read(), "\t";
                            case "v":
                                return read(), "\v";
                            case "0":
                                if (read(), om.isDigit(peek())) throw invalidChar(read());
                                return "\0";
                            case "x":
                                return read(), hexEscape();
                            case "u":
                                return read(), unicodeEscape();
                            case "\n":
                            case "\u2028":
                            case "\u2029":
                                return read(), "";
                            case "\r":
                                return read(), "\n" === peek() && read(), "";
                            case "1":
                            case "2":
                            case "3":
                            case "4":
                            case "5":
                            case "6":
                            case "7":
                            case "8":
                            case "9":
                            case void 0:
                                throw invalidChar(read());
                        }
                        return read();
                    }
                    function hexEscape() {
                        var le1 = "", vt = peek();
                        if (!om.isHexDigit(vt)) throw invalidChar(read());
                        if (le1 += read(), vt = peek(), !om.isHexDigit(vt)) throw invalidChar(read());
                        return le1 += read(), String.fromCodePoint(parseInt(le1, 16));
                    }
                    function unicodeEscape() {
                        for(var le1 = "", vt = 4; vt-- > 0;){
                            var bt = peek();
                            if (!om.isHexDigit(bt)) throw invalidChar(read());
                            le1 += read();
                        }
                        return String.fromCodePoint(parseInt(le1, 16));
                    }
                    var cm = {
                        start: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            push();
                        },
                        beforePropertyName: function() {
                            switch($d.type){
                                case "identifier":
                                case "string":
                                    return sp = $d.value, void (Yd = "afterPropertyName");
                                case "punctuator":
                                    return void pop();
                                case "eof":
                                    throw invalidEOF();
                            }
                        },
                        afterPropertyName: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            Yd = "beforePropertyValue";
                        },
                        beforePropertyValue: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            push();
                        },
                        beforeArrayValue: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            "punctuator" !== $d.type || "]" !== $d.value ? push() : pop();
                        },
                        afterPropertyValue: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            switch($d.value){
                                case ",":
                                    return void (Yd = "beforePropertyName");
                                case "}":
                                    pop();
                            }
                        },
                        afterArrayValue: function() {
                            if ("eof" === $d.type) throw invalidEOF();
                            switch($d.value){
                                case ",":
                                    return void (Yd = "beforeArrayValue");
                                case "]":
                                    pop();
                            }
                        },
                        end: function() {}
                    };
                    function push() {
                        var le1;
                        switch($d.type){
                            case "punctuator":
                                switch($d.value){
                                    case "{":
                                        le1 = {};
                                        break;
                                    case "[":
                                        le1 = [];
                                }
                                break;
                            case "null":
                            case "boolean":
                            case "numeric":
                            case "string":
                                le1 = $d.value;
                        }
                        if (void 0 === em) em = le1;
                        else {
                            var vt = Qd[Qd.length - 1];
                            Array.isArray(vt) ? vt.push(le1) : Object.defineProperty(vt, sp, {
                                value: le1,
                                writable: !0,
                                enumerable: !0,
                                configurable: !0
                            });
                        }
                        if (null !== le1 && "object" === typeof le1) Qd.push(le1), Yd = Array.isArray(le1) ? "beforeArrayValue" : "beforePropertyName";
                        else {
                            var bt = Qd[Qd.length - 1];
                            Yd = null == bt ? "end" : Array.isArray(bt) ? "afterArrayValue" : "afterPropertyValue";
                        }
                    }
                    function pop() {
                        Qd.pop();
                        var le1 = Qd[Qd.length - 1];
                        Yd = null == le1 ? "end" : Array.isArray(le1) ? "afterArrayValue" : "afterPropertyValue";
                    }
                    function invalidChar(le1) {
                        return syntaxError(void 0 === le1 ? "JSON5: invalid end of input at " + Kd + ":" + Jd : "JSON5: invalid character '" + formatChar(le1) + "' at " + Kd + ":" + Jd);
                    }
                    function invalidEOF() {
                        return syntaxError("JSON5: invalid end of input at " + Kd + ":" + Jd);
                    }
                    function invalidIdentifier() {
                        return syntaxError("JSON5: invalid identifier character at " + Kd + ":" + (Jd -= 5));
                    }
                    function separatorChar(le1) {
                        console.warn("JSON5: '" + formatChar(le1) + "' in strings is not valid ECMAScript; consider escaping");
                    }
                    function formatChar(le1) {
                        var vt = {
                            "'": "\\'",
                            '"': '\\"',
                            "\\": "\\\\",
                            "\b": "\\b",
                            "\f": "\\f",
                            "\n": "\\n",
                            "\r": "\\r",
                            "\t": "\\t",
                            "\v": "\\v",
                            "\0": "\\0",
                            "\u2028": "\\u2028",
                            "\u2029": "\\u2029"
                        };
                        if (vt[le1]) return vt[le1];
                        if (le1 < " ") {
                            var bt = le1.charCodeAt(0).toString(16);
                            return "\\x" + ("00" + bt).substring(bt.length);
                        }
                        return le1;
                    }
                    function syntaxError(le1) {
                        var vt = new SyntaxError(le1);
                        return vt.lineNumber = Kd, vt.columnNumber = Jd, vt;
                    }
                    return {
                        parse: parse,
                        stringify: function(le1, vt, bt) {
                            var ls, ho, Dl, Fl = [], sc = "", uc = "";
                            if (null == vt || "object" !== typeof vt || Array.isArray(vt) || (bt = vt.space, Dl = vt.quote, vt = vt.replacer), "function" === typeof vt) ho = vt;
                            else if (Array.isArray(vt)) {
                                ls = [];
                                for(var mc = 0, gc = vt; mc < gc.length; mc += 1){
                                    var Ac = gc[mc], Ec = void 0;
                                    "string" === typeof Ac ? Ec = Ac : ("number" === typeof Ac || Ac instanceof String || Ac instanceof Number) && (Ec = String(Ac)), void 0 !== Ec && ls.indexOf(Ec) < 0 && ls.push(Ec);
                                }
                            }
                            return bt instanceof Number ? bt = Number(bt) : bt instanceof String && (bt = String(bt)), "number" === typeof bt ? bt > 0 && (bt = Math.min(10, Math.floor(bt)), uc = "          ".substr(0, bt)) : "string" === typeof bt && (uc = bt.substr(0, 10)), serializeProperty("", {
                                "": le1
                            });
                            function serializeProperty(le1, vt) {
                                var bt = vt[le1];
                                switch(null != bt && ("function" === typeof bt.toJSON5 ? bt = bt.toJSON5(le1) : "function" === typeof bt.toJSON && (bt = bt.toJSON(le1))), ho && (bt = ho.call(vt, le1, bt)), bt instanceof Number ? bt = Number(bt) : bt instanceof String ? bt = String(bt) : bt instanceof Boolean && (bt = bt.valueOf()), bt){
                                    case null:
                                        return "null";
                                    case !0:
                                        return "true";
                                    case !1:
                                        return "false";
                                }
                                return "string" === typeof bt ? quoteString(bt, !1) : "number" === typeof bt ? String(bt) : "object" === typeof bt ? Array.isArray(bt) ? serializeArray(bt) : serializeObject(bt) : void 0;
                            }
                            function quoteString(le1) {
                                for(var vt = {
                                    "'": .1,
                                    '"': .2
                                }, bt = {
                                    "'": "\\'",
                                    '"': '\\"',
                                    "\\": "\\\\",
                                    "\b": "\\b",
                                    "\f": "\\f",
                                    "\n": "\\n",
                                    "\r": "\\r",
                                    "\t": "\\t",
                                    "\v": "\\v",
                                    "\0": "\\0",
                                    "\u2028": "\\u2028",
                                    "\u2029": "\\u2029"
                                }, ls = "", ho = 0; ho < le1.length; ho++){
                                    var Fl = le1[ho];
                                    switch(Fl){
                                        case "'":
                                        case '"':
                                            vt[Fl]++, ls += Fl;
                                            continue;
                                        case "\0":
                                            if (om.isDigit(le1[ho + 1])) {
                                                ls += "\\x00";
                                                continue;
                                            }
                                    }
                                    if (bt[Fl]) ls += bt[Fl];
                                    else if (Fl < " ") {
                                        var sc = Fl.charCodeAt(0).toString(16);
                                        ls += "\\x" + ("00" + sc).substring(sc.length);
                                    } else ls += Fl;
                                }
                                var uc = Dl || Object.keys(vt).reduce(function(le1, bt) {
                                    return vt[le1] < vt[bt] ? le1 : bt;
                                });
                                return uc + (ls = ls.replace(new RegExp(uc, "g"), bt[uc])) + uc;
                            }
                            function serializeObject(le1) {
                                if (Fl.indexOf(le1) >= 0) throw TypeError("Converting circular structure to JSON5");
                                Fl.push(le1);
                                var vt = sc;
                                sc += uc;
                                for(var bt, ho, Dl = [], mc = 0, gc = ls || Object.keys(le1); mc < gc.length; mc += 1){
                                    var Ac = gc[mc], Ec = serializeProperty(Ac, le1);
                                    if (void 0 !== Ec) {
                                        var kc = serializeKey(Ac) + ":";
                                        "" !== uc && (kc += " "), kc += Ec, Dl.push(kc);
                                    }
                                }
                                if (0 === Dl.length) bt = "{}";
                                else if ("" === uc) bt = "{" + (ho = Dl.join(",")) + "}";
                                else {
                                    var du = ",\n" + sc;
                                    ho = Dl.join(du), bt = "{\n" + sc + ho + ",\n" + vt + "}";
                                }
                                return Fl.pop(), sc = vt, bt;
                            }
                            function serializeKey(le1) {
                                if (0 === le1.length) return quoteString(le1, !0);
                                var vt = String.fromCodePoint(le1.codePointAt(0));
                                if (!om.isIdStartChar(vt)) return quoteString(le1, !0);
                                for(var bt = vt.length; bt < le1.length; bt++)if (!om.isIdContinueChar(String.fromCodePoint(le1.codePointAt(bt)))) return quoteString(le1, !0);
                                return le1;
                            }
                            function serializeArray(le1) {
                                if (Fl.indexOf(le1) >= 0) throw TypeError("Converting circular structure to JSON5");
                                Fl.push(le1);
                                var vt = sc;
                                sc += uc;
                                for(var bt, ls = [], ho = 0; ho < le1.length; ho++){
                                    var Dl = serializeProperty(String(ho), le1);
                                    ls.push(void 0 !== Dl ? Dl : "null");
                                }
                                if (0 === ls.length) bt = "[]";
                                else if ("" === uc) bt = "[" + ls.join(",") + "]";
                                else {
                                    var mc = ",\n" + sc, gc = ls.join(mc);
                                    bt = "[\n" + sc + gc + ",\n" + vt + "]";
                                }
                                return Fl.pop(), sc = vt, bt;
                            }
                        }
                    };
                }();
            },
            9922: (le1, vt, bt)=>{
                "use strict";
                function normalizeSelector(le1) {
                    function saveUnmatched() {
                        bt && (Dl.length > 0 && /^[~+>]$/.test(Dl[Dl.length - 1]) && Dl.push(" "), Dl.push(bt));
                    }
                    var vt, bt, ls, ho, Dl = [], Fl = [
                        0
                    ], sc = 0, uc = /(?:[^\\]|(?:^|[^\\])(?:\\\\)+)$/, mc = /^\s+$/, gc = [
                        /\s+|\/\*|["'>~+[(]/g,
                        /\s+|\/\*|["'[\]()]/g,
                        /\s+|\/\*|["'[\]()]/g,
                        null,
                        /\*\//g
                    ];
                    for(le1 = le1.trim();;){
                        if (bt = "", (ls = gc[Fl[Fl.length - 1]]).lastIndex = sc, !(vt = ls.exec(le1))) {
                            bt = le1.substr(sc), saveUnmatched();
                            break;
                        }
                        if ((ho = sc) < (sc = ls.lastIndex) - vt[0].length && (bt = le1.substring(ho, sc - vt[0].length)), Fl[Fl.length - 1] < 3) {
                            if (saveUnmatched(), "[" === vt[0]) Fl.push(1);
                            else if ("(" === vt[0]) Fl.push(2);
                            else if (/^["']$/.test(vt[0])) Fl.push(3), gc[3] = new RegExp(vt[0], "g");
                            else if ("/*" === vt[0]) Fl.push(4);
                            else if (/^[\])]$/.test(vt[0]) && Fl.length > 0) Fl.pop();
                            else if (/^(?:\s+|[~+>])$/.test(vt[0]) && (Dl.length > 0 && !mc.test(Dl[Dl.length - 1]) && 0 === Fl[Fl.length - 1] && Dl.push(" "), 1 === Fl[Fl.length - 1] && 5 === Dl.length && "=" === Dl[2].charAt(Dl[2].length - 1) && (Dl[4] = " " + Dl[4]), mc.test(vt[0]))) continue;
                            Dl.push(vt[0]);
                        } else Dl[Dl.length - 1] += bt, uc.test(Dl[Dl.length - 1]) && (4 === Fl[Fl.length - 1] && (Dl.length < 2 || mc.test(Dl[Dl.length - 2]) ? Dl.pop() : Dl[Dl.length - 1] = " ", vt[0] = ""), Fl.pop()), Dl[Dl.length - 1] += vt[0];
                    }
                    return Dl.join("").trim();
                }
                bt.d(vt, {
                    P: ()=>normalizeSelector
                });
            },
            9438: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    qi: ()=>querySelectorDeep
                });
                var ls = bt(9922);
                function querySelectorDeep(le1, vt, bt) {
                    return void 0 === vt && (vt = document), void 0 === bt && (bt = null), _querySelectorDeep(le1, !1, vt, bt);
                }
                function _querySelectorDeep(le1, vt, bt, ho) {
                    void 0 === ho && (ho = null), le1 = (0, ls.P)(le1);
                    let Dl = bt.querySelector(le1);
                    if (document.head.createShadowRoot || document.head.attachShadow) {
                        if (!vt && Dl) return Dl;
                        return splitByCharacterUnlessQuoted(le1, ",").reduce((le1, ls)=>{
                            if (!vt && le1) return le1;
                            const Dl = splitByCharacterUnlessQuoted(ls.replace(/^\s+/g, "").replace(/\s*([>+~]+)\s*/g, "$1"), " ").filter((le1)=>!!le1).map((le1)=>splitByCharacterUnlessQuoted(le1, ">")), Fl = Dl.length - 1, sc = function(le1, vt, bt) {
                                void 0 === le1 && (le1 = null);
                                void 0 === bt && (bt = null);
                                let ls = [];
                                if (bt) ls = bt;
                                else {
                                    const findAllElements = function(le1) {
                                        for(let vt = 0; vt < le1.length; vt++){
                                            const bt = le1[vt];
                                            ls.push(bt), bt.shadowRoot && findAllElements(bt.shadowRoot.querySelectorAll("*"));
                                        }
                                    };
                                    vt.shadowRoot && findAllElements(vt.shadowRoot.querySelectorAll("*")), findAllElements(vt.querySelectorAll("*"));
                                }
                                return le1 ? ls.filter((vt)=>vt.matches(le1)) : ls;
                            }(Dl[Fl][Dl[Fl].length - 1], bt, ho), uc = function(le1, vt, bt) {
                                return (ls)=>{
                                    let ho = vt, Dl = ls, Fl = !1;
                                    for(; Dl && !isDocumentNode(Dl);){
                                        let vt = !0;
                                        if (1 === le1[ho].length) vt = Dl.matches(le1[ho]);
                                        else {
                                            const ls = [].concat(le1[ho]).reverse();
                                            let Fl = Dl;
                                            for (const le1 of ls){
                                                if (!Fl || !Fl.matches(le1)) {
                                                    vt = !1;
                                                    break;
                                                }
                                                Fl = findParentOrHost(Fl, bt);
                                            }
                                        }
                                        if (vt && 0 === ho) {
                                            Fl = !0;
                                            break;
                                        }
                                        vt && ho--, Dl = findParentOrHost(Dl, bt);
                                    }
                                    return Fl;
                                };
                            }(Dl, Fl, bt);
                            return vt ? le1 = le1.concat(sc.filter(uc)) : (le1 = sc.find(uc)) || null;
                        }, vt ? [] : null);
                    }
                    return vt ? bt.querySelectorAll(le1) : Dl;
                }
                function splitByCharacterUnlessQuoted(le1, vt) {
                    return le1.match(/\\?.|^$/g).reduce((le1, bt)=>('"' !== bt || le1.sQuote ? "'" !== bt || le1.quote ? le1.quote || le1.sQuote || bt !== vt ? le1.a[le1.a.length - 1] += bt : le1.a.push("") : (le1.sQuote ^= 1, le1.a[le1.a.length - 1] += bt) : (le1.quote ^= 1, le1.a[le1.a.length - 1] += bt), le1), {
                        a: [
                            ""
                        ]
                    }).a;
                }
                function isDocumentNode(le1) {
                    return le1.nodeType === Node.DOCUMENT_FRAGMENT_NODE || le1.nodeType === Node.DOCUMENT_NODE;
                }
                function findParentOrHost(le1, vt) {
                    const bt = le1.parentNode;
                    return bt && bt.host && 11 === bt.nodeType ? bt.host : bt === vt ? null : bt;
                }
            },
            1865: ()=>{},
            3961: ()=>{},
            2710: ()=>{},
            1575: ()=>{},
            1080: ()=>{},
            6795: ()=>{},
            3638: ()=>{},
            7776: ()=>{},
            7365: ()=>{},
            970: ()=>{},
            9616: ()=>{},
            1870: ()=>{},
            3041: ()=>{},
            5003: ()=>{},
            3630: ()=>{},
            1811: ()=>{},
            1230: ()=>{},
            8407: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKCXZpZXdCb3g9IjAgMCA2NCA2NCIKCXdpZHRoPSI2NCIgaGVpZ2h0PSI2NCIKCXhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKCXhtbG5zOnN2Zz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPgo8cGF0aAoJZD0iTSAyNy4zNTk0ODYsMTIuNjU1MTMgMS40MzE2MzQ5LDQzLjQ5OTE3IGMgLTMuMjk5OTA4MiwzLjkwNjAxNCAtMC41Mzg3NjA0Niw5Ljk2NzA3IDQuNjQ2ODA5Nyw5Ljk2NzA3IEggNTcuOTM0MTQ2IGMgNS4xMTgyMjUsMCA3Ljk0NjcxOCwtNS45OTM3MTEgNC42NDY4MSwtOS45NjcwNyBMIDM2LjY1MzEwNSwxMi42NTUxMyBjIC0yLjQyNDQyMiwtMi44Mjg0OTMxIC02Ljg2OTE5NywtMi44Mjg0OTMxIC05LjI5MzYxOSwwIHoiCglzdHlsZT0iZmlsbDogY3VycmVudENvbG9yO2ZpbGwtb3BhY2l0eToxO3N0cm9rZS13aWR0aDowLjY3MzQ1MSIgLz4KPC9zdmc+Cg==";
            },
            6830: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+Cjxzdmcgdmlld0JveD0iMCAwIDY0IDE5MiIgd2lkdGg9IjY0IiBoZWlnaHQ9IjE5MiIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIiB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPGNpcmNsZQoJY3g9IjMyIgoJY3k9IjMyIgoJcj0iMjkuODk3ODA2IgoJc3R5bGU9ImZpbGw6IGN1cnJlbnRDb2xvcjtmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZmZmZjtzdHJva2Utd2lkdGg6NC4yMDQzOTtzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIiAvPgo8cGF0aCBkPSJtIDM0LjI3OTg3MywyMC4yNjIxNzEgNi43MTE0NDIsNi43MTQyOTQgYyAwLjg5MTQ2NSwwLjg5MTQ2NSAyLjMzOTk4NiwwLjg5MTQ2NSAzLjIzMTQ1MSwwIDAuODkxNDY2LC0wLjg5MTQ2NSAwLjg5MTQ2NiwtMi4zMzk5ODUgMCwtMy4yMzE0NSAtOS42NjI5MDIsLTkuNjY1ODI5IC0zLjc5NDI4NSwtMy43OTQyODYgLTguMTgwMjk3LC04LjE4MDI5OCAtMS4wNzEzOTYsLTEuMDc0MzIyIC0yLjUyNTY5NiwtMS42NzcxNjUgLTQuMDM5OTcyLC0xLjY3NzE2NSAtMS41MTcxMjksMCAtMi45Njg1NzYsMC42MDI4NTggLTQuMDQyODI1LDEuNjc3MTY1IGwgLTguMTgwMjk4LDguMTgwMjk4IGMgLTAuODk0MzE3LDAuODkxNDY1IC0wLjg5NDMxNywyLjMzOTk4NiAwLDMuMjMxNDUgMC44OTE0NjYsMC44OTE0NjUgMi4zMzk5ODcsMC44OTE0NjUgMy4yMzE0NTIsMCBsIDYuNjk3MTA2LC02LjY5NDI1MyB2IDI3LjcwMzk0MyBjIDAsMCAtMC4xMDk3MDYsMi4xMjYyOTIgMi4yODU5NzEsMi4xMjYyOTIgMi4zOTU2NzYsMCAyLjI4NTk3LC0yLjEyNjI5MiAyLjI4NTk3LC0yLjEyNjI5MiB6IiBzdHlsZT0iZmlsbDojZmZmZmZmO2ZpbGwtb3BhY2l0eToxO2ZpbGwtcnVsZTpldmVub2RkO3N0cm9rZS13aWR0aDowLjczMTQyOSIgLz4KPC9zdmc+Cg==";
            },
            7534: (le1)=>{
                "use strict";
                le1.exports = "data:image/jpeg;base64,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";
            },
            6810: (le1)=>{
                "use strict";
                le1.exports = "data:image/jpeg;base64,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";
            },
            5975: (le1)=>{
                "use strict";
                le1.exports = "data:image/jpeg;base64,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";
            },
            2305: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,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";
            },
            6883: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgNDggNDgiCiAgIHZlcnNpb249IjEuMSIKICAgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIgogICB4bWxuczpzdmc9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KICA8cGF0aAogICAgIGQ9Im0gOC4wMjIyOTI0LDcuODU5Nzk3NyBhIDIyLjU5NDEwNywyMi41OTQxMDcgMCAwIDEgMzEuOTU1NTYzNiwwLjAwMjcgTCAyNC4wMDE0MDksMjMuODM4OTE2IFoiCiAgICAgc3R5bGU9ImZpbGw6I2JmMzYwYztmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZmZmZjtzdHJva2Utd2lkdGg6Mi41MDAwMztzdHJva2UtbWl0ZXJsaW1pdDo0O3N0cm9rZS1kYXNoYXJyYXk6bm9uZTtzdHJva2Utb3BhY2l0eToxIiAvPgogIDxjaXJjbGUKICAgICBjeD0iMjQiCiAgICAgY3k9IjI0IgogICAgIHI9IjkuOTc3NzU2NSIKICAgICBzdHlsZT0iZmlsbDojZmY2ZjAwO2ZpbGwtb3BhY2l0eToxO3N0cm9rZTojZmZmZmZmO3N0cm9rZS13aWR0aDoyLjQ5NDQ5O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiIC8+Cjwvc3ZnPgo=";
            },
            270: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,PD94bWwgdmVyc2lvbj0iMS4wIiBlbmNvZGluZz0iVVRGLTgiIHN0YW5kYWxvbmU9Im5vIj8+CjxzdmcKICAgd2lkdGg9IjQ4IgogICBoZWlnaHQ9IjQ4IgogICB2aWV3Qm94PSIwIDAgMTIuNyAxMi43IgogICB2ZXJzaW9uPSIxLjEiCiAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyIKICAgeG1sbnM6c3ZnPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgPGRlZnMKICAgICBpZD0iZGVmczEiIC8+CiAgPHBhdGgKICAgICBkPSJNLTMuMDA3LS4wMDVhNS45NzggNS45NzggMCAwIDEtNS45NzkgNS45NzhWLS4wMDV6IgogICAgIHN0eWxlPSJmaWxsOiMxYTIzN2U7ZmlsbC1vcGFjaXR5OjE7c3Ryb2tlOiNmZmY7c3Ryb2tlLXdpZHRoOjAuNjYxNDU4O3N0cm9rZS1taXRlcmxpbWl0OjQ7c3Ryb2tlLWRhc2hhcnJheTpub25lO3N0cm9rZS1vcGFjaXR5OjEiCiAgICAgdHJhbnNmb3JtPSJyb3RhdGUoLTEzNSkiLz4KICA8Y2lyY2xlCiAgICAgY3g9IjYuMzUiCiAgICAgY3k9IjYuNTQ1IgogICAgIHI9IjIuNjQiCiAgICAgc3R5bGU9ImZpbGw6IzFlODhlNTtmaWxsLW9wYWNpdHk6MTtzdHJva2U6I2ZmZjtzdHJva2Utd2lkdGg6MC42NjAwMjc7c3Ryb2tlLW1pdGVybGltaXQ6NDtzdHJva2UtZGFzaGFycmF5Om5vbmU7c3Ryb2tlLW9wYWNpdHk6MSIgLz4KPC9zdmc+Cg==";
            },
            1760: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,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";
            },
            5940: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,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";
            },
            1462: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,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";
            },
            5721: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,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";
            },
            9472: (le1)=>{
                "use strict";
                le1.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHZpZXdCb3g9IjAgMCAzMiAxOCI+PHBhdGggZD0iTTIuNSAxaDF2MTZoLTF6bTIgMGgzdjE2aC0zem00IDBoM3YxNmgtM3oiIGZpbGw9IiM5MDAiLz48cGF0aCBkPSJNMTIuNSAxaDF2MTZoLTF6bTIgMGgxdjE2aC0xem0xMiAwaDF2MTZoLTF6bTIgMGgxdjE2aC0xeiIgZmlsbD0iIzM5NiIvPjxwYXRoIGQ9Ik0xNi41IDFoM3YxNmgtM3ptNCAwaDF2MTZoLTF6bTIgMGgzdjE2aC0zeiIgZmlsbD0iIzA2OSIvPjwvc3ZnPg==";
            },
            2968: ()=>{
                /**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.17.0/LICENSE.txt
 */ !function() {
                    "use strict";
                    function e(le1, vt, bt, ls) {
                        return new (bt || (bt = Promise))(function(ho, Dl) {
                            function o(le1) {
                                try {
                                    l(ls.next(le1));
                                } catch (le1) {
                                    Dl(le1);
                                }
                            }
                            function a(le1) {
                                try {
                                    l(ls.throw(le1));
                                } catch (le1) {
                                    Dl(le1);
                                }
                            }
                            function l(le1) {
                                var vt;
                                le1.done ? ho(le1.value) : (vt = le1.value, vt instanceof bt ? vt : new bt(function(le1) {
                                    le1(vt);
                                })).then(o, a);
                            }
                            l((ls = ls.apply(le1, vt || [])).next());
                        });
                    }
                    function t(le1, vt) {
                        this.x = le1, this.y = vt;
                    }
                    function r(le1) {
                        return le1 && le1.__esModule && Object.prototype.hasOwnProperty.call(le1, "default") ? le1.default : le1;
                    }
                    var le1, vt;
                    "function" == typeof SuppressedError && SuppressedError, t.prototype = {
                        clone () {
                            return new t(this.x, this.y);
                        },
                        add (le1) {
                            return this.clone()._add(le1);
                        },
                        sub (le1) {
                            return this.clone()._sub(le1);
                        },
                        multByPoint (le1) {
                            return this.clone()._multByPoint(le1);
                        },
                        divByPoint (le1) {
                            return this.clone()._divByPoint(le1);
                        },
                        mult (le1) {
                            return this.clone()._mult(le1);
                        },
                        div (le1) {
                            return this.clone()._div(le1);
                        },
                        rotate (le1) {
                            return this.clone()._rotate(le1);
                        },
                        rotateAround (le1, vt) {
                            return this.clone()._rotateAround(le1, vt);
                        },
                        matMult (le1) {
                            return this.clone()._matMult(le1);
                        },
                        unit () {
                            return this.clone()._unit();
                        },
                        perp () {
                            return this.clone()._perp();
                        },
                        round () {
                            return this.clone()._round();
                        },
                        mag () {
                            return Math.sqrt(this.x * this.x + this.y * this.y);
                        },
                        equals (le1) {
                            return this.x === le1.x && this.y === le1.y;
                        },
                        dist (le1) {
                            return Math.sqrt(this.distSqr(le1));
                        },
                        distSqr (le1) {
                            const vt = le1.x - this.x, bt = le1.y - this.y;
                            return vt * vt + bt * bt;
                        },
                        angle () {
                            return Math.atan2(this.y, this.x);
                        },
                        angleTo (le1) {
                            return Math.atan2(this.y - le1.y, this.x - le1.x);
                        },
                        angleWith (le1) {
                            return this.angleWithSep(le1.x, le1.y);
                        },
                        angleWithSep (le1, vt) {
                            return Math.atan2(this.x * vt - this.y * le1, this.x * le1 + this.y * vt);
                        },
                        _matMult (le1) {
                            const vt = le1[2] * this.x + le1[3] * this.y;
                            return this.x = le1[0] * this.x + le1[1] * this.y, this.y = vt, this;
                        },
                        _add (le1) {
                            return this.x += le1.x, this.y += le1.y, this;
                        },
                        _sub (le1) {
                            return this.x -= le1.x, this.y -= le1.y, this;
                        },
                        _mult (le1) {
                            return this.x *= le1, this.y *= le1, this;
                        },
                        _div (le1) {
                            return this.x /= le1, this.y /= le1, this;
                        },
                        _multByPoint (le1) {
                            return this.x *= le1.x, this.y *= le1.y, this;
                        },
                        _divByPoint (le1) {
                            return this.x /= le1.x, this.y /= le1.y, this;
                        },
                        _unit () {
                            return this._div(this.mag()), this;
                        },
                        _perp () {
                            const le1 = this.y;
                            return this.y = this.x, this.x = -le1, this;
                        },
                        _rotate (le1) {
                            const vt = Math.cos(le1), bt = Math.sin(le1), ls = bt * this.x + vt * this.y;
                            return this.x = vt * this.x - bt * this.y, this.y = ls, this;
                        },
                        _rotateAround (le1, vt) {
                            const bt = Math.cos(le1), ls = Math.sin(le1), ho = vt.y + ls * (this.x - vt.x) + bt * (this.y - vt.y);
                            return this.x = vt.x + bt * (this.x - vt.x) - ls * (this.y - vt.y), this.y = ho, this;
                        },
                        _round () {
                            return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                        },
                        constructor: t
                    }, t.convert = function(le1) {
                        if (le1 instanceof t) return le1;
                        if (Array.isArray(le1)) return new t(+le1[0], +le1[1]);
                        if (void 0 !== le1.x && void 0 !== le1.y) return new t(+le1.x, +le1.y);
                        throw new Error("Expected [x, y] or {x, y} point format");
                    };
                    var bt = function() {
                        if (vt) return le1;
                        function e(le1, vt, bt, ls) {
                            this.cx = 3 * le1, this.bx = 3 * (bt - le1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * vt, this.by = 3 * (ls - vt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = le1, this.p1y = vt, this.p2x = bt, this.p2y = ls;
                        }
                        return vt = 1, le1 = e, e.prototype = {
                            sampleCurveX: function(le1) {
                                return ((this.ax * le1 + this.bx) * le1 + this.cx) * le1;
                            },
                            sampleCurveY: function(le1) {
                                return ((this.ay * le1 + this.by) * le1 + this.cy) * le1;
                            },
                            sampleCurveDerivativeX: function(le1) {
                                return (3 * this.ax * le1 + 2 * this.bx) * le1 + this.cx;
                            },
                            solveCurveX: function(le1, vt) {
                                if (void 0 === vt && (vt = 1e-6), le1 < 0) return 0;
                                if (le1 > 1) return 1;
                                for(var bt = le1, ls = 0; ls < 8; ls++){
                                    var ho = this.sampleCurveX(bt) - le1;
                                    if (Math.abs(ho) < vt) return bt;
                                    var Dl = this.sampleCurveDerivativeX(bt);
                                    if (Math.abs(Dl) < 1e-6) break;
                                    bt -= ho / Dl;
                                }
                                var Fl = 0, sc = 1;
                                for(bt = le1, ls = 0; ls < 20 && (ho = this.sampleCurveX(bt), !(Math.abs(ho - le1) < vt)); ls++)le1 > ho ? Fl = bt : sc = bt, bt = .5 * (sc - Fl) + Fl;
                                return bt;
                            },
                            solve: function(le1, vt) {
                                return this.sampleCurveY(this.solveCurveX(le1, vt));
                            }
                        }, le1;
                    }(), ls = r(bt);
                    let ho, Dl;
                    var Fl, sc = "undefined" != typeof Float32Array ? Float32Array : Array;
                    function h(le1, vt, bt) {
                        var ls = vt[0], ho = vt[1], Dl = vt[2], Fl = vt[3];
                        return le1[0] = bt[0] * ls + bt[4] * ho + bt[8] * Dl + bt[12] * Fl, le1[1] = bt[1] * ls + bt[5] * ho + bt[9] * Dl + bt[13] * Fl, le1[2] = bt[2] * ls + bt[6] * ho + bt[10] * Dl + bt[14] * Fl, le1[3] = bt[3] * ls + bt[7] * ho + bt[11] * Dl + bt[15] * Fl, le1;
                    }
                    Fl = new sc(4), sc != Float32Array && (Fl[0] = 0, Fl[1] = 0, Fl[2] = 0, Fl[3] = 0);
                    const uc = 8192;
                    function f(le1, vt, bt) {
                        return Math.min(bt, Math.max(vt, le1));
                    }
                    function d(le1) {
                        for(var vt = arguments.length, bt = new Array(vt > 1 ? vt - 1 : 0), ls = 1; ls < vt; ls++)bt[ls - 1] = arguments[ls];
                        for (const ho of bt)for(const vt in ho)le1[vt] = ho[vt];
                        return le1;
                    }
                    function y(le1, vt, bt) {
                        const ls = {};
                        for(const ho in le1)ls[ho] = vt.call(this, le1[ho], ho, le1);
                        return ls;
                    }
                    function m(le1) {
                        return Array.isArray(le1) ? le1.map(m) : "object" == typeof le1 && le1 ? y(le1, m) : le1;
                    }
                    new ls(.25, .1, .25, 1);
                    const mc = {};
                    function x(le1) {
                        mc[le1] || ("undefined" != typeof console && console.warn(le1), mc[le1] = !0);
                    }
                    function v(le1, vt, bt) {
                        return (bt.y - le1.y) * (vt.x - le1.x) > (vt.y - le1.y) * (bt.x - le1.x);
                    }
                    function b(le1) {
                        return "undefined" != typeof WorkerGlobalScope && void 0 !== le1 && le1 instanceof WorkerGlobalScope;
                    }
                    function w(le1) {
                        return "undefined" != typeof ImageBitmap && le1 instanceof ImageBitmap;
                    }
                    let gc, Ac;
                    function A(le1, vt, bt, ls) {
                        return le1.addEventListener(vt, bt, ls), {
                            unsubscribe: ()=>{
                                le1.removeEventListener(vt, bt, ls);
                            }
                        };
                    }
                    function I(le1) {
                        return le1 * Math.PI / 180;
                    }
                    class T {
                        constructor(le1, vt, bt){
                            const ls = this.cells = [];
                            if (le1 instanceof ArrayBuffer) {
                                this.arrayBuffer = le1;
                                const ho = new Int32Array(this.arrayBuffer);
                                le1 = ho[0], this.d = (vt = ho[1]) + 2 * (bt = ho[2]);
                                for(let le1 = 0; le1 < this.d * this.d; le1++){
                                    const vt = ho[3 + le1], bt = ho[3 + le1 + 1];
                                    ls.push(vt === bt ? null : ho.subarray(vt, bt));
                                }
                                const Dl = ho[3 + ls.length + 1];
                                this.keys = ho.subarray(ho[3 + ls.length], Dl), this.bboxes = ho.subarray(Dl), this.insert = this._insertReadonly;
                            } else {
                                this.d = vt + 2 * bt;
                                for(let le1 = 0; le1 < this.d * this.d; le1++)ls.push([]);
                                this.keys = [], this.bboxes = [];
                            }
                            this.n = vt, this.extent = le1, this.padding = bt, this.scale = vt / le1, this.uid = 0;
                            const ho = bt / vt * le1;
                            this.min = -ho, this.max = le1 + ho;
                        }
                        insert(le1, vt, bt, ls, ho) {
                            this._forEachCell(vt, bt, ls, ho, this._insertCell, this.uid++, void 0, void 0), this.keys.push(le1), this.bboxes.push(vt), this.bboxes.push(bt), this.bboxes.push(ls), this.bboxes.push(ho);
                        }
                        _insertReadonly() {
                            throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                        }
                        _insertCell(le1, vt, bt, ls, ho, Dl) {
                            this.cells[ho].push(Dl);
                        }
                        query(le1, vt, bt, ls, ho) {
                            const Dl = this.min, Fl = this.max;
                            if (le1 <= Dl && vt <= Dl && Fl <= bt && Fl <= ls && !ho) return Array.prototype.slice.call(this.keys);
                            {
                                const Dl = [];
                                return this._forEachCell(le1, vt, bt, ls, this._queryCell, Dl, {}, ho), Dl;
                            }
                        }
                        _queryCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = this.cells[ho];
                            if (null !== uc) {
                                const ho = this.keys, mc = this.bboxes;
                                for(let gc = 0; gc < uc.length; gc++){
                                    const Ac = uc[gc];
                                    if (void 0 === Fl[Ac]) {
                                        const uc = 4 * Ac;
                                        (sc ? sc(mc[uc + 0], mc[uc + 1], mc[uc + 2], mc[uc + 3]) : le1 <= mc[uc + 2] && vt <= mc[uc + 3] && bt >= mc[uc + 0] && ls >= mc[uc + 1]) ? (Fl[Ac] = !0, Dl.push(ho[Ac])) : Fl[Ac] = !1;
                                    }
                                }
                            }
                        }
                        _forEachCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = this._convertToCellCoord(le1), mc = this._convertToCellCoord(vt), gc = this._convertToCellCoord(bt), Ac = this._convertToCellCoord(ls);
                            for(let Ec = uc; Ec <= gc; Ec++)for(let uc = mc; uc <= Ac; uc++){
                                const mc = this.d * uc + Ec;
                                if ((!sc || sc(this._convertFromCellCoord(Ec), this._convertFromCellCoord(uc), this._convertFromCellCoord(Ec + 1), this._convertFromCellCoord(uc + 1))) && ho.call(this, le1, vt, bt, ls, mc, Dl, Fl, sc)) return;
                            }
                        }
                        _convertFromCellCoord(le1) {
                            return (le1 - this.padding) / this.scale;
                        }
                        _convertToCellCoord(le1) {
                            return Math.max(0, Math.min(this.d - 1, Math.floor(le1 * this.scale) + this.padding));
                        }
                        toArrayBuffer() {
                            if (this.arrayBuffer) return this.arrayBuffer;
                            const le1 = this.cells, vt = 3 + this.cells.length + 1 + 1;
                            let bt = 0;
                            for(let Dl = 0; Dl < this.cells.length; Dl++)bt += this.cells[Dl].length;
                            const ls = new Int32Array(vt + bt + this.keys.length + this.bboxes.length);
                            ls[0] = this.extent, ls[1] = this.n, ls[2] = this.padding;
                            let ho = vt;
                            for(let Dl = 0; Dl < le1.length; Dl++){
                                const vt = le1[Dl];
                                ls[3 + Dl] = ho, ls.set(vt, ho), ho += vt.length;
                            }
                            return ls[3 + le1.length] = ho, ls.set(this.keys, ho), ho += this.keys.length, ls[3 + le1.length + 1] = ho, ls.set(this.bboxes, ho), ho += this.bboxes.length, ls.buffer;
                        }
                        static serialize(le1, vt) {
                            const bt = le1.toArrayBuffer();
                            return vt && vt.push(bt), {
                                buffer: bt
                            };
                        }
                        static deserialize(le1) {
                            return new T(le1.buffer);
                        }
                    }
                    var Ec = {
                        $version: 8,
                        $root: {
                            version: {
                                required: !0,
                                type: "enum",
                                values: [
                                    8
                                ]
                            },
                            name: {
                                type: "string"
                            },
                            metadata: {
                                type: "*"
                            },
                            center: {
                                type: "array",
                                value: "number",
                                length: 2
                            },
                            centerAltitude: {
                                type: "number"
                            },
                            zoom: {
                                type: "number"
                            },
                            bearing: {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees"
                            },
                            pitch: {
                                type: "number",
                                default: 0,
                                units: "degrees"
                            },
                            roll: {
                                type: "number",
                                default: 0,
                                units: "degrees"
                            },
                            state: {
                                type: "state",
                                default: {}
                            },
                            light: {
                                type: "light"
                            },
                            sky: {
                                type: "sky"
                            },
                            projection: {
                                type: "projection"
                            },
                            terrain: {
                                type: "terrain"
                            },
                            sources: {
                                required: !0,
                                type: "sources"
                            },
                            sprite: {
                                type: "sprite"
                            },
                            glyphs: {
                                type: "string"
                            },
                            "font-faces": {
                                type: "fontFaces"
                            },
                            transition: {
                                type: "transition"
                            },
                            layers: {
                                required: !0,
                                type: "array",
                                value: "layer"
                            }
                        },
                        sources: {
                            "*": {
                                type: "source"
                            }
                        },
                        source: [
                            "source_vector",
                            "source_raster",
                            "source_raster_dem",
                            "source_geojson",
                            "source_video",
                            "source_image"
                        ],
                        source_vector: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    vector: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            attribution: {
                                type: "string"
                            },
                            promoteId: {
                                type: "promoteId"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            encoding: {
                                type: "enum",
                                values: {
                                    mvt: {},
                                    mlt: {}
                                },
                                default: "mvt"
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    raster: {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            scheme: {
                                type: "enum",
                                values: {
                                    xyz: {},
                                    tms: {}
                                },
                                default: "xyz"
                            },
                            attribution: {
                                type: "string"
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_raster_dem: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    "raster-dem": {}
                                }
                            },
                            url: {
                                type: "string"
                            },
                            tiles: {
                                type: "array",
                                value: "string"
                            },
                            bounds: {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    -180,
                                    -85.051129,
                                    180,
                                    85.051129
                                ]
                            },
                            minzoom: {
                                type: "number",
                                default: 0
                            },
                            maxzoom: {
                                type: "number",
                                default: 22
                            },
                            tileSize: {
                                type: "number",
                                default: 512,
                                units: "pixels"
                            },
                            attribution: {
                                type: "string"
                            },
                            encoding: {
                                type: "enum",
                                values: {
                                    terrarium: {},
                                    mapbox: {},
                                    custom: {}
                                },
                                default: "mapbox"
                            },
                            redFactor: {
                                type: "number",
                                default: 1
                            },
                            blueFactor: {
                                type: "number",
                                default: 1
                            },
                            greenFactor: {
                                type: "number",
                                default: 1
                            },
                            baseShift: {
                                type: "number",
                                default: 0
                            },
                            volatile: {
                                type: "boolean",
                                default: !1
                            },
                            "*": {
                                type: "*"
                            }
                        },
                        source_geojson: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    geojson: {}
                                }
                            },
                            data: {
                                required: !0,
                                type: "*"
                            },
                            maxzoom: {
                                type: "number",
                                default: 18
                            },
                            attribution: {
                                type: "string"
                            },
                            buffer: {
                                type: "number",
                                default: 128,
                                maximum: 512,
                                minimum: 0
                            },
                            filter: {
                                type: "filter"
                            },
                            tolerance: {
                                type: "number",
                                default: .375
                            },
                            cluster: {
                                type: "boolean",
                                default: !1
                            },
                            clusterRadius: {
                                type: "number",
                                default: 50,
                                minimum: 0
                            },
                            clusterMaxZoom: {
                                type: "number"
                            },
                            clusterMinPoints: {
                                type: "number"
                            },
                            clusterProperties: {
                                type: "*"
                            },
                            lineMetrics: {
                                type: "boolean",
                                default: !1
                            },
                            generateId: {
                                type: "boolean",
                                default: !1
                            },
                            promoteId: {
                                type: "promoteId"
                            }
                        },
                        source_video: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    video: {}
                                }
                            },
                            urls: {
                                required: !0,
                                type: "array",
                                value: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        source_image: {
                            type: {
                                required: !0,
                                type: "enum",
                                values: {
                                    image: {}
                                }
                            },
                            url: {
                                required: !0,
                                type: "string"
                            },
                            coordinates: {
                                required: !0,
                                type: "array",
                                length: 4,
                                value: {
                                    type: "array",
                                    length: 2,
                                    value: "number"
                                }
                            }
                        },
                        layer: {
                            id: {
                                type: "string",
                                required: !0
                            },
                            type: {
                                type: "enum",
                                values: {
                                    fill: {},
                                    line: {},
                                    symbol: {},
                                    circle: {},
                                    heatmap: {},
                                    "fill-extrusion": {},
                                    raster: {},
                                    hillshade: {},
                                    "color-relief": {},
                                    background: {}
                                },
                                required: !0
                            },
                            metadata: {
                                type: "*"
                            },
                            source: {
                                type: "string"
                            },
                            "source-layer": {
                                type: "string"
                            },
                            minzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            maxzoom: {
                                type: "number",
                                minimum: 0,
                                maximum: 24
                            },
                            filter: {
                                type: "filter"
                            },
                            layout: {
                                type: "layout"
                            },
                            paint: {
                                type: "paint"
                            }
                        },
                        layout: [
                            "layout_fill",
                            "layout_line",
                            "layout_circle",
                            "layout_heatmap",
                            "layout_fill-extrusion",
                            "layout_symbol",
                            "layout_raster",
                            "layout_hillshade",
                            "layout_color-relief",
                            "layout_background"
                        ],
                        layout_background: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_fill: {
                            "fill-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_circle: {
                            "circle-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_heatmap: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        "layout_fill-extrusion": {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_line: {
                            "line-cap": {
                                type: "enum",
                                values: {
                                    butt: {},
                                    round: {},
                                    square: {}
                                },
                                default: "butt",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-join": {
                                type: "enum",
                                values: {
                                    bevel: {},
                                    round: {},
                                    miter: {}
                                },
                                default: "miter",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-miter-limit": {
                                type: "number",
                                default: 2,
                                requires: [
                                    {
                                        "line-join": "miter"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-round-limit": {
                                type: "number",
                                default: 1.05,
                                requires: [
                                    {
                                        "line-join": "round"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_symbol: {
                            "symbol-placement": {
                                type: "enum",
                                values: {
                                    point: {},
                                    line: {},
                                    "line-center": {}
                                },
                                default: "point",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-spacing": {
                                type: "number",
                                default: 250,
                                minimum: 1,
                                units: "pixels",
                                requires: [
                                    {
                                        "symbol-placement": "line"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-avoid-edges": {
                                type: "boolean",
                                default: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "symbol-sort-key": {
                                type: "number",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "symbol-z-order": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    "viewport-y": {},
                                    source: {}
                                },
                                default: "auto",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "!": "icon-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-size": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                units: "factor of the original icon size",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-text-fit": {
                                type: "enum",
                                values: {
                                    none: {},
                                    width: {},
                                    height: {},
                                    both: {}
                                },
                                default: "none",
                                requires: [
                                    "icon-image",
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-text-fit-padding": {
                                type: "array",
                                value: "number",
                                length: 4,
                                default: [
                                    0,
                                    0,
                                    0,
                                    0
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image",
                                    "text-field",
                                    {
                                        "icon-text-fit": [
                                            "both",
                                            "width",
                                            "height"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-image": {
                                type: "resolvedImage",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-padding": {
                                type: "padding",
                                default: [
                                    2
                                ],
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-keep-upright": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "icon-image",
                                    {
                                        "icon-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-offset": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotation-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {},
                                    "viewport-glyph": {},
                                    auto: {}
                                },
                                default: "auto",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-field": {
                                type: "formatted",
                                default: "",
                                tokens: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-font": {
                                type: "array",
                                value: "string",
                                default: [
                                    "Open Sans Regular",
                                    "Arial Unicode MS Regular"
                                ],
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-size": {
                                type: "number",
                                default: 16,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-width": {
                                type: "number",
                                default: 10,
                                minimum: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-line-height": {
                                type: "number",
                                default: 1.2,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-letter-spacing": {
                                type: "number",
                                default: 0,
                                units: "ems",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-justify": {
                                type: "enum",
                                values: {
                                    auto: {},
                                    left: {},
                                    center: {},
                                    right: {}
                                },
                                default: "center",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-radial-offset": {
                                type: "number",
                                units: "ems",
                                default: 0,
                                requires: [
                                    "text-field"
                                ],
                                "property-type": "data-driven",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                }
                            },
                            "text-variable-anchor": {
                                type: "array",
                                value: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-variable-anchor-offset": {
                                type: "variableAnchorOffsetCollection",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-anchor": {
                                type: "enum",
                                values: {
                                    center: {},
                                    left: {},
                                    right: {},
                                    top: {},
                                    bottom: {},
                                    "top-left": {},
                                    "top-right": {},
                                    "bottom-left": {},
                                    "bottom-right": {}
                                },
                                default: "center",
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-variable-anchor"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-max-angle": {
                                type: "number",
                                default: 45,
                                units: "degrees",
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-writing-mode": {
                                type: "array",
                                value: "enum",
                                values: {
                                    horizontal: {},
                                    vertical: {}
                                },
                                requires: [
                                    "text-field",
                                    {
                                        "symbol-placement": [
                                            "point"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                units: "degrees",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-padding": {
                                type: "number",
                                default: 2,
                                minimum: 0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-keep-upright": {
                                type: "boolean",
                                default: !0,
                                requires: [
                                    "text-field",
                                    {
                                        "text-rotation-alignment": "map"
                                    },
                                    {
                                        "symbol-placement": [
                                            "line",
                                            "line-center"
                                        ]
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-transform": {
                                type: "enum",
                                values: {
                                    none: {},
                                    uppercase: {},
                                    lowercase: {}
                                },
                                default: "none",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-offset": {
                                type: "array",
                                value: "number",
                                units: "ems",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-radial-offset"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-allow-overlap": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    {
                                        "!": "text-overlap"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-overlap": {
                                type: "enum",
                                values: {
                                    never: {},
                                    always: {},
                                    cooperative: {}
                                },
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-ignore-placement": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-optional": {
                                type: "boolean",
                                default: !1,
                                requires: [
                                    "text-field",
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_raster: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        layout_hillshade: {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        "layout_color-relief": {
                            visibility: {
                                type: "enum",
                                values: {
                                    visible: {},
                                    none: {}
                                },
                                default: "visible",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "global-state"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        filter: {
                            type: "boolean",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            },
                            "property-type": "data-driven"
                        },
                        filter_operator: {
                            type: "enum",
                            values: {
                                "==": {},
                                "!=": {},
                                ">": {},
                                ">=": {},
                                "<": {},
                                "<=": {},
                                in: {},
                                "!in": {},
                                all: {},
                                any: {},
                                none: {},
                                has: {},
                                "!has": {}
                            }
                        },
                        geometry_type: {
                            type: "enum",
                            values: {
                                Point: {},
                                LineString: {},
                                Polygon: {}
                            }
                        },
                        function: {
                            expression: {
                                type: "expression"
                            },
                            stops: {
                                type: "array",
                                value: "function_stop"
                            },
                            base: {
                                type: "number",
                                default: 1,
                                minimum: 0
                            },
                            property: {
                                type: "string",
                                default: "$zoom"
                            },
                            type: {
                                type: "enum",
                                values: {
                                    identity: {},
                                    exponential: {},
                                    interval: {},
                                    categorical: {}
                                },
                                default: "exponential"
                            },
                            colorSpace: {
                                type: "enum",
                                values: {
                                    rgb: {},
                                    lab: {},
                                    hcl: {}
                                },
                                default: "rgb"
                            },
                            default: {
                                type: "*",
                                required: !1
                            }
                        },
                        function_stop: {
                            type: "array",
                            minimum: 0,
                            maximum: 24,
                            value: [
                                "number",
                                "color"
                            ],
                            length: 2
                        },
                        expression: {
                            type: "array",
                            value: "expression_name",
                            minimum: 1
                        },
                        light: {
                            anchor: {
                                type: "enum",
                                default: "viewport",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                "property-type": "data-constant",
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            position: {
                                type: "array",
                                default: [
                                    1.15,
                                    210,
                                    30
                                ],
                                length: 3,
                                value: "number",
                                "property-type": "data-constant",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            },
                            color: {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            intensity: {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        sky: {
                            "sky-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#88C6FC",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-color": {
                                type: "color",
                                "property-type": "data-constant",
                                default: "#ffffff",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "fog-ground-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "horizon-fog-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "sky-horizon-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            },
                            "atmosphere-blend": {
                                type: "number",
                                "property-type": "data-constant",
                                default: .8,
                                minimum: 0,
                                maximum: 1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                transition: !0
                            }
                        },
                        terrain: {
                            source: {
                                type: "string",
                                required: !0
                            },
                            exaggeration: {
                                type: "number",
                                minimum: 0,
                                default: 1
                            }
                        },
                        projection: {
                            type: {
                                type: "projectionDefinition",
                                default: "mercator",
                                "property-type": "data-constant",
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                }
                            }
                        },
                        paint: [
                            "paint_fill",
                            "paint_line",
                            "paint_circle",
                            "paint_heatmap",
                            "paint_fill-extrusion",
                            "paint_symbol",
                            "paint_raster",
                            "paint_hillshade",
                            "paint_color-relief",
                            "paint_background"
                        ],
                        paint_fill: {
                            "fill-antialias": {
                                type: "boolean",
                                default: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-outline-color": {
                                type: "color",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-pattern"
                                    },
                                    {
                                        "fill-antialias": !0
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            }
                        },
                        "paint_fill-extrusion": {
                            "fill-extrusion-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "fill-extrusion-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "fill-extrusion-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "fill-extrusion-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "fill-extrusion-height": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-base": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "meters",
                                transition: !0,
                                requires: [
                                    "fill-extrusion-height"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "fill-extrusion-vertical-gradient": {
                                type: "boolean",
                                default: !0,
                                transition: !1,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_line: {
                            "line-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "line-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "line-width": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-gap-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-offset": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "line-dasharray": {
                                type: "array",
                                value: "number",
                                minimum: 0,
                                transition: !0,
                                units: "line widths",
                                requires: [
                                    {
                                        "!": "line-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "line-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "cross-faded-data-driven"
                            },
                            "line-gradient": {
                                type: "color",
                                transition: !1,
                                requires: [
                                    {
                                        "!": "line-dasharray"
                                    },
                                    {
                                        "!": "line-pattern"
                                    },
                                    {
                                        source: "geojson",
                                        has: {
                                            lineMetrics: !0
                                        }
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "line-progress"
                                    ]
                                },
                                "property-type": "color-ramp"
                            }
                        },
                        paint_circle: {
                            "circle-radius": {
                                type: "number",
                                default: 5,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-blur": {
                                type: "number",
                                default: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "circle-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-scale": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-pitch-alignment": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "circle-stroke-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "circle-stroke-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            }
                        },
                        paint_heatmap: {
                            "heatmap-radius": {
                                type: "number",
                                default: 30,
                                minimum: 1,
                                transition: !0,
                                units: "pixels",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-weight": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "heatmap-intensity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "heatmap-color": {
                                type: "color",
                                default: [
                                    "interpolate",
                                    [
                                        "linear"
                                    ],
                                    [
                                        "heatmap-density"
                                    ],
                                    0,
                                    "rgba(0, 0, 255, 0)",
                                    .1,
                                    "royalblue",
                                    .3,
                                    "cyan",
                                    .5,
                                    "lime",
                                    .7,
                                    "yellow",
                                    1,
                                    "red"
                                ],
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "heatmap-density"
                                    ]
                                },
                                "property-type": "color-ramp"
                            },
                            "heatmap-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_symbol: {
                            "icon-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "icon-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "icon-image"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "icon-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "icon-image",
                                    "icon-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                overridable: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-color": {
                                type: "color",
                                default: "rgba(0, 0, 0, 0)",
                                transition: !0,
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-width": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-halo-blur": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom",
                                        "feature",
                                        "feature-state"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            "text-translate": {
                                type: "array",
                                value: "number",
                                length: 2,
                                default: [
                                    0,
                                    0
                                ],
                                transition: !0,
                                units: "pixels",
                                requires: [
                                    "text-field"
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "text-translate-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "map",
                                requires: [
                                    "text-field",
                                    "text-translate"
                                ],
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_raster: {
                            "raster-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-hue-rotate": {
                                type: "number",
                                default: 0,
                                period: 360,
                                transition: !0,
                                units: "degrees",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-min": {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-brightness-max": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-saturation": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-contrast": {
                                type: "number",
                                default: 0,
                                minimum: -1,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-resampling": {
                                type: "enum",
                                values: {
                                    linear: {},
                                    nearest: {}
                                },
                                default: "linear",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "raster-fade-duration": {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                transition: !1,
                                units: "milliseconds",
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        paint_hillshade: {
                            "hillshade-illumination-direction": {
                                type: "numberArray",
                                default: 335,
                                minimum: 0,
                                maximum: 359,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-illumination-altitude": {
                                type: "numberArray",
                                default: 45,
                                minimum: 0,
                                maximum: 90,
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-illumination-anchor": {
                                type: "enum",
                                values: {
                                    map: {},
                                    viewport: {}
                                },
                                default: "viewport",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-exaggeration": {
                                type: "number",
                                default: .5,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-shadow-color": {
                                type: "colorArray",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-highlight-color": {
                                type: "colorArray",
                                default: "#FFFFFF",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-accent-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "hillshade-method": {
                                type: "enum",
                                values: {
                                    standard: {},
                                    basic: {},
                                    combined: {},
                                    igor: {},
                                    multidirectional: {}
                                },
                                default: "standard",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        "paint_color-relief": {
                            "color-relief-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "color-relief-color": {
                                type: "color",
                                transition: !1,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "elevation"
                                    ]
                                },
                                "property-type": "color-ramp"
                            }
                        },
                        paint_background: {
                            "background-color": {
                                type: "color",
                                default: "#000000",
                                transition: !0,
                                requires: [
                                    {
                                        "!": "background-pattern"
                                    }
                                ],
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            },
                            "background-pattern": {
                                type: "resolvedImage",
                                transition: !0,
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "cross-faded"
                            },
                            "background-opacity": {
                                type: "number",
                                default: 1,
                                minimum: 0,
                                maximum: 1,
                                transition: !0,
                                expression: {
                                    interpolated: !0,
                                    parameters: [
                                        "zoom"
                                    ]
                                },
                                "property-type": "data-constant"
                            }
                        },
                        transition: {
                            duration: {
                                type: "number",
                                default: 300,
                                minimum: 0,
                                units: "milliseconds"
                            },
                            delay: {
                                type: "number",
                                default: 0,
                                minimum: 0,
                                units: "milliseconds"
                            }
                        },
                        "property-type": {
                            "data-driven": {
                                type: "property-type"
                            },
                            "cross-faded": {
                                type: "property-type"
                            },
                            "cross-faded-data-driven": {
                                type: "property-type"
                            },
                            "color-ramp": {
                                type: "property-type"
                            },
                            "data-constant": {
                                type: "property-type"
                            },
                            constant: {
                                type: "property-type"
                            }
                        },
                        promoteId: {
                            "*": {
                                type: "string"
                            }
                        },
                        interpolation: {
                            type: "array",
                            value: "interpolation_name",
                            minimum: 1
                        },
                        interpolation_name: {
                            type: "enum",
                            values: {
                                linear: {
                                    syntax: {
                                        overloads: [
                                            {
                                                parameters: [],
                                                "output-type": "interpolation"
                                            }
                                        ],
                                        parameters: []
                                    }
                                },
                                exponential: {
                                    syntax: {
                                        overloads: [
                                            {
                                                parameters: [
                                                    "base"
                                                ],
                                                "output-type": "interpolation"
                                            }
                                        ],
                                        parameters: [
                                            {
                                                name: "base",
                                                type: "number literal"
                                            }
                                        ]
                                    }
                                },
                                "cubic-bezier": {
                                    syntax: {
                                        overloads: [
                                            {
                                                parameters: [
                                                    "x1",
                                                    "y1",
                                                    "x2",
                                                    "y2"
                                                ],
                                                "output-type": "interpolation"
                                            }
                                        ],
                                        parameters: [
                                            {
                                                name: "x1",
                                                type: "number literal"
                                            },
                                            {
                                                name: "y1",
                                                type: "number literal"
                                            },
                                            {
                                                name: "x2",
                                                type: "number literal"
                                            },
                                            {
                                                name: "y2",
                                                type: "number literal"
                                            }
                                        ]
                                    }
                                }
                            }
                        }
                    };
                    const kc = [
                        "type",
                        "source",
                        "source-layer",
                        "minzoom",
                        "maxzoom",
                        "filter",
                        "layout"
                    ];
                    class M {
                        constructor(le1, vt, bt, ls){
                            this.message = (le1 ? `${le1}: ` : "") + bt, ls && (this.identifier = ls), null != vt && vt.__line__ && (this.line = vt.__line__);
                        }
                    }
                    function D(le1) {
                        for(var vt = arguments.length, bt = new Array(vt > 1 ? vt - 1 : 0), ls = 1; ls < vt; ls++)bt[ls - 1] = arguments[ls];
                        for (const ho of bt)for(const vt in ho)le1[vt] = ho[vt];
                        return le1;
                    }
                    class P extends Error {
                        constructor(le1, vt){
                            super(vt), this.message = vt, this.key = le1;
                        }
                    }
                    class z {
                        constructor(le1, vt){
                            void 0 === vt && (vt = []), this.parent = le1, this.bindings = {};
                            for (const [bt, ls] of vt)this.bindings[bt] = ls;
                        }
                        concat(le1) {
                            return new z(this, le1);
                        }
                        get(le1) {
                            if (this.bindings[le1]) return this.bindings[le1];
                            if (this.parent) return this.parent.get(le1);
                            throw new Error(`${le1} not found in scope.`);
                        }
                        has(le1) {
                            return !!this.bindings[le1] || !!this.parent && this.parent.has(le1);
                        }
                    }
                    const du = {
                        kind: "null"
                    }, _u = {
                        kind: "number"
                    }, Md = {
                        kind: "string"
                    }, Ld = {
                        kind: "boolean"
                    }, Nd = {
                        kind: "color"
                    }, Rd = {
                        kind: "projectionDefinition"
                    }, Od = {
                        kind: "object"
                    }, jd = {
                        kind: "value"
                    }, Ud = {
                        kind: "collator"
                    }, Gd = {
                        kind: "formatted"
                    }, qd = {
                        kind: "padding"
                    }, Hd = {
                        kind: "colorArray"
                    }, Wd = {
                        kind: "numberArray"
                    }, Zd = {
                        kind: "resolvedImage"
                    }, Yd = {
                        kind: "variableAnchorOffsetCollection"
                    };
                    function Z(le1, vt) {
                        return {
                            kind: "array",
                            itemType: le1,
                            N: vt
                        };
                    }
                    function H(le1) {
                        if ("array" === le1.kind) {
                            const vt = H(le1.itemType);
                            return "number" == typeof le1.N ? `array<${vt}, ${le1.N}>` : "value" === le1.itemType.kind ? "array" : `array<${vt}>`;
                        }
                        return le1.kind;
                    }
                    const Qd = [
                        du,
                        _u,
                        Md,
                        Ld,
                        Nd,
                        Rd,
                        Gd,
                        Od,
                        Z(jd),
                        qd,
                        Wd,
                        Hd,
                        Zd,
                        Yd
                    ];
                    function J(le1, vt) {
                        if ("error" === vt.kind) return null;
                        if ("array" === le1.kind) {
                            if ("array" === vt.kind && (0 === vt.N && "value" === vt.itemType.kind || !J(le1.itemType, vt.itemType)) && ("number" != typeof le1.N || le1.N === vt.N)) return null;
                        } else {
                            if (le1.kind === vt.kind) return null;
                            if ("value" === le1.kind) {
                                for (const le1 of Qd)if (!J(le1, vt)) return null;
                            }
                        }
                        return `Expected ${H(le1)} but found ${H(vt)} instead.`;
                    }
                    function K(le1, vt) {
                        return vt.some((vt)=>vt.kind === le1.kind);
                    }
                    function Q(le1, vt) {
                        return vt.some((vt)=>"null" === vt ? null === le1 : "array" === vt ? Array.isArray(le1) : "object" === vt ? le1 && !Array.isArray(le1) && "object" == typeof le1 : vt === typeof le1);
                    }
                    function ee(le1, vt) {
                        return "array" === le1.kind && "array" === vt.kind ? le1.itemType.kind === vt.itemType.kind && "number" == typeof le1.N : le1.kind === vt.kind;
                    }
                    const Xd = .96422, Kd = .82521, Jd = 4 / 29, $d = 6 / 29, sp = 3 * $d * $d, em = $d * $d * $d, tm = Math.PI / 180, im = 180 / Math.PI;
                    function ue(le1) {
                        return (le1 %= 360) < 0 && (le1 += 360), le1;
                    }
                    function ce(le1) {
                        let vt, bt, [ls, ho, Dl, Fl] = le1;
                        const sc = pe((.2225045 * (ls = he(ls)) + .7168786 * (ho = he(ho)) + .0606169 * (Dl = he(Dl))) / 1);
                        ls === ho && ho === Dl ? vt = bt = sc : (vt = pe((.4360747 * ls + .3850649 * ho + .1430804 * Dl) / Xd), bt = pe((.0139322 * ls + .0971045 * ho + .7141733 * Dl) / Kd));
                        const uc = 116 * sc - 16;
                        return [
                            uc < 0 ? 0 : uc,
                            500 * (vt - sc),
                            200 * (sc - bt),
                            Fl
                        ];
                    }
                    function he(le1) {
                        return le1 <= .04045 ? le1 / 12.92 : Math.pow((le1 + .055) / 1.055, 2.4);
                    }
                    function pe(le1) {
                        return le1 > em ? Math.pow(le1, 1 / 3) : le1 / sp + Jd;
                    }
                    function fe(le1) {
                        let [vt, bt, ls, ho] = le1, Dl = (vt + 16) / 116, Fl = isNaN(bt) ? Dl : Dl + bt / 500, sc = isNaN(ls) ? Dl : Dl - ls / 200;
                        return Dl = 1 * ye(Dl), Fl = Xd * ye(Fl), sc = Kd * ye(sc), [
                            de(3.1338561 * Fl - 1.6168667 * Dl - .4906146 * sc),
                            de(-0.9787684 * Fl + 1.9161415 * Dl + .033454 * sc),
                            de(.0719453 * Fl - .2289914 * Dl + 1.4052427 * sc),
                            ho
                        ];
                    }
                    function de(le1) {
                        return (le1 = le1 <= .00304 ? 12.92 * le1 : 1.055 * Math.pow(le1, 1 / 2.4) - .055) < 0 ? 0 : le1 > 1 ? 1 : le1;
                    }
                    function ye(le1) {
                        return le1 > $d ? le1 * le1 * le1 : sp * (le1 - Jd);
                    }
                    const nm = Object.hasOwn || function(le1, vt) {
                        return Object.prototype.hasOwnProperty.call(le1, vt);
                    };
                    function ge(le1, vt) {
                        return nm(le1, vt) ? le1[vt] : void 0;
                    }
                    function xe(le1) {
                        return parseInt(le1.padEnd(2, le1), 16) / 255;
                    }
                    function ve(le1, vt) {
                        return be(vt ? le1 / 100 : le1, 0, 1);
                    }
                    function be(le1, vt, bt) {
                        return Math.min(Math.max(vt, le1), bt);
                    }
                    function we(le1) {
                        return !le1.some(Number.isNaN);
                    }
                    const rm = {
                        aliceblue: [
                            240,
                            248,
                            255
                        ],
                        antiquewhite: [
                            250,
                            235,
                            215
                        ],
                        aqua: [
                            0,
                            255,
                            255
                        ],
                        aquamarine: [
                            127,
                            255,
                            212
                        ],
                        azure: [
                            240,
                            255,
                            255
                        ],
                        beige: [
                            245,
                            245,
                            220
                        ],
                        bisque: [
                            255,
                            228,
                            196
                        ],
                        black: [
                            0,
                            0,
                            0
                        ],
                        blanchedalmond: [
                            255,
                            235,
                            205
                        ],
                        blue: [
                            0,
                            0,
                            255
                        ],
                        blueviolet: [
                            138,
                            43,
                            226
                        ],
                        brown: [
                            165,
                            42,
                            42
                        ],
                        burlywood: [
                            222,
                            184,
                            135
                        ],
                        cadetblue: [
                            95,
                            158,
                            160
                        ],
                        chartreuse: [
                            127,
                            255,
                            0
                        ],
                        chocolate: [
                            210,
                            105,
                            30
                        ],
                        coral: [
                            255,
                            127,
                            80
                        ],
                        cornflowerblue: [
                            100,
                            149,
                            237
                        ],
                        cornsilk: [
                            255,
                            248,
                            220
                        ],
                        crimson: [
                            220,
                            20,
                            60
                        ],
                        cyan: [
                            0,
                            255,
                            255
                        ],
                        darkblue: [
                            0,
                            0,
                            139
                        ],
                        darkcyan: [
                            0,
                            139,
                            139
                        ],
                        darkgoldenrod: [
                            184,
                            134,
                            11
                        ],
                        darkgray: [
                            169,
                            169,
                            169
                        ],
                        darkgreen: [
                            0,
                            100,
                            0
                        ],
                        darkgrey: [
                            169,
                            169,
                            169
                        ],
                        darkkhaki: [
                            189,
                            183,
                            107
                        ],
                        darkmagenta: [
                            139,
                            0,
                            139
                        ],
                        darkolivegreen: [
                            85,
                            107,
                            47
                        ],
                        darkorange: [
                            255,
                            140,
                            0
                        ],
                        darkorchid: [
                            153,
                            50,
                            204
                        ],
                        darkred: [
                            139,
                            0,
                            0
                        ],
                        darksalmon: [
                            233,
                            150,
                            122
                        ],
                        darkseagreen: [
                            143,
                            188,
                            143
                        ],
                        darkslateblue: [
                            72,
                            61,
                            139
                        ],
                        darkslategray: [
                            47,
                            79,
                            79
                        ],
                        darkslategrey: [
                            47,
                            79,
                            79
                        ],
                        darkturquoise: [
                            0,
                            206,
                            209
                        ],
                        darkviolet: [
                            148,
                            0,
                            211
                        ],
                        deeppink: [
                            255,
                            20,
                            147
                        ],
                        deepskyblue: [
                            0,
                            191,
                            255
                        ],
                        dimgray: [
                            105,
                            105,
                            105
                        ],
                        dimgrey: [
                            105,
                            105,
                            105
                        ],
                        dodgerblue: [
                            30,
                            144,
                            255
                        ],
                        firebrick: [
                            178,
                            34,
                            34
                        ],
                        floralwhite: [
                            255,
                            250,
                            240
                        ],
                        forestgreen: [
                            34,
                            139,
                            34
                        ],
                        fuchsia: [
                            255,
                            0,
                            255
                        ],
                        gainsboro: [
                            220,
                            220,
                            220
                        ],
                        ghostwhite: [
                            248,
                            248,
                            255
                        ],
                        gold: [
                            255,
                            215,
                            0
                        ],
                        goldenrod: [
                            218,
                            165,
                            32
                        ],
                        gray: [
                            128,
                            128,
                            128
                        ],
                        green: [
                            0,
                            128,
                            0
                        ],
                        greenyellow: [
                            173,
                            255,
                            47
                        ],
                        grey: [
                            128,
                            128,
                            128
                        ],
                        honeydew: [
                            240,
                            255,
                            240
                        ],
                        hotpink: [
                            255,
                            105,
                            180
                        ],
                        indianred: [
                            205,
                            92,
                            92
                        ],
                        indigo: [
                            75,
                            0,
                            130
                        ],
                        ivory: [
                            255,
                            255,
                            240
                        ],
                        khaki: [
                            240,
                            230,
                            140
                        ],
                        lavender: [
                            230,
                            230,
                            250
                        ],
                        lavenderblush: [
                            255,
                            240,
                            245
                        ],
                        lawngreen: [
                            124,
                            252,
                            0
                        ],
                        lemonchiffon: [
                            255,
                            250,
                            205
                        ],
                        lightblue: [
                            173,
                            216,
                            230
                        ],
                        lightcoral: [
                            240,
                            128,
                            128
                        ],
                        lightcyan: [
                            224,
                            255,
                            255
                        ],
                        lightgoldenrodyellow: [
                            250,
                            250,
                            210
                        ],
                        lightgray: [
                            211,
                            211,
                            211
                        ],
                        lightgreen: [
                            144,
                            238,
                            144
                        ],
                        lightgrey: [
                            211,
                            211,
                            211
                        ],
                        lightpink: [
                            255,
                            182,
                            193
                        ],
                        lightsalmon: [
                            255,
                            160,
                            122
                        ],
                        lightseagreen: [
                            32,
                            178,
                            170
                        ],
                        lightskyblue: [
                            135,
                            206,
                            250
                        ],
                        lightslategray: [
                            119,
                            136,
                            153
                        ],
                        lightslategrey: [
                            119,
                            136,
                            153
                        ],
                        lightsteelblue: [
                            176,
                            196,
                            222
                        ],
                        lightyellow: [
                            255,
                            255,
                            224
                        ],
                        lime: [
                            0,
                            255,
                            0
                        ],
                        limegreen: [
                            50,
                            205,
                            50
                        ],
                        linen: [
                            250,
                            240,
                            230
                        ],
                        magenta: [
                            255,
                            0,
                            255
                        ],
                        maroon: [
                            128,
                            0,
                            0
                        ],
                        mediumaquamarine: [
                            102,
                            205,
                            170
                        ],
                        mediumblue: [
                            0,
                            0,
                            205
                        ],
                        mediumorchid: [
                            186,
                            85,
                            211
                        ],
                        mediumpurple: [
                            147,
                            112,
                            219
                        ],
                        mediumseagreen: [
                            60,
                            179,
                            113
                        ],
                        mediumslateblue: [
                            123,
                            104,
                            238
                        ],
                        mediumspringgreen: [
                            0,
                            250,
                            154
                        ],
                        mediumturquoise: [
                            72,
                            209,
                            204
                        ],
                        mediumvioletred: [
                            199,
                            21,
                            133
                        ],
                        midnightblue: [
                            25,
                            25,
                            112
                        ],
                        mintcream: [
                            245,
                            255,
                            250
                        ],
                        mistyrose: [
                            255,
                            228,
                            225
                        ],
                        moccasin: [
                            255,
                            228,
                            181
                        ],
                        navajowhite: [
                            255,
                            222,
                            173
                        ],
                        navy: [
                            0,
                            0,
                            128
                        ],
                        oldlace: [
                            253,
                            245,
                            230
                        ],
                        olive: [
                            128,
                            128,
                            0
                        ],
                        olivedrab: [
                            107,
                            142,
                            35
                        ],
                        orange: [
                            255,
                            165,
                            0
                        ],
                        orangered: [
                            255,
                            69,
                            0
                        ],
                        orchid: [
                            218,
                            112,
                            214
                        ],
                        palegoldenrod: [
                            238,
                            232,
                            170
                        ],
                        palegreen: [
                            152,
                            251,
                            152
                        ],
                        paleturquoise: [
                            175,
                            238,
                            238
                        ],
                        palevioletred: [
                            219,
                            112,
                            147
                        ],
                        papayawhip: [
                            255,
                            239,
                            213
                        ],
                        peachpuff: [
                            255,
                            218,
                            185
                        ],
                        peru: [
                            205,
                            133,
                            63
                        ],
                        pink: [
                            255,
                            192,
                            203
                        ],
                        plum: [
                            221,
                            160,
                            221
                        ],
                        powderblue: [
                            176,
                            224,
                            230
                        ],
                        purple: [
                            128,
                            0,
                            128
                        ],
                        rebeccapurple: [
                            102,
                            51,
                            153
                        ],
                        red: [
                            255,
                            0,
                            0
                        ],
                        rosybrown: [
                            188,
                            143,
                            143
                        ],
                        royalblue: [
                            65,
                            105,
                            225
                        ],
                        saddlebrown: [
                            139,
                            69,
                            19
                        ],
                        salmon: [
                            250,
                            128,
                            114
                        ],
                        sandybrown: [
                            244,
                            164,
                            96
                        ],
                        seagreen: [
                            46,
                            139,
                            87
                        ],
                        seashell: [
                            255,
                            245,
                            238
                        ],
                        sienna: [
                            160,
                            82,
                            45
                        ],
                        silver: [
                            192,
                            192,
                            192
                        ],
                        skyblue: [
                            135,
                            206,
                            235
                        ],
                        slateblue: [
                            106,
                            90,
                            205
                        ],
                        slategray: [
                            112,
                            128,
                            144
                        ],
                        slategrey: [
                            112,
                            128,
                            144
                        ],
                        snow: [
                            255,
                            250,
                            250
                        ],
                        springgreen: [
                            0,
                            255,
                            127
                        ],
                        steelblue: [
                            70,
                            130,
                            180
                        ],
                        tan: [
                            210,
                            180,
                            140
                        ],
                        teal: [
                            0,
                            128,
                            128
                        ],
                        thistle: [
                            216,
                            191,
                            216
                        ],
                        tomato: [
                            255,
                            99,
                            71
                        ],
                        turquoise: [
                            64,
                            224,
                            208
                        ],
                        violet: [
                            238,
                            130,
                            238
                        ],
                        wheat: [
                            245,
                            222,
                            179
                        ],
                        white: [
                            255,
                            255,
                            255
                        ],
                        whitesmoke: [
                            245,
                            245,
                            245
                        ],
                        yellow: [
                            255,
                            255,
                            0
                        ],
                        yellowgreen: [
                            154,
                            205,
                            50
                        ]
                    };
                    function Se(le1, vt, bt) {
                        return le1 + bt * (vt - le1);
                    }
                    function Ae(le1, vt, bt) {
                        return le1.map((le1, ls)=>Se(le1, vt[ls], bt));
                    }
                    class Ie {
                        constructor(le1, vt, bt, ls, ho){
                            void 0 === ls && (ls = 1), void 0 === ho && (ho = !0), this.r = le1, this.g = vt, this.b = bt, this.a = ls, ho || (this.r *= ls, this.g *= ls, this.b *= ls, ls || this.overwriteGetter("rgb", [
                                le1,
                                vt,
                                bt,
                                ls
                            ]));
                        }
                        static parse(le1) {
                            if (le1 instanceof Ie) return le1;
                            if ("string" != typeof le1) return;
                            const vt = function(le1) {
                                if ("transparent" === (le1 = le1.toLowerCase().trim())) return [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                                const vt = ge(rm, le1);
                                if (vt) {
                                    const [le1, bt, ls] = vt;
                                    return [
                                        le1 / 255,
                                        bt / 255,
                                        ls / 255,
                                        1
                                    ];
                                }
                                if (le1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(le1)) {
                                    const vt = le1.length < 6 ? 1 : 2;
                                    let bt = 1;
                                    return [
                                        xe(le1.slice(bt, bt += vt)),
                                        xe(le1.slice(bt, bt += vt)),
                                        xe(le1.slice(bt, bt += vt)),
                                        xe(le1.slice(bt, bt + vt) || "ff")
                                    ];
                                }
                                if (le1.startsWith("rgb")) {
                                    const vt = le1.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                    if (vt) {
                                        const [le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec] = vt, kc = [
                                            ho || " ",
                                            sc || " ",
                                            gc
                                        ].join("");
                                        if ("  " === kc || "  /" === kc || ",," === kc || ",,," === kc) {
                                            const le1 = [
                                                ls,
                                                Fl,
                                                mc
                                            ].join(""), vt = "%%%" === le1 ? 100 : "" === le1 ? 255 : 0;
                                            if (vt) {
                                                const le1 = [
                                                    be(+bt / vt, 0, 1),
                                                    be(+Dl / vt, 0, 1),
                                                    be(+uc / vt, 0, 1),
                                                    Ac ? ve(+Ac, Ec) : 1
                                                ];
                                                if (we(le1)) return le1;
                                            }
                                        }
                                        return;
                                    }
                                }
                                const bt = le1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                if (bt) {
                                    const [le1, vt, ls, ho, Dl, Fl, sc, uc, mc] = bt, gc = [
                                        ls || " ",
                                        Dl || " ",
                                        sc
                                    ].join("");
                                    if ("  " === gc || "  /" === gc || ",," === gc || ",,," === gc) {
                                        const le1 = [
                                            +vt,
                                            be(+ho, 0, 100),
                                            be(+Fl, 0, 100),
                                            uc ? ve(+uc, mc) : 1
                                        ];
                                        if (we(le1)) return function(le1) {
                                            let [vt, bt, ls, ho] = le1;
                                            function i(le1) {
                                                const ho = (le1 + vt / 30) % 12, Dl = bt * Math.min(ls, 1 - ls);
                                                return ls - Dl * Math.max(-1, Math.min(ho - 3, 9 - ho, 1));
                                            }
                                            return vt = ue(vt), bt /= 100, ls /= 100, [
                                                i(0),
                                                i(8),
                                                i(4),
                                                ho
                                            ];
                                        }(le1);
                                    }
                                }
                            }(le1);
                            return vt ? new Ie(...vt, !1) : void 0;
                        }
                        get rgb() {
                            const { r: le1, g: vt, b: bt, a: ls } = this, ho = ls || 1 / 0;
                            return this.overwriteGetter("rgb", [
                                le1 / ho,
                                vt / ho,
                                bt / ho,
                                ls
                            ]);
                        }
                        get hcl() {
                            return this.overwriteGetter("hcl", function(le1) {
                                const [vt, bt, ls, ho] = ce(le1), Dl = Math.sqrt(bt * bt + ls * ls);
                                return [
                                    Math.round(1e4 * Dl) ? ue(Math.atan2(ls, bt) * im) : NaN,
                                    Dl,
                                    vt,
                                    ho
                                ];
                            }(this.rgb));
                        }
                        get lab() {
                            return this.overwriteGetter("lab", ce(this.rgb));
                        }
                        overwriteGetter(le1, vt) {
                            return Object.defineProperty(this, le1, {
                                value: vt
                            }), vt;
                        }
                        toString() {
                            const [le1, vt, bt, ls] = this.rgb;
                            return `rgba(${[
                                le1,
                                vt,
                                bt
                            ].map((le1)=>Math.round(255 * le1)).join(",")},${ls})`;
                        }
                        static interpolate(le1, vt, bt, ls) {
                            switch(void 0 === ls && (ls = "rgb"), ls){
                                case "rgb":
                                    {
                                        const [ls, ho, Dl, Fl] = Ae(le1.rgb, vt.rgb, bt);
                                        return new Ie(ls, ho, Dl, Fl, !1);
                                    }
                                case "hcl":
                                    {
                                        const [ls, ho, Dl, Fl] = le1.hcl, [sc, uc, mc, gc] = vt.hcl;
                                        let Ac, Ec;
                                        if (isNaN(ls) || isNaN(sc)) isNaN(ls) ? isNaN(sc) ? Ac = NaN : (Ac = sc, 1 !== Dl && 0 !== Dl || (Ec = uc)) : (Ac = ls, 1 !== mc && 0 !== mc || (Ec = ho));
                                        else {
                                            let le1 = sc - ls;
                                            sc > ls && le1 > 180 ? le1 -= 360 : sc < ls && ls - sc > 180 && (le1 += 360), Ac = ls + bt * le1;
                                        }
                                        const [kc, du, _u, Md] = function(le1) {
                                            let [vt, bt, ls, ho] = le1;
                                            return vt = isNaN(vt) ? 0 : vt * tm, fe([
                                                ls,
                                                Math.cos(vt) * bt,
                                                Math.sin(vt) * bt,
                                                ho
                                            ]);
                                        }([
                                            Ac,
                                            null != Ec ? Ec : Se(ho, uc, bt),
                                            Se(Dl, mc, bt),
                                            Se(Fl, gc, bt)
                                        ]);
                                        return new Ie(kc, du, _u, Md, !1);
                                    }
                                case "lab":
                                    {
                                        const [ls, ho, Dl, Fl] = fe(Ae(le1.lab, vt.lab, bt));
                                        return new Ie(ls, ho, Dl, Fl, !1);
                                    }
                            }
                        }
                    }
                    Ie.black = new Ie(0, 0, 0, 1), Ie.white = new Ie(1, 1, 1, 1), Ie.transparent = new Ie(0, 0, 0, 0), Ie.red = new Ie(1, 0, 0, 1);
                    class Te {
                        constructor(le1, vt, bt){
                            this.sensitivity = le1 ? vt ? "variant" : "case" : vt ? "accent" : "base", this.locale = bt, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                sensitivity: this.sensitivity,
                                usage: "search"
                            });
                        }
                        compare(le1, vt) {
                            return this.collator.compare(le1, vt);
                        }
                        resolvedLocale() {
                            return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                        }
                    }
                    const am = [
                        "bottom",
                        "center",
                        "top"
                    ];
                    class Ee {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            this.text = le1, this.image = vt, this.scale = bt, this.fontStack = ls, this.textColor = ho, this.verticalAlign = Dl;
                        }
                    }
                    class Me {
                        constructor(le1){
                            this.sections = le1;
                        }
                        static fromString(le1) {
                            return new Me([
                                new Ee(le1, null, null, null, null, null)
                            ]);
                        }
                        isEmpty() {
                            return 0 === this.sections.length || !this.sections.some((le1)=>0 !== le1.text.length || le1.image && 0 !== le1.image.name.length);
                        }
                        static factory(le1) {
                            return le1 instanceof Me ? le1 : Me.fromString(le1);
                        }
                        toString() {
                            return 0 === this.sections.length ? "" : this.sections.map((le1)=>le1.text).join("");
                        }
                    }
                    class De {
                        constructor(le1){
                            this.values = le1.slice();
                        }
                        static parse(le1) {
                            if (le1 instanceof De) return le1;
                            if ("number" == typeof le1) return new De([
                                le1,
                                le1,
                                le1,
                                le1
                            ]);
                            if (Array.isArray(le1) && !(le1.length < 1 || le1.length > 4)) {
                                for (const vt of le1)if ("number" != typeof vt) return;
                                switch(le1.length){
                                    case 1:
                                        le1 = [
                                            le1[0],
                                            le1[0],
                                            le1[0],
                                            le1[0]
                                        ];
                                        break;
                                    case 2:
                                        le1 = [
                                            le1[0],
                                            le1[1],
                                            le1[0],
                                            le1[1]
                                        ];
                                        break;
                                    case 3:
                                        le1 = [
                                            le1[0],
                                            le1[1],
                                            le1[2],
                                            le1[1]
                                        ];
                                }
                                return new De(le1);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(le1, vt, bt) {
                            return new De(Ae(le1.values, vt.values, bt));
                        }
                    }
                    class Pe {
                        constructor(le1){
                            this.values = le1.slice();
                        }
                        static parse(le1) {
                            if (le1 instanceof Pe) return le1;
                            if ("number" == typeof le1) return new Pe([
                                le1
                            ]);
                            if (Array.isArray(le1)) {
                                for (const vt of le1)if ("number" != typeof vt) return;
                                return new Pe(le1);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(le1, vt, bt) {
                            return new Pe(Ae(le1.values, vt.values, bt));
                        }
                    }
                    class ze {
                        constructor(le1){
                            this.values = le1.slice();
                        }
                        static parse(le1) {
                            if (le1 instanceof ze) return le1;
                            if ("string" == typeof le1) {
                                const vt = Ie.parse(le1);
                                if (!vt) return;
                                return new ze([
                                    vt
                                ]);
                            }
                            if (!Array.isArray(le1)) return;
                            const vt = [];
                            for (const bt of le1){
                                if ("string" != typeof bt) return;
                                const le1 = Ie.parse(bt);
                                if (!le1) return;
                                vt.push(le1);
                            }
                            return new ze(vt);
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(le1, vt, bt, ls) {
                            void 0 === ls && (ls = "rgb");
                            const ho = [];
                            if (le1.values.length != vt.values.length) throw new Error(`colorArray: Arrays have mismatched length (${le1.values.length} vs. ${vt.values.length}), cannot interpolate.`);
                            for(let Dl = 0; Dl < le1.values.length; Dl++)ho.push(Ie.interpolate(le1.values[Dl], vt.values[Dl], bt, ls));
                            return new ze(ho);
                        }
                    }
                    class Fe extends Error {
                        constructor(le1){
                            super(le1), this.name = "RuntimeError";
                        }
                        toJSON() {
                            return this.message;
                        }
                    }
                    const sm = new Set([
                        "center",
                        "left",
                        "right",
                        "top",
                        "bottom",
                        "top-left",
                        "top-right",
                        "bottom-left",
                        "bottom-right"
                    ]);
                    class Ce {
                        constructor(le1){
                            this.values = le1.slice();
                        }
                        static parse(le1) {
                            if (le1 instanceof Ce) return le1;
                            if (Array.isArray(le1) && !(le1.length < 1) && le1.length % 2 == 0) {
                                for(let vt = 0; vt < le1.length; vt += 2){
                                    const bt = le1[vt], ls = le1[vt + 1];
                                    if ("string" != typeof bt || !sm.has(bt)) return;
                                    if (!Array.isArray(ls) || 2 !== ls.length || "number" != typeof ls[0] || "number" != typeof ls[1]) return;
                                }
                                return new Ce(le1);
                            }
                        }
                        toString() {
                            return JSON.stringify(this.values);
                        }
                        static interpolate(le1, vt, bt) {
                            const ls = le1.values, ho = vt.values;
                            if (ls.length !== ho.length) throw new Fe(`Cannot interpolate values of different length. from: ${le1.toString()}, to: ${vt.toString()}`);
                            const Dl = [];
                            for(let Fl = 0; Fl < ls.length; Fl += 2){
                                if (ls[Fl] !== ho[Fl]) throw new Fe(`Cannot interpolate values containing mismatched anchors. from[${Fl}]: ${ls[Fl]}, to[${Fl}]: ${ho[Fl]}`);
                                Dl.push(ls[Fl]);
                                const [le1, vt] = ls[Fl + 1], [sc, uc] = ho[Fl + 1];
                                Dl.push([
                                    Se(le1, sc, bt),
                                    Se(vt, uc, bt)
                                ]);
                            }
                            return new Ce(Dl);
                        }
                    }
                    class Ve {
                        constructor(le1){
                            this.name = le1.name, this.available = le1.available;
                        }
                        toString() {
                            return this.name;
                        }
                        static fromString(le1) {
                            return le1 ? new Ve({
                                name: le1,
                                available: !1
                            }) : null;
                        }
                    }
                    class Le {
                        constructor(le1, vt, bt){
                            this.from = le1, this.to = vt, this.transition = bt;
                        }
                        static interpolate(le1, vt, bt) {
                            return new Le(le1, vt, bt);
                        }
                        static parse(le1) {
                            return le1 instanceof Le ? le1 : Array.isArray(le1) && 3 === le1.length && "string" == typeof le1[0] && "string" == typeof le1[1] && "number" == typeof le1[2] ? new Le(le1[0], le1[1], le1[2]) : "object" == typeof le1 && "string" == typeof le1.from && "string" == typeof le1.to && "number" == typeof le1.transition ? new Le(le1.from, le1.to, le1.transition) : "string" == typeof le1 ? new Le(le1, le1, 1) : void 0;
                        }
                    }
                    function Oe(le1, vt, bt, ls) {
                        return "number" == typeof le1 && le1 >= 0 && le1 <= 255 && "number" == typeof vt && vt >= 0 && vt <= 255 && "number" == typeof bt && bt >= 0 && bt <= 255 ? void 0 === ls || "number" == typeof ls && ls >= 0 && ls <= 1 ? null : `Invalid rgba value [${[
                            le1,
                            vt,
                            bt,
                            ls
                        ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof ls ? [
                            le1,
                            vt,
                            bt,
                            ls
                        ] : [
                            le1,
                            vt,
                            bt
                        ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                    }
                    function Re(le1) {
                        if (null === le1 || "string" == typeof le1 || "boolean" == typeof le1 || "number" == typeof le1 || le1 instanceof Le || le1 instanceof Ie || le1 instanceof Te || le1 instanceof Me || le1 instanceof De || le1 instanceof Pe || le1 instanceof ze || le1 instanceof Ce || le1 instanceof Ve) return !0;
                        if (Array.isArray(le1)) {
                            for (const vt of le1)if (!Re(vt)) return !1;
                            return !0;
                        }
                        if ("object" == typeof le1) {
                            for(const vt in le1)if (!Re(le1[vt])) return !1;
                            return !0;
                        }
                        return !1;
                    }
                    function Ne(le1) {
                        if (null === le1) return du;
                        if ("string" == typeof le1) return Md;
                        if ("boolean" == typeof le1) return Ld;
                        if ("number" == typeof le1) return _u;
                        if (le1 instanceof Ie) return Nd;
                        if (le1 instanceof Le) return Rd;
                        if (le1 instanceof Te) return Ud;
                        if (le1 instanceof Me) return Gd;
                        if (le1 instanceof De) return qd;
                        if (le1 instanceof Pe) return Wd;
                        if (le1 instanceof ze) return Hd;
                        if (le1 instanceof Ce) return Yd;
                        if (le1 instanceof Ve) return Zd;
                        if (Array.isArray(le1)) {
                            const vt = le1.length;
                            let bt;
                            for (const ls of le1){
                                const le1 = Ne(ls);
                                if (bt) {
                                    if (bt === le1) continue;
                                    bt = jd;
                                    break;
                                }
                                bt = le1;
                            }
                            return Z(bt || jd, vt);
                        }
                        return Od;
                    }
                    function $e(le1) {
                        const vt = typeof le1;
                        return null === le1 ? "" : "string" === vt || "number" === vt || "boolean" === vt ? String(le1) : le1 instanceof Ie || le1 instanceof Le || le1 instanceof Me || le1 instanceof De || le1 instanceof Pe || le1 instanceof ze || le1 instanceof Ce || le1 instanceof Ve ? le1.toString() : JSON.stringify(le1);
                    }
                    class Ue {
                        constructor(le1, vt){
                            this.type = le1, this.value = vt;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error(`'literal' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                            if (!Re(le1[1])) return vt.error("invalid value");
                            const bt = le1[1];
                            let ls = Ne(bt);
                            const ho = vt.expectedType;
                            return "array" !== ls.kind || 0 !== ls.N || !ho || "array" !== ho.kind || "number" == typeof ho.N && 0 !== ho.N || (ls = ho), new Ue(ls, bt);
                        }
                        evaluate() {
                            return this.value;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    const om = {
                        string: Md,
                        number: _u,
                        boolean: Ld,
                        object: Od
                    };
                    class Ge {
                        constructor(le1, vt){
                            this.type = le1, this.args = vt;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 2) return vt.error("Expected at least one argument.");
                            let bt, ls = 1;
                            const ho = le1[0];
                            if ("array" === ho) {
                                let ho, Dl;
                                if (le1.length > 2) {
                                    const bt = le1[1];
                                    if ("string" != typeof bt || !(bt in om) || "object" === bt) return vt.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                    ho = om[bt], ls++;
                                } else ho = jd;
                                if (le1.length > 3) {
                                    if (null !== le1[2] && ("number" != typeof le1[2] || le1[2] < 0 || le1[2] !== Math.floor(le1[2]))) return vt.error('The length argument to "array" must be a positive integer literal', 2);
                                    Dl = le1[2], ls++;
                                }
                                bt = Z(ho, Dl);
                            } else {
                                if (!om[ho]) throw new Error(`Types doesn't contain name = ${ho}`);
                                bt = om[ho];
                            }
                            const Dl = [];
                            for(; ls < le1.length; ls++){
                                const bt = vt.parse(le1[ls], ls, jd);
                                if (!bt) return null;
                                Dl.push(bt);
                            }
                            return new Ge(bt, Dl);
                        }
                        evaluate(le1) {
                            for(let vt = 0; vt < this.args.length; vt++){
                                const bt = this.args[vt].evaluate(le1);
                                if (!J(this.type, Ne(bt))) return bt;
                                if (vt === this.args.length - 1) throw new Fe(`Expected value to be of type ${H(this.type)}, but found ${H(Ne(bt))} instead.`);
                            }
                            throw new Error;
                        }
                        eachChild(le1) {
                            this.args.forEach(le1);
                        }
                        outputDefined() {
                            return this.args.every((le1)=>le1.outputDefined());
                        }
                    }
                    const lm = {
                        "to-boolean": Ld,
                        "to-color": Nd,
                        "to-number": _u,
                        "to-string": Md
                    };
                    class Xe {
                        constructor(le1, vt){
                            this.type = le1, this.args = vt;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 2) return vt.error("Expected at least one argument.");
                            const bt = le1[0];
                            if (!lm[bt]) throw new Error(`Can't parse ${bt} as it is not part of the known types`);
                            if (("to-boolean" === bt || "to-string" === bt) && 2 !== le1.length) return vt.error("Expected one argument.");
                            const ls = lm[bt], ho = [];
                            for(let Dl = 1; Dl < le1.length; Dl++){
                                const bt = vt.parse(le1[Dl], Dl, jd);
                                if (!bt) return null;
                                ho.push(bt);
                            }
                            return new Xe(ls, ho);
                        }
                        evaluate(le1) {
                            switch(this.type.kind){
                                case "boolean":
                                    return Boolean(this.args[0].evaluate(le1));
                                case "color":
                                    {
                                        let vt, bt;
                                        for (const ls of this.args){
                                            if (vt = ls.evaluate(le1), bt = null, vt instanceof Ie) return vt;
                                            if ("string" == typeof vt) {
                                                const bt = le1.parseColor(vt);
                                                if (bt) return bt;
                                            } else if (Array.isArray(vt) && (bt = vt.length < 3 || vt.length > 4 ? `Invalid rgba value ${JSON.stringify(vt)}: expected an array containing either three or four numeric values.` : Oe(vt[0], vt[1], vt[2], vt[3]), !bt)) return new Ie(vt[0] / 255, vt[1] / 255, vt[2] / 255, vt[3]);
                                        }
                                        throw new Fe(bt || `Could not parse color from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                    }
                                case "padding":
                                    {
                                        let vt;
                                        for (const bt of this.args){
                                            vt = bt.evaluate(le1);
                                            const ls = De.parse(vt);
                                            if (ls) return ls;
                                        }
                                        throw new Fe(`Could not parse padding from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                    }
                                case "numberArray":
                                    {
                                        let vt;
                                        for (const bt of this.args){
                                            vt = bt.evaluate(le1);
                                            const ls = Pe.parse(vt);
                                            if (ls) return ls;
                                        }
                                        throw new Fe(`Could not parse numberArray from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                    }
                                case "colorArray":
                                    {
                                        let vt;
                                        for (const bt of this.args){
                                            vt = bt.evaluate(le1);
                                            const ls = ze.parse(vt);
                                            if (ls) return ls;
                                        }
                                        throw new Fe(`Could not parse colorArray from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                    }
                                case "variableAnchorOffsetCollection":
                                    {
                                        let vt;
                                        for (const bt of this.args){
                                            vt = bt.evaluate(le1);
                                            const ls = Ce.parse(vt);
                                            if (ls) return ls;
                                        }
                                        throw new Fe(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                    }
                                case "number":
                                    {
                                        let vt = null;
                                        for (const bt of this.args){
                                            if (vt = bt.evaluate(le1), null === vt) return 0;
                                            const ls = Number(vt);
                                            if (!isNaN(ls)) return ls;
                                        }
                                        throw new Fe(`Could not convert ${JSON.stringify(vt)} to number.`);
                                    }
                                case "formatted":
                                    return Me.fromString($e(this.args[0].evaluate(le1)));
                                case "resolvedImage":
                                    return Ve.fromString($e(this.args[0].evaluate(le1)));
                                case "projectionDefinition":
                                    return this.args[0].evaluate(le1);
                                default:
                                    return $e(this.args[0].evaluate(le1));
                            }
                        }
                        eachChild(le1) {
                            this.args.forEach(le1);
                        }
                        outputDefined() {
                            return this.args.every((le1)=>le1.outputDefined());
                        }
                    }
                    const cm = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ];
                    class Ze {
                        constructor(){
                            this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
                        }
                        id() {
                            return this.feature && "id" in this.feature ? this.feature.id : null;
                        }
                        geometryType() {
                            return this.feature ? "number" == typeof this.feature.type ? cm[this.feature.type] : this.feature.type : null;
                        }
                        geometry() {
                            return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                        }
                        canonicalID() {
                            return this.canonical;
                        }
                        properties() {
                            return this.feature && this.feature.properties || {};
                        }
                        parseColor(le1) {
                            let vt = this._parseColorCache.get(le1);
                            return vt || (vt = Ie.parse(le1), this._parseColorCache.set(le1, vt)), vt;
                        }
                    }
                    class He {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            void 0 === bt && (bt = []), void 0 === ho && (ho = new z), void 0 === Dl && (Dl = []), this.registry = le1, this.path = bt, this.key = bt.map((le1)=>`[${le1}]`).join(""), this.scope = ho, this.errors = Dl, this.expectedType = ls, this._isConstant = vt;
                        }
                        parse(le1, vt, bt, ls, ho) {
                            return void 0 === ho && (ho = {}), vt ? this.concat(vt, bt, ls)._parse(le1, ho) : this._parse(le1, ho);
                        }
                        _parse(le1, vt) {
                            function r(le1, vt, bt) {
                                return "assert" === bt ? new Ge(vt, [
                                    le1
                                ]) : "coerce" === bt ? new Xe(vt, [
                                    le1
                                ]) : le1;
                            }
                            if (null !== le1 && "string" != typeof le1 && "boolean" != typeof le1 && "number" != typeof le1 || (le1 = [
                                "literal",
                                le1
                            ]), Array.isArray(le1)) {
                                if (0 === le1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                const bt = le1[0];
                                if ("string" != typeof bt) return this.error(`Expression name must be a string, but found ${typeof bt} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                const ls = this.registry[bt];
                                if (ls) {
                                    let bt = ls.parse(le1, this);
                                    if (!bt) return null;
                                    if (this.expectedType) {
                                        const le1 = this.expectedType, ls = bt.type;
                                        if ("string" !== le1.kind && "number" !== le1.kind && "boolean" !== le1.kind && "object" !== le1.kind && "array" !== le1.kind || "value" !== ls.kind) {
                                            if ("projectionDefinition" === le1.kind && [
                                                "string",
                                                "array"
                                            ].includes(ls.kind) || [
                                                "color",
                                                "formatted",
                                                "resolvedImage"
                                            ].includes(le1.kind) && [
                                                "value",
                                                "string"
                                            ].includes(ls.kind) || [
                                                "padding",
                                                "numberArray"
                                            ].includes(le1.kind) && [
                                                "value",
                                                "number",
                                                "array"
                                            ].includes(ls.kind) || "colorArray" === le1.kind && [
                                                "value",
                                                "string",
                                                "array"
                                            ].includes(ls.kind) || "variableAnchorOffsetCollection" === le1.kind && [
                                                "value",
                                                "array"
                                            ].includes(ls.kind)) bt = r(bt, le1, vt.typeAnnotation || "coerce");
                                            else if (this.checkSubtype(le1, ls)) return null;
                                        } else bt = r(bt, le1, vt.typeAnnotation || "assert");
                                    }
                                    if (!(bt instanceof Ue) && "resolvedImage" !== bt.type.kind && this._isConstant(bt)) {
                                        const vt = new Ze;
                                        try {
                                            bt = new Ue(bt.type, bt.evaluate(vt));
                                        } catch (le1) {
                                            return this.error(le1.message), null;
                                        }
                                    }
                                    return bt;
                                }
                                return this.error(`Unknown expression "${bt}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            }
                            return this.error(void 0 === le1 ? "'undefined' value invalid. Use null instead." : "object" == typeof le1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof le1} instead.`);
                        }
                        concat(le1, vt, bt) {
                            const ls = "number" == typeof le1 ? this.path.concat(le1) : this.path, ho = bt ? this.scope.concat(bt) : this.scope;
                            return new He(this.registry, this._isConstant, ls, vt || null, ho, this.errors);
                        }
                        error(le1) {
                            for(var vt = arguments.length, bt = new Array(vt > 1 ? vt - 1 : 0), ls = 1; ls < vt; ls++)bt[ls - 1] = arguments[ls];
                            const ho = `${this.key}${bt.map((le1)=>`[${le1}]`).join("")}`;
                            this.errors.push(new P(ho, le1));
                        }
                        checkSubtype(le1, vt) {
                            const bt = J(le1, vt);
                            return bt && this.error(bt), bt;
                        }
                    }
                    class We {
                        constructor(le1, vt){
                            this.type = vt.type, this.bindings = [].concat(le1), this.result = vt;
                        }
                        evaluate(le1) {
                            return this.result.evaluate(le1);
                        }
                        eachChild(le1) {
                            for (const vt of this.bindings)le1(vt[1]);
                            le1(this.result);
                        }
                        static parse(le1, vt) {
                            if (le1.length < 4) return vt.error(`Expected at least 3 arguments, but found ${le1.length - 1} instead.`);
                            const bt = [];
                            for(let ho = 1; ho < le1.length - 1; ho += 2){
                                const ls = le1[ho];
                                if ("string" != typeof ls) return vt.error(`Expected string, but found ${typeof ls} instead.`, ho);
                                if (/[^a-zA-Z0-9_]/.test(ls)) return vt.error("Variable names must contain only alphanumeric characters or '_'.", ho);
                                const Dl = vt.parse(le1[ho + 1], ho + 1);
                                if (!Dl) return null;
                                bt.push([
                                    ls,
                                    Dl
                                ]);
                            }
                            const ls = vt.parse(le1[le1.length - 1], le1.length - 1, vt.expectedType, bt);
                            return ls ? new We(bt, ls) : null;
                        }
                        outputDefined() {
                            return this.result.outputDefined();
                        }
                    }
                    class Je {
                        constructor(le1, vt){
                            this.type = vt.type, this.name = le1, this.boundExpression = vt;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length || "string" != typeof le1[1]) return vt.error("'var' expression requires exactly one string literal argument.");
                            const bt = le1[1];
                            return vt.scope.has(bt) ? new Je(bt, vt.scope.get(bt)) : vt.error(`Unknown variable "${bt}". Make sure "${bt}" has been bound in an enclosing "let" expression before using it.`, 1);
                        }
                        evaluate(le1) {
                            return this.boundExpression.evaluate(le1);
                        }
                        eachChild() {}
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Ke {
                        constructor(le1, vt, bt){
                            this.type = le1, this.index = vt, this.input = bt;
                        }
                        static parse(le1, vt) {
                            if (3 !== le1.length) return vt.error(`Expected 2 arguments, but found ${le1.length - 1} instead.`);
                            const bt = vt.parse(le1[1], 1, _u), ls = vt.parse(le1[2], 2, Z(vt.expectedType || jd));
                            return bt && ls ? new Ke(ls.type.itemType, bt, ls) : null;
                        }
                        evaluate(le1) {
                            const vt = this.index.evaluate(le1), bt = this.input.evaluate(le1);
                            if (vt < 0) throw new Fe(`Array index out of bounds: ${vt} < 0.`);
                            if (vt >= bt.length) throw new Fe(`Array index out of bounds: ${vt} > ${bt.length - 1}.`);
                            if (vt !== Math.floor(vt)) throw new Fe(`Array index must be an integer, but found ${vt} instead.`);
                            return bt[vt];
                        }
                        eachChild(le1) {
                            le1(this.index), le1(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Qe {
                        constructor(le1, vt){
                            this.type = Ld, this.needle = le1, this.haystack = vt;
                        }
                        static parse(le1, vt) {
                            if (3 !== le1.length) return vt.error(`Expected 2 arguments, but found ${le1.length - 1} instead.`);
                            const bt = vt.parse(le1[1], 1, jd), ls = vt.parse(le1[2], 2, jd);
                            return bt && ls ? K(bt.type, [
                                Ld,
                                Md,
                                _u,
                                du,
                                jd
                            ]) ? new Qe(bt, ls) : vt.error(`Expected first argument to be of type boolean, string, number or null, but found ${H(bt.type)} instead`) : null;
                        }
                        evaluate(le1) {
                            const vt = this.needle.evaluate(le1), bt = this.haystack.evaluate(le1);
                            if (!bt) return !1;
                            if (!Q(vt, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new Fe(`Expected first argument to be of type boolean, string, number or null, but found ${H(Ne(vt))} instead.`);
                            if (!Q(bt, [
                                "string",
                                "array"
                            ])) throw new Fe(`Expected second argument to be of type array or string, but found ${H(Ne(bt))} instead.`);
                            return bt.indexOf(vt) >= 0;
                        }
                        eachChild(le1) {
                            le1(this.needle), le1(this.haystack);
                        }
                        outputDefined() {
                            return !0;
                        }
                    }
                    class et {
                        constructor(le1, vt, bt){
                            this.type = _u, this.needle = le1, this.haystack = vt, this.fromIndex = bt;
                        }
                        static parse(le1, vt) {
                            if (le1.length <= 2 || le1.length >= 5) return vt.error(`Expected 2 or 3 arguments, but found ${le1.length - 1} instead.`);
                            const bt = vt.parse(le1[1], 1, jd), ls = vt.parse(le1[2], 2, jd);
                            if (!bt || !ls) return null;
                            if (!K(bt.type, [
                                Ld,
                                Md,
                                _u,
                                du,
                                jd
                            ])) return vt.error(`Expected first argument to be of type boolean, string, number or null, but found ${H(bt.type)} instead`);
                            if (4 === le1.length) {
                                const ho = vt.parse(le1[3], 3, _u);
                                return ho ? new et(bt, ls, ho) : null;
                            }
                            return new et(bt, ls);
                        }
                        evaluate(le1) {
                            const vt = this.needle.evaluate(le1), bt = this.haystack.evaluate(le1);
                            if (!Q(vt, [
                                "boolean",
                                "string",
                                "number",
                                "null"
                            ])) throw new Fe(`Expected first argument to be of type boolean, string, number or null, but found ${H(Ne(vt))} instead.`);
                            let ls;
                            if (this.fromIndex && (ls = this.fromIndex.evaluate(le1)), Q(bt, [
                                "string"
                            ])) {
                                const le1 = bt.indexOf(vt, ls);
                                return -1 === le1 ? -1 : [
                                    ...bt.slice(0, le1)
                                ].length;
                            }
                            if (Q(bt, [
                                "array"
                            ])) return bt.indexOf(vt, ls);
                            throw new Fe(`Expected second argument to be of type array or string, but found ${H(Ne(bt))} instead.`);
                        }
                        eachChild(le1) {
                            le1(this.needle), le1(this.haystack), this.fromIndex && le1(this.fromIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class tt {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            this.inputType = le1, this.type = vt, this.input = bt, this.cases = ls, this.outputs = ho, this.otherwise = Dl;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 5) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                            if (le1.length % 2 != 1) return vt.error("Expected an even number of arguments.");
                            let bt, ls;
                            vt.expectedType && "value" !== vt.expectedType.kind && (ls = vt.expectedType);
                            const ho = {}, Dl = [];
                            for(let uc = 2; uc < le1.length - 1; uc += 2){
                                let Fl = le1[uc];
                                const sc = le1[uc + 1];
                                Array.isArray(Fl) || (Fl = [
                                    Fl
                                ]);
                                const mc = vt.concat(uc);
                                if (0 === Fl.length) return mc.error("Expected at least one branch label.");
                                for (const le1 of Fl){
                                    if ("number" != typeof le1 && "string" != typeof le1) return mc.error("Branch labels must be numbers or strings.");
                                    if ("number" == typeof le1 && Math.abs(le1) > Number.MAX_SAFE_INTEGER) return mc.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                    if ("number" == typeof le1 && Math.floor(le1) !== le1) return mc.error("Numeric branch labels must be integer values.");
                                    if (bt) {
                                        if (mc.checkSubtype(bt, Ne(le1))) return null;
                                    } else bt = Ne(le1);
                                    if (void 0 !== ho[String(le1)]) return mc.error("Branch labels must be unique.");
                                    ho[String(le1)] = Dl.length;
                                }
                                const gc = vt.parse(sc, uc, ls);
                                if (!gc) return null;
                                ls = ls || gc.type, Dl.push(gc);
                            }
                            const Fl = vt.parse(le1[1], 1, jd);
                            if (!Fl) return null;
                            const sc = vt.parse(le1[le1.length - 1], le1.length - 1, ls);
                            return sc ? "value" !== Fl.type.kind && vt.concat(1).checkSubtype(bt, Fl.type) ? null : new tt(bt, ls, Fl, ho, Dl, sc) : null;
                        }
                        evaluate(le1) {
                            const vt = this.input.evaluate(le1);
                            return (Ne(vt) === this.inputType && this.outputs[this.cases[vt]] || this.otherwise).evaluate(le1);
                        }
                        eachChild(le1) {
                            le1(this.input), this.outputs.forEach(le1), le1(this.otherwise);
                        }
                        outputDefined() {
                            return this.outputs.every((le1)=>le1.outputDefined()) && this.otherwise.outputDefined();
                        }
                    }
                    class rt {
                        constructor(le1, vt, bt){
                            this.type = le1, this.branches = vt, this.otherwise = bt;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 4) return vt.error(`Expected at least 3 arguments, but found only ${le1.length - 1}.`);
                            if (le1.length % 2 != 0) return vt.error("Expected an odd number of arguments.");
                            let bt;
                            vt.expectedType && "value" !== vt.expectedType.kind && (bt = vt.expectedType);
                            const ls = [];
                            for(let Dl = 1; Dl < le1.length - 1; Dl += 2){
                                const ho = vt.parse(le1[Dl], Dl, Ld);
                                if (!ho) return null;
                                const Fl = vt.parse(le1[Dl + 1], Dl + 1, bt);
                                if (!Fl) return null;
                                ls.push([
                                    ho,
                                    Fl
                                ]), bt = bt || Fl.type;
                            }
                            const ho = vt.parse(le1[le1.length - 1], le1.length - 1, bt);
                            if (!ho) return null;
                            if (!bt) throw new Error("Can't infer output type");
                            return new rt(bt, ls, ho);
                        }
                        evaluate(le1) {
                            for (const [vt, bt] of this.branches)if (vt.evaluate(le1)) return bt.evaluate(le1);
                            return this.otherwise.evaluate(le1);
                        }
                        eachChild(le1) {
                            for (const [vt, bt] of this.branches)le1(vt), le1(bt);
                            le1(this.otherwise);
                        }
                        outputDefined() {
                            return this.branches.every((le1)=>{
                                let [vt, bt] = le1;
                                return bt.outputDefined();
                            }) && this.otherwise.outputDefined();
                        }
                    }
                    class nt {
                        constructor(le1, vt, bt, ls){
                            this.type = le1, this.input = vt, this.beginIndex = bt, this.endIndex = ls;
                        }
                        static parse(le1, vt) {
                            if (le1.length <= 2 || le1.length >= 5) return vt.error(`Expected 2 or 3 arguments, but found ${le1.length - 1} instead.`);
                            const bt = vt.parse(le1[1], 1, jd), ls = vt.parse(le1[2], 2, _u);
                            if (!bt || !ls) return null;
                            if (!K(bt.type, [
                                Z(jd),
                                Md,
                                jd
                            ])) return vt.error(`Expected first argument to be of type array or string, but found ${H(bt.type)} instead`);
                            if (4 === le1.length) {
                                const ho = vt.parse(le1[3], 3, _u);
                                return ho ? new nt(bt.type, bt, ls, ho) : null;
                            }
                            return new nt(bt.type, bt, ls);
                        }
                        evaluate(le1) {
                            const vt = this.input.evaluate(le1), bt = this.beginIndex.evaluate(le1);
                            let ls;
                            if (this.endIndex && (ls = this.endIndex.evaluate(le1)), Q(vt, [
                                "string"
                            ])) return [
                                ...vt
                            ].slice(bt, ls).join("");
                            if (Q(vt, [
                                "array"
                            ])) return vt.slice(bt, ls);
                            throw new Fe(`Expected first argument to be of type array or string, but found ${H(Ne(vt))} instead.`);
                        }
                        eachChild(le1) {
                            le1(this.input), le1(this.beginIndex), this.endIndex && le1(this.endIndex);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    function it(le1, vt) {
                        const bt = le1.length - 1;
                        let ls, ho, Dl = 0, Fl = bt, sc = 0;
                        for(; Dl <= Fl;)if (sc = Math.floor((Dl + Fl) / 2), ls = le1[sc], ho = le1[sc + 1], ls <= vt) {
                            if (sc === bt || vt < ho) return sc;
                            Dl = sc + 1;
                        } else {
                            if (!(ls > vt)) throw new Fe("Input is not a number.");
                            Fl = sc - 1;
                        }
                        return 0;
                    }
                    class st {
                        constructor(le1, vt, bt){
                            this.type = le1, this.input = vt, this.labels = [], this.outputs = [];
                            for (const [ls, ho] of bt)this.labels.push(ls), this.outputs.push(ho);
                        }
                        static parse(le1, vt) {
                            if (le1.length - 1 < 4) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                            if ((le1.length - 1) % 2 != 0) return vt.error("Expected an even number of arguments.");
                            const bt = vt.parse(le1[1], 1, _u);
                            if (!bt) return null;
                            const ls = [];
                            let ho = null;
                            vt.expectedType && "value" !== vt.expectedType.kind && (ho = vt.expectedType);
                            for(let Dl = 1; Dl < le1.length; Dl += 2){
                                const bt = 1 === Dl ? -1 / 0 : le1[Dl], Fl = le1[Dl + 1], sc = Dl, uc = Dl + 1;
                                if ("number" != typeof bt) return vt.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', sc);
                                if (ls.length && ls[ls.length - 1][0] >= bt) return vt.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', sc);
                                const mc = vt.parse(Fl, uc, ho);
                                if (!mc) return null;
                                ho = ho || mc.type, ls.push([
                                    bt,
                                    mc
                                ]);
                            }
                            return new st(ho, bt, ls);
                        }
                        evaluate(le1) {
                            const vt = this.labels, bt = this.outputs;
                            if (1 === vt.length) return bt[0].evaluate(le1);
                            const ls = this.input.evaluate(le1);
                            if (ls <= vt[0]) return bt[0].evaluate(le1);
                            const ho = vt.length;
                            return ls >= vt[ho - 1] ? bt[ho - 1].evaluate(le1) : bt[it(vt, ls)].evaluate(le1);
                        }
                        eachChild(le1) {
                            le1(this.input);
                            for (const vt of this.outputs)le1(vt);
                        }
                        outputDefined() {
                            return this.outputs.every((le1)=>le1.outputDefined());
                        }
                    }
                    var um, hm, dm = function() {
                        if (hm) return um;
                        function e(le1, vt, bt, ls) {
                            this.cx = 3 * le1, this.bx = 3 * (bt - le1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * vt, this.by = 3 * (ls - vt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = le1, this.p1y = vt, this.p2x = bt, this.p2y = ls;
                        }
                        return hm = 1, um = e, e.prototype = {
                            sampleCurveX: function(le1) {
                                return ((this.ax * le1 + this.bx) * le1 + this.cx) * le1;
                            },
                            sampleCurveY: function(le1) {
                                return ((this.ay * le1 + this.by) * le1 + this.cy) * le1;
                            },
                            sampleCurveDerivativeX: function(le1) {
                                return (3 * this.ax * le1 + 2 * this.bx) * le1 + this.cx;
                            },
                            solveCurveX: function(le1, vt) {
                                if (void 0 === vt && (vt = 1e-6), le1 < 0) return 0;
                                if (le1 > 1) return 1;
                                for(var bt = le1, ls = 0; ls < 8; ls++){
                                    var ho = this.sampleCurveX(bt) - le1;
                                    if (Math.abs(ho) < vt) return bt;
                                    var Dl = this.sampleCurveDerivativeX(bt);
                                    if (Math.abs(Dl) < 1e-6) break;
                                    bt -= ho / Dl;
                                }
                                var Fl = 0, sc = 1;
                                for(bt = le1, ls = 0; ls < 20 && (ho = this.sampleCurveX(bt), !(Math.abs(ho - le1) < vt)); ls++)le1 > ho ? Fl = bt : sc = bt, bt = .5 * (sc - Fl) + Fl;
                                return bt;
                            },
                            solve: function(le1, vt) {
                                return this.sampleCurveY(this.solveCurveX(le1, vt));
                            }
                        }, um;
                    }(), pm = function(le1) {
                        return le1 && le1.__esModule && Object.prototype.hasOwnProperty.call(le1, "default") ? le1.default : le1;
                    }(dm);
                    class ht {
                        constructor(le1, vt, bt, ls, ho){
                            this.type = le1, this.operator = vt, this.interpolation = bt, this.input = ls, this.labels = [], this.outputs = [];
                            for (const [Dl, Fl] of ho)this.labels.push(Dl), this.outputs.push(Fl);
                        }
                        static interpolationFactor(le1, vt, bt, ls) {
                            let ho = 0;
                            if ("exponential" === le1.name) ho = pt(vt, le1.base, bt, ls);
                            else if ("linear" === le1.name) ho = pt(vt, 1, bt, ls);
                            else if ("cubic-bezier" === le1.name) {
                                const Dl = le1.controlPoints;
                                ho = new pm(Dl[0], Dl[1], Dl[2], Dl[3]).solve(pt(vt, 1, bt, ls));
                            }
                            return ho;
                        }
                        static parse(le1, vt) {
                            let [bt, ls, ho, ...Dl] = le1;
                            if (!Array.isArray(ls) || 0 === ls.length) return vt.error("Expected an interpolation type expression.", 1);
                            if ("linear" === ls[0]) ls = {
                                name: "linear"
                            };
                            else if ("exponential" === ls[0]) {
                                const le1 = ls[1];
                                if ("number" != typeof le1) return vt.error("Exponential interpolation requires a numeric base.", 1, 1);
                                ls = {
                                    name: "exponential",
                                    base: le1
                                };
                            } else {
                                if ("cubic-bezier" !== ls[0]) return vt.error(`Unknown interpolation type ${String(ls[0])}`, 1, 0);
                                {
                                    const le1 = ls.slice(1);
                                    if (4 !== le1.length || le1.some((le1)=>"number" != typeof le1 || le1 < 0 || le1 > 1)) return vt.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                    ls = {
                                        name: "cubic-bezier",
                                        controlPoints: le1
                                    };
                                }
                            }
                            if (le1.length - 1 < 4) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                            if ((le1.length - 1) % 2 != 0) return vt.error("Expected an even number of arguments.");
                            if (ho = vt.parse(ho, 2, _u), !ho) return null;
                            const Fl = [];
                            let sc = null;
                            "interpolate-hcl" !== bt && "interpolate-lab" !== bt || vt.expectedType == Hd ? vt.expectedType && "value" !== vt.expectedType.kind && (sc = vt.expectedType) : sc = Nd;
                            for(let uc = 0; uc < Dl.length; uc += 2){
                                const le1 = Dl[uc], bt = Dl[uc + 1], ls = uc + 3, ho = uc + 4;
                                if ("number" != typeof le1) return vt.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', ls);
                                if (Fl.length && Fl[Fl.length - 1][0] >= le1) return vt.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', ls);
                                const mc = vt.parse(bt, ho, sc);
                                if (!mc) return null;
                                sc = sc || mc.type, Fl.push([
                                    le1,
                                    mc
                                ]);
                            }
                            return ee(sc, _u) || ee(sc, Rd) || ee(sc, Nd) || ee(sc, qd) || ee(sc, Wd) || ee(sc, Hd) || ee(sc, Yd) || ee(sc, Z(_u)) ? new ht(sc, bt, ls, ho, Fl) : vt.error(`Type ${H(sc)} is not interpolatable.`);
                        }
                        evaluate(le1) {
                            const vt = this.labels, bt = this.outputs;
                            if (1 === vt.length) return bt[0].evaluate(le1);
                            const ls = this.input.evaluate(le1);
                            if (ls <= vt[0]) return bt[0].evaluate(le1);
                            const ho = vt.length;
                            if (ls >= vt[ho - 1]) return bt[ho - 1].evaluate(le1);
                            const Dl = it(vt, ls), Fl = ht.interpolationFactor(this.interpolation, ls, vt[Dl], vt[Dl + 1]), sc = bt[Dl].evaluate(le1), uc = bt[Dl + 1].evaluate(le1);
                            switch(this.operator){
                                case "interpolate":
                                    switch(this.type.kind){
                                        case "number":
                                            return Se(sc, uc, Fl);
                                        case "color":
                                            return Ie.interpolate(sc, uc, Fl);
                                        case "padding":
                                            return De.interpolate(sc, uc, Fl);
                                        case "colorArray":
                                            return ze.interpolate(sc, uc, Fl);
                                        case "numberArray":
                                            return Pe.interpolate(sc, uc, Fl);
                                        case "variableAnchorOffsetCollection":
                                            return Ce.interpolate(sc, uc, Fl);
                                        case "array":
                                            return Ae(sc, uc, Fl);
                                        case "projectionDefinition":
                                            return Le.interpolate(sc, uc, Fl);
                                    }
                                case "interpolate-hcl":
                                    switch(this.type.kind){
                                        case "color":
                                            return Ie.interpolate(sc, uc, Fl, "hcl");
                                        case "colorArray":
                                            return ze.interpolate(sc, uc, Fl, "hcl");
                                    }
                                case "interpolate-lab":
                                    switch(this.type.kind){
                                        case "color":
                                            return Ie.interpolate(sc, uc, Fl, "lab");
                                        case "colorArray":
                                            return ze.interpolate(sc, uc, Fl, "lab");
                                    }
                            }
                        }
                        eachChild(le1) {
                            le1(this.input);
                            for (const vt of this.outputs)le1(vt);
                        }
                        outputDefined() {
                            return this.outputs.every((le1)=>le1.outputDefined());
                        }
                    }
                    function pt(le1, vt, bt, ls) {
                        const ho = ls - bt, Dl = le1 - bt;
                        return 0 === ho ? 0 : 1 === vt ? Dl / ho : (Math.pow(vt, Dl) - 1) / (Math.pow(vt, ho) - 1);
                    }
                    const mm = {
                        color: Ie.interpolate,
                        number: Se,
                        padding: De.interpolate,
                        numberArray: Pe.interpolate,
                        colorArray: ze.interpolate,
                        variableAnchorOffsetCollection: Ce.interpolate,
                        array: Ae
                    };
                    class dt {
                        constructor(le1, vt){
                            this.type = le1, this.args = vt;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 2) return vt.error("Expected at least one argument.");
                            let bt = null;
                            const ls = vt.expectedType;
                            ls && "value" !== ls.kind && (bt = ls);
                            const ho = [];
                            for (const Fl of le1.slice(1)){
                                const le1 = vt.parse(Fl, 1 + ho.length, bt, void 0, {
                                    typeAnnotation: "omit"
                                });
                                if (!le1) return null;
                                bt = bt || le1.type, ho.push(le1);
                            }
                            if (!bt) throw new Error("No output type");
                            const Dl = ls && ho.some((le1)=>J(ls, le1.type));
                            return new dt(Dl ? jd : bt, ho);
                        }
                        evaluate(le1) {
                            let vt, bt = null, ls = 0;
                            for (const ho of this.args)if (ls++, bt = ho.evaluate(le1), bt && bt instanceof Ve && !bt.available && (vt || (vt = bt.name), bt = null, ls === this.args.length && (bt = vt)), null !== bt) break;
                            return bt;
                        }
                        eachChild(le1) {
                            this.args.forEach(le1);
                        }
                        outputDefined() {
                            return this.args.every((le1)=>le1.outputDefined());
                        }
                    }
                    function yt(le1, vt) {
                        return "==" === le1 || "!=" === le1 ? "boolean" === vt.kind || "string" === vt.kind || "number" === vt.kind || "null" === vt.kind || "value" === vt.kind : "string" === vt.kind || "number" === vt.kind || "value" === vt.kind;
                    }
                    function mt(le1, vt, bt, ls) {
                        return 0 === ls.compare(vt, bt);
                    }
                    function gt(le1, vt, bt) {
                        const ls = "==" !== le1 && "!=" !== le1;
                        return class i {
                            constructor(le1, vt, bt){
                                this.type = Ld, this.lhs = le1, this.rhs = vt, this.collator = bt, this.hasUntypedArgument = "value" === le1.type.kind || "value" === vt.type.kind;
                            }
                            static parse(le1, vt) {
                                if (3 !== le1.length && 4 !== le1.length) return vt.error("Expected two or three arguments.");
                                const bt = le1[0];
                                let ho = vt.parse(le1[1], 1, jd);
                                if (!ho) return null;
                                if (!yt(bt, ho.type)) return vt.concat(1).error(`"${bt}" comparisons are not supported for type '${H(ho.type)}'.`);
                                let Dl = vt.parse(le1[2], 2, jd);
                                if (!Dl) return null;
                                if (!yt(bt, Dl.type)) return vt.concat(2).error(`"${bt}" comparisons are not supported for type '${H(Dl.type)}'.`);
                                if (ho.type.kind !== Dl.type.kind && "value" !== ho.type.kind && "value" !== Dl.type.kind) return vt.error(`Cannot compare types '${H(ho.type)}' and '${H(Dl.type)}'.`);
                                ls && ("value" === ho.type.kind && "value" !== Dl.type.kind ? ho = new Ge(Dl.type, [
                                    ho
                                ]) : "value" !== ho.type.kind && "value" === Dl.type.kind && (Dl = new Ge(ho.type, [
                                    Dl
                                ])));
                                let Fl = null;
                                if (4 === le1.length) {
                                    if ("string" !== ho.type.kind && "string" !== Dl.type.kind && "value" !== ho.type.kind && "value" !== Dl.type.kind) return vt.error("Cannot use collator to compare non-string types.");
                                    if (Fl = vt.parse(le1[3], 3, Ud), !Fl) return null;
                                }
                                return new i(ho, Dl, Fl);
                            }
                            evaluate(ho) {
                                const Dl = this.lhs.evaluate(ho), Fl = this.rhs.evaluate(ho);
                                if (ls && this.hasUntypedArgument) {
                                    const vt = Ne(Dl), bt = Ne(Fl);
                                    if (vt.kind !== bt.kind || "string" !== vt.kind && "number" !== vt.kind) throw new Fe(`Expected arguments for "${le1}" to be (string, string) or (number, number), but found (${vt.kind}, ${bt.kind}) instead.`);
                                }
                                if (this.collator && !ls && this.hasUntypedArgument) {
                                    const le1 = Ne(Dl), bt = Ne(Fl);
                                    if ("string" !== le1.kind || "string" !== bt.kind) return vt(ho, Dl, Fl);
                                }
                                return this.collator ? bt(ho, Dl, Fl, this.collator.evaluate(ho)) : vt(ho, Dl, Fl);
                            }
                            eachChild(le1) {
                                le1(this.lhs), le1(this.rhs), this.collator && le1(this.collator);
                            }
                            outputDefined() {
                                return !0;
                            }
                        };
                    }
                    const fm = gt("==", function(le1, vt, bt) {
                        return vt === bt;
                    }, mt), gm = gt("!=", function(le1, vt, bt) {
                        return vt !== bt;
                    }, function(le1, vt, bt, ls) {
                        return !mt(0, vt, bt, ls);
                    }), Am = gt("<", function(le1, vt, bt) {
                        return vt < bt;
                    }, function(le1, vt, bt, ls) {
                        return ls.compare(vt, bt) < 0;
                    }), _m = gt(">", function(le1, vt, bt) {
                        return vt > bt;
                    }, function(le1, vt, bt, ls) {
                        return ls.compare(vt, bt) > 0;
                    }), ym = gt("<=", function(le1, vt, bt) {
                        return vt <= bt;
                    }, function(le1, vt, bt, ls) {
                        return ls.compare(vt, bt) <= 0;
                    }), vm = gt(">=", function(le1, vt, bt) {
                        return vt >= bt;
                    }, function(le1, vt, bt, ls) {
                        return ls.compare(vt, bt) >= 0;
                    });
                    class At {
                        constructor(le1, vt, bt){
                            this.type = Ud, this.locale = bt, this.caseSensitive = le1, this.diacriticSensitive = vt;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error("Expected one argument.");
                            const bt = le1[1];
                            if ("object" != typeof bt || Array.isArray(bt)) return vt.error("Collator options argument must be an object.");
                            const ls = vt.parse(void 0 !== bt["case-sensitive"] && bt["case-sensitive"], 1, Ld);
                            if (!ls) return null;
                            const ho = vt.parse(void 0 !== bt["diacritic-sensitive"] && bt["diacritic-sensitive"], 1, Ld);
                            if (!ho) return null;
                            let Dl = null;
                            return bt.locale && (Dl = vt.parse(bt.locale, 1, Md), !Dl) ? null : new At(ls, ho, Dl);
                        }
                        evaluate(le1) {
                            return new Te(this.caseSensitive.evaluate(le1), this.diacriticSensitive.evaluate(le1), this.locale ? this.locale.evaluate(le1) : null);
                        }
                        eachChild(le1) {
                            le1(this.caseSensitive), le1(this.diacriticSensitive), this.locale && le1(this.locale);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class It {
                        constructor(le1, vt, bt, ls, ho){
                            this.type = Md, this.number = le1, this.locale = vt, this.currency = bt, this.minFractionDigits = ls, this.maxFractionDigits = ho;
                        }
                        static parse(le1, vt) {
                            if (3 !== le1.length) return vt.error("Expected two arguments.");
                            const bt = vt.parse(le1[1], 1, _u);
                            if (!bt) return null;
                            const ls = le1[2];
                            if ("object" != typeof ls || Array.isArray(ls)) return vt.error("NumberFormat options argument must be an object.");
                            let ho = null;
                            if (ls.locale && (ho = vt.parse(ls.locale, 1, Md), !ho)) return null;
                            let Dl = null;
                            if (ls.currency && (Dl = vt.parse(ls.currency, 1, Md), !Dl)) return null;
                            let Fl = null;
                            if (ls["min-fraction-digits"] && (Fl = vt.parse(ls["min-fraction-digits"], 1, _u), !Fl)) return null;
                            let sc = null;
                            return ls["max-fraction-digits"] && (sc = vt.parse(ls["max-fraction-digits"], 1, _u), !sc) ? null : new It(bt, ho, Dl, Fl, sc);
                        }
                        evaluate(le1) {
                            return new Intl.NumberFormat(this.locale ? this.locale.evaluate(le1) : [], {
                                style: this.currency ? "currency" : "decimal",
                                currency: this.currency ? this.currency.evaluate(le1) : void 0,
                                minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(le1) : void 0,
                                maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(le1) : void 0
                            }).format(this.number.evaluate(le1));
                        }
                        eachChild(le1) {
                            le1(this.number), this.locale && le1(this.locale), this.currency && le1(this.currency), this.minFractionDigits && le1(this.minFractionDigits), this.maxFractionDigits && le1(this.maxFractionDigits);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Tt {
                        constructor(le1){
                            this.type = Gd, this.sections = le1;
                        }
                        static parse(le1, vt) {
                            if (le1.length < 2) return vt.error("Expected at least one argument.");
                            const bt = le1[1];
                            if (!Array.isArray(bt) && "object" == typeof bt) return vt.error("First argument must be an image or text section.");
                            const ls = [];
                            let ho = !1;
                            for(let Dl = 1; Dl <= le1.length - 1; ++Dl){
                                const bt = le1[Dl];
                                if (ho && "object" == typeof bt && !Array.isArray(bt)) {
                                    ho = !1;
                                    let le1 = null;
                                    if (bt["font-scale"] && (le1 = vt.parse(bt["font-scale"], 1, _u), !le1)) return null;
                                    let Dl = null;
                                    if (bt["text-font"] && (Dl = vt.parse(bt["text-font"], 1, Z(Md)), !Dl)) return null;
                                    let Fl = null;
                                    if (bt["text-color"] && (Fl = vt.parse(bt["text-color"], 1, Nd), !Fl)) return null;
                                    let sc = null;
                                    if (bt["vertical-align"]) {
                                        if ("string" == typeof bt["vertical-align"] && !am.includes(bt["vertical-align"])) return vt.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${bt["vertical-align"]}' instead.`);
                                        if (sc = vt.parse(bt["vertical-align"], 1, Md), !sc) return null;
                                    }
                                    const uc = ls[ls.length - 1];
                                    uc.scale = le1, uc.font = Dl, uc.textColor = Fl, uc.verticalAlign = sc;
                                } else {
                                    const bt = vt.parse(le1[Dl], 1, jd);
                                    if (!bt) return null;
                                    const Fl = bt.type.kind;
                                    if ("string" !== Fl && "value" !== Fl && "null" !== Fl && "resolvedImage" !== Fl) return vt.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                    ho = !0, ls.push({
                                        content: bt,
                                        scale: null,
                                        font: null,
                                        textColor: null,
                                        verticalAlign: null
                                    });
                                }
                            }
                            return new Tt(ls);
                        }
                        evaluate(le1) {
                            return new Me(this.sections.map((vt)=>{
                                const bt = vt.content.evaluate(le1);
                                return Ne(bt) === Zd ? new Ee("", bt, null, null, null, vt.verticalAlign ? vt.verticalAlign.evaluate(le1) : null) : new Ee($e(bt), null, vt.scale ? vt.scale.evaluate(le1) : null, vt.font ? vt.font.evaluate(le1).join(",") : null, vt.textColor ? vt.textColor.evaluate(le1) : null, vt.verticalAlign ? vt.verticalAlign.evaluate(le1) : null);
                            }));
                        }
                        eachChild(le1) {
                            for (const vt of this.sections)le1(vt.content), vt.scale && le1(vt.scale), vt.font && le1(vt.font), vt.textColor && le1(vt.textColor), vt.verticalAlign && le1(vt.verticalAlign);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class kt {
                        constructor(le1){
                            this.type = Zd, this.input = le1;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error("Expected two arguments.");
                            const bt = vt.parse(le1[1], 1, Md);
                            return bt ? new kt(bt) : vt.error("No image name provided.");
                        }
                        evaluate(le1) {
                            const vt = this.input.evaluate(le1), bt = Ve.fromString(vt);
                            return bt && le1.availableImages && (bt.available = le1.availableImages.indexOf(vt) > -1), bt;
                        }
                        eachChild(le1) {
                            le1(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    class Et {
                        constructor(le1){
                            this.type = _u, this.input = le1;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error(`Expected 1 argument, but found ${le1.length - 1} instead.`);
                            const bt = vt.parse(le1[1], 1);
                            return bt ? "array" !== bt.type.kind && "string" !== bt.type.kind && "value" !== bt.type.kind ? vt.error(`Expected argument of type string or array, but found ${H(bt.type)} instead.`) : new Et(bt) : null;
                        }
                        evaluate(le1) {
                            const vt = this.input.evaluate(le1);
                            if ("string" == typeof vt) return [
                                ...vt
                            ].length;
                            if (Array.isArray(vt)) return vt.length;
                            throw new Fe(`Expected value to be of type string or array, but found ${H(Ne(vt))} instead.`);
                        }
                        eachChild(le1) {
                            le1(this.input);
                        }
                        outputDefined() {
                            return !1;
                        }
                    }
                    const xm = 8192;
                    function Dt(le1, vt) {
                        const bt = (180 + le1[0]) / 360, ls = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + le1[1] * Math.PI / 360))) / 360, ho = Math.pow(2, vt.z);
                        return [
                            Math.round(bt * ho * xm),
                            Math.round(ls * ho * xm)
                        ];
                    }
                    function Pt(le1, vt) {
                        const bt = Math.pow(2, vt.z);
                        var ls, ho;
                        return [
                            (ho = (le1[0] / xm + vt.x) / bt, 360 * ho - 180),
                            (ls = (le1[1] / xm + vt.y) / bt, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * ls) * Math.PI / 180)) - 90)
                        ];
                    }
                    function zt(le1, vt) {
                        le1[0] = Math.min(le1[0], vt[0]), le1[1] = Math.min(le1[1], vt[1]), le1[2] = Math.max(le1[2], vt[0]), le1[3] = Math.max(le1[3], vt[1]);
                    }
                    function Ft(le1, vt) {
                        return !(le1[0] <= vt[0] || le1[2] >= vt[2] || le1[1] <= vt[1] || le1[3] >= vt[3]);
                    }
                    function Bt(le1, vt, bt) {
                        const ls = le1[0] - vt[0], ho = le1[1] - vt[1], Dl = le1[0] - bt[0], Fl = le1[1] - bt[1];
                        return ls * Fl - Dl * ho == 0 && ls * Dl <= 0 && ho * Fl <= 0;
                    }
                    function Ct(le1, vt, bt, ls) {
                        var ho, Dl;
                        return 0 != (ho = [
                            ls[0] - bt[0],
                            ls[1] - bt[1]
                        ])[0] * (Dl = [
                            vt[0] - le1[0],
                            vt[1] - le1[1]
                        ])[1] - ho[1] * Dl[0] && !(!$t(le1, vt, bt, ls) || !$t(bt, ls, le1, vt));
                    }
                    function Vt(le1, vt, bt) {
                        for (const ls of bt)for(let bt = 0; bt < ls.length - 1; ++bt)if (Ct(le1, vt, ls[bt], ls[bt + 1])) return !0;
                        return !1;
                    }
                    function Lt(le1, vt, bt) {
                        void 0 === bt && (bt = !1);
                        let ls = !1;
                        for (const sc of vt)for(let vt = 0; vt < sc.length - 1; vt++){
                            if (Bt(le1, sc[vt], sc[vt + 1])) return bt;
                            (Dl = sc[vt])[1] > (ho = le1)[1] != (Fl = sc[vt + 1])[1] > ho[1] && ho[0] < (Fl[0] - Dl[0]) * (ho[1] - Dl[1]) / (Fl[1] - Dl[1]) + Dl[0] && (ls = !ls);
                        }
                        var ho, Dl, Fl;
                        return ls;
                    }
                    function Ot(le1, vt) {
                        for (const bt of vt)if (Lt(le1, bt)) return !0;
                        return !1;
                    }
                    function Rt(le1, vt) {
                        for (const bt of le1)if (!Lt(bt, vt)) return !1;
                        for(let bt = 0; bt < le1.length - 1; ++bt)if (Vt(le1[bt], le1[bt + 1], vt)) return !1;
                        return !0;
                    }
                    function Nt(le1, vt) {
                        for (const bt of vt)if (Rt(le1, bt)) return !0;
                        return !1;
                    }
                    function $t(le1, vt, bt, ls) {
                        const ho = ls[0] - bt[0], Dl = ls[1] - bt[1], Fl = (le1[0] - bt[0]) * Dl - ho * (le1[1] - bt[1]), sc = (vt[0] - bt[0]) * Dl - ho * (vt[1] - bt[1]);
                        return Fl > 0 && sc < 0 || Fl < 0 && sc > 0;
                    }
                    function Ut(le1, vt, bt) {
                        const ls = [];
                        for(let ho = 0; ho < le1.length; ho++){
                            const Dl = [];
                            for(let ls = 0; ls < le1[ho].length; ls++){
                                const Fl = Dt(le1[ho][ls], bt);
                                zt(vt, Fl), Dl.push(Fl);
                            }
                            ls.push(Dl);
                        }
                        return ls;
                    }
                    function qt(le1, vt, bt) {
                        const ls = [];
                        for(let ho = 0; ho < le1.length; ho++){
                            const Dl = Ut(le1[ho], vt, bt);
                            ls.push(Dl);
                        }
                        return ls;
                    }
                    function Gt(le1, vt, bt, ls) {
                        if (le1[0] < bt[0] || le1[0] > bt[2]) {
                            const vt = .5 * ls;
                            let ho = le1[0] - bt[0] > vt ? -ls : bt[0] - le1[0] > vt ? ls : 0;
                            0 === ho && (ho = le1[0] - bt[2] > vt ? -ls : bt[2] - le1[0] > vt ? ls : 0), le1[0] += ho;
                        }
                        zt(vt, le1);
                    }
                    function jt(le1, vt, bt, ls) {
                        const ho = Math.pow(2, ls.z) * xm, Dl = [
                            ls.x * xm,
                            ls.y * xm
                        ], Fl = [];
                        for (const sc of le1)for (const le1 of sc){
                            const ls = [
                                le1.x + Dl[0],
                                le1.y + Dl[1]
                            ];
                            Gt(ls, vt, bt, ho), Fl.push(ls);
                        }
                        return Fl;
                    }
                    function Xt(le1, vt, bt, ls) {
                        const ho = Math.pow(2, ls.z) * xm, Dl = [
                            ls.x * xm,
                            ls.y * xm
                        ], Fl = [];
                        for (const uc of le1){
                            const le1 = [];
                            for (const bt of uc){
                                const ls = [
                                    bt.x + Dl[0],
                                    bt.y + Dl[1]
                                ];
                                zt(vt, ls), le1.push(ls);
                            }
                            Fl.push(le1);
                        }
                        if (vt[2] - vt[0] <= ho / 2) {
                            (sc = vt)[0] = sc[1] = 1 / 0, sc[2] = sc[3] = -1 / 0;
                            for (const le1 of Fl)for (const ls of le1)Gt(ls, vt, bt, ho);
                        }
                        var sc;
                        return Fl;
                    }
                    class Yt {
                        constructor(le1, vt){
                            this.type = Ld, this.geojson = le1, this.geometries = vt;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error(`'within' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                            if (Re(le1[1])) {
                                const vt = le1[1];
                                if ("FeatureCollection" === vt.type) {
                                    const le1 = [];
                                    for (const bt of vt.features){
                                        const { type: vt, coordinates: ls } = bt.geometry;
                                        "Polygon" === vt && le1.push(ls), "MultiPolygon" === vt && le1.push(...ls);
                                    }
                                    if (le1.length) return new Yt(vt, {
                                        type: "MultiPolygon",
                                        coordinates: le1
                                    });
                                } else if ("Feature" === vt.type) {
                                    const le1 = vt.geometry.type;
                                    if ("Polygon" === le1 || "MultiPolygon" === le1) return new Yt(vt, vt.geometry);
                                } else if ("Polygon" === vt.type || "MultiPolygon" === vt.type) return new Yt(vt, vt);
                            }
                            return vt.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(le1) {
                            if (null != le1.geometry() && null != le1.canonicalID()) {
                                if ("Point" === le1.geometryType()) return function(le1, vt) {
                                    const bt = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ls = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ho = le1.canonicalID();
                                    if ("Polygon" === vt.type) {
                                        const Dl = Ut(vt.coordinates, ls, ho), Fl = jt(le1.geometry(), bt, ls, ho);
                                        if (!Ft(bt, ls)) return !1;
                                        for (const le1 of Fl)if (!Lt(le1, Dl)) return !1;
                                    }
                                    if ("MultiPolygon" === vt.type) {
                                        const Dl = qt(vt.coordinates, ls, ho), Fl = jt(le1.geometry(), bt, ls, ho);
                                        if (!Ft(bt, ls)) return !1;
                                        for (const le1 of Fl)if (!Ot(le1, Dl)) return !1;
                                    }
                                    return !0;
                                }(le1, this.geometries);
                                if ("LineString" === le1.geometryType()) return function(le1, vt) {
                                    const bt = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ls = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ], ho = le1.canonicalID();
                                    if ("Polygon" === vt.type) {
                                        const Dl = Ut(vt.coordinates, ls, ho), Fl = Xt(le1.geometry(), bt, ls, ho);
                                        if (!Ft(bt, ls)) return !1;
                                        for (const le1 of Fl)if (!Rt(le1, Dl)) return !1;
                                    }
                                    if ("MultiPolygon" === vt.type) {
                                        const Dl = qt(vt.coordinates, ls, ho), Fl = Xt(le1.geometry(), bt, ls, ho);
                                        if (!Ft(bt, ls)) return !1;
                                        for (const le1 of Fl)if (!Nt(le1, Dl)) return !1;
                                    }
                                    return !0;
                                }(le1, this.geometries);
                            }
                            return !1;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    let bm = class {
                        constructor(le1, vt){
                            if (void 0 === le1 && (le1 = []), void 0 === vt && (vt = (le1, vt)=>le1 < vt ? -1 : le1 > vt ? 1 : 0), this.data = le1, this.length = this.data.length, this.compare = vt, this.length > 0) for(let bt = (this.length >> 1) - 1; bt >= 0; bt--)this._down(bt);
                        }
                        push(le1) {
                            this.data.push(le1), this._up(this.length++);
                        }
                        pop() {
                            if (0 === this.length) return;
                            const le1 = this.data[0], vt = this.data.pop();
                            return --this.length > 0 && (this.data[0] = vt, this._down(0)), le1;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(le1) {
                            const { data: vt, compare: bt } = this, ls = vt[le1];
                            for(; le1 > 0;){
                                const ho = le1 - 1 >> 1, Dl = vt[ho];
                                if (bt(ls, Dl) >= 0) break;
                                vt[le1] = Dl, le1 = ho;
                            }
                            vt[le1] = ls;
                        }
                        _down(le1) {
                            const { data: vt, compare: bt } = this, ls = this.length >> 1, ho = vt[le1];
                            for(; le1 < ls;){
                                let ls = 1 + (le1 << 1);
                                const Dl = ls + 1;
                                if (Dl < this.length && bt(vt[Dl], vt[ls]) < 0 && (ls = Dl), bt(vt[ls], ho) >= 0) break;
                                vt[le1] = vt[ls], le1 = ls;
                            }
                            vt[le1] = ho;
                        }
                    };
                    function Ht(le1, vt, bt, ls, ho) {
                        for(void 0 === bt && (bt = 0), void 0 === ls && (ls = le1.length - 1), void 0 === ho && (ho = Jt); ls > bt;){
                            if (ls - bt > 600) {
                                const Dl = ls - bt + 1, Fl = vt - bt + 1, sc = Math.log(Dl), uc = .5 * Math.exp(2 * sc / 3), mc = .5 * Math.sqrt(sc * uc * (Dl - uc) / Dl) * (Fl - Dl / 2 < 0 ? -1 : 1);
                                Ht(le1, vt, Math.max(bt, Math.floor(vt - Fl * uc / Dl + mc)), Math.min(ls, Math.floor(vt + (Dl - Fl) * uc / Dl + mc)), ho);
                            }
                            const Dl = le1[vt];
                            let Fl = bt, sc = ls;
                            for(Wt(le1, bt, vt), ho(le1[ls], Dl) > 0 && Wt(le1, bt, ls); Fl < sc;){
                                for(Wt(le1, Fl, sc), Fl++, sc--; ho(le1[Fl], Dl) < 0;)Fl++;
                                for(; ho(le1[sc], Dl) > 0;)sc--;
                            }
                            0 === ho(le1[bt], Dl) ? Wt(le1, bt, sc) : (sc++, Wt(le1, sc, ls)), sc <= vt && (bt = sc + 1), vt <= sc && (ls = sc - 1);
                        }
                    }
                    function Wt(le1, vt, bt) {
                        const ls = le1[vt];
                        le1[vt] = le1[bt], le1[bt] = ls;
                    }
                    function Jt(le1, vt) {
                        return le1 < vt ? -1 : le1 > vt ? 1 : 0;
                    }
                    function Kt(le1, vt) {
                        if (le1.length <= 1) return [
                            le1
                        ];
                        const bt = [];
                        let ls, ho;
                        for (const Dl of le1){
                            const le1 = er(Dl);
                            0 !== le1 && (Dl.area = Math.abs(le1), void 0 === ho && (ho = le1 < 0), ho === le1 < 0 ? (ls && bt.push(ls), ls = [
                                Dl
                            ]) : ls.push(Dl));
                        }
                        if (ls && bt.push(ls), vt > 1) for(let Dl = 0; Dl < bt.length; Dl++)bt[Dl].length <= vt || (Ht(bt[Dl], vt, 1, bt[Dl].length - 1, Qt), bt[Dl] = bt[Dl].slice(0, vt));
                        return bt;
                    }
                    function Qt(le1, vt) {
                        return vt.area - le1.area;
                    }
                    function er(le1) {
                        let vt = 0;
                        for(let bt, ls, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++)bt = le1[ho], ls = le1[Fl], vt += (ls.x - bt.x) * (bt.y + ls.y);
                        return vt;
                    }
                    const wm = 1 / 298.257223563, Em = wm * (2 - wm), Mm = Math.PI / 180;
                    class ir {
                        constructor(le1){
                            const vt = 6378.137 * Mm * 1e3, bt = Math.cos(le1 * Mm), ls = 1 / (1 - Em * (1 - bt * bt)), ho = Math.sqrt(ls);
                            this.kx = vt * ho * bt, this.ky = vt * ho * ls * (1 - Em);
                        }
                        distance(le1, vt) {
                            const bt = this.wrap(le1[0] - vt[0]) * this.kx, ls = (le1[1] - vt[1]) * this.ky;
                            return Math.sqrt(bt * bt + ls * ls);
                        }
                        pointOnLine(le1, vt) {
                            let bt, ls, ho, Dl, Fl = 1 / 0;
                            for(let sc = 0; sc < le1.length - 1; sc++){
                                let uc = le1[sc][0], mc = le1[sc][1], gc = this.wrap(le1[sc + 1][0] - uc) * this.kx, Ac = (le1[sc + 1][1] - mc) * this.ky, Ec = 0;
                                0 === gc && 0 === Ac || (Ec = (this.wrap(vt[0] - uc) * this.kx * gc + (vt[1] - mc) * this.ky * Ac) / (gc * gc + Ac * Ac), Ec > 1 ? (uc = le1[sc + 1][0], mc = le1[sc + 1][1]) : Ec > 0 && (uc += gc / this.kx * Ec, mc += Ac / this.ky * Ec)), gc = this.wrap(vt[0] - uc) * this.kx, Ac = (vt[1] - mc) * this.ky;
                                const kc = gc * gc + Ac * Ac;
                                kc < Fl && (Fl = kc, bt = uc, ls = mc, ho = sc, Dl = Ec);
                            }
                            return {
                                point: [
                                    bt,
                                    ls
                                ],
                                index: ho,
                                t: Math.max(0, Math.min(1, Dl))
                            };
                        }
                        wrap(le1) {
                            for(; le1 < -180;)le1 += 360;
                            for(; le1 > 180;)le1 -= 360;
                            return le1;
                        }
                    }
                    function sr(le1, vt) {
                        return vt[0] - le1[0];
                    }
                    function or(le1) {
                        return le1[1] - le1[0] + 1;
                    }
                    function ar(le1, vt) {
                        return le1[1] >= le1[0] && le1[1] < vt;
                    }
                    function lr(le1, vt) {
                        if (le1[0] > le1[1]) return [
                            null,
                            null
                        ];
                        const bt = or(le1);
                        if (vt) {
                            if (2 === bt) return [
                                le1,
                                null
                            ];
                            const vt = Math.floor(bt / 2);
                            return [
                                [
                                    le1[0],
                                    le1[0] + vt
                                ],
                                [
                                    le1[0] + vt,
                                    le1[1]
                                ]
                            ];
                        }
                        if (1 === bt) return [
                            le1,
                            null
                        ];
                        const ls = Math.floor(bt / 2) - 1;
                        return [
                            [
                                le1[0],
                                le1[0] + ls
                            ],
                            [
                                le1[0] + ls + 1,
                                le1[1]
                            ]
                        ];
                    }
                    function ur(le1, vt) {
                        if (!ar(vt, le1.length)) return [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        const bt = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for(let ls = vt[0]; ls <= vt[1]; ++ls)zt(bt, le1[ls]);
                        return bt;
                    }
                    function cr(le1) {
                        const vt = [
                            1 / 0,
                            1 / 0,
                            -1 / 0,
                            -1 / 0
                        ];
                        for (const bt of le1)for (const le1 of bt)zt(vt, le1);
                        return vt;
                    }
                    function hr(le1) {
                        return le1[0] !== -1 / 0 && le1[1] !== -1 / 0 && le1[2] !== 1 / 0 && le1[3] !== 1 / 0;
                    }
                    function pr(le1, vt, bt) {
                        if (!hr(le1) || !hr(vt)) return NaN;
                        let ls = 0, ho = 0;
                        return le1[2] < vt[0] && (ls = vt[0] - le1[2]), le1[0] > vt[2] && (ls = le1[0] - vt[2]), le1[1] > vt[3] && (ho = le1[1] - vt[3]), le1[3] < vt[1] && (ho = vt[1] - le1[3]), bt.distance([
                            0,
                            0
                        ], [
                            ls,
                            ho
                        ]);
                    }
                    function fr(le1, vt, bt) {
                        const ls = bt.pointOnLine(vt, le1);
                        return bt.distance(le1, ls.point);
                    }
                    function dr(le1, vt, bt, ls, ho) {
                        const Dl = Math.min(fr(le1, [
                            bt,
                            ls
                        ], ho), fr(vt, [
                            bt,
                            ls
                        ], ho)), Fl = Math.min(fr(bt, [
                            le1,
                            vt
                        ], ho), fr(ls, [
                            le1,
                            vt
                        ], ho));
                        return Math.min(Dl, Fl);
                    }
                    function yr(le1, vt, bt, ls, ho) {
                        if (!ar(vt, le1.length) || !ar(ls, bt.length)) return 1 / 0;
                        let Dl = 1 / 0;
                        for(let Fl = vt[0]; Fl < vt[1]; ++Fl){
                            const vt = le1[Fl], sc = le1[Fl + 1];
                            for(let le1 = ls[0]; le1 < ls[1]; ++le1){
                                const ls = bt[le1], Fl = bt[le1 + 1];
                                if (Ct(vt, sc, ls, Fl)) return 0;
                                Dl = Math.min(Dl, dr(vt, sc, ls, Fl, ho));
                            }
                        }
                        return Dl;
                    }
                    function mr(le1, vt, bt, ls, ho) {
                        if (!ar(vt, le1.length) || !ar(ls, bt.length)) return NaN;
                        let Dl = 1 / 0;
                        for(let Fl = vt[0]; Fl <= vt[1]; ++Fl)for(let vt = ls[0]; vt <= ls[1]; ++vt)if (Dl = Math.min(Dl, ho.distance(le1[Fl], bt[vt])), 0 === Dl) return Dl;
                        return Dl;
                    }
                    function gr(le1, vt, bt) {
                        if (Lt(le1, vt, !0)) return 0;
                        let ls = 1 / 0;
                        for (const ho of vt){
                            const vt = ho[0], Dl = ho[ho.length - 1];
                            if (vt !== Dl && (ls = Math.min(ls, fr(le1, [
                                Dl,
                                vt
                            ], bt)), 0 === ls)) return ls;
                            const Fl = bt.pointOnLine(ho, le1);
                            if (ls = Math.min(ls, bt.distance(le1, Fl.point)), 0 === ls) return ls;
                        }
                        return ls;
                    }
                    function xr(le1, vt, bt, ls) {
                        if (!ar(vt, le1.length)) return NaN;
                        for(let Dl = vt[0]; Dl <= vt[1]; ++Dl)if (Lt(le1[Dl], bt, !0)) return 0;
                        let ho = 1 / 0;
                        for(let Dl = vt[0]; Dl < vt[1]; ++Dl){
                            const vt = le1[Dl], Fl = le1[Dl + 1];
                            for (const le1 of bt)for(let bt = 0, Dl = le1.length, sc = Dl - 1; bt < Dl; sc = bt++){
                                const Dl = le1[sc], uc = le1[bt];
                                if (Ct(vt, Fl, Dl, uc)) return 0;
                                ho = Math.min(ho, dr(vt, Fl, Dl, uc, ls));
                            }
                        }
                        return ho;
                    }
                    function vr(le1, vt) {
                        for (const bt of le1)for (const le1 of bt)if (Lt(le1, vt, !0)) return !0;
                        return !1;
                    }
                    function br(le1, vt, bt, ls) {
                        void 0 === ls && (ls = 1 / 0);
                        const ho = cr(le1), Dl = cr(vt);
                        if (ls !== 1 / 0 && pr(ho, Dl, bt) >= ls) return ls;
                        if (Ft(ho, Dl)) {
                            if (vr(le1, vt)) return 0;
                        } else if (vr(vt, le1)) return 0;
                        let Fl = 1 / 0;
                        for (const sc of le1)for(let le1 = 0, ls = sc.length, ho = ls - 1; le1 < ls; ho = le1++){
                            const ls = sc[ho], Dl = sc[le1];
                            for (const le1 of vt)for(let vt = 0, ho = le1.length, sc = ho - 1; vt < ho; sc = vt++){
                                const ho = le1[sc], uc = le1[vt];
                                if (Ct(ls, Dl, ho, uc)) return 0;
                                Fl = Math.min(Fl, dr(ls, Dl, ho, uc, bt));
                            }
                        }
                        return Fl;
                    }
                    function wr(le1, vt, bt, ls, ho, Dl) {
                        if (!Dl) return;
                        const Fl = pr(ur(ls, Dl), ho, bt);
                        Fl < vt && le1.push([
                            Fl,
                            Dl,
                            [
                                0,
                                0
                            ]
                        ]);
                    }
                    function _r(le1, vt, bt, ls, ho, Dl, Fl) {
                        if (!Dl || !Fl) return;
                        const sc = pr(ur(ls, Dl), ur(ho, Fl), bt);
                        sc < vt && le1.push([
                            sc,
                            Dl,
                            Fl
                        ]);
                    }
                    function Sr(le1, vt, bt, ls, ho) {
                        void 0 === ho && (ho = 1 / 0);
                        let Dl = Math.min(ls.distance(le1[0], bt[0][0]), ho);
                        if (0 === Dl) return Dl;
                        const Fl = new bm([
                            [
                                0,
                                [
                                    0,
                                    le1.length - 1
                                ],
                                [
                                    0,
                                    0
                                ]
                            ]
                        ], sr), sc = cr(bt);
                        for(; Fl.length > 0;){
                            const ho = Fl.pop();
                            if (ho[0] >= Dl) continue;
                            const uc = ho[1], mc = vt ? 50 : 100;
                            if (or(uc) <= mc) {
                                if (!ar(uc, le1.length)) return NaN;
                                if (vt) {
                                    const vt = xr(le1, uc, bt, ls);
                                    if (isNaN(vt) || 0 === vt) return vt;
                                    Dl = Math.min(Dl, vt);
                                } else for(let vt = uc[0]; vt <= uc[1]; ++vt){
                                    const ho = gr(le1[vt], bt, ls);
                                    if (Dl = Math.min(Dl, ho), 0 === Dl) return 0;
                                }
                            } else {
                                const bt = lr(uc, vt);
                                wr(Fl, Dl, ls, le1, sc, bt[0]), wr(Fl, Dl, ls, le1, sc, bt[1]);
                            }
                        }
                        return Dl;
                    }
                    function Ar(le1, vt, bt, ls, ho, Dl) {
                        void 0 === Dl && (Dl = 1 / 0);
                        let Fl = Math.min(Dl, ho.distance(le1[0], bt[0]));
                        if (0 === Fl) return Fl;
                        const sc = new bm([
                            [
                                0,
                                [
                                    0,
                                    le1.length - 1
                                ],
                                [
                                    0,
                                    bt.length - 1
                                ]
                            ]
                        ], sr);
                        for(; sc.length > 0;){
                            const Dl = sc.pop();
                            if (Dl[0] >= Fl) continue;
                            const uc = Dl[1], mc = Dl[2], gc = vt ? 50 : 100, Ac = ls ? 50 : 100;
                            if (or(uc) <= gc && or(mc) <= Ac) {
                                if (!ar(uc, le1.length) && ar(mc, bt.length)) return NaN;
                                let Dl;
                                if (vt && ls) Dl = yr(le1, uc, bt, mc, ho), Fl = Math.min(Fl, Dl);
                                else if (vt && !ls) {
                                    const vt = le1.slice(uc[0], uc[1] + 1);
                                    for(let le1 = mc[0]; le1 <= mc[1]; ++le1)if (Dl = fr(bt[le1], vt, ho), Fl = Math.min(Fl, Dl), 0 === Fl) return Fl;
                                } else if (!vt && ls) {
                                    const vt = bt.slice(mc[0], mc[1] + 1);
                                    for(let bt = uc[0]; bt <= uc[1]; ++bt)if (Dl = fr(le1[bt], vt, ho), Fl = Math.min(Fl, Dl), 0 === Fl) return Fl;
                                } else Dl = mr(le1, uc, bt, mc, ho), Fl = Math.min(Fl, Dl);
                            } else {
                                const Dl = lr(uc, vt), gc = lr(mc, ls);
                                _r(sc, Fl, ho, le1, bt, Dl[0], gc[0]), _r(sc, Fl, ho, le1, bt, Dl[0], gc[1]), _r(sc, Fl, ho, le1, bt, Dl[1], gc[0]), _r(sc, Fl, ho, le1, bt, Dl[1], gc[1]);
                            }
                        }
                        return Fl;
                    }
                    function Ir(le1) {
                        return "MultiPolygon" === le1.type ? le1.coordinates.map((le1)=>({
                                type: "Polygon",
                                coordinates: le1
                            })) : "MultiLineString" === le1.type ? le1.coordinates.map((le1)=>({
                                type: "LineString",
                                coordinates: le1
                            })) : "MultiPoint" === le1.type ? le1.coordinates.map((le1)=>({
                                type: "Point",
                                coordinates: le1
                            })) : [
                            le1
                        ];
                    }
                    class Tr {
                        constructor(le1, vt){
                            this.type = _u, this.geojson = le1, this.geometries = vt;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error(`'distance' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                            if (Re(le1[1])) {
                                const vt = le1[1];
                                if ("FeatureCollection" === vt.type) return new Tr(vt, vt.features.map((le1)=>Ir(le1.geometry)).flat());
                                if ("Feature" === vt.type) return new Tr(vt, Ir(vt.geometry));
                                if ("type" in vt && "coordinates" in vt) return new Tr(vt, Ir(vt));
                            }
                            return vt.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                        }
                        evaluate(le1) {
                            if (null != le1.geometry() && null != le1.canonicalID()) {
                                if ("Point" === le1.geometryType()) return function(le1, vt) {
                                    const bt = le1.geometry(), ls = bt.flat().map((vt)=>Pt([
                                            vt.x,
                                            vt.y
                                        ], le1.canonical));
                                    if (0 === bt.length) return NaN;
                                    const ho = new ir(ls[0][1]);
                                    let Dl = 1 / 0;
                                    for (const Fl of vt){
                                        switch(Fl.type){
                                            case "Point":
                                                Dl = Math.min(Dl, Ar(ls, !1, [
                                                    Fl.coordinates
                                                ], !1, ho, Dl));
                                                break;
                                            case "LineString":
                                                Dl = Math.min(Dl, Ar(ls, !1, Fl.coordinates, !0, ho, Dl));
                                                break;
                                            case "Polygon":
                                                Dl = Math.min(Dl, Sr(ls, !1, Fl.coordinates, ho, Dl));
                                        }
                                        if (0 === Dl) return Dl;
                                    }
                                    return Dl;
                                }(le1, this.geometries);
                                if ("LineString" === le1.geometryType()) return function(le1, vt) {
                                    const bt = le1.geometry(), ls = bt.flat().map((vt)=>Pt([
                                            vt.x,
                                            vt.y
                                        ], le1.canonical));
                                    if (0 === bt.length) return NaN;
                                    const ho = new ir(ls[0][1]);
                                    let Dl = 1 / 0;
                                    for (const Fl of vt){
                                        switch(Fl.type){
                                            case "Point":
                                                Dl = Math.min(Dl, Ar(ls, !0, [
                                                    Fl.coordinates
                                                ], !1, ho, Dl));
                                                break;
                                            case "LineString":
                                                Dl = Math.min(Dl, Ar(ls, !0, Fl.coordinates, !0, ho, Dl));
                                                break;
                                            case "Polygon":
                                                Dl = Math.min(Dl, Sr(ls, !0, Fl.coordinates, ho, Dl));
                                        }
                                        if (0 === Dl) return Dl;
                                    }
                                    return Dl;
                                }(le1, this.geometries);
                                if ("Polygon" === le1.geometryType()) return function(le1, vt) {
                                    const bt = le1.geometry();
                                    if (0 === bt.length || 0 === bt[0].length) return NaN;
                                    const ls = Kt(bt, 0).map((vt)=>vt.map((vt)=>vt.map((vt)=>Pt([
                                                    vt.x,
                                                    vt.y
                                                ], le1.canonical)))), ho = new ir(ls[0][0][0][1]);
                                    let Dl = 1 / 0;
                                    for (const Fl of vt)for (const le1 of ls){
                                        switch(Fl.type){
                                            case "Point":
                                                Dl = Math.min(Dl, Sr([
                                                    Fl.coordinates
                                                ], !1, le1, ho, Dl));
                                                break;
                                            case "LineString":
                                                Dl = Math.min(Dl, Sr(Fl.coordinates, !0, le1, ho, Dl));
                                                break;
                                            case "Polygon":
                                                Dl = Math.min(Dl, br(le1, Fl.coordinates, ho, Dl));
                                        }
                                        if (0 === Dl) return Dl;
                                    }
                                    return Dl;
                                }(le1, this.geometries);
                            }
                            return NaN;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !0;
                        }
                    }
                    class kr {
                        constructor(le1){
                            this.type = jd, this.key = le1;
                        }
                        static parse(le1, vt) {
                            if (2 !== le1.length) return vt.error(`Expected 1 argument, but found ${le1.length - 1} instead.`);
                            const bt = le1[1];
                            return null == bt ? vt.error("Global state property must be defined.") : "string" != typeof bt ? vt.error(`Global state property must be string, but found ${typeof le1[1]} instead.`) : new kr(bt);
                        }
                        evaluate(le1) {
                            var vt;
                            const bt = null === (vt = le1.globals) || void 0 === vt ? void 0 : vt.globalState;
                            return bt && 0 !== Object.keys(bt).length ? ge(bt, this.key) : null;
                        }
                        eachChild() {}
                        outputDefined() {
                            return !1;
                        }
                    }
                    const Sm = {
                        "==": fm,
                        "!=": gm,
                        ">": _m,
                        "<": Am,
                        ">=": vm,
                        "<=": ym,
                        array: Ge,
                        at: Ke,
                        boolean: Ge,
                        case: rt,
                        coalesce: dt,
                        collator: At,
                        format: Tt,
                        image: kt,
                        in: Qe,
                        "index-of": et,
                        interpolate: ht,
                        "interpolate-hcl": ht,
                        "interpolate-lab": ht,
                        length: Et,
                        let: We,
                        literal: Ue,
                        match: tt,
                        number: Ge,
                        "number-format": It,
                        object: Ge,
                        slice: nt,
                        step: st,
                        string: Ge,
                        "to-boolean": Xe,
                        "to-color": Xe,
                        "to-number": Xe,
                        "to-string": Xe,
                        var: Je,
                        within: Yt,
                        distance: Tr,
                        "global-state": kr
                    };
                    class Mr {
                        constructor(le1, vt, bt, ls){
                            this.name = le1, this.type = vt, this._evaluate = bt, this.args = ls;
                        }
                        evaluate(le1) {
                            return this._evaluate(le1, this.args);
                        }
                        eachChild(le1) {
                            this.args.forEach(le1);
                        }
                        outputDefined() {
                            return !1;
                        }
                        static parse(le1, vt) {
                            const bt = le1[0], ls = Mr.definitions[bt];
                            if (!ls) return vt.error(`Unknown expression "${bt}". If you wanted a literal array, use ["literal", [...]].`, 0);
                            const ho = Array.isArray(ls) ? ls[0] : ls.type, Dl = Array.isArray(ls) ? [
                                [
                                    ls[1],
                                    ls[2]
                                ]
                            ] : ls.overloads, Fl = Dl.filter((vt)=>{
                                let [bt] = vt;
                                return !Array.isArray(bt) || bt.length === le1.length - 1;
                            });
                            let sc = null;
                            for (const [uc, mc] of Fl){
                                sc = new He(vt.registry, Br, vt.path, null, vt.scope);
                                const ls = [];
                                let Dl = !1;
                                for(let vt = 1; vt < le1.length; vt++){
                                    const bt = le1[vt], ho = Array.isArray(uc) ? uc[vt - 1] : uc.type, Fl = sc.parse(bt, 1 + ls.length, ho);
                                    if (!Fl) {
                                        Dl = !0;
                                        break;
                                    }
                                    ls.push(Fl);
                                }
                                if (!Dl) {
                                    if (Array.isArray(uc) && uc.length !== ls.length) sc.error(`Expected ${uc.length} arguments, but found ${ls.length} instead.`);
                                    else {
                                        for(let le1 = 0; le1 < ls.length; le1++){
                                            const vt = Array.isArray(uc) ? uc[le1] : uc.type, bt = ls[le1];
                                            sc.concat(le1 + 1).checkSubtype(vt, bt.type);
                                        }
                                        if (0 === sc.errors.length) return new Mr(bt, ho, mc, ls);
                                    }
                                }
                            }
                            if (1 === Fl.length) vt.errors.push(...sc.errors);
                            else {
                                const bt = (Fl.length ? Fl : Dl).map((le1)=>{
                                    let [vt] = le1;
                                    var bt;
                                    return bt = vt, Array.isArray(bt) ? `(${bt.map(H).join(", ")})` : `(${H(bt.type)}...)`;
                                }).join(" | "), ls = [];
                                for(let ho = 1; ho < le1.length; ho++){
                                    const bt = vt.parse(le1[ho], 1 + ls.length);
                                    if (!bt) return null;
                                    ls.push(H(bt.type));
                                }
                                vt.error(`Expected arguments of type ${bt}, but found (${ls.join(", ")}) instead.`);
                            }
                            return null;
                        }
                        static register(le1, vt) {
                            Mr.definitions = vt;
                            for(const bt in vt)le1[bt] = Mr;
                        }
                    }
                    function Dr(le1, vt) {
                        let [bt, ls, ho, Dl] = vt;
                        bt = bt.evaluate(le1), ls = ls.evaluate(le1), ho = ho.evaluate(le1);
                        const Fl = Dl ? Dl.evaluate(le1) : 1, sc = Oe(bt, ls, ho, Fl);
                        if (sc) throw new Fe(sc);
                        return new Ie(bt / 255, ls / 255, ho / 255, Fl, !1);
                    }
                    function Pr(le1, vt) {
                        return le1 in vt;
                    }
                    function zr(le1, vt) {
                        const bt = vt[le1];
                        return void 0 === bt ? null : bt;
                    }
                    function Fr(le1) {
                        return {
                            type: le1
                        };
                    }
                    function Br(le1) {
                        if (le1 instanceof Je) return Br(le1.boundExpression);
                        if (le1 instanceof Mr && "error" === le1.name) return !1;
                        if (le1 instanceof At) return !1;
                        if (le1 instanceof Yt) return !1;
                        if (le1 instanceof Tr) return !1;
                        if (le1 instanceof kr) return !1;
                        const vt = le1 instanceof Xe || le1 instanceof Ge;
                        let bt = !0;
                        return le1.eachChild((le1)=>{
                            bt = vt ? bt && Br(le1) : bt && le1 instanceof Ue;
                        }), !!bt && Cr(le1) && Lr(le1, [
                            "zoom",
                            "heatmap-density",
                            "elevation",
                            "line-progress",
                            "accumulated",
                            "is-supported-script"
                        ]);
                    }
                    function Cr(le1) {
                        if (le1 instanceof Mr) {
                            if ("get" === le1.name && 1 === le1.args.length) return !1;
                            if ("feature-state" === le1.name) return !1;
                            if ("has" === le1.name && 1 === le1.args.length) return !1;
                            if ("properties" === le1.name || "geometry-type" === le1.name || "id" === le1.name) return !1;
                            if (/^filter-/.test(le1.name)) return !1;
                        }
                        if (le1 instanceof Yt) return !1;
                        if (le1 instanceof Tr) return !1;
                        let vt = !0;
                        return le1.eachChild((le1)=>{
                            vt && !Cr(le1) && (vt = !1);
                        }), vt;
                    }
                    function Vr(le1) {
                        if (le1 instanceof Mr && "feature-state" === le1.name) return !1;
                        let vt = !0;
                        return le1.eachChild((le1)=>{
                            vt && !Vr(le1) && (vt = !1);
                        }), vt;
                    }
                    function Lr(le1, vt) {
                        if (le1 instanceof Mr && vt.indexOf(le1.name) >= 0) return !1;
                        let bt = !0;
                        return le1.eachChild((le1)=>{
                            bt && !Lr(le1, vt) && (bt = !1);
                        }), bt;
                    }
                    function Or(le1) {
                        return {
                            result: "success",
                            value: le1
                        };
                    }
                    function Rr(le1) {
                        return {
                            result: "error",
                            value: le1
                        };
                    }
                    function Nr(le1) {
                        return "data-driven" === le1["property-type"] || "cross-faded-data-driven" === le1["property-type"];
                    }
                    function $r(le1) {
                        return !!le1.expression && le1.expression.parameters.indexOf("zoom") > -1;
                    }
                    function Ur(le1) {
                        return !!le1.expression && le1.expression.interpolated;
                    }
                    function qr(le1) {
                        return le1 instanceof Number ? "number" : le1 instanceof String ? "string" : le1 instanceof Boolean ? "boolean" : Array.isArray(le1) ? "array" : null === le1 ? "null" : typeof le1;
                    }
                    function Gr(le1) {
                        return "object" == typeof le1 && null !== le1 && !Array.isArray(le1) && Ne(le1) === Od;
                    }
                    function jr(le1) {
                        return le1;
                    }
                    function Xr(le1, vt) {
                        const bt = le1.stops && "object" == typeof le1.stops[0][0], ls = bt || !(bt || void 0 !== le1.property), ho = le1.type || (Ur(vt) ? "exponential" : "interval"), Dl = function(le1) {
                            switch(le1.type){
                                case "color":
                                    return Ie.parse;
                                case "padding":
                                    return De.parse;
                                case "numberArray":
                                    return Pe.parse;
                                case "colorArray":
                                    return ze.parse;
                                default:
                                    return null;
                            }
                        }(vt);
                        if (Dl && ((le1 = D({}, le1)).stops && (le1.stops = le1.stops.map((le1)=>[
                                le1[0],
                                Dl(le1[1])
                            ])), le1.default = Dl(le1.default ? le1.default : vt.default)), le1.colorSpace && "rgb" !== (Fl = le1.colorSpace) && "hcl" !== Fl && "lab" !== Fl) throw new Error(`Unknown color space: "${le1.colorSpace}"`);
                        var Fl;
                        const sc = function(le1) {
                            switch(le1){
                                case "exponential":
                                    return Wr;
                                case "interval":
                                    return Hr;
                                case "categorical":
                                    return Zr;
                                case "identity":
                                    return Jr;
                                default:
                                    throw new Error(`Unknown function type "${le1}"`);
                            }
                        }(ho);
                        let uc, mc;
                        if ("categorical" === ho) {
                            uc = Object.create(null);
                            for (const vt of le1.stops)uc[vt[0]] = vt[1];
                            mc = typeof le1.stops[0][0];
                        }
                        if (bt) {
                            const bt = {}, ls = [];
                            for(let vt = 0; vt < le1.stops.length; vt++){
                                const ho = le1.stops[vt], Dl = ho[0].zoom;
                                void 0 === bt[Dl] && (bt[Dl] = {
                                    zoom: Dl,
                                    type: le1.type,
                                    property: le1.property,
                                    default: le1.default,
                                    stops: []
                                }, ls.push(Dl)), bt[Dl].stops.push([
                                    ho[0].value,
                                    ho[1]
                                ]);
                            }
                            const ho = [];
                            for (const le1 of ls)ho.push([
                                bt[le1].zoom,
                                Xr(bt[le1], vt)
                            ]);
                            const Dl = {
                                name: "linear"
                            };
                            return {
                                kind: "composite",
                                interpolationType: Dl,
                                interpolationFactor: ht.interpolationFactor.bind(void 0, Dl),
                                zoomStops: ho.map((le1)=>le1[0]),
                                evaluate: (bt, ls)=>{
                                    let { zoom: Dl } = bt;
                                    return Wr({
                                        stops: ho,
                                        base: le1.base
                                    }, vt, Dl).evaluate(Dl, ls);
                                }
                            };
                        }
                        if (ls) {
                            const bt = "exponential" === ho ? {
                                name: "exponential",
                                base: void 0 !== le1.base ? le1.base : 1
                            } : null;
                            return {
                                kind: "camera",
                                interpolationType: bt,
                                interpolationFactor: ht.interpolationFactor.bind(void 0, bt),
                                zoomStops: le1.stops.map((le1)=>le1[0]),
                                evaluate: (bt)=>{
                                    let { zoom: ls } = bt;
                                    return sc(le1, vt, ls, uc, mc);
                                }
                            };
                        }
                        return {
                            kind: "source",
                            evaluate (bt, ls) {
                                const ho = ls && ls.properties ? ls.properties[le1.property] : void 0;
                                return void 0 === ho ? Yr(le1.default, vt.default) : sc(le1, vt, ho, uc, mc);
                            }
                        };
                    }
                    function Yr(le1, vt, bt) {
                        return void 0 !== le1 ? le1 : void 0 !== vt ? vt : void 0 !== bt ? bt : void 0;
                    }
                    function Zr(le1, vt, bt, ls, ho) {
                        return Yr(typeof bt === ho ? ls[bt] : void 0, le1.default, vt.default);
                    }
                    function Hr(le1, vt, bt) {
                        if ("number" !== qr(bt)) return Yr(le1.default, vt.default);
                        const ls = le1.stops.length;
                        if (1 === ls) return le1.stops[0][1];
                        if (bt <= le1.stops[0][0]) return le1.stops[0][1];
                        if (bt >= le1.stops[ls - 1][0]) return le1.stops[ls - 1][1];
                        const ho = it(le1.stops.map((le1)=>le1[0]), bt);
                        return le1.stops[ho][1];
                    }
                    function Wr(le1, vt, bt) {
                        const ls = void 0 !== le1.base ? le1.base : 1;
                        if ("number" !== qr(bt)) return Yr(le1.default, vt.default);
                        const ho = le1.stops.length;
                        if (1 === ho) return le1.stops[0][1];
                        if (bt <= le1.stops[0][0]) return le1.stops[0][1];
                        if (bt >= le1.stops[ho - 1][0]) return le1.stops[ho - 1][1];
                        const Dl = it(le1.stops.map((le1)=>le1[0]), bt), Fl = function(le1, vt, bt, ls) {
                            const ho = ls - bt, Dl = le1 - bt;
                            return 0 === ho ? 0 : 1 === vt ? Dl / ho : (Math.pow(vt, Dl) - 1) / (Math.pow(vt, ho) - 1);
                        }(bt, ls, le1.stops[Dl][0], le1.stops[Dl + 1][0]), sc = le1.stops[Dl][1], uc = le1.stops[Dl + 1][1], mc = mm[vt.type] || jr;
                        return "function" == typeof sc.evaluate ? {
                            evaluate () {
                                for(var vt = arguments.length, bt = new Array(vt), ls = 0; ls < vt; ls++)bt[ls] = arguments[ls];
                                const ho = sc.evaluate.apply(void 0, bt), Dl = uc.evaluate.apply(void 0, bt);
                                if (void 0 !== ho && void 0 !== Dl) return mc(ho, Dl, Fl, le1.colorSpace);
                            }
                        } : mc(sc, uc, Fl, le1.colorSpace);
                    }
                    function Jr(le1, vt, bt) {
                        switch(vt.type){
                            case "color":
                                bt = Ie.parse(bt);
                                break;
                            case "formatted":
                                bt = Me.fromString(bt.toString());
                                break;
                            case "resolvedImage":
                                bt = Ve.fromString(bt.toString());
                                break;
                            case "padding":
                                bt = De.parse(bt);
                                break;
                            case "colorArray":
                                bt = ze.parse(bt);
                                break;
                            case "numberArray":
                                bt = Pe.parse(bt);
                                break;
                            default:
                                qr(bt) === vt.type || "enum" === vt.type && vt.values[bt] || (bt = void 0);
                        }
                        return Yr(bt, le1.default, vt.default);
                    }
                    Mr.register(Sm, {
                        error: [
                            {
                                kind: "error"
                            },
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                throw new Fe(bt.evaluate(le1));
                            }
                        ],
                        typeof: [
                            Md,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return H(Ne(bt.evaluate(le1)));
                            }
                        ],
                        "to-rgba": [
                            Z(_u, 4),
                            [
                                Nd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const [ls, ho, Dl, Fl] = bt.evaluate(le1).rgb;
                                return [
                                    255 * ls,
                                    255 * ho,
                                    255 * Dl,
                                    Fl
                                ];
                            }
                        ],
                        rgb: [
                            Nd,
                            [
                                _u,
                                _u,
                                _u
                            ],
                            Dr
                        ],
                        rgba: [
                            Nd,
                            [
                                _u,
                                _u,
                                _u,
                                _u
                            ],
                            Dr
                        ],
                        has: {
                            type: Ld,
                            overloads: [
                                [
                                    [
                                        Md
                                    ],
                                    (le1, vt)=>{
                                        let [bt] = vt;
                                        return Pr(bt.evaluate(le1), le1.properties());
                                    }
                                ],
                                [
                                    [
                                        Md,
                                        Od
                                    ],
                                    (le1, vt)=>{
                                        let [bt, ls] = vt;
                                        return Pr(bt.evaluate(le1), ls.evaluate(le1));
                                    }
                                ]
                            ]
                        },
                        get: {
                            type: jd,
                            overloads: [
                                [
                                    [
                                        Md
                                    ],
                                    (le1, vt)=>{
                                        let [bt] = vt;
                                        return zr(bt.evaluate(le1), le1.properties());
                                    }
                                ],
                                [
                                    [
                                        Md,
                                        Od
                                    ],
                                    (le1, vt)=>{
                                        let [bt, ls] = vt;
                                        return zr(bt.evaluate(le1), ls.evaluate(le1));
                                    }
                                ]
                            ]
                        },
                        "feature-state": [
                            jd,
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return zr(bt.evaluate(le1), le1.featureState || {});
                            }
                        ],
                        properties: [
                            Od,
                            [],
                            (le1)=>le1.properties()
                        ],
                        "geometry-type": [
                            Md,
                            [],
                            (le1)=>le1.geometryType()
                        ],
                        id: [
                            jd,
                            [],
                            (le1)=>le1.id()
                        ],
                        zoom: [
                            _u,
                            [],
                            (le1)=>le1.globals.zoom
                        ],
                        "heatmap-density": [
                            _u,
                            [],
                            (le1)=>le1.globals.heatmapDensity || 0
                        ],
                        elevation: [
                            _u,
                            [],
                            (le1)=>le1.globals.elevation || 0
                        ],
                        "line-progress": [
                            _u,
                            [],
                            (le1)=>le1.globals.lineProgress || 0
                        ],
                        accumulated: [
                            jd,
                            [],
                            (le1)=>void 0 === le1.globals.accumulated ? null : le1.globals.accumulated
                        ],
                        "+": [
                            _u,
                            Fr(_u),
                            (le1, vt)=>{
                                let bt = 0;
                                for (const ls of vt)bt += ls.evaluate(le1);
                                return bt;
                            }
                        ],
                        "*": [
                            _u,
                            Fr(_u),
                            (le1, vt)=>{
                                let bt = 1;
                                for (const ls of vt)bt *= ls.evaluate(le1);
                                return bt;
                            }
                        ],
                        "-": {
                            type: _u,
                            overloads: [
                                [
                                    [
                                        _u,
                                        _u
                                    ],
                                    (le1, vt)=>{
                                        let [bt, ls] = vt;
                                        return bt.evaluate(le1) - ls.evaluate(le1);
                                    }
                                ],
                                [
                                    [
                                        _u
                                    ],
                                    (le1, vt)=>{
                                        let [bt] = vt;
                                        return -bt.evaluate(le1);
                                    }
                                ]
                            ]
                        },
                        "/": [
                            _u,
                            [
                                _u,
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return bt.evaluate(le1) / ls.evaluate(le1);
                            }
                        ],
                        "%": [
                            _u,
                            [
                                _u,
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return bt.evaluate(le1) % ls.evaluate(le1);
                            }
                        ],
                        ln2: [
                            _u,
                            [],
                            ()=>Math.LN2
                        ],
                        pi: [
                            _u,
                            [],
                            ()=>Math.PI
                        ],
                        e: [
                            _u,
                            [],
                            ()=>Math.E
                        ],
                        "^": [
                            _u,
                            [
                                _u,
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return Math.pow(bt.evaluate(le1), ls.evaluate(le1));
                            }
                        ],
                        sqrt: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.sqrt(bt.evaluate(le1));
                            }
                        ],
                        log10: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.log(bt.evaluate(le1)) / Math.LN10;
                            }
                        ],
                        ln: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.log(bt.evaluate(le1));
                            }
                        ],
                        log2: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.log(bt.evaluate(le1)) / Math.LN2;
                            }
                        ],
                        sin: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.sin(bt.evaluate(le1));
                            }
                        ],
                        cos: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.cos(bt.evaluate(le1));
                            }
                        ],
                        tan: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.tan(bt.evaluate(le1));
                            }
                        ],
                        asin: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.asin(bt.evaluate(le1));
                            }
                        ],
                        acos: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.acos(bt.evaluate(le1));
                            }
                        ],
                        atan: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.atan(bt.evaluate(le1));
                            }
                        ],
                        min: [
                            _u,
                            Fr(_u),
                            (le1, vt)=>Math.min(...vt.map((vt)=>vt.evaluate(le1)))
                        ],
                        max: [
                            _u,
                            Fr(_u),
                            (le1, vt)=>Math.max(...vt.map((vt)=>vt.evaluate(le1)))
                        ],
                        abs: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.abs(bt.evaluate(le1));
                            }
                        ],
                        round: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = bt.evaluate(le1);
                                return ls < 0 ? -Math.round(-ls) : Math.round(ls);
                            }
                        ],
                        floor: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.floor(bt.evaluate(le1));
                            }
                        ],
                        ceil: [
                            _u,
                            [
                                _u
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return Math.ceil(bt.evaluate(le1));
                            }
                        ],
                        "filter-==": [
                            Ld,
                            [
                                Md,
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return le1.properties()[bt.value] === ls.value;
                            }
                        ],
                        "filter-id-==": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return le1.id() === bt.value;
                            }
                        ],
                        "filter-type-==": [
                            Ld,
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return le1.geometryType() === bt.value;
                            }
                        ],
                        "filter-<": [
                            Ld,
                            [
                                Md,
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                const ho = le1.properties()[bt.value], Dl = ls.value;
                                return typeof ho == typeof Dl && ho < Dl;
                            }
                        ],
                        "filter-id-<": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = le1.id(), ho = bt.value;
                                return typeof ls == typeof ho && ls < ho;
                            }
                        ],
                        "filter->": [
                            Ld,
                            [
                                Md,
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                const ho = le1.properties()[bt.value], Dl = ls.value;
                                return typeof ho == typeof Dl && ho > Dl;
                            }
                        ],
                        "filter-id->": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = le1.id(), ho = bt.value;
                                return typeof ls == typeof ho && ls > ho;
                            }
                        ],
                        "filter-<=": [
                            Ld,
                            [
                                Md,
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                const ho = le1.properties()[bt.value], Dl = ls.value;
                                return typeof ho == typeof Dl && ho <= Dl;
                            }
                        ],
                        "filter-id-<=": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = le1.id(), ho = bt.value;
                                return typeof ls == typeof ho && ls <= ho;
                            }
                        ],
                        "filter->=": [
                            Ld,
                            [
                                Md,
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                const ho = le1.properties()[bt.value], Dl = ls.value;
                                return typeof ho == typeof Dl && ho >= Dl;
                            }
                        ],
                        "filter-id->=": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = le1.id(), ho = bt.value;
                                return typeof ls == typeof ho && ls >= ho;
                            }
                        ],
                        "filter-has": [
                            Ld,
                            [
                                jd
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.value in le1.properties();
                            }
                        ],
                        "filter-has-id": [
                            Ld,
                            [],
                            (le1)=>null !== le1.id() && void 0 !== le1.id()
                        ],
                        "filter-type-in": [
                            Ld,
                            [
                                Z(Md)
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.value.indexOf(le1.geometryType()) >= 0;
                            }
                        ],
                        "filter-id-in": [
                            Ld,
                            [
                                Z(jd)
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.value.indexOf(le1.id()) >= 0;
                            }
                        ],
                        "filter-in-small": [
                            Ld,
                            [
                                Md,
                                Z(jd)
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return ls.value.indexOf(le1.properties()[bt.value]) >= 0;
                            }
                        ],
                        "filter-in-large": [
                            Ld,
                            [
                                Md,
                                Z(jd)
                            ],
                            (le1, vt)=>{
                                let [bt, ls] = vt;
                                return function(le1, vt, bt, ls) {
                                    for(; bt <= ls;){
                                        const ho = bt + ls >> 1;
                                        if (vt[ho] === le1) return !0;
                                        vt[ho] > le1 ? ls = ho - 1 : bt = ho + 1;
                                    }
                                    return !1;
                                }(le1.properties()[bt.value], ls.value, 0, ls.value.length - 1);
                            }
                        ],
                        all: {
                            type: Ld,
                            overloads: [
                                [
                                    [
                                        Ld,
                                        Ld
                                    ],
                                    (le1, vt)=>{
                                        let [bt, ls] = vt;
                                        return bt.evaluate(le1) && ls.evaluate(le1);
                                    }
                                ],
                                [
                                    Fr(Ld),
                                    (le1, vt)=>{
                                        for (const bt of vt)if (!bt.evaluate(le1)) return !1;
                                        return !0;
                                    }
                                ]
                            ]
                        },
                        any: {
                            type: Ld,
                            overloads: [
                                [
                                    [
                                        Ld,
                                        Ld
                                    ],
                                    (le1, vt)=>{
                                        let [bt, ls] = vt;
                                        return bt.evaluate(le1) || ls.evaluate(le1);
                                    }
                                ],
                                [
                                    Fr(Ld),
                                    (le1, vt)=>{
                                        for (const bt of vt)if (bt.evaluate(le1)) return !0;
                                        return !1;
                                    }
                                ]
                            ]
                        },
                        "!": [
                            Ld,
                            [
                                Ld
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return !bt.evaluate(le1);
                            }
                        ],
                        "is-supported-script": [
                            Ld,
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                const ls = le1.globals && le1.globals.isSupportedScript;
                                return !ls || ls(bt.evaluate(le1));
                            }
                        ],
                        upcase: [
                            Md,
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.evaluate(le1).toUpperCase();
                            }
                        ],
                        downcase: [
                            Md,
                            [
                                Md
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.evaluate(le1).toLowerCase();
                            }
                        ],
                        concat: [
                            Md,
                            Fr(jd),
                            (le1, vt)=>vt.map((vt)=>$e(vt.evaluate(le1))).join("")
                        ],
                        "resolved-locale": [
                            Md,
                            [
                                Ud
                            ],
                            (le1, vt)=>{
                                let [bt] = vt;
                                return bt.evaluate(le1).resolvedLocale();
                            }
                        ]
                    });
                    class Kr {
                        constructor(le1, vt, bt){
                            this.expression = le1, this._warningHistory = {}, this._evaluator = new Ze, this._defaultValue = vt ? function(le1) {
                                if ("color" === le1.type && Gr(le1.default)) return new Ie(0, 0, 0, 0);
                                switch(le1.type){
                                    case "color":
                                        return Ie.parse(le1.default) || null;
                                    case "padding":
                                        return De.parse(le1.default) || null;
                                    case "numberArray":
                                        return Pe.parse(le1.default) || null;
                                    case "colorArray":
                                        return ze.parse(le1.default) || null;
                                    case "variableAnchorOffsetCollection":
                                        return Ce.parse(le1.default) || null;
                                    case "projectionDefinition":
                                        return Le.parse(le1.default) || null;
                                    default:
                                        return void 0 === le1.default ? null : le1.default;
                                }
                            }(vt) : null, this._enumValues = vt && "enum" === vt.type ? vt.values : null, this._globalState = bt;
                        }
                        evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                            return this._globalState && (le1 = ln(le1, this._globalState)), this._evaluator.globals = le1, this._evaluator.feature = vt, this._evaluator.featureState = bt, this._evaluator.canonical = ls, this._evaluator.availableImages = ho || null, this._evaluator.formattedSection = Dl, this.expression.evaluate(this._evaluator);
                        }
                        evaluate(le1, vt, bt, ls, ho, Dl) {
                            this._globalState && (le1 = ln(le1, this._globalState)), this._evaluator.globals = le1, this._evaluator.feature = vt || null, this._evaluator.featureState = bt || null, this._evaluator.canonical = ls, this._evaluator.availableImages = ho || null, this._evaluator.formattedSection = Dl || null;
                            try {
                                const le1 = this.expression.evaluate(this._evaluator);
                                if (null == le1 || "number" == typeof le1 && le1 != le1) return this._defaultValue;
                                if (this._enumValues && !(le1 in this._enumValues)) throw new Fe(`Expected value to be one of ${Object.keys(this._enumValues).map((le1)=>JSON.stringify(le1)).join(", ")}, but found ${JSON.stringify(le1)} instead.`);
                                return le1;
                            } catch (le1) {
                                return this._warningHistory[le1.message] || (this._warningHistory[le1.message] = !0, "undefined" != typeof console && console.warn(le1.message)), this._defaultValue;
                            }
                        }
                    }
                    function Qr(le1) {
                        return Array.isArray(le1) && le1.length > 0 && "string" == typeof le1[0] && le1[0] in Sm;
                    }
                    function en(le1, vt, bt) {
                        const ls = new He(Sm, Br, [], vt ? function(le1) {
                            const vt = {
                                color: Nd,
                                string: Md,
                                number: _u,
                                enum: Md,
                                boolean: Ld,
                                formatted: Gd,
                                padding: qd,
                                numberArray: Wd,
                                colorArray: Hd,
                                projectionDefinition: Rd,
                                resolvedImage: Zd,
                                variableAnchorOffsetCollection: Yd
                            };
                            return "array" === le1.type ? Z(vt[le1.value] || jd, le1.length) : vt[le1.type];
                        }(vt) : void 0), ho = ls.parse(le1, void 0, void 0, void 0, vt && "string" === vt.type ? {
                            typeAnnotation: "coerce"
                        } : void 0);
                        return ho ? Or(new Kr(ho, vt, bt)) : Rr(ls.errors);
                    }
                    class tn {
                        constructor(le1, vt, bt){
                            this.kind = le1, this._styleExpression = vt, this.isStateDependent = "constant" !== le1 && !Vr(vt.expression), this.globalStateRefs = an(vt.expression), this._globalState = bt;
                        }
                        evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                            return this._globalState && (le1 = ln(le1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl);
                        }
                        evaluate(le1, vt, bt, ls, ho, Dl) {
                            return this._globalState && (le1 = ln(le1, this._globalState)), this._styleExpression.evaluate(le1, vt, bt, ls, ho, Dl);
                        }
                    }
                    class rn {
                        constructor(le1, vt, bt, ls, ho){
                            this.kind = le1, this.zoomStops = bt, this._styleExpression = vt, this.isStateDependent = "camera" !== le1 && !Vr(vt.expression), this.globalStateRefs = an(vt.expression), this.interpolationType = ls, this._globalState = ho;
                        }
                        evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                            return this._globalState && (le1 = ln(le1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl);
                        }
                        evaluate(le1, vt, bt, ls, ho, Dl) {
                            return this._globalState && (le1 = ln(le1, this._globalState)), this._styleExpression.evaluate(le1, vt, bt, ls, ho, Dl);
                        }
                        interpolationFactor(le1, vt, bt) {
                            return this.interpolationType ? ht.interpolationFactor(this.interpolationType, le1, vt, bt) : 0;
                        }
                    }
                    function nn(le1, vt, bt) {
                        const ls = en(le1, vt, bt);
                        if ("error" === ls.result) return ls;
                        const ho = ls.value.expression, Dl = Cr(ho);
                        if (!Dl && !Nr(vt)) return Rr([
                            new P("", "data expressions not supported")
                        ]);
                        const Fl = Lr(ho, [
                            "zoom"
                        ]);
                        if (!Fl && !$r(vt)) return Rr([
                            new P("", "zoom expressions not supported")
                        ]);
                        const sc = on(ho);
                        return sc || Fl ? sc instanceof P ? Rr([
                            sc
                        ]) : sc instanceof ht && !Ur(vt) ? Rr([
                            new P("", '"interpolate" expressions cannot be used with this property')
                        ]) : Or(sc ? new rn(Dl ? "camera" : "composite", ls.value, sc.labels, sc instanceof ht ? sc.interpolation : void 0, bt) : new tn(Dl ? "constant" : "source", ls.value, bt)) : Rr([
                            new P("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                        ]);
                    }
                    class sn {
                        constructor(le1, vt){
                            this._parameters = le1, this._specification = vt, D(this, Xr(this._parameters, this._specification));
                        }
                        static deserialize(le1) {
                            return new sn(le1._parameters, le1._specification);
                        }
                        static serialize(le1) {
                            return {
                                _parameters: le1._parameters,
                                _specification: le1._specification
                            };
                        }
                    }
                    function on(le1) {
                        let vt = null;
                        if (le1 instanceof We) vt = on(le1.result);
                        else if (le1 instanceof dt) {
                            for (const bt of le1.args)if (vt = on(bt), vt) break;
                        } else (le1 instanceof st || le1 instanceof ht) && le1.input instanceof Mr && "zoom" === le1.input.name && (vt = le1);
                        return vt instanceof P || le1.eachChild((le1)=>{
                            const bt = on(le1);
                            bt instanceof P ? vt = bt : !vt && bt ? vt = new P("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : vt && bt && vt !== bt && (vt = new P("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                        }), vt;
                    }
                    function an(le1, vt) {
                        return void 0 === vt && (vt = new Set), le1 instanceof kr && vt.add(le1.key), le1.eachChild((le1)=>{
                            an(le1, vt);
                        }), vt;
                    }
                    function ln(le1, vt) {
                        const { zoom: bt, heatmapDensity: ls, elevation: ho, lineProgress: Dl, isSupportedScript: Fl, accumulated: sc } = null != le1 ? le1 : {};
                        return {
                            zoom: bt,
                            heatmapDensity: ls,
                            elevation: ho,
                            lineProgress: Dl,
                            isSupportedScript: Fl,
                            accumulated: sc,
                            globalState: vt
                        };
                    }
                    function un(le1) {
                        if (!0 === le1 || !1 === le1) return !0;
                        if (!Array.isArray(le1) || 0 === le1.length) return !1;
                        switch(le1[0]){
                            case "has":
                                return le1.length >= 2 && "$id" !== le1[1] && "$type" !== le1[1];
                            case "in":
                                return le1.length >= 3 && ("string" != typeof le1[1] || Array.isArray(le1[2]));
                            case "!in":
                            case "!has":
                            case "none":
                                return !1;
                            case "==":
                            case "!=":
                            case ">":
                            case ">=":
                            case "<":
                            case "<=":
                                return 3 !== le1.length || Array.isArray(le1[1]) || Array.isArray(le1[2]);
                            case "any":
                            case "all":
                                for (const vt of le1.slice(1))if (!un(vt) && "boolean" != typeof vt) return !1;
                                return !0;
                            default:
                                return !0;
                        }
                    }
                    const Tm = {
                        type: "boolean",
                        default: !1,
                        transition: !1,
                        "property-type": "data-driven",
                        expression: {
                            interpolated: !1,
                            parameters: [
                                "zoom",
                                "feature"
                            ]
                        }
                    };
                    function hn(le1, vt) {
                        if (null == le1) return {
                            filter: ()=>!0,
                            needGeometry: !1,
                            getGlobalStateRefs: ()=>new Set
                        };
                        un(le1) || (le1 = dn(le1));
                        const bt = en(le1, Tm, vt);
                        if ("error" === bt.result) throw new Error(bt.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                        return {
                            filter: (le1, vt, ls)=>bt.value.evaluate(le1, vt, {}, ls),
                            needGeometry: fn(le1),
                            getGlobalStateRefs: ()=>an(bt.value.expression)
                        };
                    }
                    function pn(le1, vt) {
                        return le1 < vt ? -1 : le1 > vt ? 1 : 0;
                    }
                    function fn(le1) {
                        if (!Array.isArray(le1)) return !1;
                        if ("within" === le1[0] || "distance" === le1[0]) return !0;
                        for(let vt = 1; vt < le1.length; vt++)if (fn(le1[vt])) return !0;
                        return !1;
                    }
                    function dn(le1) {
                        if (!le1) return !0;
                        const vt = le1[0];
                        var bt;
                        return le1.length <= 1 ? "any" !== vt : "==" === vt ? yn(le1[1], le1[2], "==") : "!=" === vt ? xn(yn(le1[1], le1[2], "==")) : "<" === vt || ">" === vt || "<=" === vt || ">=" === vt ? yn(le1[1], le1[2], vt) : "any" === vt ? (bt = le1.slice(1), [
                            "any"
                        ].concat(bt.map(dn))) : "all" === vt ? [
                            "all"
                        ].concat(le1.slice(1).map(dn)) : "none" === vt ? [
                            "all"
                        ].concat(le1.slice(1).map(dn).map(xn)) : "in" === vt ? mn(le1[1], le1.slice(2)) : "!in" === vt ? xn(mn(le1[1], le1.slice(2))) : "has" === vt ? gn(le1[1]) : "!has" !== vt || xn(gn(le1[1]));
                    }
                    function yn(le1, vt, bt) {
                        switch(le1){
                            case "$type":
                                return [
                                    `filter-type-${bt}`,
                                    vt
                                ];
                            case "$id":
                                return [
                                    `filter-id-${bt}`,
                                    vt
                                ];
                            default:
                                return [
                                    `filter-${bt}`,
                                    le1,
                                    vt
                                ];
                        }
                    }
                    function mn(le1, vt) {
                        if (0 === vt.length) return !1;
                        switch(le1){
                            case "$type":
                                return [
                                    "filter-type-in",
                                    [
                                        "literal",
                                        vt
                                    ]
                                ];
                            case "$id":
                                return [
                                    "filter-id-in",
                                    [
                                        "literal",
                                        vt
                                    ]
                                ];
                            default:
                                return vt.length > 200 && !vt.some((le1)=>typeof le1 != typeof vt[0]) ? [
                                    "filter-in-large",
                                    le1,
                                    [
                                        "literal",
                                        vt.sort(pn)
                                    ]
                                ] : [
                                    "filter-in-small",
                                    le1,
                                    [
                                        "literal",
                                        vt
                                    ]
                                ];
                        }
                    }
                    function gn(le1) {
                        switch(le1){
                            case "$type":
                                return !0;
                            case "$id":
                                return [
                                    "filter-has-id"
                                ];
                            default:
                                return [
                                    "filter-has",
                                    le1
                                ];
                        }
                    }
                    function xn(le1) {
                        return [
                            "!",
                            le1
                        ];
                    }
                    function vn(le1) {
                        const vt = typeof le1;
                        if ("number" === vt || "boolean" === vt || "string" === vt || null == le1) return JSON.stringify(le1);
                        if (Array.isArray(le1)) {
                            let vt = "[";
                            for (const bt of le1)vt += `${vn(bt)},`;
                            return `${vt}]`;
                        }
                        const bt = Object.keys(le1).sort();
                        let ls = "{";
                        for(let ho = 0; ho < bt.length; ho++)ls += `${JSON.stringify(bt[ho])}:${vn(le1[bt[ho]])},`;
                        return `${ls}}`;
                    }
                    function bn(le1) {
                        let vt = "";
                        for (const bt of kc)vt += `/${vn(le1[bt])}`;
                        return vt;
                    }
                    function wn(le1) {
                        const vt = le1.value;
                        return vt ? [
                            new M(le1.key, vt, "constants have been deprecated as of v8")
                        ] : [];
                    }
                    function _n(le1) {
                        return le1 instanceof Number || le1 instanceof String || le1 instanceof Boolean ? le1.valueOf() : le1;
                    }
                    function Sn(le1) {
                        if (Array.isArray(le1)) return le1.map(Sn);
                        if (le1 instanceof Object && !(le1 instanceof Number || le1 instanceof String || le1 instanceof Boolean)) {
                            const vt = {};
                            for(const bt in le1)vt[bt] = Sn(le1[bt]);
                            return vt;
                        }
                        return _n(le1);
                    }
                    function An(le1) {
                        const vt = le1.key, bt = le1.value, ls = le1.valueSpec || {}, ho = le1.objectElementValidators || {}, Dl = le1.style, Fl = le1.styleSpec, sc = le1.validateSpec;
                        let uc = [];
                        const mc = qr(bt);
                        if ("object" !== mc) return [
                            new M(vt, bt, `object expected, ${mc} found`)
                        ];
                        for(const gc in bt){
                            const le1 = gc.split(".")[0], mc = ge(ls, le1) || ls["*"];
                            let Ac;
                            if (ge(ho, le1)) Ac = ho[le1];
                            else if (ge(ls, le1)) {
                                if (void 0 === bt[gc]) continue;
                                Ac = sc;
                            } else if (ho["*"]) Ac = ho["*"];
                            else {
                                if (!ls["*"]) {
                                    uc.push(new M(vt, bt[gc], `unknown property "${gc}"`));
                                    continue;
                                }
                                Ac = sc;
                            }
                            uc = uc.concat(Ac({
                                key: (vt ? `${vt}.` : vt) + gc,
                                value: bt[gc],
                                valueSpec: mc,
                                style: Dl,
                                styleSpec: Fl,
                                object: bt,
                                objectKey: gc,
                                validateSpec: sc
                            }, bt));
                        }
                        for(const gc in ls)ho[gc] || ls[gc].required && void 0 === ls[gc].default && void 0 === bt[gc] && uc.push(new M(vt, bt, `missing required property "${gc}"`));
                        return uc;
                    }
                    function In(le1) {
                        const vt = le1.value, bt = le1.valueSpec, ls = le1.style, ho = le1.styleSpec, Dl = le1.key, Fl = le1.arrayElementValidator || le1.validateSpec;
                        if ("array" !== qr(vt)) return [
                            new M(Dl, vt, `array expected, ${qr(vt)} found`)
                        ];
                        if (bt.length && vt.length !== bt.length) return [
                            new M(Dl, vt, `array length ${bt.length} expected, length ${vt.length} found`)
                        ];
                        let sc = {
                            type: bt.value,
                            values: bt.values
                        };
                        ho.$version < 7 && (sc.function = bt.function), "object" === qr(bt.value) && (sc = bt.value);
                        let uc = [];
                        for(let mc = 0; mc < vt.length; mc++)uc = uc.concat(Fl({
                            array: vt,
                            arrayIndex: mc,
                            value: vt[mc],
                            valueSpec: sc,
                            validateSpec: le1.validateSpec,
                            style: ls,
                            styleSpec: ho,
                            key: `${Dl}[${mc}]`
                        }));
                        return uc;
                    }
                    function Tn(le1) {
                        const vt = le1.key, bt = le1.value, ls = le1.valueSpec;
                        let ho = qr(bt);
                        return "number" === ho && bt != bt && (ho = "NaN"), "number" !== ho ? [
                            new M(vt, bt, `number expected, ${ho} found`)
                        ] : "minimum" in ls && bt < ls.minimum ? [
                            new M(vt, bt, `${bt} is less than the minimum value ${ls.minimum}`)
                        ] : "maximum" in ls && bt > ls.maximum ? [
                            new M(vt, bt, `${bt} is greater than the maximum value ${ls.maximum}`)
                        ] : [];
                    }
                    function kn(le1) {
                        const vt = le1.valueSpec, bt = _n(le1.value.type);
                        let ls, ho, Dl, Fl = {};
                        const sc = "categorical" !== bt && void 0 === le1.value.property, uc = !sc, mc = "array" === qr(le1.value.stops) && "array" === qr(le1.value.stops[0]) && "object" === qr(le1.value.stops[0][0]), gc = An({
                            key: le1.key,
                            value: le1.value,
                            valueSpec: le1.styleSpec.function,
                            validateSpec: le1.validateSpec,
                            style: le1.style,
                            styleSpec: le1.styleSpec,
                            objectElementValidators: {
                                stops: function(le1) {
                                    if ("identity" === bt) return [
                                        new M(le1.key, le1.value, 'identity function may not have a "stops" property')
                                    ];
                                    let vt = [];
                                    const ls = le1.value;
                                    return vt = vt.concat(In({
                                        key: le1.key,
                                        value: ls,
                                        valueSpec: le1.valueSpec,
                                        validateSpec: le1.validateSpec,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec,
                                        arrayElementValidator: h
                                    })), "array" === qr(ls) && 0 === ls.length && vt.push(new M(le1.key, ls, "array must have at least one stop")), vt;
                                },
                                default: function(le1) {
                                    return le1.validateSpec({
                                        key: le1.key,
                                        value: le1.value,
                                        valueSpec: vt,
                                        validateSpec: le1.validateSpec,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec
                                    });
                                }
                            }
                        });
                        return "identity" === bt && sc && gc.push(new M(le1.key, le1.value, 'missing required property "property"')), "identity" === bt || le1.value.stops || gc.push(new M(le1.key, le1.value, 'missing required property "stops"')), "exponential" === bt && le1.valueSpec.expression && !Ur(le1.valueSpec) && gc.push(new M(le1.key, le1.value, "exponential functions not supported")), le1.styleSpec.$version >= 8 && (uc && !Nr(le1.valueSpec) ? gc.push(new M(le1.key, le1.value, "property functions not supported")) : sc && !$r(le1.valueSpec) && gc.push(new M(le1.key, le1.value, "zoom functions not supported"))), "categorical" !== bt && !mc || void 0 !== le1.value.property || gc.push(new M(le1.key, le1.value, '"property" property is required')), gc;
                        function h(le1) {
                            let bt = [];
                            const ls = le1.value, sc = le1.key;
                            if ("array" !== qr(ls)) return [
                                new M(sc, ls, `array expected, ${qr(ls)} found`)
                            ];
                            if (2 !== ls.length) return [
                                new M(sc, ls, `array length 2 expected, length ${ls.length} found`)
                            ];
                            if (mc) {
                                if ("object" !== qr(ls[0])) return [
                                    new M(sc, ls, `object expected, ${qr(ls[0])} found`)
                                ];
                                if (void 0 === ls[0].zoom) return [
                                    new M(sc, ls, "object stop key must have zoom")
                                ];
                                if (void 0 === ls[0].value) return [
                                    new M(sc, ls, "object stop key must have value")
                                ];
                                if (Dl && Dl > _n(ls[0].zoom)) return [
                                    new M(sc, ls[0].zoom, "stop zoom values must appear in ascending order")
                                ];
                                _n(ls[0].zoom) !== Dl && (Dl = _n(ls[0].zoom), ho = void 0, Fl = {}), bt = bt.concat(An({
                                    key: `${sc}[0]`,
                                    value: ls[0],
                                    valueSpec: {
                                        zoom: {}
                                    },
                                    validateSpec: le1.validateSpec,
                                    style: le1.style,
                                    styleSpec: le1.styleSpec,
                                    objectElementValidators: {
                                        zoom: Tn,
                                        value: p
                                    }
                                }));
                            } else bt = bt.concat(p({
                                key: `${sc}[0]`,
                                value: ls[0],
                                validateSpec: le1.validateSpec,
                                style: le1.style,
                                styleSpec: le1.styleSpec
                            }, ls));
                            return Qr(Sn(ls[1])) ? bt.concat([
                                new M(`${sc}[1]`, ls[1], "expressions are not allowed in function stops.")
                            ]) : bt.concat(le1.validateSpec({
                                key: `${sc}[1]`,
                                value: ls[1],
                                valueSpec: vt,
                                validateSpec: le1.validateSpec,
                                style: le1.style,
                                styleSpec: le1.styleSpec
                            }));
                        }
                        function p(le1, Dl) {
                            const sc = qr(le1.value), uc = _n(le1.value), mc = null !== le1.value ? le1.value : Dl;
                            if (ls) {
                                if (sc !== ls) return [
                                    new M(le1.key, mc, `${sc} stop domain type must match previous stop domain type ${ls}`)
                                ];
                            } else ls = sc;
                            if ("number" !== sc && "string" !== sc && "boolean" !== sc) return [
                                new M(le1.key, mc, "stop domain value must be a number, string, or boolean")
                            ];
                            if ("number" !== sc && "categorical" !== bt) {
                                let ls = `number expected, ${sc} found`;
                                return Nr(vt) && void 0 === bt && (ls += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                    new M(le1.key, mc, ls)
                                ];
                            }
                            return "categorical" !== bt || "number" !== sc || isFinite(uc) && Math.floor(uc) === uc ? "categorical" !== bt && "number" === sc && void 0 !== ho && uc < ho ? [
                                new M(le1.key, mc, "stop domain values must appear in ascending order")
                            ] : (ho = uc, "categorical" === bt && uc in Fl ? [
                                new M(le1.key, mc, "stop domain values must be unique")
                            ] : (Fl[uc] = !0, [])) : [
                                new M(le1.key, mc, `integer expected, found ${uc}`)
                            ];
                        }
                    }
                    function En(le1) {
                        const vt = ("property" === le1.expressionContext ? nn : en)(Sn(le1.value), le1.valueSpec);
                        if ("error" === vt.result) return vt.value.map((vt)=>new M(`${le1.key}${vt.key}`, le1.value, vt.message));
                        const bt = vt.value.expression || vt.value._styleExpression.expression;
                        if ("property" === le1.expressionContext && "text-font" === le1.propertyKey && !bt.outputDefined()) return [
                            new M(le1.key, le1.value, `Invalid data expression for "${le1.propertyKey}". Output values must be contained as literals within the expression.`)
                        ];
                        if ("property" === le1.expressionContext && "layout" === le1.propertyType && !Vr(bt)) return [
                            new M(le1.key, le1.value, '"feature-state" data expressions are not supported with layout properties.')
                        ];
                        if ("filter" === le1.expressionContext && !Vr(bt)) return [
                            new M(le1.key, le1.value, '"feature-state" data expressions are not supported with filters.')
                        ];
                        if (le1.expressionContext && 0 === le1.expressionContext.indexOf("cluster")) {
                            if (!Lr(bt, [
                                "zoom",
                                "feature-state"
                            ])) return [
                                new M(le1.key, le1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                            ];
                            if ("cluster-initial" === le1.expressionContext && !Cr(bt)) return [
                                new M(le1.key, le1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                            ];
                        }
                        return [];
                    }
                    function Mn(le1) {
                        const vt = le1.key, bt = le1.value, ls = qr(bt);
                        return "string" !== ls ? [
                            new M(vt, bt, `color expected, ${ls} found`)
                        ] : Ie.parse(String(bt)) ? [] : [
                            new M(vt, bt, `color expected, "${bt}" found`)
                        ];
                    }
                    function Dn(le1) {
                        const vt = le1.key, bt = le1.value, ls = le1.valueSpec, ho = [];
                        return Array.isArray(ls.values) ? -1 === ls.values.indexOf(_n(bt)) && ho.push(new M(vt, bt, `expected one of [${ls.values.join(", ")}], ${JSON.stringify(bt)} found`)) : -1 === Object.keys(ls.values).indexOf(_n(bt)) && ho.push(new M(vt, bt, `expected one of [${Object.keys(ls.values).join(", ")}], ${JSON.stringify(bt)} found`)), ho;
                    }
                    function Pn(le1) {
                        return un(Sn(le1.value)) ? En(D({}, le1, {
                            expressionContext: "filter",
                            valueSpec: {
                                value: "boolean"
                            }
                        })) : zn(le1);
                    }
                    function zn(le1) {
                        const vt = le1.value, bt = le1.key;
                        if ("array" !== qr(vt)) return [
                            new M(bt, vt, `array expected, ${qr(vt)} found`)
                        ];
                        const ls = le1.styleSpec;
                        let ho, Dl = [];
                        if (vt.length < 1) return [
                            new M(bt, vt, "filter array must have at least 1 element")
                        ];
                        switch(Dl = Dl.concat(Dn({
                            key: `${bt}[0]`,
                            value: vt[0],
                            valueSpec: ls.filter_operator,
                            style: le1.style,
                            styleSpec: le1.styleSpec
                        })), _n(vt[0])){
                            case "<":
                            case "<=":
                            case ">":
                            case ">=":
                                vt.length >= 2 && "$type" === _n(vt[1]) && Dl.push(new M(bt, vt, `"$type" cannot be use with operator "${vt[0]}"`));
                            case "==":
                            case "!=":
                                3 !== vt.length && Dl.push(new M(bt, vt, `filter array for operator "${vt[0]}" must have 3 elements`));
                            case "in":
                            case "!in":
                                vt.length >= 2 && (ho = qr(vt[1]), "string" !== ho && Dl.push(new M(`${bt}[1]`, vt[1], `string expected, ${ho} found`)));
                                for(let Fl = 2; Fl < vt.length; Fl++)ho = qr(vt[Fl]), "$type" === _n(vt[1]) ? Dl = Dl.concat(Dn({
                                    key: `${bt}[${Fl}]`,
                                    value: vt[Fl],
                                    valueSpec: ls.geometry_type,
                                    style: le1.style,
                                    styleSpec: le1.styleSpec
                                })) : "string" !== ho && "number" !== ho && "boolean" !== ho && Dl.push(new M(`${bt}[${Fl}]`, vt[Fl], `string, number, or boolean expected, ${ho} found`));
                                break;
                            case "any":
                            case "all":
                            case "none":
                                for(let ls = 1; ls < vt.length; ls++)Dl = Dl.concat(zn({
                                    key: `${bt}[${ls}]`,
                                    value: vt[ls],
                                    style: le1.style,
                                    styleSpec: le1.styleSpec
                                }));
                                break;
                            case "has":
                            case "!has":
                                ho = qr(vt[1]), 2 !== vt.length ? Dl.push(new M(bt, vt, `filter array for "${vt[0]}" operator must have 2 elements`)) : "string" !== ho && Dl.push(new M(`${bt}[1]`, vt[1], `string expected, ${ho} found`));
                        }
                        return Dl;
                    }
                    function Fn(le1, vt) {
                        const bt = le1.key, ls = le1.validateSpec, ho = le1.style, Dl = le1.styleSpec, Fl = le1.value, sc = le1.objectKey, uc = Dl[`${vt}_${le1.layerType}`];
                        if (!uc) return [];
                        const mc = sc.match(/^(.*)-transition$/);
                        if ("paint" === vt && mc && uc[mc[1]] && uc[mc[1]].transition) return ls({
                            key: bt,
                            value: Fl,
                            valueSpec: Dl.transition,
                            style: ho,
                            styleSpec: Dl
                        });
                        const gc = le1.valueSpec || uc[sc];
                        if (!gc) return [
                            new M(bt, Fl, `unknown property "${sc}"`)
                        ];
                        let Ac;
                        if ("string" === qr(Fl) && Nr(gc) && !gc.tokens && (Ac = /^{([^}]+)}$/.exec(Fl))) return [
                            new M(bt, Fl, `"${sc}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(Ac[1])} }\`.`)
                        ];
                        const Ec = [];
                        return "symbol" === le1.layerType && "text-font" === sc && Gr(Sn(Fl)) && "identity" === _n(Fl.type) && Ec.push(new M(bt, Fl, '"text-font" does not support identity functions')), Ec.concat(ls({
                            key: le1.key,
                            value: Fl,
                            valueSpec: gc,
                            style: ho,
                            styleSpec: Dl,
                            expressionContext: "property",
                            propertyType: vt,
                            propertyKey: sc
                        }));
                    }
                    function Bn(le1) {
                        return Fn(le1, "paint");
                    }
                    function Cn(le1) {
                        return Fn(le1, "layout");
                    }
                    function Vn(le1) {
                        let vt = [];
                        const bt = le1.value, ls = le1.key, ho = le1.style, Dl = le1.styleSpec;
                        if ("object" !== qr(bt)) return [
                            new M(ls, bt, `object expected, ${qr(bt)} found`)
                        ];
                        bt.type || bt.ref || vt.push(new M(ls, bt, 'either "type" or "ref" is required'));
                        let Fl = _n(bt.type);
                        const sc = _n(bt.ref);
                        if (bt.id) {
                            const Dl = _n(bt.id);
                            for(let Fl = 0; Fl < le1.arrayIndex; Fl++){
                                const le1 = ho.layers[Fl];
                                _n(le1.id) === Dl && vt.push(new M(ls, bt.id, `duplicate layer id "${bt.id}", previously used at line ${le1.id.__line__}`));
                            }
                        }
                        if ("ref" in bt) {
                            let le1;
                            [
                                "type",
                                "source",
                                "source-layer",
                                "filter",
                                "layout"
                            ].forEach((le1)=>{
                                le1 in bt && vt.push(new M(ls, bt[le1], `"${le1}" is prohibited for ref layers`));
                            }), ho.layers.forEach((vt)=>{
                                _n(vt.id) === sc && (le1 = vt);
                            }), le1 ? le1.ref ? vt.push(new M(ls, bt.ref, "ref cannot reference another ref layer")) : Fl = _n(le1.type) : vt.push(new M(ls, bt.ref, `ref layer "${sc}" not found`));
                        } else if ("background" !== Fl) {
                            if (bt.source) {
                                const le1 = ho.sources && ho.sources[bt.source], Dl = le1 && _n(le1.type);
                                le1 ? "vector" === Dl && "raster" === Fl ? vt.push(new M(ls, bt.source, `layer "${bt.id}" requires a raster source`)) : "raster-dem" !== Dl && "hillshade" === Fl || "raster-dem" !== Dl && "color-relief" === Fl ? vt.push(new M(ls, bt.source, `layer "${bt.id}" requires a raster-dem source`)) : "raster" === Dl && "raster" !== Fl ? vt.push(new M(ls, bt.source, `layer "${bt.id}" requires a vector source`)) : "vector" !== Dl || bt["source-layer"] ? "raster-dem" === Dl && "hillshade" !== Fl && "color-relief" !== Fl ? vt.push(new M(ls, bt.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== Fl || !bt.paint || !bt.paint["line-gradient"] || "geojson" === Dl && le1.lineMetrics || vt.push(new M(ls, bt, `layer "${bt.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : vt.push(new M(ls, bt, `layer "${bt.id}" must specify a "source-layer"`)) : vt.push(new M(ls, bt.source, `source "${bt.source}" not found`));
                            } else vt.push(new M(ls, bt, 'missing required property "source"'));
                        }
                        return vt = vt.concat(An({
                            key: ls,
                            value: bt,
                            valueSpec: Dl.layer,
                            style: le1.style,
                            styleSpec: le1.styleSpec,
                            validateSpec: le1.validateSpec,
                            objectElementValidators: {
                                "*": ()=>[],
                                type: ()=>le1.validateSpec({
                                        key: `${ls}.type`,
                                        value: bt.type,
                                        valueSpec: Dl.layer.type,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec,
                                        validateSpec: le1.validateSpec,
                                        object: bt,
                                        objectKey: "type"
                                    }),
                                filter: Pn,
                                layout: (le1)=>An({
                                        layer: bt,
                                        key: le1.key,
                                        value: le1.value,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec,
                                        validateSpec: le1.validateSpec,
                                        objectElementValidators: {
                                            "*": (le1)=>Cn(D({
                                                    layerType: Fl
                                                }, le1))
                                        }
                                    }),
                                paint: (le1)=>An({
                                        layer: bt,
                                        key: le1.key,
                                        value: le1.value,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec,
                                        validateSpec: le1.validateSpec,
                                        objectElementValidators: {
                                            "*": (le1)=>Bn(D({
                                                    layerType: Fl
                                                }, le1))
                                        }
                                    })
                            }
                        })), vt;
                    }
                    function Ln(le1) {
                        const vt = le1.value, bt = le1.key, ls = qr(vt);
                        return "string" !== ls ? [
                            new M(bt, vt, `string expected, ${ls} found`)
                        ] : [];
                    }
                    const km = {
                        promoteId: function(le1) {
                            let { key: vt, value: bt } = le1;
                            if ("string" === qr(bt)) return Ln({
                                key: vt,
                                value: bt
                            });
                            {
                                const le1 = [];
                                for(const ls in bt)le1.push(...Ln({
                                    key: `${vt}.${ls}`,
                                    value: bt[ls]
                                }));
                                return le1;
                            }
                        }
                    };
                    function Rn(le1) {
                        const vt = le1.value, bt = le1.key, ls = le1.styleSpec, ho = le1.style, Dl = le1.validateSpec;
                        if (!vt.type) return [
                            new M(bt, vt, '"type" is required')
                        ];
                        const Fl = _n(vt.type);
                        let sc;
                        switch(Fl){
                            case "vector":
                            case "raster":
                                return sc = An({
                                    key: bt,
                                    value: vt,
                                    valueSpec: ls[`source_${Fl.replace("-", "_")}`],
                                    style: le1.style,
                                    styleSpec: ls,
                                    objectElementValidators: km,
                                    validateSpec: Dl
                                }), sc;
                            case "raster-dem":
                                return sc = function(le1) {
                                    var vt;
                                    const bt = null !== (vt = le1.sourceName) && void 0 !== vt ? vt : "", ls = le1.value, ho = le1.styleSpec, Dl = ho.source_raster_dem, Fl = le1.style;
                                    let sc = [];
                                    const uc = qr(ls);
                                    if (void 0 === ls) return sc;
                                    if ("object" !== uc) return sc.push(new M("source_raster_dem", ls, `object expected, ${uc} found`)), sc;
                                    const mc = "custom" === _n(ls.encoding), gc = [
                                        "redFactor",
                                        "greenFactor",
                                        "blueFactor",
                                        "baseShift"
                                    ], Ac = le1.value.encoding ? `"${le1.value.encoding}"` : "Default";
                                    for(const Ec in ls)!mc && gc.includes(Ec) ? sc.push(new M(Ec, ls[Ec], `In "${bt}": "${Ec}" is only valid when "encoding" is set to "custom". ${Ac} encoding found`)) : Dl[Ec] ? sc = sc.concat(le1.validateSpec({
                                        key: Ec,
                                        value: ls[Ec],
                                        valueSpec: Dl[Ec],
                                        validateSpec: le1.validateSpec,
                                        style: Fl,
                                        styleSpec: ho
                                    })) : sc.push(new M(Ec, ls[Ec], `unknown property "${Ec}"`));
                                    return sc;
                                }({
                                    sourceName: bt,
                                    value: vt,
                                    style: le1.style,
                                    styleSpec: ls,
                                    validateSpec: Dl
                                }), sc;
                            case "geojson":
                                if (sc = An({
                                    key: bt,
                                    value: vt,
                                    valueSpec: ls.source_geojson,
                                    style: ho,
                                    styleSpec: ls,
                                    validateSpec: Dl,
                                    objectElementValidators: km
                                }), vt.cluster) for(const le1 in vt.clusterProperties){
                                    const [ls, ho] = vt.clusterProperties[le1], Dl = "string" == typeof ls ? [
                                        ls,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            le1
                                        ]
                                    ] : ls;
                                    sc.push(...En({
                                        key: `${bt}.${le1}.map`,
                                        value: ho,
                                        expressionContext: "cluster-map"
                                    })), sc.push(...En({
                                        key: `${bt}.${le1}.reduce`,
                                        value: Dl,
                                        expressionContext: "cluster-reduce"
                                    }));
                                }
                                return sc;
                            case "video":
                                return An({
                                    key: bt,
                                    value: vt,
                                    valueSpec: ls.source_video,
                                    style: ho,
                                    validateSpec: Dl,
                                    styleSpec: ls
                                });
                            case "image":
                                return An({
                                    key: bt,
                                    value: vt,
                                    valueSpec: ls.source_image,
                                    style: ho,
                                    validateSpec: Dl,
                                    styleSpec: ls
                                });
                            case "canvas":
                                return [
                                    new M(bt, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                ];
                            default:
                                return Dn({
                                    key: `${bt}.type`,
                                    value: vt.type,
                                    valueSpec: {
                                        values: [
                                            "vector",
                                            "raster",
                                            "raster-dem",
                                            "geojson",
                                            "video",
                                            "image"
                                        ]
                                    }
                                });
                        }
                    }
                    function Nn(le1) {
                        const vt = le1.value, bt = le1.styleSpec, ls = bt.light, ho = le1.style;
                        let Dl = [];
                        const Fl = qr(vt);
                        if (void 0 === vt) return Dl;
                        if ("object" !== Fl) return Dl = Dl.concat([
                            new M("light", vt, `object expected, ${Fl} found`)
                        ]), Dl;
                        for(const sc in vt){
                            const Fl = sc.match(/^(.*)-transition$/);
                            Dl = Dl.concat(Fl && ls[Fl[1]] && ls[Fl[1]].transition ? le1.validateSpec({
                                key: sc,
                                value: vt[sc],
                                valueSpec: bt.transition,
                                validateSpec: le1.validateSpec,
                                style: ho,
                                styleSpec: bt
                            }) : ls[sc] ? le1.validateSpec({
                                key: sc,
                                value: vt[sc],
                                valueSpec: ls[sc],
                                validateSpec: le1.validateSpec,
                                style: ho,
                                styleSpec: bt
                            }) : [
                                new M(sc, vt[sc], `unknown property "${sc}"`)
                            ]);
                        }
                        return Dl;
                    }
                    function $n(le1) {
                        const vt = le1.value, bt = le1.styleSpec, ls = bt.sky, ho = le1.style, Dl = qr(vt);
                        if (void 0 === vt) return [];
                        if ("object" !== Dl) return [
                            new M("sky", vt, `object expected, ${Dl} found`)
                        ];
                        let Fl = [];
                        for(const sc in vt)Fl = Fl.concat(ls[sc] ? le1.validateSpec({
                            key: sc,
                            value: vt[sc],
                            valueSpec: ls[sc],
                            style: ho,
                            styleSpec: bt
                        }) : [
                            new M(sc, vt[sc], `unknown property "${sc}"`)
                        ]);
                        return Fl;
                    }
                    function Un(le1) {
                        const vt = le1.value, bt = le1.styleSpec, ls = bt.terrain, ho = le1.style;
                        let Dl = [];
                        const Fl = qr(vt);
                        if (void 0 === vt) return Dl;
                        if ("object" !== Fl) return Dl = Dl.concat([
                            new M("terrain", vt, `object expected, ${Fl} found`)
                        ]), Dl;
                        for(const sc in vt)Dl = Dl.concat(ls[sc] ? le1.validateSpec({
                            key: sc,
                            value: vt[sc],
                            valueSpec: ls[sc],
                            validateSpec: le1.validateSpec,
                            style: ho,
                            styleSpec: bt
                        }) : [
                            new M(sc, vt[sc], `unknown property "${sc}"`)
                        ]);
                        return Dl;
                    }
                    function qn(le1) {
                        let vt = [];
                        const bt = le1.value, ls = le1.key;
                        if (Array.isArray(bt)) {
                            const ho = [], Dl = [];
                            for(const Fl in bt)bt[Fl].id && ho.includes(bt[Fl].id) && vt.push(new M(ls, bt, `all the sprites' ids must be unique, but ${bt[Fl].id} is duplicated`)), ho.push(bt[Fl].id), bt[Fl].url && Dl.includes(bt[Fl].url) && vt.push(new M(ls, bt, `all the sprites' URLs must be unique, but ${bt[Fl].url} is duplicated`)), Dl.push(bt[Fl].url), vt = vt.concat(An({
                                key: `${ls}[${Fl}]`,
                                value: bt[Fl],
                                valueSpec: {
                                    id: {
                                        type: "string",
                                        required: !0
                                    },
                                    url: {
                                        type: "string",
                                        required: !0
                                    }
                                },
                                validateSpec: le1.validateSpec
                            }));
                            return vt;
                        }
                        return Ln({
                            key: ls,
                            value: bt
                        });
                    }
                    function Gn(le1) {
                        return Boolean(le1) && le1.constructor === Object;
                    }
                    function jn(le1) {
                        return Gn(le1.value) ? [] : [
                            new M(le1.key, le1.value, `object expected, ${qr(le1.value)} found`)
                        ];
                    }
                    const Cm = {
                        "*": ()=>[],
                        array: In,
                        boolean: function(le1) {
                            const vt = le1.value, bt = le1.key, ls = qr(vt);
                            return "boolean" !== ls ? [
                                new M(bt, vt, `boolean expected, ${ls} found`)
                            ] : [];
                        },
                        number: Tn,
                        color: Mn,
                        constants: wn,
                        enum: Dn,
                        filter: Pn,
                        function: kn,
                        layer: Vn,
                        object: An,
                        source: Rn,
                        light: Nn,
                        sky: $n,
                        terrain: Un,
                        projection: function(le1) {
                            const vt = le1.value, bt = le1.styleSpec, ls = bt.projection, ho = le1.style, Dl = qr(vt);
                            if (void 0 === vt) return [];
                            if ("object" !== Dl) return [
                                new M("projection", vt, `object expected, ${Dl} found`)
                            ];
                            let Fl = [];
                            for(const sc in vt)Fl = Fl.concat(ls[sc] ? le1.validateSpec({
                                key: sc,
                                value: vt[sc],
                                valueSpec: ls[sc],
                                style: ho,
                                styleSpec: bt
                            }) : [
                                new M(sc, vt[sc], `unknown property "${sc}"`)
                            ]);
                            return Fl;
                        },
                        projectionDefinition: function(le1) {
                            const vt = le1.key;
                            let bt = le1.value;
                            bt = bt instanceof String ? bt.valueOf() : bt;
                            const ls = qr(bt);
                            return "array" !== ls || function(le1) {
                                return Array.isArray(le1) && 3 === le1.length && "string" == typeof le1[0] && "string" == typeof le1[1] && "number" == typeof le1[2];
                            }(bt) || function(le1) {
                                return !![
                                    "interpolate",
                                    "step",
                                    "literal"
                                ].includes(le1[0]);
                            }(bt) ? [
                                "array",
                                "string"
                            ].includes(ls) ? [] : [
                                new M(vt, bt, `projection expected, invalid type "${ls}" found`)
                            ] : [
                                new M(vt, bt, `projection expected, invalid array ${JSON.stringify(bt)} found`)
                            ];
                        },
                        string: Ln,
                        formatted: function(le1) {
                            return 0 === Ln(le1).length ? [] : En(le1);
                        },
                        resolvedImage: function(le1) {
                            return 0 === Ln(le1).length ? [] : En(le1);
                        },
                        padding: function(le1) {
                            const vt = le1.key, bt = le1.value;
                            if ("array" === qr(bt)) {
                                if (bt.length < 1 || bt.length > 4) return [
                                    new M(vt, bt, `padding requires 1 to 4 values; ${bt.length} values found`)
                                ];
                                const ls = {
                                    type: "number"
                                };
                                let ho = [];
                                for(let Dl = 0; Dl < bt.length; Dl++)ho = ho.concat(le1.validateSpec({
                                    key: `${vt}[${Dl}]`,
                                    value: bt[Dl],
                                    validateSpec: le1.validateSpec,
                                    valueSpec: ls
                                }));
                                return ho;
                            }
                            return Tn({
                                key: vt,
                                value: bt,
                                valueSpec: {}
                            });
                        },
                        numberArray: function(le1) {
                            const vt = le1.key, bt = le1.value;
                            if ("array" === qr(bt)) {
                                const ls = {
                                    type: "number"
                                };
                                if (bt.length < 1) return [
                                    new M(vt, bt, "array length at least 1 expected, length 0 found")
                                ];
                                let ho = [];
                                for(let Dl = 0; Dl < bt.length; Dl++)ho = ho.concat(le1.validateSpec({
                                    key: `${vt}[${Dl}]`,
                                    value: bt[Dl],
                                    validateSpec: le1.validateSpec,
                                    valueSpec: ls
                                }));
                                return ho;
                            }
                            return Tn({
                                key: vt,
                                value: bt,
                                valueSpec: {}
                            });
                        },
                        colorArray: function(le1) {
                            const vt = le1.key, bt = le1.value;
                            if ("array" === qr(bt)) {
                                if (bt.length < 1) return [
                                    new M(vt, bt, "array length at least 1 expected, length 0 found")
                                ];
                                let le1 = [];
                                for(let ls = 0; ls < bt.length; ls++)le1 = le1.concat(Mn({
                                    key: `${vt}[${ls}]`,
                                    value: bt[ls]
                                }));
                                return le1;
                            }
                            return Mn({
                                key: vt,
                                value: bt
                            });
                        },
                        variableAnchorOffsetCollection: function(le1) {
                            const vt = le1.key, bt = le1.value, ls = qr(bt), ho = le1.styleSpec;
                            if ("array" !== ls || bt.length < 1 || bt.length % 2 != 0) return [
                                new M(vt, bt, "variableAnchorOffsetCollection requires a non-empty array of even length")
                            ];
                            let Dl = [];
                            for(let Fl = 0; Fl < bt.length; Fl += 2)Dl = Dl.concat(Dn({
                                key: `${vt}[${Fl}]`,
                                value: bt[Fl],
                                valueSpec: ho.layout_symbol["text-anchor"]
                            })), Dl = Dl.concat(In({
                                key: `${vt}[${Fl + 1}]`,
                                value: bt[Fl + 1],
                                valueSpec: {
                                    length: 2,
                                    value: "number"
                                },
                                validateSpec: le1.validateSpec,
                                style: le1.style,
                                styleSpec: ho
                            }));
                            return Dl;
                        },
                        sprite: qn,
                        state: jn,
                        fontFaces: function(le1) {
                            const vt = le1.key, bt = le1.value, ls = le1.validateSpec, ho = le1.styleSpec, Dl = le1.style;
                            if (!Gn(bt)) return [
                                new M(vt, bt, `object expected, ${qr(bt)} found`)
                            ];
                            const Fl = [];
                            for(const sc in bt){
                                const le1 = bt[sc], uc = qr(le1);
                                if ("string" === uc) Fl.push(...Ln({
                                    key: `${vt}.${sc}`,
                                    value: le1
                                }));
                                else if ("array" === uc) {
                                    const bt = {
                                        url: {
                                            type: "string",
                                            required: !0
                                        },
                                        "unicode-range": {
                                            type: "array",
                                            value: "string"
                                        }
                                    };
                                    for (const [uc, mc] of le1.entries())Fl.push(...An({
                                        key: `${vt}.${sc}[${uc}]`,
                                        value: mc,
                                        valueSpec: bt,
                                        styleSpec: ho,
                                        style: Dl,
                                        validateSpec: ls
                                    }));
                                } else Fl.push(new M(`${vt}.${sc}`, le1, `string or array expected, ${uc} found`));
                            }
                            return Fl;
                        }
                    };
                    function Yn(le1) {
                        const vt = le1.value, bt = le1.valueSpec, ls = le1.styleSpec;
                        return le1.validateSpec = Yn, bt.expression && Gr(_n(vt)) ? kn(le1) : bt.expression && Qr(Sn(vt)) ? En(le1) : bt.type && Cm[bt.type] ? Cm[bt.type](le1) : An(D({}, le1, {
                            valueSpec: bt.type ? ls[bt.type] : bt
                        }));
                    }
                    function Zn(le1) {
                        const vt = le1.value, bt = le1.key, ls = Ln(le1);
                        return ls.length || (-1 === vt.indexOf("{fontstack}") && ls.push(new M(bt, vt, '"glyphs" url must include a "{fontstack}" token')), -1 === vt.indexOf("{range}") && ls.push(new M(bt, vt, '"glyphs" url must include a "{range}" token'))), ls;
                    }
                    function Hn(le1, vt) {
                        void 0 === vt && (vt = Ec);
                        let bt = [];
                        return bt = bt.concat(Yn({
                            key: "",
                            value: le1,
                            valueSpec: vt.$root,
                            styleSpec: vt,
                            style: le1,
                            validateSpec: Yn,
                            objectElementValidators: {
                                glyphs: Zn,
                                "*": ()=>[]
                            }
                        })), le1.constants && (bt = bt.concat(wn({
                            key: "constants",
                            value: le1.constants
                        }))), Jn(bt);
                    }
                    function Wn(le1) {
                        return function(vt) {
                            return le1(Object.assign({}, vt, {
                                validateSpec: Yn
                            }));
                        };
                    }
                    function Jn(le1) {
                        return [].concat(le1).sort((le1, vt)=>le1.line - vt.line);
                    }
                    function Kn(le1) {
                        return function() {
                            for(var vt = arguments.length, bt = new Array(vt), ls = 0; ls < vt; ls++)bt[ls] = arguments[ls];
                            return Jn(le1.apply(this, bt));
                        };
                    }
                    Hn.source = Kn(Wn(Rn)), Hn.sprite = Kn(Wn(qn)), Hn.glyphs = Kn(Wn(Zn)), Hn.light = Kn(Wn(Nn)), Hn.sky = Kn(Wn($n)), Hn.terrain = Kn(Wn(Un)), Hn.state = Kn(Wn(jn)), Hn.layer = Kn(Wn(Vn)), Hn.filter = Kn(Wn(Pn)), Hn.paintProperty = Kn(Wn(Bn)), Hn.layoutProperty = Kn(Wn(Cn));
                    const Im = {
                        type: "enum",
                        "property-type": "data-constant",
                        expression: {
                            interpolated: !1,
                            parameters: [
                                "global-state"
                            ]
                        },
                        values: {
                            visible: {},
                            none: {}
                        },
                        transition: !1,
                        default: "visible"
                    };
                    class ei {
                        constructor(le1, vt){
                            this._globalState = vt, this.setValue(le1);
                        }
                        evaluate() {
                            var le1;
                            return null !== (le1 = this._literalValue) && void 0 !== le1 ? le1 : this._compiledValue.evaluate({});
                        }
                        setValue(le1) {
                            if (null == le1 || "visible" === le1 || "none" === le1) return this._literalValue = "none" === le1 ? "none" : "visible", this._compiledValue = void 0, void (this._globalStateRefs = new Set);
                            const vt = en(le1, Im, this._globalState);
                            if ("error" === vt.result) throw this._literalValue = "visible", this._compiledValue = void 0, new Error(vt.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                            this._literalValue = void 0, this._compiledValue = vt.value, this._globalStateRefs = an(vt.value.expression);
                        }
                        getGlobalStateRefs() {
                            return this._globalStateRefs;
                        }
                    }
                    const Dm = "AbortError";
                    class ri extends Error {
                        constructor(le1){
                            void 0 === le1 && (le1 = Dm), super(le1 instanceof Error ? le1.message : le1), this.name = Dm, le1 instanceof Error && le1.stack && (this.stack = le1.stack);
                        }
                    }
                    function ni(le1) {
                        return le1.name === Dm;
                    }
                    const Lm = {
                        REGISTERED_PROTOCOLS: {}
                    };
                    function si(le1, vt) {
                        Lm.REGISTERED_PROTOCOLS[le1] = vt;
                    }
                    function oi(le1) {
                        delete Lm.REGISTERED_PROTOCOLS[le1];
                    }
                    const Pm = "global-dispatcher";
                    class li extends Error {
                        constructor(le1, vt, bt, ls){
                            super(`AJAXError: ${vt} (${le1}): ${bt}`), this.status = le1, this.statusText = vt, this.url = bt, this.body = ls;
                        }
                    }
                    const ui = ()=>b(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, ci = function(le1, vt) {
                        if (/:\/\//.test(le1.url) && !/^https?:|^file:/.test(le1.url)) {
                            const ls = Lm.REGISTERED_PROTOCOLS[(bt = le1.url).substring(0, bt.indexOf("://"))];
                            if (ls) return ls(le1, vt);
                            if (b(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: le1,
                                targetMapId: Pm
                            }, vt);
                        }
                        var bt;
                        if (!((le1)=>/^file:/.test(le1) || /^file:/.test(ui()) && !/^\w+:/.test(le1))(le1.url)) {
                            if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(le1, vt) {
                                return e(this, void 0, void 0, function*() {
                                    const bt = new Request(le1.url, {
                                        method: le1.method || "GET",
                                        body: le1.body,
                                        credentials: le1.credentials,
                                        headers: le1.headers,
                                        cache: le1.cache,
                                        referrer: ui(),
                                        signal: vt.signal
                                    });
                                    let ls, ho;
                                    "json" !== le1.type || bt.headers.has("Accept") || bt.headers.set("Accept", "application/json");
                                    try {
                                        ls = yield fetch(bt);
                                    } catch (bt) {
                                        if (ni(bt)) throw bt;
                                        throw new li(0, bt.message, le1.url, new Blob);
                                    }
                                    if (!ls.ok) {
                                        const vt = yield ls.blob();
                                        throw new li(ls.status, ls.statusText, le1.url, vt);
                                    }
                                    ho = "arrayBuffer" === le1.type || "image" === le1.type ? ls.arrayBuffer() : "json" === le1.type ? ls.json() : ls.text();
                                    const Dl = yield ho;
                                    return vt.signal.throwIfAborted(), {
                                        data: Dl,
                                        cacheControl: ls.headers.get("Cache-Control"),
                                        expires: ls.headers.get("Expires")
                                    };
                                });
                            }(le1, vt);
                            if (b(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                type: "GR",
                                data: le1,
                                mustQueue: !0,
                                targetMapId: Pm
                            }, vt);
                        }
                        return function(le1, vt) {
                            return new Promise((bt, ls)=>{
                                var ho;
                                const Dl = new XMLHttpRequest;
                                Dl.open(le1.method || "GET", le1.url, !0), "arrayBuffer" !== le1.type && "image" !== le1.type || (Dl.responseType = "arraybuffer");
                                for(const vt in le1.headers)Dl.setRequestHeader(vt, le1.headers[vt]);
                                "json" === le1.type && (Dl.responseType = "text", (null === (ho = le1.headers) || void 0 === ho ? void 0 : ho.Accept) || Dl.setRequestHeader("Accept", "application/json")), Dl.withCredentials = "include" === le1.credentials, Dl.onerror = ()=>{
                                    ls(new Error(Dl.statusText));
                                }, Dl.onload = ()=>{
                                    if (!vt.signal.aborted) {
                                        if ((Dl.status >= 200 && Dl.status < 300 || 0 === Dl.status) && null !== Dl.response) {
                                            let vt = Dl.response;
                                            if ("json" === le1.type) try {
                                                vt = JSON.parse(Dl.response);
                                            } catch (le1) {
                                                return void ls(le1);
                                            }
                                            bt({
                                                data: vt,
                                                cacheControl: Dl.getResponseHeader("Cache-Control"),
                                                expires: Dl.getResponseHeader("Expires")
                                            });
                                        } else {
                                            const vt = new Blob([
                                                Dl.response
                                            ], {
                                                type: Dl.getResponseHeader("Content-Type")
                                            });
                                            ls(new li(Dl.status, Dl.statusText, le1.url, vt));
                                        }
                                    }
                                }, vt.signal.addEventListener("abort", ()=>{
                                    Dl.abort(), ls(new ri(vt.signal.reason));
                                }), Dl.send(le1.body);
                            });
                        }(le1, vt);
                    }, zm = {};
                    function pi(le1, vt, bt) {
                        if (void 0 === bt && (bt = {}), zm[le1]) throw new Error(`${le1} is already registered.`);
                        Object.defineProperty(vt, "_classRegistryKey", {
                            value: le1,
                            writeable: !1
                        }), zm[le1] = {
                            klass: vt,
                            omit: bt.omit || [],
                            shallow: bt.shallow || []
                        };
                    }
                    pi("Object", Object), pi("Set", Set), pi("TransferableGridIndex", T), pi("Color", Ie), pi("Error", Error), pi("AJAXError", li), pi("ResolvedImage", Ve), pi("StylePropertyFunction", sn), pi("StyleExpression", Kr, {
                        omit: [
                            "_evaluator"
                        ]
                    }), pi("ZoomDependentExpression", rn), pi("ZoomConstantExpression", tn), pi("CompoundExpression", Mr, {
                        omit: [
                            "_evaluate"
                        ]
                    });
                    for(const PA in Sm)Sm[PA]._classRegistryKey || pi(`Expression_${PA}`, Sm[PA]);
                    function fi(le1) {
                        return le1 && "undefined" != typeof ArrayBuffer && (le1 instanceof ArrayBuffer || le1.constructor && "ArrayBuffer" === le1.constructor.name);
                    }
                    function di(le1) {
                        return le1.$name || le1.constructor._classRegistryKey;
                    }
                    function yi(le1) {
                        return !function(le1) {
                            if (null === le1 || "object" != typeof le1) return !1;
                            const vt = di(le1);
                            return !(!vt || "Object" === vt);
                        }(le1) && (null == le1 || "boolean" == typeof le1 || "number" == typeof le1 || "string" == typeof le1 || le1 instanceof Boolean || le1 instanceof Number || le1 instanceof String || le1 instanceof Date || le1 instanceof RegExp || le1 instanceof Blob || le1 instanceof Error || fi(le1) || w(le1) || ArrayBuffer.isView(le1) || le1 instanceof ImageData);
                    }
                    function mi(le1, vt) {
                        if (yi(le1)) return (fi(le1) || w(le1)) && vt && vt.push(le1), ArrayBuffer.isView(le1) && vt && vt.push(le1.buffer), le1 instanceof ImageData && vt && vt.push(le1.data.buffer), le1;
                        if (Array.isArray(le1)) {
                            const bt = [];
                            for (const ls of le1)bt.push(mi(ls, vt));
                            return bt;
                        }
                        if ("object" != typeof le1) throw new Error("can't serialize object of type " + typeof le1);
                        const bt = di(le1);
                        if (!bt) throw new Error(`can't serialize object of unregistered class ${le1.constructor.name}`);
                        if (!zm[bt]) throw new Error(`${bt} is not registered.`);
                        const { klass: ls } = zm[bt], ho = ls.serialize ? ls.serialize(le1, vt) : {};
                        if (ls.serialize) {
                            if (vt && ho === vt[vt.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                        } else {
                            for(const ls in le1){
                                if (!le1.hasOwnProperty(ls)) continue;
                                if (zm[bt].omit.indexOf(ls) >= 0) continue;
                                const Dl = le1[ls];
                                ho[ls] = zm[bt].shallow.indexOf(ls) >= 0 ? Dl : mi(Dl, vt);
                            }
                            le1 instanceof Error && (ho.message = le1.message);
                        }
                        if (ho.$name) throw new Error("$name property is reserved for worker serialization logic.");
                        return "Object" !== bt && (ho.$name = bt), ho;
                    }
                    function gi(le1) {
                        if (yi(le1)) return le1;
                        if (Array.isArray(le1)) return le1.map(gi);
                        if ("object" != typeof le1) throw new Error("can't deserialize object of type " + typeof le1);
                        const vt = di(le1) || "Object";
                        if (!zm[vt]) throw new Error(`can't deserialize unregistered class ${vt}`);
                        const { klass: bt } = zm[vt];
                        if (!bt) throw new Error(`can't deserialize unregistered class ${vt}`);
                        if (bt.deserialize) return bt.deserialize(le1);
                        const ls = Object.create(bt.prototype);
                        for (const ho of Object.keys(le1)){
                            if ("$name" === ho) continue;
                            const bt = le1[ho];
                            ls[ho] = zm[vt].shallow.indexOf(ho) >= 0 ? bt : gi(bt);
                        }
                        return ls;
                    }
                    class xi {
                        constructor(le1){
                            this._methodToThrottle = le1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                this._triggered = !1, this._methodToThrottle();
                            });
                        }
                        trigger() {
                            this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                this._triggered = !1, this._methodToThrottle();
                            }, 0));
                        }
                        remove() {
                            delete this._channel, this._methodToThrottle = ()=>{};
                        }
                    }
                    const Nm = {
                        once: !0
                    };
                    class bi {
                        constructor(le1, vt){
                            this.target = le1, this.mapId = vt, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new xi(()=>this.process()), this.subscription = A(this.target, "message", (le1)=>this.receive(le1), !1), this.globalScope = b(self) ? le1 : window;
                        }
                        registerMessageHandler(le1, vt) {
                            this.messageHandlers[le1] = vt;
                        }
                        unregisterMessageHandler(le1) {
                            delete this.messageHandlers[le1];
                        }
                        sendAsync(le1, vt) {
                            return new Promise((bt, ls)=>{
                                const ho = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), Dl = vt ? A(vt.signal, "abort", ()=>{
                                    null == Dl || Dl.unsubscribe(), delete this.resolveRejects[ho];
                                    const vt = {
                                        id: ho,
                                        type: "<cancel>",
                                        origin: location.origin,
                                        targetMapId: le1.targetMapId,
                                        sourceMapId: this.mapId
                                    };
                                    this.target.postMessage(vt);
                                }, Nm) : null;
                                this.resolveRejects[ho] = {
                                    resolve: (le1)=>{
                                        null == Dl || Dl.unsubscribe(), bt(le1);
                                    },
                                    reject: (le1)=>{
                                        null == Dl || Dl.unsubscribe(), ls(le1);
                                    }
                                };
                                const Fl = [], sc = Object.assign(Object.assign({}, le1), {
                                    id: ho,
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    data: mi(le1.data, Fl)
                                });
                                this.target.postMessage(sc, {
                                    transfer: Fl
                                });
                            });
                        }
                        receive(le1) {
                            const vt = le1.data, bt = vt.id;
                            if (!("file://" !== vt.origin && "file://" !== location.origin && "resource://android" !== vt.origin && "resource://android" !== location.origin && vt.origin !== location.origin || vt.targetMapId && this.mapId !== vt.targetMapId)) {
                                if ("<cancel>" === vt.type) {
                                    delete this.tasks[bt];
                                    const le1 = this.abortControllers[bt];
                                    return delete this.abortControllers[bt], void (le1 && le1.abort());
                                }
                                if (b(self) || vt.mustQueue) return this.tasks[bt] = vt, this.taskQueue.push(bt), void this.invoker.trigger();
                                this.processTask(bt, vt);
                            }
                        }
                        process() {
                            if (0 === this.taskQueue.length) return;
                            const le1 = this.taskQueue.shift(), vt = this.tasks[le1];
                            delete this.tasks[le1], this.taskQueue.length > 0 && this.invoker.trigger(), vt && this.processTask(le1, vt);
                        }
                        processTask(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                if ("<response>" === vt.type) {
                                    const bt = this.resolveRejects[le1];
                                    if (delete this.resolveRejects[le1], !bt) return;
                                    return void (vt.error ? bt.reject(gi(vt.error)) : bt.resolve(gi(vt.data)));
                                }
                                if (!this.messageHandlers[vt.type]) return void this.completeTask(le1, new Error(`Could not find a registered handler for ${vt.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                const bt = gi(vt.data), ls = new AbortController;
                                this.abortControllers[le1] = ls;
                                try {
                                    const ho = yield this.messageHandlers[vt.type](vt.sourceMapId, bt, ls);
                                    this.completeTask(le1, null, ho);
                                } catch (bt) {
                                    this.completeTask(le1, bt);
                                }
                            });
                        }
                        completeTask(le1, vt, bt) {
                            const ls = [];
                            delete this.abortControllers[le1];
                            const ho = {
                                id: le1,
                                type: "<response>",
                                sourceMapId: this.mapId,
                                origin: location.origin,
                                error: vt ? mi(vt) : null,
                                data: mi(bt, ls)
                            };
                            this.target.postMessage(ho, {
                                transfer: ls
                            });
                        }
                        remove() {
                            this.invoker.remove(), this.subscription.unsubscribe();
                        }
                    }
                    function wi(le1, vt, bt) {
                        bt[le1] && -1 !== bt[le1].indexOf(vt) || (bt[le1] = bt[le1] || [], bt[le1].push(vt));
                    }
                    function _i(le1, vt, bt) {
                        if (bt && bt[le1]) {
                            const ls = bt[le1].indexOf(vt);
                            -1 !== ls && bt[le1].splice(ls, 1);
                        }
                    }
                    class Si {
                        constructor(le1, vt){
                            void 0 === vt && (vt = {}), d(this, vt), this.type = le1;
                        }
                    }
                    class Ai extends Si {
                        constructor(le1, vt){
                            void 0 === vt && (vt = {}), super("error", d({
                                error: le1
                            }, vt));
                        }
                    }
                    class Ii {
                        on(le1, vt) {
                            return this._listeners = this._listeners || {}, wi(le1, vt, this._listeners), {
                                unsubscribe: ()=>{
                                    this.off(le1, vt);
                                }
                            };
                        }
                        off(le1, vt) {
                            return _i(le1, vt, this._listeners), _i(le1, vt, this._oneTimeListeners), this;
                        }
                        once(le1, vt) {
                            return vt ? (this._oneTimeListeners = this._oneTimeListeners || {}, wi(le1, vt, this._oneTimeListeners), this) : new Promise((vt)=>this.once(le1, vt));
                        }
                        fire(le1, vt) {
                            "string" == typeof le1 && (le1 = new Si(le1, vt || {}));
                            const bt = le1.type;
                            if (this.listens(bt)) {
                                le1.target = this;
                                const vt = this._listeners && this._listeners[bt] ? this._listeners[bt].slice() : [];
                                for (const bt of vt)bt.call(this, le1);
                                const ls = this._oneTimeListeners && this._oneTimeListeners[bt] ? this._oneTimeListeners[bt].slice() : [];
                                for (const Dl of ls)_i(bt, Dl, this._oneTimeListeners), Dl.call(this, le1);
                                const ho = this._eventedParent;
                                ho && (d(le1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), ho.fire(le1));
                            } else le1 instanceof Ai && console.error(le1.error);
                            return this;
                        }
                        listens(le1) {
                            return this._listeners && this._listeners[le1] && this._listeners[le1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[le1] && this._oneTimeListeners[le1].length > 0 || this._eventedParent && this._eventedParent.listens(le1);
                        }
                        setEventedParent(le1, vt) {
                            return this._eventedParent = le1, this._eventedParentData = vt, this;
                        }
                    }
                    const Rm = Hn, Fm = Rm.paintProperty, Om = Rm.layoutProperty;
                    class Mi {
                        constructor(){
                            this.first = !0;
                        }
                        update(le1, vt) {
                            const bt = Math.floor(le1);
                            return this.first ? (this.first = !1, this.lastIntegerZoom = bt, this.lastIntegerZoomTime = 0, this.lastZoom = le1, this.lastFloorZoom = bt, !0) : (this.lastFloorZoom > bt ? (this.lastIntegerZoom = bt + 1, this.lastIntegerZoomTime = vt) : this.lastFloorZoom < bt && (this.lastIntegerZoom = bt, this.lastIntegerZoomTime = vt), le1 !== this.lastZoom && (this.lastZoom = le1, this.lastFloorZoom = bt, !0));
                        }
                    }
                    function Di(le1) {
                        return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(le1));
                    }
                    function Pi(le1) {
                        return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(le1));
                    }
                    function zi(le1) {
                        return /\s/u.test(String.fromCodePoint(le1));
                    }
                    function Fi(le1) {
                        for (const vt of le1)if (Pi(vt.codePointAt(0))) return !0;
                        return !1;
                    }
                    function Bi(le1) {
                        for (const vt of le1)if (!Li(vt.codePointAt(0))) return !1;
                        return !0;
                    }
                    function Ci(le1) {
                        const vt = le1.map((le1)=>{
                            try {
                                return new RegExp(`\\p{sc=${le1}}`, "u").source;
                            } catch (le1) {
                                return null;
                            }
                        }).filter((le1)=>le1);
                        return new RegExp(vt.join("|"), "u");
                    }
                    const Bm = Ci([
                        "Arab",
                        "Dupl",
                        "Mong",
                        "Ougr",
                        "Syrc"
                    ]);
                    function Li(le1) {
                        return !Bm.test(String.fromCodePoint(le1));
                    }
                    function Oi(le1) {
                        var vt;
                        return !(Pi(le1) || (vt = le1, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(vt))));
                    }
                    const jm = Ci([
                        "Adlm",
                        "Arab",
                        "Armi",
                        "Avst",
                        "Chrs",
                        "Cprt",
                        "Egyp",
                        "Elym",
                        "Gara",
                        "Hatr",
                        "Hebr",
                        "Hung",
                        "Khar",
                        "Lydi",
                        "Mand",
                        "Mani",
                        "Mend",
                        "Merc",
                        "Mero",
                        "Narb",
                        "Nbat",
                        "Nkoo",
                        "Orkh",
                        "Palm",
                        "Phli",
                        "Phlp",
                        "Phnx",
                        "Prti",
                        "Rohg",
                        "Samr",
                        "Sarb",
                        "Sogo",
                        "Syrc",
                        "Thaa",
                        "Todr",
                        "Yezi"
                    ]);
                    function Ni(le1) {
                        return jm.test(String.fromCodePoint(le1));
                    }
                    function $i(le1, vt) {
                        return !(!vt && Ni(le1) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(le1)));
                    }
                    function Ui(le1) {
                        for (const vt of le1)if (Ni(vt.codePointAt(0))) return !0;
                        return !1;
                    }
                    const Um = new class {
                        constructor(){
                            this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
                        }
                        setState(le1) {
                            this.pluginStatus = le1.pluginStatus, this.pluginURL = le1.pluginURL;
                        }
                        getState() {
                            return {
                                pluginStatus: this.pluginStatus,
                                pluginURL: this.pluginURL
                            };
                        }
                        setMethods(le1) {
                            if (Um.isParsed()) throw new Error("RTL text plugin already registered.");
                            this.applyArabicShaping = le1.applyArabicShaping, this.processBidirectionalText = le1.processBidirectionalText, this.processStyledBidirectionalText = le1.processStyledBidirectionalText, this.loadScriptResolve();
                        }
                        isParsed() {
                            return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                        }
                        getRTLTextPluginStatus() {
                            return this.pluginStatus;
                        }
                        syncState(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                if (this.isParsed()) return this.getState();
                                if ("loading" !== le1.pluginStatus) return this.setState(le1), le1;
                                const bt = le1.pluginURL, ls = new Promise((le1)=>{
                                    this.loadScriptResolve = le1;
                                });
                                vt(bt);
                                const ho = new Promise((le1)=>setTimeout(()=>le1(), this.TIMEOUT));
                                if (yield Promise.race([
                                    ls,
                                    ho
                                ]), this.isParsed()) {
                                    const le1 = {
                                        pluginStatus: "loaded",
                                        pluginURL: bt
                                    };
                                    return this.setState(le1), le1;
                                }
                                throw this.setState({
                                    pluginStatus: "error",
                                    pluginURL: ""
                                }), new Error(`RTL Text Plugin failed to import scripts from ${bt}`);
                            });
                        }
                    };
                    class Gi {
                        constructor(le1, vt){
                            this.isSupportedScript = ji, this.zoom = le1, vt ? (this.now = vt.now || 0, this.fadeDuration = vt.fadeDuration || 0, this.zoomHistory = vt.zoomHistory || new Mi, this.transition = vt.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new Mi, this.transition = {});
                        }
                        crossFadingFactor() {
                            return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                        }
                        getCrossfadeParameters() {
                            const le1 = this.zoom, vt = le1 - Math.floor(le1), bt = this.crossFadingFactor();
                            return le1 > this.zoomHistory.lastIntegerZoom ? {
                                fromScale: 2,
                                toScale: 1,
                                t: vt + (1 - vt) * bt
                            } : {
                                fromScale: .5,
                                toScale: 1,
                                t: 1 - (1 - bt) * vt
                            };
                        }
                    }
                    function ji(le1) {
                        return function(le1, vt) {
                            for (const bt of le1)if (!$i(bt.codePointAt(0), vt)) return !1;
                            return !0;
                        }(le1, "loaded" === Um.getRTLTextPluginStatus());
                    }
                    const Vm = "-transition";
                    class Yi {
                        constructor(le1, vt, bt){
                            this.property = le1, this.value = vt, this.expression = function(le1, vt, bt) {
                                if (Gr(le1)) return new sn(le1, vt);
                                if (Qr(le1)) {
                                    const ls = nn(le1, vt, bt);
                                    if ("error" === ls.result) throw new Error(ls.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                                    return ls.value;
                                }
                                {
                                    let bt = le1;
                                    return "color" === vt.type && "string" == typeof le1 ? bt = Ie.parse(le1) : "padding" !== vt.type || "number" != typeof le1 && !Array.isArray(le1) ? "numberArray" !== vt.type || "number" != typeof le1 && !Array.isArray(le1) ? "colorArray" !== vt.type || "string" != typeof le1 && !Array.isArray(le1) ? "variableAnchorOffsetCollection" === vt.type && Array.isArray(le1) ? bt = Ce.parse(le1) : "projectionDefinition" === vt.type && "string" == typeof le1 && (bt = Le.parse(le1)) : bt = ze.parse(le1) : bt = Pe.parse(le1) : bt = De.parse(le1), {
                                        globalStateRefs: new Set,
                                        _globalState: null,
                                        kind: "constant",
                                        evaluate: ()=>bt
                                    };
                                }
                            }(void 0 === vt ? le1.specification.default : vt, le1.specification, bt);
                        }
                        isDataDriven() {
                            return "source" === this.expression.kind || "composite" === this.expression.kind;
                        }
                        getGlobalStateRefs() {
                            return this.expression.globalStateRefs || new Set;
                        }
                        possiblyEvaluate(le1, vt, bt) {
                            return this.property.possiblyEvaluate(this, le1, vt, bt);
                        }
                    }
                    class Zi {
                        constructor(le1, vt){
                            this.property = le1, this.value = new Yi(le1, void 0, vt);
                        }
                        transitioned(le1, vt) {
                            return new Wi(this.property, this.value, vt, d({}, le1.transition, this.transition), le1.now);
                        }
                        untransitioned() {
                            return new Wi(this.property, this.value, null, {}, 0);
                        }
                    }
                    class Hi {
                        constructor(le1, vt){
                            this._properties = le1, this._values = Object.create(le1.defaultTransitionablePropertyValues), this._globalState = vt;
                        }
                        getValue(le1) {
                            return m(this._values[le1].value.value);
                        }
                        setValue(le1, vt) {
                            Object.prototype.hasOwnProperty.call(this._values, le1) || (this._values[le1] = new Zi(this._values[le1].property, this._globalState)), this._values[le1].value = new Yi(this._values[le1].property, null === vt ? void 0 : m(vt), this._globalState);
                        }
                        getTransition(le1) {
                            return m(this._values[le1].transition);
                        }
                        setTransition(le1, vt) {
                            Object.prototype.hasOwnProperty.call(this._values, le1) || (this._values[le1] = new Zi(this._values[le1].property, this._globalState)), this._values[le1].transition = m(vt) || void 0;
                        }
                        serialize() {
                            const le1 = {};
                            for (const vt of Object.keys(this._values)){
                                const bt = this.getValue(vt);
                                void 0 !== bt && (le1[vt] = bt);
                                const ls = this.getTransition(vt);
                                void 0 !== ls && (le1[`${vt}${Vm}`] = ls);
                            }
                            return le1;
                        }
                        transitioned(le1, vt) {
                            const bt = new Ji(this._properties);
                            for (const ls of Object.keys(this._values))bt._values[ls] = this._values[ls].transitioned(le1, vt._values[ls]);
                            return bt;
                        }
                        untransitioned() {
                            const le1 = new Ji(this._properties);
                            for (const vt of Object.keys(this._values))le1._values[vt] = this._values[vt].untransitioned();
                            return le1;
                        }
                    }
                    class Wi {
                        constructor(le1, vt, bt, ls, ho){
                            this.property = le1, this.value = vt, this.begin = ho + ls.delay || 0, this.end = this.begin + ls.duration || 0, le1.specification.transition && (ls.delay || ls.duration) && (this.prior = bt);
                        }
                        possiblyEvaluate(le1, vt, bt) {
                            const ls = le1.now || 0, ho = this.value.possiblyEvaluate(le1, vt, bt), Dl = this.prior;
                            if (Dl) {
                                if (ls > this.end) return this.prior = null, ho;
                                if (this.value.isDataDriven()) return this.prior = null, ho;
                                if (ls < this.begin) return Dl.possiblyEvaluate(le1, vt, bt);
                                {
                                    const Fl = (ls - this.begin) / (this.end - this.begin);
                                    return this.property.interpolate(Dl.possiblyEvaluate(le1, vt, bt), ho, function(le1) {
                                        if (le1 <= 0) return 0;
                                        if (le1 >= 1) return 1;
                                        const vt = le1 * le1, bt = vt * le1;
                                        return 4 * (le1 < .5 ? bt : 3 * (le1 - vt) + bt - .75);
                                    }(Fl));
                                }
                            }
                            return ho;
                        }
                    }
                    class Ji {
                        constructor(le1){
                            this._properties = le1, this._values = Object.create(le1.defaultTransitioningPropertyValues);
                        }
                        possiblyEvaluate(le1, vt, bt) {
                            const ls = new es(this._properties);
                            for (const ho of Object.keys(this._values))ls._values[ho] = this._values[ho].possiblyEvaluate(le1, vt, bt);
                            return ls;
                        }
                        hasTransition() {
                            for (const le1 of Object.keys(this._values))if (this._values[le1].prior) return !0;
                            return !1;
                        }
                    }
                    class Ki {
                        constructor(le1, vt){
                            this._properties = le1, this._values = Object.create(le1.defaultPropertyValues), this._globalState = vt;
                        }
                        hasValue(le1) {
                            return void 0 !== this._values[le1].value;
                        }
                        getValue(le1) {
                            return m(this._values[le1].value);
                        }
                        setValue(le1, vt) {
                            this._values[le1] = new Yi(this._values[le1].property, null === vt ? void 0 : m(vt), this._globalState);
                        }
                        serialize() {
                            const le1 = {};
                            for (const vt of Object.keys(this._values)){
                                const bt = this.getValue(vt);
                                void 0 !== bt && (le1[vt] = bt);
                            }
                            return le1;
                        }
                        possiblyEvaluate(le1, vt, bt) {
                            const ls = new es(this._properties);
                            for (const ho of Object.keys(this._values))ls._values[ho] = this._values[ho].possiblyEvaluate(le1, vt, bt);
                            return ls;
                        }
                    }
                    class Qi {
                        constructor(le1, vt, bt){
                            this.property = le1, this.value = vt, this.parameters = bt;
                        }
                        isConstant() {
                            return "constant" === this.value.kind;
                        }
                        constantOr(le1) {
                            return "constant" === this.value.kind ? this.value.value : le1;
                        }
                        evaluate(le1, vt, bt, ls) {
                            return this.property.evaluate(this.value, this.parameters, le1, vt, bt, ls);
                        }
                    }
                    class es {
                        constructor(le1){
                            this._properties = le1, this._values = Object.create(le1.defaultPossiblyEvaluatedValues);
                        }
                        get(le1) {
                            return this._values[le1];
                        }
                    }
                    class ts {
                        constructor(le1){
                            this.specification = le1;
                        }
                        possiblyEvaluate(le1, vt) {
                            if (le1.isDataDriven()) throw new Error("Value should not be data driven");
                            return le1.expression.evaluate(vt);
                        }
                        interpolate(le1, vt, bt) {
                            const ls = mm[this.specification.type];
                            return ls ? ls(le1, vt, bt) : le1;
                        }
                    }
                    class rs {
                        constructor(le1, vt){
                            this.specification = le1, this.overrides = vt;
                        }
                        possiblyEvaluate(le1, vt, bt, ls) {
                            return new Qi(this, "constant" === le1.expression.kind || "camera" === le1.expression.kind ? {
                                kind: "constant",
                                value: le1.expression.evaluate(vt, null, {}, bt, ls)
                            } : le1.expression, vt);
                        }
                        interpolate(le1, vt, bt) {
                            if ("constant" !== le1.value.kind || "constant" !== vt.value.kind) return le1;
                            if (void 0 === le1.value.value || void 0 === vt.value.value) return new Qi(this, {
                                kind: "constant",
                                value: void 0
                            }, le1.parameters);
                            const ls = mm[this.specification.type];
                            if (ls) {
                                const ho = ls(le1.value.value, vt.value.value, bt);
                                return new Qi(this, {
                                    kind: "constant",
                                    value: ho
                                }, le1.parameters);
                            }
                            return le1;
                        }
                        evaluate(le1, vt, bt, ls, ho, Dl) {
                            return "constant" === le1.kind ? le1.value : le1.evaluate(vt, bt, ls, ho, Dl);
                        }
                    }
                    class ns extends rs {
                        possiblyEvaluate(le1, vt, bt, ls) {
                            if (void 0 === le1.value) return new Qi(this, {
                                kind: "constant",
                                value: void 0
                            }, vt);
                            if ("constant" === le1.expression.kind) {
                                const ho = le1.expression.evaluate(vt, null, {}, bt, ls), Dl = "resolvedImage" === le1.property.specification.type && "string" != typeof ho ? ho.name : ho, Fl = this._calculate(Dl, Dl, Dl, vt);
                                return new Qi(this, {
                                    kind: "constant",
                                    value: Fl
                                }, vt);
                            }
                            if ("camera" === le1.expression.kind) {
                                const bt = this._calculate(le1.expression.evaluate({
                                    zoom: vt.zoom - 1
                                }), le1.expression.evaluate({
                                    zoom: vt.zoom
                                }), le1.expression.evaluate({
                                    zoom: vt.zoom + 1
                                }), vt);
                                return new Qi(this, {
                                    kind: "constant",
                                    value: bt
                                }, vt);
                            }
                            return new Qi(this, le1.expression, vt);
                        }
                        evaluate(le1, vt, bt, ls, ho, Dl) {
                            if ("source" === le1.kind) {
                                const Fl = le1.evaluate(vt, bt, ls, ho, Dl);
                                return this._calculate(Fl, Fl, Fl, vt);
                            }
                            return "composite" === le1.kind ? this._calculate(le1.evaluate({
                                zoom: Math.floor(vt.zoom) - 1
                            }, bt, ls), le1.evaluate({
                                zoom: Math.floor(vt.zoom)
                            }, bt, ls), le1.evaluate({
                                zoom: Math.floor(vt.zoom) + 1
                            }, bt, ls), vt) : le1.value;
                        }
                        _calculate(le1, vt, bt, ls) {
                            return ls.zoom > ls.zoomHistory.lastIntegerZoom ? {
                                from: le1,
                                to: vt
                            } : {
                                from: bt,
                                to: vt
                            };
                        }
                        interpolate(le1) {
                            return le1;
                        }
                    }
                    class is {
                        constructor(le1){
                            this.specification = le1;
                        }
                        possiblyEvaluate(le1, vt, bt, ls) {
                            if (void 0 !== le1.value) {
                                if ("constant" === le1.expression.kind) {
                                    const ho = le1.expression.evaluate(vt, null, {}, bt, ls);
                                    return this._calculate(ho, ho, ho, vt);
                                }
                                return this._calculate(le1.expression.evaluate(new Gi(Math.floor(vt.zoom - 1), vt)), le1.expression.evaluate(new Gi(Math.floor(vt.zoom), vt)), le1.expression.evaluate(new Gi(Math.floor(vt.zoom + 1), vt)), vt);
                            }
                        }
                        _calculate(le1, vt, bt, ls) {
                            return ls.zoom > ls.zoomHistory.lastIntegerZoom ? {
                                from: le1,
                                to: vt
                            } : {
                                from: bt,
                                to: vt
                            };
                        }
                        interpolate(le1) {
                            return le1;
                        }
                    }
                    class ss {
                        constructor(le1){
                            this.specification = le1;
                        }
                        possiblyEvaluate(le1, vt, bt, ls) {
                            return !!le1.expression.evaluate(vt, null, {}, bt, ls);
                        }
                        interpolate() {
                            return !1;
                        }
                    }
                    class os {
                        constructor(le1){
                            this.properties = le1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                            for(const vt in le1){
                                const bt = le1[vt];
                                bt.specification.overridable && this.overridableProperties.push(vt);
                                const ls = this.defaultPropertyValues[vt] = new Yi(bt, void 0, void 0), ho = this.defaultTransitionablePropertyValues[vt] = new Zi(bt, void 0);
                                this.defaultTransitioningPropertyValues[vt] = ho.untransitioned(), this.defaultPossiblyEvaluatedValues[vt] = ls.possiblyEvaluate({});
                            }
                        }
                    }
                    pi("DataDrivenProperty", rs), pi("DataConstantProperty", ts), pi("CrossFadedDataDrivenProperty", ns), pi("CrossFadedProperty", is), pi("ColorRampProperty", ss);
                    class as extends Ii {
                        constructor(le1, vt, bt){
                            if (super(), this.id = le1.id, this.type = le1.type, this._globalState = bt, this._featureFilter = {
                                filter: ()=>!0,
                                needGeometry: !1,
                                getGlobalStateRefs: ()=>new Set
                            }, this._visibilityExpression = function(le1, vt) {
                                return new ei(le1, vt);
                            }(this.visibility, bt), "custom" !== le1.type && (this.metadata = le1.metadata, this.minzoom = le1.minzoom, this.maxzoom = le1.maxzoom, "background" !== le1.type && (this.source = le1.source, this.sourceLayer = le1["source-layer"], this.filter = le1.filter, this._featureFilter = hn(le1.filter, bt)), vt.layout && (this._unevaluatedLayout = new Ki(vt.layout, bt)), vt.paint)) {
                                this._transitionablePaint = new Hi(vt.paint, bt);
                                for(const vt in le1.paint)this.setPaintProperty(vt, le1.paint[vt], {
                                    validate: !1
                                });
                                for(const vt in le1.layout)this.setLayoutProperty(vt, le1.layout[vt], {
                                    validate: !1
                                });
                                this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new es(vt.paint);
                            }
                        }
                        setFilter(le1) {
                            this.filter = le1, this._featureFilter = hn(le1, this._globalState);
                        }
                        getCrossfadeParameters() {
                            return this._crossfadeParameters;
                        }
                        getLayoutProperty(le1) {
                            return "visibility" === le1 ? this.visibility : this._unevaluatedLayout.getValue(le1);
                        }
                        getLayoutAffectingGlobalStateRefs() {
                            const le1 = new Set;
                            for (const vt of this._visibilityExpression.getGlobalStateRefs())le1.add(vt);
                            if (this._unevaluatedLayout) for(const vt in this._unevaluatedLayout._values){
                                const bt = this._unevaluatedLayout._values[vt];
                                for (const vt of bt.getGlobalStateRefs())le1.add(vt);
                            }
                            for (const vt of this._featureFilter.getGlobalStateRefs())le1.add(vt);
                            return le1;
                        }
                        getPaintAffectingGlobalStateRefs() {
                            var le1;
                            const vt = new globalThis.Map;
                            if (this._transitionablePaint) for(const bt in this._transitionablePaint._values){
                                const ls = this._transitionablePaint._values[bt].value;
                                for (const ho of ls.getGlobalStateRefs()){
                                    const Dl = null !== (le1 = vt.get(ho)) && void 0 !== le1 ? le1 : [];
                                    Dl.push({
                                        name: bt,
                                        value: ls.value
                                    }), vt.set(ho, Dl);
                                }
                            }
                            return vt;
                        }
                        getVisibilityAffectingGlobalStateRefs() {
                            return this._visibilityExpression.getGlobalStateRefs();
                        }
                        setLayoutProperty(le1, vt, bt) {
                            if (void 0 === bt && (bt = {}), null == vt || !this._validate(Om, `layers.${this.id}.layout.${le1}`, le1, vt, bt)) return "visibility" === le1 ? (this.visibility = vt, this._visibilityExpression.setValue(vt), void this.recalculateVisibility()) : void this._unevaluatedLayout.setValue(le1, vt);
                        }
                        getPaintProperty(le1) {
                            return le1.endsWith(Vm) ? this._transitionablePaint.getTransition(le1.slice(0, -11)) : this._transitionablePaint.getValue(le1);
                        }
                        setPaintProperty(le1, vt, bt) {
                            if (void 0 === bt && (bt = {}), null != vt && this._validate(Fm, `layers.${this.id}.paint.${le1}`, le1, vt, bt)) return !1;
                            if (le1.endsWith(Vm)) return this._transitionablePaint.setTransition(le1.slice(0, -11), vt || void 0), !1;
                            {
                                const bt = this._transitionablePaint._values[le1], ls = "cross-faded-data-driven" === bt.property.specification["property-type"], ho = bt.value.isDataDriven(), Dl = bt.value;
                                this._transitionablePaint.setValue(le1, vt), this._handleSpecialPaintPropertyUpdate(le1);
                                const Fl = this._transitionablePaint._values[le1].value;
                                return Fl.isDataDriven() || ho || ls || this._handleOverridablePaintPropertyUpdate(le1, Dl, Fl);
                            }
                        }
                        _handleSpecialPaintPropertyUpdate(le1) {}
                        _handleOverridablePaintPropertyUpdate(le1, vt, bt) {
                            return !1;
                        }
                        isHidden(le1, vt) {
                            return void 0 === le1 && (le1 = this.minzoom), void 0 === vt && (vt = !1), !!(this.minzoom && le1 < (vt ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && le1 >= this.maxzoom) || "none" === this._evaluatedVisibility;
                        }
                        updateTransitions(le1) {
                            this._transitioningPaint = this._transitionablePaint.transitioned(le1, this._transitioningPaint);
                        }
                        hasTransition() {
                            return this._transitioningPaint.hasTransition();
                        }
                        recalculateVisibility() {
                            this._evaluatedVisibility = this._visibilityExpression.evaluate();
                        }
                        recalculate(le1, vt) {
                            le1.getCrossfadeParameters && (this._crossfadeParameters = le1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(le1, void 0, vt)), this.paint = this._transitioningPaint.possiblyEvaluate(le1, void 0, vt);
                        }
                        serialize() {
                            const le1 = {
                                id: this.id,
                                type: this.type,
                                source: this.source,
                                "source-layer": this.sourceLayer,
                                metadata: this.metadata,
                                minzoom: this.minzoom,
                                maxzoom: this.maxzoom,
                                filter: this.filter,
                                layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                paint: this._transitionablePaint && this._transitionablePaint.serialize()
                            };
                            return this.visibility && (le1.layout = le1.layout || {}, le1.layout.visibility = this.visibility), function(le1, vt) {
                                const bt = {};
                                for(const ls in le1)vt.call(this, le1[ls], ls, le1) && (bt[ls] = le1[ls]);
                                return bt;
                            }(le1, (le1, vt)=>!(void 0 === le1 || "layout" === vt && !Object.keys(le1).length || "paint" === vt && !Object.keys(le1).length));
                        }
                        _validate(le1, vt, bt, ls, ho) {
                            return void 0 === ho && (ho = {}), (!ho || !1 !== ho.validate) && function(le1, vt) {
                                let bt = !1;
                                if (vt && vt.length) for (const ls of vt)le1.fire(new Ai(new Error(ls.message))), bt = !0;
                                return bt;
                            }(this, le1.call(Rm, {
                                key: vt,
                                layerType: this.type,
                                objectKey: bt,
                                value: ls,
                                styleSpec: Ec,
                                style: {
                                    glyphs: !0,
                                    sprite: !0
                                }
                            }));
                        }
                        is3D() {
                            return !1;
                        }
                        isTileClipped() {
                            return !1;
                        }
                        hasOffscreenPass() {
                            return !1;
                        }
                        resize() {}
                        isStateDependent() {
                            for(const le1 in this.paint._values){
                                const vt = this.paint.get(le1);
                                if (vt instanceof Qi && Nr(vt.property.specification) && ("source" === vt.value.kind || "composite" === vt.value.kind) && vt.value.isStateDependent) return !0;
                            }
                            return !1;
                        }
                    }
                    const Gm = {
                        Int8: Int8Array,
                        Uint8: Uint8Array,
                        Int16: Int16Array,
                        Uint16: Uint16Array,
                        Int32: Int32Array,
                        Uint32: Uint32Array,
                        Float32: Float32Array
                    };
                    class us {
                        constructor(le1, vt){
                            this._structArray = le1, this._pos1 = vt * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                        }
                    }
                    class cs {
                        constructor(){
                            this.isTransferred = !1, this.capacity = -1, this.resize(0);
                        }
                        static serialize(le1, vt) {
                            return le1._trim(), vt && (le1.isTransferred = !0, vt.push(le1.arrayBuffer)), {
                                length: le1.length,
                                arrayBuffer: le1.arrayBuffer
                            };
                        }
                        static deserialize(le1) {
                            const vt = Object.create(this.prototype);
                            return vt.arrayBuffer = le1.arrayBuffer, vt.length = le1.length, vt.capacity = le1.arrayBuffer.byteLength / vt.bytesPerElement, vt._refreshViews(), vt;
                        }
                        _trim() {
                            this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                        }
                        clear() {
                            this.length = 0;
                        }
                        resize(le1) {
                            this.reserve(le1), this.length = le1;
                        }
                        reserve(le1) {
                            if (le1 > this.capacity) {
                                this.capacity = Math.max(le1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                const vt = this.uint8;
                                this._refreshViews(), vt && this.uint8.set(vt);
                            }
                        }
                        _refreshViews() {
                            throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                        }
                    }
                    function hs(le1, vt) {
                        void 0 === vt && (vt = 1);
                        let bt = 0, ls = 0;
                        return {
                            members: le1.map((le1)=>{
                                const ho = Gm[le1.type].BYTES_PER_ELEMENT, Dl = bt = ps(bt, Math.max(vt, ho)), Fl = le1.components || 1;
                                return ls = Math.max(ls, ho), bt += ho * Fl, {
                                    name: le1.name,
                                    type: le1.type,
                                    components: Fl,
                                    offset: Dl
                                };
                            }),
                            size: ps(bt, Math.max(ls, vt)),
                            alignment: vt
                        };
                    }
                    function ps(le1, vt) {
                        return Math.ceil(le1 / vt) * vt;
                    }
                    class fs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt) {
                            const bt = this.length;
                            return this.resize(bt + 1), this.emplace(bt, le1, vt);
                        }
                        emplace(le1, vt, bt) {
                            const ls = 2 * le1;
                            return this.int16[ls + 0] = vt, this.int16[ls + 1] = bt, le1;
                        }
                    }
                    fs.prototype.bytesPerElement = 4, pi("StructArrayLayout2i4", fs);
                    class ds extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt) {
                            const ls = this.length;
                            return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                        }
                        emplace(le1, vt, bt, ls) {
                            const ho = 3 * le1;
                            return this.int16[ho + 0] = vt, this.int16[ho + 1] = bt, this.int16[ho + 2] = ls, le1;
                        }
                    }
                    ds.prototype.bytesPerElement = 6, pi("StructArrayLayout3i6", ds);
                    class ys extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls) {
                            const ho = this.length;
                            return this.resize(ho + 1), this.emplace(ho, le1, vt, bt, ls);
                        }
                        emplace(le1, vt, bt, ls, ho) {
                            const Dl = 4 * le1;
                            return this.int16[Dl + 0] = vt, this.int16[Dl + 1] = bt, this.int16[Dl + 2] = ls, this.int16[Dl + 3] = ho, le1;
                        }
                    }
                    ys.prototype.bytesPerElement = 8, pi("StructArrayLayout4i8", ys);
                    class ms extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl) {
                            const Fl = this.length;
                            return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = 6 * le1;
                            return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.int16[sc + 2] = ls, this.int16[sc + 3] = ho, this.int16[sc + 4] = Dl, this.int16[sc + 5] = Fl, le1;
                        }
                    }
                    ms.prototype.bytesPerElement = 12, pi("StructArrayLayout2i4i12", ms);
                    class gs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl) {
                            const Fl = this.length;
                            return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = 4 * le1, uc = 8 * le1;
                            return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.uint8[uc + 4] = ls, this.uint8[uc + 5] = ho, this.uint8[uc + 6] = Dl, this.uint8[uc + 7] = Fl, le1;
                        }
                    }
                    gs.prototype.bytesPerElement = 8, pi("StructArrayLayout2i4ub8", gs);
                    class xs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt) {
                            const bt = this.length;
                            return this.resize(bt + 1), this.emplace(bt, le1, vt);
                        }
                        emplace(le1, vt, bt) {
                            const ls = 2 * le1;
                            return this.float32[ls + 0] = vt, this.float32[ls + 1] = bt, le1;
                        }
                    }
                    xs.prototype.bytesPerElement = 8, pi("StructArrayLayout2f8", xs);
                    class vs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                            const gc = this.length;
                            return this.resize(gc + 1), this.emplace(gc, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                            const Ac = 10 * le1;
                            return this.uint16[Ac + 0] = vt, this.uint16[Ac + 1] = bt, this.uint16[Ac + 2] = ls, this.uint16[Ac + 3] = ho, this.uint16[Ac + 4] = Dl, this.uint16[Ac + 5] = Fl, this.uint16[Ac + 6] = sc, this.uint16[Ac + 7] = uc, this.uint16[Ac + 8] = mc, this.uint16[Ac + 9] = gc, le1;
                        }
                    }
                    vs.prototype.bytesPerElement = 20, pi("StructArrayLayout10ui20", vs);
                    class bs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = this.length;
                            return this.resize(uc + 1), this.emplace(uc, le1, vt, bt, ls, ho, Dl, Fl, sc);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = 8 * le1;
                            return this.uint16[mc + 0] = vt, this.uint16[mc + 1] = bt, this.uint16[mc + 2] = ls, this.uint16[mc + 3] = ho, this.uint16[mc + 4] = Dl, this.uint16[mc + 5] = Fl, this.uint16[mc + 6] = sc, this.uint16[mc + 7] = uc, le1;
                        }
                    }
                    bs.prototype.bytesPerElement = 16, pi("StructArrayLayout8ui16", bs);
                    class ws extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                            const Ec = this.length;
                            return this.resize(Ec + 1), this.emplace(Ec, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                            const kc = 12 * le1;
                            return this.int16[kc + 0] = vt, this.int16[kc + 1] = bt, this.int16[kc + 2] = ls, this.int16[kc + 3] = ho, this.uint16[kc + 4] = Dl, this.uint16[kc + 5] = Fl, this.uint16[kc + 6] = sc, this.uint16[kc + 7] = uc, this.int16[kc + 8] = mc, this.int16[kc + 9] = gc, this.int16[kc + 10] = Ac, this.int16[kc + 11] = Ec, le1;
                        }
                    }
                    ws.prototype.bytesPerElement = 24, pi("StructArrayLayout4i4ui4i24", ws);
                    class _s extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt) {
                            const ls = this.length;
                            return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                        }
                        emplace(le1, vt, bt, ls) {
                            const ho = 3 * le1;
                            return this.float32[ho + 0] = vt, this.float32[ho + 1] = bt, this.float32[ho + 2] = ls, le1;
                        }
                    }
                    _s.prototype.bytesPerElement = 12, pi("StructArrayLayout3f12", _s);
                    class Ss extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1) {
                            const vt = this.length;
                            return this.resize(vt + 1), this.emplace(vt, le1);
                        }
                        emplace(le1, vt) {
                            return this.uint32[1 * le1 + 0] = vt, le1;
                        }
                    }
                    Ss.prototype.bytesPerElement = 4, pi("StructArrayLayout1ul4", Ss);
                    class As extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = this.length;
                            return this.resize(mc + 1), this.emplace(mc, le1, vt, bt, ls, ho, Dl, Fl, sc, uc);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                            const gc = 10 * le1, Ac = 5 * le1;
                            return this.int16[gc + 0] = vt, this.int16[gc + 1] = bt, this.int16[gc + 2] = ls, this.int16[gc + 3] = ho, this.int16[gc + 4] = Dl, this.int16[gc + 5] = Fl, this.uint32[Ac + 3] = sc, this.uint16[gc + 8] = uc, this.uint16[gc + 9] = mc, le1;
                        }
                    }
                    As.prototype.bytesPerElement = 20, pi("StructArrayLayout6i1ul2ui20", As);
                    class Is extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl) {
                            const Fl = this.length;
                            return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = 6 * le1;
                            return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.int16[sc + 2] = ls, this.int16[sc + 3] = ho, this.int16[sc + 4] = Dl, this.int16[sc + 5] = Fl, le1;
                        }
                    }
                    Is.prototype.bytesPerElement = 12, pi("StructArrayLayout2i2i2i12", Is);
                    class Ts extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho) {
                            const Dl = this.length;
                            return this.resize(Dl + 1), this.emplace(Dl, le1, vt, bt, ls, ho);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl) {
                            const Fl = 4 * le1, sc = 8 * le1;
                            return this.float32[Fl + 0] = vt, this.float32[Fl + 1] = bt, this.float32[Fl + 2] = ls, this.int16[sc + 6] = ho, this.int16[sc + 7] = Dl, le1;
                        }
                    }
                    Ts.prototype.bytesPerElement = 16, pi("StructArrayLayout2f1f2i16", Ts);
                    class ks extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl) {
                            const Fl = this.length;
                            return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = 16 * le1, uc = 4 * le1, mc = 8 * le1;
                            return this.uint8[sc + 0] = vt, this.uint8[sc + 1] = bt, this.float32[uc + 1] = ls, this.float32[uc + 2] = ho, this.int16[mc + 6] = Dl, this.int16[mc + 7] = Fl, le1;
                        }
                    }
                    ks.prototype.bytesPerElement = 16, pi("StructArrayLayout2ub2f2i16", ks);
                    class Es extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt) {
                            const ls = this.length;
                            return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                        }
                        emplace(le1, vt, bt, ls) {
                            const ho = 3 * le1;
                            return this.uint16[ho + 0] = vt, this.uint16[ho + 1] = bt, this.uint16[ho + 2] = ls, le1;
                        }
                    }
                    Es.prototype.bytesPerElement = 6, pi("StructArrayLayout3ui6", Es);
                    class Ms extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md) {
                            const Ld = this.length;
                            return this.resize(Ld + 1), this.emplace(Ld, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld) {
                            const Nd = 24 * le1, Rd = 12 * le1, Od = 48 * le1;
                            return this.int16[Nd + 0] = vt, this.int16[Nd + 1] = bt, this.uint16[Nd + 2] = ls, this.uint16[Nd + 3] = ho, this.uint32[Rd + 2] = Dl, this.uint32[Rd + 3] = Fl, this.uint32[Rd + 4] = sc, this.uint16[Nd + 10] = uc, this.uint16[Nd + 11] = mc, this.uint16[Nd + 12] = gc, this.float32[Rd + 7] = Ac, this.float32[Rd + 8] = Ec, this.uint8[Od + 36] = kc, this.uint8[Od + 37] = du, this.uint8[Od + 38] = _u, this.uint32[Rd + 10] = Md, this.int16[Nd + 22] = Ld, le1;
                        }
                    }
                    Ms.prototype.bytesPerElement = 48, pi("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", Ms);
                    class Ds extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd) {
                            const Yd = this.length;
                            return this.resize(Yd + 1), this.emplace(Yd, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd);
                        }
                        emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd, Yd) {
                            const Qd = 32 * le1, Xd = 16 * le1;
                            return this.int16[Qd + 0] = vt, this.int16[Qd + 1] = bt, this.int16[Qd + 2] = ls, this.int16[Qd + 3] = ho, this.int16[Qd + 4] = Dl, this.int16[Qd + 5] = Fl, this.int16[Qd + 6] = sc, this.int16[Qd + 7] = uc, this.uint16[Qd + 8] = mc, this.uint16[Qd + 9] = gc, this.uint16[Qd + 10] = Ac, this.uint16[Qd + 11] = Ec, this.uint16[Qd + 12] = kc, this.uint16[Qd + 13] = du, this.uint16[Qd + 14] = _u, this.uint16[Qd + 15] = Md, this.uint16[Qd + 16] = Ld, this.uint16[Qd + 17] = Nd, this.uint16[Qd + 18] = Rd, this.uint16[Qd + 19] = Od, this.uint16[Qd + 20] = jd, this.uint16[Qd + 21] = Ud, this.uint16[Qd + 22] = Gd, this.uint32[Xd + 12] = qd, this.float32[Xd + 13] = Hd, this.float32[Xd + 14] = Wd, this.uint16[Qd + 30] = Zd, this.uint16[Qd + 31] = Yd, le1;
                        }
                    }
                    Ds.prototype.bytesPerElement = 64, pi("StructArrayLayout8i15ui1ul2f2ui64", Ds);
                    class Ps extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1) {
                            const vt = this.length;
                            return this.resize(vt + 1), this.emplace(vt, le1);
                        }
                        emplace(le1, vt) {
                            return this.float32[1 * le1 + 0] = vt, le1;
                        }
                    }
                    Ps.prototype.bytesPerElement = 4, pi("StructArrayLayout1f4", Ps);
                    class zs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt) {
                            const ls = this.length;
                            return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                        }
                        emplace(le1, vt, bt, ls) {
                            const ho = 3 * le1;
                            return this.uint16[6 * le1 + 0] = vt, this.float32[ho + 1] = bt, this.float32[ho + 2] = ls, le1;
                        }
                    }
                    zs.prototype.bytesPerElement = 12, pi("StructArrayLayout1ui2f12", zs);
                    class Fs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt) {
                            const ls = this.length;
                            return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                        }
                        emplace(le1, vt, bt, ls) {
                            const ho = 4 * le1;
                            return this.uint32[2 * le1 + 0] = vt, this.uint16[ho + 2] = bt, this.uint16[ho + 3] = ls, le1;
                        }
                    }
                    Fs.prototype.bytesPerElement = 8, pi("StructArrayLayout1ul2ui8", Fs);
                    class Bs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt) {
                            const bt = this.length;
                            return this.resize(bt + 1), this.emplace(bt, le1, vt);
                        }
                        emplace(le1, vt, bt) {
                            const ls = 2 * le1;
                            return this.uint16[ls + 0] = vt, this.uint16[ls + 1] = bt, le1;
                        }
                    }
                    Bs.prototype.bytesPerElement = 4, pi("StructArrayLayout2ui4", Bs);
                    class Cs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                        }
                        emplaceBack(le1) {
                            const vt = this.length;
                            return this.resize(vt + 1), this.emplace(vt, le1);
                        }
                        emplace(le1, vt) {
                            return this.uint16[1 * le1 + 0] = vt, le1;
                        }
                    }
                    Cs.prototype.bytesPerElement = 2, pi("StructArrayLayout1ui2", Cs);
                    class Vs extends cs {
                        _refreshViews() {
                            this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                        }
                        emplaceBack(le1, vt, bt, ls) {
                            const ho = this.length;
                            return this.resize(ho + 1), this.emplace(ho, le1, vt, bt, ls);
                        }
                        emplace(le1, vt, bt, ls, ho) {
                            const Dl = 4 * le1;
                            return this.float32[Dl + 0] = vt, this.float32[Dl + 1] = bt, this.float32[Dl + 2] = ls, this.float32[Dl + 3] = ho, le1;
                        }
                    }
                    Vs.prototype.bytesPerElement = 16, pi("StructArrayLayout4f16", Vs);
                    class Ls extends us {
                        get anchorPointX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorPointY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get x1() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get y1() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get x2() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get y2() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get anchorPoint() {
                            return new t(this.anchorPointX, this.anchorPointY);
                        }
                    }
                    Ls.prototype.size = 20;
                    class Os extends As {
                        get(le1) {
                            return new Ls(this, le1);
                        }
                    }
                    pi("CollisionBoxArray", Os);
                    class Rs extends us {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get glyphStartIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get numGlyphs() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                        get vertexStartIndex() {
                            return this._structArray.uint32[this._pos4 + 2];
                        }
                        get lineStartIndex() {
                            return this._structArray.uint32[this._pos4 + 3];
                        }
                        get lineLength() {
                            return this._structArray.uint32[this._pos4 + 4];
                        }
                        get segment() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get lowerSize() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get upperSize() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get lineOffsetX() {
                            return this._structArray.float32[this._pos4 + 7];
                        }
                        get lineOffsetY() {
                            return this._structArray.float32[this._pos4 + 8];
                        }
                        get writingMode() {
                            return this._structArray.uint8[this._pos1 + 36];
                        }
                        get placedOrientation() {
                            return this._structArray.uint8[this._pos1 + 37];
                        }
                        set placedOrientation(le1) {
                            this._structArray.uint8[this._pos1 + 37] = le1;
                        }
                        get hidden() {
                            return this._structArray.uint8[this._pos1 + 38];
                        }
                        set hidden(le1) {
                            this._structArray.uint8[this._pos1 + 38] = le1;
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 10];
                        }
                        set crossTileID(le1) {
                            this._structArray.uint32[this._pos4 + 10] = le1;
                        }
                        get associatedIconIndex() {
                            return this._structArray.int16[this._pos2 + 22];
                        }
                    }
                    Rs.prototype.size = 48;
                    class Ns extends Ms {
                        get(le1) {
                            return new Rs(this, le1);
                        }
                    }
                    pi("PlacedSymbolArray", Ns);
                    class $s extends us {
                        get anchorX() {
                            return this._structArray.int16[this._pos2 + 0];
                        }
                        get anchorY() {
                            return this._structArray.int16[this._pos2 + 1];
                        }
                        get rightJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 2];
                        }
                        get centerJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 3];
                        }
                        get leftJustifiedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 4];
                        }
                        get verticalPlacedTextSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 5];
                        }
                        get placedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 6];
                        }
                        get verticalPlacedIconSymbolIndex() {
                            return this._structArray.int16[this._pos2 + 7];
                        }
                        get key() {
                            return this._structArray.uint16[this._pos2 + 8];
                        }
                        get textBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 9];
                        }
                        get textBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 10];
                        }
                        get verticalTextBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 11];
                        }
                        get verticalTextBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 12];
                        }
                        get iconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 13];
                        }
                        get iconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 14];
                        }
                        get verticalIconBoxStartIndex() {
                            return this._structArray.uint16[this._pos2 + 15];
                        }
                        get verticalIconBoxEndIndex() {
                            return this._structArray.uint16[this._pos2 + 16];
                        }
                        get featureIndex() {
                            return this._structArray.uint16[this._pos2 + 17];
                        }
                        get numHorizontalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 18];
                        }
                        get numVerticalGlyphVertices() {
                            return this._structArray.uint16[this._pos2 + 19];
                        }
                        get numIconVertices() {
                            return this._structArray.uint16[this._pos2 + 20];
                        }
                        get numVerticalIconVertices() {
                            return this._structArray.uint16[this._pos2 + 21];
                        }
                        get useRuntimeCollisionCircles() {
                            return this._structArray.uint16[this._pos2 + 22];
                        }
                        get crossTileID() {
                            return this._structArray.uint32[this._pos4 + 12];
                        }
                        set crossTileID(le1) {
                            this._structArray.uint32[this._pos4 + 12] = le1;
                        }
                        get textBoxScale() {
                            return this._structArray.float32[this._pos4 + 13];
                        }
                        get collisionCircleDiameter() {
                            return this._structArray.float32[this._pos4 + 14];
                        }
                        get textAnchorOffsetStartIndex() {
                            return this._structArray.uint16[this._pos2 + 30];
                        }
                        get textAnchorOffsetEndIndex() {
                            return this._structArray.uint16[this._pos2 + 31];
                        }
                    }
                    $s.prototype.size = 64;
                    class Us extends Ds {
                        get(le1) {
                            return new $s(this, le1);
                        }
                    }
                    pi("SymbolInstanceArray", Us);
                    class qs extends Ps {
                        getoffsetX(le1) {
                            return this.float32[1 * le1 + 0];
                        }
                    }
                    pi("GlyphOffsetArray", qs);
                    class Gs extends ds {
                        getx(le1) {
                            return this.int16[3 * le1 + 0];
                        }
                        gety(le1) {
                            return this.int16[3 * le1 + 1];
                        }
                        gettileUnitDistanceFromAnchor(le1) {
                            return this.int16[3 * le1 + 2];
                        }
                    }
                    pi("SymbolLineVertexArray", Gs);
                    class js extends us {
                        get textAnchor() {
                            return this._structArray.uint16[this._pos2 + 0];
                        }
                        get textOffset0() {
                            return this._structArray.float32[this._pos4 + 1];
                        }
                        get textOffset1() {
                            return this._structArray.float32[this._pos4 + 2];
                        }
                    }
                    js.prototype.size = 12;
                    class Xs extends zs {
                        get(le1) {
                            return new js(this, le1);
                        }
                    }
                    pi("TextAnchorOffsetArray", Xs);
                    class Ys extends us {
                        get featureIndex() {
                            return this._structArray.uint32[this._pos4 + 0];
                        }
                        get sourceLayerIndex() {
                            return this._structArray.uint16[this._pos2 + 2];
                        }
                        get bucketIndex() {
                            return this._structArray.uint16[this._pos2 + 3];
                        }
                    }
                    Ys.prototype.size = 8;
                    class Zs extends Fs {
                        get(le1) {
                            return new Ys(this, le1);
                        }
                    }
                    pi("FeatureIndexArray", Zs);
                    class Hs extends fs {
                    }
                    class Ws extends fs {
                    }
                    class Js extends fs {
                    }
                    class Ks extends ms {
                    }
                    class Qs extends gs {
                    }
                    class eo extends xs {
                    }
                    class to extends vs {
                    }
                    class ro extends bs {
                    }
                    class no extends ws {
                    }
                    class io extends _s {
                    }
                    class so extends Ss {
                    }
                    class oo extends Is {
                    }
                    class ao extends ks {
                    }
                    class lo extends Es {
                    }
                    class uo extends Bs {
                    }
                    const qm = hs([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Hm } = qm;
                    class po {
                        constructor(le1){
                            void 0 === le1 && (le1 = []), this._forceNewSegmentOnNextPrepare = !1, this.segments = le1;
                        }
                        prepareSegment(le1, vt, bt, ls) {
                            const ho = this.segments[this.segments.length - 1];
                            return le1 > po.MAX_VERTEX_ARRAY_LENGTH && x(`Max vertices per segment is ${po.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${le1}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${po.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !ho || ho.vertexLength + le1 > po.MAX_VERTEX_ARRAY_LENGTH || ho.sortKey !== ls ? this.createNewSegment(vt, bt, ls) : ho;
                        }
                        createNewSegment(le1, vt, bt) {
                            const ls = {
                                vertexOffset: le1.length,
                                primitiveOffset: vt.length,
                                vertexLength: 0,
                                primitiveLength: 0,
                                vaos: {}
                            };
                            return void 0 !== bt && (ls.sortKey = bt), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(ls), ls;
                        }
                        getOrCreateLatestSegment(le1, vt, bt) {
                            return this.prepareSegment(0, le1, vt, bt);
                        }
                        forceNewSegmentOnNextPrepare() {
                            this._forceNewSegmentOnNextPrepare = !0;
                        }
                        get() {
                            return this.segments;
                        }
                        destroy() {
                            for (const le1 of this.segments)for(const vt in le1.vaos)le1.vaos[vt].destroy();
                        }
                        static simpleSegment(le1, vt, bt, ls) {
                            return new po([
                                {
                                    vertexOffset: le1,
                                    primitiveOffset: vt,
                                    vertexLength: bt,
                                    primitiveLength: ls,
                                    vaos: {},
                                    sortKey: 0
                                }
                            ]);
                        }
                    }
                    function fo(le1, vt) {
                        return 256 * (le1 = f(Math.floor(le1), 0, 255)) + f(Math.floor(vt), 0, 255);
                    }
                    po.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, pi("SegmentVector", po);
                    const Wm = hs([
                        {
                            name: "a_pattern_from",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pattern_to",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_from",
                            components: 1,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixel_ratio_to",
                            components: 1,
                            type: "Uint16"
                        }
                    ]), Zm = hs([
                        {
                            name: "a_dasharray_from",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_dasharray_to",
                            components: 4,
                            type: "Uint16"
                        }
                    ]);
                    var Ym, Qm, Xm, Km = {
                        exports: {}
                    }, Jm = {
                        exports: {}
                    }, $m = {
                        exports: {}
                    }, eg = function() {
                        if (Xm) return Km.exports;
                        Xm = 1;
                        var le1 = (Ym || (Ym = 1, Jm.exports = function(le1, vt) {
                            var bt, ls, ho, Dl, Fl, sc, uc, mc;
                            for(ls = le1.length - (bt = 3 & le1.length), ho = vt, Fl = 3432918353, sc = 461845907, mc = 0; mc < ls;)uc = 255 & le1.charCodeAt(mc) | (255 & le1.charCodeAt(++mc)) << 8 | (255 & le1.charCodeAt(++mc)) << 16 | (255 & le1.charCodeAt(++mc)) << 24, ++mc, ho = 27492 + (65535 & (Dl = 5 * (65535 & (ho = (ho ^= uc = (65535 & (uc = (uc = (65535 & uc) * Fl + (((uc >>> 16) * Fl & 65535) << 16) & 4294967295) << 15 | uc >>> 17)) * sc + (((uc >>> 16) * sc & 65535) << 16) & 4294967295) << 13 | ho >>> 19)) + ((5 * (ho >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (Dl >>> 16) & 65535) << 16);
                            switch(uc = 0, bt){
                                case 3:
                                    uc ^= (255 & le1.charCodeAt(mc + 2)) << 16;
                                case 2:
                                    uc ^= (255 & le1.charCodeAt(mc + 1)) << 8;
                                case 1:
                                    ho ^= uc = (65535 & (uc = (uc = (65535 & (uc ^= 255 & le1.charCodeAt(mc))) * Fl + (((uc >>> 16) * Fl & 65535) << 16) & 4294967295) << 15 | uc >>> 17)) * sc + (((uc >>> 16) * sc & 65535) << 16) & 4294967295;
                            }
                            return ho ^= le1.length, ho = 2246822507 * (65535 & (ho ^= ho >>> 16)) + ((2246822507 * (ho >>> 16) & 65535) << 16) & 4294967295, ho = 3266489909 * (65535 & (ho ^= ho >>> 13)) + ((3266489909 * (ho >>> 16) & 65535) << 16) & 4294967295, (ho ^= ho >>> 16) >>> 0;
                        }), Jm.exports), vt = (Qm || (Qm = 1, $m.exports = function(le1, vt) {
                            for(var bt, ls = le1.length, ho = vt ^ ls, Dl = 0; ls >= 4;)bt = 1540483477 * (65535 & (bt = 255 & le1.charCodeAt(Dl) | (255 & le1.charCodeAt(++Dl)) << 8 | (255 & le1.charCodeAt(++Dl)) << 16 | (255 & le1.charCodeAt(++Dl)) << 24)) + ((1540483477 * (bt >>> 16) & 65535) << 16), ho = 1540483477 * (65535 & ho) + ((1540483477 * (ho >>> 16) & 65535) << 16) ^ (bt = 1540483477 * (65535 & (bt ^= bt >>> 24)) + ((1540483477 * (bt >>> 16) & 65535) << 16)), ls -= 4, ++Dl;
                            switch(ls){
                                case 3:
                                    ho ^= (255 & le1.charCodeAt(Dl + 2)) << 16;
                                case 2:
                                    ho ^= (255 & le1.charCodeAt(Dl + 1)) << 8;
                                case 1:
                                    ho = 1540483477 * (65535 & (ho ^= 255 & le1.charCodeAt(Dl))) + ((1540483477 * (ho >>> 16) & 65535) << 16);
                            }
                            return ho = 1540483477 * (65535 & (ho ^= ho >>> 13)) + ((1540483477 * (ho >>> 16) & 65535) << 16), (ho ^= ho >>> 15) >>> 0;
                        }), $m.exports);
                        return Km.exports = le1, Km.exports.murmur3 = le1, Km.exports.murmur2 = vt, Km.exports;
                    }(), tg = r(eg);
                    class Io {
                        constructor(){
                            this.ids = [], this.positions = [], this.indexed = !1;
                        }
                        add(le1, vt, bt, ls) {
                            this.ids.push(To(le1)), this.positions.push(vt, bt, ls);
                        }
                        getPositions(le1) {
                            if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                            const vt = To(le1);
                            let bt = 0, ls = this.ids.length - 1;
                            for(; bt < ls;){
                                const le1 = bt + ls >> 1;
                                this.ids[le1] >= vt ? ls = le1 : bt = le1 + 1;
                            }
                            const ho = [];
                            for(; this.ids[bt] === vt;)ho.push({
                                index: this.positions[3 * bt],
                                start: this.positions[3 * bt + 1],
                                end: this.positions[3 * bt + 2]
                            }), bt++;
                            return ho;
                        }
                        static serialize(le1, vt) {
                            const bt = new Float64Array(le1.ids), ls = new Uint32Array(le1.positions);
                            return ko(bt, ls, 0, bt.length - 1), vt && vt.push(bt.buffer, ls.buffer), {
                                ids: bt,
                                positions: ls
                            };
                        }
                        static deserialize(le1) {
                            const vt = new Io;
                            return vt.ids = le1.ids, vt.positions = le1.positions, vt.indexed = !0, vt;
                        }
                    }
                    function To(le1) {
                        const vt = +le1;
                        return !isNaN(vt) && vt <= Number.MAX_SAFE_INTEGER ? vt : tg(String(le1));
                    }
                    function ko(le1, vt, bt, ls) {
                        for(; bt < ls;){
                            const ho = le1[bt + ls >> 1];
                            let Dl = bt - 1, Fl = ls + 1;
                            for(;;){
                                do Dl++;
                                while (le1[Dl] < ho);
                                do Fl--;
                                while (le1[Fl] > ho);
                                if (Dl >= Fl) break;
                                Eo(le1, Dl, Fl), Eo(vt, 3 * Dl, 3 * Fl), Eo(vt, 3 * Dl + 1, 3 * Fl + 1), Eo(vt, 3 * Dl + 2, 3 * Fl + 2);
                            }
                            Fl - bt < ls - Fl ? (ko(le1, vt, bt, Fl), bt = Fl + 1) : (ko(le1, vt, Fl + 1, ls), ls = Fl);
                        }
                    }
                    function Eo(le1, vt, bt) {
                        const ls = le1[vt];
                        le1[vt] = le1[bt], le1[bt] = ls;
                    }
                    pi("FeaturePositionMap", Io);
                    class Mo {
                        constructor(le1, vt){
                            this.gl = le1.gl, this.location = vt;
                        }
                    }
                    class Do extends Mo {
                        constructor(le1, vt){
                            super(le1, vt), this.current = 0;
                        }
                        set(le1) {
                            this.current !== le1 && (this.current = le1, this.gl.uniform1f(this.location, le1));
                        }
                    }
                    class Po extends Mo {
                        constructor(le1, vt){
                            super(le1, vt), this.current = [
                                0,
                                0,
                                0,
                                0
                            ];
                        }
                        set(le1) {
                            le1[0] === this.current[0] && le1[1] === this.current[1] && le1[2] === this.current[2] && le1[3] === this.current[3] || (this.current = le1, this.gl.uniform4f(this.location, le1[0], le1[1], le1[2], le1[3]));
                        }
                    }
                    class zo extends Mo {
                        constructor(le1, vt){
                            super(le1, vt), this.current = Ie.transparent;
                        }
                        set(le1) {
                            le1.r === this.current.r && le1.g === this.current.g && le1.b === this.current.b && le1.a === this.current.a || (this.current = le1, this.gl.uniform4f(this.location, le1.r, le1.g, le1.b, le1.a));
                        }
                    }
                    function Fo(le1) {
                        return [
                            fo(255 * le1.r, 255 * le1.g),
                            fo(255 * le1.b, 255 * le1.a)
                        ];
                    }
                    class Bo {
                        constructor(le1, vt, bt){
                            this.value = le1, this.uniformNames = vt.map((le1)=>`u_${le1}`), this.type = bt;
                        }
                        setUniform(le1, vt, bt) {
                            le1.set(bt.constantOr(this.value));
                        }
                        getBinding(le1, vt, bt) {
                            return "color" === this.type ? new zo(le1, vt) : new Do(le1, vt);
                        }
                    }
                    class Co {
                        constructor(le1, vt){
                            this.uniformNames = vt.map((le1)=>`u_${le1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                        }
                        setConstantPatternPositions(le1, vt) {
                            this.pixelRatioFrom = vt.pixelRatio, this.pixelRatioTo = le1.pixelRatio, this.patternFrom = vt.tlbr, this.patternTo = le1.tlbr;
                        }
                        setConstantDashPositions(le1, vt) {
                            this.dashTo = [
                                0,
                                le1.y,
                                le1.height,
                                le1.width
                            ], this.dashFrom = [
                                0,
                                vt.y,
                                vt.height,
                                vt.width
                            ];
                        }
                        setUniform(le1, vt, bt, ls) {
                            let ho = null;
                            "u_pattern_to" === ls ? ho = this.patternTo : "u_pattern_from" === ls ? ho = this.patternFrom : "u_dasharray_to" === ls ? ho = this.dashTo : "u_dasharray_from" === ls ? ho = this.dashFrom : "u_pixel_ratio_to" === ls ? ho = this.pixelRatioTo : "u_pixel_ratio_from" === ls && (ho = this.pixelRatioFrom), null !== ho && le1.set(ho);
                        }
                        getBinding(le1, vt, bt) {
                            return "u_pattern" === bt.substr(0, 9) || "u_dasharray_" === bt.substr(0, 12) ? new Po(le1, vt) : new Do(le1, vt);
                        }
                    }
                    class Vo {
                        constructor(le1, vt, bt, ls){
                            this.expression = le1, this.type = bt, this.maxValue = 0, this.paintVertexAttributes = vt.map((le1)=>({
                                    name: `a_${le1}`,
                                    type: "Float32",
                                    components: "color" === bt ? 2 : 1,
                                    offset: 0
                                })), this.paintVertexArray = new ls;
                        }
                        populatePaintArray(le1, vt, bt) {
                            const ls = this.paintVertexArray.length, ho = this.expression.evaluate(new Gi(0, bt), vt, {}, bt.canonical, [], bt.formattedSection);
                            this.paintVertexArray.resize(le1), this._setPaintValue(ls, le1, ho);
                        }
                        updatePaintArray(le1, vt, bt, ls, ho) {
                            const Dl = this.expression.evaluate(new Gi(0, ho), bt, ls);
                            this._setPaintValue(le1, vt, Dl);
                        }
                        _setPaintValue(le1, vt, bt) {
                            if ("color" === this.type) {
                                const ls = Fo(bt);
                                for(let bt = le1; bt < vt; bt++)this.paintVertexArray.emplace(bt, ls[0], ls[1]);
                            } else {
                                for(let ls = le1; ls < vt; ls++)this.paintVertexArray.emplace(ls, bt);
                                this.maxValue = Math.max(this.maxValue, Math.abs(bt));
                            }
                        }
                        upload(le1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = le1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                    }
                    class Lo {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            this.expression = le1, this.uniformNames = vt.map((le1)=>`u_${le1}_t`), this.type = bt, this.useIntegerZoom = ls, this.zoom = ho, this.maxValue = 0, this.paintVertexAttributes = vt.map((le1)=>({
                                    name: `a_${le1}`,
                                    type: "Float32",
                                    components: "color" === bt ? 4 : 2,
                                    offset: 0
                                })), this.paintVertexArray = new Dl;
                        }
                        populatePaintArray(le1, vt, bt) {
                            const ls = this.expression.evaluate(new Gi(this.zoom, bt), vt, {}, bt.canonical, [], bt.formattedSection), ho = this.expression.evaluate(new Gi(this.zoom + 1, bt), vt, {}, bt.canonical, [], bt.formattedSection), Dl = this.paintVertexArray.length;
                            this.paintVertexArray.resize(le1), this._setPaintValue(Dl, le1, ls, ho);
                        }
                        updatePaintArray(le1, vt, bt, ls, ho) {
                            const Dl = this.expression.evaluate(new Gi(this.zoom, ho), bt, ls), Fl = this.expression.evaluate(new Gi(this.zoom + 1, ho), bt, ls);
                            this._setPaintValue(le1, vt, Dl, Fl);
                        }
                        _setPaintValue(le1, vt, bt, ls) {
                            if ("color" === this.type) {
                                const ho = Fo(bt), Dl = Fo(ls);
                                for(let bt = le1; bt < vt; bt++)this.paintVertexArray.emplace(bt, ho[0], ho[1], Dl[0], Dl[1]);
                            } else {
                                for(let ho = le1; ho < vt; ho++)this.paintVertexArray.emplace(ho, bt, ls);
                                this.maxValue = Math.max(this.maxValue, Math.abs(bt), Math.abs(ls));
                            }
                        }
                        upload(le1) {
                            this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = le1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                        }
                        destroy() {
                            this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                        }
                        setUniform(le1, vt) {
                            const bt = this.useIntegerZoom ? Math.floor(vt.zoom) : vt.zoom, ls = f(this.expression.interpolationFactor(bt, this.zoom, this.zoom + 1), 0, 1);
                            le1.set(ls);
                        }
                        getBinding(le1, vt, bt) {
                            return new Do(le1, vt);
                        }
                    }
                    class Oo {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            this.expression = le1, this.type = vt, this.useIntegerZoom = bt, this.zoom = ls, this.layerId = Dl, this.zoomInPaintVertexArray = new ho, this.zoomOutPaintVertexArray = new ho;
                        }
                        populatePaintArray(le1, vt, bt) {
                            const ls = this.zoomInPaintVertexArray.length;
                            this.zoomInPaintVertexArray.resize(le1), this.zoomOutPaintVertexArray.resize(le1), this._setPaintValues(ls, le1, this.getPositionIds(vt), bt);
                        }
                        updatePaintArray(le1, vt, bt, ls, ho) {
                            this._setPaintValues(le1, vt, this.getPositionIds(bt), ho);
                        }
                        _setPaintValues(le1, vt, bt, ls) {
                            const ho = this.getPositions(ls);
                            if (!ho || !bt) return;
                            const Dl = ho[bt.min], Fl = ho[bt.mid], sc = ho[bt.max];
                            if (Dl && Fl && sc) for(let uc = le1; uc < vt; uc++)this.emplace(this.zoomInPaintVertexArray, uc, Fl, Dl), this.emplace(this.zoomOutPaintVertexArray, uc, Fl, sc);
                        }
                        upload(le1) {
                            if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
                                const vt = this.getVertexAttributes();
                                this.zoomInPaintVertexBuffer = le1.createVertexBuffer(this.zoomInPaintVertexArray, vt, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = le1.createVertexBuffer(this.zoomOutPaintVertexArray, vt, this.expression.isStateDependent);
                            }
                        }
                        destroy() {
                            this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                        }
                    }
                    class Ro extends Oo {
                        getPositions(le1) {
                            return le1.imagePositions;
                        }
                        getPositionIds(le1) {
                            return le1.patterns && le1.patterns[this.layerId];
                        }
                        getVertexAttributes() {
                            return Wm.members;
                        }
                        emplace(le1, vt, bt, ls) {
                            le1.emplace(vt, bt.tlbr[0], bt.tlbr[1], bt.tlbr[2], bt.tlbr[3], ls.tlbr[0], ls.tlbr[1], ls.tlbr[2], ls.tlbr[3], bt.pixelRatio, ls.pixelRatio);
                        }
                    }
                    class No extends Oo {
                        getPositions(le1) {
                            return le1.dashPositions;
                        }
                        getPositionIds(le1) {
                            return le1.dashes && le1.dashes[this.layerId];
                        }
                        getVertexAttributes() {
                            return Zm.members;
                        }
                        emplace(le1, vt, bt, ls) {
                            le1.emplace(vt, 0, bt.y, bt.height, bt.width, 0, ls.y, ls.height, ls.width);
                        }
                    }
                    class $o {
                        constructor(le1, vt, bt){
                            this.binders = {}, this._buffers = [];
                            const ls = [];
                            for(const ho in le1.paint._values){
                                if (!bt(ho)) continue;
                                const Dl = le1.paint.get(ho);
                                if (!(Dl instanceof Qi && Nr(Dl.property.specification))) continue;
                                const Fl = qo(ho, le1.type), sc = Dl.value, uc = Dl.property.specification.type, mc = Dl.property.useIntegerZoom, gc = Dl.property.specification["property-type"], Ac = "cross-faded" === gc || "cross-faded-data-driven" === gc;
                                if ("constant" === sc.kind) this.binders[ho] = Ac ? new Co(sc.value, Fl) : new Bo(sc.value, Fl, uc), ls.push(`/u_${ho}`);
                                else if ("source" === sc.kind || Ac) {
                                    const bt = Go(ho, uc, "source");
                                    this.binders[ho] = Ac ? "line-dasharray" === ho ? new No(sc, uc, mc, vt, bt, le1.id) : new Ro(sc, uc, mc, vt, bt, le1.id) : new Vo(sc, Fl, uc, bt), ls.push(`/a_${ho}`);
                                } else {
                                    const le1 = Go(ho, uc, "composite");
                                    this.binders[ho] = new Lo(sc, Fl, uc, mc, vt, le1), ls.push(`/z_${ho}`);
                                }
                            }
                            this.cacheKey = ls.sort().join("");
                        }
                        getMaxValue(le1) {
                            const vt = this.binders[le1];
                            return vt instanceof Vo || vt instanceof Lo ? vt.maxValue : 0;
                        }
                        populatePaintArrays(le1, vt, bt) {
                            for(const ls in this.binders){
                                const ho = this.binders[ls];
                                (ho instanceof Vo || ho instanceof Lo || ho instanceof Oo) && ho.populatePaintArray(le1, vt, bt);
                            }
                        }
                        setConstantPatternPositions(le1, vt) {
                            for(const bt in this.binders){
                                const ls = this.binders[bt];
                                ls instanceof Co && ls.setConstantPatternPositions(le1, vt);
                            }
                        }
                        setConstantDashPositions(le1, vt) {
                            for(const bt in this.binders){
                                const ls = this.binders[bt];
                                ls instanceof Co && ls.setConstantDashPositions(le1, vt);
                            }
                        }
                        updatePaintArrays(le1, vt, bt, ls, ho) {
                            let Dl = !1;
                            for(const Fl in le1){
                                const sc = vt.getPositions(Fl);
                                for (const vt of sc){
                                    const sc = bt.feature(vt.index);
                                    for(const bt in this.binders){
                                        const uc = this.binders[bt];
                                        if ((uc instanceof Vo || uc instanceof Lo || uc instanceof Oo) && !0 === uc.expression.isStateDependent) {
                                            const mc = ls.paint.get(bt);
                                            uc.expression = mc.value, uc.updatePaintArray(vt.start, vt.end, sc, le1[Fl], ho), Dl = !0;
                                        }
                                    }
                                }
                            }
                            return Dl;
                        }
                        defines() {
                            const le1 = [];
                            for(const vt in this.binders){
                                const bt = this.binders[vt];
                                (bt instanceof Bo || bt instanceof Co) && le1.push(...bt.uniformNames.map((le1)=>`#define HAS_UNIFORM_${le1}`));
                            }
                            return le1;
                        }
                        getBinderAttributes() {
                            const le1 = [];
                            for(const vt in this.binders){
                                const bt = this.binders[vt];
                                if (bt instanceof Vo || bt instanceof Lo) for(let vt = 0; vt < bt.paintVertexAttributes.length; vt++)le1.push(bt.paintVertexAttributes[vt].name);
                                else if (bt instanceof Oo) {
                                    const vt = bt.getVertexAttributes();
                                    for (const bt of vt)le1.push(bt.name);
                                }
                            }
                            return le1;
                        }
                        getBinderUniforms() {
                            const le1 = [];
                            for(const vt in this.binders){
                                const bt = this.binders[vt];
                                if (bt instanceof Bo || bt instanceof Co || bt instanceof Lo) for (const vt of bt.uniformNames)le1.push(vt);
                            }
                            return le1;
                        }
                        getPaintVertexBuffers() {
                            return this._buffers;
                        }
                        getUniforms(le1, vt) {
                            const bt = [];
                            for(const ls in this.binders){
                                const ho = this.binders[ls];
                                if (ho instanceof Bo || ho instanceof Co || ho instanceof Lo) {
                                    for (const Dl of ho.uniformNames)if (vt[Dl]) {
                                        const Fl = ho.getBinding(le1, vt[Dl], Dl);
                                        bt.push({
                                            name: Dl,
                                            property: ls,
                                            binding: Fl
                                        });
                                    }
                                }
                            }
                            return bt;
                        }
                        setUniforms(le1, vt, bt, ls) {
                            for (const { name: ho, property: Dl, binding: Fl } of vt)this.binders[Dl].setUniform(Fl, ls, bt.get(Dl), ho);
                        }
                        updatePaintBuffers(le1) {
                            this._buffers = [];
                            for(const vt in this.binders){
                                const bt = this.binders[vt];
                                if (le1 && bt instanceof Oo) {
                                    const vt = 2 === le1.fromScale ? bt.zoomInPaintVertexBuffer : bt.zoomOutPaintVertexBuffer;
                                    vt && this._buffers.push(vt);
                                } else (bt instanceof Vo || bt instanceof Lo) && bt.paintVertexBuffer && this._buffers.push(bt.paintVertexBuffer);
                            }
                        }
                        upload(le1) {
                            for(const vt in this.binders){
                                const bt = this.binders[vt];
                                (bt instanceof Vo || bt instanceof Lo || bt instanceof Oo) && bt.upload(le1);
                            }
                            this.updatePaintBuffers();
                        }
                        destroy() {
                            for(const le1 in this.binders){
                                const vt = this.binders[le1];
                                (vt instanceof Vo || vt instanceof Lo || vt instanceof Oo) && vt.destroy();
                            }
                        }
                    }
                    class Uo {
                        constructor(le1, vt, bt){
                            void 0 === bt && (bt = ()=>!0), this.programConfigurations = {};
                            for (const ls of le1)this.programConfigurations[ls.id] = new $o(ls, vt, bt);
                            this.needsUpload = !1, this._featureMap = new Io, this._bufferOffset = 0;
                        }
                        populatePaintArrays(le1, vt, bt, ls) {
                            for(const ho in this.programConfigurations)this.programConfigurations[ho].populatePaintArrays(le1, vt, ls);
                            void 0 !== vt.id && this._featureMap.add(vt.id, bt, this._bufferOffset, le1), this._bufferOffset = le1, this.needsUpload = !0;
                        }
                        updatePaintArrays(le1, vt, bt, ls) {
                            for (const ho of bt)this.needsUpload = this.programConfigurations[ho.id].updatePaintArrays(le1, this._featureMap, vt, ho, ls) || this.needsUpload;
                        }
                        get(le1) {
                            return this.programConfigurations[le1];
                        }
                        upload(le1) {
                            if (this.needsUpload) {
                                for(const vt in this.programConfigurations)this.programConfigurations[vt].upload(le1);
                                this.needsUpload = !1;
                            }
                        }
                        destroy() {
                            for(const le1 in this.programConfigurations)this.programConfigurations[le1].destroy();
                        }
                    }
                    function qo(le1, vt) {
                        return ({
                            "text-opacity": [
                                "opacity"
                            ],
                            "icon-opacity": [
                                "opacity"
                            ],
                            "text-color": [
                                "fill_color"
                            ],
                            "icon-color": [
                                "fill_color"
                            ],
                            "text-halo-color": [
                                "halo_color"
                            ],
                            "icon-halo-color": [
                                "halo_color"
                            ],
                            "text-halo-blur": [
                                "halo_blur"
                            ],
                            "icon-halo-blur": [
                                "halo_blur"
                            ],
                            "text-halo-width": [
                                "halo_width"
                            ],
                            "icon-halo-width": [
                                "halo_width"
                            ],
                            "line-gap-width": [
                                "gapwidth"
                            ],
                            "line-dasharray": [
                                "dasharray_to",
                                "dasharray_from"
                            ],
                            "line-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ],
                            "fill-extrusion-pattern": [
                                "pattern_to",
                                "pattern_from",
                                "pixel_ratio_to",
                                "pixel_ratio_from"
                            ]
                        })[le1] || [
                            le1.replace(`${vt}-`, "").replace(/-/g, "_")
                        ];
                    }
                    function Go(le1, vt, bt) {
                        const ls = {
                            color: {
                                source: xs,
                                composite: Vs
                            },
                            number: {
                                source: Ps,
                                composite: xs
                            }
                        }, ho = function(le1) {
                            return ({
                                "line-pattern": {
                                    source: to,
                                    composite: to
                                },
                                "fill-pattern": {
                                    source: to,
                                    composite: to
                                },
                                "fill-extrusion-pattern": {
                                    source: to,
                                    composite: to
                                },
                                "line-dasharray": {
                                    source: ro,
                                    composite: ro
                                }
                            })[le1];
                        }(le1);
                        return ho && ho[bt] || ls[vt][bt];
                    }
                    pi("ConstantBinder", Bo), pi("CrossFadedConstantBinder", Co), pi("SourceExpressionBinder", Vo), pi("CrossFadedPatternBinder", Ro), pi("CrossFadedDasharrayBinder", No), pi("CompositeExpressionBinder", Lo), pi("ProgramConfiguration", $o, {
                        omit: [
                            "_buffers"
                        ]
                    }), pi("ProgramConfigurationSet", Uo);
                    const ig = Math.pow(2, 14) - 1, ng = -ig - 1;
                    function Yo(le1) {
                        const vt = uc / le1.extent, bt = le1.loadGeometry();
                        for(let ls = 0; ls < bt.length; ls++){
                            const le1 = bt[ls];
                            for(let bt = 0; bt < le1.length; bt++){
                                const ls = le1[bt], ho = Math.round(ls.x * vt), Dl = Math.round(ls.y * vt);
                                ls.x = f(ho, ng, ig), ls.y = f(Dl, ng, ig), (ho < ls.x || ho > ls.x + 1 || Dl < ls.y || Dl > ls.y + 1) && x("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                            }
                        }
                        return bt;
                    }
                    function Zo(le1, vt) {
                        return {
                            type: le1.type,
                            id: le1.id,
                            properties: le1.properties,
                            geometry: vt ? Yo(le1) : []
                        };
                    }
                    const rg = -32768;
                    function Wo(le1, vt, bt, ls, ho) {
                        le1.emplaceBack(rg + 8 * vt + ls, rg + 8 * bt + ho);
                    }
                    class Jo {
                        constructor(le1){
                            this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.layoutVertexArray = new Ws, this.indexArray = new lo, this.segments = new po, this.programConfigurations = new Uo(le1.layers, le1.zoom), this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                        }
                        populate(le1, vt, bt) {
                            const ls = this.layers[0], ho = [];
                            let Dl = null, Fl = !1, sc = "heatmap" === ls.type;
                            if ("circle" === ls.type) {
                                const le1 = ls;
                                Dl = le1.layout.get("circle-sort-key"), Fl = !Dl.isConstant(), sc = sc || "map" === le1.paint.get("circle-pitch-alignment");
                            }
                            const uc = sc ? vt.subdivisionGranularity.circle : 1;
                            for (const { feature: mc, id: gc, index: Ac, sourceLayerIndex: Ec } of le1){
                                const le1 = this.layers[0]._featureFilter.needGeometry, vt = Zo(mc, le1);
                                if (!this.layers[0]._featureFilter.filter(new Gi(this.zoom), vt, bt)) continue;
                                const ls = Fl ? Dl.evaluate(vt, {}, bt) : void 0, sc = {
                                    id: gc,
                                    properties: mc.properties,
                                    type: mc.type,
                                    sourceLayerIndex: Ec,
                                    index: Ac,
                                    geometry: le1 ? vt.geometry : Yo(mc),
                                    patterns: {},
                                    sortKey: ls
                                };
                                ho.push(sc);
                            }
                            Fl && ho.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                            for (const mc of ho){
                                const { geometry: ls, index: ho, sourceLayerIndex: Dl } = mc, Fl = le1[ho].feature;
                                this.addFeature(mc, ls, ho, bt, uc), vt.featureIndex.insert(Fl, ls, ho, Dl, this.index);
                            }
                        }
                        update(le1, vt, bt) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                imagePositions: bt
                            });
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(le1) {
                            this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Hm), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        addFeature(le1, vt, bt, ls, ho) {
                            let Dl;
                            switch(void 0 === ho && (ho = 1), ho){
                                case 1:
                                    Dl = [
                                        0,
                                        7
                                    ];
                                    break;
                                case 3:
                                    Dl = [
                                        0,
                                        2,
                                        5,
                                        7
                                    ];
                                    break;
                                case 5:
                                    Dl = [
                                        0,
                                        1,
                                        3,
                                        4,
                                        6,
                                        7
                                    ];
                                    break;
                                case 7:
                                    Dl = [
                                        0,
                                        1,
                                        2,
                                        3,
                                        4,
                                        5,
                                        6,
                                        7
                                    ];
                                    break;
                                default:
                                    throw new Error(`Invalid circle bucket granularity: ${ho}; valid values are 1, 3, 5, 7.`);
                            }
                            const Fl = Dl.length;
                            for (const sc of vt)for (const vt of sc){
                                const bt = vt.x, ls = vt.y;
                                if (bt < 0 || bt >= uc || ls < 0 || ls >= uc) continue;
                                const ho = this.segments.prepareSegment(Fl * Fl, this.layoutVertexArray, this.indexArray, le1.sortKey), sc = ho.vertexLength;
                                for(let le1 = 0; le1 < Fl; le1++)for(let vt = 0; vt < Fl; vt++)Wo(this.layoutVertexArray, bt, ls, Dl[vt], Dl[le1]);
                                for(let le1 = 0; le1 < Fl - 1; le1++)for(let vt = 0; vt < Fl - 1; vt++){
                                    const bt = sc + le1 * Fl + vt, ls = sc + (le1 + 1) * Fl + vt;
                                    this.indexArray.emplaceBack(bt, ls + 1, bt + 1), this.indexArray.emplaceBack(bt, ls, ls + 1);
                                }
                                ho.vertexLength += Fl * Fl, ho.primitiveLength += (Fl - 1) * (Fl - 1) * 2;
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                imagePositions: {},
                                canonical: ls
                            });
                        }
                    }
                    function Ko(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)if (aa(vt, le1[bt])) return !0;
                        for(let bt = 0; bt < vt.length; bt++)if (aa(le1, vt[bt])) return !0;
                        return !!ra(le1, vt);
                    }
                    function Qo(le1, vt, bt) {
                        return !!aa(le1, vt) || !!ia(vt, le1, bt);
                    }
                    function ea(le1, vt) {
                        if (1 === le1.length) return oa(vt, le1[0]);
                        for(let bt = 0; bt < vt.length; bt++){
                            const ls = vt[bt];
                            for(let vt = 0; vt < ls.length; vt++)if (aa(le1, ls[vt])) return !0;
                        }
                        for(let bt = 0; bt < le1.length; bt++)if (oa(vt, le1[bt])) return !0;
                        for(let bt = 0; bt < vt.length; bt++)if (ra(le1, vt[bt])) return !0;
                        return !1;
                    }
                    function ta(le1, vt, bt) {
                        if (le1.length > 1) {
                            if (ra(le1, vt)) return !0;
                            for(let ls = 0; ls < vt.length; ls++)if (ia(vt[ls], le1, bt)) return !0;
                        }
                        for(let ls = 0; ls < le1.length; ls++)if (ia(le1[ls], vt, bt)) return !0;
                        return !1;
                    }
                    function ra(le1, vt) {
                        if (0 === le1.length || 0 === vt.length) return !1;
                        for(let bt = 0; bt < le1.length - 1; bt++){
                            const ls = le1[bt], ho = le1[bt + 1];
                            for(let le1 = 0; le1 < vt.length - 1; le1++)if (na(ls, ho, vt[le1], vt[le1 + 1])) return !0;
                        }
                        return !1;
                    }
                    function na(le1, vt, bt, ls) {
                        return v(le1, bt, ls) !== v(vt, bt, ls) && v(le1, vt, bt) !== v(le1, vt, ls);
                    }
                    function ia(le1, vt, bt) {
                        const ls = bt * bt;
                        if (1 === vt.length) return le1.distSqr(vt[0]) < ls;
                        for(let ho = 1; ho < vt.length; ho++)if (sa(le1, vt[ho - 1], vt[ho]) < ls) return !0;
                        return !1;
                    }
                    function sa(le1, vt, bt) {
                        const ls = vt.distSqr(bt);
                        if (0 === ls) return le1.distSqr(vt);
                        const ho = ((le1.x - vt.x) * (bt.x - vt.x) + (le1.y - vt.y) * (bt.y - vt.y)) / ls;
                        return le1.distSqr(ho < 0 ? vt : ho > 1 ? bt : bt.sub(vt)._mult(ho)._add(vt));
                    }
                    function oa(le1, vt) {
                        let bt, ls, ho, Dl = !1;
                        for(let Fl = 0; Fl < le1.length; Fl++){
                            bt = le1[Fl];
                            for(let le1 = 0, Fl = bt.length - 1; le1 < bt.length; Fl = le1++)ls = bt[le1], ho = bt[Fl], ls.y > vt.y != ho.y > vt.y && vt.x < (ho.x - ls.x) * (vt.y - ls.y) / (ho.y - ls.y) + ls.x && (Dl = !Dl);
                        }
                        return Dl;
                    }
                    function aa(le1, vt) {
                        let bt = !1;
                        for(let ls = 0, ho = le1.length - 1; ls < le1.length; ho = ls++){
                            const Dl = le1[ls], Fl = le1[ho];
                            Dl.y > vt.y != Fl.y > vt.y && vt.x < (Fl.x - Dl.x) * (vt.y - Dl.y) / (Fl.y - Dl.y) + Dl.x && (bt = !bt);
                        }
                        return bt;
                    }
                    function la(le1, vt, bt) {
                        const ls = bt[0], ho = bt[2];
                        if (le1.x < ls.x && vt.x < ls.x || le1.x > ho.x && vt.x > ho.x || le1.y < ls.y && vt.y < ls.y || le1.y > ho.y && vt.y > ho.y) return !1;
                        const Dl = v(le1, vt, bt[0]);
                        return Dl !== v(le1, vt, bt[1]) || Dl !== v(le1, vt, bt[2]) || Dl !== v(le1, vt, bt[3]);
                    }
                    function ua(le1, vt, bt) {
                        const ls = vt.paint.get(le1).value;
                        return "constant" === ls.kind ? ls.value : bt.programConfigurations.get(vt.id).getMaxValue(le1);
                    }
                    function ca(le1) {
                        return Math.sqrt(le1[0] * le1[0] + le1[1] * le1[1]);
                    }
                    function ha(le1, vt, bt, ls, ho) {
                        if (!vt[0] && !vt[1]) return le1;
                        const Dl = t.convert(vt)._mult(ho);
                        "viewport" === bt && Dl._rotate(-ls);
                        const Fl = [];
                        for(let sc = 0; sc < le1.length; sc++)Fl.push(le1[sc].sub(Dl));
                        return Fl;
                    }
                    function pa(le1) {
                        const vt = [];
                        for(let bt = 0; bt < le1.length; bt++){
                            const ls = le1[bt], ho = vt.at(-1);
                            (0 === bt || ho && !ls.equals(ho)) && vt.push(ls);
                        }
                        return vt;
                    }
                    function fa(le1, vt) {
                        let { queryGeometry: bt, size: ls } = le1;
                        return Qo(bt, vt, ls);
                    }
                    function da(le1, vt) {
                        let { queryGeometry: bt, size: ls, transform: ho, unwrappedTileID: Dl, getElevation: Fl } = le1;
                        return Qo(bt, vt, ls * (ho.projectTileCoordinates(vt.x, vt.y, Dl, Fl).signedDistanceFromCamera / ho.cameraToCenterDistance));
                    }
                    function ya(le1, vt) {
                        let { queryGeometry: bt, size: ls, transform: ho, unwrappedTileID: Dl, getElevation: Fl } = le1;
                        const sc = ho.projectTileCoordinates(vt.x, vt.y, Dl, Fl).signedDistanceFromCamera, uc = ls * (ho.cameraToCenterDistance / sc);
                        return Qo(bt, xa(vt, ho, Dl, Fl), uc);
                    }
                    function ma(le1, vt) {
                        let { queryGeometry: bt, size: ls, transform: ho, unwrappedTileID: Dl, getElevation: Fl } = le1;
                        return Qo(bt, xa(vt, ho, Dl, Fl), ls);
                    }
                    function ga(le1, vt) {
                        let { queryGeometry: bt, size: ls, transform: ho, unwrappedTileID: Dl, getElevation: Fl, pitchAlignment: sc = "map", pitchScale: uc = "map" } = le1;
                        const mc = "map" === sc ? "map" === uc ? fa : da : "map" === uc ? ya : ma, gc = {
                            queryGeometry: bt,
                            size: ls,
                            transform: ho,
                            unwrappedTileID: Dl,
                            getElevation: Fl
                        };
                        for (const Ac of vt)for (const le1 of Ac)if (mc(gc, le1)) return !0;
                        return !1;
                    }
                    function xa(le1, vt, bt, ls) {
                        const ho = vt.projectTileCoordinates(le1.x, le1.y, bt, ls).point;
                        return new t((.5 * ho.x + .5) * vt.width, (.5 * -ho.y + .5) * vt.height);
                    }
                    let ag, sg;
                    pi("CircleBucket", Jo, {
                        omit: [
                            "layers"
                        ]
                    });
                    var og = {
                        get paint () {
                            return sg = sg || new os({
                                "circle-radius": new rs(Ec.paint_circle["circle-radius"]),
                                "circle-color": new rs(Ec.paint_circle["circle-color"]),
                                "circle-blur": new rs(Ec.paint_circle["circle-blur"]),
                                "circle-opacity": new rs(Ec.paint_circle["circle-opacity"]),
                                "circle-translate": new ts(Ec.paint_circle["circle-translate"]),
                                "circle-translate-anchor": new ts(Ec.paint_circle["circle-translate-anchor"]),
                                "circle-pitch-scale": new ts(Ec.paint_circle["circle-pitch-scale"]),
                                "circle-pitch-alignment": new ts(Ec.paint_circle["circle-pitch-alignment"]),
                                "circle-stroke-width": new rs(Ec.paint_circle["circle-stroke-width"]),
                                "circle-stroke-color": new rs(Ec.paint_circle["circle-stroke-color"]),
                                "circle-stroke-opacity": new rs(Ec.paint_circle["circle-stroke-opacity"])
                            });
                        },
                        get layout () {
                            return ag = ag || new os({
                                "circle-sort-key": new rs(Ec.layout_circle["circle-sort-key"])
                            });
                        }
                    };
                    class _a extends as {
                        constructor(le1, vt){
                            super(le1, og, vt);
                        }
                        createBucket(le1) {
                            return new Jo(le1);
                        }
                        queryRadius(le1) {
                            const vt = le1;
                            return ua("circle-radius", this, vt) + ua("circle-stroke-width", this, vt) + ca(this.paint.get("circle-translate"));
                        }
                        queryIntersectsFeature(le1) {
                            let { queryGeometry: vt, feature: bt, featureState: ls, geometry: ho, transform: Dl, pixelsToTileUnits: Fl, unwrappedTileID: sc, getElevation: uc } = le1;
                            const mc = ha(vt, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -Dl.bearingInRadians, Fl), gc = this.paint.get("circle-radius").evaluate(bt, ls) + this.paint.get("circle-stroke-width").evaluate(bt, ls), Ac = this.paint.get("circle-pitch-scale"), Ec = this.paint.get("circle-pitch-alignment");
                            let kc, du;
                            return "map" === Ec ? (kc = mc, du = gc * Fl) : (kc = function(le1, vt, bt, ls) {
                                return le1.map((le1)=>xa(le1, vt, bt, ls));
                            }(mc, Dl, sc, uc), du = gc), ga({
                                queryGeometry: kc,
                                size: du,
                                transform: Dl,
                                unwrappedTileID: sc,
                                getElevation: uc,
                                pitchAlignment: Ec,
                                pitchScale: Ac
                            }, ho);
                        }
                    }
                    class Sa extends Jo {
                    }
                    let lg;
                    pi("HeatmapBucket", Sa, {
                        omit: [
                            "layers"
                        ]
                    });
                    var cg = {
                        get paint () {
                            return lg = lg || new os({
                                "heatmap-radius": new rs(Ec.paint_heatmap["heatmap-radius"]),
                                "heatmap-weight": new rs(Ec.paint_heatmap["heatmap-weight"]),
                                "heatmap-intensity": new ts(Ec.paint_heatmap["heatmap-intensity"]),
                                "heatmap-color": new ss(Ec.paint_heatmap["heatmap-color"]),
                                "heatmap-opacity": new ts(Ec.paint_heatmap["heatmap-opacity"])
                            });
                        }
                    };
                    function Ta(le1, vt, bt, ls) {
                        let { width: ho, height: Dl } = vt;
                        if (ls) {
                            if (ls instanceof Uint8ClampedArray) ls = new Uint8Array(ls.buffer);
                            else if (ls.length !== ho * Dl * bt) throw new RangeError(`mismatched image size. expected: ${ls.length} but got: ${ho * Dl * bt}`);
                        } else ls = new Uint8Array(ho * Dl * bt);
                        return le1.width = ho, le1.height = Dl, le1.data = ls, le1;
                    }
                    function ka(le1, vt, bt) {
                        let { width: ls, height: ho } = vt;
                        if (ls === le1.width && ho === le1.height) return;
                        const Dl = Ta({}, {
                            width: ls,
                            height: ho
                        }, bt);
                        Ea(le1, Dl, {
                            x: 0,
                            y: 0
                        }, {
                            x: 0,
                            y: 0
                        }, {
                            width: Math.min(le1.width, ls),
                            height: Math.min(le1.height, ho)
                        }, bt), le1.width = ls, le1.height = ho, le1.data = Dl.data;
                    }
                    function Ea(le1, vt, bt, ls, ho, Dl) {
                        if (0 === ho.width || 0 === ho.height) return vt;
                        if (ho.width > le1.width || ho.height > le1.height || bt.x > le1.width - ho.width || bt.y > le1.height - ho.height) throw new RangeError("out of range source coordinates for image copy");
                        if (ho.width > vt.width || ho.height > vt.height || ls.x > vt.width - ho.width || ls.y > vt.height - ho.height) throw new RangeError("out of range destination coordinates for image copy");
                        const Fl = le1.data, sc = vt.data;
                        if (Fl === sc) throw new Error("srcData equals dstData, so image is already copied");
                        for(let uc = 0; uc < ho.height; uc++){
                            const mc = ((bt.y + uc) * le1.width + bt.x) * Dl, gc = ((ls.y + uc) * vt.width + ls.x) * Dl;
                            for(let le1 = 0; le1 < ho.width * Dl; le1++)sc[gc + le1] = Fl[mc + le1];
                        }
                        return vt;
                    }
                    class Ma {
                        constructor(le1, vt){
                            Ta(this, le1, 1, vt);
                        }
                        resize(le1) {
                            ka(this, le1, 1);
                        }
                        clone() {
                            return new Ma({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(le1, vt, bt, ls, ho) {
                            Ea(le1, vt, bt, ls, ho, 1);
                        }
                    }
                    class Da {
                        constructor(le1, vt){
                            Ta(this, le1, 4, vt);
                        }
                        resize(le1) {
                            ka(this, le1, 4);
                        }
                        replace(le1, vt) {
                            vt ? this.data.set(le1) : this.data = le1 instanceof Uint8ClampedArray ? new Uint8Array(le1.buffer) : le1;
                        }
                        clone() {
                            return new Da({
                                width: this.width,
                                height: this.height
                            }, new Uint8Array(this.data));
                        }
                        static copy(le1, vt, bt, ls, ho) {
                            Ea(le1, vt, bt, ls, ho, 4);
                        }
                        setPixel(le1, vt, bt) {
                            const ls = 4 * (le1 * this.width + vt);
                            this.data[ls + 0] = Math.round(255 * bt.r / bt.a), this.data[ls + 1] = Math.round(255 * bt.g / bt.a), this.data[ls + 2] = Math.round(255 * bt.b / bt.a), this.data[ls + 3] = Math.round(255 * bt.a);
                        }
                    }
                    pi("AlphaImage", Ma), pi("RGBAImage", Da);
                    const ug = "big-fb";
                    class za extends as {
                        createBucket(le1) {
                            return new Sa(le1);
                        }
                        constructor(le1, vt){
                            super(le1, cg, vt), this.heatmapFbos = new Map, this._updateColorRamp();
                        }
                        _handleSpecialPaintPropertyUpdate(le1) {
                            "heatmap-color" === le1 && this._updateColorRamp();
                        }
                        _updateColorRamp() {
                            this.colorRamp = function(le1) {
                                const vt = {}, bt = le1.resolution || 256, ls = le1.clips ? le1.clips.length : 1, ho = le1.image || new Da({
                                    width: bt,
                                    height: ls
                                });
                                if (Math.log(bt) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${bt}`);
                                const s = (ls, Dl, Fl)=>{
                                    vt[le1.evaluationKey] = Fl;
                                    const sc = le1.expression.evaluate(vt);
                                    ho.setPixel(ls / 4 / bt, Dl / 4, sc);
                                };
                                if (le1.clips) for(let Dl = 0, Fl = 0; Dl < ls; ++Dl, Fl += 4 * bt)for(let vt = 0, ls = 0; vt < bt; vt++, ls += 4){
                                    const ho = vt / (bt - 1), { start: sc, end: uc } = le1.clips[Dl];
                                    s(Fl, ls, sc * (1 - ho) + uc * ho);
                                }
                                else for(let Dl = 0, Fl = 0; Dl < bt; Dl++, Fl += 4)s(0, Fl, Dl / (bt - 1));
                                return ho;
                            }({
                                expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                                evaluationKey: "heatmapDensity",
                                image: this.colorRamp
                            }), this.colorRampTexture = null;
                        }
                        resize() {
                            this.heatmapFbos.has(ug) && this.heatmapFbos.delete(ug);
                        }
                        queryRadius(le1) {
                            return ua("heatmap-radius", this, le1);
                        }
                        queryIntersectsFeature(le1) {
                            let { queryGeometry: vt, feature: bt, featureState: ls, geometry: ho, transform: Dl, pixelsToTileUnits: Fl, unwrappedTileID: sc, getElevation: uc } = le1;
                            return ga({
                                queryGeometry: vt,
                                size: this.paint.get("heatmap-radius").evaluate(bt, ls) * Fl,
                                transform: Dl,
                                unwrappedTileID: sc,
                                getElevation: uc
                            }, ho);
                        }
                        hasOffscreenPass() {
                            return 0 !== this.paint.get("heatmap-opacity") && !this.isHidden();
                        }
                    }
                    let hg;
                    var dg = {
                        get paint () {
                            return hg = hg || new os({
                                "hillshade-illumination-direction": new ts(Ec.paint_hillshade["hillshade-illumination-direction"]),
                                "hillshade-illumination-altitude": new ts(Ec.paint_hillshade["hillshade-illumination-altitude"]),
                                "hillshade-illumination-anchor": new ts(Ec.paint_hillshade["hillshade-illumination-anchor"]),
                                "hillshade-exaggeration": new ts(Ec.paint_hillshade["hillshade-exaggeration"]),
                                "hillshade-shadow-color": new ts(Ec.paint_hillshade["hillshade-shadow-color"]),
                                "hillshade-highlight-color": new ts(Ec.paint_hillshade["hillshade-highlight-color"]),
                                "hillshade-accent-color": new ts(Ec.paint_hillshade["hillshade-accent-color"]),
                                "hillshade-method": new ts(Ec.paint_hillshade["hillshade-method"])
                            });
                        }
                    };
                    class Ca extends as {
                        constructor(le1, vt){
                            super(le1, dg, vt), this.recalculate({
                                zoom: 0,
                                zoomHistory: {}
                            }, void 0);
                        }
                        getIlluminationProperties() {
                            let le1 = this.paint.get("hillshade-illumination-direction").values, vt = this.paint.get("hillshade-illumination-altitude").values, bt = this.paint.get("hillshade-highlight-color").values, ls = this.paint.get("hillshade-shadow-color").values;
                            const ho = Math.max(le1.length, vt.length, bt.length, ls.length);
                            le1 = le1.concat(Array(ho - le1.length).fill(le1.at(-1))), vt = vt.concat(Array(ho - vt.length).fill(vt.at(-1))), bt = bt.concat(Array(ho - bt.length).fill(bt.at(-1))), ls = ls.concat(Array(ho - ls.length).fill(ls.at(-1)));
                            const Dl = vt.map(I);
                            return {
                                directionRadians: le1.map(I),
                                altitudeRadians: Dl,
                                shadowColor: ls,
                                highlightColor: bt
                            };
                        }
                        hasOffscreenPass() {
                            return 0 !== this.paint.get("hillshade-exaggeration") && !this.isHidden();
                        }
                    }
                    let pg;
                    var mg = {
                        get paint () {
                            return pg = pg || new os({
                                "color-relief-opacity": new ts(Ec["paint_color-relief"]["color-relief-opacity"]),
                                "color-relief-color": new ss(Ec["paint_color-relief"]["color-relief-color"])
                            });
                        }
                    };
                    class Oa {
                        constructor(le1, vt, bt, ls){
                            this.context = le1, this.format = bt, this.texture = le1.gl.createTexture(), this.update(vt, ls);
                        }
                        update(le1, vt, bt) {
                            const { width: ls, height: ho } = le1, Dl = !(this.size && this.size[0] === ls && this.size[1] === ho || bt), { context: Fl } = this, { gl: sc } = Fl;
                            if (this.useMipmap = Boolean(vt && vt.useMipmap), sc.bindTexture(sc.TEXTURE_2D, this.texture), Fl.pixelStoreUnpackFlipY.set(!1), Fl.pixelStoreUnpack.set(1), Fl.pixelStoreUnpackPremultiplyAlpha.set(this.format === sc.RGBA && (!vt || !1 !== vt.premultiply)), Dl) this.size = [
                                ls,
                                ho
                            ], le1 instanceof HTMLImageElement || le1 instanceof HTMLCanvasElement || le1 instanceof HTMLVideoElement || le1 instanceof ImageData || w(le1) ? sc.texImage2D(sc.TEXTURE_2D, 0, this.format, this.format, sc.UNSIGNED_BYTE, le1) : sc.texImage2D(sc.TEXTURE_2D, 0, this.format, ls, ho, 0, this.format, sc.UNSIGNED_BYTE, le1.data);
                            else {
                                const { x: vt, y: Dl } = bt || {
                                    x: 0,
                                    y: 0
                                };
                                le1 instanceof HTMLImageElement || le1 instanceof HTMLCanvasElement || le1 instanceof HTMLVideoElement || le1 instanceof ImageData || w(le1) ? sc.texSubImage2D(sc.TEXTURE_2D, 0, vt, Dl, sc.RGBA, sc.UNSIGNED_BYTE, le1) : sc.texSubImage2D(sc.TEXTURE_2D, 0, vt, Dl, ls, ho, sc.RGBA, sc.UNSIGNED_BYTE, le1.data);
                            }
                            this.useMipmap && this.isSizePowerOfTwo() && sc.generateMipmap(sc.TEXTURE_2D), Fl.pixelStoreUnpackFlipY.setDefault(), Fl.pixelStoreUnpack.setDefault(), Fl.pixelStoreUnpackPremultiplyAlpha.setDefault();
                        }
                        bind(le1, vt, bt) {
                            const { context: ls } = this, { gl: ho } = ls;
                            ho.bindTexture(ho.TEXTURE_2D, this.texture), bt !== ho.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (bt = ho.LINEAR), le1 !== this.filter && (ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_MAG_FILTER, le1), ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_MIN_FILTER, bt || le1), this.filter = le1), vt !== this.wrap && (ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_WRAP_S, vt), ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_WRAP_T, vt), this.wrap = vt);
                        }
                        isSizePowerOfTwo() {
                            return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                        }
                        destroy() {
                            const { gl: le1 } = this.context;
                            le1.deleteTexture(this.texture), this.texture = null;
                        }
                    }
                    class Ra {
                        constructor(le1, vt, bt, ls, ho, Dl, Fl){
                            if (void 0 === ls && (ls = 1), void 0 === ho && (ho = 1), void 0 === Dl && (Dl = 1), void 0 === Fl && (Fl = 0), this.uid = le1, vt.height !== vt.width) throw new RangeError("DEM tiles must be square");
                            if (bt && ![
                                "mapbox",
                                "terrarium",
                                "custom"
                            ].includes(bt)) return void x(`"${bt}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                            this.stride = vt.height;
                            const sc = this.dim = vt.height - 2;
                            switch(this.data = new Uint32Array(vt.data.buffer), bt){
                                case "terrarium":
                                    this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                    break;
                                case "custom":
                                    this.redFactor = ls, this.greenFactor = ho, this.blueFactor = Dl, this.baseShift = Fl;
                                    break;
                                default:
                                    this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                            }
                            for(let uc = 0; uc < sc; uc++)this.data[this._idx(-1, uc)] = this.data[this._idx(0, uc)], this.data[this._idx(sc, uc)] = this.data[this._idx(sc - 1, uc)], this.data[this._idx(uc, -1)] = this.data[this._idx(uc, 0)], this.data[this._idx(uc, sc)] = this.data[this._idx(uc, sc - 1)];
                            this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(sc, -1)] = this.data[this._idx(sc - 1, 0)], this.data[this._idx(-1, sc)] = this.data[this._idx(0, sc - 1)], this.data[this._idx(sc, sc)] = this.data[this._idx(sc - 1, sc - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                            for(let uc = 0; uc < sc; uc++)for(let le1 = 0; le1 < sc; le1++){
                                const vt = this.get(uc, le1);
                                vt > this.max && (this.max = vt), vt < this.min && (this.min = vt);
                            }
                        }
                        get(le1, vt) {
                            const bt = new Uint8Array(this.data.buffer), ls = 4 * this._idx(le1, vt);
                            return this.unpack(bt[ls], bt[ls + 1], bt[ls + 2]);
                        }
                        getUnpackVector() {
                            return [
                                this.redFactor,
                                this.greenFactor,
                                this.blueFactor,
                                this.baseShift
                            ];
                        }
                        _idx(le1, vt) {
                            if (le1 < -1 || le1 >= this.dim + 1 || vt < -1 || vt >= this.dim + 1) throw new RangeError(`Out of range source coordinates for DEM data. x: ${le1}, y: ${vt}, dim: ${this.dim}`);
                            return (vt + 1) * this.stride + (le1 + 1);
                        }
                        unpack(le1, vt, bt) {
                            return le1 * this.redFactor + vt * this.greenFactor + bt * this.blueFactor - this.baseShift;
                        }
                        pack(le1) {
                            return Na(le1, this.getUnpackVector());
                        }
                        getPixels() {
                            return new Da({
                                width: this.stride,
                                height: this.stride
                            }, new Uint8Array(this.data.buffer));
                        }
                        backfillBorder(le1, vt, bt) {
                            if (this.dim !== le1.dim) throw new Error("dem dimension mismatch");
                            let ls = vt * this.dim, ho = vt * this.dim + this.dim, Dl = bt * this.dim, Fl = bt * this.dim + this.dim;
                            switch(vt){
                                case -1:
                                    ls = ho - 1;
                                    break;
                                case 1:
                                    ho = ls + 1;
                            }
                            switch(bt){
                                case -1:
                                    Dl = Fl - 1;
                                    break;
                                case 1:
                                    Fl = Dl + 1;
                            }
                            const sc = -vt * this.dim, uc = -bt * this.dim;
                            for(let mc = Dl; mc < Fl; mc++)for(let vt = ls; vt < ho; vt++)this.data[this._idx(vt, mc)] = le1.data[this._idx(vt + sc, mc + uc)];
                        }
                    }
                    function Na(le1, vt) {
                        const bt = vt[0], ls = vt[1], ho = vt[2], Dl = vt[3], Fl = Math.min(bt, ls, ho), sc = Math.round((le1 + Dl) / Fl);
                        return {
                            r: Math.floor(sc * Fl / bt) % 256,
                            g: Math.floor(sc * Fl / ls) % 256,
                            b: Math.floor(sc * Fl / ho) % 256
                        };
                    }
                    pi("DEMData", Ra);
                    class $a extends as {
                        constructor(le1, vt){
                            super(le1, mg, vt);
                        }
                        _createColorRamp(le1) {
                            const vt = {
                                elevationStops: [],
                                colorStops: []
                            }, bt = this._transitionablePaint._values["color-relief-color"].value.expression;
                            if (bt instanceof tn && bt._styleExpression.expression instanceof ht) {
                                this.colorRampExpression = bt;
                                const le1 = bt._styleExpression.expression;
                                vt.elevationStops = le1.labels, vt.colorStops = [];
                                for (const bt of vt.elevationStops)vt.colorStops.push(le1.evaluate({
                                    globals: {
                                        elevation: bt
                                    }
                                }));
                            }
                            if (vt.elevationStops.length < 1 && (vt.elevationStops = [
                                0
                            ], vt.colorStops = [
                                Ie.transparent
                            ]), vt.elevationStops.length < 2 && (vt.elevationStops.push(vt.elevationStops[0] + 1), vt.colorStops.push(vt.colorStops[0])), vt.elevationStops.length <= le1) return vt;
                            const ls = {
                                elevationStops: [],
                                colorStops: []
                            }, ho = (vt.elevationStops.length - 1) / (le1 - 1);
                            for(let Dl = 0; Dl < vt.elevationStops.length - .5; Dl += ho)ls.elevationStops.push(vt.elevationStops[Math.round(Dl)]), ls.colorStops.push(vt.colorStops[Math.round(Dl)]);
                            return x(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${le1}, provided: ${vt.elevationStops.length}`), ls;
                        }
                        _colorRampChanged() {
                            return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
                        }
                        getColorRampTextures(le1, vt, bt) {
                            if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
                            const ls = this._createColorRamp(vt), ho = new Da({
                                width: ls.colorStops.length,
                                height: 1
                            }), Dl = new Da({
                                width: ls.colorStops.length,
                                height: 1
                            });
                            for(let Fl = 0; Fl < ls.elevationStops.length; Fl++){
                                const le1 = Na(ls.elevationStops[Fl], bt);
                                Dl.setPixel(0, Fl, new Ie(le1.r / 255, le1.g / 255, le1.b / 255, 1)), ho.setPixel(0, Fl, ls.colorStops[Fl]);
                            }
                            return this.colorRampTextures = {
                                elevationTexture: new Oa(le1, Dl, le1.gl.RGBA),
                                colorTexture: new Oa(le1, ho, le1.gl.RGBA)
                            }, this.colorRampTextures;
                        }
                        hasOffscreenPass() {
                            return !this.isHidden() && !!this.colorRampTextures;
                        }
                    }
                    const fg = hs([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: gg } = fg;
                    function Ga(le1, vt, bt) {
                        const ls = bt.patternDependencies;
                        let ho = !1;
                        for (const Dl of vt){
                            const vt = Dl.paint.get(`${le1}-pattern`);
                            vt.isConstant() || (ho = !0);
                            const bt = vt.constantOr(null);
                            bt && (ho = !0, ls[bt.to] = !0, ls[bt.from] = !0);
                        }
                        return ho;
                    }
                    function ja(le1, vt, bt, ls, ho) {
                        const { zoom: Dl } = ls, Fl = ho.patternDependencies;
                        for (const sc of vt){
                            const vt = sc.paint.get(`${le1}-pattern`).value;
                            if ("constant" !== vt.kind) {
                                let le1 = vt.evaluate({
                                    zoom: Dl - 1
                                }, bt, {}, ho.availableImages), ls = vt.evaluate({
                                    zoom: Dl
                                }, bt, {}, ho.availableImages), uc = vt.evaluate({
                                    zoom: Dl + 1
                                }, bt, {}, ho.availableImages);
                                le1 = le1 && le1.name ? le1.name : le1, ls = ls && ls.name ? ls.name : ls, uc = uc && uc.name ? uc.name : uc, Fl[le1] = !0, Fl[ls] = !0, Fl[uc] = !0, bt.patterns[sc.id] = {
                                    min: le1,
                                    mid: ls,
                                    max: uc
                                };
                            }
                        }
                        return bt;
                    }
                    function Xa(le1, vt, bt, ls, ho) {
                        let Dl;
                        if (ho === function(le1, vt, bt, ls) {
                            let ho = 0;
                            for(let Dl = vt, Fl = bt - ls; Dl < bt; Dl += ls)ho += (le1[Fl] - le1[Dl]) * (le1[Dl + 1] + le1[Fl + 1]), Fl = Dl;
                            return ho;
                        }(le1, vt, bt, ls) > 0) for(let Fl = vt; Fl < bt; Fl += ls)Dl = dl(Fl / ls | 0, le1[Fl], le1[Fl + 1], Dl);
                        else for(let Fl = bt - ls; Fl >= vt; Fl -= ls)Dl = dl(Fl / ls | 0, le1[Fl], le1[Fl + 1], Dl);
                        return Dl && ll(Dl, Dl.next) && (yl(Dl), Dl = Dl.next), Dl;
                    }
                    function Ya(le1, vt) {
                        if (!le1) return le1;
                        vt || (vt = le1);
                        let bt, ls = le1;
                        do if (bt = !1, ls.steiner || !ll(ls, ls.next) && 0 !== al(ls.prev, ls, ls.next)) ls = ls.next;
                        else {
                            if (yl(ls), ls = vt = ls.prev, ls === ls.next) break;
                            bt = !0;
                        }
                        while (bt || ls !== vt);
                        return vt;
                    }
                    function Za(le1, vt, bt, ls, ho, Dl, Fl) {
                        if (!le1) return;
                        !Fl && Dl && function(le1, vt, bt, ls) {
                            let ho = le1;
                            do 0 === ho.z && (ho.z = rl(ho.x, ho.y, vt, bt, ls)), ho.prevZ = ho.prev, ho.nextZ = ho.next, ho = ho.next;
                            while (ho !== le1);
                            ho.prevZ.nextZ = null, ho.prevZ = null, function(le1) {
                                let vt, bt = 1;
                                do {
                                    let ls, ho = le1;
                                    le1 = null;
                                    let Dl = null;
                                    for(vt = 0; ho;){
                                        vt++;
                                        let Fl = ho, sc = 0;
                                        for(let le1 = 0; le1 < bt && (sc++, Fl = Fl.nextZ, Fl); le1++);
                                        let uc = bt;
                                        for(; sc > 0 || uc > 0 && Fl;)0 !== sc && (0 === uc || !Fl || ho.z <= Fl.z) ? (ls = ho, ho = ho.nextZ, sc--) : (ls = Fl, Fl = Fl.nextZ, uc--), Dl ? Dl.nextZ = ls : le1 = ls, ls.prevZ = Dl, Dl = ls;
                                        ho = Fl;
                                    }
                                    Dl.nextZ = null, bt *= 2;
                                }while (vt > 1);
                            }(ho);
                        }(le1, ls, ho, Dl);
                        let sc = le1;
                        for(; le1.prev !== le1.next;){
                            const uc = le1.prev, mc = le1.next;
                            if (Dl ? Wa(le1, ls, ho, Dl) : Ha(le1)) vt.push(uc.i, le1.i, mc.i), yl(le1), le1 = mc.next, sc = mc.next;
                            else if ((le1 = mc) === sc) {
                                Fl ? 1 === Fl ? Za(le1 = Ja(Ya(le1), vt), vt, bt, ls, ho, Dl, 2) : 2 === Fl && Ka(le1, vt, bt, ls, ho, Dl) : Za(Ya(le1), vt, bt, ls, ho, Dl, 1);
                                break;
                            }
                        }
                    }
                    function Ha(le1) {
                        const vt = le1.prev, bt = le1, ls = le1.next;
                        if (al(vt, bt, ls) >= 0) return !1;
                        const ho = vt.x, Dl = bt.x, Fl = ls.x, sc = vt.y, uc = bt.y, mc = ls.y, gc = Math.min(ho, Dl, Fl), Ac = Math.min(sc, uc, mc), Ec = Math.max(ho, Dl, Fl), kc = Math.max(sc, uc, mc);
                        let du = ls.next;
                        for(; du !== vt;){
                            if (du.x >= gc && du.x <= Ec && du.y >= Ac && du.y <= kc && sl(ho, sc, Dl, uc, Fl, mc, du.x, du.y) && al(du.prev, du, du.next) >= 0) return !1;
                            du = du.next;
                        }
                        return !0;
                    }
                    function Wa(le1, vt, bt, ls) {
                        const ho = le1.prev, Dl = le1, Fl = le1.next;
                        if (al(ho, Dl, Fl) >= 0) return !1;
                        const sc = ho.x, uc = Dl.x, mc = Fl.x, gc = ho.y, Ac = Dl.y, Ec = Fl.y, kc = Math.min(sc, uc, mc), du = Math.min(gc, Ac, Ec), _u = Math.max(sc, uc, mc), Md = Math.max(gc, Ac, Ec), Ld = rl(kc, du, vt, bt, ls), Nd = rl(_u, Md, vt, bt, ls);
                        let Rd = le1.prevZ, Od = le1.nextZ;
                        for(; Rd && Rd.z >= Ld && Od && Od.z <= Nd;){
                            if (Rd.x >= kc && Rd.x <= _u && Rd.y >= du && Rd.y <= Md && Rd !== ho && Rd !== Fl && sl(sc, gc, uc, Ac, mc, Ec, Rd.x, Rd.y) && al(Rd.prev, Rd, Rd.next) >= 0) return !1;
                            if (Rd = Rd.prevZ, Od.x >= kc && Od.x <= _u && Od.y >= du && Od.y <= Md && Od !== ho && Od !== Fl && sl(sc, gc, uc, Ac, mc, Ec, Od.x, Od.y) && al(Od.prev, Od, Od.next) >= 0) return !1;
                            Od = Od.nextZ;
                        }
                        for(; Rd && Rd.z >= Ld;){
                            if (Rd.x >= kc && Rd.x <= _u && Rd.y >= du && Rd.y <= Md && Rd !== ho && Rd !== Fl && sl(sc, gc, uc, Ac, mc, Ec, Rd.x, Rd.y) && al(Rd.prev, Rd, Rd.next) >= 0) return !1;
                            Rd = Rd.prevZ;
                        }
                        for(; Od && Od.z <= Nd;){
                            if (Od.x >= kc && Od.x <= _u && Od.y >= du && Od.y <= Md && Od !== ho && Od !== Fl && sl(sc, gc, uc, Ac, mc, Ec, Od.x, Od.y) && al(Od.prev, Od, Od.next) >= 0) return !1;
                            Od = Od.nextZ;
                        }
                        return !0;
                    }
                    function Ja(le1, vt) {
                        let bt = le1;
                        do {
                            const ls = bt.prev, ho = bt.next.next;
                            !ll(ls, ho) && ul(ls, bt, bt.next, ho) && pl(ls, ho) && pl(ho, ls) && (vt.push(ls.i, bt.i, ho.i), yl(bt), yl(bt.next), bt = le1 = ho), bt = bt.next;
                        }while (bt !== le1);
                        return Ya(bt);
                    }
                    function Ka(le1, vt, bt, ls, ho, Dl) {
                        let Fl = le1;
                        do {
                            let le1 = Fl.next.next;
                            for(; le1 !== Fl.prev;){
                                if (Fl.i !== le1.i && ol(Fl, le1)) {
                                    let sc = fl(Fl, le1);
                                    return Fl = Ya(Fl, Fl.next), sc = Ya(sc, sc.next), Za(Fl, vt, bt, ls, ho, Dl, 0), void Za(sc, vt, bt, ls, ho, Dl, 0);
                                }
                                le1 = le1.next;
                            }
                            Fl = Fl.next;
                        }while (Fl !== le1);
                    }
                    function Qa(le1, vt) {
                        let bt = le1.x - vt.x;
                        return 0 === bt && (bt = le1.y - vt.y, 0 === bt) && (bt = (le1.next.y - le1.y) / (le1.next.x - le1.x) - (vt.next.y - vt.y) / (vt.next.x - vt.x)), bt;
                    }
                    function el(le1, vt) {
                        const bt = function(le1, vt) {
                            let bt = vt;
                            const ls = le1.x, ho = le1.y;
                            let Dl, Fl = -1 / 0;
                            if (ll(le1, bt)) return bt;
                            do {
                                if (ll(le1, bt.next)) return bt.next;
                                if (ho <= bt.y && ho >= bt.next.y && bt.next.y !== bt.y) {
                                    const le1 = bt.x + (ho - bt.y) * (bt.next.x - bt.x) / (bt.next.y - bt.y);
                                    if (le1 <= ls && le1 > Fl && (Fl = le1, Dl = bt.x < bt.next.x ? bt : bt.next, le1 === ls)) return Dl;
                                }
                                bt = bt.next;
                            }while (bt !== vt);
                            if (!Dl) return null;
                            const sc = Dl, uc = Dl.x, mc = Dl.y;
                            let gc = 1 / 0;
                            bt = Dl;
                            do {
                                if (ls >= bt.x && bt.x >= uc && ls !== bt.x && il(ho < mc ? ls : Fl, ho, uc, mc, ho < mc ? Fl : ls, ho, bt.x, bt.y)) {
                                    const vt = Math.abs(ho - bt.y) / (ls - bt.x);
                                    pl(bt, le1) && (vt < gc || vt === gc && (bt.x > Dl.x || bt.x === Dl.x && tl(Dl, bt))) && (Dl = bt, gc = vt);
                                }
                                bt = bt.next;
                            }while (bt !== sc);
                            return Dl;
                        }(le1, vt);
                        if (!bt) return vt;
                        const ls = fl(bt, le1);
                        return Ya(ls, ls.next), Ya(bt, bt.next);
                    }
                    function tl(le1, vt) {
                        return al(le1.prev, le1, vt.prev) < 0 && al(vt.next, le1, le1.next) < 0;
                    }
                    function rl(le1, vt, bt, ls, ho) {
                        return (le1 = 1431655765 & ((le1 = 858993459 & ((le1 = 252645135 & ((le1 = 16711935 & ((le1 = (le1 - bt) * ho | 0) | le1 << 8)) | le1 << 4)) | le1 << 2)) | le1 << 1)) | (vt = 1431655765 & ((vt = 858993459 & ((vt = 252645135 & ((vt = 16711935 & ((vt = (vt - ls) * ho | 0) | vt << 8)) | vt << 4)) | vt << 2)) | vt << 1)) << 1;
                    }
                    function nl(le1) {
                        let vt = le1, bt = le1;
                        do (vt.x < bt.x || vt.x === bt.x && vt.y < bt.y) && (bt = vt), vt = vt.next;
                        while (vt !== le1);
                        return bt;
                    }
                    function il(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        return (ho - Fl) * (vt - sc) >= (le1 - Fl) * (Dl - sc) && (le1 - Fl) * (ls - sc) >= (bt - Fl) * (vt - sc) && (bt - Fl) * (Dl - sc) >= (ho - Fl) * (ls - sc);
                    }
                    function sl(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        return !(le1 === Fl && vt === sc) && il(le1, vt, bt, ls, ho, Dl, Fl, sc);
                    }
                    function ol(le1, vt) {
                        return le1.next.i !== vt.i && le1.prev.i !== vt.i && !function(le1, vt) {
                            let bt = le1;
                            do {
                                if (bt.i !== le1.i && bt.next.i !== le1.i && bt.i !== vt.i && bt.next.i !== vt.i && ul(bt, bt.next, le1, vt)) return !0;
                                bt = bt.next;
                            }while (bt !== le1);
                            return !1;
                        }(le1, vt) && (pl(le1, vt) && pl(vt, le1) && function(le1, vt) {
                            let bt = le1, ls = !1;
                            const ho = (le1.x + vt.x) / 2, Dl = (le1.y + vt.y) / 2;
                            do bt.y > Dl != bt.next.y > Dl && bt.next.y !== bt.y && ho < (bt.next.x - bt.x) * (Dl - bt.y) / (bt.next.y - bt.y) + bt.x && (ls = !ls), bt = bt.next;
                            while (bt !== le1);
                            return ls;
                        }(le1, vt) && (al(le1.prev, le1, vt.prev) || al(le1, vt.prev, vt)) || ll(le1, vt) && al(le1.prev, le1, le1.next) > 0 && al(vt.prev, vt, vt.next) > 0);
                    }
                    function al(le1, vt, bt) {
                        return (vt.y - le1.y) * (bt.x - vt.x) - (vt.x - le1.x) * (bt.y - vt.y);
                    }
                    function ll(le1, vt) {
                        return le1.x === vt.x && le1.y === vt.y;
                    }
                    function ul(le1, vt, bt, ls) {
                        const ho = hl(al(le1, vt, bt)), Dl = hl(al(le1, vt, ls)), Fl = hl(al(bt, ls, le1)), sc = hl(al(bt, ls, vt));
                        return ho !== Dl && Fl !== sc || !(0 !== ho || !cl(le1, bt, vt)) || !(0 !== Dl || !cl(le1, ls, vt)) || !(0 !== Fl || !cl(bt, le1, ls)) || !(0 !== sc || !cl(bt, vt, ls));
                    }
                    function cl(le1, vt, bt) {
                        return vt.x <= Math.max(le1.x, bt.x) && vt.x >= Math.min(le1.x, bt.x) && vt.y <= Math.max(le1.y, bt.y) && vt.y >= Math.min(le1.y, bt.y);
                    }
                    function hl(le1) {
                        return le1 > 0 ? 1 : le1 < 0 ? -1 : 0;
                    }
                    function pl(le1, vt) {
                        return al(le1.prev, le1, le1.next) < 0 ? al(le1, vt, le1.next) >= 0 && al(le1, le1.prev, vt) >= 0 : al(le1, vt, le1.prev) < 0 || al(le1, le1.next, vt) < 0;
                    }
                    function fl(le1, vt) {
                        const bt = ml(le1.i, le1.x, le1.y), ls = ml(vt.i, vt.x, vt.y), ho = le1.next, Dl = vt.prev;
                        return le1.next = vt, vt.prev = le1, bt.next = ho, ho.prev = bt, ls.next = bt, bt.prev = ls, Dl.next = ls, ls.prev = Dl, ls;
                    }
                    function dl(le1, vt, bt, ls) {
                        const ho = ml(le1, vt, bt);
                        return ls ? (ho.next = ls.next, ho.prev = ls, ls.next.prev = ho, ls.next = ho) : (ho.prev = ho, ho.next = ho), ho;
                    }
                    function yl(le1) {
                        le1.next.prev = le1.prev, le1.prev.next = le1.next, le1.prevZ && (le1.prevZ.nextZ = le1.nextZ), le1.nextZ && (le1.nextZ.prevZ = le1.prevZ);
                    }
                    function ml(le1, vt, bt) {
                        return {
                            i: le1,
                            x: vt,
                            y: bt,
                            prev: null,
                            next: null,
                            z: 0,
                            prevZ: null,
                            nextZ: null,
                            steiner: !1
                        };
                    }
                    class gl {
                        constructor(le1, vt){
                            if (vt > le1) throw new Error("Min granularity must not be greater than base granularity.");
                            this._baseZoomGranularity = le1, this._minGranularity = vt;
                        }
                        getGranularityForZoomLevel(le1) {
                            return Math.max(Math.floor(this._baseZoomGranularity / (1 << le1)), this._minGranularity, 1);
                        }
                    }
                    class xl {
                        constructor(le1){
                            this.fill = le1.fill, this.line = le1.line, this.tile = le1.tile, this.stencil = le1.stencil, this.circle = le1.circle;
                        }
                    }
                    xl.noSubdivision = new xl({
                        fill: new gl(0, 0),
                        line: new gl(0, 0),
                        tile: new gl(0, 0),
                        stencil: new gl(0, 0),
                        circle: 1
                    }), pi("SubdivisionGranularityExpression", gl), pi("SubdivisionGranularitySetting", xl);
                    const Ag = -32768, _g = 32767;
                    class wl {
                        constructor(le1, vt){
                            this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = le1, this._granularityCellSize = uc / le1, this._canonical = vt;
                        }
                        _getKey(le1, vt) {
                            return (le1 += 32768) << 16 | vt + 32768;
                        }
                        _vertexToIndex(le1, vt) {
                            if (le1 < -32768 || vt < -32768 || le1 > 32767 || vt > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                            const bt = 0 | Math.round(le1), ls = 0 | Math.round(vt), ho = this._getKey(bt, ls);
                            if (this._vertexDictionary.has(ho)) return this._vertexDictionary.get(ho);
                            const Dl = this._vertexBuffer.length / 2;
                            return this._vertexDictionary.set(ho, Dl), this._vertexBuffer.push(bt, ls), Dl;
                        }
                        _subdivideTrianglesScanline(le1) {
                            if (this._granularity < 2) return function(le1, vt) {
                                const bt = [];
                                for(let ls = 0; ls < vt.length; ls += 3){
                                    const ho = vt[ls], Dl = vt[ls + 1], Fl = vt[ls + 2], sc = le1[2 * ho], uc = le1[2 * ho + 1];
                                    (le1[2 * Dl] - sc) * (le1[2 * Fl + 1] - uc) - (le1[2 * Dl + 1] - uc) * (le1[2 * Fl] - sc) > 0 ? (bt.push(ho), bt.push(Fl), bt.push(Dl)) : (bt.push(ho), bt.push(Dl), bt.push(Fl));
                                }
                                return bt;
                            }(this._vertexBuffer, le1);
                            const vt = [], bt = le1.length;
                            for(let ls = 0; ls < bt; ls += 3){
                                const bt = [
                                    le1[ls + 0],
                                    le1[ls + 1],
                                    le1[ls + 2]
                                ], ho = [
                                    this._vertexBuffer[2 * le1[ls + 0] + 0],
                                    this._vertexBuffer[2 * le1[ls + 0] + 1],
                                    this._vertexBuffer[2 * le1[ls + 1] + 0],
                                    this._vertexBuffer[2 * le1[ls + 1] + 1],
                                    this._vertexBuffer[2 * le1[ls + 2] + 0],
                                    this._vertexBuffer[2 * le1[ls + 2] + 1]
                                ];
                                let Dl = 1 / 0, Fl = 1 / 0, sc = -1 / 0, uc = -1 / 0;
                                for(let le1 = 0; le1 < 3; le1++){
                                    const vt = ho[2 * le1], bt = ho[2 * le1 + 1];
                                    Dl = Math.min(Dl, vt), sc = Math.max(sc, vt), Fl = Math.min(Fl, bt), uc = Math.max(uc, bt);
                                }
                                if (Dl === sc || Fl === uc) continue;
                                const mc = Math.floor(Dl / this._granularityCellSize), gc = Math.ceil(sc / this._granularityCellSize), Ac = Math.floor(Fl / this._granularityCellSize), Ec = Math.ceil(uc / this._granularityCellSize);
                                if (mc !== gc || Ac !== Ec) for(let le1 = Ac; le1 < Ec; le1++){
                                    const ls = this._scanlineGenerateVertexRingForCellRow(le1, ho, bt);
                                    Al(this._vertexBuffer, ls, vt);
                                }
                                else vt.push(...bt);
                            }
                            return vt;
                        }
                        _scanlineGenerateVertexRingForCellRow(le1, vt, bt) {
                            const ls = le1 * this._granularityCellSize, ho = ls + this._granularityCellSize, Dl = [];
                            for(let Fl = 0; Fl < 3; Fl++){
                                const le1 = vt[2 * Fl], sc = vt[2 * Fl + 1], uc = vt[2 * (Fl + 1) % 6], mc = vt[(2 * (Fl + 1) + 1) % 6], gc = vt[2 * (Fl + 2) % 6], Ac = vt[(2 * (Fl + 2) + 1) % 6], Ec = uc - le1, kc = mc - sc, du = 0 === Ec, _u = 0 === kc, Md = (ls - sc) / kc, Ld = (ho - sc) / kc, Nd = Math.min(Md, Ld), Rd = Math.max(Md, Ld);
                                if (!_u && (Nd >= 1 || Rd <= 0) || _u && (sc < ls || sc > ho)) {
                                    mc >= ls && mc <= ho && Dl.push(bt[(Fl + 1) % 3]);
                                    continue;
                                }
                                !_u && Nd > 0 && Dl.push(this._vertexToIndex(le1 + Ec * Nd, sc + kc * Nd));
                                const Od = le1 + Ec * Math.max(Nd, 0), jd = le1 + Ec * Math.min(Rd, 1);
                                du || this._generateIntraEdgeVertices(Dl, le1, sc, uc, mc, Od, jd), !_u && Rd < 1 && Dl.push(this._vertexToIndex(le1 + Ec * Rd, sc + kc * Rd)), (_u || mc >= ls && mc <= ho) && Dl.push(bt[(Fl + 1) % 3]), !_u && (mc <= ls || mc >= ho) && this._generateInterEdgeVertices(Dl, le1, sc, uc, mc, gc, Ac, jd, ls, ho);
                            }
                            return Dl;
                        }
                        _generateIntraEdgeVertices(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = ls - vt, uc = ho - bt, mc = 0 === uc, gc = mc ? Math.min(vt, ls) : Math.min(Dl, Fl), Ac = mc ? Math.max(vt, ls) : Math.max(Dl, Fl), Ec = Math.floor(gc / this._granularityCellSize) + 1, kc = Math.ceil(Ac / this._granularityCellSize) - 1;
                            if (mc ? vt < ls : Dl < Fl) for(let du = Ec; du <= kc; du++){
                                const ls = du * this._granularityCellSize;
                                le1.push(this._vertexToIndex(ls, bt + uc * (ls - vt) / sc));
                            }
                            else for(let du = kc; du >= Ec; du--){
                                const ls = du * this._granularityCellSize;
                                le1.push(this._vertexToIndex(ls, bt + uc * (ls - vt) / sc));
                            }
                        }
                        _generateInterEdgeVertices(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                            const gc = ho - bt, Ac = Dl - ls, Ec = Fl - ho, kc = (uc - ho) / Ec, du = (mc - ho) / Ec, _u = Math.min(kc, du), Md = Math.max(kc, du), Ld = ls + Ac * _u;
                            let Nd = Math.floor(Math.min(Ld, sc) / this._granularityCellSize) + 1, Rd = Math.ceil(Math.max(Ld, sc) / this._granularityCellSize) - 1, Od = sc < Ld;
                            const jd = 0 === Ec;
                            if (jd && (Fl === uc || Fl === mc)) return;
                            if (jd || _u >= 1 || Md <= 0) {
                                const le1 = bt - Fl, ls = Dl + (vt - Dl) * Math.min((uc - Fl) / le1, (mc - Fl) / le1);
                                Nd = Math.floor(Math.min(ls, sc) / this._granularityCellSize) + 1, Rd = Math.ceil(Math.max(ls, sc) / this._granularityCellSize) - 1, Od = sc < ls;
                            }
                            const Ud = gc > 0 ? mc : uc;
                            if (Od) for(let Gd = Nd; Gd <= Rd; Gd++)le1.push(this._vertexToIndex(Gd * this._granularityCellSize, Ud));
                            else for(let Gd = Rd; Gd >= Nd; Gd--)le1.push(this._vertexToIndex(Gd * this._granularityCellSize, Ud));
                        }
                        _generateOutline(le1) {
                            const vt = [];
                            for (const bt of le1){
                                const le1 = Sl(bt, this._granularity, !0), ls = this._pointArrayToIndices(le1), ho = [];
                                for(let vt = 1; vt < ls.length; vt++)ho.push(ls[vt - 1]), ho.push(ls[vt]);
                                vt.push(ho);
                            }
                            return vt;
                        }
                        _handlePoles(le1) {
                            let vt = !1, bt = !1;
                            this._canonical && (0 === this._canonical.y && (vt = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (bt = !0)), (vt || bt) && this._fillPoles(le1, vt, bt);
                        }
                        _ensureNoPoleVertices() {
                            const le1 = this._vertexBuffer;
                            for(let vt = 0; vt < le1.length; vt += 2){
                                const bt = le1[vt + 1];
                                bt === Ag && (le1[vt + 1] = -32767), bt === _g && (le1[vt + 1] = 32766);
                            }
                        }
                        _generatePoleQuad(le1, vt, bt, ls, ho, Dl) {
                            ls > ho != (Dl === Ag) ? (le1.push(vt), le1.push(bt), le1.push(this._vertexToIndex(ls, Dl)), le1.push(bt), le1.push(this._vertexToIndex(ho, Dl)), le1.push(this._vertexToIndex(ls, Dl))) : (le1.push(bt), le1.push(vt), le1.push(this._vertexToIndex(ls, Dl)), le1.push(this._vertexToIndex(ho, Dl)), le1.push(bt), le1.push(this._vertexToIndex(ls, Dl)));
                        }
                        _fillPoles(le1, vt, bt) {
                            const ls = this._vertexBuffer, ho = uc, Dl = le1.length;
                            for(let Fl = 2; Fl < Dl; Fl += 3){
                                const Dl = le1[Fl - 2], sc = le1[Fl - 1], uc = le1[Fl], mc = ls[2 * Dl], gc = ls[2 * Dl + 1], Ac = ls[2 * sc], Ec = ls[2 * sc + 1], kc = ls[2 * uc], du = ls[2 * uc + 1];
                                vt && (0 === gc && 0 === Ec && this._generatePoleQuad(le1, Dl, sc, mc, Ac, Ag), 0 === Ec && 0 === du && this._generatePoleQuad(le1, sc, uc, Ac, kc, Ag), 0 === du && 0 === gc && this._generatePoleQuad(le1, uc, Dl, kc, mc, Ag)), bt && (gc === ho && Ec === ho && this._generatePoleQuad(le1, Dl, sc, mc, Ac, _g), Ec === ho && du === ho && this._generatePoleQuad(le1, sc, uc, Ac, kc, _g), du === ho && gc === ho && this._generatePoleQuad(le1, uc, Dl, kc, mc, _g));
                            }
                        }
                        _initializeVertices(le1) {
                            for(let vt = 0; vt < le1.length; vt += 2)this._vertexToIndex(le1[vt], le1[vt + 1]);
                        }
                        subdividePolygonInternal(le1, vt) {
                            if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                            this._used = !0;
                            const { flattened: bt, holeIndices: ls } = function(le1) {
                                const vt = [], bt = [];
                                for (const ls of le1)if (0 !== ls.length) {
                                    ls !== le1[0] && vt.push(bt.length / 2);
                                    for(let le1 = 0; le1 < ls.length; le1++)bt.push(ls[le1].x), bt.push(ls[le1].y);
                                }
                                return {
                                    flattened: bt,
                                    holeIndices: vt
                                };
                            }(le1);
                            let ho;
                            this._initializeVertices(bt);
                            try {
                                const le1 = function(le1, vt, bt) {
                                    void 0 === bt && (bt = 2);
                                    const ls = vt && vt.length, ho = ls ? vt[0] * bt : le1.length;
                                    let Dl = Xa(le1, 0, ho, bt, !0);
                                    const Fl = [];
                                    if (!Dl || Dl.next === Dl.prev) return Fl;
                                    let sc, uc, mc;
                                    if (ls && (Dl = function(le1, vt, bt, ls) {
                                        const ho = [];
                                        for(let Dl = 0, Fl = vt.length; Dl < Fl; Dl++){
                                            const bt = Xa(le1, vt[Dl] * ls, Dl < Fl - 1 ? vt[Dl + 1] * ls : le1.length, ls, !1);
                                            bt === bt.next && (bt.steiner = !0), ho.push(nl(bt));
                                        }
                                        ho.sort(Qa);
                                        for(let Dl = 0; Dl < ho.length; Dl++)bt = el(ho[Dl], bt);
                                        return bt;
                                    }(le1, vt, Dl, bt)), le1.length > 80 * bt) {
                                        sc = le1[0], uc = le1[1];
                                        let vt = sc, ls = uc;
                                        for(let Dl = bt; Dl < ho; Dl += bt){
                                            const bt = le1[Dl], ho = le1[Dl + 1];
                                            bt < sc && (sc = bt), ho < uc && (uc = ho), bt > vt && (vt = bt), ho > ls && (ls = ho);
                                        }
                                        mc = Math.max(vt - sc, ls - uc), mc = 0 !== mc ? 32767 / mc : 0;
                                    }
                                    return Za(Dl, Fl, bt, sc, uc, mc, 0), Fl;
                                }(bt, ls), vt = this._convertIndices(bt, le1);
                                ho = this._subdivideTrianglesScanline(vt);
                            } catch (le1) {
                                console.error(le1);
                            }
                            let Dl = [];
                            return vt && (Dl = this._generateOutline(le1)), this._ensureNoPoleVertices(), this._handlePoles(ho), {
                                verticesFlattened: this._vertexBuffer,
                                indicesTriangles: ho,
                                indicesLineList: Dl
                            };
                        }
                        _convertIndices(le1, vt) {
                            const bt = [];
                            for(let ls = 0; ls < vt.length; ls++)bt.push(this._vertexToIndex(le1[2 * vt[ls]], le1[2 * vt[ls] + 1]));
                            return bt;
                        }
                        _pointArrayToIndices(le1) {
                            const vt = [];
                            for(let bt = 0; bt < le1.length; bt++){
                                const ls = le1[bt];
                                vt.push(this._vertexToIndex(ls.x, ls.y));
                            }
                            return vt;
                        }
                    }
                    function _l(le1, vt, bt, ls) {
                        return void 0 === ls && (ls = !0), new wl(bt, vt).subdividePolygonInternal(le1, ls);
                    }
                    function Sl(le1, vt, bt) {
                        if (void 0 === bt && (bt = !1), !le1 || le1.length < 1) return [];
                        if (le1.length < 2) return [];
                        const ls = le1[0], ho = le1[le1.length - 1], Dl = bt && (ls.x !== ho.x || ls.y !== ho.y);
                        if (vt < 2) return Dl ? [
                            ...le1,
                            le1[0]
                        ] : [
                            ...le1
                        ];
                        const Fl = Math.floor(uc / vt), sc = [];
                        sc.push(new t(le1[0].x, le1[0].y));
                        const mc = le1.length, gc = Dl ? mc : mc - 1;
                        for(let uc = 0; uc < gc; uc++){
                            const vt = le1[uc], bt = uc < mc - 1 ? le1[uc + 1] : le1[0], ls = vt.x, ho = vt.y, Dl = bt.x, gc = bt.y, Ac = ls !== Dl, Ec = ho !== gc;
                            if (!Ac && !Ec) continue;
                            const kc = Dl - ls, du = gc - ho, _u = Math.abs(kc), Md = Math.abs(du);
                            let Ld = ls, Nd = ho;
                            for(;;){
                                const le1 = kc > 0 ? (Math.floor(Ld / Fl) + 1) * Fl : (Math.ceil(Ld / Fl) - 1) * Fl, vt = du > 0 ? (Math.floor(Nd / Fl) + 1) * Fl : (Math.ceil(Nd / Fl) - 1) * Fl, bt = Math.abs(Ld - le1), ls = Math.abs(Nd - vt), ho = Math.abs(Ld - Dl), uc = Math.abs(Nd - gc), mc = Ac ? bt / _u : Number.POSITIVE_INFINITY, Rd = Ec ? ls / Md : Number.POSITIVE_INFINITY;
                                if ((ho <= bt || !Ac) && (uc <= ls || !Ec)) break;
                                if (mc < Rd && Ac || !Ec) {
                                    Ld = le1, Nd += du * mc;
                                    const vt = new t(Ld, Math.round(Nd));
                                    sc[sc.length - 1].x === vt.x && sc[sc.length - 1].y === vt.y || sc.push(vt);
                                } else {
                                    Ld += kc * Rd, Nd = vt;
                                    const le1 = new t(Math.round(Ld), Nd);
                                    sc[sc.length - 1].x === le1.x && sc[sc.length - 1].y === le1.y || sc.push(le1);
                                }
                            }
                            const Rd = new t(Dl, gc);
                            sc[sc.length - 1].x === Rd.x && sc[sc.length - 1].y === Rd.y || sc.push(Rd);
                        }
                        return sc;
                    }
                    function Al(le1, vt, bt) {
                        if (0 === vt.length) throw new Error("Subdivision vertex ring is empty.");
                        let ls = 0, ho = le1[2 * vt[0]];
                        for(let uc = 1; uc < vt.length; uc++){
                            const bt = le1[2 * vt[uc]];
                            bt < ho && (ho = bt, ls = uc);
                        }
                        const Dl = vt.length;
                        let Fl = ls, sc = (Fl + 1) % Dl;
                        for(;;){
                            const ls = Fl - 1 >= 0 ? Fl - 1 : Dl - 1, ho = (sc + 1) % Dl, uc = le1[2 * vt[ls]], mc = le1[2 * vt[ho]], gc = le1[2 * vt[Fl]], Ac = le1[2 * vt[Fl] + 1], Ec = le1[2 * vt[sc] + 1];
                            let kc = !1;
                            if (uc < mc) kc = !0;
                            else if (uc > mc) kc = !1;
                            else {
                                const bt = Ec - Ac, Dl = -(le1[2 * vt[sc]] - gc), Fl = Ac < Ec ? 1 : -1;
                                ((uc - gc) * bt + (le1[2 * vt[ls] + 1] - Ac) * Dl) * Fl > ((mc - gc) * bt + (le1[2 * vt[ho] + 1] - Ac) * Dl) * Fl && (kc = !0);
                            }
                            if (kc) {
                                const le1 = vt[ls], ho = vt[Fl], uc = vt[sc];
                                le1 !== ho && le1 !== uc && ho !== uc && bt.push(uc, ho, le1), Fl--, Fl < 0 && (Fl = Dl - 1);
                            } else {
                                const le1 = vt[ho], ls = vt[Fl], uc = vt[sc];
                                le1 !== ls && le1 !== uc && ls !== uc && bt.push(uc, ls, le1), sc++, sc >= Dl && (sc = 0);
                            }
                            if (ls === ho) break;
                        }
                    }
                    function Il(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                        const mc = ho.length / 2, gc = Fl && sc && uc;
                        if (mc < po.MAX_VERTEX_ARRAY_LENGTH) {
                            const Ac = vt.prepareSegment(mc, bt, ls), Ec = Ac.vertexLength;
                            for(let le1 = 0; le1 < Dl.length; le1 += 3)ls.emplaceBack(Ec + Dl[le1], Ec + Dl[le1 + 1], Ec + Dl[le1 + 2]);
                            let kc, du;
                            Ac.vertexLength += mc, Ac.primitiveLength += Dl.length / 3, gc && (du = Fl.prepareSegment(mc, bt, sc), kc = du.vertexLength, du.vertexLength += mc);
                            for(let vt = 0; vt < ho.length; vt += 2)le1(ho[vt], ho[vt + 1]);
                            if (gc) for(let le1 = 0; le1 < uc.length; le1++){
                                const vt = uc[le1];
                                for(let le1 = 1; le1 < vt.length; le1 += 2)sc.emplaceBack(kc + vt[le1 - 1], kc + vt[le1]);
                                du.primitiveLength += vt.length / 2;
                            }
                        } else !function(le1, vt, bt, ls, ho, Dl) {
                            const Fl = [];
                            for(let Ac = 0; Ac < ls.length / 2; Ac++)Fl.push(-1);
                            const sc = {
                                count: 0
                            };
                            let uc = 0, mc = le1.getOrCreateLatestSegment(vt, bt), gc = mc.vertexLength;
                            for(let Ac = 2; Ac < ho.length; Ac += 3){
                                const Ec = ho[Ac - 2], kc = ho[Ac - 1], du = ho[Ac];
                                let _u = Fl[Ec] < uc, Md = Fl[kc] < uc, Ld = Fl[du] < uc;
                                mc.vertexLength + ((_u ? 1 : 0) + (Md ? 1 : 0) + (Ld ? 1 : 0)) > po.MAX_VERTEX_ARRAY_LENGTH && (mc = le1.createNewSegment(vt, bt), uc = sc.count, _u = !0, Md = !0, Ld = !0, gc = 0);
                                const Nd = Tl(Fl, ls, Dl, sc, Ec, _u, mc), Rd = Tl(Fl, ls, Dl, sc, kc, Md, mc), Od = Tl(Fl, ls, Dl, sc, du, Ld, mc);
                                bt.emplaceBack(gc + Nd - uc, gc + Rd - uc, gc + Od - uc), mc.primitiveLength++;
                            }
                        }(vt, bt, ls, ho, Dl, le1), gc && function(le1, vt, bt, ls, ho, Dl) {
                            const Fl = [];
                            for(let Ac = 0; Ac < ls.length / 2; Ac++)Fl.push(-1);
                            const sc = {
                                count: 0
                            };
                            let uc = 0, mc = le1.getOrCreateLatestSegment(vt, bt), gc = mc.vertexLength;
                            for(let Ac = 0; Ac < ho.length; Ac++){
                                const Ec = ho[Ac];
                                for(let kc = 1; kc < ho[Ac].length; kc += 2){
                                    const ho = Ec[kc - 1], Ac = Ec[kc];
                                    let du = Fl[ho] < uc, _u = Fl[Ac] < uc;
                                    mc.vertexLength + ((du ? 1 : 0) + (_u ? 1 : 0)) > po.MAX_VERTEX_ARRAY_LENGTH && (mc = le1.createNewSegment(vt, bt), uc = sc.count, du = !0, _u = !0, gc = 0);
                                    const Md = Tl(Fl, ls, Dl, sc, ho, du, mc), Ld = Tl(Fl, ls, Dl, sc, Ac, _u, mc);
                                    bt.emplaceBack(gc + Md - uc, gc + Ld - uc), mc.primitiveLength++;
                                }
                            }
                        }(Fl, bt, sc, ho, uc, le1), vt.forceNewSegmentOnNextPrepare(), null == Fl || Fl.forceNewSegmentOnNextPrepare();
                    }
                    function Tl(le1, vt, bt, ls, ho, Dl, Fl) {
                        if (Dl) {
                            const Dl = ls.count;
                            return bt(vt[2 * ho], vt[2 * ho + 1]), le1[ho] = ls.count, ls.count++, Fl.vertexLength++, Dl;
                        }
                        return le1[ho];
                    }
                    class kl {
                        constructor(le1){
                            this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new Js, this.indexArray = new lo, this.indexArray2 = new uo, this.programConfigurations = new Uo(le1.layers, le1.zoom), this.segments = new po, this.segments2 = new po, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                        }
                        populate(le1, vt, bt) {
                            this.hasDependencies = Ga("fill", this.layers, vt);
                            const ls = this.layers[0].layout.get("fill-sort-key"), ho = !ls.isConstant(), Dl = [];
                            for (const { feature: Fl, id: sc, index: uc, sourceLayerIndex: mc } of le1){
                                const le1 = this.layers[0]._featureFilter.needGeometry, gc = Zo(Fl, le1);
                                if (!this.layers[0]._featureFilter.filter(new Gi(this.zoom), gc, bt)) continue;
                                const Ac = ho ? ls.evaluate(gc, {}, bt, vt.availableImages) : void 0, Ec = {
                                    id: sc,
                                    properties: Fl.properties,
                                    type: Fl.type,
                                    sourceLayerIndex: mc,
                                    index: uc,
                                    geometry: le1 ? gc.geometry : Yo(Fl),
                                    patterns: {},
                                    sortKey: Ac
                                };
                                Dl.push(Ec);
                            }
                            ho && Dl.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                            for (const Fl of Dl){
                                const { geometry: ls, index: ho, sourceLayerIndex: Dl } = Fl;
                                if (this.hasDependencies) {
                                    const le1 = ja("fill", this.layers, Fl, {
                                        zoom: this.zoom
                                    }, vt);
                                    this.patternFeatures.push(le1);
                                } else this.addFeature(Fl, ls, ho, bt, {}, vt.subdivisionGranularity);
                                vt.featureIndex.insert(le1[ho].feature, ls, ho, Dl, this.index);
                            }
                        }
                        update(le1, vt, bt) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                imagePositions: bt
                            });
                        }
                        addFeatures(le1, vt, bt) {
                            for (const ls of this.patternFeatures)this.addFeature(ls, ls.geometry, ls.index, vt, bt, le1.subdivisionGranularity);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(le1) {
                            this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, gg), this.indexBuffer = le1.createIndexBuffer(this.indexArray), this.indexBuffer2 = le1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(le1), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                        }
                        addFeature(le1, vt, bt, ls, ho, Dl) {
                            for (const Fl of Kt(vt, 500)){
                                const le1 = _l(Fl, ls, Dl.fill.getGranularityForZoomLevel(ls.z)), vt = this.layoutVertexArray;
                                Il((le1, bt)=>{
                                    vt.emplaceBack(le1, bt);
                                }, this.segments, this.layoutVertexArray, this.indexArray, le1.verticesFlattened, le1.indicesTriangles, this.segments2, this.indexArray2, le1.indicesLineList);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                imagePositions: ho,
                                canonical: ls
                            });
                        }
                    }
                    let yg, vg;
                    pi("FillBucket", kl, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var xg = {
                        get paint () {
                            return vg = vg || new os({
                                "fill-antialias": new ts(Ec.paint_fill["fill-antialias"]),
                                "fill-opacity": new rs(Ec.paint_fill["fill-opacity"]),
                                "fill-color": new rs(Ec.paint_fill["fill-color"]),
                                "fill-outline-color": new rs(Ec.paint_fill["fill-outline-color"]),
                                "fill-translate": new ts(Ec.paint_fill["fill-translate"]),
                                "fill-translate-anchor": new ts(Ec.paint_fill["fill-translate-anchor"]),
                                "fill-pattern": new ns(Ec.paint_fill["fill-pattern"])
                            });
                        },
                        get layout () {
                            return yg = yg || new os({
                                "fill-sort-key": new rs(Ec.layout_fill["fill-sort-key"])
                            });
                        }
                    };
                    class Pl extends as {
                        constructor(le1, vt){
                            super(le1, xg, vt);
                        }
                        recalculate(le1, vt) {
                            super.recalculate(le1, vt);
                            const bt = this.paint._values["fill-outline-color"];
                            "constant" === bt.value.kind && void 0 === bt.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                        }
                        createBucket(le1) {
                            return new kl(le1);
                        }
                        queryRadius() {
                            return ca(this.paint.get("fill-translate"));
                        }
                        queryIntersectsFeature(le1) {
                            let { queryGeometry: vt, geometry: bt, transform: ls, pixelsToTileUnits: ho } = le1;
                            return ea(ha(vt, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -ls.bearingInRadians, ho), bt);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    const bg = hs([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_normal_ed",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), wg = hs([
                        {
                            name: "a_centroid",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), { members: Eg } = bg;
                    class Cl {
                        constructor(le1, vt, bt, ls, ho){
                            this.properties = {}, this.extent = bt, this.type = 0, this.id = void 0, this._pbf = le1, this._geometry = -1, this._keys = ls, this._values = ho, le1.readFields(Vl, this, vt);
                        }
                        loadGeometry() {
                            const le1 = this._pbf;
                            le1.pos = this._geometry;
                            const vt = le1.readVarint() + le1.pos, bt = [];
                            let ls, ho = 1, Dl = 0, Fl = 0, sc = 0;
                            for(; le1.pos < vt;){
                                if (Dl <= 0) {
                                    const vt = le1.readVarint();
                                    ho = 7 & vt, Dl = vt >> 3;
                                }
                                if (Dl--, 1 === ho || 2 === ho) Fl += le1.readSVarint(), sc += le1.readSVarint(), 1 === ho && (ls && bt.push(ls), ls = []), ls && ls.push(new t(Fl, sc));
                                else {
                                    if (7 !== ho) throw new Error(`unknown command ${ho}`);
                                    ls && ls.push(ls[0].clone());
                                }
                            }
                            return ls && bt.push(ls), bt;
                        }
                        bbox() {
                            const le1 = this._pbf;
                            le1.pos = this._geometry;
                            const vt = le1.readVarint() + le1.pos;
                            let bt = 1, ls = 0, ho = 0, Dl = 0, Fl = 1 / 0, sc = -1 / 0, uc = 1 / 0, mc = -1 / 0;
                            for(; le1.pos < vt;){
                                if (ls <= 0) {
                                    const vt = le1.readVarint();
                                    bt = 7 & vt, ls = vt >> 3;
                                }
                                if (ls--, 1 === bt || 2 === bt) ho += le1.readSVarint(), Dl += le1.readSVarint(), ho < Fl && (Fl = ho), ho > sc && (sc = ho), Dl < uc && (uc = Dl), Dl > mc && (mc = Dl);
                                else if (7 !== bt) throw new Error(`unknown command ${bt}`);
                            }
                            return [
                                Fl,
                                uc,
                                sc,
                                mc
                            ];
                        }
                        toGeoJSON(le1, vt, bt) {
                            const ls = this.extent * Math.pow(2, bt), ho = this.extent * le1, Dl = this.extent * vt, Fl = this.loadGeometry();
                            function a(le1) {
                                return [
                                    360 * (le1.x + ho) / ls - 180,
                                    360 / Math.PI * Math.atan(Math.exp((1 - 2 * (le1.y + Dl) / ls) * Math.PI)) - 90
                                ];
                            }
                            function l(le1) {
                                return le1.map(a);
                            }
                            let sc;
                            if (1 === this.type) {
                                const le1 = [];
                                for (const bt of Fl)le1.push(bt[0]);
                                const vt = l(le1);
                                sc = 1 === le1.length ? {
                                    type: "Point",
                                    coordinates: vt[0]
                                } : {
                                    type: "MultiPoint",
                                    coordinates: vt
                                };
                            } else if (2 === this.type) {
                                const le1 = Fl.map(l);
                                sc = 1 === le1.length ? {
                                    type: "LineString",
                                    coordinates: le1[0]
                                } : {
                                    type: "MultiLineString",
                                    coordinates: le1
                                };
                            } else {
                                if (3 !== this.type) throw new Error("unknown feature type");
                                {
                                    const le1 = Ll(Fl), vt = [];
                                    for (const bt of le1)vt.push(bt.map(l));
                                    sc = 1 === vt.length ? {
                                        type: "Polygon",
                                        coordinates: vt[0]
                                    } : {
                                        type: "MultiPolygon",
                                        coordinates: vt
                                    };
                                }
                            }
                            const uc = {
                                type: "Feature",
                                geometry: sc,
                                properties: this.properties
                            };
                            return null != this.id && (uc.id = this.id), uc;
                        }
                    }
                    function Vl(le1, vt, bt) {
                        1 === le1 ? vt.id = bt.readVarint() : 2 === le1 ? function(le1, vt) {
                            const bt = le1.readVarint() + le1.pos;
                            for(; le1.pos < bt;){
                                const bt = vt._keys[le1.readVarint()], ls = vt._values[le1.readVarint()];
                                vt.properties[bt] = ls;
                            }
                        }(bt, vt) : 3 === le1 ? vt.type = bt.readVarint() : 4 === le1 && (vt._geometry = bt.pos);
                    }
                    function Ll(le1) {
                        const vt = le1.length;
                        if (vt <= 1) return [
                            le1
                        ];
                        const bt = [];
                        let ls, ho;
                        for(let Dl = 0; Dl < vt; Dl++){
                            const vt = Ol(le1[Dl]);
                            0 !== vt && (void 0 === ho && (ho = vt < 0), ho === vt < 0 ? (ls && bt.push(ls), ls = [
                                le1[Dl]
                            ]) : ls && ls.push(le1[Dl]));
                        }
                        return ls && bt.push(ls), bt;
                    }
                    function Ol(le1) {
                        let vt = 0;
                        for(let bt, ls, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++)bt = le1[ho], ls = le1[Fl], vt += (ls.x - bt.x) * (bt.y + ls.y);
                        return vt;
                    }
                    Cl.types = [
                        "Unknown",
                        "Point",
                        "LineString",
                        "Polygon"
                    ];
                    class Rl {
                        constructor(le1, vt){
                            this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = le1, this._keys = [], this._values = [], this._features = [], le1.readFields(Nl, this, vt), this.length = this._features.length;
                        }
                        feature(le1) {
                            if (le1 < 0 || le1 >= this._features.length) throw new Error("feature index out of bounds");
                            this._pbf.pos = this._features[le1];
                            const vt = this._pbf.readVarint() + this._pbf.pos;
                            return new Cl(this._pbf, vt, this.extent, this._keys, this._values);
                        }
                    }
                    function Nl(le1, vt, bt) {
                        15 === le1 ? vt.version = bt.readVarint() : 1 === le1 ? vt.name = bt.readString() : 5 === le1 ? vt.extent = bt.readVarint() : 2 === le1 ? vt._features.push(bt.pos) : 3 === le1 ? vt._keys.push(bt.readString()) : 4 === le1 && vt._values.push(function(le1) {
                            let vt = null;
                            const bt = le1.readVarint() + le1.pos;
                            for(; le1.pos < bt;){
                                const bt = le1.readVarint() >> 3;
                                vt = 1 === bt ? le1.readString() : 2 === bt ? le1.readFloat() : 3 === bt ? le1.readDouble() : 4 === bt ? le1.readVarint64() : 5 === bt ? le1.readVarint() : 6 === bt ? le1.readSVarint() : 7 === bt ? le1.readBoolean() : null;
                            }
                            if (null == vt) throw new Error("unknown feature value");
                            return vt;
                        }(bt));
                    }
                    class $l {
                        constructor(le1, vt){
                            this.layers = le1.readFields(Ul, {}, vt);
                        }
                    }
                    function Ul(le1, vt, bt) {
                        if (3 === le1) {
                            const le1 = new Rl(bt, bt.readVarint() + bt.pos);
                            le1.length && (vt[le1.name] = le1);
                        }
                    }
                    const Mg = Math.pow(2, 13);
                    function Gl(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        le1.emplaceBack(vt, bt, 2 * Math.floor(ls * Mg) + Fl, ho * Mg * 2, Dl * Mg * 2, Math.round(sc));
                    }
                    class jl {
                        constructor(le1){
                            this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.layoutVertexArray = new Ks, this.centroidVertexArray = new Hs, this.indexArray = new lo, this.programConfigurations = new Uo(le1.layers, le1.zoom), this.segments = new po, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                        }
                        populate(le1, vt, bt) {
                            this.features = [], this.hasDependencies = Ga("fill-extrusion", this.layers, vt);
                            for (const { feature: ls, id: ho, index: Dl, sourceLayerIndex: Fl } of le1){
                                const le1 = this.layers[0]._featureFilter.needGeometry, sc = Zo(ls, le1);
                                if (!this.layers[0]._featureFilter.filter(new Gi(this.zoom), sc, bt)) continue;
                                const uc = {
                                    id: ho,
                                    sourceLayerIndex: Fl,
                                    index: Dl,
                                    geometry: le1 ? sc.geometry : Yo(ls),
                                    properties: ls.properties,
                                    type: ls.type,
                                    patterns: {}
                                };
                                this.hasDependencies ? this.features.push(ja("fill-extrusion", this.layers, uc, {
                                    zoom: this.zoom
                                }, vt)) : this.addFeature(uc, uc.geometry, Dl, bt, {}, vt.subdivisionGranularity), vt.featureIndex.insert(ls, uc.geometry, Dl, Fl, this.index, !0);
                            }
                        }
                        addFeatures(le1, vt, bt) {
                            for (const ls of this.features){
                                const { geometry: ho } = ls;
                                this.addFeature(ls, ho, ls.index, vt, bt, le1.subdivisionGranularity);
                            }
                        }
                        update(le1, vt, bt) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                imagePositions: bt
                            });
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(le1) {
                            this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Eg), this.centroidVertexBuffer = le1.createVertexBuffer(this.centroidVertexArray, wg.members, !0), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                        }
                        addFeature(le1, vt, bt, ls, ho, Dl) {
                            for (const Fl of Kt(vt, 500)){
                                const vt = {
                                    x: 0,
                                    y: 0,
                                    sampleCount: 0
                                }, bt = this.layoutVertexArray.length;
                                this.processPolygon(vt, ls, le1, Fl, Dl);
                                const ho = this.layoutVertexArray.length - bt, sc = Math.floor(vt.x / vt.sampleCount), uc = Math.floor(vt.y / vt.sampleCount);
                                for(let le1 = 0; le1 < ho; le1++)this.centroidVertexArray.emplaceBack(sc, uc);
                            }
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                imagePositions: ho,
                                canonical: ls
                            });
                        }
                        processPolygon(le1, vt, bt, ls, ho) {
                            if (ls.length < 1) return;
                            if (Zl(ls[0])) return;
                            for (const gc of ls)0 !== gc.length && Xl(le1, gc);
                            const Dl = {
                                segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                            }, Fl = ho.fill.getGranularityForZoomLevel(vt.z), sc = "Polygon" === Cl.types[bt.type];
                            for (const gc of ls){
                                if (0 === gc.length) continue;
                                if (Zl(gc)) continue;
                                const le1 = Sl(gc, Fl, sc);
                                this._generateSideFaces(le1, Dl);
                            }
                            if (!sc) return;
                            const uc = _l(ls, vt, Fl, !1), mc = this.layoutVertexArray;
                            Il((le1, vt)=>{
                                Gl(mc, le1, vt, 0, 0, 1, 1, 0);
                            }, this.segments, this.layoutVertexArray, this.indexArray, uc.verticesFlattened, uc.indicesTriangles);
                        }
                        _generateSideFaces(le1, vt) {
                            let bt = 0;
                            for(let ls = 1; ls < le1.length; ls++){
                                const ho = le1[ls], Dl = le1[ls - 1];
                                if (Yl(ho, Dl)) continue;
                                vt.segment.vertexLength + 4 > po.MAX_VERTEX_ARRAY_LENGTH && (vt.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                const Fl = ho.sub(Dl)._perp()._unit(), sc = Dl.dist(ho);
                                bt + sc > 32768 && (bt = 0), Gl(this.layoutVertexArray, ho.x, ho.y, Fl.x, Fl.y, 0, 0, bt), Gl(this.layoutVertexArray, ho.x, ho.y, Fl.x, Fl.y, 0, 1, bt), bt += sc, Gl(this.layoutVertexArray, Dl.x, Dl.y, Fl.x, Fl.y, 0, 0, bt), Gl(this.layoutVertexArray, Dl.x, Dl.y, Fl.x, Fl.y, 0, 1, bt);
                                const uc = vt.segment.vertexLength;
                                this.indexArray.emplaceBack(uc, uc + 2, uc + 1), this.indexArray.emplaceBack(uc + 1, uc + 2, uc + 3), vt.segment.vertexLength += 4, vt.segment.primitiveLength += 2;
                            }
                        }
                    }
                    function Xl(le1, vt) {
                        for(let bt = 0; bt < vt.length; bt++){
                            const ls = vt[bt];
                            bt === vt.length - 1 && vt[0].x === ls.x && vt[0].y === ls.y || (le1.x += ls.x, le1.y += ls.y, le1.sampleCount++);
                        }
                    }
                    function Yl(le1, vt) {
                        return le1.x === vt.x && (le1.x < 0 || le1.x > uc) || le1.y === vt.y && (le1.y < 0 || le1.y > uc);
                    }
                    function Zl(le1) {
                        return le1.every((le1)=>le1.x < 0) || le1.every((le1)=>le1.x > uc) || le1.every((le1)=>le1.y < 0) || le1.every((le1)=>le1.y > uc);
                    }
                    let Sg;
                    pi("FillExtrusionBucket", jl, {
                        omit: [
                            "layers",
                            "features"
                        ]
                    });
                    var Tg = {
                        get paint () {
                            return Sg = Sg || new os({
                                "fill-extrusion-opacity": new ts(Ec["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                "fill-extrusion-color": new rs(Ec["paint_fill-extrusion"]["fill-extrusion-color"]),
                                "fill-extrusion-translate": new ts(Ec["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                "fill-extrusion-translate-anchor": new ts(Ec["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                "fill-extrusion-pattern": new ns(Ec["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                "fill-extrusion-height": new rs(Ec["paint_fill-extrusion"]["fill-extrusion-height"]),
                                "fill-extrusion-base": new rs(Ec["paint_fill-extrusion"]["fill-extrusion-base"]),
                                "fill-extrusion-vertical-gradient": new ts(Ec["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                            });
                        }
                    };
                    class Jl extends as {
                        constructor(le1, vt){
                            super(le1, Tg, vt);
                        }
                        createBucket(le1) {
                            return new jl(le1);
                        }
                        queryRadius() {
                            return ca(this.paint.get("fill-extrusion-translate"));
                        }
                        is3D() {
                            return !0;
                        }
                        queryIntersectsFeature(le1) {
                            let { queryGeometry: vt, feature: bt, featureState: ls, geometry: ho, transform: Dl, pixelsToTileUnits: Fl, pixelPosMatrix: sc } = le1;
                            const uc = ha(vt, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -Dl.bearingInRadians, Fl), mc = this.paint.get("fill-extrusion-height").evaluate(bt, ls), gc = this.paint.get("fill-extrusion-base").evaluate(bt, ls), Ac = function(le1, vt) {
                                const bt = [];
                                for (const ls of le1){
                                    const le1 = [
                                        ls.x,
                                        ls.y,
                                        0,
                                        1
                                    ];
                                    h(le1, le1, vt), bt.push(new t(le1[0] / le1[3], le1[1] / le1[3]));
                                }
                                return bt;
                            }(uc, sc), Ec = function(le1, vt, bt, ls) {
                                const ho = [], Dl = [], Fl = ls[8] * vt, sc = ls[9] * vt, uc = ls[10] * vt, mc = ls[11] * vt, gc = ls[8] * bt, Ac = ls[9] * bt, Ec = ls[10] * bt, kc = ls[11] * bt;
                                for (const du of le1){
                                    const le1 = [], vt = [];
                                    for (const bt of du){
                                        const ho = bt.x, Dl = bt.y, du = ls[0] * ho + ls[4] * Dl + ls[12], _u = ls[1] * ho + ls[5] * Dl + ls[13], Md = ls[2] * ho + ls[6] * Dl + ls[14], Ld = ls[3] * ho + ls[7] * Dl + ls[15], Nd = Md + uc, Rd = Ld + mc, Od = du + gc, jd = _u + Ac, Ud = Md + Ec, Gd = Ld + kc, qd = new t((du + Fl) / Rd, (_u + sc) / Rd);
                                        qd.z = Nd / Rd, le1.push(qd);
                                        const Hd = new t(Od / Gd, jd / Gd);
                                        Hd.z = Ud / Gd, vt.push(Hd);
                                    }
                                    ho.push(le1), Dl.push(vt);
                                }
                                return [
                                    ho,
                                    Dl
                                ];
                            }(ho, gc, mc, sc);
                            return function(le1, vt, bt) {
                                let ls = 1 / 0;
                                ea(bt, vt) && (ls = Ql(bt, vt[0]));
                                for(let ho = 0; ho < vt.length; ho++){
                                    const Dl = vt[ho], Fl = le1[ho];
                                    for(let le1 = 0; le1 < Dl.length - 1; le1++){
                                        const vt = Dl[le1], ho = [
                                            vt,
                                            Dl[le1 + 1],
                                            Fl[le1 + 1],
                                            Fl[le1],
                                            vt
                                        ];
                                        Ko(bt, ho) && (ls = Math.min(ls, Ql(bt, ho)));
                                    }
                                }
                                return ls !== 1 / 0 && ls;
                            }(Ec[0], Ec[1], Ac);
                        }
                    }
                    function Kl(le1, vt) {
                        return le1.x * vt.x + le1.y * vt.y;
                    }
                    function Ql(le1, vt) {
                        if (1 === le1.length) {
                            let bt = 0;
                            const ls = vt[bt++];
                            let ho;
                            for(; !ho || ls.equals(ho);)if (ho = vt[bt++], !ho) return 1 / 0;
                            for(; bt < vt.length; bt++){
                                const Dl = vt[bt], Fl = le1[0], sc = ho.sub(ls), uc = Dl.sub(ls), mc = Fl.sub(ls), gc = Kl(sc, sc), Ac = Kl(sc, uc), Ec = Kl(uc, uc), kc = Kl(mc, sc), du = Kl(mc, uc), _u = gc * Ec - Ac * Ac, Md = (Ec * kc - Ac * du) / _u, Ld = (gc * du - Ac * kc) / _u, Nd = ls.z * (1 - Md - Ld) + ho.z * Md + Dl.z * Ld;
                                if (isFinite(Nd)) return Nd;
                            }
                            return 1 / 0;
                        }
                        {
                            let le1 = 1 / 0;
                            for (const bt of vt)le1 = Math.min(le1, bt.z);
                            return le1;
                        }
                    }
                    const kg = hs([
                        {
                            name: "a_pos_normal",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint8"
                        }
                    ], 4), { members: Cg } = kg, Ig = hs([
                        {
                            name: "a_uv_x",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_split_index",
                            components: 1,
                            type: "Float32"
                        }
                    ]), { members: Dg } = Ig, Lg = Math.cos(Math.PI / 180 * 37.5), Pg = Math.pow(2, 14) / .5;
                    class ou {
                        constructor(le1){
                            this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((le1)=>{
                                this.gradients[le1.id] = {};
                            }), this.layoutVertexArray = new Qs, this.layoutVertexArray2 = new eo, this.indexArray = new lo, this.programConfigurations = new Uo(le1.layers, le1.zoom), this.segments = new po, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                        }
                        populate(le1, vt, bt) {
                            this.hasDependencies = Ga("line", this.layers, vt) || this.hasLineDasharray(this.layers);
                            const ls = this.layers[0].layout.get("line-sort-key"), ho = !ls.isConstant(), Dl = [];
                            for (const { feature: Fl, id: sc, index: uc, sourceLayerIndex: mc } of le1){
                                const le1 = this.layers[0]._featureFilter.needGeometry, vt = Zo(Fl, le1);
                                if (!this.layers[0]._featureFilter.filter(new Gi(this.zoom), vt, bt)) continue;
                                const gc = ho ? ls.evaluate(vt, {}, bt) : void 0, Ac = {
                                    id: sc,
                                    properties: Fl.properties,
                                    type: Fl.type,
                                    sourceLayerIndex: mc,
                                    index: uc,
                                    geometry: le1 ? vt.geometry : Yo(Fl),
                                    patterns: {},
                                    dashes: {},
                                    sortKey: gc
                                };
                                Dl.push(Ac);
                            }
                            ho && Dl.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                            for (const Fl of Dl){
                                const { geometry: ls, index: ho, sourceLayerIndex: Dl } = Fl;
                                this.hasDependencies ? (Ga("line", this.layers, vt) ? ja("line", this.layers, Fl, {
                                    zoom: this.zoom
                                }, vt) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, Fl, this.zoom, vt), this.patternFeatures.push(Fl)) : this.addFeature(Fl, ls, ho, bt, {}, {}, vt.subdivisionGranularity), vt.featureIndex.insert(le1[ho].feature, ls, ho, Dl, this.index);
                            }
                        }
                        update(le1, vt, bt, ls) {
                            this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                imagePositions: bt,
                                dashPositions: ls
                            });
                        }
                        addFeatures(le1, vt, bt, ls) {
                            for (const ho of this.patternFeatures)this.addFeature(ho, ho.geometry, ho.index, vt, bt, ls, le1.subdivisionGranularity);
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length;
                        }
                        uploadPending() {
                            return !this.uploaded || this.programConfigurations.needsUpload;
                        }
                        upload(le1) {
                            this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = le1.createVertexBuffer(this.layoutVertexArray2, Dg)), this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Cg), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                        }
                        lineFeatureClips(le1) {
                            if (le1.properties && Object.prototype.hasOwnProperty.call(le1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(le1.properties, "mapbox_clip_end")) return {
                                start: +le1.properties.mapbox_clip_start,
                                end: +le1.properties.mapbox_clip_end
                            };
                        }
                        addFeature(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = this.layers[0].layout, uc = sc.get("line-join").evaluate(le1, {}), mc = sc.get("line-cap"), gc = sc.get("line-miter-limit"), Ac = sc.get("line-round-limit");
                            this.lineClips = this.lineFeatureClips(le1);
                            for (const Ec of vt)this.addLine(Ec, le1, uc, mc, gc, Ac, ls, Fl);
                            this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                imagePositions: ho,
                                dashPositions: Dl,
                                canonical: ls
                            });
                        }
                        addLine(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, le1 = Sl(le1, Fl ? sc.line.getGranularityForZoomLevel(Fl.z) : 1), this.lineClips) {
                                this.lineClipsArray.push(this.lineClips);
                                for(let vt = 0; vt < le1.length - 1; vt++)this.totalDistance += le1[vt].dist(le1[vt + 1]);
                                this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                            }
                            const uc = "Polygon" === Cl.types[vt.type];
                            let mc = le1.length;
                            for(; mc >= 2 && le1[mc - 1].equals(le1[mc - 2]);)mc--;
                            let gc = 0;
                            for(; gc < mc - 1 && le1[gc].equals(le1[gc + 1]);)gc++;
                            if (mc < (uc ? 3 : 2)) return;
                            "bevel" === bt && (ho = 1.05);
                            const Ac = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, Ec = this.segments.prepareSegment(10 * mc, this.layoutVertexArray, this.indexArray);
                            let kc, du, _u, Md, Ld;
                            this.e1 = this.e2 = -1, uc && (kc = le1[mc - 2], Ld = le1[gc].sub(kc)._unit()._perp());
                            for(let Nd = gc; Nd < mc; Nd++){
                                if (_u = Nd === mc - 1 ? uc ? le1[gc + 1] : void 0 : le1[Nd + 1], _u && le1[Nd].equals(_u)) continue;
                                Ld && (Md = Ld), kc && (du = kc), kc = le1[Nd], Ld = _u ? _u.sub(kc)._unit()._perp() : Md, Md = Md || Ld;
                                let vt = Md.add(Ld);
                                0 === vt.x && 0 === vt.y || vt._unit();
                                const Fl = Md.x * Ld.x + Md.y * Ld.y, sc = vt.x * Ld.x + vt.y * Ld.y, Rd = 0 !== sc ? 1 / sc : 1 / 0, Od = 2 * Math.sqrt(2 - 2 * sc), jd = sc < Lg && du && _u, Ud = Md.x * Ld.y - Md.y * Ld.x > 0;
                                if (jd && Nd > gc) {
                                    const le1 = kc.dist(du);
                                    if (le1 > 2 * Ac) {
                                        const vt = kc.sub(kc.sub(du)._mult(Ac / le1)._round());
                                        this.updateDistance(du, vt), this.addCurrentVertex(vt, Md, 0, 0, Ec), du = vt;
                                    }
                                }
                                const Gd = du && _u;
                                let qd = Gd ? bt : uc ? "butt" : ls;
                                if (Gd && "round" === qd && (Rd < Dl ? qd = "miter" : Rd <= 2 && (qd = "fakeround")), "miter" === qd && Rd > ho && (qd = "bevel"), "bevel" === qd && (Rd > 2 && (qd = "flipbevel"), Rd < ho && (qd = "miter")), du && this.updateDistance(du, kc), "miter" === qd) vt._mult(Rd), this.addCurrentVertex(kc, vt, 0, 0, Ec);
                                else if ("flipbevel" === qd) {
                                    if (Rd > 100) vt = Ld.mult(-1);
                                    else {
                                        const le1 = Rd * Md.add(Ld).mag() / Md.sub(Ld).mag();
                                        vt._perp()._mult(le1 * (Ud ? -1 : 1));
                                    }
                                    this.addCurrentVertex(kc, vt, 0, 0, Ec), this.addCurrentVertex(kc, vt.mult(-1), 0, 0, Ec);
                                } else if ("bevel" === qd || "fakeround" === qd) {
                                    const le1 = -Math.sqrt(Rd * Rd - 1), vt = Ud ? le1 : 0, bt = Ud ? 0 : le1;
                                    if (du && this.addCurrentVertex(kc, Md, vt, bt, Ec), "fakeround" === qd) {
                                        const le1 = Math.round(180 * Od / Math.PI / 20);
                                        for(let vt = 1; vt < le1; vt++){
                                            let bt = vt / le1;
                                            if (.5 !== bt) {
                                                const le1 = bt - .5;
                                                bt += bt * le1 * (bt - 1) * ((1.0904 + Fl * (Fl * (3.55645 - 1.43519 * Fl) - 3.2452)) * le1 * le1 + (.848013 + Fl * (.215638 * Fl - 1.06021)));
                                            }
                                            const ls = Ld.sub(Md)._mult(bt)._add(Md)._unit()._mult(Ud ? -1 : 1);
                                            this.addHalfVertex(kc, ls.x, ls.y, !1, Ud, 0, Ec);
                                        }
                                    }
                                    _u && this.addCurrentVertex(kc, Ld, -vt, -bt, Ec);
                                } else if ("butt" === qd) this.addCurrentVertex(kc, vt, 0, 0, Ec);
                                else if ("square" === qd) {
                                    const le1 = du ? 1 : -1;
                                    this.addCurrentVertex(kc, vt, le1, le1, Ec);
                                } else "round" === qd && (du && (this.addCurrentVertex(kc, Md, 0, 0, Ec), this.addCurrentVertex(kc, Md, 1, 1, Ec, !0)), _u && (this.addCurrentVertex(kc, Ld, -1, -1, Ec, !0), this.addCurrentVertex(kc, Ld, 0, 0, Ec)));
                                if (jd && Nd < mc - 1) {
                                    const le1 = kc.dist(_u);
                                    if (le1 > 2 * Ac) {
                                        const vt = kc.add(_u.sub(kc)._mult(Ac / le1)._round());
                                        this.updateDistance(kc, vt), this.addCurrentVertex(vt, Ld, 0, 0, Ec), kc = vt;
                                    }
                                }
                            }
                        }
                        addCurrentVertex(le1, vt, bt, ls, ho, Dl) {
                            void 0 === Dl && (Dl = !1);
                            const Fl = vt.y * ls - vt.x, sc = -vt.y - vt.x * ls;
                            this.addHalfVertex(le1, vt.x + vt.y * bt, vt.y - vt.x * bt, Dl, !1, bt, ho), this.addHalfVertex(le1, Fl, sc, Dl, !0, -ls, ho), this.distance > Pg / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(le1, vt, bt, ls, ho, Dl));
                        }
                        addHalfVertex(le1, vt, bt, ls, ho, Dl, Fl) {
                            let { x: sc, y: uc } = le1;
                            const mc = .5 * (this.lineClips ? this.scaledDistance * (Pg - 1) : this.scaledDistance);
                            this.layoutVertexArray.emplaceBack((sc << 1) + (ls ? 1 : 0), (uc << 1) + (ho ? 1 : 0), Math.round(63 * vt) + 128, Math.round(63 * bt) + 128, 1 + (0 === Dl ? 0 : Dl < 0 ? -1 : 1) | (63 & mc) << 2, mc >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                            const gc = Fl.vertexLength++;
                            this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, gc, this.e2), Fl.primitiveLength++), ho ? this.e2 = gc : this.e1 = gc;
                        }
                        updateScaledDistance() {
                            this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                        }
                        updateDistance(le1, vt) {
                            this.distance += le1.dist(vt), this.updateScaledDistance();
                        }
                        hasLineDasharray(le1) {
                            for (const vt of le1){
                                const le1 = vt.paint.get("line-dasharray");
                                if (le1 && !le1.isConstant()) return !0;
                            }
                            return !1;
                        }
                        addLineDashDependencies(le1, vt, bt, ls) {
                            for (const ho of le1){
                                const le1 = ho.paint.get("line-dasharray");
                                if (!le1 || "constant" === le1.value.kind) continue;
                                const Dl = "round" === ho.layout.get("line-cap"), Fl = {
                                    dasharray: le1.value.evaluate({
                                        zoom: bt - 1
                                    }, vt, {}),
                                    round: Dl
                                }, sc = {
                                    dasharray: le1.value.evaluate({
                                        zoom: bt
                                    }, vt, {}),
                                    round: Dl
                                }, uc = {
                                    dasharray: le1.value.evaluate({
                                        zoom: bt + 1
                                    }, vt, {}),
                                    round: Dl
                                }, mc = `${Fl.dasharray.join(",")},${Fl.round}`, gc = `${sc.dasharray.join(",")},${sc.round}`, Ac = `${uc.dasharray.join(",")},${uc.round}`;
                                ls.dashDependencies[mc] = Fl, ls.dashDependencies[gc] = sc, ls.dashDependencies[Ac] = uc, vt.dashes[ho.id] = {
                                    min: mc,
                                    mid: gc,
                                    max: Ac
                                };
                            }
                        }
                    }
                    let zg, Ng;
                    pi("LineBucket", ou, {
                        omit: [
                            "layers",
                            "patternFeatures"
                        ]
                    });
                    var Rg = {
                        get paint () {
                            return Ng = Ng || new os({
                                "line-opacity": new rs(Ec.paint_line["line-opacity"]),
                                "line-color": new rs(Ec.paint_line["line-color"]),
                                "line-translate": new ts(Ec.paint_line["line-translate"]),
                                "line-translate-anchor": new ts(Ec.paint_line["line-translate-anchor"]),
                                "line-width": new rs(Ec.paint_line["line-width"]),
                                "line-gap-width": new rs(Ec.paint_line["line-gap-width"]),
                                "line-offset": new rs(Ec.paint_line["line-offset"]),
                                "line-blur": new rs(Ec.paint_line["line-blur"]),
                                "line-dasharray": new ns(Ec.paint_line["line-dasharray"]),
                                "line-pattern": new ns(Ec.paint_line["line-pattern"]),
                                "line-gradient": new ss(Ec.paint_line["line-gradient"])
                            });
                        },
                        get layout () {
                            return zg = zg || new os({
                                "line-cap": new ts(Ec.layout_line["line-cap"]),
                                "line-join": new rs(Ec.layout_line["line-join"]),
                                "line-miter-limit": new ts(Ec.layout_line["line-miter-limit"]),
                                "line-round-limit": new ts(Ec.layout_line["line-round-limit"]),
                                "line-sort-key": new rs(Ec.layout_line["line-sort-key"])
                            });
                        }
                    };
                    class cu extends rs {
                        possiblyEvaluate(le1, vt) {
                            return vt = new Gi(Math.floor(vt.zoom), {
                                now: vt.now,
                                fadeDuration: vt.fadeDuration,
                                zoomHistory: vt.zoomHistory,
                                transition: vt.transition
                            }), super.possiblyEvaluate(le1, vt);
                        }
                        evaluate(le1, vt, bt, ls) {
                            return vt = d({}, vt, {
                                zoom: Math.floor(vt.zoom)
                            }), super.evaluate(le1, vt, bt, ls);
                        }
                    }
                    let Fg;
                    class pu extends as {
                        constructor(le1, vt){
                            super(le1, Rg, vt), this.gradientVersion = 0, Fg || (Fg = new cu(Rg.paint.properties["line-width"].specification), Fg.useIntegerZoom = !0);
                        }
                        _handleSpecialPaintPropertyUpdate(le1) {
                            if ("line-gradient" === le1) {
                                const le1 = this.gradientExpression();
                                this.stepInterpolant = !!function(le1) {
                                    return void 0 !== le1._styleExpression;
                                }(le1) && le1._styleExpression.expression instanceof st, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                            }
                        }
                        gradientExpression() {
                            return this._transitionablePaint._values["line-gradient"].value.expression;
                        }
                        recalculate(le1, vt) {
                            super.recalculate(le1, vt), this.paint._values["line-floorwidth"] = Fg.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, le1);
                        }
                        createBucket(le1) {
                            return new ou(le1);
                        }
                        queryRadius(le1) {
                            const vt = le1, bt = fu(ua("line-width", this, vt), ua("line-gap-width", this, vt)), ls = ua("line-offset", this, vt);
                            return bt / 2 + Math.abs(ls) + ca(this.paint.get("line-translate"));
                        }
                        queryIntersectsFeature(le1) {
                            let { queryGeometry: vt, feature: bt, featureState: ls, geometry: ho, transform: Dl, pixelsToTileUnits: Fl } = le1;
                            const sc = ha(vt, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -Dl.bearingInRadians, Fl), uc = Fl / 2 * fu(this.paint.get("line-width").evaluate(bt, ls), this.paint.get("line-gap-width").evaluate(bt, ls)), mc = this.paint.get("line-offset").evaluate(bt, ls);
                            return mc && (ho = function(le1, vt) {
                                const bt = [];
                                for(let ls = 0; ls < le1.length; ls++){
                                    const ho = pa(le1[ls]), Dl = [];
                                    for(let le1 = 0; le1 < ho.length; le1++){
                                        const bt = ho[le1], ls = ho[le1 - 1], Fl = ho[le1 + 1], sc = 0 === le1 ? new t(0, 0) : bt.sub(ls)._unit()._perp(), uc = le1 === ho.length - 1 ? new t(0, 0) : Fl.sub(bt)._unit()._perp(), mc = sc._add(uc)._unit(), gc = mc.x * uc.x + mc.y * uc.y;
                                        0 !== gc && mc._mult(1 / gc), Dl.push(mc._mult(vt)._add(bt));
                                    }
                                    bt.push(Dl);
                                }
                                return bt;
                            }(ho, mc * Fl)), function(le1, vt, bt) {
                                for(let ls = 0; ls < vt.length; ls++){
                                    const ho = vt[ls];
                                    if (le1.length >= 3) {
                                        for(let vt = 0; vt < ho.length; vt++)if (aa(le1, ho[vt])) return !0;
                                    }
                                    if (ta(le1, ho, bt)) return !0;
                                }
                                return !1;
                            }(sc, ho, uc);
                        }
                        isTileClipped() {
                            return !0;
                        }
                    }
                    function fu(le1, vt) {
                        return vt > 0 ? vt + 2 * le1 : le1;
                    }
                    const Og = hs([
                        {
                            name: "a_pos_offset",
                            components: 4,
                            type: "Int16"
                        },
                        {
                            name: "a_data",
                            components: 4,
                            type: "Uint16"
                        },
                        {
                            name: "a_pixeloffset",
                            components: 4,
                            type: "Int16"
                        }
                    ], 4), Bg = hs([
                        {
                            name: "a_projected_pos",
                            components: 3,
                            type: "Float32"
                        }
                    ], 4);
                    hs([
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint32"
                        }
                    ], 4);
                    const jg = hs([
                        {
                            name: "a_placed",
                            components: 2,
                            type: "Uint8"
                        },
                        {
                            name: "a_shift",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_box_real",
                            components: 2,
                            type: "Int16"
                        }
                    ]);
                    hs([
                        {
                            type: "Int16",
                            name: "anchorPointX"
                        },
                        {
                            type: "Int16",
                            name: "anchorPointY"
                        },
                        {
                            type: "Int16",
                            name: "x1"
                        },
                        {
                            type: "Int16",
                            name: "y1"
                        },
                        {
                            type: "Int16",
                            name: "x2"
                        },
                        {
                            type: "Int16",
                            name: "y2"
                        },
                        {
                            type: "Uint32",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "sourceLayerIndex"
                        },
                        {
                            type: "Uint16",
                            name: "bucketIndex"
                        }
                    ]);
                    const Ug = hs([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_anchor_pos",
                            components: 2,
                            type: "Int16"
                        },
                        {
                            name: "a_extrude",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4);
                    function xu(le1, vt, bt) {
                        return le1.sections.forEach((le1)=>{
                            le1.text = function(le1, vt, bt) {
                                const ls = vt.layout.get("text-transform").evaluate(bt, {});
                                return "uppercase" === ls ? le1 = le1.toLocaleUpperCase() : "lowercase" === ls && (le1 = le1.toLocaleLowerCase()), Um.applyArabicShaping && (le1 = Um.applyArabicShaping(le1)), le1;
                            }(le1.text, vt, bt);
                        }), le1;
                    }
                    hs([
                        {
                            name: "a_pos",
                            components: 2,
                            type: "Float32"
                        },
                        {
                            name: "a_radius",
                            components: 1,
                            type: "Float32"
                        },
                        {
                            name: "a_flags",
                            components: 2,
                            type: "Int16"
                        }
                    ], 4), hs([
                        {
                            name: "triangle",
                            components: 3,
                            type: "Uint16"
                        }
                    ]), hs([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Uint16",
                            name: "glyphStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numGlyphs"
                        },
                        {
                            type: "Uint32",
                            name: "vertexStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineStartIndex"
                        },
                        {
                            type: "Uint32",
                            name: "lineLength"
                        },
                        {
                            type: "Uint16",
                            name: "segment"
                        },
                        {
                            type: "Uint16",
                            name: "lowerSize"
                        },
                        {
                            type: "Uint16",
                            name: "upperSize"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetX"
                        },
                        {
                            type: "Float32",
                            name: "lineOffsetY"
                        },
                        {
                            type: "Uint8",
                            name: "writingMode"
                        },
                        {
                            type: "Uint8",
                            name: "placedOrientation"
                        },
                        {
                            type: "Uint8",
                            name: "hidden"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Int16",
                            name: "associatedIconIndex"
                        }
                    ]), hs([
                        {
                            type: "Int16",
                            name: "anchorX"
                        },
                        {
                            type: "Int16",
                            name: "anchorY"
                        },
                        {
                            type: "Int16",
                            name: "rightJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "centerJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "leftJustifiedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedTextSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "placedIconSymbolIndex"
                        },
                        {
                            type: "Int16",
                            name: "verticalPlacedIconSymbolIndex"
                        },
                        {
                            type: "Uint16",
                            name: "key"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalTextBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "iconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "verticalIconBoxEndIndex"
                        },
                        {
                            type: "Uint16",
                            name: "featureIndex"
                        },
                        {
                            type: "Uint16",
                            name: "numHorizontalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalGlyphVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "numVerticalIconVertices"
                        },
                        {
                            type: "Uint16",
                            name: "useRuntimeCollisionCircles"
                        },
                        {
                            type: "Uint32",
                            name: "crossTileID"
                        },
                        {
                            type: "Float32",
                            name: "textBoxScale"
                        },
                        {
                            type: "Float32",
                            name: "collisionCircleDiameter"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetStartIndex"
                        },
                        {
                            type: "Uint16",
                            name: "textAnchorOffsetEndIndex"
                        }
                    ]), hs([
                        {
                            type: "Float32",
                            name: "offsetX"
                        }
                    ]), hs([
                        {
                            type: "Int16",
                            name: "x"
                        },
                        {
                            type: "Int16",
                            name: "y"
                        },
                        {
                            type: "Int16",
                            name: "tileUnitDistanceFromAnchor"
                        }
                    ]), hs([
                        {
                            type: "Uint16",
                            name: "textAnchor"
                        },
                        {
                            type: "Float32",
                            components: 2,
                            name: "textOffset"
                        }
                    ]);
                    var Vg = 24;
                    const Gg = {
                        "!": "\ufe15",
                        "#": "\uff03",
                        $: "\uff04",
                        "%": "\uff05",
                        "&": "\uff06",
                        "(": "\ufe35",
                        ")": "\ufe36",
                        "*": "\uff0a",
                        "+": "\uff0b",
                        ",": "\ufe10",
                        "-": "\ufe32",
                        ".": "\u30fb",
                        "/": "\uff0f",
                        ":": "\ufe13",
                        ";": "\ufe14",
                        "<": "\ufe3f",
                        "=": "\uff1d",
                        ">": "\ufe40",
                        "?": "\ufe16",
                        "@": "\uff20",
                        "[": "\ufe47",
                        "\\": "\uff3c",
                        "]": "\ufe48",
                        "^": "\uff3e",
                        _: "\ufe33",
                        "`": "\uff40",
                        "{": "\ufe37",
                        "|": "\u2015",
                        "}": "\ufe38",
                        "~": "\uff5e",
                        "\xa2": "\uffe0",
                        "\xa3": "\uffe1",
                        "\xa5": "\uffe5",
                        "\xa6": "\uffe4",
                        "\xac": "\uffe2",
                        "\xaf": "\uffe3",
                        "\u2013": "\ufe32",
                        "\u2014": "\ufe31",
                        "\u2018": "\ufe43",
                        "\u2019": "\ufe44",
                        "\u201c": "\ufe41",
                        "\u201d": "\ufe42",
                        "\u2026": "\ufe19",
                        "\u22ef": "\ufe19",
                        "\u2027": "\u30fb",
                        "\u20a9": "\uffe6",
                        "\u3001": "\ufe11",
                        "\u3002": "\ufe12",
                        "\u3008": "\ufe3f",
                        "\u3009": "\ufe40",
                        "\u300a": "\ufe3d",
                        "\u300b": "\ufe3e",
                        "\u300c": "\ufe41",
                        "\u300d": "\ufe42",
                        "\u300e": "\ufe43",
                        "\u300f": "\ufe44",
                        "\u3010": "\ufe3b",
                        "\u3011": "\ufe3c",
                        "\u3014": "\ufe39",
                        "\u3015": "\ufe3a",
                        "\u3016": "\ufe17",
                        "\u3017": "\ufe18",
                        "\uff01": "\ufe15",
                        "\uff08": "\ufe35",
                        "\uff09": "\ufe36",
                        "\uff0c": "\ufe10",
                        "\uff0d": "\ufe32",
                        "\uff0e": "\u30fb",
                        "\uff1a": "\ufe13",
                        "\uff1b": "\ufe14",
                        "\uff1c": "\ufe3f",
                        "\uff1e": "\ufe40",
                        "\uff1f": "\ufe16",
                        "\uff3b": "\ufe47",
                        "\uff3d": "\ufe48",
                        "\uff3f": "\ufe33",
                        "\uff5b": "\ufe37",
                        "\uff5c": "\u2015",
                        "\uff5d": "\ufe38",
                        "\uff5f": "\ufe35",
                        "\uff60": "\ufe36",
                        "\uff61": "\ufe12",
                        "\uff62": "\ufe41",
                        "\uff63": "\ufe42"
                    }, qg = {
                        10: !0,
                        32: !0,
                        38: !0,
                        41: !0,
                        43: !0,
                        45: !0,
                        47: !0,
                        173: !0,
                        183: !0,
                        8203: !0,
                        8208: !0,
                        8211: !0,
                        8231: !0
                    }, Hg = {
                        40: !0
                    };
                    function Su(le1, vt, bt, ls, ho, Dl) {
                        if ("fontStack" in vt) {
                            const ls = bt[vt.fontStack], Dl = ls && ls[le1];
                            return Dl ? Dl.metrics.advance * vt.scale + ho : 0;
                        }
                        {
                            const le1 = ls[vt.imageName];
                            return le1 ? le1.displaySize[0] * vt.scale * Vg / Dl + ho : 0;
                        }
                    }
                    function Au(le1, vt, bt, ls) {
                        const ho = Math.pow(le1 - vt, 2);
                        return ls ? le1 < vt ? ho / 2 : 2 * ho : ho + Math.abs(bt) * bt;
                    }
                    function Iu(le1, vt, bt) {
                        let ls = 0;
                        return 10 === le1 && (ls -= 1e4), bt && (ls += 150), 40 !== le1 && 65288 !== le1 || (ls += 50), 41 !== vt && 65289 !== vt || (ls += 50), ls;
                    }
                    function Tu(le1, vt, bt, ls, ho, Dl) {
                        let Fl = null, sc = Au(vt, bt, ho, Dl);
                        for (const uc of ls){
                            const le1 = Au(vt - uc.x, bt, ho, Dl) + uc.badness;
                            le1 <= sc && (Fl = uc, sc = le1);
                        }
                        return {
                            index: le1,
                            x: vt,
                            priorBreak: Fl,
                            badness: sc
                        };
                    }
                    function ku(le1) {
                        return le1 ? ku(le1.priorBreak).concat(le1.index) : [];
                    }
                    class Eu {
                        constructor(le1, vt, bt){
                            void 0 === le1 && (le1 = ""), void 0 === vt && (vt = []), void 0 === bt && (bt = []), this.text = le1, this.sections = vt, this.sectionIndex = bt, this.imageSectionID = null;
                        }
                        static fromFeature(le1, vt) {
                            const bt = new Eu;
                            for(let ls = 0; ls < le1.sections.length; ls++){
                                const ho = le1.sections[ls];
                                ho.image ? bt.addImageSection(ho) : bt.addTextSection(ho, vt);
                            }
                            return bt;
                        }
                        length() {
                            return [
                                ...this.text
                            ].length;
                        }
                        getSection(le1) {
                            return this.sections[this.sectionIndex[le1]];
                        }
                        getSectionIndex(le1) {
                            return this.sectionIndex[le1];
                        }
                        verticalizePunctuation() {
                            this.text = function(le1) {
                                let vt = "", bt = {
                                    premature: !0,
                                    value: void 0
                                };
                                const ls = le1[Symbol.iterator]();
                                let ho = ls.next();
                                const Dl = le1[Symbol.iterator]();
                                Dl.next();
                                let Fl = Dl.next();
                                for(; !ho.done;)vt += !Fl.done && Oi(Fl.value.codePointAt(0)) && !Gg[Fl.value] || !bt.premature && Oi(bt.value.codePointAt(0)) && !Gg[bt.value] || !Gg[ho.value] ? ho.value : Gg[ho.value], bt = {
                                    value: ho.value,
                                    premature: !1
                                }, ho = ls.next(), Fl = Dl.next();
                                return vt;
                            }(this.text);
                        }
                        hasZeroWidthSpaces() {
                            return this.text.includes("\u200b");
                        }
                        trim() {
                            const le1 = this.text.match(/^\s*/), vt = le1 ? le1[0].length : 0, bt = this.text.match(/\S\s*$/), ls = bt ? bt[0].length - 1 : 0;
                            this.text = this.text.substring(vt, this.text.length - ls), this.sectionIndex = this.sectionIndex.slice(vt, this.sectionIndex.length - ls);
                        }
                        substring(le1, vt) {
                            const bt = [
                                ...this.text
                            ].slice(le1, vt).join(""), ls = this.sectionIndex.slice(le1, vt);
                            return new Eu(bt, this.sections, ls);
                        }
                        toCodeUnitIndex(le1) {
                            return [
                                ...this.text
                            ].slice(0, le1).join("").length;
                        }
                        toString() {
                            return this.text;
                        }
                        getMaxScale() {
                            return this.sectionIndex.reduce((le1, vt)=>Math.max(le1, this.sections[vt].scale), 0);
                        }
                        getMaxImageSize(le1) {
                            let vt = 0, bt = 0;
                            for(let ls = 0; ls < this.length(); ls++){
                                const ho = this.getSection(ls);
                                if ("imageName" in ho) {
                                    const ls = le1[ho.imageName];
                                    if (!ls) continue;
                                    const Dl = ls.displaySize;
                                    vt = Math.max(vt, Dl[0]), bt = Math.max(bt, Dl[1]);
                                }
                            }
                            return {
                                maxImageWidth: vt,
                                maxImageHeight: bt
                            };
                        }
                        addTextSection(le1, vt) {
                            this.text += le1.text, this.sections.push({
                                scale: le1.scale || 1,
                                verticalAlign: le1.verticalAlign || "bottom",
                                fontStack: le1.fontStack || vt
                            });
                            const bt = this.sections.length - 1;
                            this.sectionIndex.push(...[
                                ...le1.text
                            ].map(()=>bt));
                        }
                        addImageSection(le1) {
                            const vt = le1.image ? le1.image.name : "";
                            if (0 === vt.length) return void x("Can't add FormattedSection with an empty image.");
                            const bt = this.getNextImageSectionCharCode();
                            bt ? (this.text += String.fromCharCode(bt), this.sections.push({
                                scale: 1,
                                verticalAlign: le1.verticalAlign || "bottom",
                                imageName: vt
                            }), this.sectionIndex.push(this.sections.length - 1)) : x("Reached maximum number of images 6401");
                        }
                        getNextImageSectionCharCode() {
                            return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                        }
                        determineLineBreaks(le1, vt, bt, ls, ho) {
                            const Dl = [], Fl = this.determineAverageLineWidth(le1, vt, bt, ls, ho), sc = this.hasZeroWidthSpaces();
                            let uc = 0, mc = 0;
                            const gc = this.text[Symbol.iterator]();
                            let Ac = gc.next();
                            const Ec = this.text[Symbol.iterator]();
                            Ec.next();
                            let kc = Ec.next();
                            const du = this.text[Symbol.iterator]();
                            du.next(), du.next();
                            let _u = du.next();
                            for(; !Ac.done;){
                                const vt = this.getSection(mc), Md = Ac.value.codePointAt(0);
                                if (zi(Md) || (uc += Su(Md, vt, bt, ls, le1, ho)), !kc.done) {
                                    const le1 = Di(Md), bt = kc.value.codePointAt(0);
                                    (qg[Md] || le1 || "imageName" in vt || !_u.done && Hg[bt]) && Dl.push(Tu(mc + 1, uc, Fl, Dl, Iu(Md, bt, le1 && sc), !1));
                                }
                                mc++, Ac = gc.next(), kc = Ec.next(), _u = du.next();
                            }
                            return ku(Tu(this.length(), uc, Fl, Dl, 0, !0));
                        }
                        determineAverageLineWidth(le1, vt, bt, ls, ho) {
                            let Dl = 0, Fl = 0;
                            for (const sc of this.text){
                                const vt = this.getSection(Fl);
                                Dl += Su(sc.codePointAt(0), vt, bt, ls, le1, ho), Fl++;
                            }
                            return Dl / Math.max(1, Math.ceil(Dl / vt));
                        }
                    }
                    const Wg = 4294967296, Zg = 1 / Wg, Yg = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                    class zu {
                        constructor(le1){
                            void 0 === le1 && (le1 = new Uint8Array(16)), this.buf = ArrayBuffer.isView(le1) ? le1 : new Uint8Array(le1), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
                        }
                        readFields(le1, vt, bt) {
                            for(void 0 === bt && (bt = this.length); this.pos < bt;){
                                const bt = this.readVarint(), ls = bt >> 3, ho = this.pos;
                                this.type = 7 & bt, le1(ls, vt, this), this.pos === ho && this.skip(bt);
                            }
                            return vt;
                        }
                        readMessage(le1, vt) {
                            return this.readFields(le1, vt, this.readVarint() + this.pos);
                        }
                        readFixed32() {
                            const le1 = this.dataView.getUint32(this.pos, !0);
                            return this.pos += 4, le1;
                        }
                        readSFixed32() {
                            const le1 = this.dataView.getInt32(this.pos, !0);
                            return this.pos += 4, le1;
                        }
                        readFixed64() {
                            const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * Wg;
                            return this.pos += 8, le1;
                        }
                        readSFixed64() {
                            const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * Wg;
                            return this.pos += 8, le1;
                        }
                        readFloat() {
                            const le1 = this.dataView.getFloat32(this.pos, !0);
                            return this.pos += 4, le1;
                        }
                        readDouble() {
                            const le1 = this.dataView.getFloat64(this.pos, !0);
                            return this.pos += 8, le1;
                        }
                        readVarint(le1) {
                            const vt = this.buf;
                            let bt, ls;
                            return ls = vt[this.pos++], bt = 127 & ls, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 7, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 14, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 21, ls < 128 ? bt : (ls = vt[this.pos], bt |= (15 & ls) << 28, function(le1, vt, bt) {
                                const ls = bt.buf;
                                let ho, Dl;
                                if (Dl = ls[bt.pos++], ho = (112 & Dl) >> 4, Dl < 128) return Fu(le1, ho, vt);
                                if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 3, Dl < 128) return Fu(le1, ho, vt);
                                if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 10, Dl < 128) return Fu(le1, ho, vt);
                                if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 17, Dl < 128) return Fu(le1, ho, vt);
                                if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 24, Dl < 128) return Fu(le1, ho, vt);
                                if (Dl = ls[bt.pos++], ho |= (1 & Dl) << 31, Dl < 128) return Fu(le1, ho, vt);
                                throw new Error("Expected varint not more than 10 bytes");
                            }(bt, le1, this)))));
                        }
                        readVarint64() {
                            return this.readVarint(!0);
                        }
                        readSVarint() {
                            const le1 = this.readVarint();
                            return le1 % 2 == 1 ? (le1 + 1) / -2 : le1 / 2;
                        }
                        readBoolean() {
                            return Boolean(this.readVarint());
                        }
                        readString() {
                            const le1 = this.readVarint() + this.pos, vt = this.pos;
                            return this.pos = le1, le1 - vt >= 12 && Yg ? Yg.decode(this.buf.subarray(vt, le1)) : function(le1, vt, bt) {
                                let ls = "", ho = vt;
                                for(; ho < bt;){
                                    const vt = le1[ho];
                                    let Dl, Fl, sc, uc = null, mc = vt > 239 ? 4 : vt > 223 ? 3 : vt > 191 ? 2 : 1;
                                    if (ho + mc > bt) break;
                                    1 === mc ? vt < 128 && (uc = vt) : 2 === mc ? (Dl = le1[ho + 1], 128 == (192 & Dl) && (uc = (31 & vt) << 6 | 63 & Dl, uc <= 127 && (uc = null))) : 3 === mc ? (Dl = le1[ho + 1], Fl = le1[ho + 2], 128 == (192 & Dl) && 128 == (192 & Fl) && (uc = (15 & vt) << 12 | (63 & Dl) << 6 | 63 & Fl, (uc <= 2047 || uc >= 55296 && uc <= 57343) && (uc = null))) : 4 === mc && (Dl = le1[ho + 1], Fl = le1[ho + 2], sc = le1[ho + 3], 128 == (192 & Dl) && 128 == (192 & Fl) && 128 == (192 & sc) && (uc = (15 & vt) << 18 | (63 & Dl) << 12 | (63 & Fl) << 6 | 63 & sc, (uc <= 65535 || uc >= 1114112) && (uc = null))), null === uc ? (uc = 65533, mc = 1) : uc > 65535 && (uc -= 65536, ls += String.fromCharCode(uc >>> 10 & 1023 | 55296), uc = 56320 | 1023 & uc), ls += String.fromCharCode(uc), ho += mc;
                                }
                                return ls;
                            }(this.buf, vt, le1);
                        }
                        readBytes() {
                            const le1 = this.readVarint() + this.pos, vt = this.buf.subarray(this.pos, le1);
                            return this.pos = le1, vt;
                        }
                        readPackedVarint(le1, vt) {
                            void 0 === le1 && (le1 = []);
                            const bt = this.readPackedEnd();
                            for(; this.pos < bt;)le1.push(this.readVarint(vt));
                            return le1;
                        }
                        readPackedSVarint(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readSVarint());
                            return le1;
                        }
                        readPackedBoolean(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readBoolean());
                            return le1;
                        }
                        readPackedFloat(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readFloat());
                            return le1;
                        }
                        readPackedDouble(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readDouble());
                            return le1;
                        }
                        readPackedFixed32(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readFixed32());
                            return le1;
                        }
                        readPackedSFixed32(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readSFixed32());
                            return le1;
                        }
                        readPackedFixed64(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readFixed64());
                            return le1;
                        }
                        readPackedSFixed64(le1) {
                            void 0 === le1 && (le1 = []);
                            const vt = this.readPackedEnd();
                            for(; this.pos < vt;)le1.push(this.readSFixed64());
                            return le1;
                        }
                        readPackedEnd() {
                            return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
                        }
                        skip(le1) {
                            const vt = 7 & le1;
                            if (0 === vt) for(; this.buf[this.pos++] > 127;);
                            else if (2 === vt) this.pos = this.readVarint() + this.pos;
                            else if (5 === vt) this.pos += 4;
                            else {
                                if (1 !== vt) throw new Error(`Unimplemented type: ${vt}`);
                                this.pos += 8;
                            }
                        }
                        writeTag(le1, vt) {
                            this.writeVarint(le1 << 3 | vt);
                        }
                        realloc(le1) {
                            let vt = this.length || 16;
                            for(; vt < this.pos + le1;)vt *= 2;
                            if (vt !== this.length) {
                                const le1 = new Uint8Array(vt);
                                le1.set(this.buf), this.buf = le1, this.dataView = new DataView(le1.buffer), this.length = vt;
                            }
                        }
                        finish() {
                            return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                        }
                        writeFixed32(le1) {
                            this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                        }
                        writeSFixed32(le1) {
                            this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                        }
                        writeFixed64(le1) {
                            this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * Zg), !0), this.pos += 8;
                        }
                        writeSFixed64(le1) {
                            this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * Zg), !0), this.pos += 8;
                        }
                        writeVarint(le1) {
                            (le1 = +le1 || 0) > 268435455 || le1 < 0 ? function(le1, vt) {
                                let bt, ls;
                                if (le1 >= 0 ? (bt = le1 % 4294967296 | 0, ls = le1 / 4294967296 | 0) : (bt = ~(-le1 % 4294967296), ls = ~(-le1 / 4294967296), 4294967295 ^ bt ? bt = bt + 1 | 0 : (bt = 0, ls = ls + 1 | 0)), le1 >= 0x10000000000000000 || le1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                vt.realloc(10), function(le1, vt, bt) {
                                    bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, bt.buf[bt.pos] = 127 & (le1 >>>= 7);
                                }(bt, 0, vt), function(le1, vt) {
                                    const bt = (7 & le1) << 4;
                                    vt.buf[vt.pos++] |= bt | ((le1 >>>= 3) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1)))));
                                }(ls, vt);
                            }(le1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & le1 | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = le1 >>> 7 & 127))));
                        }
                        writeSVarint(le1) {
                            this.writeVarint(le1 < 0 ? 2 * -le1 - 1 : 2 * le1);
                        }
                        writeBoolean(le1) {
                            this.writeVarint(+le1);
                        }
                        writeString(le1) {
                            le1 = String(le1), this.realloc(4 * le1.length), this.pos++;
                            const vt = this.pos;
                            this.pos = function(le1, vt, bt) {
                                for(let ls, ho, Dl = 0; Dl < vt.length; Dl++){
                                    if (ls = vt.charCodeAt(Dl), ls > 55295 && ls < 57344) {
                                        if (!ho) {
                                            ls > 56319 || Dl + 1 === vt.length ? (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189) : ho = ls;
                                            continue;
                                        }
                                        if (ls < 56320) {
                                            le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = ls;
                                            continue;
                                        }
                                        ls = ho - 55296 << 10 | ls - 56320 | 65536, ho = null;
                                    } else ho && (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = null);
                                    ls < 128 ? le1[bt++] = ls : (ls < 2048 ? le1[bt++] = ls >> 6 | 192 : (ls < 65536 ? le1[bt++] = ls >> 12 | 224 : (le1[bt++] = ls >> 18 | 240, le1[bt++] = ls >> 12 & 63 | 128), le1[bt++] = ls >> 6 & 63 | 128), le1[bt++] = 63 & ls | 128);
                                }
                                return bt;
                            }(this.buf, le1, this.pos);
                            const bt = this.pos - vt;
                            bt >= 128 && Bu(vt, bt, this), this.pos = vt - 1, this.writeVarint(bt), this.pos += bt;
                        }
                        writeFloat(le1) {
                            this.realloc(4), this.dataView.setFloat32(this.pos, le1, !0), this.pos += 4;
                        }
                        writeDouble(le1) {
                            this.realloc(8), this.dataView.setFloat64(this.pos, le1, !0), this.pos += 8;
                        }
                        writeBytes(le1) {
                            const vt = le1.length;
                            this.writeVarint(vt), this.realloc(vt);
                            for(let bt = 0; bt < vt; bt++)this.buf[this.pos++] = le1[bt];
                        }
                        writeRawMessage(le1, vt) {
                            this.pos++;
                            const bt = this.pos;
                            le1(vt, this);
                            const ls = this.pos - bt;
                            ls >= 128 && Bu(bt, ls, this), this.pos = bt - 1, this.writeVarint(ls), this.pos += ls;
                        }
                        writeMessage(le1, vt, bt) {
                            this.writeTag(le1, 2), this.writeRawMessage(vt, bt);
                        }
                        writePackedVarint(le1, vt) {
                            vt.length && this.writeMessage(le1, Cu, vt);
                        }
                        writePackedSVarint(le1, vt) {
                            vt.length && this.writeMessage(le1, Vu, vt);
                        }
                        writePackedBoolean(le1, vt) {
                            vt.length && this.writeMessage(le1, Ru, vt);
                        }
                        writePackedFloat(le1, vt) {
                            vt.length && this.writeMessage(le1, Lu, vt);
                        }
                        writePackedDouble(le1, vt) {
                            vt.length && this.writeMessage(le1, Ou, vt);
                        }
                        writePackedFixed32(le1, vt) {
                            vt.length && this.writeMessage(le1, Nu, vt);
                        }
                        writePackedSFixed32(le1, vt) {
                            vt.length && this.writeMessage(le1, $u, vt);
                        }
                        writePackedFixed64(le1, vt) {
                            vt.length && this.writeMessage(le1, Uu, vt);
                        }
                        writePackedSFixed64(le1, vt) {
                            vt.length && this.writeMessage(le1, qu, vt);
                        }
                        writeBytesField(le1, vt) {
                            this.writeTag(le1, 2), this.writeBytes(vt);
                        }
                        writeFixed32Field(le1, vt) {
                            this.writeTag(le1, 5), this.writeFixed32(vt);
                        }
                        writeSFixed32Field(le1, vt) {
                            this.writeTag(le1, 5), this.writeSFixed32(vt);
                        }
                        writeFixed64Field(le1, vt) {
                            this.writeTag(le1, 1), this.writeFixed64(vt);
                        }
                        writeSFixed64Field(le1, vt) {
                            this.writeTag(le1, 1), this.writeSFixed64(vt);
                        }
                        writeVarintField(le1, vt) {
                            this.writeTag(le1, 0), this.writeVarint(vt);
                        }
                        writeSVarintField(le1, vt) {
                            this.writeTag(le1, 0), this.writeSVarint(vt);
                        }
                        writeStringField(le1, vt) {
                            this.writeTag(le1, 2), this.writeString(vt);
                        }
                        writeFloatField(le1, vt) {
                            this.writeTag(le1, 5), this.writeFloat(vt);
                        }
                        writeDoubleField(le1, vt) {
                            this.writeTag(le1, 1), this.writeDouble(vt);
                        }
                        writeBooleanField(le1, vt) {
                            this.writeVarintField(le1, +vt);
                        }
                    }
                    function Fu(le1, vt, bt) {
                        return bt ? 4294967296 * vt + (le1 >>> 0) : 4294967296 * (vt >>> 0) + (le1 >>> 0);
                    }
                    function Bu(le1, vt, bt) {
                        const ls = vt <= 16383 ? 1 : vt <= 2097151 ? 2 : vt <= 268435455 ? 3 : Math.floor(Math.log(vt) / (7 * Math.LN2));
                        bt.realloc(ls);
                        for(let ho = bt.pos - 1; ho >= le1; ho--)bt.buf[ho + ls] = bt.buf[ho];
                    }
                    function Cu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeVarint(le1[bt]);
                    }
                    function Vu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeSVarint(le1[bt]);
                    }
                    function Lu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeFloat(le1[bt]);
                    }
                    function Ou(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeDouble(le1[bt]);
                    }
                    function Ru(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeBoolean(le1[bt]);
                    }
                    function Nu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeFixed32(le1[bt]);
                    }
                    function $u(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed32(le1[bt]);
                    }
                    function Uu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeFixed64(le1[bt]);
                    }
                    function qu(le1, vt) {
                        for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed64(le1[bt]);
                    }
                    function Gu(le1) {
                        let vt = 0, bt = 0;
                        for (const Fl of le1)vt += Fl.w * Fl.h, bt = Math.max(bt, Fl.w);
                        le1.sort((le1, vt)=>vt.h - le1.h);
                        const ls = [
                            {
                                x: 0,
                                y: 0,
                                w: Math.max(Math.ceil(Math.sqrt(vt / .95)), bt),
                                h: 1 / 0
                            }
                        ];
                        let ho = 0, Dl = 0;
                        for (const Fl of le1)for(let le1 = ls.length - 1; le1 >= 0; le1--){
                            const vt = ls[le1];
                            if (!(Fl.w > vt.w || Fl.h > vt.h)) {
                                if (Fl.x = vt.x, Fl.y = vt.y, Dl = Math.max(Dl, Fl.y + Fl.h), ho = Math.max(ho, Fl.x + Fl.w), Fl.w === vt.w && Fl.h === vt.h) {
                                    const vt = ls.pop();
                                    vt && le1 < ls.length && (ls[le1] = vt);
                                } else Fl.h === vt.h ? (vt.x += Fl.w, vt.w -= Fl.w) : Fl.w === vt.w ? (vt.y += Fl.h, vt.h -= Fl.h) : (ls.push({
                                    x: vt.x + Fl.w,
                                    y: vt.y,
                                    w: vt.w - Fl.w,
                                    h: Fl.h
                                }), vt.y += Fl.h, vt.h -= Fl.h);
                                break;
                            }
                        }
                        return {
                            w: ho,
                            h: Dl,
                            fill: vt / (ho * Dl) || 0
                        };
                    }
                    class ju {
                        constructor(le1, vt){
                            let { pixelRatio: bt, version: ls, stretchX: ho, stretchY: Dl, content: Fl, textFitWidth: sc, textFitHeight: uc } = vt;
                            this.paddedRect = le1, this.pixelRatio = bt, this.stretchX = ho, this.stretchY = Dl, this.content = Fl, this.version = ls, this.textFitWidth = sc, this.textFitHeight = uc;
                        }
                        get tl() {
                            return [
                                this.paddedRect.x + 1,
                                this.paddedRect.y + 1
                            ];
                        }
                        get br() {
                            return [
                                this.paddedRect.x + this.paddedRect.w - 1,
                                this.paddedRect.y + this.paddedRect.h - 1
                            ];
                        }
                        get tlbr() {
                            return this.tl.concat(this.br);
                        }
                        get displaySize() {
                            return [
                                (this.paddedRect.w - 2) / this.pixelRatio,
                                (this.paddedRect.h - 2) / this.pixelRatio
                            ];
                        }
                    }
                    class Xu {
                        constructor(le1, vt){
                            const bt = {}, ls = {};
                            this.haveRenderCallbacks = [];
                            const ho = [];
                            this.addImages(le1, bt, ho), this.addImages(vt, ls, ho);
                            const { w: Dl, h: Fl } = Gu(ho), sc = new Da({
                                width: Dl || 1,
                                height: Fl || 1
                            });
                            for(const uc in le1){
                                const vt = le1[uc], ls = bt[uc].paddedRect;
                                Da.copy(vt.data, sc, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: ls.x + 1,
                                    y: ls.y + 1
                                }, vt.data);
                            }
                            for(const uc in vt){
                                const le1 = vt[uc], bt = ls[uc].paddedRect, ho = bt.x + 1, Dl = bt.y + 1, Fl = le1.data.width, mc = le1.data.height;
                                Da.copy(le1.data, sc, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: ho,
                                    y: Dl
                                }, le1.data), Da.copy(le1.data, sc, {
                                    x: 0,
                                    y: mc - 1
                                }, {
                                    x: ho,
                                    y: Dl - 1
                                }, {
                                    width: Fl,
                                    height: 1
                                }), Da.copy(le1.data, sc, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: ho,
                                    y: Dl + mc
                                }, {
                                    width: Fl,
                                    height: 1
                                }), Da.copy(le1.data, sc, {
                                    x: Fl - 1,
                                    y: 0
                                }, {
                                    x: ho - 1,
                                    y: Dl
                                }, {
                                    width: 1,
                                    height: mc
                                }), Da.copy(le1.data, sc, {
                                    x: 0,
                                    y: 0
                                }, {
                                    x: ho + Fl,
                                    y: Dl
                                }, {
                                    width: 1,
                                    height: mc
                                });
                            }
                            this.image = sc, this.iconPositions = bt, this.patternPositions = ls;
                        }
                        addImages(le1, vt, bt) {
                            for(const ls in le1){
                                const ho = le1[ls], Dl = {
                                    x: 0,
                                    y: 0,
                                    w: ho.data.width + 2,
                                    h: ho.data.height + 2
                                };
                                bt.push(Dl), vt[ls] = new ju(Dl, ho), ho.hasRenderCallback && this.haveRenderCallbacks.push(ls);
                            }
                        }
                        patchUpdatedImages(le1, vt) {
                            le1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                            for(const bt in le1.updatedImages)this.patchUpdatedImage(this.iconPositions[bt], le1.getImage(bt), vt), this.patchUpdatedImage(this.patternPositions[bt], le1.getImage(bt), vt);
                        }
                        patchUpdatedImage(le1, vt, bt) {
                            if (!le1 || !vt) return;
                            if (le1.version === vt.version) return;
                            le1.version = vt.version;
                            const [ls, ho] = le1.tl;
                            bt.update(vt.data, void 0, {
                                x: ls,
                                y: ho
                            });
                        }
                    }
                    var Qg;
                    function Zu(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du) {
                        const _u = Eu.fromFeature(le1, ho);
                        let Md;
                        Ac === Qg.vertical && _u.verticalizePunctuation();
                        let Ld = _u.determineLineBreaks(mc, Dl, vt, ls, kc);
                        const { processBidirectionalText: Nd, processStyledBidirectionalText: Rd } = Um;
                        if (Nd && 1 === _u.sections.length) {
                            Md = [], Ld = Ld.map((le1)=>_u.toCodeUnitIndex(le1));
                            const le1 = Nd(_u.toString(), Ld);
                            for (const vt of le1){
                                const le1 = [
                                    ...vt
                                ].map(()=>0);
                                Md.push(new Eu(vt, _u.sections, le1));
                            }
                        } else if (Rd) {
                            Md = [], Ld = Ld.map((le1)=>_u.toCodeUnitIndex(le1));
                            let le1 = 0;
                            const vt = [];
                            for (const ls of _u.text)vt.push(...Array(ls.length).fill(_u.sectionIndex[le1])), le1++;
                            const bt = Rd(_u.text, vt, Ld);
                            for (const ls of bt){
                                const le1 = [];
                                let vt = "";
                                for (const bt of ls[0])le1.push(ls[1][vt.length]), vt += bt;
                                Md.push(new Eu(ls[0], _u.sections, le1));
                            }
                        } else Md = function(le1, vt) {
                            const bt = [];
                            let ls = 0;
                            for (const ho of vt)bt.push(le1.substring(ls, ho)), ls = ho;
                            return ls < le1.length() && bt.push(le1.substring(ls, le1.length())), bt;
                        }(_u, Ld);
                        const Od = [], jd = {
                            positionedLines: Od,
                            text: _u.toString(),
                            top: gc[1],
                            bottom: gc[1],
                            left: gc[0],
                            right: gc[0],
                            writingMode: Ac,
                            iconsInText: !1,
                            verticalizable: !1
                        };
                        return function(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                            let Ec = 0, kc = 0, du = 0, _u = 0;
                            const Md = "right" === sc ? 1 : "left" === sc ? 0 : .5, Ld = Vg / Ac;
                            let Nd = 0;
                            for (const jd of ho){
                                jd.trim();
                                const ho = jd.getMaxScale(), Fl = {
                                    positionedGlyphs: [],
                                    lineOffset: 0
                                };
                                le1.positionedLines[Nd] = Fl;
                                const sc = Fl.positionedGlyphs;
                                let Ac = 0;
                                if (!jd.length()) {
                                    kc += Dl, ++Nd;
                                    continue;
                                }
                                const Rd = Wu(ls, jd, Ld);
                                let Od = 0;
                                for (const Dl of jd.text){
                                    const Fl = jd.getSection(Od), du = Dl.codePointAt(0), _u = Ku(uc, gc, du), Md = {
                                        glyph: du,
                                        imageName: null,
                                        x: Ec,
                                        y: kc + -17,
                                        vertical: _u,
                                        scale: 1,
                                        fontStack: "",
                                        sectionIndex: jd.getSectionIndex(Od),
                                        metrics: null,
                                        rect: null
                                    };
                                    let Nd;
                                    if ("fontStack" in Fl) {
                                        if (Nd = Qu(Fl, du, _u, Rd, vt, bt), !Nd) continue;
                                        Md.fontStack = Fl.fontStack;
                                    } else {
                                        if (le1.iconsInText = !0, Fl.scale *= Ld, Nd = ec(Fl, _u, ho, Rd, ls), !Nd) continue;
                                        Ac = Math.max(Ac, Nd.imageOffset), Md.imageName = Fl.imageName;
                                    }
                                    const { rect: Ud, metrics: Gd, baselineOffset: qd } = Nd;
                                    Md.y += qd, Md.scale = Fl.scale, Md.metrics = Gd, Md.rect = Ud, sc.push(Md), _u ? (le1.verticalizable = !0, Ec += ("imageName" in Fl ? Gd.advance : Vg) * Fl.scale + mc) : Ec += Gd.advance * Fl.scale + mc, Od++;
                                }
                                0 !== sc.length && (du = Math.max(Ec - mc, du), tc(sc, 0, sc.length - 1, Md)), Ec = 0, Fl.lineOffset = Math.max(Ac, (ho - 1) * Vg);
                                const Ud = Dl * ho + Ac;
                                kc += Ud, _u = Math.max(Ud, _u), ++Nd;
                            }
                            const { horizontalAlign: Rd, verticalAlign: Od } = Hu(Fl);
                            (function(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                const mc = (vt - bt) * ho;
                                let gc = 0;
                                gc = Dl !== Fl ? -sc * ls - -17 : -ls * uc * Fl + .5 * Fl;
                                for (const Ac of le1)for (const le1 of Ac.positionedGlyphs)le1.x += mc, le1.y += gc;
                            })(le1.positionedLines, Md, Rd, Od, du, _u, Dl, kc, ho.length), le1.top += -Od * kc, le1.bottom = le1.top + kc, le1.left += -Rd * du, le1.right = le1.left + du;
                        }(jd, vt, bt, ls, Md, Fl, sc, uc, Ac, mc, Ec, du), !function(le1) {
                            for (const vt of le1)if (0 !== vt.positionedGlyphs.length) return !1;
                            return !0;
                        }(Od) && jd;
                    }
                    function Hu(le1) {
                        let vt = .5, bt = .5;
                        switch(le1){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                vt = 1;
                                break;
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                vt = 0;
                        }
                        switch(le1){
                            case "bottom":
                            case "bottom-right":
                            case "bottom-left":
                                bt = 1;
                                break;
                            case "top":
                            case "top-right":
                            case "top-left":
                                bt = 0;
                        }
                        return {
                            horizontalAlign: vt,
                            verticalAlign: bt
                        };
                    }
                    function Wu(le1, vt, bt) {
                        const ls = vt.getMaxScale() * Vg, { maxImageWidth: ho, maxImageHeight: Dl } = vt.getMaxImageSize(le1), Fl = Math.max(ls, Dl * bt);
                        return {
                            verticalLineContentWidth: Math.max(ls, ho * bt),
                            horizontalLineContentHeight: Fl
                        };
                    }
                    function Ju(le1) {
                        switch(le1){
                            case "top":
                                return 0;
                            case "center":
                                return .5;
                            default:
                                return 1;
                        }
                    }
                    function Ku(le1, vt, bt) {
                        var ls;
                        return !(le1 === Qg.horizontal || !vt && !Pi(bt) || vt && (zi(bt) || (ls = bt, /\p{sc=Arab}/u.test(String.fromCodePoint(ls)))));
                    }
                    function Qu(le1, vt, bt, ls, ho, Dl) {
                        const Fl = Dl[le1.fontStack], sc = function(le1, vt, bt, ls) {
                            if (le1 && le1.rect) return le1;
                            const ho = vt[bt.fontStack], Dl = ho && ho[ls];
                            return Dl ? {
                                rect: null,
                                metrics: Dl.metrics
                            } : null;
                        }(Fl && Fl[vt], ho, le1, vt);
                        if (null === sc) return null;
                        let uc;
                        if (bt) uc = ls.verticalLineContentWidth - le1.scale * Vg;
                        else {
                            const vt = Ju(le1.verticalAlign);
                            uc = (ls.horizontalLineContentHeight - le1.scale * Vg) * vt;
                        }
                        return {
                            rect: sc.rect,
                            metrics: sc.metrics,
                            baselineOffset: uc
                        };
                    }
                    function ec(le1, vt, bt, ls, ho) {
                        const Dl = ho[le1.imageName];
                        if (!Dl) return null;
                        const Fl = Dl.paddedRect, sc = Dl.displaySize, uc = {
                            width: sc[0],
                            height: sc[1],
                            left: 1,
                            top: -3,
                            advance: vt ? sc[1] : sc[0]
                        };
                        let mc;
                        if (vt) mc = ls.verticalLineContentWidth - sc[1] * le1.scale;
                        else {
                            const vt = Ju(le1.verticalAlign);
                            mc = (ls.horizontalLineContentHeight - sc[1] * le1.scale) * vt;
                        }
                        return {
                            rect: Fl,
                            metrics: uc,
                            baselineOffset: mc,
                            imageOffset: (vt ? sc[0] : sc[1]) * le1.scale - Vg * bt
                        };
                    }
                    function tc(le1, vt, bt, ls) {
                        if (0 === ls) return;
                        const ho = le1[bt], Dl = (le1[bt].x + ho.metrics.advance * ho.scale) * ls;
                        for(let Fl = vt; Fl <= bt; Fl++)le1[Fl].x -= Dl;
                    }
                    function rc(le1, vt, bt) {
                        const { horizontalAlign: ls, verticalAlign: ho } = Hu(bt), Dl = vt[0] - le1.displaySize[0] * ls, Fl = vt[1] - le1.displaySize[1] * ho;
                        return {
                            image: le1,
                            top: Fl,
                            bottom: Fl + le1.displaySize[1],
                            left: Dl,
                            right: Dl + le1.displaySize[0]
                        };
                    }
                    function nc(le1) {
                        var vt, bt;
                        let ls = le1.left, ho = le1.top, Dl = le1.right - ls, Fl = le1.bottom - ho;
                        const sc = null !== (vt = le1.image.textFitWidth) && void 0 !== vt ? vt : "stretchOrShrink", uc = null !== (bt = le1.image.textFitHeight) && void 0 !== bt ? bt : "stretchOrShrink", mc = (le1.image.content[2] - le1.image.content[0]) / (le1.image.content[3] - le1.image.content[1]);
                        if ("proportional" === uc) {
                            if ("stretchOnly" === sc && Dl / Fl < mc || "proportional" === sc) {
                                const le1 = Math.ceil(Fl * mc);
                                ls *= le1 / Dl, Dl = le1;
                            }
                        } else if ("proportional" === sc && "stretchOnly" === uc && 0 !== mc && Dl / Fl > mc) {
                            const le1 = Math.ceil(Dl / mc);
                            ho *= le1 / Fl, Fl = le1;
                        }
                        return {
                            x1: ls,
                            y1: ho,
                            x2: ls + Dl,
                            y2: ho + Fl
                        };
                    }
                    function ic(le1, vt, bt, ls, ho, Dl) {
                        const Fl = le1.image;
                        let sc;
                        if (Fl.content) {
                            const le1 = Fl.content, vt = Fl.pixelRatio || 1;
                            sc = [
                                le1[0] / vt,
                                le1[1] / vt,
                                Fl.displaySize[0] - le1[2] / vt,
                                Fl.displaySize[1] - le1[3] / vt
                            ];
                        }
                        const uc = vt.left * Dl, mc = vt.right * Dl;
                        let gc, Ac, Ec, kc;
                        "width" === bt || "both" === bt ? (kc = ho[0] + uc - ls[3], Ac = ho[0] + mc + ls[1]) : (kc = ho[0] + (uc + mc - Fl.displaySize[0]) / 2, Ac = kc + Fl.displaySize[0]);
                        const du = vt.top * Dl, _u = vt.bottom * Dl;
                        return "height" === bt || "both" === bt ? (gc = ho[1] + du - ls[0], Ec = ho[1] + _u + ls[2]) : (gc = ho[1] + (du + _u - Fl.displaySize[1]) / 2, Ec = gc + Fl.displaySize[1]), {
                            image: Fl,
                            top: gc,
                            right: Ac,
                            bottom: Ec,
                            left: kc,
                            collisionPadding: sc
                        };
                    }
                    pi("ImagePosition", ju), pi("ImageAtlas", Xu), function(le1) {
                        le1[le1.none = 0] = "none", le1[le1.horizontal = 1] = "horizontal", le1[le1.vertical = 2] = "vertical", le1[le1.horizontalOnly = 3] = "horizontalOnly";
                    }(Qg || (Qg = {}));
                    const Xg = 128, Kg = 32640;
                    function ac(le1, vt) {
                        const { expression: bt } = vt;
                        if ("constant" === bt.kind) return {
                            kind: "constant",
                            layoutSize: bt.evaluate(new Gi(le1 + 1))
                        };
                        if ("source" === bt.kind) return {
                            kind: "source"
                        };
                        {
                            const { zoomStops: vt, interpolationType: ls } = bt;
                            let ho = 0;
                            for(; ho < vt.length && vt[ho] <= le1;)ho++;
                            ho = Math.max(0, ho - 1);
                            let Dl = ho;
                            for(; Dl < vt.length && vt[Dl] < le1 + 1;)Dl++;
                            Dl = Math.min(vt.length - 1, Dl);
                            const Fl = vt[ho], sc = vt[Dl];
                            return "composite" === bt.kind ? {
                                kind: "composite",
                                minZoom: Fl,
                                maxZoom: sc,
                                interpolationType: ls
                            } : {
                                kind: "camera",
                                minZoom: Fl,
                                maxZoom: sc,
                                minSize: bt.evaluate(new Gi(Fl)),
                                maxSize: bt.evaluate(new Gi(sc)),
                                interpolationType: ls
                            };
                        }
                    }
                    function lc(le1, vt, bt) {
                        let ls = "never";
                        const ho = le1.get(vt);
                        return ho ? ls = ho : le1.get(bt) && (ls = "always"), ls;
                    }
                    const Jg = [
                        {
                            name: "a_fade_opacity",
                            components: 1,
                            type: "Uint8",
                            offset: 0
                        }
                    ];
                    function cc(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                        const kc = sc ? Math.min(Kg, Math.round(sc[0])) : 0, du = sc ? Math.min(Kg, Math.round(sc[1])) : 0;
                        le1.emplaceBack(vt, bt, Math.round(32 * ls), Math.round(32 * ho), Dl, Fl, (kc << 1) + (uc ? 1 : 0), du, 16 * mc, 16 * gc, 256 * Ac, 256 * Ec);
                    }
                    function hc(le1, vt, bt) {
                        le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt);
                    }
                    function pc(le1) {
                        for (const vt of le1.sections)if (Ui(vt.text)) return !0;
                        return !1;
                    }
                    class fc {
                        constructor(le1){
                            this.layoutVertexArray = new no, this.indexArray = new lo, this.programConfigurations = le1, this.segments = new po, this.dynamicLayoutVertexArray = new io, this.opacityVertexArray = new so, this.hasVisibleVertices = !1, this.placedSymbolArray = new Ns;
                        }
                        isEmpty() {
                            return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                        }
                        upload(le1, vt, bt, ls) {
                            this.isEmpty() || (bt && (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Og.members), this.indexBuffer = le1.createIndexBuffer(this.indexArray, vt), this.dynamicLayoutVertexBuffer = le1.createVertexBuffer(this.dynamicLayoutVertexArray, Bg.members, !0), this.opacityVertexBuffer = le1.createVertexBuffer(this.opacityVertexArray, Jg, !0), this.opacityVertexBuffer.itemSize = 1), (bt || ls) && this.programConfigurations.upload(le1));
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                        }
                    }
                    pi("SymbolBuffers", fc);
                    class dc {
                        constructor(le1, vt, bt){
                            this.layoutVertexArray = new le1, this.layoutAttributes = vt, this.indexArray = new bt, this.segments = new po, this.collisionVertexArray = new ao;
                        }
                        upload(le1) {
                            this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = le1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = le1.createVertexBuffer(this.collisionVertexArray, jg.members, !0);
                        }
                        destroy() {
                            this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                        }
                    }
                    pi("CollisionBuffers", dc);
                    class yc {
                        constructor(le1){
                            this.collisionBoxArray = le1.collisionBoxArray, this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.pixelRatio = le1.pixelRatio, this.sourceLayerIndex = le1.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                            const vt = this.layers[0]._unevaluatedLayout._values;
                            this.textSizeData = ac(this.zoom, vt["text-size"]), this.iconSizeData = ac(this.zoom, vt["icon-size"]);
                            const bt = this.layers[0].layout, ls = bt.get("symbol-sort-key"), ho = bt.get("symbol-z-order");
                            this.canOverlap = "never" !== lc(bt, "text-overlap", "text-allow-overlap") || "never" !== lc(bt, "icon-overlap", "icon-allow-overlap") || bt.get("text-ignore-placement") || bt.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== ho && !ls.isConstant(), this.sortFeaturesByY = ("viewport-y" === ho || "auto" === ho && !this.sortFeaturesByKey) && this.canOverlap, "point" === bt.get("symbol-placement") && (this.writingModes = bt.get("text-writing-mode").map((le1)=>Qg[le1])), this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id), this.sourceID = le1.sourceID;
                        }
                        createArrays() {
                            this.text = new fc(new Uo(this.layers, this.zoom, (le1)=>/^text/.test(le1))), this.icon = new fc(new Uo(this.layers, this.zoom, (le1)=>/^icon/.test(le1))), this.glyphOffsetArray = new qs, this.lineVertexArray = new Gs, this.symbolInstances = new Us, this.textAnchorOffsets = new Xs;
                        }
                        calculateGlyphDependencies(le1, vt, bt, ls, ho) {
                            for (const Dl of le1)if (vt[Dl.codePointAt(0)] = !0, (bt || ls) && ho) {
                                const le1 = Gg[Dl];
                                le1 && (vt[le1.codePointAt(0)] = !0);
                            }
                        }
                        populate(le1, vt, bt) {
                            const ls = this.layers[0], ho = ls.layout, Dl = ho.get("text-font"), Fl = ho.get("text-field"), sc = ho.get("icon-image"), uc = ("constant" !== Fl.value.kind || Fl.value.value instanceof Me && !Fl.value.value.isEmpty() || Fl.value.value.toString().length > 0) && ("constant" !== Dl.value.kind || Dl.value.value.length > 0), mc = "constant" !== sc.value.kind || !!sc.value.value || Object.keys(sc.parameters).length > 0, gc = ho.get("symbol-sort-key");
                            if (this.features = [], !uc && !mc) return;
                            const Ac = vt.iconDependencies, Ec = vt.glyphDependencies, kc = vt.availableImages, du = new Gi(this.zoom);
                            for (const { feature: _u, id: Md, index: Ld, sourceLayerIndex: Nd } of le1){
                                const le1 = ls._featureFilter.needGeometry, vt = Zo(_u, le1);
                                if (!ls._featureFilter.filter(du, vt, bt)) continue;
                                let Fl, sc;
                                if (le1 || (vt.geometry = Yo(_u)), uc) {
                                    const le1 = ls.getValueAndResolveTokens("text-field", vt, bt, kc), ho = Me.factory(le1), Dl = this.hasRTLText = this.hasRTLText || pc(ho);
                                    (!Dl || "unavailable" === Um.getRTLTextPluginStatus() || Dl && Um.isParsed()) && (Fl = xu(ho, ls, vt));
                                }
                                if (mc) {
                                    const le1 = ls.getValueAndResolveTokens("icon-image", vt, bt, kc);
                                    sc = le1 instanceof Ve ? le1 : Ve.fromString(le1);
                                }
                                if (!Fl && !sc) continue;
                                const Rd = this.sortFeaturesByKey ? gc.evaluate(vt, {}, bt) : void 0;
                                if (this.features.push({
                                    id: Md,
                                    text: Fl,
                                    icon: sc,
                                    index: Ld,
                                    sourceLayerIndex: Nd,
                                    geometry: vt.geometry,
                                    properties: _u.properties,
                                    type: Cl.types[_u.type],
                                    sortKey: Rd
                                }), sc && (Ac[sc.name] = !0), Fl) {
                                    const le1 = Dl.evaluate(vt, {}, bt).join(","), ls = "viewport" !== ho.get("text-rotation-alignment") && "point" !== ho.get("symbol-placement");
                                    this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(Qg.vertical) >= 0;
                                    for (const vt of Fl.sections)if (vt.image) Ac[vt.image.name] = !0;
                                    else {
                                        const bt = Fi(Fl.toString()), ho = vt.fontStack || le1, Dl = Ec[ho] = Ec[ho] || {};
                                        this.calculateGlyphDependencies(vt.text, Dl, ls, this.allowVerticalPlacement, bt);
                                    }
                                }
                            }
                            "line" === ho.get("symbol-placement") && (this.features = function(le1) {
                                const vt = {}, bt = {}, ls = [];
                                let ho = 0;
                                function s(vt) {
                                    ls.push(le1[vt]), ho++;
                                }
                                function o(le1, vt, ho) {
                                    const Dl = bt[le1];
                                    return delete bt[le1], bt[vt] = Dl, ls[Dl].geometry[0].pop(), ls[Dl].geometry[0] = ls[Dl].geometry[0].concat(ho[0]), Dl;
                                }
                                function a(le1, bt, ho) {
                                    const Dl = vt[bt];
                                    return delete vt[bt], vt[le1] = Dl, ls[Dl].geometry[0].shift(), ls[Dl].geometry[0] = ho[0].concat(ls[Dl].geometry[0]), Dl;
                                }
                                function l(le1, vt, bt) {
                                    const ls = bt ? vt[0][vt[0].length - 1] : vt[0][0];
                                    return `${le1}:${ls.x}:${ls.y}`;
                                }
                                for(let Dl = 0; Dl < le1.length; Dl++){
                                    const Fl = le1[Dl], sc = Fl.geometry, uc = Fl.text ? Fl.text.toString() : null;
                                    if (!uc) {
                                        s(Dl);
                                        continue;
                                    }
                                    const mc = l(uc, sc), gc = l(uc, sc, !0);
                                    if (mc in bt && gc in vt && bt[mc] !== vt[gc]) {
                                        const le1 = a(mc, gc, sc), ho = o(mc, gc, ls[le1].geometry);
                                        delete vt[mc], delete bt[gc], bt[l(uc, ls[ho].geometry, !0)] = ho, ls[le1].geometry = null;
                                    } else mc in bt ? o(mc, gc, sc) : gc in vt ? a(mc, gc, sc) : (s(Dl), vt[mc] = ho - 1, bt[gc] = ho - 1);
                                }
                                return ls.filter((le1)=>le1.geometry);
                            }(this.features)), this.sortFeaturesByKey && this.features.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                        }
                        update(le1, vt, bt) {
                            this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(le1, vt, this.layers, {
                                imagePositions: bt
                            }), this.icon.programConfigurations.updatePaintArrays(le1, vt, this.layers, {
                                imagePositions: bt
                            }));
                        }
                        isEmpty() {
                            return 0 === this.symbolInstances.length && !this.hasRTLText;
                        }
                        uploadPending() {
                            return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                        }
                        upload(le1) {
                            !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(le1), this.iconCollisionBox.upload(le1)), this.text.upload(le1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(le1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                        }
                        destroyDebugData() {
                            this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                        }
                        destroy() {
                            this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                        }
                        addToLineVertexArray(le1, vt) {
                            const bt = this.lineVertexArray.length;
                            if (void 0 !== le1.segment) {
                                let bt = le1.dist(vt[le1.segment + 1]), ls = le1.dist(vt[le1.segment]);
                                const ho = {};
                                for(let Dl = le1.segment + 1; Dl < vt.length; Dl++)ho[Dl] = {
                                    x: vt[Dl].x,
                                    y: vt[Dl].y,
                                    tileUnitDistanceFromAnchor: bt
                                }, Dl < vt.length - 1 && (bt += vt[Dl + 1].dist(vt[Dl]));
                                for(let Dl = le1.segment || 0; Dl >= 0; Dl--)ho[Dl] = {
                                    x: vt[Dl].x,
                                    y: vt[Dl].y,
                                    tileUnitDistanceFromAnchor: ls
                                }, Dl > 0 && (ls += vt[Dl - 1].dist(vt[Dl]));
                                for(let le1 = 0; le1 < vt.length; le1++){
                                    const vt = ho[le1];
                                    this.lineVertexArray.emplaceBack(vt.x, vt.y, vt.tileUnitDistanceFromAnchor);
                                }
                            }
                            return {
                                lineStartIndex: bt,
                                lineLength: this.lineVertexArray.length - bt
                            };
                        }
                        addSymbols(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                            const Ec = le1.indexArray, kc = le1.layoutVertexArray, du = le1.segments.prepareSegment(4 * vt.length, kc, Ec, this.canOverlap ? Dl.sortKey : void 0), _u = this.glyphOffsetArray.length, Md = du.vertexLength, Ld = this.allowVerticalPlacement && Fl === Qg.vertical ? Math.PI / 2 : 0, Nd = Dl.text && Dl.text.sections;
                            for(let Rd = 0; Rd < vt.length; Rd++){
                                const { tl: ls, tr: ho, bl: Fl, br: uc, tex: mc, pixelOffsetTL: gc, pixelOffsetBR: _u, minFontScaleX: Md, minFontScaleY: Od, glyphOffset: jd, isSDF: Ud, sectionIndex: Gd } = vt[Rd], qd = du.vertexLength, Hd = jd[1];
                                cc(kc, sc.x, sc.y, ls.x, Hd + ls.y, mc.x, mc.y, bt, Ud, gc.x, gc.y, Md, Od), cc(kc, sc.x, sc.y, ho.x, Hd + ho.y, mc.x + mc.w, mc.y, bt, Ud, _u.x, gc.y, Md, Od), cc(kc, sc.x, sc.y, Fl.x, Hd + Fl.y, mc.x, mc.y + mc.h, bt, Ud, gc.x, _u.y, Md, Od), cc(kc, sc.x, sc.y, uc.x, Hd + uc.y, mc.x + mc.w, mc.y + mc.h, bt, Ud, _u.x, _u.y, Md, Od), hc(le1.dynamicLayoutVertexArray, sc, Ld), Ec.emplaceBack(qd, qd + 2, qd + 1), Ec.emplaceBack(qd + 1, qd + 2, qd + 3), du.vertexLength += 4, du.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(jd[0]), Rd !== vt.length - 1 && Gd === vt[Rd + 1].sectionIndex || le1.programConfigurations.populatePaintArrays(kc.length, Dl, Dl.index, {
                                    imagePositions: {},
                                    canonical: Ac,
                                    formattedSection: Nd && Nd[Gd]
                                });
                            }
                            le1.placedSymbolArray.emplaceBack(sc.x, sc.y, _u, this.glyphOffsetArray.length - _u, Md, uc, mc, sc.segment, bt ? bt[0] : 0, bt ? bt[1] : 0, ls[0], ls[1], Fl, 0, !1, 0, gc);
                        }
                        _addCollisionDebugVertex(le1, vt, bt, ls, ho, Dl) {
                            return vt.emplaceBack(0, 0), le1.emplaceBack(bt.x, bt.y, ls, ho, Math.round(Dl.x), Math.round(Dl.y));
                        }
                        addCollisionDebugVertices(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = ho.segments.prepareSegment(4, ho.layoutVertexArray, ho.indexArray), uc = sc.vertexLength, mc = ho.layoutVertexArray, gc = ho.collisionVertexArray, Ac = Fl.anchorX, Ec = Fl.anchorY;
                            this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new t(le1, vt)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new t(bt, vt)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new t(bt, ls)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new t(le1, ls)), sc.vertexLength += 4;
                            const kc = ho.indexArray;
                            kc.emplaceBack(uc, uc + 1), kc.emplaceBack(uc + 1, uc + 2), kc.emplaceBack(uc + 2, uc + 3), kc.emplaceBack(uc + 3, uc), sc.primitiveLength += 4;
                        }
                        addDebugCollisionBoxes(le1, vt, bt, ls) {
                            for(let ho = le1; ho < vt; ho++){
                                const le1 = this.collisionBoxArray.get(ho);
                                this.addCollisionDebugVertices(le1.x1, le1.y1, le1.x2, le1.y2, ls ? this.textCollisionBox : this.iconCollisionBox, le1.anchorPoint, bt);
                            }
                        }
                        generateCollisionDebugBuffers() {
                            this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new dc(oo, Ug.members, uo), this.iconCollisionBox = new dc(oo, Ug.members, uo);
                            for(let le1 = 0; le1 < this.symbolInstances.length; le1++){
                                const vt = this.symbolInstances.get(le1);
                                this.addDebugCollisionBoxes(vt.textBoxStartIndex, vt.textBoxEndIndex, vt, !0), this.addDebugCollisionBoxes(vt.verticalTextBoxStartIndex, vt.verticalTextBoxEndIndex, vt, !0), this.addDebugCollisionBoxes(vt.iconBoxStartIndex, vt.iconBoxEndIndex, vt, !1), this.addDebugCollisionBoxes(vt.verticalIconBoxStartIndex, vt.verticalIconBoxEndIndex, vt, !1);
                            }
                        }
                        _deserializeCollisionBoxesForSymbol(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = {};
                            for(let gc = vt; gc < bt; gc++){
                                const vt = le1.get(gc);
                                mc.textBox = {
                                    x1: vt.x1,
                                    y1: vt.y1,
                                    x2: vt.x2,
                                    y2: vt.y2,
                                    anchorPointX: vt.anchorPointX,
                                    anchorPointY: vt.anchorPointY
                                }, mc.textFeatureIndex = vt.featureIndex;
                                break;
                            }
                            for(let gc = ls; gc < ho; gc++){
                                const vt = le1.get(gc);
                                mc.verticalTextBox = {
                                    x1: vt.x1,
                                    y1: vt.y1,
                                    x2: vt.x2,
                                    y2: vt.y2,
                                    anchorPointX: vt.anchorPointX,
                                    anchorPointY: vt.anchorPointY
                                }, mc.verticalTextFeatureIndex = vt.featureIndex;
                                break;
                            }
                            for(let gc = Dl; gc < Fl; gc++){
                                const vt = le1.get(gc);
                                mc.iconBox = {
                                    x1: vt.x1,
                                    y1: vt.y1,
                                    x2: vt.x2,
                                    y2: vt.y2,
                                    anchorPointX: vt.anchorPointX,
                                    anchorPointY: vt.anchorPointY
                                }, mc.iconFeatureIndex = vt.featureIndex;
                                break;
                            }
                            for(let gc = sc; gc < uc; gc++){
                                const vt = le1.get(gc);
                                mc.verticalIconBox = {
                                    x1: vt.x1,
                                    y1: vt.y1,
                                    x2: vt.x2,
                                    y2: vt.y2,
                                    anchorPointX: vt.anchorPointX,
                                    anchorPointY: vt.anchorPointY
                                }, mc.verticalIconFeatureIndex = vt.featureIndex;
                                break;
                            }
                            return mc;
                        }
                        deserializeCollisionBoxes(le1) {
                            this.collisionArrays = [];
                            for(let vt = 0; vt < this.symbolInstances.length; vt++){
                                const bt = this.symbolInstances.get(vt);
                                this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(le1, bt.textBoxStartIndex, bt.textBoxEndIndex, bt.verticalTextBoxStartIndex, bt.verticalTextBoxEndIndex, bt.iconBoxStartIndex, bt.iconBoxEndIndex, bt.verticalIconBoxStartIndex, bt.verticalIconBoxEndIndex));
                            }
                        }
                        hasTextData() {
                            return this.text.segments.get().length > 0;
                        }
                        hasIconData() {
                            return this.icon.segments.get().length > 0;
                        }
                        hasDebugData() {
                            return this.textCollisionBox && this.iconCollisionBox;
                        }
                        hasTextCollisionBoxData() {
                            return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                        }
                        hasIconCollisionBoxData() {
                            return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                        }
                        addIndicesForPlacedSymbol(le1, vt) {
                            const bt = le1.placedSymbolArray.get(vt), ls = bt.vertexStartIndex + 4 * bt.numGlyphs;
                            for(let ho = bt.vertexStartIndex; ho < ls; ho += 4)le1.indexArray.emplaceBack(ho, ho + 2, ho + 1), le1.indexArray.emplaceBack(ho + 1, ho + 2, ho + 3);
                        }
                        getSortedSymbolIndexes(le1) {
                            if (this.sortedAngle === le1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                            const vt = Math.sin(le1), bt = Math.cos(le1), ls = [], ho = [], Dl = [];
                            for(let Fl = 0; Fl < this.symbolInstances.length; ++Fl){
                                Dl.push(Fl);
                                const le1 = this.symbolInstances.get(Fl);
                                ls.push(0 | Math.round(vt * le1.anchorX + bt * le1.anchorY)), ho.push(le1.featureIndex);
                            }
                            return Dl.sort((le1, vt)=>ls[le1] - ls[vt] || ho[vt] - ho[le1]), Dl;
                        }
                        addToSortKeyRanges(le1, vt) {
                            const bt = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                            bt && bt.sortKey === vt ? bt.symbolInstanceEnd = le1 + 1 : this.sortKeyRanges.push({
                                sortKey: vt,
                                symbolInstanceStart: le1,
                                symbolInstanceEnd: le1 + 1
                            });
                        }
                        sortFeatures(le1) {
                            if (this.sortFeaturesByY && this.sortedAngle !== le1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                this.symbolInstanceIndexes = this.getSortedSymbolIndexes(le1), this.sortedAngle = le1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                for (const le1 of this.symbolInstanceIndexes){
                                    const vt = this.symbolInstances.get(le1);
                                    this.featureSortOrder.push(vt.featureIndex), [
                                        vt.rightJustifiedTextSymbolIndex,
                                        vt.centerJustifiedTextSymbolIndex,
                                        vt.leftJustifiedTextSymbolIndex
                                    ].forEach((le1, vt, bt)=>{
                                        le1 >= 0 && bt.indexOf(le1) === vt && this.addIndicesForPlacedSymbol(this.text, le1);
                                    }), vt.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, vt.verticalPlacedTextSymbolIndex), vt.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, vt.placedIconSymbolIndex), vt.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, vt.verticalPlacedIconSymbolIndex);
                                }
                                this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                            }
                        }
                    }
                    let $g, eA;
                    pi("SymbolBucket", yc, {
                        omit: [
                            "layers",
                            "collisionBoxArray",
                            "features",
                            "compareText"
                        ]
                    }), yc.MAX_GLYPHS = 65535, yc.addDynamicAttributes = hc;
                    var tA = {
                        get paint () {
                            return eA = eA || new os({
                                "icon-opacity": new rs(Ec.paint_symbol["icon-opacity"]),
                                "icon-color": new rs(Ec.paint_symbol["icon-color"]),
                                "icon-halo-color": new rs(Ec.paint_symbol["icon-halo-color"]),
                                "icon-halo-width": new rs(Ec.paint_symbol["icon-halo-width"]),
                                "icon-halo-blur": new rs(Ec.paint_symbol["icon-halo-blur"]),
                                "icon-translate": new ts(Ec.paint_symbol["icon-translate"]),
                                "icon-translate-anchor": new ts(Ec.paint_symbol["icon-translate-anchor"]),
                                "text-opacity": new rs(Ec.paint_symbol["text-opacity"]),
                                "text-color": new rs(Ec.paint_symbol["text-color"], {
                                    runtimeType: Nd,
                                    getOverride: (le1)=>le1.textColor,
                                    hasOverride: (le1)=>!!le1.textColor
                                }),
                                "text-halo-color": new rs(Ec.paint_symbol["text-halo-color"]),
                                "text-halo-width": new rs(Ec.paint_symbol["text-halo-width"]),
                                "text-halo-blur": new rs(Ec.paint_symbol["text-halo-blur"]),
                                "text-translate": new ts(Ec.paint_symbol["text-translate"]),
                                "text-translate-anchor": new ts(Ec.paint_symbol["text-translate-anchor"])
                            });
                        },
                        get layout () {
                            return $g = $g || new os({
                                "symbol-placement": new ts(Ec.layout_symbol["symbol-placement"]),
                                "symbol-spacing": new ts(Ec.layout_symbol["symbol-spacing"]),
                                "symbol-avoid-edges": new ts(Ec.layout_symbol["symbol-avoid-edges"]),
                                "symbol-sort-key": new rs(Ec.layout_symbol["symbol-sort-key"]),
                                "symbol-z-order": new ts(Ec.layout_symbol["symbol-z-order"]),
                                "icon-allow-overlap": new ts(Ec.layout_symbol["icon-allow-overlap"]),
                                "icon-overlap": new ts(Ec.layout_symbol["icon-overlap"]),
                                "icon-ignore-placement": new ts(Ec.layout_symbol["icon-ignore-placement"]),
                                "icon-optional": new ts(Ec.layout_symbol["icon-optional"]),
                                "icon-rotation-alignment": new ts(Ec.layout_symbol["icon-rotation-alignment"]),
                                "icon-size": new rs(Ec.layout_symbol["icon-size"]),
                                "icon-text-fit": new ts(Ec.layout_symbol["icon-text-fit"]),
                                "icon-text-fit-padding": new ts(Ec.layout_symbol["icon-text-fit-padding"]),
                                "icon-image": new rs(Ec.layout_symbol["icon-image"]),
                                "icon-rotate": new rs(Ec.layout_symbol["icon-rotate"]),
                                "icon-padding": new rs(Ec.layout_symbol["icon-padding"]),
                                "icon-keep-upright": new ts(Ec.layout_symbol["icon-keep-upright"]),
                                "icon-offset": new rs(Ec.layout_symbol["icon-offset"]),
                                "icon-anchor": new rs(Ec.layout_symbol["icon-anchor"]),
                                "icon-pitch-alignment": new ts(Ec.layout_symbol["icon-pitch-alignment"]),
                                "text-pitch-alignment": new ts(Ec.layout_symbol["text-pitch-alignment"]),
                                "text-rotation-alignment": new ts(Ec.layout_symbol["text-rotation-alignment"]),
                                "text-field": new rs(Ec.layout_symbol["text-field"]),
                                "text-font": new rs(Ec.layout_symbol["text-font"]),
                                "text-size": new rs(Ec.layout_symbol["text-size"]),
                                "text-max-width": new rs(Ec.layout_symbol["text-max-width"]),
                                "text-line-height": new ts(Ec.layout_symbol["text-line-height"]),
                                "text-letter-spacing": new rs(Ec.layout_symbol["text-letter-spacing"]),
                                "text-justify": new rs(Ec.layout_symbol["text-justify"]),
                                "text-radial-offset": new rs(Ec.layout_symbol["text-radial-offset"]),
                                "text-variable-anchor": new ts(Ec.layout_symbol["text-variable-anchor"]),
                                "text-variable-anchor-offset": new rs(Ec.layout_symbol["text-variable-anchor-offset"]),
                                "text-anchor": new rs(Ec.layout_symbol["text-anchor"]),
                                "text-max-angle": new ts(Ec.layout_symbol["text-max-angle"]),
                                "text-writing-mode": new ts(Ec.layout_symbol["text-writing-mode"]),
                                "text-rotate": new rs(Ec.layout_symbol["text-rotate"]),
                                "text-padding": new ts(Ec.layout_symbol["text-padding"]),
                                "text-keep-upright": new ts(Ec.layout_symbol["text-keep-upright"]),
                                "text-transform": new rs(Ec.layout_symbol["text-transform"]),
                                "text-offset": new rs(Ec.layout_symbol["text-offset"]),
                                "text-allow-overlap": new ts(Ec.layout_symbol["text-allow-overlap"]),
                                "text-overlap": new ts(Ec.layout_symbol["text-overlap"]),
                                "text-ignore-placement": new ts(Ec.layout_symbol["text-ignore-placement"]),
                                "text-optional": new ts(Ec.layout_symbol["text-optional"])
                            });
                        }
                    };
                    class vc {
                        constructor(le1){
                            if (void 0 === le1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                            this.type = le1.property.overrides ? le1.property.overrides.runtimeType : du, this.defaultValue = le1;
                        }
                        evaluate(le1) {
                            if (le1.formattedSection) {
                                const vt = this.defaultValue.property.overrides;
                                if (vt && vt.hasOverride(le1.formattedSection)) return vt.getOverride(le1.formattedSection);
                            }
                            return le1.feature && le1.featureState ? this.defaultValue.evaluate(le1.feature, le1.featureState) : this.defaultValue.property.specification.default;
                        }
                        eachChild(le1) {
                            this.defaultValue.isConstant() || le1(this.defaultValue.value._styleExpression.expression);
                        }
                        outputDefined() {
                            return !1;
                        }
                        serialize() {
                            return null;
                        }
                    }
                    pi("FormatSectionOverride", vc, {
                        omit: [
                            "defaultValue"
                        ]
                    });
                    class bc extends as {
                        constructor(le1, vt){
                            super(le1, tA, vt);
                        }
                        recalculate(le1, vt) {
                            if (super.recalculate(le1, vt), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                const le1 = this.layout.get("text-writing-mode");
                                if (le1) {
                                    const vt = [];
                                    for (const bt of le1)vt.indexOf(bt) < 0 && vt.push(bt);
                                    this.layout._values["text-writing-mode"] = vt;
                                } else this.layout._values["text-writing-mode"] = [
                                    "horizontal"
                                ];
                            }
                            this._setPaintOverrides();
                        }
                        getValueAndResolveTokens(le1, vt, bt, ls) {
                            const ho = this.layout.get(le1).evaluate(vt, {}, bt, ls), Dl = this._unevaluatedLayout._values[le1];
                            return Dl.isDataDriven() || Qr(Dl.value) || !ho ? ho : function(le1, vt) {
                                return vt.replace(/{([^{}]+)}/g, (vt, bt)=>le1 && bt in le1 ? String(le1[bt]) : "");
                            }(vt.properties, ho);
                        }
                        createBucket(le1) {
                            return new yc(le1);
                        }
                        queryRadius() {
                            return 0;
                        }
                        queryIntersectsFeature() {
                            throw new Error("Should take a different path in FeatureIndex");
                        }
                        _setPaintOverrides() {
                            for (const le1 of tA.paint.overridableProperties){
                                if (!bc.hasPaintOverride(this.layout, le1)) continue;
                                const vt = this.paint.get(le1), bt = new vc(vt), ls = new Kr(bt, vt.property.specification);
                                let ho = null;
                                ho = "constant" === vt.value.kind || "source" === vt.value.kind ? new tn("source", ls) : new rn("composite", ls, vt.value.zoomStops), this.paint._values[le1] = new Qi(vt.property, ho, vt.parameters);
                            }
                        }
                        _handleOverridablePaintPropertyUpdate(le1, vt, bt) {
                            return !(!this.layout || vt.isDataDriven() || bt.isDataDriven()) && bc.hasPaintOverride(this.layout, le1);
                        }
                        static hasPaintOverride(le1, vt) {
                            const bt = le1.get("text-field"), ls = tA.paint.properties[vt];
                            let ho = !1;
                            const s = (le1)=>{
                                for (const vt of le1)if (ls.overrides && ls.overrides.hasOverride(vt)) return void (ho = !0);
                            };
                            if ("constant" === bt.value.kind && bt.value.value instanceof Me) s(bt.value.value.sections);
                            else if ("source" === bt.value.kind || "composite" === bt.value.kind) {
                                const e = (le1)=>{
                                    ho || (le1 instanceof Ue && Ne(le1.value) === Gd ? s(le1.value.sections) : le1 instanceof Tt ? s(le1.sections) : le1.eachChild(e));
                                }, le1 = bt.value;
                                le1._styleExpression && e(le1._styleExpression.expression);
                            }
                            return ho;
                        }
                    }
                    let iA;
                    var nA = {
                        get paint () {
                            return iA = iA || new os({
                                "background-color": new ts(Ec.paint_background["background-color"]),
                                "background-pattern": new is(Ec.paint_background["background-pattern"]),
                                "background-opacity": new ts(Ec.paint_background["background-opacity"])
                            });
                        }
                    };
                    class Sc extends as {
                        constructor(le1, vt){
                            super(le1, nA, vt);
                        }
                    }
                    let rA;
                    var aA, sA, oA, lA, cA, uA, hA, dA, pA, mA, fA = {
                        get paint () {
                            return rA = rA || new os({
                                "raster-opacity": new ts(Ec.paint_raster["raster-opacity"]),
                                "raster-hue-rotate": new ts(Ec.paint_raster["raster-hue-rotate"]),
                                "raster-brightness-min": new ts(Ec.paint_raster["raster-brightness-min"]),
                                "raster-brightness-max": new ts(Ec.paint_raster["raster-brightness-max"]),
                                "raster-saturation": new ts(Ec.paint_raster["raster-saturation"]),
                                "raster-contrast": new ts(Ec.paint_raster["raster-contrast"]),
                                "raster-resampling": new ts(Ec.paint_raster["raster-resampling"]),
                                "raster-fade-duration": new ts(Ec.paint_raster["raster-fade-duration"])
                            });
                        }
                    };
                    class Vc extends as {
                        constructor(le1, vt){
                            super(le1, fA, vt);
                        }
                    }
                    class Lc extends as {
                        constructor(le1, vt){
                            super(le1, {}, vt), this.onAdd = (le1)=>{
                                this.implementation.onAdd && this.implementation.onAdd(le1, le1.painter.context.gl);
                            }, this.onRemove = (le1)=>{
                                this.implementation.onRemove && this.implementation.onRemove(le1, le1.painter.context.gl);
                            }, this.implementation = le1;
                        }
                        is3D() {
                            return "3d" === this.implementation.renderingMode;
                        }
                        hasOffscreenPass() {
                            return void 0 !== this.implementation.prerender;
                        }
                        recalculate() {}
                        updateTransitions() {}
                        hasTransition() {
                            return !1;
                        }
                        serialize() {
                            throw new Error("Custom layers cannot be serialized");
                        }
                    }
                    function Oc(le1, vt) {
                        if ("custom" === le1.type) return new Lc(le1, vt);
                        switch(le1.type){
                            case "background":
                                return new Sc(le1, vt);
                            case "circle":
                                return new _a(le1, vt);
                            case "color-relief":
                                return new $a(le1, vt);
                            case "fill":
                                return new Pl(le1, vt);
                            case "fill-extrusion":
                                return new Jl(le1, vt);
                            case "heatmap":
                                return new za(le1, vt);
                            case "hillshade":
                                return new Ca(le1, vt);
                            case "line":
                                return new pu(le1, vt);
                            case "raster":
                                return new Vc(le1, vt);
                            case "symbol":
                                return new bc(le1, vt);
                        }
                    }
                    class Rc {
                        constructor(le1){
                            this._stringToNumber = {}, this._numberToString = [];
                            for(let vt = 0; vt < le1.length; vt++){
                                const bt = le1[vt];
                                this._stringToNumber[bt] = vt, this._numberToString[vt] = bt;
                            }
                        }
                        encode(le1) {
                            return this._stringToNumber[le1];
                        }
                        decode(le1) {
                            if (le1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${le1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                            return this._numberToString[le1];
                        }
                    }
                    class Nc {
                        constructor(le1, vt, bt, ls, ho){
                            this.type = "Feature", this._vectorTileFeature = le1, this._x = bt, this._y = ls, this._z = vt, this.properties = le1.properties, this.id = ho;
                        }
                        projectPoint(le1, vt, bt, ls) {
                            return [
                                360 * (le1.x + vt) / ls - 180,
                                360 / Math.PI * Math.atan(Math.exp((1 - 2 * (le1.y + bt) / ls) * Math.PI)) - 90
                            ];
                        }
                        projectLine(le1, vt, bt, ls) {
                            return le1.map((le1)=>this.projectPoint(le1, vt, bt, ls));
                        }
                        get geometry() {
                            if (this._geometry) return this._geometry;
                            const le1 = this._vectorTileFeature, vt = le1.extent * Math.pow(2, this._z), bt = le1.extent * this._x, ls = le1.extent * this._y, ho = le1.loadGeometry();
                            switch(le1.type){
                                case 1:
                                    {
                                        const le1 = [];
                                        for (const vt of ho)le1.push(vt[0]);
                                        const Dl = this.projectLine(le1, bt, ls, vt);
                                        this._geometry = 1 === le1.length ? {
                                            type: "Point",
                                            coordinates: Dl[0]
                                        } : {
                                            type: "MultiPoint",
                                            coordinates: Dl
                                        };
                                        break;
                                    }
                                case 2:
                                    {
                                        const le1 = ho.map((le1)=>this.projectLine(le1, bt, ls, vt));
                                        this._geometry = 1 === le1.length ? {
                                            type: "LineString",
                                            coordinates: le1[0]
                                        } : {
                                            type: "MultiLineString",
                                            coordinates: le1
                                        };
                                        break;
                                    }
                                case 3:
                                    {
                                        const le1 = Ll(ho), Dl = [];
                                        for (const ho of le1)Dl.push(ho.map((le1)=>this.projectLine(le1, bt, ls, vt)));
                                        this._geometry = 1 === Dl.length ? {
                                            type: "Polygon",
                                            coordinates: Dl[0]
                                        } : {
                                            type: "MultiPolygon",
                                            coordinates: Dl
                                        };
                                        break;
                                    }
                                default:
                                    throw new Error(`unknown feature type: ${le1.type}`);
                            }
                            return this._geometry;
                        }
                        set geometry(le1) {
                            this._geometry = le1;
                        }
                        toJSON() {
                            const le1 = {
                                geometry: this.geometry
                            };
                            for(const vt in this)"_geometry" !== vt && "_vectorTileFeature" !== vt && "_x" !== vt && "_y" !== vt && "_z" !== vt && (le1[vt] = this[vt]);
                            return le1;
                        }
                    }
                    class $c {
                        constructor(le1, vt, bt){
                            this._name = void 0, this.dataBuffer = void 0, this.nullabilityBuffer = void 0, this._size = void 0, this._name = le1, this.dataBuffer = vt, "number" == typeof bt ? this._size = bt : (this.nullabilityBuffer = bt, this._size = bt.size());
                        }
                        getValue(le1) {
                            return this.nullabilityBuffer && !this.nullabilityBuffer.get(le1) ? null : this.getValueFromBuffer(le1);
                        }
                        has(le1) {
                            return this.nullabilityBuffer && this.nullabilityBuffer.get(le1) || !this.nullabilityBuffer;
                        }
                        get name() {
                            return this._name;
                        }
                        get size() {
                            return this._size;
                        }
                    }
                    class Uc extends $c {
                    }
                    class qc extends Uc {
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[le1];
                        }
                    }
                    class Gc extends Uc {
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[le1];
                        }
                    }
                    class jc extends $c {
                        constructor(le1, vt, bt, ls){
                            super(le1, vt, ls), this.delta = void 0, this.delta = bt;
                        }
                    }
                    class Xc extends jc {
                        constructor(le1, vt, bt, ls){
                            super(le1, Int32Array.of(vt), bt, ls);
                        }
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[0] + le1 * this.delta;
                        }
                    }
                    class Yc extends $c {
                        constructor(le1, vt, bt){
                            super(le1, Int32Array.of(vt), bt);
                        }
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[0];
                        }
                    }
                    class Zc {
                        constructor(le1, vt, bt, ls, ho){
                            void 0 === ho && (ho = 4096), this._name = void 0, this._geometryVector = void 0, this._idVector = void 0, this._propertyVectors = void 0, this._extent = void 0, this.propertyVectorsMap = void 0, this._name = le1, this._geometryVector = vt, this._idVector = bt, this._propertyVectors = ls, this._extent = ho;
                        }
                        get name() {
                            return this._name;
                        }
                        get idVector() {
                            return this._idVector;
                        }
                        get geometryVector() {
                            return this._geometryVector;
                        }
                        get propertyVectors() {
                            return this._propertyVectors;
                        }
                        getPropertyVector(le1) {
                            return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map((le1)=>[
                                    le1.name,
                                    le1
                                ]))), this.propertyVectorsMap.get(le1);
                        }
                        *[Symbol.iterator]() {
                            const le1 = this.geometryVector[Symbol.iterator]();
                            let vt = 0;
                            for(; vt < this.numFeatures;){
                                let bt;
                                this.idVector && (bt = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(vt)) : this.idVector.getValue(vt));
                                const ls = le1?.next().value, ho = {};
                                for (const le1 of this.propertyVectors){
                                    if (!le1) continue;
                                    const bt = le1.name, ls = le1.getValue(vt);
                                    null !== ls && (ho[bt] = ls);
                                }
                                vt++, yield {
                                    id: bt,
                                    geometry: ls,
                                    properties: ho
                                };
                            }
                        }
                        get numFeatures() {
                            return this.geometryVector.numGeometries;
                        }
                        get extent() {
                            return this._extent;
                        }
                        getFeatures() {
                            const le1 = [], vt = this.geometryVector.getGeometries();
                            for(let bt = 0; bt < this.numFeatures; bt++){
                                let ls;
                                this.idVector && (ls = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(bt)) : this.idVector.getValue(bt));
                                const ho = {
                                    coordinates: vt[bt],
                                    type: this.geometryVector.geometryType(bt)
                                }, Dl = {};
                                for (const le1 of this.propertyVectors){
                                    if (!le1) continue;
                                    const vt = le1.name, ls = le1.getValue(bt);
                                    null !== ls && (Dl[vt] = ls);
                                }
                                le1.push({
                                    id: ls,
                                    geometry: ho,
                                    properties: Dl
                                });
                            }
                            return le1;
                        }
                        containsMaxSaveIntegerValues(le1) {
                            return le1 instanceof qc || le1 instanceof Yc && le1 instanceof Xc || le1 instanceof Gc;
                        }
                    }
                    class Hc {
                        constructor(le1){
                            this.value = void 0, this.value = le1;
                        }
                        get() {
                            return this.value;
                        }
                        set(le1) {
                            this.value = le1;
                        }
                        increment() {
                            return this.value++;
                        }
                        add(le1) {
                            this.value += le1;
                        }
                    }
                    function Wc(le1, vt, bt) {
                        const ls = new Int32Array(bt);
                        let ho = 0, Dl = vt.get();
                        for(let Fl = 0; Fl < ls.length; Fl++){
                            let vt = le1[Dl++], bt = 127 & vt;
                            vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 7, vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 14, vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 21, vt < 128 || (vt = le1[Dl++], bt |= (15 & vt) << 28)))), ls[ho++] = bt;
                        }
                        return vt.set(Dl), ls;
                    }
                    function Jc(le1, vt, bt) {
                        const ls = new BigInt64Array(bt);
                        for(let ho = 0; ho < ls.length; ho++)ls[ho] = rh(le1, vt);
                        return ls;
                    }
                    function Kc(le1, vt) {
                        let bt, ls;
                        return ls = le1[vt.get()], vt.increment(), bt = 127 & ls, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 7, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 14, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 21, ls < 128 ? bt : (ls = le1[vt.get()], bt |= (15 & ls) << 28, function(le1, vt, bt) {
                            let ls, ho;
                            if (ho = vt[bt.get()], bt.increment(), ls = (112 & ho) >> 4, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 3, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 10, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 17, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 24, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            if (ho = vt[bt.get()], bt.increment(), ls |= (1 & ho) << 31, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                            throw new Error("Expected varint not more than 10 bytes");
                        }(bt, le1, vt)))));
                    }
                    function Qc(le1, vt, bt, ls) {
                        throw new Error("FastPFor is not implemented yet.");
                    }
                    function eh(le1) {
                        return le1 >>> 1 ^ -(1 & le1);
                    }
                    function th(le1) {
                        return le1 >> 1n ^ -(1n & le1);
                    }
                    function rh(le1, vt) {
                        let bt = 0n, ls = 0, ho = vt.get();
                        for(; ho < le1.length;){
                            const vt = le1[ho++];
                            if (bt |= BigInt(127 & vt) << BigInt(ls), !(128 & vt)) break;
                            if (ls += 7, ls >= 64) throw new Error("Varint too long");
                        }
                        return vt.set(ho), bt;
                    }
                    function nh(le1, vt, bt) {
                        const ls = new Int32Array(bt);
                        let ho = 0;
                        for(let Dl = 0; Dl < vt; Dl++){
                            const bt = le1[Dl];
                            ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                        }
                        return ls;
                    }
                    function ih(le1, vt, bt) {
                        const ls = new BigInt64Array(bt);
                        let ho = 0;
                        for(let Dl = 0; Dl < vt; Dl++){
                            const bt = Number(le1[Dl]);
                            ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                        }
                        return ls;
                    }
                    function sh(le1, vt, bt) {
                        const ls = new Float64Array(bt);
                        let ho = 0;
                        for(let Dl = 0; Dl < vt; Dl++){
                            const bt = le1[Dl];
                            ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                        }
                        return ls;
                    }
                    function oh(le1) {
                        const vt = le1.length / 4 * 4;
                        let bt = 1;
                        if (vt >= 4) for(let ls = le1[0]; bt < vt - 4; bt += 4)ls = le1[bt] += ls, ls = le1[bt + 1] += ls, ls = le1[bt + 2] += ls, ls = le1[bt + 3] += ls;
                        for(; bt != le1.length;)le1[bt] += le1[bt - 1], ++bt;
                    }
                    function ah(le1) {
                        le1[0] = le1[0] >>> 1 ^ -(1 & le1[0]), le1[1] = le1[1] >>> 1 ^ -(1 & le1[1]);
                        const vt = le1.length / 4 * 4;
                        let bt = 2;
                        if (vt >= 4) for(; bt < vt - 4; bt += 4){
                            const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                            le1[bt] = (vt >>> 1 ^ -(1 & vt)) + le1[bt - 2], le1[bt + 1] = (ls >>> 1 ^ -(1 & ls)) + le1[bt - 1], le1[bt + 2] = (ho >>> 1 ^ -(1 & ho)) + le1[bt], le1[bt + 3] = (Dl >>> 1 ^ -(1 & Dl)) + le1[bt + 1];
                        }
                        for(; bt != le1.length; bt += 2)le1[bt] = (le1[bt] >>> 1 ^ -(1 & le1[bt])) + le1[bt - 2], le1[bt + 1] = (le1[bt + 1] >>> 1 ^ -(1 & le1[bt + 1])) + le1[bt - 1];
                    }
                    !function(le1) {
                        le1.NONE = "NONE", le1.DELTA = "DELTA", le1.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", le1.RLE = "RLE", le1.MORTON = "MORTON", le1.PDE = "PDE";
                    }(aA || (aA = {})), function(le1) {
                        le1.NONE = "NONE", le1.FAST_PFOR = "FAST_PFOR", le1.VARINT = "VARINT", le1.ALP = "ALP";
                    }(sA || (sA = {})), function(le1) {
                        le1.PRESENT = "PRESENT", le1.DATA = "DATA", le1.OFFSET = "OFFSET", le1.LENGTH = "LENGTH";
                    }(oA || (oA = {}));
                    class lh {
                        constructor(le1, vt, bt){
                            this._dictionaryType = void 0, this._offsetType = void 0, this._lengthType = void 0, this._dictionaryType = le1, this._offsetType = vt, this._lengthType = bt;
                        }
                        get dictionaryType() {
                            return this._dictionaryType;
                        }
                        get offsetType() {
                            return this._offsetType;
                        }
                        get lengthType() {
                            return this._lengthType;
                        }
                    }
                    function uh(le1, vt) {
                        const bt = function(le1, vt) {
                            const bt = le1[vt.get()], ls = Object.values(oA)[bt >> 4];
                            let ho = null;
                            switch(ls){
                                case oA.DATA:
                                    ho = new lh(Object.values(lA)[15 & bt]);
                                    break;
                                case oA.OFFSET:
                                    ho = new lh(null, Object.values(cA)[15 & bt]);
                                    break;
                                case oA.LENGTH:
                                    ho = new lh(null, null, Object.values(uA)[15 & bt]);
                            }
                            vt.increment();
                            const Dl = le1[vt.get()], Fl = Object.values(aA)[Dl >> 5], sc = Object.values(aA)[Dl >> 2 & 7], uc = Object.values(sA)[3 & Dl];
                            vt.increment();
                            const mc = Wc(le1, vt, 2), gc = mc[0];
                            return {
                                physicalStreamType: ls,
                                logicalStreamType: ho,
                                logicalLevelTechnique1: Fl,
                                logicalLevelTechnique2: sc,
                                physicalLevelTechnique: uc,
                                numValues: gc,
                                byteLength: mc[1],
                                decompressedCount: gc
                            };
                        }(le1, vt);
                        return bt.logicalLevelTechnique1 === aA.MORTON ? function(le1, vt, bt) {
                            const ls = Wc(vt, bt, 2);
                            return {
                                physicalStreamType: le1.physicalStreamType,
                                logicalStreamType: le1.logicalStreamType,
                                logicalLevelTechnique1: le1.logicalLevelTechnique1,
                                logicalLevelTechnique2: le1.logicalLevelTechnique2,
                                physicalLevelTechnique: le1.physicalLevelTechnique,
                                numValues: le1.numValues,
                                byteLength: le1.byteLength,
                                decompressedCount: le1.decompressedCount,
                                numBits: ls[0],
                                coordinateShift: ls[1]
                            };
                        }(bt, le1, vt) : aA.RLE !== bt.logicalLevelTechnique1 && aA.RLE !== bt.logicalLevelTechnique2 || sA.NONE === bt.physicalLevelTechnique ? bt : function(le1, vt, bt) {
                            const ls = Wc(vt, bt, 2);
                            return {
                                physicalStreamType: le1.physicalStreamType,
                                logicalStreamType: le1.logicalStreamType,
                                logicalLevelTechnique1: le1.logicalLevelTechnique1,
                                logicalLevelTechnique2: le1.logicalLevelTechnique2,
                                physicalLevelTechnique: le1.physicalLevelTechnique,
                                numValues: le1.numValues,
                                byteLength: le1.byteLength,
                                decompressedCount: ls[1],
                                runs: ls[0],
                                numRleValues: ls[1]
                            };
                        }(bt, le1, vt);
                    }
                    !function(le1) {
                        le1.NONE = "NONE", le1.SINGLE = "SINGLE", le1.SHARED = "SHARED", le1.VERTEX = "VERTEX", le1.MORTON = "MORTON", le1.FSST = "FSST";
                    }(lA || (lA = {})), function(le1) {
                        le1.VERTEX = "VERTEX", le1.INDEX = "INDEX", le1.STRING = "STRING", le1.KEY = "KEY";
                    }(cA || (cA = {})), function(le1) {
                        le1.VAR_BINARY = "VAR_BINARY", le1.GEOMETRIES = "GEOMETRIES", le1.PARTS = "PARTS", le1.RINGS = "RINGS", le1.TRIANGLES = "TRIANGLES", le1.SYMBOL = "SYMBOL", le1.DICTIONARY = "DICTIONARY";
                    }(uA || (uA = {})), function(le1) {
                        le1[le1.FLAT = 0] = "FLAT", le1[le1.CONST = 1] = "CONST", le1[le1.SEQUENCE = 2] = "SEQUENCE", le1[le1.DICTIONARY = 3] = "DICTIONARY", le1[le1.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
                    }(hA || (hA = {}));
                    class ch {
                        constructor(le1, vt){
                            this.values = void 0, this._size = void 0, this.values = le1, this._size = vt;
                        }
                        get(le1) {
                            const vt = Math.floor(le1 / 8);
                            return 1 == (this.values[vt] >> le1 % 8 & 1);
                        }
                        set(le1, vt) {
                            const bt = Math.floor(le1 / 8);
                            this.values[bt] = this.values[bt] | (vt ? 1 : 0) << le1 % 8;
                        }
                        getInt(le1) {
                            const vt = Math.floor(le1 / 8);
                            return this.values[vt] >> le1 % 8 & 1;
                        }
                        size() {
                            return this._size;
                        }
                        getBuffer() {
                            return this.values;
                        }
                    }
                    function hh(le1, vt, bt, ls, ho) {
                        return function(le1, vt, bt) {
                            switch(vt.logicalLevelTechnique1){
                                case aA.DELTA:
                                    return vt.logicalLevelTechnique2 === aA.RLE ? function(le1, vt, bt) {
                                        const ls = new Int32Array(bt);
                                        let ho = 0, Dl = 0;
                                        for(let Fl = 0; Fl < vt; Fl++){
                                            const bt = le1[Fl], sc = eh(le1[Fl + vt]);
                                            for(let le1 = 0; le1 < bt; le1++)Dl += sc, ls[ho++] = Dl;
                                        }
                                        return ls;
                                    }(le1, vt.runs, vt.numRleValues) : (function(le1) {
                                        le1[0] = le1[0] >>> 1 ^ -(1 & le1[0]);
                                        const vt = le1.length / 4 * 4;
                                        let bt = 1;
                                        if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                            const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                            le1[bt] = (vt >>> 1 ^ -(1 & vt)) + le1[bt - 1], le1[bt + 1] = (ls >>> 1 ^ -(1 & ls)) + le1[bt], le1[bt + 2] = (ho >>> 1 ^ -(1 & ho)) + le1[bt + 1], le1[bt + 3] = (Dl >>> 1 ^ -(1 & Dl)) + le1[bt + 2];
                                        }
                                        for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] >>> 1 ^ -(1 & le1[bt])) + le1[bt - 1];
                                    }(le1), le1);
                                case aA.RLE:
                                    return function(le1, vt, bt) {
                                        return bt ? function(le1, vt, bt) {
                                            const ls = new Int32Array(bt);
                                            let ho = 0;
                                            for(let Dl = 0; Dl < vt; Dl++){
                                                const bt = le1[Dl];
                                                let Fl = le1[Dl + vt];
                                                Fl = Fl >>> 1 ^ -(1 & Fl), ls.fill(Fl, ho, ho + bt), ho += bt;
                                            }
                                            return ls;
                                        }(le1, vt.runs, vt.numRleValues) : nh(le1, vt.runs, vt.numRleValues);
                                    }(le1, vt, bt);
                                case aA.MORTON:
                                    return oh(le1), le1;
                                case aA.COMPONENTWISE_DELTA:
                                    return ah(le1), le1;
                                case aA.NONE:
                                    return bt && function(le1) {
                                        for(let vt = 0; vt < le1.length; vt++){
                                            const bt = le1[vt];
                                            le1[vt] = bt >>> 1 ^ -(1 & bt);
                                        }
                                    }(le1), le1;
                                default:
                                    throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                            }
                        }(fh(le1, vt, bt), bt, ls);
                    }
                    function ph(le1, vt, bt) {
                        return function(le1, vt) {
                            if (vt.logicalLevelTechnique1 === aA.DELTA && vt.logicalLevelTechnique2 === aA.NONE) {
                                const vt = function(le1) {
                                    const vt = new Int32Array(le1.length + 1);
                                    vt[0] = 0, vt[1] = eh(le1[0]);
                                    let bt = vt[1], ls = 2;
                                    for(; ls != vt.length; ++ls){
                                        const ho = le1[ls - 1];
                                        bt += ho >>> 1 ^ -(1 & ho), vt[ls] = vt[ls - 1] + bt;
                                    }
                                    return vt;
                                }(le1);
                                return vt;
                            }
                            if (vt.logicalLevelTechnique1 === aA.RLE && vt.logicalLevelTechnique2 === aA.NONE) {
                                const bt = function(le1, vt, bt) {
                                    const ls = new Int32Array(bt + 1);
                                    ls[0] = 0;
                                    let ho = 1, Dl = ls[0];
                                    for(let Fl = 0; Fl < vt; Fl++){
                                        const bt = le1[Fl], sc = le1[Fl + vt];
                                        for(let le1 = ho; le1 < ho + bt; le1++)ls[le1] = sc + Dl, Dl = ls[le1];
                                        ho += bt;
                                    }
                                    return ls;
                                }(le1, vt.runs, vt.numRleValues);
                                return bt;
                            }
                            if (vt.logicalLevelTechnique1 === aA.NONE && vt.logicalLevelTechnique2 === aA.NONE) {
                                !function(le1) {
                                    let vt = 0;
                                    for(let bt = 0; bt < le1.length; bt++)le1[bt] += vt, vt = le1[bt];
                                }(le1);
                                const bt = new Int32Array(vt.numValues + 1);
                                return bt[0] = 0, bt.set(le1, 1), bt;
                            }
                            if (vt.logicalLevelTechnique1 === aA.DELTA && vt.logicalLevelTechnique2 === aA.RLE) {
                                const bt = function(le1, vt, bt) {
                                    const ls = new Int32Array(bt + 1);
                                    ls[0] = 0;
                                    let ho = 1, Dl = ls[0];
                                    for(let Fl = 0; Fl < vt; Fl++){
                                        const bt = le1[Fl];
                                        let sc = le1[Fl + vt];
                                        sc = sc >>> 1 ^ -(1 & sc);
                                        for(let le1 = ho; le1 < ho + bt; le1++)ls[le1] = sc + Dl, Dl = ls[le1];
                                        ho += bt;
                                    }
                                    return ls;
                                }(le1, vt.runs, vt.numRleValues);
                                return oh(bt), bt;
                            }
                            throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
                        }(fh(le1, vt, bt), bt);
                    }
                    function fh(le1, vt, bt) {
                        const ls = bt.physicalLevelTechnique;
                        if (ls === sA.FAST_PFOR) return Qc();
                        if (ls === sA.VARINT) return Wc(le1, vt, bt.numValues);
                        if (ls === sA.NONE) {
                            const ls = vt.get();
                            vt.add(bt.byteLength);
                            const ho = le1.subarray(ls, vt.get());
                            return new Int32Array(ho);
                        }
                        throw new Error("Specified physicalLevelTechnique is not supported (yet).");
                    }
                    function dh(le1, vt, bt, ls) {
                        const ho = fh(le1, vt, bt);
                        if (1 === ho.length) {
                            const le1 = ho[0];
                            return ls ? eh(le1) : le1;
                        }
                        return ls ? function(le1) {
                            return eh(le1[1]);
                        }(ho) : function(le1) {
                            return le1[1];
                        }(ho);
                    }
                    function yh(le1, vt, bt) {
                        return function(le1) {
                            if (2 == le1.length) {
                                const vt = eh(le1[1]);
                                return [
                                    vt,
                                    vt
                                ];
                            }
                            return [
                                eh(le1[2]),
                                eh(le1[3])
                            ];
                        }(fh(le1, vt, bt));
                    }
                    function mh(le1, vt, bt) {
                        return function(le1) {
                            if (2 == le1.length) {
                                const vt = th(le1[1]);
                                return [
                                    vt,
                                    vt
                                ];
                            }
                            return [
                                th(le1[2]),
                                th(le1[3])
                            ];
                        }(Jc(le1, vt, bt.numValues));
                    }
                    function gh(le1, vt, bt, ls) {
                        return function(le1, vt, bt) {
                            switch(vt.logicalLevelTechnique1){
                                case aA.DELTA:
                                    return vt.logicalLevelTechnique2 === aA.RLE ? function(le1, vt, bt) {
                                        const ls = new BigInt64Array(bt);
                                        let ho = 0, Dl = 0n;
                                        for(let Fl = 0; Fl < vt; Fl++){
                                            const bt = Number(le1[Fl]), sc = th(le1[Fl + vt]);
                                            for(let le1 = 0; le1 < bt; le1++)Dl += sc, ls[ho++] = Dl;
                                        }
                                        return ls;
                                    }(le1, vt.runs, vt.numRleValues) : (function(le1) {
                                        le1[0] = le1[0] >> 1n ^ -(1n & le1[0]);
                                        const vt = le1.length / 4 * 4;
                                        let bt = 1;
                                        if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                            const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                            le1[bt] = (vt >> 1n ^ -(1n & vt)) + le1[bt - 1], le1[bt + 1] = (ls >> 1n ^ -(1n & ls)) + le1[bt], le1[bt + 2] = (ho >> 1n ^ -(1n & ho)) + le1[bt + 1], le1[bt + 3] = (Dl >> 1n ^ -(1n & Dl)) + le1[bt + 2];
                                        }
                                        for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] >> 1n ^ -(1n & le1[bt])) + le1[bt - 1];
                                    }(le1), le1);
                                case aA.RLE:
                                    return function(le1, vt, bt) {
                                        return bt ? function(le1, vt, bt) {
                                            const ls = new BigInt64Array(bt);
                                            let ho = 0;
                                            for(let Dl = 0; Dl < vt; Dl++){
                                                const bt = Number(le1[Dl]);
                                                let Fl = le1[Dl + vt];
                                                Fl = Fl >> 1n ^ -(1n & Fl), ls.fill(Fl, ho, ho + bt), ho += bt;
                                            }
                                            return ls;
                                        }(le1, vt.runs, vt.numRleValues) : ih(le1, vt.runs, vt.numRleValues);
                                    }(le1, vt, bt);
                                case aA.NONE:
                                    return bt && function(le1) {
                                        for(let vt = 0; vt < le1.length; vt++){
                                            const bt = le1[vt];
                                            le1[vt] = bt >> 1n ^ -(1n & bt);
                                        }
                                    }(le1), le1;
                                default:
                                    throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                            }
                        }(Jc(le1, vt, bt.numValues), bt, ls);
                    }
                    function xh(le1, vt, bt, ls) {
                        const ho = Jc(le1, vt, bt.numValues);
                        if (1 === ho.length) {
                            const le1 = ho[0];
                            return ls ? th(le1) : le1;
                        }
                        return ls ? function(le1) {
                            return th(le1[1]);
                        }(ho) : function(le1) {
                            return le1[1];
                        }(ho);
                    }
                    function vh(le1, vt, bt, ls, ho) {
                        return function(le1, vt, bt, ls) {
                            switch(vt.logicalLevelTechnique1){
                                case aA.DELTA:
                                    return vt.logicalLevelTechnique2 === aA.RLE && (le1 = nh(le1, vt.runs, vt.numRleValues)), function(le1, vt) {
                                        const bt = new Int32Array(le1.size());
                                        let ls = 0;
                                        le1.get(0) ? (bt[0] = le1.get(0) ? vt[0] >>> 1 ^ -(1 & vt[0]) : 0, ls = 1) : bt[0] = 0;
                                        let ho = 1;
                                        for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? bt[ho - 1] + (vt[ls] >>> 1 ^ -(1 & vt[ls++])) : bt[ho - 1];
                                        return bt;
                                    }(ls, le1);
                                case aA.RLE:
                                    return function(le1, vt, bt, ls) {
                                        const ho = vt;
                                        return bt ? function(le1, vt, bt) {
                                            const ls = new Int32Array(le1.size());
                                            let ho = 0;
                                            for(let Dl = 0; Dl < bt; Dl++){
                                                const Fl = vt[Dl];
                                                let sc = vt[Dl + bt];
                                                sc = sc >>> 1 ^ -(1 & sc);
                                                for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0, ho++);
                                                ho += Fl;
                                            }
                                            return ls;
                                        }(ls, le1, ho.runs) : function(le1, vt, bt) {
                                            const ls = new Int32Array(le1.size());
                                            let ho = 0;
                                            for(let Dl = 0; Dl < bt; Dl++){
                                                const Fl = vt[Dl], sc = vt[Dl + bt];
                                                for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0, ho++);
                                                ho += Fl;
                                            }
                                            return ls;
                                        }(ls, le1, ho.runs);
                                    }(le1, vt, bt, ls);
                                case aA.MORTON:
                                    return oh(le1), le1;
                                case aA.COMPONENTWISE_DELTA:
                                    return ah(le1), le1;
                                case aA.NONE:
                                    return le1 = bt ? function(le1, vt) {
                                        const bt = new Int32Array(le1.size());
                                        let ls = 0, ho = 0;
                                        for(; ho != bt.length; ++ho)if (le1.get(ho)) {
                                            const le1 = vt[ls++];
                                            bt[ho] = le1 >>> 1 ^ -(1 & le1);
                                        } else bt[ho] = 0;
                                        return bt;
                                    }(ls, le1) : function(le1, vt) {
                                        const bt = new Int32Array(le1.size());
                                        let ls = 0, ho = 0;
                                        for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? vt[ls++] : 0;
                                        return bt;
                                    }(ls, le1), le1;
                                default:
                                    throw new Error("The specified Logical level technique is not supported");
                            }
                        }(bt.physicalLevelTechnique === sA.FAST_PFOR ? Qc() : Wc(le1, vt, bt.numValues), bt, ls, ho);
                    }
                    function bh(le1, vt, bt, ls) {
                        const ho = le1.logicalLevelTechnique1;
                        if (ho === aA.RLE) return 1 === le1.runs ? hA.CONST : hA.FLAT;
                        const Dl = vt instanceof ch ? vt.size() : vt;
                        if (ho === aA.DELTA && le1.logicalLevelTechnique2 === aA.RLE) {
                            const vt = le1.runs, ho = 2;
                            if (le1.numRleValues !== Dl) return hA.FLAT;
                            if (1 === vt) return hA.SEQUENCE;
                            if (2 === vt) {
                                const vt = ls.get();
                                let Dl;
                                if (le1.physicalLevelTechnique === sA.VARINT) Dl = Wc(bt, ls, 4);
                                else {
                                    const le1 = ls.get();
                                    Dl = new Int32Array(bt.buffer, bt.byteOffset + le1, 4);
                                }
                                if (ls.set(vt), Dl[2] === ho && Dl[3] === ho) return hA.SEQUENCE;
                            }
                        }
                        return 1 === le1.numValues ? hA.CONST : hA.FLAT;
                    }
                    class wh extends Uc {
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[le1];
                        }
                    }
                    class _h extends jc {
                        constructor(le1, vt, bt, ls){
                            super(le1, BigInt64Array.of(vt), bt, ls);
                        }
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[0] + BigInt(le1) * this.delta;
                        }
                    }
                    class Sh {
                        constructor(le1, vt, bt){
                            this._geometryOffsets = void 0, this._partOffsets = void 0, this._ringOffsets = void 0, this._geometryOffsets = le1, this._partOffsets = vt, this._ringOffsets = bt;
                        }
                        get geometryOffsets() {
                            return this._geometryOffsets;
                        }
                        get partOffsets() {
                            return this._partOffsets;
                        }
                        get ringOffsets() {
                            return this._ringOffsets;
                        }
                    }
                    function Ah(le1, vt, bt) {
                        return {
                            x: Ih(le1, vt) - bt,
                            y: Ih(le1 >> 1, vt) - bt
                        };
                    }
                    function Ih(le1, vt) {
                        let bt = 0;
                        for(let ls = 0; ls < vt; ls++)bt |= (le1 & 1 << 2 * ls) >> ls;
                        return bt;
                    }
                    !function(le1) {
                        le1[le1.POINT = 0] = "POINT", le1[le1.LINESTRING = 1] = "LINESTRING", le1[le1.POLYGON = 2] = "POLYGON", le1[le1.MULTIPOINT = 3] = "MULTIPOINT", le1[le1.MULTILINESTRING = 4] = "MULTILINESTRING", le1[le1.MULTIPOLYGON = 5] = "MULTIPOLYGON";
                    }(dA || (dA = {})), function(le1) {
                        le1[le1.POINT = 0] = "POINT", le1[le1.LINESTRING = 1] = "LINESTRING", le1[le1.POLYGON = 2] = "POLYGON";
                    }(pA || (pA = {})), function(le1) {
                        le1[le1.MORTON = 0] = "MORTON", le1[le1.VEC_2 = 1] = "VEC_2", le1[le1.VEC_3 = 2] = "VEC_3";
                    }(mA || (mA = {}));
                    class Th {
                        createPoint(le1) {
                            return [
                                [
                                    le1
                                ]
                            ];
                        }
                        createMultiPoint(le1) {
                            return le1.map((le1)=>[
                                    le1
                                ]);
                        }
                        createLineString(le1) {
                            return [
                                le1
                            ];
                        }
                        createMultiLineString(le1) {
                            return le1;
                        }
                        createPolygon(le1, vt) {
                            return [
                                le1
                            ].concat(vt);
                        }
                        createMultiPolygon(le1) {
                            return le1.flat();
                        }
                    }
                    function kh(le1) {
                        const vt = new Array(le1.numGeometries);
                        let bt = 1, ls = 1, ho = 1, Dl = 0;
                        const Fl = new Th;
                        let sc = 0, uc = 0;
                        const mc = le1.mortonSettings, gc = le1.topologyVector, Ac = gc.geometryOffsets, Ec = gc.partOffsets, kc = gc.ringOffsets, du = le1.vertexOffsets, _u = le1.containsPolygonGeometry(), Md = le1.vertexBuffer;
                        for(let Ld = 0; Ld < le1.numGeometries; Ld++){
                            const gc = le1.geometryType(Ld);
                            if (gc === dA.POINT) {
                                if (du && 0 !== du.length) {
                                    if (le1.vertexBufferType === mA.VEC_2) {
                                        const le1 = 2 * du[uc++], bt = new t(Md[le1], Md[le1 + 1]);
                                        vt[Dl++] = Fl.createPoint(bt);
                                    } else {
                                        const le1 = Ah(Md[du[uc++]], mc.numBits, mc.coordinateShift), bt = new t(le1.x, le1.y);
                                        vt[Dl++] = Fl.createPoint(bt);
                                    }
                                } else {
                                    const le1 = new t(Md[sc++], Md[sc++]);
                                    vt[Dl++] = Fl.createPoint(le1);
                                }
                                Ac && ho++, Ec && bt++, kc && ls++;
                            } else if (gc === dA.MULTIPOINT) {
                                const le1 = Ac[ho] - Ac[ho - 1];
                                ho++;
                                const bt = new Array(le1);
                                if (du && 0 !== du.length) {
                                    for(let vt = 0; vt < le1; vt++){
                                        const le1 = 2 * du[uc++];
                                        bt[vt] = new t(Md[le1], Md[le1 + 1]);
                                    }
                                    vt[Dl++] = Fl.createMultiPoint(bt);
                                } else {
                                    for(let vt = 0; vt < le1; vt++){
                                        const le1 = Md[sc++], ls = Md[sc++];
                                        bt[vt] = new t(le1, ls);
                                    }
                                    vt[Dl++] = Fl.createMultiPoint(bt);
                                }
                            } else if (gc === dA.LINESTRING) {
                                let gc, Ld = 0;
                                _u ? (Ld = kc[ls] - kc[ls - 1], ls++) : Ld = Ec[bt] - Ec[bt - 1], bt++, du && 0 !== du.length ? (gc = le1.vertexBufferType === mA.VEC_2 ? zh(Md, du, uc, Ld, !1) : Fh(Md, du, uc, Ld, !1, mc), uc += Ld) : (gc = Ph(Md, sc, Ld, !1), sc += 2 * Ld), vt[Dl++] = Fl.createLineString(gc), Ac && ho++;
                            } else if (gc === dA.POLYGON) {
                                const gc = Ec[bt] - Ec[bt - 1];
                                bt++;
                                const _u = new Array(gc - 1);
                                let Ld = kc[ls] - kc[ls - 1];
                                if (ls++, du && 0 !== du.length) {
                                    const bt = le1.vertexBufferType === mA.VEC_2 ? Mh(Md, du, uc, Ld) : Dh(Md, du, uc, Ld, 0, mc);
                                    uc += Ld;
                                    for(let vt = 0; vt < _u.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, _u[vt] = le1.vertexBufferType === mA.VEC_2 ? Mh(Md, du, uc, Ld) : Dh(Md, du, uc, Ld, 0, mc), uc += Ld;
                                    vt[Dl++] = Fl.createPolygon(bt, _u);
                                } else {
                                    const le1 = Eh(Md, sc, Ld);
                                    sc += 2 * Ld;
                                    for(let vt = 0; vt < _u.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, _u[vt] = Eh(Md, sc, Ld), sc += 2 * Ld;
                                    vt[Dl++] = Fl.createPolygon(le1, _u);
                                }
                                Ac && ho++;
                            } else if (gc === dA.MULTILINESTRING) {
                                const gc = Ac[ho] - Ac[ho - 1];
                                ho++;
                                const Ld = new Array(gc);
                                if (du && 0 !== du.length) {
                                    for(let vt = 0; vt < gc; vt++){
                                        let ho = 0;
                                        _u ? (ho = kc[ls] - kc[ls - 1], ls++) : ho = Ec[bt] - Ec[bt - 1], bt++;
                                        const Dl = le1.vertexBufferType === mA.VEC_2 ? zh(Md, du, uc, ho, !1) : Fh(Md, du, uc, ho, !1, mc);
                                        Ld[vt] = Dl, uc += ho;
                                    }
                                    vt[Dl++] = Fl.createMultiLineString(Ld);
                                } else {
                                    for(let le1 = 0; le1 < gc; le1++){
                                        let vt = 0;
                                        _u ? (vt = kc[ls] - kc[ls - 1], ls++) : vt = Ec[bt] - Ec[bt - 1], bt++, Ld[le1] = Ph(Md, sc, vt, !1), sc += 2 * vt;
                                    }
                                    vt[Dl++] = Fl.createMultiLineString(Ld);
                                }
                            } else {
                                if (gc !== dA.MULTIPOLYGON) throw new Error("The specified geometry type is currently not supported.");
                                {
                                    const gc = Ac[ho] - Ac[ho - 1];
                                    ho++;
                                    const _u = new Array(gc);
                                    let Ld = 0;
                                    if (du && 0 !== du.length) {
                                        for(let vt = 0; vt < gc; vt++){
                                            const ho = Ec[bt] - Ec[bt - 1];
                                            bt++;
                                            const Dl = new Array(ho - 1);
                                            Ld = kc[ls] - kc[ls - 1], ls++;
                                            const sc = le1.vertexBufferType === mA.VEC_2 ? Mh(Md, du, uc, Ld) : Dh(Md, du, uc, Ld, 0, mc);
                                            uc += Ld;
                                            for(let vt = 0; vt < Dl.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, Dl[vt] = le1.vertexBufferType === mA.VEC_2 ? Mh(Md, du, uc, Ld) : Dh(Md, du, uc, Ld, 0, mc), uc += Ld;
                                            _u[vt] = Fl.createPolygon(sc, Dl);
                                        }
                                        vt[Dl++] = Fl.createMultiPolygon(_u);
                                    } else {
                                        for(let le1 = 0; le1 < gc; le1++){
                                            const vt = Ec[bt] - Ec[bt - 1];
                                            bt++;
                                            const ho = new Array(vt - 1);
                                            Ld = kc[ls] - kc[ls - 1], ls++;
                                            const Dl = Eh(Md, sc, Ld);
                                            sc += 2 * Ld;
                                            for(let le1 = 0; le1 < ho.length; le1++){
                                                const vt = kc[ls] - kc[ls - 1];
                                                ls++, ho[le1] = Eh(Md, sc, vt), sc += 2 * vt;
                                            }
                                            _u[le1] = Fl.createPolygon(Dl, ho);
                                        }
                                        vt[Dl++] = Fl.createMultiPolygon(_u);
                                    }
                                }
                            }
                        }
                        return vt;
                    }
                    function Eh(le1, vt, bt) {
                        return Ph(le1, vt, bt, !0);
                    }
                    function Mh(le1, vt, bt, ls) {
                        return zh(le1, vt, bt, ls, !0);
                    }
                    function Dh(le1, vt, bt, ls, ho, Dl) {
                        return Fh(le1, vt, bt, ls, !0, Dl);
                    }
                    function Ph(le1, vt, bt, ls) {
                        const ho = new Array(ls ? bt + 1 : bt);
                        for(let Dl = 0; Dl < 2 * bt; Dl += 2)ho[Dl / 2] = new t(le1[vt + Dl], le1[vt + Dl + 1]);
                        return ls && (ho[ho.length - 1] = ho[0]), ho;
                    }
                    function zh(le1, vt, bt, ls, ho) {
                        const Dl = new Array(ho ? ls + 1 : ls);
                        for(let Fl = 0; Fl < 2 * ls; Fl += 2){
                            const ls = 2 * vt[bt + Fl / 2];
                            Dl[Fl / 2] = new t(le1[ls], le1[ls + 1]);
                        }
                        return ho && (Dl[Dl.length - 1] = Dl[0]), Dl;
                    }
                    function Fh(le1, vt, bt, ls, ho, Dl) {
                        const Fl = new Array(ho ? ls + 1 : ls);
                        for(let sc = 0; sc < ls; sc++){
                            const ls = Ah(le1[vt[bt + sc]], Dl.numBits, Dl.coordinateShift);
                            Fl[sc] = new t(ls.x, ls.y);
                        }
                        return ho && (Fl[Fl.length - 1] = Fl[0]), Fl;
                    }
                    class Bh {
                        constructor(le1, vt, bt, ls, ho){
                            this._vertexBufferType = void 0, this._topologyVector = void 0, this._vertexOffsets = void 0, this._vertexBuffer = void 0, this._mortonSettings = void 0, this._vertexBufferType = le1, this._topologyVector = vt, this._vertexOffsets = bt, this._vertexBuffer = ls, this._mortonSettings = ho;
                        }
                        get vertexBufferType() {
                            return this._vertexBufferType;
                        }
                        get topologyVector() {
                            return this._topologyVector;
                        }
                        get vertexOffsets() {
                            return this._vertexOffsets;
                        }
                        get vertexBuffer() {
                            return this._vertexBuffer;
                        }
                        *[Symbol.iterator]() {
                            const le1 = kh(this);
                            let vt = 0;
                            for(; vt < this.numGeometries;)yield {
                                coordinates: le1[vt],
                                type: this.geometryType(vt)
                            }, vt++;
                        }
                        getSimpleEncodedVertex(le1) {
                            const vt = this.vertexOffsets ? 2 * this.vertexOffsets[le1] : 2 * le1;
                            return [
                                this.vertexBuffer[vt],
                                this.vertexBuffer[vt + 1]
                            ];
                        }
                        getVertex(le1) {
                            if (this.vertexOffsets && this.mortonSettings) {
                                const vt = Ah(this.vertexBuffer[this.vertexOffsets[le1]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
                                return [
                                    vt.x,
                                    vt.y
                                ];
                            }
                            const vt = this.vertexOffsets ? 2 * this.vertexOffsets[le1] : 2 * le1;
                            return [
                                this.vertexBuffer[vt],
                                this.vertexBuffer[vt + 1]
                            ];
                        }
                        getGeometries() {
                            return kh(this);
                        }
                        get mortonSettings() {
                            return this._mortonSettings;
                        }
                    }
                    class Ch extends Bh {
                        constructor(le1, vt, bt, ls, ho, Dl, Fl){
                            super(bt, ls, ho, Dl, Fl), this._numGeometries = void 0, this._geometryType = void 0, this._numGeometries = le1, this._geometryType = vt;
                        }
                        geometryType(le1) {
                            return this._geometryType;
                        }
                        get numGeometries() {
                            return this._numGeometries;
                        }
                        containsPolygonGeometry() {
                            return this._geometryType === dA.POLYGON || this._geometryType === dA.MULTIPOLYGON;
                        }
                        containsSingleGeometryType() {
                            return !0;
                        }
                    }
                    class Vh extends Bh {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            super(le1, bt, ls, ho, Dl), this._geometryTypes = void 0, this._geometryTypes = vt;
                        }
                        geometryType(le1) {
                            return this._geometryTypes[le1];
                        }
                        get numGeometries() {
                            return this._geometryTypes.length;
                        }
                        containsPolygonGeometry() {
                            for(let le1 = 0; le1 < this.numGeometries; le1++)if (this.geometryType(le1) === dA.POLYGON || this.geometryType(le1) === dA.MULTIPOLYGON) return !0;
                            return !1;
                        }
                        containsSingleGeometryType() {
                            return !1;
                        }
                    }
                    class Lh {
                        constructor(le1, vt, bt, ls){
                            this._triangleOffsets = void 0, this._indexBuffer = void 0, this._vertexBuffer = void 0, this._topologyVector = void 0, this._triangleOffsets = le1, this._indexBuffer = vt, this._vertexBuffer = bt, this._topologyVector = ls;
                        }
                        get triangleOffsets() {
                            return this._triangleOffsets;
                        }
                        get indexBuffer() {
                            return this._indexBuffer;
                        }
                        get vertexBuffer() {
                            return this._vertexBuffer;
                        }
                        get topologyVector() {
                            return this._topologyVector;
                        }
                        getGeometries() {
                            if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
                            const le1 = new Array(this.numGeometries), vt = this._topologyVector, bt = vt.partOffsets, ls = vt.ringOffsets, ho = vt.geometryOffsets;
                            let Dl = 0, Fl = 1, sc = 1, uc = 1;
                            for(let mc = 0; mc < this.numGeometries; mc++)switch(this.geometryType(mc)){
                                case dA.POLYGON:
                                    {
                                        const vt = bt[Fl] - bt[Fl - 1];
                                        Fl++;
                                        const gc = [];
                                        for(let le1 = 0; le1 < vt; le1++){
                                            const le1 = ls[sc] - ls[sc - 1];
                                            sc++;
                                            const vt = [];
                                            for(let bt = 0; bt < le1; bt++){
                                                const le1 = this._vertexBuffer[Dl++], bt = this._vertexBuffer[Dl++];
                                                vt.push(new t(le1, bt));
                                            }
                                            vt.length > 0 && vt.push(vt[0]), gc.push(vt);
                                        }
                                        le1[mc] = gc, ho && uc++;
                                    }
                                    break;
                                case dA.MULTIPOLYGON:
                                    {
                                        const vt = ho[uc] - ho[uc - 1];
                                        uc++;
                                        const gc = [];
                                        for(let le1 = 0; le1 < vt; le1++){
                                            const le1 = bt[Fl] - bt[Fl - 1];
                                            Fl++;
                                            for(let vt = 0; vt < le1; vt++){
                                                const le1 = ls[sc] - ls[sc - 1];
                                                sc++;
                                                const vt = [];
                                                for(let bt = 0; bt < le1; bt++){
                                                    const le1 = this._vertexBuffer[Dl++], bt = this._vertexBuffer[Dl++];
                                                    vt.push(new t(le1, bt));
                                                }
                                                vt.length > 0 && vt.push(vt[0]), gc.push(vt);
                                            }
                                        }
                                        le1[mc] = gc;
                                    }
                            }
                            return le1;
                        }
                        [Symbol.iterator]() {
                            return null;
                        }
                    }
                    function Oh(le1, vt, bt, ls, ho, Dl) {
                        return new Rh(le1, vt, bt, ls, ho, Dl);
                    }
                    class Rh extends Lh {
                        constructor(le1, vt, bt, ls, ho, Dl){
                            super(bt, ls, ho, Dl), this._numGeometries = void 0, this._geometryType = void 0, this._numGeometries = le1, this._geometryType = vt;
                        }
                        geometryType(le1) {
                            return this._geometryType;
                        }
                        get numGeometries() {
                            return this._numGeometries;
                        }
                        containsSingleGeometryType() {
                            return !0;
                        }
                    }
                    function Nh(le1, vt, bt, ls, ho) {
                        return new $h(le1, vt, bt, ls, ho);
                    }
                    class $h extends Lh {
                        constructor(le1, vt, bt, ls, ho){
                            super(vt, bt, ls, ho), this._geometryTypes = void 0, this._geometryTypes = le1;
                        }
                        geometryType(le1) {
                            return this._geometryTypes[le1];
                        }
                        get numGeometries() {
                            return this._geometryTypes.length;
                        }
                        containsSingleGeometryType() {
                            return !1;
                        }
                    }
                    function Uh(le1, vt, bt, ls, ho) {
                        const Dl = uh(le1, bt);
                        let Fl = null, sc = null, uc = null, mc = null, gc = null, Ac = null, Ec = null, kc = null;
                        if (bh(Dl, ls, le1, bt) === hA.CONST) {
                            const ho = dh(le1, bt, Dl, !1);
                            for(let ls = 0; ls < vt - 1; ls++){
                                const vt = uh(le1, bt);
                                switch(vt.physicalStreamType){
                                    case oA.LENGTH:
                                        switch(vt.logicalStreamType.lengthType){
                                            case uA.GEOMETRIES:
                                                Fl = ph(le1, bt, vt);
                                                break;
                                            case uA.PARTS:
                                                sc = ph(le1, bt, vt);
                                                break;
                                            case uA.RINGS:
                                                uc = ph(le1, bt, vt);
                                                break;
                                            case uA.TRIANGLES:
                                                Ec = ph(le1, bt, vt);
                                        }
                                        break;
                                    case oA.OFFSET:
                                        switch(vt.logicalStreamType.offsetType){
                                            case cA.VERTEX:
                                                mc = hh(le1, bt, vt, !1);
                                                break;
                                            case cA.INDEX:
                                                kc = hh(le1, bt, vt, !1);
                                        }
                                        break;
                                    case oA.DATA:
                                        lA.VERTEX === vt.logicalStreamType.dictionaryType ? gc = hh(le1, bt, vt, !0) : (Ac = {
                                            numBits: vt.numBits,
                                            coordinateShift: vt.coordinateShift
                                        }, gc = hh(le1, bt, vt, !1));
                                }
                            }
                            return null !== kc ? null != Fl || null != sc ? Oh(ls, ho, Ec, kc, gc, new Sh(Fl, sc, uc)) : Oh(ls, ho, Ec, kc, gc) : null === Ac ? function(le1, vt, bt, ls, ho) {
                                return new Ch(le1, vt, mA.VEC_2, bt, ls, ho);
                            }(ls, ho, new Sh(Fl, sc, uc), mc, gc) : function(le1, vt, bt, ls, ho, Dl) {
                                return new Ch(le1, vt, mA.MORTON, bt, ls, ho, Dl);
                            }(ls, ho, new Sh(Fl, sc, uc), mc, gc, Ac);
                        }
                        const du = hh(le1, bt, Dl, !1);
                        for(let _u = 0; _u < vt - 1; _u++){
                            const vt = uh(le1, bt);
                            switch(vt.physicalStreamType){
                                case oA.LENGTH:
                                    switch(vt.logicalStreamType.lengthType){
                                        case uA.GEOMETRIES:
                                            Fl = hh(le1, bt, vt, !1);
                                            break;
                                        case uA.PARTS:
                                            sc = hh(le1, bt, vt, !1);
                                            break;
                                        case uA.RINGS:
                                            uc = hh(le1, bt, vt, !1);
                                            break;
                                        case uA.TRIANGLES:
                                            Ec = ph(le1, bt, vt);
                                    }
                                    break;
                                case oA.OFFSET:
                                    switch(vt.logicalStreamType.offsetType){
                                        case cA.VERTEX:
                                            mc = hh(le1, bt, vt, !1);
                                            break;
                                        case cA.INDEX:
                                            kc = hh(le1, bt, vt, !1);
                                    }
                                    break;
                                case oA.DATA:
                                    lA.VERTEX === vt.logicalStreamType.dictionaryType ? gc = hh(le1, bt, vt, !0) : (Ac = {
                                        numBits: vt.numBits,
                                        coordinateShift: vt.coordinateShift
                                    }, gc = hh(le1, bt, vt, !1));
                            }
                        }
                        return null !== kc && null === sc ? Nh(du, Ec, kc, gc) : (null !== Fl ? (Fl = qh(du, Fl, 2), null !== sc && null !== uc ? (sc = Gh(du, Fl, sc, !1), uc = function(le1, vt, bt, ls) {
                            const ho = new Int32Array(bt[bt.length - 1] + 1);
                            let Dl = 0;
                            ho[0] = Dl;
                            let Fl = 1, sc = 1, uc = 0;
                            for(let mc = 0; mc < le1.length; mc++){
                                const gc = le1[mc], Ac = vt[mc + 1] - vt[mc];
                                if (0 !== gc && 3 !== gc) for(let le1 = 0; le1 < Ac; le1++){
                                    const le1 = bt[Fl] - bt[Fl - 1];
                                    Fl++;
                                    for(let vt = 0; vt < le1; vt++)Dl = ho[sc++] = Dl + ls[uc++];
                                }
                                else for(let le1 = 0; le1 < Ac; le1++)ho[sc++] = ++Dl, Fl++;
                            }
                            return ho;
                        }(du, Fl, sc, uc)) : null !== sc && (sc = function(le1, vt, bt) {
                            const ls = new Int32Array(vt[vt.length - 1] + 1);
                            let ho = 0;
                            ls[0] = ho;
                            let Dl = 1, Fl = 0;
                            for(let sc = 0; sc < le1.length; sc++){
                                const uc = le1[sc], mc = vt[sc + 1] - vt[sc];
                                if (4 === uc || 1 === uc) for(let le1 = 0; le1 < mc; le1++)ho = ls[Dl++] = ho + bt[Fl++];
                                else for(let le1 = 0; le1 < mc; le1++)ls[Dl++] = ++ho;
                            }
                            return ls;
                        }(du, Fl, sc))) : null !== sc && null !== uc ? (sc = qh(du, sc, 1), uc = Gh(du, sc, uc, !0)) : null !== sc && (sc = qh(du, sc, 0)), null !== kc ? Nh(du, Ec, kc, gc, new Sh(Fl, sc, uc)) : null === Ac ? function(le1, vt, bt, ls) {
                            return new Vh(mA.VEC_2, le1, vt, bt, ls);
                        }(du, new Sh(Fl, sc, uc), mc, gc) : function(le1, vt, bt, ls, ho) {
                            return new Vh(mA.MORTON, le1, vt, bt, ls, ho);
                        }(du, new Sh(Fl, sc, uc), mc, gc, Ac));
                    }
                    function qh(le1, vt, bt) {
                        const ls = new Int32Array(le1.length + 1);
                        let ho = 0;
                        ls[0] = ho;
                        let Dl = 0;
                        for(let Fl = 0; Fl < le1.length; Fl++)ho = ls[Fl + 1] = ho + (le1[Fl] > bt ? vt[Dl++] : 1);
                        return ls;
                    }
                    function Gh(le1, vt, bt, ls) {
                        const ho = new Int32Array(vt[vt.length - 1] + 1);
                        let Dl = 0;
                        ho[0] = Dl;
                        let Fl = 1, sc = 0;
                        for(let uc = 0; uc < le1.length; uc++){
                            const mc = le1[uc], gc = vt[uc + 1] - vt[uc];
                            if (5 === mc || 2 === mc || ls && (4 === mc || 1 === mc)) for(let le1 = 0; le1 < gc; le1++)Dl = ho[Fl++] = Dl + bt[sc++];
                            else for(let le1 = 0; le1 < gc; le1++)ho[Fl++] = ++Dl;
                        }
                        return ho;
                    }
                    class jh extends $c {
                        constructor(le1, vt, bt){
                            super(le1, vt.getBuffer(), bt), this.dataVector = void 0, this.dataVector = vt;
                        }
                        getValueFromBuffer(le1) {
                            return this.dataVector.get(le1);
                        }
                    }
                    class Xh extends Uc {
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[le1];
                        }
                    }
                    class Yh extends $c {
                        constructor(le1, vt, bt){
                            super(le1, BigInt64Array.of(vt), bt);
                        }
                        getValueFromBuffer(le1) {
                            return this.dataBuffer[0];
                        }
                    }
                    function Zh(le1, vt, bt) {
                        return Hh(le1, Math.ceil(vt / 8), bt);
                    }
                    function Hh(le1, vt, bt) {
                        const ls = new Uint8Array(vt);
                        let ho = 0;
                        for(; ho < vt;){
                            const vt = le1[bt.increment()];
                            if (vt <= 127) {
                                const Dl = vt + 3, Fl = le1[bt.increment()], sc = ho + Dl;
                                ls.fill(Fl, ho, sc), ho = sc;
                            } else {
                                const Dl = 256 - vt;
                                for(let vt = 0; vt < Dl; vt++)ls[ho++] = le1[bt.increment()];
                            }
                        }
                        return ls;
                    }
                    const gA = new TextDecoder;
                    function Jh(le1, vt, bt) {
                        return bt - vt >= 12 ? gA.decode(le1.subarray(vt, bt)) : function(le1, vt, bt) {
                            let ls = "", ho = vt;
                            for(; ho < bt;){
                                const vt = le1[ho];
                                let Dl, Fl, sc, uc = null, mc = vt > 239 ? 4 : vt > 223 ? 3 : vt > 191 ? 2 : 1;
                                if (ho + mc > bt) break;
                                1 === mc ? vt < 128 && (uc = vt) : 2 === mc ? (Dl = le1[ho + 1], 128 == (192 & Dl) && (uc = (31 & vt) << 6 | 63 & Dl, uc <= 127 && (uc = null))) : 3 === mc ? (Dl = le1[ho + 1], Fl = le1[ho + 2], 128 == (192 & Dl) && 128 == (192 & Fl) && (uc = (15 & vt) << 12 | (63 & Dl) << 6 | 63 & Fl, (uc <= 2047 || uc >= 55296 && uc <= 57343) && (uc = null))) : 4 === mc && (Dl = le1[ho + 1], Fl = le1[ho + 2], sc = le1[ho + 3], 128 == (192 & Dl) && 128 == (192 & Fl) && 128 == (192 & sc) && (uc = (15 & vt) << 18 | (63 & Dl) << 12 | (63 & Fl) << 6 | 63 & sc, (uc <= 65535 || uc >= 1114112) && (uc = null))), null === uc ? (uc = 65533, mc = 1) : uc > 65535 && (uc -= 65536, ls += String.fromCharCode(uc >>> 10 & 1023 | 55296), uc = 56320 | 1023 & uc), ls += String.fromCharCode(uc), ho += mc;
                            }
                            return ls;
                        }(le1, vt, bt);
                    }
                    class Kh extends $c {
                        constructor(le1, vt, bt, ls){
                            super(le1, bt, ls), this.offsetBuffer = void 0, this.offsetBuffer = vt;
                        }
                    }
                    class Qh extends Kh {
                        constructor(le1, vt, bt, ls){
                            super(le1, vt, bt, ls ?? vt.length - 1), this.textEncoder = void 0, this.textEncoder = new TextEncoder;
                        }
                        getValueFromBuffer(le1) {
                            return Jh(this.dataBuffer, this.offsetBuffer[le1], this.offsetBuffer[le1 + 1]);
                        }
                    }
                    class ep extends Kh {
                        constructor(le1, vt, bt, ls, ho){
                            super(le1, bt, ls, ho ?? vt.length), this.indexBuffer = void 0, this.textEncoder = void 0, this.indexBuffer = vt, this.indexBuffer = vt, this.textEncoder = new TextEncoder;
                        }
                        getValueFromBuffer(le1) {
                            const vt = this.indexBuffer[le1];
                            return Jh(this.dataBuffer, this.offsetBuffer[vt], this.offsetBuffer[vt + 1]);
                        }
                    }
                    class tp extends Kh {
                        constructor(le1, vt, bt, ls, ho, Dl, Fl){
                            super(le1, bt, ls, Fl), this.indexBuffer = void 0, this.symbolOffsetBuffer = void 0, this.symbolTableBuffer = void 0, this.textEncoder = void 0, this.symbolLengthBuffer = void 0, this.lengthBuffer = void 0, this.decodedDictionary = void 0, this.indexBuffer = vt, this.symbolOffsetBuffer = ho, this.symbolTableBuffer = Dl, this.textEncoder = new TextEncoder;
                        }
                        getValueFromBuffer(le1) {
                            null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer), this.lengthBuffer = this.offsetToLengthBuffer(this.offsetBuffer)), this.decodedDictionary = function(le1, vt, bt) {
                                const ls = [], ho = new Array(vt.length).fill(0);
                                for(let Dl = 1; Dl < vt.length; Dl++)ho[Dl] = ho[Dl - 1] + vt[Dl - 1];
                                for(let Dl = 0; Dl < bt.length; Dl++)if (255 === bt[Dl]) ls.push(bt[++Dl]);
                                else {
                                    const Fl = vt[bt[Dl]], sc = ho[bt[Dl]];
                                    for(let vt = 0; vt < Fl; vt++)ls.push(le1[sc + vt]);
                                }
                                return new Uint8Array(ls);
                            }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
                            const vt = this.indexBuffer[le1];
                            return Jh(this.decodedDictionary, this.offsetBuffer[vt], this.offsetBuffer[vt + 1]);
                        }
                        offsetToLengthBuffer(le1) {
                            const vt = new Uint32Array(le1.length - 1);
                            let bt = le1[0];
                            for(let ls = 1; ls < le1.length; ls++){
                                const ho = le1[ls];
                                vt[ls - 1] = ho - bt, bt = ho;
                            }
                            return vt;
                        }
                    }
                    function rp(le1, vt, bt, ls, ho, Dl) {
                        return "scalarType" === bt.type ? function(le1, vt, bt, ls, ho, Dl) {
                            let Fl = null, sc = 0;
                            if (0 === le1) return null;
                            if (Dl.nullable) {
                                const le1 = uh(vt, bt);
                                sc = le1.numValues;
                                const ls = bt.get(), ho = Zh(vt, sc, bt);
                                bt.set(ls + le1.byteLength), Fl = new ch(ho, le1.numValues);
                            }
                            const uc = Fl ?? ls;
                            switch(ho.physicalType){
                                case 4:
                                case 3:
                                    return function(le1, vt, bt, ls, ho) {
                                        const Dl = uh(le1, vt), Fl = bh(Dl, ho, le1, vt), sc = 3 === ls.physicalType;
                                        if (Fl === hA.FLAT) {
                                            const ls = np(ho) ? vh(le1, vt, Dl, sc, ho) : hh(le1, vt, Dl, sc);
                                            return new qc(bt.name, ls, ho);
                                        }
                                        if (Fl === hA.SEQUENCE) {
                                            const ls = yh(le1, vt, Dl);
                                            return new Xc(bt.name, ls[0], ls[1], Dl.numRleValues);
                                        }
                                        {
                                            const ls = dh(le1, vt, Dl, sc);
                                            return new Yc(bt.name, ls, ho);
                                        }
                                    }(vt, bt, Dl, ho, uc);
                                case 9:
                                    return function(le1, vt, bt, ls, ho) {
                                        let Dl = null, Fl = null, sc = null, uc = null, mc = null, gc = null, Ac = null, Ec = null;
                                        for(let kc = 0; kc < ls; kc++){
                                            const le1 = uh(vt, bt);
                                            if (0 !== le1.byteLength) switch(le1.physicalStreamType){
                                                case oA.PRESENT:
                                                    {
                                                        const ls = Zh(vt, le1.numValues, bt);
                                                        gc = new ch(ls, le1.numValues);
                                                        break;
                                                    }
                                                case oA.OFFSET:
                                                    Fl = null != ho || null != gc ? vh(vt, bt, le1, !1, ho ?? gc) : hh(vt, bt, le1, !1);
                                                    break;
                                                case oA.LENGTH:
                                                    {
                                                        const ls = ph(vt, bt, le1);
                                                        uA.DICTIONARY === le1.logicalStreamType.lengthType ? Dl = ls : uA.SYMBOL === le1.logicalStreamType.lengthType ? uc = ls : Ac = ls;
                                                        break;
                                                    }
                                                case oA.DATA:
                                                    {
                                                        const ls = vt.subarray(bt.get(), bt.get() + le1.byteLength);
                                                        bt.add(le1.byteLength);
                                                        const ho = le1.logicalStreamType.dictionaryType;
                                                        lA.FSST === ho ? mc = ls : lA.SINGLE === ho || lA.SHARED === ho ? sc = ls : lA.NONE === ho && (Ec = ls);
                                                        break;
                                                    }
                                            }
                                        }
                                        return function(le1, vt, bt, ls, ho, Dl, Fl) {
                                            return vt ? new tp(le1, bt, ls, ho, Dl, vt, Fl) : null;
                                        }(le1, mc, Fl, Dl, sc, uc, ho ?? gc) ?? function(le1, vt, bt, ls, ho) {
                                            return vt ? ho ? new ep(le1, bt, ls, vt, ho) : new ep(le1, bt, ls, vt) : null;
                                        }(le1, sc, Fl, Dl, ho ?? gc) ?? function(le1, vt, bt, ls, ho) {
                                            if (!vt || !bt) return null;
                                            if (ls) return ho ? new ep(le1, ls, vt, bt, ho) : new ep(le1, ls, vt, bt);
                                            if (ho && ho.size() !== vt.length - 1) {
                                                const ls = new Int32Array(ho.size());
                                                let Dl = 0;
                                                for(let le1 = 0; le1 < ho.size(); le1++)ls[le1] = ho.get(le1) ? Dl++ : 0;
                                                return new ep(le1, ls, vt, bt, ho);
                                            }
                                            return ho ? new Qh(le1, vt, bt, ho) : new Qh(le1, vt, bt);
                                        }(le1, Ac, Ec, Fl, ho ?? gc);
                                    }(Dl.name, vt, bt, Dl.nullable ? le1 - 1 : le1, Fl);
                                case 0:
                                    return function(le1, vt, bt, ls, ho) {
                                        const Dl = uh(le1, vt), Fl = Dl.numValues, sc = vt.get(), uc = np(ho) ? function(le1, vt, bt, ls) {
                                            const ho = Hh(le1, Math.ceil(vt / 8), bt), Dl = new ch(ho, vt), Fl = ls.size(), sc = new ch(new Uint8Array(Fl), Fl);
                                            let uc = 0;
                                            for(let mc = 0; mc < ls.size(); mc++){
                                                const le1 = !!ls.get(mc) && Dl.get(uc++);
                                                sc.set(mc, le1);
                                            }
                                            return sc.getBuffer();
                                        }(le1, Fl, vt, ho) : Zh(le1, Fl, vt);
                                        vt.set(sc + Dl.byteLength);
                                        const mc = new ch(uc, Fl);
                                        return new jh(bt.name, mc, ho);
                                    }(vt, bt, Dl, 0, uc);
                                case 6:
                                case 5:
                                    return function(le1, vt, bt, ls, ho) {
                                        const Dl = uh(le1, vt), Fl = bh(Dl, ls, le1, vt), sc = 5 === ho.physicalType;
                                        if (Fl === hA.FLAT) {
                                            const ho = np(ls) ? function(le1, vt, bt, ls, ho) {
                                                return function(le1, vt, bt, ls) {
                                                    switch(vt.logicalLevelTechnique1){
                                                        case aA.DELTA:
                                                            return vt.logicalLevelTechnique2 === aA.RLE && (le1 = ih(le1, vt.runs, vt.numRleValues)), function(le1, vt) {
                                                                const bt = new BigInt64Array(le1.size());
                                                                let ls = 0;
                                                                le1.get(0) ? (bt[0] = le1.get(0) ? vt[0] >> 1n ^ -(1n & vt[0]) : 0n, ls = 1) : bt[0] = 0n;
                                                                let ho = 1;
                                                                for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? bt[ho - 1] + (vt[ls] >> 1n ^ -(1n & vt[ls++])) : bt[ho - 1];
                                                                return bt;
                                                            }(ls, le1);
                                                        case aA.RLE:
                                                            return function(le1, vt, bt, ls) {
                                                                const ho = vt;
                                                                return bt ? function(le1, vt, bt) {
                                                                    const ls = new BigInt64Array(le1.size());
                                                                    let ho = 0;
                                                                    for(let Dl = 0; Dl < bt; Dl++){
                                                                        const Fl = Number(vt[Dl]);
                                                                        let sc = vt[Dl + bt];
                                                                        sc = sc >> 1n ^ -(1n & sc);
                                                                        for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0n, ho++);
                                                                        ho += Fl;
                                                                    }
                                                                    return ls;
                                                                }(ls, le1, ho.runs) : function(le1, vt, bt) {
                                                                    const ls = new BigInt64Array(le1.size());
                                                                    let ho = 0;
                                                                    for(let Dl = 0; Dl < bt; Dl++){
                                                                        const Fl = Number(vt[Dl]), sc = vt[Dl + bt];
                                                                        for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0n, ho++);
                                                                        ho += Fl;
                                                                    }
                                                                    return ls;
                                                                }(ls, le1, ho.runs);
                                                            }(le1, vt, bt, ls);
                                                        case aA.NONE:
                                                            return le1 = bt ? function(le1, vt) {
                                                                const bt = new BigInt64Array(le1.size());
                                                                let ls = 0, ho = 0;
                                                                for(; ho != bt.length; ++ho)if (le1.get(ho)) {
                                                                    const le1 = vt[ls++];
                                                                    bt[ho] = le1 >> 1n ^ -(1n & le1);
                                                                } else bt[ho] = 0n;
                                                                return bt;
                                                            }(ls, le1) : function(le1, vt) {
                                                                const bt = new BigInt64Array(le1.size());
                                                                let ls = 0, ho = 0;
                                                                for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? vt[ls++] : 0n;
                                                                return bt;
                                                            }(ls, le1), le1;
                                                        default:
                                                            throw new Error("The specified Logical level technique is not supported");
                                                    }
                                                }(Jc(le1, vt, bt.numValues), bt, ls, ho);
                                            }(le1, vt, Dl, sc, ls) : gh(le1, vt, Dl, sc);
                                            return new wh(bt.name, ho, ls);
                                        }
                                        if (Fl === hA.SEQUENCE) {
                                            const ls = mh(le1, vt, Dl);
                                            return new _h(bt.name, ls[0], ls[1], Dl.numRleValues);
                                        }
                                        {
                                            const ho = xh(le1, vt, Dl, sc);
                                            return new Yh(bt.name, ho, ls);
                                        }
                                    }(vt, bt, Dl, uc, ho);
                                case 7:
                                    return function(le1, vt, bt, ls) {
                                        const ho = uh(le1, vt), Dl = np(ls) ? function(le1, vt, bt, ls) {
                                            const ho = vt.get(), Dl = ho + ls * Float32Array.BYTES_PER_ELEMENT, Fl = new Uint8Array(le1.subarray(ho, Dl)).buffer, sc = new Float32Array(Fl);
                                            vt.set(Dl);
                                            const uc = bt.size(), mc = new Float32Array(uc);
                                            let gc = 0;
                                            for(let Ac = 0; Ac < uc; Ac++)mc[Ac] = bt.get(Ac) ? sc[gc++] : 0;
                                            return mc;
                                        }(le1, vt, ls, ho.numValues) : function(le1, vt, bt) {
                                            const ls = vt.get(), ho = ls + bt * Float32Array.BYTES_PER_ELEMENT, Dl = new Uint8Array(le1.subarray(ls, ho)).buffer, Fl = new Float32Array(Dl);
                                            return vt.set(ho), Fl;
                                        }(le1, vt, ho.numValues);
                                        return new Xh(bt.name, Dl, ls);
                                    }(vt, bt, Dl, uc);
                                case 8:
                                    return function(le1, vt, bt, ls) {
                                        const ho = uh(le1, vt), Dl = np(ls) ? function(le1, vt, bt, ls) {
                                            const ho = vt.get(), Dl = ho + ls * Float64Array.BYTES_PER_ELEMENT, Fl = new Uint8Array(le1.subarray(ho, Dl)).buffer, sc = new Float64Array(Fl);
                                            vt.set(Dl);
                                            const uc = bt.size(), mc = new Float64Array(uc);
                                            let gc = 0;
                                            for(let Ac = 0; Ac < uc; Ac++)mc[Ac] = bt.get(Ac) ? sc[gc++] : 0;
                                            return mc;
                                        }(le1, vt, ls, ho.numValues) : function(le1, vt, bt) {
                                            const ls = vt.get(), ho = ls + bt * Float64Array.BYTES_PER_ELEMENT, Dl = new Uint8Array(le1.subarray(ls, ho)).buffer, Fl = new Float64Array(Dl);
                                            return vt.set(ho), Fl;
                                        }(le1, vt, ho.numValues);
                                        return new Gc(bt.name, Dl, ls);
                                    }(vt, bt, Dl, uc);
                                default:
                                    throw new Error(`The specified data type for the field is currently not supported: ${ho}`);
                            }
                        }(ls, le1, vt, ho, bt.scalarType, bt) : 1 != ls ? null : function(le1, vt, bt, ls) {
                            let ho = null, Dl = null, Fl = null, sc = null, uc = !1;
                            for(; !uc;){
                                const bt = uh(le1, vt);
                                switch(bt.physicalStreamType){
                                    case oA.LENGTH:
                                        uA.DICTIONARY === bt.logicalStreamType.lengthType ? ho = ph(le1, vt, bt) : Fl = ph(le1, vt, bt);
                                        break;
                                    case oA.DATA:
                                        lA.SINGLE === bt.logicalStreamType.dictionaryType || lA.SHARED === bt.logicalStreamType.dictionaryType ? (Dl = le1.subarray(vt.get(), vt.get() + bt.byteLength), uc = !0) : sc = le1.subarray(vt.get(), vt.get() + bt.byteLength), vt.add(bt.byteLength);
                                }
                            }
                            const mc = bt.complexType.children, gc = [];
                            let Ac = 0;
                            for (const Ec of mc){
                                const uc = Wc(le1, vt, 1)[0];
                                if (0 == uc) continue;
                                const mc = `${bt.name}${"default" === Ec.name ? "" : ":" + Ec.name}`;
                                if (2 !== uc || "scalarField" !== Ec.type || 9 !== Ec.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
                                const kc = uh(le1, vt), du = Zh(le1, kc.numValues, vt), _u = uh(le1, vt), Md = _u.decompressedCount !== ls ? vh(le1, vt, _u, !1, new ch(du, kc.numValues)) : hh(le1, vt, _u, !1);
                                gc[Ac++] = sc ? new tp(mc, Md, ho, Dl, Fl, sc, new ch(du, kc.numValues)) : new ep(mc, Md, ho, Dl, new ch(du, kc.numValues));
                            }
                            return gc;
                        }(le1, vt, bt, ho);
                    }
                    function np(le1) {
                        return le1 instanceof ch;
                    }
                    function ip(le1) {
                        if ("id" === le1.name) return !1;
                        if ("scalarType" === le1.type) {
                            const vt = le1.scalarType;
                            if ("physicalType" === vt.type) switch(vt.physicalType){
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                case 4:
                                case 5:
                                case 6:
                                case 7:
                                case 8:
                                default:
                                    return !1;
                                case 9:
                                    return !0;
                            }
                            else if ("logicalType" === vt.type) return !1;
                        } else if ("complexType" === le1.type) {
                            const vt = le1.complexType;
                            if ("physicalType" === vt.type) switch(vt.physicalType){
                                case 0:
                                case 1:
                                    return !0;
                                default:
                                    return !1;
                            }
                        }
                        return console.warn("Unexpected column type in hasStreamCount", le1), !1;
                    }
                    const AA = new TextDecoder;
                    function op(le1, vt) {
                        const bt = Wc(le1, vt, 1)[0];
                        if (0 === bt) return "";
                        const ls = vt.get(), ho = le1.subarray(ls, ls + bt);
                        return vt.add(bt), AA.decode(ho);
                    }
                    function ap(le1, vt) {
                        const bt = Wc(le1, vt, 1)[0] >>> 0, ls = !!(4 & bt), ho = !!(2 & bt), Dl = Wc(le1, vt, 1)[0] >>> 0, Fl = {};
                        if (1 & bt && (Fl.nullable = !0), ho) {
                            const ho = {};
                            if (ls ? (ho.type = "logicalType", ho.logicalType = Dl) : (ho.type = "physicalType", ho.physicalType = Dl), 8 & bt) {
                                const bt = Wc(le1, vt, 1)[0] >>> 0;
                                ho.children = new Array(bt);
                                for(let ls = 0; ls < bt; ls++)ho.children[ls] = ap(le1, vt);
                            }
                            Fl.type = "complexField", Fl.complexField = ho;
                        } else {
                            const le1 = {};
                            ls ? (le1.type = "logicalType", le1.logicalType = Dl) : (le1.type = "physicalType", le1.physicalType = Dl), Fl.type = "scalarField", Fl.scalarField = le1;
                        }
                        return Fl;
                    }
                    function lp(le1, vt) {
                        const bt = Wc(le1, vt, 1)[0] >>> 0, ls = function(le1) {
                            switch(le1){
                                case 0:
                                case 1:
                                case 2:
                                case 3:
                                    {
                                        const vt = {};
                                        vt.nullable = !!(1 & le1), vt.columnScope = 0;
                                        const bt = {};
                                        return bt.physicalType = le1 > 1 ? 6 : 4, bt.type = "physicalType", vt.scalarType = bt, vt.type = "scalarType", vt;
                                    }
                                case 4:
                                    {
                                        const le1 = {
                                            nullable: !1,
                                            columnScope: 0
                                        }, vt = {
                                            type: "physicalType",
                                            physicalType: 0
                                        };
                                        return le1.type = "complexType", le1.complexType = vt, le1;
                                    }
                                case 30:
                                    {
                                        const le1 = {
                                            nullable: !1,
                                            columnScope: 0
                                        }, vt = {
                                            type: "physicalType",
                                            physicalType: 1
                                        };
                                        return le1.type = "complexType", le1.complexType = vt, le1;
                                    }
                                default:
                                    return function(le1) {
                                        let vt = null;
                                        switch(le1){
                                            case 10:
                                            case 11:
                                                vt = 0;
                                                break;
                                            case 12:
                                            case 13:
                                                vt = 1;
                                                break;
                                            case 14:
                                            case 15:
                                                vt = 2;
                                                break;
                                            case 16:
                                            case 17:
                                                vt = 3;
                                                break;
                                            case 18:
                                            case 19:
                                                vt = 4;
                                                break;
                                            case 20:
                                            case 21:
                                                vt = 5;
                                                break;
                                            case 22:
                                            case 23:
                                                vt = 6;
                                                break;
                                            case 24:
                                            case 25:
                                                vt = 7;
                                                break;
                                            case 26:
                                            case 27:
                                                vt = 8;
                                                break;
                                            case 28:
                                            case 29:
                                                vt = 9;
                                                break;
                                            default:
                                                return null;
                                        }
                                        const bt = {};
                                        bt.nullable = !!(1 & le1), bt.columnScope = 0;
                                        const ls = {
                                            type: "physicalType"
                                        };
                                        return ls.physicalType = vt, bt.type = "scalarType", bt.scalarType = ls, bt;
                                    }(le1);
                            }
                        }(bt);
                        if (!ls) throw new Error(`Unsupported column type code: ${bt}`);
                        if (function(le1) {
                            return le1 >= 10;
                        }(bt) ? ls.name = op(le1, vt) : bt >= 0 && bt <= 3 ? ls.name = "id" : 4 === bt && (ls.name = "geometry"), function(le1) {
                            return 30 === le1;
                        }(bt)) {
                            const bt = Wc(le1, vt, 1)[0] >>> 0, ho = ls.complexType;
                            ho.children = new Array(bt);
                            for(let ls = 0; ls < bt; ls++)ho.children[ls] = ap(le1, vt);
                        }
                        return ls;
                    }
                    function up(le1, vt) {
                        const bt = {
                            featureTables: []
                        }, ls = {};
                        ls.name = op(le1, vt);
                        const ho = Wc(le1, vt, 1)[0] >>> 0, Dl = Wc(le1, vt, 1)[0] >>> 0;
                        ls.columns = new Array(Dl);
                        for(let Fl = 0; Fl < Dl; Fl++)ls.columns[Fl] = lp(le1, vt);
                        return bt.featureTables.push(ls), [
                            bt,
                            ho
                        ];
                    }
                    function cp(le1, vt, bt, ls, ho, Dl, Fl) {
                        void 0 === Fl && (Fl = !1);
                        const sc = vt.scalarType.physicalType, uc = bh(ho, Dl, le1, bt);
                        if (4 === sc) switch(uc){
                            case hA.FLAT:
                                {
                                    const vt = hh(le1, bt, ho, !1);
                                    return new qc(ls, vt, Dl);
                                }
                            case hA.SEQUENCE:
                                {
                                    const vt = yh(le1, bt, ho);
                                    return new Xc(ls, vt[0], vt[1], ho.numRleValues);
                                }
                            case hA.CONST:
                                {
                                    const vt = dh(le1, bt, ho, !1);
                                    return new Yc(ls, vt, Dl);
                                }
                        }
                        else switch(uc){
                            case hA.FLAT:
                                {
                                    if (Fl) {
                                        const vt = function(le1, vt, bt) {
                                            const ls = function(le1, vt, bt) {
                                                const ls = new Float64Array(vt);
                                                for(let ho = 0; ho < vt; ho++)ls[ho] = Kc(le1, bt);
                                                return ls;
                                            }(le1, bt.numValues, vt);
                                            return function(le1, vt) {
                                                switch(vt.logicalLevelTechnique1){
                                                    case aA.DELTA:
                                                        return vt.logicalLevelTechnique2 === aA.RLE && (le1 = sh(le1, vt.runs, vt.numRleValues)), function(le1) {
                                                            le1[0] = le1[0] % 2 == 1 ? (le1[0] + 1) / -2 : le1[0] / 2;
                                                            const vt = le1.length / 4 * 4;
                                                            let bt = 1;
                                                            if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                                                const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                                                le1[bt] = (vt % 2 == 1 ? (vt + 1) / -2 : vt / 2) + le1[bt - 1], le1[bt + 1] = (ls % 2 == 1 ? (ls + 1) / -2 : ls / 2) + le1[bt], le1[bt + 2] = (ho % 2 == 1 ? (ho + 1) / -2 : ho / 2) + le1[bt + 1], le1[bt + 3] = (Dl % 2 == 1 ? (Dl + 1) / -2 : Dl / 2) + le1[bt + 2];
                                                            }
                                                            for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] % 2 == 1 ? (le1[bt] + 1) / -2 : le1[bt] / 2) + le1[bt - 1];
                                                        }(le1), le1;
                                                    case aA.RLE:
                                                        return function(le1, vt) {
                                                            return sh(le1, vt.runs, vt.numRleValues);
                                                        }(le1, vt);
                                                    case aA.NONE:
                                                        return le1;
                                                    default:
                                                        throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                                                }
                                            }(ls, bt);
                                        }(le1, bt, ho);
                                        return new Gc(ls, vt, Dl);
                                    }
                                    const vt = gh(le1, bt, ho, !1);
                                    return new wh(ls, vt, Dl);
                                }
                            case hA.SEQUENCE:
                                {
                                    const vt = mh(le1, bt, ho);
                                    return new _h(ls, vt[0], vt[1], ho.numRleValues);
                                }
                            case hA.CONST:
                                {
                                    const vt = xh(le1, bt, ho, !1);
                                    return new Yh(ls, vt, Dl);
                                }
                        }
                        throw new Error("Vector type not supported for id column.");
                    }
                    class hp {
                        constructor(le1, vt){
                            var bt;
                            switch(this._featureData = le1, this.properties = this._featureData.properties || {}, null === (bt = this._featureData.geometry) || void 0 === bt ? void 0 : bt.type){
                                case dA.POINT:
                                case dA.MULTIPOINT:
                                    this.type = 1;
                                    break;
                                case dA.LINESTRING:
                                case dA.MULTILINESTRING:
                                    this.type = 2;
                                    break;
                                case dA.POLYGON:
                                case dA.MULTIPOLYGON:
                                    this.type = 3;
                                    break;
                                default:
                                    this.type = 0;
                            }
                            this.extent = vt, this.id = Number(this._featureData.id);
                        }
                        loadGeometry() {
                            const le1 = [];
                            for (const vt of this._featureData.geometry.coordinates){
                                const bt = [];
                                for (const le1 of vt)bt.push(new t(le1.x, le1.y));
                                le1.push(bt);
                            }
                            return le1;
                        }
                    }
                    class pp {
                        constructor(le1){
                            this.features = [], this.featureTable = le1, this.name = le1.name, this.extent = le1.extent, this.version = 2, this.features = le1.getFeatures(), this.length = this.features.length;
                        }
                        feature(le1) {
                            return new hp(this.features[le1], this.extent);
                        }
                    }
                    class fp {
                        constructor(le1){
                            this.layers = {};
                            const vt = function(le1, vt, bt) {
                                void 0 === bt && (bt = !0);
                                const ls = new Hc(0), ho = [];
                                for(; ls.get() < le1.length;){
                                    const vt = Wc(le1, ls, 1)[0] >>> 0, Dl = ls.get() + vt;
                                    if (Dl > le1.length) throw new Error(`Block overruns tile: ${Dl} > ${le1.length}`);
                                    if (1 != Wc(le1, ls, 1)[0] >>> 0) {
                                        ls.set(Dl);
                                        continue;
                                    }
                                    const Fl = up(le1, ls), sc = Fl[1], uc = Fl[0].featureTables[0];
                                    let mc = null, gc = null;
                                    const Ac = [];
                                    let Ec = 0;
                                    for (const ho of uc.columns){
                                        const vt = ho.name;
                                        if ("id" === vt) {
                                            let Dl = null;
                                            if (ho.nullable) {
                                                const vt = uh(le1, ls), bt = ls.get(), ho = Zh(le1, vt.numValues, ls);
                                                ls.set(bt + vt.byteLength), Dl = new ch(ho, vt.numValues);
                                            }
                                            const Fl = uh(le1, ls);
                                            Ec = Fl.decompressedCount, mc = cp(le1, ho, ls, vt, Fl, Dl ?? Ec, bt);
                                        } else if ("geometry" === vt) {
                                            const vt = Wc(le1, ls, 1)[0];
                                            if (0 === Ec) {
                                                const vt = ls.get();
                                                Ec = uh(le1, ls).decompressedCount, ls.set(vt);
                                            }
                                            gc = Uh(le1, vt, ls, Ec);
                                        } else {
                                            const vt = ip(ho) ? Wc(le1, ls, 1)[0] : 1;
                                            if (0 === vt && "scalarType" === ho.type) continue;
                                            const bt = rp(le1, ls, ho, vt, Ec);
                                            if (bt) {
                                                if (Array.isArray(bt)) for (const le1 of bt)Ac.push(le1);
                                                else Ac.push(bt);
                                            }
                                        }
                                    }
                                    const kc = new Zc(uc.name, gc, mc, Ac, sc);
                                    ho.push(kc), ls.set(Dl);
                                }
                                return ho;
                            }(new Uint8Array(le1));
                            this.layers = vt.reduce((le1, vt)=>Object.assign(Object.assign({}, le1), {
                                    [vt.name]: new pp(vt)
                                }), {});
                        }
                    }
                    class dp {
                        constructor(){
                            this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
                        }
                        extend(le1) {
                            return this.minX = Math.min(this.minX, le1.x), this.minY = Math.min(this.minY, le1.y), this.maxX = Math.max(this.maxX, le1.x), this.maxY = Math.max(this.maxY, le1.y), this;
                        }
                        expandBy(le1) {
                            return this.minX -= le1, this.minY -= le1, this.maxX += le1, this.maxY += le1, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
                        }
                        shrinkBy(le1) {
                            return this.expandBy(-le1);
                        }
                        map(le1) {
                            const vt = new dp;
                            return vt.extend(le1(new t(this.minX, this.minY))), vt.extend(le1(new t(this.maxX, this.minY))), vt.extend(le1(new t(this.minX, this.maxY))), vt.extend(le1(new t(this.maxX, this.maxY))), vt;
                        }
                        static fromPoints(le1) {
                            const vt = new dp;
                            for (const bt of le1)vt.extend(bt);
                            return vt;
                        }
                        contains(le1) {
                            return le1.x >= this.minX && le1.x <= this.maxX && le1.y >= this.minY && le1.y <= this.maxY;
                        }
                        empty() {
                            return this.minX > this.maxX;
                        }
                        width() {
                            return this.maxX - this.minX;
                        }
                        height() {
                            return this.maxY - this.minY;
                        }
                        covers(le1) {
                            return !this.empty() && !le1.empty() && le1.minX >= this.minX && le1.maxX <= this.maxX && le1.minY >= this.minY && le1.maxY <= this.maxY;
                        }
                        intersects(le1) {
                            return !this.empty() && !le1.empty() && le1.minX <= this.maxX && le1.maxX >= this.minX && le1.minY <= this.maxY && le1.maxY >= this.minY;
                        }
                    }
                    class yp {
                        constructor(le1, vt){
                            this.feature = le1, this.type = le1.type, this.properties = le1.tags ? le1.tags : {}, this.extent = vt, "id" in le1 && ("string" == typeof le1.id ? this.id = parseInt(le1.id, 10) : "number" != typeof le1.id || isNaN(le1.id) || (this.id = le1.id));
                        }
                        loadGeometry() {
                            const le1 = [], vt = 1 === this.feature.type ? [
                                this.feature.geometry
                            ] : this.feature.geometry;
                            for (const bt of vt){
                                const vt = [];
                                for (const le1 of bt)vt.push(new t(le1[0], le1[1]));
                                le1.push(vt);
                            }
                            return le1;
                        }
                    }
                    const _A = "_geojsonTileLayer";
                    class gp {
                        constructor(le1, vt){
                            this.layers = {
                                [_A]: this
                            }, this.name = _A, this.version = vt ? vt.version : 1, this.extent = vt ? vt.extent : 4096, this.length = le1.length, this.features = le1;
                        }
                        feature(le1) {
                            return new yp(this.features[le1], this.extent);
                        }
                    }
                    function xp(le1, vt) {
                        vt.writeVarintField(15, le1.version || 1), vt.writeStringField(1, le1.name || ""), vt.writeVarintField(5, le1.extent || 4096);
                        const bt = {
                            keys: [],
                            values: [],
                            keycache: {},
                            valuecache: {}
                        };
                        for(let Dl = 0; Dl < le1.length; Dl++)bt.feature = le1.feature(Dl), vt.writeMessage(2, vp, bt);
                        const ls = bt.keys;
                        for (const Dl of ls)vt.writeStringField(3, Dl);
                        const ho = bt.values;
                        for (const Dl of ho)vt.writeMessage(4, Ap, Dl);
                    }
                    function vp(le1, vt) {
                        if (!le1.feature) return;
                        const bt = le1.feature;
                        void 0 !== bt.id && vt.writeVarintField(1, bt.id), vt.writeMessage(2, bp, le1), vt.writeVarintField(3, bt.type), vt.writeMessage(4, Sp, bt);
                    }
                    function bp(le1, vt) {
                        for(const bt in le1.feature?.properties){
                            let ls = le1.feature.properties[bt], ho = le1.keycache[bt];
                            if (null == ls) continue;
                            void 0 === ho && (le1.keys.push(bt), ho = le1.keys.length - 1, le1.keycache[bt] = ho), vt.writeVarint(ho), "string" != typeof ls && "boolean" != typeof ls && "number" != typeof ls && (ls = JSON.stringify(ls));
                            const Dl = typeof ls + ":" + ls;
                            let Fl = le1.valuecache[Dl];
                            void 0 === Fl && (le1.values.push(ls), Fl = le1.values.length - 1, le1.valuecache[Dl] = Fl), vt.writeVarint(Fl);
                        }
                    }
                    function wp(le1, vt) {
                        return (vt << 3) + (7 & le1);
                    }
                    function _p(le1) {
                        return le1 << 1 ^ le1 >> 31;
                    }
                    function Sp(le1, vt) {
                        const bt = le1.loadGeometry(), ls = le1.type;
                        let ho = 0, Dl = 0;
                        for (const Fl of bt){
                            let bt = 1;
                            1 === ls && (bt = Fl.length), vt.writeVarint(wp(1, bt));
                            const sc = 3 === ls ? Fl.length - 1 : Fl.length;
                            for(let le1 = 0; le1 < sc; le1++){
                                1 === le1 && 1 !== ls && vt.writeVarint(wp(2, sc - 1));
                                const bt = Fl[le1].x - ho, uc = Fl[le1].y - Dl;
                                vt.writeVarint(_p(bt)), vt.writeVarint(_p(uc)), ho += bt, Dl += uc;
                            }
                            3 === le1.type && vt.writeVarint(wp(7, 1));
                        }
                    }
                    function Ap(le1, vt) {
                        const bt = typeof le1;
                        "string" === bt ? vt.writeStringField(1, le1) : "boolean" === bt ? vt.writeBooleanField(7, le1) : "number" === bt && (le1 % 1 != 0 ? vt.writeDoubleField(3, le1) : le1 < 0 ? vt.writeSVarintField(6, le1) : vt.writeVarintField(5, le1));
                    }
                    class Ip {
                        constructor(le1, vt){
                            this.tileID = le1, this.x = le1.canonical.x, this.y = le1.canonical.y, this.z = le1.canonical.z, this.grid = new T(uc, 16, 0), this.grid3D = new T(uc, 16, 0), this.featureIndexArray = new Zs, this.promoteId = vt;
                        }
                        insert(le1, vt, bt, ls, ho, Dl) {
                            const Fl = this.featureIndexArray.length;
                            this.featureIndexArray.emplaceBack(bt, ls, ho);
                            const sc = Dl ? this.grid3D : this.grid;
                            for(let mc = 0; mc < vt.length; mc++){
                                const le1 = vt[mc], bt = [
                                    1 / 0,
                                    1 / 0,
                                    -1 / 0,
                                    -1 / 0
                                ];
                                for(let vt = 0; vt < le1.length; vt++){
                                    const ls = le1[vt];
                                    bt[0] = Math.min(bt[0], ls.x), bt[1] = Math.min(bt[1], ls.y), bt[2] = Math.max(bt[2], ls.x), bt[3] = Math.max(bt[3], ls.y);
                                }
                                bt[0] < uc && bt[1] < uc && bt[2] >= 0 && bt[3] >= 0 && sc.insert(Fl, bt[0], bt[1], bt[2], bt[3]);
                            }
                        }
                        loadVTLayers() {
                            return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new $l(new zu(this.rawTileData)).layers : new fp(this.rawTileData).layers, this.sourceLayerCoder = new Rc(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                _A
                            ])), this.vtLayers;
                        }
                        query(le1, vt, bt, ls) {
                            this.loadVTLayers();
                            const ho = le1.params, Dl = uc / le1.tileSize / le1.scale, Fl = hn(ho.filter, ho.globalState), sc = le1.queryGeometry, mc = le1.queryPadding * Dl, gc = dp.fromPoints(sc), Ac = this.grid.query(gc.minX - mc, gc.minY - mc, gc.maxX + mc, gc.maxY + mc), Ec = dp.fromPoints(le1.cameraQueryGeometry).expandBy(mc), kc = this.grid3D.query(Ec.minX, Ec.minY, Ec.maxX, Ec.maxY, (vt, bt, ls, ho)=>(function(le1, vt, bt, ls, ho) {
                                    for (const Fl of le1)if (vt <= Fl.x && bt <= Fl.y && ls >= Fl.x && ho >= Fl.y) return !0;
                                    const Dl = [
                                        new t(vt, bt),
                                        new t(vt, ho),
                                        new t(ls, ho),
                                        new t(ls, bt)
                                    ];
                                    if (le1.length > 2) {
                                        for (const Fl of Dl)if (aa(le1, Fl)) return !0;
                                    }
                                    for(let Fl = 0; Fl < le1.length - 1; Fl++)if (la(le1[Fl], le1[Fl + 1], Dl)) return !0;
                                    return !1;
                                })(le1.cameraQueryGeometry, vt - mc, bt - mc, ls + mc, ho + mc));
                            for (const uc of kc)Ac.push(uc);
                            Ac.sort(kp);
                            const du = {};
                            let _u;
                            for(let uc = 0; uc < Ac.length; uc++){
                                const mc = Ac[uc];
                                if (mc === _u) continue;
                                _u = mc;
                                const gc = this.featureIndexArray.get(mc);
                                let Ec = null;
                                this.loadMatchingFeature(du, gc.bucketIndex, gc.sourceLayerIndex, gc.featureIndex, Fl, ho.layers, ho.availableImages, vt, bt, ls, (vt, bt, ls)=>(Ec || (Ec = Yo(vt)), bt.queryIntersectsFeature({
                                        queryGeometry: sc,
                                        feature: vt,
                                        featureState: ls,
                                        geometry: Ec,
                                        zoom: this.z,
                                        transform: le1.transform,
                                        pixelsToTileUnits: Dl,
                                        pixelPosMatrix: le1.pixelPosMatrix,
                                        unwrappedTileID: this.tileID.toUnwrapped(),
                                        getElevation: le1.getElevation
                                    })));
                            }
                            return du;
                        }
                        loadMatchingFeature(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                            const Ac = this.bucketLayerIDs[vt];
                            if (Dl && !Ac.some((le1)=>Dl.has(le1))) return;
                            const Ec = this.sourceLayerCoder.decode(bt), kc = this.vtLayers[Ec].feature(ls);
                            if (ho.needGeometry) {
                                const le1 = Zo(kc, !0);
                                if (!ho.filter(new Gi(this.tileID.overscaledZ), le1, this.tileID.canonical)) return;
                            } else if (!ho.filter(new Gi(this.tileID.overscaledZ), kc)) return;
                            const du = this.getId(kc, Ec);
                            for(let _u = 0; _u < Ac.length; _u++){
                                const vt = Ac[_u];
                                if (Dl && !Dl.has(vt)) continue;
                                const bt = sc[vt];
                                if (!bt) continue;
                                let ho = {};
                                du && mc && (ho = mc.getState(bt.sourceLayer || _A, du));
                                const Ec = d({}, uc[vt]);
                                Ec.paint = Tp(Ec.paint, bt.paint, kc, ho, Fl), Ec.layout = Tp(Ec.layout, bt.layout, kc, ho, Fl);
                                const Md = !gc || gc(kc, bt, ho);
                                if (!Md) continue;
                                const Ld = new Nc(kc, this.z, this.x, this.y, du);
                                Ld.layer = Ec;
                                let Nd = le1[vt];
                                void 0 === Nd && (Nd = le1[vt] = []), Nd.push({
                                    featureIndex: ls,
                                    feature: Ld,
                                    intersectionZ: Md
                                });
                            }
                        }
                        lookupSymbolFeatures(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = {};
                            this.loadVTLayers();
                            const mc = hn(ho.filterSpec, ho.globalState);
                            for (const gc of le1)this.loadMatchingFeature(uc, bt, ls, gc, mc, Dl, Fl, sc, vt);
                            return uc;
                        }
                        hasLayer(le1) {
                            for (const vt of this.bucketLayerIDs)for (const bt of vt)if (le1 === bt) return !0;
                            return !1;
                        }
                        getId(le1, vt) {
                            var bt;
                            let ls = le1.id;
                            return this.promoteId && (ls = le1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[vt]], "boolean" == typeof ls && (ls = Number(ls)), void 0 === ls && (null === (bt = le1.properties) || void 0 === bt ? void 0 : bt.cluster) && this.promoteId && (ls = Number(le1.properties.cluster_id))), ls;
                        }
                    }
                    function Tp(le1, vt, bt, ls, ho) {
                        return y(le1, (le1, Dl)=>{
                            const Fl = vt instanceof es ? vt.get(Dl) : null;
                            return Fl && Fl.evaluate ? Fl.evaluate(bt, ls, ho) : Fl;
                        });
                    }
                    function kp(le1, vt) {
                        return vt - le1;
                    }
                    pi("FeatureIndex", Ip, {
                        omit: [
                            "rawTileData",
                            "sourceLayerCoder"
                        ]
                    });
                    class Ep {
                        constructor(le1, vt){
                            this.keyCache = {}, le1 && this.replace(le1, vt);
                        }
                        replace(le1, vt) {
                            this._layerConfigs = {}, this._layers = {}, this.update(le1, [], vt);
                        }
                        update(le1, vt, bt) {
                            for (const ho of le1){
                                this._layerConfigs[ho.id] = ho;
                                const le1 = this._layers[ho.id] = Oc(ho, bt);
                                le1._featureFilter = hn(le1.filter, bt), this.keyCache[ho.id] && delete this.keyCache[ho.id];
                            }
                            for (const ho of vt)delete this.keyCache[ho], delete this._layerConfigs[ho], delete this._layers[ho];
                            this.familiesBySource = {};
                            const ls = function(le1, vt) {
                                const bt = {};
                                for(let ho = 0; ho < le1.length; ho++){
                                    const ls = vt && vt[le1[ho].id] || bn(le1[ho]);
                                    vt && (vt[le1[ho].id] = ls);
                                    let Dl = bt[ls];
                                    Dl || (Dl = bt[ls] = []), Dl.push(le1[ho]);
                                }
                                const ls = [];
                                for(const ho in bt)ls.push(bt[ho]);
                                return ls;
                            }(Object.values(this._layerConfigs), this.keyCache);
                            for (const ho of ls){
                                const le1 = ho.map((le1)=>this._layers[le1.id]), vt = le1[0];
                                if (vt.isHidden()) continue;
                                const bt = vt.source || "";
                                let ls = this.familiesBySource[bt];
                                ls || (ls = this.familiesBySource[bt] = {});
                                const Dl = vt.sourceLayer || _A;
                                let Fl = ls[Dl];
                                Fl || (Fl = ls[Dl] = []), Fl.push(le1);
                            }
                        }
                    }
                    class Mp extends t {
                        constructor(le1, vt, bt, ls){
                            super(le1, vt), this.angle = bt, void 0 !== ls && (this.segment = ls);
                        }
                        clone() {
                            return new Mp(this.x, this.y, this.angle, this.segment);
                        }
                    }
                    function Dp(le1, vt, bt, ls, ho) {
                        if (void 0 === vt.segment || 0 === bt) return !0;
                        let Dl = vt, Fl = vt.segment + 1, sc = 0;
                        for(; sc > -bt / 2;){
                            if (Fl--, Fl < 0) return !1;
                            sc -= le1[Fl].dist(Dl), Dl = le1[Fl];
                        }
                        sc += le1[Fl].dist(le1[Fl + 1]), Fl++;
                        const uc = [];
                        let mc = 0;
                        for(; sc < bt / 2;){
                            const vt = le1[Fl], bt = le1[Fl + 1];
                            if (!bt) return !1;
                            let Dl = le1[Fl - 1].angleTo(vt) - vt.angleTo(bt);
                            for(Dl = Math.abs((Dl + 3 * Math.PI) % (2 * Math.PI) - Math.PI), uc.push({
                                distance: sc,
                                angleDelta: Dl
                            }), mc += Dl; sc - uc[0].distance > ls;)mc -= uc.shift().angleDelta;
                            if (mc > ho) return !1;
                            Fl++, sc += vt.dist(bt);
                        }
                        return !0;
                    }
                    function Pp(le1) {
                        let vt = 0;
                        for(let bt = 0; bt < le1.length - 1; bt++)vt += le1[bt].dist(le1[bt + 1]);
                        return vt;
                    }
                    function zp(le1, vt, bt) {
                        return le1 ? .6 * vt * bt : 0;
                    }
                    function Fp(le1, vt) {
                        return Math.max(le1 ? le1.right - le1.left : 0, vt ? vt.right - vt.left : 0);
                    }
                    function Bp(le1, vt, bt, ls, ho, Dl) {
                        const Fl = zp(bt, ho, Dl), sc = Fp(bt, ls) * Dl;
                        let uc = 0;
                        const mc = Pp(le1) / 2;
                        for(let gc = 0; gc < le1.length - 1; gc++){
                            const bt = le1[gc], ls = le1[gc + 1], ho = bt.dist(ls);
                            if (uc + ho > mc) {
                                const Dl = (mc - uc) / ho, Ac = mm.number(bt.x, ls.x, Dl), Ec = mm.number(bt.y, ls.y, Dl), kc = new Mp(Ac, Ec, ls.angleTo(bt), gc);
                                return kc._round(), !Fl || Dp(le1, kc, sc, Fl, vt) ? kc : void 0;
                            }
                            uc += ho;
                        }
                    }
                    function Cp(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                        const mc = zp(ls, Dl, Fl), gc = Fp(ls, ho), Ac = gc * Fl, Ec = 0 === le1[0].x || le1[0].x === uc || 0 === le1[0].y || le1[0].y === uc;
                        return vt - Ac < vt / 4 && (vt = Ac + vt / 4), Vp(le1, Ec ? vt / 2 * sc % vt : (gc / 2 + 2 * Dl) * Fl * sc % vt, vt, mc, bt, Ac, Ec, !1, uc);
                    }
                    function Vp(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                        const mc = Dl / 2, gc = Pp(le1);
                        let Ac = 0, Ec = vt - bt, kc = [];
                        for(let du = 0; du < le1.length - 1; du++){
                            const vt = le1[du], Fl = le1[du + 1], sc = vt.dist(Fl), _u = Fl.angleTo(vt);
                            for(; Ec + bt < Ac + sc;){
                                Ec += bt;
                                const Md = (Ec - Ac) / sc, Ld = mm.number(vt.x, Fl.x, Md), Nd = mm.number(vt.y, Fl.y, Md);
                                if (Ld >= 0 && Ld < uc && Nd >= 0 && Nd < uc && Ec - mc >= 0 && Ec + mc <= gc) {
                                    const vt = new Mp(Ld, Nd, _u, du);
                                    vt._round(), ls && !Dp(le1, vt, Dl, ls, ho) || kc.push(vt);
                                }
                            }
                            Ac += sc;
                        }
                        return sc || kc.length || Fl || (kc = Vp(le1, Ac / 2, bt, ls, ho, Dl, Fl, !0, uc)), kc;
                    }
                    function Lp(le1, vt, bt, ls, ho, Dl) {
                        let Fl = Op(le1, vt, bt, ho, 0);
                        return Fl = Op(Fl, vt, ls, Dl, 1), Fl;
                    }
                    function Op(le1, vt, bt, ls, ho) {
                        switch(vt){
                            case 1:
                                return function(le1, vt, bt, ls) {
                                    const ho = [];
                                    for (const Dl of le1)for (const le1 of Dl){
                                        const Dl = 0 === ls ? le1.x : le1.y;
                                        Dl >= vt && Dl <= bt && ho.push([
                                            le1
                                        ]);
                                    }
                                    return ho;
                                }(le1, bt, ls, ho);
                            case 2:
                                return Np(le1, bt, ls, ho, !1);
                            case 3:
                                return Np(le1, bt, ls, ho, !0);
                        }
                        return [];
                    }
                    function Rp(le1, vt, bt, ls, ho) {
                        const Dl = 0 === ls ? $p : Up;
                        let Fl = [];
                        const sc = [];
                        for(let gc = 0; gc < le1.length - 1; gc++){
                            const uc = le1[gc], mc = le1[gc + 1], Ac = 0 === ls ? uc.x : uc.y, Ec = 0 === ls ? mc.x : mc.y;
                            let kc = !1;
                            Ac < vt ? Ec > vt && Fl.push(Dl(uc, mc, vt)) : Ac > bt ? Ec < bt && Fl.push(Dl(uc, mc, bt)) : Fl.push(uc), Ec < vt && Ac >= vt && (Fl.push(Dl(uc, mc, vt)), kc = !0), Ec > bt && Ac <= bt && (Fl.push(Dl(uc, mc, bt)), kc = !0), !ho && kc && (sc.push(Fl), Fl = []);
                        }
                        const uc = le1.length - 1, mc = 0 === ls ? le1[uc].x : le1[uc].y;
                        return mc >= vt && mc <= bt && Fl.push(le1[uc]), ho && Fl.length > 0 && !Fl[0].equals(Fl[Fl.length - 1]) && Fl.push(new t(Fl[0].x, Fl[0].y)), Fl.length > 0 && sc.push(Fl), sc;
                    }
                    function Np(le1, vt, bt, ls, ho) {
                        const Dl = [];
                        for (const Fl of le1){
                            const le1 = Rp(Fl, vt, bt, ls, ho);
                            le1.length > 0 && Dl.push(...le1);
                        }
                        return Dl;
                    }
                    function $p(le1, vt, bt) {
                        return new t(bt, le1.y + (bt - le1.x) / (vt.x - le1.x) * (vt.y - le1.y));
                    }
                    function Up(le1, vt, bt) {
                        return new t(le1.x + (bt - le1.y) / (vt.y - le1.y) * (vt.x - le1.x), bt);
                    }
                    function qp(le1, vt, bt, ls) {
                        const ho = [], Dl = le1.image, Fl = Dl.pixelRatio, sc = Dl.paddedRect.w - 2, uc = Dl.paddedRect.h - 2;
                        let mc = {
                            x1: le1.left,
                            y1: le1.top,
                            x2: le1.right,
                            y2: le1.bottom
                        };
                        const gc = Dl.stretchX || [
                            [
                                0,
                                sc
                            ]
                        ], Ac = Dl.stretchY || [
                            [
                                0,
                                uc
                            ]
                        ], f = (le1, vt)=>le1 + vt[1] - vt[0], Ec = gc.reduce(f, 0), kc = Ac.reduce(f, 0), du = sc - Ec, _u = uc - kc;
                        let Md = 0, Ld = Ec, Nd = 0, Rd = kc, Od = 0, jd = du, Ud = 0, Gd = _u;
                        if (Dl.content && ls) {
                            const vt = Dl.content, bt = vt[2] - vt[0], ls = vt[3] - vt[1];
                            (Dl.textFitWidth || Dl.textFitHeight) && (mc = nc(le1)), Md = Gp(gc, 0, vt[0]), Nd = Gp(Ac, 0, vt[1]), Ld = Gp(gc, vt[0], vt[2]), Rd = Gp(Ac, vt[1], vt[3]), Od = vt[0] - Md, Ud = vt[1] - Nd, jd = bt - Ld, Gd = ls - Rd;
                        }
                        const qd = mc.x1, Hd = mc.y1, Wd = mc.x2 - qd, Zd = mc.y2 - Hd, D = (le1, ls, ho, sc)=>{
                            const uc = Xp(le1.stretch - Md, Ld, Wd, qd), mc = Yp(le1.fixed - Od, jd, le1.stretch, Ec), gc = Xp(ls.stretch - Nd, Rd, Zd, Hd), Ac = Yp(ls.fixed - Ud, Gd, ls.stretch, kc), du = Xp(ho.stretch - Md, Ld, Wd, qd), _u = Yp(ho.fixed - Od, jd, ho.stretch, Ec), Yd = Xp(sc.stretch - Nd, Rd, Zd, Hd), Qd = Yp(sc.fixed - Ud, Gd, sc.stretch, kc), Xd = new t(uc, gc), Kd = new t(du, gc), Jd = new t(du, Yd), $d = new t(uc, Yd), sp = new t(mc / Fl, Ac / Fl), em = new t(_u / Fl, Qd / Fl), tm = vt * Math.PI / 180;
                            if (tm) {
                                const le1 = Math.sin(tm), vt = Math.cos(tm), bt = [
                                    vt,
                                    -le1,
                                    le1,
                                    vt
                                ];
                                Xd._matMult(bt), Kd._matMult(bt), $d._matMult(bt), Jd._matMult(bt);
                            }
                            const im = le1.stretch + le1.fixed, nm = ls.stretch + ls.fixed;
                            return {
                                tl: Xd,
                                tr: Kd,
                                bl: $d,
                                br: Jd,
                                tex: {
                                    x: Dl.paddedRect.x + 1 + im,
                                    y: Dl.paddedRect.y + 1 + nm,
                                    w: ho.stretch + ho.fixed - im,
                                    h: sc.stretch + sc.fixed - nm
                                },
                                writingMode: void 0,
                                glyphOffset: [
                                    0,
                                    0
                                ],
                                sectionIndex: 0,
                                pixelOffsetTL: sp,
                                pixelOffsetBR: em,
                                minFontScaleX: jd / Fl / Wd,
                                minFontScaleY: Gd / Fl / Zd,
                                isSDF: bt
                            };
                        };
                        if (ls && (Dl.stretchX || Dl.stretchY)) {
                            const le1 = jp(gc, du, Ec), vt = jp(Ac, _u, kc);
                            for(let bt = 0; bt < le1.length - 1; bt++){
                                const ls = le1[bt], Dl = le1[bt + 1];
                                for(let le1 = 0; le1 < vt.length - 1; le1++)ho.push(D(ls, vt[le1], Dl, vt[le1 + 1]));
                            }
                        } else ho.push(D({
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: -1
                        }, {
                            fixed: 0,
                            stretch: sc + 1
                        }, {
                            fixed: 0,
                            stretch: uc + 1
                        }));
                        return ho;
                    }
                    function Gp(le1, vt, bt) {
                        let ls = 0;
                        for (const ho of le1)ls += Math.max(vt, Math.min(bt, ho[1])) - Math.max(vt, Math.min(bt, ho[0]));
                        return ls;
                    }
                    function jp(le1, vt, bt) {
                        const ls = [
                            {
                                fixed: -1,
                                stretch: 0
                            }
                        ];
                        for (const [ho, Dl] of le1){
                            const le1 = ls[ls.length - 1];
                            ls.push({
                                fixed: ho - le1.stretch,
                                stretch: le1.stretch
                            }), ls.push({
                                fixed: ho - le1.stretch,
                                stretch: le1.stretch + (Dl - ho)
                            });
                        }
                        return ls.push({
                            fixed: vt + 1,
                            stretch: bt
                        }), ls;
                    }
                    function Xp(le1, vt, bt, ls) {
                        return le1 / vt * bt + ls;
                    }
                    function Yp(le1, vt, bt, ls) {
                        return le1 - vt * bt / ls;
                    }
                    pi("Anchor", Mp);
                    class Zp {
                        constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc){
                            var gc;
                            if (this.boxStartIndex = le1.length, uc) {
                                let le1 = Dl.top, vt = Dl.bottom;
                                const bt = Dl.collisionPadding;
                                bt && (le1 -= bt[1], vt += bt[3]);
                                let ls = vt - le1;
                                ls > 0 && (ls = Math.max(10, ls), this.circleDiameter = ls);
                            } else {
                                const uc = (null === (gc = Dl.image) || void 0 === gc ? void 0 : gc.content) && (Dl.image.textFitWidth || Dl.image.textFitHeight) ? nc(Dl) : {
                                    x1: Dl.left,
                                    y1: Dl.top,
                                    x2: Dl.right,
                                    y2: Dl.bottom
                                };
                                uc.y1 = uc.y1 * Fl - sc[0], uc.y2 = uc.y2 * Fl + sc[2], uc.x1 = uc.x1 * Fl - sc[3], uc.x2 = uc.x2 * Fl + sc[1];
                                const Ac = Dl.collisionPadding;
                                if (Ac && (uc.x1 -= Ac[0] * Fl, uc.y1 -= Ac[1] * Fl, uc.x2 += Ac[2] * Fl, uc.y2 += Ac[3] * Fl), mc) {
                                    const le1 = new t(uc.x1, uc.y1), vt = new t(uc.x2, uc.y1), bt = new t(uc.x1, uc.y2), ls = new t(uc.x2, uc.y2), ho = mc * Math.PI / 180;
                                    le1._rotate(ho), vt._rotate(ho), bt._rotate(ho), ls._rotate(ho), uc.x1 = Math.min(le1.x, vt.x, bt.x, ls.x), uc.x2 = Math.max(le1.x, vt.x, bt.x, ls.x), uc.y1 = Math.min(le1.y, vt.y, bt.y, ls.y), uc.y2 = Math.max(le1.y, vt.y, bt.y, ls.y);
                                }
                                le1.emplaceBack(vt.x, vt.y, uc.x1, uc.y1, uc.x2, uc.y2, bt, ls, ho);
                            }
                            this.boxEndIndex = le1.length;
                        }
                    }
                    class Hp {
                        constructor(le1, vt){
                            if (void 0 === le1 && (le1 = []), void 0 === vt && (vt = (le1, vt)=>le1 < vt ? -1 : le1 > vt ? 1 : 0), this.data = le1, this.length = this.data.length, this.compare = vt, this.length > 0) for(let bt = (this.length >> 1) - 1; bt >= 0; bt--)this._down(bt);
                        }
                        push(le1) {
                            this.data.push(le1), this._up(this.length++);
                        }
                        pop() {
                            if (0 === this.length) return;
                            const le1 = this.data[0], vt = this.data.pop();
                            return --this.length > 0 && (this.data[0] = vt, this._down(0)), le1;
                        }
                        peek() {
                            return this.data[0];
                        }
                        _up(le1) {
                            const { data: vt, compare: bt } = this, ls = vt[le1];
                            for(; le1 > 0;){
                                const ho = le1 - 1 >> 1, Dl = vt[ho];
                                if (bt(ls, Dl) >= 0) break;
                                vt[le1] = Dl, le1 = ho;
                            }
                            vt[le1] = ls;
                        }
                        _down(le1) {
                            const { data: vt, compare: bt } = this, ls = this.length >> 1, ho = vt[le1];
                            for(; le1 < ls;){
                                let ls = 1 + (le1 << 1);
                                const Dl = ls + 1;
                                if (Dl < this.length && bt(vt[Dl], vt[ls]) < 0 && (ls = Dl), bt(vt[ls], ho) >= 0) break;
                                vt[le1] = vt[ls], le1 = ls;
                            }
                            vt[le1] = ho;
                        }
                    }
                    function Wp(le1, vt, bt) {
                        void 0 === vt && (vt = 1), void 0 === bt && (bt = !1);
                        const ls = dp.fromPoints(le1[0]), ho = Math.min(ls.width(), ls.height());
                        let Dl = ho / 2;
                        const Fl = new Hp([], Jp), { minX: sc, minY: uc, maxX: mc, maxY: gc } = ls;
                        if (0 === ho) return new t(sc, uc);
                        for(let kc = sc; kc < mc; kc += ho)for(let vt = uc; vt < gc; vt += ho)Fl.push(new Kp(kc + Dl, vt + Dl, Dl, le1));
                        let Ac = function(le1) {
                            let vt = 0, bt = 0, ls = 0;
                            const ho = le1[0];
                            for(let Dl = 0, Fl = ho.length, sc = Fl - 1; Dl < Fl; sc = Dl++){
                                const le1 = ho[Dl], Fl = ho[sc], uc = le1.x * Fl.y - Fl.x * le1.y;
                                bt += (le1.x + Fl.x) * uc, ls += (le1.y + Fl.y) * uc, vt += 3 * uc;
                            }
                            return new Kp(bt / vt, ls / vt, 0, le1);
                        }(le1), Ec = Fl.length;
                        for(; Fl.length;){
                            const ls = Fl.pop();
                            (ls.d > Ac.d || !Ac.d) && (Ac = ls, bt && console.log("found best %d after %d probes", Math.round(1e4 * ls.d) / 1e4, Ec)), ls.max - Ac.d <= vt || (Dl = ls.h / 2, Fl.push(new Kp(ls.p.x - Dl, ls.p.y - Dl, Dl, le1)), Fl.push(new Kp(ls.p.x + Dl, ls.p.y - Dl, Dl, le1)), Fl.push(new Kp(ls.p.x - Dl, ls.p.y + Dl, Dl, le1)), Fl.push(new Kp(ls.p.x + Dl, ls.p.y + Dl, Dl, le1)), Ec += 4);
                        }
                        return bt && (console.log(`num probes: ${Ec}`), console.log(`best distance: ${Ac.d}`)), Ac.p;
                    }
                    function Jp(le1, vt) {
                        return vt.max - le1.max;
                    }
                    function Kp(le1, vt, bt, ls) {
                        this.p = new t(le1, vt), this.h = bt, this.d = function(le1, vt) {
                            let bt = !1, ls = 1 / 0;
                            for(let ho = 0; ho < vt.length; ho++){
                                const Dl = vt[ho];
                                for(let vt = 0, ho = Dl.length, Fl = ho - 1; vt < ho; Fl = vt++){
                                    const ho = Dl[vt], sc = Dl[Fl];
                                    ho.y > le1.y != sc.y > le1.y && le1.x < (sc.x - ho.x) * (le1.y - ho.y) / (sc.y - ho.y) + ho.x && (bt = !bt), ls = Math.min(ls, sa(le1, ho, sc));
                                }
                            }
                            return (bt ? 1 : -1) * Math.sqrt(ls);
                        }(this.p, ls), this.max = this.d + this.h * Math.SQRT2;
                    }
                    var yA;
                    !function(le1) {
                        le1[le1.center = 1] = "center", le1[le1.left = 2] = "left", le1[le1.right = 3] = "right", le1[le1.top = 4] = "top", le1[le1.bottom = 5] = "bottom", le1[le1["top-left"] = 6] = "top-left", le1[le1["top-right"] = 7] = "top-right", le1[le1["bottom-left"] = 8] = "bottom-left", le1[le1["bottom-right"] = 9] = "bottom-right";
                    }(yA || (yA = {}));
                    const vA = Number.POSITIVE_INFINITY;
                    function tf(le1, vt) {
                        return vt[1] !== vA ? function(le1, vt, bt) {
                            let ls = 0, ho = 0;
                            switch(vt = Math.abs(vt), bt = Math.abs(bt), le1){
                                case "top-right":
                                case "top-left":
                                case "top":
                                    ho = bt - 7;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                case "bottom":
                                    ho = 7 - bt;
                            }
                            switch(le1){
                                case "top-right":
                                case "bottom-right":
                                case "right":
                                    ls = -vt;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                case "left":
                                    ls = vt;
                            }
                            return [
                                ls,
                                ho
                            ];
                        }(le1, vt[0], vt[1]) : function(le1, vt) {
                            let bt = 0, ls = 0;
                            vt < 0 && (vt = 0);
                            const ho = vt / Math.SQRT2;
                            switch(le1){
                                case "top-right":
                                case "top-left":
                                    ls = ho - 7;
                                    break;
                                case "bottom-right":
                                case "bottom-left":
                                    ls = 7 - ho;
                                    break;
                                case "bottom":
                                    ls = 7 - vt;
                                    break;
                                case "top":
                                    ls = vt - 7;
                            }
                            switch(le1){
                                case "top-right":
                                case "bottom-right":
                                    bt = -ho;
                                    break;
                                case "top-left":
                                case "bottom-left":
                                    bt = ho;
                                    break;
                                case "left":
                                    bt = vt;
                                    break;
                                case "right":
                                    bt = -vt;
                            }
                            return [
                                bt,
                                ls
                            ];
                        }(le1, vt[0]);
                    }
                    function rf(le1, vt, bt) {
                        var ls;
                        const ho = le1.layout, Dl = null === (ls = ho.get("text-variable-anchor-offset")) || void 0 === ls ? void 0 : ls.evaluate(vt, {}, bt);
                        if (Dl) {
                            const le1 = Dl.values, vt = [];
                            for(let bt = 0; bt < le1.length; bt += 2){
                                const ls = vt[bt] = le1[bt], ho = le1[bt + 1].map((le1)=>le1 * Vg);
                                ls.startsWith("top") ? ho[1] -= 7 : ls.startsWith("bottom") && (ho[1] += 7), vt[bt + 1] = ho;
                            }
                            return new Ce(vt);
                        }
                        const Fl = ho.get("text-variable-anchor");
                        if (Fl) {
                            let ls;
                            ls = void 0 !== le1._unevaluatedLayout.getValue("text-radial-offset") ? [
                                ho.get("text-radial-offset").evaluate(vt, {}, bt) * Vg,
                                vA
                            ] : ho.get("text-offset").evaluate(vt, {}, bt).map((le1)=>le1 * Vg);
                            const Dl = [];
                            for (const le1 of Fl)Dl.push(le1, tf(le1, ls));
                            return new Ce(Dl);
                        }
                        return null;
                    }
                    function nf(le1) {
                        var vt;
                        le1.bucket.createArrays(), le1.bucket.tilePixelRatio = uc / (512 * le1.bucket.overscaling), le1.bucket.compareText = {}, le1.bucket.iconsNeedLinear = !1;
                        const bt = le1.bucket.layers[0], ls = bt.layout, ho = bt._unevaluatedLayout._values, Dl = {
                            layoutIconSize: ho["icon-size"].possiblyEvaluate(new Gi(le1.bucket.zoom + 1), le1.canonical),
                            layoutTextSize: ho["text-size"].possiblyEvaluate(new Gi(le1.bucket.zoom + 1), le1.canonical),
                            textMaxSize: ho["text-size"].possiblyEvaluate(new Gi(18))
                        };
                        if ("composite" === le1.bucket.textSizeData.kind) {
                            const { minZoom: vt, maxZoom: bt } = le1.bucket.textSizeData;
                            Dl.compositeTextSizes = [
                                ho["text-size"].possiblyEvaluate(new Gi(vt), le1.canonical),
                                ho["text-size"].possiblyEvaluate(new Gi(bt), le1.canonical)
                            ];
                        }
                        if ("composite" === le1.bucket.iconSizeData.kind) {
                            const { minZoom: vt, maxZoom: bt } = le1.bucket.iconSizeData;
                            Dl.compositeIconSizes = [
                                ho["icon-size"].possiblyEvaluate(new Gi(vt), le1.canonical),
                                ho["icon-size"].possiblyEvaluate(new Gi(bt), le1.canonical)
                            ];
                        }
                        const Fl = ls.get("text-line-height") * Vg, sc = "viewport" !== ls.get("text-rotation-alignment") && "point" !== ls.get("symbol-placement"), mc = ls.get("text-keep-upright"), gc = ls.get("text-size");
                        for (const uc of le1.bucket.features){
                            const ho = ls.get("text-font").evaluate(uc, {}, le1.canonical).join(","), Ac = gc.evaluate(uc, {}, le1.canonical), Ec = Dl.layoutTextSize.evaluate(uc, {}, le1.canonical), kc = Dl.layoutIconSize.evaluate(uc, {}, le1.canonical), du = {
                                horizontal: {},
                                vertical: void 0
                            }, _u = uc.text;
                            let Md, Ld = [
                                0,
                                0
                            ];
                            if (_u) {
                                const vt = _u.toString(), Dl = ls.get("text-letter-spacing").evaluate(uc, {}, le1.canonical) * Vg, gc = Bi(vt) ? Dl : 0, kc = ls.get("text-anchor").evaluate(uc, {}, le1.canonical), Md = rf(bt, uc, le1.canonical);
                                if (!Md) {
                                    const vt = ls.get("text-radial-offset").evaluate(uc, {}, le1.canonical);
                                    Ld = vt ? tf(kc, [
                                        vt * Vg,
                                        vA
                                    ]) : ls.get("text-offset").evaluate(uc, {}, le1.canonical).map((le1)=>le1 * Vg);
                                }
                                let Nd = sc ? "center" : ls.get("text-justify").evaluate(uc, {}, le1.canonical);
                                const Rd = "point" === ls.get("symbol-placement") ? ls.get("text-max-width").evaluate(uc, {}, le1.canonical) * Vg : 1 / 0, b = ()=>{
                                    le1.bucket.allowVerticalPlacement && Fi(vt) && (du.vertical = Zu(_u, le1.glyphMap, le1.glyphPositions, le1.imagePositions, ho, Rd, Fl, kc, "left", gc, Ld, Qg.vertical, !0, Ec, Ac));
                                };
                                if (!sc && Md) {
                                    const vt = new Set;
                                    if ("auto" === Nd) for(let le1 = 0; le1 < Md.values.length; le1 += 2)vt.add(sf(Md.values[le1]));
                                    else vt.add(Nd);
                                    let bt = !1;
                                    for (const ls of vt)if (!du.horizontal[ls]) {
                                        if (bt) du.horizontal[ls] = du.horizontal[0];
                                        else {
                                            const vt = Zu(_u, le1.glyphMap, le1.glyphPositions, le1.imagePositions, ho, Rd, Fl, "center", ls, gc, Ld, Qg.horizontal, !1, Ec, Ac);
                                            vt && (du.horizontal[ls] = vt, bt = 1 === vt.positionedLines.length);
                                        }
                                    }
                                    b();
                                } else {
                                    "auto" === Nd && (Nd = sf(kc));
                                    const bt = Zu(_u, le1.glyphMap, le1.glyphPositions, le1.imagePositions, ho, Rd, Fl, kc, Nd, gc, Ld, Qg.horizontal, !1, Ec, Ac);
                                    bt && (du.horizontal[Nd] = bt), b(), Fi(vt) && sc && mc && (du.vertical = Zu(_u, le1.glyphMap, le1.glyphPositions, le1.imagePositions, ho, Rd, Fl, kc, Nd, gc, Ld, Qg.vertical, !1, Ec, Ac));
                                }
                            }
                            let Nd = !1;
                            if (uc.icon && uc.icon.name) {
                                const vt = le1.imageMap[uc.icon.name];
                                vt && (Md = rc(le1.imagePositions[uc.icon.name], ls.get("icon-offset").evaluate(uc, {}, le1.canonical), ls.get("icon-anchor").evaluate(uc, {}, le1.canonical)), Nd = !!vt.sdf, void 0 === le1.bucket.sdfIcons ? le1.bucket.sdfIcons = Nd : le1.bucket.sdfIcons !== Nd && x("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (vt.pixelRatio !== le1.bucket.pixelRatio || 0 !== ls.get("icon-rotate").constantOr(1)) && (le1.bucket.iconsNeedLinear = !0));
                            }
                            const Rd = lf(du.horizontal) || du.vertical;
                            (vt = le1.bucket).iconsInText || (vt.iconsInText = !!Rd && Rd.iconsInText), (Rd || Md) && of(le1.bucket, uc, du, Md, le1.imageMap, Dl, Ec, kc, Ld, Nd, le1.canonical, le1.subdivisionGranularity);
                        }
                        le1.showCollisionBoxes && le1.bucket.generateCollisionDebugBuffers();
                    }
                    function sf(le1) {
                        switch(le1){
                            case "right":
                            case "top-right":
                            case "bottom-right":
                                return "right";
                            case "left":
                            case "top-left":
                            case "bottom-left":
                                return "left";
                        }
                        return "center";
                    }
                    function of(le1, vt, bt, ls, ho, Dl, Fl, sc, mc, gc, Ac, Ec) {
                        let kc = Dl.textMaxSize.evaluate(vt, {});
                        void 0 === kc && (kc = Fl);
                        const du = le1.layers[0].layout, _u = du.get("icon-offset").evaluate(vt, {}, Ac), Md = lf(bt.horizontal), Ld = Fl / 24, Nd = le1.tilePixelRatio * Ld, Rd = le1.tilePixelRatio * kc / 24, Od = le1.tilePixelRatio * sc, jd = le1.tilePixelRatio * du.get("symbol-spacing"), Ud = du.get("text-padding") * le1.tilePixelRatio, Gd = function(le1, vt, bt, ls) {
                            void 0 === ls && (ls = 1);
                            const ho = le1.get("icon-padding").evaluate(vt, {}, bt), Dl = ho && ho.values;
                            return [
                                Dl[0] * ls,
                                Dl[1] * ls,
                                Dl[2] * ls,
                                Dl[3] * ls
                            ];
                        }(du, vt, Ac, le1.tilePixelRatio), qd = du.get("text-max-angle") / 180 * Math.PI, Hd = "viewport" !== du.get("text-rotation-alignment") && "point" !== du.get("symbol-placement"), Wd = "map" === du.get("icon-rotation-alignment") && "point" !== du.get("symbol-placement"), Zd = du.get("symbol-placement"), Yd = jd / 2, Qd = du.get("icon-text-fit");
                        let Xd;
                        ls && "none" !== Qd && (le1.allowVerticalPlacement && bt.vertical && (Xd = ic(ls, bt.vertical, Qd, du.get("icon-text-fit-padding"), _u, Ld)), Md && (ls = ic(ls, Md, Qd, du.get("icon-text-fit-padding"), _u, Ld)));
                        const Kd = Ac ? Ec.line.getGranularityForZoomLevel(Ac.z) : 1, B = (sc, Ec)=>{
                            Ec.x < 0 || Ec.x >= uc || Ec.y < 0 || Ec.y >= uc || function(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd) {
                                const Hd = le1.addToLineVertexArray(vt, bt);
                                let Wd, Zd, Yd, Qd, Xd = 0, Kd = 0, Jd = 0, $d = 0, sp = -1, em = -1;
                                const tm = {};
                                let im = tg("");
                                if (le1.allowVerticalPlacement && ls.vertical) {
                                    const le1 = sc.layout.get("text-rotate").evaluate(Od, {}, Gd) + 90;
                                    Yd = new Zp(uc, vt, mc, gc, Ac, ls.vertical, Ec, kc, du, le1), Fl && (Qd = new Zp(uc, vt, mc, gc, Ac, Fl, Md, Ld, du, le1));
                                }
                                if (ho) {
                                    const bt = sc.layout.get("icon-rotate").evaluate(Od, {}), ls = "none" !== sc.layout.get("icon-text-fit"), Dl = qp(ho, bt, Ud, ls), Ec = Fl ? qp(Fl, bt, Ud, ls) : void 0;
                                    Zd = new Zp(uc, vt, mc, gc, Ac, ho, Md, Ld, !1, bt), Xd = 4 * Dl.length;
                                    const kc = le1.iconSizeData;
                                    let du = null;
                                    "source" === kc.kind ? (du = [
                                        Xg * sc.layout.get("icon-size").evaluate(Od, {})
                                    ], du[0] > Kg && x(`${le1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === kc.kind && (du = [
                                        Xg * jd.compositeIconSizes[0].evaluate(Od, {}, Gd),
                                        Xg * jd.compositeIconSizes[1].evaluate(Od, {}, Gd)
                                    ], (du[0] > Kg || du[1] > Kg) && x(`${le1.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), le1.addSymbols(le1.icon, Dl, du, Rd, Nd, Od, Qg.none, vt, Hd.lineStartIndex, Hd.lineLength, -1, Gd), sp = le1.icon.placedSymbolArray.length - 1, Ec && (Kd = 4 * Ec.length, le1.addSymbols(le1.icon, Ec, du, Rd, Nd, Od, Qg.vertical, vt, Hd.lineStartIndex, Hd.lineLength, -1, Gd), em = le1.icon.placedSymbolArray.length - 1);
                                }
                                const nm = Object.keys(ls.horizontal);
                                for (const Am of nm){
                                    const bt = ls.horizontal[Am];
                                    if (!Wd) {
                                        im = tg(bt.text);
                                        const le1 = sc.layout.get("text-rotate").evaluate(Od, {}, Gd);
                                        Wd = new Zp(uc, vt, mc, gc, Ac, bt, Ec, kc, du, le1);
                                    }
                                    const ho = 1 === bt.positionedLines.length;
                                    if (Jd += af(le1, vt, bt, Dl, sc, du, Od, _u, Hd, ls.vertical ? Qg.horizontal : Qg.horizontalOnly, ho ? nm : [
                                        Am
                                    ], tm, sp, jd, Gd), ho) break;
                                }
                                ls.vertical && ($d += af(le1, vt, ls.vertical, Dl, sc, du, Od, _u, Hd, Qg.vertical, [
                                    "vertical"
                                ], tm, em, jd, Gd));
                                const rm = Wd ? Wd.boxStartIndex : le1.collisionBoxArray.length, am = Wd ? Wd.boxEndIndex : le1.collisionBoxArray.length, sm = Yd ? Yd.boxStartIndex : le1.collisionBoxArray.length, om = Yd ? Yd.boxEndIndex : le1.collisionBoxArray.length, lm = Zd ? Zd.boxStartIndex : le1.collisionBoxArray.length, cm = Zd ? Zd.boxEndIndex : le1.collisionBoxArray.length, um = Qd ? Qd.boxStartIndex : le1.collisionBoxArray.length, hm = Qd ? Qd.boxEndIndex : le1.collisionBoxArray.length;
                                let dm = -1;
                                const H = (le1, vt)=>le1 && le1.circleDiameter ? Math.max(le1.circleDiameter, vt) : vt;
                                dm = H(Wd, dm), dm = H(Yd, dm), dm = H(Zd, dm), dm = H(Qd, dm);
                                const pm = dm > -1 ? 1 : 0;
                                pm && (dm *= qd / Vg), le1.glyphOffsetArray.length >= yc.MAX_GLYPHS && x("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== Od.sortKey && le1.addToSortKeyRanges(le1.symbolInstances.length, Od.sortKey);
                                const mm = rf(sc, Od, Gd), [fm, gm] = function(le1, vt) {
                                    const bt = le1.length, ls = null == vt ? void 0 : vt.values;
                                    if ((null == ls ? void 0 : ls.length) > 0) for(let ho = 0; ho < ls.length; ho += 2){
                                        const vt = ls[ho + 1];
                                        le1.emplaceBack(yA[ls[ho]], vt[0], vt[1]);
                                    }
                                    return [
                                        bt,
                                        le1.length
                                    ];
                                }(le1.textAnchorOffsets, mm);
                                le1.symbolInstances.emplaceBack(vt.x, vt.y, tm.right >= 0 ? tm.right : -1, tm.center >= 0 ? tm.center : -1, tm.left >= 0 ? tm.left : -1, tm.vertical || -1, sp, em, im, rm, am, sm, om, lm, cm, um, hm, mc, Jd, $d, Xd, Kd, pm, 0, Ec, dm, fm, gm);
                            }(le1, Ec, sc, bt, ls, ho, Xd, le1.layers[0], le1.collisionBoxArray, vt.index, vt.sourceLayerIndex, le1.index, Nd, [
                                Ud,
                                Ud,
                                Ud,
                                Ud
                            ], Hd, mc, Od, Gd, Wd, _u, vt, Dl, gc, Ac, Fl);
                        };
                        if ("line" === Zd) for (const Jd of function(le1, vt, bt, ls, ho) {
                            const Dl = [];
                            for(let Fl = 0; Fl < le1.length; Fl++){
                                const vt = le1[Fl];
                                let bt;
                                for(let le1 = 0; le1 < vt.length - 1; le1++){
                                    let Fl = vt[le1], sc = vt[le1 + 1];
                                    Fl.x < 0 && sc.x < 0 || (Fl.x < 0 ? Fl = new t(0, Fl.y + (0 - Fl.x) / (sc.x - Fl.x) * (sc.y - Fl.y))._round() : sc.x < 0 && (sc = new t(0, Fl.y + (0 - Fl.x) / (sc.x - Fl.x) * (sc.y - Fl.y))._round()), Fl.y < 0 && sc.y < 0 || (Fl.y < 0 ? Fl = new t(Fl.x + (0 - Fl.y) / (sc.y - Fl.y) * (sc.x - Fl.x), 0)._round() : sc.y < 0 && (sc = new t(Fl.x + (0 - Fl.y) / (sc.y - Fl.y) * (sc.x - Fl.x), 0)._round()), Fl.x >= ls && sc.x >= ls || (Fl.x >= ls ? Fl = new t(ls, Fl.y + (ls - Fl.x) / (sc.x - Fl.x) * (sc.y - Fl.y))._round() : sc.x >= ls && (sc = new t(ls, Fl.y + (ls - Fl.x) / (sc.x - Fl.x) * (sc.y - Fl.y))._round()), Fl.y >= ho && sc.y >= ho || (Fl.y >= ho ? Fl = new t(Fl.x + (ho - Fl.y) / (sc.y - Fl.y) * (sc.x - Fl.x), ho)._round() : sc.y >= ho && (sc = new t(Fl.x + (ho - Fl.y) / (sc.y - Fl.y) * (sc.x - Fl.x), ho)._round()), bt && Fl.equals(bt[bt.length - 1]) || (bt = [
                                        Fl
                                    ], Dl.push(bt)), bt.push(sc)))));
                                }
                            }
                            return Dl;
                        }(vt.geometry, 0, 0, uc, uc)){
                            const vt = Sl(Jd, Kd), ho = Cp(vt, jd, qd, bt.vertical || Md, ls, 24, Rd, le1.overscaling, uc);
                            for (const bt of ho)Md && uf(le1, Md.text, Yd, bt) || B(vt, bt);
                        }
                        else if ("line-center" === Zd) {
                            for (const uc of vt.geometry)if (uc.length > 1) {
                                const le1 = Sl(uc, Kd), vt = Bp(le1, qd, bt.vertical || Md, ls, 24, Rd);
                                vt && B(le1, vt);
                            }
                        } else if ("Polygon" === vt.type) for (const uc of Kt(vt.geometry, 0)){
                            const le1 = Wp(uc, 16);
                            B(Sl(uc[0], Kd, !0), new Mp(le1.x, le1.y, 0));
                        }
                        else if ("LineString" === vt.type) for (const uc of vt.geometry){
                            const le1 = Sl(uc, Kd);
                            B(le1, new Mp(le1[0].x, le1[0].y, 0));
                        }
                        else if ("Point" === vt.type) for (const uc of vt.geometry)for (const le1 of uc)B([
                            le1
                        ], new Mp(le1.x, le1.y, 0));
                    }
                    function af(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du) {
                        const _u = function(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = ls.layout.get("text-rotate").evaluate(Dl, {}) * Math.PI / 180, mc = [];
                            for (const gc of vt.positionedLines)for (const le1 of gc.positionedGlyphs){
                                if (!le1.rect) continue;
                                const ls = le1.rect || {};
                                let Dl = 4, Ac = !0, Ec = 1, kc = 0;
                                const du = (ho || sc) && le1.vertical, _u = le1.metrics.advance * le1.scale / 2;
                                if (sc && vt.verticalizable && (kc = gc.lineOffset / 2 - (le1.imageName ? -(Vg - le1.metrics.width * le1.scale) / 2 : (le1.scale - 1) * Vg)), le1.imageName) {
                                    const vt = Fl[le1.imageName];
                                    Ac = vt.sdf, Ec = vt.pixelRatio, Dl = 1 / Ec;
                                }
                                const Md = ho ? [
                                    le1.x + _u,
                                    le1.y
                                ] : [
                                    0,
                                    0
                                ];
                                let Ld = ho ? [
                                    0,
                                    0
                                ] : [
                                    le1.x + _u + bt[0],
                                    le1.y + bt[1] - kc
                                ], Nd = [
                                    0,
                                    0
                                ];
                                du && (Nd = Ld, Ld = [
                                    0,
                                    0
                                ]);
                                const Rd = le1.metrics.isDoubleResolution ? 2 : 1, Od = (le1.metrics.left - Dl) * le1.scale - _u + Ld[0], jd = (-le1.metrics.top - Dl) * le1.scale + Ld[1], Ud = Od + ls.w / Rd * le1.scale / Ec, Gd = jd + ls.h / Rd * le1.scale / Ec, qd = new t(Od, jd), Hd = new t(Ud, jd), Wd = new t(Od, Gd), Zd = new t(Ud, Gd);
                                if (du) {
                                    const vt = new t(-_u, _u - -17), bt = -Math.PI / 2, ls = 12 - _u, ho = new t(22 - ls, -(le1.imageName ? ls : 0)), Dl = new t(...Nd);
                                    qd._rotateAround(bt, vt)._add(ho)._add(Dl), Hd._rotateAround(bt, vt)._add(ho)._add(Dl), Wd._rotateAround(bt, vt)._add(ho)._add(Dl), Zd._rotateAround(bt, vt)._add(ho)._add(Dl);
                                }
                                if (uc) {
                                    const le1 = Math.sin(uc), vt = Math.cos(uc), bt = [
                                        vt,
                                        -le1,
                                        le1,
                                        vt
                                    ];
                                    qd._matMult(bt), Hd._matMult(bt), Wd._matMult(bt), Zd._matMult(bt);
                                }
                                const Yd = new t(0, 0), Qd = new t(0, 0);
                                mc.push({
                                    tl: qd,
                                    tr: Hd,
                                    bl: Wd,
                                    br: Zd,
                                    tex: ls,
                                    writingMode: vt.writingMode,
                                    glyphOffset: Md,
                                    sectionIndex: le1.sectionIndex,
                                    isSDF: Ac,
                                    pixelOffsetTL: Yd,
                                    pixelOffsetBR: Qd,
                                    minFontScaleX: 0,
                                    minFontScaleY: 0
                                });
                            }
                            return mc;
                        }(0, bt, sc, ho, Dl, Fl, ls, le1.allowVerticalPlacement), Md = le1.textSizeData;
                        let Ld = null;
                        "source" === Md.kind ? (Ld = [
                            Xg * ho.layout.get("text-size").evaluate(Fl, {})
                        ], Ld[0] > Kg && x(`${le1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === Md.kind && (Ld = [
                            Xg * kc.compositeTextSizes[0].evaluate(Fl, {}, du),
                            Xg * kc.compositeTextSizes[1].evaluate(Fl, {}, du)
                        ], (Ld[0] > Kg || Ld[1] > Kg) && x(`${le1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), le1.addSymbols(le1.text, _u, Ld, sc, Dl, Fl, mc, vt, uc.lineStartIndex, uc.lineLength, Ec, du);
                        for (const Nd of gc)Ac[Nd] = le1.text.placedSymbolArray.length - 1;
                        return 4 * _u.length;
                    }
                    function lf(le1) {
                        for(const vt in le1)return le1[vt];
                        return null;
                    }
                    function uf(le1, vt, bt, ls) {
                        const ho = le1.compareText;
                        if (vt in ho) {
                            const le1 = ho[vt];
                            for(let vt = le1.length - 1; vt >= 0; vt--)if (ls.dist(le1[vt]) < bt) return !0;
                        } else ho[vt] = [];
                        return ho[vt].push(ls), !1;
                    }
                    class cf {
                        constructor(le1){
                            const vt = {}, bt = [];
                            for(const Fl in le1){
                                const ls = le1[Fl], ho = vt[Fl] = {};
                                for(const le1 in ls){
                                    const vt = ls[+le1];
                                    if (!vt || 0 === vt.bitmap.width || 0 === vt.bitmap.height) continue;
                                    const Dl = {
                                        x: 0,
                                        y: 0,
                                        w: vt.bitmap.width + 2,
                                        h: vt.bitmap.height + 2
                                    };
                                    bt.push(Dl), ho[le1] = {
                                        rect: Dl,
                                        metrics: vt.metrics
                                    };
                                }
                            }
                            const { w: ls, h: ho } = Gu(bt), Dl = new Ma({
                                width: ls || 1,
                                height: ho || 1
                            });
                            for(const Fl in le1){
                                const bt = le1[Fl];
                                for(const le1 in bt){
                                    const ls = bt[+le1];
                                    if (!ls || 0 === ls.bitmap.width || 0 === ls.bitmap.height) continue;
                                    const ho = vt[Fl][le1].rect;
                                    Ma.copy(ls.bitmap, Dl, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: ho.x + 1,
                                        y: ho.y + 1
                                    }, ls.bitmap);
                                }
                            }
                            this.image = Dl, this.positions = vt;
                        }
                    }
                    function hf(le1, vt, bt) {
                        var ls = 2 * Math.PI * 6378137 / 256 / Math.pow(2, bt);
                        return [
                            le1 * ls - 2 * Math.PI * 6378137 / 2,
                            vt * ls - 2 * Math.PI * 6378137 / 2
                        ];
                    }
                    pi("GlyphAtlas", cf);
                    const xA = 6371008.8;
                    class ff {
                        constructor(le1, vt){
                            if (isNaN(le1) || isNaN(vt)) throw new Error(`Invalid LngLat object: (${le1}, ${vt})`);
                            if (this.lng = +le1, this.lat = +vt, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                        }
                        wrap() {
                            return new ff(function(le1, vt) {
                                const bt = ((le1 - vt) % 360 + 360) % 360 + vt;
                                return bt === vt ? 180 : bt;
                            }(this.lng, -180), this.lat);
                        }
                        toArray() {
                            return [
                                this.lng,
                                this.lat
                            ];
                        }
                        toString() {
                            return `LngLat(${this.lng}, ${this.lat})`;
                        }
                        distanceTo(le1) {
                            const vt = Math.PI / 180, bt = this.lat * vt, ls = le1.lat * vt, ho = Math.sin(bt) * Math.sin(ls) + Math.cos(bt) * Math.cos(ls) * Math.cos((le1.lng - this.lng) * vt);
                            return xA * Math.acos(Math.min(ho, 1));
                        }
                        static convert(le1) {
                            if (le1 instanceof ff) return le1;
                            if (Array.isArray(le1) && (2 === le1.length || 3 === le1.length)) return new ff(Number(le1[0]), Number(le1[1]));
                            if (!Array.isArray(le1) && "object" == typeof le1 && null !== le1) return new ff(Number("lng" in le1 ? le1.lng : le1.lon), Number(le1.lat));
                            throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                        }
                    }
                    const bA = 2 * Math.PI * xA;
                    function yf(le1) {
                        return bA * Math.cos(le1 * Math.PI / 180);
                    }
                    function mf(le1) {
                        return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * le1) * Math.PI / 180)) - 90;
                    }
                    class gf {
                        constructor(le1, vt, bt){
                            void 0 === bt && (bt = 0), this.x = +le1, this.y = +vt, this.z = +bt;
                        }
                        static fromLngLat(le1, vt) {
                            void 0 === vt && (vt = 0);
                            const bt = ff.convert(le1);
                            return new gf((180 + bt.lng) / 360, (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + bt.lat * Math.PI / 360))) / 360, function(le1, vt) {
                                return le1 / yf(vt);
                            }(vt, bt.lat));
                        }
                        toLngLat() {
                            return new ff(360 * this.x - 180, mf(this.y));
                        }
                        toAltitude() {
                            return this.z * yf(mf(this.y));
                        }
                        meterInMercatorCoordinateUnits() {
                            var le1;
                            return 1 / bA * (le1 = mf(this.y), 1 / Math.cos(le1 * Math.PI / 180));
                        }
                    }
                    class xf {
                        constructor(le1, vt, bt){
                            if (!function(le1, vt, bt) {
                                return !(le1 < 0 || le1 > 25 || bt < 0 || bt >= Math.pow(2, le1) || vt < 0 || vt >= Math.pow(2, le1));
                            }(le1, vt, bt)) throw new Error(`x=${vt}, y=${bt}, z=${le1} outside of bounds. 0<=x<${Math.pow(2, le1)}, 0<=y<${Math.pow(2, le1)} 0<=z<=25 `);
                            this.z = le1, this.x = vt, this.y = bt, this.key = wf(0, le1, le1, vt, bt);
                        }
                        equals(le1) {
                            return this.z === le1.z && this.x === le1.x && this.y === le1.y;
                        }
                        url(le1, vt, bt) {
                            const ls = (Dl = this.y, Fl = this.z, sc = hf(256 * (ho = this.x), 256 * (Dl = Math.pow(2, Fl) - Dl - 1), Fl), uc = hf(256 * (ho + 1), 256 * (Dl + 1), Fl), sc[0] + "," + sc[1] + "," + uc[0] + "," + uc[1]);
                            var ho, Dl, Fl, sc, uc;
                            const mc = function(le1, vt, bt) {
                                let ls, ho = "";
                                for(let Dl = le1; Dl > 0; Dl--)ls = 1 << Dl - 1, ho += (vt & ls ? 1 : 0) + (bt & ls ? 2 : 0);
                                return ho;
                            }(this.z, this.x, this.y);
                            return le1[(this.x + this.y) % le1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === bt ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, vt > 1 ? "@2x" : "").replace(/{quadkey}/g, mc).replace(/{bbox-epsg-3857}/g, ls);
                        }
                        isChildOf(le1) {
                            const vt = this.z - le1.z;
                            return vt > 0 && le1.x === this.x >> vt && le1.y === this.y >> vt;
                        }
                        getTilePoint(le1) {
                            const vt = Math.pow(2, this.z);
                            return new t((le1.x * vt - this.x) * uc, (le1.y * vt - this.y) * uc);
                        }
                        toString() {
                            return `${this.z}/${this.x}/${this.y}`;
                        }
                    }
                    class vf {
                        constructor(le1, vt){
                            this.wrap = le1, this.canonical = vt, this.key = wf(le1, vt.z, vt.z, vt.x, vt.y);
                        }
                    }
                    class bf {
                        constructor(le1, vt, bt, ls, ho){
                            if (this.terrainRttPosMatrix32f = null, le1 < bt) throw new Error(`overscaledZ should be >= z; overscaledZ = ${le1}; z = ${bt}`);
                            this.overscaledZ = le1, this.wrap = vt, this.canonical = new xf(bt, +ls, +ho), this.key = wf(vt, le1, bt, ls, ho);
                        }
                        clone() {
                            return new bf(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        equals(le1) {
                            return this.overscaledZ === le1.overscaledZ && this.wrap === le1.wrap && this.canonical.equals(le1.canonical);
                        }
                        scaledTo(le1) {
                            if (le1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${le1}; overscaledZ = ${this.overscaledZ}`);
                            const vt = this.canonical.z - le1;
                            return le1 > this.canonical.z ? new bf(le1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new bf(le1, this.wrap, le1, this.canonical.x >> vt, this.canonical.y >> vt);
                        }
                        isOverscaled() {
                            return this.overscaledZ > this.canonical.z;
                        }
                        calculateScaledKey(le1, vt) {
                            if (le1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${le1}; overscaledZ = ${this.overscaledZ}`);
                            const bt = this.canonical.z - le1;
                            return le1 > this.canonical.z ? wf(this.wrap * +vt, le1, this.canonical.z, this.canonical.x, this.canonical.y) : wf(this.wrap * +vt, le1, le1, this.canonical.x >> bt, this.canonical.y >> bt);
                        }
                        isChildOf(le1) {
                            if (le1.wrap !== this.wrap) return !1;
                            if (this.overscaledZ - le1.overscaledZ <= 0) return !1;
                            if (0 === le1.overscaledZ) return this.overscaledZ > 0;
                            const vt = this.canonical.z - le1.canonical.z;
                            return !(vt < 0) && le1.canonical.x === this.canonical.x >> vt && le1.canonical.y === this.canonical.y >> vt;
                        }
                        children(le1) {
                            if (this.overscaledZ >= le1) return [
                                new bf(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                            ];
                            const vt = this.canonical.z + 1, bt = 2 * this.canonical.x, ls = 2 * this.canonical.y;
                            return [
                                new bf(vt, this.wrap, vt, bt, ls),
                                new bf(vt, this.wrap, vt, bt + 1, ls),
                                new bf(vt, this.wrap, vt, bt, ls + 1),
                                new bf(vt, this.wrap, vt, bt + 1, ls + 1)
                            ];
                        }
                        isLessThan(le1) {
                            return this.wrap < le1.wrap || !(this.wrap > le1.wrap) && (this.overscaledZ < le1.overscaledZ || !(this.overscaledZ > le1.overscaledZ) && (this.canonical.x < le1.canonical.x || !(this.canonical.x > le1.canonical.x) && this.canonical.y < le1.canonical.y));
                        }
                        wrapped() {
                            return new bf(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        unwrapTo(le1) {
                            return new bf(this.overscaledZ, le1, this.canonical.z, this.canonical.x, this.canonical.y);
                        }
                        overscaleFactor() {
                            return Math.pow(2, this.overscaledZ - this.canonical.z);
                        }
                        toUnwrapped() {
                            return new vf(this.wrap, this.canonical);
                        }
                        toString() {
                            return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                        }
                        getTilePoint(le1) {
                            return this.canonical.getTilePoint(new gf(le1.x - this.wrap, le1.y));
                        }
                    }
                    function wf(le1, vt, bt, ls, ho) {
                        (le1 *= 2) < 0 && (le1 = -1 * le1 - 1);
                        const Dl = 1 << bt;
                        return (Dl * Dl * le1 + Dl * ho + ls).toString(36) + bt.toString(36) + vt.toString(36);
                    }
                    pi("CanonicalTileID", xf), pi("OverscaledTileID", bf, {
                        omit: [
                            "terrainRttPosMatrix32f"
                        ]
                    });
                    class _f {
                        constructor(le1){
                            this.tileID = new bf(le1.tileID.overscaledZ, le1.tileID.wrap, le1.tileID.canonical.z, le1.tileID.canonical.x, le1.tileID.canonical.y), this.uid = le1.uid, this.zoom = le1.zoom, this.pixelRatio = le1.pixelRatio, this.tileSize = le1.tileSize, this.source = le1.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = le1.showCollisionBoxes, this.collectResourceTiming = !!le1.collectResourceTiming, this.returnDependencies = !!le1.returnDependencies, this.promoteId = le1.promoteId, this.inFlightDependencies = [];
                        }
                        parse(le1, vt, bt, ls, ho) {
                            return e(this, void 0, void 0, function*() {
                                this.status = "parsing", this.data = le1, this.collisionBoxArray = new Os;
                                const Dl = new Rc(Object.keys(le1.layers).sort()), Fl = new Ip(this.tileID, this.promoteId);
                                Fl.bucketLayerIDs = [];
                                const sc = {}, uc = {
                                    featureIndex: Fl,
                                    iconDependencies: {},
                                    patternDependencies: {},
                                    glyphDependencies: {},
                                    dashDependencies: {},
                                    availableImages: bt,
                                    subdivisionGranularity: ho
                                }, mc = vt.familiesBySource[this.source];
                                for(const vt in mc){
                                    const ls = le1.layers[vt];
                                    if (!ls) continue;
                                    1 === ls.version && x(`Vector tile source "${this.source}" layer "${vt}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                    const ho = Dl.encode(vt), gc = [];
                                    for(let le1 = 0; le1 < ls.length; le1++){
                                        const bt = ls.feature(le1), Dl = Fl.getId(bt, vt);
                                        gc.push({
                                            feature: bt,
                                            id: Dl,
                                            index: le1,
                                            sourceLayerIndex: ho
                                        });
                                    }
                                    for (const le1 of mc[vt]){
                                        const vt = le1[0];
                                        vt.source !== this.source && x(`layer.source = ${vt.source} does not equal this.source = ${this.source}`), vt.isHidden(this.zoom, !0) || (Sf(le1, this.zoom, bt), (sc[vt.id] = vt.createBucket({
                                            index: Fl.bucketLayerIDs.length,
                                            layers: le1,
                                            zoom: this.zoom,
                                            pixelRatio: this.pixelRatio,
                                            overscaling: this.overscaling,
                                            collisionBoxArray: this.collisionBoxArray,
                                            sourceLayerIndex: ho,
                                            sourceID: this.source
                                        })).populate(gc, uc, this.tileID.canonical), Fl.bucketLayerIDs.push(le1.map((le1)=>le1.id)));
                                    }
                                }
                                const gc = y(uc.glyphDependencies, (le1)=>Object.keys(le1).map(Number));
                                this.inFlightDependencies.forEach((le1)=>null == le1 ? void 0 : le1.abort()), this.inFlightDependencies = [];
                                let Ac = Promise.resolve({});
                                if (Object.keys(gc).length) {
                                    const le1 = new AbortController;
                                    this.inFlightDependencies.push(le1), Ac = ls.sendAsync({
                                        type: "GG",
                                        data: {
                                            stacks: gc,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "glyphs"
                                        }
                                    }, le1);
                                }
                                const Ec = Object.keys(uc.iconDependencies);
                                let kc = Promise.resolve({});
                                if (Ec.length) {
                                    const le1 = new AbortController;
                                    this.inFlightDependencies.push(le1), kc = ls.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: Ec,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "icons"
                                        }
                                    }, le1);
                                }
                                const du = Object.keys(uc.patternDependencies);
                                let _u = Promise.resolve({});
                                if (du.length) {
                                    const le1 = new AbortController;
                                    this.inFlightDependencies.push(le1), _u = ls.sendAsync({
                                        type: "GI",
                                        data: {
                                            icons: du,
                                            source: this.source,
                                            tileID: this.tileID,
                                            type: "patterns"
                                        }
                                    }, le1);
                                }
                                const Md = uc.dashDependencies;
                                let Ld = Promise.resolve({});
                                if (Object.keys(Md).length) {
                                    const le1 = new AbortController;
                                    this.inFlightDependencies.push(le1), Ld = ls.sendAsync({
                                        type: "GDA",
                                        data: {
                                            dashes: Md
                                        }
                                    }, le1);
                                }
                                const [Nd, Rd, Od, jd] = yield Promise.all([
                                    Ac,
                                    kc,
                                    _u,
                                    Ld
                                ]), Ud = new cf(Nd), Gd = new Xu(Rd, Od);
                                for(const le1 in sc){
                                    const vt = sc[le1];
                                    vt instanceof yc ? (Sf(vt.layers, this.zoom, bt), nf({
                                        bucket: vt,
                                        glyphMap: Nd,
                                        glyphPositions: Ud.positions,
                                        imageMap: Rd,
                                        imagePositions: Gd.iconPositions,
                                        showCollisionBoxes: this.showCollisionBoxes,
                                        canonical: this.tileID.canonical,
                                        subdivisionGranularity: uc.subdivisionGranularity
                                    })) : vt.hasDependencies && (vt instanceof kl || vt instanceof jl || vt instanceof ou) && (Sf(vt.layers, this.zoom, bt), vt.addFeatures(uc, this.tileID.canonical, Gd.patternPositions, jd));
                                }
                                return this.status = "done", {
                                    buckets: Object.values(sc).filter((le1)=>!le1.isEmpty()),
                                    featureIndex: Fl,
                                    collisionBoxArray: this.collisionBoxArray,
                                    glyphAtlasImage: Ud.image,
                                    imageAtlas: Gd,
                                    dashPositions: jd,
                                    glyphMap: this.returnDependencies ? Nd : null,
                                    iconMap: this.returnDependencies ? Rd : null,
                                    glyphPositions: this.returnDependencies ? Ud.positions : null
                                };
                            });
                        }
                    }
                    function Sf(le1, vt, bt) {
                        const ls = new Gi(vt);
                        for (const ho of le1)ho.recalculate(ls, bt);
                    }
                    class Af {
                        constructor(le1){
                            this.maxEntries = le1, this.map = new Map;
                        }
                        get(le1) {
                            const vt = this.map.get(le1);
                            return void 0 !== vt && (this.map.delete(le1), this.map.set(le1, vt)), vt;
                        }
                        set(le1, vt) {
                            if (this.map.has(le1)) this.map.delete(le1);
                            else if (this.map.size >= this.maxEntries) {
                                const le1 = this.map.keys().next().value;
                                this.map.delete(le1);
                            }
                            this.map.set(le1, vt);
                        }
                        clear() {
                            this.map.clear();
                        }
                    }
                    var wA, EA, MA;
                    !function(le1) {
                        le1.create = "create", le1.load = "load", le1.fullLoad = "fullLoad";
                    }(wA || (wA = {}));
                    class Ef {
                        constructor(le1){
                            this._marks = {
                                start: [
                                    le1.url,
                                    "start"
                                ].join("#"),
                                end: [
                                    le1.url,
                                    "end"
                                ].join("#"),
                                measure: le1.url.toString()
                            }, performance.mark(this._marks.start);
                        }
                        finish() {
                            performance.mark(this._marks.end);
                            let le1 = performance.getEntriesByName(this._marks.measure);
                            return 0 === le1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), le1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), le1;
                        }
                    }
                    class Mf {
                        constructor(le1, vt, bt, ls, ho){
                            this.type = le1, this.properties = bt || {}, this.extent = ho, this.pointsArray = vt, this.id = ls;
                        }
                        loadGeometry() {
                            return this.pointsArray.map((le1)=>le1.map((le1)=>new t(le1.x, le1.y)));
                        }
                    }
                    class Df {
                        constructor(le1, vt, bt){
                            this.version = 2, this._myFeatures = le1, this.name = vt, this.length = le1.length, this.extent = bt;
                        }
                        feature(le1) {
                            return this._myFeatures[le1];
                        }
                    }
                    class Pf {
                        constructor(){
                            this.layers = {};
                        }
                        addLayer(le1) {
                            this.layers[le1.name] = le1;
                        }
                    }
                    function zf(le1) {
                        let vt = function(le1) {
                            const vt = new zu;
                            return function(le1, vt) {
                                for(const bt in le1.layers)vt.writeMessage(3, xp, le1.layers[bt]);
                            }(le1, vt), vt.finish();
                        }(le1);
                        return 0 === vt.byteOffset && vt.byteLength === vt.buffer.byteLength || (vt = new Uint8Array(vt)), {
                            vectorTile: le1,
                            rawData: vt.buffer
                        };
                    }
                    function Ff(le1, vt, bt) {
                        const { extent: ls } = le1, ho = Math.pow(2, bt.z - vt.z), Dl = (bt.x - vt.x * ho) * ls, Fl = (bt.y - vt.y * ho) * ls, sc = [];
                        for(let uc = 0; uc < le1.length; uc++){
                            const vt = le1.feature(uc);
                            let bt = vt.loadGeometry();
                            for (const le1 of bt)for (const vt of le1)vt.x = vt.x * ho - Dl, vt.y = vt.y * ho - Fl;
                            const mc = 128;
                            bt = Lp(bt, vt.type, -mc, -mc, ls + mc, ls + mc), 0 !== bt.length && sc.push(new Mf(vt.type, bt, vt.properties, vt.id, ls));
                        }
                        return new Df(sc, le1.name, ls);
                    }
                    class Bf {
                        constructor(le1, vt, bt){
                            this.actor = le1, this.layerIndex = vt, this.availableImages = bt, this.fetching = {}, this.loading = {}, this.loaded = {}, this.overzoomedTileResultCache = new Af(1e3);
                        }
                        loadVectorTile(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                const bt = yield ((le1, vt)=>ci(d(le1, {
                                        type: "arrayBuffer"
                                    }), vt))(le1.request, vt);
                                try {
                                    return {
                                        vectorTile: "mlt" !== le1.encoding ? new $l(new zu(bt.data)) : new fp(bt.data),
                                        rawData: bt.data,
                                        cacheControl: bt.cacheControl,
                                        expires: bt.expires
                                    };
                                } catch (vt) {
                                    const ho = new Uint8Array(bt.data);
                                    let Dl = `Unable to parse the tile at ${le1.request.url}, `;
                                    throw Dl += 31 === ho[0] && 139 === ho[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${vt.message}`, new Error(Dl);
                                }
                            });
                        }
                        loadTile(le1) {
                            return e(this, void 0, void 0, function*() {
                                const { uid: vt, overzoomParameters: bt } = le1;
                                bt && (le1.request = bt.overzoomRequest);
                                const ls = !!(le1 && le1.request && le1.request.collectResourceTiming) && new Ef(le1.request), ho = new _f(le1);
                                this.loading[vt] = ho;
                                const Dl = new AbortController;
                                ho.abort = Dl;
                                try {
                                    const Fl = yield this.loadVectorTile(le1, Dl);
                                    if (delete this.loading[vt], !Fl) return null;
                                    if (bt) {
                                        const vt = this._getOverzoomTile(le1, Fl.vectorTile);
                                        Fl.rawData = vt.rawData, Fl.vectorTile = vt.vectorTile;
                                    }
                                    const sc = Fl.rawData, uc = {};
                                    Fl.expires && (uc.expires = Fl.expires), Fl.cacheControl && (uc.cacheControl = Fl.cacheControl);
                                    const mc = {};
                                    if (ls) {
                                        const le1 = ls.finish();
                                        le1 && (mc.resourceTiming = JSON.parse(JSON.stringify(le1)));
                                    }
                                    ho.vectorTile = Fl.vectorTile;
                                    const gc = ho.parse(Fl.vectorTile, this.layerIndex, this.availableImages, this.actor, le1.subdivisionGranularity);
                                    this.loaded[vt] = ho, this.fetching[vt] = {
                                        rawTileData: sc,
                                        cacheControl: uc,
                                        resourceTiming: mc
                                    };
                                    try {
                                        const vt = yield gc;
                                        return d({
                                            rawTileData: sc.slice(0),
                                            encoding: le1.encoding
                                        }, vt, uc, mc);
                                    } finally{
                                        delete this.fetching[vt];
                                    }
                                } catch (le1) {
                                    throw delete this.loading[vt], ho.status = "done", this.loaded[vt] = ho, le1;
                                }
                            });
                        }
                        _getOverzoomTile(le1, vt) {
                            const { tileID: bt, source: ls, overzoomParameters: ho } = le1, { maxZoomTileID: Dl } = ho, Fl = `${Dl.key}_${bt.key}`, sc = this.overzoomedTileResultCache.get(Fl);
                            if (sc) return sc;
                            const uc = new Pf, mc = this.layerIndex.familiesBySource[ls];
                            for(const Ac in mc){
                                const le1 = vt.layers[Ac];
                                if (!le1) continue;
                                const ls = Ff(le1, Dl, bt.canonical);
                                ls.length > 0 && uc.addLayer(ls);
                            }
                            const gc = zf(uc);
                            return this.overzoomedTileResultCache.set(Fl, gc), gc;
                        }
                        reloadTile(le1) {
                            return e(this, void 0, void 0, function*() {
                                const vt = le1.uid;
                                if (!this.loaded || !this.loaded[vt]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                const bt = this.loaded[vt];
                                if (bt.showCollisionBoxes = le1.showCollisionBoxes, "parsing" === bt.status) {
                                    const ls = yield bt.parse(bt.vectorTile, this.layerIndex, this.availableImages, this.actor, le1.subdivisionGranularity);
                                    let ho;
                                    if (this.fetching[vt]) {
                                        const { rawTileData: bt, cacheControl: Dl, resourceTiming: Fl } = this.fetching[vt];
                                        delete this.fetching[vt], ho = d({
                                            rawTileData: bt.slice(0),
                                            encoding: le1.encoding
                                        }, ls, Dl, Fl);
                                    } else ho = ls;
                                    return ho;
                                }
                                if ("done" === bt.status && bt.vectorTile) return bt.parse(bt.vectorTile, this.layerIndex, this.availableImages, this.actor, le1.subdivisionGranularity);
                            });
                        }
                        abortTile(le1) {
                            return e(this, void 0, void 0, function*() {
                                const vt = this.loading, bt = le1.uid;
                                vt && vt[bt] && vt[bt].abort && (vt[bt].abort.abort(), delete vt[bt]);
                            });
                        }
                        removeTile(le1) {
                            return e(this, void 0, void 0, function*() {
                                this.loaded && this.loaded[le1.uid] && delete this.loaded[le1.uid];
                            });
                        }
                    }
                    class Cf {
                        constructor(){
                            this.loaded = {};
                        }
                        loadTile(le1) {
                            return e(this, void 0, void 0, function*() {
                                const { uid: vt, encoding: bt, rawImageData: ls, redFactor: Fl, greenFactor: sc, blueFactor: uc, baseShift: mc } = le1, Ec = ls.width + 2, kc = ls.height + 2, du = w(ls) ? new Da({
                                    width: Ec,
                                    height: kc
                                }, (yield function(le1, vt, bt, ls, Fl) {
                                    return e(this, void 0, void 0, function*() {
                                        if (function() {
                                            if (null == Dl && (Dl = !1, null == ho && (ho = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), ho)) {
                                                const le1 = 5, vt = new OffscreenCanvas(le1, le1).getContext("2d", {
                                                    willReadFrequently: !0
                                                });
                                                if (vt) {
                                                    for(let ls = 0; ls < le1 * le1; ls++){
                                                        const bt = 4 * ls;
                                                        vt.fillStyle = `rgb(${bt},${bt + 1},${bt + 2})`, vt.fillRect(ls % le1, Math.floor(ls / le1), 1, 1);
                                                    }
                                                    const bt = vt.getImageData(0, 0, le1, le1).data;
                                                    for(let vt = 0; vt < le1 * le1 * 4; vt++)if (vt % 4 != 3 && bt[vt] !== vt) {
                                                        Dl = !0;
                                                        break;
                                                    }
                                                }
                                            }
                                            return Dl || !1;
                                        }()) try {
                                            return yield function(le1, vt, bt, ls, ho) {
                                                return e(this, void 0, void 0, function*() {
                                                    if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                                                    const vt = new VideoFrame(le1, {
                                                        timestamp: 0
                                                    });
                                                    try {
                                                        const bt = null == vt ? void 0 : vt.format;
                                                        if (!bt || !bt.startsWith("BGR") && !bt.startsWith("RGB")) throw new Error(`Unrecognized format ${bt}`);
                                                        const Dl = bt.startsWith("BGR"), Fl = new Uint8ClampedArray(ls * ho * 4);
                                                        if (yield vt.copyTo(Fl, function(le1, vt, bt, ls, ho) {
                                                            const Dl = 4 * Math.max(1, 0), Fl = (Math.max(0, -1) - -1) * ls * 4 + Dl, sc = 4 * ls, uc = Math.max(0, -1), mc = Math.max(0, -1);
                                                            return {
                                                                rect: {
                                                                    x: uc,
                                                                    y: mc,
                                                                    width: Math.min(le1.width, -1 + ls) - uc,
                                                                    height: Math.min(le1.height, -1 + ho) - mc
                                                                },
                                                                layout: [
                                                                    {
                                                                        offset: Fl,
                                                                        stride: sc
                                                                    }
                                                                ]
                                                            };
                                                        }(le1, 0, 0, ls, ho)), Dl) for(let le1 = 0; le1 < Fl.length; le1 += 4){
                                                            const vt = Fl[le1];
                                                            Fl[le1] = Fl[le1 + 2], Fl[le1 + 2] = vt;
                                                        }
                                                        return Fl;
                                                    } finally{
                                                        vt.close();
                                                    }
                                                });
                                            }(le1, 0, 0, ls, Fl);
                                        } catch (e) {}
                                        return function(le1, vt, bt, ls, ho) {
                                            const Dl = le1.width, Fl = le1.height;
                                            gc && Ac || (gc = new OffscreenCanvas(Dl, Fl), Ac = gc.getContext("2d", {
                                                willReadFrequently: !0
                                            })), gc.width = Dl, gc.height = Fl, Ac.drawImage(le1, 0, 0, Dl, Fl);
                                            const sc = Ac.getImageData(-1, -1, ls, ho);
                                            return Ac.clearRect(0, 0, Dl, Fl), sc.data;
                                        }(le1, 0, 0, ls, Fl);
                                    });
                                }(ls, 0, 0, Ec, kc))) : ls, _u = new Ra(vt, du, bt, Fl, sc, uc, mc);
                                return this.loaded = this.loaded || {}, this.loaded[vt] = _u, _u;
                            });
                        }
                        removeTile(le1) {
                            const vt = this.loaded, bt = le1.uid;
                            vt && vt[bt] && delete vt[bt];
                        }
                    }
                    var SA = function() {
                        if (MA) return EA;
                        function e(le1, vt) {
                            if (0 !== le1.length) {
                                t(le1[0], vt);
                                for(var bt = 1; bt < le1.length; bt++)t(le1[bt], !vt);
                            }
                        }
                        function t(le1, vt) {
                            for(var bt = 0, ls = 0, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++){
                                var sc = (le1[ho][0] - le1[Fl][0]) * (le1[Fl][1] + le1[ho][1]), uc = bt + sc;
                                ls += Math.abs(bt) >= Math.abs(sc) ? bt - uc + sc : sc - uc + bt, bt = uc;
                            }
                            bt + ls >= 0 != !!vt && le1.reverse();
                        }
                        return MA = 1, EA = function t(le1, vt) {
                            var bt, ls = le1 && le1.type;
                            if ("FeatureCollection" === ls) for(bt = 0; bt < le1.features.length; bt++)t(le1.features[bt], vt);
                            else if ("GeometryCollection" === ls) for(bt = 0; bt < le1.geometries.length; bt++)t(le1.geometries[bt], vt);
                            else if ("Feature" === ls) t(le1.geometry, vt);
                            else if ("Polygon" === ls) e(le1.coordinates, vt);
                            else if ("MultiPolygon" === ls) for(bt = 0; bt < le1.coordinates.length; bt++)e(le1.coordinates[bt], vt);
                            return le1;
                        };
                    }(), TA = r(SA);
                    const kA = [
                        Int8Array,
                        Uint8Array,
                        Uint8ClampedArray,
                        Int16Array,
                        Uint16Array,
                        Int32Array,
                        Uint32Array,
                        Float32Array,
                        Float64Array
                    ];
                    class Rf {
                        static from(le1) {
                            if (!(le1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                            const [vt, bt] = new Uint8Array(le1, 0, 2);
                            if (219 !== vt) throw new Error("Data does not appear to be in a KDBush format.");
                            const ls = bt >> 4;
                            if (1 !== ls) throw new Error(`Got v${ls} data when expected v1.`);
                            const ho = kA[15 & bt];
                            if (!ho) throw new Error("Unrecognized array type.");
                            const [Dl] = new Uint16Array(le1, 2, 1), [Fl] = new Uint32Array(le1, 4, 1);
                            return new Rf(Fl, Dl, ho, le1);
                        }
                        constructor(le1, vt, bt, ls){
                            if (void 0 === vt && (vt = 64), void 0 === bt && (bt = Float64Array), isNaN(le1) || le1 < 0) throw new Error(`Unpexpected numItems value: ${le1}.`);
                            this.numItems = +le1, this.nodeSize = Math.min(Math.max(+vt, 2), 65535), this.ArrayType = bt, this.IndexArrayType = le1 < 65536 ? Uint16Array : Uint32Array;
                            const ho = kA.indexOf(this.ArrayType), Dl = 2 * le1 * this.ArrayType.BYTES_PER_ELEMENT, Fl = le1 * this.IndexArrayType.BYTES_PER_ELEMENT, sc = (8 - Fl % 8) % 8;
                            if (ho < 0) throw new Error(`Unexpected typed array class: ${bt}.`);
                            ls && ls instanceof ArrayBuffer ? (this.data = ls, this.ids = new this.IndexArrayType(this.data, 8, le1), this.coords = new this.ArrayType(this.data, 8 + Fl + sc, 2 * le1), this._pos = 2 * le1, this._finished = !0) : (this.data = new ArrayBuffer(8 + Dl + Fl + sc), this.ids = new this.IndexArrayType(this.data, 8, le1), this.coords = new this.ArrayType(this.data, 8 + Fl + sc, 2 * le1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                219,
                                16 + ho
                            ]), new Uint16Array(this.data, 2, 1)[0] = vt, new Uint32Array(this.data, 4, 1)[0] = le1);
                        }
                        add(le1, vt) {
                            const bt = this._pos >> 1;
                            return this.ids[bt] = bt, this.coords[this._pos++] = le1, this.coords[this._pos++] = vt, bt;
                        }
                        finish() {
                            const le1 = this._pos >> 1;
                            if (le1 !== this.numItems) throw new Error(`Added ${le1} items when expected ${this.numItems}.`);
                            return Nf(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                        }
                        range(le1, vt, bt, ls) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            const { ids: ho, coords: Dl, nodeSize: Fl } = this, sc = [
                                0,
                                ho.length - 1,
                                0
                            ], uc = [];
                            for(; sc.length;){
                                const mc = sc.pop() || 0, gc = sc.pop() || 0, Ac = sc.pop() || 0;
                                if (gc - Ac <= Fl) {
                                    for(let Fl = Ac; Fl <= gc; Fl++){
                                        const sc = Dl[2 * Fl], mc = Dl[2 * Fl + 1];
                                        sc >= le1 && sc <= bt && mc >= vt && mc <= ls && uc.push(ho[Fl]);
                                    }
                                    continue;
                                }
                                const Ec = Ac + gc >> 1, kc = Dl[2 * Ec], du = Dl[2 * Ec + 1];
                                kc >= le1 && kc <= bt && du >= vt && du <= ls && uc.push(ho[Ec]), (0 === mc ? le1 <= kc : vt <= du) && (sc.push(Ac), sc.push(Ec - 1), sc.push(1 - mc)), (0 === mc ? bt >= kc : ls >= du) && (sc.push(Ec + 1), sc.push(gc), sc.push(1 - mc));
                            }
                            return uc;
                        }
                        within(le1, vt, bt) {
                            if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                            const { ids: ls, coords: ho, nodeSize: Dl } = this, Fl = [
                                0,
                                ls.length - 1,
                                0
                            ], sc = [], uc = bt * bt;
                            for(; Fl.length;){
                                const mc = Fl.pop() || 0, gc = Fl.pop() || 0, Ac = Fl.pop() || 0;
                                if (gc - Ac <= Dl) {
                                    for(let bt = Ac; bt <= gc; bt++)Gf(ho[2 * bt], ho[2 * bt + 1], le1, vt) <= uc && sc.push(ls[bt]);
                                    continue;
                                }
                                const Ec = Ac + gc >> 1, kc = ho[2 * Ec], du = ho[2 * Ec + 1];
                                Gf(kc, du, le1, vt) <= uc && sc.push(ls[Ec]), (0 === mc ? le1 - bt <= kc : vt - bt <= du) && (Fl.push(Ac), Fl.push(Ec - 1), Fl.push(1 - mc)), (0 === mc ? le1 + bt >= kc : vt + bt >= du) && (Fl.push(Ec + 1), Fl.push(gc), Fl.push(1 - mc));
                            }
                            return sc;
                        }
                    }
                    function Nf(le1, vt, bt, ls, ho, Dl) {
                        if (ho - ls <= bt) return;
                        const Fl = ls + ho >> 1;
                        $f(le1, vt, Fl, ls, ho, Dl), Nf(le1, vt, bt, ls, Fl - 1, 1 - Dl), Nf(le1, vt, bt, Fl + 1, ho, 1 - Dl);
                    }
                    function $f(le1, vt, bt, ls, ho, Dl) {
                        for(; ho > ls;){
                            if (ho - ls > 600) {
                                const Fl = ho - ls + 1, sc = bt - ls + 1, uc = Math.log(Fl), mc = .5 * Math.exp(2 * uc / 3), gc = .5 * Math.sqrt(uc * mc * (Fl - mc) / Fl) * (sc - Fl / 2 < 0 ? -1 : 1);
                                $f(le1, vt, bt, Math.max(ls, Math.floor(bt - sc * mc / Fl + gc)), Math.min(ho, Math.floor(bt + (Fl - sc) * mc / Fl + gc)), Dl);
                            }
                            const Fl = vt[2 * bt + Dl];
                            let sc = ls, uc = ho;
                            for(Uf(le1, vt, ls, bt), vt[2 * ho + Dl] > Fl && Uf(le1, vt, ls, ho); sc < uc;){
                                for(Uf(le1, vt, sc, uc), sc++, uc--; vt[2 * sc + Dl] < Fl;)sc++;
                                for(; vt[2 * uc + Dl] > Fl;)uc--;
                            }
                            vt[2 * ls + Dl] === Fl ? Uf(le1, vt, ls, uc) : (uc++, Uf(le1, vt, uc, ho)), uc <= bt && (ls = uc + 1), bt <= uc && (ho = uc - 1);
                        }
                    }
                    function Uf(le1, vt, bt, ls) {
                        qf(le1, bt, ls), qf(vt, 2 * bt, 2 * ls), qf(vt, 2 * bt + 1, 2 * ls + 1);
                    }
                    function qf(le1, vt, bt) {
                        const ls = le1[vt];
                        le1[vt] = le1[bt], le1[bt] = ls;
                    }
                    function Gf(le1, vt, bt, ls) {
                        const ho = le1 - bt, Dl = vt - ls;
                        return ho * ho + Dl * Dl;
                    }
                    const CA = {
                        minZoom: 0,
                        maxZoom: 16,
                        minPoints: 2,
                        radius: 40,
                        extent: 512,
                        nodeSize: 64,
                        log: !1,
                        generateId: !1,
                        reduce: null,
                        map: (le1)=>le1
                    }, IA = Math.fround || (DA = new Float32Array(1), (le1)=>(DA[0] = +le1, DA[0]));
                    var DA;
                    class Zf {
                        constructor(le1){
                            this.options = Object.assign(Object.create(CA), le1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                        }
                        load(le1) {
                            const { log: vt, minZoom: bt, maxZoom: ls } = this.options;
                            vt && console.time("total time");
                            const ho = `prepare ${le1.length} points`;
                            vt && console.time(ho), this.points = le1;
                            const Dl = [];
                            for(let sc = 0; sc < le1.length; sc++){
                                const vt = le1[sc];
                                if (!vt.geometry) continue;
                                const [bt, ls] = vt.geometry.coordinates, ho = IA(Jf(bt)), Fl = IA(Kf(ls));
                                Dl.push(ho, Fl, 1 / 0, sc, -1, 1), this.options.reduce && Dl.push(0);
                            }
                            let Fl = this.trees[ls + 1] = this._createTree(Dl);
                            vt && console.timeEnd(ho);
                            for(let sc = ls; sc >= bt; sc--){
                                const le1 = +Date.now();
                                Fl = this.trees[sc] = this._createTree(this._cluster(Fl, sc)), vt && console.log("z%d: %d clusters in %dms", sc, Fl.numItems, +Date.now() - le1);
                            }
                            return vt && console.timeEnd("total time"), this;
                        }
                        getClusters(le1, vt) {
                            let bt = ((le1[0] + 180) % 360 + 360) % 360 - 180;
                            const ls = Math.max(-90, Math.min(90, le1[1]));
                            let ho = 180 === le1[2] ? 180 : ((le1[2] + 180) % 360 + 360) % 360 - 180;
                            const Dl = Math.max(-90, Math.min(90, le1[3]));
                            if (le1[2] - le1[0] >= 360) bt = -180, ho = 180;
                            else if (bt > ho) {
                                const le1 = this.getClusters([
                                    bt,
                                    ls,
                                    180,
                                    Dl
                                ], vt), Fl = this.getClusters([
                                    -180,
                                    ls,
                                    ho,
                                    Dl
                                ], vt);
                                return le1.concat(Fl);
                            }
                            const Fl = this.trees[this._limitZoom(vt)], sc = Fl.range(Jf(bt), Kf(Dl), Jf(ho), Kf(ls)), uc = Fl.data, mc = [];
                            for (const gc of sc){
                                const le1 = this.stride * gc;
                                mc.push(uc[le1 + 5] > 1 ? Hf(uc, le1, this.clusterProps) : this.points[uc[le1 + 3]]);
                            }
                            return mc;
                        }
                        getChildren(le1) {
                            const vt = this._getOriginId(le1), bt = this._getOriginZoom(le1), ls = "No cluster with the specified id.", ho = this.trees[bt];
                            if (!ho) throw new Error(ls);
                            const Dl = ho.data;
                            if (vt * this.stride >= Dl.length) throw new Error(ls);
                            const Fl = this.options.radius / (this.options.extent * Math.pow(2, bt - 1)), sc = ho.within(Dl[vt * this.stride], Dl[vt * this.stride + 1], Fl), uc = [];
                            for (const mc of sc){
                                const vt = mc * this.stride;
                                Dl[vt + 4] === le1 && uc.push(Dl[vt + 5] > 1 ? Hf(Dl, vt, this.clusterProps) : this.points[Dl[vt + 3]]);
                            }
                            if (0 === uc.length) throw new Error(ls);
                            return uc;
                        }
                        getLeaves(le1, vt, bt) {
                            const ls = [];
                            return this._appendLeaves(ls, le1, vt = vt || 10, bt = bt || 0, 0), ls;
                        }
                        getTile(le1, vt, bt) {
                            const ls = this.trees[this._limitZoom(le1)], ho = Math.pow(2, le1), { extent: Dl, radius: Fl } = this.options, sc = Fl / Dl, uc = (bt - sc) / ho, mc = (bt + 1 + sc) / ho, gc = {
                                features: []
                            };
                            return this._addTileFeatures(ls.range((vt - sc) / ho, uc, (vt + 1 + sc) / ho, mc), ls.data, vt, bt, ho, gc), 0 === vt && this._addTileFeatures(ls.range(1 - sc / ho, uc, 1, mc), ls.data, ho, bt, ho, gc), vt === ho - 1 && this._addTileFeatures(ls.range(0, uc, sc / ho, mc), ls.data, -1, bt, ho, gc), gc.features.length ? gc : null;
                        }
                        getClusterExpansionZoom(le1) {
                            let vt = this._getOriginZoom(le1) - 1;
                            for(; vt <= this.options.maxZoom;){
                                const bt = this.getChildren(le1);
                                if (vt++, 1 !== bt.length) break;
                                le1 = bt[0].properties.cluster_id;
                            }
                            return vt;
                        }
                        _appendLeaves(le1, vt, bt, ls, ho) {
                            const Dl = this.getChildren(vt);
                            for (const Fl of Dl){
                                const vt = Fl.properties;
                                if (vt && vt.cluster ? ho + vt.point_count <= ls ? ho += vt.point_count : ho = this._appendLeaves(le1, vt.cluster_id, bt, ls, ho) : ho < ls ? ho++ : le1.push(Fl), le1.length === bt) break;
                            }
                            return ho;
                        }
                        _createTree(le1) {
                            const vt = new Rf(le1.length / this.stride | 0, this.options.nodeSize, Float32Array);
                            for(let bt = 0; bt < le1.length; bt += this.stride)vt.add(le1[bt], le1[bt + 1]);
                            return vt.finish(), vt.data = le1, vt;
                        }
                        _addTileFeatures(le1, vt, bt, ls, ho, Dl) {
                            for (const Fl of le1){
                                const le1 = Fl * this.stride, sc = vt[le1 + 5] > 1;
                                let uc, mc, gc;
                                if (sc) uc = Wf(vt, le1, this.clusterProps), mc = vt[le1], gc = vt[le1 + 1];
                                else {
                                    const bt = this.points[vt[le1 + 3]];
                                    uc = bt.properties;
                                    const [ls, ho] = bt.geometry.coordinates;
                                    mc = Jf(ls), gc = Kf(ho);
                                }
                                const Ac = {
                                    type: 1,
                                    geometry: [
                                        [
                                            Math.round(this.options.extent * (mc * ho - bt)),
                                            Math.round(this.options.extent * (gc * ho - ls))
                                        ]
                                    ],
                                    tags: uc
                                };
                                let Ec;
                                Ec = sc || this.options.generateId ? vt[le1 + 3] : this.points[vt[le1 + 3]].id, void 0 !== Ec && (Ac.id = Ec), Dl.features.push(Ac);
                            }
                        }
                        _limitZoom(le1) {
                            return Math.max(this.options.minZoom, Math.min(Math.floor(+le1), this.options.maxZoom + 1));
                        }
                        _cluster(le1, vt) {
                            const { radius: bt, extent: ls, reduce: ho, minPoints: Dl } = this.options, Fl = bt / (ls * Math.pow(2, vt)), sc = le1.data, uc = [], mc = this.stride;
                            for(let gc = 0; gc < sc.length; gc += mc){
                                if (sc[gc + 2] <= vt) continue;
                                sc[gc + 2] = vt;
                                const bt = sc[gc], ls = sc[gc + 1], Ac = le1.within(sc[gc], sc[gc + 1], Fl), Ec = sc[gc + 5];
                                let kc = Ec;
                                for (const le1 of Ac){
                                    const bt = le1 * mc;
                                    sc[bt + 2] > vt && (kc += sc[bt + 5]);
                                }
                                if (kc > Ec && kc >= Dl) {
                                    let le1, Dl = bt * Ec, Fl = ls * Ec, du = -1;
                                    const _u = (gc / mc << 5) + (vt + 1) + this.points.length;
                                    for (const bt of Ac){
                                        const ls = bt * mc;
                                        if (sc[ls + 2] <= vt) continue;
                                        sc[ls + 2] = vt;
                                        const uc = sc[ls + 5];
                                        Dl += sc[ls] * uc, Fl += sc[ls + 1] * uc, sc[ls + 4] = _u, ho && (le1 || (le1 = this._map(sc, gc, !0), du = this.clusterProps.length, this.clusterProps.push(le1)), ho(le1, this._map(sc, ls)));
                                    }
                                    sc[gc + 4] = _u, uc.push(Dl / kc, Fl / kc, 1 / 0, _u, -1, kc), ho && uc.push(du);
                                } else {
                                    for(let le1 = 0; le1 < mc; le1++)uc.push(sc[gc + le1]);
                                    if (kc > 1) for (const le1 of Ac){
                                        const bt = le1 * mc;
                                        if (!(sc[bt + 2] <= vt)) {
                                            sc[bt + 2] = vt;
                                            for(let le1 = 0; le1 < mc; le1++)uc.push(sc[bt + le1]);
                                        }
                                    }
                                }
                            }
                            return uc;
                        }
                        _getOriginId(le1) {
                            return le1 - this.points.length >> 5;
                        }
                        _getOriginZoom(le1) {
                            return (le1 - this.points.length) % 32;
                        }
                        _map(le1, vt, bt) {
                            if (le1[vt + 5] > 1) {
                                const ls = this.clusterProps[le1[vt + 6]];
                                return bt ? Object.assign({}, ls) : ls;
                            }
                            const ls = this.points[le1[vt + 3]].properties, ho = this.options.map(ls);
                            return bt && ho === ls ? Object.assign({}, ho) : ho;
                        }
                    }
                    function Hf(le1, vt, bt) {
                        var ls;
                        return {
                            type: "Feature",
                            id: le1[vt + 3],
                            properties: Wf(le1, vt, bt),
                            geometry: {
                                type: "Point",
                                coordinates: [
                                    (ls = le1[vt], 360 * (ls - .5)),
                                    Qf(le1[vt + 1])
                                ]
                            }
                        };
                    }
                    function Wf(le1, vt, bt) {
                        const ls = le1[vt + 5], ho = ls >= 1e4 ? `${Math.round(ls / 1e3)}k` : ls >= 1e3 ? Math.round(ls / 100) / 10 + "k" : ls, Dl = le1[vt + 6], Fl = -1 === Dl ? {} : Object.assign({}, bt[Dl]);
                        return Object.assign(Fl, {
                            cluster: !0,
                            cluster_id: le1[vt + 3],
                            point_count: ls,
                            point_count_abbreviated: ho
                        });
                    }
                    function Jf(le1) {
                        return le1 / 360 + .5;
                    }
                    function Kf(le1) {
                        const vt = Math.sin(le1 * Math.PI / 180), bt = .5 - .25 * Math.log((1 + vt) / (1 - vt)) / Math.PI;
                        return bt < 0 ? 0 : bt > 1 ? 1 : bt;
                    }
                    function Qf(le1) {
                        const vt = (180 - 360 * le1) * Math.PI / 180;
                        return 360 * Math.atan(Math.exp(vt)) / Math.PI - 90;
                    }
                    function ed(le1, vt, bt, ls) {
                        let ho = ls;
                        const Dl = vt + (bt - vt >> 1);
                        let Fl, sc = bt - vt;
                        const uc = le1[vt], mc = le1[vt + 1], gc = le1[bt], Ac = le1[bt + 1];
                        for(let Ec = vt + 3; Ec < bt; Ec += 3){
                            const vt = td(le1[Ec], le1[Ec + 1], uc, mc, gc, Ac);
                            if (vt > ho) Fl = Ec, ho = vt;
                            else if (vt === ho) {
                                const le1 = Math.abs(Ec - Dl);
                                le1 < sc && (Fl = Ec, sc = le1);
                            }
                        }
                        ho > ls && (Fl - vt > 3 && ed(le1, vt, Fl, ls), le1[Fl + 2] = ho, bt - Fl > 3 && ed(le1, Fl, bt, ls));
                    }
                    function td(le1, vt, bt, ls, ho, Dl) {
                        let Fl = ho - bt, sc = Dl - ls;
                        if (0 !== Fl || 0 !== sc) {
                            const uc = ((le1 - bt) * Fl + (vt - ls) * sc) / (Fl * Fl + sc * sc);
                            uc > 1 ? (bt = ho, ls = Dl) : uc > 0 && (bt += Fl * uc, ls += sc * uc);
                        }
                        return Fl = le1 - bt, sc = vt - ls, Fl * Fl + sc * sc;
                    }
                    function rd(le1, vt, bt, ls) {
                        const ho = {
                            type: vt,
                            geom: bt
                        }, Dl = {
                            id: null == le1 ? null : le1,
                            type: ho.type,
                            geometry: ho.geom,
                            tags: ls,
                            minX: 1 / 0,
                            minY: 1 / 0,
                            maxX: -1 / 0,
                            maxY: -1 / 0
                        };
                        switch(ho.type){
                            case "Point":
                            case "MultiPoint":
                            case "LineString":
                                nd(Dl, ho.geom);
                                break;
                            case "Polygon":
                                nd(Dl, ho.geom[0]);
                                break;
                            case "MultiLineString":
                                for (const le1 of ho.geom)nd(Dl, le1);
                                break;
                            case "MultiPolygon":
                                for (const le1 of ho.geom)nd(Dl, le1[0]);
                        }
                        return Dl;
                    }
                    function nd(le1, vt) {
                        for(let bt = 0; bt < vt.length; bt += 3)le1.minX = Math.min(le1.minX, vt[bt]), le1.minY = Math.min(le1.minY, vt[bt + 1]), le1.maxX = Math.max(le1.maxX, vt[bt]), le1.maxY = Math.max(le1.maxY, vt[bt + 1]);
                    }
                    function id(le1, vt) {
                        const bt = [];
                        switch(le1.type){
                            case "FeatureCollection":
                                for(let ls = 0; ls < le1.features.length; ls++)sd(bt, le1.features[ls], vt, ls);
                                break;
                            case "Feature":
                                sd(bt, le1, vt);
                                break;
                            default:
                                sd(bt, {
                                    geometry: le1,
                                    properties: void 0
                                }, vt);
                        }
                        return bt;
                    }
                    function sd(le1, vt, bt, ls) {
                        if (!vt.geometry) return;
                        if ("GeometryCollection" === vt.geometry.type) {
                            for (const ho of vt.geometry.geometries)sd(le1, {
                                id: vt.id,
                                geometry: ho,
                                properties: vt.properties
                            }, bt, ls);
                            return;
                        }
                        const ho = vt.geometry.coordinates;
                        if (!ho?.length) return;
                        const Dl = Math.pow(bt.tolerance / ((1 << bt.maxZoom) * bt.extent), 2);
                        let Fl = vt.id;
                        switch(bt.promoteId ? Fl = vt.properties?.[bt.promoteId] : bt.generateId && (Fl = ls || 0), vt.geometry.type){
                            case "Point":
                                {
                                    const bt = [];
                                    return od(vt.geometry.coordinates, bt), void le1.push(rd(Fl, vt.geometry.type, bt, vt.properties));
                                }
                            case "MultiPoint":
                                {
                                    const bt = [];
                                    for (const le1 of vt.geometry.coordinates)od(le1, bt);
                                    return void le1.push(rd(Fl, vt.geometry.type, bt, vt.properties));
                                }
                            case "LineString":
                                {
                                    const bt = [];
                                    return ad(vt.geometry.coordinates, bt, Dl, !1), void le1.push(rd(Fl, vt.geometry.type, bt, vt.properties));
                                }
                            case "MultiLineString":
                                {
                                    if (bt.lineMetrics) {
                                        for (const bt of vt.geometry.coordinates){
                                            const ls = [];
                                            ad(bt, ls, Dl, !1), le1.push(rd(Fl, "LineString", ls, vt.properties));
                                        }
                                        return;
                                    }
                                    const ls = [];
                                    return ld(vt.geometry.coordinates, ls, Dl, !1), void le1.push(rd(Fl, vt.geometry.type, ls, vt.properties));
                                }
                            case "Polygon":
                                {
                                    const bt = [];
                                    return ld(vt.geometry.coordinates, bt, Dl, !0), void le1.push(rd(Fl, vt.geometry.type, bt, vt.properties));
                                }
                            case "MultiPolygon":
                                {
                                    const bt = [];
                                    for (const le1 of vt.geometry.coordinates){
                                        const vt = [];
                                        ld(le1, vt, Dl, !0), bt.push(vt);
                                    }
                                    return void le1.push(rd(Fl, vt.geometry.type, bt, vt.properties));
                                }
                            default:
                                throw new Error("Input data is not a valid GeoJSON object.");
                        }
                    }
                    function od(le1, vt) {
                        vt.push(ud(le1[0]), cd(le1[1]), 0);
                    }
                    function ad(le1, vt, bt, ls) {
                        let ho, Dl, Fl = 0;
                        for(let uc = 0; uc < le1.length; uc++){
                            const bt = ud(le1[uc][0]), sc = cd(le1[uc][1]);
                            vt.push(bt, sc, 0), uc > 0 && (Fl += ls ? (ho * sc - bt * Dl) / 2 : Math.sqrt(Math.pow(bt - ho, 2) + Math.pow(sc - Dl, 2))), ho = bt, Dl = sc;
                        }
                        const sc = vt.length - 3;
                        vt[2] = 1, bt > 0 && ed(vt, 0, sc, bt), vt[sc + 2] = 1, vt.size = Math.abs(Fl), vt.start = 0, vt.end = vt.size;
                    }
                    function ld(le1, vt, bt, ls) {
                        for(let ho = 0; ho < le1.length; ho++){
                            const Dl = [];
                            ad(le1[ho], Dl, bt, ls), vt.push(Dl);
                        }
                    }
                    function ud(le1) {
                        return le1 / 360 + .5;
                    }
                    function cd(le1) {
                        const vt = Math.sin(le1 * Math.PI / 180), bt = .5 - .25 * Math.log((1 + vt) / (1 - vt)) / Math.PI;
                        return bt < 0 ? 0 : bt > 1 ? 1 : bt;
                    }
                    function hd(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        if (ls /= vt, Dl >= (bt /= vt) && Fl < ls) return le1;
                        if (Fl < bt || Dl >= ls) return null;
                        const uc = [];
                        for (const mc of le1){
                            const le1 = 0 === ho ? mc.minX : mc.minY, vt = 0 === ho ? mc.maxX : mc.maxY;
                            if (le1 >= bt && vt < ls) uc.push(mc);
                            else if (!(vt < bt || le1 >= ls)) switch(mc.type){
                                case "Point":
                                case "MultiPoint":
                                    {
                                        const le1 = [];
                                        if (pd(mc.geometry, le1, bt, ls, ho), !le1.length) continue;
                                        uc.push(rd(mc.id, 3 === le1.length ? "Point" : "MultiPoint", le1, mc.tags));
                                        continue;
                                    }
                                case "LineString":
                                    {
                                        const le1 = [];
                                        if (fd(mc.geometry, le1, bt, ls, ho, !1, sc.lineMetrics), !le1.length) continue;
                                        if (sc.lineMetrics) {
                                            for (const vt of le1)uc.push(rd(mc.id, mc.type, vt, mc.tags));
                                            continue;
                                        }
                                        if (le1.length > 1) {
                                            uc.push(rd(mc.id, "MultiLineString", le1, mc.tags));
                                            continue;
                                        }
                                        uc.push(rd(mc.id, mc.type, le1[0], mc.tags));
                                        continue;
                                    }
                                case "MultiLineString":
                                    {
                                        const le1 = [];
                                        if (yd(mc.geometry, le1, bt, ls, ho, !1), !le1.length) continue;
                                        if (1 === le1.length) {
                                            uc.push(rd(mc.id, "LineString", le1[0], mc.tags));
                                            continue;
                                        }
                                        uc.push(rd(mc.id, mc.type, le1, mc.tags));
                                        continue;
                                    }
                                case "Polygon":
                                    {
                                        const le1 = [];
                                        if (yd(mc.geometry, le1, bt, ls, ho, !0), !le1.length) continue;
                                        uc.push(rd(mc.id, mc.type, le1, mc.tags));
                                        continue;
                                    }
                                case "MultiPolygon":
                                    {
                                        const le1 = [];
                                        for (const vt of mc.geometry){
                                            const Dl = [];
                                            yd(vt, Dl, bt, ls, ho, !0), Dl.length && le1.push(Dl);
                                        }
                                        if (!le1.length) continue;
                                        uc.push(rd(mc.id, mc.type, le1, mc.tags));
                                        continue;
                                    }
                            }
                        }
                        return uc.length ? uc : null;
                    }
                    function pd(le1, vt, bt, ls, ho) {
                        for(let Dl = 0; Dl < le1.length; Dl += 3){
                            const Fl = le1[Dl + ho];
                            Fl >= bt && Fl <= ls && md(vt, le1[Dl], le1[Dl + 1], le1[Dl + 2]);
                        }
                    }
                    function fd(le1, vt, bt, ls, ho, Dl, Fl) {
                        let sc = dd(le1);
                        const uc = 0 === ho ? gd : xd;
                        let mc, gc, Ac = le1.start;
                        for(let Md = 0; Md < le1.length - 3; Md += 3){
                            const Ec = le1[Md], kc = le1[Md + 1], du = le1[Md + 2], _u = le1[Md + 3], Ld = le1[Md + 4], Nd = 0 === ho ? Ec : kc, Rd = 0 === ho ? _u : Ld;
                            let Od = !1;
                            Fl && (mc = Math.sqrt(Math.pow(Ec - _u, 2) + Math.pow(kc - Ld, 2))), Nd < bt ? Rd > bt && (gc = uc(sc, Ec, kc, _u, Ld, bt), Fl && (sc.start = Ac + mc * gc)) : Nd > ls ? Rd < ls && (gc = uc(sc, Ec, kc, _u, Ld, ls), Fl && (sc.start = Ac + mc * gc)) : md(sc, Ec, kc, du), Rd < bt && Nd >= bt && (gc = uc(sc, Ec, kc, _u, Ld, bt), Od = !0), Rd > ls && Nd <= ls && (gc = uc(sc, Ec, kc, _u, Ld, ls), Od = !0), !Dl && Od && (Fl && (sc.end = Ac + mc * gc), vt.push(sc), sc = dd(le1)), Fl && (Ac += mc);
                        }
                        let Ec = le1.length - 3;
                        const kc = le1[Ec], du = le1[Ec + 1], _u = 0 === ho ? kc : du;
                        _u >= bt && _u <= ls && md(sc, kc, du, le1[Ec + 2]), Ec = sc.length - 3, Dl && Ec >= 3 && (sc[Ec] !== sc[0] || sc[Ec + 1] !== sc[1]) && md(sc, sc[0], sc[1], sc[2]), sc.length && vt.push(sc);
                    }
                    function dd(le1) {
                        const vt = [];
                        return vt.size = le1.size, vt.start = le1.start, vt.end = le1.end, vt;
                    }
                    function yd(le1, vt, bt, ls, ho, Dl) {
                        for (const Fl of le1)fd(Fl, vt, bt, ls, ho, Dl, !1);
                    }
                    function md(le1, vt, bt, ls) {
                        le1.push(vt, bt, ls);
                    }
                    function gd(le1, vt, bt, ls, ho, Dl) {
                        const Fl = (Dl - vt) / (ls - vt);
                        return md(le1, Dl, bt + (ho - bt) * Fl, 1), Fl;
                    }
                    function xd(le1, vt, bt, ls, ho, Dl) {
                        const Fl = (Dl - bt) / (ho - bt);
                        return md(le1, vt + (ls - vt) * Fl, Dl, 1), Fl;
                    }
                    function vd(le1, vt) {
                        const bt = vt.buffer / vt.extent;
                        let ls = le1;
                        const ho = hd(le1, 1, -1 - bt, bt, 0, -1, 2, vt), Dl = hd(le1, 1, 1 - bt, 2 + bt, 0, -1, 2, vt);
                        return ho || Dl ? (ls = hd(le1, 1, -bt, 1 + bt, 0, -1, 2, vt) || [], ho && (ls = bd(ho, 1).concat(ls)), Dl && (ls = ls.concat(bd(Dl, -1))), ls) : ls;
                    }
                    function bd(le1, vt) {
                        const bt = [];
                        for (const ls of le1)switch(ls.type){
                            case "Point":
                            case "MultiPoint":
                            case "LineString":
                                {
                                    const le1 = wd(ls.geometry, vt);
                                    bt.push(rd(ls.id, ls.type, le1, ls.tags));
                                    continue;
                                }
                            case "MultiLineString":
                            case "Polygon":
                                {
                                    const le1 = [];
                                    for (const bt of ls.geometry)le1.push(wd(bt, vt));
                                    bt.push(rd(ls.id, ls.type, le1, ls.tags));
                                    continue;
                                }
                            case "MultiPolygon":
                                {
                                    const le1 = [];
                                    for (const bt of ls.geometry){
                                        const ls = [];
                                        for (const le1 of bt)ls.push(wd(le1, vt));
                                        le1.push(ls);
                                    }
                                    bt.push(rd(ls.id, ls.type, le1, ls.tags));
                                    continue;
                                }
                        }
                        return bt;
                    }
                    function wd(le1, vt) {
                        const bt = [];
                        bt.size = le1.size, void 0 !== le1.start && (bt.start = le1.start, bt.end = le1.end);
                        for(let ls = 0; ls < le1.length; ls += 3)bt.push(le1[ls] + vt, le1[ls + 1], le1[ls + 2]);
                        return bt;
                    }
                    function _d(le1, vt) {
                        if (le1.transformed) return le1;
                        const bt = 1 << le1.z, ls = le1.x, ho = le1.y;
                        for (const Dl of le1.features){
                            if (1 === Dl.type) {
                                const le1 = [];
                                for(let Fl = 0; Fl < Dl.geometry.length; Fl += 2)le1.push(Sd(Dl.geometry[Fl], Dl.geometry[Fl + 1], vt, bt, ls, ho));
                                Dl.geometry = le1;
                                continue;
                            }
                            const le1 = [];
                            for (const Fl of Dl.geometry){
                                const Dl = [];
                                for(let le1 = 0; le1 < Fl.length; le1 += 2)Dl.push(Sd(Fl[le1], Fl[le1 + 1], vt, bt, ls, ho));
                                le1.push(Dl);
                            }
                            Dl.geometry = le1;
                        }
                        return le1.transformed = !0, le1;
                    }
                    function Sd(le1, vt, bt, ls, ho, Dl) {
                        return [
                            Math.round(bt * (le1 * ls - ho)),
                            Math.round(bt * (vt * ls - Dl))
                        ];
                    }
                    function Ad(le1, vt, bt, ls, ho) {
                        const Dl = vt === ho.maxZoom ? 0 : ho.tolerance / ((1 << vt) * ho.extent), Fl = {
                            features: [],
                            numPoints: 0,
                            numSimplified: 0,
                            numFeatures: le1.length,
                            source: null,
                            x: bt,
                            y: ls,
                            z: vt,
                            transformed: !1,
                            minX: 2,
                            minY: 1,
                            maxX: -1,
                            maxY: 0
                        };
                        for (const sc of le1)Id(Fl, sc, Dl, ho);
                        return Fl;
                    }
                    function Id(le1, vt, bt, ls) {
                        le1.minX = Math.min(le1.minX, vt.minX), le1.minY = Math.min(le1.minY, vt.minY), le1.maxX = Math.max(le1.maxX, vt.maxX), le1.maxY = Math.max(le1.maxY, vt.maxY);
                        let ho, Dl = vt.tags || null;
                        switch(vt.type){
                            case "Point":
                            case "MultiPoint":
                                {
                                    const bt = [];
                                    for(let ls = 0; ls < vt.geometry.length; ls += 3)bt.push(vt.geometry[ls], vt.geometry[ls + 1]), le1.numPoints++, le1.numSimplified++;
                                    if (!bt.length) return;
                                    ho = {
                                        type: 1,
                                        tags: Dl,
                                        geometry: bt
                                    };
                                    break;
                                }
                            case "LineString":
                                {
                                    const Fl = [];
                                    if (Td(Fl, vt.geometry, le1, bt, !1, !1), !Fl.length) return;
                                    if (ls.lineMetrics) {
                                        Dl = {};
                                        for(const le1 in vt.tags)Dl[le1] = vt.tags[le1];
                                        Dl.mapbox_clip_start = vt.geometry.start / vt.geometry.size, Dl.mapbox_clip_end = vt.geometry.end / vt.geometry.size;
                                    }
                                    ho = {
                                        type: 2,
                                        tags: Dl,
                                        geometry: Fl
                                    };
                                    break;
                                }
                            case "MultiLineString":
                            case "Polygon":
                                {
                                    const ls = [];
                                    for(let ho = 0; ho < vt.geometry.length; ho++)Td(ls, vt.geometry[ho], le1, bt, "Polygon" === vt.type, 0 === ho);
                                    if (!ls.length) return;
                                    ho = {
                                        type: "Polygon" === vt.type ? 3 : 2,
                                        tags: Dl,
                                        geometry: ls
                                    };
                                    break;
                                }
                            case "MultiPolygon":
                                {
                                    const ls = [];
                                    for(let ho = 0; ho < vt.geometry.length; ho++){
                                        const Dl = vt.geometry[ho];
                                        for(let vt = 0; vt < Dl.length; vt++)Td(ls, Dl[vt], le1, bt, !0, 0 === vt);
                                    }
                                    if (!ls.length) return;
                                    ho = {
                                        type: 3,
                                        tags: Dl,
                                        geometry: ls
                                    };
                                    break;
                                }
                        }
                        null !== vt.id && (ho.id = vt.id), le1.features.push(ho);
                    }
                    function Td(le1, vt, bt, ls, ho, Dl) {
                        const Fl = ls * ls;
                        if (ls > 0 && vt.size < (ho ? Fl : ls)) return void (bt.numPoints += vt.length / 3);
                        const sc = [];
                        for(let uc = 0; uc < vt.length; uc += 3)(0 === ls || vt[uc + 2] > Fl) && (bt.numSimplified++, sc.push(vt[uc], vt[uc + 1])), bt.numPoints++;
                        ho && function(le1, vt) {
                            let bt = 0;
                            for(let ls = 0, ho = le1.length, Dl = ho - 2; ls < ho; Dl = ls, ls += 2)bt += (le1[ls] - le1[Dl]) * (le1[ls + 1] + le1[Dl + 1]);
                            if (bt > 0 === vt) for(let ls = 0, ho = le1.length; ls < ho / 2; ls += 2){
                                const vt = le1[ls], bt = le1[ls + 1];
                                le1[ls] = le1[ho - 2 - ls], le1[ls + 1] = le1[ho - 1 - ls], le1[ho - 2 - ls] = vt, le1[ho - 1 - ls] = bt;
                            }
                        }(sc, Dl), le1.push(sc);
                    }
                    function kd(le1, vt, bt) {
                        const ls = !!vt.newGeometry, ho = vt.removeAllProperties || vt.removeProperties?.length > 0 || vt.addOrUpdateProperties?.length > 0;
                        if (ls) {
                            let ls = id({
                                type: "FeatureCollection",
                                features: [
                                    {
                                        type: "Feature",
                                        id: le1.id,
                                        geometry: vt.newGeometry,
                                        properties: ho ? Ed(le1.tags, vt) : le1.tags
                                    }
                                ]
                            }, bt);
                            return ls = vd(ls, bt), ls[0];
                        }
                        if (ho) {
                            const bt = {
                                ...le1
                            };
                            return bt.tags = Ed(bt.tags, vt), bt;
                        }
                        return null;
                    }
                    function Ed(le1, vt) {
                        if (vt.removeAllProperties) return {};
                        const bt = {
                            ...le1 || {}
                        };
                        if (vt.removeProperties) for (const ls of vt.removeProperties)delete bt[ls];
                        if (vt.addOrUpdateProperties) for (const { key: ls, value: ho } of vt.addOrUpdateProperties)bt[ls] = ho;
                        return bt;
                    }
                    const LA = {
                        maxZoom: 14,
                        indexMaxZoom: 5,
                        indexMaxPoints: 1e5,
                        tolerance: 3,
                        extent: 4096,
                        buffer: 64,
                        lineMetrics: !1,
                        promoteId: null,
                        generateId: !1,
                        updateable: !1,
                        debug: 0
                    };
                    class Dd {
                        constructor(le1, vt){
                            this.options = void 0, this.tiles = void 0, this.tileCoords = void 0, this.stats = {}, this.total = 0, this.source = void 0;
                            const bt = (vt = this.options = Object.assign({}, LA, vt)).debug;
                            if (bt && console.time("preprocess data"), vt.maxZoom < 0 || vt.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                            if (vt.promoteId && vt.generateId) throw new Error("promoteId and generateId cannot be used together.");
                            let ls = id(le1, vt);
                            this.tiles = {}, this.tileCoords = [], bt && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", vt.indexMaxZoom, vt.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), ls = vd(ls, vt), ls.length && this.splitTile(ls, 0, 0, 0), vt.updateable && (this.source = ls), bt && (ls.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                        }
                        splitTile(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = [
                                le1,
                                vt,
                                bt,
                                ls
                            ], uc = this.options, mc = uc.debug;
                            for(; sc.length;){
                                ls = sc.pop(), bt = sc.pop(), vt = sc.pop(), le1 = sc.pop();
                                const gc = 1 << vt, Ac = Pd(vt, bt, ls);
                                let Ec = this.tiles[Ac];
                                if (!Ec && (mc > 1 && console.time("creation"), Ec = this.tiles[Ac] = Ad(le1, vt, bt, ls, uc), this.tileCoords.push({
                                    z: vt,
                                    x: bt,
                                    y: ls,
                                    id: Ac
                                }), mc)) {
                                    mc > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", vt, bt, ls, Ec.numFeatures, Ec.numPoints, Ec.numSimplified), console.timeEnd("creation"));
                                    const le1 = `z${vt}`;
                                    this.stats[le1] = (this.stats[le1] || 0) + 1, this.total++;
                                }
                                if (Ec.source = le1, null == ho) {
                                    if (vt === uc.indexMaxZoom || Ec.numPoints <= uc.indexMaxPoints) continue;
                                } else {
                                    if (vt === uc.maxZoom || vt === ho) continue;
                                    if (null != ho) {
                                        const le1 = ho - vt;
                                        if (bt !== Dl >> le1 || ls !== Fl >> le1) continue;
                                    }
                                }
                                if (Ec.source = null, !le1.length) continue;
                                mc > 1 && console.time("clipping");
                                const kc = .5 * uc.buffer / uc.extent, du = .5 - kc, _u = .5 + kc, Md = 1 + kc;
                                let Ld = null, Nd = null, Rd = null, Od = null;
                                const jd = hd(le1, gc, bt - kc, bt + _u, 0, Ec.minX, Ec.maxX, uc), Ud = hd(le1, gc, bt + du, bt + Md, 0, Ec.minX, Ec.maxX, uc);
                                jd && (Ld = hd(jd, gc, ls - kc, ls + _u, 1, Ec.minY, Ec.maxY, uc), Nd = hd(jd, gc, ls + du, ls + Md, 1, Ec.minY, Ec.maxY, uc)), Ud && (Rd = hd(Ud, gc, ls - kc, ls + _u, 1, Ec.minY, Ec.maxY, uc), Od = hd(Ud, gc, ls + du, ls + Md, 1, Ec.minY, Ec.maxY, uc)), mc > 1 && console.timeEnd("clipping"), sc.push(Ld || [], vt + 1, 2 * bt, 2 * ls), sc.push(Nd || [], vt + 1, 2 * bt, 2 * ls + 1), sc.push(Rd || [], vt + 1, 2 * bt + 1, 2 * ls), sc.push(Od || [], vt + 1, 2 * bt + 1, 2 * ls + 1);
                            }
                        }
                        getTile(le1, vt, bt) {
                            le1 = +le1, vt = +vt, bt = +bt;
                            const ls = this.options, { extent: ho, debug: Dl } = ls;
                            if (le1 < 0 || le1 > 24) return null;
                            const Fl = 1 << le1, sc = Pd(le1, vt = vt + Fl & Fl - 1, bt);
                            if (this.tiles[sc]) return _d(this.tiles[sc], ho);
                            Dl > 1 && console.log("drilling down to z%d-%d-%d", le1, vt, bt);
                            let uc, mc = le1, gc = vt, Ac = bt;
                            for(; !uc && mc > 0;)mc--, gc >>= 1, Ac >>= 1, uc = this.tiles[Pd(mc, gc, Ac)];
                            return uc?.source ? (Dl > 1 && (console.log("found parent tile z%d-%d-%d", mc, gc, Ac), console.time("drilling down")), this.splitTile(uc.source, mc, gc, Ac, le1, vt, bt), Dl > 1 && console.timeEnd("drilling down"), this.tiles[sc] ? _d(this.tiles[sc], ho) : null) : null;
                        }
                        invalidateTiles(le1) {
                            const vt = this.options, { debug: bt } = vt;
                            let ls = 1 / 0, ho = -1 / 0, Dl = 1 / 0, Fl = -1 / 0;
                            for (const mc of le1)ls = Math.min(ls, mc.minX), ho = Math.max(ho, mc.maxX), Dl = Math.min(Dl, mc.minY), Fl = Math.max(Fl, mc.maxY);
                            const sc = vt.buffer / vt.extent, uc = new Set;
                            for(const mc in this.tiles){
                                const vt = this.tiles[mc], gc = 1 << vt.z, Ac = (vt.x - sc) / gc, Ec = (vt.x + 1 + sc) / gc, kc = (vt.y - sc) / gc, du = (vt.y + 1 + sc) / gc;
                                if (ho < Ac || ls >= Ec || Fl < kc || Dl >= du) continue;
                                let _u = !1;
                                for (const bt of le1)if (bt.maxX >= Ac && bt.minX < Ec && bt.maxY >= kc && bt.minY < du) {
                                    _u = !0;
                                    break;
                                }
                                if (_u) {
                                    if (bt) {
                                        bt > 1 && console.log("invalidate tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", vt.z, vt.x, vt.y, vt.numFeatures, vt.numPoints, vt.numSimplified);
                                        const le1 = `z${vt.z}`;
                                        this.stats[le1] = (this.stats[le1] || 0) - 1, this.total--;
                                    }
                                    delete this.tiles[mc], uc.add(mc);
                                }
                            }
                            uc.size && (this.tileCoords = this.tileCoords.filter((le1)=>!uc.has(le1.id)));
                        }
                        updateData(le1) {
                            const vt = this.options, bt = vt.debug;
                            if (!vt.updateable) throw new Error("to update tile geojson `updateable` option must be set to true");
                            const { affected: ls, source: ho } = function(le1, vt, bt) {
                                const ls = function(le1) {
                                    return le1 ? {
                                        removeAll: le1.removeAll,
                                        remove: new Set(le1.remove || []),
                                        add: new Map(le1.add?.map((le1)=>[
                                                le1.id,
                                                le1
                                            ])),
                                        update: new Map(le1.update?.map((le1)=>[
                                                le1.id,
                                                le1
                                            ]))
                                    } : {
                                        remove: new Set,
                                        add: new Map,
                                        update: new Map
                                    };
                                }(vt);
                                let ho = [];
                                if (ls.removeAll && (ho = le1, le1 = []), ls.remove.size || ls.add.size) {
                                    const vt = [];
                                    for (const bt of le1){
                                        const { id: le1 } = bt;
                                        (ls.remove.has(le1) || ls.add.has(le1)) && vt.push(bt);
                                    }
                                    if (vt.length) {
                                        ho.push(...vt);
                                        const bt = new Set(vt.map((le1)=>le1.id));
                                        le1 = le1.filter((le1)=>!bt.has(le1.id));
                                    }
                                    if (ls.add.size) {
                                        let vt = id({
                                            type: "FeatureCollection",
                                            features: Array.from(ls.add.values())
                                        }, bt);
                                        vt = vd(vt, bt), ho.push(...vt), le1.push(...vt);
                                    }
                                }
                                if (ls.update.size) for (const [Dl, Fl] of ls.update){
                                    const vt = le1.findIndex((le1)=>le1.id === Dl);
                                    if (-1 === vt) continue;
                                    const ls = le1[vt], sc = kd(ls, Fl, bt);
                                    sc && (ho.push(ls, sc), le1[vt] = sc);
                                }
                                return {
                                    affected: ho,
                                    source: le1
                                };
                            }(this.source, le1, vt);
                            if (!ls.length) return;
                            this.source = ho, bt > 1 && (console.log("invalidating tiles"), console.time("invalidating")), this.invalidateTiles(ls), bt > 1 && console.timeEnd("invalidating");
                            const [Dl, Fl, sc] = [
                                0,
                                0,
                                0
                            ], uc = Ad(this.source, Dl, Fl, sc, this.options);
                            uc.source = this.source;
                            const mc = Pd(Dl, Fl, sc);
                            if (this.tiles[mc] = uc, this.tileCoords.push({
                                z: Dl,
                                x: Fl,
                                y: sc,
                                id: mc
                            }), bt) {
                                const le1 = `z${Dl}`;
                                this.stats[le1] = (this.stats[le1] || 0) + 1, this.total++;
                            }
                        }
                    }
                    function Pd(le1, vt, bt) {
                        return 32 * ((1 << le1) * bt + vt) + le1;
                    }
                    function zd(le1, vt) {
                        return vt ? le1.properties[vt] : le1.id;
                    }
                    function Fd(le1, vt) {
                        const bt = new Map;
                        if (null == le1) return bt;
                        if (null == le1.type) return bt;
                        if ("Feature" === le1.type) {
                            const ls = zd(le1, vt);
                            if (null == ls) return;
                            return bt.set(ls, le1), bt;
                        }
                        if ("FeatureCollection" === le1.type) {
                            const ls = new Set;
                            for (const ho of le1.features){
                                const le1 = zd(ho, vt);
                                if (null == le1) return;
                                if (ls.has(le1)) return;
                                ls.add(le1), bt.set(le1, ho);
                            }
                            return bt;
                        }
                    }
                    class Bd extends Bf {
                        constructor(le1, vt, bt, ls){
                            void 0 === ls && (ls = Cd), super(le1, vt, bt), this._dataUpdateable = new Map, this._createGeoJSONIndex = ls;
                        }
                        loadVectorTile(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                const vt = le1.tileID.canonical;
                                if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                const bt = this._geoJSONIndex.getTile(vt.z, vt.x, vt.y);
                                return bt ? zf(new gp(bt.features, {
                                    version: 2,
                                    extent: uc
                                })) : null;
                            });
                        }
                        loadData(le1) {
                            return e(this, void 0, void 0, function*() {
                                var vt;
                                null === (vt = this._pendingRequest) || void 0 === vt || vt.abort();
                                const bt = this._startPerformance(le1);
                                this._pendingRequest = new AbortController;
                                try {
                                    (!this._pendingData || le1.request || le1.data || le1.dataDiff) && (this._pendingData = this.loadAndProcessGeoJSON(le1, this._pendingRequest));
                                    const vt = yield this._pendingData;
                                    this._geoJSONIndex = this._createGeoJSONIndex(vt, le1), this.loaded = {};
                                    const ls = {};
                                    return le1.request && (ls.data = vt), this._finishPerformance(bt, le1, ls), ls;
                                } catch (vt) {
                                    if (delete this._pendingRequest, ni(vt)) return {
                                        abandoned: !0
                                    };
                                    throw vt;
                                }
                            });
                        }
                        _startPerformance(le1) {
                            var vt;
                            if (null === (vt = null == le1 ? void 0 : le1.request) || void 0 === vt ? void 0 : vt.collectResourceTiming) return new Ef(le1.request);
                        }
                        _finishPerformance(le1, vt, bt) {
                            if (!le1) return;
                            const ls = le1.finish();
                            ls && (bt.resourceTiming = {}, bt.resourceTiming[vt.source] = JSON.parse(JSON.stringify(ls)));
                        }
                        getData() {
                            return e(this, void 0, void 0, function*() {
                                return this._pendingData;
                            });
                        }
                        reloadTile(le1) {
                            const vt = this.loaded;
                            return vt && vt[le1.uid] ? super.reloadTile(le1) : this.loadTile(le1);
                        }
                        loadAndProcessGeoJSON(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                let bt;
                                if (le1.request ? bt = yield this.loadGeoJSONFromUrl(le1.request, le1.promoteId, vt) : le1.data ? bt = this._loadGeoJSONFromObject(le1.data, le1.promoteId) : le1.dataDiff && (bt = this._loadGeoJSONFromDiff(le1.dataDiff, le1.promoteId, le1.source)), delete this._pendingRequest, "object" != typeof bt) throw new Error(`Input data given to '${le1.source}' is not a valid GeoJSON object.`);
                                return TA(bt, !0), le1.filter && (bt = this._filterGeoJSON(bt, le1.filter)), bt;
                            });
                        }
                        loadGeoJSONFromUrl(le1, vt, bt) {
                            return e(this, void 0, void 0, function*() {
                                const ls = yield ((le1, vt)=>ci(d(le1, {
                                        type: "json"
                                    }), vt))(le1, bt);
                                return this._dataUpdateable = Fd(ls.data, vt), ls.data;
                            });
                        }
                        _loadGeoJSONFromObject(le1, vt) {
                            return this._dataUpdateable = Fd(le1, vt), le1;
                        }
                        _loadGeoJSONFromDiff(le1, vt, bt) {
                            if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${bt}`);
                            !function(le1, vt, bt) {
                                var ls, ho;
                                const Dl = [];
                                if (vt.removeAll) le1.clear();
                                else if (vt.remove) for (const Fl of vt.remove){
                                    const vt = le1.get(Fl);
                                    vt && (Dl.push(vt.geometry), le1.delete(Fl));
                                }
                                if (vt.add) for (const Fl of vt.add){
                                    const vt = zd(Fl, bt);
                                    if (null == vt) continue;
                                    const ls = le1.get(vt);
                                    ls && Dl.push(ls.geometry), Dl.push(Fl.geometry), le1.set(vt, Fl);
                                }
                                if (vt.update) for (const Fl of vt.update){
                                    const vt = le1.get(Fl.id);
                                    if (!vt) continue;
                                    const bt = !!Fl.newGeometry, sc = Fl.removeAllProperties || (null === (ls = Fl.removeProperties) || void 0 === ls ? void 0 : ls.length) > 0 || (null === (ho = Fl.addOrUpdateProperties) || void 0 === ho ? void 0 : ho.length) > 0;
                                    if (!bt && !sc) continue;
                                    Dl.push(vt.geometry);
                                    const uc = Object.assign({}, vt);
                                    if (le1.set(Fl.id, uc), bt && (Dl.push(Fl.newGeometry), uc.geometry = Fl.newGeometry), sc) {
                                        if (uc.properties = Fl.removeAllProperties ? {} : Object.assign({}, uc.properties || {}), Fl.removeProperties) for (const le1 of Fl.removeProperties)delete uc.properties[le1];
                                        if (Fl.addOrUpdateProperties) for (const { key: le1, value: vt } of Fl.addOrUpdateProperties)uc.properties[le1] = vt;
                                    }
                                }
                            }(this._dataUpdateable, le1, vt);
                            const ls = Array.from(this._dataUpdateable.values());
                            return this._toFeatureCollection(ls);
                        }
                        _filterGeoJSON(le1, vt) {
                            const bt = en(vt, {
                                type: "boolean",
                                "property-type": "data-driven",
                                overridable: !1,
                                transition: !1
                            });
                            if ("error" === bt.result) throw new Error(bt.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                            const ls = le1.features.filter((le1)=>bt.value.evaluate({
                                    zoom: 0
                                }, le1));
                            return this._toFeatureCollection(ls);
                        }
                        _toFeatureCollection(le1) {
                            return {
                                type: "FeatureCollection",
                                features: le1
                            };
                        }
                        removeSource(le1) {
                            return e(this, void 0, void 0, function*() {
                                this._pendingRequest && this._pendingRequest.abort();
                            });
                        }
                        getClusterExpansionZoom(le1) {
                            return this._geoJSONIndex.getClusterExpansionZoom(le1.clusterId);
                        }
                        getClusterChildren(le1) {
                            return this._geoJSONIndex.getChildren(le1.clusterId);
                        }
                        getClusterLeaves(le1) {
                            return this._geoJSONIndex.getLeaves(le1.clusterId, le1.limit, le1.offset);
                        }
                    }
                    function Cd(le1, vt) {
                        return vt.cluster ? new Zf(function(le1) {
                            let { superclusterOptions: vt, clusterProperties: bt } = le1;
                            if (!bt || !vt) return vt;
                            const ls = {}, ho = {}, Dl = {
                                accumulated: null,
                                zoom: 0
                            }, Fl = {
                                properties: null
                            }, sc = Object.keys(bt);
                            for (const uc of sc){
                                const [le1, vt] = bt[uc], Dl = en(vt), Fl = en("string" == typeof le1 ? [
                                    le1,
                                    [
                                        "accumulated"
                                    ],
                                    [
                                        "get",
                                        uc
                                    ]
                                ] : le1);
                                ls[uc] = Dl.value, ho[uc] = Fl.value;
                            }
                            return vt.map = (le1)=>{
                                Fl.properties = le1;
                                const vt = {};
                                for (const bt of sc)vt[bt] = ls[bt].evaluate(Dl, Fl);
                                return vt;
                            }, vt.reduce = (le1, vt)=>{
                                Fl.properties = vt;
                                for (const bt of sc)Dl.accumulated = le1[bt], le1[bt] = ho[bt].evaluate(Dl, Fl);
                            }, vt;
                        }(vt)).load(le1.features) : function(le1, vt) {
                            return new Dd(le1, vt);
                        }(le1, vt.geojsonVtOptions);
                    }
                    class Vd {
                        constructor(le1){
                            this.self = le1, this.actor = new bi(le1), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = new Map, this.self.registerWorkerSource = (le1, vt)=>{
                                if (this.externalWorkerSourceTypes[le1]) throw new Error(`Worker source with name "${le1}" already registered.`);
                                this.externalWorkerSourceTypes[le1] = vt;
                            }, this.self.addProtocol = si, this.self.removeProtocol = oi, this.self.registerRTLTextPlugin = (le1)=>{
                                Um.setMethods(le1);
                            }, this.actor.registerMessageHandler("LDT", (le1, vt)=>this._getDEMWorkerSource(le1, vt.source).loadTile(vt)), this.actor.registerMessageHandler("RDT", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    this._getDEMWorkerSource(le1, vt.source).removeTile(vt);
                                })), this.actor.registerMessageHandler("GCEZ", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(le1, vt.type, vt.source).getClusterExpansionZoom(vt);
                                })), this.actor.registerMessageHandler("GCC", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(le1, vt.type, vt.source).getClusterChildren(vt);
                                })), this.actor.registerMessageHandler("GCL", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    return this._getWorkerSource(le1, vt.type, vt.source).getClusterLeaves(vt);
                                })), this.actor.registerMessageHandler("LD", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).loadData(vt)), this.actor.registerMessageHandler("GD", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).getData()), this.actor.registerMessageHandler("LT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).loadTile(vt)), this.actor.registerMessageHandler("RT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).reloadTile(vt)), this.actor.registerMessageHandler("AT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).abortTile(vt)), this.actor.registerMessageHandler("RMT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).removeTile(vt)), this.actor.registerMessageHandler("RS", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    if (!this.workerSources[le1] || !this.workerSources[le1][vt.type] || !this.workerSources[le1][vt.type][vt.source]) return;
                                    const bt = this.workerSources[le1][vt.type][vt.source];
                                    delete this.workerSources[le1][vt.type][vt.source], void 0 !== bt.removeSource && bt.removeSource(vt);
                                })), this.actor.registerMessageHandler("RM", (le1)=>e(this, void 0, void 0, function*() {
                                    delete this.layerIndexes[le1], delete this.availableImages[le1], delete this.workerSources[le1], delete this.demWorkerSources[le1], this.globalStates.delete(le1);
                                })), this.actor.registerMessageHandler("SR", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    this.referrer = vt;
                                })), this.actor.registerMessageHandler("SRPS", (le1, vt)=>this._syncRTLPluginState(le1, vt)), this.actor.registerMessageHandler("IS", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    this.self.importScripts(vt);
                                })), this.actor.registerMessageHandler("SI", (le1, vt)=>this._setImages(le1, vt)), this.actor.registerMessageHandler("UL", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    this._getLayerIndex(le1).update(vt.layers, vt.removedIds, this._getGlobalState(le1));
                                })), this.actor.registerMessageHandler("UGS", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    const bt = this._getGlobalState(le1);
                                    for(const le1 in vt)bt[le1] = vt[le1];
                                })), this.actor.registerMessageHandler("SL", (le1, vt)=>e(this, void 0, void 0, function*() {
                                    this._getLayerIndex(le1).replace(vt, this._getGlobalState(le1));
                                }));
                        }
                        _getGlobalState(le1) {
                            let vt = this.globalStates.get(le1);
                            return vt || (vt = {}, this.globalStates.set(le1, vt)), vt;
                        }
                        _setImages(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                this.availableImages[le1] = vt;
                                for(const bt in this.workerSources[le1]){
                                    const ls = this.workerSources[le1][bt];
                                    for(const le1 in ls)ls[le1].availableImages = vt;
                                }
                            });
                        }
                        _syncRTLPluginState(le1, vt) {
                            return e(this, void 0, void 0, function*() {
                                return yield Um.syncState(vt, this.self.importScripts);
                            });
                        }
                        _getAvailableImages(le1) {
                            let vt = this.availableImages[le1];
                            return vt || (vt = []), vt;
                        }
                        _getLayerIndex(le1) {
                            let vt = this.layerIndexes[le1];
                            return vt || (vt = this.layerIndexes[le1] = new Ep), vt;
                        }
                        _getWorkerSource(le1, vt, bt) {
                            if (this.workerSources[le1] || (this.workerSources[le1] = {}), this.workerSources[le1][vt] || (this.workerSources[le1][vt] = {}), !this.workerSources[le1][vt][bt]) {
                                const ls = {
                                    sendAsync: (vt, bt)=>(vt.targetMapId = le1, this.actor.sendAsync(vt, bt))
                                };
                                switch(vt){
                                    case "vector":
                                        this.workerSources[le1][vt][bt] = new Bf(ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                        break;
                                    case "geojson":
                                        this.workerSources[le1][vt][bt] = new Bd(ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                        break;
                                    default:
                                        this.workerSources[le1][vt][bt] = new this.externalWorkerSourceTypes[vt](ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                }
                            }
                            return this.workerSources[le1][vt][bt];
                        }
                        _getDEMWorkerSource(le1, vt) {
                            return this.demWorkerSources[le1] || (this.demWorkerSources[le1] = {}), this.demWorkerSources[le1][vt] || (this.demWorkerSources[le1][vt] = new Cf), this.demWorkerSources[le1][vt];
                        }
                    }
                    b(self) && (self.worker = new Vd(self));
                }();
            },
            927: function(le1) {
                /**
 * MapLibre GL JS
 * @license 3-Clause BSD. Full text of license: https://github.com/maplibre/maplibre-gl-js/blob/v5.17.0/LICENSE.txt
 */ le1.exports = function() {
                    "use strict";
                    var le1 = {}, vt = {};
                    function define(bt, ls, ho) {
                        if (vt[bt] = ho, "index" === bt) {
                            var Dl = "var sharedModule = {}; (" + vt.shared + ")(sharedModule); (" + vt.worker + ")(sharedModule);", Fl = {};
                            return vt.shared(Fl), vt.index(le1, Fl), "undefined" !== typeof window && le1.setWorkerUrl(window.URL.createObjectURL(new Blob([
                                Dl
                            ], {
                                type: "text/javascript"
                            }))), le1;
                        }
                    }
                    return define("shared", [
                        "exports"
                    ], function(le1) {
                        function e(le1, vt, bt, ls) {
                            return new (bt || (bt = Promise))(function(ho, Dl) {
                                function a(le1) {
                                    try {
                                        l(ls.next(le1));
                                    } catch (le1) {
                                        Dl(le1);
                                    }
                                }
                                function o(le1) {
                                    try {
                                        l(ls.throw(le1));
                                    } catch (le1) {
                                        Dl(le1);
                                    }
                                }
                                function l(le1) {
                                    var vt;
                                    le1.done ? ho(le1.value) : (vt = le1.value, vt instanceof bt ? vt : new bt(function(le1) {
                                        le1(vt);
                                    })).then(a, o);
                                }
                                l((ls = ls.apply(le1, vt || [])).next());
                            });
                        }
                        function r(le1, vt) {
                            this.x = le1, this.y = vt;
                        }
                        function n(le1) {
                            return le1 && le1.__esModule && Object.prototype.hasOwnProperty.call(le1, "default") ? le1.default : le1;
                        }
                        var vt, bt;
                        "function" == typeof SuppressedError && SuppressedError, r.prototype = {
                            clone () {
                                return new r(this.x, this.y);
                            },
                            add (le1) {
                                return this.clone()._add(le1);
                            },
                            sub (le1) {
                                return this.clone()._sub(le1);
                            },
                            multByPoint (le1) {
                                return this.clone()._multByPoint(le1);
                            },
                            divByPoint (le1) {
                                return this.clone()._divByPoint(le1);
                            },
                            mult (le1) {
                                return this.clone()._mult(le1);
                            },
                            div (le1) {
                                return this.clone()._div(le1);
                            },
                            rotate (le1) {
                                return this.clone()._rotate(le1);
                            },
                            rotateAround (le1, vt) {
                                return this.clone()._rotateAround(le1, vt);
                            },
                            matMult (le1) {
                                return this.clone()._matMult(le1);
                            },
                            unit () {
                                return this.clone()._unit();
                            },
                            perp () {
                                return this.clone()._perp();
                            },
                            round () {
                                return this.clone()._round();
                            },
                            mag () {
                                return Math.sqrt(this.x * this.x + this.y * this.y);
                            },
                            equals (le1) {
                                return this.x === le1.x && this.y === le1.y;
                            },
                            dist (le1) {
                                return Math.sqrt(this.distSqr(le1));
                            },
                            distSqr (le1) {
                                const vt = le1.x - this.x, bt = le1.y - this.y;
                                return vt * vt + bt * bt;
                            },
                            angle () {
                                return Math.atan2(this.y, this.x);
                            },
                            angleTo (le1) {
                                return Math.atan2(this.y - le1.y, this.x - le1.x);
                            },
                            angleWith (le1) {
                                return this.angleWithSep(le1.x, le1.y);
                            },
                            angleWithSep (le1, vt) {
                                return Math.atan2(this.x * vt - this.y * le1, this.x * le1 + this.y * vt);
                            },
                            _matMult (le1) {
                                const vt = le1[2] * this.x + le1[3] * this.y;
                                return this.x = le1[0] * this.x + le1[1] * this.y, this.y = vt, this;
                            },
                            _add (le1) {
                                return this.x += le1.x, this.y += le1.y, this;
                            },
                            _sub (le1) {
                                return this.x -= le1.x, this.y -= le1.y, this;
                            },
                            _mult (le1) {
                                return this.x *= le1, this.y *= le1, this;
                            },
                            _div (le1) {
                                return this.x /= le1, this.y /= le1, this;
                            },
                            _multByPoint (le1) {
                                return this.x *= le1.x, this.y *= le1.y, this;
                            },
                            _divByPoint (le1) {
                                return this.x /= le1.x, this.y /= le1.y, this;
                            },
                            _unit () {
                                return this._div(this.mag()), this;
                            },
                            _perp () {
                                const le1 = this.y;
                                return this.y = this.x, this.x = -le1, this;
                            },
                            _rotate (le1) {
                                const vt = Math.cos(le1), bt = Math.sin(le1), ls = bt * this.x + vt * this.y;
                                return this.x = vt * this.x - bt * this.y, this.y = ls, this;
                            },
                            _rotateAround (le1, vt) {
                                const bt = Math.cos(le1), ls = Math.sin(le1), ho = vt.y + ls * (this.x - vt.x) + bt * (this.y - vt.y);
                                return this.x = vt.x + bt * (this.x - vt.x) - ls * (this.y - vt.y), this.y = ho, this;
                            },
                            _round () {
                                return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                            },
                            constructor: r
                        }, r.convert = function(le1) {
                            if (le1 instanceof r) return le1;
                            if (Array.isArray(le1)) return new r(+le1[0], +le1[1]);
                            if (void 0 !== le1.x && void 0 !== le1.y) return new r(+le1.x, +le1.y);
                            throw new Error("Expected [x, y] or {x, y} point format");
                        };
                        var ls = function() {
                            if (bt) return vt;
                            function t(le1, vt, bt, ls) {
                                this.cx = 3 * le1, this.bx = 3 * (bt - le1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * vt, this.by = 3 * (ls - vt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = le1, this.p1y = vt, this.p2x = bt, this.p2y = ls;
                            }
                            return bt = 1, vt = t, t.prototype = {
                                sampleCurveX: function(le1) {
                                    return ((this.ax * le1 + this.bx) * le1 + this.cx) * le1;
                                },
                                sampleCurveY: function(le1) {
                                    return ((this.ay * le1 + this.by) * le1 + this.cy) * le1;
                                },
                                sampleCurveDerivativeX: function(le1) {
                                    return (3 * this.ax * le1 + 2 * this.bx) * le1 + this.cx;
                                },
                                solveCurveX: function(le1, vt) {
                                    if (void 0 === vt && (vt = 1e-6), le1 < 0) return 0;
                                    if (le1 > 1) return 1;
                                    for(var bt = le1, ls = 0; ls < 8; ls++){
                                        var ho = this.sampleCurveX(bt) - le1;
                                        if (Math.abs(ho) < vt) return bt;
                                        var Dl = this.sampleCurveDerivativeX(bt);
                                        if (Math.abs(Dl) < 1e-6) break;
                                        bt -= ho / Dl;
                                    }
                                    var Fl = 0, sc = 1;
                                    for(bt = le1, ls = 0; ls < 20 && (ho = this.sampleCurveX(bt), !(Math.abs(ho - le1) < vt)); ls++)le1 > ho ? Fl = bt : sc = bt, bt = .5 * (sc - Fl) + Fl;
                                    return bt;
                                },
                                solve: function(le1, vt) {
                                    return this.sampleCurveY(this.solveCurveX(le1, vt));
                                }
                            }, vt;
                        }(), ho = n(ls);
                        let Dl, Fl;
                        function c() {
                            return null == Dl && (Dl = "undefined" != typeof OffscreenCanvas && new OffscreenCanvas(1, 1).getContext("2d") && "function" == typeof createImageBitmap), Dl;
                        }
                        function h() {
                            if (null == Fl && (Fl = !1, c())) {
                                const le1 = 5, vt = new OffscreenCanvas(le1, le1).getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (vt) {
                                    for(let ls = 0; ls < le1 * le1; ls++){
                                        const bt = 4 * ls;
                                        vt.fillStyle = `rgb(${bt},${bt + 1},${bt + 2})`, vt.fillRect(ls % le1, Math.floor(ls / le1), 1, 1);
                                    }
                                    const bt = vt.getImageData(0, 0, le1, le1).data;
                                    for(let vt = 0; vt < le1 * le1 * 4; vt++)if (vt % 4 != 3 && bt[vt] !== vt) {
                                        Fl = !0;
                                        break;
                                    }
                                }
                            }
                            return Fl || !1;
                        }
                        var sc = 1e-6, uc = "undefined" != typeof Float32Array ? Float32Array : Array;
                        function d() {
                            var le1 = new uc(9);
                            return uc != Float32Array && (le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[5] = 0, le1[6] = 0, le1[7] = 0), le1[0] = 1, le1[4] = 1, le1[8] = 1, le1;
                        }
                        function y(le1) {
                            return le1[0] = 1, le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[4] = 0, le1[5] = 1, le1[6] = 0, le1[7] = 0, le1[8] = 0, le1[9] = 0, le1[10] = 1, le1[11] = 0, le1[12] = 0, le1[13] = 0, le1[14] = 0, le1[15] = 1, le1;
                        }
                        function m() {
                            var le1 = new uc(3);
                            return uc != Float32Array && (le1[0] = 0, le1[1] = 0, le1[2] = 0), le1;
                        }
                        function g(le1) {
                            var vt = le1[0], bt = le1[1], ls = le1[2];
                            return Math.sqrt(vt * vt + bt * bt + ls * ls);
                        }
                        function x(le1, vt, bt) {
                            var ls = new uc(3);
                            return ls[0] = le1, ls[1] = vt, ls[2] = bt, ls;
                        }
                        function v(le1, vt, bt) {
                            return le1[0] = vt[0] + bt[0], le1[1] = vt[1] + bt[1], le1[2] = vt[2] + bt[2], le1;
                        }
                        function b(le1, vt, bt) {
                            return le1[0] = vt[0] * bt, le1[1] = vt[1] * bt, le1[2] = vt[2] * bt, le1;
                        }
                        function w(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1], Dl = vt[2], Fl = bt[0], sc = bt[1], uc = bt[2];
                            return le1[0] = ho * uc - Dl * sc, le1[1] = Dl * Fl - ls * uc, le1[2] = ls * sc - ho * Fl, le1;
                        }
                        var mc, gc = g;
                        function A(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1], Dl = vt[2], Fl = vt[3];
                            return le1[0] = bt[0] * ls + bt[4] * ho + bt[8] * Dl + bt[12] * Fl, le1[1] = bt[1] * ls + bt[5] * ho + bt[9] * Dl + bt[13] * Fl, le1[2] = bt[2] * ls + bt[6] * ho + bt[10] * Dl + bt[14] * Fl, le1[3] = bt[3] * ls + bt[7] * ho + bt[11] * Dl + bt[15] * Fl, le1;
                        }
                        function k() {
                            var le1 = new uc(4);
                            return uc != Float32Array && (le1[0] = 0, le1[1] = 0, le1[2] = 0), le1[3] = 1, le1;
                        }
                        function E(le1, vt, bt, ls) {
                            var ho = arguments.length > 4 && void 0 !== arguments[4] ? arguments[4] : "zyx", Dl = Math.PI / 360;
                            vt *= Dl, ls *= Dl, bt *= Dl;
                            var Fl = Math.sin(vt), sc = Math.cos(vt), uc = Math.sin(bt), mc = Math.cos(bt), gc = Math.sin(ls), Ac = Math.cos(ls);
                            switch(ho){
                                case "xyz":
                                    le1[0] = Fl * mc * Ac + sc * uc * gc, le1[1] = sc * uc * Ac - Fl * mc * gc, le1[2] = sc * mc * gc + Fl * uc * Ac, le1[3] = sc * mc * Ac - Fl * uc * gc;
                                    break;
                                case "xzy":
                                    le1[0] = Fl * mc * Ac - sc * uc * gc, le1[1] = sc * uc * Ac - Fl * mc * gc, le1[2] = sc * mc * gc + Fl * uc * Ac, le1[3] = sc * mc * Ac + Fl * uc * gc;
                                    break;
                                case "yxz":
                                    le1[0] = Fl * mc * Ac + sc * uc * gc, le1[1] = sc * uc * Ac - Fl * mc * gc, le1[2] = sc * mc * gc - Fl * uc * Ac, le1[3] = sc * mc * Ac + Fl * uc * gc;
                                    break;
                                case "yzx":
                                    le1[0] = Fl * mc * Ac + sc * uc * gc, le1[1] = sc * uc * Ac + Fl * mc * gc, le1[2] = sc * mc * gc - Fl * uc * Ac, le1[3] = sc * mc * Ac - Fl * uc * gc;
                                    break;
                                case "zxy":
                                    le1[0] = Fl * mc * Ac - sc * uc * gc, le1[1] = sc * uc * Ac + Fl * mc * gc, le1[2] = sc * mc * gc + Fl * uc * Ac, le1[3] = sc * mc * Ac - Fl * uc * gc;
                                    break;
                                case "zyx":
                                    le1[0] = Fl * mc * Ac - sc * uc * gc, le1[1] = sc * uc * Ac + Fl * mc * gc, le1[2] = sc * mc * gc - Fl * uc * Ac, le1[3] = sc * mc * Ac + Fl * uc * gc;
                                    break;
                                default:
                                    throw new Error("Unknown angle order " + ho);
                            }
                            return le1;
                        }
                        function T() {
                            var le1 = new uc(2);
                            return uc != Float32Array && (le1[0] = 0, le1[1] = 0), le1;
                        }
                        function I(le1, vt) {
                            var bt = new uc(2);
                            return bt[0] = le1, bt[1] = vt, bt;
                        }
                        m(), mc = new uc(4), uc != Float32Array && (mc[0] = 0, mc[1] = 0, mc[2] = 0, mc[3] = 0), m(), x(1, 0, 0), x(0, 1, 0), k(), k(), d(), T();
                        const Ac = 8192;
                        function F(le1, vt, bt) {
                            return vt * (Ac / (le1.tileSize * Math.pow(2, bt - le1.tileID.overscaledZ)));
                        }
                        function D(le1, vt) {
                            return (le1 % vt + vt) % vt;
                        }
                        function z(le1, vt, bt) {
                            return le1 * (1 - bt) + vt * bt;
                        }
                        function P(le1) {
                            if (le1 <= 0) return 0;
                            if (le1 >= 1) return 1;
                            const vt = le1 * le1, bt = vt * le1;
                            return 4 * (le1 < .5 ? bt : 3 * (le1 - vt) + bt - .75);
                        }
                        function B(le1, vt, bt, ls) {
                            const Dl = new ho(le1, vt, bt, ls);
                            return (le1)=>Dl.solve(le1);
                        }
                        const Ec = B(.25, .1, .25, 1);
                        function C(le1, vt, bt) {
                            return Math.min(bt, Math.max(vt, le1));
                        }
                        function L1(le1, vt, bt) {
                            const ls = bt - vt, ho = ((le1 - vt) % ls + ls) % ls + vt;
                            return ho === vt ? bt : ho;
                        }
                        function O(le1, ...vt) {
                            for (const bt of vt)for(const vt in bt)le1[vt] = bt[vt];
                            return le1;
                        }
                        let kc = 1;
                        function N(le1, vt, bt) {
                            const ls = {};
                            for(const ho in le1)ls[ho] = vt.call(this, le1[ho], ho, le1);
                            return ls;
                        }
                        function $(le1, vt, bt) {
                            const ls = {};
                            for(const ho in le1)vt.call(this, le1[ho], ho, le1) && (ls[ho] = le1[ho]);
                            return ls;
                        }
                        function U(le1) {
                            return Array.isArray(le1) ? le1.map(U) : "object" == typeof le1 && le1 ? N(le1, U) : le1;
                        }
                        const du = {};
                        function j(le1) {
                            du[le1] || ("undefined" != typeof console && console.warn(le1), du[le1] = !0);
                        }
                        function G(le1, vt, bt) {
                            return (bt.y - le1.y) * (vt.x - le1.x) > (vt.y - le1.y) * (bt.x - le1.x);
                        }
                        function X(le1) {
                            return "undefined" != typeof WorkerGlobalScope && void 0 !== le1 && le1 instanceof WorkerGlobalScope;
                        }
                        let _u = null;
                        function Z(le1) {
                            return "undefined" != typeof ImageBitmap && le1 instanceof ImageBitmap;
                        }
                        const Md = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";
                        function K(le1, vt, bt, ls, ho) {
                            return e(this, void 0, void 0, function*() {
                                if ("undefined" == typeof VideoFrame) throw new Error("VideoFrame not supported");
                                const Dl = new VideoFrame(le1, {
                                    timestamp: 0
                                });
                                try {
                                    const Fl = null == Dl ? void 0 : Dl.format;
                                    if (!Fl || !Fl.startsWith("BGR") && !Fl.startsWith("RGB")) throw new Error(`Unrecognized format ${Fl}`);
                                    const sc = Fl.startsWith("BGR"), uc = new Uint8ClampedArray(ls * ho * 4);
                                    if (yield Dl.copyTo(uc, function(le1, vt, bt, ls, ho) {
                                        const Dl = 4 * Math.max(-vt, 0), Fl = (Math.max(0, bt) - bt) * ls * 4 + Dl, sc = 4 * ls, uc = Math.max(0, vt), mc = Math.max(0, bt);
                                        return {
                                            rect: {
                                                x: uc,
                                                y: mc,
                                                width: Math.min(le1.width, vt + ls) - uc,
                                                height: Math.min(le1.height, bt + ho) - mc
                                            },
                                            layout: [
                                                {
                                                    offset: Fl,
                                                    stride: sc
                                                }
                                            ]
                                        };
                                    }(le1, vt, bt, ls, ho)), sc) for(let le1 = 0; le1 < uc.length; le1 += 4){
                                        const vt = uc[le1];
                                        uc[le1] = uc[le1 + 2], uc[le1 + 2] = vt;
                                    }
                                    return uc;
                                } finally{
                                    Dl.close();
                                }
                            });
                        }
                        let Ld, Nd;
                        function Q(le1, vt, bt, ls) {
                            return le1.addEventListener(vt, bt, ls), {
                                unsubscribe: ()=>{
                                    le1.removeEventListener(vt, bt, ls);
                                }
                            };
                        }
                        function tt(le1) {
                            return le1 * Math.PI / 180;
                        }
                        function et(le1) {
                            return le1 / Math.PI * 180;
                        }
                        const Rd = {
                            touchstart: !0,
                            touchmove: !0,
                            touchmoveWindow: !0,
                            touchend: !0,
                            touchcancel: !0
                        }, Od = {
                            dblclick: !0,
                            click: !0,
                            mouseover: !0,
                            mouseout: !0,
                            mousedown: !0,
                            mousemove: !0,
                            mousemoveWindow: !0,
                            mouseup: !0,
                            mouseupWindow: !0,
                            contextmenu: !0,
                            wheel: !0
                        }, jd = "AbortError";
                        class st extends Error {
                            constructor(le1 = jd){
                                super(le1 instanceof Error ? le1.message : le1), this.name = jd, le1 instanceof Error && le1.stack && (this.stack = le1.stack);
                            }
                        }
                        function at(le1) {
                            return le1.name === jd;
                        }
                        const Ud = {
                            MAX_PARALLEL_IMAGE_REQUESTS: 16,
                            MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME: 8,
                            MAX_TILE_CACHE_ZOOM_LEVELS: 5,
                            REGISTERED_PROTOCOLS: {},
                            WORKER_URL: ""
                        };
                        function lt(le1) {
                            return Ud.REGISTERED_PROTOCOLS[le1.substring(0, le1.indexOf("://"))];
                        }
                        const Gd = "global-dispatcher";
                        class ct extends Error {
                            constructor(le1, vt, bt, ls){
                                super(`AJAXError: ${vt} (${le1}): ${bt}`), this.status = le1, this.statusText = vt, this.url = bt, this.body = ls;
                            }
                        }
                        const ht = ()=>X(self) ? self.worker && self.worker.referrer : ("blob:" === window.location.protocol ? window.parent : window).location.href, pt = function(le1, vt) {
                            if (/:\/\//.test(le1.url) && !/^https?:|^file:/.test(le1.url)) {
                                const bt = lt(le1.url);
                                if (bt) return bt(le1, vt);
                                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: le1,
                                    targetMapId: Gd
                                }, vt);
                            }
                            if (!(/^file:/.test(bt = le1.url) || /^file:/.test(ht()) && !/^\w+:/.test(bt))) {
                                if (fetch && Request && AbortController && Object.prototype.hasOwnProperty.call(Request.prototype, "signal")) return function(le1, vt) {
                                    return e(this, void 0, void 0, function*() {
                                        const bt = new Request(le1.url, {
                                            method: le1.method || "GET",
                                            body: le1.body,
                                            credentials: le1.credentials,
                                            headers: le1.headers,
                                            cache: le1.cache,
                                            referrer: ht(),
                                            signal: vt.signal
                                        });
                                        let ls, ho;
                                        "json" !== le1.type || bt.headers.has("Accept") || bt.headers.set("Accept", "application/json");
                                        try {
                                            ls = yield fetch(bt);
                                        } catch (bt) {
                                            if (at(bt)) throw bt;
                                            throw new ct(0, bt.message, le1.url, new Blob);
                                        }
                                        if (!ls.ok) {
                                            const vt = yield ls.blob();
                                            throw new ct(ls.status, ls.statusText, le1.url, vt);
                                        }
                                        ho = "arrayBuffer" === le1.type || "image" === le1.type ? ls.arrayBuffer() : "json" === le1.type ? ls.json() : ls.text();
                                        const Dl = yield ho;
                                        return vt.signal.throwIfAborted(), {
                                            data: Dl,
                                            cacheControl: ls.headers.get("Cache-Control"),
                                            expires: ls.headers.get("Expires")
                                        };
                                    });
                                }(le1, vt);
                                if (X(self) && self.worker && self.worker.actor) return self.worker.actor.sendAsync({
                                    type: "GR",
                                    data: le1,
                                    mustQueue: !0,
                                    targetMapId: Gd
                                }, vt);
                            }
                            var bt;
                            return function(le1, vt) {
                                return new Promise((bt, ls)=>{
                                    var ho;
                                    const Dl = new XMLHttpRequest;
                                    Dl.open(le1.method || "GET", le1.url, !0), "arrayBuffer" !== le1.type && "image" !== le1.type || (Dl.responseType = "arraybuffer");
                                    for(const vt in le1.headers)Dl.setRequestHeader(vt, le1.headers[vt]);
                                    "json" === le1.type && (Dl.responseType = "text", (null === (ho = le1.headers) || void 0 === ho ? void 0 : ho.Accept) || Dl.setRequestHeader("Accept", "application/json")), Dl.withCredentials = "include" === le1.credentials, Dl.onerror = ()=>{
                                        ls(new Error(Dl.statusText));
                                    }, Dl.onload = ()=>{
                                        if (!vt.signal.aborted) {
                                            if ((Dl.status >= 200 && Dl.status < 300 || 0 === Dl.status) && null !== Dl.response) {
                                                let vt = Dl.response;
                                                if ("json" === le1.type) try {
                                                    vt = JSON.parse(Dl.response);
                                                } catch (le1) {
                                                    return void ls(le1);
                                                }
                                                bt({
                                                    data: vt,
                                                    cacheControl: Dl.getResponseHeader("Cache-Control"),
                                                    expires: Dl.getResponseHeader("Expires")
                                                });
                                            } else {
                                                const vt = new Blob([
                                                    Dl.response
                                                ], {
                                                    type: Dl.getResponseHeader("Content-Type")
                                                });
                                                ls(new ct(Dl.status, Dl.statusText, le1.url, vt));
                                            }
                                        }
                                    }, vt.signal.addEventListener("abort", ()=>{
                                        Dl.abort(), ls(new st(vt.signal.reason));
                                    }), Dl.send(le1.body);
                                });
                            }(le1, vt);
                        };
                        function ft(le1) {
                            if (!le1 || le1.indexOf("://") <= 0 || 0 === le1.indexOf("data:image/") || 0 === le1.indexOf("blob:")) return !0;
                            const vt = new URL(le1), bt = window.location;
                            return vt.protocol === bt.protocol && vt.host === bt.host;
                        }
                        function dt(le1, vt, bt) {
                            bt[le1] && -1 !== bt[le1].indexOf(vt) || (bt[le1] = bt[le1] || [], bt[le1].push(vt));
                        }
                        function yt(le1, vt, bt) {
                            if (bt && bt[le1]) {
                                const ls = bt[le1].indexOf(vt);
                                -1 !== ls && bt[le1].splice(ls, 1);
                            }
                        }
                        class mt {
                            constructor(le1, vt = {}){
                                O(this, vt), this.type = le1;
                            }
                        }
                        class gt extends mt {
                            constructor(le1, vt = {}){
                                super("error", O({
                                    error: le1
                                }, vt));
                            }
                        }
                        class xt {
                            on(le1, vt) {
                                return this._listeners = this._listeners || {}, dt(le1, vt, this._listeners), {
                                    unsubscribe: ()=>{
                                        this.off(le1, vt);
                                    }
                                };
                            }
                            off(le1, vt) {
                                return yt(le1, vt, this._listeners), yt(le1, vt, this._oneTimeListeners), this;
                            }
                            once(le1, vt) {
                                return vt ? (this._oneTimeListeners = this._oneTimeListeners || {}, dt(le1, vt, this._oneTimeListeners), this) : new Promise((vt)=>this.once(le1, vt));
                            }
                            fire(le1, vt) {
                                "string" == typeof le1 && (le1 = new mt(le1, vt || {}));
                                const bt = le1.type;
                                if (this.listens(bt)) {
                                    le1.target = this;
                                    const vt = this._listeners && this._listeners[bt] ? this._listeners[bt].slice() : [];
                                    for (const bt of vt)bt.call(this, le1);
                                    const ls = this._oneTimeListeners && this._oneTimeListeners[bt] ? this._oneTimeListeners[bt].slice() : [];
                                    for (const Dl of ls)yt(bt, Dl, this._oneTimeListeners), Dl.call(this, le1);
                                    const ho = this._eventedParent;
                                    ho && (O(le1, "function" == typeof this._eventedParentData ? this._eventedParentData() : this._eventedParentData), ho.fire(le1));
                                } else le1 instanceof gt && console.error(le1.error);
                                return this;
                            }
                            listens(le1) {
                                return this._listeners && this._listeners[le1] && this._listeners[le1].length > 0 || this._oneTimeListeners && this._oneTimeListeners[le1] && this._oneTimeListeners[le1].length > 0 || this._eventedParent && this._eventedParent.listens(le1);
                            }
                            setEventedParent(le1, vt) {
                                return this._eventedParent = le1, this._eventedParentData = vt, this;
                            }
                        }
                        var qd = {
                            $version: 8,
                            $root: {
                                version: {
                                    required: !0,
                                    type: "enum",
                                    values: [
                                        8
                                    ]
                                },
                                name: {
                                    type: "string"
                                },
                                metadata: {
                                    type: "*"
                                },
                                center: {
                                    type: "array",
                                    value: "number",
                                    length: 2
                                },
                                centerAltitude: {
                                    type: "number"
                                },
                                zoom: {
                                    type: "number"
                                },
                                bearing: {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees"
                                },
                                pitch: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                roll: {
                                    type: "number",
                                    default: 0,
                                    units: "degrees"
                                },
                                state: {
                                    type: "state",
                                    default: {}
                                },
                                light: {
                                    type: "light"
                                },
                                sky: {
                                    type: "sky"
                                },
                                projection: {
                                    type: "projection"
                                },
                                terrain: {
                                    type: "terrain"
                                },
                                sources: {
                                    required: !0,
                                    type: "sources"
                                },
                                sprite: {
                                    type: "sprite"
                                },
                                glyphs: {
                                    type: "string"
                                },
                                "font-faces": {
                                    type: "fontFaces"
                                },
                                transition: {
                                    type: "transition"
                                },
                                layers: {
                                    required: !0,
                                    type: "array",
                                    value: "layer"
                                }
                            },
                            sources: {
                                "*": {
                                    type: "source"
                                }
                            },
                            source: [
                                "source_vector",
                                "source_raster",
                                "source_raster_dem",
                                "source_geojson",
                                "source_video",
                                "source_image"
                            ],
                            source_vector: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        vector: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                attribution: {
                                    type: "string"
                                },
                                promoteId: {
                                    type: "promoteId"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        mvt: {},
                                        mlt: {}
                                    },
                                    default: "mvt"
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        raster: {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                scheme: {
                                    type: "enum",
                                    values: {
                                        xyz: {},
                                        tms: {}
                                    },
                                    default: "xyz"
                                },
                                attribution: {
                                    type: "string"
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_raster_dem: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        "raster-dem": {}
                                    }
                                },
                                url: {
                                    type: "string"
                                },
                                tiles: {
                                    type: "array",
                                    value: "string"
                                },
                                bounds: {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        -180,
                                        -85.051129,
                                        180,
                                        85.051129
                                    ]
                                },
                                minzoom: {
                                    type: "number",
                                    default: 0
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 22
                                },
                                tileSize: {
                                    type: "number",
                                    default: 512,
                                    units: "pixels"
                                },
                                attribution: {
                                    type: "string"
                                },
                                encoding: {
                                    type: "enum",
                                    values: {
                                        terrarium: {},
                                        mapbox: {},
                                        custom: {}
                                    },
                                    default: "mapbox"
                                },
                                redFactor: {
                                    type: "number",
                                    default: 1
                                },
                                blueFactor: {
                                    type: "number",
                                    default: 1
                                },
                                greenFactor: {
                                    type: "number",
                                    default: 1
                                },
                                baseShift: {
                                    type: "number",
                                    default: 0
                                },
                                volatile: {
                                    type: "boolean",
                                    default: !1
                                },
                                "*": {
                                    type: "*"
                                }
                            },
                            source_geojson: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        geojson: {}
                                    }
                                },
                                data: {
                                    required: !0,
                                    type: "*"
                                },
                                maxzoom: {
                                    type: "number",
                                    default: 18
                                },
                                attribution: {
                                    type: "string"
                                },
                                buffer: {
                                    type: "number",
                                    default: 128,
                                    maximum: 512,
                                    minimum: 0
                                },
                                filter: {
                                    type: "filter"
                                },
                                tolerance: {
                                    type: "number",
                                    default: .375
                                },
                                cluster: {
                                    type: "boolean",
                                    default: !1
                                },
                                clusterRadius: {
                                    type: "number",
                                    default: 50,
                                    minimum: 0
                                },
                                clusterMaxZoom: {
                                    type: "number"
                                },
                                clusterMinPoints: {
                                    type: "number"
                                },
                                clusterProperties: {
                                    type: "*"
                                },
                                lineMetrics: {
                                    type: "boolean",
                                    default: !1
                                },
                                generateId: {
                                    type: "boolean",
                                    default: !1
                                },
                                promoteId: {
                                    type: "promoteId"
                                }
                            },
                            source_video: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        video: {}
                                    }
                                },
                                urls: {
                                    required: !0,
                                    type: "array",
                                    value: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            source_image: {
                                type: {
                                    required: !0,
                                    type: "enum",
                                    values: {
                                        image: {}
                                    }
                                },
                                url: {
                                    required: !0,
                                    type: "string"
                                },
                                coordinates: {
                                    required: !0,
                                    type: "array",
                                    length: 4,
                                    value: {
                                        type: "array",
                                        length: 2,
                                        value: "number"
                                    }
                                }
                            },
                            layer: {
                                id: {
                                    type: "string",
                                    required: !0
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        fill: {},
                                        line: {},
                                        symbol: {},
                                        circle: {},
                                        heatmap: {},
                                        "fill-extrusion": {},
                                        raster: {},
                                        hillshade: {},
                                        "color-relief": {},
                                        background: {}
                                    },
                                    required: !0
                                },
                                metadata: {
                                    type: "*"
                                },
                                source: {
                                    type: "string"
                                },
                                "source-layer": {
                                    type: "string"
                                },
                                minzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                maxzoom: {
                                    type: "number",
                                    minimum: 0,
                                    maximum: 24
                                },
                                filter: {
                                    type: "filter"
                                },
                                layout: {
                                    type: "layout"
                                },
                                paint: {
                                    type: "paint"
                                }
                            },
                            layout: [
                                "layout_fill",
                                "layout_line",
                                "layout_circle",
                                "layout_heatmap",
                                "layout_fill-extrusion",
                                "layout_symbol",
                                "layout_raster",
                                "layout_hillshade",
                                "layout_color-relief",
                                "layout_background"
                            ],
                            layout_background: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_fill: {
                                "fill-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_circle: {
                                "circle-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_heatmap: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            "layout_fill-extrusion": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_line: {
                                "line-cap": {
                                    type: "enum",
                                    values: {
                                        butt: {},
                                        round: {},
                                        square: {}
                                    },
                                    default: "butt",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-join": {
                                    type: "enum",
                                    values: {
                                        bevel: {},
                                        round: {},
                                        miter: {}
                                    },
                                    default: "miter",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-miter-limit": {
                                    type: "number",
                                    default: 2,
                                    requires: [
                                        {
                                            "line-join": "miter"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-round-limit": {
                                    type: "number",
                                    default: 1.05,
                                    requires: [
                                        {
                                            "line-join": "round"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_symbol: {
                                "symbol-placement": {
                                    type: "enum",
                                    values: {
                                        point: {},
                                        line: {},
                                        "line-center": {}
                                    },
                                    default: "point",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-spacing": {
                                    type: "number",
                                    default: 250,
                                    minimum: 1,
                                    units: "pixels",
                                    requires: [
                                        {
                                            "symbol-placement": "line"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-avoid-edges": {
                                    type: "boolean",
                                    default: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "symbol-sort-key": {
                                    type: "number",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "symbol-z-order": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        "viewport-y": {},
                                        source: {}
                                    },
                                    default: "auto",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "!": "icon-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-size": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    units: "factor of the original icon size",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-text-fit": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        width: {},
                                        height: {},
                                        both: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "icon-image",
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-text-fit-padding": {
                                    type: "array",
                                    value: "number",
                                    length: 4,
                                    default: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image",
                                        "text-field",
                                        {
                                            "icon-text-fit": [
                                                "both",
                                                "width",
                                                "height"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-image": {
                                    type: "resolvedImage",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-padding": {
                                    type: "padding",
                                    default: [
                                        2
                                    ],
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-keep-upright": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "icon-image",
                                        {
                                            "icon-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-offset": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotation-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {},
                                        "viewport-glyph": {},
                                        auto: {}
                                    },
                                    default: "auto",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-field": {
                                    type: "formatted",
                                    default: "",
                                    tokens: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-font": {
                                    type: "array",
                                    value: "string",
                                    default: [
                                        "Open Sans Regular",
                                        "Arial Unicode MS Regular"
                                    ],
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-size": {
                                    type: "number",
                                    default: 16,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-width": {
                                    type: "number",
                                    default: 10,
                                    minimum: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-line-height": {
                                    type: "number",
                                    default: 1.2,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-letter-spacing": {
                                    type: "number",
                                    default: 0,
                                    units: "ems",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-justify": {
                                    type: "enum",
                                    values: {
                                        auto: {},
                                        left: {},
                                        center: {},
                                        right: {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-radial-offset": {
                                    type: "number",
                                    units: "ems",
                                    default: 0,
                                    requires: [
                                        "text-field"
                                    ],
                                    "property-type": "data-driven",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    }
                                },
                                "text-variable-anchor": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-variable-anchor-offset": {
                                    type: "variableAnchorOffsetCollection",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-anchor": {
                                    type: "enum",
                                    values: {
                                        center: {},
                                        left: {},
                                        right: {},
                                        top: {},
                                        bottom: {},
                                        "top-left": {},
                                        "top-right": {},
                                        "bottom-left": {},
                                        "bottom-right": {}
                                    },
                                    default: "center",
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-variable-anchor"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-max-angle": {
                                    type: "number",
                                    default: 45,
                                    units: "degrees",
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-writing-mode": {
                                    type: "array",
                                    value: "enum",
                                    values: {
                                        horizontal: {},
                                        vertical: {}
                                    },
                                    requires: [
                                        "text-field",
                                        {
                                            "symbol-placement": [
                                                "point"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    units: "degrees",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-padding": {
                                    type: "number",
                                    default: 2,
                                    minimum: 0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-keep-upright": {
                                    type: "boolean",
                                    default: !0,
                                    requires: [
                                        "text-field",
                                        {
                                            "text-rotation-alignment": "map"
                                        },
                                        {
                                            "symbol-placement": [
                                                "line",
                                                "line-center"
                                            ]
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-transform": {
                                    type: "enum",
                                    values: {
                                        none: {},
                                        uppercase: {},
                                        lowercase: {}
                                    },
                                    default: "none",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-offset": {
                                    type: "array",
                                    value: "number",
                                    units: "ems",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-radial-offset"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-allow-overlap": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        {
                                            "!": "text-overlap"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-overlap": {
                                    type: "enum",
                                    values: {
                                        never: {},
                                        always: {},
                                        cooperative: {}
                                    },
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-ignore-placement": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-optional": {
                                    type: "boolean",
                                    default: !1,
                                    requires: [
                                        "text-field",
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_raster: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            layout_hillshade: {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            "layout_color-relief": {
                                visibility: {
                                    type: "enum",
                                    values: {
                                        visible: {},
                                        none: {}
                                    },
                                    default: "visible",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "global-state"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            filter: {
                                type: "boolean",
                                expression: {
                                    interpolated: !1,
                                    parameters: [
                                        "zoom",
                                        "feature"
                                    ]
                                },
                                "property-type": "data-driven"
                            },
                            filter_operator: {
                                type: "enum",
                                values: {
                                    "==": {},
                                    "!=": {},
                                    ">": {},
                                    ">=": {},
                                    "<": {},
                                    "<=": {},
                                    in: {},
                                    "!in": {},
                                    all: {},
                                    any: {},
                                    none: {},
                                    has: {},
                                    "!has": {}
                                }
                            },
                            geometry_type: {
                                type: "enum",
                                values: {
                                    Point: {},
                                    LineString: {},
                                    Polygon: {}
                                }
                            },
                            function: {
                                expression: {
                                    type: "expression"
                                },
                                stops: {
                                    type: "array",
                                    value: "function_stop"
                                },
                                base: {
                                    type: "number",
                                    default: 1,
                                    minimum: 0
                                },
                                property: {
                                    type: "string",
                                    default: "$zoom"
                                },
                                type: {
                                    type: "enum",
                                    values: {
                                        identity: {},
                                        exponential: {},
                                        interval: {},
                                        categorical: {}
                                    },
                                    default: "exponential"
                                },
                                colorSpace: {
                                    type: "enum",
                                    values: {
                                        rgb: {},
                                        lab: {},
                                        hcl: {}
                                    },
                                    default: "rgb"
                                },
                                default: {
                                    type: "*",
                                    required: !1
                                }
                            },
                            function_stop: {
                                type: "array",
                                minimum: 0,
                                maximum: 24,
                                value: [
                                    "number",
                                    "color"
                                ],
                                length: 2
                            },
                            expression: {
                                type: "array",
                                value: "expression_name",
                                minimum: 1
                            },
                            light: {
                                anchor: {
                                    type: "enum",
                                    default: "viewport",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                position: {
                                    type: "array",
                                    default: [
                                        1.15,
                                        210,
                                        30
                                    ],
                                    length: 3,
                                    value: "number",
                                    "property-type": "data-constant",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                },
                                color: {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                intensity: {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            sky: {
                                "sky-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#88C6FC",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-color": {
                                    type: "color",
                                    "property-type": "data-constant",
                                    default: "#ffffff",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "fog-ground-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "horizon-fog-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "sky-horizon-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                },
                                "atmosphere-blend": {
                                    type: "number",
                                    "property-type": "data-constant",
                                    default: .8,
                                    minimum: 0,
                                    maximum: 1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    transition: !0
                                }
                            },
                            terrain: {
                                source: {
                                    type: "string",
                                    required: !0
                                },
                                exaggeration: {
                                    type: "number",
                                    minimum: 0,
                                    default: 1
                                }
                            },
                            projection: {
                                type: {
                                    type: "projectionDefinition",
                                    default: "mercator",
                                    "property-type": "data-constant",
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    }
                                }
                            },
                            paint: [
                                "paint_fill",
                                "paint_line",
                                "paint_circle",
                                "paint_heatmap",
                                "paint_fill-extrusion",
                                "paint_symbol",
                                "paint_raster",
                                "paint_hillshade",
                                "paint_color-relief",
                                "paint_background"
                            ],
                            paint_fill: {
                                "fill-antialias": {
                                    type: "boolean",
                                    default: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-outline-color": {
                                    type: "color",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-pattern"
                                        },
                                        {
                                            "fill-antialias": !0
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                }
                            },
                            "paint_fill-extrusion": {
                                "fill-extrusion-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "fill-extrusion-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "fill-extrusion-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "fill-extrusion-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "fill-extrusion-height": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-base": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "meters",
                                    transition: !0,
                                    requires: [
                                        "fill-extrusion-height"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "fill-extrusion-vertical-gradient": {
                                    type: "boolean",
                                    default: !0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_line: {
                                "line-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "line-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "line-width": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-gap-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-offset": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "line-dasharray": {
                                    type: "array",
                                    value: "number",
                                    minimum: 0,
                                    transition: !0,
                                    units: "line widths",
                                    requires: [
                                        {
                                            "!": "line-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom",
                                            "feature"
                                        ]
                                    },
                                    "property-type": "cross-faded-data-driven"
                                },
                                "line-gradient": {
                                    type: "color",
                                    transition: !1,
                                    requires: [
                                        {
                                            "!": "line-dasharray"
                                        },
                                        {
                                            "!": "line-pattern"
                                        },
                                        {
                                            source: "geojson",
                                            has: {
                                                lineMetrics: !0
                                            }
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "line-progress"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_circle: {
                                "circle-radius": {
                                    type: "number",
                                    default: 5,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-blur": {
                                    type: "number",
                                    default: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "circle-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-scale": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-pitch-alignment": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "circle-stroke-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "circle-stroke-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                }
                            },
                            paint_heatmap: {
                                "heatmap-radius": {
                                    type: "number",
                                    default: 30,
                                    minimum: 1,
                                    transition: !0,
                                    units: "pixels",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-weight": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "heatmap-intensity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "heatmap-color": {
                                    type: "color",
                                    default: [
                                        "interpolate",
                                        [
                                            "linear"
                                        ],
                                        [
                                            "heatmap-density"
                                        ],
                                        0,
                                        "rgba(0, 0, 255, 0)",
                                        .1,
                                        "royalblue",
                                        .3,
                                        "cyan",
                                        .5,
                                        "lime",
                                        .7,
                                        "yellow",
                                        1,
                                        "red"
                                    ],
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "heatmap-density"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                },
                                "heatmap-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_symbol: {
                                "icon-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "icon-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "icon-image"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "icon-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "icon-image",
                                        "icon-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    overridable: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-color": {
                                    type: "color",
                                    default: "rgba(0, 0, 0, 0)",
                                    transition: !0,
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-width": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-halo-blur": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom",
                                            "feature",
                                            "feature-state"
                                        ]
                                    },
                                    "property-type": "data-driven"
                                },
                                "text-translate": {
                                    type: "array",
                                    value: "number",
                                    length: 2,
                                    default: [
                                        0,
                                        0
                                    ],
                                    transition: !0,
                                    units: "pixels",
                                    requires: [
                                        "text-field"
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "text-translate-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "map",
                                    requires: [
                                        "text-field",
                                        "text-translate"
                                    ],
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_raster: {
                                "raster-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-hue-rotate": {
                                    type: "number",
                                    default: 0,
                                    period: 360,
                                    transition: !0,
                                    units: "degrees",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-min": {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-brightness-max": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-saturation": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-contrast": {
                                    type: "number",
                                    default: 0,
                                    minimum: -1,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-resampling": {
                                    type: "enum",
                                    values: {
                                        linear: {},
                                        nearest: {}
                                    },
                                    default: "linear",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "raster-fade-duration": {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    transition: !1,
                                    units: "milliseconds",
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            paint_hillshade: {
                                "hillshade-illumination-direction": {
                                    type: "numberArray",
                                    default: 335,
                                    minimum: 0,
                                    maximum: 359,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-altitude": {
                                    type: "numberArray",
                                    default: 45,
                                    minimum: 0,
                                    maximum: 90,
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-illumination-anchor": {
                                    type: "enum",
                                    values: {
                                        map: {},
                                        viewport: {}
                                    },
                                    default: "viewport",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-exaggeration": {
                                    type: "number",
                                    default: .5,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-shadow-color": {
                                    type: "colorArray",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-highlight-color": {
                                    type: "colorArray",
                                    default: "#FFFFFF",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-accent-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "hillshade-method": {
                                    type: "enum",
                                    values: {
                                        standard: {},
                                        basic: {},
                                        combined: {},
                                        igor: {},
                                        multidirectional: {}
                                    },
                                    default: "standard",
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            "paint_color-relief": {
                                "color-relief-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "color-relief-color": {
                                    type: "color",
                                    transition: !1,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "elevation"
                                        ]
                                    },
                                    "property-type": "color-ramp"
                                }
                            },
                            paint_background: {
                                "background-color": {
                                    type: "color",
                                    default: "#000000",
                                    transition: !0,
                                    requires: [
                                        {
                                            "!": "background-pattern"
                                        }
                                    ],
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                },
                                "background-pattern": {
                                    type: "resolvedImage",
                                    transition: !0,
                                    expression: {
                                        interpolated: !1,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "cross-faded"
                                },
                                "background-opacity": {
                                    type: "number",
                                    default: 1,
                                    minimum: 0,
                                    maximum: 1,
                                    transition: !0,
                                    expression: {
                                        interpolated: !0,
                                        parameters: [
                                            "zoom"
                                        ]
                                    },
                                    "property-type": "data-constant"
                                }
                            },
                            transition: {
                                duration: {
                                    type: "number",
                                    default: 300,
                                    minimum: 0,
                                    units: "milliseconds"
                                },
                                delay: {
                                    type: "number",
                                    default: 0,
                                    minimum: 0,
                                    units: "milliseconds"
                                }
                            },
                            "property-type": {
                                "data-driven": {
                                    type: "property-type"
                                },
                                "cross-faded": {
                                    type: "property-type"
                                },
                                "cross-faded-data-driven": {
                                    type: "property-type"
                                },
                                "color-ramp": {
                                    type: "property-type"
                                },
                                "data-constant": {
                                    type: "property-type"
                                },
                                constant: {
                                    type: "property-type"
                                }
                            },
                            promoteId: {
                                "*": {
                                    type: "string"
                                }
                            },
                            interpolation: {
                                type: "array",
                                value: "interpolation_name",
                                minimum: 1
                            },
                            interpolation_name: {
                                type: "enum",
                                values: {
                                    linear: {
                                        syntax: {
                                            overloads: [
                                                {
                                                    parameters: [],
                                                    "output-type": "interpolation"
                                                }
                                            ],
                                            parameters: []
                                        }
                                    },
                                    exponential: {
                                        syntax: {
                                            overloads: [
                                                {
                                                    parameters: [
                                                        "base"
                                                    ],
                                                    "output-type": "interpolation"
                                                }
                                            ],
                                            parameters: [
                                                {
                                                    name: "base",
                                                    type: "number literal"
                                                }
                                            ]
                                        }
                                    },
                                    "cubic-bezier": {
                                        syntax: {
                                            overloads: [
                                                {
                                                    parameters: [
                                                        "x1",
                                                        "y1",
                                                        "x2",
                                                        "y2"
                                                    ],
                                                    "output-type": "interpolation"
                                                }
                                            ],
                                            parameters: [
                                                {
                                                    name: "x1",
                                                    type: "number literal"
                                                },
                                                {
                                                    name: "y1",
                                                    type: "number literal"
                                                },
                                                {
                                                    name: "x2",
                                                    type: "number literal"
                                                },
                                                {
                                                    name: "y2",
                                                    type: "number literal"
                                                }
                                            ]
                                        }
                                    }
                                }
                            }
                        };
                        const Hd = [
                            "type",
                            "source",
                            "source-layer",
                            "minzoom",
                            "maxzoom",
                            "filter",
                            "layout"
                        ];
                        function wt(le1, vt) {
                            const bt = {};
                            for(const ls in le1)"ref" !== ls && (bt[ls] = le1[ls]);
                            return Hd.forEach((le1)=>{
                                le1 in vt && (bt[le1] = vt[le1]);
                            }), bt;
                        }
                        function _t(le1, vt) {
                            if (Array.isArray(le1)) {
                                if (!Array.isArray(vt) || le1.length !== vt.length) return !1;
                                for(let bt = 0; bt < le1.length; bt++)if (!_t(le1[bt], vt[bt])) return !1;
                                return !0;
                            }
                            if ("object" == typeof le1 && null !== le1 && null !== vt) {
                                if ("object" != typeof vt) return !1;
                                if (Object.keys(le1).length !== Object.keys(vt).length) return !1;
                                for(const bt in le1)if (!_t(le1[bt], vt[bt])) return !1;
                                return !0;
                            }
                            return le1 === vt;
                        }
                        function St(le1, vt) {
                            le1.push(vt);
                        }
                        function At(le1, vt, bt) {
                            St(bt, {
                                command: "addSource",
                                args: [
                                    le1,
                                    vt[le1]
                                ]
                            });
                        }
                        function kt(le1, vt, bt) {
                            St(vt, {
                                command: "removeSource",
                                args: [
                                    le1
                                ]
                            }), bt[le1] = !0;
                        }
                        function Et(le1, vt, bt, ls) {
                            kt(le1, bt, ls), At(le1, vt, bt);
                        }
                        function Tt(le1, vt, bt) {
                            let ls;
                            for(ls in le1[bt])if (Object.prototype.hasOwnProperty.call(le1[bt], ls) && "data" !== ls && !_t(le1[bt][ls], vt[bt][ls])) return !1;
                            for(ls in vt[bt])if (Object.prototype.hasOwnProperty.call(vt[bt], ls) && "data" !== ls && !_t(le1[bt][ls], vt[bt][ls])) return !1;
                            return !0;
                        }
                        function It(le1, vt, bt, ls, ho, Dl) {
                            le1 = le1 || {}, vt = vt || {};
                            for(const Fl in le1)Object.prototype.hasOwnProperty.call(le1, Fl) && (_t(le1[Fl], vt[Fl]) || bt.push({
                                command: Dl,
                                args: [
                                    ls,
                                    Fl,
                                    vt[Fl],
                                    ho
                                ]
                            }));
                            for(const Fl in vt)Object.prototype.hasOwnProperty.call(vt, Fl) && !Object.prototype.hasOwnProperty.call(le1, Fl) && (_t(le1[Fl], vt[Fl]) || bt.push({
                                command: Dl,
                                args: [
                                    ls,
                                    Fl,
                                    vt[Fl],
                                    ho
                                ]
                            }));
                        }
                        function Mt(le1) {
                            return le1.id;
                        }
                        function Ft(le1, vt) {
                            return le1[vt.id] = vt, le1;
                        }
                        class Dt {
                            constructor(le1, vt, bt, ls){
                                this.message = (le1 ? `${le1}: ` : "") + bt, ls && (this.identifier = ls), null != vt && vt.__line__ && (this.line = vt.__line__);
                            }
                        }
                        function zt(le1, ...vt) {
                            for (const bt of vt)for(const vt in bt)le1[vt] = bt[vt];
                            return le1;
                        }
                        class Pt extends Error {
                            constructor(le1, vt){
                                super(vt), this.message = vt, this.key = le1;
                            }
                        }
                        class Bt {
                            constructor(le1, vt = []){
                                this.parent = le1, this.bindings = {};
                                for (const [bt, ls] of vt)this.bindings[bt] = ls;
                            }
                            concat(le1) {
                                return new Bt(this, le1);
                            }
                            get(le1) {
                                if (this.bindings[le1]) return this.bindings[le1];
                                if (this.parent) return this.parent.get(le1);
                                throw new Error(`${le1} not found in scope.`);
                            }
                            has(le1) {
                                return !!this.bindings[le1] || !!this.parent && this.parent.has(le1);
                            }
                        }
                        const Wd = {
                            kind: "null"
                        }, Zd = {
                            kind: "number"
                        }, Yd = {
                            kind: "string"
                        }, Qd = {
                            kind: "boolean"
                        }, Xd = {
                            kind: "color"
                        }, Kd = {
                            kind: "projectionDefinition"
                        }, Jd = {
                            kind: "object"
                        }, $d = {
                            kind: "value"
                        }, sp = {
                            kind: "collator"
                        }, em = {
                            kind: "formatted"
                        }, tm = {
                            kind: "padding"
                        }, im = {
                            kind: "colorArray"
                        }, nm = {
                            kind: "numberArray"
                        }, rm = {
                            kind: "resolvedImage"
                        }, am = {
                            kind: "variableAnchorOffsetCollection"
                        };
                        function Kt(le1, vt) {
                            return {
                                kind: "array",
                                itemType: le1,
                                N: vt
                            };
                        }
                        function Wt(le1) {
                            if ("array" === le1.kind) {
                                const vt = Wt(le1.itemType);
                                return "number" == typeof le1.N ? `array<${vt}, ${le1.N}>` : "value" === le1.itemType.kind ? "array" : `array<${vt}>`;
                            }
                            return le1.kind;
                        }
                        const sm = [
                            Wd,
                            Zd,
                            Yd,
                            Qd,
                            Xd,
                            Kd,
                            em,
                            Jd,
                            Kt($d),
                            tm,
                            nm,
                            im,
                            rm,
                            am
                        ];
                        function Qt(le1, vt) {
                            if ("error" === vt.kind) return null;
                            if ("array" === le1.kind) {
                                if ("array" === vt.kind && (0 === vt.N && "value" === vt.itemType.kind || !Qt(le1.itemType, vt.itemType)) && ("number" != typeof le1.N || le1.N === vt.N)) return null;
                            } else {
                                if (le1.kind === vt.kind) return null;
                                if ("value" === le1.kind) {
                                    for (const le1 of sm)if (!Qt(le1, vt)) return null;
                                }
                            }
                            return `Expected ${Wt(le1)} but found ${Wt(vt)} instead.`;
                        }
                        function te(le1, vt) {
                            return vt.some((vt)=>vt.kind === le1.kind);
                        }
                        function ee(le1, vt) {
                            return vt.some((vt)=>"null" === vt ? null === le1 : "array" === vt ? Array.isArray(le1) : "object" === vt ? le1 && !Array.isArray(le1) && "object" == typeof le1 : vt === typeof le1);
                        }
                        function re(le1, vt) {
                            return "array" === le1.kind && "array" === vt.kind ? le1.itemType.kind === vt.itemType.kind && "number" == typeof le1.N : le1.kind === vt.kind;
                        }
                        const om = .96422, lm = .82521, cm = 4 / 29, um = 6 / 29, hm = 3 * um * um, dm = um * um * um, pm = Math.PI / 180, mm = 180 / Math.PI;
                        function he(le1) {
                            return (le1 %= 360) < 0 && (le1 += 360), le1;
                        }
                        function pe([le1, vt, bt, ls]) {
                            let ho, Dl;
                            const Fl = de((.2225045 * (le1 = fe(le1)) + .7168786 * (vt = fe(vt)) + .0606169 * (bt = fe(bt))) / 1);
                            le1 === vt && vt === bt ? ho = Dl = Fl : (ho = de((.4360747 * le1 + .3850649 * vt + .1430804 * bt) / om), Dl = de((.0139322 * le1 + .0971045 * vt + .7141733 * bt) / lm));
                            const sc = 116 * Fl - 16;
                            return [
                                sc < 0 ? 0 : sc,
                                500 * (ho - Fl),
                                200 * (Fl - Dl),
                                ls
                            ];
                        }
                        function fe(le1) {
                            return le1 <= .04045 ? le1 / 12.92 : Math.pow((le1 + .055) / 1.055, 2.4);
                        }
                        function de(le1) {
                            return le1 > dm ? Math.pow(le1, 1 / 3) : le1 / hm + cm;
                        }
                        function ye([le1, vt, bt, ls]) {
                            let ho = (le1 + 16) / 116, Dl = isNaN(vt) ? ho : ho + vt / 500, Fl = isNaN(bt) ? ho : ho - bt / 200;
                            return ho = 1 * ge(ho), Dl = om * ge(Dl), Fl = lm * ge(Fl), [
                                me(3.1338561 * Dl - 1.6168667 * ho - .4906146 * Fl),
                                me(-0.9787684 * Dl + 1.9161415 * ho + .033454 * Fl),
                                me(.0719453 * Dl - .2289914 * ho + 1.4052427 * Fl),
                                ls
                            ];
                        }
                        function me(le1) {
                            return (le1 = le1 <= .00304 ? 12.92 * le1 : 1.055 * Math.pow(le1, 1 / 2.4) - .055) < 0 ? 0 : le1 > 1 ? 1 : le1;
                        }
                        function ge(le1) {
                            return le1 > um ? le1 * le1 * le1 : hm * (le1 - cm);
                        }
                        const fm = Object.hasOwn || function(le1, vt) {
                            return Object.prototype.hasOwnProperty.call(le1, vt);
                        };
                        function ve(le1, vt) {
                            return fm(le1, vt) ? le1[vt] : void 0;
                        }
                        function be(le1) {
                            return parseInt(le1.padEnd(2, le1), 16) / 255;
                        }
                        function we(le1, vt) {
                            return _e(vt ? le1 / 100 : le1, 0, 1);
                        }
                        function _e(le1, vt, bt) {
                            return Math.min(Math.max(vt, le1), bt);
                        }
                        function Se(le1) {
                            return !le1.some(Number.isNaN);
                        }
                        const gm = {
                            aliceblue: [
                                240,
                                248,
                                255
                            ],
                            antiquewhite: [
                                250,
                                235,
                                215
                            ],
                            aqua: [
                                0,
                                255,
                                255
                            ],
                            aquamarine: [
                                127,
                                255,
                                212
                            ],
                            azure: [
                                240,
                                255,
                                255
                            ],
                            beige: [
                                245,
                                245,
                                220
                            ],
                            bisque: [
                                255,
                                228,
                                196
                            ],
                            black: [
                                0,
                                0,
                                0
                            ],
                            blanchedalmond: [
                                255,
                                235,
                                205
                            ],
                            blue: [
                                0,
                                0,
                                255
                            ],
                            blueviolet: [
                                138,
                                43,
                                226
                            ],
                            brown: [
                                165,
                                42,
                                42
                            ],
                            burlywood: [
                                222,
                                184,
                                135
                            ],
                            cadetblue: [
                                95,
                                158,
                                160
                            ],
                            chartreuse: [
                                127,
                                255,
                                0
                            ],
                            chocolate: [
                                210,
                                105,
                                30
                            ],
                            coral: [
                                255,
                                127,
                                80
                            ],
                            cornflowerblue: [
                                100,
                                149,
                                237
                            ],
                            cornsilk: [
                                255,
                                248,
                                220
                            ],
                            crimson: [
                                220,
                                20,
                                60
                            ],
                            cyan: [
                                0,
                                255,
                                255
                            ],
                            darkblue: [
                                0,
                                0,
                                139
                            ],
                            darkcyan: [
                                0,
                                139,
                                139
                            ],
                            darkgoldenrod: [
                                184,
                                134,
                                11
                            ],
                            darkgray: [
                                169,
                                169,
                                169
                            ],
                            darkgreen: [
                                0,
                                100,
                                0
                            ],
                            darkgrey: [
                                169,
                                169,
                                169
                            ],
                            darkkhaki: [
                                189,
                                183,
                                107
                            ],
                            darkmagenta: [
                                139,
                                0,
                                139
                            ],
                            darkolivegreen: [
                                85,
                                107,
                                47
                            ],
                            darkorange: [
                                255,
                                140,
                                0
                            ],
                            darkorchid: [
                                153,
                                50,
                                204
                            ],
                            darkred: [
                                139,
                                0,
                                0
                            ],
                            darksalmon: [
                                233,
                                150,
                                122
                            ],
                            darkseagreen: [
                                143,
                                188,
                                143
                            ],
                            darkslateblue: [
                                72,
                                61,
                                139
                            ],
                            darkslategray: [
                                47,
                                79,
                                79
                            ],
                            darkslategrey: [
                                47,
                                79,
                                79
                            ],
                            darkturquoise: [
                                0,
                                206,
                                209
                            ],
                            darkviolet: [
                                148,
                                0,
                                211
                            ],
                            deeppink: [
                                255,
                                20,
                                147
                            ],
                            deepskyblue: [
                                0,
                                191,
                                255
                            ],
                            dimgray: [
                                105,
                                105,
                                105
                            ],
                            dimgrey: [
                                105,
                                105,
                                105
                            ],
                            dodgerblue: [
                                30,
                                144,
                                255
                            ],
                            firebrick: [
                                178,
                                34,
                                34
                            ],
                            floralwhite: [
                                255,
                                250,
                                240
                            ],
                            forestgreen: [
                                34,
                                139,
                                34
                            ],
                            fuchsia: [
                                255,
                                0,
                                255
                            ],
                            gainsboro: [
                                220,
                                220,
                                220
                            ],
                            ghostwhite: [
                                248,
                                248,
                                255
                            ],
                            gold: [
                                255,
                                215,
                                0
                            ],
                            goldenrod: [
                                218,
                                165,
                                32
                            ],
                            gray: [
                                128,
                                128,
                                128
                            ],
                            green: [
                                0,
                                128,
                                0
                            ],
                            greenyellow: [
                                173,
                                255,
                                47
                            ],
                            grey: [
                                128,
                                128,
                                128
                            ],
                            honeydew: [
                                240,
                                255,
                                240
                            ],
                            hotpink: [
                                255,
                                105,
                                180
                            ],
                            indianred: [
                                205,
                                92,
                                92
                            ],
                            indigo: [
                                75,
                                0,
                                130
                            ],
                            ivory: [
                                255,
                                255,
                                240
                            ],
                            khaki: [
                                240,
                                230,
                                140
                            ],
                            lavender: [
                                230,
                                230,
                                250
                            ],
                            lavenderblush: [
                                255,
                                240,
                                245
                            ],
                            lawngreen: [
                                124,
                                252,
                                0
                            ],
                            lemonchiffon: [
                                255,
                                250,
                                205
                            ],
                            lightblue: [
                                173,
                                216,
                                230
                            ],
                            lightcoral: [
                                240,
                                128,
                                128
                            ],
                            lightcyan: [
                                224,
                                255,
                                255
                            ],
                            lightgoldenrodyellow: [
                                250,
                                250,
                                210
                            ],
                            lightgray: [
                                211,
                                211,
                                211
                            ],
                            lightgreen: [
                                144,
                                238,
                                144
                            ],
                            lightgrey: [
                                211,
                                211,
                                211
                            ],
                            lightpink: [
                                255,
                                182,
                                193
                            ],
                            lightsalmon: [
                                255,
                                160,
                                122
                            ],
                            lightseagreen: [
                                32,
                                178,
                                170
                            ],
                            lightskyblue: [
                                135,
                                206,
                                250
                            ],
                            lightslategray: [
                                119,
                                136,
                                153
                            ],
                            lightslategrey: [
                                119,
                                136,
                                153
                            ],
                            lightsteelblue: [
                                176,
                                196,
                                222
                            ],
                            lightyellow: [
                                255,
                                255,
                                224
                            ],
                            lime: [
                                0,
                                255,
                                0
                            ],
                            limegreen: [
                                50,
                                205,
                                50
                            ],
                            linen: [
                                250,
                                240,
                                230
                            ],
                            magenta: [
                                255,
                                0,
                                255
                            ],
                            maroon: [
                                128,
                                0,
                                0
                            ],
                            mediumaquamarine: [
                                102,
                                205,
                                170
                            ],
                            mediumblue: [
                                0,
                                0,
                                205
                            ],
                            mediumorchid: [
                                186,
                                85,
                                211
                            ],
                            mediumpurple: [
                                147,
                                112,
                                219
                            ],
                            mediumseagreen: [
                                60,
                                179,
                                113
                            ],
                            mediumslateblue: [
                                123,
                                104,
                                238
                            ],
                            mediumspringgreen: [
                                0,
                                250,
                                154
                            ],
                            mediumturquoise: [
                                72,
                                209,
                                204
                            ],
                            mediumvioletred: [
                                199,
                                21,
                                133
                            ],
                            midnightblue: [
                                25,
                                25,
                                112
                            ],
                            mintcream: [
                                245,
                                255,
                                250
                            ],
                            mistyrose: [
                                255,
                                228,
                                225
                            ],
                            moccasin: [
                                255,
                                228,
                                181
                            ],
                            navajowhite: [
                                255,
                                222,
                                173
                            ],
                            navy: [
                                0,
                                0,
                                128
                            ],
                            oldlace: [
                                253,
                                245,
                                230
                            ],
                            olive: [
                                128,
                                128,
                                0
                            ],
                            olivedrab: [
                                107,
                                142,
                                35
                            ],
                            orange: [
                                255,
                                165,
                                0
                            ],
                            orangered: [
                                255,
                                69,
                                0
                            ],
                            orchid: [
                                218,
                                112,
                                214
                            ],
                            palegoldenrod: [
                                238,
                                232,
                                170
                            ],
                            palegreen: [
                                152,
                                251,
                                152
                            ],
                            paleturquoise: [
                                175,
                                238,
                                238
                            ],
                            palevioletred: [
                                219,
                                112,
                                147
                            ],
                            papayawhip: [
                                255,
                                239,
                                213
                            ],
                            peachpuff: [
                                255,
                                218,
                                185
                            ],
                            peru: [
                                205,
                                133,
                                63
                            ],
                            pink: [
                                255,
                                192,
                                203
                            ],
                            plum: [
                                221,
                                160,
                                221
                            ],
                            powderblue: [
                                176,
                                224,
                                230
                            ],
                            purple: [
                                128,
                                0,
                                128
                            ],
                            rebeccapurple: [
                                102,
                                51,
                                153
                            ],
                            red: [
                                255,
                                0,
                                0
                            ],
                            rosybrown: [
                                188,
                                143,
                                143
                            ],
                            royalblue: [
                                65,
                                105,
                                225
                            ],
                            saddlebrown: [
                                139,
                                69,
                                19
                            ],
                            salmon: [
                                250,
                                128,
                                114
                            ],
                            sandybrown: [
                                244,
                                164,
                                96
                            ],
                            seagreen: [
                                46,
                                139,
                                87
                            ],
                            seashell: [
                                255,
                                245,
                                238
                            ],
                            sienna: [
                                160,
                                82,
                                45
                            ],
                            silver: [
                                192,
                                192,
                                192
                            ],
                            skyblue: [
                                135,
                                206,
                                235
                            ],
                            slateblue: [
                                106,
                                90,
                                205
                            ],
                            slategray: [
                                112,
                                128,
                                144
                            ],
                            slategrey: [
                                112,
                                128,
                                144
                            ],
                            snow: [
                                255,
                                250,
                                250
                            ],
                            springgreen: [
                                0,
                                255,
                                127
                            ],
                            steelblue: [
                                70,
                                130,
                                180
                            ],
                            tan: [
                                210,
                                180,
                                140
                            ],
                            teal: [
                                0,
                                128,
                                128
                            ],
                            thistle: [
                                216,
                                191,
                                216
                            ],
                            tomato: [
                                255,
                                99,
                                71
                            ],
                            turquoise: [
                                64,
                                224,
                                208
                            ],
                            violet: [
                                238,
                                130,
                                238
                            ],
                            wheat: [
                                245,
                                222,
                                179
                            ],
                            white: [
                                255,
                                255,
                                255
                            ],
                            whitesmoke: [
                                245,
                                245,
                                245
                            ],
                            yellow: [
                                255,
                                255,
                                0
                            ],
                            yellowgreen: [
                                154,
                                205,
                                50
                            ]
                        };
                        function ke(le1, vt, bt) {
                            return le1 + bt * (vt - le1);
                        }
                        function Ee(le1, vt, bt) {
                            return le1.map((le1, ls)=>ke(le1, vt[ls], bt));
                        }
                        class Te {
                            constructor(le1, vt, bt, ls = 1, ho = !0){
                                this.r = le1, this.g = vt, this.b = bt, this.a = ls, ho || (this.r *= ls, this.g *= ls, this.b *= ls, ls || this.overwriteGetter("rgb", [
                                    le1,
                                    vt,
                                    bt,
                                    ls
                                ]));
                            }
                            static parse(le1) {
                                if (le1 instanceof Te) return le1;
                                if ("string" != typeof le1) return;
                                const vt = function(le1) {
                                    if ("transparent" === (le1 = le1.toLowerCase().trim())) return [
                                        0,
                                        0,
                                        0,
                                        0
                                    ];
                                    const vt = ve(gm, le1);
                                    if (vt) {
                                        const [le1, bt, ls] = vt;
                                        return [
                                            le1 / 255,
                                            bt / 255,
                                            ls / 255,
                                            1
                                        ];
                                    }
                                    if (le1.startsWith("#") && /^#(?:[0-9a-f]{3,4}|[0-9a-f]{6}|[0-9a-f]{8})$/.test(le1)) {
                                        const vt = le1.length < 6 ? 1 : 2;
                                        let bt = 1;
                                        return [
                                            be(le1.slice(bt, bt += vt)),
                                            be(le1.slice(bt, bt += vt)),
                                            be(le1.slice(bt, bt += vt)),
                                            be(le1.slice(bt, bt + vt) || "ff")
                                        ];
                                    }
                                    if (le1.startsWith("rgb")) {
                                        const vt = le1.match(/^rgba?\(\s*([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s+|\s*(,)\s*)([\de.+-]+)(%)?(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                        if (vt) {
                                            const [le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec] = vt, kc = [
                                                ho || " ",
                                                sc || " ",
                                                gc
                                            ].join("");
                                            if ("  " === kc || "  /" === kc || ",," === kc || ",,," === kc) {
                                                const le1 = [
                                                    ls,
                                                    Fl,
                                                    mc
                                                ].join(""), vt = "%%%" === le1 ? 100 : "" === le1 ? 255 : 0;
                                                if (vt) {
                                                    const le1 = [
                                                        _e(+bt / vt, 0, 1),
                                                        _e(+Dl / vt, 0, 1),
                                                        _e(+uc / vt, 0, 1),
                                                        Ac ? we(+Ac, Ec) : 1
                                                    ];
                                                    if (Se(le1)) return le1;
                                                }
                                            }
                                            return;
                                        }
                                    }
                                    const bt = le1.match(/^hsla?\(\s*([\de.+-]+)(?:deg)?(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s+|\s*(,)\s*)([\de.+-]+)%(?:\s*([,\/])\s*([\de.+-]+)(%)?)?\s*\)$/);
                                    if (bt) {
                                        const [le1, vt, ls, ho, Dl, Fl, sc, uc, mc] = bt, gc = [
                                            ls || " ",
                                            Dl || " ",
                                            sc
                                        ].join("");
                                        if ("  " === gc || "  /" === gc || ",," === gc || ",,," === gc) {
                                            const le1 = [
                                                +vt,
                                                _e(+ho, 0, 100),
                                                _e(+Fl, 0, 100),
                                                uc ? we(+uc, mc) : 1
                                            ];
                                            if (Se(le1)) return function([le1, vt, bt, ls]) {
                                                function i(ls) {
                                                    const ho = (ls + le1 / 30) % 12, Dl = vt * Math.min(bt, 1 - bt);
                                                    return bt - Dl * Math.max(-1, Math.min(ho - 3, 9 - ho, 1));
                                                }
                                                return le1 = he(le1), vt /= 100, bt /= 100, [
                                                    i(0),
                                                    i(8),
                                                    i(4),
                                                    ls
                                                ];
                                            }(le1);
                                        }
                                    }
                                }(le1);
                                return vt ? new Te(...vt, !1) : void 0;
                            }
                            get rgb() {
                                const { r: le1, g: vt, b: bt, a: ls } = this, ho = ls || 1 / 0;
                                return this.overwriteGetter("rgb", [
                                    le1 / ho,
                                    vt / ho,
                                    bt / ho,
                                    ls
                                ]);
                            }
                            get hcl() {
                                return this.overwriteGetter("hcl", function(le1) {
                                    const [vt, bt, ls, ho] = pe(le1), Dl = Math.sqrt(bt * bt + ls * ls);
                                    return [
                                        Math.round(1e4 * Dl) ? he(Math.atan2(ls, bt) * mm) : NaN,
                                        Dl,
                                        vt,
                                        ho
                                    ];
                                }(this.rgb));
                            }
                            get lab() {
                                return this.overwriteGetter("lab", pe(this.rgb));
                            }
                            overwriteGetter(le1, vt) {
                                return Object.defineProperty(this, le1, {
                                    value: vt
                                }), vt;
                            }
                            toString() {
                                const [le1, vt, bt, ls] = this.rgb;
                                return `rgba(${[
                                    le1,
                                    vt,
                                    bt
                                ].map((le1)=>Math.round(255 * le1)).join(",")},${ls})`;
                            }
                            static interpolate(le1, vt, bt, ls = "rgb") {
                                switch(ls){
                                    case "rgb":
                                        {
                                            const [ls, ho, Dl, Fl] = Ee(le1.rgb, vt.rgb, bt);
                                            return new Te(ls, ho, Dl, Fl, !1);
                                        }
                                    case "hcl":
                                        {
                                            const [ls, ho, Dl, Fl] = le1.hcl, [sc, uc, mc, gc] = vt.hcl;
                                            let Ac, Ec;
                                            if (isNaN(ls) || isNaN(sc)) isNaN(ls) ? isNaN(sc) ? Ac = NaN : (Ac = sc, 1 !== Dl && 0 !== Dl || (Ec = uc)) : (Ac = ls, 1 !== mc && 0 !== mc || (Ec = ho));
                                            else {
                                                let le1 = sc - ls;
                                                sc > ls && le1 > 180 ? le1 -= 360 : sc < ls && ls - sc > 180 && (le1 += 360), Ac = ls + bt * le1;
                                            }
                                            const [kc, du, _u, Md] = function([le1, vt, bt, ls]) {
                                                return le1 = isNaN(le1) ? 0 : le1 * pm, ye([
                                                    bt,
                                                    Math.cos(le1) * vt,
                                                    Math.sin(le1) * vt,
                                                    ls
                                                ]);
                                            }([
                                                Ac,
                                                null != Ec ? Ec : ke(ho, uc, bt),
                                                ke(Dl, mc, bt),
                                                ke(Fl, gc, bt)
                                            ]);
                                            return new Te(kc, du, _u, Md, !1);
                                        }
                                    case "lab":
                                        {
                                            const [ls, ho, Dl, Fl] = ye(Ee(le1.lab, vt.lab, bt));
                                            return new Te(ls, ho, Dl, Fl, !1);
                                        }
                                }
                            }
                        }
                        Te.black = new Te(0, 0, 0, 1), Te.white = new Te(1, 1, 1, 1), Te.transparent = new Te(0, 0, 0, 0), Te.red = new Te(1, 0, 0, 1);
                        class Ie {
                            constructor(le1, vt, bt){
                                this.sensitivity = le1 ? vt ? "variant" : "case" : vt ? "accent" : "base", this.locale = bt, this.collator = new Intl.Collator(this.locale ? this.locale : [], {
                                    sensitivity: this.sensitivity,
                                    usage: "search"
                                });
                            }
                            compare(le1, vt) {
                                return this.collator.compare(le1, vt);
                            }
                            resolvedLocale() {
                                return new Intl.Collator(this.locale ? this.locale : []).resolvedOptions().locale;
                            }
                        }
                        const Am = [
                            "bottom",
                            "center",
                            "top"
                        ];
                        class Fe {
                            constructor(le1, vt, bt, ls, ho, Dl){
                                this.text = le1, this.image = vt, this.scale = bt, this.fontStack = ls, this.textColor = ho, this.verticalAlign = Dl;
                            }
                        }
                        class De {
                            constructor(le1){
                                this.sections = le1;
                            }
                            static fromString(le1) {
                                return new De([
                                    new Fe(le1, null, null, null, null, null)
                                ]);
                            }
                            isEmpty() {
                                return 0 === this.sections.length || !this.sections.some((le1)=>0 !== le1.text.length || le1.image && 0 !== le1.image.name.length);
                            }
                            static factory(le1) {
                                return le1 instanceof De ? le1 : De.fromString(le1);
                            }
                            toString() {
                                return 0 === this.sections.length ? "" : this.sections.map((le1)=>le1.text).join("");
                            }
                        }
                        class ze {
                            constructor(le1){
                                this.values = le1.slice();
                            }
                            static parse(le1) {
                                if (le1 instanceof ze) return le1;
                                if ("number" == typeof le1) return new ze([
                                    le1,
                                    le1,
                                    le1,
                                    le1
                                ]);
                                if (Array.isArray(le1) && !(le1.length < 1 || le1.length > 4)) {
                                    for (const vt of le1)if ("number" != typeof vt) return;
                                    switch(le1.length){
                                        case 1:
                                            le1 = [
                                                le1[0],
                                                le1[0],
                                                le1[0],
                                                le1[0]
                                            ];
                                            break;
                                        case 2:
                                            le1 = [
                                                le1[0],
                                                le1[1],
                                                le1[0],
                                                le1[1]
                                            ];
                                            break;
                                        case 3:
                                            le1 = [
                                                le1[0],
                                                le1[1],
                                                le1[2],
                                                le1[1]
                                            ];
                                    }
                                    return new ze(le1);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(le1, vt, bt) {
                                return new ze(Ee(le1.values, vt.values, bt));
                            }
                        }
                        class Pe {
                            constructor(le1){
                                this.values = le1.slice();
                            }
                            static parse(le1) {
                                if (le1 instanceof Pe) return le1;
                                if ("number" == typeof le1) return new Pe([
                                    le1
                                ]);
                                if (Array.isArray(le1)) {
                                    for (const vt of le1)if ("number" != typeof vt) return;
                                    return new Pe(le1);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(le1, vt, bt) {
                                return new Pe(Ee(le1.values, vt.values, bt));
                            }
                        }
                        class Be {
                            constructor(le1){
                                this.values = le1.slice();
                            }
                            static parse(le1) {
                                if (le1 instanceof Be) return le1;
                                if ("string" == typeof le1) {
                                    const vt = Te.parse(le1);
                                    if (!vt) return;
                                    return new Be([
                                        vt
                                    ]);
                                }
                                if (!Array.isArray(le1)) return;
                                const vt = [];
                                for (const bt of le1){
                                    if ("string" != typeof bt) return;
                                    const le1 = Te.parse(bt);
                                    if (!le1) return;
                                    vt.push(le1);
                                }
                                return new Be(vt);
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(le1, vt, bt, ls = "rgb") {
                                const ho = [];
                                if (le1.values.length != vt.values.length) throw new Error(`colorArray: Arrays have mismatched length (${le1.values.length} vs. ${vt.values.length}), cannot interpolate.`);
                                for(let Dl = 0; Dl < le1.values.length; Dl++)ho.push(Te.interpolate(le1.values[Dl], vt.values[Dl], bt, ls));
                                return new Be(ho);
                            }
                        }
                        class Ve extends Error {
                            constructor(le1){
                                super(le1), this.name = "RuntimeError";
                            }
                            toJSON() {
                                return this.message;
                            }
                        }
                        const _m = new Set([
                            "center",
                            "left",
                            "right",
                            "top",
                            "bottom",
                            "top-left",
                            "top-right",
                            "bottom-left",
                            "bottom-right"
                        ]);
                        class Le {
                            constructor(le1){
                                this.values = le1.slice();
                            }
                            static parse(le1) {
                                if (le1 instanceof Le) return le1;
                                if (Array.isArray(le1) && !(le1.length < 1) && le1.length % 2 == 0) {
                                    for(let vt = 0; vt < le1.length; vt += 2){
                                        const bt = le1[vt], ls = le1[vt + 1];
                                        if ("string" != typeof bt || !_m.has(bt)) return;
                                        if (!Array.isArray(ls) || 2 !== ls.length || "number" != typeof ls[0] || "number" != typeof ls[1]) return;
                                    }
                                    return new Le(le1);
                                }
                            }
                            toString() {
                                return JSON.stringify(this.values);
                            }
                            static interpolate(le1, vt, bt) {
                                const ls = le1.values, ho = vt.values;
                                if (ls.length !== ho.length) throw new Ve(`Cannot interpolate values of different length. from: ${le1.toString()}, to: ${vt.toString()}`);
                                const Dl = [];
                                for(let Fl = 0; Fl < ls.length; Fl += 2){
                                    if (ls[Fl] !== ho[Fl]) throw new Ve(`Cannot interpolate values containing mismatched anchors. from[${Fl}]: ${ls[Fl]}, to[${Fl}]: ${ho[Fl]}`);
                                    Dl.push(ls[Fl]);
                                    const [le1, vt] = ls[Fl + 1], [sc, uc] = ho[Fl + 1];
                                    Dl.push([
                                        ke(le1, sc, bt),
                                        ke(vt, uc, bt)
                                    ]);
                                }
                                return new Le(Dl);
                            }
                        }
                        class Oe {
                            constructor(le1){
                                this.name = le1.name, this.available = le1.available;
                            }
                            toString() {
                                return this.name;
                            }
                            static fromString(le1) {
                                return le1 ? new Oe({
                                    name: le1,
                                    available: !1
                                }) : null;
                            }
                        }
                        class Re {
                            constructor(le1, vt, bt){
                                this.from = le1, this.to = vt, this.transition = bt;
                            }
                            static interpolate(le1, vt, bt) {
                                return new Re(le1, vt, bt);
                            }
                            static parse(le1) {
                                return le1 instanceof Re ? le1 : Array.isArray(le1) && 3 === le1.length && "string" == typeof le1[0] && "string" == typeof le1[1] && "number" == typeof le1[2] ? new Re(le1[0], le1[1], le1[2]) : "object" == typeof le1 && "string" == typeof le1.from && "string" == typeof le1.to && "number" == typeof le1.transition ? new Re(le1.from, le1.to, le1.transition) : "string" == typeof le1 ? new Re(le1, le1, 1) : void 0;
                            }
                        }
                        function Ne(le1, vt, bt, ls) {
                            return "number" == typeof le1 && le1 >= 0 && le1 <= 255 && "number" == typeof vt && vt >= 0 && vt <= 255 && "number" == typeof bt && bt >= 0 && bt <= 255 ? void 0 === ls || "number" == typeof ls && ls >= 0 && ls <= 1 ? null : `Invalid rgba value [${[
                                le1,
                                vt,
                                bt,
                                ls
                            ].join(", ")}]: 'a' must be between 0 and 1.` : `Invalid rgba value [${("number" == typeof ls ? [
                                le1,
                                vt,
                                bt,
                                ls
                            ] : [
                                le1,
                                vt,
                                bt
                            ]).join(", ")}]: 'r', 'g', and 'b' must be between 0 and 255.`;
                        }
                        function $e(le1) {
                            if (null === le1 || "string" == typeof le1 || "boolean" == typeof le1 || "number" == typeof le1 || le1 instanceof Re || le1 instanceof Te || le1 instanceof Ie || le1 instanceof De || le1 instanceof ze || le1 instanceof Pe || le1 instanceof Be || le1 instanceof Le || le1 instanceof Oe) return !0;
                            if (Array.isArray(le1)) {
                                for (const vt of le1)if (!$e(vt)) return !1;
                                return !0;
                            }
                            if ("object" == typeof le1) {
                                for(const vt in le1)if (!$e(le1[vt])) return !1;
                                return !0;
                            }
                            return !1;
                        }
                        function Ue(le1) {
                            if (null === le1) return Wd;
                            if ("string" == typeof le1) return Yd;
                            if ("boolean" == typeof le1) return Qd;
                            if ("number" == typeof le1) return Zd;
                            if (le1 instanceof Te) return Xd;
                            if (le1 instanceof Re) return Kd;
                            if (le1 instanceof Ie) return sp;
                            if (le1 instanceof De) return em;
                            if (le1 instanceof ze) return tm;
                            if (le1 instanceof Pe) return nm;
                            if (le1 instanceof Be) return im;
                            if (le1 instanceof Le) return am;
                            if (le1 instanceof Oe) return rm;
                            if (Array.isArray(le1)) {
                                const vt = le1.length;
                                let bt;
                                for (const ls of le1){
                                    const le1 = Ue(ls);
                                    if (bt) {
                                        if (bt === le1) continue;
                                        bt = $d;
                                        break;
                                    }
                                    bt = le1;
                                }
                                return Kt(bt || $d, vt);
                            }
                            return Jd;
                        }
                        function qe(le1) {
                            const vt = typeof le1;
                            return null === le1 ? "" : "string" === vt || "number" === vt || "boolean" === vt ? String(le1) : le1 instanceof Te || le1 instanceof Re || le1 instanceof De || le1 instanceof ze || le1 instanceof Pe || le1 instanceof Be || le1 instanceof Le || le1 instanceof Oe ? le1.toString() : JSON.stringify(le1);
                        }
                        class je {
                            constructor(le1, vt){
                                this.type = le1, this.value = vt;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error(`'literal' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                                if (!$e(le1[1])) return vt.error("invalid value");
                                const bt = le1[1];
                                let ls = Ue(bt);
                                const ho = vt.expectedType;
                                return "array" !== ls.kind || 0 !== ls.N || !ho || "array" !== ho.kind || "number" == typeof ho.N && 0 !== ho.N || (ls = ho), new je(ls, bt);
                            }
                            evaluate() {
                                return this.value;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        const ym = {
                            string: Yd,
                            number: Zd,
                            boolean: Qd,
                            object: Jd
                        };
                        class Xe {
                            constructor(le1, vt){
                                this.type = le1, this.args = vt;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 2) return vt.error("Expected at least one argument.");
                                let bt, ls = 1;
                                const ho = le1[0];
                                if ("array" === ho) {
                                    let ho, Dl;
                                    if (le1.length > 2) {
                                        const bt = le1[1];
                                        if ("string" != typeof bt || !(bt in ym) || "object" === bt) return vt.error('The item type argument of "array" must be one of string, number, boolean', 1);
                                        ho = ym[bt], ls++;
                                    } else ho = $d;
                                    if (le1.length > 3) {
                                        if (null !== le1[2] && ("number" != typeof le1[2] || le1[2] < 0 || le1[2] !== Math.floor(le1[2]))) return vt.error('The length argument to "array" must be a positive integer literal', 2);
                                        Dl = le1[2], ls++;
                                    }
                                    bt = Kt(ho, Dl);
                                } else {
                                    if (!ym[ho]) throw new Error(`Types doesn't contain name = ${ho}`);
                                    bt = ym[ho];
                                }
                                const Dl = [];
                                for(; ls < le1.length; ls++){
                                    const bt = vt.parse(le1[ls], ls, $d);
                                    if (!bt) return null;
                                    Dl.push(bt);
                                }
                                return new Xe(bt, Dl);
                            }
                            evaluate(le1) {
                                for(let vt = 0; vt < this.args.length; vt++){
                                    const bt = this.args[vt].evaluate(le1);
                                    if (!Qt(this.type, Ue(bt))) return bt;
                                    if (vt === this.args.length - 1) throw new Ve(`Expected value to be of type ${Wt(this.type)}, but found ${Wt(Ue(bt))} instead.`);
                                }
                                throw new Error;
                            }
                            eachChild(le1) {
                                this.args.forEach(le1);
                            }
                            outputDefined() {
                                return this.args.every((le1)=>le1.outputDefined());
                            }
                        }
                        const vm = {
                            "to-boolean": Qd,
                            "to-color": Xd,
                            "to-number": Zd,
                            "to-string": Yd
                        };
                        class Ze {
                            constructor(le1, vt){
                                this.type = le1, this.args = vt;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 2) return vt.error("Expected at least one argument.");
                                const bt = le1[0];
                                if (!vm[bt]) throw new Error(`Can't parse ${bt} as it is not part of the known types`);
                                if (("to-boolean" === bt || "to-string" === bt) && 2 !== le1.length) return vt.error("Expected one argument.");
                                const ls = vm[bt], ho = [];
                                for(let Dl = 1; Dl < le1.length; Dl++){
                                    const bt = vt.parse(le1[Dl], Dl, $d);
                                    if (!bt) return null;
                                    ho.push(bt);
                                }
                                return new Ze(ls, ho);
                            }
                            evaluate(le1) {
                                switch(this.type.kind){
                                    case "boolean":
                                        return Boolean(this.args[0].evaluate(le1));
                                    case "color":
                                        {
                                            let vt, bt;
                                            for (const ls of this.args){
                                                if (vt = ls.evaluate(le1), bt = null, vt instanceof Te) return vt;
                                                if ("string" == typeof vt) {
                                                    const bt = le1.parseColor(vt);
                                                    if (bt) return bt;
                                                } else if (Array.isArray(vt) && (bt = vt.length < 3 || vt.length > 4 ? `Invalid rgba value ${JSON.stringify(vt)}: expected an array containing either three or four numeric values.` : Ne(vt[0], vt[1], vt[2], vt[3]), !bt)) return new Te(vt[0] / 255, vt[1] / 255, vt[2] / 255, vt[3]);
                                            }
                                            throw new Ve(bt || `Could not parse color from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                        }
                                    case "padding":
                                        {
                                            let vt;
                                            for (const bt of this.args){
                                                vt = bt.evaluate(le1);
                                                const ls = ze.parse(vt);
                                                if (ls) return ls;
                                            }
                                            throw new Ve(`Could not parse padding from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                        }
                                    case "numberArray":
                                        {
                                            let vt;
                                            for (const bt of this.args){
                                                vt = bt.evaluate(le1);
                                                const ls = Pe.parse(vt);
                                                if (ls) return ls;
                                            }
                                            throw new Ve(`Could not parse numberArray from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                        }
                                    case "colorArray":
                                        {
                                            let vt;
                                            for (const bt of this.args){
                                                vt = bt.evaluate(le1);
                                                const ls = Be.parse(vt);
                                                if (ls) return ls;
                                            }
                                            throw new Ve(`Could not parse colorArray from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                        }
                                    case "variableAnchorOffsetCollection":
                                        {
                                            let vt;
                                            for (const bt of this.args){
                                                vt = bt.evaluate(le1);
                                                const ls = Le.parse(vt);
                                                if (ls) return ls;
                                            }
                                            throw new Ve(`Could not parse variableAnchorOffsetCollection from value '${"string" == typeof vt ? vt : JSON.stringify(vt)}'`);
                                        }
                                    case "number":
                                        {
                                            let vt = null;
                                            for (const bt of this.args){
                                                if (vt = bt.evaluate(le1), null === vt) return 0;
                                                const ls = Number(vt);
                                                if (!isNaN(ls)) return ls;
                                            }
                                            throw new Ve(`Could not convert ${JSON.stringify(vt)} to number.`);
                                        }
                                    case "formatted":
                                        return De.fromString(qe(this.args[0].evaluate(le1)));
                                    case "resolvedImage":
                                        return Oe.fromString(qe(this.args[0].evaluate(le1)));
                                    case "projectionDefinition":
                                        return this.args[0].evaluate(le1);
                                    default:
                                        return qe(this.args[0].evaluate(le1));
                                }
                            }
                            eachChild(le1) {
                                this.args.forEach(le1);
                            }
                            outputDefined() {
                                return this.args.every((le1)=>le1.outputDefined());
                            }
                        }
                        const xm = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ];
                        class Ke {
                            constructor(){
                                this.globals = null, this.feature = null, this.featureState = null, this.formattedSection = null, this._parseColorCache = new Map, this.availableImages = null, this.canonical = null;
                            }
                            id() {
                                return this.feature && "id" in this.feature ? this.feature.id : null;
                            }
                            geometryType() {
                                return this.feature ? "number" == typeof this.feature.type ? xm[this.feature.type] : this.feature.type : null;
                            }
                            geometry() {
                                return this.feature && "geometry" in this.feature ? this.feature.geometry : null;
                            }
                            canonicalID() {
                                return this.canonical;
                            }
                            properties() {
                                return this.feature && this.feature.properties || {};
                            }
                            parseColor(le1) {
                                let vt = this._parseColorCache.get(le1);
                                return vt || (vt = Te.parse(le1), this._parseColorCache.set(le1, vt)), vt;
                            }
                        }
                        class We {
                            constructor(le1, vt, bt = [], ls, ho = new Bt, Dl = []){
                                this.registry = le1, this.path = bt, this.key = bt.map((le1)=>`[${le1}]`).join(""), this.scope = ho, this.errors = Dl, this.expectedType = ls, this._isConstant = vt;
                            }
                            parse(le1, vt, bt, ls, ho = {}) {
                                return vt ? this.concat(vt, bt, ls)._parse(le1, ho) : this._parse(le1, ho);
                            }
                            _parse(le1, vt) {
                                function r(le1, vt, bt) {
                                    return "assert" === bt ? new Xe(vt, [
                                        le1
                                    ]) : "coerce" === bt ? new Ze(vt, [
                                        le1
                                    ]) : le1;
                                }
                                if (null !== le1 && "string" != typeof le1 && "boolean" != typeof le1 && "number" != typeof le1 || (le1 = [
                                    "literal",
                                    le1
                                ]), Array.isArray(le1)) {
                                    if (0 === le1.length) return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');
                                    const bt = le1[0];
                                    if ("string" != typeof bt) return this.error(`Expression name must be a string, but found ${typeof bt} instead. If you wanted a literal array, use ["literal", [...]].`, 0), null;
                                    const ls = this.registry[bt];
                                    if (ls) {
                                        let bt = ls.parse(le1, this);
                                        if (!bt) return null;
                                        if (this.expectedType) {
                                            const le1 = this.expectedType, ls = bt.type;
                                            if ("string" !== le1.kind && "number" !== le1.kind && "boolean" !== le1.kind && "object" !== le1.kind && "array" !== le1.kind || "value" !== ls.kind) {
                                                if ("projectionDefinition" === le1.kind && [
                                                    "string",
                                                    "array"
                                                ].includes(ls.kind) || [
                                                    "color",
                                                    "formatted",
                                                    "resolvedImage"
                                                ].includes(le1.kind) && [
                                                    "value",
                                                    "string"
                                                ].includes(ls.kind) || [
                                                    "padding",
                                                    "numberArray"
                                                ].includes(le1.kind) && [
                                                    "value",
                                                    "number",
                                                    "array"
                                                ].includes(ls.kind) || "colorArray" === le1.kind && [
                                                    "value",
                                                    "string",
                                                    "array"
                                                ].includes(ls.kind) || "variableAnchorOffsetCollection" === le1.kind && [
                                                    "value",
                                                    "array"
                                                ].includes(ls.kind)) bt = r(bt, le1, vt.typeAnnotation || "coerce");
                                                else if (this.checkSubtype(le1, ls)) return null;
                                            } else bt = r(bt, le1, vt.typeAnnotation || "assert");
                                        }
                                        if (!(bt instanceof je) && "resolvedImage" !== bt.type.kind && this._isConstant(bt)) {
                                            const vt = new Ke;
                                            try {
                                                bt = new je(bt.type, bt.evaluate(vt));
                                            } catch (le1) {
                                                return this.error(le1.message), null;
                                            }
                                        }
                                        return bt;
                                    }
                                    return this.error(`Unknown expression "${bt}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                }
                                return this.error(void 0 === le1 ? "'undefined' value invalid. Use null instead." : "object" == typeof le1 ? 'Bare objects invalid. Use ["literal", {...}] instead.' : `Expected an array, but found ${typeof le1} instead.`);
                            }
                            concat(le1, vt, bt) {
                                const ls = "number" == typeof le1 ? this.path.concat(le1) : this.path, ho = bt ? this.scope.concat(bt) : this.scope;
                                return new We(this.registry, this._isConstant, ls, vt || null, ho, this.errors);
                            }
                            error(le1, ...vt) {
                                const bt = `${this.key}${vt.map((le1)=>`[${le1}]`).join("")}`;
                                this.errors.push(new Pt(bt, le1));
                            }
                            checkSubtype(le1, vt) {
                                const bt = Qt(le1, vt);
                                return bt && this.error(bt), bt;
                            }
                        }
                        class Je {
                            constructor(le1, vt){
                                this.type = vt.type, this.bindings = [].concat(le1), this.result = vt;
                            }
                            evaluate(le1) {
                                return this.result.evaluate(le1);
                            }
                            eachChild(le1) {
                                for (const vt of this.bindings)le1(vt[1]);
                                le1(this.result);
                            }
                            static parse(le1, vt) {
                                if (le1.length < 4) return vt.error(`Expected at least 3 arguments, but found ${le1.length - 1} instead.`);
                                const bt = [];
                                for(let ho = 1; ho < le1.length - 1; ho += 2){
                                    const ls = le1[ho];
                                    if ("string" != typeof ls) return vt.error(`Expected string, but found ${typeof ls} instead.`, ho);
                                    if (/[^a-zA-Z0-9_]/.test(ls)) return vt.error("Variable names must contain only alphanumeric characters or '_'.", ho);
                                    const Dl = vt.parse(le1[ho + 1], ho + 1);
                                    if (!Dl) return null;
                                    bt.push([
                                        ls,
                                        Dl
                                    ]);
                                }
                                const ls = vt.parse(le1[le1.length - 1], le1.length - 1, vt.expectedType, bt);
                                return ls ? new Je(bt, ls) : null;
                            }
                            outputDefined() {
                                return this.result.outputDefined();
                            }
                        }
                        class Qe {
                            constructor(le1, vt){
                                this.type = vt.type, this.name = le1, this.boundExpression = vt;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length || "string" != typeof le1[1]) return vt.error("'var' expression requires exactly one string literal argument.");
                                const bt = le1[1];
                                return vt.scope.has(bt) ? new Qe(bt, vt.scope.get(bt)) : vt.error(`Unknown variable "${bt}". Make sure "${bt}" has been bound in an enclosing "let" expression before using it.`, 1);
                            }
                            evaluate(le1) {
                                return this.boundExpression.evaluate(le1);
                            }
                            eachChild() {}
                            outputDefined() {
                                return !1;
                            }
                        }
                        class tr {
                            constructor(le1, vt, bt){
                                this.type = le1, this.index = vt, this.input = bt;
                            }
                            static parse(le1, vt) {
                                if (3 !== le1.length) return vt.error(`Expected 2 arguments, but found ${le1.length - 1} instead.`);
                                const bt = vt.parse(le1[1], 1, Zd), ls = vt.parse(le1[2], 2, Kt(vt.expectedType || $d));
                                return bt && ls ? new tr(ls.type.itemType, bt, ls) : null;
                            }
                            evaluate(le1) {
                                const vt = this.index.evaluate(le1), bt = this.input.evaluate(le1);
                                if (vt < 0) throw new Ve(`Array index out of bounds: ${vt} < 0.`);
                                if (vt >= bt.length) throw new Ve(`Array index out of bounds: ${vt} > ${bt.length - 1}.`);
                                if (vt !== Math.floor(vt)) throw new Ve(`Array index must be an integer, but found ${vt} instead.`);
                                return bt[vt];
                            }
                            eachChild(le1) {
                                le1(this.index), le1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class er {
                            constructor(le1, vt){
                                this.type = Qd, this.needle = le1, this.haystack = vt;
                            }
                            static parse(le1, vt) {
                                if (3 !== le1.length) return vt.error(`Expected 2 arguments, but found ${le1.length - 1} instead.`);
                                const bt = vt.parse(le1[1], 1, $d), ls = vt.parse(le1[2], 2, $d);
                                return bt && ls ? te(bt.type, [
                                    Qd,
                                    Yd,
                                    Zd,
                                    Wd,
                                    $d
                                ]) ? new er(bt, ls) : vt.error(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(bt.type)} instead`) : null;
                            }
                            evaluate(le1) {
                                const vt = this.needle.evaluate(le1), bt = this.haystack.evaluate(le1);
                                if (!bt) return !1;
                                if (!ee(vt, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new Ve(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(Ue(vt))} instead.`);
                                if (!ee(bt, [
                                    "string",
                                    "array"
                                ])) throw new Ve(`Expected second argument to be of type array or string, but found ${Wt(Ue(bt))} instead.`);
                                return bt.indexOf(vt) >= 0;
                            }
                            eachChild(le1) {
                                le1(this.needle), le1(this.haystack);
                            }
                            outputDefined() {
                                return !0;
                            }
                        }
                        class rr {
                            constructor(le1, vt, bt){
                                this.type = Zd, this.needle = le1, this.haystack = vt, this.fromIndex = bt;
                            }
                            static parse(le1, vt) {
                                if (le1.length <= 2 || le1.length >= 5) return vt.error(`Expected 2 or 3 arguments, but found ${le1.length - 1} instead.`);
                                const bt = vt.parse(le1[1], 1, $d), ls = vt.parse(le1[2], 2, $d);
                                if (!bt || !ls) return null;
                                if (!te(bt.type, [
                                    Qd,
                                    Yd,
                                    Zd,
                                    Wd,
                                    $d
                                ])) return vt.error(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(bt.type)} instead`);
                                if (4 === le1.length) {
                                    const ho = vt.parse(le1[3], 3, Zd);
                                    return ho ? new rr(bt, ls, ho) : null;
                                }
                                return new rr(bt, ls);
                            }
                            evaluate(le1) {
                                const vt = this.needle.evaluate(le1), bt = this.haystack.evaluate(le1);
                                if (!ee(vt, [
                                    "boolean",
                                    "string",
                                    "number",
                                    "null"
                                ])) throw new Ve(`Expected first argument to be of type boolean, string, number or null, but found ${Wt(Ue(vt))} instead.`);
                                let ls;
                                if (this.fromIndex && (ls = this.fromIndex.evaluate(le1)), ee(bt, [
                                    "string"
                                ])) {
                                    const le1 = bt.indexOf(vt, ls);
                                    return -1 === le1 ? -1 : [
                                        ...bt.slice(0, le1)
                                    ].length;
                                }
                                if (ee(bt, [
                                    "array"
                                ])) return bt.indexOf(vt, ls);
                                throw new Ve(`Expected second argument to be of type array or string, but found ${Wt(Ue(bt))} instead.`);
                            }
                            eachChild(le1) {
                                le1(this.needle), le1(this.haystack), this.fromIndex && le1(this.fromIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class nr {
                            constructor(le1, vt, bt, ls, ho, Dl){
                                this.inputType = le1, this.type = vt, this.input = bt, this.cases = ls, this.outputs = ho, this.otherwise = Dl;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 5) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                                if (le1.length % 2 != 1) return vt.error("Expected an even number of arguments.");
                                let bt, ls;
                                vt.expectedType && "value" !== vt.expectedType.kind && (ls = vt.expectedType);
                                const ho = {}, Dl = [];
                                for(let uc = 2; uc < le1.length - 1; uc += 2){
                                    let Fl = le1[uc];
                                    const sc = le1[uc + 1];
                                    Array.isArray(Fl) || (Fl = [
                                        Fl
                                    ]);
                                    const mc = vt.concat(uc);
                                    if (0 === Fl.length) return mc.error("Expected at least one branch label.");
                                    for (const le1 of Fl){
                                        if ("number" != typeof le1 && "string" != typeof le1) return mc.error("Branch labels must be numbers or strings.");
                                        if ("number" == typeof le1 && Math.abs(le1) > Number.MAX_SAFE_INTEGER) return mc.error(`Branch labels must be integers no larger than ${Number.MAX_SAFE_INTEGER}.`);
                                        if ("number" == typeof le1 && Math.floor(le1) !== le1) return mc.error("Numeric branch labels must be integer values.");
                                        if (bt) {
                                            if (mc.checkSubtype(bt, Ue(le1))) return null;
                                        } else bt = Ue(le1);
                                        if (void 0 !== ho[String(le1)]) return mc.error("Branch labels must be unique.");
                                        ho[String(le1)] = Dl.length;
                                    }
                                    const gc = vt.parse(sc, uc, ls);
                                    if (!gc) return null;
                                    ls = ls || gc.type, Dl.push(gc);
                                }
                                const Fl = vt.parse(le1[1], 1, $d);
                                if (!Fl) return null;
                                const sc = vt.parse(le1[le1.length - 1], le1.length - 1, ls);
                                return sc ? "value" !== Fl.type.kind && vt.concat(1).checkSubtype(bt, Fl.type) ? null : new nr(bt, ls, Fl, ho, Dl, sc) : null;
                            }
                            evaluate(le1) {
                                const vt = this.input.evaluate(le1);
                                return (Ue(vt) === this.inputType && this.outputs[this.cases[vt]] || this.otherwise).evaluate(le1);
                            }
                            eachChild(le1) {
                                le1(this.input), this.outputs.forEach(le1), le1(this.otherwise);
                            }
                            outputDefined() {
                                return this.outputs.every((le1)=>le1.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class ir {
                            constructor(le1, vt, bt){
                                this.type = le1, this.branches = vt, this.otherwise = bt;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 4) return vt.error(`Expected at least 3 arguments, but found only ${le1.length - 1}.`);
                                if (le1.length % 2 != 0) return vt.error("Expected an odd number of arguments.");
                                let bt;
                                vt.expectedType && "value" !== vt.expectedType.kind && (bt = vt.expectedType);
                                const ls = [];
                                for(let Dl = 1; Dl < le1.length - 1; Dl += 2){
                                    const ho = vt.parse(le1[Dl], Dl, Qd);
                                    if (!ho) return null;
                                    const Fl = vt.parse(le1[Dl + 1], Dl + 1, bt);
                                    if (!Fl) return null;
                                    ls.push([
                                        ho,
                                        Fl
                                    ]), bt = bt || Fl.type;
                                }
                                const ho = vt.parse(le1[le1.length - 1], le1.length - 1, bt);
                                if (!ho) return null;
                                if (!bt) throw new Error("Can't infer output type");
                                return new ir(bt, ls, ho);
                            }
                            evaluate(le1) {
                                for (const [vt, bt] of this.branches)if (vt.evaluate(le1)) return bt.evaluate(le1);
                                return this.otherwise.evaluate(le1);
                            }
                            eachChild(le1) {
                                for (const [vt, bt] of this.branches)le1(vt), le1(bt);
                                le1(this.otherwise);
                            }
                            outputDefined() {
                                return this.branches.every(([le1, vt])=>vt.outputDefined()) && this.otherwise.outputDefined();
                            }
                        }
                        class sr {
                            constructor(le1, vt, bt, ls){
                                this.type = le1, this.input = vt, this.beginIndex = bt, this.endIndex = ls;
                            }
                            static parse(le1, vt) {
                                if (le1.length <= 2 || le1.length >= 5) return vt.error(`Expected 2 or 3 arguments, but found ${le1.length - 1} instead.`);
                                const bt = vt.parse(le1[1], 1, $d), ls = vt.parse(le1[2], 2, Zd);
                                if (!bt || !ls) return null;
                                if (!te(bt.type, [
                                    Kt($d),
                                    Yd,
                                    $d
                                ])) return vt.error(`Expected first argument to be of type array or string, but found ${Wt(bt.type)} instead`);
                                if (4 === le1.length) {
                                    const ho = vt.parse(le1[3], 3, Zd);
                                    return ho ? new sr(bt.type, bt, ls, ho) : null;
                                }
                                return new sr(bt.type, bt, ls);
                            }
                            evaluate(le1) {
                                const vt = this.input.evaluate(le1), bt = this.beginIndex.evaluate(le1);
                                let ls;
                                if (this.endIndex && (ls = this.endIndex.evaluate(le1)), ee(vt, [
                                    "string"
                                ])) return [
                                    ...vt
                                ].slice(bt, ls).join("");
                                if (ee(vt, [
                                    "array"
                                ])) return vt.slice(bt, ls);
                                throw new Ve(`Expected first argument to be of type array or string, but found ${Wt(Ue(vt))} instead.`);
                            }
                            eachChild(le1) {
                                le1(this.input), le1(this.beginIndex), this.endIndex && le1(this.endIndex);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        function ar(le1, vt) {
                            const bt = le1.length - 1;
                            let ls, ho, Dl = 0, Fl = bt, sc = 0;
                            for(; Dl <= Fl;)if (sc = Math.floor((Dl + Fl) / 2), ls = le1[sc], ho = le1[sc + 1], ls <= vt) {
                                if (sc === bt || vt < ho) return sc;
                                Dl = sc + 1;
                            } else {
                                if (!(ls > vt)) throw new Ve("Input is not a number.");
                                Fl = sc - 1;
                            }
                            return 0;
                        }
                        class or {
                            constructor(le1, vt, bt){
                                this.type = le1, this.input = vt, this.labels = [], this.outputs = [];
                                for (const [ls, ho] of bt)this.labels.push(ls), this.outputs.push(ho);
                            }
                            static parse(le1, vt) {
                                if (le1.length - 1 < 4) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                                if ((le1.length - 1) % 2 != 0) return vt.error("Expected an even number of arguments.");
                                const bt = vt.parse(le1[1], 1, Zd);
                                if (!bt) return null;
                                const ls = [];
                                let ho = null;
                                vt.expectedType && "value" !== vt.expectedType.kind && (ho = vt.expectedType);
                                for(let Dl = 1; Dl < le1.length; Dl += 2){
                                    const bt = 1 === Dl ? -1 / 0 : le1[Dl], Fl = le1[Dl + 1], sc = Dl, uc = Dl + 1;
                                    if ("number" != typeof bt) return vt.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.', sc);
                                    if (ls.length && ls[ls.length - 1][0] >= bt) return vt.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.', sc);
                                    const mc = vt.parse(Fl, uc, ho);
                                    if (!mc) return null;
                                    ho = ho || mc.type, ls.push([
                                        bt,
                                        mc
                                    ]);
                                }
                                return new or(ho, bt, ls);
                            }
                            evaluate(le1) {
                                const vt = this.labels, bt = this.outputs;
                                if (1 === vt.length) return bt[0].evaluate(le1);
                                const ls = this.input.evaluate(le1);
                                if (ls <= vt[0]) return bt[0].evaluate(le1);
                                const ho = vt.length;
                                return ls >= vt[ho - 1] ? bt[ho - 1].evaluate(le1) : bt[ar(vt, ls)].evaluate(le1);
                            }
                            eachChild(le1) {
                                le1(this.input);
                                for (const vt of this.outputs)le1(vt);
                            }
                            outputDefined() {
                                return this.outputs.every((le1)=>le1.outputDefined());
                            }
                        }
                        function lr(le1) {
                            return le1 && le1.__esModule && Object.prototype.hasOwnProperty.call(le1, "default") ? le1.default : le1;
                        }
                        var bm, wm, Em = function() {
                            if (wm) return bm;
                            function t(le1, vt, bt, ls) {
                                this.cx = 3 * le1, this.bx = 3 * (bt - le1) - this.cx, this.ax = 1 - this.cx - this.bx, this.cy = 3 * vt, this.by = 3 * (ls - vt) - this.cy, this.ay = 1 - this.cy - this.by, this.p1x = le1, this.p1y = vt, this.p2x = bt, this.p2y = ls;
                            }
                            return wm = 1, bm = t, t.prototype = {
                                sampleCurveX: function(le1) {
                                    return ((this.ax * le1 + this.bx) * le1 + this.cx) * le1;
                                },
                                sampleCurveY: function(le1) {
                                    return ((this.ay * le1 + this.by) * le1 + this.cy) * le1;
                                },
                                sampleCurveDerivativeX: function(le1) {
                                    return (3 * this.ax * le1 + 2 * this.bx) * le1 + this.cx;
                                },
                                solveCurveX: function(le1, vt) {
                                    if (void 0 === vt && (vt = 1e-6), le1 < 0) return 0;
                                    if (le1 > 1) return 1;
                                    for(var bt = le1, ls = 0; ls < 8; ls++){
                                        var ho = this.sampleCurveX(bt) - le1;
                                        if (Math.abs(ho) < vt) return bt;
                                        var Dl = this.sampleCurveDerivativeX(bt);
                                        if (Math.abs(Dl) < 1e-6) break;
                                        bt -= ho / Dl;
                                    }
                                    var Fl = 0, sc = 1;
                                    for(bt = le1, ls = 0; ls < 20 && (ho = this.sampleCurveX(bt), !(Math.abs(ho - le1) < vt)); ls++)le1 > ho ? Fl = bt : sc = bt, bt = .5 * (sc - Fl) + Fl;
                                    return bt;
                                },
                                solve: function(le1, vt) {
                                    return this.sampleCurveY(this.solveCurveX(le1, vt));
                                }
                            }, bm;
                        }(), Mm = lr(Em);
                        class fr {
                            constructor(le1, vt, bt, ls, ho){
                                this.type = le1, this.operator = vt, this.interpolation = bt, this.input = ls, this.labels = [], this.outputs = [];
                                for (const [Dl, Fl] of ho)this.labels.push(Dl), this.outputs.push(Fl);
                            }
                            static interpolationFactor(le1, vt, bt, ls) {
                                let ho = 0;
                                if ("exponential" === le1.name) ho = dr(vt, le1.base, bt, ls);
                                else if ("linear" === le1.name) ho = dr(vt, 1, bt, ls);
                                else if ("cubic-bezier" === le1.name) {
                                    const Dl = le1.controlPoints;
                                    ho = new Mm(Dl[0], Dl[1], Dl[2], Dl[3]).solve(dr(vt, 1, bt, ls));
                                }
                                return ho;
                            }
                            static parse(le1, vt) {
                                let [bt, ls, ho, ...Dl] = le1;
                                if (!Array.isArray(ls) || 0 === ls.length) return vt.error("Expected an interpolation type expression.", 1);
                                if ("linear" === ls[0]) ls = {
                                    name: "linear"
                                };
                                else if ("exponential" === ls[0]) {
                                    const le1 = ls[1];
                                    if ("number" != typeof le1) return vt.error("Exponential interpolation requires a numeric base.", 1, 1);
                                    ls = {
                                        name: "exponential",
                                        base: le1
                                    };
                                } else {
                                    if ("cubic-bezier" !== ls[0]) return vt.error(`Unknown interpolation type ${String(ls[0])}`, 1, 0);
                                    {
                                        const le1 = ls.slice(1);
                                        if (4 !== le1.length || le1.some((le1)=>"number" != typeof le1 || le1 < 0 || le1 > 1)) return vt.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.", 1);
                                        ls = {
                                            name: "cubic-bezier",
                                            controlPoints: le1
                                        };
                                    }
                                }
                                if (le1.length - 1 < 4) return vt.error(`Expected at least 4 arguments, but found only ${le1.length - 1}.`);
                                if ((le1.length - 1) % 2 != 0) return vt.error("Expected an even number of arguments.");
                                if (ho = vt.parse(ho, 2, Zd), !ho) return null;
                                const Fl = [];
                                let sc = null;
                                "interpolate-hcl" !== bt && "interpolate-lab" !== bt || vt.expectedType == im ? vt.expectedType && "value" !== vt.expectedType.kind && (sc = vt.expectedType) : sc = Xd;
                                for(let uc = 0; uc < Dl.length; uc += 2){
                                    const le1 = Dl[uc], bt = Dl[uc + 1], ls = uc + 3, ho = uc + 4;
                                    if ("number" != typeof le1) return vt.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.', ls);
                                    if (Fl.length && Fl[Fl.length - 1][0] >= le1) return vt.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.', ls);
                                    const mc = vt.parse(bt, ho, sc);
                                    if (!mc) return null;
                                    sc = sc || mc.type, Fl.push([
                                        le1,
                                        mc
                                    ]);
                                }
                                return re(sc, Zd) || re(sc, Kd) || re(sc, Xd) || re(sc, tm) || re(sc, nm) || re(sc, im) || re(sc, am) || re(sc, Kt(Zd)) ? new fr(sc, bt, ls, ho, Fl) : vt.error(`Type ${Wt(sc)} is not interpolatable.`);
                            }
                            evaluate(le1) {
                                const vt = this.labels, bt = this.outputs;
                                if (1 === vt.length) return bt[0].evaluate(le1);
                                const ls = this.input.evaluate(le1);
                                if (ls <= vt[0]) return bt[0].evaluate(le1);
                                const ho = vt.length;
                                if (ls >= vt[ho - 1]) return bt[ho - 1].evaluate(le1);
                                const Dl = ar(vt, ls), Fl = fr.interpolationFactor(this.interpolation, ls, vt[Dl], vt[Dl + 1]), sc = bt[Dl].evaluate(le1), uc = bt[Dl + 1].evaluate(le1);
                                switch(this.operator){
                                    case "interpolate":
                                        switch(this.type.kind){
                                            case "number":
                                                return ke(sc, uc, Fl);
                                            case "color":
                                                return Te.interpolate(sc, uc, Fl);
                                            case "padding":
                                                return ze.interpolate(sc, uc, Fl);
                                            case "colorArray":
                                                return Be.interpolate(sc, uc, Fl);
                                            case "numberArray":
                                                return Pe.interpolate(sc, uc, Fl);
                                            case "variableAnchorOffsetCollection":
                                                return Le.interpolate(sc, uc, Fl);
                                            case "array":
                                                return Ee(sc, uc, Fl);
                                            case "projectionDefinition":
                                                return Re.interpolate(sc, uc, Fl);
                                        }
                                    case "interpolate-hcl":
                                        switch(this.type.kind){
                                            case "color":
                                                return Te.interpolate(sc, uc, Fl, "hcl");
                                            case "colorArray":
                                                return Be.interpolate(sc, uc, Fl, "hcl");
                                        }
                                    case "interpolate-lab":
                                        switch(this.type.kind){
                                            case "color":
                                                return Te.interpolate(sc, uc, Fl, "lab");
                                            case "colorArray":
                                                return Be.interpolate(sc, uc, Fl, "lab");
                                        }
                                }
                            }
                            eachChild(le1) {
                                le1(this.input);
                                for (const vt of this.outputs)le1(vt);
                            }
                            outputDefined() {
                                return this.outputs.every((le1)=>le1.outputDefined());
                            }
                        }
                        function dr(le1, vt, bt, ls) {
                            const ho = ls - bt, Dl = le1 - bt;
                            return 0 === ho ? 0 : 1 === vt ? Dl / ho : (Math.pow(vt, Dl) - 1) / (Math.pow(vt, ho) - 1);
                        }
                        const Sm = {
                            color: Te.interpolate,
                            number: ke,
                            padding: ze.interpolate,
                            numberArray: Pe.interpolate,
                            colorArray: Be.interpolate,
                            variableAnchorOffsetCollection: Le.interpolate,
                            array: Ee
                        };
                        class mr {
                            constructor(le1, vt){
                                this.type = le1, this.args = vt;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 2) return vt.error("Expected at least one argument.");
                                let bt = null;
                                const ls = vt.expectedType;
                                ls && "value" !== ls.kind && (bt = ls);
                                const ho = [];
                                for (const Fl of le1.slice(1)){
                                    const le1 = vt.parse(Fl, 1 + ho.length, bt, void 0, {
                                        typeAnnotation: "omit"
                                    });
                                    if (!le1) return null;
                                    bt = bt || le1.type, ho.push(le1);
                                }
                                if (!bt) throw new Error("No output type");
                                const Dl = ls && ho.some((le1)=>Qt(ls, le1.type));
                                return new mr(Dl ? $d : bt, ho);
                            }
                            evaluate(le1) {
                                let vt, bt = null, ls = 0;
                                for (const ho of this.args)if (ls++, bt = ho.evaluate(le1), bt && bt instanceof Oe && !bt.available && (vt || (vt = bt.name), bt = null, ls === this.args.length && (bt = vt)), null !== bt) break;
                                return bt;
                            }
                            eachChild(le1) {
                                this.args.forEach(le1);
                            }
                            outputDefined() {
                                return this.args.every((le1)=>le1.outputDefined());
                            }
                        }
                        function gr(le1, vt) {
                            return "==" === le1 || "!=" === le1 ? "boolean" === vt.kind || "string" === vt.kind || "number" === vt.kind || "null" === vt.kind || "value" === vt.kind : "string" === vt.kind || "number" === vt.kind || "value" === vt.kind;
                        }
                        function xr(le1, vt, bt, ls) {
                            return 0 === ls.compare(vt, bt);
                        }
                        function vr(le1, vt, bt) {
                            const ls = "==" !== le1 && "!=" !== le1;
                            return class i {
                                constructor(le1, vt, bt){
                                    this.type = Qd, this.lhs = le1, this.rhs = vt, this.collator = bt, this.hasUntypedArgument = "value" === le1.type.kind || "value" === vt.type.kind;
                                }
                                static parse(le1, vt) {
                                    if (3 !== le1.length && 4 !== le1.length) return vt.error("Expected two or three arguments.");
                                    const bt = le1[0];
                                    let ho = vt.parse(le1[1], 1, $d);
                                    if (!ho) return null;
                                    if (!gr(bt, ho.type)) return vt.concat(1).error(`"${bt}" comparisons are not supported for type '${Wt(ho.type)}'.`);
                                    let Dl = vt.parse(le1[2], 2, $d);
                                    if (!Dl) return null;
                                    if (!gr(bt, Dl.type)) return vt.concat(2).error(`"${bt}" comparisons are not supported for type '${Wt(Dl.type)}'.`);
                                    if (ho.type.kind !== Dl.type.kind && "value" !== ho.type.kind && "value" !== Dl.type.kind) return vt.error(`Cannot compare types '${Wt(ho.type)}' and '${Wt(Dl.type)}'.`);
                                    ls && ("value" === ho.type.kind && "value" !== Dl.type.kind ? ho = new Xe(Dl.type, [
                                        ho
                                    ]) : "value" !== ho.type.kind && "value" === Dl.type.kind && (Dl = new Xe(ho.type, [
                                        Dl
                                    ])));
                                    let Fl = null;
                                    if (4 === le1.length) {
                                        if ("string" !== ho.type.kind && "string" !== Dl.type.kind && "value" !== ho.type.kind && "value" !== Dl.type.kind) return vt.error("Cannot use collator to compare non-string types.");
                                        if (Fl = vt.parse(le1[3], 3, sp), !Fl) return null;
                                    }
                                    return new i(ho, Dl, Fl);
                                }
                                evaluate(ho) {
                                    const Dl = this.lhs.evaluate(ho), Fl = this.rhs.evaluate(ho);
                                    if (ls && this.hasUntypedArgument) {
                                        const vt = Ue(Dl), bt = Ue(Fl);
                                        if (vt.kind !== bt.kind || "string" !== vt.kind && "number" !== vt.kind) throw new Ve(`Expected arguments for "${le1}" to be (string, string) or (number, number), but found (${vt.kind}, ${bt.kind}) instead.`);
                                    }
                                    if (this.collator && !ls && this.hasUntypedArgument) {
                                        const le1 = Ue(Dl), bt = Ue(Fl);
                                        if ("string" !== le1.kind || "string" !== bt.kind) return vt(ho, Dl, Fl);
                                    }
                                    return this.collator ? bt(ho, Dl, Fl, this.collator.evaluate(ho)) : vt(ho, Dl, Fl);
                                }
                                eachChild(le1) {
                                    le1(this.lhs), le1(this.rhs), this.collator && le1(this.collator);
                                }
                                outputDefined() {
                                    return !0;
                                }
                            };
                        }
                        const Tm = vr("==", function(le1, vt, bt) {
                            return vt === bt;
                        }, xr), km = vr("!=", function(le1, vt, bt) {
                            return vt !== bt;
                        }, function(le1, vt, bt, ls) {
                            return !xr(0, vt, bt, ls);
                        }), Cm = vr("<", function(le1, vt, bt) {
                            return vt < bt;
                        }, function(le1, vt, bt, ls) {
                            return ls.compare(vt, bt) < 0;
                        }), Im = vr(">", function(le1, vt, bt) {
                            return vt > bt;
                        }, function(le1, vt, bt, ls) {
                            return ls.compare(vt, bt) > 0;
                        }), Dm = vr("<=", function(le1, vt, bt) {
                            return vt <= bt;
                        }, function(le1, vt, bt, ls) {
                            return ls.compare(vt, bt) <= 0;
                        }), Lm = vr(">=", function(le1, vt, bt) {
                            return vt >= bt;
                        }, function(le1, vt, bt, ls) {
                            return ls.compare(vt, bt) >= 0;
                        });
                        class Er {
                            constructor(le1, vt, bt){
                                this.type = sp, this.locale = bt, this.caseSensitive = le1, this.diacriticSensitive = vt;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error("Expected one argument.");
                                const bt = le1[1];
                                if ("object" != typeof bt || Array.isArray(bt)) return vt.error("Collator options argument must be an object.");
                                const ls = vt.parse(void 0 !== bt["case-sensitive"] && bt["case-sensitive"], 1, Qd);
                                if (!ls) return null;
                                const ho = vt.parse(void 0 !== bt["diacritic-sensitive"] && bt["diacritic-sensitive"], 1, Qd);
                                if (!ho) return null;
                                let Dl = null;
                                return bt.locale && (Dl = vt.parse(bt.locale, 1, Yd), !Dl) ? null : new Er(ls, ho, Dl);
                            }
                            evaluate(le1) {
                                return new Ie(this.caseSensitive.evaluate(le1), this.diacriticSensitive.evaluate(le1), this.locale ? this.locale.evaluate(le1) : null);
                            }
                            eachChild(le1) {
                                le1(this.caseSensitive), le1(this.diacriticSensitive), this.locale && le1(this.locale);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Tr {
                            constructor(le1, vt, bt, ls, ho){
                                this.type = Yd, this.number = le1, this.locale = vt, this.currency = bt, this.minFractionDigits = ls, this.maxFractionDigits = ho;
                            }
                            static parse(le1, vt) {
                                if (3 !== le1.length) return vt.error("Expected two arguments.");
                                const bt = vt.parse(le1[1], 1, Zd);
                                if (!bt) return null;
                                const ls = le1[2];
                                if ("object" != typeof ls || Array.isArray(ls)) return vt.error("NumberFormat options argument must be an object.");
                                let ho = null;
                                if (ls.locale && (ho = vt.parse(ls.locale, 1, Yd), !ho)) return null;
                                let Dl = null;
                                if (ls.currency && (Dl = vt.parse(ls.currency, 1, Yd), !Dl)) return null;
                                let Fl = null;
                                if (ls["min-fraction-digits"] && (Fl = vt.parse(ls["min-fraction-digits"], 1, Zd), !Fl)) return null;
                                let sc = null;
                                return ls["max-fraction-digits"] && (sc = vt.parse(ls["max-fraction-digits"], 1, Zd), !sc) ? null : new Tr(bt, ho, Dl, Fl, sc);
                            }
                            evaluate(le1) {
                                return new Intl.NumberFormat(this.locale ? this.locale.evaluate(le1) : [], {
                                    style: this.currency ? "currency" : "decimal",
                                    currency: this.currency ? this.currency.evaluate(le1) : void 0,
                                    minimumFractionDigits: this.minFractionDigits ? this.minFractionDigits.evaluate(le1) : void 0,
                                    maximumFractionDigits: this.maxFractionDigits ? this.maxFractionDigits.evaluate(le1) : void 0
                                }).format(this.number.evaluate(le1));
                            }
                            eachChild(le1) {
                                le1(this.number), this.locale && le1(this.locale), this.currency && le1(this.currency), this.minFractionDigits && le1(this.minFractionDigits), this.maxFractionDigits && le1(this.maxFractionDigits);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Ir {
                            constructor(le1){
                                this.type = em, this.sections = le1;
                            }
                            static parse(le1, vt) {
                                if (le1.length < 2) return vt.error("Expected at least one argument.");
                                const bt = le1[1];
                                if (!Array.isArray(bt) && "object" == typeof bt) return vt.error("First argument must be an image or text section.");
                                const ls = [];
                                let ho = !1;
                                for(let Dl = 1; Dl <= le1.length - 1; ++Dl){
                                    const bt = le1[Dl];
                                    if (ho && "object" == typeof bt && !Array.isArray(bt)) {
                                        ho = !1;
                                        let le1 = null;
                                        if (bt["font-scale"] && (le1 = vt.parse(bt["font-scale"], 1, Zd), !le1)) return null;
                                        let Dl = null;
                                        if (bt["text-font"] && (Dl = vt.parse(bt["text-font"], 1, Kt(Yd)), !Dl)) return null;
                                        let Fl = null;
                                        if (bt["text-color"] && (Fl = vt.parse(bt["text-color"], 1, Xd), !Fl)) return null;
                                        let sc = null;
                                        if (bt["vertical-align"]) {
                                            if ("string" == typeof bt["vertical-align"] && !Am.includes(bt["vertical-align"])) return vt.error(`'vertical-align' must be one of: 'bottom', 'center', 'top' but found '${bt["vertical-align"]}' instead.`);
                                            if (sc = vt.parse(bt["vertical-align"], 1, Yd), !sc) return null;
                                        }
                                        const uc = ls[ls.length - 1];
                                        uc.scale = le1, uc.font = Dl, uc.textColor = Fl, uc.verticalAlign = sc;
                                    } else {
                                        const bt = vt.parse(le1[Dl], 1, $d);
                                        if (!bt) return null;
                                        const Fl = bt.type.kind;
                                        if ("string" !== Fl && "value" !== Fl && "null" !== Fl && "resolvedImage" !== Fl) return vt.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");
                                        ho = !0, ls.push({
                                            content: bt,
                                            scale: null,
                                            font: null,
                                            textColor: null,
                                            verticalAlign: null
                                        });
                                    }
                                }
                                return new Ir(ls);
                            }
                            evaluate(le1) {
                                return new De(this.sections.map((vt)=>{
                                    const bt = vt.content.evaluate(le1);
                                    return Ue(bt) === rm ? new Fe("", bt, null, null, null, vt.verticalAlign ? vt.verticalAlign.evaluate(le1) : null) : new Fe(qe(bt), null, vt.scale ? vt.scale.evaluate(le1) : null, vt.font ? vt.font.evaluate(le1).join(",") : null, vt.textColor ? vt.textColor.evaluate(le1) : null, vt.verticalAlign ? vt.verticalAlign.evaluate(le1) : null);
                                }));
                            }
                            eachChild(le1) {
                                for (const vt of this.sections)le1(vt.content), vt.scale && le1(vt.scale), vt.font && le1(vt.font), vt.textColor && le1(vt.textColor), vt.verticalAlign && le1(vt.verticalAlign);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Mr {
                            constructor(le1){
                                this.type = rm, this.input = le1;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error("Expected two arguments.");
                                const bt = vt.parse(le1[1], 1, Yd);
                                return bt ? new Mr(bt) : vt.error("No image name provided.");
                            }
                            evaluate(le1) {
                                const vt = this.input.evaluate(le1), bt = Oe.fromString(vt);
                                return bt && le1.availableImages && (bt.available = le1.availableImages.indexOf(vt) > -1), bt;
                            }
                            eachChild(le1) {
                                le1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        class Fr {
                            constructor(le1){
                                this.type = Zd, this.input = le1;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error(`Expected 1 argument, but found ${le1.length - 1} instead.`);
                                const bt = vt.parse(le1[1], 1);
                                return bt ? "array" !== bt.type.kind && "string" !== bt.type.kind && "value" !== bt.type.kind ? vt.error(`Expected argument of type string or array, but found ${Wt(bt.type)} instead.`) : new Fr(bt) : null;
                            }
                            evaluate(le1) {
                                const vt = this.input.evaluate(le1);
                                if ("string" == typeof vt) return [
                                    ...vt
                                ].length;
                                if (Array.isArray(vt)) return vt.length;
                                throw new Ve(`Expected value to be of type string or array, but found ${Wt(Ue(vt))} instead.`);
                            }
                            eachChild(le1) {
                                le1(this.input);
                            }
                            outputDefined() {
                                return !1;
                            }
                        }
                        const Pm = 8192;
                        function zr(le1, vt) {
                            const bt = (180 + le1[0]) / 360, ls = (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + le1[1] * Math.PI / 360))) / 360, ho = Math.pow(2, vt.z);
                            return [
                                Math.round(bt * ho * Pm),
                                Math.round(ls * ho * Pm)
                            ];
                        }
                        function Pr(le1, vt) {
                            const bt = Math.pow(2, vt.z);
                            var ls, ho;
                            return [
                                (ho = (le1[0] / Pm + vt.x) / bt, 360 * ho - 180),
                                (ls = (le1[1] / Pm + vt.y) / bt, 360 / Math.PI * Math.atan(Math.exp((180 - 360 * ls) * Math.PI / 180)) - 90)
                            ];
                        }
                        function Br(le1, vt) {
                            le1[0] = Math.min(le1[0], vt[0]), le1[1] = Math.min(le1[1], vt[1]), le1[2] = Math.max(le1[2], vt[0]), le1[3] = Math.max(le1[3], vt[1]);
                        }
                        function Vr(le1, vt) {
                            return !(le1[0] <= vt[0] || le1[2] >= vt[2] || le1[1] <= vt[1] || le1[3] >= vt[3]);
                        }
                        function Cr(le1, vt, bt) {
                            const ls = le1[0] - vt[0], ho = le1[1] - vt[1], Dl = le1[0] - bt[0], Fl = le1[1] - bt[1];
                            return ls * Fl - Dl * ho == 0 && ls * Dl <= 0 && ho * Fl <= 0;
                        }
                        function Lr(le1, vt, bt, ls) {
                            var ho, Dl;
                            return 0 != (ho = [
                                ls[0] - bt[0],
                                ls[1] - bt[1]
                            ])[0] * (Dl = [
                                vt[0] - le1[0],
                                vt[1] - le1[1]
                            ])[1] - ho[1] * Dl[0] && !(!qr(le1, vt, bt, ls) || !qr(bt, ls, le1, vt));
                        }
                        function Or(le1, vt, bt) {
                            for (const ls of bt)for(let bt = 0; bt < ls.length - 1; ++bt)if (Lr(le1, vt, ls[bt], ls[bt + 1])) return !0;
                            return !1;
                        }
                        function Rr(le1, vt, bt = !1) {
                            let ls = !1;
                            for (const sc of vt)for(let vt = 0; vt < sc.length - 1; vt++){
                                if (Cr(le1, sc[vt], sc[vt + 1])) return bt;
                                (Dl = sc[vt])[1] > (ho = le1)[1] != (Fl = sc[vt + 1])[1] > ho[1] && ho[0] < (Fl[0] - Dl[0]) * (ho[1] - Dl[1]) / (Fl[1] - Dl[1]) + Dl[0] && (ls = !ls);
                            }
                            var ho, Dl, Fl;
                            return ls;
                        }
                        function Nr(le1, vt) {
                            for (const bt of vt)if (Rr(le1, bt)) return !0;
                            return !1;
                        }
                        function $r(le1, vt) {
                            for (const bt of le1)if (!Rr(bt, vt)) return !1;
                            for(let bt = 0; bt < le1.length - 1; ++bt)if (Or(le1[bt], le1[bt + 1], vt)) return !1;
                            return !0;
                        }
                        function Ur(le1, vt) {
                            for (const bt of vt)if ($r(le1, bt)) return !0;
                            return !1;
                        }
                        function qr(le1, vt, bt, ls) {
                            const ho = ls[0] - bt[0], Dl = ls[1] - bt[1], Fl = (le1[0] - bt[0]) * Dl - ho * (le1[1] - bt[1]), sc = (vt[0] - bt[0]) * Dl - ho * (vt[1] - bt[1]);
                            return Fl > 0 && sc < 0 || Fl < 0 && sc > 0;
                        }
                        function jr(le1, vt, bt) {
                            const ls = [];
                            for(let ho = 0; ho < le1.length; ho++){
                                const Dl = [];
                                for(let ls = 0; ls < le1[ho].length; ls++){
                                    const Fl = zr(le1[ho][ls], bt);
                                    Br(vt, Fl), Dl.push(Fl);
                                }
                                ls.push(Dl);
                            }
                            return ls;
                        }
                        function Gr(le1, vt, bt) {
                            const ls = [];
                            for(let ho = 0; ho < le1.length; ho++){
                                const Dl = jr(le1[ho], vt, bt);
                                ls.push(Dl);
                            }
                            return ls;
                        }
                        function Xr(le1, vt, bt, ls) {
                            if (le1[0] < bt[0] || le1[0] > bt[2]) {
                                const vt = .5 * ls;
                                let ho = le1[0] - bt[0] > vt ? -ls : bt[0] - le1[0] > vt ? ls : 0;
                                0 === ho && (ho = le1[0] - bt[2] > vt ? -ls : bt[2] - le1[0] > vt ? ls : 0), le1[0] += ho;
                            }
                            Br(vt, le1);
                        }
                        function Yr(le1, vt, bt, ls) {
                            const ho = Math.pow(2, ls.z) * Pm, Dl = [
                                ls.x * Pm,
                                ls.y * Pm
                            ], Fl = [];
                            for (const sc of le1)for (const le1 of sc){
                                const ls = [
                                    le1.x + Dl[0],
                                    le1.y + Dl[1]
                                ];
                                Xr(ls, vt, bt, ho), Fl.push(ls);
                            }
                            return Fl;
                        }
                        function Zr(le1, vt, bt, ls) {
                            const ho = Math.pow(2, ls.z) * Pm, Dl = [
                                ls.x * Pm,
                                ls.y * Pm
                            ], Fl = [];
                            for (const uc of le1){
                                const le1 = [];
                                for (const bt of uc){
                                    const ls = [
                                        bt.x + Dl[0],
                                        bt.y + Dl[1]
                                    ];
                                    Br(vt, ls), le1.push(ls);
                                }
                                Fl.push(le1);
                            }
                            if (vt[2] - vt[0] <= ho / 2) {
                                (sc = vt)[0] = sc[1] = 1 / 0, sc[2] = sc[3] = -1 / 0;
                                for (const le1 of Fl)for (const ls of le1)Xr(ls, vt, bt, ho);
                            }
                            var sc;
                            return Fl;
                        }
                        class Hr {
                            constructor(le1, vt){
                                this.type = Qd, this.geojson = le1, this.geometries = vt;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error(`'within' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                                if ($e(le1[1])) {
                                    const vt = le1[1];
                                    if ("FeatureCollection" === vt.type) {
                                        const le1 = [];
                                        for (const bt of vt.features){
                                            const { type: vt, coordinates: ls } = bt.geometry;
                                            "Polygon" === vt && le1.push(ls), "MultiPolygon" === vt && le1.push(...ls);
                                        }
                                        if (le1.length) return new Hr(vt, {
                                            type: "MultiPolygon",
                                            coordinates: le1
                                        });
                                    } else if ("Feature" === vt.type) {
                                        const le1 = vt.geometry.type;
                                        if ("Polygon" === le1 || "MultiPolygon" === le1) return new Hr(vt, vt.geometry);
                                    } else if ("Polygon" === vt.type || "MultiPolygon" === vt.type) return new Hr(vt, vt);
                                }
                                return vt.error("'within' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(le1) {
                                if (null != le1.geometry() && null != le1.canonicalID()) {
                                    if ("Point" === le1.geometryType()) return function(le1, vt) {
                                        const bt = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], ls = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], ho = le1.canonicalID();
                                        if ("Polygon" === vt.type) {
                                            const Dl = jr(vt.coordinates, ls, ho), Fl = Yr(le1.geometry(), bt, ls, ho);
                                            if (!Vr(bt, ls)) return !1;
                                            for (const le1 of Fl)if (!Rr(le1, Dl)) return !1;
                                        }
                                        if ("MultiPolygon" === vt.type) {
                                            const Dl = Gr(vt.coordinates, ls, ho), Fl = Yr(le1.geometry(), bt, ls, ho);
                                            if (!Vr(bt, ls)) return !1;
                                            for (const le1 of Fl)if (!Nr(le1, Dl)) return !1;
                                        }
                                        return !0;
                                    }(le1, this.geometries);
                                    if ("LineString" === le1.geometryType()) return function(le1, vt) {
                                        const bt = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], ls = [
                                            1 / 0,
                                            1 / 0,
                                            -1 / 0,
                                            -1 / 0
                                        ], ho = le1.canonicalID();
                                        if ("Polygon" === vt.type) {
                                            const Dl = jr(vt.coordinates, ls, ho), Fl = Zr(le1.geometry(), bt, ls, ho);
                                            if (!Vr(bt, ls)) return !1;
                                            for (const le1 of Fl)if (!$r(le1, Dl)) return !1;
                                        }
                                        if ("MultiPolygon" === vt.type) {
                                            const Dl = Gr(vt.coordinates, ls, ho), Fl = Zr(le1.geometry(), bt, ls, ho);
                                            if (!Vr(bt, ls)) return !1;
                                            for (const le1 of Fl)if (!Ur(le1, Dl)) return !1;
                                        }
                                        return !0;
                                    }(le1, this.geometries);
                                }
                                return !1;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        let zm = class {
                            constructor(le1 = [], vt = (le1, vt)=>le1 < vt ? -1 : le1 > vt ? 1 : 0){
                                if (this.data = le1, this.length = this.data.length, this.compare = vt, this.length > 0) for(let bt = (this.length >> 1) - 1; bt >= 0; bt--)this._down(bt);
                            }
                            push(le1) {
                                this.data.push(le1), this._up(this.length++);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const le1 = this.data[0], vt = this.data.pop();
                                return --this.length > 0 && (this.data[0] = vt, this._down(0)), le1;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(le1) {
                                const { data: vt, compare: bt } = this, ls = vt[le1];
                                for(; le1 > 0;){
                                    const ho = le1 - 1 >> 1, Dl = vt[ho];
                                    if (bt(ls, Dl) >= 0) break;
                                    vt[le1] = Dl, le1 = ho;
                                }
                                vt[le1] = ls;
                            }
                            _down(le1) {
                                const { data: vt, compare: bt } = this, ls = this.length >> 1, ho = vt[le1];
                                for(; le1 < ls;){
                                    let ls = 1 + (le1 << 1);
                                    const Dl = ls + 1;
                                    if (Dl < this.length && bt(vt[Dl], vt[ls]) < 0 && (ls = Dl), bt(vt[ls], ho) >= 0) break;
                                    vt[le1] = vt[ls], le1 = ls;
                                }
                                vt[le1] = ho;
                            }
                        };
                        function Wr(le1, vt, bt = 0, ls = le1.length - 1, ho = Qr) {
                            for(; ls > bt;){
                                if (ls - bt > 600) {
                                    const Dl = ls - bt + 1, Fl = vt - bt + 1, sc = Math.log(Dl), uc = .5 * Math.exp(2 * sc / 3), mc = .5 * Math.sqrt(sc * uc * (Dl - uc) / Dl) * (Fl - Dl / 2 < 0 ? -1 : 1);
                                    Wr(le1, vt, Math.max(bt, Math.floor(vt - Fl * uc / Dl + mc)), Math.min(ls, Math.floor(vt + (Dl - Fl) * uc / Dl + mc)), ho);
                                }
                                const Dl = le1[vt];
                                let Fl = bt, sc = ls;
                                for(Jr(le1, bt, vt), ho(le1[ls], Dl) > 0 && Jr(le1, bt, ls); Fl < sc;){
                                    for(Jr(le1, Fl, sc), Fl++, sc--; ho(le1[Fl], Dl) < 0;)Fl++;
                                    for(; ho(le1[sc], Dl) > 0;)sc--;
                                }
                                0 === ho(le1[bt], Dl) ? Jr(le1, bt, sc) : (sc++, Jr(le1, sc, ls)), sc <= vt && (bt = sc + 1), vt <= sc && (ls = sc - 1);
                            }
                        }
                        function Jr(le1, vt, bt) {
                            const ls = le1[vt];
                            le1[vt] = le1[bt], le1[bt] = ls;
                        }
                        function Qr(le1, vt) {
                            return le1 < vt ? -1 : le1 > vt ? 1 : 0;
                        }
                        function tn(le1, vt) {
                            if (le1.length <= 1) return [
                                le1
                            ];
                            const bt = [];
                            let ls, ho;
                            for (const Dl of le1){
                                const le1 = rn(Dl);
                                0 !== le1 && (Dl.area = Math.abs(le1), void 0 === ho && (ho = le1 < 0), ho === le1 < 0 ? (ls && bt.push(ls), ls = [
                                    Dl
                                ]) : ls.push(Dl));
                            }
                            if (ls && bt.push(ls), vt > 1) for(let Dl = 0; Dl < bt.length; Dl++)bt[Dl].length <= vt || (Wr(bt[Dl], vt, 1, bt[Dl].length - 1, en), bt[Dl] = bt[Dl].slice(0, vt));
                            return bt;
                        }
                        function en(le1, vt) {
                            return vt.area - le1.area;
                        }
                        function rn(le1) {
                            let vt = 0;
                            for(let bt, ls, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++)bt = le1[ho], ls = le1[Fl], vt += (ls.x - bt.x) * (bt.y + ls.y);
                            return vt;
                        }
                        const Nm = 1 / 298.257223563, Rm = Nm * (2 - Nm), Fm = Math.PI / 180;
                        class on {
                            constructor(le1){
                                const vt = 6378.137 * Fm * 1e3, bt = Math.cos(le1 * Fm), ls = 1 / (1 - Rm * (1 - bt * bt)), ho = Math.sqrt(ls);
                                this.kx = vt * ho * bt, this.ky = vt * ho * ls * (1 - Rm);
                            }
                            distance(le1, vt) {
                                const bt = this.wrap(le1[0] - vt[0]) * this.kx, ls = (le1[1] - vt[1]) * this.ky;
                                return Math.sqrt(bt * bt + ls * ls);
                            }
                            pointOnLine(le1, vt) {
                                let bt, ls, ho, Dl, Fl = 1 / 0;
                                for(let sc = 0; sc < le1.length - 1; sc++){
                                    let uc = le1[sc][0], mc = le1[sc][1], gc = this.wrap(le1[sc + 1][0] - uc) * this.kx, Ac = (le1[sc + 1][1] - mc) * this.ky, Ec = 0;
                                    0 === gc && 0 === Ac || (Ec = (this.wrap(vt[0] - uc) * this.kx * gc + (vt[1] - mc) * this.ky * Ac) / (gc * gc + Ac * Ac), Ec > 1 ? (uc = le1[sc + 1][0], mc = le1[sc + 1][1]) : Ec > 0 && (uc += gc / this.kx * Ec, mc += Ac / this.ky * Ec)), gc = this.wrap(vt[0] - uc) * this.kx, Ac = (vt[1] - mc) * this.ky;
                                    const kc = gc * gc + Ac * Ac;
                                    kc < Fl && (Fl = kc, bt = uc, ls = mc, ho = sc, Dl = Ec);
                                }
                                return {
                                    point: [
                                        bt,
                                        ls
                                    ],
                                    index: ho,
                                    t: Math.max(0, Math.min(1, Dl))
                                };
                            }
                            wrap(le1) {
                                for(; le1 < -180;)le1 += 360;
                                for(; le1 > 180;)le1 -= 360;
                                return le1;
                            }
                        }
                        function ln(le1, vt) {
                            return vt[0] - le1[0];
                        }
                        function un(le1) {
                            return le1[1] - le1[0] + 1;
                        }
                        function cn(le1, vt) {
                            return le1[1] >= le1[0] && le1[1] < vt;
                        }
                        function hn(le1, vt) {
                            if (le1[0] > le1[1]) return [
                                null,
                                null
                            ];
                            const bt = un(le1);
                            if (vt) {
                                if (2 === bt) return [
                                    le1,
                                    null
                                ];
                                const vt = Math.floor(bt / 2);
                                return [
                                    [
                                        le1[0],
                                        le1[0] + vt
                                    ],
                                    [
                                        le1[0] + vt,
                                        le1[1]
                                    ]
                                ];
                            }
                            if (1 === bt) return [
                                le1,
                                null
                            ];
                            const ls = Math.floor(bt / 2) - 1;
                            return [
                                [
                                    le1[0],
                                    le1[0] + ls
                                ],
                                [
                                    le1[0] + ls + 1,
                                    le1[1]
                                ]
                            ];
                        }
                        function pn(le1, vt) {
                            if (!cn(vt, le1.length)) return [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            const bt = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for(let ls = vt[0]; ls <= vt[1]; ++ls)Br(bt, le1[ls]);
                            return bt;
                        }
                        function fn(le1) {
                            const vt = [
                                1 / 0,
                                1 / 0,
                                -1 / 0,
                                -1 / 0
                            ];
                            for (const bt of le1)for (const le1 of bt)Br(vt, le1);
                            return vt;
                        }
                        function dn(le1) {
                            return le1[0] !== -1 / 0 && le1[1] !== -1 / 0 && le1[2] !== 1 / 0 && le1[3] !== 1 / 0;
                        }
                        function yn(le1, vt, bt) {
                            if (!dn(le1) || !dn(vt)) return NaN;
                            let ls = 0, ho = 0;
                            return le1[2] < vt[0] && (ls = vt[0] - le1[2]), le1[0] > vt[2] && (ls = le1[0] - vt[2]), le1[1] > vt[3] && (ho = le1[1] - vt[3]), le1[3] < vt[1] && (ho = vt[1] - le1[3]), bt.distance([
                                0,
                                0
                            ], [
                                ls,
                                ho
                            ]);
                        }
                        function mn(le1, vt, bt) {
                            const ls = bt.pointOnLine(vt, le1);
                            return bt.distance(le1, ls.point);
                        }
                        function gn(le1, vt, bt, ls, ho) {
                            const Dl = Math.min(mn(le1, [
                                bt,
                                ls
                            ], ho), mn(vt, [
                                bt,
                                ls
                            ], ho)), Fl = Math.min(mn(bt, [
                                le1,
                                vt
                            ], ho), mn(ls, [
                                le1,
                                vt
                            ], ho));
                            return Math.min(Dl, Fl);
                        }
                        function xn(le1, vt, bt, ls, ho) {
                            if (!cn(vt, le1.length) || !cn(ls, bt.length)) return 1 / 0;
                            let Dl = 1 / 0;
                            for(let Fl = vt[0]; Fl < vt[1]; ++Fl){
                                const vt = le1[Fl], sc = le1[Fl + 1];
                                for(let le1 = ls[0]; le1 < ls[1]; ++le1){
                                    const ls = bt[le1], Fl = bt[le1 + 1];
                                    if (Lr(vt, sc, ls, Fl)) return 0;
                                    Dl = Math.min(Dl, gn(vt, sc, ls, Fl, ho));
                                }
                            }
                            return Dl;
                        }
                        function vn(le1, vt, bt, ls, ho) {
                            if (!cn(vt, le1.length) || !cn(ls, bt.length)) return NaN;
                            let Dl = 1 / 0;
                            for(let Fl = vt[0]; Fl <= vt[1]; ++Fl)for(let vt = ls[0]; vt <= ls[1]; ++vt)if (Dl = Math.min(Dl, ho.distance(le1[Fl], bt[vt])), 0 === Dl) return Dl;
                            return Dl;
                        }
                        function bn(le1, vt, bt) {
                            if (Rr(le1, vt, !0)) return 0;
                            let ls = 1 / 0;
                            for (const ho of vt){
                                const vt = ho[0], Dl = ho[ho.length - 1];
                                if (vt !== Dl && (ls = Math.min(ls, mn(le1, [
                                    Dl,
                                    vt
                                ], bt)), 0 === ls)) return ls;
                                const Fl = bt.pointOnLine(ho, le1);
                                if (ls = Math.min(ls, bt.distance(le1, Fl.point)), 0 === ls) return ls;
                            }
                            return ls;
                        }
                        function wn(le1, vt, bt, ls) {
                            if (!cn(vt, le1.length)) return NaN;
                            for(let Dl = vt[0]; Dl <= vt[1]; ++Dl)if (Rr(le1[Dl], bt, !0)) return 0;
                            let ho = 1 / 0;
                            for(let Dl = vt[0]; Dl < vt[1]; ++Dl){
                                const vt = le1[Dl], Fl = le1[Dl + 1];
                                for (const le1 of bt)for(let bt = 0, Dl = le1.length, sc = Dl - 1; bt < Dl; sc = bt++){
                                    const Dl = le1[sc], uc = le1[bt];
                                    if (Lr(vt, Fl, Dl, uc)) return 0;
                                    ho = Math.min(ho, gn(vt, Fl, Dl, uc, ls));
                                }
                            }
                            return ho;
                        }
                        function _n(le1, vt) {
                            for (const bt of le1)for (const le1 of bt)if (Rr(le1, vt, !0)) return !0;
                            return !1;
                        }
                        function Sn(le1, vt, bt, ls = 1 / 0) {
                            const ho = fn(le1), Dl = fn(vt);
                            if (ls !== 1 / 0 && yn(ho, Dl, bt) >= ls) return ls;
                            if (Vr(ho, Dl)) {
                                if (_n(le1, vt)) return 0;
                            } else if (_n(vt, le1)) return 0;
                            let Fl = 1 / 0;
                            for (const sc of le1)for(let le1 = 0, ls = sc.length, ho = ls - 1; le1 < ls; ho = le1++){
                                const ls = sc[ho], Dl = sc[le1];
                                for (const le1 of vt)for(let vt = 0, ho = le1.length, sc = ho - 1; vt < ho; sc = vt++){
                                    const ho = le1[sc], uc = le1[vt];
                                    if (Lr(ls, Dl, ho, uc)) return 0;
                                    Fl = Math.min(Fl, gn(ls, Dl, ho, uc, bt));
                                }
                            }
                            return Fl;
                        }
                        function An(le1, vt, bt, ls, ho, Dl) {
                            if (!Dl) return;
                            const Fl = yn(pn(ls, Dl), ho, bt);
                            Fl < vt && le1.push([
                                Fl,
                                Dl,
                                [
                                    0,
                                    0
                                ]
                            ]);
                        }
                        function kn(le1, vt, bt, ls, ho, Dl, Fl) {
                            if (!Dl || !Fl) return;
                            const sc = yn(pn(ls, Dl), pn(ho, Fl), bt);
                            sc < vt && le1.push([
                                sc,
                                Dl,
                                Fl
                            ]);
                        }
                        function En(le1, vt, bt, ls, ho = 1 / 0) {
                            let Dl = Math.min(ls.distance(le1[0], bt[0][0]), ho);
                            if (0 === Dl) return Dl;
                            const Fl = new zm([
                                [
                                    0,
                                    [
                                        0,
                                        le1.length - 1
                                    ],
                                    [
                                        0,
                                        0
                                    ]
                                ]
                            ], ln), sc = fn(bt);
                            for(; Fl.length > 0;){
                                const ho = Fl.pop();
                                if (ho[0] >= Dl) continue;
                                const uc = ho[1], mc = vt ? 50 : 100;
                                if (un(uc) <= mc) {
                                    if (!cn(uc, le1.length)) return NaN;
                                    if (vt) {
                                        const vt = wn(le1, uc, bt, ls);
                                        if (isNaN(vt) || 0 === vt) return vt;
                                        Dl = Math.min(Dl, vt);
                                    } else for(let vt = uc[0]; vt <= uc[1]; ++vt){
                                        const ho = bn(le1[vt], bt, ls);
                                        if (Dl = Math.min(Dl, ho), 0 === Dl) return 0;
                                    }
                                } else {
                                    const bt = hn(uc, vt);
                                    An(Fl, Dl, ls, le1, sc, bt[0]), An(Fl, Dl, ls, le1, sc, bt[1]);
                                }
                            }
                            return Dl;
                        }
                        function Tn(le1, vt, bt, ls, ho, Dl = 1 / 0) {
                            let Fl = Math.min(Dl, ho.distance(le1[0], bt[0]));
                            if (0 === Fl) return Fl;
                            const sc = new zm([
                                [
                                    0,
                                    [
                                        0,
                                        le1.length - 1
                                    ],
                                    [
                                        0,
                                        bt.length - 1
                                    ]
                                ]
                            ], ln);
                            for(; sc.length > 0;){
                                const Dl = sc.pop();
                                if (Dl[0] >= Fl) continue;
                                const uc = Dl[1], mc = Dl[2], gc = vt ? 50 : 100, Ac = ls ? 50 : 100;
                                if (un(uc) <= gc && un(mc) <= Ac) {
                                    if (!cn(uc, le1.length) && cn(mc, bt.length)) return NaN;
                                    let Dl;
                                    if (vt && ls) Dl = xn(le1, uc, bt, mc, ho), Fl = Math.min(Fl, Dl);
                                    else if (vt && !ls) {
                                        const vt = le1.slice(uc[0], uc[1] + 1);
                                        for(let le1 = mc[0]; le1 <= mc[1]; ++le1)if (Dl = mn(bt[le1], vt, ho), Fl = Math.min(Fl, Dl), 0 === Fl) return Fl;
                                    } else if (!vt && ls) {
                                        const vt = bt.slice(mc[0], mc[1] + 1);
                                        for(let bt = uc[0]; bt <= uc[1]; ++bt)if (Dl = mn(le1[bt], vt, ho), Fl = Math.min(Fl, Dl), 0 === Fl) return Fl;
                                    } else Dl = vn(le1, uc, bt, mc, ho), Fl = Math.min(Fl, Dl);
                                } else {
                                    const Dl = hn(uc, vt), gc = hn(mc, ls);
                                    kn(sc, Fl, ho, le1, bt, Dl[0], gc[0]), kn(sc, Fl, ho, le1, bt, Dl[0], gc[1]), kn(sc, Fl, ho, le1, bt, Dl[1], gc[0]), kn(sc, Fl, ho, le1, bt, Dl[1], gc[1]);
                                }
                            }
                            return Fl;
                        }
                        function In(le1) {
                            return "MultiPolygon" === le1.type ? le1.coordinates.map((le1)=>({
                                    type: "Polygon",
                                    coordinates: le1
                                })) : "MultiLineString" === le1.type ? le1.coordinates.map((le1)=>({
                                    type: "LineString",
                                    coordinates: le1
                                })) : "MultiPoint" === le1.type ? le1.coordinates.map((le1)=>({
                                    type: "Point",
                                    coordinates: le1
                                })) : [
                                le1
                            ];
                        }
                        class Mn {
                            constructor(le1, vt){
                                this.type = Zd, this.geojson = le1, this.geometries = vt;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error(`'distance' expression requires exactly one argument, but found ${le1.length - 1} instead.`);
                                if ($e(le1[1])) {
                                    const vt = le1[1];
                                    if ("FeatureCollection" === vt.type) return new Mn(vt, vt.features.map((le1)=>In(le1.geometry)).flat());
                                    if ("Feature" === vt.type) return new Mn(vt, In(vt.geometry));
                                    if ("type" in vt && "coordinates" in vt) return new Mn(vt, In(vt));
                                }
                                return vt.error("'distance' expression requires valid geojson object that contains polygon geometry type.");
                            }
                            evaluate(le1) {
                                if (null != le1.geometry() && null != le1.canonicalID()) {
                                    if ("Point" === le1.geometryType()) return function(le1, vt) {
                                        const bt = le1.geometry(), ls = bt.flat().map((vt)=>Pr([
                                                vt.x,
                                                vt.y
                                            ], le1.canonical));
                                        if (0 === bt.length) return NaN;
                                        const ho = new on(ls[0][1]);
                                        let Dl = 1 / 0;
                                        for (const Fl of vt){
                                            switch(Fl.type){
                                                case "Point":
                                                    Dl = Math.min(Dl, Tn(ls, !1, [
                                                        Fl.coordinates
                                                    ], !1, ho, Dl));
                                                    break;
                                                case "LineString":
                                                    Dl = Math.min(Dl, Tn(ls, !1, Fl.coordinates, !0, ho, Dl));
                                                    break;
                                                case "Polygon":
                                                    Dl = Math.min(Dl, En(ls, !1, Fl.coordinates, ho, Dl));
                                            }
                                            if (0 === Dl) return Dl;
                                        }
                                        return Dl;
                                    }(le1, this.geometries);
                                    if ("LineString" === le1.geometryType()) return function(le1, vt) {
                                        const bt = le1.geometry(), ls = bt.flat().map((vt)=>Pr([
                                                vt.x,
                                                vt.y
                                            ], le1.canonical));
                                        if (0 === bt.length) return NaN;
                                        const ho = new on(ls[0][1]);
                                        let Dl = 1 / 0;
                                        for (const Fl of vt){
                                            switch(Fl.type){
                                                case "Point":
                                                    Dl = Math.min(Dl, Tn(ls, !0, [
                                                        Fl.coordinates
                                                    ], !1, ho, Dl));
                                                    break;
                                                case "LineString":
                                                    Dl = Math.min(Dl, Tn(ls, !0, Fl.coordinates, !0, ho, Dl));
                                                    break;
                                                case "Polygon":
                                                    Dl = Math.min(Dl, En(ls, !0, Fl.coordinates, ho, Dl));
                                            }
                                            if (0 === Dl) return Dl;
                                        }
                                        return Dl;
                                    }(le1, this.geometries);
                                    if ("Polygon" === le1.geometryType()) return function(le1, vt) {
                                        const bt = le1.geometry();
                                        if (0 === bt.length || 0 === bt[0].length) return NaN;
                                        const ls = tn(bt, 0).map((vt)=>vt.map((vt)=>vt.map((vt)=>Pr([
                                                        vt.x,
                                                        vt.y
                                                    ], le1.canonical)))), ho = new on(ls[0][0][0][1]);
                                        let Dl = 1 / 0;
                                        for (const Fl of vt)for (const le1 of ls){
                                            switch(Fl.type){
                                                case "Point":
                                                    Dl = Math.min(Dl, En([
                                                        Fl.coordinates
                                                    ], !1, le1, ho, Dl));
                                                    break;
                                                case "LineString":
                                                    Dl = Math.min(Dl, En(Fl.coordinates, !0, le1, ho, Dl));
                                                    break;
                                                case "Polygon":
                                                    Dl = Math.min(Dl, Sn(le1, Fl.coordinates, ho, Dl));
                                            }
                                            if (0 === Dl) return Dl;
                                        }
                                        return Dl;
                                    }(le1, this.geometries);
                                }
                                return NaN;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !0;
                            }
                        }
                        class Fn {
                            constructor(le1){
                                this.type = $d, this.key = le1;
                            }
                            static parse(le1, vt) {
                                if (2 !== le1.length) return vt.error(`Expected 1 argument, but found ${le1.length - 1} instead.`);
                                const bt = le1[1];
                                return null == bt ? vt.error("Global state property must be defined.") : "string" != typeof bt ? vt.error(`Global state property must be string, but found ${typeof le1[1]} instead.`) : new Fn(bt);
                            }
                            evaluate(le1) {
                                var vt;
                                const bt = null === (vt = le1.globals) || void 0 === vt ? void 0 : vt.globalState;
                                return bt && 0 !== Object.keys(bt).length ? ve(bt, this.key) : null;
                            }
                            eachChild() {}
                            outputDefined() {
                                return !1;
                            }
                        }
                        const Om = {
                            "==": Tm,
                            "!=": km,
                            ">": Im,
                            "<": Cm,
                            ">=": Lm,
                            "<=": Dm,
                            array: Xe,
                            at: tr,
                            boolean: Xe,
                            case: ir,
                            coalesce: mr,
                            collator: Er,
                            format: Ir,
                            image: Mr,
                            in: er,
                            "index-of": rr,
                            interpolate: fr,
                            "interpolate-hcl": fr,
                            "interpolate-lab": fr,
                            length: Fr,
                            let: Je,
                            literal: je,
                            match: nr,
                            number: Xe,
                            "number-format": Tr,
                            object: Xe,
                            slice: sr,
                            step: or,
                            string: Xe,
                            "to-boolean": Ze,
                            "to-color": Ze,
                            "to-number": Ze,
                            "to-string": Ze,
                            var: Qe,
                            within: Hr,
                            distance: Mn,
                            "global-state": Fn
                        };
                        class zn {
                            constructor(le1, vt, bt, ls){
                                this.name = le1, this.type = vt, this._evaluate = bt, this.args = ls;
                            }
                            evaluate(le1) {
                                return this._evaluate(le1, this.args);
                            }
                            eachChild(le1) {
                                this.args.forEach(le1);
                            }
                            outputDefined() {
                                return !1;
                            }
                            static parse(le1, vt) {
                                const bt = le1[0], ls = zn.definitions[bt];
                                if (!ls) return vt.error(`Unknown expression "${bt}". If you wanted a literal array, use ["literal", [...]].`, 0);
                                const ho = Array.isArray(ls) ? ls[0] : ls.type, Dl = Array.isArray(ls) ? [
                                    [
                                        ls[1],
                                        ls[2]
                                    ]
                                ] : ls.overloads, Fl = Dl.filter(([vt])=>!Array.isArray(vt) || vt.length === le1.length - 1);
                                let sc = null;
                                for (const [uc, mc] of Fl){
                                    sc = new We(vt.registry, Ln, vt.path, null, vt.scope);
                                    const ls = [];
                                    let Dl = !1;
                                    for(let vt = 1; vt < le1.length; vt++){
                                        const bt = le1[vt], ho = Array.isArray(uc) ? uc[vt - 1] : uc.type, Fl = sc.parse(bt, 1 + ls.length, ho);
                                        if (!Fl) {
                                            Dl = !0;
                                            break;
                                        }
                                        ls.push(Fl);
                                    }
                                    if (!Dl) {
                                        if (Array.isArray(uc) && uc.length !== ls.length) sc.error(`Expected ${uc.length} arguments, but found ${ls.length} instead.`);
                                        else {
                                            for(let le1 = 0; le1 < ls.length; le1++){
                                                const vt = Array.isArray(uc) ? uc[le1] : uc.type, bt = ls[le1];
                                                sc.concat(le1 + 1).checkSubtype(vt, bt.type);
                                            }
                                            if (0 === sc.errors.length) return new zn(bt, ho, mc, ls);
                                        }
                                    }
                                }
                                if (1 === Fl.length) vt.errors.push(...sc.errors);
                                else {
                                    const bt = (Fl.length ? Fl : Dl).map(([le1])=>{
                                        var vt;
                                        return vt = le1, Array.isArray(vt) ? `(${vt.map(Wt).join(", ")})` : `(${Wt(vt.type)}...)`;
                                    }).join(" | "), ls = [];
                                    for(let ho = 1; ho < le1.length; ho++){
                                        const bt = vt.parse(le1[ho], 1 + ls.length);
                                        if (!bt) return null;
                                        ls.push(Wt(bt.type));
                                    }
                                    vt.error(`Expected arguments of type ${bt}, but found (${ls.join(", ")}) instead.`);
                                }
                                return null;
                            }
                            static register(le1, vt) {
                                zn.definitions = vt;
                                for(const bt in vt)le1[bt] = zn;
                            }
                        }
                        function Pn(le1, [vt, bt, ls, ho]) {
                            vt = vt.evaluate(le1), bt = bt.evaluate(le1), ls = ls.evaluate(le1);
                            const Dl = ho ? ho.evaluate(le1) : 1, Fl = Ne(vt, bt, ls, Dl);
                            if (Fl) throw new Ve(Fl);
                            return new Te(vt / 255, bt / 255, ls / 255, Dl, !1);
                        }
                        function Bn(le1, vt) {
                            return le1 in vt;
                        }
                        function Vn(le1, vt) {
                            const bt = vt[le1];
                            return void 0 === bt ? null : bt;
                        }
                        function Cn(le1) {
                            return {
                                type: le1
                            };
                        }
                        function Ln(le1) {
                            if (le1 instanceof Qe) return Ln(le1.boundExpression);
                            if (le1 instanceof zn && "error" === le1.name) return !1;
                            if (le1 instanceof Er) return !1;
                            if (le1 instanceof Hr) return !1;
                            if (le1 instanceof Mn) return !1;
                            if (le1 instanceof Fn) return !1;
                            const vt = le1 instanceof Ze || le1 instanceof Xe;
                            let bt = !0;
                            return le1.eachChild((le1)=>{
                                bt = vt ? bt && Ln(le1) : bt && le1 instanceof je;
                            }), !!bt && On(le1) && Nn(le1, [
                                "zoom",
                                "heatmap-density",
                                "elevation",
                                "line-progress",
                                "accumulated",
                                "is-supported-script"
                            ]);
                        }
                        function On(le1) {
                            if (le1 instanceof zn) {
                                if ("get" === le1.name && 1 === le1.args.length) return !1;
                                if ("feature-state" === le1.name) return !1;
                                if ("has" === le1.name && 1 === le1.args.length) return !1;
                                if ("properties" === le1.name || "geometry-type" === le1.name || "id" === le1.name) return !1;
                                if (/^filter-/.test(le1.name)) return !1;
                            }
                            if (le1 instanceof Hr) return !1;
                            if (le1 instanceof Mn) return !1;
                            let vt = !0;
                            return le1.eachChild((le1)=>{
                                vt && !On(le1) && (vt = !1);
                            }), vt;
                        }
                        function Rn(le1) {
                            if (le1 instanceof zn && "feature-state" === le1.name) return !1;
                            let vt = !0;
                            return le1.eachChild((le1)=>{
                                vt && !Rn(le1) && (vt = !1);
                            }), vt;
                        }
                        function Nn(le1, vt) {
                            if (le1 instanceof zn && vt.indexOf(le1.name) >= 0) return !1;
                            let bt = !0;
                            return le1.eachChild((le1)=>{
                                bt && !Nn(le1, vt) && (bt = !1);
                            }), bt;
                        }
                        function $n(le1) {
                            return {
                                result: "success",
                                value: le1
                            };
                        }
                        function Un(le1) {
                            return {
                                result: "error",
                                value: le1
                            };
                        }
                        function qn(le1) {
                            return "data-driven" === le1["property-type"] || "cross-faded-data-driven" === le1["property-type"];
                        }
                        function jn(le1) {
                            return !!le1.expression && le1.expression.parameters.indexOf("zoom") > -1;
                        }
                        function Gn(le1) {
                            return !!le1.expression && le1.expression.interpolated;
                        }
                        function Xn(le1) {
                            return le1 instanceof Number ? "number" : le1 instanceof String ? "string" : le1 instanceof Boolean ? "boolean" : Array.isArray(le1) ? "array" : null === le1 ? "null" : typeof le1;
                        }
                        function Yn(le1) {
                            return "object" == typeof le1 && null !== le1 && !Array.isArray(le1) && Ue(le1) === Jd;
                        }
                        function Zn(le1) {
                            return le1;
                        }
                        function Hn(le1, vt) {
                            const bt = le1.stops && "object" == typeof le1.stops[0][0], ls = bt || !(bt || void 0 !== le1.property), ho = le1.type || (Gn(vt) ? "exponential" : "interval"), Dl = function(le1) {
                                switch(le1.type){
                                    case "color":
                                        return Te.parse;
                                    case "padding":
                                        return ze.parse;
                                    case "numberArray":
                                        return Pe.parse;
                                    case "colorArray":
                                        return Be.parse;
                                    default:
                                        return null;
                                }
                            }(vt);
                            if (Dl && ((le1 = zt({}, le1)).stops && (le1.stops = le1.stops.map((le1)=>[
                                    le1[0],
                                    Dl(le1[1])
                                ])), le1.default = Dl(le1.default ? le1.default : vt.default)), le1.colorSpace && "rgb" !== (Fl = le1.colorSpace) && "hcl" !== Fl && "lab" !== Fl) throw new Error(`Unknown color space: "${le1.colorSpace}"`);
                            var Fl;
                            const sc = function(le1) {
                                switch(le1){
                                    case "exponential":
                                        return Qn;
                                    case "interval":
                                        return Jn;
                                    case "categorical":
                                        return Wn;
                                    case "identity":
                                        return ti;
                                    default:
                                        throw new Error(`Unknown function type "${le1}"`);
                                }
                            }(ho);
                            let uc, mc;
                            if ("categorical" === ho) {
                                uc = Object.create(null);
                                for (const vt of le1.stops)uc[vt[0]] = vt[1];
                                mc = typeof le1.stops[0][0];
                            }
                            if (bt) {
                                const bt = {}, ls = [];
                                for(let vt = 0; vt < le1.stops.length; vt++){
                                    const ho = le1.stops[vt], Dl = ho[0].zoom;
                                    void 0 === bt[Dl] && (bt[Dl] = {
                                        zoom: Dl,
                                        type: le1.type,
                                        property: le1.property,
                                        default: le1.default,
                                        stops: []
                                    }, ls.push(Dl)), bt[Dl].stops.push([
                                        ho[0].value,
                                        ho[1]
                                    ]);
                                }
                                const ho = [];
                                for (const le1 of ls)ho.push([
                                    bt[le1].zoom,
                                    Hn(bt[le1], vt)
                                ]);
                                const Dl = {
                                    name: "linear"
                                };
                                return {
                                    kind: "composite",
                                    interpolationType: Dl,
                                    interpolationFactor: fr.interpolationFactor.bind(void 0, Dl),
                                    zoomStops: ho.map((le1)=>le1[0]),
                                    evaluate: ({ zoom: bt }, ls)=>Qn({
                                            stops: ho,
                                            base: le1.base
                                        }, vt, bt).evaluate(bt, ls)
                                };
                            }
                            if (ls) {
                                const bt = "exponential" === ho ? {
                                    name: "exponential",
                                    base: void 0 !== le1.base ? le1.base : 1
                                } : null;
                                return {
                                    kind: "camera",
                                    interpolationType: bt,
                                    interpolationFactor: fr.interpolationFactor.bind(void 0, bt),
                                    zoomStops: le1.stops.map((le1)=>le1[0]),
                                    evaluate: ({ zoom: bt })=>sc(le1, vt, bt, uc, mc)
                                };
                            }
                            return {
                                kind: "source",
                                evaluate (bt, ls) {
                                    const ho = ls && ls.properties ? ls.properties[le1.property] : void 0;
                                    return void 0 === ho ? Kn(le1.default, vt.default) : sc(le1, vt, ho, uc, mc);
                                }
                            };
                        }
                        function Kn(le1, vt, bt) {
                            return void 0 !== le1 ? le1 : void 0 !== vt ? vt : void 0 !== bt ? bt : void 0;
                        }
                        function Wn(le1, vt, bt, ls, ho) {
                            return Kn(typeof bt === ho ? ls[bt] : void 0, le1.default, vt.default);
                        }
                        function Jn(le1, vt, bt) {
                            if ("number" !== Xn(bt)) return Kn(le1.default, vt.default);
                            const ls = le1.stops.length;
                            if (1 === ls) return le1.stops[0][1];
                            if (bt <= le1.stops[0][0]) return le1.stops[0][1];
                            if (bt >= le1.stops[ls - 1][0]) return le1.stops[ls - 1][1];
                            const ho = ar(le1.stops.map((le1)=>le1[0]), bt);
                            return le1.stops[ho][1];
                        }
                        function Qn(le1, vt, bt) {
                            const ls = void 0 !== le1.base ? le1.base : 1;
                            if ("number" !== Xn(bt)) return Kn(le1.default, vt.default);
                            const ho = le1.stops.length;
                            if (1 === ho) return le1.stops[0][1];
                            if (bt <= le1.stops[0][0]) return le1.stops[0][1];
                            if (bt >= le1.stops[ho - 1][0]) return le1.stops[ho - 1][1];
                            const Dl = ar(le1.stops.map((le1)=>le1[0]), bt), Fl = function(le1, vt, bt, ls) {
                                const ho = ls - bt, Dl = le1 - bt;
                                return 0 === ho ? 0 : 1 === vt ? Dl / ho : (Math.pow(vt, Dl) - 1) / (Math.pow(vt, ho) - 1);
                            }(bt, ls, le1.stops[Dl][0], le1.stops[Dl + 1][0]), sc = le1.stops[Dl][1], uc = le1.stops[Dl + 1][1], mc = Sm[vt.type] || Zn;
                            return "function" == typeof sc.evaluate ? {
                                evaluate (...vt) {
                                    const bt = sc.evaluate.apply(void 0, vt), ls = uc.evaluate.apply(void 0, vt);
                                    if (void 0 !== bt && void 0 !== ls) return mc(bt, ls, Fl, le1.colorSpace);
                                }
                            } : mc(sc, uc, Fl, le1.colorSpace);
                        }
                        function ti(le1, vt, bt) {
                            switch(vt.type){
                                case "color":
                                    bt = Te.parse(bt);
                                    break;
                                case "formatted":
                                    bt = De.fromString(bt.toString());
                                    break;
                                case "resolvedImage":
                                    bt = Oe.fromString(bt.toString());
                                    break;
                                case "padding":
                                    bt = ze.parse(bt);
                                    break;
                                case "colorArray":
                                    bt = Be.parse(bt);
                                    break;
                                case "numberArray":
                                    bt = Pe.parse(bt);
                                    break;
                                default:
                                    Xn(bt) === vt.type || "enum" === vt.type && vt.values[bt] || (bt = void 0);
                            }
                            return Kn(bt, le1.default, vt.default);
                        }
                        zn.register(Om, {
                            error: [
                                {
                                    kind: "error"
                                },
                                [
                                    Yd
                                ],
                                (le1, [vt])=>{
                                    throw new Ve(vt.evaluate(le1));
                                }
                            ],
                            typeof: [
                                Yd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>Wt(Ue(vt.evaluate(le1)))
                            ],
                            "to-rgba": [
                                Kt(Zd, 4),
                                [
                                    Xd
                                ],
                                (le1, [vt])=>{
                                    const [bt, ls, ho, Dl] = vt.evaluate(le1).rgb;
                                    return [
                                        255 * bt,
                                        255 * ls,
                                        255 * ho,
                                        Dl
                                    ];
                                }
                            ],
                            rgb: [
                                Xd,
                                [
                                    Zd,
                                    Zd,
                                    Zd
                                ],
                                Pn
                            ],
                            rgba: [
                                Xd,
                                [
                                    Zd,
                                    Zd,
                                    Zd,
                                    Zd
                                ],
                                Pn
                            ],
                            has: {
                                type: Qd,
                                overloads: [
                                    [
                                        [
                                            Yd
                                        ],
                                        (le1, [vt])=>Bn(vt.evaluate(le1), le1.properties())
                                    ],
                                    [
                                        [
                                            Yd,
                                            Jd
                                        ],
                                        (le1, [vt, bt])=>Bn(vt.evaluate(le1), bt.evaluate(le1))
                                    ]
                                ]
                            },
                            get: {
                                type: $d,
                                overloads: [
                                    [
                                        [
                                            Yd
                                        ],
                                        (le1, [vt])=>Vn(vt.evaluate(le1), le1.properties())
                                    ],
                                    [
                                        [
                                            Yd,
                                            Jd
                                        ],
                                        (le1, [vt, bt])=>Vn(vt.evaluate(le1), bt.evaluate(le1))
                                    ]
                                ]
                            },
                            "feature-state": [
                                $d,
                                [
                                    Yd
                                ],
                                (le1, [vt])=>Vn(vt.evaluate(le1), le1.featureState || {})
                            ],
                            properties: [
                                Jd,
                                [],
                                (le1)=>le1.properties()
                            ],
                            "geometry-type": [
                                Yd,
                                [],
                                (le1)=>le1.geometryType()
                            ],
                            id: [
                                $d,
                                [],
                                (le1)=>le1.id()
                            ],
                            zoom: [
                                Zd,
                                [],
                                (le1)=>le1.globals.zoom
                            ],
                            "heatmap-density": [
                                Zd,
                                [],
                                (le1)=>le1.globals.heatmapDensity || 0
                            ],
                            elevation: [
                                Zd,
                                [],
                                (le1)=>le1.globals.elevation || 0
                            ],
                            "line-progress": [
                                Zd,
                                [],
                                (le1)=>le1.globals.lineProgress || 0
                            ],
                            accumulated: [
                                $d,
                                [],
                                (le1)=>void 0 === le1.globals.accumulated ? null : le1.globals.accumulated
                            ],
                            "+": [
                                Zd,
                                Cn(Zd),
                                (le1, vt)=>{
                                    let bt = 0;
                                    for (const ls of vt)bt += ls.evaluate(le1);
                                    return bt;
                                }
                            ],
                            "*": [
                                Zd,
                                Cn(Zd),
                                (le1, vt)=>{
                                    let bt = 1;
                                    for (const ls of vt)bt *= ls.evaluate(le1);
                                    return bt;
                                }
                            ],
                            "-": {
                                type: Zd,
                                overloads: [
                                    [
                                        [
                                            Zd,
                                            Zd
                                        ],
                                        (le1, [vt, bt])=>vt.evaluate(le1) - bt.evaluate(le1)
                                    ],
                                    [
                                        [
                                            Zd
                                        ],
                                        (le1, [vt])=>-vt.evaluate(le1)
                                    ]
                                ]
                            },
                            "/": [
                                Zd,
                                [
                                    Zd,
                                    Zd
                                ],
                                (le1, [vt, bt])=>vt.evaluate(le1) / bt.evaluate(le1)
                            ],
                            "%": [
                                Zd,
                                [
                                    Zd,
                                    Zd
                                ],
                                (le1, [vt, bt])=>vt.evaluate(le1) % bt.evaluate(le1)
                            ],
                            ln2: [
                                Zd,
                                [],
                                ()=>Math.LN2
                            ],
                            pi: [
                                Zd,
                                [],
                                ()=>Math.PI
                            ],
                            e: [
                                Zd,
                                [],
                                ()=>Math.E
                            ],
                            "^": [
                                Zd,
                                [
                                    Zd,
                                    Zd
                                ],
                                (le1, [vt, bt])=>Math.pow(vt.evaluate(le1), bt.evaluate(le1))
                            ],
                            sqrt: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.sqrt(vt.evaluate(le1))
                            ],
                            log10: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.log(vt.evaluate(le1)) / Math.LN10
                            ],
                            ln: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.log(vt.evaluate(le1))
                            ],
                            log2: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.log(vt.evaluate(le1)) / Math.LN2
                            ],
                            sin: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.sin(vt.evaluate(le1))
                            ],
                            cos: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.cos(vt.evaluate(le1))
                            ],
                            tan: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.tan(vt.evaluate(le1))
                            ],
                            asin: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.asin(vt.evaluate(le1))
                            ],
                            acos: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.acos(vt.evaluate(le1))
                            ],
                            atan: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.atan(vt.evaluate(le1))
                            ],
                            min: [
                                Zd,
                                Cn(Zd),
                                (le1, vt)=>Math.min(...vt.map((vt)=>vt.evaluate(le1)))
                            ],
                            max: [
                                Zd,
                                Cn(Zd),
                                (le1, vt)=>Math.max(...vt.map((vt)=>vt.evaluate(le1)))
                            ],
                            abs: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.abs(vt.evaluate(le1))
                            ],
                            round: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>{
                                    const bt = vt.evaluate(le1);
                                    return bt < 0 ? -Math.round(-bt) : Math.round(bt);
                                }
                            ],
                            floor: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.floor(vt.evaluate(le1))
                            ],
                            ceil: [
                                Zd,
                                [
                                    Zd
                                ],
                                (le1, [vt])=>Math.ceil(vt.evaluate(le1))
                            ],
                            "filter-==": [
                                Qd,
                                [
                                    Yd,
                                    $d
                                ],
                                (le1, [vt, bt])=>le1.properties()[vt.value] === bt.value
                            ],
                            "filter-id-==": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>le1.id() === vt.value
                            ],
                            "filter-type-==": [
                                Qd,
                                [
                                    Yd
                                ],
                                (le1, [vt])=>le1.geometryType() === vt.value
                            ],
                            "filter-<": [
                                Qd,
                                [
                                    Yd,
                                    $d
                                ],
                                (le1, [vt, bt])=>{
                                    const ls = le1.properties()[vt.value], ho = bt.value;
                                    return typeof ls == typeof ho && ls < ho;
                                }
                            ],
                            "filter-id-<": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>{
                                    const bt = le1.id(), ls = vt.value;
                                    return typeof bt == typeof ls && bt < ls;
                                }
                            ],
                            "filter->": [
                                Qd,
                                [
                                    Yd,
                                    $d
                                ],
                                (le1, [vt, bt])=>{
                                    const ls = le1.properties()[vt.value], ho = bt.value;
                                    return typeof ls == typeof ho && ls > ho;
                                }
                            ],
                            "filter-id->": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>{
                                    const bt = le1.id(), ls = vt.value;
                                    return typeof bt == typeof ls && bt > ls;
                                }
                            ],
                            "filter-<=": [
                                Qd,
                                [
                                    Yd,
                                    $d
                                ],
                                (le1, [vt, bt])=>{
                                    const ls = le1.properties()[vt.value], ho = bt.value;
                                    return typeof ls == typeof ho && ls <= ho;
                                }
                            ],
                            "filter-id-<=": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>{
                                    const bt = le1.id(), ls = vt.value;
                                    return typeof bt == typeof ls && bt <= ls;
                                }
                            ],
                            "filter->=": [
                                Qd,
                                [
                                    Yd,
                                    $d
                                ],
                                (le1, [vt, bt])=>{
                                    const ls = le1.properties()[vt.value], ho = bt.value;
                                    return typeof ls == typeof ho && ls >= ho;
                                }
                            ],
                            "filter-id->=": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>{
                                    const bt = le1.id(), ls = vt.value;
                                    return typeof bt == typeof ls && bt >= ls;
                                }
                            ],
                            "filter-has": [
                                Qd,
                                [
                                    $d
                                ],
                                (le1, [vt])=>vt.value in le1.properties()
                            ],
                            "filter-has-id": [
                                Qd,
                                [],
                                (le1)=>null !== le1.id() && void 0 !== le1.id()
                            ],
                            "filter-type-in": [
                                Qd,
                                [
                                    Kt(Yd)
                                ],
                                (le1, [vt])=>vt.value.indexOf(le1.geometryType()) >= 0
                            ],
                            "filter-id-in": [
                                Qd,
                                [
                                    Kt($d)
                                ],
                                (le1, [vt])=>vt.value.indexOf(le1.id()) >= 0
                            ],
                            "filter-in-small": [
                                Qd,
                                [
                                    Yd,
                                    Kt($d)
                                ],
                                (le1, [vt, bt])=>bt.value.indexOf(le1.properties()[vt.value]) >= 0
                            ],
                            "filter-in-large": [
                                Qd,
                                [
                                    Yd,
                                    Kt($d)
                                ],
                                (le1, [vt, bt])=>(function(le1, vt, bt, ls) {
                                        for(; bt <= ls;){
                                            const ho = bt + ls >> 1;
                                            if (vt[ho] === le1) return !0;
                                            vt[ho] > le1 ? ls = ho - 1 : bt = ho + 1;
                                        }
                                        return !1;
                                    })(le1.properties()[vt.value], bt.value, 0, bt.value.length - 1)
                            ],
                            all: {
                                type: Qd,
                                overloads: [
                                    [
                                        [
                                            Qd,
                                            Qd
                                        ],
                                        (le1, [vt, bt])=>vt.evaluate(le1) && bt.evaluate(le1)
                                    ],
                                    [
                                        Cn(Qd),
                                        (le1, vt)=>{
                                            for (const bt of vt)if (!bt.evaluate(le1)) return !1;
                                            return !0;
                                        }
                                    ]
                                ]
                            },
                            any: {
                                type: Qd,
                                overloads: [
                                    [
                                        [
                                            Qd,
                                            Qd
                                        ],
                                        (le1, [vt, bt])=>vt.evaluate(le1) || bt.evaluate(le1)
                                    ],
                                    [
                                        Cn(Qd),
                                        (le1, vt)=>{
                                            for (const bt of vt)if (bt.evaluate(le1)) return !0;
                                            return !1;
                                        }
                                    ]
                                ]
                            },
                            "!": [
                                Qd,
                                [
                                    Qd
                                ],
                                (le1, [vt])=>!vt.evaluate(le1)
                            ],
                            "is-supported-script": [
                                Qd,
                                [
                                    Yd
                                ],
                                (le1, [vt])=>{
                                    const bt = le1.globals && le1.globals.isSupportedScript;
                                    return !bt || bt(vt.evaluate(le1));
                                }
                            ],
                            upcase: [
                                Yd,
                                [
                                    Yd
                                ],
                                (le1, [vt])=>vt.evaluate(le1).toUpperCase()
                            ],
                            downcase: [
                                Yd,
                                [
                                    Yd
                                ],
                                (le1, [vt])=>vt.evaluate(le1).toLowerCase()
                            ],
                            concat: [
                                Yd,
                                Cn($d),
                                (le1, vt)=>vt.map((vt)=>qe(vt.evaluate(le1))).join("")
                            ],
                            "resolved-locale": [
                                Yd,
                                [
                                    sp
                                ],
                                (le1, [vt])=>vt.evaluate(le1).resolvedLocale()
                            ]
                        });
                        class ei {
                            constructor(le1, vt, bt){
                                this.expression = le1, this._warningHistory = {}, this._evaluator = new Ke, this._defaultValue = vt ? function(le1) {
                                    if ("color" === le1.type && Yn(le1.default)) return new Te(0, 0, 0, 0);
                                    switch(le1.type){
                                        case "color":
                                            return Te.parse(le1.default) || null;
                                        case "padding":
                                            return ze.parse(le1.default) || null;
                                        case "numberArray":
                                            return Pe.parse(le1.default) || null;
                                        case "colorArray":
                                            return Be.parse(le1.default) || null;
                                        case "variableAnchorOffsetCollection":
                                            return Le.parse(le1.default) || null;
                                        case "projectionDefinition":
                                            return Re.parse(le1.default) || null;
                                        default:
                                            return void 0 === le1.default ? null : le1.default;
                                    }
                                }(vt) : null, this._enumValues = vt && "enum" === vt.type ? vt.values : null, this._globalState = bt;
                            }
                            evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                                return this._globalState && (le1 = ci(le1, this._globalState)), this._evaluator.globals = le1, this._evaluator.feature = vt, this._evaluator.featureState = bt, this._evaluator.canonical = ls, this._evaluator.availableImages = ho || null, this._evaluator.formattedSection = Dl, this.expression.evaluate(this._evaluator);
                            }
                            evaluate(le1, vt, bt, ls, ho, Dl) {
                                this._globalState && (le1 = ci(le1, this._globalState)), this._evaluator.globals = le1, this._evaluator.feature = vt || null, this._evaluator.featureState = bt || null, this._evaluator.canonical = ls, this._evaluator.availableImages = ho || null, this._evaluator.formattedSection = Dl || null;
                                try {
                                    const le1 = this.expression.evaluate(this._evaluator);
                                    if (null == le1 || "number" == typeof le1 && le1 != le1) return this._defaultValue;
                                    if (this._enumValues && !(le1 in this._enumValues)) throw new Ve(`Expected value to be one of ${Object.keys(this._enumValues).map((le1)=>JSON.stringify(le1)).join(", ")}, but found ${JSON.stringify(le1)} instead.`);
                                    return le1;
                                } catch (le1) {
                                    return this._warningHistory[le1.message] || (this._warningHistory[le1.message] = !0, "undefined" != typeof console && console.warn(le1.message)), this._defaultValue;
                                }
                            }
                        }
                        function ri(le1) {
                            return Array.isArray(le1) && le1.length > 0 && "string" == typeof le1[0] && le1[0] in Om;
                        }
                        function ni(le1, vt, bt) {
                            const ls = new We(Om, Ln, [], vt ? function(le1) {
                                const vt = {
                                    color: Xd,
                                    string: Yd,
                                    number: Zd,
                                    enum: Yd,
                                    boolean: Qd,
                                    formatted: em,
                                    padding: tm,
                                    numberArray: nm,
                                    colorArray: im,
                                    projectionDefinition: Kd,
                                    resolvedImage: rm,
                                    variableAnchorOffsetCollection: am
                                };
                                return "array" === le1.type ? Kt(vt[le1.value] || $d, le1.length) : vt[le1.type];
                            }(vt) : void 0), ho = ls.parse(le1, void 0, void 0, void 0, vt && "string" === vt.type ? {
                                typeAnnotation: "coerce"
                            } : void 0);
                            return ho ? $n(new ei(ho, vt, bt)) : Un(ls.errors);
                        }
                        class ii {
                            constructor(le1, vt, bt){
                                this.kind = le1, this._styleExpression = vt, this.isStateDependent = "constant" !== le1 && !Rn(vt.expression), this.globalStateRefs = ui(vt.expression), this._globalState = bt;
                            }
                            evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                                return this._globalState && (le1 = ci(le1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl);
                            }
                            evaluate(le1, vt, bt, ls, ho, Dl) {
                                return this._globalState && (le1 = ci(le1, this._globalState)), this._styleExpression.evaluate(le1, vt, bt, ls, ho, Dl);
                            }
                        }
                        class si {
                            constructor(le1, vt, bt, ls, ho){
                                this.kind = le1, this.zoomStops = bt, this._styleExpression = vt, this.isStateDependent = "camera" !== le1 && !Rn(vt.expression), this.globalStateRefs = ui(vt.expression), this.interpolationType = ls, this._globalState = ho;
                            }
                            evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl) {
                                return this._globalState && (le1 = ci(le1, this._globalState)), this._styleExpression.evaluateWithoutErrorHandling(le1, vt, bt, ls, ho, Dl);
                            }
                            evaluate(le1, vt, bt, ls, ho, Dl) {
                                return this._globalState && (le1 = ci(le1, this._globalState)), this._styleExpression.evaluate(le1, vt, bt, ls, ho, Dl);
                            }
                            interpolationFactor(le1, vt, bt) {
                                return this.interpolationType ? fr.interpolationFactor(this.interpolationType, le1, vt, bt) : 0;
                            }
                        }
                        function ai(le1, vt, bt) {
                            const ls = ni(le1, vt, bt);
                            if ("error" === ls.result) return ls;
                            const ho = ls.value.expression, Dl = On(ho);
                            if (!Dl && !qn(vt)) return Un([
                                new Pt("", "data expressions not supported")
                            ]);
                            const Fl = Nn(ho, [
                                "zoom"
                            ]);
                            if (!Fl && !jn(vt)) return Un([
                                new Pt("", "zoom expressions not supported")
                            ]);
                            const sc = li(ho);
                            return sc || Fl ? sc instanceof Pt ? Un([
                                sc
                            ]) : sc instanceof fr && !Gn(vt) ? Un([
                                new Pt("", '"interpolate" expressions cannot be used with this property')
                            ]) : $n(sc ? new si(Dl ? "camera" : "composite", ls.value, sc.labels, sc instanceof fr ? sc.interpolation : void 0, bt) : new ii(Dl ? "constant" : "source", ls.value, bt)) : Un([
                                new Pt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')
                            ]);
                        }
                        class oi {
                            constructor(le1, vt){
                                this._parameters = le1, this._specification = vt, zt(this, Hn(this._parameters, this._specification));
                            }
                            static deserialize(le1) {
                                return new oi(le1._parameters, le1._specification);
                            }
                            static serialize(le1) {
                                return {
                                    _parameters: le1._parameters,
                                    _specification: le1._specification
                                };
                            }
                        }
                        function li(le1) {
                            let vt = null;
                            if (le1 instanceof Je) vt = li(le1.result);
                            else if (le1 instanceof mr) {
                                for (const bt of le1.args)if (vt = li(bt), vt) break;
                            } else (le1 instanceof or || le1 instanceof fr) && le1.input instanceof zn && "zoom" === le1.input.name && (vt = le1);
                            return vt instanceof Pt || le1.eachChild((le1)=>{
                                const bt = li(le1);
                                bt instanceof Pt ? vt = bt : !vt && bt ? vt = new Pt("", '"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.') : vt && bt && vt !== bt && (vt = new Pt("", 'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));
                            }), vt;
                        }
                        function ui(le1, vt = new Set) {
                            return le1 instanceof Fn && vt.add(le1.key), le1.eachChild((le1)=>{
                                ui(le1, vt);
                            }), vt;
                        }
                        function ci(le1, vt) {
                            const { zoom: bt, heatmapDensity: ls, elevation: ho, lineProgress: Dl, isSupportedScript: Fl, accumulated: sc } = null != le1 ? le1 : {};
                            return {
                                zoom: bt,
                                heatmapDensity: ls,
                                elevation: ho,
                                lineProgress: Dl,
                                isSupportedScript: Fl,
                                accumulated: sc,
                                globalState: vt
                            };
                        }
                        function hi(le1) {
                            if (!0 === le1 || !1 === le1) return !0;
                            if (!Array.isArray(le1) || 0 === le1.length) return !1;
                            switch(le1[0]){
                                case "has":
                                    return le1.length >= 2 && "$id" !== le1[1] && "$type" !== le1[1];
                                case "in":
                                    return le1.length >= 3 && ("string" != typeof le1[1] || Array.isArray(le1[2]));
                                case "!in":
                                case "!has":
                                case "none":
                                    return !1;
                                case "==":
                                case "!=":
                                case ">":
                                case ">=":
                                case "<":
                                case "<=":
                                    return 3 !== le1.length || Array.isArray(le1[1]) || Array.isArray(le1[2]);
                                case "any":
                                case "all":
                                    for (const vt of le1.slice(1))if (!hi(vt) && "boolean" != typeof vt) return !1;
                                    return !0;
                                default:
                                    return !0;
                            }
                        }
                        const Bm = {
                            type: "boolean",
                            default: !1,
                            transition: !1,
                            "property-type": "data-driven",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "zoom",
                                    "feature"
                                ]
                            }
                        };
                        function fi(le1, vt) {
                            if (null == le1) return {
                                filter: ()=>!0,
                                needGeometry: !1,
                                getGlobalStateRefs: ()=>new Set
                            };
                            hi(le1) || (le1 = mi(le1));
                            const bt = ni(le1, Bm, vt);
                            if ("error" === bt.result) throw new Error(bt.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                            return {
                                filter: (le1, vt, ls)=>bt.value.evaluate(le1, vt, {}, ls),
                                needGeometry: yi(le1),
                                getGlobalStateRefs: ()=>ui(bt.value.expression)
                            };
                        }
                        function di(le1, vt) {
                            return le1 < vt ? -1 : le1 > vt ? 1 : 0;
                        }
                        function yi(le1) {
                            if (!Array.isArray(le1)) return !1;
                            if ("within" === le1[0] || "distance" === le1[0]) return !0;
                            for(let vt = 1; vt < le1.length; vt++)if (yi(le1[vt])) return !0;
                            return !1;
                        }
                        function mi(le1) {
                            if (!le1) return !0;
                            const vt = le1[0];
                            var bt;
                            return le1.length <= 1 ? "any" !== vt : "==" === vt ? gi(le1[1], le1[2], "==") : "!=" === vt ? bi(gi(le1[1], le1[2], "==")) : "<" === vt || ">" === vt || "<=" === vt || ">=" === vt ? gi(le1[1], le1[2], vt) : "any" === vt ? (bt = le1.slice(1), [
                                "any"
                            ].concat(bt.map(mi))) : "all" === vt ? [
                                "all"
                            ].concat(le1.slice(1).map(mi)) : "none" === vt ? [
                                "all"
                            ].concat(le1.slice(1).map(mi).map(bi)) : "in" === vt ? xi(le1[1], le1.slice(2)) : "!in" === vt ? bi(xi(le1[1], le1.slice(2))) : "has" === vt ? vi(le1[1]) : "!has" !== vt || bi(vi(le1[1]));
                        }
                        function gi(le1, vt, bt) {
                            switch(le1){
                                case "$type":
                                    return [
                                        `filter-type-${bt}`,
                                        vt
                                    ];
                                case "$id":
                                    return [
                                        `filter-id-${bt}`,
                                        vt
                                    ];
                                default:
                                    return [
                                        `filter-${bt}`,
                                        le1,
                                        vt
                                    ];
                            }
                        }
                        function xi(le1, vt) {
                            if (0 === vt.length) return !1;
                            switch(le1){
                                case "$type":
                                    return [
                                        "filter-type-in",
                                        [
                                            "literal",
                                            vt
                                        ]
                                    ];
                                case "$id":
                                    return [
                                        "filter-id-in",
                                        [
                                            "literal",
                                            vt
                                        ]
                                    ];
                                default:
                                    return vt.length > 200 && !vt.some((le1)=>typeof le1 != typeof vt[0]) ? [
                                        "filter-in-large",
                                        le1,
                                        [
                                            "literal",
                                            vt.sort(di)
                                        ]
                                    ] : [
                                        "filter-in-small",
                                        le1,
                                        [
                                            "literal",
                                            vt
                                        ]
                                    ];
                            }
                        }
                        function vi(le1) {
                            switch(le1){
                                case "$type":
                                    return !0;
                                case "$id":
                                    return [
                                        "filter-has-id"
                                    ];
                                default:
                                    return [
                                        "filter-has",
                                        le1
                                    ];
                            }
                        }
                        function bi(le1) {
                            return [
                                "!",
                                le1
                            ];
                        }
                        function wi(le1) {
                            const vt = typeof le1;
                            if ("number" === vt || "boolean" === vt || "string" === vt || null == le1) return JSON.stringify(le1);
                            if (Array.isArray(le1)) {
                                let vt = "[";
                                for (const bt of le1)vt += `${wi(bt)},`;
                                return `${vt}]`;
                            }
                            const bt = Object.keys(le1).sort();
                            let ls = "{";
                            for(let ho = 0; ho < bt.length; ho++)ls += `${JSON.stringify(bt[ho])}:${wi(le1[bt[ho]])},`;
                            return `${ls}}`;
                        }
                        function _i(le1) {
                            let vt = "";
                            for (const bt of Hd)vt += `/${wi(le1[bt])}`;
                            return vt;
                        }
                        function Si(le1) {
                            const vt = le1.value;
                            return vt ? [
                                new Dt(le1.key, vt, "constants have been deprecated as of v8")
                            ] : [];
                        }
                        function Ai(le1) {
                            return le1 instanceof Number || le1 instanceof String || le1 instanceof Boolean ? le1.valueOf() : le1;
                        }
                        function ki(le1) {
                            if (Array.isArray(le1)) return le1.map(ki);
                            if (le1 instanceof Object && !(le1 instanceof Number || le1 instanceof String || le1 instanceof Boolean)) {
                                const vt = {};
                                for(const bt in le1)vt[bt] = ki(le1[bt]);
                                return vt;
                            }
                            return Ai(le1);
                        }
                        function Ei(le1) {
                            const vt = le1.key, bt = le1.value, ls = le1.valueSpec || {}, ho = le1.objectElementValidators || {}, Dl = le1.style, Fl = le1.styleSpec, sc = le1.validateSpec;
                            let uc = [];
                            const mc = Xn(bt);
                            if ("object" !== mc) return [
                                new Dt(vt, bt, `object expected, ${mc} found`)
                            ];
                            for(const gc in bt){
                                const le1 = gc.split(".")[0], mc = ve(ls, le1) || ls["*"];
                                let Ac;
                                if (ve(ho, le1)) Ac = ho[le1];
                                else if (ve(ls, le1)) {
                                    if (void 0 === bt[gc]) continue;
                                    Ac = sc;
                                } else if (ho["*"]) Ac = ho["*"];
                                else {
                                    if (!ls["*"]) {
                                        uc.push(new Dt(vt, bt[gc], `unknown property "${gc}"`));
                                        continue;
                                    }
                                    Ac = sc;
                                }
                                uc = uc.concat(Ac({
                                    key: (vt ? `${vt}.` : vt) + gc,
                                    value: bt[gc],
                                    valueSpec: mc,
                                    style: Dl,
                                    styleSpec: Fl,
                                    object: bt,
                                    objectKey: gc,
                                    validateSpec: sc
                                }, bt));
                            }
                            for(const gc in ls)ho[gc] || ls[gc].required && void 0 === ls[gc].default && void 0 === bt[gc] && uc.push(new Dt(vt, bt, `missing required property "${gc}"`));
                            return uc;
                        }
                        function Ti(le1) {
                            const vt = le1.value, bt = le1.valueSpec, ls = le1.style, ho = le1.styleSpec, Dl = le1.key, Fl = le1.arrayElementValidator || le1.validateSpec;
                            if ("array" !== Xn(vt)) return [
                                new Dt(Dl, vt, `array expected, ${Xn(vt)} found`)
                            ];
                            if (bt.length && vt.length !== bt.length) return [
                                new Dt(Dl, vt, `array length ${bt.length} expected, length ${vt.length} found`)
                            ];
                            let sc = {
                                type: bt.value,
                                values: bt.values
                            };
                            ho.$version < 7 && (sc.function = bt.function), "object" === Xn(bt.value) && (sc = bt.value);
                            let uc = [];
                            for(let mc = 0; mc < vt.length; mc++)uc = uc.concat(Fl({
                                array: vt,
                                arrayIndex: mc,
                                value: vt[mc],
                                valueSpec: sc,
                                validateSpec: le1.validateSpec,
                                style: ls,
                                styleSpec: ho,
                                key: `${Dl}[${mc}]`
                            }));
                            return uc;
                        }
                        function Ii(le1) {
                            const vt = le1.key, bt = le1.value, ls = le1.valueSpec;
                            let ho = Xn(bt);
                            return "number" === ho && bt != bt && (ho = "NaN"), "number" !== ho ? [
                                new Dt(vt, bt, `number expected, ${ho} found`)
                            ] : "minimum" in ls && bt < ls.minimum ? [
                                new Dt(vt, bt, `${bt} is less than the minimum value ${ls.minimum}`)
                            ] : "maximum" in ls && bt > ls.maximum ? [
                                new Dt(vt, bt, `${bt} is greater than the maximum value ${ls.maximum}`)
                            ] : [];
                        }
                        function Mi(le1) {
                            const vt = le1.valueSpec, bt = Ai(le1.value.type);
                            let ls, ho, Dl, Fl = {};
                            const sc = "categorical" !== bt && void 0 === le1.value.property, uc = !sc, mc = "array" === Xn(le1.value.stops) && "array" === Xn(le1.value.stops[0]) && "object" === Xn(le1.value.stops[0][0]), gc = Ei({
                                key: le1.key,
                                value: le1.value,
                                valueSpec: le1.styleSpec.function,
                                validateSpec: le1.validateSpec,
                                style: le1.style,
                                styleSpec: le1.styleSpec,
                                objectElementValidators: {
                                    stops: function(le1) {
                                        if ("identity" === bt) return [
                                            new Dt(le1.key, le1.value, 'identity function may not have a "stops" property')
                                        ];
                                        let vt = [];
                                        const ls = le1.value;
                                        return vt = vt.concat(Ti({
                                            key: le1.key,
                                            value: ls,
                                            valueSpec: le1.valueSpec,
                                            validateSpec: le1.validateSpec,
                                            style: le1.style,
                                            styleSpec: le1.styleSpec,
                                            arrayElementValidator: h
                                        })), "array" === Xn(ls) && 0 === ls.length && vt.push(new Dt(le1.key, ls, "array must have at least one stop")), vt;
                                    },
                                    default: function(le1) {
                                        return le1.validateSpec({
                                            key: le1.key,
                                            value: le1.value,
                                            valueSpec: vt,
                                            validateSpec: le1.validateSpec,
                                            style: le1.style,
                                            styleSpec: le1.styleSpec
                                        });
                                    }
                                }
                            });
                            return "identity" === bt && sc && gc.push(new Dt(le1.key, le1.value, 'missing required property "property"')), "identity" === bt || le1.value.stops || gc.push(new Dt(le1.key, le1.value, 'missing required property "stops"')), "exponential" === bt && le1.valueSpec.expression && !Gn(le1.valueSpec) && gc.push(new Dt(le1.key, le1.value, "exponential functions not supported")), le1.styleSpec.$version >= 8 && (uc && !qn(le1.valueSpec) ? gc.push(new Dt(le1.key, le1.value, "property functions not supported")) : sc && !jn(le1.valueSpec) && gc.push(new Dt(le1.key, le1.value, "zoom functions not supported"))), "categorical" !== bt && !mc || void 0 !== le1.value.property || gc.push(new Dt(le1.key, le1.value, '"property" property is required')), gc;
                            function h(le1) {
                                let bt = [];
                                const ls = le1.value, sc = le1.key;
                                if ("array" !== Xn(ls)) return [
                                    new Dt(sc, ls, `array expected, ${Xn(ls)} found`)
                                ];
                                if (2 !== ls.length) return [
                                    new Dt(sc, ls, `array length 2 expected, length ${ls.length} found`)
                                ];
                                if (mc) {
                                    if ("object" !== Xn(ls[0])) return [
                                        new Dt(sc, ls, `object expected, ${Xn(ls[0])} found`)
                                    ];
                                    if (void 0 === ls[0].zoom) return [
                                        new Dt(sc, ls, "object stop key must have zoom")
                                    ];
                                    if (void 0 === ls[0].value) return [
                                        new Dt(sc, ls, "object stop key must have value")
                                    ];
                                    if (Dl && Dl > Ai(ls[0].zoom)) return [
                                        new Dt(sc, ls[0].zoom, "stop zoom values must appear in ascending order")
                                    ];
                                    Ai(ls[0].zoom) !== Dl && (Dl = Ai(ls[0].zoom), ho = void 0, Fl = {}), bt = bt.concat(Ei({
                                        key: `${sc}[0]`,
                                        value: ls[0],
                                        valueSpec: {
                                            zoom: {}
                                        },
                                        validateSpec: le1.validateSpec,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec,
                                        objectElementValidators: {
                                            zoom: Ii,
                                            value: p
                                        }
                                    }));
                                } else bt = bt.concat(p({
                                    key: `${sc}[0]`,
                                    value: ls[0],
                                    validateSpec: le1.validateSpec,
                                    style: le1.style,
                                    styleSpec: le1.styleSpec
                                }, ls));
                                return ri(ki(ls[1])) ? bt.concat([
                                    new Dt(`${sc}[1]`, ls[1], "expressions are not allowed in function stops.")
                                ]) : bt.concat(le1.validateSpec({
                                    key: `${sc}[1]`,
                                    value: ls[1],
                                    valueSpec: vt,
                                    validateSpec: le1.validateSpec,
                                    style: le1.style,
                                    styleSpec: le1.styleSpec
                                }));
                            }
                            function p(le1, Dl) {
                                const sc = Xn(le1.value), uc = Ai(le1.value), mc = null !== le1.value ? le1.value : Dl;
                                if (ls) {
                                    if (sc !== ls) return [
                                        new Dt(le1.key, mc, `${sc} stop domain type must match previous stop domain type ${ls}`)
                                    ];
                                } else ls = sc;
                                if ("number" !== sc && "string" !== sc && "boolean" !== sc) return [
                                    new Dt(le1.key, mc, "stop domain value must be a number, string, or boolean")
                                ];
                                if ("number" !== sc && "categorical" !== bt) {
                                    let ls = `number expected, ${sc} found`;
                                    return qn(vt) && void 0 === bt && (ls += '\nIf you intended to use a categorical function, specify `"type": "categorical"`.'), [
                                        new Dt(le1.key, mc, ls)
                                    ];
                                }
                                return "categorical" !== bt || "number" !== sc || isFinite(uc) && Math.floor(uc) === uc ? "categorical" !== bt && "number" === sc && void 0 !== ho && uc < ho ? [
                                    new Dt(le1.key, mc, "stop domain values must appear in ascending order")
                                ] : (ho = uc, "categorical" === bt && uc in Fl ? [
                                    new Dt(le1.key, mc, "stop domain values must be unique")
                                ] : (Fl[uc] = !0, [])) : [
                                    new Dt(le1.key, mc, `integer expected, found ${uc}`)
                                ];
                            }
                        }
                        function Fi(le1) {
                            const vt = ("property" === le1.expressionContext ? ai : ni)(ki(le1.value), le1.valueSpec);
                            if ("error" === vt.result) return vt.value.map((vt)=>new Dt(`${le1.key}${vt.key}`, le1.value, vt.message));
                            const bt = vt.value.expression || vt.value._styleExpression.expression;
                            if ("property" === le1.expressionContext && "text-font" === le1.propertyKey && !bt.outputDefined()) return [
                                new Dt(le1.key, le1.value, `Invalid data expression for "${le1.propertyKey}". Output values must be contained as literals within the expression.`)
                            ];
                            if ("property" === le1.expressionContext && "layout" === le1.propertyType && !Rn(bt)) return [
                                new Dt(le1.key, le1.value, '"feature-state" data expressions are not supported with layout properties.')
                            ];
                            if ("filter" === le1.expressionContext && !Rn(bt)) return [
                                new Dt(le1.key, le1.value, '"feature-state" data expressions are not supported with filters.')
                            ];
                            if (le1.expressionContext && 0 === le1.expressionContext.indexOf("cluster")) {
                                if (!Nn(bt, [
                                    "zoom",
                                    "feature-state"
                                ])) return [
                                    new Dt(le1.key, le1.value, '"zoom" and "feature-state" expressions are not supported with cluster properties.')
                                ];
                                if ("cluster-initial" === le1.expressionContext && !On(bt)) return [
                                    new Dt(le1.key, le1.value, "Feature data expressions are not supported with initial expression part of cluster properties.")
                                ];
                            }
                            return [];
                        }
                        function Di(le1) {
                            const vt = le1.key, bt = le1.value, ls = Xn(bt);
                            return "string" !== ls ? [
                                new Dt(vt, bt, `color expected, ${ls} found`)
                            ] : Te.parse(String(bt)) ? [] : [
                                new Dt(vt, bt, `color expected, "${bt}" found`)
                            ];
                        }
                        function zi(le1) {
                            const vt = le1.key, bt = le1.value, ls = le1.valueSpec, ho = [];
                            return Array.isArray(ls.values) ? -1 === ls.values.indexOf(Ai(bt)) && ho.push(new Dt(vt, bt, `expected one of [${ls.values.join(", ")}], ${JSON.stringify(bt)} found`)) : -1 === Object.keys(ls.values).indexOf(Ai(bt)) && ho.push(new Dt(vt, bt, `expected one of [${Object.keys(ls.values).join(", ")}], ${JSON.stringify(bt)} found`)), ho;
                        }
                        function Pi(le1) {
                            return hi(ki(le1.value)) ? Fi(zt({}, le1, {
                                expressionContext: "filter",
                                valueSpec: {
                                    value: "boolean"
                                }
                            })) : Bi(le1);
                        }
                        function Bi(le1) {
                            const vt = le1.value, bt = le1.key;
                            if ("array" !== Xn(vt)) return [
                                new Dt(bt, vt, `array expected, ${Xn(vt)} found`)
                            ];
                            const ls = le1.styleSpec;
                            let ho, Dl = [];
                            if (vt.length < 1) return [
                                new Dt(bt, vt, "filter array must have at least 1 element")
                            ];
                            switch(Dl = Dl.concat(zi({
                                key: `${bt}[0]`,
                                value: vt[0],
                                valueSpec: ls.filter_operator,
                                style: le1.style,
                                styleSpec: le1.styleSpec
                            })), Ai(vt[0])){
                                case "<":
                                case "<=":
                                case ">":
                                case ">=":
                                    vt.length >= 2 && "$type" === Ai(vt[1]) && Dl.push(new Dt(bt, vt, `"$type" cannot be use with operator "${vt[0]}"`));
                                case "==":
                                case "!=":
                                    3 !== vt.length && Dl.push(new Dt(bt, vt, `filter array for operator "${vt[0]}" must have 3 elements`));
                                case "in":
                                case "!in":
                                    vt.length >= 2 && (ho = Xn(vt[1]), "string" !== ho && Dl.push(new Dt(`${bt}[1]`, vt[1], `string expected, ${ho} found`)));
                                    for(let Fl = 2; Fl < vt.length; Fl++)ho = Xn(vt[Fl]), "$type" === Ai(vt[1]) ? Dl = Dl.concat(zi({
                                        key: `${bt}[${Fl}]`,
                                        value: vt[Fl],
                                        valueSpec: ls.geometry_type,
                                        style: le1.style,
                                        styleSpec: le1.styleSpec
                                    })) : "string" !== ho && "number" !== ho && "boolean" !== ho && Dl.push(new Dt(`${bt}[${Fl}]`, vt[Fl], `string, number, or boolean expected, ${ho} found`));
                                    break;
                                case "any":
                                case "all":
                                case "none":
                                    for(let ls = 1; ls < vt.length; ls++)Dl = Dl.concat(Bi({
                                        key: `${bt}[${ls}]`,
                                        value: vt[ls],
                                        style: le1.style,
                                        styleSpec: le1.styleSpec
                                    }));
                                    break;
                                case "has":
                                case "!has":
                                    ho = Xn(vt[1]), 2 !== vt.length ? Dl.push(new Dt(bt, vt, `filter array for "${vt[0]}" operator must have 2 elements`)) : "string" !== ho && Dl.push(new Dt(`${bt}[1]`, vt[1], `string expected, ${ho} found`));
                            }
                            return Dl;
                        }
                        function Vi(le1, vt) {
                            const bt = le1.key, ls = le1.validateSpec, ho = le1.style, Dl = le1.styleSpec, Fl = le1.value, sc = le1.objectKey, uc = Dl[`${vt}_${le1.layerType}`];
                            if (!uc) return [];
                            const mc = sc.match(/^(.*)-transition$/);
                            if ("paint" === vt && mc && uc[mc[1]] && uc[mc[1]].transition) return ls({
                                key: bt,
                                value: Fl,
                                valueSpec: Dl.transition,
                                style: ho,
                                styleSpec: Dl
                            });
                            const gc = le1.valueSpec || uc[sc];
                            if (!gc) return [
                                new Dt(bt, Fl, `unknown property "${sc}"`)
                            ];
                            let Ac;
                            if ("string" === Xn(Fl) && qn(gc) && !gc.tokens && (Ac = /^{([^}]+)}$/.exec(Fl))) return [
                                new Dt(bt, Fl, `"${sc}" does not support interpolation syntax\nUse an identity property function instead: \`{ "type": "identity", "property": ${JSON.stringify(Ac[1])} }\`.`)
                            ];
                            const Ec = [];
                            return "symbol" === le1.layerType && "text-font" === sc && Yn(ki(Fl)) && "identity" === Ai(Fl.type) && Ec.push(new Dt(bt, Fl, '"text-font" does not support identity functions')), Ec.concat(ls({
                                key: le1.key,
                                value: Fl,
                                valueSpec: gc,
                                style: ho,
                                styleSpec: Dl,
                                expressionContext: "property",
                                propertyType: vt,
                                propertyKey: sc
                            }));
                        }
                        function Ci(le1) {
                            return Vi(le1, "paint");
                        }
                        function Li(le1) {
                            return Vi(le1, "layout");
                        }
                        function Oi(le1) {
                            let vt = [];
                            const bt = le1.value, ls = le1.key, ho = le1.style, Dl = le1.styleSpec;
                            if ("object" !== Xn(bt)) return [
                                new Dt(ls, bt, `object expected, ${Xn(bt)} found`)
                            ];
                            bt.type || bt.ref || vt.push(new Dt(ls, bt, 'either "type" or "ref" is required'));
                            let Fl = Ai(bt.type);
                            const sc = Ai(bt.ref);
                            if (bt.id) {
                                const Dl = Ai(bt.id);
                                for(let Fl = 0; Fl < le1.arrayIndex; Fl++){
                                    const le1 = ho.layers[Fl];
                                    Ai(le1.id) === Dl && vt.push(new Dt(ls, bt.id, `duplicate layer id "${bt.id}", previously used at line ${le1.id.__line__}`));
                                }
                            }
                            if ("ref" in bt) {
                                let le1;
                                [
                                    "type",
                                    "source",
                                    "source-layer",
                                    "filter",
                                    "layout"
                                ].forEach((le1)=>{
                                    le1 in bt && vt.push(new Dt(ls, bt[le1], `"${le1}" is prohibited for ref layers`));
                                }), ho.layers.forEach((vt)=>{
                                    Ai(vt.id) === sc && (le1 = vt);
                                }), le1 ? le1.ref ? vt.push(new Dt(ls, bt.ref, "ref cannot reference another ref layer")) : Fl = Ai(le1.type) : vt.push(new Dt(ls, bt.ref, `ref layer "${sc}" not found`));
                            } else if ("background" !== Fl) {
                                if (bt.source) {
                                    const le1 = ho.sources && ho.sources[bt.source], Dl = le1 && Ai(le1.type);
                                    le1 ? "vector" === Dl && "raster" === Fl ? vt.push(new Dt(ls, bt.source, `layer "${bt.id}" requires a raster source`)) : "raster-dem" !== Dl && "hillshade" === Fl || "raster-dem" !== Dl && "color-relief" === Fl ? vt.push(new Dt(ls, bt.source, `layer "${bt.id}" requires a raster-dem source`)) : "raster" === Dl && "raster" !== Fl ? vt.push(new Dt(ls, bt.source, `layer "${bt.id}" requires a vector source`)) : "vector" !== Dl || bt["source-layer"] ? "raster-dem" === Dl && "hillshade" !== Fl && "color-relief" !== Fl ? vt.push(new Dt(ls, bt.source, "raster-dem source can only be used with layer type 'hillshade' or 'color-relief'.")) : "line" !== Fl || !bt.paint || !bt.paint["line-gradient"] || "geojson" === Dl && le1.lineMetrics || vt.push(new Dt(ls, bt, `layer "${bt.id}" specifies a line-gradient, which requires a GeoJSON source with \`lineMetrics\` enabled.`)) : vt.push(new Dt(ls, bt, `layer "${bt.id}" must specify a "source-layer"`)) : vt.push(new Dt(ls, bt.source, `source "${bt.source}" not found`));
                                } else vt.push(new Dt(ls, bt, 'missing required property "source"'));
                            }
                            return vt = vt.concat(Ei({
                                key: ls,
                                value: bt,
                                valueSpec: Dl.layer,
                                style: le1.style,
                                styleSpec: le1.styleSpec,
                                validateSpec: le1.validateSpec,
                                objectElementValidators: {
                                    "*": ()=>[],
                                    type: ()=>le1.validateSpec({
                                            key: `${ls}.type`,
                                            value: bt.type,
                                            valueSpec: Dl.layer.type,
                                            style: le1.style,
                                            styleSpec: le1.styleSpec,
                                            validateSpec: le1.validateSpec,
                                            object: bt,
                                            objectKey: "type"
                                        }),
                                    filter: Pi,
                                    layout: (le1)=>Ei({
                                            layer: bt,
                                            key: le1.key,
                                            value: le1.value,
                                            style: le1.style,
                                            styleSpec: le1.styleSpec,
                                            validateSpec: le1.validateSpec,
                                            objectElementValidators: {
                                                "*": (le1)=>Li(zt({
                                                        layerType: Fl
                                                    }, le1))
                                            }
                                        }),
                                    paint: (le1)=>Ei({
                                            layer: bt,
                                            key: le1.key,
                                            value: le1.value,
                                            style: le1.style,
                                            styleSpec: le1.styleSpec,
                                            validateSpec: le1.validateSpec,
                                            objectElementValidators: {
                                                "*": (le1)=>Ci(zt({
                                                        layerType: Fl
                                                    }, le1))
                                            }
                                        })
                                }
                            })), vt;
                        }
                        function Ri(le1) {
                            const vt = le1.value, bt = le1.key, ls = Xn(vt);
                            return "string" !== ls ? [
                                new Dt(bt, vt, `string expected, ${ls} found`)
                            ] : [];
                        }
                        const jm = {
                            promoteId: function({ key: le1, value: vt }) {
                                if ("string" === Xn(vt)) return Ri({
                                    key: le1,
                                    value: vt
                                });
                                {
                                    const bt = [];
                                    for(const ls in vt)bt.push(...Ri({
                                        key: `${le1}.${ls}`,
                                        value: vt[ls]
                                    }));
                                    return bt;
                                }
                            }
                        };
                        function $i(le1) {
                            const vt = le1.value, bt = le1.key, ls = le1.styleSpec, ho = le1.style, Dl = le1.validateSpec;
                            if (!vt.type) return [
                                new Dt(bt, vt, '"type" is required')
                            ];
                            const Fl = Ai(vt.type);
                            let sc;
                            switch(Fl){
                                case "vector":
                                case "raster":
                                    return sc = Ei({
                                        key: bt,
                                        value: vt,
                                        valueSpec: ls[`source_${Fl.replace("-", "_")}`],
                                        style: le1.style,
                                        styleSpec: ls,
                                        objectElementValidators: jm,
                                        validateSpec: Dl
                                    }), sc;
                                case "raster-dem":
                                    return sc = function(le1) {
                                        var vt;
                                        const bt = null !== (vt = le1.sourceName) && void 0 !== vt ? vt : "", ls = le1.value, ho = le1.styleSpec, Dl = ho.source_raster_dem, Fl = le1.style;
                                        let sc = [];
                                        const uc = Xn(ls);
                                        if (void 0 === ls) return sc;
                                        if ("object" !== uc) return sc.push(new Dt("source_raster_dem", ls, `object expected, ${uc} found`)), sc;
                                        const mc = "custom" === Ai(ls.encoding), gc = [
                                            "redFactor",
                                            "greenFactor",
                                            "blueFactor",
                                            "baseShift"
                                        ], Ac = le1.value.encoding ? `"${le1.value.encoding}"` : "Default";
                                        for(const Ec in ls)!mc && gc.includes(Ec) ? sc.push(new Dt(Ec, ls[Ec], `In "${bt}": "${Ec}" is only valid when "encoding" is set to "custom". ${Ac} encoding found`)) : Dl[Ec] ? sc = sc.concat(le1.validateSpec({
                                            key: Ec,
                                            value: ls[Ec],
                                            valueSpec: Dl[Ec],
                                            validateSpec: le1.validateSpec,
                                            style: Fl,
                                            styleSpec: ho
                                        })) : sc.push(new Dt(Ec, ls[Ec], `unknown property "${Ec}"`));
                                        return sc;
                                    }({
                                        sourceName: bt,
                                        value: vt,
                                        style: le1.style,
                                        styleSpec: ls,
                                        validateSpec: Dl
                                    }), sc;
                                case "geojson":
                                    if (sc = Ei({
                                        key: bt,
                                        value: vt,
                                        valueSpec: ls.source_geojson,
                                        style: ho,
                                        styleSpec: ls,
                                        validateSpec: Dl,
                                        objectElementValidators: jm
                                    }), vt.cluster) for(const le1 in vt.clusterProperties){
                                        const [ls, ho] = vt.clusterProperties[le1], Dl = "string" == typeof ls ? [
                                            ls,
                                            [
                                                "accumulated"
                                            ],
                                            [
                                                "get",
                                                le1
                                            ]
                                        ] : ls;
                                        sc.push(...Fi({
                                            key: `${bt}.${le1}.map`,
                                            value: ho,
                                            expressionContext: "cluster-map"
                                        })), sc.push(...Fi({
                                            key: `${bt}.${le1}.reduce`,
                                            value: Dl,
                                            expressionContext: "cluster-reduce"
                                        }));
                                    }
                                    return sc;
                                case "video":
                                    return Ei({
                                        key: bt,
                                        value: vt,
                                        valueSpec: ls.source_video,
                                        style: ho,
                                        validateSpec: Dl,
                                        styleSpec: ls
                                    });
                                case "image":
                                    return Ei({
                                        key: bt,
                                        value: vt,
                                        valueSpec: ls.source_image,
                                        style: ho,
                                        validateSpec: Dl,
                                        styleSpec: ls
                                    });
                                case "canvas":
                                    return [
                                        new Dt(bt, null, "Please use runtime APIs to add canvas sources, rather than including them in stylesheets.", "source.canvas")
                                    ];
                                default:
                                    return zi({
                                        key: `${bt}.type`,
                                        value: vt.type,
                                        valueSpec: {
                                            values: [
                                                "vector",
                                                "raster",
                                                "raster-dem",
                                                "geojson",
                                                "video",
                                                "image"
                                            ]
                                        }
                                    });
                            }
                        }
                        function Ui(le1) {
                            const vt = le1.value, bt = le1.styleSpec, ls = bt.light, ho = le1.style;
                            let Dl = [];
                            const Fl = Xn(vt);
                            if (void 0 === vt) return Dl;
                            if ("object" !== Fl) return Dl = Dl.concat([
                                new Dt("light", vt, `object expected, ${Fl} found`)
                            ]), Dl;
                            for(const sc in vt){
                                const Fl = sc.match(/^(.*)-transition$/);
                                Dl = Dl.concat(Fl && ls[Fl[1]] && ls[Fl[1]].transition ? le1.validateSpec({
                                    key: sc,
                                    value: vt[sc],
                                    valueSpec: bt.transition,
                                    validateSpec: le1.validateSpec,
                                    style: ho,
                                    styleSpec: bt
                                }) : ls[sc] ? le1.validateSpec({
                                    key: sc,
                                    value: vt[sc],
                                    valueSpec: ls[sc],
                                    validateSpec: le1.validateSpec,
                                    style: ho,
                                    styleSpec: bt
                                }) : [
                                    new Dt(sc, vt[sc], `unknown property "${sc}"`)
                                ]);
                            }
                            return Dl;
                        }
                        function qi(le1) {
                            const vt = le1.value, bt = le1.styleSpec, ls = bt.sky, ho = le1.style, Dl = Xn(vt);
                            if (void 0 === vt) return [];
                            if ("object" !== Dl) return [
                                new Dt("sky", vt, `object expected, ${Dl} found`)
                            ];
                            let Fl = [];
                            for(const sc in vt)Fl = Fl.concat(ls[sc] ? le1.validateSpec({
                                key: sc,
                                value: vt[sc],
                                valueSpec: ls[sc],
                                style: ho,
                                styleSpec: bt
                            }) : [
                                new Dt(sc, vt[sc], `unknown property "${sc}"`)
                            ]);
                            return Fl;
                        }
                        function ji(le1) {
                            const vt = le1.value, bt = le1.styleSpec, ls = bt.terrain, ho = le1.style;
                            let Dl = [];
                            const Fl = Xn(vt);
                            if (void 0 === vt) return Dl;
                            if ("object" !== Fl) return Dl = Dl.concat([
                                new Dt("terrain", vt, `object expected, ${Fl} found`)
                            ]), Dl;
                            for(const sc in vt)Dl = Dl.concat(ls[sc] ? le1.validateSpec({
                                key: sc,
                                value: vt[sc],
                                valueSpec: ls[sc],
                                validateSpec: le1.validateSpec,
                                style: ho,
                                styleSpec: bt
                            }) : [
                                new Dt(sc, vt[sc], `unknown property "${sc}"`)
                            ]);
                            return Dl;
                        }
                        function Gi(le1) {
                            let vt = [];
                            const bt = le1.value, ls = le1.key;
                            if (Array.isArray(bt)) {
                                const ho = [], Dl = [];
                                for(const Fl in bt)bt[Fl].id && ho.includes(bt[Fl].id) && vt.push(new Dt(ls, bt, `all the sprites' ids must be unique, but ${bt[Fl].id} is duplicated`)), ho.push(bt[Fl].id), bt[Fl].url && Dl.includes(bt[Fl].url) && vt.push(new Dt(ls, bt, `all the sprites' URLs must be unique, but ${bt[Fl].url} is duplicated`)), Dl.push(bt[Fl].url), vt = vt.concat(Ei({
                                    key: `${ls}[${Fl}]`,
                                    value: bt[Fl],
                                    valueSpec: {
                                        id: {
                                            type: "string",
                                            required: !0
                                        },
                                        url: {
                                            type: "string",
                                            required: !0
                                        }
                                    },
                                    validateSpec: le1.validateSpec
                                }));
                                return vt;
                            }
                            return Ri({
                                key: ls,
                                value: bt
                            });
                        }
                        function Xi(le1) {
                            return Boolean(le1) && le1.constructor === Object;
                        }
                        function Yi(le1) {
                            return Xi(le1.value) ? [] : [
                                new Dt(le1.key, le1.value, `object expected, ${Xn(le1.value)} found`)
                            ];
                        }
                        const Um = {
                            "*": ()=>[],
                            array: Ti,
                            boolean: function(le1) {
                                const vt = le1.value, bt = le1.key, ls = Xn(vt);
                                return "boolean" !== ls ? [
                                    new Dt(bt, vt, `boolean expected, ${ls} found`)
                                ] : [];
                            },
                            number: Ii,
                            color: Di,
                            constants: Si,
                            enum: zi,
                            filter: Pi,
                            function: Mi,
                            layer: Oi,
                            object: Ei,
                            source: $i,
                            light: Ui,
                            sky: qi,
                            terrain: ji,
                            projection: function(le1) {
                                const vt = le1.value, bt = le1.styleSpec, ls = bt.projection, ho = le1.style, Dl = Xn(vt);
                                if (void 0 === vt) return [];
                                if ("object" !== Dl) return [
                                    new Dt("projection", vt, `object expected, ${Dl} found`)
                                ];
                                let Fl = [];
                                for(const sc in vt)Fl = Fl.concat(ls[sc] ? le1.validateSpec({
                                    key: sc,
                                    value: vt[sc],
                                    valueSpec: ls[sc],
                                    style: ho,
                                    styleSpec: bt
                                }) : [
                                    new Dt(sc, vt[sc], `unknown property "${sc}"`)
                                ]);
                                return Fl;
                            },
                            projectionDefinition: function(le1) {
                                const vt = le1.key;
                                let bt = le1.value;
                                bt = bt instanceof String ? bt.valueOf() : bt;
                                const ls = Xn(bt);
                                return "array" !== ls || function(le1) {
                                    return Array.isArray(le1) && 3 === le1.length && "string" == typeof le1[0] && "string" == typeof le1[1] && "number" == typeof le1[2];
                                }(bt) || function(le1) {
                                    return !![
                                        "interpolate",
                                        "step",
                                        "literal"
                                    ].includes(le1[0]);
                                }(bt) ? [
                                    "array",
                                    "string"
                                ].includes(ls) ? [] : [
                                    new Dt(vt, bt, `projection expected, invalid type "${ls}" found`)
                                ] : [
                                    new Dt(vt, bt, `projection expected, invalid array ${JSON.stringify(bt)} found`)
                                ];
                            },
                            string: Ri,
                            formatted: function(le1) {
                                return 0 === Ri(le1).length ? [] : Fi(le1);
                            },
                            resolvedImage: function(le1) {
                                return 0 === Ri(le1).length ? [] : Fi(le1);
                            },
                            padding: function(le1) {
                                const vt = le1.key, bt = le1.value;
                                if ("array" === Xn(bt)) {
                                    if (bt.length < 1 || bt.length > 4) return [
                                        new Dt(vt, bt, `padding requires 1 to 4 values; ${bt.length} values found`)
                                    ];
                                    const ls = {
                                        type: "number"
                                    };
                                    let ho = [];
                                    for(let Dl = 0; Dl < bt.length; Dl++)ho = ho.concat(le1.validateSpec({
                                        key: `${vt}[${Dl}]`,
                                        value: bt[Dl],
                                        validateSpec: le1.validateSpec,
                                        valueSpec: ls
                                    }));
                                    return ho;
                                }
                                return Ii({
                                    key: vt,
                                    value: bt,
                                    valueSpec: {}
                                });
                            },
                            numberArray: function(le1) {
                                const vt = le1.key, bt = le1.value;
                                if ("array" === Xn(bt)) {
                                    const ls = {
                                        type: "number"
                                    };
                                    if (bt.length < 1) return [
                                        new Dt(vt, bt, "array length at least 1 expected, length 0 found")
                                    ];
                                    let ho = [];
                                    for(let Dl = 0; Dl < bt.length; Dl++)ho = ho.concat(le1.validateSpec({
                                        key: `${vt}[${Dl}]`,
                                        value: bt[Dl],
                                        validateSpec: le1.validateSpec,
                                        valueSpec: ls
                                    }));
                                    return ho;
                                }
                                return Ii({
                                    key: vt,
                                    value: bt,
                                    valueSpec: {}
                                });
                            },
                            colorArray: function(le1) {
                                const vt = le1.key, bt = le1.value;
                                if ("array" === Xn(bt)) {
                                    if (bt.length < 1) return [
                                        new Dt(vt, bt, "array length at least 1 expected, length 0 found")
                                    ];
                                    let le1 = [];
                                    for(let ls = 0; ls < bt.length; ls++)le1 = le1.concat(Di({
                                        key: `${vt}[${ls}]`,
                                        value: bt[ls]
                                    }));
                                    return le1;
                                }
                                return Di({
                                    key: vt,
                                    value: bt
                                });
                            },
                            variableAnchorOffsetCollection: function(le1) {
                                const vt = le1.key, bt = le1.value, ls = Xn(bt), ho = le1.styleSpec;
                                if ("array" !== ls || bt.length < 1 || bt.length % 2 != 0) return [
                                    new Dt(vt, bt, "variableAnchorOffsetCollection requires a non-empty array of even length")
                                ];
                                let Dl = [];
                                for(let Fl = 0; Fl < bt.length; Fl += 2)Dl = Dl.concat(zi({
                                    key: `${vt}[${Fl}]`,
                                    value: bt[Fl],
                                    valueSpec: ho.layout_symbol["text-anchor"]
                                })), Dl = Dl.concat(Ti({
                                    key: `${vt}[${Fl + 1}]`,
                                    value: bt[Fl + 1],
                                    valueSpec: {
                                        length: 2,
                                        value: "number"
                                    },
                                    validateSpec: le1.validateSpec,
                                    style: le1.style,
                                    styleSpec: ho
                                }));
                                return Dl;
                            },
                            sprite: Gi,
                            state: Yi,
                            fontFaces: function(le1) {
                                const vt = le1.key, bt = le1.value, ls = le1.validateSpec, ho = le1.styleSpec, Dl = le1.style;
                                if (!Xi(bt)) return [
                                    new Dt(vt, bt, `object expected, ${Xn(bt)} found`)
                                ];
                                const Fl = [];
                                for(const sc in bt){
                                    const le1 = bt[sc], uc = Xn(le1);
                                    if ("string" === uc) Fl.push(...Ri({
                                        key: `${vt}.${sc}`,
                                        value: le1
                                    }));
                                    else if ("array" === uc) {
                                        const bt = {
                                            url: {
                                                type: "string",
                                                required: !0
                                            },
                                            "unicode-range": {
                                                type: "array",
                                                value: "string"
                                            }
                                        };
                                        for (const [uc, mc] of le1.entries())Fl.push(...Ei({
                                            key: `${vt}.${sc}[${uc}]`,
                                            value: mc,
                                            valueSpec: bt,
                                            styleSpec: ho,
                                            style: Dl,
                                            validateSpec: ls
                                        }));
                                    } else Fl.push(new Dt(`${vt}.${sc}`, le1, `string or array expected, ${uc} found`));
                                }
                                return Fl;
                            }
                        };
                        function Hi(le1) {
                            const vt = le1.value, bt = le1.valueSpec, ls = le1.styleSpec;
                            return le1.validateSpec = Hi, bt.expression && Yn(Ai(vt)) ? Mi(le1) : bt.expression && ri(ki(vt)) ? Fi(le1) : bt.type && Um[bt.type] ? Um[bt.type](le1) : Ei(zt({}, le1, {
                                valueSpec: bt.type ? ls[bt.type] : bt
                            }));
                        }
                        function Ki(le1) {
                            const vt = le1.value, bt = le1.key, ls = Ri(le1);
                            return ls.length || (-1 === vt.indexOf("{fontstack}") && ls.push(new Dt(bt, vt, '"glyphs" url must include a "{fontstack}" token')), -1 === vt.indexOf("{range}") && ls.push(new Dt(bt, vt, '"glyphs" url must include a "{range}" token'))), ls;
                        }
                        function Wi(le1, vt = qd) {
                            let bt = [];
                            return bt = bt.concat(Hi({
                                key: "",
                                value: le1,
                                valueSpec: vt.$root,
                                styleSpec: vt,
                                style: le1,
                                validateSpec: Hi,
                                objectElementValidators: {
                                    glyphs: Ki,
                                    "*": ()=>[]
                                }
                            })), le1.constants && (bt = bt.concat(Si({
                                key: "constants",
                                value: le1.constants
                            }))), Qi(bt);
                        }
                        function Ji(le1) {
                            return function(vt) {
                                return le1(Object.assign({}, vt, {
                                    validateSpec: Hi
                                }));
                            };
                        }
                        function Qi(le1) {
                            return [].concat(le1).sort((le1, vt)=>le1.line - vt.line);
                        }
                        function ts(le1) {
                            return function(...vt) {
                                return Qi(le1.apply(this, vt));
                            };
                        }
                        Wi.source = ts(Ji($i)), Wi.sprite = ts(Ji(Gi)), Wi.glyphs = ts(Ji(Ki)), Wi.light = ts(Ji(Ui)), Wi.sky = ts(Ji(qi)), Wi.terrain = ts(Ji(ji)), Wi.state = ts(Ji(Yi)), Wi.layer = ts(Ji(Oi)), Wi.filter = ts(Ji(Pi)), Wi.paintProperty = ts(Ji(Ci)), Wi.layoutProperty = ts(Ji(Li));
                        const Vm = {
                            type: "enum",
                            "property-type": "data-constant",
                            expression: {
                                interpolated: !1,
                                parameters: [
                                    "global-state"
                                ]
                            },
                            values: {
                                visible: {},
                                none: {}
                            },
                            transition: !1,
                            default: "visible"
                        };
                        class rs {
                            constructor(le1, vt){
                                this._globalState = vt, this.setValue(le1);
                            }
                            evaluate() {
                                var le1;
                                return null !== (le1 = this._literalValue) && void 0 !== le1 ? le1 : this._compiledValue.evaluate({});
                            }
                            setValue(le1) {
                                if (null == le1 || "visible" === le1 || "none" === le1) return this._literalValue = "none" === le1 ? "none" : "visible", this._compiledValue = void 0, void (this._globalStateRefs = new Set);
                                const vt = ni(le1, Vm, this._globalState);
                                if ("error" === vt.result) throw this._literalValue = "visible", this._compiledValue = void 0, new Error(vt.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                                this._literalValue = void 0, this._compiledValue = vt.value, this._globalStateRefs = ui(vt.value.expression);
                            }
                            getGlobalStateRefs() {
                                return this._globalStateRefs;
                            }
                        }
                        const Gm = qd, qm = Wi, Hm = qm.light, Wm = qm.sky, Zm = qm.paintProperty, Ym = qm.layoutProperty;
                        function us(le1, vt) {
                            let bt = !1;
                            if (vt && vt.length) for (const ls of vt)le1.fire(new gt(new Error(ls.message))), bt = !0;
                            return bt;
                        }
                        class cs {
                            constructor(le1, vt, bt){
                                const ls = this.cells = [];
                                if (le1 instanceof ArrayBuffer) {
                                    this.arrayBuffer = le1;
                                    const ho = new Int32Array(this.arrayBuffer);
                                    le1 = ho[0], this.d = (vt = ho[1]) + 2 * (bt = ho[2]);
                                    for(let le1 = 0; le1 < this.d * this.d; le1++){
                                        const vt = ho[3 + le1], bt = ho[3 + le1 + 1];
                                        ls.push(vt === bt ? null : ho.subarray(vt, bt));
                                    }
                                    const Dl = ho[3 + ls.length + 1];
                                    this.keys = ho.subarray(ho[3 + ls.length], Dl), this.bboxes = ho.subarray(Dl), this.insert = this._insertReadonly;
                                } else {
                                    this.d = vt + 2 * bt;
                                    for(let le1 = 0; le1 < this.d * this.d; le1++)ls.push([]);
                                    this.keys = [], this.bboxes = [];
                                }
                                this.n = vt, this.extent = le1, this.padding = bt, this.scale = vt / le1, this.uid = 0;
                                const ho = bt / vt * le1;
                                this.min = -ho, this.max = le1 + ho;
                            }
                            insert(le1, vt, bt, ls, ho) {
                                this._forEachCell(vt, bt, ls, ho, this._insertCell, this.uid++, void 0, void 0), this.keys.push(le1), this.bboxes.push(vt), this.bboxes.push(bt), this.bboxes.push(ls), this.bboxes.push(ho);
                            }
                            _insertReadonly() {
                                throw new Error("Cannot insert into a GridIndex created from an ArrayBuffer.");
                            }
                            _insertCell(le1, vt, bt, ls, ho, Dl) {
                                this.cells[ho].push(Dl);
                            }
                            query(le1, vt, bt, ls, ho) {
                                const Dl = this.min, Fl = this.max;
                                if (le1 <= Dl && vt <= Dl && Fl <= bt && Fl <= ls && !ho) return Array.prototype.slice.call(this.keys);
                                {
                                    const Dl = [];
                                    return this._forEachCell(le1, vt, bt, ls, this._queryCell, Dl, {}, ho), Dl;
                                }
                            }
                            _queryCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = this.cells[ho];
                                if (null !== uc) {
                                    const ho = this.keys, mc = this.bboxes;
                                    for(let gc = 0; gc < uc.length; gc++){
                                        const Ac = uc[gc];
                                        if (void 0 === Fl[Ac]) {
                                            const uc = 4 * Ac;
                                            (sc ? sc(mc[uc + 0], mc[uc + 1], mc[uc + 2], mc[uc + 3]) : le1 <= mc[uc + 2] && vt <= mc[uc + 3] && bt >= mc[uc + 0] && ls >= mc[uc + 1]) ? (Fl[Ac] = !0, Dl.push(ho[Ac])) : Fl[Ac] = !1;
                                        }
                                    }
                                }
                            }
                            _forEachCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = this._convertToCellCoord(le1), mc = this._convertToCellCoord(vt), gc = this._convertToCellCoord(bt), Ac = this._convertToCellCoord(ls);
                                for(let Ec = uc; Ec <= gc; Ec++)for(let uc = mc; uc <= Ac; uc++){
                                    const mc = this.d * uc + Ec;
                                    if ((!sc || sc(this._convertFromCellCoord(Ec), this._convertFromCellCoord(uc), this._convertFromCellCoord(Ec + 1), this._convertFromCellCoord(uc + 1))) && ho.call(this, le1, vt, bt, ls, mc, Dl, Fl, sc)) return;
                                }
                            }
                            _convertFromCellCoord(le1) {
                                return (le1 - this.padding) / this.scale;
                            }
                            _convertToCellCoord(le1) {
                                return Math.max(0, Math.min(this.d - 1, Math.floor(le1 * this.scale) + this.padding));
                            }
                            toArrayBuffer() {
                                if (this.arrayBuffer) return this.arrayBuffer;
                                const le1 = this.cells, vt = 3 + this.cells.length + 1 + 1;
                                let bt = 0;
                                for(let Dl = 0; Dl < this.cells.length; Dl++)bt += this.cells[Dl].length;
                                const ls = new Int32Array(vt + bt + this.keys.length + this.bboxes.length);
                                ls[0] = this.extent, ls[1] = this.n, ls[2] = this.padding;
                                let ho = vt;
                                for(let Dl = 0; Dl < le1.length; Dl++){
                                    const vt = le1[Dl];
                                    ls[3 + Dl] = ho, ls.set(vt, ho), ho += vt.length;
                                }
                                return ls[3 + le1.length] = ho, ls.set(this.keys, ho), ho += this.keys.length, ls[3 + le1.length + 1] = ho, ls.set(this.bboxes, ho), ho += this.bboxes.length, ls.buffer;
                            }
                            static serialize(le1, vt) {
                                const bt = le1.toArrayBuffer();
                                return vt && vt.push(bt), {
                                    buffer: bt
                                };
                            }
                            static deserialize(le1) {
                                return new cs(le1.buffer);
                            }
                        }
                        const Qm = {};
                        function ps(le1, vt, bt = {}) {
                            if (Qm[le1]) throw new Error(`${le1} is already registered.`);
                            Object.defineProperty(vt, "_classRegistryKey", {
                                value: le1,
                                writeable: !1
                            }), Qm[le1] = {
                                klass: vt,
                                omit: bt.omit || [],
                                shallow: bt.shallow || []
                            };
                        }
                        ps("Object", Object), ps("Set", Set), ps("TransferableGridIndex", cs), ps("Color", Te), ps("Error", Error), ps("AJAXError", ct), ps("ResolvedImage", Oe), ps("StylePropertyFunction", oi), ps("StyleExpression", ei, {
                            omit: [
                                "_evaluator"
                            ]
                        }), ps("ZoomDependentExpression", si), ps("ZoomConstantExpression", ii), ps("CompoundExpression", zn, {
                            omit: [
                                "_evaluate"
                            ]
                        });
                        for(const HA in Om)Om[HA]._classRegistryKey || ps(`Expression_${HA}`, Om[HA]);
                        function fs(le1) {
                            return le1 && "undefined" != typeof ArrayBuffer && (le1 instanceof ArrayBuffer || le1.constructor && "ArrayBuffer" === le1.constructor.name);
                        }
                        function ds(le1) {
                            return le1.$name || le1.constructor._classRegistryKey;
                        }
                        function ys(le1) {
                            return !function(le1) {
                                if (null === le1 || "object" != typeof le1) return !1;
                                const vt = ds(le1);
                                return !(!vt || "Object" === vt);
                            }(le1) && (null == le1 || "boolean" == typeof le1 || "number" == typeof le1 || "string" == typeof le1 || le1 instanceof Boolean || le1 instanceof Number || le1 instanceof String || le1 instanceof Date || le1 instanceof RegExp || le1 instanceof Blob || le1 instanceof Error || fs(le1) || Z(le1) || ArrayBuffer.isView(le1) || le1 instanceof ImageData);
                        }
                        function ms(le1, vt) {
                            if (ys(le1)) return (fs(le1) || Z(le1)) && vt && vt.push(le1), ArrayBuffer.isView(le1) && vt && vt.push(le1.buffer), le1 instanceof ImageData && vt && vt.push(le1.data.buffer), le1;
                            if (Array.isArray(le1)) {
                                const bt = [];
                                for (const ls of le1)bt.push(ms(ls, vt));
                                return bt;
                            }
                            if ("object" != typeof le1) throw new Error("can't serialize object of type " + typeof le1);
                            const bt = ds(le1);
                            if (!bt) throw new Error(`can't serialize object of unregistered class ${le1.constructor.name}`);
                            if (!Qm[bt]) throw new Error(`${bt} is not registered.`);
                            const { klass: ls } = Qm[bt], ho = ls.serialize ? ls.serialize(le1, vt) : {};
                            if (ls.serialize) {
                                if (vt && ho === vt[vt.length - 1]) throw new Error("statically serialized object won't survive transfer of $name property");
                            } else {
                                for(const ls in le1){
                                    if (!le1.hasOwnProperty(ls)) continue;
                                    if (Qm[bt].omit.indexOf(ls) >= 0) continue;
                                    const Dl = le1[ls];
                                    ho[ls] = Qm[bt].shallow.indexOf(ls) >= 0 ? Dl : ms(Dl, vt);
                                }
                                le1 instanceof Error && (ho.message = le1.message);
                            }
                            if (ho.$name) throw new Error("$name property is reserved for worker serialization logic.");
                            return "Object" !== bt && (ho.$name = bt), ho;
                        }
                        function gs(le1) {
                            if (ys(le1)) return le1;
                            if (Array.isArray(le1)) return le1.map(gs);
                            if ("object" != typeof le1) throw new Error("can't deserialize object of type " + typeof le1);
                            const vt = ds(le1) || "Object";
                            if (!Qm[vt]) throw new Error(`can't deserialize unregistered class ${vt}`);
                            const { klass: bt } = Qm[vt];
                            if (!bt) throw new Error(`can't deserialize unregistered class ${vt}`);
                            if (bt.deserialize) return bt.deserialize(le1);
                            const ls = Object.create(bt.prototype);
                            for (const ho of Object.keys(le1)){
                                if ("$name" === ho) continue;
                                const bt = le1[ho];
                                ls[ho] = Qm[vt].shallow.indexOf(ho) >= 0 ? bt : gs(bt);
                            }
                            return ls;
                        }
                        class xs {
                            constructor(){
                                this.first = !0;
                            }
                            update(le1, vt) {
                                const bt = Math.floor(le1);
                                return this.first ? (this.first = !1, this.lastIntegerZoom = bt, this.lastIntegerZoomTime = 0, this.lastZoom = le1, this.lastFloorZoom = bt, !0) : (this.lastFloorZoom > bt ? (this.lastIntegerZoom = bt + 1, this.lastIntegerZoomTime = vt) : this.lastFloorZoom < bt && (this.lastIntegerZoom = bt, this.lastIntegerZoomTime = vt), le1 !== this.lastZoom && (this.lastZoom = le1, this.lastFloorZoom = bt, !0));
                            }
                        }
                        function vs(le1) {
                            return /[\u02EA\u02EB\u2E80-\u2FDF\u2FF0-\u303F\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FD-\u30FF\u3105-\u312F\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(le1));
                        }
                        function bs(le1) {
                            return /[\u02EA\u02EB\u1100-\u11FF\u1400-\u167F\u18B0-\u18F5\u2E80-\u2E99\u2E9B-\u2EF3\u2F00-\u2FD5\u2FF0-\u3007\u3012\u3013\u3020-\u302F\u3031-\u303F\u3041-\u3096\u309D-\u30FB\u30FD-\u30FF\u3105-\u312F\u3131-\u318E\u3190-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE48\uFE50-\uFE57\uFE5F-\uFE62\uFE67-\uFE6F\uFF00-\uFF07\uFF0A-\uFF0C\uFF0E-\uFF19\uFF1F-\uFF3A\uFF3C\uFF3E\uFF40-\uFF5A\uFFE0-\uFFE2\uFFE4-\uFFE7]|\uD802[\uDD80-\uDD9F]|\uD805[\uDD80-\uDDFF]|\uD806[\uDE00-\uDEBF]|\uD811[\uDC00-\uDE7F]|\uD81B[\uDFE0-\uDFE4\uDFF0-\uDFF6]|[\uD81C-\uD822\uD83D\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD30-\uDEFB]|\uD833[\uDEC0-\uDFCF]|\uD834[\uDC00-\uDDFF\uDEE0-\uDF7F]|\uD836[\uDC00-\uDEAF]|\uD83C[\uDC00-\uDE00\uDF00-\uDFFF]|\uD83E[\uDD00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(le1));
                        }
                        function ws(le1) {
                            return /\s/u.test(String.fromCodePoint(le1));
                        }
                        function _s(le1) {
                            for (const vt of le1)if (bs(vt.codePointAt(0))) return !0;
                            return !1;
                        }
                        function Ss(le1) {
                            for (const vt of le1)if (!Es(vt.codePointAt(0))) return !1;
                            return !0;
                        }
                        function As(le1) {
                            const vt = le1.map((le1)=>{
                                try {
                                    return new RegExp(`\\p{sc=${le1}}`, "u").source;
                                } catch (le1) {
                                    return null;
                                }
                            }).filter((le1)=>le1);
                            return new RegExp(vt.join("|"), "u");
                        }
                        const Xm = As([
                            "Arab",
                            "Dupl",
                            "Mong",
                            "Ougr",
                            "Syrc"
                        ]);
                        function Es(le1) {
                            return !Xm.test(String.fromCodePoint(le1));
                        }
                        function Ts(le1) {
                            var vt;
                            return !(bs(le1) || (vt = le1, /[\xA7\xA9\xAE\xB1\xBC-\xBE\xD7\xF7\u2016\u2020\u2021\u2030\u2031\u203B\u203C\u2042\u2047-\u2049\u2051\u2100-\u218F\u221E\u2234\u2235\u2300-\u2307\u230C-\u231F\u2324-\u2328\u232B\u237D-\u239A\u23BE-\u23CD\u23CF\u23D1-\u23DB\u23E2-\u2422\u2424-\u24FF\u25A0-\u2619\u2620-\u2767\u2776-\u2793\u2B12-\u2B2F\u2B50-\u2B59\u2BB8-\u2BEB\u3000-\u303F\u30A0-\u30FF\uE000-\uF8FF\uFE30-\uFE6F\uFF00-\uFFEF\uFFFC\uFFFD]|[\uDB80-\uDBFF][\uDC00-\uDFFF]/gim.test(String.fromCodePoint(vt))));
                        }
                        const Km = As([
                            "Adlm",
                            "Arab",
                            "Armi",
                            "Avst",
                            "Chrs",
                            "Cprt",
                            "Egyp",
                            "Elym",
                            "Gara",
                            "Hatr",
                            "Hebr",
                            "Hung",
                            "Khar",
                            "Lydi",
                            "Mand",
                            "Mani",
                            "Mend",
                            "Merc",
                            "Mero",
                            "Narb",
                            "Nbat",
                            "Nkoo",
                            "Orkh",
                            "Palm",
                            "Phli",
                            "Phlp",
                            "Phnx",
                            "Prti",
                            "Rohg",
                            "Samr",
                            "Sarb",
                            "Sogo",
                            "Syrc",
                            "Thaa",
                            "Todr",
                            "Yezi"
                        ]);
                        function Ms(le1) {
                            return Km.test(String.fromCodePoint(le1));
                        }
                        function Fs(le1, vt) {
                            return !(!vt && Ms(le1) || /[\u0900-\u0DFF\u0F00-\u109F\u1780-\u17FF]/gim.test(String.fromCodePoint(le1)));
                        }
                        function Ds(le1) {
                            for (const vt of le1)if (Ms(vt.codePointAt(0))) return !0;
                            return !1;
                        }
                        const Jm = new class {
                            constructor(){
                                this.TIMEOUT = 5e3, this.applyArabicShaping = null, this.processBidirectionalText = null, this.processStyledBidirectionalText = null, this.pluginStatus = "unavailable", this.pluginURL = null, this.loadScriptResolve = ()=>{};
                            }
                            setState(le1) {
                                this.pluginStatus = le1.pluginStatus, this.pluginURL = le1.pluginURL;
                            }
                            getState() {
                                return {
                                    pluginStatus: this.pluginStatus,
                                    pluginURL: this.pluginURL
                                };
                            }
                            setMethods(le1) {
                                if (Jm.isParsed()) throw new Error("RTL text plugin already registered.");
                                this.applyArabicShaping = le1.applyArabicShaping, this.processBidirectionalText = le1.processBidirectionalText, this.processStyledBidirectionalText = le1.processStyledBidirectionalText, this.loadScriptResolve();
                            }
                            isParsed() {
                                return null != this.applyArabicShaping && null != this.processBidirectionalText && null != this.processStyledBidirectionalText;
                            }
                            getRTLTextPluginStatus() {
                                return this.pluginStatus;
                            }
                            syncState(le1, vt) {
                                return e(this, void 0, void 0, function*() {
                                    if (this.isParsed()) return this.getState();
                                    if ("loading" !== le1.pluginStatus) return this.setState(le1), le1;
                                    const bt = le1.pluginURL, ls = new Promise((le1)=>{
                                        this.loadScriptResolve = le1;
                                    });
                                    vt(bt);
                                    const ho = new Promise((le1)=>setTimeout(()=>le1(), this.TIMEOUT));
                                    if (yield Promise.race([
                                        ls,
                                        ho
                                    ]), this.isParsed()) {
                                        const le1 = {
                                            pluginStatus: "loaded",
                                            pluginURL: bt
                                        };
                                        return this.setState(le1), le1;
                                    }
                                    throw this.setState({
                                        pluginStatus: "error",
                                        pluginURL: ""
                                    }), new Error(`RTL Text Plugin failed to import scripts from ${bt}`);
                                });
                            }
                        };
                        class Ps {
                            constructor(le1, vt){
                                this.isSupportedScript = Bs, this.zoom = le1, vt ? (this.now = vt.now || 0, this.fadeDuration = vt.fadeDuration || 0, this.zoomHistory = vt.zoomHistory || new xs, this.transition = vt.transition || {}) : (this.now = 0, this.fadeDuration = 0, this.zoomHistory = new xs, this.transition = {});
                            }
                            crossFadingFactor() {
                                return 0 === this.fadeDuration ? 1 : Math.min((this.now - this.zoomHistory.lastIntegerZoomTime) / this.fadeDuration, 1);
                            }
                            getCrossfadeParameters() {
                                const le1 = this.zoom, vt = le1 - Math.floor(le1), bt = this.crossFadingFactor();
                                return le1 > this.zoomHistory.lastIntegerZoom ? {
                                    fromScale: 2,
                                    toScale: 1,
                                    t: vt + (1 - vt) * bt
                                } : {
                                    fromScale: .5,
                                    toScale: 1,
                                    t: 1 - (1 - bt) * vt
                                };
                            }
                        }
                        function Bs(le1) {
                            return function(le1, vt) {
                                for (const bt of le1)if (!Fs(bt.codePointAt(0), vt)) return !1;
                                return !0;
                            }(le1, "loaded" === Jm.getRTLTextPluginStatus());
                        }
                        const $m = "-transition";
                        class Cs {
                            constructor(le1, vt, bt){
                                this.property = le1, this.value = vt, this.expression = function(le1, vt, bt) {
                                    if (Yn(le1)) return new oi(le1, vt);
                                    if (ri(le1)) {
                                        const ls = ai(le1, vt, bt);
                                        if ("error" === ls.result) throw new Error(ls.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                                        return ls.value;
                                    }
                                    {
                                        let bt = le1;
                                        return "color" === vt.type && "string" == typeof le1 ? bt = Te.parse(le1) : "padding" !== vt.type || "number" != typeof le1 && !Array.isArray(le1) ? "numberArray" !== vt.type || "number" != typeof le1 && !Array.isArray(le1) ? "colorArray" !== vt.type || "string" != typeof le1 && !Array.isArray(le1) ? "variableAnchorOffsetCollection" === vt.type && Array.isArray(le1) ? bt = Le.parse(le1) : "projectionDefinition" === vt.type && "string" == typeof le1 && (bt = Re.parse(le1)) : bt = Be.parse(le1) : bt = Pe.parse(le1) : bt = ze.parse(le1), {
                                            globalStateRefs: new Set,
                                            _globalState: null,
                                            kind: "constant",
                                            evaluate: ()=>bt
                                        };
                                    }
                                }(void 0 === vt ? le1.specification.default : vt, le1.specification, bt);
                            }
                            isDataDriven() {
                                return "source" === this.expression.kind || "composite" === this.expression.kind;
                            }
                            getGlobalStateRefs() {
                                return this.expression.globalStateRefs || new Set;
                            }
                            possiblyEvaluate(le1, vt, bt) {
                                return this.property.possiblyEvaluate(this, le1, vt, bt);
                            }
                        }
                        class Ls {
                            constructor(le1, vt){
                                this.property = le1, this.value = new Cs(le1, void 0, vt);
                            }
                            transitioned(le1, vt) {
                                return new Rs(this.property, this.value, vt, O({}, le1.transition, this.transition), le1.now);
                            }
                            untransitioned() {
                                return new Rs(this.property, this.value, null, {}, 0);
                            }
                        }
                        class Os {
                            constructor(le1, vt){
                                this._properties = le1, this._values = Object.create(le1.defaultTransitionablePropertyValues), this._globalState = vt;
                            }
                            getValue(le1) {
                                return U(this._values[le1].value.value);
                            }
                            setValue(le1, vt) {
                                Object.prototype.hasOwnProperty.call(this._values, le1) || (this._values[le1] = new Ls(this._values[le1].property, this._globalState)), this._values[le1].value = new Cs(this._values[le1].property, null === vt ? void 0 : U(vt), this._globalState);
                            }
                            getTransition(le1) {
                                return U(this._values[le1].transition);
                            }
                            setTransition(le1, vt) {
                                Object.prototype.hasOwnProperty.call(this._values, le1) || (this._values[le1] = new Ls(this._values[le1].property, this._globalState)), this._values[le1].transition = U(vt) || void 0;
                            }
                            serialize() {
                                const le1 = {};
                                for (const vt of Object.keys(this._values)){
                                    const bt = this.getValue(vt);
                                    void 0 !== bt && (le1[vt] = bt);
                                    const ls = this.getTransition(vt);
                                    void 0 !== ls && (le1[`${vt}${$m}`] = ls);
                                }
                                return le1;
                            }
                            transitioned(le1, vt) {
                                const bt = new Ns(this._properties);
                                for (const ls of Object.keys(this._values))bt._values[ls] = this._values[ls].transitioned(le1, vt._values[ls]);
                                return bt;
                            }
                            untransitioned() {
                                const le1 = new Ns(this._properties);
                                for (const vt of Object.keys(this._values))le1._values[vt] = this._values[vt].untransitioned();
                                return le1;
                            }
                        }
                        class Rs {
                            constructor(le1, vt, bt, ls, ho){
                                this.property = le1, this.value = vt, this.begin = ho + ls.delay || 0, this.end = this.begin + ls.duration || 0, le1.specification.transition && (ls.delay || ls.duration) && (this.prior = bt);
                            }
                            possiblyEvaluate(le1, vt, bt) {
                                const ls = le1.now || 0, ho = this.value.possiblyEvaluate(le1, vt, bt), Dl = this.prior;
                                if (Dl) {
                                    if (ls > this.end) return this.prior = null, ho;
                                    if (this.value.isDataDriven()) return this.prior = null, ho;
                                    if (ls < this.begin) return Dl.possiblyEvaluate(le1, vt, bt);
                                    {
                                        const Fl = (ls - this.begin) / (this.end - this.begin);
                                        return this.property.interpolate(Dl.possiblyEvaluate(le1, vt, bt), ho, P(Fl));
                                    }
                                }
                                return ho;
                            }
                        }
                        class Ns {
                            constructor(le1){
                                this._properties = le1, this._values = Object.create(le1.defaultTransitioningPropertyValues);
                            }
                            possiblyEvaluate(le1, vt, bt) {
                                const ls = new qs(this._properties);
                                for (const ho of Object.keys(this._values))ls._values[ho] = this._values[ho].possiblyEvaluate(le1, vt, bt);
                                return ls;
                            }
                            hasTransition() {
                                for (const le1 of Object.keys(this._values))if (this._values[le1].prior) return !0;
                                return !1;
                            }
                        }
                        class $s {
                            constructor(le1, vt){
                                this._properties = le1, this._values = Object.create(le1.defaultPropertyValues), this._globalState = vt;
                            }
                            hasValue(le1) {
                                return void 0 !== this._values[le1].value;
                            }
                            getValue(le1) {
                                return U(this._values[le1].value);
                            }
                            setValue(le1, vt) {
                                this._values[le1] = new Cs(this._values[le1].property, null === vt ? void 0 : U(vt), this._globalState);
                            }
                            serialize() {
                                const le1 = {};
                                for (const vt of Object.keys(this._values)){
                                    const bt = this.getValue(vt);
                                    void 0 !== bt && (le1[vt] = bt);
                                }
                                return le1;
                            }
                            possiblyEvaluate(le1, vt, bt) {
                                const ls = new qs(this._properties);
                                for (const ho of Object.keys(this._values))ls._values[ho] = this._values[ho].possiblyEvaluate(le1, vt, bt);
                                return ls;
                            }
                        }
                        class Us {
                            constructor(le1, vt, bt){
                                this.property = le1, this.value = vt, this.parameters = bt;
                            }
                            isConstant() {
                                return "constant" === this.value.kind;
                            }
                            constantOr(le1) {
                                return "constant" === this.value.kind ? this.value.value : le1;
                            }
                            evaluate(le1, vt, bt, ls) {
                                return this.property.evaluate(this.value, this.parameters, le1, vt, bt, ls);
                            }
                        }
                        class qs {
                            constructor(le1){
                                this._properties = le1, this._values = Object.create(le1.defaultPossiblyEvaluatedValues);
                            }
                            get(le1) {
                                return this._values[le1];
                            }
                        }
                        class js {
                            constructor(le1){
                                this.specification = le1;
                            }
                            possiblyEvaluate(le1, vt) {
                                if (le1.isDataDriven()) throw new Error("Value should not be data driven");
                                return le1.expression.evaluate(vt);
                            }
                            interpolate(le1, vt, bt) {
                                const ls = Sm[this.specification.type];
                                return ls ? ls(le1, vt, bt) : le1;
                            }
                        }
                        class Gs {
                            constructor(le1, vt){
                                this.specification = le1, this.overrides = vt;
                            }
                            possiblyEvaluate(le1, vt, bt, ls) {
                                return new Us(this, "constant" === le1.expression.kind || "camera" === le1.expression.kind ? {
                                    kind: "constant",
                                    value: le1.expression.evaluate(vt, null, {}, bt, ls)
                                } : le1.expression, vt);
                            }
                            interpolate(le1, vt, bt) {
                                if ("constant" !== le1.value.kind || "constant" !== vt.value.kind) return le1;
                                if (void 0 === le1.value.value || void 0 === vt.value.value) return new Us(this, {
                                    kind: "constant",
                                    value: void 0
                                }, le1.parameters);
                                const ls = Sm[this.specification.type];
                                if (ls) {
                                    const ho = ls(le1.value.value, vt.value.value, bt);
                                    return new Us(this, {
                                        kind: "constant",
                                        value: ho
                                    }, le1.parameters);
                                }
                                return le1;
                            }
                            evaluate(le1, vt, bt, ls, ho, Dl) {
                                return "constant" === le1.kind ? le1.value : le1.evaluate(vt, bt, ls, ho, Dl);
                            }
                        }
                        class Xs extends Gs {
                            possiblyEvaluate(le1, vt, bt, ls) {
                                if (void 0 === le1.value) return new Us(this, {
                                    kind: "constant",
                                    value: void 0
                                }, vt);
                                if ("constant" === le1.expression.kind) {
                                    const ho = le1.expression.evaluate(vt, null, {}, bt, ls), Dl = "resolvedImage" === le1.property.specification.type && "string" != typeof ho ? ho.name : ho, Fl = this._calculate(Dl, Dl, Dl, vt);
                                    return new Us(this, {
                                        kind: "constant",
                                        value: Fl
                                    }, vt);
                                }
                                if ("camera" === le1.expression.kind) {
                                    const bt = this._calculate(le1.expression.evaluate({
                                        zoom: vt.zoom - 1
                                    }), le1.expression.evaluate({
                                        zoom: vt.zoom
                                    }), le1.expression.evaluate({
                                        zoom: vt.zoom + 1
                                    }), vt);
                                    return new Us(this, {
                                        kind: "constant",
                                        value: bt
                                    }, vt);
                                }
                                return new Us(this, le1.expression, vt);
                            }
                            evaluate(le1, vt, bt, ls, ho, Dl) {
                                if ("source" === le1.kind) {
                                    const Fl = le1.evaluate(vt, bt, ls, ho, Dl);
                                    return this._calculate(Fl, Fl, Fl, vt);
                                }
                                return "composite" === le1.kind ? this._calculate(le1.evaluate({
                                    zoom: Math.floor(vt.zoom) - 1
                                }, bt, ls), le1.evaluate({
                                    zoom: Math.floor(vt.zoom)
                                }, bt, ls), le1.evaluate({
                                    zoom: Math.floor(vt.zoom) + 1
                                }, bt, ls), vt) : le1.value;
                            }
                            _calculate(le1, vt, bt, ls) {
                                return ls.zoom > ls.zoomHistory.lastIntegerZoom ? {
                                    from: le1,
                                    to: vt
                                } : {
                                    from: bt,
                                    to: vt
                                };
                            }
                            interpolate(le1) {
                                return le1;
                            }
                        }
                        class Ys {
                            constructor(le1){
                                this.specification = le1;
                            }
                            possiblyEvaluate(le1, vt, bt, ls) {
                                if (void 0 !== le1.value) {
                                    if ("constant" === le1.expression.kind) {
                                        const ho = le1.expression.evaluate(vt, null, {}, bt, ls);
                                        return this._calculate(ho, ho, ho, vt);
                                    }
                                    return this._calculate(le1.expression.evaluate(new Ps(Math.floor(vt.zoom - 1), vt)), le1.expression.evaluate(new Ps(Math.floor(vt.zoom), vt)), le1.expression.evaluate(new Ps(Math.floor(vt.zoom + 1), vt)), vt);
                                }
                            }
                            _calculate(le1, vt, bt, ls) {
                                return ls.zoom > ls.zoomHistory.lastIntegerZoom ? {
                                    from: le1,
                                    to: vt
                                } : {
                                    from: bt,
                                    to: vt
                                };
                            }
                            interpolate(le1) {
                                return le1;
                            }
                        }
                        class Zs {
                            constructor(le1){
                                this.specification = le1;
                            }
                            possiblyEvaluate(le1, vt, bt, ls) {
                                return !!le1.expression.evaluate(vt, null, {}, bt, ls);
                            }
                            interpolate() {
                                return !1;
                            }
                        }
                        class Hs {
                            constructor(le1){
                                this.properties = le1, this.defaultPropertyValues = {}, this.defaultTransitionablePropertyValues = {}, this.defaultTransitioningPropertyValues = {}, this.defaultPossiblyEvaluatedValues = {}, this.overridableProperties = [];
                                for(const vt in le1){
                                    const bt = le1[vt];
                                    bt.specification.overridable && this.overridableProperties.push(vt);
                                    const ls = this.defaultPropertyValues[vt] = new Cs(bt, void 0, void 0), ho = this.defaultTransitionablePropertyValues[vt] = new Ls(bt, void 0);
                                    this.defaultTransitioningPropertyValues[vt] = ho.untransitioned(), this.defaultPossiblyEvaluatedValues[vt] = ls.possiblyEvaluate({});
                                }
                            }
                        }
                        ps("DataDrivenProperty", Gs), ps("DataConstantProperty", js), ps("CrossFadedDataDrivenProperty", Xs), ps("CrossFadedProperty", Ys), ps("ColorRampProperty", Zs);
                        class Ks extends xt {
                            constructor(le1, vt, bt){
                                if (super(), this.id = le1.id, this.type = le1.type, this._globalState = bt, this._featureFilter = {
                                    filter: ()=>!0,
                                    needGeometry: !1,
                                    getGlobalStateRefs: ()=>new Set
                                }, this._visibilityExpression = function(le1, vt) {
                                    return new rs(le1, vt);
                                }(this.visibility, bt), "custom" !== le1.type && (this.metadata = le1.metadata, this.minzoom = le1.minzoom, this.maxzoom = le1.maxzoom, "background" !== le1.type && (this.source = le1.source, this.sourceLayer = le1["source-layer"], this.filter = le1.filter, this._featureFilter = fi(le1.filter, bt)), vt.layout && (this._unevaluatedLayout = new $s(vt.layout, bt)), vt.paint)) {
                                    this._transitionablePaint = new Os(vt.paint, bt);
                                    for(const vt in le1.paint)this.setPaintProperty(vt, le1.paint[vt], {
                                        validate: !1
                                    });
                                    for(const vt in le1.layout)this.setLayoutProperty(vt, le1.layout[vt], {
                                        validate: !1
                                    });
                                    this._transitioningPaint = this._transitionablePaint.untransitioned(), this.paint = new qs(vt.paint);
                                }
                            }
                            setFilter(le1) {
                                this.filter = le1, this._featureFilter = fi(le1, this._globalState);
                            }
                            getCrossfadeParameters() {
                                return this._crossfadeParameters;
                            }
                            getLayoutProperty(le1) {
                                return "visibility" === le1 ? this.visibility : this._unevaluatedLayout.getValue(le1);
                            }
                            getLayoutAffectingGlobalStateRefs() {
                                const le1 = new Set;
                                for (const vt of this._visibilityExpression.getGlobalStateRefs())le1.add(vt);
                                if (this._unevaluatedLayout) for(const vt in this._unevaluatedLayout._values){
                                    const bt = this._unevaluatedLayout._values[vt];
                                    for (const vt of bt.getGlobalStateRefs())le1.add(vt);
                                }
                                for (const vt of this._featureFilter.getGlobalStateRefs())le1.add(vt);
                                return le1;
                            }
                            getPaintAffectingGlobalStateRefs() {
                                var le1;
                                const vt = new globalThis.Map;
                                if (this._transitionablePaint) for(const bt in this._transitionablePaint._values){
                                    const ls = this._transitionablePaint._values[bt].value;
                                    for (const ho of ls.getGlobalStateRefs()){
                                        const Dl = null !== (le1 = vt.get(ho)) && void 0 !== le1 ? le1 : [];
                                        Dl.push({
                                            name: bt,
                                            value: ls.value
                                        }), vt.set(ho, Dl);
                                    }
                                }
                                return vt;
                            }
                            getVisibilityAffectingGlobalStateRefs() {
                                return this._visibilityExpression.getGlobalStateRefs();
                            }
                            setLayoutProperty(le1, vt, bt = {}) {
                                if (null == vt || !this._validate(Ym, `layers.${this.id}.layout.${le1}`, le1, vt, bt)) return "visibility" === le1 ? (this.visibility = vt, this._visibilityExpression.setValue(vt), void this.recalculateVisibility()) : void this._unevaluatedLayout.setValue(le1, vt);
                            }
                            getPaintProperty(le1) {
                                return le1.endsWith($m) ? this._transitionablePaint.getTransition(le1.slice(0, -11)) : this._transitionablePaint.getValue(le1);
                            }
                            setPaintProperty(le1, vt, bt = {}) {
                                if (null != vt && this._validate(Zm, `layers.${this.id}.paint.${le1}`, le1, vt, bt)) return !1;
                                if (le1.endsWith($m)) return this._transitionablePaint.setTransition(le1.slice(0, -11), vt || void 0), !1;
                                {
                                    const bt = this._transitionablePaint._values[le1], ls = "cross-faded-data-driven" === bt.property.specification["property-type"], ho = bt.value.isDataDriven(), Dl = bt.value;
                                    this._transitionablePaint.setValue(le1, vt), this._handleSpecialPaintPropertyUpdate(le1);
                                    const Fl = this._transitionablePaint._values[le1].value;
                                    return Fl.isDataDriven() || ho || ls || this._handleOverridablePaintPropertyUpdate(le1, Dl, Fl);
                                }
                            }
                            _handleSpecialPaintPropertyUpdate(le1) {}
                            _handleOverridablePaintPropertyUpdate(le1, vt, bt) {
                                return !1;
                            }
                            isHidden(le1 = this.minzoom, vt = !1) {
                                return !!(this.minzoom && le1 < (vt ? Math.floor(this.minzoom) : this.minzoom)) || !!(this.maxzoom && le1 >= this.maxzoom) || "none" === this._evaluatedVisibility;
                            }
                            updateTransitions(le1) {
                                this._transitioningPaint = this._transitionablePaint.transitioned(le1, this._transitioningPaint);
                            }
                            hasTransition() {
                                return this._transitioningPaint.hasTransition();
                            }
                            recalculateVisibility() {
                                this._evaluatedVisibility = this._visibilityExpression.evaluate();
                            }
                            recalculate(le1, vt) {
                                le1.getCrossfadeParameters && (this._crossfadeParameters = le1.getCrossfadeParameters()), this._unevaluatedLayout && (this.layout = this._unevaluatedLayout.possiblyEvaluate(le1, void 0, vt)), this.paint = this._transitioningPaint.possiblyEvaluate(le1, void 0, vt);
                            }
                            serialize() {
                                const le1 = {
                                    id: this.id,
                                    type: this.type,
                                    source: this.source,
                                    "source-layer": this.sourceLayer,
                                    metadata: this.metadata,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    filter: this.filter,
                                    layout: this._unevaluatedLayout && this._unevaluatedLayout.serialize(),
                                    paint: this._transitionablePaint && this._transitionablePaint.serialize()
                                };
                                return this.visibility && (le1.layout = le1.layout || {}, le1.layout.visibility = this.visibility), $(le1, (le1, vt)=>!(void 0 === le1 || "layout" === vt && !Object.keys(le1).length || "paint" === vt && !Object.keys(le1).length));
                            }
                            _validate(le1, vt, bt, ls, ho = {}) {
                                return (!ho || !1 !== ho.validate) && us(this, le1.call(qm, {
                                    key: vt,
                                    layerType: this.type,
                                    objectKey: bt,
                                    value: ls,
                                    styleSpec: qd,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    }
                                }));
                            }
                            is3D() {
                                return !1;
                            }
                            isTileClipped() {
                                return !1;
                            }
                            hasOffscreenPass() {
                                return !1;
                            }
                            resize() {}
                            isStateDependent() {
                                for(const le1 in this.paint._values){
                                    const vt = this.paint.get(le1);
                                    if (vt instanceof Us && qn(vt.property.specification) && ("source" === vt.value.kind || "composite" === vt.value.kind) && vt.value.isStateDependent) return !0;
                                }
                                return !1;
                            }
                        }
                        let eg;
                        var tg = {
                            get paint () {
                                return eg = eg || new Hs({
                                    "raster-opacity": new js(qd.paint_raster["raster-opacity"]),
                                    "raster-hue-rotate": new js(qd.paint_raster["raster-hue-rotate"]),
                                    "raster-brightness-min": new js(qd.paint_raster["raster-brightness-min"]),
                                    "raster-brightness-max": new js(qd.paint_raster["raster-brightness-max"]),
                                    "raster-saturation": new js(qd.paint_raster["raster-saturation"]),
                                    "raster-contrast": new js(qd.paint_raster["raster-contrast"]),
                                    "raster-resampling": new js(qd.paint_raster["raster-resampling"]),
                                    "raster-fade-duration": new js(qd.paint_raster["raster-fade-duration"])
                                });
                            }
                        };
                        class Qs extends Ks {
                            constructor(le1, vt){
                                super(le1, tg, vt);
                            }
                        }
                        const ig = {
                            Int8: Int8Array,
                            Uint8: Uint8Array,
                            Int16: Int16Array,
                            Uint16: Uint16Array,
                            Int32: Int32Array,
                            Uint32: Uint32Array,
                            Float32: Float32Array
                        };
                        class ea {
                            constructor(le1, vt){
                                this._structArray = le1, this._pos1 = vt * this.size, this._pos2 = this._pos1 / 2, this._pos4 = this._pos1 / 4, this._pos8 = this._pos1 / 8;
                            }
                        }
                        class ra {
                            constructor(){
                                this.isTransferred = !1, this.capacity = -1, this.resize(0);
                            }
                            static serialize(le1, vt) {
                                return le1._trim(), vt && (le1.isTransferred = !0, vt.push(le1.arrayBuffer)), {
                                    length: le1.length,
                                    arrayBuffer: le1.arrayBuffer
                                };
                            }
                            static deserialize(le1) {
                                const vt = Object.create(this.prototype);
                                return vt.arrayBuffer = le1.arrayBuffer, vt.length = le1.length, vt.capacity = le1.arrayBuffer.byteLength / vt.bytesPerElement, vt._refreshViews(), vt;
                            }
                            _trim() {
                                this.length !== this.capacity && (this.capacity = this.length, this.arrayBuffer = this.arrayBuffer.slice(0, this.length * this.bytesPerElement), this._refreshViews());
                            }
                            clear() {
                                this.length = 0;
                            }
                            resize(le1) {
                                this.reserve(le1), this.length = le1;
                            }
                            reserve(le1) {
                                if (le1 > this.capacity) {
                                    this.capacity = Math.max(le1, Math.floor(5 * this.capacity), 128), this.arrayBuffer = new ArrayBuffer(this.capacity * this.bytesPerElement);
                                    const vt = this.uint8;
                                    this._refreshViews(), vt && this.uint8.set(vt);
                                }
                            }
                            _refreshViews() {
                                throw new Error("_refreshViews() must be implemented by each concrete StructArray layout");
                            }
                        }
                        function na(le1, vt = 1) {
                            let bt = 0, ls = 0;
                            return {
                                members: le1.map((le1)=>{
                                    const ho = ig[le1.type].BYTES_PER_ELEMENT, Dl = bt = ia(bt, Math.max(vt, ho)), Fl = le1.components || 1;
                                    return ls = Math.max(ls, ho), bt += ho * Fl, {
                                        name: le1.name,
                                        type: le1.type,
                                        components: Fl,
                                        offset: Dl
                                    };
                                }),
                                size: ia(bt, Math.max(ls, vt)),
                                alignment: vt
                            };
                        }
                        function ia(le1, vt) {
                            return Math.ceil(le1 / vt) * vt;
                        }
                        class sa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt) {
                                const bt = this.length;
                                return this.resize(bt + 1), this.emplace(bt, le1, vt);
                            }
                            emplace(le1, vt, bt) {
                                const ls = 2 * le1;
                                return this.int16[ls + 0] = vt, this.int16[ls + 1] = bt, le1;
                            }
                        }
                        sa.prototype.bytesPerElement = 4, ps("StructArrayLayout2i4", sa);
                        class aa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt) {
                                const ls = this.length;
                                return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                            }
                            emplace(le1, vt, bt, ls) {
                                const ho = 3 * le1;
                                return this.int16[ho + 0] = vt, this.int16[ho + 1] = bt, this.int16[ho + 2] = ls, le1;
                            }
                        }
                        aa.prototype.bytesPerElement = 6, ps("StructArrayLayout3i6", aa);
                        class oa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls) {
                                const ho = this.length;
                                return this.resize(ho + 1), this.emplace(ho, le1, vt, bt, ls);
                            }
                            emplace(le1, vt, bt, ls, ho) {
                                const Dl = 4 * le1;
                                return this.int16[Dl + 0] = vt, this.int16[Dl + 1] = bt, this.int16[Dl + 2] = ls, this.int16[Dl + 3] = ho, le1;
                            }
                        }
                        oa.prototype.bytesPerElement = 8, ps("StructArrayLayout4i8", oa);
                        class la extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl) {
                                const Fl = this.length;
                                return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = 6 * le1;
                                return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.int16[sc + 2] = ls, this.int16[sc + 3] = ho, this.int16[sc + 4] = Dl, this.int16[sc + 5] = Fl, le1;
                            }
                        }
                        la.prototype.bytesPerElement = 12, ps("StructArrayLayout2i4i12", la);
                        class ua extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl) {
                                const Fl = this.length;
                                return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = 4 * le1, uc = 8 * le1;
                                return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.uint8[uc + 4] = ls, this.uint8[uc + 5] = ho, this.uint8[uc + 6] = Dl, this.uint8[uc + 7] = Fl, le1;
                            }
                        }
                        ua.prototype.bytesPerElement = 8, ps("StructArrayLayout2i4ub8", ua);
                        class ca extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt) {
                                const bt = this.length;
                                return this.resize(bt + 1), this.emplace(bt, le1, vt);
                            }
                            emplace(le1, vt, bt) {
                                const ls = 2 * le1;
                                return this.float32[ls + 0] = vt, this.float32[ls + 1] = bt, le1;
                            }
                        }
                        ca.prototype.bytesPerElement = 8, ps("StructArrayLayout2f8", ca);
                        class ha extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                                const gc = this.length;
                                return this.resize(gc + 1), this.emplace(gc, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                                const Ac = 10 * le1;
                                return this.uint16[Ac + 0] = vt, this.uint16[Ac + 1] = bt, this.uint16[Ac + 2] = ls, this.uint16[Ac + 3] = ho, this.uint16[Ac + 4] = Dl, this.uint16[Ac + 5] = Fl, this.uint16[Ac + 6] = sc, this.uint16[Ac + 7] = uc, this.uint16[Ac + 8] = mc, this.uint16[Ac + 9] = gc, le1;
                            }
                        }
                        ha.prototype.bytesPerElement = 20, ps("StructArrayLayout10ui20", ha);
                        class pa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = this.length;
                                return this.resize(uc + 1), this.emplace(uc, le1, vt, bt, ls, ho, Dl, Fl, sc);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                const mc = 8 * le1;
                                return this.uint16[mc + 0] = vt, this.uint16[mc + 1] = bt, this.uint16[mc + 2] = ls, this.uint16[mc + 3] = ho, this.uint16[mc + 4] = Dl, this.uint16[mc + 5] = Fl, this.uint16[mc + 6] = sc, this.uint16[mc + 7] = uc, le1;
                            }
                        }
                        pa.prototype.bytesPerElement = 16, ps("StructArrayLayout8ui16", pa);
                        class fa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                                const Ec = this.length;
                                return this.resize(Ec + 1), this.emplace(Ec, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                                const kc = 12 * le1;
                                return this.int16[kc + 0] = vt, this.int16[kc + 1] = bt, this.int16[kc + 2] = ls, this.int16[kc + 3] = ho, this.uint16[kc + 4] = Dl, this.uint16[kc + 5] = Fl, this.uint16[kc + 6] = sc, this.uint16[kc + 7] = uc, this.int16[kc + 8] = mc, this.int16[kc + 9] = gc, this.int16[kc + 10] = Ac, this.int16[kc + 11] = Ec, le1;
                            }
                        }
                        fa.prototype.bytesPerElement = 24, ps("StructArrayLayout4i4ui4i24", fa);
                        class da extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt) {
                                const ls = this.length;
                                return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                            }
                            emplace(le1, vt, bt, ls) {
                                const ho = 3 * le1;
                                return this.float32[ho + 0] = vt, this.float32[ho + 1] = bt, this.float32[ho + 2] = ls, le1;
                            }
                        }
                        da.prototype.bytesPerElement = 12, ps("StructArrayLayout3f12", da);
                        class ya extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1) {
                                const vt = this.length;
                                return this.resize(vt + 1), this.emplace(vt, le1);
                            }
                            emplace(le1, vt) {
                                return this.uint32[1 * le1 + 0] = vt, le1;
                            }
                        }
                        ya.prototype.bytesPerElement = 4, ps("StructArrayLayout1ul4", ya);
                        class ma extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                const mc = this.length;
                                return this.resize(mc + 1), this.emplace(mc, le1, vt, bt, ls, ho, Dl, Fl, sc, uc);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                                const gc = 10 * le1, Ac = 5 * le1;
                                return this.int16[gc + 0] = vt, this.int16[gc + 1] = bt, this.int16[gc + 2] = ls, this.int16[gc + 3] = ho, this.int16[gc + 4] = Dl, this.int16[gc + 5] = Fl, this.uint32[Ac + 3] = sc, this.uint16[gc + 8] = uc, this.uint16[gc + 9] = mc, le1;
                            }
                        }
                        ma.prototype.bytesPerElement = 20, ps("StructArrayLayout6i1ul2ui20", ma);
                        class ga extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl) {
                                const Fl = this.length;
                                return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = 6 * le1;
                                return this.int16[sc + 0] = vt, this.int16[sc + 1] = bt, this.int16[sc + 2] = ls, this.int16[sc + 3] = ho, this.int16[sc + 4] = Dl, this.int16[sc + 5] = Fl, le1;
                            }
                        }
                        ga.prototype.bytesPerElement = 12, ps("StructArrayLayout2i2i2i12", ga);
                        class xa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho) {
                                const Dl = this.length;
                                return this.resize(Dl + 1), this.emplace(Dl, le1, vt, bt, ls, ho);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl) {
                                const Fl = 4 * le1, sc = 8 * le1;
                                return this.float32[Fl + 0] = vt, this.float32[Fl + 1] = bt, this.float32[Fl + 2] = ls, this.int16[sc + 6] = ho, this.int16[sc + 7] = Dl, le1;
                            }
                        }
                        xa.prototype.bytesPerElement = 16, ps("StructArrayLayout2f1f2i16", xa);
                        class va extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl) {
                                const Fl = this.length;
                                return this.resize(Fl + 1), this.emplace(Fl, le1, vt, bt, ls, ho, Dl);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = 16 * le1, uc = 4 * le1, mc = 8 * le1;
                                return this.uint8[sc + 0] = vt, this.uint8[sc + 1] = bt, this.float32[uc + 1] = ls, this.float32[uc + 2] = ho, this.int16[mc + 6] = Dl, this.int16[mc + 7] = Fl, le1;
                            }
                        }
                        va.prototype.bytesPerElement = 16, ps("StructArrayLayout2ub2f2i16", va);
                        class ba extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt) {
                                const ls = this.length;
                                return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                            }
                            emplace(le1, vt, bt, ls) {
                                const ho = 3 * le1;
                                return this.uint16[ho + 0] = vt, this.uint16[ho + 1] = bt, this.uint16[ho + 2] = ls, le1;
                            }
                        }
                        ba.prototype.bytesPerElement = 6, ps("StructArrayLayout3ui6", ba);
                        class wa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md) {
                                const Ld = this.length;
                                return this.resize(Ld + 1), this.emplace(Ld, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld) {
                                const Nd = 24 * le1, Rd = 12 * le1, Od = 48 * le1;
                                return this.int16[Nd + 0] = vt, this.int16[Nd + 1] = bt, this.uint16[Nd + 2] = ls, this.uint16[Nd + 3] = ho, this.uint32[Rd + 2] = Dl, this.uint32[Rd + 3] = Fl, this.uint32[Rd + 4] = sc, this.uint16[Nd + 10] = uc, this.uint16[Nd + 11] = mc, this.uint16[Nd + 12] = gc, this.float32[Rd + 7] = Ac, this.float32[Rd + 8] = Ec, this.uint8[Od + 36] = kc, this.uint8[Od + 37] = du, this.uint8[Od + 38] = _u, this.uint32[Rd + 10] = Md, this.int16[Nd + 22] = Ld, le1;
                            }
                        }
                        wa.prototype.bytesPerElement = 48, ps("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48", wa);
                        class _a extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.int16 = new Int16Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd) {
                                const Yd = this.length;
                                return this.resize(Yd + 1), this.emplace(Yd, le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd);
                            }
                            emplace(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd, Wd, Zd, Yd) {
                                const Qd = 32 * le1, Xd = 16 * le1;
                                return this.int16[Qd + 0] = vt, this.int16[Qd + 1] = bt, this.int16[Qd + 2] = ls, this.int16[Qd + 3] = ho, this.int16[Qd + 4] = Dl, this.int16[Qd + 5] = Fl, this.int16[Qd + 6] = sc, this.int16[Qd + 7] = uc, this.uint16[Qd + 8] = mc, this.uint16[Qd + 9] = gc, this.uint16[Qd + 10] = Ac, this.uint16[Qd + 11] = Ec, this.uint16[Qd + 12] = kc, this.uint16[Qd + 13] = du, this.uint16[Qd + 14] = _u, this.uint16[Qd + 15] = Md, this.uint16[Qd + 16] = Ld, this.uint16[Qd + 17] = Nd, this.uint16[Qd + 18] = Rd, this.uint16[Qd + 19] = Od, this.uint16[Qd + 20] = jd, this.uint16[Qd + 21] = Ud, this.uint16[Qd + 22] = Gd, this.uint32[Xd + 12] = qd, this.float32[Xd + 13] = Hd, this.float32[Xd + 14] = Wd, this.uint16[Qd + 30] = Zd, this.uint16[Qd + 31] = Yd, le1;
                            }
                        }
                        _a.prototype.bytesPerElement = 64, ps("StructArrayLayout8i15ui1ul2f2ui64", _a);
                        class Sa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1) {
                                const vt = this.length;
                                return this.resize(vt + 1), this.emplace(vt, le1);
                            }
                            emplace(le1, vt) {
                                return this.float32[1 * le1 + 0] = vt, le1;
                            }
                        }
                        Sa.prototype.bytesPerElement = 4, ps("StructArrayLayout1f4", Sa);
                        class Aa extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt) {
                                const ls = this.length;
                                return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                            }
                            emplace(le1, vt, bt, ls) {
                                const ho = 3 * le1;
                                return this.uint16[6 * le1 + 0] = vt, this.float32[ho + 1] = bt, this.float32[ho + 2] = ls, le1;
                            }
                        }
                        Aa.prototype.bytesPerElement = 12, ps("StructArrayLayout1ui2f12", Aa);
                        class ka extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint32 = new Uint32Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt) {
                                const ls = this.length;
                                return this.resize(ls + 1), this.emplace(ls, le1, vt, bt);
                            }
                            emplace(le1, vt, bt, ls) {
                                const ho = 4 * le1;
                                return this.uint32[2 * le1 + 0] = vt, this.uint16[ho + 2] = bt, this.uint16[ho + 3] = ls, le1;
                            }
                        }
                        ka.prototype.bytesPerElement = 8, ps("StructArrayLayout1ul2ui8", ka);
                        class Ea extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt) {
                                const bt = this.length;
                                return this.resize(bt + 1), this.emplace(bt, le1, vt);
                            }
                            emplace(le1, vt, bt) {
                                const ls = 2 * le1;
                                return this.uint16[ls + 0] = vt, this.uint16[ls + 1] = bt, le1;
                            }
                        }
                        Ea.prototype.bytesPerElement = 4, ps("StructArrayLayout2ui4", Ea);
                        class Ta extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.uint16 = new Uint16Array(this.arrayBuffer);
                            }
                            emplaceBack(le1) {
                                const vt = this.length;
                                return this.resize(vt + 1), this.emplace(vt, le1);
                            }
                            emplace(le1, vt) {
                                return this.uint16[1 * le1 + 0] = vt, le1;
                            }
                        }
                        Ta.prototype.bytesPerElement = 2, ps("StructArrayLayout1ui2", Ta);
                        class Ia extends ra {
                            _refreshViews() {
                                this.uint8 = new Uint8Array(this.arrayBuffer), this.float32 = new Float32Array(this.arrayBuffer);
                            }
                            emplaceBack(le1, vt, bt, ls) {
                                const ho = this.length;
                                return this.resize(ho + 1), this.emplace(ho, le1, vt, bt, ls);
                            }
                            emplace(le1, vt, bt, ls, ho) {
                                const Dl = 4 * le1;
                                return this.float32[Dl + 0] = vt, this.float32[Dl + 1] = bt, this.float32[Dl + 2] = ls, this.float32[Dl + 3] = ho, le1;
                            }
                        }
                        Ia.prototype.bytesPerElement = 16, ps("StructArrayLayout4f16", Ia);
                        class Ma extends ea {
                            get anchorPointX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorPointY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get x1() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get y1() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get x2() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get y2() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get anchorPoint() {
                                return new r(this.anchorPointX, this.anchorPointY);
                            }
                        }
                        Ma.prototype.size = 20;
                        class Fa extends ma {
                            get(le1) {
                                return new Ma(this, le1);
                            }
                        }
                        ps("CollisionBoxArray", Fa);
                        class Da extends ea {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get glyphStartIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get numGlyphs() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                            get vertexStartIndex() {
                                return this._structArray.uint32[this._pos4 + 2];
                            }
                            get lineStartIndex() {
                                return this._structArray.uint32[this._pos4 + 3];
                            }
                            get lineLength() {
                                return this._structArray.uint32[this._pos4 + 4];
                            }
                            get segment() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get lowerSize() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get upperSize() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get lineOffsetX() {
                                return this._structArray.float32[this._pos4 + 7];
                            }
                            get lineOffsetY() {
                                return this._structArray.float32[this._pos4 + 8];
                            }
                            get writingMode() {
                                return this._structArray.uint8[this._pos1 + 36];
                            }
                            get placedOrientation() {
                                return this._structArray.uint8[this._pos1 + 37];
                            }
                            set placedOrientation(le1) {
                                this._structArray.uint8[this._pos1 + 37] = le1;
                            }
                            get hidden() {
                                return this._structArray.uint8[this._pos1 + 38];
                            }
                            set hidden(le1) {
                                this._structArray.uint8[this._pos1 + 38] = le1;
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 10];
                            }
                            set crossTileID(le1) {
                                this._structArray.uint32[this._pos4 + 10] = le1;
                            }
                            get associatedIconIndex() {
                                return this._structArray.int16[this._pos2 + 22];
                            }
                        }
                        Da.prototype.size = 48;
                        class za extends wa {
                            get(le1) {
                                return new Da(this, le1);
                            }
                        }
                        ps("PlacedSymbolArray", za);
                        class Pa extends ea {
                            get anchorX() {
                                return this._structArray.int16[this._pos2 + 0];
                            }
                            get anchorY() {
                                return this._structArray.int16[this._pos2 + 1];
                            }
                            get rightJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 2];
                            }
                            get centerJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 3];
                            }
                            get leftJustifiedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 4];
                            }
                            get verticalPlacedTextSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 5];
                            }
                            get placedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 6];
                            }
                            get verticalPlacedIconSymbolIndex() {
                                return this._structArray.int16[this._pos2 + 7];
                            }
                            get key() {
                                return this._structArray.uint16[this._pos2 + 8];
                            }
                            get textBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 9];
                            }
                            get textBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 10];
                            }
                            get verticalTextBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 11];
                            }
                            get verticalTextBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 12];
                            }
                            get iconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 13];
                            }
                            get iconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 14];
                            }
                            get verticalIconBoxStartIndex() {
                                return this._structArray.uint16[this._pos2 + 15];
                            }
                            get verticalIconBoxEndIndex() {
                                return this._structArray.uint16[this._pos2 + 16];
                            }
                            get featureIndex() {
                                return this._structArray.uint16[this._pos2 + 17];
                            }
                            get numHorizontalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 18];
                            }
                            get numVerticalGlyphVertices() {
                                return this._structArray.uint16[this._pos2 + 19];
                            }
                            get numIconVertices() {
                                return this._structArray.uint16[this._pos2 + 20];
                            }
                            get numVerticalIconVertices() {
                                return this._structArray.uint16[this._pos2 + 21];
                            }
                            get useRuntimeCollisionCircles() {
                                return this._structArray.uint16[this._pos2 + 22];
                            }
                            get crossTileID() {
                                return this._structArray.uint32[this._pos4 + 12];
                            }
                            set crossTileID(le1) {
                                this._structArray.uint32[this._pos4 + 12] = le1;
                            }
                            get textBoxScale() {
                                return this._structArray.float32[this._pos4 + 13];
                            }
                            get collisionCircleDiameter() {
                                return this._structArray.float32[this._pos4 + 14];
                            }
                            get textAnchorOffsetStartIndex() {
                                return this._structArray.uint16[this._pos2 + 30];
                            }
                            get textAnchorOffsetEndIndex() {
                                return this._structArray.uint16[this._pos2 + 31];
                            }
                        }
                        Pa.prototype.size = 64;
                        class Ba extends _a {
                            get(le1) {
                                return new Pa(this, le1);
                            }
                        }
                        ps("SymbolInstanceArray", Ba);
                        class Va extends Sa {
                            getoffsetX(le1) {
                                return this.float32[1 * le1 + 0];
                            }
                        }
                        ps("GlyphOffsetArray", Va);
                        class Ca extends aa {
                            getx(le1) {
                                return this.int16[3 * le1 + 0];
                            }
                            gety(le1) {
                                return this.int16[3 * le1 + 1];
                            }
                            gettileUnitDistanceFromAnchor(le1) {
                                return this.int16[3 * le1 + 2];
                            }
                        }
                        ps("SymbolLineVertexArray", Ca);
                        class La extends ea {
                            get textAnchor() {
                                return this._structArray.uint16[this._pos2 + 0];
                            }
                            get textOffset0() {
                                return this._structArray.float32[this._pos4 + 1];
                            }
                            get textOffset1() {
                                return this._structArray.float32[this._pos4 + 2];
                            }
                        }
                        La.prototype.size = 12;
                        class Oa extends Aa {
                            get(le1) {
                                return new La(this, le1);
                            }
                        }
                        ps("TextAnchorOffsetArray", Oa);
                        class Ra extends ea {
                            get featureIndex() {
                                return this._structArray.uint32[this._pos4 + 0];
                            }
                            get sourceLayerIndex() {
                                return this._structArray.uint16[this._pos2 + 2];
                            }
                            get bucketIndex() {
                                return this._structArray.uint16[this._pos2 + 3];
                            }
                        }
                        Ra.prototype.size = 8;
                        class Na extends ka {
                            get(le1) {
                                return new Ra(this, le1);
                            }
                        }
                        ps("FeatureIndexArray", Na);
                        class $a extends sa {
                        }
                        class Ua extends sa {
                        }
                        class qa extends sa {
                        }
                        class ja extends la {
                        }
                        class Ga extends ua {
                        }
                        class Xa extends ca {
                        }
                        class Ya extends ha {
                        }
                        class Za extends pa {
                        }
                        class Ha extends fa {
                        }
                        class Ka extends da {
                        }
                        class Wa extends ya {
                        }
                        class Ja extends ga {
                        }
                        class Qa extends va {
                        }
                        class to extends ba {
                        }
                        class eo extends Ea {
                        }
                        const ng = na([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: rg } = ng;
                        class io {
                            constructor(le1 = []){
                                this._forceNewSegmentOnNextPrepare = !1, this.segments = le1;
                            }
                            prepareSegment(le1, vt, bt, ls) {
                                const ho = this.segments[this.segments.length - 1];
                                return le1 > io.MAX_VERTEX_ARRAY_LENGTH && j(`Max vertices per segment is ${io.MAX_VERTEX_ARRAY_LENGTH}: bucket requested ${le1}. Consider using the \`fillLargeMeshArrays\` function if you require meshes with more than ${io.MAX_VERTEX_ARRAY_LENGTH} vertices.`), this._forceNewSegmentOnNextPrepare || !ho || ho.vertexLength + le1 > io.MAX_VERTEX_ARRAY_LENGTH || ho.sortKey !== ls ? this.createNewSegment(vt, bt, ls) : ho;
                            }
                            createNewSegment(le1, vt, bt) {
                                const ls = {
                                    vertexOffset: le1.length,
                                    primitiveOffset: vt.length,
                                    vertexLength: 0,
                                    primitiveLength: 0,
                                    vaos: {}
                                };
                                return void 0 !== bt && (ls.sortKey = bt), this._forceNewSegmentOnNextPrepare = !1, this.segments.push(ls), ls;
                            }
                            getOrCreateLatestSegment(le1, vt, bt) {
                                return this.prepareSegment(0, le1, vt, bt);
                            }
                            forceNewSegmentOnNextPrepare() {
                                this._forceNewSegmentOnNextPrepare = !0;
                            }
                            get() {
                                return this.segments;
                            }
                            destroy() {
                                for (const le1 of this.segments)for(const vt in le1.vaos)le1.vaos[vt].destroy();
                            }
                            static simpleSegment(le1, vt, bt, ls) {
                                return new io([
                                    {
                                        vertexOffset: le1,
                                        primitiveOffset: vt,
                                        vertexLength: bt,
                                        primitiveLength: ls,
                                        vaos: {},
                                        sortKey: 0
                                    }
                                ]);
                            }
                        }
                        function so(le1, vt) {
                            return 256 * (le1 = C(Math.floor(le1), 0, 255)) + C(Math.floor(vt), 0, 255);
                        }
                        io.MAX_VERTEX_ARRAY_LENGTH = Math.pow(2, 16) - 1, ps("SegmentVector", io);
                        const ag = na([
                            {
                                name: "a_pattern_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pattern_to",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_from",
                                components: 1,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixel_ratio_to",
                                components: 1,
                                type: "Uint16"
                            }
                        ]), sg = na([
                            {
                                name: "a_dasharray_from",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_dasharray_to",
                                components: 4,
                                type: "Uint16"
                            }
                        ]);
                        var og, lg, cg, ug = {
                            exports: {}
                        }, hg = {
                            exports: {}
                        }, dg = {
                            exports: {}
                        }, pg = function() {
                            if (cg) return ug.exports;
                            cg = 1;
                            var le1 = (og || (og = 1, hg.exports = function(le1, vt) {
                                var bt, ls, ho, Dl, Fl, sc, uc, mc;
                                for(ls = le1.length - (bt = 3 & le1.length), ho = vt, Fl = 3432918353, sc = 461845907, mc = 0; mc < ls;)uc = 255 & le1.charCodeAt(mc) | (255 & le1.charCodeAt(++mc)) << 8 | (255 & le1.charCodeAt(++mc)) << 16 | (255 & le1.charCodeAt(++mc)) << 24, ++mc, ho = 27492 + (65535 & (Dl = 5 * (65535 & (ho = (ho ^= uc = (65535 & (uc = (uc = (65535 & uc) * Fl + (((uc >>> 16) * Fl & 65535) << 16) & 4294967295) << 15 | uc >>> 17)) * sc + (((uc >>> 16) * sc & 65535) << 16) & 4294967295) << 13 | ho >>> 19)) + ((5 * (ho >>> 16) & 65535) << 16) & 4294967295)) + ((58964 + (Dl >>> 16) & 65535) << 16);
                                switch(uc = 0, bt){
                                    case 3:
                                        uc ^= (255 & le1.charCodeAt(mc + 2)) << 16;
                                    case 2:
                                        uc ^= (255 & le1.charCodeAt(mc + 1)) << 8;
                                    case 1:
                                        ho ^= uc = (65535 & (uc = (uc = (65535 & (uc ^= 255 & le1.charCodeAt(mc))) * Fl + (((uc >>> 16) * Fl & 65535) << 16) & 4294967295) << 15 | uc >>> 17)) * sc + (((uc >>> 16) * sc & 65535) << 16) & 4294967295;
                                }
                                return ho ^= le1.length, ho = 2246822507 * (65535 & (ho ^= ho >>> 16)) + ((2246822507 * (ho >>> 16) & 65535) << 16) & 4294967295, ho = 3266489909 * (65535 & (ho ^= ho >>> 13)) + ((3266489909 * (ho >>> 16) & 65535) << 16) & 4294967295, (ho ^= ho >>> 16) >>> 0;
                            }), hg.exports), vt = (lg || (lg = 1, dg.exports = function(le1, vt) {
                                for(var bt, ls = le1.length, ho = vt ^ ls, Dl = 0; ls >= 4;)bt = 1540483477 * (65535 & (bt = 255 & le1.charCodeAt(Dl) | (255 & le1.charCodeAt(++Dl)) << 8 | (255 & le1.charCodeAt(++Dl)) << 16 | (255 & le1.charCodeAt(++Dl)) << 24)) + ((1540483477 * (bt >>> 16) & 65535) << 16), ho = 1540483477 * (65535 & ho) + ((1540483477 * (ho >>> 16) & 65535) << 16) ^ (bt = 1540483477 * (65535 & (bt ^= bt >>> 24)) + ((1540483477 * (bt >>> 16) & 65535) << 16)), ls -= 4, ++Dl;
                                switch(ls){
                                    case 3:
                                        ho ^= (255 & le1.charCodeAt(Dl + 2)) << 16;
                                    case 2:
                                        ho ^= (255 & le1.charCodeAt(Dl + 1)) << 8;
                                    case 1:
                                        ho = 1540483477 * (65535 & (ho ^= 255 & le1.charCodeAt(Dl))) + ((1540483477 * (ho >>> 16) & 65535) << 16);
                                }
                                return ho = 1540483477 * (65535 & (ho ^= ho >>> 13)) + ((1540483477 * (ho >>> 16) & 65535) << 16), (ho ^= ho >>> 15) >>> 0;
                            }), dg.exports);
                            return ug.exports = le1, ug.exports.murmur3 = le1, ug.exports.murmur2 = vt, ug.exports;
                        }(), mg = n(pg);
                        class go {
                            constructor(){
                                this.ids = [], this.positions = [], this.indexed = !1;
                            }
                            add(le1, vt, bt, ls) {
                                this.ids.push(xo(le1)), this.positions.push(vt, bt, ls);
                            }
                            getPositions(le1) {
                                if (!this.indexed) throw new Error("Trying to get index, but feature positions are not indexed");
                                const vt = xo(le1);
                                let bt = 0, ls = this.ids.length - 1;
                                for(; bt < ls;){
                                    const le1 = bt + ls >> 1;
                                    this.ids[le1] >= vt ? ls = le1 : bt = le1 + 1;
                                }
                                const ho = [];
                                for(; this.ids[bt] === vt;)ho.push({
                                    index: this.positions[3 * bt],
                                    start: this.positions[3 * bt + 1],
                                    end: this.positions[3 * bt + 2]
                                }), bt++;
                                return ho;
                            }
                            static serialize(le1, vt) {
                                const bt = new Float64Array(le1.ids), ls = new Uint32Array(le1.positions);
                                return vo(bt, ls, 0, bt.length - 1), vt && vt.push(bt.buffer, ls.buffer), {
                                    ids: bt,
                                    positions: ls
                                };
                            }
                            static deserialize(le1) {
                                const vt = new go;
                                return vt.ids = le1.ids, vt.positions = le1.positions, vt.indexed = !0, vt;
                            }
                        }
                        function xo(le1) {
                            const vt = +le1;
                            return !isNaN(vt) && vt <= Number.MAX_SAFE_INTEGER ? vt : mg(String(le1));
                        }
                        function vo(le1, vt, bt, ls) {
                            for(; bt < ls;){
                                const ho = le1[bt + ls >> 1];
                                let Dl = bt - 1, Fl = ls + 1;
                                for(;;){
                                    do Dl++;
                                    while (le1[Dl] < ho);
                                    do Fl--;
                                    while (le1[Fl] > ho);
                                    if (Dl >= Fl) break;
                                    bo(le1, Dl, Fl), bo(vt, 3 * Dl, 3 * Fl), bo(vt, 3 * Dl + 1, 3 * Fl + 1), bo(vt, 3 * Dl + 2, 3 * Fl + 2);
                                }
                                Fl - bt < ls - Fl ? (vo(le1, vt, bt, Fl), bt = Fl + 1) : (vo(le1, vt, Fl + 1, ls), ls = Fl);
                            }
                        }
                        function bo(le1, vt, bt) {
                            const ls = le1[vt];
                            le1[vt] = le1[bt], le1[bt] = ls;
                        }
                        ps("FeaturePositionMap", go);
                        class wo {
                            constructor(le1, vt){
                                this.gl = le1.gl, this.location = vt;
                            }
                        }
                        class _o extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = 0;
                            }
                            set(le1) {
                                this.current !== le1 && (this.current = le1, this.gl.uniform1f(this.location, le1));
                            }
                        }
                        class So extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = [
                                    0,
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(le1) {
                                le1[0] === this.current[0] && le1[1] === this.current[1] && le1[2] === this.current[2] && le1[3] === this.current[3] || (this.current = le1, this.gl.uniform4f(this.location, le1[0], le1[1], le1[2], le1[3]));
                            }
                        }
                        class Ao extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = Te.transparent;
                            }
                            set(le1) {
                                le1.r === this.current.r && le1.g === this.current.g && le1.b === this.current.b && le1.a === this.current.a || (this.current = le1, this.gl.uniform4f(this.location, le1.r, le1.g, le1.b, le1.a));
                            }
                        }
                        const fg = new Float32Array(16);
                        function Eo(le1) {
                            return [
                                so(255 * le1.r, 255 * le1.g),
                                so(255 * le1.b, 255 * le1.a)
                            ];
                        }
                        class To {
                            constructor(le1, vt, bt){
                                this.value = le1, this.uniformNames = vt.map((le1)=>`u_${le1}`), this.type = bt;
                            }
                            setUniform(le1, vt, bt) {
                                le1.set(bt.constantOr(this.value));
                            }
                            getBinding(le1, vt, bt) {
                                return "color" === this.type ? new Ao(le1, vt) : new _o(le1, vt);
                            }
                        }
                        class Io {
                            constructor(le1, vt){
                                this.uniformNames = vt.map((le1)=>`u_${le1}`), this.patternFrom = null, this.patternTo = null, this.pixelRatioFrom = 1, this.pixelRatioTo = 1;
                            }
                            setConstantPatternPositions(le1, vt) {
                                this.pixelRatioFrom = vt.pixelRatio, this.pixelRatioTo = le1.pixelRatio, this.patternFrom = vt.tlbr, this.patternTo = le1.tlbr;
                            }
                            setConstantDashPositions(le1, vt) {
                                this.dashTo = [
                                    0,
                                    le1.y,
                                    le1.height,
                                    le1.width
                                ], this.dashFrom = [
                                    0,
                                    vt.y,
                                    vt.height,
                                    vt.width
                                ];
                            }
                            setUniform(le1, vt, bt, ls) {
                                let ho = null;
                                "u_pattern_to" === ls ? ho = this.patternTo : "u_pattern_from" === ls ? ho = this.patternFrom : "u_dasharray_to" === ls ? ho = this.dashTo : "u_dasharray_from" === ls ? ho = this.dashFrom : "u_pixel_ratio_to" === ls ? ho = this.pixelRatioTo : "u_pixel_ratio_from" === ls && (ho = this.pixelRatioFrom), null !== ho && le1.set(ho);
                            }
                            getBinding(le1, vt, bt) {
                                return "u_pattern" === bt.substr(0, 9) || "u_dasharray_" === bt.substr(0, 12) ? new So(le1, vt) : new _o(le1, vt);
                            }
                        }
                        class Mo {
                            constructor(le1, vt, bt, ls){
                                this.expression = le1, this.type = bt, this.maxValue = 0, this.paintVertexAttributes = vt.map((le1)=>({
                                        name: `a_${le1}`,
                                        type: "Float32",
                                        components: "color" === bt ? 2 : 1,
                                        offset: 0
                                    })), this.paintVertexArray = new ls;
                            }
                            populatePaintArray(le1, vt, bt) {
                                const ls = this.paintVertexArray.length, ho = this.expression.evaluate(new Ps(0, bt), vt, {}, bt.canonical, [], bt.formattedSection);
                                this.paintVertexArray.resize(le1), this._setPaintValue(ls, le1, ho);
                            }
                            updatePaintArray(le1, vt, bt, ls, ho) {
                                const Dl = this.expression.evaluate(new Ps(0, ho), bt, ls);
                                this._setPaintValue(le1, vt, Dl);
                            }
                            _setPaintValue(le1, vt, bt) {
                                if ("color" === this.type) {
                                    const ls = Eo(bt);
                                    for(let bt = le1; bt < vt; bt++)this.paintVertexArray.emplace(bt, ls[0], ls[1]);
                                } else {
                                    for(let ls = le1; ls < vt; ls++)this.paintVertexArray.emplace(ls, bt);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(bt));
                                }
                            }
                            upload(le1) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = le1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                        }
                        class Fo {
                            constructor(le1, vt, bt, ls, ho, Dl){
                                this.expression = le1, this.uniformNames = vt.map((le1)=>`u_${le1}_t`), this.type = bt, this.useIntegerZoom = ls, this.zoom = ho, this.maxValue = 0, this.paintVertexAttributes = vt.map((le1)=>({
                                        name: `a_${le1}`,
                                        type: "Float32",
                                        components: "color" === bt ? 4 : 2,
                                        offset: 0
                                    })), this.paintVertexArray = new Dl;
                            }
                            populatePaintArray(le1, vt, bt) {
                                const ls = this.expression.evaluate(new Ps(this.zoom, bt), vt, {}, bt.canonical, [], bt.formattedSection), ho = this.expression.evaluate(new Ps(this.zoom + 1, bt), vt, {}, bt.canonical, [], bt.formattedSection), Dl = this.paintVertexArray.length;
                                this.paintVertexArray.resize(le1), this._setPaintValue(Dl, le1, ls, ho);
                            }
                            updatePaintArray(le1, vt, bt, ls, ho) {
                                const Dl = this.expression.evaluate(new Ps(this.zoom, ho), bt, ls), Fl = this.expression.evaluate(new Ps(this.zoom + 1, ho), bt, ls);
                                this._setPaintValue(le1, vt, Dl, Fl);
                            }
                            _setPaintValue(le1, vt, bt, ls) {
                                if ("color" === this.type) {
                                    const ho = Eo(bt), Dl = Eo(ls);
                                    for(let bt = le1; bt < vt; bt++)this.paintVertexArray.emplace(bt, ho[0], ho[1], Dl[0], Dl[1]);
                                } else {
                                    for(let ho = le1; ho < vt; ho++)this.paintVertexArray.emplace(ho, bt, ls);
                                    this.maxValue = Math.max(this.maxValue, Math.abs(bt), Math.abs(ls));
                                }
                            }
                            upload(le1) {
                                this.paintVertexArray && this.paintVertexArray.arrayBuffer && (this.paintVertexBuffer && this.paintVertexBuffer.buffer ? this.paintVertexBuffer.updateData(this.paintVertexArray) : this.paintVertexBuffer = le1.createVertexBuffer(this.paintVertexArray, this.paintVertexAttributes, this.expression.isStateDependent));
                            }
                            destroy() {
                                this.paintVertexBuffer && this.paintVertexBuffer.destroy();
                            }
                            setUniform(le1, vt) {
                                const bt = this.useIntegerZoom ? Math.floor(vt.zoom) : vt.zoom, ls = C(this.expression.interpolationFactor(bt, this.zoom, this.zoom + 1), 0, 1);
                                le1.set(ls);
                            }
                            getBinding(le1, vt, bt) {
                                return new _o(le1, vt);
                            }
                        }
                        class Do {
                            constructor(le1, vt, bt, ls, ho, Dl){
                                this.expression = le1, this.type = vt, this.useIntegerZoom = bt, this.zoom = ls, this.layerId = Dl, this.zoomInPaintVertexArray = new ho, this.zoomOutPaintVertexArray = new ho;
                            }
                            populatePaintArray(le1, vt, bt) {
                                const ls = this.zoomInPaintVertexArray.length;
                                this.zoomInPaintVertexArray.resize(le1), this.zoomOutPaintVertexArray.resize(le1), this._setPaintValues(ls, le1, this.getPositionIds(vt), bt);
                            }
                            updatePaintArray(le1, vt, bt, ls, ho) {
                                this._setPaintValues(le1, vt, this.getPositionIds(bt), ho);
                            }
                            _setPaintValues(le1, vt, bt, ls) {
                                const ho = this.getPositions(ls);
                                if (!ho || !bt) return;
                                const Dl = ho[bt.min], Fl = ho[bt.mid], sc = ho[bt.max];
                                if (Dl && Fl && sc) for(let uc = le1; uc < vt; uc++)this.emplace(this.zoomInPaintVertexArray, uc, Fl, Dl), this.emplace(this.zoomOutPaintVertexArray, uc, Fl, sc);
                            }
                            upload(le1) {
                                if (this.zoomInPaintVertexArray && this.zoomInPaintVertexArray.arrayBuffer && this.zoomOutPaintVertexArray && this.zoomOutPaintVertexArray.arrayBuffer) {
                                    const vt = this.getVertexAttributes();
                                    this.zoomInPaintVertexBuffer = le1.createVertexBuffer(this.zoomInPaintVertexArray, vt, this.expression.isStateDependent), this.zoomOutPaintVertexBuffer = le1.createVertexBuffer(this.zoomOutPaintVertexArray, vt, this.expression.isStateDependent);
                                }
                            }
                            destroy() {
                                this.zoomOutPaintVertexBuffer && this.zoomOutPaintVertexBuffer.destroy(), this.zoomInPaintVertexBuffer && this.zoomInPaintVertexBuffer.destroy();
                            }
                        }
                        class zo extends Do {
                            getPositions(le1) {
                                return le1.imagePositions;
                            }
                            getPositionIds(le1) {
                                return le1.patterns && le1.patterns[this.layerId];
                            }
                            getVertexAttributes() {
                                return ag.members;
                            }
                            emplace(le1, vt, bt, ls) {
                                le1.emplace(vt, bt.tlbr[0], bt.tlbr[1], bt.tlbr[2], bt.tlbr[3], ls.tlbr[0], ls.tlbr[1], ls.tlbr[2], ls.tlbr[3], bt.pixelRatio, ls.pixelRatio);
                            }
                        }
                        class Po extends Do {
                            getPositions(le1) {
                                return le1.dashPositions;
                            }
                            getPositionIds(le1) {
                                return le1.dashes && le1.dashes[this.layerId];
                            }
                            getVertexAttributes() {
                                return sg.members;
                            }
                            emplace(le1, vt, bt, ls) {
                                le1.emplace(vt, 0, bt.y, bt.height, bt.width, 0, ls.y, ls.height, ls.width);
                            }
                        }
                        class Bo {
                            constructor(le1, vt, bt){
                                this.binders = {}, this._buffers = [];
                                const ls = [];
                                for(const ho in le1.paint._values){
                                    if (!bt(ho)) continue;
                                    const Dl = le1.paint.get(ho);
                                    if (!(Dl instanceof Us && qn(Dl.property.specification))) continue;
                                    const Fl = Co(ho, le1.type), sc = Dl.value, uc = Dl.property.specification.type, mc = Dl.property.useIntegerZoom, gc = Dl.property.specification["property-type"], Ac = "cross-faded" === gc || "cross-faded-data-driven" === gc;
                                    if ("constant" === sc.kind) this.binders[ho] = Ac ? new Io(sc.value, Fl) : new To(sc.value, Fl, uc), ls.push(`/u_${ho}`);
                                    else if ("source" === sc.kind || Ac) {
                                        const bt = Lo(ho, uc, "source");
                                        this.binders[ho] = Ac ? "line-dasharray" === ho ? new Po(sc, uc, mc, vt, bt, le1.id) : new zo(sc, uc, mc, vt, bt, le1.id) : new Mo(sc, Fl, uc, bt), ls.push(`/a_${ho}`);
                                    } else {
                                        const le1 = Lo(ho, uc, "composite");
                                        this.binders[ho] = new Fo(sc, Fl, uc, mc, vt, le1), ls.push(`/z_${ho}`);
                                    }
                                }
                                this.cacheKey = ls.sort().join("");
                            }
                            getMaxValue(le1) {
                                const vt = this.binders[le1];
                                return vt instanceof Mo || vt instanceof Fo ? vt.maxValue : 0;
                            }
                            populatePaintArrays(le1, vt, bt) {
                                for(const ls in this.binders){
                                    const ho = this.binders[ls];
                                    (ho instanceof Mo || ho instanceof Fo || ho instanceof Do) && ho.populatePaintArray(le1, vt, bt);
                                }
                            }
                            setConstantPatternPositions(le1, vt) {
                                for(const bt in this.binders){
                                    const ls = this.binders[bt];
                                    ls instanceof Io && ls.setConstantPatternPositions(le1, vt);
                                }
                            }
                            setConstantDashPositions(le1, vt) {
                                for(const bt in this.binders){
                                    const ls = this.binders[bt];
                                    ls instanceof Io && ls.setConstantDashPositions(le1, vt);
                                }
                            }
                            updatePaintArrays(le1, vt, bt, ls, ho) {
                                let Dl = !1;
                                for(const Fl in le1){
                                    const sc = vt.getPositions(Fl);
                                    for (const vt of sc){
                                        const sc = bt.feature(vt.index);
                                        for(const bt in this.binders){
                                            const uc = this.binders[bt];
                                            if ((uc instanceof Mo || uc instanceof Fo || uc instanceof Do) && !0 === uc.expression.isStateDependent) {
                                                const mc = ls.paint.get(bt);
                                                uc.expression = mc.value, uc.updatePaintArray(vt.start, vt.end, sc, le1[Fl], ho), Dl = !0;
                                            }
                                        }
                                    }
                                }
                                return Dl;
                            }
                            defines() {
                                const le1 = [];
                                for(const vt in this.binders){
                                    const bt = this.binders[vt];
                                    (bt instanceof To || bt instanceof Io) && le1.push(...bt.uniformNames.map((le1)=>`#define HAS_UNIFORM_${le1}`));
                                }
                                return le1;
                            }
                            getBinderAttributes() {
                                const le1 = [];
                                for(const vt in this.binders){
                                    const bt = this.binders[vt];
                                    if (bt instanceof Mo || bt instanceof Fo) for(let vt = 0; vt < bt.paintVertexAttributes.length; vt++)le1.push(bt.paintVertexAttributes[vt].name);
                                    else if (bt instanceof Do) {
                                        const vt = bt.getVertexAttributes();
                                        for (const bt of vt)le1.push(bt.name);
                                    }
                                }
                                return le1;
                            }
                            getBinderUniforms() {
                                const le1 = [];
                                for(const vt in this.binders){
                                    const bt = this.binders[vt];
                                    if (bt instanceof To || bt instanceof Io || bt instanceof Fo) for (const vt of bt.uniformNames)le1.push(vt);
                                }
                                return le1;
                            }
                            getPaintVertexBuffers() {
                                return this._buffers;
                            }
                            getUniforms(le1, vt) {
                                const bt = [];
                                for(const ls in this.binders){
                                    const ho = this.binders[ls];
                                    if (ho instanceof To || ho instanceof Io || ho instanceof Fo) {
                                        for (const Dl of ho.uniformNames)if (vt[Dl]) {
                                            const Fl = ho.getBinding(le1, vt[Dl], Dl);
                                            bt.push({
                                                name: Dl,
                                                property: ls,
                                                binding: Fl
                                            });
                                        }
                                    }
                                }
                                return bt;
                            }
                            setUniforms(le1, vt, bt, ls) {
                                for (const { name: ho, property: Dl, binding: Fl } of vt)this.binders[Dl].setUniform(Fl, ls, bt.get(Dl), ho);
                            }
                            updatePaintBuffers(le1) {
                                this._buffers = [];
                                for(const vt in this.binders){
                                    const bt = this.binders[vt];
                                    if (le1 && bt instanceof Do) {
                                        const vt = 2 === le1.fromScale ? bt.zoomInPaintVertexBuffer : bt.zoomOutPaintVertexBuffer;
                                        vt && this._buffers.push(vt);
                                    } else (bt instanceof Mo || bt instanceof Fo) && bt.paintVertexBuffer && this._buffers.push(bt.paintVertexBuffer);
                                }
                            }
                            upload(le1) {
                                for(const vt in this.binders){
                                    const bt = this.binders[vt];
                                    (bt instanceof Mo || bt instanceof Fo || bt instanceof Do) && bt.upload(le1);
                                }
                                this.updatePaintBuffers();
                            }
                            destroy() {
                                for(const le1 in this.binders){
                                    const vt = this.binders[le1];
                                    (vt instanceof Mo || vt instanceof Fo || vt instanceof Do) && vt.destroy();
                                }
                            }
                        }
                        class Vo {
                            constructor(le1, vt, bt = ()=>!0){
                                this.programConfigurations = {};
                                for (const ls of le1)this.programConfigurations[ls.id] = new Bo(ls, vt, bt);
                                this.needsUpload = !1, this._featureMap = new go, this._bufferOffset = 0;
                            }
                            populatePaintArrays(le1, vt, bt, ls) {
                                for(const ho in this.programConfigurations)this.programConfigurations[ho].populatePaintArrays(le1, vt, ls);
                                void 0 !== vt.id && this._featureMap.add(vt.id, bt, this._bufferOffset, le1), this._bufferOffset = le1, this.needsUpload = !0;
                            }
                            updatePaintArrays(le1, vt, bt, ls) {
                                for (const ho of bt)this.needsUpload = this.programConfigurations[ho.id].updatePaintArrays(le1, this._featureMap, vt, ho, ls) || this.needsUpload;
                            }
                            get(le1) {
                                return this.programConfigurations[le1];
                            }
                            upload(le1) {
                                if (this.needsUpload) {
                                    for(const vt in this.programConfigurations)this.programConfigurations[vt].upload(le1);
                                    this.needsUpload = !1;
                                }
                            }
                            destroy() {
                                for(const le1 in this.programConfigurations)this.programConfigurations[le1].destroy();
                            }
                        }
                        function Co(le1, vt) {
                            return ({
                                "text-opacity": [
                                    "opacity"
                                ],
                                "icon-opacity": [
                                    "opacity"
                                ],
                                "text-color": [
                                    "fill_color"
                                ],
                                "icon-color": [
                                    "fill_color"
                                ],
                                "text-halo-color": [
                                    "halo_color"
                                ],
                                "icon-halo-color": [
                                    "halo_color"
                                ],
                                "text-halo-blur": [
                                    "halo_blur"
                                ],
                                "icon-halo-blur": [
                                    "halo_blur"
                                ],
                                "text-halo-width": [
                                    "halo_width"
                                ],
                                "icon-halo-width": [
                                    "halo_width"
                                ],
                                "line-gap-width": [
                                    "gapwidth"
                                ],
                                "line-dasharray": [
                                    "dasharray_to",
                                    "dasharray_from"
                                ],
                                "line-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ],
                                "fill-extrusion-pattern": [
                                    "pattern_to",
                                    "pattern_from",
                                    "pixel_ratio_to",
                                    "pixel_ratio_from"
                                ]
                            })[le1] || [
                                le1.replace(`${vt}-`, "").replace(/-/g, "_")
                            ];
                        }
                        function Lo(le1, vt, bt) {
                            const ls = {
                                color: {
                                    source: ca,
                                    composite: Ia
                                },
                                number: {
                                    source: Sa,
                                    composite: ca
                                }
                            }, ho = function(le1) {
                                return ({
                                    "line-pattern": {
                                        source: Ya,
                                        composite: Ya
                                    },
                                    "fill-pattern": {
                                        source: Ya,
                                        composite: Ya
                                    },
                                    "fill-extrusion-pattern": {
                                        source: Ya,
                                        composite: Ya
                                    },
                                    "line-dasharray": {
                                        source: Za,
                                        composite: Za
                                    }
                                })[le1];
                            }(le1);
                            return ho && ho[bt] || ls[vt][bt];
                        }
                        ps("ConstantBinder", To), ps("CrossFadedConstantBinder", Io), ps("SourceExpressionBinder", Mo), ps("CrossFadedPatternBinder", zo), ps("CrossFadedDasharrayBinder", Po), ps("CompositeExpressionBinder", Fo), ps("ProgramConfiguration", Bo, {
                            omit: [
                                "_buffers"
                            ]
                        }), ps("ProgramConfigurationSet", Vo);
                        const gg = Math.pow(2, 14) - 1, Ag = -gg - 1;
                        function No(le1) {
                            const vt = Ac / le1.extent, bt = le1.loadGeometry();
                            for(let ls = 0; ls < bt.length; ls++){
                                const le1 = bt[ls];
                                for(let bt = 0; bt < le1.length; bt++){
                                    const ls = le1[bt], ho = Math.round(ls.x * vt), Dl = Math.round(ls.y * vt);
                                    ls.x = C(ho, Ag, gg), ls.y = C(Dl, Ag, gg), (ho < ls.x || ho > ls.x + 1 || Dl < ls.y || Dl > ls.y + 1) && j("Geometry exceeds allowed extent, reduce your vector tile buffer size");
                                }
                            }
                            return bt;
                        }
                        function $o(le1, vt) {
                            return {
                                type: le1.type,
                                id: le1.id,
                                properties: le1.properties,
                                geometry: vt ? No(le1) : []
                            };
                        }
                        const _g = -32768;
                        function qo(le1, vt, bt, ls, ho) {
                            le1.emplaceBack(_g + 8 * vt + ls, _g + 8 * bt + ho);
                        }
                        class jo {
                            constructor(le1){
                                this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.layoutVertexArray = new Ua, this.indexArray = new to, this.segments = new io, this.programConfigurations = new Vo(le1.layers, le1.zoom), this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                            }
                            populate(le1, vt, bt) {
                                const ls = this.layers[0], ho = [];
                                let Dl = null, Fl = !1, sc = "heatmap" === ls.type;
                                if ("circle" === ls.type) {
                                    const le1 = ls;
                                    Dl = le1.layout.get("circle-sort-key"), Fl = !Dl.isConstant(), sc = sc || "map" === le1.paint.get("circle-pitch-alignment");
                                }
                                const uc = sc ? vt.subdivisionGranularity.circle : 1;
                                for (const { feature: mc, id: gc, index: Ac, sourceLayerIndex: Ec } of le1){
                                    const le1 = this.layers[0]._featureFilter.needGeometry, vt = $o(mc, le1);
                                    if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), vt, bt)) continue;
                                    const ls = Fl ? Dl.evaluate(vt, {}, bt) : void 0, sc = {
                                        id: gc,
                                        properties: mc.properties,
                                        type: mc.type,
                                        sourceLayerIndex: Ec,
                                        index: Ac,
                                        geometry: le1 ? vt.geometry : No(mc),
                                        patterns: {},
                                        sortKey: ls
                                    };
                                    ho.push(sc);
                                }
                                Fl && ho.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                                for (const mc of ho){
                                    const { geometry: ls, index: ho, sourceLayerIndex: Dl } = mc, Fl = le1[ho].feature;
                                    this.addFeature(mc, ls, ho, bt, uc), vt.featureIndex.insert(Fl, ls, ho, Dl, this.index);
                                }
                            }
                            update(le1, vt, bt) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                    imagePositions: bt
                                });
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(le1) {
                                this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, rg), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            addFeature(le1, vt, bt, ls, ho = 1) {
                                let Dl;
                                switch(ho){
                                    case 1:
                                        Dl = [
                                            0,
                                            7
                                        ];
                                        break;
                                    case 3:
                                        Dl = [
                                            0,
                                            2,
                                            5,
                                            7
                                        ];
                                        break;
                                    case 5:
                                        Dl = [
                                            0,
                                            1,
                                            3,
                                            4,
                                            6,
                                            7
                                        ];
                                        break;
                                    case 7:
                                        Dl = [
                                            0,
                                            1,
                                            2,
                                            3,
                                            4,
                                            5,
                                            6,
                                            7
                                        ];
                                        break;
                                    default:
                                        throw new Error(`Invalid circle bucket granularity: ${ho}; valid values are 1, 3, 5, 7.`);
                                }
                                const Fl = Dl.length;
                                for (const sc of vt)for (const vt of sc){
                                    const bt = vt.x, ls = vt.y;
                                    if (bt < 0 || bt >= Ac || ls < 0 || ls >= Ac) continue;
                                    const ho = this.segments.prepareSegment(Fl * Fl, this.layoutVertexArray, this.indexArray, le1.sortKey), sc = ho.vertexLength;
                                    for(let le1 = 0; le1 < Fl; le1++)for(let vt = 0; vt < Fl; vt++)qo(this.layoutVertexArray, bt, ls, Dl[vt], Dl[le1]);
                                    for(let le1 = 0; le1 < Fl - 1; le1++)for(let vt = 0; vt < Fl - 1; vt++){
                                        const bt = sc + le1 * Fl + vt, ls = sc + (le1 + 1) * Fl + vt;
                                        this.indexArray.emplaceBack(bt, ls + 1, bt + 1), this.indexArray.emplaceBack(bt, ls, ls + 1);
                                    }
                                    ho.vertexLength += Fl * Fl, ho.primitiveLength += (Fl - 1) * (Fl - 1) * 2;
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                    imagePositions: {},
                                    canonical: ls
                                });
                            }
                        }
                        function Go(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)if (tl(vt, le1[bt])) return !0;
                            for(let bt = 0; bt < vt.length; bt++)if (tl(le1, vt[bt])) return !0;
                            return !!Ho(le1, vt);
                        }
                        function Xo(le1, vt, bt) {
                            return !!tl(le1, vt) || !!Wo(vt, le1, bt);
                        }
                        function Yo(le1, vt) {
                            if (1 === le1.length) return Qo(vt, le1[0]);
                            for(let bt = 0; bt < vt.length; bt++){
                                const ls = vt[bt];
                                for(let vt = 0; vt < ls.length; vt++)if (tl(le1, ls[vt])) return !0;
                            }
                            for(let bt = 0; bt < le1.length; bt++)if (Qo(vt, le1[bt])) return !0;
                            for(let bt = 0; bt < vt.length; bt++)if (Ho(le1, vt[bt])) return !0;
                            return !1;
                        }
                        function Zo(le1, vt, bt) {
                            if (le1.length > 1) {
                                if (Ho(le1, vt)) return !0;
                                for(let ls = 0; ls < vt.length; ls++)if (Wo(vt[ls], le1, bt)) return !0;
                            }
                            for(let ls = 0; ls < le1.length; ls++)if (Wo(le1[ls], vt, bt)) return !0;
                            return !1;
                        }
                        function Ho(le1, vt) {
                            if (0 === le1.length || 0 === vt.length) return !1;
                            for(let bt = 0; bt < le1.length - 1; bt++){
                                const ls = le1[bt], ho = le1[bt + 1];
                                for(let le1 = 0; le1 < vt.length - 1; le1++)if (Ko(ls, ho, vt[le1], vt[le1 + 1])) return !0;
                            }
                            return !1;
                        }
                        function Ko(le1, vt, bt, ls) {
                            return G(le1, bt, ls) !== G(vt, bt, ls) && G(le1, vt, bt) !== G(le1, vt, ls);
                        }
                        function Wo(le1, vt, bt) {
                            const ls = bt * bt;
                            if (1 === vt.length) return le1.distSqr(vt[0]) < ls;
                            for(let ho = 1; ho < vt.length; ho++)if (Jo(le1, vt[ho - 1], vt[ho]) < ls) return !0;
                            return !1;
                        }
                        function Jo(le1, vt, bt) {
                            const ls = vt.distSqr(bt);
                            if (0 === ls) return le1.distSqr(vt);
                            const ho = ((le1.x - vt.x) * (bt.x - vt.x) + (le1.y - vt.y) * (bt.y - vt.y)) / ls;
                            return le1.distSqr(ho < 0 ? vt : ho > 1 ? bt : bt.sub(vt)._mult(ho)._add(vt));
                        }
                        function Qo(le1, vt) {
                            let bt, ls, ho, Dl = !1;
                            for(let Fl = 0; Fl < le1.length; Fl++){
                                bt = le1[Fl];
                                for(let le1 = 0, Fl = bt.length - 1; le1 < bt.length; Fl = le1++)ls = bt[le1], ho = bt[Fl], ls.y > vt.y != ho.y > vt.y && vt.x < (ho.x - ls.x) * (vt.y - ls.y) / (ho.y - ls.y) + ls.x && (Dl = !Dl);
                            }
                            return Dl;
                        }
                        function tl(le1, vt) {
                            let bt = !1;
                            for(let ls = 0, ho = le1.length - 1; ls < le1.length; ho = ls++){
                                const Dl = le1[ls], Fl = le1[ho];
                                Dl.y > vt.y != Fl.y > vt.y && vt.x < (Fl.x - Dl.x) * (vt.y - Dl.y) / (Fl.y - Dl.y) + Dl.x && (bt = !bt);
                            }
                            return bt;
                        }
                        function el(le1, vt, bt) {
                            const ls = bt[0], ho = bt[2];
                            if (le1.x < ls.x && vt.x < ls.x || le1.x > ho.x && vt.x > ho.x || le1.y < ls.y && vt.y < ls.y || le1.y > ho.y && vt.y > ho.y) return !1;
                            const Dl = G(le1, vt, bt[0]);
                            return Dl !== G(le1, vt, bt[1]) || Dl !== G(le1, vt, bt[2]) || Dl !== G(le1, vt, bt[3]);
                        }
                        function rl(le1, vt, bt) {
                            const ls = vt.paint.get(le1).value;
                            return "constant" === ls.kind ? ls.value : bt.programConfigurations.get(vt.id).getMaxValue(le1);
                        }
                        function nl(le1) {
                            return Math.sqrt(le1[0] * le1[0] + le1[1] * le1[1]);
                        }
                        function il(le1, vt, bt, ls, ho) {
                            if (!vt[0] && !vt[1]) return le1;
                            const Dl = r.convert(vt)._mult(ho);
                            "viewport" === bt && Dl._rotate(-ls);
                            const Fl = [];
                            for(let sc = 0; sc < le1.length; sc++)Fl.push(le1[sc].sub(Dl));
                            return Fl;
                        }
                        function sl(le1) {
                            const vt = [];
                            for(let bt = 0; bt < le1.length; bt++){
                                const ls = le1[bt], ho = vt.at(-1);
                                (0 === bt || ho && !ls.equals(ho)) && vt.push(ls);
                            }
                            return vt;
                        }
                        function al({ queryGeometry: le1, size: vt }, bt) {
                            return Xo(le1, bt, vt);
                        }
                        function ol({ queryGeometry: le1, size: vt, transform: bt, unwrappedTileID: ls, getElevation: ho }, Dl) {
                            return Xo(le1, Dl, vt * (bt.projectTileCoordinates(Dl.x, Dl.y, ls, ho).signedDistanceFromCamera / bt.cameraToCenterDistance));
                        }
                        function ll({ queryGeometry: le1, size: vt, transform: bt, unwrappedTileID: ls, getElevation: ho }, Dl) {
                            const Fl = bt.projectTileCoordinates(Dl.x, Dl.y, ls, ho).signedDistanceFromCamera, sc = vt * (bt.cameraToCenterDistance / Fl);
                            return Xo(le1, hl(Dl, bt, ls, ho), sc);
                        }
                        function ul({ queryGeometry: le1, size: vt, transform: bt, unwrappedTileID: ls, getElevation: ho }, Dl) {
                            return Xo(le1, hl(Dl, bt, ls, ho), vt);
                        }
                        function cl({ queryGeometry: le1, size: vt, transform: bt, unwrappedTileID: ls, getElevation: ho, pitchAlignment: Dl = "map", pitchScale: Fl = "map" }, sc) {
                            const uc = "map" === Dl ? "map" === Fl ? al : ol : "map" === Fl ? ll : ul, mc = {
                                queryGeometry: le1,
                                size: vt,
                                transform: bt,
                                unwrappedTileID: ls,
                                getElevation: ho
                            };
                            for (const gc of sc)for (const le1 of gc)if (uc(mc, le1)) return !0;
                            return !1;
                        }
                        function hl(le1, vt, bt, ls) {
                            const ho = vt.projectTileCoordinates(le1.x, le1.y, bt, ls).point;
                            return new r((.5 * ho.x + .5) * vt.width, (.5 * -ho.y + .5) * vt.height);
                        }
                        let yg, vg;
                        ps("CircleBucket", jo, {
                            omit: [
                                "layers"
                            ]
                        });
                        var xg = {
                            get paint () {
                                return vg = vg || new Hs({
                                    "circle-radius": new Gs(qd.paint_circle["circle-radius"]),
                                    "circle-color": new Gs(qd.paint_circle["circle-color"]),
                                    "circle-blur": new Gs(qd.paint_circle["circle-blur"]),
                                    "circle-opacity": new Gs(qd.paint_circle["circle-opacity"]),
                                    "circle-translate": new js(qd.paint_circle["circle-translate"]),
                                    "circle-translate-anchor": new js(qd.paint_circle["circle-translate-anchor"]),
                                    "circle-pitch-scale": new js(qd.paint_circle["circle-pitch-scale"]),
                                    "circle-pitch-alignment": new js(qd.paint_circle["circle-pitch-alignment"]),
                                    "circle-stroke-width": new Gs(qd.paint_circle["circle-stroke-width"]),
                                    "circle-stroke-color": new Gs(qd.paint_circle["circle-stroke-color"]),
                                    "circle-stroke-opacity": new Gs(qd.paint_circle["circle-stroke-opacity"])
                                });
                            },
                            get layout () {
                                return yg = yg || new Hs({
                                    "circle-sort-key": new Gs(qd.layout_circle["circle-sort-key"])
                                });
                            }
                        };
                        class yl extends Ks {
                            constructor(le1, vt){
                                super(le1, xg, vt);
                            }
                            createBucket(le1) {
                                return new jo(le1);
                            }
                            queryRadius(le1) {
                                const vt = le1;
                                return rl("circle-radius", this, vt) + rl("circle-stroke-width", this, vt) + nl(this.paint.get("circle-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: le1, feature: vt, featureState: bt, geometry: ls, transform: ho, pixelsToTileUnits: Dl, unwrappedTileID: Fl, getElevation: sc }) {
                                const uc = il(le1, this.paint.get("circle-translate"), this.paint.get("circle-translate-anchor"), -ho.bearingInRadians, Dl), mc = this.paint.get("circle-radius").evaluate(vt, bt) + this.paint.get("circle-stroke-width").evaluate(vt, bt), gc = this.paint.get("circle-pitch-scale"), Ac = this.paint.get("circle-pitch-alignment");
                                let Ec, kc;
                                return "map" === Ac ? (Ec = uc, kc = mc * Dl) : (Ec = function(le1, vt, bt, ls) {
                                    return le1.map((le1)=>hl(le1, vt, bt, ls));
                                }(uc, ho, Fl, sc), kc = mc), cl({
                                    queryGeometry: Ec,
                                    size: kc,
                                    transform: ho,
                                    unwrappedTileID: Fl,
                                    getElevation: sc,
                                    pitchAlignment: Ac,
                                    pitchScale: gc
                                }, ls);
                            }
                        }
                        class ml extends jo {
                        }
                        let bg;
                        ps("HeatmapBucket", ml, {
                            omit: [
                                "layers"
                            ]
                        });
                        var wg = {
                            get paint () {
                                return bg = bg || new Hs({
                                    "heatmap-radius": new Gs(qd.paint_heatmap["heatmap-radius"]),
                                    "heatmap-weight": new Gs(qd.paint_heatmap["heatmap-weight"]),
                                    "heatmap-intensity": new js(qd.paint_heatmap["heatmap-intensity"]),
                                    "heatmap-color": new Zs(qd.paint_heatmap["heatmap-color"]),
                                    "heatmap-opacity": new js(qd.paint_heatmap["heatmap-opacity"])
                                });
                            }
                        };
                        function vl(le1, { width: vt, height: bt }, ls, ho) {
                            if (ho) {
                                if (ho instanceof Uint8ClampedArray) ho = new Uint8Array(ho.buffer);
                                else if (ho.length !== vt * bt * ls) throw new RangeError(`mismatched image size. expected: ${ho.length} but got: ${vt * bt * ls}`);
                            } else ho = new Uint8Array(vt * bt * ls);
                            return le1.width = vt, le1.height = bt, le1.data = ho, le1;
                        }
                        function bl(le1, { width: vt, height: bt }, ls) {
                            if (vt === le1.width && bt === le1.height) return;
                            const ho = vl({}, {
                                width: vt,
                                height: bt
                            }, ls);
                            wl(le1, ho, {
                                x: 0,
                                y: 0
                            }, {
                                x: 0,
                                y: 0
                            }, {
                                width: Math.min(le1.width, vt),
                                height: Math.min(le1.height, bt)
                            }, ls), le1.width = vt, le1.height = bt, le1.data = ho.data;
                        }
                        function wl(le1, vt, bt, ls, ho, Dl) {
                            if (0 === ho.width || 0 === ho.height) return vt;
                            if (ho.width > le1.width || ho.height > le1.height || bt.x > le1.width - ho.width || bt.y > le1.height - ho.height) throw new RangeError("out of range source coordinates for image copy");
                            if (ho.width > vt.width || ho.height > vt.height || ls.x > vt.width - ho.width || ls.y > vt.height - ho.height) throw new RangeError("out of range destination coordinates for image copy");
                            const Fl = le1.data, sc = vt.data;
                            if (Fl === sc) throw new Error("srcData equals dstData, so image is already copied");
                            for(let uc = 0; uc < ho.height; uc++){
                                const mc = ((bt.y + uc) * le1.width + bt.x) * Dl, gc = ((ls.y + uc) * vt.width + ls.x) * Dl;
                                for(let le1 = 0; le1 < ho.width * Dl; le1++)sc[gc + le1] = Fl[mc + le1];
                            }
                            return vt;
                        }
                        class _l {
                            constructor(le1, vt){
                                vl(this, le1, 1, vt);
                            }
                            resize(le1) {
                                bl(this, le1, 1);
                            }
                            clone() {
                                return new _l({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(le1, vt, bt, ls, ho) {
                                wl(le1, vt, bt, ls, ho, 1);
                            }
                        }
                        class Sl {
                            constructor(le1, vt){
                                vl(this, le1, 4, vt);
                            }
                            resize(le1) {
                                bl(this, le1, 4);
                            }
                            replace(le1, vt) {
                                vt ? this.data.set(le1) : this.data = le1 instanceof Uint8ClampedArray ? new Uint8Array(le1.buffer) : le1;
                            }
                            clone() {
                                return new Sl({
                                    width: this.width,
                                    height: this.height
                                }, new Uint8Array(this.data));
                            }
                            static copy(le1, vt, bt, ls, ho) {
                                wl(le1, vt, bt, ls, ho, 4);
                            }
                            setPixel(le1, vt, bt) {
                                const ls = 4 * (le1 * this.width + vt);
                                this.data[ls + 0] = Math.round(255 * bt.r / bt.a), this.data[ls + 1] = Math.round(255 * bt.g / bt.a), this.data[ls + 2] = Math.round(255 * bt.b / bt.a), this.data[ls + 3] = Math.round(255 * bt.a);
                            }
                        }
                        function Al(le1) {
                            const vt = {}, bt = le1.resolution || 256, ls = le1.clips ? le1.clips.length : 1, ho = le1.image || new Sl({
                                width: bt,
                                height: ls
                            });
                            if (Math.log(bt) / Math.LN2 % 1 != 0) throw new Error(`width is not a power of 2 - ${bt}`);
                            const s = (ls, Dl, Fl)=>{
                                vt[le1.evaluationKey] = Fl;
                                const sc = le1.expression.evaluate(vt);
                                ho.setPixel(ls / 4 / bt, Dl / 4, sc);
                            };
                            if (le1.clips) for(let Dl = 0, Fl = 0; Dl < ls; ++Dl, Fl += 4 * bt)for(let vt = 0, ls = 0; vt < bt; vt++, ls += 4){
                                const ho = vt / (bt - 1), { start: sc, end: uc } = le1.clips[Dl];
                                s(Fl, ls, sc * (1 - ho) + uc * ho);
                            }
                            else for(let Dl = 0, Fl = 0; Dl < bt; Dl++, Fl += 4)s(0, Fl, Dl / (bt - 1));
                            return ho;
                        }
                        ps("AlphaImage", _l), ps("RGBAImage", Sl);
                        const Eg = "big-fb";
                        class El extends Ks {
                            createBucket(le1) {
                                return new ml(le1);
                            }
                            constructor(le1, vt){
                                super(le1, wg, vt), this.heatmapFbos = new Map, this._updateColorRamp();
                            }
                            _handleSpecialPaintPropertyUpdate(le1) {
                                "heatmap-color" === le1 && this._updateColorRamp();
                            }
                            _updateColorRamp() {
                                this.colorRamp = Al({
                                    expression: this._transitionablePaint._values["heatmap-color"].value.expression,
                                    evaluationKey: "heatmapDensity",
                                    image: this.colorRamp
                                }), this.colorRampTexture = null;
                            }
                            resize() {
                                this.heatmapFbos.has(Eg) && this.heatmapFbos.delete(Eg);
                            }
                            queryRadius(le1) {
                                return rl("heatmap-radius", this, le1);
                            }
                            queryIntersectsFeature({ queryGeometry: le1, feature: vt, featureState: bt, geometry: ls, transform: ho, pixelsToTileUnits: Dl, unwrappedTileID: Fl, getElevation: sc }) {
                                return cl({
                                    queryGeometry: le1,
                                    size: this.paint.get("heatmap-radius").evaluate(vt, bt) * Dl,
                                    transform: ho,
                                    unwrappedTileID: Fl,
                                    getElevation: sc
                                }, ls);
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("heatmap-opacity") && !this.isHidden();
                            }
                        }
                        let Mg;
                        var Sg = {
                            get paint () {
                                return Mg = Mg || new Hs({
                                    "hillshade-illumination-direction": new js(qd.paint_hillshade["hillshade-illumination-direction"]),
                                    "hillshade-illumination-altitude": new js(qd.paint_hillshade["hillshade-illumination-altitude"]),
                                    "hillshade-illumination-anchor": new js(qd.paint_hillshade["hillshade-illumination-anchor"]),
                                    "hillshade-exaggeration": new js(qd.paint_hillshade["hillshade-exaggeration"]),
                                    "hillshade-shadow-color": new js(qd.paint_hillshade["hillshade-shadow-color"]),
                                    "hillshade-highlight-color": new js(qd.paint_hillshade["hillshade-highlight-color"]),
                                    "hillshade-accent-color": new js(qd.paint_hillshade["hillshade-accent-color"]),
                                    "hillshade-method": new js(qd.paint_hillshade["hillshade-method"])
                                });
                            }
                        };
                        class Ml extends Ks {
                            constructor(le1, vt){
                                super(le1, Sg, vt), this.recalculate({
                                    zoom: 0,
                                    zoomHistory: {}
                                }, void 0);
                            }
                            getIlluminationProperties() {
                                let le1 = this.paint.get("hillshade-illumination-direction").values, vt = this.paint.get("hillshade-illumination-altitude").values, bt = this.paint.get("hillshade-highlight-color").values, ls = this.paint.get("hillshade-shadow-color").values;
                                const ho = Math.max(le1.length, vt.length, bt.length, ls.length);
                                le1 = le1.concat(Array(ho - le1.length).fill(le1.at(-1))), vt = vt.concat(Array(ho - vt.length).fill(vt.at(-1))), bt = bt.concat(Array(ho - bt.length).fill(bt.at(-1))), ls = ls.concat(Array(ho - ls.length).fill(ls.at(-1)));
                                const Dl = vt.map(tt);
                                return {
                                    directionRadians: le1.map(tt),
                                    altitudeRadians: Dl,
                                    shadowColor: ls,
                                    highlightColor: bt
                                };
                            }
                            hasOffscreenPass() {
                                return 0 !== this.paint.get("hillshade-exaggeration") && !this.isHidden();
                            }
                        }
                        let Tg;
                        var kg = {
                            get paint () {
                                return Tg = Tg || new Hs({
                                    "color-relief-opacity": new js(qd["paint_color-relief"]["color-relief-opacity"]),
                                    "color-relief-color": new Zs(qd["paint_color-relief"]["color-relief-color"])
                                });
                            }
                        };
                        class zl {
                            constructor(le1, vt, bt, ls){
                                this.context = le1, this.format = bt, this.texture = le1.gl.createTexture(), this.update(vt, ls);
                            }
                            update(le1, vt, bt) {
                                const { width: ls, height: ho } = le1, Dl = !(this.size && this.size[0] === ls && this.size[1] === ho || bt), { context: Fl } = this, { gl: sc } = Fl;
                                if (this.useMipmap = Boolean(vt && vt.useMipmap), sc.bindTexture(sc.TEXTURE_2D, this.texture), Fl.pixelStoreUnpackFlipY.set(!1), Fl.pixelStoreUnpack.set(1), Fl.pixelStoreUnpackPremultiplyAlpha.set(this.format === sc.RGBA && (!vt || !1 !== vt.premultiply)), Dl) this.size = [
                                    ls,
                                    ho
                                ], le1 instanceof HTMLImageElement || le1 instanceof HTMLCanvasElement || le1 instanceof HTMLVideoElement || le1 instanceof ImageData || Z(le1) ? sc.texImage2D(sc.TEXTURE_2D, 0, this.format, this.format, sc.UNSIGNED_BYTE, le1) : sc.texImage2D(sc.TEXTURE_2D, 0, this.format, ls, ho, 0, this.format, sc.UNSIGNED_BYTE, le1.data);
                                else {
                                    const { x: vt, y: Dl } = bt || {
                                        x: 0,
                                        y: 0
                                    };
                                    le1 instanceof HTMLImageElement || le1 instanceof HTMLCanvasElement || le1 instanceof HTMLVideoElement || le1 instanceof ImageData || Z(le1) ? sc.texSubImage2D(sc.TEXTURE_2D, 0, vt, Dl, sc.RGBA, sc.UNSIGNED_BYTE, le1) : sc.texSubImage2D(sc.TEXTURE_2D, 0, vt, Dl, ls, ho, sc.RGBA, sc.UNSIGNED_BYTE, le1.data);
                                }
                                this.useMipmap && this.isSizePowerOfTwo() && sc.generateMipmap(sc.TEXTURE_2D), Fl.pixelStoreUnpackFlipY.setDefault(), Fl.pixelStoreUnpack.setDefault(), Fl.pixelStoreUnpackPremultiplyAlpha.setDefault();
                            }
                            bind(le1, vt, bt) {
                                const { context: ls } = this, { gl: ho } = ls;
                                ho.bindTexture(ho.TEXTURE_2D, this.texture), bt !== ho.LINEAR_MIPMAP_NEAREST || this.isSizePowerOfTwo() || (bt = ho.LINEAR), le1 !== this.filter && (ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_MAG_FILTER, le1), ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_MIN_FILTER, bt || le1), this.filter = le1), vt !== this.wrap && (ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_WRAP_S, vt), ho.texParameteri(ho.TEXTURE_2D, ho.TEXTURE_WRAP_T, vt), this.wrap = vt);
                            }
                            isSizePowerOfTwo() {
                                return this.size[0] === this.size[1] && Math.log(this.size[0]) / Math.LN2 % 1 == 0;
                            }
                            destroy() {
                                const { gl: le1 } = this.context;
                                le1.deleteTexture(this.texture), this.texture = null;
                            }
                        }
                        class Pl {
                            constructor(le1, vt, bt, ls = 1, ho = 1, Dl = 1, Fl = 0){
                                if (this.uid = le1, vt.height !== vt.width) throw new RangeError("DEM tiles must be square");
                                if (bt && ![
                                    "mapbox",
                                    "terrarium",
                                    "custom"
                                ].includes(bt)) return void j(`"${bt}" is not a valid encoding type. Valid types include "mapbox", "terrarium" and "custom".`);
                                this.stride = vt.height;
                                const sc = this.dim = vt.height - 2;
                                switch(this.data = new Uint32Array(vt.data.buffer), bt){
                                    case "terrarium":
                                        this.redFactor = 256, this.greenFactor = 1, this.blueFactor = 1 / 256, this.baseShift = 32768;
                                        break;
                                    case "custom":
                                        this.redFactor = ls, this.greenFactor = ho, this.blueFactor = Dl, this.baseShift = Fl;
                                        break;
                                    default:
                                        this.redFactor = 6553.6, this.greenFactor = 25.6, this.blueFactor = .1, this.baseShift = 1e4;
                                }
                                for(let uc = 0; uc < sc; uc++)this.data[this._idx(-1, uc)] = this.data[this._idx(0, uc)], this.data[this._idx(sc, uc)] = this.data[this._idx(sc - 1, uc)], this.data[this._idx(uc, -1)] = this.data[this._idx(uc, 0)], this.data[this._idx(uc, sc)] = this.data[this._idx(uc, sc - 1)];
                                this.data[this._idx(-1, -1)] = this.data[this._idx(0, 0)], this.data[this._idx(sc, -1)] = this.data[this._idx(sc - 1, 0)], this.data[this._idx(-1, sc)] = this.data[this._idx(0, sc - 1)], this.data[this._idx(sc, sc)] = this.data[this._idx(sc - 1, sc - 1)], this.min = Number.MAX_SAFE_INTEGER, this.max = Number.MIN_SAFE_INTEGER;
                                for(let uc = 0; uc < sc; uc++)for(let le1 = 0; le1 < sc; le1++){
                                    const vt = this.get(uc, le1);
                                    vt > this.max && (this.max = vt), vt < this.min && (this.min = vt);
                                }
                            }
                            get(le1, vt) {
                                const bt = new Uint8Array(this.data.buffer), ls = 4 * this._idx(le1, vt);
                                return this.unpack(bt[ls], bt[ls + 1], bt[ls + 2]);
                            }
                            getUnpackVector() {
                                return [
                                    this.redFactor,
                                    this.greenFactor,
                                    this.blueFactor,
                                    this.baseShift
                                ];
                            }
                            _idx(le1, vt) {
                                if (le1 < -1 || le1 >= this.dim + 1 || vt < -1 || vt >= this.dim + 1) throw new RangeError(`Out of range source coordinates for DEM data. x: ${le1}, y: ${vt}, dim: ${this.dim}`);
                                return (vt + 1) * this.stride + (le1 + 1);
                            }
                            unpack(le1, vt, bt) {
                                return le1 * this.redFactor + vt * this.greenFactor + bt * this.blueFactor - this.baseShift;
                            }
                            pack(le1) {
                                return Bl(le1, this.getUnpackVector());
                            }
                            getPixels() {
                                return new Sl({
                                    width: this.stride,
                                    height: this.stride
                                }, new Uint8Array(this.data.buffer));
                            }
                            backfillBorder(le1, vt, bt) {
                                if (this.dim !== le1.dim) throw new Error("dem dimension mismatch");
                                let ls = vt * this.dim, ho = vt * this.dim + this.dim, Dl = bt * this.dim, Fl = bt * this.dim + this.dim;
                                switch(vt){
                                    case -1:
                                        ls = ho - 1;
                                        break;
                                    case 1:
                                        ho = ls + 1;
                                }
                                switch(bt){
                                    case -1:
                                        Dl = Fl - 1;
                                        break;
                                    case 1:
                                        Fl = Dl + 1;
                                }
                                const sc = -vt * this.dim, uc = -bt * this.dim;
                                for(let mc = Dl; mc < Fl; mc++)for(let vt = ls; vt < ho; vt++)this.data[this._idx(vt, mc)] = le1.data[this._idx(vt + sc, mc + uc)];
                            }
                        }
                        function Bl(le1, vt) {
                            const bt = vt[0], ls = vt[1], ho = vt[2], Dl = vt[3], Fl = Math.min(bt, ls, ho), sc = Math.round((le1 + Dl) / Fl);
                            return {
                                r: Math.floor(sc * Fl / bt) % 256,
                                g: Math.floor(sc * Fl / ls) % 256,
                                b: Math.floor(sc * Fl / ho) % 256
                            };
                        }
                        ps("DEMData", Pl);
                        class Vl extends Ks {
                            constructor(le1, vt){
                                super(le1, kg, vt);
                            }
                            _createColorRamp(le1) {
                                const vt = {
                                    elevationStops: [],
                                    colorStops: []
                                }, bt = this._transitionablePaint._values["color-relief-color"].value.expression;
                                if (bt instanceof ii && bt._styleExpression.expression instanceof fr) {
                                    this.colorRampExpression = bt;
                                    const le1 = bt._styleExpression.expression;
                                    vt.elevationStops = le1.labels, vt.colorStops = [];
                                    for (const bt of vt.elevationStops)vt.colorStops.push(le1.evaluate({
                                        globals: {
                                            elevation: bt
                                        }
                                    }));
                                }
                                if (vt.elevationStops.length < 1 && (vt.elevationStops = [
                                    0
                                ], vt.colorStops = [
                                    Te.transparent
                                ]), vt.elevationStops.length < 2 && (vt.elevationStops.push(vt.elevationStops[0] + 1), vt.colorStops.push(vt.colorStops[0])), vt.elevationStops.length <= le1) return vt;
                                const ls = {
                                    elevationStops: [],
                                    colorStops: []
                                }, ho = (vt.elevationStops.length - 1) / (le1 - 1);
                                for(let Dl = 0; Dl < vt.elevationStops.length - .5; Dl += ho)ls.elevationStops.push(vt.elevationStops[Math.round(Dl)]), ls.colorStops.push(vt.colorStops[Math.round(Dl)]);
                                return j(`Too many colors in specification of ${this.id} color-relief layer, may not render properly. Max possible colors: ${le1}, provided: ${vt.elevationStops.length}`), ls;
                            }
                            _colorRampChanged() {
                                return this.colorRampExpression != this._transitionablePaint._values["color-relief-color"].value.expression;
                            }
                            getColorRampTextures(le1, vt, bt) {
                                if (this.colorRampTextures && !this._colorRampChanged()) return this.colorRampTextures;
                                const ls = this._createColorRamp(vt), ho = new Sl({
                                    width: ls.colorStops.length,
                                    height: 1
                                }), Dl = new Sl({
                                    width: ls.colorStops.length,
                                    height: 1
                                });
                                for(let Fl = 0; Fl < ls.elevationStops.length; Fl++){
                                    const le1 = Bl(ls.elevationStops[Fl], bt);
                                    Dl.setPixel(0, Fl, new Te(le1.r / 255, le1.g / 255, le1.b / 255, 1)), ho.setPixel(0, Fl, ls.colorStops[Fl]);
                                }
                                return this.colorRampTextures = {
                                    elevationTexture: new zl(le1, Dl, le1.gl.RGBA),
                                    colorTexture: new zl(le1, ho, le1.gl.RGBA)
                                }, this.colorRampTextures;
                            }
                            hasOffscreenPass() {
                                return !this.isHidden() && !!this.colorRampTextures;
                            }
                        }
                        const Cg = na([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: Ig } = Cg;
                        function Ol(le1, vt, bt) {
                            const ls = bt.patternDependencies;
                            let ho = !1;
                            for (const Dl of vt){
                                const vt = Dl.paint.get(`${le1}-pattern`);
                                vt.isConstant() || (ho = !0);
                                const bt = vt.constantOr(null);
                                bt && (ho = !0, ls[bt.to] = !0, ls[bt.from] = !0);
                            }
                            return ho;
                        }
                        function Rl(le1, vt, bt, ls, ho) {
                            const { zoom: Dl } = ls, Fl = ho.patternDependencies;
                            for (const sc of vt){
                                const vt = sc.paint.get(`${le1}-pattern`).value;
                                if ("constant" !== vt.kind) {
                                    let le1 = vt.evaluate({
                                        zoom: Dl - 1
                                    }, bt, {}, ho.availableImages), ls = vt.evaluate({
                                        zoom: Dl
                                    }, bt, {}, ho.availableImages), uc = vt.evaluate({
                                        zoom: Dl + 1
                                    }, bt, {}, ho.availableImages);
                                    le1 = le1 && le1.name ? le1.name : le1, ls = ls && ls.name ? ls.name : ls, uc = uc && uc.name ? uc.name : uc, Fl[le1] = !0, Fl[ls] = !0, Fl[uc] = !0, bt.patterns[sc.id] = {
                                        min: le1,
                                        mid: ls,
                                        max: uc
                                    };
                                }
                            }
                            return bt;
                        }
                        function Nl(le1, vt, bt, ls, ho) {
                            let Dl;
                            if (ho === function(le1, vt, bt, ls) {
                                let ho = 0;
                                for(let Dl = vt, Fl = bt - ls; Dl < bt; Dl += ls)ho += (le1[Fl] - le1[Dl]) * (le1[Dl + 1] + le1[Fl + 1]), Fl = Dl;
                                return ho;
                            }(le1, vt, bt, ls) > 0) for(let Fl = vt; Fl < bt; Fl += ls)Dl = lu(Fl / ls | 0, le1[Fl], le1[Fl + 1], Dl);
                            else for(let Fl = bt - ls; Fl >= vt; Fl -= ls)Dl = lu(Fl / ls | 0, le1[Fl], le1[Fl + 1], Dl);
                            return Dl && ru(Dl, Dl.next) && (uu(Dl), Dl = Dl.next), Dl;
                        }
                        function $l(le1, vt) {
                            if (!le1) return le1;
                            vt || (vt = le1);
                            let bt, ls = le1;
                            do if (bt = !1, ls.steiner || !ru(ls, ls.next) && 0 !== eu(ls.prev, ls, ls.next)) ls = ls.next;
                            else {
                                if (uu(ls), ls = vt = ls.prev, ls === ls.next) break;
                                bt = !0;
                            }
                            while (bt || ls !== vt);
                            return vt;
                        }
                        function Ul(le1, vt, bt, ls, ho, Dl, Fl) {
                            if (!le1) return;
                            !Fl && Dl && function(le1, vt, bt, ls) {
                                let ho = le1;
                                do 0 === ho.z && (ho.z = Kl(ho.x, ho.y, vt, bt, ls)), ho.prevZ = ho.prev, ho.nextZ = ho.next, ho = ho.next;
                                while (ho !== le1);
                                ho.prevZ.nextZ = null, ho.prevZ = null, function(le1) {
                                    let vt, bt = 1;
                                    do {
                                        let ls, ho = le1;
                                        le1 = null;
                                        let Dl = null;
                                        for(vt = 0; ho;){
                                            vt++;
                                            let Fl = ho, sc = 0;
                                            for(let le1 = 0; le1 < bt && (sc++, Fl = Fl.nextZ, Fl); le1++);
                                            let uc = bt;
                                            for(; sc > 0 || uc > 0 && Fl;)0 !== sc && (0 === uc || !Fl || ho.z <= Fl.z) ? (ls = ho, ho = ho.nextZ, sc--) : (ls = Fl, Fl = Fl.nextZ, uc--), Dl ? Dl.nextZ = ls : le1 = ls, ls.prevZ = Dl, Dl = ls;
                                            ho = Fl;
                                        }
                                        Dl.nextZ = null, bt *= 2;
                                    }while (vt > 1);
                                }(ho);
                            }(le1, ls, ho, Dl);
                            let sc = le1;
                            for(; le1.prev !== le1.next;){
                                const uc = le1.prev, mc = le1.next;
                                if (Dl ? jl(le1, ls, ho, Dl) : ql(le1)) vt.push(uc.i, le1.i, mc.i), uu(le1), le1 = mc.next, sc = mc.next;
                                else if ((le1 = mc) === sc) {
                                    Fl ? 1 === Fl ? Ul(le1 = Gl($l(le1), vt), vt, bt, ls, ho, Dl, 2) : 2 === Fl && Xl(le1, vt, bt, ls, ho, Dl) : Ul($l(le1), vt, bt, ls, ho, Dl, 1);
                                    break;
                                }
                            }
                        }
                        function ql(le1) {
                            const vt = le1.prev, bt = le1, ls = le1.next;
                            if (eu(vt, bt, ls) >= 0) return !1;
                            const ho = vt.x, Dl = bt.x, Fl = ls.x, sc = vt.y, uc = bt.y, mc = ls.y, gc = Math.min(ho, Dl, Fl), Ac = Math.min(sc, uc, mc), Ec = Math.max(ho, Dl, Fl), kc = Math.max(sc, uc, mc);
                            let du = ls.next;
                            for(; du !== vt;){
                                if (du.x >= gc && du.x <= Ec && du.y >= Ac && du.y <= kc && Ql(ho, sc, Dl, uc, Fl, mc, du.x, du.y) && eu(du.prev, du, du.next) >= 0) return !1;
                                du = du.next;
                            }
                            return !0;
                        }
                        function jl(le1, vt, bt, ls) {
                            const ho = le1.prev, Dl = le1, Fl = le1.next;
                            if (eu(ho, Dl, Fl) >= 0) return !1;
                            const sc = ho.x, uc = Dl.x, mc = Fl.x, gc = ho.y, Ac = Dl.y, Ec = Fl.y, kc = Math.min(sc, uc, mc), du = Math.min(gc, Ac, Ec), _u = Math.max(sc, uc, mc), Md = Math.max(gc, Ac, Ec), Ld = Kl(kc, du, vt, bt, ls), Nd = Kl(_u, Md, vt, bt, ls);
                            let Rd = le1.prevZ, Od = le1.nextZ;
                            for(; Rd && Rd.z >= Ld && Od && Od.z <= Nd;){
                                if (Rd.x >= kc && Rd.x <= _u && Rd.y >= du && Rd.y <= Md && Rd !== ho && Rd !== Fl && Ql(sc, gc, uc, Ac, mc, Ec, Rd.x, Rd.y) && eu(Rd.prev, Rd, Rd.next) >= 0) return !1;
                                if (Rd = Rd.prevZ, Od.x >= kc && Od.x <= _u && Od.y >= du && Od.y <= Md && Od !== ho && Od !== Fl && Ql(sc, gc, uc, Ac, mc, Ec, Od.x, Od.y) && eu(Od.prev, Od, Od.next) >= 0) return !1;
                                Od = Od.nextZ;
                            }
                            for(; Rd && Rd.z >= Ld;){
                                if (Rd.x >= kc && Rd.x <= _u && Rd.y >= du && Rd.y <= Md && Rd !== ho && Rd !== Fl && Ql(sc, gc, uc, Ac, mc, Ec, Rd.x, Rd.y) && eu(Rd.prev, Rd, Rd.next) >= 0) return !1;
                                Rd = Rd.prevZ;
                            }
                            for(; Od && Od.z <= Nd;){
                                if (Od.x >= kc && Od.x <= _u && Od.y >= du && Od.y <= Md && Od !== ho && Od !== Fl && Ql(sc, gc, uc, Ac, mc, Ec, Od.x, Od.y) && eu(Od.prev, Od, Od.next) >= 0) return !1;
                                Od = Od.nextZ;
                            }
                            return !0;
                        }
                        function Gl(le1, vt) {
                            let bt = le1;
                            do {
                                const ls = bt.prev, ho = bt.next.next;
                                !ru(ls, ho) && nu(ls, bt, bt.next, ho) && au(ls, ho) && au(ho, ls) && (vt.push(ls.i, bt.i, ho.i), uu(bt), uu(bt.next), bt = le1 = ho), bt = bt.next;
                            }while (bt !== le1);
                            return $l(bt);
                        }
                        function Xl(le1, vt, bt, ls, ho, Dl) {
                            let Fl = le1;
                            do {
                                let le1 = Fl.next.next;
                                for(; le1 !== Fl.prev;){
                                    if (Fl.i !== le1.i && tu(Fl, le1)) {
                                        let sc = ou(Fl, le1);
                                        return Fl = $l(Fl, Fl.next), sc = $l(sc, sc.next), Ul(Fl, vt, bt, ls, ho, Dl, 0), void Ul(sc, vt, bt, ls, ho, Dl, 0);
                                    }
                                    le1 = le1.next;
                                }
                                Fl = Fl.next;
                            }while (Fl !== le1);
                        }
                        function Yl(le1, vt) {
                            let bt = le1.x - vt.x;
                            return 0 === bt && (bt = le1.y - vt.y, 0 === bt) && (bt = (le1.next.y - le1.y) / (le1.next.x - le1.x) - (vt.next.y - vt.y) / (vt.next.x - vt.x)), bt;
                        }
                        function Zl(le1, vt) {
                            const bt = function(le1, vt) {
                                let bt = vt;
                                const ls = le1.x, ho = le1.y;
                                let Dl, Fl = -1 / 0;
                                if (ru(le1, bt)) return bt;
                                do {
                                    if (ru(le1, bt.next)) return bt.next;
                                    if (ho <= bt.y && ho >= bt.next.y && bt.next.y !== bt.y) {
                                        const le1 = bt.x + (ho - bt.y) * (bt.next.x - bt.x) / (bt.next.y - bt.y);
                                        if (le1 <= ls && le1 > Fl && (Fl = le1, Dl = bt.x < bt.next.x ? bt : bt.next, le1 === ls)) return Dl;
                                    }
                                    bt = bt.next;
                                }while (bt !== vt);
                                if (!Dl) return null;
                                const sc = Dl, uc = Dl.x, mc = Dl.y;
                                let gc = 1 / 0;
                                bt = Dl;
                                do {
                                    if (ls >= bt.x && bt.x >= uc && ls !== bt.x && Jl(ho < mc ? ls : Fl, ho, uc, mc, ho < mc ? Fl : ls, ho, bt.x, bt.y)) {
                                        const vt = Math.abs(ho - bt.y) / (ls - bt.x);
                                        au(bt, le1) && (vt < gc || vt === gc && (bt.x > Dl.x || bt.x === Dl.x && Hl(Dl, bt))) && (Dl = bt, gc = vt);
                                    }
                                    bt = bt.next;
                                }while (bt !== sc);
                                return Dl;
                            }(le1, vt);
                            if (!bt) return vt;
                            const ls = ou(bt, le1);
                            return $l(ls, ls.next), $l(bt, bt.next);
                        }
                        function Hl(le1, vt) {
                            return eu(le1.prev, le1, vt.prev) < 0 && eu(vt.next, le1, le1.next) < 0;
                        }
                        function Kl(le1, vt, bt, ls, ho) {
                            return (le1 = 1431655765 & ((le1 = 858993459 & ((le1 = 252645135 & ((le1 = 16711935 & ((le1 = (le1 - bt) * ho | 0) | le1 << 8)) | le1 << 4)) | le1 << 2)) | le1 << 1)) | (vt = 1431655765 & ((vt = 858993459 & ((vt = 252645135 & ((vt = 16711935 & ((vt = (vt - ls) * ho | 0) | vt << 8)) | vt << 4)) | vt << 2)) | vt << 1)) << 1;
                        }
                        function Wl(le1) {
                            let vt = le1, bt = le1;
                            do (vt.x < bt.x || vt.x === bt.x && vt.y < bt.y) && (bt = vt), vt = vt.next;
                            while (vt !== le1);
                            return bt;
                        }
                        function Jl(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            return (ho - Fl) * (vt - sc) >= (le1 - Fl) * (Dl - sc) && (le1 - Fl) * (ls - sc) >= (bt - Fl) * (vt - sc) && (bt - Fl) * (Dl - sc) >= (ho - Fl) * (ls - sc);
                        }
                        function Ql(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            return !(le1 === Fl && vt === sc) && Jl(le1, vt, bt, ls, ho, Dl, Fl, sc);
                        }
                        function tu(le1, vt) {
                            return le1.next.i !== vt.i && le1.prev.i !== vt.i && !function(le1, vt) {
                                let bt = le1;
                                do {
                                    if (bt.i !== le1.i && bt.next.i !== le1.i && bt.i !== vt.i && bt.next.i !== vt.i && nu(bt, bt.next, le1, vt)) return !0;
                                    bt = bt.next;
                                }while (bt !== le1);
                                return !1;
                            }(le1, vt) && (au(le1, vt) && au(vt, le1) && function(le1, vt) {
                                let bt = le1, ls = !1;
                                const ho = (le1.x + vt.x) / 2, Dl = (le1.y + vt.y) / 2;
                                do bt.y > Dl != bt.next.y > Dl && bt.next.y !== bt.y && ho < (bt.next.x - bt.x) * (Dl - bt.y) / (bt.next.y - bt.y) + bt.x && (ls = !ls), bt = bt.next;
                                while (bt !== le1);
                                return ls;
                            }(le1, vt) && (eu(le1.prev, le1, vt.prev) || eu(le1, vt.prev, vt)) || ru(le1, vt) && eu(le1.prev, le1, le1.next) > 0 && eu(vt.prev, vt, vt.next) > 0);
                        }
                        function eu(le1, vt, bt) {
                            return (vt.y - le1.y) * (bt.x - vt.x) - (vt.x - le1.x) * (bt.y - vt.y);
                        }
                        function ru(le1, vt) {
                            return le1.x === vt.x && le1.y === vt.y;
                        }
                        function nu(le1, vt, bt, ls) {
                            const ho = su(eu(le1, vt, bt)), Dl = su(eu(le1, vt, ls)), Fl = su(eu(bt, ls, le1)), sc = su(eu(bt, ls, vt));
                            return ho !== Dl && Fl !== sc || !(0 !== ho || !iu(le1, bt, vt)) || !(0 !== Dl || !iu(le1, ls, vt)) || !(0 !== Fl || !iu(bt, le1, ls)) || !(0 !== sc || !iu(bt, vt, ls));
                        }
                        function iu(le1, vt, bt) {
                            return vt.x <= Math.max(le1.x, bt.x) && vt.x >= Math.min(le1.x, bt.x) && vt.y <= Math.max(le1.y, bt.y) && vt.y >= Math.min(le1.y, bt.y);
                        }
                        function su(le1) {
                            return le1 > 0 ? 1 : le1 < 0 ? -1 : 0;
                        }
                        function au(le1, vt) {
                            return eu(le1.prev, le1, le1.next) < 0 ? eu(le1, vt, le1.next) >= 0 && eu(le1, le1.prev, vt) >= 0 : eu(le1, vt, le1.prev) < 0 || eu(le1, le1.next, vt) < 0;
                        }
                        function ou(le1, vt) {
                            const bt = cu(le1.i, le1.x, le1.y), ls = cu(vt.i, vt.x, vt.y), ho = le1.next, Dl = vt.prev;
                            return le1.next = vt, vt.prev = le1, bt.next = ho, ho.prev = bt, ls.next = bt, bt.prev = ls, Dl.next = ls, ls.prev = Dl, ls;
                        }
                        function lu(le1, vt, bt, ls) {
                            const ho = cu(le1, vt, bt);
                            return ls ? (ho.next = ls.next, ho.prev = ls, ls.next.prev = ho, ls.next = ho) : (ho.prev = ho, ho.next = ho), ho;
                        }
                        function uu(le1) {
                            le1.next.prev = le1.prev, le1.prev.next = le1.next, le1.prevZ && (le1.prevZ.nextZ = le1.nextZ), le1.nextZ && (le1.nextZ.prevZ = le1.prevZ);
                        }
                        function cu(le1, vt, bt) {
                            return {
                                i: le1,
                                x: vt,
                                y: bt,
                                prev: null,
                                next: null,
                                z: 0,
                                prevZ: null,
                                nextZ: null,
                                steiner: !1
                            };
                        }
                        class hu {
                            constructor(le1, vt){
                                if (vt > le1) throw new Error("Min granularity must not be greater than base granularity.");
                                this._baseZoomGranularity = le1, this._minGranularity = vt;
                            }
                            getGranularityForZoomLevel(le1) {
                                return Math.max(Math.floor(this._baseZoomGranularity / (1 << le1)), this._minGranularity, 1);
                            }
                        }
                        class pu {
                            constructor(le1){
                                this.fill = le1.fill, this.line = le1.line, this.tile = le1.tile, this.stencil = le1.stencil, this.circle = le1.circle;
                            }
                        }
                        pu.noSubdivision = new pu({
                            fill: new hu(0, 0),
                            line: new hu(0, 0),
                            tile: new hu(0, 0),
                            stencil: new hu(0, 0),
                            circle: 1
                        }), ps("SubdivisionGranularityExpression", hu), ps("SubdivisionGranularitySetting", pu);
                        const Dg = -32768, Lg = 32767;
                        class yu {
                            constructor(le1, vt){
                                this._vertexBuffer = [], this._vertexDictionary = new Map, this._used = !1, this._granularity = le1, this._granularityCellSize = Ac / le1, this._canonical = vt;
                            }
                            _getKey(le1, vt) {
                                return (le1 += 32768) << 16 | vt + 32768;
                            }
                            _vertexToIndex(le1, vt) {
                                if (le1 < -32768 || vt < -32768 || le1 > 32767 || vt > 32767) throw new Error("Vertex coordinates are out of signed 16 bit integer range.");
                                const bt = 0 | Math.round(le1), ls = 0 | Math.round(vt), ho = this._getKey(bt, ls);
                                if (this._vertexDictionary.has(ho)) return this._vertexDictionary.get(ho);
                                const Dl = this._vertexBuffer.length / 2;
                                return this._vertexDictionary.set(ho, Dl), this._vertexBuffer.push(bt, ls), Dl;
                            }
                            _subdivideTrianglesScanline(le1) {
                                if (this._granularity < 2) return function(le1, vt) {
                                    const bt = [];
                                    for(let ls = 0; ls < vt.length; ls += 3){
                                        const ho = vt[ls], Dl = vt[ls + 1], Fl = vt[ls + 2], sc = le1[2 * ho], uc = le1[2 * ho + 1];
                                        (le1[2 * Dl] - sc) * (le1[2 * Fl + 1] - uc) - (le1[2 * Dl + 1] - uc) * (le1[2 * Fl] - sc) > 0 ? (bt.push(ho), bt.push(Fl), bt.push(Dl)) : (bt.push(ho), bt.push(Dl), bt.push(Fl));
                                    }
                                    return bt;
                                }(this._vertexBuffer, le1);
                                const vt = [], bt = le1.length;
                                for(let ls = 0; ls < bt; ls += 3){
                                    const bt = [
                                        le1[ls + 0],
                                        le1[ls + 1],
                                        le1[ls + 2]
                                    ], ho = [
                                        this._vertexBuffer[2 * le1[ls + 0] + 0],
                                        this._vertexBuffer[2 * le1[ls + 0] + 1],
                                        this._vertexBuffer[2 * le1[ls + 1] + 0],
                                        this._vertexBuffer[2 * le1[ls + 1] + 1],
                                        this._vertexBuffer[2 * le1[ls + 2] + 0],
                                        this._vertexBuffer[2 * le1[ls + 2] + 1]
                                    ];
                                    let Dl = 1 / 0, Fl = 1 / 0, sc = -1 / 0, uc = -1 / 0;
                                    for(let le1 = 0; le1 < 3; le1++){
                                        const vt = ho[2 * le1], bt = ho[2 * le1 + 1];
                                        Dl = Math.min(Dl, vt), sc = Math.max(sc, vt), Fl = Math.min(Fl, bt), uc = Math.max(uc, bt);
                                    }
                                    if (Dl === sc || Fl === uc) continue;
                                    const mc = Math.floor(Dl / this._granularityCellSize), gc = Math.ceil(sc / this._granularityCellSize), Ac = Math.floor(Fl / this._granularityCellSize), Ec = Math.ceil(uc / this._granularityCellSize);
                                    if (mc !== gc || Ac !== Ec) for(let le1 = Ac; le1 < Ec; le1++){
                                        const ls = this._scanlineGenerateVertexRingForCellRow(le1, ho, bt);
                                        xu(this._vertexBuffer, ls, vt);
                                    }
                                    else vt.push(...bt);
                                }
                                return vt;
                            }
                            _scanlineGenerateVertexRingForCellRow(le1, vt, bt) {
                                const ls = le1 * this._granularityCellSize, ho = ls + this._granularityCellSize, Dl = [];
                                for(let Fl = 0; Fl < 3; Fl++){
                                    const le1 = vt[2 * Fl], sc = vt[2 * Fl + 1], uc = vt[2 * (Fl + 1) % 6], mc = vt[(2 * (Fl + 1) + 1) % 6], gc = vt[2 * (Fl + 2) % 6], Ac = vt[(2 * (Fl + 2) + 1) % 6], Ec = uc - le1, kc = mc - sc, du = 0 === Ec, _u = 0 === kc, Md = (ls - sc) / kc, Ld = (ho - sc) / kc, Nd = Math.min(Md, Ld), Rd = Math.max(Md, Ld);
                                    if (!_u && (Nd >= 1 || Rd <= 0) || _u && (sc < ls || sc > ho)) {
                                        mc >= ls && mc <= ho && Dl.push(bt[(Fl + 1) % 3]);
                                        continue;
                                    }
                                    !_u && Nd > 0 && Dl.push(this._vertexToIndex(le1 + Ec * Nd, sc + kc * Nd));
                                    const Od = le1 + Ec * Math.max(Nd, 0), jd = le1 + Ec * Math.min(Rd, 1);
                                    du || this._generateIntraEdgeVertices(Dl, le1, sc, uc, mc, Od, jd), !_u && Rd < 1 && Dl.push(this._vertexToIndex(le1 + Ec * Rd, sc + kc * Rd)), (_u || mc >= ls && mc <= ho) && Dl.push(bt[(Fl + 1) % 3]), !_u && (mc <= ls || mc >= ho) && this._generateInterEdgeVertices(Dl, le1, sc, uc, mc, gc, Ac, jd, ls, ho);
                                }
                                return Dl;
                            }
                            _generateIntraEdgeVertices(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = ls - vt, uc = ho - bt, mc = 0 === uc, gc = mc ? Math.min(vt, ls) : Math.min(Dl, Fl), Ac = mc ? Math.max(vt, ls) : Math.max(Dl, Fl), Ec = Math.floor(gc / this._granularityCellSize) + 1, kc = Math.ceil(Ac / this._granularityCellSize) - 1;
                                if (mc ? vt < ls : Dl < Fl) for(let du = Ec; du <= kc; du++){
                                    const ls = du * this._granularityCellSize;
                                    le1.push(this._vertexToIndex(ls, bt + uc * (ls - vt) / sc));
                                }
                                else for(let du = kc; du >= Ec; du--){
                                    const ls = du * this._granularityCellSize;
                                    le1.push(this._vertexToIndex(ls, bt + uc * (ls - vt) / sc));
                                }
                            }
                            _generateInterEdgeVertices(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                                const gc = ho - bt, Ac = Dl - ls, Ec = Fl - ho, kc = (uc - ho) / Ec, du = (mc - ho) / Ec, _u = Math.min(kc, du), Md = Math.max(kc, du), Ld = ls + Ac * _u;
                                let Nd = Math.floor(Math.min(Ld, sc) / this._granularityCellSize) + 1, Rd = Math.ceil(Math.max(Ld, sc) / this._granularityCellSize) - 1, Od = sc < Ld;
                                const jd = 0 === Ec;
                                if (jd && (Fl === uc || Fl === mc)) return;
                                if (jd || _u >= 1 || Md <= 0) {
                                    const le1 = bt - Fl, ls = Dl + (vt - Dl) * Math.min((uc - Fl) / le1, (mc - Fl) / le1);
                                    Nd = Math.floor(Math.min(ls, sc) / this._granularityCellSize) + 1, Rd = Math.ceil(Math.max(ls, sc) / this._granularityCellSize) - 1, Od = sc < ls;
                                }
                                const Ud = gc > 0 ? mc : uc;
                                if (Od) for(let Gd = Nd; Gd <= Rd; Gd++)le1.push(this._vertexToIndex(Gd * this._granularityCellSize, Ud));
                                else for(let Gd = Rd; Gd >= Nd; Gd--)le1.push(this._vertexToIndex(Gd * this._granularityCellSize, Ud));
                            }
                            _generateOutline(le1) {
                                const vt = [];
                                for (const bt of le1){
                                    const le1 = gu(bt, this._granularity, !0), ls = this._pointArrayToIndices(le1), ho = [];
                                    for(let vt = 1; vt < ls.length; vt++)ho.push(ls[vt - 1]), ho.push(ls[vt]);
                                    vt.push(ho);
                                }
                                return vt;
                            }
                            _handlePoles(le1) {
                                let vt = !1, bt = !1;
                                this._canonical && (0 === this._canonical.y && (vt = !0), this._canonical.y === (1 << this._canonical.z) - 1 && (bt = !0)), (vt || bt) && this._fillPoles(le1, vt, bt);
                            }
                            _ensureNoPoleVertices() {
                                const le1 = this._vertexBuffer;
                                for(let vt = 0; vt < le1.length; vt += 2){
                                    const bt = le1[vt + 1];
                                    bt === Dg && (le1[vt + 1] = -32767), bt === Lg && (le1[vt + 1] = 32766);
                                }
                            }
                            _generatePoleQuad(le1, vt, bt, ls, ho, Dl) {
                                ls > ho != (Dl === Dg) ? (le1.push(vt), le1.push(bt), le1.push(this._vertexToIndex(ls, Dl)), le1.push(bt), le1.push(this._vertexToIndex(ho, Dl)), le1.push(this._vertexToIndex(ls, Dl))) : (le1.push(bt), le1.push(vt), le1.push(this._vertexToIndex(ls, Dl)), le1.push(this._vertexToIndex(ho, Dl)), le1.push(bt), le1.push(this._vertexToIndex(ls, Dl)));
                            }
                            _fillPoles(le1, vt, bt) {
                                const ls = this._vertexBuffer, ho = Ac, Dl = le1.length;
                                for(let Fl = 2; Fl < Dl; Fl += 3){
                                    const Dl = le1[Fl - 2], sc = le1[Fl - 1], uc = le1[Fl], mc = ls[2 * Dl], gc = ls[2 * Dl + 1], Ac = ls[2 * sc], Ec = ls[2 * sc + 1], kc = ls[2 * uc], du = ls[2 * uc + 1];
                                    vt && (0 === gc && 0 === Ec && this._generatePoleQuad(le1, Dl, sc, mc, Ac, Dg), 0 === Ec && 0 === du && this._generatePoleQuad(le1, sc, uc, Ac, kc, Dg), 0 === du && 0 === gc && this._generatePoleQuad(le1, uc, Dl, kc, mc, Dg)), bt && (gc === ho && Ec === ho && this._generatePoleQuad(le1, Dl, sc, mc, Ac, Lg), Ec === ho && du === ho && this._generatePoleQuad(le1, sc, uc, Ac, kc, Lg), du === ho && gc === ho && this._generatePoleQuad(le1, uc, Dl, kc, mc, Lg));
                                }
                            }
                            _initializeVertices(le1) {
                                for(let vt = 0; vt < le1.length; vt += 2)this._vertexToIndex(le1[vt], le1[vt + 1]);
                            }
                            subdividePolygonInternal(le1, vt) {
                                if (this._used) throw new Error("Subdivision: multiple use not allowed.");
                                this._used = !0;
                                const { flattened: bt, holeIndices: ls } = function(le1) {
                                    const vt = [], bt = [];
                                    for (const ls of le1)if (0 !== ls.length) {
                                        ls !== le1[0] && vt.push(bt.length / 2);
                                        for(let le1 = 0; le1 < ls.length; le1++)bt.push(ls[le1].x), bt.push(ls[le1].y);
                                    }
                                    return {
                                        flattened: bt,
                                        holeIndices: vt
                                    };
                                }(le1);
                                let ho;
                                this._initializeVertices(bt);
                                try {
                                    const le1 = function(le1, vt, bt = 2) {
                                        const ls = vt && vt.length, ho = ls ? vt[0] * bt : le1.length;
                                        let Dl = Nl(le1, 0, ho, bt, !0);
                                        const Fl = [];
                                        if (!Dl || Dl.next === Dl.prev) return Fl;
                                        let sc, uc, mc;
                                        if (ls && (Dl = function(le1, vt, bt, ls) {
                                            const ho = [];
                                            for(let Dl = 0, Fl = vt.length; Dl < Fl; Dl++){
                                                const bt = Nl(le1, vt[Dl] * ls, Dl < Fl - 1 ? vt[Dl + 1] * ls : le1.length, ls, !1);
                                                bt === bt.next && (bt.steiner = !0), ho.push(Wl(bt));
                                            }
                                            ho.sort(Yl);
                                            for(let Dl = 0; Dl < ho.length; Dl++)bt = Zl(ho[Dl], bt);
                                            return bt;
                                        }(le1, vt, Dl, bt)), le1.length > 80 * bt) {
                                            sc = le1[0], uc = le1[1];
                                            let vt = sc, ls = uc;
                                            for(let Dl = bt; Dl < ho; Dl += bt){
                                                const bt = le1[Dl], ho = le1[Dl + 1];
                                                bt < sc && (sc = bt), ho < uc && (uc = ho), bt > vt && (vt = bt), ho > ls && (ls = ho);
                                            }
                                            mc = Math.max(vt - sc, ls - uc), mc = 0 !== mc ? 32767 / mc : 0;
                                        }
                                        return Ul(Dl, Fl, bt, sc, uc, mc, 0), Fl;
                                    }(bt, ls), vt = this._convertIndices(bt, le1);
                                    ho = this._subdivideTrianglesScanline(vt);
                                } catch (le1) {
                                    console.error(le1);
                                }
                                let Dl = [];
                                return vt && (Dl = this._generateOutline(le1)), this._ensureNoPoleVertices(), this._handlePoles(ho), {
                                    verticesFlattened: this._vertexBuffer,
                                    indicesTriangles: ho,
                                    indicesLineList: Dl
                                };
                            }
                            _convertIndices(le1, vt) {
                                const bt = [];
                                for(let ls = 0; ls < vt.length; ls++)bt.push(this._vertexToIndex(le1[2 * vt[ls]], le1[2 * vt[ls] + 1]));
                                return bt;
                            }
                            _pointArrayToIndices(le1) {
                                const vt = [];
                                for(let bt = 0; bt < le1.length; bt++){
                                    const ls = le1[bt];
                                    vt.push(this._vertexToIndex(ls.x, ls.y));
                                }
                                return vt;
                            }
                        }
                        function mu(le1, vt, bt, ls = !0) {
                            return new yu(bt, vt).subdividePolygonInternal(le1, ls);
                        }
                        function gu(le1, vt, bt = !1) {
                            if (!le1 || le1.length < 1) return [];
                            if (le1.length < 2) return [];
                            const ls = le1[0], ho = le1[le1.length - 1], Dl = bt && (ls.x !== ho.x || ls.y !== ho.y);
                            if (vt < 2) return Dl ? [
                                ...le1,
                                le1[0]
                            ] : [
                                ...le1
                            ];
                            const Fl = Math.floor(Ac / vt), sc = [];
                            sc.push(new r(le1[0].x, le1[0].y));
                            const uc = le1.length, mc = Dl ? uc : uc - 1;
                            for(let gc = 0; gc < mc; gc++){
                                const vt = le1[gc], bt = gc < uc - 1 ? le1[gc + 1] : le1[0], ls = vt.x, ho = vt.y, Dl = bt.x, mc = bt.y, Ac = ls !== Dl, Ec = ho !== mc;
                                if (!Ac && !Ec) continue;
                                const kc = Dl - ls, du = mc - ho, _u = Math.abs(kc), Md = Math.abs(du);
                                let Ld = ls, Nd = ho;
                                for(;;){
                                    const le1 = kc > 0 ? (Math.floor(Ld / Fl) + 1) * Fl : (Math.ceil(Ld / Fl) - 1) * Fl, vt = du > 0 ? (Math.floor(Nd / Fl) + 1) * Fl : (Math.ceil(Nd / Fl) - 1) * Fl, bt = Math.abs(Ld - le1), ls = Math.abs(Nd - vt), ho = Math.abs(Ld - Dl), uc = Math.abs(Nd - mc), gc = Ac ? bt / _u : Number.POSITIVE_INFINITY, Rd = Ec ? ls / Md : Number.POSITIVE_INFINITY;
                                    if ((ho <= bt || !Ac) && (uc <= ls || !Ec)) break;
                                    if (gc < Rd && Ac || !Ec) {
                                        Ld = le1, Nd += du * gc;
                                        const vt = new r(Ld, Math.round(Nd));
                                        sc[sc.length - 1].x === vt.x && sc[sc.length - 1].y === vt.y || sc.push(vt);
                                    } else {
                                        Ld += kc * Rd, Nd = vt;
                                        const le1 = new r(Math.round(Ld), Nd);
                                        sc[sc.length - 1].x === le1.x && sc[sc.length - 1].y === le1.y || sc.push(le1);
                                    }
                                }
                                const Rd = new r(Dl, mc);
                                sc[sc.length - 1].x === Rd.x && sc[sc.length - 1].y === Rd.y || sc.push(Rd);
                            }
                            return sc;
                        }
                        function xu(le1, vt, bt) {
                            if (0 === vt.length) throw new Error("Subdivision vertex ring is empty.");
                            let ls = 0, ho = le1[2 * vt[0]];
                            for(let uc = 1; uc < vt.length; uc++){
                                const bt = le1[2 * vt[uc]];
                                bt < ho && (ho = bt, ls = uc);
                            }
                            const Dl = vt.length;
                            let Fl = ls, sc = (Fl + 1) % Dl;
                            for(;;){
                                const ls = Fl - 1 >= 0 ? Fl - 1 : Dl - 1, ho = (sc + 1) % Dl, uc = le1[2 * vt[ls]], mc = le1[2 * vt[ho]], gc = le1[2 * vt[Fl]], Ac = le1[2 * vt[Fl] + 1], Ec = le1[2 * vt[sc] + 1];
                                let kc = !1;
                                if (uc < mc) kc = !0;
                                else if (uc > mc) kc = !1;
                                else {
                                    const bt = Ec - Ac, Dl = -(le1[2 * vt[sc]] - gc), Fl = Ac < Ec ? 1 : -1;
                                    ((uc - gc) * bt + (le1[2 * vt[ls] + 1] - Ac) * Dl) * Fl > ((mc - gc) * bt + (le1[2 * vt[ho] + 1] - Ac) * Dl) * Fl && (kc = !0);
                                }
                                if (kc) {
                                    const le1 = vt[ls], ho = vt[Fl], uc = vt[sc];
                                    le1 !== ho && le1 !== uc && ho !== uc && bt.push(uc, ho, le1), Fl--, Fl < 0 && (Fl = Dl - 1);
                                } else {
                                    const le1 = vt[ho], ls = vt[Fl], uc = vt[sc];
                                    le1 !== ls && le1 !== uc && ls !== uc && bt.push(uc, ls, le1), sc++, sc >= Dl && (sc = 0);
                                }
                                if (ls === ho) break;
                            }
                        }
                        function vu(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = ho.length / 2, gc = Fl && sc && uc;
                            if (mc < io.MAX_VERTEX_ARRAY_LENGTH) {
                                const Ac = vt.prepareSegment(mc, bt, ls), Ec = Ac.vertexLength;
                                for(let le1 = 0; le1 < Dl.length; le1 += 3)ls.emplaceBack(Ec + Dl[le1], Ec + Dl[le1 + 1], Ec + Dl[le1 + 2]);
                                let kc, du;
                                Ac.vertexLength += mc, Ac.primitiveLength += Dl.length / 3, gc && (du = Fl.prepareSegment(mc, bt, sc), kc = du.vertexLength, du.vertexLength += mc);
                                for(let vt = 0; vt < ho.length; vt += 2)le1(ho[vt], ho[vt + 1]);
                                if (gc) for(let le1 = 0; le1 < uc.length; le1++){
                                    const vt = uc[le1];
                                    for(let le1 = 1; le1 < vt.length; le1 += 2)sc.emplaceBack(kc + vt[le1 - 1], kc + vt[le1]);
                                    du.primitiveLength += vt.length / 2;
                                }
                            } else !function(le1, vt, bt, ls, ho, Dl) {
                                const Fl = [];
                                for(let Ac = 0; Ac < ls.length / 2; Ac++)Fl.push(-1);
                                const sc = {
                                    count: 0
                                };
                                let uc = 0, mc = le1.getOrCreateLatestSegment(vt, bt), gc = mc.vertexLength;
                                for(let Ac = 2; Ac < ho.length; Ac += 3){
                                    const Ec = ho[Ac - 2], kc = ho[Ac - 1], du = ho[Ac];
                                    let _u = Fl[Ec] < uc, Md = Fl[kc] < uc, Ld = Fl[du] < uc;
                                    mc.vertexLength + ((_u ? 1 : 0) + (Md ? 1 : 0) + (Ld ? 1 : 0)) > io.MAX_VERTEX_ARRAY_LENGTH && (mc = le1.createNewSegment(vt, bt), uc = sc.count, _u = !0, Md = !0, Ld = !0, gc = 0);
                                    const Nd = bu(Fl, ls, Dl, sc, Ec, _u, mc), Rd = bu(Fl, ls, Dl, sc, kc, Md, mc), Od = bu(Fl, ls, Dl, sc, du, Ld, mc);
                                    bt.emplaceBack(gc + Nd - uc, gc + Rd - uc, gc + Od - uc), mc.primitiveLength++;
                                }
                            }(vt, bt, ls, ho, Dl, le1), gc && function(le1, vt, bt, ls, ho, Dl) {
                                const Fl = [];
                                for(let Ac = 0; Ac < ls.length / 2; Ac++)Fl.push(-1);
                                const sc = {
                                    count: 0
                                };
                                let uc = 0, mc = le1.getOrCreateLatestSegment(vt, bt), gc = mc.vertexLength;
                                for(let Ac = 0; Ac < ho.length; Ac++){
                                    const Ec = ho[Ac];
                                    for(let kc = 1; kc < ho[Ac].length; kc += 2){
                                        const ho = Ec[kc - 1], Ac = Ec[kc];
                                        let du = Fl[ho] < uc, _u = Fl[Ac] < uc;
                                        mc.vertexLength + ((du ? 1 : 0) + (_u ? 1 : 0)) > io.MAX_VERTEX_ARRAY_LENGTH && (mc = le1.createNewSegment(vt, bt), uc = sc.count, du = !0, _u = !0, gc = 0);
                                        const Md = bu(Fl, ls, Dl, sc, ho, du, mc), Ld = bu(Fl, ls, Dl, sc, Ac, _u, mc);
                                        bt.emplaceBack(gc + Md - uc, gc + Ld - uc), mc.primitiveLength++;
                                    }
                                }
                            }(Fl, bt, sc, ho, uc, le1), vt.forceNewSegmentOnNextPrepare(), null == Fl || Fl.forceNewSegmentOnNextPrepare();
                        }
                        function bu(le1, vt, bt, ls, ho, Dl, Fl) {
                            if (Dl) {
                                const Dl = ls.count;
                                return bt(vt[2 * ho], vt[2 * ho + 1]), le1[ho] = ls.count, ls.count++, Fl.vertexLength++, Dl;
                            }
                            return le1[ho];
                        }
                        class wu {
                            constructor(le1){
                                this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.patternFeatures = [], this.layoutVertexArray = new qa, this.indexArray = new to, this.indexArray2 = new eo, this.programConfigurations = new Vo(le1.layers, le1.zoom), this.segments = new io, this.segments2 = new io, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                            }
                            populate(le1, vt, bt) {
                                this.hasDependencies = Ol("fill", this.layers, vt);
                                const ls = this.layers[0].layout.get("fill-sort-key"), ho = !ls.isConstant(), Dl = [];
                                for (const { feature: Fl, id: sc, index: uc, sourceLayerIndex: mc } of le1){
                                    const le1 = this.layers[0]._featureFilter.needGeometry, gc = $o(Fl, le1);
                                    if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), gc, bt)) continue;
                                    const Ac = ho ? ls.evaluate(gc, {}, bt, vt.availableImages) : void 0, Ec = {
                                        id: sc,
                                        properties: Fl.properties,
                                        type: Fl.type,
                                        sourceLayerIndex: mc,
                                        index: uc,
                                        geometry: le1 ? gc.geometry : No(Fl),
                                        patterns: {},
                                        sortKey: Ac
                                    };
                                    Dl.push(Ec);
                                }
                                ho && Dl.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                                for (const Fl of Dl){
                                    const { geometry: ls, index: ho, sourceLayerIndex: Dl } = Fl;
                                    if (this.hasDependencies) {
                                        const le1 = Rl("fill", this.layers, Fl, {
                                            zoom: this.zoom
                                        }, vt);
                                        this.patternFeatures.push(le1);
                                    } else this.addFeature(Fl, ls, ho, bt, {}, vt.subdivisionGranularity);
                                    vt.featureIndex.insert(le1[ho].feature, ls, ho, Dl, this.index);
                                }
                            }
                            update(le1, vt, bt) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                    imagePositions: bt
                                });
                            }
                            addFeatures(le1, vt, bt) {
                                for (const ls of this.patternFeatures)this.addFeature(ls, ls.geometry, ls.index, vt, bt, le1.subdivisionGranularity);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(le1) {
                                this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Ig), this.indexBuffer = le1.createIndexBuffer(this.indexArray), this.indexBuffer2 = le1.createIndexBuffer(this.indexArray2)), this.programConfigurations.upload(le1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.indexBuffer2.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.segments2.destroy());
                            }
                            addFeature(le1, vt, bt, ls, ho, Dl) {
                                for (const Fl of tn(vt, 500)){
                                    const le1 = mu(Fl, ls, Dl.fill.getGranularityForZoomLevel(ls.z)), vt = this.layoutVertexArray;
                                    vu((le1, bt)=>{
                                        vt.emplaceBack(le1, bt);
                                    }, this.segments, this.layoutVertexArray, this.indexArray, le1.verticesFlattened, le1.indicesTriangles, this.segments2, this.indexArray2, le1.indicesLineList);
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                    imagePositions: ho,
                                    canonical: ls
                                });
                            }
                        }
                        let Pg, zg;
                        ps("FillBucket", wu, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Ng = {
                            get paint () {
                                return zg = zg || new Hs({
                                    "fill-antialias": new js(qd.paint_fill["fill-antialias"]),
                                    "fill-opacity": new Gs(qd.paint_fill["fill-opacity"]),
                                    "fill-color": new Gs(qd.paint_fill["fill-color"]),
                                    "fill-outline-color": new Gs(qd.paint_fill["fill-outline-color"]),
                                    "fill-translate": new js(qd.paint_fill["fill-translate"]),
                                    "fill-translate-anchor": new js(qd.paint_fill["fill-translate-anchor"]),
                                    "fill-pattern": new Xs(qd.paint_fill["fill-pattern"])
                                });
                            },
                            get layout () {
                                return Pg = Pg || new Hs({
                                    "fill-sort-key": new Gs(qd.layout_fill["fill-sort-key"])
                                });
                            }
                        };
                        class ku extends Ks {
                            constructor(le1, vt){
                                super(le1, Ng, vt);
                            }
                            recalculate(le1, vt) {
                                super.recalculate(le1, vt);
                                const bt = this.paint._values["fill-outline-color"];
                                "constant" === bt.value.kind && void 0 === bt.value.value && (this.paint._values["fill-outline-color"] = this.paint._values["fill-color"]);
                            }
                            createBucket(le1) {
                                return new wu(le1);
                            }
                            queryRadius() {
                                return nl(this.paint.get("fill-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: le1, geometry: vt, transform: bt, pixelsToTileUnits: ls }) {
                                return Yo(il(le1, this.paint.get("fill-translate"), this.paint.get("fill-translate-anchor"), -bt.bearingInRadians, ls), vt);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        const Rg = na([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_normal_ed",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), Fg = na([
                            {
                                name: "a_centroid",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), { members: Og } = Rg;
                        class Mu {
                            constructor(le1, vt, bt, ls, ho){
                                this.properties = {}, this.extent = bt, this.type = 0, this.id = void 0, this._pbf = le1, this._geometry = -1, this._keys = ls, this._values = ho, le1.readFields(Fu, this, vt);
                            }
                            loadGeometry() {
                                const le1 = this._pbf;
                                le1.pos = this._geometry;
                                const vt = le1.readVarint() + le1.pos, bt = [];
                                let ls, ho = 1, Dl = 0, Fl = 0, sc = 0;
                                for(; le1.pos < vt;){
                                    if (Dl <= 0) {
                                        const vt = le1.readVarint();
                                        ho = 7 & vt, Dl = vt >> 3;
                                    }
                                    if (Dl--, 1 === ho || 2 === ho) Fl += le1.readSVarint(), sc += le1.readSVarint(), 1 === ho && (ls && bt.push(ls), ls = []), ls && ls.push(new r(Fl, sc));
                                    else {
                                        if (7 !== ho) throw new Error(`unknown command ${ho}`);
                                        ls && ls.push(ls[0].clone());
                                    }
                                }
                                return ls && bt.push(ls), bt;
                            }
                            bbox() {
                                const le1 = this._pbf;
                                le1.pos = this._geometry;
                                const vt = le1.readVarint() + le1.pos;
                                let bt = 1, ls = 0, ho = 0, Dl = 0, Fl = 1 / 0, sc = -1 / 0, uc = 1 / 0, mc = -1 / 0;
                                for(; le1.pos < vt;){
                                    if (ls <= 0) {
                                        const vt = le1.readVarint();
                                        bt = 7 & vt, ls = vt >> 3;
                                    }
                                    if (ls--, 1 === bt || 2 === bt) ho += le1.readSVarint(), Dl += le1.readSVarint(), ho < Fl && (Fl = ho), ho > sc && (sc = ho), Dl < uc && (uc = Dl), Dl > mc && (mc = Dl);
                                    else if (7 !== bt) throw new Error(`unknown command ${bt}`);
                                }
                                return [
                                    Fl,
                                    uc,
                                    sc,
                                    mc
                                ];
                            }
                            toGeoJSON(le1, vt, bt) {
                                const ls = this.extent * Math.pow(2, bt), ho = this.extent * le1, Dl = this.extent * vt, Fl = this.loadGeometry();
                                function o(le1) {
                                    return [
                                        360 * (le1.x + ho) / ls - 180,
                                        360 / Math.PI * Math.atan(Math.exp((1 - 2 * (le1.y + Dl) / ls) * Math.PI)) - 90
                                    ];
                                }
                                function l(le1) {
                                    return le1.map(o);
                                }
                                let sc;
                                if (1 === this.type) {
                                    const le1 = [];
                                    for (const bt of Fl)le1.push(bt[0]);
                                    const vt = l(le1);
                                    sc = 1 === le1.length ? {
                                        type: "Point",
                                        coordinates: vt[0]
                                    } : {
                                        type: "MultiPoint",
                                        coordinates: vt
                                    };
                                } else if (2 === this.type) {
                                    const le1 = Fl.map(l);
                                    sc = 1 === le1.length ? {
                                        type: "LineString",
                                        coordinates: le1[0]
                                    } : {
                                        type: "MultiLineString",
                                        coordinates: le1
                                    };
                                } else {
                                    if (3 !== this.type) throw new Error("unknown feature type");
                                    {
                                        const le1 = Du(Fl), vt = [];
                                        for (const bt of le1)vt.push(bt.map(l));
                                        sc = 1 === vt.length ? {
                                            type: "Polygon",
                                            coordinates: vt[0]
                                        } : {
                                            type: "MultiPolygon",
                                            coordinates: vt
                                        };
                                    }
                                }
                                const uc = {
                                    type: "Feature",
                                    geometry: sc,
                                    properties: this.properties
                                };
                                return null != this.id && (uc.id = this.id), uc;
                            }
                        }
                        function Fu(le1, vt, bt) {
                            1 === le1 ? vt.id = bt.readVarint() : 2 === le1 ? function(le1, vt) {
                                const bt = le1.readVarint() + le1.pos;
                                for(; le1.pos < bt;){
                                    const bt = vt._keys[le1.readVarint()], ls = vt._values[le1.readVarint()];
                                    vt.properties[bt] = ls;
                                }
                            }(bt, vt) : 3 === le1 ? vt.type = bt.readVarint() : 4 === le1 && (vt._geometry = bt.pos);
                        }
                        function Du(le1) {
                            const vt = le1.length;
                            if (vt <= 1) return [
                                le1
                            ];
                            const bt = [];
                            let ls, ho;
                            for(let Dl = 0; Dl < vt; Dl++){
                                const vt = zu(le1[Dl]);
                                0 !== vt && (void 0 === ho && (ho = vt < 0), ho === vt < 0 ? (ls && bt.push(ls), ls = [
                                    le1[Dl]
                                ]) : ls && ls.push(le1[Dl]));
                            }
                            return ls && bt.push(ls), bt;
                        }
                        function zu(le1) {
                            let vt = 0;
                            for(let bt, ls, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++)bt = le1[ho], ls = le1[Fl], vt += (ls.x - bt.x) * (bt.y + ls.y);
                            return vt;
                        }
                        Mu.types = [
                            "Unknown",
                            "Point",
                            "LineString",
                            "Polygon"
                        ];
                        class Pu {
                            constructor(le1, vt){
                                this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = le1, this._keys = [], this._values = [], this._features = [], le1.readFields(Bu, this, vt), this.length = this._features.length;
                            }
                            feature(le1) {
                                if (le1 < 0 || le1 >= this._features.length) throw new Error("feature index out of bounds");
                                this._pbf.pos = this._features[le1];
                                const vt = this._pbf.readVarint() + this._pbf.pos;
                                return new Mu(this._pbf, vt, this.extent, this._keys, this._values);
                            }
                        }
                        function Bu(le1, vt, bt) {
                            15 === le1 ? vt.version = bt.readVarint() : 1 === le1 ? vt.name = bt.readString() : 5 === le1 ? vt.extent = bt.readVarint() : 2 === le1 ? vt._features.push(bt.pos) : 3 === le1 ? vt._keys.push(bt.readString()) : 4 === le1 && vt._values.push(function(le1) {
                                let vt = null;
                                const bt = le1.readVarint() + le1.pos;
                                for(; le1.pos < bt;){
                                    const bt = le1.readVarint() >> 3;
                                    vt = 1 === bt ? le1.readString() : 2 === bt ? le1.readFloat() : 3 === bt ? le1.readDouble() : 4 === bt ? le1.readVarint64() : 5 === bt ? le1.readVarint() : 6 === bt ? le1.readSVarint() : 7 === bt ? le1.readBoolean() : null;
                                }
                                if (null == vt) throw new Error("unknown feature value");
                                return vt;
                            }(bt));
                        }
                        class Vu {
                            constructor(le1, vt){
                                this.layers = le1.readFields(Cu, {}, vt);
                            }
                        }
                        function Cu(le1, vt, bt) {
                            if (3 === le1) {
                                const le1 = new Pu(bt, bt.readVarint() + bt.pos);
                                le1.length && (vt[le1.name] = le1);
                            }
                        }
                        const Bg = Math.pow(2, 13);
                        function Ou(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            le1.emplaceBack(vt, bt, 2 * Math.floor(ls * Bg) + Fl, ho * Bg * 2, Dl * Bg * 2, Math.round(sc));
                        }
                        class Ru {
                            constructor(le1){
                                this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.layoutVertexArray = new ja, this.centroidVertexArray = new $a, this.indexArray = new to, this.programConfigurations = new Vo(le1.layers, le1.zoom), this.segments = new io, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                            }
                            populate(le1, vt, bt) {
                                this.features = [], this.hasDependencies = Ol("fill-extrusion", this.layers, vt);
                                for (const { feature: ls, id: ho, index: Dl, sourceLayerIndex: Fl } of le1){
                                    const le1 = this.layers[0]._featureFilter.needGeometry, sc = $o(ls, le1);
                                    if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), sc, bt)) continue;
                                    const uc = {
                                        id: ho,
                                        sourceLayerIndex: Fl,
                                        index: Dl,
                                        geometry: le1 ? sc.geometry : No(ls),
                                        properties: ls.properties,
                                        type: ls.type,
                                        patterns: {}
                                    };
                                    this.hasDependencies ? this.features.push(Rl("fill-extrusion", this.layers, uc, {
                                        zoom: this.zoom
                                    }, vt)) : this.addFeature(uc, uc.geometry, Dl, bt, {}, vt.subdivisionGranularity), vt.featureIndex.insert(ls, uc.geometry, Dl, Fl, this.index, !0);
                                }
                            }
                            addFeatures(le1, vt, bt) {
                                for (const ls of this.features){
                                    const { geometry: ho } = ls;
                                    this.addFeature(ls, ho, ls.index, vt, bt, le1.subdivisionGranularity);
                                }
                            }
                            update(le1, vt, bt) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                    imagePositions: bt
                                });
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.centroidVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(le1) {
                                this.uploaded || (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Og), this.centroidVertexBuffer = le1.createVertexBuffer(this.centroidVertexArray, Fg.members, !0), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.centroidVertexBuffer.destroy());
                            }
                            addFeature(le1, vt, bt, ls, ho, Dl) {
                                for (const Fl of tn(vt, 500)){
                                    const vt = {
                                        x: 0,
                                        y: 0,
                                        sampleCount: 0
                                    }, bt = this.layoutVertexArray.length;
                                    this.processPolygon(vt, ls, le1, Fl, Dl);
                                    const ho = this.layoutVertexArray.length - bt, sc = Math.floor(vt.x / vt.sampleCount), uc = Math.floor(vt.y / vt.sampleCount);
                                    for(let le1 = 0; le1 < ho; le1++)this.centroidVertexArray.emplaceBack(sc, uc);
                                }
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                    imagePositions: ho,
                                    canonical: ls
                                });
                            }
                            processPolygon(le1, vt, bt, ls, ho) {
                                if (ls.length < 1) return;
                                if (Uu(ls[0])) return;
                                for (const gc of ls)0 !== gc.length && Nu(le1, gc);
                                const Dl = {
                                    segment: this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray)
                                }, Fl = ho.fill.getGranularityForZoomLevel(vt.z), sc = "Polygon" === Mu.types[bt.type];
                                for (const gc of ls){
                                    if (0 === gc.length) continue;
                                    if (Uu(gc)) continue;
                                    const le1 = gu(gc, Fl, sc);
                                    this._generateSideFaces(le1, Dl);
                                }
                                if (!sc) return;
                                const uc = mu(ls, vt, Fl, !1), mc = this.layoutVertexArray;
                                vu((le1, vt)=>{
                                    Ou(mc, le1, vt, 0, 0, 1, 1, 0);
                                }, this.segments, this.layoutVertexArray, this.indexArray, uc.verticesFlattened, uc.indicesTriangles);
                            }
                            _generateSideFaces(le1, vt) {
                                let bt = 0;
                                for(let ls = 1; ls < le1.length; ls++){
                                    const ho = le1[ls], Dl = le1[ls - 1];
                                    if ($u(ho, Dl)) continue;
                                    vt.segment.vertexLength + 4 > io.MAX_VERTEX_ARRAY_LENGTH && (vt.segment = this.segments.prepareSegment(4, this.layoutVertexArray, this.indexArray));
                                    const Fl = ho.sub(Dl)._perp()._unit(), sc = Dl.dist(ho);
                                    bt + sc > 32768 && (bt = 0), Ou(this.layoutVertexArray, ho.x, ho.y, Fl.x, Fl.y, 0, 0, bt), Ou(this.layoutVertexArray, ho.x, ho.y, Fl.x, Fl.y, 0, 1, bt), bt += sc, Ou(this.layoutVertexArray, Dl.x, Dl.y, Fl.x, Fl.y, 0, 0, bt), Ou(this.layoutVertexArray, Dl.x, Dl.y, Fl.x, Fl.y, 0, 1, bt);
                                    const uc = vt.segment.vertexLength;
                                    this.indexArray.emplaceBack(uc, uc + 2, uc + 1), this.indexArray.emplaceBack(uc + 1, uc + 2, uc + 3), vt.segment.vertexLength += 4, vt.segment.primitiveLength += 2;
                                }
                            }
                        }
                        function Nu(le1, vt) {
                            for(let bt = 0; bt < vt.length; bt++){
                                const ls = vt[bt];
                                bt === vt.length - 1 && vt[0].x === ls.x && vt[0].y === ls.y || (le1.x += ls.x, le1.y += ls.y, le1.sampleCount++);
                            }
                        }
                        function $u(le1, vt) {
                            return le1.x === vt.x && (le1.x < 0 || le1.x > Ac) || le1.y === vt.y && (le1.y < 0 || le1.y > Ac);
                        }
                        function Uu(le1) {
                            return le1.every((le1)=>le1.x < 0) || le1.every((le1)=>le1.x > Ac) || le1.every((le1)=>le1.y < 0) || le1.every((le1)=>le1.y > Ac);
                        }
                        let jg;
                        ps("FillExtrusionBucket", Ru, {
                            omit: [
                                "layers",
                                "features"
                            ]
                        });
                        var Ug = {
                            get paint () {
                                return jg = jg || new Hs({
                                    "fill-extrusion-opacity": new js(qd["paint_fill-extrusion"]["fill-extrusion-opacity"]),
                                    "fill-extrusion-color": new Gs(qd["paint_fill-extrusion"]["fill-extrusion-color"]),
                                    "fill-extrusion-translate": new js(qd["paint_fill-extrusion"]["fill-extrusion-translate"]),
                                    "fill-extrusion-translate-anchor": new js(qd["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),
                                    "fill-extrusion-pattern": new Xs(qd["paint_fill-extrusion"]["fill-extrusion-pattern"]),
                                    "fill-extrusion-height": new Gs(qd["paint_fill-extrusion"]["fill-extrusion-height"]),
                                    "fill-extrusion-base": new Gs(qd["paint_fill-extrusion"]["fill-extrusion-base"]),
                                    "fill-extrusion-vertical-gradient": new js(qd["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])
                                });
                            }
                        };
                        class Gu extends Ks {
                            constructor(le1, vt){
                                super(le1, Ug, vt);
                            }
                            createBucket(le1) {
                                return new Ru(le1);
                            }
                            queryRadius() {
                                return nl(this.paint.get("fill-extrusion-translate"));
                            }
                            is3D() {
                                return !0;
                            }
                            queryIntersectsFeature({ queryGeometry: le1, feature: vt, featureState: bt, geometry: ls, transform: ho, pixelsToTileUnits: Dl, pixelPosMatrix: Fl }) {
                                const sc = il(le1, this.paint.get("fill-extrusion-translate"), this.paint.get("fill-extrusion-translate-anchor"), -ho.bearingInRadians, Dl), uc = this.paint.get("fill-extrusion-height").evaluate(vt, bt), mc = this.paint.get("fill-extrusion-base").evaluate(vt, bt), gc = function(le1, vt) {
                                    const bt = [];
                                    for (const ls of le1){
                                        const le1 = [
                                            ls.x,
                                            ls.y,
                                            0,
                                            1
                                        ];
                                        A(le1, le1, vt), bt.push(new r(le1[0] / le1[3], le1[1] / le1[3]));
                                    }
                                    return bt;
                                }(sc, Fl), Ac = function(le1, vt, bt, ls) {
                                    const ho = [], Dl = [], Fl = ls[8] * vt, sc = ls[9] * vt, uc = ls[10] * vt, mc = ls[11] * vt, gc = ls[8] * bt, Ac = ls[9] * bt, Ec = ls[10] * bt, kc = ls[11] * bt;
                                    for (const du of le1){
                                        const le1 = [], vt = [];
                                        for (const bt of du){
                                            const ho = bt.x, Dl = bt.y, du = ls[0] * ho + ls[4] * Dl + ls[12], _u = ls[1] * ho + ls[5] * Dl + ls[13], Md = ls[2] * ho + ls[6] * Dl + ls[14], Ld = ls[3] * ho + ls[7] * Dl + ls[15], Nd = Md + uc, Rd = Ld + mc, Od = du + gc, jd = _u + Ac, Ud = Md + Ec, Gd = Ld + kc, qd = new r((du + Fl) / Rd, (_u + sc) / Rd);
                                            qd.z = Nd / Rd, le1.push(qd);
                                            const Hd = new r(Od / Gd, jd / Gd);
                                            Hd.z = Ud / Gd, vt.push(Hd);
                                        }
                                        ho.push(le1), Dl.push(vt);
                                    }
                                    return [
                                        ho,
                                        Dl
                                    ];
                                }(ls, mc, uc, Fl);
                                return function(le1, vt, bt) {
                                    let ls = 1 / 0;
                                    Yo(bt, vt) && (ls = Yu(bt, vt[0]));
                                    for(let ho = 0; ho < vt.length; ho++){
                                        const Dl = vt[ho], Fl = le1[ho];
                                        for(let le1 = 0; le1 < Dl.length - 1; le1++){
                                            const vt = Dl[le1], ho = [
                                                vt,
                                                Dl[le1 + 1],
                                                Fl[le1 + 1],
                                                Fl[le1],
                                                vt
                                            ];
                                            Go(bt, ho) && (ls = Math.min(ls, Yu(bt, ho)));
                                        }
                                    }
                                    return ls !== 1 / 0 && ls;
                                }(Ac[0], Ac[1], gc);
                            }
                        }
                        function Xu(le1, vt) {
                            return le1.x * vt.x + le1.y * vt.y;
                        }
                        function Yu(le1, vt) {
                            if (1 === le1.length) {
                                let bt = 0;
                                const ls = vt[bt++];
                                let ho;
                                for(; !ho || ls.equals(ho);)if (ho = vt[bt++], !ho) return 1 / 0;
                                for(; bt < vt.length; bt++){
                                    const Dl = vt[bt], Fl = le1[0], sc = ho.sub(ls), uc = Dl.sub(ls), mc = Fl.sub(ls), gc = Xu(sc, sc), Ac = Xu(sc, uc), Ec = Xu(uc, uc), kc = Xu(mc, sc), du = Xu(mc, uc), _u = gc * Ec - Ac * Ac, Md = (Ec * kc - Ac * du) / _u, Ld = (gc * du - Ac * kc) / _u, Nd = ls.z * (1 - Md - Ld) + ho.z * Md + Dl.z * Ld;
                                    if (isFinite(Nd)) return Nd;
                                }
                                return 1 / 0;
                            }
                            {
                                let le1 = 1 / 0;
                                for (const bt of vt)le1 = Math.min(le1, bt.z);
                                return le1;
                            }
                        }
                        const Vg = na([
                            {
                                name: "a_pos_normal",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint8"
                            }
                        ], 4), { members: Gg } = Vg, qg = na([
                            {
                                name: "a_uv_x",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_split_index",
                                components: 1,
                                type: "Float32"
                            }
                        ]), { members: Hg } = qg, Wg = Math.cos(Math.PI / 180 * 37.5), Zg = Math.pow(2, 14) / .5;
                        class tc {
                            constructor(le1){
                                this.zoom = le1.zoom, this.overscaling = le1.overscaling, this.layers = le1.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = le1.index, this.hasDependencies = !1, this.patternFeatures = [], this.lineClipsArray = [], this.gradients = {}, this.layers.forEach((le1)=>{
                                    this.gradients[le1.id] = {};
                                }), this.layoutVertexArray = new Ga, this.layoutVertexArray2 = new Xa, this.indexArray = new to, this.programConfigurations = new Vo(le1.layers, le1.zoom), this.segments = new io, this.maxLineLength = 0, this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id);
                            }
                            populate(le1, vt, bt) {
                                this.hasDependencies = Ol("line", this.layers, vt) || this.hasLineDasharray(this.layers);
                                const ls = this.layers[0].layout.get("line-sort-key"), ho = !ls.isConstant(), Dl = [];
                                for (const { feature: Fl, id: sc, index: uc, sourceLayerIndex: mc } of le1){
                                    const le1 = this.layers[0]._featureFilter.needGeometry, vt = $o(Fl, le1);
                                    if (!this.layers[0]._featureFilter.filter(new Ps(this.zoom), vt, bt)) continue;
                                    const gc = ho ? ls.evaluate(vt, {}, bt) : void 0, Ac = {
                                        id: sc,
                                        properties: Fl.properties,
                                        type: Fl.type,
                                        sourceLayerIndex: mc,
                                        index: uc,
                                        geometry: le1 ? vt.geometry : No(Fl),
                                        patterns: {},
                                        dashes: {},
                                        sortKey: gc
                                    };
                                    Dl.push(Ac);
                                }
                                ho && Dl.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                                for (const Fl of Dl){
                                    const { geometry: ls, index: ho, sourceLayerIndex: Dl } = Fl;
                                    this.hasDependencies ? (Ol("line", this.layers, vt) ? Rl("line", this.layers, Fl, {
                                        zoom: this.zoom
                                    }, vt) : this.hasLineDasharray(this.layers) && this.addLineDashDependencies(this.layers, Fl, this.zoom, vt), this.patternFeatures.push(Fl)) : this.addFeature(Fl, ls, ho, bt, {}, {}, vt.subdivisionGranularity), vt.featureIndex.insert(le1[ho].feature, ls, ho, Dl, this.index);
                                }
                            }
                            update(le1, vt, bt, ls) {
                                this.stateDependentLayers.length && this.programConfigurations.updatePaintArrays(le1, vt, this.stateDependentLayers, {
                                    imagePositions: bt,
                                    dashPositions: ls
                                });
                            }
                            addFeatures(le1, vt, bt, ls) {
                                for (const ho of this.patternFeatures)this.addFeature(ho, ho.geometry, ho.index, vt, bt, ls, le1.subdivisionGranularity);
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length;
                            }
                            uploadPending() {
                                return !this.uploaded || this.programConfigurations.needsUpload;
                            }
                            upload(le1) {
                                this.uploaded || (0 !== this.layoutVertexArray2.length && (this.layoutVertexBuffer2 = le1.createVertexBuffer(this.layoutVertexArray2, Hg)), this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Gg), this.indexBuffer = le1.createIndexBuffer(this.indexArray)), this.programConfigurations.upload(le1), this.uploaded = !0;
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy());
                            }
                            lineFeatureClips(le1) {
                                if (le1.properties && Object.prototype.hasOwnProperty.call(le1.properties, "mapbox_clip_start") && Object.prototype.hasOwnProperty.call(le1.properties, "mapbox_clip_end")) return {
                                    start: +le1.properties.mapbox_clip_start,
                                    end: +le1.properties.mapbox_clip_end
                                };
                            }
                            addFeature(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = this.layers[0].layout, uc = sc.get("line-join").evaluate(le1, {}), mc = sc.get("line-cap"), gc = sc.get("line-miter-limit"), Ac = sc.get("line-round-limit");
                                this.lineClips = this.lineFeatureClips(le1);
                                for (const Ec of vt)this.addLine(Ec, le1, uc, mc, gc, Ac, ls, Fl);
                                this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length, le1, bt, {
                                    imagePositions: ho,
                                    dashPositions: Dl,
                                    canonical: ls
                                });
                            }
                            addLine(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                if (this.distance = 0, this.scaledDistance = 0, this.totalDistance = 0, le1 = gu(le1, Fl ? sc.line.getGranularityForZoomLevel(Fl.z) : 1), this.lineClips) {
                                    this.lineClipsArray.push(this.lineClips);
                                    for(let vt = 0; vt < le1.length - 1; vt++)this.totalDistance += le1[vt].dist(le1[vt + 1]);
                                    this.updateScaledDistance(), this.maxLineLength = Math.max(this.maxLineLength, this.totalDistance);
                                }
                                const uc = "Polygon" === Mu.types[vt.type];
                                let mc = le1.length;
                                for(; mc >= 2 && le1[mc - 1].equals(le1[mc - 2]);)mc--;
                                let gc = 0;
                                for(; gc < mc - 1 && le1[gc].equals(le1[gc + 1]);)gc++;
                                if (mc < (uc ? 3 : 2)) return;
                                "bevel" === bt && (ho = 1.05);
                                const Ac = this.overscaling <= 16 ? 122880 / (512 * this.overscaling) : 0, Ec = this.segments.prepareSegment(10 * mc, this.layoutVertexArray, this.indexArray);
                                let kc, du, _u, Md, Ld;
                                this.e1 = this.e2 = -1, uc && (kc = le1[mc - 2], Ld = le1[gc].sub(kc)._unit()._perp());
                                for(let Nd = gc; Nd < mc; Nd++){
                                    if (_u = Nd === mc - 1 ? uc ? le1[gc + 1] : void 0 : le1[Nd + 1], _u && le1[Nd].equals(_u)) continue;
                                    Ld && (Md = Ld), kc && (du = kc), kc = le1[Nd], Ld = _u ? _u.sub(kc)._unit()._perp() : Md, Md = Md || Ld;
                                    let vt = Md.add(Ld);
                                    0 === vt.x && 0 === vt.y || vt._unit();
                                    const Fl = Md.x * Ld.x + Md.y * Ld.y, sc = vt.x * Ld.x + vt.y * Ld.y, Rd = 0 !== sc ? 1 / sc : 1 / 0, Od = 2 * Math.sqrt(2 - 2 * sc), jd = sc < Wg && du && _u, Ud = Md.x * Ld.y - Md.y * Ld.x > 0;
                                    if (jd && Nd > gc) {
                                        const le1 = kc.dist(du);
                                        if (le1 > 2 * Ac) {
                                            const vt = kc.sub(kc.sub(du)._mult(Ac / le1)._round());
                                            this.updateDistance(du, vt), this.addCurrentVertex(vt, Md, 0, 0, Ec), du = vt;
                                        }
                                    }
                                    const Gd = du && _u;
                                    let qd = Gd ? bt : uc ? "butt" : ls;
                                    if (Gd && "round" === qd && (Rd < Dl ? qd = "miter" : Rd <= 2 && (qd = "fakeround")), "miter" === qd && Rd > ho && (qd = "bevel"), "bevel" === qd && (Rd > 2 && (qd = "flipbevel"), Rd < ho && (qd = "miter")), du && this.updateDistance(du, kc), "miter" === qd) vt._mult(Rd), this.addCurrentVertex(kc, vt, 0, 0, Ec);
                                    else if ("flipbevel" === qd) {
                                        if (Rd > 100) vt = Ld.mult(-1);
                                        else {
                                            const le1 = Rd * Md.add(Ld).mag() / Md.sub(Ld).mag();
                                            vt._perp()._mult(le1 * (Ud ? -1 : 1));
                                        }
                                        this.addCurrentVertex(kc, vt, 0, 0, Ec), this.addCurrentVertex(kc, vt.mult(-1), 0, 0, Ec);
                                    } else if ("bevel" === qd || "fakeround" === qd) {
                                        const le1 = -Math.sqrt(Rd * Rd - 1), vt = Ud ? le1 : 0, bt = Ud ? 0 : le1;
                                        if (du && this.addCurrentVertex(kc, Md, vt, bt, Ec), "fakeround" === qd) {
                                            const le1 = Math.round(180 * Od / Math.PI / 20);
                                            for(let vt = 1; vt < le1; vt++){
                                                let bt = vt / le1;
                                                if (.5 !== bt) {
                                                    const le1 = bt - .5;
                                                    bt += bt * le1 * (bt - 1) * ((1.0904 + Fl * (Fl * (3.55645 - 1.43519 * Fl) - 3.2452)) * le1 * le1 + (.848013 + Fl * (.215638 * Fl - 1.06021)));
                                                }
                                                const ls = Ld.sub(Md)._mult(bt)._add(Md)._unit()._mult(Ud ? -1 : 1);
                                                this.addHalfVertex(kc, ls.x, ls.y, !1, Ud, 0, Ec);
                                            }
                                        }
                                        _u && this.addCurrentVertex(kc, Ld, -vt, -bt, Ec);
                                    } else if ("butt" === qd) this.addCurrentVertex(kc, vt, 0, 0, Ec);
                                    else if ("square" === qd) {
                                        const le1 = du ? 1 : -1;
                                        this.addCurrentVertex(kc, vt, le1, le1, Ec);
                                    } else "round" === qd && (du && (this.addCurrentVertex(kc, Md, 0, 0, Ec), this.addCurrentVertex(kc, Md, 1, 1, Ec, !0)), _u && (this.addCurrentVertex(kc, Ld, -1, -1, Ec, !0), this.addCurrentVertex(kc, Ld, 0, 0, Ec)));
                                    if (jd && Nd < mc - 1) {
                                        const le1 = kc.dist(_u);
                                        if (le1 > 2 * Ac) {
                                            const vt = kc.add(_u.sub(kc)._mult(Ac / le1)._round());
                                            this.updateDistance(kc, vt), this.addCurrentVertex(vt, Ld, 0, 0, Ec), kc = vt;
                                        }
                                    }
                                }
                            }
                            addCurrentVertex(le1, vt, bt, ls, ho, Dl = !1) {
                                const Fl = vt.y * ls - vt.x, sc = -vt.y - vt.x * ls;
                                this.addHalfVertex(le1, vt.x + vt.y * bt, vt.y - vt.x * bt, Dl, !1, bt, ho), this.addHalfVertex(le1, Fl, sc, Dl, !0, -ls, ho), this.distance > Zg / 2 && 0 === this.totalDistance && (this.distance = 0, this.updateScaledDistance(), this.addCurrentVertex(le1, vt, bt, ls, ho, Dl));
                            }
                            addHalfVertex({ x: le1, y: vt }, bt, ls, ho, Dl, Fl, sc) {
                                const uc = .5 * (this.lineClips ? this.scaledDistance * (Zg - 1) : this.scaledDistance);
                                this.layoutVertexArray.emplaceBack((le1 << 1) + (ho ? 1 : 0), (vt << 1) + (Dl ? 1 : 0), Math.round(63 * bt) + 128, Math.round(63 * ls) + 128, 1 + (0 === Fl ? 0 : Fl < 0 ? -1 : 1) | (63 & uc) << 2, uc >> 6), this.lineClips && this.layoutVertexArray2.emplaceBack((this.scaledDistance - this.lineClips.start) / (this.lineClips.end - this.lineClips.start), this.lineClipsArray.length);
                                const mc = sc.vertexLength++;
                                this.e1 >= 0 && this.e2 >= 0 && (this.indexArray.emplaceBack(this.e1, mc, this.e2), sc.primitiveLength++), Dl ? this.e2 = mc : this.e1 = mc;
                            }
                            updateScaledDistance() {
                                this.scaledDistance = this.lineClips ? this.lineClips.start + (this.lineClips.end - this.lineClips.start) * this.distance / this.totalDistance : this.distance;
                            }
                            updateDistance(le1, vt) {
                                this.distance += le1.dist(vt), this.updateScaledDistance();
                            }
                            hasLineDasharray(le1) {
                                for (const vt of le1){
                                    const le1 = vt.paint.get("line-dasharray");
                                    if (le1 && !le1.isConstant()) return !0;
                                }
                                return !1;
                            }
                            addLineDashDependencies(le1, vt, bt, ls) {
                                for (const ho of le1){
                                    const le1 = ho.paint.get("line-dasharray");
                                    if (!le1 || "constant" === le1.value.kind) continue;
                                    const Dl = "round" === ho.layout.get("line-cap"), Fl = {
                                        dasharray: le1.value.evaluate({
                                            zoom: bt - 1
                                        }, vt, {}),
                                        round: Dl
                                    }, sc = {
                                        dasharray: le1.value.evaluate({
                                            zoom: bt
                                        }, vt, {}),
                                        round: Dl
                                    }, uc = {
                                        dasharray: le1.value.evaluate({
                                            zoom: bt + 1
                                        }, vt, {}),
                                        round: Dl
                                    }, mc = `${Fl.dasharray.join(",")},${Fl.round}`, gc = `${sc.dasharray.join(",")},${sc.round}`, Ac = `${uc.dasharray.join(",")},${uc.round}`;
                                    ls.dashDependencies[mc] = Fl, ls.dashDependencies[gc] = sc, ls.dashDependencies[Ac] = uc, vt.dashes[ho.id] = {
                                        min: mc,
                                        mid: gc,
                                        max: Ac
                                    };
                                }
                            }
                        }
                        let Yg, Qg;
                        ps("LineBucket", tc, {
                            omit: [
                                "layers",
                                "patternFeatures"
                            ]
                        });
                        var Xg = {
                            get paint () {
                                return Qg = Qg || new Hs({
                                    "line-opacity": new Gs(qd.paint_line["line-opacity"]),
                                    "line-color": new Gs(qd.paint_line["line-color"]),
                                    "line-translate": new js(qd.paint_line["line-translate"]),
                                    "line-translate-anchor": new js(qd.paint_line["line-translate-anchor"]),
                                    "line-width": new Gs(qd.paint_line["line-width"]),
                                    "line-gap-width": new Gs(qd.paint_line["line-gap-width"]),
                                    "line-offset": new Gs(qd.paint_line["line-offset"]),
                                    "line-blur": new Gs(qd.paint_line["line-blur"]),
                                    "line-dasharray": new Xs(qd.paint_line["line-dasharray"]),
                                    "line-pattern": new Xs(qd.paint_line["line-pattern"]),
                                    "line-gradient": new Zs(qd.paint_line["line-gradient"])
                                });
                            },
                            get layout () {
                                return Yg = Yg || new Hs({
                                    "line-cap": new js(qd.layout_line["line-cap"]),
                                    "line-join": new Gs(qd.layout_line["line-join"]),
                                    "line-miter-limit": new js(qd.layout_line["line-miter-limit"]),
                                    "line-round-limit": new js(qd.layout_line["line-round-limit"]),
                                    "line-sort-key": new Gs(qd.layout_line["line-sort-key"])
                                });
                            }
                        };
                        class ic extends Gs {
                            possiblyEvaluate(le1, vt) {
                                return vt = new Ps(Math.floor(vt.zoom), {
                                    now: vt.now,
                                    fadeDuration: vt.fadeDuration,
                                    zoomHistory: vt.zoomHistory,
                                    transition: vt.transition
                                }), super.possiblyEvaluate(le1, vt);
                            }
                            evaluate(le1, vt, bt, ls) {
                                return vt = O({}, vt, {
                                    zoom: Math.floor(vt.zoom)
                                }), super.evaluate(le1, vt, bt, ls);
                            }
                        }
                        let Kg;
                        class ac extends Ks {
                            constructor(le1, vt){
                                super(le1, Xg, vt), this.gradientVersion = 0, Kg || (Kg = new ic(Xg.paint.properties["line-width"].specification), Kg.useIntegerZoom = !0);
                            }
                            _handleSpecialPaintPropertyUpdate(le1) {
                                if ("line-gradient" === le1) {
                                    const le1 = this.gradientExpression();
                                    this.stepInterpolant = !!function(le1) {
                                        return void 0 !== le1._styleExpression;
                                    }(le1) && le1._styleExpression.expression instanceof or, this.gradientVersion = (this.gradientVersion + 1) % Number.MAX_SAFE_INTEGER;
                                }
                            }
                            gradientExpression() {
                                return this._transitionablePaint._values["line-gradient"].value.expression;
                            }
                            recalculate(le1, vt) {
                                super.recalculate(le1, vt), this.paint._values["line-floorwidth"] = Kg.possiblyEvaluate(this._transitioningPaint._values["line-width"].value, le1);
                            }
                            createBucket(le1) {
                                return new tc(le1);
                            }
                            queryRadius(le1) {
                                const vt = le1, bt = oc(rl("line-width", this, vt), rl("line-gap-width", this, vt)), ls = rl("line-offset", this, vt);
                                return bt / 2 + Math.abs(ls) + nl(this.paint.get("line-translate"));
                            }
                            queryIntersectsFeature({ queryGeometry: le1, feature: vt, featureState: bt, geometry: ls, transform: ho, pixelsToTileUnits: Dl }) {
                                const Fl = il(le1, this.paint.get("line-translate"), this.paint.get("line-translate-anchor"), -ho.bearingInRadians, Dl), sc = Dl / 2 * oc(this.paint.get("line-width").evaluate(vt, bt), this.paint.get("line-gap-width").evaluate(vt, bt)), uc = this.paint.get("line-offset").evaluate(vt, bt);
                                return uc && (ls = function(le1, vt) {
                                    const bt = [];
                                    for(let ls = 0; ls < le1.length; ls++){
                                        const ho = sl(le1[ls]), Dl = [];
                                        for(let le1 = 0; le1 < ho.length; le1++){
                                            const bt = ho[le1], ls = ho[le1 - 1], Fl = ho[le1 + 1], sc = 0 === le1 ? new r(0, 0) : bt.sub(ls)._unit()._perp(), uc = le1 === ho.length - 1 ? new r(0, 0) : Fl.sub(bt)._unit()._perp(), mc = sc._add(uc)._unit(), gc = mc.x * uc.x + mc.y * uc.y;
                                            0 !== gc && mc._mult(1 / gc), Dl.push(mc._mult(vt)._add(bt));
                                        }
                                        bt.push(Dl);
                                    }
                                    return bt;
                                }(ls, uc * Dl)), function(le1, vt, bt) {
                                    for(let ls = 0; ls < vt.length; ls++){
                                        const ho = vt[ls];
                                        if (le1.length >= 3) {
                                            for(let vt = 0; vt < ho.length; vt++)if (tl(le1, ho[vt])) return !0;
                                        }
                                        if (Zo(le1, ho, bt)) return !0;
                                    }
                                    return !1;
                                }(Fl, ls, sc);
                            }
                            isTileClipped() {
                                return !0;
                            }
                        }
                        function oc(le1, vt) {
                            return vt > 0 ? vt + 2 * le1 : le1;
                        }
                        const Jg = na([
                            {
                                name: "a_pos_offset",
                                components: 4,
                                type: "Int16"
                            },
                            {
                                name: "a_data",
                                components: 4,
                                type: "Uint16"
                            },
                            {
                                name: "a_pixeloffset",
                                components: 4,
                                type: "Int16"
                            }
                        ], 4), $g = na([
                            {
                                name: "a_projected_pos",
                                components: 3,
                                type: "Float32"
                            }
                        ], 4);
                        na([
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint32"
                            }
                        ], 4);
                        const eA = na([
                            {
                                name: "a_placed",
                                components: 2,
                                type: "Uint8"
                            },
                            {
                                name: "a_shift",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_box_real",
                                components: 2,
                                type: "Int16"
                            }
                        ]);
                        na([
                            {
                                type: "Int16",
                                name: "anchorPointX"
                            },
                            {
                                type: "Int16",
                                name: "anchorPointY"
                            },
                            {
                                type: "Int16",
                                name: "x1"
                            },
                            {
                                type: "Int16",
                                name: "y1"
                            },
                            {
                                type: "Int16",
                                name: "x2"
                            },
                            {
                                type: "Int16",
                                name: "y2"
                            },
                            {
                                type: "Uint32",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "sourceLayerIndex"
                            },
                            {
                                type: "Uint16",
                                name: "bucketIndex"
                            }
                        ]);
                        const tA = na([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_anchor_pos",
                                components: 2,
                                type: "Int16"
                            },
                            {
                                name: "a_extrude",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4), iA = na([
                            {
                                name: "a_pos",
                                components: 2,
                                type: "Float32"
                            },
                            {
                                name: "a_radius",
                                components: 1,
                                type: "Float32"
                            },
                            {
                                name: "a_flags",
                                components: 2,
                                type: "Int16"
                            }
                        ], 4);
                        function fc(le1, vt, bt) {
                            return le1.sections.forEach((le1)=>{
                                le1.text = function(le1, vt, bt) {
                                    const ls = vt.layout.get("text-transform").evaluate(bt, {});
                                    return "uppercase" === ls ? le1 = le1.toLocaleUpperCase() : "lowercase" === ls && (le1 = le1.toLocaleLowerCase()), Jm.applyArabicShaping && (le1 = Jm.applyArabicShaping(le1)), le1;
                                }(le1.text, vt, bt);
                            }), le1;
                        }
                        na([
                            {
                                name: "triangle",
                                components: 3,
                                type: "Uint16"
                            }
                        ]), na([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Uint16",
                                name: "glyphStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numGlyphs"
                            },
                            {
                                type: "Uint32",
                                name: "vertexStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineStartIndex"
                            },
                            {
                                type: "Uint32",
                                name: "lineLength"
                            },
                            {
                                type: "Uint16",
                                name: "segment"
                            },
                            {
                                type: "Uint16",
                                name: "lowerSize"
                            },
                            {
                                type: "Uint16",
                                name: "upperSize"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetX"
                            },
                            {
                                type: "Float32",
                                name: "lineOffsetY"
                            },
                            {
                                type: "Uint8",
                                name: "writingMode"
                            },
                            {
                                type: "Uint8",
                                name: "placedOrientation"
                            },
                            {
                                type: "Uint8",
                                name: "hidden"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Int16",
                                name: "associatedIconIndex"
                            }
                        ]), na([
                            {
                                type: "Int16",
                                name: "anchorX"
                            },
                            {
                                type: "Int16",
                                name: "anchorY"
                            },
                            {
                                type: "Int16",
                                name: "rightJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "centerJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "leftJustifiedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedTextSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "placedIconSymbolIndex"
                            },
                            {
                                type: "Int16",
                                name: "verticalPlacedIconSymbolIndex"
                            },
                            {
                                type: "Uint16",
                                name: "key"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalTextBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "iconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "verticalIconBoxEndIndex"
                            },
                            {
                                type: "Uint16",
                                name: "featureIndex"
                            },
                            {
                                type: "Uint16",
                                name: "numHorizontalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalGlyphVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "numVerticalIconVertices"
                            },
                            {
                                type: "Uint16",
                                name: "useRuntimeCollisionCircles"
                            },
                            {
                                type: "Uint32",
                                name: "crossTileID"
                            },
                            {
                                type: "Float32",
                                name: "textBoxScale"
                            },
                            {
                                type: "Float32",
                                name: "collisionCircleDiameter"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetStartIndex"
                            },
                            {
                                type: "Uint16",
                                name: "textAnchorOffsetEndIndex"
                            }
                        ]), na([
                            {
                                type: "Float32",
                                name: "offsetX"
                            }
                        ]), na([
                            {
                                type: "Int16",
                                name: "x"
                            },
                            {
                                type: "Int16",
                                name: "y"
                            },
                            {
                                type: "Int16",
                                name: "tileUnitDistanceFromAnchor"
                            }
                        ]), na([
                            {
                                type: "Uint16",
                                name: "textAnchor"
                            },
                            {
                                type: "Float32",
                                components: 2,
                                name: "textOffset"
                            }
                        ]);
                        var nA = 24;
                        const rA = {
                            "!": "\ufe15",
                            "#": "\uff03",
                            $: "\uff04",
                            "%": "\uff05",
                            "&": "\uff06",
                            "(": "\ufe35",
                            ")": "\ufe36",
                            "*": "\uff0a",
                            "+": "\uff0b",
                            ",": "\ufe10",
                            "-": "\ufe32",
                            ".": "\u30fb",
                            "/": "\uff0f",
                            ":": "\ufe13",
                            ";": "\ufe14",
                            "<": "\ufe3f",
                            "=": "\uff1d",
                            ">": "\ufe40",
                            "?": "\ufe16",
                            "@": "\uff20",
                            "[": "\ufe47",
                            "\\": "\uff3c",
                            "]": "\ufe48",
                            "^": "\uff3e",
                            _: "\ufe33",
                            "`": "\uff40",
                            "{": "\ufe37",
                            "|": "\u2015",
                            "}": "\ufe38",
                            "~": "\uff5e",
                            "\xa2": "\uffe0",
                            "\xa3": "\uffe1",
                            "\xa5": "\uffe5",
                            "\xa6": "\uffe4",
                            "\xac": "\uffe2",
                            "\xaf": "\uffe3",
                            "\u2013": "\ufe32",
                            "\u2014": "\ufe31",
                            "\u2018": "\ufe43",
                            "\u2019": "\ufe44",
                            "\u201c": "\ufe41",
                            "\u201d": "\ufe42",
                            "\u2026": "\ufe19",
                            "\u22ef": "\ufe19",
                            "\u2027": "\u30fb",
                            "\u20a9": "\uffe6",
                            "\u3001": "\ufe11",
                            "\u3002": "\ufe12",
                            "\u3008": "\ufe3f",
                            "\u3009": "\ufe40",
                            "\u300a": "\ufe3d",
                            "\u300b": "\ufe3e",
                            "\u300c": "\ufe41",
                            "\u300d": "\ufe42",
                            "\u300e": "\ufe43",
                            "\u300f": "\ufe44",
                            "\u3010": "\ufe3b",
                            "\u3011": "\ufe3c",
                            "\u3014": "\ufe39",
                            "\u3015": "\ufe3a",
                            "\u3016": "\ufe17",
                            "\u3017": "\ufe18",
                            "\uff01": "\ufe15",
                            "\uff08": "\ufe35",
                            "\uff09": "\ufe36",
                            "\uff0c": "\ufe10",
                            "\uff0d": "\ufe32",
                            "\uff0e": "\u30fb",
                            "\uff1a": "\ufe13",
                            "\uff1b": "\ufe14",
                            "\uff1c": "\ufe3f",
                            "\uff1e": "\ufe40",
                            "\uff1f": "\ufe16",
                            "\uff3b": "\ufe47",
                            "\uff3d": "\ufe48",
                            "\uff3f": "\ufe33",
                            "\uff5b": "\ufe37",
                            "\uff5c": "\u2015",
                            "\uff5d": "\ufe38",
                            "\uff5f": "\ufe35",
                            "\uff60": "\ufe36",
                            "\uff61": "\ufe12",
                            "\uff62": "\ufe41",
                            "\uff63": "\ufe42"
                        }, aA = {
                            10: !0,
                            32: !0,
                            38: !0,
                            41: !0,
                            43: !0,
                            45: !0,
                            47: !0,
                            173: !0,
                            183: !0,
                            8203: !0,
                            8208: !0,
                            8211: !0,
                            8231: !0
                        }, sA = {
                            40: !0
                        };
                        function xc(le1, vt, bt, ls, ho, Dl) {
                            if ("fontStack" in vt) {
                                const ls = bt[vt.fontStack], Dl = ls && ls[le1];
                                return Dl ? Dl.metrics.advance * vt.scale + ho : 0;
                            }
                            {
                                const le1 = ls[vt.imageName];
                                return le1 ? le1.displaySize[0] * vt.scale * nA / Dl + ho : 0;
                            }
                        }
                        function vc(le1, vt, bt, ls) {
                            const ho = Math.pow(le1 - vt, 2);
                            return ls ? le1 < vt ? ho / 2 : 2 * ho : ho + Math.abs(bt) * bt;
                        }
                        function bc(le1, vt, bt) {
                            let ls = 0;
                            return 10 === le1 && (ls -= 1e4), bt && (ls += 150), 40 !== le1 && 65288 !== le1 || (ls += 50), 41 !== vt && 65289 !== vt || (ls += 50), ls;
                        }
                        function wc(le1, vt, bt, ls, ho, Dl) {
                            let Fl = null, sc = vc(vt, bt, ho, Dl);
                            for (const uc of ls){
                                const le1 = vc(vt - uc.x, bt, ho, Dl) + uc.badness;
                                le1 <= sc && (Fl = uc, sc = le1);
                            }
                            return {
                                index: le1,
                                x: vt,
                                priorBreak: Fl,
                                badness: sc
                            };
                        }
                        function _c(le1) {
                            return le1 ? _c(le1.priorBreak).concat(le1.index) : [];
                        }
                        class Sc {
                            constructor(le1 = "", vt = [], bt = []){
                                this.text = le1, this.sections = vt, this.sectionIndex = bt, this.imageSectionID = null;
                            }
                            static fromFeature(le1, vt) {
                                const bt = new Sc;
                                for(let ls = 0; ls < le1.sections.length; ls++){
                                    const ho = le1.sections[ls];
                                    ho.image ? bt.addImageSection(ho) : bt.addTextSection(ho, vt);
                                }
                                return bt;
                            }
                            length() {
                                return [
                                    ...this.text
                                ].length;
                            }
                            getSection(le1) {
                                return this.sections[this.sectionIndex[le1]];
                            }
                            getSectionIndex(le1) {
                                return this.sectionIndex[le1];
                            }
                            verticalizePunctuation() {
                                this.text = function(le1) {
                                    let vt = "", bt = {
                                        premature: !0,
                                        value: void 0
                                    };
                                    const ls = le1[Symbol.iterator]();
                                    let ho = ls.next();
                                    const Dl = le1[Symbol.iterator]();
                                    Dl.next();
                                    let Fl = Dl.next();
                                    for(; !ho.done;)vt += !Fl.done && Ts(Fl.value.codePointAt(0)) && !rA[Fl.value] || !bt.premature && Ts(bt.value.codePointAt(0)) && !rA[bt.value] || !rA[ho.value] ? ho.value : rA[ho.value], bt = {
                                        value: ho.value,
                                        premature: !1
                                    }, ho = ls.next(), Fl = Dl.next();
                                    return vt;
                                }(this.text);
                            }
                            hasZeroWidthSpaces() {
                                return this.text.includes("\u200b");
                            }
                            trim() {
                                const le1 = this.text.match(/^\s*/), vt = le1 ? le1[0].length : 0, bt = this.text.match(/\S\s*$/), ls = bt ? bt[0].length - 1 : 0;
                                this.text = this.text.substring(vt, this.text.length - ls), this.sectionIndex = this.sectionIndex.slice(vt, this.sectionIndex.length - ls);
                            }
                            substring(le1, vt) {
                                const bt = [
                                    ...this.text
                                ].slice(le1, vt).join(""), ls = this.sectionIndex.slice(le1, vt);
                                return new Sc(bt, this.sections, ls);
                            }
                            toCodeUnitIndex(le1) {
                                return [
                                    ...this.text
                                ].slice(0, le1).join("").length;
                            }
                            toString() {
                                return this.text;
                            }
                            getMaxScale() {
                                return this.sectionIndex.reduce((le1, vt)=>Math.max(le1, this.sections[vt].scale), 0);
                            }
                            getMaxImageSize(le1) {
                                let vt = 0, bt = 0;
                                for(let ls = 0; ls < this.length(); ls++){
                                    const ho = this.getSection(ls);
                                    if ("imageName" in ho) {
                                        const ls = le1[ho.imageName];
                                        if (!ls) continue;
                                        const Dl = ls.displaySize;
                                        vt = Math.max(vt, Dl[0]), bt = Math.max(bt, Dl[1]);
                                    }
                                }
                                return {
                                    maxImageWidth: vt,
                                    maxImageHeight: bt
                                };
                            }
                            addTextSection(le1, vt) {
                                this.text += le1.text, this.sections.push({
                                    scale: le1.scale || 1,
                                    verticalAlign: le1.verticalAlign || "bottom",
                                    fontStack: le1.fontStack || vt
                                });
                                const bt = this.sections.length - 1;
                                this.sectionIndex.push(...[
                                    ...le1.text
                                ].map(()=>bt));
                            }
                            addImageSection(le1) {
                                const vt = le1.image ? le1.image.name : "";
                                if (0 === vt.length) return void j("Can't add FormattedSection with an empty image.");
                                const bt = this.getNextImageSectionCharCode();
                                bt ? (this.text += String.fromCharCode(bt), this.sections.push({
                                    scale: 1,
                                    verticalAlign: le1.verticalAlign || "bottom",
                                    imageName: vt
                                }), this.sectionIndex.push(this.sections.length - 1)) : j("Reached maximum number of images 6401");
                            }
                            getNextImageSectionCharCode() {
                                return this.imageSectionID ? this.imageSectionID >= 63743 ? null : ++this.imageSectionID : (this.imageSectionID = 57344, this.imageSectionID);
                            }
                            determineLineBreaks(le1, vt, bt, ls, ho) {
                                const Dl = [], Fl = this.determineAverageLineWidth(le1, vt, bt, ls, ho), sc = this.hasZeroWidthSpaces();
                                let uc = 0, mc = 0;
                                const gc = this.text[Symbol.iterator]();
                                let Ac = gc.next();
                                const Ec = this.text[Symbol.iterator]();
                                Ec.next();
                                let kc = Ec.next();
                                const du = this.text[Symbol.iterator]();
                                du.next(), du.next();
                                let _u = du.next();
                                for(; !Ac.done;){
                                    const vt = this.getSection(mc), Md = Ac.value.codePointAt(0);
                                    if (ws(Md) || (uc += xc(Md, vt, bt, ls, le1, ho)), !kc.done) {
                                        const le1 = vs(Md), bt = kc.value.codePointAt(0);
                                        (aA[Md] || le1 || "imageName" in vt || !_u.done && sA[bt]) && Dl.push(wc(mc + 1, uc, Fl, Dl, bc(Md, bt, le1 && sc), !1));
                                    }
                                    mc++, Ac = gc.next(), kc = Ec.next(), _u = du.next();
                                }
                                return _c(wc(this.length(), uc, Fl, Dl, 0, !0));
                            }
                            determineAverageLineWidth(le1, vt, bt, ls, ho) {
                                let Dl = 0, Fl = 0;
                                for (const sc of this.text){
                                    const vt = this.getSection(Fl);
                                    Dl += xc(sc.codePointAt(0), vt, bt, ls, le1, ho), Fl++;
                                }
                                return Dl / Math.max(1, Math.ceil(Dl / vt));
                            }
                        }
                        const oA = 4294967296, lA = 1 / oA, cA = "undefined" == typeof TextDecoder ? null : new TextDecoder("utf-8");
                        class Tc {
                            constructor(le1 = new Uint8Array(16)){
                                this.buf = ArrayBuffer.isView(le1) ? le1 : new Uint8Array(le1), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
                            }
                            readFields(le1, vt, bt = this.length) {
                                for(; this.pos < bt;){
                                    const bt = this.readVarint(), ls = bt >> 3, ho = this.pos;
                                    this.type = 7 & bt, le1(ls, vt, this), this.pos === ho && this.skip(bt);
                                }
                                return vt;
                            }
                            readMessage(le1, vt) {
                                return this.readFields(le1, vt, this.readVarint() + this.pos);
                            }
                            readFixed32() {
                                const le1 = this.dataView.getUint32(this.pos, !0);
                                return this.pos += 4, le1;
                            }
                            readSFixed32() {
                                const le1 = this.dataView.getInt32(this.pos, !0);
                                return this.pos += 4, le1;
                            }
                            readFixed64() {
                                const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * oA;
                                return this.pos += 8, le1;
                            }
                            readSFixed64() {
                                const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * oA;
                                return this.pos += 8, le1;
                            }
                            readFloat() {
                                const le1 = this.dataView.getFloat32(this.pos, !0);
                                return this.pos += 4, le1;
                            }
                            readDouble() {
                                const le1 = this.dataView.getFloat64(this.pos, !0);
                                return this.pos += 8, le1;
                            }
                            readVarint(le1) {
                                const vt = this.buf;
                                let bt, ls;
                                return ls = vt[this.pos++], bt = 127 & ls, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 7, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 14, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 21, ls < 128 ? bt : (ls = vt[this.pos], bt |= (15 & ls) << 28, function(le1, vt, bt) {
                                    const ls = bt.buf;
                                    let ho, Dl;
                                    if (Dl = ls[bt.pos++], ho = (112 & Dl) >> 4, Dl < 128) return Ic(le1, ho, vt);
                                    if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 3, Dl < 128) return Ic(le1, ho, vt);
                                    if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 10, Dl < 128) return Ic(le1, ho, vt);
                                    if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 17, Dl < 128) return Ic(le1, ho, vt);
                                    if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 24, Dl < 128) return Ic(le1, ho, vt);
                                    if (Dl = ls[bt.pos++], ho |= (1 & Dl) << 31, Dl < 128) return Ic(le1, ho, vt);
                                    throw new Error("Expected varint not more than 10 bytes");
                                }(bt, le1, this)))));
                            }
                            readVarint64() {
                                return this.readVarint(!0);
                            }
                            readSVarint() {
                                const le1 = this.readVarint();
                                return le1 % 2 == 1 ? (le1 + 1) / -2 : le1 / 2;
                            }
                            readBoolean() {
                                return Boolean(this.readVarint());
                            }
                            readString() {
                                const le1 = this.readVarint() + this.pos, vt = this.pos;
                                return this.pos = le1, le1 - vt >= 12 && cA ? cA.decode(this.buf.subarray(vt, le1)) : function(le1, vt, bt) {
                                    let ls = "", ho = vt;
                                    for(; ho < bt;){
                                        const vt = le1[ho];
                                        let Dl, Fl, sc, uc = null, mc = vt > 239 ? 4 : vt > 223 ? 3 : vt > 191 ? 2 : 1;
                                        if (ho + mc > bt) break;
                                        1 === mc ? vt < 128 && (uc = vt) : 2 === mc ? (Dl = le1[ho + 1], 128 == (192 & Dl) && (uc = (31 & vt) << 6 | 63 & Dl, uc <= 127 && (uc = null))) : 3 === mc ? (Dl = le1[ho + 1], Fl = le1[ho + 2], 128 == (192 & Dl) && 128 == (192 & Fl) && (uc = (15 & vt) << 12 | (63 & Dl) << 6 | 63 & Fl, (uc <= 2047 || uc >= 55296 && uc <= 57343) && (uc = null))) : 4 === mc && (Dl = le1[ho + 1], Fl = le1[ho + 2], sc = le1[ho + 3], 128 == (192 & Dl) && 128 == (192 & Fl) && 128 == (192 & sc) && (uc = (15 & vt) << 18 | (63 & Dl) << 12 | (63 & Fl) << 6 | 63 & sc, (uc <= 65535 || uc >= 1114112) && (uc = null))), null === uc ? (uc = 65533, mc = 1) : uc > 65535 && (uc -= 65536, ls += String.fromCharCode(uc >>> 10 & 1023 | 55296), uc = 56320 | 1023 & uc), ls += String.fromCharCode(uc), ho += mc;
                                    }
                                    return ls;
                                }(this.buf, vt, le1);
                            }
                            readBytes() {
                                const le1 = this.readVarint() + this.pos, vt = this.buf.subarray(this.pos, le1);
                                return this.pos = le1, vt;
                            }
                            readPackedVarint(le1 = [], vt) {
                                const bt = this.readPackedEnd();
                                for(; this.pos < bt;)le1.push(this.readVarint(vt));
                                return le1;
                            }
                            readPackedSVarint(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readSVarint());
                                return le1;
                            }
                            readPackedBoolean(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readBoolean());
                                return le1;
                            }
                            readPackedFloat(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readFloat());
                                return le1;
                            }
                            readPackedDouble(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readDouble());
                                return le1;
                            }
                            readPackedFixed32(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readFixed32());
                                return le1;
                            }
                            readPackedSFixed32(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readSFixed32());
                                return le1;
                            }
                            readPackedFixed64(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readFixed64());
                                return le1;
                            }
                            readPackedSFixed64(le1 = []) {
                                const vt = this.readPackedEnd();
                                for(; this.pos < vt;)le1.push(this.readSFixed64());
                                return le1;
                            }
                            readPackedEnd() {
                                return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
                            }
                            skip(le1) {
                                const vt = 7 & le1;
                                if (0 === vt) for(; this.buf[this.pos++] > 127;);
                                else if (2 === vt) this.pos = this.readVarint() + this.pos;
                                else if (5 === vt) this.pos += 4;
                                else {
                                    if (1 !== vt) throw new Error(`Unimplemented type: ${vt}`);
                                    this.pos += 8;
                                }
                            }
                            writeTag(le1, vt) {
                                this.writeVarint(le1 << 3 | vt);
                            }
                            realloc(le1) {
                                let vt = this.length || 16;
                                for(; vt < this.pos + le1;)vt *= 2;
                                if (vt !== this.length) {
                                    const le1 = new Uint8Array(vt);
                                    le1.set(this.buf), this.buf = le1, this.dataView = new DataView(le1.buffer), this.length = vt;
                                }
                            }
                            finish() {
                                return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                            }
                            writeFixed32(le1) {
                                this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                            }
                            writeSFixed32(le1) {
                                this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                            }
                            writeFixed64(le1) {
                                this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * lA), !0), this.pos += 8;
                            }
                            writeSFixed64(le1) {
                                this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * lA), !0), this.pos += 8;
                            }
                            writeVarint(le1) {
                                (le1 = +le1 || 0) > 268435455 || le1 < 0 ? function(le1, vt) {
                                    let bt, ls;
                                    if (le1 >= 0 ? (bt = le1 % 4294967296 | 0, ls = le1 / 4294967296 | 0) : (bt = ~(-le1 % 4294967296), ls = ~(-le1 / 4294967296), 4294967295 ^ bt ? bt = bt + 1 | 0 : (bt = 0, ls = ls + 1 | 0)), le1 >= 0x10000000000000000 || le1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                                    vt.realloc(10), function(le1, vt, bt) {
                                        bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, bt.buf[bt.pos] = 127 & (le1 >>>= 7);
                                    }(bt, 0, vt), function(le1, vt) {
                                        const bt = (7 & le1) << 4;
                                        vt.buf[vt.pos++] |= bt | ((le1 >>>= 3) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), le1 && (vt.buf[vt.pos++] = 127 & le1)))));
                                    }(ls, vt);
                                }(le1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & le1 | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = le1 >>> 7 & 127))));
                            }
                            writeSVarint(le1) {
                                this.writeVarint(le1 < 0 ? 2 * -le1 - 1 : 2 * le1);
                            }
                            writeBoolean(le1) {
                                this.writeVarint(+le1);
                            }
                            writeString(le1) {
                                le1 = String(le1), this.realloc(4 * le1.length), this.pos++;
                                const vt = this.pos;
                                this.pos = function(le1, vt, bt) {
                                    for(let ls, ho, Dl = 0; Dl < vt.length; Dl++){
                                        if (ls = vt.charCodeAt(Dl), ls > 55295 && ls < 57344) {
                                            if (!ho) {
                                                ls > 56319 || Dl + 1 === vt.length ? (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189) : ho = ls;
                                                continue;
                                            }
                                            if (ls < 56320) {
                                                le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = ls;
                                                continue;
                                            }
                                            ls = ho - 55296 << 10 | ls - 56320 | 65536, ho = null;
                                        } else ho && (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = null);
                                        ls < 128 ? le1[bt++] = ls : (ls < 2048 ? le1[bt++] = ls >> 6 | 192 : (ls < 65536 ? le1[bt++] = ls >> 12 | 224 : (le1[bt++] = ls >> 18 | 240, le1[bt++] = ls >> 12 & 63 | 128), le1[bt++] = ls >> 6 & 63 | 128), le1[bt++] = 63 & ls | 128);
                                    }
                                    return bt;
                                }(this.buf, le1, this.pos);
                                const bt = this.pos - vt;
                                bt >= 128 && Mc(vt, bt, this), this.pos = vt - 1, this.writeVarint(bt), this.pos += bt;
                            }
                            writeFloat(le1) {
                                this.realloc(4), this.dataView.setFloat32(this.pos, le1, !0), this.pos += 4;
                            }
                            writeDouble(le1) {
                                this.realloc(8), this.dataView.setFloat64(this.pos, le1, !0), this.pos += 8;
                            }
                            writeBytes(le1) {
                                const vt = le1.length;
                                this.writeVarint(vt), this.realloc(vt);
                                for(let bt = 0; bt < vt; bt++)this.buf[this.pos++] = le1[bt];
                            }
                            writeRawMessage(le1, vt) {
                                this.pos++;
                                const bt = this.pos;
                                le1(vt, this);
                                const ls = this.pos - bt;
                                ls >= 128 && Mc(bt, ls, this), this.pos = bt - 1, this.writeVarint(ls), this.pos += ls;
                            }
                            writeMessage(le1, vt, bt) {
                                this.writeTag(le1, 2), this.writeRawMessage(vt, bt);
                            }
                            writePackedVarint(le1, vt) {
                                vt.length && this.writeMessage(le1, Fc, vt);
                            }
                            writePackedSVarint(le1, vt) {
                                vt.length && this.writeMessage(le1, Dc, vt);
                            }
                            writePackedBoolean(le1, vt) {
                                vt.length && this.writeMessage(le1, Bc, vt);
                            }
                            writePackedFloat(le1, vt) {
                                vt.length && this.writeMessage(le1, zc, vt);
                            }
                            writePackedDouble(le1, vt) {
                                vt.length && this.writeMessage(le1, Pc, vt);
                            }
                            writePackedFixed32(le1, vt) {
                                vt.length && this.writeMessage(le1, Vc, vt);
                            }
                            writePackedSFixed32(le1, vt) {
                                vt.length && this.writeMessage(le1, Cc, vt);
                            }
                            writePackedFixed64(le1, vt) {
                                vt.length && this.writeMessage(le1, Lc, vt);
                            }
                            writePackedSFixed64(le1, vt) {
                                vt.length && this.writeMessage(le1, Oc, vt);
                            }
                            writeBytesField(le1, vt) {
                                this.writeTag(le1, 2), this.writeBytes(vt);
                            }
                            writeFixed32Field(le1, vt) {
                                this.writeTag(le1, 5), this.writeFixed32(vt);
                            }
                            writeSFixed32Field(le1, vt) {
                                this.writeTag(le1, 5), this.writeSFixed32(vt);
                            }
                            writeFixed64Field(le1, vt) {
                                this.writeTag(le1, 1), this.writeFixed64(vt);
                            }
                            writeSFixed64Field(le1, vt) {
                                this.writeTag(le1, 1), this.writeSFixed64(vt);
                            }
                            writeVarintField(le1, vt) {
                                this.writeTag(le1, 0), this.writeVarint(vt);
                            }
                            writeSVarintField(le1, vt) {
                                this.writeTag(le1, 0), this.writeSVarint(vt);
                            }
                            writeStringField(le1, vt) {
                                this.writeTag(le1, 2), this.writeString(vt);
                            }
                            writeFloatField(le1, vt) {
                                this.writeTag(le1, 5), this.writeFloat(vt);
                            }
                            writeDoubleField(le1, vt) {
                                this.writeTag(le1, 1), this.writeDouble(vt);
                            }
                            writeBooleanField(le1, vt) {
                                this.writeVarintField(le1, +vt);
                            }
                        }
                        function Ic(le1, vt, bt) {
                            return bt ? 4294967296 * vt + (le1 >>> 0) : 4294967296 * (vt >>> 0) + (le1 >>> 0);
                        }
                        function Mc(le1, vt, bt) {
                            const ls = vt <= 16383 ? 1 : vt <= 2097151 ? 2 : vt <= 268435455 ? 3 : Math.floor(Math.log(vt) / (7 * Math.LN2));
                            bt.realloc(ls);
                            for(let ho = bt.pos - 1; ho >= le1; ho--)bt.buf[ho + ls] = bt.buf[ho];
                        }
                        function Fc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeVarint(le1[bt]);
                        }
                        function Dc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeSVarint(le1[bt]);
                        }
                        function zc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeFloat(le1[bt]);
                        }
                        function Pc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeDouble(le1[bt]);
                        }
                        function Bc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeBoolean(le1[bt]);
                        }
                        function Vc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeFixed32(le1[bt]);
                        }
                        function Cc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed32(le1[bt]);
                        }
                        function Lc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeFixed64(le1[bt]);
                        }
                        function Oc(le1, vt) {
                            for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed64(le1[bt]);
                        }
                        function Rc(le1, vt, bt) {
                            1 === le1 && bt.readMessage(Nc, vt);
                        }
                        function Nc(le1, vt, bt) {
                            if (3 === le1) {
                                const { id: le1, bitmap: ls, width: ho, height: Dl, left: Fl, top: sc, advance: uc } = bt.readMessage($c, {});
                                vt.push({
                                    id: le1,
                                    bitmap: new _l({
                                        width: ho + 6,
                                        height: Dl + 6
                                    }, ls),
                                    metrics: {
                                        width: ho,
                                        height: Dl,
                                        left: Fl,
                                        top: sc,
                                        advance: uc
                                    }
                                });
                            }
                        }
                        function $c(le1, vt, bt) {
                            1 === le1 ? vt.id = bt.readVarint() : 2 === le1 ? vt.bitmap = bt.readBytes() : 3 === le1 ? vt.width = bt.readVarint() : 4 === le1 ? vt.height = bt.readVarint() : 5 === le1 ? vt.left = bt.readSVarint() : 6 === le1 ? vt.top = bt.readSVarint() : 7 === le1 && (vt.advance = bt.readVarint());
                        }
                        function Uc(le1) {
                            let vt = 0, bt = 0;
                            for (const Fl of le1)vt += Fl.w * Fl.h, bt = Math.max(bt, Fl.w);
                            le1.sort((le1, vt)=>vt.h - le1.h);
                            const ls = [
                                {
                                    x: 0,
                                    y: 0,
                                    w: Math.max(Math.ceil(Math.sqrt(vt / .95)), bt),
                                    h: 1 / 0
                                }
                            ];
                            let ho = 0, Dl = 0;
                            for (const Fl of le1)for(let le1 = ls.length - 1; le1 >= 0; le1--){
                                const vt = ls[le1];
                                if (!(Fl.w > vt.w || Fl.h > vt.h)) {
                                    if (Fl.x = vt.x, Fl.y = vt.y, Dl = Math.max(Dl, Fl.y + Fl.h), ho = Math.max(ho, Fl.x + Fl.w), Fl.w === vt.w && Fl.h === vt.h) {
                                        const vt = ls.pop();
                                        vt && le1 < ls.length && (ls[le1] = vt);
                                    } else Fl.h === vt.h ? (vt.x += Fl.w, vt.w -= Fl.w) : Fl.w === vt.w ? (vt.y += Fl.h, vt.h -= Fl.h) : (ls.push({
                                        x: vt.x + Fl.w,
                                        y: vt.y,
                                        w: vt.w - Fl.w,
                                        h: Fl.h
                                    }), vt.y += Fl.h, vt.h -= Fl.h);
                                    break;
                                }
                            }
                            return {
                                w: ho,
                                h: Dl,
                                fill: vt / (ho * Dl) || 0
                            };
                        }
                        class qc {
                            constructor(le1, { pixelRatio: vt, version: bt, stretchX: ls, stretchY: ho, content: Dl, textFitWidth: Fl, textFitHeight: sc }){
                                this.paddedRect = le1, this.pixelRatio = vt, this.stretchX = ls, this.stretchY = ho, this.content = Dl, this.version = bt, this.textFitWidth = Fl, this.textFitHeight = sc;
                            }
                            get tl() {
                                return [
                                    this.paddedRect.x + 1,
                                    this.paddedRect.y + 1
                                ];
                            }
                            get br() {
                                return [
                                    this.paddedRect.x + this.paddedRect.w - 1,
                                    this.paddedRect.y + this.paddedRect.h - 1
                                ];
                            }
                            get tlbr() {
                                return this.tl.concat(this.br);
                            }
                            get displaySize() {
                                return [
                                    (this.paddedRect.w - 2) / this.pixelRatio,
                                    (this.paddedRect.h - 2) / this.pixelRatio
                                ];
                            }
                        }
                        class jc {
                            constructor(le1, vt){
                                const bt = {}, ls = {};
                                this.haveRenderCallbacks = [];
                                const ho = [];
                                this.addImages(le1, bt, ho), this.addImages(vt, ls, ho);
                                const { w: Dl, h: Fl } = Uc(ho), sc = new Sl({
                                    width: Dl || 1,
                                    height: Fl || 1
                                });
                                for(const uc in le1){
                                    const vt = le1[uc], ls = bt[uc].paddedRect;
                                    Sl.copy(vt.data, sc, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: ls.x + 1,
                                        y: ls.y + 1
                                    }, vt.data);
                                }
                                for(const uc in vt){
                                    const le1 = vt[uc], bt = ls[uc].paddedRect, ho = bt.x + 1, Dl = bt.y + 1, Fl = le1.data.width, mc = le1.data.height;
                                    Sl.copy(le1.data, sc, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: ho,
                                        y: Dl
                                    }, le1.data), Sl.copy(le1.data, sc, {
                                        x: 0,
                                        y: mc - 1
                                    }, {
                                        x: ho,
                                        y: Dl - 1
                                    }, {
                                        width: Fl,
                                        height: 1
                                    }), Sl.copy(le1.data, sc, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: ho,
                                        y: Dl + mc
                                    }, {
                                        width: Fl,
                                        height: 1
                                    }), Sl.copy(le1.data, sc, {
                                        x: Fl - 1,
                                        y: 0
                                    }, {
                                        x: ho - 1,
                                        y: Dl
                                    }, {
                                        width: 1,
                                        height: mc
                                    }), Sl.copy(le1.data, sc, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: ho + Fl,
                                        y: Dl
                                    }, {
                                        width: 1,
                                        height: mc
                                    });
                                }
                                this.image = sc, this.iconPositions = bt, this.patternPositions = ls;
                            }
                            addImages(le1, vt, bt) {
                                for(const ls in le1){
                                    const ho = le1[ls], Dl = {
                                        x: 0,
                                        y: 0,
                                        w: ho.data.width + 2,
                                        h: ho.data.height + 2
                                    };
                                    bt.push(Dl), vt[ls] = new qc(Dl, ho), ho.hasRenderCallback && this.haveRenderCallbacks.push(ls);
                                }
                            }
                            patchUpdatedImages(le1, vt) {
                                le1.dispatchRenderCallbacks(this.haveRenderCallbacks);
                                for(const bt in le1.updatedImages)this.patchUpdatedImage(this.iconPositions[bt], le1.getImage(bt), vt), this.patchUpdatedImage(this.patternPositions[bt], le1.getImage(bt), vt);
                            }
                            patchUpdatedImage(le1, vt, bt) {
                                if (!le1 || !vt) return;
                                if (le1.version === vt.version) return;
                                le1.version = vt.version;
                                const [ls, ho] = le1.tl;
                                bt.update(vt.data, void 0, {
                                    x: ls,
                                    y: ho
                                });
                            }
                        }
                        var uA;
                        function Xc(vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u) {
                            const Md = Sc.fromFeature(vt, Dl);
                            let Ld;
                            Ec === le1.az.vertical && Md.verticalizePunctuation();
                            let Nd = Md.determineLineBreaks(gc, Fl, bt, ho, du);
                            const { processBidirectionalText: Rd, processStyledBidirectionalText: Od } = Jm;
                            if (Rd && 1 === Md.sections.length) {
                                Ld = [], Nd = Nd.map((le1)=>Md.toCodeUnitIndex(le1));
                                const le1 = Rd(Md.toString(), Nd);
                                for (const vt of le1){
                                    const le1 = [
                                        ...vt
                                    ].map(()=>0);
                                    Ld.push(new Sc(vt, Md.sections, le1));
                                }
                            } else if (Od) {
                                Ld = [], Nd = Nd.map((le1)=>Md.toCodeUnitIndex(le1));
                                let le1 = 0;
                                const vt = [];
                                for (const ls of Md.text)vt.push(...Array(ls.length).fill(Md.sectionIndex[le1])), le1++;
                                const bt = Od(Md.text, vt, Nd);
                                for (const ls of bt){
                                    const le1 = [];
                                    let vt = "";
                                    for (const bt of ls[0])le1.push(ls[1][vt.length]), vt += bt;
                                    Ld.push(new Sc(ls[0], Md.sections, le1));
                                }
                            } else Ld = function(le1, vt) {
                                const bt = [];
                                let ls = 0;
                                for (const ho of vt)bt.push(le1.substring(ls, ho)), ls = ho;
                                return ls < le1.length() && bt.push(le1.substring(ls, le1.length())), bt;
                            }(Md, Nd);
                            const jd = [], Ud = {
                                positionedLines: jd,
                                text: Md.toString(),
                                top: Ac[1],
                                bottom: Ac[1],
                                left: Ac[0],
                                right: Ac[0],
                                writingMode: Ec,
                                iconsInText: !1,
                                verticalizable: !1
                            };
                            return function(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                                let Ec = 0, kc = 0, du = 0, _u = 0;
                                const Md = "right" === sc ? 1 : "left" === sc ? 0 : .5, Ld = nA / Ac;
                                let Nd = 0;
                                for (const jd of ho){
                                    jd.trim();
                                    const ho = jd.getMaxScale(), Fl = {
                                        positionedGlyphs: [],
                                        lineOffset: 0
                                    };
                                    le1.positionedLines[Nd] = Fl;
                                    const sc = Fl.positionedGlyphs;
                                    let Ac = 0;
                                    if (!jd.length()) {
                                        kc += Dl, ++Nd;
                                        continue;
                                    }
                                    const Rd = Zc(ls, jd, Ld);
                                    let Od = 0;
                                    for (const Dl of jd.text){
                                        const Fl = jd.getSection(Od), du = Dl.codePointAt(0), _u = Kc(uc, gc, du), Md = {
                                            glyph: du,
                                            imageName: null,
                                            x: Ec,
                                            y: kc + -17,
                                            vertical: _u,
                                            scale: 1,
                                            fontStack: "",
                                            sectionIndex: jd.getSectionIndex(Od),
                                            metrics: null,
                                            rect: null
                                        };
                                        let Nd;
                                        if ("fontStack" in Fl) {
                                            if (Nd = Wc(Fl, du, _u, Rd, vt, bt), !Nd) continue;
                                            Md.fontStack = Fl.fontStack;
                                        } else {
                                            if (le1.iconsInText = !0, Fl.scale *= Ld, Nd = Jc(Fl, _u, ho, Rd, ls), !Nd) continue;
                                            Ac = Math.max(Ac, Nd.imageOffset), Md.imageName = Fl.imageName;
                                        }
                                        const { rect: Ud, metrics: Gd, baselineOffset: qd } = Nd;
                                        Md.y += qd, Md.scale = Fl.scale, Md.metrics = Gd, Md.rect = Ud, sc.push(Md), _u ? (le1.verticalizable = !0, Ec += ("imageName" in Fl ? Gd.advance : nA) * Fl.scale + mc) : Ec += Gd.advance * Fl.scale + mc, Od++;
                                    }
                                    0 !== sc.length && (du = Math.max(Ec - mc, du), Qc(sc, 0, sc.length - 1, Md)), Ec = 0, Fl.lineOffset = Math.max(Ac, (ho - 1) * nA);
                                    const Ud = Dl * ho + Ac;
                                    kc += Ud, _u = Math.max(Ud, _u), ++Nd;
                                }
                                const { horizontalAlign: Rd, verticalAlign: Od } = Yc(Fl);
                                (function(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                    const mc = (vt - bt) * ho;
                                    let gc = 0;
                                    gc = Dl !== Fl ? -sc * ls - -17 : -ls * uc * Fl + .5 * Fl;
                                    for (const Ac of le1)for (const le1 of Ac.positionedGlyphs)le1.x += mc, le1.y += gc;
                                })(le1.positionedLines, Md, Rd, Od, du, _u, Dl, kc, ho.length), le1.top += -Od * kc, le1.bottom = le1.top + kc, le1.left += -Rd * du, le1.right = le1.left + du;
                            }(Ud, bt, ls, ho, Ld, sc, uc, mc, Ec, gc, kc, _u), !function(le1) {
                                for (const vt of le1)if (0 !== vt.positionedGlyphs.length) return !1;
                                return !0;
                            }(jd) && Ud;
                        }
                        function Yc(le1) {
                            let vt = .5, bt = .5;
                            switch(le1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    vt = 1;
                                    break;
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    vt = 0;
                            }
                            switch(le1){
                                case "bottom":
                                case "bottom-right":
                                case "bottom-left":
                                    bt = 1;
                                    break;
                                case "top":
                                case "top-right":
                                case "top-left":
                                    bt = 0;
                            }
                            return {
                                horizontalAlign: vt,
                                verticalAlign: bt
                            };
                        }
                        function Zc(le1, vt, bt) {
                            const ls = vt.getMaxScale() * nA, { maxImageWidth: ho, maxImageHeight: Dl } = vt.getMaxImageSize(le1), Fl = Math.max(ls, Dl * bt);
                            return {
                                verticalLineContentWidth: Math.max(ls, ho * bt),
                                horizontalLineContentHeight: Fl
                            };
                        }
                        function Hc(le1) {
                            switch(le1){
                                case "top":
                                    return 0;
                                case "center":
                                    return .5;
                                default:
                                    return 1;
                            }
                        }
                        function Kc(vt, bt, ls) {
                            var ho;
                            return !(vt === le1.az.horizontal || !bt && !bs(ls) || bt && (ws(ls) || (ho = ls, /\p{sc=Arab}/u.test(String.fromCodePoint(ho)))));
                        }
                        function Wc(le1, vt, bt, ls, ho, Dl) {
                            const Fl = Dl[le1.fontStack], sc = function(le1, vt, bt, ls) {
                                if (le1 && le1.rect) return le1;
                                const ho = vt[bt.fontStack], Dl = ho && ho[ls];
                                return Dl ? {
                                    rect: null,
                                    metrics: Dl.metrics
                                } : null;
                            }(Fl && Fl[vt], ho, le1, vt);
                            if (null === sc) return null;
                            let uc;
                            if (bt) uc = ls.verticalLineContentWidth - le1.scale * nA;
                            else {
                                const vt = Hc(le1.verticalAlign);
                                uc = (ls.horizontalLineContentHeight - le1.scale * nA) * vt;
                            }
                            return {
                                rect: sc.rect,
                                metrics: sc.metrics,
                                baselineOffset: uc
                            };
                        }
                        function Jc(le1, vt, bt, ls, ho) {
                            const Dl = ho[le1.imageName];
                            if (!Dl) return null;
                            const Fl = Dl.paddedRect, sc = Dl.displaySize, uc = {
                                width: sc[0],
                                height: sc[1],
                                left: 1,
                                top: -3,
                                advance: vt ? sc[1] : sc[0]
                            };
                            let mc;
                            if (vt) mc = ls.verticalLineContentWidth - sc[1] * le1.scale;
                            else {
                                const vt = Hc(le1.verticalAlign);
                                mc = (ls.horizontalLineContentHeight - sc[1] * le1.scale) * vt;
                            }
                            return {
                                rect: Fl,
                                metrics: uc,
                                baselineOffset: mc,
                                imageOffset: (vt ? sc[0] : sc[1]) * le1.scale - nA * bt
                            };
                        }
                        function Qc(le1, vt, bt, ls) {
                            if (0 === ls) return;
                            const ho = le1[bt], Dl = (le1[bt].x + ho.metrics.advance * ho.scale) * ls;
                            for(let Fl = vt; Fl <= bt; Fl++)le1[Fl].x -= Dl;
                        }
                        function th(le1, vt, bt) {
                            const { horizontalAlign: ls, verticalAlign: ho } = Yc(bt), Dl = vt[0] - le1.displaySize[0] * ls, Fl = vt[1] - le1.displaySize[1] * ho;
                            return {
                                image: le1,
                                top: Fl,
                                bottom: Fl + le1.displaySize[1],
                                left: Dl,
                                right: Dl + le1.displaySize[0]
                            };
                        }
                        function eh(le1) {
                            var vt, bt;
                            let ls = le1.left, ho = le1.top, Dl = le1.right - ls, Fl = le1.bottom - ho;
                            const sc = null !== (vt = le1.image.textFitWidth) && void 0 !== vt ? vt : "stretchOrShrink", uc = null !== (bt = le1.image.textFitHeight) && void 0 !== bt ? bt : "stretchOrShrink", mc = (le1.image.content[2] - le1.image.content[0]) / (le1.image.content[3] - le1.image.content[1]);
                            if ("proportional" === uc) {
                                if ("stretchOnly" === sc && Dl / Fl < mc || "proportional" === sc) {
                                    const le1 = Math.ceil(Fl * mc);
                                    ls *= le1 / Dl, Dl = le1;
                                }
                            } else if ("proportional" === sc && "stretchOnly" === uc && 0 !== mc && Dl / Fl > mc) {
                                const le1 = Math.ceil(Dl / mc);
                                ho *= le1 / Fl, Fl = le1;
                            }
                            return {
                                x1: ls,
                                y1: ho,
                                x2: ls + Dl,
                                y2: ho + Fl
                            };
                        }
                        function rh(le1, vt, bt, ls, ho, Dl) {
                            const Fl = le1.image;
                            let sc;
                            if (Fl.content) {
                                const le1 = Fl.content, vt = Fl.pixelRatio || 1;
                                sc = [
                                    le1[0] / vt,
                                    le1[1] / vt,
                                    Fl.displaySize[0] - le1[2] / vt,
                                    Fl.displaySize[1] - le1[3] / vt
                                ];
                            }
                            const uc = vt.left * Dl, mc = vt.right * Dl;
                            let gc, Ac, Ec, kc;
                            "width" === bt || "both" === bt ? (kc = ho[0] + uc - ls[3], Ac = ho[0] + mc + ls[1]) : (kc = ho[0] + (uc + mc - Fl.displaySize[0]) / 2, Ac = kc + Fl.displaySize[0]);
                            const du = vt.top * Dl, _u = vt.bottom * Dl;
                            return "height" === bt || "both" === bt ? (gc = ho[1] + du - ls[0], Ec = ho[1] + _u + ls[2]) : (gc = ho[1] + (du + _u - Fl.displaySize[1]) / 2, Ec = gc + Fl.displaySize[1]), {
                                image: Fl,
                                top: gc,
                                right: Ac,
                                bottom: Ec,
                                left: kc,
                                collisionPadding: sc
                            };
                        }
                        ps("ImagePosition", qc), ps("ImageAtlas", jc), le1.az = void 0, (uA = le1.az || (le1.az = {}))[uA.none = 0] = "none", uA[uA.horizontal = 1] = "horizontal", uA[uA.vertical = 2] = "vertical", uA[uA.horizontalOnly = 3] = "horizontalOnly";
                        const hA = 128, dA = 32640;
                        function sh(le1, vt) {
                            const { expression: bt } = vt;
                            if ("constant" === bt.kind) return {
                                kind: "constant",
                                layoutSize: bt.evaluate(new Ps(le1 + 1))
                            };
                            if ("source" === bt.kind) return {
                                kind: "source"
                            };
                            {
                                const { zoomStops: vt, interpolationType: ls } = bt;
                                let ho = 0;
                                for(; ho < vt.length && vt[ho] <= le1;)ho++;
                                ho = Math.max(0, ho - 1);
                                let Dl = ho;
                                for(; Dl < vt.length && vt[Dl] < le1 + 1;)Dl++;
                                Dl = Math.min(vt.length - 1, Dl);
                                const Fl = vt[ho], sc = vt[Dl];
                                return "composite" === bt.kind ? {
                                    kind: "composite",
                                    minZoom: Fl,
                                    maxZoom: sc,
                                    interpolationType: ls
                                } : {
                                    kind: "camera",
                                    minZoom: Fl,
                                    maxZoom: sc,
                                    minSize: bt.evaluate(new Ps(Fl)),
                                    maxSize: bt.evaluate(new Ps(sc)),
                                    interpolationType: ls
                                };
                            }
                        }
                        function ah(le1, vt, bt) {
                            let ls = "never";
                            const ho = le1.get(vt);
                            return ho ? ls = ho : le1.get(bt) && (ls = "always"), ls;
                        }
                        const pA = [
                            {
                                name: "a_fade_opacity",
                                components: 1,
                                type: "Uint8",
                                offset: 0
                            }
                        ];
                        function lh(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                            const kc = sc ? Math.min(dA, Math.round(sc[0])) : 0, du = sc ? Math.min(dA, Math.round(sc[1])) : 0;
                            le1.emplaceBack(vt, bt, Math.round(32 * ls), Math.round(32 * ho), Dl, Fl, (kc << 1) + (uc ? 1 : 0), du, 16 * mc, 16 * gc, 256 * Ac, 256 * Ec);
                        }
                        function uh(le1, vt, bt) {
                            le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt), le1.emplaceBack(vt.x, vt.y, bt);
                        }
                        function ch(le1) {
                            for (const vt of le1.sections)if (Ds(vt.text)) return !0;
                            return !1;
                        }
                        class hh {
                            constructor(le1){
                                this.layoutVertexArray = new Ha, this.indexArray = new to, this.programConfigurations = le1, this.segments = new io, this.dynamicLayoutVertexArray = new Ka, this.opacityVertexArray = new Wa, this.hasVisibleVertices = !1, this.placedSymbolArray = new za;
                            }
                            isEmpty() {
                                return 0 === this.layoutVertexArray.length && 0 === this.indexArray.length && 0 === this.dynamicLayoutVertexArray.length && 0 === this.opacityVertexArray.length;
                            }
                            upload(le1, vt, bt, ls) {
                                this.isEmpty() || (bt && (this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, Jg.members), this.indexBuffer = le1.createIndexBuffer(this.indexArray, vt), this.dynamicLayoutVertexBuffer = le1.createVertexBuffer(this.dynamicLayoutVertexArray, $g.members, !0), this.opacityVertexBuffer = le1.createVertexBuffer(this.opacityVertexArray, pA, !0), this.opacityVertexBuffer.itemSize = 1), (bt || ls) && this.programConfigurations.upload(le1));
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.programConfigurations.destroy(), this.segments.destroy(), this.dynamicLayoutVertexBuffer.destroy(), this.opacityVertexBuffer.destroy());
                            }
                        }
                        ps("SymbolBuffers", hh);
                        class ph {
                            constructor(le1, vt, bt){
                                this.layoutVertexArray = new le1, this.layoutAttributes = vt, this.indexArray = new bt, this.segments = new io, this.collisionVertexArray = new Qa;
                            }
                            upload(le1) {
                                this.layoutVertexBuffer = le1.createVertexBuffer(this.layoutVertexArray, this.layoutAttributes), this.indexBuffer = le1.createIndexBuffer(this.indexArray), this.collisionVertexBuffer = le1.createVertexBuffer(this.collisionVertexArray, eA.members, !0);
                            }
                            destroy() {
                                this.layoutVertexBuffer && (this.layoutVertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.collisionVertexBuffer.destroy());
                            }
                        }
                        ps("CollisionBuffers", ph);
                        class fh {
                            constructor(vt){
                                this.collisionBoxArray = vt.collisionBoxArray, this.zoom = vt.zoom, this.overscaling = vt.overscaling, this.layers = vt.layers, this.layerIds = this.layers.map((le1)=>le1.id), this.index = vt.index, this.pixelRatio = vt.pixelRatio, this.sourceLayerIndex = vt.sourceLayerIndex, this.hasDependencies = !1, this.hasRTLText = !1, this.sortKeyRanges = [], this.collisionCircleArray = [];
                                const bt = this.layers[0]._unevaluatedLayout._values;
                                this.textSizeData = sh(this.zoom, bt["text-size"]), this.iconSizeData = sh(this.zoom, bt["icon-size"]);
                                const ls = this.layers[0].layout, ho = ls.get("symbol-sort-key"), Dl = ls.get("symbol-z-order");
                                this.canOverlap = "never" !== ah(ls, "text-overlap", "text-allow-overlap") || "never" !== ah(ls, "icon-overlap", "icon-allow-overlap") || ls.get("text-ignore-placement") || ls.get("icon-ignore-placement"), this.sortFeaturesByKey = "viewport-y" !== Dl && !ho.isConstant(), this.sortFeaturesByY = ("viewport-y" === Dl || "auto" === Dl && !this.sortFeaturesByKey) && this.canOverlap, "point" === ls.get("symbol-placement") && (this.writingModes = ls.get("text-writing-mode").map((vt)=>le1.az[vt])), this.stateDependentLayerIds = this.layers.filter((le1)=>le1.isStateDependent()).map((le1)=>le1.id), this.sourceID = vt.sourceID;
                            }
                            createArrays() {
                                this.text = new hh(new Vo(this.layers, this.zoom, (le1)=>/^text/.test(le1))), this.icon = new hh(new Vo(this.layers, this.zoom, (le1)=>/^icon/.test(le1))), this.glyphOffsetArray = new Va, this.lineVertexArray = new Ca, this.symbolInstances = new Ba, this.textAnchorOffsets = new Oa;
                            }
                            calculateGlyphDependencies(le1, vt, bt, ls, ho) {
                                for (const Dl of le1)if (vt[Dl.codePointAt(0)] = !0, (bt || ls) && ho) {
                                    const le1 = rA[Dl];
                                    le1 && (vt[le1.codePointAt(0)] = !0);
                                }
                            }
                            populate(vt, bt, ls) {
                                const ho = this.layers[0], Dl = ho.layout, Fl = Dl.get("text-font"), sc = Dl.get("text-field"), uc = Dl.get("icon-image"), mc = ("constant" !== sc.value.kind || sc.value.value instanceof De && !sc.value.value.isEmpty() || sc.value.value.toString().length > 0) && ("constant" !== Fl.value.kind || Fl.value.value.length > 0), gc = "constant" !== uc.value.kind || !!uc.value.value || Object.keys(uc.parameters).length > 0, Ac = Dl.get("symbol-sort-key");
                                if (this.features = [], !mc && !gc) return;
                                const Ec = bt.iconDependencies, kc = bt.glyphDependencies, du = bt.availableImages, _u = new Ps(this.zoom);
                                for (const { feature: Md, id: Ld, index: Nd, sourceLayerIndex: Rd } of vt){
                                    const vt = ho._featureFilter.needGeometry, bt = $o(Md, vt);
                                    if (!ho._featureFilter.filter(_u, bt, ls)) continue;
                                    let sc, uc;
                                    if (vt || (bt.geometry = No(Md)), mc) {
                                        const le1 = ho.getValueAndResolveTokens("text-field", bt, ls, du), vt = De.factory(le1), Dl = this.hasRTLText = this.hasRTLText || ch(vt);
                                        (!Dl || "unavailable" === Jm.getRTLTextPluginStatus() || Dl && Jm.isParsed()) && (sc = fc(vt, ho, bt));
                                    }
                                    if (gc) {
                                        const le1 = ho.getValueAndResolveTokens("icon-image", bt, ls, du);
                                        uc = le1 instanceof Oe ? le1 : Oe.fromString(le1);
                                    }
                                    if (!sc && !uc) continue;
                                    const Od = this.sortFeaturesByKey ? Ac.evaluate(bt, {}, ls) : void 0;
                                    if (this.features.push({
                                        id: Ld,
                                        text: sc,
                                        icon: uc,
                                        index: Nd,
                                        sourceLayerIndex: Rd,
                                        geometry: bt.geometry,
                                        properties: Md.properties,
                                        type: Mu.types[Md.type],
                                        sortKey: Od
                                    }), uc && (Ec[uc.name] = !0), sc) {
                                        const vt = Fl.evaluate(bt, {}, ls).join(","), ho = "viewport" !== Dl.get("text-rotation-alignment") && "point" !== Dl.get("symbol-placement");
                                        this.allowVerticalPlacement = this.writingModes && this.writingModes.indexOf(le1.az.vertical) >= 0;
                                        for (const le1 of sc.sections)if (le1.image) Ec[le1.image.name] = !0;
                                        else {
                                            const bt = _s(sc.toString()), ls = le1.fontStack || vt, Dl = kc[ls] = kc[ls] || {};
                                            this.calculateGlyphDependencies(le1.text, Dl, ho, this.allowVerticalPlacement, bt);
                                        }
                                    }
                                }
                                "line" === Dl.get("symbol-placement") && (this.features = function(le1) {
                                    const vt = {}, bt = {}, ls = [];
                                    let ho = 0;
                                    function s(vt) {
                                        ls.push(le1[vt]), ho++;
                                    }
                                    function a(le1, vt, ho) {
                                        const Dl = bt[le1];
                                        return delete bt[le1], bt[vt] = Dl, ls[Dl].geometry[0].pop(), ls[Dl].geometry[0] = ls[Dl].geometry[0].concat(ho[0]), Dl;
                                    }
                                    function o(le1, bt, ho) {
                                        const Dl = vt[bt];
                                        return delete vt[bt], vt[le1] = Dl, ls[Dl].geometry[0].shift(), ls[Dl].geometry[0] = ho[0].concat(ls[Dl].geometry[0]), Dl;
                                    }
                                    function l(le1, vt, bt) {
                                        const ls = bt ? vt[0][vt[0].length - 1] : vt[0][0];
                                        return `${le1}:${ls.x}:${ls.y}`;
                                    }
                                    for(let Dl = 0; Dl < le1.length; Dl++){
                                        const Fl = le1[Dl], sc = Fl.geometry, uc = Fl.text ? Fl.text.toString() : null;
                                        if (!uc) {
                                            s(Dl);
                                            continue;
                                        }
                                        const mc = l(uc, sc), gc = l(uc, sc, !0);
                                        if (mc in bt && gc in vt && bt[mc] !== vt[gc]) {
                                            const le1 = o(mc, gc, sc), ho = a(mc, gc, ls[le1].geometry);
                                            delete vt[mc], delete bt[gc], bt[l(uc, ls[ho].geometry, !0)] = ho, ls[le1].geometry = null;
                                        } else mc in bt ? a(mc, gc, sc) : gc in vt ? o(mc, gc, sc) : (s(Dl), vt[mc] = ho - 1, bt[gc] = ho - 1);
                                    }
                                    return ls.filter((le1)=>le1.geometry);
                                }(this.features)), this.sortFeaturesByKey && this.features.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                            }
                            update(le1, vt, bt) {
                                this.stateDependentLayers.length && (this.text.programConfigurations.updatePaintArrays(le1, vt, this.layers, {
                                    imagePositions: bt
                                }), this.icon.programConfigurations.updatePaintArrays(le1, vt, this.layers, {
                                    imagePositions: bt
                                }));
                            }
                            isEmpty() {
                                return 0 === this.symbolInstances.length && !this.hasRTLText;
                            }
                            uploadPending() {
                                return !this.uploaded || this.text.programConfigurations.needsUpload || this.icon.programConfigurations.needsUpload;
                            }
                            upload(le1) {
                                !this.uploaded && this.hasDebugData() && (this.textCollisionBox.upload(le1), this.iconCollisionBox.upload(le1)), this.text.upload(le1, this.sortFeaturesByY, !this.uploaded, this.text.programConfigurations.needsUpload), this.icon.upload(le1, this.sortFeaturesByY, !this.uploaded, this.icon.programConfigurations.needsUpload), this.uploaded = !0;
                            }
                            destroyDebugData() {
                                this.textCollisionBox.destroy(), this.iconCollisionBox.destroy();
                            }
                            destroy() {
                                this.text.destroy(), this.icon.destroy(), this.hasDebugData() && this.destroyDebugData();
                            }
                            addToLineVertexArray(le1, vt) {
                                const bt = this.lineVertexArray.length;
                                if (void 0 !== le1.segment) {
                                    let bt = le1.dist(vt[le1.segment + 1]), ls = le1.dist(vt[le1.segment]);
                                    const ho = {};
                                    for(let Dl = le1.segment + 1; Dl < vt.length; Dl++)ho[Dl] = {
                                        x: vt[Dl].x,
                                        y: vt[Dl].y,
                                        tileUnitDistanceFromAnchor: bt
                                    }, Dl < vt.length - 1 && (bt += vt[Dl + 1].dist(vt[Dl]));
                                    for(let Dl = le1.segment || 0; Dl >= 0; Dl--)ho[Dl] = {
                                        x: vt[Dl].x,
                                        y: vt[Dl].y,
                                        tileUnitDistanceFromAnchor: ls
                                    }, Dl > 0 && (ls += vt[Dl - 1].dist(vt[Dl]));
                                    for(let le1 = 0; le1 < vt.length; le1++){
                                        const vt = ho[le1];
                                        this.lineVertexArray.emplaceBack(vt.x, vt.y, vt.tileUnitDistanceFromAnchor);
                                    }
                                }
                                return {
                                    lineStartIndex: bt,
                                    lineLength: this.lineVertexArray.length - bt
                                };
                            }
                            addSymbols(vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                                const kc = vt.indexArray, du = vt.layoutVertexArray, _u = vt.segments.prepareSegment(4 * bt.length, du, kc, this.canOverlap ? Fl.sortKey : void 0), Md = this.glyphOffsetArray.length, Ld = _u.vertexLength, Nd = this.allowVerticalPlacement && sc === le1.az.vertical ? Math.PI / 2 : 0, Rd = Fl.text && Fl.text.sections;
                                for(let le1 = 0; le1 < bt.length; le1++){
                                    const { tl: ho, tr: Dl, bl: sc, br: mc, tex: gc, pixelOffsetTL: Ac, pixelOffsetBR: Md, minFontScaleX: Ld, minFontScaleY: Od, glyphOffset: jd, isSDF: Ud, sectionIndex: Gd } = bt[le1], qd = _u.vertexLength, Hd = jd[1];
                                    lh(du, uc.x, uc.y, ho.x, Hd + ho.y, gc.x, gc.y, ls, Ud, Ac.x, Ac.y, Ld, Od), lh(du, uc.x, uc.y, Dl.x, Hd + Dl.y, gc.x + gc.w, gc.y, ls, Ud, Md.x, Ac.y, Ld, Od), lh(du, uc.x, uc.y, sc.x, Hd + sc.y, gc.x, gc.y + gc.h, ls, Ud, Ac.x, Md.y, Ld, Od), lh(du, uc.x, uc.y, mc.x, Hd + mc.y, gc.x + gc.w, gc.y + gc.h, ls, Ud, Md.x, Md.y, Ld, Od), uh(vt.dynamicLayoutVertexArray, uc, Nd), kc.emplaceBack(qd, qd + 2, qd + 1), kc.emplaceBack(qd + 1, qd + 2, qd + 3), _u.vertexLength += 4, _u.primitiveLength += 2, this.glyphOffsetArray.emplaceBack(jd[0]), le1 !== bt.length - 1 && Gd === bt[le1 + 1].sectionIndex || vt.programConfigurations.populatePaintArrays(du.length, Fl, Fl.index, {
                                        imagePositions: {},
                                        canonical: Ec,
                                        formattedSection: Rd && Rd[Gd]
                                    });
                                }
                                vt.placedSymbolArray.emplaceBack(uc.x, uc.y, Md, this.glyphOffsetArray.length - Md, Ld, mc, gc, uc.segment, ls ? ls[0] : 0, ls ? ls[1] : 0, ho[0], ho[1], sc, 0, !1, 0, Ac);
                            }
                            _addCollisionDebugVertex(le1, vt, bt, ls, ho, Dl) {
                                return vt.emplaceBack(0, 0), le1.emplaceBack(bt.x, bt.y, ls, ho, Math.round(Dl.x), Math.round(Dl.y));
                            }
                            addCollisionDebugVertices(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = ho.segments.prepareSegment(4, ho.layoutVertexArray, ho.indexArray), uc = sc.vertexLength, mc = ho.layoutVertexArray, gc = ho.collisionVertexArray, Ac = Fl.anchorX, Ec = Fl.anchorY;
                                this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new r(le1, vt)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new r(bt, vt)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new r(bt, ls)), this._addCollisionDebugVertex(mc, gc, Dl, Ac, Ec, new r(le1, ls)), sc.vertexLength += 4;
                                const kc = ho.indexArray;
                                kc.emplaceBack(uc, uc + 1), kc.emplaceBack(uc + 1, uc + 2), kc.emplaceBack(uc + 2, uc + 3), kc.emplaceBack(uc + 3, uc), sc.primitiveLength += 4;
                            }
                            addDebugCollisionBoxes(le1, vt, bt, ls) {
                                for(let ho = le1; ho < vt; ho++){
                                    const le1 = this.collisionBoxArray.get(ho);
                                    this.addCollisionDebugVertices(le1.x1, le1.y1, le1.x2, le1.y2, ls ? this.textCollisionBox : this.iconCollisionBox, le1.anchorPoint, bt);
                                }
                            }
                            generateCollisionDebugBuffers() {
                                this.hasDebugData() && this.destroyDebugData(), this.textCollisionBox = new ph(Ja, tA.members, eo), this.iconCollisionBox = new ph(Ja, tA.members, eo);
                                for(let le1 = 0; le1 < this.symbolInstances.length; le1++){
                                    const vt = this.symbolInstances.get(le1);
                                    this.addDebugCollisionBoxes(vt.textBoxStartIndex, vt.textBoxEndIndex, vt, !0), this.addDebugCollisionBoxes(vt.verticalTextBoxStartIndex, vt.verticalTextBoxEndIndex, vt, !0), this.addDebugCollisionBoxes(vt.iconBoxStartIndex, vt.iconBoxEndIndex, vt, !1), this.addDebugCollisionBoxes(vt.verticalIconBoxStartIndex, vt.verticalIconBoxEndIndex, vt, !1);
                                }
                            }
                            _deserializeCollisionBoxesForSymbol(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                const mc = {};
                                for(let gc = vt; gc < bt; gc++){
                                    const vt = le1.get(gc);
                                    mc.textBox = {
                                        x1: vt.x1,
                                        y1: vt.y1,
                                        x2: vt.x2,
                                        y2: vt.y2,
                                        anchorPointX: vt.anchorPointX,
                                        anchorPointY: vt.anchorPointY
                                    }, mc.textFeatureIndex = vt.featureIndex;
                                    break;
                                }
                                for(let gc = ls; gc < ho; gc++){
                                    const vt = le1.get(gc);
                                    mc.verticalTextBox = {
                                        x1: vt.x1,
                                        y1: vt.y1,
                                        x2: vt.x2,
                                        y2: vt.y2,
                                        anchorPointX: vt.anchorPointX,
                                        anchorPointY: vt.anchorPointY
                                    }, mc.verticalTextFeatureIndex = vt.featureIndex;
                                    break;
                                }
                                for(let gc = Dl; gc < Fl; gc++){
                                    const vt = le1.get(gc);
                                    mc.iconBox = {
                                        x1: vt.x1,
                                        y1: vt.y1,
                                        x2: vt.x2,
                                        y2: vt.y2,
                                        anchorPointX: vt.anchorPointX,
                                        anchorPointY: vt.anchorPointY
                                    }, mc.iconFeatureIndex = vt.featureIndex;
                                    break;
                                }
                                for(let gc = sc; gc < uc; gc++){
                                    const vt = le1.get(gc);
                                    mc.verticalIconBox = {
                                        x1: vt.x1,
                                        y1: vt.y1,
                                        x2: vt.x2,
                                        y2: vt.y2,
                                        anchorPointX: vt.anchorPointX,
                                        anchorPointY: vt.anchorPointY
                                    }, mc.verticalIconFeatureIndex = vt.featureIndex;
                                    break;
                                }
                                return mc;
                            }
                            deserializeCollisionBoxes(le1) {
                                this.collisionArrays = [];
                                for(let vt = 0; vt < this.symbolInstances.length; vt++){
                                    const bt = this.symbolInstances.get(vt);
                                    this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(le1, bt.textBoxStartIndex, bt.textBoxEndIndex, bt.verticalTextBoxStartIndex, bt.verticalTextBoxEndIndex, bt.iconBoxStartIndex, bt.iconBoxEndIndex, bt.verticalIconBoxStartIndex, bt.verticalIconBoxEndIndex));
                                }
                            }
                            hasTextData() {
                                return this.text.segments.get().length > 0;
                            }
                            hasIconData() {
                                return this.icon.segments.get().length > 0;
                            }
                            hasDebugData() {
                                return this.textCollisionBox && this.iconCollisionBox;
                            }
                            hasTextCollisionBoxData() {
                                return this.hasDebugData() && this.textCollisionBox.segments.get().length > 0;
                            }
                            hasIconCollisionBoxData() {
                                return this.hasDebugData() && this.iconCollisionBox.segments.get().length > 0;
                            }
                            addIndicesForPlacedSymbol(le1, vt) {
                                const bt = le1.placedSymbolArray.get(vt), ls = bt.vertexStartIndex + 4 * bt.numGlyphs;
                                for(let ho = bt.vertexStartIndex; ho < ls; ho += 4)le1.indexArray.emplaceBack(ho, ho + 2, ho + 1), le1.indexArray.emplaceBack(ho + 1, ho + 2, ho + 3);
                            }
                            getSortedSymbolIndexes(le1) {
                                if (this.sortedAngle === le1 && void 0 !== this.symbolInstanceIndexes) return this.symbolInstanceIndexes;
                                const vt = Math.sin(le1), bt = Math.cos(le1), ls = [], ho = [], Dl = [];
                                for(let Fl = 0; Fl < this.symbolInstances.length; ++Fl){
                                    Dl.push(Fl);
                                    const le1 = this.symbolInstances.get(Fl);
                                    ls.push(0 | Math.round(vt * le1.anchorX + bt * le1.anchorY)), ho.push(le1.featureIndex);
                                }
                                return Dl.sort((le1, vt)=>ls[le1] - ls[vt] || ho[vt] - ho[le1]), Dl;
                            }
                            addToSortKeyRanges(le1, vt) {
                                const bt = this.sortKeyRanges[this.sortKeyRanges.length - 1];
                                bt && bt.sortKey === vt ? bt.symbolInstanceEnd = le1 + 1 : this.sortKeyRanges.push({
                                    sortKey: vt,
                                    symbolInstanceStart: le1,
                                    symbolInstanceEnd: le1 + 1
                                });
                            }
                            sortFeatures(le1) {
                                if (this.sortFeaturesByY && this.sortedAngle !== le1 && !(this.text.segments.get().length > 1 || this.icon.segments.get().length > 1)) {
                                    this.symbolInstanceIndexes = this.getSortedSymbolIndexes(le1), this.sortedAngle = le1, this.text.indexArray.clear(), this.icon.indexArray.clear(), this.featureSortOrder = [];
                                    for (const le1 of this.symbolInstanceIndexes){
                                        const vt = this.symbolInstances.get(le1);
                                        this.featureSortOrder.push(vt.featureIndex), [
                                            vt.rightJustifiedTextSymbolIndex,
                                            vt.centerJustifiedTextSymbolIndex,
                                            vt.leftJustifiedTextSymbolIndex
                                        ].forEach((le1, vt, bt)=>{
                                            le1 >= 0 && bt.indexOf(le1) === vt && this.addIndicesForPlacedSymbol(this.text, le1);
                                        }), vt.verticalPlacedTextSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.text, vt.verticalPlacedTextSymbolIndex), vt.placedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, vt.placedIconSymbolIndex), vt.verticalPlacedIconSymbolIndex >= 0 && this.addIndicesForPlacedSymbol(this.icon, vt.verticalPlacedIconSymbolIndex);
                                    }
                                    this.text.indexBuffer && this.text.indexBuffer.updateData(this.text.indexArray), this.icon.indexBuffer && this.icon.indexBuffer.updateData(this.icon.indexArray);
                                }
                            }
                        }
                        let mA, fA;
                        ps("SymbolBucket", fh, {
                            omit: [
                                "layers",
                                "collisionBoxArray",
                                "features",
                                "compareText"
                            ]
                        }), fh.MAX_GLYPHS = 65535, fh.addDynamicAttributes = uh;
                        var gA = {
                            get paint () {
                                return fA = fA || new Hs({
                                    "icon-opacity": new Gs(qd.paint_symbol["icon-opacity"]),
                                    "icon-color": new Gs(qd.paint_symbol["icon-color"]),
                                    "icon-halo-color": new Gs(qd.paint_symbol["icon-halo-color"]),
                                    "icon-halo-width": new Gs(qd.paint_symbol["icon-halo-width"]),
                                    "icon-halo-blur": new Gs(qd.paint_symbol["icon-halo-blur"]),
                                    "icon-translate": new js(qd.paint_symbol["icon-translate"]),
                                    "icon-translate-anchor": new js(qd.paint_symbol["icon-translate-anchor"]),
                                    "text-opacity": new Gs(qd.paint_symbol["text-opacity"]),
                                    "text-color": new Gs(qd.paint_symbol["text-color"], {
                                        runtimeType: Xd,
                                        getOverride: (le1)=>le1.textColor,
                                        hasOverride: (le1)=>!!le1.textColor
                                    }),
                                    "text-halo-color": new Gs(qd.paint_symbol["text-halo-color"]),
                                    "text-halo-width": new Gs(qd.paint_symbol["text-halo-width"]),
                                    "text-halo-blur": new Gs(qd.paint_symbol["text-halo-blur"]),
                                    "text-translate": new js(qd.paint_symbol["text-translate"]),
                                    "text-translate-anchor": new js(qd.paint_symbol["text-translate-anchor"])
                                });
                            },
                            get layout () {
                                return mA = mA || new Hs({
                                    "symbol-placement": new js(qd.layout_symbol["symbol-placement"]),
                                    "symbol-spacing": new js(qd.layout_symbol["symbol-spacing"]),
                                    "symbol-avoid-edges": new js(qd.layout_symbol["symbol-avoid-edges"]),
                                    "symbol-sort-key": new Gs(qd.layout_symbol["symbol-sort-key"]),
                                    "symbol-z-order": new js(qd.layout_symbol["symbol-z-order"]),
                                    "icon-allow-overlap": new js(qd.layout_symbol["icon-allow-overlap"]),
                                    "icon-overlap": new js(qd.layout_symbol["icon-overlap"]),
                                    "icon-ignore-placement": new js(qd.layout_symbol["icon-ignore-placement"]),
                                    "icon-optional": new js(qd.layout_symbol["icon-optional"]),
                                    "icon-rotation-alignment": new js(qd.layout_symbol["icon-rotation-alignment"]),
                                    "icon-size": new Gs(qd.layout_symbol["icon-size"]),
                                    "icon-text-fit": new js(qd.layout_symbol["icon-text-fit"]),
                                    "icon-text-fit-padding": new js(qd.layout_symbol["icon-text-fit-padding"]),
                                    "icon-image": new Gs(qd.layout_symbol["icon-image"]),
                                    "icon-rotate": new Gs(qd.layout_symbol["icon-rotate"]),
                                    "icon-padding": new Gs(qd.layout_symbol["icon-padding"]),
                                    "icon-keep-upright": new js(qd.layout_symbol["icon-keep-upright"]),
                                    "icon-offset": new Gs(qd.layout_symbol["icon-offset"]),
                                    "icon-anchor": new Gs(qd.layout_symbol["icon-anchor"]),
                                    "icon-pitch-alignment": new js(qd.layout_symbol["icon-pitch-alignment"]),
                                    "text-pitch-alignment": new js(qd.layout_symbol["text-pitch-alignment"]),
                                    "text-rotation-alignment": new js(qd.layout_symbol["text-rotation-alignment"]),
                                    "text-field": new Gs(qd.layout_symbol["text-field"]),
                                    "text-font": new Gs(qd.layout_symbol["text-font"]),
                                    "text-size": new Gs(qd.layout_symbol["text-size"]),
                                    "text-max-width": new Gs(qd.layout_symbol["text-max-width"]),
                                    "text-line-height": new js(qd.layout_symbol["text-line-height"]),
                                    "text-letter-spacing": new Gs(qd.layout_symbol["text-letter-spacing"]),
                                    "text-justify": new Gs(qd.layout_symbol["text-justify"]),
                                    "text-radial-offset": new Gs(qd.layout_symbol["text-radial-offset"]),
                                    "text-variable-anchor": new js(qd.layout_symbol["text-variable-anchor"]),
                                    "text-variable-anchor-offset": new Gs(qd.layout_symbol["text-variable-anchor-offset"]),
                                    "text-anchor": new Gs(qd.layout_symbol["text-anchor"]),
                                    "text-max-angle": new js(qd.layout_symbol["text-max-angle"]),
                                    "text-writing-mode": new js(qd.layout_symbol["text-writing-mode"]),
                                    "text-rotate": new Gs(qd.layout_symbol["text-rotate"]),
                                    "text-padding": new js(qd.layout_symbol["text-padding"]),
                                    "text-keep-upright": new js(qd.layout_symbol["text-keep-upright"]),
                                    "text-transform": new Gs(qd.layout_symbol["text-transform"]),
                                    "text-offset": new Gs(qd.layout_symbol["text-offset"]),
                                    "text-allow-overlap": new js(qd.layout_symbol["text-allow-overlap"]),
                                    "text-overlap": new js(qd.layout_symbol["text-overlap"]),
                                    "text-ignore-placement": new js(qd.layout_symbol["text-ignore-placement"]),
                                    "text-optional": new js(qd.layout_symbol["text-optional"])
                                });
                            }
                        };
                        class gh {
                            constructor(le1){
                                if (void 0 === le1.property.overrides) throw new Error("overrides must be provided to instantiate FormatSectionOverride class");
                                this.type = le1.property.overrides ? le1.property.overrides.runtimeType : Wd, this.defaultValue = le1;
                            }
                            evaluate(le1) {
                                if (le1.formattedSection) {
                                    const vt = this.defaultValue.property.overrides;
                                    if (vt && vt.hasOverride(le1.formattedSection)) return vt.getOverride(le1.formattedSection);
                                }
                                return le1.feature && le1.featureState ? this.defaultValue.evaluate(le1.feature, le1.featureState) : this.defaultValue.property.specification.default;
                            }
                            eachChild(le1) {
                                this.defaultValue.isConstant() || le1(this.defaultValue.value._styleExpression.expression);
                            }
                            outputDefined() {
                                return !1;
                            }
                            serialize() {
                                return null;
                            }
                        }
                        ps("FormatSectionOverride", gh, {
                            omit: [
                                "defaultValue"
                            ]
                        });
                        class xh extends Ks {
                            constructor(le1, vt){
                                super(le1, gA, vt);
                            }
                            recalculate(le1, vt) {
                                if (super.recalculate(le1, vt), "auto" === this.layout.get("icon-rotation-alignment") && (this.layout._values["icon-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-rotation-alignment") && (this.layout._values["text-rotation-alignment"] = "point" !== this.layout.get("symbol-placement") ? "map" : "viewport"), "auto" === this.layout.get("text-pitch-alignment") && (this.layout._values["text-pitch-alignment"] = "map" === this.layout.get("text-rotation-alignment") ? "map" : "viewport"), "auto" === this.layout.get("icon-pitch-alignment") && (this.layout._values["icon-pitch-alignment"] = this.layout.get("icon-rotation-alignment")), "point" === this.layout.get("symbol-placement")) {
                                    const le1 = this.layout.get("text-writing-mode");
                                    if (le1) {
                                        const vt = [];
                                        for (const bt of le1)vt.indexOf(bt) < 0 && vt.push(bt);
                                        this.layout._values["text-writing-mode"] = vt;
                                    } else this.layout._values["text-writing-mode"] = [
                                        "horizontal"
                                    ];
                                }
                                this._setPaintOverrides();
                            }
                            getValueAndResolveTokens(le1, vt, bt, ls) {
                                const ho = this.layout.get(le1).evaluate(vt, {}, bt, ls), Dl = this._unevaluatedLayout._values[le1];
                                return Dl.isDataDriven() || ri(Dl.value) || !ho ? ho : function(le1, vt) {
                                    return vt.replace(/{([^{}]+)}/g, (vt, bt)=>le1 && bt in le1 ? String(le1[bt]) : "");
                                }(vt.properties, ho);
                            }
                            createBucket(le1) {
                                return new fh(le1);
                            }
                            queryRadius() {
                                return 0;
                            }
                            queryIntersectsFeature() {
                                throw new Error("Should take a different path in FeatureIndex");
                            }
                            _setPaintOverrides() {
                                for (const le1 of gA.paint.overridableProperties){
                                    if (!xh.hasPaintOverride(this.layout, le1)) continue;
                                    const vt = this.paint.get(le1), bt = new gh(vt), ls = new ei(bt, vt.property.specification);
                                    let ho = null;
                                    ho = "constant" === vt.value.kind || "source" === vt.value.kind ? new ii("source", ls) : new si("composite", ls, vt.value.zoomStops), this.paint._values[le1] = new Us(vt.property, ho, vt.parameters);
                                }
                            }
                            _handleOverridablePaintPropertyUpdate(le1, vt, bt) {
                                return !(!this.layout || vt.isDataDriven() || bt.isDataDriven()) && xh.hasPaintOverride(this.layout, le1);
                            }
                            static hasPaintOverride(le1, vt) {
                                const bt = le1.get("text-field"), ls = gA.paint.properties[vt];
                                let ho = !1;
                                const s = (le1)=>{
                                    for (const vt of le1)if (ls.overrides && ls.overrides.hasOverride(vt)) return void (ho = !0);
                                };
                                if ("constant" === bt.value.kind && bt.value.value instanceof De) s(bt.value.value.sections);
                                else if ("source" === bt.value.kind || "composite" === bt.value.kind) {
                                    const t = (le1)=>{
                                        ho || (le1 instanceof je && Ue(le1.value) === em ? s(le1.value.sections) : le1 instanceof Ir ? s(le1.sections) : le1.eachChild(t));
                                    }, le1 = bt.value;
                                    le1._styleExpression && t(le1._styleExpression.expression);
                                }
                                return ho;
                            }
                        }
                        let AA;
                        var _A = {
                            get paint () {
                                return AA = AA || new Hs({
                                    "background-color": new js(qd.paint_background["background-color"]),
                                    "background-pattern": new Ys(qd.paint_background["background-pattern"]),
                                    "background-opacity": new js(qd.paint_background["background-opacity"])
                                });
                            }
                        };
                        class wh extends Ks {
                            constructor(le1, vt){
                                super(le1, _A, vt);
                            }
                        }
                        class _h extends Ks {
                            constructor(le1, vt){
                                super(le1, {}, vt), this.onAdd = (le1)=>{
                                    this.implementation.onAdd && this.implementation.onAdd(le1, le1.painter.context.gl);
                                }, this.onRemove = (le1)=>{
                                    this.implementation.onRemove && this.implementation.onRemove(le1, le1.painter.context.gl);
                                }, this.implementation = le1;
                            }
                            is3D() {
                                return "3d" === this.implementation.renderingMode;
                            }
                            hasOffscreenPass() {
                                return void 0 !== this.implementation.prerender;
                            }
                            recalculate() {}
                            updateTransitions() {}
                            hasTransition() {
                                return !1;
                            }
                            serialize() {
                                throw new Error("Custom layers cannot be serialized");
                            }
                        }
                        class Sh {
                            constructor(le1){
                                this._methodToThrottle = le1, this._triggered = !1, "undefined" != typeof MessageChannel && (this._channel = new MessageChannel, this._channel.port2.onmessage = ()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                });
                            }
                            trigger() {
                                this._triggered || (this._triggered = !0, this._channel ? this._channel.port1.postMessage(!0) : setTimeout(()=>{
                                    this._triggered = !1, this._methodToThrottle();
                                }, 0));
                            }
                            remove() {
                                delete this._channel, this._methodToThrottle = ()=>{};
                            }
                        }
                        const yA = {
                            once: !0
                        }, vA = 6371008.8;
                        class Eh {
                            constructor(le1, vt){
                                if (isNaN(le1) || isNaN(vt)) throw new Error(`Invalid LngLat object: (${le1}, ${vt})`);
                                if (this.lng = +le1, this.lat = +vt, this.lat > 90 || this.lat < -90) throw new Error("Invalid LngLat latitude value: must be between -90 and 90");
                            }
                            wrap() {
                                return new Eh(L1(this.lng, -180, 180), this.lat);
                            }
                            toArray() {
                                return [
                                    this.lng,
                                    this.lat
                                ];
                            }
                            toString() {
                                return `LngLat(${this.lng}, ${this.lat})`;
                            }
                            distanceTo(le1) {
                                const vt = Math.PI / 180, bt = this.lat * vt, ls = le1.lat * vt, ho = Math.sin(bt) * Math.sin(ls) + Math.cos(bt) * Math.cos(ls) * Math.cos((le1.lng - this.lng) * vt);
                                return vA * Math.acos(Math.min(ho, 1));
                            }
                            static convert(le1) {
                                if (le1 instanceof Eh) return le1;
                                if (Array.isArray(le1) && (2 === le1.length || 3 === le1.length)) return new Eh(Number(le1[0]), Number(le1[1]));
                                if (!Array.isArray(le1) && "object" == typeof le1 && null !== le1) return new Eh(Number("lng" in le1 ? le1.lng : le1.lon), Number(le1.lat));
                                throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]");
                            }
                        }
                        const xA = 2 * Math.PI * vA;
                        function Ih(le1) {
                            return xA * Math.cos(le1 * Math.PI / 180);
                        }
                        function Mh(le1) {
                            return (180 + le1) / 360;
                        }
                        function Fh(le1) {
                            return (180 - 180 / Math.PI * Math.log(Math.tan(Math.PI / 4 + le1 * Math.PI / 360))) / 360;
                        }
                        function Dh(le1, vt) {
                            return le1 / Ih(vt);
                        }
                        function zh(le1) {
                            return 360 * le1 - 180;
                        }
                        function Ph(le1) {
                            return 360 / Math.PI * Math.atan(Math.exp((180 - 360 * le1) * Math.PI / 180)) - 90;
                        }
                        function Bh(le1, vt) {
                            return le1 * Ih(Ph(vt));
                        }
                        class Vh {
                            constructor(le1, vt, bt = 0){
                                this.x = +le1, this.y = +vt, this.z = +bt;
                            }
                            static fromLngLat(le1, vt = 0) {
                                const bt = Eh.convert(le1);
                                return new Vh(Mh(bt.lng), Fh(bt.lat), Dh(vt, bt.lat));
                            }
                            toLngLat() {
                                return new Eh(zh(this.x), Ph(this.y));
                            }
                            toAltitude() {
                                return Bh(this.z, this.y);
                            }
                            meterInMercatorCoordinateUnits() {
                                var le1;
                                return 1 / xA * (le1 = Ph(this.y), 1 / Math.cos(le1 * Math.PI / 180));
                            }
                        }
                        function Ch(le1, vt, bt) {
                            var ls = 2 * Math.PI * 6378137 / 256 / Math.pow(2, bt);
                            return [
                                le1 * ls - 2 * Math.PI * 6378137 / 2,
                                vt * ls - 2 * Math.PI * 6378137 / 2
                            ];
                        }
                        class Lh {
                            constructor(le1, vt, bt){
                                if (!function(le1, vt, bt) {
                                    return !(le1 < 0 || le1 > 25 || bt < 0 || bt >= Math.pow(2, le1) || vt < 0 || vt >= Math.pow(2, le1));
                                }(le1, vt, bt)) throw new Error(`x=${vt}, y=${bt}, z=${le1} outside of bounds. 0<=x<${Math.pow(2, le1)}, 0<=y<${Math.pow(2, le1)} 0<=z<=25 `);
                                this.z = le1, this.x = vt, this.y = bt, this.key = Nh(0, le1, le1, vt, bt);
                            }
                            equals(le1) {
                                return this.z === le1.z && this.x === le1.x && this.y === le1.y;
                            }
                            url(le1, vt, bt) {
                                const ls = (Dl = this.y, Fl = this.z, sc = Ch(256 * (ho = this.x), 256 * (Dl = Math.pow(2, Fl) - Dl - 1), Fl), uc = Ch(256 * (ho + 1), 256 * (Dl + 1), Fl), sc[0] + "," + sc[1] + "," + uc[0] + "," + uc[1]);
                                var ho, Dl, Fl, sc, uc;
                                const mc = function(le1, vt, bt) {
                                    let ls, ho = "";
                                    for(let Dl = le1; Dl > 0; Dl--)ls = 1 << Dl - 1, ho += (vt & ls ? 1 : 0) + (bt & ls ? 2 : 0);
                                    return ho;
                                }(this.z, this.x, this.y);
                                return le1[(this.x + this.y) % le1.length].replace(/{prefix}/g, (this.x % 16).toString(16) + (this.y % 16).toString(16)).replace(/{z}/g, String(this.z)).replace(/{x}/g, String(this.x)).replace(/{y}/g, String("tms" === bt ? Math.pow(2, this.z) - this.y - 1 : this.y)).replace(/{ratio}/g, vt > 1 ? "@2x" : "").replace(/{quadkey}/g, mc).replace(/{bbox-epsg-3857}/g, ls);
                            }
                            isChildOf(le1) {
                                const vt = this.z - le1.z;
                                return vt > 0 && le1.x === this.x >> vt && le1.y === this.y >> vt;
                            }
                            getTilePoint(le1) {
                                const vt = Math.pow(2, this.z);
                                return new r((le1.x * vt - this.x) * Ac, (le1.y * vt - this.y) * Ac);
                            }
                            toString() {
                                return `${this.z}/${this.x}/${this.y}`;
                            }
                        }
                        class Oh {
                            constructor(le1, vt){
                                this.wrap = le1, this.canonical = vt, this.key = Nh(le1, vt.z, vt.z, vt.x, vt.y);
                            }
                        }
                        class Rh {
                            constructor(le1, vt, bt, ls, ho){
                                if (this.terrainRttPosMatrix32f = null, le1 < bt) throw new Error(`overscaledZ should be >= z; overscaledZ = ${le1}; z = ${bt}`);
                                this.overscaledZ = le1, this.wrap = vt, this.canonical = new Lh(bt, +ls, +ho), this.key = Nh(vt, le1, bt, ls, ho);
                            }
                            clone() {
                                return new Rh(this.overscaledZ, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            equals(le1) {
                                return this.overscaledZ === le1.overscaledZ && this.wrap === le1.wrap && this.canonical.equals(le1.canonical);
                            }
                            scaledTo(le1) {
                                if (le1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${le1}; overscaledZ = ${this.overscaledZ}`);
                                const vt = this.canonical.z - le1;
                                return le1 > this.canonical.z ? new Rh(le1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y) : new Rh(le1, this.wrap, le1, this.canonical.x >> vt, this.canonical.y >> vt);
                            }
                            isOverscaled() {
                                return this.overscaledZ > this.canonical.z;
                            }
                            calculateScaledKey(le1, vt) {
                                if (le1 > this.overscaledZ) throw new Error(`targetZ > this.overscaledZ; targetZ = ${le1}; overscaledZ = ${this.overscaledZ}`);
                                const bt = this.canonical.z - le1;
                                return le1 > this.canonical.z ? Nh(this.wrap * +vt, le1, this.canonical.z, this.canonical.x, this.canonical.y) : Nh(this.wrap * +vt, le1, le1, this.canonical.x >> bt, this.canonical.y >> bt);
                            }
                            isChildOf(le1) {
                                if (le1.wrap !== this.wrap) return !1;
                                if (this.overscaledZ - le1.overscaledZ <= 0) return !1;
                                if (0 === le1.overscaledZ) return this.overscaledZ > 0;
                                const vt = this.canonical.z - le1.canonical.z;
                                return !(vt < 0) && le1.canonical.x === this.canonical.x >> vt && le1.canonical.y === this.canonical.y >> vt;
                            }
                            children(le1) {
                                if (this.overscaledZ >= le1) return [
                                    new Rh(this.overscaledZ + 1, this.wrap, this.canonical.z, this.canonical.x, this.canonical.y)
                                ];
                                const vt = this.canonical.z + 1, bt = 2 * this.canonical.x, ls = 2 * this.canonical.y;
                                return [
                                    new Rh(vt, this.wrap, vt, bt, ls),
                                    new Rh(vt, this.wrap, vt, bt + 1, ls),
                                    new Rh(vt, this.wrap, vt, bt, ls + 1),
                                    new Rh(vt, this.wrap, vt, bt + 1, ls + 1)
                                ];
                            }
                            isLessThan(le1) {
                                return this.wrap < le1.wrap || !(this.wrap > le1.wrap) && (this.overscaledZ < le1.overscaledZ || !(this.overscaledZ > le1.overscaledZ) && (this.canonical.x < le1.canonical.x || !(this.canonical.x > le1.canonical.x) && this.canonical.y < le1.canonical.y));
                            }
                            wrapped() {
                                return new Rh(this.overscaledZ, 0, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            unwrapTo(le1) {
                                return new Rh(this.overscaledZ, le1, this.canonical.z, this.canonical.x, this.canonical.y);
                            }
                            overscaleFactor() {
                                return Math.pow(2, this.overscaledZ - this.canonical.z);
                            }
                            toUnwrapped() {
                                return new Oh(this.wrap, this.canonical);
                            }
                            toString() {
                                return `${this.overscaledZ}/${this.canonical.x}/${this.canonical.y}`;
                            }
                            getTilePoint(le1) {
                                return this.canonical.getTilePoint(new Vh(le1.x - this.wrap, le1.y));
                            }
                        }
                        function Nh(le1, vt, bt, ls, ho) {
                            (le1 *= 2) < 0 && (le1 = -1 * le1 - 1);
                            const Dl = 1 << bt;
                            return (Dl * Dl * le1 + Dl * ho + ls).toString(36) + bt.toString(36) + vt.toString(36);
                        }
                        function $h(le1, vt) {
                            return vt ? le1.properties[vt] : le1.id;
                        }
                        function Uh(le1, vt) {
                            const bt = {
                                id: le1.id
                            };
                            if (vt.removeAllProperties && (delete le1.removeProperties, delete le1.addOrUpdateProperties, delete vt.removeProperties), vt.removeProperties) for (const ls of vt.removeProperties){
                                const vt = le1.addOrUpdateProperties.findIndex((le1)=>le1.key === ls);
                                vt > -1 && le1.addOrUpdateProperties.splice(vt, 1);
                            }
                            return (le1.removeAllProperties || vt.removeAllProperties) && (bt.removeAllProperties = !0), (le1.removeProperties || vt.removeProperties) && (bt.removeProperties = [
                                ...le1.removeProperties || [],
                                ...vt.removeProperties || []
                            ]), (le1.addOrUpdateProperties || vt.addOrUpdateProperties) && (bt.addOrUpdateProperties = [
                                ...le1.addOrUpdateProperties || [],
                                ...vt.addOrUpdateProperties || []
                            ]), (le1.newGeometry || vt.newGeometry) && (bt.newGeometry = vt.newGeometry || le1.newGeometry), bt;
                        }
                        function qh(le1) {
                            var vt, bt;
                            if (!le1) return {};
                            const ls = {};
                            return ls.removeAll = le1.removeAll, ls.remove = new Set(le1.remove || []), ls.add = new Map(null === (vt = le1.add) || void 0 === vt ? void 0 : vt.map((le1)=>[
                                    le1.id,
                                    le1
                                ])), ls.update = new Map(null === (bt = le1.update) || void 0 === bt ? void 0 : bt.map((le1)=>[
                                    le1.id,
                                    le1
                                ])), ls;
                        }
                        ps("CanonicalTileID", Lh), ps("OverscaledTileID", Rh, {
                            omit: [
                                "terrainRttPosMatrix32f"
                            ]
                        });
                        class jh {
                            constructor(){
                                this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0;
                            }
                            extend(le1) {
                                return this.minX = Math.min(this.minX, le1.x), this.minY = Math.min(this.minY, le1.y), this.maxX = Math.max(this.maxX, le1.x), this.maxY = Math.max(this.maxY, le1.y), this;
                            }
                            expandBy(le1) {
                                return this.minX -= le1, this.minY -= le1, this.maxX += le1, this.maxY += le1, (this.minX > this.maxX || this.minY > this.maxY) && (this.minX = 1 / 0, this.maxX = -1 / 0, this.minY = 1 / 0, this.maxY = -1 / 0), this;
                            }
                            shrinkBy(le1) {
                                return this.expandBy(-le1);
                            }
                            map(le1) {
                                const vt = new jh;
                                return vt.extend(le1(new r(this.minX, this.minY))), vt.extend(le1(new r(this.maxX, this.minY))), vt.extend(le1(new r(this.minX, this.maxY))), vt.extend(le1(new r(this.maxX, this.maxY))), vt;
                            }
                            static fromPoints(le1) {
                                const vt = new jh;
                                for (const bt of le1)vt.extend(bt);
                                return vt;
                            }
                            contains(le1) {
                                return le1.x >= this.minX && le1.x <= this.maxX && le1.y >= this.minY && le1.y <= this.maxY;
                            }
                            empty() {
                                return this.minX > this.maxX;
                            }
                            width() {
                                return this.maxX - this.minX;
                            }
                            height() {
                                return this.maxY - this.minY;
                            }
                            covers(le1) {
                                return !this.empty() && !le1.empty() && le1.minX >= this.minX && le1.maxX <= this.maxX && le1.minY >= this.minY && le1.maxY <= this.maxY;
                            }
                            intersects(le1) {
                                return !this.empty() && !le1.empty() && le1.minX <= this.maxX && le1.maxX >= this.minX && le1.minY <= this.maxY && le1.maxY >= this.minY;
                            }
                        }
                        class Gh {
                            constructor(le1){
                                this._stringToNumber = {}, this._numberToString = [];
                                for(let vt = 0; vt < le1.length; vt++){
                                    const bt = le1[vt];
                                    this._stringToNumber[bt] = vt, this._numberToString[vt] = bt;
                                }
                            }
                            encode(le1) {
                                return this._stringToNumber[le1];
                            }
                            decode(le1) {
                                if (le1 >= this._numberToString.length) throw new Error(`Out of bounds. Index requested n=${le1} can't be >= this._numberToString.length ${this._numberToString.length}`);
                                return this._numberToString[le1];
                            }
                        }
                        class Xh {
                            constructor(le1, vt, bt, ls, ho){
                                this.type = "Feature", this._vectorTileFeature = le1, this._x = bt, this._y = ls, this._z = vt, this.properties = le1.properties, this.id = ho;
                            }
                            projectPoint(le1, vt, bt, ls) {
                                return [
                                    360 * (le1.x + vt) / ls - 180,
                                    360 / Math.PI * Math.atan(Math.exp((1 - 2 * (le1.y + bt) / ls) * Math.PI)) - 90
                                ];
                            }
                            projectLine(le1, vt, bt, ls) {
                                return le1.map((le1)=>this.projectPoint(le1, vt, bt, ls));
                            }
                            get geometry() {
                                if (this._geometry) return this._geometry;
                                const le1 = this._vectorTileFeature, vt = le1.extent * Math.pow(2, this._z), bt = le1.extent * this._x, ls = le1.extent * this._y, ho = le1.loadGeometry();
                                switch(le1.type){
                                    case 1:
                                        {
                                            const le1 = [];
                                            for (const vt of ho)le1.push(vt[0]);
                                            const Dl = this.projectLine(le1, bt, ls, vt);
                                            this._geometry = 1 === le1.length ? {
                                                type: "Point",
                                                coordinates: Dl[0]
                                            } : {
                                                type: "MultiPoint",
                                                coordinates: Dl
                                            };
                                            break;
                                        }
                                    case 2:
                                        {
                                            const le1 = ho.map((le1)=>this.projectLine(le1, bt, ls, vt));
                                            this._geometry = 1 === le1.length ? {
                                                type: "LineString",
                                                coordinates: le1[0]
                                            } : {
                                                type: "MultiLineString",
                                                coordinates: le1
                                            };
                                            break;
                                        }
                                    case 3:
                                        {
                                            const le1 = Du(ho), Dl = [];
                                            for (const ho of le1)Dl.push(ho.map((le1)=>this.projectLine(le1, bt, ls, vt)));
                                            this._geometry = 1 === Dl.length ? {
                                                type: "Polygon",
                                                coordinates: Dl[0]
                                            } : {
                                                type: "MultiPolygon",
                                                coordinates: Dl
                                            };
                                            break;
                                        }
                                    default:
                                        throw new Error(`unknown feature type: ${le1.type}`);
                                }
                                return this._geometry;
                            }
                            set geometry(le1) {
                                this._geometry = le1;
                            }
                            toJSON() {
                                const le1 = {
                                    geometry: this.geometry
                                };
                                for(const vt in this)"_geometry" !== vt && "_vectorTileFeature" !== vt && "_x" !== vt && "_y" !== vt && "_z" !== vt && (le1[vt] = this[vt]);
                                return le1;
                            }
                        }
                        class Yh {
                            _name;
                            dataBuffer;
                            nullabilityBuffer;
                            _size;
                            constructor(le1, vt, bt){
                                this._name = le1, this.dataBuffer = vt, "number" == typeof bt ? this._size = bt : (this.nullabilityBuffer = bt, this._size = bt.size());
                            }
                            getValue(le1) {
                                return this.nullabilityBuffer && !this.nullabilityBuffer.get(le1) ? null : this.getValueFromBuffer(le1);
                            }
                            has(le1) {
                                return this.nullabilityBuffer && this.nullabilityBuffer.get(le1) || !this.nullabilityBuffer;
                            }
                            get name() {
                                return this._name;
                            }
                            get size() {
                                return this._size;
                            }
                        }
                        class Zh extends Yh {
                        }
                        class Hh extends Zh {
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[le1];
                            }
                        }
                        class Kh extends Zh {
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[le1];
                            }
                        }
                        class Wh extends Yh {
                            delta;
                            constructor(le1, vt, bt, ls){
                                super(le1, vt, ls), this.delta = bt;
                            }
                        }
                        class Jh extends Wh {
                            constructor(le1, vt, bt, ls){
                                super(le1, Int32Array.of(vt), bt, ls);
                            }
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[0] + le1 * this.delta;
                            }
                        }
                        class Qh extends Yh {
                            constructor(le1, vt, bt){
                                super(le1, Int32Array.of(vt), bt);
                            }
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[0];
                            }
                        }
                        class tp {
                            _name;
                            _geometryVector;
                            _idVector;
                            _propertyVectors;
                            _extent;
                            propertyVectorsMap;
                            constructor(le1, vt, bt, ls, ho = 4096){
                                this._name = le1, this._geometryVector = vt, this._idVector = bt, this._propertyVectors = ls, this._extent = ho;
                            }
                            get name() {
                                return this._name;
                            }
                            get idVector() {
                                return this._idVector;
                            }
                            get geometryVector() {
                                return this._geometryVector;
                            }
                            get propertyVectors() {
                                return this._propertyVectors;
                            }
                            getPropertyVector(le1) {
                                return this.propertyVectorsMap || (this.propertyVectorsMap = new Map(this._propertyVectors.map((le1)=>[
                                        le1.name,
                                        le1
                                    ]))), this.propertyVectorsMap.get(le1);
                            }
                            *[Symbol.iterator]() {
                                const le1 = this.geometryVector[Symbol.iterator]();
                                let vt = 0;
                                for(; vt < this.numFeatures;){
                                    let bt;
                                    this.idVector && (bt = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(vt)) : this.idVector.getValue(vt));
                                    const ls = le1?.next().value, ho = {};
                                    for (const le1 of this.propertyVectors){
                                        if (!le1) continue;
                                        const bt = le1.name, ls = le1.getValue(vt);
                                        null !== ls && (ho[bt] = ls);
                                    }
                                    vt++, yield {
                                        id: bt,
                                        geometry: ls,
                                        properties: ho
                                    };
                                }
                            }
                            get numFeatures() {
                                return this.geometryVector.numGeometries;
                            }
                            get extent() {
                                return this._extent;
                            }
                            getFeatures() {
                                const le1 = [], vt = this.geometryVector.getGeometries();
                                for(let bt = 0; bt < this.numFeatures; bt++){
                                    let ls;
                                    this.idVector && (ls = this.containsMaxSaveIntegerValues(this.idVector) ? Number(this.idVector.getValue(bt)) : this.idVector.getValue(bt));
                                    const ho = {
                                        coordinates: vt[bt],
                                        type: this.geometryVector.geometryType(bt)
                                    }, Dl = {};
                                    for (const le1 of this.propertyVectors){
                                        if (!le1) continue;
                                        const vt = le1.name, ls = le1.getValue(bt);
                                        null !== ls && (Dl[vt] = ls);
                                    }
                                    le1.push({
                                        id: ls,
                                        geometry: ho,
                                        properties: Dl
                                    });
                                }
                                return le1;
                            }
                            containsMaxSaveIntegerValues(le1) {
                                return le1 instanceof Hh || le1 instanceof Qh && le1 instanceof Jh || le1 instanceof Kh;
                            }
                        }
                        class ep {
                            value;
                            constructor(le1){
                                this.value = le1;
                            }
                            get() {
                                return this.value;
                            }
                            set(le1) {
                                this.value = le1;
                            }
                            increment() {
                                return this.value++;
                            }
                            add(le1) {
                                this.value += le1;
                            }
                        }
                        var bA, wA, EA, MA, SA, TA, kA, CA, IA, DA;
                        function pp(le1, vt, bt) {
                            const ls = new Int32Array(bt);
                            let ho = 0, Dl = vt.get();
                            for(let Fl = 0; Fl < ls.length; Fl++){
                                let vt = le1[Dl++], bt = 127 & vt;
                                vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 7, vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 14, vt < 128 || (vt = le1[Dl++], bt |= (127 & vt) << 21, vt < 128 || (vt = le1[Dl++], bt |= (15 & vt) << 28)))), ls[ho++] = bt;
                            }
                            return vt.set(Dl), ls;
                        }
                        function fp(le1, vt, bt) {
                            const ls = new BigInt64Array(bt);
                            for(let ho = 0; ho < ls.length; ho++)ls[ho] = xp(le1, vt);
                            return ls;
                        }
                        function dp(le1, vt) {
                            let bt, ls;
                            return ls = le1[vt.get()], vt.increment(), bt = 127 & ls, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 7, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 14, ls < 128 ? bt : (ls = le1[vt.get()], vt.increment(), bt |= (127 & ls) << 21, ls < 128 ? bt : (ls = le1[vt.get()], bt |= (15 & ls) << 28, function(le1, vt, bt) {
                                let ls, ho;
                                if (ho = vt[bt.get()], bt.increment(), ls = (112 & ho) >> 4, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 3, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 10, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 17, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                if (ho = vt[bt.get()], bt.increment(), ls |= (127 & ho) << 24, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                if (ho = vt[bt.get()], bt.increment(), ls |= (1 & ho) << 31, ho < 128) return 4294967296 * ls + (le1 >>> 0);
                                throw new Error("Expected varint not more than 10 bytes");
                            }(bt, le1, vt)))));
                        }
                        function yp(le1, vt, bt, ls) {
                            throw new Error("FastPFor is not implemented yet.");
                        }
                        function mp(le1) {
                            return le1 >>> 1 ^ -(1 & le1);
                        }
                        function gp(le1) {
                            return le1 >> 1n ^ -(1n & le1);
                        }
                        function xp(le1, vt) {
                            let bt = 0n, ls = 0, ho = vt.get();
                            for(; ho < le1.length;){
                                const vt = le1[ho++];
                                if (bt |= BigInt(127 & vt) << BigInt(ls), !(128 & vt)) break;
                                if (ls += 7, ls >= 64) throw new Error("Varint too long");
                            }
                            return vt.set(ho), bt;
                        }
                        function vp(le1, vt, bt) {
                            const ls = new Int32Array(bt);
                            let ho = 0;
                            for(let Dl = 0; Dl < vt; Dl++){
                                const bt = le1[Dl];
                                ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                            }
                            return ls;
                        }
                        function bp(le1, vt, bt) {
                            const ls = new BigInt64Array(bt);
                            let ho = 0;
                            for(let Dl = 0; Dl < vt; Dl++){
                                const bt = Number(le1[Dl]);
                                ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                            }
                            return ls;
                        }
                        function wp(le1, vt, bt) {
                            const ls = new Float64Array(bt);
                            let ho = 0;
                            for(let Dl = 0; Dl < vt; Dl++){
                                const bt = le1[Dl];
                                ls.fill(le1[Dl + vt], ho, ho + bt), ho += bt;
                            }
                            return ls;
                        }
                        function _p(le1) {
                            const vt = le1.length / 4 * 4;
                            let bt = 1;
                            if (vt >= 4) for(let ls = le1[0]; bt < vt - 4; bt += 4)ls = le1[bt] += ls, ls = le1[bt + 1] += ls, ls = le1[bt + 2] += ls, ls = le1[bt + 3] += ls;
                            for(; bt != le1.length;)le1[bt] += le1[bt - 1], ++bt;
                        }
                        function Sp(le1) {
                            le1[0] = le1[0] >>> 1 ^ -(1 & le1[0]), le1[1] = le1[1] >>> 1 ^ -(1 & le1[1]);
                            const vt = le1.length / 4 * 4;
                            let bt = 2;
                            if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                le1[bt] = (vt >>> 1 ^ -(1 & vt)) + le1[bt - 2], le1[bt + 1] = (ls >>> 1 ^ -(1 & ls)) + le1[bt - 1], le1[bt + 2] = (ho >>> 1 ^ -(1 & ho)) + le1[bt], le1[bt + 3] = (Dl >>> 1 ^ -(1 & Dl)) + le1[bt + 1];
                            }
                            for(; bt != le1.length; bt += 2)le1[bt] = (le1[bt] >>> 1 ^ -(1 & le1[bt])) + le1[bt - 2], le1[bt + 1] = (le1[bt + 1] >>> 1 ^ -(1 & le1[bt + 1])) + le1[bt - 1];
                        }
                        !function(le1) {
                            le1.NONE = "NONE", le1.DELTA = "DELTA", le1.COMPONENTWISE_DELTA = "COMPONENTWISE_DELTA", le1.RLE = "RLE", le1.MORTON = "MORTON", le1.PDE = "PDE";
                        }(bA || (bA = {})), function(le1) {
                            le1.NONE = "NONE", le1.FAST_PFOR = "FAST_PFOR", le1.VARINT = "VARINT", le1.ALP = "ALP";
                        }(wA || (wA = {})), function(le1) {
                            le1.PRESENT = "PRESENT", le1.DATA = "DATA", le1.OFFSET = "OFFSET", le1.LENGTH = "LENGTH";
                        }(EA || (EA = {}));
                        class Ap {
                            _dictionaryType;
                            _offsetType;
                            _lengthType;
                            constructor(le1, vt, bt){
                                this._dictionaryType = le1, this._offsetType = vt, this._lengthType = bt;
                            }
                            get dictionaryType() {
                                return this._dictionaryType;
                            }
                            get offsetType() {
                                return this._offsetType;
                            }
                            get lengthType() {
                                return this._lengthType;
                            }
                        }
                        function kp(le1, vt) {
                            const bt = function(le1, vt) {
                                const bt = le1[vt.get()], ls = Object.values(EA)[bt >> 4];
                                let ho = null;
                                switch(ls){
                                    case EA.DATA:
                                        ho = new Ap(Object.values(MA)[15 & bt]);
                                        break;
                                    case EA.OFFSET:
                                        ho = new Ap(null, Object.values(SA)[15 & bt]);
                                        break;
                                    case EA.LENGTH:
                                        ho = new Ap(null, null, Object.values(TA)[15 & bt]);
                                }
                                vt.increment();
                                const Dl = le1[vt.get()], Fl = Object.values(bA)[Dl >> 5], sc = Object.values(bA)[Dl >> 2 & 7], uc = Object.values(wA)[3 & Dl];
                                vt.increment();
                                const mc = pp(le1, vt, 2), gc = mc[0];
                                return {
                                    physicalStreamType: ls,
                                    logicalStreamType: ho,
                                    logicalLevelTechnique1: Fl,
                                    logicalLevelTechnique2: sc,
                                    physicalLevelTechnique: uc,
                                    numValues: gc,
                                    byteLength: mc[1],
                                    decompressedCount: gc
                                };
                            }(le1, vt);
                            return bt.logicalLevelTechnique1 === bA.MORTON ? function(le1, vt, bt) {
                                const ls = pp(vt, bt, 2);
                                return {
                                    physicalStreamType: le1.physicalStreamType,
                                    logicalStreamType: le1.logicalStreamType,
                                    logicalLevelTechnique1: le1.logicalLevelTechnique1,
                                    logicalLevelTechnique2: le1.logicalLevelTechnique2,
                                    physicalLevelTechnique: le1.physicalLevelTechnique,
                                    numValues: le1.numValues,
                                    byteLength: le1.byteLength,
                                    decompressedCount: le1.decompressedCount,
                                    numBits: ls[0],
                                    coordinateShift: ls[1]
                                };
                            }(bt, le1, vt) : bA.RLE !== bt.logicalLevelTechnique1 && bA.RLE !== bt.logicalLevelTechnique2 || wA.NONE === bt.physicalLevelTechnique ? bt : function(le1, vt, bt) {
                                const ls = pp(vt, bt, 2);
                                return {
                                    physicalStreamType: le1.physicalStreamType,
                                    logicalStreamType: le1.logicalStreamType,
                                    logicalLevelTechnique1: le1.logicalLevelTechnique1,
                                    logicalLevelTechnique2: le1.logicalLevelTechnique2,
                                    physicalLevelTechnique: le1.physicalLevelTechnique,
                                    numValues: le1.numValues,
                                    byteLength: le1.byteLength,
                                    decompressedCount: ls[1],
                                    runs: ls[0],
                                    numRleValues: ls[1]
                                };
                            }(bt, le1, vt);
                        }
                        !function(le1) {
                            le1.NONE = "NONE", le1.SINGLE = "SINGLE", le1.SHARED = "SHARED", le1.VERTEX = "VERTEX", le1.MORTON = "MORTON", le1.FSST = "FSST";
                        }(MA || (MA = {})), function(le1) {
                            le1.VERTEX = "VERTEX", le1.INDEX = "INDEX", le1.STRING = "STRING", le1.KEY = "KEY";
                        }(SA || (SA = {})), function(le1) {
                            le1.VAR_BINARY = "VAR_BINARY", le1.GEOMETRIES = "GEOMETRIES", le1.PARTS = "PARTS", le1.RINGS = "RINGS", le1.TRIANGLES = "TRIANGLES", le1.SYMBOL = "SYMBOL", le1.DICTIONARY = "DICTIONARY";
                        }(TA || (TA = {})), function(le1) {
                            le1[le1.FLAT = 0] = "FLAT", le1[le1.CONST = 1] = "CONST", le1[le1.SEQUENCE = 2] = "SEQUENCE", le1[le1.DICTIONARY = 3] = "DICTIONARY", le1[le1.FSST_DICTIONARY = 4] = "FSST_DICTIONARY";
                        }(kA || (kA = {}));
                        class Ep {
                            values;
                            _size;
                            constructor(le1, vt){
                                this.values = le1, this._size = vt;
                            }
                            get(le1) {
                                const vt = Math.floor(le1 / 8);
                                return 1 == (this.values[vt] >> le1 % 8 & 1);
                            }
                            set(le1, vt) {
                                const bt = Math.floor(le1 / 8);
                                this.values[bt] = this.values[bt] | (vt ? 1 : 0) << le1 % 8;
                            }
                            getInt(le1) {
                                const vt = Math.floor(le1 / 8);
                                return this.values[vt] >> le1 % 8 & 1;
                            }
                            size() {
                                return this._size;
                            }
                            getBuffer() {
                                return this.values;
                            }
                        }
                        function Tp(le1, vt, bt, ls, ho) {
                            return function(le1, vt, bt) {
                                switch(vt.logicalLevelTechnique1){
                                    case bA.DELTA:
                                        return vt.logicalLevelTechnique2 === bA.RLE ? function(le1, vt, bt) {
                                            const ls = new Int32Array(bt);
                                            let ho = 0, Dl = 0;
                                            for(let Fl = 0; Fl < vt; Fl++){
                                                const bt = le1[Fl], sc = mp(le1[Fl + vt]);
                                                for(let le1 = 0; le1 < bt; le1++)Dl += sc, ls[ho++] = Dl;
                                            }
                                            return ls;
                                        }(le1, vt.runs, vt.numRleValues) : (function(le1) {
                                            le1[0] = le1[0] >>> 1 ^ -(1 & le1[0]);
                                            const vt = le1.length / 4 * 4;
                                            let bt = 1;
                                            if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                                const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                                le1[bt] = (vt >>> 1 ^ -(1 & vt)) + le1[bt - 1], le1[bt + 1] = (ls >>> 1 ^ -(1 & ls)) + le1[bt], le1[bt + 2] = (ho >>> 1 ^ -(1 & ho)) + le1[bt + 1], le1[bt + 3] = (Dl >>> 1 ^ -(1 & Dl)) + le1[bt + 2];
                                            }
                                            for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] >>> 1 ^ -(1 & le1[bt])) + le1[bt - 1];
                                        }(le1), le1);
                                    case bA.RLE:
                                        return function(le1, vt, bt) {
                                            return bt ? function(le1, vt, bt) {
                                                const ls = new Int32Array(bt);
                                                let ho = 0;
                                                for(let Dl = 0; Dl < vt; Dl++){
                                                    const bt = le1[Dl];
                                                    let Fl = le1[Dl + vt];
                                                    Fl = Fl >>> 1 ^ -(1 & Fl), ls.fill(Fl, ho, ho + bt), ho += bt;
                                                }
                                                return ls;
                                            }(le1, vt.runs, vt.numRleValues) : vp(le1, vt.runs, vt.numRleValues);
                                        }(le1, vt, bt);
                                    case bA.MORTON:
                                        return _p(le1), le1;
                                    case bA.COMPONENTWISE_DELTA:
                                        return Sp(le1), le1;
                                    case bA.NONE:
                                        return bt && function(le1) {
                                            for(let vt = 0; vt < le1.length; vt++){
                                                const bt = le1[vt];
                                                le1[vt] = bt >>> 1 ^ -(1 & bt);
                                            }
                                        }(le1), le1;
                                    default:
                                        throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                                }
                            }(Mp(le1, vt, bt), bt, ls);
                        }
                        function Ip(le1, vt, bt) {
                            return function(le1, vt) {
                                if (vt.logicalLevelTechnique1 === bA.DELTA && vt.logicalLevelTechnique2 === bA.NONE) {
                                    const vt = function(le1) {
                                        const vt = new Int32Array(le1.length + 1);
                                        vt[0] = 0, vt[1] = mp(le1[0]);
                                        let bt = vt[1], ls = 2;
                                        for(; ls != vt.length; ++ls){
                                            const ho = le1[ls - 1];
                                            bt += ho >>> 1 ^ -(1 & ho), vt[ls] = vt[ls - 1] + bt;
                                        }
                                        return vt;
                                    }(le1);
                                    return vt;
                                }
                                if (vt.logicalLevelTechnique1 === bA.RLE && vt.logicalLevelTechnique2 === bA.NONE) {
                                    const bt = function(le1, vt, bt) {
                                        const ls = new Int32Array(bt + 1);
                                        ls[0] = 0;
                                        let ho = 1, Dl = ls[0];
                                        for(let Fl = 0; Fl < vt; Fl++){
                                            const bt = le1[Fl], sc = le1[Fl + vt];
                                            for(let le1 = ho; le1 < ho + bt; le1++)ls[le1] = sc + Dl, Dl = ls[le1];
                                            ho += bt;
                                        }
                                        return ls;
                                    }(le1, vt.runs, vt.numRleValues);
                                    return bt;
                                }
                                if (vt.logicalLevelTechnique1 === bA.NONE && vt.logicalLevelTechnique2 === bA.NONE) {
                                    !function(le1) {
                                        let vt = 0;
                                        for(let bt = 0; bt < le1.length; bt++)le1[bt] += vt, vt = le1[bt];
                                    }(le1);
                                    const bt = new Int32Array(vt.numValues + 1);
                                    return bt[0] = 0, bt.set(le1, 1), bt;
                                }
                                if (vt.logicalLevelTechnique1 === bA.DELTA && vt.logicalLevelTechnique2 === bA.RLE) {
                                    const bt = function(le1, vt, bt) {
                                        const ls = new Int32Array(bt + 1);
                                        ls[0] = 0;
                                        let ho = 1, Dl = ls[0];
                                        for(let Fl = 0; Fl < vt; Fl++){
                                            const bt = le1[Fl];
                                            let sc = le1[Fl + vt];
                                            sc = sc >>> 1 ^ -(1 & sc);
                                            for(let le1 = ho; le1 < ho + bt; le1++)ls[le1] = sc + Dl, Dl = ls[le1];
                                            ho += bt;
                                        }
                                        return ls;
                                    }(le1, vt.runs, vt.numRleValues);
                                    return _p(bt), bt;
                                }
                                throw new Error("Only delta encoding is supported for transforming length to offset streams yet.");
                            }(Mp(le1, vt, bt), bt);
                        }
                        function Mp(le1, vt, bt) {
                            const ls = bt.physicalLevelTechnique;
                            if (ls === wA.FAST_PFOR) return yp();
                            if (ls === wA.VARINT) return pp(le1, vt, bt.numValues);
                            if (ls === wA.NONE) {
                                const ls = vt.get();
                                vt.add(bt.byteLength);
                                const ho = le1.subarray(ls, vt.get());
                                return new Int32Array(ho);
                            }
                            throw new Error("Specified physicalLevelTechnique is not supported (yet).");
                        }
                        function Fp(le1, vt, bt, ls) {
                            const ho = Mp(le1, vt, bt);
                            if (1 === ho.length) {
                                const le1 = ho[0];
                                return ls ? mp(le1) : le1;
                            }
                            return ls ? function(le1) {
                                return mp(le1[1]);
                            }(ho) : function(le1) {
                                return le1[1];
                            }(ho);
                        }
                        function Dp(le1, vt, bt) {
                            return function(le1) {
                                if (2 == le1.length) {
                                    const vt = mp(le1[1]);
                                    return [
                                        vt,
                                        vt
                                    ];
                                }
                                return [
                                    mp(le1[2]),
                                    mp(le1[3])
                                ];
                            }(Mp(le1, vt, bt));
                        }
                        function zp(le1, vt, bt) {
                            return function(le1) {
                                if (2 == le1.length) {
                                    const vt = gp(le1[1]);
                                    return [
                                        vt,
                                        vt
                                    ];
                                }
                                return [
                                    gp(le1[2]),
                                    gp(le1[3])
                                ];
                            }(fp(le1, vt, bt.numValues));
                        }
                        function Pp(le1, vt, bt, ls) {
                            return function(le1, vt, bt) {
                                switch(vt.logicalLevelTechnique1){
                                    case bA.DELTA:
                                        return vt.logicalLevelTechnique2 === bA.RLE ? function(le1, vt, bt) {
                                            const ls = new BigInt64Array(bt);
                                            let ho = 0, Dl = 0n;
                                            for(let Fl = 0; Fl < vt; Fl++){
                                                const bt = Number(le1[Fl]), sc = gp(le1[Fl + vt]);
                                                for(let le1 = 0; le1 < bt; le1++)Dl += sc, ls[ho++] = Dl;
                                            }
                                            return ls;
                                        }(le1, vt.runs, vt.numRleValues) : (function(le1) {
                                            le1[0] = le1[0] >> 1n ^ -(1n & le1[0]);
                                            const vt = le1.length / 4 * 4;
                                            let bt = 1;
                                            if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                                const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                                le1[bt] = (vt >> 1n ^ -(1n & vt)) + le1[bt - 1], le1[bt + 1] = (ls >> 1n ^ -(1n & ls)) + le1[bt], le1[bt + 2] = (ho >> 1n ^ -(1n & ho)) + le1[bt + 1], le1[bt + 3] = (Dl >> 1n ^ -(1n & Dl)) + le1[bt + 2];
                                            }
                                            for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] >> 1n ^ -(1n & le1[bt])) + le1[bt - 1];
                                        }(le1), le1);
                                    case bA.RLE:
                                        return function(le1, vt, bt) {
                                            return bt ? function(le1, vt, bt) {
                                                const ls = new BigInt64Array(bt);
                                                let ho = 0;
                                                for(let Dl = 0; Dl < vt; Dl++){
                                                    const bt = Number(le1[Dl]);
                                                    let Fl = le1[Dl + vt];
                                                    Fl = Fl >> 1n ^ -(1n & Fl), ls.fill(Fl, ho, ho + bt), ho += bt;
                                                }
                                                return ls;
                                            }(le1, vt.runs, vt.numRleValues) : bp(le1, vt.runs, vt.numRleValues);
                                        }(le1, vt, bt);
                                    case bA.NONE:
                                        return bt && function(le1) {
                                            for(let vt = 0; vt < le1.length; vt++){
                                                const bt = le1[vt];
                                                le1[vt] = bt >> 1n ^ -(1n & bt);
                                            }
                                        }(le1), le1;
                                    default:
                                        throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                                }
                            }(fp(le1, vt, bt.numValues), bt, ls);
                        }
                        function Bp(le1, vt, bt, ls) {
                            const ho = fp(le1, vt, bt.numValues);
                            if (1 === ho.length) {
                                const le1 = ho[0];
                                return ls ? gp(le1) : le1;
                            }
                            return ls ? function(le1) {
                                return gp(le1[1]);
                            }(ho) : function(le1) {
                                return le1[1];
                            }(ho);
                        }
                        function Vp(le1, vt, bt, ls, ho) {
                            return function(le1, vt, bt, ls) {
                                switch(vt.logicalLevelTechnique1){
                                    case bA.DELTA:
                                        return vt.logicalLevelTechnique2 === bA.RLE && (le1 = vp(le1, vt.runs, vt.numRleValues)), function(le1, vt) {
                                            const bt = new Int32Array(le1.size());
                                            let ls = 0;
                                            le1.get(0) ? (bt[0] = le1.get(0) ? vt[0] >>> 1 ^ -(1 & vt[0]) : 0, ls = 1) : bt[0] = 0;
                                            let ho = 1;
                                            for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? bt[ho - 1] + (vt[ls] >>> 1 ^ -(1 & vt[ls++])) : bt[ho - 1];
                                            return bt;
                                        }(ls, le1);
                                    case bA.RLE:
                                        return function(le1, vt, bt, ls) {
                                            const ho = vt;
                                            return bt ? function(le1, vt, bt) {
                                                const ls = new Int32Array(le1.size());
                                                let ho = 0;
                                                for(let Dl = 0; Dl < bt; Dl++){
                                                    const Fl = vt[Dl];
                                                    let sc = vt[Dl + bt];
                                                    sc = sc >>> 1 ^ -(1 & sc);
                                                    for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0, ho++);
                                                    ho += Fl;
                                                }
                                                return ls;
                                            }(ls, le1, ho.runs) : function(le1, vt, bt) {
                                                const ls = new Int32Array(le1.size());
                                                let ho = 0;
                                                for(let Dl = 0; Dl < bt; Dl++){
                                                    const Fl = vt[Dl], sc = vt[Dl + bt];
                                                    for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0, ho++);
                                                    ho += Fl;
                                                }
                                                return ls;
                                            }(ls, le1, ho.runs);
                                        }(le1, vt, bt, ls);
                                    case bA.MORTON:
                                        return _p(le1), le1;
                                    case bA.COMPONENTWISE_DELTA:
                                        return Sp(le1), le1;
                                    case bA.NONE:
                                        return le1 = bt ? function(le1, vt) {
                                            const bt = new Int32Array(le1.size());
                                            let ls = 0, ho = 0;
                                            for(; ho != bt.length; ++ho)if (le1.get(ho)) {
                                                const le1 = vt[ls++];
                                                bt[ho] = le1 >>> 1 ^ -(1 & le1);
                                            } else bt[ho] = 0;
                                            return bt;
                                        }(ls, le1) : function(le1, vt) {
                                            const bt = new Int32Array(le1.size());
                                            let ls = 0, ho = 0;
                                            for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? vt[ls++] : 0;
                                            return bt;
                                        }(ls, le1), le1;
                                    default:
                                        throw new Error("The specified Logical level technique is not supported");
                                }
                            }(bt.physicalLevelTechnique === wA.FAST_PFOR ? yp() : pp(le1, vt, bt.numValues), bt, ls, ho);
                        }
                        function Cp(le1, vt, bt, ls) {
                            const ho = le1.logicalLevelTechnique1;
                            if (ho === bA.RLE) return 1 === le1.runs ? kA.CONST : kA.FLAT;
                            const Dl = vt instanceof Ep ? vt.size() : vt;
                            if (ho === bA.DELTA && le1.logicalLevelTechnique2 === bA.RLE) {
                                const vt = le1.runs, ho = 2;
                                if (le1.numRleValues !== Dl) return kA.FLAT;
                                if (1 === vt) return kA.SEQUENCE;
                                if (2 === vt) {
                                    const vt = ls.get();
                                    let Dl;
                                    if (le1.physicalLevelTechnique === wA.VARINT) Dl = pp(bt, ls, 4);
                                    else {
                                        const le1 = ls.get();
                                        Dl = new Int32Array(bt.buffer, bt.byteOffset + le1, 4);
                                    }
                                    if (ls.set(vt), Dl[2] === ho && Dl[3] === ho) return kA.SEQUENCE;
                                }
                            }
                            return 1 === le1.numValues ? kA.CONST : kA.FLAT;
                        }
                        class Lp extends Zh {
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[le1];
                            }
                        }
                        class Op extends Wh {
                            constructor(le1, vt, bt, ls){
                                super(le1, BigInt64Array.of(vt), bt, ls);
                            }
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[0] + BigInt(le1) * this.delta;
                            }
                        }
                        class Rp {
                            _geometryOffsets;
                            _partOffsets;
                            _ringOffsets;
                            constructor(le1, vt, bt){
                                this._geometryOffsets = le1, this._partOffsets = vt, this._ringOffsets = bt;
                            }
                            get geometryOffsets() {
                                return this._geometryOffsets;
                            }
                            get partOffsets() {
                                return this._partOffsets;
                            }
                            get ringOffsets() {
                                return this._ringOffsets;
                            }
                        }
                        function Np(le1, vt, bt) {
                            return {
                                x: $p(le1, vt) - bt,
                                y: $p(le1 >> 1, vt) - bt
                            };
                        }
                        function $p(le1, vt) {
                            let bt = 0;
                            for(let ls = 0; ls < vt; ls++)bt |= (le1 & 1 << 2 * ls) >> ls;
                            return bt;
                        }
                        !function(le1) {
                            le1[le1.POINT = 0] = "POINT", le1[le1.LINESTRING = 1] = "LINESTRING", le1[le1.POLYGON = 2] = "POLYGON", le1[le1.MULTIPOINT = 3] = "MULTIPOINT", le1[le1.MULTILINESTRING = 4] = "MULTILINESTRING", le1[le1.MULTIPOLYGON = 5] = "MULTIPOLYGON";
                        }(CA || (CA = {})), function(le1) {
                            le1[le1.POINT = 0] = "POINT", le1[le1.LINESTRING = 1] = "LINESTRING", le1[le1.POLYGON = 2] = "POLYGON";
                        }(IA || (IA = {})), function(le1) {
                            le1[le1.MORTON = 0] = "MORTON", le1[le1.VEC_2 = 1] = "VEC_2", le1[le1.VEC_3 = 2] = "VEC_3";
                        }(DA || (DA = {}));
                        class Up {
                            createPoint(le1) {
                                return [
                                    [
                                        le1
                                    ]
                                ];
                            }
                            createMultiPoint(le1) {
                                return le1.map((le1)=>[
                                        le1
                                    ]);
                            }
                            createLineString(le1) {
                                return [
                                    le1
                                ];
                            }
                            createMultiLineString(le1) {
                                return le1;
                            }
                            createPolygon(le1, vt) {
                                return [
                                    le1
                                ].concat(vt);
                            }
                            createMultiPolygon(le1) {
                                return le1.flat();
                            }
                        }
                        function qp(le1) {
                            const vt = new Array(le1.numGeometries);
                            let bt = 1, ls = 1, ho = 1, Dl = 0;
                            const Fl = new Up;
                            let sc = 0, uc = 0;
                            const mc = le1.mortonSettings, gc = le1.topologyVector, Ac = gc.geometryOffsets, Ec = gc.partOffsets, kc = gc.ringOffsets, du = le1.vertexOffsets, _u = le1.containsPolygonGeometry(), Md = le1.vertexBuffer;
                            for(let Ld = 0; Ld < le1.numGeometries; Ld++){
                                const gc = le1.geometryType(Ld);
                                if (gc === CA.POINT) {
                                    if (du && 0 !== du.length) {
                                        if (le1.vertexBufferType === DA.VEC_2) {
                                            const le1 = 2 * du[uc++], bt = new r(Md[le1], Md[le1 + 1]);
                                            vt[Dl++] = Fl.createPoint(bt);
                                        } else {
                                            const le1 = Np(Md[du[uc++]], mc.numBits, mc.coordinateShift), bt = new r(le1.x, le1.y);
                                            vt[Dl++] = Fl.createPoint(bt);
                                        }
                                    } else {
                                        const le1 = new r(Md[sc++], Md[sc++]);
                                        vt[Dl++] = Fl.createPoint(le1);
                                    }
                                    Ac && ho++, Ec && bt++, kc && ls++;
                                } else if (gc === CA.MULTIPOINT) {
                                    const le1 = Ac[ho] - Ac[ho - 1];
                                    ho++;
                                    const bt = new Array(le1);
                                    if (du && 0 !== du.length) {
                                        for(let vt = 0; vt < le1; vt++){
                                            const le1 = 2 * du[uc++];
                                            bt[vt] = new r(Md[le1], Md[le1 + 1]);
                                        }
                                        vt[Dl++] = Fl.createMultiPoint(bt);
                                    } else {
                                        for(let vt = 0; vt < le1; vt++){
                                            const le1 = Md[sc++], ls = Md[sc++];
                                            bt[vt] = new r(le1, ls);
                                        }
                                        vt[Dl++] = Fl.createMultiPoint(bt);
                                    }
                                } else if (gc === CA.LINESTRING) {
                                    let gc, Ld = 0;
                                    _u ? (Ld = kc[ls] - kc[ls - 1], ls++) : Ld = Ec[bt] - Ec[bt - 1], bt++, du && 0 !== du.length ? (gc = le1.vertexBufferType === DA.VEC_2 ? Zp(Md, du, uc, Ld, !1) : Hp(Md, du, uc, Ld, !1, mc), uc += Ld) : (gc = Yp(Md, sc, Ld, !1), sc += 2 * Ld), vt[Dl++] = Fl.createLineString(gc), Ac && ho++;
                                } else if (gc === CA.POLYGON) {
                                    const gc = Ec[bt] - Ec[bt - 1];
                                    bt++;
                                    const _u = new Array(gc - 1);
                                    let Ld = kc[ls] - kc[ls - 1];
                                    if (ls++, du && 0 !== du.length) {
                                        const bt = le1.vertexBufferType === DA.VEC_2 ? Gp(Md, du, uc, Ld) : Xp(Md, du, uc, Ld, 0, mc);
                                        uc += Ld;
                                        for(let vt = 0; vt < _u.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, _u[vt] = le1.vertexBufferType === DA.VEC_2 ? Gp(Md, du, uc, Ld) : Xp(Md, du, uc, Ld, 0, mc), uc += Ld;
                                        vt[Dl++] = Fl.createPolygon(bt, _u);
                                    } else {
                                        const le1 = jp(Md, sc, Ld);
                                        sc += 2 * Ld;
                                        for(let vt = 0; vt < _u.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, _u[vt] = jp(Md, sc, Ld), sc += 2 * Ld;
                                        vt[Dl++] = Fl.createPolygon(le1, _u);
                                    }
                                    Ac && ho++;
                                } else if (gc === CA.MULTILINESTRING) {
                                    const gc = Ac[ho] - Ac[ho - 1];
                                    ho++;
                                    const Ld = new Array(gc);
                                    if (du && 0 !== du.length) {
                                        for(let vt = 0; vt < gc; vt++){
                                            let ho = 0;
                                            _u ? (ho = kc[ls] - kc[ls - 1], ls++) : ho = Ec[bt] - Ec[bt - 1], bt++;
                                            const Dl = le1.vertexBufferType === DA.VEC_2 ? Zp(Md, du, uc, ho, !1) : Hp(Md, du, uc, ho, !1, mc);
                                            Ld[vt] = Dl, uc += ho;
                                        }
                                        vt[Dl++] = Fl.createMultiLineString(Ld);
                                    } else {
                                        for(let le1 = 0; le1 < gc; le1++){
                                            let vt = 0;
                                            _u ? (vt = kc[ls] - kc[ls - 1], ls++) : vt = Ec[bt] - Ec[bt - 1], bt++, Ld[le1] = Yp(Md, sc, vt, !1), sc += 2 * vt;
                                        }
                                        vt[Dl++] = Fl.createMultiLineString(Ld);
                                    }
                                } else {
                                    if (gc !== CA.MULTIPOLYGON) throw new Error("The specified geometry type is currently not supported.");
                                    {
                                        const gc = Ac[ho] - Ac[ho - 1];
                                        ho++;
                                        const _u = new Array(gc);
                                        let Ld = 0;
                                        if (du && 0 !== du.length) {
                                            for(let vt = 0; vt < gc; vt++){
                                                const ho = Ec[bt] - Ec[bt - 1];
                                                bt++;
                                                const Dl = new Array(ho - 1);
                                                Ld = kc[ls] - kc[ls - 1], ls++;
                                                const sc = le1.vertexBufferType === DA.VEC_2 ? Gp(Md, du, uc, Ld) : Xp(Md, du, uc, Ld, 0, mc);
                                                uc += Ld;
                                                for(let vt = 0; vt < Dl.length; vt++)Ld = kc[ls] - kc[ls - 1], ls++, Dl[vt] = le1.vertexBufferType === DA.VEC_2 ? Gp(Md, du, uc, Ld) : Xp(Md, du, uc, Ld, 0, mc), uc += Ld;
                                                _u[vt] = Fl.createPolygon(sc, Dl);
                                            }
                                            vt[Dl++] = Fl.createMultiPolygon(_u);
                                        } else {
                                            for(let le1 = 0; le1 < gc; le1++){
                                                const vt = Ec[bt] - Ec[bt - 1];
                                                bt++;
                                                const ho = new Array(vt - 1);
                                                Ld = kc[ls] - kc[ls - 1], ls++;
                                                const Dl = jp(Md, sc, Ld);
                                                sc += 2 * Ld;
                                                for(let le1 = 0; le1 < ho.length; le1++){
                                                    const vt = kc[ls] - kc[ls - 1];
                                                    ls++, ho[le1] = jp(Md, sc, vt), sc += 2 * vt;
                                                }
                                                _u[le1] = Fl.createPolygon(Dl, ho);
                                            }
                                            vt[Dl++] = Fl.createMultiPolygon(_u);
                                        }
                                    }
                                }
                            }
                            return vt;
                        }
                        function jp(le1, vt, bt) {
                            return Yp(le1, vt, bt, !0);
                        }
                        function Gp(le1, vt, bt, ls) {
                            return Zp(le1, vt, bt, ls, !0);
                        }
                        function Xp(le1, vt, bt, ls, ho, Dl) {
                            return Hp(le1, vt, bt, ls, !0, Dl);
                        }
                        function Yp(le1, vt, bt, ls) {
                            const ho = new Array(ls ? bt + 1 : bt);
                            for(let Dl = 0; Dl < 2 * bt; Dl += 2)ho[Dl / 2] = new r(le1[vt + Dl], le1[vt + Dl + 1]);
                            return ls && (ho[ho.length - 1] = ho[0]), ho;
                        }
                        function Zp(le1, vt, bt, ls, ho) {
                            const Dl = new Array(ho ? ls + 1 : ls);
                            for(let Fl = 0; Fl < 2 * ls; Fl += 2){
                                const ls = 2 * vt[bt + Fl / 2];
                                Dl[Fl / 2] = new r(le1[ls], le1[ls + 1]);
                            }
                            return ho && (Dl[Dl.length - 1] = Dl[0]), Dl;
                        }
                        function Hp(le1, vt, bt, ls, ho, Dl) {
                            const Fl = new Array(ho ? ls + 1 : ls);
                            for(let sc = 0; sc < ls; sc++){
                                const ls = Np(le1[vt[bt + sc]], Dl.numBits, Dl.coordinateShift);
                                Fl[sc] = new r(ls.x, ls.y);
                            }
                            return ho && (Fl[Fl.length - 1] = Fl[0]), Fl;
                        }
                        class Kp {
                            _vertexBufferType;
                            _topologyVector;
                            _vertexOffsets;
                            _vertexBuffer;
                            _mortonSettings;
                            constructor(le1, vt, bt, ls, ho){
                                this._vertexBufferType = le1, this._topologyVector = vt, this._vertexOffsets = bt, this._vertexBuffer = ls, this._mortonSettings = ho;
                            }
                            get vertexBufferType() {
                                return this._vertexBufferType;
                            }
                            get topologyVector() {
                                return this._topologyVector;
                            }
                            get vertexOffsets() {
                                return this._vertexOffsets;
                            }
                            get vertexBuffer() {
                                return this._vertexBuffer;
                            }
                            *[Symbol.iterator]() {
                                const le1 = qp(this);
                                let vt = 0;
                                for(; vt < this.numGeometries;)yield {
                                    coordinates: le1[vt],
                                    type: this.geometryType(vt)
                                }, vt++;
                            }
                            getSimpleEncodedVertex(le1) {
                                const vt = this.vertexOffsets ? 2 * this.vertexOffsets[le1] : 2 * le1;
                                return [
                                    this.vertexBuffer[vt],
                                    this.vertexBuffer[vt + 1]
                                ];
                            }
                            getVertex(le1) {
                                if (this.vertexOffsets && this.mortonSettings) {
                                    const vt = Np(this.vertexBuffer[this.vertexOffsets[le1]], this.mortonSettings.numBits, this.mortonSettings.coordinateShift);
                                    return [
                                        vt.x,
                                        vt.y
                                    ];
                                }
                                const vt = this.vertexOffsets ? 2 * this.vertexOffsets[le1] : 2 * le1;
                                return [
                                    this.vertexBuffer[vt],
                                    this.vertexBuffer[vt + 1]
                                ];
                            }
                            getGeometries() {
                                return qp(this);
                            }
                            get mortonSettings() {
                                return this._mortonSettings;
                            }
                        }
                        class Wp extends Kp {
                            _numGeometries;
                            _geometryType;
                            constructor(le1, vt, bt, ls, ho, Dl, Fl){
                                super(bt, ls, ho, Dl, Fl), this._numGeometries = le1, this._geometryType = vt;
                            }
                            geometryType(le1) {
                                return this._geometryType;
                            }
                            get numGeometries() {
                                return this._numGeometries;
                            }
                            containsPolygonGeometry() {
                                return this._geometryType === CA.POLYGON || this._geometryType === CA.MULTIPOLYGON;
                            }
                            containsSingleGeometryType() {
                                return !0;
                            }
                        }
                        class Jp extends Kp {
                            _geometryTypes;
                            constructor(le1, vt, bt, ls, ho, Dl){
                                super(le1, bt, ls, ho, Dl), this._geometryTypes = vt;
                            }
                            geometryType(le1) {
                                return this._geometryTypes[le1];
                            }
                            get numGeometries() {
                                return this._geometryTypes.length;
                            }
                            containsPolygonGeometry() {
                                for(let le1 = 0; le1 < this.numGeometries; le1++)if (this.geometryType(le1) === CA.POLYGON || this.geometryType(le1) === CA.MULTIPOLYGON) return !0;
                                return !1;
                            }
                            containsSingleGeometryType() {
                                return !1;
                            }
                        }
                        class Qp {
                            _triangleOffsets;
                            _indexBuffer;
                            _vertexBuffer;
                            _topologyVector;
                            constructor(le1, vt, bt, ls){
                                this._triangleOffsets = le1, this._indexBuffer = vt, this._vertexBuffer = bt, this._topologyVector = ls;
                            }
                            get triangleOffsets() {
                                return this._triangleOffsets;
                            }
                            get indexBuffer() {
                                return this._indexBuffer;
                            }
                            get vertexBuffer() {
                                return this._vertexBuffer;
                            }
                            get topologyVector() {
                                return this._topologyVector;
                            }
                            getGeometries() {
                                if (!this._topologyVector) throw new Error("Cannot convert GpuVector to coordinates without topology information");
                                const le1 = new Array(this.numGeometries), vt = this._topologyVector, bt = vt.partOffsets, ls = vt.ringOffsets, ho = vt.geometryOffsets;
                                let Dl = 0, Fl = 1, sc = 1, uc = 1;
                                for(let mc = 0; mc < this.numGeometries; mc++)switch(this.geometryType(mc)){
                                    case CA.POLYGON:
                                        {
                                            const vt = bt[Fl] - bt[Fl - 1];
                                            Fl++;
                                            const gc = [];
                                            for(let le1 = 0; le1 < vt; le1++){
                                                const le1 = ls[sc] - ls[sc - 1];
                                                sc++;
                                                const vt = [];
                                                for(let bt = 0; bt < le1; bt++){
                                                    const le1 = this._vertexBuffer[Dl++], bt = this._vertexBuffer[Dl++];
                                                    vt.push(new r(le1, bt));
                                                }
                                                vt.length > 0 && vt.push(vt[0]), gc.push(vt);
                                            }
                                            le1[mc] = gc, ho && uc++;
                                        }
                                        break;
                                    case CA.MULTIPOLYGON:
                                        {
                                            const vt = ho[uc] - ho[uc - 1];
                                            uc++;
                                            const gc = [];
                                            for(let le1 = 0; le1 < vt; le1++){
                                                const le1 = bt[Fl] - bt[Fl - 1];
                                                Fl++;
                                                for(let vt = 0; vt < le1; vt++){
                                                    const le1 = ls[sc] - ls[sc - 1];
                                                    sc++;
                                                    const vt = [];
                                                    for(let bt = 0; bt < le1; bt++){
                                                        const le1 = this._vertexBuffer[Dl++], bt = this._vertexBuffer[Dl++];
                                                        vt.push(new r(le1, bt));
                                                    }
                                                    vt.length > 0 && vt.push(vt[0]), gc.push(vt);
                                                }
                                            }
                                            le1[mc] = gc;
                                        }
                                }
                                return le1;
                            }
                            [Symbol.iterator]() {
                                return null;
                            }
                        }
                        function tf(le1, vt, bt, ls, ho, Dl) {
                            return new ef(le1, vt, bt, ls, ho, Dl);
                        }
                        class ef extends Qp {
                            _numGeometries;
                            _geometryType;
                            constructor(le1, vt, bt, ls, ho, Dl){
                                super(bt, ls, ho, Dl), this._numGeometries = le1, this._geometryType = vt;
                            }
                            geometryType(le1) {
                                return this._geometryType;
                            }
                            get numGeometries() {
                                return this._numGeometries;
                            }
                            containsSingleGeometryType() {
                                return !0;
                            }
                        }
                        function rf(le1, vt, bt, ls, ho) {
                            return new nf(le1, vt, bt, ls, ho);
                        }
                        class nf extends Qp {
                            _geometryTypes;
                            constructor(le1, vt, bt, ls, ho){
                                super(vt, bt, ls, ho), this._geometryTypes = le1;
                            }
                            geometryType(le1) {
                                return this._geometryTypes[le1];
                            }
                            get numGeometries() {
                                return this._geometryTypes.length;
                            }
                            containsSingleGeometryType() {
                                return !1;
                            }
                        }
                        function sf(le1, vt, bt, ls, ho) {
                            const Dl = kp(le1, bt);
                            let Fl = null, sc = null, uc = null, mc = null, gc = null, Ac = null, Ec = null, kc = null;
                            if (Cp(Dl, ls, le1, bt) === kA.CONST) {
                                const ho = Fp(le1, bt, Dl, !1);
                                for(let ls = 0; ls < vt - 1; ls++){
                                    const vt = kp(le1, bt);
                                    switch(vt.physicalStreamType){
                                        case EA.LENGTH:
                                            switch(vt.logicalStreamType.lengthType){
                                                case TA.GEOMETRIES:
                                                    Fl = Ip(le1, bt, vt);
                                                    break;
                                                case TA.PARTS:
                                                    sc = Ip(le1, bt, vt);
                                                    break;
                                                case TA.RINGS:
                                                    uc = Ip(le1, bt, vt);
                                                    break;
                                                case TA.TRIANGLES:
                                                    Ec = Ip(le1, bt, vt);
                                            }
                                            break;
                                        case EA.OFFSET:
                                            switch(vt.logicalStreamType.offsetType){
                                                case SA.VERTEX:
                                                    mc = Tp(le1, bt, vt, !1);
                                                    break;
                                                case SA.INDEX:
                                                    kc = Tp(le1, bt, vt, !1);
                                            }
                                            break;
                                        case EA.DATA:
                                            MA.VERTEX === vt.logicalStreamType.dictionaryType ? gc = Tp(le1, bt, vt, !0) : (Ac = {
                                                numBits: vt.numBits,
                                                coordinateShift: vt.coordinateShift
                                            }, gc = Tp(le1, bt, vt, !1));
                                    }
                                }
                                return null !== kc ? null != Fl || null != sc ? tf(ls, ho, Ec, kc, gc, new Rp(Fl, sc, uc)) : tf(ls, ho, Ec, kc, gc) : null === Ac ? function(le1, vt, bt, ls, ho) {
                                    return new Wp(le1, vt, DA.VEC_2, bt, ls, ho);
                                }(ls, ho, new Rp(Fl, sc, uc), mc, gc) : function(le1, vt, bt, ls, ho, Dl) {
                                    return new Wp(le1, vt, DA.MORTON, bt, ls, ho, Dl);
                                }(ls, ho, new Rp(Fl, sc, uc), mc, gc, Ac);
                            }
                            const du = Tp(le1, bt, Dl, !1);
                            for(let _u = 0; _u < vt - 1; _u++){
                                const vt = kp(le1, bt);
                                switch(vt.physicalStreamType){
                                    case EA.LENGTH:
                                        switch(vt.logicalStreamType.lengthType){
                                            case TA.GEOMETRIES:
                                                Fl = Tp(le1, bt, vt, !1);
                                                break;
                                            case TA.PARTS:
                                                sc = Tp(le1, bt, vt, !1);
                                                break;
                                            case TA.RINGS:
                                                uc = Tp(le1, bt, vt, !1);
                                                break;
                                            case TA.TRIANGLES:
                                                Ec = Ip(le1, bt, vt);
                                        }
                                        break;
                                    case EA.OFFSET:
                                        switch(vt.logicalStreamType.offsetType){
                                            case SA.VERTEX:
                                                mc = Tp(le1, bt, vt, !1);
                                                break;
                                            case SA.INDEX:
                                                kc = Tp(le1, bt, vt, !1);
                                        }
                                        break;
                                    case EA.DATA:
                                        MA.VERTEX === vt.logicalStreamType.dictionaryType ? gc = Tp(le1, bt, vt, !0) : (Ac = {
                                            numBits: vt.numBits,
                                            coordinateShift: vt.coordinateShift
                                        }, gc = Tp(le1, bt, vt, !1));
                                }
                            }
                            return null !== kc && null === sc ? rf(du, Ec, kc, gc) : (null !== Fl ? (Fl = af(du, Fl, 2), null !== sc && null !== uc ? (sc = of(du, Fl, sc, !1), uc = function(le1, vt, bt, ls) {
                                const ho = new Int32Array(bt[bt.length - 1] + 1);
                                let Dl = 0;
                                ho[0] = Dl;
                                let Fl = 1, sc = 1, uc = 0;
                                for(let mc = 0; mc < le1.length; mc++){
                                    const gc = le1[mc], Ac = vt[mc + 1] - vt[mc];
                                    if (0 !== gc && 3 !== gc) for(let le1 = 0; le1 < Ac; le1++){
                                        const le1 = bt[Fl] - bt[Fl - 1];
                                        Fl++;
                                        for(let vt = 0; vt < le1; vt++)Dl = ho[sc++] = Dl + ls[uc++];
                                    }
                                    else for(let le1 = 0; le1 < Ac; le1++)ho[sc++] = ++Dl, Fl++;
                                }
                                return ho;
                            }(du, Fl, sc, uc)) : null !== sc && (sc = function(le1, vt, bt) {
                                const ls = new Int32Array(vt[vt.length - 1] + 1);
                                let ho = 0;
                                ls[0] = ho;
                                let Dl = 1, Fl = 0;
                                for(let sc = 0; sc < le1.length; sc++){
                                    const uc = le1[sc], mc = vt[sc + 1] - vt[sc];
                                    if (4 === uc || 1 === uc) for(let le1 = 0; le1 < mc; le1++)ho = ls[Dl++] = ho + bt[Fl++];
                                    else for(let le1 = 0; le1 < mc; le1++)ls[Dl++] = ++ho;
                                }
                                return ls;
                            }(du, Fl, sc))) : null !== sc && null !== uc ? (sc = af(du, sc, 1), uc = of(du, sc, uc, !0)) : null !== sc && (sc = af(du, sc, 0)), null !== kc ? rf(du, Ec, kc, gc, new Rp(Fl, sc, uc)) : null === Ac ? function(le1, vt, bt, ls) {
                                return new Jp(DA.VEC_2, le1, vt, bt, ls);
                            }(du, new Rp(Fl, sc, uc), mc, gc) : function(le1, vt, bt, ls, ho) {
                                return new Jp(DA.MORTON, le1, vt, bt, ls, ho);
                            }(du, new Rp(Fl, sc, uc), mc, gc, Ac));
                        }
                        function af(le1, vt, bt) {
                            const ls = new Int32Array(le1.length + 1);
                            let ho = 0;
                            ls[0] = ho;
                            let Dl = 0;
                            for(let Fl = 0; Fl < le1.length; Fl++)ho = ls[Fl + 1] = ho + (le1[Fl] > bt ? vt[Dl++] : 1);
                            return ls;
                        }
                        function of(le1, vt, bt, ls) {
                            const ho = new Int32Array(vt[vt.length - 1] + 1);
                            let Dl = 0;
                            ho[0] = Dl;
                            let Fl = 1, sc = 0;
                            for(let uc = 0; uc < le1.length; uc++){
                                const mc = le1[uc], gc = vt[uc + 1] - vt[uc];
                                if (5 === mc || 2 === mc || ls && (4 === mc || 1 === mc)) for(let le1 = 0; le1 < gc; le1++)Dl = ho[Fl++] = Dl + bt[sc++];
                                else for(let le1 = 0; le1 < gc; le1++)ho[Fl++] = ++Dl;
                            }
                            return ho;
                        }
                        class lf extends Yh {
                            dataVector;
                            constructor(le1, vt, bt){
                                super(le1, vt.getBuffer(), bt), this.dataVector = vt;
                            }
                            getValueFromBuffer(le1) {
                                return this.dataVector.get(le1);
                            }
                        }
                        class uf extends Zh {
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[le1];
                            }
                        }
                        class cf extends Yh {
                            constructor(le1, vt, bt){
                                super(le1, BigInt64Array.of(vt), bt);
                            }
                            getValueFromBuffer(le1) {
                                return this.dataBuffer[0];
                            }
                        }
                        function hf(le1, vt, bt) {
                            return pf(le1, Math.ceil(vt / 8), bt);
                        }
                        function pf(le1, vt, bt) {
                            const ls = new Uint8Array(vt);
                            let ho = 0;
                            for(; ho < vt;){
                                const vt = le1[bt.increment()];
                                if (vt <= 127) {
                                    const Dl = vt + 3, Fl = le1[bt.increment()], sc = ho + Dl;
                                    ls.fill(Fl, ho, sc), ho = sc;
                                } else {
                                    const Dl = 256 - vt;
                                    for(let vt = 0; vt < Dl; vt++)ls[ho++] = le1[bt.increment()];
                                }
                            }
                            return ls;
                        }
                        const LA = new TextDecoder;
                        function df(le1, vt, bt) {
                            return bt - vt >= 12 ? LA.decode(le1.subarray(vt, bt)) : function(le1, vt, bt) {
                                let ls = "", ho = vt;
                                for(; ho < bt;){
                                    const vt = le1[ho];
                                    let Dl, Fl, sc, uc = null, mc = vt > 239 ? 4 : vt > 223 ? 3 : vt > 191 ? 2 : 1;
                                    if (ho + mc > bt) break;
                                    1 === mc ? vt < 128 && (uc = vt) : 2 === mc ? (Dl = le1[ho + 1], 128 == (192 & Dl) && (uc = (31 & vt) << 6 | 63 & Dl, uc <= 127 && (uc = null))) : 3 === mc ? (Dl = le1[ho + 1], Fl = le1[ho + 2], 128 == (192 & Dl) && 128 == (192 & Fl) && (uc = (15 & vt) << 12 | (63 & Dl) << 6 | 63 & Fl, (uc <= 2047 || uc >= 55296 && uc <= 57343) && (uc = null))) : 4 === mc && (Dl = le1[ho + 1], Fl = le1[ho + 2], sc = le1[ho + 3], 128 == (192 & Dl) && 128 == (192 & Fl) && 128 == (192 & sc) && (uc = (15 & vt) << 18 | (63 & Dl) << 12 | (63 & Fl) << 6 | 63 & sc, (uc <= 65535 || uc >= 1114112) && (uc = null))), null === uc ? (uc = 65533, mc = 1) : uc > 65535 && (uc -= 65536, ls += String.fromCharCode(uc >>> 10 & 1023 | 55296), uc = 56320 | 1023 & uc), ls += String.fromCharCode(uc), ho += mc;
                                }
                                return ls;
                            }(le1, vt, bt);
                        }
                        class yf extends Yh {
                            offsetBuffer;
                            constructor(le1, vt, bt, ls){
                                super(le1, bt, ls), this.offsetBuffer = vt;
                            }
                        }
                        class mf extends yf {
                            textEncoder;
                            constructor(le1, vt, bt, ls){
                                super(le1, vt, bt, ls ?? vt.length - 1), this.textEncoder = new TextEncoder;
                            }
                            getValueFromBuffer(le1) {
                                return df(this.dataBuffer, this.offsetBuffer[le1], this.offsetBuffer[le1 + 1]);
                            }
                        }
                        class gf extends yf {
                            indexBuffer;
                            textEncoder;
                            constructor(le1, vt, bt, ls, ho){
                                super(le1, bt, ls, ho ?? vt.length), this.indexBuffer = vt, this.indexBuffer = vt, this.textEncoder = new TextEncoder;
                            }
                            getValueFromBuffer(le1) {
                                const vt = this.indexBuffer[le1];
                                return df(this.dataBuffer, this.offsetBuffer[vt], this.offsetBuffer[vt + 1]);
                            }
                        }
                        class xf extends yf {
                            indexBuffer;
                            symbolOffsetBuffer;
                            symbolTableBuffer;
                            textEncoder;
                            symbolLengthBuffer;
                            lengthBuffer;
                            decodedDictionary;
                            constructor(le1, vt, bt, ls, ho, Dl, Fl){
                                super(le1, bt, ls, Fl), this.indexBuffer = vt, this.symbolOffsetBuffer = ho, this.symbolTableBuffer = Dl, this.textEncoder = new TextEncoder;
                            }
                            getValueFromBuffer(le1) {
                                null == this.decodedDictionary && (null == this.symbolLengthBuffer && (this.symbolLengthBuffer = this.offsetToLengthBuffer(this.symbolOffsetBuffer), this.lengthBuffer = this.offsetToLengthBuffer(this.offsetBuffer)), this.decodedDictionary = function(le1, vt, bt) {
                                    const ls = [], ho = new Array(vt.length).fill(0);
                                    for(let Dl = 1; Dl < vt.length; Dl++)ho[Dl] = ho[Dl - 1] + vt[Dl - 1];
                                    for(let Dl = 0; Dl < bt.length; Dl++)if (255 === bt[Dl]) ls.push(bt[++Dl]);
                                    else {
                                        const Fl = vt[bt[Dl]], sc = ho[bt[Dl]];
                                        for(let vt = 0; vt < Fl; vt++)ls.push(le1[sc + vt]);
                                    }
                                    return new Uint8Array(ls);
                                }(this.symbolTableBuffer, this.symbolLengthBuffer, this.dataBuffer));
                                const vt = this.indexBuffer[le1];
                                return df(this.decodedDictionary, this.offsetBuffer[vt], this.offsetBuffer[vt + 1]);
                            }
                            offsetToLengthBuffer(le1) {
                                const vt = new Uint32Array(le1.length - 1);
                                let bt = le1[0];
                                for(let ls = 1; ls < le1.length; ls++){
                                    const ho = le1[ls];
                                    vt[ls - 1] = ho - bt, bt = ho;
                                }
                                return vt;
                            }
                        }
                        function vf(le1, vt, bt, ls, ho, Dl) {
                            return "scalarType" === bt.type ? function(le1, vt, bt, ls, ho, Dl) {
                                let Fl = null, sc = 0;
                                if (0 === le1) return null;
                                if (Dl.nullable) {
                                    const le1 = kp(vt, bt);
                                    sc = le1.numValues;
                                    const ls = bt.get(), ho = hf(vt, sc, bt);
                                    bt.set(ls + le1.byteLength), Fl = new Ep(ho, le1.numValues);
                                }
                                const uc = Fl ?? ls;
                                switch(ho.physicalType){
                                    case 4:
                                    case 3:
                                        return function(le1, vt, bt, ls, ho) {
                                            const Dl = kp(le1, vt), Fl = Cp(Dl, ho, le1, vt), sc = 3 === ls.physicalType;
                                            if (Fl === kA.FLAT) {
                                                const ls = bf(ho) ? Vp(le1, vt, Dl, sc, ho) : Tp(le1, vt, Dl, sc);
                                                return new Hh(bt.name, ls, ho);
                                            }
                                            if (Fl === kA.SEQUENCE) {
                                                const ls = Dp(le1, vt, Dl);
                                                return new Jh(bt.name, ls[0], ls[1], Dl.numRleValues);
                                            }
                                            {
                                                const ls = Fp(le1, vt, Dl, sc);
                                                return new Qh(bt.name, ls, ho);
                                            }
                                        }(vt, bt, Dl, ho, uc);
                                    case 9:
                                        return function(le1, vt, bt, ls, ho) {
                                            let Dl = null, Fl = null, sc = null, uc = null, mc = null, gc = null, Ac = null, Ec = null;
                                            for(let kc = 0; kc < ls; kc++){
                                                const le1 = kp(vt, bt);
                                                if (0 !== le1.byteLength) switch(le1.physicalStreamType){
                                                    case EA.PRESENT:
                                                        {
                                                            const ls = hf(vt, le1.numValues, bt);
                                                            gc = new Ep(ls, le1.numValues);
                                                            break;
                                                        }
                                                    case EA.OFFSET:
                                                        Fl = null != ho || null != gc ? Vp(vt, bt, le1, !1, ho ?? gc) : Tp(vt, bt, le1, !1);
                                                        break;
                                                    case EA.LENGTH:
                                                        {
                                                            const ls = Ip(vt, bt, le1);
                                                            TA.DICTIONARY === le1.logicalStreamType.lengthType ? Dl = ls : TA.SYMBOL === le1.logicalStreamType.lengthType ? uc = ls : Ac = ls;
                                                            break;
                                                        }
                                                    case EA.DATA:
                                                        {
                                                            const ls = vt.subarray(bt.get(), bt.get() + le1.byteLength);
                                                            bt.add(le1.byteLength);
                                                            const ho = le1.logicalStreamType.dictionaryType;
                                                            MA.FSST === ho ? mc = ls : MA.SINGLE === ho || MA.SHARED === ho ? sc = ls : MA.NONE === ho && (Ec = ls);
                                                            break;
                                                        }
                                                }
                                            }
                                            return function(le1, vt, bt, ls, ho, Dl, Fl) {
                                                return vt ? new xf(le1, bt, ls, ho, Dl, vt, Fl) : null;
                                            }(le1, mc, Fl, Dl, sc, uc, ho ?? gc) ?? function(le1, vt, bt, ls, ho) {
                                                return vt ? ho ? new gf(le1, bt, ls, vt, ho) : new gf(le1, bt, ls, vt) : null;
                                            }(le1, sc, Fl, Dl, ho ?? gc) ?? function(le1, vt, bt, ls, ho) {
                                                if (!vt || !bt) return null;
                                                if (ls) return ho ? new gf(le1, ls, vt, bt, ho) : new gf(le1, ls, vt, bt);
                                                if (ho && ho.size() !== vt.length - 1) {
                                                    const ls = new Int32Array(ho.size());
                                                    let Dl = 0;
                                                    for(let le1 = 0; le1 < ho.size(); le1++)ls[le1] = ho.get(le1) ? Dl++ : 0;
                                                    return new gf(le1, ls, vt, bt, ho);
                                                }
                                                return ho ? new mf(le1, vt, bt, ho) : new mf(le1, vt, bt);
                                            }(le1, Ac, Ec, Fl, ho ?? gc);
                                        }(Dl.name, vt, bt, Dl.nullable ? le1 - 1 : le1, Fl);
                                    case 0:
                                        return function(le1, vt, bt, ls, ho) {
                                            const Dl = kp(le1, vt), Fl = Dl.numValues, sc = vt.get(), uc = bf(ho) ? function(le1, vt, bt, ls) {
                                                const ho = pf(le1, Math.ceil(vt / 8), bt), Dl = new Ep(ho, vt), Fl = ls.size(), sc = new Ep(new Uint8Array(Fl), Fl);
                                                let uc = 0;
                                                for(let mc = 0; mc < ls.size(); mc++){
                                                    const le1 = !!ls.get(mc) && Dl.get(uc++);
                                                    sc.set(mc, le1);
                                                }
                                                return sc.getBuffer();
                                            }(le1, Fl, vt, ho) : hf(le1, Fl, vt);
                                            vt.set(sc + Dl.byteLength);
                                            const mc = new Ep(uc, Fl);
                                            return new lf(bt.name, mc, ho);
                                        }(vt, bt, Dl, 0, uc);
                                    case 6:
                                    case 5:
                                        return function(le1, vt, bt, ls, ho) {
                                            const Dl = kp(le1, vt), Fl = Cp(Dl, ls, le1, vt), sc = 5 === ho.physicalType;
                                            if (Fl === kA.FLAT) {
                                                const ho = bf(ls) ? function(le1, vt, bt, ls, ho) {
                                                    return function(le1, vt, bt, ls) {
                                                        switch(vt.logicalLevelTechnique1){
                                                            case bA.DELTA:
                                                                return vt.logicalLevelTechnique2 === bA.RLE && (le1 = bp(le1, vt.runs, vt.numRleValues)), function(le1, vt) {
                                                                    const bt = new BigInt64Array(le1.size());
                                                                    let ls = 0;
                                                                    le1.get(0) ? (bt[0] = le1.get(0) ? vt[0] >> 1n ^ -(1n & vt[0]) : 0n, ls = 1) : bt[0] = 0n;
                                                                    let ho = 1;
                                                                    for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? bt[ho - 1] + (vt[ls] >> 1n ^ -(1n & vt[ls++])) : bt[ho - 1];
                                                                    return bt;
                                                                }(ls, le1);
                                                            case bA.RLE:
                                                                return function(le1, vt, bt, ls) {
                                                                    const ho = vt;
                                                                    return bt ? function(le1, vt, bt) {
                                                                        const ls = new BigInt64Array(le1.size());
                                                                        let ho = 0;
                                                                        for(let Dl = 0; Dl < bt; Dl++){
                                                                            const Fl = Number(vt[Dl]);
                                                                            let sc = vt[Dl + bt];
                                                                            sc = sc >> 1n ^ -(1n & sc);
                                                                            for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0n, ho++);
                                                                            ho += Fl;
                                                                        }
                                                                        return ls;
                                                                    }(ls, le1, ho.runs) : function(le1, vt, bt) {
                                                                        const ls = new BigInt64Array(le1.size());
                                                                        let ho = 0;
                                                                        for(let Dl = 0; Dl < bt; Dl++){
                                                                            const Fl = Number(vt[Dl]), sc = vt[Dl + bt];
                                                                            for(let vt = ho; vt < ho + Fl; vt++)le1.get(vt) ? ls[vt] = sc : (ls[vt] = 0n, ho++);
                                                                            ho += Fl;
                                                                        }
                                                                        return ls;
                                                                    }(ls, le1, ho.runs);
                                                                }(le1, vt, bt, ls);
                                                            case bA.NONE:
                                                                return le1 = bt ? function(le1, vt) {
                                                                    const bt = new BigInt64Array(le1.size());
                                                                    let ls = 0, ho = 0;
                                                                    for(; ho != bt.length; ++ho)if (le1.get(ho)) {
                                                                        const le1 = vt[ls++];
                                                                        bt[ho] = le1 >> 1n ^ -(1n & le1);
                                                                    } else bt[ho] = 0n;
                                                                    return bt;
                                                                }(ls, le1) : function(le1, vt) {
                                                                    const bt = new BigInt64Array(le1.size());
                                                                    let ls = 0, ho = 0;
                                                                    for(; ho != bt.length; ++ho)bt[ho] = le1.get(ho) ? vt[ls++] : 0n;
                                                                    return bt;
                                                                }(ls, le1), le1;
                                                            default:
                                                                throw new Error("The specified Logical level technique is not supported");
                                                        }
                                                    }(fp(le1, vt, bt.numValues), bt, ls, ho);
                                                }(le1, vt, Dl, sc, ls) : Pp(le1, vt, Dl, sc);
                                                return new Lp(bt.name, ho, ls);
                                            }
                                            if (Fl === kA.SEQUENCE) {
                                                const ls = zp(le1, vt, Dl);
                                                return new Op(bt.name, ls[0], ls[1], Dl.numRleValues);
                                            }
                                            {
                                                const ho = Bp(le1, vt, Dl, sc);
                                                return new cf(bt.name, ho, ls);
                                            }
                                        }(vt, bt, Dl, uc, ho);
                                    case 7:
                                        return function(le1, vt, bt, ls) {
                                            const ho = kp(le1, vt), Dl = bf(ls) ? function(le1, vt, bt, ls) {
                                                const ho = vt.get(), Dl = ho + ls * Float32Array.BYTES_PER_ELEMENT, Fl = new Uint8Array(le1.subarray(ho, Dl)).buffer, sc = new Float32Array(Fl);
                                                vt.set(Dl);
                                                const uc = bt.size(), mc = new Float32Array(uc);
                                                let gc = 0;
                                                for(let Ac = 0; Ac < uc; Ac++)mc[Ac] = bt.get(Ac) ? sc[gc++] : 0;
                                                return mc;
                                            }(le1, vt, ls, ho.numValues) : function(le1, vt, bt) {
                                                const ls = vt.get(), ho = ls + bt * Float32Array.BYTES_PER_ELEMENT, Dl = new Uint8Array(le1.subarray(ls, ho)).buffer, Fl = new Float32Array(Dl);
                                                return vt.set(ho), Fl;
                                            }(le1, vt, ho.numValues);
                                            return new uf(bt.name, Dl, ls);
                                        }(vt, bt, Dl, uc);
                                    case 8:
                                        return function(le1, vt, bt, ls) {
                                            const ho = kp(le1, vt), Dl = bf(ls) ? function(le1, vt, bt, ls) {
                                                const ho = vt.get(), Dl = ho + ls * Float64Array.BYTES_PER_ELEMENT, Fl = new Uint8Array(le1.subarray(ho, Dl)).buffer, sc = new Float64Array(Fl);
                                                vt.set(Dl);
                                                const uc = bt.size(), mc = new Float64Array(uc);
                                                let gc = 0;
                                                for(let Ac = 0; Ac < uc; Ac++)mc[Ac] = bt.get(Ac) ? sc[gc++] : 0;
                                                return mc;
                                            }(le1, vt, ls, ho.numValues) : function(le1, vt, bt) {
                                                const ls = vt.get(), ho = ls + bt * Float64Array.BYTES_PER_ELEMENT, Dl = new Uint8Array(le1.subarray(ls, ho)).buffer, Fl = new Float64Array(Dl);
                                                return vt.set(ho), Fl;
                                            }(le1, vt, ho.numValues);
                                            return new Kh(bt.name, Dl, ls);
                                        }(vt, bt, Dl, uc);
                                    default:
                                        throw new Error(`The specified data type for the field is currently not supported: ${ho}`);
                                }
                            }(ls, le1, vt, ho, bt.scalarType, bt) : 1 != ls ? null : function(le1, vt, bt, ls) {
                                let ho = null, Dl = null, Fl = null, sc = null, uc = !1;
                                for(; !uc;){
                                    const bt = kp(le1, vt);
                                    switch(bt.physicalStreamType){
                                        case EA.LENGTH:
                                            TA.DICTIONARY === bt.logicalStreamType.lengthType ? ho = Ip(le1, vt, bt) : Fl = Ip(le1, vt, bt);
                                            break;
                                        case EA.DATA:
                                            MA.SINGLE === bt.logicalStreamType.dictionaryType || MA.SHARED === bt.logicalStreamType.dictionaryType ? (Dl = le1.subarray(vt.get(), vt.get() + bt.byteLength), uc = !0) : sc = le1.subarray(vt.get(), vt.get() + bt.byteLength), vt.add(bt.byteLength);
                                    }
                                }
                                const mc = bt.complexType.children, gc = [];
                                let Ac = 0;
                                for (const Ec of mc){
                                    const uc = pp(le1, vt, 1)[0];
                                    if (0 == uc) continue;
                                    const mc = `${bt.name}${"default" === Ec.name ? "" : ":" + Ec.name}`;
                                    if (2 !== uc || "scalarField" !== Ec.type || 9 !== Ec.scalarField.physicalType) throw new Error("Currently only optional string fields are implemented for a struct.");
                                    const kc = kp(le1, vt), du = hf(le1, kc.numValues, vt), _u = kp(le1, vt), Md = _u.decompressedCount !== ls ? Vp(le1, vt, _u, !1, new Ep(du, kc.numValues)) : Tp(le1, vt, _u, !1);
                                    gc[Ac++] = sc ? new xf(mc, Md, ho, Dl, Fl, sc, new Ep(du, kc.numValues)) : new gf(mc, Md, ho, Dl, new Ep(du, kc.numValues));
                                }
                                return gc;
                            }(le1, vt, bt, ho);
                        }
                        function bf(le1) {
                            return le1 instanceof Ep;
                        }
                        function wf(le1) {
                            if ("id" === le1.name) return !1;
                            if ("scalarType" === le1.type) {
                                const vt = le1.scalarType;
                                if ("physicalType" === vt.type) switch(vt.physicalType){
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                    case 4:
                                    case 5:
                                    case 6:
                                    case 7:
                                    case 8:
                                    default:
                                        return !1;
                                    case 9:
                                        return !0;
                                }
                                else if ("logicalType" === vt.type) return !1;
                            } else if ("complexType" === le1.type) {
                                const vt = le1.complexType;
                                if ("physicalType" === vt.type) switch(vt.physicalType){
                                    case 0:
                                    case 1:
                                        return !0;
                                    default:
                                        return !1;
                                }
                            }
                            return console.warn("Unexpected column type in hasStreamCount", le1), !1;
                        }
                        const PA = new TextDecoder;
                        function Sf(le1, vt) {
                            const bt = pp(le1, vt, 1)[0];
                            if (0 === bt) return "";
                            const ls = vt.get(), ho = le1.subarray(ls, ls + bt);
                            return vt.add(bt), PA.decode(ho);
                        }
                        function Af(le1, vt) {
                            const bt = pp(le1, vt, 1)[0] >>> 0, ls = !!(4 & bt), ho = !!(2 & bt), Dl = pp(le1, vt, 1)[0] >>> 0, Fl = {};
                            if (1 & bt && (Fl.nullable = !0), ho) {
                                const ho = {};
                                if (ls ? (ho.type = "logicalType", ho.logicalType = Dl) : (ho.type = "physicalType", ho.physicalType = Dl), 8 & bt) {
                                    const bt = pp(le1, vt, 1)[0] >>> 0;
                                    ho.children = new Array(bt);
                                    for(let ls = 0; ls < bt; ls++)ho.children[ls] = Af(le1, vt);
                                }
                                Fl.type = "complexField", Fl.complexField = ho;
                            } else {
                                const le1 = {};
                                ls ? (le1.type = "logicalType", le1.logicalType = Dl) : (le1.type = "physicalType", le1.physicalType = Dl), Fl.type = "scalarField", Fl.scalarField = le1;
                            }
                            return Fl;
                        }
                        function kf(le1, vt) {
                            const bt = pp(le1, vt, 1)[0] >>> 0, ls = function(le1) {
                                switch(le1){
                                    case 0:
                                    case 1:
                                    case 2:
                                    case 3:
                                        {
                                            const vt = {};
                                            vt.nullable = !!(1 & le1), vt.columnScope = 0;
                                            const bt = {};
                                            return bt.physicalType = le1 > 1 ? 6 : 4, bt.type = "physicalType", vt.scalarType = bt, vt.type = "scalarType", vt;
                                        }
                                    case 4:
                                        {
                                            const le1 = {
                                                nullable: !1,
                                                columnScope: 0
                                            }, vt = {
                                                type: "physicalType",
                                                physicalType: 0
                                            };
                                            return le1.type = "complexType", le1.complexType = vt, le1;
                                        }
                                    case 30:
                                        {
                                            const le1 = {
                                                nullable: !1,
                                                columnScope: 0
                                            }, vt = {
                                                type: "physicalType",
                                                physicalType: 1
                                            };
                                            return le1.type = "complexType", le1.complexType = vt, le1;
                                        }
                                    default:
                                        return function(le1) {
                                            let vt = null;
                                            switch(le1){
                                                case 10:
                                                case 11:
                                                    vt = 0;
                                                    break;
                                                case 12:
                                                case 13:
                                                    vt = 1;
                                                    break;
                                                case 14:
                                                case 15:
                                                    vt = 2;
                                                    break;
                                                case 16:
                                                case 17:
                                                    vt = 3;
                                                    break;
                                                case 18:
                                                case 19:
                                                    vt = 4;
                                                    break;
                                                case 20:
                                                case 21:
                                                    vt = 5;
                                                    break;
                                                case 22:
                                                case 23:
                                                    vt = 6;
                                                    break;
                                                case 24:
                                                case 25:
                                                    vt = 7;
                                                    break;
                                                case 26:
                                                case 27:
                                                    vt = 8;
                                                    break;
                                                case 28:
                                                case 29:
                                                    vt = 9;
                                                    break;
                                                default:
                                                    return null;
                                            }
                                            const bt = {};
                                            bt.nullable = !!(1 & le1), bt.columnScope = 0;
                                            const ls = {
                                                type: "physicalType"
                                            };
                                            return ls.physicalType = vt, bt.type = "scalarType", bt.scalarType = ls, bt;
                                        }(le1);
                                }
                            }(bt);
                            if (!ls) throw new Error(`Unsupported column type code: ${bt}`);
                            if (function(le1) {
                                return le1 >= 10;
                            }(bt) ? ls.name = Sf(le1, vt) : bt >= 0 && bt <= 3 ? ls.name = "id" : 4 === bt && (ls.name = "geometry"), function(le1) {
                                return 30 === le1;
                            }(bt)) {
                                const bt = pp(le1, vt, 1)[0] >>> 0, ho = ls.complexType;
                                ho.children = new Array(bt);
                                for(let ls = 0; ls < bt; ls++)ho.children[ls] = Af(le1, vt);
                            }
                            return ls;
                        }
                        function Ef(le1, vt) {
                            const bt = {
                                featureTables: []
                            }, ls = {};
                            ls.name = Sf(le1, vt);
                            const ho = pp(le1, vt, 1)[0] >>> 0, Dl = pp(le1, vt, 1)[0] >>> 0;
                            ls.columns = new Array(Dl);
                            for(let Fl = 0; Fl < Dl; Fl++)ls.columns[Fl] = kf(le1, vt);
                            return bt.featureTables.push(ls), [
                                bt,
                                ho
                            ];
                        }
                        function Tf(le1, vt, bt, ls, ho, Dl, Fl = !1) {
                            const sc = vt.scalarType.physicalType, uc = Cp(ho, Dl, le1, bt);
                            if (4 === sc) switch(uc){
                                case kA.FLAT:
                                    {
                                        const vt = Tp(le1, bt, ho, !1);
                                        return new Hh(ls, vt, Dl);
                                    }
                                case kA.SEQUENCE:
                                    {
                                        const vt = Dp(le1, bt, ho);
                                        return new Jh(ls, vt[0], vt[1], ho.numRleValues);
                                    }
                                case kA.CONST:
                                    {
                                        const vt = Fp(le1, bt, ho, !1);
                                        return new Qh(ls, vt, Dl);
                                    }
                            }
                            else switch(uc){
                                case kA.FLAT:
                                    {
                                        if (Fl) {
                                            const vt = function(le1, vt, bt, ls) {
                                                const ho = function(le1, vt, bt) {
                                                    const ls = new Float64Array(vt);
                                                    for(let ho = 0; ho < vt; ho++)ls[ho] = dp(le1, bt);
                                                    return ls;
                                                }(le1, bt.numValues, vt);
                                                return function(le1, vt, bt) {
                                                    switch(vt.logicalLevelTechnique1){
                                                        case bA.DELTA:
                                                            return vt.logicalLevelTechnique2 === bA.RLE && (le1 = wp(le1, vt.runs, vt.numRleValues)), function(le1) {
                                                                le1[0] = le1[0] % 2 == 1 ? (le1[0] + 1) / -2 : le1[0] / 2;
                                                                const vt = le1.length / 4 * 4;
                                                                let bt = 1;
                                                                if (vt >= 4) for(; bt < vt - 4; bt += 4){
                                                                    const vt = le1[bt], ls = le1[bt + 1], ho = le1[bt + 2], Dl = le1[bt + 3];
                                                                    le1[bt] = (vt % 2 == 1 ? (vt + 1) / -2 : vt / 2) + le1[bt - 1], le1[bt + 1] = (ls % 2 == 1 ? (ls + 1) / -2 : ls / 2) + le1[bt], le1[bt + 2] = (ho % 2 == 1 ? (ho + 1) / -2 : ho / 2) + le1[bt + 1], le1[bt + 3] = (Dl % 2 == 1 ? (Dl + 1) / -2 : Dl / 2) + le1[bt + 2];
                                                                }
                                                                for(; bt != le1.length; ++bt)le1[bt] = (le1[bt] % 2 == 1 ? (le1[bt] + 1) / -2 : le1[bt] / 2) + le1[bt - 1];
                                                            }(le1), le1;
                                                        case bA.RLE:
                                                            return function(le1, vt, bt) {
                                                                return bt ? function(le1, vt, bt) {
                                                                    const ls = new Float64Array(bt);
                                                                    let ho = 0;
                                                                    for(let Dl = 0; Dl < vt; Dl++){
                                                                        const bt = le1[Dl];
                                                                        let Fl = le1[Dl + vt];
                                                                        Fl = Fl % 2 == 1 ? (Fl + 1) / -2 : Fl / 2, ls.fill(Fl, ho, ho + bt), ho += bt;
                                                                    }
                                                                    return ls;
                                                                }(le1, vt.runs, vt.numRleValues) : wp(le1, vt.runs, vt.numRleValues);
                                                            }(le1, vt, bt);
                                                        case bA.NONE:
                                                            return le1;
                                                        default:
                                                            throw new Error(`The specified Logical level technique is not supported: ${vt.logicalLevelTechnique1}`);
                                                    }
                                                }(ho, bt, ls);
                                            }(le1, bt, ho, !1);
                                            return new Kh(ls, vt, Dl);
                                        }
                                        const vt = Pp(le1, bt, ho, !1);
                                        return new Lp(ls, vt, Dl);
                                    }
                                case kA.SEQUENCE:
                                    {
                                        const vt = zp(le1, bt, ho);
                                        return new Op(ls, vt[0], vt[1], ho.numRleValues);
                                    }
                                case kA.CONST:
                                    {
                                        const vt = Bp(le1, bt, ho, !1);
                                        return new cf(ls, vt, Dl);
                                    }
                            }
                            throw new Error("Vector type not supported for id column.");
                        }
                        class If {
                            constructor(le1, vt){
                                var bt;
                                switch(this._featureData = le1, this.properties = this._featureData.properties || {}, null === (bt = this._featureData.geometry) || void 0 === bt ? void 0 : bt.type){
                                    case CA.POINT:
                                    case CA.MULTIPOINT:
                                        this.type = 1;
                                        break;
                                    case CA.LINESTRING:
                                    case CA.MULTILINESTRING:
                                        this.type = 2;
                                        break;
                                    case CA.POLYGON:
                                    case CA.MULTIPOLYGON:
                                        this.type = 3;
                                        break;
                                    default:
                                        this.type = 0;
                                }
                                this.extent = vt, this.id = Number(this._featureData.id);
                            }
                            loadGeometry() {
                                const le1 = [];
                                for (const vt of this._featureData.geometry.coordinates){
                                    const bt = [];
                                    for (const le1 of vt)bt.push(new r(le1.x, le1.y));
                                    le1.push(bt);
                                }
                                return le1;
                            }
                        }
                        class Mf {
                            constructor(le1){
                                this.features = [], this.featureTable = le1, this.name = le1.name, this.extent = le1.extent, this.version = 2, this.features = le1.getFeatures(), this.length = this.features.length;
                            }
                            feature(le1) {
                                return new If(this.features[le1], this.extent);
                            }
                        }
                        class Ff {
                            constructor(le1){
                                this.layers = {};
                                const vt = function(le1, vt, bt = !0) {
                                    const ls = new ep(0), ho = [];
                                    for(; ls.get() < le1.length;){
                                        const vt = pp(le1, ls, 1)[0] >>> 0, Dl = ls.get() + vt;
                                        if (Dl > le1.length) throw new Error(`Block overruns tile: ${Dl} > ${le1.length}`);
                                        if (1 != pp(le1, ls, 1)[0] >>> 0) {
                                            ls.set(Dl);
                                            continue;
                                        }
                                        const Fl = Ef(le1, ls), sc = Fl[1], uc = Fl[0].featureTables[0];
                                        let mc = null, gc = null;
                                        const Ac = [];
                                        let Ec = 0;
                                        for (const ho of uc.columns){
                                            const vt = ho.name;
                                            if ("id" === vt) {
                                                let Dl = null;
                                                if (ho.nullable) {
                                                    const vt = kp(le1, ls), bt = ls.get(), ho = hf(le1, vt.numValues, ls);
                                                    ls.set(bt + vt.byteLength), Dl = new Ep(ho, vt.numValues);
                                                }
                                                const Fl = kp(le1, ls);
                                                Ec = Fl.decompressedCount, mc = Tf(le1, ho, ls, vt, Fl, Dl ?? Ec, bt);
                                            } else if ("geometry" === vt) {
                                                const vt = pp(le1, ls, 1)[0];
                                                if (0 === Ec) {
                                                    const vt = ls.get();
                                                    Ec = kp(le1, ls).decompressedCount, ls.set(vt);
                                                }
                                                gc = sf(le1, vt, ls, Ec);
                                            } else {
                                                const vt = wf(ho) ? pp(le1, ls, 1)[0] : 1;
                                                if (0 === vt && "scalarType" === ho.type) continue;
                                                const bt = vf(le1, ls, ho, vt, Ec);
                                                if (bt) {
                                                    if (Array.isArray(bt)) for (const le1 of bt)Ac.push(le1);
                                                    else Ac.push(bt);
                                                }
                                            }
                                        }
                                        const kc = new tp(uc.name, gc, mc, Ac, sc);
                                        ho.push(kc), ls.set(Dl);
                                    }
                                    return ho;
                                }(new Uint8Array(le1));
                                this.layers = vt.reduce((le1, vt)=>Object.assign(Object.assign({}, le1), {
                                        [vt.name]: new Mf(vt)
                                    }), {});
                            }
                        }
                        class Df {
                            constructor(le1, vt){
                                this.feature = le1, this.type = le1.type, this.properties = le1.tags ? le1.tags : {}, this.extent = vt, "id" in le1 && ("string" == typeof le1.id ? this.id = parseInt(le1.id, 10) : "number" != typeof le1.id || isNaN(le1.id) || (this.id = le1.id));
                            }
                            loadGeometry() {
                                const le1 = [], vt = 1 === this.feature.type ? [
                                    this.feature.geometry
                                ] : this.feature.geometry;
                                for (const bt of vt){
                                    const vt = [];
                                    for (const le1 of bt)vt.push(new r(le1[0], le1[1]));
                                    le1.push(vt);
                                }
                                return le1;
                            }
                        }
                        const zA = "_geojsonTileLayer";
                        function Pf(le1, vt) {
                            vt.writeVarintField(15, le1.version || 1), vt.writeStringField(1, le1.name || ""), vt.writeVarintField(5, le1.extent || 4096);
                            const bt = {
                                keys: [],
                                values: [],
                                keycache: {},
                                valuecache: {}
                            };
                            for(let Dl = 0; Dl < le1.length; Dl++)bt.feature = le1.feature(Dl), vt.writeMessage(2, Bf, bt);
                            const ls = bt.keys;
                            for (const Dl of ls)vt.writeStringField(3, Dl);
                            const ho = bt.values;
                            for (const Dl of ho)vt.writeMessage(4, Rf, Dl);
                        }
                        function Bf(le1, vt) {
                            if (!le1.feature) return;
                            const bt = le1.feature;
                            void 0 !== bt.id && vt.writeVarintField(1, bt.id), vt.writeMessage(2, Vf, le1), vt.writeVarintField(3, bt.type), vt.writeMessage(4, Of, bt);
                        }
                        function Vf(le1, vt) {
                            for(const bt in le1.feature?.properties){
                                let ls = le1.feature.properties[bt], ho = le1.keycache[bt];
                                if (null == ls) continue;
                                void 0 === ho && (le1.keys.push(bt), ho = le1.keys.length - 1, le1.keycache[bt] = ho), vt.writeVarint(ho), "string" != typeof ls && "boolean" != typeof ls && "number" != typeof ls && (ls = JSON.stringify(ls));
                                const Dl = typeof ls + ":" + ls;
                                let Fl = le1.valuecache[Dl];
                                void 0 === Fl && (le1.values.push(ls), Fl = le1.values.length - 1, le1.valuecache[Dl] = Fl), vt.writeVarint(Fl);
                            }
                        }
                        function Cf(le1, vt) {
                            return (vt << 3) + (7 & le1);
                        }
                        function Lf(le1) {
                            return le1 << 1 ^ le1 >> 31;
                        }
                        function Of(le1, vt) {
                            const bt = le1.loadGeometry(), ls = le1.type;
                            let ho = 0, Dl = 0;
                            for (const Fl of bt){
                                let bt = 1;
                                1 === ls && (bt = Fl.length), vt.writeVarint(Cf(1, bt));
                                const sc = 3 === ls ? Fl.length - 1 : Fl.length;
                                for(let le1 = 0; le1 < sc; le1++){
                                    1 === le1 && 1 !== ls && vt.writeVarint(Cf(2, sc - 1));
                                    const bt = Fl[le1].x - ho, uc = Fl[le1].y - Dl;
                                    vt.writeVarint(Lf(bt)), vt.writeVarint(Lf(uc)), ho += bt, Dl += uc;
                                }
                                3 === le1.type && vt.writeVarint(Cf(7, 1));
                            }
                        }
                        function Rf(le1, vt) {
                            const bt = typeof le1;
                            "string" === bt ? vt.writeStringField(1, le1) : "boolean" === bt ? vt.writeBooleanField(7, le1) : "number" === bt && (le1 % 1 != 0 ? vt.writeDoubleField(3, le1) : le1 < 0 ? vt.writeSVarintField(6, le1) : vt.writeVarintField(5, le1));
                        }
                        class Nf {
                            constructor(le1, vt){
                                this.tileID = le1, this.x = le1.canonical.x, this.y = le1.canonical.y, this.z = le1.canonical.z, this.grid = new cs(Ac, 16, 0), this.grid3D = new cs(Ac, 16, 0), this.featureIndexArray = new Na, this.promoteId = vt;
                            }
                            insert(le1, vt, bt, ls, ho, Dl) {
                                const Fl = this.featureIndexArray.length;
                                this.featureIndexArray.emplaceBack(bt, ls, ho);
                                const sc = Dl ? this.grid3D : this.grid;
                                for(let uc = 0; uc < vt.length; uc++){
                                    const le1 = vt[uc], bt = [
                                        1 / 0,
                                        1 / 0,
                                        -1 / 0,
                                        -1 / 0
                                    ];
                                    for(let vt = 0; vt < le1.length; vt++){
                                        const ls = le1[vt];
                                        bt[0] = Math.min(bt[0], ls.x), bt[1] = Math.min(bt[1], ls.y), bt[2] = Math.max(bt[2], ls.x), bt[3] = Math.max(bt[3], ls.y);
                                    }
                                    bt[0] < Ac && bt[1] < Ac && bt[2] >= 0 && bt[3] >= 0 && sc.insert(Fl, bt[0], bt[1], bt[2], bt[3]);
                                }
                            }
                            loadVTLayers() {
                                return this.vtLayers || (this.vtLayers = "mlt" !== this.encoding ? new Vu(new Tc(this.rawTileData)).layers : new Ff(this.rawTileData).layers, this.sourceLayerCoder = new Gh(this.vtLayers ? Object.keys(this.vtLayers).sort() : [
                                    zA
                                ])), this.vtLayers;
                            }
                            query(le1, vt, bt, ls) {
                                this.loadVTLayers();
                                const ho = le1.params, Dl = Ac / le1.tileSize / le1.scale, Fl = fi(ho.filter, ho.globalState), sc = le1.queryGeometry, uc = le1.queryPadding * Dl, mc = jh.fromPoints(sc), gc = this.grid.query(mc.minX - uc, mc.minY - uc, mc.maxX + uc, mc.maxY + uc), Ec = jh.fromPoints(le1.cameraQueryGeometry).expandBy(uc), kc = this.grid3D.query(Ec.minX, Ec.minY, Ec.maxX, Ec.maxY, (vt, bt, ls, ho)=>(function(le1, vt, bt, ls, ho) {
                                        for (const Fl of le1)if (vt <= Fl.x && bt <= Fl.y && ls >= Fl.x && ho >= Fl.y) return !0;
                                        const Dl = [
                                            new r(vt, bt),
                                            new r(vt, ho),
                                            new r(ls, ho),
                                            new r(ls, bt)
                                        ];
                                        if (le1.length > 2) {
                                            for (const Fl of Dl)if (tl(le1, Fl)) return !0;
                                        }
                                        for(let Fl = 0; Fl < le1.length - 1; Fl++)if (el(le1[Fl], le1[Fl + 1], Dl)) return !0;
                                        return !1;
                                    })(le1.cameraQueryGeometry, vt - uc, bt - uc, ls + uc, ho + uc));
                                for (const Ac of kc)gc.push(Ac);
                                gc.sort(Uf);
                                const du = {};
                                let _u;
                                for(let Ac = 0; Ac < gc.length; Ac++){
                                    const uc = gc[Ac];
                                    if (uc === _u) continue;
                                    _u = uc;
                                    const mc = this.featureIndexArray.get(uc);
                                    let Ec = null;
                                    this.loadMatchingFeature(du, mc.bucketIndex, mc.sourceLayerIndex, mc.featureIndex, Fl, ho.layers, ho.availableImages, vt, bt, ls, (vt, bt, ls)=>(Ec || (Ec = No(vt)), bt.queryIntersectsFeature({
                                            queryGeometry: sc,
                                            feature: vt,
                                            featureState: ls,
                                            geometry: Ec,
                                            zoom: this.z,
                                            transform: le1.transform,
                                            pixelsToTileUnits: Dl,
                                            pixelPosMatrix: le1.pixelPosMatrix,
                                            unwrappedTileID: this.tileID.toUnwrapped(),
                                            getElevation: le1.getElevation
                                        })));
                                }
                                return du;
                            }
                            loadMatchingFeature(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                                const Ac = this.bucketLayerIDs[vt];
                                if (Dl && !Ac.some((le1)=>Dl.has(le1))) return;
                                const Ec = this.sourceLayerCoder.decode(bt), kc = this.vtLayers[Ec].feature(ls);
                                if (ho.needGeometry) {
                                    const le1 = $o(kc, !0);
                                    if (!ho.filter(new Ps(this.tileID.overscaledZ), le1, this.tileID.canonical)) return;
                                } else if (!ho.filter(new Ps(this.tileID.overscaledZ), kc)) return;
                                const du = this.getId(kc, Ec);
                                for(let _u = 0; _u < Ac.length; _u++){
                                    const vt = Ac[_u];
                                    if (Dl && !Dl.has(vt)) continue;
                                    const bt = sc[vt];
                                    if (!bt) continue;
                                    let ho = {};
                                    du && mc && (ho = mc.getState(bt.sourceLayer || zA, du));
                                    const Ec = O({}, uc[vt]);
                                    Ec.paint = $f(Ec.paint, bt.paint, kc, ho, Fl), Ec.layout = $f(Ec.layout, bt.layout, kc, ho, Fl);
                                    const Md = !gc || gc(kc, bt, ho);
                                    if (!Md) continue;
                                    const Ld = new Xh(kc, this.z, this.x, this.y, du);
                                    Ld.layer = Ec;
                                    let Nd = le1[vt];
                                    void 0 === Nd && (Nd = le1[vt] = []), Nd.push({
                                        featureIndex: ls,
                                        feature: Ld,
                                        intersectionZ: Md
                                    });
                                }
                            }
                            lookupSymbolFeatures(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = {};
                                this.loadVTLayers();
                                const mc = fi(ho.filterSpec, ho.globalState);
                                for (const gc of le1)this.loadMatchingFeature(uc, bt, ls, gc, mc, Dl, Fl, sc, vt);
                                return uc;
                            }
                            hasLayer(le1) {
                                for (const vt of this.bucketLayerIDs)for (const bt of vt)if (le1 === bt) return !0;
                                return !1;
                            }
                            getId(le1, vt) {
                                var bt;
                                let ls = le1.id;
                                return this.promoteId && (ls = le1.properties["string" == typeof this.promoteId ? this.promoteId : this.promoteId[vt]], "boolean" == typeof ls && (ls = Number(ls)), void 0 === ls && (null === (bt = le1.properties) || void 0 === bt ? void 0 : bt.cluster) && this.promoteId && (ls = Number(le1.properties.cluster_id))), ls;
                            }
                        }
                        function $f(le1, vt, bt, ls, ho) {
                            return N(le1, (le1, Dl)=>{
                                const Fl = vt instanceof qs ? vt.get(Dl) : null;
                                return Fl && Fl.evaluate ? Fl.evaluate(bt, ls, ho) : Fl;
                            });
                        }
                        function Uf(le1, vt) {
                            return vt - le1;
                        }
                        function qf(le1, vt, bt, ls, ho) {
                            const Dl = [];
                            for(let Fl = 0; Fl < le1.length; Fl++){
                                const sc = le1[Fl];
                                let uc;
                                for(let le1 = 0; le1 < sc.length - 1; le1++){
                                    let Fl = sc[le1], mc = sc[le1 + 1];
                                    Fl.x < vt && mc.x < vt || (Fl.x < vt ? Fl = new r(vt, Fl.y + (vt - Fl.x) / (mc.x - Fl.x) * (mc.y - Fl.y))._round() : mc.x < vt && (mc = new r(vt, Fl.y + (vt - Fl.x) / (mc.x - Fl.x) * (mc.y - Fl.y))._round()), Fl.y < bt && mc.y < bt || (Fl.y < bt ? Fl = new r(Fl.x + (bt - Fl.y) / (mc.y - Fl.y) * (mc.x - Fl.x), bt)._round() : mc.y < bt && (mc = new r(Fl.x + (bt - Fl.y) / (mc.y - Fl.y) * (mc.x - Fl.x), bt)._round()), Fl.x >= ls && mc.x >= ls || (Fl.x >= ls ? Fl = new r(ls, Fl.y + (ls - Fl.x) / (mc.x - Fl.x) * (mc.y - Fl.y))._round() : mc.x >= ls && (mc = new r(ls, Fl.y + (ls - Fl.x) / (mc.x - Fl.x) * (mc.y - Fl.y))._round()), Fl.y >= ho && mc.y >= ho || (Fl.y >= ho ? Fl = new r(Fl.x + (ho - Fl.y) / (mc.y - Fl.y) * (mc.x - Fl.x), ho)._round() : mc.y >= ho && (mc = new r(Fl.x + (ho - Fl.y) / (mc.y - Fl.y) * (mc.x - Fl.x), ho)._round()), uc && Fl.equals(uc[uc.length - 1]) || (uc = [
                                        Fl
                                    ], Dl.push(uc)), uc.push(mc)))));
                                }
                            }
                            return Dl;
                        }
                        function jf(le1, vt, bt, ls, ho) {
                            switch(vt){
                                case 1:
                                    return function(le1, vt, bt, ls) {
                                        const ho = [];
                                        for (const Dl of le1)for (const le1 of Dl){
                                            const Dl = 0 === ls ? le1.x : le1.y;
                                            Dl >= vt && Dl <= bt && ho.push([
                                                le1
                                            ]);
                                        }
                                        return ho;
                                    }(le1, bt, ls, ho);
                                case 2:
                                    return Xf(le1, bt, ls, ho, !1);
                                case 3:
                                    return Xf(le1, bt, ls, ho, !0);
                            }
                            return [];
                        }
                        function Gf(le1, vt, bt, ls, ho) {
                            const Dl = 0 === ls ? Yf : Zf;
                            let Fl = [];
                            const sc = [];
                            for(let gc = 0; gc < le1.length - 1; gc++){
                                const uc = le1[gc], mc = le1[gc + 1], Ac = 0 === ls ? uc.x : uc.y, Ec = 0 === ls ? mc.x : mc.y;
                                let kc = !1;
                                Ac < vt ? Ec > vt && Fl.push(Dl(uc, mc, vt)) : Ac > bt ? Ec < bt && Fl.push(Dl(uc, mc, bt)) : Fl.push(uc), Ec < vt && Ac >= vt && (Fl.push(Dl(uc, mc, vt)), kc = !0), Ec > bt && Ac <= bt && (Fl.push(Dl(uc, mc, bt)), kc = !0), !ho && kc && (sc.push(Fl), Fl = []);
                            }
                            const uc = le1.length - 1, mc = 0 === ls ? le1[uc].x : le1[uc].y;
                            return mc >= vt && mc <= bt && Fl.push(le1[uc]), ho && Fl.length > 0 && !Fl[0].equals(Fl[Fl.length - 1]) && Fl.push(new r(Fl[0].x, Fl[0].y)), Fl.length > 0 && sc.push(Fl), sc;
                        }
                        function Xf(le1, vt, bt, ls, ho) {
                            const Dl = [];
                            for (const Fl of le1){
                                const le1 = Gf(Fl, vt, bt, ls, ho);
                                le1.length > 0 && Dl.push(...le1);
                            }
                            return Dl;
                        }
                        function Yf(le1, vt, bt) {
                            return new r(bt, le1.y + (bt - le1.x) / (vt.x - le1.x) * (vt.y - le1.y));
                        }
                        function Zf(le1, vt, bt) {
                            return new r(le1.x + (bt - le1.y) / (vt.y - le1.y) * (vt.x - le1.x), bt);
                        }
                        ps("FeatureIndex", Nf, {
                            omit: [
                                "rawTileData",
                                "sourceLayerCoder"
                            ]
                        });
                        class Hf extends r {
                            constructor(le1, vt, bt, ls){
                                super(le1, vt), this.angle = bt, void 0 !== ls && (this.segment = ls);
                            }
                            clone() {
                                return new Hf(this.x, this.y, this.angle, this.segment);
                            }
                        }
                        function Kf(le1, vt, bt, ls, ho) {
                            if (void 0 === vt.segment || 0 === bt) return !0;
                            let Dl = vt, Fl = vt.segment + 1, sc = 0;
                            for(; sc > -bt / 2;){
                                if (Fl--, Fl < 0) return !1;
                                sc -= le1[Fl].dist(Dl), Dl = le1[Fl];
                            }
                            sc += le1[Fl].dist(le1[Fl + 1]), Fl++;
                            const uc = [];
                            let mc = 0;
                            for(; sc < bt / 2;){
                                const vt = le1[Fl], bt = le1[Fl + 1];
                                if (!bt) return !1;
                                let Dl = le1[Fl - 1].angleTo(vt) - vt.angleTo(bt);
                                for(Dl = Math.abs((Dl + 3 * Math.PI) % (2 * Math.PI) - Math.PI), uc.push({
                                    distance: sc,
                                    angleDelta: Dl
                                }), mc += Dl; sc - uc[0].distance > ls;)mc -= uc.shift().angleDelta;
                                if (mc > ho) return !1;
                                Fl++, sc += vt.dist(bt);
                            }
                            return !0;
                        }
                        function Wf(le1) {
                            let vt = 0;
                            for(let bt = 0; bt < le1.length - 1; bt++)vt += le1[bt].dist(le1[bt + 1]);
                            return vt;
                        }
                        function Jf(le1, vt, bt) {
                            return le1 ? .6 * vt * bt : 0;
                        }
                        function Qf(le1, vt) {
                            return Math.max(le1 ? le1.right - le1.left : 0, vt ? vt.right - vt.left : 0);
                        }
                        function td(le1, vt, bt, ls, ho, Dl) {
                            const Fl = Jf(bt, ho, Dl), sc = Qf(bt, ls) * Dl;
                            let uc = 0;
                            const mc = Wf(le1) / 2;
                            for(let gc = 0; gc < le1.length - 1; gc++){
                                const bt = le1[gc], ls = le1[gc + 1], ho = bt.dist(ls);
                                if (uc + ho > mc) {
                                    const Dl = (mc - uc) / ho, Ac = Sm.number(bt.x, ls.x, Dl), Ec = Sm.number(bt.y, ls.y, Dl), kc = new Hf(Ac, Ec, ls.angleTo(bt), gc);
                                    return kc._round(), !Fl || Kf(le1, kc, sc, Fl, vt) ? kc : void 0;
                                }
                                uc += ho;
                            }
                        }
                        function ed(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = Jf(ls, Dl, Fl), gc = Qf(ls, ho), Ac = gc * Fl, Ec = 0 === le1[0].x || le1[0].x === uc || 0 === le1[0].y || le1[0].y === uc;
                            return vt - Ac < vt / 4 && (vt = Ac + vt / 4), rd(le1, Ec ? vt / 2 * sc % vt : (gc / 2 + 2 * Dl) * Fl * sc % vt, vt, mc, bt, Ac, Ec, !1, uc);
                        }
                        function rd(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = Dl / 2, gc = Wf(le1);
                            let Ac = 0, Ec = vt - bt, kc = [];
                            for(let du = 0; du < le1.length - 1; du++){
                                const vt = le1[du], Fl = le1[du + 1], sc = vt.dist(Fl), _u = Fl.angleTo(vt);
                                for(; Ec + bt < Ac + sc;){
                                    Ec += bt;
                                    const Md = (Ec - Ac) / sc, Ld = Sm.number(vt.x, Fl.x, Md), Nd = Sm.number(vt.y, Fl.y, Md);
                                    if (Ld >= 0 && Ld < uc && Nd >= 0 && Nd < uc && Ec - mc >= 0 && Ec + mc <= gc) {
                                        const vt = new Hf(Ld, Nd, _u, du);
                                        vt._round(), ls && !Kf(le1, vt, Dl, ls, ho) || kc.push(vt);
                                    }
                                }
                                Ac += sc;
                            }
                            return sc || kc.length || Fl || (kc = rd(le1, Ac / 2, bt, ls, ho, Dl, Fl, !0, uc)), kc;
                        }
                        function nd(le1, vt, bt, ls) {
                            const ho = [], Dl = le1.image, Fl = Dl.pixelRatio, sc = Dl.paddedRect.w - 2, uc = Dl.paddedRect.h - 2;
                            let mc = {
                                x1: le1.left,
                                y1: le1.top,
                                x2: le1.right,
                                y2: le1.bottom
                            };
                            const gc = Dl.stretchX || [
                                [
                                    0,
                                    sc
                                ]
                            ], Ac = Dl.stretchY || [
                                [
                                    0,
                                    uc
                                ]
                            ], f = (le1, vt)=>le1 + vt[1] - vt[0], Ec = gc.reduce(f, 0), kc = Ac.reduce(f, 0), du = sc - Ec, _u = uc - kc;
                            let Md = 0, Ld = Ec, Nd = 0, Rd = kc, Od = 0, jd = du, Ud = 0, Gd = _u;
                            if (Dl.content && ls) {
                                const vt = Dl.content, bt = vt[2] - vt[0], ls = vt[3] - vt[1];
                                (Dl.textFitWidth || Dl.textFitHeight) && (mc = eh(le1)), Md = id(gc, 0, vt[0]), Nd = id(Ac, 0, vt[1]), Ld = id(gc, vt[0], vt[2]), Rd = id(Ac, vt[1], vt[3]), Od = vt[0] - Md, Ud = vt[1] - Nd, jd = bt - Ld, Gd = ls - Rd;
                            }
                            const qd = mc.x1, Hd = mc.y1, Wd = mc.x2 - qd, Zd = mc.y2 - Hd, F = (le1, ls, ho, sc)=>{
                                const uc = ad(le1.stretch - Md, Ld, Wd, qd), mc = od(le1.fixed - Od, jd, le1.stretch, Ec), gc = ad(ls.stretch - Nd, Rd, Zd, Hd), Ac = od(ls.fixed - Ud, Gd, ls.stretch, kc), du = ad(ho.stretch - Md, Ld, Wd, qd), _u = od(ho.fixed - Od, jd, ho.stretch, Ec), Yd = ad(sc.stretch - Nd, Rd, Zd, Hd), Qd = od(sc.fixed - Ud, Gd, sc.stretch, kc), Xd = new r(uc, gc), Kd = new r(du, gc), Jd = new r(du, Yd), $d = new r(uc, Yd), sp = new r(mc / Fl, Ac / Fl), em = new r(_u / Fl, Qd / Fl), tm = vt * Math.PI / 180;
                                if (tm) {
                                    const le1 = Math.sin(tm), vt = Math.cos(tm), bt = [
                                        vt,
                                        -le1,
                                        le1,
                                        vt
                                    ];
                                    Xd._matMult(bt), Kd._matMult(bt), $d._matMult(bt), Jd._matMult(bt);
                                }
                                const im = le1.stretch + le1.fixed, nm = ls.stretch + ls.fixed;
                                return {
                                    tl: Xd,
                                    tr: Kd,
                                    bl: $d,
                                    br: Jd,
                                    tex: {
                                        x: Dl.paddedRect.x + 1 + im,
                                        y: Dl.paddedRect.y + 1 + nm,
                                        w: ho.stretch + ho.fixed - im,
                                        h: sc.stretch + sc.fixed - nm
                                    },
                                    writingMode: void 0,
                                    glyphOffset: [
                                        0,
                                        0
                                    ],
                                    sectionIndex: 0,
                                    pixelOffsetTL: sp,
                                    pixelOffsetBR: em,
                                    minFontScaleX: jd / Fl / Wd,
                                    minFontScaleY: Gd / Fl / Zd,
                                    isSDF: bt
                                };
                            };
                            if (ls && (Dl.stretchX || Dl.stretchY)) {
                                const le1 = sd(gc, du, Ec), vt = sd(Ac, _u, kc);
                                for(let bt = 0; bt < le1.length - 1; bt++){
                                    const ls = le1[bt], Dl = le1[bt + 1];
                                    for(let le1 = 0; le1 < vt.length - 1; le1++)ho.push(F(ls, vt[le1], Dl, vt[le1 + 1]));
                                }
                            } else ho.push(F({
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: -1
                            }, {
                                fixed: 0,
                                stretch: sc + 1
                            }, {
                                fixed: 0,
                                stretch: uc + 1
                            }));
                            return ho;
                        }
                        function id(le1, vt, bt) {
                            let ls = 0;
                            for (const ho of le1)ls += Math.max(vt, Math.min(bt, ho[1])) - Math.max(vt, Math.min(bt, ho[0]));
                            return ls;
                        }
                        function sd(le1, vt, bt) {
                            const ls = [
                                {
                                    fixed: -1,
                                    stretch: 0
                                }
                            ];
                            for (const [ho, Dl] of le1){
                                const le1 = ls[ls.length - 1];
                                ls.push({
                                    fixed: ho - le1.stretch,
                                    stretch: le1.stretch
                                }), ls.push({
                                    fixed: ho - le1.stretch,
                                    stretch: le1.stretch + (Dl - ho)
                                });
                            }
                            return ls.push({
                                fixed: vt + 1,
                                stretch: bt
                            }), ls;
                        }
                        function ad(le1, vt, bt, ls) {
                            return le1 / vt * bt + ls;
                        }
                        function od(le1, vt, bt, ls) {
                            return le1 - vt * bt / ls;
                        }
                        ps("Anchor", Hf);
                        class ld {
                            constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc){
                                var gc;
                                if (this.boxStartIndex = le1.length, uc) {
                                    let le1 = Dl.top, vt = Dl.bottom;
                                    const bt = Dl.collisionPadding;
                                    bt && (le1 -= bt[1], vt += bt[3]);
                                    let ls = vt - le1;
                                    ls > 0 && (ls = Math.max(10, ls), this.circleDiameter = ls);
                                } else {
                                    const uc = (null === (gc = Dl.image) || void 0 === gc ? void 0 : gc.content) && (Dl.image.textFitWidth || Dl.image.textFitHeight) ? eh(Dl) : {
                                        x1: Dl.left,
                                        y1: Dl.top,
                                        x2: Dl.right,
                                        y2: Dl.bottom
                                    };
                                    uc.y1 = uc.y1 * Fl - sc[0], uc.y2 = uc.y2 * Fl + sc[2], uc.x1 = uc.x1 * Fl - sc[3], uc.x2 = uc.x2 * Fl + sc[1];
                                    const Ac = Dl.collisionPadding;
                                    if (Ac && (uc.x1 -= Ac[0] * Fl, uc.y1 -= Ac[1] * Fl, uc.x2 += Ac[2] * Fl, uc.y2 += Ac[3] * Fl), mc) {
                                        const le1 = new r(uc.x1, uc.y1), vt = new r(uc.x2, uc.y1), bt = new r(uc.x1, uc.y2), ls = new r(uc.x2, uc.y2), ho = mc * Math.PI / 180;
                                        le1._rotate(ho), vt._rotate(ho), bt._rotate(ho), ls._rotate(ho), uc.x1 = Math.min(le1.x, vt.x, bt.x, ls.x), uc.x2 = Math.max(le1.x, vt.x, bt.x, ls.x), uc.y1 = Math.min(le1.y, vt.y, bt.y, ls.y), uc.y2 = Math.max(le1.y, vt.y, bt.y, ls.y);
                                    }
                                    le1.emplaceBack(vt.x, vt.y, uc.x1, uc.y1, uc.x2, uc.y2, bt, ls, ho);
                                }
                                this.boxEndIndex = le1.length;
                            }
                        }
                        class ud {
                            constructor(le1 = [], vt = (le1, vt)=>le1 < vt ? -1 : le1 > vt ? 1 : 0){
                                if (this.data = le1, this.length = this.data.length, this.compare = vt, this.length > 0) for(let bt = (this.length >> 1) - 1; bt >= 0; bt--)this._down(bt);
                            }
                            push(le1) {
                                this.data.push(le1), this._up(this.length++);
                            }
                            pop() {
                                if (0 === this.length) return;
                                const le1 = this.data[0], vt = this.data.pop();
                                return --this.length > 0 && (this.data[0] = vt, this._down(0)), le1;
                            }
                            peek() {
                                return this.data[0];
                            }
                            _up(le1) {
                                const { data: vt, compare: bt } = this, ls = vt[le1];
                                for(; le1 > 0;){
                                    const ho = le1 - 1 >> 1, Dl = vt[ho];
                                    if (bt(ls, Dl) >= 0) break;
                                    vt[le1] = Dl, le1 = ho;
                                }
                                vt[le1] = ls;
                            }
                            _down(le1) {
                                const { data: vt, compare: bt } = this, ls = this.length >> 1, ho = vt[le1];
                                for(; le1 < ls;){
                                    let ls = 1 + (le1 << 1);
                                    const Dl = ls + 1;
                                    if (Dl < this.length && bt(vt[Dl], vt[ls]) < 0 && (ls = Dl), bt(vt[ls], ho) >= 0) break;
                                    vt[le1] = vt[ls], le1 = ls;
                                }
                                vt[le1] = ho;
                            }
                        }
                        function cd(le1, vt = 1, bt = !1) {
                            const ls = jh.fromPoints(le1[0]), ho = Math.min(ls.width(), ls.height());
                            let Dl = ho / 2;
                            const Fl = new ud([], hd), { minX: sc, minY: uc, maxX: mc, maxY: gc } = ls;
                            if (0 === ho) return new r(sc, uc);
                            for(let kc = sc; kc < mc; kc += ho)for(let vt = uc; vt < gc; vt += ho)Fl.push(new pd(kc + Dl, vt + Dl, Dl, le1));
                            let Ac = function(le1) {
                                let vt = 0, bt = 0, ls = 0;
                                const ho = le1[0];
                                for(let Dl = 0, Fl = ho.length, sc = Fl - 1; Dl < Fl; sc = Dl++){
                                    const le1 = ho[Dl], Fl = ho[sc], uc = le1.x * Fl.y - Fl.x * le1.y;
                                    bt += (le1.x + Fl.x) * uc, ls += (le1.y + Fl.y) * uc, vt += 3 * uc;
                                }
                                return new pd(bt / vt, ls / vt, 0, le1);
                            }(le1), Ec = Fl.length;
                            for(; Fl.length;){
                                const ls = Fl.pop();
                                (ls.d > Ac.d || !Ac.d) && (Ac = ls, bt && console.log("found best %d after %d probes", Math.round(1e4 * ls.d) / 1e4, Ec)), ls.max - Ac.d <= vt || (Dl = ls.h / 2, Fl.push(new pd(ls.p.x - Dl, ls.p.y - Dl, Dl, le1)), Fl.push(new pd(ls.p.x + Dl, ls.p.y - Dl, Dl, le1)), Fl.push(new pd(ls.p.x - Dl, ls.p.y + Dl, Dl, le1)), Fl.push(new pd(ls.p.x + Dl, ls.p.y + Dl, Dl, le1)), Ec += 4);
                            }
                            return bt && (console.log(`num probes: ${Ec}`), console.log(`best distance: ${Ac.d}`)), Ac.p;
                        }
                        function hd(le1, vt) {
                            return vt.max - le1.max;
                        }
                        function pd(le1, vt, bt, ls) {
                            this.p = new r(le1, vt), this.h = bt, this.d = function(le1, vt) {
                                let bt = !1, ls = 1 / 0;
                                for(let ho = 0; ho < vt.length; ho++){
                                    const Dl = vt[ho];
                                    for(let vt = 0, ho = Dl.length, Fl = ho - 1; vt < ho; Fl = vt++){
                                        const ho = Dl[vt], sc = Dl[Fl];
                                        ho.y > le1.y != sc.y > le1.y && le1.x < (sc.x - ho.x) * (le1.y - ho.y) / (sc.y - ho.y) + ho.x && (bt = !bt), ls = Math.min(ls, Jo(le1, ho, sc));
                                    }
                                }
                                return (bt ? 1 : -1) * Math.sqrt(ls);
                            }(this.p, ls), this.max = this.d + this.h * Math.SQRT2;
                        }
                        var NA;
                        le1.aP = void 0, (NA = le1.aP || (le1.aP = {}))[NA.center = 1] = "center", NA[NA.left = 2] = "left", NA[NA.right = 3] = "right", NA[NA.top = 4] = "top", NA[NA.bottom = 5] = "bottom", NA[NA["top-left"] = 6] = "top-left", NA[NA["top-right"] = 7] = "top-right", NA[NA["bottom-left"] = 8] = "bottom-left", NA[NA["bottom-right"] = 9] = "bottom-right";
                        const RA = Number.POSITIVE_INFINITY;
                        function yd(le1, vt) {
                            return vt[1] !== RA ? function(le1, vt, bt) {
                                let ls = 0, ho = 0;
                                switch(vt = Math.abs(vt), bt = Math.abs(bt), le1){
                                    case "top-right":
                                    case "top-left":
                                    case "top":
                                        ho = bt - 7;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                    case "bottom":
                                        ho = 7 - bt;
                                }
                                switch(le1){
                                    case "top-right":
                                    case "bottom-right":
                                    case "right":
                                        ls = -vt;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                    case "left":
                                        ls = vt;
                                }
                                return [
                                    ls,
                                    ho
                                ];
                            }(le1, vt[0], vt[1]) : function(le1, vt) {
                                let bt = 0, ls = 0;
                                vt < 0 && (vt = 0);
                                const ho = vt / Math.SQRT2;
                                switch(le1){
                                    case "top-right":
                                    case "top-left":
                                        ls = ho - 7;
                                        break;
                                    case "bottom-right":
                                    case "bottom-left":
                                        ls = 7 - ho;
                                        break;
                                    case "bottom":
                                        ls = 7 - vt;
                                        break;
                                    case "top":
                                        ls = vt - 7;
                                }
                                switch(le1){
                                    case "top-right":
                                    case "bottom-right":
                                        bt = -ho;
                                        break;
                                    case "top-left":
                                    case "bottom-left":
                                        bt = ho;
                                        break;
                                    case "left":
                                        bt = vt;
                                        break;
                                    case "right":
                                        bt = -vt;
                                }
                                return [
                                    bt,
                                    ls
                                ];
                            }(le1, vt[0]);
                        }
                        function md(le1, vt, bt) {
                            var ls;
                            const ho = le1.layout, Dl = null === (ls = ho.get("text-variable-anchor-offset")) || void 0 === ls ? void 0 : ls.evaluate(vt, {}, bt);
                            if (Dl) {
                                const le1 = Dl.values, vt = [];
                                for(let bt = 0; bt < le1.length; bt += 2){
                                    const ls = vt[bt] = le1[bt], ho = le1[bt + 1].map((le1)=>le1 * nA);
                                    ls.startsWith("top") ? ho[1] -= 7 : ls.startsWith("bottom") && (ho[1] += 7), vt[bt + 1] = ho;
                                }
                                return new Le(vt);
                            }
                            const Fl = ho.get("text-variable-anchor");
                            if (Fl) {
                                let ls;
                                ls = void 0 !== le1._unevaluatedLayout.getValue("text-radial-offset") ? [
                                    ho.get("text-radial-offset").evaluate(vt, {}, bt) * nA,
                                    RA
                                ] : ho.get("text-offset").evaluate(vt, {}, bt).map((le1)=>le1 * nA);
                                const Dl = [];
                                for (const le1 of Fl)Dl.push(le1, yd(le1, ls));
                                return new Le(Dl);
                            }
                            return null;
                        }
                        function gd(le1) {
                            switch(le1){
                                case "right":
                                case "top-right":
                                case "bottom-right":
                                    return "right";
                                case "left":
                                case "top-left":
                                case "bottom-left":
                                    return "left";
                            }
                            return "center";
                        }
                        function xd(vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ec, kc) {
                            let du = Fl.textMaxSize.evaluate(bt, {});
                            void 0 === du && (du = sc);
                            const _u = vt.layers[0].layout, Md = _u.get("icon-offset").evaluate(bt, {}, Ec), Ld = bd(ls.horizontal), Nd = sc / 24, Rd = vt.tilePixelRatio * Nd, Od = vt.tilePixelRatio * du / 24, jd = vt.tilePixelRatio * uc, Ud = vt.tilePixelRatio * _u.get("symbol-spacing"), Gd = _u.get("text-padding") * vt.tilePixelRatio, qd = function(le1, vt, bt, ls = 1) {
                                const ho = le1.get("icon-padding").evaluate(vt, {}, bt), Dl = ho && ho.values;
                                return [
                                    Dl[0] * ls,
                                    Dl[1] * ls,
                                    Dl[2] * ls,
                                    Dl[3] * ls
                                ];
                            }(_u, bt, Ec, vt.tilePixelRatio), Hd = _u.get("text-max-angle") / 180 * Math.PI, Wd = "viewport" !== _u.get("text-rotation-alignment") && "point" !== _u.get("symbol-placement"), Zd = "map" === _u.get("icon-rotation-alignment") && "point" !== _u.get("symbol-placement"), Yd = _u.get("symbol-placement"), Qd = Ud / 2, Xd = _u.get("icon-text-fit");
                            let Kd;
                            ho && "none" !== Xd && (vt.allowVerticalPlacement && ls.vertical && (Kd = rh(ho, ls.vertical, Xd, _u.get("icon-text-fit-padding"), Md, Nd)), Ld && (ho = rh(ho, Ld, Xd, _u.get("icon-text-fit-padding"), Md, Nd)));
                            const Jd = Ec ? kc.line.getGranularityForZoomLevel(Ec.z) : 1, P = (uc, kc)=>{
                                kc.x < 0 || kc.x >= Ac || kc.y < 0 || kc.y >= Ac || function(vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od, jd, Ud, Gd, qd, Hd) {
                                    const Wd = vt.addToLineVertexArray(bt, ls);
                                    let Zd, Yd, Qd, Xd, Kd = 0, Jd = 0, $d = 0, sp = 0, em = -1, tm = -1;
                                    const im = {};
                                    let nm = mg("");
                                    if (vt.allowVerticalPlacement && ho.vertical) {
                                        const le1 = uc.layout.get("text-rotate").evaluate(jd, {}, qd) + 90;
                                        Qd = new ld(mc, bt, gc, Ac, Ec, ho.vertical, kc, du, _u, le1), sc && (Xd = new ld(mc, bt, gc, Ac, Ec, sc, Ld, Nd, _u, le1));
                                    }
                                    if (Dl) {
                                        const ls = uc.layout.get("icon-rotate").evaluate(jd, {}), ho = "none" !== uc.layout.get("icon-text-fit"), Fl = nd(Dl, ls, Gd, ho), kc = sc ? nd(sc, ls, Gd, ho) : void 0;
                                        Yd = new ld(mc, bt, gc, Ac, Ec, Dl, Ld, Nd, !1, ls), Kd = 4 * Fl.length;
                                        const du = vt.iconSizeData;
                                        let _u = null;
                                        "source" === du.kind ? (_u = [
                                            hA * uc.layout.get("icon-size").evaluate(jd, {})
                                        ], _u[0] > dA && j(`${vt.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)) : "composite" === du.kind && (_u = [
                                            hA * Ud.compositeIconSizes[0].evaluate(jd, {}, qd),
                                            hA * Ud.compositeIconSizes[1].evaluate(jd, {}, qd)
                                        ], (_u[0] > dA || _u[1] > dA) && j(`${vt.layerIds[0]}: Value for "icon-size" is >= 255. Reduce your "icon-size".`)), vt.addSymbols(vt.icon, Fl, _u, Od, Rd, jd, le1.az.none, bt, Wd.lineStartIndex, Wd.lineLength, -1, qd), em = vt.icon.placedSymbolArray.length - 1, kc && (Jd = 4 * kc.length, vt.addSymbols(vt.icon, kc, _u, Od, Rd, jd, le1.az.vertical, bt, Wd.lineStartIndex, Wd.lineLength, -1, qd), tm = vt.icon.placedSymbolArray.length - 1);
                                    }
                                    const rm = Object.keys(ho.horizontal);
                                    for (const _m of rm){
                                        const ls = ho.horizontal[_m];
                                        if (!Zd) {
                                            nm = mg(ls.text);
                                            const le1 = uc.layout.get("text-rotate").evaluate(jd, {}, qd);
                                            Zd = new ld(mc, bt, gc, Ac, Ec, ls, kc, du, _u, le1);
                                        }
                                        const Dl = 1 === ls.positionedLines.length;
                                        if ($d += vd(vt, bt, ls, Fl, uc, _u, jd, Md, Wd, ho.vertical ? le1.az.horizontal : le1.az.horizontalOnly, Dl ? rm : [
                                            _m
                                        ], im, em, Ud, qd), Dl) break;
                                    }
                                    ho.vertical && (sp += vd(vt, bt, ho.vertical, Fl, uc, _u, jd, Md, Wd, le1.az.vertical, [
                                        "vertical"
                                    ], im, tm, Ud, qd));
                                    const am = Zd ? Zd.boxStartIndex : vt.collisionBoxArray.length, sm = Zd ? Zd.boxEndIndex : vt.collisionBoxArray.length, om = Qd ? Qd.boxStartIndex : vt.collisionBoxArray.length, lm = Qd ? Qd.boxEndIndex : vt.collisionBoxArray.length, cm = Yd ? Yd.boxStartIndex : vt.collisionBoxArray.length, um = Yd ? Yd.boxEndIndex : vt.collisionBoxArray.length, hm = Xd ? Xd.boxStartIndex : vt.collisionBoxArray.length, dm = Xd ? Xd.boxEndIndex : vt.collisionBoxArray.length;
                                    let pm = -1;
                                    const K = (le1, vt)=>le1 && le1.circleDiameter ? Math.max(le1.circleDiameter, vt) : vt;
                                    pm = K(Zd, pm), pm = K(Qd, pm), pm = K(Yd, pm), pm = K(Xd, pm);
                                    const mm = pm > -1 ? 1 : 0;
                                    mm && (pm *= Hd / nA), vt.glyphOffsetArray.length >= fh.MAX_GLYPHS && j("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907"), void 0 !== jd.sortKey && vt.addToSortKeyRanges(vt.symbolInstances.length, jd.sortKey);
                                    const fm = md(uc, jd, qd), [gm, Am] = function(vt, bt) {
                                        const ls = vt.length, ho = null == bt ? void 0 : bt.values;
                                        if ((null == ho ? void 0 : ho.length) > 0) for(let Dl = 0; Dl < ho.length; Dl += 2){
                                            const bt = ho[Dl + 1];
                                            vt.emplaceBack(le1.aP[ho[Dl]], bt[0], bt[1]);
                                        }
                                        return [
                                            ls,
                                            vt.length
                                        ];
                                    }(vt.textAnchorOffsets, fm);
                                    vt.symbolInstances.emplaceBack(bt.x, bt.y, im.right >= 0 ? im.right : -1, im.center >= 0 ? im.center : -1, im.left >= 0 ? im.left : -1, im.vertical || -1, em, tm, nm, am, sm, om, lm, cm, um, hm, dm, gc, $d, sp, Kd, Jd, mm, 0, kc, pm, gm, Am);
                                }(vt, kc, uc, ls, ho, Dl, Kd, vt.layers[0], vt.collisionBoxArray, bt.index, bt.sourceLayerIndex, vt.index, Rd, [
                                    Gd,
                                    Gd,
                                    Gd,
                                    Gd
                                ], Wd, mc, jd, qd, Zd, Md, bt, Fl, gc, Ec, sc);
                            };
                            if ("line" === Yd) for (const le1 of qf(bt.geometry, 0, 0, Ac, Ac)){
                                const bt = gu(le1, Jd), Dl = ed(bt, Ud, Hd, ls.vertical || Ld, ho, 24, Od, vt.overscaling, Ac);
                                for (const le1 of Dl)Ld && wd(vt, Ld.text, Qd, le1) || P(bt, le1);
                            }
                            else if ("line-center" === Yd) {
                                for (const le1 of bt.geometry)if (le1.length > 1) {
                                    const vt = gu(le1, Jd), bt = td(vt, Hd, ls.vertical || Ld, ho, 24, Od);
                                    bt && P(vt, bt);
                                }
                            } else if ("Polygon" === bt.type) for (const le1 of tn(bt.geometry, 0)){
                                const vt = cd(le1, 16);
                                P(gu(le1[0], Jd, !0), new Hf(vt.x, vt.y, 0));
                            }
                            else if ("LineString" === bt.type) for (const le1 of bt.geometry){
                                const vt = gu(le1, Jd);
                                P(vt, new Hf(vt[0].x, vt[0].y, 0));
                            }
                            else if ("Point" === bt.type) for (const le1 of bt.geometry)for (const vt of le1)P([
                                vt
                            ], new Hf(vt.x, vt.y, 0));
                        }
                        function vd(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du) {
                            const _u = function(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = ls.layout.get("text-rotate").evaluate(Dl, {}) * Math.PI / 180, mc = [];
                                for (const gc of vt.positionedLines)for (const le1 of gc.positionedGlyphs){
                                    if (!le1.rect) continue;
                                    const ls = le1.rect || {};
                                    let Dl = 4, Ac = !0, Ec = 1, kc = 0;
                                    const du = (ho || sc) && le1.vertical, _u = le1.metrics.advance * le1.scale / 2;
                                    if (sc && vt.verticalizable && (kc = gc.lineOffset / 2 - (le1.imageName ? -(nA - le1.metrics.width * le1.scale) / 2 : (le1.scale - 1) * nA)), le1.imageName) {
                                        const vt = Fl[le1.imageName];
                                        Ac = vt.sdf, Ec = vt.pixelRatio, Dl = 1 / Ec;
                                    }
                                    const Md = ho ? [
                                        le1.x + _u,
                                        le1.y
                                    ] : [
                                        0,
                                        0
                                    ];
                                    let Ld = ho ? [
                                        0,
                                        0
                                    ] : [
                                        le1.x + _u + bt[0],
                                        le1.y + bt[1] - kc
                                    ], Nd = [
                                        0,
                                        0
                                    ];
                                    du && (Nd = Ld, Ld = [
                                        0,
                                        0
                                    ]);
                                    const Rd = le1.metrics.isDoubleResolution ? 2 : 1, Od = (le1.metrics.left - Dl) * le1.scale - _u + Ld[0], jd = (-le1.metrics.top - Dl) * le1.scale + Ld[1], Ud = Od + ls.w / Rd * le1.scale / Ec, Gd = jd + ls.h / Rd * le1.scale / Ec, qd = new r(Od, jd), Hd = new r(Ud, jd), Wd = new r(Od, Gd), Zd = new r(Ud, Gd);
                                    if (du) {
                                        const vt = new r(-_u, _u - -17), bt = -Math.PI / 2, ls = 12 - _u, ho = new r(22 - ls, -(le1.imageName ? ls : 0)), Dl = new r(...Nd);
                                        qd._rotateAround(bt, vt)._add(ho)._add(Dl), Hd._rotateAround(bt, vt)._add(ho)._add(Dl), Wd._rotateAround(bt, vt)._add(ho)._add(Dl), Zd._rotateAround(bt, vt)._add(ho)._add(Dl);
                                    }
                                    if (uc) {
                                        const le1 = Math.sin(uc), vt = Math.cos(uc), bt = [
                                            vt,
                                            -le1,
                                            le1,
                                            vt
                                        ];
                                        qd._matMult(bt), Hd._matMult(bt), Wd._matMult(bt), Zd._matMult(bt);
                                    }
                                    const Yd = new r(0, 0), Qd = new r(0, 0);
                                    mc.push({
                                        tl: qd,
                                        tr: Hd,
                                        bl: Wd,
                                        br: Zd,
                                        tex: ls,
                                        writingMode: vt.writingMode,
                                        glyphOffset: Md,
                                        sectionIndex: le1.sectionIndex,
                                        isSDF: Ac,
                                        pixelOffsetTL: Yd,
                                        pixelOffsetBR: Qd,
                                        minFontScaleX: 0,
                                        minFontScaleY: 0
                                    });
                                }
                                return mc;
                            }(0, bt, sc, ho, Dl, Fl, ls, le1.allowVerticalPlacement), Md = le1.textSizeData;
                            let Ld = null;
                            "source" === Md.kind ? (Ld = [
                                hA * ho.layout.get("text-size").evaluate(Fl, {})
                            ], Ld[0] > dA && j(`${le1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)) : "composite" === Md.kind && (Ld = [
                                hA * kc.compositeTextSizes[0].evaluate(Fl, {}, du),
                                hA * kc.compositeTextSizes[1].evaluate(Fl, {}, du)
                            ], (Ld[0] > dA || Ld[1] > dA) && j(`${le1.layerIds[0]}: Value for "text-size" is >= 255. Reduce your "text-size".`)), le1.addSymbols(le1.text, _u, Ld, sc, Dl, Fl, mc, vt, uc.lineStartIndex, uc.lineLength, Ec, du);
                            for (const Nd of gc)Ac[Nd] = le1.text.placedSymbolArray.length - 1;
                            return 4 * _u.length;
                        }
                        function bd(le1) {
                            for(const vt in le1)return le1[vt];
                            return null;
                        }
                        function wd(le1, vt, bt, ls) {
                            const ho = le1.compareText;
                            if (vt in ho) {
                                const le1 = ho[vt];
                                for(let vt = le1.length - 1; vt >= 0; vt--)if (ls.dist(le1[vt]) < bt) return !0;
                            } else ho[vt] = [];
                            return ho[vt].push(ls), !1;
                        }
                        const FA = [
                            Int8Array,
                            Uint8Array,
                            Uint8ClampedArray,
                            Int16Array,
                            Uint16Array,
                            Int32Array,
                            Uint32Array,
                            Float32Array,
                            Float64Array
                        ];
                        class Sd {
                            static from(le1) {
                                if (!(le1 instanceof ArrayBuffer)) throw new Error("Data must be an instance of ArrayBuffer.");
                                const [vt, bt] = new Uint8Array(le1, 0, 2);
                                if (219 !== vt) throw new Error("Data does not appear to be in a KDBush format.");
                                const ls = bt >> 4;
                                if (1 !== ls) throw new Error(`Got v${ls} data when expected v1.`);
                                const ho = FA[15 & bt];
                                if (!ho) throw new Error("Unrecognized array type.");
                                const [Dl] = new Uint16Array(le1, 2, 1), [Fl] = new Uint32Array(le1, 4, 1);
                                return new Sd(Fl, Dl, ho, le1);
                            }
                            constructor(le1, vt = 64, bt = Float64Array, ls){
                                if (isNaN(le1) || le1 < 0) throw new Error(`Unpexpected numItems value: ${le1}.`);
                                this.numItems = +le1, this.nodeSize = Math.min(Math.max(+vt, 2), 65535), this.ArrayType = bt, this.IndexArrayType = le1 < 65536 ? Uint16Array : Uint32Array;
                                const ho = FA.indexOf(this.ArrayType), Dl = 2 * le1 * this.ArrayType.BYTES_PER_ELEMENT, Fl = le1 * this.IndexArrayType.BYTES_PER_ELEMENT, sc = (8 - Fl % 8) % 8;
                                if (ho < 0) throw new Error(`Unexpected typed array class: ${bt}.`);
                                ls && ls instanceof ArrayBuffer ? (this.data = ls, this.ids = new this.IndexArrayType(this.data, 8, le1), this.coords = new this.ArrayType(this.data, 8 + Fl + sc, 2 * le1), this._pos = 2 * le1, this._finished = !0) : (this.data = new ArrayBuffer(8 + Dl + Fl + sc), this.ids = new this.IndexArrayType(this.data, 8, le1), this.coords = new this.ArrayType(this.data, 8 + Fl + sc, 2 * le1), this._pos = 0, this._finished = !1, new Uint8Array(this.data, 0, 2).set([
                                    219,
                                    16 + ho
                                ]), new Uint16Array(this.data, 2, 1)[0] = vt, new Uint32Array(this.data, 4, 1)[0] = le1);
                            }
                            add(le1, vt) {
                                const bt = this._pos >> 1;
                                return this.ids[bt] = bt, this.coords[this._pos++] = le1, this.coords[this._pos++] = vt, bt;
                            }
                            finish() {
                                const le1 = this._pos >> 1;
                                if (le1 !== this.numItems) throw new Error(`Added ${le1} items when expected ${this.numItems}.`);
                                return Ad(this.ids, this.coords, this.nodeSize, 0, this.numItems - 1, 0), this._finished = !0, this;
                            }
                            range(le1, vt, bt, ls) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: ho, coords: Dl, nodeSize: Fl } = this, sc = [
                                    0,
                                    ho.length - 1,
                                    0
                                ], uc = [];
                                for(; sc.length;){
                                    const mc = sc.pop() || 0, gc = sc.pop() || 0, Ac = sc.pop() || 0;
                                    if (gc - Ac <= Fl) {
                                        for(let Fl = Ac; Fl <= gc; Fl++){
                                            const sc = Dl[2 * Fl], mc = Dl[2 * Fl + 1];
                                            sc >= le1 && sc <= bt && mc >= vt && mc <= ls && uc.push(ho[Fl]);
                                        }
                                        continue;
                                    }
                                    const Ec = Ac + gc >> 1, kc = Dl[2 * Ec], du = Dl[2 * Ec + 1];
                                    kc >= le1 && kc <= bt && du >= vt && du <= ls && uc.push(ho[Ec]), (0 === mc ? le1 <= kc : vt <= du) && (sc.push(Ac), sc.push(Ec - 1), sc.push(1 - mc)), (0 === mc ? bt >= kc : ls >= du) && (sc.push(Ec + 1), sc.push(gc), sc.push(1 - mc));
                                }
                                return uc;
                            }
                            within(le1, vt, bt) {
                                if (!this._finished) throw new Error("Data not yet indexed - call index.finish().");
                                const { ids: ls, coords: ho, nodeSize: Dl } = this, Fl = [
                                    0,
                                    ls.length - 1,
                                    0
                                ], sc = [], uc = bt * bt;
                                for(; Fl.length;){
                                    const mc = Fl.pop() || 0, gc = Fl.pop() || 0, Ac = Fl.pop() || 0;
                                    if (gc - Ac <= Dl) {
                                        for(let bt = Ac; bt <= gc; bt++)Id(ho[2 * bt], ho[2 * bt + 1], le1, vt) <= uc && sc.push(ls[bt]);
                                        continue;
                                    }
                                    const Ec = Ac + gc >> 1, kc = ho[2 * Ec], du = ho[2 * Ec + 1];
                                    Id(kc, du, le1, vt) <= uc && sc.push(ls[Ec]), (0 === mc ? le1 - bt <= kc : vt - bt <= du) && (Fl.push(Ac), Fl.push(Ec - 1), Fl.push(1 - mc)), (0 === mc ? le1 + bt >= kc : vt + bt >= du) && (Fl.push(Ec + 1), Fl.push(gc), Fl.push(1 - mc));
                                }
                                return sc;
                            }
                        }
                        function Ad(le1, vt, bt, ls, ho, Dl) {
                            if (ho - ls <= bt) return;
                            const Fl = ls + ho >> 1;
                            kd(le1, vt, Fl, ls, ho, Dl), Ad(le1, vt, bt, ls, Fl - 1, 1 - Dl), Ad(le1, vt, bt, Fl + 1, ho, 1 - Dl);
                        }
                        function kd(le1, vt, bt, ls, ho, Dl) {
                            for(; ho > ls;){
                                if (ho - ls > 600) {
                                    const Fl = ho - ls + 1, sc = bt - ls + 1, uc = Math.log(Fl), mc = .5 * Math.exp(2 * uc / 3), gc = .5 * Math.sqrt(uc * mc * (Fl - mc) / Fl) * (sc - Fl / 2 < 0 ? -1 : 1);
                                    kd(le1, vt, bt, Math.max(ls, Math.floor(bt - sc * mc / Fl + gc)), Math.min(ho, Math.floor(bt + (Fl - sc) * mc / Fl + gc)), Dl);
                                }
                                const Fl = vt[2 * bt + Dl];
                                let sc = ls, uc = ho;
                                for(Ed(le1, vt, ls, bt), vt[2 * ho + Dl] > Fl && Ed(le1, vt, ls, ho); sc < uc;){
                                    for(Ed(le1, vt, sc, uc), sc++, uc--; vt[2 * sc + Dl] < Fl;)sc++;
                                    for(; vt[2 * uc + Dl] > Fl;)uc--;
                                }
                                vt[2 * ls + Dl] === Fl ? Ed(le1, vt, ls, uc) : (uc++, Ed(le1, vt, uc, ho)), uc <= bt && (ls = uc + 1), bt <= uc && (ho = uc - 1);
                            }
                        }
                        function Ed(le1, vt, bt, ls) {
                            Td(le1, bt, ls), Td(vt, 2 * bt, 2 * ls), Td(vt, 2 * bt + 1, 2 * ls + 1);
                        }
                        function Td(le1, vt, bt) {
                            const ls = le1[vt];
                            le1[vt] = le1[bt], le1[bt] = ls;
                        }
                        function Id(le1, vt, bt, ls) {
                            const ho = le1 - bt, Dl = vt - ls;
                            return ho * ho + Dl * Dl;
                        }
                        var OA;
                        le1.cI = void 0, (OA = le1.cI || (le1.cI = {})).create = "create", OA.load = "load", OA.fullLoad = "fullLoad";
                        let BA = null, jA = [];
                        const UA = 1e3 / 60, VA = "loadTime", GA = "fullLoadTime", qA = {
                            mark (le1) {
                                performance.mark(le1);
                            },
                            frame (le1) {
                                const vt = le1;
                                null != BA && jA.push(vt - BA), BA = vt;
                            },
                            clearMetrics () {
                                BA = null, jA = [], performance.clearMeasures(VA), performance.clearMeasures(GA);
                                for(const vt in le1.cI)performance.clearMarks(le1.cI[vt]);
                            },
                            getPerformanceMetrics () {
                                performance.measure(VA, le1.cI.create, le1.cI.load), performance.measure(GA, le1.cI.create, le1.cI.fullLoad);
                                const vt = performance.getEntriesByName(VA)[0].duration, bt = performance.getEntriesByName(GA)[0].duration, ls = jA.length, ho = 1 / (jA.reduce((le1, vt)=>le1 + vt, 0) / ls / 1e3), Dl = jA.filter((le1)=>le1 > UA).reduce((le1, vt)=>le1 + (vt - UA) / UA, 0);
                                return {
                                    loadTime: vt,
                                    fullLoadTime: bt,
                                    fps: ho,
                                    percentDroppedFrames: Dl / (ls + Dl) * 100,
                                    totalFrames: ls
                                };
                            }
                        };
                        le1.$ = c, le1.A = uc, le1.B = us, le1.C = qm, le1.D = js, le1.E = xt, le1.F = function([le1, vt, bt]) {
                            return vt += 90, vt *= Math.PI / 180, bt *= Math.PI / 180, {
                                x: le1 * Math.cos(vt) * Math.sin(bt),
                                y: le1 * Math.sin(vt) * Math.sin(bt),
                                z: le1 * Math.cos(bt)
                            };
                        }, le1.G = Sm, le1.H = Ps, le1.I = qc, le1.J = Wm, le1.K = function(le1) {
                            if (null == _u) {
                                const vt = le1.navigator ? le1.navigator.userAgent : null;
                                _u = !!le1.safari || !(!vt || !(/\b(iPad|iPhone|iPod)\b/.test(vt) || vt.match("Safari") && !vt.match("Chrome")));
                            }
                            return _u;
                        }, le1.L = class {
                            constructor(le1, vt){
                                this.target = le1, this.mapId = vt, this.resolveRejects = {}, this.tasks = {}, this.taskQueue = [], this.abortControllers = {}, this.messageHandlers = {}, this.invoker = new Sh(()=>this.process()), this.subscription = Q(this.target, "message", (le1)=>this.receive(le1), !1), this.globalScope = X(self) ? le1 : window;
                            }
                            registerMessageHandler(le1, vt) {
                                this.messageHandlers[le1] = vt;
                            }
                            unregisterMessageHandler(le1) {
                                delete this.messageHandlers[le1];
                            }
                            sendAsync(le1, vt) {
                                return new Promise((bt, ls)=>{
                                    const ho = Math.round(1e18 * Math.random()).toString(36).substring(0, 10), Dl = vt ? Q(vt.signal, "abort", ()=>{
                                        null == Dl || Dl.unsubscribe(), delete this.resolveRejects[ho];
                                        const vt = {
                                            id: ho,
                                            type: "<cancel>",
                                            origin: location.origin,
                                            targetMapId: le1.targetMapId,
                                            sourceMapId: this.mapId
                                        };
                                        this.target.postMessage(vt);
                                    }, yA) : null;
                                    this.resolveRejects[ho] = {
                                        resolve: (le1)=>{
                                            null == Dl || Dl.unsubscribe(), bt(le1);
                                        },
                                        reject: (le1)=>{
                                            null == Dl || Dl.unsubscribe(), ls(le1);
                                        }
                                    };
                                    const Fl = [], sc = Object.assign(Object.assign({}, le1), {
                                        id: ho,
                                        sourceMapId: this.mapId,
                                        origin: location.origin,
                                        data: ms(le1.data, Fl)
                                    });
                                    this.target.postMessage(sc, {
                                        transfer: Fl
                                    });
                                });
                            }
                            receive(le1) {
                                const vt = le1.data, bt = vt.id;
                                if (!("file://" !== vt.origin && "file://" !== location.origin && "resource://android" !== vt.origin && "resource://android" !== location.origin && vt.origin !== location.origin || vt.targetMapId && this.mapId !== vt.targetMapId)) {
                                    if ("<cancel>" === vt.type) {
                                        delete this.tasks[bt];
                                        const le1 = this.abortControllers[bt];
                                        return delete this.abortControllers[bt], void (le1 && le1.abort());
                                    }
                                    if (X(self) || vt.mustQueue) return this.tasks[bt] = vt, this.taskQueue.push(bt), void this.invoker.trigger();
                                    this.processTask(bt, vt);
                                }
                            }
                            process() {
                                if (0 === this.taskQueue.length) return;
                                const le1 = this.taskQueue.shift(), vt = this.tasks[le1];
                                delete this.tasks[le1], this.taskQueue.length > 0 && this.invoker.trigger(), vt && this.processTask(le1, vt);
                            }
                            processTask(le1, vt) {
                                return e(this, void 0, void 0, function*() {
                                    if ("<response>" === vt.type) {
                                        const bt = this.resolveRejects[le1];
                                        if (delete this.resolveRejects[le1], !bt) return;
                                        return void (vt.error ? bt.reject(gs(vt.error)) : bt.resolve(gs(vt.data)));
                                    }
                                    if (!this.messageHandlers[vt.type]) return void this.completeTask(le1, new Error(`Could not find a registered handler for ${vt.type}, map ID: ${this.mapId}, available handlers: ${Object.keys(this.messageHandlers).join(", ")}`));
                                    const bt = gs(vt.data), ls = new AbortController;
                                    this.abortControllers[le1] = ls;
                                    try {
                                        const ho = yield this.messageHandlers[vt.type](vt.sourceMapId, bt, ls);
                                        this.completeTask(le1, null, ho);
                                    } catch (bt) {
                                        this.completeTask(le1, bt);
                                    }
                                });
                            }
                            completeTask(le1, vt, bt) {
                                const ls = [];
                                delete this.abortControllers[le1];
                                const ho = {
                                    id: le1,
                                    type: "<response>",
                                    sourceMapId: this.mapId,
                                    origin: location.origin,
                                    error: vt ? ms(vt) : null,
                                    data: ms(bt, ls)
                                };
                                this.target.postMessage(ho, {
                                    transfer: ls
                                });
                            }
                            remove() {
                                this.invoker.remove(), this.subscription.unsubscribe();
                            }
                        }, le1.M = Gd, le1.N = function() {
                            var le1 = new uc(16);
                            return uc != Float32Array && (le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[4] = 0, le1[6] = 0, le1[7] = 0, le1[8] = 0, le1[9] = 0, le1[11] = 0, le1[12] = 0, le1[13] = 0, le1[14] = 0), le1[0] = 1, le1[5] = 1, le1[10] = 1, le1[15] = 1, le1;
                        }, le1.O = function(le1, vt, bt) {
                            var ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u = bt[0], Md = bt[1], Ld = bt[2];
                            return vt === le1 ? (le1[12] = vt[0] * _u + vt[4] * Md + vt[8] * Ld + vt[12], le1[13] = vt[1] * _u + vt[5] * Md + vt[9] * Ld + vt[13], le1[14] = vt[2] * _u + vt[6] * Md + vt[10] * Ld + vt[14], le1[15] = vt[3] * _u + vt[7] * Md + vt[11] * Ld + vt[15]) : (ho = vt[1], Dl = vt[2], Fl = vt[3], sc = vt[4], uc = vt[5], mc = vt[6], gc = vt[7], Ac = vt[8], Ec = vt[9], kc = vt[10], du = vt[11], le1[0] = ls = vt[0], le1[1] = ho, le1[2] = Dl, le1[3] = Fl, le1[4] = sc, le1[5] = uc, le1[6] = mc, le1[7] = gc, le1[8] = Ac, le1[9] = Ec, le1[10] = kc, le1[11] = du, le1[12] = ls * _u + sc * Md + Ac * Ld + vt[12], le1[13] = ho * _u + uc * Md + Ec * Ld + vt[13], le1[14] = Dl * _u + mc * Md + kc * Ld + vt[14], le1[15] = Fl * _u + gc * Md + du * Ld + vt[15]), le1;
                        }, le1.P = r, le1.Q = function(le1, vt, bt) {
                            var ls = bt[0], ho = bt[1], Dl = bt[2];
                            return le1[0] = vt[0] * ls, le1[1] = vt[1] * ls, le1[2] = vt[2] * ls, le1[3] = vt[3] * ls, le1[4] = vt[4] * ho, le1[5] = vt[5] * ho, le1[6] = vt[6] * ho, le1[7] = vt[7] * ho, le1[8] = vt[8] * Dl, le1[9] = vt[9] * Dl, le1[10] = vt[10] * Dl, le1[11] = vt[11] * Dl, le1[12] = vt[12], le1[13] = vt[13], le1[14] = vt[14], le1[15] = vt[15], le1;
                        }, le1.R = Sl, le1.S = function(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1], Dl = vt[2], Fl = vt[3], sc = vt[4], uc = vt[5], mc = vt[6], gc = vt[7], Ac = vt[8], Ec = vt[9], kc = vt[10], du = vt[11], _u = vt[12], Md = vt[13], Ld = vt[14], Nd = vt[15], Rd = bt[0], Od = bt[1], jd = bt[2], Ud = bt[3];
                            return le1[0] = Rd * ls + Od * sc + jd * Ac + Ud * _u, le1[1] = Rd * ho + Od * uc + jd * Ec + Ud * Md, le1[2] = Rd * Dl + Od * mc + jd * kc + Ud * Ld, le1[3] = Rd * Fl + Od * gc + jd * du + Ud * Nd, le1[4] = (Rd = bt[4]) * ls + (Od = bt[5]) * sc + (jd = bt[6]) * Ac + (Ud = bt[7]) * _u, le1[5] = Rd * ho + Od * uc + jd * Ec + Ud * Md, le1[6] = Rd * Dl + Od * mc + jd * kc + Ud * Ld, le1[7] = Rd * Fl + Od * gc + jd * du + Ud * Nd, le1[8] = (Rd = bt[8]) * ls + (Od = bt[9]) * sc + (jd = bt[10]) * Ac + (Ud = bt[11]) * _u, le1[9] = Rd * ho + Od * uc + jd * Ec + Ud * Md, le1[10] = Rd * Dl + Od * mc + jd * kc + Ud * Ld, le1[11] = Rd * Fl + Od * gc + jd * du + Ud * Nd, le1[12] = (Rd = bt[12]) * ls + (Od = bt[13]) * sc + (jd = bt[14]) * Ac + (Ud = bt[15]) * _u, le1[13] = Rd * ho + Od * uc + jd * Ec + Ud * Md, le1[14] = Rd * Dl + Od * mc + jd * kc + Ud * Ld, le1[15] = Rd * Fl + Od * gc + jd * du + Ud * Nd, le1;
                        }, le1.T = zl, le1.U = function(le1, vt) {
                            const bt = {};
                            for(let ls = 0; ls < vt.length; ls++){
                                const ho = vt[ls];
                                ho in le1 && (bt[ho] = le1[ho]);
                            }
                            return bt;
                        }, le1.V = Eh, le1.W = L1, le1.X = Fh, le1.Y = Mh, le1.Z = at, le1._ = e, le1.a = st, le1.a$ = b, le1.a0 = h, le1.a1 = K, le1.a2 = Rh, le1.a3 = zh, le1.a4 = Ph, le1.a5 = Ac, le1.a6 = function(le1, vt, bt) {
                            if (!le1) return vt || {};
                            if (!vt) return le1 || {};
                            const ls = qh(le1), ho = qh(vt);
                            !function(le1, vt) {
                                vt.removeAll && (le1.add.clear(), le1.update.clear(), le1.remove.clear(), vt.remove.clear());
                                for (const bt of vt.remove)le1.add.delete(bt), le1.update.delete(bt);
                                for (const [bt, ls] of vt.update){
                                    const ho = le1.update.get(bt);
                                    ho && (vt.update.set(bt, Uh(ho, ls)), le1.update.delete(bt));
                                }
                            }(ls, ho);
                            const Dl = {};
                            if ((ls.removeAll || ho.removeAll) && (Dl.removeAll = !0), Dl.remove = new Set([
                                ...ls.remove,
                                ...ho.remove
                            ]), Dl.add = new Map([
                                ...ls.add,
                                ...ho.add
                            ]), Dl.update = new Map([
                                ...ls.update,
                                ...ho.update
                            ]), Dl.remove.size && Dl.add.size) for (const Fl of Dl.add.keys())Dl.remove.delete(Fl);
                            return function(le1) {
                                const vt = {};
                                return le1.removeAll && (vt.removeAll = le1.removeAll), le1.remove && (vt.remove = Array.from(le1.remove)), le1.add && (vt.add = Array.from(le1.add.values())), le1.update && (vt.update = Array.from(le1.update.values())), vt;
                            }(Dl);
                        }, le1.a7 = function(le1, vt) {
                            const bt = new Map;
                            if (null == le1) return bt;
                            if (null == le1.type) return bt;
                            if ("Feature" === le1.type) {
                                const ls = $h(le1, vt);
                                if (null == ls) return;
                                return bt.set(ls, le1), bt;
                            }
                            if ("FeatureCollection" === le1.type) {
                                const ls = new Set;
                                for (const ho of le1.features){
                                    const le1 = $h(ho, vt);
                                    if (null == le1) return;
                                    if (ls.has(le1)) return;
                                    ls.add(le1), bt.set(le1, ho);
                                }
                                return bt;
                            }
                        }, le1.a8 = function(le1, vt, bt) {
                            var ls, ho;
                            const Dl = [];
                            if (vt.removeAll) le1.clear();
                            else if (vt.remove) for (const Fl of vt.remove){
                                const vt = le1.get(Fl);
                                vt && (Dl.push(vt.geometry), le1.delete(Fl));
                            }
                            if (vt.add) for (const Fl of vt.add){
                                const vt = $h(Fl, bt);
                                if (null == vt) continue;
                                const ls = le1.get(vt);
                                ls && Dl.push(ls.geometry), Dl.push(Fl.geometry), le1.set(vt, Fl);
                            }
                            if (vt.update) for (const Fl of vt.update){
                                const vt = le1.get(Fl.id);
                                if (!vt) continue;
                                const bt = !!Fl.newGeometry, sc = Fl.removeAllProperties || (null === (ls = Fl.removeProperties) || void 0 === ls ? void 0 : ls.length) > 0 || (null === (ho = Fl.addOrUpdateProperties) || void 0 === ho ? void 0 : ho.length) > 0;
                                if (!bt && !sc) continue;
                                Dl.push(vt.geometry);
                                const uc = Object.assign({}, vt);
                                if (le1.set(Fl.id, uc), bt && (Dl.push(Fl.newGeometry), uc.geometry = Fl.newGeometry), sc) {
                                    if (uc.properties = Fl.removeAllProperties ? {} : Object.assign({}, uc.properties || {}), Fl.removeProperties) for (const le1 of Fl.removeProperties)delete uc.properties[le1];
                                    if (Fl.addOrUpdateProperties) for (const { key: le1, value: vt } of Fl.addOrUpdateProperties)uc.properties[le1] = vt;
                                }
                            }
                            return Dl;
                        }, le1.a9 = Vh, le1.aA = function(le1, { uSize: vt, uSizeT: bt }, { lowerSize: ls, upperSize: ho }) {
                            return "source" === le1.kind ? ls / hA : "composite" === le1.kind ? Sm.number(ls / hA, ho / hA, bt) : vt;
                        }, le1.aB = function(le1, vt) {
                            var bt = vt[0], ls = vt[1], ho = vt[2], Dl = vt[3], Fl = vt[4], sc = vt[5], uc = vt[6], mc = vt[7], gc = vt[8], Ac = vt[9], Ec = vt[10], kc = vt[11], du = vt[12], _u = vt[13], Md = vt[14], Ld = vt[15], Nd = bt * sc - ls * Fl, Rd = bt * uc - ho * Fl, Od = bt * mc - Dl * Fl, jd = ls * uc - ho * sc, Ud = ls * mc - Dl * sc, Gd = ho * mc - Dl * uc, qd = gc * _u - Ac * du, Hd = gc * Md - Ec * du, Wd = gc * Ld - kc * du, Zd = Ac * Md - Ec * _u, Yd = Ac * Ld - kc * _u, Qd = Ec * Ld - kc * Md, Xd = Nd * Qd - Rd * Yd + Od * Zd + jd * Wd - Ud * Hd + Gd * qd;
                            return Xd ? (le1[0] = (sc * Qd - uc * Yd + mc * Zd) * (Xd = 1 / Xd), le1[1] = (ho * Yd - ls * Qd - Dl * Zd) * Xd, le1[2] = (_u * Gd - Md * Ud + Ld * jd) * Xd, le1[3] = (Ec * Ud - Ac * Gd - kc * jd) * Xd, le1[4] = (uc * Wd - Fl * Qd - mc * Hd) * Xd, le1[5] = (bt * Qd - ho * Wd + Dl * Hd) * Xd, le1[6] = (Md * Od - du * Gd - Ld * Rd) * Xd, le1[7] = (gc * Gd - Ec * Od + kc * Rd) * Xd, le1[8] = (Fl * Yd - sc * Wd + mc * qd) * Xd, le1[9] = (ls * Wd - bt * Yd - Dl * qd) * Xd, le1[10] = (du * Ud - _u * Od + Ld * Nd) * Xd, le1[11] = (Ac * Od - gc * Ud - kc * Nd) * Xd, le1[12] = (sc * Hd - Fl * Zd - uc * qd) * Xd, le1[13] = (bt * Zd - ls * Hd + ho * qd) * Xd, le1[14] = (_u * Rd - du * jd - Md * Nd) * Xd, le1[15] = (gc * jd - Ac * Rd + Ec * Nd) * Xd, le1) : null;
                        }, le1.aC = T, le1.aD = function(le1) {
                            var vt = le1[0], bt = le1[1];
                            return Math.sqrt(vt * vt + bt * bt);
                        }, le1.aE = function(le1) {
                            return le1[0] = 0, le1[1] = 0, le1;
                        }, le1.aF = function(le1, vt, bt) {
                            return le1[0] = vt[0] * bt, le1[1] = vt[1] * bt, le1;
                        }, le1.aG = uh, le1.aH = A, le1.aI = function(le1, vt, bt, ls) {
                            const ho = vt.y - le1.y, Dl = vt.x - le1.x, Fl = ls.y - bt.y, sc = ls.x - bt.x, uc = Fl * Dl - sc * ho;
                            if (0 === uc) return null;
                            const mc = (sc * (le1.y - bt.y) - Fl * (le1.x - bt.x)) / uc;
                            return new r(le1.x + mc * Dl, le1.y + mc * ho);
                        }, le1.aJ = qf, le1.aK = Go, le1.aL = function(le1) {
                            let vt = 1 / 0, bt = 1 / 0, ls = -1 / 0, ho = -1 / 0;
                            for (const Dl of le1)vt = Math.min(vt, Dl.x), bt = Math.min(bt, Dl.y), ls = Math.max(ls, Dl.x), ho = Math.max(ho, Dl.y);
                            return [
                                vt,
                                bt,
                                ls,
                                ho
                            ];
                        }, le1.aM = nA, le1.aN = F, le1.aO = function(le1, vt, bt, ls, ho = !1) {
                            if (!bt[0] && !bt[1]) return [
                                0,
                                0
                            ];
                            const Dl = ho ? "map" === ls ? -le1.bearingInRadians : 0 : "viewport" === ls ? le1.bearingInRadians : 0;
                            if (Dl) {
                                const le1 = Math.sin(Dl), vt = Math.cos(Dl);
                                bt = [
                                    bt[0] * vt - bt[1] * le1,
                                    bt[0] * le1 + bt[1] * vt
                                ];
                            }
                            return [
                                ho ? bt[0] : F(vt, bt[0], le1.zoom),
                                ho ? bt[1] : F(vt, bt[1], le1.zoom)
                            ];
                        }, le1.aQ = ah, le1.aR = gd, le1.aS = Yc, le1.aT = Sd, le1.aU = na, le1.aV = pu, le1.aW = $a, le1.aX = io, le1.aY = to, le1.aZ = et, le1.a_ = Bh, le1.aa = jh, le1.ab = 25, le1.ac = Lh, le1.ad = (le1)=>{
                            const vt = window.document.createElement("video");
                            return vt.muted = !0, new Promise((bt)=>{
                                vt.onloadstart = ()=>{
                                    bt(vt);
                                };
                                for (const ls of le1){
                                    const le1 = window.document.createElement("source");
                                    ft(ls) || (vt.crossOrigin = "Anonymous"), le1.src = ls, vt.appendChild(le1);
                                }
                            });
                        }, le1.ae = Dt, le1.af = function() {
                            return kc++;
                        }, le1.ag = Fa, le1.ah = fh, le1.ai = zA, le1.aj = fi, le1.ak = $o, le1.al = Xh, le1.am = function(le1) {
                            const vt = {};
                            if (le1.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g, (le1, bt, ls, ho)=>{
                                const Dl = ls || ho;
                                return vt[bt] = !Dl || Dl.toLowerCase(), "";
                            }), vt["max-age"]) {
                                const le1 = parseInt(vt["max-age"], 10);
                                isNaN(le1) ? delete vt["max-age"] : vt["max-age"] = le1;
                            }
                            return vt;
                        }, le1.an = C, le1.ao = 85.051129, le1.ap = tt, le1.aq = function(le1) {
                            return Math.pow(2, le1);
                        }, le1.ar = y, le1.as = Dh, le1.at = function(le1) {
                            return Math.log(le1) / Math.LN2;
                        }, le1.au = function(le1) {
                            var vt = le1[0], bt = le1[1];
                            return vt * vt + bt * bt;
                        }, le1.av = function(le1) {
                            if (!le1.length) return new Set;
                            const vt = Math.max(...le1.map((le1)=>le1.canonical.z));
                            let bt = 1 / 0, ls = -1 / 0, ho = 1 / 0, Dl = -1 / 0;
                            const Fl = [];
                            for (const uc of le1){
                                const { x: le1, y: sc, z: mc } = uc.canonical, gc = Math.pow(2, vt - mc), Ac = le1 * gc, Ec = sc * gc;
                                Fl.push({
                                    id: uc,
                                    x: Ac,
                                    y: Ec
                                }), Ac < bt && (bt = Ac), Ac > ls && (ls = Ac), Ec < ho && (ho = Ec), Ec > Dl && (Dl = Ec);
                            }
                            const sc = new Set;
                            for (const uc of Fl)uc.x !== bt && uc.x !== ls && uc.y !== ho && uc.y !== Dl || sc.add(uc.id);
                            return sc;
                        }, le1.aw = function(le1, vt) {
                            const bt = Math.abs(2 * le1.wrap) - +(le1.wrap < 0), ls = Math.abs(2 * vt.wrap) - +(vt.wrap < 0);
                            return le1.overscaledZ - vt.overscaledZ || ls - bt || vt.canonical.y - le1.canonical.y || vt.canonical.x - le1.canonical.x;
                        }, le1.ax = class {
                            constructor(le1, vt){
                                this.max = le1, this.onRemove = vt, this.reset();
                            }
                            reset() {
                                for(const le1 in this.data)for (const vt of this.data[le1])vt.timeout && clearTimeout(vt.timeout), this.onRemove(vt.value);
                                return this.data = {}, this.order = [], this;
                            }
                            add(le1, vt, bt) {
                                const ls = le1.wrapped().key;
                                void 0 === this.data[ls] && (this.data[ls] = []);
                                const ho = {
                                    value: vt,
                                    timeout: void 0
                                };
                                if (void 0 !== bt && (ho.timeout = setTimeout(()=>{
                                    this.remove(le1, ho);
                                }, bt)), this.data[ls].push(ho), this.order.push(ls), this.order.length > this.max) {
                                    const le1 = this._getAndRemoveByKey(this.order[0]);
                                    le1 && this.onRemove(le1);
                                }
                                return this;
                            }
                            has(le1) {
                                return le1.wrapped().key in this.data;
                            }
                            getAndRemove(le1) {
                                return this.has(le1) ? this._getAndRemoveByKey(le1.wrapped().key) : null;
                            }
                            _getAndRemoveByKey(le1) {
                                const vt = this.data[le1].shift();
                                return vt.timeout && clearTimeout(vt.timeout), 0 === this.data[le1].length && delete this.data[le1], this.order.splice(this.order.indexOf(le1), 1), vt.value;
                            }
                            getByKey(le1) {
                                const vt = this.data[le1];
                                return vt ? vt[0].value : null;
                            }
                            get(le1) {
                                return this.has(le1) ? this.data[le1.wrapped().key][0].value : null;
                            }
                            remove(le1, vt) {
                                if (!this.has(le1)) return this;
                                const bt = le1.wrapped().key, ls = void 0 === vt ? 0 : this.data[bt].indexOf(vt), ho = this.data[bt][ls];
                                return this.data[bt].splice(ls, 1), ho.timeout && clearTimeout(ho.timeout), 0 === this.data[bt].length && delete this.data[bt], this.onRemove(ho.value), this.order.splice(this.order.indexOf(bt), 1), this;
                            }
                            setMaxSize(le1) {
                                for(this.max = le1; this.order.length > this.max;){
                                    const le1 = this._getAndRemoveByKey(this.order[0]);
                                    le1 && this.onRemove(le1);
                                }
                                return this;
                            }
                            filter(le1) {
                                const vt = [];
                                for(const bt in this.data)for (const ls of this.data[bt])le1(ls.value) || vt.push(ls);
                                for (const bt of vt)this.remove(bt.value.tileID, bt);
                            }
                        }, le1.ay = function(le1, vt) {
                            let bt = 0, ls = 0;
                            if ("constant" === le1.kind) ls = le1.layoutSize;
                            else if ("source" !== le1.kind) {
                                const { interpolationType: ho, minZoom: Dl, maxZoom: Fl } = le1, sc = ho ? C(fr.interpolationFactor(ho, vt, Dl, Fl), 0, 1) : 0;
                                "camera" === le1.kind ? ls = Sm.number(le1.minSize, le1.maxSize, sc) : bt = sc;
                            }
                            return {
                                uSizeT: bt,
                                uSize: ls
                            };
                        }, le1.b = Z, le1.b$ = Ao, le1.b0 = v, le1.b1 = function(le1) {
                            var vt = new uc(3);
                            return vt[0] = le1[0], vt[1] = le1[1], vt[2] = le1[2], vt;
                        }, le1.b2 = function(le1, vt, bt) {
                            return le1[0] = vt[0] - bt[0], le1[1] = vt[1] - bt[1], le1[2] = vt[2] - bt[2], le1;
                        }, le1.b3 = function(le1, vt) {
                            var bt = vt[0], ls = vt[1], ho = vt[2], Dl = bt * bt + ls * ls + ho * ho;
                            return Dl > 0 && (Dl = 1 / Math.sqrt(Dl)), le1[0] = vt[0] * Dl, le1[1] = vt[1] * Dl, le1[2] = vt[2] * Dl, le1;
                        }, le1.b4 = w, le1.b5 = function(le1, vt) {
                            return le1[0] * vt[0] + le1[1] * vt[1] + le1[2] * vt[2];
                        }, le1.b6 = function(le1, vt, bt) {
                            return le1[0] = vt[0] * bt[0], le1[1] = vt[1] * bt[1], le1[2] = vt[2] * bt[2], le1[3] = vt[3] * bt[3], le1;
                        }, le1.b7 = g, le1.b8 = function(le1, vt, bt) {
                            const ls = vt[0] * bt[0] + vt[1] * bt[1] + vt[2] * bt[2];
                            return 0 === ls ? null : (-(le1[0] * bt[0] + le1[1] * bt[1] + le1[2] * bt[2]) - bt[3]) / ls;
                        }, le1.b9 = gc, le1.bA = function() {
                            return new Float64Array(3);
                        }, le1.bB = E, le1.bC = function(le1, vt, bt) {
                            var ls = bt[0], ho = bt[1], Dl = bt[2], Fl = bt[3], sc = vt[0], uc = vt[1], mc = vt[2], gc = ho * mc - Dl * uc, Ac = Dl * sc - ls * mc, Ec = ls * uc - ho * sc;
                            return le1[0] = sc + Fl * (gc += gc) + ho * (Ec += Ec) - Dl * (Ac += Ac), le1[1] = uc + Fl * Ac + Dl * gc - ls * Ec, le1[2] = mc + Fl * Ec + ls * Ac - ho * gc, le1;
                        }, le1.bD = function(le1, vt, bt) {
                            const ls = (ho = [
                                le1[0],
                                le1[1],
                                le1[2],
                                vt[0],
                                vt[1],
                                vt[2],
                                bt[0],
                                bt[1],
                                bt[2]
                            ])[0] * ((gc = ho[8]) * (Fl = ho[4]) - (sc = ho[5]) * (mc = ho[7])) + ho[1] * (-gc * (Dl = ho[3]) + sc * (uc = ho[6])) + ho[2] * (mc * Dl - Fl * uc);
                            var ho, Dl, Fl, sc, uc, mc, gc;
                            if (0 === ls) return null;
                            const Ac = w([], [
                                vt[0],
                                vt[1],
                                vt[2]
                            ], [
                                bt[0],
                                bt[1],
                                bt[2]
                            ]), Ec = w([], [
                                bt[0],
                                bt[1],
                                bt[2]
                            ], [
                                le1[0],
                                le1[1],
                                le1[2]
                            ]), kc = w([], [
                                le1[0],
                                le1[1],
                                le1[2]
                            ], [
                                vt[0],
                                vt[1],
                                vt[2]
                            ]), du = b([], Ac, -le1[3]);
                            return v(du, du, b([], Ec, -vt[3])), v(du, du, b([], kc, -bt[3])), b(du, du, 1 / ls), du;
                        }, le1.bE = vA, le1.bF = function() {
                            return new Float64Array(4);
                        }, le1.bG = function(le1, vt, bt, ls) {
                            var ho = [], Dl = [];
                            return ho[0] = vt[0] - bt[0], ho[1] = vt[1] - bt[1], ho[2] = vt[2] - bt[2], Dl[0] = ho[0] * Math.cos(ls) - ho[1] * Math.sin(ls), Dl[1] = ho[0] * Math.sin(ls) + ho[1] * Math.cos(ls), Dl[2] = ho[2], le1[0] = Dl[0] + bt[0], le1[1] = Dl[1] + bt[1], le1[2] = Dl[2] + bt[2], le1;
                        }, le1.bH = function(le1, vt, bt, ls) {
                            var ho = [], Dl = [];
                            return ho[0] = vt[0] - bt[0], ho[1] = vt[1] - bt[1], ho[2] = vt[2] - bt[2], Dl[0] = ho[0], Dl[1] = ho[1] * Math.cos(ls) - ho[2] * Math.sin(ls), Dl[2] = ho[1] * Math.sin(ls) + ho[2] * Math.cos(ls), le1[0] = Dl[0] + bt[0], le1[1] = Dl[1] + bt[1], le1[2] = Dl[2] + bt[2], le1;
                        }, le1.bI = function(le1, vt, bt, ls) {
                            var ho = [], Dl = [];
                            return ho[0] = vt[0] - bt[0], ho[1] = vt[1] - bt[1], ho[2] = vt[2] - bt[2], Dl[0] = ho[2] * Math.sin(ls) + ho[0] * Math.cos(ls), Dl[1] = ho[1], Dl[2] = ho[2] * Math.cos(ls) - ho[0] * Math.sin(ls), le1[0] = Dl[0] + bt[0], le1[1] = Dl[1] + bt[1], le1[2] = Dl[2] + bt[2], le1;
                        }, le1.bJ = function(le1, vt, bt) {
                            var ls = Math.sin(bt), ho = Math.cos(bt), Dl = vt[0], Fl = vt[1], sc = vt[2], uc = vt[3], mc = vt[8], gc = vt[9], Ac = vt[10], Ec = vt[11];
                            return vt !== le1 && (le1[4] = vt[4], le1[5] = vt[5], le1[6] = vt[6], le1[7] = vt[7], le1[12] = vt[12], le1[13] = vt[13], le1[14] = vt[14], le1[15] = vt[15]), le1[0] = Dl * ho - mc * ls, le1[1] = Fl * ho - gc * ls, le1[2] = sc * ho - Ac * ls, le1[3] = uc * ho - Ec * ls, le1[8] = Dl * ls + mc * ho, le1[9] = Fl * ls + gc * ho, le1[10] = sc * ls + Ac * ho, le1[11] = uc * ls + Ec * ho, le1;
                        }, le1.bK = function(le1, vt) {
                            const bt = D(le1, 360), ls = D(vt, 360), ho = ls - bt, Dl = ls > bt ? ho - 360 : ho + 360;
                            return Math.abs(ho) < Math.abs(Dl) ? ho : Dl;
                        }, le1.bL = function(le1) {
                            return le1[0] = 0, le1[1] = 0, le1[2] = 0, le1;
                        }, le1.bM = function(le1, vt, bt, ls) {
                            const ho = Math.sqrt(le1 * le1 + vt * vt), Dl = Math.sqrt(bt * bt + ls * ls);
                            le1 /= ho, vt /= ho, bt /= Dl, ls /= Dl;
                            const Fl = Math.acos(le1 * bt + vt * ls);
                            return -vt * bt + le1 * ls > 0 ? Fl : -Fl;
                        }, le1.bN = function(le1, vt) {
                            const bt = D(le1, 2 * Math.PI), ls = D(vt, 2 * Math.PI);
                            return Math.min(Math.abs(bt - ls), Math.abs(bt - ls + 2 * Math.PI), Math.abs(bt - ls - 2 * Math.PI));
                        }, le1.bO = function() {
                            const le1 = {}, vt = qd.$version;
                            for(const bt in qd.$root){
                                const ls = qd.$root[bt];
                                if (ls.required) {
                                    let ho = null;
                                    ho = "version" === bt ? vt : "array" === ls.type ? [] : {}, null != ho && (le1[bt] = ho);
                                }
                            }
                            return le1;
                        }, le1.bP = ht, le1.bQ = xs, le1.bR = function t(le1, vt) {
                            if (Array.isArray(le1)) {
                                if (!Array.isArray(vt) || le1.length !== vt.length) return !1;
                                for(let bt = 0; bt < le1.length; bt++)if (!t(le1[bt], vt[bt])) return !1;
                                return !0;
                            }
                            if ("object" == typeof le1 && null !== le1 && null !== vt) {
                                if ("object" != typeof vt) return !1;
                                if (Object.keys(le1).length !== Object.keys(vt).length) return !1;
                                for(const bt in le1)if (!t(le1[bt], vt[bt])) return !1;
                                return !0;
                            }
                            return le1 === vt;
                        }, le1.bS = function(le1) {
                            le1 = le1.slice();
                            const vt = Object.create(null);
                            for(let bt = 0; bt < le1.length; bt++)vt[le1[bt].id] = le1[bt];
                            for(let bt = 0; bt < le1.length; bt++)"ref" in le1[bt] && (le1[bt] = wt(le1[bt], vt[le1[bt].ref]));
                            return le1;
                        }, le1.bT = function(le1, vt) {
                            if ("custom" === le1.type) return new _h(le1, vt);
                            switch(le1.type){
                                case "background":
                                    return new wh(le1, vt);
                                case "circle":
                                    return new yl(le1, vt);
                                case "color-relief":
                                    return new Vl(le1, vt);
                                case "fill":
                                    return new ku(le1, vt);
                                case "fill-extrusion":
                                    return new Gu(le1, vt);
                                case "heatmap":
                                    return new El(le1, vt);
                                case "hillshade":
                                    return new Ml(le1, vt);
                                case "line":
                                    return new ac(le1, vt);
                                case "raster":
                                    return new Qs(le1, vt);
                                case "symbol":
                                    return new xh(le1, vt);
                            }
                        }, le1.bU = (le1)=>"raster" === le1.type, le1.bV = U, le1.bW = function(le1, vt) {
                            if (!le1) return [
                                {
                                    command: "setStyle",
                                    args: [
                                        vt
                                    ]
                                }
                            ];
                            let bt = [];
                            try {
                                if (!_t(le1.version, vt.version)) return [
                                    {
                                        command: "setStyle",
                                        args: [
                                            vt
                                        ]
                                    }
                                ];
                                _t(le1.center, vt.center) || bt.push({
                                    command: "setCenter",
                                    args: [
                                        vt.center
                                    ]
                                }), _t(le1.state, vt.state) || bt.push({
                                    command: "setGlobalState",
                                    args: [
                                        vt.state
                                    ]
                                }), _t(le1.centerAltitude, vt.centerAltitude) || bt.push({
                                    command: "setCenterAltitude",
                                    args: [
                                        vt.centerAltitude
                                    ]
                                }), _t(le1.zoom, vt.zoom) || bt.push({
                                    command: "setZoom",
                                    args: [
                                        vt.zoom
                                    ]
                                }), _t(le1.bearing, vt.bearing) || bt.push({
                                    command: "setBearing",
                                    args: [
                                        vt.bearing
                                    ]
                                }), _t(le1.pitch, vt.pitch) || bt.push({
                                    command: "setPitch",
                                    args: [
                                        vt.pitch
                                    ]
                                }), _t(le1.roll, vt.roll) || bt.push({
                                    command: "setRoll",
                                    args: [
                                        vt.roll
                                    ]
                                }), _t(le1.sprite, vt.sprite) || bt.push({
                                    command: "setSprite",
                                    args: [
                                        vt.sprite
                                    ]
                                }), _t(le1.glyphs, vt.glyphs) || bt.push({
                                    command: "setGlyphs",
                                    args: [
                                        vt.glyphs
                                    ]
                                }), _t(le1.transition, vt.transition) || bt.push({
                                    command: "setTransition",
                                    args: [
                                        vt.transition
                                    ]
                                }), _t(le1.light, vt.light) || bt.push({
                                    command: "setLight",
                                    args: [
                                        vt.light
                                    ]
                                }), _t(le1.terrain, vt.terrain) || bt.push({
                                    command: "setTerrain",
                                    args: [
                                        vt.terrain
                                    ]
                                }), _t(le1.sky, vt.sky) || bt.push({
                                    command: "setSky",
                                    args: [
                                        vt.sky
                                    ]
                                }), _t(le1.projection, vt.projection) || bt.push({
                                    command: "setProjection",
                                    args: [
                                        vt.projection
                                    ]
                                });
                                const ls = {}, ho = [];
                                !function(le1, vt, bt, ls) {
                                    let ho;
                                    for(ho in vt = vt || {}, le1 = le1 || {})Object.prototype.hasOwnProperty.call(le1, ho) && (Object.prototype.hasOwnProperty.call(vt, ho) || kt(ho, bt, ls));
                                    for(ho in vt)Object.prototype.hasOwnProperty.call(vt, ho) && (Object.prototype.hasOwnProperty.call(le1, ho) ? _t(le1[ho], vt[ho]) || ("geojson" === le1[ho].type && "geojson" === vt[ho].type && Tt(le1, vt, ho) ? St(bt, {
                                        command: "setGeoJSONSourceData",
                                        args: [
                                            ho,
                                            vt[ho].data
                                        ]
                                    }) : Et(ho, vt, bt, ls)) : At(ho, vt, bt));
                                }(le1.sources, vt.sources, ho, ls);
                                const Dl = [];
                                le1.layers && le1.layers.forEach((le1)=>{
                                    "source" in le1 && ls[le1.source] ? bt.push({
                                        command: "removeLayer",
                                        args: [
                                            le1.id
                                        ]
                                    }) : Dl.push(le1);
                                }), bt = bt.concat(ho), function(le1, vt, bt) {
                                    vt = vt || [];
                                    const ls = (le1 = le1 || []).map(Mt), ho = vt.map(Mt), Dl = le1.reduce(Ft, {}), Fl = vt.reduce(Ft, {}), sc = ls.slice(), uc = Object.create(null);
                                    let mc, gc, Ac, Ec, kc;
                                    for(let du = 0, _u = 0; du < ls.length; du++)mc = ls[du], Object.prototype.hasOwnProperty.call(Fl, mc) ? _u++ : (St(bt, {
                                        command: "removeLayer",
                                        args: [
                                            mc
                                        ]
                                    }), sc.splice(sc.indexOf(mc, _u), 1));
                                    for(let du = 0, _u = 0; du < ho.length; du++)mc = ho[ho.length - 1 - du], sc[sc.length - 1 - du] !== mc && (Object.prototype.hasOwnProperty.call(Dl, mc) ? (St(bt, {
                                        command: "removeLayer",
                                        args: [
                                            mc
                                        ]
                                    }), sc.splice(sc.lastIndexOf(mc, sc.length - _u), 1)) : _u++, Ec = sc[sc.length - du], St(bt, {
                                        command: "addLayer",
                                        args: [
                                            Fl[mc],
                                            Ec
                                        ]
                                    }), sc.splice(sc.length - du, 0, mc), uc[mc] = !0);
                                    for(let du = 0; du < ho.length; du++)if (mc = ho[du], gc = Dl[mc], Ac = Fl[mc], !uc[mc] && !_t(gc, Ac)) {
                                        if (_t(gc.source, Ac.source) && _t(gc["source-layer"], Ac["source-layer"]) && _t(gc.type, Ac.type)) {
                                            for(kc in It(gc.layout, Ac.layout, bt, mc, null, "setLayoutProperty"), It(gc.paint, Ac.paint, bt, mc, null, "setPaintProperty"), _t(gc.filter, Ac.filter) || St(bt, {
                                                command: "setFilter",
                                                args: [
                                                    mc,
                                                    Ac.filter
                                                ]
                                            }), _t(gc.minzoom, Ac.minzoom) && _t(gc.maxzoom, Ac.maxzoom) || St(bt, {
                                                command: "setLayerZoomRange",
                                                args: [
                                                    mc,
                                                    Ac.minzoom,
                                                    Ac.maxzoom
                                                ]
                                            }), gc)Object.prototype.hasOwnProperty.call(gc, kc) && "layout" !== kc && "paint" !== kc && "filter" !== kc && "metadata" !== kc && "minzoom" !== kc && "maxzoom" !== kc && (0 === kc.indexOf("paint.") ? It(gc[kc], Ac[kc], bt, mc, kc.slice(6), "setPaintProperty") : _t(gc[kc], Ac[kc]) || St(bt, {
                                                command: "setLayerProperty",
                                                args: [
                                                    mc,
                                                    kc,
                                                    Ac[kc]
                                                ]
                                            }));
                                            for(kc in Ac)Object.prototype.hasOwnProperty.call(Ac, kc) && !Object.prototype.hasOwnProperty.call(gc, kc) && "layout" !== kc && "paint" !== kc && "filter" !== kc && "metadata" !== kc && "minzoom" !== kc && "maxzoom" !== kc && (0 === kc.indexOf("paint.") ? It(gc[kc], Ac[kc], bt, mc, kc.slice(6), "setPaintProperty") : _t(gc[kc], Ac[kc]) || St(bt, {
                                                command: "setLayerProperty",
                                                args: [
                                                    mc,
                                                    kc,
                                                    Ac[kc]
                                                ]
                                            }));
                                        } else St(bt, {
                                            command: "removeLayer",
                                            args: [
                                                mc
                                            ]
                                        }), Ec = sc[sc.lastIndexOf(mc) + 1], St(bt, {
                                            command: "addLayer",
                                            args: [
                                                Ac,
                                                Ec
                                            ]
                                        });
                                    }
                                }(Dl, vt.layers, bt);
                            } catch (le1) {
                                console.warn("Unable to compute style diff:", le1), bt = [
                                    {
                                        command: "setStyle",
                                        args: [
                                            vt
                                        ]
                                    }
                                ];
                            }
                            return bt;
                        }, le1.bX = function(le1) {
                            const vt = [], bt = le1.id;
                            return void 0 === bt && vt.push({
                                message: `layers.${bt}: missing required property "id"`
                            }), void 0 === le1.render && vt.push({
                                message: `layers.${bt}: missing required method "render"`
                            }), le1.renderingMode && "2d" !== le1.renderingMode && "3d" !== le1.renderingMode && vt.push({
                                message: `layers.${bt}: property "renderingMode" must be either "2d" or "3d"`
                            }), vt;
                        }, le1.bY = N, le1.bZ = $, le1.b_ = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = 0;
                            }
                            set(le1) {
                                this.current !== le1 && (this.current = le1, this.gl.uniform1i(this.location, le1));
                            }
                        }, le1.ba = function(le1, vt, bt) {
                            return le1[0] = vt[0] * bt, le1[1] = vt[1] * bt, le1[2] = vt[2] * bt, le1[3] = vt[3] * bt, le1;
                        }, le1.bb = function(le1, vt) {
                            return le1[0] * vt[0] + le1[1] * vt[1] + le1[2] * vt[2] + le1[3];
                        }, le1.bc = Oh, le1.bd = Nh, le1.be = function(le1, vt, bt, ls, ho) {
                            var Dl = 1 / Math.tan(vt / 2);
                            if (le1[0] = Dl / bt, le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[4] = 0, le1[5] = Dl, le1[6] = 0, le1[7] = 0, le1[8] = 0, le1[9] = 0, le1[11] = -1, le1[12] = 0, le1[13] = 0, le1[15] = 0, null != ho && ho !== 1 / 0) {
                                var Fl = 1 / (ls - ho);
                                le1[10] = (ho + ls) * Fl, le1[14] = 2 * ho * ls * Fl;
                            } else le1[10] = -1, le1[14] = -2 * ls;
                            return le1;
                        }, le1.bf = function(le1) {
                            var vt = new uc(16);
                            return vt[0] = le1[0], vt[1] = le1[1], vt[2] = le1[2], vt[3] = le1[3], vt[4] = le1[4], vt[5] = le1[5], vt[6] = le1[6], vt[7] = le1[7], vt[8] = le1[8], vt[9] = le1[9], vt[10] = le1[10], vt[11] = le1[11], vt[12] = le1[12], vt[13] = le1[13], vt[14] = le1[14], vt[15] = le1[15], vt;
                        }, le1.bg = function(le1, vt, bt) {
                            var ls = Math.sin(bt), ho = Math.cos(bt), Dl = vt[0], Fl = vt[1], sc = vt[2], uc = vt[3], mc = vt[4], gc = vt[5], Ac = vt[6], Ec = vt[7];
                            return vt !== le1 && (le1[8] = vt[8], le1[9] = vt[9], le1[10] = vt[10], le1[11] = vt[11], le1[12] = vt[12], le1[13] = vt[13], le1[14] = vt[14], le1[15] = vt[15]), le1[0] = Dl * ho + mc * ls, le1[1] = Fl * ho + gc * ls, le1[2] = sc * ho + Ac * ls, le1[3] = uc * ho + Ec * ls, le1[4] = mc * ho - Dl * ls, le1[5] = gc * ho - Fl * ls, le1[6] = Ac * ho - sc * ls, le1[7] = Ec * ho - uc * ls, le1;
                        }, le1.bh = function(le1, vt, bt) {
                            var ls = Math.sin(bt), ho = Math.cos(bt), Dl = vt[4], Fl = vt[5], sc = vt[6], uc = vt[7], mc = vt[8], gc = vt[9], Ac = vt[10], Ec = vt[11];
                            return vt !== le1 && (le1[0] = vt[0], le1[1] = vt[1], le1[2] = vt[2], le1[3] = vt[3], le1[12] = vt[12], le1[13] = vt[13], le1[14] = vt[14], le1[15] = vt[15]), le1[4] = Dl * ho + mc * ls, le1[5] = Fl * ho + gc * ls, le1[6] = sc * ho + Ac * ls, le1[7] = uc * ho + Ec * ls, le1[8] = mc * ho - Dl * ls, le1[9] = gc * ho - Fl * ls, le1[10] = Ac * ho - sc * ls, le1[11] = Ec * ho - uc * ls, le1;
                        }, le1.bi = function() {
                            const le1 = new Float32Array(16);
                            return y(le1), le1;
                        }, le1.bj = function() {
                            const le1 = new Float64Array(16);
                            return y(le1), le1;
                        }, le1.bk = function() {
                            return new Float64Array(16);
                        }, le1.bl = function(le1, vt, bt) {
                            const ls = new Float64Array(4);
                            return E(ls, le1, vt - 90, bt), ls;
                        }, le1.bm = function(le1, vt, bt, ls) {
                            var ho, Dl, Fl, uc, mc, gc = vt[0], Ac = vt[1], Ec = vt[2], kc = vt[3], du = bt[0], _u = bt[1], Md = bt[2], Ld = bt[3];
                            return (Dl = gc * du + Ac * _u + Ec * Md + kc * Ld) < 0 && (Dl = -Dl, du = -du, _u = -_u, Md = -Md, Ld = -Ld), 1 - Dl > sc ? (ho = Math.acos(Dl), Fl = Math.sin(ho), uc = Math.sin((1 - ls) * ho) / Fl, mc = Math.sin(ls * ho) / Fl) : (uc = 1 - ls, mc = ls), le1[0] = uc * gc + mc * du, le1[1] = uc * Ac + mc * _u, le1[2] = uc * Ec + mc * Md, le1[3] = uc * kc + mc * Ld, le1;
                        }, le1.bn = function(le1) {
                            const vt = new Float64Array(9);
                            var bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd;
                            Ac = (ho = (ls = le1)[0]) * (uc = ho + ho), Ec = (Dl = ls[1]) * uc, du = (Fl = ls[2]) * uc, _u = Fl * (mc = Dl + Dl), Ld = (sc = ls[3]) * uc, Nd = sc * mc, Rd = sc * (gc = Fl + Fl), (bt = vt)[0] = 1 - (kc = Dl * mc) - (Md = Fl * gc), bt[3] = Ec - Rd, bt[6] = du + Nd, bt[1] = Ec + Rd, bt[4] = 1 - Ac - Md, bt[7] = _u - Ld, bt[2] = du - Nd, bt[5] = _u + Ld, bt[8] = 1 - Ac - kc;
                            const Od = et(-Math.asin(C(vt[2], -1, 1)));
                            let jd, Ud;
                            return Math.hypot(vt[5], vt[8]) < .001 ? (jd = 0, Ud = -et(Math.atan2(vt[3], vt[4]))) : (jd = et(0 === vt[5] && 0 === vt[8] ? 0 : Math.atan2(vt[5], vt[8])), Ud = et(0 === vt[1] && 0 === vt[0] ? 0 : Math.atan2(vt[1], vt[0]))), {
                                roll: jd,
                                pitch: Od + 90,
                                bearing: Ud
                            };
                        }, le1.bo = function(le1, vt) {
                            return le1.roll == vt.roll && le1.pitch == vt.pitch && le1.bearing == vt.bearing;
                        }, le1.bp = Te, le1.bq = _o, le1.br = Dg, le1.bs = Lg, le1.bt = hu, le1.bu = z, le1.bv = P, le1.bw = Re, le1.bx = function(le1, vt, bt, ls, ho) {
                            return z(ls, ho, C((le1 - vt) / (bt - vt), 0, 1));
                        }, le1.by = function(le1, vt, bt, ls) {
                            return le1[0] = vt[0] + bt[0] * ls, le1[1] = vt[1] + bt[1] * ls, le1[2] = vt[2] + bt[2] * ls, le1;
                        }, le1.bz = D, le1.c = Ud, le1.c$ = class {
                            constructor(le1){
                                this._marks = {
                                    start: [
                                        le1.url,
                                        "start"
                                    ].join("#"),
                                    end: [
                                        le1.url,
                                        "end"
                                    ].join("#"),
                                    measure: le1.url.toString()
                                }, performance.mark(this._marks.start);
                            }
                            finish() {
                                performance.mark(this._marks.end);
                                let le1 = performance.getEntriesByName(this._marks.measure);
                                return 0 === le1.length && (performance.measure(this._marks.measure, this._marks.start, this._marks.end), le1 = performance.getEntriesByName(this._marks.measure), performance.clearMarks(this._marks.start), performance.clearMarks(this._marks.end), performance.clearMeasures(this._marks.measure)), le1;
                            }
                        }, le1.c0 = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = fg;
                            }
                            set(le1) {
                                if (le1[12] !== this.current[12] || le1[0] !== this.current[0]) return this.current = le1, void this.gl.uniformMatrix4fv(this.location, !1, le1);
                                for(let vt = 1; vt < 16; vt++)if (le1[vt] !== this.current[vt]) {
                                    this.current = le1, this.gl.uniformMatrix4fv(this.location, !1, le1);
                                    break;
                                }
                            }
                        }, le1.c1 = So, le1.c2 = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = [
                                    0,
                                    0,
                                    0
                                ];
                            }
                            set(le1) {
                                le1[0] === this.current[0] && le1[1] === this.current[1] && le1[2] === this.current[2] || (this.current = le1, this.gl.uniform3f(this.location, le1[0], le1[1], le1[2]));
                            }
                        }, le1.c3 = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = [
                                    0,
                                    0
                                ];
                            }
                            set(le1) {
                                le1[0] === this.current[0] && le1[1] === this.current[1] || (this.current = le1, this.gl.uniform2f(this.location, le1[0], le1[1]));
                            }
                        }, le1.c4 = d, le1.c5 = function(le1, vt) {
                            var bt = Math.sin(vt), ls = Math.cos(vt);
                            return le1[0] = ls, le1[1] = bt, le1[2] = 0, le1[3] = -bt, le1[4] = ls, le1[5] = 0, le1[6] = 0, le1[7] = 0, le1[8] = 1, le1;
                        }, le1.c6 = function(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1], Dl = vt[2];
                            return le1[0] = ls * bt[0] + ho * bt[3] + Dl * bt[6], le1[1] = ls * bt[1] + ho * bt[4] + Dl * bt[7], le1[2] = ls * bt[2] + ho * bt[5] + Dl * bt[8], le1;
                        }, le1.c7 = function(le1, vt, bt, ls, ho, Dl, Fl) {
                            var sc = 1 / (vt - bt), uc = 1 / (ls - ho), mc = 1 / (Dl - Fl);
                            return le1[0] = -2 * sc, le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[4] = 0, le1[5] = -2 * uc, le1[6] = 0, le1[7] = 0, le1[8] = 0, le1[9] = 0, le1[10] = 2 * mc, le1[11] = 0, le1[12] = (vt + bt) * sc, le1[13] = (ho + ls) * uc, le1[14] = (Fl + Dl) * mc, le1[15] = 1, le1;
                        }, le1.c8 = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = new Array;
                            }
                            set(le1) {
                                if (le1 != this.current) {
                                    this.current = le1;
                                    const vt = new Float32Array(4 * le1.length);
                                    for(let bt = 0; bt < le1.length; bt++)vt[4 * bt] = le1[bt].r, vt[4 * bt + 1] = le1[bt].g, vt[4 * bt + 2] = le1[bt].b, vt[4 * bt + 3] = le1[bt].a;
                                    this.gl.uniform4fv(this.location, vt);
                                }
                            }
                        }, le1.c9 = class extends wo {
                            constructor(le1, vt){
                                super(le1, vt), this.current = new Array;
                            }
                            set(le1) {
                                if (le1 != this.current) {
                                    this.current = le1;
                                    const vt = new Float32Array(le1);
                                    this.gl.uniform1fv(this.location, vt);
                                }
                            }
                        }, le1.cA = function(le1, vt) {
                            var bt;
                            if (!Od[vt]) return !1;
                            const ls = null == le1 ? void 0 : le1.target, ho = (null === (bt = null == ls ? void 0 : ls.ownerDocument) || void 0 === bt ? void 0 : bt.defaultView) || window;
                            return le1 instanceof ho.MouseEvent || le1 instanceof ho.WheelEvent;
                        }, le1.cB = function(le1, vt) {
                            return Rd[vt] && "touches" in le1;
                        }, le1.cC = function(le1) {
                            return Rd[le1] || Od[le1];
                        }, le1.cD = function(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1];
                            return le1[0] = bt[0] * ls + bt[4] * ho + bt[12], le1[1] = bt[1] * ls + bt[5] * ho + bt[13], le1;
                        }, le1.cE = function(le1, vt) {
                            const { x: bt, y: ls } = Vh.fromLngLat(vt);
                            return !(le1 < 0 || le1 > 25 || ls < 0 || ls >= 1 || bt < 0 || bt >= 1);
                        }, le1.cF = function(le1, vt) {
                            return le1[0] = vt[0], le1[1] = 0, le1[2] = 0, le1[3] = 0, le1[4] = 0, le1[5] = vt[1], le1[6] = 0, le1[7] = 0, le1[8] = 0, le1[9] = 0, le1[10] = vt[2], le1[11] = 0, le1[12] = 0, le1[13] = 0, le1[14] = 0, le1[15] = 1, le1;
                        }, le1.cG = class extends aa {
                        }, le1.cH = qA, le1.cJ = ct, le1.cK = function(le1, vt) {
                            Ud.REGISTERED_PROTOCOLS[le1] = vt;
                        }, le1.cL = function(le1) {
                            delete Ud.REGISTERED_PROTOCOLS[le1];
                        }, le1.cM = function(le1, vt) {
                            const bt = {};
                            for(let ho = 0; ho < le1.length; ho++){
                                const ls = vt && vt[le1[ho].id] || _i(le1[ho]);
                                vt && (vt[le1[ho].id] = ls);
                                let Dl = bt[ls];
                                Dl || (Dl = bt[ls] = []), Dl.push(le1[ho]);
                            }
                            const ls = [];
                            for(const ho in bt)ls.push(bt[ho]);
                            return ls;
                        }, le1.cN = ps, le1.cO = Gh, le1.cP = Nf, le1.cQ = jc, le1.cR = function(vt) {
                            var bt;
                            vt.bucket.createArrays(), vt.bucket.tilePixelRatio = Ac / (512 * vt.bucket.overscaling), vt.bucket.compareText = {}, vt.bucket.iconsNeedLinear = !1;
                            const ls = vt.bucket.layers[0], ho = ls.layout, Dl = ls._unevaluatedLayout._values, Fl = {
                                layoutIconSize: Dl["icon-size"].possiblyEvaluate(new Ps(vt.bucket.zoom + 1), vt.canonical),
                                layoutTextSize: Dl["text-size"].possiblyEvaluate(new Ps(vt.bucket.zoom + 1), vt.canonical),
                                textMaxSize: Dl["text-size"].possiblyEvaluate(new Ps(18))
                            };
                            if ("composite" === vt.bucket.textSizeData.kind) {
                                const { minZoom: le1, maxZoom: bt } = vt.bucket.textSizeData;
                                Fl.compositeTextSizes = [
                                    Dl["text-size"].possiblyEvaluate(new Ps(le1), vt.canonical),
                                    Dl["text-size"].possiblyEvaluate(new Ps(bt), vt.canonical)
                                ];
                            }
                            if ("composite" === vt.bucket.iconSizeData.kind) {
                                const { minZoom: le1, maxZoom: bt } = vt.bucket.iconSizeData;
                                Fl.compositeIconSizes = [
                                    Dl["icon-size"].possiblyEvaluate(new Ps(le1), vt.canonical),
                                    Dl["icon-size"].possiblyEvaluate(new Ps(bt), vt.canonical)
                                ];
                            }
                            const sc = ho.get("text-line-height") * nA, uc = "viewport" !== ho.get("text-rotation-alignment") && "point" !== ho.get("symbol-placement"), mc = ho.get("text-keep-upright"), gc = ho.get("text-size");
                            for (const Ac of vt.bucket.features){
                                const Dl = ho.get("text-font").evaluate(Ac, {}, vt.canonical).join(","), Ec = gc.evaluate(Ac, {}, vt.canonical), kc = Fl.layoutTextSize.evaluate(Ac, {}, vt.canonical), du = Fl.layoutIconSize.evaluate(Ac, {}, vt.canonical), _u = {
                                    horizontal: {},
                                    vertical: void 0
                                }, Md = Ac.text;
                                let Ld, Nd = [
                                    0,
                                    0
                                ];
                                if (Md) {
                                    const bt = Md.toString(), Fl = ho.get("text-letter-spacing").evaluate(Ac, {}, vt.canonical) * nA, gc = Ss(bt) ? Fl : 0, du = ho.get("text-anchor").evaluate(Ac, {}, vt.canonical), Ld = md(ls, Ac, vt.canonical);
                                    if (!Ld) {
                                        const le1 = ho.get("text-radial-offset").evaluate(Ac, {}, vt.canonical);
                                        Nd = le1 ? yd(du, [
                                            le1 * nA,
                                            RA
                                        ]) : ho.get("text-offset").evaluate(Ac, {}, vt.canonical).map((le1)=>le1 * nA);
                                    }
                                    let Rd = uc ? "center" : ho.get("text-justify").evaluate(Ac, {}, vt.canonical);
                                    const Od = "point" === ho.get("symbol-placement") ? ho.get("text-max-width").evaluate(Ac, {}, vt.canonical) * nA : 1 / 0, w = ()=>{
                                        vt.bucket.allowVerticalPlacement && _s(bt) && (_u.vertical = Xc(Md, vt.glyphMap, vt.glyphPositions, vt.imagePositions, Dl, Od, sc, du, "left", gc, Nd, le1.az.vertical, !0, kc, Ec));
                                    };
                                    if (!uc && Ld) {
                                        const bt = new Set;
                                        if ("auto" === Rd) for(let le1 = 0; le1 < Ld.values.length; le1 += 2)bt.add(gd(Ld.values[le1]));
                                        else bt.add(Rd);
                                        let ls = !1;
                                        for (const ho of bt)if (!_u.horizontal[ho]) {
                                            if (ls) _u.horizontal[ho] = _u.horizontal[0];
                                            else {
                                                const bt = Xc(Md, vt.glyphMap, vt.glyphPositions, vt.imagePositions, Dl, Od, sc, "center", ho, gc, Nd, le1.az.horizontal, !1, kc, Ec);
                                                bt && (_u.horizontal[ho] = bt, ls = 1 === bt.positionedLines.length);
                                            }
                                        }
                                        w();
                                    } else {
                                        "auto" === Rd && (Rd = gd(du));
                                        const ls = Xc(Md, vt.glyphMap, vt.glyphPositions, vt.imagePositions, Dl, Od, sc, du, Rd, gc, Nd, le1.az.horizontal, !1, kc, Ec);
                                        ls && (_u.horizontal[Rd] = ls), w(), _s(bt) && uc && mc && (_u.vertical = Xc(Md, vt.glyphMap, vt.glyphPositions, vt.imagePositions, Dl, Od, sc, du, Rd, gc, Nd, le1.az.vertical, !1, kc, Ec));
                                    }
                                }
                                let Rd = !1;
                                if (Ac.icon && Ac.icon.name) {
                                    const le1 = vt.imageMap[Ac.icon.name];
                                    le1 && (Ld = th(vt.imagePositions[Ac.icon.name], ho.get("icon-offset").evaluate(Ac, {}, vt.canonical), ho.get("icon-anchor").evaluate(Ac, {}, vt.canonical)), Rd = !!le1.sdf, void 0 === vt.bucket.sdfIcons ? vt.bucket.sdfIcons = Rd : vt.bucket.sdfIcons !== Rd && j("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"), (le1.pixelRatio !== vt.bucket.pixelRatio || 0 !== ho.get("icon-rotate").constantOr(1)) && (vt.bucket.iconsNeedLinear = !0));
                                }
                                const Od = bd(_u.horizontal) || _u.vertical;
                                (bt = vt.bucket).iconsInText || (bt.iconsInText = !!Od && Od.iconsInText), (Od || Ld) && xd(vt.bucket, Ac, _u, Ld, vt.imageMap, Fl, kc, du, Nd, Rd, vt.canonical, vt.subdivisionGranularity);
                            }
                            vt.showCollisionBoxes && vt.bucket.generateCollisionDebugBuffers();
                        }, le1.cS = wu, le1.cT = Ru, le1.cU = tc, le1.cV = function(le1) {
                            const vt = new Tc;
                            return function(le1, vt) {
                                for(const bt in le1.layers)vt.writeMessage(3, Pf, le1.layers[bt]);
                            }(le1, vt), vt.finish();
                        }, le1.cW = function(le1, vt, bt, ls, ho, Dl) {
                            let Fl = jf(le1, vt, bt, ho, 0);
                            return Fl = jf(Fl, vt, ls, Dl, 1), Fl;
                        }, le1.cX = class {
                            constructor(le1){
                                this.maxEntries = le1, this.map = new Map;
                            }
                            get(le1) {
                                const vt = this.map.get(le1);
                                return void 0 !== vt && (this.map.delete(le1), this.map.set(le1, vt)), vt;
                            }
                            set(le1, vt) {
                                if (this.map.has(le1)) this.map.delete(le1);
                                else if (this.map.size >= this.maxEntries) {
                                    const le1 = this.map.keys().next().value;
                                    this.map.delete(le1);
                                }
                                this.map.set(le1, vt);
                            }
                            clear() {
                                this.map.clear();
                            }
                        }, le1.cY = Vu, le1.cZ = Tc, le1.c_ = Ff, le1.ca = class extends xa {
                        }, le1.cb = iA, le1.cc = class extends ba {
                        }, le1.cd = Eg, le1.ce = function(le1) {
                            return le1 <= 1 ? 1 : Math.pow(2, Math.ceil(Math.log(le1) / Math.LN2));
                        }, le1.cf = Al, le1.cg = function(le1, vt, bt) {
                            var ls = vt[0], ho = vt[1], Dl = vt[2], Fl = bt[3] * ls + bt[7] * ho + bt[11] * Dl + bt[15];
                            return le1[0] = (bt[0] * ls + bt[4] * ho + bt[8] * Dl + bt[12]) / (Fl = Fl || 1), le1[1] = (bt[1] * ls + bt[5] * ho + bt[9] * Dl + bt[13]) / Fl, le1[2] = (bt[2] * ls + bt[6] * ho + bt[10] * Dl + bt[14]) / Fl, le1;
                        }, le1.ch = class extends oa {
                        }, le1.ci = class extends Ta {
                        }, le1.cj = function(le1, vt) {
                            return le1[0] === vt[0] && le1[1] === vt[1] && le1[2] === vt[2] && le1[3] === vt[3] && le1[4] === vt[4] && le1[5] === vt[5] && le1[6] === vt[6] && le1[7] === vt[7] && le1[8] === vt[8] && le1[9] === vt[9] && le1[10] === vt[10] && le1[11] === vt[11] && le1[12] === vt[12] && le1[13] === vt[13] && le1[14] === vt[14] && le1[15] === vt[15];
                        }, le1.ck = function(le1, vt) {
                            var bt = le1[0], ls = le1[1], ho = le1[2], Dl = le1[3], Fl = le1[4], uc = le1[5], mc = le1[6], gc = le1[7], Ac = le1[8], Ec = le1[9], kc = le1[10], du = le1[11], _u = le1[12], Md = le1[13], Ld = le1[14], Nd = le1[15], Rd = vt[0], Od = vt[1], jd = vt[2], Ud = vt[3], Gd = vt[4], qd = vt[5], Hd = vt[6], Wd = vt[7], Zd = vt[8], Yd = vt[9], Qd = vt[10], Xd = vt[11], Kd = vt[12], Jd = vt[13], $d = vt[14], sp = vt[15];
                            return Math.abs(bt - Rd) <= sc * Math.max(1, Math.abs(bt), Math.abs(Rd)) && Math.abs(ls - Od) <= sc * Math.max(1, Math.abs(ls), Math.abs(Od)) && Math.abs(ho - jd) <= sc * Math.max(1, Math.abs(ho), Math.abs(jd)) && Math.abs(Dl - Ud) <= sc * Math.max(1, Math.abs(Dl), Math.abs(Ud)) && Math.abs(Fl - Gd) <= sc * Math.max(1, Math.abs(Fl), Math.abs(Gd)) && Math.abs(uc - qd) <= sc * Math.max(1, Math.abs(uc), Math.abs(qd)) && Math.abs(mc - Hd) <= sc * Math.max(1, Math.abs(mc), Math.abs(Hd)) && Math.abs(gc - Wd) <= sc * Math.max(1, Math.abs(gc), Math.abs(Wd)) && Math.abs(Ac - Zd) <= sc * Math.max(1, Math.abs(Ac), Math.abs(Zd)) && Math.abs(Ec - Yd) <= sc * Math.max(1, Math.abs(Ec), Math.abs(Yd)) && Math.abs(kc - Qd) <= sc * Math.max(1, Math.abs(kc), Math.abs(Qd)) && Math.abs(du - Xd) <= sc * Math.max(1, Math.abs(du), Math.abs(Xd)) && Math.abs(_u - Kd) <= sc * Math.max(1, Math.abs(_u), Math.abs(Kd)) && Math.abs(Md - Jd) <= sc * Math.max(1, Math.abs(Md), Math.abs(Jd)) && Math.abs(Ld - $d) <= sc * Math.max(1, Math.abs(Ld), Math.abs($d)) && Math.abs(Nd - sp) <= sc * Math.max(1, Math.abs(Nd), Math.abs(sp));
                        }, le1.cl = function(le1, vt) {
                            return le1[0] = vt[0], le1[1] = vt[1], le1[2] = vt[2], le1[3] = vt[3], le1[4] = vt[4], le1[5] = vt[5], le1[6] = vt[6], le1[7] = vt[7], le1[8] = vt[8], le1[9] = vt[9], le1[10] = vt[10], le1[11] = vt[11], le1[12] = vt[12], le1[13] = vt[13], le1[14] = vt[14], le1[15] = vt[15], le1;
                        }, le1.cm = (le1)=>"symbol" === le1.type, le1.cn = (le1)=>"circle" === le1.type, le1.co = (le1)=>"heatmap" === le1.type, le1.cp = (le1)=>"line" === le1.type, le1.cq = (le1)=>"fill" === le1.type, le1.cr = (le1)=>"fill-extrusion" === le1.type, le1.cs = (le1)=>"hillshade" === le1.type, le1.ct = (le1)=>"color-relief" === le1.type, le1.cu = (le1)=>"background" === le1.type, le1.cv = (le1)=>"custom" === le1.type, le1.cw = B, le1.cx = function(le1, vt, bt) {
                            if (vt <= 0) return le1;
                            const ls = 1 / vt;
                            return void 0 === bt || Math.abs(bt) < 1e-10 ? Math.round(le1 * ls) / ls : (bt > 0 ? Math.ceil(le1 * ls - 1e-9) : Math.floor(le1 * ls + 1e-10)) / ls;
                        }, le1.cy = function(le1, vt, bt) {
                            const ls = I(vt.x - bt.x, vt.y - bt.y), ho = I(le1.x - bt.x, le1.y - bt.y);
                            var Dl, Fl;
                            return et(Math.atan2(ls[0] * ho[1] - ls[1] * ho[0], (Dl = ls)[0] * (Fl = ho)[0] + Dl[1] * Fl[1]));
                        }, le1.cz = Ec, le1.d = ft, le1.d0 = function(le1, vt, bt, ls, ho) {
                            return e(this, void 0, void 0, function*() {
                                if (h()) try {
                                    return yield K(le1, vt, bt, ls, ho);
                                } catch (le1) {}
                                return function(le1, vt, bt, ls, ho) {
                                    const Dl = le1.width, Fl = le1.height;
                                    Ld && Nd || (Ld = new OffscreenCanvas(Dl, Fl), Nd = Ld.getContext("2d", {
                                        willReadFrequently: !0
                                    })), Ld.width = Dl, Ld.height = Fl, Nd.drawImage(le1, 0, 0, Dl, Fl);
                                    const sc = Nd.getImageData(vt, bt, ls, ho);
                                    return Nd.clearRect(0, 0, Dl, Fl), sc.data;
                                }(le1, vt, bt, ls, ho);
                            });
                        }, le1.d1 = Pl, le1.d2 = n, le1.d3 = class {
                            constructor(le1, vt){
                                this.layers = {
                                    [zA]: this
                                }, this.name = zA, this.version = vt ? vt.version : 1, this.extent = vt ? vt.extent : 4096, this.length = le1.length, this.features = le1;
                            }
                            feature(le1) {
                                return new Df(this.features[le1], this.extent);
                            }
                        }, le1.d4 = ni, le1.d5 = Jm, le1.e = O, le1.f = (le1)=>e(void 0, void 0, void 0, function*() {
                                if (0 === le1.byteLength) return createImageBitmap(new ImageData(1, 1));
                                const vt = new Blob([
                                    new Uint8Array(le1)
                                ], {
                                    type: "image/png"
                                });
                                try {
                                    return createImageBitmap(vt);
                                } catch (le1) {
                                    throw new Error(`Could not load image because of ${le1.message}. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported.`);
                                }
                            }), le1.g = lt, le1.h = (le1)=>new Promise((vt, bt)=>{
                                const ls = new Image;
                                ls.onload = ()=>{
                                    vt(ls), URL.revokeObjectURL(ls.src), ls.onload = null, window.requestAnimationFrame(()=>{
                                        ls.src = Md;
                                    });
                                }, ls.onerror = ()=>bt(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                const ho = new Blob([
                                    new Uint8Array(le1)
                                ], {
                                    type: "image/png"
                                });
                                ls.src = le1.byteLength ? URL.createObjectURL(ho) : Md;
                            }), le1.i = X, le1.j = (le1, vt)=>pt(O(le1, {
                                type: "json"
                            }), vt), le1.k = gt, le1.l = mt, le1.m = pt, le1.n = (le1, vt)=>pt(O(le1, {
                                type: "arrayBuffer"
                            }), vt), le1.o = function(le1) {
                            return new Tc(le1).readFields(Rc, []);
                        }, le1.p = Uc, le1.q = function(le1) {
                            return /[\u02EA\u02EB\u1100-\u11FF\u2E80-\u2FDF\u3000-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u4DBF\u4E00-\uA48C\uA490-\uA4C6\uA960-\uA97C\uAC00-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFE10-\uFE1F\uFE30-\uFE4F\uFF00-\uFFEF]|\uD81B[\uDFE0-\uDFFF]|[\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFFF]|\uD82C[\uDC00-\uDEFB]|\uD83C[\uDE00-\uDEFF]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79]/gim.test(String.fromCodePoint(le1));
                        }, le1.r = _l, le1.s = Q, le1.t = Hs, le1.u = qd, le1.v = Gm, le1.w = j, le1.x = Os, le1.y = Hm, le1.z = $m;
                    }), define("worker", [
                        "./shared"
                    ], function(le1) {
                        class t {
                            constructor(le1, vt){
                                this.keyCache = {}, le1 && this.replace(le1, vt);
                            }
                            replace(le1, vt) {
                                this._layerConfigs = {}, this._layers = {}, this.update(le1, [], vt);
                            }
                            update(vt, bt, ls) {
                                for (const Dl of vt){
                                    this._layerConfigs[Dl.id] = Dl;
                                    const vt = this._layers[Dl.id] = le1.bT(Dl, ls);
                                    vt._featureFilter = le1.aj(vt.filter, ls), this.keyCache[Dl.id] && delete this.keyCache[Dl.id];
                                }
                                for (const le1 of bt)delete this.keyCache[le1], delete this._layerConfigs[le1], delete this._layers[le1];
                                this.familiesBySource = {};
                                const ho = le1.cM(Object.values(this._layerConfigs), this.keyCache);
                                for (const Dl of ho){
                                    const vt = Dl.map((le1)=>this._layers[le1.id]), bt = vt[0];
                                    if (bt.isHidden()) continue;
                                    const ls = bt.source || "";
                                    let ho = this.familiesBySource[ls];
                                    ho || (ho = this.familiesBySource[ls] = {});
                                    const Fl = bt.sourceLayer || le1.ai;
                                    let sc = ho[Fl];
                                    sc || (sc = ho[Fl] = []), sc.push(vt);
                                }
                            }
                        }
                        class o {
                            constructor(vt){
                                const bt = {}, ls = [];
                                for(const le1 in vt){
                                    const ho = vt[le1], Dl = bt[le1] = {};
                                    for(const le1 in ho){
                                        const vt = ho[+le1];
                                        if (!vt || 0 === vt.bitmap.width || 0 === vt.bitmap.height) continue;
                                        const bt = {
                                            x: 0,
                                            y: 0,
                                            w: vt.bitmap.width + 2,
                                            h: vt.bitmap.height + 2
                                        };
                                        ls.push(bt), Dl[le1] = {
                                            rect: bt,
                                            metrics: vt.metrics
                                        };
                                    }
                                }
                                const { w: ho, h: Dl } = le1.p(ls), Fl = new le1.r({
                                    width: ho || 1,
                                    height: Dl || 1
                                });
                                for(const sc in vt){
                                    const ls = vt[sc];
                                    for(const vt in ls){
                                        const ho = ls[+vt];
                                        if (!ho || 0 === ho.bitmap.width || 0 === ho.bitmap.height) continue;
                                        const Dl = bt[sc][vt].rect;
                                        le1.r.copy(ho.bitmap, Fl, {
                                            x: 0,
                                            y: 0
                                        }, {
                                            x: Dl.x + 1,
                                            y: Dl.y + 1
                                        }, ho.bitmap);
                                    }
                                }
                                this.image = Fl, this.positions = bt;
                            }
                        }
                        le1.cN("GlyphAtlas", o);
                        class s {
                            constructor(vt){
                                this.tileID = new le1.a2(vt.tileID.overscaledZ, vt.tileID.wrap, vt.tileID.canonical.z, vt.tileID.canonical.x, vt.tileID.canonical.y), this.uid = vt.uid, this.zoom = vt.zoom, this.pixelRatio = vt.pixelRatio, this.tileSize = vt.tileSize, this.source = vt.source, this.overscaling = this.tileID.overscaleFactor(), this.showCollisionBoxes = vt.showCollisionBoxes, this.collectResourceTiming = !!vt.collectResourceTiming, this.returnDependencies = !!vt.returnDependencies, this.promoteId = vt.promoteId, this.inFlightDependencies = [];
                            }
                            parse(vt, bt, ls, ho, Dl) {
                                return le1._(this, void 0, void 0, function*() {
                                    this.status = "parsing", this.data = vt, this.collisionBoxArray = new le1.ag;
                                    const Fl = new le1.cO(Object.keys(vt.layers).sort()), sc = new le1.cP(this.tileID, this.promoteId);
                                    sc.bucketLayerIDs = [];
                                    const uc = {}, mc = {
                                        featureIndex: sc,
                                        iconDependencies: {},
                                        patternDependencies: {},
                                        glyphDependencies: {},
                                        dashDependencies: {},
                                        availableImages: ls,
                                        subdivisionGranularity: Dl
                                    }, gc = bt.familiesBySource[this.source];
                                    for(const bt in gc){
                                        const ho = vt.layers[bt];
                                        if (!ho) continue;
                                        1 === ho.version && le1.w(`Vector tile source "${this.source}" layer "${bt}" does not use vector tile spec v2 and therefore may have some rendering errors.`);
                                        const Dl = Fl.encode(bt), Ac = [];
                                        for(let le1 = 0; le1 < ho.length; le1++){
                                            const vt = ho.feature(le1), ls = sc.getId(vt, bt);
                                            Ac.push({
                                                feature: vt,
                                                id: ls,
                                                index: le1,
                                                sourceLayerIndex: Dl
                                            });
                                        }
                                        for (const vt of gc[bt]){
                                            const bt = vt[0];
                                            bt.source !== this.source && le1.w(`layer.source = ${bt.source} does not equal this.source = ${this.source}`), bt.isHidden(this.zoom, !0) || (i(vt, this.zoom, ls), (uc[bt.id] = bt.createBucket({
                                                index: sc.bucketLayerIDs.length,
                                                layers: vt,
                                                zoom: this.zoom,
                                                pixelRatio: this.pixelRatio,
                                                overscaling: this.overscaling,
                                                collisionBoxArray: this.collisionBoxArray,
                                                sourceLayerIndex: Dl,
                                                sourceID: this.source
                                            })).populate(Ac, mc, this.tileID.canonical), sc.bucketLayerIDs.push(vt.map((le1)=>le1.id)));
                                        }
                                    }
                                    const Ac = le1.bY(mc.glyphDependencies, (le1)=>Object.keys(le1).map(Number));
                                    this.inFlightDependencies.forEach((le1)=>null == le1 ? void 0 : le1.abort()), this.inFlightDependencies = [];
                                    let Ec = Promise.resolve({});
                                    if (Object.keys(Ac).length) {
                                        const le1 = new AbortController;
                                        this.inFlightDependencies.push(le1), Ec = ho.sendAsync({
                                            type: "GG",
                                            data: {
                                                stacks: Ac,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "glyphs"
                                            }
                                        }, le1);
                                    }
                                    const kc = Object.keys(mc.iconDependencies);
                                    let du = Promise.resolve({});
                                    if (kc.length) {
                                        const le1 = new AbortController;
                                        this.inFlightDependencies.push(le1), du = ho.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: kc,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "icons"
                                            }
                                        }, le1);
                                    }
                                    const _u = Object.keys(mc.patternDependencies);
                                    let Md = Promise.resolve({});
                                    if (_u.length) {
                                        const le1 = new AbortController;
                                        this.inFlightDependencies.push(le1), Md = ho.sendAsync({
                                            type: "GI",
                                            data: {
                                                icons: _u,
                                                source: this.source,
                                                tileID: this.tileID,
                                                type: "patterns"
                                            }
                                        }, le1);
                                    }
                                    const Ld = mc.dashDependencies;
                                    let Nd = Promise.resolve({});
                                    if (Object.keys(Ld).length) {
                                        const le1 = new AbortController;
                                        this.inFlightDependencies.push(le1), Nd = ho.sendAsync({
                                            type: "GDA",
                                            data: {
                                                dashes: Ld
                                            }
                                        }, le1);
                                    }
                                    const [Rd, Od, jd, Ud] = yield Promise.all([
                                        Ec,
                                        du,
                                        Md,
                                        Nd
                                    ]), Gd = new o(Rd), qd = new le1.cQ(Od, jd);
                                    for(const vt in uc){
                                        const bt = uc[vt];
                                        bt instanceof le1.ah ? (i(bt.layers, this.zoom, ls), le1.cR({
                                            bucket: bt,
                                            glyphMap: Rd,
                                            glyphPositions: Gd.positions,
                                            imageMap: Od,
                                            imagePositions: qd.iconPositions,
                                            showCollisionBoxes: this.showCollisionBoxes,
                                            canonical: this.tileID.canonical,
                                            subdivisionGranularity: mc.subdivisionGranularity
                                        })) : bt.hasDependencies && (bt instanceof le1.cS || bt instanceof le1.cT || bt instanceof le1.cU) && (i(bt.layers, this.zoom, ls), bt.addFeatures(mc, this.tileID.canonical, qd.patternPositions, Ud));
                                    }
                                    return this.status = "done", {
                                        buckets: Object.values(uc).filter((le1)=>!le1.isEmpty()),
                                        featureIndex: sc,
                                        collisionBoxArray: this.collisionBoxArray,
                                        glyphAtlasImage: Gd.image,
                                        imageAtlas: qd,
                                        dashPositions: Ud,
                                        glyphMap: this.returnDependencies ? Rd : null,
                                        iconMap: this.returnDependencies ? Od : null,
                                        glyphPositions: this.returnDependencies ? Gd.positions : null
                                    };
                                });
                            }
                        }
                        function i(vt, bt, ls) {
                            const ho = new le1.H(bt);
                            for (const le1 of vt)le1.recalculate(ho, ls);
                        }
                        class n {
                            constructor(le1, vt, bt, ls, ho){
                                this.type = le1, this.properties = bt || {}, this.extent = ho, this.pointsArray = vt, this.id = ls;
                            }
                            loadGeometry() {
                                return this.pointsArray.map((vt)=>vt.map((vt)=>new le1.P(vt.x, vt.y)));
                            }
                        }
                        class r {
                            constructor(le1, vt, bt){
                                this.version = 2, this._myFeatures = le1, this.name = vt, this.length = le1.length, this.extent = bt;
                            }
                            feature(le1) {
                                return this._myFeatures[le1];
                            }
                        }
                        class a {
                            constructor(){
                                this.layers = {};
                            }
                            addLayer(le1) {
                                this.layers[le1.name] = le1;
                            }
                        }
                        function c(vt) {
                            let bt = le1.cV(vt);
                            return 0 === bt.byteOffset && bt.byteLength === bt.buffer.byteLength || (bt = new Uint8Array(bt)), {
                                vectorTile: vt,
                                rawData: bt.buffer
                            };
                        }
                        function l(vt, bt, ls) {
                            const { extent: ho } = vt, Dl = Math.pow(2, ls.z - bt.z), Fl = (ls.x - bt.x * Dl) * ho, sc = (ls.y - bt.y * Dl) * ho, uc = [];
                            for(let mc = 0; mc < vt.length; mc++){
                                const bt = vt.feature(mc);
                                let ls = bt.loadGeometry();
                                for (const le1 of ls)for (const vt of le1)vt.x = vt.x * Dl - Fl, vt.y = vt.y * Dl - sc;
                                const gc = 128;
                                ls = le1.cW(ls, bt.type, -gc, -gc, ho + gc, ho + gc), 0 !== ls.length && uc.push(new n(bt.type, ls, bt.properties, bt.id, ho));
                            }
                            return new r(uc, vt.name, ho);
                        }
                        class h {
                            constructor(vt, bt, ls){
                                this.actor = vt, this.layerIndex = bt, this.availableImages = ls, this.fetching = {}, this.loading = {}, this.loaded = {}, this.overzoomedTileResultCache = new le1.cX(1e3);
                            }
                            loadVectorTile(vt, bt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const ls = yield le1.n(vt.request, bt);
                                    try {
                                        return {
                                            vectorTile: "mlt" !== vt.encoding ? new le1.cY(new le1.cZ(ls.data)) : new le1.c_(ls.data),
                                            rawData: ls.data,
                                            cacheControl: ls.cacheControl,
                                            expires: ls.expires
                                        };
                                    } catch (le1) {
                                        const ho = new Uint8Array(ls.data);
                                        let Dl = `Unable to parse the tile at ${vt.request.url}, `;
                                        throw Dl += 31 === ho[0] && 139 === ho[1] ? "please make sure the data is not gzipped and that you have configured the relevant header in the server" : `got error: ${le1.message}`, new Error(Dl);
                                    }
                                });
                            }
                            loadTile(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const { uid: bt, overzoomParameters: ls } = vt;
                                    ls && (vt.request = ls.overzoomRequest);
                                    const ho = !!(vt && vt.request && vt.request.collectResourceTiming) && new le1.c$(vt.request), Dl = new s(vt);
                                    this.loading[bt] = Dl;
                                    const Fl = new AbortController;
                                    Dl.abort = Fl;
                                    try {
                                        const sc = yield this.loadVectorTile(vt, Fl);
                                        if (delete this.loading[bt], !sc) return null;
                                        if (ls) {
                                            const le1 = this._getOverzoomTile(vt, sc.vectorTile);
                                            sc.rawData = le1.rawData, sc.vectorTile = le1.vectorTile;
                                        }
                                        const uc = sc.rawData, mc = {};
                                        sc.expires && (mc.expires = sc.expires), sc.cacheControl && (mc.cacheControl = sc.cacheControl);
                                        const gc = {};
                                        if (ho) {
                                            const le1 = ho.finish();
                                            le1 && (gc.resourceTiming = JSON.parse(JSON.stringify(le1)));
                                        }
                                        Dl.vectorTile = sc.vectorTile;
                                        const Ac = Dl.parse(sc.vectorTile, this.layerIndex, this.availableImages, this.actor, vt.subdivisionGranularity);
                                        this.loaded[bt] = Dl, this.fetching[bt] = {
                                            rawTileData: uc,
                                            cacheControl: mc,
                                            resourceTiming: gc
                                        };
                                        try {
                                            const bt = yield Ac;
                                            return le1.e({
                                                rawTileData: uc.slice(0),
                                                encoding: vt.encoding
                                            }, bt, mc, gc);
                                        } finally{
                                            delete this.fetching[bt];
                                        }
                                    } catch (le1) {
                                        throw delete this.loading[bt], Dl.status = "done", this.loaded[bt] = Dl, le1;
                                    }
                                });
                            }
                            _getOverzoomTile(le1, vt) {
                                const { tileID: bt, source: ls, overzoomParameters: ho } = le1, { maxZoomTileID: Dl } = ho, Fl = `${Dl.key}_${bt.key}`, sc = this.overzoomedTileResultCache.get(Fl);
                                if (sc) return sc;
                                const uc = new a, mc = this.layerIndex.familiesBySource[ls];
                                for(const Ac in mc){
                                    const le1 = vt.layers[Ac];
                                    if (!le1) continue;
                                    const ls = l(le1, Dl, bt.canonical);
                                    ls.length > 0 && uc.addLayer(ls);
                                }
                                const gc = c(uc);
                                return this.overzoomedTileResultCache.set(Fl, gc), gc;
                            }
                            reloadTile(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const bt = vt.uid;
                                    if (!this.loaded || !this.loaded[bt]) throw new Error("Should not be trying to reload a tile that was never loaded or has been removed");
                                    const ls = this.loaded[bt];
                                    if (ls.showCollisionBoxes = vt.showCollisionBoxes, "parsing" === ls.status) {
                                        const ho = yield ls.parse(ls.vectorTile, this.layerIndex, this.availableImages, this.actor, vt.subdivisionGranularity);
                                        let Dl;
                                        if (this.fetching[bt]) {
                                            const { rawTileData: ls, cacheControl: Fl, resourceTiming: sc } = this.fetching[bt];
                                            delete this.fetching[bt], Dl = le1.e({
                                                rawTileData: ls.slice(0),
                                                encoding: vt.encoding
                                            }, ho, Fl, sc);
                                        } else Dl = ho;
                                        return Dl;
                                    }
                                    if ("done" === ls.status && ls.vectorTile) return ls.parse(ls.vectorTile, this.layerIndex, this.availableImages, this.actor, vt.subdivisionGranularity);
                                });
                            }
                            abortTile(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const le1 = this.loading, bt = vt.uid;
                                    le1 && le1[bt] && le1[bt].abort && (le1[bt].abort.abort(), delete le1[bt]);
                                });
                            }
                            removeTile(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    this.loaded && this.loaded[vt.uid] && delete this.loaded[vt.uid];
                                });
                            }
                        }
                        class u {
                            constructor(){
                                this.loaded = {};
                            }
                            loadTile(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const { uid: bt, encoding: ls, rawImageData: ho, redFactor: Dl, greenFactor: Fl, blueFactor: sc, baseShift: uc } = vt, mc = ho.width + 2, gc = ho.height + 2, Ac = le1.b(ho) ? new le1.R({
                                        width: mc,
                                        height: gc
                                    }, (yield le1.d0(ho, -1, -1, mc, gc))) : ho, Ec = new le1.d1(bt, Ac, ls, Dl, Fl, sc, uc);
                                    return this.loaded = this.loaded || {}, this.loaded[bt] = Ec, Ec;
                                });
                            }
                            removeTile(le1) {
                                const vt = this.loaded, bt = le1.uid;
                                vt && vt[bt] && delete vt[bt];
                            }
                        }
                        var vt, bt, ls = function() {
                            if (bt) return vt;
                            function e(le1, vt) {
                                if (0 !== le1.length) {
                                    t(le1[0], vt);
                                    for(var bt = 1; bt < le1.length; bt++)t(le1[bt], !vt);
                                }
                            }
                            function t(le1, vt) {
                                for(var bt = 0, ls = 0, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++){
                                    var sc = (le1[ho][0] - le1[Fl][0]) * (le1[Fl][1] + le1[ho][1]), uc = bt + sc;
                                    ls += Math.abs(bt) >= Math.abs(sc) ? bt - uc + sc : sc - uc + bt, bt = uc;
                                }
                                bt + ls >= 0 != !!vt && le1.reverse();
                            }
                            return bt = 1, vt = function t(le1, vt) {
                                var bt, ls = le1 && le1.type;
                                if ("FeatureCollection" === ls) for(bt = 0; bt < le1.features.length; bt++)t(le1.features[bt], vt);
                                else if ("GeometryCollection" === ls) for(bt = 0; bt < le1.geometries.length; bt++)t(le1.geometries[bt], vt);
                                else if ("Feature" === ls) t(le1.geometry, vt);
                                else if ("Polygon" === ls) e(le1.coordinates, vt);
                                else if ("MultiPolygon" === ls) for(bt = 0; bt < le1.coordinates.length; bt++)e(le1.coordinates[bt], vt);
                                return le1;
                            };
                        }(), ho = le1.d2(ls);
                        const Dl = {
                            minZoom: 0,
                            maxZoom: 16,
                            minPoints: 2,
                            radius: 40,
                            extent: 512,
                            nodeSize: 64,
                            log: !1,
                            generateId: !1,
                            reduce: null,
                            map: (le1)=>le1
                        }, Fl = Math.fround || (sc = new Float32Array(1), (le1)=>(sc[0] = +le1, sc[0]));
                        var sc;
                        class x {
                            constructor(le1){
                                this.options = Object.assign(Object.create(Dl), le1), this.trees = new Array(this.options.maxZoom + 1), this.stride = this.options.reduce ? 7 : 6, this.clusterProps = [];
                            }
                            load(le1) {
                                const { log: vt, minZoom: bt, maxZoom: ls } = this.options;
                                vt && console.time("total time");
                                const ho = `prepare ${le1.length} points`;
                                vt && console.time(ho), this.points = le1;
                                const Dl = [];
                                for(let uc = 0; uc < le1.length; uc++){
                                    const vt = le1[uc];
                                    if (!vt.geometry) continue;
                                    const [bt, ls] = vt.geometry.coordinates, ho = Fl(b(bt)), sc = Fl(S(ls));
                                    Dl.push(ho, sc, 1 / 0, uc, -1, 1), this.options.reduce && Dl.push(0);
                                }
                                let sc = this.trees[ls + 1] = this._createTree(Dl);
                                vt && console.timeEnd(ho);
                                for(let Fl = ls; Fl >= bt; Fl--){
                                    const le1 = +Date.now();
                                    sc = this.trees[Fl] = this._createTree(this._cluster(sc, Fl)), vt && console.log("z%d: %d clusters in %dms", Fl, sc.numItems, +Date.now() - le1);
                                }
                                return vt && console.timeEnd("total time"), this;
                            }
                            getClusters(le1, vt) {
                                let bt = ((le1[0] + 180) % 360 + 360) % 360 - 180;
                                const ls = Math.max(-90, Math.min(90, le1[1]));
                                let ho = 180 === le1[2] ? 180 : ((le1[2] + 180) % 360 + 360) % 360 - 180;
                                const Dl = Math.max(-90, Math.min(90, le1[3]));
                                if (le1[2] - le1[0] >= 360) bt = -180, ho = 180;
                                else if (bt > ho) {
                                    const le1 = this.getClusters([
                                        bt,
                                        ls,
                                        180,
                                        Dl
                                    ], vt), Fl = this.getClusters([
                                        -180,
                                        ls,
                                        ho,
                                        Dl
                                    ], vt);
                                    return le1.concat(Fl);
                                }
                                const Fl = this.trees[this._limitZoom(vt)], sc = Fl.range(b(bt), S(Dl), b(ho), S(ls)), uc = Fl.data, mc = [];
                                for (const gc of sc){
                                    const le1 = this.stride * gc;
                                    mc.push(uc[le1 + 5] > 1 ? w(uc, le1, this.clusterProps) : this.points[uc[le1 + 3]]);
                                }
                                return mc;
                            }
                            getChildren(le1) {
                                const vt = this._getOriginId(le1), bt = this._getOriginZoom(le1), ls = "No cluster with the specified id.", ho = this.trees[bt];
                                if (!ho) throw new Error(ls);
                                const Dl = ho.data;
                                if (vt * this.stride >= Dl.length) throw new Error(ls);
                                const Fl = this.options.radius / (this.options.extent * Math.pow(2, bt - 1)), sc = ho.within(Dl[vt * this.stride], Dl[vt * this.stride + 1], Fl), uc = [];
                                for (const mc of sc){
                                    const vt = mc * this.stride;
                                    Dl[vt + 4] === le1 && uc.push(Dl[vt + 5] > 1 ? w(Dl, vt, this.clusterProps) : this.points[Dl[vt + 3]]);
                                }
                                if (0 === uc.length) throw new Error(ls);
                                return uc;
                            }
                            getLeaves(le1, vt, bt) {
                                const ls = [];
                                return this._appendLeaves(ls, le1, vt = vt || 10, bt = bt || 0, 0), ls;
                            }
                            getTile(le1, vt, bt) {
                                const ls = this.trees[this._limitZoom(le1)], ho = Math.pow(2, le1), { extent: Dl, radius: Fl } = this.options, sc = Fl / Dl, uc = (bt - sc) / ho, mc = (bt + 1 + sc) / ho, gc = {
                                    features: []
                                };
                                return this._addTileFeatures(ls.range((vt - sc) / ho, uc, (vt + 1 + sc) / ho, mc), ls.data, vt, bt, ho, gc), 0 === vt && this._addTileFeatures(ls.range(1 - sc / ho, uc, 1, mc), ls.data, ho, bt, ho, gc), vt === ho - 1 && this._addTileFeatures(ls.range(0, uc, sc / ho, mc), ls.data, -1, bt, ho, gc), gc.features.length ? gc : null;
                            }
                            getClusterExpansionZoom(le1) {
                                let vt = this._getOriginZoom(le1) - 1;
                                for(; vt <= this.options.maxZoom;){
                                    const bt = this.getChildren(le1);
                                    if (vt++, 1 !== bt.length) break;
                                    le1 = bt[0].properties.cluster_id;
                                }
                                return vt;
                            }
                            _appendLeaves(le1, vt, bt, ls, ho) {
                                const Dl = this.getChildren(vt);
                                for (const Fl of Dl){
                                    const vt = Fl.properties;
                                    if (vt && vt.cluster ? ho + vt.point_count <= ls ? ho += vt.point_count : ho = this._appendLeaves(le1, vt.cluster_id, bt, ls, ho) : ho < ls ? ho++ : le1.push(Fl), le1.length === bt) break;
                                }
                                return ho;
                            }
                            _createTree(vt) {
                                const bt = new le1.aT(vt.length / this.stride | 0, this.options.nodeSize, Float32Array);
                                for(let le1 = 0; le1 < vt.length; le1 += this.stride)bt.add(vt[le1], vt[le1 + 1]);
                                return bt.finish(), bt.data = vt, bt;
                            }
                            _addTileFeatures(le1, vt, bt, ls, ho, Dl) {
                                for (const Fl of le1){
                                    const le1 = Fl * this.stride, sc = vt[le1 + 5] > 1;
                                    let uc, mc, gc;
                                    if (sc) uc = _(vt, le1, this.clusterProps), mc = vt[le1], gc = vt[le1 + 1];
                                    else {
                                        const bt = this.points[vt[le1 + 3]];
                                        uc = bt.properties;
                                        const [ls, ho] = bt.geometry.coordinates;
                                        mc = b(ls), gc = S(ho);
                                    }
                                    const Ac = {
                                        type: 1,
                                        geometry: [
                                            [
                                                Math.round(this.options.extent * (mc * ho - bt)),
                                                Math.round(this.options.extent * (gc * ho - ls))
                                            ]
                                        ],
                                        tags: uc
                                    };
                                    let Ec;
                                    Ec = sc || this.options.generateId ? vt[le1 + 3] : this.points[vt[le1 + 3]].id, void 0 !== Ec && (Ac.id = Ec), Dl.features.push(Ac);
                                }
                            }
                            _limitZoom(le1) {
                                return Math.max(this.options.minZoom, Math.min(Math.floor(+le1), this.options.maxZoom + 1));
                            }
                            _cluster(le1, vt) {
                                const { radius: bt, extent: ls, reduce: ho, minPoints: Dl } = this.options, Fl = bt / (ls * Math.pow(2, vt)), sc = le1.data, uc = [], mc = this.stride;
                                for(let gc = 0; gc < sc.length; gc += mc){
                                    if (sc[gc + 2] <= vt) continue;
                                    sc[gc + 2] = vt;
                                    const bt = sc[gc], ls = sc[gc + 1], Ac = le1.within(sc[gc], sc[gc + 1], Fl), Ec = sc[gc + 5];
                                    let kc = Ec;
                                    for (const le1 of Ac){
                                        const bt = le1 * mc;
                                        sc[bt + 2] > vt && (kc += sc[bt + 5]);
                                    }
                                    if (kc > Ec && kc >= Dl) {
                                        let le1, Dl = bt * Ec, Fl = ls * Ec, du = -1;
                                        const _u = (gc / mc << 5) + (vt + 1) + this.points.length;
                                        for (const bt of Ac){
                                            const ls = bt * mc;
                                            if (sc[ls + 2] <= vt) continue;
                                            sc[ls + 2] = vt;
                                            const uc = sc[ls + 5];
                                            Dl += sc[ls] * uc, Fl += sc[ls + 1] * uc, sc[ls + 4] = _u, ho && (le1 || (le1 = this._map(sc, gc, !0), du = this.clusterProps.length, this.clusterProps.push(le1)), ho(le1, this._map(sc, ls)));
                                        }
                                        sc[gc + 4] = _u, uc.push(Dl / kc, Fl / kc, 1 / 0, _u, -1, kc), ho && uc.push(du);
                                    } else {
                                        for(let le1 = 0; le1 < mc; le1++)uc.push(sc[gc + le1]);
                                        if (kc > 1) for (const le1 of Ac){
                                            const bt = le1 * mc;
                                            if (!(sc[bt + 2] <= vt)) {
                                                sc[bt + 2] = vt;
                                                for(let le1 = 0; le1 < mc; le1++)uc.push(sc[bt + le1]);
                                            }
                                        }
                                    }
                                }
                                return uc;
                            }
                            _getOriginId(le1) {
                                return le1 - this.points.length >> 5;
                            }
                            _getOriginZoom(le1) {
                                return (le1 - this.points.length) % 32;
                            }
                            _map(le1, vt, bt) {
                                if (le1[vt + 5] > 1) {
                                    const ls = this.clusterProps[le1[vt + 6]];
                                    return bt ? Object.assign({}, ls) : ls;
                                }
                                const ls = this.points[le1[vt + 3]].properties, ho = this.options.map(ls);
                                return bt && ho === ls ? Object.assign({}, ho) : ho;
                            }
                        }
                        function w(le1, vt, bt) {
                            var ls;
                            return {
                                type: "Feature",
                                id: le1[vt + 3],
                                properties: _(le1, vt, bt),
                                geometry: {
                                    type: "Point",
                                    coordinates: [
                                        (ls = le1[vt], 360 * (ls - .5)),
                                        M(le1[vt + 1])
                                    ]
                                }
                            };
                        }
                        function _(le1, vt, bt) {
                            const ls = le1[vt + 5], ho = ls >= 1e4 ? `${Math.round(ls / 1e3)}k` : ls >= 1e3 ? Math.round(ls / 100) / 10 + "k" : ls, Dl = le1[vt + 6], Fl = -1 === Dl ? {} : Object.assign({}, bt[Dl]);
                            return Object.assign(Fl, {
                                cluster: !0,
                                cluster_id: le1[vt + 3],
                                point_count: ls,
                                point_count_abbreviated: ho
                            });
                        }
                        function b(le1) {
                            return le1 / 360 + .5;
                        }
                        function S(le1) {
                            const vt = Math.sin(le1 * Math.PI / 180), bt = .5 - .25 * Math.log((1 + vt) / (1 - vt)) / Math.PI;
                            return bt < 0 ? 0 : bt > 1 ? 1 : bt;
                        }
                        function M(le1) {
                            const vt = (180 - 360 * le1) * Math.PI / 180;
                            return 360 * Math.atan(Math.exp(vt)) / Math.PI - 90;
                        }
                        function I(le1, vt, bt, ls) {
                            let ho = ls;
                            const Dl = vt + (bt - vt >> 1);
                            let Fl, sc = bt - vt;
                            const uc = le1[vt], mc = le1[vt + 1], gc = le1[bt], Ac = le1[bt + 1];
                            for(let Ec = vt + 3; Ec < bt; Ec += 3){
                                const vt = P(le1[Ec], le1[Ec + 1], uc, mc, gc, Ac);
                                if (vt > ho) Fl = Ec, ho = vt;
                                else if (vt === ho) {
                                    const le1 = Math.abs(Ec - Dl);
                                    le1 < sc && (Fl = Ec, sc = le1);
                                }
                            }
                            ho > ls && (Fl - vt > 3 && I(le1, vt, Fl, ls), le1[Fl + 2] = ho, bt - Fl > 3 && I(le1, Fl, bt, ls));
                        }
                        function P(le1, vt, bt, ls, ho, Dl) {
                            let Fl = ho - bt, sc = Dl - ls;
                            if (0 !== Fl || 0 !== sc) {
                                const uc = ((le1 - bt) * Fl + (vt - ls) * sc) / (Fl * Fl + sc * sc);
                                uc > 1 ? (bt = ho, ls = Dl) : uc > 0 && (bt += Fl * uc, ls += sc * uc);
                            }
                            return Fl = le1 - bt, sc = vt - ls, Fl * Fl + sc * sc;
                        }
                        function k(le1, vt, bt, ls) {
                            const ho = {
                                type: vt,
                                geom: bt
                            }, Dl = {
                                id: null == le1 ? null : le1,
                                type: ho.type,
                                geometry: ho.geom,
                                tags: ls,
                                minX: 1 / 0,
                                minY: 1 / 0,
                                maxX: -1 / 0,
                                maxY: -1 / 0
                            };
                            switch(ho.type){
                                case "Point":
                                case "MultiPoint":
                                case "LineString":
                                    T(Dl, ho.geom);
                                    break;
                                case "Polygon":
                                    T(Dl, ho.geom[0]);
                                    break;
                                case "MultiLineString":
                                    for (const le1 of ho.geom)T(Dl, le1);
                                    break;
                                case "MultiPolygon":
                                    for (const le1 of ho.geom)T(Dl, le1[0]);
                            }
                            return Dl;
                        }
                        function T(le1, vt) {
                            for(let bt = 0; bt < vt.length; bt += 3)le1.minX = Math.min(le1.minX, vt[bt]), le1.minY = Math.min(le1.minY, vt[bt + 1]), le1.maxX = Math.max(le1.maxX, vt[bt]), le1.maxY = Math.max(le1.maxY, vt[bt + 1]);
                        }
                        function D(le1, vt) {
                            const bt = [];
                            switch(le1.type){
                                case "FeatureCollection":
                                    for(let ls = 0; ls < le1.features.length; ls++)C(bt, le1.features[ls], vt, ls);
                                    break;
                                case "Feature":
                                    C(bt, le1, vt);
                                    break;
                                default:
                                    C(bt, {
                                        geometry: le1,
                                        properties: void 0
                                    }, vt);
                            }
                            return bt;
                        }
                        function C(le1, vt, bt, ls) {
                            if (!vt.geometry) return;
                            if ("GeometryCollection" === vt.geometry.type) {
                                for (const ho of vt.geometry.geometries)C(le1, {
                                    id: vt.id,
                                    geometry: ho,
                                    properties: vt.properties
                                }, bt, ls);
                                return;
                            }
                            const ho = vt.geometry.coordinates;
                            if (!ho?.length) return;
                            const Dl = Math.pow(bt.tolerance / ((1 << bt.maxZoom) * bt.extent), 2);
                            let Fl = vt.id;
                            switch(bt.promoteId ? Fl = vt.properties?.[bt.promoteId] : bt.generateId && (Fl = ls || 0), vt.geometry.type){
                                case "Point":
                                    {
                                        const bt = [];
                                        return O(vt.geometry.coordinates, bt), void le1.push(k(Fl, vt.geometry.type, bt, vt.properties));
                                    }
                                case "MultiPoint":
                                    {
                                        const bt = [];
                                        for (const le1 of vt.geometry.coordinates)O(le1, bt);
                                        return void le1.push(k(Fl, vt.geometry.type, bt, vt.properties));
                                    }
                                case "LineString":
                                    {
                                        const bt = [];
                                        return z(vt.geometry.coordinates, bt, Dl, !1), void le1.push(k(Fl, vt.geometry.type, bt, vt.properties));
                                    }
                                case "MultiLineString":
                                    {
                                        if (bt.lineMetrics) {
                                            for (const bt of vt.geometry.coordinates){
                                                const ls = [];
                                                z(bt, ls, Dl, !1), le1.push(k(Fl, "LineString", ls, vt.properties));
                                            }
                                            return;
                                        }
                                        const ls = [];
                                        return L1(vt.geometry.coordinates, ls, Dl, !1), void le1.push(k(Fl, vt.geometry.type, ls, vt.properties));
                                    }
                                case "Polygon":
                                    {
                                        const bt = [];
                                        return L1(vt.geometry.coordinates, bt, Dl, !0), void le1.push(k(Fl, vt.geometry.type, bt, vt.properties));
                                    }
                                case "MultiPolygon":
                                    {
                                        const bt = [];
                                        for (const le1 of vt.geometry.coordinates){
                                            const vt = [];
                                            L1(le1, vt, Dl, !0), bt.push(vt);
                                        }
                                        return void le1.push(k(Fl, vt.geometry.type, bt, vt.properties));
                                    }
                                default:
                                    throw new Error("Input data is not a valid GeoJSON object.");
                            }
                        }
                        function O(le1, vt) {
                            vt.push(F(le1[0]), A(le1[1]), 0);
                        }
                        function z(le1, vt, bt, ls) {
                            let ho, Dl, Fl = 0;
                            for(let uc = 0; uc < le1.length; uc++){
                                const bt = F(le1[uc][0]), sc = A(le1[uc][1]);
                                vt.push(bt, sc, 0), uc > 0 && (Fl += ls ? (ho * sc - bt * Dl) / 2 : Math.sqrt(Math.pow(bt - ho, 2) + Math.pow(sc - Dl, 2))), ho = bt, Dl = sc;
                            }
                            const sc = vt.length - 3;
                            vt[2] = 1, bt > 0 && I(vt, 0, sc, bt), vt[sc + 2] = 1, vt.size = Math.abs(Fl), vt.start = 0, vt.end = vt.size;
                        }
                        function L1(le1, vt, bt, ls) {
                            for(let ho = 0; ho < le1.length; ho++){
                                const Dl = [];
                                z(le1[ho], Dl, bt, ls), vt.push(Dl);
                            }
                        }
                        function F(le1) {
                            return le1 / 360 + .5;
                        }
                        function A(le1) {
                            const vt = Math.sin(le1 * Math.PI / 180), bt = .5 - .25 * Math.log((1 + vt) / (1 - vt)) / Math.PI;
                            return bt < 0 ? 0 : bt > 1 ? 1 : bt;
                        }
                        function G(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            if (ls /= vt, Dl >= (bt /= vt) && Fl < ls) return le1;
                            if (Fl < bt || Dl >= ls) return null;
                            const uc = [];
                            for (const mc of le1){
                                const le1 = 0 === ho ? mc.minX : mc.minY, vt = 0 === ho ? mc.maxX : mc.maxY;
                                if (le1 >= bt && vt < ls) uc.push(mc);
                                else if (!(vt < bt || le1 >= ls)) switch(mc.type){
                                    case "Point":
                                    case "MultiPoint":
                                        {
                                            const le1 = [];
                                            if (Z(mc.geometry, le1, bt, ls, ho), !le1.length) continue;
                                            uc.push(k(mc.id, 3 === le1.length ? "Point" : "MultiPoint", le1, mc.tags));
                                            continue;
                                        }
                                    case "LineString":
                                        {
                                            const le1 = [];
                                            if (E(mc.geometry, le1, bt, ls, ho, !1, sc.lineMetrics), !le1.length) continue;
                                            if (sc.lineMetrics) {
                                                for (const vt of le1)uc.push(k(mc.id, mc.type, vt, mc.tags));
                                                continue;
                                            }
                                            if (le1.length > 1) {
                                                uc.push(k(mc.id, "MultiLineString", le1, mc.tags));
                                                continue;
                                            }
                                            uc.push(k(mc.id, mc.type, le1[0], mc.tags));
                                            continue;
                                        }
                                    case "MultiLineString":
                                        {
                                            const le1 = [];
                                            if (Y(mc.geometry, le1, bt, ls, ho, !1), !le1.length) continue;
                                            if (1 === le1.length) {
                                                uc.push(k(mc.id, "LineString", le1[0], mc.tags));
                                                continue;
                                            }
                                            uc.push(k(mc.id, mc.type, le1, mc.tags));
                                            continue;
                                        }
                                    case "Polygon":
                                        {
                                            const le1 = [];
                                            if (Y(mc.geometry, le1, bt, ls, ho, !0), !le1.length) continue;
                                            uc.push(k(mc.id, mc.type, le1, mc.tags));
                                            continue;
                                        }
                                    case "MultiPolygon":
                                        {
                                            const le1 = [];
                                            for (const vt of mc.geometry){
                                                const Dl = [];
                                                Y(vt, Dl, bt, ls, ho, !0), Dl.length && le1.push(Dl);
                                            }
                                            if (!le1.length) continue;
                                            uc.push(k(mc.id, mc.type, le1, mc.tags));
                                            continue;
                                        }
                                }
                            }
                            return uc.length ? uc : null;
                        }
                        function Z(le1, vt, bt, ls, ho) {
                            for(let Dl = 0; Dl < le1.length; Dl += 3){
                                const Fl = le1[Dl + ho];
                                Fl >= bt && Fl <= ls && j(vt, le1[Dl], le1[Dl + 1], le1[Dl + 2]);
                            }
                        }
                        function E(le1, vt, bt, ls, ho, Dl, Fl) {
                            let sc = R(le1);
                            const uc = 0 === ho ? N : W;
                            let mc, gc, Ac = le1.start;
                            for(let Md = 0; Md < le1.length - 3; Md += 3){
                                const Ec = le1[Md], kc = le1[Md + 1], du = le1[Md + 2], _u = le1[Md + 3], Ld = le1[Md + 4], Nd = 0 === ho ? Ec : kc, Rd = 0 === ho ? _u : Ld;
                                let Od = !1;
                                Fl && (mc = Math.sqrt(Math.pow(Ec - _u, 2) + Math.pow(kc - Ld, 2))), Nd < bt ? Rd > bt && (gc = uc(sc, Ec, kc, _u, Ld, bt), Fl && (sc.start = Ac + mc * gc)) : Nd > ls ? Rd < ls && (gc = uc(sc, Ec, kc, _u, Ld, ls), Fl && (sc.start = Ac + mc * gc)) : j(sc, Ec, kc, du), Rd < bt && Nd >= bt && (gc = uc(sc, Ec, kc, _u, Ld, bt), Od = !0), Rd > ls && Nd <= ls && (gc = uc(sc, Ec, kc, _u, Ld, ls), Od = !0), !Dl && Od && (Fl && (sc.end = Ac + mc * gc), vt.push(sc), sc = R(le1)), Fl && (Ac += mc);
                            }
                            let Ec = le1.length - 3;
                            const kc = le1[Ec], du = le1[Ec + 1], _u = 0 === ho ? kc : du;
                            _u >= bt && _u <= ls && j(sc, kc, du, le1[Ec + 2]), Ec = sc.length - 3, Dl && Ec >= 3 && (sc[Ec] !== sc[0] || sc[Ec + 1] !== sc[1]) && j(sc, sc[0], sc[1], sc[2]), sc.length && vt.push(sc);
                        }
                        function R(le1) {
                            const vt = [];
                            return vt.size = le1.size, vt.start = le1.start, vt.end = le1.end, vt;
                        }
                        function Y(le1, vt, bt, ls, ho, Dl) {
                            for (const Fl of le1)E(Fl, vt, bt, ls, ho, Dl, !1);
                        }
                        function j(le1, vt, bt, ls) {
                            le1.push(vt, bt, ls);
                        }
                        function N(le1, vt, bt, ls, ho, Dl) {
                            const Fl = (Dl - vt) / (ls - vt);
                            return j(le1, Dl, bt + (ho - bt) * Fl, 1), Fl;
                        }
                        function W(le1, vt, bt, ls, ho, Dl) {
                            const Fl = (Dl - bt) / (ho - bt);
                            return j(le1, vt + (ls - vt) * Fl, Dl, 1), Fl;
                        }
                        function J(le1, vt) {
                            const bt = vt.buffer / vt.extent;
                            let ls = le1;
                            const ho = G(le1, 1, -1 - bt, bt, 0, -1, 2, vt), Dl = G(le1, 1, 1 - bt, 2 + bt, 0, -1, 2, vt);
                            return ho || Dl ? (ls = G(le1, 1, -bt, 1 + bt, 0, -1, 2, vt) || [], ho && (ls = X(ho, 1).concat(ls)), Dl && (ls = ls.concat(X(Dl, -1))), ls) : ls;
                        }
                        function X(le1, vt) {
                            const bt = [];
                            for (const ls of le1)switch(ls.type){
                                case "Point":
                                case "MultiPoint":
                                case "LineString":
                                    {
                                        const le1 = q(ls.geometry, vt);
                                        bt.push(k(ls.id, ls.type, le1, ls.tags));
                                        continue;
                                    }
                                case "MultiLineString":
                                case "Polygon":
                                    {
                                        const le1 = [];
                                        for (const bt of ls.geometry)le1.push(q(bt, vt));
                                        bt.push(k(ls.id, ls.type, le1, ls.tags));
                                        continue;
                                    }
                                case "MultiPolygon":
                                    {
                                        const le1 = [];
                                        for (const bt of ls.geometry){
                                            const ls = [];
                                            for (const le1 of bt)ls.push(q(le1, vt));
                                            le1.push(ls);
                                        }
                                        bt.push(k(ls.id, ls.type, le1, ls.tags));
                                        continue;
                                    }
                            }
                            return bt;
                        }
                        function q(le1, vt) {
                            const bt = [];
                            bt.size = le1.size, void 0 !== le1.start && (bt.start = le1.start, bt.end = le1.end);
                            for(let ls = 0; ls < le1.length; ls += 3)bt.push(le1[ls] + vt, le1[ls + 1], le1[ls + 2]);
                            return bt;
                        }
                        function H(le1, vt) {
                            if (le1.transformed) return le1;
                            const bt = 1 << le1.z, ls = le1.x, ho = le1.y;
                            for (const Dl of le1.features){
                                if (1 === Dl.type) {
                                    const le1 = [];
                                    for(let Fl = 0; Fl < Dl.geometry.length; Fl += 2)le1.push($(Dl.geometry[Fl], Dl.geometry[Fl + 1], vt, bt, ls, ho));
                                    Dl.geometry = le1;
                                    continue;
                                }
                                const le1 = [];
                                for (const Fl of Dl.geometry){
                                    const Dl = [];
                                    for(let le1 = 0; le1 < Fl.length; le1 += 2)Dl.push($(Fl[le1], Fl[le1 + 1], vt, bt, ls, ho));
                                    le1.push(Dl);
                                }
                                Dl.geometry = le1;
                            }
                            return le1.transformed = !0, le1;
                        }
                        function $(le1, vt, bt, ls, ho, Dl) {
                            return [
                                Math.round(bt * (le1 * ls - ho)),
                                Math.round(bt * (vt * ls - Dl))
                            ];
                        }
                        function U(le1, vt, bt, ls, ho) {
                            const Dl = vt === ho.maxZoom ? 0 : ho.tolerance / ((1 << vt) * ho.extent), Fl = {
                                features: [],
                                numPoints: 0,
                                numSimplified: 0,
                                numFeatures: le1.length,
                                source: null,
                                x: bt,
                                y: ls,
                                z: vt,
                                transformed: !1,
                                minX: 2,
                                minY: 1,
                                maxX: -1,
                                maxY: 0
                            };
                            for (const sc of le1)B(Fl, sc, Dl, ho);
                            return Fl;
                        }
                        function B(le1, vt, bt, ls) {
                            le1.minX = Math.min(le1.minX, vt.minX), le1.minY = Math.min(le1.minY, vt.minY), le1.maxX = Math.max(le1.maxX, vt.maxX), le1.maxY = Math.max(le1.maxY, vt.maxY);
                            let ho, Dl = vt.tags || null;
                            switch(vt.type){
                                case "Point":
                                case "MultiPoint":
                                    {
                                        const bt = [];
                                        for(let ls = 0; ls < vt.geometry.length; ls += 3)bt.push(vt.geometry[ls], vt.geometry[ls + 1]), le1.numPoints++, le1.numSimplified++;
                                        if (!bt.length) return;
                                        ho = {
                                            type: 1,
                                            tags: Dl,
                                            geometry: bt
                                        };
                                        break;
                                    }
                                case "LineString":
                                    {
                                        const Fl = [];
                                        if (V(Fl, vt.geometry, le1, bt, !1, !1), !Fl.length) return;
                                        if (ls.lineMetrics) {
                                            Dl = {};
                                            for(const le1 in vt.tags)Dl[le1] = vt.tags[le1];
                                            Dl.mapbox_clip_start = vt.geometry.start / vt.geometry.size, Dl.mapbox_clip_end = vt.geometry.end / vt.geometry.size;
                                        }
                                        ho = {
                                            type: 2,
                                            tags: Dl,
                                            geometry: Fl
                                        };
                                        break;
                                    }
                                case "MultiLineString":
                                case "Polygon":
                                    {
                                        const ls = [];
                                        for(let ho = 0; ho < vt.geometry.length; ho++)V(ls, vt.geometry[ho], le1, bt, "Polygon" === vt.type, 0 === ho);
                                        if (!ls.length) return;
                                        ho = {
                                            type: "Polygon" === vt.type ? 3 : 2,
                                            tags: Dl,
                                            geometry: ls
                                        };
                                        break;
                                    }
                                case "MultiPolygon":
                                    {
                                        const ls = [];
                                        for(let ho = 0; ho < vt.geometry.length; ho++){
                                            const Dl = vt.geometry[ho];
                                            for(let vt = 0; vt < Dl.length; vt++)V(ls, Dl[vt], le1, bt, !0, 0 === vt);
                                        }
                                        if (!ls.length) return;
                                        ho = {
                                            type: 3,
                                            tags: Dl,
                                            geometry: ls
                                        };
                                        break;
                                    }
                            }
                            null !== vt.id && (ho.id = vt.id), le1.features.push(ho);
                        }
                        function V(le1, vt, bt, ls, ho, Dl) {
                            const Fl = ls * ls;
                            if (ls > 0 && vt.size < (ho ? Fl : ls)) return void (bt.numPoints += vt.length / 3);
                            const sc = [];
                            for(let uc = 0; uc < vt.length; uc += 3)(0 === ls || vt[uc + 2] > Fl) && (bt.numSimplified++, sc.push(vt[uc], vt[uc + 1])), bt.numPoints++;
                            ho && function(le1, vt) {
                                let bt = 0;
                                for(let ls = 0, ho = le1.length, Dl = ho - 2; ls < ho; Dl = ls, ls += 2)bt += (le1[ls] - le1[Dl]) * (le1[ls + 1] + le1[Dl + 1]);
                                if (bt > 0 === vt) for(let ls = 0, ho = le1.length; ls < ho / 2; ls += 2){
                                    const vt = le1[ls], bt = le1[ls + 1];
                                    le1[ls] = le1[ho - 2 - ls], le1[ls + 1] = le1[ho - 1 - ls], le1[ho - 2 - ls] = vt, le1[ho - 1 - ls] = bt;
                                }
                            }(sc, Dl), le1.push(sc);
                        }
                        function K(le1, vt, bt) {
                            const ls = !!vt.newGeometry, ho = vt.removeAllProperties || vt.removeProperties?.length > 0 || vt.addOrUpdateProperties?.length > 0;
                            if (ls) {
                                let ls = D({
                                    type: "FeatureCollection",
                                    features: [
                                        {
                                            type: "Feature",
                                            id: le1.id,
                                            geometry: vt.newGeometry,
                                            properties: ho ? Q(le1.tags, vt) : le1.tags
                                        }
                                    ]
                                }, bt);
                                return ls = J(ls, bt), ls[0];
                            }
                            if (ho) {
                                const bt = {
                                    ...le1
                                };
                                return bt.tags = Q(bt.tags, vt), bt;
                            }
                            return null;
                        }
                        function Q(le1, vt) {
                            if (vt.removeAllProperties) return {};
                            const bt = {
                                ...le1 || {}
                            };
                            if (vt.removeProperties) for (const ls of vt.removeProperties)delete bt[ls];
                            if (vt.addOrUpdateProperties) for (const { key: ls, value: ho } of vt.addOrUpdateProperties)bt[ls] = ho;
                            return bt;
                        }
                        const uc = {
                            maxZoom: 14,
                            indexMaxZoom: 5,
                            indexMaxPoints: 1e5,
                            tolerance: 3,
                            extent: 4096,
                            buffer: 64,
                            lineMetrics: !1,
                            promoteId: null,
                            generateId: !1,
                            updateable: !1,
                            debug: 0
                        };
                        class te {
                            options;
                            tiles;
                            tileCoords;
                            stats = {};
                            total = 0;
                            source;
                            constructor(le1, vt){
                                const bt = (vt = this.options = Object.assign({}, uc, vt)).debug;
                                if (bt && console.time("preprocess data"), vt.maxZoom < 0 || vt.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                                if (vt.promoteId && vt.generateId) throw new Error("promoteId and generateId cannot be used together.");
                                let ls = D(le1, vt);
                                this.tiles = {}, this.tileCoords = [], bt && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", vt.indexMaxZoom, vt.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), ls = J(ls, vt), ls.length && this.splitTile(ls, 0, 0, 0), vt.updateable && (this.source = ls), bt && (ls.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                            }
                            splitTile(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = [
                                    le1,
                                    vt,
                                    bt,
                                    ls
                                ], uc = this.options, mc = uc.debug;
                                for(; sc.length;){
                                    ls = sc.pop(), bt = sc.pop(), vt = sc.pop(), le1 = sc.pop();
                                    const gc = 1 << vt, Ac = oe(vt, bt, ls);
                                    let Ec = this.tiles[Ac];
                                    if (!Ec && (mc > 1 && console.time("creation"), Ec = this.tiles[Ac] = U(le1, vt, bt, ls, uc), this.tileCoords.push({
                                        z: vt,
                                        x: bt,
                                        y: ls,
                                        id: Ac
                                    }), mc)) {
                                        mc > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", vt, bt, ls, Ec.numFeatures, Ec.numPoints, Ec.numSimplified), console.timeEnd("creation"));
                                        const le1 = `z${vt}`;
                                        this.stats[le1] = (this.stats[le1] || 0) + 1, this.total++;
                                    }
                                    if (Ec.source = le1, null == ho) {
                                        if (vt === uc.indexMaxZoom || Ec.numPoints <= uc.indexMaxPoints) continue;
                                    } else {
                                        if (vt === uc.maxZoom || vt === ho) continue;
                                        if (null != ho) {
                                            const le1 = ho - vt;
                                            if (bt !== Dl >> le1 || ls !== Fl >> le1) continue;
                                        }
                                    }
                                    if (Ec.source = null, !le1.length) continue;
                                    mc > 1 && console.time("clipping");
                                    const kc = .5 * uc.buffer / uc.extent, du = .5 - kc, _u = .5 + kc, Md = 1 + kc;
                                    let Ld = null, Nd = null, Rd = null, Od = null;
                                    const jd = G(le1, gc, bt - kc, bt + _u, 0, Ec.minX, Ec.maxX, uc), Ud = G(le1, gc, bt + du, bt + Md, 0, Ec.minX, Ec.maxX, uc);
                                    jd && (Ld = G(jd, gc, ls - kc, ls + _u, 1, Ec.minY, Ec.maxY, uc), Nd = G(jd, gc, ls + du, ls + Md, 1, Ec.minY, Ec.maxY, uc)), Ud && (Rd = G(Ud, gc, ls - kc, ls + _u, 1, Ec.minY, Ec.maxY, uc), Od = G(Ud, gc, ls + du, ls + Md, 1, Ec.minY, Ec.maxY, uc)), mc > 1 && console.timeEnd("clipping"), sc.push(Ld || [], vt + 1, 2 * bt, 2 * ls), sc.push(Nd || [], vt + 1, 2 * bt, 2 * ls + 1), sc.push(Rd || [], vt + 1, 2 * bt + 1, 2 * ls), sc.push(Od || [], vt + 1, 2 * bt + 1, 2 * ls + 1);
                                }
                            }
                            getTile(le1, vt, bt) {
                                le1 = +le1, vt = +vt, bt = +bt;
                                const ls = this.options, { extent: ho, debug: Dl } = ls;
                                if (le1 < 0 || le1 > 24) return null;
                                const Fl = 1 << le1, sc = oe(le1, vt = vt + Fl & Fl - 1, bt);
                                if (this.tiles[sc]) return H(this.tiles[sc], ho);
                                Dl > 1 && console.log("drilling down to z%d-%d-%d", le1, vt, bt);
                                let uc, mc = le1, gc = vt, Ac = bt;
                                for(; !uc && mc > 0;)mc--, gc >>= 1, Ac >>= 1, uc = this.tiles[oe(mc, gc, Ac)];
                                return uc?.source ? (Dl > 1 && (console.log("found parent tile z%d-%d-%d", mc, gc, Ac), console.time("drilling down")), this.splitTile(uc.source, mc, gc, Ac, le1, vt, bt), Dl > 1 && console.timeEnd("drilling down"), this.tiles[sc] ? H(this.tiles[sc], ho) : null) : null;
                            }
                            invalidateTiles(le1) {
                                const vt = this.options, { debug: bt } = vt;
                                let ls = 1 / 0, ho = -1 / 0, Dl = 1 / 0, Fl = -1 / 0;
                                for (const mc of le1)ls = Math.min(ls, mc.minX), ho = Math.max(ho, mc.maxX), Dl = Math.min(Dl, mc.minY), Fl = Math.max(Fl, mc.maxY);
                                const sc = vt.buffer / vt.extent, uc = new Set;
                                for(const mc in this.tiles){
                                    const vt = this.tiles[mc], gc = 1 << vt.z, Ac = (vt.x - sc) / gc, Ec = (vt.x + 1 + sc) / gc, kc = (vt.y - sc) / gc, du = (vt.y + 1 + sc) / gc;
                                    if (ho < Ac || ls >= Ec || Fl < kc || Dl >= du) continue;
                                    let _u = !1;
                                    for (const bt of le1)if (bt.maxX >= Ac && bt.minX < Ec && bt.maxY >= kc && bt.minY < du) {
                                        _u = !0;
                                        break;
                                    }
                                    if (_u) {
                                        if (bt) {
                                            bt > 1 && console.log("invalidate tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", vt.z, vt.x, vt.y, vt.numFeatures, vt.numPoints, vt.numSimplified);
                                            const le1 = `z${vt.z}`;
                                            this.stats[le1] = (this.stats[le1] || 0) - 1, this.total--;
                                        }
                                        delete this.tiles[mc], uc.add(mc);
                                    }
                                }
                                uc.size && (this.tileCoords = this.tileCoords.filter((le1)=>!uc.has(le1.id)));
                            }
                            updateData(le1) {
                                const vt = this.options, bt = vt.debug;
                                if (!vt.updateable) throw new Error("to update tile geojson `updateable` option must be set to true");
                                const { affected: ls, source: ho } = function(le1, vt, bt) {
                                    const ls = function(le1) {
                                        return le1 ? {
                                            removeAll: le1.removeAll,
                                            remove: new Set(le1.remove || []),
                                            add: new Map(le1.add?.map((le1)=>[
                                                    le1.id,
                                                    le1
                                                ])),
                                            update: new Map(le1.update?.map((le1)=>[
                                                    le1.id,
                                                    le1
                                                ]))
                                        } : {
                                            remove: new Set,
                                            add: new Map,
                                            update: new Map
                                        };
                                    }(vt);
                                    let ho = [];
                                    if (ls.removeAll && (ho = le1, le1 = []), ls.remove.size || ls.add.size) {
                                        const vt = [];
                                        for (const bt of le1){
                                            const { id: le1 } = bt;
                                            (ls.remove.has(le1) || ls.add.has(le1)) && vt.push(bt);
                                        }
                                        if (vt.length) {
                                            ho.push(...vt);
                                            const bt = new Set(vt.map((le1)=>le1.id));
                                            le1 = le1.filter((le1)=>!bt.has(le1.id));
                                        }
                                        if (ls.add.size) {
                                            let vt = D({
                                                type: "FeatureCollection",
                                                features: Array.from(ls.add.values())
                                            }, bt);
                                            vt = J(vt, bt), ho.push(...vt), le1.push(...vt);
                                        }
                                    }
                                    if (ls.update.size) for (const [Dl, Fl] of ls.update){
                                        const vt = le1.findIndex((le1)=>le1.id === Dl);
                                        if (-1 === vt) continue;
                                        const ls = le1[vt], sc = K(ls, Fl, bt);
                                        sc && (ho.push(ls, sc), le1[vt] = sc);
                                    }
                                    return {
                                        affected: ho,
                                        source: le1
                                    };
                                }(this.source, le1, vt);
                                if (!ls.length) return;
                                this.source = ho, bt > 1 && (console.log("invalidating tiles"), console.time("invalidating")), this.invalidateTiles(ls), bt > 1 && console.timeEnd("invalidating");
                                const [Dl, Fl, sc] = [
                                    0,
                                    0,
                                    0
                                ], uc = U(this.source, Dl, Fl, sc, this.options);
                                uc.source = this.source;
                                const mc = oe(Dl, Fl, sc);
                                if (this.tiles[mc] = uc, this.tileCoords.push({
                                    z: Dl,
                                    x: Fl,
                                    y: sc,
                                    id: mc
                                }), bt) {
                                    const le1 = `z${Dl}`;
                                    this.stats[le1] = (this.stats[le1] || 0) + 1, this.total++;
                                }
                            }
                        }
                        function oe(le1, vt, bt) {
                            return 32 * ((1 << le1) * bt + vt) + le1;
                        }
                        class se extends h {
                            constructor(le1, vt, bt, ls = ie){
                                super(le1, vt, bt), this._dataUpdateable = new Map, this._createGeoJSONIndex = ls;
                            }
                            loadVectorTile(vt, bt) {
                                return le1._(this, void 0, void 0, function*() {
                                    const bt = vt.tileID.canonical;
                                    if (!this._geoJSONIndex) throw new Error("Unable to parse the data into a cluster or geojson");
                                    const ls = this._geoJSONIndex.getTile(bt.z, bt.x, bt.y);
                                    return ls ? c(new le1.d3(ls.features, {
                                        version: 2,
                                        extent: le1.a5
                                    })) : null;
                                });
                            }
                            loadData(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    var bt;
                                    null === (bt = this._pendingRequest) || void 0 === bt || bt.abort();
                                    const ls = this._startPerformance(vt);
                                    this._pendingRequest = new AbortController;
                                    try {
                                        (!this._pendingData || vt.request || vt.data || vt.dataDiff) && (this._pendingData = this.loadAndProcessGeoJSON(vt, this._pendingRequest));
                                        const le1 = yield this._pendingData;
                                        this._geoJSONIndex = this._createGeoJSONIndex(le1, vt), this.loaded = {};
                                        const bt = {};
                                        return vt.request && (bt.data = le1), this._finishPerformance(ls, vt, bt), bt;
                                    } catch (vt) {
                                        if (delete this._pendingRequest, le1.Z(vt)) return {
                                            abandoned: !0
                                        };
                                        throw vt;
                                    }
                                });
                            }
                            _startPerformance(vt) {
                                var bt;
                                if (null === (bt = null == vt ? void 0 : vt.request) || void 0 === bt ? void 0 : bt.collectResourceTiming) return new le1.c$(vt.request);
                            }
                            _finishPerformance(le1, vt, bt) {
                                if (!le1) return;
                                const ls = le1.finish();
                                ls && (bt.resourceTiming = {}, bt.resourceTiming[vt.source] = JSON.parse(JSON.stringify(ls)));
                            }
                            getData() {
                                return le1._(this, void 0, void 0, function*() {
                                    return this._pendingData;
                                });
                            }
                            reloadTile(le1) {
                                const vt = this.loaded;
                                return vt && vt[le1.uid] ? super.reloadTile(le1) : this.loadTile(le1);
                            }
                            loadAndProcessGeoJSON(vt, bt) {
                                return le1._(this, void 0, void 0, function*() {
                                    let le1;
                                    if (vt.request ? le1 = yield this.loadGeoJSONFromUrl(vt.request, vt.promoteId, bt) : vt.data ? le1 = this._loadGeoJSONFromObject(vt.data, vt.promoteId) : vt.dataDiff && (le1 = this._loadGeoJSONFromDiff(vt.dataDiff, vt.promoteId, vt.source)), delete this._pendingRequest, "object" != typeof le1) throw new Error(`Input data given to '${vt.source}' is not a valid GeoJSON object.`);
                                    return ho(le1, !0), vt.filter && (le1 = this._filterGeoJSON(le1, vt.filter)), le1;
                                });
                            }
                            loadGeoJSONFromUrl(vt, bt, ls) {
                                return le1._(this, void 0, void 0, function*() {
                                    const ho = yield le1.j(vt, ls);
                                    return this._dataUpdateable = le1.a7(ho.data, bt), ho.data;
                                });
                            }
                            _loadGeoJSONFromObject(vt, bt) {
                                return this._dataUpdateable = le1.a7(vt, bt), vt;
                            }
                            _loadGeoJSONFromDiff(vt, bt, ls) {
                                if (!this._dataUpdateable) throw new Error(`Cannot update existing geojson data in ${ls}`);
                                le1.a8(this._dataUpdateable, vt, bt);
                                const ho = Array.from(this._dataUpdateable.values());
                                return this._toFeatureCollection(ho);
                            }
                            _filterGeoJSON(vt, bt) {
                                const ls = le1.d4(bt, {
                                    type: "boolean",
                                    "property-type": "data-driven",
                                    overridable: !1,
                                    transition: !1
                                });
                                if ("error" === ls.result) throw new Error(ls.value.map((le1)=>`${le1.key}: ${le1.message}`).join(", "));
                                const ho = vt.features.filter((le1)=>ls.value.evaluate({
                                        zoom: 0
                                    }, le1));
                                return this._toFeatureCollection(ho);
                            }
                            _toFeatureCollection(le1) {
                                return {
                                    type: "FeatureCollection",
                                    features: le1
                                };
                            }
                            removeSource(vt) {
                                return le1._(this, void 0, void 0, function*() {
                                    this._pendingRequest && this._pendingRequest.abort();
                                });
                            }
                            getClusterExpansionZoom(le1) {
                                return this._geoJSONIndex.getClusterExpansionZoom(le1.clusterId);
                            }
                            getClusterChildren(le1) {
                                return this._geoJSONIndex.getChildren(le1.clusterId);
                            }
                            getClusterLeaves(le1) {
                                return this._geoJSONIndex.getLeaves(le1.clusterId, le1.limit, le1.offset);
                            }
                        }
                        function ie(vt, bt) {
                            return bt.cluster ? new x(function({ superclusterOptions: vt, clusterProperties: bt }) {
                                if (!bt || !vt) return vt;
                                const ls = {}, ho = {}, Dl = {
                                    accumulated: null,
                                    zoom: 0
                                }, Fl = {
                                    properties: null
                                }, sc = Object.keys(bt);
                                for (const uc of sc){
                                    const [vt, Dl] = bt[uc], Fl = le1.d4(Dl), sc = le1.d4("string" == typeof vt ? [
                                        vt,
                                        [
                                            "accumulated"
                                        ],
                                        [
                                            "get",
                                            uc
                                        ]
                                    ] : vt);
                                    ls[uc] = Fl.value, ho[uc] = sc.value;
                                }
                                return vt.map = (le1)=>{
                                    Fl.properties = le1;
                                    const vt = {};
                                    for (const bt of sc)vt[bt] = ls[bt].evaluate(Dl, Fl);
                                    return vt;
                                }, vt.reduce = (le1, vt)=>{
                                    Fl.properties = vt;
                                    for (const bt of sc)Dl.accumulated = le1[bt], le1[bt] = ho[bt].evaluate(Dl, Fl);
                                }, vt;
                            }(bt)).load(vt.features) : function(le1, vt) {
                                return new te(le1, vt);
                            }(vt, bt.geojsonVtOptions);
                        }
                        class ne {
                            constructor(vt){
                                this.self = vt, this.actor = new le1.L(vt), this.layerIndexes = {}, this.availableImages = {}, this.workerSources = {}, this.demWorkerSources = {}, this.externalWorkerSourceTypes = {}, this.globalStates = new Map, this.self.registerWorkerSource = (le1, vt)=>{
                                    if (this.externalWorkerSourceTypes[le1]) throw new Error(`Worker source with name "${le1}" already registered.`);
                                    this.externalWorkerSourceTypes[le1] = vt;
                                }, this.self.addProtocol = le1.cK, this.self.removeProtocol = le1.cL, this.self.registerRTLTextPlugin = (vt)=>{
                                    le1.d5.setMethods(vt);
                                }, this.actor.registerMessageHandler("LDT", (le1, vt)=>this._getDEMWorkerSource(le1, vt.source).loadTile(vt)), this.actor.registerMessageHandler("RDT", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        this._getDEMWorkerSource(vt, bt.source).removeTile(bt);
                                    })), this.actor.registerMessageHandler("GCEZ", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(vt, bt.type, bt.source).getClusterExpansionZoom(bt);
                                    })), this.actor.registerMessageHandler("GCC", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(vt, bt.type, bt.source).getClusterChildren(bt);
                                    })), this.actor.registerMessageHandler("GCL", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        return this._getWorkerSource(vt, bt.type, bt.source).getClusterLeaves(bt);
                                    })), this.actor.registerMessageHandler("LD", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).loadData(vt)), this.actor.registerMessageHandler("GD", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).getData()), this.actor.registerMessageHandler("LT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).loadTile(vt)), this.actor.registerMessageHandler("RT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).reloadTile(vt)), this.actor.registerMessageHandler("AT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).abortTile(vt)), this.actor.registerMessageHandler("RMT", (le1, vt)=>this._getWorkerSource(le1, vt.type, vt.source).removeTile(vt)), this.actor.registerMessageHandler("RS", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        if (!this.workerSources[vt] || !this.workerSources[vt][bt.type] || !this.workerSources[vt][bt.type][bt.source]) return;
                                        const le1 = this.workerSources[vt][bt.type][bt.source];
                                        delete this.workerSources[vt][bt.type][bt.source], void 0 !== le1.removeSource && le1.removeSource(bt);
                                    })), this.actor.registerMessageHandler("RM", (vt)=>le1._(this, void 0, void 0, function*() {
                                        delete this.layerIndexes[vt], delete this.availableImages[vt], delete this.workerSources[vt], delete this.demWorkerSources[vt], this.globalStates.delete(vt);
                                    })), this.actor.registerMessageHandler("SR", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        this.referrer = bt;
                                    })), this.actor.registerMessageHandler("SRPS", (le1, vt)=>this._syncRTLPluginState(le1, vt)), this.actor.registerMessageHandler("IS", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        this.self.importScripts(bt);
                                    })), this.actor.registerMessageHandler("SI", (le1, vt)=>this._setImages(le1, vt)), this.actor.registerMessageHandler("UL", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(vt).update(bt.layers, bt.removedIds, this._getGlobalState(vt));
                                    })), this.actor.registerMessageHandler("UGS", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        const le1 = this._getGlobalState(vt);
                                        for(const vt in bt)le1[vt] = bt[vt];
                                    })), this.actor.registerMessageHandler("SL", (vt, bt)=>le1._(this, void 0, void 0, function*() {
                                        this._getLayerIndex(vt).replace(bt, this._getGlobalState(vt));
                                    }));
                            }
                            _getGlobalState(le1) {
                                let vt = this.globalStates.get(le1);
                                return vt || (vt = {}, this.globalStates.set(le1, vt)), vt;
                            }
                            _setImages(vt, bt) {
                                return le1._(this, void 0, void 0, function*() {
                                    this.availableImages[vt] = bt;
                                    for(const le1 in this.workerSources[vt]){
                                        const ls = this.workerSources[vt][le1];
                                        for(const le1 in ls)ls[le1].availableImages = bt;
                                    }
                                });
                            }
                            _syncRTLPluginState(vt, bt) {
                                return le1._(this, void 0, void 0, function*() {
                                    return yield le1.d5.syncState(bt, this.self.importScripts);
                                });
                            }
                            _getAvailableImages(le1) {
                                let vt = this.availableImages[le1];
                                return vt || (vt = []), vt;
                            }
                            _getLayerIndex(le1) {
                                let vt = this.layerIndexes[le1];
                                return vt || (vt = this.layerIndexes[le1] = new t), vt;
                            }
                            _getWorkerSource(le1, vt, bt) {
                                if (this.workerSources[le1] || (this.workerSources[le1] = {}), this.workerSources[le1][vt] || (this.workerSources[le1][vt] = {}), !this.workerSources[le1][vt][bt]) {
                                    const ls = {
                                        sendAsync: (vt, bt)=>(vt.targetMapId = le1, this.actor.sendAsync(vt, bt))
                                    };
                                    switch(vt){
                                        case "vector":
                                            this.workerSources[le1][vt][bt] = new h(ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                            break;
                                        case "geojson":
                                            this.workerSources[le1][vt][bt] = new se(ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                            break;
                                        default:
                                            this.workerSources[le1][vt][bt] = new this.externalWorkerSourceTypes[vt](ls, this._getLayerIndex(le1), this._getAvailableImages(le1));
                                    }
                                }
                                return this.workerSources[le1][vt][bt];
                            }
                            _getDEMWorkerSource(le1, vt) {
                                return this.demWorkerSources[le1] || (this.demWorkerSources[le1] = {}), this.demWorkerSources[le1][vt] || (this.demWorkerSources[le1][vt] = new u), this.demWorkerSources[le1][vt];
                            }
                        }
                        return le1.i(self) && (self.worker = new ne(self)), ne;
                    }), define("index", [
                        "exports",
                        "./shared"
                    ], function(le1, vt) {
                        var bt = "5.17.0";
                        function a() {
                            var le1 = new vt.A(4);
                            return vt.A != Float32Array && (le1[1] = 0, le1[2] = 0), le1[0] = 1, le1[3] = 1, le1;
                        }
                        let ls, ho, Dl;
                        const Fl = {
                            frame (le1, bt, ls, ho) {
                                const Dl = ho || window, Fl = Dl.requestAnimationFrame((le1)=>{
                                    sc(), bt(le1);
                                }), { unsubscribe: sc } = vt.s(le1.signal, "abort", ()=>{
                                    sc(), Dl.cancelAnimationFrame(Fl), ls(new vt.a(le1.signal.reason));
                                }, !1);
                            },
                            frameAsync (le1, vt) {
                                return new Promise((bt, ls)=>{
                                    this.frame(le1, bt, ls, vt);
                                });
                            },
                            getImageData (le1, vt = 0) {
                                return this.getImageCanvasContext(le1).getImageData(-vt, -vt, le1.width + 2 * vt, le1.height + 2 * vt);
                            },
                            getImageCanvasContext (le1) {
                                const vt = window.document.createElement("canvas"), bt = vt.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                if (!bt) throw new Error("failed to create canvas 2d context");
                                return vt.width = le1.width, vt.height = le1.height, bt.drawImage(le1, 0, 0, le1.width, le1.height), bt;
                            },
                            resolveURL: (le1)=>(ls || (ls = document.createElement("a")), ls.href = le1, ls.href),
                            hardwareConcurrency: "undefined" != typeof navigator && navigator.hardwareConcurrency || 4,
                            get prefersReducedMotion () {
                                return void 0 !== Dl ? Dl : !!matchMedia && (null == ho && (ho = matchMedia("(prefers-reduced-motion: reduce)")), ho.matches);
                            },
                            set prefersReducedMotion (le){
                                Dl = le;
                            }
                        }, sc = new class {
                            constructor(){
                                this._realTime = "undefined" != typeof performance && performance && performance.now ? performance.now.bind(performance) : Date.now.bind(Date), this._frozenAt = null;
                            }
                            getCurrentTime() {
                                return null !== this._frozenAt ? this._frozenAt : this._realTime();
                            }
                            setNow(le1) {
                                this._frozenAt = le1;
                            }
                            restoreNow() {
                                this._frozenAt = null;
                            }
                            isFrozen() {
                                return null !== this._frozenAt;
                            }
                        };
                        function c() {
                            return sc.getCurrentTime();
                        }
                        class h {
                            static testProp(le1) {
                                if (!h.docStyle) return le1[0];
                                for(let vt = 0; vt < le1.length; vt++)if (le1[vt] in h.docStyle) return le1[vt];
                                return le1[0];
                            }
                            static create(le1, vt, bt) {
                                const ls = window.document.createElement(le1);
                                return void 0 !== vt && (ls.className = vt), bt && bt.appendChild(ls), ls;
                            }
                            static createNS(le1, vt) {
                                return window.document.createElementNS(le1, vt);
                            }
                            static disableDrag() {
                                h.docStyle && h.selectProp && (h.userSelect = h.docStyle[h.selectProp], h.docStyle[h.selectProp] = "none");
                            }
                            static enableDrag() {
                                h.docStyle && h.selectProp && (h.docStyle[h.selectProp] = h.userSelect);
                            }
                            static setTransform(le1, vt) {
                                le1.style[h.transformProp] = vt;
                            }
                            static addEventListener(le1, vt, bt, ls = {}) {
                                le1.addEventListener(vt, bt, "passive" in ls ? ls : ls.capture);
                            }
                            static removeEventListener(le1, vt, bt, ls = {}) {
                                le1.removeEventListener(vt, bt, "passive" in ls ? ls : ls.capture);
                            }
                            static suppressClickInternal(le1) {
                                le1.preventDefault(), le1.stopPropagation(), window.removeEventListener("click", h.suppressClickInternal, !0);
                            }
                            static suppressClick() {
                                window.addEventListener("click", h.suppressClickInternal, !0), window.setTimeout(()=>{
                                    window.removeEventListener("click", h.suppressClickInternal, !0);
                                }, 0);
                            }
                            static getScale(le1) {
                                const vt = le1.getBoundingClientRect();
                                return {
                                    x: vt.width / le1.offsetWidth || 1,
                                    y: vt.height / le1.offsetHeight || 1,
                                    boundingClientRect: vt
                                };
                            }
                            static getPoint(le1, bt, ls) {
                                const ho = bt.boundingClientRect;
                                return new vt.P((ls.clientX - ho.left) / bt.x - le1.clientLeft, (ls.clientY - ho.top) / bt.y - le1.clientTop);
                            }
                            static mousePos(le1, vt) {
                                const bt = h.getScale(le1);
                                return h.getPoint(le1, bt, vt);
                            }
                            static touchPos(le1, vt) {
                                const bt = [], ls = h.getScale(le1);
                                for(let ho = 0; ho < vt.length; ho++)bt.push(h.getPoint(le1, ls, vt[ho]));
                                return bt;
                            }
                            static mouseButton(le1) {
                                return le1.button;
                            }
                            static remove(le1) {
                                le1.parentNode && le1.parentNode.removeChild(le1);
                            }
                            static sanitize(le1) {
                                const vt = (new DOMParser).parseFromString(le1, "text/html").body || document.createElement("body"), bt = vt.querySelectorAll("script");
                                for (const ls of bt)ls.remove();
                                return h.clean(vt), vt.innerHTML;
                            }
                            static isPossiblyDangerous(le1, vt) {
                                const bt = vt.replace(/\s+/g, "").toLowerCase();
                                return !(![
                                    "src",
                                    "href",
                                    "xlink:href"
                                ].includes(le1) || !bt.includes("javascript:") && !bt.includes("data:")) || !!le1.startsWith("on") || void 0;
                            }
                            static clean(le1) {
                                const vt = le1.children;
                                for (const bt of vt)h.removeAttributes(bt), h.clean(bt);
                            }
                            static removeAttributes(le1) {
                                for (const { name: vt, value: bt } of le1.attributes)h.isPossiblyDangerous(vt, bt) && le1.removeAttribute(vt);
                            }
                        }
                        h.docStyle = "undefined" != typeof window && window.document && window.document.documentElement.style, h.selectProp = h.testProp([
                            "userSelect",
                            "MozUserSelect",
                            "WebkitUserSelect",
                            "msUserSelect"
                        ]), h.transformProp = h.testProp([
                            "transform",
                            "WebkitTransform"
                        ]);
                        const uc = {
                            supported: !1,
                            testSupport: function(le1) {
                                !Ac && gc && (Ec ? f(le1) : mc = le1);
                            }
                        };
                        let mc, gc, Ac = !1, Ec = !1;
                        function f(le1) {
                            const vt = le1.createTexture();
                            le1.bindTexture(le1.TEXTURE_2D, vt);
                            try {
                                if (le1.texImage2D(le1.TEXTURE_2D, 0, le1.RGBA, le1.RGBA, le1.UNSIGNED_BYTE, gc), le1.isContextLost()) return;
                                uc.supported = !0;
                            } catch (le1) {}
                            le1.deleteTexture(vt), Ac = !0;
                        }
                        var kc;
                        "undefined" != typeof document && (gc = document.createElement("img"), gc.onload = ()=>{
                            mc && f(mc), mc = null, Ec = !0;
                        }, gc.onerror = ()=>{
                            Ac = !0, mc = null;
                        }, gc.src = "data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA="), function(le1) {
                            let bt, ls, ho, Dl;
                            le1.resetRequestQueue = ()=>{
                                bt = [], ls = 0, ho = 0, Dl = {};
                            }, le1.addThrottleControl = (le1)=>{
                                const vt = ho++;
                                return Dl[vt] = le1, vt;
                            }, le1.removeThrottleControl = (le1)=>{
                                delete Dl[le1], n();
                            }, le1.getImage = (le1, ls, ho = !0)=>new Promise((Dl, Fl)=>{
                                    uc.supported && (le1.headers || (le1.headers = {}), le1.headers.accept = "image/webp,*/*"), vt.e(le1, {
                                        type: "image"
                                    }), bt.push({
                                        abortController: ls,
                                        requestParameters: le1,
                                        supportImageRefresh: ho,
                                        state: "queued",
                                        onError: (le1)=>{
                                            Fl(le1);
                                        },
                                        onSuccess: (le1)=>{
                                            Dl(le1);
                                        }
                                    }), n();
                                });
                            const s = (le1)=>vt._(this, void 0, void 0, function*() {
                                    le1.state = "running";
                                    const { requestParameters: bt, supportImageRefresh: ho, onError: Dl, onSuccess: Fl, abortController: sc } = le1, uc = !1 === ho && !vt.i(self) && !vt.g(bt.url) && (!bt.headers || Object.keys(bt.headers).reduce((le1, vt)=>le1 && "accept" === vt, !0));
                                    ls++;
                                    const mc = uc ? l(bt, sc) : vt.m(bt, sc);
                                    try {
                                        const bt = yield mc;
                                        delete le1.abortController, le1.state = "completed", bt.data instanceof HTMLImageElement || vt.b(bt.data) ? Fl(bt) : bt.data && Fl({
                                            data: yield (gc = bt.data, "function" == typeof createImageBitmap ? vt.f(gc) : vt.h(gc)),
                                            cacheControl: bt.cacheControl,
                                            expires: bt.expires
                                        });
                                    } catch (vt) {
                                        delete le1.abortController, Dl(vt);
                                    } finally{
                                        ls--, n();
                                    }
                                    var gc;
                                }), n = ()=>{
                                const le1 = (()=>{
                                    for (const le1 of Object.keys(Dl))if (Dl[le1]()) return !0;
                                    return !1;
                                })() ? vt.c.MAX_PARALLEL_IMAGE_REQUESTS_PER_FRAME : vt.c.MAX_PARALLEL_IMAGE_REQUESTS;
                                for(let vt = ls; vt < le1 && bt.length > 0; vt++){
                                    const le1 = bt.shift();
                                    le1.abortController.signal.aborted ? vt-- : s(le1);
                                }
                            }, l = (le1, bt)=>new Promise((ls, ho)=>{
                                    const Dl = new Image, Fl = le1.url, sc = le1.credentials;
                                    sc && "include" === sc ? Dl.crossOrigin = "use-credentials" : (sc && "same-origin" === sc || !vt.d(Fl)) && (Dl.crossOrigin = "anonymous"), bt.signal.addEventListener("abort", ()=>{
                                        Dl.src = "", ho(new vt.a(bt.signal.reason));
                                    }), Dl.fetchPriority = "high", Dl.onload = ()=>{
                                        Dl.onerror = Dl.onload = null, ls({
                                            data: Dl
                                        });
                                    }, Dl.onerror = ()=>{
                                        Dl.onerror = Dl.onload = null, bt.signal.aborted || ho(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));
                                    }, Dl.src = Fl;
                                });
                        }(kc || (kc = {})), kc.resetRequestQueue();
                        class v {
                            constructor(le1){
                                this._transformRequestFn = null != le1 ? le1 : null;
                            }
                            transformRequest(le1, vt) {
                                return this._transformRequestFn && this._transformRequestFn(le1, vt) || {
                                    url: le1
                                };
                            }
                            setTransformRequest(le1) {
                                this._transformRequestFn = le1;
                            }
                        }
                        function x(le1) {
                            const vt = [];
                            if ("string" == typeof le1) vt.push({
                                id: "default",
                                url: le1
                            });
                            else if (le1 && le1.length > 0) {
                                const bt = [];
                                for (const { id: ls, url: ho } of le1){
                                    const le1 = `${ls}${ho}`;
                                    -1 === bt.indexOf(le1) && (bt.push(le1), vt.push({
                                        id: ls,
                                        url: ho
                                    }));
                                }
                            }
                            return vt;
                        }
                        function b(le1, vt, bt) {
                            try {
                                const ls = new URL(le1);
                                return ls.pathname += `${vt}${bt}`, ls.toString();
                            } catch (vt) {
                                throw new Error(`Invalid sprite URL "${le1}", must be absolute. Modify style specification directly or use TransformStyleFunction to correct the issue dynamically`);
                            }
                        }
                        function y(le1) {
                            const { userImage: vt } = le1;
                            return !!(vt && vt.render && vt.render()) && (le1.data.replace(new Uint8Array(vt.data.buffer)), !0);
                        }
                        class w extends vt.E {
                            constructor(){
                                super(), this.images = {}, this.updatedImages = {}, this.callbackDispatchedThisFrame = {}, this.loaded = !1, this.requestors = [], this.patterns = {}, this.atlasImage = new vt.R({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            destroy() {
                                this.atlasTexture && (this.atlasTexture.destroy(), this.atlasTexture = null);
                                for (const le1 of Object.keys(this.images))this.removeImage(le1);
                                this.patterns = {}, this.atlasImage = new vt.R({
                                    width: 1,
                                    height: 1
                                }), this.dirty = !0;
                            }
                            isLoaded() {
                                return this.loaded;
                            }
                            setLoaded(le1) {
                                if (this.loaded !== le1 && (this.loaded = le1, le1)) {
                                    for (const { ids: le1, promiseResolve: vt } of this.requestors)vt(this._getImagesForIds(le1));
                                    this.requestors = [];
                                }
                            }
                            getImage(le1) {
                                const bt = this.images[le1];
                                if (bt && !bt.data && bt.spriteData) {
                                    const le1 = bt.spriteData;
                                    bt.data = new vt.R({
                                        width: le1.width,
                                        height: le1.height
                                    }, le1.context.getImageData(le1.x, le1.y, le1.width, le1.height).data), bt.spriteData = null;
                                }
                                return bt;
                            }
                            addImage(le1, vt) {
                                if (this.images[le1]) throw new Error(`Image id ${le1} already exist, use updateImage instead`);
                                this._validate(le1, vt) && (this.images[le1] = vt);
                            }
                            _validate(le1, bt) {
                                let ls = !0;
                                const ho = bt.data || bt.spriteData;
                                return this._validateStretch(bt.stretchX, ho && ho.width) || (this.fire(new vt.k(new Error(`Image "${le1}" has invalid "stretchX" value`))), ls = !1), this._validateStretch(bt.stretchY, ho && ho.height) || (this.fire(new vt.k(new Error(`Image "${le1}" has invalid "stretchY" value`))), ls = !1), this._validateContent(bt.content, bt) || (this.fire(new vt.k(new Error(`Image "${le1}" has invalid "content" value`))), ls = !1), ls;
                            }
                            _validateStretch(le1, vt) {
                                if (!le1) return !0;
                                let bt = 0;
                                for (const ls of le1){
                                    if (ls[0] < bt || ls[1] < ls[0] || vt < ls[1]) return !1;
                                    bt = ls[1];
                                }
                                return !0;
                            }
                            _validateContent(le1, vt) {
                                if (!le1) return !0;
                                if (4 !== le1.length) return !1;
                                const bt = vt.spriteData, ls = bt && bt.width || vt.data.width, ho = bt && bt.height || vt.data.height;
                                return !(le1[0] < 0 || ls < le1[0] || le1[1] < 0 || ho < le1[1] || le1[2] < 0 || ls < le1[2] || le1[3] < 0 || ho < le1[3] || le1[2] < le1[0] || le1[3] < le1[1]);
                            }
                            updateImage(le1, vt, bt = !0) {
                                const ls = this.getImage(le1);
                                if (bt && (ls.data.width !== vt.data.width || ls.data.height !== vt.data.height)) throw new Error(`size mismatch between old image (${ls.data.width}x${ls.data.height}) and new image (${vt.data.width}x${vt.data.height}).`);
                                vt.version = ls.version + 1, this.images[le1] = vt, this.updatedImages[le1] = !0;
                            }
                            removeImage(le1) {
                                const vt = this.images[le1];
                                delete this.images[le1], delete this.patterns[le1], vt.userImage && vt.userImage.onRemove && vt.userImage.onRemove();
                            }
                            listImages() {
                                return Object.keys(this.images);
                            }
                            getImages(le1) {
                                return new Promise((vt, bt)=>{
                                    let ls = !0;
                                    if (!this.isLoaded()) for (const ho of le1)this.images[ho] || (ls = !1);
                                    this.isLoaded() || ls ? vt(this._getImagesForIds(le1)) : this.requestors.push({
                                        ids: le1,
                                        promiseResolve: vt
                                    });
                                });
                            }
                            _getImagesForIds(le1) {
                                const bt = {};
                                for (const ls of le1){
                                    let le1 = this.getImage(ls);
                                    le1 || (this.fire(new vt.l("styleimagemissing", {
                                        id: ls
                                    })), le1 = this.getImage(ls)), le1 ? bt[ls] = {
                                        data: le1.data.clone(),
                                        pixelRatio: le1.pixelRatio,
                                        sdf: le1.sdf,
                                        version: le1.version,
                                        stretchX: le1.stretchX,
                                        stretchY: le1.stretchY,
                                        content: le1.content,
                                        textFitWidth: le1.textFitWidth,
                                        textFitHeight: le1.textFitHeight,
                                        hasRenderCallback: Boolean(le1.userImage && le1.userImage.render)
                                    } : vt.w(`Image "${ls}" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.`);
                                }
                                return bt;
                            }
                            getPixelSize() {
                                const { width: le1, height: vt } = this.atlasImage;
                                return {
                                    width: le1,
                                    height: vt
                                };
                            }
                            getPattern(le1) {
                                const bt = this.patterns[le1], ls = this.getImage(le1);
                                if (!ls) return null;
                                if (bt && bt.position.version === ls.version) return bt.position;
                                if (bt) bt.position.version = ls.version;
                                else {
                                    const bt = {
                                        w: ls.data.width + 2,
                                        h: ls.data.height + 2,
                                        x: 0,
                                        y: 0
                                    }, ho = new vt.I(bt, ls);
                                    this.patterns[le1] = {
                                        bin: bt,
                                        position: ho
                                    };
                                }
                                return this._updatePatternAtlas(), this.patterns[le1].position;
                            }
                            bind(le1) {
                                const bt = le1.gl;
                                this.atlasTexture ? this.dirty && (this.atlasTexture.update(this.atlasImage), this.dirty = !1) : this.atlasTexture = new vt.T(le1, this.atlasImage, bt.RGBA), this.atlasTexture.bind(bt.LINEAR, bt.CLAMP_TO_EDGE);
                            }
                            _updatePatternAtlas() {
                                const le1 = [];
                                for(const vt in this.patterns)le1.push(this.patterns[vt].bin);
                                const { w: bt, h: ls } = vt.p(le1), ho = this.atlasImage;
                                ho.resize({
                                    width: bt || 1,
                                    height: ls || 1
                                });
                                for(const Dl in this.patterns){
                                    const { bin: le1 } = this.patterns[Dl], bt = le1.x + 1, ls = le1.y + 1, Fl = this.getImage(Dl).data, sc = Fl.width, uc = Fl.height;
                                    vt.R.copy(Fl, ho, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: bt,
                                        y: ls
                                    }, {
                                        width: sc,
                                        height: uc
                                    }), vt.R.copy(Fl, ho, {
                                        x: 0,
                                        y: uc - 1
                                    }, {
                                        x: bt,
                                        y: ls - 1
                                    }, {
                                        width: sc,
                                        height: 1
                                    }), vt.R.copy(Fl, ho, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: bt,
                                        y: ls + uc
                                    }, {
                                        width: sc,
                                        height: 1
                                    }), vt.R.copy(Fl, ho, {
                                        x: sc - 1,
                                        y: 0
                                    }, {
                                        x: bt - 1,
                                        y: ls
                                    }, {
                                        width: 1,
                                        height: uc
                                    }), vt.R.copy(Fl, ho, {
                                        x: 0,
                                        y: 0
                                    }, {
                                        x: bt + sc,
                                        y: ls
                                    }, {
                                        width: 1,
                                        height: uc
                                    });
                                }
                                this.dirty = !0;
                            }
                            beginFrame() {
                                this.callbackDispatchedThisFrame = {};
                            }
                            dispatchRenderCallbacks(le1) {
                                for (const bt of le1){
                                    if (this.callbackDispatchedThisFrame[bt]) continue;
                                    this.callbackDispatchedThisFrame[bt] = !0;
                                    const le1 = this.getImage(bt);
                                    le1 || vt.w(`Image with ID: "${bt}" was not found`), y(le1) && this.updateImage(bt, le1);
                                }
                            }
                            cloneImages() {
                                const le1 = {};
                                for(const vt in this.images){
                                    const bt = this.images[vt];
                                    le1[vt] = Object.assign(Object.assign({}, bt), {
                                        data: bt.data ? bt.data.clone() : null
                                    });
                                }
                                return le1;
                            }
                        }
                        const du = 1e20;
                        function P(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            for(let mc = vt; mc < vt + ls; mc++)C(le1, bt * Dl + mc, Dl, ho, Fl, sc, uc);
                            for(let mc = bt; mc < bt + ho; mc++)C(le1, mc * Dl + vt, 1, ls, Fl, sc, uc);
                        }
                        function C(le1, vt, bt, ls, ho, Dl, Fl) {
                            Dl[0] = 0, Fl[0] = -du, Fl[1] = du, ho[0] = le1[vt];
                            for(let sc = 1, uc = 0, mc = 0; sc < ls; sc++){
                                ho[sc] = le1[vt + sc * bt];
                                const ls = sc * sc;
                                do {
                                    const le1 = Dl[uc];
                                    mc = (ho[sc] - ho[le1] + ls - le1 * le1) / (sc - le1) / 2;
                                }while (mc <= Fl[uc] && --uc > -1);
                                uc++, Dl[uc] = sc, Fl[uc] = mc, Fl[uc + 1] = du;
                            }
                            for(let sc = 0, uc = 0; sc < ls; sc++){
                                for(; Fl[uc + 1] < sc;)uc++;
                                const ls = Dl[uc], mc = sc - ls;
                                le1[vt + sc * bt] = ho[ls] + mc * mc;
                            }
                        }
                        const _u = vt.v.layout_symbol["text-font"].default.join(",");
                        class M {
                            constructor(le1, vt, bt){
                                this.requestManager = le1, this.localIdeographFontFamily = vt, this.entries = {}, this.lang = bt;
                            }
                            setURL(le1) {
                                this.url = le1;
                            }
                            getGlyphs(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    const vt = [];
                                    for(const ho in le1)for (const bt of le1[ho])vt.push(this._getAndCacheGlyphsPromise(ho, bt));
                                    const bt = yield Promise.all(vt), ls = {};
                                    for (const { stack: le1, id: ho, glyph: Dl } of bt)ls[le1] || (ls[le1] = {}), ls[le1][ho] = Dl && {
                                        id: Dl.id,
                                        bitmap: Dl.bitmap.clone(),
                                        metrics: Dl.metrics
                                    };
                                    return ls;
                                });
                            }
                            _getAndCacheGlyphsPromise(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    let vt = this.entries[le1];
                                    vt || (vt = this.entries[le1] = {
                                        glyphs: {},
                                        requests: {},
                                        ranges: {}
                                    });
                                    let ls = vt.glyphs[bt];
                                    return void 0 !== ls ? {
                                        stack: le1,
                                        id: bt,
                                        glyph: ls
                                    } : !this.url || this._charUsesLocalIdeographFontFamily(bt) ? (ls = vt.glyphs[bt] = this._drawGlyph(vt, le1, bt), {
                                        stack: le1,
                                        id: bt,
                                        glyph: ls
                                    }) : yield this._downloadAndCacheRangePromise(le1, bt);
                                });
                            }
                            _downloadAndCacheRangePromise(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    const vt = this.entries[le1], ho = Math.floor(bt / 256);
                                    if (vt.ranges[ho]) return {
                                        stack: le1,
                                        id: bt,
                                        glyph: null
                                    };
                                    if (!vt.requests[ho]) {
                                        const bt = M.loadGlyphRange(le1, ho, this.url, this.requestManager);
                                        vt.requests[ho] = bt;
                                    }
                                    try {
                                        const ls = yield vt.requests[ho];
                                        for(const le1 in ls)vt.glyphs[+le1] = ls[+le1];
                                        return vt.ranges[ho] = !0, {
                                            stack: le1,
                                            id: bt,
                                            glyph: ls[bt] || null
                                        };
                                    } catch (ls) {
                                        const Fl = vt.glyphs[bt] = this._drawGlyph(vt, le1, bt);
                                        return this._warnOnMissingGlyphRange(Fl, ho, bt, ls), {
                                            stack: le1,
                                            id: bt,
                                            glyph: Fl
                                        };
                                    }
                                });
                            }
                            _warnOnMissingGlyphRange(le1, bt, ls, ho) {
                                const Dl = 256 * bt, Fl = Dl + 255, sc = ls.toString(16).padStart(4, "0").toUpperCase();
                                vt.w(`Unable to load glyph range ${bt}, ${Dl}-${Fl}. Rendering codepoint U+${sc} locally instead. ${ho}`);
                            }
                            _charUsesLocalIdeographFontFamily(le1) {
                                return !!this.localIdeographFontFamily && vt.q(le1);
                            }
                            _drawGlyph(le1, bt, ls) {
                                const ho = bt === _u && "" !== this.localIdeographFontFamily && this._charUsesLocalIdeographFontFamily(ls), Dl = ho ? "ideographTinySDF" : "tinySDF";
                                le1[Dl] || (le1[Dl] = this._createTinySDF(ho ? this.localIdeographFontFamily : bt));
                                const Fl = le1[Dl].draw(String.fromCodePoint(ls)), sc = /^\p{gc=Cf}+$/u.test(String.fromCodePoint(ls));
                                return {
                                    id: ls,
                                    bitmap: new vt.r({
                                        width: Fl.width || 60,
                                        height: Fl.height || 60
                                    }, Fl.data),
                                    metrics: {
                                        width: sc ? 0 : Fl.glyphWidth / 2 || 24,
                                        height: Fl.glyphHeight / 2 || 24,
                                        left: Fl.glyphLeft / 2 + .5 || 0,
                                        top: Fl.glyphTop / 2 - 27.5 || -8,
                                        advance: sc ? 0 : Fl.glyphAdvance / 2 || 24,
                                        isDoubleResolution: !0
                                    }
                                };
                            }
                            _createTinySDF(le1) {
                                const vt = le1 ? le1.split(",") : [];
                                vt.push("sans-serif");
                                const bt = vt.map((le1)=>/[-\w]+/.test(le1) ? le1 : `'${CSS.escape(le1)}'`).join(",");
                                return new M.TinySDF({
                                    fontSize: 48,
                                    buffer: 6,
                                    radius: 16,
                                    cutoff: .25,
                                    fontFamily: bt,
                                    fontWeight: this._fontWeight(vt[0]),
                                    fontStyle: this._fontStyle(vt[0]),
                                    lang: this.lang
                                });
                            }
                            _fontStyle(le1) {
                                return /italic/i.test(le1) ? "italic" : /oblique/i.test(le1) ? "oblique" : "normal";
                            }
                            _fontWeight(le1) {
                                const vt = {
                                    thin: 100,
                                    hairline: 100,
                                    "extra light": 200,
                                    "ultra light": 200,
                                    light: 300,
                                    normal: 400,
                                    regular: 400,
                                    medium: 500,
                                    semibold: 600,
                                    demibold: 600,
                                    bold: 700,
                                    "extra bold": 800,
                                    "ultra bold": 800,
                                    black: 900,
                                    heavy: 900,
                                    "extra black": 950,
                                    "ultra black": 950
                                };
                                let bt;
                                for (const [ls, ho] of Object.entries(vt))new RegExp(`\\b${ls}\\b`, "i").test(le1) && (bt = `${ho}`);
                                return bt;
                            }
                            destroy() {
                                for(const le1 in this.entries){
                                    const vt = this.entries[le1];
                                    vt.tinySDF && (vt.tinySDF = null), vt.ideographTinySDF && (vt.ideographTinySDF = null), vt.glyphs = {}, vt.requests = {}, vt.ranges = {};
                                }
                                this.entries = {};
                            }
                        }
                        M.loadGlyphRange = function(le1, bt, ls, ho) {
                            return vt._(this, void 0, void 0, function*() {
                                const Dl = 256 * bt, Fl = Dl + 255, sc = ho.transformRequest(ls.replace("{fontstack}", le1).replace("{range}", `${Dl}-${Fl}`), "Glyphs"), uc = yield vt.n(sc, new AbortController);
                                if (!uc || !uc.data) throw new Error(`Could not load glyph range. range: ${bt}, ${Dl}-${Fl}`);
                                const mc = {};
                                for (const le1 of vt.o(uc.data))mc[le1.id] = le1;
                                return mc;
                            });
                        }, M.TinySDF = class {
                            constructor({ fontSize: le1 = 24, buffer: vt = 3, radius: bt = 8, cutoff: ls = .25, fontFamily: ho = "sans-serif", fontWeight: Dl = "normal", fontStyle: Fl = "normal", lang: sc = null } = {}){
                                this.buffer = vt, this.cutoff = ls, this.radius = bt, this.lang = sc;
                                const uc = this.size = le1 + 4 * vt, mc = this._createCanvas(uc), gc = this.ctx = mc.getContext("2d", {
                                    willReadFrequently: !0
                                });
                                gc.font = `${Fl} ${Dl} ${le1}px ${ho}`, gc.textBaseline = "alphabetic", gc.textAlign = "left", gc.fillStyle = "black", this.gridOuter = new Float64Array(uc * uc), this.gridInner = new Float64Array(uc * uc), this.f = new Float64Array(uc), this.z = new Float64Array(uc + 1), this.v = new Uint16Array(uc);
                            }
                            _createCanvas(le1) {
                                const vt = document.createElement("canvas");
                                return vt.width = vt.height = le1, vt;
                            }
                            draw(le1) {
                                const { width: vt, actualBoundingBoxAscent: bt, actualBoundingBoxDescent: ls, actualBoundingBoxLeft: ho, actualBoundingBoxRight: Dl } = this.ctx.measureText(le1), Fl = Math.ceil(bt), sc = Math.max(0, Math.min(this.size - this.buffer, Math.ceil(Dl - ho))), uc = Math.min(this.size - this.buffer, Fl + Math.ceil(ls)), mc = sc + 2 * this.buffer, gc = uc + 2 * this.buffer, Ac = Math.max(mc * gc, 0), Ec = new Uint8ClampedArray(Ac), kc = {
                                    data: Ec,
                                    width: mc,
                                    height: gc,
                                    glyphWidth: sc,
                                    glyphHeight: uc,
                                    glyphTop: Fl,
                                    glyphLeft: 0,
                                    glyphAdvance: vt
                                };
                                if (0 === sc || 0 === uc) return kc;
                                const { ctx: _u, buffer: Md, gridInner: Ld, gridOuter: Nd } = this;
                                this.lang && (_u.lang = this.lang), _u.clearRect(Md, Md, sc, uc), _u.fillText(le1, Md, Md + Fl);
                                const Rd = _u.getImageData(Md, Md, sc, uc);
                                Nd.fill(du, 0, Ac), Ld.fill(0, 0, Ac);
                                for(let Od = 0; Od < uc; Od++)for(let le1 = 0; le1 < sc; le1++){
                                    const vt = Rd.data[4 * (Od * sc + le1) + 3] / 255;
                                    if (0 === vt) continue;
                                    const bt = (Od + Md) * mc + le1 + Md;
                                    if (1 === vt) Nd[bt] = 0, Ld[bt] = du;
                                    else {
                                        const le1 = .5 - vt;
                                        Nd[bt] = le1 > 0 ? le1 * le1 : 0, Ld[bt] = le1 < 0 ? le1 * le1 : 0;
                                    }
                                }
                                P(Nd, 0, 0, mc, gc, mc, this.f, this.v, this.z), P(Ld, Md, Md, sc, uc, mc, this.f, this.v, this.z);
                                for(let du = 0; du < Ac; du++){
                                    const le1 = Math.sqrt(Nd[du]) - Math.sqrt(Ld[du]);
                                    Ec[du] = Math.round(255 - 255 * (le1 / this.radius + this.cutoff));
                                }
                                return kc;
                            }
                        };
                        class E {
                            constructor(){
                                this.specification = vt.u.light.position;
                            }
                            possiblyEvaluate(le1, bt) {
                                return vt.F(le1.expression.evaluate(bt));
                            }
                            interpolate(le1, bt, ls) {
                                return {
                                    x: vt.G.number(le1.x, bt.x, ls),
                                    y: vt.G.number(le1.y, bt.y, ls),
                                    z: vt.G.number(le1.z, bt.z, ls)
                                };
                            }
                        }
                        let Md;
                        class z extends vt.E {
                            constructor(le1){
                                super(), Md = Md || new vt.t({
                                    anchor: new vt.D(vt.u.light.anchor),
                                    position: new E,
                                    color: new vt.D(vt.u.light.color),
                                    intensity: new vt.D(vt.u.light.intensity)
                                }), this._transitionable = new vt.x(Md, void 0), this.setLight(le1), this._transitioning = this._transitionable.untransitioned();
                            }
                            getLight() {
                                return this._transitionable.serialize();
                            }
                            setLight(le1, bt = {}) {
                                if (!this._validate(vt.y, le1, bt)) for(const ls in le1){
                                    const bt = le1[ls];
                                    ls.endsWith(vt.z) ? this._transitionable.setTransition(ls.slice(0, -vt.z.length), bt) : this._transitionable.setValue(ls, bt);
                                }
                            }
                            updateTransitions(le1) {
                                this._transitioning = this._transitionable.transitioned(le1, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(le1) {
                                this.properties = this._transitioning.possiblyEvaluate(le1);
                            }
                            _validate(le1, bt, ls) {
                                return (!ls || !1 !== ls.validate) && vt.B(this, le1.call(vt.C, {
                                    value: bt,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: vt.u
                                }));
                            }
                        }
                        const Ld = new vt.t({
                            "sky-color": new vt.D(vt.u.sky["sky-color"]),
                            "horizon-color": new vt.D(vt.u.sky["horizon-color"]),
                            "fog-color": new vt.D(vt.u.sky["fog-color"]),
                            "fog-ground-blend": new vt.D(vt.u.sky["fog-ground-blend"]),
                            "horizon-fog-blend": new vt.D(vt.u.sky["horizon-fog-blend"]),
                            "sky-horizon-blend": new vt.D(vt.u.sky["sky-horizon-blend"]),
                            "atmosphere-blend": new vt.D(vt.u.sky["atmosphere-blend"])
                        });
                        class D extends vt.E {
                            constructor(le1){
                                super(), this._transitionable = new vt.x(Ld, void 0), this.setSky(le1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new vt.H(0));
                            }
                            setSky(le1, bt = {}) {
                                if (!this._validate(vt.J, le1, bt)) {
                                    le1 || (le1 = {
                                        "sky-color": "transparent",
                                        "horizon-color": "transparent",
                                        "fog-color": "transparent",
                                        "fog-ground-blend": 1,
                                        "atmosphere-blend": 0
                                    });
                                    for(const bt in le1){
                                        const ls = le1[bt];
                                        bt.endsWith(vt.z) ? this._transitionable.setTransition(bt.slice(0, -vt.z.length), ls) : this._transitionable.setValue(bt, ls);
                                    }
                                }
                            }
                            getSky() {
                                return this._transitionable.serialize();
                            }
                            updateTransitions(le1) {
                                this._transitioning = this._transitionable.transitioned(le1, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition();
                            }
                            recalculate(le1) {
                                this.properties = this._transitioning.possiblyEvaluate(le1);
                            }
                            _validate(le1, bt, ls = {}) {
                                return !1 !== (null == ls ? void 0 : ls.validate) && vt.B(this, le1.call(vt.C, vt.e({
                                    value: bt,
                                    style: {
                                        glyphs: !0,
                                        sprite: !0
                                    },
                                    styleSpec: vt.u
                                })));
                            }
                            calculateFogBlendOpacity(le1) {
                                return le1 < 60 ? 0 : le1 < 70 ? (le1 - 60) / 10 : 1;
                            }
                        }
                        class A {
                            constructor(le1, vt){
                                this.width = le1, this.height = vt, this.nextRow = 0, this.data = new Uint8Array(this.width * this.height), this.dashEntry = {};
                            }
                            getDash(le1, vt) {
                                const bt = le1.join(",") + String(vt);
                                return this.dashEntry[bt] || (this.dashEntry[bt] = this.addDash(le1, vt)), this.dashEntry[bt];
                            }
                            getDashRanges(le1, vt, bt) {
                                const ls = [];
                                let ho = le1.length % 2 == 1 ? -le1[le1.length - 1] * bt : 0, Dl = le1[0] * bt, Fl = !0;
                                ls.push({
                                    left: ho,
                                    right: Dl,
                                    isDash: Fl,
                                    zeroLength: 0 === le1[0]
                                });
                                let sc = le1[0];
                                for(let uc = 1; uc < le1.length; uc++){
                                    Fl = !Fl;
                                    const vt = le1[uc];
                                    ho = sc * bt, sc += vt, Dl = sc * bt, ls.push({
                                        left: ho,
                                        right: Dl,
                                        isDash: Fl,
                                        zeroLength: 0 === vt
                                    });
                                }
                                return ls;
                            }
                            addRoundDash(le1, vt, bt) {
                                const ls = vt / 2;
                                for(let ho = -bt; ho <= bt; ho++){
                                    const vt = this.width * (this.nextRow + bt + ho);
                                    let Dl = 0, Fl = le1[Dl];
                                    for(let sc = 0; sc < this.width; sc++){
                                        sc / Fl.right > 1 && (Fl = le1[++Dl]);
                                        const uc = Math.abs(sc - Fl.left), mc = Math.abs(sc - Fl.right), gc = Math.min(uc, mc);
                                        let Ac;
                                        const Ec = ho / bt * (ls + 1);
                                        if (Fl.isDash) {
                                            const le1 = ls - Math.abs(Ec);
                                            Ac = Math.sqrt(gc * gc + le1 * le1);
                                        } else Ac = ls - Math.sqrt(gc * gc + Ec * Ec);
                                        this.data[vt + sc] = Math.max(0, Math.min(255, Ac + 128));
                                    }
                                }
                            }
                            addRegularDash(le1) {
                                for(let Fl = le1.length - 1; Fl >= 0; --Fl){
                                    const vt = le1[Fl], bt = le1[Fl + 1];
                                    vt.zeroLength ? le1.splice(Fl, 1) : bt && bt.isDash === vt.isDash && (bt.left = vt.left, le1.splice(Fl, 1));
                                }
                                const vt = le1[0], bt = le1[le1.length - 1];
                                vt.isDash === bt.isDash && (vt.left = bt.left - this.width, bt.right = vt.right + this.width);
                                const ls = this.width * this.nextRow;
                                let ho = 0, Dl = le1[ho];
                                for(let Fl = 0; Fl < this.width; Fl++){
                                    Fl / Dl.right > 1 && (Dl = le1[++ho]);
                                    const vt = Math.abs(Fl - Dl.left), bt = Math.abs(Fl - Dl.right), sc = Math.min(vt, bt);
                                    this.data[ls + Fl] = Math.max(0, Math.min(255, (Dl.isDash ? sc : -sc) + 128));
                                }
                            }
                            addDash(le1, bt) {
                                const ls = bt ? 7 : 0, ho = 2 * ls + 1;
                                if (this.nextRow + ho > this.height) return vt.w("LineAtlas out of space"), null;
                                let Dl = 0;
                                for(let vt = 0; vt < le1.length; vt++)Dl += le1[vt];
                                if (0 !== Dl) {
                                    const vt = this.width / Dl, ho = this.getDashRanges(le1, this.width, vt);
                                    bt ? this.addRoundDash(ho, vt, ls) : this.addRegularDash(ho);
                                }
                                const Fl = {
                                    y: this.nextRow + ls,
                                    height: 2 * ls,
                                    width: Dl
                                };
                                return this.nextRow += ho, this.dirty = !0, Fl;
                            }
                            bind(le1) {
                                const vt = le1.gl;
                                this.texture ? (vt.bindTexture(vt.TEXTURE_2D, this.texture), this.dirty && (this.dirty = !1, vt.texSubImage2D(vt.TEXTURE_2D, 0, 0, 0, this.width, this.height, vt.ALPHA, vt.UNSIGNED_BYTE, this.data))) : (this.texture = vt.createTexture(), vt.bindTexture(vt.TEXTURE_2D, this.texture), vt.texParameteri(vt.TEXTURE_2D, vt.TEXTURE_WRAP_S, vt.REPEAT), vt.texParameteri(vt.TEXTURE_2D, vt.TEXTURE_WRAP_T, vt.REPEAT), vt.texParameteri(vt.TEXTURE_2D, vt.TEXTURE_MIN_FILTER, vt.LINEAR), vt.texParameteri(vt.TEXTURE_2D, vt.TEXTURE_MAG_FILTER, vt.LINEAR), vt.texImage2D(vt.TEXTURE_2D, 0, vt.ALPHA, this.width, this.height, 0, vt.ALPHA, vt.UNSIGNED_BYTE, this.data));
                            }
                        }
                        const Nd = "maplibre_preloaded_worker_pool";
                        class k {
                            constructor(){
                                this.active = {};
                            }
                            acquire(le1) {
                                if (!this.workers) for(this.workers = []; this.workers.length < k.workerCount;)this.workers.push(new Worker(vt.c.WORKER_URL));
                                return this.active[le1] = !0, this.workers.slice();
                            }
                            release(le1) {
                                delete this.active[le1], 0 === this.numActive() && (this.workers.forEach((le1)=>{
                                    le1.terminate();
                                }), this.workers = null);
                            }
                            isPreloaded() {
                                return !!this.active[Nd];
                            }
                            numActive() {
                                return Object.keys(this.active).length;
                            }
                        }
                        const Rd = Math.floor(Fl.hardwareConcurrency / 2);
                        let Od, jd;
                        function j() {
                            return Od || (Od = new k), Od;
                        }
                        k.workerCount = vt.K(globalThis) ? Math.max(Math.min(Rd, 3), 1) : 1;
                        class N {
                            constructor(le1, bt){
                                this.workerPool = le1, this.actors = [], this.currentActor = 0, this.id = bt;
                                const ls = this.workerPool.acquire(bt);
                                for(let ho = 0; ho < ls.length; ho++){
                                    const le1 = new vt.L(ls[ho], bt);
                                    le1.name = `Worker ${ho}`, this.actors.push(le1);
                                }
                                if (!this.actors.length) throw new Error("No actors found");
                            }
                            broadcast(le1, vt) {
                                const bt = [];
                                for (const ls of this.actors)bt.push(ls.sendAsync({
                                    type: le1,
                                    data: vt
                                }));
                                return Promise.all(bt);
                            }
                            getActor() {
                                return this.currentActor = (this.currentActor + 1) % this.actors.length, this.actors[this.currentActor];
                            }
                            remove(le1 = !0) {
                                this.actors.forEach((le1)=>{
                                    le1.remove();
                                }), this.actors = [], le1 && this.workerPool.release(this.id);
                            }
                            registerMessageHandler(le1, vt) {
                                for (const bt of this.actors)bt.registerMessageHandler(le1, vt);
                            }
                            unregisterMessageHandler(le1) {
                                for (const vt of this.actors)vt.unregisterMessageHandler(le1);
                            }
                        }
                        function Z() {
                            return jd || (jd = new N(j(), vt.M), jd.registerMessageHandler("GR", (le1, bt, ls)=>vt.m(bt, ls))), jd;
                        }
                        function U(le1, bt) {
                            const ls = vt.N();
                            return vt.O(ls, ls, [
                                1,
                                1,
                                0
                            ]), vt.Q(ls, ls, [
                                .5 * le1.width,
                                .5 * le1.height,
                                1
                            ]), le1.calculatePosMatrix ? vt.S(ls, ls, le1.calculatePosMatrix(bt.toUnwrapped())) : ls;
                        }
                        function G(le1, vt, bt, ls, ho, Dl, Fl) {
                            var sc;
                            const uc = function(le1, vt, bt) {
                                if (le1) for (const ls of le1){
                                    const le1 = vt[ls];
                                    if (le1 && le1.source === bt && "fill-extrusion" === le1.type) return !0;
                                }
                                else for(const ls in vt){
                                    const le1 = vt[ls];
                                    if (le1.source === bt && "fill-extrusion" === le1.type) return !0;
                                }
                                return !1;
                            }(null !== (sc = null == ho ? void 0 : ho.layers) && void 0 !== sc ? sc : null, vt, le1.id), mc = Dl.maxPitchScaleFactor(), gc = le1.tilesIn(ls, mc, uc);
                            gc.sort(V);
                            const Ac = [];
                            for (const Ec of gc)Ac.push({
                                wrappedTileID: Ec.tileID.wrapped().key,
                                queryResults: Ec.tile.queryRenderedFeatures(vt, bt, le1.getState(), Ec.queryGeometry, Ec.cameraQueryGeometry, Ec.scale, ho, Dl, mc, U(Dl, Ec.tileID), Fl ? (le1, vt)=>Fl(Ec.tileID, le1, vt) : void 0)
                            });
                            return function(le1, vt) {
                                for(const bt in le1)for (const ls of le1[bt])q(ls, vt);
                                return le1;
                            }(function(le1) {
                                const vt = {}, bt = {};
                                for (const ls of le1){
                                    const le1 = ls.queryResults, ho = ls.wrappedTileID, Dl = bt[ho] = bt[ho] || {};
                                    for(const bt in le1){
                                        const ls = le1[bt], ho = Dl[bt] = Dl[bt] || {}, Fl = vt[bt] = vt[bt] || [];
                                        for (const le1 of ls)ho[le1.featureIndex] || (ho[le1.featureIndex] = !0, Fl.push(le1));
                                    }
                                }
                                return vt;
                            }(Ac), le1);
                        }
                        function V(le1, vt) {
                            const bt = le1.tileID, ls = vt.tileID;
                            return bt.overscaledZ - ls.overscaledZ || bt.canonical.y - ls.canonical.y || bt.wrap - ls.wrap || bt.canonical.x - ls.canonical.x;
                        }
                        function q(le1, vt) {
                            const bt = le1.feature, ls = vt.getFeatureState(bt.layer["source-layer"], bt.id);
                            bt.source = bt.layer.source, bt.layer["source-layer"] && (bt.sourceLayer = bt.layer["source-layer"]), bt.state = ls;
                        }
                        function W(le1, bt, ls, ho) {
                            return vt._(this, void 0, void 0, function*() {
                                let Dl = le1;
                                if (le1.url ? Dl = (yield vt.j(bt.transformRequest(le1.url, "Source"), ls)).data : yield Fl.frameAsync(ls, ho), !Dl) return null;
                                const sc = vt.U(vt.e(Dl, le1), [
                                    "tiles",
                                    "minzoom",
                                    "maxzoom",
                                    "attribution",
                                    "bounds",
                                    "scheme",
                                    "tileSize",
                                    "encoding"
                                ]);
                                return "vector_layers" in Dl && Dl.vector_layers && (sc.vectorLayerIds = Dl.vector_layers.map((le1)=>le1.id)), sc;
                            });
                        }
                        class $ {
                            constructor(le1, vt){
                                le1 && (vt ? this.setSouthWest(le1).setNorthEast(vt) : Array.isArray(le1) && (4 === le1.length ? this.setSouthWest([
                                    le1[0],
                                    le1[1]
                                ]).setNorthEast([
                                    le1[2],
                                    le1[3]
                                ]) : this.setSouthWest(le1[0]).setNorthEast(le1[1])));
                            }
                            setNorthEast(le1) {
                                return this._ne = le1 instanceof vt.V ? new vt.V(le1.lng, le1.lat) : vt.V.convert(le1), this;
                            }
                            setSouthWest(le1) {
                                return this._sw = le1 instanceof vt.V ? new vt.V(le1.lng, le1.lat) : vt.V.convert(le1), this;
                            }
                            extend(le1) {
                                const bt = this._sw, ls = this._ne;
                                let ho, Dl;
                                if (le1 instanceof vt.V) ho = le1, Dl = le1;
                                else {
                                    if (!(le1 instanceof $)) return Array.isArray(le1) ? 4 === le1.length || le1.every(Array.isArray) ? this.extend($.convert(le1)) : this.extend(vt.V.convert(le1)) : le1 && ("lng" in le1 || "lon" in le1) && "lat" in le1 ? this.extend(vt.V.convert(le1)) : this;
                                    if (ho = le1._sw, Dl = le1._ne, !ho || !Dl) return this;
                                }
                                return bt || ls ? (bt.lng = Math.min(ho.lng, bt.lng), bt.lat = Math.min(ho.lat, bt.lat), ls.lng = Math.max(Dl.lng, ls.lng), ls.lat = Math.max(Dl.lat, ls.lat)) : (this._sw = new vt.V(ho.lng, ho.lat), this._ne = new vt.V(Dl.lng, Dl.lat)), this;
                            }
                            getCenter() {
                                return new vt.V((this._sw.lng + this._ne.lng) / 2, (this._sw.lat + this._ne.lat) / 2);
                            }
                            getSouthWest() {
                                return this._sw;
                            }
                            getNorthEast() {
                                return this._ne;
                            }
                            getNorthWest() {
                                return new vt.V(this.getWest(), this.getNorth());
                            }
                            getSouthEast() {
                                return new vt.V(this.getEast(), this.getSouth());
                            }
                            getWest() {
                                return this._sw.lng;
                            }
                            getSouth() {
                                return this._sw.lat;
                            }
                            getEast() {
                                return this._ne.lng;
                            }
                            getNorth() {
                                return this._ne.lat;
                            }
                            toArray() {
                                return [
                                    this._sw.toArray(),
                                    this._ne.toArray()
                                ];
                            }
                            toString() {
                                return `LngLatBounds(${this._sw.toString()}, ${this._ne.toString()})`;
                            }
                            isEmpty() {
                                return !(this._sw && this._ne);
                            }
                            contains(le1) {
                                const { lng: bt, lat: ls } = vt.V.convert(le1);
                                let ho = this._sw.lng <= bt && bt <= this._ne.lng;
                                return this._sw.lng > this._ne.lng && (ho = this._sw.lng >= bt && bt >= this._ne.lng), this._sw.lat <= ls && ls <= this._ne.lat && ho;
                            }
                            intersects(le1) {
                                if (!((le1 = $.convert(le1)).getNorth() >= this.getSouth() && le1.getSouth() <= this.getNorth())) return !1;
                                const bt = Math.abs(this.getEast() - this.getWest()), ls = Math.abs(le1.getEast() - le1.getWest());
                                if (bt >= 360 || ls >= 360) return !0;
                                const ho = vt.W(this.getWest(), -180, 180), Dl = vt.W(this.getEast(), -180, 180), Fl = vt.W(le1.getWest(), -180, 180), sc = vt.W(le1.getEast(), -180, 180), uc = ho >= Dl, mc = Fl >= sc;
                                return !(!uc || !mc) || (uc ? sc >= ho || Fl <= Dl : mc ? Dl >= Fl || ho <= sc : Fl <= Dl && sc >= ho);
                            }
                            static convert(le1) {
                                return le1 instanceof $ ? le1 : le1 ? new $(le1) : le1;
                            }
                            static fromLngLat(le1, bt = 0) {
                                const ls = 360 * bt / 40075017, ho = ls / Math.cos(Math.PI / 180 * le1.lat);
                                return new $(new vt.V(le1.lng - ho, le1.lat - ls), new vt.V(le1.lng + ho, le1.lat + ls));
                            }
                            adjustAntiMeridian() {
                                const le1 = new vt.V(this._sw.lng, this._sw.lat), bt = new vt.V(this._ne.lng, this._ne.lat);
                                return new $(le1, le1.lng > bt.lng ? new vt.V(bt.lng + 360, bt.lat) : bt);
                            }
                        }
                        class H {
                            constructor(le1, vt, bt){
                                this.bounds = $.convert(this.validateBounds(le1)), this.minzoom = vt || 0, this.maxzoom = bt || 24;
                            }
                            validateBounds(le1) {
                                return Array.isArray(le1) && 4 === le1.length ? [
                                    Math.max(-180, le1[0]),
                                    Math.max(-90, le1[1]),
                                    Math.min(180, le1[2]),
                                    Math.min(90, le1[3])
                                ] : [
                                    -180,
                                    -90,
                                    180,
                                    90
                                ];
                            }
                            contains(le1) {
                                const bt = Math.pow(2, le1.z), ls = Math.floor(vt.Y(this.bounds.getWest()) * bt), ho = Math.floor(vt.X(this.bounds.getNorth()) * bt), Dl = Math.ceil(vt.Y(this.bounds.getEast()) * bt), Fl = Math.ceil(vt.X(this.bounds.getSouth()) * bt);
                                return le1.x >= ls && le1.x < Dl && le1.y >= ho && le1.y < Fl;
                            }
                        }
                        class X extends vt.E {
                            constructor(le1, bt, ls, ho){
                                if (super(), this.id = le1, this.dispatcher = ls, this.type = "vector", this.minzoom = 0, this.maxzoom = 22, this.scheme = "xyz", this.tileSize = 512, this.reparseOverscaled = !0, this.isTileClipped = !0, this._loaded = !1, vt.e(this, vt.U(bt, [
                                    "url",
                                    "scheme",
                                    "tileSize",
                                    "promoteId",
                                    "encoding"
                                ])), this._options = vt.e({
                                    type: "vector"
                                }, bt), this._collectResourceTiming = bt.collectResourceTiming, 512 !== this.tileSize) throw new Error("vector tile sources must have a tileSize of 512");
                                this.setEventedParent(ho);
                            }
                            load() {
                                return vt._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new vt.l("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const le1 = yield W(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
                                        this._tileJSONRequest = null, this._loaded = !0, this.map.style.tileManagers[this.id].clearTiles(), le1 && (vt.e(this, le1), le1.bounds && (this.tileBounds = new H(le1.bounds, this.minzoom, this.maxzoom)), this.fire(new vt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new vt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content"
                                        })));
                                    } catch (le1) {
                                        this._tileJSONRequest = null, this._loaded = !0, vt.Z(le1) || this.fire(new vt.k(le1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            hasTile(le1) {
                                return !this.tileBounds || this.tileBounds.contains(le1.canonical);
                            }
                            onAdd(le1) {
                                this.map = le1, this.load();
                            }
                            setSourceProperty(le1) {
                                this._tileJSONRequest && this._tileJSONRequest.abort(), le1(), this.load();
                            }
                            setTiles(le1) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = le1;
                                }), this;
                            }
                            setUrl(le1) {
                                return this.setSourceProperty(()=>{
                                    this.url = le1, this._options.url = le1;
                                }), this;
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            serialize() {
                                return vt.e({}, this._options);
                            }
                            loadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    const vt = le1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), bt = {
                                        request: this.map._requestManager.transformRequest(vt, "Tile"),
                                        uid: le1.uid,
                                        tileID: le1.tileID,
                                        zoom: le1.tileID.overscaledZ,
                                        tileSize: this.tileSize * le1.tileID.overscaleFactor(),
                                        type: this.type,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId,
                                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity,
                                        encoding: this.encoding,
                                        overzoomParameters: this._getOverzoomParameters(le1)
                                    };
                                    bt.request.collectResourceTiming = this._collectResourceTiming;
                                    let ls = "RT";
                                    if (le1.actor && "expired" !== le1.state) {
                                        if ("loading" === le1.state) return new Promise((vt, bt)=>{
                                            le1.reloadPromise = {
                                                resolve: vt,
                                                reject: bt
                                            };
                                        });
                                    } else le1.actor = this.dispatcher.getActor(), ls = "LT";
                                    le1.abortController = new AbortController;
                                    try {
                                        const vt = yield le1.actor.sendAsync({
                                            type: ls,
                                            data: bt
                                        }, le1.abortController);
                                        if (delete le1.abortController, le1.aborted) return;
                                        this._afterTileLoadWorkerResponse(le1, vt);
                                    } catch (vt) {
                                        if (delete le1.abortController, le1.aborted) return;
                                        if (vt && 404 !== vt.status) throw vt;
                                        this._afterTileLoadWorkerResponse(le1, null);
                                    }
                                });
                            }
                            _getOverzoomParameters(le1) {
                                if (le1.tileID.canonical.z <= this.maxzoom) return;
                                if (void 0 === this.map._zoomLevelsToOverscale) return;
                                const vt = le1.tileID.scaledTo(this.maxzoom).canonical, bt = vt.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                return {
                                    maxZoomTileID: vt,
                                    overzoomRequest: this.map._requestManager.transformRequest(bt, "Tile")
                                };
                            }
                            _afterTileLoadWorkerResponse(le1, vt) {
                                if (vt && vt.resourceTiming && (le1.resourceTiming = vt.resourceTiming), vt && this.map._refreshExpiredTiles && le1.setExpiryData(vt), le1.loadVectorData(vt, this.map.painter), le1.reloadPromise) {
                                    const vt = le1.reloadPromise;
                                    le1.reloadPromise = null, this.loadTile(le1).then(vt.resolve).catch(vt.reject);
                                }
                            }
                            abortTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.abortController && (le1.abortController.abort(), delete le1.abortController), le1.actor && (yield le1.actor.sendAsync({
                                        type: "AT",
                                        data: {
                                            uid: le1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            unloadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.unloadVectorData(), le1.actor && (yield le1.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: le1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class K extends vt.E {
                            constructor(le1, bt, ls, ho){
                                super(), this.id = le1, this.dispatcher = ls, this.setEventedParent(ho), this.type = "raster", this.minzoom = 0, this.maxzoom = 22, this.roundZoom = !0, this.scheme = "xyz", this.tileSize = 512, this._loaded = !1, this._options = vt.e({
                                    type: "raster"
                                }, bt), vt.e(this, vt.U(bt, [
                                    "url",
                                    "scheme",
                                    "tileSize"
                                ]));
                            }
                            load() {
                                return vt._(this, arguments, void 0, function*(le1 = !1) {
                                    this._loaded = !1, this.fire(new vt.l("dataloading", {
                                        dataType: "source"
                                    })), this._tileJSONRequest = new AbortController;
                                    try {
                                        const bt = yield W(this._options, this.map._requestManager, this._tileJSONRequest, this.map._ownerWindow);
                                        this._tileJSONRequest = null, this._loaded = !0, bt && (vt.e(this, bt), bt.bounds && (this.tileBounds = new H(bt.bounds, this.minzoom, this.maxzoom)), this.fire(new vt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "metadata"
                                        })), this.fire(new vt.l("data", {
                                            dataType: "source",
                                            sourceDataType: "content",
                                            sourceDataChanged: le1
                                        })));
                                    } catch (le1) {
                                        this._tileJSONRequest = null, this._loaded = !0, vt.Z(le1) || this.fire(new vt.k(le1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            onAdd(le1) {
                                this.map = le1, this.load();
                            }
                            onRemove() {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null);
                            }
                            setSourceProperty(le1) {
                                this._tileJSONRequest && (this._tileJSONRequest.abort(), this._tileJSONRequest = null), le1(), this.load(!0);
                            }
                            setTiles(le1) {
                                return this.setSourceProperty(()=>{
                                    this._options.tiles = le1;
                                }), this;
                            }
                            setUrl(le1) {
                                return this.setSourceProperty(()=>{
                                    this.url = le1, this._options.url = le1;
                                }), this;
                            }
                            serialize() {
                                return vt.e({}, this._options);
                            }
                            hasTile(le1) {
                                return !this.tileBounds || this.tileBounds.contains(le1.canonical);
                            }
                            loadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    const bt = le1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme);
                                    le1.abortController = new AbortController;
                                    try {
                                        const ls = yield kc.getImage(this.map._requestManager.transformRequest(bt, "Tile"), le1.abortController, this.map._refreshExpiredTiles);
                                        if (delete le1.abortController, le1.aborted) return void (le1.state = "unloaded");
                                        if (ls && ls.data) {
                                            this.map._refreshExpiredTiles && (ls.cacheControl || ls.expires) && le1.setExpiryData({
                                                cacheControl: ls.cacheControl,
                                                expires: ls.expires
                                            });
                                            const bt = this.map.painter.context, ho = bt.gl, Dl = ls.data;
                                            le1.texture = this.map.painter.getTileTexture(Dl.width), le1.texture ? le1.texture.update(Dl, {
                                                useMipmap: !0
                                            }) : (le1.texture = new vt.T(bt, Dl, ho.RGBA, {
                                                useMipmap: !0
                                            }), le1.texture.bind(ho.LINEAR, ho.CLAMP_TO_EDGE, ho.LINEAR_MIPMAP_NEAREST)), le1.state = "loaded";
                                        }
                                    } catch (vt) {
                                        if (delete le1.abortController, le1.aborted) le1.state = "unloaded";
                                        else if (vt) throw le1.state = "errored", vt;
                                    }
                                });
                            }
                            abortTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.abortController && (le1.abortController.abort(), delete le1.abortController);
                                });
                            }
                            unloadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.texture && this.map.painter.saveTileTexture(le1.texture);
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class Y extends K {
                            constructor(le1, bt, ls, ho){
                                super(le1, bt, ls, ho), this.type = "raster-dem", this.maxzoom = 22, this._options = vt.e({
                                    type: "raster-dem"
                                }, bt), this.encoding = bt.encoding || "mapbox", this.redFactor = bt.redFactor, this.greenFactor = bt.greenFactor, this.blueFactor = bt.blueFactor, this.baseShift = bt.baseShift;
                            }
                            loadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    const bt = le1.tileID.canonical.url(this.tiles, this.map.getPixelRatio(), this.scheme), ls = this.map._requestManager.transformRequest(bt, "Tile");
                                    le1.neighboringTiles = this._getNeighboringTiles(le1.tileID), le1.abortController = new AbortController;
                                    try {
                                        const bt = yield kc.getImage(ls, le1.abortController, this.map._refreshExpiredTiles);
                                        if (delete le1.abortController, le1.aborted) return void (le1.state = "unloaded");
                                        if (bt && bt.data) {
                                            const ls = bt.data;
                                            this.map._refreshExpiredTiles && (bt.cacheControl || bt.expires) && le1.setExpiryData({
                                                cacheControl: bt.cacheControl,
                                                expires: bt.expires
                                            });
                                            const ho = vt.b(ls) && vt.$() ? ls : yield this.readImageNow(ls), Dl = {
                                                type: this.type,
                                                uid: le1.uid,
                                                source: this.id,
                                                rawImageData: ho,
                                                encoding: this.encoding,
                                                redFactor: this.redFactor,
                                                greenFactor: this.greenFactor,
                                                blueFactor: this.blueFactor,
                                                baseShift: this.baseShift
                                            };
                                            if (!le1.actor || "expired" === le1.state) {
                                                le1.actor = this.dispatcher.getActor();
                                                const vt = yield le1.actor.sendAsync({
                                                    type: "LDT",
                                                    data: Dl
                                                });
                                                le1.dem = vt, le1.needsHillshadePrepare = !0, le1.needsTerrainPrepare = !0, le1.state = "loaded";
                                            }
                                        }
                                    } catch (vt) {
                                        if (delete le1.abortController, le1.aborted) le1.state = "unloaded";
                                        else if (vt) throw le1.state = "errored", vt;
                                    }
                                });
                            }
                            readImageNow(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    if ("undefined" != typeof VideoFrame && vt.a0()) {
                                        const bt = le1.width + 2, ls = le1.height + 2;
                                        try {
                                            return new vt.R({
                                                width: bt,
                                                height: ls
                                            }, (yield vt.a1(le1, -1, -1, bt, ls)));
                                        } catch (le1) {}
                                    }
                                    return Fl.getImageData(le1, 1);
                                });
                            }
                            _getNeighboringTiles(le1) {
                                const bt = le1.canonical, ls = Math.pow(2, bt.z), ho = (bt.x - 1 + ls) % ls, Dl = 0 === bt.x ? le1.wrap - 1 : le1.wrap, Fl = (bt.x + 1 + ls) % ls, sc = bt.x + 1 === ls ? le1.wrap + 1 : le1.wrap, uc = {};
                                return uc[new vt.a2(le1.overscaledZ, Dl, bt.z, ho, bt.y).key] = {
                                    backfilled: !1
                                }, uc[new vt.a2(le1.overscaledZ, sc, bt.z, Fl, bt.y).key] = {
                                    backfilled: !1
                                }, bt.y > 0 && (uc[new vt.a2(le1.overscaledZ, Dl, bt.z, ho, bt.y - 1).key] = {
                                    backfilled: !1
                                }, uc[new vt.a2(le1.overscaledZ, le1.wrap, bt.z, bt.x, bt.y - 1).key] = {
                                    backfilled: !1
                                }, uc[new vt.a2(le1.overscaledZ, sc, bt.z, Fl, bt.y - 1).key] = {
                                    backfilled: !1
                                }), bt.y + 1 < ls && (uc[new vt.a2(le1.overscaledZ, Dl, bt.z, ho, bt.y + 1).key] = {
                                    backfilled: !1
                                }, uc[new vt.a2(le1.overscaledZ, le1.wrap, bt.z, bt.x, bt.y + 1).key] = {
                                    backfilled: !1
                                }, uc[new vt.a2(le1.overscaledZ, sc, bt.z, Fl, bt.y + 1).key] = {
                                    backfilled: !1
                                }), uc;
                            }
                            unloadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.demTexture && this.map.painter.saveTileTexture(le1.demTexture), le1.fbo && (le1.fbo.destroy(), delete le1.fbo), le1.dem && delete le1.dem, delete le1.neighboringTiles, le1.state = "unloaded", le1.actor && (yield le1.actor.sendAsync({
                                        type: "RDT",
                                        data: {
                                            type: this.type,
                                            uid: le1.uid,
                                            source: this.id
                                        }
                                    }));
                                });
                            }
                        }
                        function Q(le1) {
                            return "GeometryCollection" === le1.type ? le1.geometries.map((le1)=>le1.coordinates).flat(1 / 0) : le1.coordinates.flat(1 / 0);
                        }
                        function J(le1) {
                            const vt = new $;
                            let bt;
                            switch(le1.type){
                                case "FeatureCollection":
                                    bt = le1.features.map((le1)=>Q(le1.geometry)).flat(1 / 0);
                                    break;
                                case "Feature":
                                    bt = Q(le1.geometry);
                                    break;
                                default:
                                    bt = Q(le1);
                            }
                            if (0 == bt.length) return vt;
                            for(let ls = 0; ls < bt.length - 1; ls += 2)vt.extend([
                                bt[ls],
                                bt[ls + 1]
                            ]);
                            return vt;
                        }
                        class ee extends vt.E {
                            constructor(le1, bt, ls, ho){
                                super(), this.id = le1, this.type = "geojson", this.minzoom = 0, this.maxzoom = 18, this.tileSize = 512, this.isTileClipped = !0, this.reparseOverscaled = !0, this._removed = !1, this._isUpdatingWorker = !1, this._pendingWorkerUpdate = {
                                    data: bt.data
                                }, this.actor = ls.getActor(), this.setEventedParent(ho), this._data = "string" == typeof bt.data ? {
                                    url: bt.data
                                } : {
                                    geojson: bt.data
                                }, this._options = vt.e({}, bt), this._collectResourceTiming = bt.collectResourceTiming, void 0 !== bt.maxzoom && (this.maxzoom = bt.maxzoom), bt.type && (this.type = bt.type), bt.attribution && (this.attribution = bt.attribution), this.promoteId = bt.promoteId, void 0 !== bt.clusterMaxZoom && this.maxzoom <= bt.clusterMaxZoom && vt.w(`The maxzoom value "${this.maxzoom}" is expected to be greater than the clusterMaxZoom value "${bt.clusterMaxZoom}".`), this.workerOptions = vt.e({
                                    source: this.id,
                                    cluster: bt.cluster || !1,
                                    geojsonVtOptions: {
                                        buffer: this._pixelsToTileUnits(void 0 !== bt.buffer ? bt.buffer : 128),
                                        tolerance: this._pixelsToTileUnits(void 0 !== bt.tolerance ? bt.tolerance : .375),
                                        extent: vt.a5,
                                        maxZoom: this.maxzoom,
                                        lineMetrics: bt.lineMetrics || !1,
                                        generateId: bt.generateId || !1
                                    },
                                    superclusterOptions: {
                                        maxZoom: this._getClusterMaxZoom(bt.clusterMaxZoom),
                                        minPoints: Math.max(2, bt.clusterMinPoints || 2),
                                        extent: vt.a5,
                                        radius: this._pixelsToTileUnits(bt.clusterRadius || 50),
                                        log: !1,
                                        generateId: bt.generateId || !1
                                    },
                                    clusterProperties: bt.clusterProperties,
                                    filter: bt.filter
                                }, bt.workerOptions), "string" == typeof this.promoteId && (this.workerOptions.promoteId = this.promoteId);
                            }
                            _hasPendingWorkerUpdate() {
                                return void 0 !== this._pendingWorkerUpdate.data || void 0 !== this._pendingWorkerUpdate.diff || this._pendingWorkerUpdate.optionsChanged;
                            }
                            _pixelsToTileUnits(le1) {
                                return le1 * (vt.a5 / this.tileSize);
                            }
                            _getClusterMaxZoom(le1) {
                                const bt = le1 ? Math.round(le1) : this.maxzoom - 1;
                                return Number.isInteger(le1) || void 0 === le1 || vt.w(`Integer expected for option 'clusterMaxZoom': provided value "${le1}" rounded to "${bt}"`), bt;
                            }
                            load() {
                                return vt._(this, void 0, void 0, function*() {
                                    yield this._updateWorkerData();
                                });
                            }
                            onAdd(le1) {
                                this.map = le1, this.load();
                            }
                            setData(le1, vt) {
                                this._data = "string" == typeof le1 ? {
                                    url: le1
                                } : {
                                    geojson: le1
                                }, this._pendingWorkerUpdate = {
                                    data: le1
                                };
                                const bt = this._updateWorkerData();
                                return vt ? bt : this;
                            }
                            updateData(le1, bt) {
                                this._pendingWorkerUpdate.diff = vt.a6(this._pendingWorkerUpdate.diff, le1);
                                const ls = this._updateWorkerData();
                                return bt ? ls : this;
                            }
                            getData() {
                                return vt._(this, void 0, void 0, function*() {
                                    const le1 = vt.e({
                                        type: this.type
                                    }, this.workerOptions);
                                    return this.actor.sendAsync({
                                        type: "GD",
                                        data: le1
                                    });
                                });
                            }
                            getBounds() {
                                return vt._(this, void 0, void 0, function*() {
                                    return J((yield this.getData()));
                                });
                            }
                            setClusterOptions(le1) {
                                return this.workerOptions.cluster = le1.cluster, void 0 !== le1.clusterRadius && (this.workerOptions.superclusterOptions.radius = this._pixelsToTileUnits(le1.clusterRadius)), void 0 !== le1.clusterMaxZoom && (this.workerOptions.superclusterOptions.maxZoom = this._getClusterMaxZoom(le1.clusterMaxZoom)), this._pendingWorkerUpdate.optionsChanged = !0, this._updateWorkerData(), this;
                            }
                            getClusterExpansionZoom(le1) {
                                return this.actor.sendAsync({
                                    type: "GCEZ",
                                    data: {
                                        type: this.type,
                                        clusterId: le1,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterChildren(le1) {
                                return this.actor.sendAsync({
                                    type: "GCC",
                                    data: {
                                        type: this.type,
                                        clusterId: le1,
                                        source: this.id
                                    }
                                });
                            }
                            getClusterLeaves(le1, vt, bt) {
                                return this.actor.sendAsync({
                                    type: "GCL",
                                    data: {
                                        type: this.type,
                                        source: this.id,
                                        clusterId: le1,
                                        limit: vt,
                                        offset: bt
                                    }
                                });
                            }
                            _updateWorkerData() {
                                return vt._(this, void 0, void 0, function*() {
                                    if (this._isUpdatingWorker) return;
                                    if (!this._hasPendingWorkerUpdate()) return void vt.w(`No pending worker updates for GeoJSONSource ${this.id}.`);
                                    const { data: le1, diff: bt } = this._pendingWorkerUpdate, ls = this._getLoadGeoJSONParameters(le1, bt);
                                    void 0 !== le1 ? this._pendingWorkerUpdate.data = void 0 : bt && (this._pendingWorkerUpdate.diff = void 0), this._pendingWorkerUpdate.optionsChanged = void 0, yield this._dispatchWorkerUpdate(ls);
                                });
                            }
                            _getLoadGeoJSONParameters(le1, bt) {
                                const ls = vt.e({
                                    type: this.type
                                }, this.workerOptions);
                                return "string" == typeof le1 ? (ls.request = this.map._requestManager.transformRequest(Fl.resolveURL(le1), "Source"), ls.request.collectResourceTiming = this._collectResourceTiming, ls) : void 0 !== le1 ? (ls.data = le1, ls) : bt ? (ls.dataDiff = bt, ls) : ls;
                            }
                            _dispatchWorkerUpdate(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    this._isUpdatingWorker = !0, this.fire(new vt.l("dataloading", {
                                        dataType: "source"
                                    }));
                                    try {
                                        const bt = yield this.actor.sendAsync({
                                            type: "LD",
                                            data: le1
                                        });
                                        if (this._isUpdatingWorker = !1, this._removed || bt.abandoned) return void this.fire(new vt.l("dataabort", {
                                            dataType: "source"
                                        }));
                                        bt.data && (this._data = {
                                            geojson: bt.data
                                        });
                                        const ls = this._applyDiffToSource(le1.dataDiff), ho = this._getShouldReloadTileOptions(ls), Dl = {
                                            dataType: "source"
                                        };
                                        this._applyResourceTiming(Dl, bt), this.fire(new vt.l("data", Object.assign(Object.assign({}, Dl), {
                                            sourceDataType: "metadata"
                                        }))), this.fire(new vt.l("data", Object.assign(Object.assign({}, Dl), {
                                            sourceDataType: "content",
                                            shouldReloadTileOptions: ho
                                        })));
                                    } catch (le1) {
                                        if (this._isUpdatingWorker = !1, this._removed) return void this.fire(new vt.l("dataabort", {
                                            dataType: "source"
                                        }));
                                        this.fire(new vt.k(le1));
                                    } finally{
                                        this._hasPendingWorkerUpdate() && this._updateWorkerData();
                                    }
                                });
                            }
                            _applyResourceTiming(le1, bt) {
                                var ls;
                                if (!this._collectResourceTiming) return;
                                const ho = null === (ls = bt.resourceTiming) || void 0 === ls ? void 0 : ls[this.id];
                                if (!ho) return;
                                const Dl = ho.slice(0);
                                (null == Dl ? void 0 : Dl.length) && vt.e(le1, {
                                    resourceTiming: Dl
                                });
                            }
                            _applyDiffToSource(le1) {
                                if (!le1) return;
                                const bt = "string" == typeof this.promoteId ? this.promoteId : void 0;
                                if (!this._data.url && !this._data.updateable) {
                                    const le1 = vt.a7(this._data.geojson, bt);
                                    if (!le1) throw new Error(`GeoJSONSource "${this.id}": GeoJSON data is not compatible with updateData`);
                                    this._data = {
                                        updateable: le1
                                    };
                                }
                                if (!this._data.updateable) return;
                                const ls = vt.a8(this._data.updateable, le1, bt);
                                return le1.removeAll || this._options.cluster ? void 0 : ls;
                            }
                            _getShouldReloadTileOptions(le1) {
                                if (le1) return {
                                    affectedBounds: le1.filter(Boolean).map((le1)=>J(le1))
                                };
                            }
                            shouldReloadTile(le1, { affectedBounds: bt }) {
                                if ("loading" === le1.state) return !0;
                                if ("unloaded" === le1.state) return !1;
                                const { buffer: ls, extent: ho } = this.workerOptions.geojsonVtOptions, Dl = function({ x: le1, y: bt, z: ls }, ho = 0) {
                                    const Dl = vt.a3((le1 - ho) / Math.pow(2, ls)), Fl = vt.a4((bt + 1 + ho) / Math.pow(2, ls)), sc = vt.a3((le1 + 1 + ho) / Math.pow(2, ls)), uc = vt.a4((bt - ho) / Math.pow(2, ls));
                                    return new $([
                                        Dl,
                                        Fl
                                    ], [
                                        sc,
                                        uc
                                    ]);
                                }(le1.tileID.canonical, ls / ho);
                                for (const vt of bt)if (Dl.intersects(vt)) return !0;
                                return !1;
                            }
                            loaded() {
                                return !this._isUpdatingWorker && !this._hasPendingWorkerUpdate();
                            }
                            loadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    const vt = le1.actor ? "RT" : "LT";
                                    le1.actor = this.actor;
                                    const bt = {
                                        type: this.type,
                                        uid: le1.uid,
                                        tileID: le1.tileID,
                                        zoom: le1.tileID.overscaledZ,
                                        maxZoom: this.maxzoom,
                                        tileSize: this.tileSize,
                                        source: this.id,
                                        pixelRatio: this.map.getPixelRatio(),
                                        showCollisionBoxes: this.map.showCollisionBoxes,
                                        promoteId: this.promoteId,
                                        subdivisionGranularity: this.map.style.projection.subdivisionGranularity
                                    };
                                    le1.abortController = new AbortController;
                                    const ls = yield this.actor.sendAsync({
                                        type: vt,
                                        data: bt
                                    }, le1.abortController);
                                    delete le1.abortController, le1.unloadVectorData(), le1.aborted || le1.loadVectorData(ls, this.map.painter, "RT" === vt);
                                });
                            }
                            abortTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.abortController && (le1.abortController.abort(), delete le1.abortController), le1.aborted = !0;
                                });
                            }
                            unloadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    le1.unloadVectorData(), yield this.actor.sendAsync({
                                        type: "RMT",
                                        data: {
                                            uid: le1.uid,
                                            type: this.type,
                                            source: this.id
                                        }
                                    });
                                });
                            }
                            onRemove() {
                                this._removed = !0, this.actor.sendAsync({
                                    type: "RS",
                                    data: {
                                        type: this.type,
                                        source: this.id
                                    }
                                });
                            }
                            serialize() {
                                return vt.e({}, this._options, {
                                    type: this.type,
                                    data: this._data.updateable ? {
                                        type: "FeatureCollection",
                                        features: Array.from(this._data.updateable.values())
                                    } : this._data.url || this._data.geojson
                                });
                            }
                            hasTransition() {
                                return !1;
                            }
                        }
                        class te extends vt.E {
                            constructor(le1, vt, bt, ls){
                                super(), this.flippedWindingOrder = !1, this.id = le1, this.dispatcher = bt, this.coordinates = vt.coordinates, this.type = "image", this.minzoom = 0, this.maxzoom = 22, this.tileSize = 512, this.tiles = {}, this._loaded = !1, this.setEventedParent(ls), this.options = vt;
                            }
                            load(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    this._loaded = !1, this.fire(new vt.l("dataloading", {
                                        dataType: "source"
                                    })), this.url = this.options.url, this._request = new AbortController;
                                    try {
                                        const vt = yield kc.getImage(this.map._requestManager.transformRequest(this.url, "Image"), this._request);
                                        this._request = null, this._loaded = !0, vt && vt.data && (this.image = vt.data, le1 && (this.coordinates = le1), this._finishLoading());
                                    } catch (le1) {
                                        this._request = null, this._loaded = !0, vt.Z(le1) || this.fire(new vt.k(le1));
                                    }
                                });
                            }
                            loaded() {
                                return this._loaded;
                            }
                            updateImage(le1) {
                                return le1.url ? (this._request && (this._request.abort(), this._request = null), this.options.url = le1.url, this.load(le1.coordinates).finally(()=>{
                                    this.texture = null;
                                }), this) : this;
                            }
                            _finishLoading() {
                                this.map && (this.setCoordinates(this.coordinates), this.fire(new vt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "metadata"
                                })));
                            }
                            onAdd(le1) {
                                this.map = le1, this.load();
                            }
                            onRemove() {
                                this._request && (this._request.abort(), this._request = null);
                            }
                            setCoordinates(le1) {
                                this.coordinates = le1;
                                const bt = le1.map(vt.a9.fromLngLat);
                                var ls;
                                return this.tileID = function(le1) {
                                    const bt = vt.aa.fromPoints(le1), ls = bt.width(), ho = bt.height(), Dl = Math.max(ls, ho), Fl = Math.max(0, Math.floor(-Math.log(Dl) / Math.LN2)), sc = Math.pow(2, Fl);
                                    return new vt.ac(Fl, Math.floor((bt.minX + bt.maxX) / 2 * sc), Math.floor((bt.minY + bt.maxY) / 2 * sc));
                                }(bt), this.terrainTileRanges = this._getOverlappingTileRanges(bt), this.minzoom = this.maxzoom = this.tileID.z, this.tileCoords = bt.map((le1)=>this.tileID.getTilePoint(le1)._round()), this.flippedWindingOrder = ((ls = this.tileCoords)[1].x - ls[0].x) * (ls[2].y - ls[0].y) - (ls[1].y - ls[0].y) * (ls[2].x - ls[0].x) < 0, this.fire(new vt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "content"
                                })), this;
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || !this.image) return;
                                const le1 = this.map.painter.context, bt = le1.gl;
                                this.texture || (this.texture = new vt.T(le1, this.image, bt.RGBA), this.texture.bind(bt.LINEAR, bt.CLAMP_TO_EDGE));
                                let ls = !1;
                                for(const vt in this.tiles){
                                    const le1 = this.tiles[vt];
                                    "loaded" !== le1.state && (le1.state = "loaded", le1.texture = this.texture, ls = !0);
                                }
                                ls && this.fire(new vt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            loadTile(le1) {
                                return vt._(this, void 0, void 0, function*() {
                                    this.tileID && this.tileID.equals(le1.tileID.canonical) ? (this.tiles[String(le1.tileID.wrap)] = le1, le1.buckets = {}) : le1.state = "errored";
                                });
                            }
                            serialize() {
                                return {
                                    type: "image",
                                    url: this.options.url,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return !1;
                            }
                            _getOverlappingTileRanges(le1) {
                                const { minX: bt, minY: ls, maxX: ho, maxY: Dl } = vt.aa.fromPoints(le1), Fl = {};
                                for(let sc = 0; sc <= vt.ab; sc++){
                                    const le1 = Math.pow(2, sc), vt = Math.floor(bt * le1), uc = Math.floor(ls * le1), mc = Math.floor(ho * le1), gc = Math.floor(Dl * le1), Ac = (vt % le1 + le1) % le1, Ec = mc % le1, kc = Math.floor(vt / le1), du = Math.floor(mc / le1);
                                    Fl[sc] = {
                                        minWrap: kc,
                                        maxWrap: du,
                                        minTileXWrapped: Ac,
                                        maxTileXWrapped: Ec,
                                        minTileY: uc,
                                        maxTileY: gc
                                    };
                                }
                                return Fl;
                            }
                        }
                        class ie extends te {
                            constructor(le1, vt, bt, ls){
                                super(le1, vt, bt, ls), this.roundZoom = !0, this.type = "video", this.options = vt;
                            }
                            load() {
                                return vt._(this, void 0, void 0, function*() {
                                    this._loaded = !1;
                                    const le1 = this.options;
                                    this.urls = [];
                                    for (const vt of le1.urls)this.urls.push(this.map._requestManager.transformRequest(vt, "Source").url);
                                    try {
                                        const le1 = yield vt.ad(this.urls);
                                        if (this._loaded = !0, !le1) return;
                                        this.video = le1, this.video.loop = !0, this.video.addEventListener("playing", ()=>{
                                            this.map.triggerRepaint();
                                        }), this.map && this.video.play(), this._finishLoading();
                                    } catch (le1) {
                                        this.fire(new vt.k(le1));
                                    }
                                });
                            }
                            pause() {
                                this.video && this.video.pause();
                            }
                            play() {
                                this.video && this.video.play();
                            }
                            seek(le1) {
                                if (this.video) {
                                    const bt = this.video.seekable;
                                    le1 < bt.start(0) || le1 > bt.end(0) ? this.fire(new vt.k(new vt.ae(`sources.${this.id}`, null, `Playback for this video can be set only between the ${bt.start(0)} and ${bt.end(0)}-second mark.`))) : this.video.currentTime = le1;
                                }
                            }
                            getVideo() {
                                return this.video;
                            }
                            onAdd(le1) {
                                this.map || (this.map = le1, this.load(), this.video && (this.video.play(), this.setCoordinates(this.coordinates)));
                            }
                            prepare() {
                                if (0 === Object.keys(this.tiles).length || this.video.readyState < 2) return;
                                const le1 = this.map.painter.context, bt = le1.gl;
                                this.texture ? this.video.paused || (this.texture.bind(bt.LINEAR, bt.CLAMP_TO_EDGE), bt.texSubImage2D(bt.TEXTURE_2D, 0, 0, 0, bt.RGBA, bt.UNSIGNED_BYTE, this.video)) : (this.texture = new vt.T(le1, this.video, bt.RGBA), this.texture.bind(bt.LINEAR, bt.CLAMP_TO_EDGE));
                                let ls = !1;
                                for(const vt in this.tiles){
                                    const le1 = this.tiles[vt];
                                    "loaded" !== le1.state && (le1.state = "loaded", le1.texture = this.texture, ls = !0);
                                }
                                ls && this.fire(new vt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "video",
                                    urls: this.urls,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this.video && !this.video.paused;
                            }
                        }
                        class ae extends te {
                            constructor(le1, bt, ls, ho){
                                super(le1, bt, ls, ho), bt.coordinates ? Array.isArray(bt.coordinates) && 4 === bt.coordinates.length && !bt.coordinates.some((le1)=>!Array.isArray(le1) || 2 !== le1.length || le1.some((le1)=>"number" != typeof le1)) || this.fire(new vt.k(new vt.ae(`sources.${le1}`, null, '"coordinates" property must be an array of 4 longitude/latitude array pairs'))) : this.fire(new vt.k(new vt.ae(`sources.${le1}`, null, 'missing required property "coordinates"'))), bt.animate && "boolean" != typeof bt.animate && this.fire(new vt.k(new vt.ae(`sources.${le1}`, null, 'optional "animate" property must be a boolean value'))), bt.canvas ? "string" == typeof bt.canvas || bt.canvas instanceof HTMLCanvasElement || this.fire(new vt.k(new vt.ae(`sources.${le1}`, null, '"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))) : this.fire(new vt.k(new vt.ae(`sources.${le1}`, null, 'missing required property "canvas"'))), this.options = bt, this.animate = void 0 === bt.animate || bt.animate;
                            }
                            load() {
                                return vt._(this, void 0, void 0, function*() {
                                    this._loaded = !0, this.canvas || (this.canvas = this.options.canvas instanceof HTMLCanvasElement ? this.options.canvas : document.getElementById(this.options.canvas)), this.width = this.canvas.width, this.height = this.canvas.height, this._hasInvalidDimensions() ? this.fire(new vt.k(new Error("Canvas dimensions cannot be less than or equal to zero."))) : (this.play = function() {
                                        this._playing = !0, this.map.triggerRepaint();
                                    }, this.pause = function() {
                                        this._playing && (this.prepare(), this._playing = !1);
                                    }, this._finishLoading());
                                });
                            }
                            getCanvas() {
                                return this.canvas;
                            }
                            onAdd(le1) {
                                this.map = le1, this.load(), this.canvas && this.animate && this.play();
                            }
                            onRemove() {
                                this.pause();
                            }
                            prepare() {
                                let le1 = !1;
                                if (this.canvas.width !== this.width && (this.width = this.canvas.width, le1 = !0), this.canvas.height !== this.height && (this.height = this.canvas.height, le1 = !0), this._hasInvalidDimensions()) return;
                                if (0 === Object.keys(this.tiles).length) return;
                                const bt = this.map.painter.context, ls = bt.gl;
                                this.texture ? (le1 || this._playing) && this.texture.update(this.canvas, {
                                    premultiply: !0
                                }) : (this.texture = new vt.T(bt, this.canvas, ls.RGBA, {
                                    premultiply: !0
                                }), this.texture.bind(ls.LINEAR, ls.CLAMP_TO_EDGE));
                                let ho = !1;
                                for(const vt in this.tiles){
                                    const le1 = this.tiles[vt];
                                    "loaded" !== le1.state && (le1.state = "loaded", le1.texture = this.texture, ho = !0);
                                }
                                ho && this.fire(new vt.l("data", {
                                    dataType: "source",
                                    sourceDataType: "idle",
                                    sourceId: this.id
                                }));
                            }
                            serialize() {
                                return {
                                    type: "canvas",
                                    animate: this.animate,
                                    canvas: this.options.canvas,
                                    coordinates: this.coordinates
                                };
                            }
                            hasTransition() {
                                return this._playing;
                            }
                            _hasInvalidDimensions() {
                                for (const le1 of [
                                    this.canvas.width,
                                    this.canvas.height
                                ])if (isNaN(le1) || le1 <= 0) return !0;
                                return !1;
                            }
                        }
                        const Ud = {}, re = (le1)=>{
                            switch(le1){
                                case "geojson":
                                    return ee;
                                case "image":
                                    return te;
                                case "raster":
                                    return K;
                                case "raster-dem":
                                    return Y;
                                case "vector":
                                    return X;
                                case "video":
                                    return ie;
                                case "canvas":
                                    return ae;
                            }
                            return Ud[le1];
                        }, Gd = "RTLPluginLoaded";
                        class ne extends vt.E {
                            constructor(){
                                super(...arguments), this.status = "unavailable", this.url = null, this.dispatcher = Z();
                            }
                            _syncState(le1) {
                                return this.status = le1, this.dispatcher.broadcast("SRPS", {
                                    pluginStatus: le1,
                                    pluginURL: this.url
                                }).catch((le1)=>{
                                    throw this.status = "error", le1;
                                });
                            }
                            getRTLTextPluginStatus() {
                                return this.status;
                            }
                            clearRTLTextPlugin() {
                                this.status = "unavailable", this.url = null;
                            }
                            setRTLTextPlugin(le1) {
                                return vt._(this, arguments, void 0, function*(le1, vt = !1) {
                                    if (this.url) throw new Error("setRTLTextPlugin cannot be called multiple times.");
                                    if (this.url = Fl.resolveURL(le1), !this.url) throw new Error(`requested url ${le1} is invalid`);
                                    if ("unavailable" === this.status) {
                                        if (!vt) return this._requestImport();
                                        this.status = "deferred", this._syncState(this.status);
                                    } else if ("requested" === this.status) return this._requestImport();
                                });
                            }
                            _requestImport() {
                                return vt._(this, void 0, void 0, function*() {
                                    yield this._syncState("loading"), this.status = "loaded", this.fire(new vt.l(Gd));
                                });
                            }
                            lazyLoad() {
                                "unavailable" === this.status ? this.status = "requested" : "deferred" === this.status && this._requestImport();
                            }
                        }
                        let qd = null;
                        function ce() {
                            return qd || (qd = new ne), qd;
                        }
                        var Hd, Wd;
                        !function(le1) {
                            le1[le1.Base = 0] = "Base", le1[le1.Parent = 1] = "Parent";
                        }(Hd || (Hd = {})), function(le1) {
                            le1[le1.Departing = 0] = "Departing", le1[le1.Incoming = 1] = "Incoming";
                        }(Wd || (Wd = {}));
                        class de {
                            constructor(le1, bt){
                                this.timeAdded = 0, this.fadeEndTime = 0, this.fadeOpacity = 1, this.tileID = le1, this.uid = vt.af(), this.uses = 0, this.tileSize = bt, this.buckets = {}, this.expirationTime = null, this.queryPadding = 0, this.hasSymbolBuckets = !1, this.hasRTLText = !1, this.dependencies = {}, this.rtt = [], this.rttCoords = {}, this.expiredRequestCount = 0, this.state = "loading";
                            }
                            isRenderable(le1) {
                                return this.hasData() && (!this.fadeEndTime || this.fadeOpacity > 0) && (le1 || !this.holdingForSymbolFade());
                            }
                            setCrossFadeLogic({ fadingRole: le1, fadingDirection: vt, fadingParentID: bt, fadeEndTime: ls }) {
                                this.resetFadeLogic(), this.fadingRole = le1, this.fadingDirection = vt, this.fadingParentID = bt, this.fadeEndTime = ls;
                            }
                            setSelfFadeLogic(le1) {
                                this.resetFadeLogic(), this.selfFading = !0, this.fadeEndTime = le1;
                            }
                            resetFadeLogic() {
                                this.fadingRole = null, this.fadingDirection = null, this.fadingParentID = null, this.selfFading = !1, this.timeAdded = c(), this.fadeEndTime = 0, this.fadeOpacity = 1;
                            }
                            wasRequested() {
                                return "errored" === this.state || "loaded" === this.state || "reloading" === this.state;
                            }
                            clearTextures(le1) {
                                this.demTexture && le1.saveTileTexture(this.demTexture), this.demTexture = null;
                            }
                            loadVectorData(le1, bt, ls) {
                                if (this.hasData() && this.unloadVectorData(), this.state = "loaded", le1) {
                                    le1.featureIndex && (this.latestFeatureIndex = le1.featureIndex, le1.rawTileData ? (this.latestRawTileData = le1.rawTileData, this.latestFeatureIndex.rawTileData = le1.rawTileData, this.latestFeatureIndex.encoding = le1.encoding) : this.latestRawTileData && (this.latestFeatureIndex.rawTileData = this.latestRawTileData, this.latestFeatureIndex.encoding = this.latestEncoding)), this.collisionBoxArray = le1.collisionBoxArray, this.buckets = function(le1, vt) {
                                        const bt = {};
                                        if (!vt) return bt;
                                        for (const ls of le1){
                                            const le1 = ls.layerIds.map((le1)=>vt.getLayer(le1)).filter(Boolean);
                                            if (0 !== le1.length) {
                                                ls.layers = le1, ls.stateDependentLayerIds && (ls.stateDependentLayers = ls.stateDependentLayerIds.map((vt)=>le1.filter((le1)=>le1.id === vt)[0]));
                                                for (const vt of le1)bt[vt.id] = ls;
                                            }
                                        }
                                        return bt;
                                    }(le1.buckets, null == bt ? void 0 : bt.style), this.hasSymbolBuckets = !1;
                                    for(const le1 in this.buckets){
                                        const bt = this.buckets[le1];
                                        if (bt instanceof vt.ah) {
                                            if (this.hasSymbolBuckets = !0, !ls) break;
                                            bt.justReloaded = !0;
                                        }
                                    }
                                    if (this.hasRTLText = !1, this.hasSymbolBuckets) for(const le1 in this.buckets){
                                        const bt = this.buckets[le1];
                                        if (bt instanceof vt.ah && bt.hasRTLText) {
                                            this.hasRTLText = !0, ce().lazyLoad();
                                            break;
                                        }
                                    }
                                    this.queryPadding = 0;
                                    for(const le1 in this.buckets){
                                        const vt = this.buckets[le1];
                                        this.queryPadding = Math.max(this.queryPadding, bt.style.getLayer(le1).queryRadius(vt));
                                    }
                                    le1.imageAtlas && (this.imageAtlas = le1.imageAtlas), le1.glyphAtlasImage && (this.glyphAtlasImage = le1.glyphAtlasImage), this.dashPositions = le1.dashPositions;
                                } else this.collisionBoxArray = new vt.ag;
                            }
                            unloadVectorData() {
                                for(const le1 in this.buckets)this.buckets[le1].destroy();
                                this.buckets = {}, this.imageAtlasTexture && this.imageAtlasTexture.destroy(), this.imageAtlas && (this.imageAtlas = null), this.glyphAtlasTexture && this.glyphAtlasTexture.destroy(), this.dashPositions && (this.dashPositions = null), this.latestFeatureIndex = null, this.state = "unloaded";
                            }
                            getBucket(le1) {
                                return this.buckets[le1.id];
                            }
                            upload(le1) {
                                for(const vt in this.buckets){
                                    const bt = this.buckets[vt];
                                    bt.uploadPending() && bt.upload(le1);
                                }
                                const bt = le1.gl;
                                this.imageAtlas && !this.imageAtlas.uploaded && (this.imageAtlasTexture = new vt.T(le1, this.imageAtlas.image, bt.RGBA), this.imageAtlas.uploaded = !0), this.glyphAtlasImage && (this.glyphAtlasTexture = new vt.T(le1, this.glyphAtlasImage, bt.ALPHA), this.glyphAtlasImage = null);
                            }
                            prepare(le1) {
                                this.imageAtlas && this.imageAtlas.patchUpdatedImages(le1, this.imageAtlasTexture);
                            }
                            queryRenderedFeatures(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                                return this.latestFeatureIndex && this.latestFeatureIndex.rawTileData ? this.latestFeatureIndex.query({
                                    queryGeometry: ls,
                                    cameraQueryGeometry: ho,
                                    scale: Dl,
                                    tileSize: this.tileSize,
                                    pixelPosMatrix: mc,
                                    transform: sc,
                                    params: Fl,
                                    queryPadding: this.queryPadding * uc,
                                    getElevation: gc
                                }, le1, vt, bt) : {};
                            }
                            querySourceFeatures(le1, bt) {
                                const ls = this.latestFeatureIndex;
                                if (!ls || !ls.rawTileData) return;
                                const ho = ls.loadVTLayers(), Dl = bt && bt.sourceLayer ? bt.sourceLayer : "", Fl = ho[vt.ai] || ho[Dl];
                                if (!Fl) return;
                                const sc = vt.aj(null == bt ? void 0 : bt.filter, null == bt ? void 0 : bt.globalState), { z: uc, x: mc, y: gc } = this.tileID.canonical, Ac = {
                                    z: uc,
                                    x: mc,
                                    y: gc
                                };
                                for(let Ec = 0; Ec < Fl.length; Ec++){
                                    const bt = Fl.feature(Ec);
                                    if (sc.needGeometry) {
                                        const le1 = vt.ak(bt, !0);
                                        if (!sc.filter(new vt.H(this.tileID.overscaledZ), le1, this.tileID.canonical)) continue;
                                    } else if (!sc.filter(new vt.H(this.tileID.overscaledZ), bt)) continue;
                                    const ho = ls.getId(bt, Dl), kc = new vt.al(bt, uc, mc, gc, ho);
                                    kc.tile = Ac, le1.push(kc);
                                }
                            }
                            hasData() {
                                return "loaded" === this.state || "reloading" === this.state || "expired" === this.state;
                            }
                            patternsLoaded() {
                                return this.imageAtlas && !!Object.keys(this.imageAtlas.patternPositions).length;
                            }
                            setExpiryData(le1) {
                                const bt = this.expirationTime;
                                if (le1.cacheControl) {
                                    const bt = vt.am(le1.cacheControl);
                                    bt["max-age"] && (this.expirationTime = Date.now() + 1e3 * bt["max-age"]);
                                } else le1.expires && (this.expirationTime = new Date(le1.expires).getTime());
                                if (this.expirationTime) {
                                    const le1 = Date.now();
                                    let vt = !1;
                                    if (this.expirationTime > le1) vt = !1;
                                    else if (bt) {
                                        if (this.expirationTime < bt) vt = !0;
                                        else {
                                            const ls = this.expirationTime - bt;
                                            ls ? this.expirationTime = le1 + Math.max(ls, 3e4) : vt = !0;
                                        }
                                    } else vt = !0;
                                    vt ? (this.expiredRequestCount++, this.state = "expired") : this.expiredRequestCount = 0;
                                }
                            }
                            getExpiryTimeout() {
                                if (this.expirationTime) return this.expiredRequestCount ? 1e3 * (1 << Math.min(this.expiredRequestCount - 1, 31)) : Math.min(this.expirationTime - (new Date).getTime(), Math.pow(2, 31) - 1);
                            }
                            setFeatureState(le1, bt) {
                                if (!this.latestFeatureIndex || !this.latestFeatureIndex.rawTileData || 0 === Object.keys(le1).length) return;
                                const ls = this.latestFeatureIndex.loadVTLayers();
                                for(const ho in this.buckets){
                                    if (!bt.style.hasLayer(ho)) continue;
                                    const Dl = this.buckets[ho], Fl = Dl.layers[0].sourceLayer || vt.ai, sc = ls[Fl], uc = le1[Fl];
                                    if (!sc || !uc || 0 === Object.keys(uc).length) continue;
                                    Dl.update(uc, sc, this.imageAtlas && this.imageAtlas.patternPositions || {}, this.dashPositions || {});
                                    const mc = bt && bt.style && bt.style.getLayer(ho);
                                    mc && (this.queryPadding = Math.max(this.queryPadding, mc.queryRadius(Dl)));
                                }
                            }
                            holdingForSymbolFade() {
                                return void 0 !== this.symbolFadeHoldUntil;
                            }
                            symbolFadeFinished() {
                                return !this.symbolFadeHoldUntil || this.symbolFadeHoldUntil < c();
                            }
                            clearSymbolFadeHold() {
                                this.symbolFadeHoldUntil = void 0;
                            }
                            setSymbolHoldDuration(le1) {
                                this.symbolFadeHoldUntil = c() + le1;
                            }
                            setDependencies(le1, vt) {
                                const bt = {};
                                for (const ls of vt)bt[ls] = !0;
                                this.dependencies[le1] = bt;
                            }
                            hasDependency(le1, vt) {
                                for (const bt of le1){
                                    const le1 = this.dependencies[bt];
                                    if (le1) {
                                        for (const bt of vt)if (le1[bt]) return !0;
                                    }
                                }
                                return !1;
                            }
                        }
                        class _e {
                            constructor(){
                                this.state = {}, this.stateChanges = {}, this.deletedStates = {};
                            }
                            updateState(le1, bt, ls) {
                                const ho = String(bt);
                                if (this.stateChanges[le1] = this.stateChanges[le1] || {}, this.stateChanges[le1][ho] = this.stateChanges[le1][ho] || {}, vt.e(this.stateChanges[le1][ho], ls), null === this.deletedStates[le1]) {
                                    this.deletedStates[le1] = {};
                                    for(const vt in this.state[le1])vt !== ho && (this.deletedStates[le1][vt] = null);
                                } else if (this.deletedStates[le1] && null === this.deletedStates[le1][ho]) {
                                    this.deletedStates[le1][ho] = {};
                                    for(const vt in this.state[le1][ho])ls[vt] || (this.deletedStates[le1][ho][vt] = null);
                                } else for(const vt in ls)this.deletedStates[le1] && this.deletedStates[le1][ho] && null === this.deletedStates[le1][ho][vt] && delete this.deletedStates[le1][ho][vt];
                            }
                            removeFeatureState(le1, vt, bt) {
                                if (null === this.deletedStates[le1]) return;
                                const ls = String(vt);
                                if (this.deletedStates[le1] = this.deletedStates[le1] || {}, bt && void 0 !== vt) null !== this.deletedStates[le1][ls] && (this.deletedStates[le1][ls] = this.deletedStates[le1][ls] || {}, this.deletedStates[le1][ls][bt] = null);
                                else if (void 0 !== vt) {
                                    if (this.stateChanges[le1] && this.stateChanges[le1][ls]) for(bt in this.deletedStates[le1][ls] = {}, this.stateChanges[le1][ls])this.deletedStates[le1][ls][bt] = null;
                                    else this.deletedStates[le1][ls] = null;
                                } else this.deletedStates[le1] = null;
                            }
                            getState(le1, bt) {
                                const ls = String(bt), ho = vt.e({}, (this.state[le1] || {})[ls], (this.stateChanges[le1] || {})[ls]);
                                if (null === this.deletedStates[le1]) return {};
                                if (this.deletedStates[le1]) {
                                    const vt = this.deletedStates[le1][bt];
                                    if (null === vt) return {};
                                    for(const le1 in vt)delete ho[le1];
                                }
                                return ho;
                            }
                            initializeTileState(le1, vt) {
                                le1.setFeatureState(this.state, vt);
                            }
                            coalesceChanges(le1, bt) {
                                const ls = {};
                                for(const ho in this.stateChanges){
                                    this.state[ho] = this.state[ho] || {};
                                    const le1 = {};
                                    for(const bt in this.stateChanges[ho])this.state[ho][bt] || (this.state[ho][bt] = {}), vt.e(this.state[ho][bt], this.stateChanges[ho][bt]), le1[bt] = this.state[ho][bt];
                                    ls[ho] = le1;
                                }
                                for(const ho in this.deletedStates){
                                    this.state[ho] = this.state[ho] || {};
                                    const le1 = {};
                                    if (null === this.deletedStates[ho]) for(const vt in this.state[ho])le1[vt] = {}, this.state[ho][vt] = {};
                                    else for(const vt in this.deletedStates[ho]){
                                        if (null === this.deletedStates[ho][vt]) this.state[ho][vt] = {};
                                        else for (const le1 of Object.keys(this.deletedStates[ho][vt]))delete this.state[ho][vt][le1];
                                        le1[vt] = this.state[ho][vt];
                                    }
                                    ls[ho] = ls[ho] || {}, vt.e(ls[ho], le1);
                                }
                                this.stateChanges = {}, this.deletedStates = {}, 0 !== Object.keys(ls).length && le1.setFeatureState(ls, bt);
                            }
                        }
                        const Zd = 89.25;
                        function me(le1, bt) {
                            const ls = vt.an(bt.lat, -vt.ao, vt.ao);
                            return new vt.P(vt.Y(bt.lng) * le1, vt.X(ls) * le1);
                        }
                        function fe(le1, bt) {
                            return new vt.a9(bt.x / le1, bt.y / le1).toLngLat();
                        }
                        function ge(le1) {
                            return le1.cameraToCenterDistance * Math.min(.85 * Math.tan(vt.ap(90 - le1.pitch)), Math.tan(vt.ap(Zd - le1.pitch)));
                        }
                        function ve(le1, bt) {
                            const ls = le1.canonical, ho = bt / vt.aq(ls.z), Dl = ls.x + Math.pow(2, ls.z) * le1.wrap, Fl = vt.ar(new Float64Array(16));
                            return vt.O(Fl, Fl, [
                                Dl * ho,
                                ls.y * ho,
                                0
                            ]), vt.Q(Fl, Fl, [
                                ho / vt.a5,
                                ho / vt.a5,
                                1
                            ]), Fl;
                        }
                        function xe(le1, bt, ls, ho, Dl) {
                            const Fl = vt.a9.fromLngLat(le1, bt), sc = Dl * vt.as(1, le1.lat), { x: uc, y: mc, z: gc } = be(ls, ho);
                            return new vt.a9(Fl.x + sc * -uc, Fl.y + sc * -mc, Fl.z + sc * -gc);
                        }
                        function be(le1, bt) {
                            const ls = vt.ap(le1), ho = vt.ap(bt), Dl = Math.cos(-ls), Fl = Math.sin(ls);
                            return {
                                x: Fl * Math.sin(ho),
                                y: -Fl * Math.cos(ho),
                                z: Dl
                            };
                        }
                        function ye(le1, vt, bt) {
                            const ls = vt.intersectsFrustum(le1);
                            if (!bt || 0 === ls) return ls;
                            const ho = vt.intersectsPlane(bt);
                            return 0 === ho ? 0 : 2 === ls && 2 === ho ? 2 : 1;
                        }
                        function we(le1, vt, bt) {
                            let ls = 0;
                            const ho = (bt - vt) / 10;
                            for(let Dl = 0; Dl < 10; Dl++)ls += ho * Math.pow(Math.cos(vt + (Dl + .5) / 10 * (bt - vt)), le1);
                            return ls;
                        }
                        function Te(le1, bt) {
                            return function(ls, ho, Dl, Fl, sc) {
                                const uc = 2 * ((le1 - 1) / vt.at(Math.cos(vt.ap(Zd - sc)) / Math.cos(vt.ap(Zd))) - 1), mc = Math.acos(Dl / Fl), gc = 2 * we(uc - 1, 0, vt.ap(sc / 2)), Ac = Math.min(vt.ap(Zd), mc + vt.ap(sc / 2)), Ec = we(uc - 1, Math.min(Ac, mc - vt.ap(sc / 2)), Ac), kc = Math.atan(ho / Dl), du = Math.hypot(ho, Dl);
                                let _u = ls;
                                return _u += vt.at(Fl / du / Math.max(.5, Math.cos(vt.ap(sc / 2)))), _u += uc * vt.at(Math.cos(kc)) / 2, _u -= vt.at(Math.max(1, Ec / gc / bt)) / 2, _u;
                            };
                        }
                        const Yd = Te(9.314, 3);
                        function Ce(le1, bt) {
                            const ls = (bt.roundZoom ? Math.round : Math.floor)(le1.zoom + vt.at(le1.tileSize / bt.tileSize));
                            return Math.max(0, ls);
                        }
                        function Ie(le1, bt) {
                            const ls = le1.getCameraFrustum(), ho = le1.getClippingPlane(), Dl = le1.screenPointToMercatorCoordinate(le1.getCameraPoint()), Fl = vt.a9.fromLngLat(le1.center, le1.elevation);
                            Dl.z = Fl.z + Math.cos(le1.pitchInRadians) * le1.cameraToCenterDistance / le1.worldSize;
                            const sc = le1.getCoveringTilesDetailsProvider(), uc = sc.allowVariableZoom(le1, bt), mc = Ce(le1, bt), gc = bt.minzoom || 0, Ac = void 0 !== bt.maxzoom ? bt.maxzoom : le1.maxZoom, Ec = Math.min(Math.max(0, mc), Ac), kc = Math.pow(2, Ec), du = [
                                kc * Dl.x,
                                kc * Dl.y,
                                0
                            ], _u = [
                                kc * Fl.x,
                                kc * Fl.y,
                                0
                            ], Md = Math.hypot(Fl.x - Dl.x, Fl.y - Dl.y), Ld = Math.abs(Fl.z - Dl.z), Nd = Math.hypot(Md, Ld), x = (le1)=>({
                                    zoom: 0,
                                    x: 0,
                                    y: 0,
                                    wrap: le1,
                                    fullyVisible: !1
                                }), Rd = [], Od = [];
                            if (le1.renderWorldCopies && sc.allowWorldCopies()) for(let vt = 1; vt <= 3; vt++)Rd.push(x(-vt)), Rd.push(x(vt));
                            for(Rd.push(x(0)); Rd.length > 0;){
                                const kc = Rd.pop(), Md = kc.x, jd = kc.y;
                                let Ud = kc.fullyVisible;
                                const Gd = {
                                    x: Md,
                                    y: jd,
                                    z: kc.zoom
                                }, qd = sc.getTileBoundingVolume(Gd, kc.wrap, le1.elevation, bt);
                                if (!Ud) {
                                    const le1 = ye(ls, qd, ho);
                                    if (0 === le1) continue;
                                    Ud = 2 === le1;
                                }
                                const Hd = sc.distanceToTile2d(Dl.x, Dl.y, Gd, qd);
                                let Wd = mc;
                                uc && (Wd = (bt.calculateTileZoom || Yd)(le1.zoom + vt.at(le1.tileSize / bt.tileSize), Hd, Ld, Nd, le1.fov)), Wd = (bt.roundZoom ? Math.round : Math.floor)(Wd), Wd = Math.max(0, Wd);
                                const Zd = Math.min(Wd, Ac);
                                if (kc.wrap = sc.getWrap(Fl, Gd, kc.wrap), kc.zoom >= Zd) {
                                    if (kc.zoom < gc) continue;
                                    const le1 = Ec - kc.zoom, ls = du[0] - .5 - (Md << le1), ho = du[1] - .5 - (jd << le1), Dl = bt.reparseOverscaled ? Math.max(kc.zoom, Wd) : kc.zoom;
                                    Od.push({
                                        tileID: new vt.a2(kc.zoom === Ac ? Dl : kc.zoom, kc.wrap, kc.zoom, Md, jd),
                                        distanceSq: vt.au([
                                            _u[0] - .5 - Md,
                                            _u[1] - .5 - jd
                                        ]),
                                        tileDistanceToCamera: Math.sqrt(ls * ls + ho * ho)
                                    });
                                } else for(let le1 = 0; le1 < 4; le1++)Rd.push({
                                    zoom: kc.zoom + 1,
                                    x: (Md << 1) + le1 % 2,
                                    y: (jd << 1) + (le1 >> 1),
                                    wrap: kc.wrap,
                                    fullyVisible: Ud
                                });
                            }
                            return Od.sort((le1, vt)=>le1.distanceSq - vt.distanceSq).map((le1)=>le1.tileID);
                        }
                        const Qd = vt.aa.fromPoints([
                            new vt.P(0, 0),
                            new vt.P(vt.a5, vt.a5)
                        ]);
                        function Ee(le1) {
                            return "raster" === le1 || "image" === le1 || "video" === le1;
                        }
                        function Se(le1, vt, bt, ls, ho, Dl, Fl) {
                            if (!vt.hasData()) return !1;
                            const { tileID: sc, fadingRole: uc, fadingDirection: mc, fadingParentID: gc } = vt;
                            if (uc === Hd.Base && mc === Wd.Incoming && gc) return bt[gc.key] = gc, !0;
                            const Ac = Math.max(sc.overscaledZ - ho, Dl);
                            for(let Ec = sc.overscaledZ - 1; Ec >= Ac; Ec--){
                                const ho = sc.scaledTo(Ec), Dl = le1.getLoadedTile(ho);
                                if (Dl) return vt.setCrossFadeLogic({
                                    fadingRole: Hd.Base,
                                    fadingDirection: Wd.Incoming,
                                    fadingParentID: Dl.tileID,
                                    fadeEndTime: ls + Fl
                                }), Dl.setCrossFadeLogic({
                                    fadingRole: Hd.Parent,
                                    fadingDirection: Wd.Departing,
                                    fadeEndTime: ls + Fl
                                }), bt[ho.key] = ho, !0;
                            }
                            return !1;
                        }
                        function ze(le1, vt, bt, ls, ho, Dl) {
                            if (!vt.hasData()) return !1;
                            const Fl = vt.tileID.children(ho);
                            let sc = Re(le1, vt, Fl, bt, ls, ho, Dl);
                            if (sc) return !0;
                            for (const uc of Fl)Re(le1, vt, uc.children(ho), bt, ls, ho, Dl) && (sc = !0);
                            return sc;
                        }
                        function Re(le1, vt, bt, ls, ho, Dl, Fl) {
                            if (bt[0].overscaledZ >= Dl) return !1;
                            let sc = !1;
                            for (const uc of bt){
                                const bt = le1.getLoadedTile(uc);
                                if (!bt) continue;
                                const { fadingRole: Dl, fadingDirection: mc, fadingParentID: gc } = bt;
                                Dl === Hd.Base && mc === Wd.Departing && gc || (bt.setCrossFadeLogic({
                                    fadingRole: Hd.Base,
                                    fadingDirection: Wd.Departing,
                                    fadingParentID: vt.tileID,
                                    fadeEndTime: ho + Fl
                                }), vt.setCrossFadeLogic({
                                    fadingRole: Hd.Parent,
                                    fadingDirection: Wd.Incoming,
                                    fadeEndTime: ho + Fl
                                })), ls[uc.key] = uc, sc = !0;
                            }
                            return sc;
                        }
                        function De(le1, vt, bt, ls) {
                            const ho = le1.tileID;
                            return !!le1.selfFading || !le1.hasData() && !!vt.has(ho) && (le1.setSelfFadeLogic(bt + ls), !0);
                        }
                        function Ae(le1, vt) {
                            var bt;
                            le1.needsHillshadePrepare = !0, le1.needsTerrainPrepare = !0;
                            let ls = vt.tileID.canonical.x - le1.tileID.canonical.x;
                            const ho = vt.tileID.canonical.y - le1.tileID.canonical.y, Dl = Math.pow(2, le1.tileID.canonical.z), Fl = vt.tileID.key;
                            0 === ls && 0 === ho || Math.abs(ho) > 1 || (Math.abs(ls) > 1 && (1 === Math.abs(ls + Dl) ? ls += Dl : 1 === Math.abs(ls - Dl) && (ls -= Dl)), vt.dem && le1.dem && (le1.dem.backfillBorder(vt.dem, ls, ho), (null === (bt = le1.neighboringTiles) || void 0 === bt ? void 0 : bt[Fl]) && (le1.neighboringTiles[Fl].backfilled = !0)));
                        }
                        class Le {
                            constructor(){
                                this._tiles = {};
                            }
                            handleWrapJump(le1) {
                                const vt = {};
                                for(const bt in this._tiles){
                                    const ls = this._tiles[bt];
                                    ls.tileID = ls.tileID.unwrapTo(ls.tileID.wrap + le1), vt[ls.tileID.key] = ls;
                                }
                                this._tiles = vt;
                            }
                            setFeatureState(le1, vt) {
                                for(const bt in this._tiles)this._tiles[bt].setFeatureState(le1, vt);
                            }
                            getAllTiles() {
                                return Object.values(this._tiles);
                            }
                            getAllIds(le1 = !1) {
                                return le1 ? Object.values(this._tiles).map((le1)=>le1.tileID).sort(vt.aw).map((le1)=>le1.key) : Object.keys(this._tiles);
                            }
                            getTileById(le1) {
                                return this._tiles[le1];
                            }
                            setTile(le1, vt) {
                                this._tiles[le1] = vt;
                            }
                            deleteTileById(le1) {
                                delete this._tiles[le1];
                            }
                            getLoadedTile(le1) {
                                const vt = this.getTileById(le1.key);
                                return (null == vt ? void 0 : vt.hasData()) ? vt : null;
                            }
                            isIdRenderable(le1, vt = !1) {
                                var bt;
                                return null === (bt = this.getTileById(le1)) || void 0 === bt ? void 0 : bt.isRenderable(vt);
                            }
                            getRenderableIds(le1 = 0, bt) {
                                const ls = [];
                                for (const vt of this.getAllIds())this.isIdRenderable(vt, bt) && ls.push(this.getTileById(vt));
                                return bt ? ls.sort((bt, ls)=>{
                                    const ho = bt.tileID, Dl = ls.tileID, Fl = new vt.P(ho.canonical.x, ho.canonical.y)._rotate(-le1), sc = new vt.P(Dl.canonical.x, Dl.canonical.y)._rotate(-le1);
                                    return ho.overscaledZ - Dl.overscaledZ || sc.y - Fl.y || sc.x - Fl.x;
                                }).map((le1)=>le1.tileID.key) : ls.map((le1)=>le1.tileID).sort(vt.aw).map((le1)=>le1.key);
                            }
                        }
                        class ke extends vt.E {
                            constructor(le1, bt, ls){
                                super(), this.id = le1, this.dispatcher = ls, this.on("data", (le1)=>this._dataHandler(le1)), this.on("dataloading", ()=>{
                                    this._sourceErrored = !1;
                                }), this.on("error", ()=>{
                                    this._sourceErrored = this._source.loaded();
                                }), this._source = ((le1, vt, bt, ls)=>{
                                    const ho = new (re(vt.type))(le1, vt, bt, ls);
                                    if (ho.id !== le1) throw new Error(`Expected Source id to be ${le1} instead of ${ho.id}`);
                                    return ho;
                                })(le1, bt, ls, this), this._inViewTiles = new Le, this._outOfViewCache = new vt.ax(0, (le1)=>this._unloadTile(le1)), this._timers = {}, this._maxTileCacheSize = null, this._maxTileCacheZoomLevels = null, this._rasterFadeDuration = 0, this._maxFadingAncestorLevels = 5, this._state = new _e, this._didEmitContent = !1, this._updated = !1;
                            }
                            onAdd(le1) {
                                this.map = le1, this._maxTileCacheSize = le1 ? le1._maxTileCacheSize : null, this._maxTileCacheZoomLevels = le1 ? le1._maxTileCacheZoomLevels : null, this._source && this._source.onAdd && this._source.onAdd(le1);
                            }
                            onRemove(le1) {
                                for (const vt of this._inViewTiles.getAllTiles())vt.unloadVectorData();
                                this.clearTiles(), this._source && this._source.onRemove && this._source.onRemove(le1), this._inViewTiles = new Le;
                            }
                            loaded() {
                                if (this._sourceErrored) return !0;
                                if (!this._sourceLoaded) return !1;
                                if (!this._source.loaded()) return !1;
                                if (!(void 0 === this.used && void 0 === this.usedForTerrain || this.used || this.usedForTerrain)) return !0;
                                if (!this._updated) return !1;
                                for (const le1 of this._inViewTiles.getAllTiles())if ("loaded" !== le1.state && "errored" !== le1.state) return !1;
                                return !0;
                            }
                            getSource() {
                                return this._source;
                            }
                            getState() {
                                return this._state;
                            }
                            pause() {
                                this._paused = !0;
                            }
                            resume() {
                                if (!this._paused) return;
                                const le1 = this._shouldReloadOnResume;
                                this._paused = !1, this._shouldReloadOnResume = !1, le1 && this.reload(), this.transform && this.update(this.transform, this.terrain);
                            }
                            _loadTile(le1, bt, ls) {
                                return vt._(this, void 0, void 0, function*() {
                                    try {
                                        yield this._source.loadTile(le1), this._tileLoaded(le1, bt, ls);
                                    } catch (bt) {
                                        le1.state = "errored", 404 !== bt.status ? this._source.fire(new vt.k(bt, {
                                            tile: le1
                                        })) : this.update(this.transform, this.terrain);
                                    }
                                });
                            }
                            _unloadTile(le1) {
                                this._source.unloadTile && this._source.unloadTile(le1);
                            }
                            _abortTile(le1) {
                                this._source.abortTile && this._source.abortTile(le1), this._source.fire(new vt.l("dataabort", {
                                    tile: le1,
                                    coord: le1.tileID,
                                    dataType: "source"
                                }));
                            }
                            serialize() {
                                return this._source.serialize();
                            }
                            prepare(le1) {
                                this._source.prepare && this._source.prepare(), this._state.coalesceChanges(this._inViewTiles, this.map ? this.map.painter : null);
                                for (const vt of this._inViewTiles.getAllTiles())vt.upload(le1), vt.prepare(this.map.style.imageManager);
                            }
                            getIds() {
                                return this._inViewTiles.getAllIds(!0);
                            }
                            getRenderableIds(le1) {
                                var vt;
                                return this._inViewTiles.getRenderableIds(null === (vt = this.transform) || void 0 === vt ? void 0 : vt.bearingInRadians, le1);
                            }
                            hasRenderableParent(le1) {
                                const vt = le1.overscaledZ - 1;
                                if (vt >= this._source.minzoom) {
                                    const bt = this.getLoadedTile(le1.scaledTo(vt));
                                    if (bt) return this._inViewTiles.isIdRenderable(bt.tileID.key);
                                }
                                return !1;
                            }
                            reload(le1, vt) {
                                if (this._paused) this._shouldReloadOnResume = !0;
                                else {
                                    this._outOfViewCache.reset();
                                    for (const bt of this._inViewTiles.getAllIds()){
                                        const ls = this._inViewTiles.getTileById(bt);
                                        vt && !this._source.shouldReloadTile(ls, vt) || (le1 ? this._reloadTile(bt, "expired") : "errored" !== ls.state && this._reloadTile(bt, "reloading"));
                                    }
                                }
                            }
                            _reloadTile(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    const vt = this._inViewTiles.getTileById(le1);
                                    vt && ("loading" !== vt.state && (vt.state = bt), yield this._loadTile(vt, le1, bt));
                                });
                            }
                            _tileLoaded(le1, bt, ls) {
                                le1.timeAdded = c(), le1.selfFading && (le1.fadeEndTime = le1.timeAdded + this._rasterFadeDuration), "expired" === ls && (le1.refreshedUponExpiration = !0), this._setTileReloadTimer(bt, le1), "raster-dem" === this.getSource().type && le1.dem && function(le1, vt) {
                                    var bt, ls;
                                    const ho = vt.getRenderableIds();
                                    for (const Dl of ho){
                                        if (!le1.neighboringTiles || !le1.neighboringTiles[Dl]) continue;
                                        const ho = vt.getTileById(Dl);
                                        le1.neighboringTiles[Dl].backfilled || Ae(le1, ho), (null === (ls = null === (bt = ho.neighboringTiles) || void 0 === bt ? void 0 : bt[le1.tileID.key]) || void 0 === ls ? void 0 : ls.backfilled) || Ae(ho, le1);
                                    }
                                }(le1, this._inViewTiles), this._state.initializeTileState(le1, this.map ? this.map.painter : null), le1.aborted || this._source.fire(new vt.l("data", {
                                    dataType: "source",
                                    tile: le1,
                                    coord: le1.tileID
                                }));
                            }
                            getTile(le1) {
                                return this.getTileByID(le1.key);
                            }
                            getTileByID(le1) {
                                return this._inViewTiles.getTileById(le1);
                            }
                            _retainLoadedChildren(le1, vt) {
                                const bt = this._getLoadedDescendents(vt), ls = new Set;
                                for (const ho of vt){
                                    const vt = bt[ho.key];
                                    if (!(null == vt ? void 0 : vt.length)) {
                                        ls.add(ho);
                                        continue;
                                    }
                                    const Dl = ho.overscaledZ + ke.maxOverzooming, Fl = vt.filter((le1)=>le1.tileID.overscaledZ <= Dl);
                                    if (!Fl.length) {
                                        ls.add(ho);
                                        continue;
                                    }
                                    const sc = Math.min(...Fl.map((le1)=>le1.tileID.overscaledZ)), uc = Fl.filter((le1)=>le1.tileID.overscaledZ === sc).map((le1)=>le1.tileID);
                                    for (const bt of uc)le1[bt.key] = bt;
                                    this._areDescendentsComplete(uc, sc, ho.overscaledZ) || ls.add(ho);
                                }
                                return ls;
                            }
                            _getLoadedDescendents(le1) {
                                var vt;
                                const bt = {};
                                for (const ls of this._inViewTiles.getAllTiles().filter((le1)=>le1.hasData()))for (const ho of le1)ls.tileID.isChildOf(ho) && (bt[vt = ho.key] || (bt[vt] = [])).push(ls);
                                return bt;
                            }
                            _areDescendentsComplete(le1, vt, bt) {
                                return 1 === le1.length && le1[0].isOverscaled() ? le1[0].overscaledZ === vt : Math.pow(4, vt - bt) === le1.length;
                            }
                            getLoadedTile(le1) {
                                return this._inViewTiles.getLoadedTile(le1);
                            }
                            updateCacheSize(le1) {
                                const bt = Math.ceil(le1.width / this._source.tileSize) + 1, ls = Math.ceil(le1.height / this._source.tileSize) + 1, ho = Math.floor(bt * ls * (null === this._maxTileCacheZoomLevels ? vt.c.MAX_TILE_CACHE_ZOOM_LEVELS : this._maxTileCacheZoomLevels)), Dl = "number" == typeof this._maxTileCacheSize ? Math.min(this._maxTileCacheSize, ho) : ho;
                                this._outOfViewCache.setMaxSize(Dl);
                            }
                            handleWrapJump(le1) {
                                const vt = Math.round((le1 - (void 0 === this._prevLng ? le1 : this._prevLng)) / 360);
                                this._prevLng = le1, vt && (this._inViewTiles.handleWrapJump(vt), this._resetTileReloadTimers());
                            }
                            update(le1, bt) {
                                if (!this._sourceLoaded || this._paused) return;
                                let ls;
                                this.transform = le1, this.terrain = bt, this.updateCacheSize(le1), this.handleWrapJump(this.transform.center.lng), this.used || this.usedForTerrain ? this._source.tileID ? ls = le1.getVisibleUnwrappedCoordinates(this._source.tileID).map((le1)=>new vt.a2(le1.canonical.z, le1.wrap, le1.canonical.z, le1.canonical.x, le1.canonical.y)) : (ls = Ie(le1, {
                                    tileSize: this.usedForTerrain ? this.tileSize : this._source.tileSize,
                                    minzoom: this._source.minzoom,
                                    maxzoom: "vector" === this._source.type && void 0 !== this.map._zoomLevelsToOverscale ? le1.maxZoom - this.map._zoomLevelsToOverscale : this._source.maxzoom,
                                    roundZoom: !this.usedForTerrain && this._source.roundZoom,
                                    reparseOverscaled: this._source.reparseOverscaled,
                                    terrain: bt,
                                    calculateTileZoom: this._source.calculateTileZoom
                                }), this._source.hasTile && (ls = ls.filter((le1)=>this._source.hasTile(le1)))) : ls = [], this.usedForTerrain && (ls = this._addTerrainIdealTiles(ls));
                                const ho = 0 === ls.length && !this._updated && this._didEmitContent;
                                this._updated = !0, ho && this.fire(new vt.l("data", {
                                    sourceDataType: "idle",
                                    dataType: "source",
                                    sourceId: this.id
                                }));
                                const Dl = Ce(le1, this._source), Fl = this._updateRetainedTiles(ls, Dl), sc = Ee(this._source.type);
                                sc && this._rasterFadeDuration > 0 && !bt && function(le1, bt, ls, ho, Dl, Fl, sc) {
                                    const uc = c(), mc = vt.av(bt);
                                    for (const vt of bt){
                                        const bt = le1.getTileById(vt.key);
                                        bt.fadingDirection !== Wd.Departing && 0 !== bt.fadeOpacity || bt.resetFadeLogic(), Se(le1, bt, ls, uc, ho, Dl, sc) || ze(le1, bt, ls, uc, Fl, sc) || De(bt, mc, uc, sc) || bt.resetFadeLogic();
                                    }
                                }(this._inViewTiles, ls, Fl, this._maxFadingAncestorLevels, this._source.minzoom, this._source.maxzoom, this._rasterFadeDuration), sc ? this._cleanUpRasterTiles(Fl) : this._cleanUpVectorTiles(Fl);
                            }
                            _cleanUpRasterTiles(le1) {
                                for (const vt of this._inViewTiles.getAllIds())le1[vt] || this._removeTile(vt);
                            }
                            _cleanUpVectorTiles(le1) {
                                for (const vt of this._inViewTiles.getAllIds()){
                                    const bt = this._inViewTiles.getTileById(vt);
                                    le1[vt] ? bt.clearSymbolFadeHold() : bt.hasSymbolBuckets ? bt.holdingForSymbolFade() ? bt.symbolFadeFinished() && this._removeTile(vt) : bt.setSymbolHoldDuration(this.map._fadeDuration) : this._removeTile(vt);
                                }
                            }
                            _addTerrainIdealTiles(le1) {
                                const vt = [];
                                for (const bt of le1)if (bt.canonical.z > this._source.minzoom) {
                                    const le1 = bt.scaledTo(bt.canonical.z - 1);
                                    vt.push(le1);
                                    const ls = bt.scaledTo(Math.max(this._source.minzoom, Math.min(bt.canonical.z, 5)));
                                    vt.push(ls);
                                }
                                return le1.concat(vt);
                            }
                            releaseSymbolFadeTiles() {
                                for (const le1 of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(le1).holdingForSymbolFade() && this._removeTile(le1);
                            }
                            _updateRetainedTiles(le1, vt) {
                                var bt;
                                const ls = new Set;
                                for (const uc of le1)this._addTile(uc).hasData() || ls.add(uc);
                                const ho = le1.reduce((le1, vt)=>(le1[vt.key] = vt, le1), {}), Dl = this._retainLoadedChildren(ho, ls), Fl = {}, sc = Math.max(vt - ke.maxUnderzooming, this._source.minzoom);
                                for (const uc of Dl){
                                    let le1 = this._inViewTiles.getTileById(uc.key), vt = null == le1 ? void 0 : le1.wasRequested();
                                    for(let ls = uc.overscaledZ - 1; ls >= sc; --ls){
                                        const Dl = uc.scaledTo(ls);
                                        if (Fl[Dl.key]) break;
                                        if (Fl[Dl.key] = !0, le1 = this.getTile(Dl), !le1 && vt && (le1 = this._addTile(Dl)), le1) {
                                            const ls = le1.hasData();
                                            if ((ls || !(null === (bt = this.map) || void 0 === bt ? void 0 : bt.cancelPendingTileRequestsWhileZooming) || vt) && (ho[Dl.key] = Dl), vt = le1.wasRequested(), ls) break;
                                        }
                                    }
                                }
                                return ho;
                            }
                            _addTile(le1) {
                                let bt = this._inViewTiles.getTileById(le1.key);
                                if (bt) return bt;
                                bt = this._outOfViewCache.getAndRemove(le1), bt && (bt.resetFadeLogic(), this._setTileReloadTimer(le1.key, bt), bt.tileID = le1, this._state.initializeTileState(bt, this.map ? this.map.painter : null));
                                const ls = bt;
                                return bt || (bt = new de(le1, this._source.tileSize * le1.overscaleFactor()), this._loadTile(bt, le1.key, bt.state)), bt.uses++, this._inViewTiles.setTile(le1.key, bt), ls || this._source.fire(new vt.l("dataloading", {
                                    tile: bt,
                                    coord: bt.tileID,
                                    dataType: "source"
                                })), bt;
                            }
                            _setTileReloadTimer(le1, vt) {
                                this._clearTileReloadTimer(le1);
                                const bt = vt.getExpiryTimeout();
                                bt && (this._timers[le1] = setTimeout(()=>{
                                    this._reloadTile(le1, "expired"), delete this._timers[le1];
                                }, bt));
                            }
                            _clearTileReloadTimer(le1) {
                                const vt = this._timers[le1];
                                vt && (clearTimeout(vt), delete this._timers[le1]);
                            }
                            _resetTileReloadTimers() {
                                for(const le1 in this._timers)clearTimeout(this._timers[le1]), delete this._timers[le1];
                                for (const le1 of this._inViewTiles.getAllIds()){
                                    const vt = this._inViewTiles.getTileById(le1);
                                    this._setTileReloadTimer(le1, vt);
                                }
                            }
                            refreshTiles(le1) {
                                for (const vt of this._inViewTiles.getAllIds()){
                                    const bt = this._inViewTiles.getTileById(vt);
                                    (this._inViewTiles.isIdRenderable(vt) || "errored" == bt.state) && le1.some((le1)=>le1.equals(bt.tileID.canonical)) && this._reloadTile(vt, "expired");
                                }
                            }
                            _removeTile(le1) {
                                const vt = this._inViewTiles.getTileById(le1);
                                vt && (vt.uses--, this._inViewTiles.deleteTileById(le1), this._clearTileReloadTimer(le1), vt.uses > 0 || (vt.hasData() && "reloading" !== vt.state ? this._outOfViewCache.add(vt.tileID, vt, vt.getExpiryTimeout()) : (vt.aborted = !0, this._abortTile(vt), this._unloadTile(vt))));
                            }
                            _dataHandler(le1) {
                                "source" === le1.dataType && ("metadata" !== le1.sourceDataType ? "content" === le1.sourceDataType && this._sourceLoaded && !this._paused && (this.reload(le1.sourceDataChanged, le1.shouldReloadTileOptions), this.transform && this.update(this.transform, this.terrain), this._didEmitContent = !0) : this._sourceLoaded = !0);
                            }
                            clearTiles() {
                                this._shouldReloadOnResume = !1, this._paused = !1;
                                for (const le1 of this._inViewTiles.getAllIds())this._removeTile(le1);
                                this._outOfViewCache.reset();
                            }
                            tilesIn(le1, bt, ls) {
                                const ho = [], Dl = this.transform;
                                if (!Dl) return ho;
                                const Fl = Dl.getCoveringTilesDetailsProvider().allowWorldCopies(), sc = ls ? Dl.getCameraQueryGeometry(le1) : le1, l = (le1)=>Dl.screenPointToMercatorCoordinate(le1, this.terrain), uc = this.transformBbox(le1, l, !Fl), mc = this.transformBbox(sc, l, !Fl), gc = this.getIds(), Ac = vt.aa.fromPoints(mc);
                                for(let Ec = 0; Ec < gc.length; Ec++){
                                    const le1 = this._inViewTiles.getTileById(gc[Ec]);
                                    if (le1.holdingForSymbolFade()) continue;
                                    const ls = Fl ? [
                                        le1.tileID
                                    ] : [
                                        le1.tileID.unwrapTo(-1),
                                        le1.tileID.unwrapTo(0)
                                    ], sc = Math.pow(2, Dl.zoom - le1.tileID.overscaledZ), kc = bt * le1.queryPadding * vt.a5 / le1.tileSize / sc;
                                    for (const bt of ls){
                                        const ls = Ac.map((le1)=>bt.getTilePoint(new vt.a9(le1.x, le1.y)));
                                        if (ls.expandBy(kc), ls.intersects(Qd)) {
                                            const vt = uc.map((le1)=>bt.getTilePoint(le1)), ls = mc.map((le1)=>bt.getTilePoint(le1));
                                            ho.push({
                                                tile: le1,
                                                tileID: Fl ? bt : bt.unwrapTo(0),
                                                queryGeometry: vt,
                                                cameraQueryGeometry: ls,
                                                scale: sc
                                            });
                                        }
                                    }
                                }
                                return ho;
                            }
                            transformBbox(le1, bt, ls) {
                                let ho = le1.map(bt);
                                if (ls) {
                                    const ls = vt.aa.fromPoints(le1);
                                    ls.shrinkBy(.001 * Math.min(ls.width(), ls.height()));
                                    const Dl = ls.map(bt);
                                    vt.aa.fromPoints(ho).covers(Dl) || (ho = ho.map((le1)=>le1.x > .5 ? new vt.a9(le1.x - 1, le1.y, le1.z) : le1));
                                }
                                return ho;
                            }
                            getVisibleCoordinates(le1) {
                                const vt = this.getRenderableIds(le1).map((le1)=>this._inViewTiles.getTileById(le1).tileID);
                                return this.transform && this.transform.populateCache(vt), vt;
                            }
                            hasTransition() {
                                return !!this._source.hasTransition() || !(!Ee(this._source.type) || !function(le1, vt) {
                                    if (vt <= 0) return !1;
                                    const bt = c();
                                    for (const ls of le1.getAllTiles())if (ls.fadeEndTime >= bt) return !0;
                                    return !1;
                                }(this._inViewTiles, this._rasterFadeDuration));
                            }
                            setRasterFadeDuration(le1) {
                                this._rasterFadeDuration = le1;
                            }
                            setFeatureState(le1, bt, ls) {
                                this._state.updateState(le1 = le1 || vt.ai, bt, ls);
                            }
                            removeFeatureState(le1, bt, ls) {
                                this._state.removeFeatureState(le1 = le1 || vt.ai, bt, ls);
                            }
                            getFeatureState(le1, bt) {
                                return this._state.getState(le1 = le1 || vt.ai, bt);
                            }
                            setDependencies(le1, vt, bt) {
                                const ls = this._inViewTiles.getTileById(le1);
                                ls && ls.setDependencies(vt, bt);
                            }
                            reloadTilesForDependencies(le1, vt) {
                                for (const bt of this._inViewTiles.getAllIds())this._inViewTiles.getTileById(bt).hasDependency(le1, vt) && this._reloadTile(bt, "reloading");
                                this._outOfViewCache.filter((bt)=>!bt.hasDependency(le1, vt));
                            }
                            areTilesLoaded() {
                                for (const le1 of this._inViewTiles.getAllTiles())if ("loaded" !== le1.state && "errored" !== le1.state) return !1;
                                return !0;
                            }
                        }
                        ke.maxUnderzooming = 10, ke.maxOverzooming = 3;
                        class Fe {
                            constructor(le1, vt){
                                this.reset(le1, vt);
                            }
                            reset(le1, vt) {
                                this.points = le1 || [], this._distances = [
                                    0
                                ];
                                for(let bt = 1; bt < this.points.length; bt++)this._distances[bt] = this._distances[bt - 1] + this.points[bt].dist(this.points[bt - 1]);
                                this.length = this._distances[this._distances.length - 1], this.padding = Math.min(vt || 0, .5 * this.length), this.paddedLength = this.length - 2 * this.padding;
                            }
                            lerp(le1) {
                                if (1 === this.points.length) return this.points[0];
                                le1 = vt.an(le1, 0, 1);
                                let bt = 1, ls = this._distances[bt];
                                const ho = le1 * this.paddedLength + this.padding;
                                for(; ls < ho && bt < this._distances.length;)ls = this._distances[++bt];
                                const Dl = bt - 1, Fl = this._distances[Dl], sc = ls - Fl, uc = sc > 0 ? (ho - Fl) / sc : 0;
                                return this.points[Dl].mult(1 - uc).add(this.points[bt].mult(uc));
                            }
                        }
                        function Be(le1, vt) {
                            let bt = !0;
                            return "always" === le1 || "never" !== le1 && "never" !== vt || (bt = !1), bt;
                        }
                        class Oe {
                            constructor(le1, vt, bt){
                                const ls = this.boxCells = [], ho = this.circleCells = [];
                                this.xCellCount = Math.ceil(le1 / bt), this.yCellCount = Math.ceil(vt / bt);
                                for(let Dl = 0; Dl < this.xCellCount * this.yCellCount; Dl++)ls.push([]), ho.push([]);
                                this.circleKeys = [], this.boxKeys = [], this.bboxes = [], this.circles = [], this.width = le1, this.height = vt, this.xScale = this.xCellCount / le1, this.yScale = this.yCellCount / vt, this.boxUid = 0, this.circleUid = 0;
                            }
                            keysLength() {
                                return this.boxKeys.length + this.circleKeys.length;
                            }
                            insert(le1, vt, bt, ls, ho) {
                                this._forEachCell(vt, bt, ls, ho, this._insertBoxCell, this.boxUid++), this.boxKeys.push(le1), this.bboxes.push(vt), this.bboxes.push(bt), this.bboxes.push(ls), this.bboxes.push(ho);
                            }
                            insertCircle(le1, vt, bt, ls) {
                                this._forEachCell(vt - ls, bt - ls, vt + ls, bt + ls, this._insertCircleCell, this.circleUid++), this.circleKeys.push(le1), this.circles.push(vt), this.circles.push(bt), this.circles.push(ls);
                            }
                            _insertBoxCell(le1, vt, bt, ls, ho, Dl) {
                                this.boxCells[ho].push(Dl);
                            }
                            _insertCircleCell(le1, vt, bt, ls, ho, Dl) {
                                this.circleCells[ho].push(Dl);
                            }
                            _query(le1, vt, bt, ls, ho, Dl, Fl) {
                                if (bt < 0 || le1 > this.width || ls < 0 || vt > this.height) return [];
                                const sc = [];
                                if (le1 <= 0 && vt <= 0 && this.width <= bt && this.height <= ls) {
                                    if (ho) return [
                                        {
                                            key: null,
                                            x1: le1,
                                            y1: vt,
                                            x2: bt,
                                            y2: ls
                                        }
                                    ];
                                    for(let le1 = 0; le1 < this.boxKeys.length; le1++)sc.push({
                                        key: this.boxKeys[le1],
                                        x1: this.bboxes[4 * le1],
                                        y1: this.bboxes[4 * le1 + 1],
                                        x2: this.bboxes[4 * le1 + 2],
                                        y2: this.bboxes[4 * le1 + 3]
                                    });
                                    for(let le1 = 0; le1 < this.circleKeys.length; le1++){
                                        const vt = this.circles[3 * le1], bt = this.circles[3 * le1 + 1], ls = this.circles[3 * le1 + 2];
                                        sc.push({
                                            key: this.circleKeys[le1],
                                            x1: vt - ls,
                                            y1: bt - ls,
                                            x2: vt + ls,
                                            y2: bt + ls
                                        });
                                    }
                                } else this._forEachCell(le1, vt, bt, ls, this._queryCell, sc, {
                                    hitTest: ho,
                                    overlapMode: Dl,
                                    seenUids: {
                                        box: {},
                                        circle: {}
                                    }
                                }, Fl);
                                return sc;
                            }
                            query(le1, vt, bt, ls) {
                                return this._query(le1, vt, bt, ls, !1, null);
                            }
                            hitTest(le1, vt, bt, ls, ho, Dl) {
                                return this._query(le1, vt, bt, ls, !0, ho, Dl).length > 0;
                            }
                            hitTestCircle(le1, vt, bt, ls, ho) {
                                const Dl = le1 - bt, Fl = le1 + bt, sc = vt - bt, uc = vt + bt;
                                if (Fl < 0 || Dl > this.width || uc < 0 || sc > this.height) return !1;
                                const mc = [];
                                return this._forEachCell(Dl, sc, Fl, uc, this._queryCellCircle, mc, {
                                    hitTest: !0,
                                    overlapMode: ls,
                                    circle: {
                                        x: le1,
                                        y: vt,
                                        radius: bt
                                    },
                                    seenUids: {
                                        box: {},
                                        circle: {}
                                    }
                                }, ho), mc.length > 0;
                            }
                            _queryCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const { seenUids: uc, hitTest: mc, overlapMode: gc } = Fl, Ac = this.boxCells[ho];
                                if (null !== Ac) {
                                    const ho = this.bboxes;
                                    for (const Fl of Ac)if (!uc.box[Fl]) {
                                        uc.box[Fl] = !0;
                                        const Ac = 4 * Fl, Ec = this.boxKeys[Fl];
                                        if (le1 <= ho[Ac + 2] && vt <= ho[Ac + 3] && bt >= ho[Ac + 0] && ls >= ho[Ac + 1] && (!sc || sc(Ec)) && (!mc || !Be(gc, Ec.overlapMode)) && (Dl.push({
                                            key: Ec,
                                            x1: ho[Ac],
                                            y1: ho[Ac + 1],
                                            x2: ho[Ac + 2],
                                            y2: ho[Ac + 3]
                                        }), mc)) return !0;
                                    }
                                }
                                const Ec = this.circleCells[ho];
                                if (null !== Ec) {
                                    const ho = this.circles;
                                    for (const Fl of Ec)if (!uc.circle[Fl]) {
                                        uc.circle[Fl] = !0;
                                        const Ac = 3 * Fl, Ec = this.circleKeys[Fl];
                                        if (this._circleAndRectCollide(ho[Ac], ho[Ac + 1], ho[Ac + 2], le1, vt, bt, ls) && (!sc || sc(Ec)) && (!mc || !Be(gc, Ec.overlapMode))) {
                                            const le1 = ho[Ac], vt = ho[Ac + 1], bt = ho[Ac + 2];
                                            if (Dl.push({
                                                key: Ec,
                                                x1: le1 - bt,
                                                y1: vt - bt,
                                                x2: le1 + bt,
                                                y2: vt + bt
                                            }), mc) return !0;
                                        }
                                    }
                                }
                                return !1;
                            }
                            _queryCellCircle(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const { circle: uc, seenUids: mc, overlapMode: gc } = Fl, Ac = this.boxCells[ho];
                                if (null !== Ac) {
                                    const le1 = this.bboxes;
                                    for (const vt of Ac)if (!mc.box[vt]) {
                                        mc.box[vt] = !0;
                                        const bt = 4 * vt, ls = this.boxKeys[vt];
                                        if (this._circleAndRectCollide(uc.x, uc.y, uc.radius, le1[bt + 0], le1[bt + 1], le1[bt + 2], le1[bt + 3]) && (!sc || sc(ls)) && !Be(gc, ls.overlapMode)) return Dl.push(!0), !0;
                                    }
                                }
                                const Ec = this.circleCells[ho];
                                if (null !== Ec) {
                                    const le1 = this.circles;
                                    for (const vt of Ec)if (!mc.circle[vt]) {
                                        mc.circle[vt] = !0;
                                        const bt = 3 * vt, ls = this.circleKeys[vt];
                                        if (this._circlesCollide(le1[bt], le1[bt + 1], le1[bt + 2], uc.x, uc.y, uc.radius) && (!sc || sc(ls)) && !Be(gc, ls.overlapMode)) return Dl.push(!0), !0;
                                    }
                                }
                            }
                            _forEachCell(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = this._convertToXCellCoord(le1), mc = this._convertToYCellCoord(vt), gc = this._convertToXCellCoord(bt), Ac = this._convertToYCellCoord(ls);
                                for(let Ec = uc; Ec <= gc; Ec++)for(let uc = mc; uc <= Ac; uc++)if (ho.call(this, le1, vt, bt, ls, this.xCellCount * uc + Ec, Dl, Fl, sc)) return;
                            }
                            _convertToXCellCoord(le1) {
                                return Math.max(0, Math.min(this.xCellCount - 1, Math.floor(le1 * this.xScale)));
                            }
                            _convertToYCellCoord(le1) {
                                return Math.max(0, Math.min(this.yCellCount - 1, Math.floor(le1 * this.yScale)));
                            }
                            _circlesCollide(le1, vt, bt, ls, ho, Dl) {
                                const Fl = ls - le1, sc = ho - vt, uc = bt + Dl;
                                return uc * uc > Fl * Fl + sc * sc;
                            }
                            _circleAndRectCollide(le1, vt, bt, ls, ho, Dl, Fl) {
                                const sc = (Dl - ls) / 2, uc = Math.abs(le1 - (ls + sc));
                                if (uc > sc + bt) return !1;
                                const mc = (Fl - ho) / 2, gc = Math.abs(vt - (ho + mc));
                                if (gc > mc + bt) return !1;
                                if (uc <= sc || gc <= mc) return !0;
                                const Ac = uc - sc, Ec = gc - mc;
                                return Ac * Ac + Ec * Ec <= bt * bt;
                            }
                        }
                        function je(le1, bt, ls) {
                            const ho = vt.N();
                            if (!le1) {
                                const { vecSouth: le1, vecEast: vt } = Ze(bt), ls = a();
                                ls[0] = vt[0], ls[1] = vt[1], ls[2] = le1[0], ls[3] = le1[1], Dl = ls, (Ac = (sc = (Fl = ls)[0]) * (gc = Fl[3]) - (mc = Fl[2]) * (uc = Fl[1])) && (Dl[0] = gc * (Ac = 1 / Ac), Dl[1] = -uc * Ac, Dl[2] = -mc * Ac, Dl[3] = sc * Ac), ho[0] = ls[0], ho[1] = ls[1], ho[4] = ls[2], ho[5] = ls[3];
                            }
                            var Dl, Fl, sc, uc, mc, gc, Ac;
                            return vt.Q(ho, ho, [
                                1 / ls,
                                1 / ls,
                                1
                            ]), ho;
                        }
                        function Ne(le1, bt, ls, ho) {
                            if (le1) {
                                const le1 = vt.N();
                                if (!bt) {
                                    const { vecSouth: vt, vecEast: bt } = Ze(ls);
                                    le1[0] = bt[0], le1[1] = bt[1], le1[4] = vt[0], le1[5] = vt[1];
                                }
                                return vt.Q(le1, le1, [
                                    ho,
                                    ho,
                                    1
                                ]), le1;
                            }
                            return ls.pixelsToClipSpaceMatrix;
                        }
                        function Ze(le1) {
                            const bt = Math.cos(le1.rollInRadians), ls = Math.sin(le1.rollInRadians), ho = Math.cos(le1.pitchInRadians), Dl = Math.cos(le1.bearingInRadians), Fl = Math.sin(le1.bearingInRadians), sc = vt.aC();
                            sc[0] = -Dl * ho * ls - Fl * bt, sc[1] = -Fl * ho * ls + Dl * bt;
                            const uc = vt.aD(sc);
                            uc < 1e-9 ? vt.aE(sc) : vt.aF(sc, sc, 1 / uc);
                            const mc = vt.aC();
                            mc[0] = Dl * ho * bt - Fl * ls, mc[1] = Fl * ho * bt + Dl * ls;
                            const gc = vt.aD(mc);
                            return gc < 1e-9 ? vt.aE(mc) : vt.aF(mc, mc, 1 / gc), {
                                vecEast: mc,
                                vecSouth: sc
                            };
                        }
                        function Ue(le1, bt, ls, ho) {
                            let Dl;
                            ho ? (Dl = [
                                le1,
                                bt,
                                ho(le1, bt),
                                1
                            ], vt.aH(Dl, Dl, ls)) : (Dl = [
                                le1,
                                bt,
                                0,
                                1
                            ], rt(Dl, Dl, ls));
                            const Fl = Dl[3];
                            return {
                                point: new vt.P(Dl[0] / Fl, Dl[1] / Fl),
                                signedDistanceFromCamera: Fl,
                                isOccluded: !1
                            };
                        }
                        function Ge(le1, vt) {
                            return .5 + le1 / vt * .5;
                        }
                        function Ve(le1, vt) {
                            return le1.x >= -vt[0] && le1.x <= vt[0] && le1.y >= -vt[1] && le1.y <= vt[1];
                        }
                        function qe(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc) {
                            const du = ls ? le1.textSizeData : le1.iconSizeData, _u = vt.ay(du, bt.transform.zoom), Md = [
                                256 / bt.width * 2 + 1,
                                256 / bt.height * 2 + 1
                            ], Ld = ls ? le1.text.dynamicLayoutVertexArray : le1.icon.dynamicLayoutVertexArray;
                            Ld.clear();
                            const Nd = le1.lineVertexArray, Rd = ls ? le1.text.placedSymbolArray : le1.icon.placedSymbolArray, Od = bt.transform.width / bt.transform.height;
                            let jd = !1;
                            for(let Ud = 0; Ud < Rd.length; Ud++){
                                const ls = Rd.get(Ud);
                                if (ls.hidden || ls.writingMode === vt.az.vertical && !jd) {
                                    ot(ls.numGlyphs, Ld);
                                    continue;
                                }
                                jd = !1;
                                const Gd = new vt.P(ls.anchorX, ls.anchorY), qd = {
                                    getElevation: kc,
                                    pitchedLabelPlaneMatrix: ho,
                                    lineVertexArray: Nd,
                                    pitchWithMap: Fl,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    transform: bt.transform,
                                    tileAnchorPoint: Gd,
                                    unwrappedTileID: mc,
                                    width: gc,
                                    height: Ac,
                                    translation: Ec
                                }, Hd = Je(ls.anchorX, ls.anchorY, qd);
                                if (!Ve(Hd.point, Md)) {
                                    ot(ls.numGlyphs, Ld);
                                    continue;
                                }
                                const Wd = Ge(bt.transform.cameraToCenterDistance, Hd.signedDistanceFromCamera), Zd = vt.aA(du, _u, ls), Yd = Fl ? Zd * bt.transform.getPitchedTextCorrection(ls.anchorX, ls.anchorY, mc) / Wd : Zd * Wd, Qd = He({
                                    projectionContext: qd,
                                    pitchedLabelPlaneMatrixInverse: Dl,
                                    symbol: ls,
                                    fontSize: Yd,
                                    flip: !1,
                                    keepUpright: sc,
                                    glyphOffsetArray: le1.glyphOffsetArray,
                                    dynamicLayoutVertexArray: Ld,
                                    aspectRatio: Od,
                                    rotateToLine: uc
                                });
                                jd = Qd.useVertical, (Qd.notEnoughRoom || jd || Qd.needsFlipping && He({
                                    projectionContext: qd,
                                    pitchedLabelPlaneMatrixInverse: Dl,
                                    symbol: ls,
                                    fontSize: Yd,
                                    flip: !0,
                                    keepUpright: sc,
                                    glyphOffsetArray: le1.glyphOffsetArray,
                                    dynamicLayoutVertexArray: Ld,
                                    aspectRatio: Od,
                                    rotateToLine: uc
                                }).notEnoughRoom) && ot(ls.numGlyphs, Ld);
                            }
                            ls ? le1.text.dynamicLayoutVertexBuffer.updateData(Ld) : le1.icon.dynamicLayoutVertexBuffer.updateData(Ld);
                        }
                        function We(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            const uc = Dl.glyphStartIndex + Dl.numGlyphs, mc = Dl.lineStartIndex, gc = Dl.lineStartIndex + Dl.lineLength, Ac = vt.getoffsetX(Dl.glyphStartIndex), Ec = vt.getoffsetX(uc - 1), kc = it(le1 * Ac, bt, ls, ho, Dl.segment, mc, gc, sc, Fl);
                            if (!kc) return null;
                            const du = it(le1 * Ec, bt, ls, ho, Dl.segment, mc, gc, sc, Fl);
                            return du ? sc.projectionCache.anyProjectionOccluded ? null : {
                                first: kc,
                                last: du
                            } : null;
                        }
                        function $e(le1, bt, ls, ho) {
                            return le1 === vt.az.horizontal && Math.abs(ls.y - bt.y) > Math.abs(ls.x - bt.x) * ho ? {
                                useVertical: !0
                            } : (le1 === vt.az.vertical ? bt.y < ls.y : bt.x > ls.x) ? {
                                needsFlipping: !0
                            } : null;
                        }
                        function He(le1) {
                            const { projectionContext: bt, pitchedLabelPlaneMatrixInverse: ls, symbol: ho, fontSize: Dl, flip: Fl, keepUpright: sc, glyphOffsetArray: uc, dynamicLayoutVertexArray: mc, aspectRatio: gc, rotateToLine: Ac } = le1, Ec = Dl / 24, kc = ho.lineOffsetX * Ec, du = ho.lineOffsetY * Ec;
                            let _u;
                            if (ho.numGlyphs > 1) {
                                const le1 = ho.glyphStartIndex + ho.numGlyphs, vt = ho.lineStartIndex, Dl = ho.lineStartIndex + ho.lineLength, mc = We(Ec, uc, kc, du, Fl, ho, Ac, bt);
                                if (!mc) return {
                                    notEnoughRoom: !0
                                };
                                const Md = Qe(mc.first.point.x, mc.first.point.y, bt, ls), Ld = Qe(mc.last.point.x, mc.last.point.y, bt, ls);
                                if (sc && !Fl) {
                                    const le1 = $e(ho.writingMode, Md, Ld, gc);
                                    if (le1) return le1;
                                }
                                _u = [
                                    mc.first
                                ];
                                for(let ls = ho.glyphStartIndex + 1; ls < le1 - 1; ls++){
                                    const le1 = it(Ec * uc.getoffsetX(ls), kc, du, Fl, ho.segment, vt, Dl, bt, Ac);
                                    if (!le1) return {
                                        notEnoughRoom: !0
                                    };
                                    _u.push(le1);
                                }
                                _u.push(mc.last);
                            } else {
                                if (sc && !Fl) {
                                    const le1 = Ye(bt.tileAnchorPoint.x, bt.tileAnchorPoint.y, bt).point, Dl = ho.lineStartIndex + ho.segment + 1, Fl = new vt.P(bt.lineVertexArray.getx(Dl), bt.lineVertexArray.gety(Dl)), sc = Ye(Fl.x, Fl.y, bt), uc = sc.signedDistanceFromCamera > 0 ? sc.point : Xe(bt.tileAnchorPoint, Fl, le1, 1, bt), mc = Qe(le1.x, le1.y, bt, ls), Ac = Qe(uc.x, uc.y, bt, ls), Ec = $e(ho.writingMode, mc, Ac, gc);
                                    if (Ec) return Ec;
                                }
                                const le1 = it(Ec * uc.getoffsetX(ho.glyphStartIndex), kc, du, Fl, ho.segment, ho.lineStartIndex, ho.lineStartIndex + ho.lineLength, bt, Ac);
                                if (!le1 || bt.projectionCache.anyProjectionOccluded) return {
                                    notEnoughRoom: !0
                                };
                                _u = [
                                    le1
                                ];
                            }
                            for (const Md of _u)vt.aG(mc, Md.point, Md.angle);
                            return {};
                        }
                        function Xe(le1, vt, bt, ls, ho) {
                            const Dl = le1.add(le1.sub(vt)._unit()), Fl = Ye(Dl.x, Dl.y, ho).point, sc = bt.sub(Fl);
                            return bt.add(sc._mult(ls / sc.mag()));
                        }
                        function Ke(le1, bt, ls) {
                            const ho = bt.projectionCache;
                            if (ho.projections[le1]) return ho.projections[le1];
                            const Dl = new vt.P(bt.lineVertexArray.getx(le1), bt.lineVertexArray.gety(le1)), Fl = Ye(Dl.x, Dl.y, bt);
                            if (Fl.signedDistanceFromCamera > 0) return ho.projections[le1] = Fl.point, ho.anyProjectionOccluded = ho.anyProjectionOccluded || Fl.isOccluded, Fl.point;
                            const sc = le1 - ls.direction;
                            return Xe(0 === ls.distanceFromAnchor ? bt.tileAnchorPoint : new vt.P(bt.lineVertexArray.getx(sc), bt.lineVertexArray.gety(sc)), Dl, ls.previousVertex, ls.absOffsetX - ls.distanceFromAnchor + 1, bt);
                        }
                        function Ye(le1, vt, bt) {
                            const ls = le1 + bt.translation[0], ho = vt + bt.translation[1];
                            let Dl;
                            return bt.pitchWithMap ? (Dl = Ue(ls, ho, bt.pitchedLabelPlaneMatrix, bt.getElevation), Dl.isOccluded = !1) : (Dl = bt.transform.projectTileCoordinates(ls, ho, bt.unwrappedTileID, bt.getElevation), Dl.point.x = (.5 * Dl.point.x + .5) * bt.width, Dl.point.y = (.5 * -Dl.point.y + .5) * bt.height), Dl;
                        }
                        function Qe(le1, bt, ls, ho) {
                            if (ls.pitchWithMap) {
                                const Dl = [
                                    le1,
                                    bt,
                                    0,
                                    1
                                ];
                                return vt.aH(Dl, Dl, ho), ls.transform.projectTileCoordinates(Dl[0] / Dl[3], Dl[1] / Dl[3], ls.unwrappedTileID, ls.getElevation).point;
                            }
                            return {
                                x: le1 / ls.width * 2 - 1,
                                y: 1 - bt / ls.height * 2
                            };
                        }
                        function Je(le1, vt, bt) {
                            return bt.transform.projectTileCoordinates(le1, vt, bt.unwrappedTileID, bt.getElevation);
                        }
                        function et(le1, vt, bt) {
                            return le1._unit()._perp()._mult(vt * bt);
                        }
                        function tt(le1, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                            if (uc.projectionCache.offsets[le1]) return uc.projectionCache.offsets[le1];
                            const gc = ls.add(bt);
                            if (le1 + mc.direction < ho || le1 + mc.direction >= Dl) return uc.projectionCache.offsets[le1] = gc, gc;
                            const Ac = Ke(le1 + mc.direction, uc, mc), Ec = et(Ac.sub(ls), sc, mc.direction), kc = ls.add(Ec), du = Ac.add(Ec);
                            return uc.projectionCache.offsets[le1] = vt.aI(Fl, gc, kc, du) || gc, uc.projectionCache.offsets[le1];
                        }
                        function it(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = ls ? le1 - vt : le1 + vt;
                            let gc = mc > 0 ? 1 : -1, Ac = 0;
                            ls && (gc *= -1, Ac = Math.PI), gc < 0 && (Ac += Math.PI);
                            let Ec, kc = gc > 0 ? Dl + ho : Dl + ho + 1;
                            sc.projectionCache.cachedAnchorPoint ? Ec = sc.projectionCache.cachedAnchorPoint : (Ec = Ye(sc.tileAnchorPoint.x, sc.tileAnchorPoint.y, sc).point, sc.projectionCache.cachedAnchorPoint = Ec);
                            let du, _u, Md = Ec, Ld = Ec, Nd = 0, Rd = 0;
                            const Od = Math.abs(mc), jd = [];
                            let Ud;
                            for(; Nd + Rd <= Od;){
                                if (kc += gc, kc < Dl || kc >= Fl) return null;
                                Nd += Rd, Ld = Md, _u = du;
                                const le1 = {
                                    absOffsetX: Od,
                                    direction: gc,
                                    distanceFromAnchor: Nd,
                                    previousVertex: Ld
                                };
                                if (Md = Ke(kc, sc, le1), 0 === bt) jd.push(Ld), Ud = Md.sub(Ld);
                                else {
                                    let vt;
                                    const ls = Md.sub(Ld);
                                    vt = 0 === ls.mag() ? et(Ke(kc + gc, sc, le1).sub(Md), bt, gc) : et(ls, bt, gc), _u || (_u = Ld.add(vt)), du = tt(kc, vt, Md, Dl, Fl, _u, bt, sc, le1), jd.push(_u), Ud = du.sub(_u);
                                }
                                Rd = Ud.mag();
                            }
                            const Gd = Ud._mult((Od - Nd) / Rd)._add(_u || Ld), qd = Ac + Math.atan2(Md.y - Ld.y, Md.x - Ld.x);
                            return jd.push(Gd), {
                                point: Gd,
                                angle: uc ? qd : 0,
                                path: jd
                            };
                        }
                        const Xd = new Float32Array([
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0,
                            -1 / 0,
                            -1 / 0,
                            0
                        ]);
                        function ot(le1, vt) {
                            for(let bt = 0; bt < le1; bt++){
                                const le1 = vt.length;
                                vt.resize(le1 + 4), vt.float32.set(Xd, 3 * le1);
                            }
                        }
                        function rt(le1, vt, bt) {
                            const ls = vt[0], ho = vt[1];
                            return le1[0] = bt[0] * ls + bt[4] * ho + bt[12], le1[1] = bt[1] * ls + bt[5] * ho + bt[13], le1[3] = bt[3] * ls + bt[7] * ho + bt[15], le1;
                        }
                        const Kd = 100;
                        class nt {
                            constructor(le1, vt = new Oe(le1.width + 200, le1.height + 200, 25), bt = new Oe(le1.width + 200, le1.height + 200, 25)){
                                this.transform = le1, this.grid = vt, this.ignoredGrid = bt, this.pitchFactor = Math.cos(le1.pitch * Math.PI / 180) * le1.cameraToCenterDistance, this.screenRightBoundary = le1.width + Kd, this.screenBottomBoundary = le1.height + Kd, this.gridRightBoundary = le1.width + 200, this.gridBottomBoundary = le1.height + 200, this.perspectiveRatioCutoff = .6;
                            }
                            placeCollisionBox(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                                const Ec = this.projectAndGetPerspectiveRatio(le1.anchorPointX + sc[0], le1.anchorPointY + sc[1], ho, mc, Ac), kc = bt * Ec.perspectiveRatio;
                                let du;
                                if (Dl || Fl) du = this._projectCollisionBox(le1, kc, ls, ho, Dl, Fl, sc, Ec, mc, gc, Ac);
                                else {
                                    const vt = Ec.x + (gc ? gc.x * kc : 0), bt = Ec.y + (gc ? gc.y * kc : 0);
                                    du = {
                                        allPointsOccluded: !1,
                                        box: [
                                            vt + le1.x1 * kc,
                                            bt + le1.y1 * kc,
                                            vt + le1.x2 * kc,
                                            bt + le1.y2 * kc
                                        ]
                                    };
                                }
                                const [_u, Md, Ld, Nd] = du.box, Rd = Dl ? du.allPointsOccluded : Ec.isOccluded;
                                let Od = Rd;
                                return Od || (Od = Ec.perspectiveRatio < this.perspectiveRatioCutoff), Od || (Od = !this.isInsideGrid(_u, Md, Ld, Nd)), Od || "always" !== vt && this.grid.hitTest(_u, Md, Ld, Nd, vt, uc) ? {
                                    box: [
                                        _u,
                                        Md,
                                        Ld,
                                        Nd
                                    ],
                                    placeable: !1,
                                    offscreen: !1,
                                    occluded: Rd
                                } : {
                                    box: [
                                        _u,
                                        Md,
                                        Ld,
                                        Nd
                                    ],
                                    placeable: !0,
                                    offscreen: this.isOffscreen(_u, Md, Ld, Nd),
                                    occluded: Rd
                                };
                            }
                            placeCollisionCircles(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du) {
                                const _u = [], Md = new vt.P(bt.anchorX, bt.anchorY), Ld = this.getPerspectiveRatio(Md.x, Md.y, Fl, du), Nd = (mc ? Dl * this.transform.getPitchedTextCorrection(bt.anchorX, bt.anchorY, Fl) / Ld : Dl * Ld) / vt.aM, Rd = {
                                    getElevation: du,
                                    pitchedLabelPlaneMatrix: sc,
                                    lineVertexArray: ls,
                                    pitchWithMap: mc,
                                    projectionCache: {
                                        projections: {},
                                        offsets: {},
                                        cachedAnchorPoint: void 0,
                                        anyProjectionOccluded: !1
                                    },
                                    transform: this.transform,
                                    tileAnchorPoint: Md,
                                    unwrappedTileID: Fl,
                                    width: this.transform.width,
                                    height: this.transform.height,
                                    translation: kc
                                }, Od = We(Nd, ho, bt.lineOffsetX * Nd, bt.lineOffsetY * Nd, !1, bt, !1, Rd);
                                let jd = !1, Ud = !1, Gd = !0;
                                if (Od) {
                                    const bt = .5 * Ac * Ld + Ec, ls = new vt.P(-100, -100), ho = new vt.P(this.screenRightBoundary, this.screenBottomBoundary), Dl = new Fe, Fl = Od.first, sc = Od.last;
                                    let kc = [];
                                    for(let le1 = Fl.path.length - 1; le1 >= 1; le1--)kc.push(Fl.path[le1]);
                                    for(let le1 = 1; le1 < sc.path.length; le1++)kc.push(sc.path[le1]);
                                    const du = 2.5 * bt;
                                    if (mc) {
                                        const le1 = this.projectPathToScreenSpace(kc, Rd);
                                        kc = le1.some((le1)=>le1.signedDistanceFromCamera <= 0) ? [] : le1.map((le1)=>le1.point);
                                    }
                                    let Md = [];
                                    if (kc.length > 0) {
                                        const le1 = kc[0].clone(), bt = kc[0].clone();
                                        for(let vt = 1; vt < kc.length; vt++)le1.x = Math.min(le1.x, kc[vt].x), le1.y = Math.min(le1.y, kc[vt].y), bt.x = Math.max(bt.x, kc[vt].x), bt.y = Math.max(bt.y, kc[vt].y);
                                        Md = le1.x >= ls.x && bt.x <= ho.x && le1.y >= ls.y && bt.y <= ho.y ? [
                                            kc
                                        ] : bt.x < ls.x || le1.x > ho.x || bt.y < ls.y || le1.y > ho.y ? [] : vt.aJ([
                                            kc
                                        ], ls.x, ls.y, ho.x, ho.y);
                                    }
                                    for (const vt of Md){
                                        Dl.reset(vt, .25 * bt);
                                        let ls = 0;
                                        ls = Dl.length <= .5 * bt ? 1 : Math.ceil(Dl.paddedLength / du) + 1;
                                        for(let vt = 0; vt < ls; vt++){
                                            const ho = vt / Math.max(ls - 1, 1), Fl = Dl.lerp(ho), sc = Fl.x + Kd, mc = Fl.y + Kd;
                                            _u.push(sc, mc, bt, 0);
                                            const Ac = sc - bt, Ec = mc - bt, kc = sc + bt, du = mc + bt;
                                            if (Gd = Gd && this.isOffscreen(Ac, Ec, kc, du), Ud = Ud || this.isInsideGrid(Ac, Ec, kc, du), "always" !== le1 && this.grid.hitTestCircle(sc, mc, bt, le1, gc) && (jd = !0, !uc)) return {
                                                circles: [],
                                                offscreen: !1,
                                                collisionDetected: jd
                                            };
                                        }
                                    }
                                }
                                return {
                                    circles: !uc && jd || !Ud || Ld < this.perspectiveRatioCutoff ? [] : _u,
                                    offscreen: Gd,
                                    collisionDetected: jd
                                };
                            }
                            projectPathToScreenSpace(le1, bt) {
                                const ls = function(le1, bt) {
                                    const ls = vt.N();
                                    return vt.aB(ls, bt.pitchedLabelPlaneMatrix), le1.map((le1)=>{
                                        const vt = Ue(le1.x, le1.y, ls, bt.getElevation), ho = bt.transform.projectTileCoordinates(vt.point.x, vt.point.y, bt.unwrappedTileID, bt.getElevation);
                                        return ho.point.x = (.5 * ho.point.x + .5) * bt.width, ho.point.y = (.5 * -ho.point.y + .5) * bt.height, ho;
                                    });
                                }(le1, bt);
                                return function(le1) {
                                    let vt = 0, bt = 0, ls = 0, ho = 0;
                                    for(let Dl = 0; Dl < le1.length; Dl++)le1[Dl].isOccluded ? (ls = Dl + 1, ho = 0) : (ho++, ho > bt && (bt = ho, vt = ls));
                                    return le1.slice(vt, vt + bt);
                                }(ls);
                            }
                            queryRenderedSymbols(le1) {
                                if (0 === le1.length || 0 === this.grid.keysLength() && 0 === this.ignoredGrid.keysLength()) return {};
                                const bt = [], ls = new vt.aa;
                                for (const Ac of le1){
                                    const le1 = new vt.P(Ac.x + Kd, Ac.y + Kd);
                                    ls.extend(le1), bt.push(le1);
                                }
                                const { minX: ho, minY: Dl, maxX: Fl, maxY: sc } = ls, uc = this.grid.query(ho, Dl, Fl, sc).concat(this.ignoredGrid.query(ho, Dl, Fl, sc)), mc = {}, gc = {};
                                for (const Ac of uc){
                                    const le1 = Ac.key;
                                    if (void 0 === mc[le1.bucketInstanceId] && (mc[le1.bucketInstanceId] = {}), mc[le1.bucketInstanceId][le1.featureIndex]) continue;
                                    const ls = [
                                        new vt.P(Ac.x1, Ac.y1),
                                        new vt.P(Ac.x2, Ac.y1),
                                        new vt.P(Ac.x2, Ac.y2),
                                        new vt.P(Ac.x1, Ac.y2)
                                    ];
                                    vt.aK(bt, ls) && (mc[le1.bucketInstanceId][le1.featureIndex] = !0, void 0 === gc[le1.bucketInstanceId] && (gc[le1.bucketInstanceId] = []), gc[le1.bucketInstanceId].push(le1.featureIndex));
                                }
                                return gc;
                            }
                            insertCollisionBox(le1, vt, bt, ls, ho, Dl) {
                                (bt ? this.ignoredGrid : this.grid).insert({
                                    bucketInstanceId: ls,
                                    featureIndex: ho,
                                    collisionGroupID: Dl,
                                    overlapMode: vt
                                }, le1[0], le1[1], le1[2], le1[3]);
                            }
                            insertCollisionCircles(le1, vt, bt, ls, ho, Dl) {
                                const Fl = bt ? this.ignoredGrid : this.grid, sc = {
                                    bucketInstanceId: ls,
                                    featureIndex: ho,
                                    collisionGroupID: Dl,
                                    overlapMode: vt
                                };
                                for(let uc = 0; uc < le1.length; uc += 4)Fl.insertCircle(sc, le1[uc], le1[uc + 1], le1[uc + 2]);
                            }
                            projectAndGetPerspectiveRatio(le1, bt, ls, ho, Dl) {
                                if (Dl) {
                                    let ls;
                                    ho ? (ls = [
                                        le1,
                                        bt,
                                        ho(le1, bt),
                                        1
                                    ], vt.aH(ls, ls, Dl)) : (ls = [
                                        le1,
                                        bt,
                                        0,
                                        1
                                    ], rt(ls, ls, Dl));
                                    const Fl = ls[3];
                                    return {
                                        x: (ls[0] / Fl + 1) / 2 * this.transform.width + Kd,
                                        y: (-ls[1] / Fl + 1) / 2 * this.transform.height + Kd,
                                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / Fl * .5,
                                        isOccluded: !1,
                                        signedDistanceFromCamera: Fl
                                    };
                                }
                                {
                                    const vt = this.transform.projectTileCoordinates(le1, bt, ls, ho);
                                    return {
                                        x: (vt.point.x + 1) / 2 * this.transform.width + Kd,
                                        y: (1 - vt.point.y) / 2 * this.transform.height + Kd,
                                        perspectiveRatio: .5 + this.transform.cameraToCenterDistance / vt.signedDistanceFromCamera * .5,
                                        isOccluded: vt.isOccluded,
                                        signedDistanceFromCamera: vt.signedDistanceFromCamera
                                    };
                                }
                            }
                            getPerspectiveRatio(le1, vt, bt, ls) {
                                const ho = this.transform.projectTileCoordinates(le1, vt, bt, ls);
                                return .5 + this.transform.cameraToCenterDistance / ho.signedDistanceFromCamera * .5;
                            }
                            isOffscreen(le1, vt, bt, ls) {
                                return bt < Kd || le1 >= this.screenRightBoundary || ls < Kd || vt > this.screenBottomBoundary;
                            }
                            isInsideGrid(le1, vt, bt, ls) {
                                return bt >= 0 && le1 < this.gridRightBoundary && ls >= 0 && vt < this.gridBottomBoundary;
                            }
                            getViewportMatrix() {
                                const le1 = vt.ar([]);
                                return vt.O(le1, le1, [
                                    -100,
                                    -100,
                                    0
                                ]), le1;
                            }
                            _projectCollisionBox(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                                let Ec = 1, kc = 0, du = 0, _u = 1;
                                const Md = le1.anchorPointX + sc[0], Ld = le1.anchorPointY + sc[1];
                                if (Fl && !Dl) {
                                    const le1 = this.projectAndGetPerspectiveRatio(Md + 1, Ld, ho, mc, Ac), vt = le1.x - uc.x, bt = Math.atan((le1.y - uc.y) / vt) + (vt < 0 ? Math.PI : 0), ls = Math.sin(bt), Dl = Math.cos(bt);
                                    Ec = Dl, kc = ls, du = -ls, _u = Dl;
                                } else if (!Fl && Dl) {
                                    const le1 = Ze(this.transform);
                                    Ec = le1.vecEast[0], kc = le1.vecEast[1], du = le1.vecSouth[0], _u = le1.vecSouth[1];
                                }
                                let Nd = uc.x, Rd = uc.y, Od = bt;
                                Dl && (Nd = Md, Rd = Ld, Od = Math.pow(2, -(this.transform.zoom - ls.overscaledZ)), Od *= this.transform.getPitchedTextCorrection(Md, Ld, ho), gc || (Od *= vt.an(.5 + uc.signedDistanceFromCamera / this.transform.cameraToCenterDistance * .5, 0, 4))), gc && (Nd += Ec * gc.x * Od + du * gc.y * Od, Rd += kc * gc.x * Od + _u * gc.y * Od);
                                const jd = le1.x1 * Od, Ud = le1.x2 * Od, Gd = (jd + Ud) / 2, qd = le1.y1 * Od, Hd = le1.y2 * Od, Wd = (qd + Hd) / 2, Zd = [
                                    {
                                        offsetX: jd,
                                        offsetY: qd
                                    },
                                    {
                                        offsetX: Gd,
                                        offsetY: qd
                                    },
                                    {
                                        offsetX: Ud,
                                        offsetY: qd
                                    },
                                    {
                                        offsetX: Ud,
                                        offsetY: Wd
                                    },
                                    {
                                        offsetX: Ud,
                                        offsetY: Hd
                                    },
                                    {
                                        offsetX: Gd,
                                        offsetY: Hd
                                    },
                                    {
                                        offsetX: jd,
                                        offsetY: Hd
                                    },
                                    {
                                        offsetX: jd,
                                        offsetY: Wd
                                    }
                                ];
                                let Yd = [];
                                for (const { offsetX: Xd, offsetY: Kd } of Zd)Yd.push(new vt.P(Nd + Ec * Xd + du * Kd, Rd + kc * Xd + _u * Kd));
                                let Qd = !1;
                                if (Dl) {
                                    const le1 = Yd.map((le1)=>this.projectAndGetPerspectiveRatio(le1.x, le1.y, ho, mc, Ac));
                                    Qd = le1.some((le1)=>!le1.isOccluded), Yd = le1.map((le1)=>new vt.P(le1.x, le1.y));
                                } else Qd = !0;
                                return {
                                    box: vt.aL(Yd),
                                    allPointsOccluded: !Qd
                                };
                            }
                        }
                        class lt {
                            constructor(le1, vt, bt, ls){
                                this.opacity = le1 ? Math.max(0, Math.min(1, le1.opacity + (le1.placed ? vt : -vt))) : ls && bt ? 1 : 0, this.placed = bt;
                            }
                            isHidden() {
                                return 0 === this.opacity && !this.placed;
                            }
                        }
                        class ct {
                            constructor(le1, vt, bt, ls, ho){
                                this.text = new lt(le1 ? le1.text : null, vt, bt, ho), this.icon = new lt(le1 ? le1.icon : null, vt, ls, ho);
                            }
                            isHidden() {
                                return this.text.isHidden() && this.icon.isHidden();
                            }
                        }
                        class ht {
                            constructor(le1, vt, bt){
                                this.text = le1, this.icon = vt, this.skipFade = bt;
                            }
                        }
                        class ut {
                            constructor(le1, vt, bt, ls, ho){
                                this.bucketInstanceId = le1, this.featureIndex = vt, this.sourceLayerIndex = bt, this.bucketIndex = ls, this.tileID = ho;
                            }
                        }
                        class dt {
                            constructor(le1){
                                this.crossSourceCollisions = le1, this.maxGroupID = 0, this.collisionGroups = {};
                            }
                            get(le1) {
                                if (this.crossSourceCollisions) return {
                                    ID: 0,
                                    predicate: null
                                };
                                if (!this.collisionGroups[le1]) {
                                    const vt = ++this.maxGroupID;
                                    this.collisionGroups[le1] = {
                                        ID: vt,
                                        predicate: (le1)=>le1.collisionGroupID === vt
                                    };
                                }
                                return this.collisionGroups[le1];
                            }
                        }
                        function _t(le1, bt, ls, ho, Dl) {
                            const { horizontalAlign: Fl, verticalAlign: sc } = vt.aS(le1);
                            return new vt.P(-(Fl - .5) * bt + ho[0] * Dl, -(sc - .5) * ls + ho[1] * Dl);
                        }
                        class pt {
                            constructor(le1, vt, bt, ls, ho){
                                this.transform = le1.clone(), this.terrain = vt, this.collisionIndex = new nt(this.transform), this.placements = {}, this.opacities = {}, this.variableOffsets = {}, this.stale = !1, this.commitTime = 0, this.fadeDuration = bt, this.retainedQueryData = {}, this.collisionGroups = new dt(ls), this.collisionCircleArrays = {}, this.collisionBoxArrays = new Map, this.prevPlacement = ho, ho && (ho.prevPlacement = void 0), this.placedOrientations = {};
                            }
                            _getTerrainElevationFunc(le1) {
                                const vt = this.terrain;
                                return vt ? (bt, ls)=>vt.getElevation(le1, bt, ls) : null;
                            }
                            getBucketParts(le1, bt, ls, ho) {
                                const Dl = ls.getBucket(bt), Fl = ls.latestFeatureIndex;
                                if (!Dl || !Fl || bt.id !== Dl.layerIds[0]) return;
                                const sc = ls.collisionBoxArray, uc = Dl.layers[0].layout, mc = Dl.layers[0].paint, gc = Math.pow(2, this.transform.zoom - ls.tileID.overscaledZ), Ac = ls.tileSize / vt.a5, Ec = ls.tileID.toUnwrapped(), kc = "map" === uc.get("text-rotation-alignment"), du = vt.aN(ls, 1, this.transform.zoom), _u = vt.aO(this.collisionIndex.transform, ls, mc.get("text-translate"), mc.get("text-translate-anchor")), Md = vt.aO(this.collisionIndex.transform, ls, mc.get("icon-translate"), mc.get("icon-translate-anchor")), Ld = je(kc, this.transform, du);
                                this.retainedQueryData[Dl.bucketInstanceId] = new ut(Dl.bucketInstanceId, Fl, Dl.sourceLayerIndex, Dl.index, ls.tileID);
                                const Nd = {
                                    bucket: Dl,
                                    layout: uc,
                                    translationText: _u,
                                    translationIcon: Md,
                                    unwrappedTileID: Ec,
                                    pitchedLabelPlaneMatrix: Ld,
                                    scale: gc,
                                    textPixelRatio: Ac,
                                    holdingForFade: ls.holdingForSymbolFade(),
                                    collisionBoxArray: sc,
                                    partiallyEvaluatedTextSize: vt.ay(Dl.textSizeData, this.transform.zoom),
                                    collisionGroup: this.collisionGroups.get(Dl.sourceID)
                                };
                                if (ho) for (const vt of Dl.sortKeyRanges){
                                    const { sortKey: bt, symbolInstanceStart: ls, symbolInstanceEnd: ho } = vt;
                                    le1.push({
                                        sortKey: bt,
                                        symbolInstanceStart: ls,
                                        symbolInstanceEnd: ho,
                                        parameters: Nd
                                    });
                                }
                                else le1.push({
                                    symbolInstanceStart: 0,
                                    symbolInstanceEnd: Dl.symbolInstances.length,
                                    parameters: Nd
                                });
                            }
                            attemptAnchorPlacement(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd, Rd, Od) {
                                const jd = vt.aP[le1.textAnchor], Ud = [
                                    le1.textOffset0,
                                    le1.textOffset1
                                ], Gd = _t(jd, ls, ho, Ud, Dl), qd = this.collisionIndex.placeCollisionBox(bt, Ec, uc, mc, gc, sc, Fl, Md, Ac.predicate, Rd, Gd, Od);
                                if ((!Nd || this.collisionIndex.placeCollisionBox(Nd, Ec, uc, mc, gc, sc, Fl, Ld, Ac.predicate, Rd, Gd, Od).placeable) && qd.placeable) {
                                    let le1;
                                    if (this.prevPlacement && this.prevPlacement.variableOffsets[kc.crossTileID] && this.prevPlacement.placements[kc.crossTileID] && this.prevPlacement.placements[kc.crossTileID].text && (le1 = this.prevPlacement.variableOffsets[kc.crossTileID].anchor), 0 === kc.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    return this.variableOffsets[kc.crossTileID] = {
                                        textOffset: Ud,
                                        width: ls,
                                        height: ho,
                                        anchor: jd,
                                        textBoxScale: Dl,
                                        prevAnchor: le1
                                    }, this.markUsedJustification(du, jd, kc, _u), du.allowVerticalPlacement && (this.markUsedOrientation(du, _u, kc), this.placedOrientations[kc.crossTileID] = _u), {
                                        shift: Gd,
                                        placedGlyphBoxes: qd
                                    };
                                }
                            }
                            placeLayerBucketPart(le1, bt, ls) {
                                const { bucket: ho, layout: Dl, translationText: Fl, translationIcon: sc, unwrappedTileID: uc, pitchedLabelPlaneMatrix: mc, textPixelRatio: gc, holdingForFade: Ac, collisionBoxArray: Ec, partiallyEvaluatedTextSize: kc, collisionGroup: du } = le1.parameters, _u = Dl.get("text-optional"), Md = Dl.get("icon-optional"), Ld = vt.aQ(Dl, "text-overlap", "text-allow-overlap"), Nd = "always" === Ld, Rd = vt.aQ(Dl, "icon-overlap", "icon-allow-overlap"), Od = "always" === Rd, jd = "map" === Dl.get("text-rotation-alignment"), Ud = "map" === Dl.get("text-pitch-alignment"), Gd = "none" !== Dl.get("icon-text-fit"), qd = "viewport-y" === Dl.get("symbol-z-order"), Hd = Nd && (Od || !ho.hasIconData() || Md), Wd = Od && (Nd || !ho.hasTextData() || _u);
                                !ho.collisionArrays && Ec && ho.deserializeCollisionBoxes(Ec);
                                const Zd = this.retainedQueryData[ho.bucketInstanceId].tileID, Yd = this._getTerrainElevationFunc(Zd), Qd = this.transform.getFastPathSimpleProjectionMatrix(Zd), z = (le1, Ec, Od)=>{
                                    var qd, Xd;
                                    if (bt[le1.crossTileID]) return;
                                    if (Ac) return void (this.placements[le1.crossTileID] = new ht(!1, !1, !1));
                                    let Kd = !1, Jd = !1, $d = !0, sp = null, em = {
                                        box: null,
                                        placeable: !1,
                                        offscreen: null,
                                        occluded: !1
                                    }, tm = {
                                        placeable: !1
                                    }, im = null, nm = null, rm = null, am = 0, sm = 0, om = 0;
                                    Ec.textFeatureIndex ? am = Ec.textFeatureIndex : le1.useRuntimeCollisionCircles && (am = le1.featureIndex), Ec.verticalTextFeatureIndex && (sm = Ec.verticalTextFeatureIndex);
                                    const lm = Ec.textBox;
                                    if (lm) {
                                        const i = (bt)=>{
                                            let ls = vt.az.horizontal;
                                            if (ho.allowVerticalPlacement && !bt && this.prevPlacement) {
                                                const vt = this.prevPlacement.placedOrientations[le1.crossTileID];
                                                vt && (this.placedOrientations[le1.crossTileID] = vt, ls = vt, this.markUsedOrientation(ho, ls, le1));
                                            }
                                            return ls;
                                        }, r = (bt, ls)=>{
                                            if (ho.allowVerticalPlacement && le1.numVerticalGlyphVertices > 0 && Ec.verticalTextBox) {
                                                for (const le1 of ho.writingModes)if (le1 === vt.az.vertical ? (em = ls(), tm = em) : em = bt(), em && em.placeable) break;
                                            } else em = bt();
                                        }, bt = le1.textAnchorOffsetStartIndex, Dl = le1.textAnchorOffsetEndIndex;
                                        if (Dl === bt) {
                                            const a = (vt, bt)=>{
                                                const ls = this.collisionIndex.placeCollisionBox(vt, Ld, gc, Zd, uc, Ud, jd, Fl, du.predicate, Yd, void 0, Qd);
                                                return ls && ls.placeable && (this.markUsedOrientation(ho, bt, le1), this.placedOrientations[le1.crossTileID] = bt), ls;
                                            };
                                            r(()=>a(lm, vt.az.horizontal), ()=>{
                                                const bt = Ec.verticalTextBox;
                                                return ho.allowVerticalPlacement && le1.numVerticalGlyphVertices > 0 && bt ? a(bt, vt.az.vertical) : {
                                                    box: null,
                                                    offscreen: null
                                                };
                                            }), i(em && em.placeable);
                                        } else {
                                            let mc = vt.aP[null === (Xd = null === (qd = this.prevPlacement) || void 0 === qd ? void 0 : qd.variableOffsets[le1.crossTileID]) || void 0 === Xd ? void 0 : Xd.anchor];
                                            const m = (vt, Ac, Ec)=>{
                                                const kc = vt.x2 - vt.x1, _u = vt.y2 - vt.y1, Md = le1.textBoxScale, Nd = Gd && "never" === Rd ? Ac : null;
                                                let Od = null, qd = "never" === Ld ? 1 : 2, Hd = "never";
                                                mc && qd++;
                                                for(let ls = 0; ls < qd; ls++){
                                                    for(let ls = bt; ls < Dl; ls++){
                                                        const bt = ho.textAnchorOffsets.get(ls);
                                                        if (mc && bt.textAnchor !== mc) continue;
                                                        const Dl = this.attemptAnchorPlacement(bt, vt, kc, _u, Md, jd, Ud, gc, Zd, uc, du, Hd, le1, ho, Ec, Fl, sc, Nd, Yd);
                                                        if (Dl && (Od = Dl.placedGlyphBoxes, Od && Od.placeable)) return Kd = !0, sp = Dl.shift, Od;
                                                    }
                                                    mc ? mc = null : Hd = Ld;
                                                }
                                                return ls && !Od && (Od = {
                                                    box: this.collisionIndex.placeCollisionBox(lm, "always", gc, Zd, uc, Ud, jd, Fl, du.predicate, Yd, void 0, Qd).box,
                                                    offscreen: !1,
                                                    placeable: !1,
                                                    occluded: !1
                                                }), Od;
                                            };
                                            r(()=>m(lm, Ec.iconBox, vt.az.horizontal), ()=>{
                                                const bt = Ec.verticalTextBox;
                                                return ho.allowVerticalPlacement && (!em || !em.placeable) && le1.numVerticalGlyphVertices > 0 && bt ? m(bt, Ec.verticalIconBox, vt.az.vertical) : {
                                                    box: null,
                                                    occluded: !0,
                                                    offscreen: null
                                                };
                                            }), em && (Kd = em.placeable, $d = em.offscreen);
                                            const Ac = i(em && em.placeable);
                                            if (!Kd && this.prevPlacement) {
                                                const vt = this.prevPlacement.variableOffsets[le1.crossTileID];
                                                vt && (this.variableOffsets[le1.crossTileID] = vt, this.markUsedJustification(ho, vt.anchor, le1, Ac));
                                            }
                                        }
                                    }
                                    if (im = em, Kd = im && im.placeable, $d = im && im.offscreen, le1.useRuntimeCollisionCircles && le1.centerJustifiedTextSymbolIndex >= 0) {
                                        const bt = ho.text.placedSymbolArray.get(le1.centerJustifiedTextSymbolIndex), sc = vt.aA(ho.textSizeData, kc, bt), gc = Dl.get("text-padding");
                                        nm = this.collisionIndex.placeCollisionCircles(Ld, bt, ho.lineVertexArray, ho.glyphOffsetArray, sc, uc, mc, ls, Ud, du.predicate, le1.collisionCircleDiameter, gc, Fl, Yd), nm.circles.length && nm.collisionDetected && !ls && vt.w("Collisions detected, but collision boxes are not shown"), Kd = Nd || nm.circles.length > 0 && !nm.collisionDetected, $d = $d && nm.offscreen;
                                    }
                                    if (Ec.iconFeatureIndex && (om = Ec.iconFeatureIndex), Ec.iconBox) {
                                        const e = (le1)=>this.collisionIndex.placeCollisionBox(le1, Rd, gc, Zd, uc, Ud, jd, sc, du.predicate, Yd, Gd && sp ? sp : void 0, Qd);
                                        tm && tm.placeable && Ec.verticalIconBox ? (rm = e(Ec.verticalIconBox), Jd = rm.placeable) : (rm = e(Ec.iconBox), Jd = rm.placeable), $d = $d && rm.offscreen;
                                    }
                                    const cm = _u || 0 === le1.numHorizontalGlyphVertices && 0 === le1.numVerticalGlyphVertices, um = Md || 0 === le1.numIconVertices;
                                    cm || um ? um ? cm || (Jd = Jd && Kd) : Kd = Jd && Kd : Jd = Kd = Jd && Kd;
                                    const hm = Jd && rm.placeable;
                                    if (Kd && im.placeable && this.collisionIndex.insertCollisionBox(im.box, Ld, Dl.get("text-ignore-placement"), ho.bucketInstanceId, tm && tm.placeable && sm ? sm : am, du.ID), hm && this.collisionIndex.insertCollisionBox(rm.box, Rd, Dl.get("icon-ignore-placement"), ho.bucketInstanceId, om, du.ID), nm && Kd && this.collisionIndex.insertCollisionCircles(nm.circles, Ld, Dl.get("text-ignore-placement"), ho.bucketInstanceId, am, du.ID), ls && this.storeCollisionData(ho.bucketInstanceId, Od, Ec, im, rm, nm), 0 === le1.crossTileID) throw new Error("symbolInstance.crossTileID can't be 0");
                                    if (0 === ho.bucketInstanceId) throw new Error("bucket.bucketInstanceId can't be 0");
                                    this.placements[le1.crossTileID] = new ht((Kd || Hd) && !(null == im ? void 0 : im.occluded), (Jd || Wd) && !(null == rm ? void 0 : rm.occluded), $d || ho.justReloaded), bt[le1.crossTileID] = !0;
                                };
                                if (qd) {
                                    if (0 !== le1.symbolInstanceStart) throw new Error("bucket.bucketInstanceId should be 0");
                                    const vt = ho.getSortedSymbolIndexes(-this.transform.bearingInRadians);
                                    for(let le1 = vt.length - 1; le1 >= 0; --le1){
                                        const bt = vt[le1];
                                        z(ho.symbolInstances.get(bt), ho.collisionArrays[bt], bt);
                                    }
                                } else for(let vt = le1.symbolInstanceStart; vt < le1.symbolInstanceEnd; vt++)z(ho.symbolInstances.get(vt), ho.collisionArrays[vt], vt);
                                ho.justReloaded = !1;
                            }
                            storeCollisionData(le1, vt, bt, ls, ho, Dl) {
                                if (bt.textBox || bt.iconBox) {
                                    let Dl, Fl;
                                    this.collisionBoxArrays.has(le1) ? Dl = this.collisionBoxArrays.get(le1) : (Dl = new Map, this.collisionBoxArrays.set(le1, Dl)), Dl.has(vt) ? Fl = Dl.get(vt) : (Fl = {
                                        text: null,
                                        icon: null
                                    }, Dl.set(vt, Fl)), bt.textBox && (Fl.text = ls.box), bt.iconBox && (Fl.icon = ho.box);
                                }
                                if (Dl) {
                                    let vt = this.collisionCircleArrays[le1];
                                    void 0 === vt && (vt = this.collisionCircleArrays[le1] = []);
                                    for(let le1 = 0; le1 < Dl.circles.length; le1 += 4)vt.push(Dl.circles[le1 + 0] - Kd), vt.push(Dl.circles[le1 + 1] - Kd), vt.push(Dl.circles[le1 + 2]), vt.push(Dl.collisionDetected ? 1 : 0);
                                }
                            }
                            markUsedJustification(le1, bt, ls, ho) {
                                let Dl;
                                Dl = ho === vt.az.vertical ? ls.verticalPlacedTextSymbolIndex : ({
                                    left: ls.leftJustifiedTextSymbolIndex,
                                    center: ls.centerJustifiedTextSymbolIndex,
                                    right: ls.rightJustifiedTextSymbolIndex
                                })[vt.aR(bt)];
                                const Fl = [
                                    ls.leftJustifiedTextSymbolIndex,
                                    ls.centerJustifiedTextSymbolIndex,
                                    ls.rightJustifiedTextSymbolIndex,
                                    ls.verticalPlacedTextSymbolIndex
                                ];
                                for (const vt of Fl)vt >= 0 && (le1.text.placedSymbolArray.get(vt).crossTileID = Dl >= 0 && vt !== Dl ? 0 : ls.crossTileID);
                            }
                            markUsedOrientation(le1, bt, ls) {
                                const ho = bt === vt.az.horizontal || bt === vt.az.horizontalOnly ? bt : 0, Dl = bt === vt.az.vertical ? bt : 0, Fl = [
                                    ls.leftJustifiedTextSymbolIndex,
                                    ls.centerJustifiedTextSymbolIndex,
                                    ls.rightJustifiedTextSymbolIndex
                                ];
                                for (const vt of Fl)le1.text.placedSymbolArray.get(vt).placedOrientation = ho;
                                ls.verticalPlacedTextSymbolIndex && (le1.text.placedSymbolArray.get(ls.verticalPlacedTextSymbolIndex).placedOrientation = Dl);
                            }
                            commit(le1) {
                                this.commitTime = le1, this.zoomAtLastRecencyCheck = this.transform.zoom;
                                const vt = this.prevPlacement;
                                let bt = !1;
                                this.prevZoomAdjustment = vt ? vt.zoomAdjustment(this.transform.zoom) : 0;
                                const ls = vt ? vt.symbolFadeChange(le1) : 1, ho = vt ? vt.opacities : {}, Dl = vt ? vt.variableOffsets : {}, Fl = vt ? vt.placedOrientations : {};
                                for(const sc in this.placements){
                                    const le1 = this.placements[sc], vt = ho[sc];
                                    vt ? (this.opacities[sc] = new ct(vt, ls, le1.text, le1.icon), bt = bt || le1.text !== vt.text.placed || le1.icon !== vt.icon.placed) : (this.opacities[sc] = new ct(null, ls, le1.text, le1.icon, le1.skipFade), bt = bt || le1.text || le1.icon);
                                }
                                for(const sc in ho){
                                    const le1 = ho[sc];
                                    if (!this.opacities[sc]) {
                                        const vt = new ct(le1, ls, !1, !1);
                                        vt.isHidden() || (this.opacities[sc] = vt, bt = bt || le1.text.placed || le1.icon.placed);
                                    }
                                }
                                for(const sc in Dl)this.variableOffsets[sc] || !this.opacities[sc] || this.opacities[sc].isHidden() || (this.variableOffsets[sc] = Dl[sc]);
                                for(const sc in Fl)this.placedOrientations[sc] || !this.opacities[sc] || this.opacities[sc].isHidden() || (this.placedOrientations[sc] = Fl[sc]);
                                if (vt && void 0 === vt.lastPlacementChangeTime) throw new Error("Last placement time for previous placement is not defined");
                                bt ? this.lastPlacementChangeTime = le1 : "number" != typeof this.lastPlacementChangeTime && (this.lastPlacementChangeTime = vt ? vt.lastPlacementChangeTime : le1);
                            }
                            updateLayerOpacities(le1, vt) {
                                const bt = {};
                                for (const ls of vt){
                                    const vt = ls.getBucket(le1);
                                    vt && ls.latestFeatureIndex && le1.id === vt.layerIds[0] && this.updateBucketOpacities(vt, ls.tileID, bt, ls.collisionBoxArray);
                                }
                            }
                            updateBucketOpacities(le1, bt, ls, ho) {
                                le1.hasTextData() && (le1.text.opacityVertexArray.clear(), le1.text.hasVisibleVertices = !1), le1.hasIconData() && (le1.icon.opacityVertexArray.clear(), le1.icon.hasVisibleVertices = !1), le1.hasIconCollisionBoxData() && le1.iconCollisionBox.collisionVertexArray.clear(), le1.hasTextCollisionBoxData() && le1.textCollisionBox.collisionVertexArray.clear();
                                const Dl = le1.layers[0], Fl = Dl.layout, sc = new ct(null, 0, !1, !1, !0), uc = Fl.get("text-allow-overlap"), mc = Fl.get("icon-allow-overlap"), gc = Dl._unevaluatedLayout.hasValue("text-variable-anchor") || Dl._unevaluatedLayout.hasValue("text-variable-anchor-offset"), Ac = "map" === Fl.get("text-rotation-alignment"), Ec = "map" === Fl.get("text-pitch-alignment"), kc = "none" !== Fl.get("icon-text-fit"), du = new ct(null, 0, uc && (mc || !le1.hasIconData() || Fl.get("icon-optional")), mc && (uc || !le1.hasTextData() || Fl.get("text-optional")), !0);
                                !le1.collisionArrays && ho && (le1.hasIconCollisionBoxData() || le1.hasTextCollisionBoxData()) && le1.deserializeCollisionBoxes(ho);
                                const m = (le1, vt, bt)=>{
                                    for(let ls = 0; ls < vt / 4; ls++)le1.opacityVertexArray.emplaceBack(bt);
                                    le1.hasVisibleVertices = le1.hasVisibleVertices || bt !== rm;
                                }, _u = this.collisionBoxArrays.get(le1.bucketInstanceId);
                                for(let Md = 0; Md < le1.symbolInstances.length; Md++){
                                    const bt = le1.symbolInstances.get(Md), { numHorizontalGlyphVertices: ho, numVerticalGlyphVertices: Dl, crossTileID: Fl } = bt;
                                    let uc = this.opacities[Fl];
                                    ls[Fl] ? uc = sc : uc || (uc = du, this.opacities[Fl] = uc), ls[Fl] = !0;
                                    const mc = bt.numIconVertices > 0, Ld = this.placedOrientations[bt.crossTileID], Nd = Ld === vt.az.vertical, Rd = Ld === vt.az.horizontal || Ld === vt.az.horizontalOnly;
                                    if (ho > 0 || Dl > 0) {
                                        const vt = Tt(uc.text);
                                        m(le1.text, ho, Nd ? rm : vt), m(le1.text, Dl, Rd ? rm : vt);
                                        const ls = uc.text.isHidden();
                                        [
                                            bt.rightJustifiedTextSymbolIndex,
                                            bt.centerJustifiedTextSymbolIndex,
                                            bt.leftJustifiedTextSymbolIndex
                                        ].forEach((vt)=>{
                                            vt >= 0 && (le1.text.placedSymbolArray.get(vt).hidden = ls || Nd ? 1 : 0);
                                        }), bt.verticalPlacedTextSymbolIndex >= 0 && (le1.text.placedSymbolArray.get(bt.verticalPlacedTextSymbolIndex).hidden = ls || Rd ? 1 : 0);
                                        const Fl = this.variableOffsets[bt.crossTileID];
                                        Fl && this.markUsedJustification(le1, Fl.anchor, bt, Ld);
                                        const sc = this.placedOrientations[bt.crossTileID];
                                        sc && (this.markUsedJustification(le1, "left", bt, sc), this.markUsedOrientation(le1, sc, bt));
                                    }
                                    if (mc) {
                                        const vt = Tt(uc.icon), ls = !(kc && bt.verticalPlacedIconSymbolIndex && Nd);
                                        bt.placedIconSymbolIndex >= 0 && (m(le1.icon, bt.numIconVertices, ls ? vt : rm), le1.icon.placedSymbolArray.get(bt.placedIconSymbolIndex).hidden = uc.icon.isHidden()), bt.verticalPlacedIconSymbolIndex >= 0 && (m(le1.icon, bt.numVerticalIconVertices, ls ? rm : vt), le1.icon.placedSymbolArray.get(bt.verticalPlacedIconSymbolIndex).hidden = uc.icon.isHidden());
                                    }
                                    const Od = _u && _u.has(Md) ? _u.get(Md) : {
                                        text: null,
                                        icon: null
                                    };
                                    if (le1.hasIconCollisionBoxData() || le1.hasTextCollisionBoxData()) {
                                        const bt = le1.collisionArrays[Md];
                                        if (bt) {
                                            let ls = new vt.P(0, 0);
                                            if (bt.textBox || bt.verticalTextBox) {
                                                let vt = !0;
                                                if (gc) {
                                                    const le1 = this.variableOffsets[Fl];
                                                    le1 ? (ls = _t(le1.anchor, le1.width, le1.height, le1.textOffset, le1.textBoxScale), Ac && ls._rotate(Ec ? -this.transform.bearingInRadians : this.transform.bearingInRadians)) : vt = !1;
                                                }
                                                if (bt.textBox || bt.verticalTextBox) {
                                                    let ho;
                                                    bt.textBox && (ho = Nd), bt.verticalTextBox && (ho = Rd), mt(le1.textCollisionBox.collisionVertexArray, uc.text.placed, !vt || ho, Od.text, ls.x, ls.y);
                                                }
                                            }
                                            if (bt.iconBox || bt.verticalIconBox) {
                                                const vt = Boolean(!Rd && bt.verticalIconBox);
                                                let ho;
                                                bt.iconBox && (ho = vt), bt.verticalIconBox && (ho = !vt), mt(le1.iconCollisionBox.collisionVertexArray, uc.icon.placed, ho, Od.icon, kc ? ls.x : 0, kc ? ls.y : 0);
                                            }
                                        }
                                    }
                                }
                                if (le1.sortFeatures(-this.transform.bearingInRadians), this.retainedQueryData[le1.bucketInstanceId] && (this.retainedQueryData[le1.bucketInstanceId].featureSortOrder = le1.featureSortOrder), le1.hasTextData() && le1.text.opacityVertexBuffer && le1.text.opacityVertexBuffer.updateData(le1.text.opacityVertexArray), le1.hasIconData() && le1.icon.opacityVertexBuffer && le1.icon.opacityVertexBuffer.updateData(le1.icon.opacityVertexArray), le1.hasIconCollisionBoxData() && le1.iconCollisionBox.collisionVertexBuffer && le1.iconCollisionBox.collisionVertexBuffer.updateData(le1.iconCollisionBox.collisionVertexArray), le1.hasTextCollisionBoxData() && le1.textCollisionBox.collisionVertexBuffer && le1.textCollisionBox.collisionVertexBuffer.updateData(le1.textCollisionBox.collisionVertexArray), le1.text.opacityVertexArray.length !== le1.text.layoutVertexArray.length / 4) throw new Error(`bucket.text.opacityVertexArray.length (= ${le1.text.opacityVertexArray.length}) !== bucket.text.layoutVertexArray.length (= ${le1.text.layoutVertexArray.length}) / 4`);
                                if (le1.icon.opacityVertexArray.length !== le1.icon.layoutVertexArray.length / 4) throw new Error(`bucket.icon.opacityVertexArray.length (= ${le1.icon.opacityVertexArray.length}) !== bucket.icon.layoutVertexArray.length (= ${le1.icon.layoutVertexArray.length}) / 4`);
                                le1.bucketInstanceId in this.collisionCircleArrays && (le1.collisionCircleArray = this.collisionCircleArrays[le1.bucketInstanceId], delete this.collisionCircleArrays[le1.bucketInstanceId]);
                            }
                            symbolFadeChange(le1) {
                                return 0 === this.fadeDuration ? 1 : (le1 - this.commitTime) / this.fadeDuration + this.prevZoomAdjustment;
                            }
                            zoomAdjustment(le1) {
                                return Math.max(0, (this.transform.zoom - le1) / 1.5);
                            }
                            hasTransitions(le1) {
                                return this.stale || le1 - this.lastPlacementChangeTime < this.fadeDuration;
                            }
                            stillRecent(le1, vt) {
                                const bt = this.zoomAtLastRecencyCheck === vt ? 1 - this.zoomAdjustment(vt) : 1;
                                return this.zoomAtLastRecencyCheck = vt, this.commitTime + this.fadeDuration * bt > le1;
                            }
                            setStale() {
                                this.stale = !0;
                            }
                        }
                        function mt(le1, vt, bt, ls, ho, Dl) {
                            ls && 0 !== ls.length || (ls = [
                                0,
                                0,
                                0,
                                0
                            ]);
                            const Fl = ls[0] - Kd, sc = ls[1] - Kd, uc = ls[2] - Kd, mc = ls[3] - Kd;
                            le1.emplaceBack(vt ? 1 : 0, bt ? 1 : 0, ho || 0, Dl || 0, Fl, sc), le1.emplaceBack(vt ? 1 : 0, bt ? 1 : 0, ho || 0, Dl || 0, uc, sc), le1.emplaceBack(vt ? 1 : 0, bt ? 1 : 0, ho || 0, Dl || 0, uc, mc), le1.emplaceBack(vt ? 1 : 0, bt ? 1 : 0, ho || 0, Dl || 0, Fl, mc);
                        }
                        const Jd = Math.pow(2, 25), $d = Math.pow(2, 24), sp = Math.pow(2, 17), em = Math.pow(2, 16), tm = Math.pow(2, 9), im = Math.pow(2, 8), nm = Math.pow(2, 1);
                        function Tt(le1) {
                            if (0 === le1.opacity && !le1.placed) return 0;
                            if (1 === le1.opacity && le1.placed) return 4294967295;
                            const vt = le1.placed ? 1 : 0, bt = Math.floor(127 * le1.opacity);
                            return bt * Jd + vt * $d + bt * sp + vt * em + bt * tm + vt * im + bt * nm + vt;
                        }
                        const rm = 0;
                        class Ct {
                            constructor(le1){
                                this._sortAcrossTiles = "viewport-y" !== le1.layout.get("symbol-z-order") && !le1.layout.get("symbol-sort-key").isConstant(), this._currentTileIndex = 0, this._currentPartIndex = 0, this._seenCrossTileIDs = {}, this._bucketParts = [];
                            }
                            continuePlacement(le1, vt, bt, ls, ho) {
                                const Dl = this._bucketParts;
                                for(; this._currentTileIndex < le1.length;)if (vt.getBucketParts(Dl, ls, le1[this._currentTileIndex], this._sortAcrossTiles), this._currentTileIndex++, ho()) return !0;
                                for(this._sortAcrossTiles && (this._sortAcrossTiles = !1, Dl.sort((le1, vt)=>le1.sortKey - vt.sortKey)); this._currentPartIndex < Dl.length;)if (vt.placeLayerBucketPart(Dl[this._currentPartIndex], this._seenCrossTileIDs, bt), this._currentPartIndex++, ho()) return !0;
                                return !1;
                            }
                        }
                        class It {
                            constructor(le1, vt, bt, ls, ho, Dl, Fl, sc){
                                this.placement = new pt(le1, vt, Dl, Fl, sc), this._currentPlacementIndex = bt.length - 1, this._forceFullPlacement = ls, this._showCollisionBoxes = ho, this._done = !1;
                            }
                            isDone() {
                                return this._done;
                            }
                            continuePlacement(le1, vt, bt) {
                                const ls = c(), o = ()=>!this._forceFullPlacement && c() - ls > 2;
                                for(; this._currentPlacementIndex >= 0;){
                                    const ls = vt[le1[this._currentPlacementIndex]], ho = this.placement.collisionIndex.transform.zoom;
                                    if ("symbol" === ls.type && (!ls.minzoom || ls.minzoom <= ho) && (!ls.maxzoom || ls.maxzoom > ho)) {
                                        if (this._inProgressLayer || (this._inProgressLayer = new Ct(ls)), this._inProgressLayer.continuePlacement(bt[ls.source], this.placement, this._showCollisionBoxes, ls, o)) return;
                                        delete this._inProgressLayer;
                                    }
                                    this._currentPlacementIndex--;
                                }
                                this._done = !0;
                            }
                            commit(le1) {
                                return this.placement.commit(le1), this.placement;
                            }
                        }
                        const am = 512 / vt.a5 / 2;
                        class Et {
                            constructor(le1, bt, ls){
                                this.tileID = le1, this.bucketInstanceId = ls, this._symbolsByKey = {};
                                const ho = new Map;
                                for(let vt = 0; vt < bt.length; vt++){
                                    const le1 = bt.get(vt), ls = le1.key, Dl = ho.get(ls);
                                    Dl ? Dl.push(le1) : ho.set(ls, [
                                        le1
                                    ]);
                                }
                                for (const [Dl, Fl] of ho){
                                    const le1 = {
                                        positions: Fl.map((le1)=>({
                                                x: Math.floor(le1.anchorX * am),
                                                y: Math.floor(le1.anchorY * am)
                                            })),
                                        crossTileIDs: Fl.map((le1)=>le1.crossTileID)
                                    };
                                    if (le1.positions.length > 128) {
                                        const bt = new vt.aT(le1.positions.length, 16, Uint16Array);
                                        for (const { x: vt, y: ls } of le1.positions)bt.add(vt, ls);
                                        bt.finish(), delete le1.positions, le1.index = bt;
                                    }
                                    this._symbolsByKey[Dl] = le1;
                                }
                            }
                            getScaledCoordinates(le1, bt) {
                                const { x: ls, y: ho, z: Dl } = this.tileID.canonical, { x: Fl, y: sc, z: uc } = bt.canonical, mc = am / Math.pow(2, uc - Dl), gc = (sc * vt.a5 + le1.anchorY) * mc, Ac = ho * vt.a5 * am;
                                return {
                                    x: Math.floor((Fl * vt.a5 + le1.anchorX) * mc - ls * vt.a5 * am),
                                    y: Math.floor(gc - Ac)
                                };
                            }
                            findMatches(le1, vt, bt) {
                                const ls = this.tileID.canonical.z < vt.canonical.z ? 1 : Math.pow(2, this.tileID.canonical.z - vt.canonical.z);
                                for(let ho = 0; ho < le1.length; ho++){
                                    const Dl = le1.get(ho);
                                    if (Dl.crossTileID) continue;
                                    const Fl = this._symbolsByKey[Dl.key];
                                    if (!Fl) continue;
                                    const sc = this.getScaledCoordinates(Dl, vt);
                                    if (Fl.index) {
                                        const le1 = Fl.index.range(sc.x - ls, sc.y - ls, sc.x + ls, sc.y + ls).sort();
                                        for (const vt of le1){
                                            const le1 = Fl.crossTileIDs[vt];
                                            if (!bt[le1]) {
                                                bt[le1] = !0, Dl.crossTileID = le1;
                                                break;
                                            }
                                        }
                                    } else if (Fl.positions) for(let le1 = 0; le1 < Fl.positions.length; le1++){
                                        const vt = Fl.positions[le1], ho = Fl.crossTileIDs[le1];
                                        if (Math.abs(vt.x - sc.x) <= ls && Math.abs(vt.y - sc.y) <= ls && !bt[ho]) {
                                            bt[ho] = !0, Dl.crossTileID = ho;
                                            break;
                                        }
                                    }
                                }
                            }
                            getCrossTileIDsLists() {
                                return Object.values(this._symbolsByKey).map(({ crossTileIDs: le1 })=>le1);
                            }
                        }
                        class St {
                            constructor(){
                                this.maxCrossTileID = 0;
                            }
                            generate() {
                                return ++this.maxCrossTileID;
                            }
                        }
                        class zt {
                            constructor(){
                                this.indexes = {}, this.usedCrossTileIDs = {}, this.lng = 0;
                            }
                            handleWrapJump(le1) {
                                const vt = Math.round((le1 - this.lng) / 360);
                                if (0 !== vt) for(const bt in this.indexes){
                                    const le1 = this.indexes[bt], ls = {};
                                    for(const bt in le1){
                                        const ho = le1[bt];
                                        ho.tileID = ho.tileID.unwrapTo(ho.tileID.wrap + vt), ls[ho.tileID.key] = ho;
                                    }
                                    this.indexes[bt] = ls;
                                }
                                this.lng = le1;
                            }
                            addBucket(le1, vt, bt) {
                                if (this.indexes[le1.overscaledZ] && this.indexes[le1.overscaledZ][le1.key]) {
                                    if (this.indexes[le1.overscaledZ][le1.key].bucketInstanceId === vt.bucketInstanceId) return !1;
                                    this.removeBucketCrossTileIDs(le1.overscaledZ, this.indexes[le1.overscaledZ][le1.key]);
                                }
                                for(let ho = 0; ho < vt.symbolInstances.length; ho++)vt.symbolInstances.get(ho).crossTileID = 0;
                                this.usedCrossTileIDs[le1.overscaledZ] || (this.usedCrossTileIDs[le1.overscaledZ] = {});
                                const ls = this.usedCrossTileIDs[le1.overscaledZ];
                                for(const ho in this.indexes){
                                    const bt = this.indexes[ho];
                                    if (Number(ho) > le1.overscaledZ) for(const ho in bt){
                                        const Dl = bt[ho];
                                        Dl.tileID.isChildOf(le1) && Dl.findMatches(vt.symbolInstances, le1, ls);
                                    }
                                    else {
                                        const Dl = bt[le1.scaledTo(Number(ho)).key];
                                        Dl && Dl.findMatches(vt.symbolInstances, le1, ls);
                                    }
                                }
                                for(let ho = 0; ho < vt.symbolInstances.length; ho++){
                                    const le1 = vt.symbolInstances.get(ho);
                                    le1.crossTileID || (le1.crossTileID = bt.generate(), ls[le1.crossTileID] = !0);
                                }
                                return void 0 === this.indexes[le1.overscaledZ] && (this.indexes[le1.overscaledZ] = {}), this.indexes[le1.overscaledZ][le1.key] = new Et(le1, vt.symbolInstances, vt.bucketInstanceId), !0;
                            }
                            removeBucketCrossTileIDs(le1, vt) {
                                for (const bt of vt.getCrossTileIDsLists())for (const vt of bt)delete this.usedCrossTileIDs[le1][vt];
                            }
                            removeStaleBuckets(le1) {
                                let vt = !1;
                                for(const bt in this.indexes){
                                    const ls = this.indexes[bt];
                                    for(const ho in ls)le1[ls[ho].bucketInstanceId] || (this.removeBucketCrossTileIDs(bt, ls[ho]), delete ls[ho], vt = !0);
                                }
                                return vt;
                            }
                        }
                        class Rt {
                            constructor(){
                                this.layerIndexes = {}, this.crossTileIDs = new St, this.maxBucketInstanceId = 0, this.bucketsInCurrentPlacement = {};
                            }
                            addLayer(le1, vt, bt) {
                                let ls = this.layerIndexes[le1.id];
                                void 0 === ls && (ls = this.layerIndexes[le1.id] = new zt);
                                let ho = !1;
                                const Dl = {};
                                ls.handleWrapJump(bt);
                                for (const Fl of vt){
                                    const vt = Fl.getBucket(le1);
                                    vt && le1.id === vt.layerIds[0] && (vt.bucketInstanceId || (vt.bucketInstanceId = ++this.maxBucketInstanceId), ls.addBucket(Fl.tileID, vt, this.crossTileIDs) && (ho = !0), Dl[vt.bucketInstanceId] = !0);
                                }
                                return ls.removeStaleBuckets(Dl) && (ho = !0), ho;
                            }
                            pruneUnusedLayers(le1) {
                                const vt = {};
                                le1.forEach((le1)=>{
                                    vt[le1] = !0;
                                });
                                for(const bt in this.layerIndexes)vt[bt] || delete this.layerIndexes[bt];
                            }
                        }
                        var sm = "void main() {fragColor=vec4(1.0);}";
                        const om = {
                            prelude: Lt("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nout highp vec4 fragColor;", "#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}mat3 rotationMatrixFromAxisAngle(vec3 u,float angle) {float c=cos(angle);float s=sin(angle);float c2=1.0-c;return mat3(u.x*u.x*c2+      c,u.x*u.y*c2-u.z*s,u.x*u.z*c2+u.y*s,u.y*u.x*c2+u.z*s,u.y*u.y*c2+    c,u.y*u.z*c2-u.x*s,u.z*u.x*c2-u.y*s,u.z*u.y*c2+u.x*s,u.z*u.z*c2+    c\n);}\n#ifdef TERRAIN3D\nuniform sampler2D u_terrain;uniform float u_terrain_dim;uniform mat4 u_terrain_matrix;uniform vec4 u_terrain_unpack;uniform float u_terrain_exaggeration;uniform highp sampler2D u_depth;\n#endif\nconst highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitShifts=vec4(1.)/bitSh;highp float unpack(highp vec4 color) {return dot(color,bitShifts);}highp float depthOpacity(vec3 frag) {\n#ifdef TERRAIN3D\nhighp float d=unpack(texture(u_depth,frag.xy*0.5+0.5))+0.0001-frag.z;return 1.0-max(0.0,min(1.0,-d*500.0));\n#else\nreturn 1.0;\n#endif\n}float calculate_visibility(vec4 pos) {\n#ifdef TERRAIN3D\nvec3 frag=pos.xyz/pos.w;highp float d=depthOpacity(frag);if (d > 0.95) return 1.0;return (d+depthOpacity(frag+vec3(0.0,0.01,0.0)))/2.0;\n#else\nreturn 1.0;\n#endif\n}float ele(vec2 pos) {\n#ifdef TERRAIN3D\nvec4 rgb=(texture(u_terrain,pos)*255.0)*u_terrain_unpack;return rgb.r+rgb.g+rgb.b-u_terrain_unpack.a;\n#else\nreturn 0.0;\n#endif\n}float get_elevation(vec2 pos) {\n#ifdef TERRAIN3D\n#ifdef GLOBE\nif ((pos.y <-32767.5) || (pos.y > 32766.5)) {return 0.0;}\n#endif\nvec2 coord=(u_terrain_matrix*vec4(pos,0.0,1.0)).xy*u_terrain_dim+1.0;vec2 f=fract(coord);vec2 c=(floor(coord)+0.5)/(u_terrain_dim+2.0);float d=1.0/(u_terrain_dim+2.0);float tl=ele(c);float tr=ele(c+vec2(d,0.0));float bl=ele(c+vec2(0.0,d));float br=ele(c+vec2(d,d));float elevation=mix(mix(tl,tr,f.x),mix(bl,br,f.x),f.y);return elevation*u_terrain_exaggeration;\n#else\nreturn 0.0;\n#endif\n}const float PI=3.141592653589793;uniform mat4 u_projection_matrix;"),
                            projectionMercator: Lt("", "float projectLineThickness(float tileY) {return 1.0;}float projectCircleRadius(float tileY) {return 1.0;}vec4 projectTile(vec2 p) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);return result;}vec4 projectTile(vec2 p,vec2 rawPos) {vec4 result=u_projection_matrix*vec4(p,0.0,1.0);if (rawPos.y <-32767.5 || rawPos.y > 32766.5) {result.z=-10000000.0;}return result;}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return u_projection_matrix*vec4(posInTile,elevation,1.0);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {return projectTileWithElevation(posInTile,elevation);}"),
                            projectionGlobe: Lt("", "#define GLOBE_RADIUS 6371008.8\nuniform highp vec4 u_projection_tile_mercator_coords;uniform highp vec4 u_projection_clipping_plane;uniform highp float u_projection_transition;uniform mat4 u_projection_fallback_matrix;vec3 globeRotateVector(vec3 vec,vec2 angles) {vec3 axisRight=vec3(vec.z,0.0,-vec.x);vec3 axisUp=cross(axisRight,vec);axisRight=normalize(axisRight);axisUp=normalize(axisUp);vec2 t=tan(angles);return normalize(vec+axisRight*t.x+axisUp*t.y);}mat3 globeGetRotationMatrix(vec3 spherePos) {vec3 axisRight=vec3(spherePos.z,0.0,-spherePos.x);vec3 axisDown=cross(axisRight,spherePos);axisRight=normalize(axisRight);axisDown=normalize(axisDown);return mat3(axisRight,axisDown,spherePos\n);}float circumferenceRatioAtTileY(float tileY) {float mercator_pos_y=u_projection_tile_mercator_coords.y+u_projection_tile_mercator_coords.w*tileY;float spherical_y=2.0*atan(exp(PI-(mercator_pos_y*PI*2.0)))-PI*0.5;return cos(spherical_y);}float projectLineThickness(float tileY) {float thickness=1.0/circumferenceRatioAtTileY(tileY); \nif (u_projection_transition < 0.999) {return mix(1.0,thickness,u_projection_transition);} else {return thickness;}}vec3 projectToSphere(vec2 translatedPos,vec2 rawPos) {vec2 mercator_pos=u_projection_tile_mercator_coords.xy+u_projection_tile_mercator_coords.zw*translatedPos;vec2 spherical;spherical.x=mercator_pos.x*PI*2.0+PI;spherical.y=2.0*atan(exp(PI-(mercator_pos.y*PI*2.0)))-PI*0.5;float len=cos(spherical.y);vec3 pos=vec3(sin(spherical.x)*len,sin(spherical.y),cos(spherical.x)*len\n);if (rawPos.y <-32767.5) {pos=vec3(0.0,1.0,0.0);}if (rawPos.y > 32766.5) {pos=vec3(0.0,-1.0,0.0);}return pos;}vec3 projectToSphere(vec2 posInTile) {return projectToSphere(posInTile,vec2(0.0,0.0));}float globeComputeClippingZ(vec3 spherePos) {return (1.0-(dot(spherePos,u_projection_clipping_plane.xyz)+u_projection_clipping_plane.w));}vec4 interpolateProjection(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);globePosition.z=globeComputeClippingZ(elevatedPos)*globePosition.w;if (u_projection_transition > 0.999) {return globePosition;}vec4 flatPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);const float z_globeness_threshold=0.2;vec4 result=globePosition;result.z=mix(0.0,globePosition.z,clamp((u_projection_transition-z_globeness_threshold)/(1.0-z_globeness_threshold),0.0,1.0));result.xyw=mix(flatPosition.xyw,globePosition.xyw,u_projection_transition);if ((posInTile.y <-32767.5) || (posInTile.y > 32766.5)) {result=globePosition;const float poles_hidden_anim_percentage=0.02;result.z=mix(globePosition.z,100.0,pow(max((1.0-u_projection_transition)/poles_hidden_anim_percentage,0.0),8.0));}return result;}vec4 interpolateProjectionFor3D(vec2 posInTile,vec3 spherePos,float elevation) {vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);vec4 globePosition=u_projection_matrix*vec4(elevatedPos,1.0);if (u_projection_transition > 0.999) {return globePosition;}vec4 fallbackPosition=u_projection_fallback_matrix*vec4(posInTile,elevation,1.0);return mix(fallbackPosition,globePosition,u_projection_transition);}vec4 projectTile(vec2 posInTile) {return interpolateProjection(posInTile,projectToSphere(posInTile),0.0);}vec4 projectTile(vec2 posInTile,vec2 rawPos) {return interpolateProjection(posInTile,projectToSphere(posInTile,rawPos),0.0);}vec4 projectTileWithElevation(vec2 posInTile,float elevation) {return interpolateProjection(posInTile,projectToSphere(posInTile),elevation);}vec4 projectTileFor3D(vec2 posInTile,float elevation) {vec3 spherePos=projectToSphere(posInTile,posInTile);return interpolateProjectionFor3D(posInTile,spherePos,elevation);}"),
                            background: Lt("uniform vec4 u_color;uniform float u_opacity;void main() {fragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
                            backgroundPattern: Lt("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;void main() {gl_Position=projectTile(a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),
                            circle: Lt("in vec3 v_data;in float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);float antialiased_blur=v_data.z;float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));fragColor=v_visibility*opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);const float epsilon=0.5/255.0;if (fragColor.r < epsilon && fragColor.g < epsilon && fragColor.b < epsilon && fragColor.a < epsilon) {discard;}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform highp float u_globe_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;uniform vec2 u_translate;in vec2 a_pos;out vec3 v_data;out float v_visibility;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 pos_raw=a_pos+32768.0;vec2 extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);vec2 circle_center=floor(pos_raw/8.0)+u_translate;float ele=get_elevation(circle_center);v_visibility=calculate_visibility(projectTileWithElevation(circle_center,ele));if (u_pitch_with_map) {\n#ifdef GLOBE\nvec3 center_vector=projectToSphere(circle_center);\n#endif\nfloat angle_scale=u_globe_extrude_scale;vec2 corner_position=circle_center;if (u_scale_with_map) {angle_scale*=(radius+stroke_width);corner_position+=extrude*u_extrude_scale*(radius+stroke_width);} else {\n#ifdef GLOBE\nvec4 projected_center=interpolateProjection(circle_center,center_vector,ele);\n#else\nvec4 projected_center=projectTileWithElevation(circle_center,ele);\n#endif\ncorner_position+=extrude*u_extrude_scale*(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);angle_scale*=(radius+stroke_width)*(projected_center.w/u_camera_to_center_distance);}\n#ifdef GLOBE\nvec2 angles=extrude*angle_scale;vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(corner_position,corner_vector,ele);\n#else\ngl_Position=projectTileWithElevation(corner_position,ele);\n#endif\n} else {gl_Position=projectTileWithElevation(circle_center,ele);if (gl_Position.z/gl_Position.w > 1.0) {gl_Position.xy=vec2(10000.0);}if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}float antialiasblur=-max(1.0/u_device_pixel_ratio/(radius+stroke_width),blur);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),
                            clippingMask: Lt(sm, "in vec2 a_pos;void main() {gl_Position=projectTile(a_pos);}"),
                            heatmap: Lt("uniform highp float u_intensity;in vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);fragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;uniform highp float u_globe_extrude_scale;in vec2 a_pos;out vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 pos_raw=a_pos+32768.0;vec2 unscaled_extrude=vec2(mod(pos_raw,8.0)/7.0*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec2 circle_center=floor(pos_raw/8.0);\n#ifdef GLOBE\nvec2 angles=v_extrude*radius*u_globe_extrude_scale;vec3 center_vector=projectToSphere(circle_center);vec3 corner_vector=globeRotateVector(center_vector,angles);gl_Position=interpolateProjection(circle_center+extrude,corner_vector,0.0);\n#else\ngl_Position=projectTileFor3D(circle_center+extrude,get_elevation(circle_center));\n#endif\n}"),
                            heatmapTexture: Lt("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;in vec2 v_pos;void main() {float t=texture(u_image,v_pos).r;vec4 color=texture(u_color_ramp,vec2(t,0.5));fragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(0.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_world;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),
                            collisionBox: Lt("in float v_placed;in float v_notUsed;void main() {float alpha=0.5;fragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {fragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {fragColor*=.1;}}", "in vec2 a_anchor_pos;in vec2 a_placed;in vec2 a_box_real;uniform vec2 u_pixel_extrude_scale;out float v_placed;out float v_notUsed;void main() {gl_Position=projectTileWithElevation(a_anchor_pos,get_elevation(a_anchor_pos));gl_Position.xy=((a_box_real+0.5)*u_pixel_extrude_scale*2.0-1.0)*vec2(1.0,-1.0)*gl_Position.w;if (gl_Position.z/gl_Position.w < 1.1) {gl_Position.z=0.5;}v_placed=a_placed.x;v_notUsed=a_placed.y;}"),
                            collisionCircle: Lt("in float v_radius;in vec2 v_extrude;in float v_collision;void main() {float alpha=0.5;float stroke_radius=0.9;float distance_to_center=length(v_extrude);float distance_to_edge=abs(distance_to_center-v_radius);float opacity_t=smoothstep(-stroke_radius,0.0,-distance_to_edge);vec4 color=mix(vec4(0.0,0.0,1.0,0.5),vec4(1.0,0.0,0.0,1.0),v_collision);fragColor=color*alpha*opacity_t;}", "in vec2 a_pos;in float a_radius;in vec2 a_flags;uniform vec2 u_viewport_size;out float v_radius;out vec2 v_extrude;out float v_collision;void main() {float radius=a_radius;float collision=a_flags.x;float vertexIdx=a_flags.y;vec2 quadVertexOffset=vec2(mix(-1.0,1.0,float(vertexIdx >=2.0)),mix(-1.0,1.0,float(vertexIdx >=1.0 && vertexIdx <=2.0)));vec2 quadVertexExtent=quadVertexOffset*radius;float padding_factor=1.2;v_radius=radius;v_extrude=quadVertexExtent*padding_factor;v_collision=collision;gl_Position=vec4((a_pos/u_viewport_size*2.0-1.0)*vec2(1.0,-1.0),0.0,1.0)+vec4(quadVertexExtent*padding_factor/u_viewport_size*2.0,0.0,0.0);}"),
                            colorRelief: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;uniform vec4 u_unpack;uniform sampler2D u_elevation_stops;uniform sampler2D u_color_stops;uniform int u_color_ramp_size;uniform float u_opacity;in vec2 v_pos;float getElevation(vec2 coord) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}float getElevationStop(int stop) {float x=(float(stop)+0.5)/float(u_color_ramp_size);vec4 data=texture(u_elevation_stops,vec2(x,0))*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {float el=getElevation(v_pos);int r=(u_color_ramp_size-1);int l=0;float el_l=getElevationStop(l);float el_r=getElevationStop(r);while(r-l > 1){int m=(r+l)/2;float el_m=getElevationStop(m);if(el < el_m){r=m;el_r=el_m;}else\n{l=m;el_l=el_m;}}float x=(float(l)+(el-el_l)/(el_r-el_l)+0.5)/float(u_color_ramp_size);fragColor=u_opacity*texture(u_color_stops,vec2(x,0));\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_dimension;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_pos/8192.0)*scale+epsilon;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
                            debug: Lt("uniform highp vec4 u_color;uniform sampler2D u_overlay;in vec2 v_uv;void main() {vec4 overlay_color=texture(u_overlay,v_uv);fragColor=mix(u_color,overlay_color,overlay_color.a);}", "in vec2 a_pos;out vec2 v_uv;uniform float u_overlay_scale;void main() {v_uv=a_pos/8192.0;gl_Position=projectTileWithElevation(a_pos*u_overlay_scale,get_elevation(a_pos));}"),
                            depth: Lt(sm, "in vec2 a_pos;void main() {\n#ifdef GLOBE\ngl_Position=projectTileFor3D(a_pos,0.0);\n#else\ngl_Position=u_projection_matrix*vec4(a_pos,0.0,1.0);\n#endif\n}"),
                            fill: Lt("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\nfragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_fill_translate;in vec2 a_pos;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);}"),
                            fillOutline: Lt("in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=outline_color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
                            fillOutlinePattern: Lt("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;in vec2 v_pos_a;in vec2 v_pos_b;in vec2 v_pos;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);fragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;out vec2 v_pos;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n}"),
                            fillPattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);fragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec3 u_scale;uniform vec2 u_fill_translate;in vec2 a_pos;out vec2 v_pos_a;out vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;gl_Position=projectTile(a_pos+u_fill_translate,a_pos);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),
                            fillExtrusion: Lt("in vec4 v_color;void main() {fragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\nout vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nfloat colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;vec3 normalForLighting=normal/16384.0;float directional=clamp(dot(normalForLighting,u_lightpos),0.0,1.0);\n#ifdef GLOBE\nmat3 rotMatrix=globeGetRotationMatrix(spherePos);normalForLighting=rotMatrix*normalForLighting;directional=mix(directional,clamp(dot(normalForLighting,u_lightpos_globe),0.0,1.0),u_projection_transition);\n#endif\ndirectional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),
                            fillExtrusionPattern: Lt("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;in vec2 v_pos_a;in vec2 v_pos_b;in vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);fragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec3 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec2 u_fill_translate;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp vec3 u_lightpos_globe;uniform lowp float u_lightintensity;in vec2 a_pos;in vec4 a_normal_ed;\n#ifdef TERRAIN3D\nin vec2 a_centroid;\n#endif\n#ifdef GLOBE\nout vec3 v_sphere_pos;\n#endif\nout vec2 v_pos_a;out vec2 v_pos_b;out vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;\n#ifdef TERRAIN3D\nfloat height_terrain3d_offset=get_elevation(a_centroid);float base_terrain3d_offset=height_terrain3d_offset-(base > 0.0 ? 0.0 : 10.0);\n#else\nfloat height_terrain3d_offset=0.0;float base_terrain3d_offset=0.0;\n#endif\nbase=max(0.0,base)+base_terrain3d_offset;height=max(0.0,height)+height_terrain3d_offset;float t=mod(normal.x,2.0);float elevation=t > 0.0 ? height : base;vec2 posInTile=a_pos+u_fill_translate;\n#ifdef GLOBE\nvec3 spherePos=projectToSphere(posInTile,a_pos);vec3 elevatedPos=spherePos*(1.0+elevation/GLOBE_RADIUS);v_sphere_pos=elevatedPos;gl_Position=interpolateProjectionFor3D(posInTile,spherePos,elevation);\n#else\ngl_Position=u_projection_matrix*vec4(posInTile,elevation,1.0);\n#endif\nvec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,elevation*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),
                            hillshadePrepare: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack);}void main() {vec2 epsilon=1.0/u_dimension;float tileSize=u_dimension.x-2.0;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggerationFactor=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;float exaggeration=u_zoom < 15.0 ? (u_zoom-15.0)*exaggerationFactor : 0.0;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))*tileSize/pow(2.0,exaggeration+(28.2562-u_zoom));fragColor=clamp(vec4(deriv.x/8.0+0.5,deriv.y/8.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;uniform vec2 u_dimension;in vec2 a_pos;in vec2 a_texture_pos;out vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),
                            hillshade: Lt("uniform sampler2D u_image;in vec2 v_pos;uniform vec2 u_latrange;uniform float u_exaggeration;uniform vec4 u_accent;uniform int u_method;uniform float u_altitudes[NUM_ILLUMINATION_SOURCES];uniform float u_azimuths[NUM_ILLUMINATION_SOURCES];uniform vec4 u_shadows[NUM_ILLUMINATION_SOURCES];uniform vec4 u_highlights[NUM_ILLUMINATION_SOURCES];\n#define PI 3.141592653589793\n#define STANDARD 0\n#define COMBINED 1\n#define IGOR 2\n#define MULTIDIRECTIONAL 3\n#define BASIC 4\nfloat get_aspect(vec2 deriv){return deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);}void igor_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float aspect=get_aspect(deriv);float azimuth=u_azimuths[0]+PI;float slope_stength=atan(length(deriv))*2.0/PI;float aspect_strength=1.0-abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);float shadow_strength=slope_stength*aspect_strength;float highlight_strength=slope_stength*(1.0-aspect_strength);fragColor=u_shadows[0]*shadow_strength+u_highlights[0]*highlight_strength;}void standard_hillshade(vec2 deriv){float azimuth=u_azimuths[0]+PI;float slope=atan(0.625*length(deriv));float aspect=get_aspect(deriv);float intensity=u_exaggeration;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadows[0],u_highlights[0],shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);fragColor=accent_color*(1.0-shade_color.a)+shade_color;}void basic_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor=u_highlights[0]*(2.0*shade-1.0);}else\n{fragColor=u_shadows[0]*(1.0-2.0*shade);}}void multidirectional_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;fragColor=vec4(0,0,0,0);for(int i=0; i < NUM_ILLUMINATION_SOURCES; i++){float cos_alt=cos(u_altitudes[i]);float sin_alt=sin(u_altitudes[i]);float cos_az=-cos(u_azimuths[i]);float sin_az=-sin(u_azimuths[i]);float cang=(sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv));float shade=clamp(cang,0.0,1.0);if(shade > 0.5){fragColor+=u_highlights[i]*(2.0*shade-1.0)/float(NUM_ILLUMINATION_SOURCES);}else\n{fragColor+=u_shadows[i]*(1.0-2.0*shade)/float(NUM_ILLUMINATION_SOURCES);}}}void combined_hillshade(vec2 deriv){deriv=deriv*u_exaggeration*2.0;float azimuth=u_azimuths[0]+PI;float cos_az=cos(azimuth);float sin_az=sin(azimuth);float cos_alt=cos(u_altitudes[0]);float sin_alt=sin(u_altitudes[0]);float cang=acos((sin_alt-(deriv.y*cos_az*cos_alt-deriv.x*sin_az*cos_alt))/sqrt(1.0+dot(deriv,deriv)));cang=clamp(cang,0.0,PI/2.0);float shade=cang*atan(length(deriv))*4.0/PI/PI;float highlight=(PI/2.0-cang)*atan(length(deriv))*4.0/PI/PI;fragColor=u_shadows[0]*shade+u_highlights[0]*highlight;}void main() {vec4 pixel=texture(u_image,v_pos);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));vec2 deriv=((pixel.rg*8.0)-4.0)/scaleFactor;if (u_method==BASIC) {basic_hillshade(deriv);} else if (u_method==COMBINED) {combined_hillshade(deriv);} else if (u_method==IGOR) {igor_hillshade(deriv);} else if (u_method==MULTIDIRECTIONAL) {multidirectional_hillshade(deriv);} else if (u_method==STANDARD) {standard_hillshade(deriv);} else {standard_hillshade(deriv);}\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform mat4 u_matrix;in vec2 a_pos;out vec2 v_pos;void main() {gl_Position=projectTile(a_pos,a_pos);v_pos=a_pos/8192.0;if (a_pos.y <-32767.5) {v_pos.y=0.0;}if (a_pos.y > 32766.5) {v_pos.y=1.0;}}"),
                            line: Lt("uniform lowp float u_device_pixel_ratio;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp float v_linesofar;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            lineGradient: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;in vec2 v_width2;in vec2 v_normal;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;highp float texel_height=1.0/u_image_height;highp float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_width2=vec2(outset,inset);}"),
                            linePattern: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec3 u_scale;uniform sampler2D u_image;in vec2 v_normal;in vec2 v_width2;in float v_linesofar;in float v_gamma_scale;in float v_width;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float tileZoomRatio=u_scale.x;float fromScale=u_scale.y;float toScale=u_scale.z;vec2 display_size_a=(pattern_br_a-pattern_tl_a)/pixel_ratio_from;vec2 display_size_b=(pattern_br_b-pattern_tl_b)/pixel_ratio_to;vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float aspect_a=display_size_a.y/v_width;float aspect_b=display_size_b.y/v_width;float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x*aspect_a,1.0);float x_b=mod(v_linesofar/pattern_size_b.x*aspect_b,1.0);float y=0.5*v_normal.y+0.5;vec2 texel_size=1.0/u_texsize;vec2 pos_a=mix(pattern_tl_a*texel_size-texel_size,pattern_br_a*texel_size+texel_size,vec2(x_a,y));vec2 pos_b=mix(pattern_tl_b*texel_size-texel_size,pattern_br_b*texel_size+texel_size,vec2(x_b,y));vec4 color=mix(texture(u_image,pos_a),texture(u_image,pos_b),u_fade);fragColor=color*alpha*opacity;\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;out vec2 v_normal;out vec2 v_width2;out float v_linesofar;out float v_gamma_scale;out float v_width;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float pixel_ratio_from\n#pragma mapbox: define lowp float pixel_ratio_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float pixel_ratio_from\n#pragma mapbox: initialize lowp float pixel_ratio_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nv_linesofar=a_linesofar;v_width2=vec2(outset,inset);v_width=floorwidth;}"),
                            lineSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform lowp float u_lineatlas_width;uniform sampler2D u_image;uniform float u_mix;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture(u_image,v_tex_a).a;float sdfdist_b=texture(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0/u_device_pixel_ratio)/min(dasharray_from.w,dasharray_to.w);alpha*=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out vec2 v_tex_a;out vec2 v_tex_b;out float v_gamma_scale;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
                            lineGradientSDF: Lt("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform sampler2D u_image_dash;uniform float u_mix;uniform lowp float u_lineatlas_width;in vec2 v_normal;in vec2 v_width2;in vec2 v_tex_a;in vec2 v_tex_b;in float v_gamma_scale;in highp vec2 v_uv;\n#ifdef GLOBE\nin float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture(u_image,v_uv);float sdfdist_a=texture(u_image_dash,v_tex_a).a;float sdfdist_b=texture(u_image_dash,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);float sdfgamma=(u_lineatlas_width/256.0)/min(dasharray_from.w,dasharray_to.w);float dash_alpha=smoothstep(0.5-sdfgamma/floorwidth,0.5+sdfgamma/floorwidth,sdfdist);fragColor=color*(alpha*dash_alpha*opacity);\n#ifdef GLOBE\nif (v_depth > 1.0) {discard;}\n#endif\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nin vec2 a_pos_normal;in vec4 a_data;in float a_uv_x;in float a_split_index;uniform vec2 u_translation;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;uniform float u_image_height;uniform float u_tileratio;uniform float u_crossfade_from;uniform float u_crossfade_to;uniform float u_lineatlas_height;out vec2 v_normal;out vec2 v_width2;out float v_gamma_scale;out highp vec2 v_uv;out vec2 v_tex_a;out vec2 v_tex_b;\n#ifdef GLOBE\nout float v_depth;\n#endif\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\n#pragma mapbox: define mediump vec4 dasharray_from\n#pragma mapbox: define mediump vec4 dasharray_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\n#pragma mapbox: initialize mediump vec4 dasharray_from\n#pragma mapbox: initialize mediump vec4 dasharray_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;float texel_height=1.0/u_image_height;float half_texel_height=0.5*texel_height;v_uv=vec2(a_uv_x,a_split_index*texel_height-half_texel_height);vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);float adjustedThickness=projectLineThickness(pos.y);vec4 projected_no_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation);vec4 projected_with_extrude=projectTile(pos+offset2/u_ratio*adjustedThickness+u_translation+dist/u_ratio*adjustedThickness);gl_Position=projected_with_extrude;\n#ifdef GLOBE\nv_depth=gl_Position.z/gl_Position.w;\n#endif\n#ifdef TERRAIN3D\nv_gamma_scale=1.0;\n#else\nfloat extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length((projected_with_extrude.xy-projected_no_extrude.xy)/projected_with_extrude.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;\n#endif\nfloat u_patternscale_a_x=u_tileratio/dasharray_from.w/u_crossfade_from;float u_patternscale_a_y=-dasharray_from.z/2.0/u_lineatlas_height;float u_patternscale_b_x=u_tileratio/dasharray_to.w/u_crossfade_to;float u_patternscale_b_y=-dasharray_to.z/2.0/u_lineatlas_height;v_tex_a=vec2(a_linesofar*u_patternscale_a_x/floorwidth,normal.y*u_patternscale_a_y+(float(dasharray_from.y)+0.5)/u_lineatlas_height);v_tex_b=vec2(a_linesofar*u_patternscale_b_x/floorwidth,normal.y*u_patternscale_b_y+(float(dasharray_to.y)+0.5)/u_lineatlas_height);v_width2=vec2(outset,inset);}"),
                            raster: Lt("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;in vec2 v_pos0;in vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture(u_image0,v_pos0);vec4 color1=texture(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);fragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;uniform vec4 u_coords_top;uniform vec4 u_coords_bottom;in vec2 a_pos;out vec2 v_pos0;out vec2 v_pos1;void main() {vec2 fractionalPos=a_pos/8192.0;vec2 position=mix(mix(u_coords_top.xy,u_coords_top.zw,fractionalPos.x),mix(u_coords_bottom.xy,u_coords_bottom.zw,fractionalPos.x),fractionalPos.y);gl_Position=projectTile(position,position);v_pos0=((fractionalPos-0.5)/u_buffer_scale)+0.5;\n#ifdef GLOBE\nif (a_pos.y <-32767.5) {v_pos0.y=0.0;}if (a_pos.y > 32766.5) {v_pos0.y=1.0;}\n#endif\nv_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),
                            symbolIcon: Lt("uniform sampler2D u_texture;in vec2 v_tex;in float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;fragColor=texture(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_tex;out float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}gl_Position=finalPos;v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float visibility=calculate_visibility(projectedPoint);v_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));}"),
                            symbolSDF: Lt("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;in vec2 v_data0;in vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float inner_edge=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);inner_edge=inner_edge+gamma*gamma_scale;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(inner_edge-gamma_scaled,inner_edge+gamma_scaled,dist);if (u_is_halo) {lowp float halo_edge=(6.0-halo_width/fontScale)/SDF_PX;alpha=min(smoothstep(halo_edge-gamma_scaled,halo_edge+gamma_scaled,dist),1.0-alpha);}fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec4 a_pixeloffset;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_translation;uniform float u_pitched_scale;out vec2 v_data0;out vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),
                            symbolTextAndIcon: Lt("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;in vec4 v_data0;in vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;fragColor=texture(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);fragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\nfragColor=vec4(1.0);\n#endif\n}", "in vec4 a_pos_offset;in vec4 a_data;in vec3 a_projected_pos;in float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;uniform bool u_is_along_line;uniform bool u_is_variable_anchor;uniform vec2 u_translation;uniform float u_pitched_scale;out vec4 v_data0;out vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;float ele=get_elevation(a_pos);highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec2 translated_a_pos=a_pos+u_translation;vec4 projectedPoint=projectTileWithElevation(translated_a_pos,ele);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=projectTileWithElevation(translated_a_pos+vec2(1,0),ele);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos;if (u_is_along_line || u_is_variable_anchor) {projected_pos=vec4(a_projected_pos.xy,ele,1.0);} else if (u_pitch_with_map) {projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy+u_translation,ele,1.0);} else {projected_pos=u_label_plane_matrix*projectTileWithElevation(a_projected_pos.xy+u_translation,ele);}float z=float(u_pitch_with_map)*projected_pos.z/projected_pos.w;float projectionScaling=1.0;\n#ifdef GLOBE\nif(u_pitch_with_map && !u_is_along_line) {float anchor_pos_tile_y=(u_coord_matrix*vec4(projected_pos.xy/projected_pos.w,z,1.0)).y;projectionScaling=mix(projectionScaling,1.0/circumferenceRatioAtTileY(anchor_pos_tile_y)*u_pitched_scale,u_projection_transition);}\n#endif\nvec4 finalPos=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale)*projectionScaling,z,1.0);if(u_pitch_with_map) {finalPos=projectTileWithElevation(finalPos.xy,finalPos.z);}float gamma_scale=finalPos.w;gl_Position=finalPos;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float visibility=calculate_visibility(projectedPoint);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(visibility,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}"),
                            terrain: Lt("uniform sampler2D u_texture;uniform vec4 u_fog_color;uniform vec4 u_horizon_color;uniform float u_fog_ground_blend;uniform float u_fog_ground_blend_opacity;uniform float u_horizon_fog_blend;uniform bool u_is_globe_mode;in vec2 v_texture_pos;in float v_fog_depth;const float gamma=2.2;vec4 gammaToLinear(vec4 color) {return pow(color,vec4(gamma));}vec4 linearToGamma(vec4 color) {return pow(color,vec4(1.0/gamma));}void main() {vec4 surface_color=texture(u_texture,vec2(v_texture_pos.x,1.0-v_texture_pos.y));if (!u_is_globe_mode && v_fog_depth > u_fog_ground_blend) {vec4 surface_color_linear=gammaToLinear(surface_color);float blend_color=smoothstep(0.0,1.0,max((v_fog_depth-u_horizon_fog_blend)/(1.0-u_horizon_fog_blend),0.0));vec4 fog_horizon_color_linear=mix(gammaToLinear(u_fog_color),gammaToLinear(u_horizon_color),blend_color);float factor_fog=max(v_fog_depth-u_fog_ground_blend,0.0)/(1.0-u_fog_ground_blend);fragColor=linearToGamma(mix(surface_color_linear,fog_horizon_color_linear,pow(factor_fog,2.0)*u_fog_ground_blend_opacity));} else {fragColor=surface_color;}}", "in vec3 a_pos3d;uniform mat4 u_fog_matrix;uniform float u_ele_delta;out vec2 v_texture_pos;out float v_fog_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,get_elevation(a_pos3d.xy)-ele_delta);vec4 pos=u_fog_matrix*vec4(a_pos3d.xy,ele,1.0);v_fog_depth=pos.z/pos.w*0.5+0.5;}"),
                            terrainDepth: Lt("in float v_depth;const highp vec4 bitSh=vec4(256.*256.*256.,256.*256.,256.,1.);const highp vec4 bitMsk=vec4(0.,vec3(1./256.0));highp vec4 pack(highp float value) {highp vec4 comp=fract(value*bitSh);comp-=comp.xxyz*bitMsk;return comp;}void main() {fragColor=pack(v_depth);}", "in vec3 a_pos3d;uniform float u_ele_delta;out float v_depth;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);v_depth=gl_Position.z/gl_Position.w;}"),
                            terrainCoords: Lt("precision mediump float;uniform sampler2D u_texture;uniform float u_terrain_coords_id;in vec2 v_texture_pos;void main() {vec4 rgba=texture(u_texture,v_texture_pos);fragColor=vec4(rgba.r,rgba.g,rgba.b,u_terrain_coords_id);}", "in vec3 a_pos3d;uniform float u_ele_delta;out vec2 v_texture_pos;void main() {float ele=get_elevation(a_pos3d.xy);float ele_delta=a_pos3d.z==1.0 ? u_ele_delta : 0.0;v_texture_pos=a_pos3d.xy/8192.0;gl_Position=projectTileFor3D(a_pos3d.xy,ele-ele_delta);}"),
                            projectionErrorMeasurement: Lt("in vec4 v_output_error_encoded;void main() {fragColor=v_output_error_encoded;}", "in vec2 a_pos;uniform highp float u_input;uniform highp float u_output_expected;out vec4 v_output_error_encoded;void main() {float real_output=2.0*atan(exp(PI-(u_input*PI*2.0)))-PI*0.5;float error=real_output-u_output_expected;float abs_error=abs(error)*128.0;v_output_error_encoded.x=min(floor(abs_error*256.0),255.0)/255.0;abs_error-=v_output_error_encoded.x;v_output_error_encoded.y=min(floor(abs_error*65536.0),255.0)/255.0;abs_error-=v_output_error_encoded.x/255.0;v_output_error_encoded.z=min(floor(abs_error*16777216.0),255.0)/255.0;v_output_error_encoded.w=error >=0.0 ? 1.0 : 0.0;gl_Position=vec4(a_pos,0.0,1.0);}"),
                            atmosphere: Lt("#ifdef GL_ES\nprecision highp float;\n#endif\nin vec3 view_direction;uniform vec3 u_sun_pos;uniform vec3 u_globe_position;uniform float u_globe_radius;uniform float u_atmosphere_blend;/**Shader use from https:*Made some change to adapt to MapLibre Globe geometry*/const float PI=3.141592653589793;const int iSteps=5;const int jSteps=3;/*radius of the planet*/const float EARTH_RADIUS=6371e3;/*radius of the atmosphere*/const float ATMOS_RADIUS=6471e3;vec2 rsi(vec3 r0,vec3 rd,float sr) {float a=dot(rd,rd);float b=2.0*dot(rd,r0);float c=dot(r0,r0)-(sr*sr);float d=(b*b)-4.0*a*c;if (d < 0.0) return vec2(1e5,-1e5);return vec2((-b-sqrt(d))/(2.0*a),(-b+sqrt(d))/(2.0*a));}vec4 atmosphere(vec3 r,vec3 r0,vec3 pSun,float iSun,float rPlanet,float rAtmos,vec3 kRlh,float kMie,float shRlh,float shMie,float g) {pSun=normalize(pSun);r=normalize(r);vec2 p=rsi(r0,r,rAtmos);if (p.x > p.y) {return vec4(0.0,0.0,0.0,1.0);}if (p.x < 0.0) {p.x=0.0;}vec3 pos=r0+r*p.x;vec2 p2=rsi(r0,r,rPlanet);if (p2.x <=p2.y && p2.x > 0.0) {p.y=min(p.y,p2.x);}float iStepSize=(p.y-p.x)/float(iSteps);float iTime=p.x+iStepSize*0.5;vec3 totalRlh=vec3(0,0,0);vec3 totalMie=vec3(0,0,0);float iOdRlh=0.0;float iOdMie=0.0;float mu=dot(r,pSun);float mumu=mu*mu;float gg=g*g;float pRlh=3.0/(16.0*PI)*(1.0+mumu);float pMie=3.0/(8.0*PI)*((1.0-gg)*(mumu+1.0))/(pow(1.0+gg-2.0*mu*g,1.5)*(2.0+gg));for (int i=0; i < iSteps; i++) {vec3 iPos=r0+r*iTime;float iHeight=length(iPos)-rPlanet;float odStepRlh=exp(-iHeight/shRlh)*iStepSize;float odStepMie=exp(-iHeight/shMie)*iStepSize;iOdRlh+=odStepRlh;iOdMie+=odStepMie;float jStepSize=rsi(iPos,pSun,rAtmos).y/float(jSteps);float jTime=jStepSize*0.5;float jOdRlh=0.0;float jOdMie=0.0;for (int j=0; j < jSteps; j++) {vec3 jPos=iPos+pSun*jTime;float jHeight=length(jPos)-rPlanet;jOdRlh+=exp(-jHeight/shRlh)*jStepSize;jOdMie+=exp(-jHeight/shMie)*jStepSize;jTime+=jStepSize;}vec3 attn=exp(-(kMie*(iOdMie+jOdMie)+kRlh*(iOdRlh+jOdRlh)));totalRlh+=odStepRlh*attn;totalMie+=odStepMie*attn;iTime+=iStepSize;}float opacity=exp(-(length(kRlh)*length(totalRlh)+kMie*length(totalMie)));vec3 color=iSun*(pRlh*kRlh*totalRlh+pMie*kMie*totalMie);return vec4(color,opacity);}void main() {vec3 scale_camera_pos=-u_globe_position*EARTH_RADIUS/u_globe_radius;vec4 color=atmosphere(normalize(view_direction),scale_camera_pos,u_sun_pos,22.0,EARTH_RADIUS,ATMOS_RADIUS,vec3(5.5e-6,13.0e-6,22.4e-6),21e-6,8e3,1.2e3,0.758\n);color.rgb=1.0-exp(-1.0*color.rgb);color=pow(color,vec4(1.0/2.2));fragColor=vec4(color.rgb,1.0-color.a)*u_atmosphere_blend;}", "in vec2 a_pos;uniform mat4 u_inv_proj_matrix;out vec3 view_direction;void main() {view_direction=(u_inv_proj_matrix*vec4(a_pos,0.0,1.0)).xyz;gl_Position=vec4(a_pos,0.0,1.0);}"),
                            sky: Lt("uniform vec4 u_sky_color;uniform vec4 u_horizon_color;uniform vec2 u_horizon;uniform vec2 u_horizon_normal;uniform float u_sky_horizon_blend;uniform float u_sky_blend;void main() {float x=gl_FragCoord.x;float y=gl_FragCoord.y;float blend=(y-u_horizon.y)*u_horizon_normal.y+(x-u_horizon.x)*u_horizon_normal.x;if (blend > 0.0) {if (blend < u_sky_horizon_blend) {fragColor=mix(u_sky_color,u_horizon_color,pow(1.0-blend/u_sky_horizon_blend,2.0));} else {fragColor=u_sky_color;}}fragColor=mix(fragColor,vec4(vec3(0.0),0.0),u_sky_blend);}", "in vec2 a_pos;void main() {gl_Position=vec4(a_pos,1.0,1.0);}")
                        };
                        function Lt(le1, vt) {
                            const bt = /#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g, ls = vt.match(/in ([\w]+) ([\w]+)/g), ho = le1.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), Dl = vt.match(/uniform ([\w]+) ([\w]+)([\s]*)([\w]*)/g), Fl = Dl ? Dl.concat(ho) : ho, sc = {};
                            return {
                                fragmentSource: le1 = le1.replace(bt, (le1, vt, bt, ls, ho)=>(sc[ho] = !0, "define" === vt ? `\n#ifndef HAS_UNIFORM_u_${ho}\nin ${bt} ${ls} ${ho};\n#else\nuniform ${bt} ${ls} u_${ho};\n#endif\n` : `\n#ifdef HAS_UNIFORM_u_${ho}\n    ${bt} ${ls} ${ho} = u_${ho};\n#endif\n`)),
                                vertexSource: vt = vt.replace(bt, (le1, vt, bt, ls, ho)=>{
                                    const Dl = "float" === ls ? "vec2" : "vec4", Fl = ho.match(/color/) ? "color" : Dl;
                                    return sc[ho] ? "define" === vt ? `\n#ifndef HAS_UNIFORM_u_${ho}\nuniform lowp float u_${ho}_t;\nin ${bt} ${Dl} a_${ho};\nout ${bt} ${ls} ${ho};\n#else\nuniform ${bt} ${ls} u_${ho};\n#endif\n` : "vec4" === Fl ? `\n#ifndef HAS_UNIFORM_u_${ho}\n    ${ho} = a_${ho};\n#else\n    ${bt} ${ls} ${ho} = u_${ho};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${ho}\n    ${ho} = unpack_mix_${Fl}(a_${ho}, u_${ho}_t);\n#else\n    ${bt} ${ls} ${ho} = u_${ho};\n#endif\n` : "define" === vt ? `\n#ifndef HAS_UNIFORM_u_${ho}\nuniform lowp float u_${ho}_t;\nin ${bt} ${Dl} a_${ho};\n#else\nuniform ${bt} ${ls} u_${ho};\n#endif\n` : "vec4" === Fl ? `\n#ifndef HAS_UNIFORM_u_${ho}\n    ${bt} ${ls} ${ho} = a_${ho};\n#else\n    ${bt} ${ls} ${ho} = u_${ho};\n#endif\n` : `\n#ifndef HAS_UNIFORM_u_${ho}\n    ${bt} ${ls} ${ho} = unpack_mix_${Fl}(a_${ho}, u_${ho}_t);\n#else\n    ${bt} ${ls} ${ho} = u_${ho};\n#endif\n`;
                                }),
                                staticAttributes: ls,
                                staticUniforms: Fl
                            };
                        }
                        class kt {
                            constructor(le1, vt, bt){
                                this.vertexBuffer = le1, this.indexBuffer = vt, this.segments = bt;
                            }
                            destroy() {
                                this.vertexBuffer.destroy(), this.indexBuffer.destroy(), this.segments.destroy(), this.vertexBuffer = null, this.indexBuffer = null, this.segments = null;
                            }
                        }
                        var lm = vt.aU([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        const cm = "#define PROJECTION_MERCATOR", um = "mercator";
                        class jt {
                            constructor(){
                                this._cachedMesh = null;
                            }
                            get name() {
                                return "mercator";
                            }
                            get useSubdivision() {
                                return !1;
                            }
                            get shaderVariantName() {
                                return um;
                            }
                            get shaderDefine() {
                                return cm;
                            }
                            get shaderPreludeCode() {
                                return om.projectionMercator;
                            }
                            get vertexShaderPreludeCode() {
                                return om.projectionMercator.vertexSource;
                            }
                            get subdivisionGranularity() {
                                return vt.aV.noSubdivision;
                            }
                            get useGlobeControls() {
                                return !1;
                            }
                            get transitionState() {
                                return 0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return 0;
                            }
                            destroy() {}
                            updateGPUdependent(le1) {}
                            getMeshFromTileID(le1, bt, ls, ho, Dl) {
                                if (this._cachedMesh) return this._cachedMesh;
                                const Fl = new vt.aW;
                                Fl.emplaceBack(0, 0), Fl.emplaceBack(vt.a5, 0), Fl.emplaceBack(0, vt.a5), Fl.emplaceBack(vt.a5, vt.a5);
                                const sc = le1.createVertexBuffer(Fl, lm.members), uc = vt.aX.simpleSegment(0, 0, 4, 2), mc = new vt.aY;
                                mc.emplaceBack(1, 0, 2), mc.emplaceBack(1, 2, 3);
                                const gc = le1.createIndexBuffer(mc);
                                return this._cachedMesh = new kt(sc, gc, uc), this._cachedMesh;
                            }
                            recalculate() {}
                            hasTransition() {
                                return !1;
                            }
                            setErrorQueryLatitudeDegrees(le1) {}
                        }
                        class Nt {
                            constructor(le1 = 0, vt = 0, bt = 0, ls = 0){
                                if (isNaN(le1) || le1 < 0 || isNaN(vt) || vt < 0 || isNaN(bt) || bt < 0 || isNaN(ls) || ls < 0) throw new Error("Invalid value for edge-insets, top, bottom, left and right must all be numbers");
                                this.top = le1, this.bottom = vt, this.left = bt, this.right = ls;
                            }
                            interpolate(le1, bt, ls) {
                                return null != bt.top && null != le1.top && (this.top = vt.G.number(le1.top, bt.top, ls)), null != bt.bottom && null != le1.bottom && (this.bottom = vt.G.number(le1.bottom, bt.bottom, ls)), null != bt.left && null != le1.left && (this.left = vt.G.number(le1.left, bt.left, ls)), null != bt.right && null != le1.right && (this.right = vt.G.number(le1.right, bt.right, ls)), this;
                            }
                            getCenter(le1, bt) {
                                const ls = vt.an((this.left + le1 - this.right) / 2, 0, le1), ho = vt.an((this.top + bt - this.bottom) / 2, 0, bt);
                                return new vt.P(ls, ho);
                            }
                            equals(le1) {
                                return this.top === le1.top && this.bottom === le1.bottom && this.left === le1.left && this.right === le1.right;
                            }
                            clone() {
                                return new Nt(this.top, this.bottom, this.left, this.right);
                            }
                            toJSON() {
                                return {
                                    top: this.top,
                                    bottom: this.bottom,
                                    left: this.left,
                                    right: this.right
                                };
                            }
                        }
                        function Zt(le1, vt) {
                            if (!le1.renderWorldCopies || le1.lngRange) return;
                            const bt = vt.lng - le1.center.lng;
                            vt.lng += bt > 180 ? -360 : bt < -180 ? 360 : 0;
                        }
                        function Ut(le1) {
                            return Math.max(0, Math.floor(le1));
                        }
                        class Gt {
                            constructor(le1, bt){
                                var ls;
                                this.applyConstrain = (le1, vt)=>null !== this._constrainOverride ? this._constrainOverride(le1, vt) : this._callbacks.defaultConstrain(le1, vt), this._callbacks = le1, this._tileSize = 512, this._renderWorldCopies = void 0 === (null == bt ? void 0 : bt.renderWorldCopies) || !!(null == bt ? void 0 : bt.renderWorldCopies), this._minZoom = (null == bt ? void 0 : bt.minZoom) || 0, this._maxZoom = (null == bt ? void 0 : bt.maxZoom) || 22, this._minPitch = null == (null == bt ? void 0 : bt.minPitch) ? 0 : null == bt ? void 0 : bt.minPitch, this._maxPitch = null == (null == bt ? void 0 : bt.maxPitch) ? 60 : null == bt ? void 0 : bt.maxPitch, this._constrainOverride = null !== (ls = null == bt ? void 0 : bt.constrainOverride) && void 0 !== ls ? ls : null, this.setMaxBounds(), this._width = 0, this._height = 0, this._center = new vt.V(0, 0), this._elevation = 0, this._zoom = 0, this._tileZoom = Ut(this._zoom), this._scale = vt.aq(this._zoom), this._bearingInRadians = 0, this._fovInRadians = .6435011087932844, this._pitchInRadians = 0, this._rollInRadians = 0, this._unmodified = !0, this._edgeInsets = new Nt, this._minElevationForCurrentTile = 0, this._autoCalculateNearFarZ = !0;
                            }
                            apply(le1, bt, ls) {
                                this._constrainOverride = le1.constrainOverride, this._latRange = le1.latRange, this._lngRange = le1.lngRange, this._width = le1.width, this._height = le1.height, this._center = le1.center, this._elevation = le1.elevation, this._minElevationForCurrentTile = le1.minElevationForCurrentTile, this._zoom = le1.zoom, this._tileZoom = Ut(this._zoom), this._scale = vt.aq(this._zoom), this._bearingInRadians = le1.bearingInRadians, this._fovInRadians = le1.fovInRadians, this._pitchInRadians = le1.pitchInRadians, this._rollInRadians = le1.rollInRadians, this._unmodified = le1.unmodified, this._edgeInsets = new Nt(le1.padding.top, le1.padding.bottom, le1.padding.left, le1.padding.right), this._minZoom = le1.minZoom, this._maxZoom = le1.maxZoom, this._minPitch = le1.minPitch, this._maxPitch = le1.maxPitch, this._renderWorldCopies = le1.renderWorldCopies, this._cameraToCenterDistance = le1.cameraToCenterDistance, this._nearZ = le1.nearZ, this._farZ = le1.farZ, this._autoCalculateNearFarZ = !ls && le1.autoCalculateNearFarZ, bt && this.constrainInternal(), this._calcMatrices();
                            }
                            get pixelsToClipSpaceMatrix() {
                                return this._pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._clipSpaceToPixelsMatrix;
                            }
                            get minElevationForCurrentTile() {
                                return this._minElevationForCurrentTile;
                            }
                            setMinElevationForCurrentTile(le1) {
                                this._minElevationForCurrentTile = le1;
                            }
                            get tileSize() {
                                return this._tileSize;
                            }
                            get tileZoom() {
                                return this._tileZoom;
                            }
                            get scale() {
                                return this._scale;
                            }
                            get width() {
                                return this._width;
                            }
                            get height() {
                                return this._height;
                            }
                            get bearingInRadians() {
                                return this._bearingInRadians;
                            }
                            get lngRange() {
                                return this._lngRange;
                            }
                            get latRange() {
                                return this._latRange;
                            }
                            get pixelsToGLUnits() {
                                return this._pixelsToGLUnits;
                            }
                            get minZoom() {
                                return this._minZoom;
                            }
                            setMinZoom(le1) {
                                this._minZoom !== le1 && (this._minZoom = le1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
                            }
                            get maxZoom() {
                                return this._maxZoom;
                            }
                            setMaxZoom(le1) {
                                this._maxZoom !== le1 && (this._maxZoom = le1, this.setZoom(this.applyConstrain(this._center, this.zoom).zoom));
                            }
                            get minPitch() {
                                return this._minPitch;
                            }
                            setMinPitch(le1) {
                                this._minPitch !== le1 && (this._minPitch = le1, this.setPitch(Math.max(this.pitch, le1)));
                            }
                            get maxPitch() {
                                return this._maxPitch;
                            }
                            setMaxPitch(le1) {
                                this._maxPitch !== le1 && (this._maxPitch = le1, this.setPitch(Math.min(this.pitch, le1)));
                            }
                            get renderWorldCopies() {
                                return this._renderWorldCopies;
                            }
                            setRenderWorldCopies(le1) {
                                void 0 === le1 ? le1 = !0 : null === le1 && (le1 = !1), this._renderWorldCopies = le1;
                            }
                            get constrainOverride() {
                                return this._constrainOverride;
                            }
                            setConstrainOverride(le1) {
                                void 0 === le1 && (le1 = null), this._constrainOverride !== le1 && (this._constrainOverride = le1, this.constrainInternal(), this._calcMatrices());
                            }
                            get worldSize() {
                                return this._tileSize * this._scale;
                            }
                            get centerOffset() {
                                return this.centerPoint._sub(this.size._div(2));
                            }
                            get size() {
                                return new vt.P(this._width, this._height);
                            }
                            get bearing() {
                                return this._bearingInRadians / Math.PI * 180;
                            }
                            setBearing(le1) {
                                const bt = vt.W(le1, -180, 180) * Math.PI / 180;
                                var ls, ho, Dl, Fl, sc, uc, mc, gc, Ac;
                                this._bearingInRadians !== bt && (this._unmodified = !1, this._bearingInRadians = bt, this._calcMatrices(), this._rotationMatrix = a(), ls = this._rotationMatrix, Dl = -this._bearingInRadians, Fl = (ho = this._rotationMatrix)[0], sc = ho[1], uc = ho[2], mc = ho[3], gc = Math.sin(Dl), Ac = Math.cos(Dl), ls[0] = Fl * Ac + uc * gc, ls[1] = sc * Ac + mc * gc, ls[2] = Fl * -gc + uc * Ac, ls[3] = sc * -gc + mc * Ac);
                            }
                            get rotationMatrix() {
                                return this._rotationMatrix;
                            }
                            get pitchInRadians() {
                                return this._pitchInRadians;
                            }
                            get pitch() {
                                return this._pitchInRadians / Math.PI * 180;
                            }
                            setPitch(le1) {
                                const bt = vt.an(le1, this.minPitch, this.maxPitch) / 180 * Math.PI;
                                this._pitchInRadians !== bt && (this._unmodified = !1, this._pitchInRadians = bt, this._calcMatrices());
                            }
                            get rollInRadians() {
                                return this._rollInRadians;
                            }
                            get roll() {
                                return this._rollInRadians / Math.PI * 180;
                            }
                            setRoll(le1) {
                                const vt = le1 / 180 * Math.PI;
                                this._rollInRadians !== vt && (this._unmodified = !1, this._rollInRadians = vt, this._calcMatrices());
                            }
                            get fovInRadians() {
                                return this._fovInRadians;
                            }
                            get fov() {
                                return vt.aZ(this._fovInRadians);
                            }
                            setFov(le1) {
                                le1 = vt.an(le1, .1, 150), this.fov !== le1 && (this._unmodified = !1, this._fovInRadians = vt.ap(le1), this._calcMatrices());
                            }
                            get zoom() {
                                return this._zoom;
                            }
                            setZoom(le1) {
                                const bt = this.applyConstrain(this._center, le1).zoom;
                                this._zoom !== bt && (this._unmodified = !1, this._zoom = bt, this._tileZoom = Math.max(0, Math.floor(bt)), this._scale = vt.aq(bt), this.constrainInternal(), this._calcMatrices());
                            }
                            get center() {
                                return this._center;
                            }
                            setCenter(le1) {
                                le1.lat === this._center.lat && le1.lng === this._center.lng || (this._unmodified = !1, this._center = le1, this.constrainInternal(), this._calcMatrices());
                            }
                            get elevation() {
                                return this._elevation;
                            }
                            setElevation(le1) {
                                le1 !== this._elevation && (this._elevation = le1, this.constrainInternal(), this._calcMatrices());
                            }
                            get padding() {
                                return this._edgeInsets.toJSON();
                            }
                            setPadding(le1) {
                                this._edgeInsets.equals(le1) || (this._unmodified = !1, this._edgeInsets.interpolate(this._edgeInsets, le1, 1), this._calcMatrices());
                            }
                            get centerPoint() {
                                return this._edgeInsets.getCenter(this._width, this._height);
                            }
                            get pixelsPerMeter() {
                                return this._pixelPerMeter;
                            }
                            get unmodified() {
                                return this._unmodified;
                            }
                            get cameraToCenterDistance() {
                                return this._cameraToCenterDistance;
                            }
                            get nearZ() {
                                return this._nearZ;
                            }
                            get farZ() {
                                return this._farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._autoCalculateNearFarZ;
                            }
                            overrideNearFarZ(le1, vt) {
                                this._autoCalculateNearFarZ = !1, this._nearZ = le1, this._farZ = vt, this._calcMatrices();
                            }
                            clearNearFarZOverride() {
                                this._autoCalculateNearFarZ = !0, this._calcMatrices();
                            }
                            isPaddingEqual(le1) {
                                return this._edgeInsets.equals(le1);
                            }
                            interpolatePadding(le1, vt, bt) {
                                this._unmodified = !1, this._edgeInsets.interpolate(le1, vt, bt), this.constrainInternal(), this._calcMatrices();
                            }
                            resize(le1, vt, bt = !0) {
                                this._width = le1, this._height = vt, bt && this.constrainInternal(), this._calcMatrices();
                            }
                            getMaxBounds() {
                                return this._latRange && 2 === this._latRange.length && this._lngRange && 2 === this._lngRange.length ? new $([
                                    this._lngRange[0],
                                    this._latRange[0]
                                ], [
                                    this._lngRange[1],
                                    this._latRange[1]
                                ]) : null;
                            }
                            setMaxBounds(le1) {
                                le1 ? (this._lngRange = [
                                    le1.getWest(),
                                    le1.getEast()
                                ], this._latRange = [
                                    le1.getSouth(),
                                    le1.getNorth()
                                ], this.constrainInternal()) : (this._lngRange = null, this._latRange = [
                                    -vt.ao,
                                    vt.ao
                                ]);
                            }
                            getCameraQueryGeometry(le1, bt) {
                                if (1 === bt.length) return [
                                    bt[0],
                                    le1
                                ];
                                {
                                    const { minX: ls, minY: ho, maxX: Dl, maxY: Fl } = vt.aa.fromPoints(bt).extend(le1);
                                    return [
                                        new vt.P(ls, ho),
                                        new vt.P(Dl, ho),
                                        new vt.P(Dl, Fl),
                                        new vt.P(ls, Fl),
                                        new vt.P(ls, ho)
                                    ];
                                }
                            }
                            constrainInternal() {
                                if (!this.center || !this._width || !this._height || this._constraining) return;
                                this._constraining = !0;
                                const le1 = this._unmodified, { center: vt, zoom: bt } = this.applyConstrain(this.center, this.zoom);
                                this.setCenter(vt), this.setZoom(bt), this._unmodified = le1, this._constraining = !1;
                            }
                            _calcMatrices() {
                                if (this._width && this._height) {
                                    this._pixelsToGLUnits = [
                                        2 / this._width,
                                        -2 / this._height
                                    ];
                                    let le1 = vt.ar(new Float64Array(16));
                                    vt.Q(le1, le1, [
                                        this._width / 2,
                                        -this._height / 2,
                                        1
                                    ]), vt.O(le1, le1, [
                                        1,
                                        -1,
                                        0
                                    ]), this._clipSpaceToPixelsMatrix = le1, le1 = vt.ar(new Float64Array(16)), vt.Q(le1, le1, [
                                        1,
                                        -1,
                                        1
                                    ]), vt.O(le1, le1, [
                                        -1,
                                        -1,
                                        0
                                    ]), vt.Q(le1, le1, [
                                        2 / this._width,
                                        2 / this._height,
                                        1
                                    ]), this._pixelsToClipSpaceMatrix = le1, this._cameraToCenterDistance = .5 / Math.tan(this.fovInRadians / 2) * this._height;
                                }
                                this._callbacks.calcMatrices();
                            }
                            calculateCenterFromCameraLngLatAlt(le1, bt, ls, ho) {
                                const Dl = void 0 !== ls ? ls : this.bearing, Fl = ho = void 0 !== ho ? ho : this.pitch, { distanceToCenter: sc, clampedElevation: uc } = this._distanceToCenterFromAltElevationPitch(bt, this.elevation, Fl), { x: mc, y: gc } = be(Fl, Dl), Ac = vt.a9.fromLngLat(le1, bt);
                                let Ec, kc, du = vt.a_(1, Ac.y), _u = 0;
                                do {
                                    if (_u += 1, _u > 10) break;
                                    kc = sc / du, Ec = new vt.a9(Ac.x + mc * kc, Ac.y + gc * kc), du = 1 / Ec.meterInMercatorCoordinateUnits();
                                }while (Math.abs(sc - kc * du) > 1e-12);
                                return {
                                    center: Ec.toLngLat(),
                                    elevation: uc,
                                    zoom: vt.at(this.height / 2 / Math.tan(this.fovInRadians / 2) / kc / this.tileSize)
                                };
                            }
                            recalculateZoomAndCenter(le1) {
                                if (this.elevation - le1 == 0) return;
                                const bt = 1 / this.worldSize, ls = vt.as(1, this.center.lat) * this.worldSize, ho = vt.a9.fromLngLat(this.center, this.elevation), Dl = ho.x / bt, Fl = ho.y / bt, sc = ho.z / bt, uc = this.pitch, mc = this.bearing, { x: gc, y: Ac, z: Ec } = be(uc, mc), kc = this.cameraToCenterDistance, du = Dl + kc * -gc, _u = Fl + kc * -Ac, Md = sc + kc * Ec, { distanceToCenter: Ld, clampedElevation: Nd } = this._distanceToCenterFromAltElevationPitch(Md / ls, le1, uc), Rd = Ld * ls, Od = new vt.a9((du + gc * Rd) * bt, (_u + Ac * Rd) * bt, 0).toLngLat(), jd = vt.as(1, Od.lat), Ud = vt.at(this.height / 2 / Math.tan(this.fovInRadians / 2) / Ld / jd / this.tileSize);
                                this._elevation = Nd, this._center = Od, this.setZoom(Ud);
                            }
                            _distanceToCenterFromAltElevationPitch(le1, bt, ls) {
                                const ho = -Math.cos(vt.ap(ls)), Dl = le1 - bt;
                                let Fl, sc = bt;
                                return ho * Dl >= 0 || Math.abs(ho) < .1 ? (Fl = 1e4, sc = le1 + Fl * ho) : Fl = -Dl / ho, {
                                    distanceToCenter: Fl,
                                    clampedElevation: sc
                                };
                            }
                            getCameraPoint() {
                                const le1 = Math.tan(this.pitchInRadians) * (this.cameraToCenterDistance || 1);
                                return this.centerPoint.add(new vt.P(le1 * Math.sin(this.rollInRadians), le1 * Math.cos(this.rollInRadians)));
                            }
                            getCameraAltitude() {
                                return Math.cos(this.pitchInRadians) * this._cameraToCenterDistance / this._pixelPerMeter + this.elevation;
                            }
                            getCameraLngLat() {
                                const le1 = vt.as(1, this.center.lat) * this.worldSize;
                                return xe(this.center, this.elevation, this.pitch, this.bearing, this.cameraToCenterDistance / le1).toLngLat();
                            }
                            getMercatorTileCoordinates(le1) {
                                if (!le1) return [
                                    0,
                                    0,
                                    1,
                                    1
                                ];
                                const bt = le1.canonical.z >= 0 ? 1 << le1.canonical.z : Math.pow(2, le1.canonical.z);
                                return [
                                    le1.canonical.x / bt,
                                    le1.canonical.y / bt,
                                    1 / bt / vt.a5,
                                    1 / bt / vt.a5
                                ];
                            }
                        }
                        class Vt {
                            constructor(le1, bt){
                                this.min = le1, this.max = bt, this.center = vt.a$([], vt.b0([], this.min, this.max), .5);
                            }
                            quadrant(le1) {
                                const bt = [
                                    le1 % 2 == 0,
                                    le1 < 2
                                ], ls = vt.b1(this.min), ho = vt.b1(this.max);
                                for(let vt = 0; vt < bt.length; vt++)ls[vt] = bt[vt] ? this.min[vt] : this.center[vt], ho[vt] = bt[vt] ? this.center[vt] : this.max[vt];
                                return ho[2] = this.max[2], new Vt(ls, ho);
                            }
                            distanceX(le1) {
                                return Math.max(Math.min(this.max[0], le1[0]), this.min[0]) - le1[0];
                            }
                            distanceY(le1) {
                                return Math.max(Math.min(this.max[1], le1[1]), this.min[1]) - le1[1];
                            }
                            intersectsFrustum(le1) {
                                let vt = !0;
                                for(let bt = 0; bt < le1.planes.length; bt++){
                                    const ls = this.intersectsPlane(le1.planes[bt]);
                                    if (0 === ls) return 0;
                                    1 === ls && (vt = !1);
                                }
                                return vt ? 2 : le1.aabb.min[0] > this.max[0] || le1.aabb.min[1] > this.max[1] || le1.aabb.min[2] > this.max[2] || le1.aabb.max[0] < this.min[0] || le1.aabb.max[1] < this.min[1] || le1.aabb.max[2] < this.min[2] ? 0 : 1;
                            }
                            intersectsPlane(le1) {
                                let vt = le1[3], bt = le1[3];
                                for(let ls = 0; ls < 3; ls++)le1[ls] > 0 ? (vt += le1[ls] * this.min[ls], bt += le1[ls] * this.max[ls]) : (bt += le1[ls] * this.min[ls], vt += le1[ls] * this.max[ls]);
                                return vt >= 0 ? 2 : bt < 0 ? 0 : 1;
                            }
                        }
                        class qt {
                            distanceToTile2d(le1, vt, bt, ls) {
                                const ho = ls.distanceX([
                                    le1,
                                    vt
                                ]), Dl = ls.distanceY([
                                    le1,
                                    vt
                                ]);
                                return Math.hypot(ho, Dl);
                            }
                            getWrap(le1, vt, bt) {
                                return bt;
                            }
                            getTileBoundingVolume(le1, bt, ls, ho) {
                                var Dl, Fl;
                                let sc = 0, uc = 0;
                                if (null == ho ? void 0 : ho.terrain) {
                                    const mc = new vt.a2(le1.z, bt, le1.z, le1.x, le1.y), gc = ho.terrain.getMinMaxElevation(mc);
                                    sc = null !== (Dl = gc.minElevation) && void 0 !== Dl ? Dl : Math.min(0, ls), uc = null !== (Fl = gc.maxElevation) && void 0 !== Fl ? Fl : Math.max(0, ls);
                                }
                                const mc = 1 << le1.z;
                                return new Vt([
                                    bt + le1.x / mc,
                                    le1.y / mc,
                                    sc
                                ], [
                                    bt + (le1.x + 1) / mc,
                                    (le1.y + 1) / mc,
                                    uc
                                ]);
                            }
                            allowVariableZoom(le1, bt) {
                                const ls = le1.fov * (Math.abs(Math.cos(le1.rollInRadians)) * le1.height + Math.abs(Math.sin(le1.rollInRadians)) * le1.width) / le1.height, ho = vt.an(78.5 - ls / 2, 0, 60);
                                return !!bt.terrain || le1.pitch > ho;
                            }
                            allowWorldCopies() {
                                return !0;
                            }
                            prepareNextFrame() {}
                        }
                        class Wt {
                            constructor(le1, vt, bt){
                                this.points = le1, this.planes = vt, this.aabb = bt;
                            }
                            static fromInvProjectionMatrix(le1, bt = 1, ls = 0, ho, Dl) {
                                const Fl = Dl ? [
                                    [
                                        6,
                                        5,
                                        4
                                    ],
                                    [
                                        0,
                                        1,
                                        2
                                    ],
                                    [
                                        0,
                                        3,
                                        7
                                    ],
                                    [
                                        2,
                                        1,
                                        5
                                    ],
                                    [
                                        3,
                                        2,
                                        6
                                    ],
                                    [
                                        0,
                                        4,
                                        5
                                    ]
                                ] : [
                                    [
                                        0,
                                        1,
                                        2
                                    ],
                                    [
                                        6,
                                        5,
                                        4
                                    ],
                                    [
                                        0,
                                        3,
                                        7
                                    ],
                                    [
                                        2,
                                        1,
                                        5
                                    ],
                                    [
                                        3,
                                        2,
                                        6
                                    ],
                                    [
                                        0,
                                        4,
                                        5
                                    ]
                                ], sc = Math.pow(2, ls), uc = [
                                    [
                                        -1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        -1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        -1,
                                        1
                                    ],
                                    [
                                        -1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        1,
                                        1,
                                        1
                                    ],
                                    [
                                        1,
                                        -1,
                                        1,
                                        1
                                    ],
                                    [
                                        -1,
                                        -1,
                                        1,
                                        1
                                    ]
                                ].map((ls)=>(function(le1, bt, ls, ho) {
                                        const Dl = vt.aH([], le1, bt), Fl = 1 / Dl[3] / ls * ho;
                                        return vt.b6(Dl, Dl, [
                                            Fl,
                                            Fl,
                                            1 / Dl[3],
                                            Fl
                                        ]);
                                    })(ls, le1, bt, sc));
                                ho && function(le1, bt, ls, ho) {
                                    const Dl = ho ? 4 : 0, Fl = ho ? 0 : 4;
                                    let sc = 0;
                                    const uc = [], mc = [];
                                    for(let Ec = 0; Ec < 4; Ec++){
                                        const bt = vt.b2([], le1[Ec + Fl], le1[Ec + Dl]), ls = vt.b7(bt);
                                        vt.a$(bt, bt, 1 / ls), uc.push(ls), mc.push(bt);
                                    }
                                    for(let Ec = 0; Ec < 4; Ec++){
                                        const bt = vt.b8(le1[Ec + Dl], mc[Ec], ls);
                                        sc = null !== bt && bt >= 0 ? Math.max(sc, bt) : Math.max(sc, uc[Ec]);
                                    }
                                    const gc = function(le1, bt) {
                                        const ls = vt.b2([], le1[bt[0]], le1[bt[1]]), ho = vt.b2([], le1[bt[2]], le1[bt[1]]), Dl = [
                                            0,
                                            0,
                                            0,
                                            0
                                        ];
                                        return vt.b3(Dl, vt.b4([], ls, ho)), Dl[3] = -vt.b5(Dl, le1[bt[0]]), Dl;
                                    }(le1, bt), Ac = function(le1, bt) {
                                        const ls = vt.b9(le1), ho = vt.ba([], le1, 1 / ls), Dl = vt.b2([], bt, vt.a$([], ho, vt.b5(bt, ho))), Fl = vt.b9(Dl);
                                        if (Fl > 0) {
                                            const le1 = Math.sqrt(1 - ho[3] * ho[3]), ls = vt.a$([], ho, -ho[3]), sc = vt.b0([], ls, vt.a$([], Dl, le1 / Fl));
                                            return vt.bb(bt, sc);
                                        }
                                        return null;
                                    }(ls, gc);
                                    if (null !== Ac) {
                                        const le1 = Ac / vt.b5(mc[0], gc);
                                        sc = Math.min(sc, le1);
                                    }
                                    for(let vt = 0; vt < 4; vt++){
                                        const bt = Math.min(sc, uc[vt]);
                                        le1[vt + Fl] = [
                                            le1[vt + Dl][0] + mc[vt][0] * bt,
                                            le1[vt + Dl][1] + mc[vt][1] * bt,
                                            le1[vt + Dl][2] + mc[vt][2] * bt,
                                            1
                                        ];
                                    }
                                }(uc, Fl[0], ho, Dl);
                                const mc = Fl.map((le1)=>{
                                    const bt = vt.b2([], uc[le1[0]], uc[le1[1]]), ls = vt.b2([], uc[le1[2]], uc[le1[1]]), ho = vt.b3([], vt.b4([], bt, ls)), Dl = -vt.b5(ho, uc[le1[1]]);
                                    return ho.concat(Dl);
                                }), gc = [
                                    Number.POSITIVE_INFINITY,
                                    Number.POSITIVE_INFINITY,
                                    Number.POSITIVE_INFINITY
                                ], Ac = [
                                    Number.NEGATIVE_INFINITY,
                                    Number.NEGATIVE_INFINITY,
                                    Number.NEGATIVE_INFINITY
                                ];
                                for (const vt of uc)for(let le1 = 0; le1 < 3; le1++)gc[le1] = Math.min(gc[le1], vt[le1]), Ac[le1] = Math.max(Ac[le1], vt[le1]);
                                return new Wt(uc, mc, new Vt(gc, Ac));
                            }
                        }
                        class $t {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(le1) {
                                this._helper.setMinZoom(le1);
                            }
                            setMaxZoom(le1) {
                                this._helper.setMaxZoom(le1);
                            }
                            setMinPitch(le1) {
                                this._helper.setMinPitch(le1);
                            }
                            setMaxPitch(le1) {
                                this._helper.setMaxPitch(le1);
                            }
                            setRenderWorldCopies(le1) {
                                this._helper.setRenderWorldCopies(le1);
                            }
                            setBearing(le1) {
                                this._helper.setBearing(le1);
                            }
                            setPitch(le1) {
                                this._helper.setPitch(le1);
                            }
                            setRoll(le1) {
                                this._helper.setRoll(le1);
                            }
                            setFov(le1) {
                                this._helper.setFov(le1);
                            }
                            setZoom(le1) {
                                this._helper.setZoom(le1);
                            }
                            setCenter(le1) {
                                this._helper.setCenter(le1);
                            }
                            setElevation(le1) {
                                this._helper.setElevation(le1);
                            }
                            setMinElevationForCurrentTile(le1) {
                                this._helper.setMinElevationForCurrentTile(le1);
                            }
                            setPadding(le1) {
                                this._helper.setPadding(le1);
                            }
                            interpolatePadding(le1, vt, bt) {
                                return this._helper.interpolatePadding(le1, vt, bt);
                            }
                            isPaddingEqual(le1) {
                                return this._helper.isPaddingEqual(le1);
                            }
                            resize(le1, vt, bt = !0) {
                                this._helper.resize(le1, vt, bt);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(le1) {
                                this._helper.setMaxBounds(le1);
                            }
                            setConstrainOverride(le1) {
                                this._helper.setConstrainOverride(le1);
                            }
                            overrideNearFarZ(le1, vt) {
                                this._helper.overrideNearFarZ(le1, vt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(le1) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), le1);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            get constrainOverride() {
                                return this._helper.constrainOverride;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            setTransitionState(le1, vt) {}
                            constructor(le1){
                                this._posMatrixCache = new Map, this._alignedPosMatrixCache = new Map, this._fogMatrixCacheF32 = new Map, this.defaultConstrain = (le1, bt)=>{
                                    bt = vt.an(+bt, this.minZoom, this.maxZoom);
                                    const ls = {
                                        center: new vt.V(le1.lng, le1.lat),
                                        zoom: bt
                                    };
                                    let ho = this._helper._lngRange;
                                    if (!this._helper._renderWorldCopies && null === ho) {
                                        const le1 = 180 - 1e-10;
                                        ho = [
                                            -le1,
                                            le1
                                        ];
                                    }
                                    const Dl = this.tileSize * vt.aq(ls.zoom);
                                    let Fl = 0, sc = Dl, uc = 0, mc = Dl, gc = 0, Ac = 0;
                                    const { x: Ec, y: kc } = this.size;
                                    if (this._helper._latRange) {
                                        const le1 = this._helper._latRange;
                                        Fl = vt.X(le1[1]) * Dl, sc = vt.X(le1[0]) * Dl, sc - Fl < kc && (gc = kc / (sc - Fl));
                                    }
                                    ho && (uc = vt.W(vt.Y(ho[0]) * Dl, 0, Dl), mc = vt.W(vt.Y(ho[1]) * Dl, 0, Dl), mc < uc && (mc += Dl), mc - uc < Ec && (Ac = Ec / (mc - uc)));
                                    const { x: du, y: _u } = me(Dl, le1);
                                    let Md, Ld;
                                    const Nd = Math.max(Ac || 0, gc || 0);
                                    if (Nd) {
                                        const le1 = new vt.P(Ac ? (mc + uc) / 2 : du, gc ? (sc + Fl) / 2 : _u);
                                        return ls.center = fe(Dl, le1).wrap(), ls.zoom += vt.at(Nd), ls;
                                    }
                                    if (this._helper._latRange) {
                                        const le1 = kc / 2;
                                        _u - le1 < Fl && (Ld = Fl + le1), _u + le1 > sc && (Ld = sc - le1);
                                    }
                                    if (ho) {
                                        const le1 = (uc + mc) / 2;
                                        let bt = du;
                                        this._helper._renderWorldCopies && (bt = vt.W(du, le1 - Dl / 2, le1 + Dl / 2));
                                        const ls = Ec / 2;
                                        bt - ls < uc && (Md = uc + ls), bt + ls > mc && (Md = mc - ls);
                                    }
                                    if (void 0 !== Md || void 0 !== Ld) {
                                        const le1 = new vt.P(null != Md ? Md : du, null != Ld ? Ld : _u);
                                        ls.center = fe(Dl, le1).wrap();
                                    }
                                    return ls;
                                }, this.applyConstrain = (le1, vt)=>this._helper.applyConstrain(le1, vt), this._helper = new Gt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    defaultConstrain: (le1, vt)=>this.defaultConstrain(le1, vt)
                                }, le1), this._coveringTilesDetailsProvider = new qt;
                            }
                            clone() {
                                const le1 = new $t;
                                return le1.apply(this, !1), le1;
                            }
                            apply(le1, vt, bt) {
                                this._helper.apply(le1, vt, bt);
                            }
                            get cameraPosition() {
                                return this._cameraPosition;
                            }
                            get projectionMatrix() {
                                return this._projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this._viewProjMatrix;
                            }
                            get inverseProjectionMatrix() {
                                return this._invProjMatrix;
                            }
                            get mercatorMatrix() {
                                return this._mercatorMatrix;
                            }
                            getVisibleUnwrappedCoordinates(le1) {
                                const bt = [
                                    new vt.bc(0, le1)
                                ];
                                if (this._helper._renderWorldCopies) {
                                    const ls = this.screenPointToMercatorCoordinate(new vt.P(0, 0)), ho = this.screenPointToMercatorCoordinate(new vt.P(this._helper._width, 0)), Dl = this.screenPointToMercatorCoordinate(new vt.P(this._helper._width, this._helper._height)), Fl = this.screenPointToMercatorCoordinate(new vt.P(0, this._helper._height)), sc = Math.floor(Math.min(ls.x, ho.x, Dl.x, Fl.x)), uc = Math.floor(Math.max(ls.x, ho.x, Dl.x, Fl.x)), mc = 1;
                                    for(let gc = sc - mc; gc <= uc + mc; gc++)0 !== gc && bt.push(new vt.bc(gc, le1));
                                }
                                return bt;
                            }
                            getCameraFrustum() {
                                return Wt.fromInvProjectionMatrix(this._invViewProjMatrix, this.worldSize);
                            }
                            getClippingPlane() {
                                return null;
                            }
                            getCoveringTilesDetailsProvider() {
                                return this._coveringTilesDetailsProvider;
                            }
                            recalculateZoomAndCenter(le1) {
                                const vt = this.screenPointToLocation(this.centerPoint, le1), bt = le1 ? le1.getElevationForLngLatZoom(vt, this._helper._tileZoom) : 0;
                                this._helper.recalculateZoomAndCenter(bt);
                            }
                            setLocationAtPoint(le1, bt) {
                                const ls = vt.as(this.elevation, this.center.lat), ho = this.screenPointToMercatorCoordinateAtZ(bt, ls), Dl = this.screenPointToMercatorCoordinateAtZ(this.centerPoint, ls), Fl = vt.a9.fromLngLat(le1), sc = new vt.a9(Fl.x - (ho.x - Dl.x), Fl.y - (ho.y - Dl.y));
                                this.setCenter(null == sc ? void 0 : sc.toLngLat()), this._helper._renderWorldCopies && this.setCenter(this.center.wrap());
                            }
                            locationToScreenPoint(le1, bt) {
                                return bt ? this.coordinatePoint(vt.a9.fromLngLat(le1), bt.getElevationForLngLat(le1, this), this._pixelMatrix3D) : this.coordinatePoint(vt.a9.fromLngLat(le1));
                            }
                            screenPointToLocation(le1, vt) {
                                var bt;
                                return null === (bt = this.screenPointToMercatorCoordinate(le1, vt)) || void 0 === bt ? void 0 : bt.toLngLat();
                            }
                            screenPointToMercatorCoordinate(le1, vt) {
                                if (vt) {
                                    const bt = vt.pointCoordinate(le1);
                                    if (null != bt) return bt;
                                }
                                return this.screenPointToMercatorCoordinateAtZ(le1);
                            }
                            screenPointToMercatorCoordinateAtZ(le1, bt) {
                                const ls = bt || 0, ho = [
                                    le1.x,
                                    le1.y,
                                    0,
                                    1
                                ], Dl = [
                                    le1.x,
                                    le1.y,
                                    1,
                                    1
                                ];
                                vt.aH(ho, ho, this._pixelMatrixInverse), vt.aH(Dl, Dl, this._pixelMatrixInverse);
                                const Fl = ho[3], sc = Dl[3], uc = ho[1] / Fl, mc = Dl[1] / sc, gc = ho[2] / Fl, Ac = Dl[2] / sc, Ec = gc === Ac ? 0 : (ls - gc) / (Ac - gc);
                                return new vt.a9(vt.G.number(ho[0] / Fl, Dl[0] / sc, Ec) / this.worldSize, vt.G.number(uc, mc, Ec) / this.worldSize, ls);
                            }
                            coordinatePoint(le1, bt = 0, ls = this._pixelMatrix) {
                                const ho = [
                                    le1.x * this.worldSize,
                                    le1.y * this.worldSize,
                                    bt,
                                    1
                                ];
                                return vt.aH(ho, ho, ls), new vt.P(ho[0] / ho[3], ho[1] / ho[3]);
                            }
                            getBounds() {
                                const le1 = Math.max(0, this._helper._height / 2 - ge(this));
                                return (new $).extend(this.screenPointToLocation(new vt.P(0, le1))).extend(this.screenPointToLocation(new vt.P(this._helper._width, le1))).extend(this.screenPointToLocation(new vt.P(this._helper._width, this._helper._height))).extend(this.screenPointToLocation(new vt.P(0, this._helper._height)));
                            }
                            isPointOnMapSurface(le1, vt) {
                                return vt ? null != vt.pointCoordinate(le1) : le1.y > this.height / 2 - ge(this);
                            }
                            calculatePosMatrix(le1, bt = !1, ls) {
                                var ho;
                                const Dl = null !== (ho = le1.key) && void 0 !== ho ? ho : vt.bd(le1.wrap, le1.canonical.z, le1.canonical.z, le1.canonical.x, le1.canonical.y), Fl = bt ? this._alignedPosMatrixCache : this._posMatrixCache;
                                if (Fl.has(Dl)) {
                                    const le1 = Fl.get(Dl);
                                    return ls ? le1.f32 : le1.f64;
                                }
                                const sc = ve(le1, this.worldSize);
                                vt.S(sc, bt ? this._alignedProjMatrix : this._viewProjMatrix, sc);
                                const uc = {
                                    f64: sc,
                                    f32: new Float32Array(sc)
                                };
                                return Fl.set(Dl, uc), ls ? uc.f32 : uc.f64;
                            }
                            calculateFogMatrix(le1) {
                                const bt = le1.key, ls = this._fogMatrixCacheF32;
                                if (ls.has(bt)) return ls.get(bt);
                                const ho = ve(le1, this.worldSize);
                                return vt.S(ho, this._fogMatrix, ho), ls.set(bt, new Float32Array(ho)), ls.get(bt);
                            }
                            calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls);
                            }
                            _calculateNearFarZIfNeeded(le1, bt, ls) {
                                if (!this._helper.autoCalculateNearFarZ) return;
                                const ho = Math.min(this.elevation, this.minElevationForCurrentTile, this.getCameraAltitude() - 100), Dl = le1 - ho * this._helper._pixelPerMeter / Math.cos(bt), Fl = ho < 0 ? Dl : le1, sc = Math.PI / 2 + this.pitchInRadians, uc = vt.ap(this.fov) * (Math.abs(Math.cos(vt.ap(this.roll))) * this.height + Math.abs(Math.sin(vt.ap(this.roll))) * this.width) / this.height * (.5 + ls.y / this.height), mc = Math.sin(uc) * Fl / Math.sin(vt.an(Math.PI - sc - uc, .01, Math.PI - .01)), gc = ge(this), Ac = Math.atan(gc / this._helper.cameraToCenterDistance), Ec = vt.ap(.75), kc = Ac > Ec ? 2 * Ac * (.5 + ls.y / (2 * gc)) : Ec, du = Math.sin(kc) * Fl / Math.sin(vt.an(Math.PI - sc - kc, .01, Math.PI - .01)), _u = Math.min(mc, du);
                                this._helper._farZ = 1.01 * (Math.cos(Math.PI / 2 - bt) * _u + Fl), this._helper._nearZ = this._helper._height / 50;
                            }
                            _calcMatrices() {
                                if (!this._helper._height) return;
                                const le1 = this.centerOffset, bt = me(this.worldSize, this.center), ls = bt.x, ho = bt.y;
                                this._helper._pixelPerMeter = vt.as(1, this.center.lat) * this.worldSize;
                                const Dl = vt.ap(Math.min(this.pitch, Zd)), Fl = Math.max(this._helper.cameraToCenterDistance / 2, this._helper.cameraToCenterDistance + this._helper._elevation * this._helper._pixelPerMeter / Math.cos(Dl));
                                let sc;
                                this._calculateNearFarZIfNeeded(Fl, Dl, le1), sc = new Float64Array(16), vt.be(sc, this.fovInRadians, this._helper._width / this._helper._height, this._helper._nearZ, this._helper._farZ), this._invProjMatrix = new Float64Array(16), vt.aB(this._invProjMatrix, sc), sc[8] = 2 * -le1.x / this._helper._width, sc[9] = 2 * le1.y / this._helper._height, this._projectionMatrix = vt.bf(sc), vt.Q(sc, sc, [
                                    1,
                                    -1,
                                    1
                                ]), vt.O(sc, sc, [
                                    0,
                                    0,
                                    -this._helper.cameraToCenterDistance
                                ]), vt.bg(sc, sc, -this.rollInRadians), vt.bh(sc, sc, this.pitchInRadians), vt.bg(sc, sc, -this.bearingInRadians), vt.O(sc, sc, [
                                    -ls,
                                    -ho,
                                    0
                                ]), this._mercatorMatrix = vt.Q([], sc, [
                                    this.worldSize,
                                    this.worldSize,
                                    this.worldSize
                                ]), vt.Q(sc, sc, [
                                    1,
                                    1,
                                    this._helper._pixelPerMeter
                                ]), this._pixelMatrix = vt.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, sc), vt.O(sc, sc, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this._viewProjMatrix = sc, this._invViewProjMatrix = vt.aB([], sc);
                                const uc = [
                                    0,
                                    0,
                                    -1,
                                    1
                                ];
                                vt.aH(uc, uc, this._invViewProjMatrix), this._cameraPosition = [
                                    uc[0] / uc[3],
                                    uc[1] / uc[3],
                                    uc[2] / uc[3]
                                ], this._fogMatrix = new Float64Array(16), vt.be(this._fogMatrix, this.fovInRadians, this.width / this.height, Fl, this._helper._farZ), this._fogMatrix[8] = 2 * -le1.x / this.width, this._fogMatrix[9] = 2 * le1.y / this.height, vt.Q(this._fogMatrix, this._fogMatrix, [
                                    1,
                                    -1,
                                    1
                                ]), vt.O(this._fogMatrix, this._fogMatrix, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), vt.bg(this._fogMatrix, this._fogMatrix, -this.rollInRadians), vt.bh(this._fogMatrix, this._fogMatrix, this.pitchInRadians), vt.bg(this._fogMatrix, this._fogMatrix, -this.bearingInRadians), vt.O(this._fogMatrix, this._fogMatrix, [
                                    -ls,
                                    -ho,
                                    0
                                ]), vt.Q(this._fogMatrix, this._fogMatrix, [
                                    1,
                                    1,
                                    this._helper._pixelPerMeter
                                ]), vt.O(this._fogMatrix, this._fogMatrix, [
                                    0,
                                    0,
                                    -this.elevation
                                ]), this._pixelMatrix3D = vt.S(new Float64Array(16), this.clipSpaceToPixelsMatrix, sc);
                                const mc = this._helper._width % 2 / 2, gc = this._helper._height % 2 / 2, Ac = Math.cos(this.bearingInRadians), Ec = Math.sin(-this.bearingInRadians), kc = ls - Math.round(ls) + Ac * mc + Ec * gc, du = ho - Math.round(ho) + Ac * gc + Ec * mc, _u = new Float64Array(sc);
                                if (vt.O(_u, _u, [
                                    kc > .5 ? kc - 1 : kc,
                                    du > .5 ? du - 1 : du,
                                    0
                                ]), this._alignedProjMatrix = _u, sc = vt.aB(new Float64Array(16), this._pixelMatrix), !sc) throw new Error("failed to invert matrix");
                                this._pixelMatrixInverse = sc, this._clearMatrixCaches();
                            }
                            _clearMatrixCaches() {
                                this._posMatrixCache.clear(), this._alignedPosMatrixCache.clear(), this._fogMatrixCacheF32.clear();
                            }
                            maxPitchScaleFactor() {
                                if (!this._pixelMatrixInverse) return 1;
                                const le1 = this.screenPointToMercatorCoordinate(new vt.P(0, 0)), bt = [
                                    le1.x * this.worldSize,
                                    le1.y * this.worldSize,
                                    0,
                                    1
                                ];
                                return vt.aH(bt, bt, this._pixelMatrix)[3] / this._helper.cameraToCenterDistance;
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                const le1 = vt.as(1, this.center.lat) * this.worldSize;
                                return xe(this.center, this.elevation, this.pitch, this.bearing, this._helper.cameraToCenterDistance / le1).toLngLat();
                            }
                            lngLatToCameraDepth(le1, bt) {
                                const ls = vt.a9.fromLngLat(le1), ho = [
                                    ls.x * this.worldSize,
                                    ls.y * this.worldSize,
                                    bt,
                                    1
                                ];
                                return vt.aH(ho, ho, this._viewProjMatrix), ho[2] / ho[3];
                            }
                            getProjectionData(le1) {
                                const { overscaledTileID: bt, aligned: ls, applyTerrainMatrix: ho } = le1, Dl = this._helper.getMercatorTileCoordinates(bt), Fl = bt ? this.calculatePosMatrix(bt, ls, !0) : null;
                                let sc;
                                return sc = bt && bt.terrainRttPosMatrix32f && ho ? bt.terrainRttPosMatrix32f : Fl || vt.bi(), {
                                    mainMatrix: sc,
                                    tileMercatorCoords: Dl,
                                    clippingPlane: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    projectionTransition: 0,
                                    fallbackMatrix: sc
                                };
                            }
                            isLocationOccluded(le1) {
                                return !1;
                            }
                            getPixelScale() {
                                return 1;
                            }
                            getCircleRadiusCorrection() {
                                return 1;
                            }
                            getPitchedTextCorrection(le1, vt, bt) {
                                return 1;
                            }
                            transformLightDirection(le1) {
                                return vt.b1(le1);
                            }
                            getRayDirectionFromPixel(le1) {
                                throw new Error("Not implemented.");
                            }
                            projectTileCoordinates(le1, bt, ls, ho) {
                                const Dl = this.calculatePosMatrix(ls);
                                let Fl;
                                ho ? (Fl = [
                                    le1,
                                    bt,
                                    ho(le1, bt),
                                    1
                                ], vt.aH(Fl, Fl, Dl)) : (Fl = [
                                    le1,
                                    bt,
                                    0,
                                    1
                                ], rt(Fl, Fl, Dl));
                                const sc = Fl[3];
                                return {
                                    point: new vt.P(Fl[0] / sc, Fl[1] / sc),
                                    signedDistanceFromCamera: sc,
                                    isOccluded: !1
                                };
                            }
                            populateCache(le1) {
                                for (const vt of le1)this.calculatePosMatrix(vt);
                            }
                            getMatrixForModel(le1, bt) {
                                const ls = vt.a9.fromLngLat(le1, bt), ho = ls.meterInMercatorCoordinateUnits(), Dl = vt.bj();
                                return vt.O(Dl, Dl, [
                                    ls.x,
                                    ls.y,
                                    ls.z
                                ]), vt.bg(Dl, Dl, Math.PI), vt.bh(Dl, Dl, Math.PI / 2), vt.Q(Dl, Dl, [
                                    -ho,
                                    ho,
                                    ho
                                ]), Dl;
                            }
                            getProjectionDataForCustomLayer(le1 = !0) {
                                const bt = new vt.a2(0, 0, 0, 0, 0), ls = this.getProjectionData({
                                    overscaledTileID: bt,
                                    applyGlobeMatrix: le1
                                }), ho = ve(bt, this.worldSize);
                                vt.S(ho, this._viewProjMatrix, ho), ls.tileMercatorCoords = [
                                    0,
                                    0,
                                    1,
                                    1
                                ];
                                const Dl = [
                                    vt.a5,
                                    vt.a5,
                                    this.worldSize / this._helper.pixelsPerMeter
                                ], Fl = vt.bk();
                                return vt.Q(Fl, ho, Dl), ls.fallbackMatrix = Fl, ls.mainMatrix = Fl, ls;
                            }
                            getFastPathSimpleProjectionMatrix(le1) {
                                return this.calculatePosMatrix(le1);
                            }
                        }
                        function Ht() {
                            vt.w("Map cannot fit within canvas with the given bounds, padding, and/or offset.");
                        }
                        function Xt(le1) {
                            if (le1.useSlerp) {
                                if (le1.k < 1) {
                                    const bt = vt.bl(le1.startEulerAngles.roll, le1.startEulerAngles.pitch, le1.startEulerAngles.bearing), ls = vt.bl(le1.endEulerAngles.roll, le1.endEulerAngles.pitch, le1.endEulerAngles.bearing), ho = new Float64Array(4);
                                    vt.bm(ho, bt, ls, le1.k);
                                    const Dl = vt.bn(ho);
                                    le1.tr.setRoll(Dl.roll), le1.tr.setPitch(Dl.pitch), le1.tr.setBearing(Dl.bearing);
                                } else le1.tr.setRoll(le1.endEulerAngles.roll), le1.tr.setPitch(le1.endEulerAngles.pitch), le1.tr.setBearing(le1.endEulerAngles.bearing);
                            } else le1.tr.setRoll(vt.G.number(le1.startEulerAngles.roll, le1.endEulerAngles.roll, le1.k)), le1.tr.setPitch(vt.G.number(le1.startEulerAngles.pitch, le1.endEulerAngles.pitch, le1.k)), le1.tr.setBearing(vt.G.number(le1.startEulerAngles.bearing, le1.endEulerAngles.bearing, le1.k));
                        }
                        function Kt(le1, bt, ls, ho, Dl) {
                            const Fl = Dl.padding, sc = me(Dl.worldSize, ls.getNorthWest()), uc = me(Dl.worldSize, ls.getNorthEast()), mc = me(Dl.worldSize, ls.getSouthEast()), gc = me(Dl.worldSize, ls.getSouthWest()), Ac = vt.ap(-ho), Ec = sc.rotate(Ac), kc = uc.rotate(Ac), du = mc.rotate(Ac), _u = gc.rotate(Ac), Md = new vt.P(Math.max(Ec.x, kc.x, _u.x, du.x), Math.max(Ec.y, kc.y, _u.y, du.y)), Ld = new vt.P(Math.min(Ec.x, kc.x, _u.x, du.x), Math.min(Ec.y, kc.y, _u.y, du.y)), Nd = Md.sub(Ld), Rd = (Dl.width - (Fl.left + Fl.right + bt.left + bt.right)) / Nd.x, Od = (Dl.height - (Fl.top + Fl.bottom + bt.top + bt.bottom)) / Nd.y;
                            if (Od < 0 || Rd < 0) return void Ht();
                            const jd = Math.min(vt.at(Dl.scale * Math.min(Rd, Od)), le1.maxZoom), Ud = vt.P.convert(le1.offset), Gd = new vt.P((bt.left - bt.right) / 2, (bt.top - bt.bottom) / 2).rotate(vt.ap(ho)), qd = Ud.add(Gd).mult(Dl.scale / vt.aq(jd));
                            return {
                                center: fe(Dl.worldSize, sc.add(mc).div(2).sub(qd)),
                                zoom: jd,
                                bearing: ho
                            };
                        }
                        class Yt {
                            get useGlobeControls() {
                                return !1;
                            }
                            handlePanInertia(le1, vt) {
                                const bt = le1.mag(), ls = Math.abs(ge(vt));
                                return {
                                    easingOffset: le1.mult(Math.min(.75 * ls / bt, 1)),
                                    easingCenter: vt.center
                                };
                            }
                            handleMapControlsRollPitchBearingZoom(le1, vt) {
                                le1.bearingDelta && vt.setBearing(vt.bearing + le1.bearingDelta), le1.pitchDelta && vt.setPitch(vt.pitch + le1.pitchDelta), le1.rollDelta && vt.setRoll(vt.roll + le1.rollDelta), le1.zoomDelta && vt.setZoom(vt.zoom + le1.zoomDelta);
                            }
                            handleMapControlsPan(le1, vt, bt) {
                                le1.around.distSqr(vt.centerPoint) < .01 || vt.setLocationAtPoint(bt, le1.around);
                            }
                            cameraForBoxAndBearing(le1, vt, bt, ls, ho) {
                                return Kt(le1, vt, bt, ls, ho);
                            }
                            handleJumpToCenterZoom(le1, bt) {
                                le1.zoom !== (void 0 !== bt.zoom ? +bt.zoom : le1.zoom) && le1.setZoom(+bt.zoom), void 0 !== bt.center && le1.setCenter(vt.V.convert(bt.center));
                            }
                            handleEaseTo(le1, bt) {
                                const ls = le1.zoom, ho = le1.padding, Dl = {
                                    roll: le1.roll,
                                    pitch: le1.pitch,
                                    bearing: le1.bearing
                                }, Fl = {
                                    roll: void 0 === bt.roll ? le1.roll : bt.roll,
                                    pitch: void 0 === bt.pitch ? le1.pitch : bt.pitch,
                                    bearing: void 0 === bt.bearing ? le1.bearing : bt.bearing
                                }, sc = void 0 !== bt.zoom, uc = !le1.isPaddingEqual(bt.padding);
                                let mc = !1;
                                const gc = sc ? +bt.zoom : le1.zoom;
                                let Ac = le1.centerPoint.add(bt.offsetAsPoint);
                                const Ec = le1.screenPointToLocation(Ac), { center: kc, zoom: du } = le1.applyConstrain(vt.V.convert(bt.center || Ec), null != gc ? gc : ls);
                                Zt(le1, kc);
                                const _u = me(le1.worldSize, Ec), Md = me(le1.worldSize, kc).sub(_u), Ld = vt.aq(du - ls);
                                return mc = du !== ls, {
                                    easeFunc: (sc)=>{
                                        if (mc && le1.setZoom(vt.G.number(ls, du, sc)), vt.bo(Dl, Fl) || Xt({
                                            startEulerAngles: Dl,
                                            endEulerAngles: Fl,
                                            tr: le1,
                                            k: sc,
                                            useSlerp: Dl.roll != Fl.roll
                                        }), uc && (le1.interpolatePadding(ho, bt.padding, sc), Ac = le1.centerPoint.add(bt.offsetAsPoint)), bt.around) le1.setLocationAtPoint(bt.around, bt.aroundPoint);
                                        else {
                                            const bt = vt.aq(le1.zoom - ls), ho = du > ls ? Math.min(2, Ld) : Math.max(.5, Ld), Dl = Math.pow(ho, 1 - sc), Fl = fe(le1.worldSize, _u.add(Md.mult(sc * Dl)).mult(bt));
                                            le1.setLocationAtPoint(le1.renderWorldCopies ? Fl.wrap() : Fl, Ac);
                                        }
                                    },
                                    isZooming: mc,
                                    elevationCenter: kc
                                };
                            }
                            handleFlyTo(le1, bt) {
                                const ls = void 0 !== bt.zoom, ho = le1.zoom, Dl = le1.applyConstrain(vt.V.convert(bt.center || bt.locationAtOffset), ls ? +bt.zoom : ho), Fl = Dl.center, sc = Dl.zoom;
                                Zt(le1, Fl);
                                const uc = me(le1.worldSize, bt.locationAtOffset), mc = me(le1.worldSize, Fl).sub(uc), gc = mc.mag(), Ac = vt.aq(sc - ho);
                                let Ec;
                                if (void 0 !== bt.minZoom) {
                                    const ls = Math.min(+bt.minZoom, ho, sc), Dl = le1.applyConstrain(Fl, ls).zoom;
                                    Ec = vt.aq(Dl - ho);
                                }
                                return {
                                    easeFunc: (bt, ls, Dl, gc)=>{
                                        le1.setZoom(1 === bt ? sc : ho + vt.at(ls));
                                        const Ac = 1 === bt ? Fl : fe(le1.worldSize, uc.add(mc.mult(Dl)).mult(ls));
                                        le1.setLocationAtPoint(le1.renderWorldCopies ? Ac.wrap() : Ac, gc);
                                    },
                                    scaleOfZoom: Ac,
                                    targetCenter: Fl,
                                    scaleOfMinZoom: Ec,
                                    pixelPathLength: gc
                                };
                            }
                        }
                        class Qt {
                            constructor(le1, vt, bt){
                                this.blendFunction = le1, this.blendColor = vt, this.mask = bt;
                            }
                        }
                        Qt.Replace = [
                            1,
                            0
                        ], Qt.disabled = new Qt(Qt.Replace, vt.bp.transparent, [
                            !1,
                            !1,
                            !1,
                            !1
                        ]), Qt.unblended = new Qt(Qt.Replace, vt.bp.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]), Qt.alphaBlended = new Qt([
                            1,
                            771
                        ], vt.bp.transparent, [
                            !0,
                            !0,
                            !0,
                            !0
                        ]);
                        const hm = 2305;
                        class ei {
                            constructor(le1, vt, bt){
                                this.enable = le1, this.mode = vt, this.frontFace = bt;
                            }
                        }
                        ei.disabled = new ei(!1, 1029, hm), ei.backCCW = new ei(!0, 1029, hm), ei.frontCCW = new ei(!0, 1028, hm);
                        class ti {
                            constructor(le1, vt, bt){
                                this.func = le1, this.mask = vt, this.range = bt;
                            }
                        }
                        ti.ReadOnly = !1, ti.ReadWrite = !0, ti.disabled = new ti(519, ti.ReadOnly, [
                            0,
                            1
                        ]);
                        const dm = 7680;
                        class ai {
                            constructor(le1, vt, bt, ls, ho, Dl){
                                this.test = le1, this.ref = vt, this.mask = bt, this.fail = ls, this.depthFail = ho, this.pass = Dl;
                            }
                        }
                        ai.disabled = new ai({
                            func: 519,
                            mask: 0
                        }, 0, 0, dm, dm, dm);
                        const pm = new WeakMap;
                        function ri(le1) {
                            var vt;
                            if (pm.has(le1)) return pm.get(le1);
                            {
                                const bt = null === (vt = le1.getParameter(le1.VERSION)) || void 0 === vt ? void 0 : vt.startsWith("WebGL 2.0");
                                return pm.set(le1, bt), bt;
                            }
                        }
                        class si {
                            get awaitingQuery() {
                                return !!this._readbackQueue;
                            }
                            constructor(le1){
                                this._readbackWaitFrames = 4, this._measureWaitFrames = 6, this._texWidth = 1, this._texHeight = 1, this._measuredError = 0, this._updateCount = 0, this._lastReadbackFrame = -1000, this._readbackQueue = null, this._cachedRenderContext = le1;
                                const bt = le1.context, ls = bt.gl;
                                this._texFormat = ls.RGBA, this._texType = ls.UNSIGNED_BYTE;
                                const ho = new vt.aW;
                                ho.emplaceBack(-1, -1), ho.emplaceBack(2, -1), ho.emplaceBack(-1, 2);
                                const Dl = new vt.aY;
                                Dl.emplaceBack(0, 1, 2), this._fullscreenTriangle = new kt(bt.createVertexBuffer(ho, lm.members), bt.createIndexBuffer(Dl), vt.aX.simpleSegment(0, 0, ho.length, Dl.length)), this._resultBuffer = new Uint8Array(4), bt.activeTexture.set(ls.TEXTURE1);
                                const Fl = ls.createTexture();
                                ls.bindTexture(ls.TEXTURE_2D, Fl), ls.texParameteri(ls.TEXTURE_2D, ls.TEXTURE_WRAP_S, ls.CLAMP_TO_EDGE), ls.texParameteri(ls.TEXTURE_2D, ls.TEXTURE_WRAP_T, ls.CLAMP_TO_EDGE), ls.texParameteri(ls.TEXTURE_2D, ls.TEXTURE_MIN_FILTER, ls.NEAREST), ls.texParameteri(ls.TEXTURE_2D, ls.TEXTURE_MAG_FILTER, ls.NEAREST), ls.texImage2D(ls.TEXTURE_2D, 0, this._texFormat, this._texWidth, this._texHeight, 0, this._texFormat, this._texType, null), this._fbo = bt.createFramebuffer(this._texWidth, this._texHeight, !1, !1), this._fbo.colorAttachment.set(Fl), ri(ls) && (this._pbo = ls.createBuffer(), ls.bindBuffer(ls.PIXEL_PACK_BUFFER, this._pbo), ls.bufferData(ls.PIXEL_PACK_BUFFER, 4, ls.STREAM_READ), ls.bindBuffer(ls.PIXEL_PACK_BUFFER, null));
                            }
                            destroy() {
                                const le1 = this._cachedRenderContext.context.gl;
                                this._fullscreenTriangle.destroy(), this._fbo.destroy(), le1.deleteBuffer(this._pbo), this._fullscreenTriangle = null, this._fbo = null, this._pbo = null, this._resultBuffer = null;
                            }
                            updateErrorLoop(le1, vt) {
                                const bt = this._updateCount;
                                return this._readbackQueue ? bt >= this._readbackQueue.frameNumberIssued + this._readbackWaitFrames && this._tryReadback() : bt >= this._lastReadbackFrame + this._measureWaitFrames && this._renderErrorTexture(le1, vt), this._updateCount++, this._measuredError;
                            }
                            _bindFramebuffer() {
                                const le1 = this._cachedRenderContext.context, vt = le1.gl;
                                le1.activeTexture.set(vt.TEXTURE1), vt.bindTexture(vt.TEXTURE_2D, this._fbo.colorAttachment.get()), le1.bindFramebuffer.set(this._fbo.framebuffer);
                            }
                            _renderErrorTexture(le1, bt) {
                                const ls = this._cachedRenderContext.context, ho = ls.gl;
                                if (this._bindFramebuffer(), ls.viewport.set([
                                    0,
                                    0,
                                    this._texWidth,
                                    this._texHeight
                                ]), ls.clear({
                                    color: vt.bp.transparent
                                }), this._cachedRenderContext.useProgram("projectionErrorMeasurement").draw(ls, ho.TRIANGLES, ti.disabled, ai.disabled, Qt.unblended, ei.disabled, ((le1, vt)=>({
                                        u_input: le1,
                                        u_output_expected: vt
                                    }))(le1, bt), null, null, "$clipping", this._fullscreenTriangle.vertexBuffer, this._fullscreenTriangle.indexBuffer, this._fullscreenTriangle.segments), this._pbo && ri(ho)) {
                                    ho.bindBuffer(ho.PIXEL_PACK_BUFFER, this._pbo), ho.readBuffer(ho.COLOR_ATTACHMENT0), ho.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, 0), ho.bindBuffer(ho.PIXEL_PACK_BUFFER, null);
                                    const le1 = ho.fenceSync(ho.SYNC_GPU_COMMANDS_COMPLETE, 0);
                                    ho.flush(), this._readbackQueue = {
                                        frameNumberIssued: this._updateCount,
                                        sync: le1
                                    };
                                } else this._readbackQueue = {
                                    frameNumberIssued: this._updateCount,
                                    sync: null
                                };
                            }
                            _tryReadback() {
                                const le1 = this._cachedRenderContext.context.gl;
                                if (this._pbo && this._readbackQueue && ri(le1)) {
                                    const bt = le1.clientWaitSync(this._readbackQueue.sync, 0, 0);
                                    if (bt === le1.WAIT_FAILED) return vt.w("WebGL2 clientWaitSync failed."), this._readbackQueue = null, void (this._lastReadbackFrame = this._updateCount);
                                    if (bt === le1.TIMEOUT_EXPIRED) return;
                                    le1.bindBuffer(le1.PIXEL_PACK_BUFFER, this._pbo), le1.getBufferSubData(le1.PIXEL_PACK_BUFFER, 0, this._resultBuffer, 0, 4), le1.bindBuffer(le1.PIXEL_PACK_BUFFER, null);
                                } else this._bindFramebuffer(), le1.readPixels(0, 0, this._texWidth, this._texHeight, this._texFormat, this._texType, this._resultBuffer);
                                this._readbackQueue = null, this._measuredError = si._parseRGBA8float(this._resultBuffer), this._lastReadbackFrame = this._updateCount;
                            }
                            static _parseRGBA8float(le1) {
                                let vt = 0;
                                return vt += le1[0] / 256, vt += le1[1] / 65536, vt += le1[2] / 16777216, le1[3] < 127 && (vt = -vt), vt / 128;
                            }
                        }
                        const mm = vt.a5 / 128;
                        function li(le1, bt) {
                            const ls = void 0 !== le1.granularity ? Math.max(le1.granularity, 1) : 1, ho = ls + (le1.generateBorders ? 2 : 0), Dl = ls + (le1.extendToNorthPole || le1.generateBorders ? 1 : 0) + (le1.extendToSouthPole || le1.generateBorders ? 1 : 0), Fl = ho + 1, sc = Dl + 1, uc = le1.generateBorders ? -1 : 0, mc = le1.generateBorders || le1.extendToNorthPole ? -1 : 0, gc = ls + (le1.generateBorders ? 1 : 0), Ac = ls + (le1.generateBorders || le1.extendToSouthPole ? 1 : 0), Ec = Fl * sc, kc = ho * Dl * 6, du = Fl * sc > 65536;
                            if (du && "16bit" === bt) throw new Error("Granularity is too large and meshes would not fit inside 16 bit vertex indices.");
                            const _u = du || "32bit" === bt, Md = new Int16Array(2 * Ec);
                            let Ld = 0;
                            for(let Od = mc; Od <= Ac; Od++)for(let bt = uc; bt <= gc; bt++){
                                let ho = bt / ls * vt.a5;
                                -1 === bt && (ho = -mm), bt === ls + 1 && (ho = vt.a5 + mm);
                                let Dl = Od / ls * vt.a5;
                                -1 === Od && (Dl = le1.extendToNorthPole ? vt.br : -mm), Od === ls + 1 && (Dl = le1.extendToSouthPole ? vt.bs : vt.a5 + mm), Md[Ld++] = ho, Md[Ld++] = Dl;
                            }
                            const Nd = _u ? new Uint32Array(kc) : new Uint16Array(kc);
                            let Rd = 0;
                            for(let vt = 0; vt < Dl; vt++)for(let le1 = 0; le1 < ho; le1++){
                                const bt = le1 + 1 + vt * Fl, ls = le1 + (vt + 1) * Fl, ho = le1 + 1 + (vt + 1) * Fl;
                                Nd[Rd++] = le1 + vt * Fl, Nd[Rd++] = ls, Nd[Rd++] = bt, Nd[Rd++] = bt, Nd[Rd++] = ls, Nd[Rd++] = ho;
                            }
                            return {
                                vertices: Md.buffer.slice(0),
                                indices: Nd.buffer.slice(0),
                                uses32bitIndices: _u
                            };
                        }
                        const fm = new vt.aV({
                            fill: new vt.bt(128, 2),
                            line: new vt.bt(512, 0),
                            tile: new vt.bt(128, 32),
                            stencil: new vt.bt(128, 1),
                            circle: 3
                        });
                        class hi {
                            constructor(){
                                this._tileMeshCache = {}, this._errorCorrectionUsable = 0, this._errorMeasurementLastValue = 0, this._errorCorrectionPreviousValue = 0, this._errorMeasurementLastChangeTime = -1000;
                            }
                            get name() {
                                return "vertical-perspective";
                            }
                            get transitionState() {
                                return 1;
                            }
                            get useSubdivision() {
                                return !0;
                            }
                            get shaderVariantName() {
                                return "globe";
                            }
                            get shaderDefine() {
                                return "#define GLOBE";
                            }
                            get shaderPreludeCode() {
                                return om.projectionGlobe;
                            }
                            get vertexShaderPreludeCode() {
                                return om.projectionMercator.vertexSource;
                            }
                            get subdivisionGranularity() {
                                return fm;
                            }
                            get useGlobeControls() {
                                return !0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return this._errorCorrectionUsable;
                            }
                            destroy() {
                                this._errorMeasurement && this._errorMeasurement.destroy();
                            }
                            updateGPUdependent(le1) {
                                this._errorMeasurement || (this._errorMeasurement = new si(le1));
                                const bt = vt.X(this._errorQueryLatitudeDegrees), ls = 2 * Math.atan(Math.exp(Math.PI - bt * Math.PI * 2)) - .5 * Math.PI, ho = this._errorMeasurement.updateErrorLoop(bt, ls), Dl = c();
                                ho !== this._errorMeasurementLastValue && (this._errorCorrectionPreviousValue = this._errorCorrectionUsable, this._errorMeasurementLastValue = ho, this._errorMeasurementLastChangeTime = Dl);
                                const Fl = Math.min(Math.max((Dl - this._errorMeasurementLastChangeTime) / 1e3 / .5, 0), 1);
                                this._errorCorrectionUsable = vt.bu(this._errorCorrectionPreviousValue, -this._errorMeasurementLastValue, vt.bv(Fl));
                            }
                            _getMeshKey(le1) {
                                return `${le1.granularity.toString(36)}_${le1.generateBorders ? "b" : ""}${le1.extendToNorthPole ? "n" : ""}${le1.extendToSouthPole ? "s" : ""}`;
                            }
                            getMeshFromTileID(le1, vt, bt, ls, ho) {
                                const Dl = ("stencil" === ho ? fm.stencil : fm.tile).getGranularityForZoomLevel(vt.z);
                                return this._getMesh(le1, {
                                    granularity: Dl,
                                    generateBorders: bt,
                                    extendToNorthPole: 0 === vt.y && ls,
                                    extendToSouthPole: vt.y === (1 << vt.z) - 1 && ls
                                });
                            }
                            _getMesh(le1, bt) {
                                const ls = this._getMeshKey(bt);
                                if (ls in this._tileMeshCache) return this._tileMeshCache[ls];
                                const ho = function(le1, bt) {
                                    const ls = li(bt, "16bit"), ho = vt.aW.deserialize({
                                        arrayBuffer: ls.vertices,
                                        length: ls.vertices.byteLength / 2 / 2
                                    }), Dl = vt.aY.deserialize({
                                        arrayBuffer: ls.indices,
                                        length: ls.indices.byteLength / 2 / 3
                                    });
                                    return new kt(le1.createVertexBuffer(ho, lm.members), le1.createIndexBuffer(Dl), vt.aX.simpleSegment(0, 0, ho.length, Dl.length));
                                }(le1, bt);
                                return this._tileMeshCache[ls] = ho, ho;
                            }
                            recalculate(le1) {}
                            hasTransition() {
                                const le1 = c();
                                let vt = !1;
                                return vt = vt || (le1 - this._errorMeasurementLastChangeTime) / 1e3 < .7, vt = vt || this._errorMeasurement && this._errorMeasurement.awaitingQuery, vt;
                            }
                            setErrorQueryLatitudeDegrees(le1) {
                                this._errorQueryLatitudeDegrees = le1;
                            }
                        }
                        const gm = new vt.t({
                            type: new vt.D(vt.u.projection.type)
                        });
                        class di extends vt.E {
                            constructor(le1){
                                super(), this._transitionable = new vt.x(gm, void 0), this.setProjection(le1), this._transitioning = this._transitionable.untransitioned(), this.recalculate(new vt.H(0)), this._mercatorProjection = new jt, this._verticalPerspectiveProjection = new hi;
                            }
                            get transitionState() {
                                const le1 = this.properties.get("type");
                                if ("string" == typeof le1 && "mercator" === le1) return 0;
                                if ("string" == typeof le1 && "vertical-perspective" === le1) return 1;
                                if (le1 instanceof vt.bw) {
                                    if ("vertical-perspective" === le1.from && "mercator" === le1.to) return 1 - le1.transition;
                                    if ("mercator" === le1.from && "vertical-perspective" === le1.to) return le1.transition;
                                }
                                return 1;
                            }
                            get useGlobeRendering() {
                                return this.transitionState > 0;
                            }
                            get latitudeErrorCorrectionRadians() {
                                return this._verticalPerspectiveProjection.latitudeErrorCorrectionRadians;
                            }
                            get currentProjection() {
                                return this.useGlobeRendering ? this._verticalPerspectiveProjection : this._mercatorProjection;
                            }
                            get name() {
                                return "globe";
                            }
                            get useSubdivision() {
                                return this.currentProjection.useSubdivision;
                            }
                            get shaderVariantName() {
                                return this.currentProjection.shaderVariantName;
                            }
                            get shaderDefine() {
                                return this.currentProjection.shaderDefine;
                            }
                            get shaderPreludeCode() {
                                return this.currentProjection.shaderPreludeCode;
                            }
                            get vertexShaderPreludeCode() {
                                return this.currentProjection.vertexShaderPreludeCode;
                            }
                            get subdivisionGranularity() {
                                return this.currentProjection.subdivisionGranularity;
                            }
                            get useGlobeControls() {
                                return this.transitionState > 0;
                            }
                            destroy() {
                                this._mercatorProjection.destroy(), this._verticalPerspectiveProjection.destroy();
                            }
                            updateGPUdependent(le1) {
                                this._mercatorProjection.updateGPUdependent(le1), this._verticalPerspectiveProjection.updateGPUdependent(le1);
                            }
                            getMeshFromTileID(le1, vt, bt, ls, ho) {
                                return this.currentProjection.getMeshFromTileID(le1, vt, bt, ls, ho);
                            }
                            setProjection(le1) {
                                this._transitionable.setValue("type", (null == le1 ? void 0 : le1.type) || "mercator");
                            }
                            updateTransitions(le1) {
                                this._transitioning = this._transitionable.transitioned(le1, this._transitioning);
                            }
                            hasTransition() {
                                return this._transitioning.hasTransition() || this.currentProjection.hasTransition();
                            }
                            recalculate(le1) {
                                this.properties = this._transitioning.possiblyEvaluate(le1);
                            }
                            setErrorQueryLatitudeDegrees(le1) {
                                this._verticalPerspectiveProjection.setErrorQueryLatitudeDegrees(le1), this._mercatorProjection.setErrorQueryLatitudeDegrees(le1);
                            }
                        }
                        function _i(le1) {
                            const vt = fi(le1.worldSize, le1.center.lat);
                            return 2 * Math.PI * vt;
                        }
                        function pi(le1, bt, ls, ho, Dl) {
                            const Fl = 1 / (1 << Dl), sc = bt / vt.a5 * Fl + ho * Fl, uc = vt.bz((le1 / vt.a5 * Fl + ls * Fl) * Math.PI * 2 + Math.PI, 2 * Math.PI), mc = 2 * Math.atan(Math.exp(Math.PI - sc * Math.PI * 2)) - .5 * Math.PI, gc = Math.cos(mc), Ac = new Float64Array(3);
                            return Ac[0] = Math.sin(uc) * gc, Ac[1] = Math.sin(mc), Ac[2] = Math.cos(uc) * gc, Ac;
                        }
                        function mi(le1) {
                            return function(le1, vt) {
                                const bt = Math.cos(vt), ls = new Float64Array(3);
                                return ls[0] = Math.sin(le1) * bt, ls[1] = Math.sin(vt), ls[2] = Math.cos(le1) * bt, ls;
                            }(le1.lng * Math.PI / 180, le1.lat * Math.PI / 180);
                        }
                        function fi(le1, vt) {
                            return le1 / (2 * Math.PI) / Math.cos(vt * Math.PI / 180);
                        }
                        function gi(le1) {
                            const bt = Math.asin(le1[1]) / Math.PI * 180, ls = Math.sqrt(le1[0] * le1[0] + le1[2] * le1[2]);
                            if (ls > 1e-6) {
                                const ho = le1[0] / ls, Dl = Math.acos(le1[2] / ls), Fl = (ho > 0 ? Dl : -Dl) / Math.PI * 180;
                                return new vt.V(vt.W(Fl, -180, 180), bt);
                            }
                            return new vt.V(0, bt);
                        }
                        function vi(le1) {
                            return Math.cos(le1 * Math.PI / 180);
                        }
                        function xi(le1, bt) {
                            const ls = vi(le1), ho = vi(bt);
                            return vt.at(ho / ls);
                        }
                        function bi(le1, bt) {
                            const ls = le1.rotate(bt.bearingInRadians), ho = bt.zoom + xi(bt.center.lat, 0), Dl = vt.bu(1 / vi(bt.center.lat), 1 / vi(Math.min(Math.abs(bt.center.lat), 60)), vt.bx(ho, 7, 3, 0, 1)), Fl = 360 / _i({
                                worldSize: bt.worldSize,
                                center: {
                                    lat: bt.center.lat
                                }
                            });
                            return new vt.V(bt.center.lng - ls.x * Fl * Dl, vt.an(bt.center.lat + ls.y * Fl, -vt.ao, vt.ao));
                        }
                        function yi(le1) {
                            const vt = .5 * le1, bt = Math.sin(vt), ls = Math.cos(vt);
                            return Math.log(bt + ls) - Math.log(ls - bt);
                        }
                        function wi(le1, bt, ls, ho) {
                            const Dl = le1.lat + ls * ho;
                            if (Math.abs(ls) > 1) {
                                const Fl = (Math.sign(le1.lat + ls) !== Math.sign(le1.lat) ? -Math.abs(le1.lat) : Math.abs(le1.lat)) * Math.PI / 180, sc = Math.abs(le1.lat + ls) * Math.PI / 180, uc = yi(Fl + ho * (sc - Fl)), mc = yi(Fl), gc = yi(sc);
                                return new vt.V(le1.lng + bt * ((uc - mc) / (gc - mc)), Dl);
                            }
                            return new vt.V(le1.lng + bt * ho, Dl);
                        }
                        class Ti {
                            constructor(le1){
                                this._cachePrevious = new Map, this._cache = new Map, this._hadAnyChanges = !1, this._boundingVolumeFactory = le1;
                            }
                            swapBuffers() {
                                if (!this._hadAnyChanges) return;
                                const le1 = this._cachePrevious;
                                this._cachePrevious = this._cache, this._cache = le1, this._cache.clear(), this._hadAnyChanges = !1;
                            }
                            getTileBoundingVolume(le1, vt, bt, ls) {
                                const ho = `${le1.z}_${le1.x}_${le1.y}_${(null == ls ? void 0 : ls.terrain) ? "t" : ""}`, Dl = this._cache.get(ho);
                                if (Dl) return Dl;
                                const Fl = this._cachePrevious.get(ho);
                                if (Fl) return this._cache.set(ho, Fl), Fl;
                                const sc = this._boundingVolumeFactory(le1, vt, bt, ls);
                                return this._cache.set(ho, sc), this._hadAnyChanges = !0, sc;
                            }
                        }
                        class Pi {
                            constructor(le1, vt, bt, ls){
                                this.min = bt, this.max = ls, this.points = le1, this.planes = vt;
                            }
                            static fromAabb(le1, vt) {
                                const bt = [];
                                for(let ls = 0; ls < 8; ls++)bt.push([
                                    1 & ~ls ? le1[0] : vt[0],
                                    1 == (ls >> 1 & 1) ? vt[1] : le1[1],
                                    1 == (ls >> 2 & 1) ? vt[2] : le1[2]
                                ]);
                                return new Pi(bt, [
                                    [
                                        -1,
                                        0,
                                        0,
                                        vt[0]
                                    ],
                                    [
                                        1,
                                        0,
                                        0,
                                        -le1[0]
                                    ],
                                    [
                                        0,
                                        -1,
                                        0,
                                        vt[1]
                                    ],
                                    [
                                        0,
                                        1,
                                        0,
                                        -le1[1]
                                    ],
                                    [
                                        0,
                                        0,
                                        -1,
                                        vt[2]
                                    ],
                                    [
                                        0,
                                        0,
                                        1,
                                        -le1[2]
                                    ]
                                ], le1, vt);
                            }
                            static fromCenterSizeAngles(le1, bt, ls) {
                                const ho = vt.bB([], ls[0], ls[1], ls[2]), Dl = vt.bC([], [
                                    bt[0],
                                    0,
                                    0
                                ], ho), Fl = vt.bC([], [
                                    0,
                                    bt[1],
                                    0
                                ], ho), sc = vt.bC([], [
                                    0,
                                    0,
                                    bt[2]
                                ], ho), uc = [
                                    ...le1
                                ], mc = [
                                    ...le1
                                ];
                                for(let vt = 0; vt < 8; vt++)for(let bt = 0; bt < 3; bt++){
                                    const ls = le1[bt] + Dl[bt] * (1 & ~vt ? -1 : 1) + Fl[bt] * (1 == (vt >> 1 & 1) ? 1 : -1) + sc[bt] * (1 == (vt >> 2 & 1) ? 1 : -1);
                                    uc[bt] = Math.min(uc[bt], ls), mc[bt] = Math.max(mc[bt], ls);
                                }
                                const gc = [];
                                for(let Ac = 0; Ac < 8; Ac++){
                                    const bt = [
                                        ...le1
                                    ];
                                    vt.b0(bt, bt, vt.a$([], Dl, 1 & ~Ac ? -1 : 1)), vt.b0(bt, bt, vt.a$([], Fl, 1 == (Ac >> 1 & 1) ? 1 : -1)), vt.b0(bt, bt, vt.a$([], sc, 1 == (Ac >> 2 & 1) ? 1 : -1)), gc.push(bt);
                                }
                                return new Pi(gc, [
                                    [
                                        ...Dl,
                                        -vt.b5(Dl, gc[0])
                                    ],
                                    [
                                        ...Fl,
                                        -vt.b5(Fl, gc[0])
                                    ],
                                    [
                                        ...sc,
                                        -vt.b5(sc, gc[0])
                                    ],
                                    [
                                        -Dl[0],
                                        -Dl[1],
                                        -Dl[2],
                                        -vt.b5(Dl, gc[7])
                                    ],
                                    [
                                        -Fl[0],
                                        -Fl[1],
                                        -Fl[2],
                                        -vt.b5(Fl, gc[7])
                                    ],
                                    [
                                        -sc[0],
                                        -sc[1],
                                        -sc[2],
                                        -vt.b5(sc, gc[7])
                                    ]
                                ], uc, mc);
                            }
                            intersectsFrustum(le1) {
                                let vt = !0;
                                const bt = this.points.length, ls = this.planes.length, ho = le1.planes.length, Dl = le1.points.length;
                                for(let Fl = 0; Fl < ho; Fl++){
                                    const ls = le1.planes[Fl];
                                    let ho = 0;
                                    for(let le1 = 0; le1 < bt; le1++){
                                        const vt = this.points[le1];
                                        ls[0] * vt[0] + ls[1] * vt[1] + ls[2] * vt[2] + ls[3] >= 0 && ho++;
                                    }
                                    if (0 === ho) return 0;
                                    ho < bt && (vt = !1);
                                }
                                if (vt) return 2;
                                for(let Fl = 0; Fl < ls; Fl++){
                                    const vt = this.planes[Fl];
                                    let bt = 0;
                                    for(let ls = 0; ls < Dl; ls++){
                                        const ho = le1.points[ls];
                                        vt[0] * ho[0] + vt[1] * ho[1] + vt[2] * ho[2] + vt[3] >= 0 && bt++;
                                    }
                                    if (0 === bt) return 0;
                                }
                                return 1;
                            }
                            intersectsPlane(le1) {
                                const vt = this.points.length;
                                let bt = 0;
                                for(let ls = 0; ls < vt; ls++){
                                    const vt = this.points[ls];
                                    le1[0] * vt[0] + le1[1] * vt[1] + le1[2] * vt[2] + le1[3] >= 0 && bt++;
                                }
                                return bt === vt ? 2 : 0 === bt ? 0 : 1;
                            }
                        }
                        function Ci(le1, vt, bt) {
                            const ls = le1 - vt;
                            return ls < 0 ? -ls : Math.max(0, ls - bt);
                        }
                        function Ii(le1, vt, bt, ls, ho) {
                            const Dl = le1 - bt;
                            let Fl;
                            return Fl = Dl < 0 ? Math.min(-Dl, 1 + Dl - ho) : Dl > 1 ? Math.min(Math.max(Dl - ho, 0), 1 - Dl) : 0, Math.max(Fl, Ci(vt, ls, ho));
                        }
                        class Mi {
                            constructor(){
                                this._boundingVolumeCache = new Ti(this._computeTileBoundingVolume);
                            }
                            prepareNextFrame() {
                                this._boundingVolumeCache.swapBuffers();
                            }
                            distanceToTile2d(le1, vt, bt, ls) {
                                const ho = 1 << bt.z, Dl = 1 / ho, Fl = bt.x / ho, sc = bt.y / ho;
                                let uc = 2;
                                return uc = Math.min(uc, Ii(le1, vt, Fl, sc, Dl)), uc = Math.min(uc, Ii(le1, vt, Fl + .5, -sc - Dl, Dl)), uc = Math.min(uc, Ii(le1, vt, Fl + .5, 2 - sc - Dl, Dl)), uc;
                            }
                            getWrap(le1, vt, bt) {
                                const ls = 1 << vt.z, ho = 1 / ls, Dl = vt.x / ls, Fl = Ci(le1.x, Dl, ho), sc = Ci(le1.x, Dl - 1, ho), uc = Ci(le1.x, Dl + 1, ho), mc = Math.min(Fl, sc, uc);
                                return mc === uc ? 1 : mc === sc ? -1 : 0;
                            }
                            allowVariableZoom(le1, vt) {
                                return Ce(le1, vt) > 4;
                            }
                            allowWorldCopies() {
                                return !1;
                            }
                            getTileBoundingVolume(le1, vt, bt, ls) {
                                return this._boundingVolumeCache.getTileBoundingVolume(le1, vt, bt, ls);
                            }
                            _computeTileBoundingVolume(le1, bt, ls, ho) {
                                var Dl, Fl;
                                let sc = 0, uc = 0;
                                if (null == ho ? void 0 : ho.terrain) {
                                    const mc = new vt.a2(le1.z, bt, le1.z, le1.x, le1.y), gc = ho.terrain.getMinMaxElevation(mc);
                                    sc = null !== (Dl = gc.minElevation) && void 0 !== Dl ? Dl : Math.min(0, ls), uc = null !== (Fl = gc.maxElevation) && void 0 !== Fl ? Fl : Math.max(0, ls);
                                }
                                if (sc /= vt.bE, uc /= vt.bE, sc += 1, uc += 1, le1.z <= 0) return Pi.fromAabb([
                                    -uc,
                                    -uc,
                                    -uc
                                ], [
                                    uc,
                                    uc,
                                    uc
                                ]);
                                if (1 === le1.z) return Pi.fromAabb([
                                    0 === le1.x ? -uc : 0,
                                    0 === le1.y ? 0 : -uc,
                                    -uc
                                ], [
                                    0 === le1.x ? 0 : uc,
                                    0 === le1.y ? uc : 0,
                                    uc
                                ]);
                                {
                                    const bt = [
                                        pi(0, 0, le1.x, le1.y, le1.z),
                                        pi(vt.a5, 0, le1.x, le1.y, le1.z),
                                        pi(vt.a5, vt.a5, le1.x, le1.y, le1.z),
                                        pi(0, vt.a5, le1.x, le1.y, le1.z)
                                    ], ls = [];
                                    for (const le1 of bt)ls.push(vt.a$([], le1, uc));
                                    if (uc !== sc) for (const le1 of bt)ls.push(vt.a$([], le1, sc));
                                    0 === le1.y && ls.push([
                                        0,
                                        1,
                                        0
                                    ]), le1.y === (1 << le1.z) - 1 && ls.push([
                                        0,
                                        -1,
                                        0
                                    ]);
                                    const ho = [
                                        1,
                                        1,
                                        1
                                    ], Dl = [
                                        -1,
                                        -1,
                                        -1
                                    ];
                                    for (const le1 of ls)for(let vt = 0; vt < 3; vt++)ho[vt] = Math.min(ho[vt], le1[vt]), Dl[vt] = Math.max(Dl[vt], le1[vt]);
                                    const Fl = pi(vt.a5 / 2, vt.a5 / 2, le1.x, le1.y, le1.z), mc = vt.b4([], [
                                        0,
                                        1,
                                        0
                                    ], Fl);
                                    vt.b3(mc, mc);
                                    const gc = vt.b4([], Fl, mc);
                                    vt.b3(gc, gc);
                                    const Ac = vt.b4([], bt[2], bt[1]);
                                    vt.b3(Ac, Ac);
                                    const Ec = vt.b4([], bt[0], bt[3]);
                                    vt.b3(Ec, Ec), ls.push(vt.a$([], Fl, uc)), le1.y >= (1 << le1.z) / 2 && ls.push(vt.a$([], pi(vt.a5 / 2, 0, le1.x, le1.y, le1.z), uc)), le1.y < (1 << le1.z) / 2 && ls.push(vt.a$([], pi(vt.a5 / 2, vt.a5, le1.x, le1.y, le1.z), uc));
                                    const kc = Ei(Fl, ls), du = Ei(gc, ls), _u = [
                                        -Fl[0],
                                        -Fl[1],
                                        -Fl[2],
                                        kc.max
                                    ], Md = [
                                        Fl[0],
                                        Fl[1],
                                        Fl[2],
                                        -kc.min
                                    ], Ld = [
                                        -gc[0],
                                        -gc[1],
                                        -gc[2],
                                        du.max
                                    ], Nd = [
                                        gc[0],
                                        gc[1],
                                        gc[2],
                                        -du.min
                                    ], Rd = [
                                        ...Ac,
                                        0
                                    ], Od = [
                                        ...Ec,
                                        0
                                    ], jd = [];
                                    return 0 === le1.y ? jd.push(vt.bD(Od, Rd, _u), vt.bD(Od, Rd, Md)) : jd.push(vt.bD(Ld, Rd, _u), vt.bD(Ld, Rd, Md), vt.bD(Ld, Od, _u), vt.bD(Ld, Od, Md)), le1.y === (1 << le1.z) - 1 ? jd.push(vt.bD(Od, Rd, _u), vt.bD(Od, Rd, Md)) : jd.push(vt.bD(Nd, Rd, _u), vt.bD(Nd, Rd, Md), vt.bD(Nd, Od, _u), vt.bD(Nd, Od, Md)), new Pi(jd, [
                                        _u,
                                        Md,
                                        Ld,
                                        Nd,
                                        Rd,
                                        Od
                                    ], ho, Dl);
                                }
                            }
                        }
                        function Ei(le1, bt) {
                            let ls = 1 / 0, ho = -1 / 0;
                            for (const Dl of bt){
                                const bt = vt.b5(le1, Dl);
                                ls = Math.min(ls, bt), ho = Math.max(ho, bt);
                            }
                            return {
                                min: ls,
                                max: ho
                            };
                        }
                        class Si {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(le1) {
                                this._helper.setMinZoom(le1);
                            }
                            setMaxZoom(le1) {
                                this._helper.setMaxZoom(le1);
                            }
                            setMinPitch(le1) {
                                this._helper.setMinPitch(le1);
                            }
                            setMaxPitch(le1) {
                                this._helper.setMaxPitch(le1);
                            }
                            setRenderWorldCopies(le1) {
                                this._helper.setRenderWorldCopies(le1);
                            }
                            setBearing(le1) {
                                this._helper.setBearing(le1);
                            }
                            setPitch(le1) {
                                this._helper.setPitch(le1);
                            }
                            setRoll(le1) {
                                this._helper.setRoll(le1);
                            }
                            setFov(le1) {
                                this._helper.setFov(le1);
                            }
                            setZoom(le1) {
                                this._helper.setZoom(le1);
                            }
                            setCenter(le1) {
                                this._helper.setCenter(le1);
                            }
                            setElevation(le1) {
                                this._helper.setElevation(le1);
                            }
                            setMinElevationForCurrentTile(le1) {
                                this._helper.setMinElevationForCurrentTile(le1);
                            }
                            setPadding(le1) {
                                this._helper.setPadding(le1);
                            }
                            interpolatePadding(le1, vt, bt) {
                                return this._helper.interpolatePadding(le1, vt, bt);
                            }
                            isPaddingEqual(le1) {
                                return this._helper.isPaddingEqual(le1);
                            }
                            resize(le1, vt) {
                                this._helper.resize(le1, vt);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(le1) {
                                this._helper.setMaxBounds(le1);
                            }
                            setConstrainOverride(le1) {
                                this._helper.setConstrainOverride(le1);
                            }
                            overrideNearFarZ(le1, vt) {
                                this._helper.overrideNearFarZ(le1, vt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(le1) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), le1);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get constrainOverride() {
                                return this._helper.constrainOverride;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            setTransitionState(le1) {}
                            constructor(le1){
                                this._cachedClippingPlane = vt.bF(), this._projectionMatrix = vt.bj(), this._globeViewProjMatrix32f = vt.bi(), this._globeViewProjMatrixNoCorrection = vt.bj(), this._globeViewProjMatrixNoCorrectionInverted = vt.bj(), this._globeProjMatrixInverted = vt.bj(), this._cameraPosition = vt.bA(), this._globeLatitudeErrorCorrectionRadians = 0, this.defaultConstrain = (le1, bt)=>{
                                    const ls = vt.an(le1.lat, -vt.ao, vt.ao), ho = vt.an(+bt, this.minZoom + xi(0, ls), this.maxZoom);
                                    return {
                                        center: new vt.V(le1.lng, ls),
                                        zoom: ho
                                    };
                                }, this.applyConstrain = (le1, vt)=>this._helper.applyConstrain(le1, vt), this._helper = new Gt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    defaultConstrain: (le1, vt)=>this.defaultConstrain(le1, vt)
                                }, le1), this._coveringTilesDetailsProvider = new Mi;
                            }
                            clone() {
                                const le1 = new Si;
                                return le1.apply(this, !1), le1;
                            }
                            apply(le1, vt, bt) {
                                this._globeLatitudeErrorCorrectionRadians = bt || 0, this._helper.apply(le1, vt);
                            }
                            get projectionMatrix() {
                                return this._projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this._globeViewProjMatrixNoCorrection;
                            }
                            get inverseProjectionMatrix() {
                                return this._globeProjMatrixInverted;
                            }
                            get cameraPosition() {
                                const le1 = vt.bA();
                                return le1[0] = this._cameraPosition[0], le1[1] = this._cameraPosition[1], le1[2] = this._cameraPosition[2], le1;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            getProjectionData(le1) {
                                const { overscaledTileID: vt, applyGlobeMatrix: bt } = le1, ls = this._helper.getMercatorTileCoordinates(vt);
                                return {
                                    mainMatrix: this._globeViewProjMatrix32f,
                                    tileMercatorCoords: ls,
                                    clippingPlane: this._cachedClippingPlane,
                                    projectionTransition: bt ? 1 : 0,
                                    fallbackMatrix: this._globeViewProjMatrix32f
                                };
                            }
                            _computeClippingPlane(le1) {
                                const bt = this.pitchInRadians, ls = this.cameraToCenterDistance / le1, ho = Math.sin(bt) * ls, Dl = Math.cos(bt) * ls + 1, Fl = 1 / Math.sqrt(ho * ho + Dl * Dl) * 1;
                                let sc = -ho, uc = Dl;
                                const mc = Math.sqrt(sc * sc + uc * uc);
                                sc /= mc, uc /= mc;
                                const gc = [
                                    0,
                                    sc,
                                    uc
                                ];
                                vt.bG(gc, gc, [
                                    0,
                                    0,
                                    0
                                ], -this.bearingInRadians), vt.bH(gc, gc, [
                                    0,
                                    0,
                                    0
                                ], -1 * this.center.lat * Math.PI / 180), vt.bI(gc, gc, [
                                    0,
                                    0,
                                    0
                                ], this.center.lng * Math.PI / 180);
                                const Ac = 1 / vt.b7(gc);
                                return vt.a$(gc, gc, Ac), [
                                    ...gc,
                                    -Fl * Ac
                                ];
                            }
                            isLocationOccluded(le1) {
                                return !this.isSurfacePointVisible(mi(le1));
                            }
                            transformLightDirection(le1) {
                                const bt = this._helper._center.lng * Math.PI / 180, ls = this._helper._center.lat * Math.PI / 180, ho = Math.cos(ls), Dl = [
                                    Math.sin(bt) * ho,
                                    Math.sin(ls),
                                    Math.cos(bt) * ho
                                ], Fl = [
                                    Dl[2],
                                    0,
                                    -Dl[0]
                                ], sc = [
                                    0,
                                    0,
                                    0
                                ];
                                vt.b4(sc, Fl, Dl), vt.b3(Fl, Fl), vt.b3(sc, sc);
                                const uc = [
                                    0,
                                    0,
                                    0
                                ];
                                return vt.b3(uc, [
                                    Fl[0] * le1[0] + sc[0] * le1[1] + Dl[0] * le1[2],
                                    Fl[1] * le1[0] + sc[1] * le1[1] + Dl[1] * le1[2],
                                    Fl[2] * le1[0] + sc[2] * le1[1] + Dl[2] * le1[2]
                                ]), uc;
                            }
                            getPixelScale() {
                                return 1 / Math.cos(this._helper._center.lat * Math.PI / 180);
                            }
                            getCircleRadiusCorrection() {
                                return Math.cos(this._helper._center.lat * Math.PI / 180);
                            }
                            getPitchedTextCorrection(le1, bt, ls) {
                                const ho = function(le1, bt, ls) {
                                    const ho = 1 / (1 << ls.z);
                                    return new vt.a9(le1 / vt.a5 * ho + ls.x * ho, bt / vt.a5 * ho + ls.y * ho);
                                }(le1, bt, ls.canonical), Dl = (Fl = ho.y, [
                                    vt.bz(ho.x * Math.PI * 2 + Math.PI, 2 * Math.PI),
                                    2 * Math.atan(Math.exp(Math.PI - Fl * Math.PI * 2)) - .5 * Math.PI
                                ]);
                                var Fl;
                                return this.getCircleRadiusCorrection() / Math.cos(Dl[1]);
                            }
                            projectTileCoordinates(le1, bt, ls, ho) {
                                const Dl = ls.canonical, Fl = pi(le1, bt, Dl.x, Dl.y, Dl.z), sc = 1 + (ho ? ho(le1, bt) : 0) / vt.bE, uc = [
                                    Fl[0] * sc,
                                    Fl[1] * sc,
                                    Fl[2] * sc,
                                    1
                                ];
                                vt.aH(uc, uc, this._globeViewProjMatrixNoCorrection);
                                const mc = this._cachedClippingPlane, gc = mc[0] * Fl[0] + mc[1] * Fl[1] + mc[2] * Fl[2] + mc[3] < 0;
                                return {
                                    point: new vt.P(uc[0] / uc[3], uc[1] / uc[3]),
                                    signedDistanceFromCamera: uc[3],
                                    isOccluded: gc
                                };
                            }
                            _calcMatrices() {
                                if (!this._helper._width || !this._helper._height) return;
                                const le1 = fi(this.worldSize, this.center.lat), bt = vt.bk(), ls = vt.bk();
                                this._helper.autoCalculateNearFarZ && (this._helper._nearZ = .5, this._helper._farZ = this.cameraToCenterDistance + 2 * le1), vt.be(bt, this.fovInRadians, this.width / this.height, this._helper._nearZ, this._helper._farZ);
                                const ho = this.centerOffset;
                                bt[8] = 2 * -ho.x / this._helper._width, bt[9] = 2 * ho.y / this._helper._height, this._projectionMatrix = vt.bf(bt), this._globeProjMatrixInverted = vt.bk(), vt.aB(this._globeProjMatrixInverted, bt), vt.O(bt, bt, [
                                    0,
                                    0,
                                    -this.cameraToCenterDistance
                                ]), vt.bg(bt, bt, this.rollInRadians), vt.bh(bt, bt, -this.pitchInRadians), vt.bg(bt, bt, this.bearingInRadians), vt.O(bt, bt, [
                                    0,
                                    0,
                                    -le1
                                ]);
                                const Dl = vt.bA();
                                Dl[0] = le1, Dl[1] = le1, Dl[2] = le1, vt.bh(ls, bt, this.center.lat * Math.PI / 180), vt.bJ(ls, ls, -this.center.lng * Math.PI / 180), vt.Q(ls, ls, Dl), this._globeViewProjMatrixNoCorrection = ls, vt.bh(bt, bt, this.center.lat * Math.PI / 180 - this._globeLatitudeErrorCorrectionRadians), vt.bJ(bt, bt, -this.center.lng * Math.PI / 180), vt.Q(bt, bt, Dl), this._globeViewProjMatrix32f = new Float32Array(bt), this._globeViewProjMatrixNoCorrectionInverted = vt.bk(), vt.aB(this._globeViewProjMatrixNoCorrectionInverted, ls);
                                const Fl = vt.bA();
                                this._cameraPosition = vt.bA(), this._cameraPosition[2] = this.cameraToCenterDistance / le1, vt.bG(this._cameraPosition, this._cameraPosition, Fl, -this.rollInRadians), vt.bH(this._cameraPosition, this._cameraPosition, Fl, this.pitchInRadians), vt.bG(this._cameraPosition, this._cameraPosition, Fl, -this.bearingInRadians), vt.b0(this._cameraPosition, this._cameraPosition, [
                                    0,
                                    0,
                                    1
                                ]), vt.bH(this._cameraPosition, this._cameraPosition, Fl, -this.center.lat * Math.PI / 180), vt.bI(this._cameraPosition, this._cameraPosition, Fl, this.center.lng * Math.PI / 180), this._cachedClippingPlane = this._computeClippingPlane(le1);
                                const sc = vt.bf(this._globeViewProjMatrixNoCorrectionInverted);
                                vt.Q(sc, sc, [
                                    1,
                                    1,
                                    -1
                                ]), this._cachedFrustum = Wt.fromInvProjectionMatrix(sc, 1, 0, this._cachedClippingPlane, !0);
                            }
                            calculateFogMatrix(le1) {
                                vt.w("calculateFogMatrix is not supported on globe projection.");
                                const bt = vt.bk();
                                return vt.ar(bt), bt;
                            }
                            getVisibleUnwrappedCoordinates(le1) {
                                return [
                                    new vt.bc(0, le1)
                                ];
                            }
                            getCameraFrustum() {
                                return this._cachedFrustum;
                            }
                            getClippingPlane() {
                                return this._cachedClippingPlane;
                            }
                            getCoveringTilesDetailsProvider() {
                                return this._coveringTilesDetailsProvider;
                            }
                            recalculateZoomAndCenter(le1) {
                                le1 && vt.w("terrain is not fully supported on vertical perspective projection."), this._helper.recalculateZoomAndCenter(0);
                            }
                            maxPitchScaleFactor() {
                                return 1;
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                return this._helper.getCameraLngLat();
                            }
                            lngLatToCameraDepth(le1, bt) {
                                if (!this._globeViewProjMatrixNoCorrection) return 1;
                                const ls = mi(le1);
                                vt.a$(ls, ls, 1 + bt / vt.bE);
                                const ho = vt.bF();
                                return vt.aH(ho, [
                                    ls[0],
                                    ls[1],
                                    ls[2],
                                    1
                                ], this._globeViewProjMatrixNoCorrection), ho[2] / ho[3];
                            }
                            populateCache(le1) {}
                            getBounds() {
                                const le1 = .5 * this.width, bt = .5 * this.height, ls = [
                                    new vt.P(0, 0),
                                    new vt.P(le1, 0),
                                    new vt.P(this.width, 0),
                                    new vt.P(this.width, bt),
                                    new vt.P(this.width, this.height),
                                    new vt.P(le1, this.height),
                                    new vt.P(0, this.height),
                                    new vt.P(0, bt)
                                ], ho = [];
                                for (const vt of ls)ho.push(this.unprojectScreenPoint(vt));
                                let Dl = 0, Fl = 0, sc = 0, uc = 0;
                                const mc = this.center;
                                for (const Ac of ho){
                                    const le1 = vt.bK(mc.lng, Ac.lng), bt = vt.bK(mc.lat, Ac.lat);
                                    le1 < Fl && (Fl = le1), le1 > Dl && (Dl = le1), bt < uc && (uc = bt), bt > sc && (sc = bt);
                                }
                                const gc = [
                                    mc.lng + Fl,
                                    mc.lat + uc,
                                    mc.lng + Dl,
                                    mc.lat + sc
                                ];
                                return this.isSurfacePointOnScreen([
                                    0,
                                    1,
                                    0
                                ]) && (gc[3] = 90, gc[0] = -180, gc[2] = 180), this.isSurfacePointOnScreen([
                                    0,
                                    -1,
                                    0
                                ]) && (gc[1] = -90, gc[0] = -180, gc[2] = 180), new $(gc);
                            }
                            calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls);
                            }
                            setLocationAtPoint(le1, bt) {
                                const ls = mi(this.unprojectScreenPoint(bt)), ho = mi(le1), Dl = vt.bA();
                                vt.bL(Dl);
                                const Fl = vt.bA();
                                vt.bI(Fl, ls, Dl, -this.center.lng * Math.PI / 180), vt.bH(Fl, Fl, Dl, this.center.lat * Math.PI / 180);
                                const sc = ho[0] * ho[0] + ho[2] * ho[2], uc = Fl[0] * Fl[0];
                                if (sc < uc) return;
                                const mc = Math.sqrt(sc - uc), gc = -mc, Ac = vt.bM(ho[0], ho[2], Fl[0], mc), Ec = vt.bM(ho[0], ho[2], Fl[0], gc), kc = vt.bA();
                                vt.bI(kc, ho, Dl, -Ac);
                                const du = vt.bM(kc[1], kc[2], Fl[1], Fl[2]), _u = vt.bA();
                                vt.bI(_u, ho, Dl, -Ec);
                                const Md = vt.bM(_u[1], _u[2], Fl[1], Fl[2]), Ld = .5 * Math.PI, Nd = du >= -Ld && du <= Ld, Rd = Md >= -Ld && Md <= Ld;
                                let Od, jd;
                                if (Nd && Rd) {
                                    const le1 = this.center.lng * Math.PI / 180, bt = this.center.lat * Math.PI / 180;
                                    vt.bN(Ac, le1) + vt.bN(du, bt) < vt.bN(Ec, le1) + vt.bN(Md, bt) ? (Od = Ac, jd = du) : (Od = Ec, jd = Md);
                                } else if (Nd) Od = Ac, jd = du;
                                else {
                                    if (!Rd) return;
                                    Od = Ec, jd = Md;
                                }
                                const Ud = Od / Math.PI * 180, Gd = jd / Math.PI * 180, qd = this.center.lat;
                                this.setCenter(new vt.V(Ud, vt.an(Gd, -90, 90))), this.setZoom(this.zoom + xi(qd, this.center.lat));
                            }
                            locationToScreenPoint(le1, bt) {
                                const ls = mi(le1);
                                if (bt) {
                                    const ho = bt.getElevationForLngLatZoom(le1, this._helper._tileZoom);
                                    vt.a$(ls, ls, 1 + ho / vt.bE);
                                }
                                return this._projectSurfacePointToScreen(ls);
                            }
                            _projectSurfacePointToScreen(le1) {
                                const bt = vt.bF();
                                return vt.aH(bt, [
                                    ...le1,
                                    1
                                ], this._globeViewProjMatrixNoCorrection), bt[0] /= bt[3], bt[1] /= bt[3], new vt.P((.5 * bt[0] + .5) * this.width, (.5 * -bt[1] + .5) * this.height);
                            }
                            screenPointToMercatorCoordinate(le1, bt) {
                                if (bt) {
                                    const vt = bt.pointCoordinate(le1);
                                    if (vt) return vt;
                                }
                                return vt.a9.fromLngLat(this.unprojectScreenPoint(le1));
                            }
                            screenPointToLocation(le1, vt) {
                                var bt;
                                return null === (bt = this.screenPointToMercatorCoordinate(le1, vt)) || void 0 === bt ? void 0 : bt.toLngLat();
                            }
                            isPointOnMapSurface(le1, vt) {
                                const bt = this._cameraPosition, ls = this.getRayDirectionFromPixel(le1);
                                return !!this.rayPlanetIntersection(bt, ls);
                            }
                            getRayDirectionFromPixel(le1) {
                                const bt = vt.bF();
                                bt[0] = le1.x / this.width * 2 - 1, bt[1] = -1 * (le1.y / this.height * 2 - 1), bt[2] = 1, bt[3] = 1, vt.aH(bt, bt, this._globeViewProjMatrixNoCorrectionInverted), bt[0] /= bt[3], bt[1] /= bt[3], bt[2] /= bt[3];
                                const ls = vt.bA();
                                ls[0] = bt[0] - this._cameraPosition[0], ls[1] = bt[1] - this._cameraPosition[1], ls[2] = bt[2] - this._cameraPosition[2];
                                const ho = vt.bA();
                                return vt.b3(ho, ls), ho;
                            }
                            isSurfacePointVisible(le1) {
                                const vt = this._cachedClippingPlane;
                                return vt[0] * le1[0] + vt[1] * le1[1] + vt[2] * le1[2] + vt[3] >= 0;
                            }
                            isSurfacePointOnScreen(le1) {
                                if (!this.isSurfacePointVisible(le1)) return !1;
                                const bt = vt.bF();
                                return vt.aH(bt, [
                                    ...le1,
                                    1
                                ], this._globeViewProjMatrixNoCorrection), bt[0] /= bt[3], bt[1] /= bt[3], bt[2] /= bt[3], bt[0] > -1 && bt[0] < 1 && bt[1] > -1 && bt[1] < 1 && bt[2] > -1 && bt[2] < 1;
                            }
                            rayPlanetIntersection(le1, bt) {
                                const ls = vt.b5(le1, bt), ho = vt.bA(), Dl = vt.bA();
                                vt.a$(Dl, bt, ls), vt.b2(ho, le1, Dl);
                                const Fl = 1 - vt.b5(ho, ho);
                                if (Fl < 0) return null;
                                const sc = vt.b5(le1, le1) - 1, uc = -ls + (ls < 0 ? 1 : -1) * Math.sqrt(Fl), mc = sc / uc, gc = uc;
                                return {
                                    tMin: Math.min(mc, gc),
                                    tMax: Math.max(mc, gc)
                                };
                            }
                            unprojectScreenPoint(le1) {
                                const bt = this._cameraPosition, ls = this.getRayDirectionFromPixel(le1), ho = this.rayPlanetIntersection(bt, ls);
                                if (ho) {
                                    const le1 = vt.bA();
                                    vt.b0(le1, bt, [
                                        ls[0] * ho.tMin,
                                        ls[1] * ho.tMin,
                                        ls[2] * ho.tMin
                                    ]);
                                    const Dl = vt.bA();
                                    return vt.b3(Dl, le1), gi(Dl);
                                }
                                const Dl = this._cachedClippingPlane, Fl = Dl[0] * ls[0] + Dl[1] * ls[1] + Dl[2] * ls[2], sc = -vt.bb(Dl, bt) / Fl, uc = vt.bA();
                                if (sc > 0) vt.b0(uc, bt, [
                                    ls[0] * sc,
                                    ls[1] * sc,
                                    ls[2] * sc
                                ]);
                                else {
                                    const le1 = vt.bA();
                                    vt.b0(le1, bt, [
                                        2 * ls[0],
                                        2 * ls[1],
                                        2 * ls[2]
                                    ]);
                                    const ho = vt.bb(this._cachedClippingPlane, le1);
                                    vt.b2(uc, le1, [
                                        this._cachedClippingPlane[0] * ho,
                                        this._cachedClippingPlane[1] * ho,
                                        this._cachedClippingPlane[2] * ho
                                    ]);
                                }
                                const mc = function(le1) {
                                    const bt = vt.bA();
                                    return bt[0] = le1[0] * -le1[3], bt[1] = le1[1] * -le1[3], bt[2] = le1[2] * -le1[3], {
                                        center: bt,
                                        radius: Math.sqrt(1 - le1[3] * le1[3])
                                    };
                                }(Dl);
                                return gi(function(le1, bt, ls) {
                                    const ho = vt.bA();
                                    vt.b2(ho, ls, le1);
                                    const Dl = vt.bA();
                                    return vt.by(Dl, le1, ho, bt / vt.b9(ho)), Dl;
                                }(mc.center, mc.radius, uc));
                            }
                            getMatrixForModel(le1, bt) {
                                const ls = vt.V.convert(le1), ho = 1 / vt.bE, Dl = vt.bj();
                                return vt.bJ(Dl, Dl, ls.lng / 180 * Math.PI), vt.bh(Dl, Dl, -ls.lat / 180 * Math.PI), vt.O(Dl, Dl, [
                                    0,
                                    0,
                                    1 + bt / vt.bE
                                ]), vt.bh(Dl, Dl, .5 * Math.PI), vt.Q(Dl, Dl, [
                                    ho,
                                    ho,
                                    ho
                                ]), Dl;
                            }
                            getProjectionDataForCustomLayer(le1 = !0) {
                                const bt = this.getProjectionData({
                                    overscaledTileID: new vt.a2(0, 0, 0, 0, 0),
                                    applyGlobeMatrix: le1
                                });
                                return bt.tileMercatorCoords = [
                                    0,
                                    0,
                                    1,
                                    1
                                ], bt;
                            }
                            getFastPathSimpleProjectionMatrix(le1) {}
                        }
                        class zi {
                            get pixelsToClipSpaceMatrix() {
                                return this._helper.pixelsToClipSpaceMatrix;
                            }
                            get clipSpaceToPixelsMatrix() {
                                return this._helper.clipSpaceToPixelsMatrix;
                            }
                            get pixelsToGLUnits() {
                                return this._helper.pixelsToGLUnits;
                            }
                            get centerOffset() {
                                return this._helper.centerOffset;
                            }
                            get size() {
                                return this._helper.size;
                            }
                            get rotationMatrix() {
                                return this._helper.rotationMatrix;
                            }
                            get centerPoint() {
                                return this._helper.centerPoint;
                            }
                            get pixelsPerMeter() {
                                return this._helper.pixelsPerMeter;
                            }
                            setMinZoom(le1) {
                                this._helper.setMinZoom(le1);
                            }
                            setMaxZoom(le1) {
                                this._helper.setMaxZoom(le1);
                            }
                            setMinPitch(le1) {
                                this._helper.setMinPitch(le1);
                            }
                            setMaxPitch(le1) {
                                this._helper.setMaxPitch(le1);
                            }
                            setRenderWorldCopies(le1) {
                                this._helper.setRenderWorldCopies(le1);
                            }
                            setBearing(le1) {
                                this._helper.setBearing(le1);
                            }
                            setPitch(le1) {
                                this._helper.setPitch(le1);
                            }
                            setRoll(le1) {
                                this._helper.setRoll(le1);
                            }
                            setFov(le1) {
                                this._helper.setFov(le1);
                            }
                            setZoom(le1) {
                                this._helper.setZoom(le1);
                            }
                            setCenter(le1) {
                                this._helper.setCenter(le1);
                            }
                            setElevation(le1) {
                                this._helper.setElevation(le1);
                            }
                            setMinElevationForCurrentTile(le1) {
                                this._helper.setMinElevationForCurrentTile(le1);
                            }
                            setPadding(le1) {
                                this._helper.setPadding(le1);
                            }
                            interpolatePadding(le1, vt, bt) {
                                return this._helper.interpolatePadding(le1, vt, bt);
                            }
                            isPaddingEqual(le1) {
                                return this._helper.isPaddingEqual(le1);
                            }
                            resize(le1, vt, bt = !0) {
                                this._helper.resize(le1, vt, bt);
                            }
                            getMaxBounds() {
                                return this._helper.getMaxBounds();
                            }
                            setMaxBounds(le1) {
                                this._helper.setMaxBounds(le1);
                            }
                            setConstrainOverride(le1) {
                                this._helper.setConstrainOverride(le1);
                            }
                            overrideNearFarZ(le1, vt) {
                                this._helper.overrideNearFarZ(le1, vt);
                            }
                            clearNearFarZOverride() {
                                this._helper.clearNearFarZOverride();
                            }
                            getCameraQueryGeometry(le1) {
                                return this._helper.getCameraQueryGeometry(this.getCameraPoint(), le1);
                            }
                            get tileSize() {
                                return this._helper.tileSize;
                            }
                            get tileZoom() {
                                return this._helper.tileZoom;
                            }
                            get scale() {
                                return this._helper.scale;
                            }
                            get worldSize() {
                                return this._helper.worldSize;
                            }
                            get width() {
                                return this._helper.width;
                            }
                            get height() {
                                return this._helper.height;
                            }
                            get lngRange() {
                                return this._helper.lngRange;
                            }
                            get latRange() {
                                return this._helper.latRange;
                            }
                            get minZoom() {
                                return this._helper.minZoom;
                            }
                            get maxZoom() {
                                return this._helper.maxZoom;
                            }
                            get zoom() {
                                return this._helper.zoom;
                            }
                            get center() {
                                return this._helper.center;
                            }
                            get minPitch() {
                                return this._helper.minPitch;
                            }
                            get maxPitch() {
                                return this._helper.maxPitch;
                            }
                            get pitch() {
                                return this._helper.pitch;
                            }
                            get pitchInRadians() {
                                return this._helper.pitchInRadians;
                            }
                            get roll() {
                                return this._helper.roll;
                            }
                            get rollInRadians() {
                                return this._helper.rollInRadians;
                            }
                            get bearing() {
                                return this._helper.bearing;
                            }
                            get bearingInRadians() {
                                return this._helper.bearingInRadians;
                            }
                            get fov() {
                                return this._helper.fov;
                            }
                            get fovInRadians() {
                                return this._helper.fovInRadians;
                            }
                            get elevation() {
                                return this._helper.elevation;
                            }
                            get minElevationForCurrentTile() {
                                return this._helper.minElevationForCurrentTile;
                            }
                            get padding() {
                                return this._helper.padding;
                            }
                            get unmodified() {
                                return this._helper.unmodified;
                            }
                            get renderWorldCopies() {
                                return this._helper.renderWorldCopies;
                            }
                            get cameraToCenterDistance() {
                                return this._helper.cameraToCenterDistance;
                            }
                            get constrainOverride() {
                                return this._helper.constrainOverride;
                            }
                            get nearZ() {
                                return this._helper.nearZ;
                            }
                            get farZ() {
                                return this._helper.farZ;
                            }
                            get autoCalculateNearFarZ() {
                                return this._helper.autoCalculateNearFarZ;
                            }
                            get isGlobeRendering() {
                                return this._globeness > 0;
                            }
                            setTransitionState(le1, vt) {
                                this._globeness = le1, this._globeLatitudeErrorCorrectionRadians = vt, this._calcMatrices(), this._verticalPerspectiveTransform.getCoveringTilesDetailsProvider().prepareNextFrame(), this._mercatorTransform.getCoveringTilesDetailsProvider().prepareNextFrame();
                            }
                            get currentTransform() {
                                return this.isGlobeRendering ? this._verticalPerspectiveTransform : this._mercatorTransform;
                            }
                            constructor(le1){
                                this._globeLatitudeErrorCorrectionRadians = 0, this._globeness = 1, this.defaultConstrain = (le1, vt)=>this.currentTransform.defaultConstrain(le1, vt), this.applyConstrain = (le1, vt)=>this._helper.applyConstrain(le1, vt), this._helper = new Gt({
                                    calcMatrices: ()=>{
                                        this._calcMatrices();
                                    },
                                    defaultConstrain: (le1, vt)=>this.defaultConstrain(le1, vt)
                                }, le1), this._globeness = 1, this._mercatorTransform = new $t, this._verticalPerspectiveTransform = new Si;
                            }
                            clone() {
                                const le1 = new zi;
                                return le1._globeness = this._globeness, le1._globeLatitudeErrorCorrectionRadians = this._globeLatitudeErrorCorrectionRadians, le1.apply(this, !1), le1;
                            }
                            apply(le1, vt) {
                                this._helper.apply(le1, vt), this._mercatorTransform.apply(this, !1), this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians);
                            }
                            get projectionMatrix() {
                                return this.currentTransform.projectionMatrix;
                            }
                            get modelViewProjectionMatrix() {
                                return this.currentTransform.modelViewProjectionMatrix;
                            }
                            get inverseProjectionMatrix() {
                                return this.currentTransform.inverseProjectionMatrix;
                            }
                            get cameraPosition() {
                                return this.currentTransform.cameraPosition;
                            }
                            getProjectionData(le1) {
                                const vt = this._mercatorTransform.getProjectionData(le1), bt = this._verticalPerspectiveTransform.getProjectionData(le1);
                                return {
                                    mainMatrix: this.isGlobeRendering ? bt.mainMatrix : vt.mainMatrix,
                                    clippingPlane: bt.clippingPlane,
                                    tileMercatorCoords: bt.tileMercatorCoords,
                                    projectionTransition: le1.applyGlobeMatrix ? this._globeness : 0,
                                    fallbackMatrix: vt.fallbackMatrix
                                };
                            }
                            isLocationOccluded(le1) {
                                return this.currentTransform.isLocationOccluded(le1);
                            }
                            transformLightDirection(le1) {
                                return this.currentTransform.transformLightDirection(le1);
                            }
                            getPixelScale() {
                                return vt.bu(this._mercatorTransform.getPixelScale(), this._verticalPerspectiveTransform.getPixelScale(), this._globeness);
                            }
                            getCircleRadiusCorrection() {
                                return vt.bu(this._mercatorTransform.getCircleRadiusCorrection(), this._verticalPerspectiveTransform.getCircleRadiusCorrection(), this._globeness);
                            }
                            getPitchedTextCorrection(le1, bt, ls) {
                                const ho = this._mercatorTransform.getPitchedTextCorrection(le1, bt, ls), Dl = this._verticalPerspectiveTransform.getPitchedTextCorrection(le1, bt, ls);
                                return vt.bu(ho, Dl, this._globeness);
                            }
                            projectTileCoordinates(le1, vt, bt, ls) {
                                return this.currentTransform.projectTileCoordinates(le1, vt, bt, ls);
                            }
                            _calcMatrices() {
                                this._helper._width && this._helper._height && (this._verticalPerspectiveTransform.apply(this, !1, this._globeLatitudeErrorCorrectionRadians), this._helper._nearZ = this._verticalPerspectiveTransform.nearZ, this._helper._farZ = this._verticalPerspectiveTransform.farZ, this._mercatorTransform.apply(this, !0, this.isGlobeRendering), this._helper._nearZ = this._mercatorTransform.nearZ, this._helper._farZ = this._mercatorTransform.farZ);
                            }
                            calculateFogMatrix(le1) {
                                return this.currentTransform.calculateFogMatrix(le1);
                            }
                            getVisibleUnwrappedCoordinates(le1) {
                                return this.currentTransform.getVisibleUnwrappedCoordinates(le1);
                            }
                            getCameraFrustum() {
                                return this.currentTransform.getCameraFrustum();
                            }
                            getClippingPlane() {
                                return this.currentTransform.getClippingPlane();
                            }
                            getCoveringTilesDetailsProvider() {
                                return this.currentTransform.getCoveringTilesDetailsProvider();
                            }
                            recalculateZoomAndCenter(le1) {
                                this._mercatorTransform.recalculateZoomAndCenter(le1), this._verticalPerspectiveTransform.recalculateZoomAndCenter(le1);
                            }
                            maxPitchScaleFactor() {
                                return this._mercatorTransform.maxPitchScaleFactor();
                            }
                            getCameraPoint() {
                                return this._helper.getCameraPoint();
                            }
                            getCameraAltitude() {
                                return this._helper.getCameraAltitude();
                            }
                            getCameraLngLat() {
                                return this._helper.getCameraLngLat();
                            }
                            lngLatToCameraDepth(le1, vt) {
                                return this.currentTransform.lngLatToCameraDepth(le1, vt);
                            }
                            populateCache(le1) {
                                this._mercatorTransform.populateCache(le1), this._verticalPerspectiveTransform.populateCache(le1);
                            }
                            getBounds() {
                                return this.currentTransform.getBounds();
                            }
                            calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls) {
                                return this._helper.calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls);
                            }
                            setLocationAtPoint(le1, vt) {
                                if (!this.isGlobeRendering) return this._mercatorTransform.setLocationAtPoint(le1, vt), void this.apply(this._mercatorTransform, !1);
                                this._verticalPerspectiveTransform.setLocationAtPoint(le1, vt), this.apply(this._verticalPerspectiveTransform, !1);
                            }
                            locationToScreenPoint(le1, vt) {
                                return this.currentTransform.locationToScreenPoint(le1, vt);
                            }
                            screenPointToMercatorCoordinate(le1, vt) {
                                return this.currentTransform.screenPointToMercatorCoordinate(le1, vt);
                            }
                            screenPointToLocation(le1, vt) {
                                return this.currentTransform.screenPointToLocation(le1, vt);
                            }
                            isPointOnMapSurface(le1, vt) {
                                return this.currentTransform.isPointOnMapSurface(le1, vt);
                            }
                            getRayDirectionFromPixel(le1) {
                                return this._verticalPerspectiveTransform.getRayDirectionFromPixel(le1);
                            }
                            getMatrixForModel(le1, vt) {
                                return this.currentTransform.getMatrixForModel(le1, vt);
                            }
                            getProjectionDataForCustomLayer(le1 = !0) {
                                const vt = this._mercatorTransform.getProjectionDataForCustomLayer(le1);
                                if (!this.isGlobeRendering) return vt;
                                const bt = this._verticalPerspectiveTransform.getProjectionDataForCustomLayer(le1);
                                return bt.fallbackMatrix = vt.mainMatrix, bt;
                            }
                            getFastPathSimpleProjectionMatrix(le1) {
                                return this.currentTransform.getFastPathSimpleProjectionMatrix(le1);
                            }
                        }
                        class Ri {
                            get useGlobeControls() {
                                return !0;
                            }
                            handlePanInertia(le1, bt) {
                                const ls = bi(le1, bt);
                                return Math.abs(ls.lng - bt.center.lng) > 180 && (ls.lng = bt.center.lng + 179.5 * Math.sign(ls.lng - bt.center.lng)), {
                                    easingCenter: ls,
                                    easingOffset: new vt.P(0, 0)
                                };
                            }
                            handleMapControlsRollPitchBearingZoom(le1, bt) {
                                const ls = le1.around, ho = bt.screenPointToLocation(ls);
                                le1.bearingDelta && bt.setBearing(bt.bearing + le1.bearingDelta), le1.pitchDelta && bt.setPitch(bt.pitch + le1.pitchDelta), le1.rollDelta && bt.setRoll(bt.roll + le1.rollDelta);
                                const Dl = bt.zoom;
                                le1.zoomDelta && bt.setZoom(bt.zoom + le1.zoomDelta);
                                const Fl = bt.zoom - Dl;
                                if (0 === Fl) return;
                                const sc = vt.bK(bt.center.lng, ho.lng), uc = sc / (Math.abs(sc / 180) + 1), mc = vt.bK(bt.center.lat, ho.lat), gc = bt.getRayDirectionFromPixel(ls), Ac = bt.cameraPosition, Ec = -1 * vt.b5(Ac, gc), kc = vt.bA();
                                vt.b0(kc, Ac, [
                                    gc[0] * Ec,
                                    gc[1] * Ec,
                                    gc[2] * Ec
                                ]);
                                const du = vt.b7(kc) - 1, _u = Math.exp(.5 * -Math.max(du - .3, 0)), Md = fi(bt.worldSize, bt.center.lat) / Math.min(bt.width, bt.height), Ld = vt.bx(Md, .9, .5, 1, .25), Nd = (1 - vt.aq(-Fl)) * Math.min(_u, Ld), Rd = bt.center.lat, Od = bt.zoom, jd = new vt.V(bt.center.lng + uc * Nd, vt.an(bt.center.lat + mc * Nd, -vt.ao, vt.ao));
                                bt.setLocationAtPoint(ho, ls);
                                const Ud = bt.center, Gd = vt.bx(Math.abs(sc), 45, 85, 0, 1), qd = vt.bx(Md, .75, .35, 0, 1), Hd = Math.pow(Math.max(Gd, qd), .25), Wd = vt.bK(Ud.lng, jd.lng), Zd = vt.bK(Ud.lat, jd.lat);
                                bt.setCenter(new vt.V(Ud.lng + Wd * Hd, Ud.lat + Zd * Hd).wrap()), bt.setZoom(Od + xi(Rd, bt.center.lat));
                            }
                            handleMapControlsPan(le1, vt, bt) {
                                if (!le1.panDelta) return;
                                const ls = vt.center.lat, ho = vt.zoom;
                                vt.setCenter(bi(le1.panDelta, vt).wrap()), vt.setZoom(ho + xi(ls, vt.center.lat));
                            }
                            cameraForBoxAndBearing(le1, bt, ls, ho, Dl) {
                                const Fl = Kt(le1, bt, ls, ho, Dl), sc = bt.left / Dl.width * 2 - 1, uc = (Dl.width - bt.right) / Dl.width * 2 - 1, mc = bt.top / Dl.height * -2 + 1, gc = (Dl.height - bt.bottom) / Dl.height * -2 + 1, Ac = vt.bK(ls.getWest(), ls.getEast()) < 0, Ec = Ac ? ls.getEast() : ls.getWest(), kc = Ac ? ls.getWest() : ls.getEast(), du = Math.max(ls.getNorth(), ls.getSouth()), _u = Math.min(ls.getNorth(), ls.getSouth()), Md = Ec + .5 * vt.bK(Ec, kc), Ld = du + .5 * vt.bK(du, _u), Nd = Dl.clone();
                                Nd.setCenter(Fl.center), Nd.setBearing(Fl.bearing), Nd.setPitch(0), Nd.setRoll(0), Nd.setZoom(Fl.zoom);
                                const Rd = Nd.modelViewProjectionMatrix, Od = [
                                    mi(ls.getNorthWest()),
                                    mi(ls.getNorthEast()),
                                    mi(ls.getSouthWest()),
                                    mi(ls.getSouthEast()),
                                    mi(new vt.V(kc, Ld)),
                                    mi(new vt.V(Ec, Ld)),
                                    mi(new vt.V(Md, du)),
                                    mi(new vt.V(Md, _u))
                                ], jd = mi(Fl.center);
                                let Ud = Number.POSITIVE_INFINITY;
                                for (const vt of Od)sc < 0 && (Ud = Ri.getLesserNonNegativeNonNull(Ud, Ri.solveVectorScale(vt, jd, Rd, "x", sc))), uc > 0 && (Ud = Ri.getLesserNonNegativeNonNull(Ud, Ri.solveVectorScale(vt, jd, Rd, "x", uc))), mc > 0 && (Ud = Ri.getLesserNonNegativeNonNull(Ud, Ri.solveVectorScale(vt, jd, Rd, "y", mc))), gc < 0 && (Ud = Ri.getLesserNonNegativeNonNull(Ud, Ri.solveVectorScale(vt, jd, Rd, "y", gc)));
                                if (Number.isFinite(Ud) && 0 !== Ud) return Fl.zoom = Nd.zoom + vt.at(Ud), Fl;
                                Ht();
                            }
                            handleJumpToCenterZoom(le1, bt) {
                                const ls = le1.center.lat, ho = le1.applyConstrain(bt.center ? vt.V.convert(bt.center) : le1.center, le1.zoom).center;
                                le1.setCenter(ho.wrap());
                                const Dl = void 0 !== bt.zoom ? +bt.zoom : le1.zoom + xi(ls, ho.lat);
                                le1.zoom !== Dl && le1.setZoom(Dl);
                            }
                            handleEaseTo(le1, bt) {
                                const ls = le1.zoom, ho = le1.center, Dl = le1.padding, Fl = {
                                    roll: le1.roll,
                                    pitch: le1.pitch,
                                    bearing: le1.bearing
                                }, sc = {
                                    roll: void 0 === bt.roll ? le1.roll : bt.roll,
                                    pitch: void 0 === bt.pitch ? le1.pitch : bt.pitch,
                                    bearing: void 0 === bt.bearing ? le1.bearing : bt.bearing
                                }, uc = void 0 !== bt.zoom, mc = !le1.isPaddingEqual(bt.padding);
                                let gc = !1;
                                const Ac = bt.center ? vt.V.convert(bt.center) : ho, Ec = le1.applyConstrain(Ac, ls).center;
                                Zt(le1, Ec);
                                const kc = le1.clone();
                                kc.setCenter(Ec), kc.setZoom(uc ? +bt.zoom : ls + xi(ho.lat, Ac.lat)), kc.setBearing(bt.bearing);
                                const du = new vt.P(vt.an(le1.centerPoint.x + bt.offsetAsPoint.x, 0, le1.width), vt.an(le1.centerPoint.y + bt.offsetAsPoint.y, 0, le1.height));
                                kc.setLocationAtPoint(Ec, du);
                                const _u = (bt.offset && bt.offsetAsPoint.mag()) > 0 ? kc.center : Ec, Md = uc ? +bt.zoom : ls + xi(ho.lat, _u.lat), Ld = ls + xi(ho.lat, 0), Nd = Md + xi(_u.lat, 0), Rd = vt.bK(ho.lng, _u.lng), Od = vt.bK(ho.lat, _u.lat), jd = vt.aq(Nd - Ld);
                                return gc = Md !== ls, {
                                    easeFunc: (ls)=>{
                                        if (vt.bo(Fl, sc) || Xt({
                                            startEulerAngles: Fl,
                                            endEulerAngles: sc,
                                            tr: le1,
                                            k: ls,
                                            useSlerp: Fl.roll != sc.roll
                                        }), mc && le1.interpolatePadding(Dl, bt.padding, ls), bt.around) vt.w("Easing around a point is not supported under globe projection."), le1.setLocationAtPoint(bt.around, bt.aroundPoint);
                                        else {
                                            const vt = Nd > Ld ? Math.min(2, jd) : Math.max(.5, jd), bt = Math.pow(vt, 1 - ls), Dl = wi(ho, Rd, Od, ls * bt);
                                            le1.setCenter(Dl.wrap());
                                        }
                                        if (gc) {
                                            const bt = vt.G.number(Ld, Nd, ls) + xi(0, le1.center.lat);
                                            le1.setZoom(bt);
                                        }
                                    },
                                    isZooming: gc,
                                    elevationCenter: _u
                                };
                            }
                            handleFlyTo(le1, bt) {
                                const ls = void 0 !== bt.zoom, ho = le1.center, Dl = le1.zoom, Fl = le1.padding, sc = !le1.isPaddingEqual(bt.padding), uc = le1.applyConstrain(vt.V.convert(bt.center || bt.locationAtOffset), Dl).center, mc = ls ? +bt.zoom : le1.zoom + xi(le1.center.lat, uc.lat), gc = le1.clone();
                                gc.setCenter(uc), gc.setZoom(mc), gc.setBearing(bt.bearing);
                                const Ac = new vt.P(vt.an(le1.centerPoint.x + bt.offsetAsPoint.x, 0, le1.width), vt.an(le1.centerPoint.y + bt.offsetAsPoint.y, 0, le1.height));
                                gc.setLocationAtPoint(uc, Ac);
                                const Ec = gc.center;
                                Zt(le1, Ec);
                                const kc = function(le1, bt, ls) {
                                    const ho = mi(bt), Dl = mi(ls), Fl = vt.b5(ho, Dl), sc = Math.acos(Fl), uc = _i(le1);
                                    return sc / (2 * Math.PI) * uc;
                                }(le1, ho, Ec), du = Dl + xi(ho.lat, 0), _u = mc + xi(Ec.lat, 0), Md = vt.aq(_u - du);
                                let Ld;
                                if ("number" == typeof bt.minZoom) {
                                    const ls = +bt.minZoom + xi(Ec.lat, 0), ho = Math.min(ls, du, _u) + xi(0, Ec.lat), Dl = le1.applyConstrain(Ec, ho).zoom + xi(Ec.lat, 0);
                                    Ld = vt.aq(Dl - du);
                                }
                                const Nd = vt.bK(ho.lng, Ec.lng), Rd = vt.bK(ho.lat, Ec.lat);
                                return {
                                    easeFunc: (ls, Dl, uc, gc)=>{
                                        const Ac = wi(ho, Nd, Rd, uc);
                                        sc && le1.interpolatePadding(Fl, bt.padding, ls);
                                        const kc = 1 === ls ? Ec : Ac;
                                        le1.setCenter(kc.wrap());
                                        const _u = du + vt.at(Dl);
                                        le1.setZoom(1 === ls ? mc : _u + xi(0, kc.lat));
                                    },
                                    scaleOfZoom: Md,
                                    targetCenter: Ec,
                                    scaleOfMinZoom: Ld,
                                    pixelPathLength: kc
                                };
                            }
                            static solveVectorScale(le1, vt, bt, ls, ho) {
                                const Dl = "x" === ls ? [
                                    bt[0],
                                    bt[4],
                                    bt[8],
                                    bt[12]
                                ] : [
                                    bt[1],
                                    bt[5],
                                    bt[9],
                                    bt[13]
                                ], Fl = [
                                    bt[3],
                                    bt[7],
                                    bt[11],
                                    bt[15]
                                ], sc = le1[0] * Dl[0] + le1[1] * Dl[1] + le1[2] * Dl[2], uc = le1[0] * Fl[0] + le1[1] * Fl[1] + le1[2] * Fl[2], mc = vt[0] * Dl[0] + vt[1] * Dl[1] + vt[2] * Dl[2], gc = vt[0] * Fl[0] + vt[1] * Fl[1] + vt[2] * Fl[2];
                                return mc + ho * uc === sc + ho * gc || Fl[3] * (sc - mc) + Dl[3] * (gc - uc) + sc * gc == mc * uc ? null : (mc + Dl[3] - ho * gc - ho * Fl[3]) / (mc - sc - ho * gc + ho * uc);
                            }
                            static getLesserNonNegativeNonNull(le1, vt) {
                                return null !== vt && vt >= 0 && vt < le1 ? vt : le1;
                            }
                        }
                        class Di {
                            constructor(le1){
                                this._globe = le1, this._mercatorCameraHelper = new Yt, this._verticalPerspectiveCameraHelper = new Ri;
                            }
                            get useGlobeControls() {
                                return this._globe.useGlobeRendering;
                            }
                            get currentHelper() {
                                return this.useGlobeControls ? this._verticalPerspectiveCameraHelper : this._mercatorCameraHelper;
                            }
                            handlePanInertia(le1, vt) {
                                return this.currentHelper.handlePanInertia(le1, vt);
                            }
                            handleMapControlsRollPitchBearingZoom(le1, vt) {
                                return this.currentHelper.handleMapControlsRollPitchBearingZoom(le1, vt);
                            }
                            handleMapControlsPan(le1, vt, bt) {
                                this.currentHelper.handleMapControlsPan(le1, vt, bt);
                            }
                            cameraForBoxAndBearing(le1, vt, bt, ls, ho) {
                                return this.currentHelper.cameraForBoxAndBearing(le1, vt, bt, ls, ho);
                            }
                            handleJumpToCenterZoom(le1, vt) {
                                this.currentHelper.handleJumpToCenterZoom(le1, vt);
                            }
                            handleEaseTo(le1, vt) {
                                return this.currentHelper.handleEaseTo(le1, vt);
                            }
                            handleFlyTo(le1, vt) {
                                return this.currentHelper.handleFlyTo(le1, vt);
                            }
                        }
                        const Ai = (le1, bt)=>vt.B(le1, bt && bt.filter((le1)=>"source.canvas" !== le1.identifier)), Am = vt.bO();
                        class ki extends vt.E {
                            constructor(le1, bt = {}){
                                var ls, ho;
                                super(), this._rtlPluginLoaded = ()=>{
                                    for(const le1 in this.tileManagers){
                                        const vt = this.tileManagers[le1].getSource().type;
                                        "vector" !== vt && "geojson" !== vt || this.tileManagers[le1].reload();
                                    }
                                }, this.map = le1, this.dispatcher = new N(j(), le1._getMapId()), this.dispatcher.registerMessageHandler("GG", (le1, vt)=>this.getGlyphs(le1, vt)), this.dispatcher.registerMessageHandler("GI", (le1, vt)=>this.getImages(le1, vt)), this.dispatcher.registerMessageHandler("GDA", (le1, vt)=>this.getDashes(le1, vt)), this.imageManager = new w, this.imageManager.setEventedParent(this);
                                const Dl = (null === (ls = le1._container) || void 0 === ls ? void 0 : ls.lang) || "undefined" != typeof document && (null === (ho = document.documentElement) || void 0 === ho ? void 0 : ho.lang) || void 0;
                                this.glyphManager = new M(le1._requestManager, bt.localIdeographFontFamily, Dl), this.lineAtlas = new A(256, 512), this.crossTileSymbolIndex = new Rt, this._setInitialValues(), this._resetUpdates(), this.dispatcher.broadcast("SR", vt.bP()), ce().on(Gd, this._rtlPluginLoaded), this.on("data", (le1)=>{
                                    if ("source" !== le1.dataType || "metadata" !== le1.sourceDataType) return;
                                    const vt = this.tileManagers[le1.sourceId];
                                    if (!vt) return;
                                    const bt = vt.getSource();
                                    if (bt && bt.vectorLayerIds) for(const ls in this._layers){
                                        const le1 = this._layers[ls];
                                        le1.source === bt.id && this._validateLayer(le1);
                                    }
                                });
                            }
                            _setInitialValues() {
                                var le1;
                                this._spritesImagesIds = {}, this._layers = {}, this._order = [], this.tileManagers = {}, this.zoomHistory = new vt.bQ, this._availableImages = [], this._globalState = {}, this._serializedLayers = {}, this.stylesheet = null, this.light = null, this.sky = null, this.projection && (this.projection.destroy(), delete this.projection), this._loaded = !1, this._changed = !1, this._updatedLayers = {}, this._updatedSources = {}, this._changedImages = {}, this._glyphsDidChange = !1, this._updatedPaintProps = {}, this._layerOrderChanged = !1, this.crossTileSymbolIndex = new ((null === (le1 = this.crossTileSymbolIndex) || void 0 === le1 ? void 0 : le1.constructor) || Object), this.pauseablePlacement = void 0, this.placement = void 0, this.z = 0;
                            }
                            setGlobalStateProperty(le1, bt) {
                                var ls, ho, Dl;
                                this._checkLoaded();
                                const Fl = null === bt ? null !== (Dl = null === (ho = null === (ls = this.stylesheet.state) || void 0 === ls ? void 0 : ls[le1]) || void 0 === ho ? void 0 : ho.default) && void 0 !== Dl ? Dl : null : bt;
                                if (vt.bR(Fl, this._globalState[le1])) return this;
                                this._globalState[le1] = Fl, this._applyGlobalStateChanges([
                                    le1
                                ]);
                            }
                            getGlobalState() {
                                return this._globalState;
                            }
                            setGlobalState(le1) {
                                this._checkLoaded();
                                const bt = [];
                                for(const ls in le1)!vt.bR(this._globalState[ls], le1[ls].default) && (bt.push(ls), this._globalState[ls] = le1[ls].default);
                                this._applyGlobalStateChanges(bt);
                            }
                            _applyGlobalStateChanges(le1) {
                                if (0 === le1.length) return;
                                const vt = new Set, bt = {};
                                for (const ls of le1){
                                    bt[ls] = this._globalState[ls];
                                    for(const le1 in this._layers){
                                        const bt = this._layers[le1], ho = bt.getLayoutAffectingGlobalStateRefs(), Dl = bt.getPaintAffectingGlobalStateRefs(), Fl = bt.getVisibilityAffectingGlobalStateRefs();
                                        if (ho.has(ls) && vt.add(bt.source), Dl.has(ls)) for (const { name: le1, value: vt } of Dl.get(ls))this._updatePaintProperty(bt, le1, vt);
                                        (null == Fl ? void 0 : Fl.has(ls)) && (bt.recalculateVisibility(), this._updateLayer(bt));
                                    }
                                }
                                this.dispatcher.broadcast("UGS", bt);
                                for(const ls in this.tileManagers)vt.has(ls) && (this._reloadSource(ls), this._changed = !0);
                            }
                            loadURL(le1, bt = {}, ls) {
                                this.fire(new vt.l("dataloading", {
                                    dataType: "style"
                                })), bt.validate = "boolean" != typeof bt.validate || bt.validate;
                                const ho = this.map._requestManager.transformRequest(le1, "Style");
                                this._loadStyleRequest = new AbortController;
                                const Dl = this._loadStyleRequest;
                                vt.j(ho, this._loadStyleRequest).then((le1)=>{
                                    this._loadStyleRequest = null, this._load(le1.data, bt, ls);
                                }).catch((le1)=>{
                                    this._loadStyleRequest = null, le1 && !Dl.signal.aborted && this.fire(new vt.k(le1));
                                });
                            }
                            loadJSON(le1, bt = {}, ls) {
                                this.fire(new vt.l("dataloading", {
                                    dataType: "style"
                                })), this._frameRequest = new AbortController, Fl.frameAsync(this._frameRequest, this.map._ownerWindow).then(()=>{
                                    this._frameRequest = null, bt.validate = !1 !== bt.validate, this._load(le1, bt, ls);
                                }).catch(()=>{});
                            }
                            loadEmpty() {
                                this.fire(new vt.l("dataloading", {
                                    dataType: "style"
                                })), this._load(Am, {
                                    validate: !1
                                });
                            }
                            _load(le1, bt, ls) {
                                var ho, Dl;
                                let Fl = bt.transformStyle ? bt.transformStyle(ls, le1) : le1;
                                if (!bt.validate || !Ai(this, vt.C(Fl))) {
                                    Fl = Object.assign({}, Fl), this._loaded = !0, this.stylesheet = Fl;
                                    for(const le1 in Fl.sources)this.addSource(le1, Fl.sources[le1], {
                                        validate: !1
                                    });
                                    Fl.sprite ? this._loadSprite(Fl.sprite) : this.imageManager.setLoaded(!0), this.glyphManager.setURL(Fl.glyphs), this._createLayers(), this.light = new z(this.stylesheet.light), this._setProjectionInternal((null === (ho = this.stylesheet.projection) || void 0 === ho ? void 0 : ho.type) || "mercator"), this.sky = new D(this.stylesheet.sky), this.map.setTerrain(null !== (Dl = this.stylesheet.terrain) && void 0 !== Dl ? Dl : null), this.fire(new vt.l("data", {
                                        dataType: "style"
                                    })), this.fire(new vt.l("style.load"));
                                }
                            }
                            _createLayers() {
                                var le1, bt, ls;
                                const ho = vt.bS(this.stylesheet.layers);
                                this.setGlobalState(null !== (le1 = this.stylesheet.state) && void 0 !== le1 ? le1 : null), this.dispatcher.broadcast("SL", ho), this._order = ho.map((le1)=>le1.id), this._layers = {}, this._serializedLayers = null;
                                for (const Dl of ho){
                                    const le1 = vt.bT(Dl, this._globalState);
                                    if (le1.setEventedParent(this, {
                                        layer: {
                                            id: Dl.id
                                        }
                                    }), this._layers[Dl.id] = le1, vt.bU(le1) && this.tileManagers[le1.source]) {
                                        const vt = null !== (ls = null === (bt = Dl.paint) || void 0 === bt ? void 0 : bt["raster-fade-duration"]) && void 0 !== ls ? ls : le1.paint.get("raster-fade-duration");
                                        this.tileManagers[le1.source].setRasterFadeDuration(vt);
                                    }
                                }
                            }
                            _loadSprite(le1, bt = !1, ls) {
                                this.imageManager.setLoaded(!1);
                                const ho = new AbortController;
                                let Dl;
                                this._spriteRequest = ho, (function(le1, bt, ls, ho) {
                                    return vt._(this, void 0, void 0, function*() {
                                        const Dl = x(le1), sc = ls > 1 ? "@2x" : "", uc = {}, mc = {};
                                        for (const { id: le1, url: ls } of Dl){
                                            const Dl = bt.transformRequest(b(ls, sc, ".json"), "SpriteJSON");
                                            uc[le1] = vt.j(Dl, ho);
                                            const Fl = bt.transformRequest(b(ls, sc, ".png"), "SpriteImage");
                                            mc[le1] = kc.getImage(Fl, ho);
                                        }
                                        return yield Promise.all([
                                            ...Object.values(uc),
                                            ...Object.values(mc)
                                        ]), function(le1, bt) {
                                            return vt._(this, void 0, void 0, function*() {
                                                const vt = {};
                                                for(const ls in le1){
                                                    vt[ls] = {};
                                                    const ho = Fl.getImageCanvasContext((yield bt[ls]).data), Dl = (yield le1[ls]).data;
                                                    for(const le1 in Dl){
                                                        const { width: bt, height: Fl, x: sc, y: uc, sdf: mc, pixelRatio: gc, stretchX: Ac, stretchY: Ec, content: kc, textFitWidth: du, textFitHeight: _u } = Dl[le1];
                                                        vt[ls][le1] = {
                                                            data: null,
                                                            pixelRatio: gc,
                                                            sdf: mc,
                                                            stretchX: Ac,
                                                            stretchY: Ec,
                                                            content: kc,
                                                            textFitWidth: du,
                                                            textFitHeight: _u,
                                                            spriteData: {
                                                                width: bt,
                                                                height: Fl,
                                                                x: sc,
                                                                y: uc,
                                                                context: ho
                                                            }
                                                        };
                                                    }
                                                }
                                                return vt;
                                            });
                                        }(uc, mc);
                                    });
                                })(le1, this.map._requestManager, this.map.getPixelRatio(), this._spriteRequest).then((le1)=>{
                                    if (this._spriteRequest = null, le1) for(const vt in le1){
                                        this._spritesImagesIds[vt] = [];
                                        const ls = this._spritesImagesIds[vt] ? this._spritesImagesIds[vt].filter((vt)=>!(vt in le1)) : [];
                                        for (const le1 of ls)this.imageManager.removeImage(le1), this._changedImages[le1] = !0;
                                        for(const ho in le1[vt]){
                                            const ls = "default" === vt ? ho : `${vt}:${ho}`;
                                            this._spritesImagesIds[vt].push(ls), ls in this.imageManager.images ? this.imageManager.updateImage(ls, le1[vt][ho], !1) : this.imageManager.addImage(ls, le1[vt][ho]), bt && (this._changedImages[ls] = !0);
                                        }
                                    }
                                }).catch((le1)=>{
                                    this._spriteRequest = null, Dl = le1, ho.signal.aborted || this.fire(new vt.k(Dl));
                                }).finally(()=>{
                                    this.imageManager.setLoaded(!0), this._availableImages = this.imageManager.listImages(), bt && (this._changed = !0), this.dispatcher.broadcast("SI", this._availableImages), this.fire(new vt.l("data", {
                                        dataType: "style"
                                    })), ls && ls(Dl);
                                });
                            }
                            _unloadSprite() {
                                for (const le1 of Object.values(this._spritesImagesIds).flat())this.imageManager.removeImage(le1), this._changedImages[le1] = !0;
                                this._spritesImagesIds = {}, this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new vt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            _validateLayer(le1) {
                                const bt = this.tileManagers[le1.source];
                                if (!bt) return;
                                const ls = le1.sourceLayer;
                                if (!ls) return;
                                const ho = bt.getSource();
                                ("geojson" === ho.type || ho.vectorLayerIds && -1 === ho.vectorLayerIds.indexOf(ls)) && this.fire(new vt.k(new Error(`Source layer "${ls}" does not exist on source "${ho.id}" as specified by style layer "${le1.id}".`)));
                            }
                            loaded() {
                                if (!this._loaded) return !1;
                                if (Object.keys(this._updatedSources).length) return !1;
                                for(const le1 in this.tileManagers)if (!this.tileManagers[le1].loaded()) return !1;
                                return !!this.imageManager.isLoaded();
                            }
                            _serializeByIds(le1, bt = !1) {
                                const ls = this._serializedAllLayers();
                                if (!le1 || 0 === le1.length) return Object.values(bt ? vt.bV(ls) : ls);
                                const ho = [];
                                for (const Dl of le1)if (ls[Dl]) {
                                    const le1 = bt ? vt.bV(ls[Dl]) : ls[Dl];
                                    ho.push(le1);
                                }
                                return ho;
                            }
                            _serializedAllLayers() {
                                let le1 = this._serializedLayers;
                                if (le1) return le1;
                                le1 = this._serializedLayers = {};
                                const vt = Object.keys(this._layers);
                                for (const bt of vt){
                                    const vt = this._layers[bt];
                                    "custom" !== vt.type && (le1[bt] = vt.serialize());
                                }
                                return le1;
                            }
                            hasTransitions() {
                                var le1, vt, bt;
                                if (null === (le1 = this.light) || void 0 === le1 ? void 0 : le1.hasTransition()) return !0;
                                if (null === (vt = this.sky) || void 0 === vt ? void 0 : vt.hasTransition()) return !0;
                                if (null === (bt = this.projection) || void 0 === bt ? void 0 : bt.hasTransition()) return !0;
                                for(const ls in this.tileManagers)if (this.tileManagers[ls].hasTransition()) return !0;
                                for(const ls in this._layers)if (this._layers[ls].hasTransition()) return !0;
                                return !1;
                            }
                            _checkLoaded() {
                                if (!this._loaded) throw new Error("Style is not done loading.");
                            }
                            update(le1) {
                                if (!this._loaded) return;
                                const bt = this._changed;
                                if (bt) {
                                    const vt = Object.keys(this._updatedLayers), bt = Object.keys(this._removedLayers);
                                    (vt.length || bt.length) && this._updateWorkerLayers(vt, bt);
                                    for(const le1 in this._updatedSources){
                                        const vt = this._updatedSources[le1];
                                        if ("reload" === vt) this._reloadSource(le1);
                                        else {
                                            if ("clear" !== vt) throw new Error(`Invalid action ${vt}`);
                                            this._clearSource(le1);
                                        }
                                    }
                                    this._updateTilesForChangedImages(), this._updateTilesForChangedGlyphs();
                                    for(const ls in this._updatedPaintProps)this._layers[ls].updateTransitions(le1);
                                    this.light.updateTransitions(le1), this.sky.updateTransitions(le1), this._resetUpdates();
                                }
                                const ls = {};
                                for(const vt in this.tileManagers){
                                    const le1 = this.tileManagers[vt];
                                    ls[vt] = le1.used, le1.used = !1;
                                }
                                for (const vt of this._order){
                                    const bt = this._layers[vt];
                                    bt.recalculate(le1, this._availableImages), !bt.isHidden(le1.zoom) && bt.source && (this.tileManagers[bt.source].used = !0);
                                }
                                for(const ho in ls){
                                    const le1 = this.tileManagers[ho];
                                    !!ls[ho] != !!le1.used && le1.fire(new vt.l("data", {
                                        sourceDataType: "visibility",
                                        dataType: "source",
                                        sourceId: ho
                                    }));
                                }
                                this.light.recalculate(le1), this.sky.recalculate(le1), this.projection.recalculate(le1), this.z = le1.zoom, bt && this.fire(new vt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            _updateTilesForChangedImages() {
                                const le1 = Object.keys(this._changedImages);
                                if (le1.length) {
                                    for(const vt in this.tileManagers)this.tileManagers[vt].reloadTilesForDependencies([
                                        "icons",
                                        "patterns"
                                    ], le1);
                                    this._changedImages = {};
                                }
                            }
                            _updateTilesForChangedGlyphs() {
                                if (this._glyphsDidChange) {
                                    for(const le1 in this.tileManagers)this.tileManagers[le1].reloadTilesForDependencies([
                                        "glyphs"
                                    ], [
                                        ""
                                    ]);
                                    this._glyphsDidChange = !1;
                                }
                            }
                            _updateWorkerLayers(le1, vt) {
                                this.dispatcher.broadcast("UL", {
                                    layers: this._serializeByIds(le1, !1),
                                    removedIds: vt
                                });
                            }
                            _resetUpdates() {
                                this._changed = !1, this._updatedLayers = {}, this._removedLayers = {}, this._updatedSources = {}, this._updatedPaintProps = {}, this._changedImages = {}, this._glyphsDidChange = !1;
                            }
                            setState(le1, bt = {}) {
                                var ls;
                                this._checkLoaded();
                                const ho = this.serialize();
                                if (le1 = bt.transformStyle ? bt.transformStyle(ho, le1) : le1, (null === (ls = bt.validate) || void 0 === ls || ls) && Ai(this, vt.C(le1))) return !1;
                                (le1 = vt.bV(le1)).layers = vt.bS(le1.layers);
                                const Dl = vt.bW(ho, le1), Fl = this._getOperationsToPerform(Dl);
                                if (Fl.unimplemented.length > 0) throw new Error(`Unimplemented: ${Fl.unimplemented.join(", ")}.`);
                                if (0 === Fl.operations.length) return !1;
                                for (const vt of Fl.operations)vt();
                                return this.stylesheet = le1, this._serializedLayers = null, this.fire(new vt.l("style.load", {
                                    style: this
                                })), !0;
                            }
                            _getOperationsToPerform(le1) {
                                const vt = [], bt = [];
                                for (const ls of le1)switch(ls.command){
                                    case "setCenter":
                                    case "setZoom":
                                    case "setBearing":
                                    case "setPitch":
                                    case "setRoll":
                                        continue;
                                    case "addLayer":
                                        vt.push(()=>this.addLayer.apply(this, ls.args));
                                        break;
                                    case "removeLayer":
                                        vt.push(()=>this.removeLayer.apply(this, ls.args));
                                        break;
                                    case "setPaintProperty":
                                        vt.push(()=>this.setPaintProperty.apply(this, ls.args));
                                        break;
                                    case "setLayoutProperty":
                                        vt.push(()=>this.setLayoutProperty.apply(this, ls.args));
                                        break;
                                    case "setFilter":
                                        vt.push(()=>this.setFilter.apply(this, ls.args));
                                        break;
                                    case "addSource":
                                        vt.push(()=>this.addSource.apply(this, ls.args));
                                        break;
                                    case "removeSource":
                                        vt.push(()=>this.removeSource.apply(this, ls.args));
                                        break;
                                    case "setLayerZoomRange":
                                        vt.push(()=>this.setLayerZoomRange.apply(this, ls.args));
                                        break;
                                    case "setLight":
                                        vt.push(()=>this.setLight.apply(this, ls.args));
                                        break;
                                    case "setGeoJSONSourceData":
                                        vt.push(()=>this.setGeoJSONSourceData.apply(this, ls.args));
                                        break;
                                    case "setGlyphs":
                                        vt.push(()=>this.setGlyphs.apply(this, ls.args));
                                        break;
                                    case "setSprite":
                                        vt.push(()=>this.setSprite.apply(this, ls.args));
                                        break;
                                    case "setTerrain":
                                        vt.push(()=>this.map.setTerrain.apply(this, ls.args));
                                        break;
                                    case "setSky":
                                        vt.push(()=>this.setSky.apply(this, ls.args));
                                        break;
                                    case "setProjection":
                                        this.setProjection.apply(this, ls.args);
                                        break;
                                    case "setGlobalState":
                                        vt.push(()=>this.setGlobalState.apply(this, ls.args));
                                        break;
                                    case "setTransition":
                                        vt.push(()=>{});
                                        break;
                                    default:
                                        bt.push(ls.command);
                                }
                                return {
                                    operations: vt,
                                    unimplemented: bt
                                };
                            }
                            addImage(le1, bt) {
                                if (this.getImage(le1)) return this.fire(new vt.k(new Error(`An image named "${le1}" already exists.`)));
                                this.imageManager.addImage(le1, bt), this._afterImageUpdated(le1);
                            }
                            updateImage(le1, vt) {
                                this.imageManager.updateImage(le1, vt);
                            }
                            getImage(le1) {
                                return this.imageManager.getImage(le1);
                            }
                            removeImage(le1) {
                                if (!this.getImage(le1)) return this.fire(new vt.k(new Error(`An image named "${le1}" does not exist.`)));
                                this.imageManager.removeImage(le1), this._afterImageUpdated(le1);
                            }
                            _afterImageUpdated(le1) {
                                this._availableImages = this.imageManager.listImages(), this._changedImages[le1] = !0, this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new vt.l("data", {
                                    dataType: "style"
                                }));
                            }
                            listImages() {
                                return this._checkLoaded(), this.imageManager.listImages();
                            }
                            addSource(le1, bt, ls = {}) {
                                if (this._checkLoaded(), void 0 !== this.tileManagers[le1]) throw new Error(`Source "${le1}" already exists.`);
                                if (!bt.type) throw new Error(`The type property must be defined, but only the following properties were given: ${Object.keys(bt).join(", ")}.`);
                                if ([
                                    "vector",
                                    "raster",
                                    "geojson",
                                    "video",
                                    "image"
                                ].indexOf(bt.type) >= 0 && this._validate(vt.C.source, `sources.${le1}`, bt, null, ls)) return;
                                this.map && this.map._collectResourceTiming && (bt.collectResourceTiming = !0);
                                const ho = this.tileManagers[le1] = new ke(le1, bt, this.dispatcher);
                                ho.style = this, ho.setEventedParent(this, ()=>({
                                        isSourceLoaded: ho.loaded(),
                                        source: ho.serialize(),
                                        sourceId: le1
                                    })), ho.onAdd(this.map), this._changed = !0;
                            }
                            removeSource(le1) {
                                if (this._checkLoaded(), void 0 === this.tileManagers[le1]) throw new Error("There is no source with this ID");
                                for(const ls in this._layers)if (this._layers[ls].source === le1) return this.fire(new vt.k(new Error(`Source "${le1}" cannot be removed while layer "${ls}" is using it.`)));
                                const bt = this.tileManagers[le1];
                                delete this.tileManagers[le1], delete this._updatedSources[le1], bt.fire(new vt.l("data", {
                                    sourceDataType: "metadata",
                                    dataType: "source",
                                    sourceId: le1
                                })), bt.setEventedParent(null), bt.onRemove(this.map), this._changed = !0;
                            }
                            setGeoJSONSourceData(le1, vt) {
                                if (this._checkLoaded(), void 0 === this.tileManagers[le1]) throw new Error(`There is no source with this ID=${le1}`);
                                const bt = this.tileManagers[le1].getSource();
                                if ("geojson" !== bt.type) throw new Error(`geojsonSource.type is ${bt.type}, which is !== 'geojson`);
                                bt.setData(vt), this._changed = !0;
                            }
                            getSource(le1) {
                                return this.tileManagers[le1] && this.tileManagers[le1].getSource();
                            }
                            addLayer(le1, bt, ls = {}) {
                                this._checkLoaded();
                                const ho = le1.id;
                                if (this.getLayer(ho)) return void this.fire(new vt.k(new Error(`Layer "${ho}" already exists on this map.`)));
                                let Dl;
                                if ("custom" === le1.type) {
                                    if (Ai(this, vt.bX(le1))) return;
                                    Dl = vt.bT(le1, this._globalState);
                                } else {
                                    if ("source" in le1 && "object" == typeof le1.source && (this.addSource(ho, le1.source), le1 = vt.bV(le1), le1 = vt.e(le1, {
                                        source: ho
                                    })), this._validate(vt.C.layer, `layers.${ho}`, le1, {
                                        arrayIndex: -1
                                    }, ls)) return;
                                    Dl = vt.bT(le1, this._globalState), this._validateLayer(Dl), Dl.setEventedParent(this, {
                                        layer: {
                                            id: ho
                                        }
                                    });
                                }
                                const Fl = bt ? this._order.indexOf(bt) : this._order.length;
                                if (bt && -1 === Fl) this.fire(new vt.k(new Error(`Cannot add layer "${ho}" before non-existing layer "${bt}".`)));
                                else {
                                    if (this._order.splice(Fl, 0, ho), this._layerOrderChanged = !0, this._layers[ho] = Dl, this._removedLayers[ho] && Dl.source && "custom" !== Dl.type) {
                                        const le1 = this._removedLayers[ho];
                                        delete this._removedLayers[ho], le1.type !== Dl.type ? this._updatedSources[Dl.source] = "clear" : (this._updatedSources[Dl.source] = "reload", this.tileManagers[Dl.source].pause());
                                    }
                                    this._updateLayer(Dl), Dl.onAdd && Dl.onAdd(this.map);
                                }
                            }
                            moveLayer(le1, bt) {
                                if (this._checkLoaded(), this._changed = !0, !this._layers[le1]) return void this.fire(new vt.k(new Error(`The layer '${le1}' does not exist in the map's style and cannot be moved.`)));
                                if (le1 === bt) return;
                                const ls = this._order.indexOf(le1);
                                this._order.splice(ls, 1);
                                const ho = bt ? this._order.indexOf(bt) : this._order.length;
                                bt && -1 === ho ? this.fire(new vt.k(new Error(`Cannot move layer "${le1}" before non-existing layer "${bt}".`))) : (this._order.splice(ho, 0, le1), this._layerOrderChanged = !0);
                            }
                            removeLayer(le1) {
                                this._checkLoaded();
                                const bt = this._layers[le1];
                                if (!bt) return void this.fire(new vt.k(new Error(`Cannot remove non-existing layer "${le1}".`)));
                                bt.setEventedParent(null);
                                const ls = this._order.indexOf(le1);
                                this._order.splice(ls, 1), this._layerOrderChanged = !0, this._changed = !0, this._removedLayers[le1] = bt, delete this._layers[le1], this._serializedLayers && delete this._serializedLayers[le1], delete this._updatedLayers[le1], delete this._updatedPaintProps[le1], bt.onRemove && bt.onRemove(this.map);
                            }
                            getLayer(le1) {
                                return this._layers[le1];
                            }
                            getLayersOrder() {
                                return [
                                    ...this._order
                                ];
                            }
                            hasLayer(le1) {
                                return le1 in this._layers;
                            }
                            setLayerZoomRange(le1, bt, ls) {
                                this._checkLoaded();
                                const ho = this.getLayer(le1);
                                ho ? ho.minzoom === bt && ho.maxzoom === ls || (null != bt && (ho.minzoom = bt), null != ls && (ho.maxzoom = ls), this._updateLayer(ho)) : this.fire(new vt.k(new Error(`Cannot set the zoom range of non-existing layer "${le1}".`)));
                            }
                            setFilter(le1, bt, ls = {}) {
                                this._checkLoaded();
                                const ho = this.getLayer(le1);
                                if (ho) {
                                    if (!vt.bR(ho.filter, bt)) return null == bt ? (ho.setFilter(void 0), void this._updateLayer(ho)) : void (this._validate(vt.C.filter, `layers.${ho.id}.filter`, bt, null, ls) || (ho.setFilter(vt.bV(bt)), this._updateLayer(ho)));
                                } else this.fire(new vt.k(new Error(`Cannot filter non-existing layer "${le1}".`)));
                            }
                            getFilter(le1) {
                                return vt.bV(this.getLayer(le1).filter);
                            }
                            setLayoutProperty(le1, bt, ls, ho = {}) {
                                this._checkLoaded();
                                const Dl = this.getLayer(le1);
                                Dl ? vt.bR(Dl.getLayoutProperty(bt), ls) || (Dl.setLayoutProperty(bt, ls, ho), this._updateLayer(Dl)) : this.fire(new vt.k(new Error(`Cannot style non-existing layer "${le1}".`)));
                            }
                            getLayoutProperty(le1, bt) {
                                const ls = this.getLayer(le1);
                                if (ls) return ls.getLayoutProperty(bt);
                                this.fire(new vt.k(new Error(`Cannot get style of non-existing layer "${le1}".`)));
                            }
                            setPaintProperty(le1, bt, ls, ho = {}) {
                                this._checkLoaded();
                                const Dl = this.getLayer(le1);
                                Dl ? vt.bR(Dl.getPaintProperty(bt), ls) || this._updatePaintProperty(Dl, bt, ls, ho) : this.fire(new vt.k(new Error(`Cannot style non-existing layer "${le1}".`)));
                            }
                            _updatePaintProperty(le1, bt, ls, ho = {}) {
                                le1.setPaintProperty(bt, ls, ho) && this._updateLayer(le1), vt.bU(le1) && "raster-fade-duration" === bt && this.tileManagers[le1.source].setRasterFadeDuration(ls), this._changed = !0, this._updatedPaintProps[le1.id] = !0, this._serializedLayers = null;
                            }
                            getPaintProperty(le1, vt) {
                                return this.getLayer(le1).getPaintProperty(vt);
                            }
                            setFeatureState(le1, bt) {
                                this._checkLoaded();
                                const ls = le1.source, ho = le1.sourceLayer, Dl = this.tileManagers[ls];
                                if (void 0 === Dl) return void this.fire(new vt.k(new Error(`The source '${ls}' does not exist in the map's style.`)));
                                const Fl = Dl.getSource().type;
                                "geojson" === Fl && ho ? this.fire(new vt.k(new Error("GeoJSON sources cannot have a sourceLayer parameter."))) : "vector" !== Fl || ho ? (void 0 === le1.id && this.fire(new vt.k(new Error("The feature id parameter must be provided."))), Dl.setFeatureState(ho, le1.id, bt)) : this.fire(new vt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            removeFeatureState(le1, bt) {
                                this._checkLoaded();
                                const ls = le1.source, ho = this.tileManagers[ls];
                                if (void 0 === ho) return void this.fire(new vt.k(new Error(`The source '${ls}' does not exist in the map's style.`)));
                                const Dl = ho.getSource().type, Fl = "vector" === Dl ? le1.sourceLayer : void 0;
                                "vector" !== Dl || Fl ? bt && "string" != typeof le1.id && "number" != typeof le1.id ? this.fire(new vt.k(new Error("A feature id is required to remove its specific state property."))) : ho.removeFeatureState(Fl, le1.id, bt) : this.fire(new vt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                            }
                            getFeatureState(le1) {
                                this._checkLoaded();
                                const bt = le1.source, ls = le1.sourceLayer, ho = this.tileManagers[bt];
                                if (void 0 !== ho) return "vector" !== ho.getSource().type || ls ? (void 0 === le1.id && this.fire(new vt.k(new Error("The feature id parameter must be provided."))), ho.getFeatureState(ls, le1.id)) : void this.fire(new vt.k(new Error("The sourceLayer parameter must be provided for vector source types.")));
                                this.fire(new vt.k(new Error(`The source '${bt}' does not exist in the map's style.`)));
                            }
                            getTransition() {
                                return vt.e({
                                    duration: 300,
                                    delay: 0
                                }, this.stylesheet && this.stylesheet.transition);
                            }
                            serialize() {
                                if (!this._loaded) return;
                                const le1 = vt.bY(this.tileManagers, (le1)=>le1.serialize()), bt = this._serializeByIds(this._order, !0), ls = this.map.getTerrain() || void 0, ho = this.stylesheet;
                                return vt.bZ({
                                    version: ho.version,
                                    name: ho.name,
                                    metadata: ho.metadata,
                                    light: ho.light,
                                    sky: ho.sky,
                                    center: ho.center,
                                    zoom: ho.zoom,
                                    bearing: ho.bearing,
                                    pitch: ho.pitch,
                                    sprite: ho.sprite,
                                    glyphs: ho.glyphs,
                                    transition: ho.transition,
                                    projection: ho.projection,
                                    sources: le1,
                                    layers: bt,
                                    terrain: ls
                                }, (le1)=>void 0 !== le1);
                            }
                            _updateLayer(le1) {
                                this._updatedLayers[le1.id] = !0, le1.source && !this._updatedSources[le1.source] && "raster" !== this.tileManagers[le1.source].getSource().type && (this._updatedSources[le1.source] = "reload", this.tileManagers[le1.source].pause()), this._serializedLayers = null, this._changed = !0;
                            }
                            _flattenAndSortRenderedFeatures(le1) {
                                const t = (le1)=>"fill-extrusion" === this._layers[le1].type, vt = {}, bt = [];
                                for(let ho = this._order.length - 1; ho >= 0; ho--){
                                    const ls = this._order[ho];
                                    if (t(ls)) {
                                        vt[ls] = ho;
                                        for (const vt of le1){
                                            const le1 = vt[ls];
                                            if (le1) for (const vt of le1)bt.push(vt);
                                        }
                                    }
                                }
                                bt.sort((le1, vt)=>vt.intersectionZ - le1.intersectionZ);
                                const ls = [];
                                for(let ho = this._order.length - 1; ho >= 0; ho--){
                                    const Dl = this._order[ho];
                                    if (t(Dl)) for(let le1 = bt.length - 1; le1 >= 0; le1--){
                                        const Dl = bt[le1].feature;
                                        if (vt[Dl.layer.id] < ho) break;
                                        ls.push(Dl), bt.pop();
                                    }
                                    else for (const vt of le1){
                                        const le1 = vt[Dl];
                                        if (le1) for (const vt of le1)ls.push(vt.feature);
                                    }
                                }
                                return ls;
                            }
                            queryRenderedFeatures(le1, bt, ls) {
                                bt && bt.filter && this._validate(vt.C.filter, "queryRenderedFeatures.filter", bt.filter, null, bt);
                                const ho = {};
                                if (bt && bt.layers) {
                                    if (!(Array.isArray(bt.layers) || bt.layers instanceof Set)) return this.fire(new vt.k(new Error("parameters.layers must be an Array or a Set of strings"))), [];
                                    for (const le1 of bt.layers){
                                        const bt = this._layers[le1];
                                        if (!bt) return this.fire(new vt.k(new Error(`The layer '${le1}' does not exist in the map's style and cannot be queried for features.`))), [];
                                        ho[bt.source] = !0;
                                    }
                                }
                                const Dl = [];
                                bt.availableImages = this._availableImages;
                                const Fl = this._serializedAllLayers(), sc = bt.layers instanceof Set ? bt.layers : Array.isArray(bt.layers) ? new Set(bt.layers) : null, uc = Object.assign(Object.assign({}, bt), {
                                    layers: sc,
                                    globalState: this._globalState
                                });
                                for(const vt in this.tileManagers)bt.layers && !ho[vt] || Dl.push(G(this.tileManagers[vt], this._layers, Fl, le1, uc, ls, this.map.terrain ? (le1, vt, bt)=>this.map.terrain.getElevation(le1, vt, bt) : void 0));
                                return this.placement && Dl.push(function(le1, vt, bt, ls, ho, Dl, Fl) {
                                    const sc = {}, uc = Dl.queryRenderedSymbols(ls), mc = [];
                                    for (const gc of Object.keys(uc).map(Number))mc.push(Fl[gc]);
                                    mc.sort(V);
                                    for (const gc of mc){
                                        const bt = gc.featureIndex.lookupSymbolFeatures(uc[gc.bucketInstanceId], vt, gc.bucketIndex, gc.sourceLayerIndex, {
                                            filterSpec: ho.filter,
                                            globalState: ho.globalState
                                        }, ho.layers, ho.availableImages, le1);
                                        for(const le1 in bt){
                                            const vt = sc[le1] = sc[le1] || [], ls = bt[le1];
                                            ls.sort((le1, vt)=>{
                                                const bt = gc.featureSortOrder;
                                                if (bt) {
                                                    const ls = bt.indexOf(le1.featureIndex);
                                                    return bt.indexOf(vt.featureIndex) - ls;
                                                }
                                                return vt.featureIndex - le1.featureIndex;
                                            });
                                            for (const le1 of ls)vt.push(le1);
                                        }
                                    }
                                    return function(le1, vt, bt) {
                                        for(const ls in le1)for (const ho of le1[ls])q(ho, bt[vt[ls].source]);
                                        return le1;
                                    }(sc, le1, bt);
                                }(this._layers, Fl, this.tileManagers, le1, uc, this.placement.collisionIndex, this.placement.retainedQueryData)), this._flattenAndSortRenderedFeatures(Dl);
                            }
                            querySourceFeatures(le1, bt) {
                                (null == bt ? void 0 : bt.filter) && this._validate(vt.C.filter, "querySourceFeatures.filter", bt.filter, null, bt);
                                const ls = this.tileManagers[le1];
                                return ls ? function(le1, vt) {
                                    const bt = le1.getRenderableIds().map((vt)=>le1.getTileByID(vt)), ls = [], ho = {};
                                    for(let Dl = 0; Dl < bt.length; Dl++){
                                        const le1 = bt[Dl], Fl = le1.tileID.canonical.key;
                                        ho[Fl] || (ho[Fl] = !0, le1.querySourceFeatures(ls, vt));
                                    }
                                    return ls;
                                }(ls, bt ? Object.assign(Object.assign({}, bt), {
                                    globalState: this._globalState
                                }) : {
                                    globalState: this._globalState
                                }) : [];
                            }
                            getLight() {
                                return this.light.getLight();
                            }
                            setLight(le1, bt = {}) {
                                this._checkLoaded();
                                const ls = this.light.getLight();
                                let ho = !1;
                                for(const Fl in le1)if (!vt.bR(le1[Fl], ls[Fl])) {
                                    ho = !0;
                                    break;
                                }
                                if (!ho) return;
                                const Dl = {
                                    now: c(),
                                    transition: vt.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.light.setLight(le1, bt), this.light.updateTransitions(Dl);
                            }
                            getProjection() {
                                var le1;
                                return null === (le1 = this.stylesheet) || void 0 === le1 ? void 0 : le1.projection;
                            }
                            setProjection(le1) {
                                if (this._checkLoaded(), this.projection) {
                                    if (this.projection.name === le1.type) return;
                                    this.projection.destroy(), delete this.projection;
                                }
                                this.stylesheet.projection = le1, this._setProjectionInternal(le1.type);
                            }
                            getSky() {
                                var le1;
                                return null === (le1 = this.stylesheet) || void 0 === le1 ? void 0 : le1.sky;
                            }
                            setSky(le1, bt = {}) {
                                this._checkLoaded();
                                const ls = this.getSky();
                                let ho = !1;
                                if (!le1 && !ls) return;
                                if (le1 && !ls) ho = !0;
                                else if (!le1 && ls) ho = !0;
                                else for(const Fl in le1)if (!vt.bR(le1[Fl], ls[Fl])) {
                                    ho = !0;
                                    break;
                                }
                                if (!ho) return;
                                const Dl = {
                                    now: c(),
                                    transition: vt.e({
                                        duration: 300,
                                        delay: 0
                                    }, this.stylesheet.transition)
                                };
                                this.stylesheet.sky = le1, this.sky.setSky(le1, bt), this.sky.updateTransitions(Dl);
                            }
                            _setProjectionInternal(le1) {
                                const bt = function(le1, bt) {
                                    const ls = {
                                        constrainOverride: bt
                                    };
                                    if (Array.isArray(le1)) {
                                        const vt = new di({
                                            type: le1
                                        });
                                        return {
                                            projection: vt,
                                            transform: new zi(ls),
                                            cameraHelper: new Di(vt)
                                        };
                                    }
                                    switch(le1){
                                        case "mercator":
                                            return {
                                                projection: new jt,
                                                transform: new $t(ls),
                                                cameraHelper: new Yt
                                            };
                                        case "globe":
                                            {
                                                const le1 = new di({
                                                    type: [
                                                        "interpolate",
                                                        [
                                                            "linear"
                                                        ],
                                                        [
                                                            "zoom"
                                                        ],
                                                        11,
                                                        "vertical-perspective",
                                                        12,
                                                        "mercator"
                                                    ]
                                                });
                                                return {
                                                    projection: le1,
                                                    transform: new zi(ls),
                                                    cameraHelper: new Di(le1)
                                                };
                                            }
                                        case "vertical-perspective":
                                            return {
                                                projection: new hi,
                                                transform: new Si(ls),
                                                cameraHelper: new Ri
                                            };
                                        default:
                                            return vt.w(`Unknown projection name: ${le1}. Falling back to mercator projection.`), {
                                                projection: new jt,
                                                transform: new $t(ls),
                                                cameraHelper: new Yt
                                            };
                                    }
                                }(le1, this.map.transformConstrain);
                                this.projection = bt.projection, this.map.migrateProjection(bt.transform, bt.cameraHelper);
                                for(const vt in this.tileManagers)this.tileManagers[vt].reload();
                            }
                            _validate(le1, bt, ls, ho, Dl = {}) {
                                return (!Dl || !1 !== Dl.validate) && Ai(this, le1.call(vt.C, vt.e({
                                    key: bt,
                                    style: this.serialize(),
                                    value: ls,
                                    styleSpec: vt.u
                                }, ho)));
                            }
                            _remove(le1 = !0) {
                                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null), ce().off(Gd, this._rtlPluginLoaded);
                                for(const vt in this._layers)this._layers[vt].setEventedParent(null);
                                for(const vt in this.tileManagers){
                                    const le1 = this.tileManagers[vt];
                                    le1.setEventedParent(null), le1.onRemove(this.map);
                                }
                                this.imageManager.setEventedParent(null), this.setEventedParent(null), le1 && this.dispatcher.broadcast("RM", void 0), this.dispatcher.remove(le1);
                            }
                            _clearSource(le1) {
                                this.tileManagers[le1].clearTiles();
                            }
                            _reloadSource(le1) {
                                this.tileManagers[le1].resume(), this.tileManagers[le1].reload();
                            }
                            _updateSources(le1) {
                                for(const vt in this.tileManagers)this.tileManagers[vt].update(le1, this.map.terrain);
                            }
                            _generateCollisionBoxes() {
                                for(const le1 in this.tileManagers)this._reloadSource(le1);
                            }
                            _updatePlacement(le1, vt, bt, ls, ho = !1) {
                                let Dl = !1, Fl = !1;
                                const sc = {};
                                for (const uc of this._order){
                                    const vt = this._layers[uc];
                                    if ("symbol" !== vt.type) continue;
                                    if (!sc[vt.source]) {
                                        const le1 = this.tileManagers[vt.source];
                                        sc[vt.source] = le1.getRenderableIds(!0).map((vt)=>le1.getTileByID(vt)).sort((le1, vt)=>vt.tileID.overscaledZ - le1.tileID.overscaledZ || (le1.tileID.isLessThan(vt.tileID) ? -1 : 1));
                                    }
                                    const bt = this.crossTileSymbolIndex.addLayer(vt, sc[vt.source], le1.center.lng);
                                    Dl = Dl || bt;
                                }
                                if (this.crossTileSymbolIndex.pruneUnusedLayers(this._order), ((ho = ho || this._layerOrderChanged || 0 === bt) || !this.pauseablePlacement || this.pauseablePlacement.isDone() && !this.placement.stillRecent(c(), le1.zoom)) && (this.pauseablePlacement = new It(le1, this.map.terrain, this._order, ho, vt, bt, ls, this.placement), this._layerOrderChanged = !1), this.pauseablePlacement.isDone() ? this.placement.setStale() : (this.pauseablePlacement.continuePlacement(this._order, this._layers, sc), this.pauseablePlacement.isDone() && (this.placement = this.pauseablePlacement.commit(c()), Fl = !0), Dl && this.pauseablePlacement.placement.setStale()), Fl || Dl) for (const uc of this._order){
                                    const le1 = this._layers[uc];
                                    "symbol" === le1.type && this.placement.updateLayerOpacities(le1, sc[le1.source]);
                                }
                                return !this.pauseablePlacement.isDone() || this.placement.hasTransitions(c());
                            }
                            _releaseSymbolFadeTiles() {
                                for(const le1 in this.tileManagers)this.tileManagers[le1].releaseSymbolFadeTiles();
                            }
                            getImages(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    const le1 = yield this.imageManager.getImages(bt.icons);
                                    this._updateTilesForChangedImages();
                                    const vt = this.tileManagers[bt.source];
                                    return vt && vt.setDependencies(bt.tileID.key, bt.type, bt.icons), le1;
                                });
                            }
                            getGlyphs(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    const le1 = yield this.glyphManager.getGlyphs(bt.stacks), vt = this.tileManagers[bt.source];
                                    return vt && vt.setDependencies(bt.tileID.key, bt.type, [
                                        ""
                                    ]), le1;
                                });
                            }
                            getGlyphsUrl() {
                                return this.stylesheet.glyphs || null;
                            }
                            setGlyphs(le1, bt = {}) {
                                this._checkLoaded(), le1 && this._validate(vt.C.glyphs, "glyphs", le1, null, bt) || (this._glyphsDidChange = !0, this.stylesheet.glyphs = le1, this.glyphManager.entries = {}, this.glyphManager.setURL(le1));
                            }
                            getDashes(le1, bt) {
                                return vt._(this, void 0, void 0, function*() {
                                    const le1 = {};
                                    for (const [vt, ls] of Object.entries(bt.dashes))le1[vt] = this.lineAtlas.getDash(ls.dasharray, ls.round);
                                    return le1;
                                });
                            }
                            addSprite(le1, bt, ls = {}, ho) {
                                this._checkLoaded();
                                const Dl = [
                                    {
                                        id: le1,
                                        url: bt
                                    }
                                ], Fl = [
                                    ...x(this.stylesheet.sprite),
                                    ...Dl
                                ];
                                this._validate(vt.C.sprite, "sprite", Fl, null, ls) || (this.stylesheet.sprite = Fl, this._loadSprite(Dl, !0, ho));
                            }
                            removeSprite(le1) {
                                this._checkLoaded();
                                const bt = x(this.stylesheet.sprite);
                                if (bt.find((vt)=>vt.id === le1)) {
                                    if (this._spritesImagesIds[le1]) for (const vt of this._spritesImagesIds[le1])this.imageManager.removeImage(vt), this._changedImages[vt] = !0;
                                    bt.splice(bt.findIndex((vt)=>vt.id === le1), 1), this.stylesheet.sprite = bt.length > 0 ? bt : void 0, delete this._spritesImagesIds[le1], this._availableImages = this.imageManager.listImages(), this._changed = !0, this.dispatcher.broadcast("SI", this._availableImages), this.fire(new vt.l("data", {
                                        dataType: "style"
                                    }));
                                } else this.fire(new vt.k(new Error(`Sprite "${le1}" doesn't exists on this map.`)));
                            }
                            getSprite() {
                                return x(this.stylesheet.sprite);
                            }
                            setSprite(le1, bt = {}, ls) {
                                this._checkLoaded(), le1 && this._validate(vt.C.sprite, "sprite", le1, null, bt) || (this.stylesheet.sprite = le1, le1 ? this._loadSprite(le1, !0, ls) : (this._unloadSprite(), ls && ls(null)));
                            }
                            destroy() {
                                this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._loadStyleRequest && (this._loadStyleRequest.abort(), this._loadStyleRequest = null), this._spriteRequest && (this._spriteRequest.abort(), this._spriteRequest = null);
                                for(const le1 in this.tileManagers){
                                    const vt = this.tileManagers[le1];
                                    vt.setEventedParent(null), vt.onRemove(this.map);
                                }
                                this.tileManagers = {}, this.imageManager && (this.imageManager.setEventedParent(null), this.imageManager.destroy(), this._availableImages = [], this._spritesImagesIds = {}), this.glyphManager && this.glyphManager.destroy();
                                for(const le1 in this._layers){
                                    const vt = this._layers[le1];
                                    vt.setEventedParent(null), vt.onRemove && vt.onRemove(this.map);
                                }
                                this._setInitialValues(), this.setEventedParent(null), this.dispatcher.unregisterMessageHandler("GG"), this.dispatcher.unregisterMessageHandler("GI"), this.dispatcher.unregisterMessageHandler("GDA"), this.dispatcher.remove(!0), this._listeners = {}, this._oneTimeListeners = {};
                            }
                        }
                        var _m = vt.aU([
                            {
                                name: "a_pos",
                                type: "Int16",
                                components: 2
                            },
                            {
                                name: "a_texture_pos",
                                type: "Int16",
                                components: 2
                            }
                        ]);
                        class Bi {
                            constructor(){
                                this.boundProgram = null, this.boundLayoutVertexBuffer = null, this.boundPaintVertexBuffers = [], this.boundIndexBuffer = null, this.boundVertexOffset = null, this.boundDynamicVertexBuffer = null, this.vao = null;
                            }
                            bind(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                                this.context = le1;
                                let mc = this.boundPaintVertexBuffers.length !== ls.length;
                                for(let gc = 0; !mc && gc < ls.length; gc++)this.boundPaintVertexBuffers[gc] !== ls[gc] && (mc = !0);
                                !this.vao || this.boundProgram !== vt || this.boundLayoutVertexBuffer !== bt || mc || this.boundIndexBuffer !== ho || this.boundVertexOffset !== Dl || this.boundDynamicVertexBuffer !== Fl || this.boundDynamicVertexBuffer2 !== sc || this.boundDynamicVertexBuffer3 !== uc ? this.freshBind(vt, bt, ls, ho, Dl, Fl, sc, uc) : (le1.bindVertexArray.set(this.vao), Fl && Fl.bind(), ho && ho.dynamicDraw && ho.bind(), sc && sc.bind(), uc && uc.bind());
                            }
                            freshBind(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                                const uc = le1.numAttributes, mc = this.context, gc = mc.gl;
                                this.vao && this.destroy(), this.vao = mc.createVertexArray(), mc.bindVertexArray.set(this.vao), this.boundProgram = le1, this.boundLayoutVertexBuffer = vt, this.boundPaintVertexBuffers = bt, this.boundIndexBuffer = ls, this.boundVertexOffset = ho, this.boundDynamicVertexBuffer = Dl, this.boundDynamicVertexBuffer2 = Fl, this.boundDynamicVertexBuffer3 = sc, vt.enableAttributes(gc, le1);
                                for (const Ac of bt)Ac.enableAttributes(gc, le1);
                                Dl && Dl.enableAttributes(gc, le1), Fl && Fl.enableAttributes(gc, le1), sc && sc.enableAttributes(gc, le1), vt.bind(), vt.setVertexAttribPointers(gc, le1, ho);
                                for (const Ac of bt)Ac.bind(), Ac.setVertexAttribPointers(gc, le1, ho);
                                Dl && (Dl.bind(), Dl.setVertexAttribPointers(gc, le1, ho)), ls && ls.bind(), Fl && (Fl.bind(), Fl.setVertexAttribPointers(gc, le1, ho)), sc && (sc.bind(), sc.setVertexAttribPointers(gc, le1, ho)), mc.currentNumAttributes = uc;
                            }
                            destroy() {
                                this.vao && (this.context.deleteVertexArray(this.vao), this.vao = null);
                            }
                        }
                        const Oi = (le1, bt, ls, ho, Dl)=>({
                                u_texture: 0,
                                u_ele_delta: le1,
                                u_fog_matrix: bt,
                                u_fog_color: ls ? ls.properties.get("fog-color") : vt.bp.white,
                                u_fog_ground_blend: ls ? ls.properties.get("fog-ground-blend") : 1,
                                u_fog_ground_blend_opacity: Dl ? 0 : ls ? ls.calculateFogBlendOpacity(ho) : 0,
                                u_horizon_color: ls ? ls.properties.get("horizon-color") : vt.bp.white,
                                u_horizon_fog_blend: ls ? ls.properties.get("horizon-fog-blend") : 1,
                                u_is_globe_mode: Dl ? 1 : 0
                            }), ym = {
                            mainMatrix: "u_projection_matrix",
                            tileMercatorCoords: "u_projection_tile_mercator_coords",
                            clippingPlane: "u_projection_clipping_plane",
                            projectionTransition: "u_projection_transition",
                            fallbackMatrix: "u_projection_fallback_matrix"
                        };
                        function Ni(le1) {
                            const vt = [];
                            for(let bt = 0; bt < le1.length; bt++){
                                if (null === le1[bt]) continue;
                                const ls = le1[bt].split(" ");
                                vt.push(ls.pop());
                            }
                            return vt;
                        }
                        class Zi {
                            constructor(le1, bt, ls, ho, Dl, Fl, sc, uc, mc = []){
                                const gc = le1.gl;
                                this.program = gc.createProgram();
                                const Ac = Ni(bt.staticAttributes), Ec = ls ? ls.getBinderAttributes() : [], kc = Ac.concat(Ec), du = om.prelude.staticUniforms ? Ni(om.prelude.staticUniforms) : [], _u = sc.staticUniforms ? Ni(sc.staticUniforms) : [], Md = bt.staticUniforms ? Ni(bt.staticUniforms) : [], Ld = ls ? ls.getBinderUniforms() : [], Nd = du.concat(_u).concat(Md).concat(Ld), Rd = [];
                                for (const vt of Nd)Rd.indexOf(vt) < 0 && Rd.push(vt);
                                const Od = ls ? ls.defines() : [];
                                ri(gc) && Od.unshift("#version 300 es"), Dl && Od.push("#define OVERDRAW_INSPECTOR;"), Fl && Od.push("#define TERRAIN3D;"), uc && Od.push(uc), mc && Od.push(...mc);
                                let jd = Od.concat(om.prelude.fragmentSource, sc.fragmentSource, bt.fragmentSource).join("\n"), Ud = Od.concat(om.prelude.vertexSource, sc.vertexSource, bt.vertexSource).join("\n");
                                ri(gc) || (jd = function(le1) {
                                    return le1.replace(/\bin\s/g, "varying ").replace("out highp vec4 fragColor;", "").replace(/fragColor/g, "gl_FragColor").replace(/texture\(/g, "texture2D(");
                                }(jd), Ud = function(le1) {
                                    return le1.replace(/\bin\s/g, "attribute ").replace(/\bout\s/g, "varying ").replace(/texture\(/g, "texture2D(");
                                }(Ud));
                                const Gd = gc.createShader(gc.FRAGMENT_SHADER);
                                if (gc.isContextLost()) return void (this.failedToCreate = !0);
                                if (gc.shaderSource(Gd, jd), gc.compileShader(Gd), !gc.getShaderParameter(Gd, gc.COMPILE_STATUS)) throw new Error(`Could not compile fragment shader: ${gc.getShaderInfoLog(Gd)}`);
                                gc.attachShader(this.program, Gd);
                                const qd = gc.createShader(gc.VERTEX_SHADER);
                                if (gc.isContextLost()) return void (this.failedToCreate = !0);
                                if (gc.shaderSource(qd, Ud), gc.compileShader(qd), !gc.getShaderParameter(qd, gc.COMPILE_STATUS)) throw new Error(`Could not compile vertex shader: ${gc.getShaderInfoLog(qd)}`);
                                gc.attachShader(this.program, qd), this.attributes = {};
                                const Hd = {};
                                this.numAttributes = kc.length;
                                for(let vt = 0; vt < this.numAttributes; vt++)kc[vt] && (gc.bindAttribLocation(this.program, vt, kc[vt]), this.attributes[kc[vt]] = vt);
                                if (gc.linkProgram(this.program), !gc.getProgramParameter(this.program, gc.LINK_STATUS)) throw new Error(`Program failed to link: ${gc.getProgramInfoLog(this.program)}`);
                                gc.deleteShader(qd), gc.deleteShader(Gd);
                                for(let vt = 0; vt < Rd.length; vt++){
                                    const le1 = Rd[vt];
                                    if (le1 && !Hd[le1]) {
                                        const vt = gc.getUniformLocation(this.program, le1);
                                        vt && (Hd[le1] = vt);
                                    }
                                }
                                this.fixedUniforms = ho(le1, Hd), this.terrainUniforms = ((le1, bt)=>({
                                        u_depth: new vt.b_(le1, bt.u_depth),
                                        u_terrain: new vt.b_(le1, bt.u_terrain),
                                        u_terrain_dim: new vt.bq(le1, bt.u_terrain_dim),
                                        u_terrain_matrix: new vt.c0(le1, bt.u_terrain_matrix),
                                        u_terrain_unpack: new vt.c1(le1, bt.u_terrain_unpack),
                                        u_terrain_exaggeration: new vt.bq(le1, bt.u_terrain_exaggeration)
                                    }))(le1, Hd), this.projectionUniforms = ((le1, bt)=>({
                                        u_projection_matrix: new vt.c0(le1, bt.u_projection_matrix),
                                        u_projection_tile_mercator_coords: new vt.c1(le1, bt.u_projection_tile_mercator_coords),
                                        u_projection_clipping_plane: new vt.c1(le1, bt.u_projection_clipping_plane),
                                        u_projection_transition: new vt.bq(le1, bt.u_projection_transition),
                                        u_projection_fallback_matrix: new vt.c0(le1, bt.u_projection_fallback_matrix)
                                    }))(le1, Hd), this.binderUniforms = ls ? ls.getUniforms(le1, Hd) : [];
                            }
                            draw(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u, Md, Ld, Nd) {
                                const Rd = le1.gl;
                                if (this.failedToCreate) return;
                                if (le1.program.set(this.program), le1.setDepthMode(bt), le1.setStencilMode(ls), le1.setColorMode(ho), le1.setCullFace(Dl), sc) {
                                    le1.activeTexture.set(Rd.TEXTURE2), Rd.bindTexture(Rd.TEXTURE_2D, sc.depthTexture), le1.activeTexture.set(Rd.TEXTURE3), Rd.bindTexture(Rd.TEXTURE_2D, sc.texture);
                                    for(const le1 in this.terrainUniforms)this.terrainUniforms[le1].set(sc[le1]);
                                }
                                if (uc) for(const jd in uc)this.projectionUniforms[ym[jd]].set(uc[jd]);
                                if (Fl) for(const jd in this.fixedUniforms)this.fixedUniforms[jd].set(Fl[jd]);
                                _u && _u.setUniforms(le1, this.binderUniforms, kc, {
                                    zoom: du
                                });
                                let Od = 0;
                                switch(vt){
                                    case Rd.LINES:
                                        Od = 2;
                                        break;
                                    case Rd.TRIANGLES:
                                        Od = 3;
                                        break;
                                    case Rd.LINE_STRIP:
                                        Od = 1;
                                }
                                for (const jd of Ec.get()){
                                    const bt = jd.vaos || (jd.vaos = {});
                                    (bt[mc] || (bt[mc] = new Bi)).bind(le1, this, gc, _u ? _u.getPaintVertexBuffers() : [], Ac, jd.vertexOffset, Md, Ld, Nd), Rd.drawElements(vt, jd.primitiveLength * Od, Rd.UNSIGNED_SHORT, jd.primitiveOffset * Od * 2);
                                }
                            }
                        }
                        function Ui(le1, bt, ls) {
                            const ho = 1 / vt.aN(ls, 1, bt.transform.tileZoom), Dl = Math.pow(2, ls.tileID.overscaledZ), Fl = ls.tileSize * Math.pow(2, bt.transform.tileZoom) / Dl, sc = Fl * (ls.tileID.canonical.x + ls.tileID.wrap * Dl), uc = Fl * ls.tileID.canonical.y;
                            return {
                                u_image: 0,
                                u_texsize: ls.imageAtlasTexture.size,
                                u_scale: [
                                    ho,
                                    le1.fromScale,
                                    le1.toScale
                                ],
                                u_fade: le1.t,
                                u_pixel_coord_upper: [
                                    sc >> 16,
                                    uc >> 16
                                ],
                                u_pixel_coord_lower: [
                                    65535 & sc,
                                    65535 & uc
                                ]
                            };
                        }
                        const Gi = (le1, bt, ls, ho)=>{
                            const Dl = le1.style.light, Fl = Dl.properties.get("position"), sc = [
                                Fl.x,
                                Fl.y,
                                Fl.z
                            ], uc = vt.c4();
                            "viewport" === Dl.properties.get("anchor") && vt.c5(uc, le1.transform.bearingInRadians), vt.c6(sc, sc, uc);
                            const mc = le1.transform.transformLightDirection(sc), gc = Dl.properties.get("color");
                            return {
                                u_lightpos: sc,
                                u_lightpos_globe: mc,
                                u_lightintensity: Dl.properties.get("intensity"),
                                u_lightcolor: [
                                    gc.r,
                                    gc.g,
                                    gc.b
                                ],
                                u_vertical_gradient: +bt,
                                u_opacity: ls,
                                u_fill_translate: ho
                            };
                        }, Vi = (le1, bt, ls, ho, Dl, Fl, sc)=>vt.e(Gi(le1, bt, ls, ho), Ui(Fl, le1, sc), {
                                u_height_factor: -Math.pow(2, Dl.overscaledZ) / sc.tileSize / 8
                            }), qi = (le1, bt, ls, ho)=>vt.e(Ui(bt, le1, ls), {
                                u_fill_translate: ho
                            }), Wi = (le1, vt)=>({
                                u_world: le1,
                                u_fill_translate: vt
                            }), $i = (le1, bt, ls, ho, Dl)=>vt.e(qi(le1, bt, ls, Dl), {
                                u_world: ho
                            }), Hi = (le1, bt, ls, ho, Dl)=>{
                            const Fl = le1.transform;
                            let sc, uc, mc = 0;
                            if ("map" === ls.paint.get("circle-pitch-alignment")) {
                                const le1 = vt.aN(bt, 1, Fl.zoom);
                                sc = !0, uc = [
                                    le1,
                                    le1
                                ], mc = le1 / (vt.a5 * Math.pow(2, bt.tileID.overscaledZ)) * 2 * Math.PI * Dl;
                            } else sc = !1, uc = Fl.pixelsToGLUnits;
                            return {
                                u_camera_to_center_distance: Fl.cameraToCenterDistance,
                                u_scale_with_map: +("map" === ls.paint.get("circle-pitch-scale")),
                                u_pitch_with_map: +sc,
                                u_device_pixel_ratio: le1.pixelRatio,
                                u_extrude_scale: uc,
                                u_globe_extrude_scale: mc,
                                u_translate: ho
                            };
                        }, Xi = (le1)=>({
                                u_pixel_extrude_scale: [
                                    1 / le1.width,
                                    1 / le1.height
                                ]
                            }), Ki = (le1)=>({
                                u_viewport_size: [
                                    le1.width,
                                    le1.height
                                ]
                            }), Yi = (le1, vt = 1)=>({
                                u_color: le1,
                                u_overlay: 0,
                                u_overlay_scale: vt
                            }), Qi = (le1, bt, ls, ho)=>{
                            const Dl = vt.aN(le1, 1, bt) / (vt.a5 * Math.pow(2, le1.tileID.overscaledZ)) * 2 * Math.PI * ho;
                            return {
                                u_extrude_scale: vt.aN(le1, 1, bt),
                                u_intensity: ls,
                                u_globe_extrude_scale: Dl
                            };
                        }, Ji = (le1, bt, ls, ho)=>{
                            const Dl = vt.N();
                            vt.c7(Dl, 0, le1.width, le1.height, 0, 0, 1);
                            const Fl = le1.context.gl;
                            return {
                                u_matrix: Dl,
                                u_world: [
                                    Fl.drawingBufferWidth,
                                    Fl.drawingBufferHeight
                                ],
                                u_image: ls,
                                u_color_ramp: ho,
                                u_opacity: bt.paint.get("heatmap-opacity")
                            };
                        }, ea = (le1, vt, bt)=>{
                            const ls = bt.paint.get("hillshade-accent-color");
                            let ho;
                            switch(bt.paint.get("hillshade-method")){
                                case "basic":
                                    ho = 4;
                                    break;
                                case "combined":
                                    ho = 1;
                                    break;
                                case "igor":
                                    ho = 2;
                                    break;
                                case "multidirectional":
                                    ho = 3;
                                    break;
                                default:
                                    ho = 0;
                            }
                            const Dl = bt.getIlluminationProperties();
                            for(let Fl = 0; Fl < Dl.directionRadians.length; Fl++)"viewport" === bt.paint.get("hillshade-illumination-anchor") && (Dl.directionRadians[Fl] += le1.transform.bearingInRadians);
                            return {
                                u_image: 0,
                                u_latrange: ia(0, vt.tileID),
                                u_exaggeration: bt.paint.get("hillshade-exaggeration"),
                                u_altitudes: Dl.altitudeRadians,
                                u_azimuths: Dl.directionRadians,
                                u_accent: ls,
                                u_method: ho,
                                u_highlights: Dl.highlightColor,
                                u_shadows: Dl.shadowColor
                            };
                        }, ta = (le1, bt)=>{
                            const ls = bt.stride, ho = vt.N();
                            return vt.c7(ho, 0, vt.a5, -vt.a5, 0, 0, 1), vt.O(ho, ho, [
                                0,
                                -vt.a5,
                                0
                            ]), {
                                u_matrix: ho,
                                u_image: 1,
                                u_dimension: [
                                    ls,
                                    ls
                                ],
                                u_zoom: le1.overscaledZ,
                                u_unpack: bt.getUnpackVector()
                            };
                        };
                        function ia(le1, bt) {
                            const ls = Math.pow(2, bt.canonical.z), ho = bt.canonical.y;
                            return [
                                new vt.a9(0, ho / ls).toLngLat().lat,
                                new vt.a9(0, (ho + 1) / ls).toLngLat().lat
                            ];
                        }
                        const aa = (le1, vt, bt = 0)=>({
                                u_image: 0,
                                u_unpack: vt.getUnpackVector(),
                                u_dimension: [
                                    vt.stride,
                                    vt.stride
                                ],
                                u_elevation_stops: 1,
                                u_color_stops: 4,
                                u_color_ramp_size: bt,
                                u_opacity: le1.paint.get("color-relief-opacity")
                            }), oa = (le1, bt, ls, ho)=>{
                            const Dl = le1.transform;
                            return {
                                u_translation: ha(le1, bt, ls),
                                u_ratio: ho / vt.aN(bt, 1, Dl.zoom),
                                u_device_pixel_ratio: le1.pixelRatio,
                                u_units_to_pixels: [
                                    1 / Dl.pixelsToGLUnits[0],
                                    1 / Dl.pixelsToGLUnits[1]
                                ]
                            };
                        }, ra = (le1, bt, ls, ho, Dl)=>vt.e(oa(le1, bt, ls, ho), {
                                u_image: 0,
                                u_image_height: Dl
                            }), sa = (le1, bt, ls, ho, Dl)=>{
                            const Fl = le1.transform, sc = ca(bt, Fl);
                            return {
                                u_translation: ha(le1, bt, ls),
                                u_texsize: bt.imageAtlasTexture.size,
                                u_ratio: ho / vt.aN(bt, 1, Fl.zoom),
                                u_device_pixel_ratio: le1.pixelRatio,
                                u_image: 0,
                                u_scale: [
                                    sc,
                                    Dl.fromScale,
                                    Dl.toScale
                                ],
                                u_fade: Dl.t,
                                u_units_to_pixels: [
                                    1 / Fl.pixelsToGLUnits[0],
                                    1 / Fl.pixelsToGLUnits[1]
                                ]
                            };
                        }, na = (le1, bt, ls, ho, Dl)=>{
                            const Fl = ca(bt, le1.transform);
                            return vt.e(oa(le1, bt, ls, ho), {
                                u_tileratio: Fl,
                                u_crossfade_from: Dl.fromScale,
                                u_crossfade_to: Dl.toScale,
                                u_image: 0,
                                u_mix: Dl.t,
                                u_lineatlas_width: le1.lineAtlas.width,
                                u_lineatlas_height: le1.lineAtlas.height
                            });
                        }, la = (le1, bt, ls, ho, Dl, Fl)=>{
                            const sc = ca(bt, le1.transform);
                            return vt.e(oa(le1, bt, ls, ho), {
                                u_image: 0,
                                u_image_height: Fl,
                                u_tileratio: sc,
                                u_crossfade_from: Dl.fromScale,
                                u_crossfade_to: Dl.toScale,
                                u_image_dash: 1,
                                u_mix: Dl.t,
                                u_lineatlas_width: le1.lineAtlas.width,
                                u_lineatlas_height: le1.lineAtlas.height
                            });
                        };
                        function ca(le1, bt) {
                            return 1 / vt.aN(le1, 1, bt.tileZoom);
                        }
                        function ha(le1, bt, ls) {
                            return vt.aO(le1.transform, bt, ls.paint.get("line-translate"), ls.paint.get("line-translate-anchor"));
                        }
                        const ua = (le1, vt, bt, ls, ho)=>{
                            var Dl, Fl;
                            return {
                                u_tl_parent: le1,
                                u_scale_parent: vt,
                                u_buffer_scale: 1,
                                u_fade_t: bt.mix,
                                u_opacity: bt.opacity * ls.paint.get("raster-opacity"),
                                u_image0: 0,
                                u_image1: 1,
                                u_brightness_low: ls.paint.get("raster-brightness-min"),
                                u_brightness_high: ls.paint.get("raster-brightness-max"),
                                u_saturation_factor: (Fl = ls.paint.get("raster-saturation"), Fl > 0 ? 1 - 1 / (1.001 - Fl) : -Fl),
                                u_contrast_factor: (Dl = ls.paint.get("raster-contrast"), Dl > 0 ? 1 / (1 - Dl) : 1 + Dl),
                                u_spin_weights: da(ls.paint.get("raster-hue-rotate")),
                                u_coords_top: [
                                    ho[0].x,
                                    ho[0].y,
                                    ho[1].x,
                                    ho[1].y
                                ],
                                u_coords_bottom: [
                                    ho[3].x,
                                    ho[3].y,
                                    ho[2].x,
                                    ho[2].y
                                ]
                            };
                        };
                        function da(le1) {
                            le1 *= Math.PI / 180;
                            const vt = Math.sin(le1), bt = Math.cos(le1);
                            return [
                                (2 * bt + 1) / 3,
                                (-Math.sqrt(3) * vt - bt + 1) / 3,
                                (Math.sqrt(3) * vt - bt + 1) / 3
                            ];
                        }
                        const _a = (le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec)=>{
                            const kc = Fl.transform;
                            return {
                                u_is_size_zoom_constant: +("constant" === le1 || "source" === le1),
                                u_is_size_feature_constant: +("constant" === le1 || "camera" === le1),
                                u_size_t: vt ? vt.uSizeT : 0,
                                u_size: vt ? vt.uSize : 0,
                                u_camera_to_center_distance: kc.cameraToCenterDistance,
                                u_pitch: kc.pitch / 360 * 2 * Math.PI,
                                u_rotate_symbol: +bt,
                                u_aspect_ratio: kc.width / kc.height,
                                u_fade_change: Fl.options.fadeDuration ? Fl.symbolFadeChange : 1,
                                u_label_plane_matrix: sc,
                                u_coord_matrix: uc,
                                u_is_text: +gc,
                                u_pitch_with_map: +ls,
                                u_is_along_line: ho,
                                u_is_variable_anchor: Dl,
                                u_texsize: Ac,
                                u_texture: 0,
                                u_translation: mc,
                                u_pitched_scale: Ec
                            };
                        }, pa = (le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du)=>{
                            const _u = sc.transform;
                            return vt.e(_a(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, du), {
                                u_gamma_scale: ho ? Math.cos(_u.pitch * Math.PI / 180) * _u.cameraToCenterDistance : 1,
                                u_device_pixel_ratio: sc.pixelRatio,
                                u_is_halo: 1
                            });
                        }, ma = (le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc)=>vt.e(pa(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, !0, Ac, 0, kc), {
                                u_texsize_icon: Ec,
                                u_texture_icon: 1
                            }), fa = (le1, vt)=>({
                                u_opacity: le1,
                                u_color: vt
                            }), ga = (le1, bt, ls, ho, Dl)=>vt.e(function(le1, bt, ls, ho) {
                                const Dl = ls.imageManager.getPattern(le1.from.toString()), Fl = ls.imageManager.getPattern(le1.to.toString()), { width: sc, height: uc } = ls.imageManager.getPixelSize(), mc = Math.pow(2, ho.tileID.overscaledZ), gc = ho.tileSize * Math.pow(2, ls.transform.tileZoom) / mc, Ac = gc * (ho.tileID.canonical.x + ho.tileID.wrap * mc), Ec = gc * ho.tileID.canonical.y;
                                return {
                                    u_image: 0,
                                    u_pattern_tl_a: Dl.tl,
                                    u_pattern_br_a: Dl.br,
                                    u_pattern_tl_b: Fl.tl,
                                    u_pattern_br_b: Fl.br,
                                    u_texsize: [
                                        sc,
                                        uc
                                    ],
                                    u_mix: bt.t,
                                    u_pattern_size_a: Dl.displaySize,
                                    u_pattern_size_b: Fl.displaySize,
                                    u_scale_a: bt.fromScale,
                                    u_scale_b: bt.toScale,
                                    u_tile_units_to_pixels: 1 / vt.aN(ho, 1, ls.transform.tileZoom),
                                    u_pixel_coord_upper: [
                                        Ac >> 16,
                                        Ec >> 16
                                    ],
                                    u_pixel_coord_lower: [
                                        65535 & Ac,
                                        65535 & Ec
                                    ]
                                };
                            }(ls, Dl, bt, ho), {
                                u_opacity: le1
                            }), va = (le1, vt)=>{}, vm = {
                            fillExtrusion: (le1, bt)=>({
                                    u_lightpos: new vt.c2(le1, bt.u_lightpos),
                                    u_lightpos_globe: new vt.c2(le1, bt.u_lightpos_globe),
                                    u_lightintensity: new vt.bq(le1, bt.u_lightintensity),
                                    u_lightcolor: new vt.c2(le1, bt.u_lightcolor),
                                    u_vertical_gradient: new vt.bq(le1, bt.u_vertical_gradient),
                                    u_opacity: new vt.bq(le1, bt.u_opacity),
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate)
                                }),
                            fillExtrusionPattern: (le1, bt)=>({
                                    u_lightpos: new vt.c2(le1, bt.u_lightpos),
                                    u_lightpos_globe: new vt.c2(le1, bt.u_lightpos_globe),
                                    u_lightintensity: new vt.bq(le1, bt.u_lightintensity),
                                    u_lightcolor: new vt.c2(le1, bt.u_lightcolor),
                                    u_vertical_gradient: new vt.bq(le1, bt.u_vertical_gradient),
                                    u_height_factor: new vt.bq(le1, bt.u_height_factor),
                                    u_opacity: new vt.bq(le1, bt.u_opacity),
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_pixel_coord_upper: new vt.c3(le1, bt.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new vt.c3(le1, bt.u_pixel_coord_lower),
                                    u_scale: new vt.c2(le1, bt.u_scale),
                                    u_fade: new vt.bq(le1, bt.u_fade)
                                }),
                            fill: (le1, bt)=>({
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate)
                                }),
                            fillPattern: (le1, bt)=>({
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_pixel_coord_upper: new vt.c3(le1, bt.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new vt.c3(le1, bt.u_pixel_coord_lower),
                                    u_scale: new vt.c2(le1, bt.u_scale),
                                    u_fade: new vt.bq(le1, bt.u_fade),
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate)
                                }),
                            fillOutline: (le1, bt)=>({
                                    u_world: new vt.c3(le1, bt.u_world),
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate)
                                }),
                            fillOutlinePattern: (le1, bt)=>({
                                    u_world: new vt.c3(le1, bt.u_world),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_pixel_coord_upper: new vt.c3(le1, bt.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new vt.c3(le1, bt.u_pixel_coord_lower),
                                    u_scale: new vt.c2(le1, bt.u_scale),
                                    u_fade: new vt.bq(le1, bt.u_fade),
                                    u_fill_translate: new vt.c3(le1, bt.u_fill_translate)
                                }),
                            circle: (le1, bt)=>({
                                    u_camera_to_center_distance: new vt.bq(le1, bt.u_camera_to_center_distance),
                                    u_scale_with_map: new vt.b_(le1, bt.u_scale_with_map),
                                    u_pitch_with_map: new vt.b_(le1, bt.u_pitch_with_map),
                                    u_extrude_scale: new vt.c3(le1, bt.u_extrude_scale),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_globe_extrude_scale: new vt.bq(le1, bt.u_globe_extrude_scale),
                                    u_translate: new vt.c3(le1, bt.u_translate)
                                }),
                            collisionBox: (le1, bt)=>({
                                    u_pixel_extrude_scale: new vt.c3(le1, bt.u_pixel_extrude_scale)
                                }),
                            collisionCircle: (le1, bt)=>({
                                    u_viewport_size: new vt.c3(le1, bt.u_viewport_size)
                                }),
                            debug: (le1, bt)=>({
                                    u_color: new vt.b$(le1, bt.u_color),
                                    u_overlay: new vt.b_(le1, bt.u_overlay),
                                    u_overlay_scale: new vt.bq(le1, bt.u_overlay_scale)
                                }),
                            depth: va,
                            clippingMask: va,
                            heatmap: (le1, bt)=>({
                                    u_extrude_scale: new vt.bq(le1, bt.u_extrude_scale),
                                    u_intensity: new vt.bq(le1, bt.u_intensity),
                                    u_globe_extrude_scale: new vt.bq(le1, bt.u_globe_extrude_scale)
                                }),
                            heatmapTexture: (le1, bt)=>({
                                    u_matrix: new vt.c0(le1, bt.u_matrix),
                                    u_world: new vt.c3(le1, bt.u_world),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_color_ramp: new vt.b_(le1, bt.u_color_ramp),
                                    u_opacity: new vt.bq(le1, bt.u_opacity)
                                }),
                            hillshade: (le1, bt)=>({
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_latrange: new vt.c3(le1, bt.u_latrange),
                                    u_exaggeration: new vt.bq(le1, bt.u_exaggeration),
                                    u_altitudes: new vt.c9(le1, bt.u_altitudes),
                                    u_azimuths: new vt.c9(le1, bt.u_azimuths),
                                    u_accent: new vt.b$(le1, bt.u_accent),
                                    u_method: new vt.b_(le1, bt.u_method),
                                    u_shadows: new vt.c8(le1, bt.u_shadows),
                                    u_highlights: new vt.c8(le1, bt.u_highlights)
                                }),
                            hillshadePrepare: (le1, bt)=>({
                                    u_matrix: new vt.c0(le1, bt.u_matrix),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_dimension: new vt.c3(le1, bt.u_dimension),
                                    u_zoom: new vt.bq(le1, bt.u_zoom),
                                    u_unpack: new vt.c1(le1, bt.u_unpack)
                                }),
                            colorRelief: (le1, bt)=>({
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_unpack: new vt.c1(le1, bt.u_unpack),
                                    u_dimension: new vt.c3(le1, bt.u_dimension),
                                    u_elevation_stops: new vt.b_(le1, bt.u_elevation_stops),
                                    u_color_stops: new vt.b_(le1, bt.u_color_stops),
                                    u_color_ramp_size: new vt.b_(le1, bt.u_color_ramp_size),
                                    u_opacity: new vt.bq(le1, bt.u_opacity)
                                }),
                            line: (le1, bt)=>({
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_ratio: new vt.bq(le1, bt.u_ratio),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_units_to_pixels: new vt.c3(le1, bt.u_units_to_pixels)
                                }),
                            lineGradient: (le1, bt)=>({
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_ratio: new vt.bq(le1, bt.u_ratio),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_units_to_pixels: new vt.c3(le1, bt.u_units_to_pixels),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_image_height: new vt.bq(le1, bt.u_image_height)
                                }),
                            linePattern: (le1, bt)=>({
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_ratio: new vt.bq(le1, bt.u_ratio),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_units_to_pixels: new vt.c3(le1, bt.u_units_to_pixels),
                                    u_scale: new vt.c2(le1, bt.u_scale),
                                    u_fade: new vt.bq(le1, bt.u_fade)
                                }),
                            lineSDF: (le1, bt)=>({
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_ratio: new vt.bq(le1, bt.u_ratio),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_units_to_pixels: new vt.c3(le1, bt.u_units_to_pixels),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_mix: new vt.bq(le1, bt.u_mix),
                                    u_tileratio: new vt.bq(le1, bt.u_tileratio),
                                    u_crossfade_from: new vt.bq(le1, bt.u_crossfade_from),
                                    u_crossfade_to: new vt.bq(le1, bt.u_crossfade_to),
                                    u_lineatlas_width: new vt.bq(le1, bt.u_lineatlas_width),
                                    u_lineatlas_height: new vt.bq(le1, bt.u_lineatlas_height)
                                }),
                            lineGradientSDF: (le1, bt)=>({
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_ratio: new vt.bq(le1, bt.u_ratio),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_units_to_pixels: new vt.c3(le1, bt.u_units_to_pixels),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_image_height: new vt.bq(le1, bt.u_image_height),
                                    u_tileratio: new vt.bq(le1, bt.u_tileratio),
                                    u_crossfade_from: new vt.bq(le1, bt.u_crossfade_from),
                                    u_crossfade_to: new vt.bq(le1, bt.u_crossfade_to),
                                    u_image_dash: new vt.b_(le1, bt.u_image_dash),
                                    u_mix: new vt.bq(le1, bt.u_mix),
                                    u_lineatlas_width: new vt.bq(le1, bt.u_lineatlas_width),
                                    u_lineatlas_height: new vt.bq(le1, bt.u_lineatlas_height)
                                }),
                            raster: (le1, bt)=>({
                                    u_tl_parent: new vt.c3(le1, bt.u_tl_parent),
                                    u_scale_parent: new vt.bq(le1, bt.u_scale_parent),
                                    u_buffer_scale: new vt.bq(le1, bt.u_buffer_scale),
                                    u_fade_t: new vt.bq(le1, bt.u_fade_t),
                                    u_opacity: new vt.bq(le1, bt.u_opacity),
                                    u_image0: new vt.b_(le1, bt.u_image0),
                                    u_image1: new vt.b_(le1, bt.u_image1),
                                    u_brightness_low: new vt.bq(le1, bt.u_brightness_low),
                                    u_brightness_high: new vt.bq(le1, bt.u_brightness_high),
                                    u_saturation_factor: new vt.bq(le1, bt.u_saturation_factor),
                                    u_contrast_factor: new vt.bq(le1, bt.u_contrast_factor),
                                    u_spin_weights: new vt.c2(le1, bt.u_spin_weights),
                                    u_coords_top: new vt.c1(le1, bt.u_coords_top),
                                    u_coords_bottom: new vt.c1(le1, bt.u_coords_bottom)
                                }),
                            symbolIcon: (le1, bt)=>({
                                    u_is_size_zoom_constant: new vt.b_(le1, bt.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new vt.b_(le1, bt.u_is_size_feature_constant),
                                    u_size_t: new vt.bq(le1, bt.u_size_t),
                                    u_size: new vt.bq(le1, bt.u_size),
                                    u_camera_to_center_distance: new vt.bq(le1, bt.u_camera_to_center_distance),
                                    u_pitch: new vt.bq(le1, bt.u_pitch),
                                    u_rotate_symbol: new vt.b_(le1, bt.u_rotate_symbol),
                                    u_aspect_ratio: new vt.bq(le1, bt.u_aspect_ratio),
                                    u_fade_change: new vt.bq(le1, bt.u_fade_change),
                                    u_label_plane_matrix: new vt.c0(le1, bt.u_label_plane_matrix),
                                    u_coord_matrix: new vt.c0(le1, bt.u_coord_matrix),
                                    u_is_text: new vt.b_(le1, bt.u_is_text),
                                    u_pitch_with_map: new vt.b_(le1, bt.u_pitch_with_map),
                                    u_is_along_line: new vt.b_(le1, bt.u_is_along_line),
                                    u_is_variable_anchor: new vt.b_(le1, bt.u_is_variable_anchor),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_texture: new vt.b_(le1, bt.u_texture),
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_pitched_scale: new vt.bq(le1, bt.u_pitched_scale)
                                }),
                            symbolSDF: (le1, bt)=>({
                                    u_is_size_zoom_constant: new vt.b_(le1, bt.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new vt.b_(le1, bt.u_is_size_feature_constant),
                                    u_size_t: new vt.bq(le1, bt.u_size_t),
                                    u_size: new vt.bq(le1, bt.u_size),
                                    u_camera_to_center_distance: new vt.bq(le1, bt.u_camera_to_center_distance),
                                    u_pitch: new vt.bq(le1, bt.u_pitch),
                                    u_rotate_symbol: new vt.b_(le1, bt.u_rotate_symbol),
                                    u_aspect_ratio: new vt.bq(le1, bt.u_aspect_ratio),
                                    u_fade_change: new vt.bq(le1, bt.u_fade_change),
                                    u_label_plane_matrix: new vt.c0(le1, bt.u_label_plane_matrix),
                                    u_coord_matrix: new vt.c0(le1, bt.u_coord_matrix),
                                    u_is_text: new vt.b_(le1, bt.u_is_text),
                                    u_pitch_with_map: new vt.b_(le1, bt.u_pitch_with_map),
                                    u_is_along_line: new vt.b_(le1, bt.u_is_along_line),
                                    u_is_variable_anchor: new vt.b_(le1, bt.u_is_variable_anchor),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_texture: new vt.b_(le1, bt.u_texture),
                                    u_gamma_scale: new vt.bq(le1, bt.u_gamma_scale),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_is_halo: new vt.b_(le1, bt.u_is_halo),
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_pitched_scale: new vt.bq(le1, bt.u_pitched_scale)
                                }),
                            symbolTextAndIcon: (le1, bt)=>({
                                    u_is_size_zoom_constant: new vt.b_(le1, bt.u_is_size_zoom_constant),
                                    u_is_size_feature_constant: new vt.b_(le1, bt.u_is_size_feature_constant),
                                    u_size_t: new vt.bq(le1, bt.u_size_t),
                                    u_size: new vt.bq(le1, bt.u_size),
                                    u_camera_to_center_distance: new vt.bq(le1, bt.u_camera_to_center_distance),
                                    u_pitch: new vt.bq(le1, bt.u_pitch),
                                    u_rotate_symbol: new vt.b_(le1, bt.u_rotate_symbol),
                                    u_aspect_ratio: new vt.bq(le1, bt.u_aspect_ratio),
                                    u_fade_change: new vt.bq(le1, bt.u_fade_change),
                                    u_label_plane_matrix: new vt.c0(le1, bt.u_label_plane_matrix),
                                    u_coord_matrix: new vt.c0(le1, bt.u_coord_matrix),
                                    u_is_text: new vt.b_(le1, bt.u_is_text),
                                    u_pitch_with_map: new vt.b_(le1, bt.u_pitch_with_map),
                                    u_is_along_line: new vt.b_(le1, bt.u_is_along_line),
                                    u_is_variable_anchor: new vt.b_(le1, bt.u_is_variable_anchor),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_texsize_icon: new vt.c3(le1, bt.u_texsize_icon),
                                    u_texture: new vt.b_(le1, bt.u_texture),
                                    u_texture_icon: new vt.b_(le1, bt.u_texture_icon),
                                    u_gamma_scale: new vt.bq(le1, bt.u_gamma_scale),
                                    u_device_pixel_ratio: new vt.bq(le1, bt.u_device_pixel_ratio),
                                    u_is_halo: new vt.b_(le1, bt.u_is_halo),
                                    u_translation: new vt.c3(le1, bt.u_translation),
                                    u_pitched_scale: new vt.bq(le1, bt.u_pitched_scale)
                                }),
                            background: (le1, bt)=>({
                                    u_opacity: new vt.bq(le1, bt.u_opacity),
                                    u_color: new vt.b$(le1, bt.u_color)
                                }),
                            backgroundPattern: (le1, bt)=>({
                                    u_opacity: new vt.bq(le1, bt.u_opacity),
                                    u_image: new vt.b_(le1, bt.u_image),
                                    u_pattern_tl_a: new vt.c3(le1, bt.u_pattern_tl_a),
                                    u_pattern_br_a: new vt.c3(le1, bt.u_pattern_br_a),
                                    u_pattern_tl_b: new vt.c3(le1, bt.u_pattern_tl_b),
                                    u_pattern_br_b: new vt.c3(le1, bt.u_pattern_br_b),
                                    u_texsize: new vt.c3(le1, bt.u_texsize),
                                    u_mix: new vt.bq(le1, bt.u_mix),
                                    u_pattern_size_a: new vt.c3(le1, bt.u_pattern_size_a),
                                    u_pattern_size_b: new vt.c3(le1, bt.u_pattern_size_b),
                                    u_scale_a: new vt.bq(le1, bt.u_scale_a),
                                    u_scale_b: new vt.bq(le1, bt.u_scale_b),
                                    u_pixel_coord_upper: new vt.c3(le1, bt.u_pixel_coord_upper),
                                    u_pixel_coord_lower: new vt.c3(le1, bt.u_pixel_coord_lower),
                                    u_tile_units_to_pixels: new vt.bq(le1, bt.u_tile_units_to_pixels)
                                }),
                            terrain: (le1, bt)=>({
                                    u_texture: new vt.b_(le1, bt.u_texture),
                                    u_ele_delta: new vt.bq(le1, bt.u_ele_delta),
                                    u_fog_matrix: new vt.c0(le1, bt.u_fog_matrix),
                                    u_fog_color: new vt.b$(le1, bt.u_fog_color),
                                    u_fog_ground_blend: new vt.bq(le1, bt.u_fog_ground_blend),
                                    u_fog_ground_blend_opacity: new vt.bq(le1, bt.u_fog_ground_blend_opacity),
                                    u_horizon_color: new vt.b$(le1, bt.u_horizon_color),
                                    u_horizon_fog_blend: new vt.bq(le1, bt.u_horizon_fog_blend),
                                    u_is_globe_mode: new vt.bq(le1, bt.u_is_globe_mode)
                                }),
                            terrainDepth: (le1, bt)=>({
                                    u_ele_delta: new vt.bq(le1, bt.u_ele_delta)
                                }),
                            terrainCoords: (le1, bt)=>({
                                    u_texture: new vt.b_(le1, bt.u_texture),
                                    u_terrain_coords_id: new vt.bq(le1, bt.u_terrain_coords_id),
                                    u_ele_delta: new vt.bq(le1, bt.u_ele_delta)
                                }),
                            projectionErrorMeasurement: (le1, bt)=>({
                                    u_input: new vt.bq(le1, bt.u_input),
                                    u_output_expected: new vt.bq(le1, bt.u_output_expected)
                                }),
                            atmosphere: (le1, bt)=>({
                                    u_sun_pos: new vt.c2(le1, bt.u_sun_pos),
                                    u_atmosphere_blend: new vt.bq(le1, bt.u_atmosphere_blend),
                                    u_globe_position: new vt.c2(le1, bt.u_globe_position),
                                    u_globe_radius: new vt.bq(le1, bt.u_globe_radius),
                                    u_inv_proj_matrix: new vt.c0(le1, bt.u_inv_proj_matrix)
                                }),
                            sky: (le1, bt)=>({
                                    u_sky_color: new vt.b$(le1, bt.u_sky_color),
                                    u_horizon_color: new vt.b$(le1, bt.u_horizon_color),
                                    u_horizon: new vt.c3(le1, bt.u_horizon),
                                    u_horizon_normal: new vt.c3(le1, bt.u_horizon_normal),
                                    u_sky_horizon_blend: new vt.bq(le1, bt.u_sky_horizon_blend),
                                    u_sky_blend: new vt.bq(le1, bt.u_sky_blend)
                                })
                        };
                        class ba {
                            constructor(le1, vt, bt){
                                this.context = le1;
                                const ls = le1.gl;
                                this.buffer = ls.createBuffer(), this.dynamicDraw = Boolean(bt), this.context.unbindVAO(), le1.bindElementBuffer.set(this.buffer), ls.bufferData(ls.ELEMENT_ARRAY_BUFFER, vt.arrayBuffer, this.dynamicDraw ? ls.DYNAMIC_DRAW : ls.STATIC_DRAW), this.dynamicDraw || delete vt.arrayBuffer;
                            }
                            bind() {
                                this.context.bindElementBuffer.set(this.buffer);
                            }
                            updateData(le1) {
                                const vt = this.context.gl;
                                if (!this.dynamicDraw) throw new Error("Attempted to update data while not in dynamic mode.");
                                this.context.unbindVAO(), this.bind(), vt.bufferSubData(vt.ELEMENT_ARRAY_BUFFER, 0, le1.arrayBuffer);
                            }
                            destroy() {
                                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        const xm = {
                            Int8: "BYTE",
                            Uint8: "UNSIGNED_BYTE",
                            Int16: "SHORT",
                            Uint16: "UNSIGNED_SHORT",
                            Int32: "INT",
                            Uint32: "UNSIGNED_INT",
                            Float32: "FLOAT"
                        };
                        class wa {
                            constructor(le1, vt, bt, ls){
                                this.length = vt.length, this.attributes = bt, this.itemSize = vt.bytesPerElement, this.dynamicDraw = ls, this.context = le1;
                                const ho = le1.gl;
                                this.buffer = ho.createBuffer(), le1.bindVertexBuffer.set(this.buffer), ho.bufferData(ho.ARRAY_BUFFER, vt.arrayBuffer, this.dynamicDraw ? ho.DYNAMIC_DRAW : ho.STATIC_DRAW), this.dynamicDraw || delete vt.arrayBuffer;
                            }
                            bind() {
                                this.context.bindVertexBuffer.set(this.buffer);
                            }
                            updateData(le1) {
                                if (le1.length !== this.length) throw new Error(`Length of new data is ${le1.length}, which doesn't match current length of ${this.length}`);
                                const vt = this.context.gl;
                                this.bind(), vt.bufferSubData(vt.ARRAY_BUFFER, 0, le1.arrayBuffer);
                            }
                            enableAttributes(le1, vt) {
                                for(let bt = 0; bt < this.attributes.length; bt++){
                                    const ls = vt.attributes[this.attributes[bt].name];
                                    void 0 !== ls && le1.enableVertexAttribArray(ls);
                                }
                            }
                            setVertexAttribPointers(le1, vt, bt) {
                                for(let ls = 0; ls < this.attributes.length; ls++){
                                    const ho = this.attributes[ls], Dl = vt.attributes[ho.name];
                                    void 0 !== Dl && le1.vertexAttribPointer(Dl, ho.components, le1[xm[ho.type]], !1, this.itemSize, ho.offset + this.itemSize * (bt || 0));
                                }
                            }
                            destroy() {
                                this.buffer && (this.context.gl.deleteBuffer(this.buffer), delete this.buffer);
                            }
                        }
                        class Ta {
                            constructor(le1){
                                this.gl = le1.gl, this.default = this.getDefault(), this.current = this.default, this.dirty = !1;
                            }
                            get() {
                                return this.current;
                            }
                            set(le1) {}
                            getDefault() {
                                return this.default;
                            }
                            setDefault() {
                                this.set(this.default);
                            }
                        }
                        class Pa extends Ta {
                            getDefault() {
                                return vt.bp.transparent;
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1.r !== vt.r || le1.g !== vt.g || le1.b !== vt.b || le1.a !== vt.a || this.dirty) && (this.gl.clearColor(le1.r, le1.g, le1.b, le1.a), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ca extends Ta {
                            getDefault() {
                                return 1;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.clearDepth(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ia extends Ta {
                            getDefault() {
                                return 0;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.clearStencil(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ma extends Ta {
                            getDefault() {
                                return [
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ];
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1[0] !== vt[0] || le1[1] !== vt[1] || le1[2] !== vt[2] || le1[3] !== vt[3] || this.dirty) && (this.gl.colorMask(le1[0], le1[1], le1[2], le1[3]), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ea extends Ta {
                            getDefault() {
                                return !0;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.depthMask(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Sa extends Ta {
                            getDefault() {
                                return 255;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.stencilMask(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class za extends Ta {
                            getDefault() {
                                return {
                                    func: this.gl.ALWAYS,
                                    ref: 0,
                                    mask: 255
                                };
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1.func !== vt.func || le1.ref !== vt.ref || le1.mask !== vt.mask || this.dirty) && (this.gl.stencilFunc(le1.func, le1.ref, le1.mask), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ra extends Ta {
                            getDefault() {
                                const le1 = this.gl;
                                return [
                                    le1.KEEP,
                                    le1.KEEP,
                                    le1.KEEP
                                ];
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1[0] !== vt[0] || le1[1] !== vt[1] || le1[2] !== vt[2] || this.dirty) && (this.gl.stencilOp(le1[0], le1[1], le1[2]), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Da extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                le1 ? vt.enable(vt.STENCIL_TEST) : vt.disable(vt.STENCIL_TEST), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Aa extends Ta {
                            getDefault() {
                                return [
                                    0,
                                    1
                                ];
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1[0] !== vt[0] || le1[1] !== vt[1] || this.dirty) && (this.gl.depthRange(le1[0], le1[1]), this.current = le1, this.dirty = !1);
                            }
                        }
                        class La extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                le1 ? vt.enable(vt.DEPTH_TEST) : vt.disable(vt.DEPTH_TEST), this.current = le1, this.dirty = !1;
                            }
                        }
                        class ka extends Ta {
                            getDefault() {
                                return this.gl.LESS;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.depthFunc(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Fa extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                le1 ? vt.enable(vt.BLEND) : vt.disable(vt.BLEND), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Ba extends Ta {
                            getDefault() {
                                const le1 = this.gl;
                                return [
                                    le1.ONE,
                                    le1.ZERO
                                ];
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1[0] !== vt[0] || le1[1] !== vt[1] || this.dirty) && (this.gl.blendFunc(le1[0], le1[1]), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Oa extends Ta {
                            getDefault() {
                                return vt.bp.transparent;
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1.r !== vt.r || le1.g !== vt.g || le1.b !== vt.b || le1.a !== vt.a || this.dirty) && (this.gl.blendColor(le1.r, le1.g, le1.b, le1.a), this.current = le1, this.dirty = !1);
                            }
                        }
                        class ja extends Ta {
                            getDefault() {
                                return this.gl.FUNC_ADD;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.blendEquation(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Na extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                le1 ? vt.enable(vt.CULL_FACE) : vt.disable(vt.CULL_FACE), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Za extends Ta {
                            getDefault() {
                                return this.gl.BACK;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.cullFace(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ua extends Ta {
                            getDefault() {
                                return this.gl.CCW;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.frontFace(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Ga extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.useProgram(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Va extends Ta {
                            getDefault() {
                                return this.gl.TEXTURE0;
                            }
                            set(le1) {
                                (le1 !== this.current || this.dirty) && (this.gl.activeTexture(le1), this.current = le1, this.dirty = !1);
                            }
                        }
                        class qa extends Ta {
                            getDefault() {
                                const le1 = this.gl;
                                return [
                                    0,
                                    0,
                                    le1.drawingBufferWidth,
                                    le1.drawingBufferHeight
                                ];
                            }
                            set(le1) {
                                const vt = this.current;
                                (le1[0] !== vt[0] || le1[1] !== vt[1] || le1[2] !== vt[2] || le1[3] !== vt[3] || this.dirty) && (this.gl.viewport(le1[0], le1[1], le1[2], le1[3]), this.current = le1, this.dirty = !1);
                            }
                        }
                        class Wa extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.bindFramebuffer(vt.FRAMEBUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class $a extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.bindRenderbuffer(vt.RENDERBUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Ha extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.bindTexture(vt.TEXTURE_2D, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Xa extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.bindBuffer(vt.ARRAY_BUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Ka extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                const vt = this.gl;
                                vt.bindBuffer(vt.ELEMENT_ARRAY_BUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Ya extends Ta {
                            getDefault() {
                                return null;
                            }
                            set(le1) {
                                var vt;
                                if (le1 === this.current && !this.dirty) return;
                                const bt = this.gl;
                                ri(bt) ? bt.bindVertexArray(le1) : null === (vt = bt.getExtension("OES_vertex_array_object")) || void 0 === vt || vt.bindVertexArrayOES(le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Qa extends Ta {
                            getDefault() {
                                return 4;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.pixelStorei(vt.UNPACK_ALIGNMENT, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class Ja extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.pixelStorei(vt.UNPACK_PREMULTIPLY_ALPHA_WEBGL, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class eo extends Ta {
                            getDefault() {
                                return !1;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                const vt = this.gl;
                                vt.pixelStorei(vt.UNPACK_FLIP_Y_WEBGL, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class to extends Ta {
                            constructor(le1, vt){
                                super(le1), this.context = le1, this.parent = vt;
                            }
                            getDefault() {
                                return null;
                            }
                        }
                        class io extends to {
                            setDirty() {
                                this.dirty = !0;
                            }
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const vt = this.gl;
                                vt.framebufferTexture2D(vt.FRAMEBUFFER, vt.COLOR_ATTACHMENT0, vt.TEXTURE_2D, le1, 0), this.current = le1, this.dirty = !1;
                            }
                        }
                        class ao extends to {
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const vt = this.gl;
                                vt.framebufferRenderbuffer(vt.FRAMEBUFFER, vt.DEPTH_ATTACHMENT, vt.RENDERBUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        class oo extends to {
                            set(le1) {
                                if (le1 === this.current && !this.dirty) return;
                                this.context.bindFramebuffer.set(this.parent);
                                const vt = this.gl;
                                vt.framebufferRenderbuffer(vt.FRAMEBUFFER, vt.DEPTH_STENCIL_ATTACHMENT, vt.RENDERBUFFER, le1), this.current = le1, this.dirty = !1;
                            }
                        }
                        const bm = "Framebuffer is not complete";
                        class so {
                            constructor(le1, vt, bt, ls, ho){
                                this.context = le1, this.width = vt, this.height = bt;
                                const Dl = le1.gl, Fl = this.framebuffer = Dl.createFramebuffer();
                                if (this.colorAttachment = new io(le1, Fl), ls) this.depthAttachment = ho ? new oo(le1, Fl) : new ao(le1, Fl);
                                else if (ho) throw new Error("Stencil cannot be set without depth");
                                if (Dl.checkFramebufferStatus(Dl.FRAMEBUFFER) !== Dl.FRAMEBUFFER_COMPLETE) throw new Error(bm);
                            }
                            destroy() {
                                const le1 = this.context.gl, vt = this.colorAttachment.get();
                                if (vt && le1.deleteTexture(vt), this.depthAttachment) {
                                    const vt = this.depthAttachment.get();
                                    vt && le1.deleteRenderbuffer(vt);
                                }
                                le1.deleteFramebuffer(this.framebuffer);
                            }
                        }
                        class no {
                            constructor(le1){
                                var vt, bt;
                                if (this.gl = le1, this.clearColor = new Pa(this), this.clearDepth = new Ca(this), this.clearStencil = new Ia(this), this.colorMask = new Ma(this), this.depthMask = new Ea(this), this.stencilMask = new Sa(this), this.stencilFunc = new za(this), this.stencilOp = new Ra(this), this.stencilTest = new Da(this), this.depthRange = new Aa(this), this.depthTest = new La(this), this.depthFunc = new ka(this), this.blend = new Fa(this), this.blendFunc = new Ba(this), this.blendColor = new Oa(this), this.blendEquation = new ja(this), this.cullFace = new Na(this), this.cullFaceSide = new Za(this), this.frontFace = new Ua(this), this.program = new Ga(this), this.activeTexture = new Va(this), this.viewport = new qa(this), this.bindFramebuffer = new Wa(this), this.bindRenderbuffer = new $a(this), this.bindTexture = new Ha(this), this.bindVertexBuffer = new Xa(this), this.bindElementBuffer = new Ka(this), this.bindVertexArray = new Ya(this), this.pixelStoreUnpack = new Qa(this), this.pixelStoreUnpackPremultiplyAlpha = new Ja(this), this.pixelStoreUnpackFlipY = new eo(this), this.extTextureFilterAnisotropic = le1.getExtension("EXT_texture_filter_anisotropic") || le1.getExtension("MOZ_EXT_texture_filter_anisotropic") || le1.getExtension("WEBKIT_EXT_texture_filter_anisotropic"), this.extTextureFilterAnisotropic && (this.extTextureFilterAnisotropicMax = le1.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)), this.maxTextureSize = le1.getParameter(le1.MAX_TEXTURE_SIZE), ri(le1)) {
                                    this.HALF_FLOAT = le1.HALF_FLOAT;
                                    const ls = le1.getExtension("EXT_color_buffer_half_float");
                                    this.RGBA16F = null !== (vt = le1.RGBA16F) && void 0 !== vt ? vt : null == ls ? void 0 : ls.RGBA16F_EXT, this.RGB16F = null !== (bt = le1.RGB16F) && void 0 !== bt ? bt : null == ls ? void 0 : ls.RGB16F_EXT, le1.getExtension("EXT_color_buffer_float");
                                } else {
                                    le1.getExtension("EXT_color_buffer_half_float"), le1.getExtension("OES_texture_half_float_linear");
                                    const vt = le1.getExtension("OES_texture_half_float");
                                    this.HALF_FLOAT = null == vt ? void 0 : vt.HALF_FLOAT_OES;
                                }
                            }
                            setDefault() {
                                this.unbindVAO(), this.clearColor.setDefault(), this.clearDepth.setDefault(), this.clearStencil.setDefault(), this.colorMask.setDefault(), this.depthMask.setDefault(), this.stencilMask.setDefault(), this.stencilFunc.setDefault(), this.stencilOp.setDefault(), this.stencilTest.setDefault(), this.depthRange.setDefault(), this.depthTest.setDefault(), this.depthFunc.setDefault(), this.blend.setDefault(), this.blendFunc.setDefault(), this.blendColor.setDefault(), this.blendEquation.setDefault(), this.cullFace.setDefault(), this.cullFaceSide.setDefault(), this.frontFace.setDefault(), this.program.setDefault(), this.activeTexture.setDefault(), this.bindFramebuffer.setDefault(), this.pixelStoreUnpack.setDefault(), this.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.pixelStoreUnpackFlipY.setDefault();
                            }
                            setDirty() {
                                this.clearColor.dirty = !0, this.clearDepth.dirty = !0, this.clearStencil.dirty = !0, this.colorMask.dirty = !0, this.depthMask.dirty = !0, this.stencilMask.dirty = !0, this.stencilFunc.dirty = !0, this.stencilOp.dirty = !0, this.stencilTest.dirty = !0, this.depthRange.dirty = !0, this.depthTest.dirty = !0, this.depthFunc.dirty = !0, this.blend.dirty = !0, this.blendFunc.dirty = !0, this.blendColor.dirty = !0, this.blendEquation.dirty = !0, this.cullFace.dirty = !0, this.cullFaceSide.dirty = !0, this.frontFace.dirty = !0, this.program.dirty = !0, this.activeTexture.dirty = !0, this.viewport.dirty = !0, this.bindFramebuffer.dirty = !0, this.bindRenderbuffer.dirty = !0, this.bindTexture.dirty = !0, this.bindVertexBuffer.dirty = !0, this.bindElementBuffer.dirty = !0, this.bindVertexArray.dirty = !0, this.pixelStoreUnpack.dirty = !0, this.pixelStoreUnpackPremultiplyAlpha.dirty = !0, this.pixelStoreUnpackFlipY.dirty = !0;
                            }
                            createIndexBuffer(le1, vt) {
                                return new ba(this, le1, vt);
                            }
                            createVertexBuffer(le1, vt, bt) {
                                return new wa(this, le1, vt, bt);
                            }
                            createRenderbuffer(le1, vt, bt) {
                                const ls = this.gl, ho = ls.createRenderbuffer();
                                return this.bindRenderbuffer.set(ho), ls.renderbufferStorage(ls.RENDERBUFFER, le1, vt, bt), this.bindRenderbuffer.set(null), ho;
                            }
                            createFramebuffer(le1, vt, bt, ls) {
                                return new so(this, le1, vt, bt, ls);
                            }
                            clear({ color: le1, depth: vt, stencil: bt }) {
                                const ls = this.gl;
                                let ho = 0;
                                le1 && (ho |= ls.COLOR_BUFFER_BIT, this.clearColor.set(le1), this.colorMask.set([
                                    !0,
                                    !0,
                                    !0,
                                    !0
                                ])), void 0 !== vt && (ho |= ls.DEPTH_BUFFER_BIT, this.depthRange.set([
                                    0,
                                    1
                                ]), this.clearDepth.set(vt), this.depthMask.set(!0)), void 0 !== bt && (ho |= ls.STENCIL_BUFFER_BIT, this.clearStencil.set(bt), this.stencilMask.set(255)), ls.clear(ho);
                            }
                            setCullFace(le1) {
                                !1 === le1.enable ? this.cullFace.set(!1) : (this.cullFace.set(!0), this.cullFaceSide.set(le1.mode), this.frontFace.set(le1.frontFace));
                            }
                            setDepthMode(le1) {
                                le1.func !== this.gl.ALWAYS || le1.mask ? (this.depthTest.set(!0), this.depthFunc.set(le1.func), this.depthMask.set(le1.mask), this.depthRange.set(le1.range)) : this.depthTest.set(!1);
                            }
                            setStencilMode(le1) {
                                le1.test.func !== this.gl.ALWAYS || le1.mask ? (this.stencilTest.set(!0), this.stencilMask.set(le1.mask), this.stencilOp.set([
                                    le1.fail,
                                    le1.depthFail,
                                    le1.pass
                                ]), this.stencilFunc.set({
                                    func: le1.test.func,
                                    ref: le1.ref,
                                    mask: le1.test.mask
                                })) : this.stencilTest.set(!1);
                            }
                            setColorMode(le1) {
                                vt.bR(le1.blendFunction, Qt.Replace) ? this.blend.set(!1) : (this.blend.set(!0), this.blendFunc.set(le1.blendFunction), this.blendColor.set(le1.blendColor)), this.colorMask.set(le1.mask);
                            }
                            createVertexArray() {
                                var le1;
                                return ri(this.gl) ? this.gl.createVertexArray() : null === (le1 = this.gl.getExtension("OES_vertex_array_object")) || void 0 === le1 ? void 0 : le1.createVertexArrayOES();
                            }
                            deleteVertexArray(le1) {
                                var vt;
                                return ri(this.gl) ? this.gl.deleteVertexArray(le1) : null === (vt = this.gl.getExtension("OES_vertex_array_object")) || void 0 === vt ? void 0 : vt.deleteVertexArrayOES(le1);
                            }
                            unbindVAO() {
                                this.bindVertexArray.set(null);
                            }
                        }
                        let wm;
                        function co(le1, bt, ls, ho, Dl) {
                            const Fl = le1.context, sc = le1.transform, uc = Fl.gl, mc = le1.useProgram("collisionBox"), gc = [];
                            let Ac = 0, Ec = 0;
                            for(let vt = 0; vt < ho.length; vt++){
                                const kc = ho[vt], du = bt.getTile(kc).getBucket(ls);
                                if (!du) continue;
                                const _u = Dl ? du.textCollisionBox : du.iconCollisionBox, Md = du.collisionCircleArray;
                                Md.length > 0 && (gc.push({
                                    circleArray: Md,
                                    circleOffset: Ec,
                                    coord: kc
                                }), Ac += Md.length / 4, Ec = Ac), _u && mc.draw(Fl, uc.LINES, ti.disabled, ai.disabled, le1.colorModeForRenderPass(), ei.disabled, Xi(le1.transform), le1.style.map.terrain && le1.style.map.terrain.getTerrainData(kc), sc.getProjectionData({
                                    overscaledTileID: kc,
                                    applyGlobeMatrix: !0,
                                    applyTerrainMatrix: !0
                                }), ls.id, _u.layoutVertexBuffer, _u.indexBuffer, _u.segments, null, le1.transform.zoom, null, null, _u.collisionVertexBuffer);
                            }
                            if (!Dl || !gc.length) return;
                            const kc = le1.useProgram("collisionCircle"), du = new vt.ca;
                            du.resize(4 * Ac), du._trim();
                            let _u = 0;
                            for (const vt of gc)for(let le1 = 0; le1 < vt.circleArray.length / 4; le1++){
                                const bt = 4 * le1, ls = vt.circleArray[bt + 0], ho = vt.circleArray[bt + 1], Dl = vt.circleArray[bt + 2], Fl = vt.circleArray[bt + 3];
                                du.emplace(_u++, ls, ho, Dl, Fl, 0), du.emplace(_u++, ls, ho, Dl, Fl, 1), du.emplace(_u++, ls, ho, Dl, Fl, 2), du.emplace(_u++, ls, ho, Dl, Fl, 3);
                            }
                            (!wm || wm.length < 2 * Ac) && (wm = function(le1) {
                                const bt = 2 * le1, ls = new vt.cc;
                                ls.resize(bt), ls._trim();
                                for(let vt = 0; vt < bt; vt++){
                                    const le1 = 6 * vt;
                                    ls.uint16[le1 + 0] = 4 * vt + 0, ls.uint16[le1 + 1] = 4 * vt + 1, ls.uint16[le1 + 2] = 4 * vt + 2, ls.uint16[le1 + 3] = 4 * vt + 2, ls.uint16[le1 + 4] = 4 * vt + 3, ls.uint16[le1 + 5] = 4 * vt + 0;
                                }
                                return ls;
                            }(Ac));
                            const Md = Fl.createIndexBuffer(wm, !0), Ld = Fl.createVertexBuffer(du, vt.cb.members, !0);
                            for (const Nd of gc){
                                const bt = Ki(le1.transform);
                                kc.draw(Fl, uc.TRIANGLES, ti.disabled, ai.disabled, le1.colorModeForRenderPass(), ei.disabled, bt, le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Nd.coord), null, ls.id, Ld, Md, vt.aX.simpleSegment(0, 2 * Nd.circleOffset, Nd.circleArray.length, Nd.circleArray.length / 2), null, le1.transform.zoom, null, null, null);
                            }
                            Ld.destroy(), Md.destroy();
                        }
                        const Em = vt.ar(new Float32Array(16));
                        function uo(le1, bt, ls, ho, Dl, Fl) {
                            const { horizontalAlign: sc, verticalAlign: uc } = vt.aS(le1);
                            return new vt.P((-(sc - .5) * bt / Dl + ho[0]) * Fl, (-(uc - .5) * ls / Dl + ho[1]) * Fl);
                        }
                        function _o(le1, bt, ls, ho, Dl, Fl) {
                            const sc = bt.tileAnchorPoint.add(new vt.P(bt.translation[0], bt.translation[1]));
                            if (bt.pitchWithMap) {
                                let le1 = ho.mult(Fl);
                                ls || (le1 = le1.rotate(-Dl));
                                const vt = sc.add(le1);
                                return Ue(vt.x, vt.y, bt.pitchedLabelPlaneMatrix, bt.getElevation).point;
                            }
                            if (ls) {
                                const vt = Ye(bt.tileAnchorPoint.x + 1, bt.tileAnchorPoint.y, bt).point.sub(le1), ls = Math.atan(vt.y / vt.x) + (vt.x < 0 ? Math.PI : 0);
                                return le1.add(ho.rotate(ls));
                            }
                            return le1.add(ho);
                        }
                        function po(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec) {
                            const kc = le1.text.placedSymbolArray, du = le1.text.dynamicLayoutVertexArray, _u = le1.icon.dynamicLayoutVertexArray, Md = {};
                            du.clear();
                            for(let Ld = 0; Ld < kc.length; Ld++){
                                const _u = kc.get(Ld), Nd = _u.hidden || !_u.crossTileID || le1.allowVerticalPlacement && !_u.placedOrientation ? null : ho[_u.crossTileID];
                                if (Nd) {
                                    const ho = new vt.P(_u.anchorX, _u.anchorY), kc = {
                                        getElevation: Ec,
                                        width: Dl.width,
                                        height: Dl.height,
                                        pitchedLabelPlaneMatrix: Fl,
                                        pitchWithMap: ls,
                                        transform: Dl,
                                        tileAnchorPoint: ho,
                                        translation: gc,
                                        unwrappedTileID: Ac
                                    }, Ld = ls ? Je(ho.x, ho.y, kc) : Ye(ho.x, ho.y, kc), Rd = Ge(Dl.cameraToCenterDistance, Ld.signedDistanceFromCamera);
                                    let Od = vt.aA(le1.textSizeData, uc, _u) * Rd / vt.aM;
                                    ls && (Od *= le1.tilePixelRatio / sc);
                                    const { width: jd, height: Ud, anchor: Gd, textOffset: qd, textBoxScale: Hd } = Nd, Wd = uo(Gd, jd, Ud, qd, Hd, Od), Zd = Dl.getPitchedTextCorrection(ho.x + gc[0], ho.y + gc[1], Ac), Yd = _o(Ld.point, kc, bt, Wd, -Dl.bearingInRadians, Zd), Qd = le1.allowVerticalPlacement && _u.placedOrientation === vt.az.vertical ? Math.PI / 2 : 0;
                                    for(let le1 = 0; le1 < _u.numGlyphs; le1++)vt.aG(du, Yd, Qd);
                                    mc && _u.associatedIconIndex >= 0 && (Md[_u.associatedIconIndex] = {
                                        shiftedAnchor: Yd,
                                        angle: Qd
                                    });
                                } else ot(_u.numGlyphs, du);
                            }
                            if (mc) {
                                _u.clear();
                                const bt = le1.icon.placedSymbolArray;
                                for(let le1 = 0; le1 < bt.length; le1++){
                                    const ls = bt.get(le1);
                                    if (ls.hidden) ot(ls.numGlyphs, _u);
                                    else {
                                        const bt = Md[le1];
                                        if (bt) for(let le1 = 0; le1 < ls.numGlyphs; le1++)vt.aG(_u, bt.shiftedAnchor, bt.angle);
                                        else ot(ls.numGlyphs, _u);
                                    }
                                }
                                le1.icon.dynamicLayoutVertexBuffer.updateData(_u);
                            }
                            le1.text.dynamicLayoutVertexBuffer.updateData(du);
                        }
                        function mo(le1, vt, bt) {
                            return bt.iconsInText && vt ? "symbolTextAndIcon" : le1 ? "symbolSDF" : "symbolIcon";
                        }
                        function fo(le1, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc) {
                            const du = le1.context, _u = du.gl, Md = le1.transform, Ld = "map" === uc, Nd = "map" === mc, Rd = "viewport" !== uc && "point" !== ls.layout.get("symbol-placement"), Od = Ld && !Nd && !Rd, jd = !ls.layout.get("symbol-sort-key").isConstant();
                            let Ud = !1;
                            const Gd = le1.getDepthModeForSublayer(0, ti.ReadOnly), qd = ls._unevaluatedLayout.hasValue("text-variable-anchor") || ls._unevaluatedLayout.hasValue("text-variable-anchor-offset"), Hd = [], Wd = Md.getCircleRadiusCorrection();
                            for (const Zd of ho){
                                const ho = bt.getTile(Zd), uc = ho.getBucket(ls);
                                if (!uc) continue;
                                const mc = Dl ? uc.text : uc.icon;
                                if (!mc || !mc.segments.get().length || !mc.hasVisibleVertices) continue;
                                const Ac = mc.programConfigurations.get(ls.id), Ec = Dl || uc.sdfIcons, du = Dl ? uc.textSizeData : uc.iconSizeData, Gd = Nd || 0 !== Md.pitch, Yd = le1.useProgram(mo(Ec, Dl, uc), Ac), Qd = vt.ay(du, Md.zoom), Xd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Zd);
                                let Kd, Jd, $d, sp, em = [
                                    0,
                                    0
                                ], tm = null;
                                if (Dl) Jd = ho.glyphAtlasTexture, $d = _u.LINEAR, Kd = ho.glyphAtlasTexture.size, uc.iconsInText && (em = ho.imageAtlasTexture.size, tm = ho.imageAtlasTexture, sp = Gd || le1.options.rotating || le1.options.zooming || "composite" === du.kind || "camera" === du.kind ? _u.LINEAR : _u.NEAREST);
                                else {
                                    const vt = 1 !== ls.layout.get("icon-size").constantOr(0) || uc.iconsNeedLinear;
                                    Jd = ho.imageAtlasTexture, $d = Ec || le1.options.rotating || le1.options.zooming || vt || Gd ? _u.LINEAR : _u.NEAREST, Kd = ho.imageAtlasTexture.size;
                                }
                                const im = vt.aN(ho, 1, le1.transform.zoom), nm = je(Ld, le1.transform, im), rm = vt.N();
                                vt.aB(rm, nm);
                                const am = Ne(Nd, Ld, le1.transform, im), sm = vt.aO(Md, ho, Fl, sc), om = Md.getProjectionData({
                                    overscaledTileID: Zd,
                                    applyGlobeMatrix: !kc,
                                    applyTerrainMatrix: !0
                                }), lm = qd && uc.hasTextData(), cm = "none" !== ls.layout.get("icon-text-fit") && lm && uc.hasIconData();
                                if (Rd) {
                                    const vt = le1.style.map.terrain ? (vt, bt)=>le1.style.map.terrain.getElevation(Zd, vt, bt) : null, bt = "map" === ls.layout.get("text-rotation-alignment");
                                    qe(uc, le1, Dl, nm, rm, Nd, gc, bt, Zd.toUnwrapped(), Md.width, Md.height, sm, vt);
                                }
                                const um = Dl && qd || cm, hm = Rd || um ? Em : Nd ? nm : le1.transform.clipSpaceToPixelsMatrix, dm = Ec && 0 !== ls.paint.get(Dl ? "text-halo-width" : "icon-halo-width").constantOr(1);
                                let pm;
                                pm = Ec ? uc.iconsInText ? ma(du.kind, Qd, Od, Nd, Rd, um, le1, hm, am, sm, Kd, em, Wd) : pa(du.kind, Qd, Od, Nd, Rd, um, le1, hm, am, sm, Dl, Kd, 0, Wd) : _a(du.kind, Qd, Od, Nd, Rd, um, le1, hm, am, sm, Dl, Kd, Wd);
                                const mm = {
                                    program: Yd,
                                    buffers: mc,
                                    uniformValues: pm,
                                    projectionData: om,
                                    atlasTexture: Jd,
                                    atlasTextureIcon: tm,
                                    atlasInterpolation: $d,
                                    atlasInterpolationIcon: sp,
                                    isSDF: Ec,
                                    hasHalo: dm
                                };
                                if (jd && uc.canOverlap) {
                                    Ud = !0;
                                    const le1 = mc.segments.get();
                                    for (const bt of le1)Hd.push({
                                        segments: new vt.aX([
                                            bt
                                        ]),
                                        sortKey: bt.sortKey,
                                        state: mm,
                                        terrainData: Xd
                                    });
                                } else Hd.push({
                                    segments: mc.segments,
                                    sortKey: 0,
                                    state: mm,
                                    terrainData: Xd
                                });
                            }
                            Ud && Hd.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                            for (const vt of Hd){
                                const bt = vt.state;
                                if (du.activeTexture.set(_u.TEXTURE0), bt.atlasTexture.bind(bt.atlasInterpolation, _u.CLAMP_TO_EDGE), bt.atlasTextureIcon && (du.activeTexture.set(_u.TEXTURE1), bt.atlasTextureIcon && bt.atlasTextureIcon.bind(bt.atlasInterpolationIcon, _u.CLAMP_TO_EDGE)), bt.isSDF) {
                                    const ho = bt.uniformValues;
                                    bt.hasHalo && (ho.u_is_halo = 1, go(bt.buffers, vt.segments, ls, le1, bt.program, Gd, Ac, Ec, ho, bt.projectionData, vt.terrainData)), ho.u_is_halo = 0;
                                }
                                go(bt.buffers, vt.segments, ls, le1, bt.program, Gd, Ac, Ec, bt.uniformValues, bt.projectionData, vt.terrainData);
                            }
                        }
                        function go(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc) {
                            const Ac = ls.context;
                            ho.draw(Ac, Ac.gl.TRIANGLES, Dl, Fl, sc, ei.backCCW, uc, gc, mc, bt.id, le1.layoutVertexBuffer, le1.indexBuffer, vt, bt.paint, ls.transform.zoom, le1.programConfigurations.get(bt.id), le1.dynamicLayoutVertexBuffer, le1.opacityVertexBuffer);
                        }
                        function vo(le1, bt, ls, ho, Dl) {
                            const Fl = le1.context, sc = Fl.gl, uc = ai.disabled, mc = new Qt([
                                sc.ONE,
                                sc.ONE
                            ], vt.bp.transparent, [
                                !0,
                                !0,
                                !0,
                                !0
                            ]), gc = bt.getBucket(ls);
                            if (!gc) return;
                            const Ac = ho.key;
                            let Ec = ls.heatmapFbos.get(Ac);
                            Ec || (Ec = bo(Fl, bt.tileSize, bt.tileSize), ls.heatmapFbos.set(Ac, Ec)), Fl.bindFramebuffer.set(Ec.framebuffer), Fl.viewport.set([
                                0,
                                0,
                                bt.tileSize,
                                bt.tileSize
                            ]), Fl.clear({
                                color: vt.bp.transparent
                            });
                            const kc = gc.programConfigurations.get(ls.id), du = le1.useProgram("heatmap", kc, !Dl), _u = le1.transform.getProjectionData({
                                overscaledTileID: bt.tileID,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !0
                            }), Md = le1.style.map.terrain.getTerrainData(ho);
                            du.draw(Fl, sc.TRIANGLES, ti.disabled, uc, mc, ei.disabled, Qi(bt, le1.transform.zoom, ls.paint.get("heatmap-intensity"), 1), Md, _u, ls.id, gc.layoutVertexBuffer, gc.indexBuffer, gc.segments, ls.paint, le1.transform.zoom, kc);
                        }
                        function xo(le1, vt, bt, ls, ho) {
                            const Dl = le1.context, Fl = Dl.gl, sc = le1.transform;
                            Dl.setColorMode(le1.colorModeForRenderPass());
                            const uc = yo(Dl, vt), mc = bt.key, gc = vt.heatmapFbos.get(mc);
                            if (!gc) return;
                            Dl.activeTexture.set(Fl.TEXTURE0), Fl.bindTexture(Fl.TEXTURE_2D, gc.colorAttachment.get()), Dl.activeTexture.set(Fl.TEXTURE1), uc.bind(Fl.LINEAR, Fl.CLAMP_TO_EDGE);
                            const Ac = sc.getProjectionData({
                                overscaledTileID: bt,
                                applyTerrainMatrix: ho,
                                applyGlobeMatrix: !ls
                            });
                            le1.useProgram("heatmapTexture").draw(Dl, Fl.TRIANGLES, ti.disabled, ai.disabled, le1.colorModeForRenderPass(), ei.disabled, Ji(le1, vt, 0, 1), null, Ac, vt.id, le1.rasterBoundsBuffer, le1.quadTriangleIndexBuffer, le1.rasterBoundsSegments, vt.paint, sc.zoom), gc.destroy(), vt.heatmapFbos.delete(mc);
                        }
                        function bo(le1, vt, bt) {
                            var ls, ho;
                            const Dl = le1.gl, Fl = Dl.createTexture();
                            Dl.bindTexture(Dl.TEXTURE_2D, Fl), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_WRAP_S, Dl.CLAMP_TO_EDGE), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_WRAP_T, Dl.CLAMP_TO_EDGE), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_MIN_FILTER, Dl.LINEAR), Dl.texParameteri(Dl.TEXTURE_2D, Dl.TEXTURE_MAG_FILTER, Dl.LINEAR);
                            const sc = null !== (ls = le1.HALF_FLOAT) && void 0 !== ls ? ls : Dl.UNSIGNED_BYTE, uc = null !== (ho = le1.RGBA16F) && void 0 !== ho ? ho : Dl.RGBA;
                            Dl.texImage2D(Dl.TEXTURE_2D, 0, uc, vt, bt, 0, Dl.RGBA, sc, null);
                            const mc = le1.createFramebuffer(vt, bt, !1, !1);
                            return mc.colorAttachment.set(Fl), mc;
                        }
                        function yo(le1, bt) {
                            return bt.colorRampTexture || (bt.colorRampTexture = new vt.T(le1, bt.colorRamp, le1.gl.RGBA)), bt.colorRampTexture;
                        }
                        function wo(le1, bt, ls, ho, Dl, Fl, sc, uc) {
                            let mc = 256;
                            if (Dl.stepInterpolant) {
                                const ho = bt.getSource().maxzoom, Dl = sc.canonical.z === ho ? Math.ceil(1 << le1.transform.maxZoom - sc.canonical.z) : 1;
                                mc = vt.an(vt.ce(Fl.maxLineLength / vt.a5 * 1024 * Dl), 256, ls.maxTextureSize);
                            }
                            return uc.gradient = vt.cf({
                                expression: Dl.gradientExpression(),
                                evaluationKey: "lineProgress",
                                resolution: mc,
                                image: uc.gradient || void 0,
                                clips: Fl.lineClipsArray
                            }), uc.texture ? uc.texture.update(uc.gradient) : uc.texture = new vt.T(ls, uc.gradient, ho.RGBA), uc.version = Dl.gradientVersion, uc.texture;
                        }
                        function To(le1, vt, bt, ls, ho) {
                            le1.activeTexture.set(vt.TEXTURE0), bt.imageAtlasTexture.bind(vt.LINEAR, vt.CLAMP_TO_EDGE), ls.updatePaintBuffers(ho);
                        }
                        function Po(le1, vt, bt, ls, ho, Dl) {
                            (ho || le1.lineAtlas.dirty) && (vt.activeTexture.set(bt.TEXTURE0), le1.lineAtlas.bind(vt)), ls.updatePaintBuffers(Dl);
                        }
                        function Co(le1, vt, bt, ls, ho, Dl, Fl) {
                            const sc = Dl.gradients[ho.id];
                            let uc = sc.texture;
                            ho.gradientVersion !== sc.version && (uc = wo(le1, vt, bt, ls, ho, Dl, Fl, sc)), bt.activeTexture.set(ls.TEXTURE0), uc.bind(ho.stepInterpolant ? ls.NEAREST : ls.LINEAR, ls.CLAMP_TO_EDGE);
                        }
                        function Io(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = Dl.gradients[ho.id];
                            let gc = mc.texture;
                            ho.gradientVersion !== mc.version && (gc = wo(le1, vt, bt, ls, ho, Dl, Fl, mc)), bt.activeTexture.set(ls.TEXTURE0), gc.bind(ho.stepInterpolant ? ls.NEAREST : ls.LINEAR, ls.CLAMP_TO_EDGE), bt.activeTexture.set(ls.TEXTURE1), le1.lineAtlas.bind(bt), sc.updatePaintBuffers(uc);
                        }
                        function Mo(le1, vt, bt, ls, ho) {
                            if (!bt || !ls || !ls.imageAtlas) return;
                            const Dl = ls.imageAtlas.patternPositions;
                            let Fl = Dl[bt.to.toString()], sc = Dl[bt.from.toString()];
                            if (!Fl && sc && (Fl = sc), !sc && Fl && (sc = Fl), !Fl || !sc) {
                                const le1 = ho.getPaintProperty(vt);
                                Fl = Dl[le1], sc = Dl[le1];
                            }
                            Fl && sc && le1.setConstantPatternPositions(Fl, sc);
                        }
                        function Eo(le1, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = le1.context.gl, gc = "fill-pattern", Ac = ls.paint.get(gc), Ec = Ac && Ac.constantOr(1), kc = ls.getCrossfadeParameters();
                            let du, _u, Md, Ld, Nd;
                            const Rd = le1.transform, Od = ls.paint.get("fill-translate"), jd = ls.paint.get("fill-translate-anchor");
                            sc ? (_u = Ec && !ls.getPaintProperty("fill-outline-color") ? "fillOutlinePattern" : "fillOutline", du = mc.LINES) : (_u = Ec ? "fillPattern" : "fill", du = mc.TRIANGLES);
                            const Ud = Ac.constantOr(null);
                            for (const Gd of ho){
                                const ho = bt.getTile(Gd);
                                if (Ec && !ho.patternsLoaded()) continue;
                                const Ac = ho.getBucket(ls);
                                if (!Ac) continue;
                                const qd = Ac.programConfigurations.get(ls.id), Hd = le1.useProgram(_u, qd), Wd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Gd);
                                Ec && (le1.context.activeTexture.set(mc.TEXTURE0), ho.imageAtlasTexture.bind(mc.LINEAR, mc.CLAMP_TO_EDGE), qd.updatePaintBuffers(kc)), Mo(qd, gc, Ud, ho, ls);
                                const Zd = Rd.getProjectionData({
                                    overscaledTileID: Gd,
                                    applyGlobeMatrix: !uc,
                                    applyTerrainMatrix: !0
                                }), Yd = vt.aO(Rd, ho, Od, jd);
                                if (sc) {
                                    Ld = Ac.indexBuffer2, Nd = Ac.segments2;
                                    const vt = [
                                        mc.drawingBufferWidth,
                                        mc.drawingBufferHeight
                                    ];
                                    Md = "fillOutlinePattern" === _u && Ec ? $i(le1, kc, ho, vt, Yd) : Wi(vt, Yd);
                                } else Ld = Ac.indexBuffer, Nd = Ac.segments, Md = Ec ? qi(le1, kc, ho, Yd) : {
                                    u_fill_translate: Yd
                                };
                                const Qd = le1.stencilModeForClipping(Gd);
                                Hd.draw(le1.context, du, Dl, Qd, Fl, ei.backCCW, Md, Wd, Zd, ls.id, Ac.layoutVertexBuffer, Ld, Nd, ls.paint, le1.transform.zoom, qd);
                            }
                        }
                        function So(le1, bt, ls, ho, Dl, Fl, sc, uc) {
                            const mc = le1.context, gc = mc.gl, Ac = "fill-extrusion-pattern", Ec = ls.paint.get(Ac), kc = Ec.constantOr(1), du = ls.getCrossfadeParameters(), _u = ls.paint.get("fill-extrusion-opacity"), Md = Ec.constantOr(null), Ld = le1.transform;
                            for (const Nd of ho){
                                const ho = bt.getTile(Nd), Ec = ho.getBucket(ls);
                                if (!Ec) continue;
                                const Rd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Nd), Od = Ec.programConfigurations.get(ls.id), jd = le1.useProgram(kc ? "fillExtrusionPattern" : "fillExtrusion", Od);
                                kc && (le1.context.activeTexture.set(gc.TEXTURE0), ho.imageAtlasTexture.bind(gc.LINEAR, gc.CLAMP_TO_EDGE), Od.updatePaintBuffers(du));
                                const Ud = Ld.getProjectionData({
                                    overscaledTileID: Nd,
                                    applyGlobeMatrix: !uc,
                                    applyTerrainMatrix: !0
                                });
                                Mo(Od, Ac, Md, ho, ls);
                                const Gd = vt.aO(Ld, ho, ls.paint.get("fill-extrusion-translate"), ls.paint.get("fill-extrusion-translate-anchor")), qd = ls.paint.get("fill-extrusion-vertical-gradient"), Hd = kc ? Vi(le1, qd, _u, Gd, Nd, du, ho) : Gi(le1, qd, _u, Gd);
                                jd.draw(mc, mc.gl.TRIANGLES, Dl, Fl, sc, ei.backCCW, Hd, Rd, Ud, ls.id, Ec.layoutVertexBuffer, Ec.indexBuffer, Ec.segments, ls.paint, le1.transform.zoom, Od, le1.style.map.terrain && Ec.centroidVertexBuffer);
                            }
                        }
                        function zo(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                            var mc;
                            const gc = le1.style.projection, Ac = le1.context, Ec = le1.transform, kc = Ac.gl, du = [
                                `#define NUM_ILLUMINATION_SOURCES ${bt.paint.get("hillshade-highlight-color").values.length}`
                            ], _u = le1.useProgram("hillshade", null, !1, du), Md = !le1.options.moving;
                            for (const Ld of ls){
                                const ls = vt.getTile(Ld), du = ls.fbo;
                                if (!du) continue;
                                const Nd = gc.getMeshFromTileID(Ac, Ld.canonical, sc, !0, "raster"), Rd = null === (mc = le1.style.map.terrain) || void 0 === mc ? void 0 : mc.getTerrainData(Ld);
                                Ac.activeTexture.set(kc.TEXTURE0), kc.bindTexture(kc.TEXTURE_2D, du.colorAttachment.get());
                                const Od = Ec.getProjectionData({
                                    overscaledTileID: Ld,
                                    aligned: Md,
                                    applyGlobeMatrix: !uc,
                                    applyTerrainMatrix: !0
                                });
                                _u.draw(Ac, kc.TRIANGLES, Dl, ho[Ld.overscaledZ], Fl, ei.backCCW, ea(le1, ls, bt), Rd, Od, bt.id, Nd.vertexBuffer, Nd.indexBuffer, Nd.segments);
                            }
                        }
                        function Ro(le1, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                            var gc;
                            const Ac = le1.style.projection, Ec = le1.context, kc = le1.transform, du = Ec.gl, _u = le1.useProgram("colorRelief"), Md = !le1.options.moving;
                            let Ld = !0, Nd = 0;
                            for (const Rd of ho){
                                const ho = bt.getTile(Rd), Od = ho.dem;
                                if (Ld) {
                                    const le1 = du.getParameter(du.MAX_TEXTURE_SIZE), { elevationTexture: vt, colorTexture: bt } = ls.getColorRampTextures(Ec, le1, Od.getUnpackVector());
                                    Ec.activeTexture.set(du.TEXTURE1), vt.bind(du.NEAREST, du.CLAMP_TO_EDGE), Ec.activeTexture.set(du.TEXTURE4), bt.bind(du.LINEAR, du.CLAMP_TO_EDGE), Ld = !1, Nd = vt.size[0];
                                }
                                if (!Od || !Od.data) continue;
                                const jd = Od.stride, Ud = Od.getPixels();
                                if (Ec.activeTexture.set(du.TEXTURE0), Ec.pixelStoreUnpackPremultiplyAlpha.set(!1), ho.demTexture = ho.demTexture || le1.getTileTexture(jd), ho.demTexture) {
                                    const le1 = ho.demTexture;
                                    le1.update(Ud, {
                                        premultiply: !1
                                    }), le1.bind(du.LINEAR, du.CLAMP_TO_EDGE);
                                } else ho.demTexture = new vt.T(Ec, Ud, du.RGBA, {
                                    premultiply: !1
                                }), ho.demTexture.bind(du.LINEAR, du.CLAMP_TO_EDGE);
                                const Gd = Ac.getMeshFromTileID(Ec, Rd.canonical, uc, !0, "raster"), qd = null === (gc = le1.style.map.terrain) || void 0 === gc ? void 0 : gc.getTerrainData(Rd), Hd = kc.getProjectionData({
                                    overscaledTileID: Rd,
                                    aligned: Md,
                                    applyGlobeMatrix: !mc,
                                    applyTerrainMatrix: !0
                                });
                                _u.draw(Ec, du.TRIANGLES, Fl, Dl[Rd.overscaledZ], sc, ei.backCCW, aa(ls, ho.dem, Nd), qd, Hd, ls.id, Gd.vertexBuffer, Gd.indexBuffer, Gd.segments);
                            }
                        }
                        const Mm = [
                            new vt.P(0, 0),
                            new vt.P(vt.a5, 0),
                            new vt.P(vt.a5, vt.a5),
                            new vt.P(0, vt.a5)
                        ];
                        function Ao(le1, vt, bt, ls, ho, Dl, Fl, sc, uc = !1, mc = !1) {
                            const gc = ls[ls.length - 1].overscaledZ, Ac = le1.context, Ec = Ac.gl, kc = le1.useProgram("raster"), du = le1.transform, _u = le1.style.projection, Md = le1.colorModeForRenderPass(), Ld = !le1.options.moving, Nd = bt.paint.get("raster-opacity"), Rd = bt.paint.get("raster-resampling"), Od = bt.paint.get("raster-fade-duration"), jd = !!le1.style.map.terrain;
                            for (const Ud of ls){
                                const ls = le1.getDepthModeForSublayer(Ud.overscaledZ - gc, 1 === Nd ? ti.ReadWrite : ti.ReadOnly, Ec.LESS), Gd = vt.getTile(Ud), qd = "nearest" === Rd ? Ec.NEAREST : Ec.LINEAR;
                                Ac.activeTexture.set(Ec.TEXTURE0), Gd.texture.bind(qd, Ec.CLAMP_TO_EDGE, Ec.LINEAR_MIPMAP_NEAREST), Ac.activeTexture.set(Ec.TEXTURE1);
                                const { parentTile: Hd, parentScaleBy: Wd, parentTopLeft: Zd, fadeValues: Yd } = Lo(Gd, vt, Od, jd);
                                Gd.fadeOpacity = Yd.tileOpacity, Hd ? (Hd.fadeOpacity = Yd.parentTileOpacity, Hd.texture.bind(qd, Ec.CLAMP_TO_EDGE, Ec.LINEAR_MIPMAP_NEAREST)) : Gd.texture.bind(qd, Ec.CLAMP_TO_EDGE, Ec.LINEAR_MIPMAP_NEAREST), Gd.texture.useMipmap && Ac.extTextureFilterAnisotropic && le1.transform.pitch > 20 && Ec.texParameterf(Ec.TEXTURE_2D, Ac.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, Ac.extTextureFilterAnisotropicMax);
                                const Qd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Ud), Xd = du.getProjectionData({
                                    overscaledTileID: Ud,
                                    aligned: Ld,
                                    applyGlobeMatrix: !mc,
                                    applyTerrainMatrix: !0
                                }), Kd = ua(Zd, Wd, Yd.fadeMix, bt, sc), Jd = _u.getMeshFromTileID(Ac, Ud.canonical, Dl, Fl, "raster");
                                kc.draw(Ac, Ec.TRIANGLES, ls, ho ? ho[Ud.overscaledZ] : ai.disabled, Md, uc ? ei.frontCCW : ei.backCCW, Kd, Qd, Xd, bt.id, Jd.vertexBuffer, Jd.indexBuffer, Jd.segments);
                            }
                        }
                        function Lo(le1, bt, ls, ho) {
                            const Dl = {
                                parentTile: null,
                                parentScaleBy: 1,
                                parentTopLeft: [
                                    0,
                                    0
                                ],
                                fadeValues: {
                                    tileOpacity: 1,
                                    parentTileOpacity: 1,
                                    fadeMix: {
                                        opacity: 1,
                                        mix: 0
                                    }
                                }
                            };
                            if (0 === ls || ho) return Dl;
                            if (le1.fadingParentID) {
                                const ho = bt.getLoadedTile(le1.fadingParentID);
                                if (!ho) return Dl;
                                const Fl = Math.pow(2, ho.tileID.overscaledZ - le1.tileID.overscaledZ), sc = [
                                    le1.tileID.canonical.x * Fl % 1,
                                    le1.tileID.canonical.y * Fl % 1
                                ], uc = function(le1, bt, ls) {
                                    const ho = c(), Dl = (ho - bt.timeAdded) / ls, Fl = le1.fadingDirection === Wd.Incoming, sc = vt.an((ho - le1.timeAdded) / ls, 0, 1), uc = vt.an(1 - Dl, 0, 1), mc = Fl ? sc : uc;
                                    return {
                                        tileOpacity: mc,
                                        parentTileOpacity: Fl ? uc : sc,
                                        fadeMix: {
                                            opacity: 1,
                                            mix: 1 - mc
                                        }
                                    };
                                }(le1, ho, ls);
                                return {
                                    parentTile: ho,
                                    parentScaleBy: Fl,
                                    parentTopLeft: sc,
                                    fadeValues: uc
                                };
                            }
                            if (le1.selfFading) {
                                const bt = function(le1, bt) {
                                    const ls = (c() - le1.timeAdded) / bt, ho = vt.an(ls, 0, 1);
                                    return {
                                        tileOpacity: ho,
                                        fadeMix: {
                                            opacity: ho,
                                            mix: 0
                                        }
                                    };
                                }(le1, ls);
                                return {
                                    parentTile: null,
                                    parentScaleBy: 1,
                                    parentTopLeft: [
                                        0,
                                        0
                                    ],
                                    fadeValues: bt
                                };
                            }
                            return Dl;
                        }
                        const Sm = new vt.bp(1, 0, 0, 1), Tm = new vt.bp(0, 1, 0, 1), km = new vt.bp(0, 0, 1, 1), Cm = new vt.bp(1, 0, 1, 1), Im = new vt.bp(0, 1, 1, 1);
                        function No(le1, vt, bt, ls) {
                            Uo(le1, 0, vt + bt / 2, le1.transform.width, bt, ls);
                        }
                        function Zo(le1, vt, bt, ls) {
                            Uo(le1, vt - bt / 2, 0, bt, le1.transform.height, ls);
                        }
                        function Uo(le1, vt, bt, ls, ho, Dl) {
                            const Fl = le1.context, sc = Fl.gl;
                            sc.enable(sc.SCISSOR_TEST), sc.scissor(vt * le1.pixelRatio, bt * le1.pixelRatio, ls * le1.pixelRatio, ho * le1.pixelRatio), Fl.clear({
                                color: Dl
                            }), sc.disable(sc.SCISSOR_TEST);
                        }
                        function Go(le1, bt, ls) {
                            const ho = le1.context, Dl = ho.gl, Fl = le1.useProgram("debug"), sc = ti.disabled, uc = ai.disabled, mc = le1.colorModeForRenderPass(), gc = "$debug", Ac = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(ls);
                            ho.activeTexture.set(Dl.TEXTURE0);
                            const Ec = bt.getTileByID(ls.key).latestRawTileData, kc = Math.floor((Ec && Ec.byteLength || 0) / 1024), du = bt.getTile(ls).tileSize, _u = 512 / Math.min(du, 512) * (ls.overscaledZ / le1.transform.zoom) * .5;
                            let Md = ls.canonical.toString();
                            ls.overscaledZ !== ls.canonical.z && (Md += ` => ${ls.overscaledZ}`), function(le1, vt) {
                                le1.initDebugOverlayCanvas();
                                const bt = le1.debugOverlayCanvas, ls = le1.context.gl, ho = le1.debugOverlayCanvas.getContext("2d");
                                ho.clearRect(0, 0, bt.width, bt.height), ho.shadowColor = "white", ho.shadowBlur = 2, ho.lineWidth = 1.5, ho.strokeStyle = "white", ho.textBaseline = "top", ho.font = "bold 36px Open Sans, sans-serif", ho.fillText(vt, 5, 5), ho.strokeText(vt, 5, 5), le1.debugOverlayTexture.update(bt), le1.debugOverlayTexture.bind(ls.LINEAR, ls.CLAMP_TO_EDGE);
                            }(le1, `${Md} ${kc}kB`);
                            const Ld = le1.transform.getProjectionData({
                                overscaledTileID: ls,
                                applyGlobeMatrix: !0,
                                applyTerrainMatrix: !0
                            });
                            Fl.draw(ho, Dl.TRIANGLES, sc, uc, Qt.alphaBlended, ei.disabled, Yi(vt.bp.transparent, _u), null, Ld, gc, le1.debugBuffer, le1.quadTriangleIndexBuffer, le1.debugSegments), Fl.draw(ho, Dl.LINE_STRIP, sc, uc, mc, ei.disabled, Yi(vt.bp.red), Ac, Ld, gc, le1.debugBuffer, le1.tileBorderIndexBuffer, le1.debugSegments);
                        }
                        function Vo(le1, vt, bt, ls) {
                            const { isRenderingGlobe: ho } = ls, Dl = le1.context, Fl = Dl.gl, sc = le1.transform, uc = le1.colorModeForRenderPass(), mc = le1.getDepthModeFor3D(), gc = le1.useProgram("terrain");
                            Dl.bindFramebuffer.set(null), Dl.viewport.set([
                                0,
                                0,
                                le1.width,
                                le1.height
                            ]);
                            for (const Ac of bt){
                                const bt = vt.getTerrainMesh(Ac.tileID), ls = le1.renderToTexture.getTexture(Ac), Ec = vt.getTerrainData(Ac.tileID);
                                Dl.activeTexture.set(Fl.TEXTURE0), Fl.bindTexture(Fl.TEXTURE_2D, ls.texture);
                                const kc = vt.getMeshFrameDelta(sc.zoom), du = sc.calculateFogMatrix(Ac.tileID.toUnwrapped()), _u = Oi(kc, du, le1.style.sky, sc.pitch, ho), Md = sc.getProjectionData({
                                    overscaledTileID: Ac.tileID,
                                    applyTerrainMatrix: !1,
                                    applyGlobeMatrix: !0
                                });
                                gc.draw(Dl, Fl.TRIANGLES, mc, ai.disabled, uc, ei.backCCW, _u, Ec, Md, "terrain", bt.vertexBuffer, bt.indexBuffer, bt.segments);
                            }
                        }
                        function qo(le1, bt) {
                            if (!bt.mesh) {
                                const ls = new vt.aW;
                                ls.emplaceBack(-1, -1), ls.emplaceBack(1, -1), ls.emplaceBack(1, 1), ls.emplaceBack(-1, 1);
                                const ho = new vt.aY;
                                ho.emplaceBack(0, 1, 2), ho.emplaceBack(0, 2, 3), bt.mesh = new kt(le1.createVertexBuffer(ls, lm.members), le1.createIndexBuffer(ho), vt.aX.simpleSegment(0, 0, ls.length, ho.length));
                            }
                            return bt.mesh;
                        }
                        class Wo {
                            constructor(le1, bt){
                                this.context = new no(le1), this.transform = bt, this._tileTextures = {}, this.terrainFacilitator = {
                                    dirty: !0,
                                    matrix: vt.ar(new Float64Array(16)),
                                    renderTime: 0
                                }, this.setup(), this.numSublayers = ke.maxOverzooming + ke.maxUnderzooming + 1, this.depthEpsilon = 1 / Math.pow(2, 16), this.crossTileSymbolIndex = new Rt;
                            }
                            resize(le1, vt, bt) {
                                if (this.width = Math.floor(le1 * bt), this.height = Math.floor(vt * bt), this.pixelRatio = bt, this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.style) for (const ls of this.style._order)this.style._layers[ls].resize();
                            }
                            setup() {
                                const le1 = this.context, bt = new vt.aW;
                                bt.emplaceBack(0, 0), bt.emplaceBack(vt.a5, 0), bt.emplaceBack(0, vt.a5), bt.emplaceBack(vt.a5, vt.a5), this.tileExtentBuffer = le1.createVertexBuffer(bt, lm.members), this.tileExtentSegments = vt.aX.simpleSegment(0, 0, 4, 2);
                                const ls = new vt.aW;
                                ls.emplaceBack(0, 0), ls.emplaceBack(vt.a5, 0), ls.emplaceBack(0, vt.a5), ls.emplaceBack(vt.a5, vt.a5), this.debugBuffer = le1.createVertexBuffer(ls, lm.members), this.debugSegments = vt.aX.simpleSegment(0, 0, 4, 5);
                                const ho = new vt.ch;
                                ho.emplaceBack(0, 0, 0, 0), ho.emplaceBack(vt.a5, 0, vt.a5, 0), ho.emplaceBack(0, vt.a5, 0, vt.a5), ho.emplaceBack(vt.a5, vt.a5, vt.a5, vt.a5), this.rasterBoundsBuffer = le1.createVertexBuffer(ho, _m.members), this.rasterBoundsSegments = vt.aX.simpleSegment(0, 0, 4, 2);
                                const Dl = new vt.aW;
                                Dl.emplaceBack(0, 0), Dl.emplaceBack(vt.a5, 0), Dl.emplaceBack(0, vt.a5), Dl.emplaceBack(vt.a5, vt.a5), this.rasterBoundsBufferPosOnly = le1.createVertexBuffer(Dl, lm.members), this.rasterBoundsSegmentsPosOnly = vt.aX.simpleSegment(0, 0, 4, 5);
                                const Fl = new vt.aW;
                                Fl.emplaceBack(0, 0), Fl.emplaceBack(1, 0), Fl.emplaceBack(0, 1), Fl.emplaceBack(1, 1), this.viewportBuffer = le1.createVertexBuffer(Fl, lm.members), this.viewportSegments = vt.aX.simpleSegment(0, 0, 4, 2);
                                const sc = new vt.ci;
                                sc.emplaceBack(0), sc.emplaceBack(1), sc.emplaceBack(3), sc.emplaceBack(2), sc.emplaceBack(0), this.tileBorderIndexBuffer = le1.createIndexBuffer(sc);
                                const uc = new vt.aY;
                                uc.emplaceBack(1, 0, 2), uc.emplaceBack(1, 2, 3), this.quadTriangleIndexBuffer = le1.createIndexBuffer(uc);
                                const mc = this.context.gl;
                                this.stencilClearMode = new ai({
                                    func: mc.ALWAYS,
                                    mask: 0
                                }, 0, 255, mc.ZERO, mc.ZERO, mc.ZERO), this.tileExtentMesh = new kt(this.tileExtentBuffer, this.quadTriangleIndexBuffer, this.tileExtentSegments);
                            }
                            clearStencil() {
                                const le1 = this.context, bt = le1.gl;
                                this.nextStencilID = 1, this.currentStencilSource = void 0;
                                const ls = vt.N();
                                vt.c7(ls, 0, this.width, this.height, 0, 0, 1), vt.Q(ls, ls, [
                                    bt.drawingBufferWidth,
                                    bt.drawingBufferHeight,
                                    0
                                ]);
                                const ho = {
                                    mainMatrix: ls,
                                    tileMercatorCoords: [
                                        0,
                                        0,
                                        1,
                                        1
                                    ],
                                    clippingPlane: [
                                        0,
                                        0,
                                        0,
                                        0
                                    ],
                                    projectionTransition: 0,
                                    fallbackMatrix: ls
                                };
                                this.useProgram("clippingMask", null, !0).draw(le1, bt.TRIANGLES, ti.disabled, this.stencilClearMode, Qt.disabled, ei.disabled, null, null, ho, "$clipping", this.viewportBuffer, this.quadTriangleIndexBuffer, this.viewportSegments);
                            }
                            _renderTileClippingMasks(le1, vt, bt) {
                                if (this.currentStencilSource === le1.source || !le1.isTileClipped() || !vt || !vt.length) return;
                                this.currentStencilSource = le1.source, this.nextStencilID + vt.length > 256 && this.clearStencil();
                                const ls = this.context;
                                ls.setColorMode(Qt.disabled), ls.setDepthMode(ti.disabled);
                                const ho = {};
                                for (const Dl of vt)ho[Dl.key] = this.nextStencilID++;
                                this._renderTileMasks(ho, vt, bt, !0), this._renderTileMasks(ho, vt, bt, !1), this._tileClippingMaskIDs = ho;
                            }
                            _renderTileMasks(le1, vt, bt, ls) {
                                const ho = this.context, Dl = ho.gl, Fl = this.style.projection, sc = this.transform, uc = this.useProgram("clippingMask");
                                for (const mc of vt){
                                    const vt = le1[mc.key], gc = this.style.map.terrain && this.style.map.terrain.getTerrainData(mc), Ac = Fl.getMeshFromTileID(this.context, mc.canonical, ls, !0, "stencil"), Ec = sc.getProjectionData({
                                        overscaledTileID: mc,
                                        applyGlobeMatrix: !bt,
                                        applyTerrainMatrix: !0
                                    });
                                    uc.draw(ho, Dl.TRIANGLES, ti.disabled, new ai({
                                        func: Dl.ALWAYS,
                                        mask: 0
                                    }, vt, 255, Dl.KEEP, Dl.KEEP, Dl.REPLACE), Qt.disabled, bt ? ei.disabled : ei.backCCW, null, gc, Ec, "$clipping", Ac.vertexBuffer, Ac.indexBuffer, Ac.segments);
                                }
                            }
                            _renderTilesDepthBuffer() {
                                const le1 = this.context, vt = le1.gl, bt = this.style.projection, ls = this.transform, ho = this.useProgram("depth"), Dl = this.getDepthModeFor3D(), Fl = Ie(ls, {
                                    tileSize: ls.tileSize
                                });
                                for (const sc of Fl){
                                    const Fl = this.style.map.terrain && this.style.map.terrain.getTerrainData(sc), uc = bt.getMeshFromTileID(this.context, sc.canonical, !0, !0, "raster"), mc = ls.getProjectionData({
                                        overscaledTileID: sc,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !0
                                    });
                                    ho.draw(le1, vt.TRIANGLES, Dl, ai.disabled, Qt.disabled, ei.backCCW, null, Fl, mc, "$clipping", uc.vertexBuffer, uc.indexBuffer, uc.segments);
                                }
                            }
                            stencilModeFor3D() {
                                this.currentStencilSource = void 0, this.nextStencilID + 1 > 256 && this.clearStencil();
                                const le1 = this.nextStencilID++, vt = this.context.gl;
                                return new ai({
                                    func: vt.NOTEQUAL,
                                    mask: 255
                                }, le1, 255, vt.KEEP, vt.KEEP, vt.REPLACE);
                            }
                            stencilModeForClipping(le1) {
                                const vt = this.context.gl;
                                return new ai({
                                    func: vt.EQUAL,
                                    mask: 255
                                }, this._tileClippingMaskIDs[le1.key], 0, vt.KEEP, vt.KEEP, vt.REPLACE);
                            }
                            getStencilConfigForOverlapAndUpdateStencilID(le1) {
                                const vt = this.context.gl, bt = le1.sort((le1, vt)=>vt.overscaledZ - le1.overscaledZ), ls = bt[bt.length - 1].overscaledZ, ho = bt[0].overscaledZ - ls + 1;
                                if (ho > 1) {
                                    this.currentStencilSource = void 0, this.nextStencilID + ho > 256 && this.clearStencil();
                                    const le1 = {};
                                    for(let bt = 0; bt < ho; bt++)le1[bt + ls] = new ai({
                                        func: vt.GEQUAL,
                                        mask: 255
                                    }, bt + this.nextStencilID, 255, vt.KEEP, vt.KEEP, vt.REPLACE);
                                    return this.nextStencilID += ho, [
                                        le1,
                                        bt
                                    ];
                                }
                                return [
                                    {
                                        [ls]: ai.disabled
                                    },
                                    bt
                                ];
                            }
                            stencilConfigForOverlapTwoPass(le1) {
                                const vt = this.context.gl, bt = le1.sort((le1, vt)=>vt.overscaledZ - le1.overscaledZ), ls = bt[bt.length - 1].overscaledZ, ho = bt[0].overscaledZ - ls + 1;
                                if (this.clearStencil(), ho > 1) {
                                    const le1 = {}, Dl = {};
                                    for(let bt = 0; bt < ho; bt++)le1[bt + ls] = new ai({
                                        func: vt.GREATER,
                                        mask: 255
                                    }, ho + 1 + bt, 255, vt.KEEP, vt.KEEP, vt.REPLACE), Dl[bt + ls] = new ai({
                                        func: vt.GREATER,
                                        mask: 255
                                    }, 1 + bt, 255, vt.KEEP, vt.KEEP, vt.REPLACE);
                                    return this.nextStencilID = 2 * ho + 1, [
                                        le1,
                                        Dl,
                                        bt
                                    ];
                                }
                                return this.nextStencilID = 3, [
                                    {
                                        [ls]: new ai({
                                            func: vt.GREATER,
                                            mask: 255
                                        }, 2, 255, vt.KEEP, vt.KEEP, vt.REPLACE)
                                    },
                                    {
                                        [ls]: new ai({
                                            func: vt.GREATER,
                                            mask: 255
                                        }, 1, 255, vt.KEEP, vt.KEEP, vt.REPLACE)
                                    },
                                    bt
                                ];
                            }
                            colorModeForRenderPass() {
                                const le1 = this.context.gl;
                                if (this._showOverdrawInspector) {
                                    const bt = 1 / 8;
                                    return new Qt([
                                        le1.CONSTANT_COLOR,
                                        le1.ONE
                                    ], new vt.bp(bt, bt, bt, 0), [
                                        !0,
                                        !0,
                                        !0,
                                        !0
                                    ]);
                                }
                                return "opaque" === this.renderPass ? Qt.unblended : Qt.alphaBlended;
                            }
                            getDepthModeForSublayer(le1, vt, bt) {
                                if (!this.opaquePassEnabledForLayer()) return ti.disabled;
                                const ls = 1 - ((1 + this.currentLayer) * this.numSublayers + le1) * this.depthEpsilon;
                                return new ti(bt || this.context.gl.LEQUAL, vt, [
                                    ls,
                                    ls
                                ]);
                            }
                            getDepthModeFor3D() {
                                return new ti(this.context.gl.LEQUAL, ti.ReadWrite, this.depthRangeFor3D);
                            }
                            opaquePassEnabledForLayer() {
                                return this.currentLayer < this.opaquePassCutoff;
                            }
                            render(le1, bt) {
                                var ls, ho;
                                this.style = le1, this.options = bt, this.lineAtlas = le1.lineAtlas, this.imageManager = le1.imageManager, this.glyphManager = le1.glyphManager, this.symbolFadeChange = le1.placement.symbolFadeChange(c()), this.imageManager.beginFrame();
                                const Dl = this.style._order, Fl = this.style.tileManagers, sc = {}, uc = {}, mc = {}, gc = {
                                    isRenderingToTexture: !1,
                                    isRenderingGlobe: (null === (ls = le1.projection) || void 0 === ls ? void 0 : ls.transitionState) > 0
                                };
                                for(const vt in Fl){
                                    const le1 = Fl[vt];
                                    le1.used && le1.prepare(this.context), sc[vt] = le1.getVisibleCoordinates(!1), uc[vt] = sc[vt].slice().reverse(), mc[vt] = le1.getVisibleCoordinates(!0).reverse();
                                }
                                this.opaquePassCutoff = 1 / 0;
                                for(let vt = 0; vt < Dl.length; vt++)if (this.style._layers[Dl[vt]].is3D()) {
                                    this.opaquePassCutoff = vt;
                                    break;
                                }
                                this.maybeDrawDepthAndCoords(!1), this.renderToTexture && (this.renderToTexture.prepareForRender(this.style, this.transform.zoom), this.opaquePassCutoff = 0), this.renderPass = "offscreen";
                                for (const vt of Dl){
                                    const le1 = this.style._layers[vt];
                                    if (!le1.hasOffscreenPass() || le1.isHidden(this.transform.zoom)) continue;
                                    const bt = uc[le1.source];
                                    ("custom" === le1.type || bt.length) && this.renderLayer(this, Fl[le1.source], le1, bt, gc);
                                }
                                if (null === (ho = this.style.projection) || void 0 === ho || ho.updateGPUdependent({
                                    context: this.context,
                                    useProgram: (le1)=>this.useProgram(le1)
                                }), this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.context.bindFramebuffer.set(null), this.context.clear({
                                    color: bt.showOverdrawInspector ? vt.bp.black : vt.bp.transparent,
                                    depth: 1
                                }), this.clearStencil(), this.style.sky && function(le1, vt) {
                                    const bt = le1.context, ls = bt.gl, ho = ((le1, vt, bt)=>{
                                        const ls = Math.cos(vt.rollInRadians), ho = Math.sin(vt.rollInRadians), Dl = ge(vt), Fl = vt.getProjectionData({
                                            overscaledTileID: null,
                                            applyGlobeMatrix: !0,
                                            applyTerrainMatrix: !0
                                        }).projectionTransition;
                                        return {
                                            u_sky_color: le1.properties.get("sky-color"),
                                            u_horizon_color: le1.properties.get("horizon-color"),
                                            u_horizon: [
                                                (vt.width / 2 - Dl * ho) * bt,
                                                (vt.height / 2 + Dl * ls) * bt
                                            ],
                                            u_horizon_normal: [
                                                -ho,
                                                ls
                                            ],
                                            u_sky_horizon_blend: le1.properties.get("sky-horizon-blend") * vt.height / 2 * bt,
                                            u_sky_blend: Fl
                                        };
                                    })(vt, le1.style.map.transform, le1.pixelRatio), Dl = new ti(ls.LEQUAL, ti.ReadWrite, [
                                        0,
                                        1
                                    ]), Fl = ai.disabled, sc = le1.colorModeForRenderPass(), uc = le1.useProgram("sky"), mc = qo(bt, vt);
                                    uc.draw(bt, ls.TRIANGLES, Dl, Fl, sc, ei.disabled, ho, null, void 0, "sky", mc.vertexBuffer, mc.indexBuffer, mc.segments);
                                }(this, this.style.sky), this._showOverdrawInspector = bt.showOverdrawInspector, this.depthRangeFor3D = [
                                    0,
                                    1 - (le1._order.length + 2) * this.numSublayers * this.depthEpsilon
                                ], !this.renderToTexture) for(this.renderPass = "opaque", this.currentLayer = Dl.length - 1; this.currentLayer >= 0; this.currentLayer--){
                                    const le1 = this.style._layers[Dl[this.currentLayer]], vt = Fl[le1.source], bt = sc[le1.source];
                                    this._renderTileClippingMasks(le1, bt, !1), this.renderLayer(this, vt, le1, bt, gc);
                                }
                                this.renderPass = "translucent";
                                let Ac = !1;
                                for(this.currentLayer = 0; this.currentLayer < Dl.length; this.currentLayer++){
                                    const le1 = this.style._layers[Dl[this.currentLayer]], vt = Fl[le1.source];
                                    if (this.renderToTexture && this.renderToTexture.renderLayer(le1, gc)) continue;
                                    this.opaquePassEnabledForLayer() || Ac || (Ac = !0, gc.isRenderingGlobe && !this.style.map.terrain && this._renderTilesDepthBuffer());
                                    const bt = ("symbol" === le1.type ? mc : uc)[le1.source];
                                    this._renderTileClippingMasks(le1, sc[le1.source], !!this.renderToTexture), this.renderLayer(this, vt, le1, bt, gc);
                                }
                                if (gc.isRenderingGlobe && function(le1, bt, ls) {
                                    const ho = le1.context, Dl = ho.gl, Fl = le1.useProgram("atmosphere"), sc = new ti(Dl.LEQUAL, ti.ReadOnly, [
                                        0,
                                        1
                                    ]), uc = le1.transform, mc = function(le1, bt) {
                                        const ls = le1.properties.get("position"), ho = [
                                            -ls.x,
                                            -ls.y,
                                            -ls.z
                                        ], Dl = vt.ar(new Float64Array(16));
                                        return "map" === le1.properties.get("anchor") && (vt.bg(Dl, Dl, bt.rollInRadians), vt.bh(Dl, Dl, -bt.pitchInRadians), vt.bg(Dl, Dl, bt.bearingInRadians), vt.bh(Dl, Dl, bt.center.lat * Math.PI / 180), vt.bJ(Dl, Dl, -bt.center.lng * Math.PI / 180)), vt.cg(ho, ho, Dl), ho;
                                    }(ls, le1.transform), gc = uc.getProjectionData({
                                        overscaledTileID: null,
                                        applyGlobeMatrix: !0,
                                        applyTerrainMatrix: !0
                                    }), Ac = bt.properties.get("atmosphere-blend") * gc.projectionTransition;
                                    if (0 === Ac) return;
                                    const Ec = fi(uc.worldSize, uc.center.lat), kc = uc.inverseProjectionMatrix, du = new Float64Array(4);
                                    du[3] = 1, vt.aH(du, du, uc.modelViewProjectionMatrix), du[0] /= du[3], du[1] /= du[3], du[2] /= du[3], du[3] = 1, vt.aH(du, du, kc), du[0] /= du[3], du[1] /= du[3], du[2] /= du[3], du[3] = 1;
                                    const _u = ((le1, vt, bt, ls, ho)=>({
                                            u_sun_pos: le1,
                                            u_atmosphere_blend: vt,
                                            u_globe_position: bt,
                                            u_globe_radius: ls,
                                            u_inv_proj_matrix: ho
                                        }))(mc, Ac, [
                                        du[0],
                                        du[1],
                                        du[2]
                                    ], Ec, kc), Md = qo(ho, bt);
                                    Fl.draw(ho, Dl.TRIANGLES, sc, ai.disabled, Qt.alphaBlended, ei.disabled, _u, null, null, "atmosphere", Md.vertexBuffer, Md.indexBuffer, Md.segments);
                                }(this, this.style.sky, this.style.light), this.options.showTileBoundaries) {
                                    const le1 = function(le1, vt) {
                                        let bt = null;
                                        const ls = Object.values(le1._layers).flatMap((bt)=>bt.source && !bt.isHidden(vt) ? [
                                                le1.tileManagers[bt.source]
                                            ] : []), ho = ls.filter((le1)=>"vector" === le1.getSource().type), Dl = ls.filter((le1)=>"vector" !== le1.getSource().type), s = (le1)=>{
                                            (!bt || bt.getSource().maxzoom < le1.getSource().maxzoom) && (bt = le1);
                                        };
                                        return ho.forEach((le1)=>s(le1)), bt || Dl.forEach((le1)=>s(le1)), bt;
                                    }(this.style, this.transform.zoom);
                                    le1 && function(le1, vt, bt) {
                                        for(let ls = 0; ls < bt.length; ls++)Go(le1, vt, bt[ls]);
                                    }(this, le1, le1.getVisibleCoordinates());
                                }
                                this.options.showPadding && function(le1) {
                                    const vt = le1.transform.padding;
                                    No(le1, le1.transform.height - (vt.top || 0), 3, Sm), No(le1, vt.bottom || 0, 3, Tm), Zo(le1, vt.left || 0, 3, km), Zo(le1, le1.transform.width - (vt.right || 0), 3, Cm);
                                    const bt = le1.transform.centerPoint;
                                    !function(le1, vt, bt, ls) {
                                        Uo(le1, vt - 1, bt - 10, 2, 20, ls), Uo(le1, vt - 10, bt - 1, 20, 2, ls);
                                    }(le1, bt.x, le1.transform.height - bt.y, Im);
                                }(this), this.context.setDefault();
                            }
                            maybeDrawDepthAndCoords(le1) {
                                if (!this.style || !this.style.map || !this.style.map.terrain) return;
                                const bt = this.terrainFacilitator.matrix, ls = this.transform.modelViewProjectionMatrix;
                                let ho = this.terrainFacilitator.dirty;
                                ho || (ho = le1 ? !vt.cj(bt, ls) : !vt.ck(bt, ls)), ho || (ho = this.style.map.terrain.tileManager.anyTilesAfterTime(this.terrainFacilitator.renderTime)), ho && (vt.cl(bt, ls), this.terrainFacilitator.renderTime = Date.now(), this.terrainFacilitator.dirty = !1, function(le1, bt) {
                                    const ls = le1.context, ho = ls.gl, Dl = le1.transform, Fl = Qt.unblended, sc = new ti(ho.LEQUAL, ti.ReadWrite, [
                                        0,
                                        1
                                    ]), uc = bt.tileManager.getRenderableTiles(), mc = le1.useProgram("terrainDepth");
                                    ls.bindFramebuffer.set(bt.getFramebuffer("depth").framebuffer), ls.viewport.set([
                                        0,
                                        0,
                                        le1.width / devicePixelRatio,
                                        le1.height / devicePixelRatio
                                    ]), ls.clear({
                                        color: vt.bp.transparent,
                                        depth: 1
                                    });
                                    for (const vt of uc){
                                        const le1 = bt.getTerrainMesh(vt.tileID), uc = bt.getTerrainData(vt.tileID), gc = Dl.getProjectionData({
                                            overscaledTileID: vt.tileID,
                                            applyTerrainMatrix: !1,
                                            applyGlobeMatrix: !0
                                        }), Ac = {
                                            u_ele_delta: bt.getMeshFrameDelta(Dl.zoom)
                                        };
                                        mc.draw(ls, ho.TRIANGLES, sc, ai.disabled, Fl, ei.backCCW, Ac, uc, gc, "terrain", le1.vertexBuffer, le1.indexBuffer, le1.segments);
                                    }
                                    ls.bindFramebuffer.set(null), ls.viewport.set([
                                        0,
                                        0,
                                        le1.width,
                                        le1.height
                                    ]);
                                }(this, this.style.map.terrain), function(le1, bt) {
                                    const ls = le1.context, ho = ls.gl, Dl = le1.transform, Fl = Qt.unblended, sc = new ti(ho.LEQUAL, ti.ReadWrite, [
                                        0,
                                        1
                                    ]), uc = bt.getCoordsTexture(), mc = bt.tileManager.getRenderableTiles(), gc = le1.useProgram("terrainCoords");
                                    ls.bindFramebuffer.set(bt.getFramebuffer("coords").framebuffer), ls.viewport.set([
                                        0,
                                        0,
                                        le1.width / devicePixelRatio,
                                        le1.height / devicePixelRatio
                                    ]), ls.clear({
                                        color: vt.bp.transparent,
                                        depth: 1
                                    }), bt.coordsIndex = [];
                                    for (const vt of mc){
                                        const le1 = bt.getTerrainMesh(vt.tileID), mc = bt.getTerrainData(vt.tileID);
                                        ls.activeTexture.set(ho.TEXTURE0), ho.bindTexture(ho.TEXTURE_2D, uc.texture);
                                        const Ac = {
                                            u_terrain_coords_id: (255 - bt.coordsIndex.length) / 255,
                                            u_texture: 0,
                                            u_ele_delta: bt.getMeshFrameDelta(Dl.zoom)
                                        }, Ec = Dl.getProjectionData({
                                            overscaledTileID: vt.tileID,
                                            applyTerrainMatrix: !1,
                                            applyGlobeMatrix: !0
                                        });
                                        gc.draw(ls, ho.TRIANGLES, sc, ai.disabled, Fl, ei.backCCW, Ac, mc, Ec, "terrain", le1.vertexBuffer, le1.indexBuffer, le1.segments), bt.coordsIndex.push(vt.tileID.key);
                                    }
                                    ls.bindFramebuffer.set(null), ls.viewport.set([
                                        0,
                                        0,
                                        le1.width,
                                        le1.height
                                    ]);
                                }(this, this.style.map.terrain));
                            }
                            renderLayer(le1, bt, ls, ho, Dl) {
                                ls.isHidden(this.transform.zoom) || ("background" === ls.type || "custom" === ls.type || (ho || []).length) && (this.id = ls.id, vt.cm(ls) ? function(le1, bt, ls, ho, Dl, Fl) {
                                    if ("translucent" !== le1.renderPass) return;
                                    const { isRenderingToTexture: sc } = Fl, uc = ai.disabled, mc = le1.colorModeForRenderPass();
                                    (ls._unevaluatedLayout.hasValue("text-variable-anchor") || ls._unevaluatedLayout.hasValue("text-variable-anchor-offset")) && function(le1, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                                        const gc = bt.transform, Ac = bt.style.map.terrain, Ec = "map" === Dl, kc = "map" === Fl;
                                        for (const du of le1){
                                            const le1 = ho.getTile(du), Dl = le1.getBucket(ls);
                                            if (!Dl || !Dl.text || !Dl.text.segments.get().length) continue;
                                            const Fl = vt.ay(Dl.textSizeData, gc.zoom), _u = vt.aN(le1, 1, bt.transform.zoom), Md = je(Ec, bt.transform, _u), Ld = "none" !== ls.layout.get("icon-text-fit") && Dl.hasIconData();
                                            if (Fl) {
                                                const bt = Math.pow(2, gc.zoom - le1.tileID.overscaledZ), ls = Ac ? (le1, vt)=>Ac.getElevation(du, le1, vt) : null;
                                                po(Dl, Ec, kc, mc, gc, Md, bt, Fl, Ld, vt.aO(gc, le1, sc, uc), du.toUnwrapped(), ls);
                                            }
                                        }
                                    }(ho, le1, ls, bt, ls.layout.get("text-rotation-alignment"), ls.layout.get("text-pitch-alignment"), ls.paint.get("text-translate"), ls.paint.get("text-translate-anchor"), Dl), 0 !== ls.paint.get("icon-opacity").constantOr(1) && fo(le1, bt, ls, ho, !1, ls.paint.get("icon-translate"), ls.paint.get("icon-translate-anchor"), ls.layout.get("icon-rotation-alignment"), ls.layout.get("icon-pitch-alignment"), ls.layout.get("icon-keep-upright"), uc, mc, sc), 0 !== ls.paint.get("text-opacity").constantOr(1) && fo(le1, bt, ls, ho, !0, ls.paint.get("text-translate"), ls.paint.get("text-translate-anchor"), ls.layout.get("text-rotation-alignment"), ls.layout.get("text-pitch-alignment"), ls.layout.get("text-keep-upright"), uc, mc, sc), bt.map.showCollisionBoxes && (co(le1, bt, ls, ho, !0), co(le1, bt, ls, ho, !1));
                                }(le1, bt, ls, ho, this.style.placement.variableOffsets, Dl) : vt.cn(ls) ? function(le1, bt, ls, ho, Dl) {
                                    if ("translucent" !== le1.renderPass) return;
                                    const { isRenderingToTexture: Fl } = Dl, sc = ls.paint.get("circle-opacity"), uc = ls.paint.get("circle-stroke-width"), mc = ls.paint.get("circle-stroke-opacity"), gc = !ls.layout.get("circle-sort-key").isConstant();
                                    if (0 === sc.constantOr(1) && (0 === uc.constantOr(1) || 0 === mc.constantOr(1))) return;
                                    const Ac = le1.context, Ec = Ac.gl, kc = le1.transform, du = le1.getDepthModeForSublayer(0, ti.ReadOnly), _u = ai.disabled, Md = le1.colorModeForRenderPass(), Ld = [], Nd = kc.getCircleRadiusCorrection();
                                    for(let Rd = 0; Rd < ho.length; Rd++){
                                        const Dl = ho[Rd], sc = bt.getTile(Dl), uc = sc.getBucket(ls);
                                        if (!uc) continue;
                                        const mc = ls.paint.get("circle-translate"), Ac = ls.paint.get("circle-translate-anchor"), Ec = vt.aO(kc, sc, mc, Ac), du = uc.programConfigurations.get(ls.id), _u = le1.useProgram("circle", du), Md = uc.layoutVertexBuffer, Od = uc.indexBuffer, jd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(Dl), Ud = {
                                            programConfiguration: du,
                                            program: _u,
                                            layoutVertexBuffer: Md,
                                            indexBuffer: Od,
                                            uniformValues: Hi(le1, sc, ls, Ec, Nd),
                                            terrainData: jd,
                                            projectionData: kc.getProjectionData({
                                                overscaledTileID: Dl,
                                                applyGlobeMatrix: !Fl,
                                                applyTerrainMatrix: !0
                                            })
                                        };
                                        if (gc) {
                                            const le1 = uc.segments.get();
                                            for (const bt of le1)Ld.push({
                                                segments: new vt.aX([
                                                    bt
                                                ]),
                                                sortKey: bt.sortKey,
                                                state: Ud
                                            });
                                        } else Ld.push({
                                            segments: uc.segments,
                                            sortKey: 0,
                                            state: Ud
                                        });
                                    }
                                    gc && Ld.sort((le1, vt)=>le1.sortKey - vt.sortKey);
                                    for (const vt of Ld){
                                        const { programConfiguration: bt, program: ho, layoutVertexBuffer: Dl, indexBuffer: Fl, uniformValues: sc, terrainData: uc, projectionData: mc } = vt.state;
                                        ho.draw(Ac, Ec.TRIANGLES, du, _u, Md, ei.backCCW, sc, uc, mc, ls.id, Dl, Fl, vt.segments, ls.paint, le1.transform.zoom, bt);
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.co(ls) ? function(le1, bt, ls, ho, Dl) {
                                    if (0 === ls.paint.get("heatmap-opacity")) return;
                                    const Fl = le1.context, { isRenderingToTexture: sc, isRenderingGlobe: uc } = Dl;
                                    if (le1.style.map.terrain) {
                                        for (const vt of ho){
                                            const ho = bt.getTile(vt);
                                            bt.hasRenderableParent(vt) || ("offscreen" === le1.renderPass ? vo(le1, ho, ls, vt, uc) : "translucent" === le1.renderPass && xo(le1, ls, vt, sc, uc));
                                        }
                                        Fl.viewport.set([
                                            0,
                                            0,
                                            le1.width,
                                            le1.height
                                        ]);
                                    } else "offscreen" === le1.renderPass ? function(le1, bt, ls, ho) {
                                        const Dl = le1.context, Fl = Dl.gl, sc = le1.transform, uc = ai.disabled, mc = new Qt([
                                            Fl.ONE,
                                            Fl.ONE
                                        ], vt.bp.transparent, [
                                            !0,
                                            !0,
                                            !0,
                                            !0
                                        ]);
                                        (function(le1, bt, ls) {
                                            const ho = le1.gl;
                                            le1.activeTexture.set(ho.TEXTURE1), le1.viewport.set([
                                                0,
                                                0,
                                                bt.width / 4,
                                                bt.height / 4
                                            ]);
                                            let Dl = ls.heatmapFbos.get(vt.cd);
                                            Dl ? (ho.bindTexture(ho.TEXTURE_2D, Dl.colorAttachment.get()), le1.bindFramebuffer.set(Dl.framebuffer)) : (Dl = bo(le1, bt.width / 4, bt.height / 4), ls.heatmapFbos.set(vt.cd, Dl));
                                        })(Dl, le1, ls), Dl.clear({
                                            color: vt.bp.transparent
                                        });
                                        for(let vt = 0; vt < ho.length; vt++){
                                            const gc = ho[vt];
                                            if (bt.hasRenderableParent(gc)) continue;
                                            const Ac = bt.getTile(gc), Ec = Ac.getBucket(ls);
                                            if (!Ec) continue;
                                            const kc = Ec.programConfigurations.get(ls.id), du = le1.useProgram("heatmap", kc), _u = sc.getProjectionData({
                                                overscaledTileID: gc,
                                                applyGlobeMatrix: !0,
                                                applyTerrainMatrix: !1
                                            }), Md = sc.getCircleRadiusCorrection();
                                            du.draw(Dl, Fl.TRIANGLES, ti.disabled, uc, mc, ei.backCCW, Qi(Ac, sc.zoom, ls.paint.get("heatmap-intensity"), Md), null, _u, ls.id, Ec.layoutVertexBuffer, Ec.indexBuffer, Ec.segments, ls.paint, sc.zoom, kc);
                                        }
                                        Dl.viewport.set([
                                            0,
                                            0,
                                            le1.width,
                                            le1.height
                                        ]);
                                    }(le1, bt, ls, ho) : "translucent" === le1.renderPass && function(le1, bt) {
                                        const ls = le1.context, ho = ls.gl;
                                        ls.setColorMode(le1.colorModeForRenderPass());
                                        const Dl = bt.heatmapFbos.get(vt.cd);
                                        Dl && (ls.activeTexture.set(ho.TEXTURE0), ho.bindTexture(ho.TEXTURE_2D, Dl.colorAttachment.get()), ls.activeTexture.set(ho.TEXTURE1), yo(ls, bt).bind(ho.LINEAR, ho.CLAMP_TO_EDGE), le1.useProgram("heatmapTexture").draw(ls, ho.TRIANGLES, ti.disabled, ai.disabled, le1.colorModeForRenderPass(), ei.disabled, Ji(le1, bt, 0, 1), null, null, bt.id, le1.viewportBuffer, le1.quadTriangleIndexBuffer, le1.viewportSegments, bt.paint, le1.transform.zoom));
                                    }(le1, ls);
                                }(le1, bt, ls, ho, Dl) : vt.cp(ls) ? function(le1, vt, bt, ls, ho) {
                                    if ("translucent" !== le1.renderPass) return;
                                    const { isRenderingToTexture: Dl } = ho, Fl = bt.paint.get("line-opacity"), sc = bt.paint.get("line-width");
                                    if (0 === Fl.constantOr(1) || 0 === sc.constantOr(1)) return;
                                    const uc = le1.getDepthModeForSublayer(0, ti.ReadOnly), mc = le1.colorModeForRenderPass(), gc = bt.paint.get("line-dasharray"), Ac = gc.constantOr(1), Ec = bt.paint.get("line-pattern"), kc = Ec.constantOr(1), du = bt.paint.get("line-gradient"), _u = bt.getCrossfadeParameters();
                                    let Md;
                                    Md = kc ? "linePattern" : Ac && du ? "lineGradientSDF" : Ac ? "lineSDF" : du ? "lineGradient" : "line";
                                    const Ld = le1.context, Nd = Ld.gl, Rd = le1.transform;
                                    let Od = !0;
                                    for (const jd of ls){
                                        const ls = vt.getTile(jd);
                                        if (kc && !ls.patternsLoaded()) continue;
                                        const ho = ls.getBucket(bt);
                                        if (!ho) continue;
                                        const Fl = ho.programConfigurations.get(bt.id), sc = le1.context.program.get(), Ud = le1.useProgram(Md, Fl), Gd = Od || Ud.program !== sc, qd = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(jd), Hd = Ec.constantOr(null), Wd = gc && gc.constantOr(null);
                                        if (Hd && ls.imageAtlas) {
                                            const le1 = ls.imageAtlas, vt = le1.patternPositions[Hd.to.toString()], bt = le1.patternPositions[Hd.from.toString()];
                                            vt && bt && Fl.setConstantPatternPositions(vt, bt);
                                        } else if (Wd) {
                                            const vt = "round" === bt.layout.get("line-cap"), ls = le1.lineAtlas.getDash(Wd.to, vt), ho = le1.lineAtlas.getDash(Wd.from, vt);
                                            Fl.setConstantDashPositions(ls, ho);
                                        }
                                        const Zd = Rd.getProjectionData({
                                            overscaledTileID: jd,
                                            applyGlobeMatrix: !Dl,
                                            applyTerrainMatrix: !0
                                        }), Yd = Rd.getPixelScale();
                                        let Qd;
                                        kc ? (Qd = sa(le1, ls, bt, Yd, _u), To(Ld, Nd, ls, Fl, _u)) : Ac && du ? (Qd = la(le1, ls, bt, Yd, _u, ho.lineClipsArray.length), Io(le1, vt, Ld, Nd, bt, ho, jd, Fl, _u)) : Ac ? (Qd = na(le1, ls, bt, Yd, _u), Po(le1, Ld, Nd, Fl, Gd, _u)) : du ? (Qd = ra(le1, ls, bt, Yd, ho.lineClipsArray.length), Co(le1, vt, Ld, Nd, bt, ho, jd)) : Qd = oa(le1, ls, bt, Yd);
                                        const Xd = le1.stencilModeForClipping(jd);
                                        Ud.draw(Ld, Nd.TRIANGLES, uc, Xd, mc, ei.disabled, Qd, qd, Zd, bt.id, ho.layoutVertexBuffer, ho.indexBuffer, ho.segments, bt.paint, le1.transform.zoom, Fl, ho.layoutVertexBuffer2), Od = !1;
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.cq(ls) ? function(le1, bt, ls, ho, Dl) {
                                    const Fl = ls.paint.get("fill-color"), sc = ls.paint.get("fill-opacity");
                                    if (0 === sc.constantOr(1)) return;
                                    const { isRenderingToTexture: uc } = Dl, mc = le1.colorModeForRenderPass(), gc = ls.paint.get("fill-pattern"), Ac = le1.opaquePassEnabledForLayer() && !gc.constantOr(1) && 1 === Fl.constantOr(vt.bp.transparent).a && 1 === sc.constantOr(0) ? "opaque" : "translucent";
                                    if (le1.renderPass === Ac) {
                                        const vt = le1.getDepthModeForSublayer(1, "opaque" === le1.renderPass ? ti.ReadWrite : ti.ReadOnly);
                                        Eo(le1, bt, ls, ho, vt, mc, !1, uc);
                                    }
                                    if ("translucent" === le1.renderPass && ls.paint.get("fill-antialias")) {
                                        const vt = le1.getDepthModeForSublayer(ls.getPaintProperty("fill-outline-color") ? 2 : 0, ti.ReadOnly);
                                        Eo(le1, bt, ls, ho, vt, mc, !0, uc);
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.cr(ls) ? function(le1, vt, bt, ls, ho) {
                                    const Dl = bt.paint.get("fill-extrusion-opacity");
                                    if (0 === Dl) return;
                                    const { isRenderingToTexture: Fl } = ho;
                                    if ("translucent" === le1.renderPass) {
                                        const ho = new ti(le1.context.gl.LEQUAL, ti.ReadWrite, le1.depthRangeFor3D);
                                        if (1 !== Dl || bt.paint.get("fill-extrusion-pattern").constantOr(1)) So(le1, vt, bt, ls, ho, ai.disabled, Qt.disabled, Fl), So(le1, vt, bt, ls, ho, le1.stencilModeFor3D(), le1.colorModeForRenderPass(), Fl);
                                        else {
                                            const Dl = le1.colorModeForRenderPass();
                                            So(le1, vt, bt, ls, ho, ai.disabled, Dl, Fl);
                                        }
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.cs(ls) ? function(le1, bt, ls, ho, Dl) {
                                    if ("offscreen" !== le1.renderPass && "translucent" !== le1.renderPass) return;
                                    const { isRenderingToTexture: Fl } = Dl, sc = le1.context, uc = le1.style.projection.useSubdivision, mc = le1.getDepthModeForSublayer(0, ti.ReadOnly), gc = le1.colorModeForRenderPass();
                                    if ("offscreen" === le1.renderPass) !function(le1, bt, ls, ho, Dl, Fl, sc) {
                                        const uc = le1.context, mc = uc.gl;
                                        for (const gc of ls){
                                            const ls = bt.getTile(gc), Ac = ls.dem;
                                            if (!Ac || !Ac.data) continue;
                                            if (!ls.needsHillshadePrepare) continue;
                                            const Ec = Ac.dim, kc = Ac.stride, du = Ac.getPixels();
                                            if (uc.activeTexture.set(mc.TEXTURE1), uc.pixelStoreUnpackPremultiplyAlpha.set(!1), ls.demTexture = ls.demTexture || le1.getTileTexture(kc), ls.demTexture) {
                                                const le1 = ls.demTexture;
                                                le1.update(du, {
                                                    premultiply: !1
                                                }), le1.bind(mc.NEAREST, mc.CLAMP_TO_EDGE);
                                            } else ls.demTexture = new vt.T(uc, du, mc.RGBA, {
                                                premultiply: !1
                                            }), ls.demTexture.bind(mc.NEAREST, mc.CLAMP_TO_EDGE);
                                            uc.activeTexture.set(mc.TEXTURE0);
                                            let _u = ls.fbo;
                                            if (!_u) {
                                                const le1 = new vt.T(uc, {
                                                    width: Ec,
                                                    height: Ec,
                                                    data: null
                                                }, mc.RGBA);
                                                le1.bind(mc.LINEAR, mc.CLAMP_TO_EDGE), _u = ls.fbo = uc.createFramebuffer(Ec, Ec, !0, !1), _u.colorAttachment.set(le1.texture);
                                            }
                                            uc.bindFramebuffer.set(_u.framebuffer), uc.viewport.set([
                                                0,
                                                0,
                                                Ec,
                                                Ec
                                            ]), le1.useProgram("hillshadePrepare").draw(uc, mc.TRIANGLES, Dl, Fl, sc, ei.disabled, ta(ls.tileID, Ac), null, null, ho.id, le1.rasterBoundsBuffer, le1.quadTriangleIndexBuffer, le1.rasterBoundsSegments), ls.needsHillshadePrepare = !1;
                                        }
                                    }(le1, bt, ho, ls, mc, ai.disabled, gc), sc.viewport.set([
                                        0,
                                        0,
                                        le1.width,
                                        le1.height
                                    ]);
                                    else if ("translucent" === le1.renderPass) {
                                        if (uc) {
                                            const [vt, Dl, sc] = le1.stencilConfigForOverlapTwoPass(ho);
                                            zo(le1, bt, ls, sc, vt, mc, gc, !1, Fl), zo(le1, bt, ls, sc, Dl, mc, gc, !0, Fl);
                                        } else {
                                            const [vt, Dl] = le1.getStencilConfigForOverlapAndUpdateStencilID(ho);
                                            zo(le1, bt, ls, Dl, vt, mc, gc, !1, Fl);
                                        }
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.ct(ls) ? function(le1, vt, bt, ls, ho) {
                                    if ("translucent" !== le1.renderPass) return;
                                    if (!ls.length) return;
                                    const { isRenderingToTexture: Dl } = ho, Fl = le1.style.projection.useSubdivision, sc = le1.getDepthModeForSublayer(0, ti.ReadOnly), uc = le1.colorModeForRenderPass();
                                    if (Fl) {
                                        const [ho, Fl, mc] = le1.stencilConfigForOverlapTwoPass(ls);
                                        Ro(le1, vt, bt, mc, ho, sc, uc, !1, Dl), Ro(le1, vt, bt, mc, Fl, sc, uc, !0, Dl);
                                    } else {
                                        const [ho, Fl] = le1.getStencilConfigForOverlapAndUpdateStencilID(ls);
                                        Ro(le1, vt, bt, Fl, ho, sc, uc, !1, Dl);
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.bU(ls) ? function(le1, vt, bt, ls, ho) {
                                    if ("translucent" !== le1.renderPass) return;
                                    if (0 === bt.paint.get("raster-opacity")) return;
                                    if (!ls.length) return;
                                    const { isRenderingToTexture: Dl } = ho, Fl = vt.getSource(), sc = le1.style.projection.useSubdivision;
                                    if (Fl instanceof te) Ao(le1, vt, bt, ls, null, !1, !1, Fl.tileCoords, Fl.flippedWindingOrder, Dl);
                                    else if (sc) {
                                        const [ho, Fl, sc] = le1.stencilConfigForOverlapTwoPass(ls);
                                        Ao(le1, vt, bt, sc, ho, !1, !0, Mm, !1, Dl), Ao(le1, vt, bt, sc, Fl, !0, !0, Mm, !1, Dl);
                                    } else {
                                        const [ho, Fl] = le1.getStencilConfigForOverlapAndUpdateStencilID(ls);
                                        Ao(le1, vt, bt, Fl, ho, !1, !0, Mm, !1, Dl);
                                    }
                                }(le1, bt, ls, ho, Dl) : vt.cu(ls) ? function(le1, vt, bt, ls, ho) {
                                    const Dl = bt.paint.get("background-color"), Fl = bt.paint.get("background-opacity");
                                    if (0 === Fl) return;
                                    const { isRenderingToTexture: sc } = ho, uc = le1.context, mc = uc.gl, gc = le1.style.projection, Ac = le1.transform, Ec = Ac.tileSize, kc = bt.paint.get("background-pattern");
                                    if (le1.isPatternMissing(kc)) return;
                                    const du = !kc && 1 === Dl.a && 1 === Fl && le1.opaquePassEnabledForLayer() ? "opaque" : "translucent";
                                    if (le1.renderPass !== du) return;
                                    const _u = ai.disabled, Md = le1.getDepthModeForSublayer(0, "opaque" === du ? ti.ReadWrite : ti.ReadOnly), Ld = le1.colorModeForRenderPass(), Nd = le1.useProgram(kc ? "backgroundPattern" : "background"), Rd = ls || Ie(Ac, {
                                        tileSize: Ec,
                                        terrain: le1.style.map.terrain
                                    });
                                    kc && (uc.activeTexture.set(mc.TEXTURE0), le1.imageManager.bind(le1.context));
                                    const Od = bt.getCrossfadeParameters();
                                    for (const jd of Rd){
                                        const vt = Ac.getProjectionData({
                                            overscaledTileID: jd,
                                            applyGlobeMatrix: !sc,
                                            applyTerrainMatrix: !0
                                        }), ls = kc ? ga(Fl, le1, kc, {
                                            tileID: jd,
                                            tileSize: Ec
                                        }, Od) : fa(Fl, Dl), ho = le1.style.map.terrain && le1.style.map.terrain.getTerrainData(jd), du = gc.getMeshFromTileID(uc, jd.canonical, !1, !0, "raster");
                                        Nd.draw(uc, mc.TRIANGLES, Md, _u, Ld, ei.backCCW, ls, ho, vt, bt.id, du.vertexBuffer, du.indexBuffer, du.segments);
                                    }
                                }(le1, 0, ls, ho, Dl) : vt.cv(ls) && function(le1, vt, bt, ls) {
                                    const { isRenderingGlobe: ho } = ls, Dl = le1.context, Fl = bt.implementation, sc = le1.style.projection, uc = le1.transform, mc = uc.getProjectionDataForCustomLayer(ho), gc = {
                                        farZ: uc.farZ,
                                        nearZ: uc.nearZ,
                                        fov: uc.fov * Math.PI / 180,
                                        modelViewProjectionMatrix: uc.modelViewProjectionMatrix,
                                        projectionMatrix: uc.projectionMatrix,
                                        shaderData: {
                                            variantName: sc.shaderVariantName,
                                            vertexShaderPrelude: `const float PI = 3.141592653589793;\nuniform mat4 u_projection_matrix;\n${sc.shaderPreludeCode.vertexSource}`,
                                            define: sc.shaderDefine
                                        },
                                        defaultProjectionData: mc
                                    }, Ac = Fl.renderingMode ? Fl.renderingMode : "2d";
                                    if ("offscreen" === le1.renderPass) {
                                        const vt = Fl.prerender;
                                        vt && (le1.setCustomLayerDefaults(), Dl.setColorMode(le1.colorModeForRenderPass()), vt.call(Fl, Dl.gl, gc), Dl.setDirty(), le1.setBaseState());
                                    } else if ("translucent" === le1.renderPass) {
                                        le1.setCustomLayerDefaults(), Dl.setColorMode(le1.colorModeForRenderPass()), Dl.setStencilMode(ai.disabled);
                                        const vt = "3d" === Ac ? le1.getDepthModeFor3D() : le1.getDepthModeForSublayer(0, ti.ReadOnly);
                                        Dl.setDepthMode(vt), Fl.render(Dl.gl, gc), Dl.setDirty(), le1.setBaseState(), Dl.bindFramebuffer.set(null);
                                    }
                                }(le1, 0, ls, Dl));
                            }
                            saveTileTexture(le1) {
                                const vt = this._tileTextures[le1.size[0]];
                                vt ? vt.push(le1) : this._tileTextures[le1.size[0]] = [
                                    le1
                                ];
                            }
                            getTileTexture(le1) {
                                const vt = this._tileTextures[le1];
                                return vt && vt.length > 0 ? vt.pop() : null;
                            }
                            isPatternMissing(le1) {
                                if (!le1) return !1;
                                if (!le1.from || !le1.to) return !0;
                                const vt = this.imageManager.getPattern(le1.from.toString()), bt = this.imageManager.getPattern(le1.to.toString());
                                return !vt || !bt;
                            }
                            useProgram(le1, vt, bt = !1, ls = []) {
                                this.cache = this.cache || {};
                                const ho = !!this.style.map.terrain, Dl = this.style.projection, Fl = bt ? om.projectionMercator : Dl.shaderPreludeCode, sc = bt ? cm : Dl.shaderDefine, uc = le1 + (vt ? vt.cacheKey : "") + `/${bt ? um : Dl.shaderVariantName}` + (this._showOverdrawInspector ? "/overdraw" : "") + (ho ? "/terrain" : "") + (ls ? `/${ls.join("/")}` : "");
                                return this.cache[uc] || (this.cache[uc] = new Zi(this.context, om[le1], vt, vm[le1], this._showOverdrawInspector, ho, Fl, sc, ls)), this.cache[uc];
                            }
                            setCustomLayerDefaults() {
                                this.context.unbindVAO(), this.context.cullFace.setDefault(), this.context.activeTexture.setDefault(), this.context.pixelStoreUnpack.setDefault(), this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(), this.context.pixelStoreUnpackFlipY.setDefault();
                            }
                            setBaseState() {
                                const le1 = this.context.gl;
                                this.context.cullFace.set(!1), this.context.viewport.set([
                                    0,
                                    0,
                                    this.width,
                                    this.height
                                ]), this.context.blendEquation.set(le1.FUNC_ADD);
                            }
                            initDebugOverlayCanvas() {
                                null == this.debugOverlayCanvas && (this.debugOverlayCanvas = document.createElement("canvas"), this.debugOverlayCanvas.width = 512, this.debugOverlayCanvas.height = 512, this.debugOverlayTexture = new vt.T(this.context, this.debugOverlayCanvas, this.context.gl.RGBA));
                            }
                            destroy() {
                                var le1, vt;
                                if (this._tileTextures) {
                                    for(const le1 in this._tileTextures){
                                        const vt = this._tileTextures[le1];
                                        if (vt) for (const le1 of vt)le1.destroy();
                                    }
                                    this._tileTextures = {};
                                }
                                if (this.tileExtentBuffer && this.tileExtentBuffer.destroy(), this.debugBuffer && this.debugBuffer.destroy(), this.rasterBoundsBuffer && this.rasterBoundsBuffer.destroy(), this.rasterBoundsBufferPosOnly && this.rasterBoundsBufferPosOnly.destroy(), this.viewportBuffer && this.viewportBuffer.destroy(), this.tileBorderIndexBuffer && this.tileBorderIndexBuffer.destroy(), this.quadTriangleIndexBuffer && this.quadTriangleIndexBuffer.destroy(), this.tileExtentMesh && (null === (le1 = this.tileExtentMesh.vertexBuffer) || void 0 === le1 || le1.destroy()), this.tileExtentMesh && (null === (vt = this.tileExtentMesh.indexBuffer) || void 0 === vt || vt.destroy()), this.debugOverlayTexture && this.debugOverlayTexture.destroy(), this.cache) {
                                    for(const le1 in this.cache){
                                        const vt = this.cache[le1];
                                        vt && vt.program && this.context.gl.deleteProgram(vt.program);
                                    }
                                    this.cache = {};
                                }
                                this.context && this.context.setDefault();
                            }
                            overLimit() {
                                const { drawingBufferWidth: le1, drawingBufferHeight: vt } = this.context.gl;
                                return this.width !== le1 || this.height !== vt;
                            }
                        }
                        function $o(le1, vt) {
                            let bt, ls = !1, ho = null, Dl = null;
                            const s = ()=>{
                                ho = null, ls && (le1.apply(Dl, bt), ho = setTimeout(s, vt), ls = !1);
                            };
                            return (...le1)=>(ls = !0, Dl = this, bt = le1, ho || s(), ho);
                        }
                        class Ho {
                            constructor(le1){
                                this._getCurrentHash = ()=>{
                                    const le1 = window.location.hash.replace("#", "");
                                    if (this._hashName) {
                                        let vt;
                                        return le1.split("&").map((le1)=>le1.split("=")).forEach((le1)=>{
                                            le1[0] === this._hashName && (vt = le1);
                                        }), (vt && vt[1] || "").split("/");
                                    }
                                    return le1.split("/");
                                }, this._onHashChange = ()=>{
                                    const le1 = this._getCurrentHash();
                                    if (!this._isValidHash(le1)) return !1;
                                    const vt = this._map.dragRotate.isEnabled() && this._map.touchZoomRotate.isEnabled() ? +(le1[3] || 0) : this._map.getBearing();
                                    return this._map.jumpTo({
                                        center: [
                                            +le1[2],
                                            +le1[1]
                                        ],
                                        zoom: +le1[0],
                                        bearing: vt,
                                        pitch: +(le1[4] || 0)
                                    }), !0;
                                }, this._updateHashUnthrottled = ()=>{
                                    const le1 = window.location.href.replace(/(#.*)?$/, this.getHashString());
                                    window.history.replaceState(window.history.state, null, le1);
                                }, this._removeHash = ()=>{
                                    const le1 = this._getCurrentHash();
                                    if (0 === le1.length) return;
                                    const vt = le1.join("/");
                                    let bt = vt;
                                    bt.split("&").length > 0 && (bt = bt.split("&")[0]), this._hashName && (bt = `${this._hashName}=${vt}`);
                                    let ls = window.location.hash.replace(bt, "");
                                    ls.startsWith("#&") ? ls = ls.slice(0, 1) + ls.slice(2) : "#" === ls && (ls = "");
                                    let ho = window.location.href.replace(/(#.+)?$/, ls);
                                    ho = ho.replace("&&", "&"), window.history.replaceState(window.history.state, null, ho);
                                }, this._updateHash = $o(this._updateHashUnthrottled, 300), this._hashName = le1 && encodeURIComponent(le1);
                            }
                            addTo(le1) {
                                return this._map = le1, addEventListener("hashchange", this._onHashChange, !1), this._map.on("moveend", this._updateHash), this;
                            }
                            remove() {
                                return removeEventListener("hashchange", this._onHashChange, !1), this._map.off("moveend", this._updateHash), clearTimeout(this._updateHash()), this._removeHash(), delete this._map, this;
                            }
                            getHashString(le1) {
                                const vt = this._map.getCenter(), bt = Math.round(100 * this._map.getZoom()) / 100, ls = Math.ceil((bt * Math.LN2 + Math.log(512 / 360 / .5)) / Math.LN10), ho = Math.pow(10, ls), Dl = Math.round(vt.lng * ho) / ho, Fl = Math.round(vt.lat * ho) / ho, sc = this._map.getBearing(), uc = this._map.getPitch();
                                let mc = "";
                                if (mc += le1 ? `/${Dl}/${Fl}/${bt}` : `${bt}/${Fl}/${Dl}`, (sc || uc) && (mc += "/" + Math.round(10 * sc) / 10), uc && (mc += `/${Math.round(uc)}`), this._hashName) {
                                    const le1 = this._hashName;
                                    let vt = !1;
                                    const bt = window.location.hash.slice(1).split("&").map((bt)=>{
                                        const ls = bt.split("=")[0];
                                        return ls === le1 ? (vt = !0, `${ls}=${mc}`) : bt;
                                    }).filter((le1)=>le1);
                                    return vt || bt.push(`${le1}=${mc}`), `#${bt.join("&")}`;
                                }
                                return `#${mc}`;
                            }
                            _isValidHash(le1) {
                                if (le1.length < 3 || le1.some(isNaN)) return !1;
                                try {
                                    new vt.V(+le1[2], +le1[1]);
                                } catch (le1) {
                                    return !1;
                                }
                                const bt = +le1[0], ls = +(le1[3] || 0), ho = +(le1[4] || 0);
                                return bt >= this._map.getMinZoom() && bt <= this._map.getMaxZoom() && ls >= -180 && ls <= 180 && ho >= this._map.getMinPitch() && ho <= this._map.getMaxPitch();
                            }
                        }
                        const Dm = {
                            linearity: .3,
                            easing: vt.cw(0, 0, .3, 1)
                        }, Lm = vt.e({
                            deceleration: 2500,
                            maxSpeed: 1400
                        }, Dm), Pm = vt.e({
                            deceleration: 20,
                            maxSpeed: 1400
                        }, Dm), zm = vt.e({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, Dm), Nm = vt.e({
                            deceleration: 1e3,
                            maxSpeed: 90
                        }, Dm), Rm = vt.e({
                            deceleration: 1e3,
                            maxSpeed: 360
                        }, Dm);
                        class tr {
                            constructor(le1){
                                this._map = le1, this.clear();
                            }
                            clear() {
                                this._inertiaBuffer = [];
                            }
                            record(le1) {
                                this._drainInertiaBuffer(), this._inertiaBuffer.push({
                                    time: c(),
                                    settings: le1
                                });
                            }
                            _drainInertiaBuffer() {
                                const le1 = this._inertiaBuffer, vt = c();
                                for(; le1.length > 0 && vt - le1[0].time > 160;)le1.shift();
                            }
                            _onMoveEnd(le1) {
                                if (this._drainInertiaBuffer(), this._inertiaBuffer.length < 2) return;
                                const bt = {
                                    zoom: 0,
                                    bearing: 0,
                                    pitch: 0,
                                    roll: 0,
                                    pan: new vt.P(0, 0),
                                    pinchAround: void 0,
                                    around: void 0
                                };
                                for (const { settings: vt } of this._inertiaBuffer)bt.zoom += vt.zoomDelta || 0, bt.bearing += vt.bearingDelta || 0, bt.pitch += vt.pitchDelta || 0, bt.roll += vt.rollDelta || 0, vt.panDelta && bt.pan._add(vt.panDelta), vt.around && (bt.around = vt.around), vt.pinchAround && (bt.pinchAround = vt.pinchAround);
                                const ls = this._inertiaBuffer[this._inertiaBuffer.length - 1].time - this._inertiaBuffer[0].time, ho = {};
                                if (bt.pan.mag()) {
                                    const Dl = ar(bt.pan.mag(), ls, vt.e({}, Lm, le1 || {})), Fl = bt.pan.mult(Dl.amount / bt.pan.mag()), sc = this._map.cameraHelper.handlePanInertia(Fl, this._map.transform);
                                    ho.center = sc.easingCenter, ho.offset = sc.easingOffset, ir(ho, Dl);
                                }
                                if (bt.zoom) {
                                    const le1 = ar(bt.zoom, ls, Pm), Dl = vt.cx(this._map.transform.zoom + le1.amount, this._map.getZoomSnap(), le1.amount);
                                    ho.zoom = Dl, ir(ho, le1);
                                }
                                if (bt.bearing) {
                                    const le1 = ar(bt.bearing, ls, zm);
                                    ho.bearing = this._map.transform.bearing + vt.an(le1.amount, -179, 179), ir(ho, le1);
                                }
                                if (bt.pitch) {
                                    const le1 = ar(bt.pitch, ls, Nm);
                                    ho.pitch = this._map.transform.pitch + le1.amount, ir(ho, le1);
                                }
                                if (bt.roll) {
                                    const le1 = ar(bt.roll, ls, Rm);
                                    ho.roll = this._map.transform.roll + vt.an(le1.amount, -179, 179), ir(ho, le1);
                                }
                                if (ho.zoom || ho.bearing) {
                                    const le1 = void 0 === bt.pinchAround ? bt.around : bt.pinchAround;
                                    ho.around = le1 ? this._map.unproject(le1) : this._map.getCenter();
                                }
                                return this.clear(), vt.e(ho, {
                                    noMoveStart: !0
                                });
                            }
                        }
                        function ir(le1, vt) {
                            (!le1.duration || le1.duration < vt.duration) && (le1.duration = vt.duration, le1.easing = vt.easing);
                        }
                        function ar(le1, bt, ls) {
                            const { maxSpeed: ho, linearity: Dl, deceleration: Fl } = ls, sc = vt.an(le1 * Dl / (bt / 1e3), -ho, ho), uc = Math.abs(sc) / (Fl * Dl);
                            return {
                                easing: ls.easing,
                                duration: 1e3 * uc,
                                amount: sc * (uc / 2)
                            };
                        }
                        class or extends vt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(le1, bt, ls, ho = {}){
                                ls = ls instanceof MouseEvent ? ls : new MouseEvent(le1, ls);
                                const Dl = h.mousePos(bt.getCanvas(), ls), Fl = bt.unproject(Dl);
                                super(le1, vt.e({
                                    point: Dl,
                                    lngLat: Fl,
                                    originalEvent: ls
                                }, ho)), this._defaultPrevented = !1, this.target = bt;
                            }
                        }
                        class rr extends vt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(le1, bt, ls){
                                const ho = "touchend" === le1 ? ls.changedTouches : ls.touches, Dl = h.touchPos(bt.getCanvasContainer(), ho), Fl = Dl.map((le1)=>bt.unproject(le1)), sc = Dl.reduce((le1, vt, bt, ls)=>le1.add(vt.div(ls.length)), new vt.P(0, 0));
                                super(le1, {
                                    points: Dl,
                                    point: sc,
                                    lngLats: Fl,
                                    lngLat: bt.unproject(sc),
                                    originalEvent: ls
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class sr extends vt.l {
                            preventDefault() {
                                this._defaultPrevented = !0;
                            }
                            get defaultPrevented() {
                                return this._defaultPrevented;
                            }
                            constructor(le1, vt, bt){
                                super(le1, {
                                    originalEvent: bt
                                }), this._defaultPrevented = !1;
                            }
                        }
                        class nr {
                            constructor(le1, vt){
                                this._map = le1, this._clickTolerance = vt.clickTolerance;
                            }
                            reset() {
                                delete this._mousedownPos;
                            }
                            wheel(le1) {
                                return this._firePreventable(new sr(le1.type, this._map, le1));
                            }
                            mousedown(le1, vt) {
                                return this._mousedownPos = vt, this._firePreventable(new or(le1.type, this._map, le1));
                            }
                            mouseup(le1) {
                                this._map.fire(new or(le1.type, this._map, le1));
                            }
                            click(le1, vt) {
                                this._mousedownPos && this._mousedownPos.dist(vt) >= this._clickTolerance || this._map.fire(new or(le1.type, this._map, le1));
                            }
                            dblclick(le1) {
                                return this._firePreventable(new or(le1.type, this._map, le1));
                            }
                            mouseover(le1) {
                                this._map.fire(new or(le1.type, this._map, le1));
                            }
                            mouseout(le1) {
                                this._map.fire(new or(le1.type, this._map, le1));
                            }
                            touchstart(le1) {
                                return this._firePreventable(new rr(le1.type, this._map, le1));
                            }
                            touchmove(le1) {
                                this._map.fire(new rr(le1.type, this._map, le1));
                            }
                            touchend(le1) {
                                this._map.fire(new rr(le1.type, this._map, le1));
                            }
                            touchcancel(le1) {
                                this._map.fire(new rr(le1.type, this._map, le1));
                            }
                            _firePreventable(le1) {
                                if (this._map.fire(le1), le1.defaultPrevented) return {};
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class lr {
                            constructor(le1){
                                this._map = le1;
                            }
                            reset() {
                                this._delayContextMenu = !1, this._ignoreContextMenu = !0, delete this._contextMenuEvent;
                            }
                            mousemove(le1) {
                                this._map.fire(new or(le1.type, this._map, le1));
                            }
                            mousedown() {
                                this._delayContextMenu = !0, this._ignoreContextMenu = !1;
                            }
                            mouseup() {
                                this._delayContextMenu = !1, this._contextMenuEvent && (this._map.fire(new or("contextmenu", this._map, this._contextMenuEvent)), delete this._contextMenuEvent);
                            }
                            contextmenu(le1) {
                                this._delayContextMenu ? this._contextMenuEvent = le1 : this._ignoreContextMenu || this._map.fire(new or(le1.type, this._map, le1)), this._map.listens("contextmenu") && le1.preventDefault();
                            }
                            isEnabled() {
                                return !0;
                            }
                            isActive() {
                                return !1;
                            }
                            enable() {}
                            disable() {}
                        }
                        class cr {
                            constructor(le1){
                                this._map = le1;
                            }
                            get transform() {
                                return this._map._requestedCameraState || this._map.transform;
                            }
                            get center() {
                                return {
                                    lng: this.transform.center.lng,
                                    lat: this.transform.center.lat
                                };
                            }
                            get zoom() {
                                return this.transform.zoom;
                            }
                            get pitch() {
                                return this.transform.pitch;
                            }
                            get bearing() {
                                return this.transform.bearing;
                            }
                            unproject(le1) {
                                return this.transform.screenPointToLocation(vt.P.convert(le1), this._map.terrain);
                            }
                        }
                        class hr {
                            constructor(le1, vt){
                                this._map = le1, this._tr = new cr(le1), this._el = le1.getCanvasContainer(), this._container = le1.getContainer(), this._clickTolerance = vt.clickTolerance || 1;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                            enable() {
                                this.isEnabled() || (this._enabled = !0);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            mousedown(le1, vt) {
                                this.isEnabled() && le1.shiftKey && 0 === le1.button && (h.disableDrag(), this._startPos = this._lastPos = vt, this._active = !0);
                            }
                            mousemoveWindow(le1, vt) {
                                if (!this._active) return;
                                const bt = vt;
                                if (this._lastPos.equals(bt) || !this._box && bt.dist(this._startPos) < this._clickTolerance) return;
                                const ls = this._startPos;
                                this._lastPos = bt, this._box || (this._box = h.create("div", "maplibregl-boxzoom", this._container), this._container.classList.add("maplibregl-crosshair"), this._fireEvent("boxzoomstart", le1));
                                const ho = Math.min(ls.x, bt.x), Dl = Math.max(ls.x, bt.x), Fl = Math.min(ls.y, bt.y), sc = Math.max(ls.y, bt.y);
                                h.setTransform(this._box, `translate(${ho}px,${Fl}px)`), this._box.style.width = Dl - ho + "px", this._box.style.height = sc - Fl + "px";
                            }
                            mouseupWindow(le1, bt) {
                                if (!this._active) return;
                                if (0 !== le1.button) return;
                                const ls = this._startPos, ho = bt;
                                if (this.reset(), h.suppressClick(), ls.x !== ho.x || ls.y !== ho.y) return this._map.fire(new vt.l("boxzoomend", {
                                    originalEvent: le1
                                })), {
                                    cameraAnimation: (le1)=>le1.fitScreenCoordinates(ls, ho, this._tr.bearing, {
                                            linear: !0
                                        })
                                };
                                this._fireEvent("boxzoomcancel", le1);
                            }
                            keydown(le1) {
                                this._active && 27 === le1.keyCode && (this.reset(), this._fireEvent("boxzoomcancel", le1));
                            }
                            reset() {
                                this._active = !1, this._container.classList.remove("maplibregl-crosshair"), this._box && (h.remove(this._box), this._box = null), h.enableDrag(), delete this._startPos, delete this._lastPos;
                            }
                            _fireEvent(le1, bt) {
                                return this._map.fire(new vt.l(le1, {
                                    originalEvent: bt
                                }));
                            }
                        }
                        function ur(le1, vt) {
                            if (le1.length !== vt.length) throw new Error(`The number of touches and points are not equal - touches ${le1.length}, points ${vt.length}`);
                            const bt = {};
                            for(let ls = 0; ls < le1.length; ls++)bt[le1[ls].identifier] = vt[ls];
                            return bt;
                        }
                        class dr {
                            constructor(le1){
                                this.reset(), this.numTouches = le1.numTouches;
                            }
                            reset() {
                                delete this.centroid, delete this.startTime, delete this.touches, this.aborted = !1;
                            }
                            touchstart(le1, bt, ls) {
                                (this.centroid || ls.length > this.numTouches) && (this.aborted = !0), this.aborted || (void 0 === this.startTime && (this.startTime = le1.timeStamp), ls.length === this.numTouches && (this.centroid = function(le1) {
                                    const bt = new vt.P(0, 0);
                                    for (const vt of le1)bt._add(vt);
                                    return bt.div(le1.length);
                                }(bt), this.touches = ur(ls, bt)));
                            }
                            touchmove(le1, vt, bt) {
                                if (this.aborted || !this.centroid) return;
                                const ls = ur(bt, vt);
                                for(const ho in this.touches){
                                    const le1 = ls[ho];
                                    (!le1 || le1.dist(this.touches[ho]) > 30) && (this.aborted = !0);
                                }
                            }
                            touchend(le1, vt, bt) {
                                if ((!this.centroid || le1.timeStamp - this.startTime > 500) && (this.aborted = !0), 0 === bt.length) {
                                    const le1 = !this.aborted && this.centroid;
                                    if (this.reset(), le1) return le1;
                                }
                            }
                        }
                        class _r {
                            constructor(le1){
                                this.singleTap = new dr(le1), this.numTaps = le1.numTaps, this.reset();
                            }
                            reset() {
                                this.lastTime = 1 / 0, delete this.lastTap, this.count = 0, this.singleTap.reset();
                            }
                            touchstart(le1, vt, bt) {
                                this.singleTap.touchstart(le1, vt, bt);
                            }
                            touchmove(le1, vt, bt) {
                                this.singleTap.touchmove(le1, vt, bt);
                            }
                            touchend(le1, vt, bt) {
                                const ls = this.singleTap.touchend(le1, vt, bt);
                                if (ls) {
                                    const vt = le1.timeStamp - this.lastTime < 500, bt = !this.lastTap || this.lastTap.dist(ls) < 30;
                                    if (vt && bt || this.reset(), this.count++, this.lastTime = le1.timeStamp, this.lastTap = ls, this.count === this.numTaps) return this.reset(), ls;
                                }
                            }
                        }
                        class pr {
                            constructor(le1){
                                this._tr = new cr(le1), this._zoomIn = new _r({
                                    numTouches: 1,
                                    numTaps: 2
                                }), this._zoomOut = new _r({
                                    numTouches: 2,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, this._zoomIn.reset(), this._zoomOut.reset();
                            }
                            touchstart(le1, vt, bt) {
                                this._zoomIn.touchstart(le1, vt, bt), this._zoomOut.touchstart(le1, vt, bt);
                            }
                            touchmove(le1, vt, bt) {
                                this._zoomIn.touchmove(le1, vt, bt), this._zoomOut.touchmove(le1, vt, bt);
                            }
                            touchend(le1, bt, ls) {
                                const ho = this._zoomIn.touchend(le1, bt, ls), Dl = this._zoomOut.touchend(le1, bt, ls), Fl = this._tr;
                                return ho ? (this._active = !0, le1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (bt)=>bt.easeTo({
                                            duration: 300,
                                            zoom: vt.cx(Fl.zoom + 1, bt.getZoomSnap()),
                                            around: Fl.unproject(ho)
                                        }, {
                                            originalEvent: le1
                                        })
                                }) : Dl ? (this._active = !0, le1.preventDefault(), setTimeout(()=>this.reset(), 0), {
                                    cameraAnimation: (bt)=>bt.easeTo({
                                            duration: 300,
                                            zoom: vt.cx(Fl.zoom - 1, bt.getZoomSnap()),
                                            around: Fl.unproject(Dl)
                                        }, {
                                            originalEvent: le1
                                        })
                                }) : void 0;
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class mr {
                            constructor(le1){
                                this._enabled = !!le1.enable, this._moveStateManager = le1.moveStateManager, this._clickTolerance = le1.clickTolerance || 1, this._moveFunction = le1.move, this._activateOnStart = !!le1.activateOnStart, le1.assignEvents(this), this.reset();
                            }
                            reset(le1) {
                                this._active = !1, this._moved = !1, delete this._lastPoint, this._moveStateManager.endMove(le1);
                            }
                            _move(...le1) {
                                const vt = this._moveFunction(...le1);
                                if (vt.bearingDelta || vt.pitchDelta || vt.rollDelta || vt.around || vt.panDelta) return this._active = !0, vt;
                            }
                            dragStart(le1, vt) {
                                this.isEnabled() && !this._lastPoint && this._moveStateManager.isValidStartEvent(le1) && (this._moveStateManager.startMove(le1), this._lastPoint = Array.isArray(vt) ? vt[0] : vt, this._activateOnStart && this._lastPoint && (this._active = !0));
                            }
                            dragMove(le1, vt) {
                                if (!this.isEnabled()) return;
                                const bt = this._lastPoint;
                                if (!bt) return;
                                if (le1.preventDefault(), !this._moveStateManager.isValidMoveEvent(le1)) return void this.reset(le1);
                                const ls = Array.isArray(vt) ? vt[0] : vt;
                                return !this._moved && ls.dist(bt) < this._clickTolerance ? void 0 : (this._moved = !0, this._lastPoint = ls, this._move(bt, ls));
                            }
                            dragEnd(le1) {
                                this.isEnabled() && this._lastPoint && this._moveStateManager.isValidEndEvent(le1) && (this._moved && h.suppressClick(), this.reset(le1));
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            getClickTolerance() {
                                return this._clickTolerance;
                            }
                        }
                        const Fm = 0, Om = 2, Bm = {
                            [Fm]: 1,
                            [Om]: 2
                        };
                        class xr {
                            constructor(le1){
                                this._correctEvent = le1.checkCorrectEvent;
                            }
                            startMove(le1) {
                                const vt = h.mouseButton(le1);
                                this._eventButton = vt;
                            }
                            endMove(le1) {
                                delete this._eventButton;
                            }
                            isValidStartEvent(le1) {
                                return this._correctEvent(le1);
                            }
                            isValidMoveEvent(le1) {
                                return !function(le1, vt) {
                                    const bt = Bm[vt];
                                    return void 0 === le1.buttons || (le1.buttons & bt) !== bt;
                                }(le1, this._eventButton);
                            }
                            isValidEndEvent(le1) {
                                return h.mouseButton(le1) === this._eventButton;
                            }
                        }
                        class br {
                            constructor(){
                                this._firstTouch = void 0;
                            }
                            _isOneFingerTouch(le1) {
                                return 1 === le1.targetTouches.length;
                            }
                            _isSameTouchEvent(le1) {
                                return le1.targetTouches[0].identifier === this._firstTouch;
                            }
                            startMove(le1) {
                                this._firstTouch = le1.targetTouches[0].identifier;
                            }
                            endMove(le1) {
                                delete this._firstTouch;
                            }
                            isValidStartEvent(le1) {
                                return this._isOneFingerTouch(le1);
                            }
                            isValidMoveEvent(le1) {
                                return this._isOneFingerTouch(le1) && this._isSameTouchEvent(le1);
                            }
                            isValidEndEvent(le1) {
                                return this._isOneFingerTouch(le1) && this._isSameTouchEvent(le1);
                            }
                        }
                        class yr {
                            constructor(le1 = new xr({
                                checkCorrectEvent: ()=>!0
                            }), vt = new br){
                                this.mouseMoveStateManager = le1, this.oneFingerTouchMoveStateManager = vt;
                            }
                            _executeRelevantHandler(le1, vt, bt) {
                                return le1 instanceof MouseEvent ? vt(le1) : "undefined" != typeof TouchEvent && le1 instanceof TouchEvent ? bt(le1) : void 0;
                            }
                            startMove(le1) {
                                this._executeRelevantHandler(le1, (le1)=>this.mouseMoveStateManager.startMove(le1), (le1)=>this.oneFingerTouchMoveStateManager.startMove(le1));
                            }
                            endMove(le1) {
                                this._executeRelevantHandler(le1, (le1)=>this.mouseMoveStateManager.endMove(le1), (le1)=>this.oneFingerTouchMoveStateManager.endMove(le1));
                            }
                            isValidStartEvent(le1) {
                                return this._executeRelevantHandler(le1, (le1)=>this.mouseMoveStateManager.isValidStartEvent(le1), (le1)=>this.oneFingerTouchMoveStateManager.isValidStartEvent(le1));
                            }
                            isValidMoveEvent(le1) {
                                return this._executeRelevantHandler(le1, (le1)=>this.mouseMoveStateManager.isValidMoveEvent(le1), (le1)=>this.oneFingerTouchMoveStateManager.isValidMoveEvent(le1));
                            }
                            isValidEndEvent(le1) {
                                return this._executeRelevantHandler(le1, (le1)=>this.mouseMoveStateManager.isValidEndEvent(le1), (le1)=>this.oneFingerTouchMoveStateManager.isValidEndEvent(le1));
                            }
                        }
                        const wr = (le1)=>{
                            le1.mousedown = le1.dragStart, le1.mousemoveWindow = le1.dragMove, le1.mouseup = le1.dragEnd, le1.contextmenu = (le1)=>{
                                le1.preventDefault();
                            };
                        };
                        class Tr {
                            constructor(le1, vt){
                                this._clickTolerance = le1.clickTolerance || 1, this._map = vt, this.reset();
                            }
                            reset() {
                                this._active = !1, this._touches = {}, this._sum = new vt.P(0, 0);
                            }
                            _shouldBePrevented(le1) {
                                return le1 < (this._map.cooperativeGestures.isEnabled() ? 2 : 1);
                            }
                            touchstart(le1, vt, bt) {
                                return this._calculateTransform(le1, vt, bt);
                            }
                            touchmove(le1, vt, bt) {
                                if (this._active) {
                                    if (!this._shouldBePrevented(bt.length)) return le1.preventDefault(), this._calculateTransform(le1, vt, bt);
                                    this._map.cooperativeGestures.notifyGestureBlocked("touch_pan", le1);
                                }
                            }
                            touchend(le1, vt, bt) {
                                this._calculateTransform(le1, vt, bt), this._active && this._shouldBePrevented(bt.length) && this.reset();
                            }
                            touchcancel() {
                                this.reset();
                            }
                            _calculateTransform(le1, bt, ls) {
                                ls.length > 0 && (this._active = !0);
                                const ho = ur(ls, bt), Dl = new vt.P(0, 0), Fl = new vt.P(0, 0);
                                let sc = 0;
                                for(const vt in ho){
                                    const le1 = ho[vt], bt = this._touches[vt];
                                    bt && (Dl._add(le1), Fl._add(le1.sub(bt)), sc++, ho[vt] = le1);
                                }
                                if (this._touches = ho, this._shouldBePrevented(sc) || !Fl.mag()) return;
                                const uc = Fl.div(sc);
                                return this._sum._add(uc), this._sum.mag() < this._clickTolerance ? void 0 : {
                                    around: Dl.div(sc),
                                    panDelta: uc
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class Pr {
                            constructor(){
                                this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._firstTwoTouches;
                            }
                            touchstart(le1, vt, bt) {
                                this._firstTwoTouches || bt.length < 2 || (this._firstTwoTouches = [
                                    bt[0].identifier,
                                    bt[1].identifier
                                ], this._start([
                                    vt[0],
                                    vt[1]
                                ]));
                            }
                            touchmove(le1, vt, bt) {
                                if (!this._firstTwoTouches) return;
                                le1.preventDefault();
                                const [ls, ho] = this._firstTwoTouches, Dl = Cr(bt, vt, ls), Fl = Cr(bt, vt, ho);
                                if (!Dl || !Fl) return;
                                const sc = this._aroundCenter ? null : Dl.add(Fl).div(2);
                                return this._move([
                                    Dl,
                                    Fl
                                ], sc, le1);
                            }
                            touchend(le1, vt, bt) {
                                if (!this._firstTwoTouches) return;
                                const [ls, ho] = this._firstTwoTouches, Dl = Cr(bt, vt, ls), Fl = Cr(bt, vt, ho);
                                Dl && Fl || (this._active && h.suppressClick(), this.reset());
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable(le1) {
                                this._enabled = !0, this._aroundCenter = !!le1 && "center" === le1.around;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active;
                            }
                        }
                        function Cr(le1, vt, bt) {
                            for(let ls = 0; ls < le1.length; ls++)if (le1[ls].identifier === bt) return vt[ls];
                        }
                        function Ir(le1, vt) {
                            return Math.log(le1 / vt) / Math.LN2;
                        }
                        class Mr extends Pr {
                            reset() {
                                super.reset(), delete this._distance, delete this._startDistance;
                            }
                            _start(le1) {
                                this._startDistance = this._distance = le1[0].dist(le1[1]);
                            }
                            _move(le1, vt) {
                                const bt = this._distance;
                                if (this._distance = le1[0].dist(le1[1]), this._active || !(Math.abs(Ir(this._distance, this._startDistance)) < .1)) return this._active = !0, {
                                    zoomDelta: Ir(this._distance, bt),
                                    pinchAround: vt
                                };
                            }
                        }
                        function Er(le1, vt) {
                            return 180 * le1.angleWith(vt) / Math.PI;
                        }
                        class Sr extends Pr {
                            reset() {
                                super.reset(), delete this._minDiameter, delete this._startVector, delete this._vector;
                            }
                            _start(le1) {
                                this._startVector = this._vector = le1[0].sub(le1[1]), this._minDiameter = le1[0].dist(le1[1]);
                            }
                            _move(le1, vt, bt) {
                                const ls = this._vector;
                                if (this._vector = le1[0].sub(le1[1]), this._active || !this._isBelowThreshold(this._vector)) return this._active = !0, {
                                    bearingDelta: Er(this._vector, ls),
                                    pinchAround: vt
                                };
                            }
                            _isBelowThreshold(le1) {
                                this._minDiameter = Math.min(this._minDiameter, le1.mag());
                                const vt = 25 / (Math.PI * this._minDiameter) * 360, bt = Er(le1, this._startVector);
                                return Math.abs(bt) < vt;
                            }
                        }
                        function zr(le1) {
                            return Math.abs(le1.y) > Math.abs(le1.x);
                        }
                        class Rr extends Pr {
                            constructor(le1){
                                super(), this._currentTouchCount = 0, this._map = le1;
                            }
                            reset() {
                                super.reset(), this._valid = void 0, delete this._firstMove, delete this._lastPoints;
                            }
                            touchstart(le1, vt, bt) {
                                super.touchstart(le1, vt, bt), this._currentTouchCount = bt.length;
                            }
                            _start(le1) {
                                this._lastPoints = le1, zr(le1[0].sub(le1[1])) && (this._valid = !1);
                            }
                            _move(le1, vt, bt) {
                                if (this._map.cooperativeGestures.isEnabled() && this._currentTouchCount < 3) return;
                                const ls = le1[0].sub(this._lastPoints[0]), ho = le1[1].sub(this._lastPoints[1]);
                                return this._valid = this.gestureBeginsVertically(ls, ho, bt.timeStamp), this._valid ? (this._lastPoints = le1, this._active = !0, {
                                    pitchDelta: (ls.y + ho.y) / 2 * -0.5
                                }) : void 0;
                            }
                            gestureBeginsVertically(le1, vt, bt) {
                                if (void 0 !== this._valid) return this._valid;
                                const ls = le1.mag() >= 2, ho = vt.mag() >= 2;
                                if (!ls && !ho) return;
                                if (!ls || !ho) return void 0 === this._firstMove && (this._firstMove = bt), bt - this._firstMove < 100 && void 0;
                                const Dl = le1.y > 0 == vt.y > 0;
                                return zr(le1) && zr(vt) && Dl;
                            }
                        }
                        const jm = {
                            panStep: 100,
                            bearingStep: 15,
                            pitchStep: 10
                        };
                        class Ar {
                            constructor(le1){
                                this._tr = new cr(le1);
                                const vt = jm;
                                this._panStep = vt.panStep, this._bearingStep = vt.bearingStep, this._pitchStep = vt.pitchStep, this._rotationDisabled = !1;
                            }
                            reset() {
                                this._active = !1;
                            }
                            keydown(le1) {
                                if (le1.altKey || le1.ctrlKey || le1.metaKey) return;
                                let bt = 0, ls = 0, ho = 0, Dl = 0, Fl = 0;
                                switch(le1.keyCode){
                                    case 61:
                                    case 107:
                                    case 171:
                                    case 187:
                                        bt = 1;
                                        break;
                                    case 189:
                                    case 109:
                                    case 173:
                                        bt = -1;
                                        break;
                                    case 37:
                                        le1.shiftKey ? ls = -1 : (le1.preventDefault(), Dl = -1);
                                        break;
                                    case 39:
                                        le1.shiftKey ? ls = 1 : (le1.preventDefault(), Dl = 1);
                                        break;
                                    case 38:
                                        le1.shiftKey ? ho = 1 : (le1.preventDefault(), Fl = -1);
                                        break;
                                    case 40:
                                        le1.shiftKey ? ho = -1 : (le1.preventDefault(), Fl = 1);
                                        break;
                                    default:
                                        return;
                                }
                                return this._rotationDisabled && (ls = 0, ho = 0), {
                                    cameraAnimation: (sc)=>{
                                        const uc = this._tr;
                                        sc.easeTo({
                                            duration: 300,
                                            easeId: "keyboardHandler",
                                            easing: Lr,
                                            zoom: bt ? vt.cx(uc.zoom + bt * (le1.shiftKey ? 2 : 1), sc.getZoomSnap()) : uc.zoom,
                                            bearing: uc.bearing + ls * this._bearingStep,
                                            pitch: uc.pitch + ho * this._pitchStep,
                                            offset: [
                                                -Dl * this._panStep,
                                                -Fl * this._panStep
                                            ],
                                            center: uc.center
                                        }, {
                                            originalEvent: le1
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                            disableRotation() {
                                this._rotationDisabled = !0;
                            }
                            enableRotation() {
                                this._rotationDisabled = !1;
                            }
                        }
                        function Lr(le1) {
                            return le1 * (2 - le1);
                        }
                        const Um = 4.000244140625, Vm = 1 / 450;
                        class Br {
                            constructor(le1, vt){
                                this._onTimeout = (le1)=>{
                                    this._type = "wheel", this._delta -= this._lastValue, this._active || this._start(le1);
                                }, this._map = le1, this._tr = new cr(le1), this._triggerRenderFrame = vt, this._delta = 0, this._defaultZoomRate = .01, this._wheelZoomRate = Vm;
                            }
                            setZoomRate(le1) {
                                this._defaultZoomRate = le1;
                            }
                            setWheelZoomRate(le1) {
                                this._wheelZoomRate = le1;
                            }
                            isEnabled() {
                                return !!this._enabled;
                            }
                            isActive() {
                                return !!this._active || void 0 !== this._finishTimeout;
                            }
                            isZooming() {
                                return !!this._zooming;
                            }
                            enable(le1) {
                                this.isEnabled() || (this._enabled = !0, this._aroundCenter = !!le1 && "center" === le1.around);
                            }
                            disable() {
                                this.isEnabled() && (this._enabled = !1);
                            }
                            _shouldBePrevented(le1) {
                                return !!this._map.cooperativeGestures.isEnabled() && !(le1.ctrlKey || this._map.cooperativeGestures.isBypassed(le1));
                            }
                            wheel(le1) {
                                if (!this.isEnabled()) return;
                                if (this._shouldBePrevented(le1)) return void this._map.cooperativeGestures.notifyGestureBlocked("wheel_zoom", le1);
                                let vt = le1.deltaMode === WheelEvent.DOM_DELTA_LINE ? 40 * le1.deltaY : le1.deltaY;
                                const bt = c(), ls = bt - (this._lastWheelEventTime || 0);
                                this._lastWheelEventTime = bt, 0 !== vt && vt % Um == 0 ? this._type = "wheel" : 0 !== vt && Math.abs(vt) < 4 ? this._type = "trackpad" : ls > 400 ? (this._type = null, this._lastValue = vt, this._timeout = setTimeout(this._onTimeout, 40, le1)) : this._type || (this._type = Math.abs(ls * vt) < 200 ? "trackpad" : "wheel", this._timeout && (clearTimeout(this._timeout), this._timeout = null, vt += this._lastValue)), le1.shiftKey && vt && (vt /= 4), this._type && (this._lastWheelEvent = le1, this._delta -= vt, this._active || this._start(le1)), le1.preventDefault();
                            }
                            _start(le1) {
                                if (!this._delta) return;
                                this._frameId && (this._frameId = null), this._active = !0, this.isZooming() || (this._zooming = !0), this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                                const bt = h.mousePos(this._map.getCanvas(), le1), ls = this._tr;
                                this._aroundPoint = this._aroundCenter ? ls.transform.locationToScreenPoint(vt.V.convert(ls.center)) : bt, this._frameId || (this._frameId = !0, this._triggerRenderFrame());
                            }
                            renderFrame() {
                                if (!this._frameId) return;
                                if (this._frameId = null, !this.isActive()) return;
                                const le1 = this._tr.transform;
                                if ("number" == typeof this._lastExpectedZoom) {
                                    const vt = le1.zoom - this._lastExpectedZoom;
                                    "number" == typeof this._startZoom && (this._startZoom += vt), "number" == typeof this._targetZoom && (this._targetZoom += vt);
                                }
                                if (0 !== this._delta) {
                                    const bt = "wheel" === this._type && Math.abs(this._delta) > Um ? this._wheelZoomRate : this._defaultZoomRate;
                                    let ls = 2 / (1 + Math.exp(-Math.abs(this._delta * bt)));
                                    this._delta < 0 && 0 !== ls && (ls = 1 / ls);
                                    const ho = "number" != typeof this._targetZoom ? le1.scale : vt.aq(this._targetZoom), Dl = le1.applyConstrain(le1.getCameraLngLat(), vt.at(ho * ls)).zoom, Fl = this._map.getZoomSnap();
                                    if ("wheel" === this._type && Fl > 0) {
                                        const bt = vt.cx(le1.zoom, Fl);
                                        this._targetZoom = vt.cx(Dl, Fl, Dl - bt);
                                    } else this._targetZoom = Dl;
                                    "wheel" === this._type && (this._startZoom = le1.zoom, this._easing = this._smoothOutEasing(200)), this._delta = 0;
                                }
                                const bt = "number" != typeof this._targetZoom ? le1.zoom : this._targetZoom, ls = this._startZoom, ho = this._easing;
                                let Dl, Fl = !1;
                                if ("wheel" === this._type && ls && ho) {
                                    const le1 = c() - this._lastWheelEventTime, sc = Math.min((le1 + 5) / 200, 1), uc = ho(sc);
                                    Dl = vt.G.number(ls, bt, uc), sc < 1 ? this._frameId || (this._frameId = !0) : Fl = !0;
                                } else Dl = bt, Fl = !0;
                                return this._active = !0, Fl && (this._active = !1, this._finishTimeout = setTimeout(()=>{
                                    this._zooming = !1, this._triggerRenderFrame(), delete this._targetZoom, delete this._lastExpectedZoom, delete this._finishTimeout;
                                }, 200)), this._lastExpectedZoom = Dl, {
                                    noInertia: !0,
                                    needsRenderFrame: !Fl,
                                    zoomDelta: Dl - le1.zoom,
                                    around: this._aroundPoint,
                                    originalEvent: this._lastWheelEvent
                                };
                            }
                            _smoothOutEasing(le1) {
                                let bt = vt.cz;
                                if (this._prevEase) {
                                    const le1 = this._prevEase, ls = (c() - le1.start) / le1.duration, ho = le1.easing(ls + .01) - le1.easing(ls), Dl = .27 / Math.sqrt(ho * ho + 1e-4) * .01, Fl = Math.sqrt(.0729 - Dl * Dl);
                                    bt = vt.cw(Dl, Fl, .25, 1);
                                }
                                return this._prevEase = {
                                    start: c(),
                                    duration: le1,
                                    easing: bt
                                }, bt;
                            }
                            reset() {
                                this._active = !1, this._zooming = !1, delete this._targetZoom, delete this._lastExpectedZoom, this._finishTimeout && (clearTimeout(this._finishTimeout), delete this._finishTimeout);
                            }
                        }
                        class Or {
                            constructor(le1, vt){
                                this._clickZoom = le1, this._tapZoom = vt;
                            }
                            enable() {
                                this._clickZoom.enable(), this._tapZoom.enable();
                            }
                            disable() {
                                this._clickZoom.disable(), this._tapZoom.disable();
                            }
                            isEnabled() {
                                return this._clickZoom.isEnabled() && this._tapZoom.isEnabled();
                            }
                            isActive() {
                                return this._clickZoom.isActive() || this._tapZoom.isActive();
                            }
                        }
                        class jr {
                            constructor(le1){
                                this._tr = new cr(le1), this.reset();
                            }
                            reset() {
                                this._active = !1;
                            }
                            dblclick(le1, bt) {
                                return le1.preventDefault(), {
                                    cameraAnimation: (ls)=>{
                                        ls.easeTo({
                                            duration: 300,
                                            zoom: vt.cx(this._tr.zoom + (le1.shiftKey ? -1 : 1), ls.getZoomSnap()),
                                            around: this._tr.unproject(bt)
                                        }, {
                                            originalEvent: le1
                                        });
                                    }
                                };
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class Nr {
                            constructor(){
                                this._tap = new _r({
                                    numTouches: 1,
                                    numTaps: 1
                                }), this.reset();
                            }
                            reset() {
                                this._active = !1, delete this._swipePoint, delete this._swipeTouch, delete this._tapTime, delete this._tapPoint, this._tap.reset();
                            }
                            touchstart(le1, vt, bt) {
                                if (!this._swipePoint) {
                                    if (this._tapTime) {
                                        const ls = vt[0], ho = le1.timeStamp - this._tapTime < 500, Dl = this._tapPoint.dist(ls) < 30;
                                        ho && Dl ? bt.length > 0 && (this._swipePoint = ls, this._swipeTouch = bt[0].identifier) : this.reset();
                                    } else this._tap.touchstart(le1, vt, bt);
                                }
                            }
                            touchmove(le1, vt, bt) {
                                if (this._tapTime) {
                                    if (this._swipePoint) {
                                        if (bt[0].identifier !== this._swipeTouch) return;
                                        const ls = vt[0], ho = ls.y - this._swipePoint.y;
                                        return this._swipePoint = ls, le1.preventDefault(), this._active = !0, {
                                            zoomDelta: ho / 128
                                        };
                                    }
                                } else this._tap.touchmove(le1, vt, bt);
                            }
                            touchend(le1, vt, bt) {
                                if (this._tapTime) this._swipePoint && 0 === bt.length && this.reset();
                                else {
                                    const ls = this._tap.touchend(le1, vt, bt);
                                    ls && (this._tapTime = le1.timeStamp, this._tapPoint = ls);
                                }
                            }
                            touchcancel() {
                                this.reset();
                            }
                            enable() {
                                this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this.reset();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isActive() {
                                return this._active;
                            }
                        }
                        class Zr {
                            constructor(le1, vt, bt){
                                this._el = le1, this._mousePan = vt, this._touchPan = bt;
                            }
                            enable(le1) {
                                this._inertiaOptions = le1 || {}, this._mousePan.enable(), this._touchPan.enable(), this._el.classList.add("maplibregl-touch-drag-pan");
                            }
                            disable() {
                                this._mousePan.disable(), this._touchPan.disable(), this._el.classList.remove("maplibregl-touch-drag-pan");
                            }
                            isEnabled() {
                                return this._mousePan.isEnabled() && this._touchPan.isEnabled();
                            }
                            isActive() {
                                return this._mousePan.isActive() || this._touchPan.isActive();
                            }
                        }
                        class Ur {
                            constructor(le1, vt, bt, ls){
                                this._pitchWithRotate = le1.pitchWithRotate, this._rollEnabled = le1.rollEnabled, this._mouseRotate = vt, this._mousePitch = bt, this._mouseRoll = ls;
                            }
                            enable() {
                                this._mouseRotate.enable(), this._pitchWithRotate && this._mousePitch.enable(), this._rollEnabled && this._mouseRoll.enable();
                            }
                            disable() {
                                this._mouseRotate.disable(), this._mousePitch.disable(), this._mouseRoll.disable();
                            }
                            isEnabled() {
                                return this._mouseRotate.isEnabled() && (!this._pitchWithRotate || this._mousePitch.isEnabled()) && (!this._rollEnabled || this._mouseRoll.isEnabled());
                            }
                            isActive() {
                                return this._mouseRotate.isActive() || this._mousePitch.isActive() || this._mouseRoll.isActive();
                            }
                        }
                        class Gr {
                            constructor(le1, vt, bt, ls){
                                this._el = le1, this._touchZoom = vt, this._touchRotate = bt, this._tapDragZoom = ls, this._rotationDisabled = !1, this._enabled = !0;
                            }
                            enable(le1) {
                                this._touchZoom.enable(le1), this._rotationDisabled || this._touchRotate.enable(le1), this._tapDragZoom.enable(), this._el.classList.add("maplibregl-touch-zoom-rotate");
                            }
                            disable() {
                                this._touchZoom.disable(), this._touchRotate.disable(), this._tapDragZoom.disable(), this._el.classList.remove("maplibregl-touch-zoom-rotate");
                            }
                            isEnabled() {
                                return this._touchZoom.isEnabled() && (this._rotationDisabled || this._touchRotate.isEnabled()) && this._tapDragZoom.isEnabled();
                            }
                            isActive() {
                                return this._touchZoom.isActive() || this._touchRotate.isActive() || this._tapDragZoom.isActive();
                            }
                            disableRotation() {
                                this._rotationDisabled = !0, this._touchRotate.disable();
                            }
                            enableRotation() {
                                this._rotationDisabled = !1, this._touchZoom.isEnabled() && this._touchRotate.enable();
                            }
                        }
                        class Vr {
                            constructor(le1, vt){
                                this._bypassKey = -1 !== navigator.userAgent.indexOf("Mac") ? "metaKey" : "ctrlKey", this._map = le1, this._options = vt, this._enabled = !1;
                            }
                            isActive() {
                                return !1;
                            }
                            reset() {}
                            _setupUI() {
                                if (this._container) return;
                                const le1 = this._map.getCanvasContainer();
                                le1.classList.add("maplibregl-cooperative-gestures"), this._container = h.create("div", "maplibregl-cooperative-gesture-screen", le1);
                                let vt = this._map._getUIString("CooperativeGesturesHandler.WindowsHelpText");
                                "metaKey" === this._bypassKey && (vt = this._map._getUIString("CooperativeGesturesHandler.MacHelpText"));
                                const bt = this._map._getUIString("CooperativeGesturesHandler.MobileHelpText"), ls = document.createElement("div");
                                ls.className = "maplibregl-desktop-message", ls.textContent = vt, this._container.appendChild(ls);
                                const ho = document.createElement("div");
                                ho.className = "maplibregl-mobile-message", ho.textContent = bt, this._container.appendChild(ho), this._container.setAttribute("aria-hidden", "true");
                            }
                            _destroyUI() {
                                this._container && (h.remove(this._container), this._map.getCanvasContainer().classList.remove("maplibregl-cooperative-gestures")), delete this._container;
                            }
                            enable() {
                                this._setupUI(), this._enabled = !0;
                            }
                            disable() {
                                this._enabled = !1, this._destroyUI();
                            }
                            isEnabled() {
                                return this._enabled;
                            }
                            isBypassed(le1) {
                                return le1[this._bypassKey];
                            }
                            notifyGestureBlocked(le1, bt) {
                                this._enabled && (this._map.fire(new vt.l("cooperativegestureprevented", {
                                    gestureType: le1,
                                    originalEvent: bt
                                })), this._container.classList.add("maplibregl-show"), setTimeout(()=>{
                                    this._container.classList.remove("maplibregl-show");
                                }, 100));
                            }
                        }
                        const qr = (le1)=>le1.zoom || le1.drag || le1.roll || le1.pitch || le1.rotate;
                        class Wr extends vt.l {
                        }
                        function $r(le1) {
                            return le1.panDelta && le1.panDelta.mag() || le1.zoomDelta || le1.bearingDelta || le1.pitchDelta || le1.rollDelta;
                        }
                        class Hr {
                            get _ownerDocument() {
                                var le1;
                                return (null === (le1 = this._el) || void 0 === le1 ? void 0 : le1.ownerDocument) || document;
                            }
                            get _ownerWindow() {
                                var le1, vt;
                                return (null === (vt = null === (le1 = this._el) || void 0 === le1 ? void 0 : le1.ownerDocument) || void 0 === vt ? void 0 : vt.defaultView) || window;
                            }
                            constructor(le1, bt){
                                this.handleWindowEvent = (le1)=>{
                                    this.handleEvent(le1, `${le1.type}Window`);
                                }, this.handleEvent = (le1, bt)=>{
                                    if ("blur" === le1.type) return void this.stop(!0);
                                    this._updatingCamera = !0;
                                    const ls = "renderFrame" === le1.type ? void 0 : le1, ho = {
                                        needsRenderFrame: !1
                                    }, Dl = {}, Fl = {};
                                    for (const { handlerName: mc, handler: gc, allowed: Ac } of this._handlers){
                                        if (!gc.isEnabled()) continue;
                                        let sc;
                                        if (this._blockedByActive(Fl, Ac, mc)) gc.reset();
                                        else if (gc[bt || le1.type]) {
                                            if (vt.cA(le1, bt || le1.type)) {
                                                const vt = h.mousePos(this._map.getCanvas(), le1);
                                                sc = gc[bt || le1.type](le1, vt);
                                            } else if (vt.cB(le1, bt || le1.type)) {
                                                const vt = this._getMapTouches(le1.touches), ls = h.touchPos(this._map.getCanvas(), vt);
                                                sc = gc[bt || le1.type](le1, ls, vt);
                                            } else vt.cC(bt || le1.type) || (sc = gc[bt || le1.type](le1));
                                            this.mergeHandlerResult(ho, Dl, sc, mc, ls), sc && sc.needsRenderFrame && this._triggerRenderFrame();
                                        }
                                        (sc || gc.isActive()) && (Fl[mc] = gc);
                                    }
                                    const sc = {};
                                    for(const vt in this._previousActiveHandlers)Fl[vt] || (sc[vt] = ls);
                                    this._previousActiveHandlers = Fl, (Object.keys(sc).length || $r(ho)) && (this._changes.push([
                                        ho,
                                        Dl,
                                        sc
                                    ]), this._triggerRenderFrame()), (Object.keys(Fl).length || $r(ho)) && this._map._stop(!0), this._updatingCamera = !1;
                                    const { cameraAnimation: uc } = ho;
                                    uc && (this._inertia.clear(), this._fireEvents({}, {}, !0), this._changes = [], uc(this._map));
                                }, this._map = le1, this._el = this._map.getCanvasContainer(), this._handlers = [], this._handlersById = {}, this._changes = [], this._inertia = new tr(le1), this._bearingSnap = bt.bearingSnap, this._previousActiveHandlers = {}, this._eventsInProgress = {}, this._addDefaultHandlers(bt);
                                const ls = this._el;
                                this._listeners = [
                                    [
                                        ls,
                                        "touchstart",
                                        {
                                            passive: !0
                                        }
                                    ],
                                    [
                                        ls,
                                        "touchmove",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        ls,
                                        "touchend",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "touchcancel",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "mousedown",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "mousemove",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        this._ownerDocument,
                                        "mousemove",
                                        {
                                            capture: !0
                                        }
                                    ],
                                    [
                                        this._ownerDocument,
                                        "mouseup",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "mouseover",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "mouseout",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "dblclick",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "click",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "keydown",
                                        {
                                            capture: !1
                                        }
                                    ],
                                    [
                                        ls,
                                        "keyup",
                                        void 0
                                    ],
                                    [
                                        ls,
                                        "wheel",
                                        {
                                            passive: !1
                                        }
                                    ],
                                    [
                                        ls,
                                        "contextmenu",
                                        void 0
                                    ],
                                    [
                                        this._ownerWindow,
                                        "blur",
                                        void 0
                                    ]
                                ];
                                for (const [vt, ho, Dl] of this._listeners)h.addEventListener(vt, ho, vt === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, Dl);
                            }
                            destroy() {
                                for (const [le1, vt, bt] of this._listeners)h.removeEventListener(le1, vt, le1 === this._ownerDocument ? this.handleWindowEvent : this.handleEvent, bt);
                            }
                            _addDefaultHandlers(le1) {
                                const bt = this._map, ls = bt.getCanvasContainer();
                                this._add("mapEvent", new nr(bt, le1));
                                const ho = bt.boxZoom = new hr(bt, le1);
                                this._add("boxZoom", ho), le1.interactive && le1.boxZoom && ho.enable();
                                const Dl = bt.cooperativeGestures = new Vr(bt, le1.cooperativeGestures);
                                this._add("cooperativeGestures", Dl), le1.cooperativeGestures && Dl.enable();
                                const Fl = new pr(bt), sc = new jr(bt);
                                bt.doubleClickZoom = new Or(sc, Fl), this._add("tapZoom", Fl), this._add("clickZoom", sc), le1.interactive && le1.doubleClickZoom && bt.doubleClickZoom.enable();
                                const uc = new Nr;
                                this._add("tapDragZoom", uc);
                                const mc = bt.touchPitch = new Rr(bt);
                                this._add("touchPitch", mc), le1.interactive && le1.touchPitch && bt.touchPitch.enable(le1.touchPitch);
                                const u = ()=>bt.project(bt.getCenter()), gc = function({ enable: le1, clickTolerance: bt, aroundCenter: ls = !0, minPixelCenterThreshold: ho = 100, rotateDegreesPerPixelMoved: Dl = .8 }, Fl) {
                                    const sc = new xr({
                                        checkCorrectEvent: (le1)=>0 === h.mouseButton(le1) && le1.ctrlKey || 2 === h.mouseButton(le1) && !le1.ctrlKey
                                    });
                                    return new mr({
                                        clickTolerance: bt,
                                        move: (le1, bt)=>{
                                            const sc = Fl();
                                            if (ls && Math.abs(sc.y - le1.y) > ho) return {
                                                bearingDelta: vt.cy(new vt.P(le1.x, bt.y), bt, sc)
                                            };
                                            let uc = (bt.x - le1.x) * Dl;
                                            return ls && bt.y < sc.y && (uc = -uc), {
                                                bearingDelta: uc
                                            };
                                        },
                                        moveStateManager: sc,
                                        enable: le1,
                                        assignEvents: wr
                                    });
                                }(le1, u), Ac = function({ enable: le1, clickTolerance: vt, pitchDegreesPerPixelMoved: bt = -0.5 }) {
                                    const ls = new xr({
                                        checkCorrectEvent: (le1)=>0 === h.mouseButton(le1) && le1.ctrlKey || 2 === h.mouseButton(le1)
                                    });
                                    return new mr({
                                        clickTolerance: vt,
                                        move: (le1, vt)=>({
                                                pitchDelta: (vt.y - le1.y) * bt
                                            }),
                                        moveStateManager: ls,
                                        enable: le1,
                                        assignEvents: wr
                                    });
                                }(le1), Ec = function({ enable: le1, clickTolerance: vt, rollDegreesPerPixelMoved: bt = .3 }, ls) {
                                    const ho = new xr({
                                        checkCorrectEvent: (le1)=>2 === h.mouseButton(le1) && le1.ctrlKey
                                    });
                                    return new mr({
                                        clickTolerance: vt,
                                        move: (le1, vt)=>{
                                            const ho = ls();
                                            let Dl = (vt.x - le1.x) * bt;
                                            return vt.y < ho.y && (Dl = -Dl), {
                                                rollDelta: Dl
                                            };
                                        },
                                        moveStateManager: ho,
                                        enable: le1,
                                        assignEvents: wr
                                    });
                                }(le1, u);
                                bt.dragRotate = new Ur(le1, gc, Ac, Ec), this._add("mouseRotate", gc, [
                                    "mousePitch"
                                ]), this._add("mousePitch", Ac, [
                                    "mouseRotate",
                                    "mouseRoll"
                                ]), this._add("mouseRoll", Ec, [
                                    "mousePitch"
                                ]), le1.interactive && le1.dragRotate && bt.dragRotate.enable();
                                const kc = function({ enable: le1, clickTolerance: vt }) {
                                    const bt = new xr({
                                        checkCorrectEvent: (le1)=>0 === h.mouseButton(le1) && !le1.ctrlKey
                                    });
                                    return new mr({
                                        clickTolerance: vt,
                                        move: (le1, vt)=>({
                                                around: vt,
                                                panDelta: vt.sub(le1)
                                            }),
                                        activateOnStart: !0,
                                        moveStateManager: bt,
                                        enable: le1,
                                        assignEvents: wr
                                    });
                                }(le1), du = new Tr(le1, bt);
                                bt.dragPan = new Zr(ls, kc, du), this._add("mousePan", kc), this._add("touchPan", du, [
                                    "touchZoom",
                                    "touchRotate"
                                ]), le1.interactive && le1.dragPan && bt.dragPan.enable(le1.dragPan);
                                const _u = new Sr, Md = new Mr;
                                bt.touchZoomRotate = new Gr(ls, Md, _u, uc), this._add("touchRotate", _u, [
                                    "touchPan",
                                    "touchZoom"
                                ]), this._add("touchZoom", Md, [
                                    "touchPan",
                                    "touchRotate"
                                ]), le1.interactive && le1.touchZoomRotate && bt.touchZoomRotate.enable(le1.touchZoomRotate), this._add("blockableMapEvent", new lr(bt));
                                const Ld = bt.scrollZoom = new Br(bt, ()=>this._triggerRenderFrame());
                                this._add("scrollZoom", Ld, [
                                    "mousePan"
                                ]), le1.interactive && le1.scrollZoom && bt.scrollZoom.enable(le1.scrollZoom);
                                const Nd = bt.keyboard = new Ar(bt);
                                this._add("keyboard", Nd), le1.interactive && le1.keyboard && bt.keyboard.enable();
                            }
                            _add(le1, vt, bt) {
                                this._handlers.push({
                                    handlerName: le1,
                                    handler: vt,
                                    allowed: bt
                                }), this._handlersById[le1] = vt;
                            }
                            stop(le1) {
                                if (!this._updatingCamera) {
                                    for (const { handler: le1 } of this._handlers)le1.reset();
                                    this._inertia.clear(), this._fireEvents({}, {}, le1), this._changes = [];
                                }
                            }
                            isActive() {
                                for (const { handler: le1 } of this._handlers)if (le1.isActive()) return !0;
                                return !1;
                            }
                            isZooming() {
                                return !!this._eventsInProgress.zoom || this._map.scrollZoom.isZooming();
                            }
                            isRotating() {
                                return !!this._eventsInProgress.rotate;
                            }
                            isMoving() {
                                return Boolean(qr(this._eventsInProgress)) || this.isZooming();
                            }
                            _blockedByActive(le1, vt, bt) {
                                for(const ls in le1)if (ls !== bt && (!vt || vt.indexOf(ls) < 0)) return !0;
                                return !1;
                            }
                            _getMapTouches(le1) {
                                const vt = [];
                                for (const bt of le1)this._el.contains(bt.target) && vt.push(bt);
                                return vt;
                            }
                            mergeHandlerResult(le1, bt, ls, ho, Dl) {
                                if (!ls) return;
                                vt.e(le1, ls);
                                const Fl = {
                                    handlerName: ho,
                                    originalEvent: ls.originalEvent || Dl
                                };
                                void 0 !== ls.zoomDelta && (bt.zoom = Fl), void 0 !== ls.panDelta && (bt.drag = Fl), void 0 !== ls.rollDelta && (bt.roll = Fl), void 0 !== ls.pitchDelta && (bt.pitch = Fl), void 0 !== ls.bearingDelta && (bt.rotate = Fl);
                            }
                            _applyChanges() {
                                const le1 = {}, bt = {}, ls = {};
                                for (const [ho, Dl, Fl] of this._changes)ho.panDelta && (le1.panDelta = (le1.panDelta || new vt.P(0, 0))._add(ho.panDelta)), ho.zoomDelta && (le1.zoomDelta = (le1.zoomDelta || 0) + ho.zoomDelta), ho.bearingDelta && (le1.bearingDelta = (le1.bearingDelta || 0) + ho.bearingDelta), ho.pitchDelta && (le1.pitchDelta = (le1.pitchDelta || 0) + ho.pitchDelta), ho.rollDelta && (le1.rollDelta = (le1.rollDelta || 0) + ho.rollDelta), void 0 !== ho.around && (le1.around = ho.around), void 0 !== ho.pinchAround && (le1.pinchAround = ho.pinchAround), ho.noInertia && (le1.noInertia = ho.noInertia), vt.e(bt, Dl), vt.e(ls, Fl);
                                this._updateMapTransform(le1, bt, ls), this._changes = [];
                            }
                            _updateMapTransform(le1, vt, bt) {
                                const ls = this._map, ho = ls._getTransformForUpdate(), Dl = ls.terrain;
                                if (!($r(le1) || Dl && this._terrainMovement)) return this._fireEvents(vt, bt, !0);
                                ls._stop(!0);
                                let { panDelta: Fl, zoomDelta: sc, bearingDelta: uc, pitchDelta: mc, rollDelta: gc, around: Ac, pinchAround: Ec } = le1;
                                void 0 !== Ec && (Ac = Ec), Ac = Ac || ls.transform.centerPoint, Dl && !ho.isPointOnMapSurface(Ac) && (Ac = ho.centerPoint);
                                const kc = {
                                    panDelta: Fl,
                                    zoomDelta: sc,
                                    rollDelta: gc,
                                    pitchDelta: mc,
                                    bearingDelta: uc,
                                    around: Ac
                                };
                                this._map.cameraHelper.useGlobeControls && !ho.isPointOnMapSurface(Ac) && (Ac = ho.centerPoint);
                                const du = Ac.distSqr(ho.centerPoint) < .01 ? ho.center : ho.screenPointToLocation(Fl ? Ac.sub(Fl) : Ac);
                                this._handleMapControls({
                                    terrain: Dl,
                                    tr: ho,
                                    deltasForHelper: kc,
                                    preZoomAroundLoc: du,
                                    combinedEventsInProgress: vt,
                                    panDelta: Fl
                                }), ls._applyUpdatedTransform(ho), this._map._update(), le1.noInertia || this._inertia.record(le1), this._fireEvents(vt, bt, !0);
                            }
                            _handleMapControls({ terrain: le1, tr: vt, deltasForHelper: bt, preZoomAroundLoc: ls, combinedEventsInProgress: ho, panDelta: Dl }) {
                                const Fl = this._map.cameraHelper;
                                if (Fl.handleMapControlsRollPitchBearingZoom(bt, vt), le1) return Fl.useGlobeControls ? (this._terrainMovement || !ho.drag && !ho.zoom || (this._terrainMovement = !0, this._map._elevationFreeze = !0), void Fl.handleMapControlsPan(bt, vt, ls)) : this._terrainMovement || !ho.drag && !ho.zoom ? void (ho.drag && this._terrainMovement && Dl ? vt.setCenter(vt.screenPointToLocation(vt.centerPoint.sub(Dl))) : Fl.handleMapControlsPan(bt, vt, ls)) : (this._terrainMovement = !0, this._map._elevationFreeze = !0, void Fl.handleMapControlsPan(bt, vt, ls));
                                Fl.handleMapControlsPan(bt, vt, ls);
                            }
                            _fireEvents(le1, bt, ls) {
                                const ho = qr(this._eventsInProgress), Dl = qr(le1), sc = {};
                                for(const vt in le1){
                                    const { originalEvent: bt } = le1[vt];
                                    this._eventsInProgress[vt] || (sc[`${vt}start`] = bt), this._eventsInProgress[vt] = le1[vt];
                                }
                                !ho && Dl && this._fireEvent("movestart", Dl.originalEvent);
                                for(const vt in sc)this._fireEvent(vt, sc[vt]);
                                Dl && this._fireEvent("move", Dl.originalEvent);
                                for(const vt in le1){
                                    const { originalEvent: bt } = le1[vt];
                                    this._fireEvent(vt, bt);
                                }
                                const uc = {};
                                let mc;
                                for(const vt in this._eventsInProgress){
                                    const { handlerName: le1, originalEvent: ls } = this._eventsInProgress[vt];
                                    this._handlersById[le1].isActive() || (delete this._eventsInProgress[vt], mc = bt[le1] || ls, uc[`${vt}end`] = mc);
                                }
                                for(const vt in uc)this._fireEvent(vt, uc[vt]);
                                const gc = qr(this._eventsInProgress), Ac = (ho || Dl) && !gc;
                                if (Ac && this._terrainMovement) {
                                    this._map._elevationFreeze = !1, this._terrainMovement = !1;
                                    const le1 = this._map._getTransformForUpdate();
                                    this._map.getCenterClampedToGround() && le1.recalculateZoomAndCenter(this._map.terrain), this._map._applyUpdatedTransform(le1);
                                }
                                if (ls && Ac) {
                                    this._updatingCamera = !0;
                                    const le1 = this._inertia._onMoveEnd(this._map.dragPan._inertiaOptions), i = (le1)=>0 !== le1 && -this._bearingSnap < le1 && le1 < this._bearingSnap;
                                    !le1 || !le1.essential && Fl.prefersReducedMotion ? (this._map.fire(new vt.l("moveend", {
                                        originalEvent: mc
                                    })), i(this._map.getBearing()) && this._map.resetNorth()) : (i(le1.bearing || this._map.getBearing()) && (le1.bearing = 0), le1.freezeElevation = !0, this._map.easeTo(le1, {
                                        originalEvent: mc
                                    })), this._updatingCamera = !1;
                                }
                            }
                            _fireEvent(le1, bt) {
                                this._map.fire(new vt.l(le1, bt ? {
                                    originalEvent: bt
                                } : {}));
                            }
                            _requestFrame() {
                                return this._map.triggerRepaint(), this._map._renderTaskQueue.add((le1)=>{
                                    delete this._frameId, this.handleEvent(new Wr("renderFrame", {
                                        timeStamp: le1
                                    })), this._applyChanges();
                                });
                            }
                            _triggerRenderFrame() {
                                void 0 === this._frameId && (this._frameId = this._requestFrame());
                            }
                        }
                        class Xr extends vt.E {
                            constructor(le1, vt, bt){
                                super(), this._renderFrameCallback = ()=>{
                                    const le1 = Math.min((c() - this._easeStart) / this._easeOptions.duration, 1);
                                    this._onEaseFrame(this._easeOptions.easing(le1)), le1 < 1 && this._easeFrameId ? this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback) : this.stop();
                                }, this._moving = !1, this._zooming = !1, this.transform = le1, this._bearingSnap = bt.bearingSnap, this._zoomSnap = bt.zoomSnap, this.cameraHelper = vt, this.on("moveend", ()=>{
                                    delete this._requestedCameraState;
                                });
                            }
                            migrateProjection(le1, vt) {
                                le1.apply(this.transform, !0), this.transform = le1, this.cameraHelper = vt;
                            }
                            getCenter() {
                                return new vt.V(this.transform.center.lng, this.transform.center.lat);
                            }
                            setCenter(le1, vt) {
                                return this.jumpTo({
                                    center: le1
                                }, vt);
                            }
                            getCenterElevation() {
                                return this.transform.elevation;
                            }
                            setCenterElevation(le1, vt) {
                                return this.jumpTo({
                                    elevation: le1
                                }, vt), this;
                            }
                            getCenterClampedToGround() {
                                return this._centerClampedToGround;
                            }
                            setCenterClampedToGround(le1) {
                                this._centerClampedToGround = le1;
                            }
                            panBy(le1, bt, ls) {
                                return le1 = vt.P.convert(le1).mult(-1), this.panTo(this.transform.center, vt.e({
                                    offset: le1
                                }, bt), ls);
                            }
                            panTo(le1, bt, ls) {
                                return this.easeTo(vt.e({
                                    center: le1
                                }, bt), ls);
                            }
                            getZoom() {
                                return this.transform.zoom;
                            }
                            setZoom(le1, vt) {
                                return this.jumpTo({
                                    zoom: le1
                                }, vt), this;
                            }
                            zoomTo(le1, bt, ls) {
                                return this.easeTo(vt.e({
                                    zoom: le1
                                }, bt), ls);
                            }
                            zoomIn(le1, bt) {
                                return this.zoomTo(vt.cx(this.getZoom() + 1, this._zoomSnap), le1, bt), this;
                            }
                            zoomOut(le1, bt) {
                                return this.zoomTo(vt.cx(this.getZoom() - 1, this._zoomSnap), le1, bt), this;
                            }
                            getVerticalFieldOfView() {
                                return this.transform.fov;
                            }
                            setVerticalFieldOfView(le1, bt) {
                                return le1 != this.transform.fov && (this.transform.setFov(le1), this.fire(new vt.l("movestart", bt)).fire(new vt.l("move", bt)).fire(new vt.l("moveend", bt))), this;
                            }
                            getBearing() {
                                return this.transform.bearing;
                            }
                            setZoomSnap(le1) {
                                return this._zoomSnap = le1, this;
                            }
                            getZoomSnap() {
                                return this._zoomSnap;
                            }
                            setBearing(le1, vt) {
                                return this.jumpTo({
                                    bearing: le1
                                }, vt), this;
                            }
                            getPadding() {
                                return this.transform.padding;
                            }
                            setPadding(le1, vt) {
                                return this.jumpTo({
                                    padding: le1
                                }, vt), this;
                            }
                            rotateTo(le1, bt, ls) {
                                return this.easeTo(vt.e({
                                    bearing: le1
                                }, bt), ls);
                            }
                            resetNorth(le1, bt) {
                                return this.rotateTo(0, vt.e({
                                    duration: 1e3
                                }, le1), bt), this;
                            }
                            resetNorthPitch(le1, bt) {
                                return this.easeTo(vt.e({
                                    bearing: 0,
                                    pitch: 0,
                                    roll: 0,
                                    duration: 1e3
                                }, le1), bt), this;
                            }
                            snapToNorth(le1, vt) {
                                return Math.abs(this.getBearing()) < this._bearingSnap ? this.resetNorth(le1, vt) : this;
                            }
                            getPitch() {
                                return this.transform.pitch;
                            }
                            setPitch(le1, vt) {
                                return this.jumpTo({
                                    pitch: le1
                                }, vt), this;
                            }
                            getRoll() {
                                return this.transform.roll;
                            }
                            setRoll(le1, vt) {
                                return this.jumpTo({
                                    roll: le1
                                }, vt), this;
                            }
                            cameraForBounds(le1, vt) {
                                le1 = $.convert(le1).adjustAntiMeridian();
                                const bt = vt && vt.bearing || 0;
                                return this._cameraForBoxAndBearing(le1.getNorthWest(), le1.getSouthEast(), bt, vt);
                            }
                            _cameraForBoxAndBearing(le1, bt, ls, ho) {
                                const Dl = {
                                    top: 0,
                                    bottom: 0,
                                    right: 0,
                                    left: 0
                                };
                                if ("number" == typeof (ho = vt.e({
                                    padding: Dl,
                                    offset: [
                                        0,
                                        0
                                    ],
                                    maxZoom: this.transform.maxZoom
                                }, ho)).padding) {
                                    const le1 = ho.padding;
                                    ho.padding = {
                                        top: le1,
                                        bottom: le1,
                                        right: le1,
                                        left: le1
                                    };
                                }
                                const Fl = vt.e(Dl, ho.padding);
                                ho.padding = Fl;
                                const sc = this.transform, uc = new $(le1, bt);
                                return this.cameraHelper.cameraForBoxAndBearing(ho, Fl, uc, ls, sc);
                            }
                            fitBounds(le1, vt, bt) {
                                return this._fitInternal(this.cameraForBounds(le1, vt), vt, bt);
                            }
                            fitScreenCoordinates(le1, bt, ls, ho, Dl) {
                                return this._fitInternal(this._cameraForBoxAndBearing(this.transform.screenPointToLocation(vt.P.convert(le1)), this.transform.screenPointToLocation(vt.P.convert(bt)), ls, ho), ho, Dl);
                            }
                            _fitInternal(le1, bt, ls) {
                                return le1 ? (delete (bt = vt.e(le1, bt)).padding, bt.linear ? this.easeTo(bt, ls) : this.flyTo(bt, ls)) : this;
                            }
                            jumpTo(le1, bt) {
                                this.stop();
                                const ls = this._getTransformForUpdate();
                                let ho = !1, Dl = !1, Fl = !1;
                                const sc = ls.zoom;
                                this.cameraHelper.handleJumpToCenterZoom(ls, le1);
                                const uc = ls.zoom !== sc;
                                return "elevation" in le1 && ls.elevation !== +le1.elevation && ls.setElevation(+le1.elevation), "bearing" in le1 && ls.bearing !== +le1.bearing && (ho = !0, ls.setBearing(+le1.bearing)), "pitch" in le1 && ls.pitch !== +le1.pitch && (Dl = !0, ls.setPitch(+le1.pitch)), "roll" in le1 && ls.roll !== +le1.roll && (Fl = !0, ls.setRoll(+le1.roll)), null == le1.padding || ls.isPaddingEqual(le1.padding) || ls.setPadding(le1.padding), this._applyUpdatedTransform(ls), this.fire(new vt.l("movestart", bt)).fire(new vt.l("move", bt)), uc && this.fire(new vt.l("zoomstart", bt)).fire(new vt.l("zoom", bt)).fire(new vt.l("zoomend", bt)), ho && this.fire(new vt.l("rotatestart", bt)).fire(new vt.l("rotate", bt)).fire(new vt.l("rotateend", bt)), Dl && this.fire(new vt.l("pitchstart", bt)).fire(new vt.l("pitch", bt)).fire(new vt.l("pitchend", bt)), Fl && this.fire(new vt.l("rollstart", bt)).fire(new vt.l("roll", bt)).fire(new vt.l("rollend", bt)), this.fire(new vt.l("moveend", bt));
                            }
                            calculateCameraOptionsFromTo(le1, bt, ls, ho = 0) {
                                const Dl = vt.a9.fromLngLat(le1, bt), Fl = vt.a9.fromLngLat(ls, ho), sc = Fl.x - Dl.x, uc = Fl.y - Dl.y, mc = Fl.z - Dl.z, gc = Math.hypot(sc, uc, mc);
                                if (0 === gc) throw new Error("Can't calculate camera options with same From and To");
                                const Ac = Math.hypot(sc, uc), Ec = vt.at(this.transform.cameraToCenterDistance / gc / this.transform.tileSize), kc = 180 * Math.atan2(sc, -uc) / Math.PI;
                                let du = 180 * Math.acos(Ac / gc) / Math.PI;
                                return du = mc < 0 ? 90 - du : 90 + du, {
                                    center: Fl.toLngLat(),
                                    elevation: ho,
                                    zoom: Ec,
                                    pitch: du,
                                    bearing: kc
                                };
                            }
                            calculateCameraOptionsFromCameraLngLatAltRotation(le1, vt, bt, ls, ho) {
                                const Dl = this.transform.calculateCenterFromCameraLngLatAlt(le1, vt, bt, ls);
                                return {
                                    center: Dl.center,
                                    elevation: Dl.elevation,
                                    zoom: Dl.zoom,
                                    bearing: bt,
                                    pitch: ls,
                                    roll: ho
                                };
                            }
                            easeTo(le1, bt) {
                                this._stop(!1, le1.easeId), (!1 === (le1 = vt.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    duration: 500,
                                    easing: vt.cz
                                }, le1)).animate || !le1.essential && Fl.prefersReducedMotion) && (le1.duration = 0);
                                const ls = this._getTransformForUpdate(), ho = this.getBearing(), Dl = ls.pitch, sc = ls.roll, uc = "bearing" in le1 ? this._normalizeBearing(le1.bearing, ho) : ho, mc = "pitch" in le1 ? +le1.pitch : Dl, gc = "roll" in le1 ? this._normalizeBearing(le1.roll, sc) : sc, Ac = "padding" in le1 ? le1.padding : ls.padding, Ec = vt.P.convert(le1.offset);
                                let kc, du;
                                le1.around && (kc = vt.V.convert(le1.around), du = ls.locationToScreenPoint(kc));
                                const _u = {
                                    moving: this._moving,
                                    zooming: this._zooming,
                                    rotating: this._rotating,
                                    pitching: this._pitching,
                                    rolling: this._rolling
                                }, Md = this.cameraHelper.handleEaseTo(ls, {
                                    bearing: uc,
                                    pitch: mc,
                                    roll: gc,
                                    padding: Ac,
                                    around: kc,
                                    aroundPoint: du,
                                    offsetAsPoint: Ec,
                                    offset: le1.offset,
                                    zoom: le1.zoom,
                                    center: le1.center
                                });
                                return this._rotating = this._rotating || ho !== uc, this._pitching = this._pitching || mc !== Dl, this._rolling = this._rolling || gc !== sc, this._padding = !ls.isPaddingEqual(Ac), this._zooming = this._zooming || Md.isZooming, this._easeId = le1.easeId, this._prepareEase(bt, le1.noMoveStart, _u), this.terrain && this._prepareElevation(Md.elevationCenter), this._ease((vt)=>{
                                    Md.easeFunc(vt), this.terrain && !le1.freezeElevation && this._updateElevation(vt), this._applyUpdatedTransform(ls), this._fireMoveEvents(bt);
                                }, (vt)=>{
                                    this.terrain && le1.freezeElevation && this._finalizeElevation(), this._afterEase(bt, vt);
                                }, le1), this;
                            }
                            _prepareEase(le1, bt, ls = {}) {
                                this._moving = !0, bt || ls.moving || this.fire(new vt.l("movestart", le1)), this._zooming && !ls.zooming && this.fire(new vt.l("zoomstart", le1)), this._rotating && !ls.rotating && this.fire(new vt.l("rotatestart", le1)), this._pitching && !ls.pitching && this.fire(new vt.l("pitchstart", le1)), this._rolling && !ls.rolling && this.fire(new vt.l("rollstart", le1));
                            }
                            _prepareElevation(le1) {
                                this._elevationCenter = le1, this._elevationStart = this.transform.elevation, this._elevationTarget = this.terrain.getElevationForLngLatZoom(le1, this.transform.tileZoom), this._elevationFreeze = !0;
                            }
                            _updateElevation(le1) {
                                void 0 !== this._elevationStart && void 0 !== this._elevationCenter || this._prepareElevation(this.transform.center), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom));
                                const bt = this.terrain.getElevationForLngLatZoom(this._elevationCenter, this.transform.tileZoom);
                                if (le1 < 1 && bt !== this._elevationTarget) {
                                    const vt = this._elevationTarget - this._elevationStart;
                                    this._elevationStart += le1 * (vt - (bt - (vt * le1 + this._elevationStart)) / (1 - le1)), this._elevationTarget = bt;
                                }
                                this.transform.setElevation(vt.G.number(this._elevationStart, this._elevationTarget, le1));
                            }
                            _finalizeElevation() {
                                this._elevationFreeze = !1, this.getCenterClampedToGround() && this.transform.recalculateZoomAndCenter(this.terrain);
                            }
                            _getTransformForUpdate() {
                                return this.transformCameraUpdate || this.terrain ? (this._requestedCameraState || (this._requestedCameraState = this.transform.clone()), this._requestedCameraState) : this.transform;
                            }
                            _elevateCameraIfInsideTerrain(le1) {
                                if (!this.terrain && le1.elevation >= 0 && le1.pitch <= 90) return {};
                                const vt = le1.getCameraLngLat(), bt = le1.getCameraAltitude(), ls = this.terrain ? this.terrain.getElevationForLngLatZoom(vt, le1.zoom) : 0;
                                if (bt < ls) {
                                    const bt = this.calculateCameraOptionsFromTo(vt, ls, le1.center, le1.elevation);
                                    return {
                                        pitch: bt.pitch,
                                        zoom: bt.zoom
                                    };
                                }
                                return {};
                            }
                            _applyUpdatedTransform(le1) {
                                const vt = [];
                                if (vt.push((le1)=>this._elevateCameraIfInsideTerrain(le1)), this.transformCameraUpdate && vt.push((le1)=>this.transformCameraUpdate(le1)), !vt.length) return;
                                const bt = le1.clone();
                                for (const ls of vt){
                                    const le1 = bt.clone(), { center: vt, zoom: ho, roll: Dl, pitch: Fl, bearing: sc, elevation: uc } = ls(le1);
                                    vt && le1.setCenter(vt), void 0 !== uc && le1.setElevation(uc), void 0 !== ho && le1.setZoom(ho), void 0 !== Dl && le1.setRoll(Dl), void 0 !== Fl && le1.setPitch(Fl), void 0 !== sc && le1.setBearing(sc), bt.apply(le1, !1);
                                }
                                this.transform.apply(bt, !1);
                            }
                            _fireMoveEvents(le1) {
                                this.fire(new vt.l("move", le1)), this._zooming && this.fire(new vt.l("zoom", le1)), this._rotating && this.fire(new vt.l("rotate", le1)), this._pitching && this.fire(new vt.l("pitch", le1)), this._rolling && this.fire(new vt.l("roll", le1));
                            }
                            _afterEase(le1, bt) {
                                if (this._easeId && bt && this._easeId === bt) return;
                                delete this._easeId;
                                const ls = this._zooming, ho = this._rotating, Dl = this._pitching, Fl = this._rolling;
                                this._moving = !1, this._zooming = !1, this._rotating = !1, this._pitching = !1, this._rolling = !1, this._padding = !1, ls && this.fire(new vt.l("zoomend", le1)), ho && this.fire(new vt.l("rotateend", le1)), Dl && this.fire(new vt.l("pitchend", le1)), Fl && this.fire(new vt.l("rollend", le1)), this.fire(new vt.l("moveend", le1));
                            }
                            flyTo(le1, bt) {
                                if (!le1.essential && Fl.prefersReducedMotion) {
                                    const ls = vt.U(le1, [
                                        "center",
                                        "zoom",
                                        "bearing",
                                        "pitch",
                                        "roll",
                                        "elevation",
                                        "padding"
                                    ]);
                                    return this.jumpTo(ls, bt);
                                }
                                this.stop(), le1 = vt.e({
                                    offset: [
                                        0,
                                        0
                                    ],
                                    speed: 1.2,
                                    curve: 1.42,
                                    easing: vt.cz
                                }, le1);
                                const ls = this._getTransformForUpdate(), ho = ls.bearing, Dl = ls.pitch, sc = ls.roll, uc = ls.padding, mc = "bearing" in le1 ? this._normalizeBearing(le1.bearing, ho) : ho, gc = "pitch" in le1 ? +le1.pitch : Dl, Ac = "roll" in le1 ? this._normalizeBearing(le1.roll, sc) : sc, Ec = "padding" in le1 ? le1.padding : ls.padding, kc = vt.P.convert(le1.offset);
                                let du = ls.centerPoint.add(kc);
                                const _u = ls.screenPointToLocation(du), Md = this.cameraHelper.handleFlyTo(ls, {
                                    bearing: mc,
                                    pitch: gc,
                                    roll: Ac,
                                    padding: Ec,
                                    locationAtOffset: _u,
                                    offsetAsPoint: kc,
                                    center: le1.center,
                                    minZoom: le1.minZoom,
                                    zoom: le1.zoom
                                });
                                let Ld = le1.curve;
                                const Nd = Math.max(ls.width, ls.height), Rd = Nd / Md.scaleOfZoom, Od = Md.pixelPathLength;
                                "number" == typeof Md.scaleOfMinZoom && (Ld = Math.sqrt(Nd / Md.scaleOfMinZoom / Od * 2));
                                const jd = Ld * Ld;
                                function w(le1) {
                                    const vt = (Rd * Rd - Nd * Nd + (le1 ? -1 : 1) * jd * jd * Od * Od) / (2 * (le1 ? Rd : Nd) * jd * Od);
                                    return Math.log(Math.sqrt(vt * vt + 1) - vt);
                                }
                                function T(le1) {
                                    return (Math.exp(le1) - Math.exp(-le1)) / 2;
                                }
                                function P(le1) {
                                    return (Math.exp(le1) + Math.exp(-le1)) / 2;
                                }
                                const Ud = w(!1);
                                let I = function(le1) {
                                    return P(Ud) / P(Ud + Ld * le1);
                                }, M = function(le1) {
                                    var vt;
                                    return Nd * ((P(Ud) * (T(vt = Ud + Ld * le1) / P(vt)) - T(Ud)) / jd) / Od;
                                }, Gd = (w(!0) - Ud) / Ld;
                                if (Math.abs(Od) < 2e-6 || !isFinite(Gd)) {
                                    if (Math.abs(Nd - Rd) < 1e-6) return this.easeTo(le1, bt);
                                    const vt = Rd < Nd ? -1 : 1;
                                    Gd = Math.abs(Math.log(Rd / Nd)) / Ld, M = ()=>0, I = (le1)=>Math.exp(vt * Ld * le1);
                                }
                                return le1.duration = "duration" in le1 ? +le1.duration : 1e3 * Gd / ("screenSpeed" in le1 ? +le1.screenSpeed / Ld : +le1.speed), le1.maxDuration && le1.duration > le1.maxDuration && (le1.duration = 0), this._zooming = !0, this._rotating = ho !== mc, this._pitching = gc !== Dl, this._rolling = Ac !== sc, this._padding = !ls.isPaddingEqual(Ec), this._prepareEase(bt, !1), this.terrain && this._prepareElevation(Md.targetCenter), this._ease((Fl)=>{
                                    const _u = Fl * Gd, Ld = 1 / I(_u), Nd = M(_u);
                                    this._rotating && ls.setBearing(vt.G.number(ho, mc, Fl)), this._pitching && ls.setPitch(vt.G.number(Dl, gc, Fl)), this._rolling && ls.setRoll(vt.G.number(sc, Ac, Fl)), this._padding && (ls.interpolatePadding(uc, Ec, Fl), du = ls.centerPoint.add(kc)), Md.easeFunc(Fl, Ld, Nd, du), this.terrain && !le1.freezeElevation && this._updateElevation(Fl), this._applyUpdatedTransform(ls), this._fireMoveEvents(bt);
                                }, ()=>{
                                    this.terrain && le1.freezeElevation && this._finalizeElevation(), this._afterEase(bt);
                                }, le1), this;
                            }
                            isEasing() {
                                return !!this._easeFrameId;
                            }
                            stop() {
                                return this._stop();
                            }
                            _stop(le1, vt) {
                                var bt;
                                if (this._easeFrameId && (this._cancelRenderFrame(this._easeFrameId), delete this._easeFrameId, delete this._onEaseFrame), this._onEaseEnd) {
                                    const le1 = this._onEaseEnd;
                                    delete this._onEaseEnd, le1.call(this, vt);
                                }
                                return le1 || null === (bt = this.handlers) || void 0 === bt || bt.stop(!1), this;
                            }
                            _ease(le1, vt, bt) {
                                !1 === bt.animate || 0 === bt.duration ? (le1(1), vt()) : (this._easeStart = c(), this._easeOptions = bt, this._onEaseFrame = le1, this._onEaseEnd = vt, this._easeFrameId = this._requestRenderFrame(this._renderFrameCallback));
                            }
                            _normalizeBearing(le1, bt) {
                                le1 = vt.W(le1, -180, 180);
                                const ls = Math.abs(le1 - bt);
                                return Math.abs(le1 - 360 - bt) < ls && (le1 -= 360), Math.abs(le1 + 360 - bt) < ls && (le1 += 360), le1;
                            }
                            queryTerrainElevation(le1) {
                                return this.terrain ? this.terrain.getElevationForLngLat(vt.V.convert(le1), this.transform) : null;
                            }
                        }
                        const Gm = {
                            compact: !0,
                            customAttribution: '<a href="https://maplibre.org/" target="_blank">MapLibre</a>'
                        };
                        class Yr {
                            constructor(le1 = Gm){
                                this._toggleAttribution = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && (this._container.classList.contains("maplibregl-compact-show") ? (this._container.setAttribute("open", ""), this._container.classList.remove("maplibregl-compact-show")) : (this._container.classList.add("maplibregl-compact-show"), this._container.removeAttribute("open")));
                                }, this._updateData = (le1)=>{
                                    !le1 || "metadata" !== le1.sourceDataType && "visibility" !== le1.sourceDataType && "style" !== le1.dataType && "terrain" !== le1.type || this._updateAttributions();
                                }, this._updateCompact = ()=>{
                                    this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 === this._compact ? this._container.setAttribute("open", "") : this._container.classList.contains("maplibregl-compact") || this._container.classList.contains("maplibregl-attrib-empty") || (this._container.setAttribute("open", ""), this._container.classList.add("maplibregl-compact", "maplibregl-compact-show")) : (this._container.setAttribute("open", ""), this._container.classList.contains("maplibregl-compact") && this._container.classList.remove("maplibregl-compact", "maplibregl-compact-show"));
                                }, this._updateCompactMinimize = ()=>{
                                    this._container.classList.contains("maplibregl-compact") && this._container.classList.contains("maplibregl-compact-show") && this._container.classList.remove("maplibregl-compact-show");
                                }, this.options = le1;
                            }
                            getDefaultPosition() {
                                return "bottom-right";
                            }
                            onAdd(le1) {
                                return this._map = le1, this._compact = this.options.compact, this._container = h.create("details", "maplibregl-ctrl maplibregl-ctrl-attrib"), this._compactButton = h.create("summary", "maplibregl-ctrl-attrib-button", this._container), this._compactButton.addEventListener("click", this._toggleAttribution), this._setElementTitle(this._compactButton, "ToggleAttribution"), this._innerContainer = h.create("div", "maplibregl-ctrl-attrib-inner", this._container), this._updateAttributions(), this._updateCompact(), this._map.on("styledata", this._updateData), this._map.on("sourcedata", this._updateData), this._map.on("terrain", this._updateData), this._map.on("resize", this._updateCompact), this._map.on("drag", this._updateCompactMinimize), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this._map.off("styledata", this._updateData), this._map.off("sourcedata", this._updateData), this._map.off("terrain", this._updateData), this._map.off("resize", this._updateCompact), this._map.off("drag", this._updateCompactMinimize), this._map = void 0, this._compact = void 0, this._attribHTML = void 0;
                            }
                            _setElementTitle(le1, vt) {
                                const bt = this._map._getUIString(`AttributionControl.${vt}`);
                                le1.title = bt, le1.setAttribute("aria-label", bt);
                            }
                            _updateAttributions() {
                                if (!this._map.style) return;
                                let le1 = [];
                                if (this.options.customAttribution && (Array.isArray(this.options.customAttribution) ? le1 = le1.concat(this.options.customAttribution.map((le1)=>"string" != typeof le1 ? "" : le1)) : "string" == typeof this.options.customAttribution && le1.push(this.options.customAttribution)), this._map.style.stylesheet) {
                                    const le1 = this._map.style.stylesheet;
                                    this.styleOwner = le1.owner, this.styleId = le1.id;
                                }
                                const vt = this._map.style.tileManagers;
                                for(const ls in vt){
                                    const bt = vt[ls];
                                    if (bt.used || bt.usedForTerrain) {
                                        const vt = bt.getSource();
                                        vt.attribution && le1.indexOf(vt.attribution) < 0 && le1.push(vt.attribution);
                                    }
                                }
                                le1 = le1.filter((le1)=>String(le1).trim()), le1.sort((le1, vt)=>le1.length - vt.length), le1 = le1.filter((vt, bt)=>{
                                    for(let ls = bt + 1; ls < le1.length; ls++)if (le1[ls].indexOf(vt) >= 0) return !1;
                                    return !0;
                                });
                                const bt = le1.join(" | ");
                                bt !== this._attribHTML && (this._attribHTML = bt, le1.length ? (this._innerContainer.innerHTML = h.sanitize(bt), this._container.classList.remove("maplibregl-attrib-empty")) : this._container.classList.add("maplibregl-attrib-empty"), this._updateCompact(), this._editLink = null);
                            }
                        }
                        class Qr {
                            constructor(le1 = {}){
                                this._updateCompact = ()=>{
                                    const le1 = this._container.children;
                                    if (le1.length) {
                                        const vt = le1[0];
                                        this._map.getCanvasContainer().offsetWidth <= 640 || this._compact ? !1 !== this._compact && vt.classList.add("maplibregl-compact") : vt.classList.remove("maplibregl-compact");
                                    }
                                }, this.options = le1;
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(le1) {
                                this._map = le1, this._compact = this.options && this.options.compact, this._container = h.create("div", "maplibregl-ctrl");
                                const vt = h.create("a", "maplibregl-ctrl-logo");
                                return vt.target = "_blank", vt.rel = "noopener nofollow", vt.href = "https://maplibre.org/", vt.setAttribute("aria-label", this._map._getUIString("LogoControl.Title")), vt.setAttribute("rel", "noopener nofollow"), this._container.appendChild(vt), this._container.style.display = "block", this._map.on("resize", this._updateCompact), this._updateCompact(), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this._map.off("resize", this._updateCompact), this._map = void 0, this._compact = void 0;
                            }
                        }
                        class Jr {
                            constructor(){
                                this._queue = [], this._id = 0, this._cleared = !1, this._currentlyRunning = !1;
                            }
                            add(le1) {
                                const vt = ++this._id;
                                return this._queue.push({
                                    callback: le1,
                                    id: vt,
                                    cancelled: !1
                                }), vt;
                            }
                            remove(le1) {
                                const vt = this._currentlyRunning, bt = vt ? this._queue.concat(vt) : this._queue;
                                for (const ls of bt)if (ls.id === le1) return void (ls.cancelled = !0);
                            }
                            run(le1 = 0) {
                                if (this._currentlyRunning) throw new Error("Attempting to run(), but is already running.");
                                const vt = this._currentlyRunning = this._queue;
                                this._queue = [];
                                for (const bt of vt)if (!bt.cancelled && (bt.callback(le1), this._cleared)) break;
                                this._cleared = !1, this._currentlyRunning = !1;
                            }
                            clear() {
                                this._currentlyRunning && (this._cleared = !0), this._queue = [];
                            }
                        }
                        var qm = vt.aU([
                            {
                                name: "a_pos3d",
                                type: "Int16",
                                components: 3
                            }
                        ]);
                        class ts extends vt.E {
                            constructor(le1){
                                super(), this._lastTilesetChange = c(), this.tileManager = le1, this._tiles = {}, this._renderableTilesKeys = [], this._sourceTileCache = {}, this.minzoom = 0, this.maxzoom = 22, this.deltaZoom = 1, this.tileSize = le1._source.tileSize * 2 ** this.deltaZoom, le1.usedForTerrain = !0, le1.tileSize = this.tileSize;
                            }
                            destruct() {
                                this.tileManager.usedForTerrain = !1, this.tileManager.tileSize = null;
                            }
                            getSource() {
                                return this.tileManager._source;
                            }
                            update(le1, bt) {
                                this.tileManager.update(le1, bt), this._renderableTilesKeys = [];
                                const ls = {};
                                for (const ho of Ie(le1, {
                                    tileSize: this.tileSize,
                                    minzoom: this.minzoom,
                                    maxzoom: this.maxzoom,
                                    reparseOverscaled: !1,
                                    terrain: bt,
                                    calculateTileZoom: this.tileManager._source.calculateTileZoom
                                }))ls[ho.key] = !0, this._renderableTilesKeys.push(ho.key), this._tiles[ho.key] || (ho.terrainRttPosMatrix32f = new Float64Array(16), vt.c7(ho.terrainRttPosMatrix32f, 0, vt.a5, vt.a5, 0, 0, 1), this._tiles[ho.key] = new de(ho, this.tileSize), this._lastTilesetChange = c());
                                for(const vt in this._tiles)ls[vt] || delete this._tiles[vt];
                            }
                            freeRtt(le1) {
                                for(const vt in this._tiles){
                                    const bt = this._tiles[vt];
                                    (!le1 || bt.tileID.equals(le1) || bt.tileID.isChildOf(le1) || le1.isChildOf(bt.tileID)) && (bt.rtt = []);
                                }
                            }
                            getRenderableTiles() {
                                return this._renderableTilesKeys.map((le1)=>this.getTileByID(le1));
                            }
                            getTileByID(le1) {
                                return this._tiles[le1];
                            }
                            getTerrainCoords(le1, vt) {
                                return vt ? this._getTerrainCoordsForTileRanges(le1, vt) : this._getTerrainCoordsForRegularTile(le1);
                            }
                            _getTerrainCoordsForRegularTile(le1) {
                                const bt = {};
                                for (const ls of this._renderableTilesKeys){
                                    const ho = this._tiles[ls].tileID, Dl = le1.clone(), Fl = vt.bk();
                                    if (ho.canonical.equals(le1.canonical)) vt.c7(Fl, 0, vt.a5, vt.a5, 0, 0, 1);
                                    else if (ho.canonical.isChildOf(le1.canonical)) {
                                        const bt = ho.canonical.z - le1.canonical.z, ls = ho.canonical.x - (ho.canonical.x >> bt << bt), Dl = ho.canonical.y - (ho.canonical.y >> bt << bt), sc = vt.a5 >> bt;
                                        vt.c7(Fl, 0, sc, sc, 0, 0, 1), vt.O(Fl, Fl, [
                                            -ls * sc,
                                            -Dl * sc,
                                            0
                                        ]);
                                    } else {
                                        if (!le1.canonical.isChildOf(ho.canonical)) continue;
                                        {
                                            const bt = le1.canonical.z - ho.canonical.z, ls = le1.canonical.x - (le1.canonical.x >> bt << bt), Dl = le1.canonical.y - (le1.canonical.y >> bt << bt), sc = vt.a5 >> bt;
                                            vt.c7(Fl, 0, vt.a5, vt.a5, 0, 0, 1), vt.O(Fl, Fl, [
                                                ls * sc,
                                                Dl * sc,
                                                0
                                            ]), vt.Q(Fl, Fl, [
                                                1 / 2 ** bt,
                                                1 / 2 ** bt,
                                                0
                                            ]);
                                        }
                                    }
                                    Dl.terrainRttPosMatrix32f = new Float32Array(Fl), bt[ls] = Dl;
                                }
                                return bt;
                            }
                            _getTerrainCoordsForTileRanges(le1, bt) {
                                const ls = {};
                                for (const ho of this._renderableTilesKeys){
                                    const Dl = this._tiles[ho].tileID;
                                    if (!this._isWithinTileRanges(Dl, bt)) continue;
                                    const Fl = le1.clone(), sc = vt.bk();
                                    if (Dl.canonical.z === le1.canonical.z) {
                                        const bt = le1.canonical.x - Dl.canonical.x + le1.wrap * (1 << le1.canonical.z), ls = le1.canonical.y - Dl.canonical.y;
                                        vt.c7(sc, 0, vt.a5, vt.a5, 0, 0, 1), vt.O(sc, sc, [
                                            bt * vt.a5,
                                            ls * vt.a5,
                                            0
                                        ]);
                                    } else if (Dl.canonical.z > le1.canonical.z) {
                                        const bt = Dl.canonical.z - le1.canonical.z, ls = Dl.canonical.x - (Dl.canonical.x >> bt << bt) + le1.wrap * (1 << Dl.canonical.z), ho = Dl.canonical.y - (Dl.canonical.y >> bt << bt), Fl = le1.canonical.x - (Dl.canonical.x >> bt), uc = le1.canonical.y - (Dl.canonical.y >> bt), mc = vt.a5 >> bt;
                                        vt.c7(sc, 0, mc, mc, 0, 0, 1), vt.O(sc, sc, [
                                            -ls * mc + Fl * vt.a5,
                                            -ho * mc + uc * vt.a5,
                                            0
                                        ]);
                                    } else {
                                        const bt = le1.canonical.z - Dl.canonical.z, ls = le1.canonical.x - (le1.canonical.x >> bt << bt) + le1.wrap * (1 << le1.canonical.z), ho = le1.canonical.y - (le1.canonical.y >> bt << bt), Fl = (le1.canonical.x >> bt) - Dl.canonical.x, uc = (le1.canonical.y >> bt) - Dl.canonical.y, mc = vt.a5 << bt;
                                        vt.c7(sc, 0, mc, mc, 0, 0, 1), vt.O(sc, sc, [
                                            ls * vt.a5 + Fl * mc,
                                            ho * vt.a5 + uc * mc,
                                            0
                                        ]);
                                    }
                                    Fl.terrainRttPosMatrix32f = new Float32Array(sc), ls[ho] = Fl;
                                }
                                return ls;
                            }
                            getSourceTile(le1, vt) {
                                const bt = this.tileManager._source;
                                let ls = le1.overscaledZ - this.deltaZoom;
                                if (ls > bt.maxzoom && (ls = bt.maxzoom), ls < bt.minzoom) return;
                                this._sourceTileCache[le1.key] || (this._sourceTileCache[le1.key] = le1.scaledTo(ls).key);
                                let ho = this.findTileInCaches(this._sourceTileCache[le1.key]);
                                if (!(null == ho ? void 0 : ho.dem) && vt) for(; ls >= bt.minzoom && !(null == ho ? void 0 : ho.dem);)ho = this.findTileInCaches(le1.scaledTo(ls--).key);
                                return ho;
                            }
                            findTileInCaches(le1) {
                                let vt = this.tileManager.getTileByID(le1);
                                return vt || (vt = this.tileManager._outOfViewCache.getByKey(le1), vt);
                            }
                            anyTilesAfterTime(le1 = Date.now()) {
                                return this._lastTilesetChange >= le1;
                            }
                            _isWithinTileRanges(le1, vt) {
                                const bt = vt[le1.canonical.z];
                                return !!bt && (le1.wrap > bt.minWrap || le1.wrap < bt.maxWrap || le1.canonical.x >= bt.minTileXWrapped && le1.canonical.x <= bt.maxTileXWrapped && le1.canonical.y >= bt.minTileY && le1.canonical.y <= bt.maxTileY);
                            }
                        }
                        class is {
                            constructor(le1, vt, bt){
                                this._meshCache = {}, this.painter = le1, this.tileManager = new ts(vt), this.options = bt, this.exaggeration = "number" == typeof bt.exaggeration ? bt.exaggeration : 1, this.qualityFactor = 2, this.meshSize = 128, this._demMatrixCache = {}, this.coordsIndex = [], this._coordsTextureSize = 1024;
                            }
                            getDEMElevation(le1, bt, ls, ho = vt.a5) {
                                var Dl;
                                if (!(bt >= 0 && bt < ho && ls >= 0 && ls < ho)) return 0;
                                const Fl = this.getTerrainData(le1), sc = null === (Dl = Fl.tile) || void 0 === Dl ? void 0 : Dl.dem;
                                if (!sc) return 0;
                                const uc = vt.cD([], [
                                    bt / ho * vt.a5,
                                    ls / ho * vt.a5
                                ], Fl.u_terrain_matrix), mc = [
                                    uc[0] * sc.dim,
                                    uc[1] * sc.dim
                                ], gc = Math.floor(mc[0]), Ac = Math.floor(mc[1]), Ec = mc[0] - gc, kc = mc[1] - Ac;
                                return sc.get(gc, Ac) * (1 - Ec) * (1 - kc) + sc.get(gc + 1, Ac) * Ec * (1 - kc) + sc.get(gc, Ac + 1) * (1 - Ec) * kc + sc.get(gc + 1, Ac + 1) * Ec * kc;
                            }
                            getElevationForLngLatZoom(le1, bt) {
                                if (!vt.cE(bt, le1.wrap())) return 0;
                                const { tileID: ls, mercatorX: ho, mercatorY: Dl } = this._getOverscaledTileIDFromLngLatZoom(le1, bt);
                                return this.getElevation(ls, ho % vt.a5, Dl % vt.a5, vt.a5);
                            }
                            getElevationForLngLat(le1, vt) {
                                const bt = Ie(vt, {
                                    maxzoom: this.tileManager.maxzoom,
                                    minzoom: this.tileManager.minzoom,
                                    tileSize: 512,
                                    terrain: this
                                });
                                let ls = 0;
                                for (const ho of bt)ho.canonical.z > ls && (ls = Math.min(ho.canonical.z, this.tileManager.maxzoom));
                                return this.getElevationForLngLatZoom(le1, ls);
                            }
                            getElevation(le1, bt, ls, ho = vt.a5) {
                                return this.getDEMElevation(le1, bt, ls, ho) * this.exaggeration;
                            }
                            getTerrainData(le1) {
                                if (!this._emptyDemTexture) {
                                    const le1 = this.painter.context, bt = new vt.R({
                                        width: 1,
                                        height: 1
                                    }, new Uint8Array(4));
                                    this._emptyDepthTexture = new vt.T(le1, bt, le1.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemUnpack = [
                                        0,
                                        0,
                                        0,
                                        0
                                    ], this._emptyDemTexture = new vt.T(le1, new vt.R({
                                        width: 1,
                                        height: 1
                                    }), le1.gl.RGBA, {
                                        premultiply: !1
                                    }), this._emptyDemTexture.bind(le1.gl.NEAREST, le1.gl.CLAMP_TO_EDGE), this._emptyDemMatrix = vt.ar([]);
                                }
                                const bt = this.tileManager.getSourceTile(le1, !0);
                                if (bt && bt.dem && (!bt.demTexture || bt.needsTerrainPrepare)) {
                                    const le1 = this.painter.context;
                                    bt.demTexture = this.painter.getTileTexture(bt.dem.stride), bt.demTexture ? bt.demTexture.update(bt.dem.getPixels(), {
                                        premultiply: !1
                                    }) : bt.demTexture = new vt.T(le1, bt.dem.getPixels(), le1.gl.RGBA, {
                                        premultiply: !1
                                    }), bt.demTexture.bind(le1.gl.NEAREST, le1.gl.CLAMP_TO_EDGE), bt.needsTerrainPrepare = !1;
                                }
                                const ls = bt && bt.toString() + bt.tileID.key + le1.key;
                                if (ls && !this._demMatrixCache[ls]) {
                                    const ls = this.tileManager.getSource().maxzoom;
                                    let ho = le1.canonical.z - bt.tileID.canonical.z;
                                    le1.overscaledZ > le1.canonical.z && (le1.canonical.z >= ls ? ho = le1.canonical.z - ls : vt.w("cannot calculate elevation if elevation maxzoom > source.maxzoom"));
                                    const Dl = le1.canonical.x - (le1.canonical.x >> ho << ho), Fl = le1.canonical.y - (le1.canonical.y >> ho << ho), sc = vt.cF(new Float64Array(16), [
                                        1 / (vt.a5 << ho),
                                        1 / (vt.a5 << ho),
                                        0
                                    ]);
                                    vt.O(sc, sc, [
                                        Dl * vt.a5,
                                        Fl * vt.a5,
                                        0
                                    ]), this._demMatrixCache[le1.key] = {
                                        matrix: sc,
                                        coord: le1
                                    };
                                }
                                return {
                                    u_depth: 2,
                                    u_terrain: 3,
                                    u_terrain_dim: bt && bt.dem && bt.dem.dim || 1,
                                    u_terrain_matrix: ls ? this._demMatrixCache[le1.key].matrix : this._emptyDemMatrix,
                                    u_terrain_unpack: bt && bt.dem && bt.dem.getUnpackVector() || this._emptyDemUnpack,
                                    u_terrain_exaggeration: this.exaggeration,
                                    texture: (bt && bt.demTexture || this._emptyDemTexture).texture,
                                    depthTexture: (this._fboDepthTexture || this._emptyDepthTexture).texture,
                                    tile: bt
                                };
                            }
                            getFramebuffer(le1) {
                                const bt = this.painter, ls = bt.width / devicePixelRatio, ho = bt.height / devicePixelRatio;
                                return !this._fbo || this._fbo.width === ls && this._fbo.height === ho || (this._fbo.destroy(), this._fboCoordsTexture.destroy(), this._fboDepthTexture.destroy(), delete this._fbo, delete this._fboDepthTexture, delete this._fboCoordsTexture), this._fboCoordsTexture || (this._fboCoordsTexture = new vt.T(bt.context, {
                                    width: ls,
                                    height: ho,
                                    data: null
                                }, bt.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboCoordsTexture.bind(bt.context.gl.NEAREST, bt.context.gl.CLAMP_TO_EDGE)), this._fboDepthTexture || (this._fboDepthTexture = new vt.T(bt.context, {
                                    width: ls,
                                    height: ho,
                                    data: null
                                }, bt.context.gl.RGBA, {
                                    premultiply: !1
                                }), this._fboDepthTexture.bind(bt.context.gl.NEAREST, bt.context.gl.CLAMP_TO_EDGE)), this._fbo || (this._fbo = bt.context.createFramebuffer(ls, ho, !0, !1), this._fbo.depthAttachment.set(bt.context.createRenderbuffer(bt.context.gl.DEPTH_COMPONENT16, ls, ho))), this._fbo.colorAttachment.set("coords" === le1 ? this._fboCoordsTexture.texture : this._fboDepthTexture.texture), this._fbo;
                            }
                            getCoordsTexture() {
                                const le1 = this.painter.context;
                                if (this._coordsTexture) return this._coordsTexture;
                                const bt = new Uint8Array(this._coordsTextureSize * this._coordsTextureSize * 4);
                                for(let vt = 0, Dl = 0; vt < this._coordsTextureSize; vt++)for(let le1 = 0; le1 < this._coordsTextureSize; le1++, Dl += 4)bt[Dl + 0] = 255 & le1, bt[Dl + 1] = 255 & vt, bt[Dl + 2] = le1 >> 8 << 4 | vt >> 8, bt[Dl + 3] = 0;
                                const ls = new vt.R({
                                    width: this._coordsTextureSize,
                                    height: this._coordsTextureSize
                                }, new Uint8Array(bt.buffer)), ho = new vt.T(le1, ls, le1.gl.RGBA, {
                                    premultiply: !1
                                });
                                return ho.bind(le1.gl.NEAREST, le1.gl.CLAMP_TO_EDGE), this._coordsTexture = ho, ho;
                            }
                            pointCoordinate(le1) {
                                this.painter.maybeDrawDepthAndCoords(!0);
                                const bt = new Uint8Array(4), ls = this.painter.context, ho = ls.gl, Dl = Math.round(le1.x * this.painter.pixelRatio / devicePixelRatio), Fl = Math.round(le1.y * this.painter.pixelRatio / devicePixelRatio), sc = Math.round(this.painter.height / devicePixelRatio);
                                ls.bindFramebuffer.set(this.getFramebuffer("coords").framebuffer), ho.readPixels(Dl, sc - Fl - 1, 1, 1, ho.RGBA, ho.UNSIGNED_BYTE, bt), ls.bindFramebuffer.set(null);
                                const uc = bt[0] + (bt[2] >> 4 << 8), mc = bt[1] + ((15 & bt[2]) << 8), gc = this.coordsIndex[255 - bt[3]], Ac = gc && this.tileManager.getTileByID(gc);
                                if (!Ac) return null;
                                const Ec = this._coordsTextureSize, kc = (1 << Ac.tileID.canonical.z) * Ec;
                                return new vt.a9((Ac.tileID.canonical.x * Ec + uc) / kc + Ac.tileID.wrap, (Ac.tileID.canonical.y * Ec + mc) / kc, this.getElevation(Ac.tileID, uc, mc, Ec));
                            }
                            depthAtPoint(le1) {
                                const vt = new Uint8Array(4), bt = this.painter.context, ls = bt.gl;
                                return bt.bindFramebuffer.set(this.getFramebuffer("depth").framebuffer), ls.readPixels(le1.x, this.painter.height / devicePixelRatio - le1.y - 1, 1, 1, ls.RGBA, ls.UNSIGNED_BYTE, vt), bt.bindFramebuffer.set(null), (vt[0] / 16777216 + vt[1] / 65536 + vt[2] / 256 + vt[3]) / 256;
                            }
                            getTerrainMesh(le1) {
                                var bt;
                                const ls = (null === (bt = this.painter.style.projection) || void 0 === bt ? void 0 : bt.transitionState) > 0, ho = ls && 0 === le1.canonical.y, Dl = ls && le1.canonical.y === (1 << le1.canonical.z) - 1, Fl = `m_${ho ? "n" : ""}_${Dl ? "s" : ""}`;
                                if (this._meshCache[Fl]) return this._meshCache[Fl];
                                const sc = this.painter.context, uc = new vt.cG, mc = new vt.aY, gc = this.meshSize, Ac = vt.a5 / gc, Ec = gc * gc;
                                for(let vt = 0; vt <= gc; vt++)for(let le1 = 0; le1 <= gc; le1++)uc.emplaceBack(le1 * Ac, vt * Ac, 0);
                                for(let vt = 0; vt < Ec; vt += gc + 1)for(let le1 = 0; le1 < gc; le1++)mc.emplaceBack(le1 + vt, gc + le1 + vt + 1, gc + le1 + vt + 2), mc.emplaceBack(le1 + vt, gc + le1 + vt + 2, le1 + vt + 1);
                                const kc = uc.length, du = kc + (gc + 1), _u = (gc + 1) * gc, Md = ho ? vt.br : 0, Ld = ho ? 0 : 1, Nd = Dl ? vt.bs : vt.a5, Rd = Dl ? 0 : 1;
                                for(let vt = 0; vt <= gc; vt++)uc.emplaceBack(vt * Ac, Md, Ld);
                                for(let vt = 0; vt <= gc; vt++)uc.emplaceBack(vt * Ac, Nd, Rd);
                                for(let vt = 0; vt < gc; vt++)mc.emplaceBack(_u + vt, du + vt, du + vt + 1), mc.emplaceBack(_u + vt, du + vt + 1, _u + vt + 1), mc.emplaceBack(0 + vt, kc + vt + 1, kc + vt), mc.emplaceBack(0 + vt, 0 + vt + 1, kc + vt + 1);
                                const Od = uc.length, jd = Od + 2 * (gc + 1);
                                for (const Gd of [
                                    0,
                                    1
                                ])for(let le1 = 0; le1 <= gc; le1++)for (const bt of [
                                    0,
                                    1
                                ])uc.emplaceBack(Gd * vt.a5, le1 * Ac, bt);
                                for(let vt = 0; vt < 2 * gc; vt += 2)mc.emplaceBack(Od + vt, Od + vt + 1, Od + vt + 3), mc.emplaceBack(Od + vt, Od + vt + 3, Od + vt + 2), mc.emplaceBack(jd + vt, jd + vt + 3, jd + vt + 1), mc.emplaceBack(jd + vt, jd + vt + 2, jd + vt + 3);
                                const Ud = new kt(sc.createVertexBuffer(uc, qm.members), sc.createIndexBuffer(mc), vt.aX.simpleSegment(0, 0, uc.length, mc.length));
                                return this._meshCache[Fl] = Ud, Ud;
                            }
                            getMeshFrameDelta(le1) {
                                return 2 * Math.PI * vt.bE / Math.pow(2, Math.max(le1, 0)) / 5;
                            }
                            getMinTileElevationForLngLatZoom(le1, bt) {
                                var ls;
                                if (!vt.cE(bt, le1.wrap())) return 0;
                                const { tileID: ho } = this._getOverscaledTileIDFromLngLatZoom(le1, bt);
                                return null !== (ls = this.getMinMaxElevation(ho).minElevation) && void 0 !== ls ? ls : 0;
                            }
                            getMinMaxElevation(le1) {
                                const vt = this.getTerrainData(le1).tile, bt = {
                                    minElevation: null,
                                    maxElevation: null
                                };
                                return vt && vt.dem && (bt.minElevation = vt.dem.min * this.exaggeration, bt.maxElevation = vt.dem.max * this.exaggeration), bt;
                            }
                            _getOverscaledTileIDFromLngLatZoom(le1, bt) {
                                const ls = vt.a9.fromLngLat(le1.wrap()), ho = (1 << bt) * vt.a5, Dl = ls.x * ho, Fl = ls.y * ho, sc = Math.floor(Dl / vt.a5), uc = Math.floor(Fl / vt.a5);
                                return {
                                    tileID: new vt.a2(bt, 0, bt, sc, uc),
                                    mercatorX: Dl,
                                    mercatorY: Fl
                                };
                            }
                        }
                        class as {
                            constructor(le1, vt, bt){
                                this._context = le1, this._size = vt, this._tileSize = bt, this._objects = [], this._recentlyUsed = [], this._stamp = 0;
                            }
                            destruct() {
                                for (const le1 of this._objects)le1.texture.destroy(), le1.fbo.destroy();
                            }
                            _createObject(le1) {
                                const bt = this._context.createFramebuffer(this._tileSize, this._tileSize, !0, !0), ls = new vt.T(this._context, {
                                    width: this._tileSize,
                                    height: this._tileSize,
                                    data: null
                                }, this._context.gl.RGBA);
                                return ls.bind(this._context.gl.LINEAR, this._context.gl.CLAMP_TO_EDGE), this._context.extTextureFilterAnisotropic && this._context.gl.texParameterf(this._context.gl.TEXTURE_2D, this._context.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT, this._context.extTextureFilterAnisotropicMax), bt.depthAttachment.set(this._context.createRenderbuffer(this._context.gl.DEPTH_STENCIL, this._tileSize, this._tileSize)), bt.colorAttachment.set(ls.texture), {
                                    id: le1,
                                    fbo: bt,
                                    texture: ls,
                                    stamp: -1,
                                    inUse: !1
                                };
                            }
                            getObjectForId(le1) {
                                return this._objects[le1];
                            }
                            useObject(le1) {
                                le1.inUse = !0, this._recentlyUsed = this._recentlyUsed.filter((vt)=>le1.id !== vt), this._recentlyUsed.push(le1.id);
                            }
                            stampObject(le1) {
                                le1.stamp = ++this._stamp;
                            }
                            getOrCreateFreeObject() {
                                for (const vt of this._recentlyUsed)if (!this._objects[vt].inUse) return this._objects[vt];
                                if (this._objects.length >= this._size) throw new Error("No free RenderPool available, call freeAllObjects() required!");
                                const le1 = this._createObject(this._objects.length);
                                return this._objects.push(le1), le1;
                            }
                            freeObject(le1) {
                                le1.inUse = !1;
                            }
                            freeAllObjects() {
                                for (const le1 of this._objects)this.freeObject(le1);
                            }
                            isFull() {
                                return !(this._objects.length < this._size) && !1 === this._objects.some((le1)=>!le1.inUse);
                            }
                        }
                        const Hm = {
                            background: !0,
                            fill: !0,
                            line: !0,
                            raster: !0,
                            hillshade: !0,
                            "color-relief": !0
                        };
                        class rs {
                            constructor(le1, vt){
                                this.painter = le1, this.terrain = vt, this.pool = new as(le1.context, 30, vt.tileManager.tileSize * vt.qualityFactor);
                            }
                            destruct() {
                                this.pool.destruct();
                            }
                            getTexture(le1) {
                                return this.pool.getObjectForId(le1.rtt[this._stacks.length - 1].id).texture;
                            }
                            prepareForRender(le1, vt) {
                                this._stacks = [], this._prevType = null, this._rttTiles = [], this._renderableTiles = this.terrain.tileManager.getRenderableTiles(), this._renderableLayerIds = le1._order.filter((bt)=>!le1._layers[bt].isHidden(vt)), this._coordsAscending = {};
                                for(const bt in le1.tileManagers){
                                    this._coordsAscending[bt] = {};
                                    const vt = le1.tileManagers[bt].getVisibleCoordinates(), ls = le1.tileManagers[bt].getSource(), ho = ls instanceof te ? ls.terrainTileRanges : null;
                                    for (const le1 of vt){
                                        const vt = this.terrain.tileManager.getTerrainCoords(le1, ho);
                                        for(const le1 in vt)this._coordsAscending[bt][le1] || (this._coordsAscending[bt][le1] = []), this._coordsAscending[bt][le1].push(vt[le1]);
                                    }
                                }
                                this._coordsAscendingStr = {};
                                for (const bt of le1._order){
                                    const vt = le1._layers[bt], ls = vt.source;
                                    if (Hm[vt.type] && !this._coordsAscendingStr[ls]) {
                                        this._coordsAscendingStr[ls] = {};
                                        for(const le1 in this._coordsAscending[ls])this._coordsAscendingStr[ls][le1] = this._coordsAscending[ls][le1].map((le1)=>le1.key).sort().join();
                                    }
                                }
                                for (const bt of this._renderableTiles)for(const le1 in this._coordsAscendingStr){
                                    const vt = this._coordsAscendingStr[le1][bt.tileID.key];
                                    vt && vt !== bt.rttCoords[le1] && (bt.rtt = []);
                                }
                            }
                            renderLayer(le1, bt) {
                                if (le1.isHidden(this.painter.transform.zoom)) return !1;
                                const ls = Object.assign(Object.assign({}, bt), {
                                    isRenderingToTexture: !0
                                }), ho = le1.type, Dl = this.painter, Fl = this._renderableLayerIds[this._renderableLayerIds.length - 1] === le1.id;
                                if (Hm[ho] && (this._prevType && Hm[this._prevType] || this._stacks.push([]), this._prevType = ho, this._stacks[this._stacks.length - 1].push(le1.id), !Fl)) return !0;
                                if (Hm[this._prevType] || Hm[ho] && Fl) {
                                    this._prevType = ho;
                                    const le1 = this._stacks.length - 1, bt = this._stacks[le1] || [];
                                    for (const ho of this._renderableTiles){
                                        if (this.pool.isFull() && (Vo(this.painter, this.terrain, this._rttTiles, ls), this._rttTiles = [], this.pool.freeAllObjects()), this._rttTiles.push(ho), ho.rtt[le1]) {
                                            const vt = this.pool.getObjectForId(ho.rtt[le1].id);
                                            if (vt.stamp === ho.rtt[le1].stamp) {
                                                this.pool.useObject(vt);
                                                continue;
                                            }
                                        }
                                        const Fl = this.pool.getOrCreateFreeObject();
                                        this.pool.useObject(Fl), this.pool.stampObject(Fl), ho.rtt[le1] = {
                                            id: Fl.id,
                                            stamp: Fl.stamp
                                        }, Dl.context.bindFramebuffer.set(Fl.fbo.framebuffer), Dl.context.clear({
                                            color: vt.bp.transparent,
                                            stencil: 0
                                        }), Dl.currentStencilSource = void 0;
                                        for(let le1 = 0; le1 < bt.length; le1++){
                                            const vt = Dl.style._layers[bt[le1]], sc = vt.source ? this._coordsAscending[vt.source][ho.tileID.key] : [
                                                ho.tileID
                                            ];
                                            Dl.context.viewport.set([
                                                0,
                                                0,
                                                Fl.fbo.width,
                                                Fl.fbo.height
                                            ]), Dl._renderTileClippingMasks(vt, sc, !0), Dl.renderLayer(Dl, Dl.style.tileManagers[vt.source], vt, sc, ls), vt.source && (ho.rttCoords[vt.source] = this._coordsAscendingStr[vt.source][ho.tileID.key]);
                                        }
                                    }
                                    return Vo(this.painter, this.terrain, this._rttTiles, ls), this._rttTiles = [], this.pool.freeAllObjects(), Hm[ho];
                                }
                                return !1;
                            }
                        }
                        const Wm = {
                            "AttributionControl.ToggleAttribution": "Toggle attribution",
                            "AttributionControl.MapFeedback": "Map feedback",
                            "FullscreenControl.Enter": "Enter fullscreen",
                            "FullscreenControl.Exit": "Exit fullscreen",
                            "GeolocateControl.FindMyLocation": "Find my location",
                            "GeolocateControl.LocationNotAvailable": "Location not available",
                            "LogoControl.Title": "MapLibre logo",
                            "Map.Title": "Map",
                            "Marker.Title": "Map marker",
                            "NavigationControl.ResetBearing": "Reset bearing to north",
                            "NavigationControl.ZoomIn": "Zoom in",
                            "NavigationControl.ZoomOut": "Zoom out",
                            "Popup.Close": "Close popup",
                            "ScaleControl.Feet": "ft",
                            "ScaleControl.Meters": "m",
                            "ScaleControl.Kilometers": "km",
                            "ScaleControl.Miles": "mi",
                            "ScaleControl.NauticalMiles": "nm",
                            "GlobeControl.Enable": "Enable globe",
                            "GlobeControl.Disable": "Disable globe",
                            "TerrainControl.Enable": "Enable terrain",
                            "TerrainControl.Disable": "Disable terrain",
                            "CooperativeGesturesHandler.WindowsHelpText": "Use Ctrl + scroll to zoom the map",
                            "CooperativeGesturesHandler.MacHelpText": "Use \u2318 + scroll to zoom the map",
                            "CooperativeGesturesHandler.MobileHelpText": "Use two fingers to move the map"
                        }, Zm = bt, Ym = {
                            hash: !1,
                            interactive: !0,
                            bearingSnap: 7,
                            zoomSnap: 0,
                            attributionControl: Gm,
                            maplibreLogo: !1,
                            refreshExpiredTiles: !0,
                            canvasContextAttributes: {
                                antialias: !1,
                                preserveDrawingBuffer: !1,
                                powerPreference: "high-performance",
                                failIfMajorPerformanceCaveat: !1,
                                desynchronized: !1,
                                contextType: void 0
                            },
                            scrollZoom: !0,
                            minZoom: -2,
                            maxZoom: 22,
                            minPitch: 0,
                            maxPitch: 60,
                            boxZoom: !0,
                            dragRotate: !0,
                            dragPan: !0,
                            keyboard: !0,
                            doubleClickZoom: !0,
                            touchZoomRotate: !0,
                            touchPitch: !0,
                            cooperativeGestures: !1,
                            trackResize: !0,
                            center: [
                                0,
                                0
                            ],
                            elevation: 0,
                            zoom: 0,
                            bearing: 0,
                            pitch: 0,
                            roll: 0,
                            renderWorldCopies: !0,
                            maxTileCacheSize: null,
                            maxTileCacheZoomLevels: vt.c.MAX_TILE_CACHE_ZOOM_LEVELS,
                            transformRequest: null,
                            transformCameraUpdate: null,
                            transformConstrain: null,
                            fadeDuration: 300,
                            crossSourceCollisions: !0,
                            clickTolerance: 3,
                            localIdeographFontFamily: "sans-serif",
                            pitchWithRotate: !0,
                            rollEnabled: !1,
                            reduceMotion: void 0,
                            validateStyle: !0,
                            maxCanvasSize: [
                                4096,
                                4096
                            ],
                            cancelPendingTileRequestsWhileZooming: !0,
                            centerClampedToGround: !0,
                            experimentalZoomLevelsToOverscale: void 0
                        }, Qm = {
                            showCompass: !0,
                            showZoom: !0,
                            visualizePitch: !1,
                            visualizeRoll: !0
                        };
                        class hs {
                            constructor(le1, bt, ls = !1){
                                this.mousedown = (le1)=>{
                                    this.startMove(le1, h.mousePos(this.element, le1)), h.addEventListener(window, "mousemove", this.mousemove), h.addEventListener(window, "mouseup", this.mouseup);
                                }, this.mousemove = (le1)=>{
                                    this.move(le1, h.mousePos(this.element, le1));
                                }, this.mouseup = (le1)=>{
                                    this._rotatePitchHandler.dragEnd(le1), this.offTemp();
                                }, this.touchstart = (le1)=>{
                                    1 !== le1.targetTouches.length ? this.reset() : (this._startPos = this._lastPos = h.touchPos(this.element, le1.targetTouches)[0], this.startMove(le1, this._startPos), h.addEventListener(window, "touchmove", this.touchmove, {
                                        passive: !1
                                    }), h.addEventListener(window, "touchend", this.touchend));
                                }, this.touchmove = (le1)=>{
                                    1 !== le1.targetTouches.length ? this.reset() : (this._lastPos = h.touchPos(this.element, le1.targetTouches)[0], this.move(le1, this._lastPos));
                                }, this.touchend = (le1)=>{
                                    0 === le1.targetTouches.length && this._startPos && this._lastPos && this._startPos.dist(this._lastPos) < this._clickTolerance && this.element.click(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this.reset = ()=>{
                                    this._rotatePitchHandler.reset(), delete this._startPos, delete this._lastPos, this.offTemp();
                                }, this._clickTolerance = 10, this.element = bt;
                                const ho = new yr;
                                this._rotatePitchHandler = new mr({
                                    clickTolerance: 3,
                                    move: (le1, ho)=>{
                                        const Dl = bt.getBoundingClientRect(), Fl = new vt.P((Dl.bottom - Dl.top) / 2, (Dl.right - Dl.left) / 2);
                                        return {
                                            bearingDelta: vt.cy(new vt.P(le1.x, ho.y), ho, Fl),
                                            pitchDelta: ls ? -0.5 * (ho.y - le1.y) : void 0
                                        };
                                    },
                                    moveStateManager: ho,
                                    enable: !0,
                                    assignEvents: ()=>{}
                                }), this.map = le1, h.addEventListener(bt, "mousedown", this.mousedown), h.addEventListener(bt, "touchstart", this.touchstart, {
                                    passive: !1
                                }), h.addEventListener(bt, "touchcancel", this.reset);
                            }
                            startMove(le1, vt) {
                                this._rotatePitchHandler.dragStart(le1, vt), h.disableDrag();
                            }
                            move(le1, vt) {
                                const bt = this.map, { bearingDelta: ls, pitchDelta: ho } = this._rotatePitchHandler.dragMove(le1, vt) || {};
                                ls && bt.setBearing(bt.getBearing() + ls), ho && bt.setPitch(bt.getPitch() + ho);
                            }
                            off() {
                                const le1 = this.element;
                                h.removeEventListener(le1, "mousedown", this.mousedown), h.removeEventListener(le1, "touchstart", this.touchstart, {
                                    passive: !1
                                }), h.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), h.removeEventListener(window, "touchend", this.touchend), h.removeEventListener(le1, "touchcancel", this.reset), this.offTemp();
                            }
                            offTemp() {
                                h.enableDrag(), h.removeEventListener(window, "mousemove", this.mousemove), h.removeEventListener(window, "mouseup", this.mouseup), h.removeEventListener(window, "touchmove", this.touchmove, {
                                    passive: !1
                                }), h.removeEventListener(window, "touchend", this.touchend);
                            }
                        }
                        let Xm;
                        function ds(le1, bt, ls, ho = !1) {
                            if (ho || !ls.getCoveringTilesDetailsProvider().allowWorldCopies()) return null == le1 ? void 0 : le1.wrap();
                            const Dl = new vt.V(le1.lng, le1.lat);
                            if (le1 = new vt.V(le1.lng, le1.lat), bt) {
                                const ho = new vt.V(le1.lng - 360, le1.lat), Dl = new vt.V(le1.lng + 360, le1.lat), Fl = ls.locationToScreenPoint(le1).distSqr(bt);
                                ls.locationToScreenPoint(ho).distSqr(bt) < Fl ? le1 = ho : ls.locationToScreenPoint(Dl).distSqr(bt) < Fl && (le1 = Dl);
                            }
                            for(; Math.abs(le1.lng - ls.center.lng) > 180;){
                                const vt = ls.locationToScreenPoint(le1);
                                if (vt.x >= 0 && vt.y >= 0 && vt.x <= ls.width && vt.y <= ls.height) break;
                                le1.lng > ls.center.lng ? le1.lng -= 360 : le1.lng += 360;
                            }
                            return le1.lng !== Dl.lng && ls.isPointOnMapSurface(ls.locationToScreenPoint(le1)) ? le1 : Dl;
                        }
                        const Km = {
                            center: "translate(-50%,-50%)",
                            top: "translate(-50%,0)",
                            "top-left": "translate(0,0)",
                            "top-right": "translate(-100%,0)",
                            bottom: "translate(-50%,-100%)",
                            "bottom-left": "translate(0,-100%)",
                            "bottom-right": "translate(-100%,-100%)",
                            left: "translate(0,-50%)",
                            right: "translate(-100%,-50%)"
                        };
                        function ps(le1, vt, bt) {
                            const ls = le1.classList;
                            for(const ho in Km)ls.remove(`maplibregl-${bt}-anchor-${ho}`);
                            ls.add(`maplibregl-${bt}-anchor-${vt}`);
                        }
                        class ms extends vt.E {
                            constructor(le1){
                                if (super(), this._onKeyPress = (le1)=>{
                                    const vt = le1.code, bt = le1.charCode || le1.keyCode;
                                    "Space" !== vt && "Enter" !== vt && 32 !== bt && 13 !== bt || this.togglePopup();
                                }, this._onMapClick = (le1)=>{
                                    const vt = le1.originalEvent.target, bt = this._element;
                                    this._popup && (vt === bt || bt.contains(vt)) && this.togglePopup();
                                }, this._update = (le1)=>{
                                    if (!this._map) return;
                                    const vt = this._map.loaded() && !this._map.isMoving();
                                    ("terrain" === (null == le1 ? void 0 : le1.type) || "render" === (null == le1 ? void 0 : le1.type) && !vt) && this._map.once("render", this._update), this._lngLat = ds(this._lngLat, this._flatPos, this._map.transform), this._flatPos = this._pos = this._map.project(this._lngLat)._add(this._offset), this._map.terrain && (this._flatPos = this._map.transform.locationToScreenPoint(this._lngLat)._add(this._offset));
                                    let bt = "";
                                    "viewport" === this._rotationAlignment || "auto" === this._rotationAlignment ? bt = `rotateZ(${this._rotation}deg)` : "map" === this._rotationAlignment && (bt = `rotateZ(${this._rotation - this._map.getBearing()}deg)`);
                                    let ls = "";
                                    "viewport" === this._pitchAlignment || "auto" === this._pitchAlignment ? ls = "rotateX(0deg)" : "map" === this._pitchAlignment && (ls = `rotateX(${this._map.getPitch()}deg)`), this._subpixelPositioning || le1 && "moveend" !== le1.type || (this._pos = this._pos.round()), h.setTransform(this._element, `${Km[this._anchor]} translate(${this._pos.x}px, ${this._pos.y}px) ${ls} ${bt}`), Fl.frameAsync(new AbortController, this._map._ownerWindow).then(()=>{
                                        this._updateOpacity(le1 && "moveend" === le1.type);
                                    }).catch(()=>{});
                                }, this._onMove = (le1)=>{
                                    if (!this._isDragging) {
                                        const vt = this._clickTolerance || this._map._clickTolerance;
                                        this._isDragging = le1.point.dist(this._pointerdownPos) >= vt;
                                    }
                                    this._isDragging && (this._pos = le1.point.sub(this._positionDelta), this._lngLat = this._map.unproject(this._pos), this.setLngLat(this._lngLat), this._element.style.pointerEvents = "none", "pending" === this._state && (this._state = "active", this.fire(new vt.l("dragstart"))), this.fire(new vt.l("drag")));
                                }, this._onUp = ()=>{
                                    this._element.style.pointerEvents = "auto", this._positionDelta = null, this._pointerdownPos = null, this._isDragging = !1, this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), "active" === this._state && this.fire(new vt.l("dragend")), this._state = "inactive";
                                }, this._addDragHandler = (le1)=>{
                                    this._element.contains(le1.originalEvent.target) && (le1.preventDefault(), this._positionDelta = le1.point.sub(this._pos).add(this._offset), this._pointerdownPos = le1.point, this._state = "pending", this._map.on("mousemove", this._onMove), this._map.on("touchmove", this._onMove), this._map.once("mouseup", this._onUp), this._map.once("touchend", this._onUp));
                                }, this._anchor = le1 && le1.anchor || "center", this._color = le1 && le1.color || "#3FB1CE", this._scale = le1 && le1.scale || 1, this._draggable = le1 && le1.draggable || !1, this._clickTolerance = le1 && le1.clickTolerance || 0, this._subpixelPositioning = le1 && le1.subpixelPositioning || !1, this._isDragging = !1, this._state = "inactive", this._rotation = le1 && le1.rotation || 0, this._rotationAlignment = le1 && le1.rotationAlignment || "auto", this._pitchAlignment = le1 && le1.pitchAlignment && "auto" !== le1.pitchAlignment ? le1.pitchAlignment : this._rotationAlignment, this.setOpacity(null == le1 ? void 0 : le1.opacity, null == le1 ? void 0 : le1.opacityWhenCovered), le1 && le1.element) this._element = le1.element, this._offset = vt.P.convert(le1 && le1.offset || [
                                    0,
                                    0
                                ]);
                                else {
                                    this._defaultMarker = !0, this._element = h.create("div");
                                    const bt = h.createNS("http://www.w3.org/2000/svg", "svg"), ls = 41, ho = 27;
                                    bt.setAttributeNS(null, "display", "block"), bt.setAttributeNS(null, "height", `${ls}px`), bt.setAttributeNS(null, "width", `${ho}px`), bt.setAttributeNS(null, "viewBox", `0 0 ${ho} ${ls}`);
                                    const Dl = h.createNS("http://www.w3.org/2000/svg", "g");
                                    Dl.setAttributeNS(null, "stroke", "none"), Dl.setAttributeNS(null, "stroke-width", "1"), Dl.setAttributeNS(null, "fill", "none"), Dl.setAttributeNS(null, "fill-rule", "evenodd");
                                    const Fl = h.createNS("http://www.w3.org/2000/svg", "g");
                                    Fl.setAttributeNS(null, "fill-rule", "nonzero");
                                    const sc = h.createNS("http://www.w3.org/2000/svg", "g");
                                    sc.setAttributeNS(null, "transform", "translate(3.0, 29.0)"), sc.setAttributeNS(null, "fill", "#000000");
                                    const uc = [
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "10.5",
                                            ry: "5.25002273"
                                        },
                                        {
                                            rx: "9.5",
                                            ry: "4.77275007"
                                        },
                                        {
                                            rx: "8.5",
                                            ry: "4.29549936"
                                        },
                                        {
                                            rx: "7.5",
                                            ry: "3.81822308"
                                        },
                                        {
                                            rx: "6.5",
                                            ry: "3.34094679"
                                        },
                                        {
                                            rx: "5.5",
                                            ry: "2.86367051"
                                        },
                                        {
                                            rx: "4.5",
                                            ry: "2.38636864"
                                        }
                                    ];
                                    for (const le1 of uc){
                                        const vt = h.createNS("http://www.w3.org/2000/svg", "ellipse");
                                        vt.setAttributeNS(null, "opacity", "0.04"), vt.setAttributeNS(null, "cx", "10.5"), vt.setAttributeNS(null, "cy", "5.80029008"), vt.setAttributeNS(null, "rx", le1.rx), vt.setAttributeNS(null, "ry", le1.ry), sc.appendChild(vt);
                                    }
                                    const mc = h.createNS("http://www.w3.org/2000/svg", "g");
                                    mc.setAttributeNS(null, "fill", this._color);
                                    const gc = h.createNS("http://www.w3.org/2000/svg", "path");
                                    gc.setAttributeNS(null, "d", "M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"), mc.appendChild(gc);
                                    const Ac = h.createNS("http://www.w3.org/2000/svg", "g");
                                    Ac.setAttributeNS(null, "opacity", "0.25"), Ac.setAttributeNS(null, "fill", "#000000");
                                    const Ec = h.createNS("http://www.w3.org/2000/svg", "path");
                                    Ec.setAttributeNS(null, "d", "M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"), Ac.appendChild(Ec);
                                    const kc = h.createNS("http://www.w3.org/2000/svg", "g");
                                    kc.setAttributeNS(null, "transform", "translate(6.0, 7.0)"), kc.setAttributeNS(null, "fill", "#FFFFFF");
                                    const du = h.createNS("http://www.w3.org/2000/svg", "g");
                                    du.setAttributeNS(null, "transform", "translate(8.0, 8.0)");
                                    const _u = h.createNS("http://www.w3.org/2000/svg", "circle");
                                    _u.setAttributeNS(null, "fill", "#000000"), _u.setAttributeNS(null, "opacity", "0.25"), _u.setAttributeNS(null, "cx", "5.5"), _u.setAttributeNS(null, "cy", "5.5"), _u.setAttributeNS(null, "r", "5.4999962");
                                    const Md = h.createNS("http://www.w3.org/2000/svg", "circle");
                                    Md.setAttributeNS(null, "fill", "#FFFFFF"), Md.setAttributeNS(null, "cx", "5.5"), Md.setAttributeNS(null, "cy", "5.5"), Md.setAttributeNS(null, "r", "5.4999962"), du.appendChild(_u), du.appendChild(Md), Fl.appendChild(sc), Fl.appendChild(mc), Fl.appendChild(Ac), Fl.appendChild(kc), Fl.appendChild(du), bt.appendChild(Fl), bt.setAttributeNS(null, "height", ls * this._scale + "px"), bt.setAttributeNS(null, "width", ho * this._scale + "px"), this._element.appendChild(bt), this._offset = vt.P.convert(le1 && le1.offset || [
                                        0,
                                        -14
                                    ]);
                                }
                                if (this._element.classList.add("maplibregl-marker"), this._element.addEventListener("dragstart", (le1)=>{
                                    le1.preventDefault();
                                }), this._element.addEventListener("mousedown", (le1)=>{
                                    le1.preventDefault();
                                }), ps(this._element, this._anchor, "marker"), le1 && le1.className) for (const vt of le1.className.split(" "))this._element.classList.add(vt);
                                this._popup = null;
                            }
                            addTo(le1) {
                                return this.remove(), this._map = le1, this._element.hasAttribute("aria-label") || this._element.setAttribute("aria-label", le1._getUIString("Marker.Title")), this._element.hasAttribute("role") || this._element.setAttribute("role", "button"), le1.getCanvasContainer().appendChild(this._element), le1.on("move", this._update), le1.on("moveend", this._update), le1.on("terrain", this._update), le1.on("projectiontransition", this._update), this.setDraggable(this._draggable), this._update(), this._map.on("click", this._onMapClick), this;
                            }
                            remove() {
                                return this._opacityTimeout && (clearTimeout(this._opacityTimeout), delete this._opacityTimeout), this._map && (this._map.off("click", this._onMapClick), this._map.off("move", this._update), this._map.off("moveend", this._update), this._map.off("terrain", this._update), this._map.off("projectiontransition", this._update), this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler), this._map.off("mouseup", this._onUp), this._map.off("touchend", this._onUp), this._map.off("mousemove", this._onMove), this._map.off("touchmove", this._onMove), delete this._map), h.remove(this._element), this._popup && this._popup.remove(), this;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(le1) {
                                return this._lngLat = vt.V.convert(le1), this._pos = null, this._popup && this._popup.setLngLat(this._lngLat), this._update(), this;
                            }
                            getElement() {
                                return this._element;
                            }
                            setPopup(le1) {
                                if (this._popup && (this._popup.remove(), this._popup = null, this._element.removeEventListener("keypress", this._onKeyPress), this._originalTabIndex || this._element.removeAttribute("tabindex")), le1) {
                                    if (!("offset" in le1.options)) {
                                        const vt = 38.1, bt = 13.5, ls = Math.abs(bt) / Math.SQRT2;
                                        le1.options.offset = this._defaultMarker ? {
                                            top: [
                                                0,
                                                0
                                            ],
                                            "top-left": [
                                                0,
                                                0
                                            ],
                                            "top-right": [
                                                0,
                                                0
                                            ],
                                            bottom: [
                                                0,
                                                -vt
                                            ],
                                            "bottom-left": [
                                                ls,
                                                -1 * (vt - bt + ls)
                                            ],
                                            "bottom-right": [
                                                -ls,
                                                -1 * (vt - bt + ls)
                                            ],
                                            left: [
                                                bt,
                                                -1 * (vt - bt)
                                            ],
                                            right: [
                                                -bt,
                                                -1 * (vt - bt)
                                            ]
                                        } : this._offset;
                                    }
                                    this._popup = le1, this._originalTabIndex = this._element.getAttribute("tabindex"), this._originalTabIndex || this._element.setAttribute("tabindex", "0"), this._element.addEventListener("keypress", this._onKeyPress);
                                }
                                return this;
                            }
                            setSubpixelPositioning(le1) {
                                return this._subpixelPositioning = le1, this;
                            }
                            getPopup() {
                                return this._popup;
                            }
                            togglePopup() {
                                const le1 = this._popup;
                                return this._element.style.opacity === this._opacityWhenCovered ? this : le1 ? (le1.isOpen() ? le1.remove() : (le1.setLngLat(this._lngLat), le1.addTo(this._map)), this) : this;
                            }
                            _updateOpacity(le1 = !1) {
                                var bt, ls;
                                const ho = null === (bt = this._map) || void 0 === bt ? void 0 : bt.terrain, Dl = this._map.transform.isLocationOccluded(this._lngLat);
                                if (!ho || Dl) {
                                    const le1 = Dl ? this._opacityWhenCovered : this._opacity;
                                    return void (this._element.style.opacity !== le1 && (this._element.style.opacity = le1));
                                }
                                if (le1) this._opacityTimeout = null;
                                else {
                                    if (this._opacityTimeout) return;
                                    this._opacityTimeout = setTimeout(()=>{
                                        this._opacityTimeout = null;
                                    }, 100);
                                }
                                const Fl = this._map, sc = Fl.terrain.depthAtPoint(this._pos), uc = Fl.terrain.getElevationForLngLat(this._lngLat, Fl.transform);
                                if (Fl.transform.lngLatToCameraDepth(this._lngLat, uc) - sc < .006) return void (this._element.style.opacity = this._opacity);
                                const mc = -this._offset.y / Fl.transform.pixelsPerMeter, gc = Math.sin(Fl.getPitch() * Math.PI / 180) * mc, Ac = Fl.terrain.depthAtPoint(new vt.P(this._pos.x, this._pos.y - this._offset.y)), Ec = Fl.transform.lngLatToCameraDepth(this._lngLat, uc + gc) - Ac > .006;
                                (null === (ls = this._popup) || void 0 === ls ? void 0 : ls.isOpen()) && Ec && this._popup.remove(), this._element.style.opacity = Ec ? this._opacityWhenCovered : this._opacity;
                            }
                            getOffset() {
                                return this._offset;
                            }
                            setOffset(le1) {
                                return this._offset = vt.P.convert(le1), this._update(), this;
                            }
                            addClassName(le1) {
                                this._element.classList.add(le1);
                            }
                            removeClassName(le1) {
                                this._element.classList.remove(le1);
                            }
                            toggleClassName(le1) {
                                return this._element.classList.toggle(le1);
                            }
                            setDraggable(le1) {
                                return this._draggable = !!le1, this._map && (le1 ? (this._map.on("mousedown", this._addDragHandler), this._map.on("touchstart", this._addDragHandler)) : (this._map.off("mousedown", this._addDragHandler), this._map.off("touchstart", this._addDragHandler))), this;
                            }
                            isDraggable() {
                                return this._draggable;
                            }
                            setRotation(le1) {
                                return this._rotation = le1 || 0, this._update(), this;
                            }
                            getRotation() {
                                return this._rotation;
                            }
                            setRotationAlignment(le1) {
                                return this._rotationAlignment = le1 || "auto", this._update(), this;
                            }
                            getRotationAlignment() {
                                return this._rotationAlignment;
                            }
                            setPitchAlignment(le1) {
                                return this._pitchAlignment = le1 && "auto" !== le1 ? le1 : this._rotationAlignment, this._update(), this;
                            }
                            getPitchAlignment() {
                                return this._pitchAlignment;
                            }
                            setOpacity(le1, vt) {
                                return (void 0 === this._opacity || void 0 === le1 && void 0 === vt) && (this._opacity = "1", this._opacityWhenCovered = "0.2"), void 0 !== le1 && (this._opacity = le1), void 0 !== vt && (this._opacityWhenCovered = vt), this._map && this._updateOpacity(!0), this;
                            }
                        }
                        const Jm = {
                            positionOptions: {
                                enableHighAccuracy: !1,
                                maximumAge: 0,
                                timeout: 6e3
                            },
                            fitBoundsOptions: {
                                maxZoom: 15
                            },
                            trackUserLocation: !1,
                            showAccuracyCircle: !0,
                            showUserLocation: !0
                        };
                        let $m = 0, eg = !1;
                        const tg = {
                            maxWidth: 100,
                            unit: "metric"
                        };
                        function bs(le1, vt, bt) {
                            const ls = bt && bt.maxWidth || 100, ho = le1._container.clientHeight / 2, Dl = le1._container.clientWidth / 2, Fl = le1.unproject([
                                Dl - ls / 2,
                                ho
                            ]), sc = le1.unproject([
                                Dl + ls / 2,
                                ho
                            ]), uc = Math.round(le1.project(sc).x - le1.project(Fl).x), mc = Math.min(ls, uc, le1._container.clientWidth), gc = Fl.distanceTo(sc);
                            if (bt && "imperial" === bt.unit) {
                                const bt = 3.2808 * gc;
                                bt > 5280 ? ys(vt, mc, bt / 5280, le1._getUIString("ScaleControl.Miles")) : ys(vt, mc, bt, le1._getUIString("ScaleControl.Feet"));
                            } else bt && "nautical" === bt.unit ? ys(vt, mc, gc / 1852, le1._getUIString("ScaleControl.NauticalMiles")) : gc >= 1e3 ? ys(vt, mc, gc / 1e3, le1._getUIString("ScaleControl.Kilometers")) : ys(vt, mc, gc, le1._getUIString("ScaleControl.Meters"));
                        }
                        function ys(le1, vt, bt, ls) {
                            const ho = function(le1) {
                                const vt = Math.pow(10, `${Math.floor(le1)}`.length - 1);
                                let bt = le1 / vt;
                                return bt = bt >= 10 ? 10 : bt >= 5 ? 5 : bt >= 3 ? 3 : bt >= 2 ? 2 : bt >= 1 ? 1 : function(le1) {
                                    const vt = Math.pow(10, Math.ceil(-Math.log(le1) / Math.LN10));
                                    return Math.round(le1 * vt) / vt;
                                }(bt), vt * bt;
                            }(bt);
                            le1.style.width = vt * (ho / bt) + "px", le1.innerHTML = `${ho}&nbsp;${ls}`;
                        }
                        const ig = {
                            closeButton: !0,
                            closeOnClick: !0,
                            focusAfterOpen: !0,
                            className: "",
                            maxWidth: "240px",
                            subpixelPositioning: !1,
                            locationOccludedOpacity: void 0,
                            padding: void 0
                        }, ng = [
                            "a[href]",
                            "[tabindex]:not([tabindex='-1'])",
                            "[contenteditable]:not([contenteditable='false'])",
                            "button:not([disabled])",
                            "input:not([disabled])",
                            "select:not([disabled])",
                            "textarea:not([disabled])"
                        ].join(", ");
                        function Ps(le1) {
                            if (le1) {
                                if ("number" == typeof le1) {
                                    const bt = Math.round(Math.abs(le1) / Math.SQRT2);
                                    return {
                                        center: new vt.P(0, 0),
                                        top: new vt.P(0, le1),
                                        "top-left": new vt.P(bt, bt),
                                        "top-right": new vt.P(-bt, bt),
                                        bottom: new vt.P(0, -le1),
                                        "bottom-left": new vt.P(bt, -bt),
                                        "bottom-right": new vt.P(-bt, -bt),
                                        left: new vt.P(le1, 0),
                                        right: new vt.P(-le1, 0)
                                    };
                                }
                                if (le1 instanceof vt.P || Array.isArray(le1)) {
                                    const bt = vt.P.convert(le1);
                                    return {
                                        center: bt,
                                        top: bt,
                                        "top-left": bt,
                                        "top-right": bt,
                                        bottom: bt,
                                        "bottom-left": bt,
                                        "bottom-right": bt,
                                        left: bt,
                                        right: bt
                                    };
                                }
                                return {
                                    center: vt.P.convert(le1.center || [
                                        0,
                                        0
                                    ]),
                                    top: vt.P.convert(le1.top || [
                                        0,
                                        0
                                    ]),
                                    "top-left": vt.P.convert(le1["top-left"] || [
                                        0,
                                        0
                                    ]),
                                    "top-right": vt.P.convert(le1["top-right"] || [
                                        0,
                                        0
                                    ]),
                                    bottom: vt.P.convert(le1.bottom || [
                                        0,
                                        0
                                    ]),
                                    "bottom-left": vt.P.convert(le1["bottom-left"] || [
                                        0,
                                        0
                                    ]),
                                    "bottom-right": vt.P.convert(le1["bottom-right"] || [
                                        0,
                                        0
                                    ]),
                                    left: vt.P.convert(le1.left || [
                                        0,
                                        0
                                    ]),
                                    right: vt.P.convert(le1.right || [
                                        0,
                                        0
                                    ])
                                };
                            }
                            return Ps(new vt.P(0, 0));
                        }
                        const rg = bt;
                        le1.AJAXError = vt.cJ, le1.Event = vt.l, le1.Evented = vt.E, le1.LngLat = vt.V, le1.MercatorCoordinate = vt.a9, le1.Point = vt.P, le1.addProtocol = vt.cK, le1.config = vt.c, le1.removeProtocol = vt.cL, le1.AttributionControl = Yr, le1.BoxZoomHandler = hr, le1.CanvasSource = ae, le1.CooperativeGesturesHandler = Vr, le1.DoubleClickZoomHandler = Or, le1.DragPanHandler = Zr, le1.DragRotateHandler = Ur, le1.EdgeInsets = Nt, le1.FullscreenControl = class extends vt.E {
                            constructor(le1 = {}){
                                super(), this._onFullscreenChange = ()=>{
                                    var le1;
                                    let vt = window.document.fullscreenElement || window.document.mozFullScreenElement || window.document.webkitFullscreenElement || window.document.msFullscreenElement;
                                    for(; null === (le1 = null == vt ? void 0 : vt.shadowRoot) || void 0 === le1 ? void 0 : le1.fullscreenElement;)vt = vt.shadowRoot.fullscreenElement;
                                    vt === this._container !== this._fullscreen && this._handleFullscreenChange();
                                }, this._onClickFullscreen = ()=>{
                                    this._isFullscreen() ? this._exitFullscreen() : this._requestFullscreen();
                                }, this._fullscreen = !1, le1 && le1.container && (le1.container instanceof HTMLElement ? this._container = le1.container : vt.w("Full screen control 'container' must be a DOM element.")), "onfullscreenchange" in document ? this._fullscreenchange = "fullscreenchange" : "onmozfullscreenchange" in document ? this._fullscreenchange = "mozfullscreenchange" : "onwebkitfullscreenchange" in document ? this._fullscreenchange = "webkitfullscreenchange" : "onmsfullscreenchange" in document && (this._fullscreenchange = "MSFullscreenChange");
                            }
                            onAdd(le1) {
                                return this._map = le1, this._container || (this._container = this._map.getContainer()), this._controlContainer = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), this._controlContainer;
                            }
                            onRemove() {
                                h.remove(this._controlContainer), this._map = null, window.document.removeEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _setupUI() {
                                const le1 = this._fullscreenButton = h.create("button", "maplibregl-ctrl-fullscreen", this._controlContainer);
                                h.create("span", "maplibregl-ctrl-icon", le1).setAttribute("aria-hidden", "true"), le1.type = "button", this._updateTitle(), this._fullscreenButton.addEventListener("click", this._onClickFullscreen), window.document.addEventListener(this._fullscreenchange, this._onFullscreenChange);
                            }
                            _updateTitle() {
                                const le1 = this._getTitle();
                                this._fullscreenButton.setAttribute("aria-label", le1), this._fullscreenButton.title = le1;
                            }
                            _getTitle() {
                                return this._map._getUIString(this._isFullscreen() ? "FullscreenControl.Exit" : "FullscreenControl.Enter");
                            }
                            _isFullscreen() {
                                return this._fullscreen;
                            }
                            _handleFullscreenChange() {
                                this._fullscreen = !this._fullscreen, this._fullscreenButton.classList.toggle("maplibregl-ctrl-shrink"), this._fullscreenButton.classList.toggle("maplibregl-ctrl-fullscreen"), this._updateTitle(), this._fullscreen ? (this.fire(new vt.l("fullscreenstart")), this._prevCooperativeGesturesEnabled = this._map.cooperativeGestures.isEnabled(), this._map.cooperativeGestures.disable()) : (this.fire(new vt.l("fullscreenend")), this._prevCooperativeGesturesEnabled && this._map.cooperativeGestures.enable());
                            }
                            _exitFullscreen() {
                                window.document.exitFullscreen ? window.document.exitFullscreen() : window.document.mozCancelFullScreen ? window.document.mozCancelFullScreen() : window.document.msExitFullscreen ? window.document.msExitFullscreen() : window.document.webkitCancelFullScreen ? window.document.webkitCancelFullScreen() : this._togglePseudoFullScreen();
                            }
                            _requestFullscreen() {
                                this._container.requestFullscreen ? this._container.requestFullscreen() : this._container.mozRequestFullScreen ? this._container.mozRequestFullScreen() : this._container.msRequestFullscreen ? this._container.msRequestFullscreen() : this._container.webkitRequestFullscreen ? this._container.webkitRequestFullscreen() : this._togglePseudoFullScreen();
                            }
                            _togglePseudoFullScreen() {
                                this._container.classList.toggle("maplibregl-pseudo-fullscreen"), this._handleFullscreenChange(), this._map.resize();
                            }
                        }, le1.GeoJSONSource = ee, le1.GeolocateControl = class extends vt.E {
                            constructor(le1){
                                super(), this._onSuccess = (le1)=>{
                                    if (this._map) {
                                        if (this._isOutOfMapMaxBounds(le1)) return this._setErrorState(), this.fire(new vt.l("outofmaxbounds", le1)), this._updateMarker(), void this._finish();
                                        if (this.options.trackUserLocation) switch(this._lastKnownPosition = le1, this._watchState){
                                            case "WAITING_ACTIVE":
                                            case "ACTIVE_LOCK":
                                            case "ACTIVE_ERROR":
                                                this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                                break;
                                            case "BACKGROUND":
                                            case "BACKGROUND_ERROR":
                                                this._watchState = "BACKGROUND", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background");
                                                break;
                                            default:
                                                throw new Error(`Unexpected watchState ${this._watchState}`);
                                        }
                                        this.options.showUserLocation && "OFF" !== this._watchState && this._updateMarker(le1), this.options.trackUserLocation && "ACTIVE_LOCK" !== this._watchState || this._updateCamera(le1), this.options.showUserLocation && this._dotElement.classList.remove("maplibregl-user-location-dot-stale"), this.fire(new vt.l("geolocate", le1)), this._finish();
                                    }
                                }, this._updateCamera = (le1)=>{
                                    const bt = new vt.V(le1.coords.longitude, le1.coords.latitude), ls = le1.coords.accuracy, ho = this._map.getBearing(), Dl = vt.e({
                                        bearing: ho
                                    }, this.options.fitBoundsOptions), Fl = $.fromLngLat(bt, ls);
                                    this._map.fitBounds(Fl, Dl, {
                                        geolocateSource: !0
                                    });
                                }, this._updateMarker = (le1)=>{
                                    if (le1) {
                                        const bt = new vt.V(le1.coords.longitude, le1.coords.latitude);
                                        this._accuracyCircleMarker.setLngLat(bt).addTo(this._map), this._userLocationDotMarker.setLngLat(bt).addTo(this._map), this._accuracy = le1.coords.accuracy, this._updateCircleRadiusIfNeeded();
                                    } else this._userLocationDotMarker.remove(), this._accuracyCircleMarker.remove();
                                }, this._onUpdate = ()=>{
                                    this._updateCircleRadiusIfNeeded();
                                }, this._onError = (le1)=>{
                                    if (this._map) {
                                        if (1 === le1.code) {
                                            this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.disabled = !0;
                                            const le1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.title = le1, this._geolocateButton.setAttribute("aria-label", le1), void 0 !== this._geolocationWatchID && this._clearWatch();
                                        } else {
                                            if (3 === le1.code && eg) return;
                                            this._setErrorState();
                                        }
                                        "OFF" !== this._watchState && this.options.showUserLocation && this._dotElement.classList.add("maplibregl-user-location-dot-stale"), this.fire(new vt.l("error", le1)), this._finish();
                                    }
                                }, this._finish = ()=>{
                                    this._timeoutId && clearTimeout(this._timeoutId), this._timeoutId = void 0;
                                }, this._setupUI = ()=>{
                                    this._map && (this._container.addEventListener("contextmenu", (le1)=>le1.preventDefault()), this._geolocateButton = h.create("button", "maplibregl-ctrl-geolocate", this._container), h.create("span", "maplibregl-ctrl-icon", this._geolocateButton).setAttribute("aria-hidden", "true"), this._geolocateButton.type = "button", this._geolocateButton.disabled = !0);
                                }, this._finishSetupUI = (le1)=>{
                                    if (this._map) {
                                        if (!1 === le1) {
                                            vt.w("Geolocation support is not available so the GeolocateControl will be disabled.");
                                            const le1 = this._map._getUIString("GeolocateControl.LocationNotAvailable");
                                            this._geolocateButton.disabled = !0, this._geolocateButton.title = le1, this._geolocateButton.setAttribute("aria-label", le1);
                                        } else {
                                            const le1 = this._map._getUIString("GeolocateControl.FindMyLocation");
                                            this._geolocateButton.disabled = !1, this._geolocateButton.title = le1, this._geolocateButton.setAttribute("aria-label", le1);
                                        }
                                        this.options.trackUserLocation && (this._geolocateButton.setAttribute("aria-pressed", "false"), this._watchState = "OFF"), this.options.showUserLocation && (this._dotElement = h.create("div", "maplibregl-user-location-dot"), this._userLocationDotMarker = new ms({
                                            element: this._dotElement
                                        }), this._circleElement = h.create("div", "maplibregl-user-location-accuracy-circle"), this._accuracyCircleMarker = new ms({
                                            element: this._circleElement,
                                            pitchAlignment: "map"
                                        }), this.options.trackUserLocation && (this._watchState = "OFF"), this._map.on("zoom", this._onUpdate), this._map.on("move", this._onUpdate), this._map.on("rotate", this._onUpdate), this._map.on("pitch", this._onUpdate)), this._geolocateButton.addEventListener("click", ()=>this.trigger()), this._setup = !0, this.options.trackUserLocation && this._map.on("movestart", (le1)=>{
                                            const bt = (null == le1 ? void 0 : le1[0]) instanceof ResizeObserverEntry;
                                            le1.geolocateSource || "ACTIVE_LOCK" !== this._watchState || bt || this._map.isZooming() || (this._watchState = "BACKGROUND", this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this.fire(new vt.l("trackuserlocationend")), this.fire(new vt.l("userlocationlostfocus")));
                                        });
                                    }
                                }, this.options = vt.e({}, Jm, le1);
                            }
                            onAdd(le1) {
                                return this._map = le1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._setupUI(), (function() {
                                    return vt._(this, arguments, void 0, function*(le1 = !1) {
                                        if (void 0 !== Xm && !le1) return Xm;
                                        if (void 0 === window.navigator.permissions) return Xm = !!window.navigator.geolocation, Xm;
                                        try {
                                            const le1 = yield window.navigator.permissions.query({
                                                name: "geolocation"
                                            });
                                            Xm = "denied" !== le1.state;
                                        } catch (le1) {
                                            Xm = !!window.navigator.geolocation;
                                        }
                                        return Xm;
                                    });
                                })().then((le1)=>this._finishSetupUI(le1)), this._container;
                            }
                            onRemove() {
                                void 0 !== this._geolocationWatchID && (window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0), this.options.showUserLocation && this._userLocationDotMarker && this._userLocationDotMarker.remove(), this.options.showAccuracyCircle && this._accuracyCircleMarker && this._accuracyCircleMarker.remove(), h.remove(this._container), this._map.off("zoom", this._onUpdate), this._map.off("move", this._onUpdate), this._map.off("rotate", this._onUpdate), this._map.off("pitch", this._onUpdate), this._map = void 0, $m = 0, eg = !1;
                            }
                            _isOutOfMapMaxBounds(le1) {
                                const vt = this._map.getMaxBounds(), bt = le1.coords;
                                return vt && (bt.longitude < vt.getWest() || bt.longitude > vt.getEast() || bt.latitude < vt.getSouth() || bt.latitude > vt.getNorth());
                            }
                            _setErrorState() {
                                switch(this._watchState){
                                    case "WAITING_ACTIVE":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error");
                                        break;
                                    case "ACTIVE_LOCK":
                                        this._watchState = "ACTIVE_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "BACKGROUND":
                                        this._watchState = "BACKGROUND_ERROR", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-background-error"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting");
                                        break;
                                    case "ACTIVE_ERROR":
                                    case "BACKGROUND_ERROR":
                                    case "OFF":
                                    case void 0:
                                        break;
                                    default:
                                        throw new Error(`Unexpected watchState ${this._watchState}`);
                                }
                            }
                            _updateCircleRadiusIfNeeded() {
                                const le1 = this._userLocationDotMarker.getLngLat();
                                if (!(this.options.showUserLocation && this.options.showAccuracyCircle && this._accuracy && le1)) return;
                                const vt = this._map.project(le1), bt = this._map.unproject([
                                    vt.x + 100,
                                    vt.y
                                ]), ls = le1.distanceTo(bt) / 100, ho = 2 * this._accuracy / ls;
                                this._circleElement.style.width = `${ho.toFixed(2)}px`, this._circleElement.style.height = `${ho.toFixed(2)}px`;
                            }
                            trigger() {
                                if (!this._setup) return vt.w("Geolocate control triggered before added to a map"), !1;
                                if (this.options.trackUserLocation) {
                                    switch(this._watchState){
                                        case "OFF":
                                            this._watchState = "WAITING_ACTIVE", this.fire(new vt.l("trackuserlocationstart"));
                                            break;
                                        case "WAITING_ACTIVE":
                                        case "ACTIVE_LOCK":
                                        case "ACTIVE_ERROR":
                                        case "BACKGROUND_ERROR":
                                            $m--, eg = !1, this._watchState = "OFF", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-active-error"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background-error"), this.fire(new vt.l("trackuserlocationend"));
                                            break;
                                        case "BACKGROUND":
                                            this._watchState = "ACTIVE_LOCK", this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-background"), this._lastKnownPosition && this._updateCamera(this._lastKnownPosition), this.fire(new vt.l("trackuserlocationstart")), this.fire(new vt.l("userlocationfocus"));
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    switch(this._watchState){
                                        case "WAITING_ACTIVE":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "ACTIVE_LOCK":
                                            this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-active");
                                            break;
                                        case "OFF":
                                            break;
                                        default:
                                            throw new Error(`Unexpected watchState ${this._watchState}`);
                                    }
                                    if ("OFF" === this._watchState && void 0 !== this._geolocationWatchID) this._clearWatch();
                                    else if (void 0 === this._geolocationWatchID) {
                                        let le1;
                                        this._geolocateButton.classList.add("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "true"), $m++, $m > 1 ? (le1 = {
                                            maximumAge: 6e5,
                                            timeout: 0
                                        }, eg = !0) : (le1 = this.options.positionOptions, eg = !1), this._geolocationWatchID = window.navigator.geolocation.watchPosition(this._onSuccess, this._onError, le1);
                                    }
                                } else window.navigator.geolocation.getCurrentPosition(this._onSuccess, this._onError, this.options.positionOptions), this._timeoutId = setTimeout(this._finish, 1e4);
                                return !0;
                            }
                            _clearWatch() {
                                window.navigator.geolocation.clearWatch(this._geolocationWatchID), this._geolocationWatchID = void 0, this._geolocateButton.classList.remove("maplibregl-ctrl-geolocate-waiting"), this._geolocateButton.setAttribute("aria-pressed", "false"), this.options.showUserLocation && this._updateMarker(null);
                            }
                        }, le1.GlobeControl = class {
                            constructor(){
                                this._toggleProjection = ()=>{
                                    var le1;
                                    const vt = null === (le1 = this._map.getProjection()) || void 0 === le1 ? void 0 : le1.type;
                                    this._map.setProjection("mercator" !== vt && vt ? {
                                        type: "mercator"
                                    } : {
                                        type: "globe"
                                    }), this._updateGlobeIcon();
                                }, this._updateGlobeIcon = ()=>{
                                    var le1;
                                    this._globeButton.classList.remove("maplibregl-ctrl-globe"), this._globeButton.classList.remove("maplibregl-ctrl-globe-enabled"), "globe" === (null === (le1 = this._map.getProjection()) || void 0 === le1 ? void 0 : le1.type) ? (this._globeButton.classList.add("maplibregl-ctrl-globe-enabled"), this._globeButton.title = this._map._getUIString("GlobeControl.Disable")) : (this._globeButton.classList.add("maplibregl-ctrl-globe"), this._globeButton.title = this._map._getUIString("GlobeControl.Enable"));
                                };
                            }
                            onAdd(le1) {
                                return this._map = le1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._globeButton = h.create("button", "maplibregl-ctrl-globe", this._container), h.create("span", "maplibregl-ctrl-icon", this._globeButton).setAttribute("aria-hidden", "true"), this._globeButton.type = "button", this._globeButton.addEventListener("click", this._toggleProjection), this._updateGlobeIcon(), this._map.on("styledata", this._updateGlobeIcon), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this._map.off("styledata", this._updateGlobeIcon), this._globeButton.removeEventListener("click", this._toggleProjection), this._map = void 0;
                            }
                        }, le1.Hash = Ho, le1.ImageSource = te, le1.KeyboardHandler = Ar, le1.LngLatBounds = $, le1.LogoControl = Qr, le1.Map = class extends Xr {
                            get _ownerWindow() {
                                var le1, vt;
                                return (null === (vt = null === (le1 = this._container) || void 0 === le1 ? void 0 : le1.ownerDocument) || void 0 === vt ? void 0 : vt.defaultView) || window;
                            }
                            constructor(le1){
                                var bt, ls;
                                vt.cH.mark(vt.cI.create);
                                const ho = Object.assign(Object.assign(Object.assign({}, Ym), le1), {
                                    canvasContextAttributes: Object.assign(Object.assign({}, Ym.canvasContextAttributes), le1.canvasContextAttributes)
                                });
                                if (null != ho.minZoom && null != ho.maxZoom && ho.minZoom > ho.maxZoom) throw new Error("maxZoom must be greater than or equal to minZoom");
                                if (null != ho.minPitch && null != ho.maxPitch && ho.minPitch > ho.maxPitch) throw new Error("maxPitch must be greater than or equal to minPitch");
                                if (null != ho.minPitch && ho.minPitch < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (null != ho.maxPitch && ho.maxPitch > 180) throw new Error("maxPitch must be less than or equal to 180");
                                const Dl = new $t, sc = new Yt;
                                void 0 !== ho.minZoom && Dl.setMinZoom(ho.minZoom), void 0 !== ho.maxZoom && Dl.setMaxZoom(ho.maxZoom), void 0 !== ho.minPitch && Dl.setMinPitch(ho.minPitch), void 0 !== ho.maxPitch && Dl.setMaxPitch(ho.maxPitch), void 0 !== ho.renderWorldCopies && Dl.setRenderWorldCopies(ho.renderWorldCopies), null !== ho.transformConstrain && Dl.setConstrainOverride(ho.transformConstrain), super(Dl, sc, {
                                    bearingSnap: ho.bearingSnap,
                                    zoomSnap: ho.zoomSnap
                                }), this._idleTriggered = !1, this._crossFadingFactor = 1, this._renderTaskQueue = new Jr, this._controls = [], this._mapId = vt.af(), this._lostContextStyle = {
                                    style: null,
                                    images: null
                                }, this._contextLost = (le1)=>{
                                    le1.preventDefault(), this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this.painter.destroy();
                                    for (const vt of Object.values(this.style._layers))if ("custom" === vt.type && console.warn(`Custom layer with id '${vt.id}' cannot be restored after WebGL context loss. You will need to re-add it manually after context restoration.`), vt._listeners) for (const [le1] of Object.entries(vt._listeners))console.warn(`Custom layer with id '${vt.id}' had event listeners for event '${le1}' which cannot be restored after WebGL context loss. You will need to re-add them manually after context restoration.`);
                                    this._lostContextStyle = this._getStyleAndImages(), this.style.destroy(), this.style = null, this.fire(new vt.l("webglcontextlost", {
                                        originalEvent: le1
                                    }));
                                }, this._contextRestored = (le1)=>{
                                    this._lostContextStyle.style && this.setStyle(this._lostContextStyle.style, {
                                        diff: !1
                                    }), this._lostContextStyle.images && (this.style.imageManager.images = this._lostContextStyle.images), this._lostContextStyle = {
                                        style: null,
                                        images: null
                                    }, this._setupPainter(), this.resize(), this._update(), this._resizeInternal(), this.fire(new vt.l("webglcontextrestored", {
                                        originalEvent: le1
                                    }));
                                }, this._onMapScroll = (le1)=>{
                                    if (le1.target === this._container) return this._container.scrollTop = 0, this._container.scrollLeft = 0, !1;
                                }, this._onWindowOnline = ()=>{
                                    this._update();
                                }, this._interactive = ho.interactive, this._maxTileCacheSize = ho.maxTileCacheSize, this._maxTileCacheZoomLevels = ho.maxTileCacheZoomLevels, this._canvasContextAttributes = Object.assign({}, ho.canvasContextAttributes), this._trackResize = !0 === ho.trackResize, this._bearingSnap = ho.bearingSnap, this._zoomSnap = ho.zoomSnap, this._centerClampedToGround = ho.centerClampedToGround, this._refreshExpiredTiles = !0 === ho.refreshExpiredTiles, this._fadeDuration = ho.fadeDuration, this._crossSourceCollisions = !0 === ho.crossSourceCollisions, this._collectResourceTiming = !0 === ho.collectResourceTiming, this._locale = Object.assign(Object.assign({}, Wm), ho.locale), this._clickTolerance = ho.clickTolerance, this._overridePixelRatio = ho.pixelRatio, this._maxCanvasSize = ho.maxCanvasSize, this._zoomLevelsToOverscale = ho.experimentalZoomLevelsToOverscale, this.transformCameraUpdate = ho.transformCameraUpdate, this.transformConstrain = ho.transformConstrain, this.cancelPendingTileRequestsWhileZooming = !0 === ho.cancelPendingTileRequestsWhileZooming, void 0 !== ho.reduceMotion && (Fl.prefersReducedMotion = ho.reduceMotion), this._imageQueueHandle = kc.addThrottleControl(()=>this.isMoving()), this._requestManager = new v(ho.transformRequest), this._container = this._resolveContainer(ho.container), ho.maxBounds && this.setMaxBounds(ho.maxBounds), this._setupContainer(), this._setupPainter(), this.on("move", ()=>this._update(!1)), this.on("moveend", ()=>this._update(!1)), this.on("zoom", ()=>this._update(!0)), this.on("terrain", ()=>{
                                    this.painter.terrainFacilitator.dirty = !0, this._update(!0);
                                }), this.once("idle", ()=>{
                                    this._idleTriggered = !0;
                                }), "undefined" != typeof window && (this._ownerWindow.addEventListener("online", this._onWindowOnline, !1), this._setupResizeObserver()), this.handlers = new Hr(this, ho), this._hash = ho.hash && new Ho("string" == typeof ho.hash && ho.hash || void 0).addTo(this), this._hash && this._hash._onHashChange() || (this.jumpTo({
                                    center: ho.center,
                                    elevation: ho.elevation,
                                    zoom: ho.zoom,
                                    bearing: ho.bearing,
                                    pitch: ho.pitch,
                                    roll: ho.roll
                                }), ho.bounds && (this.resize(), this.fitBounds(ho.bounds, vt.e({}, ho.fitBoundsOptions, {
                                    duration: 0
                                }))));
                                const uc = "string" == typeof ho.style || !("globe" === (null === (ls = null === (bt = ho.style) || void 0 === bt ? void 0 : bt.projection) || void 0 === ls ? void 0 : ls.type));
                                this.resize(null, uc), this._localIdeographFontFamily = ho.localIdeographFontFamily, this._validateStyle = ho.validateStyle, ho.style && this.setStyle(ho.style, {
                                    localIdeographFontFamily: ho.localIdeographFontFamily
                                }), ho.attributionControl && this.addControl(new Yr("boolean" == typeof ho.attributionControl ? void 0 : ho.attributionControl)), ho.maplibreLogo && this.addControl(new Qr, ho.logoPosition), this.on("style.load", ()=>{
                                    if (uc || this._resizeTransform(), this.transform.unmodified) {
                                        const le1 = vt.U(this.style.stylesheet, [
                                            "center",
                                            "zoom",
                                            "bearing",
                                            "pitch",
                                            "roll"
                                        ]);
                                        this.jumpTo(le1);
                                    }
                                }), this.on("data", (le1)=>{
                                    this._update("style" === le1.dataType), this.fire(new vt.l(`${le1.dataType}data`, le1));
                                }), this.on("dataloading", (le1)=>{
                                    this.fire(new vt.l(`${le1.dataType}dataloading`, le1));
                                }), this.on("dataabort", (le1)=>{
                                    this.fire(new vt.l("sourcedataabort", le1));
                                });
                            }
                            _getMapId() {
                                return this._mapId;
                            }
                            setGlobalStateProperty(le1, vt) {
                                return this.style.setGlobalStateProperty(le1, vt), this._update(!0);
                            }
                            getGlobalState() {
                                return this.style.getGlobalState();
                            }
                            addControl(le1, bt) {
                                if (void 0 === bt && (bt = le1.getDefaultPosition ? le1.getDefaultPosition() : "top-right"), !le1 || !le1.onAdd) return this.fire(new vt.k(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const ls = le1.onAdd(this);
                                this._controls.push(le1);
                                const ho = this._controlPositions[bt];
                                return -1 !== bt.indexOf("bottom") ? ho.insertBefore(ls, ho.firstChild) : ho.appendChild(ls), this;
                            }
                            removeControl(le1) {
                                if (!le1 || !le1.onRemove) return this.fire(new vt.k(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));
                                const bt = this._controls.indexOf(le1);
                                return bt > -1 && this._controls.splice(bt, 1), le1.onRemove(this), this;
                            }
                            hasControl(le1) {
                                return this._controls.indexOf(le1) > -1;
                            }
                            coveringTiles(le1) {
                                return Ie(this.transform, le1);
                            }
                            calculateCameraOptionsFromTo(le1, vt, bt, ls) {
                                return null == ls && this.terrain && (ls = this.terrain.getElevationForLngLat(bt, this.transform)), super.calculateCameraOptionsFromTo(le1, vt, bt, ls);
                            }
                            resize(le1, bt = !0) {
                                if (null !== this._lostContextStyle.style) return this;
                                this._resizeInternal(bt);
                                const ls = !this._moving;
                                return ls && (this.stop(), this.fire(new vt.l("movestart", le1)).fire(new vt.l("move", le1))), this.fire(new vt.l("resize", le1)), ls && this.fire(new vt.l("moveend", le1)), this;
                            }
                            _resizeInternal(le1 = !0) {
                                const [vt, bt] = this._containerDimensions(), ls = this._getClampedPixelRatio(vt, bt);
                                if (this._resizeCanvas(vt, bt, ls), this.painter.resize(vt, bt, ls), this.painter.overLimit()) {
                                    const le1 = this.painter.context.gl;
                                    this._maxCanvasSize = [
                                        le1.drawingBufferWidth,
                                        le1.drawingBufferHeight
                                    ];
                                    const ls = this._getClampedPixelRatio(vt, bt);
                                    this._resizeCanvas(vt, bt, ls), this.painter.resize(vt, bt, ls);
                                }
                                this._resizeTransform(le1);
                            }
                            _resizeTransform(le1 = !0) {
                                var vt;
                                const [bt, ls] = this._containerDimensions();
                                this.transform.resize(bt, ls, le1), null === (vt = this._requestedCameraState) || void 0 === vt || vt.resize(bt, ls, le1);
                            }
                            _getClampedPixelRatio(le1, vt) {
                                const { 0: bt, 1: ls } = this._maxCanvasSize, ho = this.getPixelRatio(), Dl = le1 * ho, Fl = vt * ho;
                                return Math.min(Dl > bt ? bt / Dl : 1, Fl > ls ? ls / Fl : 1) * ho;
                            }
                            getPixelRatio() {
                                var le1;
                                return null !== (le1 = this._overridePixelRatio) && void 0 !== le1 ? le1 : devicePixelRatio;
                            }
                            setPixelRatio(le1) {
                                this._overridePixelRatio = le1, this.resize();
                            }
                            getBounds() {
                                return this.transform.getBounds();
                            }
                            getMaxBounds() {
                                return this.transform.getMaxBounds();
                            }
                            setMaxBounds(le1) {
                                return this.transform.setMaxBounds($.convert(le1)), this._update();
                            }
                            setMinZoom(le1) {
                                if ((le1 = null == le1 ? -2 : le1) >= -2 && le1 <= this.transform.maxZoom) {
                                    const bt = this.transform.zoom, ls = this._getTransformForUpdate();
                                    return ls.setMinZoom(le1), this._applyUpdatedTransform(ls), this._update(), bt !== this.transform.zoom && this.fire(new vt.l("zoomstart")).fire(new vt.l("zoom")).fire(new vt.l("zoomend")).fire(new vt.l("movestart")).fire(new vt.l("move")).fire(new vt.l("moveend")), this;
                                }
                                throw new Error("minZoom must be between -2 and the current maxZoom, inclusive");
                            }
                            getMinZoom() {
                                return this.transform.minZoom;
                            }
                            setMaxZoom(le1) {
                                if ((le1 = null == le1 ? 22 : le1) >= this.transform.minZoom) {
                                    const bt = this.transform.zoom, ls = this._getTransformForUpdate();
                                    return ls.setMaxZoom(le1), this._applyUpdatedTransform(ls), this._update(), bt !== this.transform.zoom && this.fire(new vt.l("zoomstart")).fire(new vt.l("zoom")).fire(new vt.l("zoomend")).fire(new vt.l("movestart")).fire(new vt.l("move")).fire(new vt.l("moveend")), this;
                                }
                                throw new Error("maxZoom must be greater than the current minZoom");
                            }
                            getMaxZoom() {
                                return this.transform.maxZoom;
                            }
                            setMinPitch(le1) {
                                if ((le1 = null == le1 ? 0 : le1) < 0) throw new Error("minPitch must be greater than or equal to 0");
                                if (le1 >= 0 && le1 <= this.transform.maxPitch) {
                                    const bt = this.transform.pitch, ls = this._getTransformForUpdate();
                                    return ls.setMinPitch(le1), this._applyUpdatedTransform(ls), this._update(), bt !== this.transform.pitch && this.fire(new vt.l("pitchstart")).fire(new vt.l("pitch")).fire(new vt.l("pitchend")).fire(new vt.l("movestart")).fire(new vt.l("move")).fire(new vt.l("moveend")), this;
                                }
                                throw new Error("minPitch must be between 0 and the current maxPitch, inclusive");
                            }
                            getMinPitch() {
                                return this.transform.minPitch;
                            }
                            setMaxPitch(le1) {
                                if ((le1 = null == le1 ? 60 : le1) > 180) throw new Error("maxPitch must be less than or equal to 180");
                                if (le1 >= this.transform.minPitch) {
                                    const bt = this.transform.pitch, ls = this._getTransformForUpdate();
                                    return ls.setMaxPitch(le1), this._applyUpdatedTransform(ls), this._update(), bt !== this.transform.pitch && this.fire(new vt.l("pitchstart")).fire(new vt.l("pitch")).fire(new vt.l("pitchend")).fire(new vt.l("movestart")).fire(new vt.l("move")).fire(new vt.l("moveend")), this;
                                }
                                throw new Error("maxPitch must be greater than the current minPitch");
                            }
                            getMaxPitch() {
                                return this.transform.maxPitch;
                            }
                            getRenderWorldCopies() {
                                return this.transform.renderWorldCopies;
                            }
                            setRenderWorldCopies(le1) {
                                return this.transform.setRenderWorldCopies(le1), this._update();
                            }
                            setTransformConstrain(le1) {
                                return this.transform.setConstrainOverride(le1), this._update();
                            }
                            project(le1) {
                                return this.transform.locationToScreenPoint(vt.V.convert(le1), this.style && this.terrain);
                            }
                            unproject(le1) {
                                return this.transform.screenPointToLocation(vt.P.convert(le1), this.terrain);
                            }
                            isMoving() {
                                var le1;
                                return this._moving || (null === (le1 = this.handlers) || void 0 === le1 ? void 0 : le1.isMoving());
                            }
                            isZooming() {
                                var le1;
                                return this._zooming || (null === (le1 = this.handlers) || void 0 === le1 ? void 0 : le1.isZooming());
                            }
                            isRotating() {
                                var le1;
                                return this._rotating || (null === (le1 = this.handlers) || void 0 === le1 ? void 0 : le1.isRotating());
                            }
                            _createDelegatedListener(le1, vt, bt) {
                                if ("mouseenter" === le1 || "mouseover" === le1) {
                                    let ls = !1;
                                    const o = (ho)=>{
                                        const Dl = vt.filter((le1)=>this.getLayer(le1)), Fl = 0 !== Dl.length ? this.queryRenderedFeatures(ho.point, {
                                            layers: Dl
                                        }) : [];
                                        Fl.length ? ls || (ls = !0, bt.call(this, new or(le1, this, ho.originalEvent, {
                                            features: Fl
                                        }))) : ls = !1;
                                    };
                                    return {
                                        layers: vt,
                                        listener: bt,
                                        delegates: {
                                            mousemove: o,
                                            mouseout: ()=>{
                                                ls = !1;
                                            }
                                        }
                                    };
                                }
                                if ("mouseleave" === le1 || "mouseout" === le1) {
                                    let ls = !1;
                                    const o = (ho)=>{
                                        const Dl = vt.filter((le1)=>this.getLayer(le1));
                                        (0 !== Dl.length ? this.queryRenderedFeatures(ho.point, {
                                            layers: Dl
                                        }) : []).length ? ls = !0 : ls && (ls = !1, bt.call(this, new or(le1, this, ho.originalEvent)));
                                    }, r = (vt)=>{
                                        ls && (ls = !1, bt.call(this, new or(le1, this, vt.originalEvent)));
                                    };
                                    return {
                                        layers: vt,
                                        listener: bt,
                                        delegates: {
                                            mousemove: o,
                                            mouseout: r
                                        }
                                    };
                                }
                                {
                                    const a = (le1)=>{
                                        const ls = vt.filter((le1)=>this.getLayer(le1)), ho = 0 !== ls.length ? this.queryRenderedFeatures(le1.point, {
                                            layers: ls
                                        }) : [];
                                        ho.length && (le1.features = ho, bt.call(this, le1), delete le1.features);
                                    };
                                    return {
                                        layers: vt,
                                        listener: bt,
                                        delegates: {
                                            [le1]: a
                                        }
                                    };
                                }
                            }
                            _saveDelegatedListener(le1, vt) {
                                this._delegatedListeners = this._delegatedListeners || {}, this._delegatedListeners[le1] = this._delegatedListeners[le1] || [], this._delegatedListeners[le1].push(vt);
                            }
                            _removeDelegatedListener(le1, vt, bt) {
                                if (!this._delegatedListeners || !this._delegatedListeners[le1]) return;
                                const ls = this._delegatedListeners[le1];
                                for(let ho = 0; ho < ls.length; ho++){
                                    const le1 = ls[ho];
                                    if (le1.listener === bt && le1.layers.length === vt.length && le1.layers.every((le1)=>vt.includes(le1))) {
                                        for(const vt in le1.delegates)this.off(vt, le1.delegates[vt]);
                                        return void ls.splice(ho, 1);
                                    }
                                }
                            }
                            on(le1, vt, bt) {
                                if (void 0 === bt) return super.on(le1, vt);
                                const ls = "string" == typeof vt ? [
                                    vt
                                ] : vt, ho = this._createDelegatedListener(le1, ls, bt);
                                this._saveDelegatedListener(le1, ho);
                                for(const Dl in ho.delegates)this.on(Dl, ho.delegates[Dl]);
                                return {
                                    unsubscribe: ()=>{
                                        this._removeDelegatedListener(le1, ls, bt);
                                    }
                                };
                            }
                            once(le1, vt, bt) {
                                if (void 0 === bt) return super.once(le1, vt);
                                const ls = "string" == typeof vt ? [
                                    vt
                                ] : vt, ho = this._createDelegatedListener(le1, ls, bt);
                                for(const Dl in ho.delegates){
                                    const vt = ho.delegates[Dl];
                                    ho.delegates[Dl] = (...ho)=>{
                                        this._removeDelegatedListener(le1, ls, bt), vt(...ho);
                                    };
                                }
                                this._saveDelegatedListener(le1, ho);
                                for(const Dl in ho.delegates)this.once(Dl, ho.delegates[Dl]);
                                return this;
                            }
                            off(le1, vt, bt) {
                                return void 0 === bt ? super.off(le1, vt) : (this._removeDelegatedListener(le1, "string" == typeof vt ? [
                                    vt
                                ] : vt, bt), this);
                            }
                            queryRenderedFeatures(le1, bt) {
                                if (!this.style) return [];
                                let ls;
                                const ho = le1 instanceof vt.P || Array.isArray(le1), Dl = ho ? le1 : [
                                    [
                                        0,
                                        0
                                    ],
                                    [
                                        this.transform.width,
                                        this.transform.height
                                    ]
                                ];
                                if (bt = bt || (ho ? {} : le1) || {}, Dl instanceof vt.P || "number" == typeof Dl[0]) ls = [
                                    vt.P.convert(Dl)
                                ];
                                else {
                                    const le1 = vt.P.convert(Dl[0]), bt = vt.P.convert(Dl[1]);
                                    ls = [
                                        le1,
                                        new vt.P(bt.x, le1.y),
                                        bt,
                                        new vt.P(le1.x, bt.y),
                                        le1
                                    ];
                                }
                                return this.style.queryRenderedFeatures(ls, bt, this.transform);
                            }
                            querySourceFeatures(le1, vt) {
                                return this.style.querySourceFeatures(le1, vt);
                            }
                            setStyle(le1, bt) {
                                return !1 !== (bt = vt.e({}, {
                                    localIdeographFontFamily: this._localIdeographFontFamily,
                                    validate: this._validateStyle
                                }, bt)).diff && bt.localIdeographFontFamily === this._localIdeographFontFamily && this.style && le1 ? (this._diffStyle(le1, bt), this) : (this._localIdeographFontFamily = bt.localIdeographFontFamily, this._updateStyle(le1, bt));
                            }
                            setTransformRequest(le1) {
                                return this._requestManager.setTransformRequest(le1), this;
                            }
                            _getUIString(le1) {
                                const vt = this._locale[le1];
                                if (null == vt) throw new Error(`Missing UI string '${le1}'`);
                                return vt;
                            }
                            _updateStyle(le1, vt) {
                                var bt, ls;
                                if (vt.transformStyle && this.style && !this.style._loaded) return void this.style.once("style.load", ()=>this._updateStyle(le1, vt));
                                const ho = this.style && vt.transformStyle ? this.style.serialize() : void 0;
                                return this.style && (this.style.setEventedParent(null), this.style._remove(!le1)), le1 ? (this.style = new ki(this, vt || {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), "string" == typeof le1 ? this.style.loadURL(le1, vt, ho) : this.style.loadJSON(le1, vt, ho), this) : (null === (ls = null === (bt = this.style) || void 0 === bt ? void 0 : bt.projection) || void 0 === ls || ls.destroy(), delete this.style, this);
                            }
                            _lazyInitEmptyStyle() {
                                this.style || (this.style = new ki(this, {}), this.style.setEventedParent(this, {
                                    style: this.style
                                }), this.style.loadEmpty());
                            }
                            _diffStyle(le1, bt) {
                                if ("string" == typeof le1) {
                                    const ls = this._requestManager.transformRequest(le1, "Style");
                                    vt.j(ls, new AbortController).then((le1)=>{
                                        this._updateDiff(le1.data, bt);
                                    }).catch((le1)=>{
                                        le1 && this.fire(new vt.k(le1));
                                    });
                                } else "object" == typeof le1 && this._updateDiff(le1, bt);
                            }
                            _updateDiff(le1, bt) {
                                try {
                                    this.style.setState(le1, bt) && this._update(!0);
                                } catch (a) {
                                    vt.w(`Unable to perform style diff: ${a.message || a.error || a}.  Rebuilding the style from scratch.`), this._updateStyle(le1, bt);
                                }
                            }
                            getStyle() {
                                if (this.style) return this.style.serialize();
                            }
                            _getStyleAndImages() {
                                return this.style ? {
                                    style: this.style.serialize(),
                                    images: this.style.imageManager.cloneImages()
                                } : {
                                    style: null,
                                    images: {}
                                };
                            }
                            isStyleLoaded() {
                                return this.style ? this.style.loaded() : vt.w("There is no style added to the map.");
                            }
                            addSource(le1, vt) {
                                return this._lazyInitEmptyStyle(), this.style.addSource(le1, vt), this._update(!0);
                            }
                            isSourceLoaded(le1) {
                                const bt = this.style && this.style.tileManagers[le1];
                                if (void 0 !== bt) return bt.loaded();
                                this.fire(new vt.k(new Error(`There is no tile manager with ID '${le1}'`)));
                            }
                            setTerrain(le1) {
                                if (this.style._checkLoaded(), this._terrainDataCallback && this.style.off("data", this._terrainDataCallback), le1) {
                                    const bt = this.style.tileManagers[le1.source];
                                    if (!bt) throw new Error(`cannot load terrain, because there exists no source with ID: ${le1.source}`);
                                    null === this.terrain && bt.reload();
                                    for(const ls in this.style._layers){
                                        const bt = this.style._layers[ls];
                                        "hillshade" === bt.type && bt.source === le1.source && vt.w("You are using the same source for a hillshade layer and for 3D terrain. Please consider using two separate sources to improve rendering quality."), "color-relief" === bt.type && bt.source === le1.source && vt.w("You are using the same source for a color-relief layer and for 3D terrain. Please consider using two separate sources to improve rendering quality.");
                                    }
                                    this.terrain = new is(this.painter, bt, le1), this.painter.renderToTexture = new rs(this.painter, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._terrainDataCallback = (vt)=>{
                                        var bt;
                                        "style" === vt.dataType ? this.terrain.tileManager.freeRtt() : "source" === vt.dataType && vt.tile && (vt.sourceId !== le1.source || this._elevationFreeze || (this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))), "image" === (null === (bt = vt.source) || void 0 === bt ? void 0 : bt.type) ? this.terrain.tileManager.freeRtt() : this.terrain.tileManager.freeRtt(vt.tile.tileID));
                                    }, this.style.on("data", this._terrainDataCallback);
                                } else this.terrain && this.terrain.tileManager.destruct(), this.terrain = null, this.painter.renderToTexture && this.painter.renderToTexture.destruct(), this.painter.renderToTexture = null, this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0);
                                return this.fire(new vt.l("terrain", {
                                    terrain: le1
                                })), this;
                            }
                            getTerrain() {
                                var le1, vt;
                                return null !== (vt = null === (le1 = this.terrain) || void 0 === le1 ? void 0 : le1.options) && void 0 !== vt ? vt : null;
                            }
                            areTilesLoaded() {
                                const le1 = this.style && this.style.tileManagers;
                                for (const vt of Object.values(le1))if (!vt.areTilesLoaded()) return !1;
                                return !0;
                            }
                            removeSource(le1) {
                                return this.style.removeSource(le1), this._update(!0);
                            }
                            getSource(le1) {
                                return this.style.getSource(le1);
                            }
                            setSourceTileLodParams(le1, vt, bt) {
                                if (bt) {
                                    const ls = this.getSource(bt);
                                    if (!ls) throw new Error(`There is no source with ID "${bt}", cannot set LOD parameters`);
                                    ls.calculateTileZoom = Te(Math.max(1, le1), Math.max(1, vt));
                                } else for(const ls in this.style.tileManagers)this.style.tileManagers[ls].getSource().calculateTileZoom = Te(Math.max(1, le1), Math.max(1, vt));
                                return this._update(!0), this;
                            }
                            refreshTiles(le1, bt) {
                                const ls = this.style.tileManagers[le1];
                                if (!ls) throw new Error(`There is no tile manager with ID "${le1}", cannot refresh tile`);
                                void 0 === bt ? ls.reload(!0) : ls.refreshTiles(bt.map((le1)=>new vt.ac(le1.z, le1.x, le1.y)));
                            }
                            addImage(le1, bt, ls = {}) {
                                const { pixelRatio: ho = 1, sdf: Dl = !1, stretchX: sc, stretchY: uc, content: mc, textFitWidth: gc, textFitHeight: Ac } = ls;
                                if (this._lazyInitEmptyStyle(), !(bt instanceof HTMLImageElement || vt.b(bt))) {
                                    if (void 0 === bt.width || void 0 === bt.height) return this.fire(new vt.k(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                    {
                                        const { width: ls, height: Fl, data: Ec } = bt, kc = bt;
                                        return this.style.addImage(le1, {
                                            data: new vt.R({
                                                width: ls,
                                                height: Fl
                                            }, new Uint8Array(Ec)),
                                            pixelRatio: ho,
                                            stretchX: sc,
                                            stretchY: uc,
                                            content: mc,
                                            textFitWidth: gc,
                                            textFitHeight: Ac,
                                            sdf: Dl,
                                            version: 0,
                                            userImage: kc
                                        }), kc.onAdd && kc.onAdd(this, le1), this;
                                    }
                                }
                                {
                                    const { width: ls, height: Ec, data: kc } = Fl.getImageData(bt);
                                    this.style.addImage(le1, {
                                        data: new vt.R({
                                            width: ls,
                                            height: Ec
                                        }, kc),
                                        pixelRatio: ho,
                                        stretchX: sc,
                                        stretchY: uc,
                                        content: mc,
                                        textFitWidth: gc,
                                        textFitHeight: Ac,
                                        sdf: Dl,
                                        version: 0
                                    });
                                }
                            }
                            updateImage(le1, bt) {
                                const ls = this.style.getImage(le1);
                                if (!ls) return this.fire(new vt.k(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));
                                const ho = bt instanceof HTMLImageElement || vt.b(bt) ? Fl.getImageData(bt) : bt, { width: Dl, height: sc, data: uc } = ho;
                                if (void 0 === Dl || void 0 === sc) return this.fire(new vt.k(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));
                                if (Dl !== ls.data.width || sc !== ls.data.height) return this.fire(new vt.k(new Error("The width and height of the updated image must be that same as the previous version of the image")));
                                const mc = !(bt instanceof HTMLImageElement || vt.b(bt));
                                return ls.data.replace(uc, mc), this.style.updateImage(le1, ls), this;
                            }
                            getImage(le1) {
                                return this.style.getImage(le1);
                            }
                            hasImage(le1) {
                                return le1 ? !!this.style.getImage(le1) : (this.fire(new vt.k(new Error("Missing required image id"))), !1);
                            }
                            removeImage(le1) {
                                this.style.removeImage(le1);
                            }
                            loadImage(le1) {
                                return kc.getImage(this._requestManager.transformRequest(le1, "Image"), new AbortController);
                            }
                            listImages() {
                                return this.style.listImages();
                            }
                            addLayer(le1, vt) {
                                return this._lazyInitEmptyStyle(), this.style.addLayer(le1, vt), this._update(!0);
                            }
                            moveLayer(le1, vt) {
                                return this.style.moveLayer(le1, vt), this._update(!0);
                            }
                            removeLayer(le1) {
                                return this.style.removeLayer(le1), this._update(!0);
                            }
                            getLayer(le1) {
                                return this.style.getLayer(le1);
                            }
                            getLayersOrder() {
                                return this.style.getLayersOrder();
                            }
                            setLayerZoomRange(le1, vt, bt) {
                                return this.style.setLayerZoomRange(le1, vt, bt), this._update(!0);
                            }
                            setFilter(le1, vt, bt = {}) {
                                return this.style.setFilter(le1, vt, bt), this._update(!0);
                            }
                            getFilter(le1) {
                                return this.style.getFilter(le1);
                            }
                            setPaintProperty(le1, vt, bt, ls = {}) {
                                return this.style.setPaintProperty(le1, vt, bt, ls), this._update(!0);
                            }
                            getPaintProperty(le1, vt) {
                                return this.style.getPaintProperty(le1, vt);
                            }
                            setLayoutProperty(le1, vt, bt, ls = {}) {
                                return this.style.setLayoutProperty(le1, vt, bt, ls), this._update(!0);
                            }
                            getLayoutProperty(le1, vt) {
                                return this.style.getLayoutProperty(le1, vt);
                            }
                            setGlyphs(le1, vt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setGlyphs(le1, vt), this._update(!0);
                            }
                            getGlyphs() {
                                return this.style.getGlyphsUrl();
                            }
                            addSprite(le1, vt, bt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.addSprite(le1, vt, bt, (le1)=>{
                                    le1 || this._update(!0);
                                }), this;
                            }
                            removeSprite(le1) {
                                return this._lazyInitEmptyStyle(), this.style.removeSprite(le1), this._update(!0);
                            }
                            getSprite() {
                                return this.style.getSprite();
                            }
                            setSprite(le1, vt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setSprite(le1, vt, (le1)=>{
                                    le1 || this._update(!0);
                                }), this;
                            }
                            setLight(le1, vt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setLight(le1, vt), this._update(!0);
                            }
                            getLight() {
                                return this.style.getLight();
                            }
                            setSky(le1, vt = {}) {
                                return this._lazyInitEmptyStyle(), this.style.setSky(le1, vt), this._update(!0);
                            }
                            getSky() {
                                return this.style.getSky();
                            }
                            setFeatureState(le1, vt) {
                                return this.style.setFeatureState(le1, vt), this._update();
                            }
                            removeFeatureState(le1, vt) {
                                return this.style.removeFeatureState(le1, vt), this._update();
                            }
                            getFeatureState(le1) {
                                return this.style.getFeatureState(le1);
                            }
                            getContainer() {
                                return this._container;
                            }
                            getCanvasContainer() {
                                return this._canvasContainer;
                            }
                            getCanvas() {
                                return this._canvas;
                            }
                            _containerDimensions() {
                                let le1 = 0, vt = 0;
                                return this._container && (le1 = this._container.clientWidth || 400, vt = this._container.clientHeight || 300), [
                                    le1,
                                    vt
                                ];
                            }
                            _setupResizeObserver() {
                                var le1;
                                let vt = !1;
                                const bt = $o((le1)=>{
                                    this._trackResize && !this._removed && (this.resize(le1), this.redraw());
                                }, 50), ls = null !== (le1 = this._ownerWindow.ResizeObserver) && void 0 !== le1 ? le1 : ResizeObserver;
                                this._resizeObserver = new ls((le1)=>{
                                    vt ? bt(le1) : vt = !0;
                                }), this._resizeObserver.observe(this._container);
                            }
                            _resolveContainer(le1) {
                                if ("string" == typeof le1) {
                                    const vt = document.getElementById(le1);
                                    if (!vt) throw new Error(`Container '${le1}' not found.`);
                                    return vt;
                                }
                                if (le1 instanceof HTMLElement) return le1;
                                if (le1 && "object" == typeof le1 && 1 === le1.nodeType) return le1;
                                throw new Error("Invalid type: 'container' must be a String or HTMLElement.");
                            }
                            _setupContainer() {
                                const le1 = this._container;
                                le1.classList.add("maplibregl-map");
                                const vt = this._canvasContainer = h.create("div", "maplibregl-canvas-container", le1);
                                this._interactive && vt.classList.add("maplibregl-interactive"), this._canvas = h.create("canvas", "maplibregl-canvas", vt), this._canvas.addEventListener("webglcontextlost", this._contextLost, !1), this._canvas.addEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.setAttribute("tabindex", this._interactive ? "0" : "-1"), this._canvas.setAttribute("aria-label", this._getUIString("Map.Title")), this._canvas.setAttribute("role", "region");
                                const bt = this._containerDimensions(), ls = this._getClampedPixelRatio(bt[0], bt[1]);
                                this._resizeCanvas(bt[0], bt[1], ls);
                                const ho = this._controlContainer = h.create("div", "maplibregl-control-container", le1), Dl = this._controlPositions = {};
                                [
                                    "top-left",
                                    "top-right",
                                    "bottom-left",
                                    "bottom-right"
                                ].forEach((le1)=>{
                                    Dl[le1] = h.create("div", `maplibregl-ctrl-${le1} `, ho);
                                }), this._container.addEventListener("scroll", this._onMapScroll, !1);
                            }
                            _resizeCanvas(le1, vt, bt) {
                                this._canvas.width = Math.floor(bt * le1), this._canvas.height = Math.floor(bt * vt), this._canvas.style.width = `${le1}px`, this._canvas.style.height = `${vt}px`;
                            }
                            _setupPainter() {
                                const le1 = Object.assign(Object.assign({}, this._canvasContextAttributes), {
                                    alpha: !0,
                                    depth: !0,
                                    stencil: !0,
                                    premultipliedAlpha: !0
                                });
                                let vt = null;
                                this._canvas.addEventListener("webglcontextcreationerror", (bt)=>{
                                    vt = {
                                        requestedAttributes: le1
                                    }, bt && (vt.statusMessage = bt.statusMessage, vt.type = bt.type);
                                }, {
                                    once: !0
                                });
                                let bt = null;
                                if (bt = this._canvasContextAttributes.contextType ? this._canvas.getContext(this._canvasContextAttributes.contextType, le1) : this._canvas.getContext("webgl2", le1) || this._canvas.getContext("webgl", le1), !bt) {
                                    const le1 = "Failed to initialize WebGL";
                                    throw vt ? (vt.message = le1, new Error(JSON.stringify(vt))) : new Error(le1);
                                }
                                this.painter = new Wo(bt, this.transform), uc.testSupport(bt);
                            }
                            migrateProjection(le1, bt) {
                                super.migrateProjection(le1, bt), this.painter.transform = le1, this.fire(new vt.l("projectiontransition", {
                                    newProjection: this.style.projection.name
                                }));
                            }
                            loaded() {
                                return !this._styleDirty && !this._sourcesDirty && !!this.style && this.style.loaded();
                            }
                            _update(le1) {
                                return this.style && this.style._loaded ? (this._styleDirty = this._styleDirty || le1, this._sourcesDirty = !0, this.triggerRepaint(), this) : this;
                            }
                            _requestRenderFrame(le1) {
                                return this._update(), this._renderTaskQueue.add(le1);
                            }
                            _cancelRenderFrame(le1) {
                                this._renderTaskQueue.remove(le1);
                            }
                            _render(le1) {
                                var bt, ls, ho, Dl, Fl;
                                const sc = this._idleTriggered ? this._fadeDuration : 0, uc = (null === (bt = this.style.projection) || void 0 === bt ? void 0 : bt.transitionState) > 0;
                                if (this.painter.context.setDirty(), this.painter.setBaseState(), this._renderTaskQueue.run(le1), this._removed) return;
                                let mc = !1;
                                if (this.style && this._styleDirty) {
                                    this._styleDirty = !1;
                                    const le1 = this.transform.zoom, bt = c();
                                    this.style.zoomHistory.update(le1, bt);
                                    const ls = new vt.H(le1, {
                                        now: bt,
                                        fadeDuration: sc,
                                        zoomHistory: this.style.zoomHistory,
                                        transition: this.style.getTransition()
                                    }), ho = ls.crossFadingFactor();
                                    1 === ho && ho === this._crossFadingFactor || (mc = !0, this._crossFadingFactor = ho), this.style.update(ls);
                                }
                                const gc = (null === (ls = this.style.projection) || void 0 === ls ? void 0 : ls.transitionState) > 0 !== uc;
                                null === (ho = this.style.projection) || void 0 === ho || ho.setErrorQueryLatitudeDegrees(this.transform.center.lat), this.transform.setTransitionState(null === (Dl = this.style.projection) || void 0 === Dl ? void 0 : Dl.transitionState, null === (Fl = this.style.projection) || void 0 === Fl ? void 0 : Fl.latitudeErrorCorrectionRadians), this.style && (this._sourcesDirty || gc) && (this._sourcesDirty = !1, this.style._updateSources(this.transform)), this.terrain ? (this.terrain.tileManager.update(this.transform, this.terrain), this.transform.setMinElevationForCurrentTile(this.terrain.getMinTileElevationForLngLatZoom(this.transform.center, this.transform.tileZoom)), !this._elevationFreeze && this._centerClampedToGround && this.transform.setElevation(this.terrain.getElevationForLngLatZoom(this.transform.center, this.transform.tileZoom))) : (this.transform.setMinElevationForCurrentTile(0), this._centerClampedToGround && this.transform.setElevation(0)), this._placementDirty = this.style && this.style._updatePlacement(this.transform, this.showCollisionBoxes, sc, this._crossSourceCollisions, gc), this.painter.render(this.style, {
                                    showTileBoundaries: this.showTileBoundaries,
                                    showOverdrawInspector: this._showOverdrawInspector,
                                    rotating: this.isRotating(),
                                    zooming: this.isZooming(),
                                    moving: this.isMoving(),
                                    fadeDuration: sc,
                                    showPadding: this.showPadding
                                }), this.fire(new vt.l("render")), this.loaded() && !this._loaded && (this._loaded = !0, vt.cH.mark(vt.cI.load), this.fire(new vt.l("load"))), this.style && (this.style.hasTransitions() || mc) && (this._styleDirty = !0), this.style && !this._placementDirty && this.style._releaseSymbolFadeTiles();
                                const Ac = this._sourcesDirty || this._styleDirty || this._placementDirty;
                                return Ac || this._repaint ? this.triggerRepaint() : !this.isMoving() && this.loaded() && this.fire(new vt.l("idle")), !this._loaded || this._fullyLoaded || Ac || (this._fullyLoaded = !0, vt.cH.mark(vt.cI.fullLoad)), this;
                            }
                            redraw() {
                                return this.style && (this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._render(0)), this;
                            }
                            remove() {
                                var le1;
                                this._hash && this._hash.remove();
                                for (const vt of this._controls)vt.onRemove(this);
                                this._controls = [], this._frameRequest && (this._frameRequest.abort(), this._frameRequest = null), this._renderTaskQueue.clear(), this.painter.destroy(), this.handlers.destroy(), delete this.handlers, this.setStyle(null), "undefined" != typeof window && this._ownerWindow.removeEventListener("online", this._onWindowOnline, !1), kc.removeThrottleControl(this._imageQueueHandle), null === (le1 = this._resizeObserver) || void 0 === le1 || le1.disconnect();
                                const bt = this.painter.context.gl.getExtension("WEBGL_lose_context");
                                (null == bt ? void 0 : bt.loseContext) && bt.loseContext(), this._canvas.removeEventListener("webglcontextrestored", this._contextRestored, !1), this._canvas.removeEventListener("webglcontextlost", this._contextLost, !1), h.remove(this._canvasContainer), h.remove(this._controlContainer), this._container.removeEventListener("scroll", this._onMapScroll, !1), this._container.classList.remove("maplibregl-map"), vt.cH.clearMetrics(), this._removed = !0, this.fire(new vt.l("remove"));
                            }
                            triggerRepaint() {
                                this.style && !this._frameRequest && (this._frameRequest = new AbortController, Fl.frame(this._frameRequest, (le1)=>{
                                    vt.cH.frame(le1), this._frameRequest = null;
                                    try {
                                        this._render(le1);
                                    } catch (le1) {
                                        if (!vt.Z(le1) && !function(le1) {
                                            return le1.message === bm;
                                        }(le1)) throw le1;
                                    }
                                }, ()=>{}, this._ownerWindow));
                            }
                            get showTileBoundaries() {
                                return !!this._showTileBoundaries;
                            }
                            set showTileBoundaries(le1) {
                                this._showTileBoundaries !== le1 && (this._showTileBoundaries = le1, this._update());
                            }
                            get showPadding() {
                                return !!this._showPadding;
                            }
                            set showPadding(le1) {
                                this._showPadding !== le1 && (this._showPadding = le1, this._update());
                            }
                            get showCollisionBoxes() {
                                return !!this._showCollisionBoxes;
                            }
                            set showCollisionBoxes(le1) {
                                this._showCollisionBoxes !== le1 && (this._showCollisionBoxes = le1, le1 ? this.style._generateCollisionBoxes() : this._update());
                            }
                            get showOverdrawInspector() {
                                return !!this._showOverdrawInspector;
                            }
                            set showOverdrawInspector(le1) {
                                this._showOverdrawInspector !== le1 && (this._showOverdrawInspector = le1, this._update());
                            }
                            get repaint() {
                                return !!this._repaint;
                            }
                            set repaint(le1) {
                                this._repaint !== le1 && (this._repaint = le1, this.triggerRepaint());
                            }
                            get vertices() {
                                return !!this._vertices;
                            }
                            set vertices(le1) {
                                this._vertices = le1, this._update();
                            }
                            get version() {
                                return Zm;
                            }
                            getCameraTargetElevation() {
                                return this.transform.elevation;
                            }
                            getProjection() {
                                return this.style.getProjection();
                            }
                            setProjection(le1) {
                                return this._lazyInitEmptyStyle(), this.style.setProjection(le1), this._update(!0);
                            }
                        }, le1.MapMouseEvent = or, le1.MapTouchEvent = rr, le1.MapWheelEvent = sr, le1.Marker = ms, le1.NavigationControl = class {
                            constructor(le1){
                                this._updateZoomButtons = ()=>{
                                    const le1 = this._map.getZoom(), vt = le1 === this._map.getMaxZoom(), bt = le1 === this._map.getMinZoom();
                                    this._zoomInButton.disabled = vt, this._zoomOutButton.disabled = bt, this._zoomInButton.setAttribute("aria-disabled", vt.toString()), this._zoomOutButton.setAttribute("aria-disabled", bt.toString());
                                }, this._rotateCompassArrow = ()=>{
                                    this._compassIcon.style.transform = this.options.visualizePitch && this.options.visualizeRoll ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateZ(${-this._map.transform.roll}deg) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizePitch ? `scale(${1 / Math.pow(Math.cos(this._map.transform.pitchInRadians), .5)}) rotateX(${this._map.transform.pitch}deg) rotateZ(${-this._map.transform.bearing}deg)` : this.options.visualizeRoll ? `rotate(${-this._map.transform.bearing - this._map.transform.roll}deg)` : `rotate(${-this._map.transform.bearing}deg)`;
                                }, this._setButtonTitle = (le1, vt)=>{
                                    const bt = this._map._getUIString(`NavigationControl.${vt}`);
                                    le1.title = bt, le1.setAttribute("aria-label", bt);
                                }, this.options = vt.e({}, Qm, le1), this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._container.addEventListener("contextmenu", (le1)=>le1.preventDefault()), this.options.showZoom && (this._zoomInButton = this._createButton("maplibregl-ctrl-zoom-in", (le1)=>this._map.zoomIn({}, {
                                        originalEvent: le1
                                    })), h.create("span", "maplibregl-ctrl-icon", this._zoomInButton).setAttribute("aria-hidden", "true"), this._zoomOutButton = this._createButton("maplibregl-ctrl-zoom-out", (le1)=>this._map.zoomOut({}, {
                                        originalEvent: le1
                                    })), h.create("span", "maplibregl-ctrl-icon", this._zoomOutButton).setAttribute("aria-hidden", "true")), this.options.showCompass && (this._compass = this._createButton("maplibregl-ctrl-compass", (le1)=>{
                                    this.options.visualizePitch ? this._map.resetNorthPitch({}, {
                                        originalEvent: le1
                                    }) : this._map.resetNorth({}, {
                                        originalEvent: le1
                                    });
                                }), this._compassIcon = h.create("span", "maplibregl-ctrl-icon", this._compass), this._compassIcon.setAttribute("aria-hidden", "true"));
                            }
                            onAdd(le1) {
                                return this._map = le1, this.options.showZoom && (this._setButtonTitle(this._zoomInButton, "ZoomIn"), this._setButtonTitle(this._zoomOutButton, "ZoomOut"), this._map.on("zoom", this._updateZoomButtons), this._updateZoomButtons()), this.options.showCompass && (this._setButtonTitle(this._compass, "ResetBearing"), this.options.visualizePitch && this._map.on("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.on("roll", this._rotateCompassArrow), this._map.on("rotate", this._rotateCompassArrow), this._rotateCompassArrow(), this._handler = new hs(this._map, this._compass, this.options.visualizePitch)), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this.options.showZoom && this._map.off("zoom", this._updateZoomButtons), this.options.showCompass && (this.options.visualizePitch && this._map.off("pitch", this._rotateCompassArrow), this.options.visualizeRoll && this._map.off("roll", this._rotateCompassArrow), this._map.off("rotate", this._rotateCompassArrow), this._handler.off(), delete this._handler), delete this._map;
                            }
                            _createButton(le1, vt) {
                                const bt = h.create("button", le1, this._container);
                                return bt.type = "button", bt.addEventListener("click", vt), bt;
                            }
                        }, le1.Popup = class extends vt.E {
                            constructor(le1){
                                super(), this._updateOpacity = ()=>{
                                    void 0 !== this.options.locationOccludedOpacity && (this._container.style.opacity = this._map.transform.isLocationOccluded(this.getLngLat()) ? `${this.options.locationOccludedOpacity}` : "");
                                }, this.remove = ()=>(this._content && h.remove(this._content), this._container && (h.remove(this._container), delete this._container), this._map && (this._map.off("move", this._update), this._map.off("move", this._onClose), this._map.off("click", this._onClose), this._map.off("remove", this.remove), this._map.off("mousemove", this._onMouseMove), this._map.off("mouseup", this._onMouseUp), this._map.off("drag", this._onDrag), this._map._canvasContainer.classList.remove("maplibregl-track-pointer"), delete this._map, this.fire(new vt.l("close"))), this), this._onMouseUp = (le1)=>{
                                    this._update(le1.point);
                                }, this._onMouseMove = (le1)=>{
                                    this._update(le1.point);
                                }, this._onDrag = (le1)=>{
                                    this._update(le1.point);
                                }, this._update = (le1)=>{
                                    if (!this._map || !this._lngLat && !this._trackPointer || !this._content) return;
                                    if (!this._container) {
                                        if (this._container = h.create("div", "maplibregl-popup", this._map.getContainer()), this._tip = h.create("div", "maplibregl-popup-tip", this._container), this._container.appendChild(this._content), this.options.className) for (const le1 of this.options.className.split(" "))this._container.classList.add(le1);
                                        this._closeButton && this._closeButton.setAttribute("aria-label", this._map._getUIString("Popup.Close")), this._trackPointer && this._container.classList.add("maplibregl-popup-track-pointer");
                                    }
                                    if (this.options.maxWidth && this._container.style.maxWidth !== this.options.maxWidth && (this._container.style.maxWidth = this.options.maxWidth), this._lngLat = ds(this._lngLat, this._flatPos, this._map.transform, this._trackPointer), this._trackPointer && !le1) return;
                                    const vt = this._flatPos = this._pos = this._trackPointer && le1 ? le1 : this._map.project(this._lngLat);
                                    this._map.terrain && (this._flatPos = this._trackPointer && le1 ? le1 : this._map.transform.locationToScreenPoint(this._lngLat));
                                    let bt = this.options.anchor;
                                    const ls = Ps(this.options.offset);
                                    if (!bt) {
                                        const le1 = this._container.offsetWidth, ho = this._container.offsetHeight, Dl = function(le1) {
                                            var vt, bt, ls, ho;
                                            return le1 ? {
                                                top: null !== (vt = le1.top) && void 0 !== vt ? vt : 0,
                                                right: null !== (bt = le1.right) && void 0 !== bt ? bt : 0,
                                                bottom: null !== (ls = le1.bottom) && void 0 !== ls ? ls : 0,
                                                left: null !== (ho = le1.left) && void 0 !== ho ? ho : 0
                                            } : {
                                                top: 0,
                                                right: 0,
                                                bottom: 0,
                                                left: 0
                                            };
                                        }(this.options.padding);
                                        let Fl;
                                        Fl = vt.y + ls.bottom.y < ho + Dl.top ? [
                                            "top"
                                        ] : vt.y > this._map.transform.height - ho - Dl.bottom ? [
                                            "bottom"
                                        ] : [], vt.x < le1 / 2 + Dl.left ? Fl.push("left") : vt.x > this._map.transform.width - le1 / 2 - Dl.right && Fl.push("right"), bt = 0 === Fl.length ? "bottom" : Fl.join("-");
                                    }
                                    let ho = vt.add(ls[bt]);
                                    this.options.subpixelPositioning || (ho = ho.round()), h.setTransform(this._container, `${Km[bt]} translate(${ho.x}px,${ho.y}px)`), ps(this._container, bt, "popup"), this._updateOpacity();
                                }, this._onClose = ()=>{
                                    this.remove();
                                }, this.options = vt.e(Object.create(ig), le1);
                            }
                            addTo(le1) {
                                return this._map && this.remove(), this._map = le1, this.options.closeOnClick && this._map.on("click", this._onClose), this.options.closeOnMove && this._map.on("move", this._onClose), this._map.on("remove", this.remove), this._update(), this._focusFirstElement(), this._trackPointer ? (this._map.on("mousemove", this._onMouseMove), this._map.on("mouseup", this._onMouseUp), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")) : this._map.on("move", this._update), this.fire(new vt.l("open")), this;
                            }
                            isOpen() {
                                return !!this._map;
                            }
                            getLngLat() {
                                return this._lngLat;
                            }
                            setLngLat(le1) {
                                return this._lngLat = vt.V.convert(le1), this._pos = null, this._flatPos = null, this._trackPointer = !1, this._update(), this._map && (this._map.on("move", this._update), this._map.off("mousemove", this._onMouseMove), this._container && this._container.classList.remove("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.remove("maplibregl-track-pointer")), this;
                            }
                            trackPointer() {
                                return this._trackPointer = !0, this._pos = null, this._flatPos = null, this._update(), this._map && (this._map.off("move", this._update), this._map.on("mousemove", this._onMouseMove), this._map.on("drag", this._onDrag), this._container && this._container.classList.add("maplibregl-popup-track-pointer"), this._map._canvasContainer.classList.add("maplibregl-track-pointer")), this;
                            }
                            getElement() {
                                return this._container;
                            }
                            setText(le1) {
                                return this.setDOMContent(document.createTextNode(le1));
                            }
                            setHTML(le1) {
                                const vt = document.createDocumentFragment(), bt = document.createElement("body");
                                let ls;
                                for(bt.innerHTML = le1; ls = bt.firstChild, ls;)vt.appendChild(ls);
                                return this.setDOMContent(vt);
                            }
                            getMaxWidth() {
                                var le1;
                                return null === (le1 = this._container) || void 0 === le1 ? void 0 : le1.style.maxWidth;
                            }
                            setMaxWidth(le1) {
                                return this.options.maxWidth = le1, this._update(), this;
                            }
                            setDOMContent(le1) {
                                if (this._content) for(; this._content.hasChildNodes();)this._content.firstChild && this._content.removeChild(this._content.firstChild);
                                else this._content = h.create("div", "maplibregl-popup-content", this._container);
                                return this._content.appendChild(le1), this._createCloseButton(), this._update(), this._focusFirstElement(), this;
                            }
                            addClassName(le1) {
                                return this._container && this._container.classList.add(le1), this;
                            }
                            removeClassName(le1) {
                                return this._container && this._container.classList.remove(le1), this;
                            }
                            setOffset(le1) {
                                return this.options.offset = le1, this._update(), this;
                            }
                            toggleClassName(le1) {
                                if (this._container) return this._container.classList.toggle(le1);
                            }
                            setSubpixelPositioning(le1) {
                                this.options.subpixelPositioning = le1;
                            }
                            setPadding(le1) {
                                this.options.padding = le1, this._update();
                            }
                            _createCloseButton() {
                                this.options.closeButton && (this._closeButton = h.create("button", "maplibregl-popup-close-button", this._content), this._closeButton.type = "button", this._closeButton.innerHTML = "&#215;", this._closeButton.addEventListener("click", this._onClose));
                            }
                            _focusFirstElement() {
                                if (!this.options.focusAfterOpen || !this._container) return;
                                const le1 = this._container.querySelector(ng);
                                le1 && le1.focus();
                            }
                        }, le1.RasterDEMTileSource = Y, le1.RasterTileSource = K, le1.ScaleControl = class {
                            constructor(le1){
                                this._onMove = ()=>{
                                    bs(this._map, this._container, this.options);
                                }, this.setUnit = (le1)=>{
                                    this.options.unit = le1, bs(this._map, this._container, this.options);
                                }, this.options = Object.assign(Object.assign({}, tg), le1);
                            }
                            getDefaultPosition() {
                                return "bottom-left";
                            }
                            onAdd(le1) {
                                return this._map = le1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-scale", le1.getContainer()), this._map.on("move", this._onMove), this._onMove(), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this._map.off("move", this._onMove), this._map = void 0;
                            }
                        }, le1.ScrollZoomHandler = Br, le1.Style = ki, le1.TerrainControl = class {
                            constructor(le1){
                                this._toggleTerrain = ()=>{
                                    this._map.getTerrain() ? this._map.setTerrain(null) : this._map.setTerrain(this.options), this._updateTerrainIcon();
                                }, this._updateTerrainIcon = ()=>{
                                    this._terrainButton.classList.remove("maplibregl-ctrl-terrain"), this._terrainButton.classList.remove("maplibregl-ctrl-terrain-enabled"), this._map.terrain ? (this._terrainButton.classList.add("maplibregl-ctrl-terrain-enabled"), this._terrainButton.title = this._map._getUIString("TerrainControl.Disable")) : (this._terrainButton.classList.add("maplibregl-ctrl-terrain"), this._terrainButton.title = this._map._getUIString("TerrainControl.Enable"));
                                }, this.options = le1;
                            }
                            onAdd(le1) {
                                return this._map = le1, this._container = h.create("div", "maplibregl-ctrl maplibregl-ctrl-group"), this._terrainButton = h.create("button", "maplibregl-ctrl-terrain", this._container), h.create("span", "maplibregl-ctrl-icon", this._terrainButton).setAttribute("aria-hidden", "true"), this._terrainButton.type = "button", this._terrainButton.addEventListener("click", this._toggleTerrain), this._updateTerrainIcon(), this._map.on("terrain", this._updateTerrainIcon), this._container;
                            }
                            onRemove() {
                                h.remove(this._container), this._map.off("terrain", this._updateTerrainIcon), this._map = void 0;
                            }
                        }, le1.TwoFingersTouchPitchHandler = Rr, le1.TwoFingersTouchRotateHandler = Sr, le1.TwoFingersTouchZoomHandler = Mr, le1.TwoFingersTouchZoomRotateHandler = Gr, le1.VectorTileSource = X, le1.VideoSource = ie, le1.addSourceType = (le1, bt)=>vt._(void 0, void 0, void 0, function*() {
                                if (re(le1)) throw new Error(`A source type called "${le1}" already exists.`);
                                ((le1, vt)=>{
                                    Ud[le1] = vt;
                                })(le1, bt);
                            }), le1.clearPrewarmedResources = function() {
                            const le1 = Od;
                            le1 && (le1.isPreloaded() && 1 === le1.numActive() ? (le1.release(Nd), Od = null) : console.warn("Could not clear WebWorkers since there are active Map instances that still reference it. The pre-warmed WebWorker pool can only be cleared when all map instances have been removed with map.remove()"));
                        }, le1.createTileMesh = li, le1.getMaxParallelImageRequests = function() {
                            return vt.c.MAX_PARALLEL_IMAGE_REQUESTS;
                        }, le1.getRTLTextPluginStatus = function() {
                            return ce().getRTLTextPluginStatus();
                        }, le1.getVersion = function() {
                            return rg;
                        }, le1.getWorkerCount = function() {
                            return k.workerCount;
                        }, le1.getWorkerUrl = function() {
                            return vt.c.WORKER_URL;
                        }, le1.importScriptInWorkers = function(le1) {
                            return Z().broadcast("IS", le1);
                        }, le1.isTimeFrozen = function() {
                            return sc.isFrozen();
                        }, le1.now = c, le1.prewarm = function() {
                            j().acquire(Nd);
                        }, le1.restoreNow = function() {
                            sc.restoreNow();
                        }, le1.setMaxParallelImageRequests = function(le1) {
                            vt.c.MAX_PARALLEL_IMAGE_REQUESTS = le1;
                        }, le1.setNow = function(le1) {
                            sc.setNow(le1);
                        }, le1.setRTLTextPlugin = function(le1, vt) {
                            return ce().setRTLTextPlugin(le1, vt);
                        }, le1.setWorkerCount = function(le1) {
                            k.workerCount = le1;
                        }, le1.setWorkerUrl = function(le1) {
                            vt.c.WORKER_URL = le1;
                        };
                    }), le1;
                }();
            },
            3710: (le1, vt, bt)=>{
                "use strict";
                /*!
 * Font Awesome Free 6.7.2 by @fontawesome - https://fontawesome.com
 * License - https://fontawesome.com/license/free (Icons: CC BY 4.0, Fonts: SIL OFL 1.1, Code: MIT License)
 * Copyright 2024 Fonticons, Inc.
 */ function _defineProperty(le1, vt, bt) {
                    return (vt = function(le1) {
                        var vt = function(le1, vt) {
                            if ("object" != typeof le1 || !le1) return le1;
                            var bt = le1[Symbol.toPrimitive];
                            if (void 0 !== bt) {
                                var ls = bt.call(le1, vt || "default");
                                if ("object" != typeof ls) return ls;
                                throw new TypeError("@@toPrimitive must return a primitive value.");
                            }
                            return ("string" === vt ? String : Number)(le1);
                        }(le1, "string");
                        return "symbol" == typeof vt ? vt : vt + "";
                    }(vt)) in le1 ? Object.defineProperty(le1, vt, {
                        value: bt,
                        enumerable: !0,
                        configurable: !0,
                        writable: !0
                    }) : le1[vt] = bt, le1;
                }
                function ownKeys(le1, vt) {
                    var bt = Object.keys(le1);
                    if (Object.getOwnPropertySymbols) {
                        var ls = Object.getOwnPropertySymbols(le1);
                        vt && (ls = ls.filter(function(vt) {
                            return Object.getOwnPropertyDescriptor(le1, vt).enumerable;
                        })), bt.push.apply(bt, ls);
                    }
                    return bt;
                }
                function _objectSpread2(le1) {
                    for(var vt = 1; vt < arguments.length; vt++){
                        var bt = null != arguments[vt] ? arguments[vt] : {};
                        vt % 2 ? ownKeys(Object(bt), !0).forEach(function(vt) {
                            _defineProperty(le1, vt, bt[vt]);
                        }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(le1, Object.getOwnPropertyDescriptors(bt)) : ownKeys(Object(bt)).forEach(function(vt) {
                            Object.defineProperty(le1, vt, Object.getOwnPropertyDescriptor(bt, vt));
                        });
                    }
                    return le1;
                }
                bt.d(vt, {
                    Kk: ()=>Mg
                });
                const noop = ()=>{};
                let ls = {}, ho = {}, Dl = null, Fl = {
                    mark: noop,
                    measure: noop
                };
                try {
                    "undefined" !== typeof window && (ls = window), "undefined" !== typeof document && (ho = document), "undefined" !== typeof MutationObserver && (Dl = MutationObserver), "undefined" !== typeof performance && (Fl = performance);
                } catch (Sg) {}
                const { userAgent: sc = "" } = ls.navigator || {}, uc = ls, mc = ho, gc = Dl, Ac = Fl, Ec = (uc.document, !!mc.documentElement && !!mc.head && "function" === typeof mc.addEventListener && "function" === typeof mc.createElement), kc = ~sc.indexOf("MSIE") || ~sc.indexOf("Trident/");
                var du = {
                    classic: {
                        fa: "solid",
                        fas: "solid",
                        "fa-solid": "solid",
                        far: "regular",
                        "fa-regular": "regular",
                        fal: "light",
                        "fa-light": "light",
                        fat: "thin",
                        "fa-thin": "thin",
                        fab: "brands",
                        "fa-brands": "brands"
                    },
                    duotone: {
                        fa: "solid",
                        fad: "solid",
                        "fa-solid": "solid",
                        "fa-duotone": "solid",
                        fadr: "regular",
                        "fa-regular": "regular",
                        fadl: "light",
                        "fa-light": "light",
                        fadt: "thin",
                        "fa-thin": "thin"
                    },
                    sharp: {
                        fa: "solid",
                        fass: "solid",
                        "fa-solid": "solid",
                        fasr: "regular",
                        "fa-regular": "regular",
                        fasl: "light",
                        "fa-light": "light",
                        fast: "thin",
                        "fa-thin": "thin"
                    },
                    "sharp-duotone": {
                        fa: "solid",
                        fasds: "solid",
                        "fa-solid": "solid",
                        fasdr: "regular",
                        "fa-regular": "regular",
                        fasdl: "light",
                        "fa-light": "light",
                        fasdt: "thin",
                        "fa-thin": "thin"
                    }
                }, _u = [
                    "fa-classic",
                    "fa-duotone",
                    "fa-sharp",
                    "fa-sharp-duotone"
                ], Md = "classic", Ld = "duotone", Nd = [
                    Md,
                    Ld,
                    "sharp",
                    "sharp-duotone"
                ], Rd = new Map([
                    [
                        "classic",
                        {
                            defaultShortPrefixId: "fas",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin",
                                "brands"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "sharp",
                        {
                            defaultShortPrefixId: "fass",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "duotone",
                        {
                            defaultShortPrefixId: "fad",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ],
                    [
                        "sharp-duotone",
                        {
                            defaultShortPrefixId: "fasds",
                            defaultStyleId: "solid",
                            styleIds: [
                                "solid",
                                "regular",
                                "light",
                                "thin"
                            ],
                            futureStyleIds: [],
                            defaultFontWeight: 900
                        }
                    ]
                ]), Od = [
                    "fak",
                    "fa-kit",
                    "fakd",
                    "fa-kit-duotone"
                ], jd = {
                    fak: "kit",
                    "fa-kit": "kit"
                }, Ud = {
                    fakd: "kit-duotone",
                    "fa-kit-duotone": "kit-duotone"
                }, Gd = [
                    "fak",
                    "fakd"
                ], qd = {
                    kit: "fak"
                }, Hd = {
                    "kit-duotone": "fakd"
                }, Wd = {
                    GROUP: "duotone-group",
                    SWAP_OPACITY: "swap-opacity",
                    PRIMARY: "primary",
                    SECONDARY: "secondary"
                }, Zd = [
                    "fak",
                    "fa-kit",
                    "fakd",
                    "fa-kit-duotone"
                ], Yd = {
                    classic: {
                        fab: "fa-brands",
                        fad: "fa-duotone",
                        fal: "fa-light",
                        far: "fa-regular",
                        fas: "fa-solid",
                        fat: "fa-thin"
                    },
                    duotone: {
                        fadr: "fa-regular",
                        fadl: "fa-light",
                        fadt: "fa-thin"
                    },
                    sharp: {
                        fass: "fa-solid",
                        fasr: "fa-regular",
                        fasl: "fa-light",
                        fast: "fa-thin"
                    },
                    "sharp-duotone": {
                        fasds: "fa-solid",
                        fasdr: "fa-regular",
                        fasdl: "fa-light",
                        fasdt: "fa-thin"
                    }
                }, Qd = [
                    "fa",
                    "fas",
                    "far",
                    "fal",
                    "fat",
                    "fad",
                    "fadr",
                    "fadl",
                    "fadt",
                    "fab",
                    "fass",
                    "fasr",
                    "fasl",
                    "fast",
                    "fasds",
                    "fasdr",
                    "fasdl",
                    "fasdt",
                    "fa-classic",
                    "fa-duotone",
                    "fa-sharp",
                    "fa-sharp-duotone",
                    "fa-solid",
                    "fa-regular",
                    "fa-light",
                    "fa-thin",
                    "fa-duotone",
                    "fa-brands"
                ], Xd = [
                    1,
                    2,
                    3,
                    4,
                    5,
                    6,
                    7,
                    8,
                    9,
                    10
                ], Kd = Xd.concat([
                    11,
                    12,
                    13,
                    14,
                    15,
                    16,
                    17,
                    18,
                    19,
                    20
                ]), Jd = [
                    ...Object.keys({
                        classic: [
                            "fas",
                            "far",
                            "fal",
                            "fat",
                            "fad"
                        ],
                        duotone: [
                            "fadr",
                            "fadl",
                            "fadt"
                        ],
                        sharp: [
                            "fass",
                            "fasr",
                            "fasl",
                            "fast"
                        ],
                        "sharp-duotone": [
                            "fasds",
                            "fasdr",
                            "fasdl",
                            "fasdt"
                        ]
                    }),
                    "solid",
                    "regular",
                    "light",
                    "thin",
                    "duotone",
                    "brands",
                    "2xs",
                    "xs",
                    "sm",
                    "lg",
                    "xl",
                    "2xl",
                    "beat",
                    "border",
                    "fade",
                    "beat-fade",
                    "bounce",
                    "flip-both",
                    "flip-horizontal",
                    "flip-vertical",
                    "flip",
                    "fw",
                    "inverse",
                    "layers-counter",
                    "layers-text",
                    "layers",
                    "li",
                    "pull-left",
                    "pull-right",
                    "pulse",
                    "rotate-180",
                    "rotate-270",
                    "rotate-90",
                    "rotate-by",
                    "shake",
                    "spin-pulse",
                    "spin-reverse",
                    "spin",
                    "stack-1x",
                    "stack-2x",
                    "stack",
                    "ul",
                    Wd.GROUP,
                    Wd.SWAP_OPACITY,
                    Wd.PRIMARY,
                    Wd.SECONDARY
                ].concat(Xd.map((le1)=>"".concat(le1, "x"))).concat(Kd.map((le1)=>"w-".concat(le1)));
                const $d = "___FONT_AWESOME___", sp = 16, em = "svg-inline--fa", tm = "data-fa-i2svg", im = "data-fa-pseudo-element", nm = "data-prefix", rm = "data-icon", am = "fontawesome-i2svg", sm = [
                    "HTML",
                    "HEAD",
                    "STYLE",
                    "SCRIPT"
                ], om = (()=>{
                    try {
                        return !0;
                    } catch (le1) {
                        return !1;
                    }
                })();
                function familyProxy(le1) {
                    return new Proxy(le1, {
                        get: (le1, vt)=>vt in le1 ? le1[vt] : le1[Md]
                    });
                }
                const lm = _objectSpread2({}, du);
                lm[Md] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    "fa-duotone": "duotone"
                }), du[Md]), jd), Ud);
                const cm = familyProxy(lm), um = _objectSpread2({}, {
                    classic: {
                        solid: "fas",
                        regular: "far",
                        light: "fal",
                        thin: "fat",
                        brands: "fab"
                    },
                    duotone: {
                        solid: "fad",
                        regular: "fadr",
                        light: "fadl",
                        thin: "fadt"
                    },
                    sharp: {
                        solid: "fass",
                        regular: "fasr",
                        light: "fasl",
                        thin: "fast"
                    },
                    "sharp-duotone": {
                        solid: "fasds",
                        regular: "fasdr",
                        light: "fasdl",
                        thin: "fasdt"
                    }
                });
                um[Md] = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    duotone: "fad"
                }), um[Md]), qd), Hd);
                const hm = familyProxy(um), dm = _objectSpread2({}, Yd);
                dm[Md] = _objectSpread2(_objectSpread2({}, dm[Md]), {
                    fak: "fa-kit"
                });
                const pm = familyProxy(dm), mm = _objectSpread2({}, {
                    classic: {
                        "fa-brands": "fab",
                        "fa-duotone": "fad",
                        "fa-light": "fal",
                        "fa-regular": "far",
                        "fa-solid": "fas",
                        "fa-thin": "fat"
                    },
                    duotone: {
                        "fa-regular": "fadr",
                        "fa-light": "fadl",
                        "fa-thin": "fadt"
                    },
                    sharp: {
                        "fa-solid": "fass",
                        "fa-regular": "fasr",
                        "fa-light": "fasl",
                        "fa-thin": "fast"
                    },
                    "sharp-duotone": {
                        "fa-solid": "fasds",
                        "fa-regular": "fasdr",
                        "fa-light": "fasdl",
                        "fa-thin": "fasdt"
                    }
                });
                mm[Md] = _objectSpread2(_objectSpread2({}, mm[Md]), {
                    "fa-kit": "fak"
                });
                familyProxy(mm);
                const fm = /fa(s|r|l|t|d|dr|dl|dt|b|k|kd|ss|sr|sl|st|sds|sdr|sdl|sdt)?[\-\ ]/, gm = "fa-layers-text", Am = /Font ?Awesome ?([56 ]*)(Solid|Regular|Light|Thin|Duotone|Brands|Free|Pro|Sharp Duotone|Sharp|Kit)?.*/i, _m = (familyProxy(_objectSpread2({}, {
                    classic: {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal",
                        100: "fat"
                    },
                    duotone: {
                        900: "fad",
                        400: "fadr",
                        300: "fadl",
                        100: "fadt"
                    },
                    sharp: {
                        900: "fass",
                        400: "fasr",
                        300: "fasl",
                        100: "fast"
                    },
                    "sharp-duotone": {
                        900: "fasds",
                        400: "fasdr",
                        300: "fasdl",
                        100: "fasdt"
                    }
                })), [
                    "class",
                    "data-prefix",
                    "data-icon",
                    "data-fa-transform",
                    "data-fa-mask"
                ]), ym = {
                    GROUP: "duotone-group",
                    SWAP_OPACITY: "swap-opacity",
                    PRIMARY: "primary",
                    SECONDARY: "secondary"
                }, vm = [
                    "kit",
                    ...Jd
                ], xm = uc.FontAwesomeConfig || {};
                if (mc && "function" === typeof mc.querySelector) [
                    [
                        "data-family-prefix",
                        "familyPrefix"
                    ],
                    [
                        "data-css-prefix",
                        "cssPrefix"
                    ],
                    [
                        "data-family-default",
                        "familyDefault"
                    ],
                    [
                        "data-style-default",
                        "styleDefault"
                    ],
                    [
                        "data-replacement-class",
                        "replacementClass"
                    ],
                    [
                        "data-auto-replace-svg",
                        "autoReplaceSvg"
                    ],
                    [
                        "data-auto-add-css",
                        "autoAddCss"
                    ],
                    [
                        "data-auto-a11y",
                        "autoA11y"
                    ],
                    [
                        "data-search-pseudo-elements",
                        "searchPseudoElements"
                    ],
                    [
                        "data-observe-mutations",
                        "observeMutations"
                    ],
                    [
                        "data-mutate-approach",
                        "mutateApproach"
                    ],
                    [
                        "data-keep-original-source",
                        "keepOriginalSource"
                    ],
                    [
                        "data-measure-performance",
                        "measurePerformance"
                    ],
                    [
                        "data-show-missing-icons",
                        "showMissingIcons"
                    ]
                ].forEach((le1)=>{
                    let [vt, bt] = le1;
                    const ls = function(le1) {
                        return "" === le1 || "false" !== le1 && ("true" === le1 || le1);
                    }(function(le1) {
                        var vt = mc.querySelector("script[" + le1 + "]");
                        if (vt) return vt.getAttribute(le1);
                    }(vt));
                    void 0 !== ls && null !== ls && (xm[bt] = ls);
                });
                const bm = {
                    styleDefault: "solid",
                    familyDefault: Md,
                    cssPrefix: "fa",
                    replacementClass: em,
                    autoReplaceSvg: !0,
                    autoAddCss: !0,
                    autoA11y: !0,
                    searchPseudoElements: !1,
                    observeMutations: !0,
                    mutateApproach: "async",
                    keepOriginalSource: !0,
                    measurePerformance: !1,
                    showMissingIcons: !0
                };
                xm.familyPrefix && (xm.cssPrefix = xm.familyPrefix);
                const wm = _objectSpread2(_objectSpread2({}, bm), xm);
                wm.autoReplaceSvg || (wm.observeMutations = !1);
                const Em = {};
                Object.keys(bm).forEach((le1)=>{
                    Object.defineProperty(Em, le1, {
                        enumerable: !0,
                        set: function(vt) {
                            wm[le1] = vt, Mm.forEach((le1)=>le1(Em));
                        },
                        get: function() {
                            return wm[le1];
                        }
                    });
                }), Object.defineProperty(Em, "familyPrefix", {
                    enumerable: !0,
                    set: function(le1) {
                        wm.cssPrefix = le1, Mm.forEach((le1)=>le1(Em));
                    },
                    get: function() {
                        return wm.cssPrefix;
                    }
                }), uc.FontAwesomeConfig = Em;
                const Mm = [];
                const Sm = sp, Tm = {
                    size: 16,
                    x: 0,
                    y: 0,
                    rotate: 0,
                    flipX: !1,
                    flipY: !1
                };
                function nextUniqueId() {
                    let le1 = 12, vt = "";
                    for(; le1-- > 0;)vt += "0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[62 * Math.random() | 0];
                    return vt;
                }
                function toArray(le1) {
                    const vt = [];
                    for(let bt = (le1 || []).length >>> 0; bt--;)vt[bt] = le1[bt];
                    return vt;
                }
                function classArray(le1) {
                    return le1.classList ? toArray(le1.classList) : (le1.getAttribute("class") || "").split(" ").filter((le1)=>le1);
                }
                function htmlEscape(le1) {
                    return "".concat(le1).replace(/&/g, "&amp;").replace(/"/g, "&quot;").replace(/'/g, "&#39;").replace(/</g, "&lt;").replace(/>/g, "&gt;");
                }
                function joinStyles(le1) {
                    return Object.keys(le1 || {}).reduce((vt, bt)=>vt + "".concat(bt, ": ").concat(le1[bt].trim(), ";"), "");
                }
                function transformIsMeaningful(le1) {
                    return le1.size !== Tm.size || le1.x !== Tm.x || le1.y !== Tm.y || le1.rotate !== Tm.rotate || le1.flipX || le1.flipY;
                }
                function css() {
                    const le1 = "fa", vt = em, bt = Em.cssPrefix, ls = Em.replacementClass;
                    let ho = ':root, :host {\n  --fa-font-solid: normal 900 1em/1 "Font Awesome 6 Free";\n  --fa-font-regular: normal 400 1em/1 "Font Awesome 6 Free";\n  --fa-font-light: normal 300 1em/1 "Font Awesome 6 Pro";\n  --fa-font-thin: normal 100 1em/1 "Font Awesome 6 Pro";\n  --fa-font-duotone: normal 900 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-regular: normal 400 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-light: normal 300 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-duotone-thin: normal 100 1em/1 "Font Awesome 6 Duotone";\n  --fa-font-brands: normal 400 1em/1 "Font Awesome 6 Brands";\n  --fa-font-sharp-solid: normal 900 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-regular: normal 400 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-light: normal 300 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-thin: normal 100 1em/1 "Font Awesome 6 Sharp";\n  --fa-font-sharp-duotone-solid: normal 900 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-regular: normal 400 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-light: normal 300 1em/1 "Font Awesome 6 Sharp Duotone";\n  --fa-font-sharp-duotone-thin: normal 100 1em/1 "Font Awesome 6 Sharp Duotone";\n}\n\nsvg:not(:root).svg-inline--fa, svg:not(:host).svg-inline--fa {\n  overflow: visible;\n  box-sizing: content-box;\n}\n\n.svg-inline--fa {\n  display: var(--fa-display, inline-block);\n  height: 1em;\n  overflow: visible;\n  vertical-align: -0.125em;\n}\n.svg-inline--fa.fa-2xs {\n  vertical-align: 0.1em;\n}\n.svg-inline--fa.fa-xs {\n  vertical-align: 0em;\n}\n.svg-inline--fa.fa-sm {\n  vertical-align: -0.0714285705em;\n}\n.svg-inline--fa.fa-lg {\n  vertical-align: -0.2em;\n}\n.svg-inline--fa.fa-xl {\n  vertical-align: -0.25em;\n}\n.svg-inline--fa.fa-2xl {\n  vertical-align: -0.3125em;\n}\n.svg-inline--fa.fa-pull-left {\n  margin-right: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-pull-right {\n  margin-left: var(--fa-pull-margin, 0.3em);\n  width: auto;\n}\n.svg-inline--fa.fa-li {\n  width: var(--fa-li-width, 2em);\n  top: 0.25em;\n}\n.svg-inline--fa.fa-fw {\n  width: var(--fa-fw-width, 1.25em);\n}\n\n.fa-layers svg.svg-inline--fa {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n}\n\n.fa-layers-counter, .fa-layers-text {\n  display: inline-block;\n  position: absolute;\n  text-align: center;\n}\n\n.fa-layers {\n  display: inline-block;\n  height: 1em;\n  position: relative;\n  text-align: center;\n  vertical-align: -0.125em;\n  width: 1em;\n}\n.fa-layers svg.svg-inline--fa {\n  transform-origin: center center;\n}\n\n.fa-layers-text {\n  left: 50%;\n  top: 50%;\n  transform: translate(-50%, -50%);\n  transform-origin: center center;\n}\n\n.fa-layers-counter {\n  background-color: var(--fa-counter-background-color, #ff253a);\n  border-radius: var(--fa-counter-border-radius, 1em);\n  box-sizing: border-box;\n  color: var(--fa-inverse, #fff);\n  line-height: var(--fa-counter-line-height, 1);\n  max-width: var(--fa-counter-max-width, 5em);\n  min-width: var(--fa-counter-min-width, 1.5em);\n  overflow: hidden;\n  padding: var(--fa-counter-padding, 0.25em 0.5em);\n  right: var(--fa-right, 0);\n  text-overflow: ellipsis;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-counter-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-bottom-right {\n  bottom: var(--fa-bottom, 0);\n  right: var(--fa-right, 0);\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom right;\n}\n\n.fa-layers-bottom-left {\n  bottom: var(--fa-bottom, 0);\n  left: var(--fa-left, 0);\n  right: auto;\n  top: auto;\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: bottom left;\n}\n\n.fa-layers-top-right {\n  top: var(--fa-top, 0);\n  right: var(--fa-right, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top right;\n}\n\n.fa-layers-top-left {\n  left: var(--fa-left, 0);\n  right: auto;\n  top: var(--fa-top, 0);\n  transform: scale(var(--fa-layers-scale, 0.25));\n  transform-origin: top left;\n}\n\n.fa-1x {\n  font-size: 1em;\n}\n\n.fa-2x {\n  font-size: 2em;\n}\n\n.fa-3x {\n  font-size: 3em;\n}\n\n.fa-4x {\n  font-size: 4em;\n}\n\n.fa-5x {\n  font-size: 5em;\n}\n\n.fa-6x {\n  font-size: 6em;\n}\n\n.fa-7x {\n  font-size: 7em;\n}\n\n.fa-8x {\n  font-size: 8em;\n}\n\n.fa-9x {\n  font-size: 9em;\n}\n\n.fa-10x {\n  font-size: 10em;\n}\n\n.fa-2xs {\n  font-size: 0.625em;\n  line-height: 0.1em;\n  vertical-align: 0.225em;\n}\n\n.fa-xs {\n  font-size: 0.75em;\n  line-height: 0.0833333337em;\n  vertical-align: 0.125em;\n}\n\n.fa-sm {\n  font-size: 0.875em;\n  line-height: 0.0714285718em;\n  vertical-align: 0.0535714295em;\n}\n\n.fa-lg {\n  font-size: 1.25em;\n  line-height: 0.05em;\n  vertical-align: -0.075em;\n}\n\n.fa-xl {\n  font-size: 1.5em;\n  line-height: 0.0416666682em;\n  vertical-align: -0.125em;\n}\n\n.fa-2xl {\n  font-size: 2em;\n  line-height: 0.03125em;\n  vertical-align: -0.1875em;\n}\n\n.fa-fw {\n  text-align: center;\n  width: 1.25em;\n}\n\n.fa-ul {\n  list-style-type: none;\n  margin-left: var(--fa-li-margin, 2.5em);\n  padding-left: 0;\n}\n.fa-ul > li {\n  position: relative;\n}\n\n.fa-li {\n  left: calc(-1 * var(--fa-li-width, 2em));\n  position: absolute;\n  text-align: center;\n  width: var(--fa-li-width, 2em);\n  line-height: inherit;\n}\n\n.fa-border {\n  border-color: var(--fa-border-color, #eee);\n  border-radius: var(--fa-border-radius, 0.1em);\n  border-style: var(--fa-border-style, solid);\n  border-width: var(--fa-border-width, 0.08em);\n  padding: var(--fa-border-padding, 0.2em 0.25em 0.15em);\n}\n\n.fa-pull-left {\n  float: left;\n  margin-right: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-pull-right {\n  float: right;\n  margin-left: var(--fa-pull-margin, 0.3em);\n}\n\n.fa-beat {\n  animation-name: fa-beat;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-bounce {\n  animation-name: fa-bounce;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.28, 0.84, 0.42, 1));\n}\n\n.fa-fade {\n  animation-name: fa-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-beat-fade {\n  animation-name: fa-beat-fade;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, cubic-bezier(0.4, 0, 0.6, 1));\n}\n\n.fa-flip {\n  animation-name: fa-flip;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, ease-in-out);\n}\n\n.fa-shake {\n  animation-name: fa-shake;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin {\n  animation-name: fa-spin;\n  animation-delay: var(--fa-animation-delay, 0s);\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 2s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, linear);\n}\n\n.fa-spin-reverse {\n  --fa-animation-direction: reverse;\n}\n\n.fa-pulse,\n.fa-spin-pulse {\n  animation-name: fa-spin;\n  animation-direction: var(--fa-animation-direction, normal);\n  animation-duration: var(--fa-animation-duration, 1s);\n  animation-iteration-count: var(--fa-animation-iteration-count, infinite);\n  animation-timing-function: var(--fa-animation-timing, steps(8));\n}\n\n@media (prefers-reduced-motion: reduce) {\n  .fa-beat,\n.fa-bounce,\n.fa-fade,\n.fa-beat-fade,\n.fa-flip,\n.fa-pulse,\n.fa-shake,\n.fa-spin,\n.fa-spin-pulse {\n    animation-delay: -1ms;\n    animation-duration: 1ms;\n    animation-iteration-count: 1;\n    transition-delay: 0s;\n    transition-duration: 0s;\n  }\n}\n@keyframes fa-beat {\n  0%, 90% {\n    transform: scale(1);\n  }\n  45% {\n    transform: scale(var(--fa-beat-scale, 1.25));\n  }\n}\n@keyframes fa-bounce {\n  0% {\n    transform: scale(1, 1) translateY(0);\n  }\n  10% {\n    transform: scale(var(--fa-bounce-start-scale-x, 1.1), var(--fa-bounce-start-scale-y, 0.9)) translateY(0);\n  }\n  30% {\n    transform: scale(var(--fa-bounce-jump-scale-x, 0.9), var(--fa-bounce-jump-scale-y, 1.1)) translateY(var(--fa-bounce-height, -0.5em));\n  }\n  50% {\n    transform: scale(var(--fa-bounce-land-scale-x, 1.05), var(--fa-bounce-land-scale-y, 0.95)) translateY(0);\n  }\n  57% {\n    transform: scale(1, 1) translateY(var(--fa-bounce-rebound, -0.125em));\n  }\n  64% {\n    transform: scale(1, 1) translateY(0);\n  }\n  100% {\n    transform: scale(1, 1) translateY(0);\n  }\n}\n@keyframes fa-fade {\n  50% {\n    opacity: var(--fa-fade-opacity, 0.4);\n  }\n}\n@keyframes fa-beat-fade {\n  0%, 100% {\n    opacity: var(--fa-beat-fade-opacity, 0.4);\n    transform: scale(1);\n  }\n  50% {\n    opacity: 1;\n    transform: scale(var(--fa-beat-fade-scale, 1.125));\n  }\n}\n@keyframes fa-flip {\n  50% {\n    transform: rotate3d(var(--fa-flip-x, 0), var(--fa-flip-y, 1), var(--fa-flip-z, 0), var(--fa-flip-angle, -180deg));\n  }\n}\n@keyframes fa-shake {\n  0% {\n    transform: rotate(-15deg);\n  }\n  4% {\n    transform: rotate(15deg);\n  }\n  8%, 24% {\n    transform: rotate(-18deg);\n  }\n  12%, 28% {\n    transform: rotate(18deg);\n  }\n  16% {\n    transform: rotate(-22deg);\n  }\n  20% {\n    transform: rotate(22deg);\n  }\n  32% {\n    transform: rotate(-12deg);\n  }\n  36% {\n    transform: rotate(12deg);\n  }\n  40%, 100% {\n    transform: rotate(0deg);\n  }\n}\n@keyframes fa-spin {\n  0% {\n    transform: rotate(0deg);\n  }\n  100% {\n    transform: rotate(360deg);\n  }\n}\n.fa-rotate-90 {\n  transform: rotate(90deg);\n}\n\n.fa-rotate-180 {\n  transform: rotate(180deg);\n}\n\n.fa-rotate-270 {\n  transform: rotate(270deg);\n}\n\n.fa-flip-horizontal {\n  transform: scale(-1, 1);\n}\n\n.fa-flip-vertical {\n  transform: scale(1, -1);\n}\n\n.fa-flip-both,\n.fa-flip-horizontal.fa-flip-vertical {\n  transform: scale(-1, -1);\n}\n\n.fa-rotate-by {\n  transform: rotate(var(--fa-rotate-angle, 0));\n}\n\n.fa-stack {\n  display: inline-block;\n  vertical-align: middle;\n  height: 2em;\n  position: relative;\n  width: 2.5em;\n}\n\n.fa-stack-1x,\n.fa-stack-2x {\n  bottom: 0;\n  left: 0;\n  margin: auto;\n  position: absolute;\n  right: 0;\n  top: 0;\n  z-index: var(--fa-stack-z-index, auto);\n}\n\n.svg-inline--fa.fa-stack-1x {\n  height: 1em;\n  width: 1.25em;\n}\n.svg-inline--fa.fa-stack-2x {\n  height: 2em;\n  width: 2.5em;\n}\n\n.fa-inverse {\n  color: var(--fa-inverse, #fff);\n}\n\n.sr-only,\n.fa-sr-only {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.sr-only-focusable:not(:focus),\n.fa-sr-only-focusable:not(:focus) {\n  position: absolute;\n  width: 1px;\n  height: 1px;\n  padding: 0;\n  margin: -1px;\n  overflow: hidden;\n  clip: rect(0, 0, 0, 0);\n  white-space: nowrap;\n  border-width: 0;\n}\n\n.svg-inline--fa .fa-primary {\n  fill: var(--fa-primary-color, currentColor);\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa .fa-secondary {\n  fill: var(--fa-secondary-color, currentColor);\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-primary {\n  opacity: var(--fa-secondary-opacity, 0.4);\n}\n\n.svg-inline--fa.fa-swap-opacity .fa-secondary {\n  opacity: var(--fa-primary-opacity, 1);\n}\n\n.svg-inline--fa mask .fa-primary,\n.svg-inline--fa mask .fa-secondary {\n  fill: black;\n}';
                    if (bt !== le1 || ls !== vt) {
                        const Dl = new RegExp("\\.".concat(le1, "\\-"), "g"), Fl = new RegExp("\\--".concat(le1, "\\-"), "g"), sc = new RegExp("\\.".concat(vt), "g");
                        ho = ho.replace(Dl, ".".concat(bt, "-")).replace(Fl, "--".concat(bt, "-")).replace(sc, ".".concat(ls));
                    }
                    return ho;
                }
                let km = !1;
                function ensureCss() {
                    Em.autoAddCss && !km && (!function(le1) {
                        if (!le1 || !Ec) return;
                        const vt = mc.createElement("style");
                        vt.setAttribute("type", "text/css"), vt.innerHTML = le1;
                        const bt = mc.head.childNodes;
                        let ls = null;
                        for(let ho = bt.length - 1; ho > -1; ho--){
                            const le1 = bt[ho], vt = (le1.tagName || "").toUpperCase();
                            [
                                "STYLE",
                                "LINK"
                            ].indexOf(vt) > -1 && (ls = le1);
                        }
                        mc.head.insertBefore(vt, ls);
                    }(css()), km = !0);
                }
                var Cm = {
                    mixout: ()=>({
                            dom: {
                                css: css,
                                insertCss: ensureCss
                            }
                        }),
                    hooks: ()=>({
                            beforeDOMElementCreation () {
                                ensureCss();
                            },
                            beforeI2svg () {
                                ensureCss();
                            }
                        })
                };
                const Im = uc || {};
                Im[$d] || (Im[$d] = {}), Im[$d].styles || (Im[$d].styles = {}), Im[$d].hooks || (Im[$d].hooks = {}), Im[$d].shims || (Im[$d].shims = []);
                var Dm = Im[$d];
                const Lm = [], listener = function() {
                    mc.removeEventListener("DOMContentLoaded", listener), Pm = 1, Lm.map((le1)=>le1());
                };
                let Pm = !1;
                function toHtml(le1) {
                    const { tag: vt, attributes: bt = {}, children: ls = [] } = le1;
                    return "string" === typeof le1 ? htmlEscape(le1) : "<".concat(vt, " ").concat(function(le1) {
                        return Object.keys(le1 || {}).reduce((vt, bt)=>vt + "".concat(bt, '="').concat(htmlEscape(le1[bt]), '" '), "").trim();
                    }(bt), ">").concat(ls.map(toHtml).join(""), "</").concat(vt, ">");
                }
                function iconFromMapping(le1, vt, bt) {
                    if (le1 && le1[vt] && le1[vt][bt]) return {
                        prefix: vt,
                        iconName: bt,
                        icon: le1[vt][bt]
                    };
                }
                Ec && (Pm = (mc.documentElement.doScroll ? /^loaded|^c/ : /^loaded|^i|^c/).test(mc.readyState), Pm || mc.addEventListener("DOMContentLoaded", listener));
                var reduce = function(le1, vt, bt, ls) {
                    var ho, Dl, Fl, sc = Object.keys(le1), uc = sc.length, mc = void 0 !== ls ? function(le1, vt) {
                        return function(bt, ls, ho, Dl) {
                            return le1.call(vt, bt, ls, ho, Dl);
                        };
                    }(vt, ls) : vt;
                    for(void 0 === bt ? (ho = 1, Fl = le1[sc[0]]) : (ho = 0, Fl = bt); ho < uc; ho++)Fl = mc(Fl, le1[Dl = sc[ho]], Dl, le1);
                    return Fl;
                };
                function toHex(le1) {
                    const vt = function(le1) {
                        const vt = [];
                        let bt = 0;
                        const ls = le1.length;
                        for(; bt < ls;){
                            const ho = le1.charCodeAt(bt++);
                            if (ho >= 55296 && ho <= 56319 && bt < ls) {
                                const ls = le1.charCodeAt(bt++);
                                56320 == (64512 & ls) ? vt.push(((1023 & ho) << 10) + (1023 & ls) + 65536) : (vt.push(ho), bt--);
                            } else vt.push(ho);
                        }
                        return vt;
                    }(le1);
                    return 1 === vt.length ? vt[0].toString(16) : null;
                }
                function normalizeIcons(le1) {
                    return Object.keys(le1).reduce((vt, bt)=>{
                        const ls = le1[bt];
                        return !!ls.icon ? vt[ls.iconName] = ls.icon : vt[bt] = ls, vt;
                    }, {});
                }
                function defineIcons(le1, vt) {
                    let bt = arguments.length > 2 && void 0 !== arguments[2] ? arguments[2] : {};
                    const { skipHooks: ls = !1 } = bt, ho = normalizeIcons(vt);
                    "function" !== typeof Dm.hooks.addPack || ls ? Dm.styles[le1] = _objectSpread2(_objectSpread2({}, Dm.styles[le1] || {}), ho) : Dm.hooks.addPack(le1, normalizeIcons(vt)), "fas" === le1 && defineIcons("fa", vt);
                }
                const { styles: zm, shims: Nm } = Dm, Rm = Object.keys(pm), Fm = Rm.reduce((le1, vt)=>(le1[vt] = Object.keys(pm[vt]), le1), {});
                let Om = null, Bm = {}, jm = {}, Um = {}, Vm = {}, Gm = {};
                function getIconName(le1, vt) {
                    const bt = vt.split("-"), ls = bt[0], ho = bt.slice(1).join("-");
                    var Dl;
                    return ls !== le1 || "" === ho || (Dl = ho, ~vm.indexOf(Dl)) ? null : ho;
                }
                const build = ()=>{
                    const lookup = (le1)=>reduce(zm, (vt, bt, ls)=>(vt[ls] = reduce(bt, le1, {}), vt), {});
                    Bm = lookup((le1, vt, bt)=>{
                        if (vt[3] && (le1[vt[3]] = bt), vt[2]) vt[2].filter((le1)=>"number" === typeof le1).forEach((vt)=>{
                            le1[vt.toString(16)] = bt;
                        });
                        return le1;
                    }), jm = lookup((le1, vt, bt)=>{
                        if (le1[bt] = bt, vt[2]) vt[2].filter((le1)=>"string" === typeof le1).forEach((vt)=>{
                            le1[vt] = bt;
                        });
                        return le1;
                    }), Gm = lookup((le1, vt, bt)=>{
                        const ls = vt[2];
                        return le1[bt] = bt, ls.forEach((vt)=>{
                            le1[vt] = bt;
                        }), le1;
                    });
                    const le1 = "far" in zm || Em.autoFetchSvg, vt = reduce(Nm, (vt, bt)=>{
                        const ls = bt[0];
                        let ho = bt[1];
                        const Dl = bt[2];
                        return "far" !== ho || le1 || (ho = "fas"), "string" === typeof ls && (vt.names[ls] = {
                            prefix: ho,
                            iconName: Dl
                        }), "number" === typeof ls && (vt.unicodes[ls.toString(16)] = {
                            prefix: ho,
                            iconName: Dl
                        }), vt;
                    }, {
                        names: {},
                        unicodes: {}
                    });
                    Um = vt.names, Vm = vt.unicodes, Om = getCanonicalPrefix(Em.styleDefault, {
                        family: Em.familyDefault
                    });
                };
                var qm;
                function byUnicode(le1, vt) {
                    return (Bm[le1] || {})[vt];
                }
                function byAlias(le1, vt) {
                    return (Gm[le1] || {})[vt];
                }
                function byOldName(le1) {
                    return Um[le1] || {
                        prefix: null,
                        iconName: null
                    };
                }
                function getDefaultUsablePrefix() {
                    return Om;
                }
                qm = (le1)=>{
                    Om = getCanonicalPrefix(le1.styleDefault, {
                        family: Em.familyDefault
                    });
                }, Mm.push(qm), build();
                function getCanonicalPrefix(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { family: bt = Md } = vt, ls = cm[bt][le1];
                    if (bt === Ld && !le1) return "fad";
                    const ho = hm[bt][le1] || hm[bt][ls], Dl = le1 in Dm.styles ? le1 : null;
                    return ho || Dl || null;
                }
                function sortedUniqueValues(le1) {
                    return le1.sort().filter((le1, vt, bt)=>bt.indexOf(le1) === vt);
                }
                function getCanonicalIcon(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { skipLookups: bt = !1 } = vt;
                    let ls = null;
                    const ho = Qd.concat(Zd), Dl = sortedUniqueValues(le1.filter((le1)=>ho.includes(le1))), Fl = sortedUniqueValues(le1.filter((le1)=>!Qd.includes(le1))), sc = Dl.filter((le1)=>(ls = le1, !_u.includes(le1))), [uc = null] = sc, mc = function(le1) {
                        let vt = Md;
                        const bt = Rm.reduce((le1, vt)=>(le1[vt] = "".concat(Em.cssPrefix, "-").concat(vt), le1), {});
                        return Nd.forEach((ls)=>{
                            (le1.includes(bt[ls]) || le1.some((le1)=>Fm[ls].includes(le1))) && (vt = ls);
                        }), vt;
                    }(Dl), gc = _objectSpread2(_objectSpread2({}, function(le1) {
                        let vt = [], bt = null;
                        return le1.forEach((le1)=>{
                            const ls = getIconName(Em.cssPrefix, le1);
                            ls ? bt = ls : le1 && vt.push(le1);
                        }), {
                            iconName: bt,
                            rest: vt
                        };
                    }(Fl)), {}, {
                        prefix: getCanonicalPrefix(uc, {
                            family: mc
                        })
                    });
                    return _objectSpread2(_objectSpread2(_objectSpread2({}, gc), function(le1) {
                        const { values: vt, family: bt, canonical: ls, givenPrefix: ho = "", styles: Dl = {}, config: Fl = {} } = le1, sc = bt === Ld, uc = vt.includes("fa-duotone") || vt.includes("fad"), mc = "duotone" === Fl.familyDefault, gc = "fad" === ls.prefix || "fa-duotone" === ls.prefix;
                        !sc && (uc || mc || gc) && (ls.prefix = "fad");
                        (vt.includes("fa-brands") || vt.includes("fab")) && (ls.prefix = "fab");
                        if (!ls.prefix && Hm.includes(bt)) {
                            if (Object.keys(Dl).find((le1)=>Wm.includes(le1)) || Fl.autoFetchSvg) {
                                const le1 = Rd.get(bt).defaultShortPrefixId;
                                ls.prefix = le1, ls.iconName = byAlias(ls.prefix, ls.iconName) || ls.iconName;
                            }
                        }
                        "fa" !== ls.prefix && "fa" !== ho || (ls.prefix = getDefaultUsablePrefix() || "fas");
                        return ls;
                    }({
                        values: le1,
                        family: mc,
                        styles: zm,
                        config: Em,
                        canonical: gc,
                        givenPrefix: ls
                    })), function(le1, vt, bt) {
                        let { prefix: ls, iconName: ho } = bt;
                        if (le1 || !ls || !ho) return {
                            prefix: ls,
                            iconName: ho
                        };
                        const Dl = "fa" === vt ? byOldName(ho) : {}, Fl = byAlias(ls, ho);
                        ho = Dl.iconName || Fl || ho, ls = Dl.prefix || ls, "far" !== ls || zm.far || !zm.fas || Em.autoFetchSvg || (ls = "fas");
                        return {
                            prefix: ls,
                            iconName: ho
                        };
                    }(bt, ls, gc));
                }
                const Hm = Nd.filter((le1)=>le1 !== Md || le1 !== Ld), Wm = Object.keys(Yd).filter((le1)=>le1 !== Md).map((le1)=>Object.keys(Yd[le1])).flat();
                let Zm = [], Ym = {};
                const Qm = {}, Xm = Object.keys(Qm);
                function chainHooks(le1, vt) {
                    for(var bt = arguments.length, ls = new Array(bt > 2 ? bt - 2 : 0), ho = 2; ho < bt; ho++)ls[ho - 2] = arguments[ho];
                    return (Ym[le1] || []).forEach((le1)=>{
                        vt = le1.apply(null, [
                            vt,
                            ...ls
                        ]);
                    }), vt;
                }
                function callHooks(le1) {
                    for(var vt = arguments.length, bt = new Array(vt > 1 ? vt - 1 : 0), ls = 1; ls < vt; ls++)bt[ls - 1] = arguments[ls];
                    (Ym[le1] || []).forEach((le1)=>{
                        le1.apply(null, bt);
                    });
                }
                function callProvided() {
                    const le1 = arguments[0], vt = Array.prototype.slice.call(arguments, 1);
                    return Qm[le1] ? Qm[le1].apply(null, vt) : void 0;
                }
                function findIconDefinition(le1) {
                    "fa" === le1.prefix && (le1.prefix = "fas");
                    let { iconName: vt } = le1;
                    const bt = le1.prefix || getDefaultUsablePrefix();
                    if (vt) return vt = byAlias(bt, vt) || vt, iconFromMapping(Km.definitions, bt, vt) || iconFromMapping(Dm.styles, bt, vt);
                }
                const Km = new class {
                    constructor(){
                        this.definitions = {};
                    }
                    add() {
                        for(var le1 = arguments.length, vt = new Array(le1), bt = 0; bt < le1; bt++)vt[bt] = arguments[bt];
                        const ls = vt.reduce(this._pullDefinitions, {});
                        Object.keys(ls).forEach((le1)=>{
                            this.definitions[le1] = _objectSpread2(_objectSpread2({}, this.definitions[le1] || {}), ls[le1]), defineIcons(le1, ls[le1]);
                            const vt = pm[Md][le1];
                            vt && defineIcons(vt, ls[le1]), build();
                        });
                    }
                    reset() {
                        this.definitions = {};
                    }
                    _pullDefinitions(le1, vt) {
                        const bt = vt.prefix && vt.iconName && vt.icon ? {
                            0: vt
                        } : vt;
                        return Object.keys(bt).map((vt)=>{
                            const { prefix: ls, iconName: ho, icon: Dl } = bt[vt], Fl = Dl[2];
                            le1[ls] || (le1[ls] = {}), Fl.length > 0 && Fl.forEach((vt)=>{
                                "string" === typeof vt && (le1[ls][vt] = Dl);
                            }), le1[ls][ho] = Dl;
                        }), le1;
                    }
                }, Jm = {
                    i2svg: function() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        return Ec ? (callHooks("beforeI2svg", le1), callProvided("pseudoElements2svg", le1), callProvided("i2svg", le1)) : Promise.reject(new Error("Operation requires a DOM of some kind."));
                    },
                    watch: function() {
                        let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                        const { autoReplaceSvgRoot: vt } = le1;
                        var bt;
                        !1 === Em.autoReplaceSvg && (Em.autoReplaceSvg = !0), Em.observeMutations = !0, bt = ()=>{
                            autoReplace({
                                autoReplaceSvgRoot: vt
                            }), callHooks("watch", le1);
                        }, Ec && (Pm ? setTimeout(bt, 0) : Lm.push(bt));
                    }
                }, $m = {
                    icon: (le1)=>{
                        if (null === le1) return null;
                        if ("object" === typeof le1 && le1.prefix && le1.iconName) return {
                            prefix: le1.prefix,
                            iconName: byAlias(le1.prefix, le1.iconName) || le1.iconName
                        };
                        if (Array.isArray(le1) && 2 === le1.length) {
                            const vt = 0 === le1[1].indexOf("fa-") ? le1[1].slice(3) : le1[1], bt = getCanonicalPrefix(le1[0]);
                            return {
                                prefix: bt,
                                iconName: byAlias(bt, vt) || vt
                            };
                        }
                        if ("string" === typeof le1 && (le1.indexOf("".concat(Em.cssPrefix, "-")) > -1 || le1.match(fm))) {
                            const vt = getCanonicalIcon(le1.split(" "), {
                                skipLookups: !0
                            });
                            return {
                                prefix: vt.prefix || getDefaultUsablePrefix(),
                                iconName: byAlias(vt.prefix, vt.iconName) || vt.iconName
                            };
                        }
                        if ("string" === typeof le1) {
                            const vt = getDefaultUsablePrefix();
                            return {
                                prefix: vt,
                                iconName: byAlias(vt, le1) || le1
                            };
                        }
                    }
                }, eg = {
                    noAuto: ()=>{
                        Em.autoReplaceSvg = !1, Em.observeMutations = !1, callHooks("noAuto");
                    },
                    config: Em,
                    dom: Jm,
                    parse: $m,
                    library: Km,
                    findIconDefinition: findIconDefinition,
                    toHtml: toHtml
                }, autoReplace = function() {
                    let le1 = arguments.length > 0 && void 0 !== arguments[0] ? arguments[0] : {};
                    const { autoReplaceSvgRoot: vt = mc } = le1;
                    (Object.keys(Dm.styles).length > 0 || Em.autoFetchSvg) && Ec && Em.autoReplaceSvg && eg.dom.i2svg({
                        node: vt
                    });
                };
                function domVariants(le1, vt) {
                    return Object.defineProperty(le1, "abstract", {
                        get: vt
                    }), Object.defineProperty(le1, "html", {
                        get: function() {
                            return le1.abstract.map((le1)=>toHtml(le1));
                        }
                    }), Object.defineProperty(le1, "node", {
                        get: function() {
                            if (!Ec) return;
                            const vt = mc.createElement("div");
                            return vt.innerHTML = le1.html, vt.children;
                        }
                    }), le1;
                }
                function makeInlineSvgAbstract(le1) {
                    const { icons: { main: vt, mask: bt }, prefix: ls, iconName: ho, transform: Dl, symbol: Fl, title: sc, maskId: uc, titleId: mc, extra: gc, watchable: Ac = !1 } = le1, { width: Ec, height: kc } = bt.found ? bt : vt, du = Gd.includes(ls), _u = [
                        Em.replacementClass,
                        ho ? "".concat(Em.cssPrefix, "-").concat(ho) : ""
                    ].filter((le1)=>-1 === gc.classes.indexOf(le1)).filter((le1)=>"" !== le1 || !!le1).concat(gc.classes).join(" ");
                    let Md = {
                        children: [],
                        attributes: _objectSpread2(_objectSpread2({}, gc.attributes), {}, {
                            "data-prefix": ls,
                            "data-icon": ho,
                            class: _u,
                            role: gc.attributes.role || "img",
                            xmlns: "http://www.w3.org/2000/svg",
                            viewBox: "0 0 ".concat(Ec, " ").concat(kc)
                        })
                    };
                    const Ld = du && !~gc.classes.indexOf("fa-fw") ? {
                        width: "".concat(Ec / kc * 1, "em")
                    } : {};
                    Ac && (Md.attributes[tm] = ""), sc && (Md.children.push({
                        tag: "title",
                        attributes: {
                            id: Md.attributes["aria-labelledby"] || "title-".concat(mc || nextUniqueId())
                        },
                        children: [
                            sc
                        ]
                    }), delete Md.attributes.title);
                    const Nd = _objectSpread2(_objectSpread2({}, Md), {}, {
                        prefix: ls,
                        iconName: ho,
                        main: vt,
                        mask: bt,
                        maskId: uc,
                        transform: Dl,
                        symbol: Fl,
                        styles: _objectSpread2(_objectSpread2({}, Ld), gc.styles)
                    }), { children: Rd, attributes: Od } = bt.found && vt.found ? callProvided("generateAbstractMask", Nd) || {
                        children: [],
                        attributes: {}
                    } : callProvided("generateAbstractIcon", Nd) || {
                        children: [],
                        attributes: {}
                    };
                    return Nd.children = Rd, Nd.attributes = Od, Fl ? function(le1) {
                        let { prefix: vt, iconName: bt, children: ls, attributes: ho, symbol: Dl } = le1;
                        const Fl = !0 === Dl ? "".concat(vt, "-").concat(Em.cssPrefix, "-").concat(bt) : Dl;
                        return [
                            {
                                tag: "svg",
                                attributes: {
                                    style: "display: none;"
                                },
                                children: [
                                    {
                                        tag: "symbol",
                                        attributes: _objectSpread2(_objectSpread2({}, ho), {}, {
                                            id: Fl
                                        }),
                                        children: ls
                                    }
                                ]
                            }
                        ];
                    }(Nd) : function(le1) {
                        let { children: vt, main: bt, mask: ls, attributes: ho, styles: Dl, transform: Fl } = le1;
                        if (transformIsMeaningful(Fl) && bt.found && !ls.found) {
                            const { width: le1, height: vt } = bt, ls = {
                                x: le1 / vt / 2,
                                y: .5
                            };
                            ho.style = joinStyles(_objectSpread2(_objectSpread2({}, Dl), {}, {
                                "transform-origin": "".concat(ls.x + Fl.x / 16, "em ").concat(ls.y + Fl.y / 16, "em")
                            }));
                        }
                        return [
                            {
                                tag: "svg",
                                attributes: ho,
                                children: vt
                            }
                        ];
                    }(Nd);
                }
                function makeLayersTextAbstract(le1) {
                    const { content: vt, width: bt, height: ls, transform: ho, title: Dl, extra: Fl, watchable: sc = !1 } = le1, uc = _objectSpread2(_objectSpread2(_objectSpread2({}, Fl.attributes), Dl ? {
                        title: Dl
                    } : {}), {}, {
                        class: Fl.classes.join(" ")
                    });
                    sc && (uc[tm] = "");
                    const mc = _objectSpread2({}, Fl.styles);
                    transformIsMeaningful(ho) && (mc.transform = function(le1) {
                        let { transform: vt, width: bt = sp, height: ls = sp, startCentered: ho = !1 } = le1, Dl = "";
                        return Dl += ho && kc ? "translate(".concat(vt.x / Sm - bt / 2, "em, ").concat(vt.y / Sm - ls / 2, "em) ") : ho ? "translate(calc(-50% + ".concat(vt.x / Sm, "em), calc(-50% + ").concat(vt.y / Sm, "em)) ") : "translate(".concat(vt.x / Sm, "em, ").concat(vt.y / Sm, "em) "), Dl += "scale(".concat(vt.size / Sm * (vt.flipX ? -1 : 1), ", ").concat(vt.size / Sm * (vt.flipY ? -1 : 1), ") "), Dl += "rotate(".concat(vt.rotate, "deg) "), Dl;
                    }({
                        transform: ho,
                        startCentered: !0,
                        width: bt,
                        height: ls
                    }), mc["-webkit-transform"] = mc.transform);
                    const gc = joinStyles(mc);
                    gc.length > 0 && (uc.style = gc);
                    const Ac = [];
                    return Ac.push({
                        tag: "span",
                        attributes: uc,
                        children: [
                            vt
                        ]
                    }), Dl && Ac.push({
                        tag: "span",
                        attributes: {
                            class: "sr-only"
                        },
                        children: [
                            Dl
                        ]
                    }), Ac;
                }
                const { styles: tg } = Dm;
                function asFoundIcon(le1) {
                    const vt = le1[0], bt = le1[1], [ls] = le1.slice(4);
                    let ho = null;
                    return ho = Array.isArray(ls) ? {
                        tag: "g",
                        attributes: {
                            class: "".concat(Em.cssPrefix, "-").concat(ym.GROUP)
                        },
                        children: [
                            {
                                tag: "path",
                                attributes: {
                                    class: "".concat(Em.cssPrefix, "-").concat(ym.SECONDARY),
                                    fill: "currentColor",
                                    d: ls[0]
                                }
                            },
                            {
                                tag: "path",
                                attributes: {
                                    class: "".concat(Em.cssPrefix, "-").concat(ym.PRIMARY),
                                    fill: "currentColor",
                                    d: ls[1]
                                }
                            }
                        ]
                    } : {
                        tag: "path",
                        attributes: {
                            fill: "currentColor",
                            d: ls
                        }
                    }, {
                        found: !0,
                        width: vt,
                        height: bt,
                        icon: ho
                    };
                }
                const ig = {
                    found: !1,
                    width: 512,
                    height: 512
                };
                function findIcon(le1, vt) {
                    let bt = vt;
                    return "fa" === vt && null !== Em.styleDefault && (vt = getDefaultUsablePrefix()), new Promise((ls, ho)=>{
                        if ("fa" === bt) {
                            const bt = byOldName(le1) || {};
                            le1 = bt.iconName || le1, vt = bt.prefix || vt;
                        }
                        if (le1 && vt && tg[vt] && tg[vt][le1]) return ls(asFoundIcon(tg[vt][le1]));
                        !function(le1, vt) {
                            om || Em.showMissingIcons || !le1 || console.error('Icon with name "'.concat(le1, '" and prefix "').concat(vt, '" is missing.'));
                        }(le1, vt), ls(_objectSpread2(_objectSpread2({}, ig), {}, {
                            icon: Em.showMissingIcons && le1 && callProvided("missingIconAbstract") || {}
                        }));
                    });
                }
                const noop$1 = ()=>{}, ng = Em.measurePerformance && Ac && Ac.mark && Ac.measure ? Ac : {
                    mark: noop$1,
                    measure: noop$1
                }, rg = 'FA "6.7.2"', end = (le1)=>{
                    ng.mark("".concat(rg, " ").concat(le1, " ends")), ng.measure("".concat(rg, " ").concat(le1), "".concat(rg, " ").concat(le1, " begins"), "".concat(rg, " ").concat(le1, " ends"));
                };
                var perf_begin = (le1)=>(ng.mark("".concat(rg, " ").concat(le1, " begins")), ()=>end(le1));
                const noop$2 = ()=>{};
                function isWatched(le1) {
                    return "string" === typeof (le1.getAttribute ? le1.getAttribute(tm) : null);
                }
                function createElementNS(le1) {
                    return mc.createElementNS("http://www.w3.org/2000/svg", le1);
                }
                function createElement(le1) {
                    return mc.createElement(le1);
                }
                function convertSVG(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { ceFn: bt = "svg" === le1.tag ? createElementNS : createElement } = vt;
                    if ("string" === typeof le1) return mc.createTextNode(le1);
                    const ls = bt(le1.tag);
                    Object.keys(le1.attributes || []).forEach(function(vt) {
                        ls.setAttribute(vt, le1.attributes[vt]);
                    });
                    return (le1.children || []).forEach(function(le1) {
                        ls.appendChild(convertSVG(le1, {
                            ceFn: bt
                        }));
                    }), ls;
                }
                const ag = {
                    replace: function(le1) {
                        const vt = le1[0];
                        if (vt.parentNode) {
                            if (le1[1].forEach((le1)=>{
                                vt.parentNode.insertBefore(convertSVG(le1), vt);
                            }), null === vt.getAttribute(tm) && Em.keepOriginalSource) {
                                let le1 = mc.createComment(function(le1) {
                                    let vt = " ".concat(le1.outerHTML, " ");
                                    return vt = "".concat(vt, "Font Awesome fontawesome.com "), vt;
                                }(vt));
                                vt.parentNode.replaceChild(le1, vt);
                            } else vt.remove();
                        }
                    },
                    nest: function(le1) {
                        const vt = le1[0], bt = le1[1];
                        if (~classArray(vt).indexOf(Em.replacementClass)) return ag.replace(le1);
                        const ls = new RegExp("".concat(Em.cssPrefix, "-.*"));
                        if (delete bt[0].attributes.id, bt[0].attributes.class) {
                            const le1 = bt[0].attributes.class.split(" ").reduce((le1, vt)=>(vt === Em.replacementClass || vt.match(ls) ? le1.toSvg.push(vt) : le1.toNode.push(vt), le1), {
                                toNode: [],
                                toSvg: []
                            });
                            bt[0].attributes.class = le1.toSvg.join(" "), 0 === le1.toNode.length ? vt.removeAttribute("class") : vt.setAttribute("class", le1.toNode.join(" "));
                        }
                        const ho = bt.map((le1)=>toHtml(le1)).join("\n");
                        vt.setAttribute(tm, ""), vt.innerHTML = ho;
                    }
                };
                function performOperationSync(le1) {
                    le1();
                }
                function perform(le1, vt) {
                    const bt = "function" === typeof vt ? vt : noop$2;
                    if (0 === le1.length) bt();
                    else {
                        let vt = performOperationSync;
                        "async" === Em.mutateApproach && (vt = uc.requestAnimationFrame || performOperationSync), vt(()=>{
                            const vt = !0 === Em.autoReplaceSvg ? ag.replace : ag[Em.autoReplaceSvg] || ag.replace, ls = perf_begin("mutate");
                            le1.map(vt), ls(), bt();
                        });
                    }
                }
                let sg = !1;
                function disableObservation() {
                    sg = !0;
                }
                function enableObservation() {
                    sg = !1;
                }
                let og = null;
                function observe(le1) {
                    if (!gc) return;
                    if (!Em.observeMutations) return;
                    const { treeCallback: vt = noop$2, nodeCallback: bt = noop$2, pseudoElementsCallback: ls = noop$2, observeMutationsRoot: ho = mc } = le1;
                    og = new gc((le1)=>{
                        if (sg) return;
                        const ho = getDefaultUsablePrefix();
                        toArray(le1).forEach((le1)=>{
                            if ("childList" === le1.type && le1.addedNodes.length > 0 && !isWatched(le1.addedNodes[0]) && (Em.searchPseudoElements && ls(le1.target), vt(le1.target)), "attributes" === le1.type && le1.target.parentNode && Em.searchPseudoElements && ls(le1.target.parentNode), "attributes" === le1.type && isWatched(le1.target) && ~_m.indexOf(le1.attributeName)) {
                                if ("class" === le1.attributeName && function(le1) {
                                    const vt = le1.getAttribute ? le1.getAttribute(nm) : null, bt = le1.getAttribute ? le1.getAttribute(rm) : null;
                                    return vt && bt;
                                }(le1.target)) {
                                    const { prefix: vt, iconName: bt } = getCanonicalIcon(classArray(le1.target));
                                    le1.target.setAttribute(nm, vt || ho), bt && le1.target.setAttribute(rm, bt);
                                } else (Dl = le1.target) && Dl.classList && Dl.classList.contains && Dl.classList.contains(Em.replacementClass) && bt(le1.target);
                            }
                            var Dl;
                        });
                    }), Ec && og.observe(ho, {
                        childList: !0,
                        attributes: !0,
                        characterData: !0,
                        subtree: !0
                    });
                }
                function classParser(le1) {
                    const vt = le1.getAttribute("data-prefix"), bt = le1.getAttribute("data-icon"), ls = void 0 !== le1.innerText ? le1.innerText.trim() : "";
                    let ho = getCanonicalIcon(classArray(le1));
                    var Dl, Fl;
                    return ho.prefix || (ho.prefix = getDefaultUsablePrefix()), vt && bt && (ho.prefix = vt, ho.iconName = bt), ho.iconName && ho.prefix || (ho.prefix && ls.length > 0 && (ho.iconName = (Dl = ho.prefix, Fl = le1.innerText, (jm[Dl] || {})[Fl] || byUnicode(ho.prefix, toHex(le1.innerText)))), !ho.iconName && Em.autoFetchSvg && le1.firstChild && le1.firstChild.nodeType === Node.TEXT_NODE && (ho.iconName = le1.firstChild.data)), ho;
                }
                function parseMeta(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {
                        styleParser: !0
                    };
                    const { iconName: bt, prefix: ls, rest: ho } = classParser(le1), Dl = function(le1) {
                        const vt = toArray(le1.attributes).reduce((le1, vt)=>("class" !== le1.name && "style" !== le1.name && (le1[vt.name] = vt.value), le1), {}), bt = le1.getAttribute("title"), ls = le1.getAttribute("data-fa-title-id");
                        return Em.autoA11y && (bt ? vt["aria-labelledby"] = "".concat(Em.replacementClass, "-title-").concat(ls || nextUniqueId()) : (vt["aria-hidden"] = "true", vt.focusable = "false")), vt;
                    }(le1), Fl = chainHooks("parseNodeAttributes", {}, le1);
                    let sc = vt.styleParser ? function(le1) {
                        const vt = le1.getAttribute("style");
                        let bt = [];
                        return vt && (bt = vt.split(";").reduce((le1, vt)=>{
                            const bt = vt.split(":"), ls = bt[0], ho = bt.slice(1);
                            return ls && ho.length > 0 && (le1[ls] = ho.join(":").trim()), le1;
                        }, {})), bt;
                    }(le1) : [];
                    return _objectSpread2({
                        iconName: bt,
                        title: le1.getAttribute("title"),
                        titleId: le1.getAttribute("data-fa-title-id"),
                        prefix: ls,
                        transform: Tm,
                        mask: {
                            iconName: null,
                            prefix: null,
                            rest: []
                        },
                        maskId: null,
                        symbol: !1,
                        extra: {
                            classes: ho,
                            styles: sc,
                            attributes: Dl
                        }
                    }, Fl);
                }
                const { styles: lg } = Dm;
                function generateMutation(le1) {
                    const vt = "nest" === Em.autoReplaceSvg ? parseMeta(le1, {
                        styleParser: !1
                    }) : parseMeta(le1);
                    return ~vt.extra.classes.indexOf(gm) ? callProvided("generateLayersText", le1, vt) : callProvided("generateSvgReplacementMutation", le1, vt);
                }
                function onTree(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    if (!Ec) return Promise.resolve();
                    const bt = mc.documentElement.classList, hclAdd = (le1)=>bt.add("".concat(am, "-").concat(le1)), hclRemove = (le1)=>bt.remove("".concat(am, "-").concat(le1)), ls = Em.autoFetchSvg ? [
                        ...Od,
                        ...Qd
                    ] : _u.concat(Object.keys(lg));
                    ls.includes("fa") || ls.push("fa");
                    const ho = [
                        ".".concat(gm, ":not([").concat(tm, "])")
                    ].concat(ls.map((le1)=>".".concat(le1, ":not([").concat(tm, "])"))).join(", ");
                    if (0 === ho.length) return Promise.resolve();
                    let Dl = [];
                    try {
                        Dl = toArray(le1.querySelectorAll(ho));
                    } catch (uc) {}
                    if (!(Dl.length > 0)) return Promise.resolve();
                    hclAdd("pending"), hclRemove("complete");
                    const Fl = perf_begin("onTree"), sc = Dl.reduce((le1, vt)=>{
                        try {
                            const bt = generateMutation(vt);
                            bt && le1.push(bt);
                        } catch (uc) {
                            om || "MissingIcon" === uc.name && console.error(uc);
                        }
                        return le1;
                    }, []);
                    return new Promise((le1, bt)=>{
                        Promise.all(sc).then((bt)=>{
                            perform(bt, ()=>{
                                hclAdd("active"), hclAdd("complete"), hclRemove("pending"), "function" === typeof vt && vt(), Fl(), le1();
                            });
                        }).catch((le1)=>{
                            Fl(), bt(le1);
                        });
                    });
                }
                function onNode(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : null;
                    generateMutation(le1).then((le1)=>{
                        le1 && perform([
                            le1
                        ], vt);
                    });
                }
                const render = function(le1) {
                    let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                    const { transform: bt = Tm, symbol: ls = !1, mask: ho = null, maskId: Dl = null, title: Fl = null, titleId: sc = null, classes: uc = [], attributes: mc = {}, styles: gc = {} } = vt;
                    if (!le1) return;
                    const { prefix: Ac, iconName: Ec, icon: kc } = le1;
                    return domVariants(_objectSpread2({
                        type: "icon"
                    }, le1), ()=>(callHooks("beforeDOMElementCreation", {
                            iconDefinition: le1,
                            params: vt
                        }), Em.autoA11y && (Fl ? mc["aria-labelledby"] = "".concat(Em.replacementClass, "-title-").concat(sc || nextUniqueId()) : (mc["aria-hidden"] = "true", mc.focusable = "false")), makeInlineSvgAbstract({
                            icons: {
                                main: asFoundIcon(kc),
                                mask: ho ? asFoundIcon(ho.icon) : {
                                    found: !1,
                                    width: null,
                                    height: null,
                                    icon: {}
                                }
                            },
                            prefix: Ac,
                            iconName: Ec,
                            transform: _objectSpread2(_objectSpread2({}, Tm), bt),
                            symbol: ls,
                            title: Fl,
                            maskId: Dl,
                            titleId: sc,
                            extra: {
                                attributes: mc,
                                styles: gc,
                                classes: uc
                            }
                        })));
                };
                var cg = {
                    mixout () {
                        var le1;
                        return {
                            icon: (le1 = render, function(vt) {
                                let bt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const ls = (vt || {}).icon ? vt : findIconDefinition(vt || {});
                                let { mask: ho } = bt;
                                return ho && (ho = (ho || {}).icon ? ho : findIconDefinition(ho || {})), le1(ls, _objectSpread2(_objectSpread2({}, bt), {}, {
                                    mask: ho
                                }));
                            })
                        };
                    },
                    hooks: ()=>({
                            mutationObserverCallbacks: (le1)=>(le1.treeCallback = onTree, le1.nodeCallback = onNode, le1)
                        }),
                    provides (le1) {
                        le1.i2svg = function(le1) {
                            const { node: vt = mc, callback: bt = ()=>{} } = le1;
                            return onTree(vt, bt);
                        }, le1.generateSvgReplacementMutation = function(le1, vt) {
                            const { iconName: bt, title: ls, titleId: ho, prefix: Dl, transform: Fl, symbol: sc, mask: uc, maskId: mc, extra: gc } = vt;
                            return new Promise((vt, Ac)=>{
                                Promise.all([
                                    findIcon(bt, Dl),
                                    uc.iconName ? findIcon(uc.iconName, uc.prefix) : Promise.resolve({
                                        found: !1,
                                        width: 512,
                                        height: 512,
                                        icon: {}
                                    })
                                ]).then((uc)=>{
                                    let [Ac, Ec] = uc;
                                    vt([
                                        le1,
                                        makeInlineSvgAbstract({
                                            icons: {
                                                main: Ac,
                                                mask: Ec
                                            },
                                            prefix: Dl,
                                            iconName: bt,
                                            transform: Fl,
                                            symbol: sc,
                                            maskId: mc,
                                            title: ls,
                                            titleId: ho,
                                            extra: gc,
                                            watchable: !0
                                        })
                                    ]);
                                }).catch(Ac);
                            });
                        }, le1.generateAbstractIcon = function(le1) {
                            let { children: vt, attributes: bt, main: ls, transform: ho, styles: Dl } = le1;
                            const Fl = joinStyles(Dl);
                            let sc;
                            return Fl.length > 0 && (bt.style = Fl), transformIsMeaningful(ho) && (sc = callProvided("generateAbstractTransformGrouping", {
                                main: ls,
                                transform: ho,
                                containerWidth: ls.width,
                                iconWidth: ls.width
                            })), vt.push(sc || ls.icon), {
                                children: vt,
                                attributes: bt
                            };
                        };
                    }
                }, ug = {
                    mixout: ()=>({
                            layer (le1) {
                                let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { classes: bt = [] } = vt;
                                return domVariants({
                                    type: "layer"
                                }, ()=>{
                                    callHooks("beforeDOMElementCreation", {
                                        assembler: le1,
                                        params: vt
                                    });
                                    let ls = [];
                                    return le1((le1)=>{
                                        Array.isArray(le1) ? le1.map((le1)=>{
                                            ls = ls.concat(le1.abstract);
                                        }) : ls = ls.concat(le1.abstract);
                                    }), [
                                        {
                                            tag: "span",
                                            attributes: {
                                                class: [
                                                    "".concat(Em.cssPrefix, "-layers"),
                                                    ...bt
                                                ].join(" ")
                                            },
                                            children: ls
                                        }
                                    ];
                                });
                            }
                        })
                }, hg = {
                    mixout: ()=>({
                            counter (le1) {
                                let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { title: bt = null, classes: ls = [], attributes: ho = {}, styles: Dl = {} } = vt;
                                return domVariants({
                                    type: "counter",
                                    content: le1
                                }, ()=>(callHooks("beforeDOMElementCreation", {
                                        content: le1,
                                        params: vt
                                    }), function(le1) {
                                        const { content: vt, title: bt, extra: ls } = le1, ho = _objectSpread2(_objectSpread2(_objectSpread2({}, ls.attributes), bt ? {
                                            title: bt
                                        } : {}), {}, {
                                            class: ls.classes.join(" ")
                                        }), Dl = joinStyles(ls.styles);
                                        Dl.length > 0 && (ho.style = Dl);
                                        const Fl = [];
                                        return Fl.push({
                                            tag: "span",
                                            attributes: ho,
                                            children: [
                                                vt
                                            ]
                                        }), bt && Fl.push({
                                            tag: "span",
                                            attributes: {
                                                class: "sr-only"
                                            },
                                            children: [
                                                bt
                                            ]
                                        }), Fl;
                                    }({
                                        content: le1.toString(),
                                        title: bt,
                                        extra: {
                                            attributes: ho,
                                            styles: Dl,
                                            classes: [
                                                "".concat(Em.cssPrefix, "-layers-counter"),
                                                ...ls
                                            ]
                                        }
                                    })));
                            }
                        })
                }, dg = {
                    mixout: ()=>({
                            text (le1) {
                                let vt = arguments.length > 1 && void 0 !== arguments[1] ? arguments[1] : {};
                                const { transform: bt = Tm, title: ls = null, classes: ho = [], attributes: Dl = {}, styles: Fl = {} } = vt;
                                return domVariants({
                                    type: "text",
                                    content: le1
                                }, ()=>(callHooks("beforeDOMElementCreation", {
                                        content: le1,
                                        params: vt
                                    }), makeLayersTextAbstract({
                                        content: le1,
                                        transform: _objectSpread2(_objectSpread2({}, Tm), bt),
                                        title: ls,
                                        extra: {
                                            attributes: Dl,
                                            styles: Fl,
                                            classes: [
                                                "".concat(Em.cssPrefix, "-layers-text"),
                                                ...ho
                                            ]
                                        }
                                    })));
                            }
                        }),
                    provides (le1) {
                        le1.generateLayersText = function(le1, vt) {
                            const { title: bt, transform: ls, extra: ho } = vt;
                            let Dl = null, Fl = null;
                            if (kc) {
                                const vt = parseInt(getComputedStyle(le1).fontSize, 10), bt = le1.getBoundingClientRect();
                                Dl = bt.width / vt, Fl = bt.height / vt;
                            }
                            return Em.autoA11y && !bt && (ho.attributes["aria-hidden"] = "true"), Promise.resolve([
                                le1,
                                makeLayersTextAbstract({
                                    content: le1.innerHTML,
                                    width: Dl,
                                    height: Fl,
                                    transform: ls,
                                    title: bt,
                                    extra: ho,
                                    watchable: !0
                                })
                            ]);
                        };
                    }
                };
                const pg = new RegExp('"', "ug"), mg = [
                    1105920,
                    1112319
                ], fg = _objectSpread2(_objectSpread2(_objectSpread2(_objectSpread2({}, {
                    FontAwesome: {
                        normal: "fas",
                        400: "fas"
                    }
                }), {
                    "Font Awesome 6 Free": {
                        900: "fas",
                        400: "far"
                    },
                    "Font Awesome 6 Pro": {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal",
                        100: "fat"
                    },
                    "Font Awesome 6 Brands": {
                        400: "fab",
                        normal: "fab"
                    },
                    "Font Awesome 6 Duotone": {
                        900: "fad",
                        400: "fadr",
                        normal: "fadr",
                        300: "fadl",
                        100: "fadt"
                    },
                    "Font Awesome 6 Sharp": {
                        900: "fass",
                        400: "fasr",
                        normal: "fasr",
                        300: "fasl",
                        100: "fast"
                    },
                    "Font Awesome 6 Sharp Duotone": {
                        900: "fasds",
                        400: "fasdr",
                        normal: "fasdr",
                        300: "fasdl",
                        100: "fasdt"
                    }
                }), {
                    "Font Awesome 5 Free": {
                        900: "fas",
                        400: "far"
                    },
                    "Font Awesome 5 Pro": {
                        900: "fas",
                        400: "far",
                        normal: "far",
                        300: "fal"
                    },
                    "Font Awesome 5 Brands": {
                        400: "fab",
                        normal: "fab"
                    },
                    "Font Awesome 5 Duotone": {
                        900: "fad"
                    }
                }), {
                    "Font Awesome Kit": {
                        400: "fak",
                        normal: "fak"
                    },
                    "Font Awesome Kit Duotone": {
                        400: "fakd",
                        normal: "fakd"
                    }
                }), gg = Object.keys(fg).reduce((le1, vt)=>(le1[vt.toLowerCase()] = fg[vt], le1), {}), Ag = Object.keys(gg).reduce((le1, vt)=>{
                    const bt = gg[vt];
                    return le1[vt] = bt[900] || [
                        ...Object.entries(bt)
                    ][0][1], le1;
                }, {});
                function replaceForPosition(le1, vt) {
                    const bt = "".concat("data-fa-pseudo-element-pending").concat(vt.replace(":", "-"));
                    return new Promise((ls, ho)=>{
                        if (null !== le1.getAttribute(bt)) return ls();
                        const Dl = toArray(le1.children).filter((le1)=>le1.getAttribute(im) === vt)[0], Fl = uc.getComputedStyle(le1, vt), sc = Fl.getPropertyValue("font-family"), gc = sc.match(Am), Ac = Fl.getPropertyValue("font-weight"), Ec = Fl.getPropertyValue("content");
                        if (Dl && !gc) return le1.removeChild(Dl), ls();
                        if (gc && "none" !== Ec && "" !== Ec) {
                            const uc = Fl.getPropertyValue("content");
                            let Ec = function(le1, vt) {
                                const bt = le1.replace(/^['"]|['"]$/g, "").toLowerCase(), ls = parseInt(vt), ho = isNaN(ls) ? "normal" : ls;
                                return (gg[bt] || {})[ho] || Ag[bt];
                            }(sc, Ac);
                            const { value: kc, isSecondary: du } = function(le1) {
                                const vt = le1.replace(pg, ""), bt = function(le1, vt) {
                                    const bt = le1.length;
                                    let ls, ho = le1.charCodeAt(vt);
                                    return ho >= 55296 && ho <= 56319 && bt > vt + 1 && (ls = le1.charCodeAt(vt + 1), ls >= 56320 && ls <= 57343) ? 1024 * (ho - 55296) + ls - 56320 + 65536 : ho;
                                }(vt, 0), ls = bt >= mg[0] && bt <= mg[1], ho = 2 === vt.length && vt[0] === vt[1];
                                return {
                                    value: toHex(ho ? vt[0] : vt),
                                    isSecondary: ls || ho
                                };
                            }(uc), _u = gc[0].startsWith("FontAwesome");
                            let Md = byUnicode(Ec, kc), Ld = Md;
                            if (_u) {
                                const le1 = function(le1) {
                                    const vt = Vm[le1], bt = byUnicode("fas", le1);
                                    return vt || (bt ? {
                                        prefix: "fas",
                                        iconName: bt
                                    } : null) || {
                                        prefix: null,
                                        iconName: null
                                    };
                                }(kc);
                                le1.iconName && le1.prefix && (Md = le1.iconName, Ec = le1.prefix);
                            }
                            if (!Md || du || Dl && Dl.getAttribute(nm) === Ec && Dl.getAttribute(rm) === Ld) ls();
                            else {
                                le1.setAttribute(bt, Ld), Dl && le1.removeChild(Dl);
                                const Fl = {
                                    iconName: null,
                                    title: null,
                                    titleId: null,
                                    prefix: null,
                                    transform: Tm,
                                    symbol: !1,
                                    mask: {
                                        iconName: null,
                                        prefix: null,
                                        rest: []
                                    },
                                    maskId: null,
                                    extra: {
                                        classes: [],
                                        styles: {},
                                        attributes: {}
                                    }
                                }, { extra: sc } = Fl;
                                sc.attributes[im] = vt, findIcon(Md, Ec).then((ho)=>{
                                    const Dl = makeInlineSvgAbstract(_objectSpread2(_objectSpread2({}, Fl), {}, {
                                        icons: {
                                            main: ho,
                                            mask: {
                                                prefix: null,
                                                iconName: null,
                                                rest: []
                                            }
                                        },
                                        prefix: Ec,
                                        iconName: Ld,
                                        extra: sc,
                                        watchable: !0
                                    })), uc = mc.createElementNS("http://www.w3.org/2000/svg", "svg");
                                    "::before" === vt ? le1.insertBefore(uc, le1.firstChild) : le1.appendChild(uc), uc.outerHTML = Dl.map((le1)=>toHtml(le1)).join("\n"), le1.removeAttribute(bt), ls();
                                }).catch(ho);
                            }
                        } else ls();
                    });
                }
                function replace(le1) {
                    return Promise.all([
                        replaceForPosition(le1, "::before"),
                        replaceForPosition(le1, "::after")
                    ]);
                }
                function processable(le1) {
                    return le1.parentNode !== document.head && !~sm.indexOf(le1.tagName.toUpperCase()) && !le1.getAttribute(im) && (!le1.parentNode || "svg" !== le1.parentNode.tagName);
                }
                function searchPseudoElements(le1) {
                    if (Ec) return new Promise((vt, bt)=>{
                        const ls = toArray(le1.querySelectorAll("*")).filter(processable).map(replace), ho = perf_begin("searchPseudoElements");
                        disableObservation(), Promise.all(ls).then(()=>{
                            ho(), enableObservation(), vt();
                        }).catch(()=>{
                            ho(), enableObservation(), bt();
                        });
                    });
                }
                var _g = {
                    hooks: ()=>({
                            mutationObserverCallbacks: (le1)=>(le1.pseudoElementsCallback = searchPseudoElements, le1)
                        }),
                    provides (le1) {
                        le1.pseudoElements2svg = function(le1) {
                            const { node: vt = mc } = le1;
                            Em.searchPseudoElements && searchPseudoElements(vt);
                        };
                    }
                };
                let yg = !1;
                var vg = {
                    mixout: ()=>({
                            dom: {
                                unwatch () {
                                    disableObservation(), yg = !0;
                                }
                            }
                        }),
                    hooks: ()=>({
                            bootstrap () {
                                observe(chainHooks("mutationObserverCallbacks", {}));
                            },
                            noAuto () {
                                og && og.disconnect();
                            },
                            watch (le1) {
                                const { observeMutationsRoot: vt } = le1;
                                yg ? enableObservation() : observe(chainHooks("mutationObserverCallbacks", {
                                    observeMutationsRoot: vt
                                }));
                            }
                        })
                };
                const parseTransformString = (le1)=>le1.toLowerCase().split(" ").reduce((le1, vt)=>{
                        const bt = vt.toLowerCase().split("-"), ls = bt[0];
                        let ho = bt.slice(1).join("-");
                        if (ls && "h" === ho) return le1.flipX = !0, le1;
                        if (ls && "v" === ho) return le1.flipY = !0, le1;
                        if (ho = parseFloat(ho), isNaN(ho)) return le1;
                        switch(ls){
                            case "grow":
                                le1.size = le1.size + ho;
                                break;
                            case "shrink":
                                le1.size = le1.size - ho;
                                break;
                            case "left":
                                le1.x = le1.x - ho;
                                break;
                            case "right":
                                le1.x = le1.x + ho;
                                break;
                            case "up":
                                le1.y = le1.y - ho;
                                break;
                            case "down":
                                le1.y = le1.y + ho;
                                break;
                            case "rotate":
                                le1.rotate = le1.rotate + ho;
                        }
                        return le1;
                    }, {
                        size: 16,
                        x: 0,
                        y: 0,
                        flipX: !1,
                        flipY: !1,
                        rotate: 0
                    });
                var xg = {
                    mixout: ()=>({
                            parse: {
                                transform: (le1)=>parseTransformString(le1)
                            }
                        }),
                    hooks: ()=>({
                            parseNodeAttributes (le1, vt) {
                                const bt = vt.getAttribute("data-fa-transform");
                                return bt && (le1.transform = parseTransformString(bt)), le1;
                            }
                        }),
                    provides (le1) {
                        le1.generateAbstractTransformGrouping = function(le1) {
                            let { main: vt, transform: bt, containerWidth: ls, iconWidth: ho } = le1;
                            const Dl = {
                                transform: "translate(".concat(ls / 2, " 256)")
                            }, Fl = "translate(".concat(32 * bt.x, ", ").concat(32 * bt.y, ") "), sc = "scale(".concat(bt.size / 16 * (bt.flipX ? -1 : 1), ", ").concat(bt.size / 16 * (bt.flipY ? -1 : 1), ") "), uc = "rotate(".concat(bt.rotate, " 0 0)"), mc = {
                                outer: Dl,
                                inner: {
                                    transform: "".concat(Fl, " ").concat(sc, " ").concat(uc)
                                },
                                path: {
                                    transform: "translate(".concat(ho / 2 * -1, " -256)")
                                }
                            };
                            return {
                                tag: "g",
                                attributes: _objectSpread2({}, mc.outer),
                                children: [
                                    {
                                        tag: "g",
                                        attributes: _objectSpread2({}, mc.inner),
                                        children: [
                                            {
                                                tag: vt.icon.tag,
                                                children: vt.icon.children,
                                                attributes: _objectSpread2(_objectSpread2({}, vt.icon.attributes), mc.path)
                                            }
                                        ]
                                    }
                                ]
                            };
                        };
                    }
                };
                const bg = {
                    x: 0,
                    y: 0,
                    width: "100%",
                    height: "100%"
                };
                function fillBlack(le1) {
                    let vt = !(arguments.length > 1 && void 0 !== arguments[1]) || arguments[1];
                    return le1.attributes && (le1.attributes.fill || vt) && (le1.attributes.fill = "black"), le1;
                }
                var wg = {
                    hooks: ()=>({
                            parseNodeAttributes (le1, vt) {
                                const bt = vt.getAttribute("data-fa-mask"), ls = bt ? getCanonicalIcon(bt.split(" ").map((le1)=>le1.trim())) : {
                                    prefix: null,
                                    iconName: null,
                                    rest: []
                                };
                                return ls.prefix || (ls.prefix = getDefaultUsablePrefix()), le1.mask = ls, le1.maskId = vt.getAttribute("data-fa-mask-id"), le1;
                            }
                        }),
                    provides (le1) {
                        le1.generateAbstractMask = function(le1) {
                            let { children: vt, attributes: bt, main: ls, mask: ho, maskId: Dl, transform: Fl } = le1;
                            const { width: sc, icon: uc } = ls, { width: mc, icon: gc } = ho, Ac = function(le1) {
                                let { transform: vt, containerWidth: bt, iconWidth: ls } = le1;
                                const ho = {
                                    transform: "translate(".concat(bt / 2, " 256)")
                                }, Dl = "translate(".concat(32 * vt.x, ", ").concat(32 * vt.y, ") "), Fl = "scale(".concat(vt.size / 16 * (vt.flipX ? -1 : 1), ", ").concat(vt.size / 16 * (vt.flipY ? -1 : 1), ") "), sc = "rotate(".concat(vt.rotate, " 0 0)");
                                return {
                                    outer: ho,
                                    inner: {
                                        transform: "".concat(Dl, " ").concat(Fl, " ").concat(sc)
                                    },
                                    path: {
                                        transform: "translate(".concat(ls / 2 * -1, " -256)")
                                    }
                                };
                            }({
                                transform: Fl,
                                containerWidth: mc,
                                iconWidth: sc
                            }), Ec = {
                                tag: "rect",
                                attributes: _objectSpread2(_objectSpread2({}, bg), {}, {
                                    fill: "white"
                                })
                            }, kc = uc.children ? {
                                children: uc.children.map(fillBlack)
                            } : {}, du = {
                                tag: "g",
                                attributes: _objectSpread2({}, Ac.inner),
                                children: [
                                    fillBlack(_objectSpread2({
                                        tag: uc.tag,
                                        attributes: _objectSpread2(_objectSpread2({}, uc.attributes), Ac.path)
                                    }, kc))
                                ]
                            }, _u = {
                                tag: "g",
                                attributes: _objectSpread2({}, Ac.outer),
                                children: [
                                    du
                                ]
                            }, Md = "mask-".concat(Dl || nextUniqueId()), Ld = "clip-".concat(Dl || nextUniqueId()), Nd = {
                                tag: "mask",
                                attributes: _objectSpread2(_objectSpread2({}, bg), {}, {
                                    id: Md,
                                    maskUnits: "userSpaceOnUse",
                                    maskContentUnits: "userSpaceOnUse"
                                }),
                                children: [
                                    Ec,
                                    _u
                                ]
                            }, Rd = {
                                tag: "defs",
                                children: [
                                    {
                                        tag: "clipPath",
                                        attributes: {
                                            id: Ld
                                        },
                                        children: (Od = gc, "g" === Od.tag ? Od.children : [
                                            Od
                                        ])
                                    },
                                    Nd
                                ]
                            };
                            var Od;
                            return vt.push(Rd, {
                                tag: "rect",
                                attributes: _objectSpread2({
                                    fill: "currentColor",
                                    "clip-path": "url(#".concat(Ld, ")"),
                                    mask: "url(#".concat(Md, ")")
                                }, bg)
                            }), {
                                children: vt,
                                attributes: bt
                            };
                        };
                    }
                }, Eg = {
                    provides (le1) {
                        let vt = !1;
                        uc.matchMedia && (vt = uc.matchMedia("(prefers-reduced-motion: reduce)").matches), le1.missingIconAbstract = function() {
                            const le1 = [], bt = {
                                fill: "currentColor"
                            }, ls = {
                                attributeType: "XML",
                                repeatCount: "indefinite",
                                dur: "2s"
                            };
                            le1.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, bt), {}, {
                                    d: "M156.5,447.7l-12.6,29.5c-18.7-9.5-35.9-21.2-51.5-34.9l22.7-22.7C127.6,430.5,141.5,440,156.5,447.7z M40.6,272H8.5 c1.4,21.2,5.4,41.7,11.7,61.1L50,321.2C45.1,305.5,41.8,289,40.6,272z M40.6,240c1.4-18.8,5.2-37,11.1-54.1l-29.5-12.6 C14.7,194.3,10,216.7,8.5,240H40.6z M64.3,156.5c7.8-14.9,17.2-28.8,28.1-41.5L69.7,92.3c-13.7,15.6-25.5,32.8-34.9,51.5 L64.3,156.5z M397,419.6c-13.9,12-29.4,22.3-46.1,30.4l11.9,29.8c20.7-9.9,39.8-22.6,56.9-37.6L397,419.6z M115,92.4 c13.9-12,29.4-22.3,46.1-30.4l-11.9-29.8c-20.7,9.9-39.8,22.6-56.8,37.6L115,92.4z M447.7,355.5c-7.8,14.9-17.2,28.8-28.1,41.5 l22.7,22.7c13.7-15.6,25.5-32.9,34.9-51.5L447.7,355.5z M471.4,272c-1.4,18.8-5.2,37-11.1,54.1l29.5,12.6 c7.5-21.1,12.2-43.5,13.6-66.8H471.4z M321.2,462c-15.7,5-32.2,8.2-49.2,9.4v32.1c21.2-1.4,41.7-5.4,61.1-11.7L321.2,462z M240,471.4c-18.8-1.4-37-5.2-54.1-11.1l-12.6,29.5c21.1,7.5,43.5,12.2,66.8,13.6V471.4z M462,190.8c5,15.7,8.2,32.2,9.4,49.2h32.1 c-1.4-21.2-5.4-41.7-11.7-61.1L462,190.8z M92.4,397c-12-13.9-22.3-29.4-30.4-46.1l-29.8,11.9c9.9,20.7,22.6,39.8,37.6,56.9 L92.4,397z M272,40.6c18.8,1.4,36.9,5.2,54.1,11.1l12.6-29.5C317.7,14.7,295.3,10,272,8.5V40.6z M190.8,50 c15.7-5,32.2-8.2,49.2-9.4V8.5c-21.2,1.4-41.7,5.4-61.1,11.7L190.8,50z M442.3,92.3L419.6,115c12,13.9,22.3,29.4,30.5,46.1 l29.8-11.9C470,128.5,457.3,109.4,442.3,92.3z M397,92.4l22.7-22.7c-15.6-13.7-32.8-25.5-51.5-34.9l-12.6,29.5 C370.4,72.1,384.4,81.5,397,92.4z"
                                })
                            });
                            const ho = _objectSpread2(_objectSpread2({}, ls), {}, {
                                attributeName: "opacity"
                            }), Dl = {
                                tag: "circle",
                                attributes: _objectSpread2(_objectSpread2({}, bt), {}, {
                                    cx: "256",
                                    cy: "364",
                                    r: "28"
                                }),
                                children: []
                            };
                            return vt || Dl.children.push({
                                tag: "animate",
                                attributes: _objectSpread2(_objectSpread2({}, ls), {}, {
                                    attributeName: "r",
                                    values: "28;14;28;28;14;28;"
                                })
                            }, {
                                tag: "animate",
                                attributes: _objectSpread2(_objectSpread2({}, ho), {}, {
                                    values: "1;0;1;1;0;1;"
                                })
                            }), le1.push(Dl), le1.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, bt), {}, {
                                    opacity: "1",
                                    d: "M263.7,312h-16c-6.6,0-12-5.4-12-12c0-71,77.4-63.9,77.4-107.8c0-20-17.8-40.2-57.4-40.2c-29.1,0-44.3,9.6-59.2,28.7 c-3.9,5-11.1,6-16.2,2.4l-13.1-9.2c-5.6-3.9-6.9-11.8-2.6-17.2c21.2-27.2,46.4-44.7,91.2-44.7c52.3,0,97.4,29.8,97.4,80.2 c0,67.6-77.4,63.5-77.4,107.8C275.7,306.6,270.3,312,263.7,312z"
                                }),
                                children: vt ? [] : [
                                    {
                                        tag: "animate",
                                        attributes: _objectSpread2(_objectSpread2({}, ho), {}, {
                                            values: "1;0;0;0;0;1;"
                                        })
                                    }
                                ]
                            }), vt || le1.push({
                                tag: "path",
                                attributes: _objectSpread2(_objectSpread2({}, bt), {}, {
                                    opacity: "0",
                                    d: "M232.5,134.5l7,168c0.3,6.4,5.6,11.5,12,11.5h9c6.4,0,11.7-5.1,12-11.5l7-168c0.3-6.8-5.2-12.5-12-12.5h-23 C237.7,122,232.2,127.7,232.5,134.5z"
                                }),
                                children: [
                                    {
                                        tag: "animate",
                                        attributes: _objectSpread2(_objectSpread2({}, ho), {}, {
                                            values: "0;0;1;1;0;0;"
                                        })
                                    }
                                ]
                            }), {
                                tag: "g",
                                attributes: {
                                    class: "missing"
                                },
                                children: le1
                            };
                        };
                    }
                };
                !function(le1, vt) {
                    let { mixoutsTo: bt } = vt;
                    Zm = le1, Ym = {}, Object.keys(Qm).forEach((le1)=>{
                        -1 === Xm.indexOf(le1) && delete Qm[le1];
                    }), Zm.forEach((le1)=>{
                        const vt = le1.mixout ? le1.mixout() : {};
                        if (Object.keys(vt).forEach((le1)=>{
                            "function" === typeof vt[le1] && (bt[le1] = vt[le1]), "object" === typeof vt[le1] && Object.keys(vt[le1]).forEach((ls)=>{
                                bt[le1] || (bt[le1] = {}), bt[le1][ls] = vt[le1][ls];
                            });
                        }), le1.hooks) {
                            const vt = le1.hooks();
                            Object.keys(vt).forEach((le1)=>{
                                Ym[le1] || (Ym[le1] = []), Ym[le1].push(vt[le1]);
                            });
                        }
                        le1.provides && le1.provides(Qm);
                    });
                }([
                    Cm,
                    cg,
                    ug,
                    hg,
                    dg,
                    _g,
                    vg,
                    xg,
                    wg,
                    Eg,
                    {
                        hooks: ()=>({
                                parseNodeAttributes (le1, vt) {
                                    const bt = vt.getAttribute("data-fa-symbol"), ls = null !== bt && ("" === bt || bt);
                                    return le1.symbol = ls, le1;
                                }
                            })
                    }
                ], {
                    mixoutsTo: eg
                });
                const Mg = eg.icon;
            },
            4161: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    AH: ()=>i,
                    Rf: ()=>S,
                    iz: ()=>r,
                    sk: ()=>sc
                });
                /**
 * @license
 * Copyright 2019 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const ls = globalThis, ho = ls.ShadowRoot && (void 0 === ls.ShadyCSS || ls.ShadyCSS.nativeShadow) && "adoptedStyleSheets" in Document.prototype && "replace" in CSSStyleSheet.prototype, Dl = Symbol(), Fl = new WeakMap;
                class n {
                    constructor(le1, vt, bt){
                        if (this._$cssResult$ = !0, bt !== Dl) throw Error("CSSResult is not constructable. Use `unsafeCSS` or `css` instead.");
                        this.cssText = le1, this.t = vt;
                    }
                    get styleSheet() {
                        let le1 = this.o;
                        const vt = this.t;
                        if (ho && void 0 === le1) {
                            const bt = void 0 !== vt && 1 === vt.length;
                            bt && (le1 = Fl.get(vt)), void 0 === le1 && ((this.o = le1 = new CSSStyleSheet).replaceSync(this.cssText), bt && Fl.set(vt, le1));
                        }
                        return le1;
                    }
                    toString() {
                        return this.cssText;
                    }
                }
                const r = (le1)=>new n("string" == typeof le1 ? le1 : le1 + "", void 0, Dl), i = function(le1) {
                    for(var vt = arguments.length, bt = new Array(vt > 1 ? vt - 1 : 0), ls = 1; ls < vt; ls++)bt[ls - 1] = arguments[ls];
                    const ho = 1 === le1.length ? le1[0] : bt.reduce((vt, bt, ls)=>vt + ((le1)=>{
                            if (!0 === le1._$cssResult$) return le1.cssText;
                            if ("number" == typeof le1) return le1;
                            throw Error("Value passed to 'css' function must be a 'css' function result: " + le1 + ". Use 'unsafeCSS' to pass non-literal values, but take care to ensure page security.");
                        })(bt) + le1[ls + 1], le1[0]);
                    return new n(ho, le1, Dl);
                }, S = (le1, vt)=>{
                    if (ho) le1.adoptedStyleSheets = vt.map((le1)=>le1 instanceof CSSStyleSheet ? le1 : le1.styleSheet);
                    else for (const bt of vt){
                        const vt = document.createElement("style"), ho = ls.litNonce;
                        void 0 !== ho && vt.setAttribute("nonce", ho), vt.textContent = bt.cssText, le1.appendChild(vt);
                    }
                }, sc = ho ? (le1)=>le1 : (le1)=>le1 instanceof CSSStyleSheet ? ((le1)=>{
                        let vt = "";
                        for (const bt of le1.cssRules)vt += bt.cssText;
                        return r(vt);
                    })(le1) : le1;
            },
            8789: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    AH: ()=>ls.AH,
                    iz: ()=>ls.iz,
                    mN: ()=>b
                });
                var ls = bt(4161);
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const { is: ho, defineProperty: Dl, getOwnPropertyDescriptor: Fl, getOwnPropertyNames: sc, getOwnPropertySymbols: uc, getPrototypeOf: mc } = Object, gc = globalThis, Ac = gc.trustedTypes, Ec = Ac ? Ac.emptyScript : "", kc = gc.reactiveElementPolyfillSupport, d = (le1, vt)=>le1, du = {
                    toAttribute (le1, vt) {
                        switch(vt){
                            case Boolean:
                                le1 = le1 ? Ec : null;
                                break;
                            case Object:
                            case Array:
                                le1 = null == le1 ? le1 : JSON.stringify(le1);
                        }
                        return le1;
                    },
                    fromAttribute (le1, vt) {
                        let bt = le1;
                        switch(vt){
                            case Boolean:
                                bt = null !== le1;
                                break;
                            case Number:
                                bt = null === le1 ? null : Number(le1);
                                break;
                            case Object:
                            case Array:
                                try {
                                    bt = JSON.parse(le1);
                                } catch (le1) {
                                    bt = null;
                                }
                        }
                        return bt;
                    }
                }, f = (le1, vt)=>!ho(le1, vt), _u = {
                    attribute: !0,
                    type: String,
                    converter: du,
                    reflect: !1,
                    hasChanged: f
                };
                Symbol.metadata ??= Symbol("metadata"), gc.litPropertyMetadata ??= new WeakMap;
                class b extends HTMLElement {
                    static addInitializer(le1) {
                        this._$Ei(), (this.l ??= []).push(le1);
                    }
                    static get observedAttributes() {
                        return this.finalize(), this._$Eh && [
                            ...this._$Eh.keys()
                        ];
                    }
                    static createProperty(le1, vt) {
                        if (void 0 === vt && (vt = _u), vt.state && (vt.attribute = !1), this._$Ei(), this.elementProperties.set(le1, vt), !vt.noAccessor) {
                            const bt = Symbol(), ls = this.getPropertyDescriptor(le1, bt, vt);
                            void 0 !== ls && Dl(this.prototype, le1, ls);
                        }
                    }
                    static getPropertyDescriptor(le1, vt, bt) {
                        const { get: ls, set: ho } = Fl(this.prototype, le1) ?? {
                            get () {
                                return this[vt];
                            },
                            set (le1) {
                                this[vt] = le1;
                            }
                        };
                        return {
                            get () {
                                return ls?.call(this);
                            },
                            set (vt) {
                                const Dl = ls?.call(this);
                                ho.call(this, vt), this.requestUpdate(le1, Dl, bt);
                            },
                            configurable: !0,
                            enumerable: !0
                        };
                    }
                    static getPropertyOptions(le1) {
                        return this.elementProperties.get(le1) ?? _u;
                    }
                    static _$Ei() {
                        if (this.hasOwnProperty(d("elementProperties"))) return;
                        const le1 = mc(this);
                        le1.finalize(), void 0 !== le1.l && (this.l = [
                            ...le1.l
                        ]), this.elementProperties = new Map(le1.elementProperties);
                    }
                    static finalize() {
                        if (this.hasOwnProperty(d("finalized"))) return;
                        if (this.finalized = !0, this._$Ei(), this.hasOwnProperty(d("properties"))) {
                            const le1 = this.properties, vt = [
                                ...sc(le1),
                                ...uc(le1)
                            ];
                            for (const bt of vt)this.createProperty(bt, le1[bt]);
                        }
                        const le1 = this[Symbol.metadata];
                        if (null !== le1) {
                            const vt = litPropertyMetadata.get(le1);
                            if (void 0 !== vt) for (const [le1, bt] of vt)this.elementProperties.set(le1, bt);
                        }
                        this._$Eh = new Map;
                        for (const [vt, bt] of this.elementProperties){
                            const le1 = this._$Eu(vt, bt);
                            void 0 !== le1 && this._$Eh.set(le1, vt);
                        }
                        this.elementStyles = this.finalizeStyles(this.styles);
                    }
                    static finalizeStyles(le1) {
                        const vt = [];
                        if (Array.isArray(le1)) {
                            const bt = new Set(le1.flat(1 / 0).reverse());
                            for (const le1 of bt)vt.unshift((0, ls.sk)(le1));
                        } else void 0 !== le1 && vt.push((0, ls.sk)(le1));
                        return vt;
                    }
                    static _$Eu(le1, vt) {
                        const bt = vt.attribute;
                        return !1 === bt ? void 0 : "string" == typeof bt ? bt : "string" == typeof le1 ? le1.toLowerCase() : void 0;
                    }
                    constructor(){
                        super(), this._$Ep = void 0, this.isUpdatePending = !1, this.hasUpdated = !1, this._$Em = null, this._$Ev();
                    }
                    _$Ev() {
                        this._$ES = new Promise((le1)=>this.enableUpdating = le1), this._$AL = new Map, this._$E_(), this.requestUpdate(), this.constructor.l?.forEach((le1)=>le1(this));
                    }
                    addController(le1) {
                        (this._$EO ??= new Set).add(le1), void 0 !== this.renderRoot && this.isConnected && le1.hostConnected?.();
                    }
                    removeController(le1) {
                        this._$EO?.delete(le1);
                    }
                    _$E_() {
                        const le1 = new Map, vt = this.constructor.elementProperties;
                        for (const bt of vt.keys())this.hasOwnProperty(bt) && (le1.set(bt, this[bt]), delete this[bt]);
                        le1.size > 0 && (this._$Ep = le1);
                    }
                    createRenderRoot() {
                        const le1 = this.shadowRoot ?? this.attachShadow(this.constructor.shadowRootOptions);
                        return (0, ls.Rf)(le1, this.constructor.elementStyles), le1;
                    }
                    connectedCallback() {
                        this.renderRoot ??= this.createRenderRoot(), this.enableUpdating(!0), this._$EO?.forEach((le1)=>le1.hostConnected?.());
                    }
                    enableUpdating(le1) {}
                    disconnectedCallback() {
                        this._$EO?.forEach((le1)=>le1.hostDisconnected?.());
                    }
                    attributeChangedCallback(le1, vt, bt) {
                        this._$AK(le1, bt);
                    }
                    _$EC(le1, vt) {
                        const bt = this.constructor.elementProperties.get(le1), ls = this.constructor._$Eu(le1, bt);
                        if (void 0 !== ls && !0 === bt.reflect) {
                            const ho = (void 0 !== bt.converter?.toAttribute ? bt.converter : du).toAttribute(vt, bt.type);
                            this._$Em = le1, null == ho ? this.removeAttribute(ls) : this.setAttribute(ls, ho), this._$Em = null;
                        }
                    }
                    _$AK(le1, vt) {
                        const bt = this.constructor, ls = bt._$Eh.get(le1);
                        if (void 0 !== ls && this._$Em !== ls) {
                            const le1 = bt.getPropertyOptions(ls), ho = "function" == typeof le1.converter ? {
                                fromAttribute: le1.converter
                            } : void 0 !== le1.converter?.fromAttribute ? le1.converter : du;
                            this._$Em = ls, this[ls] = ho.fromAttribute(vt, le1.type), this._$Em = null;
                        }
                    }
                    requestUpdate(le1, vt, bt) {
                        if (void 0 !== le1) {
                            if (bt ??= this.constructor.getPropertyOptions(le1), !(bt.hasChanged ?? f)(this[le1], vt)) return;
                            this.P(le1, vt, bt);
                        }
                        !1 === this.isUpdatePending && (this._$ES = this._$ET());
                    }
                    P(le1, vt, bt) {
                        this._$AL.has(le1) || this._$AL.set(le1, vt), !0 === bt.reflect && this._$Em !== le1 && (this._$Ej ??= new Set).add(le1);
                    }
                    async _$ET() {
                        this.isUpdatePending = !0;
                        try {
                            await this._$ES;
                        } catch (le1) {
                            Promise.reject(le1);
                        }
                        const le1 = this.scheduleUpdate();
                        return null != le1 && await le1, !this.isUpdatePending;
                    }
                    scheduleUpdate() {
                        return this.performUpdate();
                    }
                    performUpdate() {
                        if (!this.isUpdatePending) return;
                        if (!this.hasUpdated) {
                            if (this.renderRoot ??= this.createRenderRoot(), this._$Ep) {
                                for (const [le1, vt] of this._$Ep)this[le1] = vt;
                                this._$Ep = void 0;
                            }
                            const le1 = this.constructor.elementProperties;
                            if (le1.size > 0) for (const [vt, bt] of le1)!0 !== bt.wrapped || this._$AL.has(vt) || void 0 === this[vt] || this.P(vt, this[vt], bt);
                        }
                        let le1 = !1;
                        const vt = this._$AL;
                        try {
                            le1 = this.shouldUpdate(vt), le1 ? (this.willUpdate(vt), this._$EO?.forEach((le1)=>le1.hostUpdate?.()), this.update(vt)) : this._$EU();
                        } catch (vt) {
                            throw le1 = !1, this._$EU(), vt;
                        }
                        le1 && this._$AE(vt);
                    }
                    willUpdate(le1) {}
                    _$AE(le1) {
                        this._$EO?.forEach((le1)=>le1.hostUpdated?.()), this.hasUpdated || (this.hasUpdated = !0, this.firstUpdated(le1)), this.updated(le1);
                    }
                    _$EU() {
                        this._$AL = new Map, this.isUpdatePending = !1;
                    }
                    get updateComplete() {
                        return this.getUpdateComplete();
                    }
                    getUpdateComplete() {
                        return this._$ES;
                    }
                    shouldUpdate(le1) {
                        return !0;
                    }
                    update(le1) {
                        this._$Ej &&= this._$Ej.forEach((le1)=>this._$EC(le1, this[le1])), this._$EU();
                    }
                    updated(le1) {}
                    firstUpdated(le1) {}
                }
                b.elementStyles = [], b.shadowRootOptions = {
                    mode: "open"
                }, b[d("elementProperties")] = new Map, b[d("finalized")] = new Map, kc?.({
                    ReactiveElement: b
                }), (gc.reactiveElementVersions ??= []).push("2.0.4");
            },
            4352: (le1, vt, bt)=>{
                "use strict";
                function Point(le1, vt) {
                    this.x = le1, this.y = vt;
                }
                bt.d(vt, {
                    A: ()=>Point
                }), Point.prototype = {
                    clone () {
                        return new Point(this.x, this.y);
                    },
                    add (le1) {
                        return this.clone()._add(le1);
                    },
                    sub (le1) {
                        return this.clone()._sub(le1);
                    },
                    multByPoint (le1) {
                        return this.clone()._multByPoint(le1);
                    },
                    divByPoint (le1) {
                        return this.clone()._divByPoint(le1);
                    },
                    mult (le1) {
                        return this.clone()._mult(le1);
                    },
                    div (le1) {
                        return this.clone()._div(le1);
                    },
                    rotate (le1) {
                        return this.clone()._rotate(le1);
                    },
                    rotateAround (le1, vt) {
                        return this.clone()._rotateAround(le1, vt);
                    },
                    matMult (le1) {
                        return this.clone()._matMult(le1);
                    },
                    unit () {
                        return this.clone()._unit();
                    },
                    perp () {
                        return this.clone()._perp();
                    },
                    round () {
                        return this.clone()._round();
                    },
                    mag () {
                        return Math.sqrt(this.x * this.x + this.y * this.y);
                    },
                    equals (le1) {
                        return this.x === le1.x && this.y === le1.y;
                    },
                    dist (le1) {
                        return Math.sqrt(this.distSqr(le1));
                    },
                    distSqr (le1) {
                        const vt = le1.x - this.x, bt = le1.y - this.y;
                        return vt * vt + bt * bt;
                    },
                    angle () {
                        return Math.atan2(this.y, this.x);
                    },
                    angleTo (le1) {
                        return Math.atan2(this.y - le1.y, this.x - le1.x);
                    },
                    angleWith (le1) {
                        return this.angleWithSep(le1.x, le1.y);
                    },
                    angleWithSep (le1, vt) {
                        return Math.atan2(this.x * vt - this.y * le1, this.x * le1 + this.y * vt);
                    },
                    _matMult (le1) {
                        const vt = le1[0] * this.x + le1[1] * this.y, bt = le1[2] * this.x + le1[3] * this.y;
                        return this.x = vt, this.y = bt, this;
                    },
                    _add (le1) {
                        return this.x += le1.x, this.y += le1.y, this;
                    },
                    _sub (le1) {
                        return this.x -= le1.x, this.y -= le1.y, this;
                    },
                    _mult (le1) {
                        return this.x *= le1, this.y *= le1, this;
                    },
                    _div (le1) {
                        return this.x /= le1, this.y /= le1, this;
                    },
                    _multByPoint (le1) {
                        return this.x *= le1.x, this.y *= le1.y, this;
                    },
                    _divByPoint (le1) {
                        return this.x /= le1.x, this.y /= le1.y, this;
                    },
                    _unit () {
                        return this._div(this.mag()), this;
                    },
                    _perp () {
                        const le1 = this.y;
                        return this.y = this.x, this.x = -le1, this;
                    },
                    _rotate (le1) {
                        const vt = Math.cos(le1), bt = Math.sin(le1), ls = vt * this.x - bt * this.y, ho = bt * this.x + vt * this.y;
                        return this.x = ls, this.y = ho, this;
                    },
                    _rotateAround (le1, vt) {
                        const bt = Math.cos(le1), ls = Math.sin(le1), ho = vt.x + bt * (this.x - vt.x) - ls * (this.y - vt.y), Dl = vt.y + ls * (this.x - vt.x) + bt * (this.y - vt.y);
                        return this.x = ho, this.y = Dl, this;
                    },
                    _round () {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                    },
                    constructor: Point
                }, Point.convert = function(le1) {
                    if (le1 instanceof Point) return le1;
                    if (Array.isArray(le1)) return new Point(+le1[0], +le1[1]);
                    if (void 0 !== le1.x && void 0 !== le1.y) return new Point(+le1.x, +le1.y);
                    throw new Error("Expected [x, y] or {x, y} point format");
                };
            },
            8293: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    cW: ()=>VectorTile
                });
                var ls = bt(4352);
                class VectorTileFeature {
                    constructor(le1, vt, bt, ls, ho){
                        this.properties = {}, this.extent = bt, this.type = 0, this.id = void 0, this._pbf = le1, this._geometry = -1, this._keys = ls, this._values = ho, le1.readFields(readFeature, this, vt);
                    }
                    loadGeometry() {
                        const le1 = this._pbf;
                        le1.pos = this._geometry;
                        const vt = le1.readVarint() + le1.pos, bt = [];
                        let ho, Dl = 1, Fl = 0, sc = 0, uc = 0;
                        for(; le1.pos < vt;){
                            if (Fl <= 0) {
                                const vt = le1.readVarint();
                                Dl = 7 & vt, Fl = vt >> 3;
                            }
                            if (Fl--, 1 === Dl || 2 === Dl) sc += le1.readSVarint(), uc += le1.readSVarint(), 1 === Dl && (ho && bt.push(ho), ho = []), ho && ho.push(new ls.A(sc, uc));
                            else {
                                if (7 !== Dl) throw new Error(`unknown command ${Dl}`);
                                ho && ho.push(ho[0].clone());
                            }
                        }
                        return ho && bt.push(ho), bt;
                    }
                    bbox() {
                        const le1 = this._pbf;
                        le1.pos = this._geometry;
                        const vt = le1.readVarint() + le1.pos;
                        let bt = 1, ls = 0, ho = 0, Dl = 0, Fl = 1 / 0, sc = -1 / 0, uc = 1 / 0, mc = -1 / 0;
                        for(; le1.pos < vt;){
                            if (ls <= 0) {
                                const vt = le1.readVarint();
                                bt = 7 & vt, ls = vt >> 3;
                            }
                            if (ls--, 1 === bt || 2 === bt) ho += le1.readSVarint(), Dl += le1.readSVarint(), ho < Fl && (Fl = ho), ho > sc && (sc = ho), Dl < uc && (uc = Dl), Dl > mc && (mc = Dl);
                            else if (7 !== bt) throw new Error(`unknown command ${bt}`);
                        }
                        return [
                            Fl,
                            uc,
                            sc,
                            mc
                        ];
                    }
                    toGeoJSON(le1, vt, bt) {
                        const ls = this.extent * Math.pow(2, bt), ho = this.extent * le1, Dl = this.extent * vt, Fl = this.loadGeometry();
                        function projectPoint(le1) {
                            return [
                                360 * (le1.x + ho) / ls - 180,
                                360 / Math.PI * Math.atan(Math.exp((1 - 2 * (le1.y + Dl) / ls) * Math.PI)) - 90
                            ];
                        }
                        function projectLine(le1) {
                            return le1.map(projectPoint);
                        }
                        let sc;
                        if (1 === this.type) {
                            const le1 = [];
                            for (const bt of Fl)le1.push(bt[0]);
                            const vt = projectLine(le1);
                            sc = 1 === le1.length ? {
                                type: "Point",
                                coordinates: vt[0]
                            } : {
                                type: "MultiPoint",
                                coordinates: vt
                            };
                        } else if (2 === this.type) {
                            const le1 = Fl.map(projectLine);
                            sc = 1 === le1.length ? {
                                type: "LineString",
                                coordinates: le1[0]
                            } : {
                                type: "MultiLineString",
                                coordinates: le1
                            };
                        } else {
                            if (3 !== this.type) throw new Error("unknown feature type");
                            {
                                const le1 = function(le1) {
                                    const vt = le1.length;
                                    if (vt <= 1) return [
                                        le1
                                    ];
                                    const bt = [];
                                    let ls, ho;
                                    for(let Dl = 0; Dl < vt; Dl++){
                                        const vt = signedArea(le1[Dl]);
                                        0 !== vt && (void 0 === ho && (ho = vt < 0), ho === vt < 0 ? (ls && bt.push(ls), ls = [
                                            le1[Dl]
                                        ]) : ls && ls.push(le1[Dl]));
                                    }
                                    ls && bt.push(ls);
                                    return bt;
                                }(Fl), vt = [];
                                for (const bt of le1)vt.push(bt.map(projectLine));
                                sc = 1 === vt.length ? {
                                    type: "Polygon",
                                    coordinates: vt[0]
                                } : {
                                    type: "MultiPolygon",
                                    coordinates: vt
                                };
                            }
                        }
                        const uc = {
                            type: "Feature",
                            geometry: sc,
                            properties: this.properties
                        };
                        return null != this.id && (uc.id = this.id), uc;
                    }
                }
                function readFeature(le1, vt, bt) {
                    1 === le1 ? vt.id = bt.readVarint() : 2 === le1 ? function(le1, vt) {
                        const bt = le1.readVarint() + le1.pos;
                        for(; le1.pos < bt;){
                            const bt = vt._keys[le1.readVarint()], ls = vt._values[le1.readVarint()];
                            vt.properties[bt] = ls;
                        }
                    }(bt, vt) : 3 === le1 ? vt.type = bt.readVarint() : 4 === le1 && (vt._geometry = bt.pos);
                }
                function signedArea(le1) {
                    let vt = 0;
                    for(let bt, ls, ho = 0, Dl = le1.length, Fl = Dl - 1; ho < Dl; Fl = ho++)bt = le1[ho], ls = le1[Fl], vt += (ls.x - bt.x) * (bt.y + ls.y);
                    return vt;
                }
                VectorTileFeature.types = [
                    "Unknown",
                    "Point",
                    "LineString",
                    "Polygon"
                ];
                class VectorTileLayer {
                    constructor(le1, vt){
                        this.version = 1, this.name = "", this.extent = 4096, this.length = 0, this._pbf = le1, this._keys = [], this._values = [], this._features = [], le1.readFields(readLayer, this, vt), this.length = this._features.length;
                    }
                    feature(le1) {
                        if (le1 < 0 || le1 >= this._features.length) throw new Error("feature index out of bounds");
                        this._pbf.pos = this._features[le1];
                        const vt = this._pbf.readVarint() + this._pbf.pos;
                        return new VectorTileFeature(this._pbf, vt, this.extent, this._keys, this._values);
                    }
                }
                function readLayer(le1, vt, bt) {
                    15 === le1 ? vt.version = bt.readVarint() : 1 === le1 ? vt.name = bt.readString() : 5 === le1 ? vt.extent = bt.readVarint() : 2 === le1 ? vt._features.push(bt.pos) : 3 === le1 ? vt._keys.push(bt.readString()) : 4 === le1 && vt._values.push(function(le1) {
                        let vt = null;
                        const bt = le1.readVarint() + le1.pos;
                        for(; le1.pos < bt;){
                            const bt = le1.readVarint() >> 3;
                            vt = 1 === bt ? le1.readString() : 2 === bt ? le1.readFloat() : 3 === bt ? le1.readDouble() : 4 === bt ? le1.readVarint64() : 5 === bt ? le1.readVarint() : 6 === bt ? le1.readSVarint() : 7 === bt ? le1.readBoolean() : null;
                        }
                        if (null == vt) throw new Error("unknown feature value");
                        return vt;
                    }(bt));
                }
                class VectorTile {
                    constructor(le1, vt){
                        this.layers = le1.readFields(readTile, {}, vt);
                    }
                }
                function readTile(le1, vt, bt) {
                    if (3 === le1) {
                        const le1 = new VectorTileLayer(bt, bt.readVarint() + bt.pos);
                        le1.length && (vt[le1.name] = le1);
                    }
                }
            },
            8552: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    O7: ()=>fromGeojsonVt,
                    bL: ()=>fromVectorTileJs
                });
                var ls = bt(99), ho = bt(4352);
                class FeatureWrapper {
                    constructor(le1, vt){
                        this.feature = le1, this.type = le1.type, this.properties = le1.tags ? le1.tags : {}, this.extent = vt, "id" in le1 && ("string" === typeof le1.id ? this.id = parseInt(le1.id, 10) : "number" !== typeof le1.id || isNaN(le1.id) || (this.id = le1.id));
                    }
                    loadGeometry() {
                        const le1 = [], vt = 1 === this.feature.type ? [
                            this.feature.geometry
                        ] : this.feature.geometry;
                        for (const bt of vt){
                            const vt = [];
                            for (const le1 of bt)vt.push(new ho.A(le1[0], le1[1]));
                            le1.push(vt);
                        }
                        return le1;
                    }
                }
                const Dl = "_geojsonTileLayer";
                class GeoJSONWrapper {
                    constructor(le1, vt){
                        this.layers = {
                            [Dl]: this
                        }, this.name = Dl, this.version = vt ? vt.version : 1, this.extent = vt ? vt.extent : 4096, this.length = le1.length, this.features = le1;
                    }
                    feature(le1) {
                        return new FeatureWrapper(this.features[le1], this.extent);
                    }
                }
                function fromVectorTileJs(le1) {
                    const vt = new ls.A;
                    return function(le1, vt) {
                        for(const bt in le1.layers)vt.writeMessage(3, writeLayer, le1.layers[bt]);
                    }(le1, vt), vt.finish();
                }
                function fromGeojsonVt(le1, vt) {
                    const bt = {};
                    for(const ls in le1)bt[ls] = new GeoJSONWrapper(le1[ls].features, vt), bt[ls].name = ls, bt[ls].version = vt ? vt.version : 1, bt[ls].extent = vt ? vt.extent : 4096;
                    return fromVectorTileJs({
                        layers: bt
                    });
                }
                function writeLayer(le1, vt) {
                    vt.writeVarintField(15, le1.version || 1), vt.writeStringField(1, le1.name || ""), vt.writeVarintField(5, le1.extent || 4096);
                    const bt = {
                        keys: [],
                        values: [],
                        keycache: {},
                        valuecache: {}
                    };
                    for(let Dl = 0; Dl < le1.length; Dl++)bt.feature = le1.feature(Dl), vt.writeMessage(2, writeFeature, bt);
                    const ls = bt.keys;
                    for (const Dl of ls)vt.writeStringField(3, Dl);
                    const ho = bt.values;
                    for (const Dl of ho)vt.writeMessage(4, writeValue, Dl);
                }
                function writeFeature(le1, vt) {
                    if (!le1.feature) return;
                    const bt = le1.feature;
                    void 0 !== bt.id && vt.writeVarintField(1, bt.id), vt.writeMessage(2, writeProperties, le1), vt.writeVarintField(3, bt.type), vt.writeMessage(4, writeGeometry, bt);
                }
                function writeProperties(le1, vt) {
                    for(const bt in le1.feature?.properties){
                        let ls = le1.feature.properties[bt], ho = le1.keycache[bt];
                        if (null == ls) continue;
                        "undefined" === typeof ho && (le1.keys.push(bt), ho = le1.keys.length - 1, le1.keycache[bt] = ho), vt.writeVarint(ho), "string" !== typeof ls && "boolean" !== typeof ls && "number" !== typeof ls && (ls = JSON.stringify(ls));
                        const Dl = typeof ls + ":" + ls;
                        let Fl = le1.valuecache[Dl];
                        "undefined" === typeof Fl && (le1.values.push(ls), Fl = le1.values.length - 1, le1.valuecache[Dl] = Fl), vt.writeVarint(Fl);
                    }
                }
                function command(le1, vt) {
                    return (vt << 3) + (7 & le1);
                }
                function zigzag(le1) {
                    return le1 << 1 ^ le1 >> 31;
                }
                function writeGeometry(le1, vt) {
                    const bt = le1.loadGeometry(), ls = le1.type;
                    let ho = 0, Dl = 0;
                    for (const Fl of bt){
                        let bt = 1;
                        1 === ls && (bt = Fl.length), vt.writeVarint(command(1, bt));
                        const sc = 3 === ls ? Fl.length - 1 : Fl.length;
                        for(let le1 = 0; le1 < sc; le1++){
                            1 === le1 && 1 !== ls && vt.writeVarint(command(2, sc - 1));
                            const bt = Fl[le1].x - ho, uc = Fl[le1].y - Dl;
                            vt.writeVarint(zigzag(bt)), vt.writeVarint(zigzag(uc)), ho += bt, Dl += uc;
                        }
                        3 === le1.type && vt.writeVarint(command(7, 1));
                    }
                }
                function writeValue(le1, vt) {
                    const bt = typeof le1;
                    "string" === bt ? vt.writeStringField(1, le1) : "boolean" === bt ? vt.writeBooleanField(7, le1) : "number" === bt && (le1 % 1 !== 0 ? vt.writeDoubleField(3, le1) : le1 < 0 ? vt.writeSVarintField(6, le1) : vt.writeVarintField(5, le1));
                }
            },
            8260: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>clip
                });
                var ls = bt(8290);
                function clip(le1, vt, bt, ho, Dl, Fl, sc, uc) {
                    if (ho /= vt, Fl >= (bt /= vt) && sc < ho) return le1;
                    if (sc < bt || Fl >= ho) return null;
                    const mc = [];
                    for (const gc of le1){
                        const le1 = gc.geometry;
                        let vt = gc.type;
                        const Fl = 0 === Dl ? gc.minX : gc.minY, sc = 0 === Dl ? gc.maxX : gc.maxY;
                        if (Fl >= bt && sc < ho) {
                            mc.push(gc);
                            continue;
                        }
                        if (sc < bt || Fl >= ho) continue;
                        let Ac = [];
                        if ("Point" === vt || "MultiPoint" === vt) clipPoints(le1, Ac, bt, ho, Dl);
                        else if ("LineString" === vt) clipLine(le1, Ac, bt, ho, Dl, !1, uc.lineMetrics);
                        else if ("MultiLineString" === vt) clipLines(le1, Ac, bt, ho, Dl, !1);
                        else if ("Polygon" === vt) clipLines(le1, Ac, bt, ho, Dl, !0);
                        else if ("MultiPolygon" === vt) for (const ls of le1){
                            const le1 = [];
                            clipLines(ls, le1, bt, ho, Dl, !0), le1.length && Ac.push(le1);
                        }
                        if (Ac.length) {
                            if (uc.lineMetrics && "LineString" === vt) {
                                for (const le1 of Ac)mc.push((0, ls.A)(gc.id, vt, le1, gc.tags));
                                continue;
                            }
                            "LineString" !== vt && "MultiLineString" !== vt || (1 === Ac.length ? (vt = "LineString", Ac = Ac[0]) : vt = "MultiLineString"), "Point" !== vt && "MultiPoint" !== vt || (vt = 3 === Ac.length ? "Point" : "MultiPoint"), mc.push((0, ls.A)(gc.id, vt, Ac, gc.tags));
                        }
                    }
                    return mc.length ? mc : null;
                }
                function clipPoints(le1, vt, bt, ls, ho) {
                    for(let Dl = 0; Dl < le1.length; Dl += 3){
                        const Fl = le1[Dl + ho];
                        Fl >= bt && Fl <= ls && addPoint(vt, le1[Dl], le1[Dl + 1], le1[Dl + 2]);
                    }
                }
                function clipLine(le1, vt, bt, ls, ho, Dl, Fl) {
                    let sc = newSlice(le1);
                    const uc = 0 === ho ? intersectX : intersectY;
                    let mc, gc, Ac = le1.start;
                    for(let Ld = 0; Ld < le1.length - 3; Ld += 3){
                        const Ec = le1[Ld], kc = le1[Ld + 1], du = le1[Ld + 2], _u = le1[Ld + 3], Md = le1[Ld + 4], Nd = 0 === ho ? Ec : kc, Rd = 0 === ho ? _u : Md;
                        let Od = !1;
                        Fl && (mc = Math.sqrt(Math.pow(Ec - _u, 2) + Math.pow(kc - Md, 2))), Nd < bt ? Rd > bt && (gc = uc(sc, Ec, kc, _u, Md, bt), Fl && (sc.start = Ac + mc * gc)) : Nd > ls ? Rd < ls && (gc = uc(sc, Ec, kc, _u, Md, ls), Fl && (sc.start = Ac + mc * gc)) : addPoint(sc, Ec, kc, du), Rd < bt && Nd >= bt && (gc = uc(sc, Ec, kc, _u, Md, bt), Od = !0), Rd > ls && Nd <= ls && (gc = uc(sc, Ec, kc, _u, Md, ls), Od = !0), !Dl && Od && (Fl && (sc.end = Ac + mc * gc), vt.push(sc), sc = newSlice(le1)), Fl && (Ac += mc);
                    }
                    let Ec = le1.length - 3;
                    const kc = le1[Ec], du = le1[Ec + 1], _u = le1[Ec + 2], Md = 0 === ho ? kc : du;
                    Md >= bt && Md <= ls && addPoint(sc, kc, du, _u), Ec = sc.length - 3, Dl && Ec >= 3 && (sc[Ec] !== sc[0] || sc[Ec + 1] !== sc[1]) && addPoint(sc, sc[0], sc[1], sc[2]), sc.length && vt.push(sc);
                }
                function newSlice(le1) {
                    const vt = [];
                    return vt.size = le1.size, vt.start = le1.start, vt.end = le1.end, vt;
                }
                function clipLines(le1, vt, bt, ls, ho, Dl) {
                    for (const Fl of le1)clipLine(Fl, vt, bt, ls, ho, Dl, !1);
                }
                function addPoint(le1, vt, bt, ls) {
                    le1.push(vt, bt, ls);
                }
                function intersectX(le1, vt, bt, ls, ho, Dl) {
                    const Fl = (Dl - vt) / (ls - vt);
                    return addPoint(le1, Dl, bt + (ho - bt) * Fl, 1), Fl;
                }
                function intersectY(le1, vt, bt, ls, ho, Dl) {
                    const Fl = (Dl - bt) / (ho - bt);
                    return addPoint(le1, vt + (ls - vt) * Fl, Dl, 1), Fl;
                }
            },
            7771: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>convert
                });
                var ls = bt(4337), ho = bt(8290);
                function convert(le1, vt) {
                    const bt = [];
                    if ("FeatureCollection" === le1.type) for(let ls = 0; ls < le1.features.length; ls++)convertFeature(bt, le1.features[ls], vt, ls);
                    else "Feature" === le1.type ? convertFeature(bt, le1, vt) : convertFeature(bt, {
                        geometry: le1
                    }, vt);
                    return bt;
                }
                function convertFeature(le1, vt, bt, ls) {
                    if (!vt.geometry) return;
                    const Dl = vt.geometry.coordinates;
                    if (Dl && 0 === Dl.length) return;
                    const Fl = vt.geometry.type, sc = Math.pow(bt.tolerance / ((1 << bt.maxZoom) * bt.extent), 2);
                    let uc = [], mc = vt.id;
                    if (bt.promoteId ? mc = vt.properties[bt.promoteId] : bt.generateId && (mc = ls || 0), "Point" === Fl) convertPoint(Dl, uc);
                    else if ("MultiPoint" === Fl) for (const ho of Dl)convertPoint(ho, uc);
                    else if ("LineString" === Fl) convertLine(Dl, uc, sc, !1);
                    else if ("MultiLineString" === Fl) {
                        if (bt.lineMetrics) {
                            for (const bt of Dl)uc = [], convertLine(bt, uc, sc, !1), le1.push((0, ho.A)(mc, "LineString", uc, vt.properties));
                            return;
                        }
                        convertLines(Dl, uc, sc, !1);
                    } else if ("Polygon" === Fl) convertLines(Dl, uc, sc, !0);
                    else {
                        if ("MultiPolygon" !== Fl) {
                            if ("GeometryCollection" === Fl) {
                                for (const ho of vt.geometry.geometries)convertFeature(le1, {
                                    id: mc,
                                    geometry: ho,
                                    properties: vt.properties
                                }, bt, ls);
                                return;
                            }
                            throw new Error("Input data is not a valid GeoJSON object.");
                        }
                        for (const le1 of Dl){
                            const vt = [];
                            convertLines(le1, vt, sc, !0), uc.push(vt);
                        }
                    }
                    le1.push((0, ho.A)(mc, Fl, uc, vt.properties));
                }
                function convertPoint(le1, vt) {
                    vt.push(projectX(le1[0]), projectY(le1[1]), 0);
                }
                function convertLine(le1, vt, bt, ho) {
                    let Dl, Fl, sc = 0;
                    for(let ls = 0; ls < le1.length; ls++){
                        const bt = projectX(le1[ls][0]), uc = projectY(le1[ls][1]);
                        vt.push(bt, uc, 0), ls > 0 && (sc += ho ? (Dl * uc - bt * Fl) / 2 : Math.sqrt(Math.pow(bt - Dl, 2) + Math.pow(uc - Fl, 2))), Dl = bt, Fl = uc;
                    }
                    const uc = vt.length - 3;
                    vt[2] = 1, (0, ls.A)(vt, 0, uc, bt), vt[uc + 2] = 1, vt.size = Math.abs(sc), vt.start = 0, vt.end = vt.size;
                }
                function convertLines(le1, vt, bt, ls) {
                    for(let ho = 0; ho < le1.length; ho++){
                        const Dl = [];
                        convertLine(le1[ho], Dl, bt, ls), vt.push(Dl);
                    }
                }
                function projectX(le1) {
                    return le1 / 360 + .5;
                }
                function projectY(le1) {
                    const vt = Math.sin(le1 * Math.PI / 180), bt = .5 - .25 * Math.log((1 + vt) / (1 - vt)) / Math.PI;
                    return bt < 0 ? 0 : bt > 1 ? 1 : bt;
                }
            },
            8290: (le1, vt, bt)=>{
                "use strict";
                function createFeature(le1, vt, bt, ls) {
                    const ho = {
                        id: null == le1 ? null : le1,
                        type: vt,
                        geometry: bt,
                        tags: ls,
                        minX: 1 / 0,
                        minY: 1 / 0,
                        maxX: -1 / 0,
                        maxY: -1 / 0
                    };
                    if ("Point" === vt || "MultiPoint" === vt || "LineString" === vt) calcLineBBox(ho, bt);
                    else if ("Polygon" === vt) calcLineBBox(ho, bt[0]);
                    else if ("MultiLineString" === vt) for (const Dl of bt)calcLineBBox(ho, Dl);
                    else if ("MultiPolygon" === vt) for (const Dl of bt)calcLineBBox(ho, Dl[0]);
                    return ho;
                }
                function calcLineBBox(le1, vt) {
                    for(let bt = 0; bt < vt.length; bt += 3)le1.minX = Math.min(le1.minX, vt[bt]), le1.minY = Math.min(le1.minY, vt[bt + 1]), le1.maxX = Math.max(le1.maxX, vt[bt]), le1.maxY = Math.max(le1.maxY, vt[bt + 1]);
                }
                bt.d(vt, {
                    A: ()=>createFeature
                });
            },
            2964: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>geojsonvt
                });
                var ls = bt(7771), ho = bt(8260), Dl = bt(7210), Fl = bt(9812), sc = bt(2470);
                const uc = {
                    maxZoom: 14,
                    indexMaxZoom: 5,
                    indexMaxPoints: 1e5,
                    tolerance: 3,
                    extent: 4096,
                    buffer: 64,
                    lineMetrics: !1,
                    promoteId: null,
                    generateId: !1,
                    debug: 0
                };
                class GeoJSONVT {
                    constructor(le1, vt){
                        const bt = (vt = this.options = function(le1, vt) {
                            for(const bt in vt)le1[bt] = vt[bt];
                            return le1;
                        }(Object.create(uc), vt)).debug;
                        if (bt && console.time("preprocess data"), vt.maxZoom < 0 || vt.maxZoom > 24) throw new Error("maxZoom should be in the 0-24 range");
                        if (vt.promoteId && vt.generateId) throw new Error("promoteId and generateId cannot be used together.");
                        let ho = (0, ls.A)(le1, vt);
                        this.tiles = {}, this.tileCoords = [], bt && (console.timeEnd("preprocess data"), console.log("index: maxZoom: %d, maxPoints: %d", vt.indexMaxZoom, vt.indexMaxPoints), console.time("generate tiles"), this.stats = {}, this.total = 0), ho = (0, Dl.A)(ho, vt), ho.length && this.splitTile(ho, 0, 0, 0), bt && (ho.length && console.log("features: %d, points: %d", this.tiles[0].numFeatures, this.tiles[0].numPoints), console.timeEnd("generate tiles"), console.log("tiles generated:", this.total, JSON.stringify(this.stats)));
                    }
                    splitTile(le1, vt, bt, ls, Dl, Fl, uc) {
                        const mc = [
                            le1,
                            vt,
                            bt,
                            ls
                        ], gc = this.options, Ac = gc.debug;
                        for(; mc.length;){
                            ls = mc.pop(), bt = mc.pop(), vt = mc.pop(), le1 = mc.pop();
                            const Ec = 1 << vt, kc = toID(vt, bt, ls);
                            let du = this.tiles[kc];
                            if (!du && (Ac > 1 && console.time("creation"), du = this.tiles[kc] = (0, sc.A)(le1, vt, bt, ls, gc), this.tileCoords.push({
                                z: vt,
                                x: bt,
                                y: ls
                            }), Ac)) {
                                Ac > 1 && (console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)", vt, bt, ls, du.numFeatures, du.numPoints, du.numSimplified), console.timeEnd("creation"));
                                const le1 = `z${vt}`;
                                this.stats[le1] = (this.stats[le1] || 0) + 1, this.total++;
                            }
                            if (du.source = le1, null == Dl) {
                                if (vt === gc.indexMaxZoom || du.numPoints <= gc.indexMaxPoints) continue;
                            } else {
                                if (vt === gc.maxZoom || vt === Dl) continue;
                                if (null != Dl) {
                                    const le1 = Dl - vt;
                                    if (bt !== Fl >> le1 || ls !== uc >> le1) continue;
                                }
                            }
                            if (du.source = null, 0 === le1.length) continue;
                            Ac > 1 && console.time("clipping");
                            const _u = .5 * gc.buffer / gc.extent, Md = .5 - _u, Ld = .5 + _u, Nd = 1 + _u;
                            let Rd = null, Od = null, jd = null, Ud = null, Gd = (0, ho.A)(le1, Ec, bt - _u, bt + Ld, 0, du.minX, du.maxX, gc), qd = (0, ho.A)(le1, Ec, bt + Md, bt + Nd, 0, du.minX, du.maxX, gc);
                            le1 = null, Gd && (Rd = (0, ho.A)(Gd, Ec, ls - _u, ls + Ld, 1, du.minY, du.maxY, gc), Od = (0, ho.A)(Gd, Ec, ls + Md, ls + Nd, 1, du.minY, du.maxY, gc), Gd = null), qd && (jd = (0, ho.A)(qd, Ec, ls - _u, ls + Ld, 1, du.minY, du.maxY, gc), Ud = (0, ho.A)(qd, Ec, ls + Md, ls + Nd, 1, du.minY, du.maxY, gc), qd = null), Ac > 1 && console.timeEnd("clipping"), mc.push(Rd || [], vt + 1, 2 * bt, 2 * ls), mc.push(Od || [], vt + 1, 2 * bt, 2 * ls + 1), mc.push(jd || [], vt + 1, 2 * bt + 1, 2 * ls), mc.push(Ud || [], vt + 1, 2 * bt + 1, 2 * ls + 1);
                        }
                    }
                    getTile(le1, vt, bt) {
                        le1 = +le1, vt = +vt, bt = +bt;
                        const ls = this.options, { extent: ho, debug: Dl } = ls;
                        if (le1 < 0 || le1 > 24) return null;
                        const sc = 1 << le1, uc = toID(le1, vt = vt + sc & sc - 1, bt);
                        if (this.tiles[uc]) return (0, Fl.A)(this.tiles[uc], ho);
                        Dl > 1 && console.log("drilling down to z%d-%d-%d", le1, vt, bt);
                        let mc, gc = le1, Ac = vt, Ec = bt;
                        for(; !mc && gc > 0;)gc--, Ac >>= 1, Ec >>= 1, mc = this.tiles[toID(gc, Ac, Ec)];
                        return mc && mc.source ? (Dl > 1 && (console.log("found parent tile z%d-%d-%d", gc, Ac, Ec), console.time("drilling down")), this.splitTile(mc.source, gc, Ac, Ec, le1, vt, bt), Dl > 1 && console.timeEnd("drilling down"), this.tiles[uc] ? (0, Fl.A)(this.tiles[uc], ho) : null) : null;
                    }
                }
                function toID(le1, vt, bt) {
                    return 32 * ((1 << le1) * bt + vt) + le1;
                }
                function geojsonvt(le1, vt) {
                    return new GeoJSONVT(le1, vt);
                }
            },
            4337: (le1, vt, bt)=>{
                "use strict";
                function simplify(le1, vt, bt, ls) {
                    let ho = ls;
                    const Dl = vt + (bt - vt >> 1);
                    let Fl, sc = bt - vt;
                    const uc = le1[vt], mc = le1[vt + 1], gc = le1[bt], Ac = le1[bt + 1];
                    for(let Ec = vt + 3; Ec < bt; Ec += 3){
                        const vt = getSqSegDist(le1[Ec], le1[Ec + 1], uc, mc, gc, Ac);
                        if (vt > ho) Fl = Ec, ho = vt;
                        else if (vt === ho) {
                            const le1 = Math.abs(Ec - Dl);
                            le1 < sc && (Fl = Ec, sc = le1);
                        }
                    }
                    ho > ls && (Fl - vt > 3 && simplify(le1, vt, Fl, ls), le1[Fl + 2] = ho, bt - Fl > 3 && simplify(le1, Fl, bt, ls));
                }
                function getSqSegDist(le1, vt, bt, ls, ho, Dl) {
                    let Fl = ho - bt, sc = Dl - ls;
                    if (0 !== Fl || 0 !== sc) {
                        const uc = ((le1 - bt) * Fl + (vt - ls) * sc) / (Fl * Fl + sc * sc);
                        uc > 1 ? (bt = ho, ls = Dl) : uc > 0 && (bt += Fl * uc, ls += sc * uc);
                    }
                    return Fl = le1 - bt, sc = vt - ls, Fl * Fl + sc * sc;
                }
                bt.d(vt, {
                    A: ()=>simplify
                });
            },
            2470: (le1, vt, bt)=>{
                "use strict";
                function createTile(le1, vt, bt, ls, ho) {
                    const Dl = vt === ho.maxZoom ? 0 : ho.tolerance / ((1 << vt) * ho.extent), Fl = {
                        features: [],
                        numPoints: 0,
                        numSimplified: 0,
                        numFeatures: le1.length,
                        source: null,
                        x: bt,
                        y: ls,
                        z: vt,
                        transformed: !1,
                        minX: 2,
                        minY: 1,
                        maxX: -1,
                        maxY: 0
                    };
                    for (const sc of le1)addFeature(Fl, sc, Dl, ho);
                    return Fl;
                }
                function addFeature(le1, vt, bt, ls) {
                    const ho = vt.geometry, Dl = vt.type, Fl = [];
                    if (le1.minX = Math.min(le1.minX, vt.minX), le1.minY = Math.min(le1.minY, vt.minY), le1.maxX = Math.max(le1.maxX, vt.maxX), le1.maxY = Math.max(le1.maxY, vt.maxY), "Point" === Dl || "MultiPoint" === Dl) for(let sc = 0; sc < ho.length; sc += 3)Fl.push(ho[sc], ho[sc + 1]), le1.numPoints++, le1.numSimplified++;
                    else if ("LineString" === Dl) addLine(Fl, ho, le1, bt, !1, !1);
                    else if ("MultiLineString" === Dl || "Polygon" === Dl) for(let sc = 0; sc < ho.length; sc++)addLine(Fl, ho[sc], le1, bt, "Polygon" === Dl, 0 === sc);
                    else if ("MultiPolygon" === Dl) for(let sc = 0; sc < ho.length; sc++){
                        const vt = ho[sc];
                        for(let ls = 0; ls < vt.length; ls++)addLine(Fl, vt[ls], le1, bt, !0, 0 === ls);
                    }
                    if (Fl.length) {
                        let bt = vt.tags || null;
                        if ("LineString" === Dl && ls.lineMetrics) {
                            bt = {};
                            for(const le1 in vt.tags)bt[le1] = vt.tags[le1];
                            bt.mapbox_clip_start = ho.start / ho.size, bt.mapbox_clip_end = ho.end / ho.size;
                        }
                        const sc = {
                            geometry: Fl,
                            type: "Polygon" === Dl || "MultiPolygon" === Dl ? 3 : "LineString" === Dl || "MultiLineString" === Dl ? 2 : 1,
                            tags: bt
                        };
                        null !== vt.id && (sc.id = vt.id), le1.features.push(sc);
                    }
                }
                function addLine(le1, vt, bt, ls, ho, Dl) {
                    const Fl = ls * ls;
                    if (ls > 0 && vt.size < (ho ? Fl : ls)) return void (bt.numPoints += vt.length / 3);
                    const sc = [];
                    for(let uc = 0; uc < vt.length; uc += 3)(0 === ls || vt[uc + 2] > Fl) && (bt.numSimplified++, sc.push(vt[uc], vt[uc + 1])), bt.numPoints++;
                    ho && function(le1, vt) {
                        let bt = 0;
                        for(let ls = 0, ho = le1.length, Dl = ho - 2; ls < ho; Dl = ls, ls += 2)bt += (le1[ls] - le1[Dl]) * (le1[ls + 1] + le1[Dl + 1]);
                        if (bt > 0 === vt) for(let ls = 0, ho = le1.length; ls < ho / 2; ls += 2){
                            const vt = le1[ls], bt = le1[ls + 1];
                            le1[ls] = le1[ho - 2 - ls], le1[ls + 1] = le1[ho - 1 - ls], le1[ho - 2 - ls] = vt, le1[ho - 1 - ls] = bt;
                        }
                    }(sc, Dl), le1.push(sc);
                }
                bt.d(vt, {
                    A: ()=>createTile
                });
            },
            9812: (le1, vt, bt)=>{
                "use strict";
                function transformTile(le1, vt) {
                    if (le1.transformed) return le1;
                    const bt = 1 << le1.z, ls = le1.x, ho = le1.y;
                    for (const Dl of le1.features){
                        const le1 = Dl.geometry, Fl = Dl.type;
                        if (Dl.geometry = [], 1 === Fl) for(let sc = 0; sc < le1.length; sc += 2)Dl.geometry.push(transformPoint(le1[sc], le1[sc + 1], vt, bt, ls, ho));
                        else for(let sc = 0; sc < le1.length; sc++){
                            const Fl = [];
                            for(let Dl = 0; Dl < le1[sc].length; Dl += 2)Fl.push(transformPoint(le1[sc][Dl], le1[sc][Dl + 1], vt, bt, ls, ho));
                            Dl.geometry.push(Fl);
                        }
                    }
                    return le1.transformed = !0, le1;
                }
                function transformPoint(le1, vt, bt, ls, ho, Dl) {
                    return [
                        Math.round(bt * (le1 * ls - ho)),
                        Math.round(bt * (vt * ls - Dl))
                    ];
                }
                bt.d(vt, {
                    A: ()=>transformTile
                });
            },
            7210: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>wrap
                });
                var ls = bt(8260), ho = bt(8290);
                function wrap(le1, vt) {
                    const bt = vt.buffer / vt.extent;
                    let ho = le1;
                    const Dl = (0, ls.A)(le1, 1, -1 - bt, bt, 0, -1, 2, vt), Fl = (0, ls.A)(le1, 1, 1 - bt, 2 + bt, 0, -1, 2, vt);
                    return (Dl || Fl) && (ho = (0, ls.A)(le1, 1, -bt, 1 + bt, 0, -1, 2, vt) || [], Dl && (ho = shiftFeatureCoords(Dl, 1).concat(ho)), Fl && (ho = ho.concat(shiftFeatureCoords(Fl, -1)))), ho;
                }
                function shiftFeatureCoords(le1, vt) {
                    const bt = [];
                    for(let ls = 0; ls < le1.length; ls++){
                        const Dl = le1[ls], Fl = Dl.type;
                        let sc;
                        if ("Point" === Fl || "MultiPoint" === Fl || "LineString" === Fl) sc = shiftCoords(Dl.geometry, vt);
                        else if ("MultiLineString" === Fl || "Polygon" === Fl) {
                            sc = [];
                            for (const le1 of Dl.geometry)sc.push(shiftCoords(le1, vt));
                        } else if ("MultiPolygon" === Fl) {
                            sc = [];
                            for (const le1 of Dl.geometry){
                                const bt = [];
                                for (const ls of le1)bt.push(shiftCoords(ls, vt));
                                sc.push(bt);
                            }
                        }
                        bt.push((0, ho.A)(Dl.id, Fl, sc, Dl.tags));
                    }
                    return bt;
                }
                function shiftCoords(le1, vt) {
                    const bt = [];
                    bt.size = le1.size, void 0 !== le1.start && (bt.start = le1.start, bt.end = le1.end);
                    for(let ls = 0; ls < le1.length; ls += 3)bt.push(le1[ls] + vt, le1[ls + 1], le1[ls + 2]);
                    return bt;
                }
            },
            8983: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    c8: ()=>hm
                });
                /**
* (c) Iconify
*
* For the full copyright and license information, please view the license.txt
* files at https://github.com/iconify/iconify
*
* Licensed under MIT.
*
* @license MIT
* @version 3.0.0
*/ const ls = Object.freeze({
                    left: 0,
                    top: 0,
                    width: 16,
                    height: 16
                }), ho = Object.freeze({
                    rotate: 0,
                    vFlip: !1,
                    hFlip: !1
                }), Dl = Object.freeze({
                    ...ls,
                    ...ho
                }), Fl = Object.freeze({
                    ...Dl,
                    body: "",
                    hidden: !1
                }), sc = Object.freeze({
                    width: null,
                    height: null
                }), uc = Object.freeze({
                    ...sc,
                    ...ho
                });
                const mc = /[\s,]+/;
                const gc = {
                    ...uc,
                    preserveAspectRatio: ""
                };
                function getCustomisations(le1) {
                    const vt = {
                        ...gc
                    }, attr = (vt, bt)=>le1.getAttribute(vt) || bt;
                    var bt;
                    return vt.width = attr("width", null), vt.height = attr("height", null), vt.rotate = function(le1, vt) {
                        void 0 === vt && (vt = 0);
                        const bt = le1.replace(/^-?[0-9.]*/, "");
                        function cleanup(le1) {
                            for(; le1 < 0;)le1 += 4;
                            return le1 % 4;
                        }
                        if ("" === bt) {
                            const vt = parseInt(le1);
                            return isNaN(vt) ? 0 : cleanup(vt);
                        }
                        if (bt !== le1) {
                            let vt = 0;
                            switch(bt){
                                case "%":
                                    vt = 25;
                                    break;
                                case "deg":
                                    vt = 90;
                            }
                            if (vt) {
                                let ls = parseFloat(le1.slice(0, le1.length - bt.length));
                                return isNaN(ls) ? 0 : (ls /= vt, ls % 1 === 0 ? cleanup(ls) : 0);
                            }
                        }
                        return vt;
                    }(attr("rotate", "")), bt = vt, attr("flip", "").split(mc).forEach((le1)=>{
                        switch(le1.trim()){
                            case "horizontal":
                                bt.hFlip = !0;
                                break;
                            case "vertical":
                                bt.vFlip = !0;
                        }
                    }), vt.preserveAspectRatio = attr("preserveAspectRatio", attr("preserveaspectratio", "")), vt;
                }
                const Ac = /^[a-z0-9]+(-[a-z0-9]+)*$/, stringToIcon = function(le1, vt, bt, ls) {
                    void 0 === ls && (ls = "");
                    const ho = le1.split(":");
                    if ("@" === le1.slice(0, 1)) {
                        if (ho.length < 2 || ho.length > 3) return null;
                        ls = ho.shift().slice(1);
                    }
                    if (ho.length > 3 || !ho.length) return null;
                    if (ho.length > 1) {
                        const le1 = ho.pop(), bt = ho.pop(), Dl = {
                            provider: ho.length > 0 ? ho[0] : ls,
                            prefix: bt,
                            name: le1
                        };
                        return vt && !validateIconName(Dl) ? null : Dl;
                    }
                    const Dl = ho[0], Fl = Dl.split("-");
                    if (Fl.length > 1) {
                        const le1 = {
                            provider: ls,
                            prefix: Fl.shift(),
                            name: Fl.join("-")
                        };
                        return vt && !validateIconName(le1) ? null : le1;
                    }
                    if (bt && "" === ls) {
                        const le1 = {
                            provider: ls,
                            prefix: "",
                            name: Dl
                        };
                        return vt && !validateIconName(le1, bt) ? null : le1;
                    }
                    return null;
                }, validateIconName = (le1, vt)=>!!le1 && !(!(vt && "" === le1.prefix || le1.prefix) || !le1.name);
                function mergeIconData(le1, vt) {
                    const bt = function(le1, vt) {
                        const bt = {};
                        !le1.hFlip !== !vt.hFlip && (bt.hFlip = !0), !le1.vFlip !== !vt.vFlip && (bt.vFlip = !0);
                        const ls = ((le1.rotate || 0) + (vt.rotate || 0)) % 4;
                        return ls && (bt.rotate = ls), bt;
                    }(le1, vt);
                    for(const ls in Fl)ls in ho ? ls in le1 && !(ls in bt) && (bt[ls] = ho[ls]) : ls in vt ? bt[ls] = vt[ls] : ls in le1 && (bt[ls] = le1[ls]);
                    return bt;
                }
                function internalGetIconData(le1, vt, bt) {
                    const ls = le1.icons, ho = le1.aliases || Object.create(null);
                    let Dl = {};
                    function parse(le1) {
                        Dl = mergeIconData(ls[le1] || ho[le1], Dl);
                    }
                    return parse(vt), bt.forEach(parse), mergeIconData(le1, Dl);
                }
                function parseIconSet(le1, vt) {
                    const bt = [];
                    if ("object" !== typeof le1 || "object" !== typeof le1.icons) return bt;
                    le1.not_found instanceof Array && le1.not_found.forEach((le1)=>{
                        vt(le1, null), bt.push(le1);
                    });
                    const ls = function(le1) {
                        const vt = le1.icons, bt = le1.aliases || Object.create(null), ls = Object.create(null);
                        return Object.keys(vt).concat(Object.keys(bt)).forEach(function resolve(le1) {
                            if (vt[le1]) return ls[le1] = [];
                            if (!(le1 in ls)) {
                                ls[le1] = null;
                                const vt = bt[le1] && bt[le1].parent, ho = vt && resolve(vt);
                                ho && (ls[le1] = [
                                    vt
                                ].concat(ho));
                            }
                            return ls[le1];
                        }), ls;
                    }(le1);
                    for(const ho in ls){
                        const Dl = ls[ho];
                        Dl && (vt(ho, internalGetIconData(le1, ho, Dl)), bt.push(ho));
                    }
                    return bt;
                }
                const Ec = {
                    provider: "",
                    aliases: {},
                    not_found: {},
                    ...ls
                };
                function checkOptionalProps(le1, vt) {
                    for(const bt in vt)if (bt in le1 && typeof le1[bt] !== typeof vt[bt]) return !1;
                    return !0;
                }
                function quicklyValidateIconSet(le1) {
                    if ("object" !== typeof le1 || null === le1) return null;
                    const vt = le1;
                    if ("string" !== typeof vt.prefix || !le1.icons || "object" !== typeof le1.icons) return null;
                    if (!checkOptionalProps(le1, Ec)) return null;
                    const bt = vt.icons;
                    for(const ho in bt){
                        const le1 = bt[ho];
                        if (!ho || "string" !== typeof le1.body || !checkOptionalProps(le1, Fl)) return null;
                    }
                    const ls = vt.aliases || Object.create(null);
                    for(const ho in ls){
                        const le1 = ls[ho], vt = le1.parent;
                        if (!ho || "string" !== typeof vt || !bt[vt] && !ls[vt] || !checkOptionalProps(le1, Fl)) return null;
                    }
                    return vt;
                }
                const kc = Object.create(null);
                function getStorage(le1, vt) {
                    const bt = kc[le1] || (kc[le1] = Object.create(null));
                    return bt[vt] || (bt[vt] = function(le1, vt) {
                        return {
                            provider: le1,
                            prefix: vt,
                            icons: Object.create(null),
                            missing: new Set
                        };
                    }(le1, vt));
                }
                function addIconSet(le1, vt) {
                    return quicklyValidateIconSet(vt) ? parseIconSet(vt, (vt, bt)=>{
                        bt ? le1.icons[vt] = bt : le1.missing.add(vt);
                    }) : [];
                }
                function listIcons$1(le1, vt) {
                    let bt = [];
                    return ("string" === typeof le1 ? [
                        le1
                    ] : Object.keys(kc)).forEach((le1)=>{
                        ("string" === typeof le1 && "string" === typeof vt ? [
                            vt
                        ] : Object.keys(kc[le1] || {})).forEach((vt)=>{
                            const ls = getStorage(le1, vt);
                            bt = bt.concat(Object.keys(ls.icons).map((bt)=>("" !== le1 ? "@" + le1 + ":" : "") + vt + ":" + bt));
                        });
                    }), bt;
                }
                let du = !1;
                function allowSimpleNames(le1) {
                    return "boolean" === typeof le1 && (du = le1), du;
                }
                function getIconData(le1) {
                    const vt = "string" === typeof le1 ? stringToIcon(le1, !0, du) : le1;
                    if (vt) {
                        const le1 = getStorage(vt.provider, vt.prefix), bt = vt.name;
                        return le1.icons[bt] || (le1.missing.has(bt) ? null : void 0);
                    }
                }
                function addIcon$1(le1, vt) {
                    const bt = stringToIcon(le1, !0, du);
                    if (!bt) return !1;
                    const ls = getStorage(bt.provider, bt.prefix);
                    return vt ? function(le1, vt, bt) {
                        try {
                            if ("string" === typeof bt.body) return le1.icons[vt] = {
                                ...bt
                            }, !0;
                        } catch (ls) {}
                        return !1;
                    }(ls, bt.name, vt) : (ls.missing.add(bt.name), !0);
                }
                function addCollection$1(le1, vt) {
                    if ("object" !== typeof le1) return !1;
                    if ("string" !== typeof vt && (vt = le1.provider || ""), du && !vt && !le1.prefix) {
                        let vt = !1;
                        return quicklyValidateIconSet(le1) && (le1.prefix = "", parseIconSet(le1, (le1, bt)=>{
                            addIcon$1(le1, bt) && (vt = !0);
                        })), vt;
                    }
                    const bt = le1.prefix;
                    if (!validateIconName({
                        prefix: bt,
                        name: "a"
                    })) return !1;
                    return !!addIconSet(getStorage(vt, bt), le1);
                }
                function iconLoaded$1(le1) {
                    return !!getIconData(le1);
                }
                function getIcon$1(le1) {
                    const vt = getIconData(le1);
                    return vt ? {
                        ...Dl,
                        ...vt
                    } : vt;
                }
                function removeCallback(le1, vt) {
                    le1.forEach((le1)=>{
                        const bt = le1.loaderCallbacks;
                        bt && (le1.loaderCallbacks = bt.filter((le1)=>le1.id !== vt));
                    });
                }
                let _u = 0;
                const Md = Object.create(null);
                function setAPIModule(le1, vt) {
                    Md[le1] = vt;
                }
                function getAPIModule(le1) {
                    return Md[le1] || Md[""];
                }
                var Ld = {
                    resources: [],
                    index: 0,
                    timeout: 2e3,
                    rotate: 750,
                    random: !1,
                    dataAfterTimeout: !1
                };
                function sendQuery(le1, vt, bt, ls) {
                    const ho = le1.resources.length, Dl = le1.random ? Math.floor(Math.random() * ho) : le1.index;
                    let Fl;
                    if (le1.random) {
                        let vt = le1.resources.slice(0);
                        for(Fl = []; vt.length > 1;){
                            const le1 = Math.floor(Math.random() * vt.length);
                            Fl.push(vt[le1]), vt = vt.slice(0, le1).concat(vt.slice(le1 + 1));
                        }
                        Fl = Fl.concat(vt);
                    } else Fl = le1.resources.slice(Dl).concat(le1.resources.slice(0, Dl));
                    const sc = Date.now();
                    let uc, mc = "pending", gc = 0, Ac = null, Ec = [], kc = [];
                    function resetTimer() {
                        Ac && (clearTimeout(Ac), Ac = null);
                    }
                    function abort() {
                        "pending" === mc && (mc = "aborted"), resetTimer(), Ec.forEach((le1)=>{
                            "pending" === le1.status && (le1.status = "aborted");
                        }), Ec = [];
                    }
                    function subscribe(le1, vt) {
                        vt && (kc = []), "function" === typeof le1 && kc.push(le1);
                    }
                    function failQuery() {
                        mc = "failed", kc.forEach((le1)=>{
                            le1(void 0, uc);
                        });
                    }
                    function clearQueue() {
                        Ec.forEach((le1)=>{
                            "pending" === le1.status && (le1.status = "aborted");
                        }), Ec = [];
                    }
                    function execNext() {
                        if ("pending" !== mc) return;
                        resetTimer();
                        const ls = Fl.shift();
                        if (void 0 === ls) return Ec.length ? void (Ac = setTimeout(()=>{
                            resetTimer(), "pending" === mc && (clearQueue(), failQuery());
                        }, le1.timeout)) : void failQuery();
                        const ho = {
                            status: "pending",
                            resource: ls,
                            callback: (vt, bt)=>{
                                !function(vt, bt, ls) {
                                    const ho = "success" !== bt;
                                    switch(Ec = Ec.filter((le1)=>le1 !== vt), mc){
                                        case "pending":
                                            break;
                                        case "failed":
                                            if (ho || !le1.dataAfterTimeout) return;
                                            break;
                                        default:
                                            return;
                                    }
                                    if ("abort" === bt) return uc = ls, void failQuery();
                                    if (ho) return uc = ls, void (Ec.length || (Fl.length ? execNext() : failQuery()));
                                    if (resetTimer(), clearQueue(), !le1.random) {
                                        const bt = le1.resources.indexOf(vt.resource);
                                        -1 !== bt && bt !== le1.index && (le1.index = bt);
                                    }
                                    mc = "completed", kc.forEach((le1)=>{
                                        le1(ls);
                                    });
                                }(ho, vt, bt);
                            }
                        };
                        Ec.push(ho), gc++, Ac = setTimeout(execNext, le1.rotate), bt(ls, vt, ho.callback);
                    }
                    return "function" === typeof ls && kc.push(ls), setTimeout(execNext), function() {
                        return {
                            startTime: sc,
                            payload: vt,
                            status: mc,
                            queriesSent: gc,
                            queriesPending: Ec.length,
                            subscribe: subscribe,
                            abort: abort
                        };
                    };
                }
                function initRedundancy(le1) {
                    const vt = {
                        ...Ld,
                        ...le1
                    };
                    let bt = [];
                    function cleanup() {
                        bt = bt.filter((le1)=>"pending" === le1().status);
                    }
                    return {
                        query: function(le1, ls, ho) {
                            const Dl = sendQuery(vt, le1, ls, (le1, vt)=>{
                                cleanup(), ho && ho(le1, vt);
                            });
                            return bt.push(Dl), Dl;
                        },
                        find: function(le1) {
                            return bt.find((vt)=>le1(vt)) || null;
                        },
                        setIndex: (le1)=>{
                            vt.index = le1;
                        },
                        getIndex: ()=>vt.index,
                        cleanup: cleanup
                    };
                }
                function createAPIConfig(le1) {
                    let vt;
                    if ("string" === typeof le1.resources) vt = [
                        le1.resources
                    ];
                    else if (vt = le1.resources, !(vt instanceof Array) || !vt.length) return null;
                    return {
                        resources: vt,
                        path: le1.path || "/",
                        maxURL: le1.maxURL || 500,
                        rotate: le1.rotate || 750,
                        timeout: le1.timeout || 5e3,
                        random: !0 === le1.random,
                        index: le1.index || 0,
                        dataAfterTimeout: !1 !== le1.dataAfterTimeout
                    };
                }
                const Nd = Object.create(null), Rd = [
                    "https://api.simplesvg.com",
                    "https://api.unisvg.com"
                ], Od = [];
                for(; Rd.length > 0;)1 === Rd.length || Math.random() > .5 ? Od.push(Rd.shift()) : Od.push(Rd.pop());
                function addAPIProvider$1(le1, vt) {
                    const bt = createAPIConfig(vt);
                    return null !== bt && (Nd[le1] = bt, !0);
                }
                function getAPIConfig(le1) {
                    return Nd[le1];
                }
                function listAPIProviders() {
                    return Object.keys(Nd);
                }
                function emptyCallback$1() {}
                Nd[""] = createAPIConfig({
                    resources: [
                        "https://api.iconify.design"
                    ].concat(Od)
                });
                const jd = Object.create(null);
                function sendAPIQuery(le1, vt, bt) {
                    let ls, ho;
                    if ("string" === typeof le1) {
                        const vt = getAPIModule(le1);
                        if (!vt) return bt(void 0, 424), emptyCallback$1;
                        ho = vt.send;
                        const Dl = function(le1) {
                            if (!jd[le1]) {
                                const vt = getAPIConfig(le1);
                                if (!vt) return;
                                const bt = {
                                    config: vt,
                                    redundancy: initRedundancy(vt)
                                };
                                jd[le1] = bt;
                            }
                            return jd[le1];
                        }(le1);
                        Dl && (ls = Dl.redundancy);
                    } else {
                        const vt = createAPIConfig(le1);
                        if (vt) {
                            ls = initRedundancy(vt);
                            const bt = getAPIModule(le1.resources ? le1.resources[0] : "");
                            bt && (ho = bt.send);
                        }
                    }
                    return ls && ho ? ls.query(vt, ho, bt)().abort : (bt(void 0, 424), emptyCallback$1);
                }
                function emptyCallback() {}
                function loadedNewIcons(le1) {
                    le1.iconsLoaderFlag || (le1.iconsLoaderFlag = !0, setTimeout(()=>{
                        le1.iconsLoaderFlag = !1, function(le1) {
                            le1.pendingCallbacksFlag || (le1.pendingCallbacksFlag = !0, setTimeout(()=>{
                                le1.pendingCallbacksFlag = !1;
                                const vt = le1.loaderCallbacks ? le1.loaderCallbacks.slice(0) : [];
                                if (!vt.length) return;
                                let bt = !1;
                                const ls = le1.provider, ho = le1.prefix;
                                vt.forEach((vt)=>{
                                    const Dl = vt.icons, Fl = Dl.pending.length;
                                    Dl.pending = Dl.pending.filter((vt)=>{
                                        if (vt.prefix !== ho) return !0;
                                        const Fl = vt.name;
                                        if (le1.icons[Fl]) Dl.loaded.push({
                                            provider: ls,
                                            prefix: ho,
                                            name: Fl
                                        });
                                        else {
                                            if (!le1.missing.has(Fl)) return bt = !0, !0;
                                            Dl.missing.push({
                                                provider: ls,
                                                prefix: ho,
                                                name: Fl
                                            });
                                        }
                                        return !1;
                                    }), Dl.pending.length !== Fl && (bt || removeCallback([
                                        le1
                                    ], vt.id), vt.callback(Dl.loaded.slice(0), Dl.missing.slice(0), Dl.pending.slice(0), vt.abort));
                                });
                            }));
                        }(le1);
                    }));
                }
                function parseLoaderResponse(le1, vt, bt) {
                    function checkMissing() {
                        const bt = le1.pendingIcons;
                        vt.forEach((vt)=>{
                            bt && bt.delete(vt), le1.icons[vt] || le1.missing.add(vt);
                        });
                    }
                    if (bt && "object" === typeof bt) try {
                        if (!addIconSet(le1, bt).length) return void checkMissing();
                    } catch (ls) {
                        console.error(ls);
                    }
                    checkMissing(), loadedNewIcons(le1);
                }
                function parsePossiblyAsyncResponse(le1, vt) {
                    le1 instanceof Promise ? le1.then((le1)=>{
                        vt(le1);
                    }).catch(()=>{
                        vt(null);
                    }) : vt(le1);
                }
                function loadNewIcons(le1, vt) {
                    le1.iconsToLoad ? le1.iconsToLoad = le1.iconsToLoad.concat(vt).sort() : le1.iconsToLoad = vt, le1.iconsQueueFlag || (le1.iconsQueueFlag = !0, setTimeout(()=>{
                        le1.iconsQueueFlag = !1;
                        const { provider: vt, prefix: bt } = le1, ls = le1.iconsToLoad;
                        if (delete le1.iconsToLoad, !ls || !ls.length) return;
                        const ho = le1.loadIcon;
                        if (le1.loadIcons && (ls.length > 1 || !ho)) return void parsePossiblyAsyncResponse(le1.loadIcons(ls, bt, vt), (vt)=>{
                            parseLoaderResponse(le1, ls, vt);
                        });
                        if (ho) return void ls.forEach((ls)=>{
                            parsePossiblyAsyncResponse(ho(ls, bt, vt), (vt)=>{
                                parseLoaderResponse(le1, [
                                    ls
                                ], vt ? {
                                    prefix: bt,
                                    icons: {
                                        [ls]: vt
                                    }
                                } : null);
                            });
                        });
                        const { valid: Dl, invalid: Fl } = function(le1) {
                            const vt = [], bt = [];
                            return le1.forEach((le1)=>{
                                (le1.match(Ac) ? vt : bt).push(le1);
                            }), {
                                valid: vt,
                                invalid: bt
                            };
                        }(ls);
                        if (Fl.length && parseLoaderResponse(le1, Fl, null), !Dl.length) return;
                        const sc = bt.match(Ac) ? getAPIModule(vt) : null;
                        if (!sc) return void parseLoaderResponse(le1, Dl, null);
                        sc.prepare(vt, bt, Dl).forEach((bt)=>{
                            sendAPIQuery(vt, bt, (vt)=>{
                                parseLoaderResponse(le1, bt.icons, vt);
                            });
                        });
                    }));
                }
                const loadIcons$1 = (le1, vt)=>{
                    const bt = function(le1, vt, bt) {
                        void 0 === vt && (vt = !0), void 0 === bt && (bt = !1);
                        const ls = [];
                        return le1.forEach((le1)=>{
                            const ho = "string" === typeof le1 ? stringToIcon(le1, vt, bt) : le1;
                            ho && ls.push(ho);
                        }), ls;
                    }(le1, !0, allowSimpleNames()), ls = function(le1) {
                        const vt = {
                            loaded: [],
                            missing: [],
                            pending: []
                        }, bt = Object.create(null);
                        le1.sort((le1, vt)=>le1.provider !== vt.provider ? le1.provider.localeCompare(vt.provider) : le1.prefix !== vt.prefix ? le1.prefix.localeCompare(vt.prefix) : le1.name.localeCompare(vt.name));
                        let ls = {
                            provider: "",
                            prefix: "",
                            name: ""
                        };
                        return le1.forEach((le1)=>{
                            if (ls.name === le1.name && ls.prefix === le1.prefix && ls.provider === le1.provider) return;
                            ls = le1;
                            const ho = le1.provider, Dl = le1.prefix, Fl = le1.name, sc = bt[ho] || (bt[ho] = Object.create(null)), uc = sc[Dl] || (sc[Dl] = getStorage(ho, Dl));
                            let mc;
                            mc = Fl in uc.icons ? vt.loaded : "" === Dl || uc.missing.has(Fl) ? vt.missing : vt.pending;
                            const gc = {
                                provider: ho,
                                prefix: Dl,
                                name: Fl
                            };
                            mc.push(gc);
                        }), vt;
                    }(bt);
                    if (!ls.pending.length) {
                        let le1 = !0;
                        return vt && setTimeout(()=>{
                            le1 && vt(ls.loaded, ls.missing, ls.pending, emptyCallback);
                        }), ()=>{
                            le1 = !1;
                        };
                    }
                    const ho = Object.create(null), Dl = [];
                    let Fl, sc;
                    return ls.pending.forEach((le1)=>{
                        const { provider: vt, prefix: bt } = le1;
                        if (bt === sc && vt === Fl) return;
                        Fl = vt, sc = bt, Dl.push(getStorage(vt, bt));
                        const ls = ho[vt] || (ho[vt] = Object.create(null));
                        ls[bt] || (ls[bt] = []);
                    }), ls.pending.forEach((le1)=>{
                        const { provider: vt, prefix: bt, name: ls } = le1, Dl = getStorage(vt, bt), Fl = Dl.pendingIcons || (Dl.pendingIcons = new Set);
                        Fl.has(ls) || (Fl.add(ls), ho[vt][bt].push(ls));
                    }), Dl.forEach((le1)=>{
                        const vt = ho[le1.provider][le1.prefix];
                        vt.length && loadNewIcons(le1, vt);
                    }), vt ? function(le1, vt, bt) {
                        const ls = _u++, ho = removeCallback.bind(null, bt, ls);
                        if (!vt.pending.length) return ho;
                        const Dl = {
                            id: ls,
                            icons: vt,
                            callback: le1,
                            abort: ho
                        };
                        return bt.forEach((le1)=>{
                            (le1.loaderCallbacks || (le1.loaderCallbacks = [])).push(Dl);
                        }), ho;
                    }(vt, ls, Dl) : emptyCallback;
                }, loadIcon$1 = (le1)=>new Promise((vt, bt)=>{
                        const ls = "string" === typeof le1 ? stringToIcon(le1, !0) : le1;
                        ls ? loadIcons$1([
                            ls || le1
                        ], (ho)=>{
                            if (ho.length && ls) {
                                const le1 = getIconData(ls);
                                if (le1) return void vt({
                                    ...Dl,
                                    ...le1
                                });
                            }
                            bt(le1);
                        }) : bt(le1);
                    });
                function testIconObject(le1) {
                    try {
                        const vt = "string" === typeof le1 ? JSON.parse(le1) : le1;
                        if ("string" === typeof vt.body) return {
                            ...vt
                        };
                    } catch (vt) {}
                }
                let Ud = !1;
                try {
                    Ud = 0 === navigator.vendor.indexOf("Apple");
                } catch (fm) {}
                const Gd = /(-?[0-9.]*[0-9]+[0-9.]*)/g, qd = /^-?[0-9.]*[0-9]+[0-9.]*$/g;
                function calculateSize$1(le1, vt, bt) {
                    if (1 === vt) return le1;
                    if (bt = bt || 100, "number" === typeof le1) return Math.ceil(le1 * vt * bt) / bt;
                    if ("string" !== typeof le1) return le1;
                    const ls = le1.split(Gd);
                    if (null === ls || !ls.length) return le1;
                    const ho = [];
                    let Dl = ls.shift(), Fl = qd.test(Dl);
                    for(;;){
                        if (Fl) {
                            const le1 = parseFloat(Dl);
                            isNaN(le1) ? ho.push(Dl) : ho.push(Math.ceil(le1 * vt * bt) / bt);
                        } else ho.push(Dl);
                        if (Dl = ls.shift(), void 0 === Dl) return ho.join("");
                        Fl = !Fl;
                    }
                }
                function iconToSVG(le1, vt) {
                    const bt = {
                        ...Dl,
                        ...le1
                    }, ls = {
                        ...uc,
                        ...vt
                    }, ho = {
                        left: bt.left,
                        top: bt.top,
                        width: bt.width,
                        height: bt.height
                    };
                    let Fl = bt.body;
                    [
                        bt,
                        ls
                    ].forEach((le1)=>{
                        const vt = [], bt = le1.hFlip, ls = le1.vFlip;
                        let Dl, sc = le1.rotate;
                        switch(bt ? ls ? sc += 2 : (vt.push("translate(" + (ho.width + ho.left).toString() + " " + (0 - ho.top).toString() + ")"), vt.push("scale(-1 1)"), ho.top = ho.left = 0) : ls && (vt.push("translate(" + (0 - ho.left).toString() + " " + (ho.height + ho.top).toString() + ")"), vt.push("scale(1 -1)"), ho.top = ho.left = 0), sc < 0 && (sc -= 4 * Math.floor(sc / 4)), sc %= 4, sc){
                            case 1:
                                Dl = ho.height / 2 + ho.top, vt.unshift("rotate(90 " + Dl.toString() + " " + Dl.toString() + ")");
                                break;
                            case 2:
                                vt.unshift("rotate(180 " + (ho.width / 2 + ho.left).toString() + " " + (ho.height / 2 + ho.top).toString() + ")");
                                break;
                            case 3:
                                Dl = ho.width / 2 + ho.left, vt.unshift("rotate(-90 " + Dl.toString() + " " + Dl.toString() + ")");
                        }
                        sc % 2 === 1 && (ho.left !== ho.top && (Dl = ho.left, ho.left = ho.top, ho.top = Dl), ho.width !== ho.height && (Dl = ho.width, ho.width = ho.height, ho.height = Dl)), vt.length && (Fl = function(le1, vt, bt) {
                            const ls = function(le1, vt) {
                                void 0 === vt && (vt = "defs");
                                let bt = "";
                                const ls = le1.indexOf("<" + vt);
                                for(; ls >= 0;){
                                    const ho = le1.indexOf(">", ls), Dl = le1.indexOf("</" + vt);
                                    if (-1 === ho || -1 === Dl) break;
                                    const Fl = le1.indexOf(">", Dl);
                                    if (-1 === Fl) break;
                                    bt += le1.slice(ho + 1, Dl).trim(), le1 = le1.slice(0, ls).trim() + le1.slice(Fl + 1);
                                }
                                return {
                                    defs: bt,
                                    content: le1
                                };
                            }(le1);
                            var ho, Dl;
                            return ho = ls.defs, Dl = vt + ls.content + bt, ho ? "<defs>" + ho + "</defs>" + Dl : Dl;
                        }(Fl, '<g transform="' + vt.join(" ") + '">', "</g>"));
                    });
                    const sc = ls.width, mc = ls.height, gc = ho.width, Ac = ho.height;
                    let Ec, kc;
                    null === sc ? (kc = null === mc ? "1em" : "auto" === mc ? Ac : mc, Ec = calculateSize$1(kc, gc / Ac)) : (Ec = "auto" === sc ? gc : sc, kc = null === mc ? calculateSize$1(Ec, Ac / gc) : "auto" === mc ? Ac : mc);
                    const du = {}, setAttr = (le1, vt)=>{
                        ((le1)=>"unset" === le1 || "undefined" === le1 || "none" === le1)(vt) || (du[le1] = vt.toString());
                    };
                    setAttr("width", Ec), setAttr("height", kc);
                    const _u = [
                        ho.left,
                        ho.top,
                        gc,
                        Ac
                    ];
                    return du.viewBox = _u.join(" "), {
                        attributes: du,
                        viewBox: _u,
                        body: Fl
                    };
                }
                function iconToHTML$1(le1, vt) {
                    let bt = -1 === le1.indexOf("xlink:") ? "" : ' xmlns:xlink="http://www.w3.org/1999/xlink"';
                    for(const ls in vt)bt += " " + ls + '="' + vt[ls] + '"';
                    return '<svg xmlns="http://www.w3.org/2000/svg"' + bt + ">" + le1 + "</svg>";
                }
                function svgToURL$1(le1) {
                    return 'url("' + function(le1) {
                        return "data:image/svg+xml," + function(le1) {
                            return le1.replace(/"/g, "'").replace(/%/g, "%25").replace(/#/g, "%23").replace(/</g, "%3C").replace(/>/g, "%3E").replace(/\s+/g, " ");
                        }(le1);
                    }(le1) + '")';
                }
                let Hd = (()=>{
                    let le1;
                    try {
                        if (le1 = fetch, "function" === typeof le1) return le1;
                    } catch (fm) {}
                })();
                function setFetch(le1) {
                    Hd = le1;
                }
                function getFetch() {
                    return Hd;
                }
                const Wd = {
                    prepare: (le1, vt, bt)=>{
                        const ls = [], ho = function(le1, vt) {
                            const bt = getAPIConfig(le1);
                            if (!bt) return 0;
                            let ls;
                            if (bt.maxURL) {
                                let le1 = 0;
                                bt.resources.forEach((vt)=>{
                                    const bt = vt;
                                    le1 = Math.max(le1, bt.length);
                                });
                                const ho = vt + ".json?icons=";
                                ls = bt.maxURL - le1 - bt.path.length - ho.length;
                            } else ls = 0;
                            return ls;
                        }(le1, vt), Dl = "icons";
                        let Fl = {
                            type: Dl,
                            provider: le1,
                            prefix: vt,
                            icons: []
                        }, sc = 0;
                        return bt.forEach((bt, uc)=>{
                            sc += bt.length + 1, sc >= ho && uc > 0 && (ls.push(Fl), Fl = {
                                type: Dl,
                                provider: le1,
                                prefix: vt,
                                icons: []
                            }, sc = bt.length), Fl.icons.push(bt);
                        }), ls.push(Fl), ls;
                    },
                    send: (le1, vt, bt)=>{
                        if (!Hd) return void bt("abort", 424);
                        let ls = function(le1) {
                            if ("string" === typeof le1) {
                                const vt = getAPIConfig(le1);
                                if (vt) return vt.path;
                            }
                            return "/";
                        }(vt.provider);
                        switch(vt.type){
                            case "icons":
                                {
                                    const le1 = vt.prefix, bt = vt.icons.join(",");
                                    ls += le1 + ".json?" + new URLSearchParams({
                                        icons: bt
                                    }).toString();
                                    break;
                                }
                            case "custom":
                                {
                                    const le1 = vt.uri;
                                    ls += "/" === le1.slice(0, 1) ? le1.slice(1) : le1;
                                    break;
                                }
                            default:
                                return void bt("abort", 400);
                        }
                        let ho = 503;
                        Hd(le1 + ls).then((le1)=>{
                            const vt = le1.status;
                            if (200 === vt) return ho = 501, le1.json();
                            setTimeout(()=>{
                                bt(function(le1) {
                                    return 404 === le1;
                                }(vt) ? "abort" : "next", vt);
                            });
                        }).then((le1)=>{
                            "object" === typeof le1 && null !== le1 ? setTimeout(()=>{
                                bt("success", le1);
                            }) : setTimeout(()=>{
                                404 === le1 ? bt("abort", le1) : bt("next", ho);
                            });
                        }).catch(()=>{
                            bt("next", ho);
                        });
                    }
                };
                function setCustomIconsLoader$1(le1, vt, bt) {
                    getStorage(bt || "", vt).loadIcons = le1;
                }
                function setCustomIconLoader$1(le1, vt, bt) {
                    getStorage(bt || "", vt).loadIcon = le1;
                }
                const Zd = "data-style";
                let Yd = "";
                function appendCustomStyle(le1) {
                    Yd = le1;
                }
                function updateStyle(le1, vt) {
                    let bt = Array.from(le1.childNodes).find((le1)=>le1.hasAttribute && le1.hasAttribute(Zd));
                    bt || (bt = document.createElement("style"), bt.setAttribute(Zd, Zd), le1.appendChild(bt)), bt.textContent = ":host{display:inline-block;vertical-align:" + (vt ? "-0.125em" : "0") + "}span,svg{display:block;margin:auto}" + Yd;
                }
                function exportFunctions() {
                    let le1;
                    setAPIModule("", Wd), allowSimpleNames(!0);
                    try {
                        le1 = window;
                    } catch (fm) {}
                    if (le1) {
                        if (void 0 !== le1.IconifyPreload) {
                            const vt = le1.IconifyPreload, bt = "Invalid IconifyPreload syntax.";
                            "object" === typeof vt && null !== vt && (vt instanceof Array ? vt : [
                                vt
                            ]).forEach((le1)=>{
                                try {
                                    ("object" !== typeof le1 || null === le1 || le1 instanceof Array || "object" !== typeof le1.icons || "string" !== typeof le1.prefix || !addCollection$1(le1)) && console.error(bt);
                                } catch (vt) {
                                    console.error(bt);
                                }
                            });
                        }
                        if (void 0 !== le1.IconifyProviders) {
                            const bt = le1.IconifyProviders;
                            if ("object" === typeof bt && null !== bt) for(const le1 in bt){
                                const ls = "IconifyProviders[" + le1 + "] is invalid.";
                                try {
                                    const vt = bt[le1];
                                    if ("object" !== typeof vt || !vt || void 0 === vt.resources) continue;
                                    addAPIProvider$1(le1, vt) || console.error(ls);
                                } catch (vt) {
                                    console.error(ls);
                                }
                            }
                        }
                    }
                    return {
                        iconLoaded: iconLoaded$1,
                        getIcon: getIcon$1,
                        listIcons: listIcons$1,
                        addIcon: addIcon$1,
                        addCollection: addCollection$1,
                        calculateSize: calculateSize$1,
                        buildIcon: iconToSVG,
                        iconToHTML: iconToHTML$1,
                        svgToURL: svgToURL$1,
                        loadIcons: loadIcons$1,
                        loadIcon: loadIcon$1,
                        addAPIProvider: addAPIProvider$1,
                        setCustomIconLoader: setCustomIconLoader$1,
                        setCustomIconsLoader: setCustomIconsLoader$1,
                        appendCustomStyle: appendCustomStyle,
                        _api: {
                            getAPIConfig: getAPIConfig,
                            setAPIModule: setAPIModule,
                            sendAPIQuery: sendAPIQuery,
                            setFetch: setFetch,
                            getFetch: getFetch,
                            listAPIProviders: listAPIProviders
                        }
                    };
                }
                const Qd = {
                    "background-color": "currentColor"
                }, Xd = {
                    "background-color": "transparent"
                }, Kd = {
                    image: "var(--svg)",
                    repeat: "no-repeat",
                    size: "100% 100%"
                }, Jd = {
                    "-webkit-mask": Qd,
                    mask: Qd,
                    background: Xd
                };
                for(const gm in Jd){
                    const le1 = Jd[gm];
                    for(const vt in Kd)le1[gm + "-" + vt] = Kd[vt];
                }
                function fixSize(le1) {
                    return le1 ? le1 + (le1.match(/^[-0-9.]+$/) ? "px" : "") : "inherit";
                }
                let $d;
                function cleanUpInnerHTML(le1) {
                    return void 0 === $d && function() {
                        try {
                            $d = window.trustedTypes.createPolicy("iconify", {
                                createHTML: (le1)=>le1
                            });
                        } catch (fm) {
                            $d = null;
                        }
                    }(), $d ? $d.createHTML(le1) : le1;
                }
                function findIconElement(le1) {
                    return Array.from(le1.childNodes).find((le1)=>{
                        const vt = le1.tagName && le1.tagName.toUpperCase();
                        return "SPAN" === vt || "SVG" === vt;
                    });
                }
                function renderIcon(le1, vt) {
                    const bt = vt.icon.data, ls = vt.customisations, ho = iconToSVG(bt, ls);
                    ls.preserveAspectRatio && (ho.attributes.preserveAspectRatio = ls.preserveAspectRatio);
                    const Fl = vt.renderedMode;
                    let sc;
                    if ("svg" === Fl) sc = function(le1) {
                        const vt = document.createElement("span"), bt = le1.attributes;
                        let ls = "";
                        bt.width || (ls = "width: inherit;"), bt.height || (ls += "height: inherit;"), ls && (bt.style = ls);
                        const ho = iconToHTML$1(le1.body, bt);
                        return vt.innerHTML = cleanUpInnerHTML(ho), vt.firstChild;
                    }(ho);
                    else sc = function(le1, vt, bt) {
                        const ls = document.createElement("span");
                        let ho = le1.body;
                        -1 !== ho.indexOf("<a") && (ho += "\x3c!-- " + Date.now() + " --\x3e");
                        const Dl = le1.attributes, Fl = svgToURL$1(iconToHTML$1(ho, {
                            ...Dl,
                            width: vt.width + "",
                            height: vt.height + ""
                        })), sc = ls.style, uc = {
                            "--svg": Fl,
                            width: fixSize(Dl.width),
                            height: fixSize(Dl.height),
                            ...bt ? Qd : Xd
                        };
                        for(const mc in uc)sc.setProperty(mc, uc[mc]);
                        return ls;
                    }(ho, {
                        ...Dl,
                        ...bt
                    }, "mask" === Fl);
                    const uc = findIconElement(le1);
                    uc ? "SPAN" === sc.tagName && uc.tagName === sc.tagName ? uc.setAttribute("style", sc.getAttribute("style")) : le1.replaceChild(sc, uc) : le1.appendChild(sc);
                }
                function setPendingState(le1, vt, bt) {
                    return {
                        rendered: !1,
                        inline: vt,
                        icon: le1,
                        lastRender: bt && (bt.rendered ? bt : bt.lastRender)
                    };
                }
                const sp = function(le1) {
                    let vt, bt;
                    void 0 === le1 && (le1 = "iconify-icon");
                    try {
                        vt = window.customElements, bt = window.HTMLElement;
                    } catch (fm) {
                        return;
                    }
                    if (!vt || !bt) return;
                    const ls = vt.get(le1);
                    if (ls) return ls;
                    const ho = [
                        "icon",
                        "mode",
                        "inline",
                        "noobserver",
                        "width",
                        "height",
                        "rotate",
                        "flip"
                    ], Dl = class extends bt {
                        constructor(){
                            super(), this._shadowRoot = void 0, this._initialised = !1, this._state = void 0, this._checkQueued = !1, this._connected = !1, this._observer = null, this._visible = !0;
                            const le1 = this._shadowRoot = this.attachShadow({
                                mode: "open"
                            }), vt = this.hasAttribute("inline");
                            updateStyle(le1, vt), this._state = setPendingState({
                                value: ""
                            }, vt), this._queueCheck();
                        }
                        connectedCallback() {
                            this._connected = !0, this.startObserver();
                        }
                        disconnectedCallback() {
                            this._connected = !1, this.stopObserver();
                        }
                        static get observedAttributes() {
                            return ho.slice(0);
                        }
                        attributeChangedCallback(le1) {
                            switch(le1){
                                case "inline":
                                    {
                                        const le1 = this.hasAttribute("inline"), vt = this._state;
                                        le1 !== vt.inline && (vt.inline = le1, updateStyle(this._shadowRoot, le1));
                                        break;
                                    }
                                case "noobserver":
                                    this.hasAttribute("noobserver") ? this.startObserver() : this.stopObserver();
                                    break;
                                default:
                                    this._queueCheck();
                            }
                        }
                        get icon() {
                            const le1 = this.getAttribute("icon");
                            if (le1 && "{" === le1.slice(0, 1)) try {
                                return JSON.parse(le1);
                            } catch (fm) {}
                            return le1;
                        }
                        set icon(le1) {
                            "object" === typeof le1 && (le1 = JSON.stringify(le1)), this.setAttribute("icon", le1);
                        }
                        get inline() {
                            return this.hasAttribute("inline");
                        }
                        set inline(le1) {
                            le1 ? this.setAttribute("inline", "true") : this.removeAttribute("inline");
                        }
                        get observer() {
                            return this.hasAttribute("observer");
                        }
                        set observer(le1) {
                            le1 ? this.setAttribute("observer", "true") : this.removeAttribute("observer");
                        }
                        restartAnimation() {
                            const le1 = this._state;
                            if (le1.rendered) {
                                const vt = this._shadowRoot;
                                if ("svg" === le1.renderedMode) try {
                                    return void vt.lastChild.setCurrentTime(0);
                                } catch (fm) {}
                                renderIcon(vt, le1);
                            }
                        }
                        get status() {
                            const le1 = this._state;
                            return le1.rendered ? "rendered" : null === le1.icon.data ? "failed" : "loading";
                        }
                        _queueCheck() {
                            this._checkQueued || (this._checkQueued = !0, setTimeout(()=>{
                                this._check();
                            }));
                        }
                        _check() {
                            if (!this._checkQueued) return;
                            this._checkQueued = !1;
                            const le1 = this._state, vt = this.getAttribute("icon");
                            if (vt !== le1.icon.value) return void this._iconChanged(vt);
                            if (!le1.rendered || !this._visible) return;
                            const bt = this.getAttribute("mode"), ls = getCustomisations(this);
                            le1.attrMode === bt && !function(le1, vt) {
                                for(const bt in gc)if (le1[bt] !== vt[bt]) return !0;
                                return !1;
                            }(le1.customisations, ls) && findIconElement(this._shadowRoot) || this._renderIcon(le1.icon, ls, bt);
                        }
                        _iconChanged(le1) {
                            const vt = function(le1, vt) {
                                if ("object" === typeof le1) return {
                                    data: testIconObject(le1),
                                    value: le1
                                };
                                if ("string" !== typeof le1) return {
                                    value: le1
                                };
                                if (le1.includes("{")) {
                                    const vt = testIconObject(le1);
                                    if (vt) return {
                                        data: vt,
                                        value: le1
                                    };
                                }
                                const bt = stringToIcon(le1, !0, !0);
                                if (!bt) return {
                                    value: le1
                                };
                                const ls = getIconData(bt);
                                if (void 0 !== ls || !bt.prefix) return {
                                    value: le1,
                                    name: bt,
                                    data: ls
                                };
                                const ho = loadIcons$1([
                                    bt
                                ], ()=>vt(le1, bt, getIconData(bt)));
                                return {
                                    value: le1,
                                    name: bt,
                                    loading: ho
                                };
                            }(le1, (le1, vt, bt)=>{
                                const ls = this._state;
                                if (ls.rendered || this.getAttribute("icon") !== le1) return;
                                const ho = {
                                    value: le1,
                                    name: vt,
                                    data: bt
                                };
                                ho.data ? this._gotIconData(ho) : ls.icon = ho;
                            });
                            vt.data ? this._gotIconData(vt) : this._state = setPendingState(vt, this._state.inline, this._state);
                        }
                        _forceRender() {
                            if (this._visible) this._queueCheck();
                            else {
                                const le1 = findIconElement(this._shadowRoot);
                                le1 && this._shadowRoot.removeChild(le1);
                            }
                        }
                        _gotIconData(le1) {
                            this._checkQueued = !1, this._renderIcon(le1, getCustomisations(this), this.getAttribute("mode"));
                        }
                        _renderIcon(le1, vt, bt) {
                            const ls = function(le1, vt) {
                                switch(vt){
                                    case "svg":
                                    case "bg":
                                    case "mask":
                                        return vt;
                                }
                                return "style" === vt || !Ud && -1 !== le1.indexOf("<a") ? -1 === le1.indexOf("currentColor") ? "bg" : "mask" : "svg";
                            }(le1.data.body, bt), ho = this._state.inline;
                            renderIcon(this._shadowRoot, this._state = {
                                rendered: !0,
                                icon: le1,
                                inline: ho,
                                customisations: vt,
                                attrMode: bt,
                                renderedMode: ls
                            });
                        }
                        startObserver() {
                            if (!this._observer && !this.hasAttribute("noobserver")) try {
                                this._observer = new IntersectionObserver((le1)=>{
                                    const vt = le1.some((le1)=>le1.isIntersecting);
                                    vt !== this._visible && (this._visible = vt, this._forceRender());
                                }), this._observer.observe(this);
                            } catch (fm) {
                                if (this._observer) {
                                    try {
                                        this._observer.disconnect();
                                    } catch (fm) {}
                                    this._observer = null;
                                }
                            }
                        }
                        stopObserver() {
                            this._observer && (this._observer.disconnect(), this._observer = null, this._visible = !0, this._connected && this._forceRender());
                        }
                    };
                    ho.forEach((le1)=>{
                        le1 in Dl.prototype || Object.defineProperty(Dl.prototype, le1, {
                            get: function() {
                                return this.getAttribute(le1);
                            },
                            set: function(vt) {
                                null !== vt ? this.setAttribute(le1, vt) : this.removeAttribute(le1);
                            }
                        });
                    });
                    const Fl = exportFunctions();
                    for(const sc in Fl)Dl[sc] = Dl.prototype[sc] = Fl[sc];
                    return vt.define(le1, Dl), Dl;
                }() || exportFunctions(), { iconLoaded: em, getIcon: tm, listIcons: im, addIcon: nm, addCollection: rm, calculateSize: am, buildIcon: sm, iconToHTML: om, svgToURL: lm, loadIcons: cm, loadIcon: um, setCustomIconLoader: hm, setCustomIconsLoader: dm, addAPIProvider: pm, _api: mm } = sp;
            },
            1331: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    AH: ()=>ls.AH,
                    WF: ()=>r,
                    iz: ()=>ls.iz,
                    qy: ()=>ho.qy,
                    s6: ()=>ho.s6
                });
                var ls = bt(8789), ho = bt(8531);
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ class r extends ls.mN {
                    constructor(){
                        super(...arguments), this.renderOptions = {
                            host: this
                        }, this._$Do = void 0;
                    }
                    createRenderRoot() {
                        const le1 = super.createRenderRoot();
                        return this.renderOptions.renderBefore ??= le1.firstChild, le1;
                    }
                    update(le1) {
                        const vt = this.render();
                        this.hasUpdated || (this.renderOptions.isConnected = this.isConnected), super.update(le1), this._$Do = (0, ho.XX)(vt, this.renderRoot, this.renderOptions);
                    }
                    connectedCallback() {
                        super.connectedCallback(), this._$Do?.setConnected(!0);
                    }
                    disconnectedCallback() {
                        super.disconnectedCallback(), this._$Do?.setConnected(!1);
                    }
                    render() {
                        return ho.c0;
                    }
                }
                r._$litElement$ = !0, r.finalized = !0, globalThis.litElementHydrateSupport?.({
                    LitElement: r
                });
                const Dl = globalThis.litElementPolyfillSupport;
                Dl?.({
                    LitElement: r
                });
                (globalThis.litElementVersions ??= []).push("4.1.1");
            },
            533: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    OA: ()=>ls,
                    WL: ()=>i,
                    u$: ()=>e
                });
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const ls = {
                    ATTRIBUTE: 1,
                    CHILD: 2,
                    PROPERTY: 3,
                    BOOLEAN_ATTRIBUTE: 4,
                    EVENT: 5,
                    ELEMENT: 6
                }, e = (le1)=>function() {
                        for(var vt = arguments.length, bt = new Array(vt), ls = 0; ls < vt; ls++)bt[ls] = arguments[ls];
                        return {
                            _$litDirective$: le1,
                            values: bt
                        };
                    };
                class i {
                    constructor(le1){}
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    _$AT(le1, vt, bt) {
                        this._$Ct = le1, this._$AM = vt, this._$Ci = bt;
                    }
                    _$AS(le1, vt) {
                        return this.update(le1, vt);
                    }
                    update(le1, vt) {
                        return this.render(...vt);
                    }
                }
            },
            9744: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    H: ()=>Dl
                });
                var ls = bt(8531), ho = bt(533);
                /**
 * @license
 * Copyright 2018 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const Dl = (0, ho.u$)(class extends ho.WL {
                    constructor(le1){
                        if (super(le1), le1.type !== ho.OA.ATTRIBUTE || "class" !== le1.name || le1.strings?.length > 2) throw Error("`classMap()` can only be used in the `class` attribute and must be the only part in the attribute.");
                    }
                    render(le1) {
                        return " " + Object.keys(le1).filter((vt)=>le1[vt]).join(" ") + " ";
                    }
                    update(le1, vt) {
                        let [bt] = vt;
                        if (void 0 === this.st) {
                            this.st = new Set, void 0 !== le1.strings && (this.nt = new Set(le1.strings.join(" ").split(/\s/).filter((le1)=>"" !== le1)));
                            for(const le1 in bt)bt[le1] && !this.nt?.has(le1) && this.st.add(le1);
                            return this.render(bt);
                        }
                        const ho = le1.element.classList;
                        for (const ls of this.st)ls in bt || (ho.remove(ls), this.st.delete(ls));
                        for(const ls in bt){
                            const le1 = !!bt[ls];
                            le1 === this.st.has(ls) || this.nt?.has(ls) || (le1 ? (ho.add(ls), this.st.add(ls)) : (ho.remove(ls), this.st.delete(ls)));
                        }
                        return ls.c0;
                    }
                });
            },
            4901: (le1, vt, bt)=>{
                "use strict";
                /**
 * @license
 * Copyright 2021 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ function* o(le1, vt) {
                    if (void 0 !== le1) {
                        let bt = 0;
                        for (const ls of le1)yield vt(ls, bt++);
                    }
                }
                bt.d(vt, {
                    T: ()=>o
                });
            },
            8531: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    JW: ()=>jd,
                    XX: ()=>B,
                    c0: ()=>Gd,
                    ej: ()=>Ud,
                    qy: ()=>Od,
                    s6: ()=>qd
                });
                /**
 * @license
 * Copyright 2017 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const ls = globalThis, ho = ls.trustedTypes, Dl = ho ? ho.createPolicy("lit-html", {
                    createHTML: (le1)=>le1
                }) : void 0, Fl = "$lit$", sc = `lit$${Math.random().toFixed(9).slice(2)}$`, uc = "?" + sc, mc = `<${uc}>`, gc = document, l = ()=>gc.createComment(""), c = (le1)=>null === le1 || "object" != typeof le1 && "function" != typeof le1, Ac = Array.isArray, u = (le1)=>Ac(le1) || "function" == typeof le1?.[Symbol.iterator], Ec = "[ \t\n\f\r]", kc = /<(?:(!--|\/[^a-zA-Z])|(\/?[a-zA-Z][^>\s]*)|(\/?$))/g, du = /-->/g, _u = />/g, Md = RegExp(`>|${Ec}(?:([^\\s"'>=/]+)(${Ec}*=${Ec}*(?:[^ \t\n\f\r"'\`<>=]|("|')|))|$)`, "g"), Ld = /'/g, Nd = /"/g, Rd = /^(?:script|style|textarea|title)$/i, y = (le1)=>function(vt) {
                        for(var bt = arguments.length, ls = new Array(bt > 1 ? bt - 1 : 0), ho = 1; ho < bt; ho++)ls[ho - 1] = arguments[ho];
                        return {
                            _$litType$: le1,
                            strings: vt,
                            values: ls
                        };
                    }, Od = y(1), jd = y(2), Ud = y(3), Gd = Symbol.for("lit-noChange"), qd = Symbol.for("lit-nothing"), Hd = new WeakMap, Wd = gc.createTreeWalker(gc, 129);
                function P(le1, vt) {
                    if (!Ac(le1) || !le1.hasOwnProperty("raw")) throw Error("invalid template strings array");
                    return void 0 !== Dl ? Dl.createHTML(vt) : vt;
                }
                const V = (le1, vt)=>{
                    const bt = le1.length - 1, ls = [];
                    let ho, Dl = 2 === vt ? "<svg>" : 3 === vt ? "<math>" : "", uc = kc;
                    for(let gc = 0; gc < bt; gc++){
                        const vt = le1[gc];
                        let bt, Ac, Ec = -1, Od = 0;
                        for(; Od < vt.length && (uc.lastIndex = Od, Ac = uc.exec(vt), null !== Ac);)Od = uc.lastIndex, uc === kc ? "!--" === Ac[1] ? uc = du : void 0 !== Ac[1] ? uc = _u : void 0 !== Ac[2] ? (Rd.test(Ac[2]) && (ho = RegExp("</" + Ac[2], "g")), uc = Md) : void 0 !== Ac[3] && (uc = Md) : uc === Md ? ">" === Ac[0] ? (uc = ho ?? kc, Ec = -1) : void 0 === Ac[1] ? Ec = -2 : (Ec = uc.lastIndex - Ac[2].length, bt = Ac[1], uc = void 0 === Ac[3] ? Md : '"' === Ac[3] ? Nd : Ld) : uc === Nd || uc === Ld ? uc = Md : uc === du || uc === _u ? uc = kc : (uc = Md, ho = void 0);
                        const jd = uc === Md && le1[gc + 1].startsWith("/>") ? " " : "";
                        Dl += uc === kc ? vt + mc : Ec >= 0 ? (ls.push(bt), vt.slice(0, Ec) + Fl + vt.slice(Ec) + sc + jd) : vt + sc + (-2 === Ec ? gc : jd);
                    }
                    return [
                        P(le1, Dl + (le1[bt] || "<?>") + (2 === vt ? "</svg>" : 3 === vt ? "</math>" : "")),
                        ls
                    ];
                };
                class N {
                    constructor(le1, vt){
                        let bt, { strings: ls, _$litType$: Dl } = le1;
                        this.parts = [];
                        let mc = 0, gc = 0;
                        const Ac = ls.length - 1, Ec = this.parts, [kc, du] = V(ls, Dl);
                        if (this.el = N.createElement(kc, vt), Wd.currentNode = this.el.content, 2 === Dl || 3 === Dl) {
                            const le1 = this.el.content.firstChild;
                            le1.replaceWith(...le1.childNodes);
                        }
                        for(; null !== (bt = Wd.nextNode()) && Ec.length < Ac;){
                            if (1 === bt.nodeType) {
                                if (bt.hasAttributes()) for (const le1 of bt.getAttributeNames())if (le1.endsWith(Fl)) {
                                    const vt = du[gc++], ls = bt.getAttribute(le1).split(sc), ho = /([.?@])?(.*)/.exec(vt);
                                    Ec.push({
                                        type: 1,
                                        index: mc,
                                        name: ho[2],
                                        strings: ls,
                                        ctor: "." === ho[1] ? H : "?" === ho[1] ? I : "@" === ho[1] ? L1 : k
                                    }), bt.removeAttribute(le1);
                                } else le1.startsWith(sc) && (Ec.push({
                                    type: 6,
                                    index: mc
                                }), bt.removeAttribute(le1));
                                if (Rd.test(bt.tagName)) {
                                    const le1 = bt.textContent.split(sc), vt = le1.length - 1;
                                    if (vt > 0) {
                                        bt.textContent = ho ? ho.emptyScript : "";
                                        for(let ls = 0; ls < vt; ls++)bt.append(le1[ls], l()), Wd.nextNode(), Ec.push({
                                            type: 2,
                                            index: ++mc
                                        });
                                        bt.append(le1[vt], l());
                                    }
                                }
                            } else if (8 === bt.nodeType) {
                                if (bt.data === uc) Ec.push({
                                    type: 2,
                                    index: mc
                                });
                                else {
                                    let le1 = -1;
                                    for(; -1 !== (le1 = bt.data.indexOf(sc, le1 + 1));)Ec.push({
                                        type: 7,
                                        index: mc
                                    }), le1 += sc.length - 1;
                                }
                            }
                            mc++;
                        }
                    }
                    static createElement(le1, vt) {
                        const bt = gc.createElement("template");
                        return bt.innerHTML = le1, bt;
                    }
                }
                function S(le1, vt, bt, ls) {
                    if (void 0 === bt && (bt = le1), vt === Gd) return vt;
                    let ho = void 0 !== ls ? bt._$Co?.[ls] : bt._$Cl;
                    const Dl = c(vt) ? void 0 : vt._$litDirective$;
                    return ho?.constructor !== Dl && (ho?._$AO?.(!1), void 0 === Dl ? ho = void 0 : (ho = new Dl(le1), ho._$AT(le1, bt, ls)), void 0 !== ls ? (bt._$Co ??= [])[ls] = ho : bt._$Cl = ho), void 0 !== ho && (vt = S(le1, ho._$AS(le1, vt.values), ho, ls)), vt;
                }
                class M {
                    constructor(le1, vt){
                        this._$AV = [], this._$AN = void 0, this._$AD = le1, this._$AM = vt;
                    }
                    get parentNode() {
                        return this._$AM.parentNode;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    u(le1) {
                        const { el: { content: vt }, parts: bt } = this._$AD, ls = (le1?.creationScope ?? gc).importNode(vt, !0);
                        Wd.currentNode = ls;
                        let ho = Wd.nextNode(), Dl = 0, Fl = 0, sc = bt[0];
                        for(; void 0 !== sc;){
                            if (Dl === sc.index) {
                                let vt;
                                2 === sc.type ? vt = new R(ho, ho.nextSibling, this, le1) : 1 === sc.type ? vt = new sc.ctor(ho, sc.name, sc.strings, this, le1) : 6 === sc.type && (vt = new z(ho, this, le1)), this._$AV.push(vt), sc = bt[++Fl];
                            }
                            Dl !== sc?.index && (ho = Wd.nextNode(), Dl++);
                        }
                        return Wd.currentNode = gc, ls;
                    }
                    p(le1) {
                        let vt = 0;
                        for (const bt of this._$AV)void 0 !== bt && (void 0 !== bt.strings ? (bt._$AI(le1, bt, vt), vt += bt.strings.length - 2) : bt._$AI(le1[vt])), vt++;
                    }
                }
                class R {
                    get _$AU() {
                        return this._$AM?._$AU ?? this._$Cv;
                    }
                    constructor(le1, vt, bt, ls){
                        this.type = 2, this._$AH = qd, this._$AN = void 0, this._$AA = le1, this._$AB = vt, this._$AM = bt, this.options = ls, this._$Cv = ls?.isConnected ?? !0;
                    }
                    get parentNode() {
                        let le1 = this._$AA.parentNode;
                        const vt = this._$AM;
                        return void 0 !== vt && 11 === le1?.nodeType && (le1 = vt.parentNode), le1;
                    }
                    get startNode() {
                        return this._$AA;
                    }
                    get endNode() {
                        return this._$AB;
                    }
                    _$AI(le1, vt) {
                        void 0 === vt && (vt = this), le1 = S(this, le1, vt), c(le1) ? le1 === qd || null == le1 || "" === le1 ? (this._$AH !== qd && this._$AR(), this._$AH = qd) : le1 !== this._$AH && le1 !== Gd && this._(le1) : void 0 !== le1._$litType$ ? this.$(le1) : void 0 !== le1.nodeType ? this.T(le1) : u(le1) ? this.k(le1) : this._(le1);
                    }
                    O(le1) {
                        return this._$AA.parentNode.insertBefore(le1, this._$AB);
                    }
                    T(le1) {
                        this._$AH !== le1 && (this._$AR(), this._$AH = this.O(le1));
                    }
                    _(le1) {
                        this._$AH !== qd && c(this._$AH) ? this._$AA.nextSibling.data = le1 : this.T(gc.createTextNode(le1)), this._$AH = le1;
                    }
                    $(le1) {
                        const { values: vt, _$litType$: bt } = le1, ls = "number" == typeof bt ? this._$AC(le1) : (void 0 === bt.el && (bt.el = N.createElement(P(bt.h, bt.h[0]), this.options)), bt);
                        if (this._$AH?._$AD === ls) this._$AH.p(vt);
                        else {
                            const le1 = new M(ls, this), bt = le1.u(this.options);
                            le1.p(vt), this.T(bt), this._$AH = le1;
                        }
                    }
                    _$AC(le1) {
                        let vt = Hd.get(le1.strings);
                        return void 0 === vt && Hd.set(le1.strings, vt = new N(le1)), vt;
                    }
                    k(le1) {
                        Ac(this._$AH) || (this._$AH = [], this._$AR());
                        const vt = this._$AH;
                        let bt, ls = 0;
                        for (const ho of le1)ls === vt.length ? vt.push(bt = new R(this.O(l()), this.O(l()), this, this.options)) : bt = vt[ls], bt._$AI(ho), ls++;
                        ls < vt.length && (this._$AR(bt && bt._$AB.nextSibling, ls), vt.length = ls);
                    }
                    _$AR(le1, vt) {
                        for(void 0 === le1 && (le1 = this._$AA.nextSibling), this._$AP?.(!1, !0, vt); le1 && le1 !== this._$AB;){
                            const vt = le1.nextSibling;
                            le1.remove(), le1 = vt;
                        }
                    }
                    setConnected(le1) {
                        void 0 === this._$AM && (this._$Cv = le1, this._$AP?.(le1));
                    }
                }
                class k {
                    get tagName() {
                        return this.element.tagName;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    constructor(le1, vt, bt, ls, ho){
                        this.type = 1, this._$AH = qd, this._$AN = void 0, this.element = le1, this.name = vt, this._$AM = ls, this.options = ho, bt.length > 2 || "" !== bt[0] || "" !== bt[1] ? (this._$AH = Array(bt.length - 1).fill(new String), this.strings = bt) : this._$AH = qd;
                    }
                    _$AI(le1, vt, bt, ls) {
                        void 0 === vt && (vt = this);
                        const ho = this.strings;
                        let Dl = !1;
                        if (void 0 === ho) le1 = S(this, le1, vt, 0), Dl = !c(le1) || le1 !== this._$AH && le1 !== Gd, Dl && (this._$AH = le1);
                        else {
                            const ls = le1;
                            let Fl, sc;
                            for(le1 = ho[0], Fl = 0; Fl < ho.length - 1; Fl++)sc = S(this, ls[bt + Fl], vt, Fl), sc === Gd && (sc = this._$AH[Fl]), Dl ||= !c(sc) || sc !== this._$AH[Fl], sc === qd ? le1 = qd : le1 !== qd && (le1 += (sc ?? "") + ho[Fl + 1]), this._$AH[Fl] = sc;
                        }
                        Dl && !ls && this.j(le1);
                    }
                    j(le1) {
                        le1 === qd ? this.element.removeAttribute(this.name) : this.element.setAttribute(this.name, le1 ?? "");
                    }
                }
                class H extends k {
                    constructor(){
                        super(...arguments), this.type = 3;
                    }
                    j(le1) {
                        this.element[this.name] = le1 === qd ? void 0 : le1;
                    }
                }
                class I extends k {
                    constructor(){
                        super(...arguments), this.type = 4;
                    }
                    j(le1) {
                        this.element.toggleAttribute(this.name, !!le1 && le1 !== qd);
                    }
                }
                class L1 extends k {
                    constructor(le1, vt, bt, ls, ho){
                        super(le1, vt, bt, ls, ho), this.type = 5;
                    }
                    _$AI(le1, vt) {
                        if (void 0 === vt && (vt = this), (le1 = S(this, le1, vt, 0) ?? qd) === Gd) return;
                        const bt = this._$AH, ls = le1 === qd && bt !== qd || le1.capture !== bt.capture || le1.once !== bt.once || le1.passive !== bt.passive, ho = le1 !== qd && (bt === qd || ls);
                        ls && this.element.removeEventListener(this.name, this, bt), ho && this.element.addEventListener(this.name, this, le1), this._$AH = le1;
                    }
                    handleEvent(le1) {
                        "function" == typeof this._$AH ? this._$AH.call(this.options?.host ?? this.element, le1) : this._$AH.handleEvent(le1);
                    }
                }
                class z {
                    constructor(le1, vt, bt){
                        this.element = le1, this.type = 6, this._$AN = void 0, this._$AM = vt, this.options = bt;
                    }
                    get _$AU() {
                        return this._$AM._$AU;
                    }
                    _$AI(le1) {
                        S(this, le1);
                    }
                }
                const Zd = ls.litHtmlPolyfillSupport;
                Zd?.(N, R), (ls.litHtmlVersions ??= []).push("3.2.1");
                const B = (le1, vt, bt)=>{
                    const ls = bt?.renderBefore ?? vt;
                    let ho = ls._$litPart$;
                    if (void 0 === ho) {
                        const le1 = bt?.renderBefore ?? null;
                        ls._$litPart$ = ho = new R(vt.insertBefore(l(), le1), le1, void 0, bt ?? {});
                    }
                    return ho._$AI(le1), ho;
                };
            },
            5080: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Bk: ()=>s,
                    qy: ()=>Fl
                });
                var ls = bt(8531);
                /**
 * @license
 * Copyright 2020 Google LLC
 * SPDX-License-Identifier: BSD-3-Clause
 */ const ho = Symbol.for(""), o = (le1)=>{
                    if (le1?.r === ho) return le1?._$litStatic$;
                }, s = (le1)=>({
                        _$litStatic$: le1,
                        r: ho
                    }), Dl = new Map, n = (le1)=>function(vt) {
                        for(var bt = arguments.length, ls = new Array(bt > 1 ? bt - 1 : 0), ho = 1; ho < bt; ho++)ls[ho - 1] = arguments[ho];
                        const Fl = ls.length;
                        let sc, uc;
                        const mc = [], gc = [];
                        let Ac, Ec = 0, kc = !1;
                        for(; Ec < Fl;){
                            for(Ac = vt[Ec]; Ec < Fl && void 0 !== (uc = ls[Ec], sc = o(uc));)Ac += sc + vt[++Ec], kc = !0;
                            Ec !== Fl && gc.push(uc), mc.push(Ac), Ec++;
                        }
                        if (Ec === Fl && mc.push(vt[Fl]), kc) {
                            const le1 = mc.join("$$lit$$");
                            void 0 === (vt = Dl.get(le1)) && (mc.raw = mc, Dl.set(le1, vt = mc)), ls = gc;
                        }
                        return le1(vt, ...ls);
                    }, Fl = n(ls.qy);
                n(ls.JW), n(ls.ej);
            },
            1198: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    H: ()=>ls.H
                });
                var ls = bt(9744);
            },
            4542: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    AH: ()=>ls.AH,
                    WF: ()=>ls.WF,
                    iz: ()=>ls.iz,
                    qy: ()=>ls.qy,
                    s6: ()=>ls.s6
                });
                bt(8789), bt(8531);
                var ls = bt(1331);
            },
            686: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Bk: ()=>ls.Bk,
                    qy: ()=>ls.qy
                });
                var ls = bt(5080);
            },
            99: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    A: ()=>Pbf
                });
                const ls = 4294967296, ho = 1 / ls, Dl = "undefined" === typeof TextDecoder ? null : new TextDecoder("utf-8");
                class Pbf {
                    constructor(le1){
                        void 0 === le1 && (le1 = new Uint8Array(16)), this.buf = ArrayBuffer.isView(le1) ? le1 : new Uint8Array(le1), this.dataView = new DataView(this.buf.buffer), this.pos = 0, this.type = 0, this.length = this.buf.length;
                    }
                    readFields(le1, vt, bt) {
                        for(void 0 === bt && (bt = this.length); this.pos < bt;){
                            const bt = this.readVarint(), ls = bt >> 3, ho = this.pos;
                            this.type = 7 & bt, le1(ls, vt, this), this.pos === ho && this.skip(bt);
                        }
                        return vt;
                    }
                    readMessage(le1, vt) {
                        return this.readFields(le1, vt, this.readVarint() + this.pos);
                    }
                    readFixed32() {
                        const le1 = this.dataView.getUint32(this.pos, !0);
                        return this.pos += 4, le1;
                    }
                    readSFixed32() {
                        const le1 = this.dataView.getInt32(this.pos, !0);
                        return this.pos += 4, le1;
                    }
                    readFixed64() {
                        const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getUint32(this.pos + 4, !0) * ls;
                        return this.pos += 8, le1;
                    }
                    readSFixed64() {
                        const le1 = this.dataView.getUint32(this.pos, !0) + this.dataView.getInt32(this.pos + 4, !0) * ls;
                        return this.pos += 8, le1;
                    }
                    readFloat() {
                        const le1 = this.dataView.getFloat32(this.pos, !0);
                        return this.pos += 4, le1;
                    }
                    readDouble() {
                        const le1 = this.dataView.getFloat64(this.pos, !0);
                        return this.pos += 8, le1;
                    }
                    readVarint(le1) {
                        const vt = this.buf;
                        let bt, ls;
                        return ls = vt[this.pos++], bt = 127 & ls, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 7, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 14, ls < 128 ? bt : (ls = vt[this.pos++], bt |= (127 & ls) << 21, ls < 128 ? bt : (ls = vt[this.pos], bt |= (15 & ls) << 28, function(le1, vt, bt) {
                            const ls = bt.buf;
                            let ho, Dl;
                            if (Dl = ls[bt.pos++], ho = (112 & Dl) >> 4, Dl < 128) return toNum(le1, ho, vt);
                            if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 3, Dl < 128) return toNum(le1, ho, vt);
                            if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 10, Dl < 128) return toNum(le1, ho, vt);
                            if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 17, Dl < 128) return toNum(le1, ho, vt);
                            if (Dl = ls[bt.pos++], ho |= (127 & Dl) << 24, Dl < 128) return toNum(le1, ho, vt);
                            if (Dl = ls[bt.pos++], ho |= (1 & Dl) << 31, Dl < 128) return toNum(le1, ho, vt);
                            throw new Error("Expected varint not more than 10 bytes");
                        }(bt, le1, this)))));
                    }
                    readVarint64() {
                        return this.readVarint(!0);
                    }
                    readSVarint() {
                        const le1 = this.readVarint();
                        return le1 % 2 === 1 ? (le1 + 1) / -2 : le1 / 2;
                    }
                    readBoolean() {
                        return Boolean(this.readVarint());
                    }
                    readString() {
                        const le1 = this.readVarint() + this.pos, vt = this.pos;
                        return this.pos = le1, le1 - vt >= 12 && Dl ? Dl.decode(this.buf.subarray(vt, le1)) : function(le1, vt, bt) {
                            let ls = "", ho = vt;
                            for(; ho < bt;){
                                const vt = le1[ho];
                                let Dl, Fl, sc, uc = null, mc = vt > 239 ? 4 : vt > 223 ? 3 : vt > 191 ? 2 : 1;
                                if (ho + mc > bt) break;
                                1 === mc ? vt < 128 && (uc = vt) : 2 === mc ? (Dl = le1[ho + 1], 128 === (192 & Dl) && (uc = (31 & vt) << 6 | 63 & Dl, uc <= 127 && (uc = null))) : 3 === mc ? (Dl = le1[ho + 1], Fl = le1[ho + 2], 128 === (192 & Dl) && 128 === (192 & Fl) && (uc = (15 & vt) << 12 | (63 & Dl) << 6 | 63 & Fl, (uc <= 2047 || uc >= 55296 && uc <= 57343) && (uc = null))) : 4 === mc && (Dl = le1[ho + 1], Fl = le1[ho + 2], sc = le1[ho + 3], 128 === (192 & Dl) && 128 === (192 & Fl) && 128 === (192 & sc) && (uc = (15 & vt) << 18 | (63 & Dl) << 12 | (63 & Fl) << 6 | 63 & sc, (uc <= 65535 || uc >= 1114112) && (uc = null))), null === uc ? (uc = 65533, mc = 1) : uc > 65535 && (uc -= 65536, ls += String.fromCharCode(uc >>> 10 & 1023 | 55296), uc = 56320 | 1023 & uc), ls += String.fromCharCode(uc), ho += mc;
                            }
                            return ls;
                        }(this.buf, vt, le1);
                    }
                    readBytes() {
                        const le1 = this.readVarint() + this.pos, vt = this.buf.subarray(this.pos, le1);
                        return this.pos = le1, vt;
                    }
                    readPackedVarint(le1, vt) {
                        void 0 === le1 && (le1 = []);
                        const bt = this.readPackedEnd();
                        for(; this.pos < bt;)le1.push(this.readVarint(vt));
                        return le1;
                    }
                    readPackedSVarint(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readSVarint());
                        return le1;
                    }
                    readPackedBoolean(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readBoolean());
                        return le1;
                    }
                    readPackedFloat(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readFloat());
                        return le1;
                    }
                    readPackedDouble(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readDouble());
                        return le1;
                    }
                    readPackedFixed32(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readFixed32());
                        return le1;
                    }
                    readPackedSFixed32(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readSFixed32());
                        return le1;
                    }
                    readPackedFixed64(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readFixed64());
                        return le1;
                    }
                    readPackedSFixed64(le1) {
                        void 0 === le1 && (le1 = []);
                        const vt = this.readPackedEnd();
                        for(; this.pos < vt;)le1.push(this.readSFixed64());
                        return le1;
                    }
                    readPackedEnd() {
                        return 2 === this.type ? this.readVarint() + this.pos : this.pos + 1;
                    }
                    skip(le1) {
                        const vt = 7 & le1;
                        if (0 === vt) for(; this.buf[this.pos++] > 127;);
                        else if (2 === vt) this.pos = this.readVarint() + this.pos;
                        else if (5 === vt) this.pos += 4;
                        else {
                            if (1 !== vt) throw new Error(`Unimplemented type: ${vt}`);
                            this.pos += 8;
                        }
                    }
                    writeTag(le1, vt) {
                        this.writeVarint(le1 << 3 | vt);
                    }
                    realloc(le1) {
                        let vt = this.length || 16;
                        for(; vt < this.pos + le1;)vt *= 2;
                        if (vt !== this.length) {
                            const le1 = new Uint8Array(vt);
                            le1.set(this.buf), this.buf = le1, this.dataView = new DataView(le1.buffer), this.length = vt;
                        }
                    }
                    finish() {
                        return this.length = this.pos, this.pos = 0, this.buf.subarray(0, this.length);
                    }
                    writeFixed32(le1) {
                        this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                    }
                    writeSFixed32(le1) {
                        this.realloc(4), this.dataView.setInt32(this.pos, le1, !0), this.pos += 4;
                    }
                    writeFixed64(le1) {
                        this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * ho), !0), this.pos += 8;
                    }
                    writeSFixed64(le1) {
                        this.realloc(8), this.dataView.setInt32(this.pos, -1 & le1, !0), this.dataView.setInt32(this.pos + 4, Math.floor(le1 * ho), !0), this.pos += 8;
                    }
                    writeVarint(le1) {
                        (le1 = +le1 || 0) > 268435455 || le1 < 0 ? function(le1, vt) {
                            let bt, ls;
                            le1 >= 0 ? (bt = le1 % 4294967296 | 0, ls = le1 / 4294967296 | 0) : (bt = ~(-le1 % 4294967296), ls = ~(-le1 / 4294967296), 4294967295 ^ bt ? bt = bt + 1 | 0 : (bt = 0, ls = ls + 1 | 0));
                            if (le1 >= 0x10000000000000000 || le1 < -18446744073709552000) throw new Error("Given varint doesn't fit into 10 bytes");
                            vt.realloc(10), function(le1, vt, bt) {
                                bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos++] = 127 & le1 | 128, le1 >>>= 7, bt.buf[bt.pos] = 127 & le1;
                            }(bt, 0, vt), function(le1, vt) {
                                const bt = (7 & le1) << 4;
                                if (vt.buf[vt.pos++] |= bt | ((le1 >>>= 3) ? 128 : 0), !le1) return;
                                if (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), !le1) return;
                                if (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), !le1) return;
                                if (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), !le1) return;
                                if (vt.buf[vt.pos++] = 127 & le1 | ((le1 >>>= 7) ? 128 : 0), !le1) return;
                                vt.buf[vt.pos++] = 127 & le1;
                            }(ls, vt);
                        }(le1, this) : (this.realloc(4), this.buf[this.pos++] = 127 & le1 | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = 127 & (le1 >>>= 7) | (le1 > 127 ? 128 : 0), le1 <= 127 || (this.buf[this.pos++] = le1 >>> 7 & 127))));
                    }
                    writeSVarint(le1) {
                        this.writeVarint(le1 < 0 ? 2 * -le1 - 1 : 2 * le1);
                    }
                    writeBoolean(le1) {
                        this.writeVarint(+le1);
                    }
                    writeString(le1) {
                        le1 = String(le1), this.realloc(4 * le1.length), this.pos++;
                        const vt = this.pos;
                        this.pos = function(le1, vt, bt) {
                            for(let ls, ho, Dl = 0; Dl < vt.length; Dl++){
                                if (ls = vt.charCodeAt(Dl), ls > 55295 && ls < 57344) {
                                    if (!ho) {
                                        ls > 56319 || Dl + 1 === vt.length ? (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189) : ho = ls;
                                        continue;
                                    }
                                    if (ls < 56320) {
                                        le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = ls;
                                        continue;
                                    }
                                    ls = ho - 55296 << 10 | ls - 56320 | 65536, ho = null;
                                } else ho && (le1[bt++] = 239, le1[bt++] = 191, le1[bt++] = 189, ho = null);
                                ls < 128 ? le1[bt++] = ls : (ls < 2048 ? le1[bt++] = ls >> 6 | 192 : (ls < 65536 ? le1[bt++] = ls >> 12 | 224 : (le1[bt++] = ls >> 18 | 240, le1[bt++] = ls >> 12 & 63 | 128), le1[bt++] = ls >> 6 & 63 | 128), le1[bt++] = 63 & ls | 128);
                            }
                            return bt;
                        }(this.buf, le1, this.pos);
                        const bt = this.pos - vt;
                        bt >= 128 && makeRoomForExtraLength(vt, bt, this), this.pos = vt - 1, this.writeVarint(bt), this.pos += bt;
                    }
                    writeFloat(le1) {
                        this.realloc(4), this.dataView.setFloat32(this.pos, le1, !0), this.pos += 4;
                    }
                    writeDouble(le1) {
                        this.realloc(8), this.dataView.setFloat64(this.pos, le1, !0), this.pos += 8;
                    }
                    writeBytes(le1) {
                        const vt = le1.length;
                        this.writeVarint(vt), this.realloc(vt);
                        for(let bt = 0; bt < vt; bt++)this.buf[this.pos++] = le1[bt];
                    }
                    writeRawMessage(le1, vt) {
                        this.pos++;
                        const bt = this.pos;
                        le1(vt, this);
                        const ls = this.pos - bt;
                        ls >= 128 && makeRoomForExtraLength(bt, ls, this), this.pos = bt - 1, this.writeVarint(ls), this.pos += ls;
                    }
                    writeMessage(le1, vt, bt) {
                        this.writeTag(le1, 2), this.writeRawMessage(vt, bt);
                    }
                    writePackedVarint(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedVarint, vt);
                    }
                    writePackedSVarint(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedSVarint, vt);
                    }
                    writePackedBoolean(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedBoolean, vt);
                    }
                    writePackedFloat(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedFloat, vt);
                    }
                    writePackedDouble(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedDouble, vt);
                    }
                    writePackedFixed32(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedFixed32, vt);
                    }
                    writePackedSFixed32(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedSFixed32, vt);
                    }
                    writePackedFixed64(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedFixed64, vt);
                    }
                    writePackedSFixed64(le1, vt) {
                        vt.length && this.writeMessage(le1, writePackedSFixed64, vt);
                    }
                    writeBytesField(le1, vt) {
                        this.writeTag(le1, 2), this.writeBytes(vt);
                    }
                    writeFixed32Field(le1, vt) {
                        this.writeTag(le1, 5), this.writeFixed32(vt);
                    }
                    writeSFixed32Field(le1, vt) {
                        this.writeTag(le1, 5), this.writeSFixed32(vt);
                    }
                    writeFixed64Field(le1, vt) {
                        this.writeTag(le1, 1), this.writeFixed64(vt);
                    }
                    writeSFixed64Field(le1, vt) {
                        this.writeTag(le1, 1), this.writeSFixed64(vt);
                    }
                    writeVarintField(le1, vt) {
                        this.writeTag(le1, 0), this.writeVarint(vt);
                    }
                    writeSVarintField(le1, vt) {
                        this.writeTag(le1, 0), this.writeSVarint(vt);
                    }
                    writeStringField(le1, vt) {
                        this.writeTag(le1, 2), this.writeString(vt);
                    }
                    writeFloatField(le1, vt) {
                        this.writeTag(le1, 5), this.writeFloat(vt);
                    }
                    writeDoubleField(le1, vt) {
                        this.writeTag(le1, 1), this.writeDouble(vt);
                    }
                    writeBooleanField(le1, vt) {
                        this.writeVarintField(le1, +vt);
                    }
                }
                function toNum(le1, vt, bt) {
                    return bt ? 4294967296 * vt + (le1 >>> 0) : 4294967296 * (vt >>> 0) + (le1 >>> 0);
                }
                function makeRoomForExtraLength(le1, vt, bt) {
                    const ls = vt <= 16383 ? 1 : vt <= 2097151 ? 2 : vt <= 268435455 ? 3 : Math.floor(Math.log(vt) / (7 * Math.LN2));
                    bt.realloc(ls);
                    for(let ho = bt.pos - 1; ho >= le1; ho--)bt.buf[ho + ls] = bt.buf[ho];
                }
                function writePackedVarint(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeVarint(le1[bt]);
                }
                function writePackedSVarint(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeSVarint(le1[bt]);
                }
                function writePackedFloat(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeFloat(le1[bt]);
                }
                function writePackedDouble(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeDouble(le1[bt]);
                }
                function writePackedBoolean(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeBoolean(le1[bt]);
                }
                function writePackedFixed32(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeFixed32(le1[bt]);
                }
                function writePackedSFixed32(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed32(le1[bt]);
                }
                function writePackedFixed64(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeFixed64(le1[bt]);
                }
                function writePackedSFixed64(le1, vt) {
                    for(let bt = 0; bt < le1.length; bt++)vt.writeSFixed64(le1[bt]);
                }
            },
            748: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    Zs: ()=>uc
                });
                var ls = bt(3336), ho = Object.defineProperty, Dl = Math.pow, l = (le1, vt)=>ho(le1, "name", {
                        value: vt,
                        configurable: !0
                    }), m = (le1, vt, bt)=>new Promise((ls, ho)=>{
                        var s = (le1)=>{
                            try {
                                a(bt.next(le1));
                            } catch (vt) {
                                ho(vt);
                            }
                        }, o = (le1)=>{
                            try {
                                a(bt.throw(le1));
                            } catch (vt) {
                                ho(vt);
                            }
                        }, a = (le1)=>le1.done ? ls(le1.value) : Promise.resolve(le1.value).then(s, o);
                        a((bt = bt.apply(le1, vt)).next());
                    }), Fl = (l((le1, vt)=>{
                    let bt = !1, ls = "";
                    return new (L.GridLayer.extend({
                        createTile: l((vt, ho)=>{
                            let Dl = document.createElement("img"), Fl = new AbortController, sc = Fl.signal;
                            return Dl.cancel = ()=>{
                                Fl.abort();
                            }, bt || (le1.getHeader().then((le1)=>{
                                1 === le1.tileType ? console.error("Error: archive contains MVT vector tiles, but leafletRasterLayer is for displaying raster tiles. See https://github.com/protomaps/PMTiles/tree/main/js for details.") : 2 === le1.tileType ? ls = "image/png" : 3 === le1.tileType ? ls = "image/jpeg" : 4 === le1.tileType ? ls = "image/webp" : 5 === le1.tileType && (ls = "image/avif");
                            }), bt = !0), le1.getZxy(vt.z, vt.x, vt.y, sc).then((le1)=>{
                                if (le1) {
                                    let vt = new Blob([
                                        le1.data
                                    ], {
                                        type: ls
                                    }), bt = window.URL.createObjectURL(vt);
                                    Dl.src = bt, Dl.cancel = void 0, ho(void 0, Dl);
                                }
                            }).catch((le1)=>{
                                if ("AbortError" !== le1.name) throw le1;
                            }), Dl;
                        }, "createTile"),
                        _removeTile: l(function(le1) {
                            let vt = this._tiles[le1];
                            vt && (vt.el.cancel && vt.el.cancel(), vt.el.width = 0, vt.el.height = 0, vt.el.deleted = !0, L.DomUtil.remove(vt.el), delete this._tiles[le1], this.fire("tileunload", {
                                tile: vt.el,
                                coords: this._keyToTileCoords(le1)
                            }));
                        }, "_removeTile")
                    }))(vt);
                }, "leafletRasterLayer"), l((le1)=>(vt, bt)=>{
                        if (bt instanceof AbortController) return le1(vt, bt);
                        let ls = new AbortController;
                        return le1(vt, ls).then((le1)=>bt(void 0, le1.data, le1.cacheControl || "", le1.expires || ""), (le1)=>bt(le1)).catch((le1)=>bt(le1)), {
                            cancel: l(()=>ls.abort(), "cancel")
                        };
                    }, "v3compat")), sc = class {
                    constructor(le1){
                        this.tilev4 = l((le1, vt)=>m(this, null, function*() {
                                if ("json" === le1.type) {
                                    let vt = le1.url.substr(10), bt = this.tiles.get(vt);
                                    if (bt || (bt = new Gd(vt), this.tiles.set(vt, bt)), this.metadata) return {
                                        data: yield bt.getTileJson(le1.url)
                                    };
                                    let ls = yield bt.getHeader();
                                    return (ls.minLon >= ls.maxLon || ls.minLat >= ls.maxLat) && console.error(`Bounds of PMTiles archive ${ls.minLon},${ls.minLat},${ls.maxLon},${ls.maxLat} are not valid.`), {
                                        data: {
                                            tiles: [
                                                `${le1.url}/{z}/{x}/{y}`
                                            ],
                                            minzoom: ls.minZoom,
                                            maxzoom: ls.maxZoom,
                                            bounds: [
                                                ls.minLon,
                                                ls.minLat,
                                                ls.maxLon,
                                                ls.maxLat
                                            ]
                                        }
                                    };
                                }
                                let bt = new RegExp(/pmtiles:\/\/(.+)\/(\d+)\/(\d+)\/(\d+)/), ls = le1.url.match(bt);
                                if (!ls) throw new Error("Invalid PMTiles protocol URL");
                                let ho = ls[1], Dl = this.tiles.get(ho);
                                Dl || (Dl = new Gd(ho), this.tiles.set(ho, Dl));
                                let Fl = ls[2], sc = ls[3], uc = ls[4], mc = yield Dl.getHeader(), gc = yield null == Dl ? void 0 : Dl.getZxy(+Fl, +sc, +uc, vt.signal);
                                if (gc) return {
                                    data: new Uint8Array(gc.data),
                                    cacheControl: gc.cacheControl,
                                    expires: gc.expires
                                };
                                if (1 === mc.tileType) {
                                    if (this.errorOnMissingTile) throw new Error("Tile not found.");
                                    return {
                                        data: new Uint8Array
                                    };
                                }
                                return {
                                    data: null
                                };
                            }), "tilev4"), this.tile = Fl(this.tilev4), this.tiles = new Map, this.metadata = (null == le1 ? void 0 : le1.metadata) || !1, this.errorOnMissingTile = (null == le1 ? void 0 : le1.errorOnMissingTile) || !1;
                    }
                    add(le1) {
                        this.tiles.set(le1.source.getKey(), le1);
                    }
                    get(le1) {
                        return this.tiles.get(le1);
                    }
                };
                l(sc, "Protocol");
                var uc = sc;
                function w(le1, vt) {
                    return 4294967296 * (vt >>> 0) + (le1 >>> 0);
                }
                function F(le1, vt) {
                    let bt = vt.buf, ls = bt[vt.pos++], ho = (112 & ls) >> 4;
                    if (ls < 128 || (ls = bt[vt.pos++], ho |= (127 & ls) << 3, ls < 128) || (ls = bt[vt.pos++], ho |= (127 & ls) << 10, ls < 128) || (ls = bt[vt.pos++], ho |= (127 & ls) << 17, ls < 128) || (ls = bt[vt.pos++], ho |= (127 & ls) << 24, ls < 128) || (ls = bt[vt.pos++], ho |= (1 & ls) << 31, ls < 128)) return w(le1, ho);
                    throw new Error("Expected varint not more than 10 bytes");
                }
                function v(le1) {
                    let vt = le1.buf, bt = vt[le1.pos++], ls = 127 & bt;
                    return bt < 128 || (bt = vt[le1.pos++], ls |= (127 & bt) << 7, bt < 128) || (bt = vt[le1.pos++], ls |= (127 & bt) << 14, bt < 128) || (bt = vt[le1.pos++], ls |= (127 & bt) << 21, bt < 128) ? ls : (bt = vt[le1.pos], ls |= (15 & bt) << 28, F(ls, le1));
                }
                function k(le1, vt, bt, ls) {
                    if (0 === ls) {
                        1 === bt && (vt[0] = le1 - 1 - vt[0], vt[1] = le1 - 1 - vt[1]);
                        let ls = vt[0];
                        vt[0] = vt[1], vt[1] = ls;
                    }
                }
                function N(le1, vt) {
                    let bt = Dl(2, le1), ls = vt, ho = vt, Fl = vt, sc = [
                        0,
                        0
                    ], uc = 1;
                    for(; uc < bt;)ls = 1 & Fl / 2, ho = 1 & (Fl ^ ls), k(uc, sc, ls, ho), sc[0] += uc * ls, sc[1] += uc * ho, Fl /= 4, uc *= 2;
                    return [
                        le1,
                        sc[0],
                        sc[1]
                    ];
                }
                l(w, "toNum"), l(F, "readVarintRemainder"), l(v, "readVarint"), l(k, "rotate"), l(N, "idOnLevel");
                var mc = [
                    0,
                    1,
                    5,
                    21,
                    85,
                    341,
                    1365,
                    5461,
                    21845,
                    87381,
                    349525,
                    1398101,
                    5592405,
                    22369621,
                    89478485,
                    357913941,
                    1431655765,
                    5726623061,
                    22906492245,
                    91625968981,
                    366503875925,
                    1466015503701,
                    5864062014805,
                    23456248059221,
                    93824992236885,
                    375299968947541,
                    0x5555555555555
                ];
                function G(le1, vt, bt) {
                    if (le1 > 26) throw new Error("Tile zoom level exceeds max safe number limit (26)");
                    if (vt > Dl(2, le1) - 1 || bt > Dl(2, le1) - 1) throw new Error("tile x/y outside zoom level bounds");
                    let ls = mc[le1], ho = 0, Fl = 0, sc = 0, uc = [
                        vt,
                        bt
                    ], gc = Dl(2, le1) / 2;
                    for(; gc > 0;)ho = (uc[0] & gc) > 0 ? 1 : 0, Fl = (uc[1] & gc) > 0 ? 1 : 0, sc += gc * gc * (3 * ho ^ Fl), k(gc, uc, ho, Fl), gc /= 2;
                    return ls + sc;
                }
                l(G, "zxyToTileId"), l(function(le1) {
                    let vt = 0;
                    for(let bt = 0; bt < 27; bt++){
                        let ls = (1 << bt) * (1 << bt);
                        if (vt + ls > le1) return N(bt, le1 - vt);
                        vt += ls;
                    }
                    throw new Error("Tile zoom level exceeds max safe number limit (26)");
                }, "tileIdToZxy");
                var gc, Ac = ((gc = Ac || {})[gc.Unknown = 0] = "Unknown", gc[gc.None = 1] = "None", gc[gc.Gzip = 2] = "Gzip", gc[gc.Brotli = 3] = "Brotli", gc[gc.Zstd = 4] = "Zstd", gc);
                function D(le1, vt) {
                    return m(this, null, function*() {
                        if (1 === vt || 0 === vt) return le1;
                        if (2 === vt) {
                            if ("undefined" == typeof globalThis.DecompressionStream) return (0, ls.Rq)(new Uint8Array(le1));
                            let vt = new Response(le1).body;
                            if (!vt) throw new Error("Failed to read response stream");
                            let bt = vt.pipeThrough(new globalThis.DecompressionStream("gzip"));
                            return new Response(bt).arrayBuffer();
                        }
                        throw new Error("Compression method not supported");
                    });
                }
                l(D, "defaultDecompress");
                var Ec, kc = ((Ec = kc || {})[Ec.Unknown = 0] = "Unknown", Ec[Ec.Mvt = 1] = "Mvt", Ec[Ec.Png = 2] = "Png", Ec[Ec.Jpeg = 3] = "Jpeg", Ec[Ec.Webp = 4] = "Webp", Ec[Ec.Avif = 5] = "Avif", Ec);
                function _(le1) {
                    return 1 === le1 ? ".mvt" : 2 === le1 ? ".png" : 3 === le1 ? ".jpg" : 4 === le1 ? ".webp" : 5 === le1 ? ".avif" : "";
                }
                l(_, "tileTypeExt");
                function Q(le1, vt) {
                    let bt = 0, ls = le1.length - 1;
                    for(; bt <= ls;){
                        let ho = ls + bt >> 1, Dl = vt - le1[ho].tileId;
                        if (Dl > 0) bt = ho + 1;
                        else {
                            if (!(Dl < 0)) return le1[ho];
                            ls = ho - 1;
                        }
                    }
                    return ls >= 0 && (0 === le1[ls].runLength || vt - le1[ls].tileId < le1[ls].runLength) ? le1[ls] : null;
                }
                l(Q, "findTile");
                var du = class {
                    constructor(le1){
                        this.file = le1;
                    }
                    getKey() {
                        return this.file.name;
                    }
                    getBytes(le1, vt) {
                        return m(this, null, function*() {
                            return {
                                data: yield this.file.slice(le1, le1 + vt).arrayBuffer()
                            };
                        });
                    }
                };
                l(du, "FileSource");
                var _u = class {
                    constructor(le1, vt){
                        void 0 === vt && (vt = new Headers), this.url = le1, this.customHeaders = vt, this.mustReload = !1;
                        let bt = "";
                        "navigator" in globalThis && (bt = globalThis.navigator.userAgent || "");
                        let ls = bt.indexOf("Windows") > -1, ho = /Chrome|Chromium|Edg|OPR|Brave/.test(bt);
                        this.chromeWindowsNoCache = !1, ls && ho && (this.chromeWindowsNoCache = !0);
                    }
                    getKey() {
                        return this.url;
                    }
                    setHeaders(le1) {
                        this.customHeaders = le1;
                    }
                    getBytes(le1, vt, bt, ls) {
                        return m(this, null, function*() {
                            let ho, Dl;
                            bt ? Dl = bt : (ho = new AbortController, Dl = ho.signal);
                            let Fl, sc = new Headers(this.customHeaders);
                            sc.set("range", `bytes=${le1}-${le1 + vt - 1}`), this.mustReload ? Fl = "reload" : this.chromeWindowsNoCache && (Fl = "no-store");
                            let uc = yield fetch(this.url, {
                                signal: Dl,
                                cache: Fl,
                                headers: sc
                            });
                            if (0 === le1 && 416 === uc.status) {
                                let le1 = uc.headers.get("Content-Range");
                                if (!le1 || !le1.startsWith("bytes */")) throw new Error("Missing content-length on 416 response");
                                let vt = +le1.substr(8);
                                uc = yield fetch(this.url, {
                                    signal: Dl,
                                    cache: "reload",
                                    headers: {
                                        range: "bytes=0-" + (vt - 1)
                                    }
                                });
                            }
                            let mc = uc.headers.get("Etag");
                            if (null != mc && mc.startsWith("W/") && (mc = null), 416 === uc.status || ls && mc && mc !== ls) throw this.mustReload = !0, new Nd(`Server returned non-matching ETag ${ls} after one retry. Check browser extensions and servers for issues that may affect correct ETag headers.`);
                            if (uc.status >= 300) throw new Error(`Bad response code: ${uc.status}`);
                            let gc = uc.headers.get("Content-Length");
                            if (200 === uc.status && (!gc || +gc > vt)) throw ho && ho.abort(), new Error("Server returned no content-length header or content-length exceeding request. Check that your storage backend supports HTTP Byte Serving.");
                            return {
                                data: yield uc.arrayBuffer(),
                                etag: mc || void 0,
                                cacheControl: uc.headers.get("Cache-Control") || void 0,
                                expires: uc.headers.get("Expires") || void 0
                            };
                        });
                    }
                };
                l(_u, "FetchSource");
                var Md = _u;
                function g(le1, vt) {
                    let bt = le1.getUint32(vt + 4, !0), ls = le1.getUint32(vt + 0, !0);
                    return bt * Dl(2, 32) + ls;
                }
                function X(le1, vt) {
                    let bt = new DataView(le1), ls = bt.getUint8(7);
                    if (ls > 3) throw new Error(`Archive is spec version ${ls} but this library supports up to spec version 3`);
                    return {
                        specVersion: ls,
                        rootDirectoryOffset: g(bt, 8),
                        rootDirectoryLength: g(bt, 16),
                        jsonMetadataOffset: g(bt, 24),
                        jsonMetadataLength: g(bt, 32),
                        leafDirectoryOffset: g(bt, 40),
                        leafDirectoryLength: g(bt, 48),
                        tileDataOffset: g(bt, 56),
                        tileDataLength: g(bt, 64),
                        numAddressedTiles: g(bt, 72),
                        numTileEntries: g(bt, 80),
                        numTileContents: g(bt, 88),
                        clustered: 1 === bt.getUint8(96),
                        internalCompression: bt.getUint8(97),
                        tileCompression: bt.getUint8(98),
                        tileType: bt.getUint8(99),
                        minZoom: bt.getUint8(100),
                        maxZoom: bt.getUint8(101),
                        minLon: bt.getInt32(102, !0) / 1e7,
                        minLat: bt.getInt32(106, !0) / 1e7,
                        maxLon: bt.getInt32(110, !0) / 1e7,
                        maxLat: bt.getInt32(114, !0) / 1e7,
                        centerZoom: bt.getUint8(118),
                        centerLon: bt.getInt32(119, !0) / 1e7,
                        centerLat: bt.getInt32(123, !0) / 1e7,
                        etag: vt
                    };
                }
                function Z(le1) {
                    let vt = {
                        buf: new Uint8Array(le1),
                        pos: 0
                    }, bt = v(vt), ls = [], ho = 0;
                    for(let Dl = 0; Dl < bt; Dl++){
                        let le1 = v(vt);
                        ls.push({
                            tileId: ho + le1,
                            offset: 0,
                            length: 0,
                            runLength: 1
                        }), ho += le1;
                    }
                    for(let Dl = 0; Dl < bt; Dl++)ls[Dl].runLength = v(vt);
                    for(let Dl = 0; Dl < bt; Dl++)ls[Dl].length = v(vt);
                    for(let Dl = 0; Dl < bt; Dl++){
                        let le1 = v(vt);
                        ls[Dl].offset = 0 === le1 && Dl > 0 ? ls[Dl - 1].offset + ls[Dl - 1].length : le1 - 1;
                    }
                    return ls;
                }
                l(g, "getUint64"), l(X, "bytesToHeader"), l(Z, "deserializeIndex");
                var Ld = class extends Error {
                };
                l(Ld, "EtagMismatch");
                var Nd = Ld;
                function K(le1, vt) {
                    return m(this, null, function*() {
                        let bt = yield le1.getBytes(0, 16384);
                        if (19792 !== new DataView(bt.data).getUint16(0, !0)) throw new Error("Wrong magic number for PMTiles archive");
                        let ls = X(bt.data.slice(0, 127), bt.etag), ho = bt.data.slice(ls.rootDirectoryOffset, ls.rootDirectoryOffset + ls.rootDirectoryLength), Dl = `${le1.getKey()}|${ls.etag || ""}|${ls.rootDirectoryOffset}|${ls.rootDirectoryLength}`, Fl = Z((yield vt(ho, ls.internalCompression)));
                        return [
                            ls,
                            [
                                Dl,
                                Fl.length,
                                Fl
                            ]
                        ];
                    });
                }
                function I(le1, vt, bt, ls, ho) {
                    return m(this, null, function*() {
                        let Dl = yield le1.getBytes(bt, ls, void 0, ho.etag), Fl = Z((yield vt(Dl.data, ho.internalCompression)));
                        if (0 === Fl.length) throw new Error("Empty directory is invalid");
                        return Fl;
                    });
                }
                l(K, "getHeaderAndRoot"), l(I, "getDirectory");
                var Rd = class {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = 100), void 0 === vt && (vt = !0), void 0 === bt && (bt = D), this.cache = new Map, this.maxCacheEntries = le1, this.counter = 1, this.decompress = bt;
                    }
                    getHeader(le1) {
                        return m(this, null, function*() {
                            let vt = le1.getKey(), bt = this.cache.get(vt);
                            if (bt) return bt.lastUsed = this.counter++, bt.data;
                            let ls = yield K(le1, this.decompress);
                            return ls[1] && this.cache.set(ls[1][0], {
                                lastUsed: this.counter++,
                                data: ls[1][2]
                            }), this.cache.set(vt, {
                                lastUsed: this.counter++,
                                data: ls[0]
                            }), this.prune(), ls[0];
                        });
                    }
                    getDirectory(le1, vt, bt, ls) {
                        return m(this, null, function*() {
                            let ho = `${le1.getKey()}|${ls.etag || ""}|${vt}|${bt}`, Dl = this.cache.get(ho);
                            if (Dl) return Dl.lastUsed = this.counter++, Dl.data;
                            let Fl = yield I(le1, this.decompress, vt, bt, ls);
                            return this.cache.set(ho, {
                                lastUsed: this.counter++,
                                data: Fl
                            }), this.prune(), Fl;
                        });
                    }
                    prune() {
                        if (this.cache.size > this.maxCacheEntries) {
                            let le1, vt = 1 / 0;
                            this.cache.forEach((bt, ls)=>{
                                bt.lastUsed < vt && (vt = bt.lastUsed, le1 = ls);
                            }), le1 && this.cache.delete(le1);
                        }
                    }
                    invalidate(le1) {
                        return m(this, null, function*() {
                            this.cache.delete(le1.getKey());
                        });
                    }
                };
                l(Rd, "ResolvedValueCache");
                var Od = class {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = 100), void 0 === vt && (vt = !0), void 0 === bt && (bt = D), this.cache = new Map, this.invalidations = new Map, this.maxCacheEntries = le1, this.counter = 1, this.decompress = bt;
                    }
                    getHeader(le1) {
                        return m(this, null, function*() {
                            let vt = le1.getKey(), bt = this.cache.get(vt);
                            if (bt) return bt.lastUsed = this.counter++, yield bt.data;
                            let ls = new Promise((vt, bt)=>{
                                K(le1, this.decompress).then((le1)=>{
                                    le1[1] && this.cache.set(le1[1][0], {
                                        lastUsed: this.counter++,
                                        data: Promise.resolve(le1[1][2])
                                    }), vt(le1[0]), this.prune();
                                }).catch((le1)=>{
                                    bt(le1);
                                });
                            });
                            return this.cache.set(vt, {
                                lastUsed: this.counter++,
                                data: ls
                            }), ls;
                        });
                    }
                    getDirectory(le1, vt, bt, ls) {
                        return m(this, null, function*() {
                            let ho = `${le1.getKey()}|${ls.etag || ""}|${vt}|${bt}`, Dl = this.cache.get(ho);
                            if (Dl) return Dl.lastUsed = this.counter++, yield Dl.data;
                            let Fl = new Promise((ho, Dl)=>{
                                I(le1, this.decompress, vt, bt, ls).then((le1)=>{
                                    ho(le1), this.prune();
                                }).catch((le1)=>{
                                    Dl(le1);
                                });
                            });
                            return this.cache.set(ho, {
                                lastUsed: this.counter++,
                                data: Fl
                            }), Fl;
                        });
                    }
                    prune() {
                        if (this.cache.size >= this.maxCacheEntries) {
                            let le1, vt = 1 / 0;
                            this.cache.forEach((bt, ls)=>{
                                bt.lastUsed < vt && (vt = bt.lastUsed, le1 = ls);
                            }), le1 && this.cache.delete(le1);
                        }
                    }
                    invalidate(le1) {
                        return m(this, null, function*() {
                            let vt = le1.getKey();
                            if (this.invalidations.get(vt)) return yield this.invalidations.get(vt);
                            this.cache.delete(le1.getKey());
                            let bt = new Promise((bt, ls)=>{
                                this.getHeader(le1).then((le1)=>{
                                    bt(), this.invalidations.delete(vt);
                                }).catch((le1)=>{
                                    ls(le1);
                                });
                            });
                            this.invalidations.set(vt, bt);
                        });
                    }
                };
                l(Od, "SharedPromiseCache");
                var jd = Od, Ud = class {
                    constructor(le1, vt, bt){
                        this.source = "string" == typeof le1 ? new Md(le1) : le1, this.decompress = bt || D, this.cache = vt || new jd;
                    }
                    getHeader() {
                        return m(this, null, function*() {
                            return yield this.cache.getHeader(this.source);
                        });
                    }
                    getZxyAttempt(le1, vt, bt, ls) {
                        return m(this, null, function*() {
                            let ho = G(le1, vt, bt), Dl = yield this.cache.getHeader(this.source);
                            if (le1 < Dl.minZoom || le1 > Dl.maxZoom) return;
                            let Fl = Dl.rootDirectoryOffset, sc = Dl.rootDirectoryLength;
                            for(let le1 = 0; le1 <= 3; le1++){
                                let le1 = Q((yield this.cache.getDirectory(this.source, Fl, sc, Dl)), ho);
                                if (!le1) return;
                                if (le1.runLength > 0) {
                                    let vt = yield this.source.getBytes(Dl.tileDataOffset + le1.offset, le1.length, ls, Dl.etag);
                                    return {
                                        data: yield this.decompress(vt.data, Dl.tileCompression),
                                        cacheControl: vt.cacheControl,
                                        expires: vt.expires
                                    };
                                }
                                Fl = Dl.leafDirectoryOffset + le1.offset, sc = le1.length;
                            }
                            throw new Error("Maximum directory depth exceeded");
                        });
                    }
                    getZxy(le1, vt, bt, ls) {
                        return m(this, null, function*() {
                            try {
                                return yield this.getZxyAttempt(le1, vt, bt, ls);
                            } catch (gc) {
                                if (gc instanceof Nd) return this.cache.invalidate(this.source), yield this.getZxyAttempt(le1, vt, bt, ls);
                                throw gc;
                            }
                        });
                    }
                    getMetadataAttempt() {
                        return m(this, null, function*() {
                            let le1 = yield this.cache.getHeader(this.source), vt = yield this.source.getBytes(le1.jsonMetadataOffset, le1.jsonMetadataLength, void 0, le1.etag), bt = yield this.decompress(vt.data, le1.internalCompression), ls = new TextDecoder("utf-8");
                            return JSON.parse(ls.decode(bt));
                        });
                    }
                    getMetadata() {
                        return m(this, null, function*() {
                            try {
                                return yield this.getMetadataAttempt();
                            } catch (le1) {
                                if (le1 instanceof Nd) return this.cache.invalidate(this.source), yield this.getMetadataAttempt();
                                throw le1;
                            }
                        });
                    }
                    getTileJson(le1) {
                        return m(this, null, function*() {
                            let vt = yield this.getHeader(), bt = yield this.getMetadata(), ls = _(vt.tileType);
                            return {
                                tilejson: "3.0.0",
                                scheme: "xyz",
                                tiles: [
                                    `${le1}/{z}/{x}/{y}${ls}`
                                ],
                                vector_layers: bt.vector_layers,
                                attribution: bt.attribution,
                                description: bt.description,
                                name: bt.name,
                                version: bt.version,
                                bounds: [
                                    vt.minLon,
                                    vt.minLat,
                                    vt.maxLon,
                                    vt.maxLat
                                ],
                                center: [
                                    vt.centerLon,
                                    vt.centerLat,
                                    vt.centerZoom
                                ],
                                minzoom: vt.minZoom,
                                maxzoom: vt.maxZoom
                            };
                        });
                    }
                };
                l(Ud, "PMTiles");
                var Gd = Ud;
            },
            9435: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    $EB: ()=>Ec,
                    $NF: ()=>ImageLoader,
                    $Yl: ()=>tm,
                    $_I: ()=>Rm,
                    $ei: ()=>Gd,
                    A$4: ()=>Uint16BufferAttribute,
                    AQS: ()=>arrayNeedsUint32,
                    B69: ()=>Object3D,
                    BKk: ()=>ShaderMaterial,
                    BXX: ()=>lg,
                    B_h: ()=>Ag,
                    CSG: ()=>MeshDepthMaterial,
                    CVz: ()=>pg,
                    CWW: ()=>Rg,
                    Cfg: ()=>Pm,
                    DXC: ()=>LineSegments,
                    Dmk: ()=>Ym,
                    EZo: ()=>_u,
                    EdD: ()=>Ld,
                    FFZ: ()=>aA,
                    FV: ()=>ym,
                    FXf: ()=>Od,
                    Fn: ()=>Ig,
                    GJx: ()=>km,
                    GWd: ()=>Km,
                    Gu$: ()=>SphereGeometry,
                    Gwm: ()=>cm,
                    H23: ()=>Dg,
                    HIg: ()=>Xm,
                    HO_: ()=>Ng,
                    HXV: ()=>hg,
                    I9Y: ()=>Vector2,
                    IE4: ()=>ag,
                    IUQ: ()=>Vector4,
                    Iit: ()=>mergeUniforms,
                    Jnc: ()=>Fl,
                    K52: ()=>um,
                    KDk: ()=>fg,
                    KLL: ()=>Xg,
                    KRh: ()=>pm,
                    Kef: ()=>Pg,
                    Kwu: ()=>Md,
                    LAk: ()=>xm,
                    LiQ: ()=>Zd,
                    LlO: ()=>ry,
                    LoY: ()=>BufferGeometry,
                    MW4: ()=>Uint32BufferAttribute,
                    Mjd: ()=>Am,
                    N5j: ()=>Gg,
                    NRn: ()=>Box3,
                    NTi: ()=>du,
                    Nex: ()=>getByteLength,
                    Nt7: ()=>Kd,
                    Nv2: ()=>VideoTexture,
                    Nz6: ()=>sg,
                    O9p: ()=>Euler,
                    OUM: ()=>Fm,
                    Om: ()=>Tm,
                    OuU: ()=>Qd,
                    PPD: ()=>Frustum,
                    PTz: ()=>Quaternion,
                    Pq0: ()=>Vector3,
                    Q1f: ()=>Color,
                    QP0: ()=>sc,
                    Qev: ()=>EventDispatcher,
                    Qrf: ()=>vg,
                    R3r: ()=>WebXRController,
                    RQf: ()=>Gm,
                    Riy: ()=>mg,
                    RrE: ()=>em,
                    RyA: ()=>mc,
                    S$4: ()=>Cg,
                    THS: ()=>BufferAttribute,
                    TdN: ()=>lA,
                    TiK: ()=>tA,
                    TkQ: ()=>ng,
                    U3G: ()=>lm,
                    V3x: ()=>Zm,
                    V9B: ()=>MeshBasicMaterial,
                    VCu: ()=>DepthTexture,
                    VT0: ()=>eg,
                    Vb5: ()=>Dl,
                    VxR: ()=>Qg,
                    W9U: ()=>Lg,
                    WNZ: ()=>ho,
                    Wdf: ()=>oA,
                    Wew: ()=>Hm,
                    Wk7: ()=>uc,
                    XG_: ()=>zg,
                    XIg: ()=>kc,
                    XJ7: ()=>WireframeGeometry,
                    XrR: ()=>mm,
                    Y9S: ()=>FileLoader,
                    YJl: ()=>Group,
                    Yuy: ()=>Um,
                    Z58: ()=>Scene,
                    ZQM: ()=>tg,
                    Zcv: ()=>Plane,
                    Zr2: ()=>Yg,
                    _QJ: ()=>wg,
                    _Ut: ()=>getUnlitUniformColorSpace,
                    a55: ()=>pA,
                    a5J: ()=>bg,
                    aEY: ()=>$d,
                    aJ8: ()=>bm,
                    aVO: ()=>MeshDistanceMaterial,
                    amv: ()=>Jg,
                    b4q: ()=>CubeTexture,
                    bC7: ()=>Sg,
                    bCz: ()=>Nd,
                    bI3: ()=>qg,
                    bdM: ()=>PlaneGeometry,
                    bkx: ()=>Vm,
                    brA: ()=>sm,
                    bw0: ()=>hm,
                    c90: ()=>rg,
                    cHt: ()=>jm,
                    caT: ()=>dm,
                    cj9: ()=>mA,
                    czI: ()=>_g,
                    dYF: ()=>Data3DTexture,
                    dcC: ()=>$m,
                    dwI: ()=>Matrix3,
                    e0p: ()=>im,
                    eHc: ()=>rm,
                    eaF: ()=>Mesh,
                    eoi: ()=>iA,
                    er$: ()=>Zg,
                    f4X: ()=>Wd,
                    fBL: ()=>Bm,
                    g7M: ()=>vm,
                    gJ2: ()=>Wm,
                    gO9: ()=>Rd,
                    gPd: ()=>Texture,
                    gWB: ()=>rA,
                    ghU: ()=>Cm,
                    hB5: ()=>gc,
                    hdd: ()=>Xd,
                    hgQ: ()=>sp,
                    hsX: ()=>Ac,
                    hxR: ()=>Dm,
                    hy7: ()=>wm,
                    iNn: ()=>BoxGeometry,
                    ie2: ()=>Yd,
                    ix0: ()=>qm,
                    jR7: ()=>og,
                    jej: ()=>probeAsync,
                    jf0: ()=>Wg,
                    jzd: ()=>nA,
                    k6Q: ()=>cg,
                    k6q: ()=>zm,
                    kO0: ()=>eA,
                    kRr: ()=>Nm,
                    kTW: ()=>Im,
                    kTp: ()=>ug,
                    kn4: ()=>Matrix4,
                    kyO: ()=>gm,
                    l2R: ()=>My,
                    lGu: ()=>am,
                    lPF: ()=>createCanvasElement,
                    lxW: ()=>cloneUniforms,
                    lyL: ()=>Mg,
                    mcG: ()=>warnOnce,
                    nNL: ()=>_m,
                    nST: ()=>jd,
                    nWS: ()=>WebGLRenderTarget,
                    nZQ: ()=>ArrayCamera,
                    o6l: ()=>WebGLCubeRenderTarget,
                    ojh: ()=>qd,
                    ojs: ()=>kg,
                    ov9: ()=>nm,
                    pBf: ()=>dg,
                    pHI: ()=>Lm,
                    paN: ()=>ig,
                    ppV: ()=>xA,
                    psI: ()=>xg,
                    qUd: ()=>OrthographicCamera,
                    qa3: ()=>gg,
                    qad: ()=>Hd,
                    qq$: ()=>createElementNS,
                    rFo: ()=>DataArrayTexture,
                    rSH: ()=>yg,
                    sPf: ()=>ls,
                    tBo: ()=>Raycaster,
                    tJf: ()=>Om,
                    uB5: ()=>Eg,
                    uV5: ()=>Sm,
                    ubm: ()=>PerspectiveCamera,
                    vim: ()=>$g,
                    vyJ: ()=>Hg,
                    wfO: ()=>Mm,
                    wn6: ()=>Jd,
                    wrO: ()=>Qm,
                    xFO: ()=>Em,
                    xSv: ()=>om,
                    y3Z: ()=>Tg,
                    y_p: ()=>fm,
                    zdS: ()=>Jm,
                    zgK: ()=>Layers,
                    znC: ()=>Ud
                });
                /**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ const ls = "179", ho = 0, Dl = 1, Fl = 2, sc = 1, uc = 2, mc = 3, gc = 0, Ac = 1, Ec = 2, kc = 0, du = 1, _u = 2, Md = 3, Ld = 4, Nd = 5, Rd = 100, Od = 101, jd = 102, Ud = 103, Gd = 104, qd = 200, Hd = 201, Wd = 202, Zd = 203, Yd = 204, Qd = 205, Xd = 206, Kd = 207, Jd = 208, $d = 209, sp = 210, em = 211, tm = 212, im = 213, nm = 214, rm = 0, am = 1, sm = 2, om = 3, lm = 4, cm = 5, um = 6, hm = 7, dm = 0, pm = 1, mm = 2, fm = 0, gm = 1, Am = 2, _m = 3, ym = 4, vm = 5, xm = 6, bm = 7, wm = 301, Em = 302, Mm = 303, Sm = 304, Tm = 306, km = 1e3, Cm = 1001, Im = 1002, Dm = 1003, Lm = 1004, Pm = 1005, zm = 1006, Nm = 1007, Rm = 1008, Fm = 1009, Om = 1010, Bm = 1011, jm = 1012, Um = 1013, Vm = 1014, Gm = 1015, qm = 1016, Hm = 1017, Wm = 1018, Zm = 1020, Ym = 35902, Qm = 1021, Xm = 1022, Km = 1023, Jm = 1026, $m = 1027, eg = 1028, tg = 1029, ig = 1030, ng = 1031, rg = 1033, ag = 33776, sg = 33777, og = 33778, lg = 33779, cg = 35840, ug = 35841, hg = 35842, dg = 35843, pg = 36196, mg = 37492, fg = 37496, gg = 37808, Ag = 37809, _g = 37810, yg = 37811, vg = 37812, xg = 37813, bg = 37814, wg = 37815, Eg = 37816, Mg = 37817, Sg = 37818, Tg = 37819, kg = 37820, Cg = 37821, Ig = 36492, Dg = 36494, Lg = 36495, Pg = 36283, zg = 36284, Ng = 36285, Rg = 36286, Fg = 2300, Og = 2301, Bg = 2302, jg = 2400, Ug = 2401, Vg = 2402, Gg = 3201, qg = 0, Hg = 1, Wg = "", Zg = "srgb", Yg = "srgb-linear", Qg = "linear", Xg = "srgb", Kg = 7680, Jg = 512, $g = 513, eA = 514, tA = 515, iA = 516, nA = 517, rA = 518, aA = 519, sA = 35044, oA = "300 es", lA = 2e3, cA = 2001;
                class EventDispatcher {
                    addEventListener(le1, vt) {
                        void 0 === this._listeners && (this._listeners = {});
                        const bt = this._listeners;
                        void 0 === bt[le1] && (bt[le1] = []), -1 === bt[le1].indexOf(vt) && bt[le1].push(vt);
                    }
                    hasEventListener(le1, vt) {
                        const bt = this._listeners;
                        return void 0 !== bt && void 0 !== bt[le1] && -1 !== bt[le1].indexOf(vt);
                    }
                    removeEventListener(le1, vt) {
                        const bt = this._listeners;
                        if (void 0 === bt) return;
                        const ls = bt[le1];
                        if (void 0 !== ls) {
                            const le1 = ls.indexOf(vt);
                            -1 !== le1 && ls.splice(le1, 1);
                        }
                    }
                    dispatchEvent(le1) {
                        const vt = this._listeners;
                        if (void 0 === vt) return;
                        const bt = vt[le1.type];
                        if (void 0 !== bt) {
                            le1.target = this;
                            const vt = bt.slice(0);
                            for(let bt = 0, ls = vt.length; bt < ls; bt++)vt[bt].call(this, le1);
                            le1.target = null;
                        }
                    }
                }
                const uA = [
                    "00",
                    "01",
                    "02",
                    "03",
                    "04",
                    "05",
                    "06",
                    "07",
                    "08",
                    "09",
                    "0a",
                    "0b",
                    "0c",
                    "0d",
                    "0e",
                    "0f",
                    "10",
                    "11",
                    "12",
                    "13",
                    "14",
                    "15",
                    "16",
                    "17",
                    "18",
                    "19",
                    "1a",
                    "1b",
                    "1c",
                    "1d",
                    "1e",
                    "1f",
                    "20",
                    "21",
                    "22",
                    "23",
                    "24",
                    "25",
                    "26",
                    "27",
                    "28",
                    "29",
                    "2a",
                    "2b",
                    "2c",
                    "2d",
                    "2e",
                    "2f",
                    "30",
                    "31",
                    "32",
                    "33",
                    "34",
                    "35",
                    "36",
                    "37",
                    "38",
                    "39",
                    "3a",
                    "3b",
                    "3c",
                    "3d",
                    "3e",
                    "3f",
                    "40",
                    "41",
                    "42",
                    "43",
                    "44",
                    "45",
                    "46",
                    "47",
                    "48",
                    "49",
                    "4a",
                    "4b",
                    "4c",
                    "4d",
                    "4e",
                    "4f",
                    "50",
                    "51",
                    "52",
                    "53",
                    "54",
                    "55",
                    "56",
                    "57",
                    "58",
                    "59",
                    "5a",
                    "5b",
                    "5c",
                    "5d",
                    "5e",
                    "5f",
                    "60",
                    "61",
                    "62",
                    "63",
                    "64",
                    "65",
                    "66",
                    "67",
                    "68",
                    "69",
                    "6a",
                    "6b",
                    "6c",
                    "6d",
                    "6e",
                    "6f",
                    "70",
                    "71",
                    "72",
                    "73",
                    "74",
                    "75",
                    "76",
                    "77",
                    "78",
                    "79",
                    "7a",
                    "7b",
                    "7c",
                    "7d",
                    "7e",
                    "7f",
                    "80",
                    "81",
                    "82",
                    "83",
                    "84",
                    "85",
                    "86",
                    "87",
                    "88",
                    "89",
                    "8a",
                    "8b",
                    "8c",
                    "8d",
                    "8e",
                    "8f",
                    "90",
                    "91",
                    "92",
                    "93",
                    "94",
                    "95",
                    "96",
                    "97",
                    "98",
                    "99",
                    "9a",
                    "9b",
                    "9c",
                    "9d",
                    "9e",
                    "9f",
                    "a0",
                    "a1",
                    "a2",
                    "a3",
                    "a4",
                    "a5",
                    "a6",
                    "a7",
                    "a8",
                    "a9",
                    "aa",
                    "ab",
                    "ac",
                    "ad",
                    "ae",
                    "af",
                    "b0",
                    "b1",
                    "b2",
                    "b3",
                    "b4",
                    "b5",
                    "b6",
                    "b7",
                    "b8",
                    "b9",
                    "ba",
                    "bb",
                    "bc",
                    "bd",
                    "be",
                    "bf",
                    "c0",
                    "c1",
                    "c2",
                    "c3",
                    "c4",
                    "c5",
                    "c6",
                    "c7",
                    "c8",
                    "c9",
                    "ca",
                    "cb",
                    "cc",
                    "cd",
                    "ce",
                    "cf",
                    "d0",
                    "d1",
                    "d2",
                    "d3",
                    "d4",
                    "d5",
                    "d6",
                    "d7",
                    "d8",
                    "d9",
                    "da",
                    "db",
                    "dc",
                    "dd",
                    "de",
                    "df",
                    "e0",
                    "e1",
                    "e2",
                    "e3",
                    "e4",
                    "e5",
                    "e6",
                    "e7",
                    "e8",
                    "e9",
                    "ea",
                    "eb",
                    "ec",
                    "ed",
                    "ee",
                    "ef",
                    "f0",
                    "f1",
                    "f2",
                    "f3",
                    "f4",
                    "f5",
                    "f6",
                    "f7",
                    "f8",
                    "f9",
                    "fa",
                    "fb",
                    "fc",
                    "fd",
                    "fe",
                    "ff"
                ];
                let hA = 1234567;
                const dA = Math.PI / 180, pA = 180 / Math.PI;
                function generateUUID() {
                    const le1 = 4294967295 * Math.random() | 0, vt = 4294967295 * Math.random() | 0, bt = 4294967295 * Math.random() | 0, ls = 4294967295 * Math.random() | 0;
                    return (uA[255 & le1] + uA[le1 >> 8 & 255] + uA[le1 >> 16 & 255] + uA[le1 >> 24 & 255] + "-" + uA[255 & vt] + uA[vt >> 8 & 255] + "-" + uA[vt >> 16 & 15 | 64] + uA[vt >> 24 & 255] + "-" + uA[63 & bt | 128] + uA[bt >> 8 & 255] + "-" + uA[bt >> 16 & 255] + uA[bt >> 24 & 255] + uA[255 & ls] + uA[ls >> 8 & 255] + uA[ls >> 16 & 255] + uA[ls >> 24 & 255]).toLowerCase();
                }
                function clamp(le1, vt, bt) {
                    return Math.max(vt, Math.min(bt, le1));
                }
                function euclideanModulo(le1, vt) {
                    return (le1 % vt + vt) % vt;
                }
                function lerp(le1, vt, bt) {
                    return (1 - bt) * le1 + bt * vt;
                }
                function denormalize(le1, vt) {
                    switch(vt.constructor){
                        case Float32Array:
                            return le1;
                        case Uint32Array:
                            return le1 / 4294967295;
                        case Uint16Array:
                            return le1 / 65535;
                        case Uint8Array:
                            return le1 / 255;
                        case Int32Array:
                            return Math.max(le1 / 2147483647, -1);
                        case Int16Array:
                            return Math.max(le1 / 32767, -1);
                        case Int8Array:
                            return Math.max(le1 / 127, -1);
                        default:
                            throw new Error("Invalid component type.");
                    }
                }
                function normalize(le1, vt) {
                    switch(vt.constructor){
                        case Float32Array:
                            return le1;
                        case Uint32Array:
                            return Math.round(4294967295 * le1);
                        case Uint16Array:
                            return Math.round(65535 * le1);
                        case Uint8Array:
                            return Math.round(255 * le1);
                        case Int32Array:
                            return Math.round(2147483647 * le1);
                        case Int16Array:
                            return Math.round(32767 * le1);
                        case Int8Array:
                            return Math.round(127 * le1);
                        default:
                            throw new Error("Invalid component type.");
                    }
                }
                const mA = {
                    DEG2RAD: dA,
                    RAD2DEG: pA,
                    generateUUID: generateUUID,
                    clamp: clamp,
                    euclideanModulo: euclideanModulo,
                    mapLinear: function(le1, vt, bt, ls, ho) {
                        return ls + (le1 - vt) * (ho - ls) / (bt - vt);
                    },
                    inverseLerp: function(le1, vt, bt) {
                        return le1 !== vt ? (bt - le1) / (vt - le1) : 0;
                    },
                    lerp: lerp,
                    damp: function(le1, vt, bt, ls) {
                        return lerp(le1, vt, 1 - Math.exp(-bt * ls));
                    },
                    pingpong: function(le1, vt) {
                        return void 0 === vt && (vt = 1), vt - Math.abs(euclideanModulo(le1, 2 * vt) - vt);
                    },
                    smoothstep: function(le1, vt, bt) {
                        return le1 <= vt ? 0 : le1 >= bt ? 1 : (le1 = (le1 - vt) / (bt - vt)) * le1 * (3 - 2 * le1);
                    },
                    smootherstep: function(le1, vt, bt) {
                        return le1 <= vt ? 0 : le1 >= bt ? 1 : (le1 = (le1 - vt) / (bt - vt)) * le1 * le1 * (le1 * (6 * le1 - 15) + 10);
                    },
                    randInt: function(le1, vt) {
                        return le1 + Math.floor(Math.random() * (vt - le1 + 1));
                    },
                    randFloat: function(le1, vt) {
                        return le1 + Math.random() * (vt - le1);
                    },
                    randFloatSpread: function(le1) {
                        return le1 * (.5 - Math.random());
                    },
                    seededRandom: function(le1) {
                        void 0 !== le1 && (hA = le1);
                        let vt = hA += 1831565813;
                        return vt = Math.imul(vt ^ vt >>> 15, 1 | vt), vt ^= vt + Math.imul(vt ^ vt >>> 7, 61 | vt), ((vt ^ vt >>> 14) >>> 0) / 4294967296;
                    },
                    degToRad: function(le1) {
                        return le1 * dA;
                    },
                    radToDeg: function(le1) {
                        return le1 * pA;
                    },
                    isPowerOfTwo: function(le1) {
                        return 0 === (le1 & le1 - 1) && 0 !== le1;
                    },
                    ceilPowerOfTwo: function(le1) {
                        return Math.pow(2, Math.ceil(Math.log(le1) / Math.LN2));
                    },
                    floorPowerOfTwo: function(le1) {
                        return Math.pow(2, Math.floor(Math.log(le1) / Math.LN2));
                    },
                    setQuaternionFromProperEuler: function(le1, vt, bt, ls, ho) {
                        const Dl = Math.cos, Fl = Math.sin, sc = Dl(bt / 2), uc = Fl(bt / 2), mc = Dl((vt + ls) / 2), gc = Fl((vt + ls) / 2), Ac = Dl((vt - ls) / 2), Ec = Fl((vt - ls) / 2), kc = Dl((ls - vt) / 2), du = Fl((ls - vt) / 2);
                        switch(ho){
                            case "XYX":
                                le1.set(sc * gc, uc * Ac, uc * Ec, sc * mc);
                                break;
                            case "YZY":
                                le1.set(uc * Ec, sc * gc, uc * Ac, sc * mc);
                                break;
                            case "ZXZ":
                                le1.set(uc * Ac, uc * Ec, sc * gc, sc * mc);
                                break;
                            case "XZX":
                                le1.set(sc * gc, uc * du, uc * kc, sc * mc);
                                break;
                            case "YXY":
                                le1.set(uc * kc, sc * gc, uc * du, sc * mc);
                                break;
                            case "ZYZ":
                                le1.set(uc * du, uc * kc, sc * gc, sc * mc);
                                break;
                            default:
                                console.warn("THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: " + ho);
                        }
                    },
                    normalize: normalize,
                    denormalize: denormalize
                };
                class Vector2 {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = 0), void 0 === vt && (vt = 0), Vector2.prototype.isVector2 = !0, this.x = le1, this.y = vt;
                    }
                    get width() {
                        return this.x;
                    }
                    set width(le1) {
                        this.x = le1;
                    }
                    get height() {
                        return this.y;
                    }
                    set height(le1) {
                        this.y = le1;
                    }
                    set(le1, vt) {
                        return this.x = le1, this.y = vt, this;
                    }
                    setScalar(le1) {
                        return this.x = le1, this.y = le1, this;
                    }
                    setX(le1) {
                        return this.x = le1, this;
                    }
                    setY(le1) {
                        return this.y = le1, this;
                    }
                    setComponent(le1, vt) {
                        switch(le1){
                            case 0:
                                this.x = vt;
                                break;
                            case 1:
                                this.y = vt;
                                break;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                        return this;
                    }
                    getComponent(le1) {
                        switch(le1){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y);
                    }
                    copy(le1) {
                        return this.x = le1.x, this.y = le1.y, this;
                    }
                    add(le1) {
                        return this.x += le1.x, this.y += le1.y, this;
                    }
                    addScalar(le1) {
                        return this.x += le1, this.y += le1, this;
                    }
                    addVectors(le1, vt) {
                        return this.x = le1.x + vt.x, this.y = le1.y + vt.y, this;
                    }
                    addScaledVector(le1, vt) {
                        return this.x += le1.x * vt, this.y += le1.y * vt, this;
                    }
                    sub(le1) {
                        return this.x -= le1.x, this.y -= le1.y, this;
                    }
                    subScalar(le1) {
                        return this.x -= le1, this.y -= le1, this;
                    }
                    subVectors(le1, vt) {
                        return this.x = le1.x - vt.x, this.y = le1.y - vt.y, this;
                    }
                    multiply(le1) {
                        return this.x *= le1.x, this.y *= le1.y, this;
                    }
                    multiplyScalar(le1) {
                        return this.x *= le1, this.y *= le1, this;
                    }
                    divide(le1) {
                        return this.x /= le1.x, this.y /= le1.y, this;
                    }
                    divideScalar(le1) {
                        return this.multiplyScalar(1 / le1);
                    }
                    applyMatrix3(le1) {
                        const vt = this.x, bt = this.y, ls = le1.elements;
                        return this.x = ls[0] * vt + ls[3] * bt + ls[6], this.y = ls[1] * vt + ls[4] * bt + ls[7], this;
                    }
                    min(le1) {
                        return this.x = Math.min(this.x, le1.x), this.y = Math.min(this.y, le1.y), this;
                    }
                    max(le1) {
                        return this.x = Math.max(this.x, le1.x), this.y = Math.max(this.y, le1.y), this;
                    }
                    clamp(le1, vt) {
                        return this.x = clamp(this.x, le1.x, vt.x), this.y = clamp(this.y, le1.y, vt.y), this;
                    }
                    clampScalar(le1, vt) {
                        return this.x = clamp(this.x, le1, vt), this.y = clamp(this.y, le1, vt), this;
                    }
                    clampLength(le1, vt) {
                        const bt = this.length();
                        return this.divideScalar(bt || 1).multiplyScalar(clamp(bt, le1, vt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this;
                    }
                    dot(le1) {
                        return this.x * le1.x + this.y * le1.y;
                    }
                    cross(le1) {
                        return this.x * le1.y - this.y * le1.x;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    angle() {
                        return Math.atan2(-this.y, -this.x) + Math.PI;
                    }
                    angleTo(le1) {
                        const vt = Math.sqrt(this.lengthSq() * le1.lengthSq());
                        if (0 === vt) return Math.PI / 2;
                        const bt = this.dot(le1) / vt;
                        return Math.acos(clamp(bt, -1, 1));
                    }
                    distanceTo(le1) {
                        return Math.sqrt(this.distanceToSquared(le1));
                    }
                    distanceToSquared(le1) {
                        const vt = this.x - le1.x, bt = this.y - le1.y;
                        return vt * vt + bt * bt;
                    }
                    manhattanDistanceTo(le1) {
                        return Math.abs(this.x - le1.x) + Math.abs(this.y - le1.y);
                    }
                    setLength(le1) {
                        return this.normalize().multiplyScalar(le1);
                    }
                    lerp(le1, vt) {
                        return this.x += (le1.x - this.x) * vt, this.y += (le1.y - this.y) * vt, this;
                    }
                    lerpVectors(le1, vt, bt) {
                        return this.x = le1.x + (vt.x - le1.x) * bt, this.y = le1.y + (vt.y - le1.y) * bt, this;
                    }
                    equals(le1) {
                        return le1.x === this.x && le1.y === this.y;
                    }
                    fromArray(le1, vt) {
                        return void 0 === vt && (vt = 0), this.x = le1[vt], this.y = le1[vt + 1], this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this.x, le1[vt + 1] = this.y, le1;
                    }
                    fromBufferAttribute(le1, vt) {
                        return this.x = le1.getX(vt), this.y = le1.getY(vt), this;
                    }
                    rotateAround(le1, vt) {
                        const bt = Math.cos(vt), ls = Math.sin(vt), ho = this.x - le1.x, Dl = this.y - le1.y;
                        return this.x = ho * bt - Dl * ls + le1.x, this.y = ho * ls + Dl * bt + le1.y, this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y;
                    }
                }
                class Quaternion {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = 0), void 0 === vt && (vt = 0), void 0 === bt && (bt = 0), void 0 === ls && (ls = 1), this.isQuaternion = !0, this._x = le1, this._y = vt, this._z = bt, this._w = ls;
                    }
                    static slerpFlat(le1, vt, bt, ls, ho, Dl, Fl) {
                        let sc = bt[ls + 0], uc = bt[ls + 1], mc = bt[ls + 2], gc = bt[ls + 3];
                        const Ac = ho[Dl + 0], Ec = ho[Dl + 1], kc = ho[Dl + 2], du = ho[Dl + 3];
                        if (0 === Fl) return le1[vt + 0] = sc, le1[vt + 1] = uc, le1[vt + 2] = mc, void (le1[vt + 3] = gc);
                        if (1 === Fl) return le1[vt + 0] = Ac, le1[vt + 1] = Ec, le1[vt + 2] = kc, void (le1[vt + 3] = du);
                        if (gc !== du || sc !== Ac || uc !== Ec || mc !== kc) {
                            let le1 = 1 - Fl;
                            const vt = sc * Ac + uc * Ec + mc * kc + gc * du, bt = vt >= 0 ? 1 : -1, ls = 1 - vt * vt;
                            if (ls > Number.EPSILON) {
                                const ho = Math.sqrt(ls), Dl = Math.atan2(ho, vt * bt);
                                le1 = Math.sin(le1 * Dl) / ho, Fl = Math.sin(Fl * Dl) / ho;
                            }
                            const ho = Fl * bt;
                            if (sc = sc * le1 + Ac * ho, uc = uc * le1 + Ec * ho, mc = mc * le1 + kc * ho, gc = gc * le1 + du * ho, le1 === 1 - Fl) {
                                const le1 = 1 / Math.sqrt(sc * sc + uc * uc + mc * mc + gc * gc);
                                sc *= le1, uc *= le1, mc *= le1, gc *= le1;
                            }
                        }
                        le1[vt] = sc, le1[vt + 1] = uc, le1[vt + 2] = mc, le1[vt + 3] = gc;
                    }
                    static multiplyQuaternionsFlat(le1, vt, bt, ls, ho, Dl) {
                        const Fl = bt[ls], sc = bt[ls + 1], uc = bt[ls + 2], mc = bt[ls + 3], gc = ho[Dl], Ac = ho[Dl + 1], Ec = ho[Dl + 2], kc = ho[Dl + 3];
                        return le1[vt] = Fl * kc + mc * gc + sc * Ec - uc * Ac, le1[vt + 1] = sc * kc + mc * Ac + uc * gc - Fl * Ec, le1[vt + 2] = uc * kc + mc * Ec + Fl * Ac - sc * gc, le1[vt + 3] = mc * kc - Fl * gc - sc * Ac - uc * Ec, le1;
                    }
                    get x() {
                        return this._x;
                    }
                    set x(le1) {
                        this._x = le1, this._onChangeCallback();
                    }
                    get y() {
                        return this._y;
                    }
                    set y(le1) {
                        this._y = le1, this._onChangeCallback();
                    }
                    get z() {
                        return this._z;
                    }
                    set z(le1) {
                        this._z = le1, this._onChangeCallback();
                    }
                    get w() {
                        return this._w;
                    }
                    set w(le1) {
                        this._w = le1, this._onChangeCallback();
                    }
                    set(le1, vt, bt, ls) {
                        return this._x = le1, this._y = vt, this._z = bt, this._w = ls, this._onChangeCallback(), this;
                    }
                    clone() {
                        return new this.constructor(this._x, this._y, this._z, this._w);
                    }
                    copy(le1) {
                        return this._x = le1.x, this._y = le1.y, this._z = le1.z, this._w = le1.w, this._onChangeCallback(), this;
                    }
                    setFromEuler(le1, vt) {
                        void 0 === vt && (vt = !0);
                        const bt = le1._x, ls = le1._y, ho = le1._z, Dl = le1._order, Fl = Math.cos, sc = Math.sin, uc = Fl(bt / 2), mc = Fl(ls / 2), gc = Fl(ho / 2), Ac = sc(bt / 2), Ec = sc(ls / 2), kc = sc(ho / 2);
                        switch(Dl){
                            case "XYZ":
                                this._x = Ac * mc * gc + uc * Ec * kc, this._y = uc * Ec * gc - Ac * mc * kc, this._z = uc * mc * kc + Ac * Ec * gc, this._w = uc * mc * gc - Ac * Ec * kc;
                                break;
                            case "YXZ":
                                this._x = Ac * mc * gc + uc * Ec * kc, this._y = uc * Ec * gc - Ac * mc * kc, this._z = uc * mc * kc - Ac * Ec * gc, this._w = uc * mc * gc + Ac * Ec * kc;
                                break;
                            case "ZXY":
                                this._x = Ac * mc * gc - uc * Ec * kc, this._y = uc * Ec * gc + Ac * mc * kc, this._z = uc * mc * kc + Ac * Ec * gc, this._w = uc * mc * gc - Ac * Ec * kc;
                                break;
                            case "ZYX":
                                this._x = Ac * mc * gc - uc * Ec * kc, this._y = uc * Ec * gc + Ac * mc * kc, this._z = uc * mc * kc - Ac * Ec * gc, this._w = uc * mc * gc + Ac * Ec * kc;
                                break;
                            case "YZX":
                                this._x = Ac * mc * gc + uc * Ec * kc, this._y = uc * Ec * gc + Ac * mc * kc, this._z = uc * mc * kc - Ac * Ec * gc, this._w = uc * mc * gc - Ac * Ec * kc;
                                break;
                            case "XZY":
                                this._x = Ac * mc * gc - uc * Ec * kc, this._y = uc * Ec * gc - Ac * mc * kc, this._z = uc * mc * kc + Ac * Ec * gc, this._w = uc * mc * gc + Ac * Ec * kc;
                                break;
                            default:
                                console.warn("THREE.Quaternion: .setFromEuler() encountered an unknown order: " + Dl);
                        }
                        return !0 === vt && this._onChangeCallback(), this;
                    }
                    setFromAxisAngle(le1, vt) {
                        const bt = vt / 2, ls = Math.sin(bt);
                        return this._x = le1.x * ls, this._y = le1.y * ls, this._z = le1.z * ls, this._w = Math.cos(bt), this._onChangeCallback(), this;
                    }
                    setFromRotationMatrix(le1) {
                        const vt = le1.elements, bt = vt[0], ls = vt[4], ho = vt[8], Dl = vt[1], Fl = vt[5], sc = vt[9], uc = vt[2], mc = vt[6], gc = vt[10], Ac = bt + Fl + gc;
                        if (Ac > 0) {
                            const le1 = .5 / Math.sqrt(Ac + 1);
                            this._w = .25 / le1, this._x = (mc - sc) * le1, this._y = (ho - uc) * le1, this._z = (Dl - ls) * le1;
                        } else if (bt > Fl && bt > gc) {
                            const le1 = 2 * Math.sqrt(1 + bt - Fl - gc);
                            this._w = (mc - sc) / le1, this._x = .25 * le1, this._y = (ls + Dl) / le1, this._z = (ho + uc) / le1;
                        } else if (Fl > gc) {
                            const le1 = 2 * Math.sqrt(1 + Fl - bt - gc);
                            this._w = (ho - uc) / le1, this._x = (ls + Dl) / le1, this._y = .25 * le1, this._z = (sc + mc) / le1;
                        } else {
                            const le1 = 2 * Math.sqrt(1 + gc - bt - Fl);
                            this._w = (Dl - ls) / le1, this._x = (ho + uc) / le1, this._y = (sc + mc) / le1, this._z = .25 * le1;
                        }
                        return this._onChangeCallback(), this;
                    }
                    setFromUnitVectors(le1, vt) {
                        let bt = le1.dot(vt) + 1;
                        return bt < 1e-8 ? (bt = 0, Math.abs(le1.x) > Math.abs(le1.z) ? (this._x = -le1.y, this._y = le1.x, this._z = 0, this._w = bt) : (this._x = 0, this._y = -le1.z, this._z = le1.y, this._w = bt)) : (this._x = le1.y * vt.z - le1.z * vt.y, this._y = le1.z * vt.x - le1.x * vt.z, this._z = le1.x * vt.y - le1.y * vt.x, this._w = bt), this.normalize();
                    }
                    angleTo(le1) {
                        return 2 * Math.acos(Math.abs(clamp(this.dot(le1), -1, 1)));
                    }
                    rotateTowards(le1, vt) {
                        const bt = this.angleTo(le1);
                        if (0 === bt) return this;
                        const ls = Math.min(1, vt / bt);
                        return this.slerp(le1, ls), this;
                    }
                    identity() {
                        return this.set(0, 0, 0, 1);
                    }
                    invert() {
                        return this.conjugate();
                    }
                    conjugate() {
                        return this._x *= -1, this._y *= -1, this._z *= -1, this._onChangeCallback(), this;
                    }
                    dot(le1) {
                        return this._x * le1._x + this._y * le1._y + this._z * le1._z + this._w * le1._w;
                    }
                    lengthSq() {
                        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
                    }
                    length() {
                        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
                    }
                    normalize() {
                        let le1 = this.length();
                        return 0 === le1 ? (this._x = 0, this._y = 0, this._z = 0, this._w = 1) : (le1 = 1 / le1, this._x = this._x * le1, this._y = this._y * le1, this._z = this._z * le1, this._w = this._w * le1), this._onChangeCallback(), this;
                    }
                    multiply(le1) {
                        return this.multiplyQuaternions(this, le1);
                    }
                    premultiply(le1) {
                        return this.multiplyQuaternions(le1, this);
                    }
                    multiplyQuaternions(le1, vt) {
                        const bt = le1._x, ls = le1._y, ho = le1._z, Dl = le1._w, Fl = vt._x, sc = vt._y, uc = vt._z, mc = vt._w;
                        return this._x = bt * mc + Dl * Fl + ls * uc - ho * sc, this._y = ls * mc + Dl * sc + ho * Fl - bt * uc, this._z = ho * mc + Dl * uc + bt * sc - ls * Fl, this._w = Dl * mc - bt * Fl - ls * sc - ho * uc, this._onChangeCallback(), this;
                    }
                    slerp(le1, vt) {
                        if (0 === vt) return this;
                        if (1 === vt) return this.copy(le1);
                        const bt = this._x, ls = this._y, ho = this._z, Dl = this._w;
                        let Fl = Dl * le1._w + bt * le1._x + ls * le1._y + ho * le1._z;
                        if (Fl < 0 ? (this._w = -le1._w, this._x = -le1._x, this._y = -le1._y, this._z = -le1._z, Fl = -Fl) : this.copy(le1), Fl >= 1) return this._w = Dl, this._x = bt, this._y = ls, this._z = ho, this;
                        const sc = 1 - Fl * Fl;
                        if (sc <= Number.EPSILON) {
                            const le1 = 1 - vt;
                            return this._w = le1 * Dl + vt * this._w, this._x = le1 * bt + vt * this._x, this._y = le1 * ls + vt * this._y, this._z = le1 * ho + vt * this._z, this.normalize(), this;
                        }
                        const uc = Math.sqrt(sc), mc = Math.atan2(uc, Fl), gc = Math.sin((1 - vt) * mc) / uc, Ac = Math.sin(vt * mc) / uc;
                        return this._w = Dl * gc + this._w * Ac, this._x = bt * gc + this._x * Ac, this._y = ls * gc + this._y * Ac, this._z = ho * gc + this._z * Ac, this._onChangeCallback(), this;
                    }
                    slerpQuaternions(le1, vt, bt) {
                        return this.copy(le1).slerp(vt, bt);
                    }
                    random() {
                        const le1 = 2 * Math.PI * Math.random(), vt = 2 * Math.PI * Math.random(), bt = Math.random(), ls = Math.sqrt(1 - bt), ho = Math.sqrt(bt);
                        return this.set(ls * Math.sin(le1), ls * Math.cos(le1), ho * Math.sin(vt), ho * Math.cos(vt));
                    }
                    equals(le1) {
                        return le1._x === this._x && le1._y === this._y && le1._z === this._z && le1._w === this._w;
                    }
                    fromArray(le1, vt) {
                        return void 0 === vt && (vt = 0), this._x = le1[vt], this._y = le1[vt + 1], this._z = le1[vt + 2], this._w = le1[vt + 3], this._onChangeCallback(), this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this._x, le1[vt + 1] = this._y, le1[vt + 2] = this._z, le1[vt + 3] = this._w, le1;
                    }
                    fromBufferAttribute(le1, vt) {
                        return this._x = le1.getX(vt), this._y = le1.getY(vt), this._z = le1.getZ(vt), this._w = le1.getW(vt), this._onChangeCallback(), this;
                    }
                    toJSON() {
                        return this.toArray();
                    }
                    _onChange(le1) {
                        return this._onChangeCallback = le1, this;
                    }
                    _onChangeCallback() {}
                    *[Symbol.iterator]() {
                        yield this._x, yield this._y, yield this._z, yield this._w;
                    }
                }
                class Vector3 {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = 0), void 0 === vt && (vt = 0), void 0 === bt && (bt = 0), Vector3.prototype.isVector3 = !0, this.x = le1, this.y = vt, this.z = bt;
                    }
                    set(le1, vt, bt) {
                        return void 0 === bt && (bt = this.z), this.x = le1, this.y = vt, this.z = bt, this;
                    }
                    setScalar(le1) {
                        return this.x = le1, this.y = le1, this.z = le1, this;
                    }
                    setX(le1) {
                        return this.x = le1, this;
                    }
                    setY(le1) {
                        return this.y = le1, this;
                    }
                    setZ(le1) {
                        return this.z = le1, this;
                    }
                    setComponent(le1, vt) {
                        switch(le1){
                            case 0:
                                this.x = vt;
                                break;
                            case 1:
                                this.y = vt;
                                break;
                            case 2:
                                this.z = vt;
                                break;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                        return this;
                    }
                    getComponent(le1) {
                        switch(le1){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            case 2:
                                return this.z;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y, this.z);
                    }
                    copy(le1) {
                        return this.x = le1.x, this.y = le1.y, this.z = le1.z, this;
                    }
                    add(le1) {
                        return this.x += le1.x, this.y += le1.y, this.z += le1.z, this;
                    }
                    addScalar(le1) {
                        return this.x += le1, this.y += le1, this.z += le1, this;
                    }
                    addVectors(le1, vt) {
                        return this.x = le1.x + vt.x, this.y = le1.y + vt.y, this.z = le1.z + vt.z, this;
                    }
                    addScaledVector(le1, vt) {
                        return this.x += le1.x * vt, this.y += le1.y * vt, this.z += le1.z * vt, this;
                    }
                    sub(le1) {
                        return this.x -= le1.x, this.y -= le1.y, this.z -= le1.z, this;
                    }
                    subScalar(le1) {
                        return this.x -= le1, this.y -= le1, this.z -= le1, this;
                    }
                    subVectors(le1, vt) {
                        return this.x = le1.x - vt.x, this.y = le1.y - vt.y, this.z = le1.z - vt.z, this;
                    }
                    multiply(le1) {
                        return this.x *= le1.x, this.y *= le1.y, this.z *= le1.z, this;
                    }
                    multiplyScalar(le1) {
                        return this.x *= le1, this.y *= le1, this.z *= le1, this;
                    }
                    multiplyVectors(le1, vt) {
                        return this.x = le1.x * vt.x, this.y = le1.y * vt.y, this.z = le1.z * vt.z, this;
                    }
                    applyEuler(le1) {
                        return this.applyQuaternion(gA.setFromEuler(le1));
                    }
                    applyAxisAngle(le1, vt) {
                        return this.applyQuaternion(gA.setFromAxisAngle(le1, vt));
                    }
                    applyMatrix3(le1) {
                        const vt = this.x, bt = this.y, ls = this.z, ho = le1.elements;
                        return this.x = ho[0] * vt + ho[3] * bt + ho[6] * ls, this.y = ho[1] * vt + ho[4] * bt + ho[7] * ls, this.z = ho[2] * vt + ho[5] * bt + ho[8] * ls, this;
                    }
                    applyNormalMatrix(le1) {
                        return this.applyMatrix3(le1).normalize();
                    }
                    applyMatrix4(le1) {
                        const vt = this.x, bt = this.y, ls = this.z, ho = le1.elements, Dl = 1 / (ho[3] * vt + ho[7] * bt + ho[11] * ls + ho[15]);
                        return this.x = (ho[0] * vt + ho[4] * bt + ho[8] * ls + ho[12]) * Dl, this.y = (ho[1] * vt + ho[5] * bt + ho[9] * ls + ho[13]) * Dl, this.z = (ho[2] * vt + ho[6] * bt + ho[10] * ls + ho[14]) * Dl, this;
                    }
                    applyQuaternion(le1) {
                        const vt = this.x, bt = this.y, ls = this.z, ho = le1.x, Dl = le1.y, Fl = le1.z, sc = le1.w, uc = 2 * (Dl * ls - Fl * bt), mc = 2 * (Fl * vt - ho * ls), gc = 2 * (ho * bt - Dl * vt);
                        return this.x = vt + sc * uc + Dl * gc - Fl * mc, this.y = bt + sc * mc + Fl * uc - ho * gc, this.z = ls + sc * gc + ho * mc - Dl * uc, this;
                    }
                    project(le1) {
                        return this.applyMatrix4(le1.matrixWorldInverse).applyMatrix4(le1.projectionMatrix);
                    }
                    unproject(le1) {
                        return this.applyMatrix4(le1.projectionMatrixInverse).applyMatrix4(le1.matrixWorld);
                    }
                    transformDirection(le1) {
                        const vt = this.x, bt = this.y, ls = this.z, ho = le1.elements;
                        return this.x = ho[0] * vt + ho[4] * bt + ho[8] * ls, this.y = ho[1] * vt + ho[5] * bt + ho[9] * ls, this.z = ho[2] * vt + ho[6] * bt + ho[10] * ls, this.normalize();
                    }
                    divide(le1) {
                        return this.x /= le1.x, this.y /= le1.y, this.z /= le1.z, this;
                    }
                    divideScalar(le1) {
                        return this.multiplyScalar(1 / le1);
                    }
                    min(le1) {
                        return this.x = Math.min(this.x, le1.x), this.y = Math.min(this.y, le1.y), this.z = Math.min(this.z, le1.z), this;
                    }
                    max(le1) {
                        return this.x = Math.max(this.x, le1.x), this.y = Math.max(this.y, le1.y), this.z = Math.max(this.z, le1.z), this;
                    }
                    clamp(le1, vt) {
                        return this.x = clamp(this.x, le1.x, vt.x), this.y = clamp(this.y, le1.y, vt.y), this.z = clamp(this.z, le1.z, vt.z), this;
                    }
                    clampScalar(le1, vt) {
                        return this.x = clamp(this.x, le1, vt), this.y = clamp(this.y, le1, vt), this.z = clamp(this.z, le1, vt), this;
                    }
                    clampLength(le1, vt) {
                        const bt = this.length();
                        return this.divideScalar(bt || 1).multiplyScalar(clamp(bt, le1, vt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this;
                    }
                    dot(le1) {
                        return this.x * le1.x + this.y * le1.y + this.z * le1.z;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y + this.z * this.z;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    setLength(le1) {
                        return this.normalize().multiplyScalar(le1);
                    }
                    lerp(le1, vt) {
                        return this.x += (le1.x - this.x) * vt, this.y += (le1.y - this.y) * vt, this.z += (le1.z - this.z) * vt, this;
                    }
                    lerpVectors(le1, vt, bt) {
                        return this.x = le1.x + (vt.x - le1.x) * bt, this.y = le1.y + (vt.y - le1.y) * bt, this.z = le1.z + (vt.z - le1.z) * bt, this;
                    }
                    cross(le1) {
                        return this.crossVectors(this, le1);
                    }
                    crossVectors(le1, vt) {
                        const bt = le1.x, ls = le1.y, ho = le1.z, Dl = vt.x, Fl = vt.y, sc = vt.z;
                        return this.x = ls * sc - ho * Fl, this.y = ho * Dl - bt * sc, this.z = bt * Fl - ls * Dl, this;
                    }
                    projectOnVector(le1) {
                        const vt = le1.lengthSq();
                        if (0 === vt) return this.set(0, 0, 0);
                        const bt = le1.dot(this) / vt;
                        return this.copy(le1).multiplyScalar(bt);
                    }
                    projectOnPlane(le1) {
                        return fA.copy(this).projectOnVector(le1), this.sub(fA);
                    }
                    reflect(le1) {
                        return this.sub(fA.copy(le1).multiplyScalar(2 * this.dot(le1)));
                    }
                    angleTo(le1) {
                        const vt = Math.sqrt(this.lengthSq() * le1.lengthSq());
                        if (0 === vt) return Math.PI / 2;
                        const bt = this.dot(le1) / vt;
                        return Math.acos(clamp(bt, -1, 1));
                    }
                    distanceTo(le1) {
                        return Math.sqrt(this.distanceToSquared(le1));
                    }
                    distanceToSquared(le1) {
                        const vt = this.x - le1.x, bt = this.y - le1.y, ls = this.z - le1.z;
                        return vt * vt + bt * bt + ls * ls;
                    }
                    manhattanDistanceTo(le1) {
                        return Math.abs(this.x - le1.x) + Math.abs(this.y - le1.y) + Math.abs(this.z - le1.z);
                    }
                    setFromSpherical(le1) {
                        return this.setFromSphericalCoords(le1.radius, le1.phi, le1.theta);
                    }
                    setFromSphericalCoords(le1, vt, bt) {
                        const ls = Math.sin(vt) * le1;
                        return this.x = ls * Math.sin(bt), this.y = Math.cos(vt) * le1, this.z = ls * Math.cos(bt), this;
                    }
                    setFromCylindrical(le1) {
                        return this.setFromCylindricalCoords(le1.radius, le1.theta, le1.y);
                    }
                    setFromCylindricalCoords(le1, vt, bt) {
                        return this.x = le1 * Math.sin(vt), this.y = bt, this.z = le1 * Math.cos(vt), this;
                    }
                    setFromMatrixPosition(le1) {
                        const vt = le1.elements;
                        return this.x = vt[12], this.y = vt[13], this.z = vt[14], this;
                    }
                    setFromMatrixScale(le1) {
                        const vt = this.setFromMatrixColumn(le1, 0).length(), bt = this.setFromMatrixColumn(le1, 1).length(), ls = this.setFromMatrixColumn(le1, 2).length();
                        return this.x = vt, this.y = bt, this.z = ls, this;
                    }
                    setFromMatrixColumn(le1, vt) {
                        return this.fromArray(le1.elements, 4 * vt);
                    }
                    setFromMatrix3Column(le1, vt) {
                        return this.fromArray(le1.elements, 3 * vt);
                    }
                    setFromEuler(le1) {
                        return this.x = le1._x, this.y = le1._y, this.z = le1._z, this;
                    }
                    setFromColor(le1) {
                        return this.x = le1.r, this.y = le1.g, this.z = le1.b, this;
                    }
                    equals(le1) {
                        return le1.x === this.x && le1.y === this.y && le1.z === this.z;
                    }
                    fromArray(le1, vt) {
                        return void 0 === vt && (vt = 0), this.x = le1[vt], this.y = le1[vt + 1], this.z = le1[vt + 2], this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this.x, le1[vt + 1] = this.y, le1[vt + 2] = this.z, le1;
                    }
                    fromBufferAttribute(le1, vt) {
                        return this.x = le1.getX(vt), this.y = le1.getY(vt), this.z = le1.getZ(vt), this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this;
                    }
                    randomDirection() {
                        const le1 = Math.random() * Math.PI * 2, vt = 2 * Math.random() - 1, bt = Math.sqrt(1 - vt * vt);
                        return this.x = bt * Math.cos(le1), this.y = vt, this.z = bt * Math.sin(le1), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y, yield this.z;
                    }
                }
                const fA = new Vector3, gA = new Quaternion;
                class Matrix3 {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc){
                        Matrix3.prototype.isMatrix3 = !0, this.elements = [
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ], void 0 !== le1 && this.set(le1, vt, bt, ls, ho, Dl, Fl, sc, uc);
                    }
                    set(le1, vt, bt, ls, ho, Dl, Fl, sc, uc) {
                        const mc = this.elements;
                        return mc[0] = le1, mc[1] = ls, mc[2] = Fl, mc[3] = vt, mc[4] = ho, mc[5] = sc, mc[6] = bt, mc[7] = Dl, mc[8] = uc, this;
                    }
                    identity() {
                        return this.set(1, 0, 0, 0, 1, 0, 0, 0, 1), this;
                    }
                    copy(le1) {
                        const vt = this.elements, bt = le1.elements;
                        return vt[0] = bt[0], vt[1] = bt[1], vt[2] = bt[2], vt[3] = bt[3], vt[4] = bt[4], vt[5] = bt[5], vt[6] = bt[6], vt[7] = bt[7], vt[8] = bt[8], this;
                    }
                    extractBasis(le1, vt, bt) {
                        return le1.setFromMatrix3Column(this, 0), vt.setFromMatrix3Column(this, 1), bt.setFromMatrix3Column(this, 2), this;
                    }
                    setFromMatrix4(le1) {
                        const vt = le1.elements;
                        return this.set(vt[0], vt[4], vt[8], vt[1], vt[5], vt[9], vt[2], vt[6], vt[10]), this;
                    }
                    multiply(le1) {
                        return this.multiplyMatrices(this, le1);
                    }
                    premultiply(le1) {
                        return this.multiplyMatrices(le1, this);
                    }
                    multiplyMatrices(le1, vt) {
                        const bt = le1.elements, ls = vt.elements, ho = this.elements, Dl = bt[0], Fl = bt[3], sc = bt[6], uc = bt[1], mc = bt[4], gc = bt[7], Ac = bt[2], Ec = bt[5], kc = bt[8], du = ls[0], _u = ls[3], Md = ls[6], Ld = ls[1], Nd = ls[4], Rd = ls[7], Od = ls[2], jd = ls[5], Ud = ls[8];
                        return ho[0] = Dl * du + Fl * Ld + sc * Od, ho[3] = Dl * _u + Fl * Nd + sc * jd, ho[6] = Dl * Md + Fl * Rd + sc * Ud, ho[1] = uc * du + mc * Ld + gc * Od, ho[4] = uc * _u + mc * Nd + gc * jd, ho[7] = uc * Md + mc * Rd + gc * Ud, ho[2] = Ac * du + Ec * Ld + kc * Od, ho[5] = Ac * _u + Ec * Nd + kc * jd, ho[8] = Ac * Md + Ec * Rd + kc * Ud, this;
                    }
                    multiplyScalar(le1) {
                        const vt = this.elements;
                        return vt[0] *= le1, vt[3] *= le1, vt[6] *= le1, vt[1] *= le1, vt[4] *= le1, vt[7] *= le1, vt[2] *= le1, vt[5] *= le1, vt[8] *= le1, this;
                    }
                    determinant() {
                        const le1 = this.elements, vt = le1[0], bt = le1[1], ls = le1[2], ho = le1[3], Dl = le1[4], Fl = le1[5], sc = le1[6], uc = le1[7], mc = le1[8];
                        return vt * Dl * mc - vt * Fl * uc - bt * ho * mc + bt * Fl * sc + ls * ho * uc - ls * Dl * sc;
                    }
                    invert() {
                        const le1 = this.elements, vt = le1[0], bt = le1[1], ls = le1[2], ho = le1[3], Dl = le1[4], Fl = le1[5], sc = le1[6], uc = le1[7], mc = le1[8], gc = mc * Dl - Fl * uc, Ac = Fl * sc - mc * ho, Ec = uc * ho - Dl * sc, kc = vt * gc + bt * Ac + ls * Ec;
                        if (0 === kc) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
                        const du = 1 / kc;
                        return le1[0] = gc * du, le1[1] = (ls * uc - mc * bt) * du, le1[2] = (Fl * bt - ls * Dl) * du, le1[3] = Ac * du, le1[4] = (mc * vt - ls * sc) * du, le1[5] = (ls * ho - Fl * vt) * du, le1[6] = Ec * du, le1[7] = (bt * sc - uc * vt) * du, le1[8] = (Dl * vt - bt * ho) * du, this;
                    }
                    transpose() {
                        let le1;
                        const vt = this.elements;
                        return le1 = vt[1], vt[1] = vt[3], vt[3] = le1, le1 = vt[2], vt[2] = vt[6], vt[6] = le1, le1 = vt[5], vt[5] = vt[7], vt[7] = le1, this;
                    }
                    getNormalMatrix(le1) {
                        return this.setFromMatrix4(le1).invert().transpose();
                    }
                    transposeIntoArray(le1) {
                        const vt = this.elements;
                        return le1[0] = vt[0], le1[1] = vt[3], le1[2] = vt[6], le1[3] = vt[1], le1[4] = vt[4], le1[5] = vt[7], le1[6] = vt[2], le1[7] = vt[5], le1[8] = vt[8], this;
                    }
                    setUvTransform(le1, vt, bt, ls, ho, Dl, Fl) {
                        const sc = Math.cos(ho), uc = Math.sin(ho);
                        return this.set(bt * sc, bt * uc, -bt * (sc * Dl + uc * Fl) + Dl + le1, -ls * uc, ls * sc, -ls * (-uc * Dl + sc * Fl) + Fl + vt, 0, 0, 1), this;
                    }
                    scale(le1, vt) {
                        return this.premultiply(AA.makeScale(le1, vt)), this;
                    }
                    rotate(le1) {
                        return this.premultiply(AA.makeRotation(-le1)), this;
                    }
                    translate(le1, vt) {
                        return this.premultiply(AA.makeTranslation(le1, vt)), this;
                    }
                    makeTranslation(le1, vt) {
                        return le1.isVector2 ? this.set(1, 0, le1.x, 0, 1, le1.y, 0, 0, 1) : this.set(1, 0, le1, 0, 1, vt, 0, 0, 1), this;
                    }
                    makeRotation(le1) {
                        const vt = Math.cos(le1), bt = Math.sin(le1);
                        return this.set(vt, -bt, 0, bt, vt, 0, 0, 0, 1), this;
                    }
                    makeScale(le1, vt) {
                        return this.set(le1, 0, 0, 0, vt, 0, 0, 0, 1), this;
                    }
                    equals(le1) {
                        const vt = this.elements, bt = le1.elements;
                        for(let ls = 0; ls < 9; ls++)if (vt[ls] !== bt[ls]) return !1;
                        return !0;
                    }
                    fromArray(le1, vt) {
                        void 0 === vt && (vt = 0);
                        for(let bt = 0; bt < 9; bt++)this.elements[bt] = le1[bt + vt];
                        return this;
                    }
                    toArray(le1, vt) {
                        void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0);
                        const bt = this.elements;
                        return le1[vt] = bt[0], le1[vt + 1] = bt[1], le1[vt + 2] = bt[2], le1[vt + 3] = bt[3], le1[vt + 4] = bt[4], le1[vt + 5] = bt[5], le1[vt + 6] = bt[6], le1[vt + 7] = bt[7], le1[vt + 8] = bt[8], le1;
                    }
                    clone() {
                        return (new this.constructor).fromArray(this.elements);
                    }
                }
                const AA = new Matrix3;
                function arrayNeedsUint32(le1) {
                    for(let vt = le1.length - 1; vt >= 0; --vt)if (le1[vt] >= 65535) return !0;
                    return !1;
                }
                Int8Array, Uint8Array, Uint8ClampedArray, Int16Array, Uint16Array, Int32Array, Uint32Array, Float32Array, Float64Array;
                function createElementNS(le1) {
                    return document.createElementNS("http://www.w3.org/1999/xhtml", le1);
                }
                function createCanvasElement() {
                    const le1 = createElementNS("canvas");
                    return le1.style.display = "block", le1;
                }
                const _A = {};
                function warnOnce(le1) {
                    le1 in _A || (_A[le1] = !0, console.warn(le1));
                }
                function probeAsync(le1, vt, bt) {
                    return new Promise(function(ls, ho) {
                        setTimeout(function probe() {
                            switch(le1.clientWaitSync(vt, le1.SYNC_FLUSH_COMMANDS_BIT, 0)){
                                case le1.WAIT_FAILED:
                                    ho();
                                    break;
                                case le1.TIMEOUT_EXPIRED:
                                    setTimeout(probe, bt);
                                    break;
                                default:
                                    ls();
                            }
                        }, bt);
                    });
                }
                const yA = (new Matrix3).set(.4123908, .3575843, .1804808, .212639, .7151687, .0721923, .0193308, .1191948, .9505322), vA = (new Matrix3).set(3.2409699, -1.5373832, -0.4986108, -0.9692436, 1.8759675, .0415551, .0556301, -0.203977, 1.0569715);
                function createColorManagement() {
                    const le1 = {
                        enabled: !0,
                        workingColorSpace: Yg,
                        spaces: {},
                        convert: function(le1, vt, bt) {
                            return !1 !== this.enabled && vt !== bt && vt && bt ? (this.spaces[vt].transfer === Xg && (le1.r = SRGBToLinear(le1.r), le1.g = SRGBToLinear(le1.g), le1.b = SRGBToLinear(le1.b)), this.spaces[vt].primaries !== this.spaces[bt].primaries && (le1.applyMatrix3(this.spaces[vt].toXYZ), le1.applyMatrix3(this.spaces[bt].fromXYZ)), this.spaces[bt].transfer === Xg && (le1.r = LinearToSRGB(le1.r), le1.g = LinearToSRGB(le1.g), le1.b = LinearToSRGB(le1.b)), le1) : le1;
                        },
                        workingToColorSpace: function(le1, vt) {
                            return this.convert(le1, this.workingColorSpace, vt);
                        },
                        colorSpaceToWorking: function(le1, vt) {
                            return this.convert(le1, vt, this.workingColorSpace);
                        },
                        getPrimaries: function(le1) {
                            return this.spaces[le1].primaries;
                        },
                        getTransfer: function(le1) {
                            return le1 === Wg ? Qg : this.spaces[le1].transfer;
                        },
                        getLuminanceCoefficients: function(le1, vt) {
                            return void 0 === vt && (vt = this.workingColorSpace), le1.fromArray(this.spaces[vt].luminanceCoefficients);
                        },
                        define: function(le1) {
                            Object.assign(this.spaces, le1);
                        },
                        _getMatrix: function(le1, vt, bt) {
                            return le1.copy(this.spaces[vt].toXYZ).multiply(this.spaces[bt].fromXYZ);
                        },
                        _getDrawingBufferColorSpace: function(le1) {
                            return this.spaces[le1].outputColorSpaceConfig.drawingBufferColorSpace;
                        },
                        _getUnpackColorSpace: function(le1) {
                            return void 0 === le1 && (le1 = this.workingColorSpace), this.spaces[le1].workingColorSpaceConfig.unpackColorSpace;
                        },
                        fromWorkingColorSpace: function(vt, bt) {
                            return warnOnce("THREE.ColorManagement: .fromWorkingColorSpace() has been renamed to .workingToColorSpace()."), le1.workingToColorSpace(vt, bt);
                        },
                        toWorkingColorSpace: function(vt, bt) {
                            return warnOnce("THREE.ColorManagement: .toWorkingColorSpace() has been renamed to .colorSpaceToWorking()."), le1.colorSpaceToWorking(vt, bt);
                        }
                    }, vt = [
                        .64,
                        .33,
                        .3,
                        .6,
                        .15,
                        .06
                    ], bt = [
                        .2126,
                        .7152,
                        .0722
                    ], ls = [
                        .3127,
                        .329
                    ];
                    return le1.define({
                        [Yg]: {
                            primaries: vt,
                            whitePoint: ls,
                            transfer: Qg,
                            toXYZ: yA,
                            fromXYZ: vA,
                            luminanceCoefficients: bt,
                            workingColorSpaceConfig: {
                                unpackColorSpace: Zg
                            },
                            outputColorSpaceConfig: {
                                drawingBufferColorSpace: Zg
                            }
                        },
                        [Zg]: {
                            primaries: vt,
                            whitePoint: ls,
                            transfer: Xg,
                            toXYZ: yA,
                            fromXYZ: vA,
                            luminanceCoefficients: bt,
                            outputColorSpaceConfig: {
                                drawingBufferColorSpace: Zg
                            }
                        }
                    }), le1;
                }
                const xA = createColorManagement();
                function SRGBToLinear(le1) {
                    return le1 < .04045 ? .0773993808 * le1 : Math.pow(.9478672986 * le1 + .0521327014, 2.4);
                }
                function LinearToSRGB(le1) {
                    return le1 < .0031308 ? 12.92 * le1 : 1.055 * Math.pow(le1, .41666) - .055;
                }
                let bA;
                class ImageUtils {
                    static getDataURL(le1, vt) {
                        if (void 0 === vt && (vt = "image/png"), /^data:/i.test(le1.src)) return le1.src;
                        if ("undefined" === typeof HTMLCanvasElement) return le1.src;
                        let bt;
                        if (le1 instanceof HTMLCanvasElement) bt = le1;
                        else {
                            void 0 === bA && (bA = createElementNS("canvas")), bA.width = le1.width, bA.height = le1.height;
                            const vt = bA.getContext("2d");
                            le1 instanceof ImageData ? vt.putImageData(le1, 0, 0) : vt.drawImage(le1, 0, 0, le1.width, le1.height), bt = bA;
                        }
                        return bt.toDataURL(vt);
                    }
                    static sRGBToLinear(le1) {
                        if ("undefined" !== typeof HTMLImageElement && le1 instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && le1 instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && le1 instanceof ImageBitmap) {
                            const vt = createElementNS("canvas");
                            vt.width = le1.width, vt.height = le1.height;
                            const bt = vt.getContext("2d");
                            bt.drawImage(le1, 0, 0, le1.width, le1.height);
                            const ls = bt.getImageData(0, 0, le1.width, le1.height), ho = ls.data;
                            for(let le1 = 0; le1 < ho.length; le1++)ho[le1] = 255 * SRGBToLinear(ho[le1] / 255);
                            return bt.putImageData(ls, 0, 0), vt;
                        }
                        if (le1.data) {
                            const vt = le1.data.slice(0);
                            for(let le1 = 0; le1 < vt.length; le1++)vt instanceof Uint8Array || vt instanceof Uint8ClampedArray ? vt[le1] = Math.floor(255 * SRGBToLinear(vt[le1] / 255)) : vt[le1] = SRGBToLinear(vt[le1]);
                            return {
                                data: vt,
                                width: le1.width,
                                height: le1.height
                            };
                        }
                        return console.warn("THREE.ImageUtils.sRGBToLinear(): Unsupported image type. No color space conversion applied."), le1;
                    }
                }
                let wA = 0;
                class Source {
                    constructor(le1){
                        void 0 === le1 && (le1 = null), this.isSource = !0, Object.defineProperty(this, "id", {
                            value: wA++
                        }), this.uuid = generateUUID(), this.data = le1, this.dataReady = !0, this.version = 0;
                    }
                    getSize(le1) {
                        const vt = this.data;
                        return vt instanceof HTMLVideoElement ? le1.set(vt.videoWidth, vt.videoHeight, 0) : vt instanceof VideoFrame ? le1.set(vt.displayHeight, vt.displayWidth, 0) : null !== vt ? le1.set(vt.width, vt.height, vt.depth || 0) : le1.set(0, 0, 0), le1;
                    }
                    set needsUpdate(le1) {
                        !0 === le1 && this.version++;
                    }
                    toJSON(le1) {
                        const vt = void 0 === le1 || "string" === typeof le1;
                        if (!vt && void 0 !== le1.images[this.uuid]) return le1.images[this.uuid];
                        const bt = {
                            uuid: this.uuid,
                            url: ""
                        }, ls = this.data;
                        if (null !== ls) {
                            let le1;
                            if (Array.isArray(ls)) {
                                le1 = [];
                                for(let vt = 0, bt = ls.length; vt < bt; vt++)ls[vt].isDataTexture ? le1.push(serializeImage(ls[vt].image)) : le1.push(serializeImage(ls[vt]));
                            } else le1 = serializeImage(ls);
                            bt.url = le1;
                        }
                        return vt || (le1.images[this.uuid] = bt), bt;
                    }
                }
                function serializeImage(le1) {
                    return "undefined" !== typeof HTMLImageElement && le1 instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && le1 instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && le1 instanceof ImageBitmap ? ImageUtils.getDataURL(le1) : le1.data ? {
                        data: Array.from(le1.data),
                        width: le1.width,
                        height: le1.height,
                        type: le1.data.constructor.name
                    } : (console.warn("THREE.Texture: Unable to serialize Texture."), {});
                }
                let EA = 0;
                const MA = new Vector3;
                class Texture extends EventDispatcher {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc){
                        void 0 === le1 && (le1 = Texture.DEFAULT_IMAGE), void 0 === vt && (vt = Texture.DEFAULT_MAPPING), void 0 === bt && (bt = Cm), void 0 === ls && (ls = Cm), void 0 === ho && (ho = zm), void 0 === Dl && (Dl = Rm), void 0 === Fl && (Fl = Km), void 0 === sc && (sc = Fm), void 0 === uc && (uc = Texture.DEFAULT_ANISOTROPY), void 0 === mc && (mc = Wg), super(), this.isTexture = !0, Object.defineProperty(this, "id", {
                            value: EA++
                        }), this.uuid = generateUUID(), this.name = "", this.source = new Source(le1), this.mipmaps = [], this.mapping = vt, this.channel = 0, this.wrapS = bt, this.wrapT = ls, this.magFilter = ho, this.minFilter = Dl, this.anisotropy = uc, this.format = Fl, this.internalFormat = null, this.type = sc, this.offset = new Vector2(0, 0), this.repeat = new Vector2(1, 1), this.center = new Vector2(0, 0), this.rotation = 0, this.matrixAutoUpdate = !0, this.matrix = new Matrix3, this.generateMipmaps = !0, this.premultiplyAlpha = !1, this.flipY = !0, this.unpackAlignment = 4, this.colorSpace = mc, this.userData = {}, this.updateRanges = [], this.version = 0, this.onUpdate = null, this.renderTarget = null, this.isRenderTargetTexture = !1, this.isArrayTexture = !!(le1 && le1.depth && le1.depth > 1), this.pmremVersion = 0;
                    }
                    get width() {
                        return this.source.getSize(MA).x;
                    }
                    get height() {
                        return this.source.getSize(MA).y;
                    }
                    get depth() {
                        return this.source.getSize(MA).z;
                    }
                    get image() {
                        return this.source.data;
                    }
                    set image(le1) {
                        void 0 === le1 && (le1 = null), this.source.data = le1;
                    }
                    updateMatrix() {
                        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
                    }
                    addUpdateRange(le1, vt) {
                        this.updateRanges.push({
                            start: le1,
                            count: vt
                        });
                    }
                    clearUpdateRanges() {
                        this.updateRanges.length = 0;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        return this.name = le1.name, this.source = le1.source, this.mipmaps = le1.mipmaps.slice(0), this.mapping = le1.mapping, this.channel = le1.channel, this.wrapS = le1.wrapS, this.wrapT = le1.wrapT, this.magFilter = le1.magFilter, this.minFilter = le1.minFilter, this.anisotropy = le1.anisotropy, this.format = le1.format, this.internalFormat = le1.internalFormat, this.type = le1.type, this.offset.copy(le1.offset), this.repeat.copy(le1.repeat), this.center.copy(le1.center), this.rotation = le1.rotation, this.matrixAutoUpdate = le1.matrixAutoUpdate, this.matrix.copy(le1.matrix), this.generateMipmaps = le1.generateMipmaps, this.premultiplyAlpha = le1.premultiplyAlpha, this.flipY = le1.flipY, this.unpackAlignment = le1.unpackAlignment, this.colorSpace = le1.colorSpace, this.renderTarget = le1.renderTarget, this.isRenderTargetTexture = le1.isRenderTargetTexture, this.isArrayTexture = le1.isArrayTexture, this.userData = JSON.parse(JSON.stringify(le1.userData)), this.needsUpdate = !0, this;
                    }
                    setValues(le1) {
                        for(const vt in le1){
                            const bt = le1[vt];
                            if (void 0 === bt) {
                                console.warn(`THREE.Texture.setValues(): parameter '${vt}' has value of undefined.`);
                                continue;
                            }
                            const ls = this[vt];
                            void 0 !== ls ? ls && bt && ls.isVector2 && bt.isVector2 || ls && bt && ls.isVector3 && bt.isVector3 || ls && bt && ls.isMatrix3 && bt.isMatrix3 ? ls.copy(bt) : this[vt] = bt : console.warn(`THREE.Texture.setValues(): property '${vt}' does not exist.`);
                        }
                    }
                    toJSON(le1) {
                        const vt = void 0 === le1 || "string" === typeof le1;
                        if (!vt && void 0 !== le1.textures[this.uuid]) return le1.textures[this.uuid];
                        const bt = {
                            metadata: {
                                version: 4.7,
                                type: "Texture",
                                generator: "Texture.toJSON"
                            },
                            uuid: this.uuid,
                            name: this.name,
                            image: this.source.toJSON(le1).uuid,
                            mapping: this.mapping,
                            channel: this.channel,
                            repeat: [
                                this.repeat.x,
                                this.repeat.y
                            ],
                            offset: [
                                this.offset.x,
                                this.offset.y
                            ],
                            center: [
                                this.center.x,
                                this.center.y
                            ],
                            rotation: this.rotation,
                            wrap: [
                                this.wrapS,
                                this.wrapT
                            ],
                            format: this.format,
                            internalFormat: this.internalFormat,
                            type: this.type,
                            colorSpace: this.colorSpace,
                            minFilter: this.minFilter,
                            magFilter: this.magFilter,
                            anisotropy: this.anisotropy,
                            flipY: this.flipY,
                            generateMipmaps: this.generateMipmaps,
                            premultiplyAlpha: this.premultiplyAlpha,
                            unpackAlignment: this.unpackAlignment
                        };
                        return Object.keys(this.userData).length > 0 && (bt.userData = this.userData), vt || (le1.textures[this.uuid] = bt), bt;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                    transformUv(le1) {
                        if (300 !== this.mapping) return le1;
                        if (le1.applyMatrix3(this.matrix), le1.x < 0 || le1.x > 1) switch(this.wrapS){
                            case km:
                                le1.x = le1.x - Math.floor(le1.x);
                                break;
                            case Cm:
                                le1.x = le1.x < 0 ? 0 : 1;
                                break;
                            case Im:
                                1 === Math.abs(Math.floor(le1.x) % 2) ? le1.x = Math.ceil(le1.x) - le1.x : le1.x = le1.x - Math.floor(le1.x);
                        }
                        if (le1.y < 0 || le1.y > 1) switch(this.wrapT){
                            case km:
                                le1.y = le1.y - Math.floor(le1.y);
                                break;
                            case Cm:
                                le1.y = le1.y < 0 ? 0 : 1;
                                break;
                            case Im:
                                1 === Math.abs(Math.floor(le1.y) % 2) ? le1.y = Math.ceil(le1.y) - le1.y : le1.y = le1.y - Math.floor(le1.y);
                        }
                        return this.flipY && (le1.y = 1 - le1.y), le1;
                    }
                    set needsUpdate(le1) {
                        !0 === le1 && (this.version++, this.source.needsUpdate = !0);
                    }
                    set needsPMREMUpdate(le1) {
                        !0 === le1 && this.pmremVersion++;
                    }
                }
                Texture.DEFAULT_IMAGE = null, Texture.DEFAULT_MAPPING = 300, Texture.DEFAULT_ANISOTROPY = 1;
                class Vector4 {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = 0), void 0 === vt && (vt = 0), void 0 === bt && (bt = 0), void 0 === ls && (ls = 1), Vector4.prototype.isVector4 = !0, this.x = le1, this.y = vt, this.z = bt, this.w = ls;
                    }
                    get width() {
                        return this.z;
                    }
                    set width(le1) {
                        this.z = le1;
                    }
                    get height() {
                        return this.w;
                    }
                    set height(le1) {
                        this.w = le1;
                    }
                    set(le1, vt, bt, ls) {
                        return this.x = le1, this.y = vt, this.z = bt, this.w = ls, this;
                    }
                    setScalar(le1) {
                        return this.x = le1, this.y = le1, this.z = le1, this.w = le1, this;
                    }
                    setX(le1) {
                        return this.x = le1, this;
                    }
                    setY(le1) {
                        return this.y = le1, this;
                    }
                    setZ(le1) {
                        return this.z = le1, this;
                    }
                    setW(le1) {
                        return this.w = le1, this;
                    }
                    setComponent(le1, vt) {
                        switch(le1){
                            case 0:
                                this.x = vt;
                                break;
                            case 1:
                                this.y = vt;
                                break;
                            case 2:
                                this.z = vt;
                                break;
                            case 3:
                                this.w = vt;
                                break;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                        return this;
                    }
                    getComponent(le1) {
                        switch(le1){
                            case 0:
                                return this.x;
                            case 1:
                                return this.y;
                            case 2:
                                return this.z;
                            case 3:
                                return this.w;
                            default:
                                throw new Error("index is out of range: " + le1);
                        }
                    }
                    clone() {
                        return new this.constructor(this.x, this.y, this.z, this.w);
                    }
                    copy(le1) {
                        return this.x = le1.x, this.y = le1.y, this.z = le1.z, this.w = void 0 !== le1.w ? le1.w : 1, this;
                    }
                    add(le1) {
                        return this.x += le1.x, this.y += le1.y, this.z += le1.z, this.w += le1.w, this;
                    }
                    addScalar(le1) {
                        return this.x += le1, this.y += le1, this.z += le1, this.w += le1, this;
                    }
                    addVectors(le1, vt) {
                        return this.x = le1.x + vt.x, this.y = le1.y + vt.y, this.z = le1.z + vt.z, this.w = le1.w + vt.w, this;
                    }
                    addScaledVector(le1, vt) {
                        return this.x += le1.x * vt, this.y += le1.y * vt, this.z += le1.z * vt, this.w += le1.w * vt, this;
                    }
                    sub(le1) {
                        return this.x -= le1.x, this.y -= le1.y, this.z -= le1.z, this.w -= le1.w, this;
                    }
                    subScalar(le1) {
                        return this.x -= le1, this.y -= le1, this.z -= le1, this.w -= le1, this;
                    }
                    subVectors(le1, vt) {
                        return this.x = le1.x - vt.x, this.y = le1.y - vt.y, this.z = le1.z - vt.z, this.w = le1.w - vt.w, this;
                    }
                    multiply(le1) {
                        return this.x *= le1.x, this.y *= le1.y, this.z *= le1.z, this.w *= le1.w, this;
                    }
                    multiplyScalar(le1) {
                        return this.x *= le1, this.y *= le1, this.z *= le1, this.w *= le1, this;
                    }
                    applyMatrix4(le1) {
                        const vt = this.x, bt = this.y, ls = this.z, ho = this.w, Dl = le1.elements;
                        return this.x = Dl[0] * vt + Dl[4] * bt + Dl[8] * ls + Dl[12] * ho, this.y = Dl[1] * vt + Dl[5] * bt + Dl[9] * ls + Dl[13] * ho, this.z = Dl[2] * vt + Dl[6] * bt + Dl[10] * ls + Dl[14] * ho, this.w = Dl[3] * vt + Dl[7] * bt + Dl[11] * ls + Dl[15] * ho, this;
                    }
                    divide(le1) {
                        return this.x /= le1.x, this.y /= le1.y, this.z /= le1.z, this.w /= le1.w, this;
                    }
                    divideScalar(le1) {
                        return this.multiplyScalar(1 / le1);
                    }
                    setAxisAngleFromQuaternion(le1) {
                        this.w = 2 * Math.acos(le1.w);
                        const vt = Math.sqrt(1 - le1.w * le1.w);
                        return vt < 1e-4 ? (this.x = 1, this.y = 0, this.z = 0) : (this.x = le1.x / vt, this.y = le1.y / vt, this.z = le1.z / vt), this;
                    }
                    setAxisAngleFromRotationMatrix(le1) {
                        let vt, bt, ls, ho;
                        const Dl = .01, Fl = .1, sc = le1.elements, uc = sc[0], mc = sc[4], gc = sc[8], Ac = sc[1], Ec = sc[5], kc = sc[9], du = sc[2], _u = sc[6], Md = sc[10];
                        if (Math.abs(mc - Ac) < Dl && Math.abs(gc - du) < Dl && Math.abs(kc - _u) < Dl) {
                            if (Math.abs(mc + Ac) < Fl && Math.abs(gc + du) < Fl && Math.abs(kc + _u) < Fl && Math.abs(uc + Ec + Md - 3) < Fl) return this.set(1, 0, 0, 0), this;
                            vt = Math.PI;
                            const le1 = (uc + 1) / 2, sc = (Ec + 1) / 2, Ld = (Md + 1) / 2, Nd = (mc + Ac) / 4, Rd = (gc + du) / 4, Od = (kc + _u) / 4;
                            return le1 > sc && le1 > Ld ? le1 < Dl ? (bt = 0, ls = .707106781, ho = .707106781) : (bt = Math.sqrt(le1), ls = Nd / bt, ho = Rd / bt) : sc > Ld ? sc < Dl ? (bt = .707106781, ls = 0, ho = .707106781) : (ls = Math.sqrt(sc), bt = Nd / ls, ho = Od / ls) : Ld < Dl ? (bt = .707106781, ls = .707106781, ho = 0) : (ho = Math.sqrt(Ld), bt = Rd / ho, ls = Od / ho), this.set(bt, ls, ho, vt), this;
                        }
                        let Ld = Math.sqrt((_u - kc) * (_u - kc) + (gc - du) * (gc - du) + (Ac - mc) * (Ac - mc));
                        return Math.abs(Ld) < .001 && (Ld = 1), this.x = (_u - kc) / Ld, this.y = (gc - du) / Ld, this.z = (Ac - mc) / Ld, this.w = Math.acos((uc + Ec + Md - 1) / 2), this;
                    }
                    setFromMatrixPosition(le1) {
                        const vt = le1.elements;
                        return this.x = vt[12], this.y = vt[13], this.z = vt[14], this.w = vt[15], this;
                    }
                    min(le1) {
                        return this.x = Math.min(this.x, le1.x), this.y = Math.min(this.y, le1.y), this.z = Math.min(this.z, le1.z), this.w = Math.min(this.w, le1.w), this;
                    }
                    max(le1) {
                        return this.x = Math.max(this.x, le1.x), this.y = Math.max(this.y, le1.y), this.z = Math.max(this.z, le1.z), this.w = Math.max(this.w, le1.w), this;
                    }
                    clamp(le1, vt) {
                        return this.x = clamp(this.x, le1.x, vt.x), this.y = clamp(this.y, le1.y, vt.y), this.z = clamp(this.z, le1.z, vt.z), this.w = clamp(this.w, le1.w, vt.w), this;
                    }
                    clampScalar(le1, vt) {
                        return this.x = clamp(this.x, le1, vt), this.y = clamp(this.y, le1, vt), this.z = clamp(this.z, le1, vt), this.w = clamp(this.w, le1, vt), this;
                    }
                    clampLength(le1, vt) {
                        const bt = this.length();
                        return this.divideScalar(bt || 1).multiplyScalar(clamp(bt, le1, vt));
                    }
                    floor() {
                        return this.x = Math.floor(this.x), this.y = Math.floor(this.y), this.z = Math.floor(this.z), this.w = Math.floor(this.w), this;
                    }
                    ceil() {
                        return this.x = Math.ceil(this.x), this.y = Math.ceil(this.y), this.z = Math.ceil(this.z), this.w = Math.ceil(this.w), this;
                    }
                    round() {
                        return this.x = Math.round(this.x), this.y = Math.round(this.y), this.z = Math.round(this.z), this.w = Math.round(this.w), this;
                    }
                    roundToZero() {
                        return this.x = Math.trunc(this.x), this.y = Math.trunc(this.y), this.z = Math.trunc(this.z), this.w = Math.trunc(this.w), this;
                    }
                    negate() {
                        return this.x = -this.x, this.y = -this.y, this.z = -this.z, this.w = -this.w, this;
                    }
                    dot(le1) {
                        return this.x * le1.x + this.y * le1.y + this.z * le1.z + this.w * le1.w;
                    }
                    lengthSq() {
                        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
                    }
                    length() {
                        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
                    }
                    manhattanLength() {
                        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
                    }
                    normalize() {
                        return this.divideScalar(this.length() || 1);
                    }
                    setLength(le1) {
                        return this.normalize().multiplyScalar(le1);
                    }
                    lerp(le1, vt) {
                        return this.x += (le1.x - this.x) * vt, this.y += (le1.y - this.y) * vt, this.z += (le1.z - this.z) * vt, this.w += (le1.w - this.w) * vt, this;
                    }
                    lerpVectors(le1, vt, bt) {
                        return this.x = le1.x + (vt.x - le1.x) * bt, this.y = le1.y + (vt.y - le1.y) * bt, this.z = le1.z + (vt.z - le1.z) * bt, this.w = le1.w + (vt.w - le1.w) * bt, this;
                    }
                    equals(le1) {
                        return le1.x === this.x && le1.y === this.y && le1.z === this.z && le1.w === this.w;
                    }
                    fromArray(le1, vt) {
                        return void 0 === vt && (vt = 0), this.x = le1[vt], this.y = le1[vt + 1], this.z = le1[vt + 2], this.w = le1[vt + 3], this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this.x, le1[vt + 1] = this.y, le1[vt + 2] = this.z, le1[vt + 3] = this.w, le1;
                    }
                    fromBufferAttribute(le1, vt) {
                        return this.x = le1.getX(vt), this.y = le1.getY(vt), this.z = le1.getZ(vt), this.w = le1.getW(vt), this;
                    }
                    random() {
                        return this.x = Math.random(), this.y = Math.random(), this.z = Math.random(), this.w = Math.random(), this;
                    }
                    *[Symbol.iterator]() {
                        yield this.x, yield this.y, yield this.z, yield this.w;
                    }
                }
                class RenderTarget extends EventDispatcher {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = 1), void 0 === bt && (bt = {}), super(), bt = Object.assign({
                            generateMipmaps: !1,
                            internalFormat: null,
                            minFilter: zm,
                            depthBuffer: !0,
                            stencilBuffer: !1,
                            resolveDepthBuffer: !0,
                            resolveStencilBuffer: !0,
                            depthTexture: null,
                            samples: 0,
                            count: 1,
                            depth: 1,
                            multiview: !1
                        }, bt), this.isRenderTarget = !0, this.width = le1, this.height = vt, this.depth = bt.depth, this.scissor = new Vector4(0, 0, le1, vt), this.scissorTest = !1, this.viewport = new Vector4(0, 0, le1, vt);
                        const ls = {
                            width: le1,
                            height: vt,
                            depth: bt.depth
                        }, ho = new Texture(ls);
                        this.textures = [];
                        const Dl = bt.count;
                        for(let Fl = 0; Fl < Dl; Fl++)this.textures[Fl] = ho.clone(), this.textures[Fl].isRenderTargetTexture = !0, this.textures[Fl].renderTarget = this;
                        this._setTextureOptions(bt), this.depthBuffer = bt.depthBuffer, this.stencilBuffer = bt.stencilBuffer, this.resolveDepthBuffer = bt.resolveDepthBuffer, this.resolveStencilBuffer = bt.resolveStencilBuffer, this._depthTexture = null, this.depthTexture = bt.depthTexture, this.samples = bt.samples, this.multiview = bt.multiview;
                    }
                    _setTextureOptions(le1) {
                        void 0 === le1 && (le1 = {});
                        const vt = {
                            minFilter: zm,
                            generateMipmaps: !1,
                            flipY: !1,
                            internalFormat: null
                        };
                        void 0 !== le1.mapping && (vt.mapping = le1.mapping), void 0 !== le1.wrapS && (vt.wrapS = le1.wrapS), void 0 !== le1.wrapT && (vt.wrapT = le1.wrapT), void 0 !== le1.wrapR && (vt.wrapR = le1.wrapR), void 0 !== le1.magFilter && (vt.magFilter = le1.magFilter), void 0 !== le1.minFilter && (vt.minFilter = le1.minFilter), void 0 !== le1.format && (vt.format = le1.format), void 0 !== le1.type && (vt.type = le1.type), void 0 !== le1.anisotropy && (vt.anisotropy = le1.anisotropy), void 0 !== le1.colorSpace && (vt.colorSpace = le1.colorSpace), void 0 !== le1.flipY && (vt.flipY = le1.flipY), void 0 !== le1.generateMipmaps && (vt.generateMipmaps = le1.generateMipmaps), void 0 !== le1.internalFormat && (vt.internalFormat = le1.internalFormat);
                        for(let bt = 0; bt < this.textures.length; bt++)this.textures[bt].setValues(vt);
                    }
                    get texture() {
                        return this.textures[0];
                    }
                    set texture(le1) {
                        this.textures[0] = le1;
                    }
                    set depthTexture(le1) {
                        null !== this._depthTexture && (this._depthTexture.renderTarget = null), null !== le1 && (le1.renderTarget = this), this._depthTexture = le1;
                    }
                    get depthTexture() {
                        return this._depthTexture;
                    }
                    setSize(le1, vt, bt) {
                        if (void 0 === bt && (bt = 1), this.width !== le1 || this.height !== vt || this.depth !== bt) {
                            this.width = le1, this.height = vt, this.depth = bt;
                            for(let ls = 0, ho = this.textures.length; ls < ho; ls++)this.textures[ls].image.width = le1, this.textures[ls].image.height = vt, this.textures[ls].image.depth = bt, this.textures[ls].isArrayTexture = this.textures[ls].image.depth > 1;
                            this.dispose();
                        }
                        this.viewport.set(0, 0, le1, vt), this.scissor.set(0, 0, le1, vt);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        this.width = le1.width, this.height = le1.height, this.depth = le1.depth, this.scissor.copy(le1.scissor), this.scissorTest = le1.scissorTest, this.viewport.copy(le1.viewport), this.textures.length = 0;
                        for(let vt = 0, bt = le1.textures.length; vt < bt; vt++){
                            this.textures[vt] = le1.textures[vt].clone(), this.textures[vt].isRenderTargetTexture = !0, this.textures[vt].renderTarget = this;
                            const bt = Object.assign({}, le1.textures[vt].image);
                            this.textures[vt].source = new Source(bt);
                        }
                        return this.depthBuffer = le1.depthBuffer, this.stencilBuffer = le1.stencilBuffer, this.resolveDepthBuffer = le1.resolveDepthBuffer, this.resolveStencilBuffer = le1.resolveStencilBuffer, null !== le1.depthTexture && (this.depthTexture = le1.depthTexture.clone()), this.samples = le1.samples, this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                }
                class WebGLRenderTarget extends RenderTarget {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = 1), void 0 === bt && (bt = {}), super(le1, vt, bt), this.isWebGLRenderTarget = !0;
                    }
                }
                class DataArrayTexture extends Texture {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = null), void 0 === vt && (vt = 1), void 0 === bt && (bt = 1), void 0 === ls && (ls = 1), super(null), this.isDataArrayTexture = !0, this.image = {
                            data: le1,
                            width: vt,
                            height: bt,
                            depth: ls
                        }, this.magFilter = Dm, this.minFilter = Dm, this.wrapR = Cm, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1, this.layerUpdates = new Set;
                    }
                    addLayerUpdate(le1) {
                        this.layerUpdates.add(le1);
                    }
                    clearLayerUpdates() {
                        this.layerUpdates.clear();
                    }
                }
                class Data3DTexture extends Texture {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = null), void 0 === vt && (vt = 1), void 0 === bt && (bt = 1), void 0 === ls && (ls = 1), super(null), this.isData3DTexture = !0, this.image = {
                            data: le1,
                            width: vt,
                            height: bt,
                            depth: ls
                        }, this.magFilter = Dm, this.minFilter = Dm, this.wrapR = Cm, this.generateMipmaps = !1, this.flipY = !1, this.unpackAlignment = 1;
                    }
                }
                class Box3 {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new Vector3(1 / 0, 1 / 0, 1 / 0)), void 0 === vt && (vt = new Vector3(-1 / 0, -1 / 0, -1 / 0)), this.isBox3 = !0, this.min = le1, this.max = vt;
                    }
                    set(le1, vt) {
                        return this.min.copy(le1), this.max.copy(vt), this;
                    }
                    setFromArray(le1) {
                        this.makeEmpty();
                        for(let vt = 0, bt = le1.length; vt < bt; vt += 3)this.expandByPoint(TA.fromArray(le1, vt));
                        return this;
                    }
                    setFromBufferAttribute(le1) {
                        this.makeEmpty();
                        for(let vt = 0, bt = le1.count; vt < bt; vt++)this.expandByPoint(TA.fromBufferAttribute(le1, vt));
                        return this;
                    }
                    setFromPoints(le1) {
                        this.makeEmpty();
                        for(let vt = 0, bt = le1.length; vt < bt; vt++)this.expandByPoint(le1[vt]);
                        return this;
                    }
                    setFromCenterAndSize(le1, vt) {
                        const bt = TA.copy(vt).multiplyScalar(.5);
                        return this.min.copy(le1).sub(bt), this.max.copy(le1).add(bt), this;
                    }
                    setFromObject(le1, vt) {
                        return void 0 === vt && (vt = !1), this.makeEmpty(), this.expandByObject(le1, vt);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        return this.min.copy(le1.min), this.max.copy(le1.max), this;
                    }
                    makeEmpty() {
                        return this.min.x = this.min.y = this.min.z = 1 / 0, this.max.x = this.max.y = this.max.z = -1 / 0, this;
                    }
                    isEmpty() {
                        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
                    }
                    getCenter(le1) {
                        return this.isEmpty() ? le1.set(0, 0, 0) : le1.addVectors(this.min, this.max).multiplyScalar(.5);
                    }
                    getSize(le1) {
                        return this.isEmpty() ? le1.set(0, 0, 0) : le1.subVectors(this.max, this.min);
                    }
                    expandByPoint(le1) {
                        return this.min.min(le1), this.max.max(le1), this;
                    }
                    expandByVector(le1) {
                        return this.min.sub(le1), this.max.add(le1), this;
                    }
                    expandByScalar(le1) {
                        return this.min.addScalar(-le1), this.max.addScalar(le1), this;
                    }
                    expandByObject(le1, vt) {
                        void 0 === vt && (vt = !1), le1.updateWorldMatrix(!1, !1);
                        const bt = le1.geometry;
                        if (void 0 !== bt) {
                            const ls = bt.getAttribute("position");
                            if (!0 === vt && void 0 !== ls && !0 !== le1.isInstancedMesh) for(let vt = 0, bt = ls.count; vt < bt; vt++)!0 === le1.isMesh ? le1.getVertexPosition(vt, TA) : TA.fromBufferAttribute(ls, vt), TA.applyMatrix4(le1.matrixWorld), this.expandByPoint(TA);
                            else void 0 !== le1.boundingBox ? (null === le1.boundingBox && le1.computeBoundingBox(), kA.copy(le1.boundingBox)) : (null === bt.boundingBox && bt.computeBoundingBox(), kA.copy(bt.boundingBox)), kA.applyMatrix4(le1.matrixWorld), this.union(kA);
                        }
                        const ls = le1.children;
                        for(let ho = 0, Dl = ls.length; ho < Dl; ho++)this.expandByObject(ls[ho], vt);
                        return this;
                    }
                    containsPoint(le1) {
                        return le1.x >= this.min.x && le1.x <= this.max.x && le1.y >= this.min.y && le1.y <= this.max.y && le1.z >= this.min.z && le1.z <= this.max.z;
                    }
                    containsBox(le1) {
                        return this.min.x <= le1.min.x && le1.max.x <= this.max.x && this.min.y <= le1.min.y && le1.max.y <= this.max.y && this.min.z <= le1.min.z && le1.max.z <= this.max.z;
                    }
                    getParameter(le1, vt) {
                        return vt.set((le1.x - this.min.x) / (this.max.x - this.min.x), (le1.y - this.min.y) / (this.max.y - this.min.y), (le1.z - this.min.z) / (this.max.z - this.min.z));
                    }
                    intersectsBox(le1) {
                        return le1.max.x >= this.min.x && le1.min.x <= this.max.x && le1.max.y >= this.min.y && le1.min.y <= this.max.y && le1.max.z >= this.min.z && le1.min.z <= this.max.z;
                    }
                    intersectsSphere(le1) {
                        return this.clampPoint(le1.center, TA), TA.distanceToSquared(le1.center) <= le1.radius * le1.radius;
                    }
                    intersectsPlane(le1) {
                        let vt, bt;
                        return le1.normal.x > 0 ? (vt = le1.normal.x * this.min.x, bt = le1.normal.x * this.max.x) : (vt = le1.normal.x * this.max.x, bt = le1.normal.x * this.min.x), le1.normal.y > 0 ? (vt += le1.normal.y * this.min.y, bt += le1.normal.y * this.max.y) : (vt += le1.normal.y * this.max.y, bt += le1.normal.y * this.min.y), le1.normal.z > 0 ? (vt += le1.normal.z * this.min.z, bt += le1.normal.z * this.max.z) : (vt += le1.normal.z * this.max.z, bt += le1.normal.z * this.min.z), vt <= -le1.constant && bt >= -le1.constant;
                    }
                    intersectsTriangle(le1) {
                        if (this.isEmpty()) return !1;
                        this.getCenter(NA), RA.subVectors(this.max, NA), CA.subVectors(le1.a, NA), IA.subVectors(le1.b, NA), DA.subVectors(le1.c, NA), LA.subVectors(IA, CA), PA.subVectors(DA, IA), zA.subVectors(CA, DA);
                        let vt = [
                            0,
                            -LA.z,
                            LA.y,
                            0,
                            -PA.z,
                            PA.y,
                            0,
                            -zA.z,
                            zA.y,
                            LA.z,
                            0,
                            -LA.x,
                            PA.z,
                            0,
                            -PA.x,
                            zA.z,
                            0,
                            -zA.x,
                            -LA.y,
                            LA.x,
                            0,
                            -PA.y,
                            PA.x,
                            0,
                            -zA.y,
                            zA.x,
                            0
                        ];
                        return !!satForAxes(vt, CA, IA, DA, RA) && (vt = [
                            1,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            1
                        ], !!satForAxes(vt, CA, IA, DA, RA) && (FA.crossVectors(LA, PA), vt = [
                            FA.x,
                            FA.y,
                            FA.z
                        ], satForAxes(vt, CA, IA, DA, RA)));
                    }
                    clampPoint(le1, vt) {
                        return vt.copy(le1).clamp(this.min, this.max);
                    }
                    distanceToPoint(le1) {
                        return this.clampPoint(le1, TA).distanceTo(le1);
                    }
                    getBoundingSphere(le1) {
                        return this.isEmpty() ? le1.makeEmpty() : (this.getCenter(le1.center), le1.radius = .5 * this.getSize(TA).length()), le1;
                    }
                    intersect(le1) {
                        return this.min.max(le1.min), this.max.min(le1.max), this.isEmpty() && this.makeEmpty(), this;
                    }
                    union(le1) {
                        return this.min.min(le1.min), this.max.max(le1.max), this;
                    }
                    applyMatrix4(le1) {
                        return this.isEmpty() || (SA[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(le1), SA[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(le1), SA[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(le1), SA[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(le1), SA[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(le1), SA[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(le1), SA[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(le1), SA[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(le1), this.setFromPoints(SA)), this;
                    }
                    translate(le1) {
                        return this.min.add(le1), this.max.add(le1), this;
                    }
                    equals(le1) {
                        return le1.min.equals(this.min) && le1.max.equals(this.max);
                    }
                    toJSON() {
                        return {
                            min: this.min.toArray(),
                            max: this.max.toArray()
                        };
                    }
                    fromJSON(le1) {
                        return this.min.fromArray(le1.min), this.max.fromArray(le1.max), this;
                    }
                }
                const SA = [
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3,
                    new Vector3
                ], TA = new Vector3, kA = new Box3, CA = new Vector3, IA = new Vector3, DA = new Vector3, LA = new Vector3, PA = new Vector3, zA = new Vector3, NA = new Vector3, RA = new Vector3, FA = new Vector3, OA = new Vector3;
                function satForAxes(le1, vt, bt, ls, ho) {
                    for(let Dl = 0, Fl = le1.length - 3; Dl <= Fl; Dl += 3){
                        OA.fromArray(le1, Dl);
                        const Fl = ho.x * Math.abs(OA.x) + ho.y * Math.abs(OA.y) + ho.z * Math.abs(OA.z), sc = vt.dot(OA), uc = bt.dot(OA), mc = ls.dot(OA);
                        if (Math.max(-Math.max(sc, uc, mc), Math.min(sc, uc, mc)) > Fl) return !1;
                    }
                    return !0;
                }
                const BA = new Box3, jA = new Vector3, UA = new Vector3;
                class Sphere {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new Vector3), void 0 === vt && (vt = -1), this.isSphere = !0, this.center = le1, this.radius = vt;
                    }
                    set(le1, vt) {
                        return this.center.copy(le1), this.radius = vt, this;
                    }
                    setFromPoints(le1, vt) {
                        const bt = this.center;
                        void 0 !== vt ? bt.copy(vt) : BA.setFromPoints(le1).getCenter(bt);
                        let ls = 0;
                        for(let ho = 0, Dl = le1.length; ho < Dl; ho++)ls = Math.max(ls, bt.distanceToSquared(le1[ho]));
                        return this.radius = Math.sqrt(ls), this;
                    }
                    copy(le1) {
                        return this.center.copy(le1.center), this.radius = le1.radius, this;
                    }
                    isEmpty() {
                        return this.radius < 0;
                    }
                    makeEmpty() {
                        return this.center.set(0, 0, 0), this.radius = -1, this;
                    }
                    containsPoint(le1) {
                        return le1.distanceToSquared(this.center) <= this.radius * this.radius;
                    }
                    distanceToPoint(le1) {
                        return le1.distanceTo(this.center) - this.radius;
                    }
                    intersectsSphere(le1) {
                        const vt = this.radius + le1.radius;
                        return le1.center.distanceToSquared(this.center) <= vt * vt;
                    }
                    intersectsBox(le1) {
                        return le1.intersectsSphere(this);
                    }
                    intersectsPlane(le1) {
                        return Math.abs(le1.distanceToPoint(this.center)) <= this.radius;
                    }
                    clampPoint(le1, vt) {
                        const bt = this.center.distanceToSquared(le1);
                        return vt.copy(le1), bt > this.radius * this.radius && (vt.sub(this.center).normalize(), vt.multiplyScalar(this.radius).add(this.center)), vt;
                    }
                    getBoundingBox(le1) {
                        return this.isEmpty() ? (le1.makeEmpty(), le1) : (le1.set(this.center, this.center), le1.expandByScalar(this.radius), le1);
                    }
                    applyMatrix4(le1) {
                        return this.center.applyMatrix4(le1), this.radius = this.radius * le1.getMaxScaleOnAxis(), this;
                    }
                    translate(le1) {
                        return this.center.add(le1), this;
                    }
                    expandByPoint(le1) {
                        if (this.isEmpty()) return this.center.copy(le1), this.radius = 0, this;
                        jA.subVectors(le1, this.center);
                        const vt = jA.lengthSq();
                        if (vt > this.radius * this.radius) {
                            const le1 = Math.sqrt(vt), bt = .5 * (le1 - this.radius);
                            this.center.addScaledVector(jA, bt / le1), this.radius += bt;
                        }
                        return this;
                    }
                    union(le1) {
                        return le1.isEmpty() ? this : this.isEmpty() ? (this.copy(le1), this) : (!0 === this.center.equals(le1.center) ? this.radius = Math.max(this.radius, le1.radius) : (UA.subVectors(le1.center, this.center).setLength(le1.radius), this.expandByPoint(jA.copy(le1.center).add(UA)), this.expandByPoint(jA.copy(le1.center).sub(UA))), this);
                    }
                    equals(le1) {
                        return le1.center.equals(this.center) && le1.radius === this.radius;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    toJSON() {
                        return {
                            radius: this.radius,
                            center: this.center.toArray()
                        };
                    }
                    fromJSON(le1) {
                        return this.radius = le1.radius, this.center.fromArray(le1.center), this;
                    }
                }
                const VA = new Vector3, GA = new Vector3, qA = new Vector3, HA = new Vector3, WA = new Vector3, ZA = new Vector3, YA = new Vector3;
                class Ray {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new Vector3), void 0 === vt && (vt = new Vector3(0, 0, -1)), this.origin = le1, this.direction = vt;
                    }
                    set(le1, vt) {
                        return this.origin.copy(le1), this.direction.copy(vt), this;
                    }
                    copy(le1) {
                        return this.origin.copy(le1.origin), this.direction.copy(le1.direction), this;
                    }
                    at(le1, vt) {
                        return vt.copy(this.origin).addScaledVector(this.direction, le1);
                    }
                    lookAt(le1) {
                        return this.direction.copy(le1).sub(this.origin).normalize(), this;
                    }
                    recast(le1) {
                        return this.origin.copy(this.at(le1, VA)), this;
                    }
                    closestPointToPoint(le1, vt) {
                        vt.subVectors(le1, this.origin);
                        const bt = vt.dot(this.direction);
                        return bt < 0 ? vt.copy(this.origin) : vt.copy(this.origin).addScaledVector(this.direction, bt);
                    }
                    distanceToPoint(le1) {
                        return Math.sqrt(this.distanceSqToPoint(le1));
                    }
                    distanceSqToPoint(le1) {
                        const vt = VA.subVectors(le1, this.origin).dot(this.direction);
                        return vt < 0 ? this.origin.distanceToSquared(le1) : (VA.copy(this.origin).addScaledVector(this.direction, vt), VA.distanceToSquared(le1));
                    }
                    distanceSqToSegment(le1, vt, bt, ls) {
                        GA.copy(le1).add(vt).multiplyScalar(.5), qA.copy(vt).sub(le1).normalize(), HA.copy(this.origin).sub(GA);
                        const ho = .5 * le1.distanceTo(vt), Dl = -this.direction.dot(qA), Fl = HA.dot(this.direction), sc = -HA.dot(qA), uc = HA.lengthSq(), mc = Math.abs(1 - Dl * Dl);
                        let gc, Ac, Ec, kc;
                        if (mc > 0) {
                            if (gc = Dl * sc - Fl, Ac = Dl * Fl - sc, kc = ho * mc, gc >= 0) {
                                if (Ac >= -kc) {
                                    if (Ac <= kc) {
                                        const le1 = 1 / mc;
                                        gc *= le1, Ac *= le1, Ec = gc * (gc + Dl * Ac + 2 * Fl) + Ac * (Dl * gc + Ac + 2 * sc) + uc;
                                    } else Ac = ho, gc = Math.max(0, -(Dl * Ac + Fl)), Ec = -gc * gc + Ac * (Ac + 2 * sc) + uc;
                                } else Ac = -ho, gc = Math.max(0, -(Dl * Ac + Fl)), Ec = -gc * gc + Ac * (Ac + 2 * sc) + uc;
                            } else Ac <= -kc ? (gc = Math.max(0, -(-Dl * ho + Fl)), Ac = gc > 0 ? -ho : Math.min(Math.max(-ho, -sc), ho), Ec = -gc * gc + Ac * (Ac + 2 * sc) + uc) : Ac <= kc ? (gc = 0, Ac = Math.min(Math.max(-ho, -sc), ho), Ec = Ac * (Ac + 2 * sc) + uc) : (gc = Math.max(0, -(Dl * ho + Fl)), Ac = gc > 0 ? ho : Math.min(Math.max(-ho, -sc), ho), Ec = -gc * gc + Ac * (Ac + 2 * sc) + uc);
                        } else Ac = Dl > 0 ? -ho : ho, gc = Math.max(0, -(Dl * Ac + Fl)), Ec = -gc * gc + Ac * (Ac + 2 * sc) + uc;
                        return bt && bt.copy(this.origin).addScaledVector(this.direction, gc), ls && ls.copy(GA).addScaledVector(qA, Ac), Ec;
                    }
                    intersectSphere(le1, vt) {
                        VA.subVectors(le1.center, this.origin);
                        const bt = VA.dot(this.direction), ls = VA.dot(VA) - bt * bt, ho = le1.radius * le1.radius;
                        if (ls > ho) return null;
                        const Dl = Math.sqrt(ho - ls), Fl = bt - Dl, sc = bt + Dl;
                        return sc < 0 ? null : Fl < 0 ? this.at(sc, vt) : this.at(Fl, vt);
                    }
                    intersectsSphere(le1) {
                        return !(le1.radius < 0) && this.distanceSqToPoint(le1.center) <= le1.radius * le1.radius;
                    }
                    distanceToPlane(le1) {
                        const vt = le1.normal.dot(this.direction);
                        if (0 === vt) return 0 === le1.distanceToPoint(this.origin) ? 0 : null;
                        const bt = -(this.origin.dot(le1.normal) + le1.constant) / vt;
                        return bt >= 0 ? bt : null;
                    }
                    intersectPlane(le1, vt) {
                        const bt = this.distanceToPlane(le1);
                        return null === bt ? null : this.at(bt, vt);
                    }
                    intersectsPlane(le1) {
                        const vt = le1.distanceToPoint(this.origin);
                        if (0 === vt) return !0;
                        return le1.normal.dot(this.direction) * vt < 0;
                    }
                    intersectBox(le1, vt) {
                        let bt, ls, ho, Dl, Fl, sc;
                        const uc = 1 / this.direction.x, mc = 1 / this.direction.y, gc = 1 / this.direction.z, Ac = this.origin;
                        return uc >= 0 ? (bt = (le1.min.x - Ac.x) * uc, ls = (le1.max.x - Ac.x) * uc) : (bt = (le1.max.x - Ac.x) * uc, ls = (le1.min.x - Ac.x) * uc), mc >= 0 ? (ho = (le1.min.y - Ac.y) * mc, Dl = (le1.max.y - Ac.y) * mc) : (ho = (le1.max.y - Ac.y) * mc, Dl = (le1.min.y - Ac.y) * mc), bt > Dl || ho > ls ? null : ((ho > bt || isNaN(bt)) && (bt = ho), (Dl < ls || isNaN(ls)) && (ls = Dl), gc >= 0 ? (Fl = (le1.min.z - Ac.z) * gc, sc = (le1.max.z - Ac.z) * gc) : (Fl = (le1.max.z - Ac.z) * gc, sc = (le1.min.z - Ac.z) * gc), bt > sc || Fl > ls ? null : ((Fl > bt || bt !== bt) && (bt = Fl), (sc < ls || ls !== ls) && (ls = sc), ls < 0 ? null : this.at(bt >= 0 ? bt : ls, vt)));
                    }
                    intersectsBox(le1) {
                        return null !== this.intersectBox(le1, VA);
                    }
                    intersectTriangle(le1, vt, bt, ls, ho) {
                        WA.subVectors(vt, le1), ZA.subVectors(bt, le1), YA.crossVectors(WA, ZA);
                        let Dl, Fl = this.direction.dot(YA);
                        if (Fl > 0) {
                            if (ls) return null;
                            Dl = 1;
                        } else {
                            if (!(Fl < 0)) return null;
                            Dl = -1, Fl = -Fl;
                        }
                        HA.subVectors(this.origin, le1);
                        const sc = Dl * this.direction.dot(ZA.crossVectors(HA, ZA));
                        if (sc < 0) return null;
                        const uc = Dl * this.direction.dot(WA.cross(HA));
                        if (uc < 0) return null;
                        if (sc + uc > Fl) return null;
                        const mc = -Dl * HA.dot(YA);
                        return mc < 0 ? null : this.at(mc / Fl, ho);
                    }
                    applyMatrix4(le1) {
                        return this.origin.applyMatrix4(le1), this.direction.transformDirection(le1), this;
                    }
                    equals(le1) {
                        return le1.origin.equals(this.origin) && le1.direction.equals(this.direction);
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                class Matrix4 {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u){
                        Matrix4.prototype.isMatrix4 = !0, this.elements = [
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1,
                            0,
                            0,
                            0,
                            0,
                            1
                        ], void 0 !== le1 && this.set(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u);
                    }
                    set(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc, Ac, Ec, kc, du, _u) {
                        const Md = this.elements;
                        return Md[0] = le1, Md[4] = vt, Md[8] = bt, Md[12] = ls, Md[1] = ho, Md[5] = Dl, Md[9] = Fl, Md[13] = sc, Md[2] = uc, Md[6] = mc, Md[10] = gc, Md[14] = Ac, Md[3] = Ec, Md[7] = kc, Md[11] = du, Md[15] = _u, this;
                    }
                    identity() {
                        return this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
                    }
                    clone() {
                        return (new Matrix4).fromArray(this.elements);
                    }
                    copy(le1) {
                        const vt = this.elements, bt = le1.elements;
                        return vt[0] = bt[0], vt[1] = bt[1], vt[2] = bt[2], vt[3] = bt[3], vt[4] = bt[4], vt[5] = bt[5], vt[6] = bt[6], vt[7] = bt[7], vt[8] = bt[8], vt[9] = bt[9], vt[10] = bt[10], vt[11] = bt[11], vt[12] = bt[12], vt[13] = bt[13], vt[14] = bt[14], vt[15] = bt[15], this;
                    }
                    copyPosition(le1) {
                        const vt = this.elements, bt = le1.elements;
                        return vt[12] = bt[12], vt[13] = bt[13], vt[14] = bt[14], this;
                    }
                    setFromMatrix3(le1) {
                        const vt = le1.elements;
                        return this.set(vt[0], vt[3], vt[6], 0, vt[1], vt[4], vt[7], 0, vt[2], vt[5], vt[8], 0, 0, 0, 0, 1), this;
                    }
                    extractBasis(le1, vt, bt) {
                        return le1.setFromMatrixColumn(this, 0), vt.setFromMatrixColumn(this, 1), bt.setFromMatrixColumn(this, 2), this;
                    }
                    makeBasis(le1, vt, bt) {
                        return this.set(le1.x, vt.x, bt.x, 0, le1.y, vt.y, bt.y, 0, le1.z, vt.z, bt.z, 0, 0, 0, 0, 1), this;
                    }
                    extractRotation(le1) {
                        const vt = this.elements, bt = le1.elements, ls = 1 / QA.setFromMatrixColumn(le1, 0).length(), ho = 1 / QA.setFromMatrixColumn(le1, 1).length(), Dl = 1 / QA.setFromMatrixColumn(le1, 2).length();
                        return vt[0] = bt[0] * ls, vt[1] = bt[1] * ls, vt[2] = bt[2] * ls, vt[3] = 0, vt[4] = bt[4] * ho, vt[5] = bt[5] * ho, vt[6] = bt[6] * ho, vt[7] = 0, vt[8] = bt[8] * Dl, vt[9] = bt[9] * Dl, vt[10] = bt[10] * Dl, vt[11] = 0, vt[12] = 0, vt[13] = 0, vt[14] = 0, vt[15] = 1, this;
                    }
                    makeRotationFromEuler(le1) {
                        const vt = this.elements, bt = le1.x, ls = le1.y, ho = le1.z, Dl = Math.cos(bt), Fl = Math.sin(bt), sc = Math.cos(ls), uc = Math.sin(ls), mc = Math.cos(ho), gc = Math.sin(ho);
                        if ("XYZ" === le1.order) {
                            const le1 = Dl * mc, bt = Dl * gc, ls = Fl * mc, ho = Fl * gc;
                            vt[0] = sc * mc, vt[4] = -sc * gc, vt[8] = uc, vt[1] = bt + ls * uc, vt[5] = le1 - ho * uc, vt[9] = -Fl * sc, vt[2] = ho - le1 * uc, vt[6] = ls + bt * uc, vt[10] = Dl * sc;
                        } else if ("YXZ" === le1.order) {
                            const le1 = sc * mc, bt = sc * gc, ls = uc * mc, ho = uc * gc;
                            vt[0] = le1 + ho * Fl, vt[4] = ls * Fl - bt, vt[8] = Dl * uc, vt[1] = Dl * gc, vt[5] = Dl * mc, vt[9] = -Fl, vt[2] = bt * Fl - ls, vt[6] = ho + le1 * Fl, vt[10] = Dl * sc;
                        } else if ("ZXY" === le1.order) {
                            const le1 = sc * mc, bt = sc * gc, ls = uc * mc, ho = uc * gc;
                            vt[0] = le1 - ho * Fl, vt[4] = -Dl * gc, vt[8] = ls + bt * Fl, vt[1] = bt + ls * Fl, vt[5] = Dl * mc, vt[9] = ho - le1 * Fl, vt[2] = -Dl * uc, vt[6] = Fl, vt[10] = Dl * sc;
                        } else if ("ZYX" === le1.order) {
                            const le1 = Dl * mc, bt = Dl * gc, ls = Fl * mc, ho = Fl * gc;
                            vt[0] = sc * mc, vt[4] = ls * uc - bt, vt[8] = le1 * uc + ho, vt[1] = sc * gc, vt[5] = ho * uc + le1, vt[9] = bt * uc - ls, vt[2] = -uc, vt[6] = Fl * sc, vt[10] = Dl * sc;
                        } else if ("YZX" === le1.order) {
                            const le1 = Dl * sc, bt = Dl * uc, ls = Fl * sc, ho = Fl * uc;
                            vt[0] = sc * mc, vt[4] = ho - le1 * gc, vt[8] = ls * gc + bt, vt[1] = gc, vt[5] = Dl * mc, vt[9] = -Fl * mc, vt[2] = -uc * mc, vt[6] = bt * gc + ls, vt[10] = le1 - ho * gc;
                        } else if ("XZY" === le1.order) {
                            const le1 = Dl * sc, bt = Dl * uc, ls = Fl * sc, ho = Fl * uc;
                            vt[0] = sc * mc, vt[4] = -gc, vt[8] = uc * mc, vt[1] = le1 * gc + ho, vt[5] = Dl * mc, vt[9] = bt * gc - ls, vt[2] = ls * gc - bt, vt[6] = Fl * mc, vt[10] = ho * gc + le1;
                        }
                        return vt[3] = 0, vt[7] = 0, vt[11] = 0, vt[12] = 0, vt[13] = 0, vt[14] = 0, vt[15] = 1, this;
                    }
                    makeRotationFromQuaternion(le1) {
                        return this.compose(KA, le1, JA);
                    }
                    lookAt(le1, vt, bt) {
                        const ls = this.elements;
                        return t_.subVectors(le1, vt), 0 === t_.lengthSq() && (t_.z = 1), t_.normalize(), $A.crossVectors(bt, t_), 0 === $A.lengthSq() && (1 === Math.abs(bt.z) ? t_.x += 1e-4 : t_.z += 1e-4, t_.normalize(), $A.crossVectors(bt, t_)), $A.normalize(), e_.crossVectors(t_, $A), ls[0] = $A.x, ls[4] = e_.x, ls[8] = t_.x, ls[1] = $A.y, ls[5] = e_.y, ls[9] = t_.y, ls[2] = $A.z, ls[6] = e_.z, ls[10] = t_.z, this;
                    }
                    multiply(le1) {
                        return this.multiplyMatrices(this, le1);
                    }
                    premultiply(le1) {
                        return this.multiplyMatrices(le1, this);
                    }
                    multiplyMatrices(le1, vt) {
                        const bt = le1.elements, ls = vt.elements, ho = this.elements, Dl = bt[0], Fl = bt[4], sc = bt[8], uc = bt[12], mc = bt[1], gc = bt[5], Ac = bt[9], Ec = bt[13], kc = bt[2], du = bt[6], _u = bt[10], Md = bt[14], Ld = bt[3], Nd = bt[7], Rd = bt[11], Od = bt[15], jd = ls[0], Ud = ls[4], Gd = ls[8], qd = ls[12], Hd = ls[1], Wd = ls[5], Zd = ls[9], Yd = ls[13], Qd = ls[2], Xd = ls[6], Kd = ls[10], Jd = ls[14], $d = ls[3], sp = ls[7], em = ls[11], tm = ls[15];
                        return ho[0] = Dl * jd + Fl * Hd + sc * Qd + uc * $d, ho[4] = Dl * Ud + Fl * Wd + sc * Xd + uc * sp, ho[8] = Dl * Gd + Fl * Zd + sc * Kd + uc * em, ho[12] = Dl * qd + Fl * Yd + sc * Jd + uc * tm, ho[1] = mc * jd + gc * Hd + Ac * Qd + Ec * $d, ho[5] = mc * Ud + gc * Wd + Ac * Xd + Ec * sp, ho[9] = mc * Gd + gc * Zd + Ac * Kd + Ec * em, ho[13] = mc * qd + gc * Yd + Ac * Jd + Ec * tm, ho[2] = kc * jd + du * Hd + _u * Qd + Md * $d, ho[6] = kc * Ud + du * Wd + _u * Xd + Md * sp, ho[10] = kc * Gd + du * Zd + _u * Kd + Md * em, ho[14] = kc * qd + du * Yd + _u * Jd + Md * tm, ho[3] = Ld * jd + Nd * Hd + Rd * Qd + Od * $d, ho[7] = Ld * Ud + Nd * Wd + Rd * Xd + Od * sp, ho[11] = Ld * Gd + Nd * Zd + Rd * Kd + Od * em, ho[15] = Ld * qd + Nd * Yd + Rd * Jd + Od * tm, this;
                    }
                    multiplyScalar(le1) {
                        const vt = this.elements;
                        return vt[0] *= le1, vt[4] *= le1, vt[8] *= le1, vt[12] *= le1, vt[1] *= le1, vt[5] *= le1, vt[9] *= le1, vt[13] *= le1, vt[2] *= le1, vt[6] *= le1, vt[10] *= le1, vt[14] *= le1, vt[3] *= le1, vt[7] *= le1, vt[11] *= le1, vt[15] *= le1, this;
                    }
                    determinant() {
                        const le1 = this.elements, vt = le1[0], bt = le1[4], ls = le1[8], ho = le1[12], Dl = le1[1], Fl = le1[5], sc = le1[9], uc = le1[13], mc = le1[2], gc = le1[6], Ac = le1[10], Ec = le1[14];
                        return le1[3] * (+ho * sc * gc - ls * uc * gc - ho * Fl * Ac + bt * uc * Ac + ls * Fl * Ec - bt * sc * Ec) + le1[7] * (+vt * sc * Ec - vt * uc * Ac + ho * Dl * Ac - ls * Dl * Ec + ls * uc * mc - ho * sc * mc) + le1[11] * (+vt * uc * gc - vt * Fl * Ec - ho * Dl * gc + bt * Dl * Ec + ho * Fl * mc - bt * uc * mc) + le1[15] * (-ls * Fl * mc - vt * sc * gc + vt * Fl * Ac + ls * Dl * gc - bt * Dl * Ac + bt * sc * mc);
                    }
                    transpose() {
                        const le1 = this.elements;
                        let vt;
                        return vt = le1[1], le1[1] = le1[4], le1[4] = vt, vt = le1[2], le1[2] = le1[8], le1[8] = vt, vt = le1[6], le1[6] = le1[9], le1[9] = vt, vt = le1[3], le1[3] = le1[12], le1[12] = vt, vt = le1[7], le1[7] = le1[13], le1[13] = vt, vt = le1[11], le1[11] = le1[14], le1[14] = vt, this;
                    }
                    setPosition(le1, vt, bt) {
                        const ls = this.elements;
                        return le1.isVector3 ? (ls[12] = le1.x, ls[13] = le1.y, ls[14] = le1.z) : (ls[12] = le1, ls[13] = vt, ls[14] = bt), this;
                    }
                    invert() {
                        const le1 = this.elements, vt = le1[0], bt = le1[1], ls = le1[2], ho = le1[3], Dl = le1[4], Fl = le1[5], sc = le1[6], uc = le1[7], mc = le1[8], gc = le1[9], Ac = le1[10], Ec = le1[11], kc = le1[12], du = le1[13], _u = le1[14], Md = le1[15], Ld = gc * _u * uc - du * Ac * uc + du * sc * Ec - Fl * _u * Ec - gc * sc * Md + Fl * Ac * Md, Nd = kc * Ac * uc - mc * _u * uc - kc * sc * Ec + Dl * _u * Ec + mc * sc * Md - Dl * Ac * Md, Rd = mc * du * uc - kc * gc * uc + kc * Fl * Ec - Dl * du * Ec - mc * Fl * Md + Dl * gc * Md, Od = kc * gc * sc - mc * du * sc - kc * Fl * Ac + Dl * du * Ac + mc * Fl * _u - Dl * gc * _u, jd = vt * Ld + bt * Nd + ls * Rd + ho * Od;
                        if (0 === jd) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
                        const Ud = 1 / jd;
                        return le1[0] = Ld * Ud, le1[1] = (du * Ac * ho - gc * _u * ho - du * ls * Ec + bt * _u * Ec + gc * ls * Md - bt * Ac * Md) * Ud, le1[2] = (Fl * _u * ho - du * sc * ho + du * ls * uc - bt * _u * uc - Fl * ls * Md + bt * sc * Md) * Ud, le1[3] = (gc * sc * ho - Fl * Ac * ho - gc * ls * uc + bt * Ac * uc + Fl * ls * Ec - bt * sc * Ec) * Ud, le1[4] = Nd * Ud, le1[5] = (mc * _u * ho - kc * Ac * ho + kc * ls * Ec - vt * _u * Ec - mc * ls * Md + vt * Ac * Md) * Ud, le1[6] = (kc * sc * ho - Dl * _u * ho - kc * ls * uc + vt * _u * uc + Dl * ls * Md - vt * sc * Md) * Ud, le1[7] = (Dl * Ac * ho - mc * sc * ho + mc * ls * uc - vt * Ac * uc - Dl * ls * Ec + vt * sc * Ec) * Ud, le1[8] = Rd * Ud, le1[9] = (kc * gc * ho - mc * du * ho - kc * bt * Ec + vt * du * Ec + mc * bt * Md - vt * gc * Md) * Ud, le1[10] = (Dl * du * ho - kc * Fl * ho + kc * bt * uc - vt * du * uc - Dl * bt * Md + vt * Fl * Md) * Ud, le1[11] = (mc * Fl * ho - Dl * gc * ho - mc * bt * uc + vt * gc * uc + Dl * bt * Ec - vt * Fl * Ec) * Ud, le1[12] = Od * Ud, le1[13] = (mc * du * ls - kc * gc * ls + kc * bt * Ac - vt * du * Ac - mc * bt * _u + vt * gc * _u) * Ud, le1[14] = (kc * Fl * ls - Dl * du * ls - kc * bt * sc + vt * du * sc + Dl * bt * _u - vt * Fl * _u) * Ud, le1[15] = (Dl * gc * ls - mc * Fl * ls + mc * bt * sc - vt * gc * sc - Dl * bt * Ac + vt * Fl * Ac) * Ud, this;
                    }
                    scale(le1) {
                        const vt = this.elements, bt = le1.x, ls = le1.y, ho = le1.z;
                        return vt[0] *= bt, vt[4] *= ls, vt[8] *= ho, vt[1] *= bt, vt[5] *= ls, vt[9] *= ho, vt[2] *= bt, vt[6] *= ls, vt[10] *= ho, vt[3] *= bt, vt[7] *= ls, vt[11] *= ho, this;
                    }
                    getMaxScaleOnAxis() {
                        const le1 = this.elements, vt = le1[0] * le1[0] + le1[1] * le1[1] + le1[2] * le1[2], bt = le1[4] * le1[4] + le1[5] * le1[5] + le1[6] * le1[6], ls = le1[8] * le1[8] + le1[9] * le1[9] + le1[10] * le1[10];
                        return Math.sqrt(Math.max(vt, bt, ls));
                    }
                    makeTranslation(le1, vt, bt) {
                        return le1.isVector3 ? this.set(1, 0, 0, le1.x, 0, 1, 0, le1.y, 0, 0, 1, le1.z, 0, 0, 0, 1) : this.set(1, 0, 0, le1, 0, 1, 0, vt, 0, 0, 1, bt, 0, 0, 0, 1), this;
                    }
                    makeRotationX(le1) {
                        const vt = Math.cos(le1), bt = Math.sin(le1);
                        return this.set(1, 0, 0, 0, 0, vt, -bt, 0, 0, bt, vt, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationY(le1) {
                        const vt = Math.cos(le1), bt = Math.sin(le1);
                        return this.set(vt, 0, bt, 0, 0, 1, 0, 0, -bt, 0, vt, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationZ(le1) {
                        const vt = Math.cos(le1), bt = Math.sin(le1);
                        return this.set(vt, -bt, 0, 0, bt, vt, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1), this;
                    }
                    makeRotationAxis(le1, vt) {
                        const bt = Math.cos(vt), ls = Math.sin(vt), ho = 1 - bt, Dl = le1.x, Fl = le1.y, sc = le1.z, uc = ho * Dl, mc = ho * Fl;
                        return this.set(uc * Dl + bt, uc * Fl - ls * sc, uc * sc + ls * Fl, 0, uc * Fl + ls * sc, mc * Fl + bt, mc * sc - ls * Dl, 0, uc * sc - ls * Fl, mc * sc + ls * Dl, ho * sc * sc + bt, 0, 0, 0, 0, 1), this;
                    }
                    makeScale(le1, vt, bt) {
                        return this.set(le1, 0, 0, 0, 0, vt, 0, 0, 0, 0, bt, 0, 0, 0, 0, 1), this;
                    }
                    makeShear(le1, vt, bt, ls, ho, Dl) {
                        return this.set(1, bt, ho, 0, le1, 1, Dl, 0, vt, ls, 1, 0, 0, 0, 0, 1), this;
                    }
                    compose(le1, vt, bt) {
                        const ls = this.elements, ho = vt._x, Dl = vt._y, Fl = vt._z, sc = vt._w, uc = ho + ho, mc = Dl + Dl, gc = Fl + Fl, Ac = ho * uc, Ec = ho * mc, kc = ho * gc, du = Dl * mc, _u = Dl * gc, Md = Fl * gc, Ld = sc * uc, Nd = sc * mc, Rd = sc * gc, Od = bt.x, jd = bt.y, Ud = bt.z;
                        return ls[0] = (1 - (du + Md)) * Od, ls[1] = (Ec + Rd) * Od, ls[2] = (kc - Nd) * Od, ls[3] = 0, ls[4] = (Ec - Rd) * jd, ls[5] = (1 - (Ac + Md)) * jd, ls[6] = (_u + Ld) * jd, ls[7] = 0, ls[8] = (kc + Nd) * Ud, ls[9] = (_u - Ld) * Ud, ls[10] = (1 - (Ac + du)) * Ud, ls[11] = 0, ls[12] = le1.x, ls[13] = le1.y, ls[14] = le1.z, ls[15] = 1, this;
                    }
                    decompose(le1, vt, bt) {
                        const ls = this.elements;
                        let ho = QA.set(ls[0], ls[1], ls[2]).length();
                        const Dl = QA.set(ls[4], ls[5], ls[6]).length(), Fl = QA.set(ls[8], ls[9], ls[10]).length();
                        this.determinant() < 0 && (ho = -ho), le1.x = ls[12], le1.y = ls[13], le1.z = ls[14], XA.copy(this);
                        const sc = 1 / ho, uc = 1 / Dl, mc = 1 / Fl;
                        return XA.elements[0] *= sc, XA.elements[1] *= sc, XA.elements[2] *= sc, XA.elements[4] *= uc, XA.elements[5] *= uc, XA.elements[6] *= uc, XA.elements[8] *= mc, XA.elements[9] *= mc, XA.elements[10] *= mc, vt.setFromRotationMatrix(XA), bt.x = ho, bt.y = Dl, bt.z = Fl, this;
                    }
                    makePerspective(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        void 0 === Fl && (Fl = lA), void 0 === sc && (sc = !1);
                        const uc = this.elements, mc = 2 * ho / (vt - le1), gc = 2 * ho / (bt - ls), Ac = (vt + le1) / (vt - le1), Ec = (bt + ls) / (bt - ls);
                        let kc, du;
                        if (sc) kc = ho / (Dl - ho), du = Dl * ho / (Dl - ho);
                        else if (Fl === lA) kc = -(Dl + ho) / (Dl - ho), du = -2 * Dl * ho / (Dl - ho);
                        else {
                            if (Fl !== cA) throw new Error("THREE.Matrix4.makePerspective(): Invalid coordinate system: " + Fl);
                            kc = -Dl / (Dl - ho), du = -Dl * ho / (Dl - ho);
                        }
                        return uc[0] = mc, uc[4] = 0, uc[8] = Ac, uc[12] = 0, uc[1] = 0, uc[5] = gc, uc[9] = Ec, uc[13] = 0, uc[2] = 0, uc[6] = 0, uc[10] = kc, uc[14] = du, uc[3] = 0, uc[7] = 0, uc[11] = -1, uc[15] = 0, this;
                    }
                    makeOrthographic(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        void 0 === Fl && (Fl = lA), void 0 === sc && (sc = !1);
                        const uc = this.elements, mc = 2 / (vt - le1), gc = 2 / (bt - ls), Ac = -(vt + le1) / (vt - le1), Ec = -(bt + ls) / (bt - ls);
                        let kc, du;
                        if (sc) kc = 1 / (Dl - ho), du = Dl / (Dl - ho);
                        else if (Fl === lA) kc = -2 / (Dl - ho), du = -(Dl + ho) / (Dl - ho);
                        else {
                            if (Fl !== cA) throw new Error("THREE.Matrix4.makeOrthographic(): Invalid coordinate system: " + Fl);
                            kc = -1 / (Dl - ho), du = -ho / (Dl - ho);
                        }
                        return uc[0] = mc, uc[4] = 0, uc[8] = 0, uc[12] = Ac, uc[1] = 0, uc[5] = gc, uc[9] = 0, uc[13] = Ec, uc[2] = 0, uc[6] = 0, uc[10] = kc, uc[14] = du, uc[3] = 0, uc[7] = 0, uc[11] = 0, uc[15] = 1, this;
                    }
                    equals(le1) {
                        const vt = this.elements, bt = le1.elements;
                        for(let ls = 0; ls < 16; ls++)if (vt[ls] !== bt[ls]) return !1;
                        return !0;
                    }
                    fromArray(le1, vt) {
                        void 0 === vt && (vt = 0);
                        for(let bt = 0; bt < 16; bt++)this.elements[bt] = le1[bt + vt];
                        return this;
                    }
                    toArray(le1, vt) {
                        void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0);
                        const bt = this.elements;
                        return le1[vt] = bt[0], le1[vt + 1] = bt[1], le1[vt + 2] = bt[2], le1[vt + 3] = bt[3], le1[vt + 4] = bt[4], le1[vt + 5] = bt[5], le1[vt + 6] = bt[6], le1[vt + 7] = bt[7], le1[vt + 8] = bt[8], le1[vt + 9] = bt[9], le1[vt + 10] = bt[10], le1[vt + 11] = bt[11], le1[vt + 12] = bt[12], le1[vt + 13] = bt[13], le1[vt + 14] = bt[14], le1[vt + 15] = bt[15], le1;
                    }
                }
                const QA = new Vector3, XA = new Matrix4, KA = new Vector3(0, 0, 0), JA = new Vector3(1, 1, 1), $A = new Vector3, e_ = new Vector3, t_ = new Vector3, i_ = new Matrix4, n_ = new Quaternion;
                class Euler {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = 0), void 0 === vt && (vt = 0), void 0 === bt && (bt = 0), void 0 === ls && (ls = Euler.DEFAULT_ORDER), this.isEuler = !0, this._x = le1, this._y = vt, this._z = bt, this._order = ls;
                    }
                    get x() {
                        return this._x;
                    }
                    set x(le1) {
                        this._x = le1, this._onChangeCallback();
                    }
                    get y() {
                        return this._y;
                    }
                    set y(le1) {
                        this._y = le1, this._onChangeCallback();
                    }
                    get z() {
                        return this._z;
                    }
                    set z(le1) {
                        this._z = le1, this._onChangeCallback();
                    }
                    get order() {
                        return this._order;
                    }
                    set order(le1) {
                        this._order = le1, this._onChangeCallback();
                    }
                    set(le1, vt, bt, ls) {
                        return void 0 === ls && (ls = this._order), this._x = le1, this._y = vt, this._z = bt, this._order = ls, this._onChangeCallback(), this;
                    }
                    clone() {
                        return new this.constructor(this._x, this._y, this._z, this._order);
                    }
                    copy(le1) {
                        return this._x = le1._x, this._y = le1._y, this._z = le1._z, this._order = le1._order, this._onChangeCallback(), this;
                    }
                    setFromRotationMatrix(le1, vt, bt) {
                        void 0 === vt && (vt = this._order), void 0 === bt && (bt = !0);
                        const ls = le1.elements, ho = ls[0], Dl = ls[4], Fl = ls[8], sc = ls[1], uc = ls[5], mc = ls[9], gc = ls[2], Ac = ls[6], Ec = ls[10];
                        switch(vt){
                            case "XYZ":
                                this._y = Math.asin(clamp(Fl, -1, 1)), Math.abs(Fl) < .9999999 ? (this._x = Math.atan2(-mc, Ec), this._z = Math.atan2(-Dl, ho)) : (this._x = Math.atan2(Ac, uc), this._z = 0);
                                break;
                            case "YXZ":
                                this._x = Math.asin(-clamp(mc, -1, 1)), Math.abs(mc) < .9999999 ? (this._y = Math.atan2(Fl, Ec), this._z = Math.atan2(sc, uc)) : (this._y = Math.atan2(-gc, ho), this._z = 0);
                                break;
                            case "ZXY":
                                this._x = Math.asin(clamp(Ac, -1, 1)), Math.abs(Ac) < .9999999 ? (this._y = Math.atan2(-gc, Ec), this._z = Math.atan2(-Dl, uc)) : (this._y = 0, this._z = Math.atan2(sc, ho));
                                break;
                            case "ZYX":
                                this._y = Math.asin(-clamp(gc, -1, 1)), Math.abs(gc) < .9999999 ? (this._x = Math.atan2(Ac, Ec), this._z = Math.atan2(sc, ho)) : (this._x = 0, this._z = Math.atan2(-Dl, uc));
                                break;
                            case "YZX":
                                this._z = Math.asin(clamp(sc, -1, 1)), Math.abs(sc) < .9999999 ? (this._x = Math.atan2(-mc, uc), this._y = Math.atan2(-gc, ho)) : (this._x = 0, this._y = Math.atan2(Fl, Ec));
                                break;
                            case "XZY":
                                this._z = Math.asin(-clamp(Dl, -1, 1)), Math.abs(Dl) < .9999999 ? (this._x = Math.atan2(Ac, uc), this._y = Math.atan2(Fl, ho)) : (this._x = Math.atan2(-mc, Ec), this._y = 0);
                                break;
                            default:
                                console.warn("THREE.Euler: .setFromRotationMatrix() encountered an unknown order: " + vt);
                        }
                        return this._order = vt, !0 === bt && this._onChangeCallback(), this;
                    }
                    setFromQuaternion(le1, vt, bt) {
                        return i_.makeRotationFromQuaternion(le1), this.setFromRotationMatrix(i_, vt, bt);
                    }
                    setFromVector3(le1, vt) {
                        return void 0 === vt && (vt = this._order), this.set(le1.x, le1.y, le1.z, vt);
                    }
                    reorder(le1) {
                        return n_.setFromEuler(this), this.setFromQuaternion(n_, le1);
                    }
                    equals(le1) {
                        return le1._x === this._x && le1._y === this._y && le1._z === this._z && le1._order === this._order;
                    }
                    fromArray(le1) {
                        return this._x = le1[0], this._y = le1[1], this._z = le1[2], void 0 !== le1[3] && (this._order = le1[3]), this._onChangeCallback(), this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this._x, le1[vt + 1] = this._y, le1[vt + 2] = this._z, le1[vt + 3] = this._order, le1;
                    }
                    _onChange(le1) {
                        return this._onChangeCallback = le1, this;
                    }
                    _onChangeCallback() {}
                    *[Symbol.iterator]() {
                        yield this._x, yield this._y, yield this._z, yield this._order;
                    }
                }
                Euler.DEFAULT_ORDER = "XYZ";
                class Layers {
                    constructor(){
                        this.mask = 1;
                    }
                    set(le1) {
                        this.mask = 1 << le1 >>> 0;
                    }
                    enable(le1) {
                        this.mask |= 1 << le1;
                    }
                    enableAll() {
                        this.mask = -1;
                    }
                    toggle(le1) {
                        this.mask ^= 1 << le1;
                    }
                    disable(le1) {
                        this.mask &= ~(1 << le1);
                    }
                    disableAll() {
                        this.mask = 0;
                    }
                    test(le1) {
                        return 0 !== (this.mask & le1.mask);
                    }
                    isEnabled(le1) {
                        return 0 !== (this.mask & 1 << le1);
                    }
                }
                let r_ = 0;
                const a_ = new Vector3, s_ = new Quaternion, o_ = new Matrix4, l_ = new Vector3, c_ = new Vector3, u_ = new Vector3, h_ = new Quaternion, d_ = new Vector3(1, 0, 0), p_ = new Vector3(0, 1, 0), m_ = new Vector3(0, 0, 1), f_ = {
                    type: "added"
                }, g_ = {
                    type: "removed"
                }, A_ = {
                    type: "childadded",
                    child: null
                }, __ = {
                    type: "childremoved",
                    child: null
                };
                class Object3D extends EventDispatcher {
                    constructor(){
                        super(), this.isObject3D = !0, Object.defineProperty(this, "id", {
                            value: r_++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "Object3D", this.parent = null, this.children = [], this.up = Object3D.DEFAULT_UP.clone();
                        const le1 = new Vector3, vt = new Euler, bt = new Quaternion, ls = new Vector3(1, 1, 1);
                        vt._onChange(function() {
                            bt.setFromEuler(vt, !1);
                        }), bt._onChange(function() {
                            vt.setFromQuaternion(bt, void 0, !1);
                        }), Object.defineProperties(this, {
                            position: {
                                configurable: !0,
                                enumerable: !0,
                                value: le1
                            },
                            rotation: {
                                configurable: !0,
                                enumerable: !0,
                                value: vt
                            },
                            quaternion: {
                                configurable: !0,
                                enumerable: !0,
                                value: bt
                            },
                            scale: {
                                configurable: !0,
                                enumerable: !0,
                                value: ls
                            },
                            modelViewMatrix: {
                                value: new Matrix4
                            },
                            normalMatrix: {
                                value: new Matrix3
                            }
                        }), this.matrix = new Matrix4, this.matrixWorld = new Matrix4, this.matrixAutoUpdate = Object3D.DEFAULT_MATRIX_AUTO_UPDATE, this.matrixWorldAutoUpdate = Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE, this.matrixWorldNeedsUpdate = !1, this.layers = new Layers, this.visible = !0, this.castShadow = !1, this.receiveShadow = !1, this.frustumCulled = !0, this.renderOrder = 0, this.animations = [], this.customDepthMaterial = void 0, this.customDistanceMaterial = void 0, this.userData = {};
                    }
                    onBeforeShadow() {}
                    onAfterShadow() {}
                    onBeforeRender() {}
                    onAfterRender() {}
                    applyMatrix4(le1) {
                        this.matrixAutoUpdate && this.updateMatrix(), this.matrix.premultiply(le1), this.matrix.decompose(this.position, this.quaternion, this.scale);
                    }
                    applyQuaternion(le1) {
                        return this.quaternion.premultiply(le1), this;
                    }
                    setRotationFromAxisAngle(le1, vt) {
                        this.quaternion.setFromAxisAngle(le1, vt);
                    }
                    setRotationFromEuler(le1) {
                        this.quaternion.setFromEuler(le1, !0);
                    }
                    setRotationFromMatrix(le1) {
                        this.quaternion.setFromRotationMatrix(le1);
                    }
                    setRotationFromQuaternion(le1) {
                        this.quaternion.copy(le1);
                    }
                    rotateOnAxis(le1, vt) {
                        return s_.setFromAxisAngle(le1, vt), this.quaternion.multiply(s_), this;
                    }
                    rotateOnWorldAxis(le1, vt) {
                        return s_.setFromAxisAngle(le1, vt), this.quaternion.premultiply(s_), this;
                    }
                    rotateX(le1) {
                        return this.rotateOnAxis(d_, le1);
                    }
                    rotateY(le1) {
                        return this.rotateOnAxis(p_, le1);
                    }
                    rotateZ(le1) {
                        return this.rotateOnAxis(m_, le1);
                    }
                    translateOnAxis(le1, vt) {
                        return a_.copy(le1).applyQuaternion(this.quaternion), this.position.add(a_.multiplyScalar(vt)), this;
                    }
                    translateX(le1) {
                        return this.translateOnAxis(d_, le1);
                    }
                    translateY(le1) {
                        return this.translateOnAxis(p_, le1);
                    }
                    translateZ(le1) {
                        return this.translateOnAxis(m_, le1);
                    }
                    localToWorld(le1) {
                        return this.updateWorldMatrix(!0, !1), le1.applyMatrix4(this.matrixWorld);
                    }
                    worldToLocal(le1) {
                        return this.updateWorldMatrix(!0, !1), le1.applyMatrix4(o_.copy(this.matrixWorld).invert());
                    }
                    lookAt(le1, vt, bt) {
                        le1.isVector3 ? l_.copy(le1) : l_.set(le1, vt, bt);
                        const ls = this.parent;
                        this.updateWorldMatrix(!0, !1), c_.setFromMatrixPosition(this.matrixWorld), this.isCamera || this.isLight ? o_.lookAt(c_, l_, this.up) : o_.lookAt(l_, c_, this.up), this.quaternion.setFromRotationMatrix(o_), ls && (o_.extractRotation(ls.matrixWorld), s_.setFromRotationMatrix(o_), this.quaternion.premultiply(s_.invert()));
                    }
                    add(le1) {
                        if (arguments.length > 1) {
                            for(let le1 = 0; le1 < arguments.length; le1++)this.add(arguments[le1]);
                            return this;
                        }
                        return le1 === this ? (console.error("THREE.Object3D.add: object can't be added as a child of itself.", le1), this) : (le1 && le1.isObject3D ? (le1.removeFromParent(), le1.parent = this, this.children.push(le1), le1.dispatchEvent(f_), A_.child = le1, this.dispatchEvent(A_), A_.child = null) : console.error("THREE.Object3D.add: object not an instance of THREE.Object3D.", le1), this);
                    }
                    remove(le1) {
                        if (arguments.length > 1) {
                            for(let le1 = 0; le1 < arguments.length; le1++)this.remove(arguments[le1]);
                            return this;
                        }
                        const vt = this.children.indexOf(le1);
                        return -1 !== vt && (le1.parent = null, this.children.splice(vt, 1), le1.dispatchEvent(g_), __.child = le1, this.dispatchEvent(__), __.child = null), this;
                    }
                    removeFromParent() {
                        const le1 = this.parent;
                        return null !== le1 && le1.remove(this), this;
                    }
                    clear() {
                        return this.remove(...this.children);
                    }
                    attach(le1) {
                        return this.updateWorldMatrix(!0, !1), o_.copy(this.matrixWorld).invert(), null !== le1.parent && (le1.parent.updateWorldMatrix(!0, !1), o_.multiply(le1.parent.matrixWorld)), le1.applyMatrix4(o_), le1.removeFromParent(), le1.parent = this, this.children.push(le1), le1.updateWorldMatrix(!1, !0), le1.dispatchEvent(f_), A_.child = le1, this.dispatchEvent(A_), A_.child = null, this;
                    }
                    getObjectById(le1) {
                        return this.getObjectByProperty("id", le1);
                    }
                    getObjectByName(le1) {
                        return this.getObjectByProperty("name", le1);
                    }
                    getObjectByProperty(le1, vt) {
                        if (this[le1] === vt) return this;
                        for(let bt = 0, ls = this.children.length; bt < ls; bt++){
                            const ls = this.children[bt].getObjectByProperty(le1, vt);
                            if (void 0 !== ls) return ls;
                        }
                    }
                    getObjectsByProperty(le1, vt, bt) {
                        void 0 === bt && (bt = []), this[le1] === vt && bt.push(this);
                        const ls = this.children;
                        for(let ho = 0, Dl = ls.length; ho < Dl; ho++)ls[ho].getObjectsByProperty(le1, vt, bt);
                        return bt;
                    }
                    getWorldPosition(le1) {
                        return this.updateWorldMatrix(!0, !1), le1.setFromMatrixPosition(this.matrixWorld);
                    }
                    getWorldQuaternion(le1) {
                        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(c_, le1, u_), le1;
                    }
                    getWorldScale(le1) {
                        return this.updateWorldMatrix(!0, !1), this.matrixWorld.decompose(c_, h_, le1), le1;
                    }
                    getWorldDirection(le1) {
                        this.updateWorldMatrix(!0, !1);
                        const vt = this.matrixWorld.elements;
                        return le1.set(vt[8], vt[9], vt[10]).normalize();
                    }
                    raycast() {}
                    traverse(le1) {
                        le1(this);
                        const vt = this.children;
                        for(let bt = 0, ls = vt.length; bt < ls; bt++)vt[bt].traverse(le1);
                    }
                    traverseVisible(le1) {
                        if (!1 === this.visible) return;
                        le1(this);
                        const vt = this.children;
                        for(let bt = 0, ls = vt.length; bt < ls; bt++)vt[bt].traverseVisible(le1);
                    }
                    traverseAncestors(le1) {
                        const vt = this.parent;
                        null !== vt && (le1(vt), vt.traverseAncestors(le1));
                    }
                    updateMatrix() {
                        this.matrix.compose(this.position, this.quaternion, this.scale), this.matrixWorldNeedsUpdate = !0;
                    }
                    updateMatrixWorld(le1) {
                        this.matrixAutoUpdate && this.updateMatrix(), (this.matrixWorldNeedsUpdate || le1) && (!0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), this.matrixWorldNeedsUpdate = !1, le1 = !0);
                        const vt = this.children;
                        for(let bt = 0, ls = vt.length; bt < ls; bt++)vt[bt].updateMatrixWorld(le1);
                    }
                    updateWorldMatrix(le1, vt) {
                        const bt = this.parent;
                        if (!0 === le1 && null !== bt && bt.updateWorldMatrix(!0, !1), this.matrixAutoUpdate && this.updateMatrix(), !0 === this.matrixWorldAutoUpdate && (null === this.parent ? this.matrixWorld.copy(this.matrix) : this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix)), !0 === vt) {
                            const le1 = this.children;
                            for(let vt = 0, bt = le1.length; vt < bt; vt++)le1[vt].updateWorldMatrix(!1, !0);
                        }
                    }
                    toJSON(le1) {
                        const vt = void 0 === le1 || "string" === typeof le1, bt = {};
                        vt && (le1 = {
                            geometries: {},
                            materials: {},
                            textures: {},
                            images: {},
                            shapes: {},
                            skeletons: {},
                            animations: {},
                            nodes: {}
                        }, bt.metadata = {
                            version: 4.7,
                            type: "Object",
                            generator: "Object3D.toJSON"
                        });
                        const ls = {};
                        function serialize(vt, bt) {
                            return void 0 === vt[bt.uuid] && (vt[bt.uuid] = bt.toJSON(le1)), bt.uuid;
                        }
                        if (ls.uuid = this.uuid, ls.type = this.type, "" !== this.name && (ls.name = this.name), !0 === this.castShadow && (ls.castShadow = !0), !0 === this.receiveShadow && (ls.receiveShadow = !0), !1 === this.visible && (ls.visible = !1), !1 === this.frustumCulled && (ls.frustumCulled = !1), 0 !== this.renderOrder && (ls.renderOrder = this.renderOrder), Object.keys(this.userData).length > 0 && (ls.userData = this.userData), ls.layers = this.layers.mask, ls.matrix = this.matrix.toArray(), ls.up = this.up.toArray(), !1 === this.matrixAutoUpdate && (ls.matrixAutoUpdate = !1), this.isInstancedMesh && (ls.type = "InstancedMesh", ls.count = this.count, ls.instanceMatrix = this.instanceMatrix.toJSON(), null !== this.instanceColor && (ls.instanceColor = this.instanceColor.toJSON())), this.isBatchedMesh && (ls.type = "BatchedMesh", ls.perObjectFrustumCulled = this.perObjectFrustumCulled, ls.sortObjects = this.sortObjects, ls.drawRanges = this._drawRanges, ls.reservedRanges = this._reservedRanges, ls.geometryInfo = this._geometryInfo.map((le1)=>({
                                ...le1,
                                boundingBox: le1.boundingBox ? le1.boundingBox.toJSON() : void 0,
                                boundingSphere: le1.boundingSphere ? le1.boundingSphere.toJSON() : void 0
                            })), ls.instanceInfo = this._instanceInfo.map((le1)=>({
                                ...le1
                            })), ls.availableInstanceIds = this._availableInstanceIds.slice(), ls.availableGeometryIds = this._availableGeometryIds.slice(), ls.nextIndexStart = this._nextIndexStart, ls.nextVertexStart = this._nextVertexStart, ls.geometryCount = this._geometryCount, ls.maxInstanceCount = this._maxInstanceCount, ls.maxVertexCount = this._maxVertexCount, ls.maxIndexCount = this._maxIndexCount, ls.geometryInitialized = this._geometryInitialized, ls.matricesTexture = this._matricesTexture.toJSON(le1), ls.indirectTexture = this._indirectTexture.toJSON(le1), null !== this._colorsTexture && (ls.colorsTexture = this._colorsTexture.toJSON(le1)), null !== this.boundingSphere && (ls.boundingSphere = this.boundingSphere.toJSON()), null !== this.boundingBox && (ls.boundingBox = this.boundingBox.toJSON())), this.isScene) this.background && (this.background.isColor ? ls.background = this.background.toJSON() : this.background.isTexture && (ls.background = this.background.toJSON(le1).uuid)), this.environment && this.environment.isTexture && !0 !== this.environment.isRenderTargetTexture && (ls.environment = this.environment.toJSON(le1).uuid);
                        else if (this.isMesh || this.isLine || this.isPoints) {
                            ls.geometry = serialize(le1.geometries, this.geometry);
                            const vt = this.geometry.parameters;
                            if (void 0 !== vt && void 0 !== vt.shapes) {
                                const bt = vt.shapes;
                                if (Array.isArray(bt)) for(let vt = 0, ls = bt.length; vt < ls; vt++){
                                    const ls = bt[vt];
                                    serialize(le1.shapes, ls);
                                }
                                else serialize(le1.shapes, bt);
                            }
                        }
                        if (this.isSkinnedMesh && (ls.bindMode = this.bindMode, ls.bindMatrix = this.bindMatrix.toArray(), void 0 !== this.skeleton && (serialize(le1.skeletons, this.skeleton), ls.skeleton = this.skeleton.uuid)), void 0 !== this.material) {
                            if (Array.isArray(this.material)) {
                                const vt = [];
                                for(let bt = 0, ls = this.material.length; bt < ls; bt++)vt.push(serialize(le1.materials, this.material[bt]));
                                ls.material = vt;
                            } else ls.material = serialize(le1.materials, this.material);
                        }
                        if (this.children.length > 0) {
                            ls.children = [];
                            for(let vt = 0; vt < this.children.length; vt++)ls.children.push(this.children[vt].toJSON(le1).object);
                        }
                        if (this.animations.length > 0) {
                            ls.animations = [];
                            for(let vt = 0; vt < this.animations.length; vt++){
                                const bt = this.animations[vt];
                                ls.animations.push(serialize(le1.animations, bt));
                            }
                        }
                        if (vt) {
                            const vt = extractFromCache(le1.geometries), ls = extractFromCache(le1.materials), ho = extractFromCache(le1.textures), Dl = extractFromCache(le1.images), Fl = extractFromCache(le1.shapes), sc = extractFromCache(le1.skeletons), uc = extractFromCache(le1.animations), mc = extractFromCache(le1.nodes);
                            vt.length > 0 && (bt.geometries = vt), ls.length > 0 && (bt.materials = ls), ho.length > 0 && (bt.textures = ho), Dl.length > 0 && (bt.images = Dl), Fl.length > 0 && (bt.shapes = Fl), sc.length > 0 && (bt.skeletons = sc), uc.length > 0 && (bt.animations = uc), mc.length > 0 && (bt.nodes = mc);
                        }
                        return bt.object = ls, bt;
                        function extractFromCache(le1) {
                            const vt = [];
                            for(const bt in le1){
                                const ls = le1[bt];
                                delete ls.metadata, vt.push(ls);
                            }
                            return vt;
                        }
                    }
                    clone(le1) {
                        return (new this.constructor).copy(this, le1);
                    }
                    copy(le1, vt) {
                        if (void 0 === vt && (vt = !0), this.name = le1.name, this.up.copy(le1.up), this.position.copy(le1.position), this.rotation.order = le1.rotation.order, this.quaternion.copy(le1.quaternion), this.scale.copy(le1.scale), this.matrix.copy(le1.matrix), this.matrixWorld.copy(le1.matrixWorld), this.matrixAutoUpdate = le1.matrixAutoUpdate, this.matrixWorldAutoUpdate = le1.matrixWorldAutoUpdate, this.matrixWorldNeedsUpdate = le1.matrixWorldNeedsUpdate, this.layers.mask = le1.layers.mask, this.visible = le1.visible, this.castShadow = le1.castShadow, this.receiveShadow = le1.receiveShadow, this.frustumCulled = le1.frustumCulled, this.renderOrder = le1.renderOrder, this.animations = le1.animations.slice(), this.userData = JSON.parse(JSON.stringify(le1.userData)), !0 === vt) for(let bt = 0; bt < le1.children.length; bt++){
                            const vt = le1.children[bt];
                            this.add(vt.clone());
                        }
                        return this;
                    }
                }
                Object3D.DEFAULT_UP = new Vector3(0, 1, 0), Object3D.DEFAULT_MATRIX_AUTO_UPDATE = !0, Object3D.DEFAULT_MATRIX_WORLD_AUTO_UPDATE = !0;
                const y_ = new Vector3, v_ = new Vector3, x_ = new Vector3, b_ = new Vector3, w_ = new Vector3, E_ = new Vector3, M_ = new Vector3, S_ = new Vector3, T_ = new Vector3, k_ = new Vector3, C_ = new Vector4, I_ = new Vector4, D_ = new Vector4;
                class Triangle {
                    constructor(le1, vt, bt){
                        void 0 === le1 && (le1 = new Vector3), void 0 === vt && (vt = new Vector3), void 0 === bt && (bt = new Vector3), this.a = le1, this.b = vt, this.c = bt;
                    }
                    static getNormal(le1, vt, bt, ls) {
                        ls.subVectors(bt, vt), y_.subVectors(le1, vt), ls.cross(y_);
                        const ho = ls.lengthSq();
                        return ho > 0 ? ls.multiplyScalar(1 / Math.sqrt(ho)) : ls.set(0, 0, 0);
                    }
                    static getBarycoord(le1, vt, bt, ls, ho) {
                        y_.subVectors(ls, vt), v_.subVectors(bt, vt), x_.subVectors(le1, vt);
                        const Dl = y_.dot(y_), Fl = y_.dot(v_), sc = y_.dot(x_), uc = v_.dot(v_), mc = v_.dot(x_), gc = Dl * uc - Fl * Fl;
                        if (0 === gc) return ho.set(0, 0, 0), null;
                        const Ac = 1 / gc, Ec = (uc * sc - Fl * mc) * Ac, kc = (Dl * mc - Fl * sc) * Ac;
                        return ho.set(1 - Ec - kc, kc, Ec);
                    }
                    static containsPoint(le1, vt, bt, ls) {
                        return null !== this.getBarycoord(le1, vt, bt, ls, b_) && b_.x >= 0 && b_.y >= 0 && b_.x + b_.y <= 1;
                    }
                    static getInterpolation(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        return null === this.getBarycoord(le1, vt, bt, ls, b_) ? (sc.x = 0, sc.y = 0, "z" in sc && (sc.z = 0), "w" in sc && (sc.w = 0), null) : (sc.setScalar(0), sc.addScaledVector(ho, b_.x), sc.addScaledVector(Dl, b_.y), sc.addScaledVector(Fl, b_.z), sc);
                    }
                    static getInterpolatedAttribute(le1, vt, bt, ls, ho, Dl) {
                        return C_.setScalar(0), I_.setScalar(0), D_.setScalar(0), C_.fromBufferAttribute(le1, vt), I_.fromBufferAttribute(le1, bt), D_.fromBufferAttribute(le1, ls), Dl.setScalar(0), Dl.addScaledVector(C_, ho.x), Dl.addScaledVector(I_, ho.y), Dl.addScaledVector(D_, ho.z), Dl;
                    }
                    static isFrontFacing(le1, vt, bt, ls) {
                        return y_.subVectors(bt, vt), v_.subVectors(le1, vt), y_.cross(v_).dot(ls) < 0;
                    }
                    set(le1, vt, bt) {
                        return this.a.copy(le1), this.b.copy(vt), this.c.copy(bt), this;
                    }
                    setFromPointsAndIndices(le1, vt, bt, ls) {
                        return this.a.copy(le1[vt]), this.b.copy(le1[bt]), this.c.copy(le1[ls]), this;
                    }
                    setFromAttributeAndIndices(le1, vt, bt, ls) {
                        return this.a.fromBufferAttribute(le1, vt), this.b.fromBufferAttribute(le1, bt), this.c.fromBufferAttribute(le1, ls), this;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        return this.a.copy(le1.a), this.b.copy(le1.b), this.c.copy(le1.c), this;
                    }
                    getArea() {
                        return y_.subVectors(this.c, this.b), v_.subVectors(this.a, this.b), .5 * y_.cross(v_).length();
                    }
                    getMidpoint(le1) {
                        return le1.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
                    }
                    getNormal(le1) {
                        return Triangle.getNormal(this.a, this.b, this.c, le1);
                    }
                    getPlane(le1) {
                        return le1.setFromCoplanarPoints(this.a, this.b, this.c);
                    }
                    getBarycoord(le1, vt) {
                        return Triangle.getBarycoord(le1, this.a, this.b, this.c, vt);
                    }
                    getInterpolation(le1, vt, bt, ls, ho) {
                        return Triangle.getInterpolation(le1, this.a, this.b, this.c, vt, bt, ls, ho);
                    }
                    containsPoint(le1) {
                        return Triangle.containsPoint(le1, this.a, this.b, this.c);
                    }
                    isFrontFacing(le1) {
                        return Triangle.isFrontFacing(this.a, this.b, this.c, le1);
                    }
                    intersectsBox(le1) {
                        return le1.intersectsTriangle(this);
                    }
                    closestPointToPoint(le1, vt) {
                        const bt = this.a, ls = this.b, ho = this.c;
                        let Dl, Fl;
                        w_.subVectors(ls, bt), E_.subVectors(ho, bt), S_.subVectors(le1, bt);
                        const sc = w_.dot(S_), uc = E_.dot(S_);
                        if (sc <= 0 && uc <= 0) return vt.copy(bt);
                        T_.subVectors(le1, ls);
                        const mc = w_.dot(T_), gc = E_.dot(T_);
                        if (mc >= 0 && gc <= mc) return vt.copy(ls);
                        const Ac = sc * gc - mc * uc;
                        if (Ac <= 0 && sc >= 0 && mc <= 0) return Dl = sc / (sc - mc), vt.copy(bt).addScaledVector(w_, Dl);
                        k_.subVectors(le1, ho);
                        const Ec = w_.dot(k_), kc = E_.dot(k_);
                        if (kc >= 0 && Ec <= kc) return vt.copy(ho);
                        const du = Ec * uc - sc * kc;
                        if (du <= 0 && uc >= 0 && kc <= 0) return Fl = uc / (uc - kc), vt.copy(bt).addScaledVector(E_, Fl);
                        const _u = mc * kc - Ec * gc;
                        if (_u <= 0 && gc - mc >= 0 && Ec - kc >= 0) return M_.subVectors(ho, ls), Fl = (gc - mc) / (gc - mc + (Ec - kc)), vt.copy(ls).addScaledVector(M_, Fl);
                        const Md = 1 / (_u + du + Ac);
                        return Dl = du * Md, Fl = Ac * Md, vt.copy(bt).addScaledVector(w_, Dl).addScaledVector(E_, Fl);
                    }
                    equals(le1) {
                        return le1.a.equals(this.a) && le1.b.equals(this.b) && le1.c.equals(this.c);
                    }
                }
                const L_ = {
                    aliceblue: 15792383,
                    antiquewhite: 16444375,
                    aqua: 65535,
                    aquamarine: 8388564,
                    azure: 15794175,
                    beige: 16119260,
                    bisque: 16770244,
                    black: 0,
                    blanchedalmond: 16772045,
                    blue: 255,
                    blueviolet: 9055202,
                    brown: 10824234,
                    burlywood: 14596231,
                    cadetblue: 6266528,
                    chartreuse: 8388352,
                    chocolate: 13789470,
                    coral: 16744272,
                    cornflowerblue: 6591981,
                    cornsilk: 16775388,
                    crimson: 14423100,
                    cyan: 65535,
                    darkblue: 139,
                    darkcyan: 35723,
                    darkgoldenrod: 12092939,
                    darkgray: 11119017,
                    darkgreen: 25600,
                    darkgrey: 11119017,
                    darkkhaki: 12433259,
                    darkmagenta: 9109643,
                    darkolivegreen: 5597999,
                    darkorange: 16747520,
                    darkorchid: 10040012,
                    darkred: 9109504,
                    darksalmon: 15308410,
                    darkseagreen: 9419919,
                    darkslateblue: 4734347,
                    darkslategray: 3100495,
                    darkslategrey: 3100495,
                    darkturquoise: 52945,
                    darkviolet: 9699539,
                    deeppink: 16716947,
                    deepskyblue: 49151,
                    dimgray: 6908265,
                    dimgrey: 6908265,
                    dodgerblue: 2003199,
                    firebrick: 11674146,
                    floralwhite: 16775920,
                    forestgreen: 2263842,
                    fuchsia: 16711935,
                    gainsboro: 14474460,
                    ghostwhite: 16316671,
                    gold: 16766720,
                    goldenrod: 14329120,
                    gray: 8421504,
                    green: 32768,
                    greenyellow: 11403055,
                    grey: 8421504,
                    honeydew: 15794160,
                    hotpink: 16738740,
                    indianred: 13458524,
                    indigo: 4915330,
                    ivory: 16777200,
                    khaki: 15787660,
                    lavender: 15132410,
                    lavenderblush: 16773365,
                    lawngreen: 8190976,
                    lemonchiffon: 16775885,
                    lightblue: 11393254,
                    lightcoral: 15761536,
                    lightcyan: 14745599,
                    lightgoldenrodyellow: 16448210,
                    lightgray: 13882323,
                    lightgreen: 9498256,
                    lightgrey: 13882323,
                    lightpink: 16758465,
                    lightsalmon: 16752762,
                    lightseagreen: 2142890,
                    lightskyblue: 8900346,
                    lightslategray: 7833753,
                    lightslategrey: 7833753,
                    lightsteelblue: 11584734,
                    lightyellow: 16777184,
                    lime: 65280,
                    limegreen: 3329330,
                    linen: 16445670,
                    magenta: 16711935,
                    maroon: 8388608,
                    mediumaquamarine: 6737322,
                    mediumblue: 205,
                    mediumorchid: 12211667,
                    mediumpurple: 9662683,
                    mediumseagreen: 3978097,
                    mediumslateblue: 8087790,
                    mediumspringgreen: 64154,
                    mediumturquoise: 4772300,
                    mediumvioletred: 13047173,
                    midnightblue: 1644912,
                    mintcream: 16121850,
                    mistyrose: 16770273,
                    moccasin: 16770229,
                    navajowhite: 16768685,
                    navy: 128,
                    oldlace: 16643558,
                    olive: 8421376,
                    olivedrab: 7048739,
                    orange: 16753920,
                    orangered: 16729344,
                    orchid: 14315734,
                    palegoldenrod: 15657130,
                    palegreen: 10025880,
                    paleturquoise: 11529966,
                    palevioletred: 14381203,
                    papayawhip: 16773077,
                    peachpuff: 16767673,
                    peru: 13468991,
                    pink: 16761035,
                    plum: 14524637,
                    powderblue: 11591910,
                    purple: 8388736,
                    rebeccapurple: 6697881,
                    red: 16711680,
                    rosybrown: 12357519,
                    royalblue: 4286945,
                    saddlebrown: 9127187,
                    salmon: 16416882,
                    sandybrown: 16032864,
                    seagreen: 3050327,
                    seashell: 16774638,
                    sienna: 10506797,
                    silver: 12632256,
                    skyblue: 8900331,
                    slateblue: 6970061,
                    slategray: 7372944,
                    slategrey: 7372944,
                    snow: 16775930,
                    springgreen: 65407,
                    steelblue: 4620980,
                    tan: 13808780,
                    teal: 32896,
                    thistle: 14204888,
                    tomato: 16737095,
                    turquoise: 4251856,
                    violet: 15631086,
                    wheat: 16113331,
                    white: 16777215,
                    whitesmoke: 16119285,
                    yellow: 16776960,
                    yellowgreen: 10145074
                }, P_ = {
                    h: 0,
                    s: 0,
                    l: 0
                }, z_ = {
                    h: 0,
                    s: 0,
                    l: 0
                };
                function hue2rgb(le1, vt, bt) {
                    return bt < 0 && (bt += 1), bt > 1 && (bt -= 1), bt < 1 / 6 ? le1 + 6 * (vt - le1) * bt : bt < .5 ? vt : bt < 2 / 3 ? le1 + 6 * (vt - le1) * (2 / 3 - bt) : le1;
                }
                class Color {
                    constructor(le1, vt, bt){
                        return this.isColor = !0, this.r = 1, this.g = 1, this.b = 1, this.set(le1, vt, bt);
                    }
                    set(le1, vt, bt) {
                        if (void 0 === vt && void 0 === bt) {
                            const vt = le1;
                            vt && vt.isColor ? this.copy(vt) : "number" === typeof vt ? this.setHex(vt) : "string" === typeof vt && this.setStyle(vt);
                        } else this.setRGB(le1, vt, bt);
                        return this;
                    }
                    setScalar(le1) {
                        return this.r = le1, this.g = le1, this.b = le1, this;
                    }
                    setHex(le1, vt) {
                        return void 0 === vt && (vt = Zg), le1 = Math.floor(le1), this.r = (le1 >> 16 & 255) / 255, this.g = (le1 >> 8 & 255) / 255, this.b = (255 & le1) / 255, xA.colorSpaceToWorking(this, vt), this;
                    }
                    setRGB(le1, vt, bt, ls) {
                        return void 0 === ls && (ls = xA.workingColorSpace), this.r = le1, this.g = vt, this.b = bt, xA.colorSpaceToWorking(this, ls), this;
                    }
                    setHSL(le1, vt, bt, ls) {
                        if (void 0 === ls && (ls = xA.workingColorSpace), le1 = euclideanModulo(le1, 1), vt = clamp(vt, 0, 1), bt = clamp(bt, 0, 1), 0 === vt) this.r = this.g = this.b = bt;
                        else {
                            const ls = bt <= .5 ? bt * (1 + vt) : bt + vt - bt * vt, ho = 2 * bt - ls;
                            this.r = hue2rgb(ho, ls, le1 + 1 / 3), this.g = hue2rgb(ho, ls, le1), this.b = hue2rgb(ho, ls, le1 - 1 / 3);
                        }
                        return xA.colorSpaceToWorking(this, ls), this;
                    }
                    setStyle(le1, vt) {
                        function handleAlpha(vt) {
                            void 0 !== vt && parseFloat(vt) < 1 && console.warn("THREE.Color: Alpha component of " + le1 + " will be ignored.");
                        }
                        let bt;
                        if (void 0 === vt && (vt = Zg), bt = /^(\w+)\(([^\)]*)\)/.exec(le1)) {
                            let ls;
                            const ho = bt[1], Dl = bt[2];
                            switch(ho){
                                case "rgb":
                                case "rgba":
                                    if (ls = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Dl)) return handleAlpha(ls[4]), this.setRGB(Math.min(255, parseInt(ls[1], 10)) / 255, Math.min(255, parseInt(ls[2], 10)) / 255, Math.min(255, parseInt(ls[3], 10)) / 255, vt);
                                    if (ls = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Dl)) return handleAlpha(ls[4]), this.setRGB(Math.min(100, parseInt(ls[1], 10)) / 100, Math.min(100, parseInt(ls[2], 10)) / 100, Math.min(100, parseInt(ls[3], 10)) / 100, vt);
                                    break;
                                case "hsl":
                                case "hsla":
                                    if (ls = /^\s*(\d*\.?\d+)\s*,\s*(\d*\.?\d+)\%\s*,\s*(\d*\.?\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(Dl)) return handleAlpha(ls[4]), this.setHSL(parseFloat(ls[1]) / 360, parseFloat(ls[2]) / 100, parseFloat(ls[3]) / 100, vt);
                                    break;
                                default:
                                    console.warn("THREE.Color: Unknown color model " + le1);
                            }
                        } else if (bt = /^\#([A-Fa-f\d]+)$/.exec(le1)) {
                            const ls = bt[1], ho = ls.length;
                            if (3 === ho) return this.setRGB(parseInt(ls.charAt(0), 16) / 15, parseInt(ls.charAt(1), 16) / 15, parseInt(ls.charAt(2), 16) / 15, vt);
                            if (6 === ho) return this.setHex(parseInt(ls, 16), vt);
                            console.warn("THREE.Color: Invalid hex color " + le1);
                        } else if (le1 && le1.length > 0) return this.setColorName(le1, vt);
                        return this;
                    }
                    setColorName(le1, vt) {
                        void 0 === vt && (vt = Zg);
                        const bt = L_[le1.toLowerCase()];
                        return void 0 !== bt ? this.setHex(bt, vt) : console.warn("THREE.Color: Unknown color " + le1), this;
                    }
                    clone() {
                        return new this.constructor(this.r, this.g, this.b);
                    }
                    copy(le1) {
                        return this.r = le1.r, this.g = le1.g, this.b = le1.b, this;
                    }
                    copySRGBToLinear(le1) {
                        return this.r = SRGBToLinear(le1.r), this.g = SRGBToLinear(le1.g), this.b = SRGBToLinear(le1.b), this;
                    }
                    copyLinearToSRGB(le1) {
                        return this.r = LinearToSRGB(le1.r), this.g = LinearToSRGB(le1.g), this.b = LinearToSRGB(le1.b), this;
                    }
                    convertSRGBToLinear() {
                        return this.copySRGBToLinear(this), this;
                    }
                    convertLinearToSRGB() {
                        return this.copyLinearToSRGB(this), this;
                    }
                    getHex(le1) {
                        return void 0 === le1 && (le1 = Zg), xA.workingToColorSpace(N_.copy(this), le1), 65536 * Math.round(clamp(255 * N_.r, 0, 255)) + 256 * Math.round(clamp(255 * N_.g, 0, 255)) + Math.round(clamp(255 * N_.b, 0, 255));
                    }
                    getHexString(le1) {
                        return void 0 === le1 && (le1 = Zg), ("000000" + this.getHex(le1).toString(16)).slice(-6);
                    }
                    getHSL(le1, vt) {
                        void 0 === vt && (vt = xA.workingColorSpace), xA.workingToColorSpace(N_.copy(this), vt);
                        const bt = N_.r, ls = N_.g, ho = N_.b, Dl = Math.max(bt, ls, ho), Fl = Math.min(bt, ls, ho);
                        let sc, uc;
                        const mc = (Fl + Dl) / 2;
                        if (Fl === Dl) sc = 0, uc = 0;
                        else {
                            const le1 = Dl - Fl;
                            switch(uc = mc <= .5 ? le1 / (Dl + Fl) : le1 / (2 - Dl - Fl), Dl){
                                case bt:
                                    sc = (ls - ho) / le1 + (ls < ho ? 6 : 0);
                                    break;
                                case ls:
                                    sc = (ho - bt) / le1 + 2;
                                    break;
                                case ho:
                                    sc = (bt - ls) / le1 + 4;
                            }
                            sc /= 6;
                        }
                        return le1.h = sc, le1.s = uc, le1.l = mc, le1;
                    }
                    getRGB(le1, vt) {
                        return void 0 === vt && (vt = xA.workingColorSpace), xA.workingToColorSpace(N_.copy(this), vt), le1.r = N_.r, le1.g = N_.g, le1.b = N_.b, le1;
                    }
                    getStyle(le1) {
                        void 0 === le1 && (le1 = Zg), xA.workingToColorSpace(N_.copy(this), le1);
                        const vt = N_.r, bt = N_.g, ls = N_.b;
                        return le1 !== Zg ? `color(${le1} ${vt.toFixed(3)} ${bt.toFixed(3)} ${ls.toFixed(3)})` : `rgb(${Math.round(255 * vt)},${Math.round(255 * bt)},${Math.round(255 * ls)})`;
                    }
                    offsetHSL(le1, vt, bt) {
                        return this.getHSL(P_), this.setHSL(P_.h + le1, P_.s + vt, P_.l + bt);
                    }
                    add(le1) {
                        return this.r += le1.r, this.g += le1.g, this.b += le1.b, this;
                    }
                    addColors(le1, vt) {
                        return this.r = le1.r + vt.r, this.g = le1.g + vt.g, this.b = le1.b + vt.b, this;
                    }
                    addScalar(le1) {
                        return this.r += le1, this.g += le1, this.b += le1, this;
                    }
                    sub(le1) {
                        return this.r = Math.max(0, this.r - le1.r), this.g = Math.max(0, this.g - le1.g), this.b = Math.max(0, this.b - le1.b), this;
                    }
                    multiply(le1) {
                        return this.r *= le1.r, this.g *= le1.g, this.b *= le1.b, this;
                    }
                    multiplyScalar(le1) {
                        return this.r *= le1, this.g *= le1, this.b *= le1, this;
                    }
                    lerp(le1, vt) {
                        return this.r += (le1.r - this.r) * vt, this.g += (le1.g - this.g) * vt, this.b += (le1.b - this.b) * vt, this;
                    }
                    lerpColors(le1, vt, bt) {
                        return this.r = le1.r + (vt.r - le1.r) * bt, this.g = le1.g + (vt.g - le1.g) * bt, this.b = le1.b + (vt.b - le1.b) * bt, this;
                    }
                    lerpHSL(le1, vt) {
                        this.getHSL(P_), le1.getHSL(z_);
                        const bt = lerp(P_.h, z_.h, vt), ls = lerp(P_.s, z_.s, vt), ho = lerp(P_.l, z_.l, vt);
                        return this.setHSL(bt, ls, ho), this;
                    }
                    setFromVector3(le1) {
                        return this.r = le1.x, this.g = le1.y, this.b = le1.z, this;
                    }
                    applyMatrix3(le1) {
                        const vt = this.r, bt = this.g, ls = this.b, ho = le1.elements;
                        return this.r = ho[0] * vt + ho[3] * bt + ho[6] * ls, this.g = ho[1] * vt + ho[4] * bt + ho[7] * ls, this.b = ho[2] * vt + ho[5] * bt + ho[8] * ls, this;
                    }
                    equals(le1) {
                        return le1.r === this.r && le1.g === this.g && le1.b === this.b;
                    }
                    fromArray(le1, vt) {
                        return void 0 === vt && (vt = 0), this.r = le1[vt], this.g = le1[vt + 1], this.b = le1[vt + 2], this;
                    }
                    toArray(le1, vt) {
                        return void 0 === le1 && (le1 = []), void 0 === vt && (vt = 0), le1[vt] = this.r, le1[vt + 1] = this.g, le1[vt + 2] = this.b, le1;
                    }
                    fromBufferAttribute(le1, vt) {
                        return this.r = le1.getX(vt), this.g = le1.getY(vt), this.b = le1.getZ(vt), this;
                    }
                    toJSON() {
                        return this.getHex();
                    }
                    *[Symbol.iterator]() {
                        yield this.r, yield this.g, yield this.b;
                    }
                }
                const N_ = new Color;
                Color.NAMES = L_;
                let R_ = 0;
                class Material extends EventDispatcher {
                    constructor(){
                        super(), this.isMaterial = !0, Object.defineProperty(this, "id", {
                            value: R_++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "Material", this.blending = du, this.side = gc, this.vertexColors = !1, this.opacity = 1, this.transparent = !1, this.alphaHash = !1, this.blendSrc = Yd, this.blendDst = Qd, this.blendEquation = Rd, this.blendSrcAlpha = null, this.blendDstAlpha = null, this.blendEquationAlpha = null, this.blendColor = new Color(0, 0, 0), this.blendAlpha = 0, this.depthFunc = om, this.depthTest = !0, this.depthWrite = !0, this.stencilWriteMask = 255, this.stencilFunc = 519, this.stencilRef = 0, this.stencilFuncMask = 255, this.stencilFail = Kg, this.stencilZFail = Kg, this.stencilZPass = Kg, this.stencilWrite = !1, this.clippingPlanes = null, this.clipIntersection = !1, this.clipShadows = !1, this.shadowSide = null, this.colorWrite = !0, this.precision = null, this.polygonOffset = !1, this.polygonOffsetFactor = 0, this.polygonOffsetUnits = 0, this.dithering = !1, this.alphaToCoverage = !1, this.premultipliedAlpha = !1, this.forceSinglePass = !1, this.allowOverride = !0, this.visible = !0, this.toneMapped = !0, this.userData = {}, this.version = 0, this._alphaTest = 0;
                    }
                    get alphaTest() {
                        return this._alphaTest;
                    }
                    set alphaTest(le1) {
                        this._alphaTest > 0 !== le1 > 0 && this.version++, this._alphaTest = le1;
                    }
                    onBeforeRender() {}
                    onBeforeCompile() {}
                    customProgramCacheKey() {
                        return this.onBeforeCompile.toString();
                    }
                    setValues(le1) {
                        if (void 0 !== le1) for(const vt in le1){
                            const bt = le1[vt];
                            if (void 0 === bt) {
                                console.warn(`THREE.Material: parameter '${vt}' has value of undefined.`);
                                continue;
                            }
                            const ls = this[vt];
                            void 0 !== ls ? ls && ls.isColor ? ls.set(bt) : ls && ls.isVector3 && bt && bt.isVector3 ? ls.copy(bt) : this[vt] = bt : console.warn(`THREE.Material: '${vt}' is not a property of THREE.${this.type}.`);
                        }
                    }
                    toJSON(le1) {
                        const vt = void 0 === le1 || "string" === typeof le1;
                        vt && (le1 = {
                            textures: {},
                            images: {}
                        });
                        const bt = {
                            metadata: {
                                version: 4.7,
                                type: "Material",
                                generator: "Material.toJSON"
                            }
                        };
                        function extractFromCache(le1) {
                            const vt = [];
                            for(const bt in le1){
                                const ls = le1[bt];
                                delete ls.metadata, vt.push(ls);
                            }
                            return vt;
                        }
                        if (bt.uuid = this.uuid, bt.type = this.type, "" !== this.name && (bt.name = this.name), this.color && this.color.isColor && (bt.color = this.color.getHex()), void 0 !== this.roughness && (bt.roughness = this.roughness), void 0 !== this.metalness && (bt.metalness = this.metalness), void 0 !== this.sheen && (bt.sheen = this.sheen), this.sheenColor && this.sheenColor.isColor && (bt.sheenColor = this.sheenColor.getHex()), void 0 !== this.sheenRoughness && (bt.sheenRoughness = this.sheenRoughness), this.emissive && this.emissive.isColor && (bt.emissive = this.emissive.getHex()), void 0 !== this.emissiveIntensity && 1 !== this.emissiveIntensity && (bt.emissiveIntensity = this.emissiveIntensity), this.specular && this.specular.isColor && (bt.specular = this.specular.getHex()), void 0 !== this.specularIntensity && (bt.specularIntensity = this.specularIntensity), this.specularColor && this.specularColor.isColor && (bt.specularColor = this.specularColor.getHex()), void 0 !== this.shininess && (bt.shininess = this.shininess), void 0 !== this.clearcoat && (bt.clearcoat = this.clearcoat), void 0 !== this.clearcoatRoughness && (bt.clearcoatRoughness = this.clearcoatRoughness), this.clearcoatMap && this.clearcoatMap.isTexture && (bt.clearcoatMap = this.clearcoatMap.toJSON(le1).uuid), this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture && (bt.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(le1).uuid), this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture && (bt.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(le1).uuid, bt.clearcoatNormalScale = this.clearcoatNormalScale.toArray()), void 0 !== this.dispersion && (bt.dispersion = this.dispersion), void 0 !== this.iridescence && (bt.iridescence = this.iridescence), void 0 !== this.iridescenceIOR && (bt.iridescenceIOR = this.iridescenceIOR), void 0 !== this.iridescenceThicknessRange && (bt.iridescenceThicknessRange = this.iridescenceThicknessRange), this.iridescenceMap && this.iridescenceMap.isTexture && (bt.iridescenceMap = this.iridescenceMap.toJSON(le1).uuid), this.iridescenceThicknessMap && this.iridescenceThicknessMap.isTexture && (bt.iridescenceThicknessMap = this.iridescenceThicknessMap.toJSON(le1).uuid), void 0 !== this.anisotropy && (bt.anisotropy = this.anisotropy), void 0 !== this.anisotropyRotation && (bt.anisotropyRotation = this.anisotropyRotation), this.anisotropyMap && this.anisotropyMap.isTexture && (bt.anisotropyMap = this.anisotropyMap.toJSON(le1).uuid), this.map && this.map.isTexture && (bt.map = this.map.toJSON(le1).uuid), this.matcap && this.matcap.isTexture && (bt.matcap = this.matcap.toJSON(le1).uuid), this.alphaMap && this.alphaMap.isTexture && (bt.alphaMap = this.alphaMap.toJSON(le1).uuid), this.lightMap && this.lightMap.isTexture && (bt.lightMap = this.lightMap.toJSON(le1).uuid, bt.lightMapIntensity = this.lightMapIntensity), this.aoMap && this.aoMap.isTexture && (bt.aoMap = this.aoMap.toJSON(le1).uuid, bt.aoMapIntensity = this.aoMapIntensity), this.bumpMap && this.bumpMap.isTexture && (bt.bumpMap = this.bumpMap.toJSON(le1).uuid, bt.bumpScale = this.bumpScale), this.normalMap && this.normalMap.isTexture && (bt.normalMap = this.normalMap.toJSON(le1).uuid, bt.normalMapType = this.normalMapType, bt.normalScale = this.normalScale.toArray()), this.displacementMap && this.displacementMap.isTexture && (bt.displacementMap = this.displacementMap.toJSON(le1).uuid, bt.displacementScale = this.displacementScale, bt.displacementBias = this.displacementBias), this.roughnessMap && this.roughnessMap.isTexture && (bt.roughnessMap = this.roughnessMap.toJSON(le1).uuid), this.metalnessMap && this.metalnessMap.isTexture && (bt.metalnessMap = this.metalnessMap.toJSON(le1).uuid), this.emissiveMap && this.emissiveMap.isTexture && (bt.emissiveMap = this.emissiveMap.toJSON(le1).uuid), this.specularMap && this.specularMap.isTexture && (bt.specularMap = this.specularMap.toJSON(le1).uuid), this.specularIntensityMap && this.specularIntensityMap.isTexture && (bt.specularIntensityMap = this.specularIntensityMap.toJSON(le1).uuid), this.specularColorMap && this.specularColorMap.isTexture && (bt.specularColorMap = this.specularColorMap.toJSON(le1).uuid), this.envMap && this.envMap.isTexture && (bt.envMap = this.envMap.toJSON(le1).uuid, void 0 !== this.combine && (bt.combine = this.combine)), void 0 !== this.envMapRotation && (bt.envMapRotation = this.envMapRotation.toArray()), void 0 !== this.envMapIntensity && (bt.envMapIntensity = this.envMapIntensity), void 0 !== this.reflectivity && (bt.reflectivity = this.reflectivity), void 0 !== this.refractionRatio && (bt.refractionRatio = this.refractionRatio), this.gradientMap && this.gradientMap.isTexture && (bt.gradientMap = this.gradientMap.toJSON(le1).uuid), void 0 !== this.transmission && (bt.transmission = this.transmission), this.transmissionMap && this.transmissionMap.isTexture && (bt.transmissionMap = this.transmissionMap.toJSON(le1).uuid), void 0 !== this.thickness && (bt.thickness = this.thickness), this.thicknessMap && this.thicknessMap.isTexture && (bt.thicknessMap = this.thicknessMap.toJSON(le1).uuid), void 0 !== this.attenuationDistance && this.attenuationDistance !== 1 / 0 && (bt.attenuationDistance = this.attenuationDistance), void 0 !== this.attenuationColor && (bt.attenuationColor = this.attenuationColor.getHex()), void 0 !== this.size && (bt.size = this.size), null !== this.shadowSide && (bt.shadowSide = this.shadowSide), void 0 !== this.sizeAttenuation && (bt.sizeAttenuation = this.sizeAttenuation), this.blending !== du && (bt.blending = this.blending), this.side !== gc && (bt.side = this.side), !0 === this.vertexColors && (bt.vertexColors = !0), this.opacity < 1 && (bt.opacity = this.opacity), !0 === this.transparent && (bt.transparent = !0), this.blendSrc !== Yd && (bt.blendSrc = this.blendSrc), this.blendDst !== Qd && (bt.blendDst = this.blendDst), this.blendEquation !== Rd && (bt.blendEquation = this.blendEquation), null !== this.blendSrcAlpha && (bt.blendSrcAlpha = this.blendSrcAlpha), null !== this.blendDstAlpha && (bt.blendDstAlpha = this.blendDstAlpha), null !== this.blendEquationAlpha && (bt.blendEquationAlpha = this.blendEquationAlpha), this.blendColor && this.blendColor.isColor && (bt.blendColor = this.blendColor.getHex()), 0 !== this.blendAlpha && (bt.blendAlpha = this.blendAlpha), this.depthFunc !== om && (bt.depthFunc = this.depthFunc), !1 === this.depthTest && (bt.depthTest = this.depthTest), !1 === this.depthWrite && (bt.depthWrite = this.depthWrite), !1 === this.colorWrite && (bt.colorWrite = this.colorWrite), 255 !== this.stencilWriteMask && (bt.stencilWriteMask = this.stencilWriteMask), 519 !== this.stencilFunc && (bt.stencilFunc = this.stencilFunc), 0 !== this.stencilRef && (bt.stencilRef = this.stencilRef), 255 !== this.stencilFuncMask && (bt.stencilFuncMask = this.stencilFuncMask), this.stencilFail !== Kg && (bt.stencilFail = this.stencilFail), this.stencilZFail !== Kg && (bt.stencilZFail = this.stencilZFail), this.stencilZPass !== Kg && (bt.stencilZPass = this.stencilZPass), !0 === this.stencilWrite && (bt.stencilWrite = this.stencilWrite), void 0 !== this.rotation && 0 !== this.rotation && (bt.rotation = this.rotation), !0 === this.polygonOffset && (bt.polygonOffset = !0), 0 !== this.polygonOffsetFactor && (bt.polygonOffsetFactor = this.polygonOffsetFactor), 0 !== this.polygonOffsetUnits && (bt.polygonOffsetUnits = this.polygonOffsetUnits), void 0 !== this.linewidth && 1 !== this.linewidth && (bt.linewidth = this.linewidth), void 0 !== this.dashSize && (bt.dashSize = this.dashSize), void 0 !== this.gapSize && (bt.gapSize = this.gapSize), void 0 !== this.scale && (bt.scale = this.scale), !0 === this.dithering && (bt.dithering = !0), this.alphaTest > 0 && (bt.alphaTest = this.alphaTest), !0 === this.alphaHash && (bt.alphaHash = !0), !0 === this.alphaToCoverage && (bt.alphaToCoverage = !0), !0 === this.premultipliedAlpha && (bt.premultipliedAlpha = !0), !0 === this.forceSinglePass && (bt.forceSinglePass = !0), !0 === this.wireframe && (bt.wireframe = !0), this.wireframeLinewidth > 1 && (bt.wireframeLinewidth = this.wireframeLinewidth), "round" !== this.wireframeLinecap && (bt.wireframeLinecap = this.wireframeLinecap), "round" !== this.wireframeLinejoin && (bt.wireframeLinejoin = this.wireframeLinejoin), !0 === this.flatShading && (bt.flatShading = !0), !1 === this.visible && (bt.visible = !1), !1 === this.toneMapped && (bt.toneMapped = !1), !1 === this.fog && (bt.fog = !1), Object.keys(this.userData).length > 0 && (bt.userData = this.userData), vt) {
                            const vt = extractFromCache(le1.textures), ls = extractFromCache(le1.images);
                            vt.length > 0 && (bt.textures = vt), ls.length > 0 && (bt.images = ls);
                        }
                        return bt;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        this.name = le1.name, this.blending = le1.blending, this.side = le1.side, this.vertexColors = le1.vertexColors, this.opacity = le1.opacity, this.transparent = le1.transparent, this.blendSrc = le1.blendSrc, this.blendDst = le1.blendDst, this.blendEquation = le1.blendEquation, this.blendSrcAlpha = le1.blendSrcAlpha, this.blendDstAlpha = le1.blendDstAlpha, this.blendEquationAlpha = le1.blendEquationAlpha, this.blendColor.copy(le1.blendColor), this.blendAlpha = le1.blendAlpha, this.depthFunc = le1.depthFunc, this.depthTest = le1.depthTest, this.depthWrite = le1.depthWrite, this.stencilWriteMask = le1.stencilWriteMask, this.stencilFunc = le1.stencilFunc, this.stencilRef = le1.stencilRef, this.stencilFuncMask = le1.stencilFuncMask, this.stencilFail = le1.stencilFail, this.stencilZFail = le1.stencilZFail, this.stencilZPass = le1.stencilZPass, this.stencilWrite = le1.stencilWrite;
                        const vt = le1.clippingPlanes;
                        let bt = null;
                        if (null !== vt) {
                            const le1 = vt.length;
                            bt = new Array(le1);
                            for(let ls = 0; ls !== le1; ++ls)bt[ls] = vt[ls].clone();
                        }
                        return this.clippingPlanes = bt, this.clipIntersection = le1.clipIntersection, this.clipShadows = le1.clipShadows, this.shadowSide = le1.shadowSide, this.colorWrite = le1.colorWrite, this.precision = le1.precision, this.polygonOffset = le1.polygonOffset, this.polygonOffsetFactor = le1.polygonOffsetFactor, this.polygonOffsetUnits = le1.polygonOffsetUnits, this.dithering = le1.dithering, this.alphaTest = le1.alphaTest, this.alphaHash = le1.alphaHash, this.alphaToCoverage = le1.alphaToCoverage, this.premultipliedAlpha = le1.premultipliedAlpha, this.forceSinglePass = le1.forceSinglePass, this.visible = le1.visible, this.toneMapped = le1.toneMapped, this.userData = JSON.parse(JSON.stringify(le1.userData)), this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                    set needsUpdate(le1) {
                        !0 === le1 && this.version++;
                    }
                }
                class MeshBasicMaterial extends Material {
                    constructor(le1){
                        super(), this.isMeshBasicMaterial = !0, this.type = "MeshBasicMaterial", this.color = new Color(16777215), this.map = null, this.lightMap = null, this.lightMapIntensity = 1, this.aoMap = null, this.aoMapIntensity = 1, this.specularMap = null, this.alphaMap = null, this.envMap = null, this.envMapRotation = new Euler, this.combine = dm, this.reflectivity = 1, this.refractionRatio = .98, this.wireframe = !1, this.wireframeLinewidth = 1, this.wireframeLinecap = "round", this.wireframeLinejoin = "round", this.fog = !0, this.setValues(le1);
                    }
                    copy(le1) {
                        return super.copy(le1), this.color.copy(le1.color), this.map = le1.map, this.lightMap = le1.lightMap, this.lightMapIntensity = le1.lightMapIntensity, this.aoMap = le1.aoMap, this.aoMapIntensity = le1.aoMapIntensity, this.specularMap = le1.specularMap, this.alphaMap = le1.alphaMap, this.envMap = le1.envMap, this.envMapRotation.copy(le1.envMapRotation), this.combine = le1.combine, this.reflectivity = le1.reflectivity, this.refractionRatio = le1.refractionRatio, this.wireframe = le1.wireframe, this.wireframeLinewidth = le1.wireframeLinewidth, this.wireframeLinecap = le1.wireframeLinecap, this.wireframeLinejoin = le1.wireframeLinejoin, this.fog = le1.fog, this;
                    }
                }
                const F_ = new Vector3, O_ = new Vector2;
                let B_ = 0;
                class BufferAttribute {
                    constructor(le1, vt, bt){
                        if (void 0 === bt && (bt = !1), Array.isArray(le1)) throw new TypeError("THREE.BufferAttribute: array should be a Typed Array.");
                        this.isBufferAttribute = !0, Object.defineProperty(this, "id", {
                            value: B_++
                        }), this.name = "", this.array = le1, this.itemSize = vt, this.count = void 0 !== le1 ? le1.length / vt : 0, this.normalized = bt, this.usage = sA, this.updateRanges = [], this.gpuType = Gm, this.version = 0;
                    }
                    onUploadCallback() {}
                    set needsUpdate(le1) {
                        !0 === le1 && this.version++;
                    }
                    setUsage(le1) {
                        return this.usage = le1, this;
                    }
                    addUpdateRange(le1, vt) {
                        this.updateRanges.push({
                            start: le1,
                            count: vt
                        });
                    }
                    clearUpdateRanges() {
                        this.updateRanges.length = 0;
                    }
                    copy(le1) {
                        return this.name = le1.name, this.array = new le1.array.constructor(le1.array), this.itemSize = le1.itemSize, this.count = le1.count, this.normalized = le1.normalized, this.usage = le1.usage, this.gpuType = le1.gpuType, this;
                    }
                    copyAt(le1, vt, bt) {
                        le1 *= this.itemSize, bt *= vt.itemSize;
                        for(let ls = 0, ho = this.itemSize; ls < ho; ls++)this.array[le1 + ls] = vt.array[bt + ls];
                        return this;
                    }
                    copyArray(le1) {
                        return this.array.set(le1), this;
                    }
                    applyMatrix3(le1) {
                        if (2 === this.itemSize) for(let vt = 0, bt = this.count; vt < bt; vt++)O_.fromBufferAttribute(this, vt), O_.applyMatrix3(le1), this.setXY(vt, O_.x, O_.y);
                        else if (3 === this.itemSize) for(let vt = 0, bt = this.count; vt < bt; vt++)F_.fromBufferAttribute(this, vt), F_.applyMatrix3(le1), this.setXYZ(vt, F_.x, F_.y, F_.z);
                        return this;
                    }
                    applyMatrix4(le1) {
                        for(let vt = 0, bt = this.count; vt < bt; vt++)F_.fromBufferAttribute(this, vt), F_.applyMatrix4(le1), this.setXYZ(vt, F_.x, F_.y, F_.z);
                        return this;
                    }
                    applyNormalMatrix(le1) {
                        for(let vt = 0, bt = this.count; vt < bt; vt++)F_.fromBufferAttribute(this, vt), F_.applyNormalMatrix(le1), this.setXYZ(vt, F_.x, F_.y, F_.z);
                        return this;
                    }
                    transformDirection(le1) {
                        for(let vt = 0, bt = this.count; vt < bt; vt++)F_.fromBufferAttribute(this, vt), F_.transformDirection(le1), this.setXYZ(vt, F_.x, F_.y, F_.z);
                        return this;
                    }
                    set(le1, vt) {
                        return void 0 === vt && (vt = 0), this.array.set(le1, vt), this;
                    }
                    getComponent(le1, vt) {
                        let bt = this.array[le1 * this.itemSize + vt];
                        return this.normalized && (bt = denormalize(bt, this.array)), bt;
                    }
                    setComponent(le1, vt, bt) {
                        return this.normalized && (bt = normalize(bt, this.array)), this.array[le1 * this.itemSize + vt] = bt, this;
                    }
                    getX(le1) {
                        let vt = this.array[le1 * this.itemSize];
                        return this.normalized && (vt = denormalize(vt, this.array)), vt;
                    }
                    setX(le1, vt) {
                        return this.normalized && (vt = normalize(vt, this.array)), this.array[le1 * this.itemSize] = vt, this;
                    }
                    getY(le1) {
                        let vt = this.array[le1 * this.itemSize + 1];
                        return this.normalized && (vt = denormalize(vt, this.array)), vt;
                    }
                    setY(le1, vt) {
                        return this.normalized && (vt = normalize(vt, this.array)), this.array[le1 * this.itemSize + 1] = vt, this;
                    }
                    getZ(le1) {
                        let vt = this.array[le1 * this.itemSize + 2];
                        return this.normalized && (vt = denormalize(vt, this.array)), vt;
                    }
                    setZ(le1, vt) {
                        return this.normalized && (vt = normalize(vt, this.array)), this.array[le1 * this.itemSize + 2] = vt, this;
                    }
                    getW(le1) {
                        let vt = this.array[le1 * this.itemSize + 3];
                        return this.normalized && (vt = denormalize(vt, this.array)), vt;
                    }
                    setW(le1, vt) {
                        return this.normalized && (vt = normalize(vt, this.array)), this.array[le1 * this.itemSize + 3] = vt, this;
                    }
                    setXY(le1, vt, bt) {
                        return le1 *= this.itemSize, this.normalized && (vt = normalize(vt, this.array), bt = normalize(bt, this.array)), this.array[le1 + 0] = vt, this.array[le1 + 1] = bt, this;
                    }
                    setXYZ(le1, vt, bt, ls) {
                        return le1 *= this.itemSize, this.normalized && (vt = normalize(vt, this.array), bt = normalize(bt, this.array), ls = normalize(ls, this.array)), this.array[le1 + 0] = vt, this.array[le1 + 1] = bt, this.array[le1 + 2] = ls, this;
                    }
                    setXYZW(le1, vt, bt, ls, ho) {
                        return le1 *= this.itemSize, this.normalized && (vt = normalize(vt, this.array), bt = normalize(bt, this.array), ls = normalize(ls, this.array), ho = normalize(ho, this.array)), this.array[le1 + 0] = vt, this.array[le1 + 1] = bt, this.array[le1 + 2] = ls, this.array[le1 + 3] = ho, this;
                    }
                    onUpload(le1) {
                        return this.onUploadCallback = le1, this;
                    }
                    clone() {
                        return new this.constructor(this.array, this.itemSize).copy(this);
                    }
                    toJSON() {
                        const le1 = {
                            itemSize: this.itemSize,
                            type: this.array.constructor.name,
                            array: Array.from(this.array),
                            normalized: this.normalized
                        };
                        return "" !== this.name && (le1.name = this.name), this.usage !== sA && (le1.usage = this.usage), le1;
                    }
                }
                class Uint16BufferAttribute extends BufferAttribute {
                    constructor(le1, vt, bt){
                        super(new Uint16Array(le1), vt, bt);
                    }
                }
                class Uint32BufferAttribute extends BufferAttribute {
                    constructor(le1, vt, bt){
                        super(new Uint32Array(le1), vt, bt);
                    }
                }
                class Float32BufferAttribute extends BufferAttribute {
                    constructor(le1, vt, bt){
                        super(new Float32Array(le1), vt, bt);
                    }
                }
                let j_ = 0;
                const U_ = new Matrix4, V_ = new Object3D, G_ = new Vector3, q_ = new Box3, H_ = new Box3, W_ = new Vector3;
                class BufferGeometry extends EventDispatcher {
                    constructor(){
                        super(), this.isBufferGeometry = !0, Object.defineProperty(this, "id", {
                            value: j_++
                        }), this.uuid = generateUUID(), this.name = "", this.type = "BufferGeometry", this.index = null, this.indirect = null, this.attributes = {}, this.morphAttributes = {}, this.morphTargetsRelative = !1, this.groups = [], this.boundingBox = null, this.boundingSphere = null, this.drawRange = {
                            start: 0,
                            count: 1 / 0
                        }, this.userData = {};
                    }
                    getIndex() {
                        return this.index;
                    }
                    setIndex(le1) {
                        return Array.isArray(le1) ? this.index = new (arrayNeedsUint32(le1) ? Uint32BufferAttribute : Uint16BufferAttribute)(le1, 1) : this.index = le1, this;
                    }
                    setIndirect(le1) {
                        return this.indirect = le1, this;
                    }
                    getIndirect() {
                        return this.indirect;
                    }
                    getAttribute(le1) {
                        return this.attributes[le1];
                    }
                    setAttribute(le1, vt) {
                        return this.attributes[le1] = vt, this;
                    }
                    deleteAttribute(le1) {
                        return delete this.attributes[le1], this;
                    }
                    hasAttribute(le1) {
                        return void 0 !== this.attributes[le1];
                    }
                    addGroup(le1, vt, bt) {
                        void 0 === bt && (bt = 0), this.groups.push({
                            start: le1,
                            count: vt,
                            materialIndex: bt
                        });
                    }
                    clearGroups() {
                        this.groups = [];
                    }
                    setDrawRange(le1, vt) {
                        this.drawRange.start = le1, this.drawRange.count = vt;
                    }
                    applyMatrix4(le1) {
                        const vt = this.attributes.position;
                        void 0 !== vt && (vt.applyMatrix4(le1), vt.needsUpdate = !0);
                        const bt = this.attributes.normal;
                        if (void 0 !== bt) {
                            const vt = (new Matrix3).getNormalMatrix(le1);
                            bt.applyNormalMatrix(vt), bt.needsUpdate = !0;
                        }
                        const ls = this.attributes.tangent;
                        return void 0 !== ls && (ls.transformDirection(le1), ls.needsUpdate = !0), null !== this.boundingBox && this.computeBoundingBox(), null !== this.boundingSphere && this.computeBoundingSphere(), this;
                    }
                    applyQuaternion(le1) {
                        return U_.makeRotationFromQuaternion(le1), this.applyMatrix4(U_), this;
                    }
                    rotateX(le1) {
                        return U_.makeRotationX(le1), this.applyMatrix4(U_), this;
                    }
                    rotateY(le1) {
                        return U_.makeRotationY(le1), this.applyMatrix4(U_), this;
                    }
                    rotateZ(le1) {
                        return U_.makeRotationZ(le1), this.applyMatrix4(U_), this;
                    }
                    translate(le1, vt, bt) {
                        return U_.makeTranslation(le1, vt, bt), this.applyMatrix4(U_), this;
                    }
                    scale(le1, vt, bt) {
                        return U_.makeScale(le1, vt, bt), this.applyMatrix4(U_), this;
                    }
                    lookAt(le1) {
                        return V_.lookAt(le1), V_.updateMatrix(), this.applyMatrix4(V_.matrix), this;
                    }
                    center() {
                        return this.computeBoundingBox(), this.boundingBox.getCenter(G_).negate(), this.translate(G_.x, G_.y, G_.z), this;
                    }
                    setFromPoints(le1) {
                        const vt = this.getAttribute("position");
                        if (void 0 === vt) {
                            const vt = [];
                            for(let bt = 0, ls = le1.length; bt < ls; bt++){
                                const ls = le1[bt];
                                vt.push(ls.x, ls.y, ls.z || 0);
                            }
                            this.setAttribute("position", new Float32BufferAttribute(vt, 3));
                        } else {
                            const bt = Math.min(le1.length, vt.count);
                            for(let ls = 0; ls < bt; ls++){
                                const bt = le1[ls];
                                vt.setXYZ(ls, bt.x, bt.y, bt.z || 0);
                            }
                            le1.length > vt.count && console.warn("THREE.BufferGeometry: Buffer size too small for points data. Use .dispose() and create a new geometry."), vt.needsUpdate = !0;
                        }
                        return this;
                    }
                    computeBoundingBox() {
                        null === this.boundingBox && (this.boundingBox = new Box3);
                        const le1 = this.attributes.position, vt = this.morphAttributes.position;
                        if (le1 && le1.isGLBufferAttribute) return console.error("THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box.", this), void this.boundingBox.set(new Vector3(-1 / 0, -1 / 0, -1 / 0), new Vector3(1 / 0, 1 / 0, 1 / 0));
                        if (void 0 !== le1) {
                            if (this.boundingBox.setFromBufferAttribute(le1), vt) for(let bt = 0, ls = vt.length; bt < ls; bt++){
                                const le1 = vt[bt];
                                q_.setFromBufferAttribute(le1), this.morphTargetsRelative ? (W_.addVectors(this.boundingBox.min, q_.min), this.boundingBox.expandByPoint(W_), W_.addVectors(this.boundingBox.max, q_.max), this.boundingBox.expandByPoint(W_)) : (this.boundingBox.expandByPoint(q_.min), this.boundingBox.expandByPoint(q_.max));
                            }
                        } else this.boundingBox.makeEmpty();
                        (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) && console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
                    }
                    computeBoundingSphere() {
                        null === this.boundingSphere && (this.boundingSphere = new Sphere);
                        const le1 = this.attributes.position, vt = this.morphAttributes.position;
                        if (le1 && le1.isGLBufferAttribute) return console.error("THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere.", this), void this.boundingSphere.set(new Vector3, 1 / 0);
                        if (le1) {
                            const bt = this.boundingSphere.center;
                            if (q_.setFromBufferAttribute(le1), vt) for(let le1 = 0, ho = vt.length; le1 < ho; le1++){
                                const bt = vt[le1];
                                H_.setFromBufferAttribute(bt), this.morphTargetsRelative ? (W_.addVectors(q_.min, H_.min), q_.expandByPoint(W_), W_.addVectors(q_.max, H_.max), q_.expandByPoint(W_)) : (q_.expandByPoint(H_.min), q_.expandByPoint(H_.max));
                            }
                            q_.getCenter(bt);
                            let ls = 0;
                            for(let vt = 0, ho = le1.count; vt < ho; vt++)W_.fromBufferAttribute(le1, vt), ls = Math.max(ls, bt.distanceToSquared(W_));
                            if (vt) for(let ho = 0, Dl = vt.length; ho < Dl; ho++){
                                const Dl = vt[ho], Fl = this.morphTargetsRelative;
                                for(let vt = 0, ho = Dl.count; vt < ho; vt++)W_.fromBufferAttribute(Dl, vt), Fl && (G_.fromBufferAttribute(le1, vt), W_.add(G_)), ls = Math.max(ls, bt.distanceToSquared(W_));
                            }
                            this.boundingSphere.radius = Math.sqrt(ls), isNaN(this.boundingSphere.radius) && console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
                        }
                    }
                    computeTangents() {
                        const le1 = this.index, vt = this.attributes;
                        if (null === le1 || void 0 === vt.position || void 0 === vt.normal || void 0 === vt.uv) return void console.error("THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)");
                        const bt = vt.position, ls = vt.normal, ho = vt.uv;
                        !1 === this.hasAttribute("tangent") && this.setAttribute("tangent", new BufferAttribute(new Float32Array(4 * bt.count), 4));
                        const Dl = this.getAttribute("tangent"), Fl = [], sc = [];
                        for(let jd = 0; jd < bt.count; jd++)Fl[jd] = new Vector3, sc[jd] = new Vector3;
                        const uc = new Vector3, mc = new Vector3, gc = new Vector3, Ac = new Vector2, Ec = new Vector2, kc = new Vector2, du = new Vector3, _u = new Vector3;
                        function handleTriangle(le1, vt, ls) {
                            uc.fromBufferAttribute(bt, le1), mc.fromBufferAttribute(bt, vt), gc.fromBufferAttribute(bt, ls), Ac.fromBufferAttribute(ho, le1), Ec.fromBufferAttribute(ho, vt), kc.fromBufferAttribute(ho, ls), mc.sub(uc), gc.sub(uc), Ec.sub(Ac), kc.sub(Ac);
                            const Dl = 1 / (Ec.x * kc.y - kc.x * Ec.y);
                            isFinite(Dl) && (du.copy(mc).multiplyScalar(kc.y).addScaledVector(gc, -Ec.y).multiplyScalar(Dl), _u.copy(gc).multiplyScalar(Ec.x).addScaledVector(mc, -kc.x).multiplyScalar(Dl), Fl[le1].add(du), Fl[vt].add(du), Fl[ls].add(du), sc[le1].add(_u), sc[vt].add(_u), sc[ls].add(_u));
                        }
                        let Md = this.groups;
                        0 === Md.length && (Md = [
                            {
                                start: 0,
                                count: le1.count
                            }
                        ]);
                        for(let jd = 0, Ud = Md.length; jd < Ud; ++jd){
                            const vt = Md[jd], bt = vt.start;
                            for(let ls = bt, ho = bt + vt.count; ls < ho; ls += 3)handleTriangle(le1.getX(ls + 0), le1.getX(ls + 1), le1.getX(ls + 2));
                        }
                        const Ld = new Vector3, Nd = new Vector3, Rd = new Vector3, Od = new Vector3;
                        function handleVertex(le1) {
                            Rd.fromBufferAttribute(ls, le1), Od.copy(Rd);
                            const vt = Fl[le1];
                            Ld.copy(vt), Ld.sub(Rd.multiplyScalar(Rd.dot(vt))).normalize(), Nd.crossVectors(Od, vt);
                            const bt = Nd.dot(sc[le1]) < 0 ? -1 : 1;
                            Dl.setXYZW(le1, Ld.x, Ld.y, Ld.z, bt);
                        }
                        for(let jd = 0, Ud = Md.length; jd < Ud; ++jd){
                            const vt = Md[jd], bt = vt.start;
                            for(let ls = bt, ho = bt + vt.count; ls < ho; ls += 3)handleVertex(le1.getX(ls + 0)), handleVertex(le1.getX(ls + 1)), handleVertex(le1.getX(ls + 2));
                        }
                    }
                    computeVertexNormals() {
                        const le1 = this.index, vt = this.getAttribute("position");
                        if (void 0 !== vt) {
                            let bt = this.getAttribute("normal");
                            if (void 0 === bt) bt = new BufferAttribute(new Float32Array(3 * vt.count), 3), this.setAttribute("normal", bt);
                            else for(let le1 = 0, vt = bt.count; le1 < vt; le1++)bt.setXYZ(le1, 0, 0, 0);
                            const ls = new Vector3, ho = new Vector3, Dl = new Vector3, Fl = new Vector3, sc = new Vector3, uc = new Vector3, mc = new Vector3, gc = new Vector3;
                            if (le1) for(let Ac = 0, Ec = le1.count; Ac < Ec; Ac += 3){
                                const Ec = le1.getX(Ac + 0), kc = le1.getX(Ac + 1), du = le1.getX(Ac + 2);
                                ls.fromBufferAttribute(vt, Ec), ho.fromBufferAttribute(vt, kc), Dl.fromBufferAttribute(vt, du), mc.subVectors(Dl, ho), gc.subVectors(ls, ho), mc.cross(gc), Fl.fromBufferAttribute(bt, Ec), sc.fromBufferAttribute(bt, kc), uc.fromBufferAttribute(bt, du), Fl.add(mc), sc.add(mc), uc.add(mc), bt.setXYZ(Ec, Fl.x, Fl.y, Fl.z), bt.setXYZ(kc, sc.x, sc.y, sc.z), bt.setXYZ(du, uc.x, uc.y, uc.z);
                            }
                            else for(let le1 = 0, Ac = vt.count; le1 < Ac; le1 += 3)ls.fromBufferAttribute(vt, le1 + 0), ho.fromBufferAttribute(vt, le1 + 1), Dl.fromBufferAttribute(vt, le1 + 2), mc.subVectors(Dl, ho), gc.subVectors(ls, ho), mc.cross(gc), bt.setXYZ(le1 + 0, mc.x, mc.y, mc.z), bt.setXYZ(le1 + 1, mc.x, mc.y, mc.z), bt.setXYZ(le1 + 2, mc.x, mc.y, mc.z);
                            this.normalizeNormals(), bt.needsUpdate = !0;
                        }
                    }
                    normalizeNormals() {
                        const le1 = this.attributes.normal;
                        for(let vt = 0, bt = le1.count; vt < bt; vt++)W_.fromBufferAttribute(le1, vt), W_.normalize(), le1.setXYZ(vt, W_.x, W_.y, W_.z);
                    }
                    toNonIndexed() {
                        function convertBufferAttribute(le1, vt) {
                            const bt = le1.array, ls = le1.itemSize, ho = le1.normalized, Dl = new bt.constructor(vt.length * ls);
                            let Fl = 0, sc = 0;
                            for(let uc = 0, mc = vt.length; uc < mc; uc++){
                                Fl = le1.isInterleavedBufferAttribute ? vt[uc] * le1.data.stride + le1.offset : vt[uc] * ls;
                                for(let le1 = 0; le1 < ls; le1++)Dl[sc++] = bt[Fl++];
                            }
                            return new BufferAttribute(Dl, ls, ho);
                        }
                        if (null === this.index) return console.warn("THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed."), this;
                        const le1 = new BufferGeometry, vt = this.index.array, bt = this.attributes;
                        for(const Dl in bt){
                            const ls = convertBufferAttribute(bt[Dl], vt);
                            le1.setAttribute(Dl, ls);
                        }
                        const ls = this.morphAttributes;
                        for(const Dl in ls){
                            const bt = [], ho = ls[Dl];
                            for(let le1 = 0, ls = ho.length; le1 < ls; le1++){
                                const ls = convertBufferAttribute(ho[le1], vt);
                                bt.push(ls);
                            }
                            le1.morphAttributes[Dl] = bt;
                        }
                        le1.morphTargetsRelative = this.morphTargetsRelative;
                        const ho = this.groups;
                        for(let Dl = 0, Fl = ho.length; Dl < Fl; Dl++){
                            const vt = ho[Dl];
                            le1.addGroup(vt.start, vt.count, vt.materialIndex);
                        }
                        return le1;
                    }
                    toJSON() {
                        const le1 = {
                            metadata: {
                                version: 4.7,
                                type: "BufferGeometry",
                                generator: "BufferGeometry.toJSON"
                            }
                        };
                        if (le1.uuid = this.uuid, le1.type = this.type, "" !== this.name && (le1.name = this.name), Object.keys(this.userData).length > 0 && (le1.userData = this.userData), void 0 !== this.parameters) {
                            const vt = this.parameters;
                            for(const bt in vt)void 0 !== vt[bt] && (le1[bt] = vt[bt]);
                            return le1;
                        }
                        le1.data = {
                            attributes: {}
                        };
                        const vt = this.index;
                        null !== vt && (le1.data.index = {
                            type: vt.array.constructor.name,
                            array: Array.prototype.slice.call(vt.array)
                        });
                        const bt = this.attributes;
                        for(const sc in bt){
                            const vt = bt[sc];
                            le1.data.attributes[sc] = vt.toJSON(le1.data);
                        }
                        const ls = {};
                        let ho = !1;
                        for(const sc in this.morphAttributes){
                            const vt = this.morphAttributes[sc], bt = [];
                            for(let ls = 0, ho = vt.length; ls < ho; ls++){
                                const ho = vt[ls];
                                bt.push(ho.toJSON(le1.data));
                            }
                            bt.length > 0 && (ls[sc] = bt, ho = !0);
                        }
                        ho && (le1.data.morphAttributes = ls, le1.data.morphTargetsRelative = this.morphTargetsRelative);
                        const Dl = this.groups;
                        Dl.length > 0 && (le1.data.groups = JSON.parse(JSON.stringify(Dl)));
                        const Fl = this.boundingSphere;
                        return null !== Fl && (le1.data.boundingSphere = Fl.toJSON()), le1;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                    copy(le1) {
                        this.index = null, this.attributes = {}, this.morphAttributes = {}, this.groups = [], this.boundingBox = null, this.boundingSphere = null;
                        const vt = {};
                        this.name = le1.name;
                        const bt = le1.index;
                        null !== bt && this.setIndex(bt.clone());
                        const ls = le1.attributes;
                        for(const uc in ls){
                            const le1 = ls[uc];
                            this.setAttribute(uc, le1.clone(vt));
                        }
                        const ho = le1.morphAttributes;
                        for(const uc in ho){
                            const le1 = [], bt = ho[uc];
                            for(let ls = 0, ho = bt.length; ls < ho; ls++)le1.push(bt[ls].clone(vt));
                            this.morphAttributes[uc] = le1;
                        }
                        this.morphTargetsRelative = le1.morphTargetsRelative;
                        const Dl = le1.groups;
                        for(let uc = 0, mc = Dl.length; uc < mc; uc++){
                            const le1 = Dl[uc];
                            this.addGroup(le1.start, le1.count, le1.materialIndex);
                        }
                        const Fl = le1.boundingBox;
                        null !== Fl && (this.boundingBox = Fl.clone());
                        const sc = le1.boundingSphere;
                        return null !== sc && (this.boundingSphere = sc.clone()), this.drawRange.start = le1.drawRange.start, this.drawRange.count = le1.drawRange.count, this.userData = le1.userData, this;
                    }
                    dispose() {
                        this.dispatchEvent({
                            type: "dispose"
                        });
                    }
                }
                const Z_ = new Matrix4, Y_ = new Ray, Q_ = new Sphere, X_ = new Vector3, K_ = new Vector3, J_ = new Vector3, $_ = new Vector3, ey = new Vector3, ty = new Vector3, iy = new Vector3, ny = new Vector3;
                class Mesh extends Object3D {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new BufferGeometry), void 0 === vt && (vt = new MeshBasicMaterial), super(), this.isMesh = !0, this.type = "Mesh", this.geometry = le1, this.material = vt, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.count = 1, this.updateMorphTargets();
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), void 0 !== le1.morphTargetInfluences && (this.morphTargetInfluences = le1.morphTargetInfluences.slice()), void 0 !== le1.morphTargetDictionary && (this.morphTargetDictionary = Object.assign({}, le1.morphTargetDictionary)), this.material = Array.isArray(le1.material) ? le1.material.slice() : le1.material, this.geometry = le1.geometry, this;
                    }
                    updateMorphTargets() {
                        const le1 = this.geometry.morphAttributes, vt = Object.keys(le1);
                        if (vt.length > 0) {
                            const bt = le1[vt[0]];
                            if (void 0 !== bt) {
                                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                                for(let le1 = 0, vt = bt.length; le1 < vt; le1++){
                                    const vt = bt[le1].name || String(le1);
                                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[vt] = le1;
                                }
                            }
                        }
                    }
                    getVertexPosition(le1, vt) {
                        const bt = this.geometry, ls = bt.attributes.position, ho = bt.morphAttributes.position, Dl = bt.morphTargetsRelative;
                        vt.fromBufferAttribute(ls, le1);
                        const Fl = this.morphTargetInfluences;
                        if (ho && Fl) {
                            ty.set(0, 0, 0);
                            for(let bt = 0, ls = ho.length; bt < ls; bt++){
                                const ls = Fl[bt], sc = ho[bt];
                                0 !== ls && (ey.fromBufferAttribute(sc, le1), Dl ? ty.addScaledVector(ey, ls) : ty.addScaledVector(ey.sub(vt), ls));
                            }
                            vt.add(ty);
                        }
                        return vt;
                    }
                    raycast(le1, vt) {
                        const bt = this.geometry, ls = this.material, ho = this.matrixWorld;
                        if (void 0 !== ls) {
                            if (null === bt.boundingSphere && bt.computeBoundingSphere(), Q_.copy(bt.boundingSphere), Q_.applyMatrix4(ho), Y_.copy(le1.ray).recast(le1.near), !1 === Q_.containsPoint(Y_.origin)) {
                                if (null === Y_.intersectSphere(Q_, X_)) return;
                                if (Y_.origin.distanceToSquared(X_) > (le1.far - le1.near) ** 2) return;
                            }
                            Z_.copy(ho).invert(), Y_.copy(le1.ray).applyMatrix4(Z_), null !== bt.boundingBox && !1 === Y_.intersectsBox(bt.boundingBox) || this._computeIntersections(le1, vt, Y_);
                        }
                    }
                    _computeIntersections(le1, vt, bt) {
                        let ls;
                        const ho = this.geometry, Dl = this.material, Fl = ho.index, sc = ho.attributes.position, uc = ho.attributes.uv, mc = ho.attributes.uv1, gc = ho.attributes.normal, Ac = ho.groups, Ec = ho.drawRange;
                        if (null !== Fl) {
                            if (Array.isArray(Dl)) for(let kc = 0, du = Ac.length; kc < du; kc++){
                                const ho = Ac[kc], sc = Dl[ho.materialIndex];
                                for(let Dl = Math.max(ho.start, Ec.start), Ac = Math.min(Fl.count, Math.min(ho.start + ho.count, Ec.start + Ec.count)); Dl < Ac; Dl += 3)ls = checkGeometryIntersection(this, sc, le1, bt, uc, mc, gc, Fl.getX(Dl), Fl.getX(Dl + 1), Fl.getX(Dl + 2)), ls && (ls.faceIndex = Math.floor(Dl / 3), ls.face.materialIndex = ho.materialIndex, vt.push(ls));
                            }
                            else for(let ho = Math.max(0, Ec.start), sc = Math.min(Fl.count, Ec.start + Ec.count); ho < sc; ho += 3)ls = checkGeometryIntersection(this, Dl, le1, bt, uc, mc, gc, Fl.getX(ho), Fl.getX(ho + 1), Fl.getX(ho + 2)), ls && (ls.faceIndex = Math.floor(ho / 3), vt.push(ls));
                        } else if (void 0 !== sc) {
                            if (Array.isArray(Dl)) for(let kc = 0, du = Ac.length; kc < du; kc++){
                                const ho = Ac[kc], Fl = Dl[ho.materialIndex];
                                for(let Dl = Math.max(ho.start, Ec.start), Ac = Math.min(sc.count, Math.min(ho.start + ho.count, Ec.start + Ec.count)); Dl < Ac; Dl += 3)ls = checkGeometryIntersection(this, Fl, le1, bt, uc, mc, gc, Dl, Dl + 1, Dl + 2), ls && (ls.faceIndex = Math.floor(Dl / 3), ls.face.materialIndex = ho.materialIndex, vt.push(ls));
                            }
                            else for(let ho = Math.max(0, Ec.start), Fl = Math.min(sc.count, Ec.start + Ec.count); ho < Fl; ho += 3)ls = checkGeometryIntersection(this, Dl, le1, bt, uc, mc, gc, ho, ho + 1, ho + 2), ls && (ls.faceIndex = Math.floor(ho / 3), vt.push(ls));
                        }
                    }
                }
                function checkGeometryIntersection(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc) {
                    le1.getVertexPosition(sc, K_), le1.getVertexPosition(uc, J_), le1.getVertexPosition(mc, $_);
                    const Ec = function(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                        let uc;
                        if (uc = vt.side === Ac ? ls.intersectTriangle(Fl, Dl, ho, !0, sc) : ls.intersectTriangle(ho, Dl, Fl, vt.side === gc, sc), null === uc) return null;
                        ny.copy(sc), ny.applyMatrix4(le1.matrixWorld);
                        const mc = bt.ray.origin.distanceTo(ny);
                        return mc < bt.near || mc > bt.far ? null : {
                            distance: mc,
                            point: ny.clone(),
                            object: le1
                        };
                    }(le1, vt, bt, ls, K_, J_, $_, iy);
                    if (Ec) {
                        const le1 = new Vector3;
                        Triangle.getBarycoord(iy, K_, J_, $_, le1), ho && (Ec.uv = Triangle.getInterpolatedAttribute(ho, sc, uc, mc, le1, new Vector2)), Dl && (Ec.uv1 = Triangle.getInterpolatedAttribute(Dl, sc, uc, mc, le1, new Vector2)), Fl && (Ec.normal = Triangle.getInterpolatedAttribute(Fl, sc, uc, mc, le1, new Vector3), Ec.normal.dot(ls.direction) > 0 && Ec.normal.multiplyScalar(-1));
                        const vt = {
                            a: sc,
                            b: uc,
                            c: mc,
                            normal: new Vector3,
                            materialIndex: 0
                        };
                        Triangle.getNormal(K_, J_, $_, vt.normal), Ec.face = vt, Ec.barycoord = le1;
                    }
                    return Ec;
                }
                class BoxGeometry extends BufferGeometry {
                    constructor(le1, vt, bt, ls, ho, Dl){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = 1), void 0 === bt && (bt = 1), void 0 === ls && (ls = 1), void 0 === ho && (ho = 1), void 0 === Dl && (Dl = 1), super(), this.type = "BoxGeometry", this.parameters = {
                            width: le1,
                            height: vt,
                            depth: bt,
                            widthSegments: ls,
                            heightSegments: ho,
                            depthSegments: Dl
                        };
                        const Fl = this;
                        ls = Math.floor(ls), ho = Math.floor(ho), Dl = Math.floor(Dl);
                        const sc = [], uc = [], mc = [], gc = [];
                        let Ac = 0, Ec = 0;
                        function buildPlane(le1, vt, bt, ls, ho, Dl, kc, du, _u, Md, Ld) {
                            const Nd = Dl / _u, Rd = kc / Md, Od = Dl / 2, jd = kc / 2, Ud = du / 2, Gd = _u + 1, qd = Md + 1;
                            let Hd = 0, Wd = 0;
                            const Zd = new Vector3;
                            for(let Fl = 0; Fl < qd; Fl++){
                                const Dl = Fl * Rd - jd;
                                for(let sc = 0; sc < Gd; sc++){
                                    const Ac = sc * Nd - Od;
                                    Zd[le1] = Ac * ls, Zd[vt] = Dl * ho, Zd[bt] = Ud, uc.push(Zd.x, Zd.y, Zd.z), Zd[le1] = 0, Zd[vt] = 0, Zd[bt] = du > 0 ? 1 : -1, mc.push(Zd.x, Zd.y, Zd.z), gc.push(sc / _u), gc.push(1 - Fl / Md), Hd += 1;
                                }
                            }
                            for(let Fl = 0; Fl < Md; Fl++)for(let le1 = 0; le1 < _u; le1++){
                                const vt = Ac + le1 + Gd * Fl, bt = Ac + le1 + Gd * (Fl + 1), ls = Ac + (le1 + 1) + Gd * (Fl + 1), ho = Ac + (le1 + 1) + Gd * Fl;
                                sc.push(vt, bt, ho), sc.push(bt, ls, ho), Wd += 6;
                            }
                            Fl.addGroup(Ec, Wd, Ld), Ec += Wd, Ac += Hd;
                        }
                        buildPlane("z", "y", "x", -1, -1, bt, vt, le1, Dl, ho, 0), buildPlane("z", "y", "x", 1, -1, bt, vt, -le1, Dl, ho, 1), buildPlane("x", "z", "y", 1, 1, le1, bt, vt, ls, Dl, 2), buildPlane("x", "z", "y", 1, -1, le1, bt, -vt, ls, Dl, 3), buildPlane("x", "y", "z", 1, -1, le1, vt, bt, ls, ho, 4), buildPlane("x", "y", "z", -1, -1, le1, vt, -bt, ls, ho, 5), this.setIndex(sc), this.setAttribute("position", new Float32BufferAttribute(uc, 3)), this.setAttribute("normal", new Float32BufferAttribute(mc, 3)), this.setAttribute("uv", new Float32BufferAttribute(gc, 2));
                    }
                    copy(le1) {
                        return super.copy(le1), this.parameters = Object.assign({}, le1.parameters), this;
                    }
                    static fromJSON(le1) {
                        return new BoxGeometry(le1.width, le1.height, le1.depth, le1.widthSegments, le1.heightSegments, le1.depthSegments);
                    }
                }
                function cloneUniforms(le1) {
                    const vt = {};
                    for(const bt in le1){
                        vt[bt] = {};
                        for(const ls in le1[bt]){
                            const ho = le1[bt][ls];
                            ho && (ho.isColor || ho.isMatrix3 || ho.isMatrix4 || ho.isVector2 || ho.isVector3 || ho.isVector4 || ho.isTexture || ho.isQuaternion) ? ho.isRenderTargetTexture ? (console.warn("UniformsUtils: Textures of render targets cannot be cloned via cloneUniforms() or mergeUniforms()."), vt[bt][ls] = null) : vt[bt][ls] = ho.clone() : Array.isArray(ho) ? vt[bt][ls] = ho.slice() : vt[bt][ls] = ho;
                        }
                    }
                    return vt;
                }
                function mergeUniforms(le1) {
                    const vt = {};
                    for(let bt = 0; bt < le1.length; bt++){
                        const ls = cloneUniforms(le1[bt]);
                        for(const le1 in ls)vt[le1] = ls[le1];
                    }
                    return vt;
                }
                function getUnlitUniformColorSpace(le1) {
                    const vt = le1.getRenderTarget();
                    return null === vt ? le1.outputColorSpace : !0 === vt.isXRRenderTarget ? vt.texture.colorSpace : xA.workingColorSpace;
                }
                const ry = {
                    clone: cloneUniforms,
                    merge: mergeUniforms
                };
                class ShaderMaterial extends Material {
                    constructor(le1){
                        super(), this.isShaderMaterial = !0, this.type = "ShaderMaterial", this.defines = {}, this.uniforms = {}, this.uniformsGroups = [], this.vertexShader = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}", this.fragmentShader = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}", this.linewidth = 1, this.wireframe = !1, this.wireframeLinewidth = 1, this.fog = !1, this.lights = !1, this.clipping = !1, this.forceSinglePass = !0, this.extensions = {
                            clipCullDistance: !1,
                            multiDraw: !1
                        }, this.defaultAttributeValues = {
                            color: [
                                1,
                                1,
                                1
                            ],
                            uv: [
                                0,
                                0
                            ],
                            uv1: [
                                0,
                                0
                            ]
                        }, this.index0AttributeName = void 0, this.uniformsNeedUpdate = !1, this.glslVersion = null, void 0 !== le1 && this.setValues(le1);
                    }
                    copy(le1) {
                        return super.copy(le1), this.fragmentShader = le1.fragmentShader, this.vertexShader = le1.vertexShader, this.uniforms = cloneUniforms(le1.uniforms), this.uniformsGroups = function(le1) {
                            const vt = [];
                            for(let bt = 0; bt < le1.length; bt++)vt.push(le1[bt].clone());
                            return vt;
                        }(le1.uniformsGroups), this.defines = Object.assign({}, le1.defines), this.wireframe = le1.wireframe, this.wireframeLinewidth = le1.wireframeLinewidth, this.fog = le1.fog, this.lights = le1.lights, this.clipping = le1.clipping, this.extensions = Object.assign({}, le1.extensions), this.glslVersion = le1.glslVersion, this;
                    }
                    toJSON(le1) {
                        const vt = super.toJSON(le1);
                        vt.glslVersion = this.glslVersion, vt.uniforms = {};
                        for(const ls in this.uniforms){
                            const bt = this.uniforms[ls].value;
                            bt && bt.isTexture ? vt.uniforms[ls] = {
                                type: "t",
                                value: bt.toJSON(le1).uuid
                            } : bt && bt.isColor ? vt.uniforms[ls] = {
                                type: "c",
                                value: bt.getHex()
                            } : bt && bt.isVector2 ? vt.uniforms[ls] = {
                                type: "v2",
                                value: bt.toArray()
                            } : bt && bt.isVector3 ? vt.uniforms[ls] = {
                                type: "v3",
                                value: bt.toArray()
                            } : bt && bt.isVector4 ? vt.uniforms[ls] = {
                                type: "v4",
                                value: bt.toArray()
                            } : bt && bt.isMatrix3 ? vt.uniforms[ls] = {
                                type: "m3",
                                value: bt.toArray()
                            } : bt && bt.isMatrix4 ? vt.uniforms[ls] = {
                                type: "m4",
                                value: bt.toArray()
                            } : vt.uniforms[ls] = {
                                value: bt
                            };
                        }
                        Object.keys(this.defines).length > 0 && (vt.defines = this.defines), vt.vertexShader = this.vertexShader, vt.fragmentShader = this.fragmentShader, vt.lights = this.lights, vt.clipping = this.clipping;
                        const bt = {};
                        for(const ls in this.extensions)!0 === this.extensions[ls] && (bt[ls] = !0);
                        return Object.keys(bt).length > 0 && (vt.extensions = bt), vt;
                    }
                }
                class Camera extends Object3D {
                    constructor(){
                        super(), this.isCamera = !0, this.type = "Camera", this.matrixWorldInverse = new Matrix4, this.projectionMatrix = new Matrix4, this.projectionMatrixInverse = new Matrix4, this.coordinateSystem = lA, this._reversedDepth = !1;
                    }
                    get reversedDepth() {
                        return this._reversedDepth;
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.matrixWorldInverse.copy(le1.matrixWorldInverse), this.projectionMatrix.copy(le1.projectionMatrix), this.projectionMatrixInverse.copy(le1.projectionMatrixInverse), this.coordinateSystem = le1.coordinateSystem, this;
                    }
                    getWorldDirection(le1) {
                        return super.getWorldDirection(le1).negate();
                    }
                    updateMatrixWorld(le1) {
                        super.updateMatrixWorld(le1), this.matrixWorldInverse.copy(this.matrixWorld).invert();
                    }
                    updateWorldMatrix(le1, vt) {
                        super.updateWorldMatrix(le1, vt), this.matrixWorldInverse.copy(this.matrixWorld).invert();
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                const ay = new Vector3, sy = new Vector2, oy = new Vector2;
                class PerspectiveCamera extends Camera {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = 50), void 0 === vt && (vt = 1), void 0 === bt && (bt = .1), void 0 === ls && (ls = 2e3), super(), this.isPerspectiveCamera = !0, this.type = "PerspectiveCamera", this.fov = le1, this.zoom = 1, this.near = bt, this.far = ls, this.focus = 10, this.aspect = vt, this.view = null, this.filmGauge = 35, this.filmOffset = 0, this.updateProjectionMatrix();
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.fov = le1.fov, this.zoom = le1.zoom, this.near = le1.near, this.far = le1.far, this.focus = le1.focus, this.aspect = le1.aspect, this.view = null === le1.view ? null : Object.assign({}, le1.view), this.filmGauge = le1.filmGauge, this.filmOffset = le1.filmOffset, this;
                    }
                    setFocalLength(le1) {
                        const vt = .5 * this.getFilmHeight() / le1;
                        this.fov = 2 * pA * Math.atan(vt), this.updateProjectionMatrix();
                    }
                    getFocalLength() {
                        const le1 = Math.tan(.5 * dA * this.fov);
                        return .5 * this.getFilmHeight() / le1;
                    }
                    getEffectiveFOV() {
                        return 2 * pA * Math.atan(Math.tan(.5 * dA * this.fov) / this.zoom);
                    }
                    getFilmWidth() {
                        return this.filmGauge * Math.min(this.aspect, 1);
                    }
                    getFilmHeight() {
                        return this.filmGauge / Math.max(this.aspect, 1);
                    }
                    getViewBounds(le1, vt, bt) {
                        ay.set(-1, -1, .5).applyMatrix4(this.projectionMatrixInverse), vt.set(ay.x, ay.y).multiplyScalar(-le1 / ay.z), ay.set(1, 1, .5).applyMatrix4(this.projectionMatrixInverse), bt.set(ay.x, ay.y).multiplyScalar(-le1 / ay.z);
                    }
                    getViewSize(le1, vt) {
                        return this.getViewBounds(le1, sy, oy), vt.subVectors(oy, sy);
                    }
                    setViewOffset(le1, vt, bt, ls, ho, Dl) {
                        this.aspect = le1 / vt, null === this.view && (this.view = {
                            enabled: !0,
                            fullWidth: 1,
                            fullHeight: 1,
                            offsetX: 0,
                            offsetY: 0,
                            width: 1,
                            height: 1
                        }), this.view.enabled = !0, this.view.fullWidth = le1, this.view.fullHeight = vt, this.view.offsetX = bt, this.view.offsetY = ls, this.view.width = ho, this.view.height = Dl, this.updateProjectionMatrix();
                    }
                    clearViewOffset() {
                        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
                    }
                    updateProjectionMatrix() {
                        const le1 = this.near;
                        let vt = le1 * Math.tan(.5 * dA * this.fov) / this.zoom, bt = 2 * vt, ls = this.aspect * bt, ho = -0.5 * ls;
                        const Dl = this.view;
                        if (null !== this.view && this.view.enabled) {
                            const le1 = Dl.fullWidth, Fl = Dl.fullHeight;
                            ho += Dl.offsetX * ls / le1, vt -= Dl.offsetY * bt / Fl, ls *= Dl.width / le1, bt *= Dl.height / Fl;
                        }
                        const Fl = this.filmOffset;
                        0 !== Fl && (ho += le1 * Fl / this.getFilmWidth()), this.projectionMatrix.makePerspective(ho, ho + ls, vt, vt - bt, le1, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
                    }
                    toJSON(le1) {
                        const vt = super.toJSON(le1);
                        return vt.object.fov = this.fov, vt.object.zoom = this.zoom, vt.object.near = this.near, vt.object.far = this.far, vt.object.focus = this.focus, vt.object.aspect = this.aspect, null !== this.view && (vt.object.view = Object.assign({}, this.view)), vt.object.filmGauge = this.filmGauge, vt.object.filmOffset = this.filmOffset, vt;
                    }
                }
                const ly = -90;
                class CubeCamera extends Object3D {
                    constructor(le1, vt, bt){
                        super(), this.type = "CubeCamera", this.renderTarget = bt, this.coordinateSystem = null, this.activeMipmapLevel = 0;
                        const ls = new PerspectiveCamera(ly, 1, le1, vt);
                        ls.layers = this.layers, this.add(ls);
                        const ho = new PerspectiveCamera(ly, 1, le1, vt);
                        ho.layers = this.layers, this.add(ho);
                        const Dl = new PerspectiveCamera(ly, 1, le1, vt);
                        Dl.layers = this.layers, this.add(Dl);
                        const Fl = new PerspectiveCamera(ly, 1, le1, vt);
                        Fl.layers = this.layers, this.add(Fl);
                        const sc = new PerspectiveCamera(ly, 1, le1, vt);
                        sc.layers = this.layers, this.add(sc);
                        const uc = new PerspectiveCamera(ly, 1, le1, vt);
                        uc.layers = this.layers, this.add(uc);
                    }
                    updateCoordinateSystem() {
                        const le1 = this.coordinateSystem, vt = this.children.concat(), [bt, ls, ho, Dl, Fl, sc] = vt;
                        for (const uc of vt)this.remove(uc);
                        if (le1 === lA) bt.up.set(0, 1, 0), bt.lookAt(1, 0, 0), ls.up.set(0, 1, 0), ls.lookAt(-1, 0, 0), ho.up.set(0, 0, -1), ho.lookAt(0, 1, 0), Dl.up.set(0, 0, 1), Dl.lookAt(0, -1, 0), Fl.up.set(0, 1, 0), Fl.lookAt(0, 0, 1), sc.up.set(0, 1, 0), sc.lookAt(0, 0, -1);
                        else {
                            if (le1 !== cA) throw new Error("THREE.CubeCamera.updateCoordinateSystem(): Invalid coordinate system: " + le1);
                            bt.up.set(0, -1, 0), bt.lookAt(-1, 0, 0), ls.up.set(0, -1, 0), ls.lookAt(1, 0, 0), ho.up.set(0, 0, 1), ho.lookAt(0, 1, 0), Dl.up.set(0, 0, -1), Dl.lookAt(0, -1, 0), Fl.up.set(0, -1, 0), Fl.lookAt(0, 0, 1), sc.up.set(0, -1, 0), sc.lookAt(0, 0, -1);
                        }
                        for (const uc of vt)this.add(uc), uc.updateMatrixWorld();
                    }
                    update(le1, vt) {
                        null === this.parent && this.updateMatrixWorld();
                        const { renderTarget: bt, activeMipmapLevel: ls } = this;
                        this.coordinateSystem !== le1.coordinateSystem && (this.coordinateSystem = le1.coordinateSystem, this.updateCoordinateSystem());
                        const [ho, Dl, Fl, sc, uc, mc] = this.children, gc = le1.getRenderTarget(), Ac = le1.getActiveCubeFace(), Ec = le1.getActiveMipmapLevel(), kc = le1.xr.enabled;
                        le1.xr.enabled = !1;
                        const du = bt.texture.generateMipmaps;
                        bt.texture.generateMipmaps = !1, le1.setRenderTarget(bt, 0, ls), le1.render(vt, ho), le1.setRenderTarget(bt, 1, ls), le1.render(vt, Dl), le1.setRenderTarget(bt, 2, ls), le1.render(vt, Fl), le1.setRenderTarget(bt, 3, ls), le1.render(vt, sc), le1.setRenderTarget(bt, 4, ls), le1.render(vt, uc), bt.texture.generateMipmaps = du, le1.setRenderTarget(bt, 5, ls), le1.render(vt, mc), le1.setRenderTarget(gc, Ac, Ec), le1.xr.enabled = kc, bt.texture.needsPMREMUpdate = !0;
                    }
                }
                class CubeTexture extends Texture {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc){
                        void 0 === le1 && (le1 = []), void 0 === vt && (vt = wm), super(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc), this.isCubeTexture = !0, this.flipY = !1;
                    }
                    get images() {
                        return this.image;
                    }
                    set images(le1) {
                        this.image = le1;
                    }
                }
                class WebGLCubeRenderTarget extends WebGLRenderTarget {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = {}), super(le1, le1, vt), this.isWebGLCubeRenderTarget = !0;
                        const bt = {
                            width: le1,
                            height: le1,
                            depth: 1
                        }, ls = [
                            bt,
                            bt,
                            bt,
                            bt,
                            bt,
                            bt
                        ];
                        this.texture = new CubeTexture(ls), this._setTextureOptions(vt), this.texture.isRenderTargetTexture = !0;
                    }
                    fromEquirectangularTexture(le1, vt) {
                        this.texture.type = vt.type, this.texture.colorSpace = vt.colorSpace, this.texture.generateMipmaps = vt.generateMipmaps, this.texture.minFilter = vt.minFilter, this.texture.magFilter = vt.magFilter;
                        const bt = {
                            uniforms: {
                                tEquirect: {
                                    value: null
                                }
                            },
                            vertexShader: "\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\tvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\n\t\t\t\t\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n\n\t\t\t\t}\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvWorldDirection = transformDirection( position, modelMatrix );\n\n\t\t\t\t\t#include <begin_vertex>\n\t\t\t\t\t#include <project_vertex>\n\n\t\t\t\t}\n\t\t\t",
                            fragmentShader: "\n\n\t\t\t\tuniform sampler2D tEquirect;\n\n\t\t\t\tvarying vec3 vWorldDirection;\n\n\t\t\t\t#include <common>\n\n\t\t\t\tvoid main() {\n\n\t\t\t\t\tvec3 direction = normalize( vWorldDirection );\n\n\t\t\t\t\tvec2 sampleUV = equirectUv( direction );\n\n\t\t\t\t\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\n\t\t\t\t}\n\t\t\t"
                        }, ls = new BoxGeometry(5, 5, 5), ho = new ShaderMaterial({
                            name: "CubemapFromEquirect",
                            uniforms: cloneUniforms(bt.uniforms),
                            vertexShader: bt.vertexShader,
                            fragmentShader: bt.fragmentShader,
                            side: Ac,
                            blending: kc
                        });
                        ho.uniforms.tEquirect.value = vt;
                        const Dl = new Mesh(ls, ho), Fl = vt.minFilter;
                        vt.minFilter === Rm && (vt.minFilter = zm);
                        return new CubeCamera(1, 10, this).update(le1, Dl), vt.minFilter = Fl, Dl.geometry.dispose(), Dl.material.dispose(), this;
                    }
                    clear(le1, vt, bt, ls) {
                        void 0 === vt && (vt = !0), void 0 === bt && (bt = !0), void 0 === ls && (ls = !0);
                        const ho = le1.getRenderTarget();
                        for(let Dl = 0; Dl < 6; Dl++)le1.setRenderTarget(this, Dl), le1.clear(vt, bt, ls);
                        le1.setRenderTarget(ho);
                    }
                }
                class Group extends Object3D {
                    constructor(){
                        super(), this.isGroup = !0, this.type = "Group";
                    }
                }
                const cy = {
                    type: "move"
                };
                class WebXRController {
                    constructor(){
                        this._targetRay = null, this._grip = null, this._hand = null;
                    }
                    getHandSpace() {
                        return null === this._hand && (this._hand = new Group, this._hand.matrixAutoUpdate = !1, this._hand.visible = !1, this._hand.joints = {}, this._hand.inputState = {
                            pinching: !1
                        }), this._hand;
                    }
                    getTargetRaySpace() {
                        return null === this._targetRay && (this._targetRay = new Group, this._targetRay.matrixAutoUpdate = !1, this._targetRay.visible = !1, this._targetRay.hasLinearVelocity = !1, this._targetRay.linearVelocity = new Vector3, this._targetRay.hasAngularVelocity = !1, this._targetRay.angularVelocity = new Vector3), this._targetRay;
                    }
                    getGripSpace() {
                        return null === this._grip && (this._grip = new Group, this._grip.matrixAutoUpdate = !1, this._grip.visible = !1, this._grip.hasLinearVelocity = !1, this._grip.linearVelocity = new Vector3, this._grip.hasAngularVelocity = !1, this._grip.angularVelocity = new Vector3), this._grip;
                    }
                    dispatchEvent(le1) {
                        return null !== this._targetRay && this._targetRay.dispatchEvent(le1), null !== this._grip && this._grip.dispatchEvent(le1), null !== this._hand && this._hand.dispatchEvent(le1), this;
                    }
                    connect(le1) {
                        if (le1 && le1.hand) {
                            const vt = this._hand;
                            if (vt) for (const bt of le1.hand.values())this._getHandJoint(vt, bt);
                        }
                        return this.dispatchEvent({
                            type: "connected",
                            data: le1
                        }), this;
                    }
                    disconnect(le1) {
                        return this.dispatchEvent({
                            type: "disconnected",
                            data: le1
                        }), null !== this._targetRay && (this._targetRay.visible = !1), null !== this._grip && (this._grip.visible = !1), null !== this._hand && (this._hand.visible = !1), this;
                    }
                    update(le1, vt, bt) {
                        let ls = null, ho = null, Dl = null;
                        const Fl = this._targetRay, sc = this._grip, uc = this._hand;
                        if (le1 && "visible-blurred" !== vt.session.visibilityState) {
                            if (uc && le1.hand) {
                                Dl = !0;
                                for (const Dl of le1.hand.values()){
                                    const le1 = vt.getJointPose(Dl, bt), ls = this._getHandJoint(uc, Dl);
                                    null !== le1 && (ls.matrix.fromArray(le1.transform.matrix), ls.matrix.decompose(ls.position, ls.rotation, ls.scale), ls.matrixWorldNeedsUpdate = !0, ls.jointRadius = le1.radius), ls.visible = null !== le1;
                                }
                                const ls = uc.joints["index-finger-tip"], ho = uc.joints["thumb-tip"], Fl = ls.position.distanceTo(ho.position), sc = .02, mc = .005;
                                uc.inputState.pinching && Fl > sc + mc ? (uc.inputState.pinching = !1, this.dispatchEvent({
                                    type: "pinchend",
                                    handedness: le1.handedness,
                                    target: this
                                })) : !uc.inputState.pinching && Fl <= sc - mc && (uc.inputState.pinching = !0, this.dispatchEvent({
                                    type: "pinchstart",
                                    handedness: le1.handedness,
                                    target: this
                                }));
                            } else null !== sc && le1.gripSpace && (ho = vt.getPose(le1.gripSpace, bt), null !== ho && (sc.matrix.fromArray(ho.transform.matrix), sc.matrix.decompose(sc.position, sc.rotation, sc.scale), sc.matrixWorldNeedsUpdate = !0, ho.linearVelocity ? (sc.hasLinearVelocity = !0, sc.linearVelocity.copy(ho.linearVelocity)) : sc.hasLinearVelocity = !1, ho.angularVelocity ? (sc.hasAngularVelocity = !0, sc.angularVelocity.copy(ho.angularVelocity)) : sc.hasAngularVelocity = !1));
                            null !== Fl && (ls = vt.getPose(le1.targetRaySpace, bt), null === ls && null !== ho && (ls = ho), null !== ls && (Fl.matrix.fromArray(ls.transform.matrix), Fl.matrix.decompose(Fl.position, Fl.rotation, Fl.scale), Fl.matrixWorldNeedsUpdate = !0, ls.linearVelocity ? (Fl.hasLinearVelocity = !0, Fl.linearVelocity.copy(ls.linearVelocity)) : Fl.hasLinearVelocity = !1, ls.angularVelocity ? (Fl.hasAngularVelocity = !0, Fl.angularVelocity.copy(ls.angularVelocity)) : Fl.hasAngularVelocity = !1, this.dispatchEvent(cy)));
                        }
                        return null !== Fl && (Fl.visible = null !== ls), null !== sc && (sc.visible = null !== ho), null !== uc && (uc.visible = null !== Dl), this;
                    }
                    _getHandJoint(le1, vt) {
                        if (void 0 === le1.joints[vt.jointName]) {
                            const bt = new Group;
                            bt.matrixAutoUpdate = !1, bt.visible = !1, le1.joints[vt.jointName] = bt, le1.add(bt);
                        }
                        return le1.joints[vt.jointName];
                    }
                }
                class Scene extends Object3D {
                    constructor(){
                        super(), this.isScene = !0, this.type = "Scene", this.background = null, this.environment = null, this.fog = null, this.backgroundBlurriness = 0, this.backgroundIntensity = 1, this.backgroundRotation = new Euler, this.environmentIntensity = 1, this.environmentRotation = new Euler, this.overrideMaterial = null, "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                            detail: this
                        }));
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), null !== le1.background && (this.background = le1.background.clone()), null !== le1.environment && (this.environment = le1.environment.clone()), null !== le1.fog && (this.fog = le1.fog.clone()), this.backgroundBlurriness = le1.backgroundBlurriness, this.backgroundIntensity = le1.backgroundIntensity, this.backgroundRotation.copy(le1.backgroundRotation), this.environmentIntensity = le1.environmentIntensity, this.environmentRotation.copy(le1.environmentRotation), null !== le1.overrideMaterial && (this.overrideMaterial = le1.overrideMaterial.clone()), this.matrixAutoUpdate = le1.matrixAutoUpdate, this;
                    }
                    toJSON(le1) {
                        const vt = super.toJSON(le1);
                        return null !== this.fog && (vt.object.fog = this.fog.toJSON()), this.backgroundBlurriness > 0 && (vt.object.backgroundBlurriness = this.backgroundBlurriness), 1 !== this.backgroundIntensity && (vt.object.backgroundIntensity = this.backgroundIntensity), vt.object.backgroundRotation = this.backgroundRotation.toArray(), 1 !== this.environmentIntensity && (vt.object.environmentIntensity = this.environmentIntensity), vt.object.environmentRotation = this.environmentRotation.toArray(), vt;
                    }
                }
                const uy = new Vector3, hy = new Vector3, dy = new Matrix3;
                class Plane {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new Vector3(1, 0, 0)), void 0 === vt && (vt = 0), this.isPlane = !0, this.normal = le1, this.constant = vt;
                    }
                    set(le1, vt) {
                        return this.normal.copy(le1), this.constant = vt, this;
                    }
                    setComponents(le1, vt, bt, ls) {
                        return this.normal.set(le1, vt, bt), this.constant = ls, this;
                    }
                    setFromNormalAndCoplanarPoint(le1, vt) {
                        return this.normal.copy(le1), this.constant = -vt.dot(this.normal), this;
                    }
                    setFromCoplanarPoints(le1, vt, bt) {
                        const ls = uy.subVectors(bt, vt).cross(hy.subVectors(le1, vt)).normalize();
                        return this.setFromNormalAndCoplanarPoint(ls, le1), this;
                    }
                    copy(le1) {
                        return this.normal.copy(le1.normal), this.constant = le1.constant, this;
                    }
                    normalize() {
                        const le1 = 1 / this.normal.length();
                        return this.normal.multiplyScalar(le1), this.constant *= le1, this;
                    }
                    negate() {
                        return this.constant *= -1, this.normal.negate(), this;
                    }
                    distanceToPoint(le1) {
                        return this.normal.dot(le1) + this.constant;
                    }
                    distanceToSphere(le1) {
                        return this.distanceToPoint(le1.center) - le1.radius;
                    }
                    projectPoint(le1, vt) {
                        return vt.copy(le1).addScaledVector(this.normal, -this.distanceToPoint(le1));
                    }
                    intersectLine(le1, vt) {
                        const bt = le1.delta(uy), ls = this.normal.dot(bt);
                        if (0 === ls) return 0 === this.distanceToPoint(le1.start) ? vt.copy(le1.start) : null;
                        const ho = -(le1.start.dot(this.normal) + this.constant) / ls;
                        return ho < 0 || ho > 1 ? null : vt.copy(le1.start).addScaledVector(bt, ho);
                    }
                    intersectsLine(le1) {
                        const vt = this.distanceToPoint(le1.start), bt = this.distanceToPoint(le1.end);
                        return vt < 0 && bt > 0 || bt < 0 && vt > 0;
                    }
                    intersectsBox(le1) {
                        return le1.intersectsPlane(this);
                    }
                    intersectsSphere(le1) {
                        return le1.intersectsPlane(this);
                    }
                    coplanarPoint(le1) {
                        return le1.copy(this.normal).multiplyScalar(-this.constant);
                    }
                    applyMatrix4(le1, vt) {
                        const bt = vt || dy.getNormalMatrix(le1), ls = this.coplanarPoint(uy).applyMatrix4(le1), ho = this.normal.applyMatrix3(bt).normalize();
                        return this.constant = -ls.dot(ho), this;
                    }
                    translate(le1) {
                        return this.constant -= le1.dot(this.normal), this;
                    }
                    equals(le1) {
                        return le1.normal.equals(this.normal) && le1.constant === this.constant;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                const py = new Sphere, my = new Vector2(.5, .5), fy = new Vector3;
                class Frustum {
                    constructor(le1, vt, bt, ls, ho, Dl){
                        void 0 === le1 && (le1 = new Plane), void 0 === vt && (vt = new Plane), void 0 === bt && (bt = new Plane), void 0 === ls && (ls = new Plane), void 0 === ho && (ho = new Plane), void 0 === Dl && (Dl = new Plane), this.planes = [
                            le1,
                            vt,
                            bt,
                            ls,
                            ho,
                            Dl
                        ];
                    }
                    set(le1, vt, bt, ls, ho, Dl) {
                        const Fl = this.planes;
                        return Fl[0].copy(le1), Fl[1].copy(vt), Fl[2].copy(bt), Fl[3].copy(ls), Fl[4].copy(ho), Fl[5].copy(Dl), this;
                    }
                    copy(le1) {
                        const vt = this.planes;
                        for(let bt = 0; bt < 6; bt++)vt[bt].copy(le1.planes[bt]);
                        return this;
                    }
                    setFromProjectionMatrix(le1, vt, bt) {
                        void 0 === vt && (vt = lA), void 0 === bt && (bt = !1);
                        const ls = this.planes, ho = le1.elements, Dl = ho[0], Fl = ho[1], sc = ho[2], uc = ho[3], mc = ho[4], gc = ho[5], Ac = ho[6], Ec = ho[7], kc = ho[8], du = ho[9], _u = ho[10], Md = ho[11], Ld = ho[12], Nd = ho[13], Rd = ho[14], Od = ho[15];
                        if (ls[0].setComponents(uc - Dl, Ec - mc, Md - kc, Od - Ld).normalize(), ls[1].setComponents(uc + Dl, Ec + mc, Md + kc, Od + Ld).normalize(), ls[2].setComponents(uc + Fl, Ec + gc, Md + du, Od + Nd).normalize(), ls[3].setComponents(uc - Fl, Ec - gc, Md - du, Od - Nd).normalize(), bt) ls[4].setComponents(sc, Ac, _u, Rd).normalize(), ls[5].setComponents(uc - sc, Ec - Ac, Md - _u, Od - Rd).normalize();
                        else if (ls[4].setComponents(uc - sc, Ec - Ac, Md - _u, Od - Rd).normalize(), vt === lA) ls[5].setComponents(uc + sc, Ec + Ac, Md + _u, Od + Rd).normalize();
                        else {
                            if (vt !== cA) throw new Error("THREE.Frustum.setFromProjectionMatrix(): Invalid coordinate system: " + vt);
                            ls[5].setComponents(sc, Ac, _u, Rd).normalize();
                        }
                        return this;
                    }
                    intersectsObject(le1) {
                        if (void 0 !== le1.boundingSphere) null === le1.boundingSphere && le1.computeBoundingSphere(), py.copy(le1.boundingSphere).applyMatrix4(le1.matrixWorld);
                        else {
                            const vt = le1.geometry;
                            null === vt.boundingSphere && vt.computeBoundingSphere(), py.copy(vt.boundingSphere).applyMatrix4(le1.matrixWorld);
                        }
                        return this.intersectsSphere(py);
                    }
                    intersectsSprite(le1) {
                        py.center.set(0, 0, 0);
                        const vt = my.distanceTo(le1.center);
                        return py.radius = .7071067811865476 + vt, py.applyMatrix4(le1.matrixWorld), this.intersectsSphere(py);
                    }
                    intersectsSphere(le1) {
                        const vt = this.planes, bt = le1.center, ls = -le1.radius;
                        for(let ho = 0; ho < 6; ho++){
                            if (vt[ho].distanceToPoint(bt) < ls) return !1;
                        }
                        return !0;
                    }
                    intersectsBox(le1) {
                        const vt = this.planes;
                        for(let bt = 0; bt < 6; bt++){
                            const ls = vt[bt];
                            if (fy.x = ls.normal.x > 0 ? le1.max.x : le1.min.x, fy.y = ls.normal.y > 0 ? le1.max.y : le1.min.y, fy.z = ls.normal.z > 0 ? le1.max.z : le1.min.z, ls.distanceToPoint(fy) < 0) return !1;
                        }
                        return !0;
                    }
                    containsPoint(le1) {
                        const vt = this.planes;
                        for(let bt = 0; bt < 6; bt++)if (vt[bt].distanceToPoint(le1) < 0) return !1;
                        return !0;
                    }
                    clone() {
                        return (new this.constructor).copy(this);
                    }
                }
                class LineBasicMaterial extends Material {
                    constructor(le1){
                        super(), this.isLineBasicMaterial = !0, this.type = "LineBasicMaterial", this.color = new Color(16777215), this.map = null, this.linewidth = 1, this.linecap = "round", this.linejoin = "round", this.fog = !0, this.setValues(le1);
                    }
                    copy(le1) {
                        return super.copy(le1), this.color.copy(le1.color), this.map = le1.map, this.linewidth = le1.linewidth, this.linecap = le1.linecap, this.linejoin = le1.linejoin, this.fog = le1.fog, this;
                    }
                }
                const gy = new Vector3, Ay = new Vector3, _y = new Matrix4, yy = new Ray, vy = new Sphere, xy = new Vector3, by = new Vector3;
                class Line extends Object3D {
                    constructor(le1, vt){
                        void 0 === le1 && (le1 = new BufferGeometry), void 0 === vt && (vt = new LineBasicMaterial), super(), this.isLine = !0, this.type = "Line", this.geometry = le1, this.material = vt, this.morphTargetDictionary = void 0, this.morphTargetInfluences = void 0, this.updateMorphTargets();
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.material = Array.isArray(le1.material) ? le1.material.slice() : le1.material, this.geometry = le1.geometry, this;
                    }
                    computeLineDistances() {
                        const le1 = this.geometry;
                        if (null === le1.index) {
                            const vt = le1.attributes.position, bt = [
                                0
                            ];
                            for(let le1 = 1, ls = vt.count; le1 < ls; le1++)gy.fromBufferAttribute(vt, le1 - 1), Ay.fromBufferAttribute(vt, le1), bt[le1] = bt[le1 - 1], bt[le1] += gy.distanceTo(Ay);
                            le1.setAttribute("lineDistance", new Float32BufferAttribute(bt, 1));
                        } else console.warn("THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                        return this;
                    }
                    raycast(le1, vt) {
                        const bt = this.geometry, ls = this.matrixWorld, ho = le1.params.Line.threshold, Dl = bt.drawRange;
                        if (null === bt.boundingSphere && bt.computeBoundingSphere(), vy.copy(bt.boundingSphere), vy.applyMatrix4(ls), vy.radius += ho, !1 === le1.ray.intersectsSphere(vy)) return;
                        _y.copy(ls).invert(), yy.copy(le1.ray).applyMatrix4(_y);
                        const Fl = ho / ((this.scale.x + this.scale.y + this.scale.z) / 3), sc = Fl * Fl, uc = this.isLineSegments ? 2 : 1, mc = bt.index, gc = bt.attributes.position;
                        if (null !== mc) {
                            const bt = Math.max(0, Dl.start), ls = Math.min(mc.count, Dl.start + Dl.count);
                            for(let ho = bt, Dl = ls - 1; ho < Dl; ho += uc){
                                const bt = mc.getX(ho), ls = mc.getX(ho + 1), Dl = checkIntersection(this, le1, yy, sc, bt, ls, ho);
                                Dl && vt.push(Dl);
                            }
                            if (this.isLineLoop) {
                                const ho = mc.getX(ls - 1), Dl = mc.getX(bt), Fl = checkIntersection(this, le1, yy, sc, ho, Dl, ls - 1);
                                Fl && vt.push(Fl);
                            }
                        } else {
                            const bt = Math.max(0, Dl.start), ls = Math.min(gc.count, Dl.start + Dl.count);
                            for(let ho = bt, Dl = ls - 1; ho < Dl; ho += uc){
                                const bt = checkIntersection(this, le1, yy, sc, ho, ho + 1, ho);
                                bt && vt.push(bt);
                            }
                            if (this.isLineLoop) {
                                const ho = checkIntersection(this, le1, yy, sc, ls - 1, bt, ls - 1);
                                ho && vt.push(ho);
                            }
                        }
                    }
                    updateMorphTargets() {
                        const le1 = this.geometry.morphAttributes, vt = Object.keys(le1);
                        if (vt.length > 0) {
                            const bt = le1[vt[0]];
                            if (void 0 !== bt) {
                                this.morphTargetInfluences = [], this.morphTargetDictionary = {};
                                for(let le1 = 0, vt = bt.length; le1 < vt; le1++){
                                    const vt = bt[le1].name || String(le1);
                                    this.morphTargetInfluences.push(0), this.morphTargetDictionary[vt] = le1;
                                }
                            }
                        }
                    }
                }
                function checkIntersection(le1, vt, bt, ls, ho, Dl, Fl) {
                    const sc = le1.geometry.attributes.position;
                    gy.fromBufferAttribute(sc, ho), Ay.fromBufferAttribute(sc, Dl);
                    if (bt.distanceSqToSegment(gy, Ay, xy, by) > ls) return;
                    xy.applyMatrix4(le1.matrixWorld);
                    const uc = vt.ray.origin.distanceTo(xy);
                    return uc < vt.near || uc > vt.far ? void 0 : {
                        distance: uc,
                        point: by.clone().applyMatrix4(le1.matrixWorld),
                        index: Fl,
                        face: null,
                        faceIndex: null,
                        barycoord: null,
                        object: le1
                    };
                }
                const wy = new Vector3, Ey = new Vector3;
                class LineSegments extends Line {
                    constructor(le1, vt){
                        super(le1, vt), this.isLineSegments = !0, this.type = "LineSegments";
                    }
                    computeLineDistances() {
                        const le1 = this.geometry;
                        if (null === le1.index) {
                            const vt = le1.attributes.position, bt = [];
                            for(let le1 = 0, ls = vt.count; le1 < ls; le1 += 2)wy.fromBufferAttribute(vt, le1), Ey.fromBufferAttribute(vt, le1 + 1), bt[le1] = 0 === le1 ? 0 : bt[le1 - 1], bt[le1 + 1] = bt[le1] + wy.distanceTo(Ey);
                            le1.setAttribute("lineDistance", new Float32BufferAttribute(bt, 1));
                        } else console.warn("THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.");
                        return this;
                    }
                }
                class VideoTexture extends Texture {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc){
                        void 0 === ho && (ho = zm), void 0 === Dl && (Dl = zm), super(le1, vt, bt, ls, ho, Dl, Fl, sc, uc), this.isVideoTexture = !0, this.generateMipmaps = !1, this._requestVideoFrameCallbackId = 0;
                        const mc = this;
                        "requestVideoFrameCallback" in le1 && (this._requestVideoFrameCallbackId = le1.requestVideoFrameCallback(function updateVideo() {
                            mc.needsUpdate = !0, mc._requestVideoFrameCallbackId = le1.requestVideoFrameCallback(updateVideo);
                        }));
                    }
                    clone() {
                        return new this.constructor(this.image).copy(this);
                    }
                    update() {
                        const le1 = this.image;
                        !1 === "requestVideoFrameCallback" in le1 && le1.readyState >= le1.HAVE_CURRENT_DATA && (this.needsUpdate = !0);
                    }
                    dispose() {
                        0 !== this._requestVideoFrameCallbackId && this.source.data.cancelVideoFrameCallback(this._requestVideoFrameCallbackId), super.dispose();
                    }
                }
                class DepthTexture extends Texture {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl, sc, uc, mc, gc){
                        if (void 0 === bt && (bt = Vm), void 0 === Fl && (Fl = Dm), void 0 === sc && (sc = Dm), void 0 === mc && (mc = Jm), void 0 === gc && (gc = 1), mc !== Jm && mc !== $m) throw new Error("DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat");
                        super({
                            width: le1,
                            height: vt,
                            depth: gc
                        }, ls, ho, Dl, Fl, sc, mc, bt, uc), this.isDepthTexture = !0, this.flipY = !1, this.generateMipmaps = !1, this.compareFunction = null;
                    }
                    copy(le1) {
                        return super.copy(le1), this.source = new Source(Object.assign({}, le1.image)), this.compareFunction = le1.compareFunction, this;
                    }
                    toJSON(le1) {
                        const vt = super.toJSON(le1);
                        return null !== this.compareFunction && (vt.compareFunction = this.compareFunction), vt;
                    }
                }
                class PlaneGeometry extends BufferGeometry {
                    constructor(le1, vt, bt, ls){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = 1), void 0 === bt && (bt = 1), void 0 === ls && (ls = 1), super(), this.type = "PlaneGeometry", this.parameters = {
                            width: le1,
                            height: vt,
                            widthSegments: bt,
                            heightSegments: ls
                        };
                        const ho = le1 / 2, Dl = vt / 2, Fl = Math.floor(bt), sc = Math.floor(ls), uc = Fl + 1, mc = sc + 1, gc = le1 / Fl, Ac = vt / sc, Ec = [], kc = [], du = [], _u = [];
                        for(let Md = 0; Md < mc; Md++){
                            const le1 = Md * Ac - Dl;
                            for(let vt = 0; vt < uc; vt++){
                                const bt = vt * gc - ho;
                                kc.push(bt, -le1, 0), du.push(0, 0, 1), _u.push(vt / Fl), _u.push(1 - Md / sc);
                            }
                        }
                        for(let Md = 0; Md < sc; Md++)for(let le1 = 0; le1 < Fl; le1++){
                            const vt = le1 + uc * Md, bt = le1 + uc * (Md + 1), ls = le1 + 1 + uc * (Md + 1), ho = le1 + 1 + uc * Md;
                            Ec.push(vt, bt, ho), Ec.push(bt, ls, ho);
                        }
                        this.setIndex(Ec), this.setAttribute("position", new Float32BufferAttribute(kc, 3)), this.setAttribute("normal", new Float32BufferAttribute(du, 3)), this.setAttribute("uv", new Float32BufferAttribute(_u, 2));
                    }
                    copy(le1) {
                        return super.copy(le1), this.parameters = Object.assign({}, le1.parameters), this;
                    }
                    static fromJSON(le1) {
                        return new PlaneGeometry(le1.width, le1.height, le1.widthSegments, le1.heightSegments);
                    }
                }
                class SphereGeometry extends BufferGeometry {
                    constructor(le1, vt, bt, ls, ho, Dl, Fl){
                        void 0 === le1 && (le1 = 1), void 0 === vt && (vt = 32), void 0 === bt && (bt = 16), void 0 === ls && (ls = 0), void 0 === ho && (ho = 2 * Math.PI), void 0 === Dl && (Dl = 0), void 0 === Fl && (Fl = Math.PI), super(), this.type = "SphereGeometry", this.parameters = {
                            radius: le1,
                            widthSegments: vt,
                            heightSegments: bt,
                            phiStart: ls,
                            phiLength: ho,
                            thetaStart: Dl,
                            thetaLength: Fl
                        }, vt = Math.max(3, Math.floor(vt)), bt = Math.max(2, Math.floor(bt));
                        const sc = Math.min(Dl + Fl, Math.PI);
                        let uc = 0;
                        const mc = [], gc = new Vector3, Ac = new Vector3, Ec = [], kc = [], du = [], _u = [];
                        for(let Md = 0; Md <= bt; Md++){
                            const Ec = [], Ld = Md / bt;
                            let Nd = 0;
                            0 === Md && 0 === Dl ? Nd = .5 / vt : Md === bt && sc === Math.PI && (Nd = -0.5 / vt);
                            for(let bt = 0; bt <= vt; bt++){
                                const sc = bt / vt;
                                gc.x = -le1 * Math.cos(ls + sc * ho) * Math.sin(Dl + Ld * Fl), gc.y = le1 * Math.cos(Dl + Ld * Fl), gc.z = le1 * Math.sin(ls + sc * ho) * Math.sin(Dl + Ld * Fl), kc.push(gc.x, gc.y, gc.z), Ac.copy(gc).normalize(), du.push(Ac.x, Ac.y, Ac.z), _u.push(sc + Nd, 1 - Ld), Ec.push(uc++);
                            }
                            mc.push(Ec);
                        }
                        for(let Md = 0; Md < bt; Md++)for(let le1 = 0; le1 < vt; le1++){
                            const vt = mc[Md][le1 + 1], ls = mc[Md][le1], ho = mc[Md + 1][le1], Fl = mc[Md + 1][le1 + 1];
                            (0 !== Md || Dl > 0) && Ec.push(vt, ls, Fl), (Md !== bt - 1 || sc < Math.PI) && Ec.push(ls, ho, Fl);
                        }
                        this.setIndex(Ec), this.setAttribute("position", new Float32BufferAttribute(kc, 3)), this.setAttribute("normal", new Float32BufferAttribute(du, 3)), this.setAttribute("uv", new Float32BufferAttribute(_u, 2));
                    }
                    copy(le1) {
                        return super.copy(le1), this.parameters = Object.assign({}, le1.parameters), this;
                    }
                    static fromJSON(le1) {
                        return new SphereGeometry(le1.radius, le1.widthSegments, le1.heightSegments, le1.phiStart, le1.phiLength, le1.thetaStart, le1.thetaLength);
                    }
                }
                class WireframeGeometry extends BufferGeometry {
                    constructor(le1){
                        if (void 0 === le1 && (le1 = null), super(), this.type = "WireframeGeometry", this.parameters = {
                            geometry: le1
                        }, null !== le1) {
                            const vt = [], bt = new Set, ls = new Vector3, ho = new Vector3;
                            if (null !== le1.index) {
                                const Dl = le1.attributes.position, Fl = le1.index;
                                let sc = le1.groups;
                                0 === sc.length && (sc = [
                                    {
                                        start: 0,
                                        count: Fl.count,
                                        materialIndex: 0
                                    }
                                ]);
                                for(let le1 = 0, uc = sc.length; le1 < uc; ++le1){
                                    const uc = sc[le1], mc = uc.start;
                                    for(let le1 = mc, sc = mc + uc.count; le1 < sc; le1 += 3)for(let uc = 0; uc < 3; uc++){
                                        const sc = Fl.getX(le1 + uc), mc = Fl.getX(le1 + (uc + 1) % 3);
                                        ls.fromBufferAttribute(Dl, sc), ho.fromBufferAttribute(Dl, mc), !0 === isUniqueEdge(ls, ho, bt) && (vt.push(ls.x, ls.y, ls.z), vt.push(ho.x, ho.y, ho.z));
                                    }
                                }
                            } else {
                                const Dl = le1.attributes.position;
                                for(let le1 = 0, Fl = Dl.count / 3; le1 < Fl; le1++)for(let sc = 0; sc < 3; sc++){
                                    const Fl = 3 * le1 + sc, uc = 3 * le1 + (sc + 1) % 3;
                                    ls.fromBufferAttribute(Dl, Fl), ho.fromBufferAttribute(Dl, uc), !0 === isUniqueEdge(ls, ho, bt) && (vt.push(ls.x, ls.y, ls.z), vt.push(ho.x, ho.y, ho.z));
                                }
                            }
                            this.setAttribute("position", new Float32BufferAttribute(vt, 3));
                        }
                    }
                    copy(le1) {
                        return super.copy(le1), this.parameters = Object.assign({}, le1.parameters), this;
                    }
                }
                function isUniqueEdge(le1, vt, bt) {
                    const ls = `${le1.x},${le1.y},${le1.z}-${vt.x},${vt.y},${vt.z}`, ho = `${vt.x},${vt.y},${vt.z}-${le1.x},${le1.y},${le1.z}`;
                    return !0 !== bt.has(ls) && !0 !== bt.has(ho) && (bt.add(ls), bt.add(ho), !0);
                }
                class MeshDepthMaterial extends Material {
                    constructor(le1){
                        super(), this.isMeshDepthMaterial = !0, this.type = "MeshDepthMaterial", this.depthPacking = 3200, this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.wireframe = !1, this.wireframeLinewidth = 1, this.setValues(le1);
                    }
                    copy(le1) {
                        return super.copy(le1), this.depthPacking = le1.depthPacking, this.map = le1.map, this.alphaMap = le1.alphaMap, this.displacementMap = le1.displacementMap, this.displacementScale = le1.displacementScale, this.displacementBias = le1.displacementBias, this.wireframe = le1.wireframe, this.wireframeLinewidth = le1.wireframeLinewidth, this;
                    }
                }
                class MeshDistanceMaterial extends Material {
                    constructor(le1){
                        super(), this.isMeshDistanceMaterial = !0, this.type = "MeshDistanceMaterial", this.map = null, this.alphaMap = null, this.displacementMap = null, this.displacementScale = 1, this.displacementBias = 0, this.setValues(le1);
                    }
                    copy(le1) {
                        return super.copy(le1), this.map = le1.map, this.alphaMap = le1.alphaMap, this.displacementMap = le1.displacementMap, this.displacementScale = le1.displacementScale, this.displacementBias = le1.displacementBias, this;
                    }
                }
                function convertArray(le1, vt) {
                    return le1 && le1.constructor !== vt ? "number" === typeof vt.BYTES_PER_ELEMENT ? new vt(le1) : Array.prototype.slice.call(le1) : le1;
                }
                function isTypedArray(le1) {
                    return ArrayBuffer.isView(le1) && !(le1 instanceof DataView);
                }
                class Interpolant {
                    constructor(le1, vt, bt, ls){
                        this.parameterPositions = le1, this._cachedIndex = 0, this.resultBuffer = void 0 !== ls ? ls : new vt.constructor(bt), this.sampleValues = vt, this.valueSize = bt, this.settings = null, this.DefaultSettings_ = {};
                    }
                    evaluate(le1) {
                        const vt = this.parameterPositions;
                        let bt = this._cachedIndex, ls = vt[bt], ho = vt[bt - 1];
                        e: {
                            t: {
                                let Dl;
                                i: {
                                    n: if (!(le1 < ls)) {
                                        for(let Dl = bt + 2;;){
                                            if (void 0 === ls) {
                                                if (le1 < ho) break n;
                                                return bt = vt.length, this._cachedIndex = bt, this.copySampleValue_(bt - 1);
                                            }
                                            if (bt === Dl) break;
                                            if (ho = ls, ls = vt[++bt], le1 < ls) break t;
                                        }
                                        Dl = vt.length;
                                        break i;
                                    }
                                    if (le1 >= ho) break e;
                                    {
                                        const Fl = vt[1];
                                        le1 < Fl && (bt = 2, ho = Fl);
                                        for(let Dl = bt - 2;;){
                                            if (void 0 === ho) return this._cachedIndex = 0, this.copySampleValue_(0);
                                            if (bt === Dl) break;
                                            if (ls = ho, ho = vt[--bt - 1], le1 >= ho) break t;
                                        }
                                        Dl = bt, bt = 0;
                                    }
                                }
                                for(; bt < Dl;){
                                    const ls = bt + Dl >>> 1;
                                    le1 < vt[ls] ? Dl = ls : bt = ls + 1;
                                }
                                if (ls = vt[bt], ho = vt[bt - 1], void 0 === ho) return this._cachedIndex = 0, this.copySampleValue_(0);
                                if (void 0 === ls) return bt = vt.length, this._cachedIndex = bt, this.copySampleValue_(bt - 1);
                            }
                            this._cachedIndex = bt, this.intervalChanged_(bt, ho, ls);
                        }
                        return this.interpolate_(bt, ho, le1, ls);
                    }
                    getSettings_() {
                        return this.settings || this.DefaultSettings_;
                    }
                    copySampleValue_(le1) {
                        const vt = this.resultBuffer, bt = this.sampleValues, ls = this.valueSize, ho = le1 * ls;
                        for(let Dl = 0; Dl !== ls; ++Dl)vt[Dl] = bt[ho + Dl];
                        return vt;
                    }
                    interpolate_() {
                        throw new Error("call to abstract method");
                    }
                    intervalChanged_() {}
                }
                class CubicInterpolant extends Interpolant {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls), this._weightPrev = -0, this._offsetPrev = -0, this._weightNext = -0, this._offsetNext = -0, this.DefaultSettings_ = {
                            endingStart: jg,
                            endingEnd: jg
                        };
                    }
                    intervalChanged_(le1, vt, bt) {
                        const ls = this.parameterPositions;
                        let ho = le1 - 2, Dl = le1 + 1, Fl = ls[ho], sc = ls[Dl];
                        if (void 0 === Fl) switch(this.getSettings_().endingStart){
                            case Ug:
                                ho = le1, Fl = 2 * vt - bt;
                                break;
                            case Vg:
                                ho = ls.length - 2, Fl = vt + ls[ho] - ls[ho + 1];
                                break;
                            default:
                                ho = le1, Fl = bt;
                        }
                        if (void 0 === sc) switch(this.getSettings_().endingEnd){
                            case Ug:
                                Dl = le1, sc = 2 * bt - vt;
                                break;
                            case Vg:
                                Dl = 1, sc = bt + ls[1] - ls[0];
                                break;
                            default:
                                Dl = le1 - 1, sc = vt;
                        }
                        const uc = .5 * (bt - vt), mc = this.valueSize;
                        this._weightPrev = uc / (vt - Fl), this._weightNext = uc / (sc - bt), this._offsetPrev = ho * mc, this._offsetNext = Dl * mc;
                    }
                    interpolate_(le1, vt, bt, ls) {
                        const ho = this.resultBuffer, Dl = this.sampleValues, Fl = this.valueSize, sc = le1 * Fl, uc = sc - Fl, mc = this._offsetPrev, gc = this._offsetNext, Ac = this._weightPrev, Ec = this._weightNext, kc = (bt - vt) / (ls - vt), du = kc * kc, _u = du * kc, Md = -Ac * _u + 2 * Ac * du - Ac * kc, Ld = (1 + Ac) * _u + (-1.5 - 2 * Ac) * du + (-0.5 + Ac) * kc + 1, Nd = (-1 - Ec) * _u + (1.5 + Ec) * du + .5 * kc, Rd = Ec * _u - Ec * du;
                        for(let Od = 0; Od !== Fl; ++Od)ho[Od] = Md * Dl[mc + Od] + Ld * Dl[uc + Od] + Nd * Dl[sc + Od] + Rd * Dl[gc + Od];
                        return ho;
                    }
                }
                class LinearInterpolant extends Interpolant {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                    interpolate_(le1, vt, bt, ls) {
                        const ho = this.resultBuffer, Dl = this.sampleValues, Fl = this.valueSize, sc = le1 * Fl, uc = sc - Fl, mc = (bt - vt) / (ls - vt), gc = 1 - mc;
                        for(let Ac = 0; Ac !== Fl; ++Ac)ho[Ac] = Dl[uc + Ac] * gc + Dl[sc + Ac] * mc;
                        return ho;
                    }
                }
                class DiscreteInterpolant extends Interpolant {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                    interpolate_(le1) {
                        return this.copySampleValue_(le1 - 1);
                    }
                }
                class KeyframeTrack {
                    constructor(le1, vt, bt, ls){
                        if (void 0 === le1) throw new Error("THREE.KeyframeTrack: track name is undefined");
                        if (void 0 === vt || 0 === vt.length) throw new Error("THREE.KeyframeTrack: no keyframes in track named " + le1);
                        this.name = le1, this.times = convertArray(vt, this.TimeBufferType), this.values = convertArray(bt, this.ValueBufferType), this.setInterpolation(ls || this.DefaultInterpolation);
                    }
                    static toJSON(le1) {
                        const vt = le1.constructor;
                        let bt;
                        if (vt.toJSON !== this.toJSON) bt = vt.toJSON(le1);
                        else {
                            bt = {
                                name: le1.name,
                                times: convertArray(le1.times, Array),
                                values: convertArray(le1.values, Array)
                            };
                            const vt = le1.getInterpolation();
                            vt !== le1.DefaultInterpolation && (bt.interpolation = vt);
                        }
                        return bt.type = le1.ValueTypeName, bt;
                    }
                    InterpolantFactoryMethodDiscrete(le1) {
                        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), le1);
                    }
                    InterpolantFactoryMethodLinear(le1) {
                        return new LinearInterpolant(this.times, this.values, this.getValueSize(), le1);
                    }
                    InterpolantFactoryMethodSmooth(le1) {
                        return new CubicInterpolant(this.times, this.values, this.getValueSize(), le1);
                    }
                    setInterpolation(le1) {
                        let vt;
                        switch(le1){
                            case Fg:
                                vt = this.InterpolantFactoryMethodDiscrete;
                                break;
                            case Og:
                                vt = this.InterpolantFactoryMethodLinear;
                                break;
                            case Bg:
                                vt = this.InterpolantFactoryMethodSmooth;
                        }
                        if (void 0 === vt) {
                            const vt = "unsupported interpolation for " + this.ValueTypeName + " keyframe track named " + this.name;
                            if (void 0 === this.createInterpolant) {
                                if (le1 === this.DefaultInterpolation) throw new Error(vt);
                                this.setInterpolation(this.DefaultInterpolation);
                            }
                            return console.warn("THREE.KeyframeTrack:", vt), this;
                        }
                        return this.createInterpolant = vt, this;
                    }
                    getInterpolation() {
                        switch(this.createInterpolant){
                            case this.InterpolantFactoryMethodDiscrete:
                                return Fg;
                            case this.InterpolantFactoryMethodLinear:
                                return Og;
                            case this.InterpolantFactoryMethodSmooth:
                                return Bg;
                        }
                    }
                    getValueSize() {
                        return this.values.length / this.times.length;
                    }
                    shift(le1) {
                        if (0 !== le1) {
                            const vt = this.times;
                            for(let bt = 0, ls = vt.length; bt !== ls; ++bt)vt[bt] += le1;
                        }
                        return this;
                    }
                    scale(le1) {
                        if (1 !== le1) {
                            const vt = this.times;
                            for(let bt = 0, ls = vt.length; bt !== ls; ++bt)vt[bt] *= le1;
                        }
                        return this;
                    }
                    trim(le1, vt) {
                        const bt = this.times, ls = bt.length;
                        let ho = 0, Dl = ls - 1;
                        for(; ho !== ls && bt[ho] < le1;)++ho;
                        for(; -1 !== Dl && bt[Dl] > vt;)--Dl;
                        if (++Dl, 0 !== ho || Dl !== ls) {
                            ho >= Dl && (Dl = Math.max(Dl, 1), ho = Dl - 1);
                            const le1 = this.getValueSize();
                            this.times = bt.slice(ho, Dl), this.values = this.values.slice(ho * le1, Dl * le1);
                        }
                        return this;
                    }
                    validate() {
                        let le1 = !0;
                        const vt = this.getValueSize();
                        vt - Math.floor(vt) !== 0 && (console.error("THREE.KeyframeTrack: Invalid value size in track.", this), le1 = !1);
                        const bt = this.times, ls = this.values, ho = bt.length;
                        0 === ho && (console.error("THREE.KeyframeTrack: Track is empty.", this), le1 = !1);
                        let Dl = null;
                        for(let Fl = 0; Fl !== ho; Fl++){
                            const vt = bt[Fl];
                            if ("number" === typeof vt && isNaN(vt)) {
                                console.error("THREE.KeyframeTrack: Time is not a valid number.", this, Fl, vt), le1 = !1;
                                break;
                            }
                            if (null !== Dl && Dl > vt) {
                                console.error("THREE.KeyframeTrack: Out of order keys.", this, Fl, vt, Dl), le1 = !1;
                                break;
                            }
                            Dl = vt;
                        }
                        if (void 0 !== ls && isTypedArray(ls)) for(let Fl = 0, sc = ls.length; Fl !== sc; ++Fl){
                            const vt = ls[Fl];
                            if (isNaN(vt)) {
                                console.error("THREE.KeyframeTrack: Value is not a valid number.", this, Fl, vt), le1 = !1;
                                break;
                            }
                        }
                        return le1;
                    }
                    optimize() {
                        const le1 = this.times.slice(), vt = this.values.slice(), bt = this.getValueSize(), ls = this.getInterpolation() === Bg, ho = le1.length - 1;
                        let Dl = 1;
                        for(let Fl = 1; Fl < ho; ++Fl){
                            let ho = !1;
                            const sc = le1[Fl];
                            if (sc !== le1[Fl + 1] && (1 !== Fl || sc !== le1[0])) {
                                if (ls) ho = !0;
                                else {
                                    const le1 = Fl * bt, ls = le1 - bt, Dl = le1 + bt;
                                    for(let Fl = 0; Fl !== bt; ++Fl){
                                        const bt = vt[le1 + Fl];
                                        if (bt !== vt[ls + Fl] || bt !== vt[Dl + Fl]) {
                                            ho = !0;
                                            break;
                                        }
                                    }
                                }
                            }
                            if (ho) {
                                if (Fl !== Dl) {
                                    le1[Dl] = le1[Fl];
                                    const ls = Fl * bt, ho = Dl * bt;
                                    for(let le1 = 0; le1 !== bt; ++le1)vt[ho + le1] = vt[ls + le1];
                                }
                                ++Dl;
                            }
                        }
                        if (ho > 0) {
                            le1[Dl] = le1[ho];
                            for(let le1 = ho * bt, ls = Dl * bt, Fl = 0; Fl !== bt; ++Fl)vt[ls + Fl] = vt[le1 + Fl];
                            ++Dl;
                        }
                        return Dl !== le1.length ? (this.times = le1.slice(0, Dl), this.values = vt.slice(0, Dl * bt)) : (this.times = le1, this.values = vt), this;
                    }
                    clone() {
                        const le1 = this.times.slice(), vt = this.values.slice(), bt = new this.constructor(this.name, le1, vt);
                        return bt.createInterpolant = this.createInterpolant, bt;
                    }
                }
                KeyframeTrack.prototype.ValueTypeName = "", KeyframeTrack.prototype.TimeBufferType = Float32Array, KeyframeTrack.prototype.ValueBufferType = Float32Array, KeyframeTrack.prototype.DefaultInterpolation = Og;
                class BooleanKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                }
                BooleanKeyframeTrack.prototype.ValueTypeName = "bool", BooleanKeyframeTrack.prototype.ValueBufferType = Array, BooleanKeyframeTrack.prototype.DefaultInterpolation = Fg, BooleanKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0, BooleanKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class ColorKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                }
                ColorKeyframeTrack.prototype.ValueTypeName = "color";
                class NumberKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                }
                NumberKeyframeTrack.prototype.ValueTypeName = "number";
                class QuaternionLinearInterpolant extends Interpolant {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                    interpolate_(le1, vt, bt, ls) {
                        const ho = this.resultBuffer, Dl = this.sampleValues, Fl = this.valueSize, sc = (bt - vt) / (ls - vt);
                        let uc = le1 * Fl;
                        for(let mc = uc + Fl; uc !== mc; uc += 4)Quaternion.slerpFlat(ho, 0, Dl, uc - Fl, Dl, uc, sc);
                        return ho;
                    }
                }
                class QuaternionKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                    InterpolantFactoryMethodLinear(le1) {
                        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), le1);
                    }
                }
                QuaternionKeyframeTrack.prototype.ValueTypeName = "quaternion", QuaternionKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class StringKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt){
                        super(le1, vt, bt);
                    }
                }
                StringKeyframeTrack.prototype.ValueTypeName = "string", StringKeyframeTrack.prototype.ValueBufferType = Array, StringKeyframeTrack.prototype.DefaultInterpolation = Fg, StringKeyframeTrack.prototype.InterpolantFactoryMethodLinear = void 0, StringKeyframeTrack.prototype.InterpolantFactoryMethodSmooth = void 0;
                class VectorKeyframeTrack extends KeyframeTrack {
                    constructor(le1, vt, bt, ls){
                        super(le1, vt, bt, ls);
                    }
                }
                VectorKeyframeTrack.prototype.ValueTypeName = "vector";
                const My = {
                    enabled: !1,
                    files: {},
                    add: function(le1, vt) {
                        !1 !== this.enabled && (this.files[le1] = vt);
                    },
                    get: function(le1) {
                        if (!1 !== this.enabled) return this.files[le1];
                    },
                    remove: function(le1) {
                        delete this.files[le1];
                    },
                    clear: function() {
                        this.files = {};
                    }
                };
                class LoadingManager {
                    constructor(le1, vt, bt){
                        const ls = this;
                        let ho, Dl = !1, Fl = 0, sc = 0;
                        const uc = [];
                        this.onStart = void 0, this.onLoad = le1, this.onProgress = vt, this.onError = bt, this.abortController = new AbortController, this.itemStart = function(le1) {
                            sc++, !1 === Dl && void 0 !== ls.onStart && ls.onStart(le1, Fl, sc), Dl = !0;
                        }, this.itemEnd = function(le1) {
                            Fl++, void 0 !== ls.onProgress && ls.onProgress(le1, Fl, sc), Fl === sc && (Dl = !1, void 0 !== ls.onLoad && ls.onLoad());
                        }, this.itemError = function(le1) {
                            void 0 !== ls.onError && ls.onError(le1);
                        }, this.resolveURL = function(le1) {
                            return ho ? ho(le1) : le1;
                        }, this.setURLModifier = function(le1) {
                            return ho = le1, this;
                        }, this.addHandler = function(le1, vt) {
                            return uc.push(le1, vt), this;
                        }, this.removeHandler = function(le1) {
                            const vt = uc.indexOf(le1);
                            return -1 !== vt && uc.splice(vt, 2), this;
                        }, this.getHandler = function(le1) {
                            for(let vt = 0, bt = uc.length; vt < bt; vt += 2){
                                const bt = uc[vt], ls = uc[vt + 1];
                                if (bt.global && (bt.lastIndex = 0), bt.test(le1)) return ls;
                            }
                            return null;
                        }, this.abort = function() {
                            return this.abortController.abort(), this.abortController = new AbortController, this;
                        };
                    }
                }
                const Sy = new LoadingManager;
                class Loader {
                    constructor(le1){
                        this.manager = void 0 !== le1 ? le1 : Sy, this.crossOrigin = "anonymous", this.withCredentials = !1, this.path = "", this.resourcePath = "", this.requestHeader = {};
                    }
                    load() {}
                    loadAsync(le1, vt) {
                        const bt = this;
                        return new Promise(function(ls, ho) {
                            bt.load(le1, ls, vt, ho);
                        });
                    }
                    parse() {}
                    setCrossOrigin(le1) {
                        return this.crossOrigin = le1, this;
                    }
                    setWithCredentials(le1) {
                        return this.withCredentials = le1, this;
                    }
                    setPath(le1) {
                        return this.path = le1, this;
                    }
                    setResourcePath(le1) {
                        return this.resourcePath = le1, this;
                    }
                    setRequestHeader(le1) {
                        return this.requestHeader = le1, this;
                    }
                    abort() {
                        return this;
                    }
                }
                Loader.DEFAULT_MATERIAL_NAME = "__DEFAULT";
                const Ty = {};
                class HttpError extends Error {
                    constructor(le1, vt){
                        super(le1), this.response = vt;
                    }
                }
                class FileLoader extends Loader {
                    constructor(le1){
                        super(le1), this.mimeType = "", this.responseType = "", this._abortController = new AbortController;
                    }
                    load(le1, vt, bt, ls) {
                        void 0 === le1 && (le1 = ""), void 0 !== this.path && (le1 = this.path + le1), le1 = this.manager.resolveURL(le1);
                        const ho = My.get(`file:${le1}`);
                        if (void 0 !== ho) return this.manager.itemStart(le1), setTimeout(()=>{
                            vt && vt(ho), this.manager.itemEnd(le1);
                        }, 0), ho;
                        if (void 0 !== Ty[le1]) return void Ty[le1].push({
                            onLoad: vt,
                            onProgress: bt,
                            onError: ls
                        });
                        Ty[le1] = [], Ty[le1].push({
                            onLoad: vt,
                            onProgress: bt,
                            onError: ls
                        });
                        const Dl = new Request(le1, {
                            headers: new Headers(this.requestHeader),
                            credentials: this.withCredentials ? "include" : "same-origin",
                            signal: "function" === typeof AbortSignal.any ? AbortSignal.any([
                                this._abortController.signal,
                                this.manager.abortController.signal
                            ]) : this._abortController.signal
                        }), Fl = this.mimeType, sc = this.responseType;
                        fetch(Dl).then((vt)=>{
                            if (200 === vt.status || 0 === vt.status) {
                                if (0 === vt.status && console.warn("THREE.FileLoader: HTTP Status 0 received."), "undefined" === typeof ReadableStream || void 0 === vt.body || void 0 === vt.body.getReader) return vt;
                                const bt = Ty[le1], ls = vt.body.getReader(), ho = vt.headers.get("X-File-Size") || vt.headers.get("Content-Length"), Dl = ho ? parseInt(ho) : 0, Fl = 0 !== Dl;
                                let sc = 0;
                                const uc = new ReadableStream({
                                    start (le1) {
                                        !function readData() {
                                            ls.read().then((vt)=>{
                                                let { done: ls, value: ho } = vt;
                                                if (ls) le1.close();
                                                else {
                                                    sc += ho.byteLength;
                                                    const vt = new ProgressEvent("progress", {
                                                        lengthComputable: Fl,
                                                        loaded: sc,
                                                        total: Dl
                                                    });
                                                    for(let le1 = 0, ls = bt.length; le1 < ls; le1++){
                                                        const ls = bt[le1];
                                                        ls.onProgress && ls.onProgress(vt);
                                                    }
                                                    le1.enqueue(ho), readData();
                                                }
                                            }, (vt)=>{
                                                le1.error(vt);
                                            });
                                        }();
                                    }
                                });
                                return new Response(uc);
                            }
                            throw new HttpError(`fetch for "${vt.url}" responded with ${vt.status}: ${vt.statusText}`, vt);
                        }).then((le1)=>{
                            switch(sc){
                                case "arraybuffer":
                                    return le1.arrayBuffer();
                                case "blob":
                                    return le1.blob();
                                case "document":
                                    return le1.text().then((le1)=>(new DOMParser).parseFromString(le1, Fl));
                                case "json":
                                    return le1.json();
                                default:
                                    if ("" === Fl) return le1.text();
                                    {
                                        const vt = /charset="?([^;"\s]*)"?/i.exec(Fl), bt = vt && vt[1] ? vt[1].toLowerCase() : void 0, ls = new TextDecoder(bt);
                                        return le1.arrayBuffer().then((le1)=>ls.decode(le1));
                                    }
                            }
                        }).then((vt)=>{
                            My.add(`file:${le1}`, vt);
                            const bt = Ty[le1];
                            delete Ty[le1];
                            for(let le1 = 0, ls = bt.length; le1 < ls; le1++){
                                const ls = bt[le1];
                                ls.onLoad && ls.onLoad(vt);
                            }
                        }).catch((vt)=>{
                            const bt = Ty[le1];
                            if (void 0 === bt) throw this.manager.itemError(le1), vt;
                            delete Ty[le1];
                            for(let le1 = 0, ls = bt.length; le1 < ls; le1++){
                                const ls = bt[le1];
                                ls.onError && ls.onError(vt);
                            }
                            this.manager.itemError(le1);
                        }).finally(()=>{
                            this.manager.itemEnd(le1);
                        }), this.manager.itemStart(le1);
                    }
                    setResponseType(le1) {
                        return this.responseType = le1, this;
                    }
                    setMimeType(le1) {
                        return this.mimeType = le1, this;
                    }
                    abort() {
                        return this._abortController.abort(), this._abortController = new AbortController, this;
                    }
                }
                const ky = new WeakMap;
                class ImageLoader extends Loader {
                    constructor(le1){
                        super(le1);
                    }
                    load(le1, vt, bt, ls) {
                        void 0 !== this.path && (le1 = this.path + le1), le1 = this.manager.resolveURL(le1);
                        const ho = this, Dl = My.get(`image:${le1}`);
                        if (void 0 !== Dl) {
                            if (!0 === Dl.complete) ho.manager.itemStart(le1), setTimeout(function() {
                                vt && vt(Dl), ho.manager.itemEnd(le1);
                            }, 0);
                            else {
                                let le1 = ky.get(Dl);
                                void 0 === le1 && (le1 = [], ky.set(Dl, le1)), le1.push({
                                    onLoad: vt,
                                    onError: ls
                                });
                            }
                            return Dl;
                        }
                        const Fl = createElementNS("img");
                        function onImageLoad() {
                            removeEventListeners(), vt && vt(this);
                            const bt = ky.get(this) || [];
                            for(let le1 = 0; le1 < bt.length; le1++){
                                const vt = bt[le1];
                                vt.onLoad && vt.onLoad(this);
                            }
                            ky.delete(this), ho.manager.itemEnd(le1);
                        }
                        function onImageError(vt) {
                            removeEventListeners(), ls && ls(vt), My.remove(`image:${le1}`);
                            const bt = ky.get(this) || [];
                            for(let le1 = 0; le1 < bt.length; le1++){
                                const ls = bt[le1];
                                ls.onError && ls.onError(vt);
                            }
                            ky.delete(this), ho.manager.itemError(le1), ho.manager.itemEnd(le1);
                        }
                        function removeEventListeners() {
                            Fl.removeEventListener("load", onImageLoad, !1), Fl.removeEventListener("error", onImageError, !1);
                        }
                        return Fl.addEventListener("load", onImageLoad, !1), Fl.addEventListener("error", onImageError, !1), "data:" !== le1.slice(0, 5) && void 0 !== this.crossOrigin && (Fl.crossOrigin = this.crossOrigin), My.add(`image:${le1}`, Fl), ho.manager.itemStart(le1), Fl.src = le1, Fl;
                    }
                }
                class OrthographicCamera extends Camera {
                    constructor(le1, vt, bt, ls, ho, Dl){
                        void 0 === le1 && (le1 = -1), void 0 === vt && (vt = 1), void 0 === bt && (bt = 1), void 0 === ls && (ls = -1), void 0 === ho && (ho = .1), void 0 === Dl && (Dl = 2e3), super(), this.isOrthographicCamera = !0, this.type = "OrthographicCamera", this.zoom = 1, this.view = null, this.left = le1, this.right = vt, this.top = bt, this.bottom = ls, this.near = ho, this.far = Dl, this.updateProjectionMatrix();
                    }
                    copy(le1, vt) {
                        return super.copy(le1, vt), this.left = le1.left, this.right = le1.right, this.top = le1.top, this.bottom = le1.bottom, this.near = le1.near, this.far = le1.far, this.zoom = le1.zoom, this.view = null === le1.view ? null : Object.assign({}, le1.view), this;
                    }
                    setViewOffset(le1, vt, bt, ls, ho, Dl) {
                        null === this.view && (this.view = {
                            enabled: !0,
                            fullWidth: 1,
                            fullHeight: 1,
                            offsetX: 0,
                            offsetY: 0,
                            width: 1,
                            height: 1
                        }), this.view.enabled = !0, this.view.fullWidth = le1, this.view.fullHeight = vt, this.view.offsetX = bt, this.view.offsetY = ls, this.view.width = ho, this.view.height = Dl, this.updateProjectionMatrix();
                    }
                    clearViewOffset() {
                        null !== this.view && (this.view.enabled = !1), this.updateProjectionMatrix();
                    }
                    updateProjectionMatrix() {
                        const le1 = (this.right - this.left) / (2 * this.zoom), vt = (this.top - this.bottom) / (2 * this.zoom), bt = (this.right + this.left) / 2, ls = (this.top + this.bottom) / 2;
                        let ho = bt - le1, Dl = bt + le1, Fl = ls + vt, sc = ls - vt;
                        if (null !== this.view && this.view.enabled) {
                            const le1 = (this.right - this.left) / this.view.fullWidth / this.zoom, vt = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
                            ho += le1 * this.view.offsetX, Dl = ho + le1 * this.view.width, Fl -= vt * this.view.offsetY, sc = Fl - vt * this.view.height;
                        }
                        this.projectionMatrix.makeOrthographic(ho, Dl, Fl, sc, this.near, this.far, this.coordinateSystem, this.reversedDepth), this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
                    }
                    toJSON(le1) {
                        const vt = super.toJSON(le1);
                        return vt.object.zoom = this.zoom, vt.object.left = this.left, vt.object.right = this.right, vt.object.top = this.top, vt.object.bottom = this.bottom, vt.object.near = this.near, vt.object.far = this.far, null !== this.view && (vt.object.view = Object.assign({}, this.view)), vt;
                    }
                }
                new WeakMap;
                class ArrayCamera extends PerspectiveCamera {
                    constructor(le1){
                        void 0 === le1 && (le1 = []), super(), this.isArrayCamera = !0, this.isMultiViewCamera = !1, this.cameras = le1;
                    }
                }
                const Cy = "\\[\\]\\.:\\/", Iy = new RegExp("[" + Cy + "]", "g"), Dy = "[^" + Cy + "]", Ly = "[^" + Cy.replace("\\.", "") + "]", Py = new RegExp("^" + /((?:WC+[\/:])*)/.source.replace("WC", Dy) + /(WCOD+)?/.source.replace("WCOD", Ly) + /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace("WC", Dy) + /\.(WC+)(?:\[(.+)\])?/.source.replace("WC", Dy) + "$"), zy = [
                    "material",
                    "materials",
                    "bones",
                    "map"
                ];
                class PropertyBinding {
                    constructor(le1, vt, bt){
                        this.path = vt, this.parsedPath = bt || PropertyBinding.parseTrackName(vt), this.node = PropertyBinding.findNode(le1, this.parsedPath.nodeName), this.rootNode = le1, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
                    }
                    static create(le1, vt, bt) {
                        return le1 && le1.isAnimationObjectGroup ? new PropertyBinding.Composite(le1, vt, bt) : new PropertyBinding(le1, vt, bt);
                    }
                    static sanitizeNodeName(le1) {
                        return le1.replace(/\s/g, "_").replace(Iy, "");
                    }
                    static parseTrackName(le1) {
                        const vt = Py.exec(le1);
                        if (null === vt) throw new Error("PropertyBinding: Cannot parse trackName: " + le1);
                        const bt = {
                            nodeName: vt[2],
                            objectName: vt[3],
                            objectIndex: vt[4],
                            propertyName: vt[5],
                            propertyIndex: vt[6]
                        }, ls = bt.nodeName && bt.nodeName.lastIndexOf(".");
                        if (void 0 !== ls && -1 !== ls) {
                            const le1 = bt.nodeName.substring(ls + 1);
                            -1 !== zy.indexOf(le1) && (bt.nodeName = bt.nodeName.substring(0, ls), bt.objectName = le1);
                        }
                        if (null === bt.propertyName || 0 === bt.propertyName.length) throw new Error("PropertyBinding: can not parse propertyName from trackName: " + le1);
                        return bt;
                    }
                    static findNode(le1, vt) {
                        if (void 0 === vt || "" === vt || "." === vt || -1 === vt || vt === le1.name || vt === le1.uuid) return le1;
                        if (le1.skeleton) {
                            const bt = le1.skeleton.getBoneByName(vt);
                            if (void 0 !== bt) return bt;
                        }
                        if (le1.children) {
                            const searchNodeSubtree = function(le1) {
                                for(let bt = 0; bt < le1.length; bt++){
                                    const ls = le1[bt];
                                    if (ls.name === vt || ls.uuid === vt) return ls;
                                    const ho = searchNodeSubtree(ls.children);
                                    if (ho) return ho;
                                }
                                return null;
                            }, bt = searchNodeSubtree(le1.children);
                            if (bt) return bt;
                        }
                        return null;
                    }
                    _getValue_unavailable() {}
                    _setValue_unavailable() {}
                    _getValue_direct(le1, vt) {
                        le1[vt] = this.targetObject[this.propertyName];
                    }
                    _getValue_array(le1, vt) {
                        const bt = this.resolvedProperty;
                        for(let ls = 0, ho = bt.length; ls !== ho; ++ls)le1[vt++] = bt[ls];
                    }
                    _getValue_arrayElement(le1, vt) {
                        le1[vt] = this.resolvedProperty[this.propertyIndex];
                    }
                    _getValue_toArray(le1, vt) {
                        this.resolvedProperty.toArray(le1, vt);
                    }
                    _setValue_direct(le1, vt) {
                        this.targetObject[this.propertyName] = le1[vt];
                    }
                    _setValue_direct_setNeedsUpdate(le1, vt) {
                        this.targetObject[this.propertyName] = le1[vt], this.targetObject.needsUpdate = !0;
                    }
                    _setValue_direct_setMatrixWorldNeedsUpdate(le1, vt) {
                        this.targetObject[this.propertyName] = le1[vt], this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_array(le1, vt) {
                        const bt = this.resolvedProperty;
                        for(let ls = 0, ho = bt.length; ls !== ho; ++ls)bt[ls] = le1[vt++];
                    }
                    _setValue_array_setNeedsUpdate(le1, vt) {
                        const bt = this.resolvedProperty;
                        for(let ls = 0, ho = bt.length; ls !== ho; ++ls)bt[ls] = le1[vt++];
                        this.targetObject.needsUpdate = !0;
                    }
                    _setValue_array_setMatrixWorldNeedsUpdate(le1, vt) {
                        const bt = this.resolvedProperty;
                        for(let ls = 0, ho = bt.length; ls !== ho; ++ls)bt[ls] = le1[vt++];
                        this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_arrayElement(le1, vt) {
                        this.resolvedProperty[this.propertyIndex] = le1[vt];
                    }
                    _setValue_arrayElement_setNeedsUpdate(le1, vt) {
                        this.resolvedProperty[this.propertyIndex] = le1[vt], this.targetObject.needsUpdate = !0;
                    }
                    _setValue_arrayElement_setMatrixWorldNeedsUpdate(le1, vt) {
                        this.resolvedProperty[this.propertyIndex] = le1[vt], this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _setValue_fromArray(le1, vt) {
                        this.resolvedProperty.fromArray(le1, vt);
                    }
                    _setValue_fromArray_setNeedsUpdate(le1, vt) {
                        this.resolvedProperty.fromArray(le1, vt), this.targetObject.needsUpdate = !0;
                    }
                    _setValue_fromArray_setMatrixWorldNeedsUpdate(le1, vt) {
                        this.resolvedProperty.fromArray(le1, vt), this.targetObject.matrixWorldNeedsUpdate = !0;
                    }
                    _getValue_unbound(le1, vt) {
                        this.bind(), this.getValue(le1, vt);
                    }
                    _setValue_unbound(le1, vt) {
                        this.bind(), this.setValue(le1, vt);
                    }
                    bind() {
                        let le1 = this.node;
                        const vt = this.parsedPath, bt = vt.objectName, ls = vt.propertyName;
                        let ho = vt.propertyIndex;
                        if (le1 || (le1 = PropertyBinding.findNode(this.rootNode, vt.nodeName), this.node = le1), this.getValue = this._getValue_unavailable, this.setValue = this._setValue_unavailable, !le1) return void console.warn("THREE.PropertyBinding: No target node found for track: " + this.path + ".");
                        if (bt) {
                            let ls = vt.objectIndex;
                            switch(bt){
                                case "materials":
                                    if (!le1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                                    if (!le1.material.materials) return void console.error("THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.", this);
                                    le1 = le1.material.materials;
                                    break;
                                case "bones":
                                    if (!le1.skeleton) return void console.error("THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.", this);
                                    le1 = le1.skeleton.bones;
                                    for(let vt = 0; vt < le1.length; vt++)if (le1[vt].name === ls) {
                                        ls = vt;
                                        break;
                                    }
                                    break;
                                case "map":
                                    if ("map" in le1) {
                                        le1 = le1.map;
                                        break;
                                    }
                                    if (!le1.material) return void console.error("THREE.PropertyBinding: Can not bind to material as node does not have a material.", this);
                                    if (!le1.material.map) return void console.error("THREE.PropertyBinding: Can not bind to material.map as node.material does not have a map.", this);
                                    le1 = le1.material.map;
                                    break;
                                default:
                                    if (void 0 === le1[bt]) return void console.error("THREE.PropertyBinding: Can not bind to objectName of node undefined.", this);
                                    le1 = le1[bt];
                            }
                            if (void 0 !== ls) {
                                if (void 0 === le1[ls]) return void console.error("THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.", this, le1);
                                le1 = le1[ls];
                            }
                        }
                        const Dl = le1[ls];
                        if (void 0 === Dl) {
                            const bt = vt.nodeName;
                            return void console.error("THREE.PropertyBinding: Trying to update property for track: " + bt + "." + ls + " but it wasn't found.", le1);
                        }
                        let Fl = this.Versioning.None;
                        this.targetObject = le1, !0 === le1.isMaterial ? Fl = this.Versioning.NeedsUpdate : !0 === le1.isObject3D && (Fl = this.Versioning.MatrixWorldNeedsUpdate);
                        let sc = this.BindingType.Direct;
                        if (void 0 !== ho) {
                            if ("morphTargetInfluences" === ls) {
                                if (!le1.geometry) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.", this);
                                if (!le1.geometry.morphAttributes) return void console.error("THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.", this);
                                void 0 !== le1.morphTargetDictionary[ho] && (ho = le1.morphTargetDictionary[ho]);
                            }
                            sc = this.BindingType.ArrayElement, this.resolvedProperty = Dl, this.propertyIndex = ho;
                        } else void 0 !== Dl.fromArray && void 0 !== Dl.toArray ? (sc = this.BindingType.HasFromToArray, this.resolvedProperty = Dl) : Array.isArray(Dl) ? (sc = this.BindingType.EntireArray, this.resolvedProperty = Dl) : this.propertyName = ls;
                        this.getValue = this.GetterByBindingType[sc], this.setValue = this.SetterByBindingTypeAndVersioning[sc][Fl];
                    }
                    unbind() {
                        this.node = null, this.getValue = this._getValue_unbound, this.setValue = this._setValue_unbound;
                    }
                }
                PropertyBinding.Composite = class {
                    constructor(le1, vt, bt){
                        const ls = bt || PropertyBinding.parseTrackName(vt);
                        this._targetGroup = le1, this._bindings = le1.subscribe_(vt, ls);
                    }
                    getValue(le1, vt) {
                        this.bind();
                        const bt = this._targetGroup.nCachedObjects_, ls = this._bindings[bt];
                        void 0 !== ls && ls.getValue(le1, vt);
                    }
                    setValue(le1, vt) {
                        const bt = this._bindings;
                        for(let ls = this._targetGroup.nCachedObjects_, ho = bt.length; ls !== ho; ++ls)bt[ls].setValue(le1, vt);
                    }
                    bind() {
                        const le1 = this._bindings;
                        for(let vt = this._targetGroup.nCachedObjects_, bt = le1.length; vt !== bt; ++vt)le1[vt].bind();
                    }
                    unbind() {
                        const le1 = this._bindings;
                        for(let vt = this._targetGroup.nCachedObjects_, bt = le1.length; vt !== bt; ++vt)le1[vt].unbind();
                    }
                }, PropertyBinding.prototype.BindingType = {
                    Direct: 0,
                    EntireArray: 1,
                    ArrayElement: 2,
                    HasFromToArray: 3
                }, PropertyBinding.prototype.Versioning = {
                    None: 0,
                    NeedsUpdate: 1,
                    MatrixWorldNeedsUpdate: 2
                }, PropertyBinding.prototype.GetterByBindingType = [
                    PropertyBinding.prototype._getValue_direct,
                    PropertyBinding.prototype._getValue_array,
                    PropertyBinding.prototype._getValue_arrayElement,
                    PropertyBinding.prototype._getValue_toArray
                ], PropertyBinding.prototype.SetterByBindingTypeAndVersioning = [
                    [
                        PropertyBinding.prototype._setValue_direct,
                        PropertyBinding.prototype._setValue_direct_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_direct_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_array,
                        PropertyBinding.prototype._setValue_array_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_array_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_arrayElement,
                        PropertyBinding.prototype._setValue_arrayElement_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_arrayElement_setMatrixWorldNeedsUpdate
                    ],
                    [
                        PropertyBinding.prototype._setValue_fromArray,
                        PropertyBinding.prototype._setValue_fromArray_setNeedsUpdate,
                        PropertyBinding.prototype._setValue_fromArray_setMatrixWorldNeedsUpdate
                    ]
                ];
                new Float32Array(1);
                const Ny = new Matrix4;
                class Raycaster {
                    constructor(le1, vt, bt, ls){
                        void 0 === bt && (bt = 0), void 0 === ls && (ls = 1 / 0), this.ray = new Ray(le1, vt), this.near = bt, this.far = ls, this.camera = null, this.layers = new Layers, this.params = {
                            Mesh: {},
                            Line: {
                                threshold: 1
                            },
                            LOD: {},
                            Points: {
                                threshold: 1
                            },
                            Sprite: {}
                        };
                    }
                    set(le1, vt) {
                        this.ray.set(le1, vt);
                    }
                    setFromCamera(le1, vt) {
                        vt.isPerspectiveCamera ? (this.ray.origin.setFromMatrixPosition(vt.matrixWorld), this.ray.direction.set(le1.x, le1.y, .5).unproject(vt).sub(this.ray.origin).normalize(), this.camera = vt) : vt.isOrthographicCamera ? (this.ray.origin.set(le1.x, le1.y, (vt.near + vt.far) / (vt.near - vt.far)).unproject(vt), this.ray.direction.set(0, 0, -1).transformDirection(vt.matrixWorld), this.camera = vt) : console.error("THREE.Raycaster: Unsupported camera type: " + vt.type);
                    }
                    setFromXRController(le1) {
                        return Ny.identity().extractRotation(le1.matrixWorld), this.ray.origin.setFromMatrixPosition(le1.matrixWorld), this.ray.direction.set(0, 0, -1).applyMatrix4(Ny), this;
                    }
                    intersectObject(le1, vt, bt) {
                        return void 0 === vt && (vt = !0), void 0 === bt && (bt = []), intersect(le1, this, bt, vt), bt.sort(ascSort), bt;
                    }
                    intersectObjects(le1, vt, bt) {
                        void 0 === vt && (vt = !0), void 0 === bt && (bt = []);
                        for(let ls = 0, ho = le1.length; ls < ho; ls++)intersect(le1[ls], this, bt, vt);
                        return bt.sort(ascSort), bt;
                    }
                }
                function ascSort(le1, vt) {
                    return le1.distance - vt.distance;
                }
                function intersect(le1, vt, bt, ls) {
                    let ho = !0;
                    if (le1.layers.test(vt.layers)) !1 === le1.raycast(vt, bt) && (ho = !1);
                    if (!0 === ho && !0 === ls) {
                        const ls = le1.children;
                        for(let le1 = 0, ho = ls.length; le1 < ho; le1++)intersect(ls[le1], vt, bt, !0);
                    }
                }
                function getByteLength(le1, vt, bt, ls) {
                    const ho = function(le1) {
                        switch(le1){
                            case Fm:
                            case Om:
                                return {
                                    byteLength: 1,
                                    components: 1
                                };
                            case jm:
                            case Bm:
                            case qm:
                                return {
                                    byteLength: 2,
                                    components: 1
                                };
                            case Hm:
                            case Wm:
                                return {
                                    byteLength: 2,
                                    components: 4
                                };
                            case Vm:
                            case Um:
                            case Gm:
                                return {
                                    byteLength: 4,
                                    components: 1
                                };
                            case Ym:
                                return {
                                    byteLength: 4,
                                    components: 3
                                };
                        }
                        throw new Error(`Unknown texture type ${le1}.`);
                    }(ls);
                    switch(bt){
                        case Qm:
                            return le1 * vt;
                        case eg:
                        case tg:
                            return le1 * vt / ho.components * ho.byteLength;
                        case ig:
                        case ng:
                            return le1 * vt * 2 / ho.components * ho.byteLength;
                        case Xm:
                            return le1 * vt * 3 / ho.components * ho.byteLength;
                        case Km:
                        case rg:
                            return le1 * vt * 4 / ho.components * ho.byteLength;
                        case ag:
                        case sg:
                            return Math.floor((le1 + 3) / 4) * Math.floor((vt + 3) / 4) * 8;
                        case og:
                        case lg:
                            return Math.floor((le1 + 3) / 4) * Math.floor((vt + 3) / 4) * 16;
                        case ug:
                        case dg:
                            return Math.max(le1, 16) * Math.max(vt, 8) / 4;
                        case cg:
                        case hg:
                            return Math.max(le1, 8) * Math.max(vt, 8) / 2;
                        case pg:
                        case mg:
                            return Math.floor((le1 + 3) / 4) * Math.floor((vt + 3) / 4) * 8;
                        case fg:
                        case gg:
                            return Math.floor((le1 + 3) / 4) * Math.floor((vt + 3) / 4) * 16;
                        case Ag:
                            return Math.floor((le1 + 4) / 5) * Math.floor((vt + 3) / 4) * 16;
                        case _g:
                            return Math.floor((le1 + 4) / 5) * Math.floor((vt + 4) / 5) * 16;
                        case yg:
                            return Math.floor((le1 + 5) / 6) * Math.floor((vt + 4) / 5) * 16;
                        case vg:
                            return Math.floor((le1 + 5) / 6) * Math.floor((vt + 5) / 6) * 16;
                        case xg:
                            return Math.floor((le1 + 7) / 8) * Math.floor((vt + 4) / 5) * 16;
                        case bg:
                            return Math.floor((le1 + 7) / 8) * Math.floor((vt + 5) / 6) * 16;
                        case wg:
                            return Math.floor((le1 + 7) / 8) * Math.floor((vt + 7) / 8) * 16;
                        case Eg:
                            return Math.floor((le1 + 9) / 10) * Math.floor((vt + 4) / 5) * 16;
                        case Mg:
                            return Math.floor((le1 + 9) / 10) * Math.floor((vt + 5) / 6) * 16;
                        case Sg:
                            return Math.floor((le1 + 9) / 10) * Math.floor((vt + 7) / 8) * 16;
                        case Tg:
                            return Math.floor((le1 + 9) / 10) * Math.floor((vt + 9) / 10) * 16;
                        case kg:
                            return Math.floor((le1 + 11) / 12) * Math.floor((vt + 9) / 10) * 16;
                        case Cg:
                            return Math.floor((le1 + 11) / 12) * Math.floor((vt + 11) / 12) * 16;
                        case Ig:
                        case Dg:
                        case Lg:
                            return Math.ceil(le1 / 4) * Math.ceil(vt / 4) * 16;
                        case Pg:
                        case zg:
                            return Math.ceil(le1 / 4) * Math.ceil(vt / 4) * 8;
                        case Ng:
                        case Rg:
                            return Math.ceil(le1 / 4) * Math.ceil(vt / 4) * 16;
                    }
                    throw new Error(`Unable to determine texture byte length for ${bt} format.`);
                }
                "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("register", {
                    detail: {
                        revision: ls
                    }
                })), "undefined" !== typeof window && (window.__THREE__ ? console.warn("WARNING: Multiple instances of Three.js being imported.") : window.__THREE__ = ls);
            },
            9408: (le1, vt, bt)=>{
                "use strict";
                bt.d(vt, {
                    JeP: ()=>WebGLRenderer
                });
                var ls = bt(9435);
                /**
 * @license
 * Copyright 2010-2025 Three.js Authors
 * SPDX-License-Identifier: MIT
 */ function WebGLAnimation() {
                    let le1 = null, vt = !1, bt = null, ls = null;
                    function onAnimationFrame(vt, ho) {
                        bt(vt, ho), ls = le1.requestAnimationFrame(onAnimationFrame);
                    }
                    return {
                        start: function() {
                            !0 !== vt && null !== bt && (ls = le1.requestAnimationFrame(onAnimationFrame), vt = !0);
                        },
                        stop: function() {
                            le1.cancelAnimationFrame(ls), vt = !1;
                        },
                        setAnimationLoop: function(le1) {
                            bt = le1;
                        },
                        setContext: function(vt) {
                            le1 = vt;
                        }
                    };
                }
                function WebGLAttributes(le1) {
                    const vt = new WeakMap;
                    return {
                        get: function(le1) {
                            return le1.isInterleavedBufferAttribute && (le1 = le1.data), vt.get(le1);
                        },
                        remove: function(bt) {
                            bt.isInterleavedBufferAttribute && (bt = bt.data);
                            const ls = vt.get(bt);
                            ls && (le1.deleteBuffer(ls.buffer), vt.delete(bt));
                        },
                        update: function(bt, ls) {
                            if (bt.isInterleavedBufferAttribute && (bt = bt.data), bt.isGLBufferAttribute) {
                                const le1 = vt.get(bt);
                                return void ((!le1 || le1.version < bt.version) && vt.set(bt, {
                                    buffer: bt.buffer,
                                    type: bt.type,
                                    bytesPerElement: bt.elementSize,
                                    version: bt.version
                                }));
                            }
                            const ho = vt.get(bt);
                            if (void 0 === ho) vt.set(bt, function(vt, bt) {
                                const ls = vt.array, ho = vt.usage, Dl = ls.byteLength, Fl = le1.createBuffer();
                                let sc;
                                if (le1.bindBuffer(bt, Fl), le1.bufferData(bt, ls, ho), vt.onUploadCallback(), ls instanceof Float32Array) sc = le1.FLOAT;
                                else if ("undefined" !== typeof Float16Array && ls instanceof Float16Array) sc = le1.HALF_FLOAT;
                                else if (ls instanceof Uint16Array) sc = vt.isFloat16BufferAttribute ? le1.HALF_FLOAT : le1.UNSIGNED_SHORT;
                                else if (ls instanceof Int16Array) sc = le1.SHORT;
                                else if (ls instanceof Uint32Array) sc = le1.UNSIGNED_INT;
                                else if (ls instanceof Int32Array) sc = le1.INT;
                                else if (ls instanceof Int8Array) sc = le1.BYTE;
                                else if (ls instanceof Uint8Array) sc = le1.UNSIGNED_BYTE;
                                else {
                                    if (!(ls instanceof Uint8ClampedArray)) throw new Error("THREE.WebGLAttributes: Unsupported buffer data format: " + ls);
                                    sc = le1.UNSIGNED_BYTE;
                                }
                                return {
                                    buffer: Fl,
                                    type: sc,
                                    bytesPerElement: ls.BYTES_PER_ELEMENT,
                                    version: vt.version,
                                    size: Dl
                                };
                            }(bt, ls));
                            else if (ho.version < bt.version) {
                                if (ho.size !== bt.array.byteLength) throw new Error("THREE.WebGLAttributes: The size of the buffer attribute's array buffer does not match the original size. Resizing buffer attributes is not supported.");
                                !function(vt, bt, ls) {
                                    const ho = bt.array, Dl = bt.updateRanges;
                                    if (le1.bindBuffer(ls, vt), 0 === Dl.length) le1.bufferSubData(ls, 0, ho);
                                    else {
                                        Dl.sort((le1, vt)=>le1.start - vt.start);
                                        let vt = 0;
                                        for(let le1 = 1; le1 < Dl.length; le1++){
                                            const bt = Dl[vt], ls = Dl[le1];
                                            ls.start <= bt.start + bt.count + 1 ? bt.count = Math.max(bt.count, ls.start + ls.count - bt.start) : (++vt, Dl[vt] = ls);
                                        }
                                        Dl.length = vt + 1;
                                        for(let bt = 0, Fl = Dl.length; bt < Fl; bt++){
                                            const vt = Dl[bt];
                                            le1.bufferSubData(ls, vt.start * ho.BYTES_PER_ELEMENT, ho, vt.start, vt.count);
                                        }
                                        bt.clearUpdateRanges();
                                    }
                                    bt.onUploadCallback();
                                }(ho.buffer, bt, ls), ho.version = bt.version;
                            }
                        }
                    };
                }
                const ho = {
                    alphahash_fragment: "#ifdef USE_ALPHAHASH\n\tif ( diffuseColor.a < getAlphaHashThreshold( vPosition ) ) discard;\n#endif",
                    alphahash_pars_fragment: "#ifdef USE_ALPHAHASH\n\tconst float ALPHA_HASH_SCALE = 0.05;\n\tfloat hash2D( vec2 value ) {\n\t\treturn fract( 1.0e4 * sin( 17.0 * value.x + 0.1 * value.y ) * ( 0.1 + abs( sin( 13.0 * value.y + value.x ) ) ) );\n\t}\n\tfloat hash3D( vec3 value ) {\n\t\treturn hash2D( vec2( hash2D( value.xy ), value.z ) );\n\t}\n\tfloat getAlphaHashThreshold( vec3 position ) {\n\t\tfloat maxDeriv = max(\n\t\t\tlength( dFdx( position.xyz ) ),\n\t\t\tlength( dFdy( position.xyz ) )\n\t\t);\n\t\tfloat pixScale = 1.0 / ( ALPHA_HASH_SCALE * maxDeriv );\n\t\tvec2 pixScales = vec2(\n\t\t\texp2( floor( log2( pixScale ) ) ),\n\t\t\texp2( ceil( log2( pixScale ) ) )\n\t\t);\n\t\tvec2 alpha = vec2(\n\t\t\thash3D( floor( pixScales.x * position.xyz ) ),\n\t\t\thash3D( floor( pixScales.y * position.xyz ) )\n\t\t);\n\t\tfloat lerpFactor = fract( log2( pixScale ) );\n\t\tfloat x = ( 1.0 - lerpFactor ) * alpha.x + lerpFactor * alpha.y;\n\t\tfloat a = min( lerpFactor, 1.0 - lerpFactor );\n\t\tvec3 cases = vec3(\n\t\t\tx * x / ( 2.0 * a * ( 1.0 - a ) ),\n\t\t\t( x - 0.5 * a ) / ( 1.0 - a ),\n\t\t\t1.0 - ( ( 1.0 - x ) * ( 1.0 - x ) / ( 2.0 * a * ( 1.0 - a ) ) )\n\t\t);\n\t\tfloat threshold = ( x < ( 1.0 - a ) )\n\t\t\t? ( ( x < a ) ? cases.x : cases.y )\n\t\t\t: cases.z;\n\t\treturn clamp( threshold , 1.0e-6, 1.0 );\n\t}\n#endif",
                    alphamap_fragment: "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vAlphaMapUv ).g;\n#endif",
                    alphamap_pars_fragment: "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
                    alphatest_fragment: "#ifdef USE_ALPHATEST\n\t#ifdef ALPHA_TO_COVERAGE\n\tdiffuseColor.a = smoothstep( alphaTest, alphaTest + fwidth( diffuseColor.a ), diffuseColor.a );\n\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\tif ( diffuseColor.a < alphaTest ) discard;\n\t#endif\n#endif",
                    alphatest_pars_fragment: "#ifdef USE_ALPHATEST\n\tuniform float alphaTest;\n#endif",
                    aomap_fragment: "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vAoMapUv ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_CLEARCOAT ) \n\t\tclearcoatSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_SHEEN ) \n\t\tsheenSpecularIndirect *= ambientOcclusion;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometryNormal, geometryViewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.roughness );\n\t#endif\n#endif",
                    aomap_pars_fragment: "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif",
                    batching_pars_vertex: "#ifdef USE_BATCHING\n\t#if ! defined( GL_ANGLE_multi_draw )\n\t#define gl_DrawID _gl_DrawID\n\tuniform int _gl_DrawID;\n\t#endif\n\tuniform highp sampler2D batchingTexture;\n\tuniform highp usampler2D batchingIdTexture;\n\tmat4 getBatchingMatrix( const in float i ) {\n\t\tint size = textureSize( batchingTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( batchingTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( batchingTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( batchingTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( batchingTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n\tfloat getIndirectIndex( const in int i ) {\n\t\tint size = textureSize( batchingIdTexture, 0 ).x;\n\t\tint x = i % size;\n\t\tint y = i / size;\n\t\treturn float( texelFetch( batchingIdTexture, ivec2( x, y ), 0 ).r );\n\t}\n#endif\n#ifdef USE_BATCHING_COLOR\n\tuniform sampler2D batchingColorTexture;\n\tvec3 getBatchingColor( const in float i ) {\n\t\tint size = textureSize( batchingColorTexture, 0 ).x;\n\t\tint j = int( i );\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\treturn texelFetch( batchingColorTexture, ivec2( x, y ), 0 ).rgb;\n\t}\n#endif",
                    batching_vertex: "#ifdef USE_BATCHING\n\tmat4 batchingMatrix = getBatchingMatrix( getIndirectIndex( gl_DrawID ) );\n#endif",
                    begin_vertex: "vec3 transformed = vec3( position );\n#ifdef USE_ALPHAHASH\n\tvPosition = vec3( position );\n#endif",
                    beginnormal_vertex: "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif",
                    bsdfs: "float G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_BlinnPhong( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, 1.0, dotVH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n} // validated",
                    iridescence_fragment: "#ifdef USE_IRIDESCENCE\n\tconst mat3 XYZ_TO_REC709 = mat3(\n\t\t 3.2404542, -0.9692660,  0.0556434,\n\t\t-1.5371385,  1.8760108, -0.2040259,\n\t\t-0.4985314,  0.0415560,  1.0572252\n\t);\n\tvec3 Fresnel0ToIor( vec3 fresnel0 ) {\n\t\tvec3 sqrtF0 = sqrt( fresnel0 );\n\t\treturn ( vec3( 1.0 ) + sqrtF0 ) / ( vec3( 1.0 ) - sqrtF0 );\n\t}\n\tvec3 IorToFresnel0( vec3 transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - vec3( incidentIor ) ) / ( transmittedIor + vec3( incidentIor ) ) );\n\t}\n\tfloat IorToFresnel0( float transmittedIor, float incidentIor ) {\n\t\treturn pow2( ( transmittedIor - incidentIor ) / ( transmittedIor + incidentIor ));\n\t}\n\tvec3 evalSensitivity( float OPD, vec3 shift ) {\n\t\tfloat phase = 2.0 * PI * OPD * 1.0e-9;\n\t\tvec3 val = vec3( 5.4856e-13, 4.4201e-13, 5.2481e-13 );\n\t\tvec3 pos = vec3( 1.6810e+06, 1.7953e+06, 2.2084e+06 );\n\t\tvec3 var = vec3( 4.3278e+09, 9.3046e+09, 6.6121e+09 );\n\t\tvec3 xyz = val * sqrt( 2.0 * PI * var ) * cos( pos * phase + shift ) * exp( - pow2( phase ) * var );\n\t\txyz.x += 9.7470e-14 * sqrt( 2.0 * PI * 4.5282e+09 ) * cos( 2.2399e+06 * phase + shift[ 0 ] ) * exp( - 4.5282e+09 * pow2( phase ) );\n\t\txyz /= 1.0685e-7;\n\t\tvec3 rgb = XYZ_TO_REC709 * xyz;\n\t\treturn rgb;\n\t}\n\tvec3 evalIridescence( float outsideIOR, float eta2, float cosTheta1, float thinFilmThickness, vec3 baseF0 ) {\n\t\tvec3 I;\n\t\tfloat iridescenceIOR = mix( outsideIOR, eta2, smoothstep( 0.0, 0.03, thinFilmThickness ) );\n\t\tfloat sinTheta2Sq = pow2( outsideIOR / iridescenceIOR ) * ( 1.0 - pow2( cosTheta1 ) );\n\t\tfloat cosTheta2Sq = 1.0 - sinTheta2Sq;\n\t\tif ( cosTheta2Sq < 0.0 ) {\n\t\t\treturn vec3( 1.0 );\n\t\t}\n\t\tfloat cosTheta2 = sqrt( cosTheta2Sq );\n\t\tfloat R0 = IorToFresnel0( iridescenceIOR, outsideIOR );\n\t\tfloat R12 = F_Schlick( R0, 1.0, cosTheta1 );\n\t\tfloat T121 = 1.0 - R12;\n\t\tfloat phi12 = 0.0;\n\t\tif ( iridescenceIOR < outsideIOR ) phi12 = PI;\n\t\tfloat phi21 = PI - phi12;\n\t\tvec3 baseIOR = Fresnel0ToIor( clamp( baseF0, 0.0, 0.9999 ) );\t\tvec3 R1 = IorToFresnel0( baseIOR, iridescenceIOR );\n\t\tvec3 R23 = F_Schlick( R1, 1.0, cosTheta2 );\n\t\tvec3 phi23 = vec3( 0.0 );\n\t\tif ( baseIOR[ 0 ] < iridescenceIOR ) phi23[ 0 ] = PI;\n\t\tif ( baseIOR[ 1 ] < iridescenceIOR ) phi23[ 1 ] = PI;\n\t\tif ( baseIOR[ 2 ] < iridescenceIOR ) phi23[ 2 ] = PI;\n\t\tfloat OPD = 2.0 * iridescenceIOR * thinFilmThickness * cosTheta2;\n\t\tvec3 phi = vec3( phi21 ) + phi23;\n\t\tvec3 R123 = clamp( R12 * R23, 1e-5, 0.9999 );\n\t\tvec3 r123 = sqrt( R123 );\n\t\tvec3 Rs = pow2( T121 ) * R23 / ( vec3( 1.0 ) - R123 );\n\t\tvec3 C0 = R12 + Rs;\n\t\tI = C0;\n\t\tvec3 Cm = Rs - T121;\n\t\tfor ( int m = 1; m <= 2; ++ m ) {\n\t\t\tCm *= r123;\n\t\t\tvec3 Sm = 2.0 * evalSensitivity( float( m ) * OPD, float( m ) * phi );\n\t\t\tI += Cm * Sm;\n\t\t}\n\t\treturn max( I, vec3( 0.0 ) );\n\t}\n#endif",
                    bumpmap_pars_fragment: "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vBumpMapUv );\n\t\tvec2 dSTdy = dFdy( vBumpMapUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vBumpMapUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vBumpMapUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy, float faceDirection ) {\n\t\tvec3 vSigmaX = normalize( dFdx( surf_pos.xyz ) );\n\t\tvec3 vSigmaY = normalize( dFdy( surf_pos.xyz ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 ) * faceDirection;\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif",
                    clipping_planes_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#ifdef ALPHA_TO_COVERAGE\n\t\tfloat distanceToPlane, distanceGradient;\n\t\tfloat clipOpacity = 1.0;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\tclipOpacity *= smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\tif ( clipOpacity == 0.0 ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tfloat unionClipOpacity = 1.0;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tdistanceToPlane = - dot( vClipPosition, plane.xyz ) + plane.w;\n\t\t\t\tdistanceGradient = fwidth( distanceToPlane ) / 2.0;\n\t\t\t\tunionClipOpacity *= 1.0 - smoothstep( - distanceGradient, distanceGradient, distanceToPlane );\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tclipOpacity *= 1.0 - unionClipOpacity;\n\t\t#endif\n\t\tdiffuseColor.a *= clipOpacity;\n\t\tif ( diffuseColor.a == 0.0 ) discard;\n\t#else\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\t\tbool clipped = true;\n\t\t\t#pragma unroll_loop_start\n\t\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\t\tplane = clippingPlanes[ i ];\n\t\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t\t}\n\t\t\t#pragma unroll_loop_end\n\t\t\tif ( clipped ) discard;\n\t\t#endif\n\t#endif\n#endif",
                    clipping_planes_pars_fragment: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif",
                    clipping_planes_pars_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif",
                    clipping_planes_vertex: "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif",
                    color_fragment: "#if defined( USE_COLOR_ALPHA )\n\tdiffuseColor *= vColor;\n#elif defined( USE_COLOR )\n\tdiffuseColor.rgb *= vColor;\n#endif",
                    color_pars_fragment: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR )\n\tvarying vec3 vColor;\n#endif",
                    color_pars_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvarying vec4 vColor;\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvarying vec3 vColor;\n#endif",
                    color_vertex: "#if defined( USE_COLOR_ALPHA )\n\tvColor = vec4( 1.0 );\n#elif defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR ) || defined( USE_BATCHING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor *= color;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif\n#ifdef USE_BATCHING_COLOR\n\tvec3 batchingColor = getBatchingColor( getIndirectIndex( gl_DrawID ) );\n\tvColor.xyz *= batchingColor.xyz;\n#endif",
                    common: "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement( a ) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nvec3 pow2( const in vec3 x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat max3( const in vec3 v ) { return max( max( v.x, v.y ), v.z ); }\nfloat average( const in vec3 v ) { return dot( v, vec3( 0.3333333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract( sin( sn ) * c );\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\n#ifdef USE_ALPHAHASH\n\tvarying vec3 vPosition;\n#endif\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}\nvec3 BRDF_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n}\nfloat F_Schlick( const in float f0, const in float f90, const in float dotVH ) {\n\tfloat fresnel = exp2( ( - 5.55473 * dotVH - 6.98316 ) * dotVH );\n\treturn f0 * ( 1.0 - fresnel ) + ( f90 * fresnel );\n} // validated",
                    cube_uv_reflection_fragment: "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\thighp vec2 uv = getUV( direction, face ) * ( faceSize - 2.0 ) + 1.0;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tuv.x += filterInt * 3.0 * cubeUV_minTileSize;\n\t\tuv.y += 4.0 * ( exp2( CUBEUV_MAX_MIP ) - faceSize );\n\t\tuv.x *= CUBEUV_TEXEL_WIDTH;\n\t\tuv.y *= CUBEUV_TEXEL_HEIGHT;\n\t\t#ifdef texture2DGradEXT\n\t\t\treturn texture2DGradEXT( envMap, uv, vec2( 0.0 ), vec2( 0.0 ) ).rgb;\n\t\t#else\n\t\t\treturn texture2D( envMap, uv ).rgb;\n\t\t#endif\n\t}\n\t#define cubeUV_r0 1.0\n\t#define cubeUV_m0 - 2.0\n\t#define cubeUV_r1 0.8\n\t#define cubeUV_m1 - 1.0\n\t#define cubeUV_r4 0.4\n\t#define cubeUV_m4 2.0\n\t#define cubeUV_r5 0.305\n\t#define cubeUV_m5 3.0\n\t#define cubeUV_r6 0.21\n\t#define cubeUV_m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= cubeUV_r1 ) {\n\t\t\tmip = ( cubeUV_r0 - roughness ) * ( cubeUV_m1 - cubeUV_m0 ) / ( cubeUV_r0 - cubeUV_r1 ) + cubeUV_m0;\n\t\t} else if ( roughness >= cubeUV_r4 ) {\n\t\t\tmip = ( cubeUV_r1 - roughness ) * ( cubeUV_m4 - cubeUV_m1 ) / ( cubeUV_r1 - cubeUV_r4 ) + cubeUV_m1;\n\t\t} else if ( roughness >= cubeUV_r5 ) {\n\t\t\tmip = ( cubeUV_r4 - roughness ) * ( cubeUV_m5 - cubeUV_m4 ) / ( cubeUV_r4 - cubeUV_r5 ) + cubeUV_m4;\n\t\t} else if ( roughness >= cubeUV_r6 ) {\n\t\t\tmip = ( cubeUV_r5 - roughness ) * ( cubeUV_m6 - cubeUV_m5 ) / ( cubeUV_r5 - cubeUV_r6 ) + cubeUV_m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), cubeUV_m0, CUBEUV_MAX_MIP );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif",
                    defaultnormal_vertex: "vec3 transformedNormal = objectNormal;\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = objectTangent;\n#endif\n#ifdef USE_BATCHING\n\tmat3 bm = mat3( batchingMatrix );\n\ttransformedNormal /= vec3( dot( bm[ 0 ], bm[ 0 ] ), dot( bm[ 1 ], bm[ 1 ] ), dot( bm[ 2 ], bm[ 2 ] ) );\n\ttransformedNormal = bm * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = bm * transformedTangent;\n\t#endif\n#endif\n#ifdef USE_INSTANCING\n\tmat3 im = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( im[ 0 ], im[ 0 ] ), dot( im[ 1 ], im[ 1 ] ), dot( im[ 2 ], im[ 2 ] ) );\n\ttransformedNormal = im * transformedNormal;\n\t#ifdef USE_TANGENT\n\t\ttransformedTangent = im * transformedTangent;\n\t#endif\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\ttransformedTangent = ( modelViewMatrix * vec4( transformedTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif",
                    displacementmap_pars_vertex: "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif",
                    displacementmap_vertex: "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vDisplacementMapUv ).x * displacementScale + displacementBias );\n#endif",
                    emissivemap_fragment: "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vEmissiveMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE_EMISSIVE\n\t\temissiveColor = sRGBTransferEOTF( emissiveColor );\n\t#endif\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif",
                    emissivemap_pars_fragment: "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif",
                    colorspace_fragment: "gl_FragColor = linearToOutputTexel( gl_FragColor );",
                    colorspace_pars_fragment: "vec4 LinearTransferOETF( in vec4 value ) {\n\treturn value;\n}\nvec4 sRGBTransferEOTF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 sRGBTransferOETF( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}",
                    envmap_fragment: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, envMapRotation * vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif",
                    envmap_common_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform mat3 envMapRotation;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif",
                    envmap_pars_fragment: "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif",
                    envmap_pars_vertex: "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG ) || defined( LAMBERT )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif",
                    envmap_physical_pars_fragment: "#ifdef USE_ENVMAP\n\tvec3 getIBLIrradiance( const in vec3 normal ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * worldNormal, 1.0 );\n\t\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\tvec3 getIBLRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness ) {\n\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\tvec3 reflectVec = reflect( - viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, envMapRotation * reflectVec, roughness );\n\t\t\treturn envMapColor.rgb * envMapIntensity;\n\t\t#else\n\t\t\treturn vec3( 0.0 );\n\t\t#endif\n\t}\n\t#ifdef USE_ANISOTROPY\n\t\tvec3 getIBLAnisotropyRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in vec3 bitangent, const in float anisotropy ) {\n\t\t\t#ifdef ENVMAP_TYPE_CUBE_UV\n\t\t\t\tvec3 bentNormal = cross( bitangent, viewDir );\n\t\t\t\tbentNormal = normalize( cross( bentNormal, bitangent ) );\n\t\t\t\tbentNormal = normalize( mix( bentNormal, normal, pow2( pow2( 1.0 - anisotropy * ( 1.0 - roughness ) ) ) ) );\n\t\t\t\treturn getIBLRadiance( viewDir, bentNormal, roughness );\n\t\t\t#else\n\t\t\t\treturn vec3( 0.0 );\n\t\t\t#endif\n\t\t}\n\t#endif\n#endif",
                    envmap_vertex: "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif",
                    fog_vertex: "#ifdef USE_FOG\n\tvFogDepth = - mvPosition.z;\n#endif",
                    fog_pars_vertex: "#ifdef USE_FOG\n\tvarying float vFogDepth;\n#endif",
                    fog_fragment: "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * vFogDepth * vFogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, vFogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif",
                    fog_pars_fragment: "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float vFogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif",
                    gradientmap_pars_fragment: "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn vec3( texture2D( gradientMap, coord ).r );\n\t#else\n\t\tvec2 fw = fwidth( coord ) * 0.5;\n\t\treturn mix( vec3( 0.7 ), vec3( 1.0 ), smoothstep( 0.7 - fw.x, 0.7 + fw.x, coord.x ) );\n\t#endif\n}",
                    lightmap_pars_fragment: "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif",
                    lights_lambert_fragment: "LambertMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularStrength = specularStrength;",
                    lights_lambert_pars_fragment: "varying vec3 vViewPosition;\nstruct LambertMaterial {\n\tvec3 diffuseColor;\n\tfloat specularStrength;\n};\nvoid RE_Direct_Lambert( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Lambert( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in LambertMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Lambert\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Lambert",
                    lights_pars_begin: "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\n#if defined( USE_LIGHT_PROBES )\n\tuniform vec3 lightProbe[ 9 ];\n#endif\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in vec3 normal ) {\n\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\treturn irradiance;\n}\nfloat getDistanceAttenuation( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif ( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n}\nfloat getSpotAttenuation( const in float coneCosine, const in float penumbraCosine, const in float angleCosine ) {\n\treturn smoothstep( coneCosine, penumbraCosine, angleCosine );\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalLightInfo( const in DirectionalLight directionalLight, out IncidentLight light ) {\n\t\tlight.color = directionalLight.color;\n\t\tlight.direction = directionalLight.direction;\n\t\tlight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointLightInfo( const in PointLight pointLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = pointLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tlight.color = pointLight.color;\n\t\tlight.color *= getDistanceAttenuation( lightDistance, pointLight.distance, pointLight.decay );\n\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotLightInfo( const in SpotLight spotLight, const in vec3 geometryPosition, out IncidentLight light ) {\n\t\tvec3 lVector = spotLight.position - geometryPosition;\n\t\tlight.direction = normalize( lVector );\n\t\tfloat angleCos = dot( light.direction, spotLight.direction );\n\t\tfloat spotAttenuation = getSpotAttenuation( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\tif ( spotAttenuation > 0.0 ) {\n\t\t\tfloat lightDistance = length( lVector );\n\t\t\tlight.color = spotLight.color * spotAttenuation;\n\t\t\tlight.color *= getDistanceAttenuation( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tlight.visible = ( light.color != vec3( 0.0 ) );\n\t\t} else {\n\t\t\tlight.color = vec3( 0.0 );\n\t\t\tlight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in vec3 normal ) {\n\t\tfloat dotNL = dot( normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\treturn irradiance;\n\t}\n#endif",
                    lights_toon_fragment: "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;",
                    lights_toon_pars_fragment: "varying vec3 vViewPosition;\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometryNormal, directLight.direction ) * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon",
                    lights_phong_fragment: "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;",
                    lights_phong_pars_fragment: "varying vec3 vViewPosition;\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_BlinnPhong( directLight.direction, geometryViewDir, geometryNormal, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong",
                    lights_physical_fragment: "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( nonPerturbedNormal ) ), abs( dFdy( nonPerturbedNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.roughness = max( roughnessFactor, 0.0525 );material.roughness += geometryRoughness;\nmaterial.roughness = min( material.roughness, 1.0 );\n#ifdef IOR\n\tmaterial.ior = ior;\n\t#ifdef USE_SPECULAR\n\t\tfloat specularIntensityFactor = specularIntensity;\n\t\tvec3 specularColorFactor = specularColor;\n\t\t#ifdef USE_SPECULAR_COLORMAP\n\t\t\tspecularColorFactor *= texture2D( specularColorMap, vSpecularColorMapUv ).rgb;\n\t\t#endif\n\t\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\t\tspecularIntensityFactor *= texture2D( specularIntensityMap, vSpecularIntensityMapUv ).a;\n\t\t#endif\n\t\tmaterial.specularF90 = mix( specularIntensityFactor, 1.0, metalnessFactor );\n\t#else\n\t\tfloat specularIntensityFactor = 1.0;\n\t\tvec3 specularColorFactor = vec3( 1.0 );\n\t\tmaterial.specularF90 = 1.0;\n\t#endif\n\tmaterial.specularColor = mix( min( pow2( ( material.ior - 1.0 ) / ( material.ior + 1.0 ) ) * specularColorFactor, vec3( 1.0 ) ) * specularIntensityFactor, diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( 0.04 ), diffuseColor.rgb, metalnessFactor );\n\tmaterial.specularF90 = 1.0;\n#endif\n#ifdef USE_CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\tmaterial.clearcoatF0 = vec3( 0.04 );\n\tmaterial.clearcoatF90 = 1.0;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vClearcoatMapUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vClearcoatRoughnessMapUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_DISPERSION\n\tmaterial.dispersion = dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tmaterial.iridescence = iridescence;\n\tmaterial.iridescenceIOR = iridescenceIOR;\n\t#ifdef USE_IRIDESCENCEMAP\n\t\tmaterial.iridescence *= texture2D( iridescenceMap, vIridescenceMapUv ).r;\n\t#endif\n\t#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\t\tmaterial.iridescenceThickness = (iridescenceThicknessMaximum - iridescenceThicknessMinimum) * texture2D( iridescenceThicknessMap, vIridescenceThicknessMapUv ).g + iridescenceThicknessMinimum;\n\t#else\n\t\tmaterial.iridescenceThickness = iridescenceThicknessMaximum;\n\t#endif\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheenColor;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tmaterial.sheenColor *= texture2D( sheenColorMap, vSheenColorMapUv ).rgb;\n\t#endif\n\tmaterial.sheenRoughness = clamp( sheenRoughness, 0.07, 1.0 );\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tmaterial.sheenRoughness *= texture2D( sheenRoughnessMap, vSheenRoughnessMapUv ).a;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\t#ifdef USE_ANISOTROPYMAP\n\t\tmat2 anisotropyMat = mat2( anisotropyVector.x, anisotropyVector.y, - anisotropyVector.y, anisotropyVector.x );\n\t\tvec3 anisotropyPolar = texture2D( anisotropyMap, vAnisotropyMapUv ).rgb;\n\t\tvec2 anisotropyV = anisotropyMat * normalize( 2.0 * anisotropyPolar.rg - vec2( 1.0 ) ) * anisotropyPolar.b;\n\t#else\n\t\tvec2 anisotropyV = anisotropyVector;\n\t#endif\n\tmaterial.anisotropy = length( anisotropyV );\n\tif( material.anisotropy == 0.0 ) {\n\t\tanisotropyV = vec2( 1.0, 0.0 );\n\t} else {\n\t\tanisotropyV /= material.anisotropy;\n\t\tmaterial.anisotropy = saturate( material.anisotropy );\n\t}\n\tmaterial.alphaT = mix( pow2( material.roughness ), 1.0, pow2( material.anisotropy ) );\n\tmaterial.anisotropyT = tbn[ 0 ] * anisotropyV.x + tbn[ 1 ] * anisotropyV.y;\n\tmaterial.anisotropyB = tbn[ 1 ] * anisotropyV.x - tbn[ 0 ] * anisotropyV.y;\n#endif",
                    lights_physical_pars_fragment: "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat roughness;\n\tvec3 specularColor;\n\tfloat specularF90;\n\tfloat dispersion;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat clearcoat;\n\t\tfloat clearcoatRoughness;\n\t\tvec3 clearcoatF0;\n\t\tfloat clearcoatF90;\n\t#endif\n\t#ifdef USE_IRIDESCENCE\n\t\tfloat iridescence;\n\t\tfloat iridescenceIOR;\n\t\tfloat iridescenceThickness;\n\t\tvec3 iridescenceFresnel;\n\t\tvec3 iridescenceF0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tvec3 sheenColor;\n\t\tfloat sheenRoughness;\n\t#endif\n\t#ifdef IOR\n\t\tfloat ior;\n\t#endif\n\t#ifdef USE_TRANSMISSION\n\t\tfloat transmission;\n\t\tfloat transmissionAlpha;\n\t\tfloat thickness;\n\t\tfloat attenuationDistance;\n\t\tvec3 attenuationColor;\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat anisotropy;\n\t\tfloat alphaT;\n\t\tvec3 anisotropyT;\n\t\tvec3 anisotropyB;\n\t#endif\n};\nvec3 clearcoatSpecularDirect = vec3( 0.0 );\nvec3 clearcoatSpecularIndirect = vec3( 0.0 );\nvec3 sheenSpecularDirect = vec3( 0.0 );\nvec3 sheenSpecularIndirect = vec3(0.0 );\nvec3 Schlick_to_F0( const in vec3 f, const in float f90, const in float dotVH ) {\n    float x = clamp( 1.0 - dotVH, 0.0, 1.0 );\n    float x2 = x * x;\n    float x5 = clamp( x * x2 * x2, 0.0, 0.9999 );\n    return ( f - vec3( f90 ) * x5 ) / ( 1.0 - x5 );\n}\nfloat V_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\n#ifdef USE_ANISOTROPY\n\tfloat V_GGX_SmithCorrelated_Anisotropic( const in float alphaT, const in float alphaB, const in float dotTV, const in float dotBV, const in float dotTL, const in float dotBL, const in float dotNV, const in float dotNL ) {\n\t\tfloat gv = dotNL * length( vec3( alphaT * dotTV, alphaB * dotBV, dotNV ) );\n\t\tfloat gl = dotNV * length( vec3( alphaT * dotTL, alphaB * dotBL, dotNL ) );\n\t\tfloat v = 0.5 / ( gv + gl );\n\t\treturn saturate(v);\n\t}\n\tfloat D_GGX_Anisotropic( const in float alphaT, const in float alphaB, const in float dotNH, const in float dotTH, const in float dotBH ) {\n\t\tfloat a2 = alphaT * alphaB;\n\t\thighp vec3 v = vec3( alphaB * dotTH, alphaT * dotBH, a2 * dotNH );\n\t\thighp float v2 = dot( v, v );\n\t\tfloat w2 = a2 / v2;\n\t\treturn RECIPROCAL_PI * a2 * pow2 ( w2 );\n\t}\n#endif\n#ifdef USE_CLEARCOAT\n\tvec3 BRDF_GGX_Clearcoat( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material) {\n\t\tvec3 f0 = material.clearcoatF0;\n\t\tfloat f90 = material.clearcoatF90;\n\t\tfloat roughness = material.clearcoatRoughness;\n\t\tfloat alpha = pow2( roughness );\n\t\tvec3 halfDir = normalize( lightDir + viewDir );\n\t\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\t\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\t\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\t\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\t\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t\treturn F * ( V * D );\n\t}\n#endif\nvec3 BRDF_GGX( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, const in PhysicalMaterial material ) {\n\tvec3 f0 = material.specularColor;\n\tfloat f90 = material.specularF90;\n\tfloat roughness = material.roughness;\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotVH = saturate( dot( viewDir, halfDir ) );\n\tvec3 F = F_Schlick( f0, f90, dotVH );\n\t#ifdef USE_IRIDESCENCE\n\t\tF = mix( F, material.iridescenceFresnel, material.iridescence );\n\t#endif\n\t#ifdef USE_ANISOTROPY\n\t\tfloat dotTL = dot( material.anisotropyT, lightDir );\n\t\tfloat dotTV = dot( material.anisotropyT, viewDir );\n\t\tfloat dotTH = dot( material.anisotropyT, halfDir );\n\t\tfloat dotBL = dot( material.anisotropyB, lightDir );\n\t\tfloat dotBV = dot( material.anisotropyB, viewDir );\n\t\tfloat dotBH = dot( material.anisotropyB, halfDir );\n\t\tfloat V = V_GGX_SmithCorrelated_Anisotropic( material.alphaT, alpha, dotTV, dotBV, dotTL, dotBL, dotNV, dotNL );\n\t\tfloat D = D_GGX_Anisotropic( material.alphaT, alpha, dotNH, dotTH, dotBH );\n\t#else\n\t\tfloat V = V_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\t\tfloat D = D_GGX( alpha, dotNH );\n\t#endif\n\treturn F * ( V * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie( float roughness, float dotNH ) {\n\tfloat alpha = pow2( roughness );\n\tfloat invAlpha = 1.0 / alpha;\n\tfloat cos2h = dotNH * dotNH;\n\tfloat sin2h = max( 1.0 - cos2h, 0.0078125 );\n\treturn ( 2.0 + invAlpha ) * pow( sin2h, invAlpha * 0.5 ) / ( 2.0 * PI );\n}\nfloat V_Neubelt( float dotNV, float dotNL ) {\n\treturn saturate( 1.0 / ( 4.0 * ( dotNL + dotNV - dotNL * dotNV ) ) );\n}\nvec3 BRDF_Sheen( const in vec3 lightDir, const in vec3 viewDir, const in vec3 normal, vec3 sheenColor, const in float sheenRoughness ) {\n\tvec3 halfDir = normalize( lightDir + viewDir );\n\tfloat dotNL = saturate( dot( normal, lightDir ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat D = D_Charlie( sheenRoughness, dotNH );\n\tfloat V = V_Neubelt( dotNV, dotNL );\n\treturn sheenColor * ( D * V );\n}\n#endif\nfloat IBLSheenBRDF( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat r2 = roughness * roughness;\n\tfloat a = roughness < 0.25 ? -339.2 * r2 + 161.4 * roughness - 25.9 : -8.48 * r2 + 14.3 * roughness - 9.95;\n\tfloat b = roughness < 0.25 ? 44.0 * r2 - 23.7 * roughness + 3.26 : 1.97 * r2 - 3.27 * roughness + 0.72;\n\tfloat DG = exp( a * dotNV + b ) + ( roughness < 0.25 ? 0.0 : 0.1 * ( roughness - 0.25 ) );\n\treturn saturate( DG * RECIPROCAL_PI );\n}\nvec2 DFGApprox( const in vec3 normal, const in vec3 viewDir, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\tvec2 fab = vec2( - 1.04, 1.04 ) * a004 + r.zw;\n\treturn fab;\n}\nvec3 EnvironmentBRDF( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness ) {\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\treturn specularColor * fab.x + specularF90 * fab.y;\n}\n#ifdef USE_IRIDESCENCE\nvoid computeMultiscatteringIridescence( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float iridescence, const in vec3 iridescenceF0, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#else\nvoid computeMultiscattering( const in vec3 normal, const in vec3 viewDir, const in vec3 specularColor, const in float specularF90, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n#endif\n\tvec2 fab = DFGApprox( normal, viewDir, roughness );\n\t#ifdef USE_IRIDESCENCE\n\t\tvec3 Fr = mix( specularColor, iridescenceF0, iridescence );\n\t#else\n\t\tvec3 Fr = specularColor;\n\t#endif\n\tvec3 FssEss = Fr * fab.x + specularF90 * fab.y;\n\tfloat Ess = fab.x + fab.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = Fr + ( 1.0 - Fr ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometryNormal;\n\t\tvec3 viewDir = geometryViewDir;\n\t\tvec3 position = geometryPosition;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.roughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometryNormal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNLcc = saturate( dot( geometryClearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = dotNLcc * directLight.color;\n\t\tclearcoatSpecularDirect += ccIrradiance * BRDF_GGX_Clearcoat( directLight.direction, geometryViewDir, geometryClearcoatNormal, material );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularDirect += irradiance * BRDF_Sheen( directLight.direction, geometryViewDir, geometryNormal, material.sheenColor, material.sheenRoughness );\n\t#endif\n\treflectedLight.directSpecular += irradiance * BRDF_GGX( directLight.direction, geometryViewDir, geometryNormal, material );\n\treflectedLight.directDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in vec3 geometryPosition, const in vec3 geometryNormal, const in vec3 geometryViewDir, const in vec3 geometryClearcoatNormal, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatSpecularIndirect += clearcoatRadiance * EnvironmentBRDF( geometryClearcoatNormal, geometryViewDir, material.clearcoatF0, material.clearcoatF90, material.clearcoatRoughness );\n\t#endif\n\t#ifdef USE_SHEEN\n\t\tsheenSpecularIndirect += irradiance * material.sheenColor * IBLSheenBRDF( geometryNormal, geometryViewDir, material.sheenRoughness );\n\t#endif\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\t#ifdef USE_IRIDESCENCE\n\t\tcomputeMultiscatteringIridescence( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.iridescence, material.iridescenceFresnel, material.roughness, singleScattering, multiScattering );\n\t#else\n\t\tcomputeMultiscattering( geometryNormal, geometryViewDir, material.specularColor, material.specularF90, material.roughness, singleScattering, multiScattering );\n\t#endif\n\tvec3 totalScattering = singleScattering + multiScattering;\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - max( max( totalScattering.r, totalScattering.g ), totalScattering.b ) );\n\treflectedLight.indirectSpecular += radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}",
                    lights_fragment_begin: "\nvec3 geometryPosition = - vViewPosition;\nvec3 geometryNormal = normal;\nvec3 geometryViewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\nvec3 geometryClearcoatNormal = vec3( 0.0 );\n#ifdef USE_CLEARCOAT\n\tgeometryClearcoatNormal = clearcoatNormal;\n#endif\n#ifdef USE_IRIDESCENCE\n\tfloat dotNVi = saturate( dot( normal, geometryViewDir ) );\n\tif ( material.iridescenceThickness == 0.0 ) {\n\t\tmaterial.iridescence = 0.0;\n\t} else {\n\t\tmaterial.iridescence = saturate( material.iridescence );\n\t}\n\tif ( material.iridescence > 0.0 ) {\n\t\tmaterial.iridescenceFresnel = evalIridescence( 1.0, material.iridescenceIOR, dotNVi, material.iridescenceThickness, material.specularColor );\n\t\tmaterial.iridescenceF0 = Schlick_to_F0( material.iridescenceFresnel, 1.0, dotNVi );\n\t}\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointLightInfo( pointLight, geometryPosition, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowIntensity, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\tvec4 spotColor;\n\tvec3 spotLightCoord;\n\tbool inSpotLightMap;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotLightInfo( spotLight, geometryPosition, directLight );\n\t\t#if ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#define SPOT_LIGHT_MAP_INDEX UNROLLED_LOOP_INDEX\n\t\t#elif ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t#define SPOT_LIGHT_MAP_INDEX NUM_SPOT_LIGHT_MAPS\n\t\t#else\n\t\t#define SPOT_LIGHT_MAP_INDEX ( UNROLLED_LOOP_INDEX - NUM_SPOT_LIGHT_SHADOWS + NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS )\n\t\t#endif\n\t\t#if ( SPOT_LIGHT_MAP_INDEX < NUM_SPOT_LIGHT_MAPS )\n\t\t\tspotLightCoord = vSpotLightCoord[ i ].xyz / vSpotLightCoord[ i ].w;\n\t\t\tinSpotLightMap = all( lessThan( abs( spotLightCoord * 2. - 1. ), vec3( 1.0 ) ) );\n\t\t\tspotColor = texture2D( spotLightMap[ SPOT_LIGHT_MAP_INDEX ], spotLightCoord.xy );\n\t\t\tdirectLight.color = inSpotLightMap ? directLight.color * spotColor.rgb : directLight.color;\n\t\t#endif\n\t\t#undef SPOT_LIGHT_MAP_INDEX\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowIntensity, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalLightInfo( directionalLight, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= ( directLight.visible && receiveShadow ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowIntensity, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\t#if defined( USE_LIGHT_PROBES )\n\t\tirradiance += getLightProbeIrradiance( lightProbe, geometryNormal );\n\t#endif\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometryNormal );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif",
                    lights_fragment_maps: "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\tvec3 lightMapIrradiance = lightMapTexel.rgb * lightMapIntensity;\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getIBLIrradiance( geometryNormal );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\t#ifdef USE_ANISOTROPY\n\t\tradiance += getIBLAnisotropyRadiance( geometryViewDir, geometryNormal, material.roughness, material.anisotropyB, material.anisotropy );\n\t#else\n\t\tradiance += getIBLRadiance( geometryViewDir, geometryNormal, material.roughness );\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tclearcoatRadiance += getIBLRadiance( geometryViewDir, geometryClearcoatNormal, material.clearcoatRoughness );\n\t#endif\n#endif",
                    lights_fragment_end: "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometryPosition, geometryNormal, geometryViewDir, geometryClearcoatNormal, material, reflectedLight );\n#endif",
                    logdepthbuf_fragment: "#if defined( USE_LOGDEPTHBUF )\n\tgl_FragDepth = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif",
                    logdepthbuf_pars_fragment: "#if defined( USE_LOGDEPTHBUF )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
                    logdepthbuf_pars_vertex: "#ifdef USE_LOGDEPTHBUF\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif",
                    logdepthbuf_vertex: "#ifdef USE_LOGDEPTHBUF\n\tvFragDepth = 1.0 + gl_Position.w;\n\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n#endif",
                    map_fragment: "#ifdef USE_MAP\n\tvec4 sampledDiffuseColor = texture2D( map, vMapUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\tsampledDiffuseColor = sRGBTransferEOTF( sampledDiffuseColor );\n\t#endif\n\tdiffuseColor *= sampledDiffuseColor;\n#endif",
                    map_pars_fragment: "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif",
                    map_particle_fragment: "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t#if defined( USE_POINTS_UV )\n\t\tvec2 uv = vUv;\n\t#else\n\t\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tdiffuseColor *= texture2D( map, uv );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif",
                    map_particle_pars_fragment: "#if defined( USE_POINTS_UV )\n\tvarying vec2 vUv;\n#else\n\t#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\t\tuniform mat3 uvTransform;\n\t#endif\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif",
                    metalnessmap_fragment: "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vMetalnessMapUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif",
                    metalnessmap_pars_fragment: "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif",
                    morphinstance_vertex: "#ifdef USE_INSTANCING_MORPH\n\tfloat morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\tfloat morphTargetBaseInfluence = texelFetch( morphTexture, ivec2( 0, gl_InstanceID ), 0 ).r;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tmorphTargetInfluences[i] =  texelFetch( morphTexture, ivec2( i + 1, gl_InstanceID ), 0 ).r;\n\t}\n#endif",
                    morphcolor_vertex: "#if defined( USE_MORPHCOLORS )\n\tvColor *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\t#if defined( USE_COLOR_ALPHA )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ) * morphTargetInfluences[ i ];\n\t\t#elif defined( USE_COLOR )\n\t\t\tif ( morphTargetInfluences[ i ] != 0.0 ) vColor += getMorph( gl_VertexID, i, 2 ).rgb * morphTargetInfluences[ i ];\n\t\t#endif\n\t}\n#endif",
                    morphnormal_vertex: "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) objectNormal += getMorph( gl_VertexID, i, 1 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
                    morphtarget_pars_vertex: "#ifdef USE_MORPHTARGETS\n\t#ifndef USE_INSTANCING_MORPH\n\t\tuniform float morphTargetBaseInfluence;\n\t\tuniform float morphTargetInfluences[ MORPHTARGETS_COUNT ];\n\t#endif\n\tuniform sampler2DArray morphTargetsTexture;\n\tuniform ivec2 morphTargetsTextureSize;\n\tvec4 getMorph( const in int vertexIndex, const in int morphTargetIndex, const in int offset ) {\n\t\tint texelIndex = vertexIndex * MORPHTARGETS_TEXTURE_STRIDE + offset;\n\t\tint y = texelIndex / morphTargetsTextureSize.x;\n\t\tint x = texelIndex - y * morphTargetsTextureSize.x;\n\t\tivec3 morphUV = ivec3( x, y, morphTargetIndex );\n\t\treturn texelFetch( morphTargetsTexture, morphUV, 0 );\n\t}\n#endif",
                    morphtarget_vertex: "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\tfor ( int i = 0; i < MORPHTARGETS_COUNT; i ++ ) {\n\t\tif ( morphTargetInfluences[ i ] != 0.0 ) transformed += getMorph( gl_VertexID, i, 0 ).xyz * morphTargetInfluences[ i ];\n\t}\n#endif",
                    normal_fragment_begin: "float faceDirection = gl_FrontFacing ? 1.0 : - 1.0;\n#ifdef FLAT_SHADED\n\tvec3 fdx = dFdx( vViewPosition );\n\tvec3 fdy = dFdy( vViewPosition );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal *= faceDirection;\n\t#endif\n#endif\n#if defined( USE_NORMALMAP_TANGENTSPACE ) || defined( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY )\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn = getTangentFrame( - vViewPosition, normal,\n\t\t#if defined( USE_NORMALMAP )\n\t\t\tvNormalMapUv\n\t\t#elif defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tvClearcoatNormalMapUv\n\t\t#else\n\t\t\tvUv\n\t\t#endif\n\t\t);\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn[0] *= faceDirection;\n\t\ttbn[1] *= faceDirection;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\t#ifdef USE_TANGENT\n\t\tmat3 tbn2 = mat3( normalize( vTangent ), normalize( vBitangent ), normal );\n\t#else\n\t\tmat3 tbn2 = getTangentFrame( - vViewPosition, normal, vClearcoatNormalMapUv );\n\t#endif\n\t#if defined( DOUBLE_SIDED ) && ! defined( FLAT_SHADED )\n\t\ttbn2[0] *= faceDirection;\n\t\ttbn2[1] *= faceDirection;\n\t#endif\n#endif\nvec3 nonPerturbedNormal = normal;",
                    normal_fragment_maps: "#ifdef USE_NORMALMAP_OBJECTSPACE\n\tnormal = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * faceDirection;\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( USE_NORMALMAP_TANGENTSPACE )\n\tvec3 mapN = texture2D( normalMap, vNormalMapUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\tnormal = normalize( tbn * mapN );\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( - vViewPosition, normal, dHdxy_fwd(), faceDirection );\n#endif",
                    normal_pars_fragment: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
                    normal_pars_vertex: "#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif",
                    normal_vertex: "#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif",
                    normalmap_pars_fragment: "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef USE_NORMALMAP_OBJECTSPACE\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( USE_NORMALMAP_TANGENTSPACE ) || defined ( USE_CLEARCOAT_NORMALMAP ) || defined( USE_ANISOTROPY ) )\n\tmat3 getTangentFrame( vec3 eye_pos, vec3 surf_norm, vec2 uv ) {\n\t\tvec3 q0 = dFdx( eye_pos.xyz );\n\t\tvec3 q1 = dFdy( eye_pos.xyz );\n\t\tvec2 st0 = dFdx( uv.st );\n\t\tvec2 st1 = dFdy( uv.st );\n\t\tvec3 N = surf_norm;\n\t\tvec3 q1perp = cross( q1, N );\n\t\tvec3 q0perp = cross( N, q0 );\n\t\tvec3 T = q1perp * st0.x + q0perp * st1.x;\n\t\tvec3 B = q1perp * st0.y + q0perp * st1.y;\n\t\tfloat det = max( dot( T, T ), dot( B, B ) );\n\t\tfloat scale = ( det == 0.0 ) ? 0.0 : inversesqrt( det );\n\t\treturn mat3( T * scale, B * scale, N );\n\t}\n#endif",
                    clearcoat_normal_fragment_begin: "#ifdef USE_CLEARCOAT\n\tvec3 clearcoatNormal = nonPerturbedNormal;\n#endif",
                    clearcoat_normal_fragment_maps: "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vClearcoatNormalMapUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\tclearcoatNormal = normalize( tbn2 * clearcoatMapN );\n#endif",
                    clearcoat_pars_fragment: "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif",
                    iridescence_pars_fragment: "#ifdef USE_IRIDESCENCEMAP\n\tuniform sampler2D iridescenceMap;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform sampler2D iridescenceThicknessMap;\n#endif",
                    opaque_fragment: "#ifdef OPAQUE\ndiffuseColor.a = 1.0;\n#endif\n#ifdef USE_TRANSMISSION\ndiffuseColor.a *= material.transmissionAlpha;\n#endif\ngl_FragColor = vec4( outgoingLight, diffuseColor.a );",
                    packing: "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;const float ShiftRight8 = 1. / 256.;\nconst float Inv255 = 1. / 255.;\nconst vec4 PackFactors = vec4( 1.0, 256.0, 256.0 * 256.0, 256.0 * 256.0 * 256.0 );\nconst vec2 UnpackFactors2 = vec2( UnpackDownscale, 1.0 / PackFactors.g );\nconst vec3 UnpackFactors3 = vec3( UnpackDownscale / PackFactors.rg, 1.0 / PackFactors.b );\nconst vec4 UnpackFactors4 = vec4( UnpackDownscale / PackFactors.rgb, 1.0 / PackFactors.a );\nvec4 packDepthToRGBA( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec4( 0., 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec4( 1., 1., 1., 1. );\n\tfloat vuf;\n\tfloat af = modf( v * PackFactors.a, vuf );\n\tfloat bf = modf( vuf * ShiftRight8, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec4( vuf * Inv255, gf * PackUpscale, bf * PackUpscale, af );\n}\nvec3 packDepthToRGB( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec3( 0., 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec3( 1., 1., 1. );\n\tfloat vuf;\n\tfloat bf = modf( v * PackFactors.b, vuf );\n\tfloat gf = modf( vuf * ShiftRight8, vuf );\n\treturn vec3( vuf * Inv255, gf * PackUpscale, bf );\n}\nvec2 packDepthToRG( const in float v ) {\n\tif( v <= 0.0 )\n\t\treturn vec2( 0., 0. );\n\tif( v >= 1.0 )\n\t\treturn vec2( 1., 1. );\n\tfloat vuf;\n\tfloat gf = modf( v * 256., vuf );\n\treturn vec2( vuf * Inv255, gf );\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors4 );\n}\nfloat unpackRGBToDepth( const in vec3 v ) {\n\treturn dot( v, UnpackFactors3 );\n}\nfloat unpackRGToDepth( const in vec2 v ) {\n\treturn v.r * UnpackFactors2.r + v.g * UnpackFactors2.g;\n}\nvec4 pack2HalfToRGBA( const in vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ) );\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w );\n}\nvec2 unpackRGBATo2Half( const in vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn depth * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( ( near + viewZ ) * far ) / ( ( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float depth, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * depth - far );\n}",
                    premultiplied_alpha_fragment: "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif",
                    project_vertex: "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_BATCHING\n\tmvPosition = batchingMatrix * mvPosition;\n#endif\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;",
                    dithering_fragment: "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif",
                    dithering_pars_fragment: "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif",
                    roughnessmap_fragment: "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vRoughnessMapUv );\n\troughnessFactor *= texelRoughness.g;\n#endif",
                    roughnessmap_pars_fragment: "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif",
                    shadowmap_pars_fragment: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#if NUM_SPOT_LIGHT_MAPS > 0\n\tuniform sampler2D spotLightMap[ NUM_SPOT_LIGHT_MAPS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\tfloat depth = unpackRGBAToDepth( texture2D( depths, uv ) );\n\t\t#ifdef USE_REVERSEDEPTHBUF\n\t\t\treturn step( depth, compare );\n\t\t#else\n\t\t\treturn step( compare, depth );\n\t\t#endif\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\t#ifdef USE_REVERSEDEPTHBUF\n\t\t\tfloat hard_shadow = step( distribution.x, compare );\n\t\t#else\n\t\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\t#endif\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbool inFrustum = shadowCoord.x >= 0.0 && shadowCoord.x <= 1.0 && shadowCoord.y >= 0.0 && shadowCoord.y <= 1.0;\n\t\tbool frustumTest = inFrustum && shadowCoord.z <= 1.0;\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowIntensity, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tfloat shadow = 1.0;\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\t\n\t\tfloat lightToPositionLength = length( lightToPosition );\n\t\tif ( lightToPositionLength - shadowCameraFar <= 0.0 && lightToPositionLength - shadowCameraNear >= 0.0 ) {\n\t\t\tfloat dp = ( lightToPositionLength - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\t\tdp += shadowBias;\n\t\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\t\tshadow = (\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t\t) * ( 1.0 / 9.0 );\n\t\t\t#else\n\t\t\t\tshadow = texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t\t#endif\n\t\t}\n\t\treturn mix( 1.0, shadow, shadowIntensity );\n\t}\n#endif",
                    shadowmap_pars_vertex: "#if NUM_SPOT_LIGHT_COORDS > 0\n\tuniform mat4 spotLightMatrix[ NUM_SPOT_LIGHT_COORDS ];\n\tvarying vec4 vSpotLightCoord[ NUM_SPOT_LIGHT_COORDS ];\n#endif\n#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowIntensity;\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif",
                    shadowmap_vertex: "#if ( defined( USE_SHADOWMAP ) && ( NUM_DIR_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0 ) ) || ( NUM_SPOT_LIGHT_COORDS > 0 )\n\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\tvec4 shadowWorldPosition;\n#endif\n#if defined( USE_SHADOWMAP )\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if NUM_SPOT_LIGHT_COORDS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_COORDS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition;\n\t\t#if ( defined( USE_SHADOWMAP ) && UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\t\tshadowWorldPosition.xyz += shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias;\n\t\t#endif\n\t\tvSpotLightCoord[ i ] = spotLightMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n#endif",
                    shadowmask_pars_fragment: "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowIntensity, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowIntensity, spotLight.shadowBias, spotLight.shadowRadius, vSpotLightCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowIntensity, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}",
                    skinbase_vertex: "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif",
                    skinning_pars_vertex: "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\tuniform highp sampler2D boneTexture;\n\tmat4 getBoneMatrix( const in float i ) {\n\t\tint size = textureSize( boneTexture, 0 ).x;\n\t\tint j = int( i ) * 4;\n\t\tint x = j % size;\n\t\tint y = j / size;\n\t\tvec4 v1 = texelFetch( boneTexture, ivec2( x, y ), 0 );\n\t\tvec4 v2 = texelFetch( boneTexture, ivec2( x + 1, y ), 0 );\n\t\tvec4 v3 = texelFetch( boneTexture, ivec2( x + 2, y ), 0 );\n\t\tvec4 v4 = texelFetch( boneTexture, ivec2( x + 3, y ), 0 );\n\t\treturn mat4( v1, v2, v3, v4 );\n\t}\n#endif",
                    skinning_vertex: "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif",
                    skinnormal_vertex: "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif",
                    specularmap_fragment: "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vSpecularMapUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif",
                    specularmap_pars_fragment: "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif",
                    tonemapping_fragment: "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif",
                    tonemapping_pars_fragment: "#ifndef saturate\n#define saturate( a ) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn saturate( toneMappingExposure * color );\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 CineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nconst mat3 LINEAR_REC2020_TO_LINEAR_SRGB = mat3(\n\tvec3( 1.6605, - 0.1246, - 0.0182 ),\n\tvec3( - 0.5876, 1.1329, - 0.1006 ),\n\tvec3( - 0.0728, - 0.0083, 1.1187 )\n);\nconst mat3 LINEAR_SRGB_TO_LINEAR_REC2020 = mat3(\n\tvec3( 0.6274, 0.0691, 0.0164 ),\n\tvec3( 0.3293, 0.9195, 0.0880 ),\n\tvec3( 0.0433, 0.0113, 0.8956 )\n);\nvec3 agxDefaultContrastApprox( vec3 x ) {\n\tvec3 x2 = x * x;\n\tvec3 x4 = x2 * x2;\n\treturn + 15.5 * x4 * x2\n\t\t- 40.14 * x4 * x\n\t\t+ 31.96 * x4\n\t\t- 6.868 * x2 * x\n\t\t+ 0.4298 * x2\n\t\t+ 0.1191 * x\n\t\t- 0.00232;\n}\nvec3 AgXToneMapping( vec3 color ) {\n\tconst mat3 AgXInsetMatrix = mat3(\n\t\tvec3( 0.856627153315983, 0.137318972929847, 0.11189821299995 ),\n\t\tvec3( 0.0951212405381588, 0.761241990602591, 0.0767994186031903 ),\n\t\tvec3( 0.0482516061458583, 0.101439036467562, 0.811302368396859 )\n\t);\n\tconst mat3 AgXOutsetMatrix = mat3(\n\t\tvec3( 1.1271005818144368, - 0.1413297634984383, - 0.14132976349843826 ),\n\t\tvec3( - 0.11060664309660323, 1.157823702216272, - 0.11060664309660294 ),\n\t\tvec3( - 0.016493938717834573, - 0.016493938717834257, 1.2519364065950405 )\n\t);\n\tconst float AgxMinEv = - 12.47393;\tconst float AgxMaxEv = 4.026069;\n\tcolor *= toneMappingExposure;\n\tcolor = LINEAR_SRGB_TO_LINEAR_REC2020 * color;\n\tcolor = AgXInsetMatrix * color;\n\tcolor = max( color, 1e-10 );\tcolor = log2( color );\n\tcolor = ( color - AgxMinEv ) / ( AgxMaxEv - AgxMinEv );\n\tcolor = clamp( color, 0.0, 1.0 );\n\tcolor = agxDefaultContrastApprox( color );\n\tcolor = AgXOutsetMatrix * color;\n\tcolor = pow( max( vec3( 0.0 ), color ), vec3( 2.2 ) );\n\tcolor = LINEAR_REC2020_TO_LINEAR_SRGB * color;\n\tcolor = clamp( color, 0.0, 1.0 );\n\treturn color;\n}\nvec3 NeutralToneMapping( vec3 color ) {\n\tconst float StartCompression = 0.8 - 0.04;\n\tconst float Desaturation = 0.15;\n\tcolor *= toneMappingExposure;\n\tfloat x = min( color.r, min( color.g, color.b ) );\n\tfloat offset = x < 0.08 ? x - 6.25 * x * x : 0.04;\n\tcolor -= offset;\n\tfloat peak = max( color.r, max( color.g, color.b ) );\n\tif ( peak < StartCompression ) return color;\n\tfloat d = 1. - StartCompression;\n\tfloat newPeak = 1. - d * d / ( peak + d - StartCompression );\n\tcolor *= newPeak / peak;\n\tfloat g = 1. - 1. / ( Desaturation * ( peak - newPeak ) + 1. );\n\treturn mix( color, vec3( newPeak ), g );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }",
                    transmission_fragment: "#ifdef USE_TRANSMISSION\n\tmaterial.transmission = transmission;\n\tmaterial.transmissionAlpha = 1.0;\n\tmaterial.thickness = thickness;\n\tmaterial.attenuationDistance = attenuationDistance;\n\tmaterial.attenuationColor = attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tmaterial.transmission *= texture2D( transmissionMap, vTransmissionMapUv ).r;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tmaterial.thickness *= texture2D( thicknessMap, vThicknessMapUv ).g;\n\t#endif\n\tvec3 pos = vWorldPosition;\n\tvec3 v = normalize( cameraPosition - pos );\n\tvec3 n = inverseTransformDirection( normal, viewMatrix );\n\tvec4 transmitted = getIBLVolumeRefraction(\n\t\tn, v, material.roughness, material.diffuseColor, material.specularColor, material.specularF90,\n\t\tpos, modelMatrix, viewMatrix, projectionMatrix, material.dispersion, material.ior, material.thickness,\n\t\tmaterial.attenuationColor, material.attenuationDistance );\n\tmaterial.transmissionAlpha = mix( material.transmissionAlpha, transmitted.a, material.transmission );\n\ttotalDiffuse = mix( totalDiffuse, transmitted.rgb, material.transmission );\n#endif",
                    transmission_pars_fragment: "#ifdef USE_TRANSMISSION\n\tuniform float transmission;\n\tuniform float thickness;\n\tuniform float attenuationDistance;\n\tuniform vec3 attenuationColor;\n\t#ifdef USE_TRANSMISSIONMAP\n\t\tuniform sampler2D transmissionMap;\n\t#endif\n\t#ifdef USE_THICKNESSMAP\n\t\tuniform sampler2D thicknessMap;\n\t#endif\n\tuniform vec2 transmissionSamplerSize;\n\tuniform sampler2D transmissionSamplerMap;\n\tuniform mat4 modelMatrix;\n\tuniform mat4 projectionMatrix;\n\tvarying vec3 vWorldPosition;\n\tfloat w0( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - a + 3.0 ) - 3.0 ) + 1.0 );\n\t}\n\tfloat w1( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a *  a * ( 3.0 * a - 6.0 ) + 4.0 );\n\t}\n\tfloat w2( float a ){\n\t\treturn ( 1.0 / 6.0 ) * ( a * ( a * ( - 3.0 * a + 3.0 ) + 3.0 ) + 1.0 );\n\t}\n\tfloat w3( float a ) {\n\t\treturn ( 1.0 / 6.0 ) * ( a * a * a );\n\t}\n\tfloat g0( float a ) {\n\t\treturn w0( a ) + w1( a );\n\t}\n\tfloat g1( float a ) {\n\t\treturn w2( a ) + w3( a );\n\t}\n\tfloat h0( float a ) {\n\t\treturn - 1.0 + w1( a ) / ( w0( a ) + w1( a ) );\n\t}\n\tfloat h1( float a ) {\n\t\treturn 1.0 + w3( a ) / ( w2( a ) + w3( a ) );\n\t}\n\tvec4 bicubic( sampler2D tex, vec2 uv, vec4 texelSize, float lod ) {\n\t\tuv = uv * texelSize.zw + 0.5;\n\t\tvec2 iuv = floor( uv );\n\t\tvec2 fuv = fract( uv );\n\t\tfloat g0x = g0( fuv.x );\n\t\tfloat g1x = g1( fuv.x );\n\t\tfloat h0x = h0( fuv.x );\n\t\tfloat h1x = h1( fuv.x );\n\t\tfloat h0y = h0( fuv.y );\n\t\tfloat h1y = h1( fuv.y );\n\t\tvec2 p0 = ( vec2( iuv.x + h0x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p1 = ( vec2( iuv.x + h1x, iuv.y + h0y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p2 = ( vec2( iuv.x + h0x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\tvec2 p3 = ( vec2( iuv.x + h1x, iuv.y + h1y ) - 0.5 ) * texelSize.xy;\n\t\treturn g0( fuv.y ) * ( g0x * textureLod( tex, p0, lod ) + g1x * textureLod( tex, p1, lod ) ) +\n\t\t\tg1( fuv.y ) * ( g0x * textureLod( tex, p2, lod ) + g1x * textureLod( tex, p3, lod ) );\n\t}\n\tvec4 textureBicubic( sampler2D sampler, vec2 uv, float lod ) {\n\t\tvec2 fLodSize = vec2( textureSize( sampler, int( lod ) ) );\n\t\tvec2 cLodSize = vec2( textureSize( sampler, int( lod + 1.0 ) ) );\n\t\tvec2 fLodSizeInv = 1.0 / fLodSize;\n\t\tvec2 cLodSizeInv = 1.0 / cLodSize;\n\t\tvec4 fSample = bicubic( sampler, uv, vec4( fLodSizeInv, fLodSize ), floor( lod ) );\n\t\tvec4 cSample = bicubic( sampler, uv, vec4( cLodSizeInv, cLodSize ), ceil( lod ) );\n\t\treturn mix( fSample, cSample, fract( lod ) );\n\t}\n\tvec3 getVolumeTransmissionRay( const in vec3 n, const in vec3 v, const in float thickness, const in float ior, const in mat4 modelMatrix ) {\n\t\tvec3 refractionVector = refract( - v, normalize( n ), 1.0 / ior );\n\t\tvec3 modelScale;\n\t\tmodelScale.x = length( vec3( modelMatrix[ 0 ].xyz ) );\n\t\tmodelScale.y = length( vec3( modelMatrix[ 1 ].xyz ) );\n\t\tmodelScale.z = length( vec3( modelMatrix[ 2 ].xyz ) );\n\t\treturn normalize( refractionVector ) * thickness * modelScale;\n\t}\n\tfloat applyIorToRoughness( const in float roughness, const in float ior ) {\n\t\treturn roughness * clamp( ior * 2.0 - 2.0, 0.0, 1.0 );\n\t}\n\tvec4 getTransmissionSample( const in vec2 fragCoord, const in float roughness, const in float ior ) {\n\t\tfloat lod = log2( transmissionSamplerSize.x ) * applyIorToRoughness( roughness, ior );\n\t\treturn textureBicubic( transmissionSamplerMap, fragCoord.xy, lod );\n\t}\n\tvec3 volumeAttenuation( const in float transmissionDistance, const in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tif ( isinf( attenuationDistance ) ) {\n\t\t\treturn vec3( 1.0 );\n\t\t} else {\n\t\t\tvec3 attenuationCoefficient = -log( attenuationColor ) / attenuationDistance;\n\t\t\tvec3 transmittance = exp( - attenuationCoefficient * transmissionDistance );\t\t\treturn transmittance;\n\t\t}\n\t}\n\tvec4 getIBLVolumeRefraction( const in vec3 n, const in vec3 v, const in float roughness, const in vec3 diffuseColor,\n\t\tconst in vec3 specularColor, const in float specularF90, const in vec3 position, const in mat4 modelMatrix,\n\t\tconst in mat4 viewMatrix, const in mat4 projMatrix, const in float dispersion, const in float ior, const in float thickness,\n\t\tconst in vec3 attenuationColor, const in float attenuationDistance ) {\n\t\tvec4 transmittedLight;\n\t\tvec3 transmittance;\n\t\t#ifdef USE_DISPERSION\n\t\t\tfloat halfSpread = ( ior - 1.0 ) * 0.025 * dispersion;\n\t\t\tvec3 iors = vec3( ior - halfSpread, ior, ior + halfSpread );\n\t\t\tfor ( int i = 0; i < 3; i ++ ) {\n\t\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, iors[ i ], modelMatrix );\n\t\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\t\trefractionCoords += 1.0;\n\t\t\t\trefractionCoords /= 2.0;\n\t\t\t\tvec4 transmissionSample = getTransmissionSample( refractionCoords, roughness, iors[ i ] );\n\t\t\t\ttransmittedLight[ i ] = transmissionSample[ i ];\n\t\t\t\ttransmittedLight.a += transmissionSample.a;\n\t\t\t\ttransmittance[ i ] = diffuseColor[ i ] * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance )[ i ];\n\t\t\t}\n\t\t\ttransmittedLight.a /= 3.0;\n\t\t#else\n\t\t\tvec3 transmissionRay = getVolumeTransmissionRay( n, v, thickness, ior, modelMatrix );\n\t\t\tvec3 refractedRayExit = position + transmissionRay;\n\t\t\tvec4 ndcPos = projMatrix * viewMatrix * vec4( refractedRayExit, 1.0 );\n\t\t\tvec2 refractionCoords = ndcPos.xy / ndcPos.w;\n\t\t\trefractionCoords += 1.0;\n\t\t\trefractionCoords /= 2.0;\n\t\t\ttransmittedLight = getTransmissionSample( refractionCoords, roughness, ior );\n\t\t\ttransmittance = diffuseColor * volumeAttenuation( length( transmissionRay ), attenuationColor, attenuationDistance );\n\t\t#endif\n\t\tvec3 attenuatedColor = transmittance * transmittedLight.rgb;\n\t\tvec3 F = EnvironmentBRDF( n, v, specularColor, specularF90, roughness );\n\t\tfloat transmittanceFactor = ( transmittance.r + transmittance.g + transmittance.b ) / 3.0;\n\t\treturn vec4( ( 1.0 - F ) * attenuatedColor, 1.0 - ( 1.0 - transmittedLight.a ) * transmittanceFactor );\n\t}\n#endif",
                    uv_pars_fragment: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
                    uv_pars_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvarying vec2 vUv;\n#endif\n#ifdef USE_MAP\n\tuniform mat3 mapTransform;\n\tvarying vec2 vMapUv;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform mat3 alphaMapTransform;\n\tvarying vec2 vAlphaMapUv;\n#endif\n#ifdef USE_LIGHTMAP\n\tuniform mat3 lightMapTransform;\n\tvarying vec2 vLightMapUv;\n#endif\n#ifdef USE_AOMAP\n\tuniform mat3 aoMapTransform;\n\tvarying vec2 vAoMapUv;\n#endif\n#ifdef USE_BUMPMAP\n\tuniform mat3 bumpMapTransform;\n\tvarying vec2 vBumpMapUv;\n#endif\n#ifdef USE_NORMALMAP\n\tuniform mat3 normalMapTransform;\n\tvarying vec2 vNormalMapUv;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tuniform mat3 displacementMapTransform;\n\tvarying vec2 vDisplacementMapUv;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tuniform mat3 emissiveMapTransform;\n\tvarying vec2 vEmissiveMapUv;\n#endif\n#ifdef USE_METALNESSMAP\n\tuniform mat3 metalnessMapTransform;\n\tvarying vec2 vMetalnessMapUv;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tuniform mat3 roughnessMapTransform;\n\tvarying vec2 vRoughnessMapUv;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tuniform mat3 anisotropyMapTransform;\n\tvarying vec2 vAnisotropyMapUv;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tuniform mat3 clearcoatMapTransform;\n\tvarying vec2 vClearcoatMapUv;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform mat3 clearcoatNormalMapTransform;\n\tvarying vec2 vClearcoatNormalMapUv;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform mat3 clearcoatRoughnessMapTransform;\n\tvarying vec2 vClearcoatRoughnessMapUv;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tuniform mat3 sheenColorMapTransform;\n\tvarying vec2 vSheenColorMapUv;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tuniform mat3 sheenRoughnessMapTransform;\n\tvarying vec2 vSheenRoughnessMapUv;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tuniform mat3 iridescenceMapTransform;\n\tvarying vec2 vIridescenceMapUv;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tuniform mat3 iridescenceThicknessMapTransform;\n\tvarying vec2 vIridescenceThicknessMapUv;\n#endif\n#ifdef USE_SPECULARMAP\n\tuniform mat3 specularMapTransform;\n\tvarying vec2 vSpecularMapUv;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tuniform mat3 specularColorMapTransform;\n\tvarying vec2 vSpecularColorMapUv;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tuniform mat3 specularIntensityMapTransform;\n\tvarying vec2 vSpecularIntensityMapUv;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tuniform mat3 transmissionMapTransform;\n\tvarying vec2 vTransmissionMapUv;\n#endif\n#ifdef USE_THICKNESSMAP\n\tuniform mat3 thicknessMapTransform;\n\tvarying vec2 vThicknessMapUv;\n#endif",
                    uv_vertex: "#if defined( USE_UV ) || defined( USE_ANISOTROPY )\n\tvUv = vec3( uv, 1 ).xy;\n#endif\n#ifdef USE_MAP\n\tvMapUv = ( mapTransform * vec3( MAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ALPHAMAP\n\tvAlphaMapUv = ( alphaMapTransform * vec3( ALPHAMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_LIGHTMAP\n\tvLightMapUv = ( lightMapTransform * vec3( LIGHTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_AOMAP\n\tvAoMapUv = ( aoMapTransform * vec3( AOMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_BUMPMAP\n\tvBumpMapUv = ( bumpMapTransform * vec3( BUMPMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_NORMALMAP\n\tvNormalMapUv = ( normalMapTransform * vec3( NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_DISPLACEMENTMAP\n\tvDisplacementMapUv = ( displacementMapTransform * vec3( DISPLACEMENTMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_EMISSIVEMAP\n\tvEmissiveMapUv = ( emissiveMapTransform * vec3( EMISSIVEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_METALNESSMAP\n\tvMetalnessMapUv = ( metalnessMapTransform * vec3( METALNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ROUGHNESSMAP\n\tvRoughnessMapUv = ( roughnessMapTransform * vec3( ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_ANISOTROPYMAP\n\tvAnisotropyMapUv = ( anisotropyMapTransform * vec3( ANISOTROPYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOATMAP\n\tvClearcoatMapUv = ( clearcoatMapTransform * vec3( CLEARCOATMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tvClearcoatNormalMapUv = ( clearcoatNormalMapTransform * vec3( CLEARCOAT_NORMALMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tvClearcoatRoughnessMapUv = ( clearcoatRoughnessMapTransform * vec3( CLEARCOAT_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCEMAP\n\tvIridescenceMapUv = ( iridescenceMapTransform * vec3( IRIDESCENCEMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_IRIDESCENCE_THICKNESSMAP\n\tvIridescenceThicknessMapUv = ( iridescenceThicknessMapTransform * vec3( IRIDESCENCE_THICKNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_COLORMAP\n\tvSheenColorMapUv = ( sheenColorMapTransform * vec3( SHEEN_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SHEEN_ROUGHNESSMAP\n\tvSheenRoughnessMapUv = ( sheenRoughnessMapTransform * vec3( SHEEN_ROUGHNESSMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULARMAP\n\tvSpecularMapUv = ( specularMapTransform * vec3( SPECULARMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_COLORMAP\n\tvSpecularColorMapUv = ( specularColorMapTransform * vec3( SPECULAR_COLORMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_SPECULAR_INTENSITYMAP\n\tvSpecularIntensityMapUv = ( specularIntensityMapTransform * vec3( SPECULAR_INTENSITYMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_TRANSMISSIONMAP\n\tvTransmissionMapUv = ( transmissionMapTransform * vec3( TRANSMISSIONMAP_UV, 1 ) ).xy;\n#endif\n#ifdef USE_THICKNESSMAP\n\tvThicknessMapUv = ( thicknessMapTransform * vec3( THICKNESSMAP_UV, 1 ) ).xy;\n#endif",
                    worldpos_vertex: "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP ) || defined ( USE_TRANSMISSION ) || NUM_SPOT_LIGHT_COORDS > 0\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_BATCHING\n\t\tworldPosition = batchingMatrix * worldPosition;\n\t#endif\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif",
                    background_vert: "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}",
                    background_frag: "uniform sampler2D t2D;\nuniform float backgroundIntensity;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\t#ifdef DECODE_VIDEO_TEXTURE\n\t\ttexColor = vec4( mix( pow( texColor.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), texColor.rgb * 0.0773993808, vec3( lessThanEqual( texColor.rgb, vec3( 0.04045 ) ) ) ), texColor.w );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
                    backgroundCube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
                    backgroundCube_frag: "#ifdef ENVMAP_TYPE_CUBE\n\tuniform samplerCube envMap;\n#elif defined( ENVMAP_TYPE_CUBE_UV )\n\tuniform sampler2D envMap;\n#endif\nuniform float flipEnvMap;\nuniform float backgroundBlurriness;\nuniform float backgroundIntensity;\nuniform mat3 backgroundRotation;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 texColor = textureCube( envMap, backgroundRotation * vec3( flipEnvMap * vWorldDirection.x, vWorldDirection.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 texColor = textureCubeUV( envMap, backgroundRotation * vWorldDirection, backgroundBlurriness );\n\t#else\n\t\tvec4 texColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t#endif\n\ttexColor.rgb *= backgroundIntensity;\n\tgl_FragColor = texColor;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
                    cube_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}",
                    cube_frag: "uniform samplerCube tCube;\nuniform float tFlip;\nuniform float opacity;\nvarying vec3 vWorldDirection;\nvoid main() {\n\tvec4 texColor = textureCube( tCube, vec3( tFlip * vWorldDirection.x, vWorldDirection.yz ) );\n\tgl_FragColor = texColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
                    depth_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}",
                    depth_frag: "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <logdepthbuf_fragment>\n\t#ifdef USE_REVERSEDEPTHBUF\n\t\tfloat fragCoordZ = vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ];\n\t#else\n\t\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[ 0 ] / vHighPrecisionZW[ 1 ] + 0.5;\n\t#endif\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#elif DEPTH_PACKING == 3202\n\t\tgl_FragColor = vec4( packDepthToRGB( fragCoordZ ), 1.0 );\n\t#elif DEPTH_PACKING == 3203\n\t\tgl_FragColor = vec4( packDepthToRG( fragCoordZ ), 0.0, 1.0 );\n\t#endif\n}",
                    distanceRGBA_vert: "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <skinbase_vertex>\n\t#include <morphinstance_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}",
                    distanceRGBA_frag: "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <clipping_planes_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}",
                    equirect_vert: "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}",
                    equirect_frag: "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tgl_FragColor = texture2D( tEquirect, sampleUV );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n}",
                    linedashed_vert: "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
                    linedashed_frag: "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
                    meshbasic_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#if defined ( USE_ENVMAP ) || defined ( USE_SKINNING )\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinbase_vertex>\n\t\t#include <skinnormal_vertex>\n\t\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}",
                    meshbasic_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel = texture2D( lightMap, vLightMapUv );\n\t\treflectedLight.indirectDiffuse += lightMapTexel.rgb * lightMapIntensity * RECIPROCAL_PI;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    meshlambert_vert: "#define LAMBERT\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
                    meshlambert_frag: "#define LAMBERT\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_lambert_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_lambert_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    meshmatcap_vert: "#define MATCAP\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}",
                    meshmatcap_frag: "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t#else\n\t\tvec4 matcapColor = vec4( vec3( mix( 0.2, 0.8, uv.y ) ), 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    meshnormal_vert: "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}",
                    meshnormal_frag: "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( USE_NORMALMAP_TANGENTSPACE )\n\tvarying vec3 vViewPosition;\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <normal_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( 0.0, 0.0, 0.0, opacity );\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), diffuseColor.a );\n\t#ifdef OPAQUE\n\t\tgl_FragColor.a = 1.0;\n\t#endif\n}",
                    meshphong_vert: "#define PHONG\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
                    meshphong_frag: "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    meshphysical_vert: "#define STANDARD\nvarying vec3 vViewPosition;\n#ifdef USE_TRANSMISSION\n\tvarying vec3 vWorldPosition;\n#endif\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n#ifdef USE_TRANSMISSION\n\tvWorldPosition = worldPosition.xyz;\n#endif\n}",
                    meshphysical_frag: "#define STANDARD\n#ifdef PHYSICAL\n\t#define IOR\n\t#define USE_SPECULAR\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef IOR\n\tuniform float ior;\n#endif\n#ifdef USE_SPECULAR\n\tuniform float specularIntensity;\n\tuniform vec3 specularColor;\n\t#ifdef USE_SPECULAR_COLORMAP\n\t\tuniform sampler2D specularColorMap;\n\t#endif\n\t#ifdef USE_SPECULAR_INTENSITYMAP\n\t\tuniform sampler2D specularIntensityMap;\n\t#endif\n#endif\n#ifdef USE_CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_DISPERSION\n\tuniform float dispersion;\n#endif\n#ifdef USE_IRIDESCENCE\n\tuniform float iridescence;\n\tuniform float iridescenceIOR;\n\tuniform float iridescenceThicknessMinimum;\n\tuniform float iridescenceThicknessMaximum;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheenColor;\n\tuniform float sheenRoughness;\n\t#ifdef USE_SHEEN_COLORMAP\n\t\tuniform sampler2D sheenColorMap;\n\t#endif\n\t#ifdef USE_SHEEN_ROUGHNESSMAP\n\t\tuniform sampler2D sheenRoughnessMap;\n\t#endif\n#endif\n#ifdef USE_ANISOTROPY\n\tuniform vec2 anisotropyVector;\n\t#ifdef USE_ANISOTROPYMAP\n\t\tuniform sampler2D anisotropyMap;\n\t#endif\n#endif\nvarying vec3 vViewPosition;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <iridescence_fragment>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_physical_pars_fragment>\n#include <transmission_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <iridescence_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 totalDiffuse = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse;\n\tvec3 totalSpecular = reflectedLight.directSpecular + reflectedLight.indirectSpecular;\n\t#include <transmission_fragment>\n\tvec3 outgoingLight = totalDiffuse + totalSpecular + totalEmissiveRadiance;\n\t#ifdef USE_SHEEN\n\t\tfloat sheenEnergyComp = 1.0 - 0.157 * max3( material.sheenColor );\n\t\toutgoingLight = outgoingLight * sheenEnergyComp + sheenSpecularDirect + sheenSpecularIndirect;\n\t#endif\n\t#ifdef USE_CLEARCOAT\n\t\tfloat dotNVcc = saturate( dot( geometryClearcoatNormal, geometryViewDir ) );\n\t\tvec3 Fcc = F_Schlick( material.clearcoatF0, material.clearcoatF90, dotNVcc );\n\t\toutgoingLight = outgoingLight * ( 1.0 - material.clearcoat * Fcc ) + ( clearcoatSpecularDirect + clearcoatSpecularIndirect ) * material.clearcoat;\n\t#endif\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    meshtoon_vert: "#define TOON\nvarying vec3 vViewPosition;\n#include <common>\n#include <batching_pars_vertex>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <normal_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <normal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
                    meshtoon_frag: "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <normal_pars_fragment>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}",
                    points_vert: "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\n#ifdef USE_POINTS_UV\n\tvarying vec2 vUv;\n\tuniform mat3 uvTransform;\n#endif\nvoid main() {\n\t#ifdef USE_POINTS_UV\n\t\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\t#endif\n\t#include <color_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphcolor_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}",
                    points_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}",
                    shadow_vert: "#include <common>\n#include <batching_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <batching_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphinstance_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}",
                    shadow_frag: "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <logdepthbuf_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\t#include <logdepthbuf_fragment>\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}",
                    sprite_vert: "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix[ 3 ];\n\tvec2 scale = vec2( length( modelMatrix[ 0 ].xyz ), length( modelMatrix[ 1 ].xyz ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}",
                    sprite_frag: "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <alphatest_pars_fragment>\n#include <alphahash_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <alphahash_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\t#include <opaque_fragment>\n\t#include <tonemapping_fragment>\n\t#include <colorspace_fragment>\n\t#include <fog_fragment>\n}"
                }, Dl = {
                    common: {
                        diffuse: {
                            value: new ls.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        map: {
                            value: null
                        },
                        mapTransform: {
                            value: new ls.dwI
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new ls.dwI
                        },
                        alphaTest: {
                            value: 0
                        }
                    },
                    specularmap: {
                        specularMap: {
                            value: null
                        },
                        specularMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    envmap: {
                        envMap: {
                            value: null
                        },
                        envMapRotation: {
                            value: new ls.dwI
                        },
                        flipEnvMap: {
                            value: -1
                        },
                        reflectivity: {
                            value: 1
                        },
                        ior: {
                            value: 1.5
                        },
                        refractionRatio: {
                            value: .98
                        }
                    },
                    aomap: {
                        aoMap: {
                            value: null
                        },
                        aoMapIntensity: {
                            value: 1
                        },
                        aoMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    lightmap: {
                        lightMap: {
                            value: null
                        },
                        lightMapIntensity: {
                            value: 1
                        },
                        lightMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    bumpmap: {
                        bumpMap: {
                            value: null
                        },
                        bumpMapTransform: {
                            value: new ls.dwI
                        },
                        bumpScale: {
                            value: 1
                        }
                    },
                    normalmap: {
                        normalMap: {
                            value: null
                        },
                        normalMapTransform: {
                            value: new ls.dwI
                        },
                        normalScale: {
                            value: new ls.I9Y(1, 1)
                        }
                    },
                    displacementmap: {
                        displacementMap: {
                            value: null
                        },
                        displacementMapTransform: {
                            value: new ls.dwI
                        },
                        displacementScale: {
                            value: 1
                        },
                        displacementBias: {
                            value: 0
                        }
                    },
                    emissivemap: {
                        emissiveMap: {
                            value: null
                        },
                        emissiveMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    metalnessmap: {
                        metalnessMap: {
                            value: null
                        },
                        metalnessMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    roughnessmap: {
                        roughnessMap: {
                            value: null
                        },
                        roughnessMapTransform: {
                            value: new ls.dwI
                        }
                    },
                    gradientmap: {
                        gradientMap: {
                            value: null
                        }
                    },
                    fog: {
                        fogDensity: {
                            value: 25e-5
                        },
                        fogNear: {
                            value: 1
                        },
                        fogFar: {
                            value: 2e3
                        },
                        fogColor: {
                            value: new ls.Q1f(16777215)
                        }
                    },
                    lights: {
                        ambientLightColor: {
                            value: []
                        },
                        lightProbe: {
                            value: []
                        },
                        directionalLights: {
                            value: [],
                            properties: {
                                direction: {},
                                color: {}
                            }
                        },
                        directionalLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {}
                            }
                        },
                        directionalShadowMap: {
                            value: []
                        },
                        directionalShadowMatrix: {
                            value: []
                        },
                        spotLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                direction: {},
                                distance: {},
                                coneCos: {},
                                penumbraCos: {},
                                decay: {}
                            }
                        },
                        spotLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {}
                            }
                        },
                        spotLightMap: {
                            value: []
                        },
                        spotShadowMap: {
                            value: []
                        },
                        spotLightMatrix: {
                            value: []
                        },
                        pointLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                decay: {},
                                distance: {}
                            }
                        },
                        pointLightShadows: {
                            value: [],
                            properties: {
                                shadowIntensity: 1,
                                shadowBias: {},
                                shadowNormalBias: {},
                                shadowRadius: {},
                                shadowMapSize: {},
                                shadowCameraNear: {},
                                shadowCameraFar: {}
                            }
                        },
                        pointShadowMap: {
                            value: []
                        },
                        pointShadowMatrix: {
                            value: []
                        },
                        hemisphereLights: {
                            value: [],
                            properties: {
                                direction: {},
                                skyColor: {},
                                groundColor: {}
                            }
                        },
                        rectAreaLights: {
                            value: [],
                            properties: {
                                color: {},
                                position: {},
                                width: {},
                                height: {}
                            }
                        },
                        ltc_1: {
                            value: null
                        },
                        ltc_2: {
                            value: null
                        }
                    },
                    points: {
                        diffuse: {
                            value: new ls.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        size: {
                            value: 1
                        },
                        scale: {
                            value: 1
                        },
                        map: {
                            value: null
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new ls.dwI
                        },
                        alphaTest: {
                            value: 0
                        },
                        uvTransform: {
                            value: new ls.dwI
                        }
                    },
                    sprite: {
                        diffuse: {
                            value: new ls.Q1f(16777215)
                        },
                        opacity: {
                            value: 1
                        },
                        center: {
                            value: new ls.I9Y(.5, .5)
                        },
                        rotation: {
                            value: 0
                        },
                        map: {
                            value: null
                        },
                        mapTransform: {
                            value: new ls.dwI
                        },
                        alphaMap: {
                            value: null
                        },
                        alphaMapTransform: {
                            value: new ls.dwI
                        },
                        alphaTest: {
                            value: 0
                        }
                    }
                }, Fl = {
                    basic: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.specularmap,
                            Dl.envmap,
                            Dl.aomap,
                            Dl.lightmap,
                            Dl.fog
                        ]),
                        vertexShader: ho.meshbasic_vert,
                        fragmentShader: ho.meshbasic_frag
                    },
                    lambert: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.specularmap,
                            Dl.envmap,
                            Dl.aomap,
                            Dl.lightmap,
                            Dl.emissivemap,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            Dl.fog,
                            Dl.lights,
                            {
                                emissive: {
                                    value: new ls.Q1f(0)
                                }
                            }
                        ]),
                        vertexShader: ho.meshlambert_vert,
                        fragmentShader: ho.meshlambert_frag
                    },
                    phong: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.specularmap,
                            Dl.envmap,
                            Dl.aomap,
                            Dl.lightmap,
                            Dl.emissivemap,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            Dl.fog,
                            Dl.lights,
                            {
                                emissive: {
                                    value: new ls.Q1f(0)
                                },
                                specular: {
                                    value: new ls.Q1f(1118481)
                                },
                                shininess: {
                                    value: 30
                                }
                            }
                        ]),
                        vertexShader: ho.meshphong_vert,
                        fragmentShader: ho.meshphong_frag
                    },
                    standard: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.envmap,
                            Dl.aomap,
                            Dl.lightmap,
                            Dl.emissivemap,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            Dl.roughnessmap,
                            Dl.metalnessmap,
                            Dl.fog,
                            Dl.lights,
                            {
                                emissive: {
                                    value: new ls.Q1f(0)
                                },
                                roughness: {
                                    value: 1
                                },
                                metalness: {
                                    value: 0
                                },
                                envMapIntensity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: ho.meshphysical_vert,
                        fragmentShader: ho.meshphysical_frag
                    },
                    toon: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.aomap,
                            Dl.lightmap,
                            Dl.emissivemap,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            Dl.gradientmap,
                            Dl.fog,
                            Dl.lights,
                            {
                                emissive: {
                                    value: new ls.Q1f(0)
                                }
                            }
                        ]),
                        vertexShader: ho.meshtoon_vert,
                        fragmentShader: ho.meshtoon_frag
                    },
                    matcap: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            Dl.fog,
                            {
                                matcap: {
                                    value: null
                                }
                            }
                        ]),
                        vertexShader: ho.meshmatcap_vert,
                        fragmentShader: ho.meshmatcap_frag
                    },
                    points: {
                        uniforms: (0, ls.Iit)([
                            Dl.points,
                            Dl.fog
                        ]),
                        vertexShader: ho.points_vert,
                        fragmentShader: ho.points_frag
                    },
                    dashed: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.fog,
                            {
                                scale: {
                                    value: 1
                                },
                                dashSize: {
                                    value: 1
                                },
                                totalSize: {
                                    value: 2
                                }
                            }
                        ]),
                        vertexShader: ho.linedashed_vert,
                        fragmentShader: ho.linedashed_frag
                    },
                    depth: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.displacementmap
                        ]),
                        vertexShader: ho.depth_vert,
                        fragmentShader: ho.depth_frag
                    },
                    normal: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.bumpmap,
                            Dl.normalmap,
                            Dl.displacementmap,
                            {
                                opacity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: ho.meshnormal_vert,
                        fragmentShader: ho.meshnormal_frag
                    },
                    sprite: {
                        uniforms: (0, ls.Iit)([
                            Dl.sprite,
                            Dl.fog
                        ]),
                        vertexShader: ho.sprite_vert,
                        fragmentShader: ho.sprite_frag
                    },
                    background: {
                        uniforms: {
                            uvTransform: {
                                value: new ls.dwI
                            },
                            t2D: {
                                value: null
                            },
                            backgroundIntensity: {
                                value: 1
                            }
                        },
                        vertexShader: ho.background_vert,
                        fragmentShader: ho.background_frag
                    },
                    backgroundCube: {
                        uniforms: {
                            envMap: {
                                value: null
                            },
                            flipEnvMap: {
                                value: -1
                            },
                            backgroundBlurriness: {
                                value: 0
                            },
                            backgroundIntensity: {
                                value: 1
                            },
                            backgroundRotation: {
                                value: new ls.dwI
                            }
                        },
                        vertexShader: ho.backgroundCube_vert,
                        fragmentShader: ho.backgroundCube_frag
                    },
                    cube: {
                        uniforms: {
                            tCube: {
                                value: null
                            },
                            tFlip: {
                                value: -1
                            },
                            opacity: {
                                value: 1
                            }
                        },
                        vertexShader: ho.cube_vert,
                        fragmentShader: ho.cube_frag
                    },
                    equirect: {
                        uniforms: {
                            tEquirect: {
                                value: null
                            }
                        },
                        vertexShader: ho.equirect_vert,
                        fragmentShader: ho.equirect_frag
                    },
                    distanceRGBA: {
                        uniforms: (0, ls.Iit)([
                            Dl.common,
                            Dl.displacementmap,
                            {
                                referencePosition: {
                                    value: new ls.Pq0
                                },
                                nearDistance: {
                                    value: 1
                                },
                                farDistance: {
                                    value: 1e3
                                }
                            }
                        ]),
                        vertexShader: ho.distanceRGBA_vert,
                        fragmentShader: ho.distanceRGBA_frag
                    },
                    shadow: {
                        uniforms: (0, ls.Iit)([
                            Dl.lights,
                            Dl.fog,
                            {
                                color: {
                                    value: new ls.Q1f(0)
                                },
                                opacity: {
                                    value: 1
                                }
                            }
                        ]),
                        vertexShader: ho.shadow_vert,
                        fragmentShader: ho.shadow_frag
                    }
                };
                Fl.physical = {
                    uniforms: (0, ls.Iit)([
                        Fl.standard.uniforms,
                        {
                            clearcoat: {
                                value: 0
                            },
                            clearcoatMap: {
                                value: null
                            },
                            clearcoatMapTransform: {
                                value: new ls.dwI
                            },
                            clearcoatNormalMap: {
                                value: null
                            },
                            clearcoatNormalMapTransform: {
                                value: new ls.dwI
                            },
                            clearcoatNormalScale: {
                                value: new ls.I9Y(1, 1)
                            },
                            clearcoatRoughness: {
                                value: 0
                            },
                            clearcoatRoughnessMap: {
                                value: null
                            },
                            clearcoatRoughnessMapTransform: {
                                value: new ls.dwI
                            },
                            dispersion: {
                                value: 0
                            },
                            iridescence: {
                                value: 0
                            },
                            iridescenceMap: {
                                value: null
                            },
                            iridescenceMapTransform: {
                                value: new ls.dwI
                            },
                            iridescenceIOR: {
                                value: 1.3
                            },
                            iridescenceThicknessMinimum: {
                                value: 100
                            },
                            iridescenceThicknessMaximum: {
                                value: 400
                            },
                            iridescenceThicknessMap: {
                                value: null
                            },
                            iridescenceThicknessMapTransform: {
                                value: new ls.dwI
                            },
                            sheen: {
                                value: 0
                            },
                            sheenColor: {
                                value: new ls.Q1f(0)
                            },
                            sheenColorMap: {
                                value: null
                            },
                            sheenColorMapTransform: {
                                value: new ls.dwI
                            },
                            sheenRoughness: {
                                value: 1
                            },
                            sheenRoughnessMap: {
                                value: null
                            },
                            sheenRoughnessMapTransform: {
                                value: new ls.dwI
                            },
                            transmission: {
                                value: 0
                            },
                            transmissionMap: {
                                value: null
                            },
                            transmissionMapTransform: {
                                value: new ls.dwI
                            },
                            transmissionSamplerSize: {
                                value: new ls.I9Y
                            },
                            transmissionSamplerMap: {
                                value: null
                            },
                            thickness: {
                                value: 0
                            },
                            thicknessMap: {
                                value: null
                            },
                            thicknessMapTransform: {
                                value: new ls.dwI
                            },
                            attenuationDistance: {
                                value: 0
                            },
                            attenuationColor: {
                                value: new ls.Q1f(0)
                            },
                            specularColor: {
                                value: new ls.Q1f(1, 1, 1)
                            },
                            specularColorMap: {
                                value: null
                            },
                            specularColorMapTransform: {
                                value: new ls.dwI
                            },
                            specularIntensity: {
                                value: 1
                            },
                            specularIntensityMap: {
                                value: null
                            },
                            specularIntensityMapTransform: {
                                value: new ls.dwI
                            },
                            anisotropyVector: {
                                value: new ls.I9Y
                            },
                            anisotropyMap: {
                                value: null
                            },
                            anisotropyMapTransform: {
                                value: new ls.dwI
                            }
                        }
                    ]),
                    vertexShader: ho.meshphysical_vert,
                    fragmentShader: ho.meshphysical_frag
                };
                const sc = {
                    r: 0,
                    b: 0,
                    g: 0
                }, uc = new ls.O9p, mc = new ls.kn4;
                function WebGLBackground(le1, vt, bt, ho, Dl, gc, Ac) {
                    const Ec = new ls.Q1f(0);
                    let kc, du, _u = !0 === gc ? 0 : 1, Md = null, Ld = 0, Nd = null;
                    function getBackground(le1) {
                        let ls = !0 === le1.isScene ? le1.background : null;
                        if (ls && ls.isTexture) ls = (le1.backgroundBlurriness > 0 ? bt : vt).get(ls);
                        return ls;
                    }
                    function setClear(vt, bt) {
                        vt.getRGB(sc, (0, ls._Ut)(le1)), ho.buffers.color.setClear(sc.r, sc.g, sc.b, bt, Ac);
                    }
                    return {
                        getClearColor: function() {
                            return Ec;
                        },
                        setClearColor: function(le1, vt) {
                            void 0 === vt && (vt = 1), Ec.set(le1), _u = vt, setClear(Ec, _u);
                        },
                        getClearAlpha: function() {
                            return _u;
                        },
                        setClearAlpha: function(le1) {
                            _u = le1, setClear(Ec, _u);
                        },
                        render: function(vt) {
                            let bt = !1;
                            const ls = getBackground(vt);
                            null === ls ? setClear(Ec, _u) : ls && ls.isColor && (setClear(ls, 1), bt = !0);
                            const Dl = le1.xr.getEnvironmentBlendMode();
                            "additive" === Dl ? ho.buffers.color.setClear(0, 0, 0, 1, Ac) : "alpha-blend" === Dl && ho.buffers.color.setClear(0, 0, 0, 0, Ac), (le1.autoClear || bt) && (ho.buffers.depth.setTest(!0), ho.buffers.depth.setMask(!0), ho.buffers.color.setMask(!0), le1.clear(le1.autoClearColor, le1.autoClearDepth, le1.autoClearStencil));
                        },
                        addToRenderList: function(vt, bt) {
                            const ho = getBackground(bt);
                            ho && (ho.isCubeTexture || ho.mapping === ls.Om) ? (void 0 === du && (du = new ls.eaF(new ls.iNn(1, 1, 1), new ls.BKk({
                                name: "BackgroundCubeMaterial",
                                uniforms: (0, ls.lxW)(Fl.backgroundCube.uniforms),
                                vertexShader: Fl.backgroundCube.vertexShader,
                                fragmentShader: Fl.backgroundCube.fragmentShader,
                                side: ls.hsX,
                                depthTest: !1,
                                depthWrite: !1,
                                fog: !1,
                                allowOverride: !1
                            })), du.geometry.deleteAttribute("normal"), du.geometry.deleteAttribute("uv"), du.onBeforeRender = function(le1, vt, bt) {
                                this.matrixWorld.copyPosition(bt.matrixWorld);
                            }, Object.defineProperty(du.material, "envMap", {
                                get: function() {
                                    return this.uniforms.envMap.value;
                                }
                            }), Dl.update(du)), uc.copy(bt.backgroundRotation), uc.x *= -1, uc.y *= -1, uc.z *= -1, ho.isCubeTexture && !1 === ho.isRenderTargetTexture && (uc.y *= -1, uc.z *= -1), du.material.uniforms.envMap.value = ho, du.material.uniforms.flipEnvMap.value = ho.isCubeTexture && !1 === ho.isRenderTargetTexture ? -1 : 1, du.material.uniforms.backgroundBlurriness.value = bt.backgroundBlurriness, du.material.uniforms.backgroundIntensity.value = bt.backgroundIntensity, du.material.uniforms.backgroundRotation.value.setFromMatrix4(mc.makeRotationFromEuler(uc)), du.material.toneMapped = ls.ppV.getTransfer(ho.colorSpace) !== ls.KLL, Md === ho && Ld === ho.version && Nd === le1.toneMapping || (du.material.needsUpdate = !0, Md = ho, Ld = ho.version, Nd = le1.toneMapping), du.layers.enableAll(), vt.unshift(du, du.geometry, du.material, 0, 0, null)) : ho && ho.isTexture && (void 0 === kc && (kc = new ls.eaF(new ls.bdM(2, 2), new ls.BKk({
                                name: "BackgroundMaterial",
                                uniforms: (0, ls.lxW)(Fl.background.uniforms),
                                vertexShader: Fl.background.vertexShader,
                                fragmentShader: Fl.background.fragmentShader,
                                side: ls.hB5,
                                depthTest: !1,
                                depthWrite: !1,
                                fog: !1,
                                allowOverride: !1
                            })), kc.geometry.deleteAttribute("normal"), Object.defineProperty(kc.material, "map", {
                                get: function() {
                                    return this.uniforms.t2D.value;
                                }
                            }), Dl.update(kc)), kc.material.uniforms.t2D.value = ho, kc.material.uniforms.backgroundIntensity.value = bt.backgroundIntensity, kc.material.toneMapped = ls.ppV.getTransfer(ho.colorSpace) !== ls.KLL, !0 === ho.matrixAutoUpdate && ho.updateMatrix(), kc.material.uniforms.uvTransform.value.copy(ho.matrix), Md === ho && Ld === ho.version && Nd === le1.toneMapping || (kc.material.needsUpdate = !0, Md = ho, Ld = ho.version, Nd = le1.toneMapping), kc.layers.enableAll(), vt.unshift(kc, kc.geometry, kc.material, 0, 0, null));
                        },
                        dispose: function() {
                            void 0 !== du && (du.geometry.dispose(), du.material.dispose(), du = void 0), void 0 !== kc && (kc.geometry.dispose(), kc.material.dispose(), kc = void 0);
                        }
                    };
                }
                function WebGLBindingStates(le1, vt) {
                    const bt = le1.getParameter(le1.MAX_VERTEX_ATTRIBS), ho = {}, Dl = createBindingState(null);
                    let Fl = Dl, sc = !1;
                    function bindVertexArrayObject(vt) {
                        return le1.bindVertexArray(vt);
                    }
                    function deleteVertexArrayObject(vt) {
                        return le1.deleteVertexArray(vt);
                    }
                    function createBindingState(le1) {
                        const vt = [], ls = [], ho = [];
                        for(let Dl = 0; Dl < bt; Dl++)vt[Dl] = 0, ls[Dl] = 0, ho[Dl] = 0;
                        return {
                            geometry: null,
                            program: null,
                            wireframe: !1,
                            newAttributes: vt,
                            enabledAttributes: ls,
                            attributeDivisors: ho,
                            object: le1,
                            attributes: {},
                            index: null
                        };
                    }
                    function initAttributes() {
                        const le1 = Fl.newAttributes;
                        for(let vt = 0, bt = le1.length; vt < bt; vt++)le1[vt] = 0;
                    }
                    function enableAttribute(le1) {
                        enableAttributeAndDivisor(le1, 0);
                    }
                    function enableAttributeAndDivisor(vt, bt) {
                        const ls = Fl.newAttributes, ho = Fl.enabledAttributes, Dl = Fl.attributeDivisors;
                        ls[vt] = 1, 0 === ho[vt] && (le1.enableVertexAttribArray(vt), ho[vt] = 1), Dl[vt] !== bt && (le1.vertexAttribDivisor(vt, bt), Dl[vt] = bt);
                    }
                    function disableUnusedAttributes() {
                        const vt = Fl.newAttributes, bt = Fl.enabledAttributes;
                        for(let ls = 0, ho = bt.length; ls < ho; ls++)bt[ls] !== vt[ls] && (le1.disableVertexAttribArray(ls), bt[ls] = 0);
                    }
                    function vertexAttribPointer(vt, bt, ls, ho, Dl, Fl, sc) {
                        !0 === sc ? le1.vertexAttribIPointer(vt, bt, ls, Dl, Fl) : le1.vertexAttribPointer(vt, bt, ls, ho, Dl, Fl);
                    }
                    function reset() {
                        resetDefaultState(), sc = !0, Fl !== Dl && (Fl = Dl, bindVertexArrayObject(Fl.object));
                    }
                    function resetDefaultState() {
                        Dl.geometry = null, Dl.program = null, Dl.wireframe = !1;
                    }
                    return {
                        setup: function(bt, Dl, uc, mc, gc) {
                            let Ac = !1;
                            const Ec = function(vt, bt, ls) {
                                const Dl = !0 === ls.wireframe;
                                let Fl = ho[vt.id];
                                void 0 === Fl && (Fl = {}, ho[vt.id] = Fl);
                                let sc = Fl[bt.id];
                                void 0 === sc && (sc = {}, Fl[bt.id] = sc);
                                let uc = sc[Dl];
                                void 0 === uc && (uc = createBindingState(le1.createVertexArray()), sc[Dl] = uc);
                                return uc;
                            }(mc, uc, Dl);
                            Fl !== Ec && (Fl = Ec, bindVertexArrayObject(Fl.object)), Ac = function(le1, vt, bt, ls) {
                                const ho = Fl.attributes, Dl = vt.attributes;
                                let sc = 0;
                                const uc = bt.getAttributes();
                                for(const Fl in uc)if (uc[Fl].location >= 0) {
                                    const vt = ho[Fl];
                                    let bt = Dl[Fl];
                                    if (void 0 === bt && ("instanceMatrix" === Fl && le1.instanceMatrix && (bt = le1.instanceMatrix), "instanceColor" === Fl && le1.instanceColor && (bt = le1.instanceColor)), void 0 === vt) return !0;
                                    if (vt.attribute !== bt) return !0;
                                    if (bt && vt.data !== bt.data) return !0;
                                    sc++;
                                }
                                return Fl.attributesNum !== sc || Fl.index !== ls;
                            }(bt, mc, uc, gc), Ac && function(le1, vt, bt, ls) {
                                const ho = {}, Dl = vt.attributes;
                                let sc = 0;
                                const uc = bt.getAttributes();
                                for(const Fl in uc)if (uc[Fl].location >= 0) {
                                    let vt = Dl[Fl];
                                    void 0 === vt && ("instanceMatrix" === Fl && le1.instanceMatrix && (vt = le1.instanceMatrix), "instanceColor" === Fl && le1.instanceColor && (vt = le1.instanceColor));
                                    const bt = {};
                                    bt.attribute = vt, vt && vt.data && (bt.data = vt.data), ho[Fl] = bt, sc++;
                                }
                                Fl.attributes = ho, Fl.attributesNum = sc, Fl.index = ls;
                            }(bt, mc, uc, gc), null !== gc && vt.update(gc, le1.ELEMENT_ARRAY_BUFFER), (Ac || sc) && (sc = !1, function(bt, ho, Dl, Fl) {
                                initAttributes();
                                const sc = Fl.attributes, uc = Dl.getAttributes(), mc = ho.defaultAttributeValues;
                                for(const gc in uc){
                                    const ho = uc[gc];
                                    if (ho.location >= 0) {
                                        let Dl = sc[gc];
                                        if (void 0 === Dl && ("instanceMatrix" === gc && bt.instanceMatrix && (Dl = bt.instanceMatrix), "instanceColor" === gc && bt.instanceColor && (Dl = bt.instanceColor)), void 0 !== Dl) {
                                            const sc = Dl.normalized, uc = Dl.itemSize, mc = vt.get(Dl);
                                            if (void 0 === mc) continue;
                                            const gc = mc.buffer, Ac = mc.type, Ec = mc.bytesPerElement, kc = Ac === le1.INT || Ac === le1.UNSIGNED_INT || Dl.gpuType === ls.Yuy;
                                            if (Dl.isInterleavedBufferAttribute) {
                                                const vt = Dl.data, ls = vt.stride, mc = Dl.offset;
                                                if (vt.isInstancedInterleavedBuffer) {
                                                    for(let le1 = 0; le1 < ho.locationSize; le1++)enableAttributeAndDivisor(ho.location + le1, vt.meshPerAttribute);
                                                    !0 !== bt.isInstancedMesh && void 0 === Fl._maxInstanceCount && (Fl._maxInstanceCount = vt.meshPerAttribute * vt.count);
                                                } else for(let le1 = 0; le1 < ho.locationSize; le1++)enableAttribute(ho.location + le1);
                                                le1.bindBuffer(le1.ARRAY_BUFFER, gc);
                                                for(let le1 = 0; le1 < ho.locationSize; le1++)vertexAttribPointer(ho.location + le1, uc / ho.locationSize, Ac, sc, ls * Ec, (mc + uc / ho.locationSize * le1) * Ec, kc);
                                            } else {
                                                if (Dl.isInstancedBufferAttribute) {
                                                    for(let le1 = 0; le1 < ho.locationSize; le1++)enableAttributeAndDivisor(ho.location + le1, Dl.meshPerAttribute);
                                                    !0 !== bt.isInstancedMesh && void 0 === Fl._maxInstanceCount && (Fl._maxInstanceCount = Dl.meshPerAttribute * Dl.count);
                                                } else for(let le1 = 0; le1 < ho.locationSize; le1++)enableAttribute(ho.location + le1);
                                                le1.bindBuffer(le1.ARRAY_BUFFER, gc);
                                                for(let le1 = 0; le1 < ho.locationSize; le1++)vertexAttribPointer(ho.location + le1, uc / ho.locationSize, Ac, sc, uc * Ec, uc / ho.locationSize * le1 * Ec, kc);
                                            }
                                        } else if (void 0 !== mc) {
                                            const vt = mc[gc];
                                            if (void 0 !== vt) switch(vt.length){
                                                case 2:
                                                    le1.vertexAttrib2fv(ho.location, vt);
                                                    break;
                                                case 3:
                                                    le1.vertexAttrib3fv(ho.location, vt);
                                                    break;
                                                case 4:
                                                    le1.vertexAttrib4fv(ho.location, vt);
                                                    break;
                                                default:
                                                    le1.vertexAttrib1fv(ho.location, vt);
                                            }
                                        }
                                    }
                                }
                                disableUnusedAttributes();
                            }(bt, Dl, uc, mc), null !== gc && le1.bindBuffer(le1.ELEMENT_ARRAY_BUFFER, vt.get(gc).buffer));
                        },
                        reset: reset,
                        resetDefaultState: resetDefaultState,
                        dispose: function() {
                            reset();
                            for(const le1 in ho){
                                const vt = ho[le1];
                                for(const le1 in vt){
                                    const bt = vt[le1];
                                    for(const le1 in bt)deleteVertexArrayObject(bt[le1].object), delete bt[le1];
                                    delete vt[le1];
                                }
                                delete ho[le1];
                            }
                        },
                        releaseStatesOfGeometry: function(le1) {
                            if (void 0 === ho[le1.id]) return;
                            const vt = ho[le1.id];
                            for(const bt in vt){
                                const le1 = vt[bt];
                                for(const vt in le1)deleteVertexArrayObject(le1[vt].object), delete le1[vt];
                                delete vt[bt];
                            }
                            delete ho[le1.id];
                        },
                        releaseStatesOfProgram: function(le1) {
                            for(const vt in ho){
                                const bt = ho[vt];
                                if (void 0 === bt[le1.id]) continue;
                                const ls = bt[le1.id];
                                for(const le1 in ls)deleteVertexArrayObject(ls[le1].object), delete ls[le1];
                                delete bt[le1.id];
                            }
                        },
                        initAttributes: initAttributes,
                        enableAttribute: enableAttribute,
                        disableUnusedAttributes: disableUnusedAttributes
                    };
                }
                function WebGLBufferRenderer(le1, vt, bt) {
                    let ls;
                    function renderInstances(vt, ho, Dl) {
                        0 !== Dl && (le1.drawArraysInstanced(ls, vt, ho, Dl), bt.update(ho, ls, Dl));
                    }
                    this.setMode = function(le1) {
                        ls = le1;
                    }, this.render = function(vt, ho) {
                        le1.drawArrays(ls, vt, ho), bt.update(ho, ls, 1);
                    }, this.renderInstances = renderInstances, this.renderMultiDraw = function(le1, ho, Dl) {
                        if (0 === Dl) return;
                        vt.get("WEBGL_multi_draw").multiDrawArraysWEBGL(ls, le1, 0, ho, 0, Dl);
                        let Fl = 0;
                        for(let vt = 0; vt < Dl; vt++)Fl += ho[vt];
                        bt.update(Fl, ls, 1);
                    }, this.renderMultiDrawInstances = function(le1, ho, Dl, Fl) {
                        if (0 === Dl) return;
                        const sc = vt.get("WEBGL_multi_draw");
                        if (null === sc) for(let vt = 0; vt < le1.length; vt++)renderInstances(le1[vt], ho[vt], Fl[vt]);
                        else {
                            sc.multiDrawArraysInstancedWEBGL(ls, le1, 0, ho, 0, Fl, 0, Dl);
                            let vt = 0;
                            for(let le1 = 0; le1 < Dl; le1++)vt += ho[le1] * Fl[le1];
                            bt.update(vt, ls, 1);
                        }
                    };
                }
                function WebGLCapabilities(le1, vt, bt, ho) {
                    let Dl;
                    function getMaxPrecision(vt) {
                        if ("highp" === vt) {
                            if (le1.getShaderPrecisionFormat(le1.VERTEX_SHADER, le1.HIGH_FLOAT).precision > 0 && le1.getShaderPrecisionFormat(le1.FRAGMENT_SHADER, le1.HIGH_FLOAT).precision > 0) return "highp";
                            vt = "mediump";
                        }
                        return "mediump" === vt && le1.getShaderPrecisionFormat(le1.VERTEX_SHADER, le1.MEDIUM_FLOAT).precision > 0 && le1.getShaderPrecisionFormat(le1.FRAGMENT_SHADER, le1.MEDIUM_FLOAT).precision > 0 ? "mediump" : "lowp";
                    }
                    let Fl = void 0 !== bt.precision ? bt.precision : "highp";
                    const sc = getMaxPrecision(Fl);
                    sc !== Fl && (console.warn("THREE.WebGLRenderer:", Fl, "not supported, using", sc, "instead."), Fl = sc);
                    const uc = !0 === bt.logarithmicDepthBuffer, mc = !0 === bt.reversedDepthBuffer && vt.has("EXT_clip_control"), gc = le1.getParameter(le1.MAX_TEXTURE_IMAGE_UNITS), Ac = le1.getParameter(le1.MAX_VERTEX_TEXTURE_IMAGE_UNITS);
                    return {
                        isWebGL2: !0,
                        getMaxAnisotropy: function() {
                            if (void 0 !== Dl) return Dl;
                            if (!0 === vt.has("EXT_texture_filter_anisotropic")) {
                                const bt = vt.get("EXT_texture_filter_anisotropic");
                                Dl = le1.getParameter(bt.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
                            } else Dl = 0;
                            return Dl;
                        },
                        getMaxPrecision: getMaxPrecision,
                        textureFormatReadable: function(vt) {
                            return vt === ls.GWd || ho.convert(vt) === le1.getParameter(le1.IMPLEMENTATION_COLOR_READ_FORMAT);
                        },
                        textureTypeReadable: function(bt) {
                            const Dl = bt === ls.ix0 && (vt.has("EXT_color_buffer_half_float") || vt.has("EXT_color_buffer_float"));
                            return !(bt !== ls.OUM && ho.convert(bt) !== le1.getParameter(le1.IMPLEMENTATION_COLOR_READ_TYPE) && bt !== ls.RQf && !Dl);
                        },
                        precision: Fl,
                        logarithmicDepthBuffer: uc,
                        reversedDepthBuffer: mc,
                        maxTextures: gc,
                        maxVertexTextures: Ac,
                        maxTextureSize: le1.getParameter(le1.MAX_TEXTURE_SIZE),
                        maxCubemapSize: le1.getParameter(le1.MAX_CUBE_MAP_TEXTURE_SIZE),
                        maxAttributes: le1.getParameter(le1.MAX_VERTEX_ATTRIBS),
                        maxVertexUniforms: le1.getParameter(le1.MAX_VERTEX_UNIFORM_VECTORS),
                        maxVaryings: le1.getParameter(le1.MAX_VARYING_VECTORS),
                        maxFragmentUniforms: le1.getParameter(le1.MAX_FRAGMENT_UNIFORM_VECTORS),
                        vertexTextures: Ac > 0,
                        maxSamples: le1.getParameter(le1.MAX_SAMPLES)
                    };
                }
                function WebGLClipping(le1) {
                    const vt = this;
                    let bt = null, ho = 0, Dl = !1, Fl = !1;
                    const sc = new ls.Zcv, uc = new ls.dwI, mc = {
                        value: null,
                        needsUpdate: !1
                    };
                    function projectPlanes(le1, bt, ls, ho) {
                        const Dl = null !== le1 ? le1.length : 0;
                        let Fl = null;
                        if (0 !== Dl) {
                            if (Fl = mc.value, !0 !== ho || null === Fl) {
                                const vt = ls + 4 * Dl, ho = bt.matrixWorldInverse;
                                uc.getNormalMatrix(ho), (null === Fl || Fl.length < vt) && (Fl = new Float32Array(vt));
                                for(let bt = 0, mc = ls; bt !== Dl; ++bt, mc += 4)sc.copy(le1[bt]).applyMatrix4(ho, uc), sc.normal.toArray(Fl, mc), Fl[mc + 3] = sc.constant;
                            }
                            mc.value = Fl, mc.needsUpdate = !0;
                        }
                        return vt.numPlanes = Dl, vt.numIntersection = 0, Fl;
                    }
                    this.uniform = mc, this.numPlanes = 0, this.numIntersection = 0, this.init = function(le1, vt) {
                        const bt = 0 !== le1.length || vt || 0 !== ho || Dl;
                        return Dl = vt, ho = le1.length, bt;
                    }, this.beginShadows = function() {
                        Fl = !0, projectPlanes(null);
                    }, this.endShadows = function() {
                        Fl = !1;
                    }, this.setGlobalState = function(le1, vt) {
                        bt = projectPlanes(le1, vt, 0);
                    }, this.setState = function(ls, sc, uc) {
                        const gc = ls.clippingPlanes, Ac = ls.clipIntersection, Ec = ls.clipShadows, kc = le1.get(ls);
                        if (!Dl || null === gc || 0 === gc.length || Fl && !Ec) Fl ? projectPlanes(null) : function() {
                            mc.value !== bt && (mc.value = bt, mc.needsUpdate = ho > 0);
                            vt.numPlanes = ho, vt.numIntersection = 0;
                        }();
                        else {
                            const le1 = Fl ? 0 : ho, vt = 4 * le1;
                            let ls = kc.clippingState || null;
                            mc.value = ls, ls = projectPlanes(gc, sc, vt, uc);
                            for(let ho = 0; ho !== vt; ++ho)ls[ho] = bt[ho];
                            kc.clippingState = ls, this.numIntersection = Ac ? this.numPlanes : 0, this.numPlanes += le1;
                        }
                    };
                }
                function WebGLCubeMaps(le1) {
                    let vt = new WeakMap;
                    function mapTextureMapping(le1, vt) {
                        return vt === ls.wfO ? le1.mapping = ls.hy7 : vt === ls.uV5 && (le1.mapping = ls.xFO), le1;
                    }
                    function onTextureDispose(le1) {
                        const bt = le1.target;
                        bt.removeEventListener("dispose", onTextureDispose);
                        const ls = vt.get(bt);
                        void 0 !== ls && (vt.delete(bt), ls.dispose());
                    }
                    return {
                        get: function(bt) {
                            if (bt && bt.isTexture) {
                                const ho = bt.mapping;
                                if (ho === ls.wfO || ho === ls.uV5) {
                                    if (vt.has(bt)) return mapTextureMapping(vt.get(bt).texture, bt.mapping);
                                    {
                                        const ho = bt.image;
                                        if (ho && ho.height > 0) {
                                            const Dl = new ls.o6l(ho.height);
                                            return Dl.fromEquirectangularTexture(le1, bt), vt.set(bt, Dl), bt.addEventListener("dispose", onTextureDispose), mapTextureMapping(Dl.texture, bt.mapping);
                                        }
                                        return null;
                                    }
                                }
                            }
                            return bt;
                        },
                        dispose: function() {
                            vt = new WeakMap;
                        }
                    };
                }
                const gc = [
                    .125,
                    .215,
                    .35,
                    .446,
                    .526,
                    .582
                ], Ac = 20, Ec = new ls.qUd, kc = new ls.Q1f;
                let du = null, _u = 0, Md = 0, Ld = !1;
                const Nd = (1 + Math.sqrt(5)) / 2, Rd = 1 / Nd, Od = [
                    new ls.Pq0(-Nd, Rd, 0),
                    new ls.Pq0(Nd, Rd, 0),
                    new ls.Pq0(-Rd, 0, Nd),
                    new ls.Pq0(Rd, 0, Nd),
                    new ls.Pq0(0, Nd, -Rd),
                    new ls.Pq0(0, Nd, Rd),
                    new ls.Pq0(-1, 1, -1),
                    new ls.Pq0(1, 1, -1),
                    new ls.Pq0(-1, 1, 1),
                    new ls.Pq0(1, 1, 1)
                ], jd = new ls.Pq0;
                class PMREMGenerator {
                    constructor(le1){
                        this._renderer = le1, this._pingPongRenderTarget = null, this._lodMax = 0, this._cubeSize = 0, this._lodPlanes = [], this._sizeLods = [], this._sigmas = [], this._blurMaterial = null, this._cubemapMaterial = null, this._equirectMaterial = null, this._compileMaterial(this._blurMaterial);
                    }
                    fromScene(le1, vt, bt, ls, ho) {
                        void 0 === vt && (vt = 0), void 0 === bt && (bt = .1), void 0 === ls && (ls = 100), void 0 === ho && (ho = {});
                        const { size: Dl = 256, position: Fl = jd } = ho;
                        du = this._renderer.getRenderTarget(), _u = this._renderer.getActiveCubeFace(), Md = this._renderer.getActiveMipmapLevel(), Ld = this._renderer.xr.enabled, this._renderer.xr.enabled = !1, this._setSize(Dl);
                        const sc = this._allocateTargets();
                        return sc.depthBuffer = !0, this._sceneToCubeUV(le1, bt, ls, sc, Fl), vt > 0 && this._blur(sc, 0, 0, vt), this._applyPMREM(sc), this._cleanup(sc), sc;
                    }
                    fromEquirectangular(le1, vt) {
                        return void 0 === vt && (vt = null), this._fromTexture(le1, vt);
                    }
                    fromCubemap(le1, vt) {
                        return void 0 === vt && (vt = null), this._fromTexture(le1, vt);
                    }
                    compileCubemapShader() {
                        null === this._cubemapMaterial && (this._cubemapMaterial = _getCubemapMaterial(), this._compileMaterial(this._cubemapMaterial));
                    }
                    compileEquirectangularShader() {
                        null === this._equirectMaterial && (this._equirectMaterial = _getEquirectMaterial(), this._compileMaterial(this._equirectMaterial));
                    }
                    dispose() {
                        this._dispose(), null !== this._cubemapMaterial && this._cubemapMaterial.dispose(), null !== this._equirectMaterial && this._equirectMaterial.dispose();
                    }
                    _setSize(le1) {
                        this._lodMax = Math.floor(Math.log2(le1)), this._cubeSize = Math.pow(2, this._lodMax);
                    }
                    _dispose() {
                        null !== this._blurMaterial && this._blurMaterial.dispose(), null !== this._pingPongRenderTarget && this._pingPongRenderTarget.dispose();
                        for(let le1 = 0; le1 < this._lodPlanes.length; le1++)this._lodPlanes[le1].dispose();
                    }
                    _cleanup(le1) {
                        this._renderer.setRenderTarget(du, _u, Md), this._renderer.xr.enabled = Ld, le1.scissorTest = !1, _setViewport(le1, 0, 0, le1.width, le1.height);
                    }
                    _fromTexture(le1, vt) {
                        le1.mapping === ls.hy7 || le1.mapping === ls.xFO ? this._setSize(0 === le1.image.length ? 16 : le1.image[0].width || le1.image[0].image.width) : this._setSize(le1.image.width / 4), du = this._renderer.getRenderTarget(), _u = this._renderer.getActiveCubeFace(), Md = this._renderer.getActiveMipmapLevel(), Ld = this._renderer.xr.enabled, this._renderer.xr.enabled = !1;
                        const bt = vt || this._allocateTargets();
                        return this._textureToCubeUV(le1, bt), this._applyPMREM(bt), this._cleanup(bt), bt;
                    }
                    _allocateTargets() {
                        const le1 = 3 * Math.max(this._cubeSize, 112), vt = 4 * this._cubeSize, bt = {
                            magFilter: ls.k6q,
                            minFilter: ls.k6q,
                            generateMipmaps: !1,
                            type: ls.ix0,
                            format: ls.GWd,
                            colorSpace: ls.Zr2,
                            depthBuffer: !1
                        }, ho = _createRenderTarget(le1, vt, bt);
                        if (null === this._pingPongRenderTarget || this._pingPongRenderTarget.width !== le1 || this._pingPongRenderTarget.height !== vt) {
                            null !== this._pingPongRenderTarget && this._dispose(), this._pingPongRenderTarget = _createRenderTarget(le1, vt, bt);
                            const { _lodMax: ho } = this;
                            ({ sizeLods: this._sizeLods, lodPlanes: this._lodPlanes, sigmas: this._sigmas } = function(le1) {
                                const vt = [], bt = [], ho = [];
                                let Dl = le1;
                                const Fl = le1 - 4 + 1 + gc.length;
                                for(let sc = 0; sc < Fl; sc++){
                                    const Fl = Math.pow(2, Dl);
                                    bt.push(Fl);
                                    let uc = 1 / Fl;
                                    sc > le1 - 4 ? uc = gc[sc - le1 + 4 - 1] : 0 === sc && (uc = 0), ho.push(uc);
                                    const mc = 1 / (Fl - 2), Ac = -mc, Ec = 1 + mc, kc = [
                                        Ac,
                                        Ac,
                                        Ec,
                                        Ac,
                                        Ec,
                                        Ec,
                                        Ac,
                                        Ac,
                                        Ec,
                                        Ec,
                                        Ac,
                                        Ec
                                    ], du = 6, _u = 6, Md = 3, Ld = 2, Nd = 1, Rd = new Float32Array(Md * _u * du), Od = new Float32Array(Ld * _u * du), jd = new Float32Array(Nd * _u * du);
                                    for(let le1 = 0; le1 < du; le1++){
                                        const vt = le1 % 3 * 2 / 3 - 1, bt = le1 > 2 ? 0 : -1, ls = [
                                            vt,
                                            bt,
                                            0,
                                            vt + 2 / 3,
                                            bt,
                                            0,
                                            vt + 2 / 3,
                                            bt + 1,
                                            0,
                                            vt,
                                            bt,
                                            0,
                                            vt + 2 / 3,
                                            bt + 1,
                                            0,
                                            vt,
                                            bt + 1,
                                            0
                                        ];
                                        Rd.set(ls, Md * _u * le1), Od.set(kc, Ld * _u * le1);
                                        const ho = [
                                            le1,
                                            le1,
                                            le1,
                                            le1,
                                            le1,
                                            le1
                                        ];
                                        jd.set(ho, Nd * _u * le1);
                                    }
                                    const Ud = new ls.LoY;
                                    Ud.setAttribute("position", new ls.THS(Rd, Md)), Ud.setAttribute("uv", new ls.THS(Od, Ld)), Ud.setAttribute("faceIndex", new ls.THS(jd, Nd)), vt.push(Ud), Dl > 4 && Dl--;
                                }
                                return {
                                    lodPlanes: vt,
                                    sizeLods: bt,
                                    sigmas: ho
                                };
                            }(ho)), this._blurMaterial = function(le1, vt, bt) {
                                const ho = new Float32Array(Ac), Dl = new ls.Pq0(0, 1, 0), Fl = new ls.BKk({
                                    name: "SphericalGaussianBlur",
                                    defines: {
                                        n: Ac,
                                        CUBEUV_TEXEL_WIDTH: 1 / vt,
                                        CUBEUV_TEXEL_HEIGHT: 1 / bt,
                                        CUBEUV_MAX_MIP: `${le1}.0`
                                    },
                                    uniforms: {
                                        envMap: {
                                            value: null
                                        },
                                        samples: {
                                            value: 1
                                        },
                                        weights: {
                                            value: ho
                                        },
                                        latitudinal: {
                                            value: !1
                                        },
                                        dTheta: {
                                            value: 0
                                        },
                                        mipInt: {
                                            value: 0
                                        },
                                        poleAxis: {
                                            value: Dl
                                        }
                                    },
                                    vertexShader: _getCommonVertexShader(),
                                    fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\t\t\tuniform int samples;\n\t\t\tuniform float weights[ n ];\n\t\t\tuniform bool latitudinal;\n\t\t\tuniform float dTheta;\n\t\t\tuniform float mipInt;\n\t\t\tuniform vec3 poleAxis;\n\n\t\t\t#define ENVMAP_TYPE_CUBE_UV\n\t\t\t#include <cube_uv_reflection_fragment>\n\n\t\t\tvec3 getSample( float theta, vec3 axis ) {\n\n\t\t\t\tfloat cosTheta = cos( theta );\n\t\t\t\t// Rodrigues' axis-angle rotation\n\t\t\t\tvec3 sampleDirection = vOutputDirection * cosTheta\n\t\t\t\t\t+ cross( axis, vOutputDirection ) * sin( theta )\n\t\t\t\t\t+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );\n\n\t\t\t\treturn bilinearCubeUV( envMap, sampleDirection, mipInt );\n\n\t\t\t}\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );\n\n\t\t\t\tif ( all( equal( axis, vec3( 0.0 ) ) ) ) {\n\n\t\t\t\t\taxis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );\n\n\t\t\t\t}\n\n\t\t\t\taxis = normalize( axis );\n\n\t\t\t\tgl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );\n\t\t\t\tgl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );\n\n\t\t\t\tfor ( int i = 1; i < n; i++ ) {\n\n\t\t\t\t\tif ( i >= samples ) {\n\n\t\t\t\t\t\tbreak;\n\n\t\t\t\t\t}\n\n\t\t\t\t\tfloat theta = dTheta * float( i );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );\n\t\t\t\t\tgl_FragColor.rgb += weights[ i ] * getSample( theta, axis );\n\n\t\t\t\t}\n\n\t\t\t}\n\t\t",
                                    blending: ls.XIg,
                                    depthTest: !1,
                                    depthWrite: !1
                                });
                                return Fl;
                            }(ho, le1, vt);
                        }
                        return ho;
                    }
                    _compileMaterial(le1) {
                        const vt = new ls.eaF(this._lodPlanes[0], le1);
                        this._renderer.compile(vt, Ec);
                    }
                    _sceneToCubeUV(le1, vt, bt, ho, Dl) {
                        const Fl = new ls.ubm(90, 1, vt, bt), sc = [
                            1,
                            -1,
                            1,
                            1,
                            1,
                            1
                        ], uc = [
                            1,
                            1,
                            1,
                            -1,
                            -1,
                            -1
                        ], mc = this._renderer, gc = mc.autoClear, Ac = mc.toneMapping;
                        mc.getClearColor(kc), mc.toneMapping = ls.y_p, mc.autoClear = !1;
                        mc.state.buffers.depth.getReversed() && (mc.setRenderTarget(ho), mc.clearDepth(), mc.setRenderTarget(null));
                        const Ec = new ls.V9B({
                            name: "PMREM.Background",
                            side: ls.hsX,
                            depthWrite: !1,
                            depthTest: !1
                        }), du = new ls.eaF(new ls.iNn, Ec);
                        let _u = !1;
                        const Md = le1.background;
                        Md ? Md.isColor && (Ec.color.copy(Md), le1.background = null, _u = !0) : (Ec.color.copy(kc), _u = !0);
                        for(let ls = 0; ls < 6; ls++){
                            const vt = ls % 3;
                            0 === vt ? (Fl.up.set(0, sc[ls], 0), Fl.position.set(Dl.x, Dl.y, Dl.z), Fl.lookAt(Dl.x + uc[ls], Dl.y, Dl.z)) : 1 === vt ? (Fl.up.set(0, 0, sc[ls]), Fl.position.set(Dl.x, Dl.y, Dl.z), Fl.lookAt(Dl.x, Dl.y + uc[ls], Dl.z)) : (Fl.up.set(0, sc[ls], 0), Fl.position.set(Dl.x, Dl.y, Dl.z), Fl.lookAt(Dl.x, Dl.y, Dl.z + uc[ls]));
                            const bt = this._cubeSize;
                            _setViewport(ho, vt * bt, ls > 2 ? bt : 0, bt, bt), mc.setRenderTarget(ho), _u && mc.render(du, Fl), mc.render(le1, Fl);
                        }
                        du.geometry.dispose(), du.material.dispose(), mc.toneMapping = Ac, mc.autoClear = gc, le1.background = Md;
                    }
                    _textureToCubeUV(le1, vt) {
                        const bt = this._renderer, ho = le1.mapping === ls.hy7 || le1.mapping === ls.xFO;
                        ho ? (null === this._cubemapMaterial && (this._cubemapMaterial = _getCubemapMaterial()), this._cubemapMaterial.uniforms.flipEnvMap.value = !1 === le1.isRenderTargetTexture ? -1 : 1) : null === this._equirectMaterial && (this._equirectMaterial = _getEquirectMaterial());
                        const Dl = ho ? this._cubemapMaterial : this._equirectMaterial, Fl = new ls.eaF(this._lodPlanes[0], Dl);
                        Dl.uniforms.envMap.value = le1;
                        const sc = this._cubeSize;
                        _setViewport(vt, 0, 0, 3 * sc, 2 * sc), bt.setRenderTarget(vt), bt.render(Fl, Ec);
                    }
                    _applyPMREM(le1) {
                        const vt = this._renderer, bt = vt.autoClear;
                        vt.autoClear = !1;
                        const ls = this._lodPlanes.length;
                        for(let ho = 1; ho < ls; ho++){
                            const vt = Math.sqrt(this._sigmas[ho] * this._sigmas[ho] - this._sigmas[ho - 1] * this._sigmas[ho - 1]), bt = Od[(ls - ho - 1) % Od.length];
                            this._blur(le1, ho - 1, ho, vt, bt);
                        }
                        vt.autoClear = bt;
                    }
                    _blur(le1, vt, bt, ls, ho) {
                        const Dl = this._pingPongRenderTarget;
                        this._halfBlur(le1, Dl, vt, bt, ls, "latitudinal", ho), this._halfBlur(Dl, le1, bt, bt, ls, "longitudinal", ho);
                    }
                    _halfBlur(le1, vt, bt, ho, Dl, Fl, sc) {
                        const uc = this._renderer, mc = this._blurMaterial;
                        "latitudinal" !== Fl && "longitudinal" !== Fl && console.error("blur direction must be either latitudinal or longitudinal!");
                        const gc = new ls.eaF(this._lodPlanes[ho], mc), kc = mc.uniforms, du = this._sizeLods[bt] - 1, _u = isFinite(Dl) ? Math.PI / (2 * du) : 2 * Math.PI / 39, Md = Dl / _u, Ld = isFinite(Dl) ? 1 + Math.floor(3 * Md) : Ac;
                        Ld > Ac && console.warn(`sigmaRadians, ${Dl}, is too large and will clip, as it requested ${Ld} samples when the maximum is set to 20`);
                        const Nd = [];
                        let Rd = 0;
                        for(let ls = 0; ls < Ac; ++ls){
                            const le1 = ls / Md, vt = Math.exp(-le1 * le1 / 2);
                            Nd.push(vt), 0 === ls ? Rd += vt : ls < Ld && (Rd += 2 * vt);
                        }
                        for(let ls = 0; ls < Nd.length; ls++)Nd[ls] = Nd[ls] / Rd;
                        kc.envMap.value = le1.texture, kc.samples.value = Ld, kc.weights.value = Nd, kc.latitudinal.value = "latitudinal" === Fl, sc && (kc.poleAxis.value = sc);
                        const { _lodMax: Od } = this;
                        kc.dTheta.value = _u, kc.mipInt.value = Od - bt;
                        const jd = this._sizeLods[ho];
                        _setViewport(vt, 3 * jd * (ho > Od - 4 ? ho - Od + 4 : 0), 4 * (this._cubeSize - jd), 3 * jd, 2 * jd), uc.setRenderTarget(vt), uc.render(gc, Ec);
                    }
                }
                function _createRenderTarget(le1, vt, bt) {
                    const ho = new ls.nWS(le1, vt, bt);
                    return ho.texture.mapping = ls.Om, ho.texture.name = "PMREM.cubeUv", ho.scissorTest = !0, ho;
                }
                function _setViewport(le1, vt, bt, ls, ho) {
                    le1.viewport.set(vt, bt, ls, ho), le1.scissor.set(vt, bt, ls, ho);
                }
                function _getEquirectMaterial() {
                    return new ls.BKk({
                        name: "EquirectangularToCubeUV",
                        uniforms: {
                            envMap: {
                                value: null
                            }
                        },
                        vertexShader: _getCommonVertexShader(),
                        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform sampler2D envMap;\n\n\t\t\t#include <common>\n\n\t\t\tvoid main() {\n\n\t\t\t\tvec3 outputDirection = normalize( vOutputDirection );\n\t\t\t\tvec2 uv = equirectUv( outputDirection );\n\n\t\t\t\tgl_FragColor = vec4( texture2D ( envMap, uv ).rgb, 1.0 );\n\n\t\t\t}\n\t\t",
                        blending: ls.XIg,
                        depthTest: !1,
                        depthWrite: !1
                    });
                }
                function _getCubemapMaterial() {
                    return new ls.BKk({
                        name: "CubemapToCubeUV",
                        uniforms: {
                            envMap: {
                                value: null
                            },
                            flipEnvMap: {
                                value: -1
                            }
                        },
                        vertexShader: _getCommonVertexShader(),
                        fragmentShader: "\n\n\t\t\tprecision mediump float;\n\t\t\tprecision mediump int;\n\n\t\t\tuniform float flipEnvMap;\n\n\t\t\tvarying vec3 vOutputDirection;\n\n\t\t\tuniform samplerCube envMap;\n\n\t\t\tvoid main() {\n\n\t\t\t\tgl_FragColor = textureCube( envMap, vec3( flipEnvMap * vOutputDirection.x, vOutputDirection.yz ) );\n\n\t\t\t}\n\t\t",
                        blending: ls.XIg,
                        depthTest: !1,
                        depthWrite: !1
                    });
                }
                function _getCommonVertexShader() {
                    return "\n\n\t\tprecision mediump float;\n\t\tprecision mediump int;\n\n\t\tattribute float faceIndex;\n\n\t\tvarying vec3 vOutputDirection;\n\n\t\t// RH coordinate system; PMREM face-indexing convention\n\t\tvec3 getDirection( vec2 uv, float face ) {\n\n\t\t\tuv = 2.0 * uv - 1.0;\n\n\t\t\tvec3 direction = vec3( uv, 1.0 );\n\n\t\t\tif ( face == 0.0 ) {\n\n\t\t\t\tdirection = direction.zyx; // ( 1, v, u ) pos x\n\n\t\t\t} else if ( face == 1.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xz *= -1.0; // ( -u, 1, -v ) pos y\n\n\t\t\t} else if ( face == 2.0 ) {\n\n\t\t\t\tdirection.x *= -1.0; // ( -u, v, 1 ) pos z\n\n\t\t\t} else if ( face == 3.0 ) {\n\n\t\t\t\tdirection = direction.zyx;\n\t\t\t\tdirection.xz *= -1.0; // ( -1, v, -u ) neg x\n\n\t\t\t} else if ( face == 4.0 ) {\n\n\t\t\t\tdirection = direction.xzy;\n\t\t\t\tdirection.xy *= -1.0; // ( -u, -1, v ) neg y\n\n\t\t\t} else if ( face == 5.0 ) {\n\n\t\t\t\tdirection.z *= -1.0; // ( u, v, -1 ) neg z\n\n\t\t\t}\n\n\t\t\treturn direction;\n\n\t\t}\n\n\t\tvoid main() {\n\n\t\t\tvOutputDirection = getDirection( uv, faceIndex );\n\t\t\tgl_Position = vec4( position, 1.0 );\n\n\t\t}\n\t";
                }
                function WebGLCubeUVMaps(le1) {
                    let vt = new WeakMap, bt = null;
                    function onTextureDispose(le1) {
                        const bt = le1.target;
                        bt.removeEventListener("dispose", onTextureDispose);
                        const ls = vt.get(bt);
                        void 0 !== ls && (vt.delete(bt), ls.dispose());
                    }
                    return {
                        get: function(ho) {
                            if (ho && ho.isTexture) {
                                const Dl = ho.mapping, Fl = Dl === ls.wfO || Dl === ls.uV5, sc = Dl === ls.hy7 || Dl === ls.xFO;
                                if (Fl || sc) {
                                    let ls = vt.get(ho);
                                    const Dl = void 0 !== ls ? ls.texture.pmremVersion : 0;
                                    if (ho.isRenderTargetTexture && ho.pmremVersion !== Dl) return null === bt && (bt = new PMREMGenerator(le1)), ls = Fl ? bt.fromEquirectangular(ho, ls) : bt.fromCubemap(ho, ls), ls.texture.pmremVersion = ho.pmremVersion, vt.set(ho, ls), ls.texture;
                                    if (void 0 !== ls) return ls.texture;
                                    {
                                        const Dl = ho.image;
                                        return Fl && Dl && Dl.height > 0 || sc && Dl && function(le1) {
                                            let vt = 0;
                                            const bt = 6;
                                            for(let ls = 0; ls < bt; ls++)void 0 !== le1[ls] && vt++;
                                            return vt === bt;
                                        }(Dl) ? (null === bt && (bt = new PMREMGenerator(le1)), ls = Fl ? bt.fromEquirectangular(ho) : bt.fromCubemap(ho), ls.texture.pmremVersion = ho.pmremVersion, vt.set(ho, ls), ho.addEventListener("dispose", onTextureDispose), ls.texture) : null;
                                    }
                                }
                            }
                            return ho;
                        },
                        dispose: function() {
                            vt = new WeakMap, null !== bt && (bt.dispose(), bt = null);
                        }
                    };
                }
                function WebGLExtensions(le1) {
                    const vt = {};
                    function getExtension(bt) {
                        if (void 0 !== vt[bt]) return vt[bt];
                        let ls;
                        switch(bt){
                            case "WEBGL_depth_texture":
                                ls = le1.getExtension("WEBGL_depth_texture") || le1.getExtension("MOZ_WEBGL_depth_texture") || le1.getExtension("WEBKIT_WEBGL_depth_texture");
                                break;
                            case "EXT_texture_filter_anisotropic":
                                ls = le1.getExtension("EXT_texture_filter_anisotropic") || le1.getExtension("MOZ_EXT_texture_filter_anisotropic") || le1.getExtension("WEBKIT_EXT_texture_filter_anisotropic");
                                break;
                            case "WEBGL_compressed_texture_s3tc":
                                ls = le1.getExtension("WEBGL_compressed_texture_s3tc") || le1.getExtension("MOZ_WEBGL_compressed_texture_s3tc") || le1.getExtension("WEBKIT_WEBGL_compressed_texture_s3tc");
                                break;
                            case "WEBGL_compressed_texture_pvrtc":
                                ls = le1.getExtension("WEBGL_compressed_texture_pvrtc") || le1.getExtension("WEBKIT_WEBGL_compressed_texture_pvrtc");
                                break;
                            default:
                                ls = le1.getExtension(bt);
                        }
                        return vt[bt] = ls, ls;
                    }
                    return {
                        has: function(le1) {
                            return null !== getExtension(le1);
                        },
                        init: function() {
                            getExtension("EXT_color_buffer_float"), getExtension("WEBGL_clip_cull_distance"), getExtension("OES_texture_float_linear"), getExtension("EXT_color_buffer_half_float"), getExtension("WEBGL_multisampled_render_to_texture"), getExtension("WEBGL_render_shared_exponent");
                        },
                        get: function(le1) {
                            const vt = getExtension(le1);
                            return null === vt && (0, ls.mcG)("THREE.WebGLRenderer: " + le1 + " extension not supported."), vt;
                        }
                    };
                }
                function WebGLGeometries(le1, vt, bt, ho) {
                    const Dl = {}, Fl = new WeakMap;
                    function onGeometryDispose(le1) {
                        const ls = le1.target;
                        null !== ls.index && vt.remove(ls.index);
                        for(const bt in ls.attributes)vt.remove(ls.attributes[bt]);
                        ls.removeEventListener("dispose", onGeometryDispose), delete Dl[ls.id];
                        const sc = Fl.get(ls);
                        sc && (vt.remove(sc), Fl.delete(ls)), ho.releaseStatesOfGeometry(ls), !0 === ls.isInstancedBufferGeometry && delete ls._maxInstanceCount, bt.memory.geometries--;
                    }
                    function updateWireframeAttribute(le1) {
                        const bt = [], ho = le1.index, Dl = le1.attributes.position;
                        let sc = 0;
                        if (null !== ho) {
                            const le1 = ho.array;
                            sc = ho.version;
                            for(let vt = 0, ls = le1.length; vt < ls; vt += 3){
                                const ls = le1[vt + 0], ho = le1[vt + 1], Dl = le1[vt + 2];
                                bt.push(ls, ho, ho, Dl, Dl, ls);
                            }
                        } else {
                            if (void 0 === Dl) return;
                            {
                                const le1 = Dl.array;
                                sc = Dl.version;
                                for(let vt = 0, ls = le1.length / 3 - 1; vt < ls; vt += 3){
                                    const le1 = vt + 0, ls = vt + 1, ho = vt + 2;
                                    bt.push(le1, ls, ls, ho, ho, le1);
                                }
                            }
                        }
                        const uc = new ((0, ls.AQS)(bt) ? ls.MW4 : ls.A$4)(bt, 1);
                        uc.version = sc;
                        const mc = Fl.get(le1);
                        mc && vt.remove(mc), Fl.set(le1, uc);
                    }
                    return {
                        get: function(le1, vt) {
                            return !0 === Dl[vt.id] || (vt.addEventListener("dispose", onGeometryDispose), Dl[vt.id] = !0, bt.memory.geometries++), vt;
                        },
                        update: function(bt) {
                            const ls = bt.attributes;
                            for(const ho in ls)vt.update(ls[ho], le1.ARRAY_BUFFER);
                        },
                        getWireframeAttribute: function(le1) {
                            const vt = Fl.get(le1);
                            if (vt) {
                                const bt = le1.index;
                                null !== bt && vt.version < bt.version && updateWireframeAttribute(le1);
                            } else updateWireframeAttribute(le1);
                            return Fl.get(le1);
                        }
                    };
                }
                function WebGLIndexedBufferRenderer(le1, vt, bt) {
                    let ls, ho, Dl;
                    function renderInstances(vt, Fl, sc) {
                        0 !== sc && (le1.drawElementsInstanced(ls, Fl, ho, vt * Dl, sc), bt.update(Fl, ls, sc));
                    }
                    this.setMode = function(le1) {
                        ls = le1;
                    }, this.setIndex = function(le1) {
                        ho = le1.type, Dl = le1.bytesPerElement;
                    }, this.render = function(vt, Fl) {
                        le1.drawElements(ls, Fl, ho, vt * Dl), bt.update(Fl, ls, 1);
                    }, this.renderInstances = renderInstances, this.renderMultiDraw = function(le1, Dl, Fl) {
                        if (0 === Fl) return;
                        vt.get("WEBGL_multi_draw").multiDrawElementsWEBGL(ls, Dl, 0, ho, le1, 0, Fl);
                        let sc = 0;
                        for(let vt = 0; vt < Fl; vt++)sc += Dl[vt];
                        bt.update(sc, ls, 1);
                    }, this.renderMultiDrawInstances = function(le1, Fl, sc, uc) {
                        if (0 === sc) return;
                        const mc = vt.get("WEBGL_multi_draw");
                        if (null === mc) for(let vt = 0; vt < le1.length; vt++)renderInstances(le1[vt] / Dl, Fl[vt], uc[vt]);
                        else {
                            mc.multiDrawElementsInstancedWEBGL(ls, Fl, 0, ho, le1, 0, uc, 0, sc);
                            let vt = 0;
                            for(let le1 = 0; le1 < sc; le1++)vt += Fl[le1] * uc[le1];
                            bt.update(vt, ls, 1);
                        }
                    };
                }
                function WebGLInfo(le1) {
                    const vt = {
                        frame: 0,
                        calls: 0,
                        triangles: 0,
                        points: 0,
                        lines: 0
                    };
                    return {
                        memory: {
                            geometries: 0,
                            textures: 0
                        },
                        render: vt,
                        programs: null,
                        autoReset: !0,
                        reset: function() {
                            vt.calls = 0, vt.triangles = 0, vt.points = 0, vt.lines = 0;
                        },
                        update: function(bt, ls, ho) {
                            switch(vt.calls++, ls){
                                case le1.TRIANGLES:
                                    vt.triangles += ho * (bt / 3);
                                    break;
                                case le1.LINES:
                                    vt.lines += ho * (bt / 2);
                                    break;
                                case le1.LINE_STRIP:
                                    vt.lines += ho * (bt - 1);
                                    break;
                                case le1.LINE_LOOP:
                                    vt.lines += ho * bt;
                                    break;
                                case le1.POINTS:
                                    vt.points += ho * bt;
                                    break;
                                default:
                                    console.error("THREE.WebGLInfo: Unknown draw mode:", ls);
                            }
                        }
                    };
                }
                function WebGLMorphtargets(le1, vt, bt) {
                    const ho = new WeakMap, Dl = new ls.IUQ;
                    return {
                        update: function(Fl, sc, uc) {
                            const mc = Fl.morphTargetInfluences, gc = sc.morphAttributes.position || sc.morphAttributes.normal || sc.morphAttributes.color, Ac = void 0 !== gc ? gc.length : 0;
                            let Ec = ho.get(sc);
                            if (void 0 === Ec || Ec.count !== Ac) {
                                void 0 !== Ec && Ec.texture.dispose();
                                const kc = void 0 !== sc.morphAttributes.position, du = void 0 !== sc.morphAttributes.normal, _u = void 0 !== sc.morphAttributes.color, Md = sc.morphAttributes.position || [], Ld = sc.morphAttributes.normal || [], Nd = sc.morphAttributes.color || [];
                                let Rd = 0;
                                !0 === kc && (Rd = 1), !0 === du && (Rd = 2), !0 === _u && (Rd = 3);
                                let Od = sc.attributes.position.count * Rd, jd = 1;
                                Od > vt.maxTextureSize && (jd = Math.ceil(Od / vt.maxTextureSize), Od = vt.maxTextureSize);
                                const Ud = new Float32Array(Od * jd * 4 * Ac), Gd = new ls.rFo(Ud, Od, jd, Ac);
                                Gd.type = ls.RQf, Gd.needsUpdate = !0;
                                const qd = 4 * Rd;
                                for(let Hd = 0; Hd < Ac; Hd++){
                                    const Wd = Md[Hd], Zd = Ld[Hd], Yd = Nd[Hd], Qd = Od * jd * 4 * Hd;
                                    for(let Xd = 0; Xd < Wd.count; Xd++){
                                        const Kd = Xd * qd;
                                        !0 === kc && (Dl.fromBufferAttribute(Wd, Xd), Ud[Qd + Kd + 0] = Dl.x, Ud[Qd + Kd + 1] = Dl.y, Ud[Qd + Kd + 2] = Dl.z, Ud[Qd + Kd + 3] = 0), !0 === du && (Dl.fromBufferAttribute(Zd, Xd), Ud[Qd + Kd + 4] = Dl.x, Ud[Qd + Kd + 5] = Dl.y, Ud[Qd + Kd + 6] = Dl.z, Ud[Qd + Kd + 7] = 0), !0 === _u && (Dl.fromBufferAttribute(Yd, Xd), Ud[Qd + Kd + 8] = Dl.x, Ud[Qd + Kd + 9] = Dl.y, Ud[Qd + Kd + 10] = Dl.z, Ud[Qd + Kd + 11] = 4 === Yd.itemSize ? Dl.w : 1);
                                    }
                                }
                                function disposeTexture() {
                                    Gd.dispose(), ho.delete(sc), sc.removeEventListener("dispose", disposeTexture);
                                }
                                Ec = {
                                    count: Ac,
                                    texture: Gd,
                                    size: new ls.I9Y(Od, jd)
                                }, ho.set(sc, Ec), sc.addEventListener("dispose", disposeTexture);
                            }
                            if (!0 === Fl.isInstancedMesh && null !== Fl.morphTexture) uc.getUniforms().setValue(le1, "morphTexture", Fl.morphTexture, bt);
                            else {
                                let Jd = 0;
                                for(let sp = 0; sp < mc.length; sp++)Jd += mc[sp];
                                const $d = sc.morphTargetsRelative ? 1 : 1 - Jd;
                                uc.getUniforms().setValue(le1, "morphTargetBaseInfluence", $d), uc.getUniforms().setValue(le1, "morphTargetInfluences", mc);
                            }
                            uc.getUniforms().setValue(le1, "morphTargetsTexture", Ec.texture, bt), uc.getUniforms().setValue(le1, "morphTargetsTextureSize", Ec.size);
                        }
                    };
                }
                function WebGLObjects(le1, vt, bt, ls) {
                    let ho = new WeakMap;
                    function onInstancedMeshDispose(le1) {
                        const vt = le1.target;
                        vt.removeEventListener("dispose", onInstancedMeshDispose), bt.remove(vt.instanceMatrix), null !== vt.instanceColor && bt.remove(vt.instanceColor);
                    }
                    return {
                        update: function(Dl) {
                            const Fl = ls.render.frame, sc = Dl.geometry, uc = vt.get(Dl, sc);
                            if (ho.get(uc) !== Fl && (vt.update(uc), ho.set(uc, Fl)), Dl.isInstancedMesh && (!1 === Dl.hasEventListener("dispose", onInstancedMeshDispose) && Dl.addEventListener("dispose", onInstancedMeshDispose), ho.get(Dl) !== Fl && (bt.update(Dl.instanceMatrix, le1.ARRAY_BUFFER), null !== Dl.instanceColor && bt.update(Dl.instanceColor, le1.ARRAY_BUFFER), ho.set(Dl, Fl))), Dl.isSkinnedMesh) {
                                const le1 = Dl.skeleton;
                                ho.get(le1) !== Fl && (le1.update(), ho.set(le1, Fl));
                            }
                            return uc;
                        },
                        dispose: function() {
                            ho = new WeakMap;
                        }
                    };
                }
                const Ud = new ls.gPd, Gd = new ls.VCu(1, 1), qd = new ls.rFo, Hd = new ls.dYF, Wd = new ls.b4q, Zd = [], Yd = [], Qd = new Float32Array(16), Xd = new Float32Array(9), Kd = new Float32Array(4);
                function flatten(le1, vt, bt) {
                    const ls = le1[0];
                    if (ls <= 0 || ls > 0) return le1;
                    const ho = vt * bt;
                    let Dl = Zd[ho];
                    if (void 0 === Dl && (Dl = new Float32Array(ho), Zd[ho] = Dl), 0 !== vt) {
                        ls.toArray(Dl, 0);
                        for(let ls = 1, ho = 0; ls !== vt; ++ls)ho += bt, le1[ls].toArray(Dl, ho);
                    }
                    return Dl;
                }
                function arraysEqual(le1, vt) {
                    if (le1.length !== vt.length) return !1;
                    for(let bt = 0, ls = le1.length; bt < ls; bt++)if (le1[bt] !== vt[bt]) return !1;
                    return !0;
                }
                function copyArray(le1, vt) {
                    for(let bt = 0, ls = vt.length; bt < ls; bt++)le1[bt] = vt[bt];
                }
                function allocTexUnits(le1, vt) {
                    let bt = Yd[vt];
                    void 0 === bt && (bt = new Int32Array(vt), Yd[vt] = bt);
                    for(let ls = 0; ls !== vt; ++ls)bt[ls] = le1.allocateTextureUnit();
                    return bt;
                }
                function setValueV1f(le1, vt) {
                    const bt = this.cache;
                    bt[0] !== vt && (le1.uniform1f(this.addr, vt), bt[0] = vt);
                }
                function setValueV2f(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y || (le1.uniform2f(this.addr, vt.x, vt.y), bt[0] = vt.x, bt[1] = vt.y);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform2fv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV3f(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z || (le1.uniform3f(this.addr, vt.x, vt.y, vt.z), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z);
                    else if (void 0 !== vt.r) bt[0] === vt.r && bt[1] === vt.g && bt[2] === vt.b || (le1.uniform3f(this.addr, vt.r, vt.g, vt.b), bt[0] = vt.r, bt[1] = vt.g, bt[2] = vt.b);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform3fv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV4f(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z && bt[3] === vt.w || (le1.uniform4f(this.addr, vt.x, vt.y, vt.z, vt.w), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z, bt[3] = vt.w);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform4fv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueM2(le1, vt) {
                    const bt = this.cache, ls = vt.elements;
                    if (void 0 === ls) {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniformMatrix2fv(this.addr, !1, vt), copyArray(bt, vt);
                    } else {
                        if (arraysEqual(bt, ls)) return;
                        Kd.set(ls), le1.uniformMatrix2fv(this.addr, !1, Kd), copyArray(bt, ls);
                    }
                }
                function setValueM3(le1, vt) {
                    const bt = this.cache, ls = vt.elements;
                    if (void 0 === ls) {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniformMatrix3fv(this.addr, !1, vt), copyArray(bt, vt);
                    } else {
                        if (arraysEqual(bt, ls)) return;
                        Xd.set(ls), le1.uniformMatrix3fv(this.addr, !1, Xd), copyArray(bt, ls);
                    }
                }
                function setValueM4(le1, vt) {
                    const bt = this.cache, ls = vt.elements;
                    if (void 0 === ls) {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniformMatrix4fv(this.addr, !1, vt), copyArray(bt, vt);
                    } else {
                        if (arraysEqual(bt, ls)) return;
                        Qd.set(ls), le1.uniformMatrix4fv(this.addr, !1, Qd), copyArray(bt, ls);
                    }
                }
                function setValueV1i(le1, vt) {
                    const bt = this.cache;
                    bt[0] !== vt && (le1.uniform1i(this.addr, vt), bt[0] = vt);
                }
                function setValueV2i(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y || (le1.uniform2i(this.addr, vt.x, vt.y), bt[0] = vt.x, bt[1] = vt.y);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform2iv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV3i(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z || (le1.uniform3i(this.addr, vt.x, vt.y, vt.z), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform3iv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV4i(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z && bt[3] === vt.w || (le1.uniform4i(this.addr, vt.x, vt.y, vt.z, vt.w), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z, bt[3] = vt.w);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform4iv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV1ui(le1, vt) {
                    const bt = this.cache;
                    bt[0] !== vt && (le1.uniform1ui(this.addr, vt), bt[0] = vt);
                }
                function setValueV2ui(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y || (le1.uniform2ui(this.addr, vt.x, vt.y), bt[0] = vt.x, bt[1] = vt.y);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform2uiv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV3ui(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z || (le1.uniform3ui(this.addr, vt.x, vt.y, vt.z), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform3uiv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueV4ui(le1, vt) {
                    const bt = this.cache;
                    if (void 0 !== vt.x) bt[0] === vt.x && bt[1] === vt.y && bt[2] === vt.z && bt[3] === vt.w || (le1.uniform4ui(this.addr, vt.x, vt.y, vt.z, vt.w), bt[0] = vt.x, bt[1] = vt.y, bt[2] = vt.z, bt[3] = vt.w);
                    else {
                        if (arraysEqual(bt, vt)) return;
                        le1.uniform4uiv(this.addr, vt), copyArray(bt, vt);
                    }
                }
                function setValueT1(le1, vt, bt) {
                    const ho = this.cache, Dl = bt.allocateTextureUnit();
                    let Fl;
                    ho[0] !== Dl && (le1.uniform1i(this.addr, Dl), ho[0] = Dl), this.type === le1.SAMPLER_2D_SHADOW ? (Gd.compareFunction = ls.TiK, Fl = Gd) : Fl = Ud, bt.setTexture2D(vt || Fl, Dl);
                }
                function setValueT3D1(le1, vt, bt) {
                    const ls = this.cache, ho = bt.allocateTextureUnit();
                    ls[0] !== ho && (le1.uniform1i(this.addr, ho), ls[0] = ho), bt.setTexture3D(vt || Hd, ho);
                }
                function setValueT6(le1, vt, bt) {
                    const ls = this.cache, ho = bt.allocateTextureUnit();
                    ls[0] !== ho && (le1.uniform1i(this.addr, ho), ls[0] = ho), bt.setTextureCube(vt || Wd, ho);
                }
                function setValueT2DArray1(le1, vt, bt) {
                    const ls = this.cache, ho = bt.allocateTextureUnit();
                    ls[0] !== ho && (le1.uniform1i(this.addr, ho), ls[0] = ho), bt.setTexture2DArray(vt || qd, ho);
                }
                function setValueV1fArray(le1, vt) {
                    le1.uniform1fv(this.addr, vt);
                }
                function setValueV2fArray(le1, vt) {
                    const bt = flatten(vt, this.size, 2);
                    le1.uniform2fv(this.addr, bt);
                }
                function setValueV3fArray(le1, vt) {
                    const bt = flatten(vt, this.size, 3);
                    le1.uniform3fv(this.addr, bt);
                }
                function setValueV4fArray(le1, vt) {
                    const bt = flatten(vt, this.size, 4);
                    le1.uniform4fv(this.addr, bt);
                }
                function setValueM2Array(le1, vt) {
                    const bt = flatten(vt, this.size, 4);
                    le1.uniformMatrix2fv(this.addr, !1, bt);
                }
                function setValueM3Array(le1, vt) {
                    const bt = flatten(vt, this.size, 9);
                    le1.uniformMatrix3fv(this.addr, !1, bt);
                }
                function setValueM4Array(le1, vt) {
                    const bt = flatten(vt, this.size, 16);
                    le1.uniformMatrix4fv(this.addr, !1, bt);
                }
                function setValueV1iArray(le1, vt) {
                    le1.uniform1iv(this.addr, vt);
                }
                function setValueV2iArray(le1, vt) {
                    le1.uniform2iv(this.addr, vt);
                }
                function setValueV3iArray(le1, vt) {
                    le1.uniform3iv(this.addr, vt);
                }
                function setValueV4iArray(le1, vt) {
                    le1.uniform4iv(this.addr, vt);
                }
                function setValueV1uiArray(le1, vt) {
                    le1.uniform1uiv(this.addr, vt);
                }
                function setValueV2uiArray(le1, vt) {
                    le1.uniform2uiv(this.addr, vt);
                }
                function setValueV3uiArray(le1, vt) {
                    le1.uniform3uiv(this.addr, vt);
                }
                function setValueV4uiArray(le1, vt) {
                    le1.uniform4uiv(this.addr, vt);
                }
                function setValueT1Array(le1, vt, bt) {
                    const ls = this.cache, ho = vt.length, Dl = allocTexUnits(bt, ho);
                    arraysEqual(ls, Dl) || (le1.uniform1iv(this.addr, Dl), copyArray(ls, Dl));
                    for(let Fl = 0; Fl !== ho; ++Fl)bt.setTexture2D(vt[Fl] || Ud, Dl[Fl]);
                }
                function setValueT3DArray(le1, vt, bt) {
                    const ls = this.cache, ho = vt.length, Dl = allocTexUnits(bt, ho);
                    arraysEqual(ls, Dl) || (le1.uniform1iv(this.addr, Dl), copyArray(ls, Dl));
                    for(let Fl = 0; Fl !== ho; ++Fl)bt.setTexture3D(vt[Fl] || Hd, Dl[Fl]);
                }
                function setValueT6Array(le1, vt, bt) {
                    const ls = this.cache, ho = vt.length, Dl = allocTexUnits(bt, ho);
                    arraysEqual(ls, Dl) || (le1.uniform1iv(this.addr, Dl), copyArray(ls, Dl));
                    for(let Fl = 0; Fl !== ho; ++Fl)bt.setTextureCube(vt[Fl] || Wd, Dl[Fl]);
                }
                function setValueT2DArrayArray(le1, vt, bt) {
                    const ls = this.cache, ho = vt.length, Dl = allocTexUnits(bt, ho);
                    arraysEqual(ls, Dl) || (le1.uniform1iv(this.addr, Dl), copyArray(ls, Dl));
                    for(let Fl = 0; Fl !== ho; ++Fl)bt.setTexture2DArray(vt[Fl] || qd, Dl[Fl]);
                }
                class SingleUniform {
                    constructor(le1, vt, bt){
                        this.id = le1, this.addr = bt, this.cache = [], this.type = vt.type, this.setValue = function(le1) {
                            switch(le1){
                                case 5126:
                                    return setValueV1f;
                                case 35664:
                                    return setValueV2f;
                                case 35665:
                                    return setValueV3f;
                                case 35666:
                                    return setValueV4f;
                                case 35674:
                                    return setValueM2;
                                case 35675:
                                    return setValueM3;
                                case 35676:
                                    return setValueM4;
                                case 5124:
                                case 35670:
                                    return setValueV1i;
                                case 35667:
                                case 35671:
                                    return setValueV2i;
                                case 35668:
                                case 35672:
                                    return setValueV3i;
                                case 35669:
                                case 35673:
                                    return setValueV4i;
                                case 5125:
                                    return setValueV1ui;
                                case 36294:
                                    return setValueV2ui;
                                case 36295:
                                    return setValueV3ui;
                                case 36296:
                                    return setValueV4ui;
                                case 35678:
                                case 36198:
                                case 36298:
                                case 36306:
                                case 35682:
                                    return setValueT1;
                                case 35679:
                                case 36299:
                                case 36307:
                                    return setValueT3D1;
                                case 35680:
                                case 36300:
                                case 36308:
                                case 36293:
                                    return setValueT6;
                                case 36289:
                                case 36303:
                                case 36311:
                                case 36292:
                                    return setValueT2DArray1;
                            }
                        }(vt.type);
                    }
                }
                class PureArrayUniform {
                    constructor(le1, vt, bt){
                        this.id = le1, this.addr = bt, this.cache = [], this.type = vt.type, this.size = vt.size, this.setValue = function(le1) {
                            switch(le1){
                                case 5126:
                                    return setValueV1fArray;
                                case 35664:
                                    return setValueV2fArray;
                                case 35665:
                                    return setValueV3fArray;
                                case 35666:
                                    return setValueV4fArray;
                                case 35674:
                                    return setValueM2Array;
                                case 35675:
                                    return setValueM3Array;
                                case 35676:
                                    return setValueM4Array;
                                case 5124:
                                case 35670:
                                    return setValueV1iArray;
                                case 35667:
                                case 35671:
                                    return setValueV2iArray;
                                case 35668:
                                case 35672:
                                    return setValueV3iArray;
                                case 35669:
                                case 35673:
                                    return setValueV4iArray;
                                case 5125:
                                    return setValueV1uiArray;
                                case 36294:
                                    return setValueV2uiArray;
                                case 36295:
                                    return setValueV3uiArray;
                                case 36296:
                                    return setValueV4uiArray;
                                case 35678:
                                case 36198:
                                case 36298:
                                case 36306:
                                case 35682:
                                    return setValueT1Array;
                                case 35679:
                                case 36299:
                                case 36307:
                                    return setValueT3DArray;
                                case 35680:
                                case 36300:
                                case 36308:
                                case 36293:
                                    return setValueT6Array;
                                case 36289:
                                case 36303:
                                case 36311:
                                case 36292:
                                    return setValueT2DArrayArray;
                            }
                        }(vt.type);
                    }
                }
                class StructuredUniform {
                    constructor(le1){
                        this.id = le1, this.seq = [], this.map = {};
                    }
                    setValue(le1, vt, bt) {
                        const ls = this.seq;
                        for(let ho = 0, Dl = ls.length; ho !== Dl; ++ho){
                            const Dl = ls[ho];
                            Dl.setValue(le1, vt[Dl.id], bt);
                        }
                    }
                }
                const Jd = /(\w+)(\])?(\[|\.)?/g;
                function addUniform(le1, vt) {
                    le1.seq.push(vt), le1.map[vt.id] = vt;
                }
                function parseUniform(le1, vt, bt) {
                    const ls = le1.name, ho = ls.length;
                    for(Jd.lastIndex = 0;;){
                        const Dl = Jd.exec(ls), Fl = Jd.lastIndex;
                        let sc = Dl[1];
                        const uc = "]" === Dl[2], mc = Dl[3];
                        if (uc && (sc |= 0), void 0 === mc || "[" === mc && Fl + 2 === ho) {
                            addUniform(bt, void 0 === mc ? new SingleUniform(sc, le1, vt) : new PureArrayUniform(sc, le1, vt));
                            break;
                        }
                        {
                            let le1 = bt.map[sc];
                            void 0 === le1 && (le1 = new StructuredUniform(sc), addUniform(bt, le1)), bt = le1;
                        }
                    }
                }
                class WebGLUniforms {
                    constructor(le1, vt){
                        this.seq = [], this.map = {};
                        const bt = le1.getProgramParameter(vt, le1.ACTIVE_UNIFORMS);
                        for(let ls = 0; ls < bt; ++ls){
                            const bt = le1.getActiveUniform(vt, ls);
                            parseUniform(bt, le1.getUniformLocation(vt, bt.name), this);
                        }
                    }
                    setValue(le1, vt, bt, ls) {
                        const ho = this.map[vt];
                        void 0 !== ho && ho.setValue(le1, bt, ls);
                    }
                    setOptional(le1, vt, bt) {
                        const ls = vt[bt];
                        void 0 !== ls && this.setValue(le1, bt, ls);
                    }
                    static upload(le1, vt, bt, ls) {
                        for(let ho = 0, Dl = vt.length; ho !== Dl; ++ho){
                            const Dl = vt[ho], Fl = bt[Dl.id];
                            !1 !== Fl.needsUpdate && Dl.setValue(le1, Fl.value, ls);
                        }
                    }
                    static seqWithValue(le1, vt) {
                        const bt = [];
                        for(let ls = 0, ho = le1.length; ls !== ho; ++ls){
                            const ho = le1[ls];
                            ho.id in vt && bt.push(ho);
                        }
                        return bt;
                    }
                }
                function WebGLShader(le1, vt, bt) {
                    const ls = le1.createShader(vt);
                    return le1.shaderSource(ls, bt), le1.compileShader(ls), ls;
                }
                let $d = 0;
                const sp = new ls.dwI;
                function getShaderErrors(le1, vt, bt) {
                    const ls = le1.getShaderParameter(vt, le1.COMPILE_STATUS), ho = (le1.getShaderInfoLog(vt) || "").trim();
                    if (ls && "" === ho) return "";
                    const Dl = /ERROR: 0:(\d+)/.exec(ho);
                    if (Dl) {
                        const ls = parseInt(Dl[1]);
                        return bt.toUpperCase() + "\n\n" + ho + "\n\n" + function(le1, vt) {
                            const bt = le1.split("\n"), ls = [], ho = Math.max(vt - 6, 0), Dl = Math.min(vt + 6, bt.length);
                            for(let Fl = ho; Fl < Dl; Fl++){
                                const le1 = Fl + 1;
                                ls.push(`${le1 === vt ? ">" : " "} ${le1}: ${bt[Fl]}`);
                            }
                            return ls.join("\n");
                        }(le1.getShaderSource(vt), ls);
                    }
                    return ho;
                }
                function getTexelEncodingFunction(le1, vt) {
                    const bt = function(le1) {
                        ls.ppV._getMatrix(sp, ls.ppV.workingColorSpace, le1);
                        const vt = `mat3( ${sp.elements.map((le1)=>le1.toFixed(4))} )`;
                        switch(ls.ppV.getTransfer(le1)){
                            case ls.VxR:
                                return [
                                    vt,
                                    "LinearTransferOETF"
                                ];
                            case ls.KLL:
                                return [
                                    vt,
                                    "sRGBTransferOETF"
                                ];
                            default:
                                return console.warn("THREE.WebGLProgram: Unsupported color space: ", le1), [
                                    vt,
                                    "LinearTransferOETF"
                                ];
                        }
                    }(vt);
                    return [
                        `vec4 ${le1}( vec4 value ) {`,
                        `\treturn ${bt[1]}( vec4( value.rgb * ${bt[0]}, value.a ) );`,
                        "}"
                    ].join("\n");
                }
                function getToneMappingFunction(le1, vt) {
                    let bt;
                    switch(vt){
                        case ls.kyO:
                            bt = "Linear";
                            break;
                        case ls.Mjd:
                            bt = "Reinhard";
                            break;
                        case ls.nNL:
                            bt = "Cineon";
                            break;
                        case ls.FV:
                            bt = "ACESFilmic";
                            break;
                        case ls.LAk:
                            bt = "AgX";
                            break;
                        case ls.aJ8:
                            bt = "Neutral";
                            break;
                        case ls.g7M:
                            bt = "Custom";
                            break;
                        default:
                            console.warn("THREE.WebGLProgram: Unsupported toneMapping:", vt), bt = "Linear";
                    }
                    return "vec3 " + le1 + "( vec3 color ) { return " + bt + "ToneMapping( color ); }";
                }
                const em = new ls.Pq0;
                function getLuminanceFunction() {
                    ls.ppV.getLuminanceCoefficients(em);
                    return [
                        "float luminance( const in vec3 rgb ) {",
                        `\tconst vec3 weights = vec3( ${em.x.toFixed(4)}, ${em.y.toFixed(4)}, ${em.z.toFixed(4)} );`,
                        "\treturn dot( weights, rgb );",
                        "}"
                    ].join("\n");
                }
                function filterEmptyLine(le1) {
                    return "" !== le1;
                }
                function replaceLightNums(le1, vt) {
                    const bt = vt.numSpotLightShadows + vt.numSpotLightMaps - vt.numSpotLightShadowsWithMaps;
                    return le1.replace(/NUM_DIR_LIGHTS/g, vt.numDirLights).replace(/NUM_SPOT_LIGHTS/g, vt.numSpotLights).replace(/NUM_SPOT_LIGHT_MAPS/g, vt.numSpotLightMaps).replace(/NUM_SPOT_LIGHT_COORDS/g, bt).replace(/NUM_RECT_AREA_LIGHTS/g, vt.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, vt.numPointLights).replace(/NUM_HEMI_LIGHTS/g, vt.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, vt.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS_WITH_MAPS/g, vt.numSpotLightShadowsWithMaps).replace(/NUM_SPOT_LIGHT_SHADOWS/g, vt.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, vt.numPointLightShadows);
                }
                function replaceClippingPlaneNums(le1, vt) {
                    return le1.replace(/NUM_CLIPPING_PLANES/g, vt.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, vt.numClippingPlanes - vt.numClipIntersection);
                }
                const tm = /^[ \t]*#include +<([\w\d./]+)>/gm;
                function resolveIncludes(le1) {
                    return le1.replace(tm, includeReplacer);
                }
                const im = new Map;
                function includeReplacer(le1, vt) {
                    let bt = ho[vt];
                    if (void 0 === bt) {
                        const le1 = im.get(vt);
                        if (void 0 === le1) throw new Error("Can not resolve #include <" + vt + ">");
                        bt = ho[le1], console.warn('THREE.WebGLRenderer: Shader chunk "%s" has been deprecated. Use "%s" instead.', vt, le1);
                    }
                    return resolveIncludes(bt);
                }
                const nm = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
                function unrollLoops(le1) {
                    return le1.replace(nm, loopReplacer);
                }
                function loopReplacer(le1, vt, bt, ls) {
                    let ho = "";
                    for(let Dl = parseInt(vt); Dl < parseInt(bt); Dl++)ho += ls.replace(/\[\s*i\s*\]/g, "[ " + Dl + " ]").replace(/UNROLLED_LOOP_INDEX/g, Dl);
                    return ho;
                }
                function generatePrecision(le1) {
                    let vt = `precision ${le1.precision} float;\n\tprecision ${le1.precision} int;\n\tprecision ${le1.precision} sampler2D;\n\tprecision ${le1.precision} samplerCube;\n\tprecision ${le1.precision} sampler3D;\n\tprecision ${le1.precision} sampler2DArray;\n\tprecision ${le1.precision} sampler2DShadow;\n\tprecision ${le1.precision} samplerCubeShadow;\n\tprecision ${le1.precision} sampler2DArrayShadow;\n\tprecision ${le1.precision} isampler2D;\n\tprecision ${le1.precision} isampler3D;\n\tprecision ${le1.precision} isamplerCube;\n\tprecision ${le1.precision} isampler2DArray;\n\tprecision ${le1.precision} usampler2D;\n\tprecision ${le1.precision} usampler3D;\n\tprecision ${le1.precision} usamplerCube;\n\tprecision ${le1.precision} usampler2DArray;\n\t`;
                    return "highp" === le1.precision ? vt += "\n#define HIGH_PRECISION" : "mediump" === le1.precision ? vt += "\n#define MEDIUM_PRECISION" : "lowp" === le1.precision && (vt += "\n#define LOW_PRECISION"), vt;
                }
                function WebGLProgram(le1, vt, bt, Dl) {
                    const Fl = le1.getContext(), sc = bt.defines;
                    let uc = bt.vertexShader, mc = bt.fragmentShader;
                    const gc = function(le1) {
                        let vt = "SHADOWMAP_TYPE_BASIC";
                        return le1.shadowMapType === ls.QP0 ? vt = "SHADOWMAP_TYPE_PCF" : le1.shadowMapType === ls.Wk7 ? vt = "SHADOWMAP_TYPE_PCF_SOFT" : le1.shadowMapType === ls.RyA && (vt = "SHADOWMAP_TYPE_VSM"), vt;
                    }(bt), Ac = function(le1) {
                        let vt = "ENVMAP_TYPE_CUBE";
                        if (le1.envMap) switch(le1.envMapMode){
                            case ls.hy7:
                            case ls.xFO:
                                vt = "ENVMAP_TYPE_CUBE";
                                break;
                            case ls.Om:
                                vt = "ENVMAP_TYPE_CUBE_UV";
                        }
                        return vt;
                    }(bt), Ec = function(le1) {
                        let vt = "ENVMAP_MODE_REFLECTION";
                        le1.envMap && le1.envMapMode === ls.xFO && (vt = "ENVMAP_MODE_REFRACTION");
                        return vt;
                    }(bt), kc = function(le1) {
                        let vt = "ENVMAP_BLENDING_NONE";
                        if (le1.envMap) switch(le1.combine){
                            case ls.caT:
                                vt = "ENVMAP_BLENDING_MULTIPLY";
                                break;
                            case ls.KRh:
                                vt = "ENVMAP_BLENDING_MIX";
                                break;
                            case ls.XrR:
                                vt = "ENVMAP_BLENDING_ADD";
                        }
                        return vt;
                    }(bt), du = function(le1) {
                        const vt = le1.envMapCubeUVHeight;
                        if (null === vt) return null;
                        const bt = Math.log2(vt) - 2, ls = 1 / vt;
                        return {
                            texelWidth: 1 / (3 * Math.max(Math.pow(2, bt), 112)),
                            texelHeight: ls,
                            maxMip: bt
                        };
                    }(bt), _u = function(le1) {
                        return [
                            le1.extensionClipCullDistance ? "#extension GL_ANGLE_clip_cull_distance : require" : "",
                            le1.extensionMultiDraw ? "#extension GL_ANGLE_multi_draw : require" : ""
                        ].filter(filterEmptyLine).join("\n");
                    }(bt), Md = function(le1) {
                        const vt = [];
                        for(const bt in le1){
                            const ls = le1[bt];
                            !1 !== ls && vt.push("#define " + bt + " " + ls);
                        }
                        return vt.join("\n");
                    }(sc), Ld = Fl.createProgram();
                    let Nd, Rd, Od = bt.glslVersion ? "#version " + bt.glslVersion + "\n" : "";
                    bt.isRawShaderMaterial ? (Nd = [
                        "#define SHADER_TYPE " + bt.shaderType,
                        "#define SHADER_NAME " + bt.shaderName,
                        Md
                    ].filter(filterEmptyLine).join("\n"), Nd.length > 0 && (Nd += "\n"), Rd = [
                        "#define SHADER_TYPE " + bt.shaderType,
                        "#define SHADER_NAME " + bt.shaderName,
                        Md
                    ].filter(filterEmptyLine).join("\n"), Rd.length > 0 && (Rd += "\n")) : (Nd = [
                        generatePrecision(bt),
                        "#define SHADER_TYPE " + bt.shaderType,
                        "#define SHADER_NAME " + bt.shaderName,
                        Md,
                        bt.extensionClipCullDistance ? "#define USE_CLIP_DISTANCE" : "",
                        bt.batching ? "#define USE_BATCHING" : "",
                        bt.batchingColor ? "#define USE_BATCHING_COLOR" : "",
                        bt.instancing ? "#define USE_INSTANCING" : "",
                        bt.instancingColor ? "#define USE_INSTANCING_COLOR" : "",
                        bt.instancingMorph ? "#define USE_INSTANCING_MORPH" : "",
                        bt.useFog && bt.fog ? "#define USE_FOG" : "",
                        bt.useFog && bt.fogExp2 ? "#define FOG_EXP2" : "",
                        bt.map ? "#define USE_MAP" : "",
                        bt.envMap ? "#define USE_ENVMAP" : "",
                        bt.envMap ? "#define " + Ec : "",
                        bt.lightMap ? "#define USE_LIGHTMAP" : "",
                        bt.aoMap ? "#define USE_AOMAP" : "",
                        bt.bumpMap ? "#define USE_BUMPMAP" : "",
                        bt.normalMap ? "#define USE_NORMALMAP" : "",
                        bt.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                        bt.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                        bt.displacementMap ? "#define USE_DISPLACEMENTMAP" : "",
                        bt.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                        bt.anisotropy ? "#define USE_ANISOTROPY" : "",
                        bt.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                        bt.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                        bt.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                        bt.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                        bt.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                        bt.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                        bt.specularMap ? "#define USE_SPECULARMAP" : "",
                        bt.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                        bt.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                        bt.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                        bt.metalnessMap ? "#define USE_METALNESSMAP" : "",
                        bt.alphaMap ? "#define USE_ALPHAMAP" : "",
                        bt.alphaHash ? "#define USE_ALPHAHASH" : "",
                        bt.transmission ? "#define USE_TRANSMISSION" : "",
                        bt.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                        bt.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                        bt.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                        bt.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                        bt.mapUv ? "#define MAP_UV " + bt.mapUv : "",
                        bt.alphaMapUv ? "#define ALPHAMAP_UV " + bt.alphaMapUv : "",
                        bt.lightMapUv ? "#define LIGHTMAP_UV " + bt.lightMapUv : "",
                        bt.aoMapUv ? "#define AOMAP_UV " + bt.aoMapUv : "",
                        bt.emissiveMapUv ? "#define EMISSIVEMAP_UV " + bt.emissiveMapUv : "",
                        bt.bumpMapUv ? "#define BUMPMAP_UV " + bt.bumpMapUv : "",
                        bt.normalMapUv ? "#define NORMALMAP_UV " + bt.normalMapUv : "",
                        bt.displacementMapUv ? "#define DISPLACEMENTMAP_UV " + bt.displacementMapUv : "",
                        bt.metalnessMapUv ? "#define METALNESSMAP_UV " + bt.metalnessMapUv : "",
                        bt.roughnessMapUv ? "#define ROUGHNESSMAP_UV " + bt.roughnessMapUv : "",
                        bt.anisotropyMapUv ? "#define ANISOTROPYMAP_UV " + bt.anisotropyMapUv : "",
                        bt.clearcoatMapUv ? "#define CLEARCOATMAP_UV " + bt.clearcoatMapUv : "",
                        bt.clearcoatNormalMapUv ? "#define CLEARCOAT_NORMALMAP_UV " + bt.clearcoatNormalMapUv : "",
                        bt.clearcoatRoughnessMapUv ? "#define CLEARCOAT_ROUGHNESSMAP_UV " + bt.clearcoatRoughnessMapUv : "",
                        bt.iridescenceMapUv ? "#define IRIDESCENCEMAP_UV " + bt.iridescenceMapUv : "",
                        bt.iridescenceThicknessMapUv ? "#define IRIDESCENCE_THICKNESSMAP_UV " + bt.iridescenceThicknessMapUv : "",
                        bt.sheenColorMapUv ? "#define SHEEN_COLORMAP_UV " + bt.sheenColorMapUv : "",
                        bt.sheenRoughnessMapUv ? "#define SHEEN_ROUGHNESSMAP_UV " + bt.sheenRoughnessMapUv : "",
                        bt.specularMapUv ? "#define SPECULARMAP_UV " + bt.specularMapUv : "",
                        bt.specularColorMapUv ? "#define SPECULAR_COLORMAP_UV " + bt.specularColorMapUv : "",
                        bt.specularIntensityMapUv ? "#define SPECULAR_INTENSITYMAP_UV " + bt.specularIntensityMapUv : "",
                        bt.transmissionMapUv ? "#define TRANSMISSIONMAP_UV " + bt.transmissionMapUv : "",
                        bt.thicknessMapUv ? "#define THICKNESSMAP_UV " + bt.thicknessMapUv : "",
                        bt.vertexTangents && !1 === bt.flatShading ? "#define USE_TANGENT" : "",
                        bt.vertexColors ? "#define USE_COLOR" : "",
                        bt.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                        bt.vertexUv1s ? "#define USE_UV1" : "",
                        bt.vertexUv2s ? "#define USE_UV2" : "",
                        bt.vertexUv3s ? "#define USE_UV3" : "",
                        bt.pointsUvs ? "#define USE_POINTS_UV" : "",
                        bt.flatShading ? "#define FLAT_SHADED" : "",
                        bt.skinning ? "#define USE_SKINNING" : "",
                        bt.morphTargets ? "#define USE_MORPHTARGETS" : "",
                        bt.morphNormals && !1 === bt.flatShading ? "#define USE_MORPHNORMALS" : "",
                        bt.morphColors ? "#define USE_MORPHCOLORS" : "",
                        bt.morphTargetsCount > 0 ? "#define MORPHTARGETS_TEXTURE_STRIDE " + bt.morphTextureStride : "",
                        bt.morphTargetsCount > 0 ? "#define MORPHTARGETS_COUNT " + bt.morphTargetsCount : "",
                        bt.doubleSided ? "#define DOUBLE_SIDED" : "",
                        bt.flipSided ? "#define FLIP_SIDED" : "",
                        bt.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                        bt.shadowMapEnabled ? "#define " + gc : "",
                        bt.sizeAttenuation ? "#define USE_SIZEATTENUATION" : "",
                        bt.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                        bt.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                        bt.reversedDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
                        "uniform mat4 modelMatrix;",
                        "uniform mat4 modelViewMatrix;",
                        "uniform mat4 projectionMatrix;",
                        "uniform mat4 viewMatrix;",
                        "uniform mat3 normalMatrix;",
                        "uniform vec3 cameraPosition;",
                        "uniform bool isOrthographic;",
                        "#ifdef USE_INSTANCING",
                        "\tattribute mat4 instanceMatrix;",
                        "#endif",
                        "#ifdef USE_INSTANCING_COLOR",
                        "\tattribute vec3 instanceColor;",
                        "#endif",
                        "#ifdef USE_INSTANCING_MORPH",
                        "\tuniform sampler2D morphTexture;",
                        "#endif",
                        "attribute vec3 position;",
                        "attribute vec3 normal;",
                        "attribute vec2 uv;",
                        "#ifdef USE_UV1",
                        "\tattribute vec2 uv1;",
                        "#endif",
                        "#ifdef USE_UV2",
                        "\tattribute vec2 uv2;",
                        "#endif",
                        "#ifdef USE_UV3",
                        "\tattribute vec2 uv3;",
                        "#endif",
                        "#ifdef USE_TANGENT",
                        "\tattribute vec4 tangent;",
                        "#endif",
                        "#if defined( USE_COLOR_ALPHA )",
                        "\tattribute vec4 color;",
                        "#elif defined( USE_COLOR )",
                        "\tattribute vec3 color;",
                        "#endif",
                        "#ifdef USE_SKINNING",
                        "\tattribute vec4 skinIndex;",
                        "\tattribute vec4 skinWeight;",
                        "#endif",
                        "\n"
                    ].filter(filterEmptyLine).join("\n"), Rd = [
                        generatePrecision(bt),
                        "#define SHADER_TYPE " + bt.shaderType,
                        "#define SHADER_NAME " + bt.shaderName,
                        Md,
                        bt.useFog && bt.fog ? "#define USE_FOG" : "",
                        bt.useFog && bt.fogExp2 ? "#define FOG_EXP2" : "",
                        bt.alphaToCoverage ? "#define ALPHA_TO_COVERAGE" : "",
                        bt.map ? "#define USE_MAP" : "",
                        bt.matcap ? "#define USE_MATCAP" : "",
                        bt.envMap ? "#define USE_ENVMAP" : "",
                        bt.envMap ? "#define " + Ac : "",
                        bt.envMap ? "#define " + Ec : "",
                        bt.envMap ? "#define " + kc : "",
                        du ? "#define CUBEUV_TEXEL_WIDTH " + du.texelWidth : "",
                        du ? "#define CUBEUV_TEXEL_HEIGHT " + du.texelHeight : "",
                        du ? "#define CUBEUV_MAX_MIP " + du.maxMip + ".0" : "",
                        bt.lightMap ? "#define USE_LIGHTMAP" : "",
                        bt.aoMap ? "#define USE_AOMAP" : "",
                        bt.bumpMap ? "#define USE_BUMPMAP" : "",
                        bt.normalMap ? "#define USE_NORMALMAP" : "",
                        bt.normalMapObjectSpace ? "#define USE_NORMALMAP_OBJECTSPACE" : "",
                        bt.normalMapTangentSpace ? "#define USE_NORMALMAP_TANGENTSPACE" : "",
                        bt.emissiveMap ? "#define USE_EMISSIVEMAP" : "",
                        bt.anisotropy ? "#define USE_ANISOTROPY" : "",
                        bt.anisotropyMap ? "#define USE_ANISOTROPYMAP" : "",
                        bt.clearcoat ? "#define USE_CLEARCOAT" : "",
                        bt.clearcoatMap ? "#define USE_CLEARCOATMAP" : "",
                        bt.clearcoatRoughnessMap ? "#define USE_CLEARCOAT_ROUGHNESSMAP" : "",
                        bt.clearcoatNormalMap ? "#define USE_CLEARCOAT_NORMALMAP" : "",
                        bt.dispersion ? "#define USE_DISPERSION" : "",
                        bt.iridescence ? "#define USE_IRIDESCENCE" : "",
                        bt.iridescenceMap ? "#define USE_IRIDESCENCEMAP" : "",
                        bt.iridescenceThicknessMap ? "#define USE_IRIDESCENCE_THICKNESSMAP" : "",
                        bt.specularMap ? "#define USE_SPECULARMAP" : "",
                        bt.specularColorMap ? "#define USE_SPECULAR_COLORMAP" : "",
                        bt.specularIntensityMap ? "#define USE_SPECULAR_INTENSITYMAP" : "",
                        bt.roughnessMap ? "#define USE_ROUGHNESSMAP" : "",
                        bt.metalnessMap ? "#define USE_METALNESSMAP" : "",
                        bt.alphaMap ? "#define USE_ALPHAMAP" : "",
                        bt.alphaTest ? "#define USE_ALPHATEST" : "",
                        bt.alphaHash ? "#define USE_ALPHAHASH" : "",
                        bt.sheen ? "#define USE_SHEEN" : "",
                        bt.sheenColorMap ? "#define USE_SHEEN_COLORMAP" : "",
                        bt.sheenRoughnessMap ? "#define USE_SHEEN_ROUGHNESSMAP" : "",
                        bt.transmission ? "#define USE_TRANSMISSION" : "",
                        bt.transmissionMap ? "#define USE_TRANSMISSIONMAP" : "",
                        bt.thicknessMap ? "#define USE_THICKNESSMAP" : "",
                        bt.vertexTangents && !1 === bt.flatShading ? "#define USE_TANGENT" : "",
                        bt.vertexColors || bt.instancingColor || bt.batchingColor ? "#define USE_COLOR" : "",
                        bt.vertexAlphas ? "#define USE_COLOR_ALPHA" : "",
                        bt.vertexUv1s ? "#define USE_UV1" : "",
                        bt.vertexUv2s ? "#define USE_UV2" : "",
                        bt.vertexUv3s ? "#define USE_UV3" : "",
                        bt.pointsUvs ? "#define USE_POINTS_UV" : "",
                        bt.gradientMap ? "#define USE_GRADIENTMAP" : "",
                        bt.flatShading ? "#define FLAT_SHADED" : "",
                        bt.doubleSided ? "#define DOUBLE_SIDED" : "",
                        bt.flipSided ? "#define FLIP_SIDED" : "",
                        bt.shadowMapEnabled ? "#define USE_SHADOWMAP" : "",
                        bt.shadowMapEnabled ? "#define " + gc : "",
                        bt.premultipliedAlpha ? "#define PREMULTIPLIED_ALPHA" : "",
                        bt.numLightProbes > 0 ? "#define USE_LIGHT_PROBES" : "",
                        bt.decodeVideoTexture ? "#define DECODE_VIDEO_TEXTURE" : "",
                        bt.decodeVideoTextureEmissive ? "#define DECODE_VIDEO_TEXTURE_EMISSIVE" : "",
                        bt.logarithmicDepthBuffer ? "#define USE_LOGDEPTHBUF" : "",
                        bt.reversedDepthBuffer ? "#define USE_REVERSEDEPTHBUF" : "",
                        "uniform mat4 viewMatrix;",
                        "uniform vec3 cameraPosition;",
                        "uniform bool isOrthographic;",
                        bt.toneMapping !== ls.y_p ? "#define TONE_MAPPING" : "",
                        bt.toneMapping !== ls.y_p ? ho.tonemapping_pars_fragment : "",
                        bt.toneMapping !== ls.y_p ? getToneMappingFunction("toneMapping", bt.toneMapping) : "",
                        bt.dithering ? "#define DITHERING" : "",
                        bt.opaque ? "#define OPAQUE" : "",
                        ho.colorspace_pars_fragment,
                        getTexelEncodingFunction("linearToOutputTexel", bt.outputColorSpace),
                        getLuminanceFunction(),
                        bt.useDepthPacking ? "#define DEPTH_PACKING " + bt.depthPacking : "",
                        "\n"
                    ].filter(filterEmptyLine).join("\n")), uc = resolveIncludes(uc), uc = replaceLightNums(uc, bt), uc = replaceClippingPlaneNums(uc, bt), mc = resolveIncludes(mc), mc = replaceLightNums(mc, bt), mc = replaceClippingPlaneNums(mc, bt), uc = unrollLoops(uc), mc = unrollLoops(mc), !0 !== bt.isRawShaderMaterial && (Od = "#version 300 es\n", Nd = [
                        _u,
                        "#define attribute in",
                        "#define varying out",
                        "#define texture2D texture"
                    ].join("\n") + "\n" + Nd, Rd = [
                        "#define varying in",
                        bt.glslVersion === ls.Wdf ? "" : "layout(location = 0) out highp vec4 pc_fragColor;",
                        bt.glslVersion === ls.Wdf ? "" : "#define gl_FragColor pc_fragColor",
                        "#define gl_FragDepthEXT gl_FragDepth",
                        "#define texture2D texture",
                        "#define textureCube texture",
                        "#define texture2DProj textureProj",
                        "#define texture2DLodEXT textureLod",
                        "#define texture2DProjLodEXT textureProjLod",
                        "#define textureCubeLodEXT textureLod",
                        "#define texture2DGradEXT textureGrad",
                        "#define texture2DProjGradEXT textureProjGrad",
                        "#define textureCubeGradEXT textureGrad"
                    ].join("\n") + "\n" + Rd);
                    const jd = Od + Nd + uc, Ud = Od + Rd + mc, Gd = WebGLShader(Fl, Fl.VERTEX_SHADER, jd), qd = WebGLShader(Fl, Fl.FRAGMENT_SHADER, Ud);
                    function onFirstUse(vt) {
                        if (le1.debug.checkShaderErrors) {
                            const bt = Fl.getProgramInfoLog(Ld) || "", ls = Fl.getShaderInfoLog(Gd) || "", ho = Fl.getShaderInfoLog(qd) || "", Dl = bt.trim(), sc = ls.trim(), uc = ho.trim();
                            let mc = !0, gc = !0;
                            if (!1 === Fl.getProgramParameter(Ld, Fl.LINK_STATUS)) {
                                if (mc = !1, "function" === typeof le1.debug.onShaderError) le1.debug.onShaderError(Fl, Ld, Gd, qd);
                                else {
                                    const le1 = getShaderErrors(Fl, Gd, "vertex"), bt = getShaderErrors(Fl, qd, "fragment");
                                    console.error("THREE.WebGLProgram: Shader Error " + Fl.getError() + " - VALIDATE_STATUS " + Fl.getProgramParameter(Ld, Fl.VALIDATE_STATUS) + "\n\nMaterial Name: " + vt.name + "\nMaterial Type: " + vt.type + "\n\nProgram Info Log: " + Dl + "\n" + le1 + "\n" + bt);
                                }
                            } else "" !== Dl ? console.warn("THREE.WebGLProgram: Program Info Log:", Dl) : "" !== sc && "" !== uc || (gc = !1);
                            gc && (vt.diagnostics = {
                                runnable: mc,
                                programLog: Dl,
                                vertexShader: {
                                    log: sc,
                                    prefix: Nd
                                },
                                fragmentShader: {
                                    log: uc,
                                    prefix: Rd
                                }
                            });
                        }
                        Fl.deleteShader(Gd), Fl.deleteShader(qd), Hd = new WebGLUniforms(Fl, Ld), Wd = function(le1, vt) {
                            const bt = {}, ls = le1.getProgramParameter(vt, le1.ACTIVE_ATTRIBUTES);
                            for(let ho = 0; ho < ls; ho++){
                                const ls = le1.getActiveAttrib(vt, ho), Dl = ls.name;
                                let Fl = 1;
                                ls.type === le1.FLOAT_MAT2 && (Fl = 2), ls.type === le1.FLOAT_MAT3 && (Fl = 3), ls.type === le1.FLOAT_MAT4 && (Fl = 4), bt[Dl] = {
                                    type: ls.type,
                                    location: le1.getAttribLocation(vt, Dl),
                                    locationSize: Fl
                                };
                            }
                            return bt;
                        }(Fl, Ld);
                    }
                    let Hd, Wd;
                    Fl.attachShader(Ld, Gd), Fl.attachShader(Ld, qd), void 0 !== bt.index0AttributeName ? Fl.bindAttribLocation(Ld, 0, bt.index0AttributeName) : !0 === bt.morphTargets && Fl.bindAttribLocation(Ld, 0, "position"), Fl.linkProgram(Ld), this.getUniforms = function() {
                        return void 0 === Hd && onFirstUse(this), Hd;
                    }, this.getAttributes = function() {
                        return void 0 === Wd && onFirstUse(this), Wd;
                    };
                    let Zd = !1 === bt.rendererExtensionParallelShaderCompile;
                    return this.isReady = function() {
                        return !1 === Zd && (Zd = Fl.getProgramParameter(Ld, 37297)), Zd;
                    }, this.destroy = function() {
                        Dl.releaseStatesOfProgram(this), Fl.deleteProgram(Ld), this.program = void 0;
                    }, this.type = bt.shaderType, this.name = bt.shaderName, this.id = $d++, this.cacheKey = vt, this.usedTimes = 1, this.program = Ld, this.vertexShader = Gd, this.fragmentShader = qd, this;
                }
                let rm = 0;
                class WebGLShaderCache {
                    constructor(){
                        this.shaderCache = new Map, this.materialCache = new Map;
                    }
                    update(le1) {
                        const vt = le1.vertexShader, bt = le1.fragmentShader, ls = this._getShaderStage(vt), ho = this._getShaderStage(bt), Dl = this._getShaderCacheForMaterial(le1);
                        return !1 === Dl.has(ls) && (Dl.add(ls), ls.usedTimes++), !1 === Dl.has(ho) && (Dl.add(ho), ho.usedTimes++), this;
                    }
                    remove(le1) {
                        const vt = this.materialCache.get(le1);
                        for (const bt of vt)bt.usedTimes--, 0 === bt.usedTimes && this.shaderCache.delete(bt.code);
                        return this.materialCache.delete(le1), this;
                    }
                    getVertexShaderID(le1) {
                        return this._getShaderStage(le1.vertexShader).id;
                    }
                    getFragmentShaderID(le1) {
                        return this._getShaderStage(le1.fragmentShader).id;
                    }
                    dispose() {
                        this.shaderCache.clear(), this.materialCache.clear();
                    }
                    _getShaderCacheForMaterial(le1) {
                        const vt = this.materialCache;
                        let bt = vt.get(le1);
                        return void 0 === bt && (bt = new Set, vt.set(le1, bt)), bt;
                    }
                    _getShaderStage(le1) {
                        const vt = this.shaderCache;
                        let bt = vt.get(le1);
                        return void 0 === bt && (bt = new WebGLShaderStage(le1), vt.set(le1, bt)), bt;
                    }
                }
                class WebGLShaderStage {
                    constructor(le1){
                        this.id = rm++, this.code = le1, this.usedTimes = 0;
                    }
                }
                function WebGLPrograms(le1, vt, bt, ho, Dl, sc, uc) {
                    const mc = new ls.zgK, gc = new WebGLShaderCache, Ac = new Set, Ec = [], kc = Dl.logarithmicDepthBuffer, du = Dl.vertexTextures;
                    let _u = Dl.precision;
                    const Md = {
                        MeshDepthMaterial: "depth",
                        MeshDistanceMaterial: "distanceRGBA",
                        MeshNormalMaterial: "normal",
                        MeshBasicMaterial: "basic",
                        MeshLambertMaterial: "lambert",
                        MeshPhongMaterial: "phong",
                        MeshToonMaterial: "toon",
                        MeshStandardMaterial: "physical",
                        MeshPhysicalMaterial: "physical",
                        MeshMatcapMaterial: "matcap",
                        LineBasicMaterial: "basic",
                        LineDashedMaterial: "dashed",
                        PointsMaterial: "points",
                        ShadowMaterial: "shadow",
                        SpriteMaterial: "sprite"
                    };
                    function getChannel(le1) {
                        return Ac.add(le1), 0 === le1 ? "uv" : `uv${le1}`;
                    }
                    return {
                        getParameters: function(sc, mc, Ec, Ld, Nd) {
                            const Rd = Ld.fog, Od = Nd.geometry, jd = sc.isMeshStandardMaterial ? Ld.environment : null, Ud = (sc.isMeshStandardMaterial ? bt : vt).get(sc.envMap || jd), Gd = Ud && Ud.mapping === ls.Om ? Ud.image.height : null, qd = Md[sc.type];
                            null !== sc.precision && (_u = Dl.getMaxPrecision(sc.precision), _u !== sc.precision && console.warn("THREE.WebGLProgram.getParameters:", sc.precision, "not supported, using", _u, "instead."));
                            const Hd = Od.morphAttributes.position || Od.morphAttributes.normal || Od.morphAttributes.color, Wd = void 0 !== Hd ? Hd.length : 0;
                            let Zd, Yd, Qd, Xd, Kd = 0;
                            if (void 0 !== Od.morphAttributes.position && (Kd = 1), void 0 !== Od.morphAttributes.normal && (Kd = 2), void 0 !== Od.morphAttributes.color && (Kd = 3), qd) {
                                const le1 = Fl[qd];
                                Zd = le1.vertexShader, Yd = le1.fragmentShader;
                            } else Zd = sc.vertexShader, Yd = sc.fragmentShader, gc.update(sc), Qd = gc.getVertexShaderID(sc), Xd = gc.getFragmentShaderID(sc);
                            const Jd = le1.getRenderTarget(), $d = le1.state.buffers.depth.getReversed(), sp = !0 === Nd.isInstancedMesh, em = !0 === Nd.isBatchedMesh, tm = !!sc.map, im = !!sc.matcap, nm = !!Ud, rm = !!sc.aoMap, am = !!sc.lightMap, sm = !!sc.bumpMap, om = !!sc.normalMap, lm = !!sc.displacementMap, cm = !!sc.emissiveMap, um = !!sc.metalnessMap, hm = !!sc.roughnessMap, dm = sc.anisotropy > 0, pm = sc.clearcoat > 0, mm = sc.dispersion > 0, fm = sc.iridescence > 0, gm = sc.sheen > 0, Am = sc.transmission > 0, _m = dm && !!sc.anisotropyMap, ym = pm && !!sc.clearcoatMap, vm = pm && !!sc.clearcoatNormalMap, xm = pm && !!sc.clearcoatRoughnessMap, bm = fm && !!sc.iridescenceMap, wm = fm && !!sc.iridescenceThicknessMap, Em = gm && !!sc.sheenColorMap, Mm = gm && !!sc.sheenRoughnessMap, Sm = !!sc.specularMap, Tm = !!sc.specularColorMap, km = !!sc.specularIntensityMap, Cm = Am && !!sc.transmissionMap, Im = Am && !!sc.thicknessMap, Dm = !!sc.gradientMap, Lm = !!sc.alphaMap, Pm = sc.alphaTest > 0, zm = !!sc.alphaHash, Nm = !!sc.extensions;
                            let Rm = ls.y_p;
                            sc.toneMapped && (null !== Jd && !0 !== Jd.isXRRenderTarget || (Rm = le1.toneMapping));
                            const Fm = {
                                shaderID: qd,
                                shaderType: sc.type,
                                shaderName: sc.name,
                                vertexShader: Zd,
                                fragmentShader: Yd,
                                defines: sc.defines,
                                customVertexShaderID: Qd,
                                customFragmentShaderID: Xd,
                                isRawShaderMaterial: !0 === sc.isRawShaderMaterial,
                                glslVersion: sc.glslVersion,
                                precision: _u,
                                batching: em,
                                batchingColor: em && null !== Nd._colorsTexture,
                                instancing: sp,
                                instancingColor: sp && null !== Nd.instanceColor,
                                instancingMorph: sp && null !== Nd.morphTexture,
                                supportsVertexTextures: du,
                                outputColorSpace: null === Jd ? le1.outputColorSpace : !0 === Jd.isXRRenderTarget ? Jd.texture.colorSpace : ls.Zr2,
                                alphaToCoverage: !!sc.alphaToCoverage,
                                map: tm,
                                matcap: im,
                                envMap: nm,
                                envMapMode: nm && Ud.mapping,
                                envMapCubeUVHeight: Gd,
                                aoMap: rm,
                                lightMap: am,
                                bumpMap: sm,
                                normalMap: om,
                                displacementMap: du && lm,
                                emissiveMap: cm,
                                normalMapObjectSpace: om && sc.normalMapType === ls.vyJ,
                                normalMapTangentSpace: om && sc.normalMapType === ls.bI3,
                                metalnessMap: um,
                                roughnessMap: hm,
                                anisotropy: dm,
                                anisotropyMap: _m,
                                clearcoat: pm,
                                clearcoatMap: ym,
                                clearcoatNormalMap: vm,
                                clearcoatRoughnessMap: xm,
                                dispersion: mm,
                                iridescence: fm,
                                iridescenceMap: bm,
                                iridescenceThicknessMap: wm,
                                sheen: gm,
                                sheenColorMap: Em,
                                sheenRoughnessMap: Mm,
                                specularMap: Sm,
                                specularColorMap: Tm,
                                specularIntensityMap: km,
                                transmission: Am,
                                transmissionMap: Cm,
                                thicknessMap: Im,
                                gradientMap: Dm,
                                opaque: !1 === sc.transparent && sc.blending === ls.NTi && !1 === sc.alphaToCoverage,
                                alphaMap: Lm,
                                alphaTest: Pm,
                                alphaHash: zm,
                                combine: sc.combine,
                                mapUv: tm && getChannel(sc.map.channel),
                                aoMapUv: rm && getChannel(sc.aoMap.channel),
                                lightMapUv: am && getChannel(sc.lightMap.channel),
                                bumpMapUv: sm && getChannel(sc.bumpMap.channel),
                                normalMapUv: om && getChannel(sc.normalMap.channel),
                                displacementMapUv: lm && getChannel(sc.displacementMap.channel),
                                emissiveMapUv: cm && getChannel(sc.emissiveMap.channel),
                                metalnessMapUv: um && getChannel(sc.metalnessMap.channel),
                                roughnessMapUv: hm && getChannel(sc.roughnessMap.channel),
                                anisotropyMapUv: _m && getChannel(sc.anisotropyMap.channel),
                                clearcoatMapUv: ym && getChannel(sc.clearcoatMap.channel),
                                clearcoatNormalMapUv: vm && getChannel(sc.clearcoatNormalMap.channel),
                                clearcoatRoughnessMapUv: xm && getChannel(sc.clearcoatRoughnessMap.channel),
                                iridescenceMapUv: bm && getChannel(sc.iridescenceMap.channel),
                                iridescenceThicknessMapUv: wm && getChannel(sc.iridescenceThicknessMap.channel),
                                sheenColorMapUv: Em && getChannel(sc.sheenColorMap.channel),
                                sheenRoughnessMapUv: Mm && getChannel(sc.sheenRoughnessMap.channel),
                                specularMapUv: Sm && getChannel(sc.specularMap.channel),
                                specularColorMapUv: Tm && getChannel(sc.specularColorMap.channel),
                                specularIntensityMapUv: km && getChannel(sc.specularIntensityMap.channel),
                                transmissionMapUv: Cm && getChannel(sc.transmissionMap.channel),
                                thicknessMapUv: Im && getChannel(sc.thicknessMap.channel),
                                alphaMapUv: Lm && getChannel(sc.alphaMap.channel),
                                vertexTangents: !!Od.attributes.tangent && (om || dm),
                                vertexColors: sc.vertexColors,
                                vertexAlphas: !0 === sc.vertexColors && !!Od.attributes.color && 4 === Od.attributes.color.itemSize,
                                pointsUvs: !0 === Nd.isPoints && !!Od.attributes.uv && (tm || Lm),
                                fog: !!Rd,
                                useFog: !0 === sc.fog,
                                fogExp2: !!Rd && Rd.isFogExp2,
                                flatShading: !0 === sc.flatShading && !1 === sc.wireframe,
                                sizeAttenuation: !0 === sc.sizeAttenuation,
                                logarithmicDepthBuffer: kc,
                                reversedDepthBuffer: $d,
                                skinning: !0 === Nd.isSkinnedMesh,
                                morphTargets: void 0 !== Od.morphAttributes.position,
                                morphNormals: void 0 !== Od.morphAttributes.normal,
                                morphColors: void 0 !== Od.morphAttributes.color,
                                morphTargetsCount: Wd,
                                morphTextureStride: Kd,
                                numDirLights: mc.directional.length,
                                numPointLights: mc.point.length,
                                numSpotLights: mc.spot.length,
                                numSpotLightMaps: mc.spotLightMap.length,
                                numRectAreaLights: mc.rectArea.length,
                                numHemiLights: mc.hemi.length,
                                numDirLightShadows: mc.directionalShadowMap.length,
                                numPointLightShadows: mc.pointShadowMap.length,
                                numSpotLightShadows: mc.spotShadowMap.length,
                                numSpotLightShadowsWithMaps: mc.numSpotLightShadowsWithMaps,
                                numLightProbes: mc.numLightProbes,
                                numClippingPlanes: uc.numPlanes,
                                numClipIntersection: uc.numIntersection,
                                dithering: sc.dithering,
                                shadowMapEnabled: le1.shadowMap.enabled && Ec.length > 0,
                                shadowMapType: le1.shadowMap.type,
                                toneMapping: Rm,
                                decodeVideoTexture: tm && !0 === sc.map.isVideoTexture && ls.ppV.getTransfer(sc.map.colorSpace) === ls.KLL,
                                decodeVideoTextureEmissive: cm && !0 === sc.emissiveMap.isVideoTexture && ls.ppV.getTransfer(sc.emissiveMap.colorSpace) === ls.KLL,
                                premultipliedAlpha: sc.premultipliedAlpha,
                                doubleSided: sc.side === ls.$EB,
                                flipSided: sc.side === ls.hsX,
                                useDepthPacking: sc.depthPacking >= 0,
                                depthPacking: sc.depthPacking || 0,
                                index0AttributeName: sc.index0AttributeName,
                                extensionClipCullDistance: Nm && !0 === sc.extensions.clipCullDistance && ho.has("WEBGL_clip_cull_distance"),
                                extensionMultiDraw: (Nm && !0 === sc.extensions.multiDraw || em) && ho.has("WEBGL_multi_draw"),
                                rendererExtensionParallelShaderCompile: ho.has("KHR_parallel_shader_compile"),
                                customProgramCacheKey: sc.customProgramCacheKey()
                            };
                            return Fm.vertexUv1s = Ac.has(1), Fm.vertexUv2s = Ac.has(2), Fm.vertexUv3s = Ac.has(3), Ac.clear(), Fm;
                        },
                        getProgramCacheKey: function(vt) {
                            const bt = [];
                            if (vt.shaderID ? bt.push(vt.shaderID) : (bt.push(vt.customVertexShaderID), bt.push(vt.customFragmentShaderID)), void 0 !== vt.defines) for(const le1 in vt.defines)bt.push(le1), bt.push(vt.defines[le1]);
                            return !1 === vt.isRawShaderMaterial && (!function(le1, vt) {
                                le1.push(vt.precision), le1.push(vt.outputColorSpace), le1.push(vt.envMapMode), le1.push(vt.envMapCubeUVHeight), le1.push(vt.mapUv), le1.push(vt.alphaMapUv), le1.push(vt.lightMapUv), le1.push(vt.aoMapUv), le1.push(vt.bumpMapUv), le1.push(vt.normalMapUv), le1.push(vt.displacementMapUv), le1.push(vt.emissiveMapUv), le1.push(vt.metalnessMapUv), le1.push(vt.roughnessMapUv), le1.push(vt.anisotropyMapUv), le1.push(vt.clearcoatMapUv), le1.push(vt.clearcoatNormalMapUv), le1.push(vt.clearcoatRoughnessMapUv), le1.push(vt.iridescenceMapUv), le1.push(vt.iridescenceThicknessMapUv), le1.push(vt.sheenColorMapUv), le1.push(vt.sheenRoughnessMapUv), le1.push(vt.specularMapUv), le1.push(vt.specularColorMapUv), le1.push(vt.specularIntensityMapUv), le1.push(vt.transmissionMapUv), le1.push(vt.thicknessMapUv), le1.push(vt.combine), le1.push(vt.fogExp2), le1.push(vt.sizeAttenuation), le1.push(vt.morphTargetsCount), le1.push(vt.morphAttributeCount), le1.push(vt.numDirLights), le1.push(vt.numPointLights), le1.push(vt.numSpotLights), le1.push(vt.numSpotLightMaps), le1.push(vt.numHemiLights), le1.push(vt.numRectAreaLights), le1.push(vt.numDirLightShadows), le1.push(vt.numPointLightShadows), le1.push(vt.numSpotLightShadows), le1.push(vt.numSpotLightShadowsWithMaps), le1.push(vt.numLightProbes), le1.push(vt.shadowMapType), le1.push(vt.toneMapping), le1.push(vt.numClippingPlanes), le1.push(vt.numClipIntersection), le1.push(vt.depthPacking);
                            }(bt, vt), function(le1, vt) {
                                mc.disableAll(), vt.supportsVertexTextures && mc.enable(0);
                                vt.instancing && mc.enable(1);
                                vt.instancingColor && mc.enable(2);
                                vt.instancingMorph && mc.enable(3);
                                vt.matcap && mc.enable(4);
                                vt.envMap && mc.enable(5);
                                vt.normalMapObjectSpace && mc.enable(6);
                                vt.normalMapTangentSpace && mc.enable(7);
                                vt.clearcoat && mc.enable(8);
                                vt.iridescence && mc.enable(9);
                                vt.alphaTest && mc.enable(10);
                                vt.vertexColors && mc.enable(11);
                                vt.vertexAlphas && mc.enable(12);
                                vt.vertexUv1s && mc.enable(13);
                                vt.vertexUv2s && mc.enable(14);
                                vt.vertexUv3s && mc.enable(15);
                                vt.vertexTangents && mc.enable(16);
                                vt.anisotropy && mc.enable(17);
                                vt.alphaHash && mc.enable(18);
                                vt.batching && mc.enable(19);
                                vt.dispersion && mc.enable(20);
                                vt.batchingColor && mc.enable(21);
                                vt.gradientMap && mc.enable(22);
                                le1.push(mc.mask), mc.disableAll(), vt.fog && mc.enable(0);
                                vt.useFog && mc.enable(1);
                                vt.flatShading && mc.enable(2);
                                vt.logarithmicDepthBuffer && mc.enable(3);
                                vt.reversedDepthBuffer && mc.enable(4);
                                vt.skinning && mc.enable(5);
                                vt.morphTargets && mc.enable(6);
                                vt.morphNormals && mc.enable(7);
                                vt.morphColors && mc.enable(8);
                                vt.premultipliedAlpha && mc.enable(9);
                                vt.shadowMapEnabled && mc.enable(10);
                                vt.doubleSided && mc.enable(11);
                                vt.flipSided && mc.enable(12);
                                vt.useDepthPacking && mc.enable(13);
                                vt.dithering && mc.enable(14);
                                vt.transmission && mc.enable(15);
                                vt.sheen && mc.enable(16);
                                vt.opaque && mc.enable(17);
                                vt.pointsUvs && mc.enable(18);
                                vt.decodeVideoTexture && mc.enable(19);
                                vt.decodeVideoTextureEmissive && mc.enable(20);
                                vt.alphaToCoverage && mc.enable(21);
                                le1.push(mc.mask);
                            }(bt, vt), bt.push(le1.outputColorSpace)), bt.push(vt.customProgramCacheKey), bt.join();
                        },
                        getUniforms: function(le1) {
                            const vt = Md[le1.type];
                            let bt;
                            if (vt) {
                                const le1 = Fl[vt];
                                bt = ls.LlO.clone(le1.uniforms);
                            } else bt = le1.uniforms;
                            return bt;
                        },
                        acquireProgram: function(vt, bt) {
                            let ls;
                            for(let le1 = 0, ho = Ec.length; le1 < ho; le1++){
                                const vt = Ec[le1];
                                if (vt.cacheKey === bt) {
                                    ls = vt, ++ls.usedTimes;
                                    break;
                                }
                            }
                            return void 0 === ls && (ls = new WebGLProgram(le1, bt, vt, sc), Ec.push(ls)), ls;
                        },
                        releaseProgram: function(le1) {
                            if (0 === --le1.usedTimes) {
                                const vt = Ec.indexOf(le1);
                                Ec[vt] = Ec[Ec.length - 1], Ec.pop(), le1.destroy();
                            }
                        },
                        releaseShaderCache: function(le1) {
                            gc.remove(le1);
                        },
                        programs: Ec,
                        dispose: function() {
                            gc.dispose();
                        }
                    };
                }
                function WebGLProperties() {
                    let le1 = new WeakMap;
                    return {
                        has: function(vt) {
                            return le1.has(vt);
                        },
                        get: function(vt) {
                            let bt = le1.get(vt);
                            return void 0 === bt && (bt = {}, le1.set(vt, bt)), bt;
                        },
                        remove: function(vt) {
                            le1.delete(vt);
                        },
                        update: function(vt, bt, ls) {
                            le1.get(vt)[bt] = ls;
                        },
                        dispose: function() {
                            le1 = new WeakMap;
                        }
                    };
                }
                function painterSortStable(le1, vt) {
                    return le1.groupOrder !== vt.groupOrder ? le1.groupOrder - vt.groupOrder : le1.renderOrder !== vt.renderOrder ? le1.renderOrder - vt.renderOrder : le1.material.id !== vt.material.id ? le1.material.id - vt.material.id : le1.z !== vt.z ? le1.z - vt.z : le1.id - vt.id;
                }
                function reversePainterSortStable(le1, vt) {
                    return le1.groupOrder !== vt.groupOrder ? le1.groupOrder - vt.groupOrder : le1.renderOrder !== vt.renderOrder ? le1.renderOrder - vt.renderOrder : le1.z !== vt.z ? vt.z - le1.z : le1.id - vt.id;
                }
                function WebGLRenderList() {
                    const le1 = [];
                    let vt = 0;
                    const bt = [], ls = [], ho = [];
                    function getNextRenderItem(bt, ls, ho, Dl, Fl, sc) {
                        let uc = le1[vt];
                        return void 0 === uc ? (uc = {
                            id: bt.id,
                            object: bt,
                            geometry: ls,
                            material: ho,
                            groupOrder: Dl,
                            renderOrder: bt.renderOrder,
                            z: Fl,
                            group: sc
                        }, le1[vt] = uc) : (uc.id = bt.id, uc.object = bt, uc.geometry = ls, uc.material = ho, uc.groupOrder = Dl, uc.renderOrder = bt.renderOrder, uc.z = Fl, uc.group = sc), vt++, uc;
                    }
                    return {
                        opaque: bt,
                        transmissive: ls,
                        transparent: ho,
                        init: function() {
                            vt = 0, bt.length = 0, ls.length = 0, ho.length = 0;
                        },
                        push: function(le1, vt, Dl, Fl, sc, uc) {
                            const mc = getNextRenderItem(le1, vt, Dl, Fl, sc, uc);
                            Dl.transmission > 0 ? ls.push(mc) : !0 === Dl.transparent ? ho.push(mc) : bt.push(mc);
                        },
                        unshift: function(le1, vt, Dl, Fl, sc, uc) {
                            const mc = getNextRenderItem(le1, vt, Dl, Fl, sc, uc);
                            Dl.transmission > 0 ? ls.unshift(mc) : !0 === Dl.transparent ? ho.unshift(mc) : bt.unshift(mc);
                        },
                        finish: function() {
                            for(let bt = vt, ls = le1.length; bt < ls; bt++){
                                const vt = le1[bt];
                                if (null === vt.id) break;
                                vt.id = null, vt.object = null, vt.geometry = null, vt.material = null, vt.group = null;
                            }
                        },
                        sort: function(le1, vt) {
                            bt.length > 1 && bt.sort(le1 || painterSortStable), ls.length > 1 && ls.sort(vt || reversePainterSortStable), ho.length > 1 && ho.sort(vt || reversePainterSortStable);
                        }
                    };
                }
                function WebGLRenderLists() {
                    let le1 = new WeakMap;
                    return {
                        get: function(vt, bt) {
                            const ls = le1.get(vt);
                            let ho;
                            return void 0 === ls ? (ho = new WebGLRenderList, le1.set(vt, [
                                ho
                            ])) : bt >= ls.length ? (ho = new WebGLRenderList, ls.push(ho)) : ho = ls[bt], ho;
                        },
                        dispose: function() {
                            le1 = new WeakMap;
                        }
                    };
                }
                function UniformsCache() {
                    const le1 = {};
                    return {
                        get: function(vt) {
                            if (void 0 !== le1[vt.id]) return le1[vt.id];
                            let bt;
                            switch(vt.type){
                                case "DirectionalLight":
                                    bt = {
                                        direction: new ls.Pq0,
                                        color: new ls.Q1f
                                    };
                                    break;
                                case "SpotLight":
                                    bt = {
                                        position: new ls.Pq0,
                                        direction: new ls.Pq0,
                                        color: new ls.Q1f,
                                        distance: 0,
                                        coneCos: 0,
                                        penumbraCos: 0,
                                        decay: 0
                                    };
                                    break;
                                case "PointLight":
                                    bt = {
                                        position: new ls.Pq0,
                                        color: new ls.Q1f,
                                        distance: 0,
                                        decay: 0
                                    };
                                    break;
                                case "HemisphereLight":
                                    bt = {
                                        direction: new ls.Pq0,
                                        skyColor: new ls.Q1f,
                                        groundColor: new ls.Q1f
                                    };
                                    break;
                                case "RectAreaLight":
                                    bt = {
                                        color: new ls.Q1f,
                                        position: new ls.Pq0,
                                        halfWidth: new ls.Pq0,
                                        halfHeight: new ls.Pq0
                                    };
                            }
                            return le1[vt.id] = bt, bt;
                        }
                    };
                }
                let am = 0;
                function shadowCastingAndTexturingLightsFirst(le1, vt) {
                    return (vt.castShadow ? 2 : 0) - (le1.castShadow ? 2 : 0) + (vt.map ? 1 : 0) - (le1.map ? 1 : 0);
                }
                function WebGLLights(le1) {
                    const vt = new UniformsCache, bt = function() {
                        const le1 = {};
                        return {
                            get: function(vt) {
                                if (void 0 !== le1[vt.id]) return le1[vt.id];
                                let bt;
                                switch(vt.type){
                                    case "DirectionalLight":
                                    case "SpotLight":
                                        bt = {
                                            shadowIntensity: 1,
                                            shadowBias: 0,
                                            shadowNormalBias: 0,
                                            shadowRadius: 1,
                                            shadowMapSize: new ls.I9Y
                                        };
                                        break;
                                    case "PointLight":
                                        bt = {
                                            shadowIntensity: 1,
                                            shadowBias: 0,
                                            shadowNormalBias: 0,
                                            shadowRadius: 1,
                                            shadowMapSize: new ls.I9Y,
                                            shadowCameraNear: 1,
                                            shadowCameraFar: 1e3
                                        };
                                }
                                return le1[vt.id] = bt, bt;
                            }
                        };
                    }(), ho = {
                        version: 0,
                        hash: {
                            directionalLength: -1,
                            pointLength: -1,
                            spotLength: -1,
                            rectAreaLength: -1,
                            hemiLength: -1,
                            numDirectionalShadows: -1,
                            numPointShadows: -1,
                            numSpotShadows: -1,
                            numSpotMaps: -1,
                            numLightProbes: -1
                        },
                        ambient: [
                            0,
                            0,
                            0
                        ],
                        probe: [],
                        directional: [],
                        directionalShadow: [],
                        directionalShadowMap: [],
                        directionalShadowMatrix: [],
                        spot: [],
                        spotLightMap: [],
                        spotShadow: [],
                        spotShadowMap: [],
                        spotLightMatrix: [],
                        rectArea: [],
                        rectAreaLTC1: null,
                        rectAreaLTC2: null,
                        point: [],
                        pointShadow: [],
                        pointShadowMap: [],
                        pointShadowMatrix: [],
                        hemi: [],
                        numSpotLightShadowsWithMaps: 0,
                        numLightProbes: 0
                    };
                    for(let Dl = 0; Dl < 9; Dl++)ho.probe.push(new ls.Pq0);
                    const Fl = new ls.Pq0, sc = new ls.kn4, uc = new ls.kn4;
                    return {
                        setup: function(ls) {
                            let Fl = 0, sc = 0, uc = 0;
                            for(let le1 = 0; le1 < 9; le1++)ho.probe[le1].set(0, 0, 0);
                            let mc = 0, gc = 0, Ac = 0, Ec = 0, kc = 0, du = 0, _u = 0, Md = 0, Ld = 0, Nd = 0, Rd = 0;
                            ls.sort(shadowCastingAndTexturingLightsFirst);
                            for(let le1 = 0, Dl = ls.length; le1 < Dl; le1++){
                                const Dl = ls[le1], Od = Dl.color, jd = Dl.intensity, Ud = Dl.distance, Gd = Dl.shadow && Dl.shadow.map ? Dl.shadow.map.texture : null;
                                if (Dl.isAmbientLight) Fl += Od.r * jd, sc += Od.g * jd, uc += Od.b * jd;
                                else if (Dl.isLightProbe) {
                                    for(let le1 = 0; le1 < 9; le1++)ho.probe[le1].addScaledVector(Dl.sh.coefficients[le1], jd);
                                    Rd++;
                                } else if (Dl.isDirectionalLight) {
                                    const le1 = vt.get(Dl);
                                    if (le1.color.copy(Dl.color).multiplyScalar(Dl.intensity), Dl.castShadow) {
                                        const le1 = Dl.shadow, vt = bt.get(Dl);
                                        vt.shadowIntensity = le1.intensity, vt.shadowBias = le1.bias, vt.shadowNormalBias = le1.normalBias, vt.shadowRadius = le1.radius, vt.shadowMapSize = le1.mapSize, ho.directionalShadow[mc] = vt, ho.directionalShadowMap[mc] = Gd, ho.directionalShadowMatrix[mc] = Dl.shadow.matrix, du++;
                                    }
                                    ho.directional[mc] = le1, mc++;
                                } else if (Dl.isSpotLight) {
                                    const le1 = vt.get(Dl);
                                    le1.position.setFromMatrixPosition(Dl.matrixWorld), le1.color.copy(Od).multiplyScalar(jd), le1.distance = Ud, le1.coneCos = Math.cos(Dl.angle), le1.penumbraCos = Math.cos(Dl.angle * (1 - Dl.penumbra)), le1.decay = Dl.decay, ho.spot[Ac] = le1;
                                    const ls = Dl.shadow;
                                    if (Dl.map && (ho.spotLightMap[Ld] = Dl.map, Ld++, ls.updateMatrices(Dl), Dl.castShadow && Nd++), ho.spotLightMatrix[Ac] = ls.matrix, Dl.castShadow) {
                                        const le1 = bt.get(Dl);
                                        le1.shadowIntensity = ls.intensity, le1.shadowBias = ls.bias, le1.shadowNormalBias = ls.normalBias, le1.shadowRadius = ls.radius, le1.shadowMapSize = ls.mapSize, ho.spotShadow[Ac] = le1, ho.spotShadowMap[Ac] = Gd, Md++;
                                    }
                                    Ac++;
                                } else if (Dl.isRectAreaLight) {
                                    const le1 = vt.get(Dl);
                                    le1.color.copy(Od).multiplyScalar(jd), le1.halfWidth.set(.5 * Dl.width, 0, 0), le1.halfHeight.set(0, .5 * Dl.height, 0), ho.rectArea[Ec] = le1, Ec++;
                                } else if (Dl.isPointLight) {
                                    const le1 = vt.get(Dl);
                                    if (le1.color.copy(Dl.color).multiplyScalar(Dl.intensity), le1.distance = Dl.distance, le1.decay = Dl.decay, Dl.castShadow) {
                                        const le1 = Dl.shadow, vt = bt.get(Dl);
                                        vt.shadowIntensity = le1.intensity, vt.shadowBias = le1.bias, vt.shadowNormalBias = le1.normalBias, vt.shadowRadius = le1.radius, vt.shadowMapSize = le1.mapSize, vt.shadowCameraNear = le1.camera.near, vt.shadowCameraFar = le1.camera.far, ho.pointShadow[gc] = vt, ho.pointShadowMap[gc] = Gd, ho.pointShadowMatrix[gc] = Dl.shadow.matrix, _u++;
                                    }
                                    ho.point[gc] = le1, gc++;
                                } else if (Dl.isHemisphereLight) {
                                    const le1 = vt.get(Dl);
                                    le1.skyColor.copy(Dl.color).multiplyScalar(jd), le1.groundColor.copy(Dl.groundColor).multiplyScalar(jd), ho.hemi[kc] = le1, kc++;
                                }
                            }
                            Ec > 0 && (!0 === le1.has("OES_texture_float_linear") ? (ho.rectAreaLTC1 = Dl.LTC_FLOAT_1, ho.rectAreaLTC2 = Dl.LTC_FLOAT_2) : (ho.rectAreaLTC1 = Dl.LTC_HALF_1, ho.rectAreaLTC2 = Dl.LTC_HALF_2)), ho.ambient[0] = Fl, ho.ambient[1] = sc, ho.ambient[2] = uc;
                            const Od = ho.hash;
                            Od.directionalLength === mc && Od.pointLength === gc && Od.spotLength === Ac && Od.rectAreaLength === Ec && Od.hemiLength === kc && Od.numDirectionalShadows === du && Od.numPointShadows === _u && Od.numSpotShadows === Md && Od.numSpotMaps === Ld && Od.numLightProbes === Rd || (ho.directional.length = mc, ho.spot.length = Ac, ho.rectArea.length = Ec, ho.point.length = gc, ho.hemi.length = kc, ho.directionalShadow.length = du, ho.directionalShadowMap.length = du, ho.pointShadow.length = _u, ho.pointShadowMap.length = _u, ho.spotShadow.length = Md, ho.spotShadowMap.length = Md, ho.directionalShadowMatrix.length = du, ho.pointShadowMatrix.length = _u, ho.spotLightMatrix.length = Md + Ld - Nd, ho.spotLightMap.length = Ld, ho.numSpotLightShadowsWithMaps = Nd, ho.numLightProbes = Rd, Od.directionalLength = mc, Od.pointLength = gc, Od.spotLength = Ac, Od.rectAreaLength = Ec, Od.hemiLength = kc, Od.numDirectionalShadows = du, Od.numPointShadows = _u, Od.numSpotShadows = Md, Od.numSpotMaps = Ld, Od.numLightProbes = Rd, ho.version = am++);
                        },
                        setupView: function(le1, vt) {
                            let bt = 0, ls = 0, Dl = 0, mc = 0, gc = 0;
                            const Ac = vt.matrixWorldInverse;
                            for(let Ec = 0, kc = le1.length; Ec < kc; Ec++){
                                const vt = le1[Ec];
                                if (vt.isDirectionalLight) {
                                    const le1 = ho.directional[bt];
                                    le1.direction.setFromMatrixPosition(vt.matrixWorld), Fl.setFromMatrixPosition(vt.target.matrixWorld), le1.direction.sub(Fl), le1.direction.transformDirection(Ac), bt++;
                                } else if (vt.isSpotLight) {
                                    const le1 = ho.spot[Dl];
                                    le1.position.setFromMatrixPosition(vt.matrixWorld), le1.position.applyMatrix4(Ac), le1.direction.setFromMatrixPosition(vt.matrixWorld), Fl.setFromMatrixPosition(vt.target.matrixWorld), le1.direction.sub(Fl), le1.direction.transformDirection(Ac), Dl++;
                                } else if (vt.isRectAreaLight) {
                                    const le1 = ho.rectArea[mc];
                                    le1.position.setFromMatrixPosition(vt.matrixWorld), le1.position.applyMatrix4(Ac), uc.identity(), sc.copy(vt.matrixWorld), sc.premultiply(Ac), uc.extractRotation(sc), le1.halfWidth.set(.5 * vt.width, 0, 0), le1.halfHeight.set(0, .5 * vt.height, 0), le1.halfWidth.applyMatrix4(uc), le1.halfHeight.applyMatrix4(uc), mc++;
                                } else if (vt.isPointLight) {
                                    const le1 = ho.point[ls];
                                    le1.position.setFromMatrixPosition(vt.matrixWorld), le1.position.applyMatrix4(Ac), ls++;
                                } else if (vt.isHemisphereLight) {
                                    const le1 = ho.hemi[gc];
                                    le1.direction.setFromMatrixPosition(vt.matrixWorld), le1.direction.transformDirection(Ac), gc++;
                                }
                            }
                        },
                        state: ho
                    };
                }
                function WebGLRenderState(le1) {
                    const vt = new WebGLLights(le1), bt = [], ls = [];
                    const ho = {
                        lightsArray: bt,
                        shadowsArray: ls,
                        camera: null,
                        lights: vt,
                        transmissionRenderTarget: {}
                    };
                    return {
                        init: function(le1) {
                            ho.camera = le1, bt.length = 0, ls.length = 0;
                        },
                        state: ho,
                        setupLights: function() {
                            vt.setup(bt);
                        },
                        setupLightsView: function(le1) {
                            vt.setupView(bt, le1);
                        },
                        pushLight: function(le1) {
                            bt.push(le1);
                        },
                        pushShadow: function(le1) {
                            ls.push(le1);
                        }
                    };
                }
                function WebGLRenderStates(le1) {
                    let vt = new WeakMap;
                    return {
                        get: function(bt, ls) {
                            void 0 === ls && (ls = 0);
                            const ho = vt.get(bt);
                            let Dl;
                            return void 0 === ho ? (Dl = new WebGLRenderState(le1), vt.set(bt, [
                                Dl
                            ])) : ls >= ho.length ? (Dl = new WebGLRenderState(le1), ho.push(Dl)) : Dl = ho[ls], Dl;
                        },
                        dispose: function() {
                            vt = new WeakMap;
                        }
                    };
                }
                function WebGLShadowMap(le1, vt, bt) {
                    let ho = new ls.PPD;
                    const Dl = new ls.I9Y, Fl = new ls.I9Y, sc = new ls.IUQ, uc = new ls.CSG({
                        depthPacking: ls.N5j
                    }), mc = new ls.aVO, gc = {}, Ac = bt.maxTextureSize, Ec = {
                        [ls.hB5]: ls.hsX,
                        [ls.hsX]: ls.hB5,
                        [ls.$EB]: ls.$EB
                    }, kc = new ls.BKk({
                        defines: {
                            VSM_SAMPLES: 8
                        },
                        uniforms: {
                            shadow_pass: {
                                value: null
                            },
                            resolution: {
                                value: new ls.I9Y
                            },
                            radius: {
                                value: 4
                            }
                        },
                        vertexShader: "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}",
                        fragmentShader: "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tconst float samples = float( VSM_SAMPLES );\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat uvStride = samples <= 1.0 ? 0.0 : 2.0 / ( samples - 1.0 );\n\tfloat uvStart = samples <= 1.0 ? 0.0 : - 1.0;\n\tfor ( float i = 0.0; i < samples; i ++ ) {\n\t\tfloat uvOffset = uvStart + i * uvStride;\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( uvOffset, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, uvOffset ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean / samples;\n\tsquared_mean = squared_mean / samples;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}"
                    }), du = kc.clone();
                    du.defines.HORIZONTAL_PASS = 1;
                    const _u = new ls.LoY;
                    _u.setAttribute("position", new ls.THS(new Float32Array([
                        -1,
                        -1,
                        .5,
                        3,
                        -1,
                        .5,
                        -1,
                        3,
                        .5
                    ]), 3));
                    const Md = new ls.eaF(_u, kc), Ld = this;
                    this.enabled = !1, this.autoUpdate = !0, this.needsUpdate = !1, this.type = ls.QP0;
                    let Nd = this.type;
                    function VSMPass(bt, ho) {
                        const Fl = vt.update(Md);
                        kc.defines.VSM_SAMPLES !== bt.blurSamples && (kc.defines.VSM_SAMPLES = bt.blurSamples, du.defines.VSM_SAMPLES = bt.blurSamples, kc.needsUpdate = !0, du.needsUpdate = !0), null === bt.mapPass && (bt.mapPass = new ls.nWS(Dl.x, Dl.y)), kc.uniforms.shadow_pass.value = bt.map.texture, kc.uniforms.resolution.value = bt.mapSize, kc.uniforms.radius.value = bt.radius, le1.setRenderTarget(bt.mapPass), le1.clear(), le1.renderBufferDirect(ho, null, Fl, kc, Md, null), du.uniforms.shadow_pass.value = bt.mapPass.texture, du.uniforms.resolution.value = bt.mapSize, du.uniforms.radius.value = bt.radius, le1.setRenderTarget(bt.map), le1.clear(), le1.renderBufferDirect(ho, null, Fl, du, Md, null);
                    }
                    function getDepthMaterial(vt, bt, ho, Dl) {
                        let Fl = null;
                        const sc = !0 === ho.isPointLight ? vt.customDistanceMaterial : vt.customDepthMaterial;
                        if (void 0 !== sc) Fl = sc;
                        else if (Fl = !0 === ho.isPointLight ? mc : uc, le1.localClippingEnabled && !0 === bt.clipShadows && Array.isArray(bt.clippingPlanes) && 0 !== bt.clippingPlanes.length || bt.displacementMap && 0 !== bt.displacementScale || bt.alphaMap && bt.alphaTest > 0 || bt.map && bt.alphaTest > 0 || !0 === bt.alphaToCoverage) {
                            const le1 = Fl.uuid, vt = bt.uuid;
                            let ls = gc[le1];
                            void 0 === ls && (ls = {}, gc[le1] = ls);
                            let ho = ls[vt];
                            void 0 === ho && (ho = Fl.clone(), ls[vt] = ho, bt.addEventListener("dispose", onMaterialDispose)), Fl = ho;
                        }
                        if (Fl.visible = bt.visible, Fl.wireframe = bt.wireframe, Dl === ls.RyA ? Fl.side = null !== bt.shadowSide ? bt.shadowSide : bt.side : Fl.side = null !== bt.shadowSide ? bt.shadowSide : Ec[bt.side], Fl.alphaMap = bt.alphaMap, Fl.alphaTest = !0 === bt.alphaToCoverage ? .5 : bt.alphaTest, Fl.map = bt.map, Fl.clipShadows = bt.clipShadows, Fl.clippingPlanes = bt.clippingPlanes, Fl.clipIntersection = bt.clipIntersection, Fl.displacementMap = bt.displacementMap, Fl.displacementScale = bt.displacementScale, Fl.displacementBias = bt.displacementBias, Fl.wireframeLinewidth = bt.wireframeLinewidth, Fl.linewidth = bt.linewidth, !0 === ho.isPointLight && !0 === Fl.isMeshDistanceMaterial) le1.properties.get(Fl).light = ho;
                        return Fl;
                    }
                    function renderObject(bt, Dl, Fl, sc, uc) {
                        if (!1 === bt.visible) return;
                        if (bt.layers.test(Dl.layers) && (bt.isMesh || bt.isLine || bt.isPoints) && (bt.castShadow || bt.receiveShadow && uc === ls.RyA) && (!bt.frustumCulled || ho.intersectsObject(bt))) {
                            bt.modelViewMatrix.multiplyMatrices(Fl.matrixWorldInverse, bt.matrixWorld);
                            const ls = vt.update(bt), ho = bt.material;
                            if (Array.isArray(ho)) {
                                const vt = ls.groups;
                                for(let mc = 0, gc = vt.length; mc < gc; mc++){
                                    const gc = vt[mc], Ac = ho[gc.materialIndex];
                                    if (Ac && Ac.visible) {
                                        const vt = getDepthMaterial(bt, Ac, sc, uc);
                                        bt.onBeforeShadow(le1, bt, Dl, Fl, ls, vt, gc), le1.renderBufferDirect(Fl, null, ls, vt, bt, gc), bt.onAfterShadow(le1, bt, Dl, Fl, ls, vt, gc);
                                    }
                                }
                            } else if (ho.visible) {
                                const vt = getDepthMaterial(bt, ho, sc, uc);
                                bt.onBeforeShadow(le1, bt, Dl, Fl, ls, vt, null), le1.renderBufferDirect(Fl, null, ls, vt, bt, null), bt.onAfterShadow(le1, bt, Dl, Fl, ls, vt, null);
                            }
                        }
                        const mc = bt.children;
                        for(let le1 = 0, vt = mc.length; le1 < vt; le1++)renderObject(mc[le1], Dl, Fl, sc, uc);
                    }
                    function onMaterialDispose(le1) {
                        le1.target.removeEventListener("dispose", onMaterialDispose);
                        for(const vt in gc){
                            const bt = gc[vt], ls = le1.target.uuid;
                            if (ls in bt) bt[ls].dispose(), delete bt[ls];
                        }
                    }
                    this.render = function(vt, bt, uc) {
                        if (!1 === Ld.enabled) return;
                        if (!1 === Ld.autoUpdate && !1 === Ld.needsUpdate) return;
                        if (0 === vt.length) return;
                        const mc = le1.getRenderTarget(), gc = le1.getActiveCubeFace(), Ec = le1.getActiveMipmapLevel(), kc = le1.state;
                        kc.setBlending(ls.XIg), kc.buffers.depth.getReversed() ? kc.buffers.color.setClear(0, 0, 0, 0) : kc.buffers.color.setClear(1, 1, 1, 1), kc.buffers.depth.setTest(!0), kc.setScissorTest(!1);
                        const du = Nd !== ls.RyA && this.type === ls.RyA, _u = Nd === ls.RyA && this.type !== ls.RyA;
                        for(let Md = 0, Ld = vt.length; Md < Ld; Md++){
                            const mc = vt[Md], gc = mc.shadow;
                            if (void 0 === gc) {
                                console.warn("THREE.WebGLShadowMap:", mc, "has no shadow.");
                                continue;
                            }
                            if (!1 === gc.autoUpdate && !1 === gc.needsUpdate) continue;
                            Dl.copy(gc.mapSize);
                            const Ec = gc.getFrameExtents();
                            if (Dl.multiply(Ec), Fl.copy(gc.mapSize), (Dl.x > Ac || Dl.y > Ac) && (Dl.x > Ac && (Fl.x = Math.floor(Ac / Ec.x), Dl.x = Fl.x * Ec.x, gc.mapSize.x = Fl.x), Dl.y > Ac && (Fl.y = Math.floor(Ac / Ec.y), Dl.y = Fl.y * Ec.y, gc.mapSize.y = Fl.y)), null === gc.map || !0 === du || !0 === _u) {
                                const le1 = this.type !== ls.RyA ? {
                                    minFilter: ls.hxR,
                                    magFilter: ls.hxR
                                } : {};
                                null !== gc.map && gc.map.dispose(), gc.map = new ls.nWS(Dl.x, Dl.y, le1), gc.map.texture.name = mc.name + ".shadowMap", gc.camera.updateProjectionMatrix();
                            }
                            le1.setRenderTarget(gc.map), le1.clear();
                            const Ld = gc.getViewportCount();
                            for(let le1 = 0; le1 < Ld; le1++){
                                const vt = gc.getViewport(le1);
                                sc.set(Fl.x * vt.x, Fl.y * vt.y, Fl.x * vt.z, Fl.y * vt.w), kc.viewport(sc), gc.updateMatrices(mc, le1), ho = gc.getFrustum(), renderObject(bt, uc, gc.camera, mc, this.type);
                            }
                            !0 !== gc.isPointLightShadow && this.type === ls.RyA && VSMPass(gc, uc), gc.needsUpdate = !1;
                        }
                        Nd = this.type, Ld.needsUpdate = !1, le1.setRenderTarget(mc, gc, Ec);
                    };
                }
                const sm = {
                    [ls.eHc]: ls.lGu,
                    [ls.brA]: ls.K52,
                    [ls.U3G]: ls.bw0,
                    [ls.xSv]: ls.Gwm,
                    [ls.lGu]: ls.eHc,
                    [ls.K52]: ls.brA,
                    [ls.bw0]: ls.U3G,
                    [ls.Gwm]: ls.xSv
                };
                function WebGLState(le1, vt) {
                    const bt = new function() {
                        let vt = !1;
                        const bt = new ls.IUQ;
                        let ho = null;
                        const Dl = new ls.IUQ(0, 0, 0, 0);
                        return {
                            setMask: function(bt) {
                                ho === bt || vt || (le1.colorMask(bt, bt, bt, bt), ho = bt);
                            },
                            setLocked: function(le1) {
                                vt = le1;
                            },
                            setClear: function(vt, ls, ho, Fl, sc) {
                                !0 === sc && (vt *= Fl, ls *= Fl, ho *= Fl), bt.set(vt, ls, ho, Fl), !1 === Dl.equals(bt) && (le1.clearColor(vt, ls, ho, Fl), Dl.copy(bt));
                            },
                            reset: function() {
                                vt = !1, ho = null, Dl.set(-1, 0, 0, 0);
                            }
                        };
                    }, ho = new function() {
                        let bt = !1, ho = !1, Dl = null, Fl = null, sc = null;
                        return {
                            setReversed: function(le1) {
                                if (ho !== le1) {
                                    const bt = vt.get("EXT_clip_control");
                                    le1 ? bt.clipControlEXT(bt.LOWER_LEFT_EXT, bt.ZERO_TO_ONE_EXT) : bt.clipControlEXT(bt.LOWER_LEFT_EXT, bt.NEGATIVE_ONE_TO_ONE_EXT), ho = le1;
                                    const ls = sc;
                                    sc = null, this.setClear(ls);
                                }
                            },
                            getReversed: function() {
                                return ho;
                            },
                            setTest: function(vt) {
                                vt ? enable(le1.DEPTH_TEST) : disable(le1.DEPTH_TEST);
                            },
                            setMask: function(vt) {
                                Dl === vt || bt || (le1.depthMask(vt), Dl = vt);
                            },
                            setFunc: function(vt) {
                                if (ho && (vt = sm[vt]), Fl !== vt) {
                                    switch(vt){
                                        case ls.eHc:
                                            le1.depthFunc(le1.NEVER);
                                            break;
                                        case ls.lGu:
                                            le1.depthFunc(le1.ALWAYS);
                                            break;
                                        case ls.brA:
                                            le1.depthFunc(le1.LESS);
                                            break;
                                        case ls.xSv:
                                            le1.depthFunc(le1.LEQUAL);
                                            break;
                                        case ls.U3G:
                                            le1.depthFunc(le1.EQUAL);
                                            break;
                                        case ls.Gwm:
                                            le1.depthFunc(le1.GEQUAL);
                                            break;
                                        case ls.K52:
                                            le1.depthFunc(le1.GREATER);
                                            break;
                                        case ls.bw0:
                                            le1.depthFunc(le1.NOTEQUAL);
                                            break;
                                        default:
                                            le1.depthFunc(le1.LEQUAL);
                                    }
                                    Fl = vt;
                                }
                            },
                            setLocked: function(le1) {
                                bt = le1;
                            },
                            setClear: function(vt) {
                                sc !== vt && (ho && (vt = 1 - vt), le1.clearDepth(vt), sc = vt);
                            },
                            reset: function() {
                                bt = !1, Dl = null, Fl = null, sc = null, ho = !1;
                            }
                        };
                    }, Dl = new function() {
                        let vt = !1, bt = null, ls = null, ho = null, Dl = null, Fl = null, sc = null, uc = null, mc = null;
                        return {
                            setTest: function(bt) {
                                vt || (bt ? enable(le1.STENCIL_TEST) : disable(le1.STENCIL_TEST));
                            },
                            setMask: function(ls) {
                                bt === ls || vt || (le1.stencilMask(ls), bt = ls);
                            },
                            setFunc: function(vt, bt, Fl) {
                                ls === vt && ho === bt && Dl === Fl || (le1.stencilFunc(vt, bt, Fl), ls = vt, ho = bt, Dl = Fl);
                            },
                            setOp: function(vt, bt, ls) {
                                Fl === vt && sc === bt && uc === ls || (le1.stencilOp(vt, bt, ls), Fl = vt, sc = bt, uc = ls);
                            },
                            setLocked: function(le1) {
                                vt = le1;
                            },
                            setClear: function(vt) {
                                mc !== vt && (le1.clearStencil(vt), mc = vt);
                            },
                            reset: function() {
                                vt = !1, bt = null, ls = null, ho = null, Dl = null, Fl = null, sc = null, uc = null, mc = null;
                            }
                        };
                    }, Fl = new WeakMap, sc = new WeakMap;
                    let uc = {}, mc = {}, gc = new WeakMap, Ac = [], Ec = null, kc = !1, du = null, _u = null, Md = null, Ld = null, Nd = null, Rd = null, Od = null, jd = new ls.Q1f(0, 0, 0), Ud = 0, Gd = !1, qd = null, Hd = null, Wd = null, Zd = null, Yd = null;
                    const Qd = le1.getParameter(le1.MAX_COMBINED_TEXTURE_IMAGE_UNITS);
                    let Xd = !1, Kd = 0;
                    const Jd = le1.getParameter(le1.VERSION);
                    -1 !== Jd.indexOf("WebGL") ? (Kd = parseFloat(/^WebGL (\d)/.exec(Jd)[1]), Xd = Kd >= 1) : -1 !== Jd.indexOf("OpenGL ES") && (Kd = parseFloat(/^OpenGL ES (\d)/.exec(Jd)[1]), Xd = Kd >= 2);
                    let $d = null, sp = {};
                    const em = le1.getParameter(le1.SCISSOR_BOX), tm = le1.getParameter(le1.VIEWPORT), im = (new ls.IUQ).fromArray(em), nm = (new ls.IUQ).fromArray(tm);
                    function createTexture(vt, bt, ls, ho) {
                        const Dl = new Uint8Array(4), Fl = le1.createTexture();
                        le1.bindTexture(vt, Fl), le1.texParameteri(vt, le1.TEXTURE_MIN_FILTER, le1.NEAREST), le1.texParameteri(vt, le1.TEXTURE_MAG_FILTER, le1.NEAREST);
                        for(let sc = 0; sc < ls; sc++)vt === le1.TEXTURE_3D || vt === le1.TEXTURE_2D_ARRAY ? le1.texImage3D(bt, 0, le1.RGBA, 1, 1, ho, 0, le1.RGBA, le1.UNSIGNED_BYTE, Dl) : le1.texImage2D(bt + sc, 0, le1.RGBA, 1, 1, 0, le1.RGBA, le1.UNSIGNED_BYTE, Dl);
                        return Fl;
                    }
                    const rm = {};
                    function enable(vt) {
                        !0 !== uc[vt] && (le1.enable(vt), uc[vt] = !0);
                    }
                    function disable(vt) {
                        !1 !== uc[vt] && (le1.disable(vt), uc[vt] = !1);
                    }
                    rm[le1.TEXTURE_2D] = createTexture(le1.TEXTURE_2D, le1.TEXTURE_2D, 1), rm[le1.TEXTURE_CUBE_MAP] = createTexture(le1.TEXTURE_CUBE_MAP, le1.TEXTURE_CUBE_MAP_POSITIVE_X, 6), rm[le1.TEXTURE_2D_ARRAY] = createTexture(le1.TEXTURE_2D_ARRAY, le1.TEXTURE_2D_ARRAY, 1, 1), rm[le1.TEXTURE_3D] = createTexture(le1.TEXTURE_3D, le1.TEXTURE_3D, 1, 1), bt.setClear(0, 0, 0, 1), ho.setClear(1), Dl.setClear(0), enable(le1.DEPTH_TEST), ho.setFunc(ls.xSv), setFlipSided(!1), setCullFace(ls.Vb5), enable(le1.CULL_FACE), setBlending(ls.XIg);
                    const am = {
                        [ls.gO9]: le1.FUNC_ADD,
                        [ls.FXf]: le1.FUNC_SUBTRACT,
                        [ls.nST]: le1.FUNC_REVERSE_SUBTRACT
                    };
                    am[ls.znC] = le1.MIN, am[ls.$ei] = le1.MAX;
                    const om = {
                        [ls.ojh]: le1.ZERO,
                        [ls.qad]: le1.ONE,
                        [ls.f4X]: le1.SRC_COLOR,
                        [ls.ie2]: le1.SRC_ALPHA,
                        [ls.hgQ]: le1.SRC_ALPHA_SATURATE,
                        [ls.wn6]: le1.DST_COLOR,
                        [ls.hdd]: le1.DST_ALPHA,
                        [ls.LiQ]: le1.ONE_MINUS_SRC_COLOR,
                        [ls.OuU]: le1.ONE_MINUS_SRC_ALPHA,
                        [ls.aEY]: le1.ONE_MINUS_DST_COLOR,
                        [ls.Nt7]: le1.ONE_MINUS_DST_ALPHA,
                        [ls.RrE]: le1.CONSTANT_COLOR,
                        [ls.$Yl]: le1.ONE_MINUS_CONSTANT_COLOR,
                        [ls.e0p]: le1.CONSTANT_ALPHA,
                        [ls.ov9]: le1.ONE_MINUS_CONSTANT_ALPHA
                    };
                    function setBlending(vt, bt, ho, Dl, Fl, sc, uc, mc, gc, Ac) {
                        if (vt !== ls.XIg) {
                            if (!1 === kc && (enable(le1.BLEND), kc = !0), vt === ls.bCz) Fl = Fl || bt, sc = sc || ho, uc = uc || Dl, bt === _u && Fl === Nd || (le1.blendEquationSeparate(am[bt], am[Fl]), _u = bt, Nd = Fl), ho === Md && Dl === Ld && sc === Rd && uc === Od || (le1.blendFuncSeparate(om[ho], om[Dl], om[sc], om[uc]), Md = ho, Ld = Dl, Rd = sc, Od = uc), !1 !== mc.equals(jd) && gc === Ud || (le1.blendColor(mc.r, mc.g, mc.b, gc), jd.copy(mc), Ud = gc), du = vt, Gd = !1;
                            else if (vt !== du || Ac !== Gd) {
                                if (_u === ls.gO9 && Nd === ls.gO9 || (le1.blendEquation(le1.FUNC_ADD), _u = ls.gO9, Nd = ls.gO9), Ac) switch(vt){
                                    case ls.NTi:
                                        le1.blendFuncSeparate(le1.ONE, le1.ONE_MINUS_SRC_ALPHA, le1.ONE, le1.ONE_MINUS_SRC_ALPHA);
                                        break;
                                    case ls.EZo:
                                        le1.blendFunc(le1.ONE, le1.ONE);
                                        break;
                                    case ls.Kwu:
                                        le1.blendFuncSeparate(le1.ZERO, le1.ONE_MINUS_SRC_COLOR, le1.ZERO, le1.ONE);
                                        break;
                                    case ls.EdD:
                                        le1.blendFuncSeparate(le1.DST_COLOR, le1.ONE_MINUS_SRC_ALPHA, le1.ZERO, le1.ONE);
                                        break;
                                    default:
                                        console.error("THREE.WebGLState: Invalid blending: ", vt);
                                }
                                else switch(vt){
                                    case ls.NTi:
                                        le1.blendFuncSeparate(le1.SRC_ALPHA, le1.ONE_MINUS_SRC_ALPHA, le1.ONE, le1.ONE_MINUS_SRC_ALPHA);
                                        break;
                                    case ls.EZo:
                                        le1.blendFuncSeparate(le1.SRC_ALPHA, le1.ONE, le1.ONE, le1.ONE);
                                        break;
                                    case ls.Kwu:
                                        console.error("THREE.WebGLState: SubtractiveBlending requires material.premultipliedAlpha = true");
                                        break;
                                    case ls.EdD:
                                        console.error("THREE.WebGLState: MultiplyBlending requires material.premultipliedAlpha = true");
                                        break;
                                    default:
                                        console.error("THREE.WebGLState: Invalid blending: ", vt);
                                }
                                Md = null, Ld = null, Rd = null, Od = null, jd.set(0, 0, 0), Ud = 0, du = vt, Gd = Ac;
                            }
                        } else !0 === kc && (disable(le1.BLEND), kc = !1);
                    }
                    function setFlipSided(vt) {
                        qd !== vt && (vt ? le1.frontFace(le1.CW) : le1.frontFace(le1.CCW), qd = vt);
                    }
                    function setCullFace(vt) {
                        vt !== ls.WNZ ? (enable(le1.CULL_FACE), vt !== Hd && (vt === ls.Vb5 ? le1.cullFace(le1.BACK) : vt === ls.Jnc ? le1.cullFace(le1.FRONT) : le1.cullFace(le1.FRONT_AND_BACK))) : disable(le1.CULL_FACE), Hd = vt;
                    }
                    function setPolygonOffset(vt, bt, ls) {
                        vt ? (enable(le1.POLYGON_OFFSET_FILL), Zd === bt && Yd === ls || (le1.polygonOffset(bt, ls), Zd = bt, Yd = ls)) : disable(le1.POLYGON_OFFSET_FILL);
                    }
                    return {
                        buffers: {
                            color: bt,
                            depth: ho,
                            stencil: Dl
                        },
                        enable: enable,
                        disable: disable,
                        bindFramebuffer: function(vt, bt) {
                            return mc[vt] !== bt && (le1.bindFramebuffer(vt, bt), mc[vt] = bt, vt === le1.DRAW_FRAMEBUFFER && (mc[le1.FRAMEBUFFER] = bt), vt === le1.FRAMEBUFFER && (mc[le1.DRAW_FRAMEBUFFER] = bt), !0);
                        },
                        drawBuffers: function(vt, bt) {
                            let ls = Ac, ho = !1;
                            if (vt) {
                                ls = gc.get(bt), void 0 === ls && (ls = [], gc.set(bt, ls));
                                const Dl = vt.textures;
                                if (ls.length !== Dl.length || ls[0] !== le1.COLOR_ATTACHMENT0) {
                                    for(let vt = 0, bt = Dl.length; vt < bt; vt++)ls[vt] = le1.COLOR_ATTACHMENT0 + vt;
                                    ls.length = Dl.length, ho = !0;
                                }
                            } else ls[0] !== le1.BACK && (ls[0] = le1.BACK, ho = !0);
                            ho && le1.drawBuffers(ls);
                        },
                        useProgram: function(vt) {
                            return Ec !== vt && (le1.useProgram(vt), Ec = vt, !0);
                        },
                        setBlending: setBlending,
                        setMaterial: function(vt, Fl) {
                            vt.side === ls.$EB ? disable(le1.CULL_FACE) : enable(le1.CULL_FACE);
                            let sc = vt.side === ls.hsX;
                            Fl && (sc = !sc), setFlipSided(sc), vt.blending === ls.NTi && !1 === vt.transparent ? setBlending(ls.XIg) : setBlending(vt.blending, vt.blendEquation, vt.blendSrc, vt.blendDst, vt.blendEquationAlpha, vt.blendSrcAlpha, vt.blendDstAlpha, vt.blendColor, vt.blendAlpha, vt.premultipliedAlpha), ho.setFunc(vt.depthFunc), ho.setTest(vt.depthTest), ho.setMask(vt.depthWrite), bt.setMask(vt.colorWrite);
                            const uc = vt.stencilWrite;
                            Dl.setTest(uc), uc && (Dl.setMask(vt.stencilWriteMask), Dl.setFunc(vt.stencilFunc, vt.stencilRef, vt.stencilFuncMask), Dl.setOp(vt.stencilFail, vt.stencilZFail, vt.stencilZPass)), setPolygonOffset(vt.polygonOffset, vt.polygonOffsetFactor, vt.polygonOffsetUnits), !0 === vt.alphaToCoverage ? enable(le1.SAMPLE_ALPHA_TO_COVERAGE) : disable(le1.SAMPLE_ALPHA_TO_COVERAGE);
                        },
                        setFlipSided: setFlipSided,
                        setCullFace: setCullFace,
                        setLineWidth: function(vt) {
                            vt !== Wd && (Xd && le1.lineWidth(vt), Wd = vt);
                        },
                        setPolygonOffset: setPolygonOffset,
                        setScissorTest: function(vt) {
                            vt ? enable(le1.SCISSOR_TEST) : disable(le1.SCISSOR_TEST);
                        },
                        activeTexture: function(vt) {
                            void 0 === vt && (vt = le1.TEXTURE0 + Qd - 1), $d !== vt && (le1.activeTexture(vt), $d = vt);
                        },
                        bindTexture: function(vt, bt, ls) {
                            void 0 === ls && (ls = null === $d ? le1.TEXTURE0 + Qd - 1 : $d);
                            let ho = sp[ls];
                            void 0 === ho && (ho = {
                                type: void 0,
                                texture: void 0
                            }, sp[ls] = ho), ho.type === vt && ho.texture === bt || ($d !== ls && (le1.activeTexture(ls), $d = ls), le1.bindTexture(vt, bt || rm[vt]), ho.type = vt, ho.texture = bt);
                        },
                        unbindTexture: function() {
                            const vt = sp[$d];
                            void 0 !== vt && void 0 !== vt.type && (le1.bindTexture(vt.type, null), vt.type = void 0, vt.texture = void 0);
                        },
                        compressedTexImage2D: function() {
                            try {
                                le1.compressedTexImage2D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        compressedTexImage3D: function() {
                            try {
                                le1.compressedTexImage3D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        texImage2D: function() {
                            try {
                                le1.texImage2D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        texImage3D: function() {
                            try {
                                le1.texImage3D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        updateUBOMapping: function(vt, bt) {
                            let ls = sc.get(bt);
                            void 0 === ls && (ls = new WeakMap, sc.set(bt, ls));
                            let ho = ls.get(vt);
                            void 0 === ho && (ho = le1.getUniformBlockIndex(bt, vt.name), ls.set(vt, ho));
                        },
                        uniformBlockBinding: function(vt, bt) {
                            const ls = sc.get(bt).get(vt);
                            Fl.get(bt) !== ls && (le1.uniformBlockBinding(bt, ls, vt.__bindingPointIndex), Fl.set(bt, ls));
                        },
                        texStorage2D: function() {
                            try {
                                le1.texStorage2D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        texStorage3D: function() {
                            try {
                                le1.texStorage3D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        texSubImage2D: function() {
                            try {
                                le1.texSubImage2D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        texSubImage3D: function() {
                            try {
                                le1.texSubImage3D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        compressedTexSubImage2D: function() {
                            try {
                                le1.compressedTexSubImage2D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        compressedTexSubImage3D: function() {
                            try {
                                le1.compressedTexSubImage3D(...arguments);
                            } catch (vt) {
                                console.error("THREE.WebGLState:", vt);
                            }
                        },
                        scissor: function(vt) {
                            !1 === im.equals(vt) && (le1.scissor(vt.x, vt.y, vt.z, vt.w), im.copy(vt));
                        },
                        viewport: function(vt) {
                            !1 === nm.equals(vt) && (le1.viewport(vt.x, vt.y, vt.z, vt.w), nm.copy(vt));
                        },
                        reset: function() {
                            le1.disable(le1.BLEND), le1.disable(le1.CULL_FACE), le1.disable(le1.DEPTH_TEST), le1.disable(le1.POLYGON_OFFSET_FILL), le1.disable(le1.SCISSOR_TEST), le1.disable(le1.STENCIL_TEST), le1.disable(le1.SAMPLE_ALPHA_TO_COVERAGE), le1.blendEquation(le1.FUNC_ADD), le1.blendFunc(le1.ONE, le1.ZERO), le1.blendFuncSeparate(le1.ONE, le1.ZERO, le1.ONE, le1.ZERO), le1.blendColor(0, 0, 0, 0), le1.colorMask(!0, !0, !0, !0), le1.clearColor(0, 0, 0, 0), le1.depthMask(!0), le1.depthFunc(le1.LESS), ho.setReversed(!1), le1.clearDepth(1), le1.stencilMask(4294967295), le1.stencilFunc(le1.ALWAYS, 0, 4294967295), le1.stencilOp(le1.KEEP, le1.KEEP, le1.KEEP), le1.clearStencil(0), le1.cullFace(le1.BACK), le1.frontFace(le1.CCW), le1.polygonOffset(0, 0), le1.activeTexture(le1.TEXTURE0), le1.bindFramebuffer(le1.FRAMEBUFFER, null), le1.bindFramebuffer(le1.DRAW_FRAMEBUFFER, null), le1.bindFramebuffer(le1.READ_FRAMEBUFFER, null), le1.useProgram(null), le1.lineWidth(1), le1.scissor(0, 0, le1.canvas.width, le1.canvas.height), le1.viewport(0, 0, le1.canvas.width, le1.canvas.height), uc = {}, $d = null, sp = {}, mc = {}, gc = new WeakMap, Ac = [], Ec = null, kc = !1, du = null, _u = null, Md = null, Ld = null, Nd = null, Rd = null, Od = null, jd = new ls.Q1f(0, 0, 0), Ud = 0, Gd = !1, qd = null, Hd = null, Wd = null, Zd = null, Yd = null, im.set(0, 0, le1.canvas.width, le1.canvas.height), nm.set(0, 0, le1.canvas.width, le1.canvas.height), bt.reset(), ho.reset(), Dl.reset();
                        }
                    };
                }
                function WebGLTextures(le1, vt, bt, ho, Dl, Fl, sc) {
                    const uc = vt.has("WEBGL_multisampled_render_to_texture") ? vt.get("WEBGL_multisampled_render_to_texture") : null, mc = "undefined" !== typeof navigator && /OculusBrowser/g.test(navigator.userAgent), gc = new ls.I9Y, Ac = new WeakMap;
                    let Ec;
                    const kc = new WeakMap;
                    let du = !1;
                    try {
                        du = "undefined" !== typeof OffscreenCanvas && null !== new OffscreenCanvas(1, 1).getContext("2d");
                    } catch (jd) {}
                    function createCanvas(le1, vt) {
                        return du ? new OffscreenCanvas(le1, vt) : (0, ls.qq$)("canvas");
                    }
                    function resizeImage(le1, vt, bt) {
                        let ls = 1;
                        const ho = getDimensions(le1);
                        if ((ho.width > bt || ho.height > bt) && (ls = bt / Math.max(ho.width, ho.height)), ls < 1) {
                            if ("undefined" !== typeof HTMLImageElement && le1 instanceof HTMLImageElement || "undefined" !== typeof HTMLCanvasElement && le1 instanceof HTMLCanvasElement || "undefined" !== typeof ImageBitmap && le1 instanceof ImageBitmap || "undefined" !== typeof VideoFrame && le1 instanceof VideoFrame) {
                                const bt = Math.floor(ls * ho.width), Dl = Math.floor(ls * ho.height);
                                void 0 === Ec && (Ec = createCanvas(bt, Dl));
                                const Fl = vt ? createCanvas(bt, Dl) : Ec;
                                Fl.width = bt, Fl.height = Dl;
                                return Fl.getContext("2d").drawImage(le1, 0, 0, bt, Dl), console.warn("THREE.WebGLRenderer: Texture has been resized from (" + ho.width + "x" + ho.height + ") to (" + bt + "x" + Dl + ")."), Fl;
                            }
                            return "data" in le1 && console.warn("THREE.WebGLRenderer: Image in DataTexture is too big (" + ho.width + "x" + ho.height + ")."), le1;
                        }
                        return le1;
                    }
                    function textureNeedsGenerateMipmaps(le1) {
                        return le1.generateMipmaps;
                    }
                    function generateMipmap(vt) {
                        le1.generateMipmap(vt);
                    }
                    function getTargetType(vt) {
                        return vt.isWebGLCubeRenderTarget ? le1.TEXTURE_CUBE_MAP : vt.isWebGL3DRenderTarget ? le1.TEXTURE_3D : vt.isWebGLArrayRenderTarget || vt.isCompressedArrayTexture ? le1.TEXTURE_2D_ARRAY : le1.TEXTURE_2D;
                    }
                    function getInternalFormat(bt, ho, Dl, Fl, sc) {
                        if (void 0 === sc && (sc = !1), null !== bt) {
                            if (void 0 !== le1[bt]) return le1[bt];
                            console.warn("THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format '" + bt + "'");
                        }
                        let uc = ho;
                        if (ho === le1.RED && (Dl === le1.FLOAT && (uc = le1.R32F), Dl === le1.HALF_FLOAT && (uc = le1.R16F), Dl === le1.UNSIGNED_BYTE && (uc = le1.R8)), ho === le1.RED_INTEGER && (Dl === le1.UNSIGNED_BYTE && (uc = le1.R8UI), Dl === le1.UNSIGNED_SHORT && (uc = le1.R16UI), Dl === le1.UNSIGNED_INT && (uc = le1.R32UI), Dl === le1.BYTE && (uc = le1.R8I), Dl === le1.SHORT && (uc = le1.R16I), Dl === le1.INT && (uc = le1.R32I)), ho === le1.RG && (Dl === le1.FLOAT && (uc = le1.RG32F), Dl === le1.HALF_FLOAT && (uc = le1.RG16F), Dl === le1.UNSIGNED_BYTE && (uc = le1.RG8)), ho === le1.RG_INTEGER && (Dl === le1.UNSIGNED_BYTE && (uc = le1.RG8UI), Dl === le1.UNSIGNED_SHORT && (uc = le1.RG16UI), Dl === le1.UNSIGNED_INT && (uc = le1.RG32UI), Dl === le1.BYTE && (uc = le1.RG8I), Dl === le1.SHORT && (uc = le1.RG16I), Dl === le1.INT && (uc = le1.RG32I)), ho === le1.RGB_INTEGER && (Dl === le1.UNSIGNED_BYTE && (uc = le1.RGB8UI), Dl === le1.UNSIGNED_SHORT && (uc = le1.RGB16UI), Dl === le1.UNSIGNED_INT && (uc = le1.RGB32UI), Dl === le1.BYTE && (uc = le1.RGB8I), Dl === le1.SHORT && (uc = le1.RGB16I), Dl === le1.INT && (uc = le1.RGB32I)), ho === le1.RGBA_INTEGER && (Dl === le1.UNSIGNED_BYTE && (uc = le1.RGBA8UI), Dl === le1.UNSIGNED_SHORT && (uc = le1.RGBA16UI), Dl === le1.UNSIGNED_INT && (uc = le1.RGBA32UI), Dl === le1.BYTE && (uc = le1.RGBA8I), Dl === le1.SHORT && (uc = le1.RGBA16I), Dl === le1.INT && (uc = le1.RGBA32I)), ho === le1.RGB && Dl === le1.UNSIGNED_INT_5_9_9_9_REV && (uc = le1.RGB9_E5), ho === le1.RGBA) {
                            const vt = sc ? ls.VxR : ls.ppV.getTransfer(Fl);
                            Dl === le1.FLOAT && (uc = le1.RGBA32F), Dl === le1.HALF_FLOAT && (uc = le1.RGBA16F), Dl === le1.UNSIGNED_BYTE && (uc = vt === ls.KLL ? le1.SRGB8_ALPHA8 : le1.RGBA8), Dl === le1.UNSIGNED_SHORT_4_4_4_4 && (uc = le1.RGBA4), Dl === le1.UNSIGNED_SHORT_5_5_5_1 && (uc = le1.RGB5_A1);
                        }
                        return uc !== le1.R16F && uc !== le1.R32F && uc !== le1.RG16F && uc !== le1.RG32F && uc !== le1.RGBA16F && uc !== le1.RGBA32F || vt.get("EXT_color_buffer_float"), uc;
                    }
                    function getInternalDepthFormat(vt, bt) {
                        let ho;
                        return vt ? null === bt || bt === ls.bkx || bt === ls.V3x ? ho = le1.DEPTH24_STENCIL8 : bt === ls.RQf ? ho = le1.DEPTH32F_STENCIL8 : bt === ls.cHt && (ho = le1.DEPTH24_STENCIL8, console.warn("DepthTexture: 16 bit depth attachment is not supported with stencil. Using 24-bit attachment.")) : null === bt || bt === ls.bkx || bt === ls.V3x ? ho = le1.DEPTH_COMPONENT24 : bt === ls.RQf ? ho = le1.DEPTH_COMPONENT32F : bt === ls.cHt && (ho = le1.DEPTH_COMPONENT16), ho;
                    }
                    function getMipLevels(le1, vt) {
                        return !0 === textureNeedsGenerateMipmaps(le1) || le1.isFramebufferTexture && le1.minFilter !== ls.hxR && le1.minFilter !== ls.k6q ? Math.log2(Math.max(vt.width, vt.height)) + 1 : void 0 !== le1.mipmaps && le1.mipmaps.length > 0 ? le1.mipmaps.length : le1.isCompressedTexture && Array.isArray(le1.image) ? vt.mipmaps.length : 1;
                    }
                    function onTextureDispose(le1) {
                        const vt = le1.target;
                        vt.removeEventListener("dispose", onTextureDispose), function(le1) {
                            const vt = ho.get(le1);
                            if (void 0 === vt.__webglInit) return;
                            const bt = le1.source, ls = kc.get(bt);
                            if (ls) {
                                const ho = ls[vt.__cacheKey];
                                ho.usedTimes--, 0 === ho.usedTimes && deleteTexture(le1), 0 === Object.keys(ls).length && kc.delete(bt);
                            }
                            ho.remove(le1);
                        }(vt), vt.isVideoTexture && Ac.delete(vt);
                    }
                    function onRenderTargetDispose(vt) {
                        const bt = vt.target;
                        bt.removeEventListener("dispose", onRenderTargetDispose), function(vt) {
                            const bt = ho.get(vt);
                            vt.depthTexture && (vt.depthTexture.dispose(), ho.remove(vt.depthTexture));
                            if (vt.isWebGLCubeRenderTarget) for(let ho = 0; ho < 6; ho++){
                                if (Array.isArray(bt.__webglFramebuffer[ho])) for(let vt = 0; vt < bt.__webglFramebuffer[ho].length; vt++)le1.deleteFramebuffer(bt.__webglFramebuffer[ho][vt]);
                                else le1.deleteFramebuffer(bt.__webglFramebuffer[ho]);
                                bt.__webglDepthbuffer && le1.deleteRenderbuffer(bt.__webglDepthbuffer[ho]);
                            }
                            else {
                                if (Array.isArray(bt.__webglFramebuffer)) for(let vt = 0; vt < bt.__webglFramebuffer.length; vt++)le1.deleteFramebuffer(bt.__webglFramebuffer[vt]);
                                else le1.deleteFramebuffer(bt.__webglFramebuffer);
                                if (bt.__webglDepthbuffer && le1.deleteRenderbuffer(bt.__webglDepthbuffer), bt.__webglMultisampledFramebuffer && le1.deleteFramebuffer(bt.__webglMultisampledFramebuffer), bt.__webglColorRenderbuffer) for(let vt = 0; vt < bt.__webglColorRenderbuffer.length; vt++)bt.__webglColorRenderbuffer[vt] && le1.deleteRenderbuffer(bt.__webglColorRenderbuffer[vt]);
                                bt.__webglDepthRenderbuffer && le1.deleteRenderbuffer(bt.__webglDepthRenderbuffer);
                            }
                            const ls = vt.textures;
                            for(let Dl = 0, Fl = ls.length; Dl < Fl; Dl++){
                                const vt = ho.get(ls[Dl]);
                                vt.__webglTexture && (le1.deleteTexture(vt.__webglTexture), sc.memory.textures--), ho.remove(ls[Dl]);
                            }
                            ho.remove(vt);
                        }(bt);
                    }
                    function deleteTexture(vt) {
                        const bt = ho.get(vt);
                        le1.deleteTexture(bt.__webglTexture);
                        const ls = vt.source;
                        delete kc.get(ls)[bt.__cacheKey], sc.memory.textures--;
                    }
                    let _u = 0;
                    function setTexture2D(vt, ls) {
                        const Dl = ho.get(vt);
                        if (vt.isVideoTexture && function(le1) {
                            const vt = sc.render.frame;
                            Ac.get(le1) !== vt && (Ac.set(le1, vt), le1.update());
                        }(vt), !1 === vt.isRenderTargetTexture && !0 !== vt.isExternalTexture && vt.version > 0 && Dl.__version !== vt.version) {
                            const le1 = vt.image;
                            if (null === le1) console.warn("THREE.WebGLRenderer: Texture marked for update but no image data found.");
                            else {
                                if (!1 !== le1.complete) return void uploadTexture(Dl, vt, ls);
                                console.warn("THREE.WebGLRenderer: Texture marked for update but image is incomplete");
                            }
                        } else vt.isExternalTexture && (Dl.__webglTexture = vt.sourceTexture ? vt.sourceTexture : null);
                        bt.bindTexture(le1.TEXTURE_2D, Dl.__webglTexture, le1.TEXTURE0 + ls);
                    }
                    const Md = {
                        [ls.GJx]: le1.REPEAT,
                        [ls.ghU]: le1.CLAMP_TO_EDGE,
                        [ls.kTW]: le1.MIRRORED_REPEAT
                    }, Ld = {
                        [ls.hxR]: le1.NEAREST,
                        [ls.pHI]: le1.NEAREST_MIPMAP_NEAREST,
                        [ls.Cfg]: le1.NEAREST_MIPMAP_LINEAR,
                        [ls.k6q]: le1.LINEAR,
                        [ls.kRr]: le1.LINEAR_MIPMAP_NEAREST,
                        [ls.$_I]: le1.LINEAR_MIPMAP_LINEAR
                    }, Nd = {
                        [ls.amv]: le1.NEVER,
                        [ls.FFZ]: le1.ALWAYS,
                        [ls.vim]: le1.LESS,
                        [ls.TiK]: le1.LEQUAL,
                        [ls.kO0]: le1.EQUAL,
                        [ls.gWB]: le1.GEQUAL,
                        [ls.eoi]: le1.GREATER,
                        [ls.jzd]: le1.NOTEQUAL
                    };
                    function setTextureParameters(bt, Fl) {
                        if (Fl.type !== ls.RQf || !1 !== vt.has("OES_texture_float_linear") || Fl.magFilter !== ls.k6q && Fl.magFilter !== ls.kRr && Fl.magFilter !== ls.Cfg && Fl.magFilter !== ls.$_I && Fl.minFilter !== ls.k6q && Fl.minFilter !== ls.kRr && Fl.minFilter !== ls.Cfg && Fl.minFilter !== ls.$_I || console.warn("THREE.WebGLRenderer: Unable to use linear filtering with floating point textures. OES_texture_float_linear not supported on this device."), le1.texParameteri(bt, le1.TEXTURE_WRAP_S, Md[Fl.wrapS]), le1.texParameteri(bt, le1.TEXTURE_WRAP_T, Md[Fl.wrapT]), bt !== le1.TEXTURE_3D && bt !== le1.TEXTURE_2D_ARRAY || le1.texParameteri(bt, le1.TEXTURE_WRAP_R, Md[Fl.wrapR]), le1.texParameteri(bt, le1.TEXTURE_MAG_FILTER, Ld[Fl.magFilter]), le1.texParameteri(bt, le1.TEXTURE_MIN_FILTER, Ld[Fl.minFilter]), Fl.compareFunction && (le1.texParameteri(bt, le1.TEXTURE_COMPARE_MODE, le1.COMPARE_REF_TO_TEXTURE), le1.texParameteri(bt, le1.TEXTURE_COMPARE_FUNC, Nd[Fl.compareFunction])), !0 === vt.has("EXT_texture_filter_anisotropic")) {
                            if (Fl.magFilter === ls.hxR) return;
                            if (Fl.minFilter !== ls.Cfg && Fl.minFilter !== ls.$_I) return;
                            if (Fl.type === ls.RQf && !1 === vt.has("OES_texture_float_linear")) return;
                            if (Fl.anisotropy > 1 || ho.get(Fl).__currentAnisotropy) {
                                const ls = vt.get("EXT_texture_filter_anisotropic");
                                le1.texParameterf(bt, ls.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(Fl.anisotropy, Dl.getMaxAnisotropy())), ho.get(Fl).__currentAnisotropy = Fl.anisotropy;
                            }
                        }
                    }
                    function initTexture(vt, bt) {
                        let ls = !1;
                        void 0 === vt.__webglInit && (vt.__webglInit = !0, bt.addEventListener("dispose", onTextureDispose));
                        const ho = bt.source;
                        let Dl = kc.get(ho);
                        void 0 === Dl && (Dl = {}, kc.set(ho, Dl));
                        const Fl = function(le1) {
                            const vt = [];
                            return vt.push(le1.wrapS), vt.push(le1.wrapT), vt.push(le1.wrapR || 0), vt.push(le1.magFilter), vt.push(le1.minFilter), vt.push(le1.anisotropy), vt.push(le1.internalFormat), vt.push(le1.format), vt.push(le1.type), vt.push(le1.generateMipmaps), vt.push(le1.premultiplyAlpha), vt.push(le1.flipY), vt.push(le1.unpackAlignment), vt.push(le1.colorSpace), vt.join();
                        }(bt);
                        if (Fl !== vt.__cacheKey) {
                            void 0 === Dl[Fl] && (Dl[Fl] = {
                                texture: le1.createTexture(),
                                usedTimes: 0
                            }, sc.memory.textures++, ls = !0), Dl[Fl].usedTimes++;
                            const ho = Dl[vt.__cacheKey];
                            void 0 !== ho && (Dl[vt.__cacheKey].usedTimes--, 0 === ho.usedTimes && deleteTexture(bt)), vt.__cacheKey = Fl, vt.__webglTexture = Dl[Fl].texture;
                        }
                        return ls;
                    }
                    function getRow(le1, vt, bt) {
                        return Math.floor(Math.floor(le1 / bt) / vt);
                    }
                    function uploadTexture(vt, sc, uc) {
                        let mc = le1.TEXTURE_2D;
                        (sc.isDataArrayTexture || sc.isCompressedArrayTexture) && (mc = le1.TEXTURE_2D_ARRAY), sc.isData3DTexture && (mc = le1.TEXTURE_3D);
                        const gc = initTexture(vt, sc), Ac = sc.source;
                        bt.bindTexture(mc, vt.__webglTexture, le1.TEXTURE0 + uc);
                        const Ec = ho.get(Ac);
                        if (Ac.version !== Ec.__version || !0 === gc) {
                            bt.activeTexture(le1.TEXTURE0 + uc);
                            const vt = ls.ppV.getPrimaries(ls.ppV.workingColorSpace), ho = sc.colorSpace === ls.jf0 ? null : ls.ppV.getPrimaries(sc.colorSpace), kc = sc.colorSpace === ls.jf0 || vt === ho ? le1.NONE : le1.BROWSER_DEFAULT_WEBGL;
                            le1.pixelStorei(le1.UNPACK_FLIP_Y_WEBGL, sc.flipY), le1.pixelStorei(le1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, sc.premultiplyAlpha), le1.pixelStorei(le1.UNPACK_ALIGNMENT, sc.unpackAlignment), le1.pixelStorei(le1.UNPACK_COLORSPACE_CONVERSION_WEBGL, kc);
                            let du = resizeImage(sc.image, !1, Dl.maxTextureSize);
                            du = verifyColorSpace(sc, du);
                            const _u = Fl.convert(sc.format, sc.colorSpace), Md = Fl.convert(sc.type);
                            let Ld, Nd = getInternalFormat(sc.internalFormat, _u, Md, sc.colorSpace, sc.isVideoTexture);
                            setTextureParameters(mc, sc);
                            const Rd = sc.mipmaps, Od = !0 !== sc.isVideoTexture, jd = void 0 === Ec.__version || !0 === gc, Ud = Ac.dataReady, Gd = getMipLevels(sc, du);
                            if (sc.isDepthTexture) Nd = getInternalDepthFormat(sc.format === ls.dcC, sc.type), jd && (Od ? bt.texStorage2D(le1.TEXTURE_2D, 1, Nd, du.width, du.height) : bt.texImage2D(le1.TEXTURE_2D, 0, Nd, du.width, du.height, 0, _u, Md, null));
                            else if (sc.isDataTexture) {
                                if (Rd.length > 0) {
                                    Od && jd && bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, Rd[0].width, Rd[0].height);
                                    for(let vt = 0, ls = Rd.length; vt < ls; vt++)Ld = Rd[vt], Od ? Ud && bt.texSubImage2D(le1.TEXTURE_2D, vt, 0, 0, Ld.width, Ld.height, _u, Md, Ld.data) : bt.texImage2D(le1.TEXTURE_2D, vt, Nd, Ld.width, Ld.height, 0, _u, Md, Ld.data);
                                    sc.generateMipmaps = !1;
                                } else Od ? (jd && bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, du.width, du.height), Ud && function(vt, ls, ho, Dl) {
                                    const Fl = vt.updateRanges;
                                    if (0 === Fl.length) bt.texSubImage2D(le1.TEXTURE_2D, 0, 0, 0, ls.width, ls.height, ho, Dl, ls.data);
                                    else {
                                        Fl.sort((le1, vt)=>le1.start - vt.start);
                                        let sc = 0;
                                        for(let le1 = 1; le1 < Fl.length; le1++){
                                            const vt = Fl[sc], bt = Fl[le1], ho = vt.start + vt.count, Dl = getRow(bt.start, ls.width, 4), uc = getRow(vt.start, ls.width, 4);
                                            bt.start <= ho + 1 && Dl === uc && getRow(bt.start + bt.count - 1, ls.width, 4) === Dl ? vt.count = Math.max(vt.count, bt.start + bt.count - vt.start) : (++sc, Fl[sc] = bt);
                                        }
                                        Fl.length = sc + 1;
                                        const uc = le1.getParameter(le1.UNPACK_ROW_LENGTH), mc = le1.getParameter(le1.UNPACK_SKIP_PIXELS), gc = le1.getParameter(le1.UNPACK_SKIP_ROWS);
                                        le1.pixelStorei(le1.UNPACK_ROW_LENGTH, ls.width);
                                        for(let vt = 0, Ac = Fl.length; vt < Ac; vt++){
                                            const sc = Fl[vt], uc = Math.floor(sc.start / 4), mc = Math.ceil(sc.count / 4), gc = uc % ls.width, Ac = Math.floor(uc / ls.width), Ec = mc, kc = 1;
                                            le1.pixelStorei(le1.UNPACK_SKIP_PIXELS, gc), le1.pixelStorei(le1.UNPACK_SKIP_ROWS, Ac), bt.texSubImage2D(le1.TEXTURE_2D, 0, gc, Ac, Ec, kc, ho, Dl, ls.data);
                                        }
                                        vt.clearUpdateRanges(), le1.pixelStorei(le1.UNPACK_ROW_LENGTH, uc), le1.pixelStorei(le1.UNPACK_SKIP_PIXELS, mc), le1.pixelStorei(le1.UNPACK_SKIP_ROWS, gc);
                                    }
                                }(sc, du, _u, Md)) : bt.texImage2D(le1.TEXTURE_2D, 0, Nd, du.width, du.height, 0, _u, Md, du.data);
                            } else if (sc.isCompressedTexture) {
                                if (sc.isCompressedArrayTexture) {
                                    Od && jd && bt.texStorage3D(le1.TEXTURE_2D_ARRAY, Gd, Nd, Rd[0].width, Rd[0].height, du.depth);
                                    for(let vt = 0, ho = Rd.length; vt < ho; vt++)if (Ld = Rd[vt], sc.format !== ls.GWd) {
                                        if (null !== _u) {
                                            if (Od) {
                                                if (Ud) {
                                                    if (sc.layerUpdates.size > 0) {
                                                        const ho = (0, ls.Nex)(Ld.width, Ld.height, sc.format, sc.type);
                                                        for (const ls of sc.layerUpdates){
                                                            const Dl = Ld.data.subarray(ls * ho / Ld.data.BYTES_PER_ELEMENT, (ls + 1) * ho / Ld.data.BYTES_PER_ELEMENT);
                                                            bt.compressedTexSubImage3D(le1.TEXTURE_2D_ARRAY, vt, 0, 0, ls, Ld.width, Ld.height, 1, _u, Dl);
                                                        }
                                                        sc.clearLayerUpdates();
                                                    } else bt.compressedTexSubImage3D(le1.TEXTURE_2D_ARRAY, vt, 0, 0, 0, Ld.width, Ld.height, du.depth, _u, Ld.data);
                                                }
                                            } else bt.compressedTexImage3D(le1.TEXTURE_2D_ARRAY, vt, Nd, Ld.width, Ld.height, du.depth, 0, Ld.data, 0, 0);
                                        } else console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()");
                                    } else Od ? Ud && bt.texSubImage3D(le1.TEXTURE_2D_ARRAY, vt, 0, 0, 0, Ld.width, Ld.height, du.depth, _u, Md, Ld.data) : bt.texImage3D(le1.TEXTURE_2D_ARRAY, vt, Nd, Ld.width, Ld.height, du.depth, 0, _u, Md, Ld.data);
                                } else {
                                    Od && jd && bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, Rd[0].width, Rd[0].height);
                                    for(let vt = 0, ho = Rd.length; vt < ho; vt++)Ld = Rd[vt], sc.format !== ls.GWd ? null !== _u ? Od ? Ud && bt.compressedTexSubImage2D(le1.TEXTURE_2D, vt, 0, 0, Ld.width, Ld.height, _u, Ld.data) : bt.compressedTexImage2D(le1.TEXTURE_2D, vt, Nd, Ld.width, Ld.height, 0, Ld.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()") : Od ? Ud && bt.texSubImage2D(le1.TEXTURE_2D, vt, 0, 0, Ld.width, Ld.height, _u, Md, Ld.data) : bt.texImage2D(le1.TEXTURE_2D, vt, Nd, Ld.width, Ld.height, 0, _u, Md, Ld.data);
                                }
                            } else if (sc.isDataArrayTexture) {
                                if (Od) {
                                    if (jd && bt.texStorage3D(le1.TEXTURE_2D_ARRAY, Gd, Nd, du.width, du.height, du.depth), Ud) {
                                        if (sc.layerUpdates.size > 0) {
                                            const vt = (0, ls.Nex)(du.width, du.height, sc.format, sc.type);
                                            for (const ls of sc.layerUpdates){
                                                const ho = du.data.subarray(ls * vt / du.data.BYTES_PER_ELEMENT, (ls + 1) * vt / du.data.BYTES_PER_ELEMENT);
                                                bt.texSubImage3D(le1.TEXTURE_2D_ARRAY, 0, 0, 0, ls, du.width, du.height, 1, _u, Md, ho);
                                            }
                                            sc.clearLayerUpdates();
                                        } else bt.texSubImage3D(le1.TEXTURE_2D_ARRAY, 0, 0, 0, 0, du.width, du.height, du.depth, _u, Md, du.data);
                                    }
                                } else bt.texImage3D(le1.TEXTURE_2D_ARRAY, 0, Nd, du.width, du.height, du.depth, 0, _u, Md, du.data);
                            } else if (sc.isData3DTexture) Od ? (jd && bt.texStorage3D(le1.TEXTURE_3D, Gd, Nd, du.width, du.height, du.depth), Ud && bt.texSubImage3D(le1.TEXTURE_3D, 0, 0, 0, 0, du.width, du.height, du.depth, _u, Md, du.data)) : bt.texImage3D(le1.TEXTURE_3D, 0, Nd, du.width, du.height, du.depth, 0, _u, Md, du.data);
                            else if (sc.isFramebufferTexture) {
                                if (jd) {
                                    if (Od) bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, du.width, du.height);
                                    else {
                                        let vt = du.width, ls = du.height;
                                        for(let ho = 0; ho < Gd; ho++)bt.texImage2D(le1.TEXTURE_2D, ho, Nd, vt, ls, 0, _u, Md, null), vt >>= 1, ls >>= 1;
                                    }
                                }
                            } else if (Rd.length > 0) {
                                if (Od && jd) {
                                    const vt = getDimensions(Rd[0]);
                                    bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, vt.width, vt.height);
                                }
                                for(let vt = 0, ls = Rd.length; vt < ls; vt++)Ld = Rd[vt], Od ? Ud && bt.texSubImage2D(le1.TEXTURE_2D, vt, 0, 0, _u, Md, Ld) : bt.texImage2D(le1.TEXTURE_2D, vt, Nd, _u, Md, Ld);
                                sc.generateMipmaps = !1;
                            } else if (Od) {
                                if (jd) {
                                    const vt = getDimensions(du);
                                    bt.texStorage2D(le1.TEXTURE_2D, Gd, Nd, vt.width, vt.height);
                                }
                                Ud && bt.texSubImage2D(le1.TEXTURE_2D, 0, 0, 0, _u, Md, du);
                            } else bt.texImage2D(le1.TEXTURE_2D, 0, Nd, _u, Md, du);
                            textureNeedsGenerateMipmaps(sc) && generateMipmap(mc), Ec.__version = Ac.version, sc.onUpdate && sc.onUpdate(sc);
                        }
                        vt.__version = sc.version;
                    }
                    function setupFrameBufferTexture(vt, ls, Dl, sc, mc, gc) {
                        const Ac = Fl.convert(Dl.format, Dl.colorSpace), Ec = Fl.convert(Dl.type), kc = getInternalFormat(Dl.internalFormat, Ac, Ec, Dl.colorSpace), du = ho.get(ls), _u = ho.get(Dl);
                        if (_u.__renderTarget = ls, !du.__hasExternalTextures) {
                            const vt = Math.max(1, ls.width >> gc), ho = Math.max(1, ls.height >> gc);
                            mc === le1.TEXTURE_3D || mc === le1.TEXTURE_2D_ARRAY ? bt.texImage3D(mc, gc, kc, vt, ho, ls.depth, 0, Ac, Ec, null) : bt.texImage2D(mc, gc, kc, vt, ho, 0, Ac, Ec, null);
                        }
                        bt.bindFramebuffer(le1.FRAMEBUFFER, vt), useMultisampledRTT(ls) ? uc.framebufferTexture2DMultisampleEXT(le1.FRAMEBUFFER, sc, mc, _u.__webglTexture, 0, getRenderTargetSamples(ls)) : (mc === le1.TEXTURE_2D || mc >= le1.TEXTURE_CUBE_MAP_POSITIVE_X && mc <= le1.TEXTURE_CUBE_MAP_NEGATIVE_Z) && le1.framebufferTexture2D(le1.FRAMEBUFFER, sc, mc, _u.__webglTexture, gc), bt.bindFramebuffer(le1.FRAMEBUFFER, null);
                    }
                    function setupRenderBufferStorage(vt, bt, ls) {
                        if (le1.bindRenderbuffer(le1.RENDERBUFFER, vt), bt.depthBuffer) {
                            const ho = bt.depthTexture, Dl = ho && ho.isDepthTexture ? ho.type : null, Fl = getInternalDepthFormat(bt.stencilBuffer, Dl), sc = bt.stencilBuffer ? le1.DEPTH_STENCIL_ATTACHMENT : le1.DEPTH_ATTACHMENT, mc = getRenderTargetSamples(bt);
                            useMultisampledRTT(bt) ? uc.renderbufferStorageMultisampleEXT(le1.RENDERBUFFER, mc, Fl, bt.width, bt.height) : ls ? le1.renderbufferStorageMultisample(le1.RENDERBUFFER, mc, Fl, bt.width, bt.height) : le1.renderbufferStorage(le1.RENDERBUFFER, Fl, bt.width, bt.height), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, sc, le1.RENDERBUFFER, vt);
                        } else {
                            const vt = bt.textures;
                            for(let ho = 0; ho < vt.length; ho++){
                                const Dl = vt[ho], sc = Fl.convert(Dl.format, Dl.colorSpace), mc = Fl.convert(Dl.type), gc = getInternalFormat(Dl.internalFormat, sc, mc, Dl.colorSpace), Ac = getRenderTargetSamples(bt);
                                ls && !1 === useMultisampledRTT(bt) ? le1.renderbufferStorageMultisample(le1.RENDERBUFFER, Ac, gc, bt.width, bt.height) : useMultisampledRTT(bt) ? uc.renderbufferStorageMultisampleEXT(le1.RENDERBUFFER, Ac, gc, bt.width, bt.height) : le1.renderbufferStorage(le1.RENDERBUFFER, gc, bt.width, bt.height);
                            }
                        }
                        le1.bindRenderbuffer(le1.RENDERBUFFER, null);
                    }
                    function setupDepthTexture(vt, Dl) {
                        if (Dl && Dl.isWebGLCubeRenderTarget) throw new Error("Depth Texture with cube render targets is not supported");
                        if (bt.bindFramebuffer(le1.FRAMEBUFFER, vt), !Dl.depthTexture || !Dl.depthTexture.isDepthTexture) throw new Error("renderTarget.depthTexture must be an instance of THREE.DepthTexture");
                        const Fl = ho.get(Dl.depthTexture);
                        Fl.__renderTarget = Dl, Fl.__webglTexture && Dl.depthTexture.image.width === Dl.width && Dl.depthTexture.image.height === Dl.height || (Dl.depthTexture.image.width = Dl.width, Dl.depthTexture.image.height = Dl.height, Dl.depthTexture.needsUpdate = !0), setTexture2D(Dl.depthTexture, 0);
                        const sc = Fl.__webglTexture, mc = getRenderTargetSamples(Dl);
                        if (Dl.depthTexture.format === ls.zdS) useMultisampledRTT(Dl) ? uc.framebufferTexture2DMultisampleEXT(le1.FRAMEBUFFER, le1.DEPTH_ATTACHMENT, le1.TEXTURE_2D, sc, 0, mc) : le1.framebufferTexture2D(le1.FRAMEBUFFER, le1.DEPTH_ATTACHMENT, le1.TEXTURE_2D, sc, 0);
                        else {
                            if (Dl.depthTexture.format !== ls.dcC) throw new Error("Unknown depthTexture format");
                            useMultisampledRTT(Dl) ? uc.framebufferTexture2DMultisampleEXT(le1.FRAMEBUFFER, le1.DEPTH_STENCIL_ATTACHMENT, le1.TEXTURE_2D, sc, 0, mc) : le1.framebufferTexture2D(le1.FRAMEBUFFER, le1.DEPTH_STENCIL_ATTACHMENT, le1.TEXTURE_2D, sc, 0);
                        }
                    }
                    function setupDepthRenderbuffer(vt) {
                        const ls = ho.get(vt), Dl = !0 === vt.isWebGLCubeRenderTarget;
                        if (ls.__boundDepthTexture !== vt.depthTexture) {
                            const le1 = vt.depthTexture;
                            if (ls.__depthDisposeCallback && ls.__depthDisposeCallback(), le1) {
                                const disposeEvent = ()=>{
                                    delete ls.__boundDepthTexture, delete ls.__depthDisposeCallback, le1.removeEventListener("dispose", disposeEvent);
                                };
                                le1.addEventListener("dispose", disposeEvent), ls.__depthDisposeCallback = disposeEvent;
                            }
                            ls.__boundDepthTexture = le1;
                        }
                        if (vt.depthTexture && !ls.__autoAllocateDepthBuffer) {
                            if (Dl) throw new Error("target.depthTexture not supported in Cube render targets");
                            const le1 = vt.texture.mipmaps;
                            le1 && le1.length > 0 ? setupDepthTexture(ls.__webglFramebuffer[0], vt) : setupDepthTexture(ls.__webglFramebuffer, vt);
                        } else if (Dl) {
                            ls.__webglDepthbuffer = [];
                            for(let ho = 0; ho < 6; ho++)if (bt.bindFramebuffer(le1.FRAMEBUFFER, ls.__webglFramebuffer[ho]), void 0 === ls.__webglDepthbuffer[ho]) ls.__webglDepthbuffer[ho] = le1.createRenderbuffer(), setupRenderBufferStorage(ls.__webglDepthbuffer[ho], vt, !1);
                            else {
                                const bt = vt.stencilBuffer ? le1.DEPTH_STENCIL_ATTACHMENT : le1.DEPTH_ATTACHMENT, Dl = ls.__webglDepthbuffer[ho];
                                le1.bindRenderbuffer(le1.RENDERBUFFER, Dl), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, bt, le1.RENDERBUFFER, Dl);
                            }
                        } else {
                            const ho = vt.texture.mipmaps;
                            if (ho && ho.length > 0 ? bt.bindFramebuffer(le1.FRAMEBUFFER, ls.__webglFramebuffer[0]) : bt.bindFramebuffer(le1.FRAMEBUFFER, ls.__webglFramebuffer), void 0 === ls.__webglDepthbuffer) ls.__webglDepthbuffer = le1.createRenderbuffer(), setupRenderBufferStorage(ls.__webglDepthbuffer, vt, !1);
                            else {
                                const bt = vt.stencilBuffer ? le1.DEPTH_STENCIL_ATTACHMENT : le1.DEPTH_ATTACHMENT, ho = ls.__webglDepthbuffer;
                                le1.bindRenderbuffer(le1.RENDERBUFFER, ho), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, bt, le1.RENDERBUFFER, ho);
                            }
                        }
                        bt.bindFramebuffer(le1.FRAMEBUFFER, null);
                    }
                    const Rd = [], Od = [];
                    function getRenderTargetSamples(le1) {
                        return Math.min(Dl.maxSamples, le1.samples);
                    }
                    function useMultisampledRTT(le1) {
                        const bt = ho.get(le1);
                        return le1.samples > 0 && !0 === vt.has("WEBGL_multisampled_render_to_texture") && !1 !== bt.__useRenderToTexture;
                    }
                    function verifyColorSpace(le1, vt) {
                        const bt = le1.colorSpace, ho = le1.format, Dl = le1.type;
                        return !0 === le1.isCompressedTexture || !0 === le1.isVideoTexture || bt !== ls.Zr2 && bt !== ls.jf0 && (ls.ppV.getTransfer(bt) === ls.KLL ? ho === ls.GWd && Dl === ls.OUM || console.warn("THREE.WebGLTextures: sRGB encoded textures have to use RGBAFormat and UnsignedByteType.") : console.error("THREE.WebGLTextures: Unsupported texture color space:", bt)), vt;
                    }
                    function getDimensions(le1) {
                        return "undefined" !== typeof HTMLImageElement && le1 instanceof HTMLImageElement ? (gc.width = le1.naturalWidth || le1.width, gc.height = le1.naturalHeight || le1.height) : "undefined" !== typeof VideoFrame && le1 instanceof VideoFrame ? (gc.width = le1.displayWidth, gc.height = le1.displayHeight) : (gc.width = le1.width, gc.height = le1.height), gc;
                    }
                    this.allocateTextureUnit = function() {
                        const le1 = _u;
                        return le1 >= Dl.maxTextures && console.warn("THREE.WebGLTextures: Trying to use " + le1 + " texture units while this GPU supports only " + Dl.maxTextures), _u += 1, le1;
                    }, this.resetTextureUnits = function() {
                        _u = 0;
                    }, this.setTexture2D = setTexture2D, this.setTexture2DArray = function(vt, ls) {
                        const Dl = ho.get(vt);
                        !1 === vt.isRenderTargetTexture && vt.version > 0 && Dl.__version !== vt.version ? uploadTexture(Dl, vt, ls) : bt.bindTexture(le1.TEXTURE_2D_ARRAY, Dl.__webglTexture, le1.TEXTURE0 + ls);
                    }, this.setTexture3D = function(vt, ls) {
                        const Dl = ho.get(vt);
                        !1 === vt.isRenderTargetTexture && vt.version > 0 && Dl.__version !== vt.version ? uploadTexture(Dl, vt, ls) : bt.bindTexture(le1.TEXTURE_3D, Dl.__webglTexture, le1.TEXTURE0 + ls);
                    }, this.setTextureCube = function(vt, sc) {
                        const uc = ho.get(vt);
                        vt.version > 0 && uc.__version !== vt.version ? function(vt, sc, uc) {
                            if (6 !== sc.image.length) return;
                            const mc = initTexture(vt, sc), gc = sc.source;
                            bt.bindTexture(le1.TEXTURE_CUBE_MAP, vt.__webglTexture, le1.TEXTURE0 + uc);
                            const Ac = ho.get(gc);
                            if (gc.version !== Ac.__version || !0 === mc) {
                                bt.activeTexture(le1.TEXTURE0 + uc);
                                const vt = ls.ppV.getPrimaries(ls.ppV.workingColorSpace), ho = sc.colorSpace === ls.jf0 ? null : ls.ppV.getPrimaries(sc.colorSpace), Ec = sc.colorSpace === ls.jf0 || vt === ho ? le1.NONE : le1.BROWSER_DEFAULT_WEBGL;
                                le1.pixelStorei(le1.UNPACK_FLIP_Y_WEBGL, sc.flipY), le1.pixelStorei(le1.UNPACK_PREMULTIPLY_ALPHA_WEBGL, sc.premultiplyAlpha), le1.pixelStorei(le1.UNPACK_ALIGNMENT, sc.unpackAlignment), le1.pixelStorei(le1.UNPACK_COLORSPACE_CONVERSION_WEBGL, Ec);
                                const kc = sc.isCompressedTexture || sc.image[0].isCompressedTexture, du = sc.image[0] && sc.image[0].isDataTexture, _u = [];
                                for(let le1 = 0; le1 < 6; le1++)_u[le1] = kc || du ? du ? sc.image[le1].image : sc.image[le1] : resizeImage(sc.image[le1], !0, Dl.maxCubemapSize), _u[le1] = verifyColorSpace(sc, _u[le1]);
                                const Md = _u[0], Ld = Fl.convert(sc.format, sc.colorSpace), Nd = Fl.convert(sc.type), Rd = getInternalFormat(sc.internalFormat, Ld, Nd, sc.colorSpace), Od = !0 !== sc.isVideoTexture, jd = void 0 === Ac.__version || !0 === mc, Ud = gc.dataReady;
                                let Gd, qd = getMipLevels(sc, Md);
                                if (setTextureParameters(le1.TEXTURE_CUBE_MAP, sc), kc) {
                                    Od && jd && bt.texStorage2D(le1.TEXTURE_CUBE_MAP, qd, Rd, Md.width, Md.height);
                                    for(let vt = 0; vt < 6; vt++){
                                        Gd = _u[vt].mipmaps;
                                        for(let ho = 0; ho < Gd.length; ho++){
                                            const Dl = Gd[ho];
                                            sc.format !== ls.GWd ? null !== Ld ? Od ? Ud && bt.compressedTexSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ho, 0, 0, Dl.width, Dl.height, Ld, Dl.data) : bt.compressedTexImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ho, Rd, Dl.width, Dl.height, 0, Dl.data) : console.warn("THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()") : Od ? Ud && bt.texSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ho, 0, 0, Dl.width, Dl.height, Ld, Nd, Dl.data) : bt.texImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ho, Rd, Dl.width, Dl.height, 0, Ld, Nd, Dl.data);
                                        }
                                    }
                                } else {
                                    if (Gd = sc.mipmaps, Od && jd) {
                                        Gd.length > 0 && qd++;
                                        const vt = getDimensions(_u[0]);
                                        bt.texStorage2D(le1.TEXTURE_CUBE_MAP, qd, Rd, vt.width, vt.height);
                                    }
                                    for(let vt = 0; vt < 6; vt++)if (du) {
                                        Od ? Ud && bt.texSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, 0, 0, 0, _u[vt].width, _u[vt].height, Ld, Nd, _u[vt].data) : bt.texImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, 0, Rd, _u[vt].width, _u[vt].height, 0, Ld, Nd, _u[vt].data);
                                        for(let ls = 0; ls < Gd.length; ls++){
                                            const ho = Gd[ls].image[vt].image;
                                            Od ? Ud && bt.texSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ls + 1, 0, 0, ho.width, ho.height, Ld, Nd, ho.data) : bt.texImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ls + 1, Rd, ho.width, ho.height, 0, Ld, Nd, ho.data);
                                        }
                                    } else {
                                        Od ? Ud && bt.texSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, 0, 0, 0, Ld, Nd, _u[vt]) : bt.texImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, 0, Rd, Ld, Nd, _u[vt]);
                                        for(let ls = 0; ls < Gd.length; ls++){
                                            const ho = Gd[ls];
                                            Od ? Ud && bt.texSubImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ls + 1, 0, 0, Ld, Nd, ho.image[vt]) : bt.texImage2D(le1.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ls + 1, Rd, Ld, Nd, ho.image[vt]);
                                        }
                                    }
                                }
                                textureNeedsGenerateMipmaps(sc) && generateMipmap(le1.TEXTURE_CUBE_MAP), Ac.__version = gc.version, sc.onUpdate && sc.onUpdate(sc);
                            }
                            vt.__version = sc.version;
                        }(uc, vt, sc) : bt.bindTexture(le1.TEXTURE_CUBE_MAP, uc.__webglTexture, le1.TEXTURE0 + sc);
                    }, this.rebindTextures = function(vt, bt, ls) {
                        const Dl = ho.get(vt);
                        void 0 !== bt && setupFrameBufferTexture(Dl.__webglFramebuffer, vt, vt.texture, le1.COLOR_ATTACHMENT0, le1.TEXTURE_2D, 0), void 0 !== ls && setupDepthRenderbuffer(vt);
                    }, this.setupRenderTarget = function(vt) {
                        const ls = vt.texture, Dl = ho.get(vt), uc = ho.get(ls);
                        vt.addEventListener("dispose", onRenderTargetDispose);
                        const mc = vt.textures, gc = !0 === vt.isWebGLCubeRenderTarget, Ac = mc.length > 1;
                        if (Ac || (void 0 === uc.__webglTexture && (uc.__webglTexture = le1.createTexture()), uc.__version = ls.version, sc.memory.textures++), gc) {
                            Dl.__webglFramebuffer = [];
                            for(let vt = 0; vt < 6; vt++)if (ls.mipmaps && ls.mipmaps.length > 0) {
                                Dl.__webglFramebuffer[vt] = [];
                                for(let bt = 0; bt < ls.mipmaps.length; bt++)Dl.__webglFramebuffer[vt][bt] = le1.createFramebuffer();
                            } else Dl.__webglFramebuffer[vt] = le1.createFramebuffer();
                        } else {
                            if (ls.mipmaps && ls.mipmaps.length > 0) {
                                Dl.__webglFramebuffer = [];
                                for(let vt = 0; vt < ls.mipmaps.length; vt++)Dl.__webglFramebuffer[vt] = le1.createFramebuffer();
                            } else Dl.__webglFramebuffer = le1.createFramebuffer();
                            if (Ac) for(let vt = 0, bt = mc.length; vt < bt; vt++){
                                const bt = ho.get(mc[vt]);
                                void 0 === bt.__webglTexture && (bt.__webglTexture = le1.createTexture(), sc.memory.textures++);
                            }
                            if (vt.samples > 0 && !1 === useMultisampledRTT(vt)) {
                                Dl.__webglMultisampledFramebuffer = le1.createFramebuffer(), Dl.__webglColorRenderbuffer = [], bt.bindFramebuffer(le1.FRAMEBUFFER, Dl.__webglMultisampledFramebuffer);
                                for(let bt = 0; bt < mc.length; bt++){
                                    const ls = mc[bt];
                                    Dl.__webglColorRenderbuffer[bt] = le1.createRenderbuffer(), le1.bindRenderbuffer(le1.RENDERBUFFER, Dl.__webglColorRenderbuffer[bt]);
                                    const ho = Fl.convert(ls.format, ls.colorSpace), sc = Fl.convert(ls.type), uc = getInternalFormat(ls.internalFormat, ho, sc, ls.colorSpace, !0 === vt.isXRRenderTarget), gc = getRenderTargetSamples(vt);
                                    le1.renderbufferStorageMultisample(le1.RENDERBUFFER, gc, uc, vt.width, vt.height), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, le1.COLOR_ATTACHMENT0 + bt, le1.RENDERBUFFER, Dl.__webglColorRenderbuffer[bt]);
                                }
                                le1.bindRenderbuffer(le1.RENDERBUFFER, null), vt.depthBuffer && (Dl.__webglDepthRenderbuffer = le1.createRenderbuffer(), setupRenderBufferStorage(Dl.__webglDepthRenderbuffer, vt, !0)), bt.bindFramebuffer(le1.FRAMEBUFFER, null);
                            }
                        }
                        if (gc) {
                            bt.bindTexture(le1.TEXTURE_CUBE_MAP, uc.__webglTexture), setTextureParameters(le1.TEXTURE_CUBE_MAP, ls);
                            for(let bt = 0; bt < 6; bt++)if (ls.mipmaps && ls.mipmaps.length > 0) for(let ho = 0; ho < ls.mipmaps.length; ho++)setupFrameBufferTexture(Dl.__webglFramebuffer[bt][ho], vt, ls, le1.COLOR_ATTACHMENT0, le1.TEXTURE_CUBE_MAP_POSITIVE_X + bt, ho);
                            else setupFrameBufferTexture(Dl.__webglFramebuffer[bt], vt, ls, le1.COLOR_ATTACHMENT0, le1.TEXTURE_CUBE_MAP_POSITIVE_X + bt, 0);
                            textureNeedsGenerateMipmaps(ls) && generateMipmap(le1.TEXTURE_CUBE_MAP), bt.unbindTexture();
                        } else if (Ac) {
                            for(let ls = 0, Fl = mc.length; ls < Fl; ls++){
                                const Fl = mc[ls], sc = ho.get(Fl);
                                let uc = le1.TEXTURE_2D;
                                (vt.isWebGL3DRenderTarget || vt.isWebGLArrayRenderTarget) && (uc = vt.isWebGL3DRenderTarget ? le1.TEXTURE_3D : le1.TEXTURE_2D_ARRAY), bt.bindTexture(uc, sc.__webglTexture), setTextureParameters(uc, Fl), setupFrameBufferTexture(Dl.__webglFramebuffer, vt, Fl, le1.COLOR_ATTACHMENT0 + ls, uc, 0), textureNeedsGenerateMipmaps(Fl) && generateMipmap(uc);
                            }
                            bt.unbindTexture();
                        } else {
                            let ho = le1.TEXTURE_2D;
                            if ((vt.isWebGL3DRenderTarget || vt.isWebGLArrayRenderTarget) && (ho = vt.isWebGL3DRenderTarget ? le1.TEXTURE_3D : le1.TEXTURE_2D_ARRAY), bt.bindTexture(ho, uc.__webglTexture), setTextureParameters(ho, ls), ls.mipmaps && ls.mipmaps.length > 0) for(let bt = 0; bt < ls.mipmaps.length; bt++)setupFrameBufferTexture(Dl.__webglFramebuffer[bt], vt, ls, le1.COLOR_ATTACHMENT0, ho, bt);
                            else setupFrameBufferTexture(Dl.__webglFramebuffer, vt, ls, le1.COLOR_ATTACHMENT0, ho, 0);
                            textureNeedsGenerateMipmaps(ls) && generateMipmap(ho), bt.unbindTexture();
                        }
                        vt.depthBuffer && setupDepthRenderbuffer(vt);
                    }, this.updateRenderTargetMipmap = function(le1) {
                        const vt = le1.textures;
                        for(let ls = 0, Dl = vt.length; ls < Dl; ls++){
                            const Dl = vt[ls];
                            if (textureNeedsGenerateMipmaps(Dl)) {
                                const vt = getTargetType(le1), ls = ho.get(Dl).__webglTexture;
                                bt.bindTexture(vt, ls), generateMipmap(vt), bt.unbindTexture();
                            }
                        }
                    }, this.updateMultisampleRenderTarget = function(vt) {
                        if (vt.samples > 0) {
                            if (!1 === useMultisampledRTT(vt)) {
                                const ls = vt.textures, Dl = vt.width, Fl = vt.height;
                                let sc = le1.COLOR_BUFFER_BIT;
                                const uc = vt.stencilBuffer ? le1.DEPTH_STENCIL_ATTACHMENT : le1.DEPTH_ATTACHMENT, gc = ho.get(vt), Ac = ls.length > 1;
                                if (Ac) for(let vt = 0; vt < ls.length; vt++)bt.bindFramebuffer(le1.FRAMEBUFFER, gc.__webglMultisampledFramebuffer), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, le1.COLOR_ATTACHMENT0 + vt, le1.RENDERBUFFER, null), bt.bindFramebuffer(le1.FRAMEBUFFER, gc.__webglFramebuffer), le1.framebufferTexture2D(le1.DRAW_FRAMEBUFFER, le1.COLOR_ATTACHMENT0 + vt, le1.TEXTURE_2D, null, 0);
                                bt.bindFramebuffer(le1.READ_FRAMEBUFFER, gc.__webglMultisampledFramebuffer);
                                const Ec = vt.texture.mipmaps;
                                Ec && Ec.length > 0 ? bt.bindFramebuffer(le1.DRAW_FRAMEBUFFER, gc.__webglFramebuffer[0]) : bt.bindFramebuffer(le1.DRAW_FRAMEBUFFER, gc.__webglFramebuffer);
                                for(let bt = 0; bt < ls.length; bt++){
                                    if (vt.resolveDepthBuffer && (vt.depthBuffer && (sc |= le1.DEPTH_BUFFER_BIT), vt.stencilBuffer && vt.resolveStencilBuffer && (sc |= le1.STENCIL_BUFFER_BIT)), Ac) {
                                        le1.framebufferRenderbuffer(le1.READ_FRAMEBUFFER, le1.COLOR_ATTACHMENT0, le1.RENDERBUFFER, gc.__webglColorRenderbuffer[bt]);
                                        const vt = ho.get(ls[bt]).__webglTexture;
                                        le1.framebufferTexture2D(le1.DRAW_FRAMEBUFFER, le1.COLOR_ATTACHMENT0, le1.TEXTURE_2D, vt, 0);
                                    }
                                    le1.blitFramebuffer(0, 0, Dl, Fl, 0, 0, Dl, Fl, sc, le1.NEAREST), !0 === mc && (Rd.length = 0, Od.length = 0, Rd.push(le1.COLOR_ATTACHMENT0 + bt), vt.depthBuffer && !1 === vt.resolveDepthBuffer && (Rd.push(uc), Od.push(uc), le1.invalidateFramebuffer(le1.DRAW_FRAMEBUFFER, Od)), le1.invalidateFramebuffer(le1.READ_FRAMEBUFFER, Rd));
                                }
                                if (bt.bindFramebuffer(le1.READ_FRAMEBUFFER, null), bt.bindFramebuffer(le1.DRAW_FRAMEBUFFER, null), Ac) for(let vt = 0; vt < ls.length; vt++){
                                    bt.bindFramebuffer(le1.FRAMEBUFFER, gc.__webglMultisampledFramebuffer), le1.framebufferRenderbuffer(le1.FRAMEBUFFER, le1.COLOR_ATTACHMENT0 + vt, le1.RENDERBUFFER, gc.__webglColorRenderbuffer[vt]);
                                    const Dl = ho.get(ls[vt]).__webglTexture;
                                    bt.bindFramebuffer(le1.FRAMEBUFFER, gc.__webglFramebuffer), le1.framebufferTexture2D(le1.DRAW_FRAMEBUFFER, le1.COLOR_ATTACHMENT0 + vt, le1.TEXTURE_2D, Dl, 0);
                                }
                                bt.bindFramebuffer(le1.DRAW_FRAMEBUFFER, gc.__webglMultisampledFramebuffer);
                            } else if (vt.depthBuffer && !1 === vt.resolveDepthBuffer && mc) {
                                const bt = vt.stencilBuffer ? le1.DEPTH_STENCIL_ATTACHMENT : le1.DEPTH_ATTACHMENT;
                                le1.invalidateFramebuffer(le1.DRAW_FRAMEBUFFER, [
                                    bt
                                ]);
                            }
                        }
                    }, this.setupDepthRenderbuffer = setupDepthRenderbuffer, this.setupFrameBufferTexture = setupFrameBufferTexture, this.useMultisampledRTT = useMultisampledRTT;
                }
                function WebGLUtils(le1, vt) {
                    return {
                        convert: function(bt, ho) {
                            let Dl;
                            void 0 === ho && (ho = ls.jf0);
                            const Fl = ls.ppV.getTransfer(ho);
                            if (bt === ls.OUM) return le1.UNSIGNED_BYTE;
                            if (bt === ls.Wew) return le1.UNSIGNED_SHORT_4_4_4_4;
                            if (bt === ls.gJ2) return le1.UNSIGNED_SHORT_5_5_5_1;
                            if (bt === ls.Dmk) return le1.UNSIGNED_INT_5_9_9_9_REV;
                            if (bt === ls.tJf) return le1.BYTE;
                            if (bt === ls.fBL) return le1.SHORT;
                            if (bt === ls.cHt) return le1.UNSIGNED_SHORT;
                            if (bt === ls.Yuy) return le1.INT;
                            if (bt === ls.bkx) return le1.UNSIGNED_INT;
                            if (bt === ls.RQf) return le1.FLOAT;
                            if (bt === ls.ix0) return le1.HALF_FLOAT;
                            if (bt === ls.wrO) return le1.ALPHA;
                            if (bt === ls.HIg) return le1.RGB;
                            if (bt === ls.GWd) return le1.RGBA;
                            if (bt === ls.zdS) return le1.DEPTH_COMPONENT;
                            if (bt === ls.dcC) return le1.DEPTH_STENCIL;
                            if (bt === ls.VT0) return le1.RED;
                            if (bt === ls.ZQM) return le1.RED_INTEGER;
                            if (bt === ls.paN) return le1.RG;
                            if (bt === ls.TkQ) return le1.RG_INTEGER;
                            if (bt === ls.c90) return le1.RGBA_INTEGER;
                            if (bt === ls.IE4 || bt === ls.Nz6 || bt === ls.jR7 || bt === ls.BXX) {
                                if (Fl === ls.KLL) {
                                    if (Dl = vt.get("WEBGL_compressed_texture_s3tc_srgb"), null === Dl) return null;
                                    if (bt === ls.IE4) return Dl.COMPRESSED_SRGB_S3TC_DXT1_EXT;
                                    if (bt === ls.Nz6) return Dl.COMPRESSED_SRGB_ALPHA_S3TC_DXT1_EXT;
                                    if (bt === ls.jR7) return Dl.COMPRESSED_SRGB_ALPHA_S3TC_DXT3_EXT;
                                    if (bt === ls.BXX) return Dl.COMPRESSED_SRGB_ALPHA_S3TC_DXT5_EXT;
                                } else {
                                    if (Dl = vt.get("WEBGL_compressed_texture_s3tc"), null === Dl) return null;
                                    if (bt === ls.IE4) return Dl.COMPRESSED_RGB_S3TC_DXT1_EXT;
                                    if (bt === ls.Nz6) return Dl.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                                    if (bt === ls.jR7) return Dl.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                                    if (bt === ls.BXX) return Dl.COMPRESSED_RGBA_S3TC_DXT5_EXT;
                                }
                            }
                            if (bt === ls.k6Q || bt === ls.kTp || bt === ls.HXV || bt === ls.pBf) {
                                if (Dl = vt.get("WEBGL_compressed_texture_pvrtc"), null === Dl) return null;
                                if (bt === ls.k6Q) return Dl.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                                if (bt === ls.kTp) return Dl.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                                if (bt === ls.HXV) return Dl.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                                if (bt === ls.pBf) return Dl.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
                            }
                            if (bt === ls.CVz || bt === ls.Riy || bt === ls.KDk) {
                                if (Dl = vt.get("WEBGL_compressed_texture_etc"), null === Dl) return null;
                                if (bt === ls.CVz || bt === ls.Riy) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ETC2 : Dl.COMPRESSED_RGB8_ETC2;
                                if (bt === ls.KDk) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ETC2_EAC : Dl.COMPRESSED_RGBA8_ETC2_EAC;
                            }
                            if (bt === ls.qa3 || bt === ls.B_h || bt === ls.czI || bt === ls.rSH || bt === ls.Qrf || bt === ls.psI || bt === ls.a5J || bt === ls._QJ || bt === ls.uB5 || bt === ls.lyL || bt === ls.bC7 || bt === ls.y3Z || bt === ls.ojs || bt === ls.S$4) {
                                if (Dl = vt.get("WEBGL_compressed_texture_astc"), null === Dl) return null;
                                if (bt === ls.qa3) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_4x4_KHR : Dl.COMPRESSED_RGBA_ASTC_4x4_KHR;
                                if (bt === ls.B_h) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_5x4_KHR : Dl.COMPRESSED_RGBA_ASTC_5x4_KHR;
                                if (bt === ls.czI) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_5x5_KHR : Dl.COMPRESSED_RGBA_ASTC_5x5_KHR;
                                if (bt === ls.rSH) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_6x5_KHR : Dl.COMPRESSED_RGBA_ASTC_6x5_KHR;
                                if (bt === ls.Qrf) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_6x6_KHR : Dl.COMPRESSED_RGBA_ASTC_6x6_KHR;
                                if (bt === ls.psI) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_8x5_KHR : Dl.COMPRESSED_RGBA_ASTC_8x5_KHR;
                                if (bt === ls.a5J) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_8x6_KHR : Dl.COMPRESSED_RGBA_ASTC_8x6_KHR;
                                if (bt === ls._QJ) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_8x8_KHR : Dl.COMPRESSED_RGBA_ASTC_8x8_KHR;
                                if (bt === ls.uB5) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_10x5_KHR : Dl.COMPRESSED_RGBA_ASTC_10x5_KHR;
                                if (bt === ls.lyL) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_10x6_KHR : Dl.COMPRESSED_RGBA_ASTC_10x6_KHR;
                                if (bt === ls.bC7) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_10x8_KHR : Dl.COMPRESSED_RGBA_ASTC_10x8_KHR;
                                if (bt === ls.y3Z) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_10x10_KHR : Dl.COMPRESSED_RGBA_ASTC_10x10_KHR;
                                if (bt === ls.ojs) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_12x10_KHR : Dl.COMPRESSED_RGBA_ASTC_12x10_KHR;
                                if (bt === ls.S$4) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB8_ALPHA8_ASTC_12x12_KHR : Dl.COMPRESSED_RGBA_ASTC_12x12_KHR;
                            }
                            if (bt === ls.Fn || bt === ls.H23 || bt === ls.W9U) {
                                if (Dl = vt.get("EXT_texture_compression_bptc"), null === Dl) return null;
                                if (bt === ls.Fn) return Fl === ls.KLL ? Dl.COMPRESSED_SRGB_ALPHA_BPTC_UNORM_EXT : Dl.COMPRESSED_RGBA_BPTC_UNORM_EXT;
                                if (bt === ls.H23) return Dl.COMPRESSED_RGB_BPTC_SIGNED_FLOAT_EXT;
                                if (bt === ls.W9U) return Dl.COMPRESSED_RGB_BPTC_UNSIGNED_FLOAT_EXT;
                            }
                            if (bt === ls.Kef || bt === ls.XG_ || bt === ls.HO_ || bt === ls.CWW) {
                                if (Dl = vt.get("EXT_texture_compression_rgtc"), null === Dl) return null;
                                if (bt === ls.Fn) return Dl.COMPRESSED_RED_RGTC1_EXT;
                                if (bt === ls.XG_) return Dl.COMPRESSED_SIGNED_RED_RGTC1_EXT;
                                if (bt === ls.HO_) return Dl.COMPRESSED_RED_GREEN_RGTC2_EXT;
                                if (bt === ls.CWW) return Dl.COMPRESSED_SIGNED_RED_GREEN_RGTC2_EXT;
                            }
                            return bt === ls.V3x ? le1.UNSIGNED_INT_24_8 : void 0 !== le1[bt] ? le1[bt] : null;
                        }
                    };
                }
                class ExternalTexture extends ls.gPd {
                    constructor(le1){
                        void 0 === le1 && (le1 = null), super(), this.sourceTexture = le1, this.isExternalTexture = !0;
                    }
                }
                class WebXRDepthSensing {
                    constructor(){
                        this.texture = null, this.mesh = null, this.depthNear = 0, this.depthFar = 0;
                    }
                    init(le1, vt) {
                        if (null === this.texture) {
                            const bt = new ExternalTexture(le1.texture);
                            le1.depthNear === vt.depthNear && le1.depthFar === vt.depthFar || (this.depthNear = le1.depthNear, this.depthFar = le1.depthFar), this.texture = bt;
                        }
                    }
                    getMesh(le1) {
                        if (null !== this.texture && null === this.mesh) {
                            const vt = le1.cameras[0].viewport, bt = new ls.BKk({
                                vertexShader: "\nvoid main() {\n\n\tgl_Position = vec4( position, 1.0 );\n\n}",
                                fragmentShader: "\nuniform sampler2DArray depthColor;\nuniform float depthWidth;\nuniform float depthHeight;\n\nvoid main() {\n\n\tvec2 coord = vec2( gl_FragCoord.x / depthWidth, gl_FragCoord.y / depthHeight );\n\n\tif ( coord.x >= 1.0 ) {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x - 1.0, coord.y, 1 ) ).r;\n\n\t} else {\n\n\t\tgl_FragDepth = texture( depthColor, vec3( coord.x, coord.y, 0 ) ).r;\n\n\t}\n\n}",
                                uniforms: {
                                    depthColor: {
                                        value: this.texture
                                    },
                                    depthWidth: {
                                        value: vt.z
                                    },
                                    depthHeight: {
                                        value: vt.w
                                    }
                                }
                            });
                            this.mesh = new ls.eaF(new ls.bdM(20, 20), bt);
                        }
                        return this.mesh;
                    }
                    reset() {
                        this.texture = null, this.mesh = null;
                    }
                    getDepthTexture() {
                        return this.texture;
                    }
                }
                class WebXRManager extends ls.Qev {
                    constructor(le1, vt){
                        super();
                        const bt = this;
                        let ho = null, Dl = 1, Fl = null, sc = "local-floor", uc = 1, mc = null, gc = null, Ac = null, Ec = null, kc = null, du = null;
                        const _u = new WebXRDepthSensing, Md = {}, Ld = vt.getContextAttributes();
                        let Nd = null, Rd = null;
                        const Od = [], jd = [], Ud = new ls.I9Y;
                        let Gd = null;
                        const qd = new ls.ubm;
                        qd.viewport = new ls.IUQ;
                        const Hd = new ls.ubm;
                        Hd.viewport = new ls.IUQ;
                        const Wd = [
                            qd,
                            Hd
                        ], Zd = new ls.nZQ;
                        let Yd = null, Qd = null;
                        function onSessionEvent(le1) {
                            const vt = jd.indexOf(le1.inputSource);
                            if (-1 === vt) return;
                            const bt = Od[vt];
                            void 0 !== bt && (bt.update(le1.inputSource, le1.frame, mc || Fl), bt.dispatchEvent({
                                type: le1.type,
                                data: le1.inputSource
                            }));
                        }
                        function onSessionEnd() {
                            ho.removeEventListener("select", onSessionEvent), ho.removeEventListener("selectstart", onSessionEvent), ho.removeEventListener("selectend", onSessionEvent), ho.removeEventListener("squeeze", onSessionEvent), ho.removeEventListener("squeezestart", onSessionEvent), ho.removeEventListener("squeezeend", onSessionEvent), ho.removeEventListener("end", onSessionEnd), ho.removeEventListener("inputsourceschange", onInputSourcesChange);
                            for(let le1 = 0; le1 < Od.length; le1++){
                                const vt = jd[le1];
                                null !== vt && (jd[le1] = null, Od[le1].disconnect(vt));
                            }
                            Yd = null, Qd = null, _u.reset();
                            for(const le1 in Md)delete Md[le1];
                            le1.setRenderTarget(Nd), kc = null, Ec = null, Ac = null, ho = null, Rd = null, $d.stop(), bt.isPresenting = !1, le1.setPixelRatio(Gd), le1.setSize(Ud.width, Ud.height, !1), bt.dispatchEvent({
                                type: "sessionend"
                            });
                        }
                        function onInputSourcesChange(le1) {
                            for(let vt = 0; vt < le1.removed.length; vt++){
                                const bt = le1.removed[vt], ls = jd.indexOf(bt);
                                ls >= 0 && (jd[ls] = null, Od[ls].disconnect(bt));
                            }
                            for(let vt = 0; vt < le1.added.length; vt++){
                                const bt = le1.added[vt];
                                let ls = jd.indexOf(bt);
                                if (-1 === ls) {
                                    for(let le1 = 0; le1 < Od.length; le1++){
                                        if (le1 >= jd.length) {
                                            jd.push(bt), ls = le1;
                                            break;
                                        }
                                        if (null === jd[le1]) {
                                            jd[le1] = bt, ls = le1;
                                            break;
                                        }
                                    }
                                    if (-1 === ls) break;
                                }
                                const ho = Od[ls];
                                ho && ho.connect(bt);
                            }
                        }
                        this.cameraAutoUpdate = !0, this.enabled = !1, this.isPresenting = !1, this.getController = function(le1) {
                            let vt = Od[le1];
                            return void 0 === vt && (vt = new ls.R3r, Od[le1] = vt), vt.getTargetRaySpace();
                        }, this.getControllerGrip = function(le1) {
                            let vt = Od[le1];
                            return void 0 === vt && (vt = new ls.R3r, Od[le1] = vt), vt.getGripSpace();
                        }, this.getHand = function(le1) {
                            let vt = Od[le1];
                            return void 0 === vt && (vt = new ls.R3r, Od[le1] = vt), vt.getHandSpace();
                        }, this.setFramebufferScaleFactor = function(le1) {
                            Dl = le1, !0 === bt.isPresenting && console.warn("THREE.WebXRManager: Cannot change framebuffer scale while presenting.");
                        }, this.setReferenceSpaceType = function(le1) {
                            sc = le1, !0 === bt.isPresenting && console.warn("THREE.WebXRManager: Cannot change reference space type while presenting.");
                        }, this.getReferenceSpace = function() {
                            return mc || Fl;
                        }, this.setReferenceSpace = function(le1) {
                            mc = le1;
                        }, this.getBaseLayer = function() {
                            return null !== Ec ? Ec : kc;
                        }, this.getBinding = function() {
                            return Ac;
                        }, this.getFrame = function() {
                            return du;
                        }, this.getSession = function() {
                            return ho;
                        }, this.setSession = async function(gc) {
                            if (ho = gc, null !== ho) {
                                Nd = le1.getRenderTarget(), ho.addEventListener("select", onSessionEvent), ho.addEventListener("selectstart", onSessionEvent), ho.addEventListener("selectend", onSessionEvent), ho.addEventListener("squeeze", onSessionEvent), ho.addEventListener("squeezestart", onSessionEvent), ho.addEventListener("squeezeend", onSessionEvent), ho.addEventListener("end", onSessionEnd), ho.addEventListener("inputsourceschange", onInputSourcesChange), !0 !== Ld.xrCompatible && await vt.makeXRCompatible(), Gd = le1.getPixelRatio(), le1.getSize(Ud), "undefined" !== typeof XRWebGLBinding && (Ac = new XRWebGLBinding(ho, vt));
                                if (null !== Ac && "createProjectionLayer" in XRWebGLBinding.prototype) {
                                    let bt = null, Fl = null, sc = null;
                                    Ld.depth && (sc = Ld.stencil ? vt.DEPTH24_STENCIL8 : vt.DEPTH_COMPONENT24, bt = Ld.stencil ? ls.dcC : ls.zdS, Fl = Ld.stencil ? ls.V3x : ls.bkx);
                                    const uc = {
                                        colorFormat: vt.RGBA8,
                                        depthFormat: sc,
                                        scaleFactor: Dl
                                    };
                                    Ec = Ac.createProjectionLayer(uc), ho.updateRenderState({
                                        layers: [
                                            Ec
                                        ]
                                    }), le1.setPixelRatio(1), le1.setSize(Ec.textureWidth, Ec.textureHeight, !1), Rd = new ls.nWS(Ec.textureWidth, Ec.textureHeight, {
                                        format: ls.GWd,
                                        type: ls.OUM,
                                        depthTexture: new ls.VCu(Ec.textureWidth, Ec.textureHeight, Fl, void 0, void 0, void 0, void 0, void 0, void 0, bt),
                                        stencilBuffer: Ld.stencil,
                                        colorSpace: le1.outputColorSpace,
                                        samples: Ld.antialias ? 4 : 0,
                                        resolveDepthBuffer: !1 === Ec.ignoreDepthValues,
                                        resolveStencilBuffer: !1 === Ec.ignoreDepthValues
                                    });
                                } else {
                                    const bt = {
                                        antialias: Ld.antialias,
                                        alpha: !0,
                                        depth: Ld.depth,
                                        stencil: Ld.stencil,
                                        framebufferScaleFactor: Dl
                                    };
                                    kc = new XRWebGLLayer(ho, vt, bt), ho.updateRenderState({
                                        baseLayer: kc
                                    }), le1.setPixelRatio(1), le1.setSize(kc.framebufferWidth, kc.framebufferHeight, !1), Rd = new ls.nWS(kc.framebufferWidth, kc.framebufferHeight, {
                                        format: ls.GWd,
                                        type: ls.OUM,
                                        colorSpace: le1.outputColorSpace,
                                        stencilBuffer: Ld.stencil,
                                        resolveDepthBuffer: !1 === kc.ignoreDepthValues,
                                        resolveStencilBuffer: !1 === kc.ignoreDepthValues
                                    });
                                }
                                Rd.isXRRenderTarget = !0, this.setFoveation(uc), mc = null, Fl = await ho.requestReferenceSpace(sc), $d.setContext(ho), $d.start(), bt.isPresenting = !0, bt.dispatchEvent({
                                    type: "sessionstart"
                                });
                            }
                        }, this.getEnvironmentBlendMode = function() {
                            if (null !== ho) return ho.environmentBlendMode;
                        }, this.getDepthTexture = function() {
                            return _u.getDepthTexture();
                        };
                        const Xd = new ls.Pq0, Kd = new ls.Pq0;
                        function updateCamera(le1, vt) {
                            null === vt ? le1.matrixWorld.copy(le1.matrix) : le1.matrixWorld.multiplyMatrices(vt.matrixWorld, le1.matrix), le1.matrixWorldInverse.copy(le1.matrixWorld).invert();
                        }
                        this.updateCamera = function(le1) {
                            if (null === ho) return;
                            let vt = le1.near, bt = le1.far;
                            null !== _u.texture && (_u.depthNear > 0 && (vt = _u.depthNear), _u.depthFar > 0 && (bt = _u.depthFar)), Zd.near = Hd.near = qd.near = vt, Zd.far = Hd.far = qd.far = bt, Yd === Zd.near && Qd === Zd.far || (ho.updateRenderState({
                                depthNear: Zd.near,
                                depthFar: Zd.far
                            }), Yd = Zd.near, Qd = Zd.far), Zd.layers.mask = 6 | le1.layers.mask, qd.layers.mask = 3 & Zd.layers.mask, Hd.layers.mask = 5 & Zd.layers.mask;
                            const Dl = le1.parent, Fl = Zd.cameras;
                            updateCamera(Zd, Dl);
                            for(let ls = 0; ls < Fl.length; ls++)updateCamera(Fl[ls], Dl);
                            2 === Fl.length ? function(le1, vt, bt) {
                                Xd.setFromMatrixPosition(vt.matrixWorld), Kd.setFromMatrixPosition(bt.matrixWorld);
                                const ls = Xd.distanceTo(Kd), ho = vt.projectionMatrix.elements, Dl = bt.projectionMatrix.elements, Fl = ho[14] / (ho[10] - 1), sc = ho[14] / (ho[10] + 1), uc = (ho[9] + 1) / ho[5], mc = (ho[9] - 1) / ho[5], gc = (ho[8] - 1) / ho[0], Ac = (Dl[8] + 1) / Dl[0], Ec = Fl * gc, kc = Fl * Ac, du = ls / (-gc + Ac), _u = du * -gc;
                                if (vt.matrixWorld.decompose(le1.position, le1.quaternion, le1.scale), le1.translateX(_u), le1.translateZ(du), le1.matrixWorld.compose(le1.position, le1.quaternion, le1.scale), le1.matrixWorldInverse.copy(le1.matrixWorld).invert(), -1 === ho[10]) le1.projectionMatrix.copy(vt.projectionMatrix), le1.projectionMatrixInverse.copy(vt.projectionMatrixInverse);
                                else {
                                    const vt = Fl + du, bt = sc + du, ho = Ec - _u, Dl = kc + (ls - _u), gc = uc * sc / bt * vt, Ac = mc * sc / bt * vt;
                                    le1.projectionMatrix.makePerspective(ho, Dl, gc, Ac, vt, bt), le1.projectionMatrixInverse.copy(le1.projectionMatrix).invert();
                                }
                            }(Zd, qd, Hd) : Zd.projectionMatrix.copy(qd.projectionMatrix), function(le1, vt, bt) {
                                null === bt ? le1.matrix.copy(vt.matrixWorld) : (le1.matrix.copy(bt.matrixWorld), le1.matrix.invert(), le1.matrix.multiply(vt.matrixWorld));
                                le1.matrix.decompose(le1.position, le1.quaternion, le1.scale), le1.updateMatrixWorld(!0), le1.projectionMatrix.copy(vt.projectionMatrix), le1.projectionMatrixInverse.copy(vt.projectionMatrixInverse), le1.isPerspectiveCamera && (le1.fov = 2 * ls.a55 * Math.atan(1 / le1.projectionMatrix.elements[5]), le1.zoom = 1);
                            }(le1, Zd, Dl);
                        }, this.getCamera = function() {
                            return Zd;
                        }, this.getFoveation = function() {
                            if (null !== Ec || null !== kc) return uc;
                        }, this.setFoveation = function(le1) {
                            uc = le1, null !== Ec && (Ec.fixedFoveation = le1), null !== kc && void 0 !== kc.fixedFoveation && (kc.fixedFoveation = le1);
                        }, this.hasDepthSensing = function() {
                            return null !== _u.texture;
                        }, this.getDepthSensingMesh = function() {
                            return _u.getMesh(Zd);
                        }, this.getCameraTexture = function(le1) {
                            return Md[le1];
                        };
                        let Jd = null;
                        const $d = new WebGLAnimation;
                        $d.setAnimationLoop(function(vt, Dl) {
                            if (gc = Dl.getViewerPose(mc || Fl), du = Dl, null !== gc) {
                                const vt = gc.views;
                                null !== kc && (le1.setRenderTargetFramebuffer(Rd, kc.framebuffer), le1.setRenderTarget(Rd));
                                let bt = !1;
                                vt.length !== Zd.cameras.length && (Zd.cameras.length = 0, bt = !0);
                                for(let ho = 0; ho < vt.length; ho++){
                                    const Dl = vt[ho];
                                    let Fl = null;
                                    if (null !== kc) Fl = kc.getViewport(Dl);
                                    else {
                                        const vt = Ac.getViewSubImage(Ec, Dl);
                                        Fl = vt.viewport, 0 === ho && (le1.setRenderTargetTextures(Rd, vt.colorTexture, vt.depthStencilTexture), le1.setRenderTarget(Rd));
                                    }
                                    let sc = Wd[ho];
                                    void 0 === sc && (sc = new ls.ubm, sc.layers.enable(ho), sc.viewport = new ls.IUQ, Wd[ho] = sc), sc.matrix.fromArray(Dl.transform.matrix), sc.matrix.decompose(sc.position, sc.quaternion, sc.scale), sc.projectionMatrix.fromArray(Dl.projectionMatrix), sc.projectionMatrixInverse.copy(sc.projectionMatrix).invert(), sc.viewport.set(Fl.x, Fl.y, Fl.width, Fl.height), 0 === ho && (Zd.matrix.copy(sc.matrix), Zd.matrix.decompose(Zd.position, Zd.quaternion, Zd.scale)), !0 === bt && Zd.cameras.push(sc);
                                }
                                const Dl = ho.enabledFeatures;
                                if (Dl && Dl.includes("depth-sensing") && "gpu-optimized" == ho.depthUsage && Ac) {
                                    const le1 = Ac.getDepthInformation(vt[0]);
                                    le1 && le1.isValid && le1.texture && _u.init(le1, ho.renderState);
                                }
                                if (Dl && Dl.includes("camera-access") && (le1.state.unbindTexture(), Ac)) for(let le1 = 0; le1 < vt.length; le1++){
                                    const bt = vt[le1].camera;
                                    if (bt) {
                                        let le1 = Md[bt];
                                        le1 || (le1 = new ExternalTexture, Md[bt] = le1);
                                        const vt = Ac.getCameraImage(bt);
                                        le1.sourceTexture = vt;
                                    }
                                }
                            }
                            for(let le1 = 0; le1 < Od.length; le1++){
                                const vt = jd[le1], bt = Od[le1];
                                null !== vt && void 0 !== bt && bt.update(vt, Dl, mc || Fl);
                            }
                            Jd && Jd(vt, Dl), Dl.detectedPlanes && bt.dispatchEvent({
                                type: "planesdetected",
                                data: Dl
                            }), du = null;
                        }), this.setAnimationLoop = function(le1) {
                            Jd = le1;
                        }, this.dispose = function() {};
                    }
                }
                const om = new ls.O9p, lm = new ls.kn4;
                function WebGLMaterials(le1, vt) {
                    function refreshTransformUniform(le1, vt) {
                        !0 === le1.matrixAutoUpdate && le1.updateMatrix(), vt.value.copy(le1.matrix);
                    }
                    function refreshUniformsCommon(le1, bt) {
                        le1.opacity.value = bt.opacity, bt.color && le1.diffuse.value.copy(bt.color), bt.emissive && le1.emissive.value.copy(bt.emissive).multiplyScalar(bt.emissiveIntensity), bt.map && (le1.map.value = bt.map, refreshTransformUniform(bt.map, le1.mapTransform)), bt.alphaMap && (le1.alphaMap.value = bt.alphaMap, refreshTransformUniform(bt.alphaMap, le1.alphaMapTransform)), bt.bumpMap && (le1.bumpMap.value = bt.bumpMap, refreshTransformUniform(bt.bumpMap, le1.bumpMapTransform), le1.bumpScale.value = bt.bumpScale, bt.side === ls.hsX && (le1.bumpScale.value *= -1)), bt.normalMap && (le1.normalMap.value = bt.normalMap, refreshTransformUniform(bt.normalMap, le1.normalMapTransform), le1.normalScale.value.copy(bt.normalScale), bt.side === ls.hsX && le1.normalScale.value.negate()), bt.displacementMap && (le1.displacementMap.value = bt.displacementMap, refreshTransformUniform(bt.displacementMap, le1.displacementMapTransform), le1.displacementScale.value = bt.displacementScale, le1.displacementBias.value = bt.displacementBias), bt.emissiveMap && (le1.emissiveMap.value = bt.emissiveMap, refreshTransformUniform(bt.emissiveMap, le1.emissiveMapTransform)), bt.specularMap && (le1.specularMap.value = bt.specularMap, refreshTransformUniform(bt.specularMap, le1.specularMapTransform)), bt.alphaTest > 0 && (le1.alphaTest.value = bt.alphaTest);
                        const ho = vt.get(bt), Dl = ho.envMap, Fl = ho.envMapRotation;
                        Dl && (le1.envMap.value = Dl, om.copy(Fl), om.x *= -1, om.y *= -1, om.z *= -1, Dl.isCubeTexture && !1 === Dl.isRenderTargetTexture && (om.y *= -1, om.z *= -1), le1.envMapRotation.value.setFromMatrix4(lm.makeRotationFromEuler(om)), le1.flipEnvMap.value = Dl.isCubeTexture && !1 === Dl.isRenderTargetTexture ? -1 : 1, le1.reflectivity.value = bt.reflectivity, le1.ior.value = bt.ior, le1.refractionRatio.value = bt.refractionRatio), bt.lightMap && (le1.lightMap.value = bt.lightMap, le1.lightMapIntensity.value = bt.lightMapIntensity, refreshTransformUniform(bt.lightMap, le1.lightMapTransform)), bt.aoMap && (le1.aoMap.value = bt.aoMap, le1.aoMapIntensity.value = bt.aoMapIntensity, refreshTransformUniform(bt.aoMap, le1.aoMapTransform));
                    }
                    return {
                        refreshFogUniforms: function(vt, bt) {
                            bt.color.getRGB(vt.fogColor.value, (0, ls._Ut)(le1)), bt.isFog ? (vt.fogNear.value = bt.near, vt.fogFar.value = bt.far) : bt.isFogExp2 && (vt.fogDensity.value = bt.density);
                        },
                        refreshMaterialUniforms: function(le1, bt, ho, Dl, Fl) {
                            bt.isMeshBasicMaterial || bt.isMeshLambertMaterial ? refreshUniformsCommon(le1, bt) : bt.isMeshToonMaterial ? (refreshUniformsCommon(le1, bt), function(le1, vt) {
                                vt.gradientMap && (le1.gradientMap.value = vt.gradientMap);
                            }(le1, bt)) : bt.isMeshPhongMaterial ? (refreshUniformsCommon(le1, bt), function(le1, vt) {
                                le1.specular.value.copy(vt.specular), le1.shininess.value = Math.max(vt.shininess, 1e-4);
                            }(le1, bt)) : bt.isMeshStandardMaterial ? (refreshUniformsCommon(le1, bt), function(le1, vt) {
                                le1.metalness.value = vt.metalness, vt.metalnessMap && (le1.metalnessMap.value = vt.metalnessMap, refreshTransformUniform(vt.metalnessMap, le1.metalnessMapTransform));
                                le1.roughness.value = vt.roughness, vt.roughnessMap && (le1.roughnessMap.value = vt.roughnessMap, refreshTransformUniform(vt.roughnessMap, le1.roughnessMapTransform));
                                vt.envMap && (le1.envMapIntensity.value = vt.envMapIntensity);
                            }(le1, bt), bt.isMeshPhysicalMaterial && function(le1, vt, bt) {
                                le1.ior.value = vt.ior, vt.sheen > 0 && (le1.sheenColor.value.copy(vt.sheenColor).multiplyScalar(vt.sheen), le1.sheenRoughness.value = vt.sheenRoughness, vt.sheenColorMap && (le1.sheenColorMap.value = vt.sheenColorMap, refreshTransformUniform(vt.sheenColorMap, le1.sheenColorMapTransform)), vt.sheenRoughnessMap && (le1.sheenRoughnessMap.value = vt.sheenRoughnessMap, refreshTransformUniform(vt.sheenRoughnessMap, le1.sheenRoughnessMapTransform)));
                                vt.clearcoat > 0 && (le1.clearcoat.value = vt.clearcoat, le1.clearcoatRoughness.value = vt.clearcoatRoughness, vt.clearcoatMap && (le1.clearcoatMap.value = vt.clearcoatMap, refreshTransformUniform(vt.clearcoatMap, le1.clearcoatMapTransform)), vt.clearcoatRoughnessMap && (le1.clearcoatRoughnessMap.value = vt.clearcoatRoughnessMap, refreshTransformUniform(vt.clearcoatRoughnessMap, le1.clearcoatRoughnessMapTransform)), vt.clearcoatNormalMap && (le1.clearcoatNormalMap.value = vt.clearcoatNormalMap, refreshTransformUniform(vt.clearcoatNormalMap, le1.clearcoatNormalMapTransform), le1.clearcoatNormalScale.value.copy(vt.clearcoatNormalScale), vt.side === ls.hsX && le1.clearcoatNormalScale.value.negate()));
                                vt.dispersion > 0 && (le1.dispersion.value = vt.dispersion);
                                vt.iridescence > 0 && (le1.iridescence.value = vt.iridescence, le1.iridescenceIOR.value = vt.iridescenceIOR, le1.iridescenceThicknessMinimum.value = vt.iridescenceThicknessRange[0], le1.iridescenceThicknessMaximum.value = vt.iridescenceThicknessRange[1], vt.iridescenceMap && (le1.iridescenceMap.value = vt.iridescenceMap, refreshTransformUniform(vt.iridescenceMap, le1.iridescenceMapTransform)), vt.iridescenceThicknessMap && (le1.iridescenceThicknessMap.value = vt.iridescenceThicknessMap, refreshTransformUniform(vt.iridescenceThicknessMap, le1.iridescenceThicknessMapTransform)));
                                vt.transmission > 0 && (le1.transmission.value = vt.transmission, le1.transmissionSamplerMap.value = bt.texture, le1.transmissionSamplerSize.value.set(bt.width, bt.height), vt.transmissionMap && (le1.transmissionMap.value = vt.transmissionMap, refreshTransformUniform(vt.transmissionMap, le1.transmissionMapTransform)), le1.thickness.value = vt.thickness, vt.thicknessMap && (le1.thicknessMap.value = vt.thicknessMap, refreshTransformUniform(vt.thicknessMap, le1.thicknessMapTransform)), le1.attenuationDistance.value = vt.attenuationDistance, le1.attenuationColor.value.copy(vt.attenuationColor));
                                vt.anisotropy > 0 && (le1.anisotropyVector.value.set(vt.anisotropy * Math.cos(vt.anisotropyRotation), vt.anisotropy * Math.sin(vt.anisotropyRotation)), vt.anisotropyMap && (le1.anisotropyMap.value = vt.anisotropyMap, refreshTransformUniform(vt.anisotropyMap, le1.anisotropyMapTransform)));
                                le1.specularIntensity.value = vt.specularIntensity, le1.specularColor.value.copy(vt.specularColor), vt.specularColorMap && (le1.specularColorMap.value = vt.specularColorMap, refreshTransformUniform(vt.specularColorMap, le1.specularColorMapTransform));
                                vt.specularIntensityMap && (le1.specularIntensityMap.value = vt.specularIntensityMap, refreshTransformUniform(vt.specularIntensityMap, le1.specularIntensityMapTransform));
                            }(le1, bt, Fl)) : bt.isMeshMatcapMaterial ? (refreshUniformsCommon(le1, bt), function(le1, vt) {
                                vt.matcap && (le1.matcap.value = vt.matcap);
                            }(le1, bt)) : bt.isMeshDepthMaterial ? refreshUniformsCommon(le1, bt) : bt.isMeshDistanceMaterial ? (refreshUniformsCommon(le1, bt), function(le1, bt) {
                                const ls = vt.get(bt).light;
                                le1.referencePosition.value.setFromMatrixPosition(ls.matrixWorld), le1.nearDistance.value = ls.shadow.camera.near, le1.farDistance.value = ls.shadow.camera.far;
                            }(le1, bt)) : bt.isMeshNormalMaterial ? refreshUniformsCommon(le1, bt) : bt.isLineBasicMaterial ? (function(le1, vt) {
                                le1.diffuse.value.copy(vt.color), le1.opacity.value = vt.opacity, vt.map && (le1.map.value = vt.map, refreshTransformUniform(vt.map, le1.mapTransform));
                            }(le1, bt), bt.isLineDashedMaterial && function(le1, vt) {
                                le1.dashSize.value = vt.dashSize, le1.totalSize.value = vt.dashSize + vt.gapSize, le1.scale.value = vt.scale;
                            }(le1, bt)) : bt.isPointsMaterial ? function(le1, vt, bt, ls) {
                                le1.diffuse.value.copy(vt.color), le1.opacity.value = vt.opacity, le1.size.value = vt.size * bt, le1.scale.value = .5 * ls, vt.map && (le1.map.value = vt.map, refreshTransformUniform(vt.map, le1.uvTransform));
                                vt.alphaMap && (le1.alphaMap.value = vt.alphaMap, refreshTransformUniform(vt.alphaMap, le1.alphaMapTransform));
                                vt.alphaTest > 0 && (le1.alphaTest.value = vt.alphaTest);
                            }(le1, bt, ho, Dl) : bt.isSpriteMaterial ? function(le1, vt) {
                                le1.diffuse.value.copy(vt.color), le1.opacity.value = vt.opacity, le1.rotation.value = vt.rotation, vt.map && (le1.map.value = vt.map, refreshTransformUniform(vt.map, le1.mapTransform));
                                vt.alphaMap && (le1.alphaMap.value = vt.alphaMap, refreshTransformUniform(vt.alphaMap, le1.alphaMapTransform));
                                vt.alphaTest > 0 && (le1.alphaTest.value = vt.alphaTest);
                            }(le1, bt) : bt.isShadowMaterial ? (le1.color.value.copy(bt.color), le1.opacity.value = bt.opacity) : bt.isShaderMaterial && (bt.uniformsNeedUpdate = !1);
                        }
                    };
                }
                function WebGLUniformsGroups(le1, vt, bt, ls) {
                    let ho = {}, Dl = {}, Fl = [];
                    const sc = le1.getParameter(le1.MAX_UNIFORM_BUFFER_BINDINGS);
                    function hasUniformChanged(le1, vt, bt, ls) {
                        const ho = le1.value, Dl = vt + "_" + bt;
                        if (void 0 === ls[Dl]) return ls[Dl] = "number" === typeof ho || "boolean" === typeof ho ? ho : ho.clone(), !0;
                        {
                            const le1 = ls[Dl];
                            if ("number" === typeof ho || "boolean" === typeof ho) {
                                if (le1 !== ho) return ls[Dl] = ho, !0;
                            } else if (!1 === le1.equals(ho)) return le1.copy(ho), !0;
                        }
                        return !1;
                    }
                    function getUniformSize(le1) {
                        const vt = {
                            boundary: 0,
                            storage: 0
                        };
                        return "number" === typeof le1 || "boolean" === typeof le1 ? (vt.boundary = 4, vt.storage = 4) : le1.isVector2 ? (vt.boundary = 8, vt.storage = 8) : le1.isVector3 || le1.isColor ? (vt.boundary = 16, vt.storage = 12) : le1.isVector4 ? (vt.boundary = 16, vt.storage = 16) : le1.isMatrix3 ? (vt.boundary = 48, vt.storage = 48) : le1.isMatrix4 ? (vt.boundary = 64, vt.storage = 64) : le1.isTexture ? console.warn("THREE.WebGLRenderer: Texture samplers can not be part of an uniforms group.") : console.warn("THREE.WebGLRenderer: Unsupported uniform value type.", le1), vt;
                    }
                    function onUniformsGroupsDispose(vt) {
                        const bt = vt.target;
                        bt.removeEventListener("dispose", onUniformsGroupsDispose);
                        const ls = Fl.indexOf(bt.__bindingPointIndex);
                        Fl.splice(ls, 1), le1.deleteBuffer(ho[bt.id]), delete ho[bt.id], delete Dl[bt.id];
                    }
                    return {
                        bind: function(le1, vt) {
                            const bt = vt.program;
                            ls.uniformBlockBinding(le1, bt);
                        },
                        update: function(bt, uc) {
                            let mc = ho[bt.id];
                            void 0 === mc && (!function(le1) {
                                const vt = le1.uniforms;
                                let bt = 0;
                                const ls = 16;
                                for(let Dl = 0, Fl = vt.length; Dl < Fl; Dl++){
                                    const le1 = Array.isArray(vt[Dl]) ? vt[Dl] : [
                                        vt[Dl]
                                    ];
                                    for(let vt = 0, ho = le1.length; vt < ho; vt++){
                                        const ho = le1[vt], Dl = Array.isArray(ho.value) ? ho.value : [
                                            ho.value
                                        ];
                                        for(let le1 = 0, vt = Dl.length; le1 < vt; le1++){
                                            const vt = getUniformSize(Dl[le1]), Fl = bt % ls, sc = Fl % vt.boundary, uc = Fl + sc;
                                            bt += sc, 0 !== uc && ls - uc < vt.storage && (bt += ls - uc), ho.__data = new Float32Array(vt.storage / Float32Array.BYTES_PER_ELEMENT), ho.__offset = bt, bt += vt.storage;
                                        }
                                    }
                                }
                                const ho = bt % ls;
                                ho > 0 && (bt += ls - ho);
                                le1.__size = bt, le1.__cache = {};
                            }(bt), mc = function(vt) {
                                const bt = function() {
                                    for(let le1 = 0; le1 < sc; le1++)if (-1 === Fl.indexOf(le1)) return Fl.push(le1), le1;
                                    return console.error("THREE.WebGLRenderer: Maximum number of simultaneously usable uniforms groups reached."), 0;
                                }();
                                vt.__bindingPointIndex = bt;
                                const ls = le1.createBuffer(), ho = vt.__size, Dl = vt.usage;
                                return le1.bindBuffer(le1.UNIFORM_BUFFER, ls), le1.bufferData(le1.UNIFORM_BUFFER, ho, Dl), le1.bindBuffer(le1.UNIFORM_BUFFER, null), le1.bindBufferBase(le1.UNIFORM_BUFFER, bt, ls), ls;
                            }(bt), ho[bt.id] = mc, bt.addEventListener("dispose", onUniformsGroupsDispose));
                            const gc = uc.program;
                            ls.updateUBOMapping(bt, gc);
                            const Ac = vt.render.frame;
                            Dl[bt.id] !== Ac && (!function(vt) {
                                const bt = ho[vt.id], ls = vt.uniforms, Dl = vt.__cache;
                                le1.bindBuffer(le1.UNIFORM_BUFFER, bt);
                                for(let ho = 0, Fl = ls.length; ho < Fl; ho++){
                                    const vt = Array.isArray(ls[ho]) ? ls[ho] : [
                                        ls[ho]
                                    ];
                                    for(let bt = 0, ls = vt.length; bt < ls; bt++){
                                        const ls = vt[bt];
                                        if (!0 === hasUniformChanged(ls, ho, bt, Dl)) {
                                            const vt = ls.__offset, bt = Array.isArray(ls.value) ? ls.value : [
                                                ls.value
                                            ];
                                            let ho = 0;
                                            for(let Dl = 0; Dl < bt.length; Dl++){
                                                const Fl = bt[Dl], sc = getUniformSize(Fl);
                                                "number" === typeof Fl || "boolean" === typeof Fl ? (ls.__data[0] = Fl, le1.bufferSubData(le1.UNIFORM_BUFFER, vt + ho, ls.__data)) : Fl.isMatrix3 ? (ls.__data[0] = Fl.elements[0], ls.__data[1] = Fl.elements[1], ls.__data[2] = Fl.elements[2], ls.__data[3] = 0, ls.__data[4] = Fl.elements[3], ls.__data[5] = Fl.elements[4], ls.__data[6] = Fl.elements[5], ls.__data[7] = 0, ls.__data[8] = Fl.elements[6], ls.__data[9] = Fl.elements[7], ls.__data[10] = Fl.elements[8], ls.__data[11] = 0) : (Fl.toArray(ls.__data, ho), ho += sc.storage / Float32Array.BYTES_PER_ELEMENT);
                                            }
                                            le1.bufferSubData(le1.UNIFORM_BUFFER, vt, ls.__data);
                                        }
                                    }
                                }
                                le1.bindBuffer(le1.UNIFORM_BUFFER, null);
                            }(bt), Dl[bt.id] = Ac);
                        },
                        dispose: function() {
                            for(const vt in ho)le1.deleteBuffer(ho[vt]);
                            Fl = [], ho = {}, Dl = {};
                        }
                    };
                }
                class WebGLRenderer {
                    constructor(le1){
                        void 0 === le1 && (le1 = {});
                        const { canvas: vt = (0, ls.lPF)(), context: bt = null, depth: ho = !0, stencil: Dl = !1, alpha: Fl = !1, antialias: sc = !1, premultipliedAlpha: uc = !0, preserveDrawingBuffer: mc = !1, powerPreference: gc = "default", failIfMajorPerformanceCaveat: Ac = !1, reversedDepthBuffer: Ec = !1 } = le1;
                        let kc;
                        if (this.isWebGLRenderer = !0, null !== bt) {
                            if ("undefined" !== typeof WebGLRenderingContext && bt instanceof WebGLRenderingContext) throw new Error("THREE.WebGLRenderer: WebGL 1 is not supported since r163.");
                            kc = bt.getContextAttributes().alpha;
                        } else kc = Fl;
                        const du = new Uint32Array(4), _u = new Int32Array(4);
                        let Md = null, Ld = null;
                        const Nd = [], Rd = [];
                        this.domElement = vt, this.debug = {
                            checkShaderErrors: !0,
                            onShaderError: null
                        }, this.autoClear = !0, this.autoClearColor = !0, this.autoClearDepth = !0, this.autoClearStencil = !0, this.sortObjects = !0, this.clippingPlanes = [], this.localClippingEnabled = !1, this.toneMapping = ls.y_p, this.toneMappingExposure = 1, this.transmissionResolutionScale = 1;
                        const Od = this;
                        let jd = !1;
                        this._outputColorSpace = ls.er$;
                        let Ud = 0, Gd = 0, qd = null, Hd = -1, Wd = null;
                        const Zd = new ls.IUQ, Yd = new ls.IUQ;
                        let Qd = null;
                        const Xd = new ls.Q1f(0);
                        let Kd = 0, Jd = vt.width, $d = vt.height, sp = 1, em = null, tm = null;
                        const im = new ls.IUQ(0, 0, Jd, $d), nm = new ls.IUQ(0, 0, Jd, $d);
                        let rm = !1;
                        const am = new ls.PPD;
                        let sm = !1, om = !1;
                        const lm = new ls.kn4, cm = new ls.Pq0, um = new ls.IUQ, hm = {
                            background: null,
                            fog: null,
                            environment: null,
                            overrideMaterial: null,
                            isScene: !0
                        };
                        let dm = !1;
                        function getTargetPixelRatio() {
                            return null === qd ? sp : 1;
                        }
                        let pm, mm, fm, gm, Am, _m, ym, vm, xm, bm, wm, Em, Mm, Sm, Tm, km, Cm, Im, Dm, Lm, Pm, zm, Nm, Rm, Fm = bt;
                        function getContext(le1, bt) {
                            return vt.getContext(le1, bt);
                        }
                        try {
                            const le1 = {
                                alpha: !0,
                                depth: ho,
                                stencil: Dl,
                                antialias: sc,
                                premultipliedAlpha: uc,
                                preserveDrawingBuffer: mc,
                                powerPreference: gc,
                                failIfMajorPerformanceCaveat: Ac
                            };
                            if ("setAttribute" in vt && vt.setAttribute("data-engine", `three.js r${ls.sPf}`), vt.addEventListener("webglcontextlost", onContextLost, !1), vt.addEventListener("webglcontextrestored", onContextRestore, !1), vt.addEventListener("webglcontextcreationerror", onContextCreationError, !1), null === Fm) {
                                const vt = "webgl2";
                                if (Fm = getContext(vt, le1), null === Fm) throw getContext(vt) ? new Error("Error creating WebGL context with your selected attributes.") : new Error("Error creating WebGL context.");
                            }
                        } catch (qm) {
                            throw console.error("THREE.WebGLRenderer: " + qm.message), qm;
                        }
                        function initGLContext() {
                            pm = new WebGLExtensions(Fm), pm.init(), zm = new WebGLUtils(Fm, pm), mm = new WebGLCapabilities(Fm, pm, le1, zm), fm = new WebGLState(Fm, pm), mm.reversedDepthBuffer && Ec && fm.buffers.depth.setReversed(!0), gm = new WebGLInfo(Fm), Am = new WebGLProperties, _m = new WebGLTextures(Fm, pm, fm, Am, mm, zm, gm), ym = new WebGLCubeMaps(Od), vm = new WebGLCubeUVMaps(Od), xm = new WebGLAttributes(Fm), Nm = new WebGLBindingStates(Fm, xm), bm = new WebGLGeometries(Fm, xm, gm, Nm), wm = new WebGLObjects(Fm, bm, xm, gm), Dm = new WebGLMorphtargets(Fm, mm, _m), km = new WebGLClipping(Am), Em = new WebGLPrograms(Od, ym, vm, pm, mm, Nm, km), Mm = new WebGLMaterials(Od, Am), Sm = new WebGLRenderLists, Tm = new WebGLRenderStates(pm), Im = new WebGLBackground(Od, ym, vm, fm, wm, kc, uc), Cm = new WebGLShadowMap(Od, wm, mm), Rm = new WebGLUniformsGroups(Fm, gm, mm, fm), Lm = new WebGLBufferRenderer(Fm, pm, gm), Pm = new WebGLIndexedBufferRenderer(Fm, pm, gm), gm.programs = Em.programs, Od.capabilities = mm, Od.extensions = pm, Od.properties = Am, Od.renderLists = Sm, Od.shadowMap = Cm, Od.state = fm, Od.info = gm;
                        }
                        initGLContext();
                        const Om = new WebXRManager(Od, Fm);
                        function onContextLost(le1) {
                            le1.preventDefault(), console.log("THREE.WebGLRenderer: Context Lost."), jd = !0;
                        }
                        function onContextRestore() {
                            console.log("THREE.WebGLRenderer: Context Restored."), jd = !1;
                            const le1 = gm.autoReset, vt = Cm.enabled, bt = Cm.autoUpdate, ls = Cm.needsUpdate, ho = Cm.type;
                            initGLContext(), gm.autoReset = le1, Cm.enabled = vt, Cm.autoUpdate = bt, Cm.needsUpdate = ls, Cm.type = ho;
                        }
                        function onContextCreationError(le1) {
                            console.error("THREE.WebGLRenderer: A WebGL context could not be created. Reason: ", le1.statusMessage);
                        }
                        function onMaterialDispose(le1) {
                            const vt = le1.target;
                            vt.removeEventListener("dispose", onMaterialDispose), function(le1) {
                                (function(le1) {
                                    const vt = Am.get(le1).programs;
                                    void 0 !== vt && (vt.forEach(function(le1) {
                                        Em.releaseProgram(le1);
                                    }), le1.isShaderMaterial && Em.releaseShaderCache(le1));
                                })(le1), Am.remove(le1);
                            }(vt);
                        }
                        function prepareMaterial(le1, vt, bt) {
                            !0 === le1.transparent && le1.side === ls.$EB && !1 === le1.forceSinglePass ? (le1.side = ls.hsX, le1.needsUpdate = !0, getProgram(le1, vt, bt), le1.side = ls.hB5, le1.needsUpdate = !0, getProgram(le1, vt, bt), le1.side = ls.$EB) : getProgram(le1, vt, bt);
                        }
                        this.xr = Om, this.getContext = function() {
                            return Fm;
                        }, this.getContextAttributes = function() {
                            return Fm.getContextAttributes();
                        }, this.forceContextLoss = function() {
                            const le1 = pm.get("WEBGL_lose_context");
                            le1 && le1.loseContext();
                        }, this.forceContextRestore = function() {
                            const le1 = pm.get("WEBGL_lose_context");
                            le1 && le1.restoreContext();
                        }, this.getPixelRatio = function() {
                            return sp;
                        }, this.setPixelRatio = function(le1) {
                            void 0 !== le1 && (sp = le1, this.setSize(Jd, $d, !1));
                        }, this.getSize = function(le1) {
                            return le1.set(Jd, $d);
                        }, this.setSize = function(le1, bt, ls) {
                            void 0 === ls && (ls = !0), Om.isPresenting ? console.warn("THREE.WebGLRenderer: Can't change size while VR device is presenting.") : (Jd = le1, $d = bt, vt.width = Math.floor(le1 * sp), vt.height = Math.floor(bt * sp), !0 === ls && (vt.style.width = le1 + "px", vt.style.height = bt + "px"), this.setViewport(0, 0, le1, bt));
                        }, this.getDrawingBufferSize = function(le1) {
                            return le1.set(Jd * sp, $d * sp).floor();
                        }, this.setDrawingBufferSize = function(le1, bt, ls) {
                            Jd = le1, $d = bt, sp = ls, vt.width = Math.floor(le1 * ls), vt.height = Math.floor(bt * ls), this.setViewport(0, 0, le1, bt);
                        }, this.getCurrentViewport = function(le1) {
                            return le1.copy(Zd);
                        }, this.getViewport = function(le1) {
                            return le1.copy(im);
                        }, this.setViewport = function(le1, vt, bt, ls) {
                            le1.isVector4 ? im.set(le1.x, le1.y, le1.z, le1.w) : im.set(le1, vt, bt, ls), fm.viewport(Zd.copy(im).multiplyScalar(sp).round());
                        }, this.getScissor = function(le1) {
                            return le1.copy(nm);
                        }, this.setScissor = function(le1, vt, bt, ls) {
                            le1.isVector4 ? nm.set(le1.x, le1.y, le1.z, le1.w) : nm.set(le1, vt, bt, ls), fm.scissor(Yd.copy(nm).multiplyScalar(sp).round());
                        }, this.getScissorTest = function() {
                            return rm;
                        }, this.setScissorTest = function(le1) {
                            fm.setScissorTest(rm = le1);
                        }, this.setOpaqueSort = function(le1) {
                            em = le1;
                        }, this.setTransparentSort = function(le1) {
                            tm = le1;
                        }, this.getClearColor = function(le1) {
                            return le1.copy(Im.getClearColor());
                        }, this.setClearColor = function() {
                            Im.setClearColor(...arguments);
                        }, this.getClearAlpha = function() {
                            return Im.getClearAlpha();
                        }, this.setClearAlpha = function() {
                            Im.setClearAlpha(...arguments);
                        }, this.clear = function(le1, vt, bt) {
                            void 0 === le1 && (le1 = !0), void 0 === vt && (vt = !0), void 0 === bt && (bt = !0);
                            let ho = 0;
                            if (le1) {
                                let le1 = !1;
                                if (null !== qd) {
                                    const vt = qd.texture.format;
                                    le1 = vt === ls.c90 || vt === ls.TkQ || vt === ls.ZQM;
                                }
                                if (le1) {
                                    const le1 = qd.texture.type, vt = le1 === ls.OUM || le1 === ls.bkx || le1 === ls.cHt || le1 === ls.V3x || le1 === ls.Wew || le1 === ls.gJ2, bt = Im.getClearColor(), ho = Im.getClearAlpha(), Dl = bt.r, Fl = bt.g, sc = bt.b;
                                    vt ? (du[0] = Dl, du[1] = Fl, du[2] = sc, du[3] = ho, Fm.clearBufferuiv(Fm.COLOR, 0, du)) : (_u[0] = Dl, _u[1] = Fl, _u[2] = sc, _u[3] = ho, Fm.clearBufferiv(Fm.COLOR, 0, _u));
                                } else ho |= Fm.COLOR_BUFFER_BIT;
                            }
                            vt && (ho |= Fm.DEPTH_BUFFER_BIT), bt && (ho |= Fm.STENCIL_BUFFER_BIT, this.state.buffers.stencil.setMask(4294967295)), Fm.clear(ho);
                        }, this.clearColor = function() {
                            this.clear(!0, !1, !1);
                        }, this.clearDepth = function() {
                            this.clear(!1, !0, !1);
                        }, this.clearStencil = function() {
                            this.clear(!1, !1, !0);
                        }, this.dispose = function() {
                            vt.removeEventListener("webglcontextlost", onContextLost, !1), vt.removeEventListener("webglcontextrestored", onContextRestore, !1), vt.removeEventListener("webglcontextcreationerror", onContextCreationError, !1), Im.dispose(), Sm.dispose(), Tm.dispose(), Am.dispose(), ym.dispose(), vm.dispose(), wm.dispose(), Nm.dispose(), Rm.dispose(), Em.dispose(), Om.dispose(), Om.removeEventListener("sessionstart", onXRSessionStart), Om.removeEventListener("sessionend", onXRSessionEnd), jm.stop();
                        }, this.renderBufferDirect = function(le1, vt, bt, ho, Dl, Fl) {
                            null === vt && (vt = hm);
                            const sc = Dl.isMesh && Dl.matrixWorld.determinant() < 0, uc = function(le1, vt, bt, ho, Dl) {
                                !0 !== vt.isScene && (vt = hm);
                                _m.resetTextureUnits();
                                const Fl = vt.fog, sc = ho.isMeshStandardMaterial ? vt.environment : null, uc = null === qd ? Od.outputColorSpace : !0 === qd.isXRRenderTarget ? qd.texture.colorSpace : ls.Zr2, mc = (ho.isMeshStandardMaterial ? vm : ym).get(ho.envMap || sc), gc = !0 === ho.vertexColors && !!bt.attributes.color && 4 === bt.attributes.color.itemSize, Ac = !!bt.attributes.tangent && (!!ho.normalMap || ho.anisotropy > 0), Ec = !!bt.morphAttributes.position, kc = !!bt.morphAttributes.normal, du = !!bt.morphAttributes.color;
                                let _u = ls.y_p;
                                ho.toneMapped && (null !== qd && !0 !== qd.isXRRenderTarget || (_u = Od.toneMapping));
                                const Md = bt.morphAttributes.position || bt.morphAttributes.normal || bt.morphAttributes.color, Nd = void 0 !== Md ? Md.length : 0, Rd = Am.get(ho), jd = Ld.state.lights;
                                if (!0 === sm && (!0 === om || le1 !== Wd)) {
                                    const vt = le1 === Wd && ho.id === Hd;
                                    km.setState(ho, le1, vt);
                                }
                                let Ud = !1;
                                ho.version === Rd.__version ? Rd.needsLights && Rd.lightsStateVersion !== jd.state.version || Rd.outputColorSpace !== uc || Dl.isBatchedMesh && !1 === Rd.batching ? Ud = !0 : Dl.isBatchedMesh || !0 !== Rd.batching ? Dl.isBatchedMesh && !0 === Rd.batchingColor && null === Dl.colorTexture || Dl.isBatchedMesh && !1 === Rd.batchingColor && null !== Dl.colorTexture || Dl.isInstancedMesh && !1 === Rd.instancing ? Ud = !0 : Dl.isInstancedMesh || !0 !== Rd.instancing ? Dl.isSkinnedMesh && !1 === Rd.skinning ? Ud = !0 : Dl.isSkinnedMesh || !0 !== Rd.skinning ? Dl.isInstancedMesh && !0 === Rd.instancingColor && null === Dl.instanceColor || Dl.isInstancedMesh && !1 === Rd.instancingColor && null !== Dl.instanceColor || Dl.isInstancedMesh && !0 === Rd.instancingMorph && null === Dl.morphTexture || Dl.isInstancedMesh && !1 === Rd.instancingMorph && null !== Dl.morphTexture || Rd.envMap !== mc || !0 === ho.fog && Rd.fog !== Fl ? Ud = !0 : void 0 === Rd.numClippingPlanes || Rd.numClippingPlanes === km.numPlanes && Rd.numIntersection === km.numIntersection ? (Rd.vertexAlphas !== gc || Rd.vertexTangents !== Ac || Rd.morphTargets !== Ec || Rd.morphNormals !== kc || Rd.morphColors !== du || Rd.toneMapping !== _u || Rd.morphTargetsCount !== Nd) && (Ud = !0) : Ud = !0 : Ud = !0 : Ud = !0 : Ud = !0 : (Ud = !0, Rd.__version = ho.version);
                                let Gd = Rd.currentProgram;
                                !0 === Ud && (Gd = getProgram(ho, vt, Dl));
                                let Zd = !1, Yd = !1, Qd = !1;
                                const Xd = Gd.getUniforms(), Kd = Rd.uniforms;
                                fm.useProgram(Gd.program) && (Zd = !0, Yd = !0, Qd = !0);
                                ho.id !== Hd && (Hd = ho.id, Yd = !0);
                                if (Zd || Wd !== le1) {
                                    fm.buffers.depth.getReversed() && !0 !== le1.reversedDepth && (le1._reversedDepth = !0, le1.updateProjectionMatrix()), Xd.setValue(Fm, "projectionMatrix", le1.projectionMatrix), Xd.setValue(Fm, "viewMatrix", le1.matrixWorldInverse);
                                    const vt = Xd.map.cameraPosition;
                                    void 0 !== vt && vt.setValue(Fm, cm.setFromMatrixPosition(le1.matrixWorld)), mm.logarithmicDepthBuffer && Xd.setValue(Fm, "logDepthBufFC", 2 / (Math.log(le1.far + 1) / Math.LN2)), (ho.isMeshPhongMaterial || ho.isMeshToonMaterial || ho.isMeshLambertMaterial || ho.isMeshBasicMaterial || ho.isMeshStandardMaterial || ho.isShaderMaterial) && Xd.setValue(Fm, "isOrthographic", !0 === le1.isOrthographicCamera), Wd !== le1 && (Wd = le1, Yd = !0, Qd = !0);
                                }
                                if (Dl.isSkinnedMesh) {
                                    Xd.setOptional(Fm, Dl, "bindMatrix"), Xd.setOptional(Fm, Dl, "bindMatrixInverse");
                                    const le1 = Dl.skeleton;
                                    le1 && (null === le1.boneTexture && le1.computeBoneTexture(), Xd.setValue(Fm, "boneTexture", le1.boneTexture, _m));
                                }
                                Dl.isBatchedMesh && (Xd.setOptional(Fm, Dl, "batchingTexture"), Xd.setValue(Fm, "batchingTexture", Dl._matricesTexture, _m), Xd.setOptional(Fm, Dl, "batchingIdTexture"), Xd.setValue(Fm, "batchingIdTexture", Dl._indirectTexture, _m), Xd.setOptional(Fm, Dl, "batchingColorTexture"), null !== Dl._colorsTexture && Xd.setValue(Fm, "batchingColorTexture", Dl._colorsTexture, _m));
                                const Jd = bt.morphAttributes;
                                void 0 === Jd.position && void 0 === Jd.normal && void 0 === Jd.color || Dm.update(Dl, bt, Gd);
                                (Yd || Rd.receiveShadow !== Dl.receiveShadow) && (Rd.receiveShadow = Dl.receiveShadow, Xd.setValue(Fm, "receiveShadow", Dl.receiveShadow));
                                ho.isMeshGouraudMaterial && null !== ho.envMap && (Kd.envMap.value = mc, Kd.flipEnvMap.value = mc.isCubeTexture && !1 === mc.isRenderTargetTexture ? -1 : 1);
                                ho.isMeshStandardMaterial && null === ho.envMap && null !== vt.environment && (Kd.envMapIntensity.value = vt.environmentIntensity);
                                Yd && (Xd.setValue(Fm, "toneMappingExposure", Od.toneMappingExposure), Rd.needsLights && (tm = Qd, (em = Kd).ambientLightColor.needsUpdate = tm, em.lightProbe.needsUpdate = tm, em.directionalLights.needsUpdate = tm, em.directionalLightShadows.needsUpdate = tm, em.pointLights.needsUpdate = tm, em.pointLightShadows.needsUpdate = tm, em.spotLights.needsUpdate = tm, em.spotLightShadows.needsUpdate = tm, em.rectAreaLights.needsUpdate = tm, em.hemisphereLights.needsUpdate = tm), Fl && !0 === ho.fog && Mm.refreshFogUniforms(Kd, Fl), Mm.refreshMaterialUniforms(Kd, ho, sp, $d, Ld.state.transmissionRenderTarget[le1.id]), WebGLUniforms.upload(Fm, getUniformList(Rd), Kd, _m));
                                var em, tm;
                                ho.isShaderMaterial && !0 === ho.uniformsNeedUpdate && (WebGLUniforms.upload(Fm, getUniformList(Rd), Kd, _m), ho.uniformsNeedUpdate = !1);
                                ho.isSpriteMaterial && Xd.setValue(Fm, "center", Dl.center);
                                if (Xd.setValue(Fm, "modelViewMatrix", Dl.modelViewMatrix), Xd.setValue(Fm, "normalMatrix", Dl.normalMatrix), Xd.setValue(Fm, "modelMatrix", Dl.matrixWorld), ho.isShaderMaterial || ho.isRawShaderMaterial) {
                                    const le1 = ho.uniformsGroups;
                                    for(let vt = 0, bt = le1.length; vt < bt; vt++){
                                        const bt = le1[vt];
                                        Rm.update(bt, Gd), Rm.bind(bt, Gd);
                                    }
                                }
                                return Gd;
                            }(le1, vt, bt, ho, Dl);
                            fm.setMaterial(ho, sc);
                            let mc = bt.index, gc = 1;
                            if (!0 === ho.wireframe) {
                                if (mc = bm.getWireframeAttribute(bt), void 0 === mc) return;
                                gc = 2;
                            }
                            const Ac = bt.drawRange, Ec = bt.attributes.position;
                            let kc = Ac.start * gc, du = (Ac.start + Ac.count) * gc;
                            null !== Fl && (kc = Math.max(kc, Fl.start * gc), du = Math.min(du, (Fl.start + Fl.count) * gc)), null !== mc ? (kc = Math.max(kc, 0), du = Math.min(du, mc.count)) : void 0 !== Ec && null !== Ec && (kc = Math.max(kc, 0), du = Math.min(du, Ec.count));
                            const _u = du - kc;
                            if (_u < 0 || _u === 1 / 0) return;
                            let Md;
                            Nm.setup(Dl, ho, uc, bt, mc);
                            let Nd = Lm;
                            if (null !== mc && (Md = xm.get(mc), Nd = Pm, Nd.setIndex(Md)), Dl.isMesh) !0 === ho.wireframe ? (fm.setLineWidth(ho.wireframeLinewidth * getTargetPixelRatio()), Nd.setMode(Fm.LINES)) : Nd.setMode(Fm.TRIANGLES);
                            else if (Dl.isLine) {
                                let le1 = ho.linewidth;
                                void 0 === le1 && (le1 = 1), fm.setLineWidth(le1 * getTargetPixelRatio()), Dl.isLineSegments ? Nd.setMode(Fm.LINES) : Dl.isLineLoop ? Nd.setMode(Fm.LINE_LOOP) : Nd.setMode(Fm.LINE_STRIP);
                            } else Dl.isPoints ? Nd.setMode(Fm.POINTS) : Dl.isSprite && Nd.setMode(Fm.TRIANGLES);
                            if (Dl.isBatchedMesh) {
                                if (null !== Dl._multiDrawInstances) (0, ls.mcG)("THREE.WebGLRenderer: renderMultiDrawInstances has been deprecated and will be removed in r184. Append to renderMultiDraw arguments and use indirection."), Nd.renderMultiDrawInstances(Dl._multiDrawStarts, Dl._multiDrawCounts, Dl._multiDrawCount, Dl._multiDrawInstances);
                                else if (pm.get("WEBGL_multi_draw")) Nd.renderMultiDraw(Dl._multiDrawStarts, Dl._multiDrawCounts, Dl._multiDrawCount);
                                else {
                                    const le1 = Dl._multiDrawStarts, vt = Dl._multiDrawCounts, bt = Dl._multiDrawCount, ls = mc ? xm.get(mc).bytesPerElement : 1, Fl = Am.get(ho).currentProgram.getUniforms();
                                    for(let ho = 0; ho < bt; ho++)Fl.setValue(Fm, "_gl_DrawID", ho), Nd.render(le1[ho] / ls, vt[ho]);
                                }
                            } else if (Dl.isInstancedMesh) Nd.renderInstances(kc, _u, Dl.count);
                            else if (bt.isInstancedBufferGeometry) {
                                const le1 = void 0 !== bt._maxInstanceCount ? bt._maxInstanceCount : 1 / 0, vt = Math.min(bt.instanceCount, le1);
                                Nd.renderInstances(kc, _u, vt);
                            } else Nd.render(kc, _u);
                        }, this.compile = function(le1, vt, bt) {
                            void 0 === bt && (bt = null), null === bt && (bt = le1), Ld = Tm.get(bt), Ld.init(vt), Rd.push(Ld), bt.traverseVisible(function(le1) {
                                le1.isLight && le1.layers.test(vt.layers) && (Ld.pushLight(le1), le1.castShadow && Ld.pushShadow(le1));
                            }), le1 !== bt && le1.traverseVisible(function(le1) {
                                le1.isLight && le1.layers.test(vt.layers) && (Ld.pushLight(le1), le1.castShadow && Ld.pushShadow(le1));
                            }), Ld.setupLights();
                            const ls = new Set;
                            return le1.traverse(function(le1) {
                                if (!(le1.isMesh || le1.isPoints || le1.isLine || le1.isSprite)) return;
                                const vt = le1.material;
                                if (vt) {
                                    if (Array.isArray(vt)) for(let ho = 0; ho < vt.length; ho++){
                                        const Dl = vt[ho];
                                        prepareMaterial(Dl, bt, le1), ls.add(Dl);
                                    }
                                    else prepareMaterial(vt, bt, le1), ls.add(vt);
                                }
                            }), Ld = Rd.pop(), ls;
                        }, this.compileAsync = function(le1, vt, bt) {
                            void 0 === bt && (bt = null);
                            const ls = this.compile(le1, vt, bt);
                            return new Promise((vt)=>{
                                function checkMaterialsReady() {
                                    ls.forEach(function(le1) {
                                        Am.get(le1).currentProgram.isReady() && ls.delete(le1);
                                    }), 0 !== ls.size ? setTimeout(checkMaterialsReady, 10) : vt(le1);
                                }
                                null !== pm.get("KHR_parallel_shader_compile") ? checkMaterialsReady() : setTimeout(checkMaterialsReady, 10);
                            });
                        };
                        let Bm = null;
                        function onXRSessionStart() {
                            jm.stop();
                        }
                        function onXRSessionEnd() {
                            jm.start();
                        }
                        const jm = new WebGLAnimation;
                        function projectObject(le1, vt, bt, ls) {
                            if (!1 === le1.visible) return;
                            if (le1.layers.test(vt.layers)) {
                                if (le1.isGroup) bt = le1.renderOrder;
                                else if (le1.isLOD) !0 === le1.autoUpdate && le1.update(vt);
                                else if (le1.isLight) Ld.pushLight(le1), le1.castShadow && Ld.pushShadow(le1);
                                else if (le1.isSprite) {
                                    if (!le1.frustumCulled || am.intersectsSprite(le1)) {
                                        ls && um.setFromMatrixPosition(le1.matrixWorld).applyMatrix4(lm);
                                        const vt = wm.update(le1), ho = le1.material;
                                        ho.visible && Md.push(le1, vt, ho, bt, um.z, null);
                                    }
                                } else if ((le1.isMesh || le1.isLine || le1.isPoints) && (!le1.frustumCulled || am.intersectsObject(le1))) {
                                    const vt = wm.update(le1), ho = le1.material;
                                    if (ls && (void 0 !== le1.boundingSphere ? (null === le1.boundingSphere && le1.computeBoundingSphere(), um.copy(le1.boundingSphere.center)) : (null === vt.boundingSphere && vt.computeBoundingSphere(), um.copy(vt.boundingSphere.center)), um.applyMatrix4(le1.matrixWorld).applyMatrix4(lm)), Array.isArray(ho)) {
                                        const ls = vt.groups;
                                        for(let Dl = 0, Fl = ls.length; Dl < Fl; Dl++){
                                            const Fl = ls[Dl], sc = ho[Fl.materialIndex];
                                            sc && sc.visible && Md.push(le1, vt, sc, bt, um.z, Fl);
                                        }
                                    } else ho.visible && Md.push(le1, vt, ho, bt, um.z, null);
                                }
                            }
                            const ho = le1.children;
                            for(let Dl = 0, Fl = ho.length; Dl < Fl; Dl++)projectObject(ho[Dl], vt, bt, ls);
                        }
                        function renderScene(le1, vt, bt, ls) {
                            const ho = le1.opaque, Dl = le1.transmissive, Fl = le1.transparent;
                            Ld.setupLightsView(bt), !0 === sm && km.setGlobalState(Od.clippingPlanes, bt), ls && fm.viewport(Zd.copy(ls)), ho.length > 0 && renderObjects(ho, vt, bt), Dl.length > 0 && renderObjects(Dl, vt, bt), Fl.length > 0 && renderObjects(Fl, vt, bt), fm.buffers.depth.setTest(!0), fm.buffers.depth.setMask(!0), fm.buffers.color.setMask(!0), fm.setPolygonOffset(!1);
                        }
                        function renderTransmissionPass(le1, vt, bt, ho) {
                            if (null !== (!0 === bt.isScene ? bt.overrideMaterial : null)) return;
                            void 0 === Ld.state.transmissionRenderTarget[ho.id] && (Ld.state.transmissionRenderTarget[ho.id] = new ls.nWS(1, 1, {
                                generateMipmaps: !0,
                                type: pm.has("EXT_color_buffer_half_float") || pm.has("EXT_color_buffer_float") ? ls.ix0 : ls.OUM,
                                minFilter: ls.$_I,
                                samples: 4,
                                stencilBuffer: Dl,
                                resolveDepthBuffer: !1,
                                resolveStencilBuffer: !1,
                                colorSpace: ls.ppV.workingColorSpace
                            }));
                            const Fl = Ld.state.transmissionRenderTarget[ho.id], sc = ho.viewport || Zd;
                            Fl.setSize(sc.z * Od.transmissionResolutionScale, sc.w * Od.transmissionResolutionScale);
                            const uc = Od.getRenderTarget(), mc = Od.getActiveCubeFace(), gc = Od.getActiveMipmapLevel();
                            Od.setRenderTarget(Fl), Od.getClearColor(Xd), Kd = Od.getClearAlpha(), Kd < 1 && Od.setClearColor(16777215, .5), Od.clear(), dm && Im.render(bt);
                            const Ac = Od.toneMapping;
                            Od.toneMapping = ls.y_p;
                            const Ec = ho.viewport;
                            if (void 0 !== ho.viewport && (ho.viewport = void 0), Ld.setupLightsView(ho), !0 === sm && km.setGlobalState(Od.clippingPlanes, ho), renderObjects(le1, bt, ho), _m.updateMultisampleRenderTarget(Fl), _m.updateRenderTargetMipmap(Fl), !1 === pm.has("WEBGL_multisampled_render_to_texture")) {
                                let le1 = !1;
                                for(let Dl = 0, Fl = vt.length; Dl < Fl; Dl++){
                                    const Fl = vt[Dl], sc = Fl.object, uc = Fl.geometry, mc = Fl.material, gc = Fl.group;
                                    if (mc.side === ls.$EB && sc.layers.test(ho.layers)) {
                                        const vt = mc.side;
                                        mc.side = ls.hsX, mc.needsUpdate = !0, renderObject(sc, bt, ho, uc, mc, gc), mc.side = vt, mc.needsUpdate = !0, le1 = !0;
                                    }
                                }
                                !0 === le1 && (_m.updateMultisampleRenderTarget(Fl), _m.updateRenderTargetMipmap(Fl));
                            }
                            Od.setRenderTarget(uc, mc, gc), Od.setClearColor(Xd, Kd), void 0 !== Ec && (ho.viewport = Ec), Od.toneMapping = Ac;
                        }
                        function renderObjects(le1, vt, bt) {
                            const ls = !0 === vt.isScene ? vt.overrideMaterial : null;
                            for(let ho = 0, Dl = le1.length; ho < Dl; ho++){
                                const Dl = le1[ho], Fl = Dl.object, sc = Dl.geometry, uc = Dl.group;
                                let mc = Dl.material;
                                !0 === mc.allowOverride && null !== ls && (mc = ls), Fl.layers.test(bt.layers) && renderObject(Fl, vt, bt, sc, mc, uc);
                            }
                        }
                        function renderObject(le1, vt, bt, ho, Dl, Fl) {
                            le1.onBeforeRender(Od, vt, bt, ho, Dl, Fl), le1.modelViewMatrix.multiplyMatrices(bt.matrixWorldInverse, le1.matrixWorld), le1.normalMatrix.getNormalMatrix(le1.modelViewMatrix), Dl.onBeforeRender(Od, vt, bt, ho, le1, Fl), !0 === Dl.transparent && Dl.side === ls.$EB && !1 === Dl.forceSinglePass ? (Dl.side = ls.hsX, Dl.needsUpdate = !0, Od.renderBufferDirect(bt, vt, ho, Dl, le1, Fl), Dl.side = ls.hB5, Dl.needsUpdate = !0, Od.renderBufferDirect(bt, vt, ho, Dl, le1, Fl), Dl.side = ls.$EB) : Od.renderBufferDirect(bt, vt, ho, Dl, le1, Fl), le1.onAfterRender(Od, vt, bt, ho, Dl, Fl);
                        }
                        function getProgram(le1, vt, bt) {
                            !0 !== vt.isScene && (vt = hm);
                            const ls = Am.get(le1), ho = Ld.state.lights, Dl = Ld.state.shadowsArray, Fl = ho.state.version, sc = Em.getParameters(le1, ho.state, Dl, vt, bt), uc = Em.getProgramCacheKey(sc);
                            let mc = ls.programs;
                            ls.environment = le1.isMeshStandardMaterial ? vt.environment : null, ls.fog = vt.fog, ls.envMap = (le1.isMeshStandardMaterial ? vm : ym).get(le1.envMap || ls.environment), ls.envMapRotation = null !== ls.environment && null === le1.envMap ? vt.environmentRotation : le1.envMapRotation, void 0 === mc && (le1.addEventListener("dispose", onMaterialDispose), mc = new Map, ls.programs = mc);
                            let gc = mc.get(uc);
                            if (void 0 !== gc) {
                                if (ls.currentProgram === gc && ls.lightsStateVersion === Fl) return updateCommonMaterialProperties(le1, sc), gc;
                            } else sc.uniforms = Em.getUniforms(le1), le1.onBeforeCompile(sc, Od), gc = Em.acquireProgram(sc, uc), mc.set(uc, gc), ls.uniforms = sc.uniforms;
                            const Ac = ls.uniforms;
                            return (le1.isShaderMaterial || le1.isRawShaderMaterial) && !0 !== le1.clipping || (Ac.clippingPlanes = km.uniform), updateCommonMaterialProperties(le1, sc), ls.needsLights = function(le1) {
                                return le1.isMeshLambertMaterial || le1.isMeshToonMaterial || le1.isMeshPhongMaterial || le1.isMeshStandardMaterial || le1.isShadowMaterial || le1.isShaderMaterial && !0 === le1.lights;
                            }(le1), ls.lightsStateVersion = Fl, ls.needsLights && (Ac.ambientLightColor.value = ho.state.ambient, Ac.lightProbe.value = ho.state.probe, Ac.directionalLights.value = ho.state.directional, Ac.directionalLightShadows.value = ho.state.directionalShadow, Ac.spotLights.value = ho.state.spot, Ac.spotLightShadows.value = ho.state.spotShadow, Ac.rectAreaLights.value = ho.state.rectArea, Ac.ltc_1.value = ho.state.rectAreaLTC1, Ac.ltc_2.value = ho.state.rectAreaLTC2, Ac.pointLights.value = ho.state.point, Ac.pointLightShadows.value = ho.state.pointShadow, Ac.hemisphereLights.value = ho.state.hemi, Ac.directionalShadowMap.value = ho.state.directionalShadowMap, Ac.directionalShadowMatrix.value = ho.state.directionalShadowMatrix, Ac.spotShadowMap.value = ho.state.spotShadowMap, Ac.spotLightMatrix.value = ho.state.spotLightMatrix, Ac.spotLightMap.value = ho.state.spotLightMap, Ac.pointShadowMap.value = ho.state.pointShadowMap, Ac.pointShadowMatrix.value = ho.state.pointShadowMatrix), ls.currentProgram = gc, ls.uniformsList = null, gc;
                        }
                        function getUniformList(le1) {
                            if (null === le1.uniformsList) {
                                const vt = le1.currentProgram.getUniforms();
                                le1.uniformsList = WebGLUniforms.seqWithValue(vt.seq, le1.uniforms);
                            }
                            return le1.uniformsList;
                        }
                        function updateCommonMaterialProperties(le1, vt) {
                            const bt = Am.get(le1);
                            bt.outputColorSpace = vt.outputColorSpace, bt.batching = vt.batching, bt.batchingColor = vt.batchingColor, bt.instancing = vt.instancing, bt.instancingColor = vt.instancingColor, bt.instancingMorph = vt.instancingMorph, bt.skinning = vt.skinning, bt.morphTargets = vt.morphTargets, bt.morphNormals = vt.morphNormals, bt.morphColors = vt.morphColors, bt.morphTargetsCount = vt.morphTargetsCount, bt.numClippingPlanes = vt.numClippingPlanes, bt.numIntersection = vt.numClipIntersection, bt.vertexAlphas = vt.vertexAlphas, bt.vertexTangents = vt.vertexTangents, bt.toneMapping = vt.toneMapping;
                        }
                        jm.setAnimationLoop(function(le1) {
                            Bm && Bm(le1);
                        }), "undefined" !== typeof self && jm.setContext(self), this.setAnimationLoop = function(le1) {
                            Bm = le1, Om.setAnimationLoop(le1), null === le1 ? jm.stop() : jm.start();
                        }, Om.addEventListener("sessionstart", onXRSessionStart), Om.addEventListener("sessionend", onXRSessionEnd), this.render = function(le1, vt) {
                            if (void 0 !== vt && !0 !== vt.isCamera) return void console.error("THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.");
                            if (!0 === jd) return;
                            if (!0 === le1.matrixWorldAutoUpdate && le1.updateMatrixWorld(), null === vt.parent && !0 === vt.matrixWorldAutoUpdate && vt.updateMatrixWorld(), !0 === Om.enabled && !0 === Om.isPresenting && (!0 === Om.cameraAutoUpdate && Om.updateCamera(vt), vt = Om.getCamera()), !0 === le1.isScene && le1.onBeforeRender(Od, le1, vt, qd), Ld = Tm.get(le1, Rd.length), Ld.init(vt), Rd.push(Ld), lm.multiplyMatrices(vt.projectionMatrix, vt.matrixWorldInverse), am.setFromProjectionMatrix(lm, ls.TdN, vt.reversedDepth), om = this.localClippingEnabled, sm = km.init(this.clippingPlanes, om), Md = Sm.get(le1, Nd.length), Md.init(), Nd.push(Md), !0 === Om.enabled && !0 === Om.isPresenting) {
                                const le1 = Od.xr.getDepthSensingMesh();
                                null !== le1 && projectObject(le1, vt, -1 / 0, Od.sortObjects);
                            }
                            projectObject(le1, vt, 0, Od.sortObjects), Md.finish(), !0 === Od.sortObjects && Md.sort(em, tm), dm = !1 === Om.enabled || !1 === Om.isPresenting || !1 === Om.hasDepthSensing(), dm && Im.addToRenderList(Md, le1), this.info.render.frame++, !0 === sm && km.beginShadows();
                            const bt = Ld.state.shadowsArray;
                            Cm.render(bt, le1, vt), !0 === sm && km.endShadows(), !0 === this.info.autoReset && this.info.reset();
                            const ho = Md.opaque, Dl = Md.transmissive;
                            if (Ld.setupLights(), vt.isArrayCamera) {
                                const bt = vt.cameras;
                                if (Dl.length > 0) for(let vt = 0, ls = bt.length; vt < ls; vt++)renderTransmissionPass(ho, Dl, le1, bt[vt]);
                                dm && Im.render(le1);
                                for(let vt = 0, ls = bt.length; vt < ls; vt++){
                                    const ls = bt[vt];
                                    renderScene(Md, le1, ls, ls.viewport);
                                }
                            } else Dl.length > 0 && renderTransmissionPass(ho, Dl, le1, vt), dm && Im.render(le1), renderScene(Md, le1, vt);
                            null !== qd && 0 === Gd && (_m.updateMultisampleRenderTarget(qd), _m.updateRenderTargetMipmap(qd)), !0 === le1.isScene && le1.onAfterRender(Od, le1, vt), Nm.resetDefaultState(), Hd = -1, Wd = null, Rd.pop(), Rd.length > 0 ? (Ld = Rd[Rd.length - 1], !0 === sm && km.setGlobalState(Od.clippingPlanes, Ld.state.camera)) : Ld = null, Nd.pop(), Md = Nd.length > 0 ? Nd[Nd.length - 1] : null;
                        }, this.getActiveCubeFace = function() {
                            return Ud;
                        }, this.getActiveMipmapLevel = function() {
                            return Gd;
                        }, this.getRenderTarget = function() {
                            return qd;
                        }, this.setRenderTargetTextures = function(le1, vt, bt) {
                            const ls = Am.get(le1);
                            ls.__autoAllocateDepthBuffer = !1 === le1.resolveDepthBuffer, !1 === ls.__autoAllocateDepthBuffer && (ls.__useRenderToTexture = !1), Am.get(le1.texture).__webglTexture = vt, Am.get(le1.depthTexture).__webglTexture = ls.__autoAllocateDepthBuffer ? void 0 : bt, ls.__hasExternalTextures = !0;
                        }, this.setRenderTargetFramebuffer = function(le1, vt) {
                            const bt = Am.get(le1);
                            bt.__webglFramebuffer = vt, bt.__useDefaultFramebuffer = void 0 === vt;
                        };
                        const Um = Fm.createFramebuffer();
                        this.setRenderTarget = function(le1, vt, bt) {
                            void 0 === vt && (vt = 0), void 0 === bt && (bt = 0), qd = le1, Ud = vt, Gd = bt;
                            let ls = !0, ho = null, Dl = !1, Fl = !1;
                            if (le1) {
                                const sc = Am.get(le1);
                                if (void 0 !== sc.__useDefaultFramebuffer) fm.bindFramebuffer(Fm.FRAMEBUFFER, null), ls = !1;
                                else if (void 0 === sc.__webglFramebuffer) _m.setupRenderTarget(le1);
                                else if (sc.__hasExternalTextures) _m.rebindTextures(le1, Am.get(le1.texture).__webglTexture, Am.get(le1.depthTexture).__webglTexture);
                                else if (le1.depthBuffer) {
                                    const vt = le1.depthTexture;
                                    if (sc.__boundDepthTexture !== vt) {
                                        if (null !== vt && Am.has(vt) && (le1.width !== vt.image.width || le1.height !== vt.image.height)) throw new Error("WebGLRenderTarget: Attached DepthTexture is initialized to the incorrect size.");
                                        _m.setupDepthRenderbuffer(le1);
                                    }
                                }
                                const uc = le1.texture;
                                (uc.isData3DTexture || uc.isDataArrayTexture || uc.isCompressedArrayTexture) && (Fl = !0);
                                const mc = Am.get(le1).__webglFramebuffer;
                                le1.isWebGLCubeRenderTarget ? (ho = Array.isArray(mc[vt]) ? mc[vt][bt] : mc[vt], Dl = !0) : ho = le1.samples > 0 && !1 === _m.useMultisampledRTT(le1) ? Am.get(le1).__webglMultisampledFramebuffer : Array.isArray(mc) ? mc[bt] : mc, Zd.copy(le1.viewport), Yd.copy(le1.scissor), Qd = le1.scissorTest;
                            } else Zd.copy(im).multiplyScalar(sp).floor(), Yd.copy(nm).multiplyScalar(sp).floor(), Qd = rm;
                            0 !== bt && (ho = Um);
                            if (fm.bindFramebuffer(Fm.FRAMEBUFFER, ho) && ls && fm.drawBuffers(le1, ho), fm.viewport(Zd), fm.scissor(Yd), fm.setScissorTest(Qd), Dl) {
                                const ls = Am.get(le1.texture);
                                Fm.framebufferTexture2D(Fm.FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Fm.TEXTURE_CUBE_MAP_POSITIVE_X + vt, ls.__webglTexture, bt);
                            } else if (Fl) {
                                const ls = vt;
                                for(let vt = 0; vt < le1.textures.length; vt++){
                                    const ho = Am.get(le1.textures[vt]);
                                    Fm.framebufferTextureLayer(Fm.FRAMEBUFFER, Fm.COLOR_ATTACHMENT0 + vt, ho.__webglTexture, bt, ls);
                                }
                            } else if (null !== le1 && 0 !== bt) {
                                const vt = Am.get(le1.texture);
                                Fm.framebufferTexture2D(Fm.FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Fm.TEXTURE_2D, vt.__webglTexture, bt);
                            }
                            Hd = -1;
                        }, this.readRenderTargetPixels = function(le1, vt, bt, ls, ho, Dl, Fl, sc) {
                            if (void 0 === sc && (sc = 0), !le1 || !le1.isWebGLRenderTarget) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                            let uc = Am.get(le1).__webglFramebuffer;
                            if (le1.isWebGLCubeRenderTarget && void 0 !== Fl && (uc = uc[Fl]), uc) {
                                fm.bindFramebuffer(Fm.FRAMEBUFFER, uc);
                                try {
                                    const Fl = le1.textures[sc], uc = Fl.format, mc = Fl.type;
                                    if (!mm.textureFormatReadable(uc)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.");
                                    if (!mm.textureTypeReadable(mc)) return void console.error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.");
                                    vt >= 0 && vt <= le1.width - ls && bt >= 0 && bt <= le1.height - ho && (le1.textures.length > 1 && Fm.readBuffer(Fm.COLOR_ATTACHMENT0 + sc), Fm.readPixels(vt, bt, ls, ho, zm.convert(uc), zm.convert(mc), Dl));
                                } finally{
                                    const le1 = null !== qd ? Am.get(qd).__webglFramebuffer : null;
                                    fm.bindFramebuffer(Fm.FRAMEBUFFER, le1);
                                }
                            }
                        }, this.readRenderTargetPixelsAsync = async function(le1, vt, bt, ho, Dl, Fl, sc, uc) {
                            if (void 0 === uc && (uc = 0), !le1 || !le1.isWebGLRenderTarget) throw new Error("THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.");
                            let mc = Am.get(le1).__webglFramebuffer;
                            if (le1.isWebGLCubeRenderTarget && void 0 !== sc && (mc = mc[sc]), mc) {
                                if (vt >= 0 && vt <= le1.width - ho && bt >= 0 && bt <= le1.height - Dl) {
                                    fm.bindFramebuffer(Fm.FRAMEBUFFER, mc);
                                    const sc = le1.textures[uc], gc = sc.format, Ac = sc.type;
                                    if (!mm.textureFormatReadable(gc)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in RGBA or implementation defined format.");
                                    if (!mm.textureTypeReadable(Ac)) throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: renderTarget is not in UnsignedByteType or implementation defined type.");
                                    const Ec = Fm.createBuffer();
                                    Fm.bindBuffer(Fm.PIXEL_PACK_BUFFER, Ec), Fm.bufferData(Fm.PIXEL_PACK_BUFFER, Fl.byteLength, Fm.STREAM_READ), le1.textures.length > 1 && Fm.readBuffer(Fm.COLOR_ATTACHMENT0 + uc), Fm.readPixels(vt, bt, ho, Dl, zm.convert(gc), zm.convert(Ac), 0);
                                    const kc = null !== qd ? Am.get(qd).__webglFramebuffer : null;
                                    fm.bindFramebuffer(Fm.FRAMEBUFFER, kc);
                                    const du = Fm.fenceSync(Fm.SYNC_GPU_COMMANDS_COMPLETE, 0);
                                    return Fm.flush(), await (0, ls.jej)(Fm, du, 4), Fm.bindBuffer(Fm.PIXEL_PACK_BUFFER, Ec), Fm.getBufferSubData(Fm.PIXEL_PACK_BUFFER, 0, Fl), Fm.deleteBuffer(Ec), Fm.deleteSync(du), Fl;
                                }
                                throw new Error("THREE.WebGLRenderer.readRenderTargetPixelsAsync: requested read bounds are out of range.");
                            }
                        }, this.copyFramebufferToTexture = function(le1, vt, bt) {
                            void 0 === vt && (vt = null), void 0 === bt && (bt = 0);
                            const ls = Math.pow(2, -bt), ho = Math.floor(le1.image.width * ls), Dl = Math.floor(le1.image.height * ls), Fl = null !== vt ? vt.x : 0, sc = null !== vt ? vt.y : 0;
                            _m.setTexture2D(le1, 0), Fm.copyTexSubImage2D(Fm.TEXTURE_2D, bt, 0, 0, Fl, sc, ho, Dl), fm.unbindTexture();
                        };
                        const Vm = Fm.createFramebuffer(), Gm = Fm.createFramebuffer();
                        this.copyTextureToTexture = function(le1, vt, bt, ho, Dl, Fl) {
                            let sc, uc, mc, gc, Ac, Ec, kc, du, _u;
                            void 0 === bt && (bt = null), void 0 === ho && (ho = null), void 0 === Dl && (Dl = 0), void 0 === Fl && (Fl = null), null === Fl && (0 !== Dl ? ((0, ls.mcG)("WebGLRenderer: copyTextureToTexture function signature has changed to support src and dst mipmap levels."), Fl = Dl, Dl = 0) : Fl = 0);
                            const Md = le1.isCompressedTexture ? le1.mipmaps[Fl] : le1.image;
                            if (null !== bt) sc = bt.max.x - bt.min.x, uc = bt.max.y - bt.min.y, mc = bt.isBox3 ? bt.max.z - bt.min.z : 1, gc = bt.min.x, Ac = bt.min.y, Ec = bt.isBox3 ? bt.min.z : 0;
                            else {
                                const vt = Math.pow(2, -Dl);
                                sc = Math.floor(Md.width * vt), uc = Math.floor(Md.height * vt), mc = le1.isDataArrayTexture ? Md.depth : le1.isData3DTexture ? Math.floor(Md.depth * vt) : 1, gc = 0, Ac = 0, Ec = 0;
                            }
                            null !== ho ? (kc = ho.x, du = ho.y, _u = ho.z) : (kc = 0, du = 0, _u = 0);
                            const Ld = zm.convert(vt.format), Nd = zm.convert(vt.type);
                            let Rd;
                            vt.isData3DTexture ? (_m.setTexture3D(vt, 0), Rd = Fm.TEXTURE_3D) : vt.isDataArrayTexture || vt.isCompressedArrayTexture ? (_m.setTexture2DArray(vt, 0), Rd = Fm.TEXTURE_2D_ARRAY) : (_m.setTexture2D(vt, 0), Rd = Fm.TEXTURE_2D), Fm.pixelStorei(Fm.UNPACK_FLIP_Y_WEBGL, vt.flipY), Fm.pixelStorei(Fm.UNPACK_PREMULTIPLY_ALPHA_WEBGL, vt.premultiplyAlpha), Fm.pixelStorei(Fm.UNPACK_ALIGNMENT, vt.unpackAlignment);
                            const Od = Fm.getParameter(Fm.UNPACK_ROW_LENGTH), jd = Fm.getParameter(Fm.UNPACK_IMAGE_HEIGHT), Ud = Fm.getParameter(Fm.UNPACK_SKIP_PIXELS), Gd = Fm.getParameter(Fm.UNPACK_SKIP_ROWS), qd = Fm.getParameter(Fm.UNPACK_SKIP_IMAGES);
                            Fm.pixelStorei(Fm.UNPACK_ROW_LENGTH, Md.width), Fm.pixelStorei(Fm.UNPACK_IMAGE_HEIGHT, Md.height), Fm.pixelStorei(Fm.UNPACK_SKIP_PIXELS, gc), Fm.pixelStorei(Fm.UNPACK_SKIP_ROWS, Ac), Fm.pixelStorei(Fm.UNPACK_SKIP_IMAGES, Ec);
                            const Hd = le1.isDataArrayTexture || le1.isData3DTexture, Wd = vt.isDataArrayTexture || vt.isData3DTexture;
                            if (le1.isDepthTexture) {
                                const bt = Am.get(le1), ls = Am.get(vt), ho = Am.get(bt.__renderTarget), Md = Am.get(ls.__renderTarget);
                                fm.bindFramebuffer(Fm.READ_FRAMEBUFFER, ho.__webglFramebuffer), fm.bindFramebuffer(Fm.DRAW_FRAMEBUFFER, Md.__webglFramebuffer);
                                for(let Ld = 0; Ld < mc; Ld++)Hd && (Fm.framebufferTextureLayer(Fm.READ_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Am.get(le1).__webglTexture, Dl, Ec + Ld), Fm.framebufferTextureLayer(Fm.DRAW_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Am.get(vt).__webglTexture, Fl, _u + Ld)), Fm.blitFramebuffer(gc, Ac, sc, uc, kc, du, sc, uc, Fm.DEPTH_BUFFER_BIT, Fm.NEAREST);
                                fm.bindFramebuffer(Fm.READ_FRAMEBUFFER, null), fm.bindFramebuffer(Fm.DRAW_FRAMEBUFFER, null);
                            } else if (0 !== Dl || le1.isRenderTargetTexture || Am.has(le1)) {
                                const bt = Am.get(le1), ls = Am.get(vt);
                                fm.bindFramebuffer(Fm.READ_FRAMEBUFFER, Vm), fm.bindFramebuffer(Fm.DRAW_FRAMEBUFFER, Gm);
                                for(let le1 = 0; le1 < mc; le1++)Hd ? Fm.framebufferTextureLayer(Fm.READ_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, bt.__webglTexture, Dl, Ec + le1) : Fm.framebufferTexture2D(Fm.READ_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Fm.TEXTURE_2D, bt.__webglTexture, Dl), Wd ? Fm.framebufferTextureLayer(Fm.DRAW_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, ls.__webglTexture, Fl, _u + le1) : Fm.framebufferTexture2D(Fm.DRAW_FRAMEBUFFER, Fm.COLOR_ATTACHMENT0, Fm.TEXTURE_2D, ls.__webglTexture, Fl), 0 !== Dl ? Fm.blitFramebuffer(gc, Ac, sc, uc, kc, du, sc, uc, Fm.COLOR_BUFFER_BIT, Fm.NEAREST) : Wd ? Fm.copyTexSubImage3D(Rd, Fl, kc, du, _u + le1, gc, Ac, sc, uc) : Fm.copyTexSubImage2D(Rd, Fl, kc, du, gc, Ac, sc, uc);
                                fm.bindFramebuffer(Fm.READ_FRAMEBUFFER, null), fm.bindFramebuffer(Fm.DRAW_FRAMEBUFFER, null);
                            } else Wd ? le1.isDataTexture || le1.isData3DTexture ? Fm.texSubImage3D(Rd, Fl, kc, du, _u, sc, uc, mc, Ld, Nd, Md.data) : vt.isCompressedArrayTexture ? Fm.compressedTexSubImage3D(Rd, Fl, kc, du, _u, sc, uc, mc, Ld, Md.data) : Fm.texSubImage3D(Rd, Fl, kc, du, _u, sc, uc, mc, Ld, Nd, Md) : le1.isDataTexture ? Fm.texSubImage2D(Fm.TEXTURE_2D, Fl, kc, du, sc, uc, Ld, Nd, Md.data) : le1.isCompressedTexture ? Fm.compressedTexSubImage2D(Fm.TEXTURE_2D, Fl, kc, du, Md.width, Md.height, Ld, Md.data) : Fm.texSubImage2D(Fm.TEXTURE_2D, Fl, kc, du, sc, uc, Ld, Nd, Md);
                            Fm.pixelStorei(Fm.UNPACK_ROW_LENGTH, Od), Fm.pixelStorei(Fm.UNPACK_IMAGE_HEIGHT, jd), Fm.pixelStorei(Fm.UNPACK_SKIP_PIXELS, Ud), Fm.pixelStorei(Fm.UNPACK_SKIP_ROWS, Gd), Fm.pixelStorei(Fm.UNPACK_SKIP_IMAGES, qd), 0 === Fl && vt.generateMipmaps && Fm.generateMipmap(Rd), fm.unbindTexture();
                        }, this.copyTextureToTexture3D = function(le1, vt, bt, ho, Dl) {
                            return void 0 === bt && (bt = null), void 0 === ho && (ho = null), void 0 === Dl && (Dl = 0), (0, ls.mcG)('WebGLRenderer: copyTextureToTexture3D function has been deprecated. Use "copyTextureToTexture" instead.'), this.copyTextureToTexture(le1, vt, bt, ho, Dl);
                        }, this.initRenderTarget = function(le1) {
                            void 0 === Am.get(le1).__webglFramebuffer && _m.setupRenderTarget(le1);
                        }, this.initTexture = function(le1) {
                            le1.isCubeTexture ? _m.setTextureCube(le1, 0) : le1.isData3DTexture ? _m.setTexture3D(le1, 0) : le1.isDataArrayTexture || le1.isCompressedArrayTexture ? _m.setTexture2DArray(le1, 0) : _m.setTexture2D(le1, 0), fm.unbindTexture();
                        }, this.resetState = function() {
                            Ud = 0, Gd = 0, qd = null, fm.reset(), Nm.reset();
                        }, "undefined" !== typeof __THREE_DEVTOOLS__ && __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent("observe", {
                            detail: this
                        }));
                    }
                    get coordinateSystem() {
                        return ls.TdN;
                    }
                    get outputColorSpace() {
                        return this._outputColorSpace;
                    }
                    set outputColorSpace(le1) {
                        this._outputColorSpace = le1;
                        const vt = this.getContext();
                        vt.drawingBufferColorSpace = ls.ppV._getDrawingBufferColorSpace(le1), vt.unpackColorSpace = ls.ppV._getUnpackColorSpace();
                    }
                }
            },
            8330: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"rE":"4.4.0","Jk":{"O":"https://gitlab.com/panoramax/clients/web-viewer"}}');
            },
            3087: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"\u0412\u044b\u043a\u0430\u0440\u044b\u0441\u0442\u043e\u045e\u0432\u0430\u0439\u0446\u0435 \u0434\u0432\u0430 \u043f\u0430\u043b\u044c\u0446\u044b \u0434\u043b\u044f \u043d\u0430\u0432\u0456\u0433\u0430\u0446\u044b\u0456","ctrlZoom":"\u0412\u044b\u043a\u0430\u0440\u044b\u0441\u0442\u043e\u045e\u0432\u0430\u0439\u0446\u0435 ctrl + \u043f\u0440\u043e\u043a\u0440\u0443\u0442\u043a\u0430 \u0434\u043b\u044f \u043c\u0430\u0448\u0442\u0430\u0431\u0430\u0432\u0430\u043d\u043d\u044f \u0432\u044b\u044f\u0432\u044b","loadError":"\u041f\u0430\u043d\u0430\u0440\u0430\u043c\u0443 \u043d\u0435\u043c\u0430\u0433\u0447\u044b\u043c\u0430 \u0437\u0430\u0433\u0440\u0443\u0437\u0456\u0446\u044c"},"maplibre":{"GeolocateControl.FindMyLocation":"\u0417\u043d\u0430\u0439\u0441\u0446\u0456 \u043c\u0430\u0451 \u043c\u0435\u0441\u0446\u0430\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0430\u043d\u043d\u0435","GeolocateControl.LocationNotAvailable":"\u041c\u0435\u0441\u0446\u0430\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0430\u043d\u043d\u0435 \u043d\u0435\u0434\u0430\u0441\u0442\u0443\u043f\u043d\u0430"},"pnx":{"zoom":"\u041c\u0430\u0448\u0442\u0430\u0431","zoomOut":"\u0410\u0434\u0434\u0430\u043b\u0456\u0446\u044c","zoomIn":"\u041d\u0430\u0431\u043b\u0456\u0437\u0456\u0446\u044c","moveUp":"\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045e\u0432\u0435\u0440\u0445","search_user":"\u0428\u0443\u043a\u0430\u0446\u044c \u0456\u043c\u044f \u043a\u0430\u0440\u044b\u0441\u0442\u0430\u043b\u044c\u043d\u0456\u043a\u0430\u2026","share":"\u041f\u0430\u0434\u0437\u044f\u043b\u0456\u0446\u0446\u0430","share_links":"\u0421\u043f\u0430\u0441\u044b\u043b\u043a\u0456","share_page":"\u0421\u043f\u0430\u0441\u044b\u043b\u043a\u0430 \u043d\u0430 \u0433\u044d\u0442\u0443 \u0432\u044b\u044f\u0432\u0443","share_image":"\u0412\u044b\u044f\u0432\u0430 \u0432\u044b\u0441\u043e\u043a\u0430\u0439 \u044f\u043a\u0430\u0441\u0446\u0456","share_rss":"RSS \u0441\u0442\u0443\u0436\u043a\u0430","share_rss_title":"RSS \u0441\u0442\u0443\u0436\u043a\u0430 \u043d\u043e\u0432\u044b\u0445 \u0441\u0435\u0440\u044b\u0439 \u0443 \u0431\u0430\u0447\u043d\u0430\u0439 \u0432\u043e\u0431\u043b\u0430\u0441\u0446\u0456 \u043a\u0430\u0440\u0442\u044b","share_embed":"\u0423\u0431\u0443\u0434\u0430\u0432\u0430\u0446\u044c \u043d\u0430 \u0412\u0430\u0448 \u0441\u0430\u0439\u0442","share_embed_docs":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u043d\u0430\u043b\u0430\u0434\u043a\u0443 \u045e\u0431\u0443\u0434\u043e\u0432\u044b","share_print":"\u0414\u0440\u0443\u043a","panoramax":"Panoramax","copy":"\u041a\u0430\u043f\u0456\u044f\u0432\u0430\u0446\u044c","loading_labels_serious":["\ud83d\uddfa\ufe0f \u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0434\u0430\u043d\u044b\u0445 \u043a\u0430\u0440\u0442\u044b","\ud83d\udda5\ufe0f \u0417\u0430\u043f\u044b\u0442 \u0434\u0430 API","\ud83d\uddbc\ufe0f \u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u043c\u0456\u043d\u0456\u044f\u0446\u044e\u0440","\ud83d\udd0d \u0410\u043d\u0430\u043b\u0456\u0437 EXIF \u043c\u0435\u0442\u0430\u0434\u0430\u043d\u044b\u0445","\ud83c\udfd8\ufe0f 3D \u0440\u044d\u043d\u0434\u044d\u0440\u044b\u043d\u0433","\ud83d\udcf7 \u0406\u043d\u0456\u0446\u044b\u044f\u043b\u0456\u0437\u0430\u0446\u044b\u044f 360\xb0 \u0432\u044b\u044f\u045e","\ud83d\udfe0 \u0411\u0430\u043b\u0430\u043d\u0441 \u043a\u043e\u043b\u0435\u0440\u0430\u045e","\ud83d\udcaf \u0420\u0430\u0437\u043b\u0456\u043a \u0430\u0434\u0437\u043d\u0430\u043a\u0456 \u044f\u043a\u0430\u0441\u0446\u0456 \xa9","\ud83d\udce1 \u0421\u0446\u044f\u0433\u0432\u0430\u043d\u043d\u0435 \u0430\u0431\u043d\u0430\u045e\u043b\u0435\u043d\u043d\u044f\u045e","\ud83c\udf0d \u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430 \u0442\u0430\u0439\u043b\u0430\u045e \u043a\u0430\u0440\u0442\u044b","\ud83d\udcf8 \u0410\u043f\u0440\u0430\u0446\u043e\u045e\u043a\u0430 \u0446\u0435\u043d\u044f\u045e"],"loading_labels_fun":["\ud83e\udd8c \u0412\u044b\u044f\u045e\u043b\u0435\u043d\u043d\u0435 \u0437\u043d\u0430\u043a\u0430\u045e \u043f\u0435\u0440\u0430\u0445\u043e\u0434\u0443 \u0430\u043b\u0435\u043d\u044f\u045e","\ud83d\ude98 \u041f\u043e\u0448\u0443\u043a \u0430\u045e\u0442\u0430\u043c\u0430\u0431\u0456\u043b\u044f Panoramax\xa9","\u2615 \u0406\u043d\'\u0435\u043a\u0446\u044b\u044f \u043a\u0430\u0444\u0435\u0456\u043d\u0443","\ud83d\ude00 \u0423\u0441\u043c\u0456\u0445\u043d\u0456\u0446\u0435\u0441\u044f, \u0432\u044b \u043d\u0430 \u043a\u0430\u0440\u0446\u0435!","\ud83d\udc08 \u041f\u0430\u0434\u0437\u044f\u043b\u044f\u0435\u043c\u0441\u044f \u0444\u0430\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u044f\u043c\u0456 \u043a\u0430\u0442\u043a\u043e\u045e","\ud83d\ude34 \u0417\u043c\u044f\u043d\u0448\u044d\u043d\u043d\u0435 \u043f\u0440\u0430\u043a\u0440\u0430\u0441\u0442\u044b\u043d\u0430\u0446\u044b\u0456","\ud83e\uded6 \u0417\u0430\u0432\u0430\u0440\u0432\u0430\u043d\u043d\u0435 \u0433\u0430\u0440\u0431\u0430\u0442\u044b","\ud83d\udc27 \u0410\u0434\u043a\u0440\u044b\u0446\u0446\u0451 \u0437\u044b\u0445\u043e\u0434\u043d\u0430\u0433\u0430 \u043a\u043e\u0434\u0430","\ud83d\ude87 \u0406\u043d\u0434\u044d\u043a\u0441\u0430\u0446\u044b\u044f \u0441\u0442\u0430\u043d\u0446\u044b\u0439 \u043c\u0435\u0442\u0440\u043e","\ud83e\uddf9 \u041f\u0440\u044b\u0431\u0456\u0440\u0430\u0435\u043c \u045e\u0441\u0451 \u0441\u043c\u0435\u0446\u0446\u0435 \u0437 \u0432\u0443\u043b\u0456\u0446","\ud83d\ude92 \u0420\u0430\u0441\u0447\u044b\u0448\u0447\u0430\u0435\u043c \u0432\u0443\u043b\u0456\u0446\u044b \u0430\u0434 \u043c\u0430\u0448\u044b\u043d \u0434\u043b\u044f \u043f\u0440\u0430\u0435\u0437\u0434\u0443 \u043f\u0430\u0436\u0430\u0440\u043d\u044b\u0445","\ud83c\udf33 \u041f\u0435\u0440\u0430\u043b\u0456\u0447\u0432\u0430\u0435\u043c \u043b\u044f\u0441\u043d\u044b\u044f \u0441\u0446\u0435\u0436\u0430\u0447\u043a\u0456 \u045e \u0411\u0435\u043b\u0430\u0432\u0435\u0436\u0441\u043a\u0430\u0439 \u043f\u0443\u0448\u0447\u044b... \u0410\u0434\u043d\u0430, \u0434\u0440\u0443\u0433\u0430\u044f, \u0442\u0440\u044d\u0446\u044f\u044f... \u0417\u0431\u0456\u043b\u0456\u0441\u044f! \u041f\u0430\u0447\u044b\u043d\u0430\u0435\u043c \u0441\u043f\u0430\u0447\u0430\u0442\u043a\u0443!","\ud83d\ude89 \u0410\u0433\u043b\u044f\u0434 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c \u0441\u0442\u0430\u043d\u0446\u044b\u0439","\ud83d\udef0\ufe0f \u041f\u043e\u0448\u0443\u043a \u0441\u043f\u0430\u0434\u0430\u0440\u043e\u0436\u043d\u0456\u043a\u0430\u045e","\ud83d\udc65 \u0421\u0442\u0432\u0430\u0440\u044d\u043d\u043d\u0435 \u043f\u0435\u0440\u0441\u043e\u043d","\ud83d\udc1f \u041b\u0430\u043a\u0430\u0446\u044b\u044f \u0440\u044b\u0431\u043d\u044b\u0445 \u043a\u0440\u0430\u043c","\ud83e\uddd1\u200d\ud83d\udcbb \u0410\u0434\u043b\u0430\u0434\u043a\u0430 \u0456\u043d\u0442\u044d\u0440\u0444\u0435\u0439\u0441\u0443","\ud83d\udcc8 \u041f\u0430\u0432\u0435\u043b\u0456\u0447\u044d\u043d\u043d\u0435 \u0441\u0442\u0430\u0442\u044b\u0441\u0442\u044b\u043a\u0456","\ud83e\udd16 \u0412\u044b\u0432\u0443\u0447\u044d\u043d\u043d\u0435 \u0441\u0435\u043c\u0430\u043d\u0442\u044b\u043a\u0456","\ud83c\udfa8 \u0420\u044d\u0434\u044b\u0437\u0430\u0439\u043d \u0456\u043d\u0442\u044d\u0440\u0444\u0435\u0439\u0441\u0443","\ud83d\udcc5 \u041f\u043b\u0430\u043d\u0430\u0432\u0430\u043d\u043d\u0435 \u0444\u043e\u0442\u0430-\u043a\u0430\u0440\u0442\u0430\u0433\u0440\u0430\u0444\u0456\u0447\u043d\u044b\u0445 \u0432\u0435\u0447\u0430\u0440\u044b\u043d","\ud83e\uddc0 \u041f\u0430\u0441\u043f\u044f\u0432\u0430\u043d\u043d\u0435 \u043a\u043b\u0456\u043d\u043a\u043e\u0432\u0430\u0433\u0430 \u0441\u044b\u0440\u0443","\ud83c\udf04 \u0427\u0430\u043a\u0430\u0435\u043c \u043d\u0430\u0441\u0442\u0443\u043f\u0443 \u0441\u0432\u0456\u0442\u0430\u043d\u043a\u0443","\ud83c\udf0a \u0412\u044b\u043c\u044f\u0440\u044d\u043d\u043d\u0435 \u043f\u0440\u044b\u043b\u0456\u0432\u0430\u045e"],"qualityscore_doc_3":"\u042f\u043d\u0430 \u0440\u0430\u0437\u043b\u0456\u0447\u0432\u0430\u0435\u0446\u0446\u0430 \u043d\u0430 \u0430\u0441\u043d\u043e\u0432\u0435 \u0434\u0430\u043a\u043b\u0430\u0434\u043d\u0430\u0441\u0446\u0456 GPS \u0456 \u0440\u0430\u0437\u0434\u0437\u044f\u043b\u044f\u043b\u044c\u043d\u0430\u0441\u0446\u0456 \u0432\u044b\u044f\u0432\u044b. \u041f\u0440\u0430\u0444\u0435\u0441\u0456\u0439\u043d\u0430\u044f \u0441\u0456\u0441\u0442\u044d\u043c\u0430 \u0431\u0443\u0434\u0437\u0435 \u043c\u0435\u0446\u044c \u0430\u0434\u0437\u043d\u0430\u043a\u0443 A, \u044d\u043a\u0448\u043d-\u043a\u0430\u043c\u0435\u0440\u0430 360\xb0 - B, \u0430 \u0441\u043c\u0430\u0440\u0442\u0444\u043e\u043d - C/D/E.","qualityscore_doc_link":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u0430\u0434\u0437\u043d\u0430\u043a\u0443 \u044f\u043a\u0430\u0441\u0446\u0456","filter_gps_precision":"\u0414\u0430\u043a\u043b\u0430\u0434\u043d\u0430\u0441\u0446\u044c \u043f\u0430\u0437\u0456\u0446\u044b\u044f\u043d\u0430\u0432\u0430\u043d\u043d\u044f","filter_gps_precision_between":"\u041f\u0430\u043c\u0456\u0436 {n1} \u0456 {n2} \u043c\u0435\u0442\u0440\u0430\u043c\u0456","filter_gps_precision_morethan":"\u0411\u043e\u043b\u044c\u0448 \u0437\u0430 {n} \u043c\u0435\u0442\u0440\u0430\u045e","map_theme_age":"\u0414\u0430\u0442\u0430 \u0437\u0434\u044b\u043c\u043a\u0456","map_theme_type":"\u0422\u044b\u043f \u043a\u0430\u043c\u0435\u0440\u044b","map_theme_score":"\u0410\u0434\u0437\u043d\u0430\u043a\u0430 \u044f\u043a\u0430\u0441\u0446\u0456","map_theme_gps":"\u0414\u0430\u043a\u043b\u0430\u0434\u043d\u0430\u0441\u0446\u044c \u043f\u0430\u0437\u0456\u0446\u044b\u044f\u043d\u0430\u0432\u0430\u043d\u043d\u044f","map_theme_age_1":"> 2 \u0433\u0430\u0434\u044b","map_theme_age_2":"< 2 \u0433\u0430\u0434\u044b","map_theme_age_3":"< 1 \u0433\u043e\u0434","map_theme_age_4":"< 1 \u043c\u0435\u0441\u044f\u0446","contrast":"\u0423\u043a\u043b\u044e\u0447\u044b\u0446\u044c \u0431\u043e\u043b\u044c\u0448\u044b \u043a\u0430\u043d\u0442\u0440\u0430\u0441\u0442 \u0432\u044b\u044f\u0432\u044b","metadata":"\u041c\u0435\u0442\u0430\u0434\u0430\u043d\u044b\u044f \u0432\u044b\u044f\u0432\u044b","metadata_summary":"\u0410\u043f\u0456\u0441\u0430\u043d\u043d\u0435","metadata_location_coordinates":"\u041a\u0430\u0430\u0440\u0434\u044b\u043d\u0430\u0442\u044b (\u0434\u0430\u045e\u0433\u0430\u0442\u0430, \u0448\u044b\u0440\u0430\u0442\u0430)","metadata_location_orientation":"\u041d\u0430\u043f\u0440\u0430\u043c\u0430\u043a","metadata_location_precision":"\u0414\u0430\u043a\u043b\u0430\u0434\u043d\u0430\u0441\u0446\u044c \u043f\u0430\u0437\u0456\u0446\u044b\u044f\u043d\u0430\u0432\u0430\u043d\u043d\u044f","metadata_location_copy":"\u041a\u0430\u043f\u0456\u044f\u0432\u0430\u0446\u044c {v}","metadata_location_copy_more":"\u0411\u043e\u043b\u044c\u0448 \u043e\u043f\u0446\u044b\u0439 \u043a\u0430\u043f\u0456\u044f\u0432\u0430\u043d\u043d\u044f \u043a\u0430\u0430\u0440\u0434\u044b\u043d\u0430\u0442","metadata_quality":"\u042f\u043a\u0430\u0441\u0446\u044c","metadata_quality_help":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u0430\u0434\u0437\u043d\u0430\u043a\u0443 \u044f\u043a\u0430\u0441\u0446\u0456","metadata_quality_gps_score":"\u0410\u0434\u0437\u043d\u0430\u043a\u0430 \u043f\u0430\u0437\u0456\u0446\u044b\u044f\u043d\u0430\u0432\u0430\u043d\u043d\u044f","metadata_quality_resolution_score":"\u0410\u0434\u0437\u043d\u0430\u043a\u0430 \u0440\u0430\u0437\u0434\u0437\u044f\u043b\u044f\u043b\u044c\u043d\u0430\u0441\u0446\u0456","metadata_quality_missing":"\u0437\u043d\u0430\u0447\u044d\u043d\u043d\u0435 \u043d\u0435 \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043d\u0430 \u045e \u0432\u044b\u044f\u0432\u0435","metadata_exif":"EXIF","metadata_exif_name":"\u0422\u044d\u0433","semantics_features":"\u0410\u0431\'\u0435\u043a\u0442\u044b \u043d\u0430 \u0432\u044b\u044f\u0432\u0435","semantics_features_none":"\u041d\u0430 \u0433\u044d\u0442\u0430\u0439 \u0432\u044b\u044f\u0432\u0435 \u044f\u0448\u0447\u044d \u043d\u0435 \u0432\u044b\u043b\u0443\u0447\u0430\u043d\u044b \u043d\u0456\u0432\u043e\u0434\u043d\u044b \u0430\u0431\'\u0435\u043a\u0442.","semantics_show_all_tags":"\u041f\u0430\u043a\u0430\u0437\u0430\u0446\u044c \u0443\u0441\u0435 \u0442\u044d\u0433\u0456","semantics_hide_all_tags":"\u0421\u0445\u0430\u0432\u0430\u0446\u044c \u0443\u0441\u0435 \u0442\u044d\u0433\u0456","report_nature":{"blur_missing":"\u0411\u0430\u0447\u043d\u044b \u0442\u0432\u0430\u0440 \u0447\u0430\u043b\u0430\u0432\u0435\u043a\u0430 \u0430\u0431\u043e \u043d\u0443\u043c\u0430\u0440\u043d\u044b \u0437\u043d\u0430\u043a \u0430\u045e\u0442\u043e","blur_excess":"\u041d\u0430 \u0430\u0431\'\u0435\u043a\u0442 \u0431\u044b\u045e \u0443\u0436\u044b\u0442\u044b \u043d\u0435\u043f\u0430\u0442\u0440\u044d\u0431\u043d\u0430\u0435 \u0440\u0430\u0437\u043c\u044b\u0446\u0446\u0451","":"\u0412\u044b\u0431\u0435\u0440\u044b\u0446\u0435 \u0442\u044b\u043f \u043f\u0440\u0430\u0431\u043b\u0435\u043c\u044b\u2026","inappropriate":"\u041d\u0435\u0430\u0434\u043f\u0430\u0432\u0435\u0434\u043d\u0430\u044f \u0432\u044b\u044f\u0432\u0430 (\u043d\u0435 \u0437\u0432\u044f\u0437\u0430\u043d\u0430\u044f, \u0430\u0433\u043e\u043b\u0435\u043d\u0430\u0441\u0446\u044c\u2026)","privacy":"\u0411\u0430\u0447\u043d\u044b \u043f\u0440\u044b\u0432\u0430\u0442\u043d\u044b \u0448\u043b\u044f\u0445 \u0430\u0431\u043e \u045e\u043b\u0430\u0441\u043d\u0430\u0441\u0446\u044c","picture_low_quality":"\u0412\u044b\u044f\u0432\u0430 \u043d\u0456\u0437\u043a\u0430\u0439 \u044f\u043a\u0430\u0441\u0446\u0456","mislocated":"\u0412\u044b\u044f\u0432\u0430 \u0434\u0440\u044d\u043d\u043d\u0430 \u0440\u0430\u0437\u043c\u0435\u0448\u0447\u0430\u043d\u0430 \u043d\u0430 \u043a\u0430\u0440\u0446\u0435","copyright":"\u0412\u044b\u044f\u0432\u0430 \u043f\u0430\u0440\u0443\u0448\u0430\u0435 \u0430\u045e\u0442\u0430\u0440\u0441\u043a\u0456\u044f \u043f\u0440\u0430\u0432\u044b","other":"\u041b\u044e\u0431\u044b \u0456\u043d\u0448\u044b \u0432\u0456\u0434 \u043f\u0440\u0430\u0431\u043b\u0435\u043c\u044b"},"semantics_editor_example":"\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u044d\u043d\u043d\u0435\\n\u043f\u0440\u044d\u0444\u0456\u043a\u0441|\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u044d\u043d\u043d\u0435","moveDown":"\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u045e\u043d\u0456\u0437","moveLeft":"\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043d\u0430\u043b\u0435\u0432\u0430","moveRight":"\u0420\u0443\u0445\u0430\u0446\u0446\u0430 \u043d\u0430\u043f\u0440\u0430\u0432\u0430","moveMiddle":"\u0426\u044d\u043d\u0442\u0440\u0430\u0432\u0430\u0446\u044c \u0432\u0456\u0434","expand":"\u0420\u0430\u0437\u0433\u0430\u0440\u043d\u0443\u0446\u044c","expand_info":"\u0410\u0434\u043b\u044e\u0441\u0442\u0440\u0430\u0432\u0430\u0446\u044c \u0432\u0456\u0434\u0436\u044d\u0442 \u043d\u0430 \u045e\u0441\u044e \u0441\u0442\u0430\u0440\u043e\u043d\u043a\u0443","show_psv":"\u041f\u0430\u043a\u0430\u0437\u0430\u0446\u044c \u043f\u0440\u0430\u0433\u043b\u044f\u0434\u0430\u043b\u044c\u043d\u0456\u043a \u0432\u044b\u044f\u045e","show_map":"\u041f\u0430\u043a\u0430\u0437\u0430\u0446\u044c \u043a\u0430\u0440\u0442\u0443","minimize":"\u0421\u0445\u0430\u0432\u0430\u0446\u044c \u0433\u044d\u0442\u044b \u0432\u0456\u0434\u0436\u044d\u0442, \u0412\u044b \u043c\u043e\u0436\u0430\u0446\u0435 \u0437\u043d\u043e\u045e \u043f\u0430\u043a\u0430\u0437\u0430\u0446\u044c \u044f\u0433\u043e \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u043a\u043d\u043e\u043f\u043a\u0456 \u045e \u043b\u0435\u0432\u044b\u043c \u043d\u0456\u0436\u043d\u0456\u043c \u043a\u0443\u0446\u0435","minimize_short":"\u0421\u0445\u0430\u0432\u0430\u0446\u044c","options":"\u041e\u043f\u0446\u044b\u0456","filters":"\u0424\u0456\u043b\u044c\u0442\u0440\u044b","layers":"\u0421\u043b\u0430\u0456","search":"\u041f\u043e\u0448\u0443\u043a","search_empty":"\u0412\u044b\u043d\u0456\u043a\u0430\u045e \u043d\u0435 \u0437\u043d\u043e\u0439\u0434\u0437\u0435\u043d\u0430","search_address":"\u0428\u0443\u043a\u0430\u0446\u044c \u0430\u0434\u0440\u0430\u0441, \u0433\u043e\u0440\u0430\u0434\u2026","whats_panoramax":"Panoramax - \u0433\u044d\u0442\u0430 \u0430\u0434\u043a\u0440\u044b\u0442\u0430\u044f \u0433\u0435\u0430-\u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0430 \u0434\u043b\u044f \u0432\u044b\u044f\u0432\u0430\u045e \u0442\u044d\u0440\u044b\u0442\u043e\u0440\u044b\u0439.","copied":"\u0421\u043a\u0430\u043f\u0456\u044f\u0432\u0430\u043d\u0430","error":"\u0423 \u043d\u0430\u0441 \u043f\u0440\u0430\u0431\u043b\u0435\u043c\u0430\u2026","error_click":"\u041f\u0440\u0430\u0446\u044f\u0433\u0432\u0430\u0446\u044c","error_retry":"\u041a\u0430\u043b\u0456 \u043b\u0430\u0441\u043a\u0430, \u043f\u0430\u0441\u043f\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043f\u0430\u0437\u043d\u0435\u0439","sequence_next":"\u041d\u0430\u0441\u0442\u0443\u043f\u043d\u0430\u044f \u0432\u044b\u044f\u0432\u0430 \u045e \u0441\u0435\u0440\u044b\u0456","sequence_play":"\u041f\u0440\u0430\u0439\u0433\u0440\u0430\u0446\u044c \u0433\u044d\u0442\u0443\u044e \u0441\u0435\u0440\u044b\u044e","sequence_pause":"\u041f\u0440\u044b\u043f\u044b\u043d\u0456\u0446\u044c \u0441\u0435\u0440\u044b\u044e","sequence_prev":"\u041f\u0430\u043f\u044f\u0440\u044d\u0434\u043d\u044f\u044f \u0432\u044b\u044f\u0432\u0430 \u045e \u0441\u0435\u0440\u044b\u0456","sequence_more":"\u0411\u043e\u043b\u044c\u0448 \u043e\u043f\u0446\u044b\u0439 \u043f\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043d\u043d\u044f","sequence_speed":"\u0425\u0443\u0442\u043a\u0430\u0441\u0446\u044c \u043f\u0440\u0430\u0439\u0433\u0440\u0430\u0432\u0430\u043d\u043d\u044f","legend_license":"\u041b\u0456\u0446\u044d\u043d\u0437\u0456\u044f: {l}","legend_title":"\u041f\u0430\u043a\u0430\u0437\u0430\u0446\u044c \u043f\u0430\u0434\u0440\u0430\u0431\u044f\u0437\u043d\u0430\u0441\u0446\u0456 \u0432\u044b\u044f\u0432\u044b","id":"iD","contribute_id":"\u0423\u043d\u0435\u0441\u0446\u0456 \u045e\u043a\u043b\u0430\u0434 \u0443 OpenStreetMap \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u0440\u044d\u0434\u0430\u043a\u0442\u0430\u0440\u0430 iD","geo_uri":"\u0417\u043d\u0435\u0448\u043d\u044f\u044f \u043f\u0440\u0430\u0433\u0440\u0430\u043c\u0430","josm":"JOSM","josm_live":"\u0423\u043a\u043b\u044e\u0447\u044b\u0446\u044c \u0430\u045e\u0442\u0430\u043c\u0430\u0442\u044b\u0447\u043d\u0443\u044e \u0441\u0456\u043d\u0445\u0440\u0430\u043d\u0456\u0437\u0430\u0446\u044b\u044e JOSM \u043f\u0440\u044b \u0437\u0430\u0433\u0440\u0443\u0437\u0446\u044b \u0432\u044b\u044f\u0432\u044b","error_psv":"Photo Sphere Viewer \u043d\u0435 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u043f\u0440\u0430\u0432\u0456\u043b\u044c\u043d\u0430","error_pic":"\u0417\u0430\u043f\u044b\u0442\u0430\u043d\u0430\u044f \u0432\u044b\u044f\u0432\u0430 \u043d\u0435 \u0437\u043d\u043e\u0439\u0434\u0437\u0435\u043d\u0430","error_nopic":"\u041d\u044f\u043c\u0430 \u0432\u044b\u044f\u0432\u044b \u045e \u0437\u0430\u0434\u0430\u0434\u0437\u0435\u043d\u0430\u0439 \u043f\u0430\u0437\u0456\u0446\u044b\u0456","error_api":"\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044b\u044f\u045e \u043d\u0435\u0434\u0430\u0441\u0442\u0443\u043f\u043d\u044b","error_webgl":"WebGL \u043d\u0435 \u043f\u0430\u0434\u0442\u0440\u044b\u043c\u043b\u0456\u0432\u0430\u0435\u0446\u0446\u0430 \u0432\u0430\u0448\u044b\u043c \u0431\u0440\u0430\u045e\u0437\u0430\u0440\u0430\u043c","error_josm":"JOSM \u043d\u0435 \u0430\u0434\u043a\u0430\u0437\u0432\u0430\u0435, \u0446\u0456 \u0451\u043d \u0437\u0430\u043f\u0443\u0448\u0447\u0430\u043d\u044b \u0456 \u045e\u043a\u043b\u044e\u0447\u0430\u043d\u044b \u0432\u044b\u0434\u0430\u043b\u0435\u043d\u044b \u0434\u043e\u0441\u0442\u0443\u043f?","error_api_compatibility":"\u0421\u0435\u0440\u0432\u0435\u0440 \u0432\u044b\u044f\u045e \u043d\u0435\u0441\u0443\u043c\u044f\u0448\u0447\u0430\u043b\u044c\u043d\u044b \u0437 \u0433\u044d\u0442\u0430\u0439 \u0432\u0435\u0440\u0441\u0456\u044f\u0439 \u043f\u0440\u0430\u0433\u043b\u044f\u0434\u0430\u043b\u044c\u043d\u0456\u043a\u0430","filter_date":"\u0414\u0430\u0442\u0430","filter_date_1month":"1 \u043c\u0435\u0441\u044f\u0446","filter_date_6months":"6 \u043c\u0435\u0441\u044f\u0446\u0430\u045e","filter_date_1year":"1 \u0433\u043e\u0434","filter_user":"\u041a\u0430\u0440\u044b\u0441\u0442\u0430\u043b\u044c\u043d\u0456\u043a","filter_user_mypics":"\u041c\u0430\u0435 \u0432\u044b\u044f\u0432\u044b","filter_picture":"\u0422\u044b\u043f \u0432\u044b\u044f\u0432\u044b","filter_zoom_in":"\u041d\u0430\u0431\u043b\u0456\u0437\u044c\u0446\u0435 \u043a\u0430\u0440\u0442\u0443, \u043a\u0430\u0431 \u0443\u0431\u0430\u0447\u044b\u0446\u044c \u0433\u044d\u0442\u044b \u0444\u0456\u043b\u044c\u0442\u0440","picture_all":"\u0423\u0441\u0435","picture_flat":"\u041a\u043b\u0430\u0441\u0456\u0447\u043d\u044b\u044f","picture_360":"360\xb0","picture_flat_long":"\u041a\u043b\u0430\u0441\u0456\u0447\u043d\u0430\u044f \u0432\u044b\u044f\u0432\u0430","picture_360_long":"\u041f\u0430\u043d\u0430\u0440\u0430\u043c\u043d\u0430\u044f \u0432\u044b\u044f\u0432\u0430","filter_qualityscore":"\u0410\u0434\u0437\u043d\u0430\u043a\u0430 \u044f\u043a\u0430\u0441\u0446\u0456","filter_qualityscore_help":"\u041d\u0430\u0446\u0456\u0441\u043d\u0456\u0446\u0435, \u043a\u0430\u0431 \u0443\u043a\u043b\u044e\u0447\u044b\u0446\u044c \u0430\u0431\u043e \u0432\u044b\u043a\u043b\u044e\u0447\u044b\u0446\u044c","qualityscore_title":"\u041f\u0440\u0430 \u0430\u0434\u0437\u043d\u0430\u043a\u0443 \u044f\u043a\u0430\u0441\u0446\u0456","qualityscore_doc_1":"Panoramax \u043f\u0440\u0430\u043f\u0430\u043d\u0443\u0435 \u0430\u0434\u0437\u043d\u0430\u043a\u0443 \u044f\u043a\u0430\u0441\u0446\u0456 \u0434\u043b\u044f \u043a\u043e\u0436\u043d\u0430\u0439 \u0432\u044b\u044f\u0432\u044b. \u0413\u044d\u0442\u0430 \u0434\u0430\u0437\u0432\u0430\u043b\u044f\u0435 \u043b\u0451\u0433\u043a\u0430 \u0444\u0456\u043b\u044c\u0442\u0440\u0430\u0432\u0430\u0446\u044c \u043a\u0430\u0440\u0442\u0443 \u0456 \u043f\u0430\u043a\u0430\u0437\u0432\u0430\u0446\u044c \u043d\u0430\u044f\u045e\u043d\u0430\u0441\u0446\u044c \u0432\u044b\u044f\u045e \u0432\u044b\u0441\u043e\u043a\u0430\u0439 \u044f\u043a\u0430\u0441\u0446\u0456.","qualityscore_doc_2":"\u0410\u0434\u0437\u043d\u0430\u043a\u0430 \u043f\u0430\u043a\u0430\u0437\u0432\u0430\u0435\u0446\u0446\u0430 \u043a\u0430\u0440\u044b\u0441\u0442\u0430\u043b\u044c\u043d\u0456\u043a\u0430\u043c \u044f\u043a A/B/C/D/E (A - \u043b\u0435\u043f\u0448\u0430\u044f, E - \u0433\u043e\u0440\u0448\u0430\u044f) \u0434\u044b \u0430\u0434\u043b\u044e\u0441\u0442\u0440\u043e\u045e\u0432\u0430\u0435\u0446\u0446\u0430 \u0433\u0440\u0430\u0444\u0456\u0447\u043d\u0430 \u043f\u0440\u0430\u0437 \u0433\u044d\u0442\u0443\u044e \u0448\u043a\u0430\u043b\u0443:","filter_gps_precision_lessthan":"\u041c\u0435\u043d\u0448 \u0437\u0430 {n} \u043c\u0435\u0442\u0440\u0430\u045e","map_background":"\u0424\u043e\u043d \u043a\u0430\u0440\u0442\u044b","map_background_aerial":"\u0421\u043f\u0430\u0434\u0430\u0440\u043e\u0436\u043d\u0456\u043a\u0430\u0432\u044b","map_background_streets":"\u0412\u0443\u043b\u0456\u0447\u043d\u044b","map_theme":"\u0422\u044d\u043c\u0430 \u043a\u0430\u0440\u0442\u044b","map_theme_default":"\u041a\u043b\u0430\u0441\u0456\u0447\u043d\u0430\u044f","metadata_general_copy_id":"\u041a\u0430\u043f\u0456\u044f\u0432\u0430\u0446\u044c ID","metadata_general_copy_picid":"\u041a\u0430\u043f\u0456\u044f\u0432\u0430\u0446\u044c ID \u0432\u044b\u044f\u0432\u044b","metadata_general_picid":"\u0412\u044b\u044f\u0432\u0430","metadata_general_seqid":"\u0421\u0435\u0440\u044b\u044f","metadata_general_picid_link":"\u041f\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043f\u0456\u0441\u0430\u043d\u043d\u044f \u0432\u044b\u044f\u0432\u044b","metadata_general_seqid_link":"\u041f\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 JSON \u0430\u043f\u0456\u0441\u0430\u043d\u043d\u044f \u0441\u0435\u0440\u044b\u0456","metadata_general_author":"\u0410\u045e\u0442\u0430\u0440","metadata_general_license":"\u041b\u0456\u0446\u044d\u043d\u0437\u0456\u044f","metadata_general_license_link":"\u0413\u043b\u044f\u0434\u0437\u0435\u0446\u044c \u043f\u043e\u045e\u043d\u0430\u0435 \u0430\u043f\u0456\u0441\u0430\u043d\u043d\u0435 \u043b\u0456\u0446\u044d\u043d\u0437\u0456\u0456","metadata_general_date":"\u0414\u0430\u0442\u0430 \u0437\u0434\u044b\u043c\u043a\u0456","metadata_general_instance":"\u0406\u043d\u0441\u0442\u0430\u043d\u0446\u044b\u044f \u043f\u0430\u0445\u043e\u0434\u0436\u0430\u043d\u043d\u044f","metadata_camera":"\u041a\u0430\u043c\u0435\u0440\u0430","metadata_camera_make":"\u0412\u044b\u0442\u0432\u043e\u0440\u0446\u0430","metadata_camera_model":"\u041c\u0430\u0434\u044d\u043b\u044c","metadata_camera_type":"\u0422\u044b\u043f","metadata_camera_resolution":"\u0420\u0430\u0437\u0434\u0437\u044f\u043b\u044f\u043b\u044c\u043d\u0430\u0441\u0446\u044c","metadata_camera_focal_length":"\u0424\u0430\u043a\u0443\u0441\u043d\u0430\u044f \u0430\u0434\u043b\u0435\u0433\u043b\u0430\u0441\u0446\u044c","metadata_location":"\u041f\u0430\u0437\u0456\u0446\u044b\u044f","metadata_quality_score":"\u0410\u0433\u0443\u043b\u044c\u043d\u0430\u044f \u0430\u0434\u0437\u043d\u0430\u043a\u0430","metadata_exif_value":"\u0417\u043d\u0430\u0447\u044d\u043d\u043d\u0435","metadata_exif_doc":"\u0414\u0430\u043a\u0443\u043c\u0435\u043d\u0442\u0430\u0446\u044b\u044f \u043f\u0430 EXIF \u0442\u044d\u0433\u0430\u0445","metadata_exif_doc_title":"\u041f\u0435\u0440\u0430\u0439\u0441\u0446\u0456 \u0434\u0430 \u0434\u0430\u043a\u0443\u043c\u0435\u043d\u0442\u0430\u0446\u044b\u0456 Exiv2 \u0434\u043b\u044f \u043f\u043e\u045e\u043d\u044b\u0445 \u0437\u0432\u0435\u0441\u0442\u0430\u043a \u043f\u0440\u0430 \u0432\u044b\u0437\u043d\u0430\u0447\u044d\u043d\u043d\u0456 EXIF \u0456 XMP \u0442\u044d\u0433\u0430\u045e","semantics_title":"\u0422\u044d\u0433\u0456","semantics_tags":"{nb} \u0442\u044d\u0433\u0430\u045e","semantics_features_default_title":"\u0422\u044d\u0433 {nb}","semantics_features_subtitle":"{nb} \u0437\u0432\u044f\u0437\u0430\u043d\u044b\u0445 \u0443\u043b\u0430\u0441\u0446\u0456\u0432\u0430\u0441\u0446\u0435\u0439","semantics_annotation_tooltip":"\u041d\u0430\u0446\u0456\u0441\u043d\u0456\u0446\u0435, \u043a\u0430\u0431 \u0443\u0431\u0430\u0447\u044b\u0446\u044c \u043f\u0430\u0434\u0440\u0430\u0431\u044f\u0437\u043d\u0430\u0441\u0446\u0456","semantics_key":"\u041a\u043b\u044e\u0447","semantics_value":"\u0417\u043d\u0430\u0447\u044d\u043d\u043d\u0435","semantics_sequence_tags":"\u0422\u044d\u0433 \u0441\u0435\u0440\u044b\u0456","semantics_picture_tags":"\u0422\u044d\u0433 \u0432\u044b\u044f\u0432\u044b","semantics_annotation_tags":"\u0422\u044d\u0433 \u0430\u0431\'\u0435\u043a\u0442\u0430","semantics_doc":"\u0414\u0430\u043f\u0430\u043c\u043e\u0433\u0430","semantics_doc_title":"\u041f\u0440\u0430 \u0442\u044d\u0433\u0456","semantics_doc_info1":"\u0414\u0430\u0434\u0430\u0439\u0446\u0435 \u043a\u0430\u043d\u0442\u044d\u043a\u0441\u0442 \u0434\u0430 \u0432\u044b\u044f\u0432\u044b \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u0442\u044d\u0433\u0430\u045e. \u0412\u044b \u043c\u043e\u0436\u0430\u0446\u0435 \u043f\u0430\u0437\u043d\u0430\u0447\u044b\u0446\u044c, \u0448\u0442\u043e \u044f\u043d\u0430 \u0437\u0440\u043e\u0431\u043b\u0435\u043d\u0430 \u0437 \u043c\u0430\u0448\u044b\u043d\u044b, \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u0442\u044d\u0433\u0430 transport=car.","semantics_doc_info2":"\u0412\u044b \u0442\u0430\u043a\u0441\u0430\u043c\u0430 \u043c\u043e\u0436\u0430\u0446\u0435 \u0432\u044b\u043b\u0443\u0447\u044b\u0446\u044c \u0430\u0431\'\u0435\u043a\u0442\u044b \u043d\u0430 \u0432\u044b\u044f\u0432\u0435: \u0434\u0430\u0440\u043e\u0436\u043d\u044b\u044f \u0437\u043d\u0430\u043a\u0456, \u0433\u0430\u0440\u0430\u0434\u0441\u043a\u043e\u0435 \u0430\u0431\u0441\u0442\u0430\u043b\u044f\u0432\u0430\u043d\u043d\u0435\u2026 \u041f\u0430\u0437\u043d\u0430\u0447\u0430\u0439\u0446\u0435 \u0442\u043e\u0435, \u0448\u0442\u043e \u0431\u0430\u0447\u044b\u0446\u0435, \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u0456\u0441\u043d\u0443\u044e\u0447\u044b\u0445 \u0442\u044d\u0433\u0430\u045e. \u041f\u0440\u044b \u043d\u0435\u0430\u0431\u0445\u043e\u0434\u043d\u0430\u0441\u0446\u0456 \u0432\u044b \u043c\u043e\u0436\u0430\u0446\u0435 \u0441\u0442\u0432\u0430\u0440\u0430\u0446\u044c \u0441\u0432\u0430\u0435 \u045e\u043b\u0430\u0441\u043d\u044b\u044f.","semantics_doc_info3":"\u041d\u0435\u043a\u0430\u0442\u043e\u0440\u044b\u044f \u0430\u0431\'\u0435\u043a\u0442\u044b \u0430\u045e\u0442\u0430\u043c\u0430\u0442\u044b\u0447\u043d\u0430 \u0432\u044b\u044f\u045e\u043b\u044f\u044e\u0446\u0446\u0430 \u0437 \u0434\u0430\u043f\u0430\u043c\u043e\u0433\u0430\u0439 \u0428\u0406: \u044f\u043a\u0430\u0441\u0446\u044c \u043d\u0435 \u0433\u0430\u0440\u0430\u043d\u0442\u0443\u0435\u0446\u0446\u0430.","semantics_doc_link":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u0442\u044d\u0433\u0456","semantics_key_doc":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u0433\u044d\u0442\u044b \u043a\u043b\u044e\u0447","semantics_value_doc":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 \u0433\u044d\u0442\u044b \u0442\u044d\u0433","semantics_qualifiers":"\u041a\u0432\u0430\u043b\u0456\u0444\u0456\u043a\u0430\u0442\u0430\u0440\u044b","semantics_show_annotations":"\u0410\u0434\u043b\u044e\u0441\u0442\u0440\u043e\u045e\u0432\u0430\u0446\u044c \u0430\u0431\'\u0435\u043a\u0442\u044b \u043d\u0430 \u0432\u044b\u044f\u0432\u0435","semantics_hide_annotations":"\u0421\u0445\u0430\u0432\u0430\u0446\u044c \u0430\u0431\'\u0435\u043a\u0442\u044b \u043d\u0430 \u0432\u044b\u044f\u0432\u0435","semantics_zero_annotations":"\u041d\u0430 \u0433\u044d\u0442\u0430\u0439 \u0432\u044b\u044f\u0432\u0435 \u0430\u0431\'\u0435\u043a\u0442\u044b \u043d\u0435 \u0432\u044b\u043b\u0443\u0447\u0430\u043d\u044b","semantics_add_annotation":"\u0414\u0430\u0434\u0430\u0446\u044c \u043d\u043e\u0432\u044b \u0442\u044d\u0433","semantics_draw_annotation":"\u0412\u044b \u043c\u043e\u0436\u0430\u0446\u0435 \u0432\u044b\u043b\u0443\u0447\u044b\u0446\u044c \u0430\u0431\'\u0435\u043a\u0442, \u044f\u043a\u0456 \u0445\u043e\u0447\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044c, \u043d\u0430 \u0432\u044b\u044f\u0432\u0435 (\u041d\u0435\u0430\u0431\u0430\u0432\u044f\u0437\u043a\u043e\u0432\u0430).","semantics_erase_annotation":"\u0421\u0446\u0435\u0440\u0446\u0456 \u0432\u044b\u043b\u0443\u0447\u0430\u043d\u044b \u0430\u0431\'\u0435\u043a\u0442","semantics_delete_annotation":"\u0412\u044b\u0434\u0430\u043b\u0456\u0446\u044c \u0433\u044d\u0442\u044b \u0430\u0431\'\u0435\u043a\u0442","semantics_delete_annotation_confirm":"\u0412\u044b \u0441\u0430\u043f\u0440\u0430\u045e\u0434\u044b \u0436\u0430\u0434\u0430\u0435\u0446\u0435 \u0432\u044b\u0434\u0430\u043b\u0456\u0446\u044c \u0433\u044d\u0442\u044b \u0442\u044d\u0433?","semantics_wikidata_properties":{"P31":"\u0430\u0441\u043e\u0431\u043d\u0456\u043a \u043a\u043b\u0430\u0441\u0430","P279":"\u043f\u0430\u0434\u043a\u043b\u0430\u0441","P361":"\u0447\u0430\u0441\u0442\u043a\u0430"},"semantics_editor_error":"\u0421\u0456\u043d\u0442\u0430\u043a\u0441\u0456\u0441 \u043d\u0435\u0441\u0430\u043f\u0440\u0430\u045e\u0434\u043d\u044b. \u0412\u0430\u0448\u044b \u0442\u044d\u0433\u0456 \u043c\u043e\u0433\u0443\u0446\u044c \u0432\u044b\u0433\u043b\u044f\u0434\u0430\u0446\u044c \u0442\u0430\u043a:\\nkey=value\\nprefix|key=value\\nprefix|key[qualif_key=qualif_val]=value\\n\\n\u041c\u0430\u043a\u0441\u0456\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0434\u0430\u045e\u0436\u044b\u043d\u044f \u043a\u043b\u044e\u0447\u0430 - 256 \u0441\u0456\u043c\u0432\u0430\u043b\u0430\u045e, \u043c\u0430\u043a\u0441\u0456\u043c\u0430\u043b\u044c\u043d\u0430\u044f \u0434\u0430\u045e\u0436\u044b\u043d\u044f \u0437\u043d\u0430\u0447\u044d\u043d\u043d\u044f - 2048 \u0441\u0456\u043c\u0432\u0430\u043b\u0430\u045e.","semantics_edit":"\u0420\u044d\u0434\u0430\u0433\u0430\u0432\u0430\u0446\u044c \u0430\u0442\u0440\u044b\u0431\u0443\u0442\u044b","semantics_save":"\u0417\u0430\u0445\u0430\u0432\u0430\u0446\u044c \u0437\u043c\u0435\u043d\u044b","semantics_undo":"\u0421\u043a\u0430\u0441\u0430\u0432\u0430\u0446\u044c \u0440\u044d\u0434\u0430\u0433\u0430\u0432\u0430\u043d\u043d\u0435","semantics_send_fail":"\u041d\u0435\u043c\u0430\u0433\u0447\u044b\u043c\u0430 \u0437\u0430\u0445\u0430\u0432\u0430\u0446\u044c \u0437\u043c\u0435\u043d\u044b, \u043a\u0430\u043b\u0456 \u043b\u0430\u0441\u043a\u0430, \u043f\u0430\u0441\u043f\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043f\u0430\u0437\u043d\u0435\u0439","semantics_login_needed":"\u0414\u043b\u044f \u0440\u044d\u0434\u0430\u0433\u0430\u0432\u0430\u043d\u043d\u044f \u0442\u044d\u0433\u0430\u045e \u0430\u0431\u043e \u0430\u0431\'\u0435\u043a\u0442\u0430\u045e \u043d\u0430 \u0432\u044b\u044f\u0432\u0435 \u0432\u0430\u043c \u043d\u0435\u0430\u0431\u0445\u043e\u0434\u043d\u0430 \u045e\u0432\u0430\u0439\u0441\u0446\u0456 \u045e \u0456\u043d\u0441\u0442\u0430\u043d\u0446\u044b\u044e Panoramax {n}. \u0416\u0430\u0434\u0430\u0435\u0446\u0435 \u045e\u0432\u0430\u0439\u0441\u0446\u0456?","report":"\u041f\u0430\u0432\u0435\u0434\u0430\u043c\u043b\u0435\u043d\u043d\u0435","report_auth":"\u0413\u044d\u0442\u0430\u044f \u043f\u0430\u0432\u0435\u0434\u0430\u043c\u043b\u0435\u043d\u043d\u0435 \u0431\u0443\u0434\u0437\u0435 \u0430\u0434\u043f\u0440\u0430\u045e\u043b\u0435\u043d\u0430 \u0437 \u0432\u0430\u0448\u0430\u0433\u0430 \u045e\u043b\u0456\u043a\u043e\u0432\u0430\u0433\u0430 \u0437\u0430\u043f\u0456\u0441\u0443 \\"{a}\\"","report_nature_label":"\u041f\u0440\u044b\u0447\u044b\u043d\u0430 \u043f\u0440\u0430\u0431\u043b\u0435\u043c\u044b","report_whole_sequence":"\u0413\u044d\u0442\u0430 \u0442\u044b\u0447\u044b\u0446\u0446\u0430 \u045e\u0441\u0451\u0439 \u0441\u0435\u0440\u044b\u0456","report_details":"\u0414\u0430\u0434\u0430\u0442\u043a\u043e\u0432\u044b\u044f \u043f\u0430\u0434\u0440\u0430\u0431\u044f\u0437\u043d\u0430\u0441\u0446\u0456","report_details_placeholder":"\u041f\u0430 \u0436\u0430\u0434\u0430\u043d\u043d\u0456, \u0432\u044b \u043c\u043e\u0436\u0430\u0446\u0435 \u0434\u0430\u0434\u0430\u0446\u044c \u043f\u0430\u0434\u0440\u0430\u0431\u044f\u0437\u043d\u0430\u0441\u0446\u0456 \u043f\u0440\u0430 \u043f\u0440\u0430\u0431\u043b\u0435\u043c\u0443","report_email":"\u0412\u0430\u0448 email","report_email_placeholder":"\u041d\u0435\u0430\u0431\u0430\u0432\u044f\u0437\u043a\u043e\u0432\u0430","report_submit":"\u0410\u0434\u043f\u0440\u0430\u0432\u0456\u0446\u044c","report_wait":"\u0410\u0434\u043f\u0440\u0430\u045e\u043a\u0430 \u043f\u0430\u0432\u0435\u0434\u0430\u043c\u043b\u0435\u043d\u043d\u044f\u2026","report_failure":"\u041f\u0440\u044b \u0441\u0442\u0432\u0430\u0440\u044d\u043d\u043d\u0456 \u043f\u0430\u0432\u0435\u0434\u0430\u043c\u043b\u0435\u043d\u043d\u044f \u0430\u0434\u0431\u044b\u043b\u0430\u0441\u044f \u043f\u0430\u043c\u044b\u043b\u043a\u0430: {e}. \u041a\u0430\u043b\u0456 \u043b\u0430\u0441\u043a\u0430, \u043f\u0430\u0441\u043f\u0440\u0430\u0431\u0443\u0439\u0446\u0435 \u043f\u0430\u0437\u043d\u0435\u0439.","report_success":"\u041f\u0410\u0432\u0435\u0434\u0430\u043c\u043b\u0435\u043d\u043d\u0435 \u043f\u0430\u0441\u043f\u044f\u0445\u043e\u0432\u0430 \u0430\u0434\u043f\u0440\u0430\u045e\u043b\u0435\u043d\u0430. \u042f\u043d\u043e \u0431\u0443\u0434\u0437\u0435 \u0440\u0430\u0437\u0433\u043b\u0435\u0434\u0436\u0430\u043d\u0430 \u044f\u043a \u043c\u0430\u0433\u0430 \u0445\u0443\u0442\u0447\u044d\u0439."},"map":{"loading":"\u0417\u0430\u0433\u0440\u0443\u0437\u043a\u0430\u2026","thumbnail":"\u041c\u0456\u043d\u0456\u044f\u0446\u044e\u0440\u0430 \u0432\u044b\u044f\u0432\u044b \u043f\u0430\u0434 \u043a\u0443\u0440\u0441\u043e\u0440\u0430\u043c","not_public":"\u041d\u0435\u043f\u0443\u0431\u043b\u0456\u0447\u043d\u0430 \u0431\u0430\u0447\u043d\u0430\u044f","slow_loading":"\u041a\u0430\u0440\u0442\u0430 \u043f\u0430\u0432\u043e\u043b\u044c\u043d\u0430 \u0437\u0430\u0433\u0440\u0443\u0436\u0430\u0435\u0446\u0446\u0430 \u0456 \u043c\u043e\u0436\u0430 \u0437\u0434\u0430\u0432\u0430\u0446\u0446\u0430 \u043f\u0430\u0448\u043a\u043e\u0434\u0436\u0430\u043d\u0430\u0439","map_data":"\u041a\u0430\u0440\u0442\u0430 \u043d\u0430 \u0430\u0441\u043d\u043e\u0432\u0435 {m}","more_panoramax":"\u0414\u0430\u0432\u0435\u0434\u0430\u0446\u0446\u0430 \u0431\u043e\u043b\u044c\u0448 \u043f\u0440\u0430 Panoramax"}}');
            },
            4149: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"maplibre":{"GeolocateControl.LocationNotAvailable":"Placering ikke tilg\xe6ngelig","GeolocateControl.FindMyLocation":"Find min placering"},"pnx":{"minimize":"Skjul dette modul, du kan vise det igen ved hj\xe6lp af knappen i nederste venstre hj\xf8rne","share_embed_docs":"L\xe6s mere om indlejringskonfiguration","zoom":"Zoom","zoomOut":"Zoom ud","zoomIn":"Zoom ind","moveUp":"Ryk opad","moveDown":"Ryk nedad","moveLeft":"Ryk til venstre","moveRight":"Ryk til h\xf8jre","moveMiddle":"Centreret visning","expand":"Udvid","expand_info":"F\xe5 modulet til at blive vist p\xe5 hele siden","show_psv":"Vis billedfremviseren","show_map":"Vis kortet","options":"Valgmuligheder","filters":"Filtre","layers":"Lag","search":"S\xf8g","search_empty":"Ingen resultater fundet","search_user":"S\xf8g efter et brugernavn\u2026","share":"Del","share_links":"Links","share_page":"Link til dette billede","share_image":"HD-billede","share_rss":"RSS-feed","share_rss_title":"RSS-feed med nye sekvenser i det aktuelt synlige kortomr\xe5de","share_embed":"Indlejr p\xe5 din hjemmeside","share_print":"Udskriv","copy":"Kopi\xe9r","copied":"Kopieret","error_retry":"Pr\xf8v igen senere","sequence_next":"N\xe6ste billede i sekvensen","sequence_play":"Afspil denne sekvens","sequence_more":"Flere afspilningsmuligheder","sequence_speed":"Afspillerens hastighed","legend_license":"Licens: {l}","legend_title":"Vis detaljer om billedet","error_click":"Forts\xe6t","error":"Vi har et problem\u2026","search_address":"S\xf8g efter en adresse, by\u2026","sequence_pause":"S\xe6t sekvensen p\xe5 pause","sequence_prev":"Forrige billede i sekvensen","loading_labels_serious":["\ud83d\uddfa\ufe0f Indl\xe6ser kortdata","\ud83d\udda5\ufe0f Anmoder API","\ud83d\uddbc\ufe0f Indl\xe6ser thumbnails","\ud83d\udd0d Analyserer EXIF-metadata","\ud83c\udfd8\ufe0f 3D-rendering","\ud83d\udcf7 Initialiserer 360\xb0-billeder","\ud83d\udfe0 Farveafstemning","\ud83d\udcaf Beregning af kvalitetsscore \xa9","\ud83d\udce1 Downloader opdateringer","\ud83c\udf0d Henter kortfliser","\ud83d\udcf8 Behandler skygger"],"edit_osm":"Rediger OSM","josm_live":"Aktiv\xe9r automatisk JOSM-synkronisering ved indl\xe6sning af billeder","loading_labels_fun":["\ud83e\udd8c Registrering af skilte om hjortekrydsning","\ud83d\ude98 S\xf8ger Panoramax Car \xa9","\u2615 Injicerer koffein","\ud83d\ude00 Smil, du er blevet kortlagt!","\ud83d\udc08 Deler kattebilleder","\ud83d\ude34 Reducerer overspringshandlinger","\ud83e\uded6 Brygger te","\ud83d\udc27 \xc5bner kildekode","\ud83d\ude87 Indekser undergrundsstationer","\ud83e\uddf9 Metadata-oprydning","\ud83d\ude92 Sender billeder af brandstation","\ud83d\udeb2 Opdatering af Greenways","\ud83d\ude89 Gennemgang af perron p\xe5 station","\ud83d\udef0\ufe0f S\xf8ger efter satellitter","\ud83d\udc65 Skriver personaer","\ud83d\udc1f Finder fish and chip butik","\ud83e\uddd1\u200d\ud83d\udcbb Gr\xe6nseflade til fejlfinding","\ud83d\udcc8 Inkrementelle statistikker","\ud83e\udd16 L\xe6rer semantik","\ud83c\udfa8 Redesign af gr\xe6nseflade","\ud83d\udcc5 Planl\xe6gning af foto-kortl\xe6gningsfester","\ud83e\uddc0 Modning af cheddars","\ud83c\udf04 Beregning af Cornwalls solskin","\ud83c\udf0a M\xe5ling af h\xf8jvande"],"error_psv":"Photo Sphere Viewer indl\xe6ses ikke korrekt","error_nopic":"Intet billede tilg\xe6ngeligt p\xe5 den givne position","error_api":"Billedserveren er ikke tilg\xe6ngelig","error_webgl":"WebGL underst\xf8ttes ikke af din browser","filter_date":"Dato","filter_date_1month":"1 m\xe5ned","filter_date_1year":"1 \xe5r","filter_user":"Bruger","filter_user_mypics":"Mine billeder","filter_picture":"Billedtype","filter_zoom_in":"Zoom ind p\xe5 kortet for at se dette filter","picture_flat":"Klassisk","picture_360":"360\xb0","filter_qualityscore_help":"Klik for at aktivere eller deaktivere","map_background":"Kortbaggrund","map_background_aerial":"Luftfoto","map_background_streets":"Gader","map_theme":"Korttema","error_pic":"Det \xf8nskede billede blev ikke fundet","error_api_compatibility":"Billedserveren er ikke kompatibel med denne version af fremviseren","filter_qualityscore":"Kvalitetsscore","error_josm":"JOSM svarer ikke, k\xf8rer den, og er fjernstyring aktiveret?","metadata_general_seqid_link":"G\xe5 til JSON-beskrivelse af sekvensen","map_theme_default":"Klassisk","map_theme_age_1":"> 2 \xe5r","map_theme_age_2":"< 2 \xe5r","map_theme_age_3":"< 1 \xe5r","map_theme_age_4":"< 1 m\xe5ned","map_theme_type":"Kameratype","map_theme_score":"Kvalitetsscore","contrast":"Aktiv\xe9r h\xf8jere billedkontrast","metadata_general_picid":"Billede","metadata_general_seqid":"Sekvens","metadata_general_picid_link":"G\xe5 til JSON-beskrivelse af billedet","metadata_general_author":"Forfatter","metadata_general_license":"Licens","metadata_general_license_link":"Se den fulde licensbeskrivelse","metadata_general_date":"Optagelsesdato","metadata_camera":"Kamera","metadata_camera_make":"Fabrikat","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Opl\xf8sning","metadata_camera_focal_length":"Br\xe6ndvidde","metadata_location_latitude":"Breddegrad","metadata_location_orientation":"Retning","metadata_location_precision":"Pr\xe6cision i positionering","metadata_quality":"Kvalitet","metadata_quality_score":"Global score","metadata_quality_gps_score":"Positioneringsscore","metadata_quality_help":"F\xe5 mere at vide om kvalitetsscore","map_theme_age":"Optagelsesdato","metadata_location":"Position","metadata":"Metadata for billede","metadata_location_longitude":"L\xe6ngdegrad","metadata_quality_resolution_score":"Opl\xf8sningsscore","metadata_quality_missing":"ingen v\xe6rdi indstillet i billedet","metadata_exif":"EXIF","metadata_exif_name":"Tag","metadata_exif_value":"V\xe6rdi","report":"Indberet","report_auth":"Denne indberetning vil blive sendt via din konto \\"{a}\\"","report_nature_label":"Problemets \xe5rsag","report_nature":{"":"V\xe6lg problemets art\u2026","blur_missing":"En persons ansigt eller bils nummerplade er synlig","blur_excess":"Der blev anvendt un\xf8dvendig sl\xf8ring p\xe5 et objekt","inappropriate":"Billedet er upassende (ikke relevant, n\xf8genhed\u2026)","privacy":"En privat sti eller ejendom er synlig","picture_low_quality":"Billedet er af lav kvalitet","mislocated":"Billedet er d\xe5rligt placeret p\xe5 kortet","copyright":"Billedet kr\xe6nker ophavsretten","other":"Enhver anden form for problem"},"report_whole_sequence":"Det g\xe6lder hele sekvensen","report_details":"Yderligere detaljer","report_details_placeholder":"Du kan eventuelt tilf\xf8je detaljer om problemet","report_email":"Din e-mail","report_email_placeholder":"Valgfri","report_submit":"Indsend","report_wait":"Sender indberetning\u2026","report_success":"Indberetningen blev sendt. Den vil blive gennemg\xe5et hurtigst muligt.","report_failure":"Der opstod en fejl under oprettelse af indberetning: {e}. Pr\xf8v venligst igen senere.","qualityscore_title":"Om kvalitetsscoren","qualityscore_doc_2":"Scoren vises som et bogstav:","qualityscore_doc_3":"\\"A\\" er den bedste karakter, \\"E\\" den d\xe5rligste.","qualityscore_doc_link":"Yderligere oplysninger om kvalitetsscoren","qualityscore_doc_1":"Der beregnes en kvalitetsscore for hvert billede.","minimize_short":"Skjul","id":"iD","josm":"JOSM","metadata_general_instance":"Oprindelsesinstans","contribute_id":"Bidrag til OpenStreetMap med iD-editor","geo_uri":"Ekstern app","picture_flat_long":"Klassisk billede","picture_360_long":"Panoramabillede","metadata_summary":"Opsummering","metadata_general_copy_id":"Kopi-ID","metadata_general_copy_picid":"Kopi\xe9r billed-ID","filter_date_6months":"6 m\xe5neder","picture_all":"Alle","panoramax":"Panoramax","semantics_send_ok":"Dine redigeringer blev indsendt","semantics_doc_info3":"Nogle objekter registreres automatisk med AI: kvaliteten er ikke garanteret.","semantics_doc_info1":"Giv kontekst for et billede ved hj\xe6lp af tags.","filter_gps_precision":"Placeringsn\xf8jagtighed","filter_gps_precision_lessthan":"Mindre {n} meter","filter_gps_precision_between":"Mellem {n1} og {n2} meter","filter_gps_precision_morethan":"Mere end {n} meter","map_theme_gps":"Placeringsn\xf8jagtighed","metadata_location_copy":"Kopi\xe9r {v}","metadata_location_copy_more":"Flere muligheder for kopiering af koordinater","metadata_exif_doc":"Dok af EXIF-tags","semantics_editor_example":"key=v\xe6rdi\\nprefix|key=v\xe6rdi","semantics_send_fail":"Kunne ikke gemme dine \xe6ndringer. Pr\xf8v igen senere","semantics_save":"Gem dine \xe6ndringer","semantics_edit":"Rediger egenskaber","semantics_undo":"Annuller dine \xe6ndringer","semantics_features":"Billedeobjekter","semantics_features_subtitle":"{nb} tilknyttede egenskaber","semantics_show_all_tags":"Vis alle tags","semantics_hide_all_tags":"Skjul alle tags","semantics_key":"N\xf8gle","semantics_title":"Tags","semantics_tags":"{nb} tags","semantics_value":"V\xe6rdi","semantics_key_doc":"F\xe5 mere at vide om denne n\xf8gle","semantics_annotation_tooltip":"Klik for at se detaljer","semantics_value_doc":"F\xe5 mere at vide om dette tag","semantics_qualifiers":"Kvalificerende","semantics_show_annotations":"Vis billedobjekter","semantics_doc_link":"F\xe5 mere at vide om tags","metadata_location_coordinates":"Koordinater (l\xe6ngdegrad, breddegrad)","whats_panoramax":"Panoramax er geo-commons for billeder af territorier.","semantics_features_none":"Der er endnu ikke tegnet nogen objekter p\xe5 dette billede.","semantics_wikidata_properties":{"P361":"del af","P279":"underklasse af","P31":"instans af","P180":"afbilder"},"metadata_exif_doc_title":"G\xe5 til Exiv2-dokumentationen for at f\xe5 alle detaljer om definitionerne af EXIF- og XMP-tags","semantics_features_default_title":"Tag {nb}","semantics_picture_tags":"Billed-tag","semantics_annotation_tags":"Objekt-tag","semantics_hide_annotations":"Skjul billedobjekter","semantics_sequence_tags":"Sekvens-tag","semantics_zero_annotations":"Ingen objekter tegnet p\xe5 dette billede","semantics_editor_error":"Syntaksen er ugyldig. Dine tags kan se s\xe5dan ud:\\nkey=value\\nprefix|key=value\\nprefix|key[qualif_key=qualif_val]=value\\n\\nDen maksimale n\xf8glel\xe6ngde er 256 tegn, den maksimale v\xe6rdil\xe6ngde er 2048 tegn.","semantics_delete_annotation":"Slet dette objekt","semantics_delete_annotation_confirm":"Vil du virkelig slette dette tag?","semantics_add_annotation":"Tilf\xf8j et nyt tag","semantics_draw_annotation":"Du kan tegne det objekt, du vil tilf\xf8je, over billedet (valgfrit).","semantics_login_needed":"For at redigere billedtags eller objekter skal du logge ind p\xe5 Panoramax {n} instance. Vil du logge ind?","semantics_doc":"Hj\xe6lp","semantics_doc_title":"Om tags","semantics_erase_annotation":"Slet tegnet objekt","semantics_doc_info2":"Du kan ogs\xe5 tegne objekter p\xe5 billedet: vejskilte, byudstyr\u2026 Mark\xe9r det, du ser, ved hj\xe6lp af eksisterende tags. Du kan ogs\xe5 oprette dine egne, hvis det er n\xf8dvendigt.","semantics_overlays":{"tfsigns":"F\xe6rdselstavler","features":"Alle objekter"},"semantics_zoom_in":"Zoom ind p\xe5 kortet for at se tags","semantics_download":"Download","semantics_download_title":"Download tags","semantics_download_cta":"Download open-data","semantics_download_info":"Alle semantiske data (tags) er tilg\xe6ngelige som \xe5bne data. Du kan downloade dem og bruge dem frit.","semantics_doc_info1u1":"Du kan tagge det som optaget fra bil med tagget transport=car.","semantics_copy":"Kopi\xe9r egenskaber","semantics_value_show_osm":"Se p\xe5 OpenStreetMap","popup_details_link":"Flere detaljer","qualityscore_doc_41":"GPS-pr\xe6cisionen","filter_gps_precision_help_4":"En RTK GPS f\xe5r karakteren \\"5\u2b50\\" , et actionkamera som GoPro Max f\xe5r karakteren \\"3\u2b50\\", og en smartphone GPS i en underjordisk parkeringsk\xe6lder f\xe5r karakteren \\"1\u2b50\\".","filter_gps_precision_help_1":"Der er oplysninger om placeringspr\xe6cision tilg\xe6ngelige for hvert billede. Dette svarer til GPS-pr\xe6cision under billedoptagelsen.","filter_gps_precision_help_2":"Pr\xe6cisionen udtrykkes med stjerner:","filter_gps_precision_help":"F\xe5 mere at vide om placeringsn\xf8jagtighed","qualityscore_doc_4":"Denne score beregnes p\xe5 baggrund af:","qualityscore_doc_42":"billedopl\xf8sningen","qualityscore_doc_5":"Et professionelt kamera f\xe5r karakteren A, et 360\xb0-actionkamera f\xe5r karakteren B, og en smartphone f\xe5r en karakter mellem C og E.","filter_gps_precision_help_3":"\\"5\u2b50\\" er meget pr\xe6cis (<= {p5}m), \\"1\u2b50\\" er meget upr\xe6cis (> {p1}m) eller ukendt."},"psv":{"loadError":"Panoramaet kan ikke indl\xe6ses","twoFingers":"Brug to fingre til at navigere","ctrlZoom":"Brug ctrl + scroll til at zoome ind p\xe5 billedet"},"map":{"loading":"Indl\xe6ser\u2026","thumbnail":"Miniature af billedet, der holdes","not_public":"Ikke offentligt synlig","slow_loading":"Kortet indl\xe6ses langsomt og kan virke defekt","map_data":"Kortdata: {m}","more_panoramax":"F\xe5 mere at vide om Panoramax"}}');
            },
            369: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"options":"Optionen","filters":"Filter","search":"Suche","layers":"Ebenen","share_links":"Links","share_page":"Link zu diesem Bild","loading_labels_fun":["\ud83e\udd8c Erkennung von \\"Reh kreuzt\\"-Schildern","\ud83d\ude98 Suche Panoramax-Auto \xa9","\u2615 Koffeininjektion","\ud83d\ude00 L\xe4chle, Du wirst kartografiert!","\ud83d\udc08 Katzenfotos teilen","\ud83d\ude34 Vermeide Prokrastination","\ud83c\udf7a\ufe0f Bier brauen","\ud83d\udc27 Quellcode \xf6ffnen","\ud83d\udee3\ufe0f Indizierung der Autobahnen","\ud83e\uddf9 Metadaten aufr\xe4umen","\ud83d\ude92 Sende Fotos von Feuerwachen","\ud83d\udeb2 Radwege aktualisieren","\ud83d\ude89 Bahnsteig ablaufen","\ud83d\udef0\ufe0f Suche Satelliten","\ud83d\udc65 Personas anlegen","\ud83c\udf2d\ufe0f Orte n\xe4chsten Currywurst-Stand","\ud83e\uddd1\u200d\ud83d\udcbb Fehlerbehebung wird ausgef\xfchrt","\ud83d\udcc8 Statistiken anpassen","\ud83e\udd16 Suche den Sinn des Lebens","\ud83c\udfa8 Benutzeroberfl\xe4che neu gestalten","\ud83d\udcc5 Fotomapping-Partys planen","\ud83e\uddc0 Dem Emmentaler beim Reifen zuschauen","\ud83c\udf04 Sonnenstand berechnen","\ud83c\udf0a Messung der Gezeiten"],"search_empty":"Keine Ergebnisse gefunden","share":"Teilen","metadata_general_picid":"Bild","zoom":"Zoom","zoomOut":"Herauszoomen","zoomIn":"Hereinzoomen","moveUp":"Nach oben","moveDown":"Nach unten","moveRight":"Nach rechts","moveMiddle":"Sicht zentrieren","map_theme_age":"Aufnahmedatum","expand":"Ausklappen","expand_info":"Widget im Vollbild anzeigen","show_psv":"Bildbetrachter anzeigen","show_map":"Karte anzeigen","search_user":"Suche einen Nutzernamen\u2026","filter_zoom_in":"Vergr\xf6\xdfere die Karte, um diesen Filter zu anzuwenden","picture_flat":"Klassisch","picture_360":"360\xb0","filter_camera_model":"Nach Kameramodell","map_background":"Kartenhintergrund","map_background_aerial":"Satelliten","map_background_streets":"Stra\xdfen","map_theme":"Karten-Art","metadata_exif_name":"Tag","metadata_exif_value":"Wert","map_theme_age_2":"< 2 Jahre","map_theme_age_3":"< 1 Jahr","map_theme_type":"Kameratyp","contrast":"H\xf6heren Bildkontrast aktivieren","metadata":"Bildmetadaten","metadata_general_seqid":"Sequenz","metadata_general_picid_link":"Zur JSON-Beschreibung des Bildes wechseln","loading_labels_serious":["\ud83d\uddfa\ufe0f Lade Kartendaten","\ud83d\udda5\ufe0f API anfragen","\ud83d\uddbc\ufe0f Vorschaubilder laden","\ud83d\udd0d EXIF-Metadaten analysieren","\ud83c\udfd8\ufe0f 3D-Rendering","\ud83d\udcf7 360\xb0 Fotos initialisieren","\ud83d\udfe0 Farben ausgleichen","\ud83d\udcaf Berechne Quality Score \xa9","\ud83d\udce1 Herunterladen von Updates","\ud83c\udf0d Lade Kartenausschnitte","\ud83d\udcf8 Bearbeitung der Schatten"],"search_address":"Suche eine Adresse, Stadt, \u2026","share_image":"HD-Bild","share_rss":"RSS-Feed","share_embed":"Auf Webseite einbetten","share_print":"Drucken","copy":"Kopieren","copied":"Kopiert","error":"Ein Fehler ist aufgetreten\u2026","sequence_next":"N\xe4chstes Foto in der Sequenz","sequence_play":"Sequenz abspielen","sequence_pause":"Sequenz pausieren","sequence_prev":"Vorheriges Foto in der Sequenz","sequence_more":"Mehr Abspieloptionen","sequence_speed":"Abspielgeschwindigkeit","legend_license":"Lizenz: {l}","edit_osm":"OSM editieren","id":"iD","josm":"JOSM","josm_live":"Einschalten der automatischen JOSM-Synchronisierung beim Laden eines Bildes","error_psv":"Betrachter f\xfcr die Photospheres wurde nicht richtig geladen","error_pic":"Angefragtes Foto wurde nicht gefunden","error_nopic":"Kein Foto an dieser Position verf\xfcgbar","error_api":"Foto-Server ist nicht erreichbar","error_josm":"JOSM reagiert nicht. Ist das Programm ge\xf6ffnet und die Remote-Verbindung aktiv?","error_api_compatibility":"Der Foto-Server ist nicht mit dieser Version des Betrachters kompatibel","filter_date":"Datum","filter_user":"Benutzer","filter_picture":"Art des Fotos","map_theme_default":"Klassisch","map_theme_age_1":"> 2 Jahre","metadata_general_seqid_link":"Zur JSON-Beschreibung der Sequenz wechseln","metadata_general_author":"Autor","metadata_general_license":"Lizenz","metadata_general_date":"Aufnahmedatum","metadata_camera":"Kamera","metadata_camera_make":"Hersteller","metadata_camera_model":"Modell","metadata_camera_type":"Typ","metadata_camera_focal_length":"Brennweite","metadata_location":"Position","metadata_location_longitude":"L\xe4ngengrad","metadata_location_latitude":"Breitengrad","metadata_location_orientation":"Richtung","metadata_location_precision":"Genauigkeit der Positionierung","metadata_exif":"EXIF","minimize":"Dieses Widget verbergen. Du kannst es \xfcber die Schaltfl\xe4che in der linken, unteren Ecke wieder einblenden","map_theme_age_4":"< 1 Monat","error_subtitle":"Bitte versuchen sie es sp\xe4ter erneut, oder schauen sie in die Web-Browser-Konsole f\xfcr mehr Details.","moveLeft":"Nach links","share_rss_title":"RSS-Feed neuer Sequenzen auf dem aktuell sichtbaren Kartenbereich","error_webgl":"WebGL wird von ihrem Browser nicht unterst\xfctzt","metadata_general_license_link":"Vollst\xe4ndige Lizenzbeschreibung anschauen","share_embed_docs":"Mehr \xfcber die Einbettungs-Konfiguration lesen","report_nature":{"":"Art des Problems ausw\xe4hlen\u2026","inappropriate":"Das Bild ist unangemessen (irrelevant, Nacktheit, ...)","picture_low_quality":"Das Bild hat eine sehr schlechte Qualit\xe4t","blur_missing":"Das Gesicht einer Person oder ein KFZ-Kennzeichen ist sichtbar","blur_excess":"Ein Objekt wurde unkenntlich gemacht, obwohl es nicht erforderlich war","privacy":"Ein privater Pfad oder ein privates Grundst\xfcck ist sichtbar","mislocated":"Das Bild ist falsch auf der Karte eingezeichnet","copyright":"Das Bild verst\xf6\xdft gegen das Urheberrecht","other":"Eine andere Art von Problem"},"report_details_placeholder":"Du kannst optional Details \xfcber das Problem hinzuf\xfcgen","report_auth":"Diese Meldung wird \xfcber dein Konto \\"{a}\\" gesendet","report_nature_label":"Ursache des Problems","report_whole_sequence":"Dies betrifft die gesamte Sequenz","report_details":"Weitere Details","report_email":"Deine Email-Adresse","report_email_placeholder":"Optional","report_submit":"Absenden","report_success":"Deine Meldung wurde erfolgreich gesendet. Sie wird so schnell wie m\xf6glich \xfcberpr\xfcft.","report_failure":"Bei der Erstellung der Meldung ist ein Fehler aufgetreten: {e}. Bitte versuche es sp\xe4ter erneut.","report":"Melden","legend_title":"Zeige Bilderdetails","report_wait":"Meldung wird gesendet\u2026","error_click":"Weiter","error_retry":"Bitte sp\xe4ter erneut versuchen","metadata_camera_resolution":"Aufl\xf6sung","filter_user_mypics":"Meine Fotos","metadata_quality_missing":"kein Wert im Foto gesetzt","filter_date_1month":"1 Monat","filter_date_1year":"1 Jahr","filter_qualityscore":"Qualit\xe4tswert","filter_qualityscore_help":"Zum Aktivieren oder Deaktivieren klicken","map_theme_score":"Qualit\xe4tswert","metadata_quality":"Qualit\xe4t","metadata_quality_help":"Erfahre mehr \xfcber den Qualit\xe4tswert","metadata_quality_resolution_score":"Bewertung der Aufl\xf6sung","metadata_quality_gps_score":"Bewertung der Position","metadata_quality_score":"Gesamtwertung","qualityscore_title":"\xdcber den Qualit\xe4tswert","qualityscore_doc_link":"Weitere Informationen zur Berechnung des Qualit\xe4tsfaktors findest du in unserer Dokumentation","qualityscore_doc_1":"F\xfcr jedes Bild wird ein Qualit\xe4tswert berechnet.","qualityscore_doc_2":"Die Punktzahl wird als Buchstabe angezeigt:","qualityscore_doc_3":"\u201eA\u201c ist die beste Note, \u201eE\u201c die schlechteste.","minimize_short":"Verbergen","semantics_features_none":"Bislang wurde kein Feature in diesem Bild markiert.","semantics_features_default_title":"Tag {nb}","semantics_features_subtitle":"{nb} assoziierte Eigenschaften","semantics_show_all_tags":"Alle Tags anzeigen","semantics_title":"Tags","semantics_tags":"{nb] Tags","semantics_features":"Features im Bild","semantics_hide_all_tags":"Alle Tags verbergen","semantics_annotation_tooltip":"Klicke, um Details zu sehen","semantics_key":"Schl\xfcssel","semantics_value":"Wert","semantics_key_doc":"Mehr \xfcber diesen Schl\xfcssel erfahren","semantics_value_doc":"Mehr \xfcber dieses Tag erfahren","semantics_tags_picture":"Foto-Schlagworte","semantics_tags_picture_none":"Bislang wurden keine Schlagworte f\xfcr dieses Foto gesetzt.","semantics_show_annotations":"Features im Bild anzeigen","semantics_hide_annotations":"Features im Bild verbergen","semantics_wikidata_properties":{"P31":"Instanz von","P279":"Unterklasse von","P361":"Teil von","P180":"zeigt"},"metadata_exif_doc":"Dokumentation der EXIF-Tags","metadata_exif_doc_title":"Wechsle zur Exiv2-Dokumentation f\xfcr eine vollst\xe4ndige Beschreibung von EXIF- und XMP-Tags","metadata_location_coordinates":"Koordinaten (L\xe4ngengrad, Breitengrad)","metadata_location_copy":"Kopiere {v}","metadata_location_copy_more":"Mehr Optionen zum Kopieren der Koordinaten","whats_panoramax":"Panoramax ist eine Geo-Commons f\xfcr Gebietsfotos.","picture_360_long":"Panoramafoto","metadata_summary":"Zusammenfassung","filter_date_6months":"6 Monate","picture_all":"Alle","picture_flat_long":"Klassisches Foto","metadata_general_instance":"Quell-Instanz","geo_uri":"Externe App","contribute_id":"Zu OpenStreetMap mit dem iD Editor beitragen","metadata_general_copy_id":"ID kopieren","metadata_general_copy_picid":"Kopiere Foto-ID","semantics_qualifiers":"Qualifikatoren","panoramax":"Panoramax","semantics_zero_annotations":"In diesem Bild wurden keine Features markiert","semantics_hashtags":"Bild-Hashtags","semantics_editor_error":"Die Syntax ist ung\xfcltig. Deine Tags sollten so aussehen:\\nSchl\xfcssel=Wert\\nPr\xe4fix|Schl\xfcssel=Wert\\nPr\xe4fix|Schl\xfcssel[Qualif_Schl\xfcssel=Qualif_Wert]=Wert\\n\\nDie maximale L\xe4nge eines Schl\xfcssels betr\xe4gt 256 Zeichen, die eines Wertes betr\xe4gt 2048 Zeichen.","semantics_cantsave_invalid":"\xc4nderungen k\xf6nnen nicht angewendet werden, Eingabe ist ung\xfcltig","semantics_editor_example":"Schl\xfcssel=Wert\\nPr\xe4fix|Schl\xfcssel=Wert","semantics_edit":"Attribute bearbeiten","semantics_save":"\xc4nderungen speichern","semantics_undo":"Bearbeitung abbrechen","semantics_send_fail":"\xc4nderungen k\xf6nnen nicht angewendet werden. Bitte versuche es sp\xe4ter noch einmal","semantics_send_ok":"\xc4nderungen wurden erfolgreich hochgeladen","semantics_save_drawn_annotation":"Position speichern","semantics_undo_drawn_annotation":"Abbrechen","semantics_save_drawn_annotation_incomplete":"Sie m\xfcssen vor der Validierung ein Rechteck dass in das Foto passt zeichnen","semantics_delete_annotation":"Dieses Feature l\xf6schen","semantics_delete_annotation_confirm":"M\xf6chtest du dieses Tag wirklich l\xf6schen?","semantics_add_annotation":"Neues Tag hinzuf\xfcgen","semantics_draw_annotation":"Du kannst ein Objekt im Bild markieren, um es hinzuzuf\xfcgen (optional).","semantics_login_needed":"Um Tags oder Features in Fotos zu bearbeiten, ist es erforderlich, in Panoramax-Instanz {n} angemeldet zu sein. M\xf6chtest du dich anmelden?","semantics_doc_title":"\xdcber Tags","semantics_erase_annotation":"Markiertes Feature entfernen","semantics_doc_info1":"Stelle mittels Tags mehr Kontext zu einem Bild bereit.","semantics_doc":"Hilfe","semantics_doc_info3":"Einige Objekte werden automatisch mittels KI erkannt: Eine gute Erkennungsrate kann nicht garantiert werden.","semantics_doc_link":"Erfahre mehr \xfcber Tags","semantics_doc_info2":"Du kannst auch Objekte im Bild markieren: Verkehrszeichen, Stadtmobiliar\u2026 Nutze bestehende Tags, um zu markieren, was du siehst. Du kannst au\xdferdem, falls erforderlich, neue Tags erstellen.","semantics_sequence_tags":"Sequenz-Tag","semantics_picture_tags":"Bild-Tag","semantics_annotation_tags":"Objekt-Tag","filter_gps_precision":"Standortgenauigkeit","filter_gps_precision_lessthan":"Weniger als {n} Meter","filter_gps_precision_between":"Zwischen {n1} und {n2} Metern","filter_gps_precision_morethan":"Mehr als {n} Meter","map_theme_gps":"Standortgenauigkeit","semantics_overlays":{"tfsigns":"Verkehrszeichen","features":"Alle Features"},"semantics_doc_info1u1":"Mit dem Tag transport=car kannst du markieren, dass es mit Hilfe eines Autos aufgenommen wurde.","semantics_zoom_in":"Vergr\xf6\xdfere die Karte, um die Tags zu sehen","semantics_download":"Herunterladen","semantics_download_title":"Tags herunterladen","semantics_download_info":"Alle semantischen Daten (Tags) sind als Open Data verf\xfcgbar. Du kannst sie herunterladen und frei verwenden.","semantics_download_cta":"Open Data herunterladen","semantics_copy":"Attribute kopieren","semantics_value_show_osm":"Auf OpenStreetMap ansehen","filter_gps_precision_help_1":"Zu jedem Bild gibt\'s Infos zur Standortgenauigkeit. Das ist so \xe4hnlich wie die GPS-Genauigkeit beim Fotografieren.","filter_gps_precision_help_2":"Die Genauigkeit wird mit Sternchen angezeigt:","filter_gps_precision_help":"Mehr \xfcber Standortgenauigkeit erfahren","filter_gps_precision_help_3":"\u201e5\u2b50\u201c ist sehr genau (<= {p5}m), \u201e1\u2b50\u201c ist sehr ungenau (> {p1}m) oder unbekannt.","filter_gps_precision_help_4":"Ein RTK-GPS kriegt eine Bewertung von \u201e5\u2b50\u201c, eine Actionkamera wie die GoPro Max eine Bewertung von \u201e3\u2b50\u201c und ein Smartphone-GPS in einer Tiefgarage eine Bewertung von \u201e1\u2b50\u201c.","qualityscore_doc_41":"die GPS-Genauigkeit","qualityscore_doc_42":"die Bildaufl\xf6sung","qualityscore_doc_5":"Ein Profi-Ger\xe4t kriegt die Note A, eine 360\xb0-Actionkamera die Note B und ein Smartphone eine Note zwischen C und E.","qualityscore_doc_4":"Dieser Score wird berechnet anhand von:","popup_details_link":"Mehr Details","indoor_selector_expand":"Klicken, um alle verf\xfcgbaren Level zu sehen","indoor_selector_levelup":"Zum h\xf6heren Level gehen","indoor_selector_leveldown":"Zum niedrigeren Level gehen","indoor_selector_scrollup":"Level-Liste nach oben scrollen","indoor_selector_scrolldown":"Level-Liste nach unten scrollen","indoor_selector_shrink":"Zum Minimieren klicken","indoor_switch":"Innenraumkarten"},"psv":{"twoFingers":"Nutze zwei Finger zum Navigieren","ctrlZoom":"Nutze Strg + Scrollen, um das Bild zu vergr\xf6\xdfern","loadError":"Das Panorama konnte nicht geladen werden"},"map":{"thumbnail":"Vorschau des markierten Fotos","not_public":"Nicht \xf6ffentlich sichtbar","loading":"Laden\u2026","slow_loading":"Die Karte wird nur langsam geladen und k\xf6nnte fehlerhaft erscheinen","map_data":"Kartendaten: {m}","more_panoramax":"Mehr \xfcber Panoramax erfahren"},"maplibre":{"GeolocateControl.FindMyLocation":"Meinen Standort finden","GeolocateControl.LocationNotAvailable":"Standort nicht verf\xfcgbar"}}');
            },
            389: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"Use two fingers to navigate","ctrlZoom":"Use ctrl + scroll to zoom the image","loadError":"The panorama can\'t be loaded"},"maplibre":{"GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available"},"pnx":{"zoom":"Zoom","zoomOut":"Zoom out","zoomIn":"Zoom in","moveUp":"Move up","moveDown":"Move down","moveLeft":"Move left","moveRight":"Move right","moveMiddle":"Center view","expand":"Expand","expand_info":"Make the widget appear in full page","show_psv":"Show the picture viewer","show_map":"Show the map","minimize":"Hide this widget, you can show it again using button in bottom left corner","minimize_short":"Hide","options":"Options","filters":"Filters","layers":"Layers","search":"Search","search_empty":"No results found","search_address":"Search an address, city\u2026","search_user":"Search a username\u2026","share":"Share","share_links":"Links","share_page":"Link to this picture","share_image":"HD Image","share_rss":"RSS feed","share_rss_title":"RSS feed of new sequences in the currently visible map area","share_embed":"Embed on your website","share_embed_docs":"Read more about embed configuration","share_print":"Print","panoramax":"Panoramax","whats_panoramax":"Panoramax is the geo-commons for territories\' pictures.","copy":"Copy","copied":"Copied","error":"We have a problem\u2026","error_click":"Continue","error_retry":"Please retry later","sequence_next":"Next picture in sequence","sequence_play":"Play along this sequence","sequence_pause":"Pause sequence","sequence_prev":"Previous picture in sequence","sequence_more":"More play options","sequence_speed":"Player speed","legend_license":"License: {l}","legend_title":"Show details of picture","id":"iD","contribute_id":"Contribute to OpenStreetMap with iD editor","geo_uri":"External app","josm":"JOSM","josm_live":"Enable JOSM automatic sync on picture loading","loading_labels_serious":["\ud83d\uddfa\ufe0f Loading map data","\ud83d\udda5\ufe0f Querying API","\ud83d\uddbc\ufe0f Loading thumbnails","\ud83d\udd0d Analyzing EXIF metadata","\ud83c\udfd8\ufe0f 3D rendering","\ud83d\udcf7 Initializing 360\xb0 pictures","\ud83d\udfe0 Colour balancing","\ud83d\udcaf Computing Quality Score \xa9","\ud83d\udce1 Downloading updates","\ud83c\udf0d Fetching map tiles","\ud83d\udcf8 Processing shadows"],"loading_labels_fun":["\ud83e\udd8c Detecting deer crossing signs","\ud83d\ude98 Searching Panoramax Car \xa9","\u2615 Injecting caffeine","\ud83d\ude00 Smile, you\'re mapped!","\ud83d\udc08 Sharing cat pictures","\ud83d\ude34 Reducing procrastination","\ud83e\uded6 Brewing tea","\ud83d\udc27 Opening source code","\ud83d\ude87 Indexing Underground stations","\ud83e\uddf9 Metadata cleanup","\ud83d\ude92 Sending fire station photos","\ud83d\udeb2 Greenways update","\ud83d\ude89 Station platform walkthrough","\ud83d\udef0\ufe0f Searching satellites","\ud83d\udc65 Writing personas","\ud83d\udc1f Locating chip shops","\ud83e\uddd1\u200d\ud83d\udcbb Debugging interface","\ud83d\udcc8 Incrementing statistics","\ud83e\udd16 Learning semantics","\ud83c\udfa8 Interface redesign","\ud83d\udcc5 Planning photo-mapping-parties","\ud83e\uddc0 Maturing cheddars","\ud83c\udf04 Calculating Cornish sunshine","\ud83c\udf0a Measuring the high tides"],"error_psv":"Photo Sphere Viewer is not loading properly","error_pic":"Requested picture wasn\'t found","error_nopic":"No picture available at given position","error_api":"The pictures server is not available","error_webgl":"WebGL is not supported by your browser","error_josm":"JOSM doesn\'t respond, is it running and is remote enabled?","error_api_compatibility":"The pictures server is not compatible with this viewer version","filter_date":"Date","filter_date_1month":"1 month","filter_date_6months":"6 months","filter_date_1year":"1 year","filter_user":"User","filter_user_mypics":"My pictures","filter_picture":"Picture type","filter_zoom_in":"Zoom-in the map to see this filter","picture_all":"All","picture_flat":"Classic","picture_360":"360\xb0","picture_flat_long":"Classic picture","picture_360_long":"Panoramic picture","popup_details_link":"More details","filter_qualityscore":"Quality score","filter_qualityscore_help":"Click to enable or disable","qualityscore_doc_1":"A Quality Score is computed for each picture.","qualityscore_doc_2":"The Score is shown as a letter:","qualityscore_doc_3":"\\"A\\" is the best grade, \\"E\\" the worst.","qualityscore_doc_4":"This Score is computed based on:","qualityscore_doc_41":"the GPS precision","qualityscore_doc_42":"the picture resolution","qualityscore_doc_5":"A professional device will have an A-grade, a 360\xb0 action camera a B-grade, and a smartphone a grade between C and E.","qualityscore_doc_link":"Know more about the Quality Score","filter_gps_precision":"Location precision","filter_gps_precision_lessthan":"Less than {n} meters","filter_gps_precision_between":"Between {n1} and {n2} meters","filter_gps_precision_morethan":"More than {n} meters","filter_gps_precision_help":"Know more about Location precision","filter_gps_precision_help_1":"A Location Precision information is available for every picture. This corresponds to GPS precision during picture capture.","filter_gps_precision_help_2":"The precision is expressed with stars:","filter_gps_precision_help_3":"\\"5\u2b50\\" is very precise (<= {p5}m), \\"1\u2b50\\" is very imprecise (> {p1}m) or unknown.","filter_gps_precision_help_4":"A RTK GPS will have a \\"5\u2b50\\" grade, an action camera like GoPro Max a \\"3\u2b50\\" grade, and a smartphone GPS in an underground parking a \\"1\u2b50\\" grade.","map_background":"Map background","map_background_aerial":"Aerial","map_background_streets":"Streets","map_theme":"Map theme","map_theme_default":"Classic","map_theme_age":"Capture date","map_theme_age_1":"> 2 years","map_theme_age_2":"< 2 years","map_theme_age_3":"< 1 year","map_theme_age_4":"< 1 month","map_theme_type":"Camera type","map_theme_score":"Quality score","map_theme_gps":"Location precision","contrast":"Enable higher image contrast","metadata":"Picture metadata","metadata_summary":"Summary","metadata_general_copy_id":"Copy ID","metadata_general_copy_picid":"Copy picture ID","metadata_general_picid":"Picture","metadata_general_seqid":"Sequence","metadata_general_picid_link":"Go to JSON description of the picture","metadata_general_seqid_link":"Go to JSON description of the sequence","metadata_general_author":"Author","metadata_general_license":"License","metadata_general_license_link":"See the full licence description","metadata_general_date":"Capture date","metadata_general_instance":"Origin instance","metadata_camera":"Camera","metadata_camera_make":"Make","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Resolution","metadata_camera_focal_length":"Focal length","metadata_location":"Position","metadata_location_coordinates":"Coordinates (longitude, latitude)","metadata_location_orientation":"Direction","metadata_location_precision":"Positioning precision","metadata_location_copy":"Copy {v}","metadata_location_copy_more":"More coordinates copy options","metadata_quality":"Quality","metadata_quality_help":"Know more about Quality Score","metadata_quality_score":"Global score","metadata_quality_gps_score":"Positioning score","metadata_quality_resolution_score":"Resolution score","metadata_quality_missing":"no value set in picture","metadata_exif":"EXIF","metadata_exif_name":"Tag","metadata_exif_value":"Value","metadata_exif_doc":"Docs for EXIF tags","metadata_exif_doc_title":"Go to Exiv2 documentation to have full details on EXIF and XMP tags definitions","semantics_title":"Tags","semantics_tags":"{nb} tags","semantics_features":"Picture features","semantics_features_none":"No feature has been drawn in this picture yet.","semantics_features_default_title":"Tag {nb}","semantics_features_subtitle":"{nb} associated properties","semantics_annotation_tooltip":"Click to see details","semantics_show_all_tags":"Show all tags","semantics_hide_all_tags":"Hide all tags","semantics_key":"Key","semantics_value":"Value","semantics_sequence_tags":"Sequence tag","semantics_picture_tags":"Picture tag","semantics_annotation_tags":"Object tag","semantics_doc":"Help","semantics_doc_info1":"Give context around a picture using tags.","semantics_doc_info1u1":"You can tag it as captured by car with the transport=car tag.","semantics_doc_info2":"You can draw objects in the picture as well: road signs, urban equipments\u2026 Mark what you see using existing tags. You can create your own ones as well if necessary.","semantics_doc_info3":"Some objects are automatically detected with AI: quality is not guaranteed.","semantics_doc_link":"Know more about tags","semantics_key_doc":"Know more about this key","semantics_value_doc":"Know more about this tag","semantics_value_show_osm":"See on OpenStreetMap","semantics_qualifiers":"Qualifiers","semantics_show_annotations":"Display picture features","semantics_hide_annotations":"Hide picture features","semantics_zero_annotations":"No features drawn on this picture","semantics_add_annotation":"Add a new tag","semantics_draw_annotation":"You can draw the object you want to add over the picture (Optional).","semantics_erase_annotation":"Erase drawn feature","semantics_delete_annotation":"Delete this feature","semantics_delete_annotation_confirm":"Do you really want to delete this tag ?","semantics_wikidata_properties":{"P31":"instance of","P180":"depicts","P279":"subclass of","P361":"part of"},"semantics_editor_error":"The syntax is invalid. Your tags may look like:\\nkey=value\\nprefix|key=value\\nprefix|key[qualif_key=qualif_val]=value\\n\\nMax key length is 256 characters, max value length 2048 characters.","semantics_editor_example":"key=value\\nprefix|key=value","semantics_copy":"Copy attributes","semantics_edit":"Edit attributes","semantics_save":"Save your changes","semantics_undo":"Cancel your edits","semantics_send_fail":"Unable to save your changes, please try again later","semantics_login_needed":"In order to edit picture tags or features, you need to log in on Panoramax {n} instance. Do you want to log-in ?","semantics_overlays":{"tfsigns":"Traffic signs","features":"All features"},"semantics_zoom_in":"Zoom-in the map to see tags","semantics_download":"Download","semantics_download_title":"Download tags","semantics_download_info":"All semantic data (tags) are available as open data. You can download them and use it as you like.","semantics_download_cta":"Download open data","report":"Report","report_auth":"This report will be sent using your account \\"{a}\\"","report_nature_label":"Cause of the issue","report_nature":{"":"Select the nature of issue\u2026","blur_missing":"A person\'s face or car license plate is visible","blur_excess":"An unnecessary blur was applied to an object","inappropriate":"Picture is inappropriate (unrelated, nudity\u2026)","privacy":"A private path or property is visible","picture_low_quality":"Image is low quality","mislocated":"Picture is poorly positioned on map","copyright":"Picture infringes copyright","other":"Any other kind of issue"},"report_whole_sequence":"This concerns the entire sequence","report_details":"Additional details","report_details_placeholder":"Optionally, you can add details about the issue","report_email":"Your email","report_email_placeholder":"Optional","report_submit":"Submit","report_wait":"Sending report\u2026","report_success":"Report was sent successfully. It will be reviewed as soon as possible.","report_failure":"An error occurred when creating report: {e}. Please try again later.","indoor_switch":"Indoor maps","indoor_selector_expand":"Click to see all available levels","indoor_selector_shrink":"Click to minimize","indoor_selector_levelup":"Go to upper level","indoor_selector_leveldown":"Go to lower level","indoor_selector_scrollup":"Scroll the level list up","indoor_selector_scrolldown":"Scroll the level list down","visibility_logged-only":"Members","visibility_title_logged-only":"Only people with an account can see this picture","visibility_owner-only":"Hidden","visibility_title_owner-only":"Only you can see this picture"},"map":{"loading":"Loading\u2026","thumbnail":"Thumbnail of hovered picture","not_public":"Not publicly visible","slow_loading":"Map is slow to load and could appear broken","map_data":"Map based on {m}","more_panoramax":"Discover more about Panoramax"}}');
            },
            9946: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"Uzu du fingrojn por navigi","ctrlZoom":"Uzu ctrl + rulumo por zomi la bildon","loadError":"La bildo ne povas esti \u015dar\u011dita"},"pnx":{"zoom":"Zomo","zoomOut":"Malzomo","zoomIn":"Zomi","moveUp":"Movi supren","moveDown":"Movi malsupren","moveLeft":"Movi maldekstren","moveRight":"Movi dekstren","moveMiddle":"Centri vido","expand":"Pligrandigi","expand_info":"Aperigu la fenestra\u0135on en plena pa\u011do","show_psv":"Montri la bildspektilo","show_map":"Montri la mapo","minimize":"Maski la fenestra\u0135o, vu povas montri \u011din denove kun la butono en malsupra maldekstra angulo","sequence_prev":"Anta\u016da foto en la sekvenco","sequence_more":"Pli da ludopcioj","sequence_speed":"Rapideco de legado","sequence_next":"Sekva foto en la sekvenco","sequence_play":"Foliumi \u0109i tiun sinsekvon","sequence_pause":"Pa\u016dzi la sekvenco","copy":"Kopii","copied":"Kopiita","error":"Ni havas problemon\u2026","error_click":"Kontinui","error_retry":"Bonvolu reprovi poste","search_address":"Ser\u0109i adreson, urbon\u2026","filters":"Filtriloj","layers":"Tavoloj","search":"Ser\u0109i","share_embed_docs":"Pli pri enigito sur via retpa\u011daro","search_empty":"Neniu rezulto trovita","search_user":"Ser\u0109i uzantnomon\u2026","share":"Kunhavigi","share_links":"Ligiloj","share_page":"Ligilo de la foto","share_image":"HD bildo","share_rss":"RSS abonfluo","share_rss_title":"RSS abonfluo de la novaj sekvecoj en la nuntempe videbla mapzono","share_embed":"Enigita en via retpa\u011daro","share_print":"Presi","edit_osm":"Modifi OSM","legend_license":"Rajtigilo : {l}","josm_live":"Ebligas a\u016dtomatan JOSM-sinkronigon dum \u015dar\u011do de bildo","loading_labels_serious":["\ud83d\uddfa\ufe0f \u015cargo de la bazmapon","\ud83d\udda5\ufe0f API demandado","\ud83d\uddbc\ufe0f \u015car\u011do de miniaturoj","\ud83d\udd0d Analizo de EXIF-metadatumoj","\ud83c\udfd8\ufe0f 3D-rendumo","\ud83d\udcf7 Inico de 360\xb0-bildoj","\ud83d\udfe0 Kolora ekvilibrigo","\ud83d\udcaf Kalkulo de kvalitpoentaro \xa9","\ud83d\udce1 El\u015dutante \u011disdatoj","\ud83c\udf0d Reakirante mapkaheloj","\ud83d\udcf8 Traktadante ombroj"],"legend_title":"Montri la detaloj de la bildo","error_api":"La bildservilo ne estas disponebla","error_josm":"JOSM ne respondis. \u0108u \u011di funkcias kaj la regilo estas \u015daltita?","error_webgl":"WebGL ne estas subtenata per via retumilo","loading_labels_fun":["\ud83e\udd8c Detekto de cervinaj vojmontriloj","\ud83d\ude98 Ser\u0109o de Panoramax-a\u016dto \xa9","\u2615 Injekto de kafeino","\ud83d\ude00 Ridetu, vi estas mapita!","\ud83d\udc08 Kunhavigo de katbildoj","\ud83d\ude34 Redukto de prokrastado","\ud83d\udcd6 Lernado de Esperanto","\ud83d\udc27 Malfermo de fontkodo","\ud83d\ude87 Indekso de subteraj stacioj","\ud83e\uddf9 Purigo de metadatumoj","\ud83d\ude92 Sendado de fotoj de fajrostacioj","\ud83d\udeb2 \u011cisdatigo de verdaj vojoj","\ud83d\ude89 Promenado tra stacioplatformoj","\ud83d\udef0\ufe0f Ser\u0109o de satelitoj","\ud83d\udc65 Verkado de roluloj","\u2747\ufe0f Lokalizo de la Esperanto-flagoj","\ud83e\uddd1\u200d\ud83d\udcbb Sencimigado de la interfaco","\ud83d\udcc8 Alkrementi de la statistikoj","\ud83e\udd16 Lernadante semantiko","\ud83c\udfa8 Interfaca redezajno","\ud83d\udcc5 Planante fota-mapa-festoj","\ud83e\uddc0 Finmaturigo de la froma\u011doj","\ud83c\udf04 Kalkulante la sunbrilon de la Saharo","\ud83c\udf0a Mezurado de la altaj tajdoj"],"picture_360":"360\xb0","picture_flat":"Klasika","report_nature_label":"Speco de problemo","report_nature":{"":"Elektu la specon de problemo\u2026","blur_missing":"Viza\u011do a\u016d numerplato estas videbla","copyright":"La bildo malobeas kopirajton","blur_excess":"Objekto kiu ne bezonis malklari\u011don estas malklarigita","inappropriate":"La bildo estas neta\u016dga (nevera, nudeco...)","privacy":"Privata vojo a\u016d poseda\u0135o estas videbla","picture_low_quality":"La bildo estas de tre malbona kvalito","mislocated":"La bildo estas malbone poziciigita sur la mapo","other":"\u0108ia alia speco de problemo"},"report":"Raporti","report_auth":"\u0108i tiu raporto estos sendita per via konto \\"{a}\\"","filter_date":"Dato","filter_user_mypics":"Miaj fotoj","options":"Opcioj","error_api_compatibility":"La fotoservilo ne kongruas kun \u0109i tiu spektilo","filter_qualityscore":"Kvalitpoentaro","filter_qualityscore_help":"Alllaku por aktivigi a\u016d mal\u015dalti","map_theme_age":"Dato de fotado","map_theme_age_1":"> 2 jaroj","map_theme_age_2":"< 2 jaroj","map_theme_age_3":"< 1 jaro","map_theme_age_4":"< 1 monato","map_theme_score":"Kvalitpoentaro","metadata":"Metadatenoj de la bildo","map_theme_type":"Fotiltipo","metadata_general_seqid":"Sekvenco","metadata_camera_resolution":"Difino","metadata_quality_resolution_score":"Rezolucia poentaro","error_psv":"Foto-Sfera Spektilo ne \u015dar\u011di\u011das \u011duste","error_pic":"La petita bildo ne estis trovita","error_nopic":"Neniu bildo disponeblas \u0109e la donita pozicio","filter_user":"Uzanto","map_theme_default":"Klasika","filter_date_1month":"1 monato","filter_date_1year":"1 jaro","contrast":"Pliigi bildkontraston","metadata_general_picid":"Foto","filter_picture":"Bilda tipo","filter_zoom_in":"Zomu en la mapo por vidi tiun filtrilon","map_background":"Bazmapo","map_background_aerial":"Aera","map_background_streets":"Stratoj","map_theme":"Mapa etoso","metadata_general_picid_link":"Iru al la JSON-priskribo de la foto","metadata_general_seqid_link":"Iru al la JSON-priskribo de la sekvenco","metadata_general_author":"A\u016dtoro","metadata_general_license":"Rajtigilo","metadata_general_license_link":"Vidi la kompletan rajtigilon en la priskribo","metadata_general_date":"Dato de la fotado","metadata_camera":"Fotilo","metadata_camera_make":"Faristo","metadata_camera_model":"\u015cablono","metadata_camera_type":"Tipo","metadata_camera_focal_length":"Fokuslongo","metadata_location":"Pozicio","metadata_location_longitude":"Longitudo","metadata_location_latitude":"Latitudo","metadata_location_orientation":"Direkto","metadata_location_precision":"Pozicia precizeco","metadata_quality":"Kvalito","metadata_quality_help":"Pli pri la Kvalitapoentaro","metadata_quality_score":"Malloka poentaro","metadata_quality_gps_score":"Pozicia poentaro","metadata_quality_missing":"neniu valoro en la bildo","metadata_exif":"EXIF","metadata_exif_name":"Etikedo","metadata_exif_value":"Valoro","report_whole_sequence":"\u0108i tio koncernas la tutan sekvencon","report_details":"Aliaj detaloj","report_email":"Via retpo\u015dto","report_submit":"Sendi","report_wait":"Sendante raporton\u2026","report_success":"La raporto estis sukcese sendita. \u011ci estos reviziita balda\u016d.","report_details_placeholder":"Opcie, vi povas aldoni detalojn pri la problemo","report_email_placeholder":"Opcie","report_failure":"Eraro okazis dum kreo de la raporto: {e}. Bonvolu provi denove poste.","qualityscore_doc_3":"\u011ci estas kalkulita surbaze de GPS-precizeco kaj bildrezolucio. Profesiaj sistemoj havos A-poentaron, 360\xb0-akcifotilo havos B-poentaron, kaj po\u015dtelefono havos C/D/E-poentaron.","qualityscore_title":"Pri la kvalita poentaro","qualityscore_doc_1":"Panoramax ofertas Kvalitan Poentaron por \u0109iu bildo. \u011ci ebligas facilan mapfiltradon kaj ampleksan vidigon de la havebleco de altkvalitaj bildoj.","qualityscore_doc_link":"Pli da detaloj pri la kalkulo de la Kvalita Poentaro estas disponeblaj en nia dokumentado","minimize_short":"Maski","qualityscore_doc_2":"La poentaro estas montrita al uzantoj kiel litero A/B/C/D/E (A estas la plej bona, E la plej malbona) kaj grafike prezentita per \u0109i tiu skalo:","id":"iD","josm":"JOSM","contribute_id":"Kontribuu al OpenStreetMap kun iD-modifilo","filter_date_6months":"6 monatoj","picture_all":"\u0108iuj","picture_flat_long":"Klasika foto","picture_360_long":"Panorama foto","metadata_summary":"Resumo","metadata_general_copy_id":"Kopii la ID-on","metadata_general_copy_picid":"Kopii la fotan ID-on","metadata_general_instance":"Origina instanco","geo_uri":"Ekseteraj aplika\u0135oj","semantics_title":"Etikedoj","semantics_tags":"{nb} etikedoj","semantics_features":"Detektitaj objektoj","semantics_features_none":"No objekto estis ankora\u016d detektita a\u016d prinotita en \u0109i tiu foto.","semantics_features_default_title":"Objekto #{nb}","metadata_exif_doc":"Dokumentoj por EXIF-etikedoj","metadata_exif_doc_title":"Iru al la dokumentaro de Exiv2 por havi plenajn detalojn pri difinoj de EXIF kaj XMP-etikedoj","metadata_location_coordinates":"Koordinatoj (longitudo, latitudo)","metadata_location_copy":"Kopii {v}","metadata_location_copy_more":"Pli da ebloj por kopii koordinatojn","whats_panoramax":"Panoramax estas la geokomuna\u0135o por teritoriaj fotoj.","semantics_features_subtitle":"{nb} asociitaj atributoj","semantics_tags_picture_none":"Ankora\u016d neniuj atributoj estas difinitaj por \u0109i tiu foto.","semantics_hide_all_tags":"Maski la atributojn","semantics_key":"\u015closilo","semantics_value":"Valoro","semantics_show_all_tags":"Vidi \u0109iujn atributojn","semantics_tags_picture":"Foto-atributoj","semantics_value_doc":"Lernu pli pri \u0109i tiu atributo","semantics_qualifiers":"Kvalifikiloj","semantics_hide_annotations":"Maski bildajn komentojn","semantics_wikidata_properties":{"P279":"subklaso de","P361":"parto de","P31":"instanco de"},"share_picture":"Foto","semantics_annotation_tooltip":"Alklaku por vidi la detalojn","semantics_show_annotations":"Montri bildajn komentojn","semantics_key_doc":"Lernu pli pri \u0109i tiu \u015dlosilo"},"maplibre":{"GeolocateControl.FindMyLocation":"Trovi mian pozicion","GeolocateControl.LocationNotAvailable":"Loko ne disponeblas"},"map":{"slow_loading":"La mapo \u015dar\u011das malrapide kaj povus aperi rompi\u011dinta","loading":"\u015car\u011danto\u2026","thumbnail":"Miniaturo de la surflikta bildo","not_public":"Ne publike videbla","more_panoramax":"Malkovri pli pri Panoramax","map_data":"Kartaj datumoj : {m}"}}');
            },
            8302: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"report_auth":"La denuncia se enviar\xe1 usando tu cuenta \xab{a}\xbb","report":"Denunciar imagen","report_nature_label":"Tipo de problema","report_nature":{"":"Selecciona el tipo de problema\u2026","blur_missing":"Se ve el rostro de una persona, o una matr\xedcula","blur_excess":"Est\xe1 borroso un objeto que no hac\xeda falta ocultar","inappropriate":"La imagen no es apropiada (irrelevante, desnudez, \u2026)","privacy":"Se ve un camino privado, o una propiedad privada","mislocated":"La localizaci\xf3n de la imagen en el mapa no es correcta","picture_low_quality":"La calidad de la imagen es pobre","copyright":"La imagen infringe derechos de autor","other":"Otro tipo de problema"},"sequence_more":"M\xe1s opciones de reproducci\xf3n","sequence_speed":"Velocidad de reproducci\xf3n","legend_license":"Licencia: {l}","edit_osm":"Editar OpenStreetMap","id":"iD","josm":"JOSM","josm_live":"Activar la sincronizaci\xf3n autom\xe1tica de JOSM cuando se carga una imagen","loading_labels_serious":["\ud83d\uddfa\ufe0f Cargando datos del mapa","\ud83d\udda5\ufe0f Consultando la API","\ud83d\uddbc\ufe0f Cargando vistas previas","\ud83d\udd0d Analizando metadatos EXIF","\ud83c\udfd8\ufe0f Renderizado 3D","\ud83d\udcf7 Preparando im\xe1genes 360\xb0","\ud83d\udfe0 Ajustando balance de color","\ud83d\udcaf C\xe1lculo del nivel de calidad \xa9"],"metadata":"Metadatos de la imagen","map_theme_type":"Tipo de c\xe1mara","contrast":"Dar m\xe1s contraste a la imagen","zoom":"Acercar/alejar","zoomOut":"Alejar","map_background_streets":"Calles","loading_labels_fun":["\ud83e\udd8c Detectando paneles de cruce de alces","\ud83d\ude98 Buscando el Coche Panoramax \xa9","\u2615 Inyectando cafe\xedna","\ud83d\ude00 \xa1Sonr\xede, est\xe1s siendo mapeado!","\ud83d\udc08 Compartiendo fotos de gatos","\ud83d\ude34 Reduciendo la procrastinaci\xf3n","\ud83e\uded6 Preparando el t\xe9","\ud83d\udc27 Abriendo el c\xf3digo fuente","\ud83d\ude87 Indexando estaciones del metro","\ud83e\uddf9 Limpieza de metadatos","\ud83d\ude92 Enviando fotos de estaciones de bomberos","\ud83d\udeb2 Actualizando v\xedas verdes","\ud83d\ude89 Paseo por el and\xe9n de la estaci\xf3n","\ud83d\udef0\ufe0f Buscando sat\xe9lites","\ud83d\udc65 Describiendo tipolog\xedas de persona","\ud83d\udc1f Localizando tiendas de fish & chips","\ud83e\uddd1\u200d\ud83d\udcbb Buscando gazapos de la interfaz","\ud83d\udcc8 Incrementando estad\xedsticas"],"metadata_general_license_link":"Ir a la descripci\xf3n completa de la licencia","metadata_general_picid":"Identificador de la imagen","metadata_general_license":"Licencia","report_details_placeholder":"Opcional; puedes a\xf1adir m\xe1s detalles sobre el problema y por qu\xe9 te preocupa","expand":"Expandir","expand_info":"Mostrar el elemento ocupando toda la p\xe1gina","show_psv":"Mostrar el visor de im\xe1genes","show_map":"Mostrar el mapa","zoomIn":"Acercar","moveUp":"Desplazar hacia arriba","moveDown":"Desplazar hacia abajo","moveLeft":"Desplazar hacia la izquierda","moveRight":"Desplazar hacia la derecha","moveMiddle":"Centrar la vista","minimize":"Esconder este elemento. Para mostrarlo de nuevo, pulsa el bot\xf3n en la esquina inferior izquierda","options":"Opciones","filters":"Filtros","layers":"Capas","search":"Buscar","search_empty":"No se encontraron resultados","search_address":"Buscar una direcci\xf3n, una ciudad, \u2026","search_user":"Buscar un usuario\u2026","share":"Compartir","share_links":"Enlaces","share_page":"Enlace a esta p\xe1gina","share_image":"Imagen de alta calidad","share_rss":"Flujo RSS","share_rss_title":"Flujo RSS de las nuevas secuencias en el \xe1rea visible del mapa","share_embed":"Incrustar en tu p\xe1gina web","share_embed_docs":"M\xe1s informaci\xf3n sobre c\xf3mo configurar el incrustado","share_print":"Imprimir","copy":"Copiar","copied":"Copiado","error":"Hay un problema\u2026","sequence_next":"Siguiente imagen de la secuencia","sequence_play":"Reproducir esta secuencia","sequence_pause":"Pausar la secuencia","sequence_prev":"Imagen anterior de la secuencia","error_click":"Continuar","error_retry":"Por favor, int\xe9ntalo m\xe1s tarde","error_psv":"El visor de fotos esf\xe9ricas no se carga correctamente","error_pic":"No se encuentra la imagen que quer\xedamos","error_nopic":"No hay im\xe1genes para la posici\xf3n dada","error_api":"El servidor de im\xe1genes no est\xe1 disponible","error_webgl":"Este navegador no admite WebGL","error_josm":"JOSM no responde. \xbfEst\xe1 abierto, y admite el modo de Control Remoto?","error_api_compatibility":"El servidor de im\xe1genes no es compatible con esta versi\xf3n del visor","filter_date":"Fecha","filter_user":"Usuario","filter_picture":"Tipo de imagen","filter_zoom_in":"Ac\xe9rcate para poder ver filtros","picture_flat":"Cl\xe1sico","picture_360":"360\xb0","filter_camera_model":"Por modelo de c\xe1mara","map_background":"Fondo de mapa","map_background_aerial":"Vista a\xe9rea","map_theme":"Tema de mapa","map_theme_default":"Cl\xe1sico","map_theme_age":"Fecha de toma de imagen","map_theme_age_1":"M\xe1s de dos a\xf1os","map_theme_age_2":"Menos de dos a\xf1os","map_theme_age_3":"Menos de un a\xf1o","map_theme_age_4":"Menos de un mes","metadata_general_seqid":"Identificador de la secuencia","metadata_general_picid_link":"Ir a la descripci\xf3n de la imagen en formato JSON","metadata_general_seqid_link":"Ir a la descripci\xf3n de la secuencia en formato JSON","metadata_general_author":"Autor","metadata_general_date":"Fecha de toma de imagen","metadata_camera":"C\xe1mara","metadata_camera_make":"Marca","metadata_camera_model":"Modelo","metadata_camera_type":"Tipo","metadata_camera_focal_length":"Distancia focal","metadata_location":"Localizaci\xf3n","metadata_location_longitude":"Longitud","metadata_location_latitude":"Latitud","metadata_location_orientation":"Orientaci\xf3n","metadata_location_precision":"Precisi\xf3n de la localizaci\xf3n","metadata_exif":"EXIF / XMP","metadata_exif_name":"Etiqueta","metadata_exif_value":"Valor","report_whole_sequence":"El problema afecta a la secuencia entera","report_details":"M\xe1s detalles","report_email":"Tu direcci\xf3n de correo electr\xf3nico","report_email_placeholder":"Opcional","report_submit":"Enviar","report_success":"La denuncia se ha enviado correctamente. Ser\xe1 revisada lo antes posible.","report_failure":"Ocurri\xf3 un error al crear la denuncia: {e}. Por favor, int\xe9ntalo m\xe1s tarde.","map_theme_score":"Nivel de calidad","filter_qualityscore":"Nivel de calidad","filter_qualityscore_help":"Haga clic para habilitar o deshabilitar","legend_title":"Ver detalles de la imagen","metadata_camera_resolution":"Resoluci\xf3n","metadata_quality":"Puntuaci\xf3n de calidad","metadata_quality_help":"M\xe1s informaci\xf3n sobre el nivel de calidad","metadata_quality_score":"Valoraci\xf3n general","metadata_quality_gps_score":"Puntuaci\xf3n de posicionamiento","metadata_quality_resolution_score":"Puntuaci\xf3n de resoluci\xf3n","metadata_quality_missing":"no hay informaci\xf3n en la imagen","report_wait":"Env\xedo del informe\u2026"},"psv":{"ctrlZoom":"Utiliza Control+rueda de desplazamiento para acercar/alejar","loadError":"Este panorama no se puede cargar","twoFingers":"Desplaza el mapa con dos dedos"},"maplibre":{"GeolocateControl.FindMyLocation":"Local\xedzame","GeolocateControl.LocationNotAvailable":"Localizaci\xf3n no disponible"},"map":{"loading":"Cargando\u2026","thumbnail":"Vista previa de la imagen bajo el cursor","not_public":"No es visible p\xfablicamente","slow_loading":"La mapa tarda mucho en cargarse y puede parecer rota"}}');
            },
            5222: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"Utilisez deux doigts pour vous d\xe9placer","ctrlZoom":"Utilisez ctrl + scroll pour zoomer dans l\'image","loadError":"L\'image ne peut pas \xeatre charg\xe9e"},"maplibre":{"GeolocateControl.FindMyLocation":"Afficher ma position","GeolocateControl.LocationNotAvailable":"GPS non-disponible"},"pnx":{"zoom":"Zoom","zoomOut":"D\xe9zoomer","zoomIn":"Zoomer","moveUp":"Vers le haut","moveDown":"Vers le bas","moveLeft":"Vers la gauche","moveRight":"Vers la droite","moveMiddle":"Centrer la vue","expand":"Agrandir","expand_info":"Faire appara\xeetre ce widget en pleine page","show_psv":"Afficher la visionneuse de photos","show_map":"Afficher la carte","minimize":"Masquer ce widget, vous pouvez l\'afficher de nouveau gr\xe2ce au bouton dans le coin en bas \xe0 gauche","minimize_short":"Masquer","options":"Options","filters":"Filtres","layers":"Calques","search":"Rechercher","search_empty":"Aucun r\xe9sultat","search_address":"Rechercher une adresse, ville\u2026","search_user":"Rechercher un nom d\'utilisateur\u2026","share":"Partager","share_links":"Liens utiles","share_page":"Lien de la photo","share_image":"Image HD","share_rss":"Flux RSS","share_rss_title":"Flux RSS des nouvelles s\xe9quences dans la zone visible sur la carte","share_embed":"Int\xe9gration sur votre site","share_embed_docs":"D\xe9couvrir plus de possibilit\xe9s pour l\'int\xe9gration sur votre site","share_print":"Imprimer","panoramax":"Panoramax","whats_panoramax":"Panoramax est le g\xe9ocommun des photos des territoires.","copy":"Copier","copied":"Copi\xe9","error":"On a un probl\xe8me\u2026","error_click":"Continuer","error_retry":"Merci de r\xe9essayer plus tard","sequence_next":"Photo suivante dans la s\xe9quence","sequence_play":"Parcourir cette s\xe9quence","sequence_pause":"Mettre en pause la s\xe9quence","sequence_prev":"Photo pr\xe9c\xe9dente dans la s\xe9quence","sequence_more":"Plus d\'options de lecture","sequence_speed":"Vitesse de lecture","legend_license":"Licence : {l}","legend_title":"Afficher les d\xe9tails de l\'image","id":"iD","contribute_id":"Contribuez \xe0 OpenStreetMap avec l\'\xe9diteur iD","geo_uri":"App externe","josm":"JOSM","josm_live":"Active la synchronisation automatique de JOSM lors du chargement d\'une photo","loading_labels_serious":["\ud83d\uddfa\ufe0f Chargement du fond de carte","\ud83d\udda5\ufe0f Interrogation de l\'API","\ud83d\uddbc\ufe0f Chargement des miniatures","\ud83d\udd0d Analyse des m\xe9tadonn\xe9es EXIF","\ud83c\udfd8\ufe0f Cr\xe9ation du rendu 3D","\ud83d\udcf7 Initialisation des vues 360\xb0","\ud83d\udfe0 \xc9quilibrage des couleurs","\ud83d\udcaf Calcul du score qualit\xe9 \xa9","\ud83d\udce1 T\xe9l\xe9chargement des mises \xe0 jour","\ud83c\udf0d R\xe9cup\xe9ration des tuiles","\ud83d\udcf8 Traitement des ombres"],"loading_labels_fun":["\ud83e\udd8c D\xe9tection des panneaux biche","\ud83d\ude98 Recherche de la Panoramax Car \xa9","\u2615 Injection de caf\xe9ine","\ud83d\ude00 Souriez, vous \xeates mapp\xe9s !","\ud83d\udc08 Partage de photos de chats","\ud83d\ude34 R\xe9duction de la procrastination","\ud83c\uddf7\ud83c\uddea Chargement : 974%","\ud83d\udc27 Ouverture du code source","\ud83e\udd81 Indexation des traboules","\ud83e\uddf9 Nettoyage des m\xe9tadonn\xe9es","\ud83d\ude92 Envoi des photos du SDIS","\ud83d\udeb2 Mise \xe0 jour des voies vertes","\ud83d\ude89 Remont\xe9e des quais de gare","\ud83d\udef0\ufe0f Recherche de satellites","\ud83d\udc65 \xc9criture des personas","\ud83e\udd5e Localisation des cr\xeaperies","\ud83e\uddd1\u200d\ud83d\udcbb D\xe9boguage de l\'interface","\ud83d\udcc8 Incr\xe9mentation des statistiques","\ud83e\udd16 Apprentissage de la s\xe9mantique","\ud83c\udfa8 Redesign de l\'interface","\ud83d\udcc5 Planification des photos-carto-parties","\ud83e\uddc0 Affinage des fromages","\ud83c\udf04 Calcul de l\'ensoleillement corse","\ud83c\udf0a Mesure des grandes mar\xe9es"],"error_psv":"Photo Sphere Viewer ne s\'est pas charg\xe9 correctement","error_pic":"La photo demand\xe9e est introuvable","error_nopic":"Aucune photo disponible autour de la localisation recherch\xe9e","error_api":"Le serveur de photos n\'est pas disponible","error_webgl":"WebGL n\'est pas support\xe9 par votre navigateur","error_josm":"JOSM n\'a pas r\xe9pondu, est-il bien lanc\xe9 et la t\xe9l\xe9commande activ\xe9e ?","error_api_compatibility":"Le serveur de photos n\'est pas compatible avec cette visionneuse","filter_date":"Date","filter_date_1month":"1 mois","filter_date_6months":"6 mois","filter_date_1year":"1 an","filter_user":"Utilisateur","filter_user_mypics":"Mes photos","filter_picture":"Type d\'image","picture_all":"Tout","picture_flat":"Classique","picture_360":"360\xb0","picture_flat_long":"Photo classique","picture_360_long":"Photo panoramique","popup_details_link":"Plus de d\xe9tails","filter_qualityscore":"Score de qualit\xe9","filter_qualityscore_help":"Cliquez pour activer ou d\xe9sactiver","qualityscore_doc_1":"Un Score de Qualit\xe9 est calcul\xe9 pour chaque image.","qualityscore_doc_2":"Le Score est affich\xe9 sous la forme d\'une lettre :","qualityscore_doc_3":"\\"A\\" est la meilleure note, \\"E\\" la moins bonne.","qualityscore_doc_4":"Ce score est calcul\xe9 selon :","qualityscore_doc_41":"la pr\xe9cision du GPS","qualityscore_doc_42":"la r\xe9solution de la photo","qualityscore_doc_5":"Un mat\xe9riel professionnel aura une note de A, une cam\xe9ra sportive 360\xb0 une note de B, et un smartphone une note entre C et E.","qualityscore_doc_link":"En savoir plus sur le Score de Qualit\xe9","filter_zoom_in":"Zoomez la carte pour voir ce filtre","filter_gps_precision":"Pr\xe9cision du positionnement","filter_gps_precision_lessthan":"Moins de {n} m\xe8tres","filter_gps_precision_between":"Entre {n1} et {n2} m\xe8tres","filter_gps_precision_morethan":"Plus de {n} m\xe8tres","filter_gps_precision_help":"En savoir plus sur la pr\xe9cision du positionnement","filter_gps_precision_help_1":"Une Pr\xe9cision du positionnement est disponible pour chaque image. Cela correspond \xe0 la pr\xe9cision du GPS utilis\xe9.","filter_gps_precision_help_2":"La pr\xe9cision est exprim\xe9 sous forme d\'\xe9toile :","filter_gps_precision_help_3":"\\"5\u2b50\\" est tr\xe8s pr\xe9cis (<= {p5}m), \\"1\u2b50\\" est tr\xe8s impr\xe9cis (> {p1}m) ou inconnu.","filter_gps_precision_help_4":"Un GPS RTK aura une note de \\"5\u2b50\\", un GPS de cam\xe9ra sportive type GoPro Max une note de \\"3\u2b50\\", un GPS de smartphone dans un parking souterrain une note de \\"1\u2b50\\".","map_background":"Fond de carte","map_background_aerial":"Satellite","map_background_streets":"Plan","map_theme":"Rendu de carte","map_theme_default":"Classique","map_theme_age":"Date de prise de vue","map_theme_age_1":"> 2 ans","map_theme_age_2":"< 2 ans","map_theme_age_3":"< 1 an","map_theme_age_4":"< 1 mois","map_theme_type":"Type de cam\xe9ra","map_theme_score":"Score de qualit\xe9","map_theme_gps":"Pr\xe9cision du positionnement","contrast":"Augmenter le contraste de l\'image","metadata":"M\xe9tadonn\xe9es de la photo","metadata_summary":"R\xe9sum\xe9","metadata_general_copy_id":"Copier l\'ID","metadata_general_copy_picid":"Copier l\'ID de photo","metadata_general_picid":"Photo","metadata_general_seqid":"S\xe9quence","metadata_general_picid_link":"Aller au descriptif JSON de la photo","metadata_general_seqid_link":"Aller au descriptif JSON de la s\xe9quence","metadata_general_author":"Auteur","metadata_general_license":"Licence","metadata_general_license_link":"Voir la description compl\xe8te de la licence","metadata_general_date":"Date de prise de vue","metadata_general_instance":"Instance d\'origine","metadata_camera":"Appareil","metadata_camera_make":"Fabricant","metadata_camera_model":"Mod\xe8le","metadata_camera_type":"Type","metadata_camera_resolution":"R\xe9solution","metadata_camera_focal_length":"Longueur focale","metadata_location":"Position","metadata_location_coordinates":"Coordonn\xe9es (longitude, latitude)","metadata_location_orientation":"Direction","metadata_location_precision":"Pr\xe9cision du positionnement","metadata_location_copy":"Copier {v}","metadata_location_copy_more":"Copier d\'autres formats de coordonn\xe9es","metadata_quality":"Qualit\xe9","metadata_quality_help":"En savoir plus sur le score de qualit\xe9","metadata_quality_score":"Note globale","metadata_quality_gps_score":"Note du positionnement","metadata_quality_resolution_score":"Note de la r\xe9solution","metadata_quality_missing":"pas d\'info dans l\'image","metadata_exif":"EXIF","metadata_exif_name":"Balise","metadata_exif_value":"Valeur","metadata_exif_doc":"Doc des attributs EXIF","metadata_exif_doc_title":"Ac\xe9\xe9der \xe0 la doc Exiv2 pour en savoir plus sur les attributs EXIF et XMP","semantics_title":"Tags","semantics_tags":"{nb} attributs","semantics_features":"Objets dans la photo","semantics_features_none":"Aucun objet n\'a \xe9t\xe9 dessin\xe9 dans cette photo pour l\'instant.","semantics_features_default_title":"Tag {nb}","semantics_features_subtitle":"{nb} attributs associ\xe9s","semantics_annotation_tooltip":"Cliquez pour voir les d\xe9tails","semantics_show_all_tags":"Voir tous les attributs","semantics_hide_all_tags":"Masquer les attributs","semantics_key":"Cl\xe9","semantics_value":"Valeur","semantics_sequence_tags":"Tag de s\xe9quence","semantics_picture_tags":"Tag de photo","semantics_annotation_tags":"Tag d\'un objet","semantics_doc":"Aide","semantics_doc_info1":"Pr\xe9cisez le contexte d\'une photo en utilisant un tag.","semantics_doc_info1u1":"Indiquez par exemple qu\'elle a \xe9t\xe9 prise en voiture avec le tag transport=car.","semantics_doc_info2":"Vous pouvez \xe9galement d\xe9tourer des objets au sein d\'une photo\u202f: panneaux routiers, mobilier urbain\u2026 Pr\xe9cisez ce que vous voyez en utilisant les tags d\xe9j\xe0 utilis\xe9s par la communaut\xe9. Vous pouvez \xe9galement cr\xe9er votre propre tag si besoin.","semantics_doc_info3":"Certains objets sont d\xe9tect\xe9s automatiquement par IA : il n\'y a pas de garantie de qualit\xe9.","semantics_doc_link":"En savoir plus (documentation compl\xe8te en anglais)","semantics_key_doc":"En savoir plus \xe0 propos de cette cl\xe9","semantics_value_doc":"En savoir plus \xe0 propos de cet attribut","semantics_value_show_osm":"Voir sur OpenStreetMap","semantics_qualifiers":"Qualificateurs","semantics_show_annotations":"Afficher les objets dans la photo","semantics_hide_annotations":"Masquer les objets dans la photo","semantics_zero_annotations":"Aucun objet dessin\xe9 dans cette photo","semantics_add_annotation":"Ajouter un nouveau tag","semantics_draw_annotation":"Vous pouvez dessiner l\'emplacement de l\'objet \xe0 cr\xe9er sur la photo (Optionnel).","semantics_erase_annotation":"Effacer l\'objet dessin\xe9","semantics_delete_annotation":"Supprimer cet objet","semantics_delete_annotation_confirm":"\xcates-vous s\xfbr(e) de vouloir supprimer ce tag ?","semantics_wikidata_properties":{"P31":"instance de","P180":"d\xe9peint","P279":"sous-classe de","P361":"partie de"},"semantics_editor_error":"La syntaxe est invalide. Vos attributs doivent avoir cette forme:\\ncl\xe9=valeur\\npr\xe9fixe|cl\xe9=valeur\\npr\xe9fixe|cl\xe9[qualif_cl\xe9=qualif_val]=valeur\\n\\nLongueur max des cl\xe9s : 256 caract\xe8res, max des valeurs 2048 caract\xe8res.","semantics_editor_example":"cl\xe9=valeur\\npr\xe9fixe|cl\xe9=valeur","semantics_copy":"Copier les attributs","semantics_edit":"Modifier les attributs","semantics_save":"Enregistrer vos modifications","semantics_undo":"Annuler vos modifications","semantics_send_fail":"Impossible d\'enregistrer vos modifications, merci de r\xe9essayer plus tard","semantics_login_needed":"Afin de pouvoir modifier les attributs ou objets de la photo, vous devez vous connecter sur l\'instance Panoramax {n}. Voulez-vous vous connecter ?","semantics_overlays":{"tfsigns":"Panneaux routiers","features":"Tous les objets"},"semantics_zoom_in":"Zoomez la carte pour voir les tags","semantics_download":"T\xe9l\xe9charger","semantics_download_title":"T\xe9l\xe9charger les tags","semantics_download_info":"Toutes les donn\xe9es s\xe9mantiques (tags) sont disponibles en open data. Vous pouvez les t\xe9l\xe9charger et en faire un libre usage.","semantics_download_cta":"T\xe9l\xe9charger les donn\xe9es","report":"Signaler","report_auth":"Ce signalement sera envoy\xe9 en utilisant votre compte \\"{a}\\"","report_nature_label":"Nature du probl\xe8me","report_nature":{"":"S\xe9lectionnez la nature du probl\xe8me\u2026","blur_missing":"Un visage ou une plaque d\'immatriculation est visible","blur_excess":"Un objet a \xe9t\xe9 sur-flout\xe9","inappropriate":"L\'image est inappropri\xe9e (non pertinente, nudit\xe9\u2026)","privacy":"Un chemin priv\xe9 ou une propri\xe9t\xe9 priv\xe9e est visible","picture_low_quality":"L\'image est de mauvaise qualit\xe9","mislocated":"L\'image est mal g\xe9olocalis\xe9e","copyright":"L\'image enfreint les droits d\'auteur","other":"Tout autre type de probl\xe8me"},"report_whole_sequence":"Cela concerne toute la s\xe9quence","report_details":"D\xe9tails suppl\xe9mentaires","report_details_placeholder":"Optionnel, vous pouvez ajouter des d\xe9tails sur le probl\xe8me","report_email":"Votre email","report_email_placeholder":"Optionnel","report_submit":"Envoyer","report_wait":"Envoi du signalement en cours\u2026","report_success":"Le signalement a \xe9t\xe9 envoy\xe9 avec succ\xe8s. Il sera examin\xe9 d\xe8s que possible.","report_failure":"Une erreur est survenue lors de la cr\xe9ation du signalement : {e}. Veuillez r\xe9essayer plus tard.","indoor_switch":"Plans de b\xe2timents","indoor_selector_expand":"Cliquez pour voir tous les niveaux disponibles","indoor_selector_shrink":"Cliquez pour r\xe9duire","indoor_selector_levelup":"Aller au niveau sup\xe9rieur","indoor_selector_leveldown":"Aller au niveau inf\xe9rieur","indoor_selector_scrollup":"D\xe9rouler la liste vers le haut","indoor_selector_scrolldown":"D\xe9rouler la liste vers le bas","visibility_logged-only":"Membres","visibility_title_logged-only":"Seules les personnes avec un compte peuvent voir cette image","visibility_owner-only":"Masqu\xe9","visibility_title_owner-only":"Personne \xe0 part vous ne peut voir cette image"},"map":{"loading":"Chargement\u2026","thumbnail":"Miniature de la photo survol\xe9e","not_public":"Masqu\xe9 au public","slow_loading":"La carte est longue \xe0 charger et pourrait appara\xeetre cass\xe9e","map_data":"Carte bas\xe9e sur {m}","more_panoramax":"En savoir plus sur Panoramax"}}');
            },
            6909: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"K\xe9t ujjal navig\xe1lhat","ctrlZoom":"K\xf6zel\xedt\xe9s vagy t\xe1vol\xedt\xe1s: Ctrl + g\xf6rget\xe9s","loadError":"A panor\xe1ma nem t\xf6lthet\u0151 be"},"pnx":{"zoom":"Nagy\xedt\xe1s","zoomOut":"T\xe1vol\xedt\xe1s","zoomIn":"K\xf6zel\xedt\xe9s","moveUp":"Mozg\xe1s fel","moveDown":"Mozg\xe1s le","moveLeft":"Mozg\xe1s balra","moveRight":"Mozg\xe1s jobbra","moveMiddle":"N\xe9zet k\xf6z\xe9pre hoz\xe1sa","expand":"B\u0151v\xedt\xe9s","expand_info":"Widget megjelen\xedt\xe9se teljes oldalon","show_psv":"K\xe9pn\xe9zeget\u0151 megjelen\xedt\xe9se","show_map":"T\xe9rk\xe9p megjelen\xedt\xe9se","minimize":"Widget elrejt\xe9se; a bal als\xf3 sarokban l\xe9v\u0151 gombbal \xfajra megjelen\xedtheti","options":"Be\xe1ll\xedt\xe1sok","filters":"Sz\u0171r\u0151k","layers":"R\xe9tegek","share":"Megoszt\xe1s","search":"Keres\xe9s","search_empty":"Nincs tal\xe1lat","share_links":"Linkek","share_page":"Link erre az oldalra","share_image":"Nagy felbont\xe1s\xfa (HD) k\xe9p","share_rss":"RSS h\xedrcsatorna","share_rss_title":"A t\xe9rk\xe9p l\xe1that\xf3 ter\xfclet\xe9n l\xe9v\u0151 \xfaj sorozatok RSS-h\xedrcsatorn\xe1ja","share_embed":"Be\xe1gyaz\xe1s a weboldaladon","share_print":"Nyomtat\xe1s","copy":"M\xe1sol\xe1s","copied":"M\xe1solva","error":"Ajjaj, baj van\u2026","error_subtitle":"Pr\xf3b\xe1lja \xfajra k\xe9s\u0151bb, vagy n\xe9zze meg a b\xf6ng\xe9sz\u0151konzolt a tov\xe1bbi r\xe9szletek\xe9rt.","sequence_next":"A sorozat k\xf6vetkez\u0151 k\xe9pe","sequence_play":"Sorozat lej\xe1tsz\xe1sa","sequence_pause":"Sorozatlej\xe1tsz\xe1s sz\xfcneteltet\xe9se","sequence_prev":"A sorozat el\u0151z\u0151 k\xe9pe","sequence_more":"Tov\xe1bbi lej\xe1tsz\xe1si lehet\u0151s\xe9gek","sequence_speed":"Lej\xe1tsz\xe1s sebess\xe9ge","legend_license":"Licenc: {l}","edit_osm":"OSM szerkeszt\xe9se","id":"iD","josm":"JOSM","josm_live":"JOSM automatikus szinkroniz\xe1l\xe1s\xe1nak enged\xe9lyez\xe9se k\xe9pbet\xf6lt\xe9skor","loading_labels_serious":["\ud83d\uddfa\ufe0f T\xe9rk\xe9padatok bet\xf6lt\xe9se","\ud83d\udda5\ufe0f API lek\xe9rdez\xe9se","\ud83d\uddbc\ufe0f B\xe9lyegk\xe9pek bet\xf6lt\xe9se","\ud83d\udd0d EXIF metaadatok elemz\xe9se","\ud83c\udfd8\ufe0f 3D megjelen\xedt\xe9s","\ud83d\udcf7 360\xb0-os k\xe9pek inicializ\xe1l\xe1sa","\ud83d\udfe0 Sz\xednek kiegyenl\xedt\xe9se","\ud83d\udcaf Min\u0151s\xe9gi pontsz\xe1m kisz\xe1m\xedt\xe1sa \xa9"],"loading_labels_fun":["\ud83e\udd8c Vadvesz\xe9lyt jelz\u0151 t\xe1bla \xe9szlel\xe9se","\ud83d\ude98 Panoramax aut\xf3 \xa9 keres\xe9se","\u2615 Koffeininjekci\xf3","\ud83d\ude00 Mosolyogj, fel lett\xe9l t\xe9rk\xe9pezve!","\ud83d\udc08 Kiscic\xe1s k\xe9pek megoszt\xe1sa","\ud83d\ude34 Halogat\xe1s cs\xf6kkent\xe9se","\ud83e\uded6 Tea megf\u0151z\xe9se","\ud83d\udc27 Forr\xe1sk\xf3d felnyit\xe1sa","\ud83d\ude87 Metr\xf3\xe1llom\xe1sok indexel\xe9se","\ud83e\uddf9 Metaadatok tisztogat\xe1sa","\ud83d\ude92 T\u0171zolt\xf3s\xe1gr\xf3l sz\xf3l\xf3 fot\xf3k bek\xfcld\xe9se","\ud83d\udeb2 Z\xf6ldutak friss\xedt\xe9se","\ud83d\ude89 Peronok bej\xe1r\xe1sa","\ud83d\udef0\ufe0f M\u0171holdak keres\xe9se","\ud83d\udc65 Person\xe1k meg\xedr\xe1sa","\ud83d\udc1f S\xfcltkrumplikap\xf3k lokaliz\xe1l\xe1sa","\ud83e\uddd1\u200d\ud83d\udcbb Hibakeres\u0151 fel\xfclet","\ud83d\udcc8 Statisztika n\xf6vel\xe9se"],"error_psv":"A Photo Sphere Viewer (g\xf6mbpanor\xe1ma-n\xe9zeget\u0151) nem t\xf6lt\u0151dik be megfelel\u0151en","error_pic":"A k\xe9rt k\xe9p nem tal\xe1lhat\xf3","error_nopic":"Az adott helyen nem \xe9rhet\u0151 el k\xe9p","error_api":"A k\xe9pkiszolg\xe1l\xf3 nem \xe9rhet\u0151 el","error_webgl":"A WebGL nem t\xe1mogatott ebben a b\xf6ng\xe9sz\u0151ben","error_josm":"A JOSM nem v\xe1laszol. Val\xf3ban fut \xe9s el\xe9rhet\u0151 t\xe1volr\xf3l?","error_api_compatibility":"A k\xe9pkiszolg\xe1l\xf3 nem kompatibilis a k\xe9pn\xe9zeget\u0151 ezen verzi\xf3j\xe1val","filter_date":"D\xe1tum szerint","filter_user":"Felhaszn\xe1l\xf3 szerint","filter_picture":"K\xe9pt\xedpus szerint","picture_flat":"Klasszikus","picture_360":"360\xb0","filter_camera_model":"Kameramodell szerint","map_background":"T\xe9rk\xe9ph\xe1tt\xe9r","map_background_aerial":"L\xe9gi felv\xe9tel","map_background_streets":"k\xe9pUtca","map_theme":"T\xe9rk\xe9p t\xe9m\xe1ja","map_theme_default":"Klasszikus","map_theme_age":"K\xe9pk\xe9sz\xedt\xe9s ideje","map_theme_age_1":"> 2 \xe9ve","map_theme_age_2":"< 2 \xe9ve","map_theme_age_3":"< 1 \xe9ve","map_theme_age_4":"< 1 h\xf3napja","map_theme_type":"Kamerat\xedpus","contrast":"Nagyobb k\xe9pkontraszt enged\xe9lyez\xe9se","metadata":"K\xe9p metaadatai","metadata_general_picid":"K\xe9p azonos\xedt\xf3js","metadata_general_seqid":"Sorozat azonos\xedt\xf3ja","metadata_general_picid_link":"Ugr\xe1s a k\xe9p JSON le\xedr\xe1s\xe1hoz","metadata_general_seqid_link":"Ugr\xe1s a sorozat JSON le\xedr\xe1s\xe1hoz","metadata_general_author":"Szerz\u0151","metadata_general_license":"Licenc (enged\xe9ly)","metadata_general_license_link":"Ugr\xe1s a licenc teljes le\xedr\xe1s\xe1hoz","metadata_general_date":"K\xe9sz\xedt\xe9s d\xe1tuma","metadata_camera":"Kamera","metadata_camera_make":"Gy\xe1rt\xf3","metadata_camera_model":"Modell","metadata_camera_type":"T\xedpus","metadata_camera_focal_length":"Gy\xfajt\xf3t\xe1vols\xe1g","metadata_location":"Helysz\xedn","metadata_location_longitude":"Hossz\xfas\xe1g","metadata_location_latitude":"Sz\xe9less\xe9g","metadata_location_orientation":"Felv\xe9tel ir\xe1nya","metadata_location_precision":"Helymeghat\xe1roz\xe1s pontoss\xe1ga","metadata_exif":"EXIF / XMP","metadata_exif_name":"C\xedmke","metadata_exif_value":"\xc9rt\xe9k","report":"K\xe9p bejelent\xe9se","report_auth":"A jelent\xe9s a fi\xf3kod ({a}) felhaszn\xe1l\xe1s\xe1val lesz elk\xfcldve","report_nature":{"":"Probl\xe9ma jelleg\xe9nek kiv\xe1laszt\xe1sa\u2026","blur_missing":"A k\xe9pen l\xe1tszik egy szem\xe9ly arca vagy egy rendsz\xe1mt\xe1bla","blur_excess":"A k\xe9pen el van hom\xe1lyos\xedtva egy olyan objektum, amelynek \xe9lesnek kellene lennie","inappropriate":"A k\xe9p nem megfelel\u0151 (irrelev\xe1ns, meztelens\xe9get jelen\xedt meg stb.)","privacy":"A k\xe9pen mag\xe1n\xfat vagy mag\xe1nter\xfclet l\xe1that\xf3","picture_low_quality":"A k\xe9p nagyon rossz min\u0151s\xe9g\u0171","mislocated":"A k\xe9p rosszul van elhelyezve a t\xe9rk\xe9pen","copyright":"A k\xe9p szerz\u0151i jogot s\xe9rt","other":"B\xe1rmilyen m\xe1s jelleg\u0171 probl\xe9ma"},"report_nature_label":"Probl\xe9ma jellege","report_details":"Tov\xe1bbi r\xe9szletek","filter_zoom_in":"Nagy\xedts a sz\u0171r\u0151k l\xe1that\xf3v\xe1 t\xe9tel\xe9hez","report_email":"E-mail-c\xedm","report_email_placeholder":"Nem k\xf6telez\u0151","report_submit":"Bek\xfcld\xe9s","report_success":"A jelent\xe9s sikeresen be lett k\xfcldve; a lehet\u0151 leghamarabb megvizsg\xe1ljuk.","report_failure":"Hiba t\xf6rt\xe9nt a jelent\xe9s l\xe9trehoz\xe1sakor: {e}. K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb \xfajra.","search_user":"Felhaszn\xe1l\xf3n\xe9v keres\xe9se\u2026","search_address":"C\xedm, v\xe1ros stb. keres\xe9se\u2026","share_embed_docs":"Tov\xe1bbi inform\xe1ci\xf3 a be\xe1gyaz\xe1s konfigur\xe1l\xe1s\xe1r\xf3l","error_click":"Kattints a folytat\xe1shoz","error_retry":"K\xe9rj\xfck, pr\xf3b\xe1ld meg k\xe9s\u0151bb","legend_title":"K\xe9p adatainak megjelen\xedt\xe9se","report_whole_sequence":"A teljes sorozatra vonatkozik","report_wait":"Jelent\xe9s bek\xfcld\xe9se folyamatban\u2026","report_details_placeholder":"Megadhatsz tov\xe1bbi r\xe9szleteket a probl\xe9m\xe1r\xf3l (nem k\xf6telez\u0151)","filter_qualityscore_help":"Kattints az enged\xe9lyez\xe9shez vagy a letilt\xe1shoz","filter_qualityscore":"Min\u0151s\xe9gi pontsz\xe1m","map_theme_score":"Min\u0151s\xe9gi pontsz\xe1m","metadata_camera_resolution":"Felbont\xe1s","metadata_quality":"Min\u0151s\xe9gi pontsz\xe1m","metadata_quality_help":"Tov\xe1bbi tudnival\xf3k a min\u0151s\xe9gi pontsz\xe1mr\xf3l","metadata_quality_score":"\xd6sszes\xedtett pontsz\xe1m","metadata_quality_gps_score":"Pozicion\xe1l\xe1si pontsz\xe1m","metadata_quality_resolution_score":"Felbont\xe1si pontsz\xe1m","metadata_quality_missing":"a k\xe9pben nincs megadva \xe9rt\xe9k"},"map":{"loading":"Bet\xf6lt\xe9s\u2026","thumbnail":"A kurzor alatti k\xe9p b\xe9lyegk\xe9pe","not_public":"Nem l\xe1that\xf3 nyilv\xe1nosan","slow_loading":"A t\xe9rk\xe9p lassan t\xf6lt\u0151dik be, \xe9s lehet, hogy lerobbant"},"maplibre":{"GeolocateControl.FindMyLocation":"Tart\xf3zkod\xe1si hely megtal\xe1l\xe1sa","GeolocateControl.LocationNotAvailable":"Tart\xf3zkod\xe1si hely nem \xe9rhet\u0151 el"}}');
            },
            4895: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"expand":"Espandi","zoomOut":"Rimpicciolisci","zoomIn":"Ingrandisci","zoom":"Zoom","moveUp":"Muovi in alto","moveDown":"Muovi in basso","moveLeft":"Muovi a sinistra","moveRight":"Muovi a destra","expand_info":"Fai apparire il widget a schermo pieno","options":"Opzioni","filters":"Filtri","layers":"Livelli","search":"Cerca","search_empty":"Nessun risultato trovato","search_address":"Cerca un indirizzo, citt\xe0\u2026","search_user":"Cerca un nome utente\u2026","share":"Condividi","share_links":"Collegamenti","share_page":"Collegamento a questa immagine","share_image":"Immagine HD","share_embed":"Incorpora nel tuo sito web","share_embed_docs":"Scopri di pi\xf9 sulla configurazione della incorporazione","share_print":"Stampa","copy":"Copia","copied":"Copiato","error":"Abbiamo un problema\u2026","error_click":"Continuare","error_retry":"Riprovare pi\xf9 tardi","sequence_play":"Riproduci questa sequenza","sequence_pause":"Pausa la sequenza","sequence_speed":"Velocit\xe0 di riproduzione","legend_license":"Licenza: {l}","legend_title":"Mostra dettagli della foto","edit_osm":"Modifica OSM","loading_labels_serious":["\ud83d\uddfa\ufe0f Caricamento dei dati della mappa","\ud83d\udda5\ufe0f Interrogazione delle API","\ud83d\uddbc\ufe0f Caricamento delle miniature","\ud83d\udd0d Analisi dei metadata EXIF","\ud83c\udfd8\ufe0f Creazione del rendering 3D","\ud83d\udcf7 Inizializzazione delle foto a 360\xb0","\ud83d\udfe0 Bilanciamento del colore","\ud83d\udcaf Calcolo del punteggio della qualit\xe0 \xa9","\ud83d\udce1 Scaricamento degli aggiornamenti","\ud83c\udf0d Recupero dei tasselli della mappa","\ud83d\udcf8 Elaborazione delle ombre"],"loading_labels_fun":["\ud83e\udd8c Rilevazione dei cartelli di attraversamento dei cervi","\ud83d\ude98 Ricerca dell\u2019auto Panoramax \xa9","\u2615 Iniezione di caffeina","\ud83d\ude00 Sorridete, siete stati mappati!","\ud83d\udc08 Condivisione delle foto di gatti","\ud83d\ude34 Riduzione della procrastinazione","\ud83e\uded6 Preparazione del t\xe8","\ud83d\udc27 Apertura del codice sorgente","\ud83d\ude87 Indicizzazione delle stazioni della metro","\ud83e\uddf9 Pulizia dei metadata","\ud83d\ude92 Invio delle foto delle stazioni dei pompieri","\ud83d\udeb2 Aggiornamento delle strade verdi","\ud83d\ude89 Passeggiata sulle banchine della stazione","\ud83d\udef0\ufe0f Ricerca dei satelliti","\ud83d\udc65 Scrittura delle persone","\ud83d\udc1f Ricerca dei negozi di patatine fritte","\ud83e\uddd1\u200d\ud83d\udcbb Debug dell\u2019interfaccia","\ud83d\udcc8 Incremento delle statistiche","\ud83e\udd16 Apprendimento della semantica","\ud83c\udfa8 Riprogettazione dell\u2019interfaccia","\ud83d\udcc5 Pianificazione di eventi di photo-mapping","\ud83e\uddc0 Affinamento dei formaggi","\ud83c\udf04 Calcolo della nebbia in Valpadana","\ud83c\udf0a Misurazione delle grandi maree"],"error_psv":"Il visualizzatore delle foto sferiche non si sta caricando correttamente","error_pic":"La foto richiesta non \xe8 stata trovata","error_nopic":"Nessuna foto disponibile alla posizione richiesta","error_api":"Il server delle foto non \xe8 disponibile","error_webgl":"Il tuo browser non supporta WebGL","error_josm":"JOSM non risponde, \xe8 in esecuzione con il controllo remoto abilitato?","error_api_compatibility":"Il server delle foto non \xe8 compatibile con questa versione del visualizzatore","filter_date":"Data","filter_date_1month":"1 mese","filter_date_1year":"1 anno","filter_user_mypics":"Le mie foto","filter_picture":"Tipo di foto","filter_zoom_in":"Ingrandisci la mappa per vedere questo filtro","picture_flat":"Classica","picture_360":"360\xb0","filter_qualityscore_help":"Clicca per abilitare o disabilitare","map_background":"Sfondo della mappa","map_background_aerial":"Satellite","map_background_streets":"Strade","map_theme":"Tema della mappa","map_theme_default":"Classica","map_theme_age":"Data di acquisizione","map_theme_age_2":"< 2 anni","map_theme_age_3":"< 1 anno","map_theme_age_4":"< 1 mese","map_theme_score":"Punteggio della qualit\xe0","contrast":"Abilita un maggiore contrasto della foto","metadata":"Metadata della foto","metadata_general_picid":"Foto","metadata_general_picid_link":"Vai alla descrizione JSON della foto","metadata_general_seqid_link":"Vai alla descrizione JSON della sequenza","metadata_general_author":"Autore","metadata_general_license":"Licenza","metadata_general_date":"Data di acquisizione","metadata_camera":"Fotocamera","metadata_camera_make":"Costruttore","metadata_camera_model":"Modello","metadata_camera_type":"Tipo","metadata_camera_resolution":"Risoluzione","metadata_location":"Posizione","metadata_location_longitude":"Longitudine","metadata_location_latitude":"Latitudine","metadata_location_precision":"Precisione della posizione","metadata_quality":"Qualit\xe0","metadata_quality_score":"Punteggio globale","metadata_quality_gps_score":"Punteggio della posizione","metadata_quality_resolution_score":"Punteggio della risoluzione","metadata_exif":"EXIF","metadata_exif_name":"Attributo","report_auth":"Questa segnalazione verr\xe0 inviata usando la tua utenza \u201c{a}\u201d","report_nature_label":"Causa del problema","report_nature":{"blur_excess":"\xc8 stata applicata ad un oggetto una sfocatura non necessaria","inappropriate":"La foto \xe8 inappropriata (non pertinente, nudo, \u2026)","mislocated":"La posizione della foto sulla mappa \xe8 sbagliata","copyright":"La foto viola il diritto d\u2019autore","other":"Qualsiasi altro tipo di problema","picture_low_quality":"La foto \xe8 di bassa qualit\xe0","":"Selezione la natura del problema\u2026","blur_missing":"Sono visibili la faccia di una persona o la targa di un\u2019auto","privacy":"Sono visibili un sentiero o una propriet\xe0 privati"},"report_whole_sequence":"Riguarda l\u2019intera sequenza","report_details":"Ulteriori dettagli","report_email":"La tua e-mail","report_email_placeholder":"Facoltativo","report_submit":"Invia","report_wait":"Invio della segnalazione\u2026","report_failure":"\xc8 avvenuto un errore durante la creazione della segnalazione: {e}. Riprovare pi\xf9 tardi.","moveMiddle":"Centra la visuale","show_map":"Mostra la mappa","sequence_next":"Prossima foto nella sequenza","map_theme_age_1":"> 2 anni","map_theme_type":"Tipo di fotocamera","minimize":"Nascondi il widget, puoi mostrarlo di nuovo usando il pulsante nell\u2019angolo in basso a sinistra","metadata_general_license_link":"Vedi la descrizione completa della licenza","share_rss":"Feed RSS","show_psv":"Mostra il visualizzatore delle foto","share_rss_title":"Feed RSS delle nuove sequenze nell\u2019attuale area visibile della mappa","sequence_prev":"Foto precedente della sequenza","sequence_more":"Altre opzioni di riproduzione","josm_live":"Abilita la sincronizzazione automatica di JOSM al caricamento delle foto","metadata_general_seqid":"Sequenza","metadata_camera_focal_length":"Lunghezza focale","filter_user":"Utente","metadata_location_orientation":"Direzione","filter_qualityscore":"Punteggio della qualit\xe0","metadata_quality_help":"Per saperne di pi\xf9 sul punteggio della qualit\xe0","metadata_quality_missing":"Nessun valore impostato nella foto","metadata_exif_value":"Valore","report":"Segnala","report_details_placeholder":"Facoltativo, puoi aggiungere dei dettagli sul problema","report_success":"La segnalazione \xe8 stata inviata correttamente. Non appena possibile verr\xe0 esaminata.","minimize_short":"Nascondi","qualityscore_title":"Informazioni sul punteggio della qualit\xe0","qualityscore_doc_1":"Un punteggio sulla qualit\xe0 viene calcolato per ogni foto.","qualityscore_doc_2":"Il voto viene mostrato con una lettera:","qualityscore_doc_link":"Nella nostra documentazione sono presenti maggiori dettagli sul calcolo del Punteggio della qualit\xe0","qualityscore_doc_3":"\u201cA\u201d \xe8 il punteggio pi\xf9 alto, \u201cE\u201d quello pi\xf9 basso.","metadata_general_instance":"Istanza di origine","josm":"JOSM","picture_flat_long":"Foto classica","picture_360_long":"Foto panoramica","metadata_summary":"Sintesi","metadata_general_copy_id":"Copia l\u2019ID","metadata_general_copy_picid":"Copia l\u2019ID della foto","id":"iD","contribute_id":"Contribuisci a OpenStreetMap con l\u2019editor iD","geo_uri":"App esterna","filter_date_6months":"6 mesi","picture_all":"Tutte","metadata_exif_doc":"Doc per gli attributi EXIF","metadata_exif_doc_title":"Vai alla documentazione di Exiv2 per i dettagli completi sulle definizioni degli attributi EXIF e XMP","semantics_value":"Valore","semantics_key_doc":"Per saperne di pi\xf9 su questa chiave","semantics_title":"Etichette","semantics_features":"Oggetti nella foto","semantics_features_none":"Non \xe8 ancora stato rilevato alcun oggetto in questa foto.","semantics_features_default_title":"Etichetta {nb}","semantics_features_subtitle":"{nb} propriet\xe0 associate","semantics_tags":"{nb} attributi","semantics_show_all_tags":"Mostra tutti gli attributi","semantics_hide_all_tags":"Nascondi tutti gli attributi","semantics_key":"Chiave","semantics_value_doc":"Per saperne di pi\xf9 su questa etichetta","semantics_wikidata_properties":{"P361":"parte di","P31":"instanza di","P279":"sottoclasse di"},"semantics_hide_annotations":"Nascondi gli oggetti nella foto","semantics_tags_picture":"Etichette della foto","semantics_show_annotations":"Mostra gli oggetti nella foto","semantics_annotation_tooltip":"Clicca per vedere i dettagli","semantics_tags_picture_none":"Non \xe8 stata ancora aggiunta alcuna etichetta su questa foto.","semantics_qualifiers":"Qualificatori","metadata_location_coordinates":"Coordinate (longitudine, latitudine)","metadata_location_copy":"Copia {v}","metadata_location_copy_more":"Ulteriori opzioni per la copia delle coordinate","whats_panoramax":"Panoramax \xe8 la geo-commons per le foto dei territori.","panoramax":"Panoramax","semantics_zero_annotations":"Nessuna annotazione impostata per questa immagine","semantics_hashtags":"Hashtag dell\u2019immagine","semantics_editor_error":"La sintassi non \xe8 valida. Le tue etichette devono avere la seguente forma:\\nchiave=valore\\nprefisso|chiave=valore\\nprefisso|chiave[qualif_chiave=qualif_valore]=valore\\n\\nLa lunghezza massima di una chiave \xe8 di 256 caratteri, quella di un valore \xe8 di 2048 caratteri.","semantics_editor_example":"chiave=valore\\nprefisso|chiave=valore","semantics_edit":"Modifica gli attributi","semantics_save":"Salva le tue modifiche","semantics_undo":"Annulla le tue modifiche","semantics_send_fail":"Non \xe8 stato possibile salvare le tue modifiche, riprova pi\xf9 tardi","semantics_cantsave_invalid":"Impossibile salvare le modifiche, input non valido","semantics_send_ok":"Le tue modifiche sono state inviate con successo","semantics_add_annotation":"Aggiungi una nuova etichetta","semantics_draw_annotation":"Per prima cosa fai clic su un angolo dell\u2019elemento che vorresti rappresentare. Poi fai clic sull\u2019angolo opposto. Per spostarle un angolo fai clic di nuovo su di esso.","semantics_save_drawn_annotation":"Salva posizione","semantics_undo_drawn_annotation":"Annulla","semantics_save_drawn_annotation_incomplete":"Devi disegnare un rettangolo all\u2019interno dell\u2019immagine prima di validarlo","semantics_delete_annotation":"Elimina questo oggetto","semantics_delete_annotation_confirm":"Vuoi veramente eliminare questa etichetta?","filter_gps_precision":"Precisione della posizione","filter_gps_precision_lessthan":"Meno di {n} metri","filter_gps_precision_between":"Tra {n1} e {n2} metri","filter_gps_precision_morethan":"Pi\xf9 di {n} metri","filter_gps_precision_help":"Per saperne di pi\xf9 sulla precisione della posizione","qualityscore_doc_4":"Il punteggio \xe8 calcolato basandosi su:","qualityscore_doc_41":"la precisione GPS","qualityscore_doc_42":"la risoluzione della foto","qualityscore_doc_5":"Un dispositivo professionale otterr\xe0 una A, un\u2019action camera a 360\xb0 una B mentre una smartphone si attester\xe0 tra una C e una E.","semantics_copy":"Copia gli attributi","map_theme_gps":"Precisione della posizione","semantics_doc_info1":"Specifica il contesto di una foto utilizzando un\u2019etichetta.","semantics_overlays":{"features":"Tutti gli oggetti","tfsigns":"Segnali stradali"},"semantics_doc_info1u1":"Puoi etichettarla come scattata dall\u2019auto con l\u2019etichetta transport=car.","semantics_zoom_in":"Ingrandisci la mappa per vedere le etichette","semantics_download":"Scarica","semantics_download_title":"Scarica le etichette","semantics_download_cta":"Scarica i dati aperti","semantics_value_show_osm":"Vedi su OpenStreetMap","filter_gps_precision_help_2":"La precisione viene espressa con delle stelle:","filter_gps_precision_help_3":"\u201c5\u2b50\u201d \xe8 molto preciso (<={p5}m), \u201c1\u2b50\u201d molto impreciso (> {p1}m) o sconosciuto.","filter_gps_precision_help_4":"Un GPS RTK otterr\xe0 il voto \u201c5\u2b50\u201d, un\u2019action camera come la GoPro Max il voto \u201c3\u2b50\u201d, il GPS di uno smartphone in un garage sotterraneo un voto \u201c1\u2b50\u201d.","semantics_doc":"Assistenza","semantics_picture_tags":"Etichetta della foto","semantics_annotation_tags":"Etichetta dell\u2019oggetto","semantics_doc_link":"Per saperne di pi\xf9 sulle etichette","semantics_doc_info3":"Alcuni oggetti vengono automaticamente rilevati con la IA: la qualit\xe0 non \xe8 garantita.","semantics_sequence_tags":"Etichetta della sequenza"},"psv":{"loadError":"Impossibile caricare l\u2019immagine panoramica","ctrlZoom":"Utilizza Ctrl + rotellina del mouse per ingrandire l\u2019immagine","twoFingers":"Usa due dita per spostarti"},"maplibre":{"GeolocateControl.FindMyLocation":"Trova la mia posizione","GeolocateControl.LocationNotAvailable":"Posizione non disponibile"},"map":{"loading":"Caricamento\u2026","thumbnail":"Miniatura della foto passata con il mouse","not_public":"Non pubblicamente visibile","slow_loading":"La mappa impiega troppo tempo a caricarsi e potrebbe apparire a pezzi","map_data":"Dati cartografici: {m}","more_panoramax":"Per saperne di pi\xf9 su Panoramax"}}');
            },
            3979: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"metadata_general_picid":"\u753b\u50cf\u8b58\u5225\u5b50","loading_labels_fun":["\ud83e\udd8c \u9e7f\u306e\u6a2a\u65ad\u6a19\u8b58\u306e\u691c\u51fa","\ud83d\ude98 Panoramax Car \xa9\u3092\u691c\u7d22","\u2615 \u30ab\u30d5\u30a7\u30a4\u30f3\u306e\u6ce8\u5165","\ud83d\ude00 \u7b11\u3063\u3066\u304f\u3060\u3055\u3044\u3001\u3042\u306a\u305f\u306f\u5730\u56f3\u306b\u8f09\u3063\u3066\u3044\u307e\u3059\uff01","\ud83d\udc08 \u732b\u306e\u5199\u771f\u3092\u5171\u6709\u3059\u308b","\ud83d\ude34 \u5148\u5ef6\u3070\u3057\u3092\u6e1b\u3089\u3059","\ud83e\uded6 \u304a\u8336\u3092\u6df9\u308c\u308b","\ud83d\udc27 \u30bd\u30fc\u30b9\u30b3\u30fc\u30c9\u3092\u516c\u958b","\ud83d\ude87 \u5730\u4e0b\u9244\u99c5\u306e\u7d22\u5f15","\ud83e\uddf9 \u30e1\u30bf\u30c7\u30fc\u30bf\u306e\u30af\u30ea\u30fc\u30f3\u30a2\u30c3\u30d7","\ud83d\ude92 \u6d88\u9632\u7f72\u306e\u5199\u771f\u3092\u9001\u4fe1","\ud83d\udeb2 \u30b0\u30ea\u30fc\u30f3\u30a6\u30a7\u30a4\u30ba\u306e\u66f4\u65b0","\ud83d\ude89 \u99c5\u306e\u30db\u30fc\u30e0\u306e\u30a6\u30a9\u30fc\u30af\u30b9\u30eb\u30fc","\ud83d\udef0\ufe0f \u885b\u661f\u306e\u63a2\u7d22","\ud83d\udc65 \u30da\u30eb\u30bd\u30ca\u3092\u66f8\u304f","\ud83d\udc1f \u30c1\u30c3\u30d7\u30b7\u30e7\u30c3\u30d7\u306e\u5834\u6240","\ud83e\uddd1\u200d\ud83d\udcbb \u30c7\u30d0\u30c3\u30b0\u30a4\u30f3\u30bf\u30fc\u30d5\u30a7\u30fc\u30b9","\ud83d\udcc8 \u7d71\u8a08\u306e\u5897\u52a0"],"share_embed_docs":"\u57cb\u3081\u8fbc\u307f\u8a2d\u5b9a\u306e\u8a73\u7d30\u3092\u8aad\u3080","filter_zoom_in":"\u3053\u306e\u30d5\u30a3\u30eb\u30bf\u30fc\u3092\u8868\u793a\u3059\u308b\u306b\u306f\u62e1\u5927\u3057\u3066\u304f\u3060\u3055\u3044","metadata_camera_type":"\u30bf\u30a4\u30d7","minimize":"\u3053\u306e\u30a6\u30a3\u30b8\u30a7\u30c3\u30c8\u3092\u975e\u8868\u793a\u306b\u3059\u308b\u306b\u306f\u3001\u5de6\u4e0b\u306e\u30dc\u30bf\u30f3\u3092\u4f7f\u7528\u3057\u3066\u518d\u5ea6\u8868\u793a\u3057\u307e\u3059","error_psv":"Photo Sphere Viewer \u304c\u6b63\u3057\u304f\u8aad\u307f\u8fbc\u307e\u308c\u307e\u305b\u3093\u3067\u3057\u305f","error_josm":"JOSM \u304c\u5fdc\u7b54\u3057\u307e\u305b\u3093\u3002\u5b9f\u884c\u3055\u308c\u3066\u3044\u3066\u3001\u30ea\u30e2\u30fc\u30c8\u304c\u6709\u52b9\u306b\u306a\u3063\u3066\u3044\u307e\u3059\u304b?","filter_user":"\u30e6\u30fc\u30b6\u30fc","qualityscore_doc_3":"\u3053\u308c\u306f GPS \u306e\u7cbe\u5ea6\u3068\u753b\u50cf\u306e\u89e3\u50cf\u5ea6\u306b\u57fa\u3065\u3044\u3066\u8a08\u7b97\u3055\u308c\u307e\u3059\u3002\u30d7\u30ed\u4ed5\u69d8\u306e\u30b7\u30b9\u30c6\u30e0\u306f A \u8a55\u4fa1\u3001360\xb0 \u30a2\u30af\u30b7\u30e7\u30f3 \u30ab\u30e1\u30e9\u306f B \u8a55\u4fa1\u3001\u30b9\u30de\u30fc\u30c8\u30d5\u30a9\u30f3\u306f C/D/E \u8a55\u4fa1\u306b\u306a\u308a\u307e\u3059\u3002","report_nature":{"inappropriate":"\u5199\u771f\u304c\u4e0d\u9069\u5207\u3067\u3059\uff08\u7121\u95a2\u4fc2\u3001\u30cc\u30fc\u30c9\u306a\u3069\uff09","":"\u554f\u984c\u306e\u6027\u8cea\u3092\u9078\u629e\u3057\u3066\u304f\u3060\u3055\u3044\u2026","blur_missing":"\u4eba\u306e\u9854\u3084\u8eca\u306e\u30ca\u30f3\u30d0\u30fc\u30d7\u30ec\u30fc\u30c8\u304c\u898b\u3048\u308b","blur_excess":"\u307c\u304b\u3059\u5fc5\u8981\u306e\u306a\u3044\u30aa\u30d6\u30b8\u30a7\u30af\u30c8\u304c\u307c\u3084\u3051\u3066\u3044\u308b","privacy":"\u30d7\u30e9\u30a4\u30d9\u30fc\u30c8\u30d1\u30b9\u307e\u305f\u306f\u30d7\u30ed\u30d1\u30c6\u30a3\u304c\u8868\u793a\u3055\u308c\u307e\u3059","picture_low_quality":"\u753b\u50cf\u306e\u54c1\u8cea\u304c\u60aa\u3044","mislocated":"\u5730\u56f3\u4e0a\u306e\u5199\u771f\u306e\u4f4d\u7f6e\u304c\u9069\u5207\u3067\u306f\u3042\u308a\u307e\u305b\u3093","copyright":"\u753b\u50cf\u306f\u8457\u4f5c\u6a29\u3092\u4fb5\u5bb3\u3057\u3066\u3044\u307e\u3059","other":"\u305d\u306e\u4ed6\u306e\u554f\u984c"},"sequence_next":"\u6b21\u306e\u753b\u50cf","sequence_play":"\u3053\u306e\u30b7\u30fc\u30b1\u30f3\u30b9\u306b\u6cbf\u3063\u3066\u30d7\u30ec\u30a4\u3057\u3066\u304f\u3060\u3055\u3044","sequence_pause":"\u4e00\u6642\u505c\u6b62\u30b7\u30fc\u30b1\u30f3\u30b9","sequence_prev":"\u524d\u306e\u753b\u50cf","sequence_more":"\u3088\u308a\u591a\u304f\u306e\u30d7\u30ec\u30a4\u30aa\u30d7\u30b7\u30e7\u30f3","sequence_speed":"\u30d7\u30ec\u30a4\u30e4\u30fc\u306e\u30b9\u30d4\u30fc\u30c9","legend_license":"\u30e9\u30a4\u30bb\u30f3\u30b9: {l}","legend_title":"\u5199\u771f\u306e\u8a73\u7d30\u3092\u8868\u793a","edit_osm":"OSM\u306b\u8ca2\u732e\u3059\u308b","josm_live":"\u753b\u50cf\u8aad\u307f\u8fbc\u307f\u6642\u306bJOSM\u81ea\u52d5\u540c\u671f\u3092\u6709\u52b9\u306b\u3059\u308b","loading_labels_serious":["\ud83d\uddfa\ufe0f \u30de\u30c3\u30d7\u30c7\u30fc\u30bf\u306e\u8aad\u307f\u8fbc\u307f","\ud83d\udda5\ufe0f \u30af\u30a8\u30eaAPI","\ud83d\uddbc\ufe0f \u30b5\u30e0\u30cd\u30a4\u30eb\u3092\u8aad\u307f\u8fbc\u3093\u3067\u3044\u307e\u3059","\ud83d\udd0d EXIF\u30e1\u30bf\u30c7\u30fc\u30bf\u306e\u5206\u6790","\ud83c\udfd8\ufe0f 3D\u30ec\u30f3\u30c0\u30ea\u30f3\u30b0","\ud83d\udcf7 360\xb0\u5199\u771f\u3092\u521d\u671f\u5316\u3057\u3066\u3044\u307e\u3059","\ud83d\udfe0 \u8272\u306e\u30d0\u30e9\u30f3\u30b9","\ud83d\udcaf \u30b3\u30f3\u30d4\u30e5\u30fc\u30c6\u30a3\u30f3\u30b0\u54c1\u8cea\u30b9\u30b3\u30a2 \xa9"],"error_pic":"\u8981\u6c42\u3055\u308c\u305f\u5199\u771f\u304c\u898b\u3064\u304b\u308a\u307e\u305b\u3093\u3067\u3057\u305f","error_nopic":"\u6307\u5b9a\u3055\u308c\u305f\u4f4d\u7f6e\u306b\u306f\u753b\u50cf\u304c\u3042\u308a\u307e\u305b\u3093","error_api":"\u5199\u771f\u30b5\u30fc\u30d0\u30fc\u304c\u5229\u7528\u3067\u304d\u307e\u305b\u3093","error_webgl":"WebGL\u306f\u30d6\u30e9\u30a6\u30b6\u3067\u30b5\u30dd\u30fc\u30c8\u3055\u308c\u3066\u3044\u307e\u305b\u3093","error_api_compatibility":"\u753b\u50cf\u30b5\u30fc\u30d0\u30fc\u306f\u3053\u306e\u30d3\u30e5\u30fc\u30a2\u306e\u30d0\u30fc\u30b8\u30e7\u30f3\u3068\u4e92\u63db\u6027\u304c\u3042\u308a\u307e\u305b\u3093","filter_date":"\u65e5\u4ed8","filter_date_1month":"1\u30f6\u6708","filter_date_1year":"1\u5e74","filter_user_mypics":"\u79c1\u306e\u5199\u771f","filter_picture":"\u753b\u50cf\u30bf\u30a4\u30d7","picture_flat":"\u30af\u30e9\u30b7\u30c3\u30af","picture_360":"360\xb0","filter_qualityscore":"\u54c1\u8cea\u30b9\u30b3\u30a2","filter_qualityscore_help":"\u30af\u30ea\u30c3\u30af\u3057\u3066\u6709\u52b9\u307e\u305f\u306f\u7121\u52b9\u306b\u3057\u307e\u3059","qualityscore_title":"\u54c1\u8cea\u30b9\u30b3\u30a2\u306b\u3064\u3044\u3066","qualityscore_doc_1":"Panoramax \u306f\u3001\u5404\u5199\u771f\u306b\u54c1\u8cea\u30b9\u30b3\u30a2\u3092\u63d0\u4f9b\u3057\u307e\u3059\u3002\u3053\u308c\u306b\u3088\u308a\u3001\u5730\u56f3\u30d5\u30a3\u30eb\u30bf\u30ea\u30f3\u30b0\u304c\u7c21\u5358\u306b\u306a\u308a\u3001\u9ad8\u54c1\u8cea\u306e\u5199\u771f\u306e\u53ef\u7528\u6027\u3092\u5305\u62ec\u7684\u306b\u8868\u793a\u3067\u304d\u307e\u3059\u3002","qualityscore_doc_2":"\u8a55\u4fa1\u306f A/B/C/D/E \u30b9\u30b3\u30a2 (A \u304c\u6700\u9ad8\u3001E \u304c\u6700\u4f4e) \u3068\u3057\u3066\u30e6\u30fc\u30b6\u30fc\u306b\u8868\u793a\u3055\u308c\u3001\u6b21\u306e\u30b9\u30b1\u30fc\u30eb\u3067\u30b0\u30e9\u30d5\u8868\u793a\u3055\u308c\u307e\u3059\u3002","qualityscore_doc_link":"\u54c1\u8cea\u30b9\u30b3\u30a2\u306e\u8a08\u7b97\u306e\u8a73\u7d30\u306b\u3064\u3044\u3066\u306f\u3001\u30c9\u30ad\u30e5\u30e1\u30f3\u30c8\u3092\u3054\u89a7\u304f\u3060\u3055\u3044\u3002","map_background":"\u5730\u56f3\u306e\u80cc\u666f","map_background_aerial":"\u822a\u7a7a\u5199\u771f","map_background_streets":"\u901a\u308a","map_theme":"\u30de\u30c3\u30d7\u30c6\u30fc\u30de","map_theme_default":"\u30af\u30e9\u30b7\u30c3\u30af","map_theme_age":"\u64ae\u5f71\u65e5","map_theme_age_1":"2\u6b73\u4ee5\u4e0a","map_theme_age_2":"2\u6b73\u672a\u6e80","map_theme_age_3":"1\u6b73\u672a\u6e80","map_theme_age_4":"1\u304b\u6708\u672a\u6e80","map_theme_type":"\u30ab\u30e1\u30e9\u30bf\u30a4\u30d7","map_theme_score":"\u54c1\u8cea\u30b9\u30b3\u30a2","contrast":"\u3088\u308a\u9ad8\u3044\u753b\u50cf\u30b3\u30f3\u30c8\u30e9\u30b9\u30c8\u3092\u6709\u52b9\u306b\u3059\u308b","metadata":"\u753b\u50cf\u30e1\u30bf\u30c7\u30fc\u30bf","metadata_general_seqid":"\u30b7\u30fc\u30b1\u30f3\u30b9\u8b58\u5225\u5b50","metadata_general_picid_link":"\u753b\u50cf\u306eJSON\u8aac\u660e\u3078\u79fb\u52d5","metadata_general_seqid_link":"\u30b7\u30fc\u30b1\u30f3\u30b9\u306eJSON\u8a18\u8ff0\u3078\u79fb\u52d5","metadata_general_author":"\u8457\u8005","metadata_general_license":"\u30e9\u30a4\u30bb\u30f3\u30b9","metadata_general_license_link":"\u30e9\u30a4\u30bb\u30f3\u30b9\u306e\u5b8c\u5168\u306a\u8aac\u660e\u3092\u898b\u308b","metadata_general_date":"\u64ae\u5f71\u65e5","metadata_camera":"\u30ab\u30e1\u30e9","metadata_camera_make":"\u30e1\u30fc\u30ab\u30fc","metadata_camera_model":"\u30e2\u30c7\u30eb","metadata_camera_resolution":"\u89e3\u50cf\u5ea6","metadata_camera_focal_length":"\u7126\u70b9\u8ddd\u96e2","metadata_location":"\u4f4d\u7f6e","metadata_location_longitude":"\u7d4c\u5ea6","metadata_location_latitude":"\u7def\u5ea6","metadata_location_orientation":"\u64ae\u5f71\u65b9\u5411","metadata_location_precision":"\u4f4d\u7f6e\u6c7a\u3081\u7cbe\u5ea6","metadata_quality":"\u54c1\u8cea\u30b9\u30b3\u30a2","metadata_quality_help":"\u54c1\u8cea\u30b9\u30b3\u30a2\u306b\u3064\u3044\u3066\u8a73\u3057\u304f\u77e5\u308b","metadata_quality_score":"\u30b0\u30ed\u30fc\u30d0\u30eb\u30b9\u30b3\u30a2","metadata_quality_gps_score":"\u30dd\u30b8\u30b7\u30e7\u30cb\u30f3\u30b0\u30b9\u30b3\u30a2","metadata_quality_resolution_score":"\u89e3\u6c7a\u30b9\u30b3\u30a2","metadata_quality_missing":"\u753b\u50cf\u306b\u5024\u304c\u8a2d\u5b9a\u3055\u308c\u3066\u3044\u307e\u305b\u3093","metadata_exif":"EXIF / XMP","metadata_exif_name":"\u30bf\u30b0","metadata_exif_value":"\u4fa1\u5024","report":"\u5199\u771f\u3092\u5831\u544a\u3059\u308b","report_auth":"\u3053\u306e\u30ec\u30dd\u30fc\u30c8\u306f\u3042\u306a\u305f\u306e\u30a2\u30ab\u30a6\u30f3\u30c8\u300c{a}\u300d\u3092\u4f7f\u7528\u3057\u3066\u9001\u4fe1\u3055\u308c\u307e\u3059","report_nature_label":"\u554f\u984c\u306e\u6027\u8cea","report_whole_sequence":"\u3053\u308c\u306f\u30b7\u30fc\u30b1\u30f3\u30b9\u5168\u4f53\u306b\u95a2\u4fc2\u3059\u308b","report_details":"\u8ffd\u52a0\u306e\u8a73\u7d30","report_details_placeholder":"\u30aa\u30d7\u30b7\u30e7\u30f3\u3068\u3057\u3066\u3001\u554f\u984c\u306e\u8a73\u7d30\u3068\u305d\u308c\u304c\u3069\u306e\u3088\u3046\u306b\u95a2\u4fc2\u3057\u3066\u3044\u308b\u304b\u3092\u8ffd\u52a0\u3067\u304d\u307e\u3059","report_email":"\u3042\u306a\u305f\u306e\u30e1\u30fc\u30eb","report_email_placeholder":"\u30aa\u30d7\u30b7\u30e7\u30f3","report_submit":"\u9001\u4fe1","report_wait":"\u30ec\u30dd\u30fc\u30c8\u3092\u9001\u4fe1\u3057\u3066\u3044\u307e\u3059\u2026","report_success":"\u30ec\u30dd\u30fc\u30c8\u306f\u6b63\u5e38\u306b\u9001\u4fe1\u3055\u308c\u307e\u3057\u305f\u3002\u3067\u304d\u308b\u3060\u3051\u65e9\u304f\u78ba\u8a8d\u3055\u308c\u307e\u3059\u3002","report_failure":"\u30ec\u30dd\u30fc\u30c8\u306e\u4f5c\u6210\u4e2d\u306b\u30a8\u30e9\u30fc\u304c\u767a\u751f\u3057\u307e\u3057\u305f: {e}\u3002\u3057\u3070\u3089\u304f\u3057\u3066\u304b\u3089\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044\u3002","zoom":"\u30ba\u30fc\u30e0","zoomOut":"\u30ba\u30fc\u30e0\u30a2\u30a6\u30c8","zoomIn":"\u30ba\u30fc\u30e0\u30a4\u30f3","moveUp":"\u4e0a\u306b\u79fb\u52d5","moveDown":"\u4e0b\u306b\u79fb\u52d5","moveLeft":"\u5de6\u306b\u79fb\u52d5","moveRight":"\u53f3\u306b\u79fb\u52d5","moveMiddle":"\u30d3\u30e5\u30fc\u3092\u4e2d\u592e\u306b\u914d\u7f6e\u3059\u308b","expand":"\u62e1\u5927\u3059\u308b","expand_info":"\u30a6\u30a3\u30b8\u30a7\u30c3\u30c8\u3092\u5168\u30da\u30fc\u30b8\u306b\u8868\u793a\u3059\u308b","show_psv":"\u753b\u50cf\u30d3\u30e5\u30fc\u30a2\u3092\u8868\u793a\u3059\u308b","show_map":"\u5730\u56f3\u3092\u8868\u793a","minimize_short":"\u96a0\u308c\u308b","options":"\u30aa\u30d7\u30b7\u30e7\u30f3","filters":"\u30d5\u30a3\u30eb\u30bf\u30fc","layers":"\u30ec\u30a4\u30e4\u30fc","search":"\u691c\u7d22","search_empty":"\u7d50\u679c\u306a\u3057","search_address":"\u4f4f\u6240\u3001\u5e02\u533a\u753a\u6751\u306a\u3069\u3092\u691c\u7d22","search_user":"\u30e6\u30fc\u30b6\u30fc\u540d\u3092\u691c\u7d22\u2026","share":"\u5171\u6709","share_links":"\u30ea\u30f3\u30af","share_page":"\u3053\u306e\u30da\u30fc\u30b8\u3078\u306e\u30ea\u30f3\u30af","share_image":"HD\u753b\u50cf","share_rss":"RSS\u30d5\u30a3\u30fc\u30c9","share_rss_title":"\u73fe\u5728\u8868\u793a\u3055\u308c\u3066\u3044\u308b\u30de\u30c3\u30d7\u30a8\u30ea\u30a2\u5185\u306e\u65b0\u3057\u3044\u30b7\u30fc\u30b1\u30f3\u30b9\u306e RSS \u30d5\u30a3\u30fc\u30c9","share_embed":"\u30a6\u30a7\u30d6\u30b5\u30a4\u30c8\u306b\u57cb\u3081\u8fbc\u3080","share_print":"\u5370\u5237","copy":"\u30b3\u30d4\u30fc","copied":"\u30b3\u30d4\u30fc\u3057\u307e\u3057\u305f","error":"\u554f\u984c\u304c\u767a\u751f\u3057\u307e\u3057\u305f\u2026","error_click":"\u7d9a\u304f","error_retry":"\u5f8c\u3067\u3082\u3046\u4e00\u5ea6\u304a\u8a66\u3057\u304f\u3060\u3055\u3044"},"map":{"loading":"\u8aad\u307f\u8fbc\u307f\u4e2d\u2026","thumbnail":"\u30db\u30d0\u30fc\u3057\u305f\u753b\u50cf\u306e\u30b5\u30e0\u30cd\u30a4\u30eb","not_public":"\u516c\u958b\u3055\u308c\u306a\u3044","slow_loading":"\u30de\u30c3\u30d7\u306e\u8aad\u307f\u8fbc\u307f\u304c\u9045\u304f\u3001\u58ca\u308c\u3066\u3044\u308b\u3088\u3046\u306b\u898b\u3048\u308b\u5834\u5408\u304c\u3042\u308a\u307e\u3059"},"psv":{"twoFingers":"2\u672c\u306e\u6307\u3067\u79fb\u52d5\u3057\u307e\u3059","ctrlZoom":"Ctrl + \u30b9\u30af\u30ed\u30fc\u30eb\u3067\u753b\u50cf\u3092\u62e1\u5927\u3057\u307e\u3059","loadError":"\u753b\u50cf\u3092\u8aad\u307f\u8fbc\u3081\u307e\u305b\u3093"},"maplibre":{"GeolocateControl.FindMyLocation":"\u81ea\u5206\u306e\u4f4d\u7f6e\u3092\u8868\u793a","GeolocateControl.LocationNotAvailable":"GPS\u306f\u5229\u7528\u3067\u304d\u307e\u305b\u3093"}}');
            },
            6920: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"zoomIn":"Zoom in","zoom":"Zoom","zoomOut":"Zoom uit","moveDown":"Naar beneden","search_user":"Zoek een gebruikersnaam\u2026","moveUp":"Ga omhoog","share_rss":"RSS-feed","loading_labels_serious":["\ud83d\uddfa\ufe0f Kaart aan het laden","\ud83d\udda5\ufe0f API opvragen","\ud83d\uddbc\ufe0f Miniatuurweergaven laden","\ud83d\udd0d EXIF metadata analyseren","\ud83c\udfd8\ufe0f 3D-rendering","\ud83d\udcf7 360\xb0 afbeelden initialiseren","\ud83d\udfe0 Kleur balancering","\ud83d\udcaf Bereken kwaliteits-score \xa9","\ud83d\udce1 Updates downloaden","\ud83c\udf0d Kaarttegels ophalen","\ud83d\udcf8 Schaduwen verwerken"],"share_embed_docs":"Lees meer over embedded instellingen","sequence_pause":"Pauzeer sequentie","sequence_prev":"Vorige afbeelding uit de sequentie","id":"iD","josm":"JOSM","sequence_more":"Meer afspeelmogelijkheden","sequence_speed":"Afspeel snelheid","edit_osm":"OSM aanpassen","moveLeft":"Naar links","moveRight":"Naar rechts","moveMiddle":"Middelpunt","expand":"Vergroot","show_psv":"Toon de afbeeldingsviewer","show_map":"Toon de kaart","options":"Opties","filters":"Filters","layers":"Lagen","search":"Zoek","search_empty":"Geen resultaat gevonden","search_address":"Zoek een adres, stad\u2026","share":"Deel","share_links":"Links","share_page":"Link naar deze foto","share_image":"HD afbeelding","share_embed":"Embedden op uw website","share_print":"Afdrukken","copy":"Kopieer","copied":"Gekopieerd","error":"We hebben een probleem\u2026","sequence_next":"Volgende afbeelding van de sequentie","error_click":"Klik om verder te gaan","error_retry":"Probeer later opnieuw","legend_license":"Licentie: {l}","legend_title":"Toon gegevens van de afbeelding","sequence_play":"Speel deze sequentie af","expand_info":"De widget op de volledige pagina weergeven","minimize":"Verberg deze widget, je kan hem terug tonen met de knop linksonder","loading_labels_fun":["\ud83e\udd8c Detectie verkeersborden overstekende herten","\ud83d\ude98 Panoramax auto zoeken \xa9","\u2615 Cafe\xefne-injectie","\ud83d\ude00 Gelukt, je kaart is gekaart!","\ud83d\udc08 Foto\'s delen van katten","\ud83d\ude34 Uitstelgedrag verminderen","\ud83e\uded6 Thee zetten","\ud83d\udc27 Broncode openen","\ud83d\ude87 Indexering metrostations","\ud83e\uddf9 Metadata opschonen","\ud83d\ude92 Foto\'s van brandweerkazernes versturen","\ud83d\udeb2 Fiets- en wandelpaden bijwerken","\ud83d\ude89 Perron doorgang","\ud83d\udef0\ufe0f Satellieten zoeken","\ud83d\udc65 Personas opslaan","\ud83e\udd5e Pannenkoekenhuizen localiseren","\ud83e\uddd1\u200d\ud83d\udcbb Interface debuggen","\ud83d\udcc8 Statistieken verhogen","\ud83e\udd16 Semantiek aanleren","\ud83c\udfa8 Interface herontwerpen","\ud83d\udcc5 Fotomappingparty\'s plannen","\ud83e\uddc0 Kazen laten rijpen","\ud83c\udf04 Prachtige zonneschijn berekenen","\ud83c\udf0a Meten van het hoogwater"],"share_rss_title":"RSS-feed van nieuwe reeksen in het nu zichtbare kaartgebied","josm_live":"Schakel JOSM automatische synchronisatie in bij het laden van afbeeldingen","minimize_short":"Verbergen","error_psv":"Photo Sphere Viewer werd niet correct geladen","error_nopic":"Geen foto beschikbaar op de aangegeven locatie","error_api":"De fotoserver is niet beschikbaar","error_webgl":"WebGL wordt niet ondersteund door je browser","error_api_compatibility":"De fotoserver is niet compatibel met deze viewer","filter_date_1month":"1 maand","filter_date_1year":"1 jaar","filter_user":"Gebruiker","filter_user_mypics":"Mijn foto\'s","filter_picture":"Afbeeldingstype","picture_flat":"Klassiek","picture_360":"360\xb0","filter_qualityscore":"Kwaliteitsscore","qualityscore_doc_2":"De score wordt getoond als een letter A/B/C/D/E (waarbij A het beste is en E het slechtse), en wordt grafisch weergegeven volgens deze schaal:","qualityscore_doc_link":"Meer weten over de Kwaliteitsscore","map_background":"Kaartachtergrond","map_background_aerial":"Satelliet","map_background_streets":"Straten","map_theme":"Kaartthema","map_theme_default":"Klassiek","map_theme_age":"Opnamedatum","map_theme_age_3":"< 1 jaar","map_theme_age_4":"< 1 maand","filter_qualityscore_help":"Klik om aan- of uit te schakelen","report_failure":"Er is een fout opgetreden bij het aanmaken van het rapport: {e}. Probleem later opnieuw.","map_theme_score":"Kwaliteitsscore","contrast":"Afbeeldingscontrast verhogen","metadata":"Metadata van de foto","metadata_camera_make":"Fabrikant","filter_date":"Datum","filter_zoom_in":"Zoom in om dit filter te zien","metadata_general_license_link":"De volledige beschrijving van de licentie bekijken","metadata_general_seqid":"Serie","metadata_general_picid_link":"Ga naar de JSON-beschrijving van de foto","metadata_general_seqid_link":"Ga naar de JSON-beschrijving van de sequentie","metadata_general_author":"Auteur","error_josm":"JOSM antwoord niet, is het actief en is afstandsbediening ingeschakeld?","qualityscore_title":"Over de kwaliteitsscore","metadata_general_license":"Licentie","error_pic":"The gevraagde foto werd niet gevonden","map_theme_age_2":"< 2 jaar","metadata_general_picid":"Afbeelding","metadata_general_date":"Opnamedatum","map_theme_type":"Cameratype","qualityscore_doc_1":"Panoramax toont een Kwaliteitsscore voor elke foto. Dit vergemakkelijkt filtering en laat toe om foto\'s van hoge kwaliteit te vinden.","qualityscore_doc_3":"Hij wordt berekend op basis van de GPS-nauwkeurigheid en resolutie van de foto. Een professioneel systeem zal een A-score hebben, een 360\xb0 actiecamera een B-score, en een smartphone een C/D/E-score.","map_theme_age_1":"> 2 jaar","report_details_placeholder":"Je kan, optioneel, details over het probleem toevoegen","metadata_camera":"Apparaat","metadata_camera_model":"Model","metadata_camera_type":"Type","metadata_camera_resolution":"Resolutie","metadata_camera_focal_length":"Brandpuntsafstand","metadata_location":"Positie","metadata_location_longitude":"Longitude","metadata_location_latitude":"Latitude","metadata_location_orientation":"Richting","metadata_location_precision":"Nauwkeurigheid van de positionering","metadata_quality":"Kwaliteit","metadata_quality_help":"Meer weten over de Kwaliteitsscore","metadata_quality_score":"Globale score","metadata_quality_gps_score":"Positioneringsscore","metadata_quality_resolution_score":"Resolutiescore","metadata_quality_missing":"geen info in de afbeelding","metadata_exif":"EXIF","metadata_exif_name":"Tag","metadata_exif_value":"Waarde","report":"Rapporteer","report_auth":"Dit rapport zal worden verstuurd met je account \\"{a}\\"","report_nature_label":"Oorzaak van het probleem","report_nature":{"":"Selecteer de aard van het probleem \u2026","blur_missing":"Het gezicht van een persoon of een nummerplaat is zichtbaar","blur_excess":"Een overbodige vervaging werd toegepast op een object","inappropriate":"De foto is ongepast (ongerelateerd, naaktheid \u2026)","privacy":"Een private weg of een privaat eigendom is zichtbaar","picture_low_quality":"De foto is van lage kwaliteit","mislocated":"De foto is slecht gepositioneerd","copyright":"De foto schendt het auteursrecht","other":"Een ander soort probleem"},"report_whole_sequence":"Dit betreft de volledige sequentie","report_details":"Aanvullende details","report_email":"Je e-mail","report_email_placeholder":"Optioneel","report_submit":"Verzenden","report_wait":"Rapport verzenden \u2026","report_success":"Het rapport werd succesvol verzonden. Het zal zo snel mogelijk behandeld worden.","whats_panoramax":"Panoramax is de geo-commons voor foto\'s van gebieden.","contribute_id":"Bijdragen aan OpenStreetMap met de iD-editor","geo_uri":"Externe app","semantics_hide_all_tags":"Verberg alle tags","semantics_key":"Sleutel","semantics_value":"Waarde","semantics_key_doc":"Meer weten over deze sleutel","semantics_value_doc":"Meer weten over deze tag","semantics_title":"Tags","semantics_tags":"{nb} tags","semantics_features":"Objecten in de foto","semantics_features_none":"Er is nog geen object getekend in deze afbeelding.","semantics_features_default_title":"Tag {nb}","semantics_features_subtitle":"{nb} geassocieerde eigenschappen","semantics_show_all_tags":"Toon alle tags","metadata_general_instance":"Bron instance","semantics_annotation_tooltip":"Klik om details te zien","semantics_tags_picture":"Afbeelding tags","semantics_tags_picture_none":"Er zijn nog geen tags ingesteld voor deze afbeelding.","semantics_qualifiers":"Kwalificaties","semantics_show_annotations":"Objecten in de foto weergeven","semantics_hide_annotations":"Objecten in de foto verbergen","semantics_wikidata_properties":{"P31":"Instance van","P279":"subklasse van","P361":"onderdeel van"},"metadata_exif_doc":"Documenten voor EXIF-tags","metadata_exif_doc_title":"Ga naar documentatie van Exiv2 voor volledige informatie over definities van EXIF- en XMP-tags","metadata_location_copy":"Kopieer {v}","metadata_location_copy_more":"Meer kopieeropties voor co\xf6rdinaten","metadata_general_copy_picid":"Kopieer afbeelding ID","filter_date_6months":"6 maanden","picture_360_long":"Panorama afbeelding","metadata_summary":"Samenvatting","metadata_general_copy_id":"Kopieer ID","picture_flat_long":"Klassieke afbeelding","metadata_location_coordinates":"Co\xf6rdinaten (lengtegraad, breedtegraad)","picture_all":"Alles","semantics_zero_annotations":"Geen objecten getekend in deze afbeelding","semantics_hashtags":"Foto-hashtags","panoramax":"Panoramax","semantics_editor_error":"De syntax is ongeldig. Je tags moeten eruit zien als:\\nsleutel=waarde\\nprefix|sleutel=waarde\\nprefix|sleutel[qualif_sleutel=qualif_waarde]=waarde\\n\\nMaximale lengte van de sleutel: 256 karakters, maximale lengte van de waarde: 2048 karakters.","semantics_save":"Je wijzigingen opslaan","semantics_editor_example":"sleutel=waarde\\nprefix|sleutel=waarde","semantics_edit":"De attributen bewerken","semantics_undo":"Je bewerkingen annuleren","semantics_send_ok":"Je bewerkingen werden succesvol verzonden","semantics_cantsave_invalid":"Kan wijzigingen niet opslaan, input is ongeldig","semantics_send_fail":"Wijzigingen opslaan mislukt, probeer later opnieuw","semantics_save_drawn_annotation":"Bewaar positie","semantics_undo_drawn_annotation":"Annuleer","semantics_save_drawn_annotation_incomplete":"Er moet een rechthoek getekend worden die op de afbeelding past voor validatie mogelijk is","semantics_delete_annotation":"Verwijder dit object","semantics_delete_annotation_confirm":"Ben je zeker dat je deze tag wil verwijderen?","semantics_add_annotation":"Voeg een nieuwe tag toe","semantics_draw_annotation":"Je kan het object dat je wil toevoegen tekenen over de foto (optioneel).","filter_gps_precision_lessthan":"Minder dan {n} meter","filter_gps_precision_between":"Tussen {n1} en {n2} meter","filter_gps_precision_morethan":"Meer dan {n} meter","map_theme_gps":"Locatieprecisie","filter_gps_precision":"Locatieprecisie","semantics_login_needed":"Om tags of objecten te bewerken moet je inloggen op de Panoramax-instantie {n}. Wil je inloggen?","semantics_doc_info3":"Sommige objecten worden automatisch gedetecteerd aan de hand van AI: kwaliteit is niet gegarandeerd.","semantics_sequence_tags":"Sequentietag","semantics_picture_tags":"Fototag","semantics_annotation_tags":"Objecttag","semantics_doc_info1":"Geef context over een foto door gebruik te maken van een tag.","semantics_doc_info2":"Je kan eveneens objecten tekenen in de foto: verkeersborden, straatmeubilair \u2026 Geef aan wat je zien aan de hand van de bestaande tags. Je kan ook je eigen tag cre\xebren mocht dat nodig zijn.","semantics_doc_link":"Meer weten over tags (volledige documentatie, in het Engels)","semantics_doc":"Hulp","semantics_doc_title":"Over de tags","semantics_erase_annotation":"Getekend object verwijderen","semantics_overlays":{"tfsigns":"Verkeersborden","features":"Alle objecten"},"semantics_doc_info1u1":"Gebruik bijvoorbeeld de tag transport=car om aan te geven dat een foto vanuit een auto genomen werd.","semantics_zoom_in":"Zoom in op de kaart om tags te zien","semantics_download":"Downloaden","semantics_download_title":"Download tags","semantics_download_info":"Alle semantische data (tags) zijn beschikbaar als open data. Je kan ze downloaden en vrij gebruiken.","semantics_download_cta":"Open data downloaden"},"psv":{"twoFingers":"Gebruik twee vingers om te navigeren","ctrlZoom":"Gebruik ctrl + scroll om de afbeelding in en uit te zoomen","loadError":"Het panorama kan niet worden geupload"},"maplibre":{"GeolocateControl.FindMyLocation":"Mijn locatie zoeken","GeolocateControl.LocationNotAvailable":"Locatitie niet beschikbaar"},"map":{"loading":"Laden \u2026","slow_loading":"De kaart laadt traag en kan er gebroken uitzien","thumbnail":"Thumbnail van de aangeduide foto","not_public":"Niet openbaar zichtbaar","map_data":"Kaartdata: {m}","more_panoramax":"Meer weten over Panoramax"}}');
            },
            9026: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"moveRight":"Przesu\u0144 w prawo","sequence_speed":"Pr\u0119dko\u015b\u0107 odtwarzania","metadata_camera_model":"Model","search_address":"Szukaj adres, miasto\u2026","zoom":"Przybli\u017cenie","zoomIn":"Przybli\u017c","moveUp":"Przesu\u0144 w g\xf3r\u0119","moveDown":"Przesu\u0144 w d\xf3\u0142","moveLeft":"Przesu\u0144 w lewo","moveMiddle":"Wycentruj widok","expand":"Rozszerz","show_psv":"Poka\u017c przegl\u0105dark\u0119 zdj\u0119\u0107","show_map":"Poka\u017c map\u0119","options":"Opcje","filters":"Filtry","layers":"Warstwy","search":"Szukaj","search_empty":"Brak wynik\xf3w","search_user":"Szukaj nazwy u\u017cytkownika\u2026","share":"Udost\u0119pnij","share_links":"Linki","share_page":"Link do tej strony","share_rss":"Kana\u0142 RSS","share_print":"Drukuj","copy":"Kopiuj","copied":"Skopiowano","error":"Mamy problem\u2026","error_click":"Kliknij, aby kontynuowa\u0107","error_retry":"Prosz\u0119 spr\xf3buj p\xf3\u017aniej","sequence_next":"Nast\u0119pne zdj\u0119cie w sekwencji","sequence_pause":"Spauzuj sekwencj\u0119","sequence_prev":"Poprzednie zdj\u0119cie w sekwencji","sequence_more":"Wi\u0119cej opcji odtwarzania","legend_license":"Licencja: {l}","legend_title":"Poka\u017c szczeg\xf3\u0142y zdj\u0119cia","edit_osm":"Edytuj OSM","loading_labels_serious":["\ud83d\uddfa\ufe0f Wczytywanie danych mapy","\ud83d\udda5\ufe0f Odpytywanie API","\ud83d\uddbc\ufe0f Wczytywanie miniaturek","\ud83d\udd0d Analizowanie metadanych EXIF","\ud83c\udfd8\ufe0f Renderowanie 3D","\ud83d\udcf7 Inicjowanie zdj\u0119\u0107 360\xb0","\ud83d\udfe0 Balansowanie kolor\xf3w","\ud83d\udcaf Obliczanie oceny jako\u015bci \xa9"],"map_theme_age_2":"< 2 lata","map_theme_age_1":"> 2 lata","map_theme_age":"Data zrobienia","filter_picture":"Typ zdj\u0119cia","map_theme_age_3":"< rok","map_theme_age_4":"< miesi\u0105c","map_theme_type":"Typ aparatu","metadata":"Metadane zdj\u0119cia","metadata_general_picid":"Identyfikator zdj\u0119cia","metadata_general_seqid":"Identyfikator sekwencji","metadata_general_license":"Licencja","metadata_general_author":"Autor","metadata_camera":"Aparat","metadata_camera_type":"Typ","metadata_camera_resolution":"Rozdzielczo\u015b\u0107","metadata_location":"Lokalizacja","metadata_exif":"EXIF / XMP","metadata_quality_missing":"Brak warto\u015bci ustawionej w zdj\u0119ciu","metadata_exif_name":"Tag","metadata_exif_value":"Warto\u015b\u0107","report":"Zg\u0142o\u015b zdj\u0119cie","report_nature":{"privacy":"Prywatna droga lub w\u0142asno\u015b\u0107 widoczna","mislocated":"Zdj\u0119cie jest w z\u0142ym miejscu na mapie","copyright":"Zdj\u0119cie narusza prawa autorskie","picture_low_quality":"Zdj\u0119cie jest bardzo niskiej jako\u015bci","other":"Inny problem","":"Wybierz typ problemu\u2026","blur_missing":"Twarz osoby lub rejestracja samochodu jest widoczna","blur_excess":"Obiekt, kt\xf3ry nie wymaga zamazania jest zamazany","inappropriate":"Zdj\u0119cie jest niestosowne (niezwi\u0105zane, nago\u015b\u0107\u2026)"},"zoomOut":"Oddal","report_whole_sequence":"Dotyczy ca\u0142ej sekwencji","report_details":"Dodatkowe szczeg\xf3\u0142y","report_email":"Tw\xf3j adres email","report_email_placeholder":"Opcjonalne","report_submit":"Wy\u015blij","report_wait":"Wysy\u0142anie zg\u0142oszenia\u2026","report_success":"Zg\u0142oszenie zosta\u0142o wys\u0142ane. Zostanie przejrzane tak szybko jak to mo\u017cliwe.","share_rss_title":"Kana\u0142 RSS nowych sekwencji na widocznym obszarze mapy","loading_labels_fun":["\ud83e\udd8c Wykrywanie znak\xf3w przechodzenia jeleni",null,"\u2615 Wstrzykiwanie kofeiny","\ud83d\ude00 U\u015bmiechnij si\u0119, jeste\u015b mapowany!","\ud83d\udc08 Udost\u0119pnianie zdj\u0119\u0107 kot\xf3w","\ud83d\ude34 Zmniejszania prokrastynacji","\ud83e\uded6 Parzenie herbaty","\ud83d\udc27 Otwieranie kodu \u017ar\xf3d\u0142owego","\ud83d\ude87 Indeksowanie stacji metra","\ud83e\uddf9 Czyszczenie metadanych","\ud83d\ude92 Przesy\u0142anie zdj\u0119\u0107 remiz",null,"\ud83d\ude89 Przechodzenie peron\xf3w stacji","\ud83d\udef0\ufe0f Wyszukiwanie satelit",null,"\ud83d\udc1f Szukanie sklep\xf3w z frytkami i ryb\u0105","\ud83e\uddd1\u200d\ud83d\udcbb Interfejs debugowania","\ud83d\udcc8 Zwi\u0119kszanie statystyk"],"share_embed_docs":"Przeczytaj wi\u0119cej o konfiguracji osadzenia","sequence_play":"Odtw\xf3rz t\u0119 sekwencj\u0119","josm_live":"W\u0142\u0105cz automatyczn\u0105 synchronizacj\u0119 JOSM przy \u0142adowaniu zdj\u0119\u0107","error_api":"Serwer zdj\u0119\u0107 nie jest dost\u0119pny","error_webgl":"WebGL nie jest obs\u0142ugiwany przez t\u0119 przegl\u0105dark\u0119","error_api_compatibility":"Serwer zdj\u0119\u0107 nie jest kompatybilny z t\u0105 wersj\u0105 przegl\u0105darki","filter_date":"Data","filter_date_1month":"1 miesi\u0105c","filter_date_1year":"1 rok","filter_user":"U\u017cytkownik","filter_user_mypics":"Moje zdj\u0119cia","filter_zoom_in":"Przybli\u017c, aby filtry by\u0142y widoczne","picture_flat":"Klasyczne","picture_360":"360\xb0","filter_qualityscore":"Ocena jako\u015bci","map_background":"Podk\u0142ad mapowy","map_background_aerial":"Zdj\u0119cia lotnicze","map_background_streets":"Ulice","map_theme":"Motyw mapy","map_theme_default":"Klasyczny","map_theme_score":"Ocena jako\u015bci","contrast":"W\u0142\u0105cz wy\u017cszy kontrast zdj\u0119cia","metadata_general_picid_link":"Id\u017a do opisu zdj\u0119cia w JSON","metadata_general_seqid_link":"Id\u017a do opisu sekwencji w JSON","metadata_general_license_link":"Id\u017a do strony z pelnym opisem licencji","metadata_general_date":"Data zrobienia","metadata_camera_make":"Marka","metadata_camera_focal_length":"Ogniskowa","metadata_location_longitude":"D\u0142ugo\u015b\u0107 geograficzna","metadata_location_latitude":"Szeroko\u015b\u0107 geograficzna","metadata_location_orientation":"Kierunek robienia zdj\u0119cia","metadata_location_precision":"Precyzja lokalizacji","metadata_quality":"Ocena jako\u015bci","metadata_quality_help":"Dowiedz si\u0119 wi\u0119cej o ocenie jako\u015bci","metadata_quality_score":"Ocena globalna","metadata_quality_gps_score":"Ocena pozycji","metadata_quality_resolution_score":"Ocena rozdzielczo\u015bci","report_auth":"To zg\u0142oszenie b\u0119dzie wys\u0142anie przy pomocy Twojego konta \\"{a}\\"","report_nature_label":"Typ problemu","report_details_placeholder":"Opcjonalnie, mo\u017cesz doda\u0107 szczeg\xf3\u0142y o problemie","report_failure":"B\u0142\u0105d wyst\u0105pi\u0142 podczas tworzenia zg\u0142oszenia: {e}. Prosz\u0119 spr\xf3buj ponownie.","filter_qualityscore_help":"Kliknij, aby w\u0142\u0105czy\u0107 lub wy\u0142\u0105czy\u0107","error_josm":"JOSM nie odpowiada, czy jest uruchomiony i czy dost\u0119p zdalny jest w\u0142\u0105czony?"},"psv":{"twoFingers":"U\u017cyj dw\xf3ch palc\xf3w do nawigacji","ctrlZoom":"U\u017cyj ctrl + rolka myszy, aby powi\u0119kszy\u0107 zdj\u0119cie","loadError":"Panorama nie mo\u017ce by\u0107 za\u0142adowana"},"maplibre":{"GeolocateControl.FindMyLocation":"Znajd\u017a moj\u0105 lokalizacj\u0119","GeolocateControl.LocationNotAvailable":"Lokalizacja niedost\u0119pna"},"map":{"thumbnail":"Miniaturki najechanego zdj\u0119cia","not_public":"Niewidoczne publicznie","slow_loading":"Mapa \u0142aduje si\u0119 wolno i mo\u017ce si\u0119 wydawaj popsuta","loading":"\u0141adowanie\u2026"}}');
            },
            8010: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"ctrlZoom":"Use ctrl + rolagem para ampliar a imagem","loadError":"O panorama n\xe3o pode ser carregado","twoFingers":"Use dois dedos para navegar"},"pnx":{"search_user":"Pesquisar um nome de utilizador\u2026","legend_license":"Licen\xe7a: {l}","map_background":"Fundo do mapa","semantics_features":"Caracter\xedsticas da imagem","show_map":"Exibir o mapa","minimize":"Ocultar este widget, pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo","share_image":"Imagem HD","error_retry":"Por favor, tente novamente mais tarde","picture_flat_long":"Imagem cl\xe1ssica","report_success":"O relat\xf3rio foi enviado com sucesso. Ser\xe1 analisado assim que poss\xedvel.","loading_labels_serious":["\ud83d\uddfa\ufe0f Carregando dados do mapa","\ud83d\udda5\ufe0f Consultando a API","\ud83d\uddbc\ufe0f Carregando miniaturas","\ud83d\udd0d Analisando os metadados EXIF","\ud83c\udfd8\ufe0f Renderiza\xe7\xe3o 3D","\ud83d\udcf7 Inicializando imagens em 360\xb0","\ud83d\udfe0 Ajuste de cores","\ud83d\udcaf Computando o Quality Score \xa9","\ud83d\udce1 Transferindo atualiza\xe7\xf5es","\ud83c\udf0d Buscando blocos de mapa","\ud83d\udcf8 Processando sombras"],"loading_labels_fun":["\ud83d\udc17 Detetando placas de passagem de javalis","\ud83d\ude98 Pesquisando Panoramax Car \xa9","\u2615 Injetando cafe\xedna","\ud83d\ude00 Sorria, est\xe1 a ser mapeado!","\ud83d\udc08 Partilhando fotos de gatos","\ud83d\ude34 Reduzindo a procrastina\xe7\xe3o","\ud83e\uded6 Preparando um ch\xe1","\ud83d\udc27 Abrindo o c\xf3digo-fonte","\ud83d\ude87 Indexando esta\xe7\xf5es de el\xe9trico","\ud83e\uddf9 Limpeza de metadados","\ud83d\ude92 Enviando fotos do quartel dos bombeiros","\ud83d\udeb2 Atualiza\xe7\xe3o das ciclovias","\ud83d\ude89 Passeio pela plataforma da esta\xe7\xe3o","\ud83d\udef0\ufe0f Pesquisando sat\xe9lites","\ud83d\ude8b Mapeando Lisboa de el\xe9trico","\ud83c\udf5f Procurando lanchonetes","\ud83e\uddd1\u200d\ud83d\udcbb Depurando a interface","\ud83d\udcc8 Aumentando as estat\xedsticas","\ud83d\udea2 Procurando portos em Porto","\ud83c\udfa8 Redesenho da interface","\ud83c\udfc4\u200d\u2640\ufe0f Mapeando e surfando nas ondas em Peniche","\ud83e\uddc0 Maturando os queijos","\ud83c\udf04 Calculando a insola\xe7\xe3o em Tavira","\ud83c\udf0a Medindo as mar\xe9s altas"],"error_psv":"O Photo Sphere Viewer n\xe3o est\xe1 a carregar corretamente","error_api":"O servidor de imagens n\xe3o est\xe1 dispon\xedvel","metadata_quality_resolution_score":"Pontua\xe7\xe3o de resolu\xe7\xe3o","semantics_doc":"Ajuda","map_theme_score":"Pontua\xe7\xe3o de qualidade","metadata_general_picid_link":"Ir para a descri\xe7\xe3o JSON da imagem","metadata_general_seqid_link":"Ir para a descri\xe7\xe3o JSON da sequ\xeancia","metadata_quality_help":"Saiba mais sobre a Pontua\xe7\xe3o de Qualidade","panoramax":"Panoramax","whats_panoramax":"Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.","sequence_pause":"Pausar sequ\xeancia","contribute_id":"Contribua para o OpenStreetMap com o editor iD","josm_live":"Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens","zoom":"Zoom","zoomOut":"Diminuir o zoom","zoomIn":"Ampliar o zoom","moveUp":"Mover para cima","moveDown":"Mover para baixo","moveLeft":"Mover para a esquerda","moveMiddle":"Centralizar a vista","expand":"Expandir","expand_info":"Fazer com que o widget apare\xe7a em p\xe1gina inteira","show_psv":"Exibir o visualizador de imagens","minimize_short":"Ocultar","options":"Op\xe7\xf5es","filters":"Filtros","layers":"Camadas","search":"Pesquisa","search_empty":"Nenhum resultado encontrado","search_address":"Pesquisar um endere\xe7o, cidade\u2026","share":"Partilhar","share_links":"Links","share_page":"Link para esta foto","share_rss":"Feed RSS","share_embed":"Incorporar no seu site","share_embed_docs":"Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o","share_print":"Imprimir","copy":"Copiar","copied":"Copiado","error":"Temos um problema\u2026","error_click":"Continuar","sequence_next":"Pr\xf3xima imagem na sequ\xeancia","sequence_play":"Reproduzir esta sequ\xeancia","sequence_prev":"Imagem anterior na sequ\xeancia","sequence_more":"Mais op\xe7\xf5es de reprodu\xe7\xe3o","sequence_speed":"Velocidade de reprodu\xe7\xe3o","legend_title":"Exibir detalhes da imagem","id":"iD","geo_uri":"Aplica\xe7\xe3o externa","josm":"JOSM","error_nopic":"N\xe3o h\xe1 imagem dispon\xedvel na posi\xe7\xe3o indicada","error_webgl":"O WebGL n\xe3o \xe9 suportado pelo seu navegador","error_josm":"O JOSM n\xe3o responde, est\xe1 a funcionar e est\xe1 ativado o acesso remoto?","filter_date":"Data","filter_date_1month":"1 m\xeas","filter_date_1year":"1 ano","filter_user":"Utilizador","filter_user_mypics":"Minhas imagens","filter_picture":"Tipo de imagem","filter_zoom_in":"Amplie o mapa para ver este filtro","picture_all":"Todas","picture_flat":"Cl\xe1ssica","picture_360":"360\xb0","picture_360_long":"Imagem panor\xe2mica","filter_qualityscore":"Pontua\xe7\xe3o de qualidade","filter_qualityscore_help":"Clique para ativar ou desativar","qualityscore_title":"Sobre a pontua\xe7\xe3o de qualidade","qualityscore_doc_3":"\xabA\xbb \xe9 a melhor nota, \xabE\xbb a pior.","qualityscore_doc_link":"Saiba mais sobre a Pontua\xe7\xe3o de Qualidade","filter_gps_precision":"Precis\xe3o de localiza\xe7\xe3o","filter_gps_precision_lessthan":"Menos de {n} metros","filter_gps_precision_between":"Entre {n1} e {n2} metros","filter_gps_precision_morethan":"Mais de {n} metros","map_background_aerial":"A\xe9reo","map_background_streets":"Ruas","map_theme":"Tema do mapa","map_theme_default":"Cl\xe1ssico","map_theme_age":"Data da captura","map_theme_age_1":"> 2 anos","map_theme_age_2":"< 2 anos","map_theme_age_4":"< 1 m\xeas","map_theme_type":"Tipo de c\xe2mara","map_theme_gps":"Precis\xe3o de localiza\xe7\xe3o","contrast":"Ativar maior contraste da imagem","metadata":"Metadados de imagem","metadata_summary":"Resumo","metadata_general_copy_id":"Copiar ID","metadata_general_copy_picid":"Copiar ID da imagem","metadata_general_picid":"Imagem","metadata_general_seqid":"Sequ\xeancia","metadata_general_author":"Autor","metadata_general_license":"Licen\xe7a","metadata_general_license_link":"Veja a descri\xe7\xe3o completa da licen\xe7a","metadata_general_date":"Data da captura","metadata_general_instance":"Inst\xe2ncia de origem","metadata_camera":"C\xe2mara","metadata_camera_make":"Marca","metadata_camera_model":"Modelo","metadata_camera_type":"Tipo","metadata_camera_resolution":"Resolu\xe7\xe3o","metadata_camera_focal_length":"Dist\xe2ncia focal","metadata_location":"Posi\xe7\xe3o","metadata_location_orientation":"Dire\xe7\xe3o","metadata_location_precision":"Precis\xe3o de posicionamento","metadata_location_copy":"Copiar {v}","metadata_location_copy_more":"Mais op\xe7\xf5es de c\xf3pia de coordenadas","metadata_quality":"Qualidade","metadata_quality_score":"Pontua\xe7\xe3o global","metadata_quality_gps_score":"Pontua\xe7\xe3o de posicionamento","metadata_quality_missing":"nenhum valor definido na imagem","metadata_exif":"EXIF","metadata_exif_value":"Valor","semantics_features_subtitle":"{nb} propriedades associadas","semantics_annotation_tooltip":"Clique para ver detalhes","semantics_key":"Chave","semantics_value":"Valor","semantics_key_doc":"Saiba mais sobre esta chave","semantics_qualifiers":"Qualificadores","semantics_show_annotations":"Exibir caracter\xedsticas da imagem","semantics_hide_annotations":"Ocultar caracter\xedsticas da imagem","semantics_zero_annotations":"Nenhuma caracter\xedstica desenhada nesta imagem","semantics_erase_annotation":"Apagar caracter\xedstica desenhada","semantics_delete_annotation":"Eliminar esta caracter\xedstica","semantics_wikidata_properties":{"P31":"inst\xe2ncia de","P361":"parte de","P279":"subclasse de","P180":"retrata"},"semantics_editor_example":"chave=valor\\nprefixo|chave=valor","semantics_edit":"Editar atributos","semantics_save":"Salvar suas altera\xe7\xf5es","semantics_undo":"Cancelar suas edi\xe7\xf5es","report":"Denunciar","report_nature_label":"Causa do problema","report_nature":{"":"Selecione o tipo do problema\u2026","blur_missing":"O rosto de uma pessoa ou a matr\xedcula de um carro s\xe3o vis\xedveis","inappropriate":"A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)","privacy":"Um caminho ou propriedade privada \xe9 vis\xedvel","mislocated":"A imagem est\xe1 mal posicionada no mapa","copyright":"A imagem viola direitos autorais","other":"Qualquer outro tipo de problema","picture_low_quality":"A imagem \xe9 de baixa qualidade","blur_excess":"Foi aplicado um desfoque desnecess\xe1rio a um objeto"},"report_whole_sequence":"Isto diz respeito a toda a sequ\xeancia","report_details":"Detalhes adicionais","report_email_placeholder":"Opcional","report_wait":"Enviando relat\xf3rio\u2026","report_failure":"Ocorreu um erro ao criar o relat\xf3rio: {e}. Por favor, tente novamente mais tarde.","moveRight":"Mover para a direita","share_rss_title":"Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel","error_pic":"A imagem solicitada n\xe3o foi encontrada","filter_date_6months":"6 meses","error_api_compatibility":"O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador","semantics_doc_info3":"Alguns objetos s\xe3o detetados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.","report_email":"Seu e-mail","map_theme_age_3":"< 1 ano","metadata_location_coordinates":"Coordenadas (longitude, latitude)","qualityscore_doc_2":"A pontua\xe7\xe3o \xe9 apresentada como uma letra:","semantics_features_none":"Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.","qualityscore_doc_1":"\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.","semantics_draw_annotation":"Pode desenhar o objeto que deseja adicionar na imagem (opcional).","semantics_send_fail":"N\xe3o foi poss\xedvel guardar as suas altera\xe7\xf5es, por favor, tente novamente mais tarde","report_auth":"Este relat\xf3rio ser\xe1 enviado usando a sua conta \\"{a}\\"","report_details_placeholder":"Opcionalmente, pode adicionar detalhes sobre o problema","report_submit":"Enviar","metadata_exif_name":"Tag","metadata_exif_doc":"Documenta\xe7\xe3o para etiquetas EXIF","semantics_tags":"{nb} etiquetas","semantics_title":"Etiquetas","semantics_show_all_tags":"Mostrar todas as etiquetas","semantics_hide_all_tags":"Ocultar todas as etiquetas","semantics_sequence_tags":"Etiqueta da sequ\xeancia","semantics_picture_tags":"Etiqueta de imagem","semantics_features_default_title":"Etiqueta {nb}","semantics_annotation_tags":"Etiqueta de objeto","semantics_doc_title":"Sobre etiquetas","semantics_doc_info2":"Tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que v\xea usando as etiquetas existentes. Tamb\xe9m pode criar as suas pr\xf3prias, se necess\xe1rio.","semantics_doc_link":"Saiba mais sobre etiquetas","semantics_value_doc":"Saiba mais sobre esta etiqueta","semantics_add_annotation":"Adicionar uma nova etiqueta","semantics_delete_annotation_confirm":"Quer mesmo eliminar esta etiqueta?","semantics_editor_error":"A sintaxe \xe9 inv\xe1lida. Suas etiquetas podem ficar assim:\\nchave=valor\\nprefixo|chave=valor\\nprefixo|chave[qualif_chave=qualif_val]=valor\\n\\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.","semantics_login_needed":"Para editar tags ou recursos de imagens, \xe9 necess\xe1rio fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?","metadata_exif_doc_title":"Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das etiquetas EXIF e XMP","semantics_doc_info1":"D\xea contexto a uma imagem usando etiquetas.","semantics_overlays":{"tfsigns":"Sinais de tr\xe2nsito","features":"Todas as caracter\xedsticas"},"semantics_doc_info1u1":"Pode marc\xe1-la como capturada por carro com a etiqueta transport=car.","semantics_zoom_in":"Amplie o mapa para ver as etiquetas","semantics_download_info":"Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.","semantics_download_title":"Baixar etiquetas","semantics_download":"Baixar","semantics_download_cta":"Baixar dados abertos","semantics_copy":"Copiar atributos","popup_details_link":"Mais detalhes","qualityscore_doc_41":"a precis\xe3o do GPS","filter_gps_precision_help":"Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o","filter_gps_precision_help_1":"Informa\xe7\xf5es de precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedveis para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.","filter_gps_precision_help_3":"\xab5\u2b50\xbb \xe9 muito preciso (<= {p5}m), \xab1\u2b50\xbb \xe9 muito impreciso (> {p1}m) ou desconhecido.","qualityscore_doc_4":"Esta pontua\xe7\xe3o \xe9 calculada com base em:","filter_gps_precision_help_4":"Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \xab5\u2b50\xbb, uma c\xe2mara de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \xab3\u2b50\xbb e um GPS de smartphone num estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \xab1\u2b50\xbb.","filter_gps_precision_help_2":"A precis\xe3o \xe9 expressa com estrelas:","semantics_value_show_osm":"Ver no OpenStreetMap","qualityscore_doc_42":"a resolu\xe7\xe3o da imagem","qualityscore_doc_5":"Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mara de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.","indoor_selector_expand":"Clique para ver todos os n\xedveis dispon\xedveis","indoor_selector_shrink":"Clique para minimizar","indoor_selector_levelup":"Ir para o n\xedvel superior","indoor_selector_leveldown":"Ir para o n\xedvel inferior","indoor_selector_scrollup":"Role a lista de n\xedveis para cima","indoor_selector_scrolldown":"Role a lista de n\xedveis para baixo","indoor_switch":"Mapas de interiores"},"maplibre":{"GeolocateControl.LocationNotAvailable":"Localiza\xe7\xe3o n\xe3o dispon\xedvel","GeolocateControl.FindMyLocation":"Encontre minha localiza\xe7\xe3o"},"map":{"thumbnail":"Miniatura da imagem ao passar o cursor","not_public":"N\xe3o vis\xedvel publicamente","slow_loading":"O mapa demora a carregar e pode aparecer corrompido","map_data":"Mapa baseado em {m}","more_panoramax":"Descubra mais sobre o Panoramax","loading":"Carregando\u2026"}}');
            },
            6611: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"loading_labels_fun":["\ud83e\udda5 Detectando placas de travessia de bichos-pregui\xe7a","\ud83d\ude98 Procurando Panoramax Car \xa9","\u2615 Injetando cafe\xedna","\ud83d\ude00 Sorria, voc\xea est\xe1 mapeado!","\ud83d\udc08 Compartilhando imagens de gatos","\ud83d\ude34 Reduzindo a procrastina\xe7\xe3o","\u2615 Preparando um cafezinho","\ud83d\udc27 Abrindo c\xf3digo-fonte","\ud83d\ude87 Indexando as esta\xe7\xf5es de metr\xf4","\ud83e\uddf9 Limpeza de metadados","\ud83d\ude92 Enviando fotos do quartel dos bombeiros","\ud83d\udeb2 Atualiza\xe7\xe3o das ciclovias","\ud83d\ude89 Passagem pela plataforma da esta\xe7\xe3o","\ud83d\udef0\ufe0f Procurando sat\xe9lites","\ud83d\udea1 Subindo o P\xe3o de A\xe7\xfacar de telef\xe9rico","\ud83c\udf5f Localizando lanchonetes","\ud83e\uddd1\u200d\ud83d\udcbb Depurando a interface","\ud83d\udcc8 Incrementando as estat\xedsticas","\ud83c\udff0 Fortificando fortalezas em Fortaleza","\ud83c\udfa8 Redesenho da interface","\ud83d\udc2c Procurando o boto-rosa no rio Amazonas","\ud83e\uddc0 Maturando os queijos minas","\ud83c\udf04 Calculando a insola\xe7\xe3o em Ubatuba","\ud83c\udf0a Medindo as mar\xe9s altas"],"zoom":"Zoom","zoomOut":"Diminuir o zoom","zoomIn":"Ampliar o zoom","moveUp":"Mover para cima","moveDown":"Mover para baixo","moveLeft":"Mover para a esquerda","expand":"Expandir","expand_info":"Fazer com que o widget apare\xe7a em p\xe1gina inteira","show_psv":"Exibir o visualizador de imagens","show_map":"Exibir o mapa","minimize_short":"Ocultar","options":"Op\xe7\xf5es","filters":"Filtros","layers":"Camadas","search":"Pesquisa","search_empty":"Nenhum resultado encontrado","search_address":"Pesquisar um endere\xe7o, cidade\u2026","search_user":"Pesquisar um nome de usu\xe1rio\u2026","share":"Compartilhar","share_links":"Links","share_page":"Link para esta foto","share_image":"Imagem HD","share_rss":"Feed RSS","share_embed":"Incorporar no seu site","share_embed_docs":"Leia mais sobre a configura\xe7\xe3o de incorpora\xe7\xe3o","share_print":"Imprimir","panoramax":"Panoramax","whats_panoramax":"Panoramax \xe9 o geo-reposit\xf3rio comum para imagens de territ\xf3rios.","copy":"Copiar","copied":"Copiado","error":"Temos um problema\u2026","error_retry":"Por favor, tente novamente mais tarde","sequence_play":"Reproduzir esta sequ\xeancia","sequence_pause":"Pausar sequ\xeancia","sequence_next":"Pr\xf3xima imagem na sequ\xeancia","sequence_more":"Mais op\xe7\xf5es de reprodu\xe7\xe3o","sequence_speed":"Velocidade de reprodu\xe7\xe3o","legend_license":"Licen\xe7a: {l}","legend_title":"Exibir detalhes da imagem","id":"iD","geo_uri":"Aplicativo externo","josm":"JOSM","josm_live":"Ativar a sincroniza\xe7\xe3o autom\xe1tica do JOSM ao carregar imagens","loading_labels_serious":["\ud83d\uddfa\ufe0f Carregando dados do mapa","\ud83d\udda5\ufe0f Consultando a API","\ud83d\uddbc\ufe0f Carregando miniaturas","\ud83d\udd0d Analisando os metadados EXIF","\ud83c\udfd8\ufe0f Renderiza\xe7\xe3o 3D","\ud83d\udcf7 Inicializando imagens em 360\xb0","\ud83d\udfe0 Ajuste de cores","\ud83d\udcaf Computando o Quality Score \xa9","\ud83d\udce1 Baixando atualiza\xe7\xf5es","\ud83c\udf0d Buscando blocos de mapa","\ud83d\udcf8 Processando sombras"],"moveMiddle":"Centralizar a visualiza\xe7\xe3o","share_rss_title":"Feed RSS de novas sequ\xeancias na \xe1rea do mapa atualmente vis\xedvel","contribute_id":"Contribua para o OpenStreetMap com o editor iD","moveRight":"Mover para a direita","sequence_prev":"Imagem anterior na sequ\xeancia","minimize":"Ocultar este widget. Voc\xea pode exibi-lo novamente usando o bot\xe3o no canto inferior esquerdo","error_click":"Continuar","semantics_features_none":"Ainda n\xe3o foi desenhado nenhuma caracter\xedstica nesta imagem.","semantics_draw_annotation":"Voc\xea pode desenhar o objeto que deseja adicionar na imagem (opcional).","semantics_login_needed":"Para editar etiquetas ou caracter\xedsticas de imagens, voc\xea precisa fazer login na inst\xe2ncia Panoramax {n}. Deseja fazer login?","filter_zoom_in":"Amplie o mapa para ver este filtro","picture_360":"360\xb0","picture_flat_long":"Imagem cl\xe1ssica","filter_qualityscore":"Pontua\xe7\xe3o de qualidade","filter_qualityscore_help":"Clique para ativar ou desativar","qualityscore_title":"Sobre a pontua\xe7\xe3o de qualidade","qualityscore_doc_2":"A pontua\xe7\xe3o \xe9 apresentada como uma letra:","semantics_features":"Caracter\xedsticas da imagem","semantics_features_default_title":"Etiqueta {nb}","semantics_features_subtitle":"{nb} propriedades associadas","semantics_annotation_tooltip":"Clique para ver detalhes","semantics_hide_all_tags":"Ocultar todas as etiquetas","semantics_key":"Chave","semantics_value":"Valor","semantics_value_doc":"Saiba mais sobre esta etiqueta","semantics_tags_picture":"Etiquetas de imagem","qualityscore_doc_3":"\u201cA\u201d \xe9 a melhor nota, \u201cE\u201d \xe9 a pior.","error_psv":"O Photo Sphere Viewer n\xe3o est\xe1 carregando corretamente","error_pic":"A imagem solicitada n\xe3o foi encontrada","error_api":"O servidor de imagens n\xe3o est\xe1 dispon\xedvel","error_webgl":"O WebGL n\xe3o \xe9 compat\xedvel com o seu navegador","error_api_compatibility":"O servidor de imagens n\xe3o \xe9 compat\xedvel com esta vers\xe3o do visualizador","filter_date":"Data","filter_date_1month":"1 m\xeas","filter_date_6months":"6 meses","filter_date_1year":"1 ano","filter_user":"Usu\xe1rio","filter_user_mypics":"Minhas imagens","error_josm":"O JOSM n\xe3o responde. Ele est\xe1 sendo executado e est\xe1 ativado o acesso remoto?","filter_picture":"Tipo de imagem","picture_flat":"Cl\xe1ssica","picture_360_long":"Imagem panor\xe2mica","qualityscore_doc_link":"Saiba mais sobre a Pontua\xe7\xe3o de Qualidade","metadata_general_picid_link":"Ir para a descri\xe7\xe3o JSON da imagem","metadata_camera_resolution":"Resolu\xe7\xe3o","metadata_exif_doc":"Documenta\xe7\xe3o para etiquetas EXIF","metadata_exif_doc_title":"Acesse a documenta\xe7\xe3o do Exiv2 para obter detalhes completos sobre as defini\xe7\xf5es das tags EXIF e XMP","semantics_title":"Etiquetas","semantics_show_all_tags":"Mostrar todas as etiquetas","semantics_tags_picture_none":"Ainda n\xe3o foram definidas etiquetas para esta imagem.","semantics_send_fail":"N\xe3o \xe9 poss\xedvel salvar suas altera\xe7\xf5es, por favor, tente novamente mais tarde","report_details_placeholder":"Opcionalmente, voc\xea pode adicionar detalhes sobre o problema","report_nature":{"inappropriate":"A imagem \xe9 inadequada (sem rela\xe7\xe3o, nudez\u2026)","":"Selecione o tipo do problema\u2026","blur_missing":"O rosto de uma pessoa ou a placa de um carro s\xe3o vis\xedveis","blur_excess":"Um desfoque desnecess\xe1rio foi aplicado a um objeto","privacy":"Um caminho ou propriedade privada \xe9 vis\xedvel","picture_low_quality":"A imagem \xe9 de baixa qualidade","mislocated":"A imagem est\xe1 mal posicionada no mapa","copyright":"A imagem viola direitos autorais","other":"Qualquer outro tipo de problema"},"error_nopic":"Nenhuma imagem dispon\xedvel na posi\xe7\xe3o indicada","picture_all":"Todas","metadata_location_copy_more":"Mais op\xe7\xf5es de c\xf3pia de coordenadas","semantics_tags":"{nb} etiquetas","semantics_zero_annotations":"Nenhuma caracter\xedstica desenhada nesta imagem","semantics_save_drawn_annotation_incomplete":"Voc\xea deve desenhar um ret\xe2ngulo que se encaixe na imagem antes de validar","map_background":"Fundo do mapa","map_background_aerial":"A\xe9reo","map_background_streets":"Ruas","map_theme":"Tema do mapa","map_theme_default":"Cl\xe1ssico","map_theme_age":"Data da captura","map_theme_age_1":"> 2 anos","map_theme_age_2":"< 2 anos","map_theme_age_3":"< 1 ano","map_theme_age_4":"< 1 m\xeas","map_theme_type":"Tipo de c\xe2mera","contrast":"Ativar maior contraste da imagem","metadata":"Metadados de imagem","metadata_summary":"Resumo","metadata_general_copy_id":"Copiar ID","metadata_general_copy_picid":"Copiar ID da imagem","metadata_general_picid":"Imagem","metadata_general_seqid":"Sequ\xeancia","metadata_general_seqid_link":"Ir para a descri\xe7\xe3o JSON da sequ\xeancia","metadata_general_author":"Autor","metadata_general_license":"Licen\xe7a","metadata_general_license_link":"Consulte a descri\xe7\xe3o completa da licen\xe7a","metadata_general_date":"Data da captura","metadata_general_instance":"Inst\xe2ncia de origem","metadata_camera":"C\xe2mera","metadata_camera_make":"Marca","metadata_camera_model":"Modelo","metadata_camera_type":"Tipo","metadata_camera_focal_length":"Dist\xe2ncia focal","metadata_location":"Posi\xe7\xe3o","metadata_location_coordinates":"Coordenadas (longitude, latitude)","metadata_location_orientation":"Dire\xe7\xe3o","metadata_location_precision":"Precis\xe3o de posicionamento","metadata_location_copy":"Copiar {v}","metadata_quality":"Qualidade","metadata_quality_help":"Saiba mais sobre a Pontua\xe7\xe3o de Qualidade","metadata_quality_score":"Pontua\xe7\xe3o global","metadata_quality_gps_score":"Pontua\xe7\xe3o de posicionamento","metadata_quality_resolution_score":"Pontua\xe7\xe3o de resolu\xe7\xe3o","metadata_quality_missing":"nenhum valor definido na imagem","metadata_exif":"EXIF","metadata_exif_name":"Etiqueta","metadata_exif_value":"Valor","semantics_editor_error":"A sintaxe est\xe1 inv\xe1lida. Suas etiquetas podem ficar assim:\\nchave=valor\\nprefixo|chave=valor\\nprefixo|chave[qualif_chave=qualif_val]=valor\\n\\nO comprimento m\xe1ximo da chave \xe9 de 256 caracteres, e o comprimento m\xe1ximo do valor \xe9 de 2048 caracteres.","report":"Denunciar","report_auth":"Este relat\xf3rio ser\xe1 enviado usando sua conta \\"{a}\\"","report_nature_label":"Causa do problema","semantics_qualifiers":"Qualificadores","semantics_show_annotations":"Exibir caracter\xedsticas da imagem","semantics_hide_annotations":"Ocultar caracter\xedsticas da imagem","semantics_add_annotation":"Adicionar uma nova etiqueta","semantics_save_drawn_annotation":"Salvar posi\xe7\xe3o","semantics_undo_drawn_annotation":"Cancelar","semantics_delete_annotation":"Excluir esta caracter\xedstica","semantics_delete_annotation_confirm":"Voc\xea realmente deseja excluir esta etiqueta ?","semantics_hashtags":"Hashtags da imagem","semantics_wikidata_properties":{"P31":"inst\xe2ncia de","P279":"subclasse de","P361":"parte de","P180":"retrata"},"semantics_editor_example":"chave=valor\\nprefixo|chave=valor","semantics_edit":"Editar atributos","semantics_save":"Salvar suas altera\xe7\xf5es","semantics_undo":"Cancelar suas edi\xe7\xf5es","semantics_cantsave_invalid":"N\xe3o \xe9 poss\xedvel salvar as altera\xe7\xf5es, entrada \xe9 inv\xe1lida","semantics_send_ok":"Suas edi\xe7\xf5es foram enviadas com \xeaxito","report_whole_sequence":"Isso diz respeito a toda a sequ\xeancia","report_details":"Detalhes adicionais","report_email":"Seu e-mail","report_email_placeholder":"Opcional","report_submit":"Enviar","report_wait":"Enviando relat\xf3rio\u2026","qualityscore_doc_1":"\xc9 calculada uma pontua\xe7\xe3o de qualidade para cada imagem.","map_theme_score":"Pontua\xe7\xe3o de qualidade","report_success":"O relat\xf3rio foi enviado com sucesso. Ele ser\xe1 analisado assim que poss\xedvel.","report_failure":"Ocorreu um erro ao criar o relat\xf3rio: {e}. Tente novamente mais tarde.","semantics_key_doc":"Saiba mais sobre esta chave","semantics_doc":"Ajuda","semantics_erase_annotation":"Apagar caracter\xedstica desenhada","semantics_doc_title":"Sobre etiquetas","semantics_doc_info1":"D\xea contexto a uma imagem usando etiquetas.","semantics_doc_link":"Saiba mais sobre etiquetas","semantics_doc_info3":"Alguns objetos s\xe3o detectados automaticamente com IA: a qualidade n\xe3o \xe9 garantida.","semantics_doc_info2":"Voc\xea tamb\xe9m pode desenhar objetos na imagem: sinais de tr\xe2nsito, equipamentos urbanos\u2026 Marque o que voc\xea v\xea usando as etiquetas existentes. Voc\xea tamb\xe9m pode criar suas pr\xf3prias etiquetas, se necess\xe1rio.","semantics_picture_tags":"Etiqueta de imagem","semantics_sequence_tags":"Etiqueta de sequ\xeancia","semantics_annotation_tags":"Etiqueta de objeto","filter_gps_precision":"Precis\xe3o de localiza\xe7\xe3o","filter_gps_precision_lessthan":"Menos de {n} metros","filter_gps_precision_between":"Entre {n1} e {n2} metros","filter_gps_precision_morethan":"Mais de {n} metros","map_theme_gps":"Precis\xe3o de localiza\xe7\xe3o","semantics_overlays":{"tfsigns":"Sinais de tr\xe2nsito","features":"Todas as caracter\xedsticas"},"semantics_doc_info1u1":"Voc\xea pode marc\xe1-la como capturada por carro com a etiqueta transport=car.","semantics_zoom_in":"Amplie o mapa para ver as etiquetas","semantics_download":"Baixar","semantics_download_title":"Baixar etiquetas","semantics_download_info":"Todos os dados sem\xe2nticos (etiquetas) est\xe3o dispon\xedveis como dados abertos. Voc\xea pode baix\xe1-los e utiliz\xe1-los livremente.","semantics_download_cta":"Baixar dados abertos","semantics_copy":"Copiar atributos","popup_details_link":"Mais detalhes","qualityscore_doc_5":"Um dispositivo profissional ter\xe1 uma classifica\xe7\xe3o A, uma c\xe2mera de a\xe7\xe3o 360\xb0 ter\xe1 uma classifica\xe7\xe3o B e um smartphone ter\xe1 uma classifica\xe7\xe3o entre C e E.","semantics_value_show_osm":"Ver no OpenStreetMap","filter_gps_precision_help_4":"Um GPS RTK ter\xe1 uma classifica\xe7\xe3o de \u201c5\u2b50\u201d, uma c\xe2mera de a\xe7\xe3o como a GoPro Max ter\xe1 uma classifica\xe7\xe3o de \u201c3\u2b50\u201d e um GPS de smartphone em um estacionamento subterr\xe2neo ter\xe1 uma classifica\xe7\xe3o de \u201c1\u2b50\u201d.","filter_gps_precision_help":"Saiba mais sobre a precis\xe3o da localiza\xe7\xe3o","filter_gps_precision_help_1":"Informa\xe7\xf5es sobre a precis\xe3o da localiza\xe7\xe3o est\xe3o dispon\xedveis para cada foto. Isso corresponde \xe0 precis\xe3o do GPS durante a captura da foto.","filter_gps_precision_help_2":"A precis\xe3o \xe9 expressa com estrelas:","filter_gps_precision_help_3":"\u201c5\u2b50\u201d \xe9 muito preciso (<= {p5}m), \u201c1\u2b50\u201d \xe9 muito impreciso (> {p1}m) ou desconhecido.","qualityscore_doc_4":"Esta pontua\xe7\xe3o \xe9 calculada com base em:","qualityscore_doc_41":"a precis\xe3o do GPS","qualityscore_doc_42":"a resolu\xe7\xe3o da imagem","indoor_selector_expand":"Clique para ver todos os n\xedveis dispon\xedveis","indoor_selector_shrink":"Clique para minimizar","indoor_selector_levelup":"Ir para o n\xedvel superior","indoor_selector_scrollup":"Role a lista de n\xedveis para cima","indoor_selector_scrolldown":"Role a lista de n\xedveis para baixo","indoor_selector_leveldown":"Ir para o n\xedvel inferior","indoor_switch":"Mapas de interiores"},"psv":{"ctrlZoom":"Use ctrl + rolagem para ampliar a imagem","loadError":"O panorama n\xe3o pode ser carregado","twoFingers":"Use dois dedos para navegar"},"maplibre":{"GeolocateControl.LocationNotAvailable":"Localiza\xe7\xe3o n\xe3o dispon\xedvel","GeolocateControl.FindMyLocation":"Encontre minha localiza\xe7\xe3o"},"map":{"thumbnail":"Miniatura da imagem ao passar o cursor","not_public":"N\xe3o vis\xedvel publicamente","slow_loading":"O mapa demora a carregar e pode parecer danificado","map_data":"Mapa baseado em {m}","more_panoramax":"Descubra mais sobre o Panoramax","loading":"Carregando\u2026"}}');
            },
            991: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"Anv\xe4nd tv\xe5 fingrar f\xf6r att panorera","loadError":"Panoramat kan inte laddas","ctrlZoom":"Anv\xe4nd ctrl + scroll f\xf6r att zooma in p\xe5 bilden"},"pnx":{"moveUp":"Flytta upp","zoom":"Zoom","zoomOut":"Zooma ut","zoomIn":"Zooma in","moveDown":"Flytta ner","moveLeft":"Flytta v\xe4nster","moveRight":"Flytta h\xf6ger","moveMiddle":"Centrera vy","expand":"Expandera","show_psv":"Visa bildvisaren","show_map":"Visa kartan","expand_info":"Visa widgeten p\xe5 hela sidan","minimize":"G\xf6m denna flik, du kan visa den igen genom att anv\xe4nda knappen i nedersta v\xe4nstra h\xf6rnet","minimize_short":"G\xf6m","options":"Alternativ","search":"S\xf6k","search_empty":"Inga resultat hittade","filters":"Filter","layers":"Lager","share":"Dela","share_links":"L\xe4nkar","share_page":"L\xe4nka till denna sida","share_image":"HD bild","share_rss":"RSS feed","share_embed":"B\xe4dda in p\xe5 din hemsida","share_embed_docs":"L\xe4s mer om inb\xe4ddad konfiguration","share_print":"Skriv ut","copy":"Kopiera","copied":"Kopierad","error":"Vi har ett problem\u2026","error_click":"Forts\xe4tt","error_retry":"V\xe4nligen f\xf6rs\xf6k igen senare","sequence_next":"N\xe4sta bild i sekvensen","sequence_play":"Spela upp bilder i sekvensen","sequence_pause":"Pausa sekvens","sequence_more":"Mera uppspelningsalternativ","sequence_speed":"Uppspelningshastighet","legend_license":"Licens: {l}","search_address":"S\xf6k en adress, stad\u2026","edit_osm":"Redigera OSM","loading_labels_serious":["\ud83d\uddfa\ufe0f Laddar kartdata","\ud83d\udda5\ufe0f Anropar API","\ud83d\uddbc\ufe0f Laddar miniatyrer","\ud83d\udd0d Analyserar EXIF metadata","\ud83c\udfd8\ufe0f 3D rendering","\ud83d\udcf7 Initialiserar 360\xb0 bilder","\ud83d\udfe0 F\xe4rg balansering","\ud83d\udcaf Ber\xe4kna Kvalitetspo\xe4ng \xa9"],"loading_labels_fun":["\ud83e\udd8c R\xe4knar \xe4lgar","R\xe4knar gula bilar","\u2615 Bunkrar upp med kaffe","Kaj nu simmar du ur bild!","\ud83d\udc08 Delar kattbilder","\ud83d\ude34 Prokastinerar","\ud83e\uded6 Kokar te","\ud83d\udc27 \xd6ppnar k\xe4llkod","\ud83d\ude87 R\xe4knar t\xe5g","\ud83e\uddf9 St\xe4dar upp bland metadata","\ud83d\udc3f\ufe0f R\xe4knar ekorrar","\ud83d\udeb2 R\xe4knar cykelst\xe4ll","\ud83d\ude89 G\xe5r igenom stationer","\ud83d\udef0\ufe0f S\xf6ker satelliter","\ud83e\uddd1\u200d\ud83c\udf73 Lagar k\xf6ttbullar","\ud83e\uddcdSt\xe5r i k\xf6","\ud83e\uddd1\u200d\ud83d\udcbb Fels\xf6ker gr\xe4nsnitt","\ud83d\udcc8 \xd6kar statistik"],"error_psv":"Foto-sf\xe4r visaren laddar inte ordentligt","error_nopic":"Ingen bild finns p\xe5 angiven position","error_api":"Bildservern \xe4r inte tillg\xe4nlig","error_webgl":"WebGL st\xf6ds inte i din webbl\xe4sare","error_api_compatibility":"Bildservern \xe4r inte kompatibel med den h\xe4r visarens version","filter_date":"Datum","filter_date_1month":"1 m\xe5nad","filter_date_1year":"1 \xe5r","filter_user":"Anv\xe4ndare","filter_user_mypics":"Mina bilder","filter_picture":"Bildtyp","filter_zoom_in":"Zooma in f\xf6r att se detta filter","picture_360":"360\xb0","filter_qualityscore_help":"Klicka f\xf6r att sl\xe5 p\xe5 eller av","qualityscore_title":"Om Kvalitetspo\xe4ng","filter_qualityscore":"Kvalitetspo\xe4ng","qualityscore_doc_2":"Kvalitet visas som en skala p\xe5 A/B/C/D/E (A \xe4r b\xe4st, E \xe4r s\xe4mst) och visas grafisk genom skalan:","map_theme_default":"Klassisk","map_theme_age_1":"> 2 \xe5r","map_theme_age_2":"< 2 \xe5r","map_theme_age_3":"< 1 \xe5r","map_theme_age_4":"< 1 m\xe5nad","map_theme_type":"Kameratyp","contrast":"Aktivera h\xf6gre bildkontrast","metadata":"Bildmetadata","metadata_general_picid":"Bild-identifierare","metadata_general_seqid":"Sekvens-identifierare","qualityscore_doc_link":"Mer information om hur Kvalitetspo\xe4ng ber\xe4knas finns i v\xe5r dokumentation.","map_theme_score":"Kvalitetspo\xe4ng","metadata_general_seqid_link":"G\xe5 till JSON beskrivning av sekvensen","metadata_general_author":"Upphovsman","metadata_general_license":"Licens","metadata_general_license_link":"Se full licensbeskrivning","metadata_general_date":"Bild tagen","metadata_camera":"Kamera","metadata_camera_make":"M\xe4rke","metadata_camera_model":"Modell","metadata_camera_type":"Typ","metadata_camera_resolution":"Uppl\xf6sning","metadata_location":"Plats","metadata_location_longitude":"Longitud","metadata_location_latitude":"Latitud","metadata_location_orientation":"Kamerariktning","metadata_location_precision":"Positionsprecision","metadata_quality":"Kvalitetspo\xe4ng","metadata_quality_score":"Global po\xe4ng","metadata_quality_gps_score":"Positioneringspo\xe4ng","metadata_quality_resolution_score":"Uppl\xf6sningspo\xe4ng","metadata_quality_missing":"Inget v\xe4rde satt i bilden","metadata_exif":"EXIF / XMP","metadata_exif_name":"Tag","metadata_exif_value":"V\xe4rde","report":"Rapportera bild","search_user":"S\xf6k anv\xe4ndarnamn\u2026","legend_title":"Visa detaljer f\xf6r bild","report_auth":"Denna rapport kommer skickas genom ditt konto \\"{a}\\"","share_rss_title":"RSS feed av nya sekvensen f\xf6r karta i bild","error_josm":"JOSM svarar inte, k\xf6rs det och \xe4r remote p\xe5slaget?","sequence_prev":"F\xf6reg\xe5ende bild i sekvensen","josm_live":"Aktivera automatisk JOSM synkronisering vid inladdning av bild","metadata_general_picid_link":"G\xe5 till JSON beskrivning av bilden","metadata_quality_help":"L\xe4s mer om Kvalitetspo\xe4ng","error_pic":"Beg\xe4rd bild hittades inte","qualityscore_doc_3":"Det r\xe4knas ut baserat p\xe5 GPS precision och bildens uppl\xf6sning. Ett profesionellt system kommer ha A-kvalit\xe9, en 360\xb0 actionkamera kommer ha B-kvalit\xe9 och en telefon kommer ha C/D/E-kvalit\xe9.","qualityscore_doc_1":"Panoramax erbjuder en Kvalitetspo\xe4ng f\xf6r varje bild. Det m\xf6jlig\xf6r enkel kartfiltrering och en omfattande uppvisning av tillg\xe4nligheten av bilder av h\xf6g kvalitet.","metadata_camera_focal_length":"Br\xe4nnvidd","picture_flat":"Klassisk","map_background":"Kartbakgrund","map_background_aerial":"Sattelit","map_background_streets":"Gator","map_theme":"Karttema","map_theme_age":"Fotodatum","report_nature_label":"Typ av problem","report_nature":{"":"V\xe4lj typen av problem\u2026","blur_missing":"En persons ansikte eller en registreringspl\xe5t \xe4r synlig","blur_excess":"Ett objekt som inte beh\xf6ver suddas \xe4r suddad","inappropriate":"Bilden \xe4r ol\xe4mplig(orelaterat, nakenhet...)","privacy":"En privat v\xe4g eller fastighet \xe4r synlig","picture_low_quality":"Bilden \xe4r av mycket d\xe5lig kvalitet","mislocated":"Bilden \xe4r placerat d\xe5lig p\xe5 kartan","copyright":"Bilden inkr\xe4nker p\xe5 upphovsr\xe4tt","other":"N\xe5got annat typ av problem"},"report_whole_sequence":"Detta g\xe4ller hela sekvensen","report_details":"Ytterligare detaljer","report_details_placeholder":"Valfritt, kan du l\xe4gga till information om problemet och varf\xf6r det \xe4r ett problem","report_email":"Din e-post","report_email_placeholder":"Valfri","report_submit":"Skicka","report_wait":"Skickar rapport \u2026","report_success":"Rapporten har skickats. Det kommer att ses \xf6ver s\xe5 snart som m\xf6jligt.","report_failure":"Ett fel uppstod n\xe4r rapporten skapades: {e}. F\xf6rs\xf6k igen senare."},"maplibre":{"GeolocateControl.FindMyLocation":"Hitta min postion","GeolocateControl.LocationNotAvailable":"Plats inte tillg\xe4nlig"},"map":{"loading":"Laddar\u2026","thumbnail":"Miniatyrbild av r\xf6rd bild","not_public":"Inte offentligt synligt","slow_loading":"Kartan laddas l\xe5ngsamt och kan verka trasig"}}');
            },
            7304: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"Gezinmek i\xe7in iki parma\u011f\u0131n\u0131z\u0131 kullan\u0131n","loadError":"Panorama y\xfcklenemedi","ctrlZoom":"G\xf6r\xfcnt\xfcy\xfc yak\u0131nla\u015ft\u0131rmak i\xe7in ctrl + kayd\u0131rma tu\u015flar\u0131n\u0131 kullan\u0131n"},"pnx":{"search_empty":"Sonu\xe7 bulunamad\u0131","zoom":"Yak\u0131nla\u015ft\u0131r","zoomIn":"Yak\u0131nla\u015ft\u0131r","expand":"Geni\u015flet","layers":"Katmanlar","search":"Ara","minimize_short":"Gizle","share_links":"Ba\u011flant\u0131lar","share_embed_docs":"G\xf6mme yap\u0131land\u0131rmas\u0131 hakk\u0131nda daha fazla bilgi edinin","share_print":"Yazd\u0131r","panoramax":"Panoramax","copied":"Kopyaland\u0131","error_click":"Devam et","sequence_pause":"Sekans duraklat","legend_title":"Resim detaylar\u0131n\u0131 g\xf6r\xfcnt\xfcle","contribute_id":"iD edit\xf6r ile OpenStreetMap\'e katk\u0131da bulunun","josm":"JOSM","loading_labels_serious":["\ud83d\uddfa\ufe0f Harita verisi y\xfckleniyor","\ud83d\udda5\ufe0f API sorgulan\u0131yor","\ud83d\uddbc\ufe0f K\xfc\xe7\xfck resimler y\xfckleniyor","\ud83d\udd0d EXIF meta verileri analiz ediliyor","\ud83c\udfd8\ufe0f 3D i\u015fleniyor","\ud83d\udcf7 360\xb0 resimler ba\u015flat\u0131l\u0131yor","\ud83d\udfe0 Renk dengeleme","\ud83d\udcaf Kalite Skoru Hesaplan\u0131yor \xa9","\ud83d\udce1 G\xfcncellemeler indiriliyor","\ud83c\udf0d Harita d\xf6\u015femeleri getiriliyor","\ud83d\udcf8 G\xf6lgeler i\u015fleniyor"],"metadata_general_license":"Lisans","metadata_general_picid":"Resim","metadata_general_seqid":"Sekans","metadata_general_seqid_link":"Sekans\u0131n JSON a\xe7\u0131klamas\u0131na git","metadata_camera_model":"Model","metadata_location":"Pozisyon","metadata_exif":"EXIF","metadata_exif_name":"Etiket","metadata_exif_value":"De\u011fer","semantics_title":"Etiketler","share_embed":"Web sitenize yerle\u015ftirin","sequence_speed":"Oynat\u0131c\u0131 h\u0131z\u0131","metadata_summary":"\xd6zet","metadata_general_license_link":"Lisans\u0131n tam a\xe7\u0131klamas\u0131n\u0131 g\xf6r\xfcn","metadata_quality":"Kalite","zoomOut":"Uzakla\u015ft\u0131r","share":"Payla\u015f","share_image":"HD Resim","copy":"Kopyala","error_retry":"L\xfctfen daha sonra tekrar deneyin","show_map":"Haritay\u0131 g\xf6r\xfcnt\xfcle","metadata":"Resim meta verisi","metadata_general_picid_link":"Resmin JSON a\xe7\u0131klamas\u0131na git","metadata_camera_type":"Tip","metadata_camera_resolution":"\xc7\xf6z\xfcn\xfcrl\xfck","metadata_quality_resolution_score":"\xc7\xf6z\xfcn\xfcrl\xfck skoru","metadata_camera":"Kamera","report_wait":"Rapor g\xf6nderiliyor\u2026","semantics_show_all_tags":"T\xfcm etiketleri g\xf6r\xfcnt\xfcle","semantics_hide_all_tags":"T\xfcm etiketleri gizle","semantics_value":"De\u011fer","semantics_delete_annotation":"\xd6zelli\u011fi sil","semantics_annotation_tooltip":"Detaylar\u0131 g\xf6r\xfcnt\xfclemek i\xe7in t\u0131klay\u0131n","semantics_tags_picture":"Resim etiketleri","semantics_delete_annotation_confirm":"Etiketi ger\xe7ekten silmek istiyor musunuz?","semantics_save":"De\u011fi\u015fiklikleri kaydet","minimize":"Bu widget\'\u0131 gizleyin, sol alt k\xf6\u015fedeki d\xfc\u011fmeyi kullanarak tekrar g\xf6sterebilirsiniz","moveUp":"Yukar\u0131 hareket et","moveDown":"A\u015fa\u011f\u0131 hareket et","moveLeft":"Sola hareket et","moveRight":"Sa\u011fa hareket et","moveMiddle":"Merkez g\xf6r\xfcn\xfcm","expand_info":"Widget\'\u0131n tam sayfada g\xf6r\xfcnmesini sa\u011fla","show_psv":"Resim g\xf6r\xfcnt\xfcleyiciyi g\xf6ster","options":"Se\xe7enekler","filters":"Filtreler","report_nature":{"picture_low_quality":"G\xf6r\xfcnt\xfc kalitesi d\xfc\u015f\xfck","other":"Ba\u015fka herhangi bir sorun","":"Sorunun niteli\u011fini se\xe7in\u2026","mislocated":"Resim haritada k\xf6t\xfc konumland\u0131r\u0131lm\u0131\u015f","copyright":"Resim telif hakk\u0131n\u0131 ihlal ediyor","blur_missing":"Bir ki\u015finin y\xfcz\xfc veya ara\xe7 plakas\u0131 g\xf6r\xfcn\xfcyor","blur_excess":"Bir nesneye gereksiz bir bulan\u0131kl\u0131k uyguland\u0131","inappropriate":"Resim uygunsuz (ilgisiz, \xe7\u0131plakl\u0131k\u2026)","privacy":"\xd6zel bir yol veya m\xfclk g\xf6r\xfcn\xfcyor"},"map_background_streets":"Sokaklar","contrast":"Daha y\xfcksek g\xf6r\xfcnt\xfc kontrast\u0131n\u0131 etkinle\u015ftirin","search_address":"Bir adres ya da \u015fehir aray\u0131n\u2026","search_user":"Bir kullan\u0131c\u0131 ad\u0131 aray\u0131n\u2026","share_page":"Resim ba\u011flant\u0131s\u0131","share_rss":"RSS beslemesi","share_rss_title":"\u015eu anda g\xf6r\xfcnen harita alan\u0131ndaki yeni sekanslar\u0131n RSS beslemesi","whats_panoramax":"Panoramax, b\xf6lgelerin resimlerinin co\u011frafi ortak alan\u0131d\u0131r.","error":"Bir sorunumuz var\u2026","sequence_next":"S\u0131radaki resim","sequence_play":"Bu sekans\u0131 izleyin","sequence_prev":"\xd6nceki resim","sequence_more":"Daha fazla oynatma se\xe7ene\u011fi","legend_license":"Lisans: {l}","id":"iD","geo_uri":"Harici uygulama","josm_live":"Resim y\xfcklenirken JOSM otomatik senkronizasyonunu etkinle\u015ftir","loading_labels_fun":["\ud83e\udd8c Geyik ge\xe7i\u015f i\u015faretlerini tespit etme","\ud83d\ude98 Panoramax Arac\u0131n\u0131 Bul \xa9","\u2615 Kafein enjekte ediliyor","\ud83d\ude00 G\xfcl\xfcmse, haritaland\u0131n!","\ud83d\udc08Kedi resimleri payla\u015f\u0131n","\ud83d\ude34 Ertelemeyi azalt","\ud83e\uded6 \xc7ay demle","\ud83d\udc27 Kaynak kodunu a\xe7","\ud83d\ude87 Yeralt\u0131 istasyonlar\u0131n\u0131n indeksleniyor","\ud83e\uddf9 Meta veri temizleme","\ud83d\ude92 \u0130tfaiye istasyonu resimleri g\xf6nderiliyor","\ud83d\udeb2Ye\u015fil yollar g\xfcncelleniyor","\ud83d\ude89 \u0130stasyon platformu turu","\ud83d\udef0\ufe0f Uydular Aran\u0131yor","\ud83d\udc65 Ki\u015filikler yaz\u0131l\u0131yor","\ud83d\udc1f Bal\u0131k ve patates k\u0131zartmas\u0131 d\xfckkanlar\u0131 bulunuyor","\ud83e\uddd1\u200d\ud83d\udcbb Hata ay\u0131klama aray\xfcz\xfc","\ud83d\udcc8 \u0130statistikler artt\u0131r\u0131l\u0131yor","\ud83e\udd16 Anlam bilimi \xf6\u011freniliyor","\ud83c\udfa8 Aray\xfcz yeniden tasarlan\u0131yor","\ud83d\udcc5 Foto\u011fraf haritalama partileri planla","\ud83e\uddc0 Olgunla\u015fan \xe7edarlar","\ud83c\udf04 Cornwall g\xfcne\u015f \u0131\u015f\u0131\u011f\u0131n\u0131n hesaplanmas\u0131","\ud83c\udf0a Y\xfcksek gelgitlerin \xf6l\xe7\xfcm\xfc"],"error_pic":"\u0130stenen resim bulunamad\u0131","error_nopic":"Belirtilen konumda resim mevcut de\u011fil","error_api":"Resim sunucusu kullan\u0131lam\u0131yor","error_webgl":"Taray\u0131c\u0131n\u0131z WebGL\'yi desteklemiyor","error_josm":"JOSM yan\u0131t vermiyor, \xe7al\u0131\u015f\u0131yor mu ve uzaktan eri\u015fim etkin mi?","error_api_compatibility":"Resim sunucusu bu g\xf6r\xfcnt\xfcleyici s\xfcr\xfcm\xfcyle uyumlu de\u011fil","filter_date":"Tarih","filter_date_1month":"1 ay","filter_date_6months":"6 ay","filter_date_1year":"1 y\u0131l","filter_user":"Kullan\u0131c\u0131","filter_user_mypics":"Resimlerim","filter_picture":"Resim tipi","filter_zoom_in":"Bu filtreyi g\xf6rmek i\xe7in haritay\u0131 yak\u0131nla\u015ft\u0131r\u0131n","picture_all":"T\xfcm\xfc","picture_flat":"Klasik","picture_360":"360\xb0","picture_flat_long":"Klasik resim","filter_qualityscore_help":"Etkinle\u015ftirmek veya devre d\u0131\u015f\u0131 b\u0131rakmak i\xe7in t\u0131klay\u0131n","qualityscore_title":"Kalite skoru hakk\u0131nda","qualityscore_doc_link":"Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin","map_background":"Harita arkaplan\u0131","map_theme":"Harita temas\u0131","map_theme_default":"Klasik","map_theme_age":"Yakalama tarihi","map_theme_age_1":"> 2 y\u0131l","map_theme_age_2":"< 2 y\u0131l","map_theme_age_4":"< 1 ay","map_theme_type":"Kamera tipi","map_theme_score":"Kalite skoru","metadata_general_copy_id":"ID Kopyala","metadata_general_copy_picid":"Resim ID kopyala","metadata_general_author":"Yazar","metadata_general_date":"Yakalama tarihi","metadata_general_instance":"K\xf6ken \xf6rne\u011fi","metadata_camera_focal_length":"Odak uzakl\u0131\u011f\u0131","metadata_location_orientation":"Y\xf6n","metadata_location_copy":"Kopyala {v}","metadata_location_precision":"Konumland\u0131rma hassasiyeti","metadata_quality_help":"Kalite Puan\u0131 hakk\u0131nda daha fazla bilgi edinin","metadata_quality_score":"K\xfcresel skor","metadata_quality_gps_score":"Pozisyon skoru","metadata_quality_missing":"resimde herhangi bir de\u011fer belirtilmemi\u015f","metadata_exif_doc":"EXIF etiketleri i\xe7in belgeler","semantics_tags":"{nb} etiketler","semantics_features":"Resim \xf6zellikleri","semantics_features_none":"Bu resimde hen\xfcz hi\xe7bir \xf6zellik \xe7izilmedi.","semantics_features_default_title":"Etiket {nb}","semantics_value_doc":"Bu etiket hakk\u0131nda daha fazla bilgi edinin","semantics_features_subtitle":"{nb} ili\u015fkili \xf6zellikler","semantics_key":"Anahtar","semantics_key_doc":"Bu anahtar hakk\u0131nda daha fazla bilgi edinin","semantics_qualifiers":"Niteleyiciler","semantics_draw_annotation":"Resmin \xfczerine eklemek istedi\u011finiz nesneyi \xe7izebilirsiniz (Opsiyonel).","semantics_login_needed":"Resim etiketlerini veya \xf6zelliklerini d\xfczenlemek i\xe7in Panoramax {n} \xf6rne\u011finde oturum a\xe7man\u0131z gerekir. Oturum a\xe7mak istiyor musunuz?","report_email_placeholder":"\u0130ste\u011fe ba\u011fl\u0131","semantics_add_annotation":"Yeni bir etiket ekle","semantics_erase_annotation":"\xc7izilmi\u015f \xf6zelli\u011fi sil","semantics_doc":"Yard\u0131m","semantics_doc_title":"Etiketler hakk\u0131nda","semantics_show_annotations":"Resim \xf6zelliklerini g\xf6r\xfcnt\xfcle","semantics_hide_annotations":"Resim \xf6zelliklerini gizle","semantics_zero_annotations":"Bu resimde hi\xe7bir \xf6zellik \xe7izilmedi","report":"Rapor et","report_auth":"Bu rapor \\"{a}\\" hesab\u0131n\u0131z kullan\u0131larak g\xf6nderilecektir","report_nature_label":"Sorunun nedeni","semantics_doc_info3":"Baz\u0131 nesneler yapay zeka ile otomatik olarak alg\u0131lan\u0131yor: kalite garanti edilmiyor.","semantics_doc_link":"Etiketler hakk\u0131nda daha fazla bilgi edinin","report_whole_sequence":"Bu t\xfcm sekans\u0131 ilgilendiriyor","report_details":"Ek ayr\u0131nt\u0131lar","report_details_placeholder":"\u0130ste\u011fe ba\u011fl\u0131 olarak sorunla ilgili ayr\u0131nt\u0131lar\u0131 ekleyebilirsiniz","report_email":"Eposta adresin","metadata_exif_doc_title":"EXIF ve XMP etiket tan\u0131mlar\u0131 hakk\u0131nda tam ayr\u0131nt\u0131lar i\xe7in Exiv2 belgelerine gidin","report_failure":"{e} raporu olu\u015fturulurken bir hata olu\u015ftu. L\xfctfen daha sonra tekrar deneyin.","error_psv":"Foto\u011fraf K\xfcresi G\xf6r\xfcnt\xfcleyicisi d\xfczg\xfcn y\xfcklenmiyor","picture_360_long":"Panoramic resim","report_success":"Rapor ba\u015far\u0131yla g\xf6nderildi. En k\u0131sa s\xfcrede incelenecektir.","filter_qualityscore":"Kalite skoru","map_theme_age_3":"< 1 y\u0131l","metadata_location_coordinates":"Koordinatlar (boylam, enlem)","semantics_doc_info2":"Resimdeki nesneleri de \xe7izebilirsiniz: yol i\u015faretleri, \u015fehir ekipmanlar\u0131... G\xf6rd\xfcklerinizi mevcut etiketleri kullanarak i\u015faretleyin. Gerekirse kendi etiketlerinizi de olu\u015fturabilirsiniz.","map_background_aerial":"Havadan","qualityscore_doc_3":"\\"A\\" en iyi not, \\"E\\" en k\xf6t\xfc nottur.","metadata_location_copy_more":"Daha fazla koordinat kopyalama se\xe7ene\u011fi","report_submit":"G\xf6nder","qualityscore_doc_2":"Puan, harf olarak g\xf6sterilir:","semantics_doc_info1":"Etiketler kullanarak bir resme ba\u011flam kazand\u0131r\u0131n.","qualityscore_doc_1":"Her resim i\xe7in bir Kalite Puan\u0131 hesaplan\u0131r.","metadata_camera_make":"Olu\u015ftur","semantics_wikidata_properties":{"P31":"\xf6rne\u011fi","P279":"alt s\u0131n\u0131f\u0131","P361":"par\xe7as\u0131","P180":"tasvir eder"},"semantics_editor_error":"S\xf6zdizimi ge\xe7ersiz. Etiketleriniz \u015f\xf6yle g\xf6r\xfcnebilir:\\nkey=value\\nprefix|key=value\\nprefix|key[qualif_key=qualif_val]=value\\n\\nMaksimum anahtar uzunlu\u011fu 256 karakter, maksimum de\u011fer uzunlu\u011fu 2048 karakterdir.","semantics_send_fail":"De\u011fi\u015fiklikleriniz kaydedilemedi, l\xfctfen daha sonra tekrar deneyin","semantics_editor_example":"key=value\\nprefix|key=value","semantics_edit":"Nitelikleri d\xfczenle","semantics_undo":"D\xfczenlemelerinizi iptal edin","semantics_sequence_tags":"Sekans etiketi","semantics_picture_tags":"Resim etiketi","semantics_annotation_tags":"Nesne etiketi","filter_gps_precision_lessthan":"{n} metreden az","filter_gps_precision_morethan":"{n} metreden fazla","filter_gps_precision":"Konum hassasiyeti","filter_gps_precision_between":"{n1} ile {n2} metre aras\u0131nda","map_theme_gps":"Konum hassasiyeti","semantics_overlays":{"tfsigns":"Trafik i\u015faretleri","features":"T\xfcm \xf6zellikler"},"semantics_download":"\u0130ndir","semantics_doc_info1u1":"\\"transport=car\\" etiketini kullanarak, foto\u011fraf\u0131n ara\xe7 taraf\u0131ndan \xe7ekildi\u011fini belirtebilirsiniz.","semantics_zoom_in":"Etiketleri g\xf6rmek i\xe7in haritay\u0131 yak\u0131nla\u015ft\u0131r\u0131n.","semantics_download_title":"Etiketleri indir","semantics_download_cta":"A\xe7\u0131k verileri indirin","semantics_download_info":"T\xfcm donn\xe9es semantiques (etiketler) a\xe7\u0131k veride kullan\u0131labilir. \u0130ndirebilir ve \xf6zg\xfcrce kullanabilirsiniz.","semantics_copy":"\xd6zellikleri kopyala","semantics_value_show_osm":"OpenStreetMap\'te g\xf6r\xfcnt\xfcle","filter_gps_precision_help":"Konum hassasiyeti hakk\u0131nda daha fazla bilgi edinin","filter_gps_precision_help_1":"Her foto\u011fraf i\xe7in konum hassasiyeti bilgisi mevcuttur. Bu bilgi, foto\u011fraf \xe7ekimi s\u0131ras\u0131nda GPS hassasiyetine kar\u015f\u0131l\u0131k gelir.","filter_gps_precision_help_2":"Hassasiyet y\u0131ld\u0131zlarla ifade edilir:","filter_gps_precision_help_3":"\\"5\u2b50\\" \xe7ok hassast\u0131r (<= {p5}m), \\"1\u2b50\\" ise \xe7ok belirsizdir (> {p1}m) veya bilinmemektedir.","qualityscore_doc_4":"Bu puan a\u015fa\u011f\u0131daki kriterlere g\xf6re hesaplan\u0131r:","qualityscore_doc_41":"GPS hassasiyeti","qualityscore_doc_42":"resim \xe7\xf6z\xfcn\xfcrl\xfc\u011f\xfc","qualityscore_doc_5":"Profesyonel bir cihaz A s\u0131n\u0131f\u0131, 360\xb0 aksiyon kameras\u0131 B s\u0131n\u0131f\u0131, ak\u0131ll\u0131 telefon ise C ile E aras\u0131nda bir s\u0131n\u0131fa sahip olacakt\u0131r.","filter_gps_precision_help_4":"RTK GPS cihazlar\u0131 \\"5\u2b50\\" puan al\u0131rken, GoPro Max gibi aksiyon kameralar\u0131 \\"3\u2b50\\" puan, yer alt\u0131 otopark\u0131ndaki ak\u0131ll\u0131 telefon GPS\'leri ise \\"1\u2b50\\" puan alacakt\u0131r.","popup_details_link":"Daha fazla detay","indoor_selector_shrink":"K\xfc\xe7\xfcltmek i\xe7in t\u0131klay\u0131n","indoor_selector_leveldown":"Alt kata inin","indoor_selector_scrollup":"Seviye listesini yukar\u0131 kayd\u0131r\u0131n","indoor_selector_scrolldown":"Seviye listesini a\u015fa\u011f\u0131 kayd\u0131r\u0131n","indoor_switch":"\u0130\xe7 mekan haritalar\u0131","indoor_selector_expand":"Mevcut t\xfcm seviyeleri g\xf6rmek i\xe7in t\u0131klay\u0131n","indoor_selector_levelup":"\xdcst kata \xe7\u0131k\u0131n"},"maplibre":{"GeolocateControl.FindMyLocation":"Konumu bul","GeolocateControl.LocationNotAvailable":"Lokasyon mevcut de\u011fil"},"map":{"thumbnail":"\xdczerine gelinen k\xfc\xe7\xfck resim","not_public":"Kamuya a\xe7\u0131k de\u011fil","slow_loading":"Haritan\u0131n y\xfcklenmesi yava\u015f ve bozuk g\xf6r\xfcnebilir","map_data":"{m} temelli harita","loading":"Y\xfckleniyor\u2026","more_panoramax":"Panoramax hakk\u0131nda daha fazla bilgi edinin"}}');
            },
            8230: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"psv":{"twoFingers":"\u0412\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0439\u0442\u0435 \u0434\u0432\u0430 \u043f\u0430\u043b\u044c\u0446\u0456 \u0434\u043b\u044f \u043d\u0430\u0432\u0456\u0433\u0430\u0446\u0456\u0457","ctrlZoom":"\u0412\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u0439\u0442\u0435 \u043a\u043e\u043c\u0431\u0456\u043d\u0430\u0446\u0456\u044e \u043a\u043b\u0430\u0432\u0456\u0448 Ctrl + \u043f\u0440\u043e\u043a\u0440\u0443\u0442\u043a\u0430, \u0449\u043e\u0431 \u0437\u0431\u0456\u043b\u044c\u0448\u0438\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","loadError":"\u041f\u0430\u043d\u043e\u0440\u0430\u043c\u0430 \u043d\u0435 \u043c\u043e\u0436\u0435 \u0431\u0443\u0442\u0438 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u0430"},"maplibre":{"GeolocateControl.FindMyLocation":"\u0417\u043d\u0430\u0439\u0442\u0438 \u043c\u043e\u0454 \u043c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f","GeolocateControl.LocationNotAvailable":"\u041c\u0456\u0441\u0446\u0435\u0437\u043d\u0430\u0445\u043e\u0434\u0436\u0435\u043d\u043d\u044f \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0435"},"pnx":{"zoomOut":"\u0417\u043c\u0435\u043d\u0448\u0438\u0442\u0438","zoom":"\u041c\u0430\u0441\u0448\u0442\u0430\u0431\u0443\u0432\u0430\u043d\u043d\u044f","zoomIn":"\u0417\u0431\u0456\u043b\u044c\u0448\u0438\u0442\u0438","moveDown":"\u041f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u043d\u0438\u0437","moveLeft":"\u0420\u0443\u0445\u0430\u0442\u0438\u0441\u044f \u043b\u0456\u0432\u043e\u0440\u0443\u0447","moveUp":"\u041f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0438\u0442\u0438 \u0432\u0433\u043e\u0440\u0443","moveMiddle":"\u0426\u0435\u043d\u0442\u0440\u0430\u043b\u044c\u043d\u0438\u0439 \u0432\u0438\u0434","moveRight":"\u041f\u0435\u0440\u0435\u043c\u0456\u0441\u0442\u0438\u0442\u0438\u0441\u044f \u0432\u043f\u0440\u0430\u0432\u043e","expand":"\u0420\u043e\u0437\u0433\u043e\u0440\u043d\u0443\u0442\u0438","show_psv":"\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u0434\u0430\u0447 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c","show_map":"\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u043a\u0430\u0440\u0442\u0443","minimize":"\u0421\u0445\u043e\u0432\u0430\u0442\u0438 \u0446\u0435\u0439 \u0432\u0456\u0434\u0436\u0435\u0442, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0439\u043e\u0433\u043e \u0437\u043d\u043e\u0432\u0443 \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u043a\u043d\u043e\u043f\u043a\u0438 \u0432 \u043d\u0438\u0436\u043d\u044c\u043e\u043c\u0443 \u043b\u0456\u0432\u043e\u043c\u0443 \u043a\u0443\u0442\u0456","minimize_short":"\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438","options":"\u041e\u043f\u0446\u0456\u0457","filters":"\u0424\u0456\u043b\u044c\u0442\u0440\u0438","layers":"\u0428\u0430\u0440\u0438","search":"\u041f\u043e\u0448\u0443\u043a","search_empty":"\u0420\u0435\u0437\u0443\u043b\u044c\u0442\u0430\u0442\u0438 \u043d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u0456","search_user":"\u041f\u043e\u0448\u0443\u043a \u0456\u043c\u0435\u043d\u0456 \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u2026","share_links":"\u041b\u0456\u043d\u043a\u0438","share_image":"HD-\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","share_rss":"RSS-\u043a\u0430\u043d\u0430\u043b","share_embed":"\u0412\u0431\u0443\u0434\u0443\u0432\u0430\u0442\u0438 \u043d\u0430 \u0441\u0432\u0456\u0439 \u0432\u0435\u0431-\u0441\u0430\u0439\u0442","share_embed_docs":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u043a\u043e\u043d\u0444\u0456\u0433\u0443\u0440\u0430\u0446\u0456\u044e \u0432\u0431\u0443\u0434\u043e\u0432\u0443\u0432\u0430\u043d\u043d\u044f","share_print":"\u0414\u0440\u0443\u043a","panoramax":"Panoramax","copy":"\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438","copied":"\u0421\u043a\u043e\u043f\u0456\u0439\u043e\u0432\u0430\u043d\u043e","error":"\u0423 \u043d\u0430\u0441 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0430\u2026","error_click":"\u041f\u0440\u043e\u0434\u043e\u0432\u0436\u0438\u0442\u0438","error_retry":"\u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043f\u0456\u0437\u043d\u0456\u0448\u0435","sequence_play":"\u0412\u0456\u0434\u0442\u0432\u043e\u0440\u0456\u0442\u044c \u0446\u044e \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u0456\u0441\u0442\u044c","sequence_pause":"\u041f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u0456\u0441\u0442\u044c \u043f\u0430\u0443\u0437","sequence_prev":"\u041f\u043e\u043f\u0435\u0440\u0435\u0434\u043d\u0454 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0432 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0456","sequence_more":"\u0411\u0456\u043b\u044c\u0448\u0435 \u0432\u0430\u0440\u0456\u0430\u043d\u0442\u0456\u0432 \u0433\u0440\u0438","legend_license":"\u041b\u0456\u0446\u0435\u043d\u0437\u0456\u044f: {l}","legend_title":"\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043b\u0456 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","id":"iD","geo_uri":"\u0417\u043e\u0432\u043d\u0456\u0448\u043d\u044f \u043f\u0440\u043e\u0433\u0440\u0430\u043c\u0430","josm":"JOSM","loading_labels_serious":["\ud83d\uddfa\ufe0f \u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u0434\u0430\u043d\u0438\u0445 \u043a\u0430\u0440\u0442\u0438","\ud83d\udda5\ufe0f \u0417\u0430\u043f\u0438\u0442 API","\ud83d\uddbc\ufe0f \u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u043c\u0456\u043d\u0456\u0430\u0442\u044e\u0440","\ud83d\udd0d \u0410\u043d\u0430\u043b\u0456\u0437 \u043c\u0435\u0442\u0430\u0434\u0430\u043d\u0438\u0445 EXIF","\ud83c\udfd8\ufe0f 3D-\u0432\u0456\u0437\u0443\u0430\u043b\u0456\u0437\u0430\u0446\u0456\u044f","\ud83d\udcf7 \u0406\u043d\u0456\u0446\u0456\u0430\u043b\u0456\u0437\u0430\u0446\u0456\u044f 360\xb0-\u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c","\ud83d\udfe0 \u0411\u0430\u043b\u0430\u043d\u0441\u0443\u0432\u0430\u043d\u043d\u044f \u043a\u043e\u043b\u044c\u043e\u0440\u0456\u0432","\ud83d\udcaf \u041e\u0431\u0447\u0438\u0441\u043b\u0435\u043d\u043d\u044f \u043f\u043e\u043a\u0430\u0437\u043d\u0438\u043a\u0430 \u044f\u043a\u043e\u0441\u0442\u0456 \xa9","\ud83d\udce1 \u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u043e\u043d\u043e\u0432\u043b\u0435\u043d\u044c","\ud83c\udf0d \u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u0444\u0440\u0430\u0433\u043c\u0435\u043d\u0442\u0456\u0432 \u043a\u0430\u0440\u0442\u0438","\ud83d\udcf8 \u041e\u0431\u0440\u043e\u0431\u043a\u0430 \u0442\u0456\u043d\u0435\u0439"],"expand_info":"\u0417\u0440\u043e\u0431\u0438\u0442\u0438 \u0432\u0456\u0434\u0436\u0435\u0442 \u0432\u0438\u0434\u0438\u043c\u0438\u043c \u043d\u0430 \u0432\u0441\u0456\u0439 \u0441\u0442\u043e\u0440\u0456\u043d\u0446\u0456","search_address":"\u041f\u043e\u0448\u0443\u043a \u0437\u0430 \u0430\u0434\u0440\u0435\u0441\u043e\u044e, \u043c\u0456\u0441\u0442\u043e\u043c\u2026","sequence_speed":"\u0428\u0432\u0438\u0434\u043a\u0456\u0441\u0442\u044c \u0433\u0440\u0430\u0432\u0446\u044f","share_rss_title":"RSS-\u043a\u0430\u043d\u0430\u043b \u043d\u043e\u0432\u0438\u0445 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0435\u0439 \u0443 \u043f\u043e\u0442\u043e\u0447\u043d\u0456\u0439 \u0432\u0438\u0434\u0438\u043c\u0456\u0439 \u043e\u0431\u043b\u0430\u0441\u0442\u0456 \u043a\u0430\u0440\u0442\u0438","whats_panoramax":"Panoramax \u2014 \u0446\u0435 \u0433\u0435\u043e\u0433\u0440\u0430\u0444\u0456\u0447\u043d\u0430 \u0431\u0430\u0437\u0430 \u0434\u0430\u043d\u0438\u0445 \u0434\u043b\u044f \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c \u0442\u0435\u0440\u0438\u0442\u043e\u0440\u0456\u0439.","share":"\u041f\u043e\u0434\u0456\u043b\u0438\u0442\u0438\u0441\u044f","share_page":"\u041f\u043e\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u043d\u0430 \u0446\u044e \u043a\u0430\u0440\u0442\u0438\u043d\u043a\u0443","sequence_next":"\u041d\u0430\u0441\u0442\u0443\u043f\u043d\u0435 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0432 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0456","contribute_id":"\u0414\u043e\u043b\u0443\u0447\u0456\u0442\u044c\u0441\u044f \u0434\u043e OpenStreetMap \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0440\u0435\u0434\u0430\u043a\u0442\u043e\u0440\u0430 iD","josm_live":"\u0423\u0432\u0456\u043c\u043a\u043d\u0443\u0442\u0438 \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0447\u043d\u0443 \u0441\u0438\u043d\u0445\u0440\u043e\u043d\u0456\u0437\u0430\u0446\u0456\u044e JOSM \u043f\u0456\u0434 \u0447\u0430\u0441 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c","loading_labels_fun":["\ud83e\udd8c \u0412\u0438\u044f\u0432\u043b\u0435\u043d\u043d\u044f \u0437\u043d\u0430\u043a\u0456\u0432 \u043f\u0435\u0440\u0435\u0445\u043e\u0434\u0443 \u0434\u043b\u044f \u043e\u043b\u0435\u043d\u0456\u0432","\ud83d\ude98 \u041f\u043e\u0448\u0443\u043a \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0456\u043b\u044f Panoramax \xa9","\u2615 \u0406\u043d\'\u0454\u043a\u0446\u0456\u0457 \u043a\u043e\u0444\u0435\u0457\u043d\u0443","\ud83d\ude00 \u041f\u043e\u0441\u043c\u0456\u0445\u043d\u0438\u0441\u044f, \u0442\u0438 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456!","\ud83d\udc08 \u0414\u0456\u043b\u044e\u0441\u044f \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u044f\u043c\u0438 \u043a\u043e\u0442\u0456\u0432","\ud83d\ude34 \u0417\u043c\u0435\u043d\u0448\u0435\u043d\u043d\u044f \u043f\u0440\u043e\u043a\u0440\u0430\u0441\u0442\u0438\u043d\u0430\u0446\u0456\u0457","\ud83e\uded6 \u0417\u0430\u0432\u0430\u0440\u044e\u0432\u0430\u043d\u043d\u044f \u0447\u0430\u044e","\ud83d\udc27 \u0412\u0456\u0434\u043a\u0440\u0438\u0442\u0442\u044f \u0432\u0438\u0445\u0456\u0434\u043d\u043e\u0433\u043e \u043a\u043e\u0434\u0443","\ud83d\ude87 \u0406\u043d\u0434\u0435\u043a\u0441\u0443\u0432\u0430\u043d\u043d\u044f \u0441\u0442\u0430\u043d\u0446\u0456\u0439 \u043c\u0435\u0442\u0440\u043e","\ud83e\uddf9 \u041e\u0447\u0438\u0449\u0435\u043d\u043d\u044f \u043c\u0435\u0442\u0430\u0434\u0430\u043d\u0438\u0445","\ud83d\ude92 \u041d\u0430\u0434\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u0439 \u043f\u043e\u0436\u0435\u0436\u043d\u043e\u0457 \u0441\u0442\u0430\u043d\u0446\u0456\u0457","\ud83d\udeb2 \u041e\u043d\u043e\u0432\u043b\u0435\u043d\u043d\u044f \u0437\u0435\u043b\u0435\u043d\u0438\u0445 \u0441\u0442\u0435\u0436\u043e\u043a","\ud83d\ude89 \u041e\u0433\u043b\u044f\u0434 \u043f\u043b\u0430\u0442\u0444\u043e\u0440\u043c\u0438 \u0441\u0442\u0430\u043d\u0446\u0456\u0457","\ud83d\udef0\ufe0f \u041f\u043e\u0448\u0443\u043a \u0441\u0443\u043f\u0443\u0442\u043d\u0438\u043a\u0456\u0432","\ud83d\udc65 \u041f\u0438\u0441\u044c\u043c\u0435\u043d\u043d\u0438\u0446\u044c\u043a\u0456 \u043f\u0435\u0440\u0441\u043e\u043d\u0438","\ud83d\udc1f \u041f\u043e\u0448\u0443\u043a \u043c\u0430\u0433\u0430\u0437\u0438\u043d\u0456\u0432 \u0447\u0456\u043f\u0441\u0456\u0432","\ud83e\uddd1\u200d\ud83d\udcbb \u0406\u043d\u0442\u0435\u0440\u0444\u0435\u0439\u0441 \u043d\u0430\u043b\u0430\u0433\u043e\u0434\u0436\u0435\u043d\u043d\u044f","\ud83d\udcc8 \u0417\u0431\u0456\u043b\u044c\u0448\u0435\u043d\u043d\u044f \u0441\u0442\u0430\u0442\u0438\u0441\u0442\u0438\u043a\u0438","\ud83e\udd16 \u0412\u0438\u0432\u0447\u0435\u043d\u043d\u044f \u0441\u0435\u043c\u0430\u043d\u0442\u0438\u043a\u0438","\ud83c\udfa8 \u0420\u0435\u0434\u0438\u0437\u0430\u0439\u043d \u0456\u043d\u0442\u0435\u0440\u0444\u0435\u0439\u0441\u0443","\ud83d\udcc5 \u041f\u043b\u0430\u043d\u0443\u0432\u0430\u043d\u043d\u044f \u0432\u0435\u0447\u0456\u0440\u043e\u043a \u0437 \u0444\u043e\u0442\u043e\u043c\u0435\u043f\u0456\u043d\u0433\u043e\u043c","\ud83e\uddc0 \u0412\u0438\u0437\u0440\u0456\u043b\u0438\u0439 \u0447\u0435\u0434\u0434\u0435\u0440","\ud83c\udf04 \u0420\u043e\u0437\u0440\u0430\u0445\u0443\u043d\u043e\u043a \u043a\u043e\u0440\u043d\u0443\u043e\u043b\u044c\u0441\u044c\u043a\u043e\u0457 \u0441\u043e\u043d\u044f\u0447\u043d\u043e\u0457 \u0435\u043d\u0435\u0440\u0433\u0456\u0457","\ud83c\udf0a \u0412\u0438\u043c\u0456\u0440\u044e\u0432\u0430\u043d\u043d\u044f \u043f\u0440\u0438\u043f\u043b\u0438\u0432\u0456\u0432"],"error_psv":"\u041f\u0440\u043e\u0433\u0440\u0430\u043c\u0430 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u0434\u0443 \u0444\u043e\u0442\u043e\u0441\u0444\u0435\u0440 \u043d\u0435 \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0443\u0454\u0442\u044c\u0441\u044f \u043d\u0430\u043b\u0435\u0436\u043d\u0438\u043c \u0447\u0438\u043d\u043e\u043c","error_pic":"\u0417\u0430\u043f\u0438\u0442\u0430\u043d\u0435 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043d\u0435 \u0437\u043d\u0430\u0439\u0434\u0435\u043d\u043e","error_nopic":"\u0423 \u0432\u043a\u0430\u0437\u0430\u043d\u043e\u043c\u0443 \u043c\u0456\u0441\u0446\u0456 \u043d\u0435\u043c\u0430\u0454 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","error_api":"\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c \u043d\u0435\u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0439","error_webgl":"\u0412\u0430\u0448 \u0431\u0440\u0430\u0443\u0437\u0435\u0440 \u043d\u0435 \u043f\u0456\u0434\u0442\u0440\u0438\u043c\u0443\u0454 WebGL","error_josm":"JOSM \u043d\u0435 \u0432\u0456\u0434\u043f\u043e\u0432\u0456\u0434\u0430\u0454, \u0447\u0438 \u043f\u0440\u0430\u0446\u044e\u0454 \u0432\u0456\u043d \u0456 \u0447\u0438 \u0443\u0432\u0456\u043c\u043a\u043d\u0435\u043d\u043e \u0432\u0456\u0434\u0434\u0430\u043b\u0435\u043d\u0438\u0439 \u0434\u043e\u0441\u0442\u0443\u043f?","error_api_compatibility":"\u0421\u0435\u0440\u0432\u0435\u0440 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c \u043d\u0435 \u0441\u0443\u043c\u0456\u0441\u043d\u0438\u0439 \u0437 \u0446\u0456\u0454\u044e \u0432\u0435\u0440\u0441\u0456\u0454\u044e \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u0434\u0430\u0447\u0430","filter_date":"\u0414\u0430\u0442\u0430","filter_date_1month":"1 \u043c\u0456\u0441\u044f\u0446\u044c","filter_date_6months":"6 \u043c\u0456\u0441\u044f\u0446\u0456\u0432","filter_date_1year":"1 \u0440\u0456\u043a","filter_user":"\u041a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447","filter_user_mypics":"\u041c\u043e\u0457 \u0444\u043e\u0442\u043e\u0433\u0440\u0430\u0444\u0456\u0457","filter_picture":"\u0422\u0438\u043f \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","filter_zoom_in":"\u0417\u0431\u0456\u043b\u044c\u0448\u0442\u0435 \u043c\u0430\u0441\u0448\u0442\u0430\u0431 \u043a\u0430\u0440\u0442\u0438, \u0449\u043e\u0431 \u043f\u043e\u0431\u0430\u0447\u0438\u0442\u0438 \u0446\u0435\u0439 \u0444\u0456\u043b\u044c\u0442\u0440","picture_all":"\u0423\u0441\u0456","picture_flat":"\u041a\u043b\u0430\u0441\u0438\u0447\u043d\u0438\u0439","picture_360":"360\xb0","picture_flat_long":"\u041a\u043b\u0430\u0441\u0438\u0447\u043d\u0430 \u043a\u0430\u0440\u0442\u0438\u043d\u0430","picture_360_long":"\u041f\u0430\u043d\u043e\u0440\u0430\u043c\u043d\u0435 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","filter_qualityscore":"\u041f\u043e\u043a\u0430\u0437\u043d\u0438\u043a \u044f\u043a\u043e\u0441\u0442\u0456","filter_qualityscore_help":"\u041d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c, \u0449\u043e\u0431 \u0443\u0432\u0456\u043c\u043a\u043d\u0443\u0442\u0438 \u0430\u0431\u043e \u0432\u0438\u043c\u043a\u043d\u0443\u0442\u0438","qualityscore_title":"\u041f\u0440\u043e \u043f\u043e\u043a\u0430\u0437\u043d\u0438\u043a \u044f\u043a\u043e\u0441\u0442\u0456","qualityscore_doc_1":"Panoramax \u043f\u0440\u043e\u043f\u043e\u043d\u0443\u0454 \u043e\u0446\u0456\u043d\u043a\u0443 \u044f\u043a\u043e\u0441\u0442\u0456 \u0434\u043b\u044f \u043a\u043e\u0436\u043d\u043e\u0433\u043e \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f. \u0426\u0435 \u0434\u043e\u0437\u0432\u043e\u043b\u044f\u0454 \u043b\u0435\u0433\u043a\u043e \u0444\u0456\u043b\u044c\u0442\u0440\u0443\u0432\u0430\u0442\u0438 \u043a\u0430\u0440\u0442\u0438 \u0442\u0430 \u043f\u043e\u0432\u043d\u0435 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0434\u043e\u0441\u0442\u0443\u043f\u043d\u0438\u0445 \u0432\u0438\u0441\u043e\u043a\u043e\u044f\u043a\u0456\u0441\u043d\u0438\u0445 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c.","qualityscore_doc_2":"\u041e\u0446\u0456\u043d\u043a\u0430 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044c\u0441\u044f \u043a\u043e\u0440\u0438\u0441\u0442\u0443\u0432\u0430\u0447\u0430\u043c \u0443 \u0432\u0438\u0433\u043b\u044f\u0434\u0456 \u0431\u0430\u043b\u0456\u0432 A/B/C/D/E (A \u2013 \u043d\u0430\u0439\u043a\u0440\u0430\u0449\u0438\u0439, E \u2013 \u043d\u0430\u0439\u0433\u0456\u0440\u0448\u0438\u0439) \u0442\u0430 \u0432\u0456\u0434\u043e\u0431\u0440\u0430\u0436\u0430\u0454\u0442\u044c\u0441\u044f \u0433\u0440\u0430\u0444\u0456\u0447\u043d\u043e \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0446\u0456\u0454\u0457 \u0448\u043a\u0430\u043b\u0438:","qualityscore_doc_3":"\u0412\u0456\u043d \u0440\u043e\u0437\u0440\u0430\u0445\u043e\u0432\u0443\u0454\u0442\u044c\u0441\u044f \u043d\u0430 \u043e\u0441\u043d\u043e\u0432\u0456 \u0442\u043e\u0447\u043d\u043e\u0441\u0442\u0456 GPS \u0442\u0430 \u0440\u043e\u0437\u0434\u0456\u043b\u044c\u043d\u043e\u0457 \u0437\u0434\u0430\u0442\u043d\u043e\u0441\u0442\u0456 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f. \u041f\u0440\u043e\u0444\u0435\u0441\u0456\u0439\u043d\u0430 \u0441\u0438\u0441\u0442\u0435\u043c\u0430 \u043c\u0430\u0442\u0438\u043c\u0435 \u0440\u0435\u0439\u0442\u0438\u043d\u0433 A, \u0435\u043a\u0448\u043d-\u043a\u0430\u043c\u0435\u0440\u0430 \u043d\u0430 360\xb0 \u2014 \u0440\u0435\u0439\u0442\u0438\u043d\u0433 B, \u0430 \u0441\u043c\u0430\u0440\u0442\u0444\u043e\u043d \u2014 \u0440\u0435\u0439\u0442\u0438\u043d\u0433 C/D/E.","qualityscore_doc_link":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u043f\u043e\u043a\u0430\u0437\u043d\u0438\u043a \u044f\u043a\u043e\u0441\u0442\u0456","map_background":"\u0424\u043e\u043d \u043a\u0430\u0440\u0442\u0438","map_background_aerial":"\u0421\u0443\u043f\u0443\u0442\u043d\u0438\u043a\u043e\u0432\u0438\u0439","map_background_streets":"\u0412\u0443\u043b\u0438\u0446\u0456","map_theme":"\u0422\u0435\u043c\u0430 \u043a\u0430\u0440\u0442\u0438","map_theme_default":"\u041a\u043b\u0430\u0441\u0438\u0447\u043d\u0438\u0439","map_theme_age":"\u0414\u0430\u0442\u0430 \u0437\u0439\u043e\u043c\u043a\u0438","map_theme_age_1":"> 2 \u0440\u043e\u043a\u0456\u0432","map_theme_age_2":"< 2 \u0440\u043e\u043a\u0456\u0432","map_theme_age_3":"< 1 \u0440\u043e\u043a\u0443","map_theme_age_4":"< 1 \u043c\u0456\u0441\u044f\u0446\u044f","map_theme_type":"\u0422\u0438\u043f \u043a\u0430\u043c\u0435\u0440\u0438","map_theme_score":"\u041f\u043e\u043a\u0430\u0437\u043d\u0438\u043a \u044f\u043a\u043e\u0441\u0442\u0456","contrast":"\u0423\u0432\u0456\u043c\u043a\u043d\u0443\u0442\u0438 \u0432\u0438\u0449\u0443 \u043a\u043e\u043d\u0442\u0440\u0430\u0441\u0442\u043d\u0456\u0441\u0442\u044c \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","metadata":"\u041c\u0435\u0442\u0430\u0434\u0430\u043d\u0456 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","metadata_summary":"\u041a\u043e\u0440\u043e\u0442\u043a\u0438\u0439 \u0437\u043c\u0456\u0441\u0442","metadata_general_copy_id":"\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440","metadata_general_picid":"\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","metadata_general_seqid":"\u041f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u0456\u0441\u0442\u044c","metadata_general_copy_picid":"\u041a\u043e\u043f\u0456\u044e\u0432\u0430\u0442\u0438 \u0456\u0434\u0435\u043d\u0442\u0438\u0444\u0456\u043a\u0430\u0442\u043e\u0440 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","metadata_general_picid_link":"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043e JSON-\u043e\u043f\u0438\u0441\u0443 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","metadata_general_seqid_link":"\u041f\u0435\u0440\u0435\u0439\u0442\u0438 \u0434\u043e JSON-\u043e\u043f\u0438\u0441\u0443 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0456","metadata_general_author":"\u0410\u0432\u0442\u043e\u0440","metadata_general_license":"\u041b\u0456\u0446\u0435\u043d\u0437\u0456\u044f","metadata_general_license_link":"\u0414\u0438\u0432. \u043f\u043e\u0432\u043d\u0438\u0439 \u043e\u043f\u0438\u0441 \u043b\u0456\u0446\u0435\u043d\u0437\u0456\u0457","metadata_general_date":"\u0414\u0430\u0442\u0430 \u0437\u0439\u043e\u043c\u043a\u0438","metadata_camera":"\u041a\u0430\u043c\u0435\u0440\u0430","metadata_camera_make":"\u0417\u0440\u043e\u0431\u0438\u0442\u0438","metadata_general_instance":"\u041f\u043e\u0447\u0430\u0442\u043a\u043e\u0432\u0438\u0439 \u0435\u043a\u0437\u0435\u043c\u043f\u043b\u044f\u0440","metadata_camera_model":"\u041c\u043e\u0434\u0435\u043b\u044c","metadata_camera_type":"\u0422\u0438\u043f","metadata_camera_resolution":"\u0420\u043e\u0437\u0434\u0456\u043b\u044c\u043d\u0430 \u0437\u0434\u0430\u0442\u043d\u0456\u0441\u0442\u044c","metadata_location":"\u041f\u043e\u0437\u0438\u0446\u0456\u044f","metadata_location_coordinates":"\u041a\u043e\u043e\u0440\u0434\u0438\u043d\u0430\u0442\u0438 (\u0434\u043e\u0432\u0433\u043e\u0442\u0430, \u0448\u0438\u0440\u043e\u0442\u0430)","metadata_location_orientation":"\u041d\u0430\u043f\u0440\u044f\u043c\u043e\u043a","metadata_location_precision":"\u0422\u043e\u0447\u043d\u0456\u0441\u0442\u044c \u043f\u043e\u0437\u0438\u0446\u0456\u043e\u043d\u0443\u0432\u0430\u043d\u043d\u044f","metadata_location_copy":"\u041a\u043e\u043f\u0456\u044f {v}","metadata_location_copy_more":"\u0411\u0456\u043b\u044c\u0448\u0435 \u043e\u043f\u0446\u0456\u0439 \u043a\u043e\u043f\u0456\u044e\u0432\u0430\u043d\u043d\u044f \u043a\u043e\u043e\u0440\u0434\u0438\u043d\u0430\u0442","metadata_quality":"\u042f\u043a\u0456\u0441\u0442\u044c","metadata_quality_help":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u043f\u043e\u043a\u0430\u0437\u043d\u0438\u043a \u044f\u043a\u043e\u0441\u0442\u0456","metadata_quality_score":"\u0413\u043b\u043e\u0431\u0430\u043b\u044c\u043d\u0438\u0439 \u0431\u0430\u043b","metadata_quality_gps_score":"\u041e\u0446\u0456\u043d\u043a\u0430 \u043f\u043e\u0437\u0438\u0446\u0456\u043e\u043d\u0443\u0432\u0430\u043d\u043d\u044f","metadata_quality_resolution_score":"\u041e\u0446\u0456\u043d\u043a\u0430 \u0440\u043e\u0437\u0434\u0456\u043b\u044c\u043d\u043e\u0457 \u0437\u0434\u0430\u0442\u043d\u043e\u0441\u0442\u0456","metadata_exif":"EXIF","metadata_exif_name":"\u0422\u0435\u0433","metadata_exif_value":"\u0417\u043d\u0430\u0447\u0435\u043d\u043d\u044f","metadata_exif_doc":"\u0414\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430\u0446\u0456\u044f \u0434\u043b\u044f \u0442\u0435\u0433\u0456\u0432 EXIF","metadata_exif_doc_title":"\u041f\u0435\u0440\u0435\u0439\u0434\u0456\u0442\u044c \u0434\u043e \u0434\u043e\u043a\u0443\u043c\u0435\u043d\u0442\u0430\u0446\u0456\u0457 Exiv2, \u0449\u043e\u0431 \u043e\u0442\u0440\u0438\u043c\u0430\u0442\u0438 \u043f\u043e\u0432\u043d\u0443 \u0456\u043d\u0444\u043e\u0440\u043c\u0430\u0446\u0456\u044e \u043f\u0440\u043e \u0432\u0438\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f \u0442\u0435\u0433\u0456\u0432 EXIF \u0442\u0430 XMP","semantics_title":"\u0422\u0435\u0433\u0438","semantics_tags":"\u0442\u0435\u0433\u0438 {nb}","semantics_features_subtitle":"{nb} \u043f\u043e\u0432\'\u044f\u0437\u0430\u043d\u0456 \u0432\u043b\u0430\u0441\u0442\u0438\u0432\u043e\u0441\u0442\u0456","semantics_annotation_tooltip":"\u041d\u0430\u0442\u0438\u0441\u043d\u0456\u0442\u044c, \u0449\u043e\u0431 \u043f\u0435\u0440\u0435\u0433\u043b\u044f\u043d\u0443\u0442\u0438 \u0434\u0435\u0442\u0430\u043b\u0456","semantics_show_all_tags":"\u041f\u043e\u043a\u0430\u0437\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438","semantics_hide_all_tags":"\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u0432\u0441\u0456 \u0442\u0435\u0433\u0438","semantics_key":"\u041a\u043b\u044e\u0447","semantics_value":"\u0417\u043d\u0430\u0447\u0435\u043d\u043d\u044f","semantics_key_doc":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u0446\u0435\u0439 \u043a\u043b\u044e\u0447","semantics_value_doc":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u0446\u0435\u0439 \u0442\u0435\u0433","semantics_tags_picture":"\u0422\u0435\u0433\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c","semantics_tags_picture_none":"\u0414\u043b\u044f \u0446\u044c\u043e\u0433\u043e \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0449\u0435 \u043d\u0435 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d\u043e \u0436\u043e\u0434\u043d\u0438\u0445 \u0442\u0435\u0433\u0456\u0432.","semantics_qualifiers":"\u041a\u0432\u0430\u043b\u0456\u0444\u0456\u043a\u0430\u0442\u043e\u0440\u0438","semantics_features":"\u041e\u0441\u043e\u0431\u043b\u0438\u0432\u043e\u0441\u0442\u0456 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","semantics_features_default_title":"\u0422\u0435\u0433 {nb}","semantics_features_none":"\u041d\u0430 \u0446\u044c\u043e\u043c\u0443 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u0456 \u0449\u0435 \u043d\u0435 \u043d\u0430\u043c\u0430\u043b\u044c\u043e\u0432\u0430\u043d\u043e \u0436\u043e\u0434\u043d\u043e\u0457 \u043e\u0441\u043e\u0431\u043b\u0438\u0432\u043e\u0441\u0442\u0456.","semantics_show_annotations":"\u0424\u0443\u043d\u043a\u0446\u0456\u0457 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043d\u0430 \u0434\u0438\u0441\u043f\u043b\u0435\u0457","metadata_camera_focal_length":"\u0424\u043e\u043a\u0443\u0441\u043d\u0430 \u0432\u0456\u0434\u0441\u0442\u0430\u043d\u044c","metadata_quality_missing":"\u043d\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u0456 \u043d\u0435 \u0432\u0441\u0442\u0430\u043d\u043e\u0432\u043b\u0435\u043d\u043e \u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f","semantics_draw_annotation":"\u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043d\u0430\u043c\u0430\u043b\u044e\u0432\u0430\u0442\u0438 \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u0438\u0439 \u043e\u0431\'\u0454\u043a\u0442 \u043f\u043e\u0432\u0435\u0440\u0445 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f (\u043d\u0435\u043e\u0431\u043e\u0432\'\u044f\u0437\u043a\u043e\u0432\u043e).","semantics_save_drawn_annotation":"\u0417\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u043f\u043e\u0437\u0438\u0446\u0456\u044e","semantics_undo_drawn_annotation":"\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438","semantics_delete_annotation":"\u0412\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0446\u0435\u0439 \u043e\u0431\'\u0454\u043a\u0442","semantics_hashtags":"\u0425\u0435\u0448\u0442\u0435\u0433\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c","semantics_wikidata_properties":{"P31":"\u043f\u0440\u0438\u043a\u043b\u0430\u0434","P279":"\u043f\u0456\u0434\u043a\u043b\u0430\u0441","P361":"\u0447\u0430\u0441\u0442\u0438\u043d\u0430"},"semantics_editor_error":"\u0421\u0438\u043d\u0442\u0430\u043a\u0441\u0438\u0441 \u043d\u0435\u0434\u0456\u0439\u0441\u043d\u0438\u0439. \u0412\u0430\u0448\u0456 \u0442\u0435\u0433\u0438 \u043c\u043e\u0436\u0443\u0442\u044c \u0432\u0438\u0433\u043b\u044f\u0434\u0430\u0442\u0438 \u0442\u0430\u043a:\\n\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f\\n\u043f\u0440\u0435\u0444\u0456\u043a\u0441|\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f\\n\u043f\u0440\u0435\u0444\u0456\u043a\u0441|\u043a\u043b\u044e\u0447[\u043a\u0432\u0430\u043b\u0456\u0444\u0456\u043a\u0430\u0446\u0456\u0439\u043d\u0438\u0439_\u043a\u043b\u044e\u0447=\u043a\u0432\u0430\u043b\u0456\u0444\u0456\u043a\u0430\u0446\u0456\u0439\u043d\u0435_\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f]=\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f\\n\\n\u041c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430 \u0434\u043e\u0432\u0436\u0438\u043d\u0430 \u043a\u043b\u044e\u0447\u0430 \u2014 256 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432, \u043c\u0430\u043a\u0441\u0438\u043c\u0430\u043b\u044c\u043d\u0430 \u0434\u043e\u0432\u0436\u0438\u043d\u0430 \u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f \u2014 2048 \u0441\u0438\u043c\u0432\u043e\u043b\u0456\u0432.","semantics_editor_example":"\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f\\n\u043f\u0440\u0435\u0444\u0456\u043a\u0441|\u043a\u043b\u044e\u0447=\u0437\u043d\u0430\u0447\u0435\u043d\u043d\u044f","semantics_edit":"\u0420\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0430\u0442\u0440\u0438\u0431\u0443\u0442\u0438","semantics_save":"\u0417\u0431\u0435\u0440\u0435\u0436\u0456\u0442\u044c \u0437\u043c\u0456\u043d\u0438","semantics_undo":"\u0421\u043a\u0430\u0441\u0443\u0432\u0430\u0442\u0438 \u0432\u0430\u0448\u0456 \u0437\u043c\u0456\u043d\u0438","semantics_cantsave_invalid":"\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043c\u0456\u043d\u0438, \u0432\u0432\u0435\u0434\u0435\u043d\u0456 \u0434\u0430\u043d\u0456 \u043d\u0435\u0434\u0456\u0439\u0441\u043d\u0456","semantics_send_fail":"\u041d\u0435 \u0432\u0434\u0430\u043b\u043e\u0441\u044f \u0437\u0431\u0435\u0440\u0435\u0433\u0442\u0438 \u0437\u043c\u0456\u043d\u0438, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043f\u0456\u0437\u043d\u0456\u0448\u0435","semantics_send_ok":"\u0412\u0430\u0448\u0456 \u0437\u043c\u0456\u043d\u0438 \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e","report_details":"\u0414\u043e\u0434\u0430\u0442\u043a\u043e\u0432\u0456 \u0434\u0435\u0442\u0430\u043b\u0456","report_details_placeholder":"\u0417\u0430 \u0431\u0430\u0436\u0430\u043d\u043d\u044f\u043c, \u0432\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u0434\u043e\u0434\u0430\u0442\u0438 \u0434\u0435\u0442\u0430\u043b\u0456 \u043f\u0440\u043e \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0443","semantics_zero_annotations":"\u041d\u0430 \u0446\u044c\u043e\u043c\u0443 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u0456 \u043d\u0435\u043c\u0430\u0454 \u043d\u0430\u043c\u0430\u043b\u044c\u043e\u0432\u0430\u043d\u0438\u0445 \u0440\u0438\u0441","semantics_add_annotation":"\u0414\u043e\u0434\u0430\u0442\u0438 \u043d\u043e\u0432\u0438\u0439 \u0442\u0435\u0433","semantics_delete_annotation_confirm":"\u0412\u0438 \u0441\u043f\u0440\u0430\u0432\u0434\u0456 \u0445\u043e\u0447\u0435\u0442\u0435 \u0432\u0438\u0434\u0430\u043b\u0438\u0442\u0438 \u0446\u0435\u0439 \u0442\u0435\u0433?","semantics_login_needed":"\u0429\u043e\u0431 \u0440\u0435\u0434\u0430\u0433\u0443\u0432\u0430\u0442\u0438 \u0442\u0435\u0433\u0438 \u0430\u0431\u043e \u043e\u0431\'\u0454\u043a\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u044c, \u0432\u0430\u043c \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u0443\u0432\u0456\u0439\u0442\u0438 \u0432 \u0435\u043a\u0437\u0435\u043c\u043f\u043b\u044f\u0440 Panoramax {n}. \u0412\u0438 \u0445\u043e\u0447\u0435\u0442\u0435 \u0443\u0432\u0456\u0439\u0442\u0438?","report":"\u0417\u0432\u0456\u0442","report_auth":"\u0426\u0435\u0439 \u0437\u0432\u0456\u0442 \u0431\u0443\u0434\u0435 \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e \u0437 \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u0430\u043d\u043d\u044f\u043c \u0432\u0430\u0448\u043e\u0433\u043e \u043e\u0431\u043b\u0456\u043a\u043e\u0432\u043e\u0433\u043e \u0437\u0430\u043f\u0438\u0441\u0443 \\"{a}\\"","report_nature_label":"\u041f\u0440\u0438\u0447\u0438\u043d\u0430 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0438","report_nature":{"blur_excess":"\u0414\u043e \u043e\u0431\'\u0454\u043a\u0442\u0430 \u0437\u0430\u0441\u0442\u043e\u0441\u043e\u0432\u0430\u043d\u043e \u043d\u0435\u043f\u043e\u0442\u0440\u0456\u0431\u043d\u0435 \u0440\u043e\u0437\u043c\u0438\u0442\u0442\u044f","inappropriate":"\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043d\u0435\u0434\u043e\u0440\u0435\u0447\u043d\u0435 (\u043d\u0435 \u0441\u0442\u043e\u0441\u0443\u0454\u0442\u044c\u0441\u044f \u0442\u0435\u043c\u0438, \u043e\u0433\u043e\u043b\u0435\u043d\u0435 \u0442\u0456\u043b\u043e\u2026)","privacy":"\u0412\u0438\u0434\u043d\u043e \u043f\u0440\u0438\u0432\u0430\u0442\u043d\u0438\u0439 \u0448\u043b\u044f\u0445 \u0430\u0431\u043e \u0432\u043b\u0430\u0441\u043d\u0456\u0441\u0442\u044c","mislocated":"\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043f\u043e\u0433\u0430\u043d\u043e \u0440\u043e\u0437\u0442\u0430\u0448\u043e\u0432\u0430\u043d\u0435 \u043d\u0430 \u043a\u0430\u0440\u0442\u0456","copyright":"\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043f\u043e\u0440\u0443\u0448\u0443\u0454 \u0430\u0432\u0442\u043e\u0440\u0441\u044c\u043a\u0456 \u043f\u0440\u0430\u0432\u0430","other":"\u0411\u0443\u0434\u044c-\u044f\u043a\u0438\u0439 \u0456\u043d\u0448\u0438\u0439 \u0432\u0438\u0434 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0438","picture_low_quality":"\u0417\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043d\u0438\u0437\u044c\u043a\u043e\u0457 \u044f\u043a\u043e\u0441\u0442\u0456","":"\u0412\u0438\u0431\u0435\u0440\u0456\u0442\u044c \u0445\u0430\u0440\u0430\u043a\u0442\u0435\u0440 \u043f\u0440\u043e\u0431\u043b\u0435\u043c\u0438\u2026","blur_missing":"\u0412\u0438\u0434\u043d\u043e \u043e\u0431\u043b\u0438\u0447\u0447\u044f \u043b\u044e\u0434\u0438\u043d\u0438 \u0430\u0431\u043e \u043d\u043e\u043c\u0435\u0440\u043d\u0438\u0439 \u0437\u043d\u0430\u043a \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0456\u043b\u044f"},"report_email":"\u0412\u0430\u0448\u0430 \u0435\u043b\u0435\u043a\u0442\u0440\u043e\u043d\u043d\u0430 \u0430\u0434\u0440\u0435\u0441\u0430","report_email_placeholder":"\u041d\u0435\u043e\u0431\u043e\u0432\'\u044f\u0437\u043a\u043e\u0432\u043e","report_submit":"\u041d\u0430\u0434\u0456\u0441\u043b\u0430\u0442\u0438","report_success":"\u0417\u0432\u0456\u0442 \u0443\u0441\u043f\u0456\u0448\u043d\u043e \u043d\u0430\u0434\u0456\u0441\u043b\u0430\u043d\u043e. \u0419\u043e\u0433\u043e \u0431\u0443\u0434\u0435 \u0440\u043e\u0437\u0433\u043b\u044f\u043d\u0443\u0442\u043e \u044f\u043a\u043e\u043c\u043e\u0433\u0430 \u0448\u0432\u0438\u0434\u0448\u0435.","report_failure":"\u041f\u0456\u0434 \u0447\u0430\u0441 \u0441\u0442\u0432\u043e\u0440\u0435\u043d\u043d\u044f \u0437\u0432\u0456\u0442\u0443 \u0441\u0442\u0430\u043b\u0430\u0441\u044f \u043f\u043e\u043c\u0438\u043b\u043a\u0430: {e}. \u0411\u0443\u0434\u044c \u043b\u0430\u0441\u043a\u0430, \u0441\u043f\u0440\u043e\u0431\u0443\u0439\u0442\u0435 \u043f\u0456\u0437\u043d\u0456\u0448\u0435.","report_whole_sequence":"\u0426\u0435 \u0441\u0442\u043e\u0441\u0443\u0454\u0442\u044c\u0441\u044f \u0432\u0441\u0456\u0454\u0457 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0456","report_wait":"\u041d\u0430\u0434\u0441\u0438\u043b\u0430\u043d\u043d\u044f \u0437\u0432\u0456\u0442\u0443\u2026","semantics_save_drawn_annotation_incomplete":"\u041f\u0435\u0440\u0435\u0434 \u043f\u0435\u0440\u0435\u0432\u0456\u0440\u043a\u043e\u044e \u043f\u043e\u0442\u0440\u0456\u0431\u043d\u043e \u043d\u0430\u043c\u0430\u043b\u044e\u0432\u0430\u0442\u0438 \u043f\u0440\u044f\u043c\u043e\u043a\u0443\u0442\u043d\u0438\u043a, \u044f\u043a\u0438\u0439 \u043f\u043e\u043c\u0456\u0441\u0442\u0438\u0442\u044c\u0441\u044f \u043d\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u0456","semantics_hide_annotations":"\u041f\u0440\u0438\u0445\u043e\u0432\u0430\u0442\u0438 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u043e\u0431\'\u0454\u043a\u0442\u0456\u0432","semantics_doc":"\u0414\u043e\u043f\u043e\u043c\u043e\u0433\u0430","semantics_doc_title":"\u041f\u0440\u043e \u0442\u0435\u0433\u0438","semantics_erase_annotation":"\u0421\u0442\u0435\u0440\u0442\u0438 \u043d\u0430\u043c\u0430\u043b\u044c\u043e\u0432\u0430\u043d\u0438\u0439 \u0435\u043b\u0435\u043c\u0435\u043d\u0442","semantics_doc_info1":"\u041d\u0430\u0434\u0430\u0439\u0442\u0435 \u043a\u043e\u043d\u0442\u0435\u043a\u0441\u0442 \u043d\u0430\u0432\u043a\u043e\u043b\u043e \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0442\u0435\u0433\u0456\u0432. \u0412\u0438 \u043c\u043e\u0436\u0435\u0442\u0435 \u043f\u043e\u0437\u043d\u0430\u0447\u0438\u0442\u0438 \u0439\u043e\u0433\u043e \u044f\u043a \u0437\u043d\u044f\u0442\u0435 \u0430\u0432\u0442\u043e\u043c\u043e\u0431\u0456\u043b\u0435\u043c \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0442\u0435\u0433\u0443 transport=car.","semantics_doc_info2":"\u0412\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u043c\u0430\u043b\u044e\u0432\u0430\u0442\u0438 \u043e\u0431\'\u0454\u043a\u0442\u0438 \u043d\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u0456: \u0434\u043e\u0440\u043e\u0436\u043d\u0456 \u0437\u043d\u0430\u043a\u0438, \u043c\u0456\u0441\u044c\u043a\u0435 \u043e\u0431\u043b\u0430\u0434\u043d\u0430\u043d\u043d\u044f\u2026 \u041f\u043e\u0437\u043d\u0430\u0447\u0430\u0439\u0442\u0435 \u0442\u0435, \u0449\u043e \u0431\u0430\u0447\u0438\u0442\u0435, \u0432\u0438\u043a\u043e\u0440\u0438\u0441\u0442\u043e\u0432\u0443\u044e\u0447\u0438 \u0456\u0441\u043d\u0443\u044e\u0447\u0456 \u0442\u0435\u0433\u0438. \u0417\u0430 \u043f\u043e\u0442\u0440\u0435\u0431\u0438 \u0432\u0438 \u0442\u0430\u043a\u043e\u0436 \u043c\u043e\u0436\u0435\u0442\u0435 \u0441\u0442\u0432\u043e\u0440\u0438\u0442\u0438 \u0441\u0432\u043e\u0457 \u0432\u043b\u0430\u0441\u043d\u0456.","semantics_doc_info3":"\u0414\u0435\u044f\u043a\u0456 \u043e\u0431\'\u0454\u043a\u0442\u0438 \u0430\u0432\u0442\u043e\u043c\u0430\u0442\u0438\u0447\u043d\u043e \u0440\u043e\u0437\u043f\u0456\u0437\u043d\u0430\u044e\u0442\u044c\u0441\u044f \u0437\u0430 \u0434\u043e\u043f\u043e\u043c\u043e\u0433\u043e\u044e \u0448\u0442\u0443\u0447\u043d\u043e\u0433\u043e \u0456\u043d\u0442\u0435\u043b\u0435\u043a\u0442\u0443: \u044f\u043a\u0456\u0441\u0442\u044c \u043d\u0435 \u0433\u0430\u0440\u0430\u043d\u0442\u0443\u0454\u0442\u044c\u0441\u044f.","semantics_doc_link":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e \u0442\u0435\u0433\u0438","semantics_sequence_tags":"\u0422\u0435\u0433 \u043f\u043e\u0441\u043b\u0456\u0434\u043e\u0432\u043d\u043e\u0441\u0442\u0456","semantics_picture_tags":"\u0422\u0435\u0433 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f","semantics_annotation_tags":"\u0422\u0435\u0433 \u043e\u0431\'\u0454\u043a\u0442\u0430","filter_gps_precision_lessthan":"\u041c\u0435\u043d\u0448\u0435 {n} \u043c\u0435\u0442\u0440\u0456\u0432","filter_gps_precision_morethan":"\u0411\u0456\u043b\u044c\u0448\u0435 {n} \u043c\u0435\u0442\u0440\u0456\u0432","filter_gps_precision_between":"\u0412\u0456\u0434 {n1} \u0434\u043e {n2} \u043c\u0435\u0442\u0440\u0456\u0432","filter_gps_precision":"\u0422\u043e\u0447\u043d\u0456\u0441\u0442\u044c \u043f\u043e\u0437\u0438\u0446\u0456\u044e\u0432\u0430\u043d\u043d\u044f","map_theme_gps":"\u0422\u043e\u0447\u043d\u0456\u0441\u0442\u044c \u043f\u043e\u0437\u0438\u0446\u0456\u044e\u0432\u0430\u043d\u043d\u044f","semantics_overlays":{"tfsigns":"\u0414\u043e\u0440\u043e\u0436\u043d\u0456 \u0437\u043d\u0430\u043a\u0438"}},"map":{"not_public":"\u041d\u0435 \u043f\u0443\u0431\u043b\u0456\u0447\u043d\u043e \u0432\u0438\u0434\u0438\u043c\u0435","map_data":"\u041a\u0430\u0440\u0442\u0430 \u043d\u0430 \u043e\u0441\u043d\u043e\u0432\u0456 {m}","more_panoramax":"\u0414\u0456\u0437\u043d\u0430\u0439\u0442\u0435\u0441\u044f \u0431\u0456\u043b\u044c\u0448\u0435 \u043f\u0440\u043e Panoramax","thumbnail":"\u041c\u0456\u043d\u0456\u0430\u0442\u044e\u0440\u0430 \u0437\u043e\u0431\u0440\u0430\u0436\u0435\u043d\u043d\u044f, \u043d\u0430 \u044f\u043a\u0435 \u043d\u0430\u0432\u0435\u0434\u0435\u043d\u043e \u043a\u0443\u0440\u0441\u043e\u0440","slow_loading":"\u041a\u0430\u0440\u0442\u0430 \u043f\u043e\u0432\u0456\u043b\u044c\u043d\u043e \u0437\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0443\u0454\u0442\u044c\u0441\u044f \u0442\u0430 \u043c\u043e\u0436\u0435 \u0432\u0438\u0433\u043b\u044f\u0434\u0430\u0442\u0438 \u043f\u043e\u0448\u043a\u043e\u0434\u0436\u0435\u043d\u043e\u044e","loading":"\u0417\u0430\u0432\u0430\u043d\u0442\u0430\u0436\u0435\u043d\u043d\u044f\u2026"}}');
            },
            6984: (le1)=>{
                "use strict";
                le1.exports = JSON.parse('{"pnx":{"contrast":"\u589e\u52a0\u76f8\u7247\u5c0d\u6bd4\u5ea6","copied":"\u5df2\u8907\u88fd","copy":"\u8907\u88fd","edit_osm":"\u7de8\u8f2f OSM","error":"Panoramax \u7576\u6a5f\u4e86\u2026","error_api":"\u76f8\u7247\u4f3a\u670d\u5668\u7121\u6cd5\u4f7f\u7528","error_api_compatibility":"\u76f8\u7247\u4f3a\u670d\u5668\u548c\u6b64\u6aa2\u8996\u5668\u7684\u7248\u672c\u4e0d\u76f8\u5bb9","error_josm":"JOSM \u6c92\u6709\u56de\u61c9\uff0c\u5b83\u5df2\u7d93\u555f\u52d5\u4e14\u555f\u7528\u9060\u7aef\u63a7\u5236\u4e86\u55ce?","error_nopic":"\u641c\u5c0b\u7684\u4f4d\u7f6e\u9644\u8fd1\u6c92\u6709\u76f8\u7247","error_pic":"\u627e\u4e0d\u5230\u6307\u5b9a\u7684\u76f8\u7247","error_psv":"\u7121\u6cd5\u6b63\u78ba\u8f09\u5165 Photo Sphere Viewer","error_subtitle":"\u8acb\u7a0d\u5f8c\u91cd\u8a66\u6216\u6aa2\u67e5\u700f\u89bd\u5668\u7684\u4e3b\u63a7\u53f0\u4ee5\u4e86\u89e3\u8a73\u60c5\u3002","error_webgl":"\u60a8\u7684\u700f\u89bd\u5668\u4e0d\u652f\u63f4 WebGL","expand":"\u5c55\u958b","expand_info":"\u5728\u6574\u500b\u756b\u9762\u986f\u793a\u6b64\u5c0f\u5de5\u5177","filter_camera_model":"\u6309\u76f8\u6a5f\u578b\u865f","filter_date":"\u65e5\u671f","filter_picture":"\u76f8\u7247\u985e\u578b","filter_user":"\u4f7f\u7528\u8005","filter_zoom_in":"\u62c9\u8fd1\u5730\u5716\u4ee5\u986f\u793a\u7be9\u9078\u7d50\u679c","filters":"\u7be9\u9078\u5668","id":"iD","josm":"JOSM","josm_live":"\u555f\u7528\u8f09\u5165\u76f8\u7247\u6642\u81ea\u52d5\u540c\u6b65 JOSM","layers":"\u5716\u5c64","legend_license":"\u6388\u6b0a: {l}","loading_labels_fun":["\ud83e\udd8c \u5075\u6e2c\u5230\u7576\u5fc3\u6885\u82b1\u9e7f\u6a19\u8a8c","\ud83d\ude98 \u6b63\u5728\u641c\u5c0b Panoramax \u6c7d\u8eca \xa9","\u2615 \u6ce8\u5165\u5496\u5561\u56e0","\ud83d\ude00 \u8acb\u5fae\u7b11\uff0c\u60a8\u5df2\u88ab\u6a19\u8a18\u5728\u5730\u5716\u4e0a\u4e86\uff01","\ud83d\udc08 \u6b63\u5728\u5206\u4eab\u8c93\u54aa\u7684\u76f8\u7247","\ud83d\ude34 \u6b63\u5728\u6e1b\u5c11\u5ef6\u9072","\ud83e\uded6 \u6b63\u5728\u6c8f\u58fa\u597d\u8336","\ud83d\udc27 \u6b63\u5728\u958b\u555f\u539f\u59cb\u78bc","\ud83d\ude87 \u6b63\u5728\u7d22\u5f15\u5730\u9435\u8eca\u7ad9","\ud83e\uddf9 \u6e05\u7406\u8a6e\u91cb\u8cc7\u6599","\ud83d\ude92 \u6b63\u5728\u50b3\u9001\u6d88\u9632\u968a\u7684\u76f8\u7247","\ud83d\udeb2 \u66f4\u65b0\u7da0\u9053","\ud83d\ude89 \u6b63\u5728\u901a\u904e\u8eca\u7ad9\u6708\u53f0","\ud83d\udef0\ufe0f \u6b63\u5728\u641c\u5c0b\u885b\u661f","\ud83d\udc65 \u6b63\u5728\u64b0\u5beb\u4eba\u7269\u8a8c","\ud83c\udf57 \u6b63\u5728\u5b9a\u4f4d\u9e79\u9165\u96de\u5e97","\ud83e\uddd1\u200d\ud83d\udcbb \u6b63\u5728\u5075\u932f\u4ecb\u9762","\ud83d\udcc8 \u7d71\u8a08\u6578\u64da\u6b63\u5728\u589e\u52a0","\ud83e\udd16 \u6b63\u5728\u5b78\u7fd2\u8a9e\u7fa9","\ud83c\udfa8 \u91cd\u65b0\u8a2d\u8a08\u4ecb\u9762","\ud83d\udcc5 \u6b63\u5728\u898f\u5283\u76f8\u7247\u5730\u5716\u7e6a\u5716\u805a\u6703","\ud83e\uddc0 \u6b63\u5728\u719f\u6210\u5207\u9054\u8d77\u53f8","\ud83c\udf04 \u6b63\u5728\u8a08\u7b97\u6046\u6625\u7684\u65e5\u7167\u6642\u6578","\ud83c\udf0a \u6b63\u5728\u6e2c\u91cf\u6f6e\u6c50"],"loading_labels_serious":["\ud83d\uddfa\ufe0f \u6b63\u5728\u8f09\u5165\u5730\u5716\u8cc7\u6599","\ud83d\udda5\ufe0f \u6b63\u5728\u67e5\u8a62 API","\ud83d\uddbc\ufe0f \u6b63\u5728\u8f09\u5165\u7e2e\u5716","\ud83d\udd0d \u6b63\u5728\u5206\u6790 EXIF \u8a6e\u91cb\u8cc7\u6599","\ud83c\udfd8\ufe0f \u6b63\u5728\u7b97\u7e6a 3D","\ud83d\udcf7 \u6b63\u5728\u521d\u59cb\u5316 360\xb0 \u76f8\u7247","\ud83d\udfe0 \u6b63\u5728\u5e73\u8861\u8272\u5f69","\ud83d\udcaf \u6b63\u5728\u8a08\u7b97\u54c1\u8cea\u5206\u6578 \xa9","\ud83d\udce1 \u6b63\u5728\u4e0b\u8f09\u66f4\u65b0","\ud83c\udf0d \u6b63\u5728\u53d6\u5f97\u5730\u5716\u5716\u78da","\ud83d\udcf8 \u6b63\u5728\u8655\u7406\u9670\u5f71"],"map_background":"\u5730\u5716\u80cc\u666f","map_background_aerial":"\u885b\u661f","map_background_streets":"\u9810\u8a2d","map_theme":"\u5730\u5716\u4e3b\u984c","map_theme_age":"\u62cd\u651d\u6642\u9593","map_theme_age_1":"> 2 \u5e74","map_theme_age_2":"< 2 \u5e74","map_theme_age_3":"< 1 \u5e74","map_theme_age_4":"< 1 \u500b\u6708","map_theme_default":"\u7d93\u5178","map_theme_type":"\u76f8\u6a5f\u985e\u578b","metadata":"\u76f8\u7247\u8a6e\u91cb\u8cc7\u6599","metadata_camera":"\u76f8\u6a5f","metadata_camera_focal_length":"\u7126\u8ddd","metadata_camera_make":"\u88fd\u9020\u5546","metadata_camera_model":"\u578b\u865f","metadata_camera_type":"\u985e\u578b","metadata_exif":"EXIF","metadata_exif_name":"\u6a19\u7c64","metadata_exif_value":"\u503c","metadata_general_author":"\u4f5c\u8005","metadata_general_date":"\u62cd\u651d\u6642\u9593","metadata_general_license":"\u6388\u6b0a","metadata_general_license_link":"\u67e5\u770b\u5b8c\u6574\u6388\u6b0a\u689d\u6b3e","metadata_general_picid":"\u76f8\u7247","metadata_general_picid_link":"\u524d\u5f80\u672c\u76f8\u7247\u7684 JSON \u8aaa\u660e","metadata_general_seqid":"\u5e8f\u5217","metadata_general_seqid_link":"\u524d\u5f80\u672c\u5e8f\u5217\u7684 JSON \u8aaa\u660e","metadata_location":"\u4f4d\u7f6e","metadata_location_latitude":"\u7def\u5ea6","metadata_location_longitude":"\u7d93\u5ea6","metadata_location_orientation":"\u65b9\u5411","metadata_location_precision":"\u5b9a\u4f4d\u7cbe\u5ea6","minimize":"\u96b1\u85cf\u9019\u500b\u5c0f\u5de5\u5177\uff0c\u60a8\u53ef\u4ee5\u6309\u5de6\u4e0b\u89d2\u7684\u6309\u9215\u518d\u6b21\u986f\u793a\u5b83","moveDown":"\u4e0b\u79fb","moveLeft":"\u5de6\u79fb","moveMiddle":"\u756b\u9762\u7f6e\u4e2d","moveRight":"\u53f3\u79fb","moveUp":"\u4e0a\u79fb","options":"\u9078\u9805","picture_360":"360\xb0","picture_flat":"\u7d93\u5178","search":"\u641c\u5c0b","search_address":"\u641c\u5c0b\u5730\u5740\u3001\u57ce\u5e02\u2026","search_empty":"\u627e\u4e0d\u5230\u7d50\u679c","search_user":"\u641c\u5c0b\u5e33\u865f\u2026","sequence_more":"\u66f4\u591a\u64ad\u653e\u9078\u9805","sequence_next":"\u5e8f\u5217\u4e2d\u7684\u4e0b\u4e00\u5f35\u76f8\u7247","sequence_pause":"\u66ab\u505c\u5e8f\u5217","sequence_play":"\u64ad\u653e\u5e8f\u5217","sequence_prev":"\u5e8f\u5217\u4e2d\u7684\u4e0a\u4e00\u5f35\u76f8\u7247","sequence_speed":"\u64ad\u653e\u901f\u5ea6","share":"\u5206\u4eab","share_embed":"\u5d4c\u5165\u5230\u60a8\u7684\u7db2\u7ad9","share_image":"\u9ad8\u756b\u8cea\u76f8\u7247","share_links":"\u8d85\u9023\u7d50","share_page":"\u9019\u5f35\u76f8\u7247\u7684\u9023\u7d50","share_print":"\u5217\u5370","share_rss":"RSS \u6458\u8981","share_rss_title":"\u76ee\u524d\u5730\u5716\u53ef\u898b\u5340\u57df\u4e2d\u65b0\u76f8\u7247\u5e8f\u5217\u7684 RSS \u6458\u8981","show_map":"\u986f\u793a\u5730\u5716","show_psv":"\u986f\u793a\u76f8\u7247\u6aa2\u8996\u5668","zoom":"\u7e2e\u653e","zoomIn":"\u62c9\u8fd1","zoomOut":"\u62c9\u9060","report_submit":"\u9001\u51fa","report_email":"\u60a8\u7684 email","report_nature_label":"\u554f\u984c\u7684\u539f\u56e0","report_nature":{"":"\u9078\u64c7\u554f\u984c\u7684\u985e\u578b\u2026","blur_missing":"\u53ef\u4ee5\u770b\u898b\u4eba\u81c9\u6216\u8eca\u724c","blur_excess":"\u5c0d\u7269\u4ef6\u5957\u7528\u4e86\u4e0d\u5fc5\u8981\u7684\u6a21\u7cca\u8655\u7406","inappropriate":"\u4e0d\u7576\u7684\u76f8\u7247 (\u4e0d\u76f8\u95dc\u3001\u88f8\u9ad4\u2026)","privacy":"\u53ef\u4ee5\u770b\u898b\u79c1\u4eba\u7684\u9053\u8def\u6216\u8cc7\u7522","picture_low_quality":"\u4f4e\u54c1\u8cea\u7684\u76f8\u7247","mislocated":"\u76f8\u7247\u5728\u5730\u5716\u4e0a\u7684\u4f4d\u7f6e\u4e0d\u6b63\u78ba","copyright":"\u76f8\u7247\u4fb5\u72af\u4e86\u7248\u6b0a","other":"\u4efb\u4f55\u5176\u4ed6\u985e\u578b\u7684\u554f\u984c"},"share_embed_docs":"\u6df1\u5165\u4e86\u89e3\u5d4c\u5165\u8a2d\u5b9a\u503c","error_retry":"\u8acb\u7a0d\u5f8c\u518d\u8a66","error_click":"\u7e7c\u7e8c","legend_title":"\u986f\u793a\u76f8\u7247\u7684\u8a73\u7d30\u8cc7\u6599","report_email_placeholder":"\u9078\u586b","report_whole_sequence":"\u9019\u500b\u554f\u984c\u5f71\u97ff\u6574\u500b\u5e8f\u5217","report_details":"\u66f4\u591a\u8cc7\u8a0a","report_details_placeholder":"\u9078\u586b\uff0c\u60a8\u53ef\u4ee5\u8a73\u8ff0\u6b64\u554f\u984c","report_wait":"\u6b63\u5728\u50b3\u9001\u5831\u544a\u2026","report_success":"\u5df2\u6210\u529f\u767c\u9001\u5831\u544a\uff0c\u6211\u5011\u5c07\u5118\u5feb\u5c0d\u5b83\u9032\u884c\u5be9\u6838\u3002","report_failure":"\u5efa\u7acb\u5831\u544a\u6642\u767c\u9001\u932f\u8aa4: {e}\uff0c\u8acb\u7a0d\u5f8c\u518d\u8a66\u3002","report_auth":"\u6b64\u5831\u544a\u5c07\u4f7f\u7528\u60a8\u7684\u5e33\u6236\u300c{a}\u300d\u767c\u9001","filter_qualityscore":"\u54c1\u8cea\u5206\u6578","filter_qualityscore_help":"\u9ede\u64ca\u4ee5\u555f\u7528\u6216\u505c\u7528","map_theme_score":"\u54c1\u8cea\u5206\u6578","metadata_camera_resolution":"\u89e3\u6790\u5ea6","metadata_quality":"\u54c1\u8cea","metadata_quality_help":"\u6df1\u5165\u4e86\u89e3\u54c1\u8cea\u5206\u6578","metadata_quality_gps_score":"\u5b9a\u4f4d\u5206\u6578","metadata_quality_resolution_score":"\u89e3\u6790\u5ea6\u5206\u6578","metadata_quality_missing":"\u76f8\u7247\u672a\u5305\u542b\u8cc7\u8a0a","report":"\u6aa2\u8209","metadata_quality_score":"\u6574\u9ad4\u5206\u6578","filter_user_mypics":"\u6211\u7684\u76f8\u7247","filter_date_1month":"1 \u500b\u6708","filter_date_1year":"1 \u5e74","qualityscore_doc_2":"\u5206\u6578\u4ee5\u5b57\u6bcd\u8868\u793a:","qualityscore_doc_link":"\u6df1\u5165\u4e86\u89e3\u54c1\u8cea\u5206\u6578","qualityscore_title":"\u95dc\u65bc\u54c1\u8cea\u5206\u6578","qualityscore_doc_1":"\u6211\u5011\u70ba\u6bcf\u5f35\u76f8\u7247\u8a08\u7b97\u54c1\u8cea\u5206\u6578\u3002","qualityscore_doc_3":"A \u70ba\u6700\u4f73\u7b49\u7d1a\uff0cE \u70ba\u6700\u5dee\u7b49\u7d1a\u3002","minimize_short":"\u96b1\u85cf","metadata_general_instance":"\u4f86\u6e90\u57f7\u884c\u500b\u9ad4","metadata_general_copy_picid":"\u8907\u88fd\u76f8\u7247 ID","metadata_general_copy_id":"\u8907\u88fd ID","picture_360_long":"\u5168\u666f\u76f8\u7247","metadata_summary":"\u6458\u8981","picture_flat_long":"\u7d93\u5178\u76f8\u7247","geo_uri":"\u5916\u90e8\u7a0b\u5f0f","contribute_id":"\u900f\u904e iD \u7de8\u8f2f\u5668\u4f86\u8ca2\u737b OpenStreetMap","filter_date_6months":"6 \u500b\u6708","picture_all":"\u5168\u90e8","metadata_exif_doc":"EXIF \u6a19\u7c64\u6587\u4ef6","metadata_exif_doc_title":"\u8acb\u53c3\u95b1 Exiv2 \u6587\u4ef6\u4ee5\u53d6\u5f97 EXIF \u548c XMP \u6a19\u7c64\u5b9a\u7fa9\u7684\u5b8c\u6574\u8aaa\u660e","metadata_location_coordinates":"\u5ea7\u6a19 (\u7d93\u5ea6, \u7def\u5ea6)","metadata_location_copy":"\u8907\u88fd {v}","metadata_location_copy_more":"\u66f4\u591a\u5ea7\u6a19\u8907\u88fd\u9078\u9805","semantics_title":"\u6a19\u7c64","semantics_tags":"{nb} \u500b\u6a19\u7c64","semantics_show_annotations":"\u986f\u793a\u76f8\u7247\u7279\u5fb5","semantics_show_all_tags":"\u986f\u793a\u6240\u6709\u6a19\u7c64","semantics_key":"\u7d22\u5f15\u9375","semantics_annotation_tooltip":"\u9ede\u64ca\u67e5\u770b\u8a73\u60c5","semantics_features_default_title":"\u6a19\u7c64 {nb}","semantics_features_subtitle":"{nb} \u500b\u95dc\u806f\u7684\u5c6c\u6027","semantics_hide_all_tags":"\u96b1\u85cf\u6240\u6709\u6a19\u7c64","semantics_features_none":"\u6b64\u76f8\u7247\u5c1a\u672a\u7e6a\u88fd\u4efb\u4f55\u7279\u5fb5\u3002","semantics_value":"\u503c","semantics_tags_picture_none":"\u6b64\u76f8\u7247\u5c1a\u672a\u52a0\u4e0a\u4efb\u4f55\u6a19\u7c64\u3002","semantics_tags_picture":"\u76f8\u7247\u6a19\u7c64","whats_panoramax":"Panoramax \u662f\u5404\u5730\u76f8\u7247\u7684\u5730\u7406\u5171\u4eab\u8cc7\u6e90\u3002","semantics_features":"\u76f8\u7247\u7279\u5fb5","semantics_key_doc":"\u6df1\u5165\u4e86\u89e3\u6b64\u7d22\u5f15\u9375","semantics_value_doc":"\u6df1\u5165\u4e86\u89e3\u6b64\u6a19\u7c64","semantics_qualifiers":"\u9650\u5b9a\u689d\u4ef6","semantics_hide_annotations":"\u96b1\u85cf\u76f8\u7247\u7279\u5fb5","semantics_zero_annotations":"\u6b64\u76f8\u7247\u5c1a\u672a\u7e6a\u88fd\u4efb\u4f55\u7279\u5fb5","semantics_hashtags":"\u76f8\u7247\u4e3b\u984c\u6a19\u7c64","semantics_wikidata_properties":{"P31":"\u96b8\u5c6c\u65bc","P279":"\u4e0a\u7d1a\u5206\u985e","P361":"\u6240\u5c6c\u5be6\u9ad4","P180":"\u63cf\u7e6a"},"panoramax":"Panoramax","semantics_editor_example":"key=value\\nprefix|key=value","semantics_edit":"\u7de8\u8f2f\u5c6c\u6027","semantics_save":"\u5132\u5b58\u8b8a\u66f4","semantics_undo":"\u53d6\u6d88\u8b8a\u66f4","semantics_cantsave_invalid":"\u7121\u6cd5\u5132\u5b58\u8b8a\u66f4\uff0c\u7121\u6548\u7684\u8f38\u5165","semantics_send_fail":"\u7121\u6cd5\u5132\u5b58\u8b8a\u66f4\uff0c\u8acb\u7a0d\u5019\u518d\u8a66","semantics_send_ok":"\u5df2\u6210\u529f\u5132\u5b58\u8b8a\u66f4","semantics_add_annotation":"\u65b0\u589e\u6a19\u7c64","semantics_save_drawn_annotation":"\u5132\u5b58\u4f4d\u7f6e","semantics_undo_drawn_annotation":"\u53d6\u6d88","semantics_delete_annotation":"\u522a\u9664\u9019\u500b\u7279\u5fb5","semantics_delete_annotation_confirm":"\u60a8\u78ba\u5b9a\u8981\u522a\u9664\u9019\u500b\u6a19\u7c64\u55ce\uff1f","semantics_save_drawn_annotation_incomplete":"\u60a8\u5fc5\u9808\u5728\u9a57\u8b49\u4e4b\u524d\u7e6a\u88fd\u4e00\u500b\u9069\u5408\u76f8\u7247\u7684\u77e9\u5f62","semantics_draw_annotation":"\u60a8\u53ef\u4ee5\u5c07\u60f3\u8981\u65b0\u589e\u7684\u7269\u4ef6\u7e6a\u88fd\u5728\u5716\u7247\u4e0a (\u9078\u7528)\u3002","semantics_editor_error":"\u8a9e\u6cd5\u7121\u6548\uff0c\u60a8\u7684\u6a19\u7c64\u770b\u8d77\u4f86\u61c9\u8a72\u8981\u50cf:\\nkey=value\\nprefix|key=value\\nprefix|key[qualif_key=qualif_val]=value\\n\\nkey \u6700\u5927\u9577\u5ea6\u70ba 256 \u500b\u5b57\u5143\uff0cvalue \u6700\u5927\u9577\u5ea6\u70ba 2048 \u500b\u5b57\u5143\u3002","semantics_login_needed":"\u82e5\u8981\u7de8\u8f2f\u76f8\u7247\u6a19\u7c64\u6216\u7279\u5fb5\uff0c\u60a8\u9700\u8981\u767b\u5165 Panoramax {n} \u57f7\u884c\u500b\u9ad4\uff0c\u60a8\u8981\u767b\u5165\u55ce\uff1f","semantics_doc":"\u8aaa\u660e","semantics_doc_title":"\u95dc\u65bc\u6a19\u7c64","semantics_erase_annotation":"\u522a\u9664\u7e6a\u88fd\u7684\u6a19\u7c64","semantics_doc_info1":"\u4f7f\u7528\u6a19\u7c64\u6a19\u8a18\u5716\u7247\u7684\u80cc\u666f\u8cc7\u8a0a\u3002","semantics_doc_info2":"\u60a8\u4e5f\u53ef\u4ee5\u5728\u5716\u7247\u4e2d\u6a19\u8a18\u7269\u4ef6\uff1a\u9053\u8def\u6a19\u8a8c\u3001\u90fd\u5e02\u8a2d\u5099\u7b49\u3002\u4f7f\u7528\u73fe\u6709\u7684\u6a19\u7c64\u6a19\u8a18\u60a8\u6240\u770b\u5230\u7684\uff0c\u4e5f\u53ef\u4ee5\u6309\u7167\u9700\u6c42\u5efa\u7acb\u81ea\u5df1\u7684\u6a19\u7c64\u3002","semantics_doc_info3":"\u6709\u4e9b\u7269\u4ef6\u662f\u7531 AI \u81ea\u52d5\u5075\u6e2c\u7684\uff0c\u56e0\u6b64\u4e0d\u4fdd\u8b49\u54c1\u8cea\u3002","semantics_doc_link":"\u6df1\u5165\u4e86\u89e3\u6a19\u7c64","semantics_sequence_tags":"\u5e8f\u5217\u6a19\u7c64","semantics_picture_tags":"\u76f8\u7247\u6a19\u7c64","semantics_annotation_tags":"\u7269\u4ef6\u6a19\u7c64","filter_gps_precision_lessthan":"\u5c0f\u65bc {n} \u516c\u5c3a","filter_gps_precision_between":"\u4ecb\u65bc {n1} \u548c {n2} \u516c\u5c3a","map_theme_gps":"\u5b9a\u4f4d\u7cbe\u78ba\u5ea6","filter_gps_precision_morethan":"\u5927\u65bc {n} \u516c\u5c3a","filter_gps_precision":"\u5b9a\u4f4d\u7cbe\u78ba\u5ea6","semantics_overlays":{"tfsigns":"\u4ea4\u901a\u6a19\u8a8c","features":"\u6240\u6709\u7279\u5fb5"},"semantics_doc_info1u1":"\u60a8\u53ef\u4ee5\u52a0\u4e0a transport=car \u9019\u500b\u6a19\u7c64\uff0c\u5c07\u5176\u6a19\u8a18\u70ba\u99d5\u99db\u6c7d\u8eca\u62cd\u651d\u3002","semantics_zoom_in":"\u653e\u5927\u5730\u5716\u4ee5\u67e5\u770b\u6a19\u7c64","semantics_download":"\u4e0b\u8f09","semantics_download_title":"\u4e0b\u8f09\u6a19\u7c64","semantics_download_info":"\u6240\u6709\u8a9e\u7fa9\u8cc7\u6599 (\u6a19\u7c64) \u7686\u70ba\u958b\u653e\u8cc7\u6599\uff0c\u60a8\u53ef\u4ee5\u514d\u8cbb\u4e0b\u8f09\u548c\u4f7f\u7528\u3002","semantics_download_cta":"\u4e0b\u8f09\u958b\u653e\u8cc7\u6599","semantics_copy":"\u8907\u88fd\u5c6c\u6027","semantics_value_show_osm":"\u5728 OpenStreetMap \u4e0a\u67e5\u770b","filter_gps_precision_help":"\u6df1\u5165\u4e86\u89e3\u5b9a\u4f4d\u7cbe\u78ba\u5ea6","filter_gps_precision_help_1":"\u6bcf\u5f35\u76f8\u7247\u6709\u5b9a\u4f4d\u7cbe\u78ba\u5ea6\u8cc7\u8a0a\uff0c\u9019\u5c0d\u61c9\u65bc\u62cd\u7167\u6642\u7684 GPS \u7cbe\u78ba\u5ea6\u3002","filter_gps_precision_help_2":"\u7cbe\u78ba\u5ea6\u7528\u661f\u865f\u8868\u793a:","filter_gps_precision_help_3":"\u300c5\u2b50\u300d\u8868\u793a\u975e\u5e38\u7cbe\u78ba (<= {p5}m)\uff0c\u300c1\u2b50\u300d\u8868\u793a\u975e\u5e38\u4e0d\u7cbe\u78ba (> {p1}m) \u6216\u672a\u77e5\u3002","filter_gps_precision_help_4":"RTK GPS \u7684\u6703\u5f97\u5230\u300c5\u2b50\u300d\u7b49\u7d1a\uff0c\u50cf GoPro Max \u9019\u6a23\u7684\u904b\u52d5\u76f8\u6a5f\u6703\u5f97\u5230\u300c3\u2b50\u300d\uff0c\u800c\u5730\u4e0b\u505c\u8eca\u5834\u4e2d\u7684\u667a\u6167\u578b\u624b\u6a5f GPS \u6703\u5f97\u5230\u300c1\u2b50\u300d\u3002","qualityscore_doc_4":"\u6b64\u5206\u6578\u6839\u64da\u4ee5\u4e0b\u56e0\u7d20\u8a08\u7b97\u5f97\u51fa:","qualityscore_doc_41":"GPS \u7cbe\u78ba\u5ea6","qualityscore_doc_42":"\u76f8\u7247\u89e3\u6790\u5ea6","qualityscore_doc_5":"\u5c08\u696d\u8a2d\u5099\u6703\u5f97\u5230 A \u7b49\u3001360\xb0 \u904b\u52d5\u76f8\u6a5f B \u7b49\u3001\u667a\u6167\u578b\u624b\u6a5f\u5247\u6703\u4ecb\u65bc C \u548c E \u4e4b\u9593\u3002"},"map":{"loading":"\u6b63\u5728\u8f09\u5165\u2026","not_public":"\u672a\u516c\u958b\u986f\u793a","thumbnail":"\u904a\u6a19\u61f8\u505c\u76f8\u7247\u7684\u7e2e\u5716","slow_loading":"\u5730\u5716\u8f09\u5165\u901f\u5ea6\u7de9\u6162\u800c\u4e14\u53ef\u80fd\u51fa\u73fe\u640d\u58de","more_panoramax":"\u6df1\u5165\u4e86\u89e3 Panoramax","map_data":"\u5730\u5716\u8cc7\u6599: {m}"},"psv":{"ctrlZoom":"\u4f7f\u7528 CTRL + \u6ed1\u9f20\u6efe\u8f2a\u7e2e\u653e\u5716\u7247","loadError":"\u7121\u6cd5\u8f09\u5165\u5168\u666f\u5716","twoFingers":"\u4f7f\u7528\u96d9\u6307\u79fb\u52d5"},"maplibre":{"GeolocateControl.FindMyLocation":"\u5c0b\u627e\u6211\u7684\u4f4d\u7f6e","GeolocateControl.LocationNotAvailable":"\u7121\u6cd5\u4f7f\u7528\u4f4d\u7f6e\u8cc7\u8a0a"}}');
            }
        }, vt = {};
        function __webpack_require__(bt) {
            var ls = vt[bt];
            if (void 0 !== ls) return ls.exports;
            var ho = vt[bt] = {
                exports: {}
            };
            return le1[bt].call(ho.exports, ho, ho.exports, __webpack_require__), ho.exports;
        }
        __webpack_require__.n = (le1)=>{
            var vt = le1 && le1.__esModule ? ()=>le1.default : ()=>le1;
            return __webpack_require__.d(vt, {
                a: vt
            }), vt;
        }, __webpack_require__.d = (le1, vt)=>{
            for(var bt in vt)__webpack_require__.o(vt, bt) && !__webpack_require__.o(le1, bt) && Object.defineProperty(le1, bt, {
                enumerable: !0,
                get: vt[bt]
            });
        }, __webpack_require__.o = (le1, vt)=>Object.prototype.hasOwnProperty.call(le1, vt), __webpack_require__.r = (le1)=>{
            "undefined" !== typeof Symbol && Symbol.toStringTag && Object.defineProperty(le1, Symbol.toStringTag, {
                value: "Module"
            }), Object.defineProperty(le1, "__esModule", {
                value: !0
            });
        };
        var bt = {};
        return (()=>{
            "use strict";
            __webpack_require__.r(bt), __webpack_require__.d(bt, {
                CoverageMap: ()=>ho.A,
                Editor: ()=>Dl.A,
                PhotoViewer: ()=>Fl.Ay,
                Viewer: ()=>ls.A,
                components: ()=>le1,
                utils: ()=>vt
            });
            var le1 = __webpack_require__(9341), vt = __webpack_require__(2030), ls = __webpack_require__(8743), ho = __webpack_require__(153), Dl = __webpack_require__(1752), Fl = __webpack_require__(3407);
        })(), bt;
    })());


document.addEventListener('DOMContentLoaded', ()=>{
    const browser = document.querySelector('pnx-viewer');
    const xyzField = document.getElementById('xyz-coords');
    const imageId = document.getElementById('image-id');
    if (browser && xyzField) {
        const updateXYZandImageID = (event)=>{
            const { x: x, y: y, z: z } = event.detail;
            const xyz = `${x}/${y}/${z}`;
            xyzField.value = xyz;
            imageId.value = browser.getAttribute('picture');
        };
        browser.addEventListener('psv:view-rotated', updateXYZandImageID);
        browser.addEventListener('psv:position-changed', updateXYZandImageID);
    }
    const viewer = document.querySelector('pnx-photo-viewer');
    if (viewer) {
        const xyz = viewer.getAttribute('xyz');
        viewer.addEventListener('psv:picture-loaded', ()=>{
            if (xyz) {
                const [x, y, z] = xyz.split('/').map(Number);
                viewer.psv.setXYZ(x, y, z);
            }
        });
    }
    $f11cef508aa0223c$var$enableKeyboardOnFocus();
    $f11cef508aa0223c$var$enhancePanoramaxLegendA11y();
});
// RGAA 12.x: the Panoramax viewer reacts to keyboard shortcuts via a window-level
// keydown listener gated by psv.state.keyboardEnabled. The component only flips
// that flag on mouse click / character keypress, so a keyboard-only user can
// never reach it. Make the host focusable and enable the shortcuts while it
// holds focus, disabling them on blur so they don't fire from elsewhere.
function $f11cef508aa0223c$var$enableKeyboardOnFocus() {
    // Keys the viewer consumes for navigation; prevent them from also scrolling
    // the page while the viewer holds focus.
    const SCROLL_KEYS = [
        'ArrowUp',
        'ArrowDown',
        'ArrowLeft',
        'ArrowRight',
        'PageUp',
        'PageDown',
        'Home',
        'End',
        ' ',
        'Spacebar'
    ];
    document.querySelectorAll('pnx-photo-viewer, pnx-viewer').forEach((host)=>{
        host.setAttribute('tabindex', '0');
        host.addEventListener('focus', ()=>host.psv?.startKeyboardControl?.());
        host.addEventListener('blur', ()=>host.psv?.stopKeyboardControl?.());
        host.addEventListener('keydown', (event)=>{
            if (event.target !== host || !SCROLL_KEYS.includes(event.key)) return;
            host.psv?.startKeyboardControl?.();
            event.preventDefault();
        });
    });
}
// RGAA 6.1: the Panoramax legend (shadow DOM, third-party component) ships
// non-explicit links. Make their accessible names explicit and signal that
// they open in a new window. Re-applied on every Lit re-render via observers.
function $f11cef508aa0223c$var$enhancePanoramaxLegendA11y() {
    const legend = document.querySelector('pnx-widget-legend');
    if (!legend) return;
    // Lit re-renders the legend on every picture change, overwriting the title and
    // wiping any icon we appended. So enhancement must be idempotent and re-run
    // after each render. We watch with observers and mask our own writes (disconnect
    // while writing) to avoid a feedback loop, since setAttribute fires the observer
    // even when the value is unchanged.
    const rootObserver = new MutationObserver(()=>enhance());
    const pictureObserver = new MutationObserver(()=>enhance());
    const setExternalLink = (link, label, visibleText)=>{
        if (!link) return;
        link.setAttribute('title', `${label} - ${gettext("nouvelle fen\xeatre")}`);
        link.setAttribute('rel', 'noopener');
        // Replace the on-screen text when it isn't self-explanatory (e.g. the photo
        // link only shows the author name). The descriptive label stays in title.
        if (visibleText && link.firstChild?.textContent !== visibleText) link.textContent = visibleText;
        // Append the new-window indicator once; Lit drops it on re-render so we
        // re-add it whenever it is missing. The legend lives in a shadow root that
        // can't reach the DSFR icon font, so we reproduce DSFR's external-link icon
        // (remixicon external-link-line) as an inline SVG mask tinted to the link
        // colour — same box-with-arrow as fr-link[target="_blank"].
        if (!link.querySelector('[data-a11y-icon]')) {
            const svg = "<svg xmlns='http://www.w3.org/2000/svg' viewBox='0 0 24 24'><path d='M10 6v2H5v11h11v-5h2v6a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V7a1 1 0 0 1 1-1h6zm11-3v8h-2V6.413l-7.793 7.794-1.414-1.414L18.585 5H13V3h8z'/></svg>";
            const mask = `url("data:image/svg+xml,${encodeURIComponent(svg)}") no-repeat center / contain`;
            const icon = document.createElement('span');
            icon.setAttribute('aria-hidden', 'true');
            icon.setAttribute('data-a11y-icon', '');
            icon.style.cssText = [
                'display:inline-block',
                'width:1em',
                'height:1em',
                'margin-left:0.25em',
                'vertical-align:middle',
                'background-color:currentColor',
                `-webkit-mask:${mask}`,
                `mask:${mask}`
            ].join(';');
            link.appendChild(icon);
        }
    };
    const enhance = ()=>{
        const root = legend.shadowRoot;
        if (!root) return;
        rootObserver.disconnect();
        pictureObserver.disconnect();
        setExternalLink(root.querySelector('.presentation a[target="_blank"]'), gettext('Panoramax'));
        const pictureRoot = root.querySelector('pnx-picture-legend')?.shadowRoot;
        if (pictureRoot) {
            pictureRoot.querySelectorAll('a[target="_blank"]').forEach((link)=>{
                if (link.href.includes('/?pic=')) {
                    // Visible text becomes the author name; cache it on first pass so the
                    // descriptive title survives our own text replacement and re-renders.
                    const author = link.dataset.a11yAuthor || (link.dataset.a11yAuthor = link.textContent.trim());
                    setExternalLink(link, 'Voir sur Panoramax', gettext('Voir sur Panoramax'));
                } else {
                    const licence = link.textContent.replace("\u2197", '').trim();
                    setExternalLink(link, licence);
                }
            });
            pictureObserver.observe(pictureRoot, {
                childList: true,
                subtree: true
            });
        }
        rootObserver.observe(root, {
            childList: true,
            subtree: true
        });
    };
    const start = ()=>{
        if (!legend.shadowRoot) {
            requestAnimationFrame(start);
            return;
        }
        enhance();
    };
    start();
}

})();
//# sourceMappingURL=panoramax.js.map
